require = (function (require) {
var exposedRequire = function exposedRequire(e,r){return exposedRequire.m.hasOwnProperty(e)?exposedRequire.m[e]:"function"!=typeof require||r?"function"==typeof exposedRequire.r?exposedRequire.r(e,1):void 0:require(e,1)};
exposedRequire.m = {};
exposedRequire.r = require;var createModuleFactory = function createModuleFactory(t){var e;return function(r){return e||t(e={exports:{},parent:r},e.exports),e.exports}};
var _$Readable_462 = createModuleFactory(function (module, exports) {
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

/* removed: var _$processNextickArgs_458 = require('process-nextick-args'); */;
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
/* removed: var _$isarray_451 = require('isarray'); */;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = _$EventEmitter_442.EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
/* removed: var _$streamBrowser_467 = require('./internal/streams/stream'); */;
/*</replacement>*/

/*<replacement>*/

var Buffer = _$safeBuffer_468.Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(_$util_13);
util.inherits = _$inherits_browser_448;
/*</replacement>*/

/*<replacement>*/
/* removed: var _$empty_6 = require('util'); */;
var debug = void 0;
if (_$empty_6 && _$empty_6.debuglog) {
  debug = _$empty_6.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

/* removed: var _$BufferList_465 = require('./internal/streams/BufferList'); */;
/* removed: var _$destroy_466 = require('./internal/streams/destroy'); */;
var StringDecoder;

util.inherits(Readable, _$streamBrowser_467);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (_$isarray_451(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || _$Duplex_460({});

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new _$BufferList_465();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = _$string_decoder_469({}).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || _$Duplex_460({});

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  _$streamBrowser_467.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = _$destroy_466.destroy;
Readable.prototype._undestroy = _$destroy_466.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = _$string_decoder_469({}).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) _$processNextickArgs_458.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    _$processNextickArgs_458.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) _$processNextickArgs_458.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, { hasUnpiped: false });
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = _$streamBrowser_467.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        _$processNextickArgs_458.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    _$processNextickArgs_458.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    _$processNextickArgs_458.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,_$browser_459,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
});
var _$string_decoder_469 = createModuleFactory(function (module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = _$safeBuffer_468.Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
});
var _$Duplex_460 = createModuleFactory(function (module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/

/* removed: var _$processNextickArgs_458 = require('process-nextick-args'); */;
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(_$util_13);
util.inherits = _$inherits_browser_448;
/*</replacement>*/

var Readable = _$Readable_462({});
var Writable = _$Writable_464({});

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  _$processNextickArgs_458.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  _$processNextickArgs_458.nextTick(cb, err);
};
});
var _$Writable_464 = createModuleFactory(function (module, exports) {
(function (process,global,setImmediate){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

/*<replacement>*/

/* removed: var _$processNextickArgs_458 = require('process-nextick-args'); */;
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : _$processNextickArgs_458.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(_$util_13);
util.inherits = _$inherits_browser_448;
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: _$deprecate_602
};
/*</replacement>*/

/*<replacement>*/
/* removed: var _$streamBrowser_467 = require('./internal/streams/stream'); */;
/*</replacement>*/

/*<replacement>*/

var Buffer = _$safeBuffer_468.Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/* removed: var _$destroy_466 = require('./internal/streams/destroy'); */;

util.inherits(Writable, _$streamBrowser_467);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || _$Duplex_460({});

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || _$Duplex_460({});

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  _$streamBrowser_467.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  _$processNextickArgs_458.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    _$processNextickArgs_458.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    _$processNextickArgs_458.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    _$processNextickArgs_458.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      _$processNextickArgs_458.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) _$processNextickArgs_458.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = _$destroy_466.destroy;
Writable.prototype._undestroy = _$destroy_466.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
}).call(this)}).call(this,_$browser_459,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},_$main_586({}).setImmediate)
});
var _$buffer_8 = createModuleFactory(function (module, exports) {
(function (Buffer){(function (){
'use strict';
/* removed: var _$base64Js_5 = require('base64-js'); */;
/* removed: var _$ieee754_447 = require('ieee754'); */;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 2147483647;
exports.kMaxLength = K_MAX_LENGTH;
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
}
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function () {
                return 42;
            }
        };
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function () {
        if (!Buffer.isBuffer(this))
            return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function () {
        if (!Buffer.isBuffer(this))
            return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) {
        throw new RangeError('The value "' + length + '" is invalid for option "size"');
    }
    var buf = new Uint8Array(length);
    buf.__proto__ = Buffer.prototype;
    return buf;
}
function Buffer(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') {
            throw new TypeError('The "string" argument must be of type string. Received type number');
        }
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
if (typeof Symbol !== 'undefined' && Symbol.species != null && Buffer[Symbol.species] === Buffer) {
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true,
        enumerable: false,
        writable: false
    });
}
Buffer.poolSize = 8192;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') {
        return fromString(value, encodingOrOffset);
    }
    if (ArrayBuffer.isView(value)) {
        return fromArrayLike(value);
    }
    if (value == null) {
        throw TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
    }
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
        return fromArrayBuffer(value, encodingOrOffset, length);
    }
    if (typeof value === 'number') {
        throw new TypeError('The "value" argument must not be of type number. Received type number');
    }
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) {
        return Buffer.from(valueOf, encodingOrOffset, length);
    }
    var b = fromObject(value);
    if (b)
        return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
        return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    }
    throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
}
Buffer.from = function (value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
Buffer.prototype.__proto__ = Uint8Array.prototype;
Buffer.__proto__ = Uint8Array;
function assertSize(size) {
    if (typeof size !== 'number') {
        throw new TypeError('"size" argument must be of type number');
    } else if (size < 0) {
        throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
        return createBuffer(size);
    }
    if (fill !== undefined) {
        return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    }
    return createBuffer(size);
}
Buffer.alloc = function (size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
Buffer.allocUnsafe = function (size) {
    return allocUnsafe(size);
};
Buffer.allocUnsafeSlow = function (size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') {
        encoding = 'utf8';
    }
    if (!Buffer.isEncoding(encoding)) {
        throw new TypeError('Unknown encoding: ' + encoding);
    }
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) {
        buf = buf.slice(0, actual);
    }
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for (var i = 0; i < length; i += 1) {
        buf[i] = array[i] & 255;
    }
    return buf;
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('"offset" is outside of buffer bounds');
    }
    if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('"length" is outside of buffer bounds');
    }
    var buf;
    if (byteOffset === undefined && length === undefined) {
        buf = new Uint8Array(array);
    } else if (length === undefined) {
        buf = new Uint8Array(array, byteOffset);
    } else {
        buf = new Uint8Array(array, byteOffset, length);
    }
    buf.__proto__ = Buffer.prototype;
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) {
            return buf;
        }
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
            return createBuffer(0);
        }
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
        return fromArrayLike(obj.data);
    }
}
function checked(length) {
    if (length >= K_MAX_LENGTH) {
        throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
    }
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) {
        length = 0;
    }
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array))
        a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array))
        b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
        throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    }
    if (a === b)
        return 0;
    var x = a.length;
    var y = b.length;
    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
    }
    if (x < y)
        return -1;
    if (y < x)
        return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
        return true;
    default:
        return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
    }
    if (list.length === 0) {
        return Buffer.alloc(0);
    }
    var i;
    if (length === undefined) {
        length = 0;
        for (i = 0; i < list.length; ++i) {
            length += list[i].length;
        }
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for (i = 0; i < list.length; ++i) {
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            buf = Buffer.from(buf);
        }
        if (!Buffer.isBuffer(buf)) {
            throw new TypeError('"list" argument must be an Array of Buffers');
        }
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) {
        return string.length;
    }
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
        return string.byteLength;
    }
    if (typeof string !== 'string') {
        throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type ' + typeof string);
    }
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0)
        return 0;
    var loweredCase = false;
    for (;;) {
        switch (encoding) {
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) {
                return mustMatch ? -1 : utf8ToBytes(string).length;
            }
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    if (start === undefined || start < 0) {
        start = 0;
    }
    if (start > this.length) {
        return '';
    }
    if (end === undefined || end > this.length) {
        end = this.length;
    }
    if (end <= 0) {
        return '';
    }
    end >>>= 0;
    start >>>= 0;
    if (end <= start) {
        return '';
    }
    if (!encoding)
        encoding = 'utf8';
    while (true) {
        switch (encoding) {
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase)
                throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
        }
    }
}
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 16-bits');
    }
    for (var i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
    }
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 32-bits');
    }
    for (var i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 64-bits');
    }
    for (var i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0)
        return '';
    if (arguments.length === 0)
        return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b))
        throw new TypeError('Argument must be a Buffer');
    if (this === b)
        return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max)
        str += ' ... ';
    return '<Buffer ' + str + '>';
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) {
        target = Buffer.from(target, target.offset, target.byteLength);
    }
    if (!Buffer.isBuffer(target)) {
        throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + typeof target);
    }
    if (start === undefined) {
        start = 0;
    }
    if (end === undefined) {
        end = target ? target.length : 0;
    }
    if (thisStart === undefined) {
        thisStart = 0;
    }
    if (thisEnd === undefined) {
        thisEnd = this.length;
    }
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError('out of range index');
    }
    if (thisStart >= thisEnd && start >= end) {
        return 0;
    }
    if (thisStart >= thisEnd) {
        return -1;
    }
    if (start >= end) {
        return 1;
    }
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target)
        return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for (var i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
    }
    if (x < y)
        return -1;
    if (y < x)
        return 1;
    return 0;
};
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    if (buffer.length === 0)
        return -1;
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
    } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
    }
    byteOffset = +byteOffset;
    if (numberIsNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer.length - 1;
    }
    if (byteOffset < 0)
        byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir)
            return -1;
        else
            byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir)
            byteOffset = 0;
        else
            return -1;
    }
    if (typeof val === 'string') {
        val = Buffer.from(val, encoding);
    }
    if (Buffer.isBuffer(val)) {
        if (val.length === 0) {
            return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 255;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) {
                return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            } else {
                return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) {
                return -1;
            }
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) {
            return buf[i];
        } else {
            return buf.readUInt16BE(i * indexSize);
        }
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
            if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1)
                    foundIndex = i;
                if (i - foundIndex + 1 === valLength)
                    return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1)
                    i -= i - foundIndex;
                foundIndex = -1;
            }
        }
    } else {
        if (byteOffset + valLength > arrLength)
            byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
            var found = true;
            for (var j = 0; j < valLength; j++) {
                if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
            }
            if (found)
                return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) {
        length = remaining;
    } else {
        length = Number(length);
        if (length > remaining) {
            length = remaining;
        }
    }
    var strLen = string.length;
    if (length > strLen / 2) {
        length = strLen / 2;
    }
    for (var i = 0; i < length; ++i) {
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed))
            return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined)
                encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else {
        throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    }
    var remaining = this.length - offset;
    if (length === undefined || length > remaining)
        length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
        throw new RangeError('Attempt to write outside buffer bounds');
    }
    if (!encoding)
        encoding = 'utf8';
    var loweredCase = false;
    for (;;) {
        switch (encoding) {
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
            return asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return latin1Write(this, string, offset, length);
        case 'base64':
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase)
                throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) {
        return _$base64Js_5.fromByteArray(buf);
    } else {
        return _$base64Js_5.fromByteArray(buf.slice(start, end));
    }
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while (i < end) {
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch (bytesPerSequence) {
            case 1:
                if (firstByte < 128) {
                    codePoint = firstByte;
                }
                break;
            case 2:
                secondByte = buf[i + 1];
                if ((secondByte & 192) === 128) {
                    tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                    if (tempCodePoint > 127) {
                        codePoint = tempCodePoint;
                    }
                }
                break;
            case 3:
                secondByte = buf[i + 1];
                thirdByte = buf[i + 2];
                if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                    tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                    if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                        codePoint = tempCodePoint;
                    }
                }
                break;
            case 4:
                secondByte = buf[i + 1];
                thirdByte = buf[i + 2];
                fourthByte = buf[i + 3];
                if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                    tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                    if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                        codePoint = tempCodePoint;
                    }
                }
            }
        }
        if (codePoint === null) {
            codePoint = 65533;
            bytesPerSequence = 1;
        } else if (codePoint > 65535) {
            codePoint -= 65536;
            res.push(codePoint >>> 10 & 1023 | 55296);
            codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
var MAX_ARGUMENTS_LENGTH = 4096;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
    }
    var res = '';
    var i = 0;
    while (i < len) {
        res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    }
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 127);
    }
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
    }
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0)
        start = 0;
    if (!end || end < 0 || end > len)
        end = len;
    var out = '';
    for (var i = start; i < end; ++i) {
        out += toHex(buf[i]);
    }
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for (var i = 0; i < bytes.length; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0)
            start = 0;
    } else if (start > len) {
        start = len;
    }
    if (end < 0) {
        end += len;
        if (end < 0)
            end = 0;
    } else if (end > len) {
        end = len;
    }
    if (end < start)
        end = start;
    var newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
    return newBuf;
};
function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0)
        throw new RangeError('offset is not uint');
    if (offset + ext > length)
        throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert)
        checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 256)) {
        val += this[offset + i] * mul;
    }
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        checkOffset(offset, byteLength, this.length);
    }
    var val = this[offset + --byteLength];
    var mul = 1;
    while (byteLength > 0 && (mul *= 256)) {
        val += this[offset + --byteLength] * mul;
    }
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert)
        checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 256)) {
        val += this[offset + i] * mul;
    }
    mul *= 128;
    if (val >= mul)
        val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert)
        checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while (i > 0 && (mul *= 256)) {
        val += this[offset + --i] * mul;
    }
    mul *= 128;
    if (val >= mul)
        val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 1, this.length);
    if (!(this[offset] & 128))
        return this[offset];
    return (255 - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 32768 ? val | 4294901760 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 32768 ? val | 4294901760 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return _$ieee754_447.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return _$ieee754_447.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 8, this.length);
    return _$ieee754_447.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
        checkOffset(offset, 8, this.length);
    return _$ieee754_447.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf))
        throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min)
        throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length)
        throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 255;
    while (++i < byteLength && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
    }
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 255;
    while (--i >= 0 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
    }
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(this, value, offset, 1, 255, 0);
    this[offset] = value & 255;
    return offset + 1;
};
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 255;
    return offset + 2;
};
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 255;
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 255;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 255;
    while (++i < byteLength && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
            sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 255;
    while (--i >= 0 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
            sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(this, value, offset, 1, 127, -128);
    if (value < 0)
        value = 255 + value + 1;
    this[offset] = value & 255;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 255;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
    if (value < 0)
        value = 4294967295 + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 255;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length)
        throw new RangeError('Index out of range');
    if (offset < 0)
        throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    }
    _$ieee754_447.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 1.7976931348623157e+308, -1.7976931348623157e+308);
    }
    _$ieee754_447.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target))
        throw new TypeError('argument should be a Buffer');
    if (!start)
        start = 0;
    if (!end && end !== 0)
        end = this.length;
    if (targetStart >= target.length)
        targetStart = target.length;
    if (!targetStart)
        targetStart = 0;
    if (end > 0 && end < start)
        end = start;
    if (end === start)
        return 0;
    if (target.length === 0 || this.length === 0)
        return 0;
    if (targetStart < 0) {
        throw new RangeError('targetStart out of bounds');
    }
    if (start < 0 || start >= this.length)
        throw new RangeError('Index out of range');
    if (end < 0)
        throw new RangeError('sourceEnd out of bounds');
    if (end > this.length)
        end = this.length;
    if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
    }
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
        this.copyWithin(targetStart, start, end);
    } else if (this === target && start < targetStart && targetStart < end) {
        for (var i = len - 1; i >= 0; --i) {
            target[i + targetStart] = this[i + start];
        }
    } else {
        Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    }
    return len;
};
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') {
            throw new TypeError('encoding must be a string');
        }
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
            throw new TypeError('Unknown encoding: ' + encoding);
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
                val = code;
            }
        }
    } else if (typeof val === 'number') {
        val = val & 255;
    }
    if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError('Out of range index');
    }
    if (end <= start) {
        return this;
    }
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val)
        val = 0;
    var i;
    if (typeof val === 'number') {
        for (i = start; i < end; ++i) {
            this[i] = val;
        }
    } else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) {
            throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        }
        for (i = 0; i < end - start; ++i) {
            this[i + start] = bytes[i % len];
        }
    }
    return this;
};
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    str = str.split('=')[0];
    str = str.trim().replace(INVALID_BASE64_RE, '');
    if (str.length < 2)
        return '';
    while (str.length % 4 !== 0) {
        str = str + '=';
    }
    return str;
}
function toHex(n) {
    if (n < 16)
        return '0' + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for (var i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
            if (!leadSurrogate) {
                if (codePoint > 56319) {
                    if ((units -= 3) > -1)
                        bytes.push(239, 191, 189);
                    continue;
                } else if (i + 1 === length) {
                    if ((units -= 3) > -1)
                        bytes.push(239, 191, 189);
                    continue;
                }
                leadSurrogate = codePoint;
                continue;
            }
            if (codePoint < 56320) {
                if ((units -= 3) > -1)
                    bytes.push(239, 191, 189);
                leadSurrogate = codePoint;
                continue;
            }
            codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
            if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
            if ((units -= 1) < 0)
                break;
            bytes.push(codePoint);
        } else if (codePoint < 2048) {
            if ((units -= 2) < 0)
                break;
            bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
        } else if (codePoint < 65536) {
            if ((units -= 3) < 0)
                break;
            bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else if (codePoint < 1114112) {
            if ((units -= 4) < 0)
                break;
            bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else {
            throw new Error('Invalid code point');
        }
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
        byteArray.push(str.charCodeAt(i) & 255);
    }
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0)
            break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return _$base64Js_5.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for (var i = 0; i < length; ++i) {
        if (i + offset >= dst.length || i >= src.length)
            break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    return obj !== obj;
}
}).call(this)}).call(this,_$buffer_8({}).Buffer)
});
var _$_unpackIeee754_190 = createModuleFactory(function (module, exports) {
/* eslint no-bitwise: "off" */
// Credit: https://github.com/paulmillr/es6-shim/

"use strict";

var pow = Math.pow;

module.exports = function (bytes, ebits, fbits) {
	// Bytes to bits
	var bits = [], i, j, bit, str, bias, sign, e, fraction;

	for (i = bytes.length; i; i -= 1) {
		bit = bytes[i - 1];
		for (j = 8; j; j -= 1) {
			bits.push(bit % 2 ? 1 : 0);
			bit >>= 1;
		}
	}
	bits.reverse();
	str = bits.join("");

	// Unpack sign, exponent, fraction
	bias = (1 << (ebits - 1)) - 1;
	sign = parseInt(str.substring(0, 1), 2) ? -1 : 1;
	e = parseInt(str.substring(1, 1 + ebits), 2);
	fraction = parseInt(str.substring(1 + ebits), 2);

	// Produce number
	if (e === (1 << ebits) - 1) return fraction === 0 ? sign * Infinity : NaN;
	if (e > 0) return sign * pow(2, e - bias) * (1 + fraction / pow(2, fbits));
	if (fraction !== 0) return sign * pow(2, -(bias - 1)) * (fraction / pow(2, fbits));
	return sign < 0 ? -0 : 0;
};

});
var _$_packIeee754_189 = createModuleFactory(function (module, exports) {
/* eslint no-bitwise: "off" */
// Credit: https://github.com/paulmillr/es6-shim/

"use strict";

var abs = Math.abs
  , floor = Math.floor
  , log = Math.log
  , min = Math.min
  , pow = Math.pow
  , LN2 = Math.LN2
  , roundToEven;

roundToEven = function (num) {
	var whole = floor(num), fraction = num - whole;
	if (fraction < 0.5) return whole;
	if (fraction > 0.5) return whole + 1;
	return whole % 2 ? whole + 1 : whole;
};

// eslint-disable-next-line max-statements, max-lines-per-function
module.exports = function (value, ebits, fbits) {
	var bias = (1 << (ebits - 1)) - 1, sign, e, fraction, i, bits, str, bytes;

	// Compute sign, exponent, fraction
	if (isNaN(value)) {
		// NaN
		// http://dev.w3.org/2006/webapi/WebIDL/#es-type-mapping
		e = (1 << ebits) - 1;
		fraction = pow(2, fbits - 1);
		sign = 0;
	} else if (value === Infinity || value === -Infinity) {
		e = (1 << ebits) - 1;
		fraction = 0;
		sign = value < 0 ? 1 : 0;
	} else if (value === 0) {
		e = 0;
		fraction = 0;
		sign = 1 / value === -Infinity ? 1 : 0;
	} else {
		sign = value < 0;
		value = abs(value);

		if (value >= pow(2, 1 - bias)) {
			e = min(floor(log(value) / LN2), 1023);
			fraction = roundToEven((value / pow(2, e)) * pow(2, fbits));
			if (fraction / pow(2, fbits) >= 2) {
				e += 1;
				fraction = 1;
			}
			if (e > bias) {
				// Overflow
				e = (1 << ebits) - 1;
				fraction = 0;
			} else {
				// Normal
				e += bias;
				fraction -= pow(2, fbits);
			}
		} else {
			// Subnormal
			e = 0;
			fraction = roundToEven(value / pow(2, 1 - bias - fbits));
		}
	}

	// Pack sign, exponent, fraction
	bits = [];
	for (i = fbits; i; i -= 1) {
		bits.push(fraction % 2 ? 1 : 0);
		fraction = floor(fraction / 2);
	}
	for (i = ebits; i; i -= 1) {
		bits.push(e % 2 ? 1 : 0);
		e = floor(e / 2);
	}
	bits.push(sign ? 1 : 0);
	bits.reverse();
	str = bits.join("");

	// Bits to bytes
	bytes = [];
	while (str.length) {
		bytes.push(parseInt(str.substring(0, 8), 2));
		str = str.substring(8);
	}
	return bytes;
};

});
var _$main_586 = createModuleFactory(function (module, exports) {
(function (setImmediate,clearImmediate){(function (){
var nextTick = _$browser_459.nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,_$main_586({}).setImmediate,_$main_586({}).clearImmediate)
});
var _$mixin_327 = createModuleFactory(function (module, exports) {
"use strict";

var defineProperty           = Object.defineProperty
  , getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor
  , getOwnPropertyNames      = Object.getOwnPropertyNames
  , getOwnPropertySymbols    = Object.getOwnPropertySymbols;

module.exports = function (target, source) {
	var error, sourceObject = Object(_$validValue_340(source));
	target = Object(_$validValue_340(target));
	getOwnPropertyNames(sourceObject).forEach(function (name) {
		try {
			defineProperty(target, name, getOwnPropertyDescriptor(source, name));
		} catch (e) { error = e; }
	});
	if (typeof getOwnPropertySymbols === "function") {
		getOwnPropertySymbols(sourceObject).forEach(function (symbol) {
			try {
				defineProperty(target, symbol, getOwnPropertyDescriptor(source, symbol));
			} catch (e) { error = e; }
		});
	}
	if (error !== undefined) throw error;
	return target;
};

});
var _$_subArrayDummy_128 = createModuleFactory(function (module, exports) {
"use strict";

/* removed: var _$setPrototypeOf_332 = require("../object/set-prototype-of"); */;

module.exports = (function () {
	var SubArray;

	if (!_$setPrototypeOf_332) return null;
	SubArray = function () { Array.apply(this, arguments); };
	_$setPrototypeOf_332(SubArray, Array);
	SubArray.prototype = Object.create(Array.prototype, {
		constructor: { value: SubArray, enumerable: false, writable: true, configurable: true }
	});
	return SubArray;
})();

});
var _$shim_334 = createModuleFactory(function (module, exports) {
/* eslint no-proto: "off" */

// Big thanks to @WebReflection for sorting this out
// https://gist.github.com/WebReflection/5593554

"use strict";

var objIsPrototypeOf = Object.prototype.isPrototypeOf
  , defineProperty   = Object.defineProperty
  , nullDesc         = { configurable: true, enumerable: false, writable: true, value: undefined }
  , validate;

validate = function (obj, prototype) {
	_$validValue_340(obj);
	if (prototype === null || _$isObject_313(prototype)) return obj;
	throw new TypeError("Prototype must be null or an object");
};

module.exports = (function (status) {
	var fn, set;
	if (!status) return null;
	if (status.level === 2) {
		if (status.set) {
			set = status.set;
			fn = function (obj, prototype) {
				set.call(validate(obj, prototype), prototype);
				return obj;
			};
		} else {
			fn = function (obj, prototype) {
				validate(obj, prototype).__proto__ = prototype;
				return obj;
			};
		}
	} else {
		fn = function self(obj, prototype) {
			var isNullBase;
			validate(obj, prototype);
			isNullBase = objIsPrototypeOf.call(self.nullPolyfill, obj);
			if (isNullBase) delete self.nullPolyfill.__proto__;
			if (prototype === null) prototype = self.nullPolyfill;
			obj.__proto__ = prototype;
			if (isNullBase) defineProperty(self.nullPolyfill, "__proto__", nullDesc);
			return obj;
		};
	}
	return Object.defineProperty(fn, "level", {
		configurable: false,
		enumerable: false,
		writable: false,
		value: status.level
	});
})(
	(function () {
		var tmpObj1 = Object.create(null)
		  , tmpObj2 = {}
		  , set
		  , desc = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");

		if (desc) {
			try {
				set = desc.set; // Opera crashes at this point
				set.call(tmpObj1, tmpObj2);
			} catch (ignore) {}
			if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { set: set, level: 2 };
		}

		tmpObj1.__proto__ = tmpObj2;
		if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 2 };

		tmpObj1 = {};
		tmpObj1.__proto__ = tmpObj2;
		if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 1 };

		return false;
	})()
);

_$create_280({});

});
var _$create_280 = createModuleFactory(function (module, exports) {
// Workaround for http://code.google.com/p/v8/issues/detail?id=2804

"use strict";

var create = Object.create, shim;

if (!_$isImplemented_333()) {
	shim = _$shim_334({});
}

module.exports = (function () {
	var nullObject, polyProps, desc;
	if (!shim) return create;
	if (shim.level !== 1) return create;

	nullObject = {};
	polyProps = {};
	desc = { configurable: false, enumerable: false, writable: true, value: undefined };
	Object.getOwnPropertyNames(Object.prototype).forEach(function (name) {
		if (name === "__proto__") {
			polyProps[name] = {
				configurable: true,
				enumerable: false,
				writable: true,
				value: undefined
			};
			return;
		}
		polyProps[name] = desc;
	});
	Object.defineProperties(nullObject, polyProps);

	Object.defineProperty(shim, "nullPolyfill", {
		configurable: false,
		enumerable: false,
		writable: false,
		value: nullObject
	});

	return function (prototype, props) {
		return create(prototype === null ? nullObject : prototype, props);
	};
})();

});
var _$trim_56 = {};
"use strict";
Object.defineProperty(_$trim_56, "__esModule", { value: true });
_$trim_56.trim = (str, char) => {
    return str.replace(new RegExp("^[" + char + "]+|[" + char + "]+$", "g"), "");
};

var _$version_60 = {};
"use strict";
Object.defineProperty(_$version_60, "__esModule", { value: true });
/* removed: const _$trim_56 = require("./trim"); */;
_$version_60.formatVersion = (version, versionTruncation) => {
    if (version === undefined)
        return "";
    const versionString = _$trim_56.trim(version, ". ").replace(new RegExp("_", "g"), ".");
    const versionParts = versionString.split(".");
    // Return if the string is not only digits once we removed the dots
    if (!/^\d+$/.test(versionParts.join(""))) {
        return versionString;
    }
    if (versionTruncation !== 0) {
        if (Number.isInteger(parseFloat(versionString))) {
            return parseInt(versionString, 10).toFixed(1);
        }
    }
    if (versionParts.length > 1) {
        if (versionTruncation !== null) {
            return versionParts.slice(0, versionTruncation + 1).join(".");
        }
    }
    return versionString;
};
_$version_60.parseBrowserEngineVersion = (userAgent, engine) => {
    if (!engine)
        return "";
    if (engine === "Gecko") {
        const geckoVersionRegex = /[ ](?:rv[: ]([0-9\.]+)).*gecko\/[0-9]{8,10}/i;
        const match = userAgent.match(geckoVersionRegex);
        if (match) {
            return match.pop();
        }
    }
    const regex = new RegExp(`${engine}\\s*\\/?\\s*((?:(?=\\d+\\.\\d)\\d+[.\\d]*|\\d{1,7}(?=(?:\\D|$))))`, "i");
    const match = userAgent.match(regex);
    if (!match)
        return "";
    return match.pop();
};

var _$variableReplacement_58 = {};
"use strict";
Object.defineProperty(_$variableReplacement_58, "__esModule", { value: true });
_$variableReplacement_58.variableReplacement = (template, variables) => {
    const regex = new RegExp(`\\$\\d`, "g");
    if (template === null || template === undefined)
        return "";
    return template.replace(regex, (match) => {
        const index = parseInt(match.substr(1), 10);
        const variable = variables[index - 1];
        return variable || "";
    });
};

var _$memoryCache_54 = {};
"use strict";
Object.defineProperty(_$memoryCache_54, "__esModule", { value: true });
_$memoryCache_54.memoryCache = () => {
    const memoryCacheBucket = {};
    const set = (key, value) => {
        memoryCacheBucket[key] = value;
    };
    const get = (key) => {
        if (memoryCacheBucket.hasOwnProperty(key)) {
            return memoryCacheBucket[key];
        }
    };
    return {
        set,
        get
    };
};

var _$userAgent_57 = {};
"use strict";
Object.defineProperty(_$userAgent_57, "__esModule", { value: true });
/* removed: const _$memoryCache_54 = require("./memory-cache"); */;
const cache = _$memoryCache_54.memoryCache();
const getRegexInstance = (rawRegex) => {
    const cachedRegexInstance = cache.get(rawRegex);
    if (cachedRegexInstance)
        return cachedRegexInstance.value;
    const regexInstance = RegExp(`(?:^|[^A-Z0-9\-_]|[^A-Z0-9\-]_|sprd-)(?:${rawRegex})`, "i");
    cache.set(rawRegex, {
        value: regexInstance
    });
    return regexInstance;
};
_$userAgent_57.userAgentParser = (rawRegex, userAgent) => {
    // TODO: find out why it fails in some browsers
    try {
        const regexInstance = getRegexInstance(rawRegex);
        const match = regexInstance.exec(userAgent);
        return match ? match.slice(1) : null;
    }
    catch (_a) {
        return null;
    }
};

var _$browsers_18=[
    {
        "regex": "Helio/(\\d+[\\.\\d]+)",
        "name": "Helio",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "7654Browser/(\\d+[\\.\\d]+)",
        "name": "7654 Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Qazweb/(\\d+[\\.\\d]+)",
        "name": "Qazweb",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Degdegan/(\\d+[\\.\\d]+)",
        "name": "deg-degan",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "JavaFX/(\\d+[\\.\\d]+)",
        "name": "JavaFX",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Chedot/(\\d+[\\.\\d]+)",
        "name": "Chedot",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome/(\\d+[\\.\\d]+) \\(Chromium GOST\\)",
        "name": "Chromium GOST",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "(?:DeledaoPersonal|DeledaoFamily)/(\\d+[\\.\\d]+)",
        "name": "Deledao",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "HasBrowser/(\\d+[\\.\\d]+)",
        "name": "HasBrowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Byffox/(\\d+[\\.\\d]+)",
        "name": "Byffox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Chrome/(\\d+[\\.\\d]+).+AgentWeb.+UCBrowser",
        "name": "CoolBrowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "DotBrowser/(\\d+[\\.\\d]+)",
        "name": "Dot Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "CravingExplorer/(\\d+[\\.\\d]+)",
        "name": "Craving Explorer",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "DeskBrowse/(\\d+[\\.\\d]+)",
        "name": "DeskBrowse",
        "version": "$1"
    },
    {
        "regex": "Lolifox/(\\d+[\\.\\d]+)",
        "name": "Lolifox",
        "version": "$1"
    },
    {
        "regex": "qutebrowser/(\\d+[\\.\\d]+).+Chrome",
        "name": "Qutebrowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "qutebrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Qutebrowser",
        "version": "$1"
    },
    {
        "regex": "flast/(\\d+[\\.\\d]+)",
        "name": "Flast",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "PolyBrowser/(\\d+[\\.\\d]+)",
        "name": "PolyBrowser",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Chrome.+BriskBard/(\\d+[\\.\\d]+)",
        "name": "BriskBard",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "BriskBard(?:/(\\d+[\\.\\d]+))?",
        "name": "BriskBard",
        "version": "$1"
    },
    {
        "regex": "GinxDroidBrowser/(\\d+[\\.\\d]+)",
        "name": "GinxDroid Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "AviraScout/(\\d+[\\.\\d]+)",
        "name": "Avira Scout",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "VenusBrowser/(\\d+[\\.\\d]+)",
        "name": "Venus Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome.+Otter(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Otter Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Otter(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Otter Browser",
        "version": "$1"
    },
    {
        "regex": "Chrome.+Smooz/(\\d+[\\.\\d]+)",
        "name": "Smooz",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Smooz/(\\d+[\\.\\d]+)",
        "name": "Smooz",
        "version": "$1"
    },
    {
        "regex": "Cornowser/(\\d+[\\.\\d]+)",
        "name": "Cornowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Orca/(\\d+[\\.\\d]+)",
        "name": "Orca",
        "version": "$1"
    },
    {
        "regex": "Flow/(?:(\\d+[\\.\\d]+))",
        "name": "Flow",
        "version": "$1",
        "engine": {
            "default": "EkiohFlow"
        }
    },
    {
        "regex": "Ekioh/(?:(\\d+[\\.\\d]+))",
        "name": "Flow",
        "version": "$1",
        "engine": {
            "default": "EkiohFlow"
        }
    },
    {
        "regex": "xStand/(\\d+[\\.\\d]+)",
        "name": "xStand",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Biyubi/(\\d+[\\.\\d]+)",
        "name": "Biyubi",
        "version": "$1"
    },
    {
        "regex": "(?:Perfect%20Browser(?:-iPad)?|Perfect(?:BrowserPro)?)/(\\d+[\\.\\d]+)",
        "name": "Perfect Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Browser/Phantom/V(\\d+[\\.\\d]+)",
        "name": "Phantom Browser",
        "version": "$1"
    },
    {
        "regex": "AwoX(?:/(\\d+[\\.\\d]+))? Browser",
        "name": "AwoX",
        "version": "$1"
    },
    {
        "regex": "Zetakey/(\\d+[\\.\\d]+)",
        "name": "Zetakey",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "PlayFreeBrowser/(?:(\\d+[\\.\\d]+))?",
        "name": "PlayFree Browser",
        "version": "$1"
    },
    {
        "regex": "(?:chimlac_browser|chimlac)/(?:(\\d+[\\.\\d]+))",
        "name": "Chim Lac",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Odin/(?:(\\d+[\\.\\d]+))",
        "name": "Odin",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Tbrowser/(\\d+[\\.\\d]+)",
        "name": "T-Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SFive(?:_Android)?/.+ Chrome/(\\d+[\\.\\d]+)",
        "name": "SFive",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SFive_IOS/(\\d+[\\.\\d]+)",
        "name": "SFive",
        "version": "$1"
    },
    {
        "regex": "Navigateur web/(?:(\\d+[\\.\\d]+))?",
        "name": "Navigateur Web",
        "version": "$1"
    },
    {
        "regex": "Sraf(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Seraphic Sraf",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SeewoBrowser/(?:(\\d+[\\.\\d]+))?",
        "name": "Seewo Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "(?:Kode(?:iOS)?/(?:(\\d+[\\.\\d]+))?|TansoDL)",
        "name": "Kode Browser",
        "version": "$1"
    },
    {
        "regex": "UR/(?:(\\d+[\\.\\d]+))",
        "name": "UR Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "OceanHero/([\\.\\d]+)",
        "name": "OceanHero",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome/.+ SLBrowser/(?:(\\d+[\\.\\d]+))?",
        "name": "Smart Lenovo Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SLBrowser/(?:(\\d+[\\.\\d]+))?",
        "name": "Smart Lenovo Browser",
        "version": "$1"
    },
    {
        "regex": "Browzar",
        "name": "Browzar",
        "version": ""
    },
    {
        "regex": "Stargon/(?:(\\d+[\\.\\d]+))?",
        "name": "Stargon",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "NFSBrowser/(?:(\\d+[\\.\\d]+))?",
        "name": "NFS Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Borealis/(\\d+[\\.\\d]+)",
        "name": "Borealis Navigator",
        "version": "$1"
    },
    {
        "regex": "YoloBrowser/(?:(\\d+[\\.\\d]+))?",
        "name": "Yolo Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "PHX/(?:(\\d+[\\.\\d]+))?",
        "name": "Phoenix Browser",
        "version": "$1"
    },
    {
        "regex": "PrivacyWall/(?:(\\d+[\\.\\d]+))?",
        "name": "PrivacyWall",
        "version": "$1"
    },
    {
        "regex": "Ghostery:?(\\d+[\\.\\d]+)?",
        "name": "Ghostery Privacy Browser",
        "version": "$1"
    },
    {
        "regex": "Firefox/.*(?:Turkcell-)?YaaniBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Yaani Browser",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "(?:Turkcell-)?YaaniBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Yaani Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SEB/(?:(\\d+[\\.\\d]+))?",
        "name": "Safe Exam Browser",
        "version": "$1"
    },
    {
        "regex": "Colibri/(?:(\\d+[\\.\\d]+))?",
        "name": "Colibri",
        "version": "$1"
    },
    {
        "regex": "Xvast/(?:(\\d+[\\.\\d]+))?",
        "name": "Xvast",
        "version": "$1"
    },
    {
        "regex": "TungstenBrowser/(?:(\\d+[\\.\\d]+))?",
        "name": "Tungsten",
        "version": "$1"
    },
    {
        "regex": "Lulumi-browser/(?:(\\d+[\\.\\d]+))?",
        "name": "Lulumi",
        "version": "$1"
    },
    {
        "regex": "ybrowser/(?:(\\d+[\\.\\d]+))?",
        "name": "Yahoo! Japan Browser",
        "version": "$1"
    },
    {
        "regex": "iLunascapeLite/(?:(\\d+[\\.\\d]+))?",
        "name": "Lunascape Lite",
        "version": "$1"
    },
    {
        "regex": "Polypane/(?:(\\d+[\\.\\d]+))?",
        "name": "Polypane",
        "version": "$1"
    },
    {
        "regex": "OhHaiBrowser/(?:(\\d+[\\.\\d]+))?",
        "name": "OhHai Browser",
        "version": "$1"
    },
    {
        "regex": "Sizzy/(?:(\\d+[\\.\\d]+))?",
        "name": "Sizzy",
        "version": "$1"
    },
    {
        "regex": "GlassBrowser/(?:(\\d+[\\.\\d]+))?",
        "name": "Glass Browser",
        "version": "$1"
    },
    {
        "regex": "ToGate/(?:(\\d+[\\.\\d]+))?",
        "name": "ToGate",
        "version": "$1"
    },
    {
        "regex": "AirWatch Browser v(?:(\\d+[\\.\\d]+))?",
        "name": "VMware AirWatch",
        "version": "$1"
    },
    {
        "regex": "ADG/(?:(\\d+[\\.\\d]+))?",
        "name": "AOL Desktop",
        "version": "$1"
    },
    {
        "regex": "Elements Browser/(?:(\\d+[\\.\\d]+))?",
        "name": "Elements Browser",
        "version": "$1"
    },
    {
        "regex": "Light/(\\d+[\\.\\d]+)",
        "name": "Light",
        "version": "$1"
    },
    {
        "regex": "Valve Steam GameOverlay/(?:(\\d+[\\.\\d]+))?",
        "name": "Steam In-Game Overlay",
        "version": "$1"
    },
    {
        "regex": "115Browser/(?:(\\d+[\\.\\d]+))?",
        "name": "115 Browser",
        "version": "$1"
    },
    {
        "regex": "Atom/(?:(\\d+[\\.\\d]+))?",
        "name": "Atom",
        "version": "$1"
    },
    {
        "regex": "Mobile VR.+Firefox",
        "name": "Firefox Reality",
        "version": ""
    },
    {
        "regex": "AVG(?:/(\\d+[\\.\\d]+))?",
        "name": "AVG Secure Browser",
        "version": "$1"
    },
    {
        "regex": "Start/(?:(\\d+[\\.\\d]+))?",
        "name": "START Internet Browser",
        "version": "$1"
    },
    {
        "regex": "Lovense(?:/(\\d+[\\.\\d]+))?",
        "name": "Lovense Browser",
        "version": "$1"
    },
    {
        "regex": "com.airfind.deltabrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Delta Browser",
        "version": "$1"
    },
    {
        "regex": "(?:Ordissimo|webissimo3)(?:/(\\d+[\\.\\d]+))?",
        "name": "Ordissimo",
        "version": "$1"
    },
    {
        "regex": "CCleaner(?:/(\\d+[\\.\\d]+))?",
        "name": "CCleaner",
        "version": "$1"
    },
    {
        "regex": "AlohaLite(?:/(\\d+[\\.\\d]+))?",
        "name": "Aloha Browser Lite",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "TaoBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Tao Browser",
        "version": "$1"
    },
    {
        "regex": "Falkon(?:/(\\d+[\\.\\d]+))?",
        "name": "Falkon",
        "version": "$1"
    },
    {
        "regex": "mCent(?:/(\\d+[\\.\\d]+))?",
        "name": "mCent",
        "version": "$1"
    },
    {
        "regex": "SalamWeb(?:/(\\d+[\\.\\d]+))?",
        "name": "SalamWeb",
        "version": "$1"
    },
    {
        "regex": "BlackHawk(?:/(\\d+[\\.\\d]+))?",
        "name": "BlackHawk",
        "version": "$1"
    },
    {
        "regex": "Minimo(?:/(\\d+[\\.\\d]+))?",
        "name": "Minimo",
        "version": "$1"
    },
    {
        "regex": "WIB(?:/(\\d+[\\.\\d]+))?",
        "name": "Wear Internet Browser",
        "version": "$1"
    },
    {
        "regex": "Origyn Web Browser",
        "name": "Origyn Web Browser",
        "version": ""
    },
    {
        "regex": "Kinza(?:/(\\d+[\\.\\d]+))?",
        "name": "Kinza",
        "version": "$1"
    },
    {
        "regex": "Beamrise(?:/(\\d+[\\.\\d]+))?",
        "name": "Beamrise",
        "version": "$1"
    },
    {
        "regex": "Faux(?:/(\\d+[\\.\\d]+))?",
        "name": "Faux Browser",
        "version": "$1"
    },
    {
        "regex": "splash Version(?:/(\\d+[\\.\\d]+))?",
        "name": "Splash",
        "version": "$1"
    },
    {
        "regex": "MZBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Meizu Browser",
        "version": "$1"
    },
    {
        "regex": "COSBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "COS Browser",
        "version": "$1"
    },
    {
        "regex": "Crusta(?:/(\\d+[\\.\\d]+))?",
        "name": "Crusta",
        "version": "$1"
    },
    {
        "regex": "Hawk/TurboBrowser(?:/v?(\\d+[\\.\\d]+))?",
        "name": "Hawk Turbo Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "FreeU(?:/(\\d+[\\.\\d]+))?",
        "name": "FreeU",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "NoxBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Nox Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Basilisk(?:/(\\d+[\\.\\d]+))?",
        "name": "Basilisk",
        "version": "$1",
        "engine": {
            "default": "Goanna"
        }
    },
    {
        "regex": "SputnikBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Sputnik Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "TNSBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "K.Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "OculusBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Oculus Browser",
        "version": "$1"
    },
    {
        "regex": "Jio(?:Browser|Pages)(?:/(\\d+[\\.\\d]+))?",
        "name": "Jio Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome/.+ Hola(?:/(\\d+[\\.\\d]+))?",
        "name": "hola! Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Slimjet/(?:(\\d+[\\.\\d]+))",
        "name": "Slimjet",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "7Star/(?:(\\d+[\\.\\d]+))",
        "name": "7Star",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "MxNitro/(?:(\\d+[\\.\\d]+))",
        "name": "MxNitro",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "HuaweiBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Huawei Browser",
        "version": "$1"
    },
    {
        "regex": "VivoBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "vivo Browser",
        "version": "$1"
    },
    {
        "regex": "RealmeBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Realme Browser",
        "version": "$1"
    },
    {
        "regex": "Beaker ?Browser(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Beaker Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "QwantiOS/(\\d+[\\.\\d]+)",
        "name": "Qwant Mobile",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "QwantMobile(?:/(\\d+[\\.\\d]+))?",
        "name": "Qwant Mobile",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Qwant/(\\d+[\\.\\d]+)",
        "name": "Qwant Mobile",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "TenFourFox(?:/(\\d+[\\.\\d]+))?",
        "name": "TenFourFox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "AOLShield(?:/(\\d+[\\.\\d]+))?",
        "name": "AOL Shield",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Edge[ /](\\d+[\\.\\d]+)",
        "name": "Microsoft Edge",
        "version": "$1",
        "engine": {
            "default": "Edge"
        }
    },
    {
        "regex": "EdgiOS[ /](\\d+[\\.\\d]+)",
        "name": "Microsoft Edge",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "EdgA[ /](\\d+[\\.\\d]+)",
        "name": "Microsoft Edge",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Edg[ /](\\d+[\\.\\d]+)",
        "name": "Microsoft Edge",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "QIHU 360[ES]E",
        "name": "360 Browser",
        "version": ""
    },
    {
        "regex": "360 Aphone Browser(?: \\((\\d+[\\.\\d]+)(?:beta)?\\))?",
        "name": "360 Phone Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "SailfishBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Sailfish Browser",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "IceCat(?:/(\\d+[\\.\\d]+))?",
        "name": "IceCat",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Mobicip",
        "name": "Mobicip",
        "version": "",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Camino(?:/(\\d+[\\.\\d]+))?",
        "name": "Camino",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Waterfox(?:/(\\d+[\\.\\d]+))?",
        "name": "Waterfox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Chrome/.+ AlohaBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Aloha Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "AlohaBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Aloha Browser",
        "version": "$1"
    },
    {
        "regex": "(?:Avast|ASW|Safer)(?:/(\\d+[\\.\\d]+))?",
        "name": "Avast Secure Browser",
        "version": "$1"
    },
    {
        "regex": "Epic(?:/(\\d+[\\.\\d]+))",
        "name": "Epic",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Fennec(?:/(\\d+[\\.\\d]+))?",
        "name": "Fennec",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Firefox.*Tablet browser (\\d+[\\.\\d]+)",
        "name": "MicroB",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Maemo Browser(?: (\\d+[\\.\\d]+))?",
        "name": "MicroB",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Deepnet Explorer (\\d+[\\.\\d]+)?",
        "name": "Deepnet Explorer",
        "version": "$1"
    },
    {
        "regex": "Avant ?Browser",
        "name": "Avant Browser",
        "version": "",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "OppoBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Oppo Browser",
        "version": "$1"
    },
    {
        "regex": "Chrome/(\\d+[\\.\\d]+).*MRCHROME",
        "name": "Amigo",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "AtomicBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Atomic Web Browser",
        "version": "$1"
    },
    {
        "regex": "Bunjalloo(?:/(\\d+[\\.\\d]+))?",
        "name": "Bunjalloo",
        "version": "$1"
    },
    {
        "regex": "Brave(?:/(\\d+[\\.\\d]+))?",
        "name": "Brave",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Iridium(?:/(\\d+[\\.\\d]+))?",
        "name": "Iridium",
        "version": "$1"
    },
    {
        "regex": "Iceweasel(?:/(\\d+[\\.\\d]+))?",
        "name": "Iceweasel",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "WebPositive",
        "name": "WebPositive",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": ".*Goanna.*PaleMoon(?:/(\\d+[\\.\\d]+))?",
        "name": "Pale Moon",
        "version": "$1",
        "engine": {
            "default": "Goanna"
        }
    },
    {
        "regex": "PaleMoon(?:/(\\d+[\\.\\d]+))?",
        "name": "Pale Moon",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "CometBird(?:/(\\d+[\\.\\d]+))?",
        "name": "CometBird",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "IceDragon(?:/(\\d+[\\.\\d]+))?",
        "name": "IceDragon",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Flock(?:/(\\d+[\\.\\d]+))?",
        "name": "Flock",
        "version": "$1",
        "engine": {
            "default": "Gecko",
            "versions": {
                "3": "WebKit"
            }
        }
    },
    {
        "regex": "JigBrowserPlus/(?:(\\d+[\\.\\d]+))?",
        "name": "Jig Browser Plus",
        "version": "$1"
    },
    {
        "regex": "jig browser(?: web;|9i?)?(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Jig Browser",
        "version": "$1"
    },
    {
        "regex": "Kapiko(?:/(\\d+[\\.\\d]+))?",
        "name": "Kapiko",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Kylo(?:/(\\d+[\\.\\d]+))?",
        "name": "Kylo",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Origin/(?:(\\d+[\\.\\d]+))?",
        "name": "Origin In-Game Overlay",
        "version": "$1"
    },
    {
        "regex": "Cunaguaro(?:/(\\d+[\\.\\d]+))?",
        "name": "Cunaguaro",
        "version": "$1"
    },
    {
        "regex": "(?:TO-Browser/TOB|DT-Browser/DTB)(\\d+[\\.\\d]+)",
        "name": "t-online.de Browser",
        "version": "$1"
    },
    {
        "regex": "Kazehakase(?:/(\\d+[\\.\\d]+))?",
        "name": "Kazehakase",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "ArcticFox(?:/(\\d+[\\.\\d]+))?",
        "name": "Arctic Fox",
        "version": "$1",
        "engine": {
            "default": "Goanna"
        }
    },
    {
        "regex": "Mypal(?:/(\\d+[\\.\\d]+))?",
        "name": "Mypal",
        "version": "$1",
        "engine": {
            "default": "Goanna"
        }
    },
    {
        "regex": "Centaury(?:/(\\d+[\\.\\d]+))?",
        "name": "Centaury",
        "version": "$1",
        "engine": {
            "default": "Goanna"
        }
    },
    {
        "regex": "(?:Focus|Klar)(?:/(\\d+[\\.\\d]+))?",
        "name": "Firefox Focus",
        "version": "$1"
    },
    {
        "regex": "Cyberfox(?:/(\\d+[\\.\\d]+))?",
        "name": "Cyberfox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Firefox/(\\d+[\\.\\d]+).*\\(Swiftfox\\)",
        "name": "Swiftfox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "(?:Mobile|Tablet).*Servo.*Firefox(?:/(\\d+[\\.\\d]+))?",
        "name": "Firefox Mobile",
        "version": "$1",
        "engine": {
            "default": "Servo"
        }
    },
    {
        "regex": "(?:Mobile|Tablet).*Firefox(?:/(\\d+[\\.\\d]+))?",
        "name": "Firefox Mobile",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "FxiOS/(\\d+[\\.\\d]+)",
        "name": "Firefox Mobile iOS",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": ".*Servo.*Firefox(?:/(\\d+[\\.\\d]+))?",
        "name": "Firefox",
        "version": "$1",
        "engine": {
            "default": "Servo"
        }
    },
    {
        "regex": "(?!.*Opera[ /])Firefox(?:/(\\d+[\\.\\d]+))?",
        "name": "Firefox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "(?:BonEcho|GranParadiso|Lorentz|Minefield|Namoroka|Shiretoko)/(\\d+[\\.\\d]+)",
        "name": "Firefox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "ANTFresco(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "ANT Fresco",
        "version": "$1"
    },
    {
        "regex": "ANTGalio(?:/(\\d+[\\.\\d]+))?",
        "name": "ANTGalio",
        "version": "$1"
    },
    {
        "regex": "(?:Espial|Escape)(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Espial TV Browser",
        "version": "$1"
    },
    {
        "regex": "RockMelt(?:/(\\d+[\\.\\d]+))?",
        "name": "RockMelt",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Fireweb Navigator(?:/(\\d+[\\.\\d]+))?",
        "name": "Fireweb Navigator",
        "version": "$1"
    },
    {
        "regex": "Fireweb(?:/(\\d+[\\.\\d]+))?",
        "name": "Fireweb",
        "version": "$1"
    },
    {
        "regex": "(?:Navigator|Netscape6?)(?:/(\\d+[\\.\\d]+))?",
        "name": "Netscape",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "(?:Polarity)(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Polarity",
        "version": "$1"
    },
    {
        "regex": "(?:QupZilla)(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "QupZilla",
        "version": "$1"
    },
    {
        "regex": "(?:Dooble)(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Dooble",
        "version": "$1"
    },
    {
        "regex": "Whale/(\\d+[\\.\\d]+)",
        "name": "Whale Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Obigo[ ]?(?:InternetBrowser|Browser)?(?:[ /]([a-z0-9]*))?",
        "name": "Obigo",
        "version": "$1"
    },
    {
        "regex": "Obigo|Teleca",
        "name": "Obigo",
        "version": ""
    },
    {
        "regex": "UCBrowserHD/(\\d[\\d\\.]+)",
        "name": "UC Browser HD",
        "version": "$1"
    },
    {
        "regex": "UCMini(?:[ /]?(\\d+[\\.\\d]+))?",
        "name": "UC Browser Mini",
        "version": "$1"
    },
    {
        "regex": "UC[ ]?Browser.* \\(UCMini\\)",
        "name": "UC Browser Mini",
        "version": ""
    },
    {
        "regex": "UCTurbo(?:[ /]?(\\d+[\\.\\d]+))?",
        "name": "UC Browser Turbo",
        "version": "$1"
    },
    {
        "regex": "UC[ ]?Browser.* \\(UCTurbo\\)",
        "name": "UC Browser Turbo",
        "version": ""
    },
    {
        "regex": "OPRGX(?:/(\\d+[\\.\\d]+))?",
        "name": "Opera GX",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "(?:Opera Tablet.*Version|Opera/.+Opera Mobi.+Version|Mobile.+OPR)/(\\d+[\\.\\d]+)",
        "name": "Opera Mobile",
        "version": "$1",
        "engine": {
            "default": "Presto",
            "versions": {
                "15": "Blink"
            }
        }
    },
    {
        "regex": "MMS/(\\d+[\\.\\d]+)",
        "name": "Opera Neon",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "OMI/(\\d+[\\.\\d]+)",
        "name": "Opera Devices",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Opera%20Touch/(\\d+[\\.\\d]+)? CFNetwork/.+Darwin/.+(?!.*x86_64)",
        "name": "Opera Touch",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "OPT/(\\d+[\\.\\d]+)",
        "name": "Opera Touch",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Opera/(\\d+[\\.\\d]+).+Opera Mobi",
        "name": "Opera Mobile",
        "version": "$1",
        "engine": {
            "default": "Presto",
            "versions": {
                "15": "Blink"
            }
        }
    },
    {
        "regex": "Opera ?Mini/(?:att/)?(\\d+[\\.\\d]+)",
        "name": "Opera Mini",
        "version": "$1",
        "engine": {
            "default": "Presto"
        }
    },
    {
        "regex": "Opera ?Mini.+Version/(\\d+[\\.\\d]+)",
        "name": "Opera Mini",
        "version": "$1",
        "engine": {
            "default": "Presto"
        }
    },
    {
        "regex": "OPiOS/(\\d+[\\.\\d]+)",
        "name": "Opera Mini iOS",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Opera%20Mini/(\\d+[\\.\\d]+) CFNetwork",
        "name": "Opera Mini iOS",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Opera.+Edition Next.+Version/(\\d+[\\.\\d]+)",
        "name": "Opera Next",
        "version": "$1",
        "engine": {
            "default": "Presto",
            "versions": {
                "15": "Blink"
            }
        }
    },
    {
        "regex": "(?:Opera|OPR)[/ ](?:9.80.*Version/)?(\\d+[\\.\\d]+).+Edition Next",
        "name": "Opera Next",
        "version": "$1",
        "engine": {
            "default": "Presto",
            "versions": {
                "15": "Blink"
            }
        }
    },
    {
        "regex": "(?:Opera[/ ]?|OPR[/ ])(?:9.80.*Version/)?(\\d+[\\.\\d]+)",
        "name": "Opera",
        "version": "$1",
        "engine": {
            "default": "",
            "versions": {
                "7": "Presto",
                "15": "Blink",
                "3.5": "Elektra"
            }
        }
    },
    {
        "regex": "rekonq(?:/(\\d+[\\.\\d]+))?",
        "name": "Rekonq",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "CoolNovo(?:/(\\d+[\\.\\d]+))?",
        "name": "CoolNovo",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "(?:Comodo[ _])?Dragon(?!fruit)(?:/(\\d+[\\.\\d]+))?",
        "name": "Comodo Dragon",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "ChromePlus(?:/(\\d+[\\.\\d]+))?",
        "name": "ChromePlus",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Conkeror(?:/(\\d+[\\.\\d]+))?",
        "name": "Conkeror",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Konqueror(?:/(\\d+[\\.\\d]+))?",
        "name": "Konqueror",
        "version": "$1",
        "engine": {
            "default": "KHTML",
            "versions": {
                "4": ""
            }
        }
    },
    {
        "regex": "(?:baidubrowser|bdbrowser(?:(?:hd)?_i18n)?|FlyFlow|BaiduHD)(?:[/ ](\\d+[\\.\\d]*))?",
        "name": "Baidu Browser",
        "version": "$1"
    },
    {
        "regex": "(?:(?:BD)?Spark(?:Safe)?|BIDUBrowser)[/ ](\\d+[\\.\\d]*)",
        "name": "Baidu Spark",
        "version": "$1"
    },
    {
        "regex": "YaBrowser(?:/(\\d+[\\.\\d]*)) \\(lite\\)?",
        "name": "Yandex Browser Lite",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "YaBrowser(?:/(\\d+[\\.\\d]*))(?: \\((alpha|beta)\\))?",
        "name": "Yandex Browser",
        "version": "$1 $2",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Ya(?:ndex)?SearchBrowser(?:/(\\d+[\\.\\d]*))",
        "name": "Yandex Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Vivaldi(?:/(\\d+[\\.\\d]+))?",
        "name": "Vivaldi",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "TweakStyle(?:/(\\d+[\\.\\d]+))?",
        "name": "TweakStyle",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome.+Midori Browser/(\\d+[\\.\\d]+)",
        "name": "Midori",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Midori(?:/(\\d+[\\.\\d]+))?",
        "name": "Midori",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Mercury(?:/(\\d+[\\.\\d]+))?",
        "name": "Mercury",
        "version": "$1"
    },
    {
        "regex": "Chrome.+Maxthon(?:.+\\(portable\\))?/(\\d+[\\.\\d]+)",
        "name": "Maxthon",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "5.2": "Blink"
            }
        }
    },
    {
        "regex": "(?:Maxthon(?:%20Browser)?|MxBrowser(?:-inhouse|-iPhone)?)[ /](\\d+[\\.\\d]+)",
        "name": "Maxthon",
        "version": "$1",
        "engine": {
            "default": "",
            "versions": {
                "3": "WebKit"
            }
        }
    },
    {
        "regex": "(?:Maxthon|MyIE2)",
        "name": "Maxthon",
        "version": "",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Puffin(?:/(\\d+[\\.\\d]+))?",
        "name": "Puffin",
        "version": "$1"
    },
    {
        "regex": "MobileIron(?:/(\\d+[\\.\\d]+))?",
        "name": "Iron Mobile",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome(?:/(\\d+[\\.\\d]+))?.*Iron",
        "name": "Iron",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Iron(?:/(\\d+[\\.\\d]+))?",
        "name": "Iron",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "Epiphany(?:/(\\d+[\\.\\d]+))?",
        "name": "GNOME Web",
        "version": "$1",
        "engine": {
            "default": "Gecko",
            "versions": {
                "2.9.16": "",
                "2.28": "WebKit"
            }
        }
    },
    {
        "regex": "LieBaoFast(?:[ /](\\d+[\\.\\d]+))?",
        "name": "LieBaoFast",
        "version": "$1"
    },
    {
        "regex": "LBBrowser(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Cheetah Browser",
        "version": "$1"
    },
    {
        "regex": "SE (\\d+[\\.\\d]+)",
        "name": "Sogou Explorer",
        "version": "$1"
    },
    {
        "regex": "QQBrowserLite/([\\d\\.]+)",
        "name": "QQ Browser Lite",
        "version": "$1"
    },
    {
        "regex": "M?QQBrowser/Mini([\\.\\d]+)?",
        "name": "QQ Browser Mini",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "M?QQBrowser(?:/([\\.\\d]+))?",
        "name": "QQ Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "(?:MIUIBrowser|MiuiBrowser)(?:/(\\d+[\\.\\d]+))?",
        "name": "MIUI Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "(?:coc_coc_browser|coccocbrowser|CocCoc)(?:/(\\d+[\\.\\d]+))?",
        "name": "Coc Coc",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "DuckDuckGo/(\\d+[\\.\\d]*)",
        "name": "DuckDuckGo Privacy Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Samsung ?Browser(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Samsung Browser",
        "version": "$1"
    },
    {
        "regex": "(?:SFB(?:rowser)?)/(\\d+[\\.\\d]+)",
        "name": "Super Fast Browser",
        "version": "$1"
    },
    {
        "regex": "com.browser.tssomas(?:/(\\d+[\\.\\d]+))?",
        "name": "Super Fast Browser",
        "version": "$1"
    },
    {
        "regex": "EUI Browser(?:/(\\d+[\\.\\d]+))?",
        "name": "EUI Browser",
        "version": "$1"
    },
    {
        "regex": "UBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "UBrowser",
        "version": "$1"
    },
    {
        "regex": "Streamy(?:/(\\d+[\\.\\d]+))?",
        "name": "Streamy",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "isivioo",
        "name": "Isivioo",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "UC[ ]?Browser(?:[ /]?(\\d+[\\.\\d]+))?",
        "name": "UC Browser",
        "version": "$1"
    },
    {
        "regex": "UCWEB(?:[ /]?(\\d+[\\.\\d]+))?",
        "name": "UC Browser",
        "version": "$1"
    },
    {
        "regex": "UC AppleWebKit",
        "name": "UC Browser",
        "version": ""
    },
    {
        "regex": "Tenta/(\\d+[\\.\\d]+)",
        "name": "Tenta Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Rocket/(\\d+[\\.\\d]+)",
        "name": "Firefox Rocket",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Web Explorer/(\\d+[\\.\\d]+).*Chrome",
        "name": "Web Explorer",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "SznProhlizec/(\\d+[\\.\\d]+)",
        "name": "Seznam Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SogouMobileBrowser/(\\d+[\\.\\d]+)",
        "name": "Sogou Mobile Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Mint Browser/(\\d+[\\.\\d]+)",
        "name": "Mint Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Ecosia (?:android|ios)@(\\d+[\\.\\d]+)",
        "name": "Ecosia",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "ACHEETAHI",
        "name": "CM Browser",
        "version": "",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Kiwi Chrome",
        "name": "Kiwi",
        "version": "",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Mb2345Browser/(\\d+[\\.\\d]+)",
        "name": "2345 Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "QtWebEngine/(\\d+[\\.\\d]+)",
        "name": "QtWebEngine",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Silk/(\\d+[\\.\\d]+) like Chrome",
        "name": "Mobile Silk",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Silk(?:/(\\d+[\\.\\d]+))?",
        "name": "Mobile Silk",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "IBrowse(?:[ /](\\d+[\\.\\d]+))?",
        "name": "IBrowse",
        "version": "$1"
    },
    {
        "regex": "UP.Browser(?:/(\\d+[\\.\\d]+))?",
        "name": "Openwave Mobile Browser",
        "version": "$1"
    },
    {
        "regex": "Openwave(?:/(\\d+[\\.\\d]+))?",
        "name": "Openwave Mobile Browser",
        "version": "$1"
    },
    {
        "regex": "OneBrowser(?:[ /](\\d+[\\.\\d]+))?",
        "name": "ONE Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?:NokiaBrowser|BrowserNG)(?:/(\\d+[\\.\\d]+))?",
        "name": "Nokia Browser",
        "version": "$1"
    },
    {
        "regex": "Series60/5\\.0",
        "name": "Nokia Browser",
        "version": "7.0"
    },
    {
        "regex": "Series60/(\\d+[\\.\\d]+)",
        "name": "Nokia OSS Browser",
        "version": "$1"
    },
    {
        "regex": "S40OviBrowser/(\\d+[\\.\\d]+)",
        "name": "Nokia Ovi Browser",
        "version": "$1"
    },
    {
        "regex": "^Nokia|Nokia[EN]?\\d+",
        "name": "Nokia Browser",
        "version": ""
    },
    {
        "regex": "Sleipnir(?:(?:%20Browser)?[ /](\\d+[\\.\\d]+))?",
        "name": "Sleipnir",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "NTENTBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "NTENT Browser",
        "version": "$1"
    },
    {
        "regex": "TV Bro/(\\d+[\\.\\d]+)",
        "name": "TV Bro",
        "version": "$1"
    },
    {
        "regex": "Chrome/.+ Quark(?:/(\\d+[\\.\\d]+))?",
        "name": "Quark",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "MonumentBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Monument Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "BlueBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "Blue Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "JAPAN Browser(?:/(\\d+[\\.\\d]+))?",
        "name": "Japan Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Version/.* Chrome(?:/(\\d+[\\.\\d]+))?",
        "name": "Chrome Webview",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "CrMo(?:/(\\d+[\\.\\d]+))?",
        "name": "Chrome Mobile",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "CriOS(?:/(\\d+[\\.\\d]+))?",
        "name": "Chrome Mobile iOS",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Chrome(?:/(\\d+[\\.\\d]+))? Mobile",
        "name": "Chrome Mobile",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "chromeframe(?:/(\\d+[\\.\\d]+))?",
        "name": "Chrome Frame",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Chromium(?:/(\\d+[\\.\\d]+))?",
        "name": "Chromium",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "HeadlessChrome(?:/(\\d+[\\.\\d]+))?",
        "name": "Headless Chrome",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome(?!book)(?:/(\\d+[\\.\\d]+))?",
        "name": "Chrome",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "(?:Tizen|SLP) Browser(?:/(\\d+[\\.\\d]+))?",
        "name": "Tizen Browser",
        "version": "$1"
    },
    {
        "regex": "Blazer(?:/(\\d+[\\.\\d]+))?",
        "name": "Palm Blazer",
        "version": "$1"
    },
    {
        "regex": "Pre/(\\d+[\\.\\d]+)",
        "name": "Palm Pre",
        "version": "$1"
    },
    {
        "regex": "(?:hpw|web)OS/(\\d+[\\.\\d]+)",
        "name": "wOSBrowser",
        "version": "$1"
    },
    {
        "regex": "WebPro(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Palm WebPro",
        "version": "$1"
    },
    {
        "regex": "Palmscape(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Palmscape",
        "version": "$1"
    },
    {
        "regex": "Jasmine(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Jasmine",
        "version": "$1"
    },
    {
        "regex": "Lynx(?:/(\\d+[\\.\\d]+))?",
        "name": "Lynx",
        "version": "$1",
        "engine": {
            "default": "Text-based"
        }
    },
    {
        "regex": "NCSA_Mosaic(?:/(\\d+[\\.\\d]+))?",
        "name": "NCSA Mosaic",
        "version": "$1"
    },
    {
        "regex": "ABrowse(?: (\\d+[\\.\\d]+))?",
        "name": "ABrowse",
        "version": "$1"
    },
    {
        "regex": "amaya(?:/(\\d+[\\.\\d]+))?",
        "name": "Amaya",
        "version": "$1"
    },
    {
        "regex": "AmigaVoyager(?:/(\\d+[\\.\\d]+))?",
        "name": "Amiga Voyager",
        "version": "$1"
    },
    {
        "regex": "Amiga-Aweb(?:/(\\d+[\\.\\d]+))?",
        "name": "Amiga Aweb",
        "version": "$1"
    },
    {
        "regex": "Arora(?:/(\\d+[\\.\\d]+))?",
        "name": "Arora",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Beonex(?:/(\\d+[\\.\\d]+))?",
        "name": "Beonex",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "bline(?:/(\\d+[\\.\\d]+))?",
        "name": "B-Line",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "BrowseX \\((\\d+[\\.\\d]+)",
        "name": "BrowseX",
        "version": "$1"
    },
    {
        "regex": "Charon(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Charon",
        "version": "$1"
    },
    {
        "regex": "Cheshire(?:/(\\d+[\\.\\d]+))?",
        "name": "Cheshire",
        "version": "$1"
    },
    {
        "regex": "dbrowser",
        "name": "dbrowser",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Dillo(?:/(\\d+[\\.\\d]+))?",
        "name": "Dillo",
        "version": "$1",
        "engine": {
            "default": "Dillo"
        }
    },
    {
        "regex": "Dolfin(?:/(\\d+[\\.\\d]+))?|dolphin",
        "name": "Dolphin",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Elinks(?:/(\\d+[\\.\\d]+))?",
        "name": "Elinks",
        "version": "$1",
        "engine": {
            "default": "Text-based"
        }
    },
    {
        "regex": "Element Browser(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Element Browser",
        "version": "$1"
    },
    {
        "regex": "eZBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "eZ Browser",
        "version": "$1"
    },
    {
        "regex": "Firebird(?! Build)(?:/(\\d+[\\.\\d]+))?",
        "name": "Firebird",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Fluid(?:/(\\d+[\\.\\d]+))?",
        "name": "Fluid",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Galeon(?:/(\\d+[\\.\\d]+))?",
        "name": "Galeon",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Google Earth(?:/(\\d+[\\.\\d]+))?",
        "name": "Google Earth",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "HotJava(?:/(\\d+[\\.\\d]+))?",
        "name": "HotJava",
        "version": "$1"
    },
    {
        "regex": "iCabMobile(?:[ /](\\d+[\\.\\d]+))?",
        "name": "iCab Mobile",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "iCab(?:[ /](\\d+[\\.\\d]+))?",
        "name": "iCab",
        "version": "$1",
        "engine": {
            "default": "iCab",
            "versions": {
                "4": "WebKit"
            }
        }
    },
    {
        "regex": "i?Lunascape(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Lunascape",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Crazy Browser (\\d+[\\.\\d]+)",
        "name": "Crazy Browser",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "IEMobile[ /](\\d+[\\.\\d]+)",
        "name": "IE Mobile",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "MSIE (\\d+[\\.\\d]+).*XBLWP7",
        "name": "IE Mobile",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "MSIE.*Trident/4.0",
        "name": "Internet Explorer",
        "version": "8.0",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "MSIE.*Trident/5.0",
        "name": "Internet Explorer",
        "version": "9.0",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "MSIE.*Trident/6.0",
        "name": "Internet Explorer",
        "version": "10.0",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "Trident/[78].0",
        "name": "Internet Explorer",
        "version": "11.0",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "MSIE (\\d+[\\.\\d]+)",
        "name": "Internet Explorer",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "IE[ /](\\d+[\\.\\d]+)",
        "name": "Internet Explorer",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "Kindle/(\\d+[\\.\\d]+)",
        "name": "Kindle Browser",
        "version": "$1"
    },
    {
        "regex": "K-meleon(?:/(\\d+[\\.\\d]+))?",
        "name": "K-meleon",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Links(?: \\((\\d+[\\.\\d]+))?",
        "name": "Links",
        "version": "$1",
        "engine": {
            "default": "Text-based"
        }
    },
    {
        "regex": "LG Browser(?:/(\\d+[\\.\\d]+))",
        "name": "LG Browser",
        "version": "$1"
    },
    {
        "regex": "LuaKit(?:/(\\d+[\\.\\d]+))?",
        "name": "LuaKit",
        "version": "$1"
    },
    {
        "regex": "OmniWeb(?:/[v]?(\\d+[\\.\\d]+))?",
        "name": "OmniWeb",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Phoenix(?:/(\\d+[\\.\\d]+))?",
        "name": "Phoenix",
        "version": "$1"
    },
    {
        "regex": "NetFrontLifeBrowser(?:/(\\d+[\\.\\d]+))?",
        "name": "NetFront Life",
        "version": "$1",
        "engine": {
            "default": "NetFront"
        }
    },
    {
        "regex": "NetFront(?:/(\\d+[\\.\\d]+))?",
        "name": "NetFront",
        "version": "$1",
        "engine": {
            "default": "NetFront"
        }
    },
    {
        "regex": "PLAYSTATION|NINTENDO 3|AppleWebKit.+ N[XF]/\\d+\\.\\d+\\.\\d+",
        "name": "NetFront",
        "version": ""
    },
    {
        "regex": "NetPositive(?:/(\\d+[\\.\\d]+))?",
        "name": "NetPositive",
        "version": "$1"
    },
    {
        "regex": "Odyssey Web Browser(?:.*OWB/(\\d+[\\.\\d]+))?",
        "name": "Odyssey Web Browser",
        "version": "$1"
    },
    {
        "regex": "OffByOne",
        "name": "Off By One",
        "version": ""
    },
    {
        "regex": "(?:Oregano|OreganMediaBrowser)(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Oregano",
        "version": "$1"
    },
    {
        "regex": "(?:Polaris|Embider)(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Polaris",
        "version": "$1"
    },
    {
        "regex": "SEMC-Browser(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "SEMC-Browser",
        "version": "$1"
    },
    {
        "regex": "Shiira(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Shiira",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Skyfire(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Skyfire",
        "version": "$1"
    },
    {
        "regex": "Snowshoe(?:/(\\d+[\\.\\d]+))?",
        "name": "Snowshoe",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Sunrise(?:Browser)?(?:/(\\d+[\\.\\d]+))?",
        "name": "Sunrise",
        "version": "$1"
    },
    {
        "regex": "SuperBird(?:/(\\d+[\\.\\d]+))?",
        "name": "SuperBird",
        "version": "$1"
    },
    {
        "regex": "Vision-Browser(?:/(\\d+[\\.\\d]+))",
        "name": "Vision Mobile Browser",
        "version": "$1"
    },
    {
        "regex": "WeTab-Browser",
        "name": "WeTab Browser",
        "version": ""
    },
    {
        "regex": "Xiino(?:/(\\d+[\\.\\d]+))?",
        "name": "Xiino",
        "version": "$1"
    },
    {
        "regex": "BlackBerry|PlayBook|BB10",
        "name": "BlackBerry Browser",
        "version": ""
    },
    {
        "regex": "Android",
        "name": "Android Browser",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Coast(?:/(\\d+[\\.\\d]+))?",
        "name": "Coast",
        "version": "$1"
    },
    {
        "regex": "Surf(?:/(\\d+[\\.\\d]+))?",
        "name": "surf",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?:(?:iPod|iPad|iPhone).+Version|MobileSafari)/(\\d+[\\.\\d]+)",
        "name": "Mobile Safari",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?:Version/(\\d+[\\.\\d]+).*)?Mobile.*Safari/",
        "name": "Mobile Safari",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?:iPod|iPhone|iPad)",
        "name": "Mobile Safari",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Version/(\\d+[\\.\\d]+).*Safari/|Safari/?\\d+",
        "name": "Safari",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Dorado WAP-Browser[/ ](\\d+[\\.\\d]+)",
        "name": "Dorado",
        "version": "$1"
    },
    {
        "regex": "NetSurf(?:/(\\d+[\\.\\d]+))?",
        "name": "NetSurf",
        "version": "$1",
        "engine": {
            "default": "NetSurf"
        }
    },
    {
        "regex": "Uzbl",
        "name": "Uzbl",
        "version": ""
    },
    {
        "regex": "SimpleBrowser",
        "name": "SimpleBrowser",
        "version": ""
    },
    {
        "regex": "Zvu(?:/(\\d+[\\.\\d]+))?",
        "name": "Zvu",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "GOGGalaxyClient/(\\d+[\\.\\d]+)?",
        "name": "GOG Galaxy",
        "version": "$1"
    },
    {
        "regex": "WAP Browser/MAUI|(?:\\w+)?Maui Wap Browser|MAUI[- ]Browser",
        "name": "MAUI WAP Browser",
        "version": ""
    },
    {
        "regex": "SP%20Browser/(\\d+[\\.\\d]+)",
        "name": "SP Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    }
]

var _$browser_engine_17=[
    {
        "regex": "NetFront",
        "name": "NetFront"
    },
    {
        "regex": "Edge",
        "name": "Edge"
    },
    {
        "regex": "Trident",
        "name": "Trident"
    },
    {
        "regex": "(?<!SmartHu)Blink",
        "name": "Blink"
    },
    {
        "regex": "(?:Apple)?WebKit",
        "name": "WebKit"
    },
    {
        "regex": "Presto",
        "name": "Presto"
    },
    {
        "regex": "Goanna",
        "name": "Goanna"
    },
    {
        "regex": "(?<!like )Gecko",
        "name": "Gecko"
    },
    {
        "regex": "KHTML",
        "name": "KHTML"
    },
    {
        "regex": "NetSurf",
        "name": "NetSurf"
    },
    {
        "regex": "Servo",
        "name": "Servo"
    },
    {
        "regex": "Goanna",
        "name": "Goanna"
    },
    {
        "regex": "Ekioh(?:Flow)?",
        "name": "EkiohFlow"
    }
]

var _$availableBrowsers_36={
    "1B": "115 Browser",
    "2B": "2345 Browser",
    "36": "360 Phone Browser",
    "3B": "360 Browser",
    "7B": "7654 Browser",
    "AA": "Avant Browser",
    "AB": "ABrowse",
    "AF": "ANT Fresco",
    "AG": "ANTGalio",
    "AL": "Aloha Browser",
    "AH": "Aloha Browser Lite",
    "AM": "Amaya",
    "AO": "Amigo",
    "AN": "Android Browser",
    "AE": "AOL Desktop",
    "AD": "AOL Shield",
    "AR": "Arora",
    "AX": "Arctic Fox",
    "AV": "Amiga Voyager",
    "AW": "Amiga Aweb",
    "A0": "Atom",
    "AT": "Atomic Web Browser",
    "AS": "Avast Secure Browser",
    "VG": "AVG Secure Browser",
    "AC": "Avira Scout",
    "A1": "AwoX",
    "BA": "Beaker Browser",
    "BM": "Beamrise",
    "BB": "BlackBerry Browser",
    "BD": "Baidu Browser",
    "BS": "Baidu Spark",
    "BI": "Basilisk",
    "BE": "Beonex",
    "BH": "BlackHawk",
    "BJ": "Bunjalloo",
    "BL": "B-Line",
    "BU": "Blue Browser",
    "BN": "Borealis Navigator",
    "BR": "Brave",
    "BK": "BriskBard",
    "BX": "BrowseX",
    "BZ": "Browzar",
    "BY": "Biyubi",
    "BF": "Byffox",
    "CA": "Camino",
    "CL": "CCleaner",
    "C6": "Chedot",
    "C0": "Centaury",
    "CC": "Coc Coc",
    "C4": "CoolBrowser",
    "C2": "Colibri",
    "CD": "Comodo Dragon",
    "C1": "Coast",
    "CX": "Charon",
    "CE": "CM Browser",
    "CF": "Chrome Frame",
    "HC": "Headless Chrome",
    "CH": "Chrome",
    "CI": "Chrome Mobile iOS",
    "CK": "Conkeror",
    "CM": "Chrome Mobile",
    "CN": "CoolNovo",
    "CO": "CometBird",
    "CB": "COS Browser",
    "CW": "Cornowser",
    "C3": "Chim Lac",
    "CP": "ChromePlus",
    "CR": "Chromium",
    "C5": "Chromium GOST",
    "CY": "Cyberfox",
    "CS": "Cheshire",
    "CT": "Crusta",
    "CG": "Craving Explorer",
    "CZ": "Crazy Browser",
    "CU": "Cunaguaro",
    "CV": "Chrome Webview",
    "DB": "dbrowser",
    "DE": "Deepnet Explorer",
    "DG": "deg-degan",
    "DA": "Deledao",
    "DT": "Delta Browser",
    "DS": "DeskBrowse",
    "DF": "Dolphin",
    "DO": "Dorado",
    "DR": "Dot Browser",
    "DL": "Dooble",
    "DI": "Dillo",
    "DD": "DuckDuckGo Privacy Browser",
    "EC": "Ecosia",
    "EI": "Epic",
    "EL": "Elinks",
    "EB": "Element Browser",
    "EE": "Elements Browser",
    "EZ": "eZ Browser",
    "EU": "EUI Browser",
    "EP": "GNOME Web",
    "ES": "Espial TV Browser",
    "FA": "Falkon",
    "FX": "Faux Browser",
    "F1": "Firefox Mobile iOS",
    "FB": "Firebird",
    "FD": "Fluid",
    "FE": "Fennec",
    "FF": "Firefox",
    "FK": "Firefox Focus",
    "FY": "Firefox Reality",
    "FR": "Firefox Rocket",
    "FL": "Flock",
    "FO": "Flow",
    "FM": "Firefox Mobile",
    "FW": "Fireweb",
    "FN": "Fireweb Navigator",
    "FS": "Flast",
    "FU": "FreeU",
    "GA": "Galeon",
    "GH": "Ghostery Privacy Browser",
    "GI": "GinxDroid Browser",
    "GB": "Glass Browser",
    "GE": "Google Earth",
    "GO": "GOG Galaxy",
    "HS": "HasBrowser",
    "HA": "Hawk Turbo Browser",
    "HE": "Helio",
    "HO": "hola! Browser",
    "HJ": "HotJava",
    "HU": "Huawei Browser",
    "IB": "IBrowse",
    "IC": "iCab",
    "I2": "iCab Mobile",
    "I1": "Iridium",
    "I3": "Iron Mobile",
    "I4": "IceCat",
    "ID": "IceDragon",
    "IV": "Isivioo",
    "IW": "Iceweasel",
    "IE": "Internet Explorer",
    "IM": "IE Mobile",
    "IR": "Iron",
    "JB": "Japan Browser",
    "JS": "Jasmine",
    "JA": "JavaFX",
    "JI": "Jig Browser",
    "JP": "Jig Browser Plus",
    "JO": "Jio Browser",
    "KB": "K.Browser",
    "KI": "Kindle Browser",
    "KM": "K-meleon",
    "KO": "Konqueror",
    "KP": "Kapiko",
    "KN": "Kinza",
    "KW": "Kiwi",
    "KD": "Kode Browser",
    "KY": "Kylo",
    "KZ": "Kazehakase",
    "LB": "Cheetah Browser",
    "LF": "LieBaoFast",
    "LG": "LG Browser",
    "LH": "Light",
    "LI": "Links",
    "IF": "Lolifox",
    "LO": "Lovense Browser",
    "LU": "LuaKit",
    "LL": "Lulumi",
    "LS": "Lunascape",
    "LN": "Lunascape Lite",
    "LX": "Lynx",
    "M1": "mCent",
    "MB": "MicroB",
    "MC": "NCSA Mosaic",
    "MZ": "Meizu Browser",
    "ME": "Mercury",
    "MF": "Mobile Safari",
    "MI": "Midori",
    "MO": "Mobicip",
    "MU": "MIUI Browser",
    "MS": "Mobile Silk",
    "MN": "Minimo",
    "MT": "Mint Browser",
    "MX": "Maxthon",
    "NM": "MxNitro",
    "MY": "Mypal",
    "MR": "Monument Browser",
    "MW": "MAUI WAP Browser",
    "NW": "Navigateur Web",
    "NR": "NFS Browser",
    "NB": "Nokia Browser",
    "NO": "Nokia OSS Browser",
    "NV": "Nokia Ovi Browser",
    "NX": "Nox Browser",
    "NE": "NetSurf",
    "NF": "NetFront",
    "NL": "NetFront Life",
    "NP": "NetPositive",
    "NS": "Netscape",
    "NT": "NTENT Browser",
    "OC": "Oculus Browser",
    "O1": "Opera Mini iOS",
    "OB": "Obigo",
    "O2": "Odin",
    "H2": "OceanHero",
    "OD": "Odyssey Web Browser",
    "OF": "Off By One",
    "HH": "OhHai Browser",
    "OE": "ONE Browser",
    "OX": "Opera GX",
    "OG": "Opera Neon",
    "OH": "Opera Devices",
    "OI": "Opera Mini",
    "OM": "Opera Mobile",
    "OP": "Opera",
    "ON": "Opera Next",
    "OO": "Opera Touch",
    "OA": "Orca",
    "OS": "Ordissimo",
    "OR": "Oregano",
    "O0": "Origin In-Game Overlay",
    "OY": "Origyn Web Browser",
    "OV": "Openwave Mobile Browser",
    "OW": "OmniWeb",
    "OT": "Otter Browser",
    "PL": "Palm Blazer",
    "PM": "Pale Moon",
    "PY": "Polypane",
    "PP": "Oppo Browser",
    "PR": "Palm Pre",
    "PU": "Puffin",
    "PW": "Palm WebPro",
    "PA": "Palmscape",
    "PE": "Perfect Browser",
    "PH": "Phantom Browser",
    "PX": "Phoenix",
    "PB": "Phoenix Browser",
    "PF": "PlayFree Browser",
    "PO": "Polaris",
    "PT": "Polarity",
    "LY": "PolyBrowser",
    "PI": "PrivacyWall",
    "PS": "Microsoft Edge",
    "QA": "Qazweb",
    "Q2": "QQ Browser Lite",
    "Q1": "QQ Browser Mini",
    "QQ": "QQ Browser",
    "QT": "Qutebrowser",
    "QU": "Quark",
    "QZ": "QupZilla",
    "QM": "Qwant Mobile",
    "QW": "QtWebEngine",
    "RE": "Realme Browser",
    "RK": "Rekonq",
    "RM": "RockMelt",
    "SB": "Samsung Browser",
    "SA": "Sailfish Browser",
    "S8": "Seewo Browser",
    "SC": "SEMC-Browser",
    "SE": "Sogou Explorer",
    "SF": "Safari",
    "S5": "Safe Exam Browser",
    "SW": "SalamWeb",
    "SV": "SFive",
    "SH": "Shiira",
    "S1": "SimpleBrowser",
    "SY": "Sizzy",
    "SK": "Skyfire",
    "SS": "Seraphic Sraf",
    "SL": "Sleipnir",
    "S6": "Slimjet",
    "S7": "SP Browser",
    "7S": "7Star",
    "LE": "Smart Lenovo Browser",
    "OZ": "Smooz",
    "SN": "Snowshoe",
    "SO": "Sogou Mobile Browser",
    "S2": "Splash",
    "SI": "Sputnik Browser",
    "SR": "Sunrise",
    "SP": "SuperBird",
    "SU": "Super Fast Browser",
    "S3": "surf",
    "SG": "Stargon",
    "S0": "START Internet Browser",
    "S4": "Steam In-Game Overlay",
    "ST": "Streamy",
    "SX": "Swiftfox",
    "SZ": "Seznam Browser",
    "TR": "T-Browser",
    "TO": "t-online.de Browser",
    "TA": "Tao Browser",
    "TF": "TenFourFox",
    "TB": "Tenta Browser",
    "TZ": "Tizen Browser",
    "TU": "Tungsten",
    "TG": "ToGate",
    "TS": "TweakStyle",
    "TV": "TV Bro",
    "UB": "UBrowser",
    "UC": "UC Browser",
    "UH": "UC Browser HD",
    "UM": "UC Browser Mini",
    "UT": "UC Browser Turbo",
    "UR": "UR Browser",
    "UZ": "Uzbl",
    "VE": "Venus Browser",
    "VI": "Vivaldi",
    "VV": "vivo Browser",
    "VB": "Vision Mobile Browser",
    "VM": "VMware AirWatch",
    "WI": "Wear Internet Browser",
    "WP": "Web Explorer",
    "WE": "WebPositive",
    "WF": "Waterfox",
    "WH": "Whale Browser",
    "WO": "wOSBrowser",
    "WT": "WeTab Browser",
    "YJ": "Yahoo! Japan Browser",
    "YA": "Yandex Browser",
    "YL": "Yandex Browser Lite",
    "YN": "Yaani Browser",
    "YB": "Yolo Browser",
    "XS": "xStand",
    "XI": "Xiino",
    "XV": "Xvast",
    "ZE": "Zetakey",
    "ZV": "Zvu"
}

var _$mobileOnlyBrowsers_37=[
    "36", "OC", "PU", "SK", "MF", "OI", "OM", "DD", "DB",
    "ST", "BL", "IV", "FM", "C1", "C4", "SA", "SB", "FR",
    "WP", "HA", "NX", "HU", "VV", "RE", "CB", "MZ", "UM",
    "FK", "FX", "WI", "MN", "M1", "AH", "SU", "EU", "EZ",
    "UT", "DT", "S0", "QU", "YN", "JB", "GH", "PI", "SG",
    "KD", "PE", "UH", "S7", "CW", "OZ", "GI", "VE"
]

var _$browser_34 = {};
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$browser_34, "__esModule", { value: true });
/* removed: const _$version_60 = require("../../utils/version"); */;
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
const browsers_json_1 = __importDefault(_$browsers_18);
const browser_engine_json_1 = __importDefault(_$browser_engine_17);
const available_browsers_json_1 = __importDefault(_$availableBrowsers_36);
const mobile_only_browsers_json_1 = __importDefault(_$mobileOnlyBrowsers_37);
class BrowserParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: "",
                engine: "",
                engineVersion: ""
            };
            for (const browser of browsers_json_1.default) {
                const match = _$userAgent_57.userAgentParser(browser.regex, userAgent);
                if (!match)
                    continue;
                const vrpVersion = _$variableReplacement_58.variableReplacement(browser.version, match);
                const version = _$version_60.formatVersion(vrpVersion, this.options.versionTruncation);
                const shortVersion = version && parseFloat(_$version_60.formatVersion(vrpVersion, 1)) || "";
                if (browser.engine) {
                    result.engine = browser.engine.default;
                    if (browser.engine && browser.engine.versions && shortVersion) {
                        const sortedEngineVersions = Object.entries(browser.engine.versions).sort((a, b) => {
                            return parseFloat(a[0]) > parseFloat(b[0]) ? 1 : -1;
                        });
                        for (const [versionThreshold, engineByVersion] of sortedEngineVersions) {
                            if (parseFloat(versionThreshold) <= shortVersion) {
                                result.engine = engineByVersion || "";
                            }
                        }
                    }
                }
                result.type = "browser";
                result.name = _$variableReplacement_58.variableReplacement(browser.name, match);
                result.version = version;
                break;
            }
            if (!result.engine) {
                for (const browserEngine of browser_engine_json_1.default) {
                    let match = null;
                    try {
                        match = RegExp(browserEngine.regex, "i").exec(userAgent);
                    }
                    catch (_a) {
                        // TODO: find out why it fails in some browsers
                    }
                    if (!match)
                        continue;
                    result.engine = browserEngine.name;
                    break;
                }
            }
            result.engineVersion = _$version_60.formatVersion(_$version_60.parseBrowserEngineVersion(userAgent, result.engine), this.options.versionTruncation);
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
_$browser_34.default = BrowserParser;
BrowserParser.getBrowserShortName = (browserName) => {
    for (const [shortName, name] of Object.entries(available_browsers_json_1.default)) {
        if (name === browserName) {
            return shortName;
        }
    }
    return "";
};
BrowserParser.isMobileOnlyBrowser = (browserName) => {
    return mobile_only_browsers_json_1.default.includes(BrowserParser.getBrowserShortName(browserName));
};

var _$mobile_apps_22=[
    {
        "regex": "AndroidDownloadManager(?:[ /]([\\d\\.]+))?",
        "name": "AndroidDownloadManager",
        "version": "$1"
    },
    {
        "regex": "(?:Apple)?News(?:[ /][\\d\\.]+)? Version(?:[ /]([\\d\\.]+))?",
        "name": "Apple News",
        "version": "$1"
    },
    {
        "regex": "bPod",
        "name": "bPod",
        "version": ""
    },
    {
        "regex": "MessengerLiteForiOS.(?:FBAV)(?:[ /]([\\d\\.]+))?",
        "name": "Facebook Messenger Lite",
        "version": "$1"
    },
    {
        "regex": "(?:MessengerForiOS|MESSENGER).(?:FBAV)(?:[ /]([\\d\\.]+))?",
        "name": "Facebook Messenger",
        "version": "$1"
    },
    {
        "regex": "(?:FBAV|com.facebook.katana)(?:[ /]([\\d\\.]+))?",
        "name": "Facebook",
        "version": "$1"
    },
    {
        "regex": "(?:FBAN|FBSV|FBID|FBBV)/",
        "name": "Facebook",
        "version": ""
    },
    {
        "regex": "FeedR(?:/([\\d\\.]+))?",
        "name": "FeedR",
        "version": "$1"
    },
    {
        "regex": "com.google.android.apps.searchlite",
        "name": "Google Go",
        "version": ""
    },
    {
        "regex": "com.google.android.apps.magazines",
        "name": "Google Play Newsstand",
        "version": ""
    },
    {
        "regex": "com.google.GooglePlus",
        "name": "Google Plus",
        "version": ""
    },
    {
        "regex": "MicroMessenger/([^; ]+)",
        "name": "WeChat",
        "version": "$1"
    },
    {
        "regex": "WeChatShareExtensionNew/([\\d\\.]+)",
        "name": "WeChat Share Extension",
        "version": "$1"
    },
    {
        "regex": "DingTalk/([0-9\\.]+)",
        "name": "DingTalk",
        "version": "$1"
    },
    {
        "regex": ".*__weibo__([0-9\\.]+)__",
        "name": "Sina Weibo",
        "version": "$1"
    },
    {
        "regex": "Pinterest(?: for (?:Android|iOS))?(?:/([\\d\\.]+))?",
        "name": "Pinterest",
        "version": "$1"
    },
    {
        "regex": "Podcatcher Deluxe",
        "name": "Podcatcher Deluxe",
        "version": ""
    },
    {
        "regex": "com.google.android.youtube(?:/([\\d\\.]+))?",
        "name": "YouTube",
        "version": "$1"
    },
    {
        "regex": "([^/]+)/(\\d+(?:\\.\\d+)+) \\((?:iPhone|iPad); iOS [0-9\\.]+; Scale/[0-9\\.]+\\)",
        "name": "$1",
        "version": "$2"
    },
    {
        "regex": "WhatsApp(?:[ /]([\\d\\.]+))?",
        "name": "WhatsApp",
        "version": "$1"
    },
    {
        "regex": "Line(?:[ /]([\\d\\.]+))",
        "name": "Line",
        "version": "$1"
    },
    {
        "regex": "Instacast(?:HD)?/(\\d\\.[\\d\\.abc]+) CFNetwork/([\\d\\.]+) Darwin/([\\d\\.]+)",
        "name": "Instacast",
        "version": "$1"
    },
    {
        "regex": "Podcasts/([\\d\\.]+)",
        "name": "Podcasts",
        "version": "$1"
    },
    {
        "regex": "Pocket Casts(?:, (?:Android|iOS) v([\\d\\.]+))?",
        "name": "Pocket Casts",
        "version": "$1"
    },
    {
        "regex": "Podcat/([\\d\\.]+)",
        "name": "Podcat",
        "version": "$1"
    },
    {
        "regex": "BeyondPod",
        "name": "BeyondPod",
        "version": null
    },
    {
        "regex": "AntennaPod/?([\\d\\.]+)?",
        "name": "AntennaPod",
        "version": "$1"
    },
    {
        "regex": "Overcast/([\\d\\.]+)",
        "name": "Overcast",
        "version": "$1"
    },
    {
        "regex": "(?:CastBox|fm.castbox.audiobook.radio.podcast)/?([\\d\\.]+)?",
        "name": "CastBox",
        "version": "$1"
    },
    {
        "regex": "Player FM",
        "name": "Player FM",
        "version": ""
    },
    {
        "regex": "Podkicker(?: Pro)?/([\\d\\.]+)",
        "name": "Podkicker",
        "version": "$1"
    },
    {
        "regex": "PodcastRepublic/([\\d\\.]+)",
        "name": "Podcast Republic",
        "version": "$1"
    },
    {
        "regex": "Castro/(\\d+)",
        "name": "Castro",
        "version": "$1"
    },
    {
        "regex": "Castro 2 ([\\d\\.]+)/[\\d]+ Like iTunes",
        "name": "Castro 2",
        "version": "$1"
    },
    {
        "regex": "Castro 2",
        "name": "Castro 2",
        "version": ""
    },
    {
        "regex": "DoggCatcher",
        "name": "DoggCatcher",
        "version": null
    },
    {
        "regex": "PodcastAddict/v([\\d]+)",
        "name": "Podcast & Radio Addict",
        "version": "$1"
    },
    {
        "regex": "Podcat(?:%202)?/([\\d]+) CFNetwork",
        "name": "Podcat",
        "version": "$1"
    },
    {
        "regex": "iCatcher[^\\d]+([\\d\\.]+)",
        "name": "iCatcher",
        "version": "$1"
    },
    {
        "regex": "YelpApp/([\\d\\.]+)",
        "name": "Yelp Mobile",
        "version": "$1"
    },
    {
        "regex": "jp.co.yahoo.android.yjtop/([\\d\\.]+)",
        "name": "Yahoo! Japan",
        "version": "$1"
    },
    {
        "regex": "RSSRadio/([\\d]+)?",
        "name": "RSSRadio",
        "version": "$1"
    },
    {
        "regex": "SogouSearch Android[\\d\\.]+ version([\\d\\.]+)?",
        "name": "SogouSearch App",
        "version": "$1"
    },
    {
        "regex": "NewsArticle/([\\d\\.]+)?",
        "name": "NewsArticle App",
        "version": "$1"
    },
    {
        "regex": "tieba/([\\d\\.]+)?",
        "name": "tieba",
        "version": "$1"
    },
    {
        "regex": "com\\.douban\\.group/([\\d\\.]+)?",
        "name": "douban App",
        "version": "$1"
    },
    {
        "regex": "BingWeb/([\\d\\.]+)?",
        "name": "BingWebApp",
        "version": "$1"
    },
    {
        "regex": "(?:com.google.GoogleMobile|GSA)/([\\d\\.]+)?",
        "name": "Google Search App",
        "version": "$1"
    },
    {
        "regex": "Flipboard/([\\d\\.]+)?",
        "name": "Flipboard App",
        "version": "$1"
    },
    {
        "regex": "Instagram[ /]([\\d\\.]+)?",
        "name": "Instagram App",
        "version": "$1"
    },
    {
        "regex": "baiduboxapp/([\\d\\.]+)?",
        "name": "Baidu Box App",
        "version": "$1"
    },
    {
        "regex": "Crosswalk(?!.*(?:Streamy|QwantMobile))/([\\d\\.]+)?",
        "name": "CrosswalkApp",
        "version": "$1"
    },
    {
        "regex": "Twitter for iPhone[/]?([\\d\\.]+)?",
        "name": "Twitter",
        "version": "$1"
    },
    {
        "regex": "Twitter/([\\d\\.]+)",
        "name": "Twitter",
        "version": "$1"
    },
    {
        "regex": "TwitterAndroid[/]?([\\d\\.]+)?",
        "name": "Twitter",
        "version": "$1"
    },
    {
        "regex": "TopBuzz/([\\d\\.]+)",
        "name": "TopBuzz",
        "version": "$1"
    },
    {
        "regex": "Snapchat/([\\d\\.]+)",
        "name": "Snapchat",
        "version": "$1"
    },
    {
        "regex": "UnityPlayer/([\\d\\.]+)",
        "name": "UnityPlayer",
        "version": "$1"
    },
    {
        "regex": "UCURSOS/v([\\d\\.]+)",
        "name": "U-Cursos",
        "version": "$1"
    },
    {
        "regex": "HeyTapBrowser/([\\d\\.]+)",
        "name": "HeyTapBrowser",
        "version": "$1"
    },
    {
        "regex": "RobloxApp/([\\d\\.]+)",
        "name": "Roblox",
        "version": "$1"
    },
    {
        "regex": "Viber/([\\d\\.]+)",
        "name": "Viber",
        "version": "$1"
    },
    {
        "regex": "Siri/1",
        "name": "Siri",
        "version": "1.0"
    },
    {
        "regex": "LinkedIn/([\\d\\.]+)",
        "name": "LinkedIn",
        "version": "$1"
    },
    {
        "regex": "Instapaper/([\\d\\.]+)",
        "name": "Instapaper",
        "version": "$1"
    },
    {
        "regex": "Keeper/([\\d\\.]+)",
        "name": "Keeper Password Manager",
        "version": "$1"
    },
    {
        "regex": "Skyeng Teachers/([\\d\\.]+)",
        "name": "Skyeng Teachers",
        "version": "$1"
    },
    {
        "regex": "Kik/([\\d\\.]+) \\(Android",
        "name": "Kik",
        "version": "$1"
    },
    {
        "regex": "Procast/?([\\d\\.]+)?",
        "name": "Procast",
        "version": "$1"
    },
    {
        "regex": "DeviantArt/([\\d\\.]+)",
        "name": "DeviantArt",
        "version": ""
    },
    {
        "regex": "Discord/([\\d\\.]+)",
        "name": "Discord",
        "version": ""
    },
    {
        "regex": "Covenant%20Eyes/([\\d\\.]+)",
        "name": "Covenant Eyes",
        "version": "$1"
    },
    {
        "regex": "HP%20Smart/([\\d\\.]+)",
        "name": "HP Smart",
        "version": ""
    },
    {
        "regex": "Bitsboard/([\\d\\.]+)",
        "name": "Bitsboard",
        "version": "$1"
    },
    {
        "regex": "Betbull/([\\d\\.]+)",
        "name": "BetBull",
        "version": ""
    },
    {
        "regex": "U-Cursos/([\\d\\.]+)",
        "name": "U-Cursos",
        "version": ""
    },
    {
        "regex": "1PasswordThumbs/([\\d\\.]+)",
        "name": "1Password",
        "version": "$1"
    },
    {
        "regex": "(?:Microsoft Office )?(Access|Excel|OneDrive for Business|OneNote|PowerPoint|Project|Publisher|Visio|Word)[ /]([\\d\\.]+)",
        "name": "Microsoft Office $1",
        "version": "$2"
    },
    {
        "regex": "OneDriveiOSApp/([\\d\\.]+)",
        "name": "Microsoft OneDrive",
        "version": "$1"
    },
    {
        "regex": "Microsoft Office Mobile/([\\d\\.]+)",
        "name": "Microsoft Office Mobile",
        "version": "$1"
    },
    {
        "regex": "OC/([\\d\\.]+) \\(Skype for Business\\)",
        "name": "Skype for Business",
        "version": "$1"
    },
    {
        "regex": "TikTok[/ ](\\d+\\.(?:[\\.\\d]+))?",
        "name": "TikTok",
        "version": "$1"
    },
    {
        "regex": "NAVER/(\\d+[\\.\\d]+) CFNetwork",
        "name": "Naver",
        "version": "$1"
    },
    {
        "regex": "Copied/(\\d+[\\.\\d]+) CFNetwork",
        "name": "Copied",
        "version": ""
    },
    {
        "regex": "Pic%20Collage/(\\d+[\\.\\d]+) CFNetwork",
        "name": "Pic Collage",
        "version": "$1"
    },
    {
        "regex": "Papers/(\\d+[\\.\\d]+) CFNetwork",
        "name": "Papers",
        "version": "$1"
    },
    {
        "regex": "RoboForm/(\\d+[\\.\\d]+) CFNetwork",
        "name": "RoboForm",
        "version": ""
    },
    {
        "regex": "Slack/(\\d+[\\.\\d]+) CFNetwork",
        "name": "Slack",
        "version": ""
    },
    {
        "regex": "KAKAOTALK (\\d+\\.(?:[\\.\\d]+))?",
        "name": "KakaoTalk",
        "version": "$1"
    },
    {
        "regex": "ShopeeVN/([\\d\\.]+)",
        "name": "Shopee",
        "version": "$1"
    },
    {
        "regex": "SPORT1/([\\d\\.]+)",
        "name": "SPORT1",
        "version": ""
    },
    {
        "regex": "Clovia/([\\d\\.]+)",
        "name": "Clovia",
        "version": "$1"
    },
    {
        "regex": "ShowMe/([\\d\\.]+)",
        "name": "ShowMe",
        "version": "$1"
    },
    {
        "regex": "Wattpad/([\\d\\.]+)",
        "name": "Wattpad",
        "version": "$1"
    },
    {
        "regex": "WSJ/([\\d\\.]+)",
        "name": "The Wall Street Journal",
        "version": ""
    },
    {
        "regex": "WH%20Questions/([\\d\\.]+)",
        "name": "WH Questions",
        "version": "$1"
    },
    {
        "regex": "whisper/([\\d\\.]+)",
        "name": "Whisper",
        "version": ""
    },
    {
        "regex": "Opal/([\\d\\.]+)",
        "name": "Opal Travel",
        "version": "$1"
    },
    {
        "regex": "Zalo/([\\d\\.]+)",
        "name": "Zalo",
        "version": "$1"
    },
    {
        "regex": "Yandex/([\\d\\.]+)",
        "name": "Yandex",
        "version": ""
    },
    {
        "regex": "Zoho%20Chat/([\\d\\.]+)",
        "name": "Zoho Chat",
        "version": "$1"
    },
    {
        "regex": "Thunder/(\\d+[\\.\\d]+)",
        "name": "Thunder",
        "version": "$1"
    },
    {
        "regex": "CGNBrowser/(\\d+[\\.\\d]+)",
        "name": "CGN",
        "version": "$1"
    },
    {
        "regex": "Podbean/.+App (\\d+[\\.\\d]+)",
        "name": "Podbean",
        "version": "$1"
    },
    {
        "regex": "AlexaMediaPlayer/(\\d+[\\.\\d]+)",
        "name": "Alexa Media Player",
        "version": "$1"
    },
    {
        "regex": "TuneIn Radio Pro(?:[^/]+)?/(\\d+[\\.\\d]+)",
        "name": "TuneIn Radio Pro",
        "version": "$1"
    },
    {
        "regex": "TuneIn Radio(?:[^/]+)?/(\\d+[\\.\\d]+)",
        "name": "TuneIn Radio",
        "version": "$1"
    },
    {
        "regex": "Podcaster/(\\d+[\\.\\d]+)",
        "name": "Podcaster",
        "version": "$1"
    },
    {
        "regex": "Swoot/(\\d+[\\.\\d]+)",
        "name": "Swoot",
        "version": "$1"
    },
    {
        "regex": "RadioPublic/android-(\\d+[\\.\\d]+)",
        "name": "RadioPublic",
        "version": "$1"
    },
    {
        "regex": "Podimo/(\\d+[\\.\\d]+)",
        "name": "Podimo",
        "version": "$1"
    },
    {
        "regex": "com.evolve.podcast/(\\d+[\\.\\d]+)",
        "name": "Evolve Podcast",
        "version": "$1"
    },
    {
        "regex": " Rocket.Chat\\+?/(\\d+[\\.\\d]+)",
        "name": "Rocket Chat",
        "version": "$1"
    },
    {
        "regex": "^Pandora Audio.+Android",
        "name": "Pandora",
        "version": ""
    },
    {
        "regex": "^NPROneAndroid",
        "name": "NPR One",
        "version": ""
    },
    {
        "regex": "^WirtschaftsWoche-iOS-(\\d+[\\.\\d]+)",
        "name": "Wirtschafts Woche",
        "version": "$1"
    },
    {
        "regex": "^Outlook-iOS/.+\\((\\d+[\\.\\d]+)\\)$",
        "name": "Microsoft Outlook",
        "version": "$1"
    },
    {
        "regex": "^TVirl/(\\d+[\\.\\d]+)",
        "name": "TVirl",
        "version": "$1"
    },
    {
        "regex": "2?chMate/(\\d+[\\.\\d]+)",
        "name": "ChMate",
        "version": "$1"
    },
    {
        "regex": "2tch/(\\d+[\\.\\d]+)",
        "name": "2tch",
        "version": "$1"
    },
    {
        "regex": "Ciisaa/(\\d+[\\.\\d]+)",
        "name": "Ciisaa",
        "version": "$1"
    },
    {
        "regex": "BB2C (\\d+[\\.\\d]+)",
        "name": "BB2C",
        "version": "$1"
    },
    {
        "regex": "twinkle/(\\d+[\\.\\d]+)",
        "name": "twinkle",
        "version": "$1"
    },
    {
        "regex": "JaneStyle_iOS/(\\d+[\\.\\d]+)",
        "name": "JaneStyle",
        "version": "$1"
    }
]

var _$mobileApps_41 = {};
"use strict";
var ____importDefault_41 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$mobileApps_41, "__esModule", { value: true });
const mobile_apps_json_1 = ____importDefault_41(_$mobile_apps_22);
/* removed: const _$version_60 = require("../../utils/version"); */;
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class MobileAppParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: ""
            };
            for (const mobileApp of mobile_apps_json_1.default) {
                const match = _$userAgent_57.userAgentParser(mobileApp.regex, userAgent);
                if (!match)
                    continue;
                result.type = "mobile app";
                result.name = _$variableReplacement_58.variableReplacement(mobileApp.name, match);
                result.version = _$version_60.formatVersion(_$variableReplacement_58.variableReplacement(mobileApp.version, match), this.options.versionTruncation);
                break;
            }
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
_$mobileApps_41.default = MobileAppParser;

var _$feed_readers_19=[
    {
        "regex": "Akregator(?:/(\\d+[\\.\\d]+))?",
        "name": "Akregator",
        "version": "$1",
        "url": "http://userbase.kde.org/Akregator",
        "type": "Feed Reader"
    },
    {
        "regex": "Apple-PubSub(?:/(\\d+[\\.\\d]+))?",
        "name": "Apple PubSub",
        "version": "$1",
        "url": "https://developer.apple.com/library/mac/documentation/Darwin/Reference/ManPages/man1/pubsub.1.html",
        "type": "Feed Reader"
    },
    {
        "regex": "BashPodder",
        "name": "BashPodder",
        "version": "",
        "url": "http://lincgeek.org/bashpodder/",
        "type": "Feed Reader"
    },
    {
        "regex": "Breaker/v([\\d\\.]+)",
        "name": "Breaker",
        "version": "$1",
        "url": "https://www.breaker.audio/",
        "type": "Feed Reader App"
    },
    {
        "regex": "Downcast/([\\d\\.]+)",
        "name": "Downcast",
        "version": "$1",
        "url": "http://downcastapp.com/",
        "type": "Feed Reader App"
    },
    {
        "regex": "FeedDemon(?:/(\\d+[\\.\\d]+))?",
        "name": "FeedDemon",
        "version": "$1",
        "url": "http://www.feeddemon.com/",
        "type": "Feed Reader"
    },
    {
        "regex": "Feeddler(?:RSS|PRO)(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Feeddler RSS Reader",
        "version": "$1",
        "url": "http://www.chebinliu.com/projects/iphone/feeddler-rss-reader/",
        "type": "Feed Reader App"
    },
    {
        "regex": "QuiteRSS(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "QuiteRSS",
        "version": "$1",
        "url": "https://quiterss.org",
        "type": "Feed Reader App"
    },
    {
        "regex": "gPodder/([\\d\\.]+)",
        "name": "gPodder",
        "version": "$1",
        "url": "http://gpodder.org/",
        "type": "Feed Reader App"
    },
    {
        "regex": "JetBrains Omea Reader(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "JetBrains Omea Reader",
        "version": "$1",
        "url": "http://www.jetbrains.com/omea/reader/",
        "type": "Feed Reader"
    },
    {
        "regex": "Liferea(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Liferea",
        "version": "$1",
        "url": "http://liferea.sf.net/",
        "type": "Feed Reader"
    },
    {
        "regex": "(?:NetNewsWire|Evergreen.+MacOS)(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "NetNewsWire",
        "version": "$1",
        "url": "http://netnewswireapp.com/",
        "type": "Feed Reader"
    },
    {
        "regex": "NewsBlur (?:iPhone|iPad) App(?: v(\\d+[\\.\\d]+))?",
        "name": "NewsBlur Mobile App",
        "version": "$1",
        "url": "http://www.newsblur.com",
        "type": "Feed Reader App"
    },
    {
        "regex": "NewsBlur(?:/(\\d+[\\.\\d]+))",
        "name": "NewsBlur",
        "version": "$1",
        "url": "http://www.newsblur.com",
        "type": "Feed Reader"
    },
    {
        "regex": "newsbeuter(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Newsbeuter",
        "version": "$1",
        "url": "http://www.newsbeuter.org/",
        "type": "Feed Reader"
    },
    {
        "regex": "PritTorrent/([\\d\\.]+)",
        "name": "PritTorrent",
        "version": "$1",
        "url": "http://bitlove.org",
        "type": "Feed Reader"
    },
    {
        "regex": "Pulp[/ ](\\d+[\\.\\d]+)",
        "name": "Pulp",
        "version": "$1",
        "url": "http://www.acrylicapps.com/pulp/",
        "type": "Feed Reader App"
    },
    {
        "regex": "ReadKit(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "ReadKit",
        "version": "$1",
        "url": "http://readkitapp.com/",
        "type": "Feed Reader App"
    },
    {
        "regex": "Reeder[/ ](\\d+[\\.\\d]+)",
        "name": "Reeder",
        "version": "$1",
        "url": "http://reederapp.com/",
        "type": "Feed Reader App"
    },
    {
        "regex": "RSSBandit(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "RSS Bandit",
        "version": "$1",
        "url": "http://www.rssbandit.org)",
        "type": "Feed Reader"
    },
    {
        "regex": "RSS Junkie(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "RSS Junkie",
        "version": "$1",
        "url": "https://play.google.com/store/apps/details?id=com.bitpowder.rssjunkie",
        "type": "Feed Reader App"
    },
    {
        "regex": "RSSOwl(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "RSSOwl",
        "version": "$1",
        "url": "http://www.rssowl.org/",
        "type": "Feed Reader"
    },
    {
        "regex": "Stringer",
        "name": "Stringer",
        "version": "",
        "url": "https://github.com/swanson/stringer",
        "type": "Feed Reader"
    }
]

var _$feedReaders_35 = {};
"use strict";
var ____importDefault_35 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$feedReaders_35, "__esModule", { value: true });
const feed_readers_json_1 = ____importDefault_35(_$feed_readers_19);
/* removed: const _$version_60 = require("../../utils/version"); */;
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class FeedReaderParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: "",
                url: ""
            };
            for (const feedReader of feed_readers_json_1.default) {
                const match = _$userAgent_57.userAgentParser(feedReader.regex, userAgent);
                if (!match)
                    continue;
                result.type = "feed reader";
                result.name = _$variableReplacement_58.variableReplacement(feedReader.name, match);
                result.version = _$version_60.formatVersion(_$variableReplacement_58.variableReplacement(feedReader.version, match), this.options.versionTruncation);
                result.url = feedReader.url;
                break;
            }
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
_$feedReaders_35.default = FeedReaderParser;

var _$libraries_20=[
    {
        "regex": "Wget(?:/(\\d+[\\.\\d]+))?",
        "name": "Wget",
        "version": "$1"
    },
    {
        "regex": "Guzzle(?:/(\\d+[\\.\\d]+))?",
        "name": "Guzzle (PHP HTTP Client)",
        "version": "$1"
    },
    {
        "regex": "(?:lib)?curl(?:/(\\d+[\\.\\d]+))?",
        "name": "curl",
        "version": "$1"
    },
    {
        "regex": "python-requests(?:/(\\d+[\\.\\d]+))?",
        "name": "Python Requests",
        "version": "$1"
    },
    {
        "regex": "Python-urllib(?:/?(\\d+[\\.\\d]+))?",
        "name": "Python urllib",
        "version": "$1"
    },
    {
        "regex": "Java(?:/?(\\d+[\\.\\d]+))?",
        "name": "Java",
        "version": "$1"
    },
    {
        "regex": "(?:perlclient|libwww-perl)(?:/?(\\d+[\\.\\d]+))?",
        "name": "Perl",
        "version": "$1"
    },
    {
        "regex": "okhttp/([\\d\\.]+)",
        "name": "OkHttp",
        "version": "$1"
    },
    {
        "regex": "HTTP_Request2(?:/(\\d+[\\.\\d]+))?",
        "name": "HTTP_Request2",
        "version": "$1"
    },
    {
        "regex": "HTTP_Request2(?:/(\\d+[\\.\\d]+))?",
        "name": "HTTP_Request2",
        "version": "$1",
        "url": "http://pear.php.net/package/http_request2"
    },
    {
        "regex": "Mechanize(?:/(\\d+[\\.\\d]+))?",
        "name": "Mechanize",
        "version": "$1",
        "url": "http://github.com/sparklemotion/mechanize/"
    },
    {
        "regex": "aiohttp(?:/(\\d+[\\.\\d]+))?",
        "name": "aiohttp",
        "version": "$1"
    },
    {
        "regex": "Google-HTTP-Java-Client(?:/(\\d+[\\.\\d\\w-]+))?",
        "name": "Google HTTP Java Client",
        "version": "$1"
    },
    {
        "regex": "WWW-Mechanize(?:/(\\d+[\\.\\d]+))?",
        "name": "WWW-Mechanize",
        "version": "$1"
    },
    {
        "regex": "Faraday(?: v(\\d+[\\.\\d]+))?",
        "name": "Faraday",
        "version": "$1"
    },
    {
        "regex": "(?:Go-http-client|Go )/?(?:(\\d+[\\.\\d]+))?(?: package http)?",
        "name": "Go-http-client",
        "version": "$1"
    },
    {
        "regex": "urlgrabber(?:/(\\d+[\\.\\d]+))?",
        "name": "urlgrabber (yum)",
        "version": "$1"
    },
    {
        "regex": "libdnf(?:/(\\d+[\\.\\d]+))?",
        "name": "libdnf",
        "version": "$1"
    },
    {
        "regex": "HTTPie(?:/(\\d+[\\.\\d]+))?",
        "name": "HTTPie",
        "version": "$1"
    },
    {
        "regex": "rest-client/(\\d+[\\.\\d]+).*ruby",
        "name": "REST Client for Ruby",
        "version": "$1"
    },
    {
        "regex": "RestSharp/(\\d+[\\.\\d]+)",
        "name": "RestSharp",
        "version": "$1",
        "url": "http://restsharp.org/"
    },
    {
        "regex": "scalaj-http/(\\d+[\\.\\d]+)",
        "name": "ScalaJ HTTP",
        "version": "$1",
        "url": "https://github.com/scalaj/scalaj-http"
    },
    {
        "regex": "REST::Client/(\\d+)",
        "name": "Perl REST::Client",
        "version": "$1",
        "url": "https://metacpan.org/pod/REST::Client"
    },
    {
        "regex": "node-fetch/(\\d+[\\.\\d]+)",
        "name": "Node Fetch",
        "version": "$1",
        "url": "https://github.com/node-fetch/node-fetch"
    },
    {
        "regex": "ReactorNetty/(\\d+[\\.\\d]+)",
        "name": "ReactorNetty",
        "version": "$1",
        "url": "https://github.com/reactor/reactor-netty"
    },
    {
        "regex": "PostmanRuntime(?:/(\\d+[\\.\\d]+))?",
        "name": "Postman Desktop",
        "version": "$1",
        "url": "https://github.com/postmanlabs/postman-runtime"
    },
    {
        "regex": "Jakarta Commons-HttpClient/([\\.\\d]+)",
        "name": "Jakarta Commons HttpClient",
        "version": "$1",
        "url": "https://hc.apache.org/httpclient-3.x"
    },
    {
        "regex": "WinHttp.WinHttpRequest.+([\\.\\d]+)",
        "name": "WinHttp WinHttpRequest",
        "version": "$1"
    },
    {
        "regex": "Embarcadero URI Client/([\\.\\d]+)",
        "name": "Embarcadero URI Client",
        "version": "$1"
    },
    {
        "regex": "Mikrotik/([\\.\\d]+)",
        "name": "Mikrotik Fetch",
        "version": "$1"
    },
    {
        "regex": "GRequests(?:/(\\d+[\\.\\d]+))?",
        "name": "GRequests",
        "version": "$1"
    },
    {
        "regex": "akka-http/([\\.\\d]+)",
        "name": "Akka HTTP",
        "version": "$1"
    }
]

var _$libraries_39 = {};
"use strict";
var ____importDefault_39 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$libraries_39, "__esModule", { value: true });
const libraries_json_1 = ____importDefault_39(_$libraries_20);
/* removed: const _$version_60 = require("../../utils/version"); */;
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class LibraryParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: "",
                url: ""
            };
            for (const library of libraries_json_1.default) {
                const match = _$userAgent_57.userAgentParser(library.regex, userAgent);
                if (!match)
                    continue;
                result.type = "library";
                result.name = _$variableReplacement_58.variableReplacement(library.name, match);
                result.version = _$version_60.formatVersion(_$variableReplacement_58.variableReplacement(library.version, match), this.options.versionTruncation);
                result.url = library.url || "";
                break;
            }
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
_$libraries_39.default = LibraryParser;

var _$mediaplayers_21=[
    {
        "regex": "Audacious(?:[ /]([\\d\\.]+))?",
        "name": "Audacious",
        "version": "$1"
    },
    {
        "regex": "Banshee(?:[ /]([\\d\\.]+))?",
        "name": "Banshee",
        "version": "$1"
    },
    {
        "regex": "Boxee(?:[ /]([\\d\\.]+))?",
        "name": "Boxee",
        "version": "$1"
    },
    {
        "regex": "Clementine(?:[ /]([\\d\\.]+))?",
        "name": "Clementine",
        "version": "$1"
    },
    {
        "regex": "Deezer(?:/([\\d\\.]+))?",
        "name": "Deezer",
        "version": "$1"
    },
    {
        "regex": "iTunes(?:-iPhone|-iPad)?(?:/([\\d\\.]+))?",
        "name": "iTunes",
        "version": "$1"
    },
    {
        "regex": "FlyCast(?:/([\\d\\.]+))?",
        "name": "FlyCast",
        "version": "$1"
    },
    {
        "regex": "foobar2000(?:/([\\d\\.]+))?",
        "name": "Foobar2000",
        "version": "$1"
    },
    {
        "regex": "MediaMonkey(?:[ /](\\d+[\\.\\d]+))?",
        "name": "MediaMonkey",
        "version": "$1"
    },
    {
        "regex": "Miro(?:/(\\d+[\\.\\d]+))?",
        "name": "Miro",
        "version": "$1"
    },
    {
        "regex": "NexPlayer(?:/(\\d+[\\.\\d]+))?",
        "name": "NexPlayer",
        "version": "$1"
    },
    {
        "regex": "Nightingale(?:/([\\d\\.]+))?",
        "name": "Nightingale",
        "version": "$1"
    },
    {
        "regex": "QuickTime(?:(?:(?:.+qtver=)|(?:(?: E-)?[\\./]))([\\d\\.]+))?",
        "name": "QuickTime",
        "version": "$1"
    },
    {
        "regex": "Songbird(?:/([\\d\\.]+))?",
        "name": "Songbird",
        "version": "$1"
    },
    {
        "regex": "SubStream(?:/([\\d\\.]+))?",
        "name": "SubStream",
        "version": "$1"
    },
    {
        "regex": "Sonos/([\\d\\.]+)?",
        "name": "SONOS",
        "version": "$1"
    },
    {
        "regex": "(?:Lib)?VLC(?:/([\\d\\.]+))?",
        "name": "VLC",
        "version": "$1"
    },
    {
        "regex": "Winamp(?:MPEG)?(?:/(\\d+[\\.\\d]+))?",
        "name": "Winamp",
        "version": "$1"
    },
    {
        "regex": "(?:Windows-Media-Player|NSPlayer)(?:/(\\d+[\\.\\d]+))?",
        "name": "Windows Media Player",
        "version": "$1"
    },
    {
        "regex": "XBMC(?:/([\\d\\.]+))?",
        "name": "XBMC",
        "version": "$1"
    },
    {
        "regex": "Kodi(?:/([\\d\\.]+))?",
        "name": "Kodi",
        "version": "$1"
    },
    {
        "regex": "stagefright(?:/([\\d\\.]+))?",
        "name": "Stagefright",
        "version": "$1"
    },
    {
        "regex": "GoogleChirp(?:/(\\d+[\\.\\d]+))?",
        "name": "Google Podcasts",
        "version": "$1"
    },
    {
        "regex": "Music Player Daemon (?:(\\d+[\\.\\d]+))?",
        "name": "Music Player Daemon",
        "version": "$1"
    },
    {
        "regex": "mpv (?:(\\d+[\\.\\d]+))?",
        "name": "mpv",
        "version": "$1"
    }
]

var _$mediaPlayers_40 = {};
"use strict";
var ____importDefault_40 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$mediaPlayers_40, "__esModule", { value: true });
const mediaplayers_json_1 = ____importDefault_40(_$mediaplayers_21);
/* removed: const _$version_60 = require("../../utils/version"); */;
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class MediaPlayerParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: ""
            };
            for (const mediaPlayer of mediaplayers_json_1.default) {
                const match = _$userAgent_57.userAgentParser(mediaPlayer.regex, userAgent);
                if (!match)
                    continue;
                result.type = "media player";
                result.name = _$variableReplacement_58.variableReplacement(mediaPlayer.name, match);
                result.version = _$version_60.formatVersion(_$variableReplacement_58.variableReplacement(mediaPlayer.version, match), this.options.versionTruncation);
                break;
            }
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
_$mediaPlayers_40.default = MediaPlayerParser;

var _$pim_23=[
    {
        "regex": "Outlook-Express(?:/(\\d+[\\.\\d]+))?",
        "name": "Outlook Express",
        "version": "$1"
    },
    {
        "regex": "Microsoft Outlook(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Microsoft Outlook",
        "version": "$1"
    },
    {
        "regex": "(?:Thunderbird|Icedove|Shredder)(?:/(\\d+[\\.\\d]+))?",
        "name": "Thunderbird",
        "version": "$1"
    },
    {
        "regex": "Airmail(?: (\\d+[\\.\\d]+))?",
        "name": "Airmail",
        "version": "$1"
    },
    {
        "regex": "Lotus-Notes(?:/(\\d+[\\.\\d]+))?",
        "name": "Lotus Notes",
        "version": "$1"
    },
    {
        "regex": "Barca(?:Pro)?(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Barca",
        "version": "$1"
    },
    {
        "regex": "Postbox(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Postbox",
        "version": "$1"
    },
    {
        "regex": "MailBar(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "MailBar",
        "version": "$1"
    },
    {
        "regex": "The Bat!(?: Voyager)?(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "The Bat!",
        "version": "$1"
    },
    {
        "regex": "DAVdroid(?:/(\\d+[\\.\\d]+))?",
        "name": "DAVdroid",
        "version": "$1"
    },
    {
        "regex": "(?:SeaMonkey|Iceape)(?:/(\\d+[\\.\\d]+))?",
        "name": "SeaMonkey",
        "version": "$1"
    },
    {
        "regex": "Live5ch/(\\d+[\\.\\d]+)",
        "name": "Live5ch",
        "version": "$1"
    },
    {
        "regex": "JaneView/",
        "name": "JaneView",
        "version": ""
    },
    {
        "regex": "BathyScaphe/",
        "name": "BathyScaphe",
        "version": ""
    }
]

var _$personalInformationManagers_42 = {};
"use strict";
var ____importDefault_42 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$personalInformationManagers_42, "__esModule", { value: true });
const pim_json_1 = ____importDefault_42(_$pim_23);
/* removed: const _$version_60 = require("../../utils/version"); */;
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class PersonalInformationManagerParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: ""
            };
            for (const personalInformationManager of pim_json_1.default) {
                const match = _$userAgent_57.userAgentParser(personalInformationManager.regex, userAgent);
                if (!match)
                    continue;
                result.type = "personal information manager";
                result.name = _$variableReplacement_58.variableReplacement(personalInformationManager.name, match);
                result.version = _$version_60.formatVersion(_$variableReplacement_58.variableReplacement(personalInformationManager.version, match), this.options.versionTruncation);
                break;
            }
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
_$personalInformationManagers_42.default = PersonalInformationManagerParser;

var _$client_38 = {};
"use strict";
var ____importDefault_38 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$client_38, "__esModule", { value: true });
const browser_1 = ____importDefault_38(_$browser_34);
const mobile_apps_1 = ____importDefault_38(_$mobileApps_41);
const feed_readers_1 = ____importDefault_38(_$feedReaders_35);
const libraries_1 = ____importDefault_38(_$libraries_39);
const media_players_1 = ____importDefault_38(_$mediaPlayers_40);
const personal_information_managers_1 = ____importDefault_38(_$personalInformationManagers_42);
const clientParsers = [
    feed_readers_1.default,
    mobile_apps_1.default,
    media_players_1.default,
    personal_information_managers_1.default,
    browser_1.default,
    libraries_1.default
];
class ClientParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            for (const Parser of clientParsers) {
                const parser = new Parser(this.options);
                const client = parser.parse(userAgent);
                if (client.type !== "")
                    return client;
            }
            return null;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
_$client_38.default = ClientParser;

var _$cameras_24={
    "Nikon": {
        "regex": "Coolpix S800c",
        "device": "camera",
        "model": "Coolpix S800c"
    },
    "Samsung": {
        "regex": "EK-G[CN][0-9]{3}",
        "device": "camera",
        "models": [
            {
                "regex": "EK-GN120",
                "model": "Galaxy NX"
            },
            {
                "regex": "EK-GC100",
                "model": "Galaxy Camera"
            },
            {
                "regex": "EK-GC110",
                "model": "Galaxy Camera WiFi only"
            },
            {
                "regex": "EK-GC200",
                "model": "Galaxy Camera 2"
            },
            {
                "regex": "EK-GC([0-9]{3})",
                "model": "Galaxy Camera $1"
            }
        ]
    }
}

var _$cameras_43 = {};
"use strict";
var ____importDefault_43 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$cameras_43, "__esModule", { value: true });
const cameras_json_1 = ____importDefault_43(_$cameras_24);
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class CameraParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            for (const [brand, camera] of Object.entries(cameras_json_1.default)) {
                const match = _$userAgent_57.userAgentParser(camera.regex, userAgent);
                if (!match)
                    continue;
                result.type = "camera";
                result.brand = brand;
                if ("model" in camera && camera.model) {
                    result.model = _$variableReplacement_58.variableReplacement(camera.model, match).trim();
                }
                else if ("models" in camera && camera.models) {
                    for (const model of camera.models) {
                        const modelMatch = _$userAgent_57.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = _$variableReplacement_58.variableReplacement(model.model, modelMatch).trim();
                        break;
                    }
                }
                break;
            }
            return result;
        };
    }
}
_$cameras_43.default = CameraParser;

var _$mobiles_27={
    "360": {
        "regex": "(?:180[1379]-A01|1713-A01|1707-A01|1509-A00|1603-A03|1607-A01|1503-A01)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "1807-A01(?:[);/ ]|$)",
                "model": "N7"
            },
            {
                "regex": "1803-A01(?:[);/ ]|$)",
                "model": "N7 Lite"
            },
            {
                "regex": "1809-A01(?:[);/ ]|$)",
                "model": "N7 Pro"
            },
            {
                "regex": "1713-A01(?:[);/ ]|$)",
                "model": "N6 Lite"
            },
            {
                "regex": "1707-A01(?:[);/ ]|$)",
                "model": "N6"
            },
            {
                "regex": "1801-A01(?:[);/ ]|$)",
                "model": "N6 Pro"
            },
            {
                "regex": "1509-A00(?:[);/ ]|$)",
                "model": "Q5 Plus"
            },
            {
                "regex": "1503-A01(?:[);/ ]|$)",
                "model": "N4"
            },
            {
                "regex": "1603-A03(?:[);/ ]|$)",
                "model": "N4A"
            },
            {
                "regex": "1607-A01(?:[);/ ]|$)",
                "model": "N5S"
            }
        ]
    },
    "8848": {
        "regex": "8848 (M[3-6])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Ace": {
        "regex": "(?:BUZZ [12]|BUZZ 2|CLEVER 1|URBAN 1(?: Pro)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BUZZ ([12]) Lite",
                "model": "Buzz $1 Lite"
            },
            {
                "regex": "BUZZ ([12]) Plus",
                "model": "Buzz $1 Plus"
            },
            {
                "regex": "BUZZ ([12])",
                "model": "Buzz $1"
            },
            {
                "regex": "CLEVER 1",
                "model": "Clever 1"
            },
            {
                "regex": "URBAN 1 Pro",
                "model": "Urban 1 Pro"
            },
            {
                "regex": "URBAN 1",
                "model": "Urban 1"
            }
        ]
    },
    "Tunisie Telecom": {
        "regex": "StarTrail TT(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "StarTrail by TT"
    },
    "SFR": {
        "regex": "StarShine|StarTrail|STARADDICT|StarText|StarNaute|StarXtrem|StarTab",
        "device": "smartphone",
        "models": [
            {
                "regex": "StarXtrem II(?:[);/ ]|$)",
                "model": "StarXtrem 2"
            },
            {
                "regex": "StarXtrem ?([3-6])(?:[);/ ]|$)",
                "model": "StarXtrem $1"
            },
            {
                "regex": "StarXtrem(?:[);/ ]|$)",
                "model": "StarXtrem"
            },
            {
                "regex": "StarTrail III(?:[);/ ]|$)",
                "model": "StarTrail 3"
            },
            {
                "regex": "StarTrail II(?:[);/ ]|$)",
                "model": "StarTrail 2"
            },
            {
                "regex": "StarTrail[ _]?([1-9])[ _]([34])G(?:[);/ ]|$)",
                "model": "StarTrail $1 $2G"
            },
            {
                "regex": "StarTrail[ _]?([1-9])(?:[);/ ]|$)",
                "model": "StarTrail $1"
            },
            {
                "regex": "StarTrail(?:[);/ ]|$)",
                "model": "StarTrail"
            },
            {
                "regex": "StarShine II(?:[);/ ]|$)",
                "model": "StarShine 2"
            },
            {
                "regex": "StarShine(?:[);/ ]|$)",
                "model": "StarShine"
            },
            {
                "regex": "STARADDICT 4(?:[);/ ]|$)",
                "model": "Staraddict 4"
            },
            {
                "regex": "STARADDICT III(?:[);/ ]|$)",
                "model": "Staraddict 3"
            },
            {
                "regex": "STARADDICT II Plus(?:[);/ ]|$)",
                "model": "Staraddict 2 Plus"
            },
            {
                "regex": "STARADDICT II(?:[);/ ]|$)",
                "model": "Staraddict 2"
            },
            {
                "regex": "STARADDICT(?:[);/ ]|$)",
                "model": "Staraddict"
            },
            {
                "regex": "StarText II(?:[);/ ]|$)",
                "model": "StarText 2"
            },
            {
                "regex": "StarText(?:[);/ ]|$)",
                "model": "StarText"
            },
            {
                "regex": "StarNaute II(?:[);/ ]|$)",
                "model": "StarNaute 2"
            },
            {
                "regex": "StarNaute(?:[);/ ]|$)",
                "model": "StarNaute"
            },
            {
                "regex": "StarTab",
                "model": "StarTab",
                "device": "tablet"
            },
            {
                "regex": "((?:StarShine|StarTrail|STARADDICT|StarText|StarNaute|StarXtrem)[^;/]*) Build",
                "model": "$1"
            }
        ]
    },
    "HTC": {
        "regex": "HTC|Sprint (?:APA|ATP)|ADR(?!910L)[a-z0-9]+|NexusHD2|Amaze[ _]4G(?:[);/ ]|$)|(Desire|Sensation|Evo ?3D|IncredibleS|Wildfire|Butterfly)[ _]?([^;/)]+)(?: Build|\\))|(Amaze[ _]4G|(?<!BLU LIFE )One ?[XELSV\\+]+)(?:[);/ ]|$)|SPV E6[05]0|(One M8|One Mini 2|X525a|PG86100|PC36100|XV6975|PJ83100|2PYB2|2PS64|2PZC5|0PJA10|0PJA2|HTV33|0PM92|0PCV1|601HT|0PAJ5|HTL2[23]|HTV3[12]|2PQ93|X2-HT|EXODUS 1|ISW13HT)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "2PZC5(?:[);/ ]|$)",
                "model": "U11"
            },
            {
                "regex": "XV6975(?:[);/ ]|$)",
                "model": "Imagio"
            },
            {
                "regex": "PG86100(?:[);/ ]|$)",
                "model": "Evo 3G"
            },
            {
                "regex": "PC36100(?:[);/ ]|$)",
                "model": "Evo 4G"
            },
            {
                "regex": "(?:HTV33|601HT)(?:[);/ ]|$)",
                "model": "U11"
            },
            {
                "regex": "(?:801e|802[wdt])",
                "model": "One"
            },
            {
                "regex": "PJ83100(?:[);/ ]|$)",
                "model": "One X"
            },
            {
                "regex": "One Mini 2(?:[);/ ]|$)",
                "model": "One Mini 2"
            },
            {
                "regex": "X2-HT(?:[);/ ]|$)",
                "model": "One X2"
            },
            {
                "regex": "ISW13HT(?:[);/ ]|$)",
                "model": "J"
            },
            {
                "regex": "HTL22(?:[);/ ]|$)",
                "model": "J One"
            },
            {
                "regex": "HTL23(?:[);/ ]|$)",
                "model": "J Butterfly"
            },
            {
                "regex": "(?:0PJA2|0PJA10)(?:[);/ ]|$)",
                "model": "One M9"
            },
            {
                "regex": "X525a(?:[);/ ]|$)",
                "model": "One X+"
            },
            {
                "regex": "2PQ93(?:[);/ ]|$)",
                "model": "One A9"
            },
            {
                "regex": "ADR6300",
                "model": "Droid Incredible"
            },
            {
                "regex": "ADR6400L",
                "model": "ThunderBolt"
            },
            {
                "regex": "ADR6410LRA",
                "model": "Droid Incredible 3"
            },
            {
                "regex": "SPV E600",
                "model": "Excalibur"
            },
            {
                "regex": "SPV E650",
                "model": "Vox"
            },
            {
                "regex": "2PYB2",
                "model": "Bolt"
            },
            {
                "regex": "2PS64",
                "model": "10"
            },
            {
                "regex": "0PM92(?:[);/ ]|$)",
                "model": "Desire 626S"
            },
            {
                "regex": "0PCV1(?:[);/ ]|$)",
                "model": "Desire 510"
            },
            {
                "regex": "608t(?:[);/ ]|$)",
                "model": "Desire 608t"
            },
            {
                "regex": "EXODUS 1(?:[);/ ]|$)",
                "model": "Exodus 1"
            },
            {
                "regex": "NexusHD2",
                "model": "HD2"
            },
            {
                "regex": "HTC[ _\\-]P715a",
                "device": "tablet",
                "model": "P715a"
            },
            {
                "regex": "HTC[ _\\-]Flyer Build",
                "device": "tablet",
                "model": "Flyer"
            },
            {
                "regex": "HTC[ _\\-]Flyer[ _\\-]([\\w]{1,5})",
                "device": "tablet",
                "model": "Flyer $1"
            },
            {
                "regex": "HTC[ _\\-]One[ _\\-]max(?:[);/ ]|$)",
                "device": "phablet",
                "model": "One max"
            },
            {
                "regex": "HTC[ _]([^/;]+) [0-9]+(?:\\.[0-9]+)+ Build",
                "model": "$1"
            },
            {
                "regex": "HTC[ _]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "HTC[ _]([a-z0-9]+[ _\\-]?(?:[a-z0-9_+\\-])*)",
                "model": "$1"
            },
            {
                "regex": "USCCHTC(\\d+)",
                "model": "$1"
            },
            {
                "regex": "Sprint (ATP.*) Build",
                "device": "tablet",
                "model": "$1 (Sprint)"
            },
            {
                "regex": "Sprint (APA.*) Build",
                "model": "$1 (Sprint)"
            },
            {
                "regex": "(?:HTC-)?HTC(?:[\\-/ ])?([a-z0-9\\-_]+)",
                "model": "$1"
            },
            {
                "regex": "HTC;(?: )?([a-z0-9 ]+)",
                "model": "$1"
            },
            {
                "regex": "(Desire|Sensation|Evo ?3D|IncredibleS|Wildfire|Butterfly)[ _]?([^;/)]+)(?: Build|\\))",
                "model": "$1 $2"
            },
            {
                "regex": "(Amaze[ _]4G|One ?[XELSV\\+]*) Build",
                "model": "$1"
            },
            {
                "regex": "(ADR[^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(ADR[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(One M8)",
                "model": "$1"
            },
            {
                "regex": "0PAJ5(?:[);/ ]|$)",
                "model": "One E8"
            },
            {
                "regex": "HTV32(?:[);/ ]|$)",
                "model": "10"
            },
            {
                "regex": "HTV31(?:[);/ ]|$)",
                "model": "J Butterfly"
            }
        ]
    },
    "Microsoft": {
        "regex": "KIN\\.(One|Two)|RM-(?:1010|1031|106[57]|107[23467]|1089|109[02]|1096|1099|1109|111[348]|1127|1141|115[24]|994)|Microsoft; Lumia|Lumia (?:1530|1320|950|850|650|640|550|535|435)|Corporation/Surface",
        "device": "smartphone",
        "models": [
            {
                "regex": "KIN\\.(One|Two)",
                "device": "feature phone",
                "model": "Kin $1"
            },
            {
                "regex": "RM-1099|Lumia 430",
                "model": "Lumia 430"
            },
            {
                "regex": "RM-1114|Lumia 435",
                "model": "Lumia 435"
            },
            {
                "regex": "RM-1031|Lumia 532",
                "model": "Lumia 532"
            },
            {
                "regex": "Lumia 535 Dual SIM",
                "model": "Lumia 535 Dual SIM"
            },
            {
                "regex": "RM-109[02]|RM-1089|Lumia 535",
                "model": "Lumia 535"
            },
            {
                "regex": "RM-1141|Lumia 540",
                "model": "Lumia 540"
            },
            {
                "regex": "RM-1127|Lumia 550",
                "model": "Lumia 550"
            },
            {
                "regex": "RM-1010",
                "model": "Lumia 638"
            },
            {
                "regex": "Lumia 640 XL LTE",
                "model": "Lumia 640 XL LTE",
                "device": "phablet"
            },
            {
                "regex": "RM-106[57]|RM-1096|Lumia 640 XL",
                "model": "Lumia 640 XL",
                "device": "phablet"
            },
            {
                "regex": "Lumia 640 LTE Dual SIM",
                "model": "Lumia 640 LTE Dual SIM"
            },
            {
                "regex": "Lumia 640 LTE",
                "model": "Lumia 640 LTE"
            },
            {
                "regex": "Lumia 640 Dual SIM",
                "model": "Lumia 640 Dual SIM"
            },
            {
                "regex": "RM-1109|RM-1113|RM-107[23467]|Lumia 640",
                "model": "Lumia 640"
            },
            {
                "regex": "RM-1154|Lumia 650",
                "model": "Lumia 650"
            },
            {
                "regex": "RM-1152",
                "model": "Lumia 650 SS"
            },
            {
                "regex": "Lumia 850",
                "model": "Lumia 850"
            },
            {
                "regex": "Lumia 950 XL Dual SIM",
                "model": "Lumia 950 XL Dual SIM",
                "device": "phablet"
            },
            {
                "regex": "Lumia 950 XL",
                "model": "Lumia 950 XL",
                "device": "phablet"
            },
            {
                "regex": "Lumia 950 Dual SIM",
                "model": "Lumia 950 Dual SIM"
            },
            {
                "regex": "Lumia 950|RM-1118",
                "model": "Lumia 950"
            },
            {
                "regex": "RM-994|Lumia 1320",
                "model": "Lumia 1320"
            },
            {
                "regex": "Lumia 1530",
                "model": "Lumia 1530"
            },
            {
                "regex": "Surface Book 3",
                "device": "desktop",
                "model": "Surface Book 3"
            },
            {
                "regex": "Surface Pro( [34])?",
                "device": "desktop",
                "model": "Surface Pro$1"
            },
            {
                "regex": "Microsoft; Lumia ([^;/)]+)(?:[;/)]|$)",
                "model": "Lumia $1"
            }
        ]
    },
    "Nokia": {
        "regex": "Nokia(?!Browser|Webview|; GT-I8750)|Lumia|Maemo RX|portalmmm/2\\.0 N7|portalmmm/2\\.0 NK|nok[0-9]+|Symbian.*\\s([a-z0-9]+)$|RX-51 N900|TA-[0-9]{4}|ARM; 909",
        "device": "smartphone",
        "models": [
            {
                "regex": "TA-10(07|23|29|35)",
                "model": "2"
            },
            {
                "regex": "TA-10(20|28|32|38)",
                "model": "3"
            },
            {
                "regex": "TA-10(24|27|44|53)",
                "model": "5"
            },
            {
                "regex": "TA-10(00|03|21|25|33|39|54)",
                "model": "6"
            },
            {
                "regex": "TA-1041",
                "model": "7"
            },
            {
                "regex": "TA-10(04|12|52)",
                "model": "8"
            },
            {
                "regex": "Nokia 8\\.1",
                "model": "8.1"
            },
            {
                "regex": "Nokia 8 Sirocco",
                "model": "8 Sirocco"
            },
            {
                "regex": "Nokia 7\\.1",
                "model": "7.1"
            },
            {
                "regex": "Nokia 7 plus",
                "model": "7 plus"
            },
            {
                "regex": "Nokia 6\\.1 Plus",
                "model": "6.1 Plus"
            },
            {
                "regex": "Nokia 6\\.1",
                "model": "6.1"
            },
            {
                "regex": "Nokia 5\\.1 Plus",
                "model": "5.1 Plus"
            },
            {
                "regex": "Nokia 5\\.1",
                "model": "5.1"
            },
            {
                "regex": "Nokia 3\\.1 Plus",
                "model": "3.1 Plus"
            },
            {
                "regex": "Nokia 3\\.1",
                "model": "3.1"
            },
            {
                "regex": "Nokia 2\\.1",
                "model": "2.1"
            },
            {
                "regex": "Nokia 1 Plus",
                "model": "1 Plus"
            },
            {
                "regex": "Nokia 1",
                "model": "1"
            },
            {
                "regex": "RX-51 N900",
                "model": "N900"
            },
            {
                "regex": "(?: )?(Nokia500|nokiaasha500(?:dualsim)?)(?: Build|[_);/])",
                "model": "Asha 500"
            },
            {
                "regex": "Nokia5130c(?:-2)?",
                "model": "5130 XpressMusic"
            },
            {
                "regex": "Nokia5230",
                "model": "Nuron"
            },
            {
                "regex": "Nokia5233",
                "model": "5233"
            },
            {
                "regex": "Nokia5800d-1",
                "model": "5800 XpressMusic"
            },
            {
                "regex": "Nokia6210Navigator",
                "model": "Navigator"
            },
            {
                "regex": "Nokia8800e?",
                "model": "Sapphire Arte"
            },
            {
                "regex": "NOKIA-RH-17",
                "model": "2280"
            },
            {
                "regex": "NOKIA-RH-27",
                "model": "6225"
            },
            {
                "regex": "NOKIA-RH-34",
                "model": "6585"
            },
            {
                "regex": "NOKIA-RH-48",
                "model": "3105"
            },
            {
                "regex": "NOKIA-RM-11",
                "model": "3205"
            },
            {
                "regex": "Nokia808 PureView",
                "model": "808 PureView"
            },
            {
                "regex": "Nokia ?([0-9]{4})c(?:-)?",
                "model": "$1 Classic"
            },
            {
                "regex": "Nokia ?([0-9]{4})s(?:-)?",
                "model": "$1 Slide"
            },
            {
                "regex": "Nokia ?([0-9]{4})",
                "model": "$1"
            },
            {
                "regex": "(?: )?Nokia([235][0-9]{2})(?: Build|[_);/])",
                "model": "Asha $1"
            },
            {
                "regex": "Nokia([CEX]-?[0-9]{1,2}i?)-[0-9]{1,2}u?(?: Build|[_);/])",
                "model": "$1"
            },
            {
                "regex": "Nokia;? 520T",
                "model": "Lumia 520T"
            },
            {
                "regex": "RM-91[45]",
                "model": "Lumia 520"
            },
            {
                "regex": "RM-997|Nokia 526",
                "model": "Lumia 526"
            },
            {
                "regex": "RM-846",
                "model": "Lumia 620"
            },
            {
                "regex": "RM-97[68]",
                "model": "Lumia 630"
            },
            {
                "regex": "RM-97[45]",
                "model": "Lumia 635"
            },
            {
                "regex": "RM-1027",
                "model": "Lumia 636"
            },
            {
                "regex": "NOKIA;? 710",
                "model": "Lumia 710"
            },
            {
                "regex": "Nokia;? 720T",
                "model": "Lumia 720T"
            },
            {
                "regex": "RM-885",
                "model": "Lumia 720"
            },
            {
                "regex": "Lumia 730",
                "model": "Lumia 730"
            },
            {
                "regex": "RM-103[89]",
                "model": "Lumia 735"
            },
            {
                "regex": "Nokia;? 800C",
                "model": "Lumia 800C"
            },
            {
                "regex": "Nokia;? 800",
                "model": "Lumia 800"
            },
            {
                "regex": "Nokia 820",
                "model": "Lumia 820"
            },
            {
                "regex": "RM-984",
                "model": "Lumia 830"
            },
            {
                "regex": "Nokia;? 900",
                "model": "Lumia 900"
            },
            {
                "regex": "(RM-82[12]|Nokia;? 920)(?: Build|[_);/])",
                "model": "Lumia 920"
            },
            {
                "regex": "(RM-89[23]|RM-910|Nokia;? 925)(?: Build|[a_);/])",
                "model": "Lumia 925"
            },
            {
                "regex": "Lumia 929",
                "model": "Lumia Icon"
            },
            {
                "regex": "RM-1045",
                "model": "Lumia 930"
            },
            {
                "regex": "(ARM; 909|NOKIA;? 909|NOKIA; id300)(?: Build|[_);/])",
                "model": "Lumia 1020"
            },
            {
                "regex": "NOKIA;? 1520\\.1",
                "model": "Lumia 1520.1"
            },
            {
                "regex": "Nokia ([A-Za-z0-9\\. ]+)(?: Build|\\))",
                "model": "$1"
            },
            {
                "regex": "Nokia(N[0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Nokia-([a-z0-9]+)",
                "model": "N$1"
            },
            {
                "regex": "NOKIA; (?!Qt;)([a-z0-9\\- ]+)",
                "model": "$1"
            },
            {
                "regex": "NOKIA[ _]?([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "NOKIA/([a-z0-9 ]+)",
                "model": "$1"
            },
            {
                "regex": "(Lumia [a-z0-9\\-]+ XL)",
                "device": "phablet",
                "model": "$1"
            },
            {
                "regex": "(Lumia [a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "Maemo RX-51 ([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Maemo RX-34",
                "model": "N800"
            },
            {
                "regex": "NokiaInternal|Nokia-WAP-Toolkit|Nokia-MIT-Browser|Nokia Mobile|Nokia Browser|Nokia/Series",
                "model": ""
            },
            {
                "regex": "portalmmm/2\\.0 (N7[37]|NK[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "nok([0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Symbian.*\\s([a-z0-9]+)$",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "CnM": {
        "regex": "CnM",
        "device": "tablet",
        "models": [
            {
                "regex": "CnM[ \\-](?:Touchpad|TP)[ \\-]([0-9\\.]+)",
                "model": "Touchpad $1"
            }
        ]
    },
    "RIM": {
        "regex": "BB10;|BlackBerry|rim[0-9]+|PlayBook|STV100-[1234]|STH100-[12]|BBA100-[12]|BBB100-[1234567]|BBD100-[126]|BB[EF]100-[123456789]|BB[CGH]100-1",
        "device": "smartphone",
        "models": [
            {
                "regex": "BBA100-[12]",
                "model": "BlackBerry DTEK60"
            },
            {
                "regex": "BBB100-[1234567]",
                "model": "KEYone"
            },
            {
                "regex": "BBC100-1",
                "model": "Aurora"
            },
            {
                "regex": "BBD100-[126]",
                "model": "Motion"
            },
            {
                "regex": "BBE100-[123456789]",
                "model": "KEY2 LE"
            },
            {
                "regex": "BBF100-[1234567]",
                "model": "KEY2"
            },
            {
                "regex": "BBF100-8",
                "model": "KEY2 Silver"
            },
            {
                "regex": "BBF100-9",
                "model": "KEY2 Black"
            },
            {
                "regex": "BBG100-1",
                "model": "Evolve"
            },
            {
                "regex": "BBH100-1",
                "model": "Evolve X"
            },
            {
                "regex": "STV100-[1234]",
                "model": "BlackBerry Priv"
            },
            {
                "regex": "STH100-[12]",
                "model": "BlackBerry DTEK50"
            },
            {
                "regex": "BB10; ([a-z0-9\\- ]+)\\)",
                "model": "BlackBerry $1"
            },
            {
                "regex": "PlayBook.+RIM Tablet OS",
                "model": "BlackBerry Playbook",
                "device": "tablet"
            },
            {
                "regex": "BlackBerry(?: )?([a-z0-9]+)",
                "model": "BlackBerry $1"
            },
            {
                "regex": "rim([0-9]+)",
                "model": "BlackBerry $1"
            },
            {
                "regex": "9000",
                "model": "Bold 9000"
            },
            {
                "regex": "9300",
                "model": "Curve 3G 9300"
            },
            {
                "regex": "(8520|8530|9220|9320|9360)",
                "model": "Curve $1"
            },
            {
                "regex": "9630",
                "model": "Tour 9630"
            },
            {
                "regex": "9720",
                "model": "9720"
            },
            {
                "regex": "(9800|9860)",
                "model": "Torch $1"
            },
            {
                "regex": "BlackBerry",
                "model": "BlackBerry"
            }
        ]
    },
    "CHIA": {
        "regex": "(SVEGLIO[ _][QH]1|TREO_TAB8G|GTA7WF)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SVEGLIO[ _]([QH]1)",
                "model": "Sveglio $1"
            },
            {
                "regex": "TREO_TAB8G",
                "device": "tablet",
                "model": "TREO TAB8G"
            },
            {
                "regex": "GTA7WF",
                "device": "tablet",
                "model": "GTA7WF"
            }
        ]
    },
    "Palm": {
        "regex": "(?:Pre|Pixi)/(\\d+)\\.(\\d+)|Palm|Treo|Xiino",
        "device": "smartphone",
        "models": [
            {
                "regex": "((?:Pre|Pixi))/(\\d+\\.\\d+)",
                "model": "$1 $2"
            },
            {
                "regex": "Palm(?:[ \\-])?((?!OS|Source|scape)[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Treo([a-z0-9]+)",
                "model": "Treo $1"
            },
            {
                "regex": "Tungsten",
                "model": "Tungsten"
            },
            {
                "regex": "Xiino|Palmscape",
                "model": ""
            }
        ]
    },
    "HP": {
        "regex": "Hewlett-Packard|HP/HP|HP EliteBook 820|TouchPad/\\d+\\.\\d+|hp-tablet|HP ?iPAQ|webOS.*P160U|HP (?:Pro )?Slate|HP [78]|HP 10 Plus|Compaq [7|8]|HP; [^;/)]+",
        "device": "smartphone",
        "models": [
            {
                "regex": "HP Slate 6 Voice Tab",
                "model": "Slate 6 VoiceTab",
                "device": "phablet"
            },
            {
                "regex": "HP 10 Plus",
                "model": "10 Plus",
                "device": "tablet"
            },
            {
                "regex": "HP ([78][^)/;]*)(?: Build|\\))",
                "model": "Slate $1",
                "device": "tablet"
            },
            {
                "regex": "Compaq ([78][^/;]*) Build",
                "model": "Compaq $1",
                "device": "tablet"
            },
            {
                "regex": "HP Pro Slate 8",
                "model": "Pro Slate 8",
                "device": "tablet"
            },
            {
                "regex": "HP Slate ?(.+) Build",
                "model": "Slate $1",
                "device": "tablet"
            },
            {
                "regex": "HP Slate ?([0-9]+)",
                "model": "Slate $1",
                "device": "tablet"
            },
            {
                "regex": "TouchPad/(\\d+\\.\\d+)|hp-tablet",
                "model": "TouchPad",
                "device": "tablet"
            },
            {
                "regex": "HP; ([^;/)]+)",
                "model": "$1"
            },
            {
                "regex": "HP ?iPAQ ?([a-z0-9]+)",
                "model": "iPAQ $1"
            },
            {
                "regex": "webOS.*(P160U)",
                "model": "Veer"
            },
            {
                "regex": "HP ProBook (6560b)",
                "device": "desktop",
                "model": "ProBook $1"
            },
            {
                "regex": "HP EliteBook 820 G2",
                "device": "desktop",
                "model": "EliteBook 820 G2"
            },
            {
                "regex": "Z240 Tower Workstation",
                "device": "desktop",
                "model": "Z240 Tower Workstation"
            }
        ]
    },
    "TiPhone": {
        "regex": "TiPhone ?([a-z0-9]+)",
        "device": "smartphone",
        "model": "$1"
    },
    "Apple": {
        "regex": "(?:iTunes-)?Apple[ _]?TV|Apple/|(?:Apple-|iTunes-)?(?<!like )(?:iPad|iPhone)|iPh[0-9],[0-9]|CFNetwork|HomePod|Watch ?OS|Watch1,[12]|MDCR_Mac|ICRU_iP(?:ad|hone)",
        "models": [
            {
                "regex": "HomePod",
                "device": "smart speaker",
                "model": "HomePod"
            },
            {
                "regex": "Watch1,1",
                "device": "wearable",
                "model": "Watch 38mm"
            },
            {
                "regex": "Watch1,2",
                "device": "wearable",
                "model": "Watch 42mm"
            },
            {
                "regex": "Watch2,6",
                "device": "wearable",
                "model": "Watch Series 1 38mm"
            },
            {
                "regex": "Watch2,7",
                "device": "wearable",
                "model": "Watch Series 1 42mm"
            },
            {
                "regex": "Watch2,3",
                "device": "wearable",
                "model": "Watch Series 2 38mm"
            },
            {
                "regex": "Watch2,4",
                "device": "wearable",
                "model": "Watch Series 2 42mm"
            },
            {
                "regex": "Watch3,[13]",
                "device": "wearable",
                "model": "Watch Series 3 38mm"
            },
            {
                "regex": "Watch3,[24]",
                "device": "wearable",
                "model": "Watch Series 3 42mm"
            },
            {
                "regex": "Watch5,(?:9|11)",
                "device": "wearable",
                "model": "Watch SE 40mm"
            },
            {
                "regex": "Watch5,1[02]",
                "device": "wearable",
                "model": "Watch SE 44mm"
            },
            {
                "regex": "Watch([456]),[13]",
                "device": "wearable",
                "model": "Watch Series $1 40mm"
            },
            {
                "regex": "Watch([456]),[24]",
                "device": "wearable",
                "model": "Watch Series $1 44mm"
            },
            {
                "regex": "(?:.+_)?MacBook7(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 13\" (2010)"
            },
            {
                "regex": "(?:.+_)?MacPro5(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Pro (2010-2012)"
            },
            {
                "regex": "(?:.+_)?iMac12(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac 21.5\" (2011)"
            },
            {
                "regex": "(?:.+_)?iMac17(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac 27\" (2015)"
            },
            {
                "regex": "(?:.+_)?iMac19(?:%2C|,)2",
                "device": "desktop",
                "model": "iMac 21.5\" (2019)"
            },
            {
                "regex": "(?:.+_)?iMac19(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac 27\" (2019)"
            },
            {
                "regex": "(?:.+_)?iMac20(?:%2C|,)[12]",
                "device": "desktop",
                "model": "iMac 27\" (2020)"
            },
            {
                "regex": "(?:.+_)?iMac14(?:%2C|,)2",
                "device": "desktop",
                "model": "iMac 27\" (2013)"
            },
            {
                "regex": "(?:.+_)?iMac14(?:%2C|,)4",
                "device": "desktop",
                "model": "iMac 21.5\" (2014)"
            },
            {
                "regex": "(?:.+_)?iMac14(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac 21.5\" (2013)"
            },
            {
                "regex": "(?:.+_)?MacBook6(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 13\" (2009)"
            },
            {
                "regex": "(?:.+_)?MacBook8(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 12\" (2015)"
            },
            {
                "regex": "(?:.+_)?MacBook9(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 12\" (2016)"
            },
            {
                "regex": "(?:.+_)?iMac10(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac (2009)"
            },
            {
                "regex": "(?:.+_)?MacBookAir2(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air (2009)"
            },
            {
                "regex": "(?:.+_)?MacBookAir3(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 11\" (2010)"
            },
            {
                "regex": "(?:.+_)?MacBookAir3(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2010)"
            },
            {
                "regex": "(?:.+_)?MacBookAir4(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 11\" (2011)"
            },
            {
                "regex": "(?:.+_)?MacBookAir4(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2011)"
            },
            {
                "regex": "(?:.+_)?MacBookAir5(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 11\" (2012)"
            },
            {
                "regex": "(?:.+_)?MacBookAir5(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2012)"
            },
            {
                "regex": "(?:.+_)?MacBookAir6(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 11\" (2013-2014)"
            },
            {
                "regex": "(?:.+_)?MacBookAir6(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2013-2014)"
            },
            {
                "regex": "(?:.+_)?MacBookAir7(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 11\" (2015)"
            },
            {
                "regex": "(?:.+_)?MacBookAir7(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2015-2017)"
            },
            {
                "regex": "(?:.+_)?MacBookAir8(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 13\" (2018)"
            },
            {
                "regex": "(?:.+_)?MacBookAir8(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2019)"
            },
            {
                "regex": "(?:.+_)?MacBookAir9(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 13\" (2020)"
            },
            {
                "regex": "(?:.+_)?MacBookAir10(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 13\" (2020)"
            },
            {
                "regex": "(?:.+_)?MacBookPro1(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2006)"
            },
            {
                "regex": "(?:.+_)?MacBookPro1(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 17\" (2006)"
            },
            {
                "regex": "(?:.+_)?MacBookPro2(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 17\" (2007)"
            },
            {
                "regex": "(?:.+_)?MacBookPro2(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2007)"
            },
            {
                "regex": "(?:.+_)?MacBookPro[34](?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro (2008)"
            },
            {
                "regex": "(?:.+_)?MacBookPro5(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2008)"
            },
            {
                "regex": "(?:.+_)?MacBookPro5(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 17\" (2009)"
            },
            {
                "regex": "(?:.+_)?MacBookPro5(?:%2C|,)[34]",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2009)"
            },
            {
                "regex": "(?:.+_)?MacBookPro5(?:%2C|,)5",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2009)"
            },
            {
                "regex": "(?:.+_)?MacBookPro6(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 17\" (2010)"
            },
            {
                "regex": "(?:.+_)?MacBookPro6(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2010)"
            },
            {
                "regex": "(?:.+_)?MacBookPro7(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2010)"
            },
            {
                "regex": "(?:.+_)?MacBookPro8(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2011)"
            },
            {
                "regex": "(?:.+_)?MacBookPro8(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2011)"
            },
            {
                "regex": "(?:.+_)?MacBookPro8(?:%2C|,)3",
                "device": "desktop",
                "model": "MacBook Pro 17\" (2011)"
            },
            {
                "regex": "(?:.+_)?MacBookPro9(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2012)"
            },
            {
                "regex": "(?:.+_)?MacBookPro9(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2012)"
            },
            {
                "regex": "(?:.+_)?MacBookPro10(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2012-2013)"
            },
            {
                "regex": "(?:.+_)?MacBookPro10(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2012-2013)"
            },
            {
                "regex": "(?:.+_)?MacBookPro11(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2013-2014)"
            },
            {
                "regex": "(?:.+_)?MacBookPro11(?:%2C|,)[23]",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2013-2014)"
            },
            {
                "regex": "(?:.+_)?MacBookPro11(?:%2C|,)[45]",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2015)"
            },
            {
                "regex": "(?:.+_)?MacBookPro12(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2015)"
            },
            {
                "regex": "(?:.+_)?MacBookPro13(?:%2C|,)[12]",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2016)"
            },
            {
                "regex": "(?:.+_)?MacBookPro13(?:%2C|,)3",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2016)"
            },
            {
                "regex": "(?:.+_)?MacBookPro14(?:%2C|,)[12]",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2017)"
            },
            {
                "regex": "(?:.+_)?MacBookPro14(?:%2C|,)3",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2017)"
            },
            {
                "regex": "(?:.+_)?MacBookPro15(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2018-2019)"
            },
            {
                "regex": "(?:.+_)?MacBookPro15(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2018-2019)"
            },
            {
                "regex": "(?:.+_)?MacBookPro15(?:%2C|,)3",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2019)"
            },
            {
                "regex": "(?:.+_)?MacBookPro15(?:%2C|,)4",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2019)"
            },
            {
                "regex": "(?:.+_)?MacBookPro16(?:%2C|,)[14]",
                "device": "desktop",
                "model": "MacBook Pro 16\" (2019)"
            },
            {
                "regex": "(?:.+_)?MacBookPro16(?:%2C|,)[23]",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2020)"
            },
            {
                "regex": "(?:.+_)?MacBookPro17(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2020)"
            },
            {
                "regex": "(?:.+_)?Macmini8(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini (2018)"
            },
            {
                "regex": "(?:.+_)?Macmini9(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini (2020)"
            },
            {
                "regex": "(?:.+_)?Macmini7(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini (2014)"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?1[C,_]1",
                "model": "iPhone",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?1[C,_]2",
                "model": "iPhone 3G",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?2[C,_]1| 3GS\\)$",
                "model": "iPhone 3GS",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?3[C,_][123]",
                "model": "iPhone 4",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?4[C,_]1|1C2%254enohPi| 4S\\)$",
                "model": "iPhone 4S",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?5[C,_][12]| 5\\)$",
                "model": "iPhone 5",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?5[C,_][34]",
                "model": "iPhone 5C",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?6[C,_][12]| 5S\\)$",
                "model": "iPhone 5S",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?7[C,_]1|1C2%257enohPi| 6PLUS\\)$",
                "model": "iPhone 6 Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?7[C,_]2| 6\\)$",
                "model": "iPhone 6",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?8[C,_]2| 6SPLUS\\)$",
                "model": "iPhone 6s Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?8[C,_]1|iPhone 6s| 6S\\)$",
                "model": "iPhone 6s",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?8[C,_]4| SE\\)$",
                "model": "iPhone SE",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?9[C,_][13]| 7\\)$",
                "model": "iPhone 7",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?9[C,_][24]| 7PLUS\\)$",
                "model": "iPhone 7 Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?10[C,_][14]| 8\\)$",
                "model": "iPhone 8",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?10[C,_][25]| 8PLUS\\)$",
                "model": "iPhone 8 Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?10[C,_][36]|iPhone X| X\\)$",
                "model": "iPhone X",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?11[C,_][2]| XS\\)$",
                "model": "iPhone XS",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?11[C,_][46]| XSMAX\\)$",
                "model": "iPhone XS Max",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?11[C,_][8]| XR\\)$",
                "model": "iPhone XR",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?12[C,_][1]| 11\\)$",
                "model": "iPhone 11",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?12[C,_][3]| 11PRO\\)$",
                "model": "iPhone 11 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?12[C,_][5]| 11PROMAX\\)$",
                "model": "iPhone 11 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?12[C,_][8]",
                "model": "iPhone SE (2020)",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?13[C,_][1]",
                "model": "iPhone 12 Mini",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?13[C,_][2]",
                "model": "iPhone 12",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?13[C,_][3]",
                "model": "iPhone 12 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPh(?:one)?13[C,_][4]",
                "model": "iPhone 12 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad1[C,_]1",
                "model": "iPad",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad2[C,_][1234]",
                "model": "iPad 2",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad2[C,_][567]",
                "model": "iPad Mini",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad3[C,_][123]",
                "model": "iPad 3",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad3[C,_][456]",
                "model": "iPad 4",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad4[C,_][123]",
                "model": "iPad Air",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad4[C,_][456]",
                "model": "iPad Mini 2",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad4[C,_][789]",
                "model": "iPad Mini 3",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad5[C,_][12]",
                "model": "iPad Mini 4",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad5[C,_][34]",
                "model": "iPad Air 2",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad6[C,_][34]",
                "model": "iPad Pro 9.7",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad6[C,_][78]",
                "model": "iPad Pro 12.9",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad6[C,_](?:11|12)",
                "model": "iPad 5 9.7",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad7[C,_][12]",
                "model": "iPad Pro 2 12.9",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad7[C,_][34]",
                "model": "iPad Pro 10.5",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad7[C,_][56]",
                "model": "iPad 6 9.7",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad7[C,_](?:11|12)",
                "model": "iPad 7 10.2",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad8[C,_](?:9|10)",
                "model": "iPad Pro 2 11\"",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad8[C,_]1[12]",
                "model": "iPad Pro 4 12.9\"",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad8[C,_][1-4]",
                "model": "iPad Pro 3 11.0",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad8[C,_][5-8]",
                "model": "iPad Pro 3 12.9",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad11[C,_][12]",
                "model": "iPad Mini 5",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad11[C,_][34]",
                "model": "iPad Air 3",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad11[C,_][67]",
                "model": "iPad 8 10.2\"",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad13[C,_][12]",
                "model": "iPad Air 4",
                "device": "tablet"
            },
            {
                "regex": "Apple-?TV2[C,_]1",
                "model": "Apple TV 2",
                "device": "tv"
            },
            {
                "regex": "Apple-?TV3[C,_][12]",
                "model": "Apple TV 3",
                "device": "tv"
            },
            {
                "regex": "Apple-?TV5[C,_]3",
                "model": "Apple TV 4",
                "device": "tv"
            },
            {
                "regex": "Apple-?TV6[C,_]2",
                "model": "Apple TV 4K",
                "device": "tv"
            },
            {
                "regex": "(?:iTunes-)?Apple[ _]?TV",
                "model": "Apple TV",
                "device": "tv"
            },
            {
                "regex": "HomePod",
                "model": "HomePod",
                "device": "smart speaker"
            },
            {
                "regex": "iTunes-iPad/[0-9]+(?:\\.[0-9]+)* \\(([^;]+);",
                "model": "iPad $1",
                "device": "tablet"
            },
            {
                "regex": "(?:Apple-|.+_)?iPad",
                "model": "iPad",
                "device": "tablet"
            },
            {
                "regex": "iTunes-iPhone/[0-9]+(?:\\.[0-9]+)* \\(([^;]+);",
                "model": "iPhone $1",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-)?iPhone ?(3GS?|4S?|5[CS]?|6(:? Plus)?)?",
                "model": "iPhone $1",
                "device": "smartphone"
            }
        ]
    },
    "MicroMax": {
        "regex": "(?:MicroMax[ \\-\\_]?[a-z0-9]+|Q327)|4560MMX|P70221|(?:YU(?:5040|5530)|AQ5001(?: Canvas Power)?|N8216|N8301)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AQ5001 Canvas Power",
                "model": "Canvas Power"
            },
            {
                "regex": "AQ5001",
                "model": "Canvas Juice 2"
            },
            {
                "regex": "4560MMX(?:[);/ ]|$)",
                "model": "4560MMX"
            },
            {
                "regex": "E481",
                "model": "Canvas 5"
            },
            {
                "regex": "P70221(?:[);/ ]|$)",
                "model": "Canvas Tab",
                "device": "tablet"
            },
            {
                "regex": "Q327",
                "model": "Bolt"
            },
            {
                "regex": "Q417",
                "model": "Canvas Mega"
            },
            {
                "regex": "Q402\\+",
                "model": "Bolt Pace"
            },
            {
                "regex": "YU5040(?:[);/ ]|$)",
                "model": "YU Yureka YU5040"
            },
            {
                "regex": "YU5530(?:[);/ ]|$)",
                "model": "YU Yureka S YU5530"
            },
            {
                "regex": "Q424",
                "model": "Bolt Selfie"
            },
            {
                "regex": "Q426",
                "model": "Canvas Mega 2"
            },
            {
                "regex": "N8216",
                "model": "Infinity N11"
            },
            {
                "regex": "N8301",
                "model": "Infinity N12"
            },
            {
                "regex": "MicroMax(?:[ \\-\\_])?(X291|X246|X252|X458|X312)",
                "model": "$1",
                "device": "feature phone"
            },
            {
                "regex": "MicroMax(?:[ \\-\\_])?(P[a-z0-9]+)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "MicroMax(?:[ \\-\\_])?([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "3Q": {
        "regex": "AC0731B|AC1024C|AC7803C|BC9710AM|EL72B|LC0720C|LC0723B|LC0725B|LC0804B|LC0808B|LC0809B|LC0810C|LC0816C|LC0901D|LC1016C|MT0724B|MT0729[BD]|MT0811B|OC1020A|RC0709B|RC0710B|RC0718C|RC0719H|RC0721B|RC0722C|RC0726B|RC0734H|RC0743H|RC0817C|RC1018C|RC1019G|RC1025F|RC1301C|RC780[24]F|RC9711B|RC9712C|RC9716B|RC9717B|RC9724C|RC9726C|RC9727F|RC9730C|RC9731C|TS0807B|TS1013B|VM0711A|VM1017A|RC0813C|QS9719D|QS9718C|QS9715F|QS1023H|QS0815C|QS0730C|QS0728C|QS0717D|QS0716D|QS0715C|MT7801C|TS9708B|AC0732C|MT0739D|MT0812E|(?:3Q_)?ER71B",
        "device": "tablet",
        "models": [
            {
                "regex": "MT0724B|LC0901D|LC0816C|LC0810C|LC0809B|LC0808B|LC0804B|LC0725B|LC0723B",
                "model": "Qoo! P-Pad"
            },
            {
                "regex": "VM1017A|TS1013B|TS0807B|RC9731C|RC9730C|RC9727F|RC9726C|RC9724C|RC9717B|RC9716B|RC9712C|RC9711B|RC1301C|RC1025F|RC1019G|RC1018C|RC0817C|RC0813C|RC0743H|RC0734H|RC0726B|RC0722C|RC0721B|RC0719H|RC0718C|RC0710B|RC0709B|QS9715F|QS1023H|QS0815C|QS0730C|QS0728C|QS0717D|QS0716D|QS0715C|MT0811B|MT0739D|MT0729[BD]|LC1016C|LC0720C|BC9710AM|AC1024C|AC0731B",
                "model": "Qoo! Q-Pad"
            },
            {
                "regex": "MT7801C|QS9718C|QS9719D|VM0711A|OC1020A",
                "model": "Qoo! Surf"
            },
            {
                "regex": "TS9708B",
                "model": "Surf TS1009B"
            },
            {
                "regex": "AC7803C|AC0732C",
                "model": "Qoo! Lite"
            },
            {
                "regex": "MT0812E|RC7802F",
                "model": "Qoo! Meta"
            },
            {
                "regex": "EL72B|(?:3Q_)?ER71B",
                "model": "Qoo! Q-Book"
            },
            {
                "regex": "(RC7804F)",
                "model": "Qoo! Glaze"
            }
        ]
    },
    "4Good": {
        "regex": "4Good[ _]|S450m [43]G|S555m 4G|S501m 3G|T700i_3G|People (?:G503|G410|GT300)|Light (?:A103|B100)",
        "device": "smartphone",
        "models": [
            {
                "regex": "T700i_3G",
                "model": "T700i 3G",
                "device": "tablet"
            },
            {
                "regex": "People GT300",
                "model": "People GT300",
                "device": "tablet"
            },
            {
                "regex": "S555m[_ ]4G",
                "model": "People"
            },
            {
                "regex": "(S(?:450m|501m)[_ ][43]G|Light (?:A103|B100)|People (?:G503|G410))",
                "model": "$1"
            },
            {
                "regex": "4Good[ _]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "4Good[ _]([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Acteck": {
        "regex": "BLECK",
        "device": "tablet",
        "model": "Bleck"
    },
    "Alba": {
        "regex": "Alba ?(?:57|4|10 TABLET|(?:7|10)(?:Nou|Pie))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Alba 57",
                "model": "5.7"
            },
            {
                "regex": "Alba (4)",
                "model": "$1"
            },
            {
                "regex": "10 TABLET",
                "device": "tablet",
                "model": "10 Tablet"
            },
            {
                "regex": "Alba((?:7|10)(?:Nou|Pie))",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "AllCall": {
        "regex": "AllCall_|Heat[34]|Rio_X(?:[);/ ]|$)|Hot ?[125][^;/]+ Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "AllCall_(Alpha|Atom|Bro|Madrid)",
                "model": "$1"
            },
            {
                "regex": "AllCall_S1_X",
                "model": "S1 X"
            },
            {
                "regex": "AllCall_S1",
                "model": "S1"
            },
            {
                "regex": "AllCall_RIO_S",
                "model": "Rio S"
            },
            {
                "regex": "AllCall_RIO_PRO",
                "model": "Rio Pro"
            },
            {
                "regex": "AllCall_RIO",
                "model": "Rio"
            },
            {
                "regex": "Heat([34])",
                "model": "Heat $1"
            },
            {
                "regex": "Rio_X(?:[);/ ]|$)",
                "model": "Rio X"
            },
            {
                "regex": "Hot ?([125][^;/]+) Build",
                "model": "Hot $1"
            }
        ]
    },
    "Bravis": {
        "regex": "Bravis[ _]|A501 Bright|A552 JOY Max|A504 Trace|A505 JOY Plus|A503 Joy|NB(?:106M|10[1-8]|751|7[145]|8[57]1|76)|NP101|NB961|NP 104 3G|B501|N1-570 Space|Atlas A551|A512 Harmony Pro|A510_Jeans_4G|A509_Jeans|N1_550_Cruiser",
        "device": "smartphone",
        "models": [
            {
                "regex": "A501 BRIGHT",
                "model": "A501 Bright"
            },
            {
                "regex": "Bravis[_ ]X500",
                "model": "Trace Pro"
            },
            {
                "regex": "Bravis[_ ]A506",
                "model": "Crystal"
            },
            {
                "regex": "Bravis[_ ]A553",
                "model": "Discovery"
            },
            {
                "regex": "BRAVIS[ _]TAU",
                "model": "Tau"
            },
            {
                "regex": "BRAVIS[ _]DELTA",
                "model": "Delta"
            },
            {
                "regex": "BRAVIS[ _]TREND",
                "model": "Trend"
            },
            {
                "regex": "B501",
                "model": "Easy"
            },
            {
                "regex": "N1-570",
                "model": "Space"
            },
            {
                "regex": "BRAVIS[ ]A554",
                "model": "A554 Grand"
            },
            {
                "regex": "BRAVIS[ ]S500",
                "model": "S500 Diamond"
            },
            {
                "regex": "A505 JOY Plus",
                "model": "A505 Joy Plus"
            },
            {
                "regex": "A552 JOY Max",
                "model": "A552 Joy Max"
            },
            {
                "regex": "Atlas A551",
                "model": "A551 Atlas"
            },
            {
                "regex": "A503 Joy",
                "model": "A503 Joy"
            },
            {
                "regex": "A504 Trace",
                "model": "A504 Trace"
            },
            {
                "regex": "A512 Harmony Pro",
                "model": "A512 Harmony Pro"
            },
            {
                "regex": "A510_Jeans_4G",
                "model": "A510 Jeans 4G"
            },
            {
                "regex": "A509_Jeans",
                "model": "A509 Jeans"
            },
            {
                "regex": "BRAVIS NEO",
                "model": "A401 Neo"
            },
            {
                "regex": "N1_550_Cruiser",
                "model": "N1-550 Cruiser"
            },
            {
                "regex": "BRAVIS OMEGA",
                "model": "Omega"
            },
            {
                "regex": "BRAVIS BIZ",
                "model": "Biz"
            },
            {
                "regex": "BRAVIS POWER",
                "model": "Power"
            },
            {
                "regex": "BRAVIS[ _]SPARK",
                "model": "Spark"
            },
            {
                "regex": "BRAVIS[ _]SLIM[ _]3G",
                "model": "Slim 3G",
                "device": "tablet"
            },
            {
                "regex": "NP 104 3G",
                "model": "NP104 3G",
                "device": "tablet"
            },
            {
                "regex": "BRAVIS NP 103",
                "model": "NP103",
                "device": "tablet"
            },
            {
                "regex": "BRAVIS NP 844",
                "model": "NP844",
                "device": "tablet"
            },
            {
                "regex": "Bravis[_ ]([^;\\)]+) Build",
                "model": "$1"
            },
            {
                "regex": "(NB(?:106M|10[1-8]|751|7[145]|8[57]1|76)|NP101|NB961)",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "Acer": {
        "regex": "acer|(?<!Satellite |ZTE BLADE |ImSmart |ERGO |X-Style Tab )a(?:101|110|2[10]0|211|50[10]|51[10]|70[10])(?:[);/ ]|$)|Android.*V3[67]0(?:[);/ ]|$)|Android.*Z1[23456]0 Build|Android.*Z5\\d{2} Build|Android.*T0[234678] Build|Android.*S55(?:[);/ ]|$)|(?:A1-(713(HD)?|7[23]4|830|841|840FHD|81[01])|A3-A[1234][01]|B1-(7[1235-8][01](HD)?|7[23]3|7A0|8[1235]0|A71|860A)|TPA60W|B3-(A[125]0|A3[02]|A40FHD)|E39)(?:[);/ ]|$)|S5[12]0 Build|(DA[0-9]+HQ?L|Aspire (?:V5-121|XC-704G|V5-573G)|Chromebook 14 \\(CB3-431\\)|Predator G9-793|GT-810|B1-870|B3-A4[02]|B3-A50FHD)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DA220HQL(?:[);/ ]|$)",
                "model": "DA220HQL",
                "device": "smart display"
            },
            {
                "regex": "DA241HL(?:[);/ ]|$)",
                "model": "DA241HL",
                "device": "smart display"
            },
            {
                "regex": "(DA[0-9]+HQ?L)(?:[);/ ]|$)",
                "model": "$1",
                "device": "smart display"
            },
            {
                "regex": "A1-81[01]",
                "model": "Iconia A",
                "device": "tablet"
            },
            {
                "regex": "TPA60W",
                "model": "TPA60W",
                "device": "tablet"
            },
            {
                "regex": "A1-84(1|0FHD)",
                "model": "Iconia Tab 8",
                "device": "tablet"
            },
            {
                "regex": "A1-713(HD)?",
                "model": "Iconia Tab 7",
                "device": "tablet"
            },
            {
                "regex": "A1-830",
                "model": "Iconia A1",
                "device": "tablet"
            },
            {
                "regex": "A1-7[23]4",
                "model": "Iconia Talk S",
                "device": "tablet"
            },
            {
                "regex": "A3-A[12][01]",
                "model": "Iconia A3",
                "device": "tablet"
            },
            {
                "regex": "A3-A[34]0",
                "model": "Iconia Tab 10",
                "device": "tablet"
            },
            {
                "regex": "B1-7(?:[5678]0|30HD|A0)",
                "model": "Iconia One 7",
                "device": "tablet"
            },
            {
                "regex": "B1-7[123][01]|B1-A71",
                "model": "Iconia B1",
                "device": "tablet"
            },
            {
                "regex": "B1-7[23]3",
                "model": "Iconia Talk 7",
                "device": "tablet"
            },
            {
                "regex": "B1-8[123567]0",
                "model": "Iconia One 8",
                "device": "tablet"
            },
            {
                "regex": "B3-A([125]0|3[02]|[45]0FHD|4[02])",
                "model": "Iconia One 10",
                "device": "tablet"
            },
            {
                "regex": "A101",
                "model": "Vangogh",
                "device": "tablet"
            },
            {
                "regex": "A200",
                "model": "Picasso E",
                "device": "tablet"
            },
            {
                "regex": "A50[01]",
                "model": "Picasso",
                "device": "tablet"
            },
            {
                "regex": "Acer One 7",
                "model": "One 7",
                "device": "tablet"
            },
            {
                "regex": "GT-810",
                "model": "Predator 8",
                "device": "tablet"
            },
            {
                "regex": "E39(?:[);/ ]|$)",
                "model": "Liquid E700"
            },
            {
                "regex": "E310(?:[);/ ]|$)",
                "model": "Liquid Mini"
            },
            {
                "regex": "E320(?:-orange)?(?:[);/ ]|$)",
                "model": "Liquid Express"
            },
            {
                "regex": "E310(?:[);/ ]|$)",
                "model": "beTouch E210"
            },
            {
                "regex": "Android.*V360(?:[);/ ]|$)",
                "model": "Liquid E1 Duo"
            },
            {
                "regex": "Android.*V370(?:[);/ ]|$)",
                "model": "Liquid E2 Duo"
            },
            {
                "regex": "S510(?:[);/ ]|$)",
                "model": "Liquid S1"
            },
            {
                "regex": "S520(?:[);/ ]|$)",
                "model": "Liquid S2"
            },
            {
                "regex": "(?:Acer_)?P400(?:[);/ ]|$)",
                "model": "neoTouch P400"
            },
            {
                "regex": "(?:Acer_)?P300(?:[);/ ]|$)",
                "model": "neoTouch P300"
            },
            {
                "regex": "(?:Acer_)?S200(?:[);/ ]|$)",
                "model": "neoTouch S200"
            },
            {
                "regex": "(?:Acer_)?E100(?:[);/ ]|$)",
                "model": "beTouch E100"
            },
            {
                "regex": "Android.*Z1([234])0(?:[);/ ]|$)",
                "model": "Liquid Z$1"
            },
            {
                "regex": "Android.*Z110(?:[);/ ]|$)",
                "model": "Liquid Z110"
            },
            {
                "regex": "Android.*Z150(?:[);/ ]|$)",
                "model": "Liquid Z5 Duo"
            },
            {
                "regex": "Android.*Z160(?:[);/ ]|$)",
                "model": "Liquid Z4 Duo"
            },
            {
                "regex": "Android.*Z(5\\d{2})(?:[);/ ]|$)",
                "model": "Liquid Z$1"
            },
            {
                "regex": "Android.*S57(?:[);/ ]|$)",
                "model": "Liquid Jade Z"
            },
            {
                "regex": "Android.*T02(?:[);/ ]|$)",
                "model": "Liquid Z530"
            },
            {
                "regex": "Android.*T03(?:[);/ ]|$)",
                "model": "Liquid Z630"
            },
            {
                "regex": "Android.*T04(?:[);/ ]|$)",
                "model": "Liquid Z630S"
            },
            {
                "regex": "Android.*T06(?:[);/ ]|$)",
                "model": "Liquid Zest"
            },
            {
                "regex": "Android.*T07(?:[);/ ]|$)",
                "model": "Liquid Zest 4G"
            },
            {
                "regex": "Android.*T08(?:[);/ ]|$)",
                "model": "Liquid Zest Plus"
            },
            {
                "regex": "TM01(?:[);/ ]|$)",
                "model": "Liquid M330"
            },
            {
                "regex": "M220(?:[);/ ]|$)",
                "model": "Liquid M220"
            },
            {
                "regex": "AcerTD600",
                "model": "TD600"
            },
            {
                "regex": "Android.*S55(?:[);/ ]|$)",
                "model": "Liquid Jade"
            },
            {
                "regex": "(?:Acer )?(Chromebook R1[13])",
                "model": "$1",
                "device": "desktop"
            },
            {
                "regex": "(?:Acer )?(Chromebook 14)",
                "model": "$1",
                "device": "desktop"
            },
            {
                "regex": "(Aspire (?:V5-121|XC-704G|V5-573G|A515-51G))",
                "model": "$1",
                "device": "desktop"
            },
            {
                "regex": "(Predator G9-793|Aspire E5-511)",
                "model": "$1",
                "device": "desktop"
            },
            {
                "regex": "Acer; ?([^;\\(\\)/]+)",
                "model": "$1"
            },
            {
                "regex": "Acer(?! ?inc)[ _\\-]?([^;\\(\\)/]+)[();/ ]",
                "model": "$1"
            },
            {
                "regex": "acer[\\-_]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "a(101|110|2[10]0|211|50[10]|51[10]|70[10])(?:[);/ ]|$)",
                "model": "Iconia Tab A$1",
                "device": "tablet"
            }
        ]
    },
    "Advan": {
        "regex": "(?:ADVAN (?:M4|S40)|i7U|S45E|S50H|I7D|i55[KD]|i4U|S7D|S4Z|i5[KE]|S5E[ _]NXT|S5J\\+|S4\\+)(?:[);/ ]|$)|[ ](?:50(?:[46]1|59)|600[24])(?: Build|\\) AppleWebKit)|(?:E1C_3G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ADVAN M4",
                "model": "M4"
            },
            {
                "regex": "ADVAN S40",
                "model": "S40"
            },
            {
                "regex": "i7U",
                "model": "I Lite i7U"
            },
            {
                "regex": "S5E[ _]NXT",
                "model": "S5E NXT"
            },
            {
                "regex": "i(55[KD]|5[KE])",
                "model": "I$1"
            },
            {
                "regex": "i4U",
                "model": "I4U"
            },
            {
                "regex": " 6004(?: Build|\\) AppleWebKit)",
                "model": "G2 Pro"
            },
            {
                "regex": " 6002(?: Build|\\) AppleWebKit)",
                "model": "G3 Pro"
            },
            {
                "regex": "(S45E|50[46]1|5059|S50H|I7D|S7D|S4Z|S5J\\+|S4\\+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "E1C_3G",
                "device": "tablet",
                "model": "E1C 3G"
            }
        ]
    },
    "Advance": {
        "regex": "Hollogram|(?:HL(?:4936|6246|[56]575|5[67]67)|IntroTr3544|Pr(?:61(?:4[56]|50)|60[27]0|5[69]50)|Tr3845)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IntroTr3544|Tr3845",
                "model": "Intro",
                "device": "tablet"
            },
            {
                "regex": "Pr(61(?:4[56]|50)|60[27]0|5[69]50)",
                "model": "Prime PR$1",
                "device": "tablet"
            },
            {
                "regex": "HL(4936|6246|[56]575|5[67]67)",
                "model": "Hollogram HL$1"
            },
            {
                "regex": "Hollogram ([^;/)]+)(?: Build|[;)])",
                "model": "Hollogram $1"
            }
        ]
    },
    "AGM": {
        "regex": "AGM ([^/;)]+)(?: Build|[;)])",
        "device": "smartphone",
        "model": "$1"
    },
    "Airness": {
        "regex": "AIRNESS-([\\w]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Aiwa": {
        "regex": "(?:AW790|M300|AWM(?:533|50[19]|561)|AW500)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AW790(?:[);/ ]|$)",
                "model": "AW790"
            },
            {
                "regex": "AW500(?:[);/ ]|$)",
                "model": "AW500"
            },
            {
                "regex": "AWM(533|50[19]|561)(?:[);/ ]|$)",
                "model": "AWM$1"
            },
            {
                "regex": "M300(?:[);/ ]|$)",
                "model": "M300",
                "device": "phablet"
            }
        ]
    },
    "Akai": {
        "regex": "AKAI,|Akai[ _-]|Eco[ _]E2|Glory[ _](?:G[1235]|L[123]|O[125])|TAB-[79]8[03]0Q?|X6 METAL|AKTB-703MZ",
        "device": "smartphone",
        "models": [
            {
                "regex": "TAB-([79]8[03]0Q?)",
                "device": "tablet",
                "model": "TAB $1"
            },
            {
                "regex": "AKTB-703MZ",
                "device": "tablet",
                "model": "AKTB-703MZ"
            },
            {
                "regex": "X6 METAL",
                "model": "iLike"
            },
            {
                "regex": "Glory[ _](G[1235]|L[123]|O[125])",
                "model": "Glory $1"
            },
            {
                "regex": "Eco[ _]E2",
                "model": "Eco E2"
            },
            {
                "regex": "Akai[ _-]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "AKAI,(AK3219NF)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "Si2157LG32",
                "device": "tv",
                "model": "Si2157LG32"
            }
        ]
    },
    "Arian Space": {
        "regex": "Arian Space",
        "device": "tablet",
        "models": [
            {
                "regex": "100 ST1004PG",
                "model": "100"
            },
            {
                "regex": "80 SS8003PG",
                "model": "80"
            },
            {
                "regex": "71 ST7002PG",
                "model": "71"
            },
            {
                "regex": "70 ST7001RW",
                "model": "70"
            }
        ]
    },
    "Alcatel": {
        "regex": "Alcatel|Alc(?!or )[a-z0-9]+|One[ _]?Touch|idol3|TIMXL|(?:(?:4003[AJ]|4009[ADEFIKMSX]|4013[DEJKMX]|4014[ADEKMX]|4015[ADNTX]|4016[ADX]|4017[ADEFSX]|4018[ADEFMX]|4024[EDX]|4027[ADNX]|4028[AEJS]|4032[ADEX]|4034[ADEFGXTL]|4035[ADXY]|4045[ADEX]|4047[ADFGNX]|4049[DEGMX]|4060[SW]|A466BG|A621BL|4114E|4087U|5001[ADJTU]|5002[ADFH]|5003[ADGU]|5006D|5007[AU]|5008[ADUYT]|5009[AD]|5010[DEGSUX]|5011A|5012[DFG]|5015[ADEX]|5016[AXJ]|5017[ABDEOX]|5019D|5022[EDX]|5023[EF]|5024[ADJF]|5025[DEG]|5026[ADJ]|5027B|5028[AYD]|5029[EYD]|5030[DE]|5032W|5033[AEFXDJGMOTXYQS]|5034D|5036D|5038[ADEX]|5039[DY]|5041[CD]|5042[ADEFGWXT]|5044[ADGIKOPSTY]|5045[ADFGIJTXY]|5046[ADGIJSTUY]|5047[DIUY]|5048[AYUI]|5049[EGSWZ]|5050[ASXY]|5051[ADEJMTWX]|5052[ADY]|5053[ADKY]|5054[ADNSTWX]|5056[ADEGIJMNTUWX]|5057M|5058[AIY]|5059[ADJXYZIST]|5060[ADJ]|5061[KU]|5065[ADNWX]|5070D|5080[ADFQUX]|5085[ABCDGHIJNOQY]|5086[ADY]|5090[AIY]|5095[IKY]|5098[OS]|5099[ADYUI]|5116J|5145A|6016[ADEX]|6036[AXY]|6037[BKY]|6039[AHJKY]|6042D|6043[AD]|6044D|6045[BFIKOYX]|6050[AFY]|6055[ABDHIKPUYZ]|6058[ADX]|6060[SX]|6062W|6070K|7040[ADEFKRT]|7041[DX]|7042A|7043[AEKY]|7044[AX]|7045Y|7048[ASWX]|7053D|7055A|7070X|7071[ADX]|8030Y|8050[DEGX]|8063|8088[XQM]|9001[DIX]|9002X|9003[AX]|9024O|9005X|9026X|9007[ATX]|9008[ADIJNTUX]|9009G|9010X|9020A|9022X|9027[FTWX]|9029Z|9203A|A(?:464BG|570BL|50[13]DL|57[17]VL|574BL)|I213|I216X|(?<!\\.)80(?:82|6[78])|A576CC)(?:_(?:EEA|RU))?|P360X)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "4087U",
                "model": "1SE Light"
            },
            {
                "regex": "5022[EDX]|5070D",
                "model": "One Touch Pop Star"
            },
            {
                "regex": "6044D",
                "model": "One Touch Pop Up"
            },
            {
                "regex": "4015[ATX]|4016A",
                "model": "One Touch Pop C1"
            },
            {
                "regex": "4015[DN]|4016[DX]",
                "model": "One Touch Pop C1 Dual SIM"
            },
            {
                "regex": "4032[AX]",
                "model": "One Touch Pop C2"
            },
            {
                "regex": "4032[DE]",
                "model": "One Touch Pop C2 Dual SIM"
            },
            {
                "regex": "5036D",
                "model": "One Touch Pop C5 Dual SIM"
            },
            {
                "regex": "7040[AFK]|7041X|7042A",
                "model": "One Touch Pop C7"
            },
            {
                "regex": "7040[DE]|7041D",
                "model": "One Touch Pop C7 Dual SIM"
            },
            {
                "regex": "4018[ADEFMX]",
                "model": "One Touch Pop D1"
            },
            {
                "regex": "4035[ADXY]",
                "model": "One Touch Pop D3"
            },
            {
                "regex": "5038[ADEX]",
                "model": "One Touch Pop D5"
            },
            {
                "regex": "4045[AX]",
                "model": "One Touch Pop 2 4\""
            },
            {
                "regex": "4045[DE]",
                "model": "One Touch Pop 2 4\" Dual SIM"
            },
            {
                "regex": "5042[AFGWX]",
                "model": "One Touch Pop 2 4.5\""
            },
            {
                "regex": "5042[DE]",
                "model": "One Touch Pop 2 4.5\" Dual SIM"
            },
            {
                "regex": "7043[AY]|7044[AX]",
                "model": "One Touch Pop 2 5\""
            },
            {
                "regex": "7043[EK]",
                "model": "One Touch Pop 2 5\" Dual SIM"
            },
            {
                "regex": "50[16]5X",
                "model": "One Touch Pop 3"
            },
            {
                "regex": "5015[AE]|5016[AJ]|5065[ADWX]|5116J",
                "model": "One Touch Pop 3 5\""
            },
            {
                "regex": "5025[DEG]|5054[ADSTX]",
                "model": "One Touch Pop 3 5.5\""
            },
            {
                "regex": "5015D",
                "model": "One Touch Pop 3 Dual SIM"
            },
            {
                "regex": "5051[AEJMTWX]",
                "model": "One Touch Pop 4"
            },
            {
                "regex": "5051D",
                "model": "One Touch Pop 4 Dual SIM"
            },
            {
                "regex": "5095[IKY]",
                "model": "One Touch Pop 4S"
            },
            {
                "regex": "5056[ADEGJMTUX]",
                "model": "One Touch Pop 4+"
            },
            {
                "regex": "7070X",
                "model": "One Touch Pop 4 6\""
            },
            {
                "regex": "5057M",
                "model": "One Touch Pop Mirage"
            },
            {
                "regex": "5050[ASXY]",
                "model": "One Touch Pop S3"
            },
            {
                "regex": "7045Y",
                "model": "One Touch Pop S7"
            },
            {
                "regex": "6037[BKY]",
                "model": "One Touch Idol 2"
            },
            {
                "regex": "5042T",
                "model": "One Touch Astro"
            },
            {
                "regex": "5027B",
                "model": "One Touch Dawn"
            },
            {
                "regex": "5024[ADF]|5028Y",
                "model": "1S"
            },
            {
                "regex": "7071[ADX]",
                "model": "A7 XL"
            },
            {
                "regex": "5002[ADH]",
                "model": "1B (2020)"
            },
            {
                "regex": "4034T",
                "model": "1E"
            },
            {
                "regex": "5002F",
                "model": "1A (2020)"
            },
            {
                "regex": "5034D",
                "model": "3L"
            },
            {
                "regex": "A576CC",
                "model": "Kora A576CC"
            },
            {
                "regex": "7040[RT]",
                "model": "One Touch Fierce 2"
            },
            {
                "regex": "5056[NW]",
                "model": "One Touch Fierce 4"
            },
            {
                "regex": "5054N",
                "model": "One Touch Fierce XL"
            },
            {
                "regex": "6042D",
                "model": "One Touch Flash"
            },
            {
                "regex": "6016[AX]",
                "model": "One Touch Idol 2 mini"
            },
            {
                "regex": "6016[DE]",
                "model": "One Touch Idol 2 mini Dual SIM"
            },
            {
                "regex": "6036[AXY]",
                "model": "One Touch Idol 2 mini S"
            },
            {
                "regex": "6050[AFY]",
                "model": "One Touch Idol 2S"
            },
            {
                "regex": "6039[AHJKY]|idol3",
                "model": "One Touch Idol 3"
            },
            {
                "regex": "6045[BFIKOYX]",
                "model": "One Touch Idol 3 5.5\""
            },
            {
                "regex": "6055[ABDHIKPUYZ]",
                "model": "One Touch Idol 4"
            },
            {
                "regex": "6070K",
                "model": "One Touch Idol 4S"
            },
            {
                "regex": "6058[ADX]",
                "model": "One Touch Idol 5"
            },
            {
                "regex": "6060[SX]",
                "model": "One Touch Idol 5S"
            },
            {
                "regex": "6043[AD]",
                "model": "One Touch Idol X+"
            },
            {
                "regex": "8030Y",
                "model": "One Touch Hero 2"
            },
            {
                "regex": "7055A",
                "model": "One Touch Hero 2C"
            },
            {
                "regex": "7053D",
                "model": "One Touch X1"
            },
            {
                "regex": "5065N",
                "model": "TRU"
            },
            {
                "regex": "A574BL",
                "model": "Raven"
            },
            {
                "regex": "A577VL",
                "model": "Zip"
            },
            {
                "regex": "A466BG",
                "model": "Pixi Unite"
            },
            {
                "regex": "5056I",
                "model": "One Touch Optus X Smart"
            },
            {
                "regex": "A570BL",
                "model": "One Touch Pixi Avion LTE"
            },
            {
                "regex": "A571VL",
                "model": "One Touch Pixi Avion 4G LTE"
            },
            {
                "regex": "4024[DEX]",
                "model": "One Touch Pixi First"
            },
            {
                "regex": "A464BG",
                "model": "One Touch Pixi Glitz"
            },
            {
                "regex": "A621BL",
                "model": "One Touch Pixi Glory"
            },
            {
                "regex": "4014D",
                "model": "One Touch Pixi 2"
            },
            {
                "regex": "4009[AFIKMSX]",
                "model": "One Touch Pixi 3 3.5\""
            },
            {
                "regex": "4009[DE]",
                "model": "One Touch Pixi 3 3.5\" Dual SIM"
            },
            {
                "regex": "4003[AJ]|4013[DEJKMX]|4014[AEKMX]|4114E",
                "model": "One Touch Pixi 3 4\""
            },
            {
                "regex": "4027[ADNX]|4028[AEJS]|5019D",
                "model": "One Touch Pixi 3 4.5\""
            },
            {
                "regex": "5017[ABDEOX]",
                "model": "One Touch Pixi 3 4.5\" 4G"
            },
            {
                "regex": "9002X",
                "model": "One Touch Pixi 3 7\"",
                "device": "phablet"
            },
            {
                "regex": "9007A",
                "model": "One Touch Pixi 3 7\"",
                "device": "tablet"
            },
            {
                "regex": "9007[TX]",
                "model": "One Touch Pixi 3 7\" 4G",
                "device": "tablet"
            },
            {
                "regex": "9009G",
                "model": "1T",
                "device": "tablet"
            },
            {
                "regex": "(?!<\\.)8082(?:_(?:EEA|RU))?(?:[);/ ]|$)",
                "model": "1T 10",
                "device": "tablet"
            },
            {
                "regex": "(?!<\\.)806[78](?:_(?:EEA|RU))?(?:[);/ ]|$)",
                "model": "1T 7",
                "device": "tablet"
            },
            {
                "regex": "9022X",
                "model": "One Touch Pixi 3 8\"",
                "device": "phablet"
            },
            {
                "regex": "9010X",
                "model": "One Touch Pixi 3 10\"",
                "device": "tablet"
            },
            {
                "regex": "4017[ADEFSX]",
                "model": "One Touch Pixi 4 3.5\""
            },
            {
                "regex": "4034[ADEFGXL]",
                "model": "One Touch Pixi 4 4\""
            },
            {
                "regex": "4060[SW]",
                "model": "One Touch Pixi 4 4.5\""
            },
            {
                "regex": "5023[EF]",
                "model": "One Touch Pixi 4 Plus Power"
            },
            {
                "regex": "5010[DEGSUX]",
                "model": "One Touch Pixi 4 5\" 3G"
            },
            {
                "regex": "5041D",
                "model": "One Touch Pixi 4 5.0\""
            },
            {
                "regex": "5012[DFG]",
                "model": "One Touch Pixi 4 5.5\" 3G"
            },
            {
                "regex": "5045[ADFGIJTXY]|5145A",
                "model": "One Touch Pixi 4 5\" 4G"
            },
            {
                "regex": "5098O",
                "model": "One Touch Pixi Theatre"
            },
            {
                "regex": "A501DL",
                "model": "A1"
            },
            {
                "regex": "A503DL",
                "model": "A1X"
            },
            {
                "regex": "5046[ADIJTUY]",
                "model": "A3"
            },
            {
                "regex": "5011A|5049[EG]",
                "model": "A3 Plus"
            },
            {
                "regex": "9008[ADIJNTUX]",
                "model": "A3 XL"
            },
            {
                "regex": "9203A",
                "model": "A3 7\" 3G",
                "device": "tablet"
            },
            {
                "regex": "9027[FTWX]",
                "model": "3T 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "9026X",
                "model": "A3 10\"",
                "device": "tablet"
            },
            {
                "regex": "5085[BQ]",
                "model": "A5"
            },
            {
                "regex": "5085[ADHIJY]",
                "model": "A5 LED"
            },
            {
                "regex": "5085N",
                "model": "A5 Max LED"
            },
            {
                "regex": "5090[AIY]",
                "model": "A7"
            },
            {
                "regex": "5046[GS]",
                "model": "A30"
            },
            {
                "regex": "5049S",
                "model": "A30 Plus"
            },
            {
                "regex": "5049Z",
                "model": "A30 Fierce"
            },
            {
                "regex": "5085[GO]",
                "model": "A50"
            },
            {
                "regex": "5048[AYUI]",
                "model": "3X (2019)"
            },
            {
                "regex": "5049W",
                "model": "Revvl"
            },
            {
                "regex": "8050[GX]",
                "model": "One Touch Pixi 4 6\" 3G"
            },
            {
                "regex": "8050[ED]",
                "model": "One Touch Pixi 4 6\" 3G Dual SIM"
            },
            {
                "regex": "5098S|9001[DIX]",
                "model": "One Touch Pixi 4 6\" 4G"
            },
            {
                "regex": "9003[AX]",
                "model": "One Touch Pixi 4 7\" 3G",
                "device": "tablet"
            },
            {
                "regex": "8063",
                "model": "One Touch Pixi 4 7\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "9024O",
                "model": "One Touch Pixi 5",
                "device": "tablet"
            },
            {
                "regex": "I216X",
                "model": "One Touch Pixi 7",
                "device": "tablet"
            },
            {
                "regex": "I213",
                "model": "One Touch Pixi 7",
                "device": "tablet"
            },
            {
                "regex": "9005X",
                "model": "One Touch Pixi 8",
                "device": "tablet"
            },
            {
                "regex": "P320X",
                "model": "One Touch POP 8",
                "device": "tablet"
            },
            {
                "regex": "P310X",
                "model": "One Touch POP 7",
                "device": "tablet"
            },
            {
                "regex": "9020A",
                "model": "One Touch Trek HD",
                "device": "tablet"
            },
            {
                "regex": "7048[ASWX]",
                "model": "One Touch Go Play"
            },
            {
                "regex": "(?:Alcatel-)?OT-802",
                "model": "Wave"
            },
            {
                "regex": "ALCATEL_ONE_TOUCH_768T",
                "model": "Island"
            },
            {
                "regex": "(?:TRIBE_)?3075A",
                "model": "One Touch Tribe"
            },
            {
                "regex": "ALCATEL_one_touch_585",
                "model": "One Touch 585"
            },
            {
                "regex": "ALCATEL_ONE_TOUCH_838",
                "model": "One Touch 838"
            },
            {
                "regex": "ALCATEL_one_touch_813d",
                "model": "One Touch 813D"
            },
            {
                "regex": "ALCATEL_one_touch_813",
                "model": "One Touch 813"
            },
            {
                "regex": "OT871A",
                "model": "One Touch 871A"
            },
            {
                "regex": "P360X",
                "model": "One Touch Pop 10"
            },
            {
                "regex": "(?:Alcatel[ _])?One[ _]?Touch[ _]((?:T[0-9]+|TAB[^/;]+|EVO[78](?:HD)?)) Build",
                "device": "tablet",
                "model": "One Touch $1"
            },
            {
                "regex": "(?:Alcatel[ _])?One[ _]?Touch([^/;]*) Build",
                "model": "One Touch$1"
            },
            {
                "regex": "(?:Alcatel[ _])?One[ _]?Touch([^/;\\)]*)\\)",
                "model": "One Touch$1"
            },
            {
                "regex": "5080[ADFQUX]",
                "model": "Shine Lite"
            },
            {
                "regex": "TIMXL",
                "model": "TIM XL"
            },
            {
                "regex": "5085C",
                "model": "PulseMix"
            },
            {
                "regex": "4049[DEGMX]",
                "model": "U3"
            },
            {
                "regex": "5044[ADIKOPTY]",
                "model": "U5"
            },
            {
                "regex": "4047[DFXN]",
                "model": "U5 3G"
            },
            {
                "regex": "5047[DIUY]",
                "model": "U5 HD"
            },
            {
                "regex": "4047G",
                "model": "U5 Lite"
            },
            {
                "regex": "4047A",
                "model": "U5 Plus"
            },
            {
                "regex": "4044[CV]",
                "model": "Quick Flip"
            },
            {
                "regex": "4044O",
                "model": "Cingular Flip 2"
            },
            {
                "regex": "(?:Alcatel)?4044[MNT]",
                "model": "Go Flip"
            },
            {
                "regex": "5044[GS]",
                "model": "U50"
            },
            {
                "regex": "5033[ADXJEFGMOTXYQS]",
                "model": "1"
            },
            {
                "regex": "5009[AD]",
                "model": "1C"
            },
            {
                "regex": "5008[ADUYT]",
                "model": "1X (2019)"
            },
            {
                "regex": "5007[AU]",
                "model": "1V (2020)"
            },
            {
                "regex": "5003[ADGU]",
                "model": "1C (2019)"
            },
            {
                "regex": "5006D",
                "model": "3C (2019)"
            },
            {
                "regex": "5024J",
                "model": "1S"
            },
            {
                "regex": "5028[AD]",
                "model": "1S (2020)"
            },
            {
                "regex": "5030[DE]",
                "model": "1SE (2020)"
            },
            {
                "regex": "5001[ADJTU]",
                "model": "1V"
            },
            {
                "regex": "5059[ADJXYZIT]",
                "model": "1X"
            },
            {
                "regex": "5059S",
                "model": "Avalon V"
            },
            {
                "regex": "5060[ADJ]",
                "model": "5V",
                "device": "phablet"
            },
            {
                "regex": "5052[ADY]|5053[ADKY]",
                "model": "3"
            },
            {
                "regex": "5029E",
                "model": "3 (2020)"
            },
            {
                "regex": "5029[DY]",
                "model": "3L (2020)"
            },
            {
                "regex": "5032W|5099[ADYUI]",
                "model": "3V"
            },
            {
                "regex": "5026[ADJ]",
                "model": "3C"
            },
            {
                "regex": "5039[DY]",
                "model": "3L",
                "device": "phablet"
            },
            {
                "regex": "5058[AIY]",
                "model": "3X"
            },
            {
                "regex": "5061[KU]",
                "model": "3X (2020)"
            },
            {
                "regex": "5086[ADY]",
                "model": "5"
            },
            {
                "regex": "6062W",
                "model": "7"
            },
            {
                "regex": "8088[XQM]",
                "model": "3T 10",
                "device": "tablet"
            },
            {
                "regex": "9029Z",
                "model": "Joy Tab",
                "device": "tablet"
            },
            {
                "regex": "9029Z",
                "model": "Joy Tab",
                "device": "tablet"
            },
            {
                "regex": "Alcatel UP",
                "model": ""
            },
            {
                "regex": "(?:ALCATEL_)?A383G",
                "model": "Big Easy Plus"
            },
            {
                "regex": "5041C",
                "model": "TETRA"
            },
            {
                "regex": "ALCATEL([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "ALCATEL[ \\-]?([^/;\\)]+)",
                "model": "$1"
            },
            {
                "regex": "ALCATEL_([^/;\\)]+)",
                "model": "$1"
            },
            {
                "regex": "Alc([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Allview": {
        "regex": "Allview|A4You|H1003_LTE_PRO|A5_(?:Easy(?:_TM)?|Ready(?:_TM)?|Quad|Quad_Plus_TM)|A[5-9]_Lite|A5Smiley|A6_Duo|A10_Lite_2019|A10_(?:Plus|Max)|AX2_Frenzy|AX4Nano|AX5NanoQ|C6_Duo|E[23]_Living|E3_(?:Jump|Sign)|E4_Lite|M9_Connect|P(?:43_Easy|[5689]_Energy|6_Energy_Lite|[68]_Energy_Mini(?:_TM)?|(41|[458])_eMagic(?:_TM)?|[589](?:_)?Life(?:_TM)?|[567]_Lite(?:_TM)?|6_plus|[45678]_Pro|7_Seon|10_Life|10_Max|10_Style|7_Xtreme|6_Qmax|4_Quad)|V(?:[134]_Viper|1_Viper_I|2_Viper_(?:E|I|S|X|X_plus|Xe))|X4_Soul_Vision|X(?:[1-46]_Soul_Xtreme|[1-5]_Soul|3_Soul_Lite|[2-6]_Soul_Mini(?:_TM)?|4_Soul_Mini_S(?:_TM)?|[2-5]_Soul_Style(?:_TM)?|2_Soul_Style_Plus|2_Twin)|Viva_(?:H801|100[13]G|(?:H100[12]|H701|H802)_LTE|C701|i701G)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A4You",
                "model": "A4 You"
            },
            {
                "regex": "AX2_Frenzy",
                "model": "AX2 Frenzy",
                "device": "tablet"
            },
            {
                "regex": "AX4Nano",
                "model": "AX4 Nano"
            },
            {
                "regex": "AX5NanoQ",
                "model": "AX5 Nano Q",
                "device": "tablet"
            },
            {
                "regex": "C6_Duo",
                "model": "C6 Duo"
            },
            {
                "regex": "E([23])_Living",
                "model": "E$1 Living"
            },
            {
                "regex": "E3_Jump",
                "model": "E3 Jump"
            },
            {
                "regex": "E3_Sign",
                "model": "E3 Sign"
            },
            {
                "regex": "E4_Lite",
                "model": "E4 Lite"
            },
            {
                "regex": "M9_Connect",
                "model": "M9 Connect"
            },
            {
                "regex": "P43_Easy",
                "model": "P43 Easy"
            },
            {
                "regex": "P(41|[458])_eMagic(?:_TM)?",
                "model": "P$1 eMagic"
            },
            {
                "regex": "P([567])_Lite(?:_TM)?",
                "model": "P$1 Lite"
            },
            {
                "regex": "P6_plus",
                "model": "P6 Plus"
            },
            {
                "regex": "P6_Qmax",
                "model": "P6 Qmax"
            },
            {
                "regex": "P([45678])_Pro",
                "model": "P$1 Pro"
            },
            {
                "regex": "P4_Quad",
                "model": "P4 Quad"
            },
            {
                "regex": "P9_Energy_Lite_2017",
                "model": "P9 Energy Lite (2017)"
            },
            {
                "regex": "P9_Energy_S",
                "model": "P9 Energy S"
            },
            {
                "regex": "P([69])_Energy_Lite",
                "model": "P$1 Energy Lite"
            },
            {
                "regex": "P8_Energy_PRO",
                "model": "P8 Energy Pro"
            },
            {
                "regex": "P([689])_Energy_mini(?:_TM)?",
                "model": "P$1 Energy Mini"
            },
            {
                "regex": "P([5689])_Energy",
                "model": "P$1 Energy"
            },
            {
                "regex": "P7_Seon",
                "model": "P7 Seon"
            },
            {
                "regex": "P7_Xtreme",
                "model": "P7 Xtreme"
            },
            {
                "regex": "P([589])(?:_)?Life(?:_TM)?",
                "model": "P$1 Life"
            },
            {
                "regex": "P10_Life",
                "model": "P10 Life"
            },
            {
                "regex": "P10_Max",
                "model": "P10 Max"
            },
            {
                "regex": "P10_Style",
                "model": "P10 Style"
            },
            {
                "regex": "V([12])_Viper_I4G(?:_TM)?",
                "model": "V$1 Viper I 4G"
            },
            {
                "regex": "V1_Viper_I",
                "model": "V1 Viper I"
            },
            {
                "regex": "V([134])_Viper",
                "model": "V$1 Viper"
            },
            {
                "regex": "V2_Viper_X_plus",
                "model": "V2 Viper X Plus"
            },
            {
                "regex": "V2_Viper_(E|I|S|X(?:e)?)",
                "model": "V2 Viper $1"
            },
            {
                "regex": "X4_Soul_Vision",
                "model": "X4 Soul Vision"
            },
            {
                "regex": "X([1246])_Soul_Xtreme",
                "model": "X$1 Soul Xtreme"
            },
            {
                "regex": "X4_Soul_Infinity_(L|N|S|Z)",
                "model": "X4 Soul Infinity $1"
            },
            {
                "regex": "X([34])_Soul_Lite",
                "model": "X$1 Soul Lite"
            },
            {
                "regex": "X4_Soul_Mini_S(?:_TM)?",
                "model": "X4 Soul Mini S"
            },
            {
                "regex": "X([23456])_Soul_Mini(?:_TM)?",
                "model": "X$1 Soul Mini"
            },
            {
                "regex": "X3_Soul_PLUS",
                "model": "X3 Soul Plus"
            },
            {
                "regex": "X([35])_Soul_Pro",
                "model": "X$1 Soul Pro"
            },
            {
                "regex": "X2_Soul_Style_Plus",
                "model": "X2 Soul Style Plus"
            },
            {
                "regex": "X([2345])_Soul_Style(?:_TM)?",
                "model": "X$1 Soul Style"
            },
            {
                "regex": "X([12345])_Soul",
                "model": "X$1 Soul"
            },
            {
                "regex": "X2_Twin",
                "model": "X2 Twin"
            },
            {
                "regex": "A5_Easy(?:_TM)?",
                "model": "A5 Easy"
            },
            {
                "regex": "A([56789])_Lite",
                "model": "A$1 Lite"
            },
            {
                "regex": "A5_Ready(?:_TM)?",
                "model": "A5 Ready"
            },
            {
                "regex": "A5Smiley",
                "model": "A5 Smiley"
            },
            {
                "regex": "A5_Quad_Plus_TM",
                "model": "A5 Quad Plus"
            },
            {
                "regex": "A5_Quad",
                "model": "A5 Quad"
            },
            {
                "regex": "A6_Duo",
                "model": "A6 Duo"
            },
            {
                "regex": "A10_Lite_2019",
                "model": "A10 Lite (2019)"
            },
            {
                "regex": "A10_Plus",
                "model": "A10 Plus"
            },
            {
                "regex": "A10_Max",
                "model": "A10 Max"
            },
            {
                "regex": "Impera S",
                "model": "Impera S"
            },
            {
                "regex": "ALLVIEW P4i",
                "model": "AllDro P4"
            },
            {
                "regex": "Allview_P2",
                "model": "AllDro"
            },
            {
                "regex": "AllviewCityPlus",
                "device": "tablet",
                "model": "City Plus"
            },
            {
                "regex": "AllviewCity",
                "device": "tablet",
                "model": "City"
            },
            {
                "regex": "AllviewAX2Frenzy",
                "device": "tablet",
                "model": "AX2 Frenzy"
            },
            {
                "regex": "Allview2SpeedDuo",
                "device": "tablet",
                "model": "Alldro 2 Speed Duo"
            },
            {
                "regex": "Allview3SpeedQuad",
                "device": "tablet",
                "model": "Alldro 3 Speed Quad"
            },
            {
                "regex": "H1003_LTE_PRO",
                "device": "tablet",
                "model": "Viva H1003 LTE Pro"
            },
            {
                "regex": "Viva_(H801|100[13]G|(?:H802|H100[12]|H701)_LTE|C701|i701G)",
                "device": "tablet",
                "model": "Viva $1"
            },
            {
                "regex": "ALLVIEW ?SPEEDI",
                "device": "tablet",
                "model": "Speed I"
            },
            {
                "regex": "ALLVIEW ?SPEED",
                "device": "tablet",
                "model": "Speed"
            },
            {
                "regex": "ALLVIEWSPEED",
                "device": "tablet",
                "model": "Speed"
            },
            {
                "regex": "AX4Nano",
                "device": "tablet",
                "model": "AX4 Nano"
            },
            {
                "regex": "ALLVIEW_TX1_Quasar",
                "device": "tablet",
                "model": "TX1 Quasar"
            },
            {
                "regex": "Allview[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Allview[ _-]([^;/]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Allwinner": {
        "regex": "(?:QUAD-CORE (?:A64 p3|A33 y3|T3 K2001M)|ZY-07B|UltraOcta-T8|OCTA-CORE T8)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "QUAD-CORE A64 p3",
                "model": "A64 QUAD-CORE p3"
            },
            {
                "regex": "QUAD-CORE A33 y3",
                "model": "A33 QUAD-CORE y3"
            },
            {
                "regex": "ZY-07B",
                "model": "ZY-07B"
            },
            {
                "regex": "UltraOcta-T8",
                "device": "car browser",
                "model": "Ultra Octa T8"
            },
            {
                "regex": "QUAD-CORE T3 K2001M",
                "device": "car browser",
                "model": "QUAD-CORE T3 K2001M"
            },
            {
                "regex": "OCTA-CORE T8",
                "device": "car browser",
                "model": "OCTA-CORE T8"
            }
        ]
    },
    "altron": {
        "regex": "(AL-555|GI-626|OB[_-](?:421|728|627))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AL-555",
                "model": "AL-555"
            },
            {
                "regex": "OB[_-](421|728|627)",
                "model": "OB-$1"
            },
            {
                "regex": "GI-626",
                "device": "phablet",
                "model": "GI-626"
            }
        ]
    },
    "AMGOO": {
        "regex": "AM(350|355|40[257]|41[025]|450|50[89]|52[037]|51[58]|53[05])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AM350",
                "model": "Jack Pro"
            },
            {
                "regex": "AM(355|407)",
                "model": "Tigo"
            },
            {
                "regex": "AM402",
                "model": "Pronto"
            },
            {
                "regex": "AM410",
                "model": "Unico"
            },
            {
                "regex": "AM450",
                "model": "Swift"
            },
            {
                "regex": "AM508",
                "model": "Fuego"
            },
            {
                "regex": "AM509",
                "model": "Uno"
            },
            {
                "regex": "AM515",
                "model": "D1"
            },
            {
                "regex": "AM518",
                "model": "C1"
            },
            {
                "regex": "AM520",
                "model": "Pro"
            },
            {
                "regex": "AM523",
                "model": "Plus"
            },
            {
                "regex": "AM527",
                "model": "Geo"
            },
            {
                "regex": "AM530",
                "model": "A1"
            },
            {
                "regex": "AM535",
                "model": "P1"
            },
            {
                "regex": "AM([0-9]{3})",
                "model": "AM$1"
            }
        ]
    },
    "Amoi": {
        "regex": "Amoi|(?:A862W|Clever[ -]?(?:Gem S52|Gleam S45|Pad P7|Wave S50|Touch S46|JOY S40|Lite S41))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Clever Pad P7",
                "model": "Clever Pad P7"
            },
            {
                "regex": "A862W",
                "model": "A862W"
            },
            {
                "regex": "CLEVER JOY S40",
                "model": "Clever Joy S40"
            },
            {
                "regex": "Clever[ -]?(Gleam S45|Gem S52|Wave S50|Touch S46|Lite S41)",
                "model": "Clever $1"
            },
            {
                "regex": "Amoi[\\- /]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Amoisonic-([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Ainol": {
        "regex": "Numy|novo[0-9]|Novo 10 Hero|AX10PRO|NUMY3GAX9|NOVO10 Spark|Aurora-II",
        "device": "tablet",
        "models": [
            {
                "regex": "Numy 3G AX1",
                "model": "Novo 7 Numy AX1 3G"
            },
            {
                "regex": "Numy[_ ]?3G[_ ]?Sword",
                "model": "Numy 3G Sword"
            },
            {
                "regex": "NOVO10 Spark",
                "model": "Novo 10 Spark"
            },
            {
                "regex": "AX10PRO",
                "model": "Numy AX10 Pro"
            },
            {
                "regex": "Numy_3G_AX3",
                "model": "Numy AX3 Sword"
            },
            {
                "regex": "Numy3GTalos",
                "model": "Numy 3G Talos"
            },
            {
                "regex": "Numy_3G_BW1",
                "model": "Numy 3G Talos 2"
            },
            {
                "regex": "NUMY3GAX9(?:[);/ ]|$)",
                "model": "Numy 3G AX9"
            },
            {
                "regex": "Numy3G_AX10(?:[);/ ]|$)",
                "model": "Numy 3G AX10"
            },
            {
                "regex": "(Novo 10 Hero QuadCore)",
                "model": "$1"
            },
            {
                "regex": "Aurora-II",
                "model": "Novo 7 Aurora II"
            },
            {
                "regex": "Novo7 Flame(?:[);/ ]|$)",
                "model": "Novo 7 Flame"
            },
            {
                "regex": "NOVO7(?:[);/ ]|$)",
                "model": "Novo 7"
            },
            {
                "regex": "Numy[ _]([^;/]+) Build",
                "model": "Numy $1"
            },
            {
                "regex": "Novo([0-9]+)[ \\-]([^;/]+) Build",
                "model": "Novo $1 $2"
            }
        ]
    },
    "Archos": {
        "regex": "(?:YL-)?Archos|(?:A50TI|AC101BHE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Archos (Oxygen (?:63|57|68XL))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "A50TI(?:[);/ ]|$)",
                "model": "50 Titanium 4G"
            },
            {
                "regex": "Archos ?5(?:[);/ ]|$)",
                "device": "tablet",
                "model": "5"
            },
            {
                "regex": "AC101BHE(?:[);/ ]|$)",
                "device": "tablet",
                "model": "101B Helium 4G"
            },
            {
                "regex": "(?:YL-)?Archos ([^/;]*(?:PAD)[^/;]*) Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Archos ((?:[789]|10)[0-9]?[a-z]* ?(?:G9|G10|Helium|Titanium|Cobalt|Platinum|Xenon|Carbon|Neon|XS|IT)[^/;]*) Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(?:YL-)?Archos ([a-z0-9 ]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:YL-)?Archos ([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Axxion": {
        "regex": "Axxion ATAB-[0-9]+(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Axxion ATAB-([0-9]+)(?:[);/ ]|$)",
                "model": "ATAB-$1"
            }
        ]
    },
    "MEU": {
        "regex": "MEU ([a-z0-9]+) Build",
        "device": "smartphone",
        "model": "$1"
    },
    "Arnova": {
        "regex": "arnova|ARCHM901|AN7CG2|AN7G2(DTE|I)?|AN7[BCDFH]?G3|A80KSC|AN8G2|AN8[BC]?G3|AN9G2I?|AN9G3|A101[BC]|AN10G2|AN10BG2(DT|I)?|AN10BG3(DT)?|AN10[CD]G3",
        "device": "tablet",
        "models": [
            {
                "regex": "ARCHM901",
                "model": "M901"
            },
            {
                "regex": "AN7CG2",
                "model": "7c G2"
            },
            {
                "regex": "AN7G2I|AN7G2|AN7G2DTE",
                "model": "7 G2"
            },
            {
                "regex": "AN7G3",
                "model": "7 G3"
            },
            {
                "regex": "AN7BG3",
                "model": "7b G3"
            },
            {
                "regex": "AN7CG3",
                "model": "7c G3"
            },
            {
                "regex": "AN7DG3-CP",
                "model": "Childpad"
            },
            {
                "regex": "AN7DG3",
                "model": "7d G3"
            },
            {
                "regex": "AN7FG3",
                "model": "7f G3"
            },
            {
                "regex": "AN7HG3",
                "model": "7h G3"
            },
            {
                "regex": "A80KSC",
                "model": "8"
            },
            {
                "regex": "AN8G2",
                "model": "8 G2"
            },
            {
                "regex": "AN8G3",
                "model": "8 G3"
            },
            {
                "regex": "AN8BG3",
                "model": "8b G3"
            },
            {
                "regex": "AN8CG3",
                "model": "8c G3"
            },
            {
                "regex": "AN9G2I",
                "model": "9i G2"
            },
            {
                "regex": "AN9G2",
                "model": "9 G2"
            },
            {
                "regex": "AN9G3",
                "model": "9 G3"
            },
            {
                "regex": "A101B2|A101C|AN10G2",
                "model": "10 G2"
            },
            {
                "regex": "A101B",
                "model": "10"
            },
            {
                "regex": "AN10BG2|AN10BG2DT|AN10BG2I",
                "model": "10b G2"
            },
            {
                "regex": "AN10BG3|AN10BG3DT|AN10BG3-LZ",
                "model": "10b G3"
            },
            {
                "regex": "AN10CG3",
                "model": "10c G3"
            },
            {
                "regex": "AN10DG3",
                "model": "10d G3"
            },
            {
                "regex": "ARNOVA 90G3",
                "model": "90 G3"
            },
            {
                "regex": "ARNOVA 90 G4",
                "model": "90 G4"
            },
            {
                "regex": "ARNOVA 97G4",
                "model": "97 G4"
            },
            {
                "regex": "ARNOVA 101 G4",
                "model": "101 G4"
            },
            {
                "regex": "Arnova ([^/;]*) Build",
                "model": "$1"
            }
        ]
    },
    "ARRIS": {
        "regex": "ARRIS",
        "device": "tv",
        "models": [
            {
                "regex": "ARRIS[,;] ([^),;/]+)",
                "model": "$1"
            }
        ]
    },
    "Ask": {
        "regex": "ASK[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "ASK[ _]791SP[ _]3G",
                "model": "791SP 3G",
                "device": "tablet"
            },
            {
                "regex": "ASK[_ ]([^/;]*) Build",
                "model": "$1"
            }
        ]
    },
    "ANS": {
        "regex": "UL40 Build",
        "device": "smartphone",
        "model": "UL40"
    },
    "AOC": {
        "regex": "AOC,",
        "device": "tv",
        "models": [
            {
                "regex": "(LE(?:32|43)S5970(?:s)?-20|LE55U7970-30|LE43S5977-20|U60856)",
                "model": "$1"
            }
        ]
    },
    "Assistant": {
        "regex": "(AS[-_](?:50[123]|543[1-6]|44[12]1|541[12]|54[23]1|6431|[46]01L)|AP-(?:109|115G|721N|753G|7[25]7G|10[68]|107G|110N|941|719))[;/)_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "AS[-_]401L(?:[);/ ]|$)",
                "model": "Asper"
            },
            {
                "regex": "AS-5432(?:[);/ ]|$)",
                "model": "Agio"
            },
            {
                "regex": "AS[-_](?:5434|501)(?:[);/ ]|$)",
                "model": "Club"
            },
            {
                "regex": "AS_601L(?:[);/ ]|$)",
                "model": "AS-601L"
            },
            {
                "regex": "AS-5433 Secret(?:[);/ ]|$)",
                "model": "Secret"
            },
            {
                "regex": "AS-5433(?:[);/ ]|$)",
                "model": "Max Secret"
            },
            {
                "regex": "AS-5421(?:[);/ ]|$)",
                "model": "Surf"
            },
            {
                "regex": "AS-44[12]1(?:[);/ ]|$)",
                "model": "Unami"
            },
            {
                "regex": "AS-5431(?:[);/ ]|$)",
                "model": "Prima"
            },
            {
                "regex": "AS-502(?:[);/ ]|$)",
                "model": "Shot"
            },
            {
                "regex": "AS-503(?:[);/ ]|$)",
                "model": "Target"
            },
            {
                "regex": "AS-5435(?:[);/ ]|$)",
                "model": "Shine"
            },
            {
                "regex": "AS-5436[ _]",
                "model": "Grid"
            },
            {
                "regex": "AS-6431(?:[);/ ]|$)",
                "model": "Rider"
            },
            {
                "regex": "AS-5411[_ ]",
                "model": "Max Ritm"
            },
            {
                "regex": "AS-5412 Max(?:[);/ ]|$)",
                "model": "AS-5412 Max"
            },
            {
                "regex": "AP-721N(?:[);/ ]|$)",
                "model": "AP-721N Force",
                "device": "tablet"
            },
            {
                "regex": "AP-941(?:[);/ ]|$)",
                "model": "AP-941",
                "device": "tablet"
            },
            {
                "regex": "AP-108(?:[);/ ]|$)",
                "model": "Cetus",
                "device": "tablet"
            },
            {
                "regex": "AP-106(?:[);/ ]|$)",
                "model": "AP-106 Force",
                "device": "tablet"
            },
            {
                "regex": "(AP-(?:109|115G|7[25]7G|753G|107G|110N|719))(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Ark": {
        "regex": "(ARK[_ -])?Benefit[_ -]([^/;]*)(?: Build|\\))|EDGE A5HD|Elf_S8|ICON (R40\\+|R45)|Impulse[ _](P[12])|Wizard_[12](?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:ARK[_ -])?Benefit[_ -]([^/;]*)(?: Build|\\))",
                "model": "Benefit $1"
            },
            {
                "regex": "Impulse[ _]P1\\+",
                "model": "Impulse P1 Plus"
            },
            {
                "regex": "Impulse[ _](P[12])",
                "model": "Impulse $1"
            },
            {
                "regex": "EDGE (A5HD)",
                "model": "Edge $1"
            },
            {
                "regex": "ICON (R40\\+|R45)",
                "model": "Icon $1"
            },
            {
                "regex": "Wizard_([12])",
                "model": "Wizard $1"
            },
            {
                "regex": "Elf_S8(?:[);/ ]|$)",
                "model": "Elf S8"
            }
        ]
    },
    "Garmin-Asus": {
        "regex": "Garmin-Asus|Garminfone",
        "device": "smartphone",
        "models": [
            {
                "regex": "Garminfone[ \\-_]([^;/]*)Build",
                "model": "Garminfone $1"
            },
            {
                "regex": "Garmin-Asus[ \\-_]([^;/]+)Build",
                "model": "$1"
            },
            {
                "regex": "Garmin-Asus[ \\-_]([^;/]+)[\\)/]",
                "model": "$1"
            }
        ]
    },
    "Asus": {
        "regex": "Asus|Transformer|ZenFone Max|TF300T|Slider SL101|PadFone|ME302(?:C|KL)|ME301T|ME371MG|ME17(?:1|2V|3X)|(?:K0[01][0-9a-z]|P(?:00[18ACIL]|01[MTVWYZ]|01MA|01T_1|02[13478])(?: Build|\\))|X015D|X018D|X003|X00[7ABT]D|Z00D|Z00[MTY]D|Z01[7FGHKMR]D)(?:[);/ ]|$)|G55[023]KL|ZB(631|602|633|55[135]|50[01])KL|ZC(55[134]|520|600)KL|ZA550KL|ZE(5[02]0|620|55[2345])KL|ZD55[23]KL|ZS6(?:61|7[01])KS|ZS(6[0236]0|55[10])KL|ZB(500KG|601KL)|MeMo Pad FHD 10 LTE|Z00[SV]D",
        "device": "smartphone",
        "models": [
            {
                "regex": "ME171(?:[);/ ]|$)",
                "model": "Eee Pad MeMO 171",
                "device": "tablet"
            },
            {
                "regex": "ASUS Z906(?:[);/ ]|$)",
                "model": "Z906 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "ME172V",
                "model": "MeMO Pad",
                "device": "tablet"
            },
            {
                "regex": "ME302C(?:[);/ ]|$)",
                "model": "MeMO Pad FHD 10",
                "device": "tablet"
            },
            {
                "regex": "(ME302KL|MeMo Pad FHD 10 LTE)(?:[);/ ]|$)",
                "model": "MeMO Pad FHD 10 LTE",
                "device": "tablet"
            },
            {
                "regex": "ME301T(?:[);/ ]|$)",
                "model": "MeMO Pad Smart 10",
                "device": "tablet"
            },
            {
                "regex": "Z101(?:[);/ ]|$)",
                "model": "Z101",
                "device": "tablet"
            },
            {
                "regex": "X Pad 10 LTE(?:[);/ ]|$)",
                "model": "X Pad 10 LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:K01[3A]|K007|K00R)(?:[);/ ]|$)|MeMO Pad 7",
                "model": "MeMO Pad 7",
                "device": "tablet"
            },
            {
                "regex": "K01E(?:[);/ ]|$)",
                "model": "MeMO Pad 10 ME103K",
                "device": "tablet"
            },
            {
                "regex": "K00U|ME173X(?:[);/ ]|$)",
                "model": "MeMO Pad HD 7",
                "device": "tablet"
            },
            {
                "regex": "(?:K011|K00L)(?:[);/ ]|$)",
                "model": "MeMO Pad 8",
                "device": "tablet"
            },
            {
                "regex": "K014(?:[);/ ]|$)",
                "model": "MeMO Pad 8.9",
                "device": "tablet"
            },
            {
                "regex": "K00S(?:[);/ ]|$)",
                "model": "MeMO Pad HD 7 Dual SIM",
                "device": "tablet"
            },
            {
                "regex": "K00F(?:[);/ ]|$)",
                "model": "MeMO Pad 10",
                "device": "tablet"
            },
            {
                "regex": "K00C(?:[);/ ]|$)",
                "model": "Transformer Pad TF701T",
                "device": "tablet"
            },
            {
                "regex": "K010(?:[);/ ]|$)",
                "model": "Transformer Pad TF103C",
                "device": "tablet"
            },
            {
                "regex": "K018(?:[);/ ]|$)",
                "model": "Transformer Pad TF103CG",
                "device": "tablet"
            },
            {
                "regex": "TF300T(?:[);/ ]|$)",
                "model": "Transformer Pad TF300T",
                "device": "tablet"
            },
            {
                "regex": "K01B(?:[);/ ]|$)",
                "model": "Transformer Pad TF303K",
                "device": "tablet"
            },
            {
                "regex": "Slider SL101",
                "model": "Eee Pad Slider SL101",
                "device": "tablet"
            },
            {
                "regex": "P01[YZ]",
                "model": "ZenPad C 7.0",
                "device": "tablet"
            },
            {
                "regex": "P008 Build",
                "model": "ZenPad Z8",
                "device": "tablet"
            },
            {
                "regex": "P001",
                "model": "ZenPad Z10",
                "device": "tablet"
            },
            {
                "regex": "(?:ASUS_)?P00J",
                "model": "ZenPad Z8s",
                "device": "tablet"
            },
            {
                "regex": "P01[VW]",
                "model": "ZenPad 7.0",
                "device": "tablet"
            },
            {
                "regex": "(?:P024|P00A)(?:[);/ ]|$)",
                "model": "ZenPad 8.0",
                "device": "tablet"
            },
            {
                "regex": "P01MA(?: Build|\\))|P01M(?: Build|\\))",
                "model": "ZenPad S 8.0",
                "device": "tablet"
            },
            {
                "regex": "P027",
                "model": "ZenPad 3S 10",
                "device": "tablet"
            },
            {
                "regex": "(?:ASUS_)?P00I",
                "model": "ZenPad 3S 10 LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:ASUS_)?P00C|P02[138]|P00L|P01T_1",
                "model": "ZenPad 10",
                "device": "tablet"
            },
            {
                "regex": "ASUS Tablet P1801-T",
                "model": "Transformer AiO P1801 18.4\"",
                "device": "tablet"
            },
            {
                "regex": "ASUS TAB A8",
                "model": "TAB A8",
                "device": "tablet"
            },
            {
                "regex": "ME371MG(?:[);/ ]|$)",
                "model": "Fonepad",
                "device": "phablet"
            },
            {
                "regex": "K00G(?:[);/ ]|$)",
                "model": "Fonepad Note 6",
                "device": "phablet"
            },
            {
                "regex": "(?:K012|K00E)(?:[);/ ]|$)",
                "model": "Fonepad 7",
                "device": "phablet"
            },
            {
                "regex": "K00Z(?:[);/ ]|$)",
                "model": "Fonepad 7 Dual SIM",
                "device": "phablet"
            },
            {
                "regex": "K016(?:[);/ ]|$)",
                "model": "Fonepad 8",
                "device": "phablet"
            },
            {
                "regex": "(?:ASUS_)?T00N",
                "model": "PadFone S"
            },
            {
                "regex": "(?:ASUS_)?T00[CE]",
                "model": "PadFone Mini"
            },
            {
                "regex": "(?:ASUS[-_])?T00T",
                "model": "PadFone X Mini"
            },
            {
                "regex": "PadFone T008",
                "model": "PadFone E"
            },
            {
                "regex": "PadFone T004",
                "model": "PadFone Infinity"
            },
            {
                "regex": "(?:ASUS_)?A002(A)?",
                "model": "ZenFone AR"
            },
            {
                "regex": "(?:ASUS_)?A006",
                "model": "ZenFone V"
            },
            {
                "regex": "(?:ASUS_)?A009",
                "model": "ZenFone V Live"
            },
            {
                "regex": "(?:ASUS_)?Z007",
                "model": "ZenFone C"
            },
            {
                "regex": "(?:ASUS_)?(X00P[SD]|ZB555KL)",
                "model": "ZenFone Max M1"
            },
            {
                "regex": "(?:ASUS_)?(?:ZB60[12]KL)|ZenFone Max Pro M1",
                "model": "ZenFone Max Pro M1"
            },
            {
                "regex": "(?:ASUS_)?(X01([AB]D)|ZB633KL)(?:[);/ ]|$)",
                "model": "ZenFone Max M2"
            },
            {
                "regex": "(?:ASUS_)?(?:Z00[AD]|Z008D|Z008|Z00AD[AB]?|ZE551ML)",
                "model": "ZenFone 2"
            },
            {
                "regex": "(?:ASUS_)?(?:ZenFone 2E)",
                "model": "ZenFone 2E"
            },
            {
                "regex": "(?:ASUS_)?(?:A007|Z00YD|ZA550KL|ZB553KL|ZB501KL)(?:[);/ ]|$)",
                "model": "ZenFone Live"
            },
            {
                "regex": "(?:ASUS_)?(?:X00RD|G552KL)",
                "model": "ZenFone Live L1"
            },
            {
                "regex": "G553KL",
                "model": "ZenFone Lite L1"
            },
            {
                "regex": "(?:ASUS_)?(?:Z00[ERLMTW]D|Z011D|ZE500KL)",
                "model": "ZenFone 2 Laser"
            },
            {
                "regex": "(?:ASUS_)?(?:T00[IQ1]|Z01KD)",
                "model": "ZenFone 4"
            },
            {
                "regex": "(?:ASUS_)?(?:T00[JF]|X00QD|X00QSA|ZE620KL)",
                "model": "ZenFone 5"
            },
            {
                "regex": "(?:ASUS_)?T00P",
                "model": "ZenFone 5 LTE"
            },
            {
                "regex": "(?:ASUS_)?(?:T00K|X017DA|X017D|ZC600KL)",
                "model": "ZenFone 5 Lite"
            },
            {
                "regex": "(?:ASUS_)?(?:Z01RD|ZS620KL)",
                "model": "ZenFone 5Z"
            },
            {
                "regex": "(?:ASUS_)?(?:T00G|Z002|ZS630KL|I01WD[X]?)",
                "model": "ZenFone 6"
            },
            {
                "regex": "(?:ASUS_)?ZS671KS",
                "model": "ZenFone 7 Pro"
            },
            {
                "regex": "(?:ASUS_)?(?:ZS670KS|I002D)(?:[);/ ]|$)",
                "model": "ZenFone 7"
            },
            {
                "regex": "(?:ASUS_)?Z010D",
                "model": "ZenFone Max"
            },
            {
                "regex": "(?:ASUS_)?X018D",
                "model": "ZenFone Max Plus M1"
            },
            {
                "regex": "(?:ASUS_)?X00TD?",
                "model": "ZenFone Max Pro M1"
            },
            {
                "regex": "(?:ASUS_)?(?:X01BDA|ZB631KL|Zenfone Max Pro M2)",
                "model": "ZenFone Max Pro M2"
            },
            {
                "regex": "(?:ASUS_)?X014D",
                "model": "ZenFone Go Plus"
            },
            {
                "regex": "(?:ASUS_)?(L001|X00[7AB]D|X009[DB][DA]|X009D|Z00[SV]D|ZB500K[LG]|ZB551KL)",
                "model": "ZenFone Go"
            },
            {
                "regex": "(?:ASUS_)?X013D",
                "model": "ZenFone Go Life"
            },
            {
                "regex": "(?:ASUS_)?G550KL",
                "model": "ZenFone Go TV"
            },
            {
                "regex": "(?:ASUS_)?Z00[SV]D",
                "model": "ZenFone Go"
            },
            {
                "regex": "(?:ASUS_)?(X00[23])",
                "model": "ZenFone Pegasus"
            },
            {
                "regex": "(?:ASUS_)?X005",
                "model": "ZenFone Pegasus 5000"
            },
            {
                "regex": "(?:ASUS_)?X550",
                "model": "ZenFone Pegasus 2 Plus"
            },
            {
                "regex": "(?:ASUS_)?(X00GD)",
                "model": "ZenFone Pegasus 3S Max"
            },
            {
                "regex": "(?:ASUS_)?(?:X00D[DS]|X008D)|ZC553KL",
                "model": "ZenFone 3 Max"
            },
            {
                "regex": "(?:ASUS_)?(X008)",
                "model": "ZenFone 3 Pegasus"
            },
            {
                "regex": "(?:ASUS_)?(ZE553KL|Z01HD)",
                "model": "ZenFone 3 Zoom"
            },
            {
                "regex": "(?:ASUS_)?ZS550KL",
                "model": "ZenFone 3 Deluxe"
            },
            {
                "regex": "(?:ASUS_)?Z00UD",
                "model": "ZenFone Selfie"
            },
            {
                "regex": "(?:ASUS_)?(Z016[DS]|Z01FD)",
                "model": "ZenFone 3 Deluxe"
            },
            {
                "regex": "(?:ASUS_)?(Z017DA|ZE520KL|ZE552KL|Z017D|Z012(D|S))",
                "model": "ZenFone 3"
            },
            {
                "regex": "(?:ASUS_)?Z01B[DS]|ZC551KL",
                "model": "ZenFone 3 Laser"
            },
            {
                "regex": "(?:ASUS_)?A001",
                "model": "ZenFone 3 Ultra"
            },
            {
                "regex": "(?:ASUS_)?(?:ZD552KL|Z01MDA?)(?:[);/ ]|$)",
                "model": "ZenFone 4 Selfie Pro"
            },
            {
                "regex": "(?:ASUS_)?(?:X00LDA|ZD553KL)",
                "model": "ZenFone 4 Selfie"
            },
            {
                "regex": "(?:ASUS_)?(?:X00LD|Z01KS|Z01KDA|ZE554KL)",
                "model": "ZenFone 4"
            },
            {
                "regex": "(?:ASUS_)?X00(?:[HIK]D|IS)|ZC554KL|ZC520KL",
                "model": "ZenFone 4 Max"
            },
            {
                "regex": "(?:ASUS_)?X015D",
                "model": "ZenFone 4 Max Plus"
            },
            {
                "regex": "(?:ASUS_)?(:?Z01G[DS]|ZS551KL)",
                "model": "ZenFone 4 Pro"
            },
            {
                "regex": "(?:ASUS_)?Z00XS",
                "model": "ZenFone Zoom"
            },
            {
                "regex": "(?:ASUS_)?(?:Z01QD|ZS600KL)",
                "model": "ROG Phone"
            },
            {
                "regex": "(?:ASUS_)?(?:I001D[ABCE]?|ZS660KL)",
                "model": "ROG Phone 2"
            },
            {
                "regex": "(?:ASUS_)?(?:I003DD?|ZS661KS)",
                "model": "ROG Phone 3"
            },
            {
                "regex": "(?:ASUS_)?(?:I005DA)",
                "model": "ROG Phone 5"
            },
            {
                "regex": "ZN220IC",
                "device": "desktop",
                "model": "Zen AiO ZN220IC"
            },
            {
                "regex": "(?:ASUS_)?ZenWatch( 2)?",
                "device": "wearable",
                "model": "ZenWatch$1"
            },
            {
                "regex": "Asus(?:-|;)?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(PadFone(?: [^;/]+)?) Build",
                "model": "$1"
            },
            {
                "regex": "(PadFone(?: [a-z0-9]+)?)",
                "model": "$1"
            },
            {
                "regex": "(?:Asus|Transformer) ((?:Pad |Prime )?TF[0-9a-z]+)",
                "device": "tablet",
                "model": "Transformer $1"
            },
            {
                "regex": "Chromebook Flip (C10[01]PA|C302)",
                "device": "desktop",
                "model": "Chromebook Flip $1"
            }
        ]
    },
    "Audiovox": {
        "regex": "Audiovox|CDM|UTS(?:TARCOM)?\\-|audio(?!book)[a-z0-9\\-]+",
        "device": "smartphone",
        "models": [
            {
                "regex": "Audiovox[_\\-]([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "CDM(?:-)?([a-z0-9]+)",
                "model": "CDM-$1"
            },
            {
                "regex": "UTS(?:TARCOM)?-([a-z0-9\\-]+)",
                "model": "CDM-$1"
            },
            {
                "regex": "audio([a-z0-9\\-]+)",
                "model": "CDM-$1"
            }
        ]
    },
    "AVH": {
        "regex": "Excer[ _]",
        "device": "tablet",
        "models": [
            {
                "regex": "Excer[ _]G5.3",
                "model": "Excer G5.3"
            },
            {
                "regex": "Excer[ _]G5",
                "model": "Excer G5"
            },
            {
                "regex": "Excer[ _]10[ _]PRO",
                "model": "Excer 10 Pro"
            },
            {
                "regex": "Excer[ _]8",
                "model": "Excer 8"
            }
        ]
    },
    "Avvio": {
        "regex": "Avvio[ _]?([a-z0-9\\-]+)|(?:CHIVAS_55|Colombia_2018|Mint_M353)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "CHIVAS_55",
                "model": "Chivas 55"
            },
            {
                "regex": "Mint_M353",
                "model": "Mint M353"
            },
            {
                "regex": "Colombia_2018",
                "model": "Colombia (2018)"
            },
            {
                "regex": "Avvio[ _]PAD",
                "model": "PAD",
                "device": "tablet"
            },
            {
                "regex": "Avvio[ _]?([a-z0-9\\-]+)",
                "model": "$1"
            }
        ]
    },
    "Azumi Mobile": {
        "regex": "Azumi[_ -]|(?:SPEED55|A50_Style_Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Azumi[_ -]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Azumi[_ -]([a-z0-9_]+)",
                "model": "$1"
            },
            {
                "regex": "SPEED55",
                "model": "Speed 5.5\""
            },
            {
                "regex": "A50_Style_Plus",
                "model": "A50 Style Plus"
            }
        ]
    },
    "Barnes & Noble": {
        "regex": "Nook|BN[TR]V[0-9]+",
        "device": "tablet",
        "models": [
            {
                "regex": "Nook([a-z0-9]+)",
                "model": "Nook $1"
            },
            {
                "regex": "Nook[ _]([^/;]+)[ _]Build",
                "model": "Nook $1"
            },
            {
                "regex": "(BN[TR]V[0-9]+)",
                "model": "Nook $1"
            }
        ]
    },
    "BGH": {
        "regex": "(?!Positivo )BGH ([^/;\\)]+)(?: Build|\\))",
        "device": "smartphone",
        "models": [
            {
                "regex": "Y([17]00|2[01]0|1010)",
                "device": "tablet",
                "model": "Y$1"
            },
            {
                "regex": "BGH (\\+Simple|Mini)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Y710 KIDS",
                "device": "tablet",
                "model": "Y710 Kids"
            },
            {
                "regex": "JOY X2",
                "model": "Joy X2"
            },
            {
                "regex": "BGH ([^/;\\)]+)(?: Build|\\))",
                "model": "$1"
            }
        ]
    },
    "Bitel": {
        "regex": "Bitel[ _-]([^/;]+) Build|(?:B(?:840[5-9]|841[0456]|850[2346]|860[146]|9401|950[1-5])|S8402L?|S8501L?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(B(?:840[5789]|841[0456]|850[2346]|860[146]|9401|950[12345])|S8402L?|S8501L?)",
                "model": "$1"
            },
            {
                "regex": "Bitel[ _-]([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Blu": {
        "regex": "BLU[ _]|(?:blu|Dash)[ _]([^/;)]+)(?: Build|[;)])|(?:Studio[ _](5.0K|5.5|View XL|Mega|C 8\\+8|[CGM][ _]HD|[CGX]|SELFIE|Selfie LTE|Touch|M5 Plus|J[1258]|X8 HD)|Advance (4.0 ?[LM]|5.[02](?: HD)?|A4|L[45])|ENERGY (DIAMOND|XL)|Energy X 2|LIFE XL|B110DL|Dash (?:X[2L]|L3)|PURE (?:X[LR]|MINI)|Life One X2|G90(?: PRO)?|Grand M3|GRAND (?:5.5 HD|XL LTE)|R1 (?:HD|PLUS)|Tank Xtreme [45].0|Tank Xtreme Pro|Touchbook M7 Pro|DASH X PLUS|C[456] 2019|BOLD N1|B130DL|Vivo 5 Mini)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Advance (4.0 ?[LM]|4.0|5.[02](?: HD)?|A4|L[54])",
                "model": "Advance $1"
            },
            {
                "regex": "(?:BLU[_ ])?Studio[ _](5.0 C|5.5|View XL|Mega|C 8\\+8|[CG][ _]HD|C|G|Touch|M HD|M5 Plus|J[1258]|X8 HD|X5|XL|X)(?:[);/ ]|$)",
                "model": "Studio $1"
            },
            {
                "regex": "(?:BLU[_ ])?Studio[ _]5.0 ?K(?:[);/ ]|$)",
                "model": "Studio 5.0 K"
            },
            {
                "regex": "STUDIO SELFIE LTE",
                "model": "Studio Selfie LTE"
            },
            {
                "regex": "STUDIO ONE",
                "model": "Studio One"
            },
            {
                "regex": "STUDIO SELFIE ([23]|LTE)",
                "model": "Studio Selfie $1"
            },
            {
                "regex": "STUDIO SELFIE",
                "model": "Studio Selfie"
            },
            {
                "regex": "(?:BLU[_ ])?NEO_ENERGY_MINI",
                "model": "Neo Energy Mini"
            },
            {
                "regex": "ENERGY DIAMOND",
                "model": "Energy Diamond"
            },
            {
                "regex": "ENERGY XL",
                "model": "Energy XL"
            },
            {
                "regex": "Energy X 2",
                "model": "Energy X 2"
            },
            {
                "regex": "ENERGY X PLUS 2",
                "model": "Energy X Plus 2"
            },
            {
                "regex": "ENERGY X PLUS",
                "model": "Energy X Plus"
            },
            {
                "regex": "LIFE XL",
                "model": "Life XL"
            },
            {
                "regex": "DASH[ _]X[ _]PLUS[ _]LTE",
                "model": "Dash X Plus LTE"
            },
            {
                "regex": "DASH X PLUS",
                "model": "Dash X Plus"
            },
            {
                "regex": "DASH 4.5",
                "model": "Dash 4.5"
            },
            {
                "regex": "Dash XL",
                "model": "Dash XL"
            },
            {
                "regex": "PURE (X[LR])",
                "model": "Pure $1"
            },
            {
                "regex": "PURE MINI",
                "model": "Pure Mini"
            },
            {
                "regex": "BOLD N1",
                "model": "Bold N1"
            },
            {
                "regex": "Life One X2",
                "model": "Life One X2"
            },
            {
                "regex": "LIFE ONE X",
                "model": "Life One X"
            },
            {
                "regex": "LIFE ONE",
                "model": "Life One"
            },
            {
                "regex": "LIFE MARK",
                "model": "Life Mark"
            },
            {
                "regex": "NEO X PLUS",
                "model": "Neo X Plus"
            },
            {
                "regex": "NEO (XL|X)",
                "model": "Neo $1"
            },
            {
                "regex": "G90 PRO",
                "model": "G90 Pro"
            },
            {
                "regex": "G90",
                "model": "G90"
            },
            {
                "regex": "GRAND 5.5 HD",
                "model": "Grand 5.5 HD"
            },
            {
                "regex": "Grand X LTE",
                "model": "Grand X LTE"
            },
            {
                "regex": "Grand XL LTE",
                "model": "Grand XL LTE"
            },
            {
                "regex": "Grand M3",
                "model": "Grand M3"
            },
            {
                "regex": "B110DL",
                "model": "View Mega"
            },
            {
                "regex": "B130DL",
                "model": "View 2"
            },
            {
                "regex": "R1 HD",
                "model": "R1 HD"
            },
            {
                "regex": "R1 PLUS",
                "model": "R1 Plus"
            },
            {
                "regex": "C([456]) (2019)",
                "model": "C$1 ($2)"
            },
            {
                "regex": "Tank Xtreme ([45]).0",
                "model": "Tank Xtreme $1.0\""
            },
            {
                "regex": "Tank Xtreme Pro",
                "model": "Tank Xtreme Pro"
            },
            {
                "regex": "VIVO AIR LTE",
                "model": "Vivo Air LTE"
            },
            {
                "regex": "Touchbook G7",
                "model": "Touchbook G7"
            },
            {
                "regex": "(?:BLU[_ ])?VIVO[ _]SELFIE",
                "model": "Vivo Selfie"
            },
            {
                "regex": "(?:BLU[_ ])?Vivo 5 Mini",
                "model": "Vivo 5 Mini"
            },
            {
                "regex": "Touchbook M7 Pro",
                "model": "Touchbook M7 Pro",
                "device": "tablet"
            },
            {
                "regex": "STUDIO 7.0 II",
                "model": "Studio 7.0\" II",
                "device": "tablet"
            },
            {
                "regex": "DASH (L[45] LTE|5.0|L[45]X|L3|X2|[LMX])(?:[);/ ]|$)",
                "model": "Dash $1"
            },
            {
                "regex": "DASH[ _]([^)/;]+)(?: Build|\\))",
                "model": "Dash $1"
            },
            {
                "regex": "blu[ _]([^/;]+)( Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Bluegood": {
        "regex": "BLUEGOOD",
        "device": "smartphone",
        "models": [
            {
                "regex": "V6",
                "model": "V6"
            }
        ]
    },
    "Blackview": {
        "regex": "Blackview|(BV([24-9]000|[46]900|(5[1589]|9[15689])00|6[138]00)(?:[ _](?:PRO))?|(P10000(?:[ _](?:PRO))?)|omega[ _]pro|Alife[ _][PS]1|Heatwave|DM550|BV9700Pro|(?<!Lenovo[_ ])A[68]0(?:Pro)?\\))|A[86]0Plus|BL6000Pro",
        "device": "smartphone",
        "models": [
            {
                "regex": "A60Pro\\)",
                "model": "A60 Pro"
            },
            {
                "regex": "A60\\)",
                "model": "A60"
            },
            {
                "regex": "A80Pro(?:[);/ ]|$)",
                "model": "A80 Pro"
            },
            {
                "regex": "A([86]0)Plus(?:[);/ ]|$)",
                "model": "A$1 Plus"
            },
            {
                "regex": "(BV6000S)",
                "model": "$1"
            },
            {
                "regex": "(BV9700|BL6000)Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "Blackview (A[78]|E7S)",
                "model": "$1"
            },
            {
                "regex": "BV9000Pro-F",
                "model": "BV9000 Pro F"
            },
            {
                "regex": "(BV([48]000|9[56]00|6[83]00))Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "(BV6[13]00)(?:[);/ ]|$)",
                "model": "$1",
                "device": "phablet"
            },
            {
                "regex": "(BV([24-9]000|6900|4900|(5[1589]|9[15689])00)(?:[ _](?:PRO))?)",
                "model": "$1"
            },
            {
                "regex": "(P10000(?:[ _](?:PRO))?)",
                "model": "$1"
            },
            {
                "regex": "omega[ _]pro",
                "model": "Omega Pro"
            },
            {
                "regex": "(Alife[ _][PS]1|DM550|Heatwave)",
                "model": "$1"
            }
        ]
    },
    "Bluboo": {
        "regex": "Bluboo|Xfire|Picasso 4G|Maya Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "Maya Build",
                "model": "Maya"
            },
            {
                "regex": "Xfire2",
                "model": "Xfire 2"
            },
            {
                "regex": "Picasso 4G",
                "model": "Picasso 4G"
            },
            {
                "regex": "Xfire",
                "model": "Xfire"
            },
            {
                "regex": "Bluboo[ _-]?([^;/)]+) Build",
                "model": "$1"
            },
            {
                "regex": "Bluboo[ _-]?([^;/)]+)",
                "model": "$1"
            }
        ]
    },
    "Black Fox": {
        "regex": "BMM[ _-]?(?:44[123]D|441[WB]|44[12]S|431D|533D|54[12]S|541[ABW]|54[123]D|543S|531[ABD]|532 S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BMM443D",
                "model": "B7 Fox+"
            },
            {
                "regex": "BMM441S",
                "model": "B8 Fox"
            },
            {
                "regex": "BMM442S|BMM441B",
                "model": "B8 Fox+"
            },
            {
                "regex": "BMM441W",
                "model": "B8M"
            },
            {
                "regex": "BMM442D",
                "model": "B7"
            },
            {
                "regex": "BMM531D",
                "model": "B6"
            },
            {
                "regex": "BMM531A",
                "model": "B5"
            },
            {
                "regex": "BMM541A",
                "model": "B5+"
            },
            {
                "regex": "BMM543[DS]",
                "model": "B4"
            },
            {
                "regex": "BMM441D",
                "model": "B4 Mini"
            },
            {
                "regex": "BMM541B",
                "model": "B4 Mini NFC"
            },
            {
                "regex": "BMM531B",
                "model": "B4 Mini (2019)"
            },
            {
                "regex": "BMM542D",
                "model": "B3+"
            },
            {
                "regex": "BMM541D",
                "model": "B3"
            },
            {
                "regex": "BMM541W",
                "model": "B7R Fox"
            },
            {
                "regex": "BMM 532 S",
                "model": "BMM 532S"
            },
            {
                "regex": "BMM[ _-]?(533D|431D|54[12]S)(?:[);/ ]|$)",
                "model": "BMM $1"
            }
        ]
    },
    "bogo": {
        "regex": "BO-(FRSP4|LFSPBS5|LFSP4|LFSPSL4|LFSPBS5|LFSPSL6QCI)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BO-LFSP4",
                "model": "LifeStyle 4DC"
            },
            {
                "regex": "BO-LFSPSL4",
                "model": "LifeStyle 4SL"
            },
            {
                "regex": "BO-LFSPBS5",
                "model": "LifeStyle 5BS"
            },
            {
                "regex": "BO-LFSPSL6QCI",
                "model": "LifeStyle 6QC"
            },
            {
                "regex": "BO-(FRSP4)",
                "model": "$1"
            }
        ]
    },
    "Boway": {
        "regex": "(?:sprd-)?(BOWAY)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BOWAY[ _-]([^/;]+)[ _]Build",
                "model": "$1"
            },
            {
                "regex": "([^/;]+) Build/BOWAY",
                "model": "$1"
            },
            {
                "regex": ".*BOWAY[ _-]([^/;]+)/",
                "model": "$1"
            }
        ]
    },
    "Brondi": {
        "regex": "Brondi[ _]|(?:CENTURION|GLADIATOR| GLORY|LUXURY|SENSUELLE|VICTORY)(?:[ _-]?[2-6])?(?:[);/ ]|$)|Surfing Tab|501 SZ",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Brondi[ _])?(620 SZ|730_4G_HD|501 SZ)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "CENTURION(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "CENTURION $1"
            },
            {
                "regex": "GLADIATOR(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "GLADIATOR $1"
            },
            {
                "regex": "GLORY(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "GLORY $1"
            },
            {
                "regex": "LUXURY(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "LUXURY $1"
            },
            {
                "regex": "SENSUELLE(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "SENSUELLE $1"
            },
            {
                "regex": "VICTORY(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "VICTORY $1"
            },
            {
                "regex": "Surfing Tab ([^;/]+) Build",
                "model": "SURFING TAB $1",
                "device": "tablet"
            },
            {
                "regex": "Surfing Tab ([^;/)]+)[;/)]",
                "model": "SURFING TAB $1",
                "device": "tablet"
            }
        ]
    },
    "VGO TEL": {
        "regex": "(?:Venture V(?:[278]|12)|Ocean[_ ][689]|Ocean9L)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Venture V([278]|12)(?:[);/ ]|$)",
                "model": "Venture V$1"
            },
            {
                "regex": "Ocean[_ ]?([689]|9L)(?:[);/ ]|$)",
                "model": "Ocean $1"
            }
        ]
    },
    "Vivo": {
        "regex": "((?:VIV-|BBG-)?(?<!FBCR/)vivo(?!(?:Browser)))|(?:V1730(D[AT]|GA)|V18(18CA|01A0|13B[AT]|18T|09[AT]|1[346][AT]|[13]8[AT]|14A|24[B]?A|2[19][AT]|3[12][AT]|36[AT])|V1731CA|V1732[AT]|V1818CT|V19[01]1[AT]|V1932[AT]|V191[3469][AT]|V192[1348]A|V193[04]A|V194[15]A|V1938CT|V1955A|V1938T|V1730EA|V19[26]2A|V196[35]A|V198[16]A|V1936A[L]?|V19[59]0A|V200[125]A|1819|V201[12]A|V202[0345]C?A|V202[235-9]|V2054A|V203[026]|V204[03]|V2049A|X50 Pro\\+|I1927)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "V1824[B]?A(?:[);/ ]|$)",
                "model": "iQOO"
            },
            {
                "regex": "V1955A(?:[);/ ]|$)",
                "model": "iQOO 3"
            },
            {
                "regex": "I1927(?:[);/ ]|$)",
                "model": "iQOO 3 5G"
            },
            {
                "regex": "V2049A(?:[);/ ]|$)",
                "model": "iQOO 7"
            },
            {
                "regex": "V1922A(?:[);/ ]|$)",
                "model": "iQOO Pro"
            },
            {
                "regex": "V1916A(?:[);/ ]|$)",
                "model": "iQOO Pro 5G"
            },
            {
                "regex": "V1914A(?:[);/ ]|$)",
                "model": "iQOO Neo"
            },
            {
                "regex": "V1981A(?:[);/ ]|$)",
                "model": "iQOO Neo 3"
            },
            {
                "regex": "V1936A[L]?(?:[);/ ]|$)",
                "model": "iQOO Neo 855"
            },
            {
                "regex": "V1986A(?:[);/ ]|$)",
                "model": "iQOO Z1"
            },
            {
                "regex": "V2012A(?:[);/ ]|$)",
                "model": "iQOO Z1x"
            },
            {
                "regex": "V1919A(?:[);/ ]|$)",
                "model": "iQOO Z5x"
            },
            {
                "regex": "V2023A(?:[);/ ]|$)",
                "model": "iQOO U1"
            },
            {
                "regex": "V2024A(?:[);/ ]|$)",
                "model": "iQOO 5"
            },
            {
                "regex": "V2025A(?:[);/ ]|$)",
                "model": "iQOO 5 Pro"
            },
            {
                "regex": "V2025(?:[);/ ]|$)",
                "model": "V20"
            },
            {
                "regex": "V2040(?:[);/ ]|$)",
                "model": "V20 (2021)"
            },
            {
                "regex": "vivo 1805(?:[);/ ]|$)",
                "model": "Nex"
            },
            {
                "regex": "V1923A(?:[);/ ]|$)",
                "model": "Nex 3"
            },
            {
                "regex": "V1924A(?:[);/ ]|$)",
                "model": "Nex 3 5G"
            },
            {
                "regex": "V1950A(?:[);/ ]|$)",
                "model": "Nex 3S"
            },
            {
                "regex": "V1821[AT](?:[);/ ]|$)",
                "model": "Nex Dual Display"
            },
            {
                "regex": "Vivo ONE(?:[);/ ]|$)",
                "model": "One"
            },
            {
                "regex": "V1831[AT](?:[);/ ]|$)",
                "model": "S1"
            },
            {
                "regex": "V1832[AT](?:[);/ ]|$)",
                "model": "S1 Pro"
            },
            {
                "regex": "V1932[AT](?:[);/ ]|$)",
                "model": "S5"
            },
            {
                "regex": "V1962A(?:[);/ ]|$)",
                "model": "S6 5G"
            },
            {
                "regex": "V2020C?A(?:[);/ ]|$)",
                "model": "S7"
            },
            {
                "regex": "V1941A(?:[);/ ]|$)",
                "model": "U3"
            },
            {
                "regex": "V1928A(?:[);/ ]|$)",
                "model": "U3X"
            },
            {
                "regex": "vivo 1804(?:[);/ ]|$)",
                "model": "V11 Pro"
            },
            {
                "regex": "vivo 1806(?:[);/ ]|$)",
                "model": "V11i"
            },
            {
                "regex": "1819(?:[);/ ]|$)",
                "model": "V15"
            },
            {
                "regex": "vivo 1818(?:[);/ ]|$)",
                "model": "V15 Pro"
            },
            {
                "regex": "vivo 1909(?:[);/ ]|$)",
                "model": "V17 Pro"
            },
            {
                "regex": "V2022(?:[);/ ]|$)",
                "model": "V20 SE"
            },
            {
                "regex": "(?:VIV-|BBG-)?vivo[ _]1601(?:[);/ ]|$)",
                "model": "V5"
            },
            {
                "regex": "vivo 1609(?:[);/ ]|$)",
                "model": "V5 Lite"
            },
            {
                "regex": "vivo 1611(?:[);/ ]|$)",
                "model": "V5 Plus"
            },
            {
                "regex": "vivo (1713|1612)(?:[);/ ]|$)",
                "model": "V5s"
            },
            {
                "regex": "vivo 1718(?:[);/ ]|$)",
                "model": "V7"
            },
            {
                "regex": "vivo 1716(?:[);/ ]|$)",
                "model": "V7 Plus"
            },
            {
                "regex": "vivo 1723(?:[);/ ]|$)",
                "model": "V9"
            },
            {
                "regex": "vivo 1727(?:[);/ ]|$)",
                "model": "V9 Youth"
            },
            {
                "regex": "vivo 1721(?:[);/ ]|$)",
                "model": "X20"
            },
            {
                "regex": "X20Plus(?:[);/ ]|$)",
                "model": "X20 Plus"
            },
            {
                "regex": "vivo 1725(?:[);/ ]|$)",
                "model": "X21"
            },
            {
                "regex": "V1814[AT](?:[);/ ]|$)",
                "model": "X21S"
            },
            {
                "regex": "V1809[AT](?:[);/ ]|$)",
                "model": "X23"
            },
            {
                "regex": "V1816[AT](?:[);/ ]|$)",
                "model": "X23"
            },
            {
                "regex": "V18(38|29)[AT](?:[);/ ]|$)",
                "model": "X27"
            },
            {
                "regex": "V1836[AT](?:[);/ ]|$)",
                "model": "X27 Pro"
            },
            {
                "regex": "V1938CT(?:[);/ ]|$)",
                "model": "X30"
            },
            {
                "regex": "V1938T(?:[);/ ]|$)",
                "model": "X30 Pro"
            },
            {
                "regex": "V2001A(?:[);/ ]|$)",
                "model": "X50"
            },
            {
                "regex": "V2005A(?:[);/ ]|$)",
                "model": "X50 Pro"
            },
            {
                "regex": "(?:V2011A|X50 Pro\\+)(?:[);/ ]|$)",
                "model": "X50 Pro Plus"
            },
            {
                "regex": "X9Plus(?:[);/ ]|$)",
                "model": "X9 Plus"
            },
            {
                "regex": "vivo 1902(?:[);/ ]|$)",
                "model": "Y17"
            },
            {
                "regex": "vivo 1915(?:[);/ ]|$)",
                "model": "Y19"
            },
            {
                "regex": "V202[79](?:[);/ ]|$)",
                "model": "Y20"
            },
            {
                "regex": "V2028(?:[);/ ]|$)",
                "model": "Y11s"
            },
            {
                "regex": "V2043(?:[);/ ]|$)",
                "model": "Y20 (2021)"
            },
            {
                "regex": "V2032(?:[);/ ]|$)",
                "model": "Y20i"
            },
            {
                "regex": "V2023(?:[);/ ]|$)",
                "model": "V20 SE"
            },
            {
                "regex": "V1901[AT](?:[);/ ]|$)",
                "model": "Y3"
            },
            {
                "regex": "V1930A(?:[);/ ]|$)",
                "model": "Y3 Standard"
            },
            {
                "regex": "V2036(?:[);/ ]|$)",
                "model": "Y31"
            },
            {
                "regex": "V1934A(?:[);/ ]|$)",
                "model": "Y5s"
            },
            {
                "regex": "V1965A(?:[);/ ]|$)",
                "model": "Y50"
            },
            {
                "regex": "V2030(?:[);/ ]|$)",
                "model": "Y51"
            },
            {
                "regex": "V2054A(?:[);/ ]|$)",
                "model": "Y31s"
            },
            {
                "regex": "vivo 1606(?:[);/ ]|$)",
                "model": "Y53i"
            },
            {
                "regex": "vivo 1603(?:[);/ ]|$)",
                "model": "Y55l"
            },
            {
                "regex": "vivo 1610(?:[);/ ]|$)",
                "model": "Y55s"
            },
            {
                "regex": "vivo 1719(?:[);/ ]|$)",
                "model": "Y65"
            },
            {
                "regex": "vivo 1714(?:[);/ ]|$)",
                "model": "Y69"
            },
            {
                "regex": "V2002A(?:[);/ ]|$)",
                "model": "Y70s"
            },
            {
                "regex": "vivo 1724(?:[);/ ]|$)",
                "model": "Y71"
            },
            {
                "regex": "vivo 1801(?:[);/ ]|$)",
                "model": "Y71i"
            },
            {
                "regex": "V1731CA(?:[);/ ]|$)",
                "model": "Y73"
            },
            {
                "regex": "V1913[AT](?:[);/ ]|$)",
                "model": "Y7s"
            },
            {
                "regex": "vivo 180([38]|8i)(?:[);/ ]|$)",
                "model": "Y81"
            },
            {
                "regex": "vivo 1812(?:[);/ ]|$)",
                "model": "Y81i"
            },
            {
                "regex": "V1732[AT](?:[);/ ]|$)",
                "model": "Y81s"
            },
            {
                "regex": "vivo 1726(?:[);/ ]|$)",
                "model": "Y83 Pro"
            },
            {
                "regex": "V1730EA(?:[);/ ]|$)",
                "model": "Y89"
            },
            {
                "regex": "vivo 181[17](?:[);/ ]|$)",
                "model": "Y91"
            },
            {
                "regex": "V1945A(?:[);/ ]|$)",
                "model": "Y9s"
            },
            {
                "regex": "V2026(?:[);/ ]|$)",
                "model": "Y12s"
            },
            {
                "regex": "vivo 18(16|20)(?:[);/ ]|$)",
                "model": "Y91i"
            },
            {
                "regex": "(V1818[AT]|vivo 181[45])(?:[);/ ]|$)",
                "model": "Y93"
            },
            {
                "regex": "V1818C[AT](?:[);/ ]|$)",
                "model": "Y93s"
            },
            {
                "regex": "vivo 1807(?:[);/ ]|$)",
                "model": "Y95"
            },
            {
                "regex": "V1813[AT](?:[);/ ]|$)",
                "model": "Y97"
            },
            {
                "regex": "V1801A0(?:[);/ ]|$)",
                "model": "Z1"
            },
            {
                "regex": "V1730D[AT](?:[);/ ]|$)",
                "model": "Z1i"
            },
            {
                "regex": "vivo 1917(?:[);/ ]|$)",
                "model": "Z1x"
            },
            {
                "regex": "V1813B[AT](?:[);/ ]|$)",
                "model": "Z3"
            },
            {
                "regex": "V1730GA(?:[);/ ]|$)",
                "model": "Z3x"
            },
            {
                "regex": "V1921A(?:[);/ ]|$)",
                "model": "Z5"
            },
            {
                "regex": "V1911A(?:[);/ ]|$)",
                "model": "Z5x"
            },
            {
                "regex": "V1990A(?:[);/ ]|$)",
                "model": "Z5x (2020)"
            },
            {
                "regex": "V1963A(?:[);/ ]|$)",
                "model": "Z6"
            },
            {
                "regex": "(?:VIV-|BBG-)?vivo[ _]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:VIV-|BBG-)?vivo[ _]([^);/]+)(?:[);/]|$)",
                "model": "$1"
            }
        ]
    },
    "Vinsoc": {
        "regex": "(XA Pro) Build",
        "device": "smartphone",
        "model": "$1"
    },
    "Bird": {
        "regex": "BIRD[\\-. _]([^;/]+)",
        "device": "feature phone",
        "models": [
            {
                "regex": "BIRD[\\-. _]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "BIRD[\\-. _]([^;/]+)",
                "model": "$1"
            }
        ]
    },
    "Becker": {
        "regex": "Becker-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Beeline": {
        "regex": "Beeline",
        "device": "smartphone",
        "models": [
            {
                "regex": "Beeline[_ ]Pro[_ ]([2436])",
                "model": "Pro $1"
            },
            {
                "regex": "Tab (Fast|Pro)",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "Tab ([0-9])",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "Tab",
                "model": "Tab",
                "device": "tablet"
            },
            {
                "regex": "E700",
                "model": "E700"
            },
            {
                "regex": "Smart2",
                "model": "Smart 2"
            },
            {
                "regex": "Smart ([0-9])",
                "model": "Smart $1"
            },
            {
                "regex": "Smart Dual",
                "model": "Smart Dual"
            },
            {
                "regex": "(?:Beeline[_ ])?Fast[_ ]2(?:[);/ ]|$)",
                "model": "Fast 2"
            },
            {
                "regex": "Fast(?:[);/ ]|$)",
                "model": "Fast"
            }
        ]
    },
    "Beetel": {
        "regex": "Beetel ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "BenQ-Siemens": {
        "regex": "BENQ-SIEMENS - ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "BenQ": {
        "regex": "BENQ(?:[ \\-])?([a-z0-9]+)|F52_09(?:[);/ ]|$)",
        "device": "feature phone",
        "models": [
            {
                "regex": "F52_09(?:[);/ ]|$)",
                "model": "F52"
            },
            {
                "regex": "BENQ(?:[ \\-])?([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Blaupunkt": {
        "regex": "Blaupunkt|Soundphone S2|Atlantis[_ ](?:1001A|1010A|A10\\.G40[23])|SLplus02|Discovery[_ ](?:A10_302|111C|1000C|1001A?)|Endeavour[_ ](?:785|101[GLM]|1000|1001|101[03]|1100)|Polaris[_ ]803|BP_6010",
        "device": "tablet",
        "models": [
            {
                "regex": "Discovery[_ ]111C",
                "model": "Discovery 111C"
            },
            {
                "regex": "Discovery[_ ]A10_302",
                "model": "Discovery A10.302"
            },
            {
                "regex": "Discovery[_ ]1000C",
                "model": "Discovery 1000C"
            },
            {
                "regex": "Discovery[_ ]1001A",
                "model": "Discovery 1001A"
            },
            {
                "regex": "Discovery[_ ]1001",
                "model": "Discovery 1001"
            },
            {
                "regex": "Soundphone S2",
                "model": "Soundphone S2"
            },
            {
                "regex": "Endeavour[_ ](101[GLM]|785|100[01]|101[03]|1100)",
                "model": "Endeavour $1"
            },
            {
                "regex": "Polaris[_ ](803)",
                "model": "Polaris $1"
            },
            {
                "regex": "Atlantis[_ ](1001A|1010A|A10\\.G40[23])",
                "model": "Atlantis $1"
            },
            {
                "regex": "SLplus02",
                "model": "SL Plus 02"
            },
            {
                "regex": "(BP_6010)",
                "model": "$1"
            },
            {
                "regex": "Blaupunkt[_ ](SL[_ ]0[124]|SM[_ ]0[12])",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "(4K Android TV)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Bmobile": {
        "regex": "Bmobile[_ ]|AX-?(?:[1-9][0-9]{2,3}[eEO+]?|7OO)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AX-?([1-9][0-9]{2,3}[eEO+]?)",
                "model": "AX$1"
            },
            {
                "regex": "AX7OO",
                "model": "AX700"
            },
            {
                "regex": "Bmobile[_ ]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Bmobile[_ ]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "bq": {
        "regex": "Aquaris|bq [^/;]+ Build|BQS[-_]([0-9]{4})|(BQ(ru)?[_ -][0-9]{3,4})|BQ5059|BQ1008G|BQru_BQru-",
        "device": "smartphone",
        "models": [
            {
                "regex": "BQ(?:ru)?-(?:5209L|5044)(?:[);/ ]|$)",
                "model": "Strike LTE"
            },
            {
                "regex": "BQ(?:ru)?-(?:6035L)(?:[);/ ]|$)",
                "model": "Strike Power Max"
            },
            {
                "regex": "BQ(?:ru)?-(?:5535L)(?:[);/ ]|$)",
                "model": "Strike Power Plus"
            },
            {
                "regex": "BQ(S|ru)?-(?:5070|6040L)(?:[);/ ]|$)",
                "model": "Magic"
            },
            {
                "regex": "BQ(S|ru)?-(?:6424L)(?:[);/ ]|$)",
                "model": "Magic O"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5730L)(?:[);/ ]|$)",
                "model": "Magic C"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5731L)(?:[);/ ]|$)",
                "model": "Magic S"
            },
            {
                "regex": "BQ(?:S|ru)?-5745L(?:[);/ ]|$)",
                "model": "Clever"
            },
            {
                "regex": "BQ(?:S|ru)?-5533G(?:[);/ ]|$)",
                "model": "Fresh"
            },
            {
                "regex": "BQ(?:S|ru)?-5031G(?:[);/ ]|$)",
                "model": "Fun"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5732L)(?:[);/ ]|$)",
                "model": "Aurora SE"
            },
            {
                "regex": "BQ(?:S|ru)?-6430L(?:[);/ ]|$)",
                "model": "Aurora"
            },
            {
                "regex": "BQ(?:S|ru)?-6630L(?:[);/ ]|$)",
                "model": "Magic L"
            },
            {
                "regex": "BQ-9011[G]?(?:[);/ ]|$)",
                "model": "Vision",
                "device": "tablet"
            },
            {
                "regex": "BQ-8068L(?:[);/ ]|$)",
                "model": "Hornet Plus Pro"
            },
            {
                "regex": "BQ-8067L",
                "model": "Hornet Plus",
                "device": "tablet"
            },
            {
                "regex": "BQ-8052G",
                "model": "BQ-8052G",
                "device": "tablet"
            },
            {
                "regex": "BQ-8041L",
                "model": "Art",
                "device": "tablet"
            },
            {
                "regex": "BQ-7084G",
                "model": "Simple",
                "device": "tablet"
            },
            {
                "regex": "BQ-7061G",
                "model": "Andros",
                "device": "tablet"
            },
            {
                "regex": "BQ(ru)?-(7082)",
                "model": "Armor",
                "device": "tablet"
            },
            {
                "regex": "BQ-7051G",
                "model": "Elba",
                "device": "tablet"
            },
            {
                "regex": "BQ-7036L",
                "model": "Hornet",
                "device": "tablet"
            },
            {
                "regex": "BQ-7022(G)?",
                "model": "Canion",
                "device": "tablet"
            },
            {
                "regex": "BQ-7021G",
                "model": "Hit",
                "device": "tablet"
            },
            {
                "regex": "BQ-7010G",
                "model": "Max",
                "device": "tablet"
            },
            {
                "regex": "BQ-7006G",
                "model": "Union",
                "device": "tablet"
            },
            {
                "regex": "BQ-7003",
                "model": "Jamaica",
                "device": "tablet"
            },
            {
                "regex": "BQ-6200L|BQ-6000L",
                "model": "Aurora"
            },
            {
                "regex": "BQ-6631G",
                "model": "Surf"
            },
            {
                "regex": "BQ-6022G",
                "model": "Aura"
            },
            {
                "regex": "BQ(ru)?[ -]6015L",
                "model": "Universe"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5525|6030G|6010G)",
                "model": "Practic"
            },
            {
                "regex": "BQ-6001L|BQ-6050",
                "model": "Jumbo"
            },
            {
                "regex": "BQ-5707G(?:[);/ ]|$)",
                "model": "Next Music"
            },
            {
                "regex": "BQ-5702(?:[);/ ]|$)",
                "model": "Spring"
            },
            {
                "regex": "BQ-5700L(?:[);/ ]|$)",
                "model": "Space X"
            },
            {
                "regex": "BQ-(?:5591|551[89]G)(?:[);/ ]|$)",
                "model": "Jeans"
            },
            {
                "regex": "BQ-5522",
                "model": "Next"
            },
            {
                "regex": "BQ-5520L(?:[);/ ]|$)",
                "model": "Silk"
            },
            {
                "regex": "BQ-5519L(?:[);/ ]|$)",
                "model": "Fast Plus"
            },
            {
                "regex": "BQ-5540L(?:[);/ ]|$)",
                "model": "Fast Pro"
            },
            {
                "regex": "BQ-5517L(?:[);/ ]|$)",
                "model": "Twin Pro"
            },
            {
                "regex": "BQ-5516L(?:[);/ ]|$)",
                "model": "Twin"
            },
            {
                "regex": "BQS-5515(?:[);/ ]|$)",
                "model": "Wide"
            },
            {
                "regex": "BQ-5515[L]?(?:[);/ ]|$)",
                "model": "Fast"
            },
            {
                "regex": "BQ-(?:5512L|5528L)(?:[);/ ]|$)",
                "model": "Strike Forward"
            },
            {
                "regex": "BQ-5511L(?:[);/ ]|$)",
                "model": "Bliss"
            },
            {
                "regex": "BQS[_ ]5505(?:[);/ ]|$)",
                "model": "Amsterdam"
            },
            {
                "regex": "BQ(?:ru)?-5510(?:[);/ ]|$)",
                "model": "Strike Power Max 4G"
            },
            {
                "regex": "BQ(?:ru)?-(?:5521|5594)(?:[);/ ]|$)",
                "model": "Strike Power Max"
            },
            {
                "regex": "BQ-5508L(?:[);/ ]|$)",
                "model": "Next LTE"
            },
            {
                "regex": "BQ-5507L(?:[);/ ]|$)",
                "model": "Iron Max"
            },
            {
                "regex": "BQ(?:ru)?-5504(?:[);/ ]|$)",
                "model": "Strike Selfie Max"
            },
            {
                "regex": "BQ(?:ru)?-5503(?:[);/ ]|$)",
                "model": "Nice 2"
            },
            {
                "regex": "BQ(?:ru)?-6045L(?:[);/ ]|$)",
                "model": "Nice"
            },
            {
                "regex": "BQ(?:ru)?-4030G(?:[);/ ]|$)",
                "model": "Nice Mini"
            },
            {
                "regex": "BQS-5502(?:[);/ ]|$)",
                "model": "Hammer"
            },
            {
                "regex": "BQS-5501(?:[);/ ]|$)",
                "model": "Kawasaki"
            },
            {
                "regex": "BQS-5500(?:[);/ ]|$)",
                "model": "Vancouver"
            },
            {
                "regex": "BQ-5500L(?:[);/ ]|$)",
                "model": "Advance"
            },
            {
                "regex": "BQ-5302G(?:[);/ ]|$)",
                "model": "Velvet 2"
            },
            {
                "regex": "BQ-5301(?:[);/ ]|$)",
                "model": "Strike View"
            },
            {
                "regex": "BQ-5300G(?:[);/ ]|$)",
                "model": "Velvet View"
            },
            {
                "regex": "BQ(ru|S)?-(?:5211|5020)(?:[);/ ]|$)",
                "model": "Strike"
            },
            {
                "regex": "BQ-5206L(?:[);/ ]|$)",
                "model": "Balance"
            },
            {
                "regex": "BQ(?:ru|S)?-(?:5204|5050)(?:[);/ ]|$)",
                "model": "Strike Selfie"
            },
            {
                "regex": "BQ(?:ru)?-5203(?:[);/ ]|$)",
                "model": "Vision"
            },
            {
                "regex": "BQ(?:ru)?-5202(?:[);/ ]|$)",
                "model": "Space Lite"
            },
            {
                "regex": "BQ(?:ru)?-5201(?:[);/ ]|$)",
                "model": "Space"
            },
            {
                "regex": "BQ-5082(?:[);/ ]|$)",
                "model": "Sense 2"
            },
            {
                "regex": "BQ-5045L(?:[);/ ]|$)",
                "model": "Wallet"
            },
            {
                "regex": "BQ-5047L(?:[);/ ]|$)",
                "model": "Like"
            },
            {
                "regex": "BQ-5071(?:[);/ ]|$)",
                "model": "Belief"
            },
            {
                "regex": "BQ[S]?-(?:5065|5340)(?:[);/ ]|$)",
                "model": "Choice"
            },
            {
                "regex": "BQ(?:S|ru)?-5046L(?:[);/ ]|$)",
                "model": "Choice LTE"
            },
            {
                "regex": "BQ(?:ru)?-?(?:5059|5514G)(?:[);/ ]|$)",
                "model": "Strike Power"
            },
            {
                "regex": "(?:BQru_)?BQ(?:ru)?-5058(?:[);/ ]|$)",
                "model": "Strike Power Easy"
            },
            {
                "regex": "BQ(?:ru)?-5057(?:[);/ ]|$)",
                "model": "Strike 2"
            },
            {
                "regex": "BQ[S]?-(?:5056|5030)(?:[);/ ]|$)",
                "model": "Fresh"
            },
            {
                "regex": "BQ-6042l(?:[);/ ]|$)",
                "model": "Magic E"
            },
            {
                "regex": "BQS-5055(?:[);/ ]|$)",
                "model": "Turbo Plus"
            },
            {
                "regex": "BQ(?:ru)?-5054(?:[);/ ]|$)",
                "model": "Crystal"
            },
            {
                "regex": "BQ-5052(?:[);/ ]|$)",
                "model": "Sense"
            },
            {
                "regex": "BQ[S]?-5045(?:[);/ ]|$)",
                "model": "Fast"
            },
            {
                "regex": "BQ(?:ru)?-(?:5037|5514L)(?:[);/ ]|$)",
                "model": "Strike Power 4G"
            },
            {
                "regex": "BQ(?:ru)?-5035(?:[);/ ]|$)",
                "model": "Velvet"
            },
            {
                "regex": "BQ(?:ru)?-5033(?:[);/ ]|$)",
                "model": "Shark"
            },
            {
                "regex": "BQ-5541L(?:[);/ ]|$)",
                "model": "Shark Rush"
            },
            {
                "regex": "BQ-5032(?:[);/ ]|$)",
                "model": "Element"
            },
            {
                "regex": "BQS-5025(?:[);/ ]|$)",
                "model": "High Way"
            },
            {
                "regex": "BQ(?:ru)?-5022(?:[);/ ]|$)",
                "model": "Bond"
            },
            {
                "regex": "BQ-5015L(?:[);/ ]|$)",
                "model": "First"
            },
            {
                "regex": "BQ-5016G(?:[);/ ]|$)",
                "model": "Choice"
            },
            {
                "regex": "BQ-5012L(?:[);/ ]|$)",
                "model": "Rich"
            },
            {
                "regex": "BQ-5521L(?:[);/ ]|$)",
                "model": "Rich Max"
            },
            {
                "regex": "BQS-5011(?:[);/ ]|$)",
                "model": "Monte Carlo"
            },
            {
                "regex": "BQ-5010G(?:[);/ ]|$)",
                "model": "Spot"
            },
            {
                "regex": "BQ-5000G(?:[);/ ]|$)",
                "model": "Velvet Easy"
            },
            {
                "regex": "BQS-5010(?:[);/ ]|$)",
                "model": "Prague"
            },
            {
                "regex": "BQ-5009L(?:[);/ ]|$)",
                "model": "Trend"
            },
            {
                "regex": "BQS-500[59](?:[);/ ]|$)",
                "model": "Sydney"
            },
            {
                "regex": "BQ-5008L(?:[);/ ]|$)",
                "model": "Brave"
            },
            {
                "regex": "BQ-5007L(?:[);/ ]|$)",
                "model": "Iron"
            },
            {
                "regex": "BQS-5006(?:[);/ ]|$)",
                "model": "Los Angeles"
            },
            {
                "regex": "BQ-(?:5005L|5530L)(?:[);/ ]|$)",
                "model": "Intense"
            },
            {
                "regex": "BQS-5004(?:[);/ ]|$)",
                "model": "Paris"
            },
            {
                "regex": "BQ-5003L(?:[);/ ]|$)",
                "model": "Shark Pro"
            },
            {
                "regex": "BQ-5002G(?:[);/ ]|$)",
                "model": "Fun"
            },
            {
                "regex": "BQS-5002(?:[);/ ]|$)",
                "model": "Colombo"
            },
            {
                "regex": "BQS-5003(?:[);/ ]|$)",
                "model": "Colombo II"
            },
            {
                "regex": "BQ-5001L(?:[);/ ]|$)",
                "model": "Contact"
            },
            {
                "regex": "BQS-5001(?:[);/ ]|$)",
                "model": "Milan"
            },
            {
                "regex": "BQ(?:ru|S)?-5000(?:[);/ ]|$)",
                "model": "Tokyo"
            },
            {
                "regex": "BQS-4800(?:[);/ ]|$)",
                "model": "Blade"
            },
            {
                "regex": "BQS-4707(?:[);/ ]|$)",
                "model": "Montreal"
            },
            {
                "regex": "BQS-4702(?:[);/ ]|$)",
                "model": "Оsaka"
            },
            {
                "regex": "BQS-4701(?:[);/ ]|$)",
                "model": "Venice"
            },
            {
                "regex": "BQ-(?:4585|5011G)(?:[);/ ]|$)",
                "model": "Fox View"
            },
            {
                "regex": "BQ(?:ru)?-4583(?:[);/ ]|$)",
                "model": "Fox Power"
            },
            {
                "regex": "BQS-4570(?:[);/ ]|$)",
                "model": "Drive"
            },
            {
                "regex": "BQS-4560(?:[);/ ]|$)",
                "model": "Golf"
            },
            {
                "regex": "BQS-4555(?:[);/ ]|$)",
                "model": "Turbo"
            },
            {
                "regex": "BQS-4550(?:[);/ ]|$)",
                "model": "Richmond"
            },
            {
                "regex": "BQ(?:ru)?-(?:4526|5004G)(?:[);/ ]|$)",
                "model": "Fox"
            },
            {
                "regex": "BQS-4525(?:[);/ ]|$)",
                "model": "Vienna"
            },
            {
                "regex": "BQS-4516(?:[);/ ]|$)",
                "model": "Singapore"
            },
            {
                "regex": "BQS-4515(?:[);/ ]|$)",
                "model": "Moscow"
            },
            {
                "regex": "BQS-4510(?:[);/ ]|$)",
                "model": "Florence"
            },
            {
                "regex": "BQS-4505(?:[);/ ]|$)",
                "model": "Santiago"
            },
            {
                "regex": "BQS-4503(?:[);/ ]|$)",
                "model": "Dubai"
            },
            {
                "regex": "BQS-4502(?:[);/ ]|$)",
                "model": "Kingston"
            },
            {
                "regex": "BQS-4501 Bristol",
                "model": "Bristol"
            },
            {
                "regex": "BQ-4501G(?:[);/ ]|$)",
                "model": "Fox Easy"
            },
            {
                "regex": "BQ(?:ru)?-4500(?:[);/ ]|$)",
                "model": "Fox LTE"
            },
            {
                "regex": "BQ-4077(?:[);/ ]|$)",
                "model": "Shark Mini"
            },
            {
                "regex": "BQ(?:ru)?-4072(?:[);/ ]|$)",
                "model": "Strike Mini"
            },
            {
                "regex": "BQ(?:ru)?[- ]402[68](?:[);/ ]|$)",
                "model": "Up!"
            },
            {
                "regex": "BQS-4010(?:[);/ ]|$)",
                "model": "Aspen"
            },
            {
                "regex": "BQS-4009(?:[);/ ]|$)",
                "model": "Orleans"
            },
            {
                "regex": "BQS-4008(?:[);/ ]|$)",
                "model": "Shanghai"
            },
            {
                "regex": "BQS-4007(?:[);/ ]|$)",
                "model": "Valencia"
            },
            {
                "regex": "BQS-4005(?:[);/ ]|$)",
                "model": "Seoul"
            },
            {
                "regex": "BQS-4004(?:[);/ ]|$)",
                "model": "Dusseldorf"
            },
            {
                "regex": "BQS-4003(?:[);/ ]|$)",
                "model": "Verona"
            },
            {
                "regex": "BQ-4001G(?:[);/ ]|$)",
                "model": "Cool"
            },
            {
                "regex": "BQS-4001(?:[);/ ]|$)",
                "model": "Oxford"
            },
            {
                "regex": "BQS-3510(?:[);/ ]|$)",
                "model": "Aspen Mini"
            },
            {
                "regex": "BQS-3503(?:[);/ ]|$)",
                "model": "Bombay"
            },
            {
                "regex": "BQ-1085L(?:[);/ ]|$)",
                "model": "Hornet Max Pro",
                "device": "tablet"
            },
            {
                "regex": "BQ-1084L(?:[);/ ]|$)",
                "model": "Hornet Max",
                "device": "tablet"
            },
            {
                "regex": "BQ-1083G(?:[);/ ]|$)",
                "model": "Armor Pro Plus",
                "device": "tablet"
            },
            {
                "regex": "BQ-1082G(?:[);/ ]|$)",
                "model": "Armor Pro",
                "device": "tablet"
            },
            {
                "regex": "BQ-1077L(?:[);/ ]|$)",
                "model": "Armor Pro LTE",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1057L(?:[);/ ]|$)",
                "model": "Passion",
                "device": "tablet"
            },
            {
                "regex": "BQ-1051G(?:[);/ ]|$)",
                "model": "Corsika",
                "device": "tablet"
            },
            {
                "regex": "BQ-1050G(?:[);/ ]|$)",
                "model": "Hawaii",
                "device": "tablet"
            },
            {
                "regex": "BQ[-]?1008G(?:[);/ ]|$)",
                "model": "Grace",
                "device": "tablet"
            },
            {
                "regex": "Aquaris M8",
                "model": "Aquaris M8",
                "device": "tablet"
            },
            {
                "regex": "Aquaris_([AM])4.5",
                "model": "Aquaris $14.5"
            },
            {
                "regex": "BQ(?:ru)?[_ -](?:5590|5740G)(?:[);/ ]|$)",
                "model": "Spring"
            },
            {
                "regex": "BQ[S]?-(?:6016L|5520)(?:[);/ ]|$)",
                "model": "Mercury"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5701L|5060)(?:[);/ ]|$)",
                "model": "Slim"
            },
            {
                "regex": "(BQ-7850|BQ-700[12]G|BQ-8002G|BQ-905[12]G|BQ-9702G|BQ-7056G)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "BQ-8006G(?:[);/ ]|$)",
                "model": "Java",
                "device": "tablet"
            },
            {
                "regex": "BQ-7062G(?:[);/ ]|$)",
                "model": "Fiji",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1081G(?:[);/ ]|$)",
                "model": "Grace 3G",
                "device": "tablet"
            },
            {
                "regex": "BQ-7802G(?:[);/ ]|$)",
                "model": "Luzon",
                "device": "tablet"
            },
            {
                "regex": "BQ-7008G(?:[);/ ]|$)",
                "model": "Clarion",
                "device": "tablet"
            },
            {
                "regex": "BQ-7064G(?:[);/ ]|$)",
                "model": "Fusion",
                "device": "tablet"
            },
            {
                "regex": "BQ-7050G(?:[);/ ]|$)",
                "model": "Malta",
                "device": "tablet"
            },
            {
                "regex": "BQ-7000G(?:[);/ ]|$)",
                "model": "Сharm",
                "device": "tablet"
            },
            {
                "regex": "BQ-7040G(?:[);/ ]|$)",
                "model": "Сharm Plus",
                "device": "tablet"
            },
            {
                "regex": "BQ-7038G(?:[);/ ]|$)",
                "model": "Light Plus",
                "device": "tablet"
            },
            {
                "regex": "BQ-7005G(?:[);/ ]|$)",
                "model": "Maui",
                "device": "tablet"
            },
            {
                "regex": "BQ-7098G(?:[);/ ]|$)",
                "model": "Armor Power",
                "device": "tablet"
            },
            {
                "regex": "BQ-1007(?:[);/ ]|$)",
                "model": "Necker",
                "device": "tablet"
            },
            {
                "regex": "BQ-1045[G]?(?:[);/ ]|$)",
                "model": "Orion",
                "device": "tablet"
            },
            {
                "regex": "BQ-(?:1054L|1020L)(?:[);/ ]|$)",
                "model": "Nexion",
                "device": "tablet"
            },
            {
                "regex": "BQ-7083G(?:[);/ ]|$)",
                "model": "Light",
                "device": "tablet"
            },
            {
                "regex": "BQ-8077L(?:[);/ ]|$)",
                "model": "Exion Plus",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-7083(?:[);/ ]|$)",
                "model": "7083",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1056L(?:[);/ ]|$)",
                "model": "1056L",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1022l(?:[);/ ]|$)",
                "model": "Armor Pro LTE+",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1024L(?:[);/ ]|$)",
                "model": "Exion Pro",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-7081(?:[);/ ]|$)",
                "model": "Charm",
                "device": "tablet"
            },
            {
                "regex": "(?:bq )?(Aquaris[^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "Aquaris (E(4.5|[56])|M(5|10)|U2 Lite|U2|U (Lite|Plus)|V Plus|X5 Plus|X2? Pro|X[25]|[CMUVX])",
                "model": "Aquaris $1"
            },
            {
                "regex": "bq ([^/;]+) Build",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "Bush": {
        "regex": "Bush[ _-]|Bush10Nou",
        "device": "smartphone",
        "models": [
            {
                "regex": "Bush10Nou",
                "device": "tablet",
                "model": "10Nou"
            },
            {
                "regex": "BUSH ([^;/)]+)Tablet(?: Build|[);])",
                "model": "$1Tablet",
                "device": "tablet"
            },
            {
                "regex": "BUSH ([^;/)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "CAGI": {
        "regex": "CAGI-",
        "device": "smartphone",
        "models": [
            {
                "regex": "CAGI-OMEGA",
                "model": "Omega"
            },
            {
                "regex": "CAGI-([a-z0-9_\\-]+)",
                "model": "$1"
            }
        ]
    },
    "Capitel": {
        "regex": "Capitel-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Captiva": {
        "regex": "Captiva[ _-]([^;/)]+)(?: Build|\\))",
        "device": "tablet",
        "model": "Pad $1"
    },
    "Casio": {
        "regex": "(C811|C7[57]1)(?: 4G)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "C751(?:[);/ ]|$)",
                "model": "G'zOne Ravine"
            },
            {
                "regex": "C771(?:[);/ ]|$)",
                "model": "G'zOne Commando"
            },
            {
                "regex": "C811 4G(?:[);/ ]|$)",
                "model": "G'zOne Commando 4G LTE"
            }
        ]
    },
    "Casper": {
        "regex": "CASPER[_ ]|VIA[- _](T7D|A[34]|E3|F[123]|G4|M4|[LS]8|S7|P2|V8C|A1_Plus(?:_64)?|A1(?:_1)?|S[13]0|S|T17_M|T1[07]|T7|T7-3G|T8B|T8D-3G|S1[78])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:CASPER[_ ])?VIA_A1_Plus(?:_64)?",
                "model": "VIA A1 Plus"
            },
            {
                "regex": "(?:CASPER[_ ])?VIA[_ ](G1_Plus|G1|E1|[AE]2|M[123]|V[35689]|V10|G3|V6X|A[34]|E3|F[123]|G4|M4|P2|S|V8C|A1(?:_1)?)(?:[);/ ]|$)",
                "model": "VIA $1"
            },
            {
                "regex": "CASPER_VIA_E1c",
                "model": "VIA E1C"
            },
            {
                "regex": "CASPER_L10_4.5G",
                "model": "L10 4.5G",
                "device": "tablet"
            },
            {
                "regex": "CASPER_(S[23]8)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "VIA[- _](T7|T8D)-3G",
                "model": "VIA $1 3G",
                "device": "tablet"
            },
            {
                "regex": "VIA[- _](T7D|S[13]0|[LS]8|S7|T17_M|T1[07]|T7|T8B|S1[78])(?:[);/ ]|$)",
                "model": "VIA $1",
                "device": "tablet"
            }
        ]
    },
    "Cat": {
        "regex": "Cat ?(tablet|stargate|nova)|B15Q|CAT B35|CAT-B100",
        "device": "tablet",
        "models": [
            {
                "regex": "B15Q",
                "model": "B15Q",
                "device": "smartphone"
            },
            {
                "regex": "CAT B35",
                "model": "B35",
                "device": "smartphone"
            },
            {
                "regex": "Cat ?(?:tablet)? ?((?:Galactica|Nova|StarGate|PHOENIX)[^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "Cat ?tablet",
                "model": "Nova"
            },
            {
                "regex": "CAT-(B100)",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "Carrefour": {
        "regex": "CT(?:10[0123]0|7[12]0|820)(?:W|FR)?(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CT820",
                "model": "Touch Tablet Neo2"
            },
            {
                "regex": "CT(10[0123]0(?:W|FR)?)",
                "model": "CT$1"
            },
            {
                "regex": "CT(7[12]0(?:W|FR)?)",
                "model": "CT$1"
            }
        ]
    },
    "Celkon": {
        "regex": "Celkon|Millennia Hero",
        "device": "smartphone",
        "models": [
            {
                "regex": "Celkon[ _*](C[78]20)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Millennia Hero",
                "model": "Millennia Hero"
            },
            {
                "regex": "Celkon[ _*](CT[^;/]+) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Celkon[ _*]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Celkon[\\. _*]([^;/\\)]+)[\\)/]",
                "model": "$1"
            }
        ]
    },
    "Changhong": {
        "regex": "Changhong",
        "device": "smartphone",
        "models": [
            {
                "regex": "Changhong[ ]?(X1-K|X6|R8|Z9S?|Z1S|S18)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "ChangHong Android TV",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "(?:Opera TV.+)Changhong-([^);/]+)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Cherry Mobile": {
        "regex": "Cherry|Superion S1 DTV|Flare([ _])?(2X|4|A[123]|J[123568]|P[13]|S[4-8]|X2|Y[367]|S Play|HD|LITE|XL|X_V2|Y3s|Tab)(?:[ _](?:Pro|Plus|Max|LTE))?|Fusion Bolt|Omega[_ ](?:Icon 2|Icon Lite 2|lite[_ ][43][Cs]?|HD [45]|HD_Duo)|Spin Max 2|Selfie_Two",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Flare2X)",
                "model": "$1"
            },
            {
                "regex": "Flare[_ ]HD[_ ]([345])",
                "model": "Flare HD $1"
            },
            {
                "regex": "Flare_HD_MAX",
                "model": "Flare HD Max"
            },
            {
                "regex": "FLARE LITE",
                "model": "Flare Lite"
            },
            {
                "regex": "Flare S Play",
                "model": "Flare S Play"
            },
            {
                "regex": "Flare[_ ]J([26])S",
                "model": "Flare J$1s"
            },
            {
                "regex": "Flare_(J2|S7)_Prime",
                "model": "Flare $1 Prime"
            },
            {
                "regex": "Flare_S7_Deluxe",
                "model": "Flare S7 Deluxe"
            },
            {
                "regex": "Flare_S7_Power",
                "model": "Flare S7 Power"
            },
            {
                "regex": "Flare[_ ]Y([367])[_ ]Pro",
                "model": "Flare Y$1 Pro"
            },
            {
                "regex": "Flare XL Plus",
                "model": "Flare XL Plus"
            },
            {
                "regex": "Flare[ _]X[_ ]V2",
                "model": "Flare X V2"
            },
            {
                "regex": "Flare[ _](A2|J3|P1|S[467])[ _]Lite",
                "model": "Flare $1 Lite"
            },
            {
                "regex": "Flare[ _](J[12]|S[57]|Y3|J6)[ _]mini",
                "model": "Flare $1 Mini"
            },
            {
                "regex": "Flare_J2_2018",
                "model": "Flare J2 (2018)"
            },
            {
                "regex": "Flare S4 Max LTE",
                "model": "Flare S4 Max LTE"
            },
            {
                "regex": "Flare[_ ](S[47]|J2)[_ ]Max",
                "model": "Flare $1 Max"
            },
            {
                "regex": "FlareS5LiteDTV",
                "model": "Flare S5 Lite DTV"
            },
            {
                "regex": "Flare[_ ](S[567]|J6)[_ ]Plus",
                "model": "Flare $1 Plus"
            },
            {
                "regex": "FLARE S6 POWER",
                "model": "Flare S6 Power"
            },
            {
                "regex": "Flare(?:[ _])?(4|A[123]|J8 LTE|J[13568]|P[13]|S[4-8]|X2|Y3s|Y7_LTE|Y[673])",
                "model": "Flare $1"
            },
            {
                "regex": "OMEGA HD ([45])",
                "model": "Omega HD $1"
            },
            {
                "regex": "Omega_HD_Duo",
                "model": "Omega HD Duo"
            },
            {
                "regex": "Omega Icon Lite 2",
                "model": "Omega Icon Lite 2"
            },
            {
                "regex": "Omega Icon 2",
                "model": "Omega Icon 2"
            },
            {
                "regex": "Omega[_ ]Lite[_ ](3[Cs]|4)",
                "model": "Omega Lite $1"
            },
            {
                "regex": "Spin Max 2",
                "model": "Spin Max 2"
            },
            {
                "regex": "Selfie_Two",
                "model": "Selfie Two"
            },
            {
                "regex": "(Fusion Bolt|Flare Tab Pro|Flare Tab|Superion S1 DTV)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Cherry(?:[ _]?Mobile)?[ _]?([^/;]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "China Mobile": {
        "regex": "(M812C|1501_M02|9930i|A1303|A309W|M651CY) Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "M651CY",
                "model": "A3"
            },
            {
                "regex": "(M812C|1501_M02|9930i|A1303|A309W)",
                "model": "$1"
            }
        ]
    },
    "Comio": {
        "regex": "Comio|CT701G PLUS|CT701W|GT100",
        "device": "smartphone",
        "models": [
            {
                "regex": "GT100",
                "model": "GT100",
                "device": "tablet"
            },
            {
                "regex": "CT701W",
                "model": "CT701W",
                "device": "tablet"
            },
            {
                "regex": "CT701G PLUS",
                "model": "CT701G Plus",
                "device": "tablet"
            },
            {
                "regex": "Comio[ _-]?([^;/)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Compal": {
        "regex": "Compal-[a-z0-9]+",
        "device": "feature phone",
        "model": "$1"
    },
    "Artel": {
        "regex": "Artel[_ ]|\\w+_ARTEL_\\w+|GAP YOQ(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GAP YOQ(?:[);/ ]|$)",
                "model": "Gap Yo Q"
            },
            {
                "regex": "Artel[_ ](Quadro(?: Pro)?|Tesla|Air|Tomchi|Premium|U3_4G|Z5|Sentinel (?:X 8G|X D5|X)|T10)",
                "model": "$1"
            },
            {
                "regex": "Artel[_ ]Komi3",
                "model": "Komi 3"
            },
            {
                "regex": "Artel[_ ](Star|Nova|Connect|Choice|Style)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(?:\\w+_)?ARTEL_([FVM]5|X[45])_\\w+",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "ComTrade Tesla": {
        "regex": "Tesla|Impulse 7.85 3G|Impulse 10.1 OCTA|Smartphone_6.1|SP(?:6.2|6.2_Lite)|TTL(?:713G|8)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TeslaEvo5.0",
                "model": "Evo 5.0"
            },
            {
                "regex": "(Gravity 9.7 SHD)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(Impulse 7.85 3G)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Impulse 10.1 OCTA",
                "model": "Impulse 10.1\" OCTA",
                "device": "tablet"
            },
            {
                "regex": "Tesla_SP([^/;]+)L Build",
                "model": "Smartphone $1 Lite"
            },
            {
                "regex": "Smartphone_6.1",
                "model": "Smartphone 6.1"
            },
            {
                "regex": "SP6.2_Lite",
                "model": "Smartphone 6.2 Lite"
            },
            {
                "regex": "Tesla_SP([^/;]+) Build",
                "model": "Smartphone $1"
            },
            {
                "regex": "SP([^/;]+) Build",
                "model": "Smartphone $1"
            },
            {
                "regex": "Smartphone ([36])",
                "model": "Smartphone $1"
            },
            {
                "regex": "Tesla_Tablet_785",
                "model": "7.85\"",
                "device": "tablet"
            },
            {
                "regex": "TTH7",
                "model": "H7",
                "device": "tablet"
            },
            {
                "regex": "TTL7 Build",
                "model": "L7",
                "device": "tablet"
            },
            {
                "regex": "Tesla_Tablet_L7_3G",
                "model": "L7 3G",
                "device": "tablet"
            },
            {
                "regex": "(L7.1)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "TTL713G",
                "model": "L7.1 3G",
                "device": "tablet"
            },
            {
                "regex": "(L7 Quad) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(L7 Quad Lite)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "TTL8 Build",
                "model": "L8",
                "device": "tablet"
            },
            {
                "regex": "(L8.1)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "TESLA_TABLET_M7",
                "model": "M7",
                "device": "tablet"
            },
            {
                "regex": "Tesla_Tablet_M8",
                "model": "M8",
                "device": "tablet"
            }
        ]
    },
    "ConCorde": {
        "regex": "ConCorde ([^/;]+) Build|Concorde_Raptor_Z55(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Concorde_(Raptor_Z55)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "ConCorde Tab ?([^/;]+) Build",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "ConCorde ReadMan ?([^/;]+) Build",
                "model": "ReadMan $1",
                "device": "tablet"
            },
            {
                "regex": "ConCorde ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Condor": {
        "regex": "Allure (?:M[13]|X)|Griffe T[2356789]|TFX712G|TRA-901G|TGW[-]?(710G|709)|(?:PGN\\-?[456][012][0-9]|PHS\\-601|PHQ519|PHQ52[056]|TB105L|TB717G|PKT\\-301|Plume (?:H1|L[1-468]|P8|P6 PRO LTE))(?:[);/ ]|$)|CTAB[^/;]+ Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "CTAB([^/;]+) Build",
                "device": "tablet",
                "model": "CTAB $1"
            },
            {
                "regex": "(TGW)-?(710G|709)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1 $2"
            },
            {
                "regex": "(TFX712G|TB105L|TB717G)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(TRA)-(901G)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1 $2"
            },
            {
                "regex": "PHS\\-601",
                "model": "C8"
            },
            {
                "regex": "PGN\\-?403",
                "model": "C4+ Noir"
            },
            {
                "regex": "PGN\\-?404",
                "model": "C7 Mini"
            },
            {
                "regex": "PGN\\-?409",
                "model": "Plume P4"
            },
            {
                "regex": "PKT\\-?301",
                "model": "C2"
            },
            {
                "regex": "PGN\\-?504",
                "model": "C5"
            },
            {
                "regex": "PGN\\-?505",
                "model": "C8S"
            },
            {
                "regex": "PGN\\-?506",
                "model": "C7"
            },
            {
                "regex": "(Allure (?:M[13]|X))",
                "model": "$1"
            },
            {
                "regex": "PGN\\-?507",
                "model": "Allure A9"
            },
            {
                "regex": "PGN\\-?508",
                "model": "C6+"
            },
            {
                "regex": "PGN\\-?509",
                "model": "C6 Pro"
            },
            {
                "regex": "PGN\\-?511",
                "model": "Allure A9 Plus"
            },
            {
                "regex": "PGN\\-?513",
                "model": "Griffe G4"
            },
            {
                "regex": "PHQ519",
                "model": "Griffe G4S"
            },
            {
                "regex": "PHQ520",
                "model": "Griffe G5"
            },
            {
                "regex": "PHQ525",
                "model": "Griffe G6"
            },
            {
                "regex": "PHQ526",
                "model": "Griffe G6 Pro"
            },
            {
                "regex": "PGN\\-?514",
                "model": "Plume P7"
            },
            {
                "regex": "PGN\\-?515",
                "model": "Plume P4 Pro"
            },
            {
                "regex": "PGN\\-?516",
                "model": "Plume P5"
            },
            {
                "regex": "PGN\\-?51[78]",
                "model": "Plume P6"
            },
            {
                "regex": "PGN\\-?521",
                "model": "Griffe G4 Plus"
            },
            {
                "regex": "Griffe T3 ?pro",
                "model": "Griffe T3 Pro"
            },
            {
                "regex": "Griffe T([0-9]) Plus",
                "model": "Griffe T$1 Plus"
            },
            {
                "regex": "Griffe T([0-9])",
                "model": "Griffe T$1"
            },
            {
                "regex": "PGN\\-?522",
                "model": "P6 Plus"
            },
            {
                "regex": "PGN\\-?523",
                "model": "P7 Plus"
            },
            {
                "regex": "PGN\\-?527",
                "model": "Plume P4 Plus"
            },
            {
                "regex": "PGN\\-?528|PLUME P6 PRO LTE",
                "model": "Plume P6 Pro LTE"
            },
            {
                "regex": "PGN\\-?605",
                "model": "Plume P8"
            },
            {
                "regex": "PGN\\-?606",
                "model": "Allure A55"
            },
            {
                "regex": "PGN\\-?607",
                "model": "Allure A100"
            },
            {
                "regex": "PGN\\-?608",
                "model": "Allure A55 Slim"
            },
            {
                "regex": "PGN\\-?609",
                "model": "Allure A100 Lite"
            },
            {
                "regex": "PGN\\-?610",
                "model": "Plume P8 Lite"
            },
            {
                "regex": "PGN\\-?611",
                "model": "Allure A8"
            },
            {
                "regex": "PGN\\-?612",
                "model": "Allure A8 Plus"
            },
            {
                "regex": "PGN\\-?613",
                "model": "Allure A55 Plus"
            },
            {
                "regex": "Plume H1",
                "model": "Plume H1"
            },
            {
                "regex": "Plume L([2468]) Pro",
                "model": "Plume L$1 Pro"
            },
            {
                "regex": "Plume L3 Plus",
                "model": "Plume L3 Plus"
            },
            {
                "regex": "Plume L3 Smart",
                "model": "Plume L3 Smart"
            },
            {
                "regex": "Plume L([1-4])",
                "model": "Plume L$1"
            },
            {
                "regex": "Plume P8 Pro",
                "model": "Plume P8 Pro"
            },
            {
                "regex": "PGN\\-?([0-9]{3})",
                "model": "PGN-$1"
            }
        ]
    },
    "Coolpad": {
        "regex": "(?:YL-)?Coolpad|(?:Cool_9S|1824-S0|8190Q|1831-A0|8676-[AM]01|CP8298_I00|CP3648A|CP8676_I0[23]|REVVLPLUS C3701A|VCR-[AI]0|C105-E0|C106-[79]| C106|MTS-T0|cp3705A[S]?|ORL-C0|DLS-E0|8298-M02|5560S)(?:[);/ ]|$)|(8295|5860S) Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "VCR-[AI]0",
                "model": "Cool Play 6"
            },
            {
                "regex": "1831-A0(?:[);/ ]|$)",
                "model": "Cool Play C7"
            },
            {
                "regex": "REVVLPLUS C3701A",
                "model": "REVVL Plus",
                "device": "phablet"
            },
            {
                "regex": "8190Q(?:[);/ ]|$)",
                "model": "8190Q"
            },
            {
                "regex": "DLS-E0(?:[);/ ]|$)",
                "model": "N5"
            },
            {
                "regex": "1824-S0(?:[);/ ]|$)",
                "model": "N5C"
            },
            {
                "regex": "CP3705A[S]?(?:[);/ ]|$)",
                "model": "Legacy"
            },
            {
                "regex": "CP3648A(?:[);/ ]|$)",
                "model": "Legacy S"
            },
            {
                "regex": "MTS-T0(?:[);/ ]|$)",
                "model": "N2M"
            },
            {
                "regex": "C106-[79](?:[);/ ]|$)",
                "model": "Cool 1"
            },
            {
                "regex": "C105-E0(?:[);/ ]|$)",
                "model": "Cool S1"
            },
            {
                "regex": "ORL-C0(?:[);/ ]|$)",
                "model": "Cool 9"
            },
            {
                "regex": "Cool_9S(?:[);/ ]|$)",
                "model": "Cool 9S"
            },
            {
                "regex": "5560S(?:[);/ ]|$)",
                "model": "Arise"
            },
            {
                "regex": "(5860S|8295) Build",
                "model": "$1"
            },
            {
                "regex": "CP8676_I02(?:[);/ ]|$)",
                "model": "Note 3"
            },
            {
                "regex": "CP8676_I03(?:[);/ ]|$)",
                "model": "Note 3 Plus"
            },
            {
                "regex": "CP8298_I00(?:[);/ ]|$)",
                "model": "Note 3 Lite"
            },
            {
                "regex": "(8676-[AM]01|8298-M02)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:YL-)?Coolpad[ _\\-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:YL-)?Coolpad[ _\\-]?([a-z0-9\\-]+)",
                "model": "$1"
            }
        ]
    },
    "Clarmin": {
        "regex": "Clarmin",
        "device": "smartphone",
        "models": [
            {
                "regex": "Clarmin[_ ](B[65]|C1)",
                "model": "$1"
            }
        ]
    },
    "CORN": {
        "regex": "CORN ",
        "device": "smartphone",
        "models": [
            {
                "regex": "CORN R20",
                "model": "R20"
            }
        ]
    },
    "Cosmote": {
        "regex": "Cosmote",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cosmote_My_mini_Tab",
                "device": "tablet",
                "model": "My Mini Tab"
            }
        ]
    },
    "Cricket": {
        "regex": "Cricket-([a-z0-9]+)|U705AC(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "U705AC",
                "model": "Ovation"
            },
            {
                "regex": "Cricket-([a-z0-9]+)",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "Crius Mea": {
        "regex": "(Q7A\\+?)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Crosscall": {
        "regex": "Crosscall|ODYSSEY_Plus|Odyssey S1|Trekker-[MSX][1234]|Action-X3|Core-X3",
        "device": "smartphone",
        "models": [
            {
                "regex": "Action-X3",
                "model": "Action-X3"
            },
            {
                "regex": "Core-X3",
                "model": "Core-X3"
            },
            {
                "regex": "Crosscall ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "ODYSSEY_Plus",
                "model": "ODYSSEY+"
            },
            {
                "regex": "Odyssey S1",
                "model": "ODYSSEY S1"
            },
            {
                "regex": "Trekker-([MSX][1234](?: Core)?)",
                "model": "Trekker-$1"
            }
        ]
    },
    "AllDocube": {
        "regex": "(?:T1001XS?|T1006S?|iPlay_[24]0|U1006H?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "T1001XS(?:[);/ ]|$)",
                "model": "M5XS"
            },
            {
                "regex": "T1006S(?:[);/ ]|$)",
                "model": "M5S"
            },
            {
                "regex": "T1006(?:[);/ ]|$)",
                "model": "M5"
            },
            {
                "regex": "T1001X(?:[);/ ]|$)",
                "model": "M5X"
            },
            {
                "regex": "U1006H?(?:[);/ ]|$)",
                "model": "iPlay 10 Pro 10.1\""
            },
            {
                "regex": "iPlay_([24]0)(?:[);/ ]|$)",
                "model": "iPlay $1"
            }
        ]
    },
    "Cube": {
        "regex": "(<!myPhone ?)Cube|(U[0-9]+GT|K8GT)|(?:T8-PLUSM?S?|T8PLUSML|I1-TF[BD]?|I1-TC|i1002S|Iwork10 Flagship|iwork10 Pro)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "U27GT",
                "model": "Talk 8"
            },
            {
                "regex": "(?:T8-PLUSM?S?|T8PLUSML)(?:[);/ ]|$)",
                "model": "T8 Ultimate"
            },
            {
                "regex": "U55GT",
                "model": "Talk 79"
            },
            {
                "regex": "U65GT",
                "model": "Talk 9X"
            },
            {
                "regex": "I1-TF[BD]?(?:[);/ ]|$)",
                "model": "iWork 8 Air"
            },
            {
                "regex": "I1-TC(?:[);/ ]|$)",
                "model": "iWork 8 Ultimate"
            },
            {
                "regex": "(?:i1002S|iwork10 Pro)(?:[);/ ]|$)",
                "model": "iWork 10 Pro"
            },
            {
                "regex": "Iwork10 Flagship(?:[);/ ]|$)",
                "model": "iWork 10 Flagship"
            },
            {
                "regex": "(U[0-9]+GT[^;/]*) Build",
                "model": "$1"
            },
            {
                "regex": "(U[0-9]+GT(?:[0-9]|[\\-_][a-z]+)?)",
                "model": "$1"
            },
            {
                "regex": "(K8GT)",
                "model": "$1"
            }
        ]
    },
    "CUBOT": {
        "regex": "CUBOT|RAINBOW 2|KING_KONG_3|ZORRO 001|KINGKONG[_ ]MINI2?|KING KONG CS|(?<!QUMO )QUEST(?!(?:[0-9]|\\s[0-9]))(?: LITE)?|NOTE 20 PRO",
        "device": "smartphone",
        "models": [
            {
                "regex": "CHEETAH 2",
                "model": "Cheetah 2"
            },
            {
                "regex": "RAINBOW 2",
                "model": "Rainbow 2"
            },
            {
                "regex": "RAINBOW",
                "model": "Rainbow"
            },
            {
                "regex": "DINOSAUR",
                "model": "Dinosaur"
            },
            {
                "regex": "KINGKONG MINI2",
                "model": "King Kong Mini 2"
            },
            {
                "regex": "KINGKONG_MINI",
                "model": "King Kong Mini"
            },
            {
                "regex": "KING_KONG_3",
                "model": "King Kong 3"
            },
            {
                "regex": "KING KONG CS",
                "model": "King Kong CS"
            },
            {
                "regex": "KING KONG",
                "model": "King Kong"
            },
            {
                "regex": "QUEST LITE",
                "model": "Quest Lite"
            },
            {
                "regex": "QUEST",
                "model": "Quest"
            },
            {
                "regex": "ZORRO 001",
                "model": "Zorro 001"
            },
            {
                "regex": "CUBOT[ _]Echo",
                "model": "Echo"
            },
            {
                "regex": "CUBOT[ _]MANITO",
                "model": "Manito"
            },
            {
                "regex": "CUBOT[ _]MAGIC",
                "model": "Magic"
            },
            {
                "regex": "CUBOT[ _]MAX",
                "model": "Max"
            },
            {
                "regex": "NOTE Plus",
                "model": "Note Plus"
            },
            {
                "regex": "NOTE 20 PRO",
                "model": "Note 20 Pro"
            },
            {
                "regex": "CUBOT[_ ]NOTE[_ ]S",
                "model": "Note S"
            },
            {
                "regex": "CUBOT_NOVA",
                "model": "Nova"
            },
            {
                "regex": "CUBOT_POWER",
                "model": "Power"
            },
            {
                "regex": "CUBOT_X18_Plus",
                "model": "X18 Plus"
            },
            {
                "regex": "CUBOT[ _](A5|C6W|H3|J3|P7|P20|[RXJ]9|R11|X18)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "CUBOT ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "([^;/]+) Build/CUBOT",
                "model": "$1"
            }
        ]
    },
    "Clout": {
        "regex": "Hind[ _]5\\.1|X417[ _]Amaze|X418[ _]Zest|X421[ _]Nova|X422[ ]Exotic|X425[ _]Shavit|X428[ _]Astute",
        "device": "smartphone",
        "models": [
            {
                "regex": "Hind[ _]5\\.1",
                "model": "Hind 5.1"
            },
            {
                "regex": "X417[ _]Amaze",
                "model": "X417 Amaze"
            },
            {
                "regex": "X418[ _]Zest",
                "model": "X418 Zest"
            },
            {
                "regex": "X421[ _]Nova",
                "model": "X421 Nova"
            },
            {
                "regex": "X422[ _]Exotic",
                "model": "X422 Exotic"
            },
            {
                "regex": "X425[ _]Shavit",
                "model": "X425 Shavit"
            },
            {
                "regex": "X428[ _]Astute",
                "model": "X428 Astute"
            }
        ]
    },
    "Concord": {
        "regex": "Concord[ _-]|(?:Flyfix 6|C-721|Plus-7_C777|Plus_M19_C779|Plus-9_C778)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "M10",
                "model": "M10"
            },
            {
                "regex": "Flyfix 6",
                "model": "Flyfix 6"
            },
            {
                "regex": "C-721",
                "model": "Flyfix Q",
                "device": "tablet"
            },
            {
                "regex": "Plus[-_]([79]|M19)_(C77[789])(?:[);/ ]|$)",
                "model": "Plus-$1 $2",
                "device": "tablet"
            }
        ]
    },
    "Crescent": {
        "regex": "WING 5|WING9|Venus[ _][14]",
        "device": "smartphone",
        "models": [
            {
                "regex": "WING 5",
                "model": "Wing 5"
            },
            {
                "regex": "WING9",
                "model": "Wing 9"
            },
            {
                "regex": "Venus[ _]([14])",
                "model": "Venus $1"
            }
        ]
    },
    "Cyrus": {
        "regex": "Cyrus[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cyrus[ _-]?([^;/)]+) Build",
                "model": "$1"
            },
            {
                "regex": "Cyrus[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Datang": {
        "regex": "DATANG",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:DATANG[ _-])+([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:DATANG[ _-])+([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Datsun": {
        "regex": "DATSUN",
        "device": "smartphone",
        "models": [
            {
                "regex": "DATSUN_D5500",
                "model": "D5500"
            },
            {
                "regex": "Datsun_D5001",
                "model": "D5001"
            }
        ]
    },
    "Danew": {
        "regex": "Dslide ?([^;/]+) Build|Konnect_?(?:402|50[246]|60[127])|GEODROID_A5",
        "device": "smartphone",
        "models": [
            {
                "regex": "Konnect_?(402|50[246]|60[127])",
                "model": "Konnect $1"
            },
            {
                "regex": "Dslide ?([^;/]+) Build",
                "device": "tablet",
                "model": "DSlide $1"
            },
            {
                "regex": "GEODROID_A5",
                "device": "tablet",
                "model": "Geodroid A5"
            }
        ]
    },
    "Denver": {
        "regex": "(?:TA[CDQ]-[0-9]+)|P(?:.+)TAQ-(?:[0-9]+)|SDQ[_-](?:550[24]4L|52001G|50002G|57004L)",
        "device": "tablet",
        "models": [
            {
                "regex": "P(?:.+)TAQ-(10213GMK2|10172MK3|10242MK2|70242MK2|[0-9]+)(?:[);/ ]|$)",
                "model": "TAQ-$1"
            },
            {
                "regex": "(TA[CDQ]-[0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SDQ[_-](550[24]4L|52001G|50002G|57004L)",
                "device": "smartphone",
                "model": "SDQ-$1"
            }
        ]
    },
    "Dell": {
        "regex": "Dell[^a-z]|Venue|XCD35",
        "device": "smartphone",
        "models": [
            {
                "regex": "XCD35",
                "model": "XCD35"
            },
            {
                "regex": "Venue (8 7840|10 7040|8 3830)",
                "model": "Venue $1",
                "device": "tablet"
            },
            {
                "regex": "(?:Dell )?Venue Build",
                "model": "Venue"
            },
            {
                "regex": "Dell; Venue Pro",
                "model": "Venue Pro"
            },
            {
                "regex": "(OptiPlex (?:3050|7010))",
                "device": "desktop",
                "model": "$1"
            },
            {
                "regex": "(?:Dell )?(Streak|Venue) ?([^/;]*) Build",
                "model": "$1 $2",
                "device": "tablet"
            },
            {
                "regex": "(?:Dell Inc./)?(XPS 13 9360|Latitude 7480)(?:[);/ ]|$)",
                "device": "desktop",
                "model": "$1"
            },
            {
                "regex": "Dell; ((?:Streak|Venue)[^;/\\)]*)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Dell; ([^;/\\)]+)",
                "model": "$1"
            },
            {
                "regex": "Dell[ _\\-]([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Desay": {
        "regex": "Desay",
        "device": "smartphone",
        "models": [
            {
                "regex": "Desay[ _-]?([^;/)]+) Build",
                "model": "$1"
            },
            {
                "regex": "Desay[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "DEXP": {
        "regex": "DEXP|(?:Ursus|Ixion)[ _]([^;/)]+)|H135[ _]Build|Larus_TV1|Ixion(?:ML4.7|ES250)|M150Storm|(?:SENIOR|F4[38]D8000K|VA[12]10|VA170|ML450|MS[56]50|BL[123]50|BS155|BS160|BS[1256]50|AL[12]40|AL[23]50|AS155|AS260|GS15[035]| (?:N280i|P380i|R110|BL160|B450|B340|A1[45]0|A340|AS160|GL[23]55|ES750))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Ixion[_ ]([^;/]+)(?: Build|\\))",
                "model": "Ixion $1"
            },
            {
                "regex": "(ML450|MS[56]50|ES750)(?:[);/ ]|$)",
                "model": "Ixion $1"
            },
            {
                "regex": "IxionES250(?:[);/ ]|$)",
                "model": "Ixion ES250 Rage"
            },
            {
                "regex": "IxionML4.7(?:[);/ ]|$)",
                "model": "Ixion ML 4.7\""
            },
            {
                "regex": "M150Storm(?:[);/ ]|$)",
                "model": "Ixion M150 Storm"
            },
            {
                "regex": "AL250(?:[);/ ]|$)",
                "model": "4.5\" AL250"
            },
            {
                "regex": "AL350(?:[);/ ]|$)",
                "model": "5.0\" AL350"
            },
            {
                "regex": "AS155(?:[);/ ]|$)",
                "model": "5.45\" AS155"
            },
            {
                "regex": "AS260(?:[);/ ]|$)",
                "model": "5.85\" AS260",
                "device": "phablet"
            },
            {
                "regex": "Ursus ([^;/)]+)(?: Build|\\))",
                "model": "Ursus $1",
                "device": "tablet"
            },
            {
                "regex": "(VA[21]10|VA170|R110|N280i|P380i)(?:[);/ ]|$)",
                "model": "Ursus $1",
                "device": "tablet"
            },
            {
                "regex": " (B450|B340|BL160|A340)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SENIOR(?:[);/ ]|$)",
                "model": "Senior"
            },
            {
                "regex": "Larus_TV1",
                "device": "feature phone",
                "model": "Larus_TV1"
            },
            {
                "regex": "H135[ _]Build",
                "model": "Atlas",
                "device": "desktop"
            },
            {
                "regex": "(BL[123]50|BS155|BS160|BS[1256]50|AL[12]40|A1[45]0|GS15[035]|AS160|GL[23]55)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "DEXP[ _]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "DEXP[ _]([^);/]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(F4[38]D8000K)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Dbtel": {
        "regex": "DBTEL(?:[\\-/])?([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Dialog": {
        "regex": "Dialog ?([^;/]+) Build",
        "device": "smartphone",
        "model": "$1"
    },
    "Dicam": {
        "regex": "DICAM-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Digi": {
        "regex": "(?<!FBCR/)Digi[ _]([^);/]+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Digicel": {
        "regex": "DIGICEL",
        "device": "smartphone",
        "models": [
            {
                "regex": "DL810",
                "model": "DL810"
            },
            {
                "regex": "DIGICEL ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Digiland": {
        "regex": "(?:DL1008M|DL(?:1023|9002|[78]006))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "DL1008M",
                "model": "DL1008M"
            },
            {
                "regex": "DL(1023|9002|[78]006)",
                "model": "DL$1"
            }
        ]
    },
    "Digma": {
        "regex": "Digma[_ ]([^;/]+) Build|HIT HT707[10]MG|CITI (?:7 E401 4G|8 E400 4G|ATL 4G|Kids|Octa [178]0|1902 3G|10 E402|Z530 3G)|(CITI[_ ](?:[A-Z0-9]+)[_ ][34]G)[ _][TC][ST](606[32]ML|111[46]ML|11[459]4MG|1117PG|1207MG|1210MG|1195MG|1196ML|3001ML|4024PG|5009PL|5021ML|5026PL|500[67]PG|7052PG|706[56]MG|709[68]PL|7097MG|720[48]MG|7140ML|7141MG|7113PL|7193MG|820[69]MG|7153MG|8139ML|8143MG|8152ML|1050PL|8205PG|7203MG|106[24]ML|1115MG)|HIT 4G|HT7074ML|IDX5|(iDx10|iDx7)|MVM900H(?:WZ|C)|MVM908HCZ|(iDxD8 3G|iDxD10 3G|iDrQ10 3G|iDxD[45]|iDxQ5|iD[nx]D7(?:[_ ]3G)?)|PS604M|PT452E|LINX B510 3G LT5037MG|LINX A452 3G LT4030PG|LINX A453 3G LT4038PG|LINX A420 3G LS4019PG|LINX A450 3G LT4028PG|Linx A400 3G LT4001PG|Linx C500 3G LT5001PG|Linx PS474S|LS504[01]PL|LT40(47|54)MG|PS1043MG|LS405[01]MG|LS5053ML|LT5048MG|HT7071MG|LT5052ML|HT5035PG|HT4039PG|LT4049PG|NS6902QL|NS9797MG|TS7854M|TS1012E 3G|TT1004PG|TT702[045]MG|TT1002MG|TT7026MW|((?:Optima|Platina|Plane)[ _](?:[EM])?(?:[0-9\\.ST]+|Prime)(?:[ _][43]G)?)|(VOX[ _](?:[0-9\\.A-Z]+)[_ ][43]G)",
        "device": "smartphone",
        "models": [
            {
                "regex": "HIT(?: 3G)? HT707[10]MG",
                "model": "HIT 3G",
                "device": "tablet"
            },
            {
                "regex": "iDx5",
                "model": "iDx5"
            },
            {
                "regex": "HT5035PG",
                "model": "HIT Q500 3G"
            },
            {
                "regex": "HT4039PG",
                "model": "HIT Q401 3G"
            },
            {
                "regex": "(VOX[ _](?:[0-9\\.A-Z]+)[_ ][43]G)",
                "model": "$1"
            },
            {
                "regex": "PS604M",
                "model": "Linx 6.0"
            },
            {
                "regex": "LT4049PG",
                "model": "Linx Atom 3G"
            },
            {
                "regex": "LT5048MG",
                "model": "Linx Joy 3G"
            },
            {
                "regex": "LT5052ML",
                "model": "Linx Base 4G"
            },
            {
                "regex": "LT4047MG",
                "model": "Linx Alfa 3G"
            },
            {
                "regex": "LS4050MG",
                "model": "Linx X1 3G"
            },
            {
                "regex": "LS4051MG",
                "model": "Linx X1 Pro 3G"
            },
            {
                "regex": "LT4054MG",
                "model": "Linx Argo 3G"
            },
            {
                "regex": "LS5041PL",
                "model": "Linx Trix 4G"
            },
            {
                "regex": "LS5040PL",
                "model": "Linx Rage 4G"
            },
            {
                "regex": "LS5053ML",
                "model": "Linx Pay 4G"
            },
            {
                "regex": "Linx ([A-Z][0-9]{3}) 3G (?:LT4028PG|LS4019PG|LT4001PG|LT5001PG|LT4038PG|LT5037MG|LT4030PG)",
                "model": "Linx $1 3G"
            },
            {
                "regex": "(Linx PS474S)",
                "model": "$1"
            },
            {
                "regex": "PT452E",
                "model": "Linx 4.5"
            },
            {
                "regex": "CITI ATL 4G CS5029ML",
                "model": "CITI ATL 4G"
            },
            {
                "regex": "(CITI Z530 3G)",
                "model": "$1"
            },
            {
                "regex": "(CITI [A-Z0-9]+ [34]G) C[ST](?:606[32]ML|4024PG|5009PL|5021ML|5026PL)",
                "model": "$1"
            },
            {
                "regex": "TS7854M",
                "model": "Plane 8.1\" 3G",
                "device": "tablet"
            },
            {
                "regex": "PS1043MG",
                "model": "Plane 10.3\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TS1012E 3G",
                "model": "Plane 10.1\" 3G",
                "device": "tablet"
            },
            {
                "regex": "MVM900H(?:WZ|C)",
                "model": "iDx8",
                "device": "tablet"
            },
            {
                "regex": "MVM908HCZ",
                "model": "iDx9",
                "device": "tablet"
            },
            {
                "regex": "(iD(?:xD10|rQ10|xD7)[_ ]3G)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(iDx10|iDx7)",
                "model": "$1"
            },
            {
                "regex": "(iDxD[45]|iDxQ5)",
                "model": "$1"
            },
            {
                "regex": "HIT 4G HT7074ML",
                "model": "HIT 4G",
                "device": "tablet"
            },
            {
                "regex": "CITI[_ ](1902 3G|Kids|8527_4G|Octa [178]0|10 E402 4G|8 E400 4G|7 E401 4G)",
                "model": "CITI $1",
                "device": "tablet"
            },
            {
                "regex": "(CITI[ _](?:[A-Z0-9]+)[ _][34]G)[ _][TC][ST](?:106[24]ML|111[46]ML|1115MG|1117PG|1207MG|1210MG|3001ML|500[67]PG|7052PG|706[567]MG|7097MG|720[48]MG|820[69]MG|11[459]4MG|1195MG|1196ML|3001ML|8152ML|1050PL|709[68]PL|7113PL|7193MG|7216MG|8205PG|7203MG|8143MG|7153MG|7141MG|7140ML)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "iDxD8 3G",
                "model": "D-Plane2 8",
                "device": "tablet"
            },
            {
                "regex": "(iDnD7)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "NS6902QL",
                "model": "Platina 7.2 4G",
                "device": "tablet"
            },
            {
                "regex": "NS9797MG",
                "model": "Platina 7.2 3G",
                "device": "tablet"
            },
            {
                "regex": "TT1004PG",
                "model": "Optima 10.4\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TT1002MG",
                "model": "Optima D 10.4\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TT7025MG",
                "model": "Optima 7.5\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TT7026MW",
                "model": "Optima 7.6\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TT7020MG",
                "model": "Optima 7.3\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TT7024MG",
                "model": "Optima 7.4\" 3G",
                "device": "tablet"
            },
            {
                "regex": "((?:Optima|Platina|Plane)[ _](?:[EM])?(?:[0-9\\.STNM]+|Prime)(?:[ _][43]G)?)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Digma[_ ]([^;/]+) Build",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "DoCoMo": {
        "regex": "DoCoMo|\\;FOMA|KGT/1\\.0",
        "device": "feature phone",
        "models": [
            {
                "regex": "DoCoMo/.+MST.+(SH2101V)",
                "model": "$1"
            },
            {
                "regex": "DoCoMo/[12]\\.0[/ ]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "([a-z0-9]+)(?:_W)?\\;FOMA",
                "model": "$1"
            },
            {
                "regex": "KGT/1\\.0 ([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Doogee": {
        "regex": "DOOGEE[ _-]|Valencia2_Y100_?(?:pro|plus)|Y100_Plus|X5max(?:[_ ]PRO)?|Shoot_[12]|x5_doogee|(KISSME|BIGBOY|COLLO[23]?|DAGGER|DISCOVERY2?|FIND|HOTWIND|LATTE|MAX|MINT|MOON|PIXELS|RAINBOX|TURBO|VALENCIA|VOYAGER2?|TITANS2?)[ -_](DG[0-9]+C?)(?:[);/ ]|$)|(?:BL12000|BL5500[_ ]Lite|X9 Mini|LEO_DG280|Y9Plus|Hitman_DG850|S(?:[568]8|9[056]|59|40)Pro|X95Pro|S40Lite|BL[579]000|N20Pro|(?<!Lenovo )S90C|Ibiza_F2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Valencia2_)?Y100_Plus(?:[);/ ]|$)",
                "model": "Valencia2 Y100 Plus"
            },
            {
                "regex": "Valencia2_Y100pro",
                "model": "Valencia2 Y100 Pro"
            },
            {
                "regex": "LEO_(DG280)",
                "model": "Leo $1"
            },
            {
                "regex": "(BL[579]000|S90C)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "X95Pro(?:[);/ ]|$)",
                "model": "X95 Pro"
            },
            {
                "regex": "N20Pro(?:[);/ ]|$)",
                "model": "N20 Pro"
            },
            {
                "regex": "BL12000 PRO",
                "model": "BL12000 Pro"
            },
            {
                "regex": "BL5500[_ ]Lite",
                "model": "BL5500 Lite"
            },
            {
                "regex": "BL12000",
                "model": "BL12000"
            },
            {
                "regex": "S([568]8|9[056]|59|40)Pro",
                "model": "S$1 Pro"
            },
            {
                "regex": "S40Lite",
                "model": "S40 Lite"
            },
            {
                "regex": "KISSME-DG580",
                "model": "Kissme DG580"
            },
            {
                "regex": "Hitman_DG850",
                "model": "Hitman DG580"
            },
            {
                "regex": "X9 Mini",
                "model": "X9 Mini"
            },
            {
                "regex": "x5_doogee",
                "model": "X5"
            },
            {
                "regex": "Shoot_([12])",
                "model": "Shoot $1"
            },
            {
                "regex": "Ibiza_F2",
                "model": "Ibiza F2"
            },
            {
                "regex": "(X5max(?:[_ ]PRO)?)",
                "model": "$1"
            },
            {
                "regex": "(?:DOOGEE[ _-])?(BIGBOY|COLLO[23]?|DAGGER|DISCOVERY2?|FIND|HOTWIND|LATTE|MAX|MINT|MOON|PIXELS|RAINBOX|TURBO|VALENCIA|Valencia2_Y100pro|VOYAGER2?|TITANS2?)[ -_](DG[0-9]+C?)(?:[);/ ]|$)",
                "model": "$1 $2"
            },
            {
                "regex": "DOOGEE[ _-]([^);/]+) Build",
                "model": "$1"
            },
            {
                "regex": "DOOGEE[ _-]([^);/]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Y9Plus(?:[);/ ]|$)",
                "model": "Y9 Plus"
            }
        ]
    },
    "Doov": {
        "regex": "(?:Doov-)?Doov[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Doov-)?Doov[ _]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:Doov-)?Doov[ _]([^);/]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Dopod": {
        "regex": "Dopod(?: )?([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Doro": {
        "regex": "Doro",
        "device": "smartphone",
        "models": [
            {
                "regex": "Doro[ _-]?([^;/)]+) Build",
                "model": "$1"
            },
            {
                "regex": "Doro[ _-]([0-9a-z]+)",
                "model": "$1"
            }
        ]
    },
    "Dune HD": {
        "regex": "DuneHD|SOLO 4K(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "SOLO 4K(?:[);/ ]|$)",
                "model": "Solo 4k"
            },
            {
                "regex": "DuneHD/\\d.\\d \\([a-z]+__([a-z0-9_-]+);",
                "model": "$1"
            },
            {
                "regex": "DuneHD/\\d.\\d \\(([a-z0-9_-]+);",
                "model": "$1"
            }
        ]
    },
    "DNS": {
        "regex": "(?:DNS|AirTab)[ _\\-]([^;/)]+)|(?:S4505M|S4004M|SD01M)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:DNS[_ ])?(S4505M|S4004M|SD01M|S4502|S4003|S4003)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "AirTab[ _\\-]([^;/]+)(?: Build|[);])",
                "model": "AirTab $1",
                "device": "tablet"
            },
            {
                "regex": "DNS[ _\\-]([^;/]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "E-Boda": {
        "regex": "E-Boda|Eclipse_(?:G400M|G500)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E-Boda ((?:Revo|Izzycomm|Essential|Intelligence|Supreme)[^/;]+) Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Eclipse_(G400M|G500)",
                "model": "Eclipse $1"
            },
            {
                "regex": "E-Boda ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Easypix": {
        "regex": "EasyPad|EasyPhone",
        "device": "smartphone",
        "models": [
            {
                "regex": "(EasyPhone[^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "EasyPad ([^/;)]+)(?: Build|[;)])",
                "model": "EasyPad $1",
                "device": "tablet"
            }
        ]
    },
    "EBEST": {
        "regex": "EBEST",
        "device": "smartphone",
        "models": [
            {
                "regex": "EBEST[ _-]?([^;/)]+) Build",
                "model": "$1"
            },
            {
                "regex": "EBEST[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Echo Mobiles": {
        "regex": "ECHO[ _](HOLI|HORIZON|MAX|MOSS|NOTE|POWER|SMART|DUNE|JAVA|FUSION)|HORIZON_M|Stellar 3G|FEELING",
        "device": "smartphone",
        "models": [
            {
                "regex": "ECHO_HORIZON_LITE",
                "model": "HORIZON Lite"
            },
            {
                "regex": "(HORIZON_M|FEELING)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "STELLAR 3G",
                "model": "STELLAR 3G"
            },
            {
                "regex": "ECHO_SMART_4G",
                "model": "SMART 4G"
            },
            {
                "regex": "ECHO[ _](HOLI|MAX|MOSS|NOTE|POWER|SMART|DUNE|JAVA|FUSION)",
                "model": "$1"
            }
        ]
    },
    "ECS": {
        "regex": "(?:TA10CA3|TM105A?|TR10[CR]S1)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "TA10CA3(?:[);/ ]|$)",
                "model": "TA10CA3"
            },
            {
                "regex": "(TR10[CR]S1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "TM105A(?:[);/ ]|$)",
                "model": "TM105A"
            },
            {
                "regex": "TM105(?:[);/ ]|$)",
                "model": "TM105"
            }
        ]
    },
    "EE": {
        "regex": "Hawk_from_EE",
        "device": "smartphone",
        "models": [
            {
                "regex": "Hawk_from_EE",
                "model": "Hawk"
            }
        ]
    },
    "EKT": {
        "regex": "EK-(?:5040|5336|5540|5937|6020|8680|MII|T7020)",
        "device": "tablet",
        "models": [
            {
                "regex": "EK-(MII|T7020)",
                "model": "EK-$1"
            },
            {
                "regex": "EK-(5040|5336|5540|5937|6020|8680)",
                "device": "smartphone",
                "model": "EK-$1"
            }
        ]
    },
    "Eks Mobility": {
        "regex": "S5LS|X4UPlus",
        "device": "smartphone",
        "models": [
            {
                "regex": "S5LS",
                "model": "S5LS"
            },
            {
                "regex": "X4UPlus",
                "model": "X4U Plus"
            }
        ]
    },
    "Elephone": {
        "regex": "Elephone|P6000( ?Pro| ?Plus|\\+| ?02| 5.0 01)?",
        "device": "smartphone",
        "models": [
            {
                "regex": "Elephone Trunk(?:[);/ ]|$)",
                "model": "Trunk"
            },
            {
                "regex": "P6000(\\+| ?Plus)(?:[);/ ]|$)",
                "model": "P6000 Plus"
            },
            {
                "regex": "P6000 02(?:[);/ ]|$)",
                "model": "P6000 02"
            },
            {
                "regex": "P6000 5.0 01(?:[);/ ]|$)",
                "model": "P6000 01"
            },
            {
                "regex": "P6000 ?Pro(?:[);/ ]|$)",
                "model": "P6000 Pro"
            },
            {
                "regex": "(?:Elephone[ _])?(P[768]000|S2)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Elephone[ _\\-]([^/;]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Element": {
        "regex": "AFTRS",
        "model": "Element 4K (2017)",
        "device": "tv"
    },
    "Elenberg": {
        "regex": "(TAB(?:101|728)[ _]3G|TAB7(?:[03]8|16|40|3[30]))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Ericy": {
        "regex": "Ericy-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Essential": {
        "regex": "PH-1[ )]",
        "device": "smartphone",
        "models": [
            {
                "regex": "PH-1[ )]",
                "model": "PH-1"
            }
        ]
    },
    "E-tel": {
        "regex": "E-tel_i250",
        "device": "smartphone",
        "models": [
            {
                "regex": "E-tel[_ ]i250",
                "model": "i250"
            }
        ]
    },
    "Evercoss": {
        "regex": "EVERCOSS[ _]|(A75A\\*|U50A_PLUS|M50 STAR|A75 MAX)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A75A\\*(?:[);/ ]|$)",
                "model": "A75A Star"
            },
            {
                "regex": "A75 MAX*(?:[);/ ]|$)",
                "model": "A75 Max"
            },
            {
                "regex": "U50A_PLUS(?:[);/ ]|$)",
                "model": "U50A Plus"
            },
            {
                "regex": "M50 STAR(?:[);/ ]|$)",
                "model": "M50 Star"
            },
            {
                "regex": "EVERCOSS[ _](A7[BRLZ]|A65|A74A|A5Z)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Eurostar": {
        "regex": "(ET7002C-H12|Onyx-[13]S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Onyx-([13]S)(?:[);/ ]|$)",
                "model": "Onyx $1"
            },
            {
                "regex": "ET7002C-H12(?:[);/ ]|$)",
                "model": "ePad 4S",
                "device": "tablet"
            }
        ]
    },
    "Eton": {
        "regex": "Eton",
        "device": "smartphone",
        "models": [
            {
                "regex": "Eton[ _-]?([^;/)]+) Build",
                "model": "$1"
            },
            {
                "regex": "Eton[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Essentielb": {
        "regex": "(?:Wooze[_ ]?(?:I55?|I45|X?L)|HEYOU(?:[135]|30))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "HEYOU([135]|30)(?:[);/ ]|$)",
                "model": "HEYou $1"
            },
            {
                "regex": "Wooze[_ ]?((?:I55?|I45|X?L))(?:[);/ ]|$)",
                "model": "Wooze $1"
            }
        ]
    },
    "Facebook": {
        "regex": "PortalTV",
        "device": "tv",
        "model": "Portal TV"
    },
    "Rikomagic": {
        "regex": "MK(80[28][^/;]*) Build",
        "device": "tv",
        "model": "MK$1"
    },
    "Rinno": {
        "regex": "Rinno (R(?:400|505))",
        "device": "smartphone",
        "model": "$1"
    },
    "Riviera": {
        "regex": "RIVIERA ",
        "device": "smartphone",
        "models": [
            {
                "regex": "F23",
                "model": "F23"
            }
        ]
    },
    "Senseit": {
        "regex": "SENSEIT[ _]?([^;/)]+)( Build|\\))",
        "device": "smartphone",
        "model": "$1"
    },
    "Sony": {
        "regex": "Sony(?: ?Ericsson)?|SGP|Xperia|(?:[4-9]0[12])SO|C1[569]0[45]|C2[01]0[45]|C230[45]|C530[236]|C550[23]|C6[56]0[236]|C6616|C68(?:0[26]|[34]3)|C69(?:0[236]|16|43)|D200[45]|D21(?:0[45]|14)|D22(?:0[236]|12|43)|D230[2356]|D240[36]|D25(?:02|33)|D510[236]|D530[36]|D5316|D5322|D5503|D58[03]3|D65(?:0[23]|43|63)|D66[03458]3|D66[14]6|D6708|E(?:20[0345]3|2006|210[45]|2115|2124|230[36]|2312|23[356]3|530[36]|53[3456]3|5506|55[356]3|56[46305][36]|58[02]3|65[35]3|66[0358]3|68[358]3)|I[34]312|I4332|F311[12356]|F331[13]|F321[12356]|F5[13]21|F5122|F813[12]|F833[12]|G312[135]|G311[26]|G322[136]|G3212|G331[123]|G3412|G3416|G342[136]|G823[12]|G834[123]|G8[14]4[12]|H(?:3113|3123|3133|3213|3223|3311|3321|4113|4133|4213|4233|4311|4331|4413|4433|82[167]6|83[12]4|8416|9436)|(?:WT|LT|SO|ST|SK|MK)[0-9]+[a-z]+[0-9]*(?: Build|\\))|X?L39H|XM50[ht]|W960|portalmmm/2\\.0 K|S3[69]h|SOG01|SOL2[2346]|SOV3[1-9]|SOV4[0-3]|X10[ia]v?|E1[05][ai]v?|MT[0-9]{2}[a-z]? Build|SO-0(?:[12]C|[345]D|[234]E|[1-5]F|[1-5]G|[1-4]H|[1-4]J|[1-5]K|1M|[1-3]L)|R800[aix]|J3173|J82[17]0|J9110|J92[16]0|J81[17]0|I[34]113|I3[12]23|I42[19]3|H9493|H8296|H8166|H4493|G2299|LiveWithWalkman|BRAVIA|SGP771|E3 Dual|A001SO|I4193|E6508|SOT31|SO-[45]1A|SO-52A|XQ-A[DT]51|XQ-A[TU]42|XQ-AS[67]2|XQ-A[TSU]52|SOL25|SOG02|A002SO|NW-(A100|Z1000)Series|J3273",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Sony(?:Ericsson)?)?E10[ai]v?",
                "model": "Xperia X10 mini",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U20",
                "model": "Xperia X10 mini pro",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E15[ai]v?",
                "model": "Xperia X8",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(LT15[ai]?v?|SO-01C)",
                "model": "Xperia arc",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT18[ai]v?",
                "model": "Xperia arc S",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?MT11",
                "model": "Xperia neo V",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?MT15",
                "model": "Xperia neo",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?MT27",
                "model": "Xperia Sola",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?MK16[ai]",
                "model": "Xperia pro",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST15[ai]",
                "model": "Xperia mini",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST17[ai]",
                "model": "Xperia active",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-02L",
                "model": "Xperia Ace",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST18[ai]",
                "model": "Xperia ray",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SK17[ai]?",
                "model": "Xperia mini pro",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?X10[ai]v?",
                "model": "Xperia X10",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)M1",
                "model": "Aspen",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?R800",
                "model": "Xperia PLAY",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?WT19|LiveWithWalkman",
                "model": "Live with Walkman",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?CK13i",
                "model": "txt",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?CK15[ai]",
                "model": "txt pro",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F100i",
                "model": "Jalou",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J105",
                "model": "Naite",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J108",
                "model": "Cedar",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J10",
                "model": "Elm",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J20",
                "model": "Hazel",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U10",
                "model": "Aino",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U100",
                "model": "Yari",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U1",
                "model": "Satio",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U5",
                "model": "Vivaz",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U8",
                "model": "Vivaz pro",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?W20",
                "model": "Zylo",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?W100",
                "model": "Spiro",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?W150",
                "model": "Yendo",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?W960",
                "model": "W960",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?WT13",
                "model": "Mix Walkman",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "SO-04F",
                "model": "Xperia A2"
            },
            {
                "regex": "G2299",
                "model": "Xperia R1 Plus"
            },
            {
                "regex": "SO-04G",
                "model": "Xperia A4"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?I(?:4113|31[12]3)",
                "model": "Xperia 10"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J3173(?:[);/ ]|$)",
                "model": "Xperia Ace"
            },
            {
                "regex": "(?:A001SO|XQ-A[TU]52|XQ-AU42|SO-41A|SOV43)(?:[);/ ]|$)",
                "model": "Xperia 10 II"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?I(?:42[19]3|3223)",
                "model": "Xperia 10 Plus"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?I4193",
                "model": "Xperia 10 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:J(?:9110|81[17]0)|SOV40|SO-03L|802SO)",
                "model": "Xperia 1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:SOG01|SO-51A|XQ-AT42|XQ-AT51)(?:[);/ ]|$)",
                "model": "Xperia 1 II"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT22i|Xperia P",
                "model": "Xperia P"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT25i|Xperia V",
                "model": "Xperia V"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J92[16]0",
                "model": "Xperia 5 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:J82[17]0|SO-01M|SOV41|901SO)",
                "model": "Xperia 5"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:SOG02|A002SO|XQ-AS[567]2|SO-52A)",
                "model": "Xperia 5 II"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:SOV42|902SO)",
                "model": "Xperia 8"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J3273",
                "model": "Xperia 8 Lite"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT26ii",
                "model": "Xperia SL"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT26i|Xperia S(?:[);/ ]|$)",
                "model": "Xperia S"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-02C",
                "model": "Xperia arco"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-03D",
                "model": "Xperia arco HD"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT26w",
                "model": "Xperia arco S"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT28[aih]",
                "model": "Xperia ion"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT29i|Xperia TX(?:[);/ ]|$)",
                "model": "Xperia TX"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT30a",
                "model": "Xperia T LTE"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT30p",
                "model": "Xperia T"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST21[ia]2",
                "model": "Xperia tipo dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST21[ia]",
                "model": "Xperia tipo"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST23[ia]",
                "model": "Xperia miro"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST25[ia]",
                "model": "Xperia U"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SOL22",
                "model": "Xperia UL"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST26[ia]",
                "model": "Xperia J"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST27[ia]",
                "model": "Xperia go"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C150[45]",
                "model": "Xperia E"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C160[45]",
                "model": "Xperia E Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E210[45]|E2115|E2124)",
                "model": "Xperia E4"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E20[05]3|E2006",
                "model": "Xperia E4G"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C190[45]",
                "model": "Xperia M"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C200[45]",
                "model": "Xperia M Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C210[45]|S36h",
                "model": "Xperia L"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C230[45]|S39h",
                "model": "Xperia C"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C530[236]|Xperia SP(?:[);/ ]|$)",
                "model": "Xperia SP"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C550[23]",
                "model": "Xperia ZR"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C650[236]|Xperia ZL(?:[);/ ]|$)",
                "model": "Xperia ZL"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SOL25(?:[);/ ]|$)",
                "model": "Xperia ZL2"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:C66(?:0[236]|16)|SO-02E)",
                "model": "Xperia Z"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:C68(?:0[26]|[34]3)|XL39H|SOL24)|Xperia Z Ultra(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Xperia Z Ultra"
            },
            {
                "regex": "Xperia Z(?:[);/ ]|$)",
                "model": "Xperia Z"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D200[45]",
                "model": "Xperia E1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D21(?:0[45]|14)",
                "model": "Xperia E1 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D22(?:0[236]|43)",
                "model": "Xperia E3"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D2212|E3 Dual",
                "model": "Xperia E3 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E20[34]3",
                "model": "Xperia E4g Dual"
            },
            {
                "regex": "H33[12]1",
                "model": "Xperia L2"
            },
            {
                "regex": "H43[13]1",
                "model": "Xperia L2 Dual"
            },
            {
                "regex": "I3312",
                "model": "Xperia L3"
            },
            {
                "regex": "I43[13]2",
                "model": "Xperia L3 Dual"
            },
            {
                "regex": "XQ-AD51",
                "model": "Xperia L4"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D2302",
                "model": "Xperia M2 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D230[356]",
                "model": "Xperia M2"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D240[36]",
                "model": "Xperia M2 Aqua"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E230[36]|E23[35]3)",
                "model": "Xperia M4 Aqua"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E2312|E2363)",
                "model": "Xperia M4 Aqua Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E56[05][36]",
                "model": "Xperia M5"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E56[436]3",
                "model": "Xperia M5 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D2502",
                "model": "Xperia C3 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D2533",
                "model": "Xperia C3"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E53[05]3|E5306",
                "model": "Xperia C4"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E53[0346]3",
                "model": "Xperia C4 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E5506|E5553",
                "model": "Xperia C5 Ultra"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E55[36]3",
                "model": "Xperia C5 Ultra Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D510[236]",
                "model": "Xperia T3"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D530[36]|D5316|XM50[ht])",
                "model": "Xperia T2 Ultra",
                "device": "phablet"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D5322",
                "model": "Xperia T2 Ultra Dual",
                "device": "phablet"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D5503|Xperia Z1 Compact",
                "model": "Xperia Z1 Compact"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:C69(?:0[236]|16|43)|SOL23|L39H|SO-0[12]F)|Xperia Z1(?:[);/ ]|$)",
                "model": "Xperia Z1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D58[03]3|SO-02G)|Xperia Z3 Compact(?:[);/ ]|$)",
                "model": "Xperia Z3 Compact"
            },
            {
                "regex": "Xperia Z2 Tablet Wifi",
                "model": "Xperia Z2 Tablet WiFi",
                "device": "tablet"
            },
            {
                "regex": "SGP561",
                "model": "Xperia Z2 Tablet",
                "device": "tablet"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D65(?:0[23]|43)|SO-03F)|Xperia Z2(?:[);/ ]|$)",
                "model": "Xperia Z2"
            },
            {
                "regex": "D6563",
                "model": "Xperia Z2a"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D66[045]3|D66[14]6|SO-01G|SOL26|401SO)|Xperia Z3(?:[);/ ]|$)",
                "model": "Xperia Z3"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D6633|D6683)",
                "model": "Xperia Z3 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E65[35]3)",
                "model": "Xperia Z3+"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D6708)",
                "model": "Xperia Z3v"
            },
            {
                "regex": "SOV31|402SO|SO-03G",
                "model": "Xperia Z4"
            },
            {
                "regex": "E6508",
                "model": "Xperia Z4v"
            },
            {
                "regex": "SGP771|SOT31|SO-05G",
                "model": "Xperia Z4",
                "device": "tablet"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E58[02]3|SO-02H)",
                "model": "Xperia Z5 Compact"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E66[05]3|SOV32|501SO|SO-01H)",
                "model": "Xperia Z5"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E66[38]3",
                "model": "Xperia Z5 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E68[58]3|SO-03H)",
                "model": "Xperia Z5 Premium"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E6833",
                "model": "Xperia Z5 Premium Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F311[135]",
                "model": "Xperia XA"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F311[26]",
                "model": "Xperia XA Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F321[135]",
                "model": "Xperia XA Ultra"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F321[26]",
                "model": "Xperia XA Ultra Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F833[12]|SOV34|601SO|SO-01J",
                "model": "Xperia XZ"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:701SO|SOV36|G834[123]|SO-01K)",
                "model": "Xperia XZ1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G8441|SO-02K",
                "model": "Xperia XZ1 Compact"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F331[13]",
                "model": "Xperia E5"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G312[135]|G311[26]",
                "model": "Xperia XA1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G341[26]|G342[13]",
                "model": "Xperia XA1 Plus"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G3426",
                "model": "Xperia XA1 Plus Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G322[136]|G3212",
                "model": "Xperia XA1 Ultra"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?H31[123]3",
                "model": "Xperia XA2"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?H41[13]3",
                "model": "Xperia XA2 Dual"
            },
            {
                "regex": "H44[19]3",
                "model": "Xperia XA2 Plus Dual"
            },
            {
                "regex": "H4433",
                "model": "H4433"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?H(?:3213|3223|4213|4233)",
                "model": "Xperia XA2 Ultra"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G823[12]|SOV35|602SO|SO-03J",
                "model": "Xperia XZs"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G814[12]|SO-04[JK]",
                "model": "Xperia XZ Premium"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:H83[12]4|H82[17]6|SOV37|SO-03K|H8296|702SO)",
                "model": "Xperia XZ2"
            },
            {
                "regex": "H8266",
                "model": "Xperia XZ2 Dual"
            },
            {
                "regex": "SO-05K",
                "model": "Xperia XZ2 Compact"
            },
            {
                "regex": "(?:H8166|SOV38)(?:[);/ ]|$)",
                "model": "Xperia XZ2 Premium Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:H(8416|9436|9493)|SO-01L|SOV39|801SO)",
                "model": "Xperia XZ3"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G331[13]",
                "model": "Xperia L1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G3312",
                "model": "Xperia L1 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-04E",
                "model": "Xperia A"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-04D",
                "model": "Xperia GX"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-05D",
                "model": "Xperia SX"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F5121",
                "model": "Xperia X"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F5122",
                "model": "Xperia X Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F5321|SO-02J",
                "model": "Xperia X Compact"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:F8131|502SO|SOV33|SO-04H)",
                "model": "Xperia X Performance"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F8132",
                "model": "Xperia X Performance Dual"
            },
            {
                "regex": "SGP(?:311|312|321)(?:[);/ ]|$)|SO-03E",
                "model": "Xperia Tablet Z",
                "device": "tablet"
            },
            {
                "regex": "SGP712(?:[);/ ]|$)",
                "model": "Xperia Tablet Z4",
                "device": "tablet"
            },
            {
                "regex": "SGP(?:511|512|521)(?:[);/ ]|$)|SO-05F",
                "model": "Xperia Tablet Z2",
                "device": "tablet"
            },
            {
                "regex": "SGP(?:6[124]1|612)(?:[);/ ]|$)",
                "model": "Xperia Tablet Z3 Compact",
                "device": "tablet"
            },
            {
                "regex": "SGPT(?:12|121|122|123|13|131|132|133)(?:[);/ ]|$)",
                "model": "Xperia Tablet S",
                "device": "tablet"
            },
            {
                "regex": "(?:BRAVIA )(2K GB ATV3|4K UR2|4K GB ATV3|4K GB|4K 2015|2015)(?:[);/ ]|$)",
                "model": "Bravia $1",
                "device": "tv"
            },
            {
                "regex": "NW-A100Series",
                "model": "Walkman A100",
                "device": "portable media player"
            },
            {
                "regex": "NW-Z1000Series",
                "model": "Walkman Z1000",
                "device": "portable media player"
            },
            {
                "regex": "SonyBDP|SonyDBV",
                "model": "Blu-ray Player",
                "device": "tv"
            },
            {
                "regex": "(?:Sony-)?(KDL?-?[0-9a-z]+)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "Opera TV Store.*(?:Sony-)([0-9a-z\\-_]+)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "((?:WT|SO|ST|SK|MK)[0-9]+[a-z]*[0-9]*)(?: Build|\\))",
                "model": "$1",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(MT[0-9]{2}[a-z]?)(?:[);/ ]|$)",
                "model": "$1",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "portalmmm/2.0 K([a-z0-9]+)",
                "model": "K$1",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "Sony ?Ericsson?([^/;]*) Build",
                "model": "$1",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "SonyEricsson([CGJKPTWZ][0-9]+[a-z]+)/",
                "model": "$1",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "Sony ?Ericsson ?([a-z0-9\\-]+)",
                "model": "$1",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "Sony (Tablet[^/;]*) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(SGP[^/;]*) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Xperia ([^/;]*Tablet[^/;]*) Build",
                "model": "Xperia $1",
                "device": "tablet"
            },
            {
                "regex": "Xperia ([^;/]+) Build",
                "model": "Xperia $1"
            },
            {
                "regex": "Sony[ -]?([^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "Sony[ -]?([a-z0-9\\-]+)",
                "model": "$1"
            }
        ]
    },
    "Ergo": {
        "regex": "ERGO|(V550[_ ]Vision|B502 Basic|B504[_ ]Unit|A502[_ ]Aurum|A503[ _]Optima|Prime B400|A551 Sky 4G|A553 Power|A555 Universe|Force F500|GoTab GBT9|GoTab Gti8|F501_Magic|V551[ _]Aura|V540_Level|V570_BIG_BEN|B506[_ ]INTRO|A503-Optima|B505_Unit_4G)",
        "device": "smartphone",
        "models": [
            {
                "regex": "F501_Magic",
                "model": "F501 Magic"
            },
            {
                "regex": "B502 Basic",
                "model": "B502 Basic"
            },
            {
                "regex": "A503-Optima",
                "model": "A503 Optima"
            },
            {
                "regex": "B506[_ ]INTRO",
                "model": "B506 Intro"
            },
            {
                "regex": "V550[_ ]Vision",
                "model": "V550 Vision"
            },
            {
                "regex": "B504[_ ]Unit",
                "model": "B504 Unit"
            },
            {
                "regex": "B505_Unit_4G",
                "model": "B505 Unit 4G"
            },
            {
                "regex": "V551[ _]Aura",
                "model": "V551 Aura"
            },
            {
                "regex": "V540_Level",
                "model": "V540 Level"
            },
            {
                "regex": "V570_BIG_BEN",
                "model": "V570 Big Ben"
            },
            {
                "regex": "Ergo F502",
                "model": "F502 Platinum"
            },
            {
                "regex": "(ERGO_)?A500[ _]Best",
                "model": "A500 Best"
            },
            {
                "regex": "(ERGO_)?A550[ _]Maxx",
                "model": "A550 Maxx"
            },
            {
                "regex": "Prime B400",
                "model": "Prime B400"
            },
            {
                "regex": "A502[_ ]Aurum",
                "model": "A502 Aurum"
            },
            {
                "regex": "A503[ _]Optima",
                "model": "A503 Optima"
            },
            {
                "regex": "A551 Sky 4G",
                "model": "A551 Sky 4G"
            },
            {
                "regex": "A553 Power",
                "model": "A553 Power"
            },
            {
                "regex": "A555 Universe",
                "model": "A555 Universe"
            },
            {
                "regex": "ERGO[_ ]A556",
                "model": "A556"
            },
            {
                "regex": "ERGO[_ ]F500",
                "model": "F500"
            },
            {
                "regex": "ERGO[_ ]F501",
                "model": "F501"
            },
            {
                "regex": "B500 First",
                "model": "B500 First"
            },
            {
                "regex": "Force F500",
                "model": "Force F500"
            },
            {
                "regex": "GoTab GBT9",
                "model": "GoTab GBT9",
                "device": "tablet"
            },
            {
                "regex": "GoTab Gti8",
                "model": "GoTab GTi8",
                "device": "tablet"
            },
            {
                "regex": "ERGO[_ ]Tab[ _]Crystal[ _]Lite",
                "model": "Tab Crystal Lite",
                "device": "tablet"
            },
            {
                "regex": "ERGO[_ ]Tab[ _]Hero[ _]II",
                "model": "Tab Hero II",
                "device": "tablet"
            },
            {
                "regex": "ERGO[_ ](B700)",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "ERGO SmartBox SX",
                "model": "SmartBox SX",
                "device": "tv"
            }
        ]
    },
    "Ericsson": {
        "regex": "(?:Ericsson(?:/ )?[a-z0-9]+)|(?:R380 2.0 WAP1.1)",
        "device": "feature phone",
        "models": [
            {
                "regex": "Ericsson(?:/ )?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "R380 2.0 WAP1.1",
                "model": "R380"
            }
        ]
    },
    "Energizer": {
        "regex": "PowerMax|ENERGY[_ ]?(?:[45]00|400S|S[56]00|E12|E5[02]0S?)(?:[_ ](?:LTE|EU))?",
        "device": "smartphone",
        "models": [
            {
                "regex": "PowerMax(P[0-9]+S?)",
                "model": "Power Max $1"
            },
            {
                "regex": "ENERGY[_ ]([45]00|E520)[_ ]LTE",
                "model": "Energy $1 LTE"
            },
            {
                "regex": "ENERGY[_ ]400S",
                "model": "Energy 400S"
            },
            {
                "regex": "ENERGY400",
                "model": "Energy 400"
            },
            {
                "regex": "ENERGY[_ ]S([56]00)",
                "model": "Energy S$1"
            },
            {
                "regex": "ENERGY[_ ]?(E500S|E500|E12)",
                "model": "Energy $1"
            }
        ]
    },
    "Energy Sistem": {
        "regex": "ENERGY[ _-]?([^;/]+) Build|Energy Phone Pro 3",
        "device": "smartphone",
        "models": [
            {
                "regex": "Energy Phone Pro 3",
                "model": "Energy Phone Pro 3"
            },
            {
                "regex": "ENERGY[ _-]?([^;/]+) Build",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "eTouch": {
        "regex": "eTouch ?([a-z0-9]+)",
        "device": "smartphone",
        "model": "$1"
    },
    "Etuline": {
        "regex": "(ETL-S(?:3520|4521|5042|5084|6022)|ETL-T(?:752G|882G|9[78]0))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(ETL-S(?:[^/); ]+))",
                "model": "$1"
            },
            {
                "regex": "(ETL-T(?:[^/); ]+))",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Storex": {
        "regex": "eZee[^a-z]*Tab ?([^;/]*) Build|STOREX LinkBox",
        "device": "tablet",
        "models": [
            {
                "regex": "eZee[^a-z]*Tab ?([^;/]*) Build",
                "model": "eZee'Tab$1"
            },
            {
                "regex": "STOREX LinkBox",
                "model": "LinkBox",
                "device": "tv"
            }
        ]
    },
    "Evertek": {
        "regex": "(Ever(?:Glory|Shine|Miracle|Mellow|Classic|Trendy|Fancy|Vivid|Slim|Glow|Magic|Smart|Star)[^/;]*) Build|E70[25]0HD|E805[01]HD|E9054HD|E8050HG|E7914HG",
        "device": "smartphone",
        "models": [
            {
                "regex": "(E70[25]0HD|E805[01]HD|E9054HD|E8050HG|E7914HG)",
                "device": "tablet",
                "model": "Everpad $1"
            },
            {
                "regex": "(Ever(?:Glory|Shine|Miracle|Mellow|Classic|Trendy|Fancy|Vivid|Slim|Glow|Magic|Smart|Star)[^/;]*) Build",
                "model": "$1"
            }
        ]
    },
    "Evolio": {
        "regex": "Evolio|M4MAGIC",
        "device": "smartphone",
        "models": [
            {
                "regex": "M4MAGIC",
                "model": "M4 Magic"
            },
            {
                "regex": "Evolio_M5Pro",
                "model": "M5 Pro"
            },
            {
                "regex": "Evolio[ _](M6|S4 Cobalt|S5|X10|Yuppi)",
                "model": "$1"
            }
        ]
    },
    "Evolveo": {
        "regex": "EVOLVEO|StrongPhone",
        "device": "smartphone",
        "models": [
            {
                "regex": "EVOLVEO MultiMedia Box M4",
                "device": "tv",
                "model": "MultiMedia Box M4"
            },
            {
                "regex": "Smart TV ([^;/]*) Build",
                "device": "tv",
                "model": "Smart TV $1"
            },
            {
                "regex": "EVOLVEO StrongPhone G([248])",
                "model": "StrongPhone G$1"
            },
            {
                "regex": "(?:EVOLVEO[ _])?StrongPhone[ _]?Q([679])(_LTE)?",
                "model": "StrongPhone Q$1$2"
            },
            {
                "regex": "EVOLVEO[ _]([^;/]*) Build",
                "model": "$1"
            }
        ]
    },
    "Explay": {
        "regex": "Explay|[\\w]+-EXPLAY-FIN|ActiveD[ _]|Atlant |Informer[ _][0-9]+|CinemaTV 3G|Surfer[ _][0-9\\.]|sQuad[ _][0-9\\.]|Onliner[1-3]|RioPlay|Leader|Pulsar|Infinityll|Imperium[78]|Indigo|Lagoon",
        "device": "tablet",
        "models": [
            {
                "regex": "ActiveD[ _]7.4[ _]3G",
                "model": "ActiveD 7.4 3G"
            },
            {
                "regex": "Imperium([78])(?:[);/ ]|$)",
                "model": "Imperium $1 3G"
            },
            {
                "regex": "ActiveD[ _]8.2[ _]3G",
                "model": "ActiveD 8.2 3G"
            },
            {
                "regex": "CinemaTV[ _]3G",
                "model": "CinemaTV 3G"
            },
            {
                "regex": "Infinityll",
                "model": "Infinity II"
            },
            {
                "regex": "Informer[ _]([0-9]+(?:[ _]3G)?)",
                "model": "Informer $1"
            },
            {
                "regex": "Surfer[ _]([0-9\\.]+(?:[ _]3G)?)",
                "model": "Surfer $1"
            },
            {
                "regex": "sQuad[ _]([0-9\\.]+(?:[ _]3G)?)",
                "model": "sQuad $1"
            },
            {
                "regex": "Onliner([1-3])",
                "model": "Onliner $1"
            },
            {
                "regex": "Atlant(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Atlant"
            },
            {
                "regex": "Indigo(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Indigo"
            },
            {
                "regex": "Pulsar(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Pulsar"
            },
            {
                "regex": "[\\w]+-EXPLAY-FIN",
                "device": "feature phone",
                "model": "Fin"
            },
            {
                "regex": "Lagoon(?:[);/ ]|$)",
                "model": "Lagoon"
            },
            {
                "regex": "Explay[ _-]([^;/]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "RioPlay(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Rio Play"
            },
            {
                "regex": "Leader",
                "model": "Leader"
            }
        ]
    },
    "EvroMedia": {
        "regex": "EVROMEDIA|Playpad[ _]|PLAY_PAD_PRO_XL",
        "device": "tablet",
        "models": [
            {
                "regex": "Playpad 3G GOO",
                "model": "Play Pad 3G Goo"
            },
            {
                "regex": "Play Pad 3G 2Goo",
                "model": "Play Pad 3G 2Goo"
            },
            {
                "regex": "Play Pad PRO",
                "model": "Play Pad Pro"
            },
            {
                "regex": "PLAY_PAD_PRO_XL",
                "model": "Play Pad Pro XL"
            },
            {
                "regex": "PlayPad 3GTab XL",
                "model": "Play Pad 3G Tab XL"
            }
        ]
    },
    "EKO": {
        "regex": "EKO",
        "device": "smartphone",
        "models": [
            {
                "regex": "EKO[ _-]?([^;/)]+) Build",
                "model": "$1"
            },
            {
                "regex": "EKO[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Extrem": {
        "regex": "Rock X9+|ROCK_X11",
        "device": "smartphone",
        "models": [
            {
                "regex": "Rock X9+",
                "model": "Rock X9+"
            },
            {
                "regex": "ROCK_X11",
                "model": "Rock X11"
            }
        ]
    },
    "Ezze": {
        "regex": "EZZE-|EZ(?!Browser)[a-z0-9]+",
        "device": "feature phone",
        "models": [
            {
                "regex": "EZZE-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "EZ([a-z0-9]+)",
                "model": "EZ$1"
            }
        ]
    },
    "Ezio": {
        "regex": "EZIO-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Forstar": {
        "regex": "Amosta ?3G5",
        "device": "smartphone",
        "models": [
            {
                "regex": "Amosta ?3G5",
                "model": "Amosta 3G5"
            }
        ]
    },
    "Foxconn": {
        "regex": "InFocus M[0-9]+[a-z]?",
        "device": "smartphone",
        "models": [
            {
                "regex": "InFocus M([0-9]+[a-z]?)",
                "model": "InFocus M$1"
            }
        ]
    },
    "Fondi": {
        "regex": "Fondi[- _]([^;/)]+)|(T702|Q008B|Q010B|Q718B|Q902|T602B|T707G|T708B|T725B|T725B1|T907B)(?:\\)| Build)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(T702|T602B)",
                "model": "$1"
            },
            {
                "regex": "(Q008B|Q010B|Q718B|Q902|T707G|T708B|T725B|T725B1|T907B)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Fondi[- _]([^;/)]+)",
                "model": "$1"
            }
        ]
    },
    "Fairphone": {
        "regex": "(FP(?:1U?|2))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Famoco": {
        "regex": "(FX[123]00)",
        "device": "smartphone",
        "model": "$1"
    },
    "FiGO": {
        "regex": "ATRIUM II F55L2|TRIO F40LT|CENTRIC S50G|EPIC F50G|Gravity X55L|Orion M50L|ULTRA M50G|M405B|VIRTUE3|F55L Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "ATRIUM II F55L2",
                "model": "Atrium II"
            },
            {
                "regex": "(F55L)",
                "model": "$1"
            },
            {
                "regex": "TRIO F40LT",
                "model": "Trio F40LT"
            },
            {
                "regex": "EPIC F50G",
                "model": "Epic F50G"
            },
            {
                "regex": "(Gravity X55L|Orion M50L)",
                "model": "$1"
            },
            {
                "regex": "ULTRA M50G",
                "model": "Prime"
            },
            {
                "regex": "M405B_8GB",
                "model": "Virtue II 8GB"
            },
            {
                "regex": "M405B",
                "model": "Virtue II"
            },
            {
                "regex": "VIRTUE3",
                "model": "Virtue III"
            },
            {
                "regex": "CENTRIC S50G",
                "model": "Centric S50G"
            }
        ]
    },
    "FNB": {
        "regex": "ConeXis (A[12]|X[12])|SP5045V",
        "device": "smartphone",
        "models": [
            {
                "regex": "SP5045V",
                "model": "SP5045V"
            },
            {
                "regex": "ConeXis A1",
                "model": "ConeXis A1"
            },
            {
                "regex": "ConeXis A2",
                "model": "ConeXis A2"
            },
            {
                "regex": "ConeXis X1",
                "model": "ConeXis X1"
            },
            {
                "regex": "ConeXis X2",
                "model": "ConeXis X2"
            }
        ]
    },
    "Fujitsu": {
        "regex": "(?:F-01[FHJKLM]|F-02[EFGHLK]|F-03[DEFGKHL]|F-04[EGFHKJ]|F-05[DEFJG]|F-06[EF]|F-07[DE]|F-08D|F-09[DE]|F-10D|F-[45]1A|F-[45]2A|F-11D|F-12C|M532|FARTM933KZ|901FJ|arrows(?:RX|M03|M0[45](?:-PREMIUM)?)|801FJ|FJL2[12])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "F-51A(?:[);/ ]|$)",
                "model": "Arrows 5G F-51A"
            },
            {
                "regex": "F-01F(?:[);/ ]|$)",
                "model": "Arrows NX F-01F"
            },
            {
                "regex": "(F-01[LM]|F-06F|F-03K|F-42A)(?:[);/ ]|$)",
                "model": "Easy Phone $1"
            },
            {
                "regex": "F-03L(?:[);/ ]|$)",
                "model": "Arrows Phone F-03L"
            },
            {
                "regex": "F-01J(?:[);/ ]|$)",
                "model": "Arrows NX F-01J"
            },
            {
                "regex": "F-01K(?:[);/ ]|$)",
                "model": "Arrows NX F-01K"
            },
            {
                "regex": "F-01H(?:[);/ ]|$)",
                "model": "Arrows Fit F-01H"
            },
            {
                "regex": "F-02E(?:[);/ ]|$)",
                "model": "Arrows X F-02E"
            },
            {
                "regex": "F-02G(?:[);/ ]|$)",
                "model": "Arrows NX F-02G"
            },
            {
                "regex": "FJL21(?:[);/ ]|$)",
                "model": "Arrows EF FJL21"
            },
            {
                "regex": "FJL22(?:[);/ ]|$)",
                "model": "Arrows Z FJL22"
            },
            {
                "regex": "F-02H(?:[);/ ]|$)",
                "model": "Arrows NX F-02H"
            },
            {
                "regex": "F-52A(?:[);/ ]|$)",
                "model": "Arrows NX9 F-52A"
            },
            {
                "regex": "F-03D(?:[);/ ]|$)",
                "model": "Arrows Kiss F-03D"
            },
            {
                "regex": "F-03E(?:[);/ ]|$)",
                "model": "Arrows Kiss F-03E"
            },
            {
                "regex": "F-03F(?:[);/ ]|$)",
                "model": "Disney Mobile F-03F"
            },
            {
                "regex": "F-03H(?:[);/ ]|$)",
                "model": "Arrows SV F-03H"
            },
            {
                "regex": "901FJ(?:[);/ ]|$)",
                "model": "Arrows J 901FJ"
            },
            {
                "regex": "F-04E(?:[);/ ]|$)",
                "model": "Arrows V F-04E"
            },
            {
                "regex": "F-04G(?:[);/ ]|$)",
                "model": "Arrows NX F-04G"
            },
            {
                "regex": "F-05D(?:[);/ ]|$)",
                "model": "Arrows X LTE F-05D"
            },
            {
                "regex": "F-05F(?:[);/ ]|$)",
                "model": "Arrows NX F-05F"
            },
            {
                "regex": "F-05J(?:[);/ ]|$)",
                "model": "Arrows Be F-05J"
            },
            {
                "regex": "F-05G(?:[);/ ]|$)",
                "model": "Arrows K-tai"
            },
            {
                "regex": "F-04K(?:[);/ ]|$)",
                "model": "Arrows Be F-04K"
            },
            {
                "regex": "F-02L(?:[);/ ]|$)",
                "model": "Arrows Be 3 F-02L"
            },
            {
                "regex": "F-41A(?:[);/ ]|$)",
                "model": "Arrows Be 4 F-41A"
            },
            {
                "regex": "F-06E(?:[);/ ]|$)",
                "model": "Arrows NX F-06E"
            },
            {
                "regex": "F-07D(?:[);/ ]|$)",
                "model": "Arrows μ F-07D"
            },
            {
                "regex": "801FJ(?:[);/ ]|$)",
                "model": "Arrows U 801FJ"
            },
            {
                "regex": "F-07E(?:[);/ ]|$)",
                "model": "Disney Mobile F-07E"
            },
            {
                "regex": "F-08D(?:[);/ ]|$)",
                "model": "Disney Mobile F-08D"
            },
            {
                "regex": "F-09D(?:[);/ ]|$)",
                "model": "ANTEPRIMA F-09D"
            },
            {
                "regex": "F-09E(?:[);/ ]|$)",
                "model": "Raku-Raku Smartphone Premium F-09E"
            },
            {
                "regex": "F-10D(?:[);/ ]|$)",
                "model": "Arrows X F-10D"
            },
            {
                "regex": "F-11D(?:[);/ ]|$)",
                "model": "Arrows Me F-11D"
            },
            {
                "regex": "F-12C(?:[);/ ]|$)",
                "model": "F-12C"
            },
            {
                "regex": "(F-04[JF])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "arrowsM03(?:[);/ ]|$)",
                "model": "Arrows M03"
            },
            {
                "regex": "arrowsRX(?:[);/ ]|$)",
                "model": "Arrows RX"
            },
            {
                "regex": "arrowsM04-PREMIUM(?:[);/ ]|$)",
                "model": "Arrows M04 Premium"
            },
            {
                "regex": "arrowsM(0[45])(?:[);/ ]|$)",
                "model": "Arrows M$1"
            },
            {
                "regex": "(F-0[32]F|F-03G|F-04H|F-05E|F-02K)(?:[);/ ]|$)",
                "model": "Arrows Tab $1",
                "device": "tablet"
            },
            {
                "regex": "FARTM933KZ",
                "model": "Arrows Tab M504/HA4",
                "device": "tablet"
            },
            {
                "regex": "M532(?:[);/ ]|$)",
                "model": "Stylistic",
                "device": "tablet"
            }
        ]
    },
    "G-TiDE": {
        "regex": "G-TiDE",
        "device": "smartphone",
        "models": [
            {
                "regex": "Shining7",
                "model": "Shining 7"
            },
            {
                "regex": "G-TiDE_(A1|S[34])",
                "model": "$1"
            },
            {
                "regex": "G-TiDE V6",
                "model": "V6"
            },
            {
                "regex": "E(57|60|66|72|77)",
                "model": "$1"
            }
        ]
    },
    "Gemini": {
        "regex": "(GEM[0-9]+[a-z]*)",
        "device": "tablet",
        "model": "$1"
    },
    "General Mobile": {
        "regex": "GM 5 Plus|GM8 go|GM [68] d|GM 8|General Mobile 4G|GM 9 (?:Pro|Plus)|e-tab 20(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GM 5 Plus",
                "model": "GM 5 Plus"
            },
            {
                "regex": "GM ([68]) d",
                "model": "GM $1D"
            },
            {
                "regex": "GM 8",
                "model": "GM 8"
            },
            {
                "regex": "GM8 go",
                "model": "GM 8 Go"
            },
            {
                "regex": "GM 9 Pro",
                "model": "GM 9 Pro"
            },
            {
                "regex": "GM 9 Plus",
                "model": "GM 9 Plus"
            },
            {
                "regex": "General Mobile 4G Dual",
                "model": "4G Dual"
            },
            {
                "regex": "General Mobile 4G",
                "model": "4G"
            },
            {
                "regex": "e-tab 20(?:[);/ ]|$)",
                "device": "tablet",
                "model": "E-Tab 20"
            }
        ]
    },
    "Geotel": {
        "regex": "GEOTEL[ _]?",
        "device": "smartphone",
        "models": [
            {
                "regex": "G1",
                "model": "G1"
            },
            {
                "regex": "GEOTEL[ _]?Note",
                "model": "Note"
            },
            {
                "regex": "GEOTEL[ _]AMIGO",
                "model": "Amigo"
            }
        ]
    },
    "Ghia": {
        "regex": "GHIA|QS702|VECTOR10\\.1",
        "device": "smartphone",
        "models": [
            {
                "regex": "QS702",
                "model": "QS702"
            },
            {
                "regex": "GHIA_ZEUS_3G",
                "model": "Zeus 3G"
            },
            {
                "regex": "GHIA_AXIS7",
                "model": "Axis 7",
                "device": "tablet"
            },
            {
                "regex": "VECTOR10\\.1",
                "model": "Vector 10.1\"",
                "device": "tablet"
            }
        ]
    },
    "Gigabyte": {
        "regex": "GSmart[ _][a-z0-9 ]+(?: Build|\\))|Gigabyte-[a-z0-9]+|Simba SX1|GSmart_Classic_Lite|(?<!Eagle )Classic[_ ](?:Joy|Pro)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(GSmart[ _][a-z0-9 ]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "Gigabyte-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(Classic[ _](?:Joy|Pro)|GSmart_Classic_Lite)",
                "model": "$1"
            },
            {
                "regex": "Simba SX1",
                "model": "GSmart Simba SX1"
            }
        ]
    },
    "Gigaset": {
        "regex": "Gigaset|(?: GS80|GS1[0189]0|GS1[89]5|GS2[89]0|GS5[357]-6|GS[23]70(?:_Plus)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Gigaset QV(1030|830)",
                "model": "Gigaset QV$1",
                "device": "tablet"
            },
            {
                "regex": "G(S[23]70)[_ ]Plus(?:[);/ ]|$)",
                "model": "G$1 Plus"
            },
            {
                "regex": "GS([23]70|1[0189]0|1[89]5|2[89]0|80)(?:[);/ ]|$)",
                "model": "GS$1"
            },
            {
                "regex": "GS57-6",
                "model": "ME Pro"
            },
            {
                "regex": "GS55-6",
                "model": "ME"
            },
            {
                "regex": "GS53-6",
                "model": "ME Pure"
            },
            {
                "regex": "Gigaset ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Gigaset ([^;/)]+)(?:[);/]|$)",
                "model": "$1"
            }
        ]
    },
    "Ginzzu": {
        "regex": "GINZZU[_ ]|((?:RS(?:7[14]|81|9[67])D)|S5002|(?<!Wave Pro )S5021|S5230|S50[45]0|S5120|RS(6[12]|9[45])D|S40[23]0|RS850[12]|RS9602)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GINZZU[_ ]?(S40[17]0|S4710|ST60[14]0|ST6120)",
                "model": "$1"
            },
            {
                "regex": "GINZZU[_ ]?(GT-(?:1050|7105|70[1-4]0|7115|7210|[WX]831|X[78]70|7810|8[01]10|X853))",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(RS6[12]D) ULTIMATE",
                "model": "$1 Ultimate"
            },
            {
                "regex": "(?:GINZZU[ _])?((?:RS(?:7[14]|81|9[4-7])D)|S50[45]0|S5002|S5021|S5230|S5120|S40[23]0|RS850[12]|RS9602|RS94D)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Gionee": {
        "regex": "(?:GIO-)?GIONEE[ _-]?[a-z0-9]+|(?:Dream_D1|V188S?|GN[0-9]{3,4}[a-z]?)(?:[);/ ]|$)|F103(?: Pro)?(?: Build|\\))|P5 mini Build|P7 Max Build|(M7 Power|F106L|F100A|F103S|F103 Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GN810(?:[);/ ]|$)",
                "model": "GN810",
                "device": "phablet"
            },
            {
                "regex": "GN([0-9]{3,4}[a-z]?)(?:[);/ ]|$)",
                "model": "GN$1"
            },
            {
                "regex": "(F106L|F100A|V188S|V188|F103S)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "M7 Power(?:[);/ ]|$)",
                "model": "M7 Power"
            },
            {
                "regex": "P5 mini Build",
                "model": "P5 mini"
            },
            {
                "regex": "P7 Max Build",
                "model": "P7 Max"
            },
            {
                "regex": "(S11) Lite(?:[);/ ]|$)",
                "model": "$1 Lite"
            },
            {
                "regex": "F103( Pro)?( BUILD|\\))",
                "model": "F103$1"
            },
            {
                "regex": "(?:(?:GIO-)?GIONEE[ _-])?Dream_D1(?:[);/ ]|$)",
                "model": "Dream D1"
            },
            {
                "regex": "(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+).*Android",
                "model": "$1"
            },
            {
                "regex": "Android.*(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+)",
                "model": "$1"
            },
            {
                "regex": "(?:GIO-)?GIONEE[ _-]?([a-z0-9]+)",
                "model": "$1",
                "device": "feature phone"
            }
        ]
    },
    "Grape": {
        "regex": "(?:Grape[ _])?GTM-5([^;/]+) Build",
        "device": "smartphone",
        "model": "GTM-5$1"
    },
    "Vizio": {
        "regex": "Vizio|VAP430|VTAB1008",
        "device": "tv",
        "models": [
            {
                "regex": "VAP430",
                "model": "VAP430"
            },
            {
                "regex": "VTAB1008",
                "device": "tablet",
                "model": "VTAB1008"
            }
        ]
    },
    "GOCLEVER": {
        "regex": "GOCLEVER|QUANTUM_[0-9]{3}|QUANTUM [0-9]{1}|QUANTUM 700N|Quantum2 500|QUANTUM_(1010N|1010M|900)|ARIES|INSIGNIA|ORION_|ELIPSO|LIBRA[ _]97",
        "device": "smartphone",
        "models": [
            {
                "regex": "QUANTUM_(1010N|1010M|900)",
                "model": "QUANTUM $1",
                "device": "tablet"
            },
            {
                "regex": "INSIGNIA_(785_PRO|1010M|800M)",
                "model": "INSIGNIA $1",
                "device": "tablet"
            },
            {
                "regex": "(ORION|ARIES|ELIPSO)[_ ](71|101|102)",
                "model": "$1 $2",
                "device": "tablet"
            },
            {
                "regex": "TQ700N",
                "model": "QUANTUM 700N",
                "device": "tablet"
            },
            {
                "regex": "Quantum2 500",
                "model": "Quantum 2 500"
            },
            {
                "regex": "((?:QUANTUM|ARIES|INSIGNIA|ORION|ELIPSO)[ _-]?[^;/]+)(?: Build|\\))",
                "model": "$1"
            },
            {
                "regex": "GOCLEVER[ _-]TAB[ _-]?([^;/]+) Build",
                "model": "TAB $1",
                "device": "tablet"
            },
            {
                "regex": "GOCLEVER[ _-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "TAB ([^;/)]+) Build/GOCLEVER",
                "model": "TAB $1",
                "device": "tablet"
            },
            {
                "regex": "([^;/)]+) Build/GOCLEVER",
                "model": "$1"
            },
            {
                "regex": "GOCLEVER[ _-]?TAB[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "TAB $1",
                "device": "tablet"
            },
            {
                "regex": "GOCLEVER[ _-]?([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            },
            {
                "regex": "LIBRA[ _]97",
                "model": "Libra 97",
                "device": "tablet"
            }
        ]
    },
    "GoMobile": {
        "regex": "GO Onyx|GO[0-9]{3,4}",
        "device": "smartphone",
        "models": [
            {
                "regex": "GO Onyx",
                "model": "Go Onyx"
            },
            {
                "regex": "GO([0-9]{3,4})",
                "model": "Go$1"
            }
        ]
    },
    "Gol Mobile": {
        "regex": "F10_PRIME",
        "device": "smartphone",
        "models": [
            {
                "regex": "F10_PRIME",
                "model": "F10 Prime"
            }
        ]
    },
    "Goly": {
        "regex": "Goly[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Goly[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Goly[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Google": {
        "regex": "Nexus|GoogleTV|Glass(?<!Browser)|CrKey[^a-z0-9]|Pixel(?: Build|\\))|Pixel (?:XL|C|[2-5]|[2-4] XL)|Google 2XL|G011A",
        "device": "smartphone",
        "models": [
            {
                "regex": "Glass",
                "model": "Glass"
            },
            {
                "regex": "Galaxy Nexus",
                "model": "Galaxy Nexus"
            },
            {
                "regex": "(Nexus (?:S|4|5X?|One))",
                "model": "$1"
            },
            {
                "regex": "(Nexus (?:6P?))",
                "device": "phablet",
                "model": "$1"
            },
            {
                "regex": "(Nexus (?:7|9|10))",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "CrKey[^a-z0-9]",
                "model": "Chromecast",
                "device": "tv"
            },
            {
                "regex": "GoogleTV",
                "device": "tv",
                "model": "GoogleTV"
            },
            {
                "regex": "Pixel(?: Build|\\))",
                "model": "Pixel"
            },
            {
                "regex": "Pixel XL",
                "model": "Pixel XL"
            },
            {
                "regex": "Pixel 3 XL",
                "model": "Pixel 3 XL"
            },
            {
                "regex": "Pixel 2 XL",
                "model": "Pixel 2 XL"
            },
            {
                "regex": "Pixel 3a XL",
                "model": "Pixel 3a XL"
            },
            {
                "regex": "Pixel 3a",
                "model": "Pixel 3a"
            },
            {
                "regex": "Pixel 4 XL",
                "model": "Pixel 4 XL"
            },
            {
                "regex": "Pixel 4a \\(5G\\)",
                "model": "Pixel 4a (5G)"
            },
            {
                "regex": "pixel 4a",
                "model": "Pixel 4a"
            },
            {
                "regex": "G011A",
                "model": "Pixel 2"
            },
            {
                "regex": "Google 2XL",
                "model": "Pixel 2 XL"
            },
            {
                "regex": "pixel ([2-5])",
                "model": "Pixel $1"
            },
            {
                "regex": "Pixel C",
                "device": "tablet",
                "model": "Pixel C"
            }
        ]
    },
    "Gradiente": {
        "regex": "GRADIENTE",
        "device": "feature phone",
        "models": [
            {
                "regex": "GRADIENTE-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "GRADIENTE ([a-z0-9\\-]+)",
                "model": "$1"
            }
        ]
    },
    "Grundig": {
        "regex": "GR?-TB[0-9]+[a-z]*|GRUNDIG|portalmmm/2\\.0 G|AFTEU(?:011|014|FF014)",
        "device": "tv",
        "models": [
            {
                "regex": "(GR?-TB[0-9]+[a-z]*)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "GRUNDIG ([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/2\\.0 G([a-z0-9]+)",
                "model": "G$1"
            },
            {
                "regex": "AFTEU014",
                "model": "Vision 7 4K (2019)"
            },
            {
                "regex": "AFTEUFF014",
                "model": "OLED 4K (2019)"
            },
            {
                "regex": "AFTEU011",
                "model": "Vision 6 HD (2019)"
            }
        ]
    },
    "Hafury": {
        "regex": "HAFURY",
        "device": "smartphone",
        "models": [
            {
                "regex": "(MIX|UMAX)",
                "model": "$1"
            }
        ]
    },
    "Haier": {
        "regex": "Haier|I6_Infinity|Titan[ _]T[135]|(?:HW-)?W(?:71[67]|757|860|970)(?:[);/ ]|$)|S5 Silk|(?:HM-)?(N505|N700|G(?:152|303|353|552|70[01])?-FL|HM-N501-FL|G(?:303)?-W|I(?:557)?-FL)|(?:PAD[ _](?:D71|G781|d85))|A2_Lite_NFC",
        "device": "smartphone",
        "models": [
            {
                "regex": "A2_Lite_NFC",
                "model": "Alpha A2 Lite NFC"
            },
            {
                "regex": "HM-N505-FL",
                "model": "I8"
            },
            {
                "regex": "S5 Silk",
                "model": "S5 Silk"
            },
            {
                "regex": "HM-N700-FL",
                "model": "L7"
            },
            {
                "regex": "HM-N501-FL",
                "model": "L56"
            },
            {
                "regex": "(?:HM-)?(G(?:152|353|552|70[01])|G(?:303)|I(?:557))",
                "model": "$1"
            },
            {
                "regex": "(Titan[_ ]T[135]|I6_Infinity)",
                "model": "$1"
            },
            {
                "regex": "(?:HW-)?W(71[67]|757|860|970)(?:[);/ ]|$)",
                "model": "W$1"
            },
            {
                "regex": "PAD[ -_](D71|G781|d85)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Haier[ _\\-](H[WT]-[^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Haier[ _\\-](H[WT]-[a-z0-9_\\-]+)",
                "model": "$1"
            },
            {
                "regex": "Haier[ _\\-](sy[0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Haier[ _\\-]([a-z0-9\\-]+)",
                "model": "$1",
                "device": "feature phone"
            }
        ]
    },
    "HannSpree": {
        "regex": "(HSG[0-9]{4})|SN97T41W|SN1AT71W\\(B\\)|SN70T51A|SN70T31?|T7-QC",
        "device": "tablet",
        "models": [
            {
                "regex": "(HSG[0-9]{4})",
                "model": "$1"
            },
            {
                "regex": "SN1AT71W\\(B\\)",
                "model": "SN1AT71W(B)"
            },
            {
                "regex": "SN70T31",
                "model": "SN70T31"
            },
            {
                "regex": "SN70T3",
                "model": "SN70T3"
            },
            {
                "regex": "SN70T51A",
                "model": "SN70T51A"
            },
            {
                "regex": "SN97T41W",
                "model": "SN97T41W"
            },
            {
                "regex": "T7-QC",
                "model": "SNAT71BUE"
            }
        ]
    },
    "Hasee": {
        "regex": "Hasee",
        "device": "smartphone",
        "models": [
            {
                "regex": "Hasee ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Hasee ([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Hisense": {
        "regex": "(?:HS-)?Hisense ([^;/]+) Build|Hisense [^);/]+|HISENSE; |HS-(?:G|U|EG?|I|L|T|X)[0-9]+[a-z0-9\\-]*|E270BSA|HWCD100E|HITV300C|M470BS[AE]|EG98|E2281|EG680|I46D1G|HAT4KDTV|HLTE([237]00T|200M|203T|202N|21[023567]T|22[67]T|22[13]E|230E|310[TM]|31[16]T|500T|501N|510[TM]|7[23]0T)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E270BSA",
                "device": "tablet",
                "model": "Sero 7"
            },
            {
                "regex": "M470BS[AE]",
                "device": "tablet",
                "model": "Sero 7 Pro"
            },
            {
                "regex": "E2281",
                "device": "tablet",
                "model": "Sero 8"
            },
            {
                "regex": "HLTE202N",
                "model": "A5"
            },
            {
                "regex": "HLTE203T",
                "model": "A5 Pro CC"
            },
            {
                "regex": "HLTE700T",
                "model": "A6"
            },
            {
                "regex": "HLTE730T",
                "model": "A6L"
            },
            {
                "regex": "HLTE221E",
                "model": "E Max"
            },
            {
                "regex": "HLTE501N",
                "model": "V Plus"
            },
            {
                "regex": "HLTE223E",
                "model": "H30"
            },
            {
                "regex": "I46D1G",
                "model": "Smartfren Andromax R"
            },
            {
                "regex": "EG680",
                "model": "Smartfren Andromax Z"
            },
            {
                "regex": "EG98",
                "model": "Smartfren Andromax U2"
            },
            {
                "regex": "HLTE200T(?:[);/ ]|$)",
                "model": "F26"
            },
            {
                "regex": "HLTE210T(?:[);/ ]|$)",
                "model": "F28"
            },
            {
                "regex": "HLTE215T(?:[);/ ]|$)",
                "model": "F29"
            },
            {
                "regex": "HLTE213T(?:[);/ ]|$)",
                "model": "King Kong 4"
            },
            {
                "regex": "HLTE311T(?:[);/ ]|$)",
                "model": "King Kong 4 Pro"
            },
            {
                "regex": "HLTE216T(?:[);/ ]|$)",
                "model": "King Kong 5"
            },
            {
                "regex": "HLTE316T(?:[);/ ]|$)",
                "model": "King Kong 5 Pro"
            },
            {
                "regex": "HLTE226T(?:[);/ ]|$)",
                "model": "King Kong 6"
            },
            {
                "regex": "HLTE217T(?:[);/ ]|$)",
                "model": "F30S"
            },
            {
                "regex": "HLTE227T(?:[);/ ]|$)",
                "model": "F40"
            },
            {
                "regex": "HLTE310[TM](?:[);/ ]|$)",
                "model": "H18"
            },
            {
                "regex": "HLTE510[TM](?:[);/ ]|$)",
                "model": "H20"
            },
            {
                "regex": "HLTE500T(?:[);/ ]|$)",
                "model": "H11"
            },
            {
                "regex": "HLTE230E(?:[);/ ]|$)",
                "model": "H40 Lite"
            },
            {
                "regex": "HLTE720T(?:[);/ ]|$)",
                "model": "U30",
                "device": "phablet"
            },
            {
                "regex": "HWCD100E(?:[);/ ]|$)",
                "model": "U40 Lite"
            },
            {
                "regex": "(HLTE300T|HLTE200M|HLTE212T)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "HITV300C(?:[);/ ]|$)",
                "model": "E9"
            },
            {
                "regex": "E260T\\+(?:[);/ ]|$)",
                "model": "Nana"
            },
            {
                "regex": "(HS-(?:G|U|EG?|I|L|T|X)[0-9]+[a-z0-9\\-]*)",
                "model": "$1"
            },
            {
                "regex": "(HAT4KDTV)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "(?:HS-)?Hisense ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Hisense ([^);/]+)",
                "model": "$1"
            }
        ]
    },
    "Hi-Level": {
        "regex": "HLV-T([a-z0-9]+)",
        "device": "tablet",
        "model": "HLV-T$1"
    },
    "Hoffmann": {
        "regex": "(HOFFMANN|Neo[_ ]A[1379]00)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Neo[_ ](A[1379]00)",
                "model": "Neo $1"
            },
            {
                "regex": "HOFFMANN[ _]X[-_ ](Prime|Twist|Max)",
                "model": "X $1"
            }
        ]
    },
    "Homtom": {
        "regex": "Homtom|(?:HT[0-9]{1,2})(?: ?Pro)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Homtom[_ ])?HT ?([0-9]{1,2}(?: ?Pro)?)(?:[);/ ]|$)",
                "model": "HT$1"
            },
            {
                "regex": "Homtom ([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Hosin": {
        "regex": "HOSIN[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "HOSIN[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "HOSIN[ _-]([^;/]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Hoozo": {
        "regex": "(?:HOOZO[_ ](MT232|MT116|MT Pad 116 LTE|X1001)|HZ0010)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "HOOZO[_ ](MT232|MT116|MT Pad 116 LTE|X1001)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(HZ0010)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Minix": {
        "regex": "NEO-(?:X8-H|U9-H|X[57]-mini|X8H-PLUS|X88-?I|X7-216A|X5-116A|X[68]|U1|Z64)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "NEO-X8-H(?:[);/ ]|$)",
                "model": "NEO X8H"
            },
            {
                "regex": "NEO-X([57])-mini(?:[);/ ]|$)",
                "model": "NEO X$1 Mini"
            },
            {
                "regex": "NEO-X8H-PLUS(?:[);/ ]|$)",
                "model": "NEO X8H Plus"
            },
            {
                "regex": "NEO-X88-?I(?:[);/ ]|$)",
                "model": "NEO X88i"
            },
            {
                "regex": "NEO-X7-216A(?:[);/ ]|$)",
                "model": "NEO X7"
            },
            {
                "regex": "NEO-X5-116A(?:[);/ ]|$)",
                "model": "NEO X5"
            },
            {
                "regex": "NEO-X([68])(?:[);/ ]|$)",
                "model": "NEO X$1"
            },
            {
                "regex": "NEO-U1(?:[);/ ]|$)",
                "model": "NEO U1"
            },
            {
                "regex": "NEO-Z64(?:[);/ ]|$)",
                "model": "NEO Z64"
            },
            {
                "regex": "NEO-U9-H(?:[);/ ]|$)",
                "model": "NEO U9H"
            }
        ]
    },
    "Huawei": {
        "regex": "(HW-)?(?:Huawei|MediaPad T1|Ideos|Honor[ _]?|(?:(?:AGS|AGS2|ALE|ALP|AMN|ANA|ANE|ARE|ARS|ASK|ATH|ATU|AUM|BAC|BAH[23]?|BG2|BGO|B[ZK]K|BKL|BL[ALN]|BND|BTV|CA[GMNZ]|CH[CM]|CHE[12]?|CLT|CMR|COL|COR|CPN|CRO|CRR|CUN|DIG|DLI|DRA|DUA|DUB|DUK|EDI|ELE|EML|EVA|EVR|FDR|FIG|FLA|FRD|FRL|GEM|GRA|HDN|HLK|HMA|Hol|HRY|HWI|H[36]0|INE|JAT|JEF|JDN|JDN2|JKM|JMM|JSN|KII|KIW|KNT|KOB|KSA|LDN|LEO|LIO|LLD|LND|LON|LRA|LUA|LY[AO]|MAR|MHA|MRD|MYA|NCE|NEM|NEO|NXT|PAR|PCT|PIC|PLE|PLK|POT|PPA|PRA|RIO|RNE|RVL|SCC|SCL|SCM|SEA|SHT|SLA|SNE|SPN|STF|STK|TAG|TIT|TNY|TRT|VCE|VEN|VIE|VKY|VNS|VOG|VRD|VTR|WAS|YAL|G(?:527|620S|621|630|735)|Y(?:221|330|550|6[23]5))-(?:[A-Z]{0,2}[0-9]{1,4}[A-Z]{0,3}?)|H1711|U(?:8230|8500|8661|8665|8667|8800|8818|8860|9200|9508))(?:[);/ ]|$))|hi6210sft|PE-(UL00|TL[12]0|TL00M)|T1-(A21[Lw]|A23L|701u|823L)|G7-(?:L01|TL00)|HW-01K|JNY-(LX[12]|AL10)|OXF-AN[01]0|TAS-(A[LN]00|L29|TL00)|WLZ-(AL10|AN00)|NIC-LX1A|MRX-(AL09|W09)|CDY-(?:[AT]N00|AN90|NX9A)|GLK-(?:[AT]L00|LX1U)|JER-[AT]N10|ELS-(?:[AT]N[10]0|NX9|N39|N04)|AKA-(AL10|L29)|MON-(W|AL)19|BMH-AN[12]0|AQM-([AT]L[01]0|LX1)|MOA-(AL[02]0|LX9N)|NTS-AL00|ART-(?:[AT]L00[xm]|L29N?|L28)|MED-(?:[AT]L00|LX9N?)|EBG-(?:AN[01]0|TN00)|ANA-(?:[AT]N00|NX9)|BZ[AK]-W00|BZT-(W09|AL[01]0)|HDL-(AL09|W09)|HWV3[123]|HW-02L|TEL-[AT]N(?:00a?|10)|KKG-AN00|MXW-AN00|JKM-AL00[ab]|TAH-(?:N29|AN00)m|C8817D|T1-821W|d-01[JK]|d-02[HK]|KRJ-W09|HWT31|Y320-U10|Y541-U02|VAT-L19|70[14]HW|60[58]HW|NOH-(?:NX9|AN00)|TNNH-AN00|LIO-(?:[TA]L00|[LN]29|AN00)|KOB2-[LW]09|AGS3-[WL]09|DNN-LX9|NEY-NX9|LON-AL00|HLK-L41|503HW|AGR-[LW]09|PPA-LX[12]|ANG-AN00|NOP-AN00",
        "device": "smartphone",
        "models": [
            {
                "regex": "POT-[TA]L00a(?:[);/ ]|$)",
                "model": "9S"
            },
            {
                "regex": "U9500(?:[);/ ]|$)",
                "model": "Ascend D1"
            },
            {
                "regex": "Z100-UL00(?:[);/ ]|$)",
                "model": "Ascend D3"
            },
            {
                "regex": "Y320-(?:U10|T00|U05)(?:[);/ ]|$)",
                "model": "Ascend Y320"
            },
            {
                "regex": "Y330-U05(?:[);/ ]|$)",
                "model": "Ascend Y330"
            },
            {
                "regex": "Y541-U02(?:[);/ ]|$)",
                "model": "Ascend Y5C"
            },
            {
                "regex": "U8818(?:[);/ ]|$)",
                "model": "Ascend G300"
            },
            {
                "regex": "G527-U081(?:[);/ ]|$)",
                "model": "Ascend G527"
            },
            {
                "regex": "(G620S-L0[13]|C8817D)(?:[);/ ]|$)",
                "model": "Ascend G620S"
            },
            {
                "regex": "G630-U251(?:[);/ ]|$)",
                "model": "Ascend G630"
            },
            {
                "regex": "G7-(?:L01|TL00)(?:[);/ ]|$)",
                "model": "Ascend G7"
            },
            {
                "regex": "P7-L10(?:[);/ ]|$)",
                "model": "Ascend P7"
            },
            {
                "regex": "G730-C00(?:[);/ ]|$)",
                "model": "Ascend G730"
            },
            {
                "regex": "U9200(?:[);/ ]|$)",
                "model": "Ascend P1"
            },
            {
                "regex": "H1711(?:[);/ ]|$)",
                "model": "Ascend XT2"
            },
            {
                "regex": "Y221-U(?:[12]2|[0345]3)(?:[);/ ]|$)",
                "model": "Ascend Y221"
            },
            {
                "regex": "Y550-L03(?:[);/ ]|$)",
                "model": "Ascend Y550"
            },
            {
                "regex": "ART-[AT]L00[xm](?:[);/ ]|$)",
                "model": "Enjoy 10"
            },
            {
                "regex": "STK-[AT]L00(?:[);/ ]|$)",
                "model": "Enjoy 10 Plus"
            },
            {
                "regex": "MED-[AT]L00(?:[);/ ]|$)",
                "model": "Enjoy 10E"
            },
            {
                "regex": "AQM-[AT]L00(?:[);/ ]|$)",
                "model": "Enjoy 10S"
            },
            {
                "regex": "TAG-[ACT]L00(?:[);/ ]|$)",
                "model": "Enjoy 5S"
            },
            {
                "regex": "NCE-(AL[10]0|TL10)(?:[);/ ]|$)",
                "model": "Enjoy 6"
            },
            {
                "regex": "DIG-(?:TL10|AL00)(?:[);/ ]|$)",
                "model": "Enjoy 6S"
            },
            {
                "regex": "SLA-(?:AL00|TL10)(?:[);/ ]|$)",
                "model": "Enjoy 7"
            },
            {
                "regex": "FIG-(?:[AT]L[10]0)(?:[);/ ]|$)",
                "model": "Enjoy 7S"
            },
            {
                "regex": "(?:TRT-AL00[A]?|TRT-TL10A)(?:[);/ ]|$)",
                "model": "Enjoy 7 Plus"
            },
            {
                "regex": "LDN-(?:AL[12]0|TL[02]0)(?:[);/ ]|$)",
                "model": "Enjoy 8"
            },
            {
                "regex": "FLA-AL10(?:[);/ ]|$)",
                "model": "Enjoy 8 Plus"
            },
            {
                "regex": "ATU-[AT]L10(?:[);/ ]|$)",
                "model": "Enjoy 8e"
            },
            {
                "regex": "MRD-[TA]L00(?:[);/ ]|$)",
                "model": "Enjoy 9e"
            },
            {
                "regex": "DVC-TN20(?:[);/ ]|$)",
                "model": "Enjoy 20 Pro"
            },
            {
                "regex": "U8665(?:[);/ ]|$)",
                "model": "Fusion 2"
            },
            {
                "regex": "MED-LX9N?(?:[);/ ]|$)",
                "model": "Y6p"
            },
            {
                "regex": "G735-L(?:03|12|23)(?:[);/ ]|$)",
                "model": "G Play"
            },
            {
                "regex": "CHC-U(?:0[13]|23)(?:[);/ ]|$)",
                "model": "G Play Mini"
            },
            {
                "regex": "(?:Honor_|HW-)?G621-TL00M?(?:[);/ ]|$)",
                "model": "G621"
            },
            {
                "regex": "DIG-L2[12](?:[);/ ]|$)",
                "model": "GR3 (2017)"
            },
            {
                "regex": "KII-L21(?:[);/ ]|$)",
                "model": "GR5"
            },
            {
                "regex": "BLL-L2[12](?:[);/ ]|$)",
                "model": "GR5 (2017)"
            },
            {
                "regex": "RIO-L03(?:[);/ ]|$)",
                "model": "GX8"
            },
            {
                "regex": "U8860(?:[);/ ]|$)",
                "model": "Honor"
            },
            {
                "regex": "COL-(?:AL[01]0|TL[01]0|L29)(?:[);/ ]|$)",
                "model": "Honor 10"
            },
            {
                "regex": "HRY-(?:[AT]L00[A]?|LX[12]|LX1MEB)(?:[);/ ]|$)",
                "model": "Honor 10 Lite"
            },
            {
                "regex": "HRY-LX1T(?:[);/ ]|$)",
                "model": "Honor 10I"
            },
            {
                "regex": "U9508(?:[);/ ]|$)",
                "model": "Honor 2"
            },
            {
                "regex": "YAL-(?:L21|[AT]L00)(?:[);/ ]|$)",
                "model": "Honor 20"
            },
            {
                "regex": "LRA-AL00(?:[);/ ]|$)",
                "model": "Honor 20 Lite"
            },
            {
                "regex": "(HRY-AL00T[a]?)(?:[);/ ]|$)",
                "model": "Honor 20I"
            },
            {
                "regex": "YAL-(L41|AL10)(?:[);/ ]|$)",
                "model": "Honor 20 Pro"
            },
            {
                "regex": "(MAR-LX1H|YAL-AL50)(?:[);/ ]|$)",
                "model": "Honor 20S"
            },
            {
                "regex": "(?:BMH-AN[12]0|MXW-AN00)(?:[);/ ]|$)",
                "model": "Honor 30"
            },
            {
                "regex": "EBG-[AT]N00(?:[);/ ]|$)",
                "model": "Honor 30 Pro"
            },
            {
                "regex": "EBG-AN10(?:[);/ ]|$)",
                "model": "Honor 30 Pro Plus"
            },
            {
                "regex": "CDY-(?:AN90|NX9A)(?:[);/ ]|$)",
                "model": "Honor 30S"
            },
            {
                "regex": "LRA-LX1(?:[);/ ]|$)",
                "model": "Honor 30I"
            },
            {
                "regex": "(?:Honor_|HW-)?H30-(?:C00|L01M?|L02|U10|T00|T10)(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor 3C"
            },
            {
                "regex": "Hol-U19(?:[);/ ]|$)",
                "model": "Honor 3C Lite"
            },
            {
                "regex": "G750-T01(?:[);/ ]|$)",
                "model": "Honor 3X"
            },
            {
                "regex": "(?:Honor_|HW-)?SCL-(?:AL00|CL00|TL00H?)(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor 4A"
            },
            {
                "regex": "(?:Honor_|HW-)?CHM-U01(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor 4C"
            },
            {
                "regex": "Honor 4c Pro(?:[);/ ]|$)",
                "model": "Honor 4C Pro"
            },
            {
                "regex": "AQM-AL10(?:[);/ ]|$)",
                "model": "Honor 4T Pro"
            },
            {
                "regex": "(CHE2?-[UT]L00[HM]?|CHE1-CL[12]0|CHE2-L(?:1[12]|23)|Che1-L04|CHE-TL00)(?:[);/ ]|$)",
                "model": "Honor 4X"
            },
            {
                "regex": "(?:Honor_|HW-)?CUN-[AT]L00(?:[);/ ]|$)",
                "model": "Honor 5 Play"
            },
            {
                "regex": "(?:Honor_|HW-)?CAM-(?:AL00|TL00H|TL00)(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor 5A"
            },
            {
                "regex": "(?:Honor_|HW-)?NEM-(?:AL10|L51|UL10|TL00)(?:[);/ ]|$)",
                "model": "Honor 5C"
            },
            {
                "regex": "(?:Honor_|HW-)?NEM-(?:L22|TL00H)(?:[);/ ]|$)",
                "model": "Honor 5C Dual SIM"
            },
            {
                "regex": "(?:Honor_|HW-)?KIW-(?:AL10|TL00H|[TC]L00|L2[1-4]|UL00)(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor 5X"
            },
            {
                "regex": "((?:Honor_|HW-)?H60-L(?:01|02|03|04|11|12)(?:_TD)?|HW-H60-J1)(?:[);/ ]|$)",
                "model": "Honor 6"
            },
            {
                "regex": "MYA-TL10(?:[);/ ]|$)",
                "model": "Honor 6 Play"
            },
            {
                "regex": "PE-(UL00|TL[12]0|TL00M)(?:[);/ ]|$)",
                "model": "Honor 6 Plus"
            },
            {
                "regex": "(?:HONOR[ _]?)?DLI-(?:AL10|L[24]2|TL20)(?:[);/ ]|$)",
                "model": "Honor 6A"
            },
            {
                "regex": "DIG-L21HN(?:[);/ ]|$)",
                "model": "Honor 6C"
            },
            {
                "regex": "JMM-L22(?:[);/ ]|$)",
                "model": "Honor 6C Pro"
            },
            {
                "regex": "(?:HONOR[ _]?)?BLN-(?:L2[124]|AL[1234]0|TL[01]0(?:[);/ ]|$))",
                "model": "Honor 6X"
            },
            {
                "regex": "(?:Honor[_]?|HW-)?PLK-(?:AL10|CL00|TL00|TL01H?|UL00|L01)(?:[);/ ]|$)",
                "model": "Honor 7"
            },
            {
                "regex": "(?:Honor_|HW-)?NEM-L21(?:[);/ ]|$)",
                "model": "Honor 7 Lite"
            },
            {
                "regex": "AUM-(?:AL[20]0|L33[A]?|TL20)(?:[);/ ]|$)",
                "model": "Honor 7A"
            },
            {
                "regex": "AUM-L29(?:[);/ ]|$)",
                "model": "Honor 7A Pro"
            },
            {
                "regex": "(?:Honor_|HW-)?(?:LND-(?:AL[34]0|L29|TL40)|AUM-L41)(?:[);/ ]|$)",
                "model": "Honor 7C"
            },
            {
                "regex": "ATH-(?:[CAU]L00|TL00H)(?:[);/ ]|$)",
                "model": "Honor 7i"
            },
            {
                "regex": "(?:Honor_|HW-)?DUA-(?:L22|LX3)(?:[);/ ]|$)",
                "model": "Honor 7S"
            },
            {
                "regex": "(?:HONOR[ _]?)?BND-(?:AL[01]0|TL10|L2[14]|L31)(?:[);/ ]|$)",
                "model": "Honor 7X"
            },
            {
                "regex": "(?:FRD-(?:AL[01]0|L0[249]|L1[49]|DL00)|VAT-L19)(?:[);/ ]|$)",
                "model": "Honor 8"
            },
            {
                "regex": "PRA-(?:AL00X|AL00|TL10)(?:[);/ ]|$)",
                "model": "Honor 8 Lite"
            },
            {
                "regex": "DUK-(?:L09|TL30)(?:[);/ ]|$)",
                "model": "Honor 8 Pro"
            },
            {
                "regex": "VEN-L22(?:[);/ ]|$)",
                "model": "Honor 8 Smart"
            },
            {
                "regex": "JAT-L(29|X[13])(?:[);/ ]|$)",
                "model": "Honor 8A"
            },
            {
                "regex": "JAT-L41(?:[);/ ]|$)",
                "model": "Honor 8A Pro"
            },
            {
                "regex": "BKK-(?:AL[10]0|L21|L22|LX2|TL00)(?:[);/ ]|$)",
                "model": "Honor 8C"
            },
            {
                "regex": "KSA-(LX[239]|AL00)(?:[);/ ]|$)",
                "model": "Honor 8S"
            },
            {
                "regex": "JSN-L(?:2[123]|42)|JSN-[TA]L00[a]?(?:[);/ ]|$)",
                "model": "Honor 8X"
            },
            {
                "regex": "ARE-(?:AL[10]0|L22(?:HN)?|TL00)(?:[);/ ]|$)",
                "model": "Honor 8X Max"
            },
            {
                "regex": "STF-(?:AL[10]0|L09S?|TL10)(?:[);/ ]|$)",
                "model": "Honor 9"
            },
            {
                "regex": "MOA-LX9N(?:[);/ ]|$)",
                "model": "Honor 9A"
            },
            {
                "regex": "AKA-L29(?:[);/ ]|$)",
                "model": "Honor 9C"
            },
            {
                "regex": "LLD-(?:AL[01]0|L[23]1|TL10)(?:[);/ ]|$)",
                "model": "Honor 9 Lite"
            },
            {
                "regex": "LLD-AL[23]0(?:[);/ ]|$)",
                "model": "Honor 9i"
            },
            {
                "regex": "DUA-LX9(?:[);/ ]|$)",
                "model": "Honor 9S"
            },
            {
                "regex": "HLK-AL00a?(?:[);/ ]|$)",
                "model": "Honor 9X"
            },
            {
                "regex": "HLK-(?:AL10|L4[12])(?:[);/ ]|$)",
                "model": "Honor 9X Pro"
            },
            {
                "regex": "CAM-UL00(?:[);/ ]|$)",
                "model": "Honor Holly 3"
            },
            {
                "regex": "NTS-AL00(?:[);/ ]|$)",
                "model": "Honor Magic"
            },
            {
                "regex": "TNY-[AT]L00(?:[);/ ]|$)",
                "model": "Honor Magic 2"
            },
            {
                "regex": "RVL-AL09(?:[);/ ]|$)",
                "model": "Honor Note 10"
            },
            {
                "regex": "EDI-AL10(?:[);/ ]|$)",
                "model": "Honor Note 8"
            },
            {
                "regex": "VKY-TL00(?:[);/ ]|$)",
                "model": "Honor P10 Plus"
            },
            {
                "regex": "VOG-AL00(?:[);/ ]|$)",
                "model": "Honor P30 Pro"
            },
            {
                "regex": "ANA-(?:[AT]N00|NX9)(?:[);/ ]|$)",
                "model": "Honor P40"
            },
            {
                "regex": "COR-(?:AL[01]0|L29|TL10)(?:[);/ ]|$)",
                "model": "Honor Play"
            },
            {
                "regex": "ASK-AL00x(?:[);/ ]|$)",
                "model": "Honor Play 3"
            },
            {
                "regex": "KSA-AL10(?:[);/ ]|$)",
                "model": "Honor Play 3E"
            },
            {
                "regex": "TNNH-AN00(?:[);/ ]|$)",
                "model": "Honor Play 4"
            },
            {
                "regex": "CHM-[CUT]L00[HM]?(?:[);/ ]|$)",
                "model": "Honor Play 4C"
            },
            {
                "regex": "AKA-AL10(?:[);/ ]|$)",
                "model": "Honor Play 4T"
            },
            {
                "regex": "DUA-[TA]L00(?:[);/ ]|$)",
                "model": "Honor Play 7"
            },
            {
                "regex": "JAT-[AT]L00(?:[);/ ]|$)",
                "model": "Honor Play 8A"
            },
            {
                "regex": "MOA-AL[02]0(?:[);/ ]|$)",
                "model": "Honor Play 9A"
            },
            {
                "regex": "BKL-(?:AL00|AL20|AL30|L09|TL10)(?:[);/ ]|$)",
                "model": "Honor V10"
            },
            {
                "regex": "PCT-[TA]L10(?:[);/ ]|$)",
                "model": "Honor V20"
            },
            {
                "regex": "KNT-(?:AL[12]0|[TU]L10)(?:[);/ ]|$)",
                "model": "Honor V8"
            },
            {
                "regex": "DUK-AL20(?:[);/ ]|$)",
                "model": "Honor V9"
            },
            {
                "regex": "JMM-[AT]L[01]0(?:[);/ ]|$)",
                "model": "Honor V9 Play"
            },
            {
                "regex": "BKL-L04(?:[);/ ]|$)",
                "model": "Honor View 10"
            },
            {
                "regex": "PCT-L29(?:[);/ ]|$)",
                "model": "Honor View 20"
            },
            {
                "regex": "OXF-AN00(?:[);/ ]|$)",
                "model": "Honor View 30"
            },
            {
                "regex": "OXF-AN10(?:[);/ ]|$)",
                "model": "Honor View 30 Pro"
            },
            {
                "regex": "(?:Honor_|HW-)?SCL-L(01|32)(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor Y6"
            },
            {
                "regex": "(?:Honor_|HW-)?LYO-L21(?:[);/ ]|$)",
                "model": "Honor Y6 II Compact"
            },
            {
                "regex": "TEL-(?:AN(?:00a?|10)|TN00)(?:[);/ ]|$)",
                "model": "Honor X10"
            },
            {
                "regex": "KKG-AN00(?:[);/ ]|$)",
                "model": "Honor X10 Max"
            },
            {
                "regex": "DNN-LX9(?:[);/ ]|$)",
                "model": "Honor X10 Lite"
            },
            {
                "regex": "U8500(?:[);/ ]|$)",
                "model": "Ideos X2"
            },
            {
                "regex": "U8510(?:[);/ ]|$)",
                "model": "Ideos X3"
            },
            {
                "regex": "U8800(?:[);/ ]|$)",
                "model": "Ideos X5"
            },
            {
                "regex": "MLA-AL10(?:[);/ ]|$)",
                "model": "Maimang 5"
            },
            {
                "regex": "POT-AL10(?:[);/ ]|$)",
                "model": "Maimang 8"
            },
            {
                "regex": "TAH-(?:N29|AN00)m(?:[);/ ]|$)",
                "model": "Mate XS"
            },
            {
                "regex": "ALP-(?:[TA]L00|L[02]9)(?:[);/ ]|$)",
                "model": "Mate 10"
            },
            {
                "regex": "RNE-(?:AL00|L(?:01|03|21|23))(?:[);/ ]|$)",
                "model": "Mate 10 Lite"
            },
            {
                "regex": "BLA-(?:A09|L[02]9|[TA]L00)(?:[);/ ]|$)",
                "model": "Mate 10 Pro"
            },
            {
                "regex": "HMA-(?:[AT]L00|L[02]9)(?:[);/ ]|$)",
                "model": "Mate 20"
            },
            {
                "regex": "SNE-(?:AL00|LX[0-3])(?:[);/ ]|$)",
                "model": "Mate 20 Lite"
            },
            {
                "regex": "LYA-(?:AL[01]0|L[02]9|L0C|TL00)(?:[);/ ]|$)",
                "model": "Mate 20 Pro"
            },
            {
                "regex": "LYA-AL00P(?:[);/ ]|$)",
                "model": "Mate 20 RS"
            },
            {
                "regex": "EVR-(?:[TA]L00|L29|N29|AN00)(?:[);/ ]|$)",
                "model": "Mate 20 X"
            },
            {
                "regex": "TAS-([AT]L00|L29)(?:[);/ ]|$)",
                "model": "Mate 30"
            },
            {
                "regex": "TAS-AN00(?:[);/ ]|$)",
                "model": "Mate 30 5G"
            },
            {
                "regex": "SPN-AL00(?:[);/ ]|$)",
                "model": "Mate 30 Lite"
            },
            {
                "regex": "LIO-(?:[TA]L00|L29|AN00)(?:[);/ ]|$)",
                "model": "Mate 30 Pro"
            },
            {
                "regex": "LIO-N29(?:[);/ ]|$)",
                "model": "Mate 30 Pro 5G"
            },
            {
                "regex": "NOH-(?:NX9|AN00)(?:[);/ ]|$)",
                "model": "Mate 40 Pro"
            },
            {
                "regex": "NOP-AN00(?:[);/ ]|$)",
                "model": "Mate 40 Pro+"
            },
            {
                "regex": "NXT-(?:AL10|L29)(?:[);/ ]|$)",
                "model": "Mate 8"
            },
            {
                "regex": "MHA-(?:L[02]9|[AT]L00)(?:[);/ ]|$)",
                "model": "Mate 9"
            },
            {
                "regex": "BLL-L23(?:[);/ ]|$)",
                "model": "Mate 9 Lite"
            },
            {
                "regex": "LON-(?:AL00(?:-PD)?|L29)(?:[);/ ]|$)",
                "model": "Mate 9 Pro"
            },
            {
                "regex": "NEO-AL00(?:[);/ ]|$)",
                "model": "Mate RS"
            },
            {
                "regex": "NEO-L29(?:[);/ ]|$)",
                "model": "Mate RS Porsche Design"
            },
            {
                "regex": "CRR-(?:L09|UL00)(?:[);/ ]|$)",
                "model": "Mate S"
            },
            {
                "regex": "BND-L34(?:[);/ ]|$)",
                "model": "Mate SE"
            },
            {
                "regex": "(CAZ-(?:AL[01]0|TL[12]0)|CAN-L[01][1-3])(?:[);/ ]|$)",
                "model": "Nova"
            },
            {
                "regex": "608HW(?:[);/ ]|$)",
                "model": "Nova Lite"
            },
            {
                "regex": "(?:PIC-(?:[AT]L00|LX9)|HWV31)(?:[);/ ]|$)",
                "model": "Nova 2"
            },
            {
                "regex": "704HW(?:[);/ ]|$)",
                "model": "Nova 2 Lite"
            },
            {
                "regex": "BAC-(?:L01|TL00)(?:[);/ ]|$)",
                "model": "Nova 2 Plus"
            },
            {
                "regex": "BAC-(?:AL00|L2[12])(?:[);/ ]|$)",
                "model": "Nova 2 Plus Dual SIM"
            },
            {
                "regex": "RNE-L[02]2(?:[);/ ]|$)",
                "model": "Nova 2I"
            },
            {
                "regex": "HWI-[AT]L00(?:[);/ ]|$)",
                "model": "Nova 2S"
            },
            {
                "regex": "PAR-(?:[AT]L00|LX[19]|LX1M|TL20)(?:[);/ ]|$)",
                "model": "Nova 3"
            },
            {
                "regex": "ANE-AL00(?:[);/ ]|$)",
                "model": "Nova 3e"
            },
            {
                "regex": "INE-(?:AL00|LX[12]r|LX[12]|TL00)(?:[);/ ]|$)",
                "model": "Nova 3i"
            },
            {
                "regex": "VCE-(L22|[AT]L00)(?:[);/ ]|$)",
                "model": "Nova 4"
            },
            {
                "regex": "MAR-AL00(?:[);/ ]|$)",
                "model": "Nova 4e"
            },
            {
                "regex": "SEA-AL00(?:[);/ ]|$)",
                "model": "Nova 5"
            },
            {
                "regex": "SEA-AL10(?:[);/ ]|$)",
                "model": "Nova 5 Pro"
            },
            {
                "regex": "GLK-(?:[AT]L00|LX1U)(?:[);/ ]|$)",
                "model": "Nova 5i"
            },
            {
                "regex": "SPN-TL00(?:[);/ ]|$)",
                "model": "Nova 5i Pro"
            },
            {
                "regex": "WLZ-AL10(?:[);/ ]|$)",
                "model": "Nova 6"
            },
            {
                "regex": "WLZ-AN00(?:[);/ ]|$)",
                "model": "Nova 6 5G"
            },
            {
                "regex": "JNY-AL10(?:[);/ ]|$)",
                "model": "Nova 6 SE"
            },
            {
                "regex": "JEF-(?:[AT]N00|AN20|NX9)(?:[);/ ]|$)",
                "model": "Nova 7 5G"
            },
            {
                "regex": "JER-[AT]N10(?:[);/ ]|$)",
                "model": "Nova 7 Pro 5G"
            },
            {
                "regex": "CDY-(?:[AT]N00|NX9B)(?:[);/ ]|$)",
                "model": "Nova 7 SE 5G"
            },
            {
                "regex": "JNY-LX2(?:[);/ ]|$)",
                "model": "Nova 7i"
            },
            {
                "regex": "ANG-AN00(?:[);/ ]|$)",
                "model": "Nova 8 5G"
            },
            {
                "regex": "DIG-L01(?:[);/ ]|$)",
                "model": "Nova Smart"
            },
            {
                "regex": "WAS-AL00(?:[);/ ]|$)",
                "model": "Nova Youth"
            },
            {
                "regex": "FIG-L(?:A1|X[123])(?:[);/ ]|$)",
                "model": "P smart"
            },
            {
                "regex": "POT-(?:LX(?:[13]|1T|2J|1AF)|AL00)(?:[);/ ]|$)",
                "model": "P smart (2019)"
            },
            {
                "regex": "POT-LX1A(?:[);/ ]|$)",
                "model": "P smart (2020)"
            },
            {
                "regex": "PPA-LX[12](?:[);/ ]|$)",
                "model": "P smart (2021)"
            },
            {
                "regex": "STK-LX1(?:[);/ ]|$)",
                "model": "P smart Z"
            },
            {
                "regex": "VTR-(?:L[02]9|AL00|TL00)(?:[);/ ]|$)",
                "model": "P10"
            },
            {
                "regex": "WAS-(?:L(?:X1|X1A|X2|X2J|X3|03T)|TL10)(?:[);/ ]|$)",
                "model": "P10 Lite"
            },
            {
                "regex": "VKY-(?:AL00|L09|L29)(?:[);/ ]|$)",
                "model": "P10 Plus"
            },
            {
                "regex": "BAC-L[02]3(?:[);/ ]|$)",
                "model": "P10 Selfie"
            },
            {
                "regex": "EML-(?:[TA]L00|L[02]9)(?:[);/ ]|$)",
                "model": "P20"
            },
            {
                "regex": "(?:ANE-(?:LX[123]|LX2J|TL00)|HWV32)(?:[);/ ]|$)",
                "model": "P20 Lite"
            },
            {
                "regex": "(?:CLT-(?:AL0[01]|TL0[01]|L(?:04|[02]9))|HW-01K)(?:[);/ ]|$)",
                "model": "P20 Pro"
            },
            {
                "regex": "(ELE-L(?:04|09|29)|ELE-[AT]L00)(?:[);/ ]|$)",
                "model": "P30"
            },
            {
                "regex": "(?:MAR-(?:LX(?:1[BM]|2J?|3BM)|TL00)|NIC-LX1A|HWV33)(?:[);/ ]|$)",
                "model": "P30 Lite"
            },
            {
                "regex": "MAR-LX[13]Am?(?:[);/ ]|$)",
                "model": "P30 Lite Dual SIM"
            },
            {
                "regex": "(?:VOG-(?:L(?:04|09|29)|TL00|AL10)|HW-02L)(?:[);/ ]|$)",
                "model": "P30 Pro"
            },
            {
                "regex": "ANA-LX4(?:[);/ ]|$)",
                "model": "P40"
            },
            {
                "regex": "JNY-LX1(?:[);/ ]|$)",
                "model": "P40 Lite"
            },
            {
                "regex": "ART-L29(?:[);/ ]|$)",
                "model": "P40 Lite E"
            },
            {
                "regex": "ART-L29N(?:[);/ ]|$)",
                "model": "P40 Lite E NFC"
            },
            {
                "regex": "(?:ELS-(?:[AT]N00|NX9|N04)|NEY-NX9)(?:[);/ ]|$)",
                "model": "P40 Pro"
            },
            {
                "regex": "ELS-(?:AN10|N39)(?:[);/ ]|$)",
                "model": "P40 Pro Plus"
            },
            {
                "regex": "GRA-(?:L09|UL00)(?:[);/ ]|$)",
                "model": "P8"
            },
            {
                "regex": "(?:ALE-L(?:02|21|23)|ALE-UL00|ALE-TL00|503HW)(?:[);/ ]|$)",
                "model": "P8 Lite (2015)"
            },
            {
                "regex": "(?:PRA-L(?:A1|X2|X1|X3)|hi6210sft)(?:[);/ ]|$)",
                "model": "P8 Lite (2017)"
            },
            {
                "regex": "EVA-(?:AL[10]0|L[012]9|[TCD]L00)(?:[);/ ]|$)",
                "model": "P9"
            },
            {
                "regex": "VNS-L(?:[23]1|[26]2)(?:[);/ ]|$)",
                "model": "P9 Lite"
            },
            {
                "regex": "SLA-L(?:02|03|22|23)(?:[);/ ]|$)",
                "model": "P9 Lite Mini"
            },
            {
                "regex": "DIG-L(?:03|23)(?:[);/ ]|$)",
                "model": "P9 Lite Smart"
            },
            {
                "regex": "VIE-(?:AL10|L[02]9)(?:[);/ ]|$)",
                "model": "P9 Plus"
            },
            {
                "regex": "ATH-UL0[16](?:[);/ ]|$)",
                "model": "ShotX"
            },
            {
                "regex": "U(8230|8661|8667)(?:[);/ ]|$)",
                "model": "U$1"
            },
            {
                "regex": "ARS-([AT]L00|L22)(?:[);/ ]|$)",
                "model": "Y Max"
            },
            {
                "regex": "CRO-(?:L[02]2|U00)(?:[);/ ]|$)",
                "model": "Y3 (2017)"
            },
            {
                "regex": "CAG-L[02]2(?:[);/ ]|$)",
                "model": "Y3 (2018)"
            },
            {
                "regex": "LUA-(U22|L2[12]|U03)(?:[);/ ]|$)",
                "model": "Y3II"
            },
            {
                "regex": "MYA-(?:L(?:02|03|2[23])|U29)(?:[);/ ]|$)",
                "model": "Y5 (2017)"
            },
            {
                "regex": "DRA-L(?:01|03|21|23|X3)(?:[);/ ]|$)",
                "model": "Y5 (2018)"
            },
            {
                "regex": "AMN-LX[1239](?:[);/ ]|$)",
                "model": "Y5 (2019)"
            },
            {
                "regex": "DRA-LX5(?:[);/ ]|$)",
                "model": "Y5 lite"
            },
            {
                "regex": "DRA-LX9(?:[);/ ]|$)",
                "model": "Y5p"
            },
            {
                "regex": "CRO-L[02]3(?:[);/ ]|$)",
                "model": "Y5 Lite (2017)"
            },
            {
                "regex": "CAG-L[02]3(?:[);/ ]|$)",
                "model": "Y5 Lite (2018)"
            },
            {
                "regex": "DRA-(?:LX2|[AT]L00)(?:[);/ ]|$)",
                "model": "Y5 Prime (2018)"
            },
            {
                "regex": "MYA-L13(?:[);/ ]|$)",
                "model": "Y5 Pro (2017)"
            },
            {
                "regex": "CUN-(?:L(?:0[123]|2[123]|33)|U29)(?:[);/ ]|$)",
                "model": "Y5II"
            },
            {
                "regex": "(?:SCC-U21|SCL-U31)(?:[);/ ]|$)",
                "model": "Y6"
            },
            {
                "regex": "MYA-L11(?:[);/ ]|$)",
                "model": "Y6 (2016)"
            },
            {
                "regex": "MYA-(L41|AL10)(?:[);/ ]|$)",
                "model": "Y6 (2017)"
            },
            {
                "regex": "ATU-L(?:11|21|22|X3)(?:[);/ ]|$)",
                "model": "Y6 (2018)"
            },
            {
                "regex": "MRD-L(?:X1[NF]?|X3)(?:[);/ ]|$)",
                "model": "Y6 (2019)"
            },
            {
                "regex": "ATU-L(?:31|42)(?:[);/ ]|$)",
                "model": "Y6 Prime (2018)"
            },
            {
                "regex": "TIT-(?:AL00|L01|U02)(?:[);/ ]|$)",
                "model": "Y6 Pro"
            },
            {
                "regex": "MRD-LX2(?:[);/ ]|$)",
                "model": "Y6 Pro (2019)"
            },
            {
                "regex": "Y625-U03(?:[);/ ]|$)",
                "model": "Y625"
            },
            {
                "regex": "Y635-L0[123](?:[);/ ]|$)",
                "model": "Y635"
            },
            {
                "regex": "Y635-L21(?:[);/ ]|$)",
                "model": "Y635 Dual SIM"
            },
            {
                "regex": "CAM-L(?:03|21|23|32)(?:[);/ ]|$)",
                "model": "Y6II"
            },
            {
                "regex": "TRT-LX[123](?:[);/ ]|$)",
                "model": "Y7 (2017)"
            },
            {
                "regex": "LDN-L(?:01|X3)(?:[);/ ]|$)",
                "model": "Y7 (2018)"
            },
            {
                "regex": "(?:HUAWEI[ _]?)?DUB-(?:LX[13]|TL00)(?:[);/ ]|$)",
                "model": "Y7 (2019)"
            },
            {
                "regex": "(LDN-(?:AL00|L21)|TRT-TL10)(?:[);/ ]|$)",
                "model": "Y7 Prime"
            },
            {
                "regex": "(LDN-(?:LX2|TL10)|TRT-(?:L21A|L53))(?:[);/ ]|$)",
                "model": "Y7 Prime (2018)"
            },
            {
                "regex": "DUB-(?:LX2|AL00)(?:[);/ ]|$)",
                "model": "Y7 Pro (2019)"
            },
            {
                "regex": "DUB-AL00a(?:[);/ ]|$)",
                "model": "Enjoy 9"
            },
            {
                "regex": "DUB-AL20(?:[);/ ]|$)",
                "model": "Y7 Pro (2019)"
            },
            {
                "regex": "PPA-LX3(?:[);/ ]|$)",
                "model": "Y7a"
            },
            {
                "regex": "ART-L28(?:[);/ ]|$)",
                "model": "Y7p"
            },
            {
                "regex": "AQM-LX1(?:[);/ ]|$)",
                "model": "Y8p"
            },
            {
                "regex": "FLA-(LX[123]|AL20|TL10)(?:[);/ ]|$)",
                "model": "Y9 (2018)"
            },
            {
                "regex": "JKM-(?:[TA]L00[ab]?|LX[123])(?:[);/ ]|$)",
                "model": "Y9 (2019)"
            },
            {
                "regex": "STK-(L2[12]|LX3)(?:[);/ ]|$)",
                "model": "Y9 Prime (2019)"
            },
            {
                "regex": "FRL-L2[23](?:[);/ ]|$)",
                "model": "Y9a"
            },
            {
                "regex": "HWT31(?:[);/ ]|$)",
                "model": "Qua Tab 02 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "HDN-[LW]09(?:[);/ ]|$)",
                "model": "Honor Water Play 10.1",
                "device": "tablet"
            },
            {
                "regex": "BAH3-(?:AL00|[LW]09)(?:[);/ ]|$)",
                "model": "MatePad 10.4\"",
                "device": "tablet"
            },
            {
                "regex": "BAH3-W59(?:[);/ ]|$)",
                "model": "MatePad 10.4\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "AGS3-[WL]09(?:[);/ ]|$)",
                "model": "MatePad T10s",
                "device": "tablet"
            },
            {
                "regex": "HDL-(?:W09|AL09)(?:[);/ ]|$)",
                "model": "Honor Water Play 8.0",
                "device": "tablet"
            },
            {
                "regex": "JDN-(?:AL00|W09)(?:[);/ ]|$)",
                "model": "Honor Pad 2",
                "device": "tablet"
            },
            {
                "regex": "KRJ-W09(?:[);/ ]|$)",
                "model": "Honor Pad V6",
                "device": "tablet"
            },
            {
                "regex": "MON-(W|AL)19(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MatePad C5 8"
            },
            {
                "regex": "BZA-W00(?:[);/ ]|$)",
                "device": "tablet",
                "model": "C3 9.6"
            },
            {
                "regex": "M2-801L(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M2 8.0\""
            },
            {
                "regex": "MRX-(AL09|W09)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MatePad Pro"
            },
            {
                "regex": "CMR-(?:AL[01]9|W09)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M5 10.8"
            },
            {
                "regex": "CMR-W19(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M5 Pro 10.8"
            },
            {
                "regex": "SCM-AL09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M5 Pro"
            },
            {
                "regex": "GEM-70[1-3]L(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad X2"
            },
            {
                "regex": "(?:JDN2-(:?[WL]09|AL[50]0)|BAH2-(?:AL[01]0|L09|W[01]9))(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M5 Lite"
            },
            {
                "regex": "SHT-(?:AL|W)09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M5 8.4"
            },
            {
                "regex": "VRD-(?:(AL|W)09|AL10|W10)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M6 8.4"
            },
            {
                "regex": "SCM-W09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M6 10"
            },
            {
                "regex": "BTV-W09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M3 8"
            },
            {
                "regex": "(BAH-W09|CPN-(?:L|W)09|CPN-AL00|701HW)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M3 Lite"
            },
            {
                "regex": "BAH-(?:L09|AL00)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M3 Lite 10"
            },
            {
                "regex": "BTV-DL09",
                "device": "tablet",
                "model": "MediaPad M3"
            },
            {
                "regex": "(AGS2-AL00|JDN2-W09)HN(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Honor Tab 5"
            },
            {
                "regex": "AGS2-(?:[LW]09|W19|L03)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T5 10"
            },
            {
                "regex": "KOB2-[LW]09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T 8.0\""
            },
            {
                "regex": "AGR-[LW]09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T 10"
            },
            {
                "regex": "AGS-(?:L0[39]|W09)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T3 10"
            },
            {
                "regex": "(KOB-(?:L|W)09|BZK-[LW]00)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T3 8"
            },
            {
                "regex": "BG2-(?:U0[13]|W09)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T3 7"
            },
            {
                "regex": "BGO-L03(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T2 7.0"
            },
            {
                "regex": "(?:BGO-DL09|PLE-70[13]L)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T2 7.0 Pro"
            },
            {
                "regex": "JDN-L01(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T2 8.0 Pro"
            },
            {
                "regex": "(?:FDR-(A01[LW]|A03L)|605HW)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T2 10.0\" Pro"
            },
            {
                "regex": "T1-(?:A21[LW]|A23L)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T1 10"
            },
            {
                "regex": "T1-701u(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T1 7"
            },
            {
                "regex": "(?:T1-82(?:3L|1W)|MediaPad T1 8.0)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T1 8"
            },
            {
                "regex": "AGS2-AL00(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Enjoy Tablet 10.1"
            },
            {
                "regex": "BZT-(W09|AL[01]0)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad C5 10.1"
            },
            {
                "regex": "(?:d-01J|d-02[HK])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "D Tab Compact"
            },
            {
                "regex": "(d-01K)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "dtab d-01K"
            },
            {
                "regex": "LEO-BX9(?:[);/ ]|$)",
                "device": "wearable",
                "model": "Smart Watch 2"
            },
            {
                "regex": "(MediaPad[^/;]*) Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Ideos([^;/]*) Build",
                "model": "Ideos$1"
            },
            {
                "regex": "(?:HUAWEI )?MT([0-9]+)",
                "device": "phablet",
                "model": "Ascend Mate $1"
            },
            {
                "regex": "Huawei[ _\\-]?([^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "(?:HW-)?Huawei(?!Browser)(?:/1\\.0/0?(?:Huawei))?[_\\- /]?([a-z0-9\\-_]+)",
                "model": "$1"
            },
            {
                "regex": "Huawei; ([a-z0-9 \\-]+)",
                "model": "$1"
            }
        ]
    },
    "Hyundai": {
        "regex": "Hyundai|Ultra (?:Active|Air|Charm|Dream|Energy|Latitude|Link|Live|Shadow|Shine|Storm|Style|Sync|Trend|Vision|Wave)|G(24027|2552[34])K|W25042L|HP554O|Seoul S8|L503F Plus|HT0701L16|HT0704K08|HT1004L16|HT1004LI16|Koral_8W2|Eternity[_ ]G25",
        "device": "smartphone",
        "models": [
            {
                "regex": "Ultra (Active|Air|Charm|Dream|Energy Lite|Energy Plus|Energy|Latitude|Link|Live II|Live|Shadow|Shine|Storm|Style|Sync|Trend|Vision|Wave)",
                "model": "Ultra $1"
            },
            {
                "regex": "Seoul S8",
                "model": "Seoul S8"
            },
            {
                "regex": "G25523K",
                "model": "Eternity G23"
            },
            {
                "regex": "Eternity[_ ]G25",
                "model": "Eternity G25"
            },
            {
                "regex": "G25524K",
                "model": "Eternity G24"
            },
            {
                "regex": "G24027K",
                "model": "Eternity G27"
            },
            {
                "regex": "W25042L",
                "model": "Eternity W42"
            },
            {
                "regex": "HP554O",
                "model": "HP554O"
            },
            {
                "regex": "L503F Plus",
                "model": "L503F Plus"
            },
            {
                "regex": "L503F Plus",
                "model": "L503F Plus"
            },
            {
                "regex": "(?:Hyundai_)?(Eternity_G57L)",
                "model": "$1"
            },
            {
                "regex": "HT0701L16",
                "model": "Koral 7XL",
                "device": "tablet"
            },
            {
                "regex": "HT1004LI16",
                "model": "Koral 10XL",
                "device": "tablet"
            },
            {
                "regex": "Koral_8W2",
                "model": "Koral 8W2",
                "device": "tablet"
            },
            {
                "regex": "HT1004L16",
                "model": "Koral 10XL",
                "device": "tablet"
            },
            {
                "regex": "HT0704K08",
                "model": "Koral 7M4",
                "device": "tablet"
            },
            {
                "regex": "Hyundai ([^;/]+) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Hyundai[ _\\-]?([a-z0-9_-]+)",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "i-Joy": {
        "regex": "i-Joy|i-Call|(?:Neon[79]|Sygnus|Deox|Elektra (?:M|L|XL|XXL))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Elektra M(?:[);/ ]|$)",
                "model": "Elektra M"
            },
            {
                "regex": "Elektra L(?:[);/ ]|$)",
                "model": "Elektra L"
            },
            {
                "regex": "Elektra XL(?:[);/ ]|$)",
                "model": "Elektra XL"
            },
            {
                "regex": "Elektra XXL(?:[);/ ]|$)",
                "model": "Elektra XXL",
                "device": "phablet"
            },
            {
                "regex": "Neon([79])(?:[);/ ]|$)",
                "model": "Neon $1",
                "device": "tablet"
            },
            {
                "regex": "Sygnus(?:[);/ ]|$)",
                "model": "Sygnus",
                "device": "tablet"
            },
            {
                "regex": "Deox(?:[);/ ]|$)",
                "model": "Deox",
                "device": "tablet"
            },
            {
                "regex": "i-Call ([^;/]+) Build",
                "model": "i-Call $1"
            },
            {
                "regex": "i-Joy ([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "iBall": {
        "regex": "iBall[ _]([^;/)]+)[ _]Build|iBall_Slide|(?:Snap[_ ]4G2|6351-Q400i|iT-KSA0003|iT-KSA0012|iT-KSA0066|Avid|Twinkle_i5|Gorgeo[_ ]4GL|Brisk 4G2|Blaze_V4|Wondro 10|Q27 4G|Andi (?:Wink|5G Blink) 4G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Andi Wink 4G",
                "device": "smartphone",
                "model": "Andi Wink 4G"
            },
            {
                "regex": "Andi 5G Blink 4G",
                "device": "smartphone",
                "model": "Andi 5G Blink 4G"
            },
            {
                "regex": "(Snap[_ ]4G2|Avid|Twinkle_i5|Gorgeo[_ ]4GL|Blaze_V4|Wondro 10|Q27 4G|Brisk 4G2)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "6351-Q400i(?:[);/ ]|$)",
                "model": "Slide"
            },
            {
                "regex": "iT-KSA0003(?:[);/ ]|$)",
                "model": "iTAB BizniZ"
            },
            {
                "regex": "iT-KSA0066(?:[);/ ]|$)",
                "model": "iTAB BizniZ Mini"
            },
            {
                "regex": "iT-KSA0012(?:[);/ ]|$)",
                "model": "iTAB Moviez Pro"
            },
            {
                "regex": "iBall[ _]([^;/)]+)(?:[ _]Build|\\))",
                "model": "$1"
            }
        ]
    },
    "iRola": {
        "regex": "iRola ([^/;]+) Build|(DX758|DX752|DX752|DX758[ _]?Pro) Build",
        "device": "tablet",
        "models": [
            {
                "regex": "DX758[ _]?Pro",
                "model": "DX758 Pro"
            },
            {
                "regex": "(DX758|DX752)",
                "model": "$1"
            },
            {
                "regex": "iRola ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "iRulu": {
        "regex": "iRULU[ _-](X11|V[34]|U2|AL101)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "iRULU[ _-](X11|V[34]|AL101)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "iRULU[ _](U2)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "Irbis": {
        "regex": "IRBIS|TZ(1(?:0[04]|42|5[01]|84|65|7[01345-89]|8[356]|9[12578])|49|55|72|22|7(?:1[124679]|2[021567]|37|4[257]|5[23457]|6[12]|72|7[17]|8[1]|9[147])|8(?:[34]1|5[3-8]|6[45]|7[2478]|8[1-5]|9[0127])|96[0-9])|TZ85|TZ13|TZ(?:one|art|HIT|81L)|(SP(?:0[56]|2[01]|4[1-36]|40[12]|45[345]|49[34]|50|51[0147]|531|54[12]|55[0124]|571))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(TZ(?:[0-9]+)|TZ(?:one|art|HIT|81L))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(SP[0-9]+)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "iBerry": {
        "regex": "AUXUS ([^/;]+) Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "AUXUS (Core[^/;]+) Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "AUXUS ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "iHunt": {
        "regex": "iHunt|One_ Love_|TITAN_P11000_PRO|Like_(3|4U|3_Pro)|X300 Elite|S10_Tank_2019|S60_Discovery_2019|AlienXLite2020|Alien X Lite|Alien_X|S20 Ultra ApeX 2021",
        "device": "smartphone",
        "models": [
            {
                "regex": "iHunt_Like",
                "model": "Like"
            },
            {
                "regex": "S10_Tank_2019",
                "model": "S10 Tank (2019)"
            },
            {
                "regex": "One_ Love_",
                "model": "One Love"
            },
            {
                "regex": "TITAN_P11000_PRO",
                "model": "Titan P11000 Pro"
            },
            {
                "regex": "Like_3_Pro",
                "model": "Like 3 Pro"
            },
            {
                "regex": "Like_3",
                "model": "Like 3"
            },
            {
                "regex": "Like_4U",
                "model": "Like 4U"
            },
            {
                "regex": "X300 Elite",
                "model": "X300 Elite"
            },
            {
                "regex": "S60_Discovery_2019",
                "model": "S60 Discovery (2019)"
            },
            {
                "regex": "AlienXLite2020",
                "model": "Alien X Lite (2020)"
            },
            {
                "regex": "Alien X Lite PRO",
                "model": "Alien X Lite Pro"
            },
            {
                "regex": "Alien X Lite",
                "model": "Alien X Lite"
            },
            {
                "regex": "Alien_X_ApeX",
                "model": "Alien X ApeX"
            },
            {
                "regex": "Alien_X",
                "model": "Alien X"
            },
            {
                "regex": "S20 Ultra ApeX 2021",
                "model": "S20 Ultra ApeX (2021)"
            }
        ]
    },
    "IconBIT": {
        "regex": "IconBIT|NT-(3506M|0704S|0909T|1009T|10[01]1T|1017T|3601P/3602P|3603P|3702S|3805C|3905T|3701S|0701S|0805C|0902S|370[23]M)|XDS[789]4K|Omnicast UHD|Movie Smart 4K|Movie IPTV Quad",
        "device": "tablet",
        "models": [
            {
                "regex": "NT-3506M",
                "device": "smartphone",
                "model": "NetTAB Mercury Quad FHD"
            },
            {
                "regex": "NT-0704S",
                "model": "NetTAB Sky LE"
            },
            {
                "regex": "NT-0909T",
                "model": "NetTAB Thor IZ"
            },
            {
                "regex": "NT-1009T",
                "model": "NetTAB Thor quad II"
            },
            {
                "regex": "NT-10[01]1T",
                "model": "NetTAB Thor LE"
            },
            {
                "regex": "NT-1017T",
                "model": "NetTAB Thor 3G quad"
            },
            {
                "regex": "NT-3601P/3602P",
                "model": "NetTAB Pocket 3G"
            },
            {
                "regex": "NT-3603P",
                "model": "NetTAB Pocket 3G Slim"
            },
            {
                "regex": "NT-3702S",
                "model": "NetTAB Sky HD 3G"
            },
            {
                "regex": "NT-3805C",
                "model": "NetTAB Skat 3G quad"
            },
            {
                "regex": "NT-3701S",
                "model": "NetTAB Sky 3G duo"
            },
            {
                "regex": "NT-3905T",
                "model": "NetTAB Thor ZX 3G"
            },
            {
                "regex": "NT-0701S",
                "model": "NetTAB Sky net"
            },
            {
                "regex": "NT-0805C",
                "model": "NetTAB Skat MX"
            },
            {
                "regex": "NT-0902S",
                "model": "NetTAB Space quad RX"
            },
            {
                "regex": "NT-3702M",
                "model": "NetTAB Matrix 3G duo"
            },
            {
                "regex": "NT-3703M",
                "model": "NetTAB Matrix 3GT"
            },
            {
                "regex": "(?:iconBIT )?(Movie Smart 4K|Movie IPTV Quad|Movie Ultra HD 4K|XDS[789]4K|Omnicast UHD)",
                "model": "$1",
                "device": "tv"
            }
        ]
    },
    "LYF": {
        "regex": "(LYF[ _])?LS-[456][0-9]{3}|LYF/[^/]+/",
        "device": "smartphone",
        "models": [
            {
                "regex": "LS-4004",
                "model": "Flame 2"
            },
            {
                "regex": "LS-5501",
                "model": "Earth 1"
            },
            {
                "regex": "LS-5021",
                "model": "Earth 2"
            },
            {
                "regex": "LS-5505",
                "model": "Water F1"
            },
            {
                "regex": "LS-4503",
                "model": "Flame LS-4503"
            },
            {
                "regex": "LS-4001",
                "model": "Flame 3"
            },
            {
                "regex": "LS-4003",
                "model": "Flame 4"
            },
            {
                "regex": "LS-4002",
                "model": "Flame 5"
            },
            {
                "regex": "LS-4005",
                "model": "Flame 6"
            },
            {
                "regex": "(LYF[ _])?LS-4006",
                "model": "Flame 7"
            },
            {
                "regex": "LS-4008",
                "model": "Flame 7S"
            },
            {
                "regex": "LS-450[58]",
                "model": "Flame 8"
            },
            {
                "regex": "LS-5002",
                "model": "Water 1"
            },
            {
                "regex": "LS-5005",
                "model": "Water 4"
            },
            {
                "regex": "LS-5006",
                "model": "Water 6"
            },
            {
                "regex": "LS-5008",
                "model": "Water 2"
            },
            {
                "regex": "LS-5009",
                "model": "Wind 6"
            },
            {
                "regex": "LS-5013",
                "model": "Wind 5"
            },
            {
                "regex": "LS-5014",
                "model": "Wind 4"
            },
            {
                "regex": "LS-5010",
                "model": "Wind 1"
            },
            {
                "regex": "LS-5015",
                "model": "Water 8"
            },
            {
                "regex": "LS-5016",
                "model": "Wind 7"
            },
            {
                "regex": "LS-5504",
                "model": "Water 7"
            },
            {
                "regex": "LS-5507",
                "model": "Water 7S"
            },
            {
                "regex": "LS-5017",
                "model": "Water 11"
            },
            {
                "regex": "LS-5018",
                "model": "Wind 4S"
            },
            {
                "regex": "LS-5020",
                "model": "Water 10"
            },
            {
                "regex": "LS-5201",
                "model": "Water F1S"
            },
            {
                "regex": "LS-5502",
                "model": "Wind 3"
            },
            {
                "regex": "LS-5503",
                "model": "Water 3"
            },
            {
                "regex": "LS-5506",
                "model": "Water 9"
            },
            {
                "regex": "LS-6001",
                "model": "Wind 2"
            },
            {
                "regex": "LYF/([^/]+)/",
                "model": "$1"
            }
        ]
    },
    "Lumus": {
        "regex": "LUMUS Shell|(?:NEO(SR620|SC600)|INNOSR545|Lumus[_ ]Ion)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NEO(SR620|SC600)(?:[);/ ]|$)",
                "model": "Neo $1"
            },
            {
                "regex": "INNO(SR545)(?:[);/ ]|$)",
                "model": "INNO $1"
            },
            {
                "regex": "Lumus[_ ]Ion(?:[);/ ]|$)",
                "model": "Ion"
            },
            {
                "regex": "LUMUS Shell [0-9A-Z]+",
                "device": "tv",
                "model": ""
            }
        ]
    },
    "M4tel": {
        "regex": "M4 SS[0-9]{4}(?:-R)?|M4_B[23]",
        "device": "smartphone",
        "models": [
            {
                "regex": "SS1050",
                "model": "Joy"
            },
            {
                "regex": "SS1060",
                "model": "Live"
            },
            {
                "regex": "SS1070",
                "model": "Sense"
            },
            {
                "regex": "SS1080",
                "model": "Max One"
            },
            {
                "regex": "SS1090",
                "model": "Max Ultra"
            },
            {
                "regex": "SS4020",
                "model": "Play"
            },
            {
                "regex": "SS4040",
                "model": "In Touch"
            },
            {
                "regex": "SS4045",
                "model": "Style"
            },
            {
                "regex": "SS4345",
                "model": "Soul Mini"
            },
            {
                "regex": "SS4350",
                "model": "Soul"
            },
            {
                "regex": "SS4445",
                "model": "Style Access"
            },
            {
                "regex": "SS4450",
                "model": "Share"
            },
            {
                "regex": "SS4451",
                "model": "Believe"
            },
            {
                "regex": "SS4452",
                "model": "Dream"
            },
            {
                "regex": "SS4453",
                "model": "Inspiration"
            },
            {
                "regex": "SS4455",
                "model": "Excite"
            },
            {
                "regex": "SS4456",
                "model": "Evolution"
            },
            {
                "regex": "SS4457-R",
                "model": "Ever"
            },
            {
                "regex": "SS4457",
                "model": "Elegance"
            },
            {
                "regex": "SS4458-R",
                "model": "Feel Plus"
            },
            {
                "regex": "SS4458",
                "model": "Attitude"
            },
            {
                "regex": "M4_B([23])",
                "model": "B$1"
            }
        ]
    },
    "IMO Mobile": {
        "regex": "IMO[ _]\\w",
        "device": "smartphone",
        "models": [
            {
                "regex": "IMO[ _]Q([23]) Plus(?:[);/ ]|$)",
                "model": "Q$1 Plus"
            },
            {
                "regex": "IMO[ _]Q2(?:[);/ ]|$)",
                "model": "Q2"
            },
            {
                "regex": "IMO[ _]S2(?:[);/ ]|$)",
                "model": "S2"
            },
            {
                "regex": "IMO[ _]FEEL A2(?:[);/ ]|$)",
                "model": "Feel A2"
            },
            {
                "regex": "IMO[ _]S50(?:[);/ ]|$)",
                "model": "S50 Light"
            },
            {
                "regex": "IMO[ _]S80(?:[);/ ]|$)",
                "model": "S80 Hero"
            },
            {
                "regex": "IMO[ _]S89(?:[);/ ]|$)",
                "model": "S89 Miracle"
            },
            {
                "regex": "IMO[ _]S88(?:[);/ ]|$)",
                "model": "S88 Discovery"
            },
            {
                "regex": "IMO[ _]S99(?:[);/ ]|$)",
                "model": "S99 Ocean"
            },
            {
                "regex": "IMO[ _]S98(?:[);/ ]|$)",
                "model": "S98 Champion"
            },
            {
                "regex": "IMO[ _]S87(?:[);/ ]|$)",
                "model": "S87 Raptor"
            },
            {
                "regex": "IMO[ _]S67(?:[);/ ]|$)",
                "model": "S67 Blast"
            },
            {
                "regex": "IMO[ _]S78(?:[);/ ]|$)",
                "model": "S78 Glory"
            },
            {
                "regex": "IMO[ _]Q8(?:[);/ ]|$)",
                "model": "Q8 Clarity"
            },
            {
                "regex": "IMO[ _]Discovery II(?:[);/ ]|$)",
                "model": "Discovery II"
            },
            {
                "regex": "IMO[ _]Q(?:[);/ ]|$)",
                "model": "Q"
            },
            {
                "regex": "IMO[ _](Y5|Z[67])(?:[);/ ]|$)",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "IMO TAB X9(?:[);/ ]|$)",
                "model": "Tab X9",
                "device": "tablet"
            }
        ]
    },
    "iLA": {
        "regex": "iLA[-_ ](Silk|X)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "iNew": {
        "regex": "iNew|(?:V7A|V3 Plus|V3-?E|V3C|FIRE_Tab_6)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "V3C(?:[);/ ]|$)",
                "model": "V3C"
            },
            {
                "regex": "V3-?E(?:[);/ ]|$)",
                "model": "V3-E"
            },
            {
                "regex": "V3 Plus(?:[);/ ]|$)",
                "model": "V3 Plus"
            },
            {
                "regex": "V7A(?:[);/ ]|$)",
                "model": "V7A"
            },
            {
                "regex": "FIRE_Tab_6(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Fire Tab 6"
            },
            {
                "regex": "iNew[ -_]([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "iPro": {
        "regex": "(?:Kylin[ _]5.[05]S?|KYLIN40|Jade[78]s|Amber[67]S?|Amber5S_Pro|Phonenix50S|Zafiro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Kylin_5.0S",
                "model": "Kylin 5.0S"
            },
            {
                "regex": "Kylin (5.[05])",
                "model": "Kylin $1"
            },
            {
                "regex": "KYLIN40",
                "model": "Kylin 40"
            },
            {
                "regex": "Jade([78])s",
                "model": "Jade $1s"
            },
            {
                "regex": "Amber7S",
                "model": "Amber 7S"
            },
            {
                "regex": "Amber5S_Pro",
                "model": "Amber 5S Pro"
            },
            {
                "regex": "Amber6",
                "model": "Amber 6"
            },
            {
                "regex": "Phonenix50S",
                "model": "Phonenix 50S"
            },
            {
                "regex": "Zafiro",
                "model": "Zafiro"
            }
        ]
    },
    "Infinix": {
        "regex": "Infinix",
        "device": "smartphone",
        "models": [
            {
                "regex": "Infinix[ _-]X260",
                "model": "Buzz"
            },
            {
                "regex": "Infinix[ _-]X502",
                "model": "Alpha Marvel"
            },
            {
                "regex": "Infinix[ _-]X570",
                "model": "Alpha"
            },
            {
                "regex": "Infinix[ _-]X350",
                "model": "Surf Smart"
            },
            {
                "regex": "Infinix[ _-]X351",
                "model": "Surf Smart 3G"
            },
            {
                "regex": "Infinix[ _-]X352",
                "model": "Surf Smart 2"
            },
            {
                "regex": "Infinix[ _-]X403",
                "model": "Surf Spice"
            },
            {
                "regex": "Infinix[ _-]X503",
                "model": "Surf Bravo"
            },
            {
                "regex": "Infinix[ _-]X511",
                "model": "Surf Noir"
            },
            {
                "regex": "Infinix[ _-]X400",
                "model": "Race"
            },
            {
                "regex": "Infinix[ _-]X401",
                "model": "Race Lite"
            },
            {
                "regex": "Infinix[ _-]X450",
                "model": "Race Bolt"
            },
            {
                "regex": "Infinix[ _-]X451",
                "model": "Race Bolt Q"
            },
            {
                "regex": "Infinix[ _-]X454",
                "model": "Race Bolt 2"
            },
            {
                "regex": "Infinix[ _-]X500",
                "model": "Race Eagle"
            },
            {
                "regex": "Infinix[ _-]X501",
                "model": "Race Jet"
            },
            {
                "regex": "Infinix[ _-]X506",
                "model": "Zero"
            },
            {
                "regex": "Infinix[ _-]X509",
                "model": "Zero 2"
            },
            {
                "regex": "Infinix[ _-]X552",
                "model": "Zero 3"
            },
            {
                "regex": "Infinix[ _-]X555",
                "model": "Zero 4"
            },
            {
                "regex": "Infinix[ _-]X(?:574|602)",
                "model": "Zero 4 Plus"
            },
            {
                "regex": "Infinix[ _-]X603",
                "model": "Zero 5"
            },
            {
                "regex": "Infinix[ _-]X603B",
                "model": "Zero 5 Pro"
            },
            {
                "regex": "Infinix[ _-]X620",
                "model": "Zero 6"
            },
            {
                "regex": "Infinix[ _-]X507",
                "model": "Hot"
            },
            {
                "regex": "Infinix[ _-]X510",
                "model": "Hot 2"
            },
            {
                "regex": "Infinix[ _-]X55[34]",
                "model": "Hot 3"
            },
            {
                "regex": "Infinix[ _-]X521",
                "model": "Hot S"
            },
            {
                "regex": "Infinix[ _-]X522",
                "model": "Hot S2"
            },
            {
                "regex": "Infinix[ _-]X557",
                "model": "Hot 4"
            },
            {
                "regex": "Infinix[ _-]X556",
                "model": "Hot 4 Pro"
            },
            {
                "regex": "Infinix[ _-]X559c",
                "model": "Hot 5"
            },
            {
                "regex": "Infinix[ _-]X559",
                "model": "Hot 5 Lite"
            },
            {
                "regex": "Infinix[ _-]X606[BC]?",
                "model": "Hot 6"
            },
            {
                "regex": "Infinix[ _-]X608",
                "model": "Hot 6 Pro"
            },
            {
                "regex": "Infinix[ _-]X624",
                "model": "Hot 7"
            },
            {
                "regex": "Infinix[ _-]X650",
                "model": "Hot 8"
            },
            {
                "regex": "Infinix[ _-]X680",
                "model": "Hot 9 Play"
            },
            {
                "regex": "Infinix[ _-]X573B?",
                "model": "Hot S3"
            },
            {
                "regex": "Infinix[ _-]X5010",
                "model": "Smart"
            },
            {
                "regex": "Infinix[ _-]X5515F",
                "model": "Smart 2"
            },
            {
                "regex": "Infinix[ _-]X5514D",
                "model": "Smart 2 Pro"
            },
            {
                "regex": "Infinix[ _-]X653",
                "model": "Smart 4"
            },
            {
                "regex": "Infinix[ _-]X626",
                "model": "S4"
            },
            {
                "regex": "Infinix[ _-]X652",
                "model": "S5"
            },
            {
                "regex": "Infinix[ _-]X660",
                "model": "S5 Pro"
            },
            {
                "regex": "Infinix[ _-]X551",
                "model": "Hot Note",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X600",
                "model": "Note 2",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X601",
                "model": "Note 3",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X572",
                "model": "Note 4",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X571",
                "model": "Note 4 Pro",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X604",
                "model": "Note 5",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X610",
                "model": "Note 6",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X690",
                "model": "Note 7",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X656",
                "model": "Note 7 Lite",
                "device": "phablet"
            },
            {
                "regex": "Infinix HOT ([a-z]?[1-6])( (?:Lite|Plus|Pro))?",
                "model": "Hot $1$2"
            },
            {
                "regex": "Infinix[ _-](X[78]00)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Infinix[ _-](X\\d+)",
                "model": "$1"
            },
            {
                "regex": "Infinix[ _-]([a-z0-9_\\-]+)",
                "model": "$1"
            }
        ]
    },
    "InFocus": {
        "regex": "IF(900[1237]|902[19]|903[15])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IF9001",
                "model": "Turbo 5"
            },
            {
                "regex": "IF9007",
                "model": "A3"
            },
            {
                "regex": "IF9021",
                "model": "Turbo 5 Plus"
            },
            {
                "regex": "IF9035",
                "model": "A2"
            },
            {
                "regex": "IF9002",
                "model": "M5s"
            },
            {
                "regex": "IF9003",
                "model": "M6s"
            },
            {
                "regex": "IF9031",
                "model": "Vision 3"
            },
            {
                "regex": "IF9029",
                "model": "Vision 3 Pro"
            }
        ]
    },
    "InnJoo": {
        "regex": "InnJoo|(?:Halo Plus|Halo X|Halo[ _]4(?:[ _]mini[ _]LTE)?|Halo2 3G|Fire2 Plus LTE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "InnJoo[ _]X3(?:[);/ ]|$)",
                "model": "X3"
            },
            {
                "regex": "Halo[ _]X[ _]LTE(?:[);/ ]|$)",
                "model": "Halo X LTE"
            },
            {
                "regex": "InnJoo[ _]X(?:[);/ ]|$)",
                "model": "X"
            },
            {
                "regex": "Halo Plus(?:[);/ ]|$)",
                "model": "Halo Plus"
            },
            {
                "regex": "Halo[ _]4[ _]mini[ _]LTE(?:[);/ ]|$)",
                "model": "Halo 4 Mini LTE"
            },
            {
                "regex": "Halo 4(?:[);/ ]|$)",
                "model": "Halo 4"
            },
            {
                "regex": "Halo2 3G(?:[);/ ]|$)",
                "model": "Halo 2 3G"
            },
            {
                "regex": "InnJoo[ _]Pro2(?:[);/ ]|$)",
                "model": "Pro 2"
            },
            {
                "regex": "Innjoo ONE 3G(?:[);/ ]|$)",
                "model": "One 3G"
            },
            {
                "regex": "Innjoo[ _]2[ _]LTE(?:[);/ ]|$)",
                "model": "2 LTE"
            },
            {
                "regex": "InnJoo[ _]([2-4])",
                "model": "$1"
            },
            {
                "regex": "Fire2 Plus LTE",
                "model": "Fire 2 Plus LTE"
            }
        ]
    },
    "Inkti": {
        "regex": "intki[ _]([^/;]*)[ _]Build",
        "device": "smartphone",
        "model": "$1"
    },
    "Innos": {
        "regex": "Innos_?(D6000)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Innostream": {
        "regex": "INNO([a-z0-9]+)",
        "device": "feature phone",
        "model": "INNO$1"
    },
    "Insignia": {
        "regex": "NS-(P11A8100|P10A8100|P10A6100|P16AT08|P16AT10|P16AT785HD|P08A7100|P10A7100)(?:[);/ ]|$)|AFTEAMR311|AFTJMST12",
        "device": "tablet",
        "models": [
            {
                "regex": "NS-P11A8100",
                "model": "11.6\""
            },
            {
                "regex": "NS-(P10A6100|P16AT10)",
                "model": "Flex 10.1\""
            },
            {
                "regex": "NS-P16AT08",
                "model": "Flex 8\""
            },
            {
                "regex": "NS-P08A7100",
                "model": "8\""
            },
            {
                "regex": "NS-(P10A8100|P10A7100)",
                "model": "10.1\""
            },
            {
                "regex": "NS-P16AT785HD",
                "model": "Flex Elite 7.85\""
            },
            {
                "regex": "AFTEAMR311",
                "model": "HD (2018)",
                "device": "tv"
            },
            {
                "regex": "AFTJMST12",
                "model": "4K (2018)",
                "device": "tv"
            }
        ]
    },
    "INQ": {
        "regex": "INQ[/ ]",
        "device": "feature phone",
        "models": [
            {
                "regex": "INQ/([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "INQ ([^;/]+) Build",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "Intex": {
        "regex": "Intex|(Aqua|Cloud[ _][XY][0-9]{1}|Cloud (?:Fame|Glory) 4G)|IM0318ND(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IM0318ND",
                "model": "Aqua Lions 3"
            },
            {
                "regex": "Intex[ _]([^/;]*)[ _]Build",
                "model": "$1"
            },
            {
                "regex": "(Cloud (?:Fame|Glory) 4G)",
                "model": "$1"
            },
            {
                "regex": "(Aqua|Cloud)[ _\\.]([^/;\\)]+)(?:[ _]Build|(?<!Build)/|\\))",
                "model": "$1 $2"
            },
            {
                "regex": "Intex[ _]([a-z0-9_+\\-]+)",
                "model": "$1"
            }
        ]
    },
    "i-mate": {
        "regex": "i-mate ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "i-mobile": {
        "regex": "i-mobile ?[a-z0-9]+|i-Style|IQ ?(9\\.1|5\\.5|5\\.6A?)",
        "device": "feature phone",
        "models": [
            {
                "regex": "i-mobile (i-note[^/;]*) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "i-Style ?([^;/]+) Build",
                "model": "i-Style $1",
                "device": "smartphone"
            },
            {
                "regex": "IQ ?(9\\.1|5\\.5|5\\.6A?)",
                "model": "IQ $1",
                "device": "smartphone"
            },
            {
                "regex": "i-mobile (IQ[^/;]*) Build",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "i-mobile(?: )?([a-z0-9\\- ]+) Build",
                "model": "$1"
            },
            {
                "regex": "i-mobile(?: )?([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "iKoMo": {
        "regex": "iKoMo ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "iOcean": {
        "regex": "iOCEAN|M6752|W180|X7[ _]?S|X8 mini",
        "device": "smartphone",
        "models": [
            {
                "regex": "X7S-T",
                "model": "X7S-T"
            },
            {
                "regex": "X8 mini pro",
                "model": "X8 Mini Pro"
            },
            {
                "regex": "X8 mini",
                "model": "X8 Mini"
            },
            {
                "regex": "X7[ _]?S",
                "model": "X7S Elite"
            },
            {
                "regex": "(M6752|W180) Build",
                "model": "$1"
            },
            {
                "regex": "iOCEAN[ _\\-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "iOCEAN[ _\\-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "iView": {
        "regex": "(733TPC|730TPC|769TPCII|930TPC)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Impression": {
        "regex": "(?:Impression[ _\\-]?([^/;]+)|A502|I10\\-LE|ImPad[ _]?(.*)|ImSmart[ _]?(.*))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(A502)",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "ImSmart[ _]?([^/;)]+)(?: Build|\\))",
                "model": "ImSmart $1",
                "device": "smartphone"
            },
            {
                "regex": "ImPad[ _]?([^/;)]+)(?: Build|\\))",
                "model": "ImPad $1"
            },
            {
                "regex": "(I10\\-LE)",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "Impression[ _\\-]?([^/;)]+)(?: Build|\\))",
                "model": "$1"
            }
        ]
    },
    "iLife": {
        "regex": "(ITELL[_ ](?:K3300|K3500N?|K4700))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "iTel": {
        "regex": "itel|iNote|GP10X2019(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "W6502",
                "device": "phablet",
                "model": "S16"
            },
            {
                "regex": "W5505",
                "model": "A36"
            },
            {
                "regex": "W6002E?",
                "model": "S15"
            },
            {
                "regex": "L5502",
                "model": "A44 Air"
            },
            {
                "regex": "L5505",
                "model": "A47"
            },
            {
                "regex": "L6006",
                "model": "A48"
            },
            {
                "regex": "L6003P",
                "model": "A55 LTE"
            },
            {
                "regex": "L6002P",
                "model": "S15 Pro"
            },
            {
                "regex": "L5002",
                "model": "A22"
            },
            {
                "regex": "L5503",
                "model": "A46"
            },
            {
                "regex": "L6004",
                "model": "A56 LTE"
            },
            {
                "regex": "W6004P",
                "model": "A56 Pro"
            },
            {
                "regex": "W6001",
                "model": "P33 Plus"
            },
            {
                "regex": "W6003",
                "model": "A55"
            },
            {
                "regex": "L6005",
                "model": "Vision 1"
            },
            {
                "regex": "L6501",
                "model": "Vision 1 Plus"
            },
            {
                "regex": "L6502",
                "model": "Vision 1 Pro"
            },
            {
                "regex": "GP10X2019",
                "model": "GP10X2019"
            },
            {
                "regex": "iNote ([^/;]*)Build",
                "model": "iNote $1"
            },
            {
                "regex": "iNote_([a-z0-9\\-_]+)",
                "model": "iNote $1"
            },
            {
                "regex": "itel-it(1410|1512|1520)(?:[);/ ]|$)",
                "model": "it$1"
            },
            {
                "regex": "itel-it1553(?:[);/ ]|$)",
                "model": "Power Pro"
            },
            {
                "regex": "itel[- ](A14|A16 Plus|A44 Power|A23S|A52 Lite)",
                "model": "$1"
            },
            {
                "regex": "itel it1701",
                "device": "tablet",
                "model": "iNote Prime"
            },
            {
                "regex": "itel it170([23])",
                "device": "tablet",
                "model": "iNote Prime $1"
            },
            {
                "regex": "iTel ([^/;]*)Build",
                "model": "$1"
            },
            {
                "regex": "iTel[_ ]([a-z0-9\\-_]*)",
                "model": "$1"
            }
        ]
    },
    "iZotron": {
        "regex": "(Mi7_HERO_(?:BETA|TAB))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Mi7[_ ]HERO[_ ]BETA(?:[);/ ]|$)",
                "model": "MI7 Hero Beta"
            },
            {
                "regex": "Mi7[_ ]HERO[_ ]TAB(?:[);/ ]|$)",
                "model": "MI7 Hero Tab"
            }
        ]
    },
    "JAY-Tech": {
        "regex": "TPC-[A-Z0-9]+|TPCY-TX[TE][^);/ ]+",
        "device": "tablet",
        "models": [
            {
                "regex": "TPC-([A-Z0-9]+)",
                "model": "Tablet PC $1"
            },
            {
                "regex": "(TPCY-TX[TE][^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Jiayu": {
        "regex": "JIAYU[ _-]|(?:JY-G4[\\\\_]G5|(?:JY-[a-z0-9]+)|JY_G4C)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:JIAYU G4_G5|JY-G4[\\\\_]G5)(?:[);/ ]|$)",
                "model": "G4/G5"
            },
            {
                "regex": "JIAYU[ _-](G4[S]?|G2F|G3[S]?|S[23])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "JY[-_]([a-z0-9]+|G4C)(?:[);/ ]|$)",
                "model": "JY-$1"
            }
        ]
    },
    "Jolla": {
        "regex": "Jolla",
        "device": "smartphone",
        "model": ""
    },
    "Just5": {
        "regex": "JUST5(-)?SPACER(s)?|COSMO[_ ](L707|L808)|BLASTER|FREEDOM[ _](C100|M303|X1)|Freedom",
        "device": "smartphone",
        "models": [
            {
                "regex": "COSMO[_ ](L707|L808)",
                "model": "Cosmo $1"
            },
            {
                "regex": "FREEDOM[ _](C100|M303|X1)",
                "model": "Freedom $1"
            },
            {
                "regex": "Freedom",
                "model": "Freedom"
            },
            {
                "regex": "JUST5(-)?SPACER2s",
                "model": "Spacer 2S"
            },
            {
                "regex": "JUST5(-)?SPACER2",
                "model": "Spacer 2"
            },
            {
                "regex": "JUST5SPACER",
                "model": "Spacer"
            },
            {
                "regex": "BLASTER 2",
                "model": "Blaster 2"
            },
            {
                "regex": "BLASTER",
                "model": "Blaster"
            }
        ]
    },
    "Kalley": {
        "regex": "KALLEY|(?:ELEMENT (?:MAX|Q)|ELEMENT_PRO_2|K-BOOK(?:8MG|73G))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ELEMENT MAX",
                "model": "Element Max"
            },
            {
                "regex": "ELEMENT Q",
                "model": "Element Q"
            },
            {
                "regex": "ELEMENT_PRO_2",
                "model": "Element Pro 2"
            },
            {
                "regex": "K-BOOK(8MG|73G)",
                "device": "tablet",
                "model": "K-BOOK$1"
            },
            {
                "regex": "KALLEY,(55D1240)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Kaan": {
        "regex": "KAAN[ _](N[12]|A1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Kazam": {
        "regex": "Kazam|Trooper_X[0-9][0-9](?:[);/ ]|$)|Tornado 348|TROOPER 4\\.0",
        "device": "smartphone",
        "models": [
            {
                "regex": "Tornado 348",
                "model": "Tornado 348"
            },
            {
                "regex": "Thunder 450W",
                "model": "Thunder 450W"
            },
            {
                "regex": "TROOPER 4\\.0",
                "model": "Trooper X4.0"
            },
            {
                "regex": "Trooper_X([0-9])([0-9])(?:[);/ ]|$)",
                "model": "Trooper X$1.$2"
            },
            {
                "regex": "Kazam[; _]([^;/)]+)(?: Build|\\))",
                "model": "$1"
            }
        ]
    },
    "Keneksi": {
        "regex": "KENEKSI|(?:Hemera|Teta Dual|Helios)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Hemera|Teta Dual|Helios)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "KENEKSI[ _-]liberty",
                "model": "Liberty"
            },
            {
                "regex": "KENEKSI[ _-]FLASH",
                "model": "Flash"
            },
            {
                "regex": "KENEKSI[ _-]SUN",
                "model": "Sun"
            },
            {
                "regex": "KENEKSI[ _-]ZETA",
                "model": "Zeta"
            },
            {
                "regex": "KENEKSI[ _-]SIGMA",
                "model": "Sigma"
            },
            {
                "regex": "KENEKSI[ _-](Moon|Libra_Dual|Glass|Amber|Chance|Amulet|Choice|Crystal|Dream|Delta[_ ]Dual|Norma 2|Norma|Sky|Fire 2|Fire|Flame|Flora|Rock|Solo|Soul|Step|Smart|Star|Storm|Wind)",
                "model": "$1"
            }
        ]
    },
    "Kempler & Strauss": {
        "regex": "Alumini_?3_?Plus|Alumini ?[23]|KEMPLER_(?:P1|TV|X|8_PLUS)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Alumini ?2",
                "model": "Alumini 2"
            },
            {
                "regex": "Alumini_?3_?Plus",
                "model": "Alumini 3 Plus"
            },
            {
                "regex": "Alumini3",
                "model": "Alumini 3"
            },
            {
                "regex": "KEMPLER_P1",
                "model": "P1"
            },
            {
                "regex": "KEMPLER_TV",
                "model": "TV"
            },
            {
                "regex": "KEMPLER_X",
                "model": "X"
            },
            {
                "regex": "KEMPLER_8_PLUS",
                "model": "8 Plus"
            }
        ]
    },
    "Kiano": {
        "regex": "Kiano|Elegance_[45]_[015](?:_PRO)?|Elegance 6|CORE 10.1 DUAL 3G|Intelect ?(7|8|10)|Slim ?Tab ?\\d+(?:[_ ]3GR?)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Slim ?Tab ?(\\d+)(?:[_ ]3GR?)?",
                "model": "Slim Tab $1",
                "device": "tablet"
            },
            {
                "regex": "CORE 10.1 DUAL 3G",
                "model": "CORE 10.1 DUAL 3G",
                "device": "tablet"
            },
            {
                "regex": "Elegance_(5)_([51])_Pro",
                "model": "Elegance $1.$2\" Pro"
            },
            {
                "regex": "Elegance_([45])_([015])",
                "model": "Elegance $1.$2\""
            },
            {
                "regex": "Elegance 6",
                "model": "Elegance 6 5.85\""
            },
            {
                "regex": "(Kiano)?(Intelect|Elegance) ?(7|8|10)?",
                "model": "$2 $3",
                "device": "tablet"
            },
            {
                "regex": "Kiano[ _]([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Kingsun": {
        "regex": "Kingsun[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Kingsun[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Kingsun[ -]((?!Build)[a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Kocaso": {
        "regex": "Kocaso|M(?:729|7[357][026][hw]?|76[01236][bw]?|83[016]|8[567]0|1050s|106[012368]w?|1070|X736(?:-kit)?|X780)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "M729(?:[);/ ]|$)",
                "model": "M729"
            },
            {
                "regex": "M(7[357][026])[hw]?(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "M(76[01236])[bw]?(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "MX780(?:[);/ ]|$)",
                "model": "MX780"
            },
            {
                "regex": "M(83[016])(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "M(8[567]0)(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "M851(?:[);/ ]|$)",
                "model": "M851"
            },
            {
                "regex": "M1050S(?:[);/ ]|$)",
                "model": "M1050s"
            },
            {
                "regex": "M(106[012368])W?(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "M1070(?:[);/ ]|$)",
                "model": "M1070"
            },
            {
                "regex": "MX736(?:-kit)?(?:[);/ ]|$)",
                "model": "MX736"
            },
            {
                "regex": "MX780(?:[);/ ]|$)",
                "model": "MX780"
            },
            {
                "regex": "Kocaso[ _\\-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Kocaso[ _\\-]?([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Kogan": {
        "regex": "Kogan",
        "device": "smartphone",
        "models": [
            {
                "regex": "Kogan[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Kogan[ _-]([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Komu": {
        "regex": "Komu[ -]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Komu[ -]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Komu[ -]([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Koobee": {
        "regex": "Koobee",
        "device": "smartphone",
        "models": [
            {
                "regex": "Koobee[ _\\-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Koobee[ _\\-]?([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Kumai": {
        "regex": "(?:KM-)?Kumai",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:KM-)?Kumai[ _\\-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:KM-)?Kumai[ _\\-]?([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "KT-Tech": {
        "regex": "(KM-[a-z0-9]+|EV-[a-z0-9]+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "KDDI": {
        "regex": "kddi-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Kodak": {
        "regex": "KODAK|(?:IM5|Ektra|Smartway_T1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IM5",
                "model": "IM5"
            },
            {
                "regex": "Ektra(?:[);/ ]|$)",
                "model": "Ektra"
            },
            {
                "regex": "(?:KODAK[_ ])?SMARTWAY[_ ]([MTX]1)",
                "model": "Smartway $1"
            },
            {
                "regex": "Tablet (7|10)",
                "device": "tablet",
                "model": "Tablet $1"
            }
        ]
    },
    "KOPO": {
        "regex": "KOPO[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "KOPO[ _\\-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "KOPO[ _\\-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Koridy": {
        "regex": "KORIDY[ _-]([^/;]+) Build",
        "device": "smartphone",
        "model": "$1"
    },
    "KRONO": {
        "regex": "NET1100|NET_(?:TITAN|VOLT)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NET1100",
                "model": "NET 1100"
            },
            {
                "regex": "NET_(TITAN|VOLT)",
                "model": "NET $1"
            }
        ]
    },
    "K-Touch": {
        "regex": "K-?Touch[ _][a-z0-9]+",
        "device": "smartphone",
        "models": [
            {
                "regex": "K-?Touch[ _]([^/;]*)[ _]Build",
                "model": "$1"
            },
            {
                "regex": "K-?Touch[ _]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Diva": {
        "regex": "(QC-(?:703GN|704GA|803GN|1013G|7BHD))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Kyocera": {
        "regex": "Kyocera|KWC-|QC-[0-9]{4}|(?:QC6035|NP501KC|302KC|503KC|602KC|705KC|901KC|C51[27]0|C5155|C5215|C67[35]0|C6522N?|C6530N|C6740N?|C6743|E6[89]10|KYL2[13]|KYV3[13-9]|KYT3[123]|KYF3[123579]|KYF40|KYX31|KYG01|KYY2[1-4]|S2151|KC-S701|S[468]-KC|KYV40U?|KYV4[1-8]|KYV4[47]|KC-S301AE|X3-KC|E6560[CT]|E6782[L]?|E6790(?:TM)?|[47]04KC|A001KC|WX10K|URBANO PROGRESSO|E7110)(?:[-_]u2?)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "C5120(?:[);/ ]|$)",
                "model": "Milano"
            },
            {
                "regex": "S4-KC(?:[);/ ]|$)",
                "model": "One S4"
            },
            {
                "regex": "S6-KC(?:[);/ ]|$)",
                "model": "One S6"
            },
            {
                "regex": "S8-KC(?:[);/ ]|$)",
                "model": "One S8"
            },
            {
                "regex": "C5155(?:[);/ ]|$)",
                "model": "Rise"
            },
            {
                "regex": "602KC(?:[);/ ]|$)",
                "model": "Digno G"
            },
            {
                "regex": "503KC(?:[);/ ]|$)",
                "model": "Digno E"
            },
            {
                "regex": "404KC(?:[);/ ]|$)",
                "model": "Digno C"
            },
            {
                "regex": "704KC(?:[);/ ]|$)",
                "model": "Digno J"
            },
            {
                "regex": "302KC(?:[);/ ]|$)",
                "model": "Digno T"
            },
            {
                "regex": "NP501KC(?:[);/ ]|$)",
                "model": "Digno"
            },
            {
                "regex": "WX10K(?:[);/ ]|$)",
                "model": "Digno Dual 2"
            },
            {
                "regex": "KYV36(?:[);/ ]|$)",
                "model": "Digno Rafre"
            },
            {
                "regex": "901KC(?:[);/ ]|$)",
                "model": "Digno BX"
            },
            {
                "regex": "KYV39(?:[);/ ]|$)",
                "model": "Miraie F"
            },
            {
                "regex": "KYX31(?:[);/ ]|$)",
                "model": "Infobar XV"
            },
            {
                "regex": "C5170(?:[);/ ]|$)",
                "model": "Hydro"
            },
            {
                "regex": "C5215(?:[);/ ]|$)",
                "model": "Hydro EDGE"
            },
            {
                "regex": "C6522N?",
                "model": "Hydro XTRM"
            },
            {
                "regex": "C6730",
                "model": "Hydro ICON"
            },
            {
                "regex": "C6750",
                "model": "Hydro ELITE"
            },
            {
                "regex": "C6530N",
                "model": "Hydro LIFE"
            },
            {
                "regex": "C6740(N)?",
                "model": "Hydro WAVE"
            },
            {
                "regex": "C6743",
                "model": "Hydro Reach"
            },
            {
                "regex": "E6560[CT]",
                "model": "DuraForce"
            },
            {
                "regex": "E6810",
                "model": "DuraForce Pro"
            },
            {
                "regex": "E6910",
                "model": "DuraForce Pro 2"
            },
            {
                "regex": "E7110",
                "model": "DuraForce Ultra 5G"
            },
            {
                "regex": "KC-S701",
                "model": "Torque"
            },
            {
                "regex": "KYG01",
                "model": "Torque 5G"
            },
            {
                "regex": "KYL21(?:[);/ ]|$)",
                "model": "Digno S"
            },
            {
                "regex": "KYL23(?:[);/ ]|$)",
                "model": "Miraie"
            },
            {
                "regex": "KYY24(?:[);/ ]|$)",
                "model": "Torque G01"
            },
            {
                "regex": "KYF32(?:[);/ ]|$)",
                "model": "Easy Mobile Phone"
            },
            {
                "regex": "KYF35(?:[);/ ]|$)",
                "model": "Marvera"
            },
            {
                "regex": "KYF40(?:[);/ ]|$)",
                "model": "Mamorino 5"
            },
            {
                "regex": "KYF3[179](?:[);/ ]|$)",
                "model": "Gratina 4G"
            },
            {
                "regex": "KYV48(?:[);/ ]|$)",
                "model": "Gratina KYV48"
            },
            {
                "regex": "KYF33(?:[);/ ]|$)",
                "model": "Torque X01"
            },
            {
                "regex": "KYV35(?:[);/ ]|$)",
                "model": "Torque G02"
            },
            {
                "regex": "KYV41(?:[);/ ]|$)",
                "model": "Torque G03"
            },
            {
                "regex": "KYV46(?:[);/ ]|$)",
                "model": "Torque G04"
            },
            {
                "regex": "KYV47(?:-u)?(?:[);/ ]|$)",
                "model": "Basio 4"
            },
            {
                "regex": "KYV43(?:[);/ ]|$)",
                "model": "Basio 3"
            },
            {
                "regex": "705KC(?:[);/ ]|$)",
                "model": "Kantan Sumaho"
            },
            {
                "regex": "KYV37(?:[);/ ]|$)",
                "model": "Qua Phone"
            },
            {
                "regex": "KYV42(?:_u)?(?:[);/ ]|$)",
                "model": "Qua Phone QX"
            },
            {
                "regex": "KYV44(?:_u2?)?(?:[);/ ]|$)",
                "model": "Qua Phone QZ"
            },
            {
                "regex": "KYT33(?:[);/ ]|$)",
                "model": "Qua Tab QZ10",
                "device": "tablet"
            },
            {
                "regex": "KYT32(?:[);/ ]|$)",
                "model": "Qua Tab QZ8",
                "device": "tablet"
            },
            {
                "regex": "KYT31(?:[);/ ]|$)",
                "model": "Qua Tab 01",
                "device": "tablet"
            },
            {
                "regex": "KYV40U?(?:[);/ ]|$)",
                "model": "Rafre"
            },
            {
                "regex": "KYV33(?:[);/ ]|$)",
                "model": "Infobar A03"
            },
            {
                "regex": "KYY21(?:[);/ ]|$)",
                "model": "Urbano L01"
            },
            {
                "regex": "KYY22(?:[);/ ]|$)",
                "model": "Urbano L02"
            },
            {
                "regex": "KYY23(?:[);/ ]|$)",
                "model": "Urbano L03"
            },
            {
                "regex": "KYV31(?:[);/ ]|$)",
                "model": "Urbano V01"
            },
            {
                "regex": "KYV34(?:[);/ ]|$)",
                "model": "Urbano V02"
            },
            {
                "regex": "KYV(?:45|38)(?:[);/ ]|$)",
                "model": "Urbano V03"
            },
            {
                "regex": "(?:Kyocera-)?E6790(?:TM)?",
                "model": "DuraForce XD"
            },
            {
                "regex": "X3-KC(?:[);/ ]|$)",
                "model": "One X3"
            },
            {
                "regex": "E6782(?:[);/ ]|$)",
                "model": "Brigadier"
            },
            {
                "regex": "E6782L(?:[);/ ]|$)",
                "model": "DuraScout"
            },
            {
                "regex": "(KC-S301AE)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "A001KC(?:[);/ ]|$)",
                "model": "Katan Sumaho 2"
            },
            {
                "regex": "URBANO PROGRESSO(?:[);/ ]|$)",
                "model": "Urbano Progresso"
            },
            {
                "regex": "S2151",
                "model": "Coast",
                "device": "feature phone"
            },
            {
                "regex": "Kyocera-KZ-([a-z0-9]+)",
                "model": "KZ $1"
            },
            {
                "regex": "Kyocera(?:[\\-/])?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(KWC|QC)-?([a-z0-9]+)",
                "model": "$1-$2"
            }
        ]
    },
    "Krüger&Matz": {
        "regex": "Kruger[ _&]Matz|KrugerMatz[ _]|FLOW ?5PLUS|FLOW_5|FLOW7|FLOW6(?:S|Lite)|DRIVE[_ ]6S?|MOVE8mini|MOVE_|LIVE_6plus|LIVE 5 PLUS|LIVE4_KM043[89]|LIVE 7S|KM(?:106[67]|1065G|0701_1|0702|0805_1)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MOVE8mini",
                "model": "MOVE 8 Mini"
            },
            {
                "regex": "MOVE_6_mini",
                "model": "MOVE 6 Mini"
            },
            {
                "regex": "MOVE[_ ]([78]|6S)",
                "model": "MOVE $1"
            },
            {
                "regex": "DRIVE 4 mini LTE",
                "model": "DRIVE 4 mini LTE"
            },
            {
                "regex": "DRIVE[ _]([456][S]?)(?:[);/ ]|$)",
                "model": "DRIVE $1"
            },
            {
                "regex": "FLOW ?5PLUS(?:[);/ ]|$)",
                "model": "FLOW 5 Plus"
            },
            {
                "regex": "FLOW6Lite(?:[);/ ]|$)",
                "model": "FLOW 6 Lite"
            },
            {
                "regex": "FLOW[ _]?([4-7][S]?)(?:[);/ ]|$)",
                "model": "FLOW $1"
            },
            {
                "regex": "LIVE4_(KM043[89])(?:[);/ ]|$)",
                "model": "LIVE 4 $1"
            },
            {
                "regex": "KrugerMatz_LIVE4(?:[);/ ]|$)",
                "model": "LIVE 4"
            },
            {
                "regex": "_LIVE5_(KM0450)(?:[);/ ]|$)",
                "model": "LIVE 5 $1"
            },
            {
                "regex": "LIVE 5 PLUS(?:[);/ ]|$)",
                "model": "LIVE 5 Plus"
            },
            {
                "regex": "LIVE_6plus(?:[);/ ]|$)",
                "model": "LIVE 6 Plus"
            },
            {
                "regex": "LIVE 7S(?:[);/ ]|$)",
                "model": "LIVE 7S"
            },
            {
                "regex": "KM(106[67])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 10.1\""
            },
            {
                "regex": "KM(1065G)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 10.1\""
            },
            {
                "regex": "KM0(701)_1(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 7.1\""
            },
            {
                "regex": "KM0(805)_1(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 8.0\""
            },
            {
                "regex": "KM0(702)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 7.0\""
            }
        ]
    },
    "LAIQ": {
        "regex": "LAIQ",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Glam|New York|Dubai)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "AIS": {
        "regex": "iris708|Kingcomm C500",
        "device": "smartphone",
        "models": [
            {
                "regex": "iris708",
                "model": "LAVA PRO 4.5"
            },
            {
                "regex": "Kingcomm C500",
                "model": "Super Smart Plus X3"
            }
        ]
    },
    "Lava": {
        "regex": "Lava[ _]|LAVAA1|(?:DISCOVER136|KKT QUADRA)|iris[ _]?([^/;]+)(?:\\)| Build)|A(?:67|76) Build|X1 Selfie Build|X41 Plus Build|(?:Flair Z1|PixelV1|Pixel V2|Z61_2GB|A97 IPS|A97 2GB PLUS|L[EH]9920(?:[_ ]P)?|L[NEH]9910|LH9810|Ivory(?:S1|S4G)?|A76Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Flair Z1(?:[);/ ]|$)",
                "model": "Flair Z1"
            },
            {
                "regex": "A97 IPS(?:[);/ ]|$)",
                "model": "A97 IPS"
            },
            {
                "regex": "A97 2GB PLUS(?:[);/ ]|$)",
                "model": "A97 2GB Plus"
            },
            {
                "regex": "A76Plus(?:[);/ ]|$)",
                "model": "A76 Plus"
            },
            {
                "regex": "Pixel ?V([12])(?:[);/ ]|$)",
                "model": "Pixel V$1"
            },
            {
                "regex": "X1 Selfie(?:[);/ ]|$)",
                "model": "Iris X1 Selfie"
            },
            {
                "regex": "X41 Plus(?:[);/ ]|$)",
                "model": "X41 Plus"
            },
            {
                "regex": "(?:LAVA[_ ]?)?A([13]|67|76)(?:[);/ ]|$)",
                "model": "A$1"
            },
            {
                "regex": "LAVA_R1",
                "model": "R1"
            },
            {
                "regex": "Z61_2GB(?:[);/ ]|$)",
                "model": "Z61"
            },
            {
                "regex": "LE9920[ _]P(?:[);/ ]|$)",
                "model": "V7"
            },
            {
                "regex": "LE9920(?:[);/ ]|$)",
                "model": "Z53"
            },
            {
                "regex": "LH9910(?:[);/ ]|$)",
                "model": "Z52"
            },
            {
                "regex": "LH9810(?:[);/ ]|$)",
                "model": "Iris 52"
            },
            {
                "regex": "LN9910(?:[);/ ]|$)",
                "model": "Z41"
            },
            {
                "regex": "LE9910(?:[);/ ]|$)",
                "model": "V8"
            },
            {
                "regex": "LH9920(?:[);/ ]|$)",
                "model": "V+6"
            },
            {
                "regex": "DISCOVER136",
                "device": "feature phone",
                "model": "Discover 136"
            },
            {
                "regex": "KKT QUADRA",
                "device": "feature phone",
                "model": "KKT Quadra"
            },
            {
                "regex": "KKT40[ ]?Power[P\\+]",
                "device": "feature phone",
                "model": "KKT40 Power Plus"
            },
            {
                "regex": "Ivory(S1|S4G)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Ivory $1"
            },
            {
                "regex": "iris[ _]?([^/;]+)(?:\\)| Build)",
                "model": "Iris $1"
            },
            {
                "regex": "Lava[ _]?([^/;]+)(?:/| Build)",
                "model": "$1"
            }
        ]
    },
    "SKG": {
        "regex": "(Modern[ _](?:S10?|S[3679]))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Landvo": {
        "regex": "XM[123]00|(?<!Blade )S6 Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "S6 Build",
                "model": "S6"
            },
            {
                "regex": "XM([123])00([^/;]*) Build",
                "model": "XM$100$2"
            }
        ]
    },
    "Land Rover": {
        "regex": "Land[ ]?Rover[d]?[ _-](?:X1[0-9]|Explore|T878|L15\\+|V18|V[168]|X)(?:[);/ ]|$)|Polar3",
        "device": "smartphone",
        "models": [
            {
                "regex": "Land[ ]?Rover[d]?[ _-](X1[0-9]|Explore|T878|L15\\+|V18|V[168]|X)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Polar3",
                "model": "Ioutdoor Polar 3"
            }
        ]
    },
    "Lanix": {
        "regex": "LANIX-([a-z0-9]+)|Ilium[ _]|IliumPad|X120C|Alpha 950",
        "device": "smartphone",
        "models": [
            {
                "regex": "ILIUM[ _]?PAD[ _]?([^;/]+)(?: Build|[;)])",
                "model": "Ilium Pad $1",
                "device": "tablet"
            },
            {
                "regex": "X120C",
                "model": "Ilium X120C"
            },
            {
                "regex": "Ilium[ _](Alpha [15]s|Alpha [379]|L(?:200|6[12]0|9[0125]0|1[0124]00|1050|1120)|LT5[012]0|M[13579]|S(?:106|520|6[27]0)|X(?:1[12]0|2[0126]0|5[12]0|500B|710)|M[579]s)(?:[);/ ]|$)",
                "model": "Ilium $1"
            },
            {
                "regex": "ILIUM[ _]([^;/]+) Build",
                "model": "Ilium $1"
            },
            {
                "regex": "Alpha 950",
                "model": "Ilium Alpha 950"
            },
            {
                "regex": "LANIX-([a-z0-9]+)",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "Lark": {
        "regex": "(Lark|Cumulus|Evolution|FreeMe|Ultimate (?:X4|7i))[ _-]|Build/Lark|Bjorn[_ ]SP-500|FreeBird 5WiFi",
        "device": "tablet",
        "models": [
            {
                "regex": "Cumulus[ _](5\\.5|[56])[ _]HD",
                "model": "Cumulus $1 HD",
                "device": "smartphone"
            },
            {
                "regex": "FreeMe X2 ([79]) (?:ver|v)?\\.([23])",
                "model": "FreeMe X2 $1 Version $2"
            },
            {
                "regex": "FreeMe X4 7 3G HD",
                "model": "FreeMe X4 7HD 3G"
            },
            {
                "regex": "FreeMe[ _]X2[ _]([7-9])",
                "model": "FreeMe X2 $1"
            },
            {
                "regex": "FreeMe X4[ _]7[_ ]HD",
                "model": "FreeMe X4 7HD"
            },
            {
                "regex": "FreeMe X4[ _]9",
                "model": "FreeMe X4 9"
            },
            {
                "regex": "FreeBird 5WiFi",
                "model": "FreeBird 5 WiFi"
            },
            {
                "regex": "(?:Lark[ _-])?Evolution[ _](X2 7 3G-GPS|X4[_ ]10\\.1|10|X4[_ ]7[ _]IPS)",
                "model": "Evolution $1"
            },
            {
                "regex": "Ul(?:ti|it)mate (X4 10\\.1 3G IPS|X4 8s 3G|7i)",
                "model": "Ultimate $1"
            },
            {
                "regex": "PHABLET 7",
                "model": "Phablet 7"
            },
            {
                "regex": "Phablet 6\\.0",
                "model": "Phablet 6.0",
                "device": "smartphone"
            },
            {
                "regex": "Bjorn[_ ]SP-500",
                "model": "Bjorn SP-500",
                "device": "smartphone"
            },
            {
                "regex": "Cirrus[ _](4\\.5|[45])",
                "model": "Cirrus $1",
                "device": "smartphone"
            },
            {
                "regex": "Lark[ _](Stratus[_ ]5)",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "LCT": {
        "regex": "LCT_([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Le Pan": {
        "regex": "Le ?Pan|TC970 ([^;/]+)Build",
        "device": "tablet",
        "models": [
            {
                "regex": "TC802A",
                "model": "Le Pan Mini"
            },
            {
                "regex": "TC970 ([^;/]+)Build",
                "model": "TC970 $1"
            },
            {
                "regex": "Le ?Pan ?(II|S)(?:[);/ ]|$)",
                "model": "Le Pan $1"
            },
            {
                "regex": "Le ?Pan ?([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Leagoo": {
        "regex": "(?:MY)?LEAGOO[ _-]?|(?:M5 EDGE|KIICAA (POWER|MIX)|Leapad[ _](?:X|7s)|Elite [15]|Venture 1|Z10-E)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LEAGOO[- _]M8[_-]?Pro(?:[);/ ]|$)",
                "model": "M8 Pro"
            },
            {
                "regex": "LEAGOO[- _](Z[156]|M[58]|T1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "M5 EDGE",
                "model": "M5 Edge"
            },
            {
                "regex": "LEAGOO[_ ]Lead([57])",
                "model": "Lead $1"
            },
            {
                "regex": "KIICAA POWER",
                "model": "KICCAA Power"
            },
            {
                "regex": "KIICAA MIX",
                "model": "KICCAA Mix"
            },
            {
                "regex": "Elite ([15])(?:[);/ ]|$)",
                "model": "Elite $1"
            },
            {
                "regex": "Venture 1(?:[);/ ]|$)",
                "model": "Venture 1"
            },
            {
                "regex": "(?:LEAGOO[- _])?(Z10-E|M6)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:My)?Leagoo[- _](E4)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:Leapad[ _])(7s|10|X)",
                "model": "LeaPad $1",
                "device": "tablet"
            }
        ]
    },
    "Ledstar": {
        "regex": "(?:Ledstar[_ ])?(?:Trendy 5.0|Novus_Premium_6.0)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Trendy 5.0",
                "model": "Trendy 5.0"
            },
            {
                "regex": "Ledstar_Novus_Premium_6.0(?:[);/ ]|$)",
                "model": "Novus Premium 6.0\""
            }
        ]
    },
    "LeEco": {
        "regex": "Letv|LeEco|Le ?X[0-9][^;/]+|Le Max|Le [12]|Le2[_ ]x527|X900 Build|(?:X[89]00\\+|X52[67])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "X800\\+",
                "model": "Le 1 Pro"
            },
            {
                "regex": "X900\\+",
                "model": "Max X900+"
            },
            {
                "regex": "X50[10]",
                "model": "Le 1S"
            },
            {
                "regex": "(X910)",
                "model": "$1"
            },
            {
                "regex": "X900 Build",
                "model": "Le X900"
            },
            {
                "regex": "(?:Le ?X526|Le2[_ ]x527|Le 2|X52[67])(?:[);/ ]|$)",
                "model": "Le 2"
            },
            {
                "regex": "Le ?X([^;/]+) Build",
                "model": "Le X$1"
            },
            {
                "regex": "Le ?X([^) ;/]+)",
                "model": "Le X$1"
            },
            {
                "regex": "Le ?([12][^;/]+) Build",
                "model": "Le $1"
            },
            {
                "regex": "Le Max([^;/]*) Build",
                "model": "Le Max$1"
            },
            {
                "regex": "Le Max([^ ;/]*)",
                "model": "Le Max$1"
            },
            {
                "regex": "LeEco ([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Leotec": {
        "regex": "LESPH501[14]|LESPH5003B|SUPERNOVA (Qi16|Qi32|i3G96[X]?)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LESPH5011",
                "model": "Argon e250"
            },
            {
                "regex": "LESPH5003B",
                "model": "Argon A250B"
            },
            {
                "regex": "LESPH5014",
                "model": "Krypton K150"
            },
            {
                "regex": "SUPERNOVA (Qi16|Qi32|i3G96[X]?)",
                "device": "tablet",
                "model": "Supernova $1"
            }
        ]
    },
    "Lephone": {
        "regex": "lephone[ _]|lephoneP1",
        "device": "smartphone",
        "models": [
            {
                "regex": "lephone[ _](K7|K10)",
                "device": "feature phone",
                "model": "$1"
            },
            {
                "regex": "lephone(?:[ _])?(W(1[0125]|[279])|T2|P1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "lephone_W7_plus",
                "model": "W7 Plus"
            }
        ]
    },
    "Lenco": {
        "regex": "Lenco ([^/;]*) Build",
        "device": "tablet",
        "model": "$1"
    },
    "Lenovo": {
        "regex": "(?:LNV-)?Lenovo|IdeaTab|IdeaPad|Thinkpad|Yoga Tablet|Tab2A[0-9]-[0-9]{2}[a-z]?|ZUK[ -_]|(?:TB2-X30L|TB3-710I|YT3-X50[ML]|K50a40|TB-(?:X103F|8504F|X304F|X704V|X704A)|A5500-H|A2107A-H|A3500-HV|A2109A|S6000|Z2 Plus|Vibe[ _](?:P1|S6i Plus|S[23567]i|C|[ZX]2|K5(?: Plus)?|V7)|P2A42|L38011|L18011|[5-8]01LV|[67]02LV|Z2131|K350t|K31-t3|TAB 2 A8-50LC|S90-A|P70-A|VR-1541F)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Lenovo ?G780",
                "model": "G780",
                "device": "desktop"
            },
            {
                "regex": "Lenovo ?A3500-FL",
                "model": "IdeaTab A7-40",
                "device": "tablet"
            },
            {
                "regex": "(?:Lenovo ?)?A3500-(?:H|HV|F)",
                "model": "IdeaTab A7-50",
                "device": "tablet"
            },
            {
                "regex": "(?:Lenovo[ _])?A5500-[HF]",
                "model": "IdeaTab A8-50",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ?A7600-[HF]",
                "model": "IdeaTab A10-70",
                "device": "tablet"
            },
            {
                "regex": "A2107A-H",
                "model": "A2107",
                "device": "tablet"
            },
            {
                "regex": "A2109A",
                "model": "IdeaTab A2109A",
                "device": "tablet"
            },
            {
                "regex": "TB2-X30[FL]",
                "model": "Tab 2 A10-30",
                "device": "tablet"
            },
            {
                "regex": "YT3-X50[FLM]",
                "model": "Yoga Tab 3",
                "device": "tablet"
            },
            {
                "regex": "TB3-730X",
                "model": "TAB3 7",
                "device": "tablet"
            },
            {
                "regex": "TB3-710[IF]",
                "model": "TAB3 7 Essential",
                "device": "tablet"
            },
            {
                "regex": "TB-7703X",
                "model": "TAB3 7 Plus",
                "device": "tablet"
            },
            {
                "regex": "TB3-X70L",
                "model": "TAB3 10 Plus",
                "device": "tablet"
            },
            {
                "regex": "TB-8703X",
                "model": "TAB3 8 Plus",
                "device": "tablet"
            },
            {
                "regex": "TAB 2 A8-50LC",
                "model": "TAB2 A8-50LC",
                "device": "tablet"
            },
            {
                "regex": "501LV(?:[);/ ]|$)",
                "model": "TAB2 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "TAB 2 A10-70L(?:[);/ ]|$)",
                "model": "TAB 2 A10",
                "device": "tablet"
            },
            {
                "regex": "(?:TB3-850[FM]|601LV)(?:[);/ ]|$)",
                "model": "TAB3 8",
                "device": "tablet"
            },
            {
                "regex": "602LV(?:[);/ ]|$)",
                "model": "TAB3 8 Dual",
                "device": "tablet"
            },
            {
                "regex": "TB-X304[FL]",
                "model": "TAB4 10",
                "device": "tablet"
            },
            {
                "regex": "TB-8504X",
                "model": "TAB4 8",
                "device": "tablet"
            },
            {
                "regex": "TB-8704X",
                "model": "TAB4 8 Plus",
                "device": "tablet"
            },
            {
                "regex": "(?:TB-X704[FVL]|70[12]LV)(?:[);/ ]|$)",
                "model": "TAB4 10 Plus",
                "device": "tablet"
            },
            {
                "regex": "801LV(?:[);/ ]|$)",
                "model": "TAB5 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "TB-X103F(?:[);/ ]|$)",
                "model": "TAB10 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "TB-X704A(?:[);/ ]|$)",
                "model": "Moto Tab",
                "device": "tablet"
            },
            {
                "regex": "TB-X605F(?:[);/ ]|$)",
                "model": "Tab M10",
                "device": "tablet"
            },
            {
                "regex": "TB-X705F(?:[);/ ]|$)",
                "model": "Tab P10",
                "device": "tablet"
            },
            {
                "regex": "TB-X705F(?:[);/ ]|$)",
                "model": "Tab P10",
                "device": "tablet"
            },
            {
                "regex": "TB-7104I(?:[);/ ]|$)",
                "model": "Tab E7",
                "device": "tablet"
            },
            {
                "regex": "TB-8304F1(?:[);/ ]|$)",
                "model": "Tab E8",
                "device": "tablet"
            },
            {
                "regex": "TB-7304X(?:[);/ ]|$)",
                "model": "Tab 7 Essential",
                "device": "tablet"
            },
            {
                "regex": "TB-7504X(?:[);/ ]|$)",
                "model": "Tab 7",
                "device": "tablet"
            },
            {
                "regex": "TB-X606[FXV](?:[);/ ]|$)",
                "model": "Tab M10 FHD Plus",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ?B8000(-[FH])?",
                "model": "Yoga Tablet 10",
                "device": "tablet"
            },
            {
                "regex": "YOGA Tablet 2 Pro-1380[FL]",
                "model": "Yoga Tablet 2 Pro 13.3\"",
                "device": "tablet"
            },
            {
                "regex": "YOGA Tablet 2-1050[FL]",
                "model": "Yoga Tablet 2 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "YOGA Tablet 2-830(?:[FL]|LC)",
                "model": "Yoga Tablet 2 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ?B6000(-[FH])?",
                "model": "Yoga Tablet 8",
                "device": "tablet"
            },
            {
                "regex": "YT3-X90(L|F|X)",
                "model": "Yoga 3 Pro",
                "device": "tablet"
            },
            {
                "regex": "YT3-850[FL]",
                "model": "Yoga Tab 3 8",
                "device": "tablet"
            },
            {
                "regex": "YT3-850M",
                "model": "Yoga Tab 3 10",
                "device": "tablet"
            },
            {
                "regex": "YT-X703L",
                "model": "Yoga Tab 3 Plus",
                "device": "tablet"
            },
            {
                "regex": "S6000(?:[);/ ]|$)",
                "model": "IdeaTab S6000",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ([ASB][0-9]{4})[A-Z]?\\-[EHF]",
                "model": "IdeaTab $1",
                "device": "tablet"
            },
            {
                "regex": "ThinkPadTablet_(A[0-9]{3})_",
                "model": "ThinkPad Tablet $1",
                "device": "tablet"
            },
            {
                "regex": "ThinkPad ?Tablet([^;/]*) Build",
                "model": "ThinkPad Tablet$1",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ?A3300-(?:GV|H)",
                "model": "TAB 2 A7-30",
                "device": "tablet"
            },
            {
                "regex": "TAB 2 A7-30[HGD]C",
                "model": "TAB 2 A7",
                "device": "tablet"
            },
            {
                "regex": "TB-8504F",
                "model": "TAB 4 8",
                "device": "tablet"
            },
            {
                "regex": "TB-X304X",
                "model": "Tab 4 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "TB-X304X",
                "model": "Tab 4 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "TB-X304F",
                "model": "TAB4 10",
                "device": "tablet"
            },
            {
                "regex": "TB-X505[FX]",
                "model": "M10",
                "device": "tablet"
            },
            {
                "regex": "TB-X104[FXL]",
                "model": "E10",
                "device": "tablet"
            },
            {
                "regex": "Tab2A([0-9]-[0-9]{2}[a-z]?)",
                "model": "TAB 2 A$1",
                "device": "tablet"
            },
            {
                "regex": "IdeaTab[ \\-_]?([a-z0-9]+)",
                "model": "IdeaTab $1",
                "device": "tablet"
            },
            {
                "regex": "Yoga Tablet([^;/]+) Build",
                "model": "Yoga Tablet$1",
                "device": "tablet"
            },
            {
                "regex": "TB-8505F",
                "model": "Tab M8",
                "device": "tablet"
            },
            {
                "regex": "TB-8705F",
                "model": "Tab M8 FHD",
                "device": "tablet"
            },
            {
                "regex": "TB-8705F",
                "model": "Tab M8 FHD",
                "device": "tablet"
            },
            {
                "regex": "Lenovo (TB[0-9]?\\-[a-z0-9\\-]+) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "L18011(?:[);/ ]|$)",
                "model": "A5"
            },
            {
                "regex": "Z2 Plus",
                "model": "Z2 Plus"
            },
            {
                "regex": "Z2151",
                "model": "ZUK Edge"
            },
            {
                "regex": "Z213[12]",
                "model": "ZUK Z2"
            },
            {
                "regex": "Z2121",
                "model": "ZUK Z2 Pro"
            },
            {
                "regex": "ZUK[ -_]([^/;]*)(?: Build|\\))",
                "model": "ZUK $1"
            },
            {
                "regex": "K10a40(?:[);/ ]|$)",
                "model": "C2"
            },
            {
                "regex": "k50a40(?:[);/ ]|$)",
                "model": "K3 Note"
            },
            {
                "regex": "A7010a48(?:[);/ ]|$)",
                "model": "K4 Note"
            },
            {
                "regex": "K350t(?:[);/ ]|$)",
                "model": "K5"
            },
            {
                "regex": "L38011(?:[);/ ]|$)",
                "model": "K5 Play"
            },
            {
                "regex": "A7020a4[08](?:[);/ ]|$)",
                "model": "K5 Note"
            },
            {
                "regex": "K31-t3(?:[);/ ]|$)",
                "model": "K31"
            },
            {
                "regex": "(?:A6020a46|Vibe K5 Plus)(?:[);/ ]|$)",
                "model": "Vibe K5 Plus"
            },
            {
                "regex": "(?:Lenovo-)?(?:A6020(?:a40|l36)|Vibe K5)(?:[);/ ]|$)",
                "model": "Vibe K5"
            },
            {
                "regex": "VIBE Z2(?:[);/ ]|$)",
                "model": "Vibe Z2"
            },
            {
                "regex": "VIBE C(?:[);/ ]|$)",
                "model": "Vibe C"
            },
            {
                "regex": "VIBE X2(?:[);/ ]|$)",
                "model": "Vibe X2"
            },
            {
                "regex": "VIBE V7(?:[);/ ]|$)",
                "model": "Vibe V7"
            },
            {
                "regex": "VIBE S6i Plus(?:[);/ ]|$)",
                "model": "Vibe S6i Plus"
            },
            {
                "regex": "VIBE[ _]S([23567])i(?:[);/ ]|$)",
                "model": "Vibe S$1i"
            },
            {
                "regex": "k33a48(?:[);/ ]|$)",
                "model": "K6"
            },
            {
                "regex": "P2A42(?:[);/ ]|$)",
                "model": "P2"
            },
            {
                "regex": "k53a48(?:[);/ ]|$)",
                "model": "K6 Note"
            },
            {
                "regex": "K33a42(?:[);/ ]|$)",
                "model": "K6 Power"
            },
            {
                "regex": "P1ma40(?:[);/ ]|$)",
                "model": "Vibe P1m"
            },
            {
                "regex": "Vibe P1 Turbo(?:[);/ ]|$)",
                "model": "Vibe P1 Turbo"
            },
            {
                "regex": "(?:P1(?:a42|c72)|Vibe P1)(?:[);/ ]|$)",
                "model": "Vibe P1"
            },
            {
                "regex": "A2016a40(?:[);/ ]|$)",
                "model": "Vibe B"
            },
            {
                "regex": "A1010a20(?:[);/ ]|$)",
                "model": "A Plus"
            },
            {
                "regex": "Z90a40(?:[);/ ]|$)",
                "model": "Vibe Shot"
            },
            {
                "regex": "S1a40(?:[);/ ]|$)",
                "model": "Vibe S1"
            },
            {
                "regex": "L78071(?:[);/ ]|$)",
                "model": "Z5s"
            },
            {
                "regex": "L58041(?:[);/ ]|$)",
                "model": "S5 Pro"
            },
            {
                "regex": "L18021(?:[);/ ]|$)",
                "model": "A3"
            },
            {
                "regex": "PB2-670M(?:[);/ ]|$)",
                "model": "Phab 2"
            },
            {
                "regex": "(S90-A|P70-A)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "IdeaPad ?([^;/]*) Build",
                "model": "IdeaPad $1",
                "device": "tablet"
            },
            {
                "regex": "VR-1541F",
                "device": "wearable",
                "model": "Mirage Solo"
            },
            {
                "regex": "LENOVO/81W8(?:[);/ ]|$)",
                "device": "desktop",
                "model": "IdeaPad S145-15IIL"
            },
            {
                "regex": "LENOVO/81MV(?:[);/ ]|$)",
                "device": "desktop",
                "model": "IdeaPad S145-15IWL"
            },
            {
                "regex": "LENOVO/81SS(?:[);/ ]|$)",
                "device": "desktop",
                "model": "Flex 14API 81SS"
            },
            {
                "regex": "Lenovo TAB ?([^/;]*) Build",
                "model": "TAB $1",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ([^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "(?:LNV-|Lenovo-)?Lenovo[ \\-_]?([a-z0-9_+\\-]+)",
                "model": "$1"
            }
        ]
    },
    "Lexand": {
        "regex": "(?:SC7 PRO HD|S5A[1-4]|S4A[1-5]|S6A1|A811|A802)(?:[);/ ]|$)|Lexand ([^;/]+) Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "A(811|802)",
                "device": "tablet",
                "model": "A$1"
            },
            {
                "regex": "S4A1",
                "model": "Vega"
            },
            {
                "regex": "S4A2",
                "model": "Irida"
            },
            {
                "regex": "S4A3",
                "model": "Pallada"
            },
            {
                "regex": "S4A5",
                "model": "Oxygen"
            },
            {
                "regex": "S4A4 NEON",
                "model": "S4A4 Neon"
            },
            {
                "regex": "S5A1",
                "model": "Callisto"
            },
            {
                "regex": "S5A2",
                "model": "Overon"
            },
            {
                "regex": "S5A3",
                "model": "Capella"
            },
            {
                "regex": "S5A4",
                "model": "Argon"
            },
            {
                "regex": "S6A1",
                "model": "Antares"
            },
            {
                "regex": "SC7 PRO HD",
                "model": "SC7 PRO HD"
            },
            {
                "regex": "Lexand ([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Lexibook": {
        "regex": "(MFC[0-9]{3}[a-z]{2,})",
        "device": "tablet",
        "models": [
            {
                "regex": "MFC191FR",
                "model": "Tablet Ultra 3 XL"
            },
            {
                "regex": "MFC045FR",
                "model": "TabTab"
            },
            {
                "regex": "MFC163FR",
                "model": "Tablet Master 3"
            },
            {
                "regex": "MFC142FR",
                "model": "Tablet Kids"
            },
            {
                "regex": "MFC250FR",
                "model": "Tablet Junior"
            },
            {
                "regex": "MFC270FR",
                "model": "Tablet Junior Power Touch"
            },
            {
                "regex": "MFC280FR",
                "model": "Tablet Junior 2"
            },
            {
                "regex": "MFC156FR",
                "model": "Tablet One"
            },
            {
                "regex": "MFC155FR",
                "model": "Tablet Master"
            },
            {
                "regex": "MFC157FR",
                "model": "Tablet Master 2"
            },
            {
                "regex": "MFC17[05]FR",
                "model": "Tablet Ultra"
            },
            {
                "regex": "MFC375FR",
                "model": "Tablet Ultra 2"
            },
            {
                "regex": "MFC162FR",
                "model": "Power Tablet"
            },
            {
                "regex": "MFC180FR",
                "model": "Tablet Advanced"
            },
            {
                "regex": "MFC181FR",
                "model": "Tablet Advanced 2"
            },
            {
                "regex": "MFC500FR",
                "model": "Tablet XL"
            },
            {
                "regex": "MFC190BBFR",
                "model": "Barbie Tablet"
            },
            {
                "regex": "MFC195DCFR",
                "model": "Tablet Disney Cars HD"
            },
            {
                "regex": "MFC195FUFR",
                "model": "Furby Tablet"
            },
            {
                "regex": "MFC195DPFR",
                "model": "Tablet Disney Princesse HD"
            },
            {
                "regex": "MFC140FR",
                "model": "LapTab"
            },
            {
                "regex": "MFC141FR",
                "model": "LapTab 2"
            },
            {
                "regex": "(MFC[0-9]{3}[a-z]{2,})",
                "model": "$1"
            }
        ]
    },
    "LG": {
        "regex": "LG|Web0S; Linux/SmartTV|portalmmm/2\\.0 (?:KE|KG|KP|L3)|(?:VX[0-9]+|L-0[12]D|L-07C|P713|(LM-[A-Z][0-9]{3}[A-Z]{0,3}(?:\\(FGN?\\)|\\(G\\)|\\.FN|\\.F(?:GN?)?)?)|LM-(X625N1|G820QM[0127]))(?:[);/ ]|$)|NetCast|RS98[78]|RS500|VS(?:50[01]|835|876|880|98[0578]|99[056]|(410|415|425|500|880)PP)|VS820|VS870 4G|Nexsus 5|LML(41[34]D|211B|713D|212V)L|VK810 4G|VK815|X5-LG|L-05[DE]|L-03K|L-01[LJK]|L-52A|L-[45]1A|901LG|A001LG|80[12]LG|402LG|LGT32|L-02K|L-01F|LM-V40|DM-01K|LMX130IM",
        "device": "smartphone",
        "models": [
            {
                "regex": "DM-01K",
                "model": "Disney Mobile DM-01K"
            },
            {
                "regex": "LG-D325",
                "model": "L70"
            },
            {
                "regex": "LG-D340F8",
                "model": "L70 Tri"
            },
            {
                "regex": "LM-X210APM",
                "model": "Phoenix 4"
            },
            {
                "regex": "LG-P505R",
                "model": "Phoenix"
            },
            {
                "regex": "LM-X210VPP",
                "model": "Zone 4"
            },
            {
                "regex": "LM-X220PM",
                "model": "Tribute Empire"
            },
            {
                "regex": "VS980|L-01F",
                "model": "G2"
            },
            {
                "regex": "LG-D6(?:18|20)",
                "model": "G2 Mini"
            },
            {
                "regex": "LG-D85[01258]|VS985",
                "model": "G3"
            },
            {
                "regex": "LG-D72[2458]",
                "model": "G3 Beat"
            },
            {
                "regex": "LG-H81[158]",
                "model": "G4"
            },
            {
                "regex": "LG-H525n?",
                "model": "G4c"
            },
            {
                "regex": "LG-(?:H540|H542|H630)",
                "model": "G4 Stylus"
            },
            {
                "regex": "LG-H736",
                "model": "G4s"
            },
            {
                "regex": "LG-H735",
                "model": "G4 Beat"
            },
            {
                "regex": "LG-H8(?:20|3[01]|5[08]|6[08])|VS987|RS988",
                "model": "G5"
            },
            {
                "regex": "LG-H84[05]",
                "model": "G5 SE"
            },
            {
                "regex": "VS988|LG-H87(?:0DS|3)",
                "model": "G6"
            },
            {
                "regex": "LM-Q850",
                "model": "G7 Fit"
            },
            {
                "regex": "LM-Q910",
                "model": "G7 One"
            },
            {
                "regex": "LM-G820(N|QM[0127]|UMB)?",
                "model": "G8"
            },
            {
                "regex": "LM-G850",
                "model": "G8X ThinQ"
            },
            {
                "regex": "LM-G810",
                "model": "G8S ThinQ"
            },
            {
                "regex": "901LG(?:[);/ ]|$)",
                "model": "G8X ThinQ"
            },
            {
                "regex": "VS501|LM-X120",
                "model": "K20"
            },
            {
                "regex": "(?:LG-)?H502",
                "model": "Magna"
            },
            {
                "regex": "(?:LG-)?H343",
                "model": "Risio"
            },
            {
                "regex": "(?:LG-)?H650",
                "model": "Zero"
            },
            {
                "regex": "(?:LG-)?M154",
                "model": "Risio 2"
            },
            {
                "regex": "(?:LG-)?P500H",
                "model": "Optimus One"
            },
            {
                "regex": "(L-05[DE])(?:[);/ ]|$)",
                "model": "Optimus it $1"
            },
            {
                "regex": "LG-L160L(?:[);/ ]|$)",
                "model": "Optimus LTE 2"
            },
            {
                "regex": "P713(?:[);/ ]|$)",
                "model": "Optimus L7II"
            },
            {
                "regex": "L-01D(?:[);/ ]|$)",
                "model": "Optimus LTE L-01D"
            },
            {
                "regex": "L-02D(?:[);/ ]|$)",
                "model": "PRADA phone L-02D"
            },
            {
                "regex": "L-07C",
                "model": "Optimus Bright L-07C"
            },
            {
                "regex": "(?:LG-)?F800(?:S|K|L)?",
                "model": "V20"
            },
            {
                "regex": "LM-Q710(?:\\(FGN\\)|[\\.]?FGN)",
                "model": "Q Stylus Plus"
            },
            {
                "regex": "801LG",
                "model": "Q Stylus"
            },
            {
                "regex": "LM-Q[67]10\\.FG(?:[);/ ]|$)",
                "model": "Q7"
            },
            {
                "regex": "LM-(Q725[KL]|Q610.FGN)(?:[);/ ]|$)",
                "model": "Q7+"
            },
            {
                "regex": "LM-Q815[SL](?:[);/ ]|$)",
                "model": "Q8+"
            },
            {
                "regex": "LM-Q925L(?:[);/ ]|$)",
                "model": "Q9"
            },
            {
                "regex": "LM-Q730N(?:[);/ ]|$)",
                "model": "Q70"
            },
            {
                "regex": "LGV33(?:[);/ ]|$)",
                "model": "Qua Phone PX"
            },
            {
                "regex": "L-03K(?:[);/ ]|$)",
                "model": "Style"
            },
            {
                "regex": "L-01L(?:[);/ ]|$)",
                "model": "Style 2"
            },
            {
                "regex": "VS835(?:[);/ ]|$)",
                "model": "Stylo 2 V"
            },
            {
                "regex": "L-41A(?:[);/ ]|$)",
                "model": "Style 3"
            },
            {
                "regex": "LM-Q710|LML713DL",
                "model": "Stylo 4"
            },
            {
                "regex": "(?:LM-Q720|LGL722DL)(?:[);/ ]|$)",
                "model": "Stylo 5"
            },
            {
                "regex": "LM-Q730(?:[);/ ]|$)",
                "model": "Stylo 6"
            },
            {
                "regex": "LM-G710(N|VM)?",
                "model": "G7 ThinQ"
            },
            {
                "regex": "LM-X210CM",
                "model": "Fortune 2"
            },
            {
                "regex": "LM-X410\\.F(?:[);/ ]|$)",
                "model": "Premier Pro"
            },
            {
                "regex": "LML41[34]DL(?:[);/ ]|$)",
                "model": "Premier Pro LTE"
            },
            {
                "regex": "LM-X525",
                "model": "Q60"
            },
            {
                "regex": "LM-X210K",
                "model": "X2"
            },
            {
                "regex": "LG-K580",
                "model": "X Cam"
            },
            {
                "regex": "LM-X510WM",
                "model": "X Power 3"
            },
            {
                "regex": "LM-X(?:41[05]K|410S)",
                "model": "X4"
            },
            {
                "regex": "LM-X(415[LS]|410L)",
                "model": "X4+"
            },
            {
                "regex": "LM-X410(?:\\.FN|\\(FG\\))",
                "model": "K11"
            },
            {
                "regex": "LM-X(?:320|410[UP]M)",
                "model": "K30"
            },
            {
                "regex": "LMX130IM",
                "model": "W10"
            },
            {
                "regex": "LM-X410",
                "model": "LM-X410"
            },
            {
                "regex": "LM-X420N",
                "model": "X4 (2019)"
            },
            {
                "regex": "LG-X230",
                "model": "K4"
            },
            {
                "regex": "LM-X420",
                "model": "K40"
            },
            {
                "regex": "LM-X430(?:[);/ ]|$)",
                "model": "K40S"
            },
            {
                "regex": "LG-X220",
                "model": "K5"
            },
            {
                "regex": "LM-X540",
                "model": "K50S"
            },
            {
                "regex": "(?:802LG|LM-X520)(?:[);/ ]|$)",
                "model": "K50"
            },
            {
                "regex": "402LG",
                "model": "Spray"
            },
            {
                "regex": "L-02K",
                "model": "JoJo"
            },
            {
                "regex": "(?:LM-X510[KLS]|X5-LG)",
                "model": "X5"
            },
            {
                "regex": "LM-X625N1",
                "model": "X6"
            },
            {
                "regex": "LM-X625N",
                "model": "X6 (2019)"
            },
            {
                "regex": "LGMS210",
                "model": "Aristo"
            },
            {
                "regex": "LM-X210[G]?",
                "model": "Aristo 2"
            },
            {
                "regex": "LM-X220",
                "model": "Aristo 3"
            },
            {
                "regex": "LM-V40(?:5|9N)?(?:[);/ ]|$)",
                "model": "V40 ThinQ"
            },
            {
                "regex": "LM-(?:V500N|V450)(?:[);/ ]|$)",
                "model": "V50 ThinQ"
            },
            {
                "regex": "LM-V510N",
                "model": "V50S ThinQ"
            },
            {
                "regex": "LM-Q920N",
                "model": "Q92"
            },
            {
                "regex": "LM-Q927L",
                "model": "Q9 One"
            },
            {
                "regex": "(?:LG-)?(?:RS987|H901|H96[0128]|VS990)",
                "model": "V10"
            },
            {
                "regex": "LG-X240",
                "model": "K8 (2017)"
            },
            {
                "regex": "(?:LG-)?RS500",
                "model": "K8 4G"
            },
            {
                "regex": "(?:LG-)?VS500",
                "model": "K8 V"
            },
            {
                "regex": "LM-X212\\(G\\)",
                "model": "K8 (2018)"
            },
            {
                "regex": "(?:LG-)?H91[058]",
                "model": "V20"
            },
            {
                "regex": "(?:LG-)?H990(?:DS|N|T)?",
                "model": "V20"
            },
            {
                "regex": "(?:LG-)?LS997",
                "model": "V20"
            },
            {
                "regex": "(?:LG-)?VS995",
                "model": "V20"
            },
            {
                "regex": "(?:LG-)?US999",
                "model": "V20"
            },
            {
                "regex": "(?:VS996|LG-(?:H933|H93[012]|H932PR|[LU]S998|AS998)|LGM-V300[KLS])(?:[);/ ]|$)",
                "model": "V30"
            },
            {
                "regex": "L-01J(?:[);/ ]|$)",
                "model": "V20 Pro"
            },
            {
                "regex": "(?:L-01K|LGV35)(?:[);/ ]|$)",
                "model": "V30 Plus"
            },
            {
                "regex": "L-51A(?:[);/ ]|$)",
                "model": "V60"
            },
            {
                "regex": "(?:L-52A|LM-G900N?)(?:[);/ ]|$)",
                "model": "Velvet 5G"
            },
            {
                "regex": "(?:LM-G910)(?:[);/ ]|$)",
                "model": "Velvet 4G"
            },
            {
                "regex": "(?:A001LG|LM-V600)(?:[);/ ]|$)",
                "model": "V60 ThinQ 5G"
            },
            {
                "regex": "(?:LG-)?VS410PP",
                "model": "Optimus Zone"
            },
            {
                "regex": "LM-V350[N]?",
                "model": "V35"
            },
            {
                "regex": "(?:LG-)?VS415PP",
                "model": "Optimus Zone 2"
            },
            {
                "regex": "(?:LG-)?VS425PP",
                "model": "Optimus Zone 3"
            },
            {
                "regex": "(?:LG-)?K100",
                "model": "K3"
            },
            {
                "regex": "(?:LG-?)?(?:K|MS)33[02]",
                "model": "K7"
            },
            {
                "regex": "(?:LG-?)?(?:K|MS)350",
                "model": "K8"
            },
            {
                "regex": "VS500PP",
                "model": "K8 V"
            },
            {
                "regex": "(?:LG-)?K420(?:N)?",
                "model": "K10"
            },
            {
                "regex": "(?:LG-)?K430(?:DS|DSF|DSY)?",
                "model": "K10"
            },
            {
                "regex": "(?:LG-)?M250N?",
                "model": "K10 (2017)"
            },
            {
                "regex": "(?:LG-)?F670[KLS]?",
                "model": "K10"
            },
            {
                "regex": "(?:LG-)?M255",
                "model": "K20"
            },
            {
                "regex": "(?:LG-?)?[MT]P260",
                "model": "K20 Plus"
            },
            {
                "regex": "LM-K200(?:[);/ ]|$)",
                "model": "K22"
            },
            {
                "regex": "LM-K300(?:[);/ ]|$)",
                "model": "K31"
            },
            {
                "regex": "LM-K420(?:[);/ ]|$)",
                "model": "K42"
            },
            {
                "regex": "LM-K500(?:[);/ ]|$)",
                "model": "K51"
            },
            {
                "regex": "LM-K520(?:[);/ ]|$)",
                "model": "K52"
            },
            {
                "regex": "LM-Q510N(?:[);/ ]|$)",
                "model": "Q51"
            },
            {
                "regex": "LM-Q630N?(?:[);/ ]|$)",
                "model": "Q61"
            },
            {
                "regex": "(?:LG-)?M700(?:N|A|DSK|AN)?",
                "model": "Q6"
            },
            {
                "regex": "LM-X440IM",
                "model": "W30"
            },
            {
                "regex": "(?:LG-?)?K220",
                "model": "X Power"
            },
            {
                "regex": "(?:LG-?)?M320",
                "model": "X Power 2"
            },
            {
                "regex": "(?:LG-)?K371",
                "model": "Phoenix 2"
            },
            {
                "regex": "(?:LG-)?M150",
                "model": "Phoenix 3"
            },
            {
                "regex": "(?:LG-)?F100[SL]",
                "model": "Optimus Vu"
            },
            {
                "regex": "(?:LG-)?P880",
                "model": "Optimus 4X HD"
            },
            {
                "regex": "(?:LG-)?(H340n?|H324)",
                "model": "Leon"
            },
            {
                "regex": "(?:LG-)?H342",
                "model": "Leon 4G LTE"
            },
            {
                "regex": "(?:LG-)?H422",
                "model": "Spirit"
            },
            {
                "regex": "(?:LG)?C660",
                "model": "Optimus Pro"
            },
            {
                "regex": "LML21(?:1B|2V)L",
                "model": "Rebel 4"
            },
            {
                "regex": "VS876",
                "model": "Lucid 3"
            },
            {
                "regex": "VS880(PP)?",
                "model": "G Vista"
            },
            {
                "regex": "VS820",
                "model": "Lancet"
            },
            {
                "regex": "VS870 4G",
                "model": "Lucid 2"
            },
            {
                "regex": "LM-F100N?(?:[);/ ]|$)",
                "device": "phablet",
                "model": "WING"
            },
            {
                "regex": "LGUK410",
                "model": "G Pad 7.0\" LTE",
                "device": "tablet"
            },
            {
                "regex": "LGLK430",
                "model": "G Pad F 7.0\"",
                "device": "tablet"
            },
            {
                "regex": "LGLK430",
                "model": "G Pad F 7.0\"",
                "device": "tablet"
            },
            {
                "regex": "LG-V490",
                "model": "G Pad 8.0",
                "device": "tablet"
            },
            {
                "regex": "LGT01",
                "model": "G Pad 8.0\" LTE",
                "device": "tablet"
            },
            {
                "regex": "LG-V500",
                "model": "G Pad 8.3",
                "device": "tablet"
            },
            {
                "regex": "LG-V700",
                "model": "G Pad 10.1",
                "device": "tablet"
            },
            {
                "regex": "LG-V935",
                "model": "G Pad II 10.1",
                "device": "tablet"
            },
            {
                "regex": "LG-V521",
                "model": "G Pad X 8.0",
                "device": "tablet"
            },
            {
                "regex": "VK810",
                "model": "G Pad 8.3 LTE",
                "device": "tablet"
            },
            {
                "regex": "VK815",
                "model": "G Pad X 8.3",
                "device": "tablet"
            },
            {
                "regex": "LGT32",
                "model": "Qua Tad PZ",
                "device": "tablet"
            },
            {
                "regex": "LGT31",
                "model": "Qua Tad PX",
                "device": "tablet"
            },
            {
                "regex": "webOS.TV",
                "device": "tv",
                "model": "WebOS TV"
            },
            {
                "regex": "LGE_DLNA_SDK|NetCast",
                "device": "tv",
                "model": "NetCast"
            },
            {
                "regex": "LG Watch Urbane",
                "device": "wearable",
                "model": "Watch Urbane"
            },
            {
                "regex": "(LM-[A-Z]{1}[0-9]{3}([A-Z]{1,3})?)",
                "model": "$1"
            },
            {
                "regex": "LGE(?: |-LG| LG-AX|-)([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "FBDV/LG-([a-z0-9]+);FBSV",
                "model": "$1"
            },
            {
                "regex": "LGE;([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "LG[ _\\-](V90.*|Optimus[ _\\-]Pad.*) Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "LG(?:/|-LG| |-)?([^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "LG(?:/|-LG| |-)?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "LG; ([a-z0-9 ]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/2.0 ((?:KE|KG|KP|L3)[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(VX[0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Web0S; Linux/SmartTV",
                "device": "tv",
                "model": ""
            }
        ]
    },
    "Lingwin": {
        "regex": "Lingwin[ _\\-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Lingwin[ _\\-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Lingwin[ _\\-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Logicom": {
        "regex": "LOGICOM[_ ]|(TAB950|TAB1062|E731|E812|E912|E1031|POWER BOT|La[ _]Tab[ _](?:7[24]|10[57]|114)|(?:B|C|M|ID|VR)[ _]?BOT[ _]?(?:TAB[ _])?([0-9]+\\+?)(?:PLUS)?|KT712A_4\\.4|L-?IXIR[0-9]*|L-ITE|L-EGANTONE(?:-R)?|L-?EMENT.+|Le[ _]?(?:Hop|Hello|Lift|Hola|Moov[2]?|Must(?: 2)?|Starter L|Fit FR|Spark|Prime|Smooth(?: FR)?))[_);/ ]",
        "device": "tablet",
        "models": [
            {
                "regex": "La[ _]Tab[ _](7[24]|10[57]|114)(?:[);/ ]|$)",
                "model": "La Tab $1"
            },
            {
                "regex": "LOGICOM_LA_TAB_LINK_71",
                "model": "La Tab Link 71"
            },
            {
                "regex": "KT712A_4.4|L-IXIR TAB 701 3G",
                "model": "L-ixir Tab 701 3G"
            },
            {
                "regex": "LIXIR1041",
                "model": "L-ixir Tab 1041"
            },
            {
                "regex": "L-?IXIR[ _]TAB[ _]([^);/]+)( Build|[);])",
                "model": "L-ixir Tab $1"
            },
            {
                "regex": "L-ITE[ _](400M|452|50[46] HD|506R HD|552 HD)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "L-ite $1"
            },
            {
                "regex": "L-ITE[ _]([^;/]+) Build",
                "model": "L-ite Tab $1"
            },
            {
                "regex": "L-?EMENT[ _]?(350|451|40[103]|55[013]|50[15]|500L?)(?:[);/ ]|$)",
                "model": "L-ement $1",
                "device": "smartphone"
            },
            {
                "regex": "L-?EMENT[ _](?:TAB)[ )]?([^);/]+)(?: Build|[);])",
                "model": "L-ement Tab $1"
            },
            {
                "regex": "L-?EMENT[ _]?(74[01])(?:[);/ ]|$)",
                "model": "L-ement Tab $1"
            },
            {
                "regex": "(TAB950|TAB1062|E731|E812|E912|E1031)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "POWER BOT",
                "model": "POWER BOT"
            },
            {
                "regex": "((?:B|C|M|ID|VR))[ _]?BOT[ _]?((?:TAB[ _])?([0-9]+\\+?)(?:PLUS)?)",
                "model": "$1 BOT $2"
            },
            {
                "regex": "Le Lift",
                "model": "Le Lift",
                "device": "smartphone"
            },
            {
                "regex": "Le Hola FR(?:[);/ ]|$)",
                "model": "Le Hola FR",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Hola(?:[);/ ]|$)",
                "model": "Le Hola",
                "device": "smartphone"
            },
            {
                "regex": "LeMoov2(?:[);/ ]|$)",
                "model": "Le Moov 2",
                "device": "smartphone"
            },
            {
                "regex": "LeMoov(?:[);/ ]|$)",
                "model": "Le Moov",
                "device": "smartphone"
            },
            {
                "regex": "Le Fit FR(?:[);/ ]|$)",
                "model": "Le Fit FR",
                "device": "smartphone"
            },
            {
                "regex": "Le Hop(?:[);/ ]|$)",
                "model": "Le Hop",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Hello(?:[);/ ]|$)",
                "model": "Le Hello",
                "device": "smartphone"
            },
            {
                "regex": "Le Smooth FR(?:[);/ ]|$)",
                "model": "Le Smooth FR",
                "device": "smartphone"
            },
            {
                "regex": "Le Smooth(?:[);/ ]|$)",
                "model": "Le Smooth",
                "device": "smartphone"
            },
            {
                "regex": "Le Must 2(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Le Must 2"
            },
            {
                "regex": "Le Must(?:[);/ ]|$)",
                "model": "Le Must",
                "device": "smartphone"
            },
            {
                "regex": "Le Starter L(?:[);/ ]|$)",
                "model": "Le Starter L",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Spark(?:[);/ ]|$)",
                "model": "Le Spark",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Prime(?:[);/ ]|$)",
                "model": "Le Prime",
                "device": "smartphone"
            },
            {
                "regex": "L-EGANTONE-R",
                "model": "L-Egant One R",
                "device": "smartphone"
            },
            {
                "regex": "L-EGANTONE",
                "model": "L-Egant One",
                "device": "smartphone"
            }
        ]
    },
    "Konka": {
        "regex": "KONKA[_ ]([a-z0-9]+)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E5660S",
                "model": "Viva 5660s"
            },
            {
                "regex": "W830",
                "model": "Tango 830"
            },
            {
                "regex": "W(9[67]0)",
                "model": "Expose $1"
            },
            {
                "regex": "W990",
                "model": "Tuxedo 990"
            },
            {
                "regex": "KONKA[_ ]([a-z0-9]+)",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "Konrow": {
        "regex": "(?:BIGCOOL|COOLFIVE|COOL-K|Just5|Link5|EASY(?:5|62)|CITY55|Cool55)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BIGCOOL(?:[);/ ]|$)",
                "model": "BigCool"
            },
            {
                "regex": "COOL-K(?:[);/ ]|$)",
                "model": "Cool-K"
            },
            {
                "regex": "Cool55(?:[);/ ]|$)",
                "model": "Cool 55"
            },
            {
                "regex": "COOLFIVE(?:[);/ ]|$)",
                "model": "Cool Five"
            },
            {
                "regex": "Just5(?:[);/ ]|$)",
                "model": "Just 5"
            },
            {
                "regex": "Link5(?:[);/ ]|$)",
                "model": "Link 5"
            },
            {
                "regex": "EASY(5|62)(?:[);/ ]|$)",
                "model": "Easy $1"
            },
            {
                "regex": "CITY55(?:[);/ ]|$)",
                "model": "City 55"
            }
        ]
    },
    "Karbonn": {
        "regex": "(?:Browser-)?Karbonn|K9 Kavach 4G|K9[_ ]Viraat[_ ]Plus|K9 Music 4G|K9 Smart|K9 VIRAAT 4G|Aura (?:Sleek Plus|Power 4G Plus|Note Play)|Titanium[ _](?:3D-Plex|Octane Plus|Vista 4G|Jumbo|S360|S1[059]|S35|S20[13]|S22|S[15]|S200 HD|Frames S7|MOGHUL|S9)|K-lite F3|Sparkle V|Alfa A114 Quad|Quattro L55 HD",
        "device": "smartphone",
        "models": [
            {
                "regex": "K9 Kavach 4G",
                "model": "K9 Kavach 4G"
            },
            {
                "regex": "K9 Music 4G",
                "model": "K9 Music 4G"
            },
            {
                "regex": "K9 Smart 1GB",
                "model": "K9 Smart"
            },
            {
                "regex": "K9 Smart 4G",
                "model": "K9 Smart 4G"
            },
            {
                "regex": "K9 Smart Grand",
                "model": "K9 Smart Grand"
            },
            {
                "regex": "K9 Smart Yuva",
                "model": "K9 Smart Yuva"
            },
            {
                "regex": "K9 Smart",
                "model": "K9 Smart"
            },
            {
                "regex": "K9[_ ]Viraat[_ ]Plus",
                "model": "K9 Viraat Plus"
            },
            {
                "regex": "Aura Sleek Plus",
                "model": "Aura Sleek Plus"
            },
            {
                "regex": "Aura Power 4G Plus",
                "model": "Aura Power 4G Plus"
            },
            {
                "regex": "Aura Note Play",
                "model": "Aura Note Play"
            },
            {
                "regex": "Alfa A114 Quad",
                "model": "Alfa A114 Quad"
            },
            {
                "regex": "karbonnK9 Viraat 4G|K9 VIRAAT 4G",
                "model": "K9 Viraat 4G"
            },
            {
                "regex": "Titanium[ _]S2[ _]Plus",
                "model": "Titanium S2 Plus"
            },
            {
                "regex": "Titanium_S9Plus",
                "model": "Titanium S9 Plus"
            },
            {
                "regex": "Titanium[_ ]S(99|360|1[059]|109|35|200 HD|20[13]|22|[15])(?:[);/ ]|$)",
                "model": "Titanium S$1"
            },
            {
                "regex": "Titanium Vista 4G",
                "model": "Titanium Vista 4G"
            },
            {
                "regex": "Titanium Jumbo 2",
                "model": "Titanium Jumbo 2"
            },
            {
                "regex": "Titanium Jumbo",
                "model": "Titanium Jumbo"
            },
            {
                "regex": "Titanium[ _]MOGHUL",
                "model": "Titanium Moghul"
            },
            {
                "regex": "Titanium Frames S7",
                "model": "Titanium Frames S7"
            },
            {
                "regex": "Titanium Octane Plus",
                "model": "Titanium Octane Plus"
            },
            {
                "regex": "Titanium[ _]3D-Plex",
                "model": "Titanium 3D Plex"
            },
            {
                "regex": "K-lite F3",
                "model": "K-Lite F3"
            },
            {
                "regex": "Sparkle V",
                "model": "Sparkle V"
            },
            {
                "regex": "Quattro L55 HD",
                "model": "Quattro L55 HD"
            },
            {
                "regex": "Karbonn ([a-z0-9]+) WAP-Browser",
                "model": "$1",
                "device": "feature phone"
            },
            {
                "regex": "WAP Browser-Karbonn ([a-z0-9]+)/",
                "model": "$1",
                "device": "feature phone"
            },
            {
                "regex": "Karbonn_([^;/)]+)",
                "model": "$1"
            },
            {
                "regex": "Karbonn ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Karbonn ([^;/]+)/",
                "model": "$1"
            }
        ]
    },
    "Sagem": {
        "regex": "SAGEM|portalmmm/2.0 (?:SG|my)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SAGEM-(my[a-z0-9\\-]+)",
                "model": "$1",
                "device": "feature phone"
            },
            {
                "regex": "SAGEM ([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SAGEM-([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/2.0 ((?:SG|my)[a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Coby Kyros": {
        "regex": "(MID(?:1024|1125|1126|1045|1048|1060|1065|4331|7012|7015A?|7016|7022|7032|7035|7036|7042|7047|7048|7052|7065|7120|8024|8042|8048|8065|8125|8127|8128|9724|9740|9742))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Mpman": {
        "regex": "(?:MPQC|MPDC)[0-9]+|PH(?:150|340|350|360|451|500|520|544|604)|(?:MID(?:7C|74C|82C|84C|801|811|701|711|170|77C|43C|102C|103C|104C|114C)|MP100i OCTA|MP(?:843|717|718|1010|7007|7008|843|888|959|969)|MGP7)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "((?:MPQC|MPDC)[0-9]+[^/;)]+)(?: Build|\\))",
                "model": "$1"
            },
            {
                "regex": "MP100i OCTA(?:[);/ ]|$)",
                "model": "MP100i OCTA"
            },
            {
                "regex": "(MID(?:7C|74C|82C|84C|801|811|701|711|170|77C|43C|102C|103C|104C|114C)|MP(?:843|717|718|1010|7007|7008|843|888|959|969)|MGP7)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(PH(?:150|340|350|360|451|500|520|544|604))",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "Majestic": {
        "regex": "MAJESTIC[ _-]|CRONO ?[0-9]+|TAB (?:647|411) 3G|URANO 77LTE",
        "device": "smartphone",
        "models": [
            {
                "regex": "URANO 77LTE(?:[);/ ]|$)",
                "model": "Urano 77 LTE"
            },
            {
                "regex": "TAB (647|411) 3G",
                "model": "Tab $1 3G",
                "device": "tablet"
            },
            {
                "regex": "MAJESTIC[ _]Tab([^;/]+)Build",
                "model": "Tab$1",
                "device": "tablet"
            },
            {
                "regex": "MAJESTIC[ _]Tab([^);/]+)(?:[);/]|$)",
                "model": "Tab$1",
                "device": "tablet"
            },
            {
                "regex": "MAJESTIC[ _]([^;/]+)Build",
                "model": "$1"
            },
            {
                "regex": "MAJESTIC[ _]([^);/]+)(?:(?:[);/ ]|$)|$)",
                "model": "$1"
            },
            {
                "regex": "CRONO ?([0-9]+) Build",
                "model": "Crono $1"
            },
            {
                "regex": "CRONO ?([0-9]+)(?:[);/]|$)",
                "model": "Crono $1"
            }
        ]
    },
    "Manta Multimedia": {
        "regex": "MSP950(1[245]|2[01])|MSP96017|((?<!/)MID713|MID(?:06[SN]|08[S]?|12|13|14|15|701|702|703|704|705(?:DC)?|706[AS]?|707|708|709|711|712|714|717|781|801|802|901|1001|1002|1003|1004(?: 3G)?|1005|1009|1010|7802|9701|9702))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "((?<!/)MID713|MID(?:06[SN]|08[S]?|12|13|14|15|701|702|703|704|705(?:DC)?|706[AS]?|707|708|709|711|712|714|717|781|801|802|901|1001|1002|1003|1004(?: 3G)?|1005|1009|1010|7802|9701|9702))(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "MSP95012",
                "model": "Titano 1"
            },
            {
                "regex": "MSP95014",
                "model": "Titano 3"
            },
            {
                "regex": "MSP95015",
                "model": "Mezo 2"
            },
            {
                "regex": "MSP95020",
                "model": "Rocky 2"
            },
            {
                "regex": "MSP95021",
                "model": "Rocky 3 Pro"
            },
            {
                "regex": "MSP96017",
                "model": "Forto 2"
            }
        ]
    },
    "Masstel": {
        "regex": "Masstel",
        "device": "smartphone",
        "models": [
            {
                "regex": "Masstel[_ ](Juno[_ ]Q3|X9|N4[56]0|N5[2458]0|N536|M05|M1[29]0|M1[125]|M250|M25)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Masstel[_ ]\\((M18)\\)",
                "model": "$1"
            },
            {
                "regex": "Masstel_Tab7LTE(?:[);/ ]|$)",
                "model": "Tab 7 LTE",
                "device": "tablet"
            },
            {
                "regex": "Masstel Tab (840|700i)(?:[);/ ]|$)",
                "model": "Tab $1",
                "device": "tablet"
            }
        ]
    },
    "Maxwest": {
        "regex": "(?:Astro[_ ](?:5N_LTE|X4|5_GO_LTE|X55s)|Virtue Z5|Nitro[_ ](?:4S?|55R|5[XR]|[45] GO|4s LTE)|Gravity_55?_GO|Nitro_Phablet_9s)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Astro_5N_LTE",
                "model": "Astro 5N LTE"
            },
            {
                "regex": "Astro_5_GO_LTE",
                "model": "Astro 5 Go LTE"
            },
            {
                "regex": "Virtue Z5",
                "model": "Virtue Z5"
            },
            {
                "regex": "Astro X55s",
                "model": "Astro X55s"
            },
            {
                "regex": "Astro[_ ]X4",
                "model": "Astro X4"
            },
            {
                "regex": "Nitro ([45]) GO",
                "model": "Nitro $1 GO"
            },
            {
                "regex": "Nitro 4s LTE",
                "model": "Nitro 4s LTE"
            },
            {
                "regex": "Nitro[ _]4s",
                "model": "Nitro 4s"
            },
            {
                "regex": "Nitro_(4|55R|5[XR])",
                "model": "Nitro $1"
            },
            {
                "regex": "Gravity_(55?)_GO",
                "model": "Gravity $1 GO"
            },
            {
                "regex": "Nitro_Phablet_9s",
                "device": "tablet",
                "model": "Nitro Phablet 9s"
            }
        ]
    },
    "True Slim": {
        "regex": "(SSB-508[ED])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Maze Speed": {
        "regex": "(SSB-(?:500|508)|SSB408D|SSB504R)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SSB-?(500|508|408D|504R)(?:[);/ ]|$)",
                "model": "SSB-$1"
            }
        ]
    },
    "Maze": {
        "regex": "(?:Alpha[_ ]X|Maze Alpha)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Alpha[_ ]X(?:[);/ ]|$)",
                "model": "Alpha X"
            },
            {
                "regex": "Maze Alpha(?:[);/ ]|$)",
                "model": "Alpha"
            }
        ]
    },
    "Mediacom": {
        "regex": "(?:SmartPad7503G|M-SP10MXA|M-PPAB500|SmartPad970s2(?:3G)?|M[_-][MPS]P[0-9a-z]+|M-IPRO[0-9a-z]+|1AEC)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SmartPad7503G(?:[);/ ]|$)",
                "model": "SmartPad 750 3G"
            },
            {
                "regex": "SmartPad970s23G(?:[);/ ]|$)",
                "model": "SmartPad 970 S2 3G"
            },
            {
                "regex": "SmartPad970s2(?:[);/ ]|$)",
                "model": "SmartPad 970 S2"
            },
            {
                "regex": "M-MP84[02]M(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" Mobile"
            },
            {
                "regex": "M-MP940M(?:[);/ ]|$)",
                "model": "SmartPad 9.7\" Mobile"
            },
            {
                "regex": "M-SP10MXA(?:[);/ ]|$)",
                "model": "SmartPad MX 10.1\""
            },
            {
                "regex": "M-SP8MXA(?:[);/ ]|$)",
                "model": "SmartPad MX 8.0\""
            },
            {
                "regex": "M-SP7HXAH(?:[);/ ]|$)",
                "model": "SmartPad HX 7.0\""
            },
            {
                "regex": "M-SP8HXAH(?:[);/ ]|$)",
                "model": "SmartPad HX 8.0\" HD"
            },
            {
                "regex": "M-MP(?:710|720|725|726|740)GOx?(?:[);/ ]|$)",
                "model": "SmartPad 7.0\" Go"
            },
            {
                "regex": "M-MP876S2(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" S2"
            },
            {
                "regex": "M-MP8S2[AB]?3G(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" S2 3G"
            },
            {
                "regex": "M-MP(101|102|860|875)S2[BW]?(?:[);/ ]|$)",
                "model": "SmartPad $1 S2"
            },
            {
                "regex": "M-MP85S23G(?:[);/ ]|$)",
                "model": "SmartPad 875 S2 3G"
            },
            {
                "regex": "M-SP1AGO3G",
                "model": "SmartPad 10 Go 3G"
            },
            {
                "regex": "M-SP7xGO3G",
                "model": "SmartPad 10.1\" iPro 3G"
            },
            {
                "regex": "1AEC",
                "model": "SmartPad 10 Eclipse"
            },
            {
                "regex": "M-MP10[45][01]S2(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" S2"
            },
            {
                "regex": "M-MP1S2[AB]3G(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" S2 3G"
            },
            {
                "regex": "M-MP8[24]S4(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" S4"
            },
            {
                "regex": "M-MP8S4[AB]3G(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" S4 3G"
            },
            {
                "regex": "M-MP9S4A3G(?:[);/ ]|$)",
                "model": "SmartPad 9.7\" S4 3G"
            },
            {
                "regex": "M-MP1[02]S4(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" S4"
            },
            {
                "regex": "M-MP1040MC?(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" HD S4 3G"
            },
            {
                "regex": "M-MP1S4[AB]3G(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" S4 3G"
            },
            {
                "regex": "M-SP10HXxH(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" HX HD"
            },
            {
                "regex": "M-SP10MXHA(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" MX"
            },
            {
                "regex": "M-SP10MXHL(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" MX Lite"
            },
            {
                "regex": "M-MP8PA3G(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" HD Pro 3G"
            },
            {
                "regex": "M-MP10PA(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" HD Pro"
            },
            {
                "regex": "M-MP10PA3G(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" HD Pro 3G"
            },
            {
                "regex": "M-IPRO([18][01]0)[BW](?:[);/ ]|$)",
                "model": "SmartPad 8.0\" HD iPro$1 3G"
            },
            {
                "regex": "(?:M-MP75S23G|M-MP72[01]M)(?:[);/ ]|$)",
                "model": "SmartPad 7.0\" Mobile",
                "device": "phablet"
            },
            {
                "regex": "M-MP7S2[ABDK]3G(?:[);/ ]|$)",
                "model": "SmartPad 7.0\" S2 3G",
                "device": "phablet"
            },
            {
                "regex": "M-MP5303G(?:[);/ ]|$)",
                "model": "SmartPad Mini Mobile",
                "device": "phablet"
            },
            {
                "regex": "M-PPxB400(?:[);/ ]|$)",
                "model": "PhonePad Duo B400",
                "device": "phablet"
            },
            {
                "regex": "M-PPAG550(?:[);/ ]|$)",
                "model": "PhonePad Duo G550",
                "device": "phablet"
            },
            {
                "regex": "M-PPAB500(?:[);/ ]|$)",
                "model": "PhonePad Duo B500",
                "device": "phablet"
            },
            {
                "regex": "M-PP2G530(?:[);/ ]|$)",
                "model": "PhonePad Duo G530",
                "device": "phablet"
            },
            {
                "regex": "M-PPG700(?:[);/ ]|$)",
                "model": "PhonePad Duo G700",
                "device": "phablet"
            },
            {
                "regex": "M-PPxS531(?:[);/ ]|$)",
                "model": "PhonePad Duo S531",
                "device": "phablet"
            },
            {
                "regex": "M-PP2S550(?:[);/ ]|$)",
                "model": "PhonePad Duo S550",
                "device": "phablet"
            },
            {
                "regex": "M-PP2S650C?(?:[);/ ]|$)",
                "model": "PhonePad Duo S650",
                "device": "phablet"
            },
            {
                "regex": "M-PPxS551U(?:[);/ ]|$)",
                "model": "PhonePad Duo S551U",
                "device": "phablet"
            },
            {
                "regex": "M-PPAG4(?:[);/ ]|$)",
                "model": "PhonePad Duo G4",
                "device": "smartphone"
            },
            {
                "regex": "M-PP[ABC]G500(?:[);/ ]|$)",
                "model": "PhonePad Duo G500",
                "device": "smartphone"
            },
            {
                "regex": "M-PP2S500[BC]?(?:[);/ ]|$)",
                "model": "PhonePad Duo S500",
                "device": "smartphone"
            },
            {
                "regex": "M[_-]PP[Ax]X(470|510|520)U(?:[);/ ]|$)",
                "model": "PhonePad Duo X$1U",
                "device": "smartphone"
            },
            {
                "regex": "M-PPxG(400|501|[457][PM]?)(?:[);/ ]|$)",
                "model": "PhonePad Duo G$1",
                "device": "smartphone"
            },
            {
                "regex": "M-PPxS(532[LU]|470|501|5P?|7P?)(?:[);/ ]|$)",
                "model": "PhonePad Duo S$1",
                "device": "smartphone"
            },
            {
                "regex": "M-PPxG(450)(?:[);/ ]|$)",
                "model": "PhonePad Duo G$1",
                "device": "smartphone"
            },
            {
                "regex": "M-MP([0-9a-z]+)",
                "model": "SmartPad $1"
            }
        ]
    },
    "Medion": {
        "regex": "Medion|(?:MD_)?LIFETAB|([SPX]10[0-9]{2}X|E10[45]1X|X5001|P851X|P850X|E691X|E1050X)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:MD_)?LIFETAB_([a-z0-9]+)",
                "device": "tablet",
                "model": "Lifetab $1"
            },
            {
                "regex": "(E450[46]|E5004|S5004|X5001|E5020|P5015)(?:[);/ ]|$)",
                "model": "Life $1"
            },
            {
                "regex": "(B5530)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(E10[45]1X)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "([SPX]10[0-9]{2}X|P851X|P850X|E691X|E1050X)(?:[);/ ]|$)",
                "model": "Lifetab $1",
                "device": "tablet"
            },
            {
                "regex": "Medion(?: Smartphone)? ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "MEEG": {
        "regex": "MEEG[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "MEEG[ _\\-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "MEEG[ _\\-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Fourel": {
        "regex": "(?:EASYSMARTM3|EasySmart M2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "EASY ?SMART ?M([32])",
                "model": "Easy Smart M$1"
            }
        ]
    },
    "Meizu": {
        "regex": "Meizu|MZ-[a-z]|(?<!POCO )(M04[05]|MZ-16th(?: Plus)?|MZ-16[st]|M7[12]1C|M35[1356]|M612C|M578CA|M181[36]|M1822|M681C|M6T|MX[ -]?[2345](?: Pro)?|(?:MZ-)?m[1-6] note|M621C|M1852|M57[18]C|M3[ESX]|M031|m1 metal|M1 E|M2|M2 E|M5s Build|PRO [67]|PRO 7-[HS]| 15 Lite| 16th|MZ-15 (?:Lite|Plus)|MZ-16 X)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:MZ-)?M571C",
                "device": "phablet",
                "model": "M2 Note"
            },
            {
                "regex": "(?:MZ-|Meizu-)?m([1-6])[_ ]note(?:[);/ ]|$)",
                "device": "phablet",
                "model": "M$1 Note"
            },
            {
                "regex": "M1 E(?:[);/ ]|$)",
                "model": "M1E"
            },
            {
                "regex": "M2 E(?:[);/ ]|$)",
                "model": "M2E"
            },
            {
                "regex": "(?:MZ-)?M578C[A]?|M2(?:[);/ ]|$)",
                "model": "M2"
            },
            {
                "regex": "M681C(?:[);/ ]|$)",
                "model": "M3 Note",
                "device": "phablet"
            },
            {
                "regex": "M621C(?:[);/ ]|$)",
                "model": "M5 Note",
                "device": "phablet"
            },
            {
                "regex": "M711C(?:[);/ ]|$)",
                "model": "M6"
            },
            {
                "regex": "M721C(?:[);/ ]|$)",
                "model": "M6 Note",
                "device": "phablet"
            },
            {
                "regex": "M6T",
                "model": "M6T"
            },
            {
                "regex": "M3E",
                "model": "M3E"
            },
            {
                "regex": "M3S",
                "model": "M3S"
            },
            {
                "regex": "M3X",
                "model": "M3X"
            },
            {
                "regex": "M5S|M612C",
                "model": "M5S"
            },
            {
                "regex": "(M04[05]|MX[ -]?2)(?:[);/ ]|$)",
                "model": "MX2"
            },
            {
                "regex": "(M35[1356]|MX[ -]?3)(?:[);/ ]|$)",
                "model": "MX3"
            },
            {
                "regex": "MX[ -]?4 Pro(?:[);/ ]|$)",
                "model": "MX4 Pro"
            },
            {
                "regex": "MX[ -]?4(?:[);/ ]|$)",
                "model": "MX4"
            },
            {
                "regex": "(Meizu[- _])?MX[ -]?5(?:[);/ ]|$)",
                "model": "MX5"
            },
            {
                "regex": "m1 metal",
                "model": "M1 Metal"
            },
            {
                "regex": "M1813(?:[);/ ]|$)",
                "model": "M8"
            },
            {
                "regex": "M1816(?:[);/ ]|$)",
                "model": "M8 Lite"
            },
            {
                "regex": "PRO 7-[HS](?:[);/ ]|$)",
                "model": "PRO 7"
            },
            {
                "regex": "PRO 7 Plus(?:[);/ ]|$)",
                "model": "Pro 7 Plus"
            },
            {
                "regex": "PRO ([67])",
                "model": "PRO $1"
            },
            {
                "regex": "M031(?:[);/ ]|$)",
                "model": "MX Dual Core"
            },
            {
                "regex": "M1852(?:[);/ ]|$)",
                "model": "X8"
            },
            {
                "regex": "M1822(?:[);/ ]|$)",
                "model": "Note 8"
            },
            {
                "regex": "MZ-16T(?:[);/ ]|$)",
                "model": "16T"
            },
            {
                "regex": "(?:MZ-)?16th Plus(?:[);/ ]|$)",
                "model": "16th Plus"
            },
            {
                "regex": "MZ-15 Plus(?:[);/ ]|$)",
                "model": "15 Plus"
            },
            {
                "regex": "(?:MZ-15 Lite| 15 Lite)(?:[);/ ]|$)",
                "model": "15 Lite"
            },
            {
                "regex": "MZ-16th| 16th(?:[);/ ]|$)",
                "model": "16th"
            },
            {
                "regex": "MZ-16 X(?:[);/ ]|$)",
                "model": "16X"
            },
            {
                "regex": "Meizu[_ ]note([89])(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Note $1"
            },
            {
                "regex": "(?:MZ-)?Meizu[_ ]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:MZ-)?Meizu[_ ]([a-z0-9_]+)",
                "model": "$1"
            },
            {
                "regex": "MZ-([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Meitu": {
        "regex": "(?:(?<!MI CC 9 )Meitu[2]?|MP1503|MP1512|MP160[235]|MP170[19]|MP171[138])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MP1503(?:[);/ ]|$)",
                "model": "M6"
            },
            {
                "regex": "MP1512(?:[);/ ]|$)",
                "model": "M6s"
            },
            {
                "regex": "MP1602(?:[);/ ]|$)",
                "model": "T8"
            },
            {
                "regex": "MP1605(?:[);/ ]|$)",
                "model": "V6"
            },
            {
                "regex": "MP17(?:01|13)(?:[);/ ]|$)",
                "model": "T8s"
            },
            {
                "regex": "MP1718(?:[);/ ]|$)",
                "model": "T9"
            },
            {
                "regex": "MP1603(?:[);/ ]|$)",
                "model": "M8"
            },
            {
                "regex": "MP17(?:09|11)(?:[);/ ]|$)",
                "model": "M8s"
            },
            {
                "regex": "Meitu2(?:[);/ ]|$)",
                "model": "2"
            },
            {
                "regex": "Meitu (Kiss|[MV]4)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Memup": {
        "regex": "SlidePad ?([^;/]*) Build|SPNG?[0-9]{2,4}[a-z]{0,2}(?:[);/ ]|$)|SP704CE?|SP-NG708-3G",
        "device": "tablet",
        "models": [
            {
                "regex": "SlidePad ?([^;/]*) Build",
                "model": "SlidePad $1"
            },
            {
                "regex": "SPNG([0-9]{2,4}[a-z]{0,2})(?:[);/ ]|$)",
                "model": "SlidePad NG$1"
            },
            {
                "regex": "SP-NG(708)-3G(?:[);/ ]|$)",
                "model": "SlidePad NG$1 3G"
            },
            {
                "regex": "SP704(CE?)",
                "model": "SlidePad 704$1"
            }
        ]
    },
    "Mecer": {
        "regex": "(M785|800P3[12]C|101P51C|X1010)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "M785(?:[);/ ]|$)",
                "model": "Xpress Smartlife M785"
            },
            {
                "regex": "X1010(?:[);/ ]|$)",
                "model": "X1010"
            },
            {
                "regex": "800P31C(?:[);/ ]|$)",
                "model": "Xpress Smartlife 800P31C"
            },
            {
                "regex": "800P32C(?:[);/ ]|$)",
                "model": "Xpress Smartlife 800P32C"
            },
            {
                "regex": "101P51C(?:[);/ ]|$)",
                "model": "Xpress Smartlife 101P51C"
            }
        ]
    },
    "Mio": {
        "regex": "MIO(?:/)?([a-z0-9]+)|(?:MOBIX M6|Mio TouchPad 7 Quad Core)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MOBIX M6(?:[);/ ]|$)",
                "model": "Mobix M6"
            },
            {
                "regex": "MIO(?:/)?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Mio TouchPad 7 Quad Core",
                "device": "tablet",
                "model": "TouchPad 7 Quad Core"
            }
        ]
    },
    "Miray": {
        "regex": "MIDM[_-]|MPM[_-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "MIDM[_-]([a-z0-9]+)",
                "model": "MIDM $1",
                "device": "tablet"
            },
            {
                "regex": "MPM[_-]([a-z0-9]+)",
                "model": "MPM $1"
            }
        ]
    },
    "Mitsubishi": {
        "regex": "MITSU|portalmmm/[12]\\.0 M",
        "device": "feature phone",
        "models": [
            {
                "regex": "MITSU/[a-z0-9.]+ \\(([a-z0-9]+)\\)",
                "model": "$1"
            },
            {
                "regex": "MITSU[ \\-]?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/[12]\\.0 (M[a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "MIXC": {
        "regex": "(M35|M20|G7106|G7108)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(M[0-9]{1,2})(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(G[0-9]{4})(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Mobiola": {
        "regex": "(MS5[50]X6|MS55X5|MS55L1|MS50L1|MS43A3000|MS45A4000|MS50A4000|MS50A4500|MS50A5000|MS50A6000|MS50B11000|MB-2900 QUATTRO|POLYS[_ ]MS45L1|Wave5)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MS50X6",
                "model": "Atmos II"
            },
            {
                "regex": "POLYS[_ ]MS45L1",
                "model": "Polys MS45L1"
            },
            {
                "regex": "MS55X6",
                "model": "Atmos Pro II"
            },
            {
                "regex": "MS55X5",
                "model": "Atmos Pro"
            },
            {
                "regex": "MS55L1",
                "model": "GAIA"
            },
            {
                "regex": "MS50L1",
                "model": "Inti"
            },
            {
                "regex": "MB-2900 QUATTRO",
                "model": "MB-2900 Quattro"
            },
            {
                "regex": "MS43A3000",
                "model": "MS43A3000"
            },
            {
                "regex": "MS45A4000",
                "model": "eOn 45"
            },
            {
                "regex": "MS50A4000",
                "model": "eOn 50"
            },
            {
                "regex": "MS50A4500",
                "model": "eOn 50 Elegance"
            },
            {
                "regex": "MS50A5000",
                "model": "eOn 50 Quad 8"
            },
            {
                "regex": "MS50A6000",
                "model": "eOn 50 Quad 16"
            },
            {
                "regex": "MS50B11000",
                "model": "MS50B11000"
            },
            {
                "regex": "Wave5",
                "model": "Wave 5"
            }
        ]
    },
    "Mobicel": {
        "regex": "Mobicel_(R1)|(?:HYPE|DANDY(?:_ZAM)?|(?<!SMADL )Matrix|TRENDY PLUS|FENDY_DS|TANGO_LITE|BLINK|BERRY[_ ]?(?:[12]|PLUS))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Matrix",
                "model": "Matrix"
            },
            {
                "regex": "BLINK",
                "model": "Blink"
            },
            {
                "regex": "BERRY1",
                "model": "Berry 1"
            },
            {
                "regex": "BERRY 2",
                "model": "Berry 2"
            },
            {
                "regex": "BERRY[_ ]PLUS",
                "model": "Berry Plus"
            },
            {
                "regex": "TRENDY PLUS",
                "model": "Trendy Plus"
            },
            {
                "regex": "HYPE",
                "model": "Hype"
            },
            {
                "regex": "DANDY_ZAM",
                "model": "Dandy Zam"
            },
            {
                "regex": "DANDY",
                "model": "Dandy"
            },
            {
                "regex": "TANGO_LITE",
                "model": "Tango Lite"
            },
            {
                "regex": "FENDY_DS",
                "model": "Fendy DS"
            },
            {
                "regex": "Mobicel_(R1)",
                "model": "$1"
            }
        ]
    },
    "Mobiistar": {
        "regex": "Mobiistar|Zumbo[ _]S|PRIME X MAX|X1 Notch|E1 Selfie",
        "device": "smartphone",
        "models": [
            {
                "regex": "X1 Notch(?:[);/ ]|$)",
                "model": "X1 Notch"
            },
            {
                "regex": "E1 Selfie(?:[);/ ]|$)",
                "model": "E1 Selfie"
            },
            {
                "regex": "mobiistar_LAI_Zumbo(?:[);/ ]|$)",
                "model": "Zumbo"
            },
            {
                "regex": "Zumbo[_ ]S[_ ]2017[_ ]Lite(?:[);/ ]|$)",
                "model": "Lai Zumbo S Lite (2017)"
            },
            {
                "regex": "Zumbo[_ ]S[_ ]2017(?:[);/ ]|$)",
                "model": "Lai Zumbo S (2017)"
            },
            {
                "regex": "mobiistar ZUMBO S2( Dual)",
                "model": "Zumbo S2"
            },
            {
                "regex": "Mobiistar_LAI_Zumbo_J_2017(?:[);/ ]|$)",
                "model": "Lai Zumbo J (2017)"
            },
            {
                "regex": "Mobiistar_LAI_Zumbo_J(?:[);/ ]|$)",
                "model": "Lai Zumbo J"
            },
            {
                "regex": "Mobiistar_Zumbo_J2",
                "model": "Lai Zumbo J2"
            },
            {
                "regex": "Mobiistar[_ ]Zumbo[_ ]S2",
                "model": "Zumbo S2"
            },
            {
                "regex": "mobiistar ZUMBO Power",
                "model": "Zumbo Power"
            },
            {
                "regex": "mobiistar[ _]LAI[ _]YUNA[ _]([1XCS])",
                "model": "Lai Yuna $1"
            },
            {
                "regex": "mobiistar LAI Yuki",
                "model": "Lai Yuki"
            },
            {
                "regex": "mobiistar[ _]LAI[ _]ZORO[ _]([23])",
                "model": "Lai Zoro $1"
            },
            {
                "regex": "mobiistar[ _]LAI[ _]Zena",
                "model": "Lai Zena"
            },
            {
                "regex": "mobiistar[ _]LAI[ _]Z([12])?",
                "model": "Lai Z$1"
            },
            {
                "regex": "mobiistar_ZORO_4G",
                "model": "Zoro 4G"
            },
            {
                "regex": "mobiistar touch LAI 512",
                "model": "Touch Lai 512"
            },
            {
                "regex": "mobiistar LAI 504([KC])",
                "model": "Lai 504$1"
            },
            {
                "regex": "mobiistar LAI Y",
                "model": "Lai Y"
            },
            {
                "regex": "mobiistar PRIME X 2017",
                "model": "Prime X"
            },
            {
                "regex": "mobiistar[ _]PRIME[ _](X1|558|X[ _]Plus|X[ _]Grand) Build",
                "model": "Prime $1"
            },
            {
                "regex": "PRIME X MAX 2018",
                "model": "Prime X Max"
            },
            {
                "regex": "mobiistar[ _]KOOL([ _]Lite)?",
                "model": "Kool$1"
            },
            {
                "regex": "mobiistar KAT 452 Build",
                "model": "Kat 452"
            },
            {
                "regex": "mobiistar_LAI_YOLLO Build",
                "model": "Lai Yollo"
            },
            {
                "regex": "Mobiistar[ _]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "MSI": {
        "regex": "Primo ?(?:9[13]|81|76)|Enjoy 7 Plus",
        "device": "tablet",
        "models": [
            {
                "regex": "Primo ?(9[13]|76|81)",
                "model": "Primo $1"
            },
            {
                "regex": "Enjoy 7 Plus",
                "model": "Enjoy 7 Plus"
            }
        ]
    },
    "MLLED": {
        "regex": "MLLED[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "MLLED[ _]([^;/]+)Build",
                "model": "$1"
            },
            {
                "regex": "MLLED[ _]([^);/]+)(?:[);/]|$)",
                "model": "$1"
            }
        ]
    },
    "Mobistel": {
        "regex": "(Cynus[ _][^/;)]+)( Build|\\))",
        "device": "smartphone",
        "model": "$1"
    },
    "Mecool": {
        "regex": "(?:KM9PRO|BB2 PRO|K[I]{1,3} PRO|KI PLUS|KM9_TV_BOX|M8SPROW|M8S (?:PLUS|PRO) (?:DVB|[LW]|PLUS)|M8S (?:MAX|PRO))(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "KM9PRO(?:[);/ ]|$)",
                "model": "KM9 Pro"
            },
            {
                "regex": "KM9_TV_BOX(?:[);/ ]|$)",
                "model": "KM9 TV Box"
            },
            {
                "regex": "BB2 PRO(?:[);/ ]|$)",
                "model": "BB2 Pro"
            },
            {
                "regex": "(K[I]{1,3}) PRO(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "KI PLUS(?:[);/ ]|$)",
                "model": "KI Plus"
            },
            {
                "regex": "M8SPROW(?:[);/ ]|$)",
                "model": "M8S Pro W"
            },
            {
                "regex": "M8S PLUS DVB(?:[);/ ]|$)",
                "model": "M8S Plus DVB"
            },
            {
                "regex": "M8S PLUS ([LW])(?:[);/ ]|$)",
                "model": "M8S Plus $1"
            },
            {
                "regex": "M8S PRO ([LW])(?:[);/ ]|$)",
                "model": "M8S Pro $1"
            },
            {
                "regex": "M8S PRO PLUS(?:[);/ ]|$)",
                "model": "M8S Pro Plus"
            },
            {
                "regex": "M8S PRO(?:[);/ ]|$)",
                "model": "M8S Pro"
            },
            {
                "regex": "M8S MAX(?:[);/ ]|$)",
                "model": "M8S Max"
            }
        ]
    },
    "Modecom": {
        "regex": "Modecom|Free(?:Way )?Tab|xino z[\\d]+ x[\\d]+",
        "device": "tablet",
        "models": [
            {
                "regex": "xino Z([\\d]+) X([\\d]+)",
                "model": "Xino Z$1 X$2",
                "device": "smartphone"
            },
            {
                "regex": "FreeTab[ _\\-]?([^/;]+)? Build",
                "model": "FreeTab $1"
            },
            {
                "regex": "FreeTab[ _\\-]?((?!Build)[^);/ ]+)?",
                "model": "FreeTab $1"
            },
            {
                "regex": "FreeWay Tab[ _\\-]?([^/;]+) Build",
                "model": "FreeWay Tab $1"
            },
            {
                "regex": "FreeWay Tab[ _\\-]?((?!Build)[^);/ ]+)",
                "model": "FreeWay Tab $1"
            }
        ]
    },
    "Mofut": {
        "regex": "Mofut",
        "device": "smartphone",
        "models": [
            {
                "regex": "Mofut[ _\\-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Mofut[ _\\-]?((?!Build)[^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "BrightSign": {
        "regex": "BrightSign",
        "device": "tv",
        "models": [
            {
                "regex": "(HD1023|XD233|XD230|XD1030|XT114[34]|4K1142|LS424)",
                "model": "$1"
            }
        ]
    },
    "Motorola": {
        "regex": "MOT(?!TO)|(?<!AN)DROID ?(?:Build|[a-z0-9]+)|portalmmm/2.0 (?:E378i|L6|L7|v3)|XOOM [^;/]*Build|XT1941-2|XT1924-9|XT1925-10|XT1965-6|XT1970-5|XT1799-2|XT1021|XT1710-08|XT180[3-5]|XT194[23]-1|XT1929-15|(?:XT|MZ|MB|ME)[0-9]{3,4}[a-z]?(?:\\(Defy\\)|-0[1-5])?(?:[;]? Build|\\))",
        "device": "smartphone",
        "models": [
            {
                "regex": "MOT-V360",
                "model": "V360",
                "device": "feature phone"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT300",
                "model": "Spice"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT30[35]",
                "model": "Motosmart ME"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT31[16]",
                "model": "Fire"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT32[01]",
                "model": "Defy Mini"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT3(?:89|90)",
                "model": "Motosmart"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT502",
                "model": "Quench"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT531",
                "model": "Fire XT"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT535",
                "model": "Defy"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT55[567]C?",
                "model": "Defy XT"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT603",
                "model": "Admiral"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT610",
                "model": "Droid Pro"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT615",
                "model": "Motoluxe"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT621",
                "model": "Primus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT626",
                "model": "IronRock"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT682",
                "model": "Atrix"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT685",
                "model": "Motoluxe Dual-SIM"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT687",
                "model": "Atrix TV"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT720",
                "model": "Milestone"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT800W",
                "model": "Glam"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT860",
                "model": "Milestone 3"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT881",
                "model": "Electrify 2"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT882",
                "model": "Moto XT882"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT88[56]",
                "model": "Droid RAZR V"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT890",
                "model": "Droid RAZR i"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT894",
                "model": "Droid 4"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT897",
                "model": "Photon Q"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT901",
                "model": "Electrify M"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT90[567]",
                "model": "Droid RAZR M"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT910S?",
                "model": "Droid RAZR"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT91[4568]",
                "model": "Droid RAZR D1"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT9(?:19|20)",
                "model": "Droid RAZR D3"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT925",
                "model": "Droid RAZR HD"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT102[12]",
                "model": "Moto E"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1706",
                "model": "Moto E3 Power"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1924-9|moto e5 plus",
                "model": "Moto E5 Plus"
            },
            {
                "regex": "Moto E5 Play",
                "model": "Moto E5 Play"
            },
            {
                "regex": "Moto E5 go(?:[);/ ]|$)",
                "model": "Moto E5 Go"
            },
            {
                "regex": "Moto E6(?:[);/ ]|$)",
                "model": "Moto E6"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1030",
                "model": "Droid Mini"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1096",
                "model": "Moto X2"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1254",
                "model": "Droid Turbo"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT10(?:28|3[1234]|68|69)",
                "model": "Moto G"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1799-2",
                "model": "Moto G5s"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT180[3-5]",
                "model": "Moto G5s Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT168[57]",
                "model": "Moto G5 Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1670",
                "model": "Moto G5"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1925-10",
                "model": "Moto G6"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1965-6",
                "model": "Moto G7 Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT10(?:49|5[23568]|60|9[23457])",
                "model": "Moto X"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1562",
                "model": "Moto X Play"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1572",
                "model": "Moto X Style"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1080",
                "model": "Droid Ultra"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1650-05",
                "model": "Moto Z"
            },
            {
                "regex": "moto z4(?:[);/ ]|$)",
                "model": "Moto Z4"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1635(?:-0[1-3])?",
                "model": "Moto Z Play"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1710-(?:-0[28])?",
                "model": "Moto Z2 Play"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1789-05",
                "model": "Moto Z2 Force"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1929-15",
                "model": "Moto Z3"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1663",
                "model": "Moto M"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1943-1",
                "model": "P30"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1941-2",
                "model": "P30 Play"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1942-1",
                "model": "P30 Note"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1970-5",
                "model": "One Vision"
            },
            {
                "regex": "(?:MOT-|Motorola-)?one zoom",
                "model": "One Zoom"
            },
            {
                "regex": "motorola one action",
                "model": "One Action"
            },
            {
                "regex": "motorola one macro",
                "model": "One Macro"
            },
            {
                "regex": "motorola one 5G UW",
                "model": "One 5G UW"
            },
            {
                "regex": "moto g power",
                "model": "Moto G Power"
            },
            {
                "regex": "moto g\\(([0-9])\\) power lite",
                "model": "Moto G$1 Power Lite"
            },
            {
                "regex": "moto g\\(([0-9])\\) power",
                "model": "Moto G$1 Power"
            },
            {
                "regex": "moto g\\(([0-9])\\) supra",
                "model": "Moto G$1 Supra"
            },
            {
                "regex": "moto g\\(([0-9])\\) plus",
                "model": "Moto G$1 Plus"
            },
            {
                "regex": "moto g\\(([0-9]+)\\) play",
                "model": "Moto G$1 Play"
            },
            {
                "regex": "moto g\\(([0-9]+)\\)",
                "model": "Moto G$1"
            },
            {
                "regex": "Moto ([CGEXZ]) ?\\(([a-z0-9]+)\\)( Plus| Play)?",
                "model": "Moto $1$2$3"
            },
            {
                "regex": "Moto ?([CGEXZ])([0-9]+)( Plus| Play)?",
                "model": "Moto $1$2$3"
            },
            {
                "regex": "(?:Motorola-)?Moto[ _]?([CGEXZ])([ _](?:Plus|Play))?",
                "model": "Moto $1$2"
            },
            {
                "regex": "MotoroiX",
                "model": "MotoroiX"
            },
            {
                "regex": "Motorola[ _\\-]([^/;]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "MOTORAZR[ _\\-]([a-z0-9]+)",
                "model": "RAZR $1"
            },
            {
                "regex": "MOTORIZR[ _\\-]([a-z0-9]+)",
                "model": "RIZR $1"
            },
            {
                "regex": "MOT(?!OROLA)[O]?[_\\-]?([a-z0-9.]+)",
                "model": "$1"
            },
            {
                "regex": "(?<!AN)DROID ?([a-z0-9 ]*) Build",
                "model": "DROID $1"
            },
            {
                "regex": "(?<!AN)DROID ?([a-z0-9]+)",
                "model": "DROID $1"
            },
            {
                "regex": "portalmmm/2.0 ((?:E378i|L6|L7|V3)[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(XOOM [^;/]*)Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(MZ[0-9]{3})(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "((?:ME|MB|XT)[0-9]{3,4}(?:\\(Defy\\))?)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Movic": {
        "regex": "MOVIC",
        "device": "smartphone",
        "models": [
            {
                "regex": "MOVIC[ -]W([2345])",
                "model": "W$1"
            }
        ]
    },
    "MTN": {
        "regex": "MTN-",
        "device": "smartphone",
        "models": [
            {
                "regex": "MTN-(L860|S620)",
                "model": "Sm@rt Mini $1"
            },
            {
                "regex": "MTN-8978P",
                "device": "tablet",
                "model": "Steppa"
            },
            {
                "regex": "MTN-([a-z0-9_\\-]+)",
                "model": "MTN-$1"
            }
        ]
    },
    "MyTab": {
        "regex": "MyTAB[ _-](?:8 MINI Dual Core|U55GT)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "MyTAB[ _-]8 MINI Dual Core(?:[);/ ]|$)",
                "model": "8 Mini Dual Core"
            },
            {
                "regex": "MyTAB-U55GT(?:[);/ ]|$)",
                "model": "U55GT"
            }
        ]
    },
    "MyPhone": {
        "regex": "(?:MyPhone|MyPad|MyTab)[ _][^;/)]+( Build|\\))|Cube_LTE|myTab10II|HAMMER[ _](Blade2_PRO|IRON_3|Explorer|ENERGY|Titan 2|AXE[_ ](?:M[_ ]LTE|Pro)|Iron 2|Active[2]?(_LTE)?)|C-Smart_pix|myPhone_Fun_8|FUN_18x9|MyPhoneMY27|Prime_4_Lite|myA17|myX12|Pocket_2|Prime_18x9|Prime3Lite|myT6 DTV|myXI1 (?:Plus|Pro)|myXI3|Q_Smart_BE",
        "device": "smartphone",
        "models": [
            {
                "regex": "MyPad[ _]([^;/]+) Build",
                "model": "MyPad $1",
                "device": "tablet"
            },
            {
                "regex": "MyTab[ _]([^;/]+) Build",
                "model": "MyTab $1",
                "device": "tablet"
            },
            {
                "regex": "myTab_10III",
                "model": "MyTab 10 III",
                "device": "tablet"
            },
            {
                "regex": "myTab10II",
                "model": "MyTab 10 II",
                "device": "tablet"
            },
            {
                "regex": "myT6 DTV",
                "model": "myT6 DTV",
                "device": "tablet"
            },
            {
                "regex": "Cube_LTE",
                "model": "Cube LTE"
            },
            {
                "regex": "Prime_4_Lite",
                "model": "Prime 4 Lite"
            },
            {
                "regex": "HAMMER[ _]ENERGY",
                "model": "Hammer Energy"
            },
            {
                "regex": "HAMMER_AXE[_ ]M[_ ]LTE",
                "model": "Hammer Axe M LTE"
            },
            {
                "regex": "Hammer Titan 2",
                "model": "Hammer Titan 2"
            },
            {
                "regex": "Hammer[ _]Iron[ _](2|3)",
                "model": "Hammer Iron $1"
            },
            {
                "regex": "Hammer[ _]Explorer",
                "model": "Hammer Explorer"
            },
            {
                "regex": "Hammer Active(?:[);/ ]|$)",
                "model": "Hammer Active"
            },
            {
                "regex": "Hammer_Active2(?:[);/ ]|$)",
                "model": "Hammer Active 2"
            },
            {
                "regex": "Hammer_Active2_LTE(?:[);/ ]|$)",
                "model": "Hammer Active 2 LTE"
            },
            {
                "regex": "Hammer AXE Pro",
                "model": "Hammer Axe Pro"
            },
            {
                "regex": "Hammer_Blade2_PRO",
                "model": "Hammer Blade 2 Pro"
            },
            {
                "regex": "C-Smart_pix",
                "model": "C-Smart Pix"
            },
            {
                "regex": "Pocket_2(?:[);/ ]|$)",
                "model": "Pocket 2"
            },
            {
                "regex": "myA17(?:[);/ ]|$)",
                "model": "myA17"
            },
            {
                "regex": "(?:myPhone_)?Fun_(8|18x9)",
                "model": "FUN $1"
            },
            {
                "regex": "MyPhoneMY27",
                "model": "my27"
            },
            {
                "regex": "myX12(?:[);/ ]|$)",
                "model": "myX12"
            },
            {
                "regex": "myXI1 Plus(?:[);/ ]|$)",
                "model": "myXI1 Plus"
            },
            {
                "regex": "myXI1 Pro(?:[);/ ]|$)",
                "model": "myXI1 Pro"
            },
            {
                "regex": "myXI3(?:[);/ ]|$)",
                "model": "myXI3"
            },
            {
                "regex": "Q_Smart_BE(?:[);/ ]|$)",
                "model": "Q-Smart BE"
            },
            {
                "regex": "Prime_18x9(_LTE)?(?:[);/ ]|$)",
                "model": "Prime 18x9$1"
            },
            {
                "regex": "Prime3Lite(?:[);/ ]|$)",
                "model": "Prime 3 Lite"
            },
            {
                "regex": "MyPhone[ _]([^;/)]+)( Build|\\))",
                "model": "$1"
            }
        ]
    },
    "MyWigo": {
        "regex": "MyWigo ",
        "device": "smartphone",
        "models": [
            {
                "regex": "City3",
                "model": "City 3"
            }
        ]
    },
    "Myros": {
        "regex": "(E70 Ultra)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Myria": {
        "regex": " (Myria_[^/;]+|502M|Cozy|Easy tab 9|Grand) Build|Myria_FIVE|Myria_Grand_4G|Myria_Wide_2|Myria_Wide_4G",
        "device": "smartphone",
        "models": [
            {
                "regex": "Myria_([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Myria_FIVE",
                "model": "Five"
            },
            {
                "regex": "(502M|Grand)",
                "model": "$1"
            },
            {
                "regex": "Myria_Grand_4G",
                "model": "Grand 4G"
            },
            {
                "regex": "Myria_Wide_4G",
                "model": "Wide 4G"
            },
            {
                "regex": "Myria_Wide_2",
                "model": "Wide 2"
            },
            {
                "regex": "(Cozy|Easy tab 9)",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "M.T.T.": {
        "regex": "M.T.T.",
        "device": "smartphone",
        "models": [
            {
                "regex": "M.T.T. ?Tablet([^;/]+)? Build",
                "device": "tablet",
                "model": "Tablet$1"
            },
            {
                "regex": "M.T.T. ?([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Navon": {
        "regex": "Navon[_ ]|(?:Vision_Tab_(?:7|10)|Superme_Max|Predator (?:10|3G)|Platinum[_ ]10[_ ]3G(?:_V2)?|Supreme[_ ](?:Fine(?:[_ ]Micro)?|Chief|Pure|Pro)(?:[_ ](?:Mini|Plus))?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "M505 LTE(?:[);/ ]|$)",
                "model": "Mizu M505 LTE"
            },
            {
                "regex": "(F552|D504)(?:[);/ ]|$)",
                "model": "Mizu $1"
            },
            {
                "regex": "Superme_Max(?:[);/ ]|$)",
                "model": "Supreme Max"
            },
            {
                "regex": "Supreme_Fine_Mini(?:[);/ ]|$)",
                "model": "Supreme Fine Mini"
            },
            {
                "regex": "Supreme_Fine_Micro(?:[);/ ]|$)",
                "model": "Supreme Fine Micro"
            },
            {
                "regex": "Supreme[_ ]Fine[_ ]Plus(?:[);/ ]|$)",
                "model": "Supreme Fine Plus"
            },
            {
                "regex": "Supreme_Fine(?:[);/ ]|$)",
                "model": "Supreme Fine"
            },
            {
                "regex": "Supreme[_ ]Chief(?:[);/ ]|$)",
                "model": "Supreme Chief"
            },
            {
                "regex": "Supreme[_ ]Pure[ _]Plus(?:[);/ ]|$)",
                "model": "Supreme Pure Plus"
            },
            {
                "regex": "Supreme Pure(?:[);/ ]|$)",
                "model": "Supreme Pure"
            },
            {
                "regex": "Supreme[_ ]Pro(?:[);/ ]|$)",
                "model": "Supreme Pro"
            },
            {
                "regex": "Navon[_ ]Infinity(?:[);/ ]|$)",
                "model": "Infinity"
            },
            {
                "regex": "(?:Navon[_ ])?Platinum[ _]10[ _]3G(_V2)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Platinum 10.1\" 3G$1"
            },
            {
                "regex": "(?:Navon[_ ])?Orpheus[ _]3G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Orpheus 3G"
            },
            {
                "regex": "Predator (3G|10)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Predator $1"
            },
            {
                "regex": "Vision_Tab_(7|10)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Vision Tab $1"
            }
        ]
    },
    "NOA": {
        "regex": "(?:NOA-)?NOA[ _]|Hummer(?:_2019_R|LE)|NextSE",
        "device": "smartphone",
        "models": [
            {
                "regex": "NOA[_ ]CORE[_ ]FORTE",
                "model": "Core Forte"
            },
            {
                "regex": "HummerLE",
                "model": "Hummer LE"
            },
            {
                "regex": "Hummer_2019_R",
                "model": "Hummer R (2019)"
            },
            {
                "regex": "NOA[_ ]Hummer[_ ]Lite",
                "model": "Hummer Lite"
            },
            {
                "regex": "NOA[_ ]MOVEse",
                "model": "Move SE"
            },
            {
                "regex": "NextSE",
                "model": "Next SE"
            },
            {
                "regex": "NOA[_ ]NEXT",
                "model": "Next"
            },
            {
                "regex": "NOA[_ ]VISION[_ ]H3SE",
                "model": "Vision H3SE"
            },
            {
                "regex": "NOA[_ ]VISION[_ ]H3",
                "model": "Vision H3"
            },
            {
                "regex": "NOA[_ ]LOOP",
                "model": "Loop"
            },
            {
                "regex": "(?:NOA-)?NOA[_ ]H4se",
                "model": "H4SE"
            },
            {
                "regex": "NOA[_ ]Mg12",
                "model": "MG12"
            },
            {
                "regex": "NOA[_ ]H44SE",
                "model": "H44SE"
            },
            {
                "regex": "NOA[_ ]H10LE",
                "model": "H10LE"
            },
            {
                "regex": "NOA[_ ]([^;)/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Nobby": {
        "regex": "Nobby[ ](S500|X800|S300(?: Pro)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "NEC": {
        "regex": "NEC[ _\\-]|KGT/2\\.0|PC-TE508(?:S1|[BH]AW)|PC-TE510(?:HAW|BAL|S1)|PC-TS708T1W|PC-TS507N1S|PC-TE507JAW|portalmmm/1\\.0 (?:DB|N)|(?:portalmmm|o2imode)/2.0[ ,]N|(?:N-06C|N-02E|LAVIE Tab E (?:10|8)FHD1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "N-06C(?:[);/ ]|$)",
                "model": "Medias Amadana"
            },
            {
                "regex": "N-02E(?:[);/ ]|$)",
                "model": "Medias U"
            },
            {
                "regex": "(?:NEC[ _\\-]|KGT/2\\.0 )([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/1\\.0 ((?:DB|N)[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(?:portalmmm|o2imode)/2\\.0[ ,](N[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "PC-TE508[BH]AW(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab E TE508"
            },
            {
                "regex": "PC-TE510(?:BAL|HAW|S1)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab E TE510"
            },
            {
                "regex": "PC-TS507N1S(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab S TS507"
            },
            {
                "regex": "PC-TS708T1W(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab S TS708"
            },
            {
                "regex": "PC-TE507JAW(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab E TS507"
            },
            {
                "regex": "PC-TE508S1(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab E TE508"
            },
            {
                "regex": "(LAVIE Tab E (?:10|8)FHD1)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Neffos": {
        "regex": "Neffos|(TP601A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TP601A(?:[);/ ]|$)",
                "model": "C5L"
            },
            {
                "regex": "Neffos[_ ]Y50",
                "model": "Y50"
            },
            {
                "regex": "Neffos X20 Pro",
                "model": "X20 Pro"
            },
            {
                "regex": "Neffos[_ ]((?:[YNCXA])[0-9][A-Z]?(?: Max| Lite)?)",
                "model": "$1"
            }
        ]
    },
    "Nextbit": {
        "regex": "Nextbit|(?:Robin)(?: Build|\\))",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Robin)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Newgen": {
        "regex": "NEWGEN\\-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Netgear": {
        "regex": "GTV100",
        "device": "tv",
        "models": [
            {
                "regex": "GTV100",
                "model": "NeoTV Prime"
            }
        ]
    },
    "NeuImage": {
        "regex": "NIM-",
        "device": "smartphone",
        "models": [
            {
                "regex": "NIM-(450D|550O|600Q)",
                "model": "$1"
            }
        ]
    },
    "NextBook": {
        "regex": "Next[0-9]|NX(?:785QC8G|M900MC|008HD8G|010HI8G|M908HC|M726|16A8116K|A8QC116|16A10132S|16A11264)",
        "device": "tablet",
        "models": [
            {
                "regex": "NX008HD8G",
                "model": "Premium 8 HD"
            },
            {
                "regex": "NXA8QC116",
                "model": "Ares 8"
            },
            {
                "regex": "NX16A8116K",
                "model": "Ares A8"
            },
            {
                "regex": "NX16A10132S",
                "model": "Ares A10"
            },
            {
                "regex": "NX16A11264",
                "model": "Ares A11"
            },
            {
                "regex": "NXM908HC",
                "model": "Premium 9"
            },
            {
                "regex": "NX010HI8G",
                "model": "Premium 10 Hi"
            },
            {
                "regex": "NX785QC8G",
                "model": "8"
            },
            {
                "regex": "NXM900MC",
                "model": "8 HD"
            },
            {
                "regex": "NXM726",
                "model": "Premium 7"
            },
            {
                "regex": "Next([0-9]+[^;/]+) Build",
                "model": "Next $1"
            }
        ]
    },
    "NGM": {
        "regex": "NGM[_ ][a-z0-9]+|(Forward|Dynamic)[ _]?[^/;]+(?:Build|/)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Forward|Dynamic)[ _]?([^/;]+) Build",
                "model": "$1 $2"
            },
            {
                "regex": "(Forward|Dynamic)[ _]?([^/;]+)/",
                "model": "$1 $2"
            },
            {
                "regex": "NGM ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "NGM_([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Nexian": {
        "regex": "S?Nexian",
        "device": "smartphone",
        "models": [
            {
                "regex": "S?Nexian[ ]?([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "S?Nexian-([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Noain": {
        "regex": "NOAIN",
        "device": "smartphone",
        "models": [
            {
                "regex": "NOAIN[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "NOAIN[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Noblex": {
        "regex": "Noblex|NBX-",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Noblex|NBX)[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:Noblex|NBX)[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Nomu": {
        "regex": "Nomu[ _-](?:T18|S30mini|S10)(?:[);/ ]|$)|V1600S(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Nomu[ _-]T18(?:[);/ ]|$)",
                "model": "T18"
            },
            {
                "regex": "Nomu[ _-]s10(?:[);/ ]|$)",
                "model": "S10"
            },
            {
                "regex": "Nomu[ _-]S30mini(?:[);/ ]|$)",
                "model": "S30 Mini"
            },
            {
                "regex": "(V1600S)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Nomi": {
        "regex": "Nomi[ _-]|(C101010 Ultra2|i501[234]|i5032|i50[57]0|i5510|i5532|C0(700(?:[02358]|2HD)|7850)|C1010[0-3])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "i501[23](?:[);/ ]|$)",
                "model": "Evo M2"
            },
            {
                "regex": "I5070(?:[);/ ]|$)",
                "model": "Iron-X"
            },
            {
                "regex": "i5014(?:[);/ ]|$)",
                "model": "Evo M4"
            },
            {
                "regex": "i5032(?:[);/ ]|$)",
                "model": "Evo X2"
            },
            {
                "regex": "i5050(?:[);/ ]|$)",
                "model": "Evo Z"
            },
            {
                "regex": "Nomi_i4510(?:[);/ ]|$)",
                "model": "Beat M"
            },
            {
                "regex": "i5532(?:[);/ ]|$)",
                "model": "Space X2"
            },
            {
                "regex": "i5510(?:[);/ ]|$)",
                "model": "Space M"
            },
            {
                "regex": "C101010 Ultra2",
                "model": "Ultra 2",
                "device": "tablet"
            },
            {
                "regex": "(C0(?:700(?:[02358]|2HD)|7850)|C1010[0-3])(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Nomi[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Nomi[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "NUU Mobile": {
        "regex": "NUU_|(?:(?:N(5702|5001)L|S6001L)|A6L-[CG])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NUU_A([13])",
                "model": "A$1"
            },
            {
                "regex": "NUU_M([32])(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "NUU_X5(?:[);/ ]|$)",
                "model": "X5"
            },
            {
                "regex": "S6001L",
                "model": "G2"
            },
            {
                "regex": "N5702L",
                "model": "G3"
            },
            {
                "regex": "(N5001L|A6L-[CG])(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "NYX Mobile": {
        "regex": "NYX[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "NYX_A1",
                "model": "A1"
            },
            {
                "regex": "NYX_Blink",
                "model": "Blink"
            },
            {
                "regex": "NYX_EGO",
                "model": "Ego"
            },
            {
                "regex": "NYX_FENIX",
                "model": "Fenix"
            },
            {
                "regex": "NYX_FLY_II",
                "model": "Fly II"
            },
            {
                "regex": "NYX_FLY_MINI",
                "model": "Fly Mini"
            },
            {
                "regex": "NYX_FLY",
                "model": "Fly"
            },
            {
                "regex": "NYX_HIT",
                "model": "Hit"
            },
            {
                "regex": "NYX_JAK",
                "model": "Jak"
            },
            {
                "regex": "NYX_JOIN",
                "model": "Join"
            },
            {
                "regex": "NYX_NOBA_II",
                "model": "Noba II"
            },
            {
                "regex": "NYX_NOBA",
                "model": "Noba"
            },
            {
                "regex": "NYX_ORBIS",
                "model": "Orbis"
            },
            {
                "regex": "NYX[ _]REX",
                "model": "Rex"
            },
            {
                "regex": "NYX_SHADE",
                "model": "Shade"
            },
            {
                "regex": "NYX_SKY",
                "model": "Sky"
            },
            {
                "regex": "NYX_SPARK",
                "model": "Spark"
            },
            {
                "regex": "NYX_VOX",
                "model": "Vox"
            },
            {
                "regex": "NYX_ZEUZ_HD",
                "model": "Zeus HD"
            }
        ]
    },
    "Nous": {
        "regex": "(?:NS(?:[356]|500[2-68]|5511|5502)|NS 5511)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NS 5511(?:[);/ ]|$)",
                "model": "NS5511"
            },
            {
                "regex": "(NS[0-9]{1,4})(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Nvidia": {
        "regex": "NVIDIA|SHIELD Tablet K1|SHIELD Android TV|Tegra(Note-P1640| Note 7)",
        "device": "tablet",
        "models": [
            {
                "regex": "TegraNote-P1640",
                "model": "Tegra Note P1640"
            },
            {
                "regex": "(SHIELD Tablet K1|Tegra Note 7)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "SHIELD Android TV",
                "model": "SHIELD Android TV",
                "device": "tv"
            },
            {
                "regex": "NVIDIA_SHIELD_PRO_2019",
                "model": "SHIELD TV Pro",
                "device": "tv"
            },
            {
                "regex": "NVIDIA Shield",
                "model": "SHIELD TV",
                "device": "tv"
            }
        ]
    },
    "O+": {
        "regex": "O\\+[ _](Air|Crunch|Ultra|Upsized|Venti|360 ALPHA PLUS 2.0)",
        "device": "smartphone",
        "models": [
            {
                "regex": "O\\+[ _](Crunch|Ultra 2.0|Ultra|Upsized|Venti 4G)",
                "model": "$1"
            },
            {
                "regex": "O\\+_AIR",
                "model": "Air"
            },
            {
                "regex": "O\\+ 360 ALPHA PLUS 2.0",
                "model": "360 Alpha Plus 2.0"
            }
        ]
    },
    "O2": {
        "regex": "Xda|(?<!FBCR/)O2[ \\-]|COCOON",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Xda[ _][a-z0-9_]+)",
                "model": "$1"
            },
            {
                "regex": "(COCOON)",
                "model": "$1"
            },
            {
                "regex": "O2 ([a-z0-9 ]+)",
                "model": "$1"
            },
            {
                "regex": "O2-([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Odys": {
        "regex": "ODYS[ _-]|IEOS[_ ]([^/;]+)|NOON(?:_PRO)? Build|SPACE10_(?:PLUS|PRO)_3G|THOR_?10|TAO_X10|RAPID_?(?:10|7)_?LTE|MAVEN_?10_|CONNECT[78]|ELEMENT10_PLUS_3G|XELIO[_0-9P]|ADM816HC|ADM8000KP|NEO6_LTE|EOS10|AEON|FALCON_10_PLUS_3G|FUSION|THANOS_10|MAVEN_X10_HD(?:_LTE)?|JUNIOR_8_PRO|JuniorT8Pro|(?:NOVA|PYRO)_X?7_PLUS_3G|UNO_X8|SLADE_X55|XELIO_PRO_10_LTE|NOTOSplus3G",
        "device": "tablet",
        "models": [
            {
                "regex": "XELIO[_ ]A10",
                "model": "Xelio A10"
            },
            {
                "regex": "XELIOPHONETAB3",
                "model": "Xelio Phonetab 3"
            },
            {
                "regex": "THANOS_10",
                "model": "Thanos 10"
            },
            {
                "regex": "XELIO_NEXT_10_PLUS_3G",
                "model": "Xelio Next 10 Plus 3G"
            },
            {
                "regex": "XELIO_PHONE_TAB7_3G",
                "model": "Xelio Phonetab 7 3G"
            },
            {
                "regex": "XELIO10EXTREME",
                "model": "Xelio 10 Xtreme"
            },
            {
                "regex": "XELIO10_PLUS_3G",
                "model": "Xelio 10 Plus 3G"
            },
            {
                "regex": "XELIO10_HD_PLUS_3G",
                "model": "Xelio 10 HD Plus 3G"
            },
            {
                "regex": "XELIO_10_HD",
                "model": "Xelio 10 HD"
            },
            {
                "regex": "XELIO_PRO_10_LTE",
                "model": "Xelio Pro 10 LTE"
            },
            {
                "regex": "ELEMENT10_PLUS_3G",
                "model": "Element 10 Plus 3G"
            },
            {
                "regex": "CONNECT8PLUS",
                "model": "Connect 8 Plus"
            },
            {
                "regex": "CONNECT7PRO",
                "model": "Connect 7 Pro"
            },
            {
                "regex": "MAVEN_X10_HD_LTE",
                "model": "Maven X10 HD LTE"
            },
            {
                "regex": "MAVEN_X10_HD",
                "model": "Maven X10 HD"
            },
            {
                "regex": "MAVEN_?10_PRO_PLUS_3G",
                "model": "Maven 10 Pro Plus 3G"
            },
            {
                "regex": "MAVEN_?10_?PLUS",
                "model": "Maven 10 Plus"
            },
            {
                "regex": "MAVEN_?10_?PRO",
                "model": "Maven 10 Pro"
            },
            {
                "regex": "MAVEN_?10_?HD",
                "model": "Maven 10 HD"
            },
            {
                "regex": "RAPID_?7_?LTE",
                "model": "Rapid 7 LTE"
            },
            {
                "regex": "RAPID_?10_?LTE",
                "model": "Rapid 10 LTE"
            },
            {
                "regex": "TAO_X10",
                "model": "Tao X10"
            },
            {
                "regex": "SPACE10_PLUS_3G",
                "model": "Space 10 Plus 3G"
            },
            {
                "regex": "SPACE10_PRO_3G",
                "model": "Space 10 Pro 3G"
            },
            {
                "regex": "THOR_?10 Build",
                "model": "Thor 10"
            },
            {
                "regex": "JuniorT8Pro",
                "model": "Junior T8 Pro"
            },
            {
                "regex": "JUNIOR_8_PRO",
                "model": "Junior 8 Pro"
            },
            {
                "regex": "ADM816HC",
                "model": "Neo X"
            },
            {
                "regex": "EOS10",
                "model": "EOS 10"
            },
            {
                "regex": "AEON",
                "model": "Aeon"
            },
            {
                "regex": "FALCON_10_PLUS_3G",
                "model": "Falcon 10 Plus 3G"
            },
            {
                "regex": "FUSION",
                "model": "Fusion 7"
            },
            {
                "regex": "UNO_X8",
                "model": "Uno X8"
            },
            {
                "regex": "ADM8000KP",
                "model": "Titan"
            },
            {
                "regex": "PYRO_7_PLUS_3G",
                "model": "Pyro 7 Plus 3G"
            },
            {
                "regex": "NOVA_X7_PLUS_3G",
                "model": "Nova X7 Plus 3G"
            },
            {
                "regex": "ODYS_NOVA_X7",
                "model": "Nova X7"
            },
            {
                "regex": "THOR_?10_PLUS_3G",
                "model": "Thor 10 Plus 3G"
            },
            {
                "regex": "NOTOSplus3G",
                "model": "Notos Plus 3G"
            },
            {
                "regex": "NEO6[_ ]LTE",
                "model": "Neo 6 LTE",
                "device": "smartphone"
            },
            {
                "regex": "SLADE_X55",
                "model": "Slade X55",
                "device": "smartphone"
            },
            {
                "regex": "IEOS[ _]([^/;]+) Build",
                "model": "Ieos $1"
            },
            {
                "regex": "(?:ODYS[ _-])?NOON Build",
                "model": "Noon"
            },
            {
                "regex": "(?:ODYS[ _-])?NOON_PRO Build",
                "model": "Noon Pro"
            },
            {
                "regex": "Odys[ _-]([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Obi": {
        "regex": "Obi[ _-]|(SJ1\\.5|SJ2\\.6|S400|S452\\+|S451|S453|S501|S502|S503\\+?|S507|S520|S550|S551|falcon)[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "SJ2\\.6",
                "model": "SJ2.6"
            },
            {
                "regex": "SJ1\\.5",
                "model": "SJ1.5"
            },
            {
                "regex": "(?:Obi_)?S400",
                "model": "Skipper"
            },
            {
                "regex": "(?:Obi_)?S451|falcon",
                "model": "Flacon"
            },
            {
                "regex": "(?:Obi_)?S452\\+",
                "model": "Python"
            },
            {
                "regex": "(?:Obi_)?S453",
                "model": "Fox"
            },
            {
                "regex": "(?:Obi_)?S501",
                "model": "Wolverine"
            },
            {
                "regex": "(?:Obi_)?S502",
                "model": "Leopard"
            },
            {
                "regex": "(?:Obi_)?S503\\+",
                "model": "Boa Plus"
            },
            {
                "regex": "(?:Obi_)?S503",
                "model": "Boa"
            },
            {
                "regex": "(?:Obi_)?S507",
                "model": "Pelican"
            },
            {
                "regex": "(?:Obi_)?S520",
                "model": "Octopus"
            },
            {
                "regex": "(?:Obi_)?S550",
                "model": "Crane"
            },
            {
                "regex": "(?:Obi_)?S551",
                "model": "Hornbill"
            },
            {
                "regex": "(?:Obi_)?S454",
                "model": "Alligator"
            },
            {
                "regex": "Obi[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Obi[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Okapia": {
        "regex": "Signature (?:L|Pro|Touch)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Signature (L|Pro|Touch)",
                "model": "Signature $1"
            }
        ]
    },
    "Onda": {
        "regex": "Onda|(?:(?:V820w|V891[w]?|V919(?: 3G)? Air)[ _-]DualOS|(?:V919 4G Air|V989 Air|V972) Core[48]|T2101L2B1C| V10 4G|OBOOK (?:20 SE|20 PLUS DUALOS)|OBOOK10 SE|V919 Air CH DualOS)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ONDA[ _]MID",
                "model": "MID",
                "device": "tablet"
            },
            {
                "regex": "V820w[ _-]DualOS",
                "model": "V820W Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V891W[ _-]DualOS",
                "model": "V891W Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V891[ _-]DualOS",
                "model": "V891 Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V919 3G Air[ _-]DualOS",
                "model": "V919 3G Air Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V919 Air[ _-]DualOS",
                "model": "V919 Air Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V919 Air CH DualOS",
                "model": "V919 Air CH Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V919 4G Air Core8",
                "model": "V919 4G Air Core 8",
                "device": "tablet"
            },
            {
                "regex": "V972 Core4",
                "model": "V919 Core 4",
                "device": "tablet"
            },
            {
                "regex": "V989 Air Core8",
                "model": "V989 Air Core 8",
                "device": "tablet"
            },
            {
                "regex": "T2101L2B1C|OBOOK 20 PLUS DUALOS",
                "model": "oBook 20 Plus Dual OS",
                "device": "tablet"
            },
            {
                "regex": " V10 4G(?:[);/ ]|$)",
                "model": "V10 10.1\" 4G",
                "device": "tablet"
            },
            {
                "regex": "OBOOK 20 SE(?:[);/ ]|$)",
                "model": "oBook 20 SE",
                "device": "tablet"
            },
            {
                "regex": "OBOOK10 SE(?:[);/ ]|$)",
                "model": "oBook 10 SE",
                "device": "tablet"
            },
            {
                "regex": "([a-z0-9]+)[ _]Onda",
                "model": "$1"
            },
            {
                "regex": "Onda ([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "OnePlus": {
        "regex": "(?:du_)?ONEPLUS|(?:A0001|A200[135]|AC200[13]|A300[03]|A3010|A5000|A600[03]|A601[03]|BE201[1235]|BE2025|BE202[89]|E100[135]|GM191[03517]|GM190[0135]|GM192[05]|HD191[013]|HD190[01357]|HD1925|IN201[013579]|IN202[0135]|KB200[01357]|LE2117|LE212[03])(?: Build|\\))",
        "device": "smartphone",
        "models": [
            {
                "regex": "AC200[13](?:[);/ ]|$)",
                "model": "Nord 5G"
            },
            {
                "regex": "BE2012(?:[);/ ]|$)",
                "model": "Clover"
            },
            {
                "regex": "BE201[135](?:[);/ ]|$)",
                "model": "Nord N100"
            },
            {
                "regex": "BE2025(?:[);/ ]|$)",
                "model": "Nord N10"
            },
            {
                "regex": "BE2029(?:[);/ ]|$)",
                "model": "Nord N10 5G"
            },
            {
                "regex": "BE2028(?:[);/ ]|$)",
                "model": "Nord N10 Lite"
            },
            {
                "regex": "IN202[0135](?:[);/ ]|$)",
                "model": "8 Pro"
            },
            {
                "regex": "KB2000(?:[);/ ]|$)",
                "model": "8T"
            },
            {
                "regex": "IN201[01357](?:[);/ ]|$)",
                "model": "8"
            },
            {
                "regex": "IN2019(?:[);/ ]|$)",
                "model": "8 5G UW"
            },
            {
                "regex": "LE2117(?:[);/ ]|$)",
                "model": "9"
            },
            {
                "regex": "LE212[03](?:[);/ ]|$)",
                "model": "9 Pro"
            },
            {
                "regex": "(?:GM191[01357]|OnePlus 7 Pro)(?:[);/ ]|$)",
                "model": "7 Pro"
            },
            {
                "regex": "GM190[0135](?:[);/ ]|$)",
                "model": "7"
            },
            {
                "regex": "HD190[01357](?:[);/ ]|$)",
                "model": "7T"
            },
            {
                "regex": "(?:HD191[013]|OnePlus 7T Pro)(?:[);/ ]|$)",
                "model": "7T Pro"
            },
            {
                "regex": "(?:HD1925|GM192[05])(?:[);/ ]|$)",
                "model": "7T Pro 5G"
            },
            {
                "regex": "KB200[1357](?:[);/ ]|$)",
                "model": "8T"
            },
            {
                "regex": "A0001(?:[);/ ]|$)",
                "model": "One"
            },
            {
                "regex": "A200[135]|OnePlus2",
                "model": "2"
            },
            {
                "regex": "E100[135](?:[);/ ]|$)",
                "model": "X"
            },
            {
                "regex": "A3010|OnePlus3T",
                "model": "3T"
            },
            {
                "regex": "A300[03]|OnePlus3",
                "model": "3"
            },
            {
                "regex": "A5010|OnePlus[ ]?5T",
                "model": "5T"
            },
            {
                "regex": "A5000|OnePlus5",
                "model": "5"
            },
            {
                "regex": "A600[03]|OnePlus6",
                "model": "6"
            },
            {
                "regex": "A601[03](?:[);/ ]|$)",
                "model": "6T"
            },
            {
                "regex": "(?:du_)?ONEPLUS ?([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Realme": {
        "regex": "Realme[ _]|(?:RMX(?:19(03|4[1235]|19|9[23]|2[157]|[01379]1|73)|20(?:[025-7]1|[037]2|2[57]|63|7[56]|8[156]|[2-5]0)|21(?:0[13]|17|[12]1|4[24]|5[15]|6[13]|7[60]|8[059]|9[35])|2200|18(0[1579]|11|3[13]|2[157]|[45]1|45)|3201|30[38]1|3063)|(?:OPPO[ _]?)?CPH1861)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:OPPO[ _]?)?CPH1861(?:[);/ ]|$)",
                "model": "1"
            },
            {
                "regex": "RMX180[59]",
                "model": "2"
            },
            {
                "regex": "RMX180[17]",
                "model": "2 Pro"
            },
            {
                "regex": "RMX(1833|182[15])",
                "model": "3"
            },
            {
                "regex": "RMX1827",
                "model": "3i"
            },
            {
                "regex": "RMX1851",
                "model": "3 Pro"
            },
            {
                "regex": "RMX190[13]|Realme X(?:[);/ ]|$)",
                "model": "X"
            },
            {
                "regex": "RMX199[12]",
                "model": "X2"
            },
            {
                "regex": "RMX1993",
                "model": "X2 Dual"
            },
            {
                "regex": "RMX1931|Realme X2 Pro(?:[);/ ]|$)",
                "model": "X2 Pro"
            },
            {
                "regex": "RMX2117",
                "model": "Q2 5G"
            },
            {
                "regex": "RMX2176(?:[);/ ]|$)",
                "model": "X7 5G"
            },
            {
                "regex": "RMX2121(?:[);/ ]|$)",
                "model": "X7 Pro 5G"
            },
            {
                "regex": "RMX1921|Realme XT(?:[);/ ]|$)",
                "model": "XT"
            },
            {
                "regex": "RMX19(1[19]|27)",
                "model": "5"
            },
            {
                "regex": "RMX197[13]",
                "model": "5 Pro"
            },
            {
                "regex": "RMX203[02]",
                "model": "5i"
            },
            {
                "regex": "RMX2001",
                "model": "6"
            },
            {
                "regex": "RMX2040",
                "model": "6I"
            },
            {
                "regex": "RMX2002",
                "model": "6S"
            },
            {
                "regex": "RMX206[13](?:[);/ ]|$)",
                "model": "6 Pro"
            },
            {
                "regex": "RMX215[15]",
                "model": "7"
            },
            {
                "regex": "RMX2103",
                "model": "7I"
            },
            {
                "regex": "RMX2170",
                "model": "7 Pro"
            },
            {
                "regex": "RMX3081",
                "model": "8 Pro"
            },
            {
                "regex": "RMX1925(?:[);/ ]|$)",
                "model": "5S"
            },
            {
                "regex": "RMX1811(?:[);/ ]|$)",
                "model": "C1"
            },
            {
                "regex": "RMX194[1235](?:[);/ ]|$)",
                "model": "C2"
            },
            {
                "regex": "RMX202[107](?:[);/ ]|$)",
                "model": "C3"
            },
            {
                "regex": "RMX2185(?:[);/ ]|$)",
                "model": "C11"
            },
            {
                "regex": "RMX2189(?:[);/ ]|$)",
                "model": "C12"
            },
            {
                "regex": "RMX2180(?:[);/ ]|$)",
                "model": "C15"
            },
            {
                "regex": "RMX2195(?:[);/ ]|$)",
                "model": "C15 Qualcomm Edition"
            },
            {
                "regex": "RMX2101(?:[);/ ]|$)",
                "model": "C17"
            },
            {
                "regex": "RMX3063(?:[);/ ]|$)",
                "model": "C20"
            },
            {
                "regex": "RMX3031(?:[);/ ]|$)",
                "model": "GT Neo"
            },
            {
                "regex": "RMX216[13](?:[);/ ]|$)",
                "model": "Narzo 20 Pro"
            },
            {
                "regex": "RMX2193(?:[);/ ]|$)",
                "model": "Narzo 20"
            },
            {
                "regex": "RMX2050(?:[);/ ]|$)",
                "model": "Narzo 20A"
            },
            {
                "regex": "RMX1831(?:[);/ ]|$)",
                "model": "U1"
            },
            {
                "regex": "RMX(?:20(?:51|[2]5)|2144)(?:[);/ ]|$)",
                "model": "X50 5G"
            },
            {
                "regex": "RMX2071(?:[);/ ]|$)",
                "model": "X50 Pro"
            },
            {
                "regex": "RMX207[56](?:[);/ ]|$)",
                "model": "X50 Pro 5G"
            },
            {
                "regex": "RMX2072(?:[);/ ]|$)",
                "model": "X50 Pro Player"
            },
            {
                "regex": "RMX(2142|2081)(?:[);/ ]|$)",
                "model": "X3"
            },
            {
                "regex": "RMX208[56](?:[);/ ]|$)",
                "model": "X3 Super Zoom"
            },
            {
                "regex": "RMX2111",
                "model": "V5 5G"
            },
            {
                "regex": "RMX2200",
                "model": "V3 5G"
            },
            {
                "regex": "RMX3201",
                "model": "C21"
            },
            {
                "regex": "Realme[ _]([1-9])[ _]Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            }
        ]
    },
    "OPPO": {
        "regex": "(?:OB-)?OPPO[ _]?([a-z0-9]+)|N1T|R8001|OPG01|A00[12]OP|(?:X90[07][0679]|U70[57]T?|X909T?|R(?:10[01]1|2001|201[07]|6007|7005|7007|80[13579]|81[13579]|82[01379]|83[013]|800[067]|8015|810[679]|811[13]|820[057])[KLSTW]?|N520[79]|N5117|A33f|A33fw|A37fw?|PAAM00|PAAT00|PAC[TM]00)(?:[);/ ]|$)|R7kf|R7plusf|R7Plusm|A1601|CPH[0-9]{4}|CPH19(69|79|23|1[179])|PB(A[TM]00|CT10|BT30|CM[13]0|[FD]M00)|P(DAM10|ADM00|AF[TM]00|ADT00|AHM00|BBM[03]0|BBT00|BDT00|BFT00|[CB]E[MT]00|CA[MT]00|C[CDG]M00|CA[MT]10|[CD]PM00|CRM00|CDT00|CD[TM]10|CHM[013]0|CKM[08]0|CLM[15]0|DEM[13]0|DHM00|DK[TM]00|DPT00|DB[TM]00|DCM00|[CD]NM00|DVM00|DY[TM]20|DNT00|EA[TM]00)|PDSM00",
        "device": "smartphone",
        "models": [
            {
                "regex": "PCHM10(?:[);/ ]|$)",
                "model": "A11"
            },
            {
                "regex": "(?:CPH2083|CPH2077)(?:[);/ ]|$)",
                "model": "A12"
            },
            {
                "regex": "PCHM00(?:[);/ ]|$)",
                "model": "A11x"
            },
            {
                "regex": "CPH1923(?:[);/ ]|$)",
                "model": "A1K"
            },
            {
                "regex": "(?:OPPO[ _]?)?(CPH1837|PAD[TM]00)(?:[);/ ]|$)",
                "model": "A3"
            },
            {
                "regex": "(?:OPPO[ _]?)?A37f(w)(?:[);/ ]|$)",
                "model": "A37f$1"
            },
            {
                "regex": "A37f(?:[);/ ]|$)",
                "model": "A37f"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1605(?:[);/ ]|$)",
                "model": "A39"
            },
            {
                "regex": "CPH20(?:81|73|31|15)(?:[);/ ]|$)",
                "model": "A31"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH18(?:0[35]|53)|PBBM30)(?:[);/ ]|$)",
                "model": "A3s"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1809|PBA[TM]00|PBBT30)(?:[);/ ]|$)",
                "model": "A5"
            },
            {
                "regex": "CPH19(?:3[13]|43)(?:[);/ ]|$)",
                "model": "A5 (2020)"
            },
            {
                "regex": "PDVM00(?:[);/ ]|$)",
                "model": "A32"
            },
            {
                "regex": "(?:PDAM10|CPH2069|CPH2061)(?:[);/ ]|$)",
                "model": "A52"
            },
            {
                "regex": "CPH2127(?:[);/ ]|$)",
                "model": "A53"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH170[15](?:[);/ ]|$)",
                "model": "A57"
            },
            {
                "regex": "CPH19(?:09|1[02])(?:[);/ ]|$)",
                "model": "A5S"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH190[15]|PBF[TM]00)(?:[);/ ]|$)",
                "model": "A7"
            },
            {
                "regex": "(?:OPPO[ _]?)?(CPH1801|CPH1717)(?:[);/ ]|$)",
                "model": "A71"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PDY[TM]20|CPH2067)(?:[);/ ]|$)",
                "model": "A72"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1715(?:[);/ ]|$)",
                "model": "A77"
            },
            {
                "regex": "PCD[TM]00(?:[);/ ]|$)",
                "model": "A7n"
            },
            {
                "regex": "(PBBT00|PBBM00)(?:[);/ ]|$)",
                "model": "A7x"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PDBM00)(?:[);/ ]|$)",
                "model": "A8"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1729(?:[);/ ]|$)",
                "model": "A83"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1827(?:[);/ ]|$)",
                "model": "A83 (2018)"
            },
            {
                "regex": "PCA[TM]10(?:[);/ ]|$)",
                "model": "A9"
            },
            {
                "regex": "(CPH1937|CPH1941|PCHM30)(?:[);/ ]|$)",
                "model": "A9 (2020)"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1938(?:[);/ ]|$)",
                "model": "A9 (EN)"
            },
            {
                "regex": "(?:PCPM00|CPH20[02]1)(?:[);/ ]|$)",
                "model": "A91"
            },
            {
                "regex": "CPH2059(?:[);/ ]|$)",
                "model": "A92"
            },
            {
                "regex": "PDKT00(?:[);/ ]|$)",
                "model": "A92s"
            },
            {
                "regex": "PDKM00(?:[);/ ]|$)",
                "model": "A93s"
            },
            {
                "regex": "PCE[TM]00(?:[);/ ]|$)",
                "model": "A9x"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1851(?:[);/ ]|$)",
                "model": "AX5"
            },
            {
                "regex": "CPH1920(?:[);/ ]|$)",
                "model": "AX5s"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1903(?:[);/ ]|$)",
                "model": "AX7"
            },
            {
                "regex": "(?:OPPO[ _]?)?X9009(?:[);/ ]|$)",
                "model": "F1 Plus"
            },
            {
                "regex": "CPH191[135](?:[);/ ]|$)",
                "model": "F11"
            },
            {
                "regex": "CPH19(?:69|87)(?:[);/ ]|$)",
                "model": "F11 Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH2119)(?:[);/ ]|$)",
                "model": "F17 Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?A1601(?:[);/ ]|$)",
                "model": "F1s"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1609(?:[);/ ]|$)",
                "model": "F3"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1613(?:[);/ ]|$)",
                "model": "F3 Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH172[37](?:[);/ ]|$)",
                "model": "F5"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1725(?:[);/ ]|$)",
                "model": "F5 Youth"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH(1859|18(?:19|21))(?:[);/ ]|$)",
                "model": "F7"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1825|CPH1881)(?:[);/ ]|$)",
                "model": "F9"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1823(?:[);/ ]|$)",
                "model": "F9 Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?X909T?(?:[);/ ]|$)",
                "model": "Find 5"
            },
            {
                "regex": "(?:OPPO[ _]?)?R827T?(?:[);/ ]|$)",
                "model": "Find 5 Mini"
            },
            {
                "regex": "(?:OPPO[ _]?)?X907[067](?:[);/ ]|$)",
                "model": "Find 7"
            },
            {
                "regex": "(?:OPPO[ _]?)?X900[067](?:[);/ ]|$)",
                "model": "Find 7a"
            },
            {
                "regex": "(?:OPPO[ _]?)?R815[TW]?(?:[);/ ]|$)",
                "model": "Find Clover"
            },
            {
                "regex": "(?:OPPO[ _]?)?R8015(?:[);/ ]|$)",
                "model": "Find Guitar"
            },
            {
                "regex": "(?:OPPO[ _]?)?R8111(?:[);/ ]|$)",
                "model": "Find Melody"
            },
            {
                "regex": "(?:OPPO[ _]?)?R821T?(?:[);/ ]|$)",
                "model": "Find Muse"
            },
            {
                "regex": "(?:OPPO[ _]?)?U707T?(?:[);/ ]|$)",
                "model": "Find Way S"
            },
            {
                "regex": "(?:OPPO[ _]?)?U705T(?:[);/ ]|$)",
                "model": "Ulike 2"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH187[15]|PAF[MT]00)(?:[);/ ]|$)",
                "model": "Find X"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PAHM00)(?:[);/ ]|$)",
                "model": "Find X Lamborghini"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PDEM10|CPH2023)(?:[);/ ]|$)",
                "model": "Find X2"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH2005(?:[);/ ]|$)",
                "model": "Find X2 Lite"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PDEM30|OPG01|CPH2025)(?:[);/ ]|$)",
                "model": "Find X2 Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?R1011 Build",
                "model": "Joy Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?(PBC(?:M30|T10))(?:[);/ ]|$)",
                "model": "K1"
            },
            {
                "regex": "CPH1955(?:[);/ ]|$)",
                "model": "K3"
            },
            {
                "regex": "(?:OPPO[ _]?)?(PCNM00)(?:[);/ ]|$)",
                "model": "K5"
            },
            {
                "regex": "(?:OPPO[ _]?)?(PCLM50)(?:[);/ ]|$)",
                "model": "K7"
            },
            {
                "regex": "(?:OPPO[ _]?)?N5117(?:[);/ ]|$)",
                "model": "N1 Mini"
            },
            {
                "regex": "(?:OPPO[ _]?)?N520[79](?:[);/ ]|$)",
                "model": "N3"
            },
            {
                "regex": "(?:OPPO[ _]?)?R831T?(?:[);/ ]|$)",
                "model": "Neo"
            },
            {
                "regex": "(?:OPPO[ _]?)?R831K(?:[);/ ]|$)",
                "model": "Neo 3"
            },
            {
                "regex": "(?:OPPO[ _]?)?R831[SL](?:[);/ ]|$)",
                "model": "Neo 5"
            },
            {
                "regex": "(?:OPPO[ _]?)?A33f(?:[);/ ]|$)",
                "model": "Neo 7"
            },
            {
                "regex": "(?:OPPO[ _]?)?A33fw(?:[);/ ]|$)",
                "model": "Neo 7s"
            },
            {
                "regex": "(?:OPPO[ _]?)?R8113(?:[);/ ]|$)",
                "model": "Piano"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1707(?:[);/ ]|$)",
                "model": "R11"
            },
            {
                "regex": "R8001(?:[);/ ]|$)",
                "model": "R1K"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1719(?:[);/ ]|$)",
                "model": "R11s"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1721(?:[);/ ]|$)",
                "model": "R11s Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1835|PAC[TM]00|PAAM00)(?:[);/ ]|$)",
                "model": "R15"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH183[13]|PAAT00)(?:[);/ ]|$)",
                "model": "R15 Pro"
            },
            {
                "regex": "PBCM10(?:[);/ ]|$)",
                "model": "R15x"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1879|PBE[MT]00)(?:[);/ ]|$)",
                "model": "R17"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1893)(?:[);/ ]|$)",
                "model": "R17 Neo"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1877|PBD[MT]00)(?:[);/ ]|$)",
                "model": "R17 Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?R8006(?:[);/ ]|$)",
                "model": "R1L"
            },
            {
                "regex": "(?:OPPO[ _]?)?R800[07](?:[);/ ]|$)",
                "model": "R1S"
            },
            {
                "regex": "(?:OPPO[ _]?)?R810[679](?:[);/ ]|$)",
                "model": "R5"
            },
            {
                "regex": "(?:OPPO[ _]?)?R7kf(?:[);/ ]|$)",
                "model": "R7 Lite"
            },
            {
                "regex": "(?:OPPO[ _]?)?R7Plusm(?:[);/ ]|$)",
                "model": "R7 Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?R7Plusf(?:[);/ ]|$)",
                "model": "R7 Plus F"
            },
            {
                "regex": "(?:OPPO[ _]?)?X9079(?:[);/ ]|$)",
                "model": "R9 Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1607(?:[);/ ]|$)",
                "model": "R9s"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1611|R9s Plus)(?:[);/ ]|$)",
                "model": "R9s Plus"
            },
            {
                "regex": "(?:CPH1917|PCA[MT]00)(?:[);/ ]|$)",
                "model": "Reno"
            },
            {
                "regex": "CPH1983(?:[);/ ]|$)",
                "model": "Reno A"
            },
            {
                "regex": "PCCM00(?:[);/ ]|$)",
                "model": "Reno 10X"
            },
            {
                "regex": "CPH1919(?:[);/ ]|$)",
                "model": "Reno 10X Zoom"
            },
            {
                "regex": "(?:PCKM00|CPH1907)(?:[);/ ]|$)",
                "model": "Reno 2"
            },
            {
                "regex": "CPH1989(?:[);/ ]|$)",
                "model": "Reno 2F"
            },
            {
                "regex": "(?:PCKM80|CPH1945|CPH1951)(?:[);/ ]|$)",
                "model": "Reno 2Z"
            },
            {
                "regex": "CPH2043(?:[);/ ]|$)",
                "model": "Reno 3"
            },
            {
                "regex": "(?:CPH2013|A002OP)(?:[);/ ]|$)",
                "model": "Reno 3A"
            },
            {
                "regex": "(?:PDCM00|A001OP)(?:[);/ ]|$)",
                "model": "Reno 3 5G"
            },
            {
                "regex": "(?:PCRM00|CPH203[57]|CPH2009)",
                "model": "Reno 3 Pro"
            },
            {
                "regex": "CPH2113(?:[);/ ]|$)",
                "model": "Reno 4 4G"
            },
            {
                "regex": "CPH2125(?:[);/ ]|$)",
                "model": "Reno 4 Lite"
            },
            {
                "regex": "CPH2109(?:[);/ ]|$)",
                "model": "Reno 4 Pro 4G"
            },
            {
                "regex": "PDP[TM]00(?:[);/ ]|$)",
                "model": "Reno 4 5G"
            },
            {
                "regex": "PEA[TM]00(?:[);/ ]|$)",
                "model": "Reno 4 SE 5G "
            },
            {
                "regex": "PDN[TM]00(?:[);/ ]|$)",
                "model": "Reno 4 Pro 5G"
            },
            {
                "regex": "PDSM00(?:[);/ ]|$)",
                "model": "Reno 5 Pro 5G"
            },
            {
                "regex": "CPH192[15]",
                "model": "Reno 5G"
            },
            {
                "regex": "PCLM10(?:[);/ ]|$)",
                "model": "Reno Ace"
            },
            {
                "regex": "PDHM00(?:[);/ ]|$)",
                "model": "Reno Ace 2"
            },
            {
                "regex": "PCGM00(?:[);/ ]|$)",
                "model": "Reno K3"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1979|PCD[TM]10)(?:[);/ ]|$)",
                "model": "Reno Z"
            },
            {
                "regex": "N1T?(?:[);/ ]|$)",
                "model": "N1T",
                "device": "phablet"
            },
            {
                "regex": "R([0-9]{3,4}[KSTW]?)(?:[);/ ]|$)",
                "model": "R$1"
            },
            {
                "regex": "(CPH[0-9]{4})",
                "model": "$1"
            },
            {
                "regex": "(?:OB-)?OPPO[ _]?((?!Browser)[a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Opsson": {
        "regex": "Opsson|IUSAI",
        "device": "smartphone",
        "models": [
            {
                "regex": "IUSAI[ _]([^/;]+) Build",
                "model": "Iusai $1"
            },
            {
                "regex": "IUSAI[ _]([^/;\\)]+)[/;\\)]",
                "model": "Iusai $1"
            },
            {
                "regex": "Opsson[ _]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:Opsson-)?Opsson[ -_]([^/;]+)/",
                "model": "$1"
            }
        ]
    },
    "Orange": {
        "regex": "SPV[ \\-]?([a-z0-9]+)|(?<!FBCR/)Orange[ _-](?!Tahiti-LS\\))([^/;]+)( Build|\\))(?<!Tahiti-LS\\))|SC/IHD92|Nura 2|FunTab ([^/;]+) Build|Orange Mahpee",
        "device": "smartphone",
        "models": [
            {
                "regex": "SC/IHD92",
                "model": "Livebox Play",
                "device": "tv"
            },
            {
                "regex": "Nura 2",
                "model": "Nura 2"
            },
            {
                "regex": "Sego",
                "model": "Sego",
                "device": "tablet"
            },
            {
                "regex": "FunTab ([^/;]+) Build",
                "model": "FunTab $1",
                "device": "tablet"
            },
            {
                "regex": "Orange[ _-](Rise)(3[12]|5[12])(?:[);/ ]|$)",
                "model": "$1 $2"
            },
            {
                "regex": "Orange[ _-](Dive)72(?:[);/ ]|$)",
                "model": "$1 72"
            },
            {
                "regex": "Orange[ _-](Daytona|Dive (30|7[13])|Dublin|Fova|Gova|Hi 4G|Hiro|Kivo|Monte Carlo|Neva 80|Neva play|Nura|Reyo|Rise[_ ](3[034]|40|5[345])|Rono|Roya|San Francisco|Tactile internet 2|Tado|Yomi|Yumo|Zali|Mahpee)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SPV[ \\-]?([a-z0-9]+)",
                "model": "SPV $1"
            }
        ]
    },
    "Oukitel": {
        "regex": "OUKITEL|(?:(?:C15|C16|K10000|K[46]000)(?:[ _]Pro)|K4000Pro|U16 Max|U7 Max|U7 Plus|U11[_ ]Plus|U20_Plus|OK6000 Plus|WP5000|WP[58] Pro|K[46]000[ _](?:Plus|Lite)|Y4800|K10000|K[4-8]000| WP[5-7])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(C15|C16|K10000|K[46]000|WP[258]|U15)[ _]?Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "OUKITEL K([37])(?:[);/ ]|$)",
                "model": "K$1"
            },
            {
                "regex": "(K10000|U16|U7)[ _]Max(?:[);/ ]|$)",
                "model": "$1 Max"
            },
            {
                "regex": "(U20|K[46]000|U7|U11|OK6000)[_ ]?Plus(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "(K4000)[_ ]Lite(?:[);/ ]|$)",
                "model": "$1 Lite"
            },
            {
                "regex": "(Y4800|K10000|K[4-8]000|WP2|WP5000|[CU]2|U10)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": " (WP[5-7])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "OUKITEL; ([^;]+);",
                "model": "$1"
            }
        ]
    },
    "OKWU": {
        "regex": "OKWU SIGMA(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Sigma"
    },
    "Ouki": {
        "regex": "OUKI|OK[AU][0-9]+[a-z]* Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "OUKI[ _-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "([^;/)]+) Build/OUKI",
                "model": "$1"
            },
            {
                "regex": "OUKI[ _-]?([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            },
            {
                "regex": "(OK[AU][0-9]+[a-z]*) Build",
                "model": "$1"
            }
        ]
    },
    "Overmax": {
        "regex": "OV-[a-z]+(?:[^;(/]*)[();/ ]|Qualcore 10(?:10|27)|Vertis 5021 Aim|OV1027[34]G",
        "device": "tablet",
        "models": [
            {
                "regex": "OV-V10",
                "model": "Vertis Yard",
                "device": "smartphone"
            },
            {
                "regex": "Vertis 5021 Aim",
                "model": "Vertis 5021 Aim",
                "device": "smartphone"
            },
            {
                "regex": "OV-Vertis[ _-]([^;/]+) Build",
                "model": "Vertis $1",
                "device": "smartphone"
            },
            {
                "regex": "Qualcore 1010",
                "model": "Qualcore 1010",
                "device": "tablet"
            },
            {
                "regex": "Qualcore 1027 4G",
                "model": "Qualcore 1027 4G",
                "device": "tablet"
            },
            {
                "regex": "OV1027([34])G",
                "model": "Qualcore 1027 $1G",
                "device": "tablet"
            },
            {
                "regex": "(OV-[a-z]+(?:[^;(/]*))(?<!Build)[();/ ]",
                "model": "$1"
            }
        ]
    },
    "Oysters": {
        "regex": "Oysters|T84ERI[ _]3G|T72HM(s_)?3G|T102MS_3G|T102ER3G|(T74HMi|T84Bi)[_ ]4G|T74MR4G|T84Ni[_ ][34]G|Pacific[ ]?800i|T104B_[34]G|IndianV|T72HA_3G|T74D_3G|T74N_3G|T74SC_3G|T74Mai_3G|T104MBi_3G|T104SCi_3G|T104ER4G|Atlantic4G|AntarcticE|T7V 3G",
        "device": "tablet",
        "models": [
            {
                "regex": "Pacific[ ]?800i",
                "device": "smartphone",
                "model": "Pacific 800i"
            },
            {
                "regex": "Atlantic4G",
                "device": "smartphone",
                "model": "Atlantic 4G"
            },
            {
                "regex": "AntarcticE",
                "device": "smartphone",
                "model": "Antarctic E"
            },
            {
                "regex": "IndianV",
                "device": "smartphone",
                "model": "Indian V"
            },
            {
                "regex": "Oysters[_ ]PacificV",
                "device": "smartphone",
                "model": "Pacific V"
            },
            {
                "regex": "Oysters ((?:Arctic|Indian|Atlantic|Pacific)[^/;]+) Build",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "(T84ERI[ _]3G|T72HM(s_)?3G|(?:(T74HMi|T84Bi)[_ ]4G)|T84Ni[_ ][34]G)",
                "model": "$1"
            },
            {
                "regex": "(T74MR|T102MS|T104B|T74SC|T74[DN]|T72HA|T102ER|T104SCi|T104MBi|T104ER|T7V)[ _]?([34]G)",
                "model": "$1 $2"
            },
            {
                "regex": "T74Mai_3G",
                "model": "T74MAi 3G"
            },
            {
                "regex": "Oysters ([^/;]+)( Build|\\))",
                "model": "$1"
            }
        ]
    },
    "öwn": {
        "regex": "OWN[ _]|(?:S4035[ _][34]G|Smart8|SMART PLUS LTE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "FUN ([67])",
                "model": "Fun $1"
            },
            {
                "regex": "FUN 5\\(4G\\)",
                "model": "Fun 5 4G"
            },
            {
                "regex": "(?:OWN[ _])?(S3000D|S3010|S3020D|S4010|S4025|S4035[ _][34]G)",
                "model": "$1"
            },
            {
                "regex": "One Plus",
                "model": "One Plus"
            },
            {
                "regex": "One",
                "model": "One"
            },
            {
                "regex": "SMART 9",
                "model": "Smart 9"
            },
            {
                "regex": "Smart8(?:[);/ ]|$)",
                "model": "Smart 8"
            },
            {
                "regex": "SMART PLUS LTE(?:[);/ ]|$)",
                "model": "Smart Plus LTE"
            }
        ]
    },
    "Panacom": {
        "regex": "T-i708D",
        "device": "smartphone",
        "models": [
            {
                "regex": "T-i708D",
                "device": "tablet",
                "model": "T-i708D"
            }
        ]
    },
    "Panasonic": {
        "regex": "Panasonic|PANATV[0-9]+|Viera/|(?:P902i|P-0[28]D|FZ-B2D|FZ-[NX]1|DMC-CM1|P-01J|P-03E)(?:[);/ ]|$)|Eluga[ _]|P55 Novo 4G",
        "device": "smartphone",
        "models": [
            {
                "regex": "P-01J(?:[);/ ]|$)",
                "model": "P-smart Keitai"
            },
            {
                "regex": "P-03E(?:[);/ ]|$)",
                "model": "Eluga P"
            },
            {
                "regex": "Eluga[ _-]([^;/]+) Build",
                "model": "Eluga $1"
            },
            {
                "regex": "Eluga[ _-]([^);/]+)[;/)]",
                "model": "Eluga $1"
            },
            {
                "regex": "(DMC-CM1)",
                "model": "Lumix $1",
                "device": "camera"
            },
            {
                "regex": "P-02D(?:[);/ ]|$)",
                "model": "Lumix Phone P-02D"
            },
            {
                "regex": "(FZ-[XN]1)(?:[);/ ]|$)",
                "model": "Toughpad $1"
            },
            {
                "regex": "FZ-B2D(?:[);/ ]|$)",
                "model": "Toughpad FZ-B2D",
                "device": "tablet"
            },
            {
                "regex": "P55 Novo 4G",
                "model": "P55 Novo 4G"
            },
            {
                "regex": "P902i(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "P902i"
            },
            {
                "regex": "Panasonic MIL DLNA",
                "device": "tv",
                "model": "Viera Cast"
            },
            {
                "regex": "PANATV[0-9]+|Viera/",
                "device": "tv",
                "model": "Smart TV"
            },
            {
                "regex": "(43D1200|(?:32|43)D1270|32D1280)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "Panasonic[ _\\-]?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/2.0 (P[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "P-08D(?:[);/ ]|$)",
                "model": "Eluga Live 10.1\"",
                "device": "tablet"
            }
        ]
    },
    "PCBOX": {
        "regex": "Art-PCB-V116|Bee-PCB-V216|Clap-PCB-I316|PCB-T(103|715)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Art-PCB-V116",
                "model": "Art"
            },
            {
                "regex": "Bee-PCB-V216",
                "model": "Bee"
            },
            {
                "regex": "Clap-PCB-I316",
                "model": "Clap"
            },
            {
                "regex": "PCB-T103",
                "device": "tablet",
                "model": "Curi Lite"
            },
            {
                "regex": "PCB-T715",
                "device": "tablet",
                "model": "T715"
            }
        ]
    },
    "PCD": {
        "regex": "PH4001",
        "device": "smartphone",
        "models": [
            {
                "regex": "PH4001",
                "model": "PH4001"
            }
        ]
    },
    "PCD Argentina": {
        "regex": "PCD[ ]?50[689]",
        "device": "smartphone",
        "models": [
            {
                "regex": "PCD[ ]?(50[689])",
                "model": "$1"
            }
        ]
    },
    "ArmPhone": {
        "regex": "(TSD Octa A0520P|TSD Quadra A050[59]P)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Pentagram": {
        "regex": "Pentagram|Quadra|Monster X5",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:PENTAGRAM[_ ])?EON[_ ]PRIX",
                "model": "Eon Prix"
            },
            {
                "regex": "Quadra 7(?: UltraSlim)?",
                "model": "Quadra 7 UltraSlim"
            },
            {
                "regex": "Monster X5?",
                "model": "Monster X5",
                "device": "smartphone"
            },
            {
                "regex": "Quadra ?([^);/]*) Build",
                "model": "Quadra $1"
            },
            {
                "regex": "Pentagram ?TAB ?([^);/]*) Build",
                "model": "Tab $1"
            },
            {
                "regex": "Pentagram ?([^);/]*) Build",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "TCL": {
        "regex": "TCL,|TCL[_ -][a-z0-9]+|(?:TCL[_ -][^;/]+ Build)|(?:TCLGalaG60(?:\\(9108A\\))?|A502DL|T78[02]H|5199I|7040N|5133A|5159[AJ]|5152D|T770H|T671H|T790Y|T766H_EEA|T766A|T799[BH]|Percee TV)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TCLGalaG60(?:\\(9108A\\))?(?:[);/ ]|$)",
                "model": "Gala G60"
            },
            {
                "regex": "5199I(?:[);/ ]|$)",
                "model": "C9"
            },
            {
                "regex": "5152D(?:[);/ ]|$)",
                "model": "C5"
            },
            {
                "regex": "5133A(?:[);/ ]|$)",
                "model": "L5"
            },
            {
                "regex": "T780H(?:[);/ ]|$)",
                "model": "Plex"
            },
            {
                "regex": "T782H(?:[);/ ]|$)",
                "model": "10 Plus"
            },
            {
                "regex": "T790Y(?:[);/ ]|$)",
                "model": "10 5G"
            },
            {
                "regex": "TCL[_ -]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "TCL[_ -]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(7040N)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "A502DL(?:[);/ ]|$)",
                "model": "LX"
            },
            {
                "regex": "5159[AJ](?:[);/ ]|$)",
                "model": "L9"
            },
            {
                "regex": "T770H(?:[);/ ]|$)",
                "model": "10L"
            },
            {
                "regex": "T766[HA](?:_EEA)?(?:[);/ ]|$)",
                "model": "10 SE"
            },
            {
                "regex": "T671H(?:_EEA)?(?:[);/ ]|$)",
                "model": "20 SE"
            },
            {
                "regex": "T799[BH](?:[);/ ]|$)",
                "model": "10 Pro"
            },
            {
                "regex": "(Percee TV)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "((?:43|55)S62FS|(?:43|50)P65US|U(?:43|60)P60|65P4USM|(?:40|49)S62|L32S6|55P610|50P8S|55S62|(?:43|50)P6US|55DP60)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "JVC": {
        "regex": "JVC[;,]|JVC Shell",
        "device": "tv",
        "models": [
            {
                "regex": "JVC Shell [0-9A-Z]+",
                "model": ""
            },
            {
                "regex": "JVC[;,](32D1290)",
                "model": "$1"
            }
        ]
    },
    "phoneOne": {
        "regex": "phoneOne[ \\-]?([a-z0-9]+)",
        "device": "smartphone",
        "model": "$1"
    },
    "Primepad": {
        "regex": "PD\\-(3127NC|3127) Build",
        "device": "tablet",
        "models": [
            {
                "regex": "PD\\-3127NC Build",
                "model": "PD-3127NC"
            },
            {
                "regex": "PD\\-3127 Build",
                "model": "PD-3127"
            }
        ]
    },
    "Pioneer": {
        "regex": "Pioneer|.*; R1 Build|dvr700pi|XDP-300R",
        "device": "smartphone",
        "models": [
            {
                "regex": ".*; R1 Build",
                "model": "R1",
                "device": "tablet"
            },
            {
                "regex": "Pioneer[ _-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Pioneer[ _-]?([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            },
            {
                "regex": "dvr700pi",
                "model": "DVR700PI 7.0\"",
                "device": "tablet"
            },
            {
                "regex": "(XDP-300R)",
                "device": "portable media player",
                "model": "$1"
            }
        ]
    },
    "Pixus": {
        "regex": "Pixus|(hiPower|Ride[_ ][34]G|Play[ _]Three[ _]v(?:[24].0|3.1))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Ride[_ ]([34])G",
                "model": "Ride $1G"
            },
            {
                "regex": "Play[ _]Three[ _]v([24].0|3.1)",
                "model": "Play Three v$1"
            },
            {
                "regex": "Play Two",
                "model": "Play Two"
            },
            {
                "regex": "Play Five",
                "model": "Play Five"
            },
            {
                "regex": "hiPower",
                "model": "hiPower"
            },
            {
                "regex": "Pixus[ _]Sprint",
                "model": "Sprint"
            },
            {
                "regex": "Touch 7 3G",
                "model": "Touch 7 3G"
            },
            {
                "regex": "Pixus[ _]hiMax",
                "model": "HiMax 9.6\""
            },
            {
                "regex": "Pixus[ _]Blast",
                "model": "Blast 10.1\""
            },
            {
                "regex": "Pixus[ _]Joker",
                "model": "Joker 10.1\""
            },
            {
                "regex": "Pixus Blaze 10.1 3G",
                "model": "Blaze 10.1\" 3G"
            },
            {
                "regex": "Raze",
                "model": "Raze",
                "device": "smartphone"
            },
            {
                "regex": "Pixus_Jet",
                "model": "Jet",
                "device": "smartphone"
            },
            {
                "regex": "pixus hit 2",
                "model": "Hit 2",
                "device": "smartphone"
            }
        ]
    },
    "PULID": {
        "regex": "PULID[ _]|F1[01357]\\+? Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "F(1[01357]\\+?) Build",
                "model": "F$1"
            },
            {
                "regex": "PULID[ _]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "PULID[ _]([a-z0-9_]+)\\)",
                "model": "$1"
            }
        ]
    },
    "Point of View": {
        "regex": "POV_TV|POV_TAB|MOB-5045",
        "device": "tablet",
        "models": [
            {
                "regex": "POV_TV-HDMI-KB-01",
                "model": "HDMI Smart TV Dongle",
                "device": "tv"
            },
            {
                "regex": "POV_TV-HDMI-200BT",
                "model": "Mini PC HDMI Dongle",
                "device": "tv"
            },
            {
                "regex": "MOB-5045",
                "model": "Mobii Phone 5045",
                "device": "smartphone"
            },
            {
                "regex": "POV_TAB-P506",
                "model": "ONYX 506 Navi"
            },
            {
                "regex": "POV_TAB[_-]NAVI7[_-]3G[_-]M",
                "model": "ONYX 507 Navi"
            },
            {
                "regex": "POV_TAB-P527S",
                "model": "ONYX 527S"
            },
            {
                "regex": "POV_TAB-P547",
                "model": "ONYX 547 Navi"
            },
            {
                "regex": "POV_TAB-PROTAB26",
                "model": "ProTab 26 XXL IPS"
            },
            {
                "regex": "POV_TAB-PROTAB25XXL8?",
                "model": "ProTab 25XXL"
            },
            {
                "regex": "POV_TAB-PL1015",
                "model": "Mobii 1015"
            },
            {
                "regex": "POV_TAB-PROTAB([a-z0-9]+)",
                "model": "ProTab $1"
            },
            {
                "regex": "POV_TAB-P?([a-z0-9]+)",
                "model": "Mobii $1"
            }
        ]
    },
    "Pomp": {
        "regex": "POMP[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "POMP[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "POMP[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "PPTV": {
        "regex": "(KING 7S?)",
        "device": "smartphone",
        "model": "$1"
    },
    "ProScan": {
        "regex": "PLT([^;/]+) Build|PLT(?:777[45]|9774|1074)G(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "PLT([^;/]+) Build",
                "model": "PLT$1"
            },
            {
                "regex": "PLT(777[45]|9774|1074)G",
                "model": "PLT$1G"
            }
        ]
    },
    "RCA Tablets": {
        "regex": "RCT([^;/]+) Build|RCA RLTP4028|RCT6513W87|RCT6973W43(?:MD)?|RCT6703W12|RCT(?:6A06P22|6603W47M7|6303W87(?:DK|M)|6773W22B|6203W46L|6873W42M|6K03W13)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RCA RLTP4028",
                "model": "RLTP4028"
            },
            {
                "regex": "RCT6513W87",
                "device": "tablet",
                "model": "Galileo Pro 11.5\""
            },
            {
                "regex": "RCT6873W42M",
                "device": "tablet",
                "model": "Voyager 7.0\""
            },
            {
                "regex": "RCT6973W43(?:MD)?",
                "device": "tablet",
                "model": "Voyager III 7.0\""
            },
            {
                "regex": "RCT6773W22B",
                "device": "tablet",
                "model": "Voyager II 7.0\""
            },
            {
                "regex": "RCT6703W12",
                "device": "tablet",
                "model": "Atlas 10.0\""
            },
            {
                "regex": "RCT6203W46L",
                "device": "tablet",
                "model": "Pro 10 Edition II"
            },
            {
                "regex": "RCT6A06P22",
                "device": "tablet",
                "model": "Endeavor 10.0\" HD"
            },
            {
                "regex": "RCT(?:6303W87(?:DK|M)|6K03W13)",
                "device": "tablet",
                "model": "Viking Pro 10.0\""
            },
            {
                "regex": "RCT6603W47M7",
                "device": "tablet",
                "model": "Viking II 10.0\""
            },
            {
                "regex": "RCT([^;/)]+)(?: Build|[;)])",
                "device": "tablet",
                "model": "RCT$1"
            }
        ]
    },
    "Readboy": {
        "regex": "Readboy[ _-]",
        "device": "tablet",
        "models": [
            {
                "regex": "Readboy[ _-]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Roku": {
        "regex": "Roku/DVP",
        "device": "tv",
        "model": "Digital Video Player"
    },
    "Rokit": {
        "regex": "IO Pro",
        "device": "smartphone",
        "models": [
            {
                "regex": "IO Pro",
                "model": "IO Pro"
            }
        ]
    },
    "Rombica": {
        "regex": "(Rombica|SSQ-A0500|Smart Box v[0-9]+)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "SSQ-A0500(?:[);/ ]|$)",
                "model": "Smart Stick 4K"
            },
            {
                "regex": "(Infinity K8|Smart Box (?:v00[345789]|Quad|Ultra HD v002|4K V001))(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Rover": {
        "regex": "Rover ([0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "RoverPad": {
        "regex": "(?:Rover[ ]?Pad|RoverPhone|Sky 7.85 3G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "RoverPhone(?:[);/ ]|$)",
                "model": "",
                "device": "smartphone"
            },
            {
                "regex": "(?:Rover[ ]?Pad)?sky 7.85(?: 3G)?(?:[);/ ]|$)",
                "model": "Sky 7.85\" 3G"
            },
            {
                "regex": "RoverPad (10.4|Air S70|9.7 3G|Sky 9.7|3W A73|3W7|3WT70|3W9.4)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Roadrover": {
        "regex": "Roadrover ChangAn S",
        "device": "tablet",
        "model": "ChangAn S"
    },
    "RT Project": {
        "regex": "Shock 5",
        "device": "smartphone",
        "models": [
            {
                "regex": "Shock 5",
                "model": "Shock 5"
            }
        ]
    },
    "S-TELL": {
        "regex": "S-TELL",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:S-TELL[ _])?M4(61|77|80)",
                "model": "M4$1"
            }
        ]
    },
    "Safaricom": {
        "regex": "NEON_RAY",
        "device": "smartphone",
        "models": [
            {
                "regex": "NEON_RAY",
                "model": "Neon Ray"
            }
        ]
    },
    "Santin": {
        "regex": "(?:SANTIN|BiTBiZ_V58|ACTOMA ACE|DREAMPLUS03A|Candy U7 Pro)[);/_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "BiTBiZ_V58(?:[);/ ]|$)",
                "model": "BiTBiZ V58"
            },
            {
                "regex": "Candy U7 Pro(?:[);/ ]|$)",
                "model": "Candy U7 Pro"
            },
            {
                "regex": "DREAMPLUS03A(?:[);/ ]|$)",
                "model": "Dream Plus 03A"
            },
            {
                "regex": "GreenOrange(?:[);/ ]|$)",
                "model": "Green Orange"
            },
            {
                "regex": "halove(?:[);/ ]|$)",
                "model": "Halove"
            },
            {
                "regex": "ACTOMA ACE(?:[);/ ]|$)",
                "model": "Actoma Ace"
            },
            {
                "regex": "monica(?:[);/ ]|$)",
                "model": "Monica"
            },
            {
                "regex": "POWER(?:[);/ ]|$)",
                "model": "Power"
            },
            {
                "regex": "GALAZ(?:[);/ ]|$)",
                "model": "Galaz"
            },
            {
                "regex": "NEWDUN(?:[);/ ]|$)",
                "model": "Newdun"
            },
            {
                "regex": "SANTIN[ _][#]?(Dante|Candy U7|Armor|YSL-Y7|ANT.W|N[13]|JS|S6|V9|Life Shine)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Siemens": {
        "regex": "SIEMENS|SIE-|portalmmm/2\\.0 SI|(?:S55|SL45i)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:SIE-)?(S[56]5|S40|C45|ME45|SLIK)(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "$1"
            },
            {
                "regex": "SIEMENS[ \\-]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SIE(?:MENS )?[\\-]?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(?:SIE-)?(SL45i)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/2.0 (SI[a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Soundmax": {
        "regex": "((?:SM-LED32M(?:11|04)S)(?:_-Ver01)?|SM-LED40M04S)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Samsung": {
        "regex": "SAMSUNG(?! ?Browser)|Maple (?!III)|SC-(?:01[FGHKLM]|02[CGHJKLM]|03[JKL]|04[EJL]|05[GL]|(?:4[12]|5[1234])A)|N[57]100|N5110|N9100|S(?:CH|GH|PH|EC|AM|HV|HW|M)-|SMART-TV|GT-|(?<!GOG|GOG )Galaxy|(?:portalmmm|o2imode)/2\\.0 [SZ]|sam[rua]|vollo Vi86(?:[);/ ]|$)|(?:OTV-)?SMT-E5015|ISW11SC|SCV4[0-9]|SCV3[1-9]|40[34]SC|SCL2[234]|SCG0[1-7]|SCT21",
        "device": "smartphone",
        "models": [
            {
                "regex": "GT-B9150",
                "device": "tv",
                "model": "Home Sync"
            },
            {
                "regex": "(?:OTV-)?SMT-E5015",
                "device": "tv",
                "model": "SMT-E5015"
            },
            {
                "regex": "Maple ",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-)?N5100",
                "device": "tablet",
                "model": "Galaxy Note 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T677(?:[ATV]|N[KL])?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy View 18.4\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T670(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy View 18.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-)?N5110",
                "device": "tablet",
                "model": "Galaxy Note 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-N5120",
                "device": "tablet",
                "model": "Galaxy Note 8.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT|SM)-N8000",
                "device": "tablet",
                "model": "Galaxy Note 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?GT-N8010",
                "device": "tablet",
                "model": "Galaxy Note 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-N8020",
                "device": "tablet",
                "model": "Galaxy Note 10.1\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P1000M?|SCH-I800",
                "device": "tablet",
                "model": "Galaxy Tab"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P3100B?",
                "device": "tablet",
                "model": "Galaxy Tab 2 7\""
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P311[03]",
                "device": "tablet",
                "model": "Galaxy Tab 2 7\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P5100|SCH-I915",
                "device": "tablet",
                "model": "Galaxy Tab 2 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P511[03]",
                "device": "tablet",
                "model": "Galaxy Tab 2 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T217T",
                "device": "tablet",
                "model": "Galaxy Tab 3 7.0\" 4G"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P5200",
                "device": "tablet",
                "model": "Galaxy Tab 3 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P5210",
                "device": "tablet",
                "model": "Galaxy Tab 3 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P5220",
                "device": "tablet",
                "model": "Galaxy Tab 3 10.1\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P6200",
                "device": "tablet",
                "model": "Galaxy Tab 7\" Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P6201",
                "device": "tablet",
                "model": "Galaxy Tab 7\" Plus N"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P6810",
                "device": "tablet",
                "model": "Galaxy Tab 7.7\""
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P7100",
                "device": "tablet",
                "model": "Galaxy Tab 10.1v"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P75[01]0",
                "device": "tablet",
                "model": "Galaxy Tab 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P600",
                "device": "tablet",
                "model": "Galaxy Note 10.1\" 2014 Edition WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P60[12]",
                "device": "tablet",
                "model": "Galaxy Note 10.1\" 2014 Edition"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P605|P607T)",
                "device": "tablet",
                "model": "Galaxy Note 10.1\" 2014 Edition LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P900",
                "device": "tablet",
                "model": "Galaxy NotePRO 12.2\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P901",
                "device": "tablet",
                "model": "Galaxy NotePRO 12.2\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P905",
                "device": "tablet",
                "model": "Galaxy NotePRO 12.2\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P587|P588C)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A 10.1\" with S Pen (2016) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P583(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A 10.1\" with S Pen (2016) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P205(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" with S Pen (2019) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P200(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" with S Pen (2019) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T307U(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A 8.4\" (2020) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T505[CN]?|T507)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A7 10.4\" (2020) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T500(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A7 10.4\" (2020) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T11[03]",
                "device": "tablet",
                "model": "Galaxy Tab 3 Lite 7.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T830[X]?|T837R4)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S4 10.5\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T837P(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S4 10.5\" with S Pen"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T835[CN]?|T837[VTA]?)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S4 10.5\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T725[CN]?|T720X|T727(?:R4|[AUV])?)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S5e 10.5\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T720(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S5e 10.5\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T865N?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 10.5\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T867(?:R4|[VU])?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 10.5\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P615[CN]?|P617)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 Lite 10.4\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P610X?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 Lite 10.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T860(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 10.5\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T866N(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 10.5\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T111[M]?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab 3 Lite 7.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T116(?:BU|NU|NY)?",
                "device": "tablet",
                "model": "Galaxy Tab 3 V"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T2105|T212)",
                "device": "tablet",
                "model": "Galaxy Tab 3 7.0\" Kids"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T210R?",
                "device": "tablet",
                "model": "Galaxy Tab 3 7.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T21(?:[15]|7[AS])",
                "device": "tablet",
                "model": "Galaxy Tab 3 7.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T230(?:NU)?",
                "device": "tablet",
                "model": "Galaxy Tab 4 7.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T23[15]|403SC",
                "device": "tablet",
                "model": "Galaxy Tab 4 7.0\" 3G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T239|T237[PV])",
                "device": "tablet",
                "model": "Galaxy Tab 4 7.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T232(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab 4 7.0\" WiFi + 3G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T310",
                "device": "tablet",
                "model": "Galaxy Tab 3 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T311",
                "device": "tablet",
                "model": "Galaxy Tab 3 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T315",
                "device": "tablet",
                "model": "Galaxy Tab 3 8.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T330",
                "device": "tablet",
                "model": "Galaxy Tab 4 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T33[215]|T337[AVT])",
                "device": "tablet",
                "model": "Galaxy Tab 4 8.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T520",
                "device": "tablet",
                "model": "Galaxy TabPRO 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T53[15]|T537[AV])",
                "device": "tablet",
                "model": "Galaxy Tab 4 10.1\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T536(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab 4 10.1\" Advanced"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T532(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab 4 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T320",
                "device": "tablet",
                "model": "Galaxy TabPRO 8.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T325",
                "device": "tablet",
                "model": "Galaxy TabPRO 8.4\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T525",
                "device": "tablet",
                "model": "Galaxy TabPRO 10.1\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T530(?:NU)?|T533)",
                "device": "tablet",
                "model": "Galaxy Tab 4 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T700",
                "device": "tablet",
                "model": "Galaxy Tab S 8.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T705|T707[AV])",
                "device": "tablet",
                "model": "Galaxy Tab S 8.4\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T800",
                "device": "tablet",
                "model": "Galaxy Tab S 10.5\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-(?:T805|T807[PV]?)|SCT21)",
                "device": "tablet",
                "model": "Galaxy Tab S 10.5\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T813|T810)",
                "device": "tablet",
                "model": "Galaxy Tab S2 9.7\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T719[CY]?|T715(?:N0|[CY])?)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S2 8.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T71[03]|T710X)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S2 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T815|T817[ATW]?|T818[ATVW]?|T819[Y]?)",
                "device": "tablet",
                "model": "Galaxy Tab S2 9.7\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T820",
                "device": "tablet",
                "model": "Galaxy Tab S3 9.7\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T82[57]",
                "device": "tablet",
                "model": "Galaxy Tab S3 9.7\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T975N?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7+ 12.4\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T970(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7+ 12.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T976[BN]|T978U)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7+ 12.4\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T870(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7 11.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T875N?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7 11.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T878U(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7 11.0\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T900",
                "device": "tablet",
                "model": "Galaxy TabPRO 12.2\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T280",
                "device": "tablet",
                "model": "Galaxy Tab A 7.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T285",
                "device": "tablet",
                "model": "Galaxy Tab A 7.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T3[58]0",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P350|T3[58]5|T357[TW])",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T387(?:AA|R4|VK|[TVW])",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" LTE (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T295",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" LTE (2019)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T290",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" WiFi (2019)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P355([MY])?|T550)",
                "device": "tablet",
                "model": "Galaxy Tab A 9.7\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P550|P555(M)?|T555)",
                "device": "tablet",
                "model": "Galaxy Tab A 9.7\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T58[05]|P58[05])",
                "device": "tablet",
                "model": "Galaxy Tab A 10.1\" WiFi (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T587[P]?",
                "device": "tablet",
                "model": "Galaxy Tab A 10.1\" LTE (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T59[057]",
                "device": "tablet",
                "model": "Galaxy Tab A 10.5\" LTE (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T51(?:7P|[057])",
                "device": "tablet",
                "model": "Galaxy Tab A 10.1\" (2019)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T37[57]|T378[KLSV])",
                "device": "tablet",
                "model": "Galaxy Tab E 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T56[02]",
                "device": "tablet",
                "model": "Galaxy Tab E 9.6\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T561",
                "device": "tablet",
                "model": "Galaxy Tab E 9.6\" 3G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T567V",
                "device": "tablet",
                "model": "Galaxy Tab E 9.6\" 4G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T365(?:F0|[MY])?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T360(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T395[CN]?|T397U)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 2 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T390(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 2 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T575N?|T577U?)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 3 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T570(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 3 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T545|T547U?)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active Pro 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T540(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active Pro 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P902|P907A)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Note Pro 12.2\""
            },
            {
                "regex": "(?:SAMSUNG[- ])?SM-T2519",
                "model": "Galaxy Tab Q",
                "device": "tablet"
            },
            {
                "regex": "(?:SAMSUNG )?SM-R820",
                "device": "wearable",
                "model": "Galaxy Watch Active 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G850(?:8S|[AFKLMSWXY])",
                "model": "Galaxy Alpha"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-B5330",
                "model": "Galaxy Chat"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A605K",
                "model": "Galaxy Jean"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A202K",
                "model": "Galaxy Jean 2"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-B5510",
                "model": "Galaxy Y Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-B5512",
                "model": "Galaxy Y Pro Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-B7510",
                "model": "Galaxy Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I5700",
                "model": "Galaxy Spica"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I5801",
                "model": "Galaxy Apollo"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I5800",
                "model": "Galaxy 3"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8000",
                "model": "Omnia II"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-I8150|SM-T255S)",
                "model": "Galaxy W"
            },
            {
                "regex": "SC-01H(?:[);/ ]|$)",
                "model": "Galaxy Active Neo"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5830",
                "model": "Galaxy Ace"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G357(?:FZ|M)|G310HN)",
                "model": "Galaxy Ace Style"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8160",
                "model": "Galaxy Ace 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G313(?:HY|M[LUY]|[FM])",
                "model": "Galaxy Ace 4"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G316M",
                "model": "Galaxy Ace 4 Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G313[HU]",
                "model": "Galaxy Ace 4 Lite"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G316U|G318(?:H|ML))(?:[);/ ]|$)",
                "model": "Galaxy Ace 4 Neo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G9100(?:[);/ ]|$)",
                "model": "Galaxy S II"
            },
            {
                "regex": "(?:SAMSUNG-)?SHV-E120S(?:[);/ ]|$)",
                "model": "Galaxy S II HD LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8190",
                "model": "Galaxy S III mini"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8200",
                "model": "Galaxy S III mini Value Edition"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I826[02]",
                "model": "Galaxy Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G386W",
                "model": "Galaxy Core LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G3589W",
                "model": "Galaxy Core Lite LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8320",
                "model": "H1"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I85[23]0",
                "model": "Galaxy Beam"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G3858",
                "model": "Galaxy Beam 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G600S",
                "model": "Galaxy Wide"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I855[028]",
                "model": "Galaxy Win"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G381[28]",
                "model": "Galaxy Win Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8580",
                "model": "Galaxy Core Advance"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8730",
                "model": "Galaxy Express"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:E500(?:HQ|YZ|[0FHM])|S978L)",
                "model": "Galaxy E5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E700[09FHM]",
                "model": "Galaxy E7"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I90(?:00|08|18|88)",
                "model": "Galaxy S"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9001",
                "model": "Galaxy S Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9003",
                "model": "Galaxy SL"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9010",
                "model": "Galaxy S Giorgio Armani"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9070",
                "model": "Galaxy S Advance"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I910[08]",
                "model": "Galaxy S II"
            },
            {
                "regex": "(?:SAMSUNG-)?ISW11SC",
                "model": "Galaxy S II WiMAX"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9103",
                "model": "Galaxy R"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9105",
                "model": "Galaxy S II Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G730(?:W8|[AV])",
                "model": "Galaxy S3 mini"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-I919[025]|SCH-I435)",
                "model": "Galaxy S4 mini"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9515",
                "model": "Galaxy S4 Value Edition"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9295",
                "model": "Galaxy S4 ACTIVE"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-I9300|SCH-(?:I535|I939|L710))",
                "model": "Galaxy S III"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-I9305|SCH-R530)",
                "model": "Galaxy S III LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S975L|GT-I950[025]|SC-04E|SCH-(?:I545|I959|R970)|SGH-M919N?|Galaxy-S4)",
                "model": "Galaxy S4"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9506",
                "model": "Galaxy S4 with LTE+"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5280",
                "model": "Galaxy STAR"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5301",
                "model": "Galaxy POCKET Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5310",
                "model": "Galaxy POCKET Neo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G110[BHM]",
                "model": "Galaxy POCKET 2"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5360",
                "model": "Galaxy Y Hello Kitty"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S6310",
                "model": "Galaxy Young"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S6312",
                "model": "Galaxy Young DUOS"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G130(?:BT|HN|[EHMU])",
                "model": "Galaxy Young 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G130BU",
                "model": "Galaxy Young 2 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S6790",
                "model": "Galaxy FAME Lite with NFC"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S6810",
                "model": "Galaxy FAME"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S6812",
                "model": "Galaxy FAME Duos"
            },
            {
                "regex": "SC-04J(?:[);/ ]|$)",
                "model": "Galaxy Feel"
            },
            {
                "regex": "SC-02L(?:[);/ ]|$)",
                "model": "Galaxy Feel 2"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7275",
                "model": "Galaxy ACE 3"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7500",
                "model": "Galaxy ACE Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-S7560|SCH-I699)",
                "model": "Galaxy Trend"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7390",
                "model": "Galaxy Trend Lite"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7580",
                "model": "Galaxy Trend Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?SCH-I739",
                "model": "Galaxy Trend 2"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-S7562|SCH-I919)",
                "model": "Galaxy S DUOS"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7582",
                "model": "Galaxy S DUOS 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G31[36]HU|G313HZ)",
                "model": "Galaxy S DUOS 3"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7710",
                "model": "Galaxy Xcover 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G388F",
                "model": "Galaxy Xcover 3"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G389F",
                "model": "Galaxy Xcover 3 VE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G390[FWY]",
                "model": "Galaxy Xcover 4"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G398FN",
                "model": "Galaxy Xcover 4s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G715(?:FN|U1|[AUW])",
                "model": "Galaxy Xcover Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G889(?:YB|[AFG])",
                "model": "Galaxy Xcover FieldPro"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S8500",
                "model": "Wave"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S8530",
                "model": "Wave II"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S8600",
                "model": "Wave 3"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5380",
                "model": "Wave Y"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7250",
                "model": "Wave M"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5250",
                "model": "Wave 525"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5330",
                "model": "Wave 533"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5780",
                "model": "Wave 578"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7230",
                "model": "Wave 723"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:C101|C105([AL])?)",
                "model": "Galaxy S4 zoom"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:C111(M)?|C115)",
                "model": "Galaxy K zoom"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G318[HM]Z",
                "model": "Galaxy V Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G355(?:6D|[89HM])",
                "model": "Galaxy Core 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G350",
                "model": "Galaxy Core Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G360[FH]?|S820L)",
                "model": "Galaxy Core Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G361[FH]?",
                "model": "Galaxy Core Prime Value Edition"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G386F|G3518(?:_TD)?|G3586V)",
                "model": "Galaxy Core LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G3568V",
                "model": "Galaxy Core Mini 4G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G5108Q?",
                "model": "Galaxy Core Max"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G3815",
                "model": "Galaxy EXPRESS II"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G800",
                "model": "Galaxy S5 mini"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G9009D",
                "model": "Galaxy S5 Dual-SIM"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G900|G906[KLS]|S902L|S903VL)|Galaxy-S5|SCL23",
                "model": "Galaxy S5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G901F",
                "model": "Galaxy S5 LTE+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G870[AFW]|SC-02G",
                "model": "Galaxy S5 Active"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G903[FMW]",
                "model": "Galaxy S5 Neo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G860P",
                "model": "Galaxy S5 K Sport"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-G920(?:F[DQ]|W8|[089AFIKLPRSTVX])?|SM-S906L|SM-S907VL)|SC-05G",
                "model": "Galaxy S6"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G890A",
                "model": "Galaxy S5 Active"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G925[0ADFIKLPRSTVWX]|SCV31|404SC",
                "model": "Galaxy S6 Edge"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G928(?:7C|N0|R4|W8|[07ACFGIKLPSTVX])",
                "model": "Galaxy S6 Edge+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G930(?:AZ|FD|R[467]|T1|V[CL]|W8|[0AFKLPRSTUVX8])?(?:[);/ ]|$)",
                "model": "Galaxy S7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G935(?:R4|W8|[0AFKLPSTUVX])|SC-02H|SCV33",
                "model": "Galaxy S7 Edge"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G891A",
                "model": "Galaxy S7 Active"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G950[08FNUW]?|SCV36|SC-02J",
                "model": "Galaxy S8"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G8750",
                "model": "Galaxy S8 Lite"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G892[AU]",
                "model": "Galaxy S8 Active"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G955[0AFKLNPRTUVWX]?|SCV35|SC-03J",
                "model": "Galaxy S8+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G960[0FNUWX]?|SCV38|SC-02K",
                "model": "Galaxy S9"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G965[0FNUWX]|SCV39|SC-03K",
                "model": "Galaxy S9+"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-(?:G973|G977[BNPTU])|SCV41|SC-03L)",
                "model": "Galaxy S10"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:S10 Lite|G770(?:U1|F))",
                "model": "Galaxy S10 Lite"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-G975[08FUNWX]|SCV42|SC-04L)",
                "model": "Galaxy S10+"
            },
            {
                "regex": "SC-05L",
                "model": "Galaxy S10+ Olympic Games Edition"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G970(?:U1|[08FUNWX])(?:[);/ ]|$)",
                "model": "Galaxy S10e"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G980F",
                "model": "Galaxy S20"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G981(?:U1|[0BNUVW])|SCG01|SC-51A",
                "model": "Galaxy S20 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G780F",
                "model": "Galaxy S20 FE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G781(?:U1|[0BNUVW])",
                "model": "Galaxy S20 FE 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G988(?:U1|[0BNQUW])|SCG03",
                "model": "Galaxy S20 Ultra 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G985F|SCG02",
                "model": "Galaxy S20+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G986(?:U1|[0BNUW])|SC-52A",
                "model": "Galaxy S20+ 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G991(?:U1|[0BNW])",
                "model": "Galaxy S21 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G998(?:U1|[0BNUW])",
                "model": "Galaxy S21 Ultra 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G996(?:U1|[0BNWU])",
                "model": "Galaxy S21+ 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-F700(?:U1|[0FNUW])|SCV47",
                "model": "Galaxy Z Flip"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-F707(?:U1|[0BNUW])|SCG04",
                "model": "Galaxy Z Flip 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SCH-I200",
                "model": "Galaxy Stellar"
            },
            {
                "regex": "(?:SAMSUNG-)?SCH-I829",
                "model": "Galaxy Style Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SCH-R740|SGH-S730)",
                "model": "Galaxy Discover"
            },
            {
                "regex": "(?:SAMSUNG-)?SCH-S738",
                "model": "Galaxy Centura"
            },
            {
                "regex": "vollo Vi86(?:[);/ ]|$)",
                "model": "Vollo Vi86"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G386(?:T1|T)",
                "model": "Galaxy Avant"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A716S",
                "model": "Galaxy A Quantum"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A015(?:DL|[TU]1|[AFGMUV])|S111DL)",
                "model": "Galaxy A01"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A013[FGM]",
                "model": "Galaxy A01 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A025[FGM]",
                "model": "Galaxy A02s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A022G",
                "model": "Galaxy A02"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A260[FG]",
                "model": "Galaxy A2 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A300(?:FU|YZ|XU|XZ|[09FGHMXY])",
                "model": "Galaxy A3 (2015)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A310(?:N0|[FMXY])",
                "model": "Galaxy A3 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A320(?:FL|[FXY])",
                "model": "Galaxy A3 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A430F",
                "model": "Galaxy A4"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A500(?:YZ|[9LSWY])?(?:[);/ ]|$)",
                "model": "Galaxy A5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A500[0FGHKM]",
                "model": "Galaxy A5 Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A500(?:FU|X)",
                "model": "Galaxy A5 (2015)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A510[08FKLMSXY]",
                "model": "Galaxy A5 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A520[FKLSWX]",
                "model": "Galaxy A5 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A525F",
                "model": "Galaxy A52"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A600(?:AZ|FN|GN|T1|[AFGNPTUX])",
                "model": "Galaxy A6"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A605(?:[FG]N|[08FGX])",
                "model": "Galaxy A6+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G6200",
                "model": "Galaxy A6s (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A606[0Y]",
                "model": "Galaxy A60"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A700(?:YD|[09FHKLSX])",
                "model": "Galaxy A7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A710[08FKLMSXY]",
                "model": "Galaxy A7 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A720[FMSX]",
                "model": "Galaxy A7 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A750(?:GN|[CFGNX])",
                "model": "Galaxy A7 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A71(?:5[FW])?(?:[);/ ]|$)",
                "model": "Galaxy A71"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A725F(?:[);/ ]|$)",
                "model": "Galaxy A72"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A716(?:U1|[0BUV])(?:[);/ ]|$)",
                "model": "Galaxy A71 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A(?:530F|800[0FISXY])|SCV32",
                "model": "Galaxy A8"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G885[FSY]",
                "model": "Galaxy A8 Star"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A810(?:YZ|[FS])",
                "model": "Galaxy A8 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A8s|G887[0F])",
                "model": "Galaxy A8s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A530[MNWX]",
                "model": "Galaxy A8 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A730[FX]",
                "model": "Galaxy A8+ (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A900[0F]",
                "model": "Galaxy A9"
            },
            {
                "regex": "SM-A9\\[7\\]",
                "model": "Galaxy A9 7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A920[0FXN]",
                "model": "Galaxy A9 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G885[08]",
                "model": "Galaxy A9 Star"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A9 Pro|A910[0F]|G887N)",
                "model": "Galaxy A9 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A105[FGMN]",
                "model": "Galaxy A10"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A107[FM]",
                "model": "Galaxy A10s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:S102DL|A102[NUW])",
                "model": "Galaxy A10e"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A115(?:A[PZ]|U1|[AFMUW])",
                "model": "Galaxy A11"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A125[FM]",
                "model": "Galaxy A12"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A205(?:U1|YN|[FGSWU])|S205DL)|SC-02M|SCV46",
                "model": "Galaxy A20"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A215(?:DL|U1|[UW])|SC-42A|SCV49)(?:[);/ ]|$)",
                "model": "Galaxy A21"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A217[FMN](?:[);/ ]|$)",
                "model": "Galaxy A21s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A202[FG]",
                "model": "Galaxy A20e"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A207[0FM]",
                "model": "Galaxy A20s"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A305(?:[FGY]N|GT|[FGN])|SCV43)",
                "model": "Galaxy A30"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A307(?:FN|GN|GT|[FG])",
                "model": "Galaxy A30s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A315[FGN](?:[);/ ]|$)",
                "model": "Galaxy A31"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A325F(?:[);/ ]|$)",
                "model": "Galaxy A32"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A326(?:BR|B)",
                "model": "Galaxy A32 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A405(?:F[NM]|S)",
                "model": "Galaxy A40"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A305[018](?:[);/ ]|$)",
                "model": "Galaxy A40s"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A415F|SC-41A|SCV48)(?:[);/ ]|$)",
                "model": "Galaxy A41"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A426[0BN](?:[);/ ]|$)",
                "model": "Galaxy A42 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A505(?:F[GN]|U1|YN|[FGNUWX])|S506DL|505FN)",
                "model": "Galaxy A50"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A5070(?:[);/ ]|$)",
                "model": "Galaxy A50s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A507FN",
                "model": "Galaxy A50s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A515[FUW]|S515DL)",
                "model": "Galaxy A51"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A516(?:U1|[0BNUV])|SC-54A|SCG07)",
                "model": "Galaxy A51 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A705(?:GM|[MYF]N|[0FUWX])",
                "model": "Galaxy A70"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A707[0F]",
                "model": "Galaxy A70s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A805[0FNX]",
                "model": "Galaxy A80"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A908[BN]",
                "model": "Galaxy A90"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A9080",
                "model": "Galaxy A90 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-F127G(?:[);/ ]|$)",
                "model": "Galaxy F12"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-F415F(?:[);/ ]|$)",
                "model": "Galaxy F41"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9301I",
                "model": "Galaxy S III Neo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S120VL(?:[);/ ]|$)",
                "model": "Galaxy Luna"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J100(?:FN|VPP|MU|[FGHMY])|S777C)",
                "model": "Galaxy J1"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J105[BFHYM]",
                "model": "Galaxy J1 Mini"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J106[BFHM]",
                "model": "Galaxy J1 mini Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J120(?:ZN|[AFGHMPTW])|J05H)",
                "model": "Galaxy J1 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J110[FGHLM]|J111[FM])",
                "model": "Galaxy J1 Ace"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J200[FGHMY]",
                "model": "Galaxy J2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J200BT",
                "model": "Galaxy J2 Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J260AZ",
                "model": "Galaxy J2 Pure"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J260([AFGMY]|T1)|S260DL)",
                "model": "Galaxy J2 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J(?:210F|250[FGMNY])",
                "model": "Galaxy J2 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:S367VL|S357BL)",
                "model": "Galaxy J3 Orbit"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J311(?:[09]|9S)",
                "model": "Galaxy J3 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S320VL(?:[);/ ]|$)",
                "model": "Galaxy J3 Sky"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S327VL(?:[);/ ]|$)",
                "model": "Galaxy J3 Luna Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J327(?:T1|[ATW])(?:[);/ ]|$)",
                "model": "Galaxy J3 Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J327(?:[FP]|R4)",
                "model": "Galaxy J3 Emerge"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J337R4(?:[);/ ]|$)",
                "model": "Galaxy J3 Aura"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J337T(?:[);/ ]|$)",
                "model": "Galaxy J3 Star"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J327V",
                "model": "Galaxy J3 Eclipse"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S337TL",
                "model": "Galaxy J3 Luna Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J3109",
                "model": "Galaxy J3 (2015)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J300H|J320(?:[ZF]N|R4|W8|YZ|[AFGHMNPVY]))",
                "model": "Galaxy J3 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J330(?:FN|[08FGLN])|J327(?:R7|U))(?:[);/ ]|$)",
                "model": "Galaxy J3 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J337(?:VPP|[AWPUV])(?:[);/ ]|$)",
                "model": "Galaxy J3 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G400[FG]|J400[FGM])",
                "model": "Galaxy J4"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J500(?:FN|N0|[78FGHMY])(?:[);/ ]|$)",
                "model": "Galaxy J5 (2015)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J510(?:[FGMU]N|FQ|[8FGHKLSY])|5108|G510H)(?:[);/ ]|$)",
                "model": "Galaxy J5 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J530",
                "model": "Galaxy J5 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G570[0FMY]",
                "model": "Galaxy J5 Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J600[FGLN]",
                "model": "Galaxy J6"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J610[FG]",
                "model": "Galaxy J6+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J410[FG]",
                "model": "Galaxy J4 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J415(?:[FG]N|[FGN])",
                "model": "Galaxy J4+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J7[01]0(?:FN|MN|[8FHKM])",
                "model": "Galaxy J7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J700P",
                "model": "Galaxy J7 (2015)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J700(?:T1|T)|J710GN|J7109)",
                "model": "Galaxy J7 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J730[K]|J727(?:R4|[AFSU]))(?:[);/ ]|$)",
                "model": "Galaxy J7 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J737(?:R4|T1|VPP|[APSTUV])(?:[);/ ]|$)",
                "model": "Galaxy J7 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C710F",
                "model": "Galaxy J7+ (C7)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G610[FMY]",
                "model": "Galaxy J7 Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G611(?:FF|MT|M)",
                "model": "Galaxy J7 Prime 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G615F",
                "model": "Galaxy J7 Max"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:S727VL|S737TL)",
                "model": "Galaxy J7 Sky Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J7 Pro|J730(?:GM|[FG]))",
                "model": "Galaxy J7 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J701[FM]",
                "model": "Galaxy J7 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J720[FM]",
                "model": "Galaxy J7 Duo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:S767VL|S757BL)",
                "model": "Galaxy J7 Crown"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J727[PTV]",
                "model": "Galaxy J7 V"
            },
            {
                "regex": "SM-J7\\[7\\]",
                "model": "Galaxy J7 7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J810",
                "model": "Galaxy J8"
            },
            {
                "regex": "SM-J8 Plus",
                "model": "Galaxy J8 Plus"
            },
            {
                "regex": "SM-J8 Pro",
                "model": "Galaxy J8 Pro"
            },
            {
                "regex": "SM-J9\\[7\\] Prime",
                "model": "Galaxy J9 7 Prime"
            },
            {
                "regex": "SM-J9\\[8\\] Pro",
                "model": "Galaxy J9 8 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M015[FG]",
                "model": "Galaxy M01"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M013F",
                "model": "Galaxy M01 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M017F",
                "model": "Galaxy M01s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M025F",
                "model": "Galaxy M02s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M105[FGMY]",
                "model": "Galaxy M10"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M107F",
                "model": "Galaxy M10s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M115[FM]",
                "model": "Galaxy M11"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M127[FG]",
                "model": "Galaxy M12"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:M205(?:[FGMN]|FN)|M20)(?:[);/ ]|$)",
                "model": "Galaxy M20"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M215F",
                "model": "Galaxy M21"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:M307(?:FN|[0F])|M30s)",
                "model": "Galaxy M30s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M305?",
                "model": "Galaxy M30"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M315F",
                "model": "Galaxy M31"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M317F",
                "model": "Galaxy M31s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M405",
                "model": "Galaxy M40"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M515F",
                "model": "Galaxy M51"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W201([689])",
                "model": "Galaxy W201$1"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W2015",
                "model": "Galaxy Golden 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G910S",
                "model": "Galaxy Round"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G550(?:FY|T[12]?)|S550TL|G55[01]0|G5520)",
                "model": "Galaxy On5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G5528",
                "model": "Galaxy On5 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G600(?:FY|[0F])",
                "model": "Galaxy On7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G610[0KLS]",
                "model": "Galaxy On7 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G611[FKLS]",
                "model": "Galaxy On7 Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C500[0X]",
                "model": "Galaxy C5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C501[08]",
                "model": "Galaxy C5 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C700[0X]",
                "model": "Galaxy C7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C701[08FX]",
                "model": "Galaxy C7 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C710[08]",
                "model": "Galaxy C8"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C900[08FY]",
                "model": "Galaxy C9 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-Z130H",
                "model": "Galaxy Z1"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-Z200[FMY]",
                "model": "Galaxy Z2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-Z300H",
                "model": "Galaxy Z3"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-Z400[FY]",
                "model": "Galaxy Z4"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G150(?:N[0KLS])?|G155S)(?:[);/ ]|$)",
                "model": "Galaxy Folder"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-G16(?:0N|[05]0?|5N))(?:[);/ ]|$)",
                "model": "Galaxy Folder 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J321AZ(?:[);/ ]|$)",
                "model": "Galaxy Sol"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J326AZ(?:[);/ ]|$)",
                "model": "Galaxy Sol 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J336AZ(?:[);/ ]|$)",
                "model": "Galaxy Sol 3"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J727AZ(?:[);/ ]|$)",
                "model": "Galaxy Halo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J327AZ",
                "model": "Galaxy Amp Prime 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J337AZ",
                "model": "Galaxy Amp Prime 3 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:F900[0FUW]|F907[BN])|SCV44",
                "model": "Galaxy Fold",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-F916(?:U1|[0BNQUW])|SCG05",
                "model": "Galaxy Z Fold 2 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9060(?:[);/ ]|$)",
                "model": "Galaxy Grand Neo",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9063",
                "model": "Galaxy Grand Neo Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9(?:080|128)",
                "model": "Galaxy Grand",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9168",
                "model": "Galaxy Grand Neo+",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9082",
                "model": "Galaxy Grand Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-N7000",
                "model": "Galaxy Note",
                "device": "phablet"
            },
            {
                "regex": "(?:SC-01G|SCL24)(?:[);/ ]|$)",
                "model": "Galaxy Note Edge",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N935[FSLK](?:[);/ ]|$)",
                "model": "Galaxy Note Fan Edition",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:(?:GT-)?N7100|SCH-(?:I605|N719|R950)|SPH-L900)(?:[);/ ]|$)",
                "model": "Galaxy Note II",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-N7105",
                "model": "Galaxy Note II LTE",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G710(?:2T|5[HL]|[25689KLS])?(?:[);/ ]|$)",
                "model": "Galaxy Grand 2",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G720(?:AX|N0|[02])(?:[);/ ]|$)",
                "model": "Galaxy Grand Max"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G530(?:[689]W|[AF]Z|BT|MU|R[47]|[AFHMPTWY])|G531[FH]|S920L)(?:[);/ ]|$)",
                "model": "Galaxy Grand Prime",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G531(?:BT|[MY])(?:[);/ ]|$)",
                "model": "Galaxy Grand Prime VE Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G532F(?:[);/ ]|$)",
                "model": "Galaxy Grand Prime Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G532MT(?:[);/ ]|$)",
                "model": "Galaxy J2 Prime (TV)",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G532[MG](?:[);/ ]|$)",
                "model": "Galaxy J2 Prime",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N7502(?:[);/ ]|$)",
                "model": "Galaxy Note 3 Neo Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N750[05LQ]?",
                "model": "Galaxy Note 3 Neo",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N9002(?:[);/ ]|$)",
                "model": "Galaxy Note 3 Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-9005(?:[);/ ]|$)",
                "model": "Galaxy Note 3 LTE",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-N900(?:W8|[05689][VQ]?|[AKLPSTV])?|SCL22|SC-01F(?:[);/ ]|$))",
                "model": "Galaxy Note 3",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:N910|910U)|N9100(?:[);/ ]|$)",
                "model": "Galaxy Note 4",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N916[KLS]",
                "model": "Galaxy Note 4 LTE",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N915",
                "model": "Galaxy Note 4 Edge",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N920(?:R[467]|W8|[0ACFGIKLPSTVX])",
                "model": "Galaxy Note 5",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N9208",
                "model": "Galaxy Note 5 Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G750(?:8Q|[9AFH])",
                "model": "Galaxy Mega 2",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I915[028]",
                "model": "Galaxy Mega 5.8",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I920[05]",
                "model": "Galaxy Mega 6.3",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-N930(?:R[467]|W8|[0AFKLPSTUVX])|SCV34)",
                "model": "Galaxy Note 7",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?SM-N950|SCV37|SC-01K",
                "model": "Galaxy Note 8",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N960|SCV40|SC-01L)",
                "model": "Galaxy Note 9",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?SM-(?:N970(?:U1|W8|[089DFJKLSUWX])|N971N)",
                "model": "Galaxy Note 10",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?SM-N770[FX]",
                "model": "Galaxy Note 10 Lite",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N975(?:U1|XU|[0CFUWX])|SM-N976[0BVNQU]|SC-01M|SCV45)",
                "model": "Galaxy Note 10+",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N980(?:F/DS|F))",
                "model": "Galaxy Note 20",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N981(?:B/DS|U1|[0BNUW]))",
                "model": "Galaxy Note 20 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N985(?:F/DS|F))",
                "model": "Galaxy Note 20 Ultra",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N986(?:B/DS|U1|[0BNUW])|SC-53A|SCG06)",
                "model": "Galaxy Note 20 Ultra 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W750V",
                "model": "Ativ SE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G310R5",
                "model": "GreatCall Touch 3"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-E2152",
                "model": "E2152",
                "device": "feature phone"
            },
            {
                "regex": "(?:SAMSUNG-)?(GT-(P|N8|N5)[0-9]+[a-z]?)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "SC-02C",
                "model": "Galaxy S II"
            },
            {
                "regex": "(?:SAMSUNG-)?((?:SM-[TNP]|GT-P)[a-z0-9_\\-]+)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "((?:SCH|SGH|SPH|SHV|SHW|GT|SM)-[a-z0-9_\\-]+)",
                "model": "$1"
            },
            {
                "regex": "SMART-TV",
                "device": "tv",
                "model": "Smart TV"
            },
            {
                "regex": "Galaxy ([^/;]+) Build",
                "model": "Galaxy $1"
            },
            {
                "regex": "Galaxy ([a-z0-9]+)",
                "model": "Galaxy $1"
            },
            {
                "regex": "SAMSUNG[\\-][ ]?([a-z0-9]+[\\-_][a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SAMSUNG;[ ]?([a-z0-9]+[\\-_][a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SAMSUNG[ _/\\-]?([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "SAMSUNG;[ ]?([a-z0-9 ]+)",
                "model": "$1"
            },
            {
                "regex": "SEC-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SAM-([a-z0-9]+)",
                "model": "SCH-$1"
            },
            {
                "regex": "(?:portalmmm|o2imode)/2\\.0 ([SZ][a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "sam([rua][0-9]+)",
                "model": "SCH-$1"
            }
        ]
    },
    "Sanei": {
        "regex": "(?:8312D|G(60[25]|70[3568]G?|785|803)|N83(?:-2cpu)?|N91) Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "N83",
                "model": "N83"
            },
            {
                "regex": "N91",
                "model": "N91"
            },
            {
                "regex": "8312D",
                "model": "G101"
            },
            {
                "regex": "G(60[25]|70[3568]G?|785|803)",
                "model": "G$1"
            }
        ]
    },
    "Selfix": {
        "regex": "SELFIX",
        "device": "smartphone",
        "models": [
            {
                "regex": "SELFIX_SLASH6",
                "model": "Slash 6"
            },
            {
                "regex": "VOYAGER-V45",
                "model": "Voyager V45"
            }
        ]
    },
    "Sencor": {
        "regex": "Sencor|ELEMENT[ _]?(?:7|8|9\\.7|10[ _]1)(?:[ _]?V[23])?(?:[);/ ]|$)|ELEMENT[ _]?(?:P[0-9]+|10.1 Q001)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:SENCOR[ _])?Element (10\\.1) (Q001)",
                "model": "Element $1\" $2"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V3",
                "model": "Element 7 V3"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V2[ _]BASIC",
                "model": "Element 7 V2 Basic"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V2",
                "model": "Element 7 V2"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]8[ _]?V3",
                "model": "Element 8 V3"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]8[ _]?V2",
                "model": "Element 8 V2"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT8",
                "model": "Element 8"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]9\\.7[ _]?V3",
                "model": "Element 9.7 V3"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]9\\.7[ _]?V2",
                "model": "Element 9.7 V2"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]9\\.7",
                "model": "Element 9.7"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT10[ _]1",
                "model": "Element 10.1"
            },
            {
                "regex": "(?:SENCOR[ _])?(7Q105)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]?P([0-9]+)",
                "model": "Element P$1",
                "device": "smartphone"
            },
            {
                "regex": "Sencor[ _]([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Senwa": {
        "regex": "Senwa|(?:S\\-?(?:471|7[12]5|6[01]5|915|905TL|1000|5018)|V705B|LS50F| LS50?|LS5518H|LS5718)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S-?471(?:[);/ ]|$)",
                "model": "Jazz"
            },
            {
                "regex": "S-?605(?:[);/ ]|$)",
                "model": "City"
            },
            {
                "regex": "S-?905TL(?:[);/ ]|$)",
                "model": "Odin"
            },
            {
                "regex": "S-?1000(?:[);/ ]|$)",
                "model": "Odin"
            },
            {
                "regex": "S-?5018(?:[);/ ]|$)",
                "model": "Inizio"
            },
            {
                "regex": "S-?(615|7[12]5|915)(?:[);/ ]|$)",
                "model": "S$1"
            },
            {
                "regex": "V705B(?:[);/ ]|$)",
                "model": "V705B"
            },
            {
                "regex": "LS50F(?:[);/ ]|$)",
                "model": "Evolution"
            },
            {
                "regex": " LS50(?:[);/ ]|$)",
                "model": "Pegasus"
            },
            {
                "regex": " LS5(?:[);/ ]|$)",
                "model": "Thor"
            },
            {
                "regex": "LS5518H(?:[);/ ]|$)",
                "model": "Sparkly"
            },
            {
                "regex": "LS5718(?:[);/ ]|$)",
                "model": "Diamond"
            },
            {
                "regex": "Senwa[ _-]*([^;/]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Sky": {
        "regex": "(?:SKY|Elite|Fuego)[_ ][3-7]\\.[05](?:[A-Z]{1,2})?|Elite[ _](?:5_0T|M45|[45]T|45T|GO|M5Plus|T55|T[46]|[AB]5|5_5_Octa)|Platinum[_ ](?:5.0M|5\\.5C|5\\.0+|M5|[ABCM]4|[ACG]55|[ABDEFG]5|A57|P9|X|UNO|VIEW2|O|4\\.0|4_0Plus)|PLATINUMVIEW|SKY[ _](?:55M|Pro_III)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Platinum[_ ](?:5\\.0M|M5)",
                "model": "Platinum 5.0M"
            },
            {
                "regex": "Platinum[_ ]5\\.5C",
                "model": "Platinum 5.5C"
            },
            {
                "regex": "Platinum[_ ]5\\.0\\+",
                "model": "Platinum 5.0 Plus"
            },
            {
                "regex": "Platinum_4_0Plus",
                "model": "Platinum 4.0 Plus"
            },
            {
                "regex": "Platinum[ _]4\\.0",
                "model": "Platinum 4.0"
            },
            {
                "regex": "Platinum[_ ](P9) Pro(?:[);/ ]|$)",
                "model": "Platinum $1 Pro"
            },
            {
                "regex": "Platinum[_ ]([ABCM]4|[ACG]55|[ABDEFG]5|A57|P9|X|UNO|O)(?:[);/ ]|$)",
                "model": "Platinum $1"
            },
            {
                "regex": "Platinum[_ ]?VIEW(2)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Platinum View$1"
            },
            {
                "regex": "Elite_5_5_Octa",
                "model": "Elite 5.5 Octa"
            },
            {
                "regex": "Elite M5Plus",
                "model": "Elite M5 Plus"
            },
            {
                "regex": "Elite[ _](M45|Go|[45]T|T[46]|T55|[AB]5|A55|45T)(?:[);/ ]|$)",
                "model": "Elite $1"
            },
            {
                "regex": "Elite[_ ]([3-7])[\\._]([05](?:[A-Z]{1,2})?\\+?)",
                "model": "Elite $1.$2"
            },
            {
                "regex": "Fuego[_ ]([3-7]\\.[05](?:[A-Z]{1,2})?\\+?)",
                "model": "Fuego $1"
            },
            {
                "regex": "SKY_Pro_III",
                "model": "Pro III"
            },
            {
                "regex": "SKY 55M",
                "model": "55M"
            },
            {
                "regex": "SKY[_ ]([3-7]\\.[05](?:[A-Z]{1,2})?)",
                "model": "$1"
            }
        ]
    },
    "Skyworth": {
        "regex": "Sky_?worth",
        "device": "tv",
        "models": [
            {
                "regex": "Sky_?worth ([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Smartfren": {
        "regex": "Smartfren|Androtab|Andromax|PD6D1J|AD682J|AD68[89]G|AD6B1H|AD9A1H|AD682H|AD683G",
        "device": "smartphone",
        "models": [
            {
                "regex": "S7 Build",
                "model": "Andromax Tab 7.0",
                "device": "tablet"
            },
            {
                "regex": "PD6D1J",
                "model": "Andromax V3s"
            },
            {
                "regex": "AD682J",
                "model": "Andromax T"
            },
            {
                "regex": "AD688G",
                "model": "Andromax C2"
            },
            {
                "regex": "AD689G",
                "model": "Andromax i3"
            },
            {
                "regex": "AD682H",
                "model": "Andromax i3s"
            },
            {
                "regex": "AD6B1H",
                "model": "Andromax G2 Hot"
            },
            {
                "regex": "AD9A1H",
                "model": "Andromax G2"
            },
            {
                "regex": "AD683G",
                "model": "Andromax I"
            },
            {
                "regex": "New Andromax-i",
                "model": "New Andromax I"
            },
            {
                "regex": "Andromax[ _\\-]([^/;]+) Build",
                "model": "Andromax $1"
            },
            {
                "regex": "Andromax[ _\\-]([a-z0-9]+)",
                "model": "Andromax $1"
            },
            {
                "regex": "Smartfren[ _\\-]([^/;\\)]+)(?: Build|[/;\\)])",
                "model": "$1"
            },
            {
                "regex": "(Androtab[^/;]+) Build",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "Smartisan": {
        "regex": "(SM(?:70[15]|[89]01|919)|OD10[35]|YQ60[1357]|DE106|DT1901A|O[CE]106|OS103|O[CS]105)[ /;\\)]",
        "device": "smartphone",
        "models": [
            {
                "regex": "SM70[15]",
                "model": "T1"
            },
            {
                "regex": "SM801",
                "model": "T2"
            },
            {
                "regex": "SM901",
                "model": "M1"
            },
            {
                "regex": "SM919",
                "model": "M1L"
            },
            {
                "regex": "YQ60[1357]",
                "model": "U1"
            },
            {
                "regex": "OD10[35]",
                "model": "Pro"
            },
            {
                "regex": "OS105[ /;\\)]",
                "model": "Pro 2"
            },
            {
                "regex": "DE106[ /;\\)]",
                "model": "R1"
            },
            {
                "regex": "OE106[ /;\\)]",
                "model": "Nut Pro 2s"
            },
            {
                "regex": "OC10[56][ /;\\)]",
                "model": "Nut 3"
            },
            {
                "regex": "DT1901A[ /;\\)]",
                "model": "Nut Pro 3"
            },
            {
                "regex": "OS103[ /;\\)]",
                "model": "JianGuo Pro 2"
            }
        ]
    },
    "STF Mobile": {
        "regex": "(?:Fractal|AERIAL PLUS|Origins Pro|BLOCK_MINI|BLOCK GO|BLOCK 3|SLAY II)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Fractal",
                "model": "Fractal"
            },
            {
                "regex": "Origins Pro",
                "model": "Origins Pro"
            },
            {
                "regex": "AERIAL PLUS",
                "model": "Aerial Plus"
            },
            {
                "regex": "BLOCK_MINI",
                "model": "Block Mini"
            },
            {
                "regex": "BLOCK 3 mini",
                "model": "Block 3 Mini"
            },
            {
                "regex": "BLOCK 3",
                "model": "Block 3"
            },
            {
                "regex": "BLOCK GO",
                "model": "Block Go"
            },
            {
                "regex": "SLAY II",
                "model": "Slay II"
            }
        ]
    },
    "STK": {
        "regex": "STK[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "STK[_ ]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "STK[_ ]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Stonex": {
        "regex": "STX[ -]([^;/]+)|STONE EVO",
        "device": "smartphone",
        "models": [
            {
                "regex": "STX[ -]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "STX[ -]([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "SuperSonic": {
        "regex": "(SC-[0-9]+[a-z]+)",
        "device": "tablet",
        "model": "$1"
    },
    "Supra": {
        "regex": "SUPRA|NVTAB 7.0 3G",
        "device": "smartphone",
        "models": [
            {
                "regex": "SUPRA[ _]([^;/)]+)(?: Build|[;)])",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(NVTAB 7.0 3G)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Sumvision": {
        "regex": "(Cyclone [^/;]+) Build",
        "device": "tablet",
        "model": "$1"
    },
    "SunVan": {
        "regex": "SUNVAN[ _\\-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "SUNVAN[ _\\-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "SUNVAN[ _\\-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "SWISSMOBILITY": {
        "regex": "(?:SCHR9GR|PRA(?:U8|100)|ZUR(?:722M|70016W?|700[RW]|805A))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SCHR9GR",
                "model": "SCHON R9"
            },
            {
                "regex": "PRA(U8|100)",
                "model": "PRA$1"
            },
            {
                "regex": "ZUR722M",
                "device": "phablet",
                "model": "Z72 go"
            },
            {
                "regex": "ZUR(70016W?|700[RW]|805A)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "ZUR$1"
            }
        ]
    },
    "Thomson": {
        "regex": "(?:Primo(7|8)|QM73[45]-8G|QM734-2|QM736-8G\\(HD\\)|(?<!\\.)8950|MID1002|5014G|TEO7RK|Friendly_TH101|Delight TH201)(?:[);/ ]|$)|(?:Tlink|Every)[0-9]+|THOMSON,",
        "device": "tablet",
        "models": [
            {
                "regex": "Primo(7|8)",
                "model": "Primo $1"
            },
            {
                "regex": "QM734-2",
                "model": "QM734-2"
            },
            {
                "regex": "QM734-8G",
                "model": "QM734-8G"
            },
            {
                "regex": "QM735-8G",
                "model": "QM735-8G"
            },
            {
                "regex": "QM736-8G\\(HD\\)",
                "model": "QM736-8G (HD)"
            },
            {
                "regex": "(?<!\\.)8950(?:[);/ ]|$)",
                "model": "3G 8950"
            },
            {
                "regex": "TEO7RK(?:[);/ ]|$)",
                "model": "TEO7RK"
            },
            {
                "regex": "5014G(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "5014G"
            },
            {
                "regex": "Tlink([0-9]+)",
                "device": "smartphone",
                "model": "Tlink$1"
            },
            {
                "regex": "Every([0-9]+)",
                "device": "smartphone",
                "model": "Every$1"
            },
            {
                "regex": "Delight TH201",
                "device": "smartphone",
                "model": "Delight TH201"
            },
            {
                "regex": "Friendly_TH101",
                "device": "smartphone",
                "model": "Friendly TH101"
            },
            {
                "regex": "((?:49|55)UC6306|55UC63|32HD55|40FD54|55UD63)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Tanix": {
        "regex": "TX5 MAX(?:[);/ ]|$)",
        "device": "tv",
        "model": "TX5 Max"
    },
    "Pantech": {
        "regex": "Pantech|P[GN]-|PT-[a-z0-9]{3,}|(?<!Winmax )TX[T]?[0-9]+|IM-[a-z0-9]+(?:[);/ ]|$)|ADR910L",
        "device": "smartphone",
        "models": [
            {
                "regex": "ADR910L",
                "model": "Star Q"
            },
            {
                "regex": "IM-A870K",
                "model": "Vega Iron"
            },
            {
                "regex": "Pantech[ \\-]?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Pantech_([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "(P[GTN]-[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(TX[T]?[0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(IM-[a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Ployer": {
        "regex": "MOMO([0-9]|[ ]?mini[ ]?(?:S|3GS)?)",
        "device": "tablet",
        "models": [
            {
                "regex": "MOMOminiS",
                "model": "MOMO mini S"
            },
            {
                "regex": "momo mini 3GS",
                "model": "MOMO Mini 3GS"
            },
            {
                "regex": "MOMO([0-9][^);/]*) Build",
                "model": "MOMO $1"
            },
            {
                "regex": "MOMO([0-9][^);/]*)(?:[);/]|$)",
                "model": "MOMO $1"
            }
        ]
    },
    "Plum": {
        "regex": "PLUM[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Z405",
                "model": "Gator 3"
            },
            {
                "regex": "Z407",
                "model": "Axe 4"
            },
            {
                "regex": "Z516",
                "model": "Compass"
            },
            {
                "regex": "Z811",
                "device": "tablet",
                "model": "Optimax 11"
            },
            {
                "regex": "Z709",
                "device": "tablet",
                "model": "Optimax 7"
            },
            {
                "regex": "Z712",
                "device": "tablet",
                "model": "Optimax 12"
            }
        ]
    },
    "Polaroid": {
        "regex": "Polaroid|(?:PMID|MIDC)[0-9a-z]+(?:[);/ ]|$)|MID(?:1014|0714)|PRO[VG]?(?:[0-9]{3,}[a-z]*|[0-9]{2}[a-z])|(?:P(?:400[56]|4526|500[56]|502[56]|504[67]|552[56])A|P902/A900|PSPC(?:505|550|[MZL]20A0|K2[01]NA)|SIGMA 5|MIDS145PXE|MIDS747PX|MID4004JBL|MIDS185PR|PSPTD21NA)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "P4005A",
                "model": "Turbo C4"
            },
            {
                "regex": "P5005A",
                "model": "Turbo C5"
            },
            {
                "regex": "P4006A",
                "model": "Turbo D4"
            },
            {
                "regex": "PSPTD21NA",
                "model": "Turbo D2 Plus"
            },
            {
                "regex": "P4526A",
                "model": "Turbo E"
            },
            {
                "regex": "PSPC(505|550)",
                "model": "Cosmo $1"
            },
            {
                "regex": "P5006A",
                "model": "Cosmo K"
            },
            {
                "regex": "P5526A",
                "model": "Cosmo K Plus"
            },
            {
                "regex": "PSPCK20NA",
                "model": "Cosmo K2"
            },
            {
                "regex": "PSPCK21NA",
                "model": "Cosmo K2 Plus"
            },
            {
                "regex": "P5026A",
                "model": "Cosmo L"
            },
            {
                "regex": "PSPCL20A0",
                "model": "Cosmo L2"
            },
            {
                "regex": "PSPCM20A0",
                "model": "Cosmo M2"
            },
            {
                "regex": "P5046A",
                "model": "Cosmo P5s"
            },
            {
                "regex": "P5525A",
                "model": "Cosmo Q5s"
            },
            {
                "regex": "P5047A",
                "model": "Cosmo Z"
            },
            {
                "regex": "PSPCZ20A0",
                "model": "Cosmo Z2"
            },
            {
                "regex": "P5025A",
                "model": "L5s"
            },
            {
                "regex": "PRO4611(?:PR201)?",
                "model": "Pro4611"
            },
            {
                "regex": "PROV400",
                "model": "Agate"
            },
            {
                "regex": "PROV350",
                "model": "ProV350"
            },
            {
                "regex": "SIGMA 5(?:[);/ ]|$)",
                "model": "Sigma 5"
            },
            {
                "regex": "PRO([VG]?(?:[0-9]{3,}[a-z]*|[0-9]{2}[a-z]))",
                "model": "Pro$1"
            },
            {
                "regex": "PSPT350",
                "model": "Turbo 350 Gris"
            },
            {
                "regex": "MIDS185PR",
                "model": "Pure 10.1\""
            },
            {
                "regex": "(MID(?:1014|0714|S145PXE|S747PX|4004JBL))",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "((?:PMID|MIDC)[0-9a-z]+)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(P902/A900)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Polaroid",
                "model": "",
                "device": "tablet"
            }
        ]
    },
    "PolyPad": {
        "regex": "POLY ?PAD",
        "device": "tablet",
        "models": [
            {
                "regex": "POLY ?PAD[_ \\.]([a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "POLY ?PAD[_\\.]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Polytron": {
        "regex": "POLYTRON|W8480|W7430|PW1100S|W7550|W7531|W8570|R2401",
        "device": "smartphone",
        "models": [
            {
                "regex": "R2508",
                "model": "Rocket"
            },
            {
                "regex": "POLYTRON[ _]R1500",
                "model": "Rocket Q-Five"
            },
            {
                "regex": "R2401",
                "model": "Rocket 2X"
            },
            {
                "regex": "POLYTRON[ _-]R2402",
                "model": "Rocket R2402"
            },
            {
                "regex": "POLYTRON[ _-]R2403",
                "model": "Rocket R1"
            },
            {
                "regex": "POLYTRON[ _-]R2406",
                "model": "Rocket R2"
            },
            {
                "regex": "POLYTRON[ _-]R2407",
                "model": "Rocket R3"
            },
            {
                "regex": "POLYTRON[ _-]R2452",
                "model": "Rocket S1"
            },
            {
                "regex": "POLYTRON[ _-]R2457",
                "model": "Rocket S2"
            },
            {
                "regex": "POLYTRON[ _-]R2501",
                "model": "Rocket T1"
            },
            {
                "regex": "POLYTRON[ _-]R2507",
                "model": "Rocket T3"
            },
            {
                "regex": "POLYTRON[ _-]R2509SE",
                "model": "Rocket T6 SE"
            },
            {
                "regex": "POLYTRON[ _-]R2509",
                "model": "Rocket T6"
            },
            {
                "regex": "POLYTRON[ _-]R250A",
                "model": "Rocket T7"
            },
            {
                "regex": "POLYTRON[ _-]R2506",
                "model": "Rocket T4"
            },
            {
                "regex": "POLYTRON[ _-](?:R3450|W1400)",
                "model": "Rocket Jetz"
            },
            {
                "regex": "POLYTRON[ _-]R3500",
                "model": "Rocket Jetz 5.0"
            },
            {
                "regex": "4G450",
                "model": "Zap 5"
            },
            {
                "regex": "W6500",
                "model": "Quadra Rocket"
            },
            {
                "regex": "W7452",
                "model": "Quadra S2"
            },
            {
                "regex": "W7550",
                "model": "Quadra V5"
            },
            {
                "regex": "W8570",
                "model": "Quadra V7"
            },
            {
                "regex": "POLYTRON[ _]L501",
                "model": "Rocket L501"
            },
            {
                "regex": "POLYTRON[ _]P520",
                "model": "Prime 7S"
            },
            {
                "regex": "POLYTRON[ _]P552",
                "model": "Prime 7 Pro"
            },
            {
                "regex": "4G500",
                "model": "Zap 6 Cleo"
            },
            {
                "regex": "W8480",
                "model": "Crystal 4 W8480"
            },
            {
                "regex": "W7531",
                "model": "Wizard V"
            },
            {
                "regex": "W7430",
                "model": "Quadra Mini W7430"
            },
            {
                "regex": "POLYTRON[ _]4G501",
                "model": "Zap 6 Posh"
            },
            {
                "regex": "POLYTRON[ _]4G502",
                "model": "Zap 6 Power"
            },
            {
                "regex": "POLYTRON[ _]4G503",
                "model": "Zap 6 Flaz"
            },
            {
                "regex": "POLYTRON[_ ]?[ _]4G550",
                "model": "Zap 6 Note"
            },
            {
                "regex": "POLYTRON[ _]4G551",
                "model": "Zap 6 Posh Note"
            },
            {
                "regex": "PW1100S",
                "model": "PW1100S"
            },
            {
                "regex": "Q2352",
                "model": "Q2352"
            },
            {
                "regex": "POLYTRON[ _]T7800",
                "model": "Cosmica T7800",
                "device": "tablet"
            },
            {
                "regex": "POLYTRON[ _]T7700",
                "model": "Rocket Pad",
                "device": "tablet"
            }
        ]
    },
    "Positivo": {
        "regex": "YPY_S450",
        "device": "smartphone",
        "models": [
            {
                "regex": "YPY_S450",
                "model": "YPY S450"
            }
        ]
    },
    "Prestigio": {
        "regex": "Prestigio 5500 DUO|(?:PMP|PAP|PMT|PSP|PGPS)[0-9]+[a-z0-9_]+(?:[);/ ]|$)|Muze C3",
        "device": "tablet",
        "models": [
            {
                "regex": "PMT3277_3G",
                "model": "MultiPad Ranger 7.0 3G"
            },
            {
                "regex": "PGPS7799CIS08GBPG(?:[);/ ]|$)",
                "model": "Geo Vision Tour 3"
            },
            {
                "regex": "PGPS7797(?:[);/ ]|$)",
                "model": "Geo Vision Tour 2"
            },
            {
                "regex": "PMT3201_4G",
                "model": "Grace 4G"
            },
            {
                "regex": "PSP5551DUO",
                "model": "Grace S5"
            },
            {
                "regex": "PMT3287_3G",
                "model": "MultiPad Ranger 8.0 3G"
            },
            {
                "regex": "Prestigio 5500 DUO",
                "model": "MultiPhone 5500 Duo",
                "device": "smartphone"
            },
            {
                "regex": "PMT3208[_ ]3G",
                "model": "MultiPad Wize 8.0 3G"
            },
            {
                "regex": "PSP7546DUO([ _][A-Z]{2})?",
                "model": "X Pro"
            },
            {
                "regex": "PSP7610DUO([ _][A-Z]{2})?",
                "model": "S Max"
            },
            {
                "regex": "(PM[PT][0-9]+[a-z0-9_]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "((?:PAP|PSP)[0-9]+[a-z0-9_]+(?: DUO)?)(?:[);/ ]|$)",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "Muze C3(?:[);/ ]|$)",
                "model": "Muze C3",
                "device": "smartphone"
            }
        ]
    },
    "Sanyo": {
        "regex": "Sanyo|MobilePhone[ ;]",
        "device": "feature phone",
        "models": [
            {
                "regex": "SCP-?6750",
                "model": "Katana Eclipse X"
            },
            {
                "regex": "SCP-?6760",
                "model": "Incognito"
            },
            {
                "regex": "SCP-?6780",
                "model": "Innuendo"
            },
            {
                "regex": "SANYO[ /_-]([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "MobilePhone ([a-z0-9\\-]+)",
                "model": "$1"
            }
        ]
    },
    "Qilive": {
        "regex": "Qilive [0-9][^;/]*|Q(7S5[5]?IN4G|7T10INP|8T10IN|8S55IN4G2|8S[56]IN4G|9T9IN|9T(?:7|10)IN4G|9S55IN4G|10S5[37]IN4G|10S[56]IN4G|10S[56]IN4GR|9S5IN4G|6T7IN)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Q7S5IN4G",
                "model": "Q7 5.0\" 4G"
            },
            {
                "regex": "Q7S55IN4G",
                "model": "Q7 5.5\" 4G"
            },
            {
                "regex": "Q8S55IN4G2",
                "model": "Q8 5.5\" 4G"
            },
            {
                "regex": "Q8S6IN4G",
                "model": "Q8 6.0\" 4G"
            },
            {
                "regex": "Q8S5IN4GP",
                "model": "Q8 5.1\" 4G"
            },
            {
                "regex": "Q9S5IN4G",
                "model": "Q9 5.0\" 4G"
            },
            {
                "regex": "Q9S55IN4G",
                "model": "Q9 5.5\" 4G"
            },
            {
                "regex": "Q10S53IN4G",
                "model": "Q10 5.3\" 4G"
            },
            {
                "regex": "Q10S57IN4G",
                "model": "Q10 5.7\" 4G"
            },
            {
                "regex": "Q10S5IN4G[R]?",
                "model": "Q10 5.0\" 4G"
            },
            {
                "regex": "Q10S6IN4G",
                "model": "Q10 6.0\" 4G"
            },
            {
                "regex": "Q6T7IN",
                "model": "Q6",
                "device": "tablet"
            },
            {
                "regex": "Q7T10INP",
                "model": "Q7 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "Q8T10IN",
                "model": "Q8 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "Q9T7IN4G",
                "model": "Q9 7.0\" 4G",
                "device": "tablet"
            },
            {
                "regex": "Q9T9IN",
                "model": "Q9 9.0\"",
                "device": "tablet"
            },
            {
                "regex": "Q9T10IN4G",
                "model": "Q9 10.1\" 4G",
                "device": "tablet"
            },
            {
                "regex": "Qilive ([0-5][^;/]*) Build",
                "model": "$1"
            },
            {
                "regex": "Qilive ([0-5][^;/]*)/",
                "model": "$1"
            },
            {
                "regex": "Qilive ([6-9][^;/]*) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Qilive ([6-9][^;/]*)/",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "QMobile": {
        "regex": "QMobile|QTab(?!10EW)|Q-Smart|(?:E2 Noir|Noir X1S|LUNA PRO|NICE S|JazzX JS(?:[27]|10)(?: PRO)?|LT[57]00 PRO|LT950|Q Infinity|Hot Pro 2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "JazzX JS7 PRO",
                "model": "Jazz X JS7 Pro"
            },
            {
                "regex": "JazzX JS(2|10)",
                "model": "Jazz X JS$1"
            },
            {
                "regex": "Noir X1S",
                "model": "Noir X1S"
            },
            {
                "regex": "E2 Noir",
                "model": "E2 Noir"
            },
            {
                "regex": "Hot Pro 2",
                "model": "Hot Pro 2"
            },
            {
                "regex": "LT([57]00) PRO",
                "model": "Noir LT$1 Pro"
            },
            {
                "regex": "LUNA PRO",
                "model": "Luna Pro"
            },
            {
                "regex": "NICE S",
                "model": "Nice S"
            },
            {
                "regex": "Q Infinity PRO",
                "model": "Q Infinity Pro"
            },
            {
                "regex": "Q Infinity E Lite",
                "model": "Q Infinity E Lite"
            },
            {
                "regex": "Q Infinity ([FCB])",
                "model": "Q Infinity $1"
            },
            {
                "regex": "(LT950)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "QTab[ _-]([^;/]+) Build",
                "model": "$1 Tab",
                "device": "tablet"
            },
            {
                "regex": "QTab[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1 Tab",
                "device": "tablet"
            },
            {
                "regex": "(?:QMobile|Q-Smart)[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:QMobile|Q-Smart)[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            },
            {
                "regex": "Q Infinity",
                "model": "Q Infinity"
            }
        ]
    },
    "Maximus": {
        "regex": "Maximus[ _]|(Noir X)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Maximus[ _])?(Noir X|D1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Maximus_(T2)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Quantum": {
        "regex": "Quantum (?:Fit|MUV (?:PRO|UP)|Go|Mini|V|You [2E])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Quantum (Fit|Go|Mini|V|You [2E])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Quantum MUV PRO(?:[);/ ]|$)",
                "model": "MUV Pro"
            },
            {
                "regex": "Quantum MUV UP(?:[);/ ]|$)",
                "model": "MUV Up"
            }
        ]
    },
    "Quechua": {
        "regex": "Quechua Phone 5",
        "device": "smartphone",
        "model": "Quechua Phone 5"
    },
    "Ramos": {
        "regex": "Ramos ?([^/;]+) Build|MOS1(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(MOS1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Ramos ?([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Razer": {
        "regex": "Phone 2",
        "device": "smartphone",
        "model": "Phone 2"
    },
    "Sendo": {
        "regex": "Sendo([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Turbo-X": {
        "regex": "Turbo-X|Hive V 3G|Turbox_S3",
        "device": "smartphone",
        "models": [
            {
                "regex": "Turbox_S3",
                "model": "S3"
            },
            {
                "regex": "Turbo-X_A2(?:[);/ ]|$)",
                "model": "A2"
            },
            {
                "regex": "Turbo-X_e3(?:[);/ ]|$)",
                "model": "E3"
            },
            {
                "regex": "Turbo-X Ice(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Ice"
            },
            {
                "regex": "Hive V 3G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Hive V 3G"
            },
            {
                "regex": "Turbo-X Tablet([^;/]+) Build",
                "device": "tablet",
                "model": "Tablet$1"
            },
            {
                "regex": "Turbo-X ([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Turbo": {
        "regex": "Turbo[_ ]?(?:X5[_ ]?(?:Max|Black|Space|Hero)|X8|X6[ _]Z|X[ _]Ray)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TurboX5Space(?:[);/ ]|$)",
                "model": "X5 Space"
            },
            {
                "regex": "TurboX5Hero(?:[);/ ]|$)",
                "model": "X5 Hero"
            },
            {
                "regex": "TurboX[ _]Ray(?:[);/ ]|$)",
                "model": "X Ray"
            },
            {
                "regex": "Turbo[ _]?X5[ _]?Black(?:[);/ ]|$)",
                "model": "X5 Black"
            },
            {
                "regex": "Turbo[ _]X5[ _]Max(?:[);/ ]|$)",
                "model": "X5 Max"
            },
            {
                "regex": "Turbo[ _]X6[ _]Z(?:[);/ ]|$)",
                "model": "X6 Z"
            },
            {
                "regex": "Turbo[ _]X8(?:[);/ ]|$)",
                "model": "X8"
            }
        ]
    },
    "Silent Circle": {
        "regex": "Blackphone 2",
        "device": "smartphone",
        "model": "Blackphone 2"
    },
    "Sigma": {
        "regex": "Sigma(?!Designs)|(X[_-]Style[ _]?Tab[_ ]A([0-9]{2,3})|X[-_ ]?treme[-_ ]?PQ[0-9]{2}|X-Style_S5501)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Sigma[ _])?X[-_ ]?treme[-_ ]?PQ([0-9]{2})(?:[);/ ]|$)",
                "model": "X-Treme PQ$1"
            },
            {
                "regex": "X[_-]Style[ _]?Tab[_ ]A([0-9]{2,3})(?:[);/ ]|$)",
                "model": "X-Style Tab A$1",
                "device": "tablet"
            },
            {
                "regex": "(?:Sigma[ _])?X[-_ ]?Style[-_ ]S([0-9]+)(?:[);/ ]|$)",
                "model": "X-Style S$1"
            }
        ]
    },
    "Spice": {
        "regex": "(?<![\\d];)Spice",
        "device": "smartphone",
        "models": [
            {
                "regex": "Spice[ _\\-]?([^/;]+)(?:[\\)]| Build)",
                "model": "$1"
            },
            {
                "regex": "Spice[ _\\-]?([^/;]+)(?:/|$)",
                "model": "$1"
            }
        ]
    },
    "Sharp": {
        "regex": "SHARP|SBM|SH-?[0-9]+[a-z]?(?:[);/ ]|$)|AQUOS|(?:SH-M0[14-9]|SH-M1[1-6](?:-y)?|S[357]-SH|SH-[MZ](10|01)|SH-[CL]02|SH-RM(?:1[125]|02)|[34]04SH|401SH|[45]02SH|306SH|[36]05SH|70[1246]SH|80[138]SH|90[1678]SH|50[3679]SH|SHL2[25]|SHV4[0-8]|SHV3[1-9](?:[-_]u)?|FS80(?:1[08]|32|28|0[29])|TG-L900S|NP601SH|403SH|603SH|SHF3[134]|SHV4[035][-_]u|SW001SH|SHG0[123]|X4-SH|A002SH|SH-A01|DM-01J|SH-D01|A001SH|606SH|FS801[56]|d-41A|NP80[567]SH|NP501SH)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "506SH(?:[);/ ]|$)",
                "model": "Aquos Xx3"
            },
            {
                "regex": "603SH(?:[);/ ]|$)",
                "model": "Aquos Xx3 Mini"
            },
            {
                "regex": "50[23]SH(?:[);/ ]|$)",
                "model": "Aquos Xx2"
            },
            {
                "regex": "[34]04SH(?:[);/ ]|$)",
                "model": "Aquos Xx"
            },
            {
                "regex": "606SH(?:[);/ ]|$)",
                "model": "Aquos ea"
            },
            {
                "regex": "507SH(?:[);/ ]|$)",
                "model": "Android One"
            },
            {
                "regex": "S3-SH(?:[);/ ]|$)",
                "model": "Android One S3"
            },
            {
                "regex": "S5-SH(?:[);/ ]|$)",
                "model": "Android One S5"
            },
            {
                "regex": "S7-SH(?:[);/ ]|$)",
                "model": "Android One S7"
            },
            {
                "regex": "X4-SH(?:[);/ ]|$)",
                "model": "Android One X4"
            },
            {
                "regex": "SH-M04(?:[);/ ]|$)",
                "model": "Aquos SH-M04"
            },
            {
                "regex": "SH-M05(?:[);/ ]|$)",
                "model": "Aquos Sense Lite"
            },
            {
                "regex": "SH-M07(?:[);/ ]|$)",
                "model": "Aquos Sense Plus"
            },
            {
                "regex": "SHG03(?:[);/ ]|$)",
                "model": "Aquos Sense 5G"
            },
            {
                "regex": "SH-D01(?:[);/ ]|$)",
                "model": "Aquos D10"
            },
            {
                "regex": "SH-M12(?:-y)?(?:[);/ ]|$)",
                "model": "Aquos S3 Dual SIM"
            },
            {
                "regex": "(?:SH-[MZ]10|801SH)(?:[);/ ]|$)",
                "model": "Aquos Zero"
            },
            {
                "regex": "(?:SH-M13|906SH)(?:[);/ ]|$)",
                "model": "Aquos Zero 2"
            },
            {
                "regex": "(?:SHG02|A002SH)(?:[);/ ]|$)",
                "model": "Aquos Zero 5G Basic"
            },
            {
                "regex": "SH-Z01(?:[);/ ]|$)",
                "model": "Aquos S2 (C10)"
            },
            {
                "regex": "(?:SH-02E|SH-01[GH]|SH-04H)(?:[);/ ]|$)",
                "model": "Aquos Phone Zeta"
            },
            {
                "regex": "SH-?06D(?:[);/ ]|$)",
                "model": "Aquos Phone SH-06D"
            },
            {
                "regex": "(SHL2[25]|SH-M01)(?:[);/ ]|$)",
                "model": "Aquos Phone $1"
            },
            {
                "regex": "SH-L02(?:[);/ ]|$)",
                "model": "Aquos L2"
            },
            {
                "regex": "(?:605SH|SH-03J|SHV39)(?:[);/ ]|$)",
                "model": "Aquos R"
            },
            {
                "regex": "(?:605SH|SH-03J|SHV39)(?:[);/ ]|$)",
                "model": "Aquos R"
            },
            {
                "regex": "(?:701SH|SHV41|SH-M06)(?:[);/ ]|$)",
                "model": "Aquos R Compact"
            },
            {
                "regex": "(?:SH-M09|SHV42|706SH|SH-03K)(?:[);/ ]|$)",
                "model": "Aquos R2"
            },
            {
                "regex": "803SH(?:[);/ ]|$)",
                "model": "Aquos R2 Compact"
            },
            {
                "regex": "(?:908SH|SHG01|SH-M14)(?:[);/ ]|$)",
                "model": "Aquos R5G"
            },
            {
                "regex": "SH-M16(?:[);/ ]|$)",
                "model": "Aquos S4 Plus"
            },
            {
                "regex": "SH-M15(?:[);/ ]|$)",
                "model": "Aquos S4 SIM"
            },
            {
                "regex": "SH-C02(?:[);/ ]|$)",
                "model": "Aquos V"
            },
            {
                "regex": "(SHF3[134])(?:[);/ ]|$)",
                "model": "Aquos K $1"
            },
            {
                "regex": "704SH(?:[);/ ]|$)",
                "model": "Simple Smartphone 4"
            },
            {
                "regex": "(?:SH-02J|SH-04G)(?:[);/ ]|$)",
                "model": "Aquos Ever"
            },
            {
                "regex": "SH-02H(?:[);/ ]|$)",
                "model": "Aquos Compact"
            },
            {
                "regex": "30[56]SH(?:[);/ ]|$)",
                "model": "Aquos Crystal"
            },
            {
                "regex": "402SH(?:[);/ ]|$)",
                "model": "Aquos Crystal X"
            },
            {
                "regex": "403SH(?:[);/ ]|$)",
                "model": "Aquos Crystal 2"
            },
            {
                "regex": "509SH(?:[);/ ]|$)",
                "model": "Aquos 3"
            },
            {
                "regex": "NP601SH(?:[);/ ]|$)",
                "model": "Aquos 2"
            },
            {
                "regex": "(?:SHV40|SHV3[24])(?:_u)?(?:[);/ ]|$)",
                "model": "Aquos S"
            },
            {
                "regex": "702SH(?:[);/ ]|$)",
                "model": "Aquos S Basic"
            },
            {
                "regex": "SHV3[183](?:[);/ ]|$)",
                "model": "Aquos S Mini"
            },
            {
                "regex": "(?:FS8010|SH-M08|SHV43(?:-u)?|SH-01[KL])(?:[);/ ]|$)",
                "model": "Aquos S2"
            },
            {
                "regex": "FS8016(?:[);/ ]|$)",
                "model": "Aquos S2 Plus"
            },
            {
                "regex": "(?:SHV46|SH-R?M11|901SH)(?:[);/ ]|$)",
                "model": "Aquos S3 Plus"
            },
            {
                "regex": "(?:SHV44|808SH|SH-04L|SH-03G)(?:[);/ ]|$)",
                "model": "Aquos R3"
            },
            {
                "regex": "(?:FS8032|FS8015|SH-02M|SHV45(?:-U)?)(?:[);/ ]|$)",
                "model": "Aquos S3"
            },
            {
                "regex": "FS8018(?:[);/ ]|$)",
                "model": "Aquos S3 Mini"
            },
            {
                "regex": "(?:SHV48|907SH)(?:[);/ ]|$)",
                "model": "Aquos S3 Basic"
            },
            {
                "regex": "SH-RM12(?:[);/ ]|$)",
                "model": "Aquos S3 Lite"
            },
            {
                "regex": "SH-RM15(?:[);/ ]|$)",
                "model": "Aquos S4 Lite"
            },
            {
                "regex": "SH-51A(?:[);/ ]|$)",
                "model": "Aquos R5G"
            },
            {
                "regex": "SHV3[57](?:_u)?(?:[);/ ]|$)",
                "model": "Aquos U"
            },
            {
                "regex": "TG-L900S(?:[);/ ]|$)",
                "model": "Luna S"
            },
            {
                "regex": "SH-A01(?:[);/ ]|$)",
                "model": "B10"
            },
            {
                "regex": "(?:FS8002|SHV47)(?:[);/ ]|$)",
                "model": "Z2"
            },
            {
                "regex": "FS8009(?:[);/ ]|$)",
                "model": "Z3"
            },
            {
                "regex": "FS8028(?:[);/ ]|$)",
                "model": "R1S"
            },
            {
                "regex": "SHV36(?:[);/ ]|$)",
                "model": "Basio 2"
            },
            {
                "regex": "SW001SH(?:[);/ ]|$)",
                "model": "Star Wars"
            },
            {
                "regex": "SH-RM02",
                "model": "Aquos SH-RM02"
            },
            {
                "regex": "401SH",
                "model": "Aquos 401SH"
            },
            {
                "regex": "DM-01J",
                "model": "Disney Mobile DM-01J"
            },
            {
                "regex": "A001SH",
                "model": "Simple Sumaho 5"
            },
            {
                "regex": "NP80[56]SH",
                "model": "Aquos Keitai 3"
            },
            {
                "regex": "NP807SH",
                "model": "Aquos Keitai 10"
            },
            {
                "regex": "NP501SH",
                "model": "Aquos Keitai"
            },
            {
                "regex": "SH-08E(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Sharp Aquos Pad"
            },
            {
                "regex": "d-41A(?:[);/ ]|$)",
                "device": "tablet",
                "model": "dtab d-41A"
            },
            {
                "regex": "(LC-(?:[0-9]{2})[a-z0-9]+)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "SHARP-AQUOS|AQUOSBrowser",
                "device": "tv",
                "model": "Aquos Net Plus"
            },
            {
                "regex": "SHARP[ \\-]([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "(?:SHARP|SBM)([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(SH-?[0-9]+[a-z]?)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Simply": {
        "regex": "(NP602SI)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Softbank": {
        "regex": "Softbank|J-PHONE",
        "device": "smartphone",
        "models": [
            {
                "regex": "Softbank/[12]\\.0/([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "([a-z0-9]+);Softbank;",
                "model": "$1"
            },
            {
                "regex": "J-PHONE/[0-9]\\.[0-9]/([a-z0-9\\-]+)",
                "model": "$1"
            }
        ]
    },
    "Sonim": {
        "regex": "Sonim[ -]|XP(?:[67]7|88)00(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Sonim-XP3400",
                "model": "XP3400",
                "device": "feature phone"
            },
            {
                "regex": "XP6700(?:[);/ ]|$)",
                "model": "XP6700"
            },
            {
                "regex": "XP7700(?:[);/ ]|$)",
                "model": "XP7700"
            },
            {
                "regex": "XP8800(?:[);/ ]|$)",
                "model": "XP8"
            }
        ]
    },
    "Star": {
        "regex": "N(9[5678]00|8800|9000|9977)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "N9000",
                "model": "Note 3"
            },
            {
                "regex": "N(9[5678]00|8800|9977)(?:[);/ ]|$)",
                "model": "N$1"
            }
        ]
    },
    "Starmobile": {
        "regex": "(?:Starmobile (?:Play (?:Neo|Spark|GO|Click))|UP[_ ](?:Sense|Rave|Groove|Prime|Selfie|Xtreme|XL))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Starmobile PLAY GO(?:[);/ ]|$)",
                "model": "Play Go"
            },
            {
                "regex": "Starmobile Play (Neo|Spark|Click)(?:[);/ ]|$)",
                "model": "Play $1"
            },
            {
                "regex": "UP[_ ](Sense|Rave|Groove|Prime|Selfie|Xtreme|XL)(?:[);/ ]|$)",
                "model": "UP $1"
            }
        ]
    },
    "Amazon": {
        "regex": "KF(?:OT|ONWI|TT|JWI|JWA|[DFS]OWI|A[PRSU]WI|T[BH]WI|SAW[IA]|GIWI|KAWI|MAWI|MEWI|MUWI|SUWI)(?:[);/ ]|$)|Kindle|Silk/\\d+\\.\\d+|AlexaMediaPlayer|Amazon (?:Tate|Jem)|AFT[ABMNRST]|SD4930UR|AEO(BC|KN)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "AFTA",
                "model": "Fire TV Cube (Gen 1)",
                "device": "tv"
            },
            {
                "regex": "AFTR",
                "model": "Fire TV Cube (Gen 2)",
                "device": "tv"
            },
            {
                "regex": "AFTN",
                "model": "Fire TV (Gen 3)",
                "device": "tv"
            },
            {
                "regex": "AFTB",
                "model": "Fire TV",
                "device": "tv"
            },
            {
                "regex": "AFT[MST]",
                "model": "Fire TV stick",
                "device": "tv"
            },
            {
                "regex": "KFFOWI(?:[);/ ]|$)",
                "model": "Fire 7\""
            },
            {
                "regex": "KFMUWI(?:[);/ ]|$)",
                "model": "Fire 7\" (2019)"
            },
            {
                "regex": "KFTT(?:[);/ ]|$)",
                "model": "Kindle Fire HD"
            },
            {
                "regex": "KFJWI(?:[);/ ]|$)|Amazon Jem",
                "model": "Kindle Fire HD 8.9\" WiFi"
            },
            {
                "regex": "KFJWA(?:[);/ ]|$)",
                "model": "Kindle Fire HD 8.9\" 4G"
            },
            {
                "regex": "KFSOWI(?:[);/ ]|$)|Amazon Tate",
                "model": "Kindle Fire HD 7\" WiFi"
            },
            {
                "regex": "KFTHWI(?:[);/ ]|$)",
                "model": "Kindle Fire HDX 7\" WiFi"
            },
            {
                "regex": "KFTHWA(?:[);/ ]|$)",
                "model": "Kindle Fire HDX 7\" 4G"
            },
            {
                "regex": "KFAPWI(?:[);/ ]|$)",
                "model": "Kindle Fire HDX 8.9\" WiFi"
            },
            {
                "regex": "KFAPWA(?:[);/ ]|$)",
                "model": "Kindle Fire HDX 8.9\" 4G"
            },
            {
                "regex": "KFARWI(?:[);/ ]|$)",
                "model": "Fire HD 6"
            },
            {
                "regex": "KFASWI(?:[);/ ]|$)",
                "model": "Fire HD 7"
            },
            {
                "regex": "KFAUWI(?:[);/ ]|$)",
                "model": "Fire HD 7 (2017)"
            },
            {
                "regex": "KFMEWI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2015)"
            },
            {
                "regex": "KFGIWI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2016)"
            },
            {
                "regex": "KFDOWI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2017)"
            },
            {
                "regex": "KFKAWI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2018)"
            },
            {
                "regex": "KFONWI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2020)"
            },
            {
                "regex": "KFSAWI(?:[);/ ]|$)",
                "model": "Fire HDX 8.9"
            },
            {
                "regex": "KFSAWA(?:[);/ ]|$)",
                "model": "Fire HDX 8.9 4G"
            },
            {
                "regex": "KFTBWI(?:[);/ ]|$)",
                "model": "Fire HD 10"
            },
            {
                "regex": "KFSUWI(?:[);/ ]|$)",
                "model": "Fire HD 10 (2017)"
            },
            {
                "regex": "KFMAWI(?:[);/ ]|$)",
                "model": "Fire HD 10 (2019)"
            },
            {
                "regex": "SD4930UR",
                "model": "Fire Phone",
                "device": "smartphone"
            },
            {
                "regex": "KFOT|Kindle Fire|Silk/\\d+\\.\\d+",
                "model": "Kindle Fire"
            },
            {
                "regex": "Kindle",
                "model": "Kindle"
            },
            {
                "regex": "AEO(BC|KN)(?:[);/ ]|$)",
                "model": "Echo",
                "device": "smart speaker"
            },
            {
                "regex": "AlexaMediaPlayer",
                "model": "Alexa",
                "device": "smart speaker"
            }
        ]
    },
    "Symphony": {
        "regex": "SYMPHONY[ \\_]([a-z0-9]+)|(?:roar[ _](?:V20|V78|E80|V150))|roarV95|ZVIII(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZVIII",
                "model": "ZVIII"
            },
            {
                "regex": "roar[ _]?(V20|E80|V78|V95|V150)(?:[);/ ]|$)",
                "model": "Roar $1"
            },
            {
                "regex": "SYMPHONY[ \\_]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Helio": {
        "regex": "Helio (S60|S5)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Syrox": {
        "regex": "(SYX-(?:T70[04]|T10[12]))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Qtek": {
        "regex": "Qtek[ _]?([a-z0-9]+)",
        "device": "smartphone",
        "model": "$1"
    },
    "Q-Touch": {
        "regex": "( Q09|QS701|Q05A)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "G-Touch": {
        "regex": "GTouch[_ ]|(?:Stella (?:XS?|Omega))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Stella (XS?|Omega)",
                "model": "Stella $1"
            },
            {
                "regex": "GTouch[_ ]STELLA",
                "model": "Stella"
            }
        ]
    },
    "T-Mobile": {
        "regex": "T-Mobile[ _][a-z0-9 ]+|(?:REVVLRY|REVVL 2(?: PLUS)?|5062[ZW]|5007[ZW])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "5062[ZW]",
                "model": "REVVL 4 Plus"
            },
            {
                "regex": "5007[ZW]",
                "model": "REVVL 4"
            },
            {
                "regex": "REVVL 2 PLUS",
                "model": "REVVL 2 Plus"
            },
            {
                "regex": "REVVLRY",
                "model": "REVVL Plus"
            },
            {
                "regex": "REVVL 2(?:[);/ ]|$)",
                "model": "REVVL 2"
            },
            {
                "regex": "T-Mobile[ _]([a-z0-9_ ]+) Build",
                "model": "$1"
            },
            {
                "regex": "T-Mobile[ _]([a-z0-9_ ]+)",
                "model": "$1"
            }
        ]
    },
    "TB Touch": {
        "regex": "Ignis [89]",
        "device": "tablet",
        "models": [
            {
                "regex": "Ignis ([89])",
                "model": "Ignis $1"
            }
        ]
    },
    "Teclast": {
        "regex": "Teclast|TLA002|TLA016|X98 Air III|M20_4G|X98 Air II\\(HG5N\\)|Tbook|X80 Power\\(B2N4\\)|(?:T30|P80X|P20HD|P10_HD|M40)_(?:ROW|EEA)|T10\\(E3C6\\)|P10S\\(N4H5\\)|98\\(M1E[45789]\\)|98\\(M3E3\\)",
        "device": "tablet",
        "models": [
            {
                "regex": "Tbook[_ -]([^;/]+) Build",
                "model": "Tbook $1"
            },
            {
                "regex": "T10\\(E3C6\\)",
                "model": "T10"
            },
            {
                "regex": "T30_(ROW|EEA)",
                "model": "T30 $1"
            },
            {
                "regex": "P80X_(ROW|EEA)",
                "model": "P80X $1"
            },
            {
                "regex": "P10S\\(N4H5\\)",
                "model": "P10S"
            },
            {
                "regex": "P20HD_(?:ROW|EEA)",
                "model": "P20HD"
            },
            {
                "regex": "M40_(?:ROW|EEA)",
                "model": "M40"
            },
            {
                "regex": "P10_HD_(?:ROW|EEA)",
                "model": "P10HD"
            },
            {
                "regex": "M20_4G",
                "model": "M20 4G"
            },
            {
                "regex": "TLA002",
                "model": "M30 4G"
            },
            {
                "regex": "TLA016",
                "model": "M16"
            },
            {
                "regex": "98\\(M1E[45789]\\)|98\\(M3E3\\)",
                "model": "TPad 98 10.1\" 4G"
            },
            {
                "regex": "X80 Power\\(B2N4\\)(?:[);/ ]|$)",
                "model": "X98 Power"
            },
            {
                "regex": "X98 Air III(?:[);/ ]|$)",
                "model": "X98 Air III"
            },
            {
                "regex": "X98 Air II\\(HG5N\\)(?:[);/ ]|$)",
                "model": "X98 Air II"
            },
            {
                "regex": "Teclast[_ -]([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Tecno Mobile": {
        "regex": "Tecno|Phantom6|Phantom6-Plus|DP7C Pro-SGA1",
        "device": "smartphone",
        "models": [
            {
                "regex": "Phantom6-Plus",
                "model": "Phantom 6 Plus"
            },
            {
                "regex": "Phantom6",
                "model": "Phantom 6"
            },
            {
                "regex": "TECNO-W3",
                "model": "W3"
            },
            {
                "regex": "TECNO[ _]F4 Pro(?:[);/ ]|$)",
                "model": "F4 Pro"
            },
            {
                "regex": "TECNO[ _]KE5j(?:[);/ ]|$)",
                "model": "Spark 6 Go"
            },
            {
                "regex": "TECNO[ _]ID6(?:[);/ ]|$)",
                "model": "Camon iClick 2"
            },
            {
                "regex": "Tecno[ _]7C(?:[);/ ]|$)",
                "model": "DroidPad 7C",
                "device": "tablet"
            },
            {
                "regex": "DP7C Pro-SGA1(?:[);/ ]|$)",
                "model": "DroidPad 7C Pro",
                "device": "tablet"
            },
            {
                "regex": "TECNO[ _]DP10A Pro(?:[);/ ]|$)",
                "model": "DroidPad 10A Pro",
                "device": "tablet"
            },
            {
                "regex": "TECNO[ _]P904(?:[);/ ]|$)",
                "model": "DroidPad 10D 4G",
                "device": "tablet"
            },
            {
                "regex": "Tecno[ _]CB7[j]?",
                "model": "Camon i4"
            },
            {
                "regex": "Tecno[ _]CF7(?:[);/ ]|$)",
                "model": "Camon 11"
            },
            {
                "regex": "Tecno[ _]CC6(?:[);/ ]|$)",
                "model": "Camon 12 Air"
            },
            {
                "regex": "Tecno[ _]CC7(?:[);/ ]|$)",
                "model": "Camon 12"
            },
            {
                "regex": "Tecno[ _]KC8(?:[);/ ]|$)",
                "model": "Spark 4"
            },
            {
                "regex": "Tecno[ _]BB4k(?:[);/ ]|$)",
                "model": "Spark 4 Lite"
            },
            {
                "regex": "Tecno[ _]KD7(?:[);/ ]|$)",
                "model": "Spark 5 Pro"
            },
            {
                "regex": "Tecno[ _]DP8D(?:[);/ ]|$)",
                "model": "DroidPad 8D",
                "device": "tablet"
            },
            {
                "regex": "Tecno[ _]LB8",
                "model": "Pouvoir 3 Plus"
            },
            {
                "regex": "TECNO S9",
                "device": "phablet",
                "model": "S9"
            },
            {
                "regex": "Tecno ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Tecno[ _]?([a-z0-9_\\-]+)",
                "model": "$1"
            }
        ]
    },
    "TechPad": {
        "regex": "Tech ?pad|XTAB[ _-]|Dual C1081HD|S813G",
        "device": "tablet",
        "models": [
            {
                "regex": "S813G",
                "model": "S813G"
            },
            {
                "regex": "TechPad10QC",
                "model": "10QC"
            },
            {
                "regex": "TechPad_10xx",
                "model": "10XX"
            },
            {
                "regex": "TechPad703",
                "model": "703"
            },
            {
                "regex": "TechPad[_ ](10Y|9x|i700)",
                "model": "$1"
            },
            {
                "regex": "TechPad[_ ]3Gx",
                "model": "3Gx"
            },
            {
                "regex": "Dual C1081HD",
                "model": "XTAB C1081HD"
            },
            {
                "regex": "XTAB[ _-]([^/;]+) Build",
                "model": "XTAB $1"
            },
            {
                "regex": "Tech ?pad[ _-]([^/;)]+)(?: Build|[;)])",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "Tesco": {
        "regex": "Hudl (?:[^/;]+)(?: Build|[;)])|W032i-C3(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Hudl ([^/;]+)(?: Build|[;)])",
                "model": "Hudl $1"
            },
            {
                "regex": "W032i-C3(?:[);/ ]|$)",
                "model": "Op3n Dott"
            }
        ]
    },
    "teXet": {
        "regex": "Texet|(NaviPad [^/;]*) Build|TM-(?:1046|1058|1057|1067|3000|3200R|3500|4003|4071|450[34]|451[30]|4377|4082R|508[34]|550[358]|5010|5017|507[4-7]|5[23]77|6003|6906|702[13]|7055HD|709[69]|9747BT|9758|9751HD|9767|5513|520[410]|507[13]|558[134]|570[23]|7859|8044|9748[ _]3G|9720|7047HD[ _]3G|9757|9740|4982|4515|4083|500[3567]|5571|3204R|5016|8043|7047HD[ _]3G|8041HD|8066|705[23]|7041|8041HD|8051|8048|974[96]|973[78]W|974[170]|9743W|9750HD|7043XD|7049|7887|7037W|702[46])|TB-(771A|711A)|X-Force[\\(-]?TM-5009\\)?|X-Plus[\\(-]?TM-5577\\)?|TM_5011|X-pad (?:AIR 8|iX 7|NAVI 7.[35]|NAVI 10|SKY 8.1|STYLE 8|STYLE 10.1|HIT|LITE 7.[12]|QUAD (?:7.2|10|7)|SHINE 8.1)(?: 3G)?",
        "device": "tablet",
        "models": [
            {
                "regex": "TM-9749",
                "model": "X-pad Plus 7.1 3G"
            },
            {
                "regex": "TM-9746",
                "model": "X-pad Plus 7 3G"
            },
            {
                "regex": "TM-8051",
                "model": "X-pad Force 8i 3G"
            },
            {
                "regex": "TM-1058",
                "model": "X-Force 10 3G"
            },
            {
                "regex": "TM-8048",
                "model": "X-pad Force 8 3G"
            },
            {
                "regex": "(NaviPad [^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "TM-7055HD",
                "model": "NaviPad 3G"
            },
            {
                "regex": "TM-9758",
                "model": "X-pad Style 10.0\""
            },
            {
                "regex": "X-pad SHINE 8.1 3G",
                "model": "X-pad Shine 8.1\" 3G"
            },
            {
                "regex": "X-pad QUAD 10 3G",
                "model": "X-pad Quad 10.0\" 3G"
            },
            {
                "regex": "X-pad QUAD 7 3G",
                "model": "X-pad Quad 7.0\" 3G"
            },
            {
                "regex": "X-pad QUAD 7.2 3G",
                "model": "X-pad Quad 7.2\" 3G"
            },
            {
                "regex": "X-pad STYLE 8 3G",
                "model": "X-pad Style 8.0\" 3G"
            },
            {
                "regex": "X-pad HIT 3G",
                "model": "X-pad Hit 3G"
            },
            {
                "regex": "X-pad LITE (7.[12])",
                "model": "X-pad Lite $1\""
            },
            {
                "regex": "TM-9767",
                "model": "X-pad Style 10.0\" 3G"
            },
            {
                "regex": "X-pad STYLE 10.1 3G",
                "model": "X-pad Style 10.1\" 3G"
            },
            {
                "regex": "(X-pad (?:AIR 8|iX 7) 3G)",
                "model": "$1"
            },
            {
                "regex": "TM-7096|X-pad NAVI 7.3 3G",
                "model": "X-pad NAVI 7.3\" 3G"
            },
            {
                "regex": "TM-7099",
                "model": "X-pad NAVI 7.4\" 3G"
            },
            {
                "regex": "X-pad NAVI 7.5 3G",
                "model": "X-pad NAVI 7.5\" 3G"
            },
            {
                "regex": "X-pad SKY 8.1 3G",
                "model": "X-pad Sky 8.1\" 3G"
            },
            {
                "regex": "TM-1046|X-pad NAVI 10 3G",
                "model": "X-pad NAVI 10.0\" 3G"
            },
            {
                "regex": "TM-7859",
                "model": "X-pad NAVI 8.2\" 3G"
            },
            {
                "regex": "TM-7049",
                "model": "NaviPad TM-7049 3G"
            },
            {
                "regex": "TM-7887",
                "model": "NaviPad TM-7887 3G"
            },
            {
                "regex": "TM-8066",
                "model": "X-pad Rapid 8.2\" 4G"
            },
            {
                "regex": "(TM-(?:1057|1067|6906|8043|9748[_ ]3G|9740|9757(?:[_ ]3G)?|7047HD[ _]3G|9747BT|9751HD|702[13]|705[23]|7041|9720|7047HD[_ ]3G|8044|8041HD|973[78]W|9743W|974[710]|9750HD|7043XD|7037W|702[46])|TB-(?:771A|711A|8041HD))",
                "model": "$1"
            },
            {
                "regex": "TM-4503",
                "device": "smartphone",
                "model": "X-Quad"
            },
            {
                "regex": "(TM-(?:3000|3200R|4003|4083|4377|4504|451[30]|500[35]|5[23]77|5571|3204R|520[04]|5581|5505|5017|507[13-7]|5081|6003|5513))",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "TM-5006",
                "device": "smartphone",
                "model": "X-Line"
            },
            {
                "regex": "TM-5007",
                "device": "smartphone",
                "model": "X-Shine"
            },
            {
                "regex": "TM_5011",
                "device": "smartphone",
                "model": "X-Omega"
            },
            {
                "regex": "TM-508(3|4)",
                "device": "smartphone",
                "model": "Pay $1G"
            },
            {
                "regex": "TM-558(3|4)",
                "device": "smartphone",
                "model": "Pay 5.5\" $1G"
            },
            {
                "regex": "TM-5702",
                "device": "smartphone",
                "model": "Pay 5.7\" 3G"
            },
            {
                "regex": "TM-5703",
                "device": "smartphone",
                "model": "Pay 5.7\" Pro"
            },
            {
                "regex": "TM-5201",
                "device": "smartphone",
                "model": "Rock"
            },
            {
                "regex": "TM-4515",
                "device": "smartphone",
                "model": "X-Style"
            },
            {
                "regex": "TM-(5016|3500)",
                "device": "smartphone",
                "model": "X-Maxi 2"
            },
            {
                "regex": "TM-4071",
                "device": "smartphone",
                "model": "X-Smart"
            },
            {
                "regex": "TM-4982",
                "device": "smartphone",
                "model": "iX-Maxi"
            },
            {
                "regex": "TEXET[_ ]IX-MINI",
                "device": "smartphone",
                "model": "iX-Mini"
            },
            {
                "regex": "TM-5010",
                "device": "smartphone",
                "model": "X-Selfie"
            },
            {
                "regex": "TM-4082R",
                "device": "smartphone",
                "model": "X-Driver Quad"
            },
            {
                "regex": "TM-5503",
                "device": "smartphone",
                "model": "X-Mage"
            },
            {
                "regex": "TM-5508",
                "device": "smartphone",
                "model": "X-Cosmo"
            },
            {
                "regex": "X-Force[\\(-]?TM-5009\\)?",
                "device": "smartphone",
                "model": "X-Force"
            },
            {
                "regex": "X-Plus[\\(-]?TM-5577\\)?",
                "device": "smartphone",
                "model": "X-Plus"
            },
            {
                "regex": "teXet[_ ]X-medium[_ ]plus",
                "device": "smartphone",
                "model": "X-Medium Plus"
            }
        ]
    },
    "Telefunken": {
        "regex": "TELEFUNKEN|Foxtrot|TEL-1013GIQA|TF-SP(?:500[12]|4002)|(TF-MID(?:[78]02G|70[78]G|80[46]G|9705RG|9707G|7805G|100[57]G|1010G))|(TF-LED(?:65S75T2SU|32S39T2S|32S5[289]T2S|32S70T2S|40S63T2S))",
        "device": "tablet",
        "models": [
            {
                "regex": "TEL-1013GIQA",
                "model": "Giqa 10.1 3G"
            },
            {
                "regex": "Foxtrot2",
                "model": "Foxtrot 2",
                "device": "smartphone"
            },
            {
                "regex": "(?:TELEFUNKEN)?(TF-SP(?:500[12]|4002)|Outdoor LTE|Foxtrot)",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "(TF-MID(?:[78]02G|70[78]G|80[46]G|9705RG|9707G|7805G|100[57]G|1010G))",
                "model": "$1"
            },
            {
                "regex": "(TF-LED(?:65S75T2SU|32S39T2S|32S5[289]T2S|32S70T2S|40S63T2S))",
                "model": "$1",
                "device": "tv"
            }
        ]
    },
    "Telego": {
        "regex": "TELEGO",
        "device": "smartphone",
        "models": [
            {
                "regex": "TELEGO-W503",
                "model": "W503"
            },
            {
                "regex": "Telego_JOY2",
                "model": "Joy 2"
            },
            {
                "regex": "Telego[ _]Mate",
                "model": "Mate"
            }
        ]
    },
    "Telenor": {
        "regex": "(?<!FBCR/)Telenor|Infinity E5",
        "device": "smartphone",
        "models": [
            {
                "regex": "Telenor[ _]([^;/]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "Infinity E5",
                "model": "Infinity E5"
            }
        ]
    },
    "Telit": {
        "regex": "Telit",
        "device": "feature phone",
        "models": [
            {
                "regex": "Telit_Mobile_Terminals-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Telit[\\-_]?([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "ThL": {
        "regex": "ThL[ _-]|Knight 2",
        "device": "smartphone",
        "models": [
            {
                "regex": "Knight 2",
                "model": "Knight 2"
            },
            {
                "regex": "ThL[ _-]*([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "ThL[ _-]*([^ ;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "TIANYU": {
        "regex": "TIANYU",
        "device": "feature phone",
        "models": [
            {
                "regex": "TIANYU ([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "TIANYU-KTOUCH/([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Timovi": {
        "regex": "Tmovi[ _]|(?:Infinit_Lite_2|Vision_PRO|VISION ULTRA|Epix)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Tmovi[ _]Prime",
                "model": "Prime"
            },
            {
                "regex": "TMOVI_YEAH_BEAT",
                "model": "Yeah Beat"
            },
            {
                "regex": "YeahLIVE",
                "model": "Yeah LIVE"
            },
            {
                "regex": "Infinit Lite",
                "model": "Infinit Lite"
            },
            {
                "regex": "Infinit_Lite_2",
                "model": "Infinit Lite 2"
            },
            {
                "regex": "Vision_PRO",
                "model": "Vision Pro"
            },
            {
                "regex": "VISION ULTRA",
                "model": "Vision Ultra"
            },
            {
                "regex": "Epix",
                "model": "Epix"
            }
        ]
    },
    "Tooky": {
        "regex": "TOOKY",
        "device": "smartphone",
        "models": [
            {
                "regex": "TOOKY (A19|W1|T8[368]|T1982)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "TOOKY A9PLUS(?:[);/ ]|$)",
                "model": "A9 Plus"
            }
        ]
    },
    "Tolino": {
        "regex": "Tolino Tab ([^/;]+) Build",
        "device": "tablet",
        "model": "Tolino Tab $1"
    },
    "Top House": {
        "regex": "Coto[_ ]|X1013",
        "device": "smartphone",
        "models": [
            {
                "regex": "Coto W418",
                "model": "Coto W418"
            },
            {
                "regex": "COTO_T117",
                "model": "Coto T117",
                "device": "tablet"
            },
            {
                "regex": "X1013",
                "model": "X1013",
                "device": "tablet"
            },
            {
                "regex": "COTO_T40017",
                "model": "T40017"
            }
        ]
    },
    "Toplux": {
        "regex": "Toplux ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Touchmate": {
        "regex": "TOUCHMATE|(TM-(?:MID1050WKD|MID1020A|MID794C|MID795|MID710|MID798|MID792|MID788D|SM500N|SM410|MID1010))",
        "device": "smartphone",
        "models": [
            {
                "regex": "(TM-(?:MID1020A|MID794C|MID795|MID710|MID798|MID792|MID788D|MID1010))",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "TM-MID1050WKD",
                "device": "tablet",
                "model": "Mega Matrix 10.1\" 3G"
            },
            {
                "regex": "(TM-(?:SM500N|SM410))",
                "model": "$1"
            },
            {
                "regex": "Touchmate ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "TrekStor": {
        "regex": "(?:TrekStor|Surftab) ([^/;]+)(?: Build|\\))|Surftab[^;\\)]*(?:[;\\)]|$)|ST10216-2A|ST13416-1|VT10416-[12]|TFMTKAW01232",
        "device": "tablet",
        "models": [
            {
                "regex": "ST10216-2A|VT10416-[12]",
                "model": "SurfTab 10.1"
            },
            {
                "regex": "ST13416-1",
                "model": "SurfTab Theatre 13.4\""
            },
            {
                "regex": "PrimeTab P10",
                "model": "PrimeTab P10"
            },
            {
                "regex": "TrekStor ([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Surftab ([^/;]+) Build",
                "model": "SurfTab $1"
            },
            {
                "regex": "Surftab[ _]([^;\\)]*)(?:[;\\)]|$)",
                "model": "SurfTab $1"
            },
            {
                "regex": "TFMTKAW01232",
                "model": "SurfTab L15"
            }
        ]
    },
    "Trevi": {
        "regex": "Trevi[ _]|TAB[ _]10[ _]3G[ _]V16|TAB[ _](7|8)[ _]3G[ _]V8|TAB9 3G|MINITAB 3GV|Phablet[ _](?:4|4\\.5|5|5\\,3|6)[ _]?[CSQ]|REVERSE[ _]5\\.5[ _]?Q",
        "device": "tablet",
        "models": [
            {
                "regex": "TAB[ _]?(7|8)[ _]3G[ _]V8",
                "model": "TAB $1 3G V8"
            },
            {
                "regex": "TAB[ _]?9[ _]3G[ _]V8",
                "model": "TAB 9 3G V8"
            },
            {
                "regex": "TAB[ _]?9[ _]3G",
                "model": "TAB 9 3G"
            },
            {
                "regex": "TAB[ _]10[ _]3G[ _]V16",
                "model": "TAB 10 3G V16"
            },
            {
                "regex": "MINITAB 3GV",
                "model": "MINITAB 3G V"
            },
            {
                "regex": "(?:Trevi_)?Phablet[ _]4[ _]?C",
                "model": "Phablet 4 C",
                "device": "smartphone"
            },
            {
                "regex": "(?:Trevi_)?Phablet[ _]4[ _]?S",
                "model": "Phablet 4 S",
                "device": "smartphone"
            },
            {
                "regex": "(?:Trevi_)?Phablet[ _]4.5[ _]?Q",
                "model": "Phablet 4.5Q",
                "device": "smartphone"
            },
            {
                "regex": "(?:Trevi_)?PHABLET[ _]5[ _]?S",
                "model": "Phablet 5 S",
                "device": "smartphone"
            },
            {
                "regex": "(?:Trevi_)?PHABLET[ _]5,3[ _]?Q",
                "model": "Phablet 5.3 Q",
                "device": "phablet"
            },
            {
                "regex": "(?:Trevi_)?REVERSE[ _]5.5[ _]?Q",
                "model": "Phablet 5.5 Q REVERSE",
                "device": "phablet"
            },
            {
                "regex": "(?:Trevi_)?PHABLET[ _]6[ _]?S",
                "model": "Phablet 6 S",
                "device": "phablet"
            },
            {
                "regex": "Trevi[_]([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "TVC": {
        "regex": "(NuclearSX-SP5)",
        "device": "smartphone",
        "model": "Nuclear SX-SP5"
    },
    "U.S. Cellular": {
        "regex": "USCC-",
        "device": "smartphone",
        "models": [
            {
                "regex": "USCC-E6762",
                "model": "Kyocera DuraForce"
            },
            {
                "regex": "(USCC-[a-z0-9_\\-]+)",
                "model": "$1"
            }
        ]
    },
    "Uhappy": {
        "regex": "Uhappy|UP?580|UP350|UP[35679]20",
        "device": "smartphone",
        "models": [
            {
                "regex": "UP([35679]20)",
                "model": "UP$1"
            },
            {
                "regex": "UP350",
                "model": "UP350"
            },
            {
                "regex": "UP580",
                "model": "UP580"
            },
            {
                "regex": "U580",
                "model": "U580"
            },
            {
                "regex": "Uhappy[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Uhappy[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Unimax": {
        "regex": "U((?:67[013]|680)C|(?:452|504)TL|683CL|693CL)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "U$1"
    },
    "Unowhy": {
        "regex": "QOOQ ",
        "device": "tablet",
        "model": "QOOQ"
    },
    "UTStarcom": {
        "regex": "utstar[ _-]?([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Ulefone": {
        "regex": "Ulefone|Gemini Pro|Power_[356]|S10_Pro|(?:Note [89]P|Armor(?:[ _](?:[2367]|2S|X[236]|6[SE]|3WT|3W|X))?|U00[78][ _]Pro|Be[ _]X|Be[ _]Touch(?:[ _][23])?|Be[ _](?:One|Pure)(?:[ _]Lite)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S10_Pro",
                "model": "S10 Pro"
            },
            {
                "regex": "Be[ _]Touch([ _][23])?",
                "model": "Be Touch$1"
            },
            {
                "regex": "Be[ _]Pure[ _]Lite",
                "model": "Be Pure Lite"
            },
            {
                "regex": "Be[ _]Pure",
                "model": "Be Pure"
            },
            {
                "regex": "Be[ _]One[ _]Lite",
                "model": "Be One Lite"
            },
            {
                "regex": "Be[ _]One",
                "model": "Be One"
            },
            {
                "regex": "Be[ _]X",
                "model": "Be X"
            },
            {
                "regex": "U007 Pro",
                "model": "U007 Pro"
            },
            {
                "regex": "U008 Pro",
                "model": "U008 Pro"
            },
            {
                "regex": "Armor[ _]X([236])(?:[);/ ]|$)",
                "model": "Armor X$1"
            },
            {
                "regex": "Armor[ _]6S(?:[);/ ]|$)",
                "model": "Armor 6S"
            },
            {
                "regex": "Armor[ _]([679])E(?:[);/ ]|$)",
                "model": "Armor $1E"
            },
            {
                "regex": "Armor[ _]X([57]) Pro(?:[);/ ]|$)",
                "model": "Armor X$1 Pro"
            },
            {
                "regex": "Armor[ _]X([578])(?:[);/ ]|$)",
                "model": "Armor X$1"
            },
            {
                "regex": "Armor[ _]([25])S(?:[);/ ]|$)",
                "model": "Armor $1S"
            },
            {
                "regex": "Armor[ _]X(?:[);/ ]|$)",
                "model": "Armor X"
            },
            {
                "regex": "Armor[ _]3W(?:[);/ ]|$)",
                "model": "Armor 3W"
            },
            {
                "regex": "Armor[ _]3WT(?:[);/ ]|$)",
                "model": "Armor 3WT"
            },
            {
                "regex": "Armor[ _]([236789])(?:[);/ ]|$)",
                "model": "Armor $1"
            },
            {
                "regex": "Armor(?:[);/ ]|$)",
                "model": "Armor"
            },
            {
                "regex": "Gemini Pro(?:[);/ ]|$)",
                "model": "Gemini Pro"
            },
            {
                "regex": "Power[_ ]([356])",
                "model": "Power $1"
            },
            {
                "regex": "Note 8P(?:[);/ ]|$)",
                "model": "Note 8P"
            },
            {
                "regex": "Note 9P(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Note 9P"
            },
            {
                "regex": "Ulefone[_ ](X|S1[ _]Pro|S[17])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Ulefone[ _-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Ulefone[ _-]?([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "UMIDIGI": {
        "regex": "UMI(?:DIGI)?[ _]|(?:A5_Pro|ROME[_ ]X|BISON|hammer_S)(?:[;/) ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A5_Pro",
                "model": "A5 Pro"
            },
            {
                "regex": "UMI TOUCH X",
                "model": "Touch X"
            },
            {
                "regex": "UMI TOUCH",
                "model": "Touch"
            },
            {
                "regex": "ROME[_ ]X",
                "model": "Rome X"
            },
            {
                "regex": "BISON",
                "model": "Bison"
            },
            {
                "regex": "hammer_S",
                "model": "Hammer S"
            },
            {
                "regex": "UMI_(London|Diamond(?:_X)?)",
                "model": "$1"
            },
            {
                "regex": "UMI(?:DIGI)?[ _]([^/;)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Uniscope": {
        "regex": "Uniscope",
        "device": "smartphone",
        "models": [
            {
                "regex": "Uniscope[ _\\-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Uniscope[ _\\-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Unnecto": {
        "regex": "Unnecto|(?:U513|U5151|U61[1356]|U7[12]0|U-830|U90[35])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "U513",
                "model": "Drone XT"
            },
            {
                "regex": "U5151",
                "model": "Bolt"
            },
            {
                "regex": "U611",
                "model": "Quattro X"
            },
            {
                "regex": "U613",
                "model": "Quattro S"
            },
            {
                "regex": "U615",
                "model": "Quattro M"
            },
            {
                "regex": "U616",
                "model": "U616"
            },
            {
                "regex": "U710",
                "model": "Quattro U710"
            },
            {
                "regex": "U720",
                "model": "Quattro Z"
            },
            {
                "regex": "U-830",
                "model": "Rush"
            },
            {
                "regex": "U903",
                "model": "Air"
            },
            {
                "regex": "U905",
                "model": "Air 5.5"
            }
        ]
    },
    "Unonu": {
        "regex": "Unonu[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Unonu[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Unonu[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "UTOK": {
        "regex": "UTOK (45[01]D)",
        "device": "smartphone",
        "model": "$1"
    },
    "Vastking": {
        "regex": "(M910A|M783K|M783K-16G|M1072R-3G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "ViewSonic": {
        "regex": "ViewSonic|VSD[0-9]+(?:[);/ ]|$)|ViewPad|ViewPhone",
        "device": "smart display",
        "models": [
            {
                "regex": "(?:ViewSonic-)?V500(?:[);/ ]|$)",
                "model": "V500",
                "device": "smartphone"
            },
            {
                "regex": "ViewSonic A8\\+(?:[);/ ]|$)",
                "model": "A8 Plus",
                "device": "smartphone"
            },
            {
                "regex": "(?:ViewSonic-)?ViewPhone ?([^;/]+) Build",
                "model": "ViewPhone $1",
                "device": "smartphone"
            },
            {
                "regex": "(?:ViewSonic-)?ViewPad ?([^;/]+) Build",
                "model": "ViewPad $1",
                "device": "tablet"
            },
            {
                "regex": "(VSD[0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Vitelcom": {
        "regex": "Vitelcom|portalmmm/[12].0 TSM",
        "device": "feature phone",
        "models": [
            {
                "regex": "TSM-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "TSM([a-z0-9\\-]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/[12].0 (TSM[a-z0-9 ]+)",
                "model": "$1"
            }
        ]
    },
    "Fengxiang": {
        "regex": "(vKB011B|vKB004L)",
        "device": "tablet",
        "model": "$1"
    },
    "VK Mobile": {
        "regex": "VK-VK([79]00)(?:[);/ ]|$)",
        "device": "feature phone",
        "model": "VK$1"
    },
    "Vernee": {
        "regex": "Vernee|Mars Pro|Apollo[ _](?:Lite|X)|Thor (?:E|Plus)|X2_euro",
        "device": "smartphone",
        "models": [
            {
                "regex": "Apollo[ _]Lite",
                "model": "Apollo Lite"
            },
            {
                "regex": "Apollo[ _]X",
                "model": "Apollo X"
            },
            {
                "regex": "Mars Pro",
                "model": "Mars Pro"
            },
            {
                "regex": "Thor E",
                "model": "Thor E"
            },
            {
                "regex": "Thor Plus",
                "model": "Thor Plus"
            },
            {
                "regex": "Vernee_M5",
                "model": "M5"
            },
            {
                "regex": "X2_euro",
                "model": "X2"
            },
            {
                "regex": "Vernee[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Vernee[ _-]([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Vertu": {
        "regex": "Vertu[ ]?([a-z0-9]+)|(?:ASTER P|CONSTELLATION X)(?:[);/ ]|$)",
        "device": "feature phone",
        "models": [
            {
                "regex": "ASTER P(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Aster P"
            },
            {
                "regex": "CONSTELLATION X(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Constellation X"
            },
            {
                "regex": "Vertu[ ]?([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Venso": {
        "regex": "(?:CX-508|CX-551|Reiv 500|Creon F5|Isprit U50|Isprit-U50-LTE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Isprit U50|Isprit-U50-LTE",
                "model": "Isprit U50"
            },
            {
                "regex": "(CX-508|CX-551|Reiv 500|Creon F5)",
                "model": "$1"
            }
        ]
    },
    "Verizon": {
        "regex": "QTA(SUN[12]|XIA1|QZ3|QZ3KID|IR7)|QMV7B",
        "device": "tablet",
        "models": [
            {
                "regex": "QTAXIA1|QTAIR7",
                "model": "Ellipsis 10"
            },
            {
                "regex": "QTASUN1",
                "model": "Ellipsis 8 HD"
            },
            {
                "regex": "QTASUN2",
                "model": "Ellipsis 8 HD 4G LTE"
            },
            {
                "regex": "QTAQZ3KID",
                "model": "Ellipsis Kids LTE"
            },
            {
                "regex": "QTAQZ3",
                "model": "Ellipsis 8"
            },
            {
                "regex": "QMV7B",
                "model": "Ellipsis 7"
            }
        ]
    },
    "Verykool": {
        "regex": "verykool",
        "device": "smartphone",
        "models": [
            {
                "regex": "verykoolS5004",
                "model": "Lotus JR."
            },
            {
                "regex": "verykoolS5005",
                "model": "Lotus II"
            },
            {
                "regex": "verykool[ _]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "verykool[ _]?([^/;]+);",
                "model": "$1"
            }
        ]
    },
    "Vestel": {
        "regex": "Vestel[ _]|Venus[ _](GO|E[2-5]|V[1-9]|Z[1-9]0)|(?<!Winnovo )V_?TAB|VP74|VT97PRO|VSP145M|VSP250[GS]|VSP355[GS]|V3_5580_Dual",
        "device": "smartphone",
        "models": [
            {
                "regex": "VT97PRO",
                "model": "VTab 9.7 Pro",
                "device": "tablet"
            },
            {
                "regex": "VP74",
                "model": "VTab Lite II",
                "device": "tablet"
            },
            {
                "regex": "VTAB10",
                "model": "VTab 10",
                "device": "tablet"
            },
            {
                "regex": "V_TAB_7_ECO_III ",
                "model": "VTab 7 Eco 3",
                "device": "tablet"
            },
            {
                "regex": "V_TAB_([0-9]{4}[A-Z]?)",
                "model": "VTab $1",
                "device": "tablet"
            },
            {
                "regex": "V3_5580_Dual",
                "model": "Venus V3 5580 Dual"
            },
            {
                "regex": "VSP145M",
                "model": "Venus 4.5"
            },
            {
                "regex": "VSP250G",
                "model": "Venus 5.0V"
            },
            {
                "regex": "VSP250S",
                "model": "Venus 5.0X"
            },
            {
                "regex": "VSP355G",
                "model": "Venus 5.5V"
            },
            {
                "regex": "VSP355S",
                "model": "Venus 5.5X"
            },
            {
                "regex": "Venus[ _]V([1-9])",
                "model": "Venus V$1"
            },
            {
                "regex": "Venus[ _]Z([1-9]0)",
                "model": "Venus Z$1"
            },
            {
                "regex": "Venus[ _]GO",
                "model": "Venus Go"
            },
            {
                "regex": "Venus E2 Plus Dual",
                "model": "Venus E2 Plus Dual"
            },
            {
                "regex": "Venus[ _]E2 Plus",
                "model": "Venus E2 Plus"
            },
            {
                "regex": "Venus[ _]E([345])",
                "model": "Venus E$1"
            },
            {
                "regex": "Vestel_5000_Dual",
                "model": "5000 Dual"
            },
            {
                "regex": "Vestel_5000_2gb",
                "model": "5000 2GB"
            },
            {
                "regex": "Vestel[ _](5000|5530)",
                "model": "$1"
            }
        ]
    },
    "Videocon": {
        "regex": "Videocon[_ \\-]|(?:VT75C|V406018|V512930|V50(?:2430|3630|5024|5430|4630|5[98]20)|Z45_(?:Dazzle|Amaze)|Z45Q Star|Z50 Nova)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Videocon_V1585",
                "device": "feature phone",
                "model": "V1585"
            },
            {
                "regex": "Videocon[_ \\-]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "VT75C(?:[);/ ]|$)",
                "model": "VT75C",
                "device": "tablet"
            },
            {
                "regex": "V502430(?:[);/ ]|$)",
                "model": "Kryton 3"
            },
            {
                "regex": "V505024(?:[);/ ]|$)",
                "model": "Kryton 22 Plus"
            },
            {
                "regex": "V503630(?:[);/ ]|$)",
                "model": "Delite 11"
            },
            {
                "regex": "V505920(?:[);/ ]|$)",
                "model": "Metal Pro 2"
            },
            {
                "regex": "V505820(?:[);/ ]|$)",
                "model": "Metal Pro 1"
            },
            {
                "regex": "V406018(?:[);/ ]|$)",
                "model": "Starr 100"
            },
            {
                "regex": "V512930(?:[);/ ]|$)",
                "model": "Ultra 50"
            },
            {
                "regex": "(V505430|V504630)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Z45_(Dazzle|Amaze)(?:[);/ ]|$)",
                "model": "Infinium Z45 $1"
            },
            {
                "regex": "Z45Q Star(?:[);/ ]|$)",
                "model": "Infinium Z45Q Star"
            },
            {
                "regex": "Z50 Nova(?:[);/ ]|$)",
                "model": "Infinium Z50 Nova"
            }
        ]
    },
    "Vodafone": {
        "regex": "(?<!FBCR/)Vodafone[ _-]|Smart ?Tab ?(?:III? ?)?(?:|4G|7|10)[);/ -]|VodafoneSmartChat|VFD[ _][0-9]+(?:[);/ ]|$)|VFD320|VF6[89]5|VF-(696|1397|795|895N|1497)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VFD 100",
                "model": "Smart Mini"
            },
            {
                "regex": "VF685",
                "model": "Smart Kicka"
            },
            {
                "regex": "VF695",
                "model": "Smart First 6"
            },
            {
                "regex": "VFD 200",
                "model": "Smart First 7"
            },
            {
                "regex": "VFD 300",
                "model": "Smart Mini 7"
            },
            {
                "regex": "VFD 50[02]",
                "model": "Smart Turbo 7"
            },
            {
                "regex": "VFD 51[013]",
                "model": "Smart E8"
            },
            {
                "regex": "VFD 600",
                "model": "Smart Prime 7"
            },
            {
                "regex": "VFD320",
                "model": "Smart C9"
            },
            {
                "regex": "VFD 820",
                "model": "Smart X9"
            },
            {
                "regex": "VFD 610",
                "model": "Smart N8"
            },
            {
                "regex": "Smart ultra 6",
                "model": "Smart Ultra 6"
            },
            {
                "regex": "VFD 700",
                "model": "Smart Ultra 7"
            },
            {
                "regex": "VFD 720",
                "model": "Smart N9"
            },
            {
                "regex": "VFD 900",
                "model": "Smart Platinum 7"
            },
            {
                "regex": "Vodafone[ _]875(?:[);/ ]|$)",
                "model": "Smart Mini"
            },
            {
                "regex": "Vodafone[ _]975N?(?:[);/ ]|$)",
                "model": "Smart 3"
            },
            {
                "regex": "Vodafone[ _]785(?:[);/ ]|$)",
                "model": "Smart 4 Mini"
            },
            {
                "regex": "Vodafone[ _]890N(?:[);/ ]|$)",
                "model": "Smart 4 Turbo"
            },
            {
                "regex": "Vodafone[ _]985N(?:[);/ ]|$)",
                "model": "Smart 4 Power"
            },
            {
                "regex": "VodafoneSmartChat",
                "model": "Smart Chat"
            },
            {
                "regex": "VF-696",
                "model": "Smart Grand 6"
            },
            {
                "regex": "VF-795",
                "model": "Smart Speed 6"
            },
            {
                "regex": "VF-895N",
                "model": "Smart Prime 6"
            },
            {
                "regex": "VF-1397",
                "model": "Tab Speed 6",
                "device": "tablet"
            },
            {
                "regex": "VF-1497",
                "model": "Tab Prime 6",
                "device": "tablet"
            },
            {
                "regex": "VFD 1100",
                "device": "tablet",
                "model": "Tab Mini 7"
            },
            {
                "regex": "VFD 1300",
                "device": "tablet",
                "model": "Smart Tab N8"
            },
            {
                "regex": "VFD 1400",
                "device": "tablet",
                "model": "Tab Prime 7"
            },
            {
                "regex": "Smart ?Tab ?3G",
                "device": "tablet",
                "model": "Smart Tab 3G"
            },
            {
                "regex": "Smart ?Tab ?4G",
                "device": "tablet",
                "model": "Smart Tab 4G"
            },
            {
                "regex": "Smart ?Tab ?4",
                "model": "Smart Tab 4",
                "device": "tablet"
            },
            {
                "regex": "SmartTab7[);/ -]",
                "model": "Smart Tab 7",
                "device": "tablet"
            },
            {
                "regex": "SmartTab10[);/ -]",
                "model": "Smart Tab 10",
                "device": "tablet"
            },
            {
                "regex": "Smart ?Tab ?II ?7",
                "model": "Smart Tab II 7",
                "device": "tablet"
            },
            {
                "regex": "Smart ?Tab ?II ?10",
                "model": "Smart Tab II 10",
                "device": "tablet"
            },
            {
                "regex": "Smart ?Tab ?III ?7",
                "model": "Smart Tab III 7",
                "device": "tablet"
            },
            {
                "regex": "Smart ?Tab ?III ?10",
                "model": "Smart Tab III 10",
                "device": "tablet"
            },
            {
                "regex": "VFD[ _]([0-9]+)(?:[);/ ]|$)",
                "model": "VFD $1"
            },
            {
                "regex": "Vodafone[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Vodafone[ _-]([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Vonino": {
        "regex": "Vonino|Epic (?:E8|P7)|Gyga[ _](?:X|S|QS|XS)|Jax[ _](?:QS|[SXQN]|Mini)|Magnet[ _]M[19]|Navo_QS|Onyx_(QS|Z)|Orin_QS|Pluri[ _](?:[BCMQ]7|[CQM]8)|Sirius_QS|Volt[ _][XS]|Xavy_(T7|L8)|Xylo[ _][XSPQT]|Zun[ _]X[OS]?|JAX_N",
        "device": "smartphone",
        "models": [
            {
                "regex": "Zun[ _]XO",
                "model": "Zun XO"
            },
            {
                "regex": "Zun[ _]XS",
                "model": "Zun XS"
            },
            {
                "regex": "Zun[ _]X",
                "model": "Zun X"
            },
            {
                "regex": "Xylo[ _]([PSXQT])",
                "model": "Xylo $1"
            },
            {
                "regex": "Volt[ _]S_A7",
                "model": "Volt S A7"
            },
            {
                "regex": "Volt[ _]S",
                "model": "Volt S"
            },
            {
                "regex": "Volt[ _]X",
                "model": "Volt X"
            },
            {
                "regex": "Gyga[ _]QS",
                "model": "Gyga QS"
            },
            {
                "regex": "Gyga[ _]XS",
                "model": "Gyga XS"
            },
            {
                "regex": "Gyga[ _](S|X)",
                "model": "Gyga $1"
            },
            {
                "regex": "Jax[ _]QS",
                "model": "Jax QS"
            },
            {
                "regex": "Jax[ _]S_A7",
                "model": "Jax S A7"
            },
            {
                "regex": "Jax[ _]([SQXN])",
                "model": "Jax $1"
            },
            {
                "regex": "Jax[ _]Mini",
                "model": "Jax Mini"
            },
            {
                "regex": "Epic (E8|P7)",
                "model": "Epic $1",
                "device": "tablet"
            },
            {
                "regex": "Pluri[ _](B|C|M|Q)7",
                "model": "Pluri $17",
                "device": "tablet"
            },
            {
                "regex": "Pluri[ _]([CQM])8",
                "model": "Pluri $18",
                "device": "tablet"
            },
            {
                "regex": "Magnet[ _]M([19])",
                "model": "Magnet M$1",
                "device": "tablet"
            },
            {
                "regex": "Navo_QS",
                "model": "Navo QS",
                "device": "tablet"
            },
            {
                "regex": "Onyx_(QS|Z)",
                "model": "Onyx $1",
                "device": "tablet"
            },
            {
                "regex": "Orin_QS",
                "model": "Orin QS",
                "device": "tablet"
            },
            {
                "regex": "Sirius_QS",
                "model": "Sirius QS",
                "device": "tablet"
            },
            {
                "regex": "Xavy_T7",
                "model": "Xavy T7",
                "device": "tablet"
            },
            {
                "regex": "Xavy_L8",
                "model": "Xavy L8",
                "device": "tablet"
            }
        ]
    },
    "Vorago": {
        "regex": "VORAGO",
        "device": "smartphone",
        "models": [
            {
                "regex": "CELL-500",
                "model": "CELL-500"
            }
        ]
    },
    "Voto": {
        "regex": "VOTO[ _\\-]|VT8[89]8(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VOTO[ _\\-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "VOTO[ _\\-]?([^);/ ]+)",
                "model": "$1"
            },
            {
                "regex": "(VT8[89]8)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Voxtel": {
        "regex": "Voxtel_([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Vulcan": {
        "regex": "(?:VP5004A|HT0704W08|VS5513|VS4011|VR6031)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(VP5004A|VR6031)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "VS5513(?:[);/ ]|$)",
                "model": "Tempo S13"
            },
            {
                "regex": "VS4011(?:[);/ ]|$)",
                "model": "Tempo S11"
            },
            {
                "regex": "HT0704W08",
                "model": "Koral 7W4",
                "device": "tablet"
            }
        ]
    },
    "Walton": {
        "regex": "Walton|Walpad|Primo[ _](C[1234]?|D[1-689]|E[1-589]|F8s|S7|EF[23]?|EM|F[1-79]i?|G[1-9]|GF[234]?|GH[23]?|GM|H[2-689M]|H7s|N[F1]?|NX2?|R[1-46]|R[HM]2?|RX[23]?|S[1-6]|V1|X[1-4]|Z|ZX)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Walpad ([^;/]+) Build",
                "device": "tablet",
                "model": "Primo Walpad $1"
            },
            {
                "regex": "Primo S6 infinity",
                "model": "Primo S6 Infinity"
            },
            {
                "regex": "Primo H8 Pro(?:[);/ ]|$)",
                "model": "Primo H8 Pro"
            },
            {
                "regex": "Primo H8(?:[);/ ]|$)",
                "model": "Primo H8 Turbo"
            },
            {
                "regex": "Primo[ _]([^;/)]+)(?: Build|[;)])",
                "model": "Primo $1"
            },
            {
                "regex": "Walton[ _]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "WellcoM": {
        "regex": "WELLCOM[ _\\-/]([a-z0-9]+)",
        "device": "smartphone",
        "model": "$1"
    },
    "Wexler": {
        "regex": "Wexler|(?:ULTIMA 7 TWIST PLUS|TAB10iQ3G|TAB[ _]10Q)(?:[);/ ]|$)|ZEN[ _](?:4\\.[57]|5)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:Wexler[ _\\-\\.])?ZEN[ _]4\\.5(?:[);/ ]|$)",
                "model": "ZEN 4.5",
                "device": "smartphone"
            },
            {
                "regex": "(?:Wexler[ _\\-\\.])?ZEN[ _]4\\.7(?:[);/ ]|$)",
                "model": "ZEN 4.7",
                "device": "smartphone"
            },
            {
                "regex": "(?:Wexler[ _\\-\\.])?ZEN[ _]5(?:[);/ ]|$)",
                "model": "ZEN 5",
                "device": "smartphone"
            },
            {
                "regex": "(?:Wexler[ _\\-\\.])?TAB[ _]10Q(?:[);/ ]|$)",
                "model": "TAB 10Q"
            },
            {
                "regex": "TAB10iQ3G(?:[);/ ]|$)",
                "model": "TAB 10iQ 3G"
            },
            {
                "regex": "Wexler[ _\\-\\.]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Wexler[ _\\-\\.]([^);/]+)(?:[);/]|$)",
                "model": "$1"
            },
            {
                "regex": "(ULTIMA 7 TWIST PLUS)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Inco": {
        "regex": "(?:Inco[ _](Aurora II|Sphere|Plain[_ ]2S?|Plain2 S|Flex 2S|S4|Bloom 2)|(Horizon_S|Horizon \\+))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Inco[ _])?(Plain[_ ]2S?|Horizon_S|Horizon \\+|Aurora II|Flex 2S|S4|Bloom 2)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Plain2 S",
                "model": "Plain 2S"
            },
            {
                "regex": "Inco Sphere(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Sphere"
            }
        ]
    },
    "Wink": {
        "regex": "(?<!mismart )Wink[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Wink[_ ]((?:Glory|World|Share|City)(?:[_ ](?:SE|S))?)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Wink[ _](Primo|Highway)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Wiko": {
        "regex": "(?:WIKO[_ -])|(?:WIKO-)?CINK_[a-z0-9_]+|(?:WIKO-)?HIGHWAY_[a-z0-9_]+|(?:WIKO-)?(?:Cink([^/;]*)|Highway([^/;]*)|Iggy|Stairway|Rainbow ?(Jam|Lite|Up)?|Darkside|Darkmoon|Darkfull|Darknight|Freddy|FEVER|Jerry[2]?|Sublim|Ozzy|JIMMY|Barry|Birdy|Bloom|Getaway|Goa(?!nna)|Kite|Robby|Lenny[2-9]?|Slide|Sunset[2-9]?|Sunny[2-9]?|Tommy[2-9]?|PULP(?: Fab)?|Wax|HARRY|Ridge(?: Fab)?|U FEEL(?: Prime| Lite)?|U PULSE(?: LITE)?|View2 Go|View XL|View Prime)(?: Plus)?(?: 4G)?(?: Build|$)?|W_(?:C8[06]0|K[346]00|P130|P200|C200SN)|WC300|W-(?:V7[23]0|V8[30]0|P[36]11|K420|K510S?|K130)-(?:TMV|TIM|TVM|EEA|SUN|SWI|OPE|BYT|DU|TH)|WIM Lite|W-K360-TV|W-V600|W-K200|W-U300|U307AS|CINK PEAX 2|HIGHWAY PURE|C210AE|v3913",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:WIKO-)?Cink Peax 2",
                "model": "Cink Peax 2"
            },
            {
                "regex": "(?:Wiko-)?Cink([^/;]*) Build",
                "model": "Cink$1"
            },
            {
                "regex": "(?:WIKO-)?CINK_([a-z0-9_]+)",
                "model": "Cink $1"
            },
            {
                "regex": "(?:WIKO-)?HIGHWAY PURE",
                "model": "Highway Pure"
            },
            {
                "regex": "(?:WIKO-)?HIGHWAY STAR",
                "model": "Highway Star"
            },
            {
                "regex": "(?:Wiko-)?Highway([^/;]*) Build",
                "model": "Highway$1"
            },
            {
                "regex": "(?:WIKO-)?HIGHWAY_([a-z0-9_]+)",
                "model": "Highway $1"
            },
            {
                "regex": "(?:WIKO-)?Iggy",
                "model": "Iggy"
            },
            {
                "regex": "(?:WIKO-)?FEVER",
                "model": "Fever"
            },
            {
                "regex": "(?:WIKO-)?Stairway",
                "model": "Stairway"
            },
            {
                "regex": "(?:WIKO-)?Ridge Fab 4G",
                "model": "Ridge Fab 4G"
            },
            {
                "regex": "(?:WIKO-)?Ridge 4G",
                "model": "Ridge 4G"
            },
            {
                "regex": "(?:WIKO-)?Ridge",
                "model": "Ridge"
            },
            {
                "regex": "(?:WIKO-)?Rainbow ([^/;]+) Build",
                "model": "Rainbow $1"
            },
            {
                "regex": "(?:WIKO-)?Rainbow",
                "model": "Rainbow"
            },
            {
                "regex": "(?:WIKO-)?Darkside",
                "model": "Darkside"
            },
            {
                "regex": "(?:WIKO-)?Darkmoon",
                "model": "Darkmoon"
            },
            {
                "regex": "(?:WIKO-)?Darkfull",
                "model": "Darkfull"
            },
            {
                "regex": "(?:WIKO-)?Darknight",
                "model": "Darknight"
            },
            {
                "regex": "(?:WIKO-)?Sublim",
                "model": "Sublim"
            },
            {
                "regex": "(?:WIKO-)?Ozzy",
                "model": "Ozzy"
            },
            {
                "regex": "(?:WIKO-)?Barry",
                "model": "Barry"
            },
            {
                "regex": "(?:WIKO-)?Birdy",
                "model": "Birdy"
            },
            {
                "regex": "(?:WIKO-)?Bloom",
                "model": "Bloom"
            },
            {
                "regex": "(?:WIKO-)?JIMMY",
                "model": "Jimmy"
            },
            {
                "regex": "JERRY MAX",
                "model": "Jerry Max"
            },
            {
                "regex": "W_K300",
                "model": "Jerry 3"
            },
            {
                "regex": "W-K420-TVM",
                "model": "Jerry 4"
            },
            {
                "regex": "(?:WIKO-)?Jerry2",
                "model": "Jerry 2"
            },
            {
                "regex": "(?:WIKO-)?Jerry",
                "model": "Jerry"
            },
            {
                "regex": "(?:WIKO-)?Getaway",
                "model": "Getaway"
            },
            {
                "regex": "(?:WIKO-)?Goa(?!nna)",
                "model": "Goa"
            },
            {
                "regex": "(?:WIKO-)?Freddy",
                "model": "Freddy"
            },
            {
                "regex": "(?:WIKO-)?Kite",
                "model": "Kite"
            },
            {
                "regex": "W_K400",
                "model": "Lenny 5"
            },
            {
                "regex": "C210AE(?:[);/ ]|$)",
                "model": "Life"
            },
            {
                "regex": "U307AS(?:[);/ ]|$)",
                "model": "Life 2"
            },
            {
                "regex": "v3913(?:[);/ ]|$)",
                "model": "Kenny"
            },
            {
                "regex": "(?:WIKO-)?Lenny[ -_]?3 Max",
                "model": "Lenny 3 Max"
            },
            {
                "regex": "(?:WIKO-)?Lenny[ -_]?4 Plus",
                "model": "Lenny 4 Plus"
            },
            {
                "regex": "(?:WIKO-)?Lenny[ -_]?([2-9])",
                "model": "Lenny $1"
            },
            {
                "regex": "(?:WIKO-)?Lenny",
                "model": "Lenny"
            },
            {
                "regex": "(?:WIKO-)?Slide",
                "model": "Slide"
            },
            {
                "regex": "(?:WIKO-)?Sunset2",
                "model": "Sunset 2"
            },
            {
                "regex": "(?:WIKO-)?Sunset",
                "model": "Sunset"
            },
            {
                "regex": "(?:WIKO-)?Sunny3",
                "model": "Sunny 3"
            },
            {
                "regex": "W-K200",
                "model": "Sunny 3 Plus"
            },
            {
                "regex": "(?:WIKO-)?Sunny2 Plus",
                "model": "Sunny 2 Plus"
            },
            {
                "regex": "(?:WIKO-)?Sunny2",
                "model": "Sunny 2"
            },
            {
                "regex": "W-K360-TV",
                "model": "Sunny 4 Plus"
            },
            {
                "regex": "W-K130-TMV",
                "model": "Sunny 4"
            },
            {
                "regex": "(?:WIKO-)?Sunny",
                "model": "Sunny"
            },
            {
                "regex": "(?:W_K600|Tommy3|W_C200SN)",
                "model": "Tommy 3"
            },
            {
                "regex": "(?:WIKO-)?Tommy2 Plus",
                "model": "Tommy 2 Plus"
            },
            {
                "regex": "(?:WIKO-)?Tommy2",
                "model": "Tommy 2"
            },
            {
                "regex": "(?:WIKO-)?Tommy",
                "model": "Tommy"
            },
            {
                "regex": "(?:WIKO-)?Wax",
                "model": "Wax"
            },
            {
                "regex": "(?:WIKO-)?HARRY",
                "model": "Harry"
            },
            {
                "regex": "W-V600",
                "model": "Harry 2"
            },
            {
                "regex": "(?:WIKO-)?WIM Lite",
                "model": "WIM Lite"
            },
            {
                "regex": "(?:WIKO-)?Pulp Fab 4G",
                "model": "Pulp Fab 4G"
            },
            {
                "regex": "(?:WIKO-)?Pulp Fab",
                "model": "Pulp Fab"
            },
            {
                "regex": "(?:WIKO-)?Pulp 4G",
                "model": "Pulp 4G"
            },
            {
                "regex": "(?:WIKO-)?Pulp",
                "model": "Pulp"
            },
            {
                "regex": "(?:WIKO-)?Robby",
                "model": "Robby"
            },
            {
                "regex": "(?:WIKO-)?U PULSE LITE",
                "model": "U Pulse Lite"
            },
            {
                "regex": "(?:WIKO-)?U PULSE",
                "model": "U Pulse"
            },
            {
                "regex": "(?:WIKO-)?U FEEL LITE",
                "model": "U Feel Lite"
            },
            {
                "regex": "(?:WIKO-)?U FEEL PRIME",
                "model": "U Feel Prime"
            },
            {
                "regex": "(?:WIKO-)?U FEEL",
                "model": "U Feel"
            },
            {
                "regex": "(?:WIKO-)?View2 Go",
                "model": "View 2 Go"
            },
            {
                "regex": "(?:WIKO-)?View XL",
                "model": "View XL"
            },
            {
                "regex": "(?:WIKO-)?View Prime",
                "model": "View Prime"
            },
            {
                "regex": "WC300",
                "model": "View Lite"
            },
            {
                "regex": "W_C800",
                "model": "View 2"
            },
            {
                "regex": "W_C860",
                "model": "View 2 Pro"
            },
            {
                "regex": "W_P200",
                "model": "View Max"
            },
            {
                "regex": "W_P130",
                "model": "View Go"
            },
            {
                "regex": "W-V800-(TVM|TIM|EEA|OPE|DU)",
                "model": "View 3 Lite"
            },
            {
                "regex": "W-K130-(?:OPE|EEA)",
                "model": "Y50"
            },
            {
                "regex": "W-K420-EEA",
                "model": "Y50"
            },
            {
                "regex": "W-K510-(?:TVM|EEA|OPE|SUN|BYT|TH)|W-K510S-SWI",
                "model": "Y60"
            },
            {
                "regex": "W-V720-(?:EEA|OPE|SUN)",
                "model": "Y80"
            },
            {
                "regex": "W-P311-(?:EEA|OPE|TVM)",
                "model": "View 3"
            },
            {
                "regex": "W-P611-(?:EEA|OPE)",
                "model": "View 3 Pro"
            },
            {
                "regex": "W-V830-EEA",
                "model": "View 4"
            },
            {
                "regex": "W-V730-EEA",
                "model": "View 4 Lite"
            },
            {
                "regex": "W-U300(?:[);/ ]|$)",
                "model": "Ride"
            },
            {
                "regex": "Wiko ([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Wiko ([^/; ]+)",
                "model": "$1"
            }
        ]
    },
    "Wieppo": {
        "regex": "Wieppo (S6 Lite|S[658]|E1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Weimei": {
        "regex": "weplus_3",
        "device": "smartphone",
        "models": [
            {
                "regex": "weplus_3",
                "model": "WePlus 3"
            }
        ]
    },
    "Wileyfox": {
        "regex": "(?:Wileyfox [^/]+)|Swift 2(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Wileyfox Spark \\+",
                "model": "Spark +"
            },
            {
                "regex": "Wileyfox Spark X",
                "model": "Spark X"
            },
            {
                "regex": "Wileyfox (Spark|Swift)",
                "model": "$1"
            },
            {
                "regex": "Wileyfox ([^/)]+)(?: Build|\\))",
                "model": "$1"
            },
            {
                "regex": "Swift 2 (X|Plus)(?:[);/ ]|$)",
                "model": "Swift 2 $1"
            },
            {
                "regex": "Swift 2(?:[);/ ]|$)",
                "model": "Swift 2"
            }
        ]
    },
    "Wolder": {
        "regex": "miSmart|miTab|WIAM \\#24|WOLDER",
        "device": "smartphone",
        "models": [
            {
                "regex": "WIAM \\#24",
                "model": "Wiam #24"
            },
            {
                "regex": "WOLDER_WIAM_65",
                "model": "Wiam #65"
            },
            {
                "regex": "miSmart[ \\-_]?([^/]+) Build",
                "model": "miSmart $1"
            },
            {
                "regex": "miTab[ \\-_]?([^/)]+)(?: Build|\\))",
                "device": "tablet",
                "model": "miTab $1"
            }
        ]
    },
    "Wolfgang": {
        "regex": "AT[ _-]AS([0-9A-Z]+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "AT-AS$1"
    },
    "Wonu": {
        "regex": "Wonu ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Woo": {
        "regex": "SP5026i-Scorpio",
        "device": "smartphone",
        "models": [
            {
                "regex": "SP5026i-Scorpio",
                "model": "Scorpio"
            }
        ]
    },
    "Woxter": {
        "regex": "Woxter[ _]([^/;)]+)(?: Build|\\))|Nimbus 101Q",
        "device": "tablet",
        "models": [
            {
                "regex": "Nimbus 101Q",
                "model": "Nimbus 101Q"
            },
            {
                "regex": "Woxter[ _]([^/;)]+)(?: Build|\\))",
                "model": "$1"
            }
        ]
    },
    "X-View": {
        "regex": "ZEN_U5\\+|AMBER_KIDS|Proton_Amber_HD|PROTON_JADE_2_PRO",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZEN_U5\\+",
                "model": "ZEN U5+"
            },
            {
                "regex": "AMBER_KIDS",
                "device": "tablet",
                "model": "Amber Kids"
            },
            {
                "regex": "Proton_Amber_HD",
                "device": "tablet",
                "model": "Proton Amber HD"
            },
            {
                "regex": "PROTON_JADE_2_PRO",
                "device": "tablet",
                "model": "Proton Jade 2 Pro"
            }
        ]
    },
    "POCO": {
        "regex": "(?:POCO[ _](?:X[23]|F2 PRO|M[32])|M2010J19C[GI]|M2007J20C[ITG]|M2012K11AG|M2006C3MI|M2004J19PI|M2102J20SG)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "POCO X2(?:[);/ ]|$)",
                "model": "X2"
            },
            {
                "regex": "(?:M2010J19C[GI]|POCO M3)(?:[);/ ]|$)",
                "model": "M3"
            },
            {
                "regex": "M2012K11AG(?:[);/ ]|$)",
                "model": "F3"
            },
            {
                "regex": "M2004J19PI(?:[);/ ]|$)",
                "model": "M2"
            },
            {
                "regex": "POCO M2 Pro(?:[);/ ]|$)",
                "model": "M2 Pro"
            },
            {
                "regex": "(?:M2007J20C[GT]|POCO X3 NFC)(?:[);/ ]|$)",
                "model": "X3 NFC"
            },
            {
                "regex": "(?:M2007J20CI|POCO X3)(?:[);/ ]|$)",
                "model": "X3"
            },
            {
                "regex": "M2102J20SG(?:[);/ ]|$)",
                "model": "X3 Pro"
            },
            {
                "regex": "M2006C3MI(?:[);/ ]|$)",
                "model": "C3"
            },
            {
                "regex": "POCO F2 PRO(?:[);/ ]|$)",
                "model": "F2 Pro"
            }
        ]
    },
    "Xiaomi": {
        "regex": "Xiaomi(?!/(?:Miui|Mint[ ])Browser)|Mi9 Pro 5G|(?:MI [a-z0-9]+|Mi-4c|MI-One[ _]?[a-z0-9]+|MIX(?: 2S?)?)(?:[);/ ]|$)|HM (?:[^/;]+) (?:Build|MIUI)|(?:2014501|2014011|201481[12378]|201302[23]|2013061) Build|Redmi|POCOPHONE|(?:SHARK )?(KLE|MBU)-[AH]0|SKR-[AH]0|SKW-[AH]0|POCO F1|DLT-[AH]0|MIBOX[234]([_ ]PRO)?|MiTV4[CSX]?|MiTV-(MSSP[01]|AXSO0)|AWM-A0|MI CC 9 Meitu Edition|MiBOX1S|MiTV4A|M2006J10C|M2006C3(?:L[IGC]|LVG|MN?G)|M2007J1(?:7[CGI]|SC)|M2002J9[EG]|HM2014819|WT88047|M2004J(?:7[AB]|19)C|M2012K11C|M2011K2[CG]|M2006C3[ML]II|M2003J15SC|M2007J3S[ICYGP]|M2007J22[CG]|M2101K6[GI]|M2101K(?:[79]AG|7AI)|M2010J19S[CGYI]|HM NOTE 1(?:LTE|W)|MI[_ ]PLAY|XIG01|MI_(NOTE_Pro|5X|4i|(?:A2|8)_Lite)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SKR-[AH]0",
                "model": "Black Shark"
            },
            {
                "regex": "AWM-A0",
                "model": "Black Shark Helo"
            },
            {
                "regex": "SKW-[AH]0",
                "model": "Black Shark 2"
            },
            {
                "regex": "DLT-[AH]0",
                "model": "Black Shark 2 Pro"
            },
            {
                "regex": "(?:SHARK )?KLE-A0",
                "model": "Black Shark 3"
            },
            {
                "regex": "(?:SHARK )?KLE-H0",
                "model": "Black Shark 3 5G"
            },
            {
                "regex": "(?:SHARK )?MBU-H0",
                "model": "Black Shark 3 Pro 5G"
            },
            {
                "regex": "(?:SHARK )?MBU-A0",
                "model": "Black Shark 3 Pro"
            },
            {
                "regex": "Xiaomi_2014501|2014501 Build",
                "model": "Hongmi 4G"
            },
            {
                "regex": "Xiaomi_2014011|2014011 Build",
                "model": "Hongmi 1S"
            },
            {
                "regex": "Xiaomi_201302[23]|201302[23] Build",
                "model": "Hongmi"
            },
            {
                "regex": "Xiaomi[_-]2014818|2014818 Build",
                "model": "Hongmi 2 3G"
            },
            {
                "regex": "Xiaomi_2014817|2014817 Build",
                "model": "Hongmi 2"
            },
            {
                "regex": "Xiaomi[_-]201481[123]|201481[123] Build",
                "model": "Hongmi 2 4G"
            },
            {
                "regex": "MI[_ ]PLAY(?:[);/ ]|$)",
                "model": "MI Play"
            },
            {
                "regex": "Mi 9 SE(?:[);/ ]|$)",
                "model": "MI 9 SE"
            },
            {
                "regex": "MI CC 9 Meitu Edition(?:[);/ ]|$)",
                "model": "MI CC 9"
            },
            {
                "regex": "Xiaomi_M2001J2E_TD-LTE(?:[);/ ]|$)",
                "model": "MI 10"
            },
            {
                "regex": "M2011K2[CG](?:[);/ ]|$)",
                "model": "MI 11"
            },
            {
                "regex": "M2007J3S[CYP](?:[);/ ]|$)",
                "model": "MI 10T 5G"
            },
            {
                "regex": "M2007J3S[GI](?:[);/ ]|$)",
                "model": "MI 10T Pro 5G"
            },
            {
                "regex": "M2007J17G(?:[);/ ]|$)",
                "model": "MI 10T Lite 5G"
            },
            {
                "regex": "M2007J1SC(?:[);/ ]|$)",
                "model": "MI 10 Ultra 5G"
            },
            {
                "regex": "(?:M2002J9[EG]|XIG01)(?:[);/ ]|$)",
                "model": "MI 10 Lite 5G"
            },
            {
                "regex": "M2007J17I(?:[);/ ]|$)",
                "model": "MI 10i"
            },
            {
                "regex": "M2101K9AG(?:[);/ ]|$)",
                "model": "MI 11 Lite"
            },
            {
                "regex": "MI[ _]8[ _]Lite(?:[);/ ]|$)",
                "model": "MI 8 Lite"
            },
            {
                "regex": "Mi 9T Pro(?:[);/ ]|$)",
                "model": "MI 9T Pro"
            },
            {
                "regex": "Mi9 Pro 5G(?:[);/ ]|$)",
                "model": "MI 9 Pro 5G"
            },
            {
                "regex": "MI ([89]) Lite(?:[);/ ]|$)",
                "model": "MI $1 Lite"
            },
            {
                "regex": "MI 5s Plus(?:[);/ ]|$)",
                "model": "MI 5s Plus"
            },
            {
                "regex": "Xiaomi_2013061|2013061 Build",
                "model": "MI 3"
            },
            {
                "regex": "Mi-4c(?:[);/ ]|$)",
                "model": "MI 4C"
            },
            {
                "regex": "MI 4W(?:[);/ ]|$)",
                "model": "MI 4W"
            },
            {
                "regex": "Mi_4i(?:[);/ ]|$)",
                "model": "MI 4i"
            },
            {
                "regex": "MI MAX 3(?:[);/ ]|$)",
                "model": "MI MAX 3"
            },
            {
                "regex": "MI MAX 2(?:[);/ ]|$)",
                "model": "MI MAX 2"
            },
            {
                "regex": "Mi[ _]A2[ _]Lite(?:[);/ ]|$)",
                "model": "MI A2 Lite"
            },
            {
                "regex": "MIX 3(?:[);/ ]|$)",
                "model": "MI MIX 3"
            },
            {
                "regex": "MIX 2S(?:[);/ ]|$)",
                "model": "MI MIX 2S"
            },
            {
                "regex": "MIX 2(?:[);/ ]|$)",
                "model": "MI MIX 2"
            },
            {
                "regex": "MIX(?:[);/ ]|$)",
                "model": "MI MIX"
            },
            {
                "regex": "POCOPHONE[ _]F1|POCO F1",
                "model": "Pocophone F1"
            },
            {
                "regex": "Redmi 5 Plus",
                "model": "Redmi 5 Plus"
            },
            {
                "regex": "WT88047(?:[);/ ]|$)",
                "model": "Redmi 2"
            },
            {
                "regex": "HM2014819(?:[);/ ]|$)",
                "model": "Redmi 2 Pro"
            },
            {
                "regex": "HM 2A(?:[);/ ]|$)",
                "model": "Redmi 2A"
            },
            {
                "regex": "HM 1S[CW]?(?:[);/ ]|$)",
                "model": "Redmi 1S"
            },
            {
                "regex": "HM 1(?:[);/ ]|$)",
                "model": "Redmi 1"
            },
            {
                "regex": "M2004J7AC(?:[);/ ]|$)",
                "model": "Redmi 10X"
            },
            {
                "regex": "(?:M2004J19C|M2006C3MII)(?:[);/ ]|$)",
                "model": "Redmi 9"
            },
            {
                "regex": "M2010J19SI(?:[);/ ]|$)",
                "model": "Redmi 9 Power"
            },
            {
                "regex": "M2006C3L[GCI](?:[);/ ]|$)",
                "model": "Redmi 9A"
            },
            {
                "regex": "M2006C3LII(?:[);/ ]|$)",
                "model": "Redmi 9i"
            },
            {
                "regex": "M2006C3MG(?:[);/ ]|$)",
                "model": "Redmi 9C"
            },
            {
                "regex": "M2006C3LVG(?:[);/ ]|$)",
                "model": "Redmi 9AT"
            },
            {
                "regex": "M2010J19S[GY](?:[);/ ]|$)",
                "model": "Redmi 9T"
            },
            {
                "regex": "M2006C3MNG(?:[);/ ]|$)",
                "model": "Redmi 9C NFC"
            },
            {
                "regex": "M2004J7BC(?:[);/ ]|$)",
                "model": "Redmi 10X Pro"
            },
            {
                "regex": "Redmi K20 Pro(?:[);/ ]|$)",
                "model": "Redmi K20 Pro"
            },
            {
                "regex": "Redmi K30 5G(?:[);/ ]|$)",
                "model": "Redmi K30 5G"
            },
            {
                "regex": "M2012K11C(?:[);/ ]|$)",
                "model": "Redmi K40 Pro"
            },
            {
                "regex": "M2006J10C(?:[);/ ]|$)",
                "model": "Redmi K30 Ultra"
            },
            {
                "regex": "Redmi Y1 Lite(?:[);/ ]|$)",
                "model": "Redmi Y1 Lite"
            },
            {
                "regex": "MI PAD 4 PLUS(?:[);/ ]|$)",
                "model": "Mi Pad 4 Plus",
                "device": "tablet"
            },
            {
                "regex": "MI PAD 4(?:[);/ ]|$)",
                "model": "Mi Pad 4",
                "device": "tablet"
            },
            {
                "regex": "MI PAD 3(?:[);/ ]|$)",
                "model": "Mi Pad 3",
                "device": "tablet"
            },
            {
                "regex": "MI PAD 2(?:[);/ ]|$)",
                "model": "Mi Pad 2",
                "device": "tablet"
            },
            {
                "regex": "MI PAD(?:[);/ ]|$)",
                "model": "Mi Pad",
                "device": "tablet"
            },
            {
                "regex": "MIBOX3[ _]Pro(?:[);/ ]|$)",
                "model": "Mi Box 3 Pro",
                "device": "tv"
            },
            {
                "regex": "MIBOX([234])(?:[);/ ]|$)",
                "model": "Mi Box $1",
                "device": "tv"
            },
            {
                "regex": "MiBOX1S(?:[);/ ]|$)",
                "model": "Mi Box 1S",
                "device": "tv"
            },
            {
                "regex": "MiTV-MSSP1(?:[);/ ]|$)",
                "model": "MiTV 4S",
                "device": "tv"
            },
            {
                "regex": "(?:MiTV-AXSO0|MiTV4(?:A|-ANSM0)|MiTV-MSSP0)(?:[);/ ]|$)",
                "model": "MiTV 4A",
                "device": "tv"
            },
            {
                "regex": "(MiTV)(4[CSX]|4)(?:[);/ ]|$)",
                "model": "$1 $2",
                "device": "tv"
            },
            {
                "regex": "HM NOTE 1W(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Redmi Note"
            },
            {
                "regex": "HM NOTE 1TD (?:Build|MIUI)",
                "device": "phablet",
                "model": "Hongmi Note 1TD"
            },
            {
                "regex": "HM NOTE 1(?:LTE|S)(?:W|GLOBAL|TD)? (?:Build|MIUI)|HM NOTE 1LTE",
                "device": "phablet",
                "model": "Redmi Note 4G"
            },
            {
                "regex": "Redmi Note 5A Prime",
                "model": "Redmi Note 5A Prime",
                "device": "phablet"
            },
            {
                "regex": "M2010J19SC(?:[);/ ]|$)",
                "model": "Redmi Note 9",
                "device": "phablet"
            },
            {
                "regex": "M2003J15SC(?:[);/ ]|$)",
                "model": "Redmi Note 10X",
                "device": "phablet"
            },
            {
                "regex": "M2007J22G(?:[);/ ]|$)",
                "model": "Redmi Note 9T 5G",
                "device": "phablet"
            },
            {
                "regex": "M2007J22C(?:[);/ ]|$)",
                "model": "Redmi Note 9 5G",
                "device": "phablet"
            },
            {
                "regex": "M2007J17C(?:[);/ ]|$)",
                "model": "Redmi Note 9 Pro 5G",
                "device": "phablet"
            },
            {
                "regex": "M2101K7A[GI]",
                "model": "Redmi Note 10",
                "device": "phablet"
            },
            {
                "regex": "M2101K6[GI]",
                "model": "Redmi Note 10 Pro",
                "device": "phablet"
            },
            {
                "regex": "Redmi Note ([5-9]) Pro(?:[);/ ]|$)",
                "model": "Redmi Note $1 Pro",
                "device": "phablet"
            },
            {
                "regex": "Redmi[ _]Note[ _]([^;/) ]+)?",
                "model": "Redmi Note $1",
                "device": "phablet"
            },
            {
                "regex": "Redmi[ _]([^;/) ]+)?",
                "model": "Redmi $1"
            },
            {
                "regex": "MI_NOTE_Pro",
                "model": "MI Note Pro",
                "device": "phablet"
            },
            {
                "regex": "Mi Note 10 Pro",
                "model": "Mi Note 10 Pro",
                "device": "phablet"
            },
            {
                "regex": "MI[ _]Note[ _]([^;/) ]+)?",
                "model": "MI Note $1",
                "device": "phablet"
            },
            {
                "regex": "(MI(?:-One)?[ _](?:[^;/]*))Build",
                "model": "$1"
            },
            {
                "regex": "(MI[ _][a-z0-9]+|MI-One[ _]?[a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "HM Note ([^/;]+) (?:Build|MIUI)",
                "device": "phablet",
                "model": "Note"
            },
            {
                "regex": "HM ([^/;]+) (?:Build|MIUI)",
                "model": "HM $1"
            },
            {
                "regex": "Xiaomi[ _-]([^/;]+)(?: Build|$)",
                "model": "$1"
            }
        ]
    },
    "Xion": {
        "regex": "XI-CE(?:655|U[48])",
        "device": "smartphone",
        "models": [
            {
                "regex": "XI-CE(655|U[48])",
                "model": "CE$1"
            }
        ]
    },
    "Xolo": {
        "regex": "Xolo|(?:Q600|Q700s?|Q800|Q1000s|Q1000[ _]Opus|Q1010i|Q2000|Omega[ _]5.[05]|Era5X|Era[ _]2V|Era_4X(?:_2GB)?)(?:[);/ ]|$)|BLACK-1XM",
        "device": "smartphone",
        "models": [
            {
                "regex": "BLACK-1XM",
                "model": "Black 1X"
            },
            {
                "regex": "Era_?([45])X(?:[);/ ]|$)",
                "model": "Era $1X"
            },
            {
                "regex": "Era_4X_2GB(?:[);/ ]|$)",
                "model": "Era 4X 2GB"
            },
            {
                "regex": "Era[ _]2V(?:[);/ ]|$)",
                "model": "Era 2V"
            },
            {
                "regex": "(Q600 Club|Q600|Q700s?|Q800|Q1000s Plus|Q1000s|Q1000[ _]Opus|Q1010i|Q2000|Omega[ _]5.[05])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Xolo[ _]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Xolo[ _]?([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Yarvik": {
        "regex": "Xenta[ \\-]Tab|Luna TAB|TAB09-410|TAB10-410|TAB07-485|TAB0[78]-200|TAB08-201-3G|TAB9-200|TAB09-211|TAB10-2[01]1|TAB13-201",
        "device": "tablet",
        "models": [
            {
                "regex": "Luna TAB07-920N",
                "model": "Luna 7"
            },
            {
                "regex": "Luna TAB07-10[01]",
                "model": "Luna 7c"
            },
            {
                "regex": "Luna TAB274",
                "model": "Luna 7c"
            },
            {
                "regex": "Luna TAB474",
                "model": "Luna 10"
            },
            {
                "regex": "Luna TAB10-150",
                "model": "Luna 10c"
            },
            {
                "regex": "TAB09-410",
                "model": "Noble 9.7"
            },
            {
                "regex": "TAB10-410",
                "model": "Noble 10.1"
            },
            {
                "regex": "TAB07-485",
                "model": "Noble Mini"
            },
            {
                "regex": "Xenta-TAB07-21[01]",
                "model": "Xenta 7c"
            },
            {
                "regex": "TAB07-200",
                "model": "Xenta 7ic"
            },
            {
                "regex": "TAB08-200",
                "model": "Xenta 8ic"
            },
            {
                "regex": "TAB08-201-3G",
                "model": "Xenta 8c"
            },
            {
                "regex": "TAB9-200",
                "model": "Xenta 9.7ic"
            },
            {
                "regex": "TAB09-211",
                "model": "Xenta 9.7ic+"
            },
            {
                "regex": "TAB10-2[01]1",
                "model": "Xenta 10ic"
            },
            {
                "regex": "TAB13-201",
                "model": "Xenta 13c"
            }
        ]
    },
    "Yes": {
        "regex": "M631Y|M685Y4|M651G_MY|YES (MPY(?:48|54))",
        "device": "smartphone",
        "models": [
            {
                "regex": "M631Y",
                "model": "Altitude"
            },
            {
                "regex": "M651G_MY",
                "model": "Altitude 2"
            },
            {
                "regex": "M685Y4",
                "model": "Altitude 3"
            },
            {
                "regex": "YES (MPY(?:48|54))",
                "model": "$1"
            }
        ]
    },
    "Yezz": {
        "regex": "Yezz|ANDY[ _]|(?:4E4|A5EI|LIV1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "4E4",
                "model": "Andy 4E4"
            },
            {
                "regex": "Yezz-AC4EI",
                "model": "Andy 4EI"
            },
            {
                "regex": "YEZZ-A4M",
                "model": "Andy A4M"
            },
            {
                "regex": "A5EI",
                "model": "Andy A5EI"
            },
            {
                "regex": "LIV1",
                "model": "LIV1"
            },
            {
                "regex": "Andy[ _]([A-Z]*[0-9]\\.[0-9][A-Z0-9]*)(?:[ _](LTE))?",
                "model": "Andy $1 $2"
            },
            {
                "regex": "Andy[ _]([A-Z]*[0-9])([0-9][A-Z0-9]*)(?:[ _](LTE))?",
                "model": "Andy $1.$2 $3"
            },
            {
                "regex": "Andy[ _]([A-Z]*[0-9][A-Z0-9]+)(?:[ _](LTE))?",
                "model": "Andy $1 $2"
            }
        ]
    },
    "Yu": {
        "regex": "(?:YU5[05]10[A]?|YU4711|AO5510|YU5050|YU501[14]|YU5551)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "YU5010[A]?(?:[);/ ]|$)",
                "model": "Yuphoria"
            },
            {
                "regex": "YU5011(?:[);/ ]|$)",
                "model": "Yunique 2"
            },
            {
                "regex": "YU5050(?:[);/ ]|$)",
                "model": "Yutopia"
            },
            {
                "regex": "AO5510(?:[);/ ]|$)",
                "model": "Yureka"
            },
            {
                "regex": "YU5551(?:[);/ ]|$)",
                "model": "Yureka 2"
            },
            {
                "regex": "YU5510[A]?(?:[);/ ]|$)",
                "model": "Yureka Plus"
            },
            {
                "regex": "YU4711(?:[);/ ]|$)",
                "model": "Yunique"
            },
            {
                "regex": "YU5014(?:[);/ ]|$)",
                "model": "Ace"
            }
        ]
    },
    "Yuandao": {
        "regex": "N101[ _]DUAL(?:[ _]CORE)?(?:[ _]?2|\\|\\|)?(?:[ _]V11)?(?:[);/ ]|$)",
        "device": "tablet",
        "model": "N101"
    },
    "Yusun": {
        "regex": "Yusun|LA2-T",
        "device": "smartphone",
        "models": [
            {
                "regex": "LA2-T",
                "model": "LA2-T"
            },
            {
                "regex": "Yusun ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Yusun ([a-z0-9_\\-\\+]+)",
                "model": "$1"
            }
        ]
    },
    "Ytone": {
        "regex": "YTONE[ _\\-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "YTONE[ _\\-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "YTONE[ _\\-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Zonda": {
        "regex": "(ZM(?:CK|EM|TFTV|TN)[a-z0-9]+)|ZA409",
        "device": "feature phone",
        "models": [
            {
                "regex": "ZA409",
                "device": "smartphone",
                "model": "Muzic"
            },
            {
                "regex": "(ZM(?:CK|EM|TFTV|TN)[a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "ZYQ": {
        "regex": "ZYQ-Q88|(Q(?:2602|262[436]|638|2688|272[89]|3022|3623|TAB Tab4|328 m9|328|668)|J77|Q[._](?:Up|Boss P99|Dee R09|Good M9|Hi|Hot|Me|Mate R99|Next|TOP-X8|You))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Q638",
                "model": "I7"
            },
            {
                "regex": "Q2624",
                "model": "Cheer 3G"
            },
            {
                "regex": "Q2602",
                "model": "TV Next"
            },
            {
                "regex": "Q2728",
                "model": "Zone 3G"
            },
            {
                "regex": "Q2729",
                "model": "Q2729"
            },
            {
                "regex": "Q2688",
                "model": "Q2688"
            },
            {
                "regex": "Q2623",
                "model": "Win 3G"
            },
            {
                "regex": "Q2626",
                "model": "Care 3G"
            },
            {
                "regex": "Q3623",
                "model": "Braw 3G"
            },
            {
                "regex": "Q3022",
                "model": "Q3022"
            },
            {
                "regex": "Q328 m9",
                "model": "Q328 M9"
            },
            {
                "regex": "Q328",
                "model": "Speed 3G"
            },
            {
                "regex": "Q668",
                "model": "TV I4"
            },
            {
                "regex": "J77",
                "model": "Q.Dee"
            },
            {
                "regex": "Q\\.Up C5",
                "model": "Q.Up C5"
            },
            {
                "regex": "Q\\.Up",
                "model": "Q.Up"
            },
            {
                "regex": "Q\\.Boss P99",
                "model": "Q.Boss P99"
            },
            {
                "regex": "Q[._]Dee R09",
                "model": "Q.Dee R09"
            },
            {
                "regex": "Q\\.Good M9",
                "model": "Q.Good M9"
            },
            {
                "regex": "Q[._]Hi S1",
                "model": "Q.Hi S1"
            },
            {
                "regex": "Q[._]Hi",
                "model": "Q.Hi"
            },
            {
                "regex": "Q[._]Hot P7 3G",
                "model": "Q.Hot P7 3G"
            },
            {
                "regex": "Q[._]Hot",
                "model": "Q.Hot"
            },
            {
                "regex": "Q[._]Me Phone7 3G",
                "model": "Q.Me Phone 7 3G"
            },
            {
                "regex": "Q[._]Me Plus7",
                "model": "Q.Me Plus 7"
            },
            {
                "regex": "Q[._]Me",
                "model": "Q.Me"
            },
            {
                "regex": "Q[._]Mate R99",
                "model": "Q.Mate R99"
            },
            {
                "regex": "Q[._]Next B7",
                "model": "Q.Next B7"
            },
            {
                "regex": "Q[._]Next J2",
                "model": "Q.Next J2"
            },
            {
                "regex": "Q[._]TOP-X8",
                "model": "Q.Top X8"
            },
            {
                "regex": "Q[._]You",
                "model": "Q.You"
            },
            {
                "regex": "QTAB Tab4",
                "model": "QTab Tab4",
                "device": "tablet"
            },
            {
                "regex": "ZYQ-Q88",
                "model": "Q88",
                "device": "tablet"
            }
        ]
    },
    "Toshiba": {
        "regex": "Toshiba|TSBNetTV/|portalmmm/[12].0 TS|T-01C|T-0[12]D|IS04|IS11T|AT1S0|AT300SE|AT(7-C|10-A|10[PL]E-A|100|200|270|300|330|374|400|470|500|503|570|703|830)",
        "device": "smartphone",
        "models": [
            {
                "regex": "T-01C",
                "model": "Regza T-01C"
            },
            {
                "regex": "T-01D",
                "model": "Regza T-01D"
            },
            {
                "regex": "T-02D",
                "model": "Regza T-02D"
            },
            {
                "regex": "IS04",
                "model": "Regza IS04"
            },
            {
                "regex": "IS11T",
                "model": "Regza IS11T"
            },
            {
                "regex": "AT7-C",
                "model": "Excite",
                "device": "tablet"
            },
            {
                "regex": "AT1S0",
                "model": "Regza AT1S0",
                "device": "tablet"
            },
            {
                "regex": "AT300SE",
                "model": "Regza AT300SE",
                "device": "tablet"
            },
            {
                "regex": "AT500a",
                "model": "Regza AT500a",
                "device": "tablet"
            },
            {
                "regex": "AT(100|200|270|300|330|374|400|470|500|503|570|703|830)",
                "model": "Regza AT$1",
                "device": "tablet"
            },
            {
                "regex": "AT10([PL])E-A",
                "model": "Excite AT10$1-A",
                "device": "tablet"
            },
            {
                "regex": "AT10-A",
                "model": "Excite AT10-A",
                "device": "tablet"
            },
            {
                "regex": "TSBNetTV/",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "Toshiba[ /_\\-]?([a-z0-9_ \\-]+) Build",
                "model": "$1"
            },
            {
                "regex": "Toshiba[ /_\\-]?([a-z0-9_\\-]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/[12].0 (TS[a-z0-9 ]+)",
                "model": "$1"
            }
        ]
    },
    "Vivax": {
        "regex": "VIVAX|(?:Fly5[_ ]Lite|Fun[_ ]S500|Point_(?:X[12]|X501)|PRO3|32LE77SM|40LE77SM|FUN S1|FUN_S20)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Fly5[_ ]Lite(?:[);/ ]|$)",
                "model": "Fly 5 Lite"
            },
            {
                "regex": "Point_X([12])(?:[);/ ]|$)",
                "model": "Point X$1"
            },
            {
                "regex": "Fun[_ ]S500(?:[);/ ]|$)",
                "model": "Fun S500"
            },
            {
                "regex": "FUN[ _]S(1|20)(?:[);/ ]|$)",
                "model": "Fun S$1"
            },
            {
                "regex": "VIVAX[ _]Fly3(?:[);/ ]|$)",
                "model": "Fly 3"
            },
            {
                "regex": "VIVAX[ _]Fly[ _]V1(?:[);/ ]|$)",
                "model": "Fly V1"
            },
            {
                "regex": "(?:VIVAX )?(Point[ _](?:X551|X501))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SMART Point X5010(?:[);/ ]|$)",
                "model": "Smart Point X5010"
            },
            {
                "regex": "VIVAX[_ ]PRO3",
                "model": "Pro 3"
            },
            {
                "regex": "VIVAX TABLET TPC 802 3G(?:[);/ ]|$)",
                "model": "TPC-802 3G"
            },
            {
                "regex": "(32LE77SM|40LE77SM)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "MLS": {
        "regex": "IQ(?:0705|L550|1010w?|1012N?|1019N|1025|1380|1401|1436|1452a|1453|1470|1502a|1511|1552|1553|1568|1570|1805N|1806|1808|1810B_M|1832|1850|1890|5017|9610|181011N|E[12]00|EL41|G550|GW516|L30|L5[01]|M801|M1001|N700|P50|R300|S300|S1001|W503|W511T|W553N?|W60[38]|W626|M960|D700|9013_4N)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IQ0705(?:[);/ ]|$)",
                "model": "iQTalk Twist"
            },
            {
                "regex": "IQL550(?:[);/ ]|$)",
                "model": "Notch Lite"
            },
            {
                "regex": "IQ1010W?(?:[);/ ]|$)",
                "model": "iQTab 10",
                "device": "tablet"
            },
            {
                "regex": "IQ1012N?(?:[);/ ]|$)",
                "model": "iQTab Brave 3G",
                "device": "tablet"
            },
            {
                "regex": "IQ1025(?:[);/ ]|$)",
                "model": "iQTab Action 4G",
                "device": "tablet"
            },
            {
                "regex": "iQ9013_4N(?:[);/ ]|$)",
                "model": "Life 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "IQ1019N(?:[);/ ]|$)",
                "model": "Alu Plus 4G 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "iQ1805N(?:[);/ ]|$)",
                "model": "iQTab Ideal 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "iQ181011N(?:[);/ ]|$)",
                "model": "iQTab Care 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "IQ1380(?:[);/ ]|$)",
                "model": "Brain 3G"
            },
            {
                "regex": "IQ1401(?:[);/ ]|$)",
                "model": "iQTalk Verse 4G"
            },
            {
                "regex": "IQ1436(?:[);/ ]|$)",
                "model": "Color mini 4G"
            },
            {
                "regex": "IQ1452a(?:[);/ ]|$)",
                "model": "TOP-S 4G"
            },
            {
                "regex": "IQ1453(?:[);/ ]|$)",
                "model": "Trend 4G"
            },
            {
                "regex": "IQ1470(?:[);/ ]|$)",
                "model": "iQTalk Onyx"
            },
            {
                "regex": "IQ1502a(?:[);/ ]|$)",
                "model": "iQTalk Flame"
            },
            {
                "regex": "IQ1511(?:[);/ ]|$)",
                "model": "iQTalk Spicy"
            },
            {
                "regex": "IQ1552(?:[);/ ]|$)",
                "model": "iQTalk Titan 4G"
            },
            {
                "regex": "IQ1553(?:[);/ ]|$)",
                "model": "Color 3 4G"
            },
            {
                "regex": "IQ1568(?:[);/ ]|$)",
                "model": "Range 4G"
            },
            {
                "regex": "IQ1570(?:[);/ ]|$)",
                "model": "iQTalk Color 5.5 4G"
            },
            {
                "regex": "IQ1806(?:[);/ ]|$)",
                "model": "iQTab Rose",
                "device": "tablet"
            },
            {
                "regex": "IQ1808(?:[);/ ]|$)",
                "model": "iQTab Master",
                "device": "tablet"
            },
            {
                "regex": "IQ1810B_M(?:[);/ ]|$)",
                "model": "iQTab Novel 3G",
                "device": "tablet"
            },
            {
                "regex": "IQ1832(?:[);/ ]|$)",
                "model": "Jet 3G",
                "device": "tablet"
            },
            {
                "regex": "IQ1850(?:[);/ ]|$)",
                "model": "Diamond 5.2 4G"
            },
            {
                "regex": "IQ1890(?:[);/ ]|$)",
                "model": "iQTalk Aura"
            },
            {
                "regex": "IQ5017(?:[);/ ]|$)",
                "model": "Slice 4G"
            },
            {
                "regex": "IQ9610(?:[);/ ]|$)",
                "model": "Angel 3G",
                "device": "tablet"
            },
            {
                "regex": "iQM960(?:[);/ ]|$)",
                "model": "Angel 3G (2018)",
                "device": "tablet"
            },
            {
                "regex": "IQG550(?:[);/ ]|$)",
                "model": "Style 4G"
            },
            {
                "regex": "IQGW516(?:[);/ ]|$)",
                "model": "F5"
            },
            {
                "regex": "IQE100(?:[);/ ]|$)",
                "model": "Energy 4G"
            },
            {
                "regex": "iQE200(?:[);/ ]|$)",
                "model": "MX 4G"
            },
            {
                "regex": "IQEL41(?:[);/ ]|$)",
                "model": "Fab 4G"
            },
            {
                "regex": "IQL30(?:[);/ ]|$)",
                "model": "Status 4G"
            },
            {
                "regex": "IQL50(?:[);/ ]|$)",
                "model": "More 4G"
            },
            {
                "regex": "IQL51(?:[);/ ]|$)",
                "model": "Wave 4G"
            },
            {
                "regex": "IQM801(?:[);/ ]|$)",
                "model": "Brace 2018 4G",
                "device": "tablet"
            },
            {
                "regex": "IQM1001(?:[);/ ]|$)",
                "model": "Level 4G",
                "device": "tablet"
            },
            {
                "regex": "IQN700(?:[);/ ]|$)",
                "model": "Inspire 4G"
            },
            {
                "regex": "IQP50(?:[);/ ]|$)",
                "model": "Ruby 4G"
            },
            {
                "regex": "IQS300(?:[);/ ]|$)",
                "model": "DX 4G"
            },
            {
                "regex": "IQS1001(?:[);/ ]|$)",
                "model": "Vista 4G",
                "device": "tablet"
            },
            {
                "regex": "IQR300(?:[);/ ]|$)",
                "model": "R3 4G"
            },
            {
                "regex": "IQW608(?:[);/ ]|$)",
                "model": "Regal"
            },
            {
                "regex": "iQW603(?:[);/ ]|$)",
                "model": "Phab 6.0\"",
                "device": "phablet"
            },
            {
                "regex": "IQW626(?:[);/ ]|$)",
                "model": "D6 4G"
            },
            {
                "regex": "IQW511T(?:[);/ ]|$)",
                "model": "Liberal"
            },
            {
                "regex": "IQW553N?(?:[);/ ]|$)",
                "model": "Alu 5.5\""
            },
            {
                "regex": "IQW503(?:[);/ ]|$)",
                "model": "Flame 4G (2018)"
            },
            {
                "regex": "iQD700(?:[);/ ]|$)",
                "model": "Color Fingerprint 4G"
            }
        ]
    },
    "Fly": {
        "regex": "Fly(?!Flow|touch)|Power Plus 5000|Photo Pro|Slimline|Life (?:Ace|Jet|Sky|Compact 4G|Geo)|FS50[1-9]|FS51[0-8]|FS52[0-9]|FS530|FS55[134]|FS40[1-9]|FS45[1-9]|4FS06|MERIDIAN-|(?:IQ(?!10[134]0)[0-9]{3,}[i]?)[ _]?(?:Quad|Firebird|Quattro|Turbo|Magic)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Fly_)?IQ310(?:[);/ ]|$)",
                "model": "Panorama",
                "device": "tablet"
            },
            {
                "regex": "(?:Fly_)?IQ236(?:[);/ ]|$)",
                "model": "Victory"
            },
            {
                "regex": "Slimline(?:[);/ ]|$)",
                "model": "Slimline"
            },
            {
                "regex": "Power Plus 5000(?:[);/ ]|$)",
                "model": "Power Plus 5000"
            },
            {
                "regex": "Photo Pro(?:[);/ ]|$)",
                "model": "Photo Pro"
            },
            {
                "regex": "Life Ace(?:[);/ ]|$)",
                "model": "Life Ace"
            },
            {
                "regex": "Life Jet(?:[);/ ]|$)",
                "model": "Life Jet"
            },
            {
                "regex": "Life Sky(?:[);/ ]|$)",
                "model": "Life Sky"
            },
            {
                "regex": "Life Geo(?:[);/ ]|$)",
                "model": "Life Geo"
            },
            {
                "regex": "Life Compact 4G(?:[);/ ]|$)",
                "model": "Life Compact 4G"
            },
            {
                "regex": "FS506",
                "model": "Cirrus 3"
            },
            {
                "regex": "FS403",
                "model": "Cumulus 1"
            },
            {
                "regex": "FS508",
                "model": "Cirrus 6"
            },
            {
                "regex": "FS511",
                "model": "Cirrus 7"
            },
            {
                "regex": "FS509",
                "model": "Nimbus 9"
            },
            {
                "regex": "FS406",
                "model": "Stratus 5"
            },
            {
                "regex": "FS404",
                "model": "Stratus 3"
            },
            {
                "regex": "FS504",
                "model": "Cirrus 2"
            },
            {
                "regex": "FS407",
                "model": "Stratus 6"
            },
            {
                "regex": "FS401",
                "model": "Stratus 1"
            },
            {
                "regex": "FS402",
                "model": "Stratus 2"
            },
            {
                "regex": "FS501",
                "model": "Nimbus 3"
            },
            {
                "regex": "FS502",
                "model": "Cirrus 1"
            },
            {
                "regex": "FS507",
                "model": "Cirrus 4"
            },
            {
                "regex": "FS505",
                "model": "Nimbus 7"
            },
            {
                "regex": "FS551",
                "model": "Nimbus 4"
            },
            {
                "regex": "FS514",
                "model": "Cirrus 8"
            },
            {
                "regex": "FS553",
                "model": "Cirrus 9"
            },
            {
                "regex": "FS554",
                "model": "Power Plus FHD"
            },
            {
                "regex": "FS517",
                "model": "Cirrus 11"
            },
            {
                "regex": "FS516",
                "model": "Cirrus 12"
            },
            {
                "regex": "FS518",
                "model": "Cirrus 13"
            },
            {
                "regex": "FS520",
                "model": "Selfie 1"
            },
            {
                "regex": "FS521",
                "model": "Power Plus 1"
            },
            {
                "regex": "FS522",
                "model": "Cirrus 14"
            },
            {
                "regex": "FS523",
                "model": "Cirrus 16"
            },
            {
                "regex": "FS524",
                "model": "Knockout"
            },
            {
                "regex": "FS526",
                "model": "Power Plus 2"
            },
            {
                "regex": "FS527",
                "model": "Nimbus 17"
            },
            {
                "regex": "FS528",
                "model": "Memory Plus"
            },
            {
                "regex": "FS529",
                "model": "Сhamp"
            },
            {
                "regex": "FS530",
                "model": "Power Plus XXL"
            },
            {
                "regex": "FS454",
                "model": "Nimbus 8"
            },
            {
                "regex": "FS452",
                "model": "Nimbus 2"
            },
            {
                "regex": "FS512",
                "model": "Nimbus 10"
            },
            {
                "regex": "FS510",
                "model": "Nimbus 12"
            },
            {
                "regex": "FS451",
                "model": "Nimbus 1"
            },
            {
                "regex": "FS405",
                "model": "Stratus 4"
            },
            {
                "regex": "FS408",
                "model": "Stratus 8"
            },
            {
                "regex": "FS409",
                "model": "Stratus 9"
            },
            {
                "regex": "FS455",
                "model": "Nimbus 11"
            },
            {
                "regex": "FS456",
                "model": "Nimbus 14"
            },
            {
                "regex": "FS457",
                "model": "Nimbus 15"
            },
            {
                "regex": "FS459",
                "model": "Nimbus 16"
            },
            {
                "regex": "FS458",
                "model": "Stratus 7"
            },
            {
                "regex": "(?:Fly_)?IQ237(?:[);/ ]|$)",
                "model": "Dynamic"
            },
            {
                "regex": "(?:Fly_)?IQ238(?:[);/ ]|$)",
                "model": "Jazz"
            },
            {
                "regex": "(?:Fly_)?IQ240(?:[);/ ]|$)",
                "model": "Whizz"
            },
            {
                "regex": "(?:Fly_)?IQ255(?:[);/ ]|$)",
                "model": "Pride"
            },
            {
                "regex": "(?:Fly_)?IQ270(?: Firebird)?(?:[);/ ]|$)",
                "model": "Firebird"
            },
            {
                "regex": "(?:Fly_)?IQ275(?:[);/ ]|$)",
                "model": "Marathon"
            },
            {
                "regex": "(?:Fly_)?IQ285(?: Turbo)?(?:[);/ ]|$)",
                "model": "Turbo"
            },
            {
                "regex": "(?:Fly_)?IQ430(?:[);/ ]|$)",
                "model": "Evoke"
            },
            {
                "regex": "(?:Fly_)?IQ431(?:[);/ ]|$)",
                "model": "Glory"
            },
            {
                "regex": "(?:Fly_)?IQ432(?:[);/ ]|$)",
                "model": "Era Nano 1"
            },
            {
                "regex": "(?:Fly_)?IQ436(?:[);/ ]|$)",
                "model": "Era Nano 3"
            },
            {
                "regex": "(?:Fly_)?IQ4490(?:[);/ ]|$)",
                "model": "Era Nano 4"
            },
            {
                "regex": "(?:Fly_)?IQ434(?:[);/ ]|$)",
                "model": "Era Nano 5"
            },
            {
                "regex": "(?:Fly_)?IQ4406(?:[);/ ]|$)",
                "model": "Era Nano 6"
            },
            {
                "regex": "(?:Fly_)?IQ436i(?:[);/ ]|$)",
                "model": "Era Nano 9"
            },
            {
                "regex": "(?:Fly_)?IQ440(?:[);/ ]|$)",
                "model": "Energy"
            },
            {
                "regex": "(?:Fly_)?IQ4401(?:[);/ ]|$)",
                "model": "Era Energy 2"
            },
            {
                "regex": "(?:Fly_)?IQ441(?:[);/ ]|$)",
                "model": "Radiance"
            },
            {
                "regex": "(?:Fly_)?IQ442 Quad(?:[);/ ]|$)",
                "model": "Miracle 2"
            },
            {
                "regex": "(?:Fly_)?IQ442(?:[);/ ]|$)",
                "model": "Miracle"
            },
            {
                "regex": "(?:Fly_)?IQ443(?:[);/ ]|$)",
                "model": "Trend"
            },
            {
                "regex": "(?:Fly_)?IQ444(?: Quattro)?(?:[);/ ]|$)",
                "model": "Diamond 2"
            },
            {
                "regex": "(?:Fly_)?IQ445(?:[);/ ]|$)",
                "model": "Genius"
            },
            {
                "regex": "(?:Fly_)?IQ446(?: Magic)?(?:[);/ ]|$)",
                "model": "Magic"
            },
            {
                "regex": "(?:Fly_)?IQ447(?:[);/ ]|$)",
                "model": "Era Life 1"
            },
            {
                "regex": "(?:Fly_)?IQ456(?:[);/ ]|$)",
                "model": "Era Life 2"
            },
            {
                "regex": "(?:Fly_)?IQ4409 Quad(?:[);/ ]|$)",
                "model": "Era Life 4"
            },
            {
                "regex": "(?:Fly_)?IQ448(?:[);/ ]|$)",
                "model": "Chic"
            },
            {
                "regex": "(?:Fly_)?IQ449(?:[);/ ]|$)",
                "model": "Pronto"
            },
            {
                "regex": "(?:Fly_)?IQ450(?:[);/ ]|$)",
                "model": "Horizon"
            },
            {
                "regex": "(?:Fly_)?IQ450[ _]Quattro(?:[);/ ]|$)",
                "model": "Horizon 2"
            },
            {
                "regex": "(?:Fly_)?IQ451(?:[);/ ]|$)",
                "model": "Vista"
            },
            {
                "regex": "(?:Fly_)?IQ452 Quad(?:[);/ ]|$)",
                "model": "Ego Vision 1"
            },
            {
                "regex": "(?:Fly_)?IQ454(?:[);/ ]|$)",
                "model": "Evo Tech 1"
            },
            {
                "regex": "(?:Fly_)?IQ4403(?:[);/ ]|$)",
                "model": "Energy 3"
            },
            {
                "regex": "(?:Fly_)?IQ4404(?:[);/ ]|$)",
                "model": "Spark"
            },
            {
                "regex": "(?:Fly_)?IQ4410 Quad(?:[);/ ]|$)",
                "model": "Phoenix"
            },
            {
                "regex": "(?:Fly_)?IQ4411(?:[);/ ]|$)",
                "model": "Energy 2"
            },
            {
                "regex": "(?:Fly_)?IQ4412 Quad(?:[);/ ]|$)",
                "model": "Coral"
            },
            {
                "regex": "(?:Fly_)?IQ4413[ _]Quad(?:[);/ ]|$)",
                "model": "Evo Chic 3"
            },
            {
                "regex": "(?:Fly_)?IQ4414 Quad(?:[);/ ]|$)",
                "model": "Evo Tech 3"
            },
            {
                "regex": "(?:Fly_)?IQ4415 Quad(?:[);/ ]|$)",
                "model": "Era Style 3"
            },
            {
                "regex": "(?:Fly_)?IQ4504 Quad(?:[);/ ]|$)",
                "model": "Evo Energy 5"
            },
            {
                "regex": "(?:Fly_)?IQ([0-9]+[i]? ?(?:Quad|Firebird|Quattro)?)(?:[);/ ]|$)",
                "model": "IQ$1"
            },
            {
                "regex": "Fly[ _\\-]?([a-z0-9_]+)/",
                "model": "$1",
                "device": "feature phone"
            },
            {
                "regex": "Flylife[ _\\-]?([^/;]+) Build",
                "model": "Flylife $1",
                "device": "tablet"
            },
            {
                "regex": "Fly[ _\\-]?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "MERIDIAN-([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "FinePower": {
        "regex": "FinePower[_ ]?([AB][1-9]|[CD][1-9])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "FinePower[_ ]?([AB][1-9])(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "FinePower[_ ]?([CD][1-9])(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Freetel": {
        "regex": "(?:FTJ17[AC]00|FTJ152[ABCD]|FTU18A00|FT141B|FT142D(?:_LTEXM)?|FT142A?|FTJ161[AB]|FTJ1[56]2E|FTJ162[BD]|FTE161[GE])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "FTJ152C",
                "model": "Samurai Miyabi"
            },
            {
                "regex": "FTJ17A00(?:[);/ ]|$)",
                "model": "Rei 2 Dual"
            },
            {
                "regex": "FTJ17C00(?:[);/ ]|$)",
                "model": "Priori 5"
            },
            {
                "regex": "FTU18A00(?:[);/ ]|$)",
                "model": "Cricket Wave"
            },
            {
                "regex": "FTJ161A",
                "model": "Musashi"
            },
            {
                "regex": "FTE161E",
                "model": "Ice 2"
            },
            {
                "regex": "FTE161G",
                "model": "Ice 2 Plus"
            },
            {
                "regex": "FTJ162E",
                "model": "Raijin"
            },
            {
                "regex": "FT141B",
                "model": "Nico"
            },
            {
                "regex": "FT142D(?:_LTEXM)?(?:[);/ ]|$)",
                "model": "XM"
            },
            {
                "regex": "FT142A?",
                "model": "Priori 2"
            },
            {
                "regex": "FTJ152A",
                "model": "Priori 3"
            },
            {
                "regex": "FTJ162D",
                "model": "Priori 4"
            },
            {
                "regex": "FTJ152B",
                "model": "Priori 3S LTE"
            },
            {
                "regex": "FTJ152D",
                "model": "Samurai Kiwami"
            },
            {
                "regex": "FTJ162B",
                "model": "Samurai Kiwami 2"
            },
            {
                "regex": "FTJ161B",
                "model": "Samurai Rei"
            },
            {
                "regex": "FTJ152E",
                "model": "Katana 1"
            }
        ]
    },
    "Western Digital": {
        "regex": "Westerndigital|WDSimpleBrowser",
        "device": "tv",
        "models": [
            {
                "regex": "Streamer2010",
                "model": "Streamer (2010)"
            }
        ]
    },
    "Zeemi": {
        "regex": "ZEEMI[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZEEMI[ _-]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "ZEEMI[ _-]([^/;)]+)(?:[);/]|$)",
                "model": "$1"
            }
        ]
    },
    "Zenek": {
        "regex": "Z5007|Z551[679]|Z6001",
        "device": "smartphone",
        "models": [
            {
                "regex": "Z5517",
                "model": "Leopardo"
            },
            {
                "regex": "Z6001",
                "model": "Libelula"
            },
            {
                "regex": "Z5007",
                "model": "Oso"
            },
            {
                "regex": "Z5519",
                "model": "Pingûino"
            },
            {
                "regex": "Z5516",
                "model": "Zebra"
            }
        ]
    },
    "Zopo": {
        "regex": "ZOPO|(?:ZOPO[_ ])?(Flash X3|ZP[0-9]{2,}[^/;]+)(?:\\)| Build)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:ZOPO_C2_MOD|ZP998)(?:[);/ ]|$)",
                "model": "C2 II"
            },
            {
                "regex": "ZOPO 9xxQuad(?:[);/ ]|$)",
                "model": "9XX Quad"
            },
            {
                "regex": "(?:ZOPO_)?ZP980[+](?:[);/ ]|$)",
                "model": "ZP980+"
            },
            {
                "regex": "(?:ZOPO_)?ZP980(?:[);/ ]|$)",
                "model": "Scorpio"
            },
            {
                "regex": "ZP952(?:[);/ ]|$)",
                "model": "Speed 7 Plus"
            },
            {
                "regex": "ZP951(?:[);/ ]|$)",
                "model": "Speed 7"
            },
            {
                "regex": "ZP955(?:[);/ ]|$)",
                "model": "Speed 8"
            },
            {
                "regex": "ZP950[+h]?(?:[);/ ]|$)",
                "model": "Leader Max"
            },
            {
                "regex": "ZP(?:900H?|910)(?:[);/ ]|$)",
                "model": "Leader"
            },
            {
                "regex": "ZP(?:800H|810)(?:[);/ ]|$)",
                "model": "Libero HD"
            },
            {
                "regex": "ZP500[+]?(?:[);/ ]|$)",
                "model": "Libero"
            },
            {
                "regex": "ZP330(?:[);/ ]|$)",
                "model": "Color C"
            },
            {
                "regex": "ZP370(?:[);/ ]|$)",
                "model": "Color S"
            },
            {
                "regex": "ZP5(63|86)(?:[);/ ]|$)",
                "model": "Color X"
            },
            {
                "regex": "ZP567(?:[);/ ]|$)",
                "model": "Color C5i"
            },
            {
                "regex": "ZP300[S+]?(?:[);/ ]|$)",
                "model": "Field"
            },
            {
                "regex": "ZP200[+]?(?:[);/ ]|$)",
                "model": "Shining"
            },
            {
                "regex": "ZP100(?:[);/ ]|$)",
                "model": "Pilot"
            },
            {
                "regex": "ZP1790(?:[);/ ]|$)",
                "model": "Flash X2"
            },
            {
                "regex": "ZP781(?:[);/ ]|$)",
                "model": "Flash G5 Plus"
            },
            {
                "regex": "(?:ZOPO_)?(Flash X3|X1i|ZP[0-9]{2,}[^/;)]+)(?: Build|\\))",
                "model": "$1"
            }
        ]
    },
    "ZTE": {
        "regex": "ZTE|AxonPhone|([a-z0-9]+)_USA_Cricket|(?:Blade (?:V0820|L110|L[2357]|L7A|S6|V[6789]|V8Q|V8 SE|V9 VITA|X7|A(310|460|465|475|520|530|602)|V580|V Ultra|Q Lux)|N9[15]8St|NX(?:403A|404H|406E|40[X2]|507J|503A|505J|506J|508J|510J|512J|511J|513J|521J|523J_V1|529J|531J|541J|5[48]9J|551J|563J|569[HJ]|573J|575J|59[157]J|60[1689]J|61[12679]J|62[79]J|65[19]J|907J)|N818S|N951[0579]|N91[38]0|N9101|N913[267]|N952[01]|N9560|N9810|N799D|[UV]9180|[UV]9815|Z(?:233V|331|5031O|559DL|6621O|667T|768G|792|81[25]|818L|82[08]|83[12359]|85[125]|851M|992|(557|71[67]|798|836|861|916)BL|986DL|(232|718|828)TL|(?:233|353|558|717|799|837|862|899|917|963)VL|955A|95[678]|965|97[018]|98[1237]|986U|999|936L)|V769M|Apex2|G (LTE|Lux)|Vec|Z959|V865M|Z3001S|902ZT|KIS II Max|Kis 3|K3DX-V5G|Z930L|Optus X|Blade[ _](A510|A[357] 2019-T|A6 MAX|A0622|X9)|Z3153V|Z836F|Nubia Z(?:9|11)|Ctyon-A9|602ZT|MO-01[JK]|Z963U|402ZT|P545|P609|dandelion|901ZT|A001ZT|Z-01K|UZTE V808|ZR01|ZTG01|K8[37]CA)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "602ZT(?:[);/ ]|$)",
                "model": "Libero 2"
            },
            {
                "regex": "A001ZT(?:[);/ ]|$)",
                "model": "Libero 3"
            },
            {
                "regex": "901ZT(?:[);/ ]|$)",
                "model": "Libero S10"
            },
            {
                "regex": "ZR01(?:[);/ ]|$)",
                "model": "Rakuten Big"
            },
            {
                "regex": "ZTG01(?:[);/ ]|$)",
                "model": "A1"
            },
            {
                "regex": "A7020(?:[);/ ]|$)",
                "model": "Blade A7s (2020)"
            },
            {
                "regex": "ZTE 2050(?:RU)?",
                "model": "Blade 20 Smart"
            },
            {
                "regex": "902ZT(?:[);/ ]|$)",
                "model": "Axon 10 Pro 5G"
            },
            {
                "regex": "N799D(?:[);/ ]|$)",
                "model": "Blade Eg"
            },
            {
                "regex": "Z818L(?:[);/ ]|$)",
                "model": "Allstar"
            },
            {
                "regex": "Z3001S(?:[);/ ]|$)",
                "model": "Quest Plus"
            },
            {
                "regex": "Ctyon-A9(?:[);/ ]|$)",
                "model": "Ctyon A9"
            },
            {
                "regex": "K3DX-V5G(?:[);/ ]|$)",
                "model": "V5G"
            },
            {
                "regex": "N918St(?:[);/ ]|$)",
                "model": "V5S"
            },
            {
                "regex": "N958St(?:[);/ ]|$)",
                "model": "V5 Max"
            },
            {
                "regex": "N9101(?:[);/ ]|$)",
                "model": "Imperial"
            },
            {
                "regex": "Z963U(?:[);/ ]|$)",
                "model": "Imperial Max"
            },
            {
                "regex": "N9120(?:[);/ ]|$)",
                "model": "Avid"
            },
            {
                "regex": "N9130(?:[);/ ]|$)",
                "model": "Speed"
            },
            {
                "regex": "N9132(?:[);/ ]|$)",
                "model": "Prestige"
            },
            {
                "regex": "N9136(?:[);/ ]|$)",
                "model": "Prestige 2"
            },
            {
                "regex": "N9137(?:[);/ ]|$)",
                "model": "Tempo X"
            },
            {
                "regex": "N9180(?:[);/ ]|$)",
                "model": "V5"
            },
            {
                "regex": "N9510(?:[);/ ]|$)",
                "model": "Warp 4G"
            },
            {
                "regex": "N9517(?:[);/ ]|$)",
                "model": "Blade Force"
            },
            {
                "regex": "Z559DL(?:[);/ ]|$)",
                "model": "Blade T2"
            },
            {
                "regex": "402ZT(?:[);/ ]|$)",
                "model": "Blade Q+"
            },
            {
                "regex": "Blade Q Lux(?:[);/ ]|$)",
                "model": "Blade Q Lux"
            },
            {
                "regex": "N9515(?:[);/ ]|$)",
                "model": "Warp Sync"
            },
            {
                "regex": "N9519(?:[);/ ]|$)",
                "model": "Warp 7"
            },
            {
                "regex": "N9520(?:[);/ ]|$)",
                "model": "Boost Max"
            },
            {
                "regex": "N9521(?:[);/ ]|$)",
                "model": "Boost Max+"
            },
            {
                "regex": "N9560(?:[);/ ]|$)",
                "model": "Max XL"
            },
            {
                "regex": "N9810(?:[);/ ]|$)",
                "model": "Vital"
            },
            {
                "regex": "NX40[X2](?:[);/ ]|$)",
                "model": "Nubia Z5 Mini"
            },
            {
                "regex": "NX(403[AE]|406E|404H)(?:[);/ ]|$)",
                "model": "Nubia Z5S Mini"
            },
            {
                "regex": "NX503A(?:[);/ ]|$)",
                "model": "Nubia Z5S"
            },
            {
                "regex": "NX506J(?:[);/ ]|$)",
                "model": "Nubia Z7"
            },
            {
                "regex": "NX507J(?:[);/ ]|$)",
                "model": "Nubia Z7 Mini"
            },
            {
                "regex": "NX505J(?:[);/ ]|$)",
                "model": "Nubia Z7 Max"
            },
            {
                "regex": "NX508J(?:[);/ ]|$)",
                "model": "Nubia Z9"
            },
            {
                "regex": "(NX5[12]1J|Nubia Z9 mini)(?:[);/ ]|$)",
                "model": "Nubia Z9 Mini"
            },
            {
                "regex": "(NX510J|Nubia Z9 Max)(?:[);/ ]|$)",
                "model": "Nubia Z9 Max"
            },
            {
                "regex": "NX512J(?:[);/ ]|$)",
                "model": "Nubia Z9 Max Dual"
            },
            {
                "regex": "NX531J(?:[);/ ]|$)",
                "model": "Nubia Z11"
            },
            {
                "regex": "NX523J_V1",
                "model": "Nubia Z11 Max"
            },
            {
                "regex": "(?:NX549J|Nubia Z11 mini S)(?:[);/ ]|$)",
                "model": "Nubia Z11 Mini S"
            },
            {
                "regex": "(?:NX529J|Nubia Z11 mini)(?:[);/ ]|$)",
                "model": "Nubia Z11 Mini"
            },
            {
                "regex": "NX606J(?:[);/ ]|$)",
                "model": "Nubia Z18"
            },
            {
                "regex": "NX616J(?:[);/ ]|$)",
                "model": "Nubia Z18S"
            },
            {
                "regex": "NX611J(?:[);/ ]|$)",
                "model": "Nubia Z18 Mini"
            },
            {
                "regex": "NX551J(?:[);/ ]|$)",
                "model": "Nubia M2"
            },
            {
                "regex": "NX563J(?:[);/ ]|$)",
                "model": "Nubia Z17"
            },
            {
                "regex": "NX569[HJ](?:[);/ ]|$)",
                "model": "Nubia Z17 Mini"
            },
            {
                "regex": "NX589J(?:[);/ ]|$)",
                "model": "Nubia Z17 Mini S"
            },
            {
                "regex": "NX591J(?:[);/ ]|$)",
                "model": "Nubia Z17 Lite"
            },
            {
                "regex": "NX595J(?:[);/ ]|$)",
                "model": "Nubia Z17S"
            },
            {
                "regex": "NX612J(?:[);/ ]|$)",
                "model": "Nubia V18"
            },
            {
                "regex": "NX627J",
                "model": "Nubia Z20"
            },
            {
                "regex": "NX513J(?:[);/ ]|$)",
                "model": "Nubia My Prague"
            },
            {
                "regex": "NX601J(?:[);/ ]|$)",
                "model": "Nubia X6"
            },
            {
                "regex": "NX609J(?:[);/ ]|$)",
                "model": "Nubia Red Magic"
            },
            {
                "regex": "NX659J(?:[);/ ]|$)",
                "model": "Nubia Red Magic 5G"
            },
            {
                "regex": "NX651J(?:[);/ ]|$)",
                "model": "Nubia Play"
            },
            {
                "regex": "NX619J(?:[);/ ]|$)",
                "model": "Nubia Red Magic Mars"
            },
            {
                "regex": "NX629J(?:[);/ ]|$)",
                "model": "Nubia Red Magic 3"
            },
            {
                "regex": "NX573J",
                "model": "Nubia M2 Lite"
            },
            {
                "regex": "NX907J(?:[);/ ]|$)",
                "model": "Nubia M2 Play"
            },
            {
                "regex": "NX541J",
                "model": "Nubia N1"
            },
            {
                "regex": "NX597J",
                "model": "Nubia N1 Lite"
            },
            {
                "regex": "NX575J",
                "model": "Nubia N2"
            },
            {
                "regex": "NX6(08|17)J(?:[);/ ]|$)",
                "model": "Nubia N3"
            },
            {
                "regex": "[UV]9180(?:[);/ ]|$)",
                "model": "V5 Red Bull"
            },
            {
                "regex": "[UV]9815(?:[);/ ]|$)",
                "model": "Grand Memo LTE"
            },
            {
                "regex": "V779M",
                "model": "Joey Jump 2"
            },
            {
                "regex": "V807",
                "model": "Blade C"
            },
            {
                "regex": "V809",
                "model": "Blade C2"
            },
            {
                "regex": "ZTE_Blade_C2_Plus",
                "model": "Blade C2 Plus"
            },
            {
                "regex": "Blade G Plus",
                "model": "Blade G Plus"
            },
            {
                "regex": "ZTE_Blade_III",
                "model": "Blade III"
            },
            {
                "regex": "(?:ZTE_)?V829",
                "model": "Blade G Pro"
            },
            {
                "regex": "V882",
                "model": "Lord"
            },
            {
                "regex": "V967S",
                "model": "Grand X2"
            },
            {
                "regex": "V970M?|V987",
                "model": "Grand X"
            },
            {
                "regex": "Z959(?:[);/ ]|$)",
                "model": "Grand X3"
            },
            {
                "regex": "V8000",
                "model": "Nova 4"
            },
            {
                "regex": "Z95[67]",
                "model": "Grand X4"
            },
            {
                "regex": "Z987",
                "model": "Grand X Max+"
            },
            {
                "regex": "(?:ZTE_)?Grand[ _]Era",
                "model": "Grand Era"
            },
            {
                "regex": "V788D",
                "model": "Kis Plus"
            },
            {
                "regex": "Z331(?:[);/ ]|$)",
                "model": "Z331"
            },
            {
                "regex": "N818S(?:[);/ ]|$)",
                "model": "N818S"
            },
            {
                "regex": "Z5031O(?:[);/ ]|$)",
                "model": "Optus X Spirit 2"
            },
            {
                "regex": "P545(?:[);/ ]|$)",
                "model": "Optus X Power 2"
            },
            {
                "regex": "P609(?:[);/ ]|$)",
                "model": "Optus X Wave"
            },
            {
                "regex": "Optus X Start(?:[);/ ]|$)",
                "model": "Optus X Start"
            },
            {
                "regex": "BA520(?:[);/ ]|$)",
                "model": "Blade A520"
            },
            {
                "regex": "Blade (A(0620|310|321|452|460|462|465|475|510|512|52[012]|530|531|602|612|910)|L[12]10|L130|V0730|V0800|V580|V1000)(?:[);/ ]|$)",
                "model": "Blade $1"
            },
            {
                "regex": "Blade L2 Plus(?:[);/ ]|$)",
                "model": "Blade L2 Plus"
            },
            {
                "regex": "(?:ZTE_)?Blade[ _]L2(?:[);/ ]|$)",
                "model": "Blade L2"
            },
            {
                "regex": "Blade L3 Plus(?:[);/ ]|$)",
                "model": "Blade L3 Plus"
            },
            {
                "regex": "Blade L3 Apex(?:[);/ ]|$)",
                "model": "Blade L3 Apex"
            },
            {
                "regex": "Blade L3(?:[);/ ]|$)",
                "model": "Blade L3"
            },
            {
                "regex": "Blade L5 Plus(?:[);/ ]|$)",
                "model": "Blade L5 Plus"
            },
            {
                "regex": "Blade L5(?:[);/ ]|$)",
                "model": "Blade L5"
            },
            {
                "regex": "Blade L6(?:[);/ ]|$)",
                "model": "Blade L6"
            },
            {
                "regex": "Blade L7A(?:[);/ ]|$)",
                "model": "Blade L7A"
            },
            {
                "regex": "Blade L7(?:[);/ ]|$)",
                "model": "Blade L7"
            },
            {
                "regex": "Blade L8(?:RU)?(?:[);/ ]|$)",
                "model": "Blade L8"
            },
            {
                "regex": "Blade A([357]) (20(?:19|20))",
                "model": "Blade A$1 ($2)"
            },
            {
                "regex": "Blade A3 Lite(?:[);/ ]|$)",
                "model": "Blade A3 Lite"
            },
            {
                "regex": "BLADE A0622(?:[);/ ]|$)",
                "model": "Blade A6"
            },
            {
                "regex": "BLADE A6 MAX(?:[);/ ]|$)",
                "model": "Blade A6 Max"
            },
            {
                "regex": "Blade S6 Plus(?:[);/ ]|$)",
                "model": "Blade S6 Plus"
            },
            {
                "regex": "Blade S6(?:[);/ ]|$)",
                "model": "Blade S6"
            },
            {
                "regex": "T920(?:[);/ ]|$)",
                "model": "Blade S7"
            },
            {
                "regex": "BLADE V Ultra(?:[);/ ]|$)",
                "model": "Blade V Ultra"
            },
            {
                "regex": "Blade V6 MAX(?:[);/ ]|$)",
                "model": "Blade V6 Max"
            },
            {
                "regex": "Blade V6 Plus(?:[);/ ]|$)",
                "model": "Blade V6 Plus"
            },
            {
                "regex": "Blade (?:V7 Lite|V0720)(?:[);/ ]|$)",
                "model": "Blade V7 Lite"
            },
            {
                "regex": "Blade V([67])(?:[);/ ]|$)",
                "model": "Blade V$1"
            },
            {
                "regex": "Blade X([79])(?:[);/ ]|$)",
                "model": "Blade X$1"
            },
            {
                "regex": "Blade V8Q(?:[);/ ]|$)",
                "model": "Blade V8Q"
            },
            {
                "regex": "Blade V8 SE(?:[);/ ]|$)",
                "model": "Blade V8 SE"
            },
            {
                "regex": "Blade V(9|10) Vita(?:[);/ ]|$)",
                "model": "Blade V$1 Vita"
            },
            {
                "regex": "Blade V([89]|10)(?:[);/ ]|$)",
                "model": "Blade V$1"
            },
            {
                "regex": "BLADE V0820(?:[);/ ]|$)",
                "model": "Blade V8 Lite"
            },
            {
                "regex": "BLADE V0850(?:[);/ ]|$)",
                "model": "Blade V8 Mini"
            },
            {
                "regex": "(?:Blade[ _])?(Apex2|G (LTE|Lux)|Vec|A510)",
                "model": "Blade $1"
            },
            {
                "regex": "Z768G(?:[);/ ]|$)",
                "model": "Midnight"
            },
            {
                "regex": "Z820",
                "model": "Obsidian"
            },
            {
                "regex": "Z986U",
                "model": "Blade Max 3"
            },
            {
                "regex": "Z971",
                "model": "Blade Spark"
            },
            {
                "regex": "Z978",
                "model": "Blade V8 Pro"
            },
            {
                "regex": "Z839",
                "model": "Blade Vantage"
            },
            {
                "regex": "Z3153V",
                "model": "Blade Vantage 2"
            },
            {
                "regex": "Z930L",
                "model": "Unico LTE"
            },
            {
                "regex": "Z965",
                "model": "Blade X"
            },
            {
                "regex": "Z981",
                "model": "Blade Z Max Pro"
            },
            {
                "regex": "Z982",
                "model": "Blade Z Max"
            },
            {
                "regex": "Z983",
                "model": "Blade X Max"
            },
            {
                "regex": "Z717[BV]L(?:[);/ ]|$)",
                "model": "Citrine LTE"
            },
            {
                "regex": "Z233VL(?:[);/ ]|$)",
                "model": "Cymbal-C LTE"
            },
            {
                "regex": "Z233V",
                "model": "Cymbal LTE"
            },
            {
                "regex": "Z232TL",
                "model": "Cymbal-G LTE"
            },
            {
                "regex": "Z353VL",
                "model": "Cymbal-T LTE"
            },
            {
                "regex": "Z718TL",
                "model": "Jasper LTE"
            },
            {
                "regex": "KIS II Max",
                "model": "Kis II Max"
            },
            {
                "regex": "Kis 3",
                "model": "Kis 3"
            },
            {
                "regex": "(?:Z798BL|Z799VL)(?:[);/ ]|$)",
                "model": "Majesty Pro LTE"
            },
            {
                "regex": "Z899VL",
                "model": "Majesty Pro Plus LTE"
            },
            {
                "regex": "Z828TL",
                "model": "Midnight Pro LTE"
            },
            {
                "regex": "(?:ZTE-)?Z792",
                "model": "Fanfare"
            },
            {
                "regex": "(?:ZTE-)?Z812",
                "model": "Maven"
            },
            {
                "regex": "Z815",
                "model": "Fanfare 2"
            },
            {
                "regex": "Z831",
                "model": "Maven 2"
            },
            {
                "regex": "Z832",
                "model": "Sonata 3"
            },
            {
                "regex": "Z835",
                "model": "Maven 3"
            },
            {
                "regex": "Z851(?:[);/ ]|$)",
                "model": "Prelude Plus"
            },
            {
                "regex": "Z851M",
                "model": "Overture 3"
            },
            {
                "regex": "Z852",
                "model": "Fanfare 3"
            },
            {
                "regex": "Z828",
                "model": "Avid Plus"
            },
            {
                "regex": "Z855",
                "model": "Avid 4"
            },
            {
                "regex": "Z833",
                "model": "Avid TRIO"
            },
            {
                "regex": "(?:Z836BL|Z837VL|Z836F)(?:[);/ ]|$)",
                "model": "ZFive 2 LTE"
            },
            {
                "regex": "Z558VL",
                "model": "ZFive C LTE"
            },
            {
                "regex": "Z557BL",
                "model": "ZFive G LTE"
            },
            {
                "regex": "(?:Z861BL|Z862VL)(?:[);/ ]|$)",
                "model": "ZFive L LTE"
            },
            {
                "regex": "Z916BL",
                "model": "ZMax Grand LTE"
            },
            {
                "regex": "Z917VL",
                "model": "ZMax Champ LTE"
            },
            {
                "regex": "(?:Z958|Z955A)(?:[);/ ]|$)",
                "model": "ZMax 2"
            },
            {
                "regex": "dandelion(?:[);/ ]|$)",
                "model": "ZMax 3"
            },
            {
                "regex": "Z963VL",
                "model": "Max Duo LTE"
            },
            {
                "regex": "Z970",
                "model": "ZMax Z970"
            },
            {
                "regex": "Z986DL",
                "model": "MAX Blue LTE"
            },
            {
                "regex": "(?:ZTE[-_])?Z992",
                "model": "Avail 2"
            },
            {
                "regex": "(?:Z999|Z-01K)(?:[);/ ]|$)",
                "model": "Axon M"
            },
            {
                "regex": "B2016",
                "model": "Axon Mini"
            },
            {
                "regex": "A2015",
                "model": "Axon Tianji"
            },
            {
                "regex": "A2017[GU]?",
                "model": "Axon 7"
            },
            {
                "regex": "A2018",
                "model": "Axon 7s"
            },
            {
                "regex": "A2019G Pro",
                "model": "Axon Pro"
            },
            {
                "regex": "B2017G",
                "model": "Axon 7 Mini"
            },
            {
                "regex": "A2020G? Pro(?:[);/ ]|$)",
                "model": "Axon 10 Pro"
            },
            {
                "regex": "Z667T",
                "model": "Zinger"
            },
            {
                "regex": "V?975|geek",
                "model": "Geek"
            },
            {
                "regex": "Z716BL",
                "model": "Citrine LTE"
            },
            {
                "regex": "X500",
                "model": "Score"
            },
            {
                "regex": "X501",
                "model": "Groove"
            },
            {
                "regex": "(?:ZTE-)?G-X991",
                "model": "Rio"
            },
            {
                "regex": "F-450",
                "model": "Adamant"
            },
            {
                "regex": "Z936L(?:[);/ ]|$)",
                "model": "Lever"
            },
            {
                "regex": "MO-01[JK](?:[);/ ]|$)",
                "model": "Mono"
            },
            {
                "regex": "V865M(?:[);/ ]|$)",
                "model": "V865M"
            },
            {
                "regex": "Z6621O(?:[);/ ]|$)",
                "model": "Optus X Vista"
            },
            {
                "regex": "V769M(?:[);/ ]|$)",
                "model": "Leo Q2"
            },
            {
                "regex": "K83CA(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Grand X View 3"
            },
            {
                "regex": "K87CA(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Grand X View 4"
            },
            {
                "regex": "AxonPhone ([^;/]+) Build",
                "model": "AxonPhone $1"
            },
            {
                "regex": "([a-z0-9]+)_USA_Cricket",
                "model": "$1"
            },
            {
                "regex": "ZTE[- ](V98|V96A|V81|V70)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "ZTE[- ]([a-z0-9\\-_ ]+) Build",
                "model": "$1"
            },
            {
                "regex": "ZTE-(?:G |G-)?([a-z0-9 _]+)",
                "model": "$1"
            },
            {
                "regex": "U?ZTE[ _]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Zuum": {
        "regex": "Zuum[ _-]|(?:Akus Z|COVET|MAGNO|ONIX S|STEDI|STELLAR(?:[ _](?:Z|PRO|[MP]1))?|GRAVITY Z|AURA X|COVET_PRO_LITE|RONI)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Akus Z",
                "model": "Akus Z"
            },
            {
                "regex": "COVET_PRO_LITE",
                "model": "Covet Pro Lite"
            },
            {
                "regex": "COVET PRO",
                "model": "Covet Pro"
            },
            {
                "regex": "COVET( Z)?",
                "model": "Covet$1"
            },
            {
                "regex": "MAGNO PLUS",
                "model": "Magno Plus"
            },
            {
                "regex": "MAGNO( C)?",
                "model": "Magno$1"
            },
            {
                "regex": "ONIX S",
                "model": "Onix S"
            },
            {
                "regex": "STEDI",
                "model": "Stedi"
            },
            {
                "regex": "STELLAR PRO",
                "model": "Stellar Pro"
            },
            {
                "regex": "STELLAR PLUS",
                "model": "Stellar Plus"
            },
            {
                "regex": "STELLAR ([MP]1|Z)",
                "model": "Stellar $1"
            },
            {
                "regex": "STELLAR MINI",
                "model": "Stellar Mini"
            },
            {
                "regex": "STELLAR MINI",
                "model": "Stellar Mini"
            },
            {
                "regex": "STELLAR",
                "model": "Stellar"
            },
            {
                "regex": "GRAVITY Z",
                "model": "Gravity Z"
            },
            {
                "regex": "AURA X",
                "model": "Aura X"
            },
            {
                "regex": "RONI",
                "model": "Roni"
            },
            {
                "regex": "Zuum[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Zuum[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Zen": {
        "regex": "(Admire[_ ][^/;]+|Cinemax[^/;)]+)(?:Build|\\))|AdmireGlam",
        "device": "smartphone",
        "models": [
            {
                "regex": "AdmireGlam(?:[);/ ]|$)",
                "model": "Admire Glam"
            },
            {
                "regex": "(Admire[_ ][^/;]+|Cinemax[^/;)]+)(?:Build|\\))",
                "model": "$1"
            }
        ]
    },
    "Zync": {
        "regex": "ZYNC|(Cloud Z5|Z1000|Z18|Z99|Z99[_ ][23]G|Z99|Z900[_ ]Plus|Z909|Z930[+]|Z930)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Z18| DuZ99al Core|Z99[_ ][23]G|Z99 Dual Core|Z99|Z900[_ ]Plus|Z909|Z930[+]|Z930)",
                "model": "$1"
            },
            {
                "regex": "(Z1000[^/;]+)Build",
                "model": "$1"
            },
            {
                "regex": "Cloud (Z5)",
                "model": "Cloud $1"
            },
            {
                "regex": "ZYNC Cloud[ _]([^;]+)Build",
                "model": "Cloud $1"
            },
            {
                "regex": "ZYNC[ _]([^;]+)Build",
                "model": "$1"
            }
        ]
    },
    "Lemhoov": {
        "regex": "Lemhoov",
        "device": "smartphone",
        "models": [
            {
                "regex": "Lemhoov[ _-]([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "MTC": {
        "regex": "MTC[ _](968|97[82]|970|982[OT]?|1078)|(?:MTC[_ ])?SMART[ _]?(?:Race[2]?|Sprint|Run|Surf[2]?)[ _]4G|MTC975|Smart_(?:LINE|Light)|MTC[ _]SMART[ _](?:Run|Start_2)|Redbox Mini 5\\(MTS\\)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MTC[ _]?(97[258]|970[H]?|982[OT]?|968)",
                "model": "$1"
            },
            {
                "regex": "MTC[ _](1078)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "SMART[ _]Race[ _]4G",
                "model": "Smart Race 4G"
            },
            {
                "regex": "SMART[ _]Race2[ _]4G",
                "model": "Smart Race 2 4G"
            },
            {
                "regex": "(?:MTC_)?SMART[ _]Sprint[ _]4G",
                "model": "Smart Sprint 4G"
            },
            {
                "regex": "(?:MTC_)?SMART[ _]Start_2",
                "model": "Smart Start 2"
            },
            {
                "regex": "Smart_LINE",
                "model": "Smart Line"
            },
            {
                "regex": "Smart_Light",
                "model": "Smart Light"
            },
            {
                "regex": "SMART[ _]?Run(?:[ _]4G)?",
                "model": "Smart Run 4G"
            },
            {
                "regex": "SMART[ _]Surf2[ _]4G",
                "model": "Smart Surf 2 4G"
            },
            {
                "regex": "SMART[ _]Surf[ _]4G",
                "model": "Smart Surf 4G"
            },
            {
                "regex": "Redbox Mini 5\\(MTS\\)",
                "device": "tv",
                "model": "Redbox Mini 5"
            }
        ]
    },
    "MegaFon": {
        "regex": "MegaFon|MFLoginPh|MegLogPh|(MFLogin[34]T?|MS3B|SP-A5|SP-A20i)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MFLoginPh|MegLogPh",
                "model": "Login+"
            },
            {
                "regex": "MFLogin4",
                "model": "Login 4 LTE"
            },
            {
                "regex": "MFLogin3T|MegaFon Login 3",
                "model": "Login 3",
                "device": "tablet"
            },
            {
                "regex": "MS3B|Megafon Optima",
                "model": "Optima"
            },
            {
                "regex": "SP-A20i",
                "model": "Mint"
            },
            {
                "regex": "(SP-A5)",
                "model": "$1"
            }
        ]
    },
    "Inoi": {
        "regex": "INOI",
        "device": "smartphone",
        "models": [
            {
                "regex": "INOI 2 Lite 2019",
                "model": "2 Lite (2019)"
            },
            {
                "regex": "INOI ([257]) (2019|202[01])(?:[);/ ]|$)",
                "model": "$1 ($2)"
            },
            {
                "regex": "INOI[_ ]([^);/]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Vertex": {
        "regex": "(?:Luck|Lion_Dual|V709X|Tab [43]G (?:7-2|8-1|10-1)|Pro_P3[01]0_4G|Lion_DC|Baccara|Eagle[ _]4G|ImpressMAX)(?:[);/ ]|$)|Impress[ _]([^;/]+)(?:Build|\\))",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Lion_Dual|Lion_DC|Baccara|Eagle[ _]4G|Luck)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "ImpressMAX(?:[);/ ]|$)",
                "model": "Impress Max"
            },
            {
                "regex": "Pro_P(3[01]0)_4G(?:[);/ ]|$)",
                "model": "Pro P$1 4G"
            },
            {
                "regex": "(Impress[ _]([^;/]+))(?:Build|\\))",
                "model": "$1"
            },
            {
                "regex": "(V709X)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Tab ([43])G ([78]|10)-([21])",
                "device": "tablet",
                "model": "Tab $1G $2.$3\""
            }
        ]
    },
    "Unknown": {
        "regex": "WebTV/(\\d+\\.\\d+)",
        "device": "tv",
        "model": "Web TV"
    },
    "Starway": {
        "regex": "Andromeda[ _]S(707|84[05]|850|8)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Andromeda S$1"
    },
    "Savio": {
        "regex": " (TB-PO1|TB-B01|TB-G01)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Simbans": {
        "regex": "TangoTab|Presto[ )]|Ultimax|Valumax|S72-B|SX2W",
        "device": "tablet",
        "models": [
            {
                "regex": "TangoTab",
                "model": "TangoTab"
            },
            {
                "regex": "Ultimax",
                "model": "Ultimax"
            },
            {
                "regex": "Valumax",
                "model": "Valumax"
            },
            {
                "regex": "Presto",
                "model": "Presto"
            },
            {
                "regex": "S72-B",
                "model": "S72-B"
            },
            {
                "regex": "SX2W",
                "model": "SX2W"
            }
        ]
    },
    "MYFON": {
        "regex": "MYPAD7s",
        "device": "tablet",
        "model": "My Pad 7s"
    },
    "X-TIGI": {
        "regex": "X[-_]TIGI|Hope7[_ ]Mate|Photo_P15_Lite",
        "device": "smartphone",
        "models": [
            {
                "regex": "X-TIGI_JOY10_PRO",
                "model": "Joy 10 Pro",
                "device": "tablet"
            },
            {
                "regex": "Hope7[_ ]Mate",
                "model": "Hope 7 Mate",
                "device": "tablet"
            },
            {
                "regex": "X-TIGI_JOY7_MAX",
                "model": "Joy 7 Max",
                "device": "tablet"
            },
            {
                "regex": "X-TIGI[_ ]V28[_ ]LTE",
                "model": "V28 LTE"
            },
            {
                "regex": "X[-_]TIGI[_ ]V19",
                "model": "V19"
            },
            {
                "regex": "X-TIGI[_ ]Photo[_ ]P11",
                "model": "Photo P11"
            },
            {
                "regex": "Photo_P15_Lite",
                "model": "Photo P15 Lite"
            },
            {
                "regex": "X[-_]TIGI[ _-]([^/;)]+) Build",
                "model": "$1"
            }
        ]
    },
    "Xiaolajiao": {
        "regex": "(LA2-(?:L|S[N]?)|HLA Note3|20190416Q|20170608S|20180322D)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "HLA Note3(?:[);/ ]|$)",
                "model": "Red Pepper Note 3"
            },
            {
                "regex": "(LA2-(?:L|S[N]?))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(20190416Q)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "20170608S(?:[);/ ]|$)",
                "model": "Red Pepper Plus"
            },
            {
                "regex": "20180322D(?:[);/ ]|$)",
                "model": "E Sports"
            }
        ]
    },
    "Ritmix": {
        "regex": "(RMD[-_](?:10(?:2[689]|30|5[089])|1121|75[017]|726|85[57]|870)|RMP-(?:450|50[56]|530|600))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "RMD[-_](10(?:2[689]|30|5[089])|1121|75[017]|726|85[57]|870)(?:[);/ ]|$)",
                "model": "RMD-$1"
            },
            {
                "regex": "RMP[-_](450|50[56]|530|600)(?:[);/ ]|$)",
                "model": "RMP-$1",
                "device": "smartphone"
            }
        ]
    },
    "Ross&Moor": {
        "regex": "RMD[-_](974R|600)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "RMD-$1"
    },
    "R-TV": {
        "regex": "R-TV BOX[ _]?(MINI\\+|X99|X10 PRO|[RXS]10)",
        "device": "tv",
        "model": "Box $1"
    },
    "NEXBOX": {
        "regex": "(MXQ|MXQ-Pro)-NEXBOX|NEXBOX-([^) ]+)",
        "device": "tv",
        "models": [
            {
                "regex": "MXQ-Pro-NEXBOX",
                "model": "MXQ Pro"
            },
            {
                "regex": "MXQ-NEXBOX",
                "model": "MXQ"
            },
            {
                "regex": "NEXBOX-([^) ]+)",
                "model": "$1"
            }
        ]
    },
    "True": {
        "regex": " TRUE BEYOND TAB 3G|SMART[ _](MAX 4.0 PLUS|4G[ _](?:GEN C [45].[05]|Champion|Speedy 5.0 Plus|Speedy[_ ]5inch|P1))",
        "device": "smartphone",
        "models": [
            {
                "regex": "SMART MAX 4.0 PLUS",
                "model": "Smart Max 4.0 Plus"
            },
            {
                "regex": "SMART 4G Gen C ([45].[05])",
                "model": "Smart 4G Gen C $1\""
            },
            {
                "regex": "SMART 4G Speedy 5.0 Plus",
                "model": "Smart 4G Speedy 5.0 Plus"
            },
            {
                "regex": "SMART[ _]4G[_ ]Speedy[_ ]5inch",
                "model": "Smart 4G Speedy 5"
            },
            {
                "regex": "SMART[ _]4G[_ ]Champion",
                "model": "Smart 4G Champion"
            },
            {
                "regex": "SMART[ _]4G[_ ]P1 Prime",
                "model": "Smart 4G P1 Prime"
            },
            {
                "regex": "SMART[ _]4G[_ ]P1",
                "model": "Smart 4G P1"
            },
            {
                "regex": "TRUE BEYOND TAB 3G",
                "model": "Beyond Tab 3G"
            }
        ]
    },
    "Yandex": {
        "regex": "(YNDX-?000SB)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "YNDX-000SB"
    },
    "FORME": {
        "regex": "FORME[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "FORME[ _-]F520(?:[);/ ]|$)",
                "model": "Forever"
            },
            {
                "regex": "FORME[ _-](A[35]7|R7S?|P6)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Shuttle": {
        "regex": "(PNT-704[025])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "BDF": {
        "regex": "(BDF[- ](?:819|P10|K107H|KT107|MT6753|X20)|K960N_MT(?:6580|6753)(?:_32_N)?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "BDF[- ](819|P10|K107H|KT107|MT6753|X20)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "K960N_MT(6580|6753)(_32_N)?(?:[);/ ]|$)",
                "model": "BK960N MT$1"
            }
        ]
    },
    "Highscreen": {
        "regex": "HIGHSCREEN|(Easy[- ]Power(?:[- ]Pro)?|Pure[_ ](?:Power|F)|Power Ice(?: Max)?|Easy[_ ]([SFL]|XL)(?:_Pro)?|Razar_Pro|Power Rage(?: Evo)?|Zera-S-Power|Zera[ _][UFS]|Power[ _]?Five[ matrixstyle _]?(?:Pro|Evo|Max|Max(?:Lite|2))|PowerFour|BOOST II(?:se)?|Fest(?:XL)?(?:-Pro)?|Tasty|Boost3|Boost 3(?: Pro)? SE|Expanse|Hercules|Alpha Rage|VergeM)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Power Ice(?:[ ](?:Max|Evo))?|Power Rage(?: Evo)?|Zera[ _][UFS])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "PowerFivePro(?:[);/ ]|$)",
                "model": "Power Five Pro"
            },
            {
                "regex": "PowerFiveMaxLite(?:[);/ ]|$)",
                "model": "Power Five Max Lite"
            },
            {
                "regex": "PowerFiveMax2(?:[);/ ]|$)",
                "model": "Power Five Max 2"
            },
            {
                "regex": "Power Five Evo(?:[);/ ]|$)",
                "model": "Power Five Evo"
            },
            {
                "regex": "Power Five Max(?:[);/ ]|$)",
                "model": "Power Five Max"
            },
            {
                "regex": "FestXL-Pro(?:[);/ ]|$)",
                "model": "Fest XL Pro"
            },
            {
                "regex": "FestXL(?:[);/ ]|$)",
                "model": "Fest XL"
            },
            {
                "regex": "Fest-Pro(?:[);/ ]|$)",
                "model": "Fest Pro"
            },
            {
                "regex": "Fest(?:[);/ ]|$)",
                "model": "Fest"
            },
            {
                "regex": "PowerFour(?:[);/ ]|$)",
                "model": "Power Four"
            },
            {
                "regex": "Pure[_ ]Power(?:[);/ ]|$)",
                "model": "Pure Power"
            },
            {
                "regex": "Pure[ _]F(?:[);/ ]|$)",
                "model": "Pure F"
            },
            {
                "regex": "Razar_Pro(?:[);/ ]|$)",
                "model": "Razar Pro"
            },
            {
                "regex": "Easy[_ ]([SLF]|XL)[_ ]Pro(?:[);/ ]|$)",
                "model": "Easy $1 Pro"
            },
            {
                "regex": "Easy[_ ]([SFL]|XL)(?:[);/ ]|$)",
                "model": "Easy $1"
            },
            {
                "regex": "(?:HIGHSCREEN )?Easy[- ]Power[- ]Pro(?:[);/ ]|$)",
                "model": "Easy Power Pro"
            },
            {
                "regex": "(?:HIGHSCREEN )?Easy-Power(?:[);/ ]|$)",
                "model": "Easy Power"
            },
            {
                "regex": "BOOST II(?:[);/ ]|$)",
                "model": "Boost 2"
            },
            {
                "regex": "BOOST IIse(?:[);/ ]|$)",
                "model": "Boost 2 SE"
            },
            {
                "regex": "Boost 3 SE(?:[);/ ]|$)",
                "model": "Boost 3 SE"
            },
            {
                "regex": "Boost 3 Pro SE(?:[);/ ]|$)",
                "model": "Boost 3 Pro SE"
            },
            {
                "regex": "BOOST3(?:[);/ ]|$)",
                "model": "Boost 3"
            },
            {
                "regex": "Zera-S-Power(?:[);/ ]|$)",
                "model": "Zera S Power"
            },
            {
                "regex": "Tasty(?:[);/ ]|$)",
                "model": "Tasty"
            },
            {
                "regex": "VergeM(?:[);/ ]|$)",
                "model": "Verge M"
            },
            {
                "regex": "WinWin(?:[);/ ]|$)",
                "model": "WinWin"
            },
            {
                "regex": "Expanse(?:[);/ ]|$)",
                "model": "Expanse"
            },
            {
                "regex": "Hercules(?:[);/ ]|$)",
                "model": "Hercules"
            },
            {
                "regex": "Alpha Rage(?:[);/ ]|$)",
                "model": "Alpha Rage"
            }
        ]
    },
    "CVTE": {
        "regex": "CVTE[_ ](MSD338_(:?1G|512M))(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Globex": {
        "regex": "(GU1011C|GU8012C|GU7013C|GU730C|GU-6012B)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "GU8012C(?:[);/ ]|$)",
                "model": "X8"
            },
            {
                "regex": "GU-6012B(?:[);/ ]|$)",
                "model": "GU6012B"
            },
            {
                "regex": "(GU1011C|GU7013C|GU730C)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Atom": {
        "regex": "ATOM-(108AM|216RK|216AM)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Qumo": {
        "regex": "QUMO[ _]?|(?:Quest[ _]?(?:408|410|45[56]|50[679])|Vega[ _]?78[23]|Sirius[ _]?(?:1001|890))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:QUMO[ _]?)?Vega[ _]?(78[23]|8002)(?:[);/ ]|$)",
                "model": "Vega $1"
            },
            {
                "regex": "Yooda(?:[);/ ]|$)",
                "model": "Yooda"
            },
            {
                "regex": "Sirius[ _]?(1001|890)(?:[);/ ]|$)",
                "model": "Sirius $1"
            },
            {
                "regex": "(?:QUMO)?(Sirius 101-4G 8GB Black|Altair 701 8GB Black|Altair 71 4GB Black|Altair 700[24]|Altair 706)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:QUMO[ _])?Quest[ _]?(35[34]|40[268]|410|45[2568]|47[46]|50[679]|5[17]0|600)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Quest $1"
            }
        ]
    },
    "Umax": {
        "regex": "VisionBook[ _]|[78]Qa_3G(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(VisionBook[ _](?:10Qi|7Q[i]?|8Q[ei]?|P70|8Qi_3G)(?:[ _](?:[34]G|Plus|LTE))?)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "([78])Qa_3G(?:[);/ ]|$)",
                "model": "VisionBook $1Qa 3G"
            },
            {
                "regex": "VisionBook_10Q_LTE(?:[);/ ]|$)",
                "model": "VisionBook 10Q LTE"
            },
            {
                "regex": "VisionBook_P50Plus_LTE(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "VisionBook P50 Plus LTE"
            },
            {
                "regex": "(VisionBook[ _](?:P50 LTE|P55 X2 LTE|P55 LTE(?: Pro)?))(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "Mann": {
        "regex": "(ZUG 3|ZUG 5S(?: Q)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Unihertz": {
        "regex": "(Titan|Jelly-Pro|Atom_X?L)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Jelly)-(Pro)(?:[);/ ]|$)",
                "model": "$1 $2"
            },
            {
                "regex": "(Titan|Atom_X?L)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Chuwi": {
        "regex": "(?:CW-(Hi8-super|Hi12|V99i?|V17HD3G|VX8-3G|V88-QUAD|V9-DUAL|V88S|Vi[78]|[HV]i10 (?:pro|plus))|Hi10 (?:Pro|plus)|HiPad X|HiBox-hero|HiBook(?: pro)?|Hi[89] ?(?:Air|Pro)|Hi8SE|Vi10(?: ?Pro)?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(CW-Hi8-super)(?:[);/ ]|$)",
                "model": "Hi8"
            },
            {
                "regex": "(?:CW-)?(Vi10|Hi10) plus(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "CW-(V88)-QUAD(?:[);/ ]|$)",
                "model": "$1 Quad"
            },
            {
                "regex": "CW-(V9)-DUAL(?:[);/ ]|$)",
                "model": "$1 Dual"
            },
            {
                "regex": "CW-(V17HD|VX8)-?(3G)(?:[);/ ]|$)",
                "model": "$1 $2"
            },
            {
                "regex": "(?:CW-)?(Hi10) pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "HiBook pro(?:[);/ ]|$)",
                "model": "HiBook Pro"
            },
            {
                "regex": "HiBook(?:[);/ ]|$)",
                "model": "HiBook"
            },
            {
                "regex": "HiPad X(?:[);/ ]|$)",
                "model": "HiPad X"
            },
            {
                "regex": "Hi([89]) ?Air(?:[);/ ]|$)",
                "model": "Hi$1 Air"
            },
            {
                "regex": "Hi8SE(?:[);/ ]|$)",
                "model": "Hi8 SE"
            },
            {
                "regex": "Hi([89]) ?pro(?:[);/ ]|$)",
                "model": "Hi$1 Pro"
            },
            {
                "regex": "Vi10 Plus(?:[);/ ]|$)",
                "model": "Vi10 Plus"
            },
            {
                "regex": "Vi10 ?Pro(?:[);/ ]|$)",
                "model": "Vi10 Pro"
            },
            {
                "regex": "Vi10(?:[);/ ]|$)",
                "model": "Vi10"
            },
            {
                "regex": "HiBox-hero(?:[);/ ]|$)",
                "model": "HiBox Hero",
                "device": "desktop"
            },
            {
                "regex": "CW-(Vi[78]|Hi12|V99i?|V88S)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Bezkam": {
        "regex": "BEZKAM (BK-RAM2)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "NG Optics": {
        "regex": "(NG3128HD)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "KATV1": {
        "regex": "(KATV-01) PRO(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1 Pro"
    },
    "Ghong": {
        "regex": "GHONG(V10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Xoro": {
        "regex": "(?:TelePAD(?:795|731|1032|10A3|7A3)|Era 2X|HMT(?:390Q?|400)|HST 260)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "TelePAD(7|10)A3 4G(?:[);/ ]|$)",
                "model": "TelePad $1 A3 4G"
            },
            {
                "regex": "TelePAD(795|731|1032)(?:[);/ ]|$)",
                "model": "TelePad $1"
            },
            {
                "regex": "HMT(390Q?|400)(?:[);/ ]|$)",
                "model": "HMT $1",
                "device": "portable media player"
            },
            {
                "regex": "HST 260(?:[);/ ]|$)",
                "model": "HST 260",
                "device": "tv"
            },
            {
                "regex": "(Era 2X)(?:[);/ ]|$)",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "Vinga": {
        "regex": "VMP-(015-162|021-82|041-162|011-81|025-324|045-664)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "VMP-021-82",
                "model": "021"
            },
            {
                "regex": "VMP-025-324",
                "model": "025"
            },
            {
                "regex": "VMP-015-162",
                "model": "015"
            },
            {
                "regex": "VMP-041-162",
                "model": "041"
            },
            {
                "regex": "VMP-045-664",
                "model": "045"
            },
            {
                "regex": "VMP-011-81",
                "model": "011"
            }
        ]
    },
    "Viumee": {
        "regex": "SMART[_ ](EV[56])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Smart $1"
    },
    "Nuvo": {
        "regex": "Nuvo[_ ](NS35|Blue ND40|Green[_ ]ND[_ ]45)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Nuvo[_ ](NS35)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Blue (ND40)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Green[_ ]ND[_ ]45(?:[);/ ]|$)",
                "model": "ND45"
            }
        ]
    },
    "Sunvell": {
        "regex": "(?:T95ZPLUS|T95[KU]PRO)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "T95ZPLUS",
                "model": "T95Z Plus"
            },
            {
                "regex": "(T95[KU])PRO",
                "model": "$1 Pro"
            }
        ]
    },
    "Ugoos": {
        "regex": "UGOOS-AM6(?:[);/ ]|$)",
        "device": "tv",
        "model": "AM6"
    },
    "Yxtel": {
        "regex": "YXTEL_([HU]1|U3)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Proline": {
        "regex": "(H10882M-TN)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Yota": {
        "regex": "(YD20[16]|YOTA 3[+])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "YD20[16](?:[);/ ]|$)",
                "model": "Phone 2"
            },
            {
                "regex": "YOTA 3[+](?:[);/ ]|$)",
                "model": "Phone 3 Plus"
            }
        ]
    },
    "Mystery": {
        "regex": "MYSTERY|(MID-(?:123G|72[12]|7[01348]3G|753G|8[23]3G))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "MID-(123G|72[12]|7[01348]3G|753G|8[23]3G)(?:[);/ ]|$)",
                "model": "MID-$1"
            },
            {
                "regex": "MYSTERY_TV_(D3155CH31)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Ritzviva": {
        "regex": "(RITZVIVA[_ ]S500C)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "S500C"
    },
    "DeWalt": {
        "regex": "DeWalt (MD501)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Runbo": {
        "regex": "Runbo|F1-TT(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Runbo[ _-]?(X5-W|F1 Plus|F1-TT|F1-EN|F1|TT|Q5-S|X5-King|X6|Q5)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "F1-TT",
                "model": "F1-TT"
            }
        ]
    },
    "NewsMy": {
        "regex": "(CarPad-(?:II|III)-P)(?:[);/ ]|$)",
        "device": "car browser",
        "model": "$1"
    },
    "Newsday": {
        "regex": "Newsday[_ ](E1|A[12])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Daewoo": {
        "regex": "Daewoo|(DTA-07IDRF)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(DTA-07IDRF)(?:[);/ ]|$)",
                "model": "Archive 7P"
            },
            {
                "regex": "Daewoo (Android TV 638)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tv"
            }
        ]
    },
    "Vesta": {
        "regex": "VESTA32LD86(?:[);/ ]|$)",
        "device": "tv",
        "model": "SmartT V2.0 32LD86S"
    },
    "Spectrum": {
        "regex": "(CARBONO_5|CUARZO_6|DIAMANTE_5|VULCANO_55)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VULCANO_55(?:[);/ ]|$)",
                "model": "Vulcano 5.5\""
            },
            {
                "regex": "CARBONO_5(?:[);/ ]|$)",
                "model": "Carbono 5.0\""
            },
            {
                "regex": "CUARZO_6(?:[);/ ]|$)",
                "model": "Cuarzo 6.0\""
            },
            {
                "regex": "DIAMANTE_5(?:[);/ ]|$)",
                "model": "Diamante 5.0\""
            }
        ]
    },
    "Kivi": {
        "regex": "(?:24H600G[RU]|24FR50WU|24HK30B|32HR55GU|4[39]UP50GU|40UR50G[RU]|40U600G[RU]|55U600G[RU]|65UP50GU|55U[PC]50G[RU]|50U600G[RU]|50UX10S|55UR50G[RU]|40FK30G|40FR50BR|43UK35G|50FK30G|50UK35G|32HR50GR|55UC30G|32HK30G|40FK30G|32HR50GU|43UK30G|32FR50(?:WR|BU)|32FK3[02]G)(?:_-Ver0[0-9])?(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(24H600G[RU]|24FR50WU|24HK30B|32HR55GU|4[39]UP50GU|40UR50G[RU]|40U600G[RU]|55U600G[RU]|65UP50GU|55U[PC]50G[RU]|50UX10S|50U600G[RU]|55UR50G[RU]|40FK30G|40FR50BR|43UK35G|50FK30G|50UK35G|32HR50GR|32FR50(?:WR|BU)|32FK3[02]G)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(55UC30G|40FK30G|43UK30G|32HR50G[RU]|32HK30G|32FK32G)_-Ver0([0-9])(?:[);/ ]|$)",
                "model": "$1 v$2"
            }
        ]
    },
    "Divisat": {
        "regex": "(Divisat)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(J-Link)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Kanji": {
        "regex": "KJ-(OB03|YUBI)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "KJ-OB03(?:[);/ ]|$)",
                "model": "Cata 7"
            },
            {
                "regex": "KJ-YUBI(?:[);/ ]|$)",
                "model": "Yubi 3G"
            }
        ]
    },
    "Kaiomy": {
        "regex": "KaiCloud[ ]?(7[48]4|942)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "KaiCloud $1"
    },
    "National": {
        "regex": "(NX-32THS100)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Vsun": {
        "regex": "(?:VSUN (?:ILLUSION|RACE|V9)|MARS TOUCH|MARS NOTE|MARS NOCAM|SATURN SELFIE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ILLUSION(?:[);/ ]|$)",
                "model": "Illusion"
            },
            {
                "regex": "MARS TOUCH(?:[);/ ]|$)",
                "model": "Mars Touch"
            },
            {
                "regex": "MARS NOTE(?:[);/ ]|$)",
                "model": "Mars Note"
            },
            {
                "regex": "MARS NOCAM(?:[);/ ]|$)",
                "model": "Mars Nocam"
            },
            {
                "regex": "SATURN SELFIE(?:[);/ ]|$)",
                "model": "Saturn Selfie"
            },
            {
                "regex": "RACE(?:[);/ ]|$)",
                "model": "Race"
            },
            {
                "regex": "(V9)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Shift Phones": {
        "regex": "(SHIFT6m)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "RugGear": {
        "regex": "(RugGear|RG(?:310|500|65[05]|702|7[13]0|850))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(RG[0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Aligator": {
        "regex": "ALIGATOR[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "ALIGATOR[ _](S4080|S50(?:6[56]|[678]0)|S5540|RX510|S6500|RX710|RX800|S5520)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Maxcom": {
        "regex": "(MS(?:45[036]|505|514)|MS457(?:PLUS)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(MS457)PLUS(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "MS(45[0367]|505|514)(?:[);/ ]|$)",
                "model": "MS$1"
            }
        ]
    },
    "Luna": {
        "regex": "(?:LUNA[ _](?:V55|G[56]0)|TG-L800S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LUNA[ _](V55|G[56]0)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(TG-L800S)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Protruly": {
        "regex": "PROTRULY[ _](D[78]|V10S)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "JFone": {
        "regex": "JFone[ _](JS501)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Uhans": {
        "regex": "(A101S)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Soyes": {
        "regex": "SOYES[ _]([67]S|XS)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Zidoo": {
        "regex": "ZIDOO[ _](H6 Pro|X6 Pro|X9S|Z10|X[158]|X20 Pro|Z9S)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Zfiner": {
        "regex": "ZFINERY900(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Y900"
    },
    "iGet": {
        "regex": "SMART[_ ](G10[12]|S7[02]|G71|G81[H]?)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Smart $1"
    },
    "iVA": {
        "regex": "(LAMCY (?:L3[05]0|C100|L400)|IVA S6)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LAMCY (L3[05]0|C100|L400)(?:[);/ ]|$)",
                "model": "Lamcy $1"
            },
            {
                "regex": "IVA S6(?:[);/ ]|$)",
                "model": "S6"
            }
        ]
    },
    "Phicomm": {
        "regex": "(PHICOMM)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "C630 \\(CLUE L\\)(?:[);/ ]|$)",
                "model": "Clue L"
            },
            {
                "regex": "E653\\(ENERGY L\\)(?:[);/ ]|$)",
                "model": "Energy L"
            },
            {
                "regex": "PHICOMM ENERGY 3\\+(?:[);/ ]|$)",
                "model": "Energy 3+"
            },
            {
                "regex": "CLUE (2S|M)(?:[);/ ]|$)",
                "model": "Clue $1"
            }
        ]
    },
    "Huadoo": {
        "regex": "Huadoo[ _](HG0[46]|HG11|V[34])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Gome": {
        "regex": "(?:GOME[_ ](?:201[678].+|C7_Note(?:_Plus)?|U9|S[17])|Fenmmy_Note)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GOME[_ ](?:2018X38A)(?:[);/ ]|$)",
                "model": "C72"
            },
            {
                "regex": "GOME[_ ](?:2018X07A)(?:[);/ ]|$)",
                "model": "C7"
            },
            {
                "regex": "GOME[_ ](?:2017X05A)(?:[);/ ]|$)",
                "model": "C71"
            },
            {
                "regex": "GOME[_ ](?:2016G68A)(?:[);/ ]|$)",
                "model": "K1"
            },
            {
                "regex": "GOME[_ ](?:2016M25A)(?:[);/ ]|$)",
                "model": "U1"
            },
            {
                "regex": "GOME[_ ](?:2017M27A)(?:[);/ ]|$)",
                "model": "U7"
            },
            {
                "regex": "GOME[_ ](C7_Note(?:_Plus)?|U9|S[17])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:GOME[_ ])?(Fenmmy_Note)(?:[);/ ]|$)",
                "device": "phablet",
                "model": "$1"
            }
        ]
    },
    "Voyo": {
        "regex": "(?:VOYO[_ ](?:A15)|i8-Max|Q101-4G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "i8-Max(?:[);/ ]|$)",
                "model": "i8 Max"
            },
            {
                "regex": "(Q101)-4G(?:[);/ ]|$)",
                "model": "$1 4G"
            },
            {
                "regex": "VOYO[_ ](A15)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Ryte": {
        "regex": "RYTE (U55 LTE)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Vontar": {
        "regex": "(HK1 (?:Max|MINI|PLUS|PRO)|VONTAR[ -](?:Z[58]|V1|KIII|MX-4K|X3))(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "VONTAR[ -](Z[58]|V1|KIII|MX-4K|X3)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "HK1 Max(?:[);/ ]|$)",
                "model": "HK1 Max"
            },
            {
                "regex": "HK1 MINI(?:[);/ ]|$)",
                "model": "HK1 Mini"
            },
            {
                "regex": "HK1 PLUS(?:[);/ ]|$)",
                "model": "HK1 Plus"
            },
            {
                "regex": "HK1 PRO(?:[);/ ]|$)",
                "model": "HK1 Pro"
            }
        ]
    },
    "Vorke": {
        "regex": "VORKE (Z[157]|Z6(?: Plus)?)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Wigor": {
        "regex": "Wigor (V4)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "NEXON": {
        "regex": "NEXON (X[1589])(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "ONN": {
        "regex": "(ONA19TB00[327]|10000520[6-9]|O8HD)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "EXO": {
        "regex": "(Wave_i101G|Wave i101[Hb])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Q.Bell": {
        "regex": "(QPHONE[_ ](?:10.1|9.[12]|7.1|5.[46])|QTAB10EW)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(QPHONE[_ ](?:10.1|9.[12]|7.1|5.[46]))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "QTAB10EW",
                "device": "tablet",
                "model": "QTAB10EW"
            }
        ]
    },
    "Datawind": {
        "regex": "DW-[A-Z0-9]{5}(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(DW-PS3G5)(?:[);/ ]|$)",
                "model": "Pocket Surfer 3G5"
            },
            {
                "regex": "DW-UBT7W",
                "device": "tablet",
                "model": "Ubislate 7W"
            }
        ]
    },
    "Droxio": {
        "regex": "DROXIO (C40|B45)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Goophone": {
        "regex": "Goophone[ _]|(?:M(G492|L7[JK]2)CH|MN(4A2|8J2)ZP|MGA92ZP|MKU82ZP|MNGW2CH|MNH02CH|MNRM2CH)[/]A(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:MG492CH|MGA92ZP)[/]A(?:[);/ ]|$)",
                "model": "I6 Plus"
            },
            {
                "regex": "ML7[JK]2CH[/]A(?:[);/ ]|$)",
                "model": "I6"
            },
            {
                "regex": "MKU82ZP[/]A(?:[);/ ]|$)",
                "model": "I6S"
            },
            {
                "regex": "MNGW2CH[/]A(?:[);/ ]|$)",
                "model": "I6S Plus"
            },
            {
                "regex": "(?:MN4A2ZP|MNH02CH)[/]A(?:[);/ ]|$)",
                "model": "I7"
            },
            {
                "regex": "(?:MN8J2ZP|MNRM2CH)[/]A(?:[);/ ]|$)",
                "model": "I7 Plus"
            },
            {
                "regex": "S4 MEGA(?:[);/ ]|$)",
                "model": "S4 Mega"
            },
            {
                "regex": "Goophone i([69])(?:[);/ ]|$)",
                "model": "I$1"
            }
        ]
    },
    "PocketBook": {
        "regex": "PocketBook[ _/]",
        "device": "tablet",
        "models": [
            {
                "regex": "PocketBook SURFpad 3 \\(([\\d]+).([\\d]+)[\"]?\\)(?:[);/ ]|$)",
                "model": "Surfpad 3 $1.$2\""
            },
            {
                "regex": "PocketBook/(62[67]|63[12]|740|840)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Bitmore": {
        "regex": "(?:Mobitab10c-3G|Tab1011Q_II)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Mobitab)(10)c-3G(?:[);/ ]|$)",
                "model": "$1 $2C 3G"
            },
            {
                "regex": "Tab1011Q_II(?:[);/ ]|$)",
                "model": "Tab1011Q II"
            }
        ]
    },
    "Kuliao": {
        "regex": "KULIAO (K10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Sugar": {
        "regex": "SUGAR[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "SUGAR Y([78]) MAX(?:[);/ ]|$)",
                "model": "Y$1 Max"
            },
            {
                "regex": "SUGAR F7 Mini(?:[);/ ]|$)",
                "model": "F7 Mini"
            },
            {
                "regex": "SUGAR (C[12]1|C1[23]|S11|C11s|[SF]20s?|[YF]11|[YFS]9|C[679]|[FY]7|Y12s|Y1[256]|P1)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Subor": {
        "regex": "SUBOR[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "SUBOR[ _](S5|2019)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SUBOR[_ ]K10PLUS(?:[);/ ]|$)",
                "model": "K10 Plus"
            }
        ]
    },
    "Xshitou": {
        "regex": "Xshitou[_ ](P7)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "JKL": {
        "regex": "JKL[_ ](A28)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Gree": {
        "regex": "(G0215D|G0245D|G0335D)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Vodacom": {
        "regex": "(?:Vodacom)[ _](Power Tab 10)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "VKworld": {
        "regex": "(?:(?:VK700)-MAX|VK700 Pro|T5SE|VK700X|vk6050|vk6735|vk700)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(VK700)-MAX(?:[);/ ]|$)",
                "model": "$1 Max"
            },
            {
                "regex": "(VK700) Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "T5SE(?:[);/ ]|$)",
                "model": "T5 SE"
            },
            {
                "regex": "VK(700X|6050|6735|700)(?:[);/ ]|$)",
                "model": "VK$1"
            }
        ]
    },
    "Mito": {
        "regex": "MITO[- _](A(?:1[0678]|19_[12]GB|21|3[59]|55|180|2[36]0|313|322|33|3[136]0|[35]50|6[89]|7[235]|82|[356]0|810|950)|T(?:8|10|35|3[03]0|510|888)|311)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MITO[- _](A(?:1[0678]|19_[12]GB|21|3[59]|55|180|2[36]0|33|322|313|3[136]0|[35]50|6[89]|7[235]|82|[356]0|810|950)|311)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "MITO[ _](T(?:8|10|35|3[03]0|510|888))(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "TWM": {
        "regex": "Amazing[ _](X[35]s|X[123567]|A5S|A3[025]|A[468]|A4S|A5[057]|P6)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Amazing[ _](X[35])s(?:[);/ ]|$)",
                "model": "Amazing $1S"
            },
            {
                "regex": "Amazing[ _](A5S|X[123567]|A[468]|A4S|A5[057]|A3[025])(?:[);/ ]|$)",
                "model": "Amazing $1"
            },
            {
                "regex": "Amazing[ _](P6)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Amazing $1"
            }
        ]
    },
    "TWZ": {
        "regex": "TWZ[-_ ](?:TabPlay|Y6[08]|Y52|A49|A[59]5|A567|AA8|QQ[12])|TWZQQ1",
        "device": "smartphone",
        "models": [
            {
                "regex": "TWZ[_ ]TabPlay[_ ](12[56])",
                "device": "tablet",
                "model": "TabPlay $1"
            },
            {
                "regex": "TWZ[-_ ]?(Y6[08]|Y52|A49|A[59]5|A567|AA8|QQ[12])",
                "model": "$1"
            }
        ]
    },
    "Onix": {
        "regex": "(?:ONIX S405|AT101-1116)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(AT101-1116)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(S405)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "Oale": {
        "regex": "Apex([13])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Apex $1"
    },
    "Mobo": {
        "regex": "(?:(?:MOBO[_ ]MB7005|MT7-421HD)|(?:MT7-442D|MT7-411D))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:MOBO[_ ])?(MB7005|MT7-421HD|MT7-442D|MT7-411D)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Macoox": {
        "regex": "(MC-X7MINI)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "MC-X7 Mini"
    },
    "Prixton": {
        "regex": "PRIXTON |(T7012Q)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "PRIXTON (C18)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "(T7012Q)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Magnus": {
        "regex": "Magnus[ _](?:bravoZ[23]0|Infinity_?(?:G8|G11))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "bravo(Z[23]0)",
                "model": "Bravo $1"
            },
            {
                "regex": "(?:Magnus[ _])?Infinity_?(G8|G11)",
                "model": "Infinity $1"
            }
        ]
    },
    "Newland": {
        "regex": "(?:NLS-MT90)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "MT90 Orca"
    },
    "Orbic": {
        "regex": "(?:RC555L|RC501L)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RC555L(?:[);/ ]|$)",
                "model": "Wonder"
            },
            {
                "regex": "RC501L(?:[);/ ]|$)",
                "model": "Slim"
            }
        ]
    },
    "RED": {
        "regex": "(?:H1A1000)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Hydrogen One"
    },
    "Contixo": {
        "regex": "Contixo|(?:CX-1045 3G|KT995 3G|CX1045)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CX-?1045(?: 3G)?(?:[);/ ]|$)",
                "model": "CX-1045 3G"
            },
            {
                "regex": "CONTIXO GX 1035(?:[);/ ]|$)",
                "model": "GX-1035 4G 10.1\""
            },
            {
                "regex": "Contixo GT1160 4G(?:[);/ ]|$)",
                "model": "GT1160 4G 10.1\""
            },
            {
                "regex": "B105(?:[);/ ]|$)",
                "model": "B105 3G 10.1\""
            },
            {
                "regex": "B108(?:[);/ ]|$)",
                "model": "B108 4G 10.1\""
            },
            {
                "regex": "KT107(?: 3G)?(?:[);/ ]|$)",
                "model": "KT107 3G 10.1\""
            },
            {
                "regex": "K109(?:[);/ ]|$)",
                "model": "KT109 4G 10.1\""
            },
            {
                "regex": "KT715 3G(?:[);/ ]|$)",
                "model": "KT715 3G 7.0\""
            },
            {
                "regex": "KT995(?:[);/ ]|$)",
                "model": "KT995 3G 10.1\""
            },
            {
                "regex": "KT1100GT(?:[);/ ]|$)",
                "model": "KT1100GT"
            }
        ]
    },
    "E-Ceros": {
        "regex": "(?:CT9716(?:-B)?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CT9716(?:[);/ ]|$)",
                "model": "Revolution"
            },
            {
                "regex": "CT9716-B(?:[);/ ]|$)",
                "model": "Revolution HD"
            }
        ]
    },
    "How": {
        "regex": "(?:HT-705XS|705-G Go|1001-G Go)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(HT-705XS)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(1001-G Go)(?:[);/ ]|$)",
                "model": "HT-1001G Go Kids"
            },
            {
                "regex": "(705-G Go)(?:[);/ ]|$)",
                "model": "HT-$1"
            }
        ]
    },
    "Multilaser": {
        "regex": "(?:Multilaser[ _](?:[FEGH])(?:[_ ](?:Pro|Max|Lite))?|MS50[LGX]|M7[_-]3G[_-]PLUS|MS5\\.V2|MS45S_A6|ML([02]1|12)-M7s[- ]?Quad-?Core| ML01-M7-SD|MS45S|MS50S|MS60[XZ]|M7SQC_Plus|MS80X|MS40[GS]|MS55M|MS70|M7-3G QUAD CORE|M7sLite|MS50L_4G|MS60F(?:_PLUS)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Multilaser[ _]G[_ ]Pro(?:[);/ ]|$)",
                "model": "G Pro"
            },
            {
                "regex": "Multilaser[ _]F[_ ]Pro(?:[);/ ]|$)",
                "model": "F Pro"
            },
            {
                "regex": "Multilaser[ _]G[_ ]Max(?:[);/ ]|$)",
                "model": "G Max"
            },
            {
                "regex": "Multilaser[ _]G(?:[);/ ]|$)",
                "model": "G"
            },
            {
                "regex": "Multilaser[ _]E[_ ]Lite(?:[);/ ]|$)",
                "model": "E Lite"
            },
            {
                "regex": "Multilaser[ _]([FEH])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "MS60F_PLUS(?:[);/ ]|$)",
                "model": "MS60F Plus"
            },
            {
                "regex": "(MS50[LGX]|MS45S_A6|MS40[GS]|MS55M|MS60F|MS70|MS60[XZ]|MS45S|MS80X|MS50L_4G|MS50S|MS5\\.V2)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "M7[_-]3G[_-]PLUS(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M7 3G Plus"
            },
            {
                "regex": "M7SQC_PLUS(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M7SQC Plus"
            },
            {
                "regex": "M7-3G QUAD CORE(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M7 3G Quad Core"
            },
            {
                "regex": "ML([02]1|12)-M7s[- ]?Quad-?Core(?:[);/ ]|$)",
                "device": "tablet",
                "model": "ML$1-M7s Quad Core"
            },
            {
                "regex": "M7sLite(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M7s Lite"
            },
            {
                "regex": "ML01-M7-SD(?:[);/ ]|$)",
                "device": "tablet",
                "model": "ML01-M7 SD"
            }
        ]
    },
    "Positivo BGH": {
        "regex": "(?:T1060B|S455|Positivo (?:Twist|Ypy|Mini I)|Twist[ _](?:\\(2018\\)|2 (?:Fit|Pro)|Mini|Tab|Metal(?: 32GB)?|Max|XL|SE|[23SM]))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S455(?:[);/ ]|$)",
                "model": "Selfie"
            },
            {
                "regex": "Twist \\(2018\\)(?:[);/ ]|$)",
                "model": "Twist (2018)"
            },
            {
                "regex": "Twist Metal 32GB(?:[);/ ]|$)",
                "model": "Twist Metal 32GB"
            },
            {
                "regex": "Twist Metal(?:[);/ ]|$)",
                "model": "Twist Metal"
            },
            {
                "regex": "Twist Max(?:[);/ ]|$)",
                "model": "Twist Max"
            },
            {
                "regex": "Twist[ _]Mini(?:[);/ ]|$)",
                "model": "Twist Mini"
            },
            {
                "regex": "Twist 2 Fit(?:[);/ ]|$)",
                "model": "Twist 2 Fit"
            },
            {
                "regex": "Twist 2 Pro(?:[);/ ]|$)",
                "model": "Twist 2 Pro"
            },
            {
                "regex": "Twist XL(?:[);/ ]|$)",
                "model": "Twist XL"
            },
            {
                "regex": "Twist SE(?:[);/ ]|$)",
                "model": "Twist SE"
            },
            {
                "regex": "(?:Positivo )?Twist ([23SM])(?:[);/ ]|$)",
                "model": "Twist $1"
            },
            {
                "regex": "(?:Positivo )Mini I(?:[);/ ]|$)",
                "model": "Mini I"
            },
            {
                "regex": "T1060B(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T1060B"
            },
            {
                "regex": "Positivo Ypy (AB7F|AB10H|L1050E)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Ypy $1"
            },
            {
                "regex": "Twist Tab(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Twist Tab"
            }
        ]
    },
    "Maxtron": {
        "regex": "Maxtron[ _-](V[327]|S[89]|T1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Maxtron[ _-](V[327]|S[89])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Maxtron[ _-](T1)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Philco": {
        "regex": "PHILCO |(PCS01|PH350B|PTB7R|PTB7PAP_PTB7PAB_PTB7PAR)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(PCS01|PH350B)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(PTB7R)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "PHILCO Android TV(?:[);/ ]|$)",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "PTB7PAP_PTB7PAB_PTB7PAR(?:[);/ ]|$)",
                "device": "tablet",
                "model": "PTB7PA"
            }
        ]
    },
    "SEMP TCL": {
        "regex": "(?:GO[35]E|5101J|GO3C(?: Plus)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "5101J(?:[);/ ]|$)",
                "model": "L9 Plus"
            },
            {
                "regex": "GO3C Plus(?:[);/ ]|$)",
                "model": "GO! 3C Plus"
            },
            {
                "regex": "GO3C(?:[);/ ]|$)",
                "model": "GO! 3C"
            },
            {
                "regex": "(GO[35]E)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Newman": {
        "regex": "Newman[ _](P308|K1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Swipe": {
        "regex": "(Elite Sense|Elite_VR)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Owwo": {
        "regex": "(?:OWWO[ _]?(?:[1457]S|Q[78])|CARNIVAL B5)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "OWWO[ _]?([1457]S|Q[78])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "CARNIVAL B5(?:[);/ ]|$)",
                "model": "Carnival B5"
            }
        ]
    },
    "TD Systems": {
        "regex": "(K32DLX9HS|K40DLM8FS|K40DLX9FS)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Ravoz": {
        "regex": "RAVOZ[ _](Z5 (?:Lite|Pro)|Z[3-7]|R[478])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Tone": {
        "regex": "TONE (e19|m15|e20)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "AT&T": {
        "regex": "(?:U304AA|QS5509A|U705AA)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "U304AA(?:[);/ ]|$)",
                "model": "Radiant Core"
            },
            {
                "regex": "U705AA(?:[);/ ]|$)",
                "model": "Radiant Max"
            },
            {
                "regex": "QS5509A(?:[);/ ]|$)",
                "model": "Axia"
            }
        ]
    },
    "BIHEE": {
        "regex": "(ZBH-)?BIHEE",
        "device": "smartphone",
        "models": [
            {
                "regex": "(A1[12]|A[78]\\+|A[56])(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Enot": {
        "regex": "Enot[ _-](E102|J101)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Kooper": {
        "regex": "Kooper-mobile-W502(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Mobile W502"
    },
    "Lesia": {
        "regex": "ANOVA A5(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Anova A5"
    },
    "Anry": {
        "regex": "ANRY-(RS10|[SX]20)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Tinai": {
        "regex": "Tinai (K[12])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Winds": {
        "regex": "NOTE GRACE V(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Note Grace V"
    },
    "Asano": {
        "regex": "32LF7130S(?:[);/ ]|$)",
        "device": "tv",
        "model": "32LF7130S 32.0\""
    },
    "Phonemax": {
        "regex": "PHONEMAX[_ ](Saturn(?:[_ ]X)?|Mars|Venus X)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "PHONEMAX[_ ]Saturn[_ ]X(?:[);/ ]|$)",
                "model": "Saturn X"
            },
            {
                "regex": "PHONEMAX[_ ]Saturn(?:[);/ ]|$)",
                "model": "Saturn"
            },
            {
                "regex": "PHONEMAX[_ ]Mars(?:[);/ ]|$)",
                "model": "Mars"
            },
            {
                "regex": "PHONEMAX[_ ]Venus X(?:[);/ ]|$)",
                "model": "Venus X"
            }
        ]
    },
    "Vipro": {
        "regex": "VIPRO(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VIPRO PRO2X(?:[);/ ]|$)",
                "model": "Pro 2X"
            },
            {
                "regex": "VIPRO PRO[ _-]?([0-9])(?:[);/ ]|$)",
                "model": "Pro $1"
            }
        ]
    },
    "OzoneHD": {
        "regex": "Ozone HD|OzoneHD[ _](T2 WiFi|4K(?: TV)?|Fun)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Kzen": {
        "regex": "(?:Ureki_U1|Victor V1|DART KZ07)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Ureki_U1",
                "model": "Ureki U1"
            },
            {
                "regex": "Victor V1",
                "model": "Victor V1"
            },
            {
                "regex": "DART KZ07",
                "device": "tablet",
                "model": "Dart KZ07"
            }
        ]
    },
    "Melrose": {
        "regex": "MELROSE_(?:S9|2019)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MELROSE_S9(?:[);/ ]|$)",
                "model": "S9"
            },
            {
                "regex": "MELROSE_2019(?:[);/ ]|$)",
                "model": "2019 Ultra Slim 3.4\""
            }
        ]
    },
    "Crony": {
        "regex": "CRONY-7021(?:[);/ ]|$)",
        "device": "tablet",
        "model": "7021"
    },
    "Takara": {
        "regex": "(MID211H)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Tronsmart": {
        "regex": "(Orion R68G|Draco AW80|Draco H3|Vega S95_(?:Meta|Pro|Telos))(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Amigoo": {
        "regex": "AMIGOO (R300|R9 Max|M1 Max|X15)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Lumigon": {
        "regex": "Lumigon[ _](T3)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Neomi": {
        "regex": "NEO[ ]?(90[689])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Neo $1"
    },
    "Eltex": {
        "regex": "(?:NV5(?:01|10)WAC|NV501|NV510WB)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "NV5(01|10)WAC(?:[);/ ]|$)",
                "model": "NV-5$1-Wac"
            },
            {
                "regex": "NV501(?:[);/ ]|$)",
                "model": "NV-501"
            },
            {
                "regex": "NV510WB(?:[);/ ]|$)",
                "model": "NV-510-WB"
            }
        ]
    },
    "Senkatel": {
        "regex": "Senkatel[ _](T1009|T8002|T701[12]|T9702)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Bobarry": {
        "regex": "(?:K10[ ]?SE)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "K10 SE"
    },
    "Wortmann": {
        "regex": "TERRA[ _]PAD[ _](100[45])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Terra Pad $1"
    },
    "BB Mobile": {
        "regex": "Techno[-_ ](8\\.0|9\\.7|TQ863Q|X595BT|S700BF|I700AJ|10.1 LTE TQ060X|7.0 LTE TQ763I|I785AP|I101BI)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Techno[_ ]S700BF(?:[);/ ]|$)",
                "model": "Techno 7.0\" Pioneer LTE S700BF"
            },
            {
                "regex": "Techno[_ ]10.1 LTE TQ060X(?:[);/ ]|$)",
                "model": "Techno 10.0\" LTE TQ060X"
            },
            {
                "regex": "Techno[_ ]TQ863Q(?:[);/ ]|$)",
                "model": "Techno 8.0\" Poplar LTE TQ863Q"
            },
            {
                "regex": "Techno[_ ]I700AJ(?:[);/ ]|$)",
                "model": "Techno 7.0\" Mozg LTE I700AJ"
            },
            {
                "regex": "Techno[-_ ]I785AP(?:[);/ ]|$)",
                "model": "Techno 7.85\" Mozg I785AP"
            },
            {
                "regex": "Techno[-_ ]I101BI(?:[);/ ]|$)",
                "model": "Techno 10.1\" Mozg I101BI"
            },
            {
                "regex": "Techno[_ ]7.0 LTE TQ763I(?:[);/ ]|$)",
                "model": "Techno 7.0\" Kalash LTE TQ763I"
            },
            {
                "regex": "Techno[_ ](9\\.7|8\\.0) 3G(?:[);/ ]|$)",
                "model": "Techno $1\" 3G"
            },
            {
                "regex": "Techno[_ ](?:X595BT)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Techno Spark 3G X595BT"
            }
        ]
    },
    "2E": {
        "regex": "(?:E500A_2019|2E E450 2018)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E500A_2019(?:[);/ ]|$)",
                "model": "E500A (2019)"
            },
            {
                "regex": "2E E450 2018(?:[);/ ]|$)",
                "model": "E450 (2018)"
            }
        ]
    },
    "Billion": {
        "regex": "Capture\\+(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Capture Plus"
    },
    "Tele2": {
        "regex": "Tele2[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Tele2[ _](Mi[dn]i)[ _]1.1(?:[);/ ]|$)",
                "model": "$1 1.1"
            },
            {
                "regex": "Tele2[ _]Midi[ _]2.0(?:[);/ ]|$)",
                "model": "Midi 2.0"
            },
            {
                "regex": "Tele2[ _]((?:Maxi|Midi)(?:[_ ](?:Plus|LTE))?)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Tele2[ _](Mi[dn]i)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Alfawise": {
        "regex": "(?:Alfawise (?:A9)|(?:A95X_R1))(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(A95X_R1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Alfawise (A9)",
                "model": "$1"
            }
        ]
    },
    "Klipad": {
        "regex": "KLIPAD_|(?:KL-V905|KL4889|KL9878|7589AN)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:KLIPAD_)?(V355B?|KL600|KL-V905)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(KL4889|7589AN|KL9878)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "SQOOL": {
        "regex": "SQOOL-V(41?)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "V$1"
    },
    "TurboKids": {
        "regex": "Turbokids[-_ ]?(TMNT|3G|S4)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Jinga": {
        "regex": "Jinga[-_ ]|(?:(?:Fresh|Optim)4G|Pass(?:Plus|3G)|PicassoNote|Hotz[_ ]M1|WinPRO|Touch4G|Start3G|IGO[ _]L[41]|Basco (?:L3|L[45]00|XS1|S2))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Optim4G(?:[);/ ]|$)",
                "model": "Optim 4G"
            },
            {
                "regex": "Fresh4G(?:[);/ ]|$)",
                "model": "Fresh 4G"
            },
            {
                "regex": "Hotz[_ ]M1(?:[);/ ]|$)",
                "model": "Hotz M1"
            },
            {
                "regex": "PassPlus(?:[);/ ]|$)",
                "model": "Pass Plus"
            },
            {
                "regex": "Pass3G(?:[);/ ]|$)",
                "model": "Pass 3G"
            },
            {
                "regex": "WinPRO(?:[);/ ]|$)",
                "model": "Win Pro"
            },
            {
                "regex": "Touch4G(?:[);/ ]|$)",
                "model": "Touch 4G"
            },
            {
                "regex": "Start3G(?:[);/ ]|$)",
                "model": "Start 4G"
            },
            {
                "regex": "PicassoNote(?:[);/ ]|$)",
                "model": "Picasso Note"
            },
            {
                "regex": "Jinga Iron(?:[);/ ]|$)",
                "model": "Iron"
            },
            {
                "regex": "Jinga Basco neo(?:[);/ ]|$)",
                "model": "Basco Neo"
            },
            {
                "regex": "(?:Jinga )?Basco (L3|L[45]00|XS1|S2)(?:[);/ ]|$)",
                "model": "Basco $1"
            },
            {
                "regex": "Jinga Trezor S1 Plus(?:[);/ ]|$)",
                "model": "Trezor S1 Plus"
            },
            {
                "regex": "JINGA_IGO_L2(?:[);/ ]|$)",
                "model": "IGO L2"
            },
            {
                "regex": "(?:JINGA[_ ])?IGO[_ ]([ML]1|L4)(?:[);/ ]|$)",
                "model": "IGO $1"
            },
            {
                "regex": "Jinga Trezor S1 Plus(?:[);/ ]|$)",
                "model": "Trezor S1 Plus"
            }
        ]
    },
    "Twoe": {
        "regex": "(?:TWOE[-_ ]E450R|F534L|F572L|E500A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TWOE[-_ ](E450R)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(F534L|F572L|E500A)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "iTruck": {
        "regex": "iTRUCK 7 3G(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "7.0\" 3G"
    },
    "Torex": {
        "regex": "TOREX[- ](?:PS12|S18|S27)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "TOREX-(PS12)",
                "model": "$1"
            },
            {
                "regex": "TOREX[- ](S18|S27)",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "Doffler": {
        "regex": "(24DHS54)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Oyyu": {
        "regex": "OYYUT11(?:[);/ ]|$)",
        "device": "tablet",
        "model": "T11 3G"
    },
    "Primux": {
        "regex": "Primux",
        "device": "smartphone",
        "models": [
            {
                "regex": "Primux_ioxphone(?:[);/ ]|$)",
                "model": "IOX Phone"
            },
            {
                "regex": "PrimuxDelta6(?:[);/ ]|$)",
                "model": "Delta 6"
            },
            {
                "regex": "PrimuxKappa(P50[01])(?:[);/ ]|$)",
                "model": "Kappa $1"
            },
            {
                "regex": "PrimuxKappa(?:[);/ ]|$)",
                "model": "Kappa"
            },
            {
                "regex": "Primux_Beta2(?:[);/ ]|$)",
                "model": "Beta 2"
            },
            {
                "regex": "Primux_?Omega([57])(?:[);/ ]|$)",
                "model": "Omega $1"
            },
            {
                "regex": "PrimuxUP(?:[);/ ]|$)",
                "device": "tablet",
                "model": "UP"
            },
            {
                "regex": " PrimuxZonda4(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Zonda 4"
            },
            {
                "regex": "Primux_Siroco6(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Siroco 6"
            }
        ]
    },
    "iMars": {
        "regex": "(?:IMARS VEGA X7|VIVI_8)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IMARS VEGA X7",
                "model": "Vega X7"
            },
            {
                "regex": "VIVI_8",
                "model": "VIVI 8"
            }
        ]
    },
    "Logic": {
        "regex": "LOGIC[_ ](X[135]|X4M|L5D|X5[AFT]|X60G|L61|X60_PLUS)(:?[_ ]LITE2?)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LOGIC[_ ]X60_PLUS(?:[);/ ]|$)",
                "model": "X60 Plus"
            },
            {
                "regex": "LOGIC[_ ](X5|X4M)[_ ]LITE(?:[);/ ]|$)",
                "model": "$1 Lite"
            },
            {
                "regex": "LOGIC[_ ](X5)[_ ]LITE2(?:[);/ ]|$)",
                "model": "$1 Lite 2"
            },
            {
                "regex": "LOGIC[_ ](X[13]|X4M|L5D|X5[AFT]|X60G|L61)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Cloudpad": {
        "regex": "\\+VT(?:107C|Q007C)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "\\+VT(107C)",
                "model": "+VT$1"
            },
            {
                "regex": "\\+VTQ(007C)",
                "model": "+VTQ$1"
            }
        ]
    },
    "Cloudfone": {
        "regex": "(?:Thrill (?:Boost[ ]?(2|3)?|Snap|Access)|Excite Prime 2 Pro|NBA Edition)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Thrill Boost (2|3)(?:[);/ ]|$)",
                "model": "Thrill Boost $1"
            },
            {
                "regex": "Thrill Boost(?:[);/ ]|$)",
                "model": "Thrill Boost"
            },
            {
                "regex": "Thrill Snap(?:[);/ ]|$)",
                "model": "Thrill Snap"
            },
            {
                "regex": "Thrill Access(?:[);/ ]|$)",
                "model": "Thrill Access"
            },
            {
                "regex": "Excite Prime 2 Pro(?:[);/ ]|$)",
                "model": "Excite Prime 2 Pro"
            },
            {
                "regex": "NBA Edition(?:[);/ ]|$)",
                "model": "NBA Edition"
            }
        ]
    },
    "Vsmart": {
        "regex": "(?:Joy 1\\+|Active 1\\+|Bee 3|Active 3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Joy 1\\+(?:[);/ ]|$)",
                "model": "Joy 1 Plus"
            },
            {
                "regex": "Active 1\\+(?:[);/ ]|$)",
                "model": "Active 1 Plus"
            },
            {
                "regex": "Bee 3(?:[);/ ]|$)",
                "model": "Bee 3"
            },
            {
                "regex": "Active 3(?:[);/ ]|$)",
                "model": "Active 3"
            }
        ]
    },
    "MiXzo": {
        "regex": "(?:MiXzo[ _])?(?:ME1023|ME1030|MX1037|MX1024|MX10[24]1|MX1397)([ _][34]G)?(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "MiXzo[_ ]ME(1023|1030)(?:[_ ]3G)(?:[);/ ]|$)",
                "model": "ME$1 3G"
            },
            {
                "regex": "MiXzo[_ ]MX1021(?:[_ ]3G)?(?:[);/ ]|$)",
                "model": "MX1021 3G"
            },
            {
                "regex": "(?:MiXzo[ _])?MX(1037|1041|1024|1397)[ _]4G(?:[);/ ]|$)",
                "model": "MX$1 4G"
            }
        ]
    },
    "Openbox": {
        "regex": "Openbox (A[34](?: (?:Pro|Lite))?)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Ziox": {
        "regex": "ZIOX[_ ]|(?:Astra Viva 4G|Astra NXT Pro|Duopix F9)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZIOX[_ ]F9[_ ]PRO(?:[);/ ]|$)",
                "model": "F9 Pro"
            },
            {
                "regex": "Astra Viva 4G(?:[);/ ]|$)",
                "model": "Astra Viva 4G"
            },
            {
                "regex": "Astra NXT Pro(?:[);/ ]|$)",
                "model": "Astra NXT Pro"
            },
            {
                "regex": "Duopix F9(?:[);/ ]|$)",
                "model": "Duopix F9"
            }
        ]
    },
    "iDroid": {
        "regex": "APACHE G6(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Apache G6"
    },
    "Aoson": {
        "regex": "aoson(?:R10[1-3]|S[78]|M707TG)(?:[_ ]?Pro)?(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "aosonR10([1-3])(?:[);/ ]|$)",
                "model": "R10$1 10.1\""
            },
            {
                "regex": "aosonS7_Pro(?:[);/ ]|$)",
                "model": "S7 Pro 7.0\""
            },
            {
                "regex": "aosonS7(?:[);/ ]|$)",
                "model": "S7 7.0\""
            },
            {
                "regex": "aosonS8Pro(?:[);/ ]|$)",
                "model": "S8 Pro 8.0\""
            },
            {
                "regex": "aoson(M707TG)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "FireFly Mobile": {
        "regex": "(?:AURII[ _](?:Passion|Virtuoso|ULTRA|Secret Lite|AMUSE[_ ]3G|FORCE|FUSION|F8[_ ]Premium|XCITE|DELIGHT|DREAM[_ ](?:MINI|One))|SECRET_XR|INTENSE[ _](?:POWER|METAL_2|XT)|SUPER SWEET|SWEET MINI)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AURII[ _]FORCE(?:[);/ ]|$)",
                "model": "Aurii Force"
            },
            {
                "regex": "AURII[ _]DELIGHT(?:[);/ ]|$)",
                "model": "Aurii Delight"
            },
            {
                "regex": "AURII[ _]DREAM[_ ]MINI(?:[);/ ]|$)",
                "model": "Aurii Dream Mini"
            },
            {
                "regex": "AURII[ _]DREAM[_ ]One(?:[);/ ]|$)",
                "model": "Aurii Dream One"
            },
            {
                "regex": "AURII[ _]ULTRA(?:[);/ ]|$)",
                "model": "Aurii Ultra"
            },
            {
                "regex": "AURII[ _]AMUSE[_ ]3G(?:[);/ ]|$)",
                "model": "Aurii Amuse 3G"
            },
            {
                "regex": "AURII[ _]FUSION(?:[);/ ]|$)",
                "model": "Aurii Fusion"
            },
            {
                "regex": "AURII[ _]XCITE(?:[);/ ]|$)",
                "model": "Aurii xCite"
            },
            {
                "regex": "SECRET_XR(?:[);/ ]|$)",
                "model": "Aurii Secret XR"
            },
            {
                "regex": "AURII[ _]((?:Passion|Virtuoso|Secret Lite|F8[_ ]Premium))(?:[);/ ]|$)",
                "model": "Aurii $1"
            },
            {
                "regex": "INTENSE POWER(?:[);/ ]|$)",
                "model": "Intense Power"
            },
            {
                "regex": "INTENSE_XT(?:[);/ ]|$)",
                "model": "Intense XT"
            },
            {
                "regex": "INTENSE_METAL_2(?:[);/ ]|$)",
                "model": "Intense Metal 2"
            },
            {
                "regex": "SUPER SWEET(?:[);/ ]|$)",
                "model": "Super Sweet"
            },
            {
                "regex": "SWEET MINI(?:[);/ ]|$)",
                "model": "Sweet Mini"
            }
        ]
    },
    "i-Cherry": {
        "regex": "iCherry_?",
        "device": "smartphone",
        "models": [
            {
                "regex": "iCherry[ _](C(?:25[1258]|21[16]|110|121|22[0379]|23[03])|X1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "iCherry-C256",
                "device": "tablet",
                "model": "C256 Nano 3G"
            }
        ]
    },
    "NextTab": {
        "regex": "TAB (A40[13]0)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Time2": {
        "regex": "(TC1050G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1 10.1\""
    },
    "Sunstech": {
        "regex": "(TAB2323GMQC)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Hotwav": {
        "regex": "(?:Venus[_ ]X1[024569]|Cosmos[ _](?:V8_lite|V19_Plus|V2[0-3]|U2|V19|V[569])|Pearl K2|Magic Q8|Magic 5 Plus|Magic (?:[89]|1[13])|Hot[_ ]6)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cosmos[ _]V8_lite(?:[);/ ]|$)",
                "model": "Cosmos V8 Lite"
            },
            {
                "regex": "Hot[_ ]6?(?:[);/ ]|$)",
                "model": "Hot 6"
            },
            {
                "regex": "(Venus[_ ]X1[024569]|Cosmos[ _](?:V19_Plus|V2[0-3]|U2|V19|V[569])|Pearl K2|Magic Q8|Magic 5 Plus|Magic (?:[89]|1[13]))(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Tetratab": {
        "regex": "CASEBOOK_3(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Casebook 3"
    },
    "Dolamee": {
        "regex": "Dolamee[_ -](D[56])(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Invin": {
        "regex": "INVIN[ _-]|KM5PRO(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "INVIN[ _-](X[24]|KM[678])",
                "model": "$1"
            },
            {
                "regex": "KM5PRO",
                "model": "KM5 Pro"
            }
        ]
    },
    "Doopro": {
        "regex": "Doopro P3(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "P3"
    },
    "IQM": {
        "regex": "IQM (?:picasso|vivaldi|newton)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IQM picasso(?:[);/ ]|$)",
                "model": "Picasso"
            },
            {
                "regex": "IQM vivaldi(?:[);/ ]|$)",
                "model": "Vivaldi"
            },
            {
                "regex": "IQM newton(?:[);/ ]|$)",
                "model": "Newton"
            }
        ]
    },
    "Nos": {
        "regex": "Nos (?:FIVE|NOVU|NEVA|Roya)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NOS FIVE(?:[);/ ]|$)",
                "model": "Five"
            },
            {
                "regex": "NOS NOVU III(?:[);/ ]|$)",
                "model": "Novu III"
            },
            {
                "regex": "NOS NOVU II(?:[);/ ]|$)",
                "model": "Novu II"
            },
            {
                "regex": "NOS NOVU(?:[);/ ]|$)",
                "model": "Novu"
            },
            {
                "regex": "NOS NEVA 80(?:[);/ ]|$)",
                "model": "Neva 80"
            },
            {
                "regex": "NOS Roya(?:[);/ ]|$)",
                "model": "Roya"
            }
        ]
    },
    "Accent": {
        "regex": "(?:ACCENT[_ ]NEON|FAST73G|PEARL[_ ]A[24567]|TANK_P55|CAMELEON[_ ](?:C[456]|A1)(?:[_ ]PLUS)?|Speed[- ](?:[AXYM]2|X2\\+))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ACCENT[_ ]NEON(?:[);/ ]|$)",
                "model": "Neon"
            },
            {
                "regex": "CAMELEON[_ ]C6[_ ]PLUS(?:[);/ ]|$)",
                "model": "Cameleon C6 Plus"
            },
            {
                "regex": "Speed[- ]([AXYM]2)(?:[);/ ]|$)",
                "model": "Speed $1"
            },
            {
                "regex": "Speed-X2\\+(?:[);/ ]|$)",
                "model": "Speed X2 Plus"
            },
            {
                "regex": "CAMELEON[_ ](C[456]|A1)(?:[);/ ]|$)",
                "model": "Cameleon $1"
            },
            {
                "regex": "PEARL A4 Lite(?:[);/ ]|$)",
                "model": "Pearl A4 Lite"
            },
            {
                "regex": "PEARL[_ ]A([2567])(?:[);/ ]|$)",
                "model": "Pearl A$1"
            },
            {
                "regex": "TANK_P55(?:[);/ ]|$)",
                "model": "Tank P55"
            },
            {
                "regex": "FAST73G(?:[);/ ]|$)",
                "device": "phablet",
                "model": "FAST7 3G"
            }
        ]
    },
    "Avenzo": {
        "regex": "Avenzo(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MOB4 4G(?:[);/ ]|$)",
                "model": "Mob 4 4G"
            },
            {
                "regex": "MOB4PRO 4G(?:[);/ ]|$)",
                "model": "Mob 4 Pro 4G"
            }
        ]
    },
    "Beelink": {
        "regex": "(?:Beelink (?:G[ST]1|LAKE I|SEA I|A1)|GTKing|GT1mini-2|GT1-mini(?:-AT)?)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Beelink (G[ST]1|LAKE I|SEA I|A1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "GT1-mini(?:-AT)?(?:[);/ ]|$)",
                "model": "GT1 Mini"
            },
            {
                "regex": "GT1mini-2(?:[);/ ]|$)",
                "model": "GT1 Mini 2"
            },
            {
                "regex": "GTKing(?:[);/ ]|$)",
                "model": "GT King"
            }
        ]
    },
    "MAXVI": {
        "regex": "MAXVI[ _](?:MS401)(?:[);/ ]|$)|(?:\\w+)?_MAXVI_\\w+|MS502[_ ]Orion|MS531",
        "device": "smartphone",
        "models": [
            {
                "regex": "MAXVI[ _](MS401)",
                "model": "$1"
            },
            {
                "regex": "MS531",
                "model": "MS531 Vega"
            },
            {
                "regex": "MS502[_ ]Orion",
                "model": "MS502 Orion"
            },
            {
                "regex": "(?:\\w+)?MAXVI_(P11|K10|X[358]00)_\\w+",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "MDC Store": {
        "regex": "Prime_S(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Prime_S(?:[);/ ]|$)",
                "model": "Prime S"
            }
        ]
    },
    "meanIT": {
        "regex": "meanIT[ _](?:C[12]|X10|X[126]|MG430|Q[145])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "meanIT[ _]Q1 plus(?:[);/ ]|$)",
                "model": "Q1 Plus"
            },
            {
                "regex": "meanIT[ _](C[12]|X[126]|MG430|Q[145])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "meanIT[ _]X10(?:[);/ ]|$)",
                "device": "tablet",
                "model": "X10"
            }
        ]
    },
    "Kenxinda": {
        "regex": "Three[_ ]Proofings[_ ]W([5-9])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Three Proofings W$1"
    },
    "X-BO": {
        "regex": "X[-]?BO (V[78]|V1[01]|V[89]\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Xgody": {
        "regex": "XGODY",
        "device": "smartphone",
        "models": [
            {
                "regex": "XGODY Y17(?:[);/ ]|$)",
                "model": "Y17"
            },
            {
                "regex": "XGODY_X96(?:[);/ ]|$)",
                "model": "X96",
                "device": "tv"
            }
        ]
    },
    "Alcor": {
        "regex": "(Access_Q784C)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "iBrit": {
        "regex": "IBRIT_|(?:SI5[12])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IBRIT_I([57])(?:[);/ ]|$)",
                "model": "I$1"
            },
            {
                "regex": "iBRIT_POWER6(?:[);/ ]|$)",
                "model": "Power 6"
            },
            {
                "regex": "iBRIT_Speed Pro(?:[);/ ]|$)",
                "model": "Speed Pro"
            },
            {
                "regex": "SI51(?:[);/ ]|$)",
                "model": "Speed"
            },
            {
                "regex": "SI52(?:[);/ ]|$)",
                "model": "Speed Plus"
            }
        ]
    },
    "Ovvi": {
        "regex": "Jumbo X1",
        "device": "smartphone",
        "model": "Jumbo X1"
    },
    "Fero": {
        "regex": "Fero[_ ]|Royale[_ ](?:[YX]2|A1)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Fero_Y1",
                "model": "Y1"
            },
            {
                "regex": "Royale Y2 Lite",
                "model": "Royale Y2 Lite"
            },
            {
                "regex": "Royale[_ ]([YX]2|A1)",
                "model": "Royale $1"
            },
            {
                "regex": "FERO PACE",
                "model": "Pace"
            },
            {
                "regex": "Fero[ _](A4001|A450[23]|A5001|L100|Iris|Power|Mega LTE|Vibe)",
                "model": "$1"
            }
        ]
    },
    "Ruio": {
        "regex": "Ruio[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Ruio[ _](S4)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Ruio[ _](S5)Plus(?:[);/ ]|$)",
                "model": "$1 Plus"
            }
        ]
    },
    "Transpeed": {
        "regex": "Transpeed_|(?:TR99 MINI\\+|TR99)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "TR99 MINI\\+",
                "model": "TR99 Mini Plus"
            },
            {
                "regex": "(?:Transpeed_)?(TR99|H616|6K)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "VVETIME": {
        "regex": "ZYVV1(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "V1"
    },
    "A1": {
        "regex": "A1 (?:Alpha|Alpha 20\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A1 Alpha 20\\+",
                "model": "Alpha 20 Plus"
            },
            {
                "regex": "A1 Alpha",
                "model": "Alpha"
            }
        ]
    },
    "Swisstone": {
        "regex": "swisstone (SD 5[13]0)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "P-UP": {
        "regex": "MD-04P(?:[);/ ]|$)",
        "device": "phablet",
        "model": "Mode 1 RR"
    },
    "iVooMi": {
        "regex": "(?:Innelo_1|iV 505)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Innelo_1",
                "model": "Innelo 1"
            },
            {
                "regex": "iV 505",
                "model": "Me 1"
            }
        ]
    },
    "Pixelphone": {
        "regex": "Pixelphone S1(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "S1"
    },
    "Pixela": {
        "regex": "Infineum[_ ](Z4?5)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Infineum $1"
    },
    "Iris": {
        "regex": "(?:Vox[_ ](?:[45]S|Alpha|POP|STEEL Plus|Energy)|IS2_?Plus|IS2S|Next_P_PRO|IRS002-16)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Vox[_ ]([45])S",
                "model": "Vox $1S"
            },
            {
                "regex": "VOX Alpha Plus",
                "model": "Vox Alpha Plus"
            },
            {
                "regex": "VOX STEEL Plus",
                "model": "Vox Steel Plus"
            },
            {
                "regex": "VOX Alpha",
                "model": "Vox Alpha"
            },
            {
                "regex": "VOX Energy",
                "model": "Vox Energy"
            },
            {
                "regex": "VOX POP plus",
                "model": "Vox Pop Plus"
            },
            {
                "regex": "VOX POP Pro",
                "model": "Vox Pop Pro"
            },
            {
                "regex": "Next_P_PRO",
                "model": "Next P Pro"
            },
            {
                "regex": "IS2_?Plus",
                "model": "IS2 Plus"
            },
            {
                "regex": "IRS002-16",
                "model": "I-S6"
            },
            {
                "regex": "IS2S",
                "model": "IS2S"
            }
        ]
    },
    "Fonos": {
        "regex": "Fonos-(O1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Xtouch": {
        "regex": "Xtouch[ _](X10|A5)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Conquest": {
        "regex": "Conquest[-_](?:S(?:[68]|1[0126])|F2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Conquest[-_]S([68]|1[0126])",
                "model": "S$1"
            },
            {
                "regex": "Conquest-F2",
                "model": "F2"
            }
        ]
    },
    "Zatec": {
        "regex": "ZATEC[_ ]|(?:[ ]WIND|ZPLAY1_2018|Zpower_(?:Plus|2018))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZATEC[_ ]GRAVITY(?:[);/ ]|$)",
                "model": "Gravity"
            },
            {
                "regex": "[ ]WIND(?:[);/ ]|$)",
                "model": "Wind"
            },
            {
                "regex": "ZPLAY1_2018",
                "model": "Zplay (2018)"
            },
            {
                "regex": "Zpower_2018",
                "model": "Zpower (2018)"
            },
            {
                "regex": "Zpower_Plus",
                "model": "Zpower Plus"
            }
        ]
    },
    "Selenga": {
        "regex": "Selenga[ _](A[134])(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Starlight": {
        "regex": "Starlight|(?:My_Star_X|RIO STAR|C_Note_Pro|Star_Mix_2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "My_Star_X",
                "model": "My Star X"
            },
            {
                "regex": "RIO STAR",
                "model": "Rio Star"
            },
            {
                "regex": "C_Note_Pro",
                "model": "C Note Pro"
            },
            {
                "regex": "Star_Mix_2",
                "model": "Star Mix 2"
            },
            {
                "regex": "Starlight_ROME_X",
                "model": "Rome X"
            }
        ]
    },
    "GEOFOX": {
        "regex": "GEOFOX[_](MID743)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Tinmo": {
        "regex": "TiNMO[- _](A11|K3)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Matrix": {
        "regex": "(7116-A5)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Verico": {
        "regex": "(RP-UDM0[12]A|RP-UDP05A)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Uni Pad $1"
    },
    "TTEC": {
        "regex": "(Magictab (?:9GX|7GE|718))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "eSTAR": {
        "regex": "eSTAR[_ ](?:Grand|GO\\!?|Zoom Quad|Gemini|MINI[_ ]3G|BEAUTY|MOON)",
        "device": "tablet",
        "models": [
            {
                "regex": "eSTAR (Grand|GO\\!?) (HD Intel|IPS Intel|IPS|HD|Intel) Quad Core 3G",
                "model": "$1 $2 Quad Core 3G"
            },
            {
                "regex": "eSTAR (Zoom Quad|Gemini|GO)",
                "model": "$1"
            },
            {
                "regex": "eSTAR GRAND HD quad core( [34]G)?",
                "model": "Grand HD Quad Core$1"
            },
            {
                "regex": "eSTAR GRAND",
                "model": "Grand"
            },
            {
                "regex": "eSTAR BEAUTY HD Quad core",
                "model": "Beauty HD Quad Core"
            },
            {
                "regex": "eSTAR MOON HD Quad core",
                "model": "Moon HD Quad Core 3G"
            },
            {
                "regex": "eSTAR BEAUTY 2 HD Quad core",
                "model": "Beauty 2 HD Quad Core"
            },
            {
                "regex": "eSTAR[_ ]MINI[_ ]3G",
                "model": "Mini 3G"
            }
        ]
    },
    "Hometech": {
        "regex": "(?:Ideal (?:10S|Tab [79])|ALFA10TB|ALFA[_ ](?:10RC|10TM?|7RS|[78]RC|7M)|HT[ _](?:7RT|8MZ))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Ideal (?:10S|Tab 9))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "ALFA[_ ]?(10RC|10T[BM]?|7RS|[78]RC|7M)(?:[);/ ]|$)",
                "model": "ALFA $1"
            },
            {
                "regex": "Ideal Tab 7 Ips( 3G)?",
                "model": "Ideal Tab 7 IPS$1"
            },
            {
                "regex": "HT[ _](7RT|8MZ)(?:[);/ ]|$)",
                "model": "HT $1"
            }
        ]
    },
    "ExMobile": {
        "regex": "EX(29|45)i(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "EX $1i"
    },
    "Hipstreet": {
        "regex": "10DTB12(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Phoenix"
    },
    "Navitech": {
        "regex": "(NeoTab)[ _-]((?:S1[23]0|S125|H85|H11[05]|KID741|S9700))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1 $2"
    },
    "NorthTech": {
        "regex": "(NT-TP10)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "TouchPad 10.0\""
    },
    "UNIWA": {
        "regex": "UNIWA[ _](X5)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Andowl": {
        "regex": "ANDOWL-(Q[45])(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Silelis": {
        "regex": "Silelis[ _](T-1)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Bluedot": {
        "regex": "BLUEDOT[_ ]|(?:BNT-71)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:BLUEDOT[_ ])?(BNP-500)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "(BNT-71)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Planet Computers": {
        "regex": "(Cosmo_Communicator)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Reach": {
        "regex": "(Allure[_ ](?:Ultra(?:[_]Curve)?|Secure|Admire|Rise))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "MobiWire": {
        "regex": "(?:Kiona|KANUNA|Halona|Kicka[_ ][45][ _]Plus|Kohana|Kosumi|KWANITA|Lonan|Hotah|Kicka 5|Kiona)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "KANUNA",
                "model": "Kanuna"
            },
            {
                "regex": "KWANITA",
                "model": "Kwanita"
            },
            {
                "regex": "(Kiona|Kicka[_ ][45][ _]Plus|Kohana|Kosumi|Lonan|Halona|Hotah|Kicka 5|Kiona)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Hezire": {
        "regex": "(HTB801)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Hurricane": {
        "regex": "Hurricane[ _]|(?:Flame_Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Hurricane[ _]IGNITE",
                "model": "Ignite"
            },
            {
                "regex": "Hurricane[ _]Bolt",
                "model": "Bolt"
            },
            {
                "regex": "Hurricane[ _]VORTEX",
                "model": "Vortex"
            },
            {
                "regex": "Hurricane[ _]GIGA",
                "model": "Giga"
            },
            {
                "regex": "Flame_Plus",
                "model": "Flame Plus"
            }
        ]
    },
    "iSWAG": {
        "regex": "ISWAG[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "ISWAG[_ ]VIPER",
                "model": "Viper"
            },
            {
                "regex": "iSWAG[_ ]Lynx",
                "model": "Lynx"
            },
            {
                "regex": "iSWAG[_ ]MANTRA",
                "model": "Mantra"
            },
            {
                "regex": "iSWAG[_ ]MEGA",
                "model": "Mega"
            },
            {
                "regex": "iSWAG[_ ]NEMESIS",
                "model": "Nemesis"
            }
        ]
    },
    "Reeder": {
        "regex": "(?:reeder[_ ](?:3G_Tablet|A7iC|A[78]i[_ ]Quad|A8i Q2|M8 Plus|[TM]8|M10 Plus|P11SE)|P12Curve)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "reeder[_ ](3G_Tablet|A7iC|A[78]i[_ ]Quad|A8i Q2|M8 Plus|[TM]8|M10 Plus|P11SE)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "P12Curve",
                "device": "smartphone",
                "model": "P12 Curve"
            }
        ]
    },
    "ELARI": {
        "regex": "KidPhone4G(?:[);/ ]|$)",
        "device": "wearable",
        "model": "KidPhone 4G"
    },
    "Epik One": {
        "regex": "(K501 Plus|[ ]K5(?:0[0-4]|1[01]|03T|3[456]|4[05]|73)|[ ]K60[01]|[ ]X507T|[ ]K40[56]|[ ]T700)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "K501 Plus",
                "model": "Leo Plus"
            },
            {
                "regex": "K501",
                "model": "Leo"
            },
            {
                "regex": "K500",
                "model": "Omega Lite"
            },
            {
                "regex": "K502",
                "model": "Omega"
            },
            {
                "regex": "K503T",
                "model": "Leo Turbo"
            },
            {
                "regex": "K503",
                "model": "Leo Max"
            },
            {
                "regex": "K504",
                "model": "Titan 3G"
            },
            {
                "regex": "X507T",
                "model": "Titan II"
            },
            {
                "regex": "K510",
                "model": "Bolt"
            },
            {
                "regex": "K511",
                "model": "Bolt Pro"
            },
            {
                "regex": "K534",
                "model": "Hada"
            },
            {
                "regex": "K535",
                "model": "Hada Turbo"
            },
            {
                "regex": "K545",
                "model": "Rocket"
            },
            {
                "regex": "K536",
                "model": "Royal"
            },
            {
                "regex": "K540",
                "model": "Excalibur"
            },
            {
                "regex": "K573",
                "model": "Panther"
            },
            {
                "regex": "K600",
                "model": "Jupiter"
            },
            {
                "regex": "K601",
                "model": "Jupiter One"
            },
            {
                "regex": "K406",
                "model": "Pebble Plus"
            },
            {
                "regex": "K405",
                "model": "Pebble II"
            },
            {
                "regex": "T700",
                "model": "Palette",
                "device": "tablet"
            }
        ]
    },
    "Altice": {
        "regex": "Altice[ _](S62|S31|S43)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Kult": {
        "regex": "(Ambition|Beyond)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Beyond": {
        "regex": "SURVE(10|[26-8]|[12] PRO)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SURVE([12]) PRO",
                "model": "Surve $1 Pro"
            },
            {
                "regex": "SURVE(10|[26-8])",
                "model": "Surve $1"
            }
        ]
    },
    "BioRugged": {
        "regex": "(?:BioWolf 8-F30|BIOWOLF8F30|Ruggbo 20 Lite)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "BioWolf 8-F30|BIOWOLF8F30",
                "model": "BioWolf 8-F30"
            },
            {
                "regex": "Ruggbo 20 Lite",
                "model": "Ruggbo 20 Lite"
            }
        ]
    },
    "VAIO": {
        "regex": "(?:VPA051|VA-10J)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VPA051",
                "model": "Phone A"
            },
            {
                "regex": "(VA-10J)",
                "model": "$1"
            }
        ]
    },
    "Spark": {
        "regex": "Spark Plus 3(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Plus 3",
                "model": "Plus 3"
            }
        ]
    },
    "SPC": {
        "regex": "(?:Gravity Max|GRAVITY_OCTACORE|SPC SMART LITE|SPC_ALIEN(?:_STICK)?|SPC Glow9.7)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "GRAVITY_OCTACORE",
                "model": "Gravity OctaCore"
            },
            {
                "regex": "Gravity Max",
                "model": "Gravity Max"
            },
            {
                "regex": "SPC Glow9.7",
                "model": "Glow 9.7\""
            },
            {
                "regex": "SPC SMART LITE",
                "device": "smartphone",
                "model": "Smart Lite"
            },
            {
                "regex": "SPC_ALIEN_STICK",
                "device": "tv",
                "model": "Alien Stick"
            },
            {
                "regex": "SPC_ALIEN",
                "device": "tv",
                "model": "Alien"
            }
        ]
    },
    "Winmax": {
        "regex": "Winmax[ _](?:XC14|XC[46]|TX30)(?:[);/ ]|$)|MAUI.+Winmax_BD45",
        "device": "smartphone",
        "models": [
            {
                "regex": "Winmax[ _](XC14|XC[46])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Winmax[ _](TX30)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "MAUI.+Winmax_(BD45)",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "Zebra": {
        "regex": " (TC5[16]|TC2[05]|TC75|TC7[05]x|TC700H)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Thuraya": {
        "regex": "Thuraya[ _](X5-Touch)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Bkav": {
        "regex": "Bphone[ _](B111[45]|B2017)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Bphone $1"
    },
    "Brandt": {
        "regex": "(BPRIME|BSTAR\\+?|BPRIMES|B-ONE)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Bigben": {
        "regex": "GAMETAB-ONE(?:[);/ ]|$)",
        "device": "tablet",
        "model": "GameTab-One"
    },
    "SMARTEC": {
        "regex": "(Atractivo)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Asanzo": {
        "regex": "ASANZO[ _](?:A2|S[23]|[SZ]5|S3_PLUS)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ASANZO[ _]S3[ _]PLUS",
                "model": "S3 Plus"
            },
            {
                "regex": "ASANZO[ _](A2|S[23]|[SZ]5)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Artizlee": {
        "regex": "Artizlee[ _]S9|ATL-(?:16|21(?:PLUS|[XT])?|31|26)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "ATL-21PLUS(?:[);/ ]|$)",
                "model": "ATL-21 Plus"
            },
            {
                "regex": "(ATL-(?:16|21[XT]?|31|26))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Artizlee[ _]S9",
                "device": "smartphone",
                "model": "S9"
            }
        ]
    },
    "Mintt": {
        "regex": "(?:Coolmintt(?:A3|M2)?|Ultramintt(?:S2)?|FRESHMINTT(?:A7|A10)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Coolmintt ?([PM]1|P3|A3|M2)(?:[);/ ]|$)",
                "model": "CoolMintt $1"
            },
            {
                "regex": "Ultramintt ?([SR]1|S2)(?:[);/ ]|$)",
                "model": "UltraMintt $1"
            },
            {
                "regex": "FRESHMINTT ?(A7|A10)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "FreshMintt $1"
            }
        ]
    },
    "Premio": {
        "regex": "(?:186HS2080531|186HS1050531|186HS1050232|186FT1080231|185FT5050231|PREMIO[ _](?:S50|P420|P451))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "186HS2080531",
                "model": "X1"
            },
            {
                "regex": "186HS1050531",
                "model": "P541"
            },
            {
                "regex": "185FT5050231",
                "model": "P511"
            },
            {
                "regex": "186FT1080231",
                "model": "P571"
            },
            {
                "regex": "186HS1050232",
                "model": "P630"
            },
            {
                "regex": "PREMIO[ _](S50|P420|P451)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Trifone": {
        "regex": "Passion[-_](?:1S|PRO|PLUS)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Passion-1S",
                "model": "Passion 1S"
            },
            {
                "regex": "Passion-Plus",
                "model": "Passion Plus"
            },
            {
                "regex": "Passion_Pro",
                "model": "Passion Pro"
            }
        ]
    },
    "Bluewave": {
        "regex": "(?:33GT HD|WV8R-M|WV8R[_-]N)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "33GT HD",
                "model": "Wave 8 HD+"
            },
            {
                "regex": "WV8R-M",
                "model": "Wave 8 Red Marshmallow"
            },
            {
                "regex": "WV8R[_-]N",
                "model": "Wave 8 Red Nougat"
            }
        ]
    },
    "Siragon": {
        "regex": "Siragon|(?:SP-(?:5250|5400|5050))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Siragon[_ ])?(SP-(?:5[12]50|5400|5050))",
                "model": "$1"
            }
        ]
    },
    "Poppox": {
        "regex": "Poppox P3",
        "device": "smartphone",
        "model": "P3"
    },
    "Zentality": {
        "regex": "C-723ULTRA(?:[);/ ]|$)",
        "device": "tablet",
        "model": "C-723 Ultra"
    },
    "Black Bear": {
        "regex": "(B6 Master|B6 Note X)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Fortis": {
        "regex": "(Apollo 5 Neo)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "OpelMobile": {
        "regex": " OpelMobile_(SmartJX)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "NuAns": {
        "regex": "NEO \\[Reloaded\\](?:[);/ ]|$)",
        "device": "smartphone",
        "model": "NEO Reloaded"
    },
    "Koolnee": {
        "regex": "(K1 Trio)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Sansui": {
        "regex": "Sansui[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Sansui[_ ](Switch|Play|Fun|SA4[01]|U4[56]|U3[02]|Nova)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Sico": {
        "regex": "SICO[_ ](?:PLUS|e1002)|Express3-Max|SSR3-1-51-5M|SSD-1-53-13M",
        "device": "smartphone",
        "models": [
            {
                "regex": "SICO[_ ]PLUS2",
                "model": "Plus 2"
            },
            {
                "regex": "SICO[_ ]PLUS",
                "model": "Plus"
            },
            {
                "regex": "SSR3-1-51-5M",
                "model": "Pro 3"
            },
            {
                "regex": "SSD-1-53-13M",
                "model": "Diamond"
            },
            {
                "regex": "SICO[_ ]e1002",
                "device": "tablet",
                "model": "E1002"
            },
            {
                "regex": "Express3-Max",
                "device": "tablet",
                "model": "Express 3 Max"
            }
        ]
    },
    "Smadl": {
        "regex": "Android.+(?:Safari)(?!/[\\d.]+)(?: Build|\\) AppleWebKit)|SMADL[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Android.+(?:Safari)(?!/[\\d.]+)(?: Build|\\) AppleWebKit)",
                "model": "Safari"
            },
            {
                "regex": "SMADL[ _]Matri([2X])",
                "model": "Matri $1"
            }
        ]
    },
    "EXCEED": {
        "regex": "(EX7SL?4|EX10S4)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Tymes": {
        "regex": "Tymes[ _](V5)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Solone": {
        "regex": "SOLONE|(?:E1457|W145[02])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E1457",
                "model": "Earth Iron E1457"
            },
            {
                "regex": "W1450",
                "model": "Wind Breeze W1450"
            },
            {
                "regex": "W1452",
                "model": "Wind Air W1452"
            },
            {
                "regex": "SOLONE A47",
                "model": "SL-A47"
            },
            {
                "regex": "SOLONE[ _]Elite[ _]L5501",
                "model": "Elite L5501"
            },
            {
                "regex": "SOLONE[ _]SUMO[_ ]S5001",
                "model": "Sumo S5001"
            },
            {
                "regex": "SOLONE[ _](SL-K40|S5002)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "FarEasTone": {
        "regex": "Smart ?(601|550|50[59])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Smart $1"
    },
    "Smailo": {
        "regex": "Smailo_(2GO)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Colors": {
        "regex": "(?:Colors[ _](S(?:[19]|11)|P70|P[456]5|P32|E15|P50 Plus)|Pride_1A|P52_Pride5C|P90_Pride5X)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Pride_1A(?:[);/ ]|$)",
                "model": "Pride 1A"
            },
            {
                "regex": "P52_Pride5C(?:[);/ ]|$)",
                "model": "Pride 5C"
            },
            {
                "regex": "P90_Pride5X(?:[);/ ]|$)",
                "model": "Pride 5X"
            },
            {
                "regex": "Colors[ _](S(?:[19]|11)|P70|E15|P[456]5|P32|P50 Plus)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Honeywell": {
        "regex": "(EDA50K?|EDA70|EDA51)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "ScanPal $1"
    },
    "Electroneum": {
        "regex": "electroneum(M1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "High Q": {
        "regex": "(ELT070[46]H|ELT0802H)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Pluzz": {
        "regex": "Pluzz[_-](Z552|PL5[05]10|PL4010|PL501[46]|Elite_Dual)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "IKU Mobile": {
        "regex": "(Powerful_K55i|Curvy C50L)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "IKI Mobile": {
        "regex": "(?:GO5_55|BLESS_GO55|BLESSPLUS|KF4Go|KF5bless)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GO5_55",
                "model": "Go 5.5\""
            },
            {
                "regex": "BLESS_GO55",
                "model": "Bless Go 5.5\""
            },
            {
                "regex": "BLESSPLUS",
                "model": "Bless Plus"
            },
            {
                "regex": "(KF4Go|KF5bless)",
                "model": "$1"
            }
        ]
    },
    "CG Mobile": {
        "regex": "(?:CG_OMEGA6|Omega (?:[38])|CG_EON_Blaze_Pro|CG\\|EON Blaze GOLD)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Omega ([38])(?:[);/ ]|$)",
                "model": "Omega $1"
            },
            {
                "regex": "CG_OMEGA6(?:[);/ ]|$)",
                "model": "Omega 6"
            },
            {
                "regex": "CG_EON_Blaze_Pro(?:[);/ ]|$)",
                "model": "EON Blaze Pro"
            },
            {
                "regex": "CG\\|EON Blaze GOLD(?:[);/ ]|$)",
                "model": "EON Blaze Gold"
            }
        ]
    },
    "IUNI": {
        "regex": "IUNI[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "IUNI[ _](U3|i1|N1)",
                "model": "$1"
            }
        ]
    },
    "ZH&K": {
        "regex": "(?:ODYSSEY O2|ODYSSEY RANGE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ODYSSEY O2",
                "model": "Odyssey O2"
            },
            {
                "regex": "ODYSSEY RANGE",
                "model": "Odyssey Range"
            }
        ]
    },
    "Ordissimo": {
        "regex": "(LeNumero1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Necnot": {
        "regex": "(M002[DGQK]-2|M002N|M002N-3T|M002W-2T|6M-3T)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Einstein": {
        "regex": "Einstein(T3)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "AfriOne": {
        "regex": "(CYGNUSX?|Gravity Z2|ChampionPro)(?:[);/ ]|$)",
        "device": "phablet",
        "models": [
            {
                "regex": "CYGNUSX(?:[);/ ]|$)",
                "model": "Cygnus X"
            },
            {
                "regex": "CYGNUS(?:[);/ ]|$)",
                "model": "Cygnus"
            },
            {
                "regex": "Gravity Z2(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Gravity Z2"
            },
            {
                "regex": "ChampionPro(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Champion Pro"
            }
        ]
    },
    "Connex": {
        "regex": "(CTAB1044hn|CTAB-1044)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Connectce": {
        "regex": "(?:CP6001A)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Connect Core 6"
    },
    "Clementoni": {
        "regex": "(?:CLEMPAD[_ ](?:6_XL|HR_Plus|HR|[68]|7_S|201[89])|ClemPhone_7|MFC_(?:2018|8))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CLEMPAD_(201[89])",
                "model": "Clempad ($1)"
            },
            {
                "regex": "MFC_2018",
                "model": "Clempad (2018)"
            },
            {
                "regex": "MFC_8",
                "model": "Clempad 8"
            },
            {
                "regex": "CLEMPAD_7_S",
                "model": "Clempad 7S"
            },
            {
                "regex": "Clempad[_ ](6_XL|HR_Plus|HR|[68])",
                "model": "Clempad $1"
            },
            {
                "regex": "ClemPhone[ _](7)",
                "device": "smartphone",
                "model": "Clemphone $1"
            }
        ]
    },
    "Cell-C": {
        "regex": "Cell_?C_",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cell_C_(Summit_Plus|Fame|Evolve)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "CELLC_Evolve",
                "device": "tablet",
                "model": "Evolve"
            }
        ]
    },
    "VC": {
        "regex": "(?:Camellia_II|Cactus II|Maple III|Maple-II|Cactus-Pro|LavenderII|Jasmine-II)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Camellia_II|Cactus II|Maple III)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Cactus-Pro",
                "model": "Cactus Pro"
            },
            {
                "regex": "(Maple|Jasmine|Lavender)-?II(?:[);/ ]|$)",
                "model": "$1 II"
            }
        ]
    },
    "CellAllure": {
        "regex": "(?:Cool_Extreme_2|Earn|Fashion2Plus|Fashion[ _]C|Cool Duo|CHIC_X1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Cool_Extreme_2|Earn|Fashion[ _]C|Cool Duo)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Fashion2Plus",
                "model": "Fashion 2 Plus"
            },
            {
                "regex": "CHIC_X1",
                "model": "Chic X1"
            }
        ]
    },
    "Eagle": {
        "regex": "Eagle[ _](Classic Pro|Elite|Gold)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Invens": {
        "regex": "(Fighter|Eager)(?: Build|[;)])",
        "device": "smartphone",
        "model": "$1"
    },
    "Chico Mobile": {
        "regex": "(?:ALTO (?:Bombo|classic|Estrella|JUEGO|SUBIR|[235])|FUEGO MAX|OJOS[ _](?:CAMBIO|NUBE|[68i]|ORO))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ALTO Bombo",
                "model": "Alto Bombo"
            },
            {
                "regex": "ALTO classic",
                "model": "Alto Classic"
            },
            {
                "regex": "ALTO Estrella",
                "model": "Alto Estrella"
            },
            {
                "regex": "ALTO JUEGO",
                "model": "Alto Juego"
            },
            {
                "regex": "ALTO SUBIR",
                "model": "Alto Subir"
            },
            {
                "regex": "ALTO ([235])",
                "model": "Alto $1"
            },
            {
                "regex": "OJOS[ _]([68i])",
                "model": "Ojos $1"
            },
            {
                "regex": "OJOS NUBE",
                "model": "Ojos Nube"
            },
            {
                "regex": "OJOS CAMBIO",
                "model": "Ojos Cambio"
            },
            {
                "regex": "OJOS ORO",
                "model": "Ojos Oro"
            },
            {
                "regex": "FUEGO MAX",
                "device": "tablet",
                "model": "Fuego Max"
            }
        ]
    },
    "Claresta": {
        "regex": "Claresta[ _]|(?:AirPhoneS[56]|AirPhone K6)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AirPhone ?(S[56]|K6)",
                "model": "AirPhone $1"
            },
            {
                "regex": "Claresta (F3) PRO",
                "model": "$1 Pro"
            },
            {
                "regex": "Claresta[ _](F4)",
                "model": "$1"
            }
        ]
    },
    "Camfone": {
        "regex": "(?:Camfone (?:SE)|Hero[_ ](?:H5\\+|SE2|H9|(?:H7|XR)_Plus|SX|1[123]|SE3[ _]Max)|Honey (?:Y1|Y2s))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Hero[_ ](?:H5\\+|SE2|H9|(?:H7|XR)_Plus|SX|1[123]|SE3[ _]Max)|Honey (?:Y1|Y2s))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Camfone (SE)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Bellphone": {
        "regex": "Bp100 X-Plus(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "BP 100 X-Plus"
    },
    "Gini": {
        "regex": "Gini[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Gini[ _]W(7)",
                "model": "W$1"
            },
            {
                "regex": "Gini[ _]n(8)",
                "model": "N$1"
            },
            {
                "regex": "Gini[ _]s5Pro",
                "model": "S5 Pro"
            },
            {
                "regex": "Gini[ _]Tab[ _](V[78])",
                "device": "tablet",
                "model": "Tab $1"
            }
        ]
    },
    "MIVO": {
        "regex": "(Caryota [1245789]|Jazz J[13] 2018)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Caryota [1245789])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Jazz (J[13]) 2018",
                "model": "Jazz $1 (2018)"
            }
        ]
    },
    "Jesy": {
        "regex": "Jesy_(J7)",
        "device": "smartphone",
        "model": "$1"
    },
    "Teknosa": {
        "regex": "Preo[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Preo Teknosa P1",
                "model": "Preo P1"
            },
            {
                "regex": "Preo[ _]P([23])",
                "model": "Preo P$1"
            }
        ]
    },
    "Hyve": {
        "regex": "(?:Pryme 01|ST01)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Pryme 01",
                "model": "Pryme 01"
            },
            {
                "regex": "ST01",
                "model": "Storm ST01"
            }
        ]
    },
    "EWIS": {
        "regex": "OCTA T720Q(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Octa T720Q"
    },
    "Leader Phone": {
        "regex": "(Vyper|N-5[07]|N-45)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "N-45 light",
                "model": "N-45 Light"
            },
            {
                "regex": "(Vyper|N-5[07]|N-45)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Cavion": {
        "regex": "(?:Cavion[_ ](?:Solid[_ ]4[\\._]5|Base[ _](?:7|7_3G_Silver|5\\.0|10|7.2 Quad)|10_3GRQ)|Cavion7.1quad)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cavion[_ ]Solid[_ ]4[\\._]5",
                "model": "Solid 4.5\""
            },
            {
                "regex": "Cavion BASE 5.0",
                "model": "Base 5.0\""
            },
            {
                "regex": "CAVION_10_3GRQ",
                "device": "tablet",
                "model": "Base 10 3GR Quad"
            },
            {
                "regex": "Cavion(?:7.1quad)",
                "device": "tablet",
                "model": "Base 7.1\" Quad"
            },
            {
                "regex": "Cavion Base 7.2 Quad",
                "device": "tablet",
                "model": "Base 7.2\" Quad"
            },
            {
                "regex": "Cavion Base 10",
                "device": "tablet",
                "model": "Base 10"
            },
            {
                "regex": "Cavion Base 7 Dual",
                "device": "tablet",
                "model": "Base 7.0\" Dual"
            },
            {
                "regex": "Cavion Base 7 Quad",
                "device": "tablet",
                "model": "Base 7.0\" Quad"
            },
            {
                "regex": "Cavion_Base_7_3G_Silver",
                "device": "tablet",
                "model": "Base 7.0\" 3G Silver"
            }
        ]
    },
    "GLX": {
        "regex": "GLX (?:Aria|Dorna|Taban|Shine|Spark|ASA)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GLX ASA",
                "model": "Asa"
            },
            {
                "regex": "GLX (Aria|Taban|Shine|Spark)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "GLX (Dorna)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Seeken": {
        "regex": "Seeken[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Seeken[_ -](SG1|SJ1)",
                "model": "$1"
            },
            {
                "regex": "Seeken[_ -](ST-101)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Jivi": {
        "regex": "(?:Revolution TnT3|Xtreme_(?:[37]|3x)|Xtreme (?:XT84|XT309 Plus|1))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Revolution (TnT3)",
                "model": "Revolution $1"
            },
            {
                "regex": "Xtreme (XT84)",
                "model": "Xtreme Klick $1"
            },
            {
                "regex": "Xtreme (XT309) Plus",
                "model": "Xtreme View Pro $1Plus"
            },
            {
                "regex": "Xtreme[ _]([137]|3x)(?:[);/ ]|$)",
                "model": "Xtreme $1"
            }
        ]
    },
    "Winnovo": {
        "regex": "Winnovo[ _]",
        "device": "tablet",
        "models": [
            {
                "regex": "Winnovo[ _](M866|M798|VTab|750[PK])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Winnovo[ _](K5[46]|K43)[a-z]{2}",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "WE": {
        "regex": "WE (A[15]0|B3|F[12]0|E[12]|L[3469]|R[34]|V[34]|S1|X[13]|T1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Trio": {
        "regex": "Trio V51 DT(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "V51DT"
    },
    "Seuic": {
        "regex": "(AUTOID9N)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Centric": {
        "regex": "(?:Centric[- ]CM(?:5001|33[23]1|3321Plus)|CM4331)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Centric[- ])?CM5001",
                "model": "A1"
            },
            {
                "regex": "(?:Centric[- ])?CM3321Plus",
                "model": "P1 Plus"
            },
            {
                "regex": "(?:Centric[- ])?CM3321",
                "model": "P1"
            },
            {
                "regex": "(?:Centric[- ])?CM3331",
                "model": "L3"
            },
            {
                "regex": "(?:Centric[- ])?CM4331",
                "model": "G1"
            }
        ]
    },
    "Kata": {
        "regex": "Kata[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Kata[ _-](C3|L1|M3s|M4|V[56])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Kata[ _-]i5-\\w",
                "model": "I5"
            },
            {
                "regex": "Kata-(T5)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Kata-Tmini4(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T Mini 4"
            },
            {
                "regex": "Kata Box 2(?:[);/ ]|$)",
                "device": "tv",
                "model": "Box 2"
            }
        ]
    },
    "Leff": {
        "regex": "Leff Shell (?:HV320WHB-N55|LC390TA2A)(?:[);/ ]|$)",
        "device": "tv",
        "model": ""
    },
    "Hardkernel": {
        "regex": "ODROID[-]?(C2|U2|XU[34])(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "ODROID $1"
    },
    "Wiseasy": {
        "regex": "WISENET5(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "WISENET5"
    },
    "Shtrikh-M": {
        "regex": "SHTRIH-SMARTPOS-F2(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "Smartpos F2"
    },
    "BBK": {
        "regex": "([65]5|4[03]|3[29]|28)LEX[-_](81(?:27|39|45|58|61)|71(?:[23]7|4[345]|5[45]|6[368]|[57]8))[_/]([FU]?TS2C)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1LEX-$2/$3"
    },
    "4ife": {
        "regex": "4ife (4K Smart TV Box)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Westpoint": {
        "regex": "WESTPOINT[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "(TETS-4919SM)",
                "model": "$1"
            }
        ]
    },
    "Wintouch": {
        "regex": "Q93S",
        "device": "tablet",
        "model": "Q93S"
    },
    "Aiuto": {
        "regex": "(AT702)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Seatel": {
        "regex": "Seatel",
        "device": "smartphone",
        "models": [
            {
                "regex": "Seatel[ _](L2|V8[AE]|T[5-8]|R6|V[89])(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Ditecma": {
        "regex": "(M1092R(?:-[12]|V[45])?)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Datamini": {
        "regex": "(K908H4G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "3GNET": {
        "regex": "(?<!NetType/)3GNET[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "3GNET[ _](U8|T800|U6s)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "3GNET[ _]T ?900",
                "model": "T900"
            }
        ]
    },
    "Yoka TV": {
        "regex": "KB2 PRO(?:[);/ ]|$)",
        "device": "tv",
        "model": "KB2 Pro"
    },
    "Formuler": {
        "regex": "Formuler[ _]",
        "device": "tv",
        "models": [
            {
                "regex": "Formuler[ _](Z8(?: Pro)?)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Malata": {
        "regex": "(?:Build/)?Malata[ _]?([a-z0-9]+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "IT": {
        "regex": "IT-(?:1101S?|1101-QUAD)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "IT-1101-QUAD",
                "model": "1101 Quad"
            },
            {
                "regex": "IT-(1101S?)",
                "model": "$1"
            }
        ]
    },
    "Navcity": {
        "regex": "NP-752Go(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NP-752Go",
                "model": "NP-752 Go"
            }
        ]
    },
    "Jiake": {
        "regex": "(?:JK(?:960|103) 3G|JK-?760)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "JK-?(760)(?:[);/ ]|$)",
                "model": "JK-$1"
            },
            {
                "regex": "JK(960|103) 3G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "JK-$1 3G"
            }
        ]
    },
    "iQ&T": {
        "regex": "(IFoo (?:U200|H55))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Mantra": {
        "regex": "(MFSTAB(?:_74G)?)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "Datalogic": {
        "regex": "(?:MEMOR 10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Memor 10"
    },
    "Naomi Phone": {
        "regex": "NAOMIPHONE Ambar(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Ambar"
    },
    "Navitel": {
        "regex": "NAVITEL[ _]",
        "device": "tablet",
        "models": [
            {
                "regex": "NAVITEL[ _](T70[07]) 3G(?:[);/ ]|$)",
                "model": "$1 3G"
            },
            {
                "regex": "NAVITEL[ _](T757)LTE(?:[);/ ]|$)",
                "model": "$1 LTE"
            },
            {
                "regex": "NAVITEL[ _](A73[0157]|A650)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "RE900 Full HD(?:[);/ ]|$)",
                "model": "RE900 Full HD"
            }
        ]
    },
    "Linnex": {
        "regex": "LI(22)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Li $1"
    },
    "Smartab": {
        "regex": "(ST1009)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "SuperTab": {
        "regex": "SuperTab(A10|K7|S7G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Suzuki": {
        "regex": "SUZUKI[ _]|(?:ECOPAD7|SUMOPad10)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SUMOPAD(8100|10)(?:[);/ ]|$)",
                "model": "SumoPad $1"
            },
            {
                "regex": "ECOPAD7",
                "model": "ECOPad 7"
            }
        ]
    },
    "Philips": {
        "regex": "Philips|AND1E(?:[);/ ]|$)|NETTV/|PI3210G|TLE(821L|722G)|TPM1[79]1E|70PUH6774_96|QM16[134]E|Xenium S[25]66|S397|W5510",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Philips[_ ])?Xenium[ _](S[25]66|V787)(?:[);/ ]|$)",
                "model": "Xenium $1"
            },
            {
                "regex": "(?:Philips[_ ])?(S397|W5510)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "AND1E(?: TV)?(?:[);/ ]|$)",
                "model": "Android TV",
                "device": "tv"
            },
            {
                "regex": "(PI3210G)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(TPM1[79]1E)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "(QM16[134]E)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "(70PUH6774)_96",
                "model": "$1/96 4K UHD",
                "device": "tv"
            },
            {
                "regex": "(TLE821L)(?:[);/ ]|$)",
                "model": "$1 4G LTE",
                "device": "tablet"
            },
            {
                "regex": "(TLE722G)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Philips, BDP([0-9]{4})",
                "model": "Blu-ray Player (BDP$1)",
                "device": "tv"
            },
            {
                "regex": "Philips, ([a-z0-9-]+)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "(NETTV/[0-9\\.]{5})",
                "model": "NetTV Series",
                "device": "tv"
            },
            {
                "regex": "Philips-FISIO ([a-z0-9]+)",
                "model": "Fisio $1"
            },
            {
                "regex": "Philips[ _-]?([a-z0-9\\-@]+)",
                "model": "$1"
            }
        ]
    },
    "INCAR": {
        "regex": "(KZCAR)(?:[);/ ]|$)",
        "device": "car browser",
        "model": "$1"
    },
    "FaRao Pro": {
        "regex": "(FTRW100)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Nabi": {
        "regex": "(?:DMTAB-(?:IN08A|NV08B|NV2[04]A)|NBTY07SMKG|NBFP07PMKG|SNB02-NV7A|NABI2-NV7A)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "DMTAB-(?:IN08A|NV08B)",
                "model": "Dream Tab HD 8.0\""
            },
            {
                "regex": "DMTAB-NV(2[04])A",
                "model": "Big Tab HD $1.0\""
            },
            {
                "regex": "NBTY07SMKG",
                "model": "Barbie Tab 7.0\""
            },
            {
                "regex": "NBFP07PMKG",
                "model": "Fisher Price Learning Tab 7.0\""
            },
            {
                "regex": "SNB02-NV7A",
                "model": "2S Tab"
            },
            {
                "regex": "NABI2-NV7A",
                "model": "2 Tab"
            }
        ]
    },
    "StrawBerry": {
        "regex": "StrawBerry[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "StrawBerry[ _](SX|QX15)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Gresso": {
        "regex": "Gresso[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Gresso[ _]Regal(?:[);/ ]|$)",
                "model": "Regal"
            }
        ]
    },
    "Pendoo": {
        "regex": "Pendoo|A5X MAX(?:[\\.-]\\w+)?\\.01\\.d4",
        "device": "tv",
        "models": [
            {
                "regex": "Pendoo ?(T95Z|X10) PLUS",
                "model": "$1 Plus"
            },
            {
                "regex": "Pendoo ?X8PRO+",
                "model": "X8 Pro+"
            },
            {
                "regex": "Pendoo[ \\.]?(X9[29])",
                "model": "$1"
            },
            {
                "regex": "pendoo mini",
                "model": "Mini"
            },
            {
                "regex": "A5X MAX(?:[\\.-]\\w+)?\\.01\\.d4",
                "model": "A5X Max"
            }
        ]
    },
    "PiPO": {
        "regex": "Pipo[_ ]|PipoM9Pro",
        "device": "tablet",
        "models": [
            {
                "regex": "Pipo[_ ]([TP]9)",
                "model": "$1"
            },
            {
                "regex": "PipoM9Pro",
                "model": "M9 Pro"
            },
            {
                "regex": "PIPO[_ ](X10|X9S)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Engel": {
        "regex": "(EN1007Q)plus(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1 Plus"
    },
    "Genesis": {
        "regex": "(SK-Mtek GT730[15])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "InfoKit": {
        "regex": "(TVB-906X)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Blloc": {
        "regex": "(Zero18)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Huskee": {
        "regex": "VULKANO(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Vulkano"
    },
    "SOLE": {
        "regex": "SOLE[_ ]POP[_ ]S([45]0)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Pop S$1"
    },
    "SOLO": {
        "regex": "SOLO[_ ](Aspire(?: M)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "OINOM": {
        "regex": "OINOM[_ ](V9D|V7H|V[679])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Singtech": {
        "regex": "Singtech|(?:Sapphire[_ ](?:H50S|H7S?|H90))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Sapphire[_ ](H50S|H7S?|H90)(?:[);/ ]|$)",
                "model": "Sapphire $1"
            },
            {
                "regex": "Singtech[ _](Q2|S1)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Sunny": {
        "regex": "(SS4G9 Mira|SS4G7 Sole|SS4G1 Luna|SS4G8 Nora|SS4G6 Lola)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "TEENO": {
        "regex": "TEENO",
        "device": "smartphone",
        "models": [
            {
                "regex": "TEENO[_ ](S9|A1|S11)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "v-mobile": {
        "regex": "Vmobile[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Vmobile[ _](J7)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Vmobile XS Pro(?:[);/ ]|$)",
                "model": "XS Pro"
            }
        ]
    },
    "OASYS": {
        "regex": "(TEG9300)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "Aspera": {
        "regex": "ASPERA|(?:Wren)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ASPERA[ _](R5h|RT3|A4[02]|A50)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Wren(?:[);/ ]|$)",
                "model": "Wren"
            }
        ]
    },
    "Vision Touch": {
        "regex": "Vision ?Touch",
        "device": "smartphone",
        "models": [
            {
                "regex": "VisionTouchLife",
                "model": "Life"
            },
            {
                "regex": "Inspire",
                "model": "Inspire"
            }
        ]
    },
    "NOBUX": {
        "regex": "SMART_VOLT_NX5(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Smart Volt NX5"
    },
    "Hitech": {
        "regex": "(Amaze[ _](?:S2_4G|S[56] 4G|S1|S[56](?: Plus)?))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "F150": {
        "regex": "Bison2021(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "B2021"
    },
    "BilimLand": {
        "regex": "BilimBook mini(?:[);/ ]|$)",
        "device": "desktop",
        "model": "BilimBook Mini"
    },
    "Greentel": {
        "regex": "X1_Light_Lte(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "X1_Light_Lte",
                "model": "X1 Light LTE"
            }
        ]
    },
    "Kyowon": {
        "regex": "(KA-E410W)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "LT Mobile": {
        "regex": "(?:LT-NOTE 10S)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LT-NOTE 10S",
                "model": "Note 10S"
            }
        ]
    },
    "ONYX BOOX": {
        "regex": "KON_TIKI(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Kon Tiki"
    },
    "GFive": {
        "regex": "(?:PRESIDENT_GOLD_(9|10))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "PRESIDENT_GOLD_(9|10)",
                "model": "President Gold $1"
            }
        ]
    },
    "KINGZONE": {
        "regex": "KINGZONE_",
        "device": "smartphone",
        "models": [
            {
                "regex": "KINGZONE_(N5)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "M-Tech": {
        "regex": "EROS 4G(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Eros 4G"
    },
    "Fantec": {
        "regex": "FAN-M300H(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "M300H"
    },
    "AURIS": {
        "regex": "(TB-703G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "YUHO": {
        "regex": "YUHO_",
        "device": "smartphone",
        "models": [
            {
                "regex": "YUHO_(O2|H2|Y[123])_PRO",
                "model": "$1 Pro"
            },
            {
                "regex": "YUHO_Vast_Plus",
                "model": "Vast Plus"
            },
            {
                "regex": "YUHO_Y1_ACE",
                "model": "Y1 Ace"
            },
            {
                "regex": "YUHO_Y1_STAR",
                "model": "Y1 Star"
            },
            {
                "regex": "YUHO_O1_LITE",
                "model": "O1 Lite"
            },
            {
                "regex": "YUHO_(Vast2?|O[12]|Y2)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "2F Mobile": {
        "regex": "(Z8PLUS|Z8POCKET)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Z8PLUS",
                "model": "Z8 Plus"
            },
            {
                "regex": "Z8POCKET",
                "model": "Z8 Pocket"
            }
        ]
    }
}

var _$model_55 = {};
"use strict";
Object.defineProperty(_$model_55, "__esModule", { value: true });
_$model_55.buildModel = (model) => {
    model = model.replace(/_/g, " ");
    model = model.replace(RegExp(" TD$", "i"), "");
    if (model === "Build")
        return "";
    return model;
};

var _$mobiles_47 = {};
"use strict";
var ____importDefault_47 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$mobiles_47, "__esModule", { value: true });
const mobiles_json_1 = ____importDefault_47(_$mobiles_27);
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
/* removed: const _$model_55 = require("../../utils/model"); */;
class MobileParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            let resultType = "";
            for (const [brand, mobile] of Object.entries(mobiles_json_1.default)) {
                const match = _$userAgent_57.userAgentParser(mobile.regex, userAgent);
                if (!match)
                    continue;
                resultType = "device" in mobile && mobile.device || "";
                result.brand = brand;
                if ("model" in mobile && mobile.model) {
                    result.model = _$model_55.buildModel(_$variableReplacement_58.variableReplacement(mobile.model, match)).trim();
                }
                else if ("models" in mobile && mobile.models) {
                    for (const model of mobile.models) {
                        const modelMatch = _$userAgent_57.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = _$model_55.buildModel(_$variableReplacement_58.variableReplacement(model.model, modelMatch)).trim();
                        if ("device" in model && model.device) {
                            resultType = model.device;
                        }
                        if ("brand" in model) {
                            result.brand = model.brand || "";
                        }
                        break;
                    }
                }
                break;
            }
            // Sanitize device type
            if (resultType === "tv") {
                result.type = "television";
            }
            else if (resultType === "car browser") {
                result.type = "car";
            }
            else {
                result.type = resultType;
            }
            // Sanitize device brand
            if (result.brand === "Unknown") {
                result.brand = "";
            }
            return result;
        };
    }
}
_$mobiles_47.default = MobileParser;

var _$televisions_30={
    "Airties": {
        "regex": "Airties",
        "device": "tv",
        "models": [
            {
                "regex": "Airties; ?([^);/]+)",
                "model": "$1"
            }
        ]
    },
    "ALDI NORD": {
        "regex": "ALDINORD[;,]",
        "device": "tv",
        "model": ""
    },
    "ALDI SÜD": {
        "regex": "ALDISUED[;,]",
        "device": "tv",
        "model": ""
    },
    "Altech UEC": {
        "regex": "Altech UEC",
        "device": "tv",
        "models": [
            {
                "regex": "Altech UEC; ?([^);/]+)",
                "model": "$1"
            }
        ]
    },
    "AOC": {
        "regex": "AOC",
        "device": "tv",
        "models": [
            {
                "regex": "(LE43S5970-20|S50856)",
                "model": "$1"
            }
        ]
    },
    "ARRIS": {
        "regex": "ARRIS[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "FS-ARS-01B",
                "model": "FS-ARS-01B"
            }
        ]
    },
    "Atvio": {
        "regex": "ATVIO",
        "device": "tv",
        "models": [
            {
                "regex": "55D1620",
                "model": "55D1620"
            }
        ]
    },
    "BangOlufsen": {
        "regex": "Bangolufsen",
        "device": "tv",
        "model": "BeoVision"
    },
    "Blaupunkt": {
        "regex": "Blaupunkt_UMC[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "LC-65CUG8052E",
                "model": "LC-65CUG8052E"
            }
        ]
    },
    "Bush": {
        "regex": "BUSH[;,]",
        "device": "tv",
        "model": ""
    },
    "Celcus": {
        "regex": "CELCUS[;,]",
        "device": "tv",
        "model": ""
    },
    "Changhong": {
        "regex": "Changhong",
        "device": "tv",
        "models": [
            {
                "regex": "Changhong; ?([^);/]+)",
                "model": "$1"
            }
        ]
    },
    "CreNova": {
        "regex": "CreNova",
        "device": "tv",
        "model": "CNV001"
    },
    "Digihome": {
        "regex": "DIGIHOME[;,]",
        "device": "tv",
        "model": ""
    },
    "DMM": {
        "regex": "DMM",
        "device": "tv",
        "model": "Dreambox"
    },
    "ELECTRONIA": {
        "regex": "ELECTRONIA[;,]",
        "device": "tv",
        "model": ""
    },
    "Essentielb": {
        "regex": "ESSENTIELB[;,]",
        "device": "tv",
        "model": ""
    },
    "Finlux": {
        "regex": "FINLUX[;,]",
        "device": "tv",
        "model": ""
    },
    "F&U": {
        "regex": "FU[;,]",
        "device": "tv",
        "model": ""
    },
    "Fuego": {
        "regex": "FUEGO[;,]",
        "device": "tv",
        "model": ""
    },
    "GoGEN": {
        "regex": "GOGEN[;,]",
        "device": "tv",
        "model": ""
    },
    "Grundig": {
        "regex": "(OWB|Grundig|Arcelik)",
        "device": "tv",
        "model": ""
    },
    "Haier": {
        "regex": "(?:HHW_)?HAIER",
        "device": "tv",
        "models": [
            {
                "regex": "LE55X7000U",
                "model": "LE55X7000U"
            }
        ]
    },
    "Hi-Level": {
        "regex": "HI-LEVEL[;,]",
        "device": "tv",
        "model": ""
    },
    "Hisense": {
        "regex": "Hisense|Eurofins_Digital_Testing",
        "device": "tv",
        "models": [
            {
                "regex": "50ADEVTOOL",
                "model": "50ADEVTOOL"
            },
            {
                "regex": "50A683FEVS",
                "model": "50A683FEVS"
            },
            {
                "regex": "55A6100EE",
                "model": "55A6100EE"
            },
            {
                "regex": "55U62QGAVT",
                "model": "55U62QGAVT"
            },
            {
                "regex": "50A6502EA",
                "model": "50A6502EA"
            },
            {
                "regex": "MICALIDVB6886",
                "model": "MICALIDVB6886"
            },
            {
                "regex": "(L[A-Z]{2,3}[0-9]{2}[A-Z][0-9]{3,4}[A-Z]{0,6}[0-9]?[A-Z]?)",
                "model": "$1"
            },
            {
                "regex": "(H[A-Z]?[0-9]{2}[A-Z][0-9]{3,4}[A-Z]{0,4})",
                "model": "$1"
            }
        ]
    },
    "Hitachi": {
        "regex": "Hitachi[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "49D2900",
                "model": "49D2900"
            }
        ]
    },
    "Horizon": {
        "regex": "HORIZON[;,]",
        "device": "tv",
        "model": ""
    },
    "Hotel": {
        "regex": "HOTEL[;,]",
        "device": "tv",
        "model": ""
    },
    "Humax": {
        "regex": "Humax",
        "device": "tv",
        "models": [
            {
                "regex": "(HD-FOX C|HD (FOX\\+|NANO)|iCord (HD\\+|MINI|Cable)|(CX|IR)HD-5100(C|S)|HM9503HD)",
                "model": "$1"
            },
            {
                "regex": "HMS1000S",
                "model": "HMS-1000S"
            },
            {
                "regex": "Humax; ([^);/]+)",
                "model": "$1"
            }
        ]
    },
    "Hyundai": {
        "regex": "HYUNDAI[;,]",
        "device": "tv",
        "model": ""
    },
    "Ikea": {
        "regex": "Ikea",
        "device": "tv",
        "model": ""
    },
    "Intek": {
        "regex": "Intek",
        "device": "tv",
        "models": [
            {
                "regex": "(Vantage|VT-100|VT-1)",
                "model": "$1"
            }
        ]
    },
    "Inverto": {
        "regex": "Inverto",
        "device": "tv",
        "models": [
            {
                "regex": "inverto; ([^);/]+)",
                "model": "$1"
            },
            {
                "regex": "(Volksbox Web Edition|Volksbox Essential|Volksbox II|Volksbox)",
                "model": "$1"
            }
        ]
    },
    "JVC": {
        "regex": "AFTSO001|JVC[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "AFTSO001",
                "model": "4K (2019)"
            }
        ]
    },
    "Kalley": {
        "regex": "KALLEY[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "32D1620",
                "model": "32D1620"
            }
        ]
    },
    "KUBO": {
        "regex": "KUBO[;,]",
        "device": "tv",
        "model": ""
    },
    "Laurus": {
        "regex": "LAURUS[;,]",
        "device": "tv",
        "model": ""
    },
    "LG": {
        "regex": "LGE",
        "device": "tv",
        "models": [
            {
                "regex": "XU43WT180N",
                "model": "XU43WT180N"
            },
            {
                "regex": "43LJ614V-ZA",
                "model": "43LJ614V-ZA"
            },
            {
                "regex": "55SK850V-ZA",
                "model": "55SK850V-ZA"
            },
            {
                "regex": "KEY0000213F1z",
                "model": "KEY0000213F1z"
            },
            {
                "regex": "KEY0000213F",
                "model": "KEY0000213F"
            },
            {
                "regex": "KEY000000(2E|2F|3B|3F)",
                "model": "KEY000000$1"
            },
            {
                "regex": "(NetCast [0-9]{1}.[0-9]{1}|GLOBAL_PLAT3)",
                "model": "$1"
            },
            {
                "regex": "(OLED[0-9]{2}[A-Z0-9]{3}[A-Z]{2})",
                "model": "$1"
            },
            {
                "regex": "(OLED[0-9]{2}[A-Z][0-9][A-Z])",
                "model": "$1"
            },
            {
                "regex": "(OLED[0-9]{2}[A-Z0-9]{2})",
                "model": "$1"
            },
            {
                "regex": "([0-9]{2}[A-Z]{2}[0-9]{4}[A-Z0-9]{1}[A-Z]{2})",
                "model": "$1"
            },
            {
                "regex": "([0-9]{2}NANO[0-9]{3}[A-Z]{2})",
                "model": "$1"
            },
            {
                "regex": "([0-9]{2}NANO[0-9]{2})",
                "model": "$1"
            },
            {
                "regex": "LGE;? ?([0-9]{2}[A-Z]{2}[0-9]{2,4}[A-Z]?)",
                "model": "$1"
            },
            {
                "regex": "LM21U",
                "model": "LM21U"
            },
            {
                "regex": "32LM",
                "model": "32LM"
            }
        ]
    },
    "Lifemaxx": {
        "regex": "Lifemaxx[;,]",
        "device": "tv",
        "model": ""
    },
    "Linsar": {
        "regex": "LINSAR[;,]",
        "device": "tv",
        "model": ""
    },
    "Loewe": {
        "regex": "Loewe",
        "device": "tv",
        "models": [
            {
                "regex": "([A-Z]{2}[0-9]{3})",
                "model": "$1"
            }
        ]
    },
    "Luxor": {
        "regex": "LUXOR[;,]",
        "device": "tv",
        "model": ""
    },
    "Manhattan": {
        "regex": "Manhattan",
        "device": "tv",
        "models": [
            {
                "regex": "T3",
                "model": "T3"
            }
        ]
    },
    "MediaTek": {
        "regex": "MTK|MediaTek;",
        "device": "tv",
        "models": [
            {
                "regex": "(MT[0-9]{4})",
                "model": "$1"
            }
        ]
    },
    "Medion": {
        "regex": "Medion",
        "device": "tv",
        "model": ""
    },
    "Miray": {
        "regex": "MIRAY",
        "device": "tv",
        "models": [
            {
                "regex": "LEDM-322NIP",
                "model": "LEDM-322NIP"
            }
        ]
    },
    "MStar": {
        "regex": "MStar[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "([24])KTV18",
                "model": "$1KTV18"
            }
        ]
    },
    "MTC": {
        "regex": "MTC[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "([24])K_Android_TV_V01",
                "model": "$1K Android TV"
            }
        ]
    },
    "Nordmende": {
        "regex": "NORDMENDE[;,]",
        "device": "tv",
        "model": ""
    },
    "Metz": {
        "regex": "Metz",
        "device": "tv",
        "model": ""
    },
    "Ok": {
        "regex": "OK[;,]",
        "device": "tv",
        "model": ""
    },
    "Panasonic": {
        "regex": "Panasonic",
        "device": "tv",
        "models": [
            {
                "regex": "VIERA (201[1-9])",
                "model": "VIERA ($1)"
            },
            {
                "regex": "(DIGA [A-Z]{1}[0-9]{4})",
                "model": "$1"
            },
            {
                "regex": "DIGA Webkit ([A-Z]{1}[0-9]{4})",
                "model": "DIGA $1"
            },
            {
                "regex": "SmartTV(201[89]|202[0-1])",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "PEAQ": {
        "regex": "PEAQ",
        "device": "tv",
        "model": ""
    },
    "Philips": {
        "regex": "Philips|NETTV/",
        "device": "tv",
        "models": [
            {
                "regex": "Philips[,;] ?((?! )[^),;/]+)",
                "model": "$1"
            },
            {
                "regex": "NETTV/[0-9\\.]{5}",
                "model": "NetTV Series"
            }
        ]
    },
    "Polaroid": {
        "regex": "POLAROID[;,]",
        "device": "tv",
        "model": ""
    },
    "PROFiLO": {
        "regex": "PROFILO[;,]",
        "device": "tv",
        "model": ""
    },
    "Qilive": {
        "regex": "QILIVE[;,]",
        "device": "tv",
        "model": ""
    },
    "REGAL": {
        "regex": "REGAL[;,]",
        "device": "tv",
        "model": ""
    },
    "Saba": {
        "regex": "Saba[;,]",
        "device": "tv",
        "model": ""
    },
    "Salora": {
        "regex": "Salora[;,]",
        "device": "tv",
        "model": ""
    },
    "Samsung": {
        "regex": "Samsung|Maple_2011",
        "device": "tv",
        "models": [
            {
                "regex": "SmartTV(201[2-9]|202[0-1]):([^);/]+)",
                "model": "$2"
            },
            {
                "regex": "SmartTV(201[2-9]|202[0-1])",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "Maple_2011",
                "model": "Smart TV (2011)"
            }
        ]
    },
    "SCBC": {
        "regex": "SCBC[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "SCBC586",
                "model": "SCBC586"
            },
            {
                "regex": "43D1850",
                "model": "43D1850"
            }
        ]
    },
    "SEG": {
        "regex": "SEG[;,]",
        "device": "tv",
        "model": ""
    },
    "Selevision": {
        "regex": "Selevision",
        "device": "tv",
        "models": [
            {
                "regex": "Selevision; (?:Selevision )?([^);/]+)",
                "model": "$1"
            },
            {
                "regex": "(EMC1000i)",
                "model": "$1"
            }
        ]
    },
    "Sharp": {
        "regex": "(?:UMC-)?Sharp",
        "device": "tv",
        "models": [
            {
                "regex": "Sharp[,;] ?((?! |HbbTV)[^),;/]+)",
                "model": "$1"
            },
            {
                "regex": "(LE[0-9]{3}[A-Z]{0,3})",
                "model": "$1"
            },
            {
                "regex": "LC-([^);/]+)",
                "model": "LC-$1"
            },
            {
                "regex": "BLA-43",
                "model": "BLA-43"
            }
        ]
    },
    "Skyworth": {
        "regex": "Sky_worth",
        "device": "tv",
        "models": [
            {
                "regex": "Sky_worth;([^);/]+)",
                "model": "$1"
            }
        ]
    },
    "Smart": {
        "regex": "Smart[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "Smart; ([^);/]+)",
                "model": "$1"
            },
            {
                "regex": "([A-Z]{2}[0-9]{2}|ZAPPIX)",
                "model": "$1"
            }
        ]
    },
    "Sony": {
        "regex": "Sony",
        "device": "tv",
        "models": [
            {
                "regex": "KDL-GR1",
                "model": "KDL-GR1"
            },
            {
                "regex": "KDL-GN([56])",
                "model": "KDL-GN$1"
            },
            {
                "regex": "BRAVIA (VH1|4K VH2)",
                "model": "BRAVIA $1"
            },
            {
                "regex": "(KDL?-?[0-9]{2}[A-Z]{1}[0-9]{4}[A-Z]{1})",
                "model": "$1"
            },
            {
                "regex": "(KDL?-?[0-9]{2}[A-Z]{1}[0-9]{3}[A-Z]{1})",
                "model": "$1"
            },
            {
                "regex": "(KDL?-?[0-9]{2}[A-Z]{1,2}[0-9]{1,5})",
                "model": "$1"
            }
        ]
    },
    "SWTV": {
        "regex": "SWTV[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "SKWE20E21",
                "model": "SKWE20E21"
            }
        ]
    },
    "TD Systems": {
        "regex": "TDSystems[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "SmartTV(2019|2020)",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Technicolor": {
        "regex": "Technicolor",
        "device": "tv",
        "models": [
            {
                "regex": "uzw4054ttg",
                "model": "UZW4054TTG"
            }
        ]
    },
    "Technika": {
        "regex": "TECHNIKA[;,]",
        "device": "tv",
        "model": ""
    },
    "TechniSat": {
        "regex": "TechniSat",
        "device": "tv",
        "models": [
            {
                "regex": "((DigiCorder|MultyVision|Digit) (ISIO S|ISIO C|ISIO))",
                "model": "$1"
            }
        ]
    },
    "TechnoTrend": {
        "regex": "TechnoTrend",
        "device": "tv",
        "models": [
            {
                "regex": "([A-Z]{1}-[0-9]{3})",
                "model": "$1"
            }
        ]
    },
    "Techwood": {
        "regex": "Techwood[;,]",
        "device": "tv",
        "model": ""
    },
    "Telefunken": {
        "regex": "Telefunken",
        "device": "tv",
        "model": ""
    },
    "TCL": {
        "regex": "TCL",
        "device": "tv",
        "models": [
            {
                "regex": "(32D1820|(?:39|55)D2900|32D2930|(?:32|43)S4900)",
                "model": "$1"
            }
        ]
    },
    "Thomson": {
        "regex": "THOMSON[,]?|THOM",
        "device": "tv",
        "models": [
            {
                "regex": "(TB28D19DHS-01|T28D18SFS-01B)",
                "model": "$1 28.0\""
            },
            {
                "regex": "(T32RTM5040|T32D18SFS-01B)",
                "model": "$1 32.0\""
            },
            {
                "regex": "(T43FSL5031|T43D18SFS-01B)",
                "model": "$1 43.0\""
            },
            {
                "regex": "(T40D18SFS-01B)",
                "model": "$1 40.0\""
            },
            {
                "regex": "(T49D18SFS-01B)",
                "model": "$1 49.0\""
            },
            {
                "regex": "(T55D18[SD]FS-01B)",
                "model": "$1 55.0\""
            },
            {
                "regex": "40FB5426",
                "model": "40FB5426"
            }
        ]
    },
    "TOKYO": {
        "regex": "TOKYO[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "TOKTCLED32S",
                "model": "TOKTCLED32S"
            }
        ]
    },
    "Toshiba": {
        "regex": "Toshiba",
        "device": "tv",
        "models": [
            {
                "regex": "40L2600",
                "model": "40L2600"
            },
            {
                "regex": "(([0-9]{2}|DTV_)[A-Z]{2}[0-9]{1,3})",
                "model": "$1"
            }
        ]
    },
    "Videoweb": {
        "regex": "videoweb|tv2n",
        "device": "tv",
        "models": [
            {
                "regex": "(tv2n)",
                "model": "$1"
            },
            {
                "regex": "(videowebtv)",
                "model": "VideoWeb TV"
            }
        ]
    },
    "VOX": {
        "regex": "VOX[;,]",
        "device": "tv",
        "model": ""
    },
    "WELLINGTON": {
        "regex": "WELLINGTON[;,]",
        "device": "tv",
        "model": ""
    },
    "X.Vision": {
        "regex": "X-VISION[;,]",
        "device": "tv",
        "model": ""
    },
    "Vestel": {
        "regex": "(?:Vestel.+VESTEL|VESTEL;)",
        "device": "tv",
        "model": ""
    }
}

var _$televisions_50 = {};
"use strict";
var ____importDefault_50 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$televisions_50, "__esModule", { value: true });
const televisions_json_1 = ____importDefault_50(_$televisions_30);
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
/* removed: const _$model_55 = require("../../utils/model"); */;
class TelevisionParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            if (!this.isHbbTv(userAgent))
                return result;
            result.type = "television";
            for (const [brand, television] of Object.entries(televisions_json_1.default)) {
                const match = _$userAgent_57.userAgentParser(television.regex, userAgent);
                if (!match)
                    continue;
                result.brand = brand;
                if ("model" in television && television.model) {
                    result.model = _$model_55.buildModel(_$variableReplacement_58.variableReplacement(television.model, match)).trim();
                }
                else if ("models" in television && television.models) {
                    for (const model of television.models) {
                        const modelMatch = _$userAgent_57.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = _$model_55.buildModel(_$variableReplacement_58.variableReplacement(model.model, modelMatch)).trim();
                        break;
                    }
                }
                break;
            }
            return result;
        };
        this.isHbbTv = (userAgent) => {
            return _$userAgent_57.userAgentParser("HbbTV\/([1-9]{1}(?:\.[0-9]{1}){1,2})", userAgent);
        };
    }
}
_$televisions_50.default = TelevisionParser;

var _$car_browsers_25={
    "Tesla": {
        "regex": "(?:Tesla/[0-9.]+|QtCarBrowser)",
        "device": "car browser",
        "models": [
            {
                "regex": "QtCarBrowser",
                "model": "Model S"
            },
            {
                "regex": "Tesla/[0-9.]+",
                "model": ""
            }
        ]
    },
    "MAC AUDIO": {
        "regex": "Mac Audio Spro",
        "device": "car browser",
        "models": [
            {
                "regex": "Spro",
                "model": "S Pro"
            }
        ]
    },
    "Topway": {
        "regex": "sp9853i_1h10_vmm",
        "device": "car browser",
        "models": [
            {
                "regex": "sp9853i_1h10_vmm",
                "model": "TS9"
            }
        ]
    }
}

var _$cars_44 = {};
"use strict";
var ____importDefault_44 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$cars_44, "__esModule", { value: true });
const car_browsers_json_1 = ____importDefault_44(_$car_browsers_25);
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class CarParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            for (const [brand, car] of Object.entries(car_browsers_json_1.default)) {
                const match = _$userAgent_57.userAgentParser(car.regex, userAgent);
                if (!match)
                    continue;
                result.type = "car";
                result.brand = brand;
                for (const model of car.models) {
                    const match = _$userAgent_57.userAgentParser(model.regex, userAgent);
                    if (!match)
                        continue;
                    result.model = _$variableReplacement_58.variableReplacement(model.model, match).trim();
                }
                break;
            }
            return result;
        };
    }
}
_$cars_44.default = CarParser;

var _$consoles_26={
    "Archos": {
        "regex": "Archos.*GAMEPAD([2]?)",
        "device": "console",
        "model": "Gamepad $1"
    },
    "Microsoft": {
        "regex": "Xbox",
        "device": "console",
        "models": [
            {
                "regex": "Xbox Series X",
                "model": "Xbox Series X"
            },
            {
                "regex": "Xbox One X",
                "model": "Xbox One X"
            },
            {
                "regex": "Xbox One",
                "model": "Xbox One"
            },
            {
                "regex": "XBOX_ONE_ED",
                "model": "Xbox One S"
            },
            {
                "regex": "Xbox",
                "model": "Xbox 360"
            }
        ]
    },
    "Nintendo": {
        "regex": "Nintendo (([3]?DS[i]?)|Wii[U]?|Switch)",
        "device": "console",
        "model": "$1"
    },
    "OUYA": {
        "regex": "OUYA",
        "device": "console",
        "model": "OUYA"
    },
    "Sega": {
        "regex": "Dreamcast",
        "device": "console",
        "model": "Dreamcast"
    },
    "Sony": {
        "regex": "PlayStation (3|4 Pro|4|Portable|Vita)",
        "device": "console",
        "model": "PlayStation $1"
    }
}

var _$consoles_45 = {};
"use strict";
var ____importDefault_45 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$consoles_45, "__esModule", { value: true });
const consoles_json_1 = ____importDefault_45(_$consoles_26);
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class ConsoleParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            for (const [brand, gameConsole] of Object.entries(consoles_json_1.default)) {
                const match = _$userAgent_57.userAgentParser(gameConsole.regex, userAgent);
                if (!match)
                    continue;
                result.type = gameConsole.device;
                result.brand = brand;
                if ("model" in gameConsole && gameConsole.model) {
                    result.model = _$variableReplacement_58.variableReplacement(gameConsole.model, match).trim();
                }
                else if ("models" in gameConsole && gameConsole.models) {
                    for (const model of gameConsole.models) {
                        const modelMatch = _$userAgent_57.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = _$variableReplacement_58.variableReplacement(model.model, modelMatch).trim();
                        break;
                    }
                }
                break;
            }
            return result;
        };
    }
}
_$consoles_45.default = ConsoleParser;

var _$notebooks_28={
    "Acer": {
        "regex": "FBMD/(?:Aspire E5-421G|Z5WAL|One S1003);",
        "device": "desktop",
        "models": [
            {
                "regex": "FBMD/Aspire E5-421G;",
                "model": "Aspire E5-421G"
            },
            {
                "regex": "FBMD/Z5WAL;",
                "model": "Aspire E5-511"
            },
            {
                "regex": "FBMD/One S1003;",
                "model": "One 10"
            }
        ]
    },
    "Asus": {
        "regex": "FBMD/(?:K50IN|K54L|T100HAN|T103HAF|UX360CAK|X550LB|X553MA|X555LN|X556UQK);",
        "device": "desktop",
        "models": [
            {
                "regex": "FBMD/K50IN;",
                "model": "K50IN"
            },
            {
                "regex": "FBMD/K54L;",
                "model": "K54L"
            },
            {
                "regex": "FBMD/T100HAN;",
                "model": "Transformer Book"
            },
            {
                "regex": "FBMD/T103HAF;",
                "model": "Transformer Mini"
            },
            {
                "regex": "FBMD/UX360CAK;",
                "model": "ZenBook Flip"
            },
            {
                "regex": "FBMD/X550LB;",
                "model": "X550LB"
            },
            {
                "regex": "FBMD/X553MA;",
                "model": "X553MA"
            },
            {
                "regex": "FBMD/X555LN;",
                "model": "X555LN"
            },
            {
                "regex": "FBMD/X556UQK;",
                "model": "X556UQK"
            }
        ]
    },
    "Dell": {
        "regex": "FBMD/(?:Latitude E4300|Inspiron 3541|XPS 15 95[35]0);",
        "device": "desktop",
        "models": [
            {
                "regex": "Latitude E4300",
                "model": "Latitude E4300"
            },
            {
                "regex": "Inspiron 3541",
                "model": "Inspiron 3541"
            },
            {
                "regex": "XPS 15 9530",
                "model": "XPS 15 9530"
            },
            {
                "regex": "XPS 15 9550",
                "model": "XPS 15 9550"
            }
        ]
    },
    "HP": {
        "regex": "FBMD/((?:Compaq|HP) |23-f364)",
        "device": "desktop",
        "models": [
            {
                "regex": "Compaq Presario CQ61 Notebook PC",
                "model": "Compaq Presario CQ61"
            },
            {
                "regex": "HP Pavilion x2 Detachable",
                "model": "Pavilion x2"
            },
            {
                "regex": "HP Laptop 15-bs0xx",
                "model": "15 Laptop PC"
            },
            {
                "regex": "HP ENVY x360 Convertible 15-bp0xx",
                "model": "ENVY x360 Convertible PC"
            },
            {
                "regex": "HP EliteBook (25[67]0p)",
                "model": "EliteBook $1"
            },
            {
                "regex": "HP ProBook (440 G5|6[35]60b)",
                "model": "ProBook $1"
            },
            {
                "regex": "HP Pavilion dv6 Notebook PC",
                "model": "Pavilion dv6"
            },
            {
                "regex": "HP Pavilion Notebook",
                "model": "Pavilion"
            },
            {
                "regex": "HP Spectre x360 Convertible",
                "model": "Spectre x360"
            },
            {
                "regex": "HP Pavilion All-in-One 24-r0xx",
                "model": "Pavilion 24-r0xx All-in-One Desktop PC",
                "device": "desktop"
            },
            {
                "regex": "23-f364",
                "model": "Pavilion TouchSmart 23-f364 All-in-One Desktop PC",
                "device": "desktop"
            }
        ]
    },
    "Lenovo": {
        "regex": "FBMD/(?:37021C5|80E5|80SM|80VR);",
        "device": "desktop",
        "models": [
            {
                "regex": "FBMD/37021C5;",
                "model": "ThinkPad Helix 3702"
            },
            {
                "regex": "FBMD/80E5;",
                "model": "G50-80"
            },
            {
                "regex": "FBMD/80SM;",
                "model": "Ideapad 310-15ISK"
            },
            {
                "regex": "FBMD/80VR;",
                "model": "Legion Y720"
            }
        ]
    },
    "Schneider": {
        "regex": "FBMD/SCL141CTP;",
        "device": "desktop",
        "model": "Notebook 14\" Cherry Trail"
    },
    "Thomson": {
        "regex": "FBMD/TH360R12.32CTW;",
        "device": "desktop",
        "model": "Prestige TH-360R12.32CTW"
    },
    "Toshiba": {
        "regex": "FBMD/Satellite ",
        "device": "desktop",
        "models": [
            {
                "regex": "Satellite (A[25]00|C650|C855|L650|S855)",
                "model": "Satellite $1"
            },
            {
                "regex": "Satellite ([^;\\)]+);",
                "model": "Satellite $1"
            }
        ]
    }
}

var _$notebooks_48 = {};
"use strict";
var ____importDefault_48 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$notebooks_48, "__esModule", { value: true });
const notebooks_json_1 = ____importDefault_48(_$notebooks_28);
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
/* removed: const _$model_55 = require("../../utils/model"); */;
class NotebooksParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            if (!_$userAgent_57.userAgentParser("FBMD/", userAgent)) {
                return result;
            }
            for (const [brand, notebook] of Object.entries(notebooks_json_1.default)) {
                const match = _$userAgent_57.userAgentParser(notebook.regex, userAgent);
                if (!match)
                    continue;
                result.type = "desktop";
                result.brand = brand;
                if ("model" in notebook && notebook.model) {
                    result.model = _$model_55.buildModel(_$variableReplacement_58.variableReplacement(notebook.model, match)).trim();
                }
                else if ("models" in notebook && notebook.models) {
                    for (const model of notebook.models) {
                        const match = _$userAgent_57.userAgentParser(model.regex, userAgent);
                        if (!match)
                            continue;
                        result.model = _$variableReplacement_58.variableReplacement(model.model, match).trim();
                    }
                }
                break;
            }
            return result;
        };
    }
}
_$notebooks_48.default = NotebooksParser;

var _$portable_media_player_29={
    "Apple": {
        "regex": "(?:Apple-)?iPod",
        "device": "portable media player",
        "models": [
            {
                "regex": "(?:Apple-)?iPod1[C,]1",
                "model": "iPod Touch 1G"
            },
            {
                "regex": "(?:Apple-)?iPod2[C,]1",
                "model": "iPod Touch 2G"
            },
            {
                "regex": "(?:Apple-)?iPod3[C,]1",
                "model": "iPod Touch 3"
            },
            {
                "regex": "(?:Apple-)?iPod4[C,]1",
                "model": "iPod Touch 4"
            },
            {
                "regex": "(?:Apple-)?iPod5[C,]1",
                "model": "iPod Touch 5"
            },
            {
                "regex": "(?:Apple-)?iPod7[C,]1",
                "model": "iPod Touch 6"
            },
            {
                "regex": "(?:Apple-)?iPod",
                "model": "iPod Touch"
            }
        ]
    },
    "Cowon": {
        "regex": "COWON ([^;/]+) Build",
        "device": "portable media player",
        "model": "$1"
    },
    "Microsoft": {
        "regex": "Microsoft ZuneHD",
        "device": "portable media player",
        "model": "Zune HD"
    },
    "Panasonic": {
        "regex": "(SV-MV100)",
        "device": "portable media player",
        "model": "$1"
    },
    "Samsung": {
        "regex": "YP-(G[SIPB]?1|G[57]0|GB70D)",
        "device": "portable media player",
        "models": [
            {
                "regex": "YP-G[B]?1",
                "model": "Galaxy Player 4.0"
            },
            {
                "regex": "YP-G70",
                "model": "Galaxy Player 5.0"
            },
            {
                "regex": "YP-GS1",
                "model": "Galaxy Player 3.6"
            },
            {
                "regex": "YP-GI1",
                "model": "Galaxy Player 4.2"
            },
            {
                "regex": "YP-GP1",
                "model": "Galaxy Player 5.8"
            },
            {
                "regex": "YP-G50",
                "model": "Galaxy Player 50"
            },
            {
                "regex": "YP-GB70D",
                "model": "Galaxy Player 70 Plus"
            }
        ]
    },
    "Wizz": {
        "regex": "(DV-PTB1080)(?:[);/ ]|$)",
        "device": "portable media player",
        "model": "$1"
    },
    "SONOS": {
        "regex": "Sonos/.+\\((?:ZP.+)\\)|Sonos;",
        "device": "portable media player",
        "models": [
            {
                "regex": "\\((ZPS(?:[13569]|1[1-578]|2[03])|ZP90)\\)",
                "model": "$1"
            },
            {
                "regex": "Sonos;Play5;",
                "model": "Play:5"
            },
            {
                "regex": "Sonos;One;",
                "model": "One"
            }
        ]
    }
}

var _$portableMediaPlayers_49 = {};
"use strict";
var ____importDefault_49 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$portableMediaPlayers_49, "__esModule", { value: true });
const portable_media_player_json_1 = ____importDefault_49(_$portable_media_player_29);
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class PortableMediaPlayersParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            for (const [brand, portableMediaPlayer] of Object.entries(portable_media_player_json_1.default)) {
                const match = _$userAgent_57.userAgentParser(portableMediaPlayer.regex, userAgent);
                if (!match)
                    continue;
                result.type = portableMediaPlayer.device;
                result.brand = brand;
                if ("model" in portableMediaPlayer && portableMediaPlayer.model) {
                    result.model = _$variableReplacement_58.variableReplacement(portableMediaPlayer.model, match).trim();
                }
                else if ("models" in portableMediaPlayer && portableMediaPlayer.models) {
                    for (const model of portableMediaPlayer.models) {
                        const modelMatch = _$userAgent_57.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = _$variableReplacement_58.variableReplacement(model.model, modelMatch).trim();
                        break;
                    }
                }
                break;
            }
            return result;
        };
    }
}
_$portableMediaPlayers_49.default = PortableMediaPlayersParser;

var _$device_46 = {};
"use strict";
var ____importDefault_46 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$device_46, "__esModule", { value: true });
const cameras_1 = ____importDefault_46(_$cameras_43);
const mobiles_1 = ____importDefault_46(_$mobiles_47);
const televisions_1 = ____importDefault_46(_$televisions_50);
const cars_1 = ____importDefault_46(_$cars_44);
const consoles_1 = ____importDefault_46(_$consoles_45);
const notebooks_1 = ____importDefault_46(_$notebooks_48);
const portable_media_players_1 = ____importDefault_46(_$portableMediaPlayers_49);
const deviceParsers = [
    consoles_1.default,
    cars_1.default,
    cameras_1.default,
    televisions_1.default,
    portable_media_players_1.default,
    mobiles_1.default,
    notebooks_1.default
];
class __ClientParser_46 {
    constructor() {
        this.parse = (userAgent) => {
            for (const Parser of deviceParsers) {
                const parser = new Parser();
                const device = parser.parse(userAgent);
                if (device.type !== "") {
                    return device;
                }
            }
            return null;
        };
    }
}
_$device_46.default = __ClientParser_46;

var _$oss_31=[
    {
        "regex": "Grid OS (\\d+[\\.\\d]+)",
        "name": "GridOS",
        "version": "$1"
    },
    {
        "regex": "CaixaMagica",
        "name": "Caixa Mágica",
        "version": ""
    },
    {
        "regex": "Mageia; Linux",
        "name": "Mageia",
        "version": ""
    },
    {
        "regex": "(?:WH|WhaleTV/)(\\d+[\\.\\d]+)",
        "name": "Whale OS",
        "version": "$1"
    },
    {
        "regex": "Tizen[ /]?(\\d+[\\.\\d]+)?",
        "name": "Tizen",
        "version": "$1"
    },
    {
        "regex": "Sailfish|Jolla",
        "name": "Sailfish OS",
        "version": ""
    },
    {
        "regex": "(?:Ali)?YunOS[ /]?(\\d+[\\.\\d]+)?",
        "name": "YunOS",
        "version": "$1"
    },
    {
        "regex": "Windows Phone;FBSV/(\\d+[\\.\\d]+)",
        "name": "Windows Phone",
        "version": "$1"
    },
    {
        "regex": "(?:Windows Phone (?:OS)?|wds)[ /]?(\\d+[\\.\\d]+)",
        "name": "Windows Phone",
        "version": "$1"
    },
    {
        "regex": "XBLWP7|Windows Phone",
        "name": "Windows Phone",
        "version": ""
    },
    {
        "regex": "Windows CE(?: (\\d+[\\.\\d]+))?",
        "name": "Windows CE",
        "version": "$1"
    },
    {
        "regex": "(?:IEMobile|Windows ?Mobile)(?: (\\d+[\\.\\d]+))?",
        "name": "Windows Mobile",
        "version": "$1"
    },
    {
        "regex": "Windows NT 6.2; ARM;",
        "name": "Windows RT",
        "version": ""
    },
    {
        "regex": "Windows NT 6.3; ARM;",
        "name": "Windows RT",
        "version": "8.1"
    },
    {
        "regex": "Windows IoT 10.0",
        "name": "Windows IoT",
        "version": "10"
    },
    {
        "regex": "KAIOS(?:/(\\d+[\\.\\d]+))?",
        "name": "KaiOS",
        "version": "$1"
    },
    {
        "regex": "RazoDroiD(?: v(\\d+[\\.\\d]*))?",
        "name": "RazoDroiD",
        "version": "$1"
    },
    {
        "regex": "MildWild(?: CM-(\\d+[\\.\\d]*))?",
        "name": "MildWild",
        "version": "$1"
    },
    {
        "regex": "CyanogenMod(?:[\\-/](?:CM)?(\\d+[\\.\\d]*))?",
        "name": "CyanogenMod",
        "version": "$1"
    },
    {
        "regex": "(?:.*_)?MocorDroid(?:(\\d+[\\.\\d]*))?",
        "name": "MocorDroid",
        "version": "$1"
    },
    {
        "regex": "Fire OS(?:/(\\d+[\\.\\d]*))?",
        "name": "Fire OS",
        "version": "$1"
    },
    {
        "regex": "AFTSO001",
        "name": "Fire OS",
        "version": "7"
    },
    {
        "regex": "FydeOS",
        "name": "FydeOS",
        "version": ""
    },
    {
        "regex": "(?:Podbean|Podimo)(?:.+)?/Android",
        "name": "Android",
        "version": ""
    },
    {
        "regex": "Pinterest for Android/.+; (\\d(?:[\\d\\.]+)?)\\)$",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "Android; (\\d+[\\.\\d]*); Mobile;",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "[ ]([\\d\\.]+)\\) AppleWebKit.*ROBLOX Android App",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "(?:(?:Orca-)?Android|Adr)[ /]?(?:[a-z]+ )?(\\d+[\\.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "(?:Allview_TX1_Quasar|Cosmote_My_mini_Tab) (\\d+[\\.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "Android ?(?:jelly bean|Kit Kat|S.O. Ginger Bread|The FireCyano|:) (\\d+[\\.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "(?:Orca-Android|FB4A).*FBSV/(\\d+[\\.\\d]*);",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": " Adr |Android|Silk-Accelerated=[a-z]{4,5}",
        "name": "Android",
        "version": ""
    },
    {
        "regex": "(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "BeyondPod|AntennaPod|Podkicker|DoggCatcher|Player FM|okhttp|Podcatcher Deluxe|.+K_?Android_?TV_|Sonos/.+\\(ACR_",
        "name": "Android",
        "version": ""
    },
    {
        "regex": "Linux; Andr0id[; ](\\d+[\\.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "Linux; diordnA[; ](\\d+[\\.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "AmigaOS[ ]?(\\d+[\\.\\d]+)",
        "name": "AmigaOS",
        "version": "$1"
    },
    {
        "regex": "AmigaOS|AmigaVoyager|Amiga-AWeb",
        "name": "AmigaOS",
        "version": ""
    },
    {
        "regex": "ThreadX(?:/(\\d+[\\.\\d]*))?",
        "name": "ThreadX",
        "version": "$1"
    },
    {
        "regex": "Nucleus(?:(?: |/v?)(\\d+[\\.\\d]*))?",
        "name": "MTK / Nucleus",
        "version": "$1"
    },
    {
        "regex": "MTK(?:(?: |/v?)(\\d+[\\.\\d]*))?",
        "name": "MTK / Nucleus",
        "version": "$1"
    },
    {
        "regex": "MRE/(\\d+)\\.(\\d+).*;MAUI",
        "name": "MRE",
        "version": "$1.$2"
    },
    {
        "regex": "dvkbuntu",
        "name": "DVKBuntu",
        "version": ""
    },
    {
        "regex": "Helio/(\\d+[\\.\\d]+)",
        "name": "Lumin OS",
        "version": "$1"
    },
    {
        "regex": "HasCodingOs (\\d+[\\.\\d]+)",
        "name": "HasCodingOS",
        "version": "$1"
    },
    {
        "regex": "PCLinuxOS/(\\d+[\\.\\d]+)",
        "name": "PCLinuxOS",
        "version": "$1"
    },
    {
        "regex": "(Ordissimo|webissimo3)",
        "name": "Ordissimo",
        "version": ""
    },
    {
        "regex": "(?:Win|Sistema )Fenix",
        "name": "Fenix",
        "version": ""
    },
    {
        "regex": "TOS; Linux",
        "name": "TmaxOS",
        "version": ""
    },
    {
        "regex": "Maemo",
        "name": "Maemo",
        "version": ""
    },
    {
        "regex": "Arch ?Linux(?:[ /\\-](\\d+[\\.\\d]+))?",
        "name": "Arch Linux",
        "version": "$1"
    },
    {
        "regex": "VectorLinux(?: package)?(?:[ /\\-](\\d+[\\.\\d]+))?",
        "name": "VectorLinux",
        "version": "$1"
    },
    {
        "regex": "Linux; .*((?:Debian|Knoppix|Mint|Ubuntu|Kubuntu|Xubuntu|Lubuntu|Fedora|Red Hat|Mandriva|Gentoo|Sabayon|Slackware|SUSE|CentOS|BackTrack))[ /](\\d+[\\.\\d]+)",
        "name": "$1",
        "version": "$2"
    },
    {
        "regex": "Deepin[ /](\\d+[\\.\\d]+)",
        "name": "Deepin",
        "version": "$1"
    },
    {
        "regex": "(Debian|Knoppix|Mint(?! Browser)|Ubuntu|Kubuntu|Xubuntu|Lubuntu|Fedora|Red Hat|Mandriva|Gentoo|Sabayon|Slackware|SUSE|CentOS|BackTrack|Freebox)(?:(?: Enterprise)? Linux)?(?:[ /\\-](\\d+[\\.\\d]+))?",
        "name": "$1",
        "version": "$2"
    },
    {
        "regex": "OS ROSA; Linux",
        "name": "Rosa",
        "version": ""
    },
    {
        "regex": "WEBOS(\\d+[\\.\\d]+)",
        "name": "webOS",
        "version": "$1"
    },
    {
        "regex": "Web0S; Linux/SmartTV.+Chrome/68",
        "name": "webOS",
        "version": "5"
    },
    {
        "regex": "Web0S; Linux/SmartTV.+Chrome/53",
        "name": "webOS",
        "version": "4"
    },
    {
        "regex": "Web0S; Linux/SmartTV.+Chrome/38",
        "name": "webOS",
        "version": "3"
    },
    {
        "regex": "Web0S; Linux/SmartTV.+Safari/538",
        "name": "webOS",
        "version": "2"
    },
    {
        "regex": "Web0S; Linux/SmartTV.+Safari/537",
        "name": "webOS",
        "version": "1"
    },
    {
        "regex": "(?:Web0S; .*WEBOS|webOS|web0S|Palm webOS|hpwOS)(?:[/]?(\\d+[\\.\\d]+))?",
        "name": "webOS",
        "version": "$1"
    },
    {
        "regex": "(?:PalmOS|Palm OS)(?:[/ ](\\d+[\\.\\d]+))?|Palm",
        "name": "palmOS",
        "version": "$1"
    },
    {
        "regex": "Xiino(?:.*v\\. (\\d+[\\.\\d]+))?",
        "name": "palmOS",
        "version": "$1"
    },
    {
        "regex": "MorphOS(?:[ /](\\d+[\\.\\d]+))?",
        "name": "MorphOS",
        "version": "$1"
    },
    {
        "regex": "FBW.+FBSV/(\\d+[\\.\\d]*);",
        "name": "Windows",
        "version": "$1"
    },
    {
        "regex": "mingw32",
        "name": "Windows",
        "version": ""
    },
    {
        "regex": "Windows/(\\d+\\.\\d+)",
        "name": "Windows",
        "version": "$1"
    },
    {
        "regex": "CYGWIN_NT-10.0|Windows NT 10.0|Windows 10",
        "name": "Windows",
        "version": "10"
    },
    {
        "regex": "CYGWIN_NT-6.4|Windows NT 6.4|Windows 10|win10",
        "name": "Windows",
        "version": "10"
    },
    {
        "regex": "CYGWIN_NT-6.3|Windows NT 6.3|Windows 8.1",
        "name": "Windows",
        "version": "8.1"
    },
    {
        "regex": "CYGWIN_NT-6.2|Windows NT 6.2|Windows 8",
        "name": "Windows",
        "version": "8"
    },
    {
        "regex": "CYGWIN_NT-6.1|Windows NT 6.1|Windows 7|win7",
        "name": "Windows",
        "version": "7"
    },
    {
        "regex": "CYGWIN_NT-6.0|Windows NT 6.0|Windows Vista",
        "name": "Windows",
        "version": "Vista"
    },
    {
        "regex": "CYGWIN_NT-5.2|Windows NT 5.2|Windows Server 2003 / XP x64",
        "name": "Windows",
        "version": "Server 2003"
    },
    {
        "regex": "CYGWIN_NT-5.1|Windows NT 5.1|Windows XP",
        "name": "Windows",
        "version": "XP"
    },
    {
        "regex": "CYGWIN_NT-5.0|Windows NT 5.0|Windows 2000",
        "name": "Windows",
        "version": "2000"
    },
    {
        "regex": "CYGWIN_NT-4.0|Windows NT 4.0|WinNT|Windows NT",
        "name": "Windows",
        "version": "NT"
    },
    {
        "regex": "CYGWIN_ME-4.90|Win 9x 4.90|Windows ME",
        "name": "Windows",
        "version": "ME"
    },
    {
        "regex": "CYGWIN_98-4.10|Win98|Windows 98",
        "name": "Windows",
        "version": "98"
    },
    {
        "regex": "CYGWIN_95-4.0|Win32|Win95|Windows 95|Windows_95",
        "name": "Windows",
        "version": "95"
    },
    {
        "regex": "Windows 3.1",
        "name": "Windows",
        "version": "3.1"
    },
    {
        "regex": "Windows",
        "name": "Windows",
        "version": ""
    },
    {
        "regex": "Haiku",
        "name": "Haiku OS",
        "version": ""
    },
    {
        "regex": "(?:Watch1,[12]/|Watch OS,|watchOS[ /])(\\d+[\\.\\d]*)",
        "name": "watchOS",
        "version": "$1"
    },
    {
        "regex": "iPad/([89]|1[012]).(\\d+[\\.\\d]*)",
        "name": "iOS",
        "version": "$1.$2"
    },
    {
        "regex": "Pinterest for iOS/.+; (\\d(?:[\\d\\.]+)?)\\)$",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "CFNetwork/.+ Darwin/20.4.0(?!.*x86_64)",
        "name": "iOS",
        "version": "14.5"
    },
    {
        "regex": "CFNetwork/.+ Darwin/20.3.0(?!.*x86_64)",
        "name": "iOS",
        "version": "14.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/20.2.0(?!.*x86_64)",
        "name": "iOS",
        "version": "14.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/20.1.0(?!.*x86_64)",
        "name": "iOS",
        "version": "14.2"
    },
    {
        "regex": "CFNetwork/.+ Darwin/20.0.0(?!.*x86_64)",
        "name": "iOS",
        "version": "14.0"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.6.0(?!.*x86_64)",
        "name": "iOS",
        "version": "13.6"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.5.0(?!.*x86_64)",
        "name": "iOS",
        "version": "13.5"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.4.0(?!.*x86_64)",
        "name": "iOS",
        "version": "13.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.3.0(?!.*x86_64)",
        "name": "iOS",
        "version": "13.3.1"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.2.0(?!.*x86_64)",
        "name": "iOS",
        "version": "13.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.0.0(?!.*x86_64)",
        "name": "iOS",
        "version": "13.0"
    },
    {
        "regex": "CFNetwork/.+ Darwin/18.7.0(?!.*x86_64)",
        "name": "iOS",
        "version": "12.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/18.6.0(?!.*x86_64)",
        "name": "iOS",
        "version": "12.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/18.5.0(?!.*x86_64)",
        "name": "iOS",
        "version": "12.2"
    },
    {
        "regex": "CFNetwork/.+ Darwin/18.2.0(?!.*x86_64)",
        "name": "iOS",
        "version": "12.1"
    },
    {
        "regex": "CFNetwork/.+ Darwin/18.0.0(?!.*x86_64)",
        "name": "iOS",
        "version": "12.0"
    },
    {
        "regex": "CFNetwork/.+ Darwin/17.7.0(?!.*x86_64)",
        "name": "iOS",
        "version": "11.4.1"
    },
    {
        "regex": "CFNetwork/.+ Darwin/17.6.0(?!.*x86_64)",
        "name": "iOS",
        "version": "11.4"
    },
    {
        "regex": "CFNetwork/889(?!.*x86_64)",
        "name": "iOS",
        "version": "11.1"
    },
    {
        "regex": "CFNetwork/887(?!.*x86_64)",
        "name": "iOS",
        "version": "11.0"
    },
    {
        "regex": "CFNetwork/811(?!.*x86_64)",
        "name": "iOS",
        "version": "10.3"
    },
    {
        "regex": "CFNetwork/808\\.3",
        "name": "iOS",
        "version": "10.3"
    },
    {
        "regex": "CFNetwork/808\\.2",
        "name": "iOS",
        "version": "10.2"
    },
    {
        "regex": "CFNetwork/808\\.1",
        "name": "iOS",
        "version": "10.1"
    },
    {
        "regex": "CFNetwork/808\\.0",
        "name": "iOS",
        "version": "10.0"
    },
    {
        "regex": "CFNetwork/808",
        "name": "iOS",
        "version": "10"
    },
    {
        "regex": "CFNetwork/758\\.4\\.3",
        "name": "iOS",
        "version": "9.3.2"
    },
    {
        "regex": "CFNetwork/758\\.3\\.15",
        "name": "iOS",
        "version": "9.3"
    },
    {
        "regex": "CFNetwork/758\\.2\\.[78]",
        "name": "iOS",
        "version": "9.2"
    },
    {
        "regex": "CFNetwork/758\\.1\\.6",
        "name": "iOS",
        "version": "9.1"
    },
    {
        "regex": "CFNetwork/758\\.0\\.2",
        "name": "iOS",
        "version": "9.0"
    },
    {
        "regex": "CFNetwork/711\\.5\\.6",
        "name": "iOS",
        "version": "8.4.1"
    },
    {
        "regex": "CFNetwork/711\\.4\\.6",
        "name": "iOS",
        "version": "8.4"
    },
    {
        "regex": "CFNetwork/711\\.3\\.18",
        "name": "iOS",
        "version": "8.3"
    },
    {
        "regex": "CFNetwork/711\\.2\\.23",
        "name": "iOS",
        "version": "8.2"
    },
    {
        "regex": "CFNetwork/711\\.1\\.1[26]",
        "name": "iOS",
        "version": "8.1"
    },
    {
        "regex": "CFNetwork/711\\.0\\.6",
        "name": "iOS",
        "version": "8.0"
    },
    {
        "regex": "CFNetwork/672\\.1",
        "name": "iOS",
        "version": "7.1"
    },
    {
        "regex": "CFNetwork/672\\.0",
        "name": "iOS",
        "version": "7.0"
    },
    {
        "regex": "CFNetwork/609\\.1",
        "name": "iOS",
        "version": "6.1"
    },
    {
        "regex": "CFNetwork/60[29]",
        "name": "iOS",
        "version": "6.0"
    },
    {
        "regex": "CFNetwork/548\\.1",
        "name": "iOS",
        "version": "5.1"
    },
    {
        "regex": "CFNetwork/548\\.0",
        "name": "iOS",
        "version": "5.0"
    },
    {
        "regex": "CFNetwork/485\\.13",
        "name": "iOS",
        "version": "4.3"
    },
    {
        "regex": "CFNetwork/485\\.12",
        "name": "iOS",
        "version": "4.2"
    },
    {
        "regex": "CFNetwork/485\\.10",
        "name": "iOS",
        "version": "4.1"
    },
    {
        "regex": "CFNetwork/485\\.2",
        "name": "iOS",
        "version": "4.0"
    },
    {
        "regex": "CFNetwork/467\\.12",
        "name": "iOS",
        "version": "3.2"
    },
    {
        "regex": "CFNetwork/459",
        "name": "iOS",
        "version": "3.1"
    },
    {
        "regex": "iPhone/(\\d+[\\.\\d]*) hw/",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "iOS(\\d+\\.\\d+\\.\\d+)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "iOS(\\d+)\\.(\\d+)0",
        "name": "iOS",
        "version": "$1.$2"
    },
    {
        "regex": "iPhone OS ([0-9]{1})([0-9]{1})([0-9]{1})",
        "name": "iOS",
        "version": "$1.$2.$3"
    },
    {
        "regex": "(?:CPU OS|iPh(?:one)?[ _]OS|iOS)[ _/](\\d+(?:[_\\.]\\d+)*)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "(?:FBIOS|Messenger(?:Lite)?ForiOS).*FBSV/ ?(\\d+[\\.\\d]*);",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "(?:Apple-)?(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\d+\\.\\d+)|; Opera)?",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "(?:Podcasts/(?:[\\d\\.]+)|Instacast(?:HD)?/(?:\\d\\.[\\d\\.abc]+)|Pocket Casts, iOS|\\(iOS\\)|iOS; Opera|Overcast|Castro|Podcat|iCatcher|RSSRadio/|MobileSafari/)(?!.*x86_64)",
        "name": "iOS",
        "version": ""
    },
    {
        "regex": "iTunes-(iPod|iPad|iPhone)/(?:[\\d\\.]+)",
        "name": "iOS",
        "version": ""
    },
    {
        "regex": "iOS/Version ([\\d\\.]+)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "Sonos/.+\\(ICRU_",
        "name": "iOS",
        "version": ""
    },
    {
        "regex": "CFNetwork/.+ Darwin/20.2.0.*(x86_64)|(x86_64-apple-)?darwin20.2.0",
        "name": "Mac",
        "version": "11.1"
    },
    {
        "regex": "CFNetwork/.+ Darwin/20.[01].0.*(x86_64)|(x86_64-apple-)?darwin20.[01].0",
        "name": "Mac",
        "version": "11.0"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.6.0.*(x86_64)|(x86_64-apple-)?darwin19.6.0",
        "name": "Mac",
        "version": "10.15.6"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.5.0.*(x86_64)|(x86_64-apple-)?darwin19.5.0",
        "name": "Mac",
        "version": "10.15.5"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.4.0.*(x86_64)|(x86_64-apple-)?darwin19.4.0",
        "name": "Mac",
        "version": "10.15.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.3.0.*(x86_64)|(x86_64-apple-)?darwin19.3.0",
        "name": "Mac",
        "version": "10.15.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/19.2.0.*(x86_64)|(x86_64-apple-)?darwin19.2.0",
        "name": "Mac",
        "version": "10.15.2"
    },
    {
        "regex": "CFNetwork/(?:108[258]|109[18]|1103).*(x86_64)",
        "name": "Mac",
        "version": "10.15"
    },
    {
        "regex": "CFNetwork/.+ Darwin/18.2.0.*(x86_64)|(x86_64-apple-)?darwin18.2.0",
        "name": "Mac",
        "version": "10.14.1"
    },
    {
        "regex": "CFNetwork/(?:96[29]|97[14568]).*(x86_64)",
        "name": "Mac",
        "version": "10.14"
    },
    {
        "regex": "CFNetwork/.+ Darwin/17.7.0.*(x86_64)|(x86_64-apple-)?darwin17.7.0",
        "name": "Mac",
        "version": "10.13.6"
    },
    {
        "regex": "CFNetwork/.+ Darwin/17.6.0.*(x86_64)|(x86_64-apple-)?darwin17.6.0",
        "name": "Mac",
        "version": "10.13.5"
    },
    {
        "regex": "CFNetwork/.+ Darwin/17.5.0.*(x86_64)|(x86_64-apple-)?darwin17.5.0",
        "name": "Mac",
        "version": "10.13.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/17.4.0.*(x86_64)|(x86_64-apple-)?darwin17.4.0",
        "name": "Mac",
        "version": "10.13.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/17.3.0.*(x86_64)|(x86_64-apple-)?darwin17.3.0",
        "name": "Mac",
        "version": "10.13.2"
    },
    {
        "regex": "CFNetwork/.+ Darwin/17.2.0.*(x86_64)|(x86_64-apple-)?darwin17.2.0",
        "name": "Mac",
        "version": "10.13.1"
    },
    {
        "regex": "CFNetwork/(?:887|889|893|897|901|902).*(x86_64)",
        "name": "Mac",
        "version": "10.13"
    },
    {
        "regex": "CFNetwork/.+ Darwin/16.7.0.*(x86_64)|(x86_64-apple-)?darwin16.7.0",
        "name": "Mac",
        "version": "10.12.6"
    },
    {
        "regex": "CFNetwork/.+ Darwin/16.6.0.*(x86_64)|(x86_64-apple-)?darwin16.6.0",
        "name": "Mac",
        "version": "10.12.5"
    },
    {
        "regex": "CFNetwork/.+ Darwin/16.5.0.*(x86_64)|(x86_64-apple-)?darwin16.5.0",
        "name": "Mac",
        "version": "10.12.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/16.3.0.*(x86_64)|(x86_64-apple-)?darwin16.3.0",
        "name": "Mac",
        "version": "10.12.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/16.2.0.*(x86_64)|(x86_64-apple-)?darwin16.2.0",
        "name": "Mac",
        "version": "10.12.2"
    },
    {
        "regex": "CFNetwork/.+ Darwin/16.1.0.*(x86_64)|(x86_64-apple-)?darwin16.1.0",
        "name": "Mac",
        "version": "10.12.1"
    },
    {
        "regex": "CFNetwork/811.*(x86_64)",
        "name": "Mac",
        "version": "10.12"
    },
    {
        "regex": "CFNetwork/807",
        "name": "Mac",
        "version": "10.12"
    },
    {
        "regex": "CFNetwork/.+ Darwin/15.6.0.*(x86_64)|(x86_64-apple-)?darwin15.6.0",
        "name": "Mac",
        "version": "10.11.6"
    },
    {
        "regex": "CFNetwork/.+ Darwin/15.5.0.*(x86_64)|(x86_64-apple-)?darwin15.5.0",
        "name": "Mac",
        "version": "10.11.5"
    },
    {
        "regex": "CFNetwork/.+ Darwin/15.4.0.*(x86_64)|(x86_64-apple-)?darwin15.4.0",
        "name": "Mac",
        "version": "10.11.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/15.3.0.*(x86_64)|(x86_64-apple-)?darwin15.3.0",
        "name": "Mac",
        "version": "10.11.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/15.2.0.*(x86_64)|(x86_64-apple-)?darwin15.2.0",
        "name": "Mac",
        "version": "10.11.2"
    },
    {
        "regex": "CFNetwork/760",
        "name": "Mac",
        "version": "10.11"
    },
    {
        "regex": "CFNetwork/.+ Darwin/14.5.0.*(x86_64)|(x86_64-apple-)?darwin14.5.0",
        "name": "Mac",
        "version": "10.10.5"
    },
    {
        "regex": "CFNetwork/.+ Darwin/14.4.0.*(x86_64)|(x86_64-apple-)?darwin14.4.0",
        "name": "Mac",
        "version": "10.10.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/14.3.0.*(x86_64)|(x86_64-apple-)?darwin14.3.0",
        "name": "Mac",
        "version": "10.10.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/14.1.0.*(x86_64)|(x86_64-apple-)?darwin14.1.0",
        "name": "Mac",
        "version": "10.10.2"
    },
    {
        "regex": "CFNetwork/720",
        "name": "Mac",
        "version": "10.10"
    },
    {
        "regex": "CFNetwork/.+ Darwin/13.4.0.*(x86_64)|(x86_64-apple-)?darwin13.4.0",
        "name": "Mac",
        "version": "10.9.5"
    },
    {
        "regex": "CFNetwork/.+ Darwin/13.3.0.*(x86_64)|(x86_64-apple-)?darwin13.3.0",
        "name": "Mac",
        "version": "10.9.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/13.2.0.*(x86_64)|(x86_64-apple-)?darwin13.2.0",
        "name": "Mac",
        "version": "10.9.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/13.1.0.*(x86_64)|(x86_64-apple-)?darwin13.1.0",
        "name": "Mac",
        "version": "10.9.2"
    },
    {
        "regex": "CFNetwork/673",
        "name": "Mac",
        "version": "10.9"
    },
    {
        "regex": "CFNetwork/.+ Darwin/12.5.0.*(x86_64)|(x86_64-apple-)?darwin12.5.0",
        "name": "Mac",
        "version": "10.8.5"
    },
    {
        "regex": "CFNetwork/.+ Darwin/12.4.0.*(x86_64)|(x86_64-apple-)?darwin12.4.0",
        "name": "Mac",
        "version": "10.8.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/12.3.0.*(x86_64)|(x86_64-apple-)?darwin12.3.0",
        "name": "Mac",
        "version": "10.8.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/12.2.0.*(x86_64)|(x86_64-apple-)?darwin12.2.0",
        "name": "Mac",
        "version": "10.8.2"
    },
    {
        "regex": "CFNetwork/.+ Darwin/12.1.0.*(x86_64)|(x86_64-apple-)?darwin12.1.0",
        "name": "Mac",
        "version": "10.8.1"
    },
    {
        "regex": "CFNetwork/596",
        "name": "Mac",
        "version": "10.8"
    },
    {
        "regex": "CFNetwork/.+ Darwin/11.5.0.*(x86_64)|(x86_64-apple-)?darwin11.5.0",
        "name": "Mac",
        "version": "10.7.5"
    },
    {
        "regex": "CFNetwork/.+ Darwin/11.4.0.*(x86_64)|(x86_64-apple-)?darwin11.4.0",
        "name": "Mac",
        "version": "10.7.4"
    },
    {
        "regex": "CFNetwork/.+ Darwin/11.3.0.*(x86_64)|(x86_64-apple-)?darwin11.3.0",
        "name": "Mac",
        "version": "10.7.3"
    },
    {
        "regex": "CFNetwork/.+ Darwin/11.2.0.*(x86_64)|(x86_64-apple-)?darwin11.2.0",
        "name": "Mac",
        "version": "10.7.2"
    },
    {
        "regex": "CFNetwork/.+ Darwin/11.1.0.*(x86_64)|(x86_64-apple-)?darwin11.1.0",
        "name": "Mac",
        "version": "10.7.1"
    },
    {
        "regex": "CFNetwork/520",
        "name": "Mac",
        "version": "10.7"
    },
    {
        "regex": "CFNetwork/454",
        "name": "Mac",
        "version": "10.6"
    },
    {
        "regex": "CFNetwork/(?:438|422|339|330|221|220|217)",
        "name": "Mac",
        "version": "10.5"
    },
    {
        "regex": "CFNetwork/12[89]",
        "name": "Mac",
        "version": "10.4"
    },
    {
        "regex": "CFNetwork/1\\.2",
        "name": "Mac",
        "version": "10.3"
    },
    {
        "regex": "CFNetwork/1\\.1",
        "name": "Mac",
        "version": "10.2"
    },
    {
        "regex": "Mac[ +]OS[ +]?X(?:[ /](?:Version )?(\\d+(?:[_\\.]\\d+)+))?",
        "name": "Mac",
        "version": "$1"
    },
    {
        "regex": "Mac (?:OS/)?(\\d+(?:[_\\.]\\d+)+)",
        "name": "Mac",
        "version": "$1"
    },
    {
        "regex": "macOS/(\\d+[\\.\\d]+)",
        "name": "Mac",
        "version": "$1"
    },
    {
        "regex": "Darwin|Macintosh|Mac_PowerPC|PPC|Mac PowerPC|iMac|MacBook|macOS|Sonos/.+\\(MDCR_",
        "name": "Mac",
        "version": ""
    },
    {
        "regex": "SeewoOS x86_64 (\\d+[\\.\\d]+)",
        "name": "SeewoOS",
        "version": "$1"
    },
    {
        "regex": "CrOS [a-z0-9_]+ .* Chrome/(\\d+[\\.\\d]+)",
        "name": "Chrome OS",
        "version": "$1"
    },
    {
        "regex": "(?:BB10;.+Version|Black[Bb]erry[0-9a-z]+|Black[Bb]erry.+Version)/(\\d+[\\.\\d]+)",
        "name": "BlackBerry OS",
        "version": "$1"
    },
    {
        "regex": "RIM Tablet OS (\\d+[\\.\\d]+)",
        "name": "BlackBerry Tablet OS",
        "version": "$1"
    },
    {
        "regex": "RIM Tablet OS|QNX|Play[Bb]ook",
        "name": "BlackBerry Tablet OS",
        "version": ""
    },
    {
        "regex": "BlackBerry",
        "name": "BlackBerry OS",
        "version": ""
    },
    {
        "regex": "bPod",
        "name": "BlackBerry OS",
        "version": ""
    },
    {
        "regex": "BeOS",
        "name": "BeOS",
        "version": ""
    },
    {
        "regex": "Symbian/3.+NokiaBrowser/7\\.3",
        "name": "Symbian^3",
        "version": "Anna"
    },
    {
        "regex": "Symbian/3.+NokiaBrowser/7\\.4",
        "name": "Symbian^3",
        "version": "Belle"
    },
    {
        "regex": "Symbian/3",
        "name": "Symbian^3",
        "version": ""
    },
    {
        "regex": "(?:Series ?60|SymbOS|S60)(?:[ /]?(\\d+[\\.\\d]+|V\\d+))?",
        "name": "Symbian OS Series 60",
        "version": "$1"
    },
    {
        "regex": "Series40",
        "name": "Symbian OS Series 40",
        "version": ""
    },
    {
        "regex": "SymbianOS/(\\d+[\\.\\d]+)",
        "name": "Symbian OS",
        "version": "$1"
    },
    {
        "regex": "MeeGo|WeTab",
        "name": "MeeGo",
        "version": ""
    },
    {
        "regex": "Symbian(?: OS)?|SymbOS",
        "name": "Symbian OS",
        "version": ""
    },
    {
        "regex": "Nokia",
        "name": "Symbian",
        "version": ""
    },
    {
        "regex": "(?:Mobile|Tablet);.+Firefox/\\d+\\.\\d+",
        "name": "Firefox OS",
        "version": ""
    },
    {
        "regex": "RISC OS(?:-NC)?(?:[ /](\\d+[\\.\\d]+))?",
        "name": "RISC OS",
        "version": "$1"
    },
    {
        "regex": "Inferno(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Inferno",
        "version": "$1"
    },
    {
        "regex": "bada(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Bada",
        "version": "$1"
    },
    {
        "regex": "(?:Brew(?!-Applet)(?: MP)?|BMP)(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Brew",
        "version": "$1"
    },
    {
        "regex": "GoogleTV(?:[ /](\\d+[\\.\\d]+))?",
        "name": "Google TV",
        "version": "$1"
    },
    {
        "regex": "AppleTV(?:/?(\\d+[\\.\\d]+))?",
        "name": "Apple TV",
        "version": "$1"
    },
    {
        "regex": "WebTV/(\\d+[\\.\\d]+)",
        "name": "WebTV",
        "version": "$1"
    },
    {
        "regex": "RemixOS 5.1.1",
        "name": "Remix OS",
        "version": "1"
    },
    {
        "regex": "RemixOS 6.0",
        "name": "Remix OS",
        "version": "2"
    },
    {
        "regex": "RemixOS",
        "name": "Remix OS",
        "version": ""
    },
    {
        "regex": "(?:SunOS|Solaris)(?:[/ ](\\d+[\\.\\d]+))?",
        "name": "Solaris",
        "version": "$1"
    },
    {
        "regex": "AIX(?:[/ ]?(\\d+[\\.\\d]+))?",
        "name": "AIX",
        "version": "$1"
    },
    {
        "regex": "HP-UX(?:[/ ]?(\\d+[\\.\\d]+))?",
        "name": "HP-UX",
        "version": "$1"
    },
    {
        "regex": "FreeBSD(?:[/ ]?(\\d+[\\.\\d]+))?",
        "name": "FreeBSD",
        "version": "$1"
    },
    {
        "regex": "NetBSD(?:[/ ]?(\\d+[\\.\\d]+))?",
        "name": "NetBSD",
        "version": "$1"
    },
    {
        "regex": "OpenBSD(?:[/ ]?(\\d+[\\.\\d]+))?",
        "name": "OpenBSD",
        "version": "$1"
    },
    {
        "regex": "DragonFly(?:[/ ]?(\\d+[\\.\\d]+))?",
        "name": "DragonFly",
        "version": "$1"
    },
    {
        "regex": "Syllable(?:[/ ]?(\\d+[\\.\\d]+))?",
        "name": "Syllable",
        "version": "$1"
    },
    {
        "regex": "IRIX(?:;64)?(?:[/ ]?(\\d+[\\.\\d]+))",
        "name": "IRIX",
        "version": "$1"
    },
    {
        "regex": "OSF1(?:[/ ]?v?(\\d+[\\.\\d]+))?",
        "name": "OSF1",
        "version": "$1"
    },
    {
        "regex": "Nintendo (Wii|Switch)",
        "name": "Nintendo",
        "version": "$1"
    },
    {
        "regex": "PlayStation ?([34])",
        "name": "PlayStation",
        "version": "$1"
    },
    {
        "regex": "Xbox|KIN\\.(?:One|Two)",
        "name": "Xbox",
        "version": "360"
    },
    {
        "regex": "Nitro|Nintendo ([3]?DS[i]?)",
        "name": "Nintendo Mobile",
        "version": "$1"
    },
    {
        "regex": "PlayStation ((?:Portable|Vita))",
        "name": "PlayStation Portable",
        "version": "$1"
    },
    {
        "regex": "OS/2",
        "name": "OS/2",
        "version": ""
    },
    {
        "regex": "Linux(?:OS)?[^a-z]",
        "name": "GNU/Linux",
        "version": ""
    }
]

var _$operatingSystem_51={
    "operatingSystem": {
        "AIX": "AIX",
        "AND": "Android",
        "AMG": "AmigaOS",
        "ATV": "Apple TV",
        "ARL": "Arch Linux",
        "BTR": "BackTrack",
        "SBA": "Bada",
        "BEO": "BeOS",
        "BLB": "BlackBerry OS",
        "QNX": "BlackBerry Tablet OS",
        "BMP": "Brew",
        "CES": "CentOS",
        "COS": "Chrome OS",
        "CYN": "CyanogenMod",
        "DEB": "Debian",
        "DEE": "Deepin",
        "DFB": "DragonFly",
        "FED": "Fedora",
        "FOS": "Firefox OS",
        "FIR": "Fire OS",
        "FRE": "Freebox",
        "BSD": "FreeBSD",
        "FYD": "FydeOS",
        "GNT": "Gentoo",
        "GTV": "Google TV",
        "HPX": "HP-UX",
        "HAI": "Haiku OS",
        "IRI": "IRIX",
        "INF": "Inferno",
        "KOS": "KaiOS",
        "KNO": "Knoppix",
        "KBT": "Kubuntu",
        "LIN": "GNU/Linux",
        "LBT": "Lubuntu",
        "VLN": "VectorLinux",
        "MAC": "Mac",
        "MAE": "Maemo",
        "MDR": "Mandriva",
        "SMG": "MeeGo",
        "MCD": "MocorDroid",
        "MIN": "Mint",
        "MLD": "MildWild",
        "MOR": "MorphOS",
        "NBS": "NetBSD",
        "MTK": "MTK / Nucleus",
        "MRE": "MRE",
        "WII": "Nintendo",
        "NDS": "Nintendo Mobile",
        "OS2": "OS/2",
        "T64": "OSF1",
        "OBS": "OpenBSD",
        "ORD": "Ordissimo",
        "PSP": "PlayStation Portable",
        "PS3": "PlayStation",
        "RHT": "Red Hat",
        "ROS": "RISC OS",
        "RSO": "Rosa",
        "REM": "Remix OS",
        "RZD": "RazoDroiD",
        "SAB": "Sabayon",
        "SSE": "SUSE",
        "SAF": "Sailfish OS",
        "SEE": "SeewoOS",
        "SLW": "Slackware",
        "SOS": "Solaris",
        "SYL": "Syllable",
        "SYM": "Symbian",
        "SYS": "Symbian OS",
        "S40": "Symbian OS Series 40",
        "S60": "Symbian OS Series 60",
        "SY3": "Symbian^3",
        "TDX": "ThreadX",
        "TIZ": "Tizen",
        "TOS": "TmaxOS",
        "UBT": "Ubuntu",
        "WAS": "watchOS",
        "WTV": "WebTV",
        "WHS": "Whale OS",
        "WIN": "Windows",
        "WCE": "Windows CE",
        "WIO": "Windows IoT",
        "WMO": "Windows Mobile",
        "WPH": "Windows Phone",
        "WRT": "Windows RT",
        "XBX": "Xbox",
        "XBT": "Xubuntu",
        "YNS": "YunOs",
        "IOS": "iOS",
        "POS": "palmOS",
        "WOS": "webOS"
    },
    "osFamilies": {
        "Android": ["AND", "CYN", "FIR", "REM", "RZD", "MLD", "MCD", "YNS"],
        "AmigaOS": ["AMG", "MOR"],
        "Apple TV": ["ATV"],
        "BlackBerry": ["BLB", "QNX"],
        "Brew": ["BMP"],
        "BeOS": ["BEO", "HAI"],
        "Chrome OS": ["COS", "FYD", "SEE"],
        "Firefox OS": ["FOS", "KOS"],
        "Gaming Console": ["WII", "PS3"],
        "Google TV": ["GTV"],
        "IBM": ["OS2"],
        "iOS": ["IOS", "WAS"],
        "RISC OS": ["ROS"],
        "GNU/Linux": [
            "LIN", "ARL", "DEB", "KNO", "MIN", "UBT", "KBT", "XBT", "LBT", "FED",
            "RHT", "VLN", "MDR", "GNT", "SAB", "SLW", "SSE", "CES", "BTR", "SAF",
            "ORD", "TOS", "RSO", "DEE", "FRE"
        ],
        "Mac": ["MAC"],
        "Mobile Gaming Console": ["PSP", "NDS", "XBX"],
        "Real-time OS": ["MTK", "TDX", "MRE"],
        "Other Mobile": ["WOS", "POS", "SBA", "TIZ", "SMG", "MAE"],
        "Symbian": ["SYM", "SYS", "SY3", "S60", "S40"],
        "Unix": ["SOS", "AIX", "HPX", "BSD", "NBS", "OBS", "DFB", "SYL", "IRI", "T64", "INF"],
        "WebTV": ["WTV"],
        "Windows": ["WIN"],
        "Windows Mobile": ["WPH", "WMO", "WCE", "WRT", "WIO"],
        "Other Smart TV": ["WHS"]
    }
}

var _$operatingSystem_52 = {};
"use strict";
var ____importDefault_52 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$operatingSystem_52, "__esModule", { value: true });
const oss_json_1 = ____importDefault_52(_$oss_31);
/* removed: const _$version_60 = require("../../utils/version"); */;
/* removed: const _$variableReplacement_58 = require("../../utils/variable-replacement"); */;
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
const operating_system_json_1 = ____importDefault_52(_$operatingSystem_51);
const desktopOsArray = ["AmigaOS", "IBM", "GNU/Linux", "Mac", "Unix", "Windows", "BeOS", "Chrome OS"];
const shortOsNames = operating_system_json_1.default.operatingSystem;
const osFamilies = operating_system_json_1.default.osFamilies;
class OperatingSystemParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                name: "",
                version: "",
                platform: this.parsePlatform(userAgent)
            };
            for (const operatingSystem of oss_json_1.default) {
                const match = _$userAgent_57.userAgentParser(operatingSystem.regex, userAgent);
                if (!match)
                    continue;
                result.name = _$variableReplacement_58.variableReplacement(operatingSystem.name, match);
                result.version = _$version_60.formatVersion(_$variableReplacement_58.variableReplacement(operatingSystem.version, match), this.options.versionTruncation);
                if (result.name === "lubuntu") {
                    result.name = "Lubuntu";
                }
                if (result.name === "debian") {
                    result.name = "Debian";
                }
                if (result.name === "YunOS") {
                    result.name = "YunOs";
                }
                return result;
            }
            return null;
        };
        this.parsePlatform = (userAgent) => {
            if (_$userAgent_57.userAgentParser("arm|aarch64|Watch ?OS|Watch1,[12]", userAgent)) {
                return "ARM";
            }
            if (_$userAgent_57.userAgentParser("mips", userAgent)) {
                return "MIPS";
            }
            if (_$userAgent_57.userAgentParser("sh4", userAgent)) {
                return "SuperH";
            }
            if (_$userAgent_57.userAgentParser("WOW64|x64|win64|amd64|x86_?64", userAgent)) {
                return "x64";
            }
            if (_$userAgent_57.userAgentParser("(?:i[0-9]|x)86|i86pc", userAgent)) {
                return "x86";
            }
            return "";
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
_$operatingSystem_52.default = OperatingSystemParser;
OperatingSystemParser.getDesktopOsArray = () => desktopOsArray;
OperatingSystemParser.getOsFamily = (osName) => {
    const osShortName = OperatingSystemParser.getOsShortName(osName);
    for (const [osFamily, shortNames] of Object.entries(osFamilies)) {
        if (shortNames.includes(osShortName)) {
            return osFamily;
        }
    }
    return "";
};
OperatingSystemParser.getOsShortName = (osName) => {
    for (const [shortName, name] of Object.entries(shortOsNames)) {
        if (name === osName)
            return shortName;
    }
    return "";
};

var _$vendorfragments_32={
    "Dell": [
        "MDDR(JS)?",
        "MDDC(JS)?",
        "MDDS(JS)?"
    ],
    "Acer": [
        "MAAR(JS)?"
    ],
    "Sony": [
        "MASE(JS)?",
        "MASP(JS)?",
        "MASA(JS)?"
    ],
    "Asus": [
        "MAAU",
        "NP0[26789]",
        "ASJB",
        "ASU2(JS)?"
    ],
    "Samsung": [
        "MASM(JS)?",
        "SMJB"
    ],
    "Lenovo": [
        "MALC(JS)?",
        "MALE(JS)?",
        "MALN(JS)?",
        "LCJB",
        "LEN2"
    ],
    "Toshiba": [
        "MATM(JS)?",
        "MATB(JS)?",
        "MATP(JS)?",
        "TNJB",
        "TAJB"
    ],
    "Medion": [
        "MAMD"
    ],
    "MSI": [
        "MAMI(JS)?",
        "MAM3"
    ],
    "Gateway": [
        "MAGW(JS)?"
    ],
    "Fujitsu": [
        "MAFS(JS)?",
        "FSJB"
    ],
    "Compaq": [
        "CPDTDF",
        "CPNTDF(JS?)",
        "CMNTDF(JS)?",
        "CMDTDF(JS)?"
    ],
    "HP": [
        "HPCMHP",
        "HPNTDF(JS)?",
        "HPDTDF(JS)?"
    ],
    "Hyrican": [
        "MANM(JS)?"
    ],
    "Ordissimo": [
        "Ordissimo",
        "webissimo3"
    ]
}

var _$vendorFragment_53 = {};
"use strict";
var ____importDefault_53 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(_$vendorFragment_53, "__esModule", { value: true });
const vendorfragments_json_1 = ____importDefault_53(_$vendorfragments_32);
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class VendorFragmentParser {
    constructor() {
        this.parse = (userAgent) => {
            for (const [brand, vendorFragment] of Object.entries(vendorfragments_json_1.default)) {
                for (const regex of vendorFragment) {
                    const match = _$userAgent_57.userAgentParser(regex, userAgent);
                    if (!match)
                        continue;
                    return brand;
                }
            }
            return "";
        };
    }
}
_$vendorFragment_53.default = VendorFragmentParser;

var _$bots_16=[
    {
        "regex": "360Spider(-Image|-Video)?",
        "name": "360Spider",
        "category": "Search bot",
        "url": "https://www.so.com/help/help_3_2.html",
        "producer": {
            "name": "Online Media Group, Inc.",
            "url": ""
        }
    },
    {
        "regex": "Aboundex",
        "name": "Aboundexbot",
        "category": "Search bot",
        "url": "http://www.aboundex.com/crawler/",
        "producer": {
            "name": "Aboundex.com",
            "url": "http://www.aboundex.com"
        }
    },
    {
        "regex": "AcoonBot",
        "name": "Acoon",
        "category": "Search bot",
        "url": "http://www.acoon.de/robot.asp",
        "producer": {
            "name": "Acoon GmbH",
            "url": "http://www.acoon.de"
        }
    },
    {
        "regex": "AddThis\\.com",
        "name": "AddThis.com",
        "category": "Social Media Agent",
        "url": "",
        "producer": {
            "name": "Clearspring Technologies, Inc.",
            "url": "http://www.clearspring.com"
        }
    },
    {
        "regex": "AhrefsBot",
        "name": "aHrefs Bot",
        "category": "Crawler",
        "url": "https://ahrefs.com/robot",
        "producer": {
            "name": "Ahrefs Pte Ltd",
            "url": "https://ahrefs.com/robot"
        }
    },
    {
        "regex": "ia_archiver|alexabot|verifybot",
        "name": "Alexa Crawler",
        "category": "Search bot",
        "url": "https://support.alexa.com/hc/en-us/sections/200100794-Crawlers",
        "producer": {
            "name": "Alexa Internet",
            "url": "https://www.alexa.com"
        }
    },
    {
        "regex": "alexa site audit",
        "name": "Alexa Site Audit",
        "category": "Site Monitor",
        "url": "https://support.alexa.com/hc/en-us/articles/200450194",
        "producer": {
            "name": "Alexa Internet",
            "url": "https://www.alexa.com"
        }
    },
    {
        "regex": "Amazon[ -]Route ?53[ -]Health[ -]Check[ -]Service",
        "name": "Amazon Route53 Health Check",
        "category": "Service Agent",
        "producer": {
            "name": "Amazon Web Services",
            "url": "https://aws.amazon.com/"
        }
    },
    {
        "regex": "AmorankSpider",
        "name": "Amorank Spider",
        "category": "Crawler",
        "url": "http://amorank.com/webcrawler.html",
        "producer": {
            "name": "Amorank",
            "url": "http://www.amorank.com"
        }
    },
    {
        "regex": "ApacheBench",
        "name": "ApacheBench",
        "category": "Benchmark",
        "url": "https://httpd.apache.org/docs/2.4/programs/ab.html",
        "producer": {
            "name": "The Apache Software Foundation",
            "url": "https://www.apache.org/foundation/"
        }
    },
    {
        "regex": "Applebot",
        "name": "Applebot",
        "category": "Crawler",
        "url": "https://support.apple.com/en-us/HT204683",
        "producer": {
            "name": "Apple Inc",
            "url": "https://www.apple.com"
        }
    },
    {
        "regex": "AppSignalBot",
        "name": "AppSignalBot",
        "category": "Site Monitor",
        "url": "https://docs.appsignal.com/uptime-monitoring/",
        "producer": {
            "name": "AppSignal",
            "url": "https://appsignal.com/"
        }
    },
    {
        "regex": "Arachni",
        "name": "Arachni",
        "category": "Security Checker",
        "url": "https://www.arachni-scanner.com/",
        "producer": {
            "name": "Sarosys LLC",
            "url": "https://www.sarosys.com/"
        }
    },
    {
        "regex": "AspiegelBot",
        "name": "AspiegelBot",
        "category": "Crawler",
        "url": "https://aspiegel.com/",
        "producer": {
            "name": "Huawei",
            "url": "https://www.huawei.com/"
        }
    },
    {
        "regex": "Castro 2, Episode Duration Lookup",
        "name": "Castro 2",
        "category": "Service Agent",
        "url": "http://supertop.co/castro/",
        "producer": {
            "name": "Supertop",
            "url": "http://supertop.co"
        }
    },
    {
        "regex": "Curious George",
        "name": "Analytics SEO Crawler",
        "category": "Crawler",
        "url": "http://www.analyticsseo.com/crawler",
        "producer": {
            "name": "Analytics SEO",
            "url": "http://www.analyticsseo.com"
        }
    },
    {
        "regex": "archive\\.org_bot|special_archiver",
        "name": "archive.org bot",
        "category": "Crawler",
        "url": "https://archive.org/details/archive.org_bot",
        "producer": {
            "name": "The Internet Archive",
            "url": "https://archive.org"
        }
    },
    {
        "regex": "Ask Jeeves/Teoma",
        "name": "Ask Jeeves",
        "category": "Search bot",
        "url": "",
        "producer": {
            "name": "Ask Jeeves Inc.",
            "url": "http://www.ask.com"
        }
    },
    {
        "regex": "Backlink-Check\\.de",
        "name": "Backlink-Check.de",
        "category": "Crawler",
        "url": "http://www.backlink-check.de/bot.html",
        "producer": {
            "name": "Mediagreen Medienservice",
            "url": "http://www.backlink-check.de"
        }
    },
    {
        "regex": "BacklinkCrawler",
        "name": "BacklinkCrawler",
        "category": "Crawler",
        "url": "http://www.backlinktest.com/crawler.html",
        "producer": {
            "name": "2.0Promotion GbR",
            "url": "http://www.backlinktest.com"
        }
    },
    {
        "regex": "baiduspider(-image)?|baidu Transcoder|baidu.*spider",
        "name": "Baidu Spider",
        "category": "Search bot",
        "url": "http://www.baidu.com/search/spider.htm",
        "producer": {
            "name": "Baidu",
            "url": "http://www.baidu.com"
        }
    },
    {
        "regex": "BazQux",
        "name": "BazQux Reader",
        "url": "https://bazqux.com/fetcher",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "MSNBot|msrbot|bingbot|BingPreview|msnbot-(UDiscovery|NewsBlogs)|adidxbot",
        "name": "BingBot",
        "category": "Search bot",
        "url": "http://search.msn.com/msnbot.htmn",
        "producer": {
            "name": "Microsoft Corporation",
            "url": "http://www.microsoft.com"
        }
    },
    {
        "regex": "Blekkobot",
        "name": "Blekkobot",
        "category": "Search bot",
        "url": "http://blekko.com/about/blekkobot",
        "producer": {
            "name": "Blekko",
            "url": "http://blekko.com"
        }
    },
    {
        "regex": "BLEXBot(Test)?",
        "name": "BLEXBot Crawler",
        "category": "Crawler",
        "url": "http://webmeup-crawler.com",
        "producer": {
            "name": "WebMeUp",
            "url": "http://webmeup.com"
        }
    },
    {
        "regex": "Bloglovin",
        "name": "Bloglovin",
        "url": "http://www.bloglovin.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Blogtrottr",
        "name": "Blogtrottr",
        "url": "",
        "category": "Feed Fetcher",
        "producer": {
            "name": "Blogtrottr Ltd",
            "url": "https://blogtrottr.com/"
        }
    },
    {
        "regex": "BoardReader Blog Indexer",
        "name": "BoardReader Blog Indexer",
        "category": "Crawler",
        "producer": {
            "name": "BoardReader",
            "url": "https://boardreader.com/"
        }
    },
    {
        "regex": "BountiiBot",
        "name": "Bountii Bot",
        "category": "Search bot",
        "url": "http://bountii.com/contact.php",
        "producer": {
            "name": "Bountii Inc.",
            "url": "http://bountii.com"
        }
    },
    {
        "regex": "Browsershots",
        "name": "Browsershots",
        "category": "Service Agent",
        "url": "http://browsershots.org/faq",
        "producer": {
            "name": "Browsershots.org",
            "url": "http://browsershots.org"
        }
    },
    {
        "regex": "BUbiNG",
        "name": "BUbiNG",
        "category": "Crawler",
        "url": "http://law.di.unimi.it/BUbiNG.html",
        "producer": {
            "name": "The Laboratory for Web Algorithmics (LAW)",
            "url": "http://law.di.unimi.it/software.php#buging"
        }
    },
    {
        "regex": "(?<!HTC)[ _]Butterfly/",
        "name": "Butterfly Robot",
        "category": "Search bot",
        "url": "http://labs.topsy.com/butterfly",
        "producer": {
            "name": "Topsy Labs",
            "url": "http://labs.topsy.com"
        }
    },
    {
        "regex": "CareerBot",
        "name": "CareerBot",
        "category": "Crawler",
        "url": "http://www.career-x.de/bot.html",
        "producer": {
            "name": "career-x GmbH",
            "url": "http://www.career-x.de"
        }
    },
    {
        "regex": "CCBot",
        "name": "ccBot crawler",
        "category": "Crawler",
        "url": "http://commoncrawl.org/faq/",
        "producer": {
            "name": "reddit inc.",
            "url": "http://www.reddit.com"
        }
    },
    {
        "regex": "Cliqzbot",
        "name": "Cliqzbot",
        "category": "Crawler",
        "url": "http://cliqz.com/company/cliqzbot",
        "producer": {
            "name": "10betterpages GmbH",
            "url": "http://cliqz.com"
        }
    },
    {
        "regex": "Cloudflare-AMP",
        "name": "CloudFlare AMP Fetcher",
        "category": "Crawler",
        "url": "https://amp.cloudflare.com/doc/fetcher.html",
        "producer": {
            "name": "CloudFlare",
            "url": "http://www.cloudflare.com"
        }
    },
    {
        "regex": "CloudflareDiagnostics",
        "name": "Cloudflare Diagnostics",
        "category": "Site Monitor",
        "url": "https://www.cloudflare.com/",
        "producer": {
            "name": "Cloudflare",
            "url": "https://www.cloudflare.com"
        }
    },
    {
        "regex": "CloudFlare-AlwaysOnline",
        "name": "CloudFlare Always Online",
        "category": "Site Monitor",
        "url": "http://www.cloudflare.com/always-online",
        "producer": {
            "name": "CloudFlare",
            "url": "http://www.cloudflare.com"
        }
    },
    {
        "regex": "coccoc.com",
        "name": "Cốc Cốc Bot",
        "url": "https://help.coccoc.com/en/search-engine/coccoc-robots",
        "category": "Search bot",
        "producer": {
            "name": "Cốc Cốc",
            "url": "https://coccoc.com/"
        }
    },
    {
        "regex": "collectd",
        "name": "Collectd",
        "url": "https://collectd.org/",
        "category": "Site Monitor",
        "producer": {
            "name": "Collectd",
            "url": "https://collectd.org/"
        }
    },
    {
        "regex": "CommaFeed",
        "name": "CommaFeed",
        "url": "http://www.commafeed.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "CSS Certificate Spider",
        "name": "CSS Certificate Spider",
        "category": "Crawler",
        "url": "http://www.css-security.com/certificatespider/",
        "producer": {
            "name": "Certified Security Solutions",
            "url": "https://www.css-security.com/company/about-us/"
        }
    },
    {
        "regex": "Datadog Agent",
        "name": "Datadog Agent",
        "url": "https://github.com/DataDog/dd-agent",
        "category": "Site Monitor",
        "producer": {
            "name": "Datadog",
            "url": "https://www.datadoghq.com/"
        }
    },
    {
        "regex": "Datanyze",
        "name": "Datanyze",
        "url": "",
        "category": "Crawler",
        "producer": {
            "name": "Datanyze",
            "url": "https://www.datanyze.com"
        }
    },
    {
        "regex": "Dataprovider",
        "name": "Dataprovider",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Dataprovider B.V.",
            "url": "https://www.dataprovider.com/"
        }
    },
    {
        "regex": "Daum(oa)?[ /][0-9]",
        "name": "Daum",
        "category": "Search bot",
        "url": "http://tab.search.daum.net/aboutWebSearch_en.html",
        "producer": {
            "name": "Daum Communications Corp.",
            "url": "http://www.kakaocorp.com/main"
        }
    },
    {
        "regex": "Dazoobot",
        "name": "Dazoobot",
        "category": "Search bot",
        "url": "",
        "producer": {
            "name": "DAZOO.FR",
            "url": "http://dazoo.fr"
        }
    },
    {
        "regex": "discobot(-news)?",
        "name": "Discobot",
        "category": "Search bot",
        "url": "http://discoveryengine.com/discobot.html",
        "producer": {
            "name": "Discovery Engine",
            "url": "http://discoveryengine.com"
        }
    },
    {
        "regex": "Domain Re-Animator Bot|support@domainreanimator.com",
        "name": "Domain Re-Animator Bot",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Domain Re-Animator, LLC",
            "url": "http://domainreanimator.com"
        }
    },
    {
        "regex": "DotBot",
        "name": "DotBot",
        "category": "Crawler",
        "url": "http://www.opensiteexplorer.org/dotbot",
        "producer": {
            "name": "SEOmoz, Inc.",
            "url": "http://moz.com/"
        }
    },
    {
        "regex": "DuckDuck(?:Go-Favicons-)?Bot",
        "name": "DuckDuckGo Bot",
        "category": "Search bot",
        "url": "https://duckduckgo.com/duckduckbot",
        "producer": {
            "name": "DuckDuckGo",
            "url": "https://duckduckgo.com/"
        }
    },
    {
        "regex": "EasouSpider",
        "name": "Easou Spider",
        "category": "Search bot",
        "url": "http://www.easou.com/search/spider.html",
        "producer": {
            "name": "easou ICP",
            "url": "http://www.easou.com"
        }
    },
    {
        "regex": "eCairn-Grabber",
        "name": "eCairn-Grabber",
        "category": "Crawler",
        "producer": {
            "name": "eCairn",
            "url": "https://ecairn.com"
        }
    },
    {
        "regex": "EMail Exractor",
        "name": "EMail Exractor",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "evc-batch",
        "name": "evc-batch",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "eVenture Capital Partners II, LLC",
            "url": "http://www.eventures.vc/"
        }
    },
    {
        "regex": "Exabot(-Thumbnails|-Images)?|ExaleadCloudview",
        "name": "ExaBot",
        "category": "Crawler",
        "url": "http://www.exabot.com/go/robot",
        "producer": {
            "name": "Dassault Systèmes",
            "url": "http://www.3ds.com"
        }
    },
    {
        "regex": "ExactSeek Crawler",
        "name": "ExactSeek Crawler",
        "category": "Search bot",
        "url": "http://www.exactseek.com",
        "producer": {
            "name": "Jayde Online, Inc.",
            "url": "http://www.jaydeonlineinc.com"
        }
    },
    {
        "regex": "Ezooms",
        "name": "Ezooms",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "SEOmoz, Inc.",
            "url": "http://moz.com/"
        }
    },
    {
        "regex": "facebookexternalhit|facebookplatform|facebookexternalua",
        "name": "Facebook External Hit",
        "category": "Social Media Agent",
        "url": "https://www.facebook.com/externalhit_uatext.php",
        "producer": {
            "name": "Facebook",
            "url": "http://www.facebook.com"
        }
    },
    {
        "regex": "Feedbin",
        "name": "Feedbin",
        "url": "http://feedbin.com/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "FeedBurner",
        "name": "FeedBurner",
        "url": "http://www.feedburner.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Feed Wrangler",
        "name": "Feed Wrangler",
        "url": "https://feedwrangler.net/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "David Smith & Developing Perspective, LLC",
            "url": "https://david-smith.org"
        }
    },
    {
        "regex": "(Meta)?Feedly(Bot|App)?",
        "name": "Feedly",
        "url": "http://www.feedly.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Feedspot",
        "name": "Feedspot",
        "url": "http://www.feedspot.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Fever/[0-9]",
        "name": "Fever",
        "url": "http://feedafever.com/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "FlipboardProxy|FlipboardRSS",
        "name": "Flipboard",
        "url": "http://flipboard.com/browserproxy",
        "category": "Feed Fetcher",
        "producer": {
            "name": "Flipboard",
            "url": "http://flipboard.com/"
        }
    },
    {
        "regex": "Findxbot",
        "name": "Findxbot",
        "category": "Crawler",
        "url": "http://www.findxbot.com"
    },
    {
        "regex": "FreshRSS",
        "name": "FreshRSS",
        "category": "Feed Fetcher",
        "url": "https://freshrss.org/"
    },
    {
        "regex": "Genieo",
        "name": "Genieo Web filter",
        "category": "",
        "url": "http://www.genieo.com/webfilter.html",
        "producer": {
            "name": "Genieo",
            "url": "http://www.genieo.com"
        }
    },
    {
        "regex": "GigablastOpenSource",
        "name": "Gigablast",
        "category": "Search bot",
        "url": "https://github.com/gigablast/open-source-search-engine",
        "producer": {
            "name": "Matt Wells",
            "url": "http://www.gigablast.com/faq.html"
        }
    },
    {
        "regex": "Gluten Free Crawler",
        "name": "Gluten Free Crawler",
        "category": "Crawler",
        "url": "http://glutenfreepleasure.com/",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "ichiro/mobile goo",
        "name": "Goo",
        "category": "Search bot",
        "url": "http://search.goo.ne.jp/option/use/sub4/sub4-1",
        "producer": {
            "name": "NTT Resonant",
            "url": "http://goo.ne.jp"
        }
    },
    {
        "regex": "Google Favicon",
        "name": "Google Favicon",
        "category": "Crawler"
    },
    {
        "regex": "Google Search Console",
        "name": "Google Search Console",
        "category": "Crawler",
        "url": "https://search.google.com/search-console/about",
        "producer": {
            "name": "Google Inc.",
            "url": "http://www.google.com"
        }
    },
    {
        "regex": "Google Page Speed Insights",
        "name": "Google PageSpeed Insights",
        "category": "Site Monitor",
        "url": "http://developers.google.com/speed/pagespeed/insights/",
        "producer": {
            "name": "Google Inc.",
            "url": "http://www.google.com"
        }
    },
    {
        "regex": "google_partner_monitoring",
        "name": "Google Partner Monitoring",
        "category": "Site Monitor",
        "url": "",
        "producer": {
            "name": "Google Inc.",
            "url": "http://www.google.com"
        }
    },
    {
        "regex": "Google-Cloud-Scheduler",
        "name": "Google Cloud Scheduler",
        "category": "Crawler",
        "url": "https://cloud.google.com/scheduler",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com"
        }
    },
    {
        "regex": "Google-Structured-Data-Testing-Tool",
        "name": "Google Structured Data Testing Tool",
        "category": "Validator",
        "url": "https://search.google.com/structured-data/testing-tool",
        "producer": {
            "name": "Google Inc.",
            "url": "http://www.google.com"
        }
    },
    {
        "regex": "GoogleStackdriverMonitoring",
        "name": "Google Stackdriver Monitoring",
        "category": "Site Monitor",
        "url": "https://cloud.google.com/monitoring",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com"
        }
    },
    {
        "regex": "via ggpht\\.com GoogleImageProxy",
        "name": "Gmail Image Proxy",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Google Inc.",
            "url": "http://www.google.com"
        }
    },
    {
        "regex": "SeznamEmailProxy",
        "name": "Seznam Email Proxy",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Seznam.cz, a.s.",
            "url": "http://www.seznam.cz/"
        }
    },
    {
        "regex": "Seznam-Zbozi-robot",
        "name": "Seznam Zbozi.cz",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Seznam.cz, a.s.",
            "url": "https://www.zbozi.cz/"
        }
    },
    {
        "regex": "Heurekabot-Feed",
        "name": "Heureka Feed",
        "category": "Crawler",
        "url": "https://sluzby.heureka.cz/napoveda/heurekabot/",
        "producer": {
            "name": "Heureka.cz, a.s.",
            "url": "https://www.heureka.cz/"
        }
    },
    {
        "regex": "ShopAlike",
        "name": "ShopAlike",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Visual Meta",
            "url": "https://www.shopalike.cz/"
        }
    },
    {
        "regex": "AdsBot-Google(-Mobile)?|Adwords-(DisplayAds|Express|Instant)|Google Web Preview|Google[ -]Publisher[ -]Plugin|Google-(Ads-Qualify|Adwords|AMPHTML|Assess|HotelAdsVerifier|Read-Aloud|Shopping-Quality|Site-Verification|speakr|Test|Youtube-Links)|(APIs|DuplexWeb|Feedfetcher|Mediapartners)-Google|Googlebot(-Mobile|-Image|-Video|-News)?|GoogleProducer|Google.*/\\+/web/snippet",
        "name": "Googlebot",
        "category": "Search bot",
        "url": "http://www.google.com/bot.html",
        "producer": {
            "name": "Google Inc.",
            "url": "http://www.google.com"
        }
    },
    {
        "regex": "heritrix",
        "name": "Heritrix",
        "category": "Crawler",
        "url": "https://webarchive.jira.com/wiki/display/Heritrix/Heritrix",
        "producer": {
            "name": "The Internet Archive",
            "url": "https://archive.org"
        }
    },
    {
        "regex": "HubSpot ",
        "name": "HubSpot",
        "category": "Crawler",
        "producer": {
            "name": "HubSpot Inc.",
            "url": "https://www.hubspot.com"
        }
    },
    {
        "regex": "HTTPMon",
        "name": "HTTPMon",
        "category": "Site Monitor",
        "url": "http://www.httpmon.com",
        "producer": {
            "name": "towards GmbH",
            "url": "http://www.towards.ch/"
        }
    },
    {
        "regex": "ICC-Crawler",
        "name": "ICC-Crawler",
        "category": "Crawler",
        "url": "http://www.nict.go.jp/en/univ-com/plan/crawl.html",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "inoreader.com",
        "name": "inoreader",
        "category": "Feed Reader",
        "url": "https://www.inoreader.com"
    },
    {
        "regex": "iisbot",
        "name": "IIS Site Analysis",
        "category": "Crawler",
        "url": "http://www.iis.net/iisbot.html",
        "producer": {
            "name": "Microsoft Corporation",
            "url": "http://www.microsoft.com"
        }
    },
    {
        "regex": "ips-agent",
        "name": "IPS Agent",
        "category": "Crawler",
        "producer": {
            "name": "VeriSign, Inc",
            "url": "http://www.verisign.com/"
        }
    },
    {
        "regex": "IP-Guide\\.com",
        "name": "IP-Guide Crawler",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "",
            "url": "https://ip-guide.com"
        }
    },
    {
        "regex": "kouio",
        "name": "Kouio",
        "url": "http://kouio.com/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "larbin",
        "name": "Larbin web crawler",
        "category": "Crawler",
        "url": "http://larbin.sourceforge.net",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "([A-z0-9]*)-Lighthouse",
        "name": "Lighthouse",
        "category": "Site Monitor",
        "url": "https://developers.google.com/web/tools/lighthouse",
        "producer": {
            "name": "Lighthouse",
            "url": "https://developers.google.com/web/tools/lighthouse"
        }
    },
    {
        "regex": "linkdexbot(-mobile)?|linkdex\\.com",
        "name": "Linkdex Bot",
        "category": "Search bot",
        "url": "http://www.linkdex.com/bots",
        "producer": {
            "name": "Mojeek Ltd.",
            "url": "http://www.mojeek.com"
        }
    },
    {
        "regex": "LinkedInBot",
        "name": "LinkedIn Bot",
        "category": "Social Media Agent",
        "url": "http://www.linkedin.com",
        "producer": {
            "name": "LinkedIn",
            "url": "http://www.linkedin.com"
        }
    },
    {
        "regex": "ltx71",
        "name": "LTX71",
        "url": "http://ltx71.com/",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Mail\\.RU(_Bot)?",
        "name": "Mail.Ru Bot",
        "category": "Search bot",
        "url": "http://help.mail.ru/webmaster/indexing/robots/types_robots",
        "producer": {
            "name": "Mail.Ru Group",
            "url": "http://corp.mail.ru"
        }
    },
    {
        "regex": "magpie-crawler",
        "name": "Magpie-Crawler",
        "category": "Social Media Agent",
        "url": "http://www.brandwatch.com/magpie-crawler/",
        "producer": {
            "name": "Brandwatch",
            "url": "http://www.brandwatch.com"
        }
    },
    {
        "regex": "MagpieRSS",
        "name": "MagpieRSS",
        "url": "http://magpierss.sourceforge.net/",
        "category": "Feed Parser",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "masscan",
        "name": "masscan",
        "url": "https://github.com/robertdavidgraham/masscan",
        "category": "Crawler",
        "producer": {
            "name": "Robert Graham",
            "url": "https://github.com/robertdavidgraham"
        }
    },
    {
        "regex": "Mastodon/",
        "name": "Mastodon Bot",
        "category": "Social Media Agent"
    },
    {
        "regex": "meanpathbot",
        "name": "Meanpath Bot",
        "category": "Search bot",
        "url": "http://www.meanpath.com/meanpathbot.html",
        "producer": {
            "name": "Meanpath",
            "url": "http://www.meanpath.com"
        }
    },
    {
        "regex": "MetaJobBot",
        "name": "MetaJobBot",
        "category": "Crawler",
        "url": "http://www.metajob.at/the/crawler",
        "producer": {
            "name": "MetaJob",
            "url": "http://www.metajob.at"
        }
    },
    {
        "regex": "MetaInspector",
        "name": "MetaInspector",
        "category": "Crawler",
        "url": "https://github.com/jaimeiniesta/metainspector"
    },
    {
        "regex": "MixrankBot",
        "name": "Mixrank Bot",
        "category": "Crawler",
        "url": "http://mixrank.com",
        "producer": {
            "name": "Online Media Group, Inc.",
            "url": ""
        }
    },
    {
        "regex": "MJ12bot",
        "name": "MJ12 Bot",
        "category": "Search bot",
        "url": "http://majestic12.co.uk/bot.php",
        "producer": {
            "name": "Majestic-12",
            "url": "http://majestic12.co.uk"
        }
    },
    {
        "regex": "Mnogosearch",
        "name": "Mnogosearch",
        "category": "Search bot",
        "url": "http://www.mnogosearch.org/",
        "producer": {
            "name": "Lavtech.Com Corp.",
            "url": ""
        }
    },
    {
        "regex": "MojeekBot",
        "name": "MojeekBot",
        "category": "Search bot",
        "url": "http://www.mojeek.com/bot.html",
        "producer": {
            "name": "Mojeek Ltd.",
            "url": "http://www.mojeek.com"
        }
    },
    {
        "regex": "munin",
        "name": "Munin",
        "category": "Site Monitor",
        "url": "http://munin-monitoring.org/",
        "producer": {
            "name": "Munin",
            "url": "http://munin-monitoring.org/"
        }
    },
    {
        "regex": "NalezenCzBot",
        "name": "NalezenCzBot",
        "category": "Crawler",
        "url": "http://www.nalezen.cz/about-crawler",
        "producer": {
            "name": "Jaroslav Kuboš",
            "url": ""
        }
    },
    {
        "regex": "check_http/v",
        "name": "Nagios check_http",
        "category": "Site Monitor",
        "url": "https://nagios.org",
        "producer": {
            "name": "Nagios Plugins Development Team",
            "url": "https://nagios.org"
        }
    },
    {
        "regex": "nbertaupete95\\(at\\)gmail.com",
        "name": "nbertaupete95",
        "category": "Crawler"
    },
    {
        "regex": "Netcraft( Web Server Survey| SSL Server Survey|SurveyAgent)",
        "name": "Netcraft Survey Bot",
        "category": "Search bot",
        "url": "",
        "producer": {
            "name": "Netcraft",
            "url": "http://www.netcraft.com"
        }
    },
    {
        "regex": "netEstate NE Crawler",
        "name": "netEstate",
        "category": "Crawler",
        "url": "http://www.website-datenbank.de/Impressum",
        "producer": {
            "name": "netEstate GmbH",
            "url": "https://www.netestate.de/en/"
        }
    },
    {
        "regex": "Netvibes",
        "name": "Netvibes",
        "url": "http://www.netvibes.com/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "NewsBlur .*(Fetcher|Finder)",
        "name": "NewsBlur",
        "url": "http://www.newsblur.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "NewsGatorOnline",
        "name": "NewsGator",
        "url": "http://www.newsgator.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "nlcrawler",
        "name": "NLCrawler",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Northern Light",
            "url": "http://northernlight.com"
        }
    },
    {
        "regex": "Nmap Scripting Engine",
        "name": "Nmap",
        "category": "Security Checker",
        "url": "https://nmap.org/book/nse.html",
        "producer": {
            "name": "Nmap",
            "url": "https://nmap.org/"
        }
    },
    {
        "regex": "Nuzzel",
        "name": "Nuzzel",
        "category": "Crawler",
        "producer": {
            "name": "Nuzzel",
            "url": "https://www.nuzzel.com/"
        }
    },
    {
        "regex": "Octopus [0-9]",
        "name": "Octopus"
    },
    {
        "regex": "omgili(?:bot)?",
        "name": "Omgili bot",
        "category": "Search bot",
        "url": "http://www.omgili.com/Crawler.html",
        "producer": {
            "name": "Omgili",
            "url": "http://www.omgili.com"
        }
    },
    {
        "regex": "OpenindexSpider",
        "name": "Openindex Spider",
        "category": "Search bot",
        "url": "http://www.openindex.io/en/webmasters/spider.html",
        "producer": {
            "name": "Openindex B.V.",
            "url": "http://www.openindex.io"
        }
    },
    {
        "regex": "spbot",
        "name": "OpenLinkProfiler",
        "category": "Crawler",
        "url": "http://openlinkprofiler.org/bot",
        "producer": {
            "name": "Axandra GmbH",
            "url": "http://www.axandra.com"
        }
    },
    {
        "regex": "OpenWebSpider",
        "name": "OpenWebSpider",
        "category": "Crawler",
        "url": "http://www.openwebspider.org",
        "producer": {
            "name": "OpenWebSpider Lab",
            "url": "http://lab.openwebspider.org"
        }
    },
    {
        "regex": "OrangeBot|VoilaBot",
        "name": "Orange Bot",
        "category": "Search bot",
        "url": "http://lemoteur.orange.fr",
        "producer": {
            "name": "Orange",
            "url": "http://www.orange.fr"
        }
    },
    {
        "regex": "PaperLiBot",
        "name": "PaperLiBot",
        "category": "Search bot",
        "url": "http://support.paper.li/entries/20023257-what-is-paper-li",
        "producer": {
            "name": "Smallrivers SA",
            "url": "http://www.paper.li"
        }
    },
    {
        "regex": "phantomas/",
        "name": "Phantomas",
        "category": "Site Monitor",
        "url": "https://github.com/macbre/phantomas"
    },
    {
        "regex": "phpservermon",
        "name": "PHP Server Monitor",
        "category": "Site Monitor",
        "url": "https://github.com/phpservermon/phpservermon",
        "producer": {
            "name": "PHP Server Monitor",
            "url": "http://www.phpservermonitor.org/"
        }
    },
    {
        "regex": "PocketParser",
        "name": "PocketParser",
        "category": "Read-it-later Service",
        "url": "https://getpocket.com/pocketparser_ua",
        "producer": {
            "name": "Pocket",
            "url": "https://getpocket.com/"
        }
    },
    {
        "regex": "PritTorrent",
        "name": "PritTorrent",
        "category": "Crawler",
        "url": "https://github.com/astro/prittorrent",
        "producer": {
            "name": "Bitlove",
            "url": "http://bitlove.org/"
        }
    },
    {
        "regex": "PRTG Network Monitor",
        "name": "PRTG Network Monitor",
        "category": "Network Monitor",
        "url": "https://www.paessler.com/prtg",
        "producer": {
            "name": "Paessler AG",
            "url": "https://www.paessler.com"
        }
    },
    {
        "regex": "psbot(-page)?",
        "name": "Picsearch bot",
        "category": "Search bot",
        "url": "http://www.picsearch.com/bot.html",
        "producer": {
            "name": "Picsearch",
            "url": "http://www.picsearch.com"
        }
    },
    {
        "regex": "Pingdom(?:\\.com|TMS)",
        "name": "Pingdom Bot",
        "category": "Site Monitor",
        "url": "",
        "producer": {
            "name": "Pingdom AB",
            "url": "https://www.pingdom.com"
        }
    },
    {
        "regex": "Quora Link Preview",
        "name": "Quora Link Preview",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Quora",
            "url": "http://www.quora.com"
        }
    },
    {
        "regex": "Quora-Bot",
        "name": "Quora Bot",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Quora",
            "url": "https://www.quora.com/"
        }
    },
    {
        "regex": "RamblerMail",
        "name": "RamblerMail Image Proxy",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Rambler&Co",
            "url": "https://rambler-co.ru/"
        }
    },
    {
        "regex": "QuerySeekerSpider",
        "name": "QuerySeekerSpider",
        "category": "Crawler",
        "url": "http://queryseeker.com/bot.html",
        "producer": {
            "name": "QueryEye Inc.",
            "url": "http://queryeye.com"
        }
    },
    {
        "regex": "Qwantify",
        "name": "Qwantify",
        "category": "Crawler",
        "url": "https://www.qwant.com/",
        "producer": {
            "name": "Qwant Corporation",
            "url": "https://www.qwant.com/"
        }
    },
    {
        "regex": "Rainmeter",
        "name": "Rainmeter",
        "category": "Crawler",
        "url": "https://www.rainmeter.net"
    },
    {
        "regex": "redditbot",
        "name": "Reddit Bot",
        "category": "Social Media Agent",
        "url": "http://www.reddit.com/feedback",
        "producer": {
            "name": "reddit inc.",
            "url": "http://www.reddit.com"
        }
    },
    {
        "regex": "Riddler",
        "name": "Riddler",
        "category": "Security search bot",
        "url": "https://riddler.io/about",
        "producer": {
            "name": "F-Secure",
            "url": "https://www.f-secure.com"
        }
    },
    {
        "regex": "rogerbot",
        "name": "Rogerbot",
        "category": "Crawler",
        "url": "http://moz.com/help/pro/what-is-rogerbot-",
        "producer": {
            "name": "SEOmoz, Inc.",
            "url": "http://moz.com/"
        }
    },
    {
        "regex": "ROI Hunter",
        "name": "ROI Hunter",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Roihunter a.s.",
            "url": "http://roihunter.com/"
        }
    },
    {
        "regex": "SafeDNSBot",
        "name": "SafeDNSBot",
        "category": "Crawler",
        "url": "https://www.safedns.com/searchbot",
        "producer": {
            "name": "SafeDNS, Inc.",
            "url": "https://www.safedns.com/"
        }
    },
    {
        "regex": "Scrapy",
        "name": "Scrapy",
        "category": "Crawler",
        "url": "http://scrapy.org"
    },
    {
        "regex": "Screaming Frog SEO Spider",
        "name": "Screaming Frog SEO Spider",
        "category": "Crawler",
        "url": "http://www.screamingfrog.co.uk/seo-spider",
        "producer": {
            "name": "Screaming Frog Ltd",
            "url": "http://www.screamingfrog.co.uk"
        }
    },
    {
        "regex": "ScreenerBot",
        "name": "ScreenerBot",
        "category": "Crawler",
        "url": "http://www.screenerbot.com",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "SemrushBot",
        "name": "Semrush Bot",
        "category": "Crawler",
        "url": "http://www.semrush.com/bot.html",
        "producer": {
            "name": "SEMrush",
            "url": "http://www.semrush.com"
        }
    },
    {
        "regex": "SensikaBot",
        "name": "Sensika Bot",
        "category": "",
        "url": "",
        "producer": {
            "name": "Sensika",
            "url": "http://sensika.com"
        }
    },
    {
        "regex": "SEOENG(World)?Bot",
        "name": "SEOENGBot",
        "category": "Crawler",
        "url": "http://www.seoengine.com/seoengbot.htm",
        "producer": {
            "name": "SEO Engine",
            "url": "http://www.seoengine.com"
        }
    },
    {
        "regex": "SEOkicks-Robot",
        "name": "SEOkicks-Robot",
        "category": "Crawler",
        "url": "http://www.seokicks.de/robot.html",
        "producer": {
            "name": "SEOkicks",
            "url": "https://www.seokicks.de/"
        }
    },
    {
        "regex": "seoscanners\\.net",
        "name": "Seoscanners.net",
        "category": "Crawler",
        "url": ""
    },
    {
        "regex": "SkypeUriPreview",
        "name": "Skype URI Preview",
        "category": "Service Agent",
        "url": "",
        "producer": {
            "name": "Skype Communications S.à.r.l.",
            "url": "https://www.skype.com"
        }
    },
    {
        "regex": "SeznamBot|SklikBot|Seznam screenshot-generator",
        "name": "Seznam Bot",
        "category": "Search bot",
        "url": "http://www.mapy.cz/cz/seznambot.html",
        "producer": {
            "name": "Seznam.cz, a.s.",
            "url": "http://www.seznam.cz/"
        }
    },
    {
        "regex": "shopify-partner-homepage-scraper",
        "name": "Shopify Partner",
        "category": "Crawler",
        "url": "https://www.shopify.com/partners",
        "producer": {
            "name": "Shopify",
            "url": "https://www.shopify.com/"
        }
    },
    {
        "regex": "ShopWiki",
        "name": "ShopWiki",
        "category": "Search tools",
        "url": "http://www.shopwiki.com/wiki/Help:Bot",
        "producer": {
            "name": "ShopWiki Corp.",
            "url": "http://www.shopwiki.com"
        }
    },
    {
        "regex": "SilverReader",
        "name": "SilverReader",
        "url": "http://silverreader.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "SimplePie",
        "name": "SimplePie",
        "url": "http://www.simplepie.org",
        "category": "Feed Parser",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "SISTRIX Crawler",
        "name": "SISTRIX Crawler",
        "category": "Crawler",
        "url": "http://crawler.sistrix.net",
        "producer": {
            "name": "SISTRIX GmbH",
            "url": "http://www.sistrix.de"
        }
    },
    {
        "regex": "compatible; (?:SISTRIX )?Optimizer",
        "name": "SISTRIX Optimizer",
        "category": "Crawler",
        "url": "https://optimizer.sistrix.com",
        "producer": {
            "name": "SISTRIX GmbH",
            "url": "http://www.sistrix.de"
        }
    },
    {
        "regex": "SiteSucker",
        "name": "SiteSucker",
        "category": "Crawler",
        "url": "http://ricks-apps.com/osx/sitesucker/"
    },
    {
        "regex": "sixy.ch",
        "name": "Sixy.ch",
        "category": "Site Monitor",
        "url": "http://sixy.ch",
        "producer": {
            "name": "Manuel Kasper",
            "url": "https://neon1.net/"
        }
    },
    {
        "regex": "Slackbot|Slack-ImgProxy",
        "name": "Slackbot",
        "category": "Crawler",
        "url": "https://api.slack.com/robots",
        "producer": {
            "name": "Slack Technologies",
            "url": "http://slack.com"
        }
    },
    {
        "regex": "(Sogou (web|inst|Pic) spider)|New-Sogou-Spider",
        "name": "Sogou Spider",
        "category": "Search bot",
        "url": "http://www.sogou.com/docs/help/webmasters.htm",
        "producer": {
            "name": "Sohu, Inc.",
            "url": "http://www.sogou.com"
        }
    },
    {
        "regex": "Sosospider|Sosoimagespider",
        "name": "Soso Spider",
        "category": "Search bot",
        "url": "http://help.soso.com/webspider.htm",
        "producer": {
            "name": "Tencent Holdings",
            "url": "http://www.soso.com"
        }
    },
    {
        "regex": "Sprinklr",
        "name": "Sprinklr",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Sprinklr, Inc.",
            "url": "https://www.sprinklr.com/"
        }
    },
    {
        "regex": "sqlmap/",
        "name": "sqlmap",
        "category": "Security Checker",
        "url": "http://sqlmap.org/",
        "producer": {
            "name": "sqlmap",
            "url": "http://sqlmap.org/"
        }
    },
    {
        "regex": "SSL Labs",
        "name": "SSL Labs",
        "category": "Validator",
        "url": "https://www.ssllabs.com/about/assessment.html",
        "producer": {
            "name": "SSL Labs",
            "url": "https://www.ssllabs.com/about/assessment.html"
        }
    },
    {
        "regex": "StatusCake",
        "name": "StatusCake",
        "category": "Site Monitor",
        "url": "https://www.statuscake.com",
        "producer": {
            "name": "StatusCake",
            "url": "https://www.statuscake.com"
        }
    },
    {
        "regex": "Superfeedr bot",
        "name": "Superfeedr Bot",
        "category": "Feed Fetcher",
        "url": "",
        "producer": {
            "name": "Superfeedr",
            "url": "https://superfeedr.com/"
        }
    },
    {
        "regex": "Sparkler/[0-9]",
        "name": "Sparkler",
        "category": "Crawler",
        "url": "https://github.com/USCDataScience/sparkler"
    },
    {
        "regex": "Spinn3r",
        "name": "Spinn3r",
        "category": "Crawler",
        "url": "http://spinn3r.com/robot",
        "producer": {
            "name": "Tailrank Inc",
            "url": "http://spinn3r.com"
        }
    },
    {
        "regex": "SputnikBot",
        "name": "Sputnik Bot",
        "category": "Crawler",
        "url": ""
    },
    {
        "regex": "SputnikFaviconBot",
        "name": "Sputnik Favicon Bot",
        "category": "Crawler",
        "url": ""
    },
    {
        "regex": "SputnikImageBot",
        "name": "Sputnik Image Bot",
        "category": "Crawler",
        "url": ""
    },
    {
        "regex": "SurveyBot",
        "name": "Survey Bot",
        "category": "Search bot",
        "url": "http://www.domaintools.com/webmasters/surveybot.php",
        "producer": {
            "name": "Domain Tools",
            "url": "http://www.domaintools.com"
        }
    },
    {
        "regex": "TarmotGezgin",
        "name": "Tarmot Gezgin",
        "url": "http://www.tarmot.com/gezgin/",
        "category": "Search bot"
    },
    {
        "regex": "TelegramBot",
        "name": "TelegramBot",
        "url": "https://telegram.org/blog/bot-revolution"
    },
    {
        "regex": "TLSProbe",
        "name": "TLSProbe",
        "url": "https://scan.trustnet.venafi.com/",
        "category": "Security search bot",
        "producer": {
            "name": "Venafi TrustNet",
            "url": "https://www.venafi.com"
        }
    },
    {
        "regex": "TinEye-bot",
        "name": "TinEye Crawler",
        "category": "Search bot",
        "url": "http://www.tineye.com/crawler.html",
        "producer": {
            "name": "Idée Inc.",
            "url": "http://ideeinc.com"
        }
    },
    {
        "regex": "Tiny Tiny RSS",
        "name": "Tiny Tiny RSS",
        "url": "http://tt-rss.org",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "theoldreader.com",
        "name": "theoldreader",
        "category": "Feed Reader",
        "url": "https://theoldreader.com"
    },
    {
        "regex": "trendictionbot",
        "name": "Trendiction Bot",
        "category": "Crawler",
        "url": "http://www.trendiction.de/bot",
        "producer": {
            "name": "Talkwalker Inc.",
            "url": "http://www.talkwalker.com"
        }
    },
    {
        "regex": "TurnitinBot",
        "name": "TurnitinBot",
        "category": "Crawler",
        "url": "http://www.turnitin.com/robot/crawlerinfo.html",
        "producer": {
            "name": "iParadigms, LLC.",
            "url": "http://www.turnitin.com"
        }
    },
    {
        "regex": "TweetedTimes Bot",
        "name": "TweetedTimes Bot",
        "category": "Crawler",
        "url": "http://tweetedtimes.com",
        "producer": {
            "name": "TweetedTimes",
            "url": "http://tweetedtimes.com/"
        }
    },
    {
        "regex": "TweetmemeBot",
        "name": "Tweetmeme Bot",
        "category": "Crawler",
        "url": "http://tweetmeme.com/",
        "producer": {
            "name": "Mediasift",
            "url": ""
        }
    },
    {
        "regex": "Twingly Recon",
        "name": "Twingly Recon",
        "category": "Crawler",
        "producer": {
            "name": "Twingly",
            "url": "https://www.twingly.com"
        }
    },
    {
        "regex": "Twitterbot",
        "name": "Twitterbot",
        "category": "Social Media Agent",
        "url": "https://dev.twitter.com/docs/cards/getting-started",
        "producer": {
            "name": "Twitter",
            "url": "http://www.twitter.com"
        }
    },
    {
        "regex": "UniversalFeedParser",
        "name": "UniversalFeedParser",
        "category": "Feed Fetcher",
        "url": "https://github.com/kurtmckee/feedparser",
        "producer": {
            "name": "Kurt McKee",
            "url": "https://github.com/kurtmckee"
        }
    },
    {
        "regex": "via secureurl\\.fwdcdn\\.com",
        "name": "UkrNet Mail Proxy",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "UkrNet Ltd",
            "url": "https://www.ukr.net/"
        }
    },
    {
        "regex": "Uptimebot",
        "name": "Uptimebot",
        "category": "Site Monitor",
        "url": "https://uptime.com/uptimebot",
        "producer": {
            "name": "Uptime",
            "url": "https://uptime.com"
        }
    },
    {
        "regex": "UptimeRobot",
        "name": "Uptime Robot",
        "category": "Site Monitor",
        "url": "",
        "producer": {
            "name": "Uptime Robot",
            "url": "http://uptimerobot.com"
        }
    },
    {
        "regex": "URLAppendBot",
        "name": "URLAppendBot",
        "category": "Crawler",
        "url": "http://www.profound.net/urlappendbot.html",
        "producer": {
            "name": "Profound Networks",
            "url": "http://www.profound.net"
        }
    },
    {
        "regex": "Vagabondo",
        "name": "Vagabondo",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "WiseGuys",
            "url": "http://www.wise-guys.nl/"
        }
    },
    {
        "regex": "vkShare; ",
        "name": "VK Share Button",
        "category": "Crawler",
        "url": "http://vk.com/dev/Share",
        "producer": {
            "name": "VK",
            "url": "http://vk.com/"
        }
    },
    {
        "regex": "VSMCrawler",
        "name": "Visual Site Mapper Crawler",
        "category": "Crawler",
        "url": "http://www.visualsitemapper.com/crawler",
        "producer": {
            "name": "Alentum Software Ltd.",
            "url": "http://www.alentum.com"
        }
    },
    {
        "regex": "Jigsaw",
        "name": "W3C CSS Validator",
        "category": "Validator",
        "url": "http://jigsaw.w3.org/css-validator",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "W3C_I18n-Checker",
        "name": "W3C I18N Checker",
        "category": "Validator",
        "url": "http://validator.w3.org/i18n-checker",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "W3C-checklink",
        "name": "W3C Link Checker",
        "category": "Validator",
        "url": "http://validator.w3.org/checklink",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "W3C_Validator|Validator.nu",
        "name": "W3C Markup Validation Service",
        "category": "Validator",
        "url": "http://validator.w3.org/services",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "W3C-mobileOK",
        "name": "W3C MobileOK Checker",
        "category": "Validator",
        "url": "http://validator.w3.org/mobile",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "W3C_Unicorn",
        "name": "W3C Unified Validator",
        "category": "Validator",
        "url": "http://validator.w3.org/unicorn",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "Wappalyzer",
        "name": "Wappalyzer",
        "url": "https://github.com/AliasIO/Wappalyzer",
        "producer": {
            "name": "AliasIO",
            "url": "https://github.com/AliasIO"
        }
    },
    {
        "regex": "PTST/",
        "name": "WebPageTest",
        "category": "Site Monitor",
        "url": "https://www.webpagetest.org"
    },
    {
        "regex": "WeSEE(:Search)?",
        "name": "WeSEE:Search",
        "category": "Search bot",
        "url": "http://www.wesee.com/bot",
        "producer": {
            "name": "WeSEE Ltd",
            "url": "http://www.wesee.com"
        }
    },
    {
        "regex": "WebbCrawler",
        "name": "WebbCrawler",
        "category": "Crawler",
        "url": "http://badcheese.com/crawler.html",
        "producer": {
            "name": "Steve Webb",
            "url": "http://badcheese.com"
        }
    },
    {
        "regex": "websitepulse[+ ]checker",
        "name": "WebSitePulse",
        "category": "Site Monitor",
        "url": "http://badcheese.com/crawler.html",
        "producer": {
            "name": "WebSitePulse",
            "url": "http://www.websitepulse.com/"
        }
    },
    {
        "regex": "WordPress",
        "name": "WordPress",
        "category": "Service Agent",
        "url": "https://wordpress.org/",
        "producer": {
            "name": "Wordpress.org",
            "url": "https://wordpress.org/"
        }
    },
    {
        "regex": "Wotbox",
        "name": "Wotbox",
        "category": "Search bot",
        "url": "http://www.wotbox.com/bot/",
        "producer": {
            "name": "Wotbox",
            "url": "http://www.wotbox.com"
        }
    },
    {
        "regex": "XenForo",
        "name": "XenForo",
        "category": "Service Agent",
        "url": "https://xenforo.com/",
        "producer": {
            "name": "XenForo Ltd.",
            "url": "https://xenforo.com/"
        }
    },
    {
        "regex": "yacybot",
        "name": "YaCy",
        "category": "Search bot",
        "url": "http://yacy.net/bot.html",
        "producer": {
            "name": "YaCy",
            "url": "http://yacy.net"
        }
    },
    {
        "regex": "Yahoo! Slurp|Yahoo!-AdCrawler",
        "name": "Yahoo! Slurp",
        "category": "Search bot",
        "url": "http://help.yahoo.com/ysearch/slurp",
        "producer": {
            "name": "Yahoo! Inc.",
            "url": "http://www.yahoo.com"
        }
    },
    {
        "regex": "Yahoo Link Preview|Yahoo:LinkExpander:Slingstone",
        "name": "Yahoo! Link Preview",
        "category": "Crawler",
        "url": "https://help.yahoo.com/kb/mail/yahoo-link-preview-SLN23615.html",
        "producer": {
            "name": "Yahoo! Inc.",
            "url": "http://www.yahoo.com"
        }
    },
    {
        "regex": "YahooMailProxy",
        "name": "Yahoo! Mail Proxy",
        "category": "Service Agent",
        "url": "https://help.yahoo.com/kb/yahoo-mail-proxy-SLN28749.html",
        "producer": {
            "name": "Yahoo! Inc.",
            "url": "http://www.yahoo.com"
        }
    },
    {
        "regex": "YahooCacheSystem",
        "name": "Yahoo! Cache System",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Yahoo! Inc.",
            "url": "http://www.yahoo.com"
        }
    },
    {
        "regex": "Y!J-BRW",
        "name": "Yahoo! Japan BRW",
        "category": "Crawler",
        "url": "https://www.yahoo-help.jp/app/answers/detail/p/595/a_id/42716/~/ウェブページにアクセスするシステムのユーザーエージェントについて",
        "producer": {
            "name": "Yahoo! Japan Corp.",
            "url": "https://www.yahoo.co.jp/"
        }
    },
    {
        "regex": "Yandex(SpravBot|ScreenshotBot|MobileBot|AccessibilityBot|ForDomain|Vertis|Market|Catalog|Calendar|Sitelinks|AdNet|Pagechecker|Webmaster|Media|Video|Bot|Images|Antivirus|Direct|Blogs|Favicons|ImageResizer|Verticals|News(links)?|Metrika|\\.Gazeta Bot)|YaDirectFetcher|YandexTurbo|YandexTracker|YandexSearchShop|YandexRCA|YandexPartner|YandexOntoDBAPI|YandexOntoDB|YandexMobileScreenShotBot",
        "name": "Yandex Bot",
        "category": "Search bot",
        "url": "http://www.yandex.com/bots",
        "producer": {
            "name": "Yandex LLC",
            "url": "http://company.yandex.com"
        }
    },
    {
        "regex": "Yeti|NaverJapan",
        "name": "Yeti/Naverbot",
        "category": "Search bot",
        "url": "http://help.naver.com/robots/",
        "producer": {
            "name": "Naver",
            "url": "http://www.naver.com"
        }
    },
    {
        "regex": "YoudaoBot",
        "name": "Youdao Bot",
        "category": "Search bot",
        "url": "http://www.youdao.com/help/webmaster/spider",
        "producer": {
            "name": "NetEase, Inc.",
            "url": "http://corp.163.com"
        }
    },
    {
        "regex": "YOURLS v[0-9]",
        "name": "Yourls",
        "category": "Crawler",
        "url": "http://yourls.org"
    },
    {
        "regex": "YRSpider|YYSpider",
        "name": "Yunyun Bot",
        "category": "Search bot",
        "url": "http://www.yunyun.com/SiteInfo.php?r=about",
        "producer": {
            "name": "YunYun",
            "url": "http://www.yunyun.com"
        }
    },
    {
        "regex": "zgrab",
        "name": "zgrab",
        "category": "Security Checker",
        "url": "https://github.com/zmap/zgrab"
    },
    {
        "regex": "Zookabot",
        "name": "Zookabot",
        "category": "Crawler",
        "url": "http://zookabot.com",
        "producer": {
            "name": "Hwacha ApS",
            "url": "http://hwacha.dk"
        }
    },
    {
        "regex": "ZumBot",
        "name": "ZumBot",
        "category": "Search bot",
        "url": "http://help.zum.com/inquiry",
        "producer": {
            "name": "ZUM internet",
            "url": "http://www.zuminternet.com/"
        }
    },
    {
        "regex": "YottaaMonitor",
        "name": "Yottaa Site Monitor",
        "category": "Site Monitor",
        "url": "http://www.yottaa.com/products/site-monitor",
        "producer": {
            "name": "Yottaa",
            "url": "http://www.yottaa.com/"
        }
    },
    {
        "regex": "Yahoo Ad monitoring.*yahoo-ad-monitoring-SLN24857.*",
        "name": "Yahoo Gemini",
        "category": "Crawler",
        "url": "https://help.yahoo.com/kb/yahoo-ad-monitoring-SLN24857.html",
        "producer": {
            "name": "Yahoo! Inc.",
            "url": "http://www.yahoo.com"
        }
    },
    {
        "regex": ".*Java.*outbrain",
        "name": "Outbrain",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Outbrain",
            "url": "http://www.outbrain.com/"
        }
    },
    {
        "regex": "HubPages.*crawlingpolicy",
        "name": "HubPages",
        "category": "Crawler",
        "url": "http://hubpages.com/help/crawlingpolicy",
        "producer": {
            "name": "HubPages",
            "url": "http://hubpages.com/"
        }
    },
    {
        "regex": "Pinterest(bot)?/\\d\\.\\d.*www\\.pinterest\\.com.*",
        "name": "Pinterest",
        "url": "http://www.pinterest.com/bot.html",
        "category": "Crawler",
        "producer": {
            "name": "Pinterest",
            "url": "http://www.pinterest.com/"
        }
    },
    {
        "regex": "Site24x7",
        "name": "Site24x7 Website Monitoring",
        "category": "Site Monitor",
        "url": "https://www.site24x7.com/site24x7-faq.html",
        "producer": {
            "name": "Site24x7",
            "url": "https://www.site24x7.com"
        }
    },
    {
        "regex": "s~snapchat-proxy",
        "name": "Snapchat Proxy",
        "category": "Crawler",
        "url": "https://www.snapchat.com",
        "producer": {
            "name": "Snapchat Inc.",
            "url": "https://www.snapchat.com"
        }
    },
    {
        "regex": "Let's Encrypt validation server",
        "name": "Let's Encrypt Validation",
        "category": "Service Agent",
        "url": "https://letsencrypt.org/how-it-works/",
        "producer": {
            "name": "Let's Encrypt",
            "url": "https://letsencrypt.org"
        }
    },
    {
        "regex": "GrapeshotCrawler",
        "name": "Grapeshot",
        "category": "Crawler",
        "url": "https://www.grapeshot.com/crawler",
        "producer": {
            "name": "Grapeshot",
            "url": "https://www.grapeshot.com"
        }
    },
    {
        "regex": "www\\.monitor\\.us",
        "name": "Monitor.Us",
        "category": "Site Monitor",
        "url": "http://www.monitor.us",
        "producer": {
            "name": "Monitor.Us",
            "url": "http://www.monitor.us"
        }
    },
    {
        "regex": "Catchpoint( bot)?",
        "name": "Catchpoint",
        "category": "Site Monitor",
        "url": "",
        "producer": {
            "name": "Catchpoint Systems",
            "url": "http://www.catchpoint.com/"
        }
    },
    {
        "regex": "bitlybot",
        "name": "BitlyBot",
        "category": "Crawler",
        "url": "https://bitly.com",
        "producer": {
            "name": "Bitly, Inc.",
            "url": "https://bitly.com"
        }
    },
    {
        "regex": "Zao/",
        "name": "Zao",
        "category": "Crawler"
    },
    {
        "regex": "lycos",
        "name": "Lycos"
    },
    {
        "regex": "Slurp",
        "name": "Inktomi Slurp"
    },
    {
        "regex": "Speedy Spider",
        "name": "Speedy"
    },
    {
        "regex": "ScoutJet",
        "name": "ScoutJet"
    },
    {
        "regex": "nrsbot|netresearch",
        "name": "NetResearchServer"
    },
    {
        "regex": "scooter",
        "name": "Scooter"
    },
    {
        "regex": "gigabot",
        "name": "Gigabot"
    },
    {
        "regex": "charlotte",
        "name": "Charlotte"
    },
    {
        "regex": "Pompos",
        "name": "Pompos"
    },
    {
        "regex": "ichiro",
        "name": "ichiro"
    },
    {
        "regex": "PagePeeker",
        "name": "PagePeeker"
    },
    {
        "regex": "WebThumbnail",
        "name": "WebThumbnail"
    },
    {
        "regex": "Willow Internet Crawler",
        "name": "Willow Internet Crawler"
    },
    {
        "regex": "EmailWolf",
        "name": "EmailWolf"
    },
    {
        "regex": "NetLyzer FastProbe",
        "name": "NetLyzer FastProbe"
    },
    {
        "regex": "AdMantX.*admantx\\.com",
        "name": "ADMantX"
    },
    {
        "regex": "Server Density Service Monitoring.*",
        "name": "Server Density"
    },
    {
        "regex": "RSSRadio \\(Push Notification Scanner;support@dorada\\.co\\.uk\\)",
        "name": "RSSRadio Bot"
    },
    {
        "regex": "(A6-Indexer|nuhk|TsolCrawler|Yammybot|Openbot|Gulper Web Bot|grub-client|Download Demon|SearchExpress|Microsoft URL Control|borg|altavista|dataminr.com|tweetedtimes.com|TrendsmapResolver|teoma|blitzbot|oegp|furlbot|http%20client|polybot|htdig|mogimogi|larbin|scrubby|searchsight|seekbot|semanticdiscovery|snappy|vortex(?! Build)|zeal|fast-webcrawler|converacrawler|dataparksearch|findlinks|BrowserMob|HttpMonitor|ThumbShotsBot|URL2PNG|ZooShot|GomezA|Google SketchUp|Read%20Later|RackspaceBot|robots|SeopultContentAnalyzer|7Siters|centuryb.o.t9|InterNaetBoten|EasyBib AutoCite|Bidtellect|tomnomnom/meg)",
        "name": "Generic Bot"
    },
    {
        "regex": "^sentry",
        "name": "Sentry Bot",
        "producer": {
            "name": "Sentry",
            "url": "https://sentry.io"
        }
    },
    {
        "regex": "^Spotify",
        "name": "Spotify",
        "producer": {
            "name": "Spotify",
            "url": "https://www.spotify.com"
        }
    },
    {
        "regex": "The Knowledge AI",
        "name": "The Knowledge AI",
        "category": "Crawler"
    },
    {
        "regex": "Embedly",
        "name": "Embedly",
        "category": "Crawler",
        "url": "https://support.embed.ly/hc/en-us",
        "producer": {
            "name": "A Medium, Corp.",
            "url": "https://medium.com/"
        }
    },
    {
        "regex": "BrandVerity",
        "name": "BrandVerity",
        "category": "Crawler",
        "url": "https://www.brandverity.com/why-is-brandverity-visiting-me",
        "producer": {
            "name": "BrandVerity, Inc.",
            "url": "https://www.brandverity.com/"
        }
    },
    {
        "regex": "Kaspersky Lab CFR link resolver",
        "name": "Kaspersky",
        "category": "Security Checker",
        "url": "https://www.kaspersky.com/",
        "producer": {
            "name": "AO Kaspersky Lab",
            "url": "https://www.kaspersky.com/"
        }
    },
    {
        "regex": "eZ Publish Link Validator",
        "name": "eZ Publish Link Validator",
        "category": "Crawler",
        "url": "https://ez.no/",
        "producer": {
            "name": "eZ Systems AS",
            "url": "https://ez.no/"
        }
    },
    {
        "regex": "woorankreview",
        "name": "WooRank",
        "category": "Search bot",
        "url": "https://www.woorank.com/",
        "producer": {
            "name": "WooRank sprl",
            "url": "https://www.woorank.com/"
        }
    },
    {
        "regex": "(Match|LinkCheck) by Siteimprove.com",
        "name": "Siteimprove",
        "category": "Search bot",
        "url": "https://siteimprove.com/",
        "producer": {
            "name": "Siteimprove GmbH",
            "url": "https://siteimprove.com/"
        }
    },
    {
        "regex": "CATExplorador",
        "name": "CATExplorador",
        "category": "Search bot",
        "url": "https://fundacio.cat/ca/domini/",
        "producer": {
            "name": "Fundació puntCAT",
            "url": "https://fundacio.cat/ca/domini/"
        }
    },
    {
        "regex": "Buck",
        "name": "Buck",
        "category": "Search bot",
        "url": "https://hypefactors.com/",
        "producer": {
            "name": "Hypefactors A/S",
            "url": "https://hypefactors.com/"
        }
    },
    {
        "regex": "tracemyfile",
        "name": "TraceMyFile",
        "category": "Search bot",
        "url": "https://www.tracemyfile.com/",
        "producer": {
            "name": "Idee Inc.",
            "url": "http://ideeinc.com/"
        }
    },
    {
        "regex": "zelist.ro feed parser",
        "name": "Ze List",
        "url": "https://www.zelist.ro/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "Treeworks SRL",
            "url": "https://www.tree.ro/"
        }
    },
    {
        "regex": "weborama-fetcher",
        "name": "Weborama",
        "category": "Search bot",
        "url": "https://weborama.com/",
        "producer": {
            "name": "Weborama SA",
            "url": "https://weborama.com/"
        }
    },
    {
        "regex": "BoardReader Favicon Fetcher",
        "name": "BoardReader",
        "category": "Search bot",
        "url": "https://boardreader.com/",
        "producer": {
            "name": "Effyis Inc",
            "url": "https://boardreader.com/"
        }
    },
    {
        "regex": "IDG/IT",
        "name": "IDG/IT",
        "category": "Search bot",
        "url": "https://spaziodati.eu/",
        "producer": {
            "name": "SpazioDati S.r.l.",
            "url": "https://spaziodati.eu/"
        }
    },
    {
        "regex": "Bytespider",
        "name": "Bytespider",
        "category": "Search bot",
        "url": "https://bytedance.com/",
        "producer": {
            "name": "ByteDance Ltd.",
            "url": "https://bytedance.com/"
        }
    },
    {
        "regex": "WikiDo",
        "name": "WikiDo",
        "category": "Search bot",
        "url": "https://www.wikido.com/",
        "producer": {
            "name": "Fotolitografie Fiorentine di Becchi Antonio s.n.c.",
            "url": "https://www.wikido.com/"
        }
    },
    {
        "regex": "AwarioSmartBot",
        "name": "Awario",
        "category": "Search bot",
        "url": "https://awario.com/bots.html",
        "producer": {
            "name": "Awario",
            "url": "https://awario.com/"
        }
    },
    {
        "regex": "AwarioRssBot",
        "name": "Awario",
        "category": "Feed Fetcher",
        "url": "https://awario.com/bots.html",
        "producer": {
            "name": "Awario",
            "url": "https://awario.com/"
        }
    },
    {
        "regex": "oBot",
        "name": "oBot",
        "category": "Search bot",
        "url": "https://www.xforce-security.com/crawler/",
        "producer": {
            "name": "IBM Germany Research & Development GmbH",
            "url": "https://exchange.xforce.ibmcloud.com/"
        }
    },
    {
        "regex": "SMTBot",
        "name": "SMTBot",
        "category": "Search bot",
        "url": "https://www.similartech.com/smtbot",
        "producer": {
            "name": "SimilarTech Ltd.",
            "url": "https://www.similartech.com/"
        }
    },
    {
        "regex": "LCC",
        "name": "LCC",
        "category": "Search bot",
        "url": "https://corpora.uni-leipzig.de/crawler_faq.html",
        "producer": {
            "name": "Universität Leipzig",
            "url": "https://www.uni-leipzig.de/"
        }
    },
    {
        "regex": "Startpagina-Linkchecker",
        "name": "Startpagina Linkchecker",
        "category": "Search bot",
        "url": "https://www.startpagina.nl/linkchecker",
        "producer": {
            "name": "Startpagina B.V.",
            "url": "https://www.startpagina.nl/"
        }
    },
    {
        "regex": "GTmetrix",
        "name": "GTmetrix",
        "category": "Crawler",
        "url": "https://gtmetrix.com/",
        "producer": {
            "name": "Carbon60 Operating Co. Ltd.",
            "url": "https://www.carbon60.com/"
        }
    },
    {
        "regex": "Nutch",
        "name": "Nutch-based Bot",
        "category": "Crawler",
        "url": "https://nutch.apache.org",
        "producer": {
            "name": "The Apache Software Foundation",
            "url": "https://www.apache.org/foundation/"
        }
    },
    {
        "regex": "Seobility",
        "name": "Seobility",
        "category": "Crawler",
        "url": "https://www.seobility.net/en/faq/?category=crawling#!aboutourbot"
    },
    {
        "regex": "Vercelbot",
        "name": "Vercel Bot",
        "category": "Service bot",
        "url": "https://vercel.com"
    },
    {
        "regex": "Grammarly",
        "name": "Grammarly",
        "category": "Service bot",
        "url": "https://www.grammarly.com"
    },
    {
        "regex": "Robozilla",
        "name": "Robozilla",
        "category": "Crawler"
    },
    {
        "regex": "Domains Project",
        "name": "Domains Project",
        "category": "Crawler",
        "url": "https://domainsproject.org"
    },
    {
        "regex": "PetalBot",
        "name": "Petal Bot",
        "category": "Crawler",
        "url": "https://aspiegel.com/petalbot"
    },
    {
        "regex": "SerendeputyBot",
        "name": "Serendeputy Bot",
        "category": "Crawler",
        "url": "https://serendeputy.com/about/serendeputy-bot"
    },
    {
        "regex": "ias-va.*admantx.*service-fetcher",
        "name": "ADmantX Service Fetcher",
        "category": "Service bot",
        "url": "https://www.admantx.com/service-fetcher.html"
    },
    {
        "regex": "SemanticScholarBot",
        "name": "Semantic Scholar Bot",
        "category": "Crawler",
        "url": "https://www.semanticscholar.org/crawler"
    },
    {
        "regex": "VelenPublicWebCrawler",
        "name": "Velen Public Web Crawler",
        "category": "Crawler",
        "url": "https://hunter.io/robot"
    },
    {
        "regex": "Barkrowler",
        "name": "Barkrowler",
        "category": "Crawler",
        "url": "http://www.exensa.com/crawl"
    },
    {
        "regex": "BDCbot",
        "name": "BDCbot",
        "category": "Crawler",
        "url": "https://bigweb.bigdatacorp.com.br/pages/faq.aspx",
        "producer": {
            "name": "BIG Data Solucoes Em Tecnologia de Informatica LTDA",
            "url": "https://bigdatacorp.com.br/"
        }
    },
    {
        "regex": "adbeat",
        "name": "Adbeat",
        "category": "Crawler",
        "url": "https://www.adbeat.com/operation_policy",
        "producer": {
            "name": "PPC Labs LLC",
            "url": "https://www.adbeat.com/"
        }
    },
    {
        "regex": "BW/(?:(\\d+[\\.\\d]+))",
        "name": "BuiltWith",
        "category": "Crawler",
        "url": "https://builtwith.com/biup",
        "producer": {
            "name": "BuiltWith Pty Ltd",
            "url": "https://builtwith.com/"
        }
    },
    {
        "regex": "https://whatis.contentkingapp.com",
        "name": "ContentKing",
        "category": "Site Monitor",
        "url": "https://whatis.contentkingapp.com/",
        "producer": {
            "name": "ContentKing BV",
            "url": "https://www.contentkingapp.com/"
        }
    },
    {
        "regex": "MicroAdBot",
        "name": "MicroAdBot",
        "category": "Crawler",
        "url": "https://www.microad.co.jp/",
        "producer": {
            "name": "MicroAd, Inc.",
            "url": "https://www.microad.co.jp/"
        }
    },
    {
        "regex": "PingAdmin.Ru",
        "name": "PingAdmin.Ru",
        "category": "Site Monitor",
        "url": "https://ping-admin.ru/"
    },
    {
        "regex": "notifyninja.+monitoring",
        "name": "Notify Ninja",
        "category": "Site Monitor",
        "url": "http://notifyninja.com"
    },
    {
        "regex": "WebDataStats",
        "name": "WebDataStats",
        "category": "Crawler",
        "url": "https://webdatastats.com/policy.html",
        "producer": {
            "name": "WebTehRazrabotka LLC",
            "url": "https://webdatastats.com/"
        }
    },
    {
        "regex": "parse.ly scraper",
        "name": "parse.ly",
        "category": "Crawler",
        "url": "https://www.parse.ly/help/integration/crawler",
        "producer": {
            "name": "Parsely, Inc.",
            "url": "https://www.parse.ly/"
        }
    },
    {
        "regex": "Nimbostratus-Bot",
        "name": "Nimbostratus Bot",
        "category": "Site Monitor",
        "url": "http://cloudsystemnetworks.com"
    },
    {
        "regex": "HeartRails_Capture/\\d",
        "name": "Heart Rails Capture",
        "category": "Service Agent",
        "url": "http://capture.heartrails.com"
    },
    {
        "regex": "Project-Resonance",
        "name": "Project Resonance",
        "category": "Crawler",
        "url": "http://project-resonance.com"
    },
    {
        "regex": "DataXu/\\d",
        "name": "DataXu",
        "category": "Service Agent",
        "url": "https://advertising.roku.com/dataxu",
        "producer": {
            "name": "Roku, Inc.",
            "url": "https://roku.com"
        }
    },
    {
        "regex": "Cocolyzebot",
        "name": "Cocolyzebot",
        "category": "Crawler",
        "url": "https://cocolyze.com/en/cocolyzebot",
        "producer": {
            "name": "VSI INNOVATION SAS",
            "url": "https://vsi-innovation.com/"
        }
    },
    {
        "regex": "veryhip",
        "name": "VeryHip",
        "category": "Crawler",
        "url": "https://veryhip.com/",
        "producer": {
            "name": "VeryHip",
            "url": "https://veryhip.com/"
        }
    },
    {
        "regex": "LinkpadBot",
        "name": "LinkpadBot",
        "category": "Crawler",
        "url": "https://www.linkpad.org/",
        "producer": {
            "name": "Solomono LLC",
            "url": "https://www.linkpad.org/"
        }
    },
    {
        "regex": "MuscatFerret",
        "name": "MuscatFerret",
        "category": "Crawler",
        "url": "http://www.webtop.com/"
    },
    {
        "regex": "PageThing.com",
        "name": "PageThing",
        "category": "Crawler",
        "url": "https://www.pagething.com/",
        "producer": {
            "name": "SPECIALNOISE LTD",
            "url": "https://www.specialnoise.com/"
        }
    },
    {
        "regex": "ArchiveBox",
        "name": "ArchiveBox",
        "url": "https://archivebox.io/",
        "category": "Crawler",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Choosito",
        "name": "Choosito",
        "url": "https://www.choosito.com/",
        "category": "Crawler",
        "producer": {
            "name": "Choosito! Inc.",
            "url": "https://www.choosito.com/"
        }
    },
    {
        "regex": "datagnionbot",
        "name": "datagnionbot",
        "url": "https://www.datagnion.com/bot.html",
        "category": "Crawler",
        "producer": {
            "name": "DATAGNION GMBH",
            "url": "https://www.datagnion.com/"
        }
    },
    {
        "regex": "WhatCMS",
        "name": "WhatCMS",
        "url": "https://whatcms.org/",
        "category": "Crawler",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "httpx",
        "name": "httpx",
        "url": "https://github.com/projectdiscovery/httpx",
        "category": "Crawler",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "scaninfo@expanseinc.com",
        "name": "Expanse",
        "category": "Security Checker",
        "url": "https://expanse.co/",
        "producer": {
            "name": "Expanse Inc.",
            "url": "https://expanse.co/"
        }
    },
    {
        "regex": "HuaweiWebCatBot",
        "name": "HuaweiWebCatBot",
        "category": "Crawler",
        "url": "https://isecurity.huawei.com",
        "producer": {
            "name": "Huawei Technologies Co., Ltd.",
            "url": "https://huawei.com"
        }
    },
    {
        "regex": "Hatena-Favicon",
        "name": "Hatena Favicon",
        "category": "Crawler",
        "url": "https://www.hatena.ne.jp/faq/",
        "producer": {
            "name": "Hatena Co., Ltd.",
            "url": "https://www.hatena.ne.jp"
        }
    },
    {
        "regex": "RyowlEngine/(\\d+)",
        "name": "Ryowl",
        "category": "Crawler",
        "url": "https://ryowl.org"
    },
    {
        "regex": "OdklBot/(\\d+)",
        "name": "Odnoklassniki Bot",
        "category": "Crawler",
        "url": "https://odnoklassniki.ru"
    },
    {
        "regex": "Mediatoolkitbot",
        "name": "Mediatoolkit Bot",
        "category": "Crawler",
        "url": "https://mediatoolkit.com"
    },
    {
        "regex": "ZoominfoBot",
        "name": "ZoominfoBot",
        "category": "Crawler",
        "url": "https://www.zoominfo.com"
    },
    {
        "regex": "WeViKaBot/([\\d+\\.])",
        "name": "WeViKaBot",
        "category": "Crawler",
        "url": "http://www.wevika.de"
    },
    {
        "regex": "SEOkicks",
        "name": "SEOkicks",
        "category": "Crawler",
        "url": "https://www.seokicks.de/robot.html"
    },
    {
        "regex": "Plukkie/([\\d+\\.])",
        "name": "Plukkie",
        "category": "Crawler",
        "url": "http://www.botje.com/plukkie.htm"
    },
    {
        "regex": "proximic;",
        "name": "Comscore",
        "category": "Crawler",
        "url": "https://www.comscore.com/Web-Crawler"
    },
    {
        "regex": "SurdotlyBot/([\\d+\\.])",
        "name": "SurdotlyBot",
        "category": "Crawler",
        "url": "http://sur.ly/bot.html"
    },
    {
        "regex": "Gowikibot/([\\d+\\.])",
        "name": "Gowikibot",
        "category": "Crawler",
        "url": "http:/www.gowikibot.com"
    },
    {
        "regex": "SabsimBot/([\\d+\\.])",
        "name": "SabsimBot",
        "category": "Crawler",
        "url": "https://sabsim.com"
    },
    {
        "regex": "LumtelBot/([\\d+\\.])",
        "name": "LumtelBot",
        "category": "Crawler",
        "url": "https://umtel.com"
    },
    {
        "regex": "PiplBot",
        "name": "PiplBot",
        "category": "Crawler",
        "url": "http://www.pipl.com/bot"
    },
    {
        "regex": "woobot/([\\d+\\.])",
        "name": "WooRank",
        "category": "Crawler",
        "url": "https://www.woorank.com/bot"
    },
    {
        "regex": "[a-z0-9\\-_]*((?<!cu|power[ _]|m[ _])bot(?![ _]TAB|[ _]?5[0-9])|crawler|crawl|checker|archiver|transcoder|spider)([^a-z]|$)",
        "name": "Generic Bot"
    }
]

"use strict";
var ____importDefault_33 = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const bots_json_1 = ____importDefault_33(_$bots_16);
/* removed: const _$userAgent_57 = require("../../utils/user-agent"); */;
class BotParser {
    constructor() {
        this.parse = (userAgent) => {
            var _a, _b, _c, _d;
            for (const bot of bots_json_1.default) {
                const match = _$userAgent_57.userAgentParser(bot.regex, userAgent);
                if (!match)
                    continue;
                return {
                    name: bot.name,
                    category: bot.category || "",
                    url: bot.url || "",
                    producer: {
                        name: ((_b = (_a = bot) === null || _a === void 0 ? void 0 : _a.producer) === null || _b === void 0 ? void 0 : _b.name) || "",
                        url: ((_d = (_c = bot) === null || _c === void 0 ? void 0 : _c.producer) === null || _d === void 0 ? void 0 : _d.url) || ""
                    }
                };
            }
            return null;
        };
    }
}
var _$BotParser_33 = BotParser;

var _$versionCompare_59 = {};
"use strict";
Object.defineProperty(_$versionCompare_59, "__esModule", { value: true });
_$versionCompare_59.versionCompare = (v1, v2, operator) => {
    //      discuss at: http://locutus.io/php/version_compare/
    //      original by: Philippe Jausions (http://pear.php.net/user/jausions)
    //      original by: Aidan Lister (http://aidanlister.com/)
    //      reimplemented by: Kankrelune (http://www.webfaktory.info/)
    //      improved by: Brett Zamir (http://brett-zamir.me)
    //      improved by: Scott Baker
    //      improved by: Theriault (https://github.com/Theriault)
    //      example 1: version_compare('8.2.5rc', '8.2.5a')
    //      returns 1: 1
    //      example 2: version_compare('8.2.50', '8.2.52', '<')
    //      returns 2: true
    //      example 3: version_compare('5.3.0-dev', '5.3.0')
    //      returns 3: -1
    //      example 4: version_compare('4.1.0.52','4.01.0.51')
    //      returns 4: 1
    // Important: compare must be initialized at 0.
    let i;
    let x;
    let compare = 0;
    // vm maps textual PHP versions to negatives so they're less than 0.
    // PHP currently defines these as CASE-SENSITIVE. It is important to
    // leave these as negatives so that they can come before numerical versions
    // and as if no letters were there to begin with.
    // (1alpha is < 1 and < 1.1 but > 1dev1)
    // If a non-numerical value can't be mapped to this table, it receives
    // -7 as its value.
    const vm = {
        "dev": -6,
        "alpha": -5,
        "a": -5,
        "beta": -4,
        "b": -4,
        "RC": -3,
        "rc": -3,
        "#": -2,
        "p": 1,
        "pl": 1
    };
    // This function will be called to prepare each version argument.
    // It replaces every _, -, and + with a dot.
    // It surrounds any nonsequence of numbers/dots with dots.
    // It replaces sequences of dots with a single dot.
    //    version_compare('4..0', '4.0') === 0
    // Important: A string of 0 length needs to be converted into a value
    // even less than an unexisting value in vm (-7), hence [-8].
    // It's also important to not strip spaces because of this.
    //   version_compare('', ' ') === 1
    const prepVersion = (v) => {
        v = ("" + v).replace(/[_\-+]/g, ".");
        v = v.replace(/([^.\d]+)/g, ".$1.").replace(/\.{2,}/g, ".");
        return (!v.length ? [-8] : v.split("."));
    };
    // This converts a version component to a number.
    // Empty component becomes 0.
    // Non-numerical component becomes a negative number.
    // Numerical component becomes itself as an integer.
    const numVersion = (v) => {
        return !v ? 0 : (isNaN(v) ? vm[v] || -7 : parseInt(v, 10));
    };
    v1 = prepVersion(v1);
    v2 = prepVersion(v2);
    x = Math.max(v1.length, v2.length);
    for (i = 0; i < x; i++) {
        if (v1[i] === v2[i]) {
            continue;
        }
        v1[i] = numVersion(v1[i]);
        v2[i] = numVersion(v2[i]);
        if (v1[i] < v2[i]) {
            compare = -1;
            break;
        }
        else if (v1[i] > v2[i]) {
            compare = 1;
            break;
        }
    }
    if (!operator) {
        return compare;
    }
    // Important: operator is CASE-SENSITIVE.
    // "No operator" seems to be treated as "<."
    // Any other values seem to make the function return null.
    switch (operator) {
        case ">":
        case "gt":
            return (compare > 0);
        case ">=":
        case "ge":
            return (compare >= 0);
        case "<=":
        case "le":
            return (compare <= 0);
        case "===":
        case "=":
        case "eq":
            return (compare === 0);
        case "<>":
        case "!==":
        case "ne":
            return (compare !== 0);
        case "":
        case "<":
        case "lt":
            return (compare < 0);
        default:
            return null;
    }
};

"use strict";
var ____importDefault_deviceDetectorJs = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const client_1 = ____importDefault_deviceDetectorJs(_$client_38);
const device_1 = ____importDefault_deviceDetectorJs(_$device_46);
const operating_system_1 = ____importDefault_deviceDetectorJs(_$operatingSystem_52);
const vendor_fragment_1 = ____importDefault_deviceDetectorJs(_$vendorFragment_53);
const __browser_1_deviceDetectorJs = ____importDefault_deviceDetectorJs(_$browser_34);
/* removed: const _$BotParser_33 = require("./parsers/bot"); */;
/* removed: const _$userAgent_57 = require("./utils/user-agent"); */;
/* removed: const _$versionCompare_59 = require("./utils/version-compare"); */;
class DeviceDetector {
    constructor(options) {
        // Default options
        this.options = {
            skipBotDetection: false,
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            const result = {
                client: this.clientParser.parse(userAgent),
                os: this.operatingSystemParser.parse(userAgent),
                device: this.deviceParser.parse(userAgent),
                bot: this.options.skipBotDetection ? null : this.botParser.parse(userAgent)
            };
            const osName = (_a = result.os) === null || _a === void 0 ? void 0 : _a.name;
            const osVersion = (_b = result.os) === null || _b === void 0 ? void 0 : _b.version;
            const osFamily = operating_system_1.default.getOsFamily(osName || "");
            if (!((_c = result.device) === null || _c === void 0 ? void 0 : _c.brand)) {
                const brand = this.vendorFragmentParser.parse(userAgent);
                if (brand) {
                    if (!result.device) {
                        result.device = this.createDeviceObject();
                    }
                    result.device.brand = brand;
                }
            }
            /**
             * Assume all devices running iOS / Mac OS are from Apple
             */
            if (!((_d = result.device) === null || _d === void 0 ? void 0 : _d.brand) && ["Apple TV", "watchOS", "iOS", "Mac"].includes(osName || "")) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.brand = "Apple";
            }
            /**
             * Chrome on Android passes the device type based on the keyword 'Mobile'
             * If it is present the device should be a smartphone, otherwise it's a tablet
             * See https://developer.chrome.com/multidevice/user-agent#chrome_for_android_user_agent
             * Note: We do not check for browser (family) here, as there might be mobile apps using Chrome, that won't have
             *       a detected browser, but can still be detected. So we check the useragent for Chrome instead.
             */
            if (!((_e = result.device) === null || _e === void 0 ? void 0 : _e.type) && osFamily === "Android" && _$userAgent_57.userAgentParser("Chrome/[\\.0-9]*", userAgent)) {
                if (_$userAgent_57.userAgentParser("Chrome/[.0-9]* (?:Mobile|eliboM)", userAgent)) {
                    if (!result.device) {
                        result.device = this.createDeviceObject();
                    }
                    result.device.type = "smartphone";
                }
                else if (_$userAgent_57.userAgentParser("Chrome/[.0-9]* (?!Mobile)", userAgent)) {
                    if (!result.device) {
                        result.device = this.createDeviceObject();
                    }
                    result.device.type = "tablet";
                }
            }
            /**
             * Some user agents simply contain the fragment 'Android; Tablet;' or 'Opera Tablet', so we assume those devices are tablets
             */
            if (!((_f = result.device) === null || _f === void 0 ? void 0 : _f.type) && this.hasAndroidTabletFragment(userAgent) || _$userAgent_57.userAgentParser("Opera Tablet", userAgent)) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "tablet";
            }
            /**
             * Some user agents simply contain the fragment 'Android; Mobile;', so we assume those devices are smartphones
             */
            if (!((_g = result.device) === null || _g === void 0 ? void 0 : _g.type) && this.hasAndroidMobileFragment(userAgent)) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "smartphone";
            }
            /**
             * Android up to 3.0 was designed for smartphones only. But as 3.0, which was tablet only, was published
             * too late, there were a bunch of tablets running with 2.x
             * With 4.0 the two trees were merged and it is for smartphones and tablets
             *
             * So were are expecting that all devices running Android < 2 are smartphones
             * Devices running Android 3.X are tablets. Device type of Android 2.X and 4.X+ are unknown
             */
            if (!((_h = result.device) === null || _h === void 0 ? void 0 : _h.type) && osName === "Android" && osVersion !== "") {
                if (_$versionCompare_59.versionCompare(osVersion, "2.0") === -1) {
                    if (!result.device) {
                        result.device = this.createDeviceObject();
                    }
                    result.device.type = "smartphone";
                }
                else if (_$versionCompare_59.versionCompare(osVersion, "3.0") >= 0 && _$versionCompare_59.versionCompare(osVersion, "4.0") === -1) {
                    if (!result.device) {
                        result.device = this.createDeviceObject();
                    }
                    result.device.type = "tablet";
                }
            }
            /**
             * All detected feature phones running android are more likely smartphones
             */
            if (((_j = result.device) === null || _j === void 0 ? void 0 : _j.type) === "feature phone" && osFamily === "Android") {
                result.device.type = "smartphone";
            }
            /**
             * According to http://msdn.microsoft.com/en-us/library/ie/hh920767(v=vs.85).aspx
             * Internet Explorer 10 introduces the "Touch" UA string token. If this token is present at the end of the
             * UA string, the computer has touch capability, and is running Windows 8 (or later).
             * This UA string will be transmitted on a touch-enabled system running Windows 8 (RT)
             *
             * As most touch enabled devices are tablets and only a smaller part are desktops/notebooks we assume that
             * all Windows 8 touch devices are tablets.
             */
            if (!((_k = result.device) === null || _k === void 0 ? void 0 : _k.type)
                && this.isToucheEnabled(userAgent)
                && (osName === "Windows RT"
                    || (osName === "Windows"
                        && _$versionCompare_59.versionCompare(osVersion, "8.0") >= 0))) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "tablet";
            }
            /**
             * All devices running Opera TV Store are assumed to be televisions
             */
            if (_$userAgent_57.userAgentParser("Opera TV Store", userAgent)) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "television";
            }
            /**
             * All devices running Tizen TV or SmartTV are assumed to be televisions
             */
            if (_$userAgent_57.userAgentParser("SmartTV|Tizen.+ TV .+$", userAgent)) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "television";
            }
            /**
             * Devices running Kylo or Espital TV Browsers are assumed to be televisions
             */
            if (!((_l = result.device) === null || _l === void 0 ? void 0 : _l.type) && ["Kylo", "Espial TV Browser"].includes(((_m = result.client) === null || _m === void 0 ? void 0 : _m.name) || "")) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "television";
            }
            /**
             * Set device type to desktop if string ua contains desktop
             */
            const hasDesktop = "desktop" !== ((_o = result.device) === null || _o === void 0 ? void 0 : _o.type)
                && null !== _$userAgent_57.userAgentParser("Desktop", userAgent)
                && this.hasDesktopFragment(userAgent);
            if (hasDesktop) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "desktop";
            }
            // set device type to desktop for all devices running a desktop os that were not detected as an other device type
            if (!((_p = result.device) === null || _p === void 0 ? void 0 : _p.type) && this.isDesktop(result, osFamily)) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "desktop";
            }
            return result;
        };
        this.hasAndroidMobileFragment = (userAgent) => {
            return _$userAgent_57.userAgentParser("Android( [\.0-9]+)?; Mobile;", userAgent);
        };
        this.hasAndroidTabletFragment = (userAgent) => {
            return _$userAgent_57.userAgentParser("Android( [\.0-9]+)?; Tablet;", userAgent);
        };
        this.hasDesktopFragment = (userAgent) => {
            return _$userAgent_57.userAgentParser("Desktop (x(?:32|64)|WOW64);", userAgent);
        };
        this.isDesktop = (result, osFamily) => {
            if (!result.os) {
                return false;
            }
            // Check for browsers available for mobile devices only
            if (this.usesMobileBrowser(result.client)) {
                return false;
            }
            return operating_system_1.default.getDesktopOsArray().includes(osFamily);
        };
        this.usesMobileBrowser = (client) => {
            var _a, _b;
            if (!client)
                return false;
            return ((_a = client) === null || _a === void 0 ? void 0 : _a.type) === "browser" && __browser_1_deviceDetectorJs.default.isMobileOnlyBrowser((_b = client) === null || _b === void 0 ? void 0 : _b.name);
        };
        this.isToucheEnabled = (userAgent) => {
            return _$userAgent_57.userAgentParser("Touch", userAgent);
        };
        this.createDeviceObject = () => ({
            type: "",
            brand: "",
            model: ""
        });
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.clientParser = new client_1.default(this.options);
        this.deviceParser = new device_1.default();
        this.operatingSystemParser = new operating_system_1.default(this.options);
        this.vendorFragmentParser = new vendor_fragment_1.default();
        this.botParser = new _$BotParser_33();
    }
}
var _$DeviceDetector_deviceDetectorJs = DeviceDetector;

var _$dompurify_dompurify = { exports: {} };
/*! @license DOMPurify 3.2.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.5/LICENSE */

(function (global, factory) {
  typeof _$dompurify_dompurify.exports === 'object' && "object" !== 'undefined' ? _$dompurify_dompurify.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.DOMPurify = factory());
})(this, (function () { 'use strict';

  const {
    entries,
    setPrototypeOf,
    isFrozen,
    getPrototypeOf,
    getOwnPropertyDescriptor
  } = Object;
  let {
    freeze,
    seal,
    create
  } = Object; // eslint-disable-line import/no-mutable-exports
  let {
    apply,
    construct
  } = typeof Reflect !== 'undefined' && Reflect;
  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }
  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }
  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }
  if (!construct) {
    construct = function construct(Func, args) {
      return new Func(...args);
    };
  }
  const arrayForEach = unapply(Array.prototype.forEach);
  const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
  const arrayPop = unapply(Array.prototype.pop);
  const arrayPush = unapply(Array.prototype.push);
  const arraySplice = unapply(Array.prototype.splice);
  const stringToLowerCase = unapply(String.prototype.toLowerCase);
  const stringToString = unapply(String.prototype.toString);
  const stringMatch = unapply(String.prototype.match);
  const stringReplace = unapply(String.prototype.replace);
  const stringIndexOf = unapply(String.prototype.indexOf);
  const stringTrim = unapply(String.prototype.trim);
  const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
  const regExpTest = unapply(RegExp.prototype.test);
  const typeErrorCreate = unconstruct(TypeError);
  /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */
  function unapply(func) {
    return function (thisArg) {
      if (thisArg instanceof RegExp) {
        thisArg.lastIndex = 0;
      }
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return apply(func, thisArg, args);
    };
  }
  /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return construct(func, args);
    };
  }
  /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */
  function addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }
    let l = array.length;
    while (l--) {
      let element = array[l];
      if (typeof element === 'string') {
        const lcElement = transformCaseFunc(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }
          element = lcElement;
        }
      }
      set[element] = true;
    }
    return set;
  }
  /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */
  function cleanArray(array) {
    for (let index = 0; index < array.length; index++) {
      const isPropertyExist = objectHasOwnProperty(array, index);
      if (!isPropertyExist) {
        array[index] = null;
      }
    }
    return array;
  }
  /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */
  function clone(object) {
    const newObject = create(null);
    for (const [property, value] of entries(object)) {
      const isPropertyExist = objectHasOwnProperty(object, property);
      if (isPropertyExist) {
        if (Array.isArray(value)) {
          newObject[property] = cleanArray(value);
        } else if (value && typeof value === 'object' && value.constructor === Object) {
          newObject[property] = clone(value);
        } else {
          newObject[property] = value;
        }
      }
    }
    return newObject;
  }
  /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */
  function lookupGetter(object, prop) {
    while (object !== null) {
      const desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }
        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }
      object = getPrototypeOf(object);
    }
    function fallbackValue() {
      return null;
    }
    return fallbackValue;
  }

  const html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
  const svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  const svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  const svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  const mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']);
  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  const mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  const text = freeze(['#text']);

  const html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'wrap', 'xmlns', 'slot']);
  const svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'amplitude', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'exponent', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'slope', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'tablevalues', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  const mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  const xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
  const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
  const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  const DOCTYPE_NAME = seal(/^html$/i);
  const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

  var EXPRESSIONS = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ARIA_ATTR: ARIA_ATTR,
    ATTR_WHITESPACE: ATTR_WHITESPACE,
    CUSTOM_ELEMENT: CUSTOM_ELEMENT,
    DATA_ATTR: DATA_ATTR,
    DOCTYPE_NAME: DOCTYPE_NAME,
    ERB_EXPR: ERB_EXPR,
    IS_ALLOWED_URI: IS_ALLOWED_URI,
    IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
    MUSTACHE_EXPR: MUSTACHE_EXPR,
    TMPLIT_EXPR: TMPLIT_EXPR
  });

  /* eslint-disable @typescript-eslint/indent */
  // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
  const NODE_TYPE = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    // Deprecated
    entityNode: 6,
    // Deprecated
    progressingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12 // Deprecated
  };
  const getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */
  const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }
    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = 'data-tt-policy-suffix';
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
      suffix = purifyHostElement.getAttribute(ATTR_NAME);
    }
    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML(html) {
          return html;
        },
        createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };
  const _createHooksMap = function _createHooksMap() {
    return {
      afterSanitizeAttributes: [],
      afterSanitizeElements: [],
      afterSanitizeShadowDOM: [],
      beforeSanitizeAttributes: [],
      beforeSanitizeElements: [],
      beforeSanitizeShadowDOM: [],
      uponSanitizeAttribute: [],
      uponSanitizeElement: [],
      uponSanitizeShadowNode: []
    };
  };
  function createDOMPurify() {
    let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
    const DOMPurify = root => createDOMPurify(root);
    DOMPurify.version = '3.2.5';
    DOMPurify.removed = [];
    if (!window || !window.document || window.document.nodeType !== NODE_TYPE.document || !window.Element) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }
    let {
      document
    } = window;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    const {
      DocumentFragment,
      HTMLTemplateElement,
      Node,
      Element,
      NodeFilter,
      NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap,
      HTMLFormElement,
      DOMParser,
      trustedTypes
    } = window;
    const ElementPrototype = Element.prototype;
    const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    const remove = lookupGetter(ElementPrototype, 'remove');
    const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      const template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }
    let trustedTypesPolicy;
    let emptyHTML = '';
    const {
      implementation,
      createNodeIterator,
      createDocumentFragment,
      getElementsByTagName
    } = document;
    const {
      importNode
    } = originalDocument;
    let hooks = _createHooksMap();
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
    const {
      MUSTACHE_EXPR,
      ERB_EXPR,
      TMPLIT_EXPR,
      DATA_ATTR,
      ARIA_ATTR,
      IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE,
      CUSTOM_ELEMENT
    } = EXPRESSIONS;
    let {
      IS_ALLOWED_URI: IS_ALLOWED_URI$1
    } = EXPRESSIONS;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */
    /* allowed element names */
    let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
    /* Allowed attribute names */
    let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);
    /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */
    let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    let FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    let FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */
    let ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */
    let ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */
    let ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */
    let ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    let SAFE_FOR_TEMPLATES = false;
    /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */
    let SAFE_FOR_XML = true;
    /* Decide if document with <html>... should be returned */
    let WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */
    let SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    let FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    let RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    let RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    let RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */
    let SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */
    let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */
    let KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    let IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */
    let USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */
    let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */
    let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */
    let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */
    let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    let HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);
    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Parsing of strict XHTML documents */
    let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    let transformCaseFunc = null;
    /* Keep a reference to config to pass to hooks */
    let CONFIG = null;
    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */
    const formElement = document.createElement('form');
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */
    // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig() {
      let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */
      if (!cfg || typeof cfg !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);
      PARSER_MEDIA_TYPE =
      // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
      // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */
      ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
      HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }
      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }
      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, text);
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }
        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }
      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }
        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }
      if (cfg.TRUSTED_TYPES_POLICY) {
        if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
          throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        }
        if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
          throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        }
        // Overwrite existing TrustedTypes policy.
        trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
        // Sign local variables required by `sanitize`.
        emptyHTML = trustedTypesPolicy.createHTML('');
      } else {
        // Uninitialized policy, attempt to initialize the internal dompurify policy.
        if (trustedTypesPolicy === undefined) {
          trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
        }
        // If creating the internal policy succeeded sign internal variables.
        if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') {
          emptyHTML = trustedTypesPolicy.createHTML('');
        }
      }
      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }
      CONFIG = cfg;
    };
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
    const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
    /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    const _checkValidNamespace = function _checkValidNamespace(element) {
      let parent = getParentNode(element);
      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }
      const tagName = stringToLowerCase(element.tagName);
      const parentTagName = stringToLowerCase(parent.tagName);
      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }
      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }
        // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }
        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }
      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }
        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }
        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }
      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }
        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      }
      // For XHTML and XML documents that support custom namespaces
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      }
      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.
      return false;
    };
    /**
     * _forceRemove
     *
     * @param node a DOM node
     */
    const _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        getParentNode(node).removeChild(node);
      } catch (_) {
        remove(node);
      }
    };
    /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */
    const _removeAttribute = function _removeAttribute(name, element) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: element.getAttributeNode(name),
          from: element
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: element
        });
      }
      element.removeAttribute(name);
      // We void attribute values for unremovable "is" attributes
      if (name === 'is') {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(element);
          } catch (_) {}
        } else {
          try {
            element.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */
    const _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      let doc = null;
      let leadingWhitespace = null;
      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        const matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }
      const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }
      const body = doc.body || doc.documentElement;
      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }
      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */
    const _createNodeIterator = function _createNodeIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */
    const _isClobbered = function _isClobbered(element) {
      return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
    };
    /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */
    const _isNode = function _isNode(value) {
      return typeof Node === 'function' && value instanceof Node;
    };
    function _executeHooks(hooks, currentNode, data) {
      arrayForEach(hooks, hook => {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    }
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */
    const _sanitizeElements = function _sanitizeElements(currentNode) {
      let content = null;
      /* Execute a hook if present */
      _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }
      /* Now let's check the element's type and name */
      const tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */
      _executeHooks(hooks.uponSanitizeElement, currentNode, {
        tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */
      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }
      /* Remove any occurrence of processing instructions */
      if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
        _forceRemove(currentNode);
        return true;
      }
      /* Remove any kind of possibly harmful comments */
      if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
        _forceRemove(currentNode);
        return true;
      }
      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
            return false;
          }
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
            return false;
          }
        }
        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          const parentNode = getParentNode(currentNode) || currentNode.parentNode;
          const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
          if (childNodes && parentNode) {
            const childCount = childNodes.length;
            for (let i = childCount - 1; i >= 0; --i) {
              const childClone = cloneNode(childNodes[i], true);
              childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
              parentNode.insertBefore(childClone, getNextSibling(currentNode));
            }
          }
        }
        _forceRemove(currentNode);
        return true;
      }
      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }
      /* Make sure that older browsers don't get fallback-tag mXSS */
      if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }
      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
        /* Get the element's text content */
        content = currentNode.textContent;
        arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
          content = stringReplace(content, expr, ' ');
        });
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */
      _executeHooks(hooks.afterSanitizeElements, currentNode, null);
      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
        // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if (value) {
        return false;
      } else ;
      return true;
    };
    /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */
    const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
      return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */
    const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      /* Execute a hook if present */
      _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
      const {
        attributes
      } = currentNode;
      /* Check if we have attributes; if not we might have a text node */
      if (!attributes || _isClobbered(currentNode)) {
        return;
      }
      const hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR,
        forceKeepAttr: undefined
      };
      let l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        const attr = attributes[l];
        const {
          name,
          namespaceURI,
          value: attrValue
        } = attr;
        const lcName = transformCaseFunc(name);
        let value = name === 'value' ? attrValue : stringTrim(attrValue);
        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
        value = hookEvent.attrValue;
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */
        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode);
          // Prefix the value and later re-create the attribute with the sanitized value
          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Work around a security issue with comments inside attributes */
        if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }
        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */
        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */
        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }
        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
            value = stringReplace(value, expr, ' ');
          });
        }
        /* Is `value` valid for this attribute? */
        const lcTag = transformCaseFunc(currentNode.nodeName);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Handle attributes that require Trusted Types */
        if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                {
                  value = trustedTypesPolicy.createHTML(value);
                  break;
                }
              case 'TrustedScriptURL':
                {
                  value = trustedTypesPolicy.createScriptURL(value);
                  break;
                }
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }
          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {}
      }
      /* Execute a hook if present */
      _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */
    const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      let shadowNode = null;
      const shadowIterator = _createNodeIterator(fragment);
      /* Execute a hook if present */
      _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
        /* Sanitize tags and elements */
        _sanitizeElements(shadowNode);
        /* Check attributes next */
        _sanitizeAttributes(shadowNode);
        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
      }
      /* Execute a hook if present */
      _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
    };
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty) {
      let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let body = null;
      let importedNode = null;
      let currentNode = null;
      let returnNode = null;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        if (typeof dirty.toString === 'function') {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        } else {
          throw typeErrorCreate('toString is not a function');
        }
      }
      /* Return dirty HTML if DOMPurify cannot run */
      if (!DOMPurify.isSupported) {
        return dirty;
      }
      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */
      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }
      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          const tagName = transformCaseFunc(dirty.nodeName);
          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */
        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */
      const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Sanitize tags and elements */
        _sanitizeElements(currentNode);
        /* Check attributes next */
        _sanitizeAttributes(currentNode);
        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
      }
      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);
          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }
        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }
        return returnNode;
      }
      let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */
      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
          serializedHTML = stringReplace(serializedHTML, expr, ' ');
        });
      }
      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    DOMPurify.setConfig = function () {
      let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _parseConfig(cfg);
      SET_CONFIG = true;
    };
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }
      const lcTag = transformCaseFunc(tag);
      const lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }
      arrayPush(hooks[entryPoint], hookFunction);
    };
    DOMPurify.removeHook = function (entryPoint, hookFunction) {
      if (hookFunction !== undefined) {
        const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
        return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
      }
      return arrayPop(hooks[entryPoint]);
    };
    DOMPurify.removeHooks = function (entryPoint) {
      hooks[entryPoint] = [];
    };
    DOMPurify.removeAllHooks = function () {
      hooks = _createHooksMap();
    };
    return DOMPurify;
  }
  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map

_$dompurify_dompurify = _$dompurify_dompurify.exports
var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

var _$global_180 = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Fallback to standard globalThis if available
	if (typeof globalThis === "object" && globalThis) return globalThis;

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of updates to Object.prototype being restricted
		// via preventExtensions, seal or freeze
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ works, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();

"use strict";

// eslint-disable-next-line no-empty-function
var _$noop_177 = function () {};

"use strict";

var _undefined = _$noop_177(); // Support ES3 engines

var _$isValue_318 = function (val) { return val !== _undefined && val !== null; };

"use strict";

/* removed: var _$isValue_318 = require("./object/is-value"); */;

var slice = Array.prototype.slice;

// eslint-disable-next-line no-unused-vars
var _$optionalChaining_345 = function (value, propertyName1 /*, …propertyNamen*/) {
	var propertyNames = slice.call(arguments, 1), index = 0, length = propertyNames.length;
	while (_$isValue_318(value) && index < length) value = value[propertyNames[index++]];
	return index === length ? value : undefined;
};

// Deprecated

"use strict";

var _$isCallable_304 = function (obj) { return typeof obj === "function"; };

"use strict";

/* removed: var _$isCallable_304 = require("./object/is-callable"); */;

var _$safeToString_372 = function (value) {
	try {
		if (value && _$isCallable_304(value.toString)) return value.toString();
		return String(value);
	} catch (e) {
		return "<Non-coercible to string value>";
	}
};

"use strict";

/* removed: var _$safeToString_372 = require("./safe-to-string"); */;

var reNewLine = /[\n\r\u2028\u2029]/g;

var _$toShortStringRepresentation_419 = function (value) {
	var string = _$safeToString_372(value);
	// Trim if too long
	if (string.length > 100) string = string.slice(0, 99) + "…";
	// Replace eventual new lines
	string = string.replace(reNewLine, function (char) {
		return JSON.stringify(char).slice(1, -1);
	});
	return string;
};

"use strict";

var _$isImplemented_445 = function () {
	if (typeof globalThis !== "object") return false;
	if (!globalThis) return false;
	return globalThis.Array === Array;
};

var __naiveFallback_443 = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

var _$implementation_443 = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of Object.prototype being sealed (via preventExtensions, seal or freeze)
		return __naiveFallback_443();
	}
	try {
		// Safari case (window.__global__ is resolved with global context, but __global__ does not)
		if (!__global__) return __naiveFallback_443();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();

"use strict";

var _$globalThis_444 = _$isImplemented_445() ? globalThis : _$implementation_443;

"use strict";

var validTypes = { object: true, symbol: true };

var _$isImplemented_427 = function () {
	var Symbol = _$globalThis_444.Symbol;
	var symbol;
	if (typeof Symbol !== "function") return false;
	symbol = Symbol("test symbol");
	try { String(symbol); }
	catch (e) { return false; }

	// Return 'true' also for polyfills
	if (!validTypes[typeof Symbol.iterator]) return false;
	if (!validTypes[typeof Symbol.toPrimitive]) return false;
	if (!validTypes[typeof Symbol.toStringTag]) return false;

	return true;
};

"use strict";

// ES3 safe
var ___undefined_599 = void 0;

var _$is_599 = function (value) { return value !== ___undefined_599 && value !== null; };

"use strict";

/* removed: var _$is_599 = require("../value/is"); */;

// prettier-ignore
var possibleTypes = { "object": true, "function": true, "undefined": true /* document.all */ };

var _$is_592 = function (value) {
	if (!_$is_599(value)) return false;
	return hasOwnProperty.call(possibleTypes, typeof value);
};

"use strict";

/* removed: var _$is_592 = require("../object/is"); */;

var _$is_595 = function (value) {
	if (!_$is_592(value)) return false;
	try {
		if (!value.constructor) return false;
		return value.constructor.prototype === value;
	} catch (error) {
		return false;
	}
};

"use strict";

/* removed: var _$is_595 = require("../prototype/is"); */;

var _$is_587 = function (value) {
	if (typeof value !== "function") return false;

	if (!hasOwnProperty.call(value, "length")) return false;

	try {
		if (typeof value.length !== "number") return false;
		if (typeof value.call !== "function") return false;
		if (typeof value.apply !== "function") return false;
	} catch (error) {
		return false;
	}

	return !_$is_595(value);
};

"use strict";

/* removed: var _$is_587 = require("../function/is"); */;

var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;

var _$is_594 = function (value) {
	if (!_$is_587(value)) return false;
	if (classRe.test(functionToString.call(value))) return false;
	return true;
};

"use strict";

var _$isImplemented_272 = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
};

"use strict";

var _$isImplemented_322 = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};

"use strict";

/* removed: var _$isValue_318 = require("../is-value"); */;

var keys = Object.keys;

var _$shim_323 = function (object) { return keys(_$isValue_318(object) ? Object(object) : object); };

"use strict";

var _$keys_321 = _$isImplemented_322() ? Object.keys : _$shim_323;

"use strict";

/* removed: var _$isValue_318 = require("./is-value"); */;

var _$validValue_340 = function (value) {
	if (!_$isValue_318(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};

"use strict";

var max   = Math.max;

var _$shim_273 = function (dest, src /*, …srcn*/) {
	var error, i, length = max(arguments.length, 2), assign;
	dest = Object(_$validValue_340(dest));
	assign = function (key) {
		try {
			dest[key] = src[key];
		} catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < length; ++i) {
		src = arguments[i];
		_$keys_321(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};

"use strict";

var _$assign_271 = _$isImplemented_272() ? Object.assign : _$shim_273;

"use strict";

/* removed: var _$isValue_318 = require("./is-value"); */;

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

// eslint-disable-next-line no-unused-vars
var _$normalizeOptions_328 = function (opts1 /*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (!_$isValue_318(options)) return;
		process(Object(options), result);
	});
	return result;
};

"use strict";

var str = "razdwatrzy";

var _$isImplemented_384 = function () {
	if (typeof str.contains !== "function") return false;
	return str.contains("dwa") === true && str.contains("foo") === false;
};

"use strict";

var indexOf = String.prototype.indexOf;

var _$shim_385 = function (searchString /*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};

"use strict";

var _$contains_383 = _$isImplemented_384() ? String.prototype.contains : _$shim_385;

var _$d_15 = {};
"use strict";

/* removed: var _$contains_383        = require("es5-ext/string/#/contains"); */;

var d = (_$d_15 = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if (arguments.length < 2 || typeof dscr !== "string") {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (_$is_599(dscr)) {
		c = _$contains_383.call(dscr, "c");
		e = _$contains_383.call(dscr, "e");
		w = _$contains_383.call(dscr, "w");
	} else {
		c = w = true;
		e = false;
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : _$assign_271(_$normalizeOptions_328(options), desc);
});

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== "string") {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (!_$is_599(get)) {
		get = undefined;
	} else if (!_$is_594(get)) {
		options = get;
		get = set = undefined;
	} else if (!_$is_599(set)) {
		set = undefined;
	} else if (!_$is_594(set)) {
		options = set;
		set = undefined;
	}
	if (_$is_599(dscr)) {
		c = _$contains_383.call(dscr, "c");
		e = _$contains_383.call(dscr, "e");
	} else {
		c = true;
		e = false;
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : _$assign_271(_$normalizeOptions_328(options), desc);
};

"use strict";

var _$isSymbol_428 = function (value) {
	if (!value) return false;
	if (typeof value === "symbol") return true;
	if (!value.constructor) return false;
	if (value.constructor.name !== "Symbol") return false;
	return value[value.constructor.toStringTag] === "Symbol";
};

"use strict";

/* removed: var _$isSymbol_428 = require("./is-symbol"); */;

var _$validateSymbol_433 = function (value) {
	if (!_$isSymbol_428(value)) throw new TypeError(value + " is not a symbol");
	return value;
};

"use strict";

/* removed: var _$d_15 = require("d"); */;

var __create_429 = Object.create, defineProperty = Object.defineProperty, objPrototype = Object.prototype;

var created = __create_429(null);
var _$generateName_429 = function (desc) {
	var postfix = 0, name, ie11BugWorkaround;
	while (created[desc + (postfix || "")]) ++postfix;
	desc += postfix || "";
	created[desc] = true;
	name = "@@" + desc;
	defineProperty(
		objPrototype, name,
		_$d_15.gs(null, function (value) {
			// For IE11 issue see:
			// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
			//    ie11-broken-getters-on-dom-objects
			// https://github.com/medikoo/es6-symbol/issues/12
			if (ie11BugWorkaround) return;
			ie11BugWorkaround = true;
			defineProperty(this, name, _$d_15(value));
			ie11BugWorkaround = false;
		})
	);
	return name;
};

"use strict";

var NativeSymbol = _$globalThis_444.Symbol;

var _$standardSymbols_430 = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		// To ensure proper interoperability with other native functions (e.g. Array.from)
		// fallback to eventual native implementation of given symbol
		hasInstance: _$d_15(
			"", (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill("hasInstance")
		),
		isConcatSpreadable: _$d_15(
			"",
			(NativeSymbol && NativeSymbol.isConcatSpreadable) ||
				SymbolPolyfill("isConcatSpreadable")
		),
		iterator: _$d_15("", (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill("iterator")),
		match: _$d_15("", (NativeSymbol && NativeSymbol.match) || SymbolPolyfill("match")),
		replace: _$d_15("", (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill("replace")),
		search: _$d_15("", (NativeSymbol && NativeSymbol.search) || SymbolPolyfill("search")),
		species: _$d_15("", (NativeSymbol && NativeSymbol.species) || SymbolPolyfill("species")),
		split: _$d_15("", (NativeSymbol && NativeSymbol.split) || SymbolPolyfill("split")),
		toPrimitive: _$d_15(
			"", (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill("toPrimitive")
		),
		toStringTag: _$d_15(
			"", (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill("toStringTag")
		),
		unscopables: _$d_15(
			"", (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill("unscopables")
		)
	});
};

"use strict";

/* removed: var _$validateSymbol_433 = require("../../../validate-symbol"); */;

var registry = Object.create(null);

var _$symbolRegistry_431 = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		for: _$d_15(function (key) {
			if (registry[key]) return registry[key];
			return (registry[key] = SymbolPolyfill(String(key)));
		}),
		keyFor: _$d_15(function (symbol) {
			var key;
			_$validateSymbol_433(symbol);
			for (key in registry) {
				if (registry[key] === symbol) return key;
			}
			return undefined;
		})
	});
};

// ES2015 Symbol polyfill for environments that do not (or partially) support it

"use strict";

var __NativeSymbol_432         = _$globalThis_444.Symbol;

var __create_432 = Object.create
  , defineProperties = Object.defineProperties
  , __defineProperty_432 = Object.defineProperty;

var SymbolPolyfill, HiddenSymbol, isNativeSafe;

if (typeof __NativeSymbol_432 === "function") {
	try {
		String(__NativeSymbol_432());
		isNativeSafe = true;
	} catch (ignore) {}
} else {
	__NativeSymbol_432 = null;
}

// Internal constructor (not one exposed) for creating Symbol instances.
// This one is used to ensure that `someSymbol instanceof Symbol` always return false
HiddenSymbol = function Symbol(description) {
	if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
	return SymbolPolyfill(description);
};

// Exposed `Symbol` constructor
// (returns instances of HiddenSymbol)
var _$polyfill_432 = SymbolPolyfill = function Symbol(description) {
	var symbol;
	if (this instanceof Symbol) throw new TypeError("Symbol is not a constructor");
	if (isNativeSafe) return __NativeSymbol_432(description);
	symbol = __create_432(HiddenSymbol.prototype);
	description = description === undefined ? "" : String(description);
	return defineProperties(symbol, {
		__description__: _$d_15("", description),
		__name__: _$d_15("", _$generateName_429(description))
	});
};

_$standardSymbols_430(SymbolPolyfill);
_$symbolRegistry_431(SymbolPolyfill);

// Internal tweaks for real symbol producer
defineProperties(HiddenSymbol.prototype, {
	constructor: _$d_15(SymbolPolyfill),
	toString: _$d_15("", function () { return this.__name__; })
});

// Proper implementation of methods exposed on Symbol.prototype
// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
defineProperties(SymbolPolyfill.prototype, {
	toString: _$d_15(function () { return "Symbol (" + _$validateSymbol_433(this).__description__ + ")"; }),
	valueOf: _$d_15(function () { return _$validateSymbol_433(this); })
});
__defineProperty_432(
	SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive,
	_$d_15("", function () {
		var symbol = _$validateSymbol_433(this);
		if (typeof symbol === "symbol") return symbol;
		return symbol.toString();
	})
);
__defineProperty_432(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, _$d_15("c", "Symbol"));

// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
__defineProperty_432(
	HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
	_$d_15("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag])
);

// Note: It's important to define `toPrimitive` as last one, as some implementations
// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
// And that may invoke error in definition flow:
// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
__defineProperty_432(
	HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
	_$d_15("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive])
);

"use strict";

var _$es6Symbol_es6Symbol = _$isImplemented_427()
	? _$globalThis_444.Symbol
	: _$polyfill_432;

"use strict";

var iteratorSymbol = _$es6Symbol_es6Symbol.iterator;

var _$isImplemented_62 = function () {
	var arr = ["foo", 1], iterator, result;
	if (typeof arr[iteratorSymbol] !== "function") return false;
	iterator = arr[iteratorSymbol]();
	if (!iterator) return false;
	if (typeof iterator.next !== "function") return false;
	result = iterator.next();
	if (!result) return false;
	if (result.value !== "foo") return false;
	if (result.done !== false) return false;
	return true;
};

"use strict";

var __create_333 = Object.create, getPrototypeOf = Object.getPrototypeOf, plainObject = {};

var _$isImplemented_333 = function (/* CustomCreate*/) {
	var setPrototypeOf = Object.setPrototypeOf, customCreate = arguments[0] || __create_333;
	if (typeof setPrototypeOf !== "function") return false;
	return getPrototypeOf(setPrototypeOf(customCreate(null), plainObject)) === plainObject;
};

"use strict";

/* removed: var _$isValue_318 = require("./is-value"); */;

var map = { function: true, object: true };

var _$isObject_313 = function (value) { return (_$isValue_318(value) && map[typeof value]) || false; };

"use strict";

var _$setPrototypeOf_332 = _$isImplemented_333() ? Object.setPrototypeOf : _$shim_334({});

// Inspired by Google Closure:
// http://closure-library.googlecode.com/svn/docs/
// closure_goog_array_array.js.html#goog.array.clear

"use strict";

/* removed: var _$validValue_340 = require("../../object/valid-value"); */;

var _$clear_66 = function () {
	_$validValue_340(this).length = 0;
	return this;
};

"use strict";

var _$validCallable_338 = function (fn) {
	if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
	return fn;
};

"use strict";

/* removed: var _$is_592 = require("../object/is"); */;

var objectToString = Object.prototype.toString;

var _$coerce_596 = function (value) {
	if (!_$is_599(value)) return null;
	if (_$is_592(value)) {
		// Reject Object.prototype.toString coercion
		var valueToString = value.toString;
		if (typeof valueToString !== "function") return null;
		if (valueToString === objectToString) return null;
		// Note: It can be object coming from other realm, still as there's no ES3 and CSP compliant
		// way to resolve its realm's Object.prototype.toString it's left as not addressed edge case
	}
	try {
		return "" + value; // Ensure implicit coercion
	} catch (error) {
		return null;
	}
};

"use strict";

var _$safeToString_590 = function (value) {
	try {
		return value.toString();
	} catch (error) {
		try { return String(value); }
		catch (error2) { return null; }
	}
};

"use strict";

/* removed: var _$safeToString_590 = require("./safe-to-string"); */;

var __reNewLine_591 = /[\n\r\u2028\u2029]/g;

var _$toShortString_591 = function (value) {
	var string = _$safeToString_590(value);
	if (string === null) return "<Non-coercible to string value>";
	// Trim if too long
	if (string.length > 100) string = string.slice(0, 99) + "…";
	// Replace eventual new lines
	string = string.replace(__reNewLine_591, function (char) {
		switch (char) {
			case "\n":
				return "\\n";
			case "\r":
				return "\\r";
			case "\u2028":
				return "\\u2028";
			case "\u2029":
				return "\\u2029";
			/* istanbul ignore next */
			default:
				throw new Error("Unexpected character");
		}
	});
	return string;
};

"use strict";

/* removed: var _$toShortString_591 = require("./to-short-string"); */;

var _$resolveErrorMessage_588 = function (errorMessage, value, inputOptions) {
	if (inputOptions && inputOptions.errorMessage) {
		errorMessage = _$coerce_596(inputOptions.errorMessage);
	}

	var valueInsertIndex = errorMessage.indexOf("%v");
	var valueToken = valueInsertIndex > -1 ? _$toShortString_591(value) : null;
	if (inputOptions && inputOptions.name) {
		var nameInsertIndex = errorMessage.indexOf("%n");
		if (nameInsertIndex > -1) {
			if (valueInsertIndex > -1) {
				var firstToken, secondToken, firstInsertIndex, secondInsertIndex;
				if (nameInsertIndex > valueInsertIndex) {
					firstToken = valueToken;
					firstInsertIndex = valueInsertIndex;
					secondToken = inputOptions.name;
					secondInsertIndex = nameInsertIndex;
				} else {
					firstToken = inputOptions.name;
					firstInsertIndex = nameInsertIndex;
					secondToken = valueToken;
					secondInsertIndex = valueInsertIndex;
				}
				return (
					errorMessage.slice(0, firstInsertIndex) +
					firstToken +
					errorMessage.slice(firstInsertIndex + 2, secondInsertIndex) +
					secondToken +
					errorMessage.slice(secondInsertIndex + 2)
				);
			}
			return (
				errorMessage.slice(0, nameInsertIndex) +
				inputOptions.name +
				errorMessage.slice(nameInsertIndex + 2)
			);
		}
	}
	if (valueInsertIndex > -1) {
		return (
			errorMessage.slice(0, valueInsertIndex) +
			valueToken +
			errorMessage.slice(valueInsertIndex + 2)
		);
	}
	return errorMessage;
};

"use strict";

/* removed: var _$resolveErrorMessage_588 = require("./resolve-error-message"); */;

var _$resolveException_589 = function (value, defaultMessage, inputOptions) {
	if (inputOptions && !_$is_599(value)) {
		if ("default" in inputOptions) return inputOptions["default"];
		if (inputOptions.isOptional) return null;
	}
	var ErrorConstructor = (inputOptions && inputOptions.Error) || TypeError;
	var error = new ErrorConstructor(_$resolveErrorMessage_588(defaultMessage, value, inputOptions));
	if (inputOptions && inputOptions.errorCode) error.code = inputOptions.errorCode;
	throw error;
};

"use strict";

/* removed: var _$is_599               = require("./is"); */;

var _$ensure_598 = function (value/*, options*/) {
	if (_$is_599(value)) return value;
	var options = arguments[1];
	var errorMessage =
		options && options.name ? "Expected a value for %n, received %v" : "Cannot use %v";
	return _$resolveException_589(value, errorMessage, options);
};

"use strict";

/* removed: var _$is_594               = require("./is"); */;

var _$ensure_593 = function (value/*, options*/) {
	if (_$is_594(value)) return value;
	var options = arguments[1];
	var errorMessage =
		options && options.name
			? "Expected a plain function for %n, received %v"
			: "%v is not a plain function";
	return _$resolveException_589(value, errorMessage, options);
};

"use strict";

var _$isImplemented_130 = function () {
	var from = Array.from, arr, result;
	if (typeof from !== "function") return false;
	arr = ["raz", "dwa"];
	result = from(arr);
	return Boolean(result && result !== arr && result[1] === "dwa");
};

"use strict";

var objToString = Object.prototype.toString
  , id = objToString.call((function () { return arguments; })());

var _$isArguments_175 = function (value) { return objToString.call(value) === id; };

"use strict";

var __objToString_176 = Object.prototype.toString
  , isFunctionStringTag = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);

var _$isFunction_176 = function (value) {
	return typeof value === "function" && isFunctionStringTag(__objToString_176.call(value));
};

"use strict";

var _$isImplemented_235 = function () {
	var sign = Math.sign;
	if (typeof sign !== "function") return false;
	return sign(10) === 1 && sign(-20) === -1;
};

"use strict";

var _$shim_236 = function (value) {
	value = Number(value);
	if (isNaN(value) || value === 0) return value;
	return value > 0 ? 1 : -1;
};

"use strict";

var _$sign_234 = _$isImplemented_235() ? Math.sign : _$shim_236;

"use strict";

var abs   = Math.abs
  , floor = Math.floor;

var _$toInteger_266 = function (value) {
	if (isNaN(value)) return 0;
	value = Number(value);
	if (value === 0 || !isFinite(value)) return value;
	return _$sign_234(value) * floor(abs(value));
};

"use strict";

var __max_267       = Math.max;

var _$toPosInteger_267 = function (value) { return __max_267(0, _$toInteger_266(value)); };

"use strict";

var __objToString_413 = Object.prototype.toString, __id_413 = __objToString_413.call("");

var _$isString_413 = function (value) {
	return (
		typeof value === "string" ||
		(value &&
			typeof value === "object" &&
			(value instanceof String || __objToString_413.call(value) === __id_413)) ||
		false
	);
};

"use strict";

var __iteratorSymbol_131 = _$es6Symbol_es6Symbol.iterator
  , isArray        = Array.isArray
  , call           = Function.prototype.call
  , desc           = { configurable: true, enumerable: true, writable: true, value: null }
  , __defineProperty_131 = Object.defineProperty;

// eslint-disable-next-line complexity, max-lines-per-function
var _$shim_131 = function (arrayLike /*, mapFn, thisArg*/) {
	var mapFn = arguments[1]
	  , thisArg = arguments[2]
	  , Context
	  , i
	  , j
	  , arr
	  , length
	  , code
	  , iterator
	  , result
	  , getIterator
	  , value;

	arrayLike = Object(_$validValue_340(arrayLike));

	if (_$isValue_318(mapFn)) _$validCallable_338(mapFn);
	if (!this || this === Array || !_$isFunction_176(this)) {
		// Result: Plain array
		if (!mapFn) {
			if (_$isArguments_175(arrayLike)) {
				// Source: Arguments
				length = arrayLike.length;
				if (length !== 1) return Array.apply(null, arrayLike);
				arr = new Array(1);
				arr[0] = arrayLike[0];
				return arr;
			}
			if (isArray(arrayLike)) {
				// Source: Array
				arr = new Array((length = arrayLike.length));
				for (i = 0; i < length; ++i) arr[i] = arrayLike[i];
				return arr;
			}
		}
		arr = [];
	} else {
		// Result: Non plain array
		Context = this;
	}

	if (!isArray(arrayLike)) {
		if ((getIterator = arrayLike[__iteratorSymbol_131]) !== undefined) {
			// Source: Iterator
			iterator = _$validCallable_338(getIterator).call(arrayLike);
			if (Context) arr = new Context();
			result = iterator.next();
			i = 0;
			while (!result.done) {
				value = mapFn ? call.call(mapFn, thisArg, result.value, i) : result.value;
				if (Context) {
					desc.value = value;
					__defineProperty_131(arr, i, desc);
				} else {
					arr[i] = value;
				}
				result = iterator.next();
				++i;
			}
			length = i;
		} else if (_$isString_413(arrayLike)) {
			// Source: String
			length = arrayLike.length;
			if (Context) arr = new Context();
			for (i = 0, j = 0; i < length; ++i) {
				value = arrayLike[i];
				if (i + 1 < length) {
					code = value.charCodeAt(0);
					// eslint-disable-next-line max-depth
					if (code >= 0xd800 && code <= 0xdbff) value += arrayLike[++i];
				}
				value = mapFn ? call.call(mapFn, thisArg, value, j) : value;
				if (Context) {
					desc.value = value;
					__defineProperty_131(arr, j, desc);
				} else {
					arr[j] = value;
				}
				++j;
			}
			length = j;
		}
	}
	if (length === undefined) {
		// Source: array or array-like
		length = _$toPosInteger_267(arrayLike.length);
		if (Context) arr = new Context(length);
		for (i = 0; i < length; ++i) {
			value = mapFn ? call.call(mapFn, thisArg, arrayLike[i], i) : arrayLike[i];
			if (Context) {
				desc.value = value;
				__defineProperty_131(arr, i, desc);
			} else {
				arr[i] = value;
			}
		}
	}
	if (Context) {
		desc.value = null;
		arr.length = length;
	}
	return arr;
};

"use strict";

var _$from_129 = _$isImplemented_130() ? Array.from : _$shim_131;

"use strict";

/* removed: var _$validValue_340  = require("./valid-value"); */;

var _$copy_278 = function (obj /*, propertyNames, options*/) {
	var copy = Object(_$validValue_340(obj)), propertyNames = arguments[1], options = Object(arguments[2]);
	if (copy !== obj && !propertyNames) return copy;
	var result = {};
	if (propertyNames) {
		_$from_129(propertyNames, function (propertyName) {
			if (options.ensure || propertyName in obj) result[propertyName] = obj[propertyName];
		});
	} else {
		_$assign_271(result, obj);
	}
	return result;
};

// Internal method, used by iteration functions.
// Calls a function for each key-value pair found in object
// Optionally takes compareFn to iterate object in specific order

"use strict";

var bind                    = Function.prototype.bind
  , __call_269                    = Function.prototype.call
  , __keys_269                    = Object.keys
  , objPropertyIsEnumerable = Object.prototype.propertyIsEnumerable;

var _$_iterate_269 = function (method, defVal) {
	return function (obj, cb /*, thisArg, compareFn*/) {
		var list, thisArg = arguments[2], compareFn = arguments[3];
		obj = Object(_$validValue_340(obj));
		_$validCallable_338(cb);

		list = __keys_269(obj);
		if (compareFn) {
			list.sort(typeof compareFn === "function" ? bind.call(compareFn, obj) : undefined);
		}
		if (typeof method !== "function") method = list[method];
		return __call_269.call(method, list, function (key, index) {
			if (!objPropertyIsEnumerable.call(obj, key)) return defVal;
			return __call_269.call(cb, thisArg, obj[key], key, obj, index);
		});
	};
};

"use strict";

var _$forEach_300 = _$_iterate_269("forEach");

"use strict";

var __call_325     = Function.prototype.call;

var _$map_325 = function (obj, cb /*, thisArg*/) {
	var result = {}, thisArg = arguments[2];
	_$validCallable_338(cb);
	_$forEach_300(obj, function (value, key, targetObj, index) {
		result[key] = __call_325.call(cb, thisArg, value, key, targetObj, index);
	});
	return result;
};

"use strict";

/* removed: var _$map_325                 = require("es5-ext/object/map"); */;

var __bind_14 = Function.prototype.bind
  , __defineProperty_14 = Object.defineProperty
  , __hasOwnProperty_14 = Object.prototype.hasOwnProperty
  , __define_14;

__define_14 = function (name, desc, options) {
	var value = _$ensure_598(desc) && _$ensure_593(desc.value), dgs;
	dgs = _$copy_278(desc);
	delete dgs.writable;
	delete dgs.value;
	dgs.get = function () {
		if (!options.overwriteDefinition && __hasOwnProperty_14.call(this, name)) return value;
		desc.value = __bind_14.call(value, options.resolveContext ? options.resolveContext(this) : this);
		__defineProperty_14(this, name, desc);
		return this[name];
	};
	return dgs;
};

var _$autoBind_14 = function (props/*, options*/) {
	var options = _$normalizeOptions_328(arguments[1]);
	if (_$is_599(options.resolveContext)) _$ensure_593(options.resolveContext);
	return _$map_325(props, function (desc, name) { return __define_14(name, desc, options); });
};

"use strict";

/* removed: var _$es6Symbol_es6Symbol   = require("es6-symbol"); */;

var __defineProperty_423 = Object.defineProperty, __defineProperties_423 = Object.defineProperties, Iterator;

var _$es6Iterator_423 = Iterator = function (list, context) {
	if (!(this instanceof Iterator)) throw new TypeError("Constructor requires 'new'");
	__defineProperties_423(this, {
		__list__: _$d_15("w", _$validValue_340(list)),
		__context__: _$d_15("w", context),
		__nextIndex__: _$d_15("w", 0)
	});
	if (!context) return;
	_$validCallable_338(context.on);
	context.on("_add", this._onAdd);
	context.on("_delete", this._onDelete);
	context.on("_clear", this._onClear);
};

// Internal %IteratorPrototype% doesn't expose its constructor
delete Iterator.prototype.constructor;

__defineProperties_423(
	Iterator.prototype,
	_$assign_271(
		{
			_next: _$d_15(function () {
				var i;
				if (!this.__list__) return undefined;
				if (this.__redo__) {
					i = this.__redo__.shift();
					if (i !== undefined) return i;
				}
				if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
				this._unBind();
				return undefined;
			}),
			next: _$d_15(function () {
				return this._createResult(this._next());
			}),
			_createResult: _$d_15(function (i) {
				if (i === undefined) return { done: true, value: undefined };
				return { done: false, value: this._resolve(i) };
			}),
			_resolve: _$d_15(function (i) {
				return this.__list__[i];
			}),
			_unBind: _$d_15(function () {
				this.__list__ = null;
				delete this.__redo__;
				if (!this.__context__) return;
				this.__context__.off("_add", this._onAdd);
				this.__context__.off("_delete", this._onDelete);
				this.__context__.off("_clear", this._onClear);
				this.__context__ = null;
			}),
			toString: _$d_15(function () {
				return "[object " + (this[_$es6Symbol_es6Symbol.toStringTag] || "Object") + "]";
			})
		},
		_$autoBind_14({
			_onAdd: _$d_15(function (index) {
				if (index >= this.__nextIndex__) return;
				++this.__nextIndex__;
				if (!this.__redo__) {
					__defineProperty_423(this, "__redo__", _$d_15("c", [index]));
					return;
				}
				this.__redo__.forEach(function (redo, i) {
					if (redo >= index) this.__redo__[i] = ++redo;
				}, this);
				this.__redo__.push(index);
			}),
			_onDelete: _$d_15(function (index) {
				var i;
				if (index >= this.__nextIndex__) return;
				--this.__nextIndex__;
				if (!this.__redo__) return;
				i = this.__redo__.indexOf(index);
				if (i !== -1) this.__redo__.splice(i, 1);
				this.__redo__.forEach(function (redo, j) {
					if (redo > index) this.__redo__[j] = --redo;
				}, this);
			}),
			_onClear: _$d_15(function () {
				if (this.__redo__) _$clear_66.call(this.__redo__);
				this.__nextIndex__ = 0;
			})
		})
	)
);

__defineProperty_423(
	Iterator.prototype,
	_$es6Symbol_es6Symbol.iterator,
	_$d_15(function () {
		return this;
	})
);

var _$array_420 = {};
"use strict";

/* removed: var _$es6Iterator_423       = require("./"); */;

var __defineProperty_420 = Object.defineProperty, ArrayIterator;

ArrayIterator = _$array_420 = function (arr, kind) {
	if (!(this instanceof ArrayIterator)) throw new TypeError("Constructor requires 'new'");
	_$es6Iterator_423.call(this, arr);
	if (!kind) kind = "value";
	else if (_$contains_383.call(kind, "key+value")) kind = "key+value";
	else if (_$contains_383.call(kind, "key")) kind = "key";
	else kind = "value";
	__defineProperty_420(this, "__kind__", _$d_15("", kind));
};
if (_$setPrototypeOf_332) _$setPrototypeOf_332(ArrayIterator, _$es6Iterator_423);

// Internal %ArrayIteratorPrototype% doesn't expose its constructor
delete ArrayIterator.prototype.constructor;

ArrayIterator.prototype = Object.create(_$es6Iterator_423.prototype, {
	_resolve: _$d_15(function (i) {
		if (this.__kind__ === "value") return this.__list__[i];
		if (this.__kind__ === "key+value") return [i, this.__list__[i]];
		return i;
	})
});
__defineProperty_420(ArrayIterator.prototype, _$es6Symbol_es6Symbol.toStringTag, _$d_15("c", "Array Iterator"));

"use strict";

/* removed: var _$array_420 = require("es6-iterator/array"); */;
var _$shim_125 = function () { return new _$array_420(this, "value"); };

"use strict";

var _$shim_63 = _$shim_125;

"use strict";

var _$Iterator_61 = _$isImplemented_62()
	? Array.prototype[_$es6Symbol_es6Symbol.iterator]
	: _$shim_63;

"use strict";

var __floor_65    = Math.floor;

var _$binarySearch_65 = function (compareFn) {
	var length, low, high, middle;

	_$validValue_340(this);
	_$validCallable_338(compareFn);

	length = _$toPosInteger_267(this.length);
	low = 0;
	high = length - 1;

	while (low <= high) {
		middle = __floor_65((low + high) / 2);
		if (compareFn(this[middle]) < 0) high = middle - 1;
		else low = middle + 1;
	}

	if (high < 0) return 0;
	if (high >= length) return length - 1;
	return high;
};

// Inspired by: http://documentcloud.github.com/underscore/#compact

"use strict";

/* removed: var _$isValue_318 = require("../../object/is-value"); */;

var filter = Array.prototype.filter;

var _$compact_67 = function () {
	return filter.call(this, function (val) { return _$isValue_318(val); });
};

"use strict";

var _$_isExtensible_126 = (function () {
	var SubArray = _$_subArrayDummy_128({})
	  , arr;

	if (!SubArray) return false;
	arr = new SubArray();
	if (!Array.isArray(arr)) return false;
	if (!(arr instanceof SubArray)) return false;

	arr[34] = "foo";
	return arr.length === 35;
})();

"use strict";

/* removed: var _$_isExtensible_126   = require("./_is-extensible"); */;

var _$_subArrayDummySafe_127 = (function () {
	var SubArray;

	if (_$_isExtensible_126) return _$_subArrayDummy_128({});

	if (!_$setPrototypeOf_332) return null;
	SubArray = function () {
		var arr = Array.apply(this, arguments);
		_$setPrototypeOf_332(arr, SubArray.prototype);
		return arr;
	};
	_$setPrototypeOf_332(SubArray, Array);
	SubArray.prototype = Object.create(Array.prototype, {
		constructor: { value: SubArray, enumerable: false, writable: true, configurable: true }
	});
	return SubArray;
})();

"use strict";

/* removed: var _$_subArrayDummySafe_127 = require("../../_sub-array-dummy-safe"); */;

var _$isImplemented_69 = function () { return new _$_subArrayDummySafe_127().concat("foo") instanceof _$_subArrayDummySafe_127; };

"use strict";

var __isArray_134 = Array.isArray, __getPrototypeOf_134 = Object.getPrototypeOf;

var _$isPlainArray_134 = function (obj) {
	var proto;
	if (!obj || !__isArray_134(obj)) return false;
	proto = __getPrototypeOf_134(obj);
	if (!__isArray_134(proto)) return false;
	return !__isArray_134(__getPrototypeOf_134(proto));
};

"use strict";

var isConcatSpreadable = _$es6Symbol_es6Symbol.isConcatSpreadable
  , __isArray_70            = Array.isArray
  , concat             = Array.prototype.concat
  , __forEach_70            = Array.prototype.forEach
  , isSpreadable;

isSpreadable = function (value) {
	if (!value) return false;
	if (!_$isObject_313(value)) return false;
	if (value[isConcatSpreadable] !== undefined) {
		return Boolean(value[isConcatSpreadable]);
	}
	return __isArray_70(value);
};

// eslint-disable-next-line no-unused-vars
var _$shim_70 = function (item /*, …items*/) {
	var result;
	if (!this || !__isArray_70(this) || _$isPlainArray_134(this)) {
		return concat.apply(this, arguments);
	}
	result = new this.constructor();
	if (isSpreadable(this)) {
		__forEach_70.call(this, function (val, i) { result[i] = val; });
	} else {
		result[0] = this;
	}
	__forEach_70.call(arguments, function (arg) {
		var base;
		if (isSpreadable(arg)) {
			base = result.length;
			result.length += _$toPosInteger_267(arg.length);
			__forEach_70.call(arg, function (val, i) { result[base + i] = val; });
			return;
		}
		result.push(arg);
	});
	return result;
};

"use strict";

var _$concat_68 = _$isImplemented_69() ? Array.prototype.concat : _$shim_70;

"use strict";

var _$isImplemented_257 = function () {
	var numberIsNaN = Number.isNaN;
	if (typeof numberIsNaN !== "function") return false;
	return !numberIsNaN({}) && numberIsNaN(NaN) && !numberIsNaN(34);
};

"use strict";

var _$shim_258 = function (value) {
	// eslint-disable-next-line no-self-compare
	return value !== value;
};

"use strict";

var _$isNan_256 = _$isImplemented_257() ? Number.isNaN : _$shim_258;

"use strict";

var __indexOf_76           = Array.prototype.indexOf
  , objHasOwnProperty = Object.prototype.hasOwnProperty
  , __abs_76               = Math.abs
  , __floor_76             = Math.floor;

var _$eIndexOf_76 = function (searchElement /*, fromIndex*/) {
	var i, length, fromIndex, val;
	if (!_$isNan_256(searchElement)) return __indexOf_76.apply(this, arguments);

	length = _$toPosInteger_267(_$validValue_340(this).length);
	fromIndex = arguments[1];
	if (isNaN(fromIndex)) fromIndex = 0;
	else if (fromIndex >= 0) fromIndex = __floor_76(fromIndex);
	else fromIndex = _$toPosInteger_267(this.length) - __floor_76(__abs_76(fromIndex));

	for (i = fromIndex; i < length; ++i) {
		if (objHasOwnProperty.call(this, i)) {
			val = this[i];
			if (_$isNan_256(val)) return i; // Jslint: ignore
		}
	}
	return -1;
};

"use strict";

/* removed: var _$eIndexOf_76 = require("./e-index-of"); */;

var _$contains_71 = function (searchElement /*, position*/) {
	return _$eIndexOf_76.call(this, searchElement, arguments[1]) > -1;
};

"use strict";

var _$isImplemented_73 = function () {
	var arr = [1, 2, 3, 4, 5];
	if (typeof arr.copyWithin !== "function") return false;
	return String(arr.copyWithin(1, 3)) === "1,4,5,4,5";
};

// Taken from: https://github.com/paulmillr/es6-shim/

"use strict";

var __objHasOwnProperty_74 = Object.prototype.hasOwnProperty
  , __max_74               = Math.max
  , min               = Math.min;

var _$shim_74 = function (target, start /*, end*/) {
	var arr = _$validValue_340(this)
	  , end = arguments[2]
	  , length = _$toPosInteger_267(arr.length)
	  , to
	  , from
	  , fin
	  , count
	  , direction;

	target = _$toInteger_266(target);
	start = _$toInteger_266(start);
	end = end === undefined ? length : _$toInteger_266(end);

	to = target < 0 ? __max_74(length + target, 0) : min(target, length);
	from = start < 0 ? __max_74(length + start, 0) : min(start, length);
	fin = end < 0 ? __max_74(length + end, 0) : min(end, length);
	count = min(fin - from, length - to);
	direction = 1;

	if (from < to && to < from + count) {
		direction = -1;
		from += count - 1;
		to += count - 1;
	}
	while (count > 0) {
		if (__objHasOwnProperty_74.call(arr, from)) arr[to] = arr[from];
		else delete arr[from];
		from += direction;
		to += direction;
		count -= 1;
	}
	return arr;
};

"use strict";

var _$copyWithin_72 = _$isImplemented_73() ? Array.prototype.copyWithin : _$shim_74;

"use strict";

var __filter_75   = Array.prototype.filter;

var _$diff_75 = function (other) {
	_$validValue_340(this);
	_$validValue_340(other);
	return __filter_75.call(this, function (item) { return !_$contains_71.call(other, item); });
};

"use strict";

var lastIndexOf       = Array.prototype.lastIndexOf
  , __objHasOwnProperty_77 = Object.prototype.hasOwnProperty
  , __abs_77               = Math.abs
  , __floor_77             = Math.floor;

var _$eLastIndexOf_77 = function (searchElement /*, fromIndex*/) {
	var i, fromIndex, val;
	if (!_$isNan_256(searchElement)) {
		// Jslint: ignore
		return lastIndexOf.apply(this, arguments);
	}

	_$validValue_340(this);
	fromIndex = arguments[1];
	if (isNaN(fromIndex)) fromIndex = _$toPosInteger_267(this.length) - 1;
	else if (fromIndex >= 0) fromIndex = __floor_77(fromIndex);
	else fromIndex = _$toPosInteger_267(this.length) - __floor_77(__abs_77(fromIndex));

	for (i = fromIndex; i >= 0; --i) {
		if (__objHasOwnProperty_77.call(this, i)) {
			val = this[i];
			if (_$isNan_256(val)) return i; // Jslint: ignore
		}
	}
	return -1;
};

"use strict";

var _$isImplemented_79 = function () {
	var arr = [1, "foo"], iterator, result;
	if (typeof arr.entries !== "function") return false;
	iterator = arr.entries();
	if (!iterator) return false;
	if (typeof iterator.next !== "function") return false;
	result = iterator.next();
	if (!result || !result.value) return false;
	if (result.value[0] !== 0) return false;
	if (result.value[1] !== 1) return false;
	if (result.done !== false) return false;
	return true;
};

"use strict";

/* removed: var _$array_420 = require("es6-iterator/array"); */;
var _$shim_80 = function () { return new _$array_420(this, "key+value"); };

"use strict";

var _$entries_78 = _$isImplemented_79() ? Array.prototype.entries : _$shim_80;

"use strict";

var __isArray_138 = Array.isArray;

var _$toArray_138 = function (arrayLike) { return __isArray_138(arrayLike) ? arrayLike : _$from_129(arrayLike); };

// Used internally to sort array of lists by length

"use strict";

/* removed: var _$toPosInteger_267 = require("../../number/to-pos-integer"); */;

var _$_compareByLength_64 = function (arr1, arr2) { return _$toPosInteger_267(arr1.length) - _$toPosInteger_267(arr2.length); };

"use strict";

var __filter_81   = Array.prototype.filter
  , push     = Array.prototype.push;

var _$exclusion_81 = function (/* …lists*/) {
	var lists, seen, result;
	if (!arguments.length) return _$from_129(this);
	push.apply((lists = [this]), arguments);
	lists.forEach(_$validValue_340);
	seen = [];
	result = [];
	lists.sort(_$_compareByLength_64).forEach(function (list) {
		result = result
			.filter(function (item) { return !_$contains_71.call(list, item); })
			.concat(__filter_81.call(list, function (item) { return !_$contains_71.call(seen, item); }));
		push.apply(seen, _$toArray_138(list));
	});
	return result;
};

"use strict";

var _$isImplemented_83 = function () {
	var arr = [1, 2, 3, 4, 5, 6];
	if (typeof arr.fill !== "function") return false;
	return String(arr.fill(-1, -3)) === "1,2,3,-1,-1,-1";
};

// Taken from: https://github.com/paulmillr/es6-shim/

"use strict";

var __max_84        = Math.max
  , __min_84        = Math.min;

var _$shim_84 = function (value /*, start, end*/) {
	var arr = _$validValue_340(this)
	  , start = arguments[1]
	  , end = arguments[2]
	  , length = _$toPosInteger_267(arr.length)
	  , relativeStart
	  , i;

	start = start === undefined ? 0 : _$toInteger_266(start);
	end = end === undefined ? length : _$toInteger_266(end);

	relativeStart = start < 0 ? __max_84(length + start, 0) : __min_84(start, length);
	for (i = relativeStart; i < length && i < end; ++i) arr[i] = value;
	return arr;
};

"use strict";

var _$fill_82 = _$isImplemented_83() ? Array.prototype.fill : _$shim_84;

"use strict";

var pass     = function () { return true; };

var _$isImplemented_86 = function () { return new _$_subArrayDummySafe_127().filter(pass) instanceof _$_subArrayDummySafe_127; };

"use strict";

var __isArray_87      = Array.isArray
  , __filter_87       = Array.prototype.filter
  , __forEach_87      = Array.prototype.forEach
  , __call_87         = Function.prototype.call;

var _$shim_87 = function (callbackFn /*, thisArg*/) {
	var result, thisArg, i;
	if (!this || !__isArray_87(this) || _$isPlainArray_134(this)) {
		return __filter_87.apply(this, arguments);
	}
	_$validCallable_338(callbackFn);
	thisArg = arguments[1];
	result = new this.constructor();
	i = 0;
	__forEach_87.call(this, function (val, j, self) {
		if (__call_87.call(callbackFn, thisArg, val, j, self)) result[i++] = val;
	});
	return result;
};

"use strict";

var _$filter_85 = _$isImplemented_86() ? Array.prototype.filter : _$shim_87;

"use strict";

var fn = function (value) { return value > 3; };

var _$isImplemented_92 = function () {
	var arr = [1, 2, 3, 4, 5, 6];
	if (typeof arr.find !== "function") return false;
	return arr.find(fn) === 4;
};

"use strict";

var some        = Array.prototype.some
  , apply       = Function.prototype.apply;

var _$shim_90 = function (predicate /*, thisArg*/) {
	var k, self;
	self = Object(_$validValue_340(this));
	_$validCallable_338(predicate);

	return some.call(
		self,
		function (value, index) {
			if (apply.call(predicate, this, arguments)) {
				k = index;
				return true;
			}
			return false;
		},
		arguments[1]
	)
		? k
		: -1;
};

"use strict";

/* removed: var _$shim_90 = require("../find-index/shim"); */;

// eslint-disable-next-line no-unused-vars
var _$shim_93 = function (predicate /*, thisArg*/) {
	var index = _$shim_90.apply(this, arguments);
	return index === -1 ? undefined : this[index];
};

"use strict";

var _$find_91 = _$isImplemented_92() ? Array.prototype.find : _$shim_93;

"use strict";

var __fn_89 = function (value) { return value > 3; };

var _$isImplemented_89 = function () {
	var arr = [1, 2, 3, 4, 5, 6];
	if (typeof arr.findIndex !== "function") return false;
	return arr.findIndex(__fn_89) === 3;
};

"use strict";

var _$findIndex_88 = _$isImplemented_89() ? Array.prototype.findIndex : _$shim_90;

"use strict";

var __objHasOwnProperty_94 = Object.prototype.hasOwnProperty;

var _$firstIndex_94 = function () {
	var i, length;
	if (!(length = _$toPosInteger_267(_$validValue_340(this).length))) return null;
	i = 0;
	while (!__objHasOwnProperty_94.call(this, i)) {
		if (++i === length) return null;
	}
	return i;
};

"use strict";

/* removed: var _$firstIndex_94 = require("./first-index"); */;

var _$first_95 = function () {
	var i;
	if ((i = _$firstIndex_94.call(this)) !== null) return this[i];
	return undefined;
};

// Stack grow safe implementation

"use strict";

var __isArray_96           = Array.isArray
  , __objHasOwnProperty_96 = Object.prototype.hasOwnProperty;

var _$flatten_96 = function () {
	var input = _$validValue_340(this), index = 0, remaining, remainingIndexes, length, i, result = [];
	// Jslint: ignore
	main: while (input) {
		length = input.length;
		for (i = index; i < length; ++i) {
			if (!__objHasOwnProperty_96.call(input, i)) continue;
			if (__isArray_96(input[i])) {
				if (i < length - 1) {
					// eslint-disable-next-line max-depth
					if (!remaining) {
						remaining = [];
						remainingIndexes = [];
					}
					remaining.push(input);
					remainingIndexes.push(i + 1);
				}
				input = input[i];
				index = 0;
				continue main;
			}
			result.push(input[i]);
		}
		if (remaining) {
			input = remaining.pop();
			index = remainingIndexes.pop();
		} else {
			input = null;
		}
	}
	return result;
};

"use strict";

var __objHasOwnProperty_97 = Object.prototype.hasOwnProperty
  , __call_97              = Function.prototype.call;

var _$forEachRight_97 = function (cb /*, thisArg*/) {
	var i, self, thisArg;

	self = Object(_$validValue_340(this));
	_$validCallable_338(cb);
	thisArg = arguments[1];

	for (i = _$toPosInteger_267(self.length) - 1; i >= 0; --i) {
		if (__objHasOwnProperty_97.call(self, i)) __call_97.call(cb, thisArg, self[i], i, self);
	}
};

"use strict";

var _$isImplemented_106 = function () {
	var arr = [1, "foo"], iterator, result;
	if (typeof arr.keys !== "function") return false;
	iterator = arr.keys();
	if (!iterator) return false;
	if (typeof iterator.next !== "function") return false;
	result = iterator.next();
	if (!result) return false;
	if (result.value !== 0) return false;
	if (result.done !== false) return false;
	return true;
};

"use strict";

/* removed: var _$array_420 = require("es6-iterator/array"); */;
var _$shim_107 = function () { return new _$array_420(this, "key"); };

"use strict";

var _$keys_105 = _$isImplemented_106() ? Array.prototype.keys : _$shim_107;

// Inspired by Underscore's groupBy:
// http://documentcloud.github.com/underscore/#groupBy

"use strict";

var __forEach_98  = Array.prototype.forEach
  , __apply_98    = Function.prototype.apply;

var _$group_98 = function (cb /*, thisArg*/) {
	var result;

	_$validValue_340(this);
	_$validCallable_338(cb);

	result = Object.create(null);
	__forEach_98.call(
		this,
		function (item) {
			var key = __apply_98.call(cb, this, arguments);
			if (!result[key]) result[key] = [];
			result[key].push(item);
		},
		arguments[1]
	);
	return result;
};

"use strict";

/* removed: var _$eIndexOf_76 = require("./e-index-of"); */;

var _$indexesOf_100 = function (value /*, fromIndex*/) {
	var result = [], i, fromIndex = arguments[1];
	while ((i = _$eIndexOf_76.call(this, value, fromIndex)) !== -1) {
		result.push(i);
		fromIndex = i + 1;
	}
	return result;
};

"use strict";

var __filter_101   = Array.prototype.filter
  , __push_101     = Array.prototype.push
  , __slice_101    = Array.prototype.slice;

var _$intersection_101 = function (/* …list*/) {
	var lists;
	if (!arguments.length) __slice_101.call(this);
	__push_101.apply((lists = [this]), arguments);
	lists.forEach(_$validValue_340);
	lists.sort(_$_compareByLength_64);
	return lists.reduce(function (list1, list2) {
		return __filter_101.call(list1, function (item) { return _$contains_71.call(list2, item); });
	});
};

"use strict";

/* removed: var _$isNan_256 = require("../number/is-nan"); */;

var _$eq_293 = function (val1, val2) {
	return val1 === val2 || (_$isNan_256(val1) && _$isNan_256(val2));
};

"use strict";

var __objHasOwnProperty_102 = Object.prototype.hasOwnProperty;

var _$isCopy_102 = function (other) {
	var i, length;
	_$validValue_340(this);
	_$validValue_340(other);
	length = _$toPosInteger_267(this.length);
	if (length !== _$toPosInteger_267(other.length)) return false;
	for (i = 0; i < length; ++i) {
		if (__objHasOwnProperty_102.call(this, i) !== __objHasOwnProperty_102.call(other, i)) {
			return false;
		}
		if (!_$eq_293(this[i], other[i])) return false;
	}
	return true;
};

"use strict";

/* removed: var _$isValue_318    = require("./is-value"); */;

var _$isArrayLike_303 = function (value) {
	return (
		(_$isValue_318(value) &&
			typeof value.length === "number" &&
			// Just checking ((typeof x === 'object') && (typeof x !== 'function'))
			// won't work right for some cases, e.g.:
			// type of instance of NodeList in Safari is a 'function'
			((_$isObject_313(value) && !_$isFunction_176(value)) || typeof value === "string")) ||
		false
	);
};

"use strict";

/* removed: var _$isArrayLike_303       = require("./is-array-like"); */;

var _$ensureArray_281 = function (value) {
	if (_$isArrayLike_303(value)) return value;
	throw new TypeError(_$toShortStringRepresentation_419(value) + " is not a array");
};

"use strict";

/* removed: var _$firstIndex_94  = require("./first-index"); */;

var _$isEmpty_103 = function () { return _$firstIndex_94.call(_$ensureArray_281(this)) === null; };

"use strict";

var every   = Array.prototype.every
  , isFirst;

isFirst = function (value, index) { return _$eIndexOf_76.call(this, value) === index; };

var _$isUniq_104 = function () { return every.call(this, isFirst, this); };

"use strict";

var __objHasOwnProperty_108 = Object.prototype.hasOwnProperty;

var _$lastIndex_108 = function () {
	var i, length;
	if (!(length = _$toPosInteger_267(_$validValue_340(this).length))) return null;
	i = length - 1;
	while (!__objHasOwnProperty_108.call(this, i)) {
		if (--i === -1) return null;
	}
	return i;
};

"use strict";

/* removed: var _$lastIndex_108 = require("./last-index"); */;

var _$last_109 = function () {
	var i;
	if ((i = _$lastIndex_108.call(this)) !== null) return this[i];
	return undefined;
};

"use strict";

var _$identity_172 = function (value) { return value; };

"use strict";

/* removed: var _$_subArrayDummySafe_127 = require("../../_sub-array-dummy-safe"); */;

var _$isImplemented_111 = function () { return new _$_subArrayDummySafe_127().map(_$identity_172) instanceof _$_subArrayDummySafe_127; };

"use strict";

var __isArray_112      = Array.isArray
  , __map_112          = Array.prototype.map
  , __forEach_112      = Array.prototype.forEach
  , __call_112         = Function.prototype.call;

var _$shim_112 = function (callbackFn /*, thisArg*/) {
	var result, thisArg;
	if (!this || !__isArray_112(this) || _$isPlainArray_134(this)) {
		return __map_112.apply(this, arguments);
	}
	_$validCallable_338(callbackFn);
	thisArg = arguments[1];
	result = new this.constructor(this.length);
	__forEach_112.call(this, function (val, i, self) {
		result[i] = __call_112.call(callbackFn, thisArg, val, i, self);
	});
	return result;
};

"use strict";

var _$map_110 = _$isImplemented_111() ? Array.prototype.map : _$shim_112;

"use strict";

var __forEach_113 = Array.prototype.forEach
  , splice  = Array.prototype.splice;

// eslint-disable-next-line no-unused-vars
var _$remove_113 = function (itemToRemove /*, …item*/) {
	__forEach_113.call(
		arguments,
		function (item) {
			var index = _$eIndexOf_76.call(this, item);
			if (index !== -1) splice.call(this, index, 1);
		},
		this
	);
};

"use strict";

var __forEach_114 = Array.prototype.forEach;

var _$separate_114 = function (sep) {
	var result = [];
	__forEach_114.call(this, function (val) { result.push(val, sep); });
	result.pop();
	return result;
};

"use strict";

/* removed: var _$_subArrayDummySafe_127 = require("../../_sub-array-dummy-safe"); */;

var _$isImplemented_116 = function () { return new _$_subArrayDummySafe_127().slice() instanceof _$_subArrayDummySafe_127; };

"use strict";

var __isArray_117           = Array.isArray
  , __slice_117             = Array.prototype.slice
  , __objHasOwnProperty_117 = Object.prototype.hasOwnProperty
  , __max_117               = Math.max;

var _$shim_117 = function (start, end) {
	var length, result, i;
	if (!this || !__isArray_117(this) || _$isPlainArray_134(this)) {
		return __slice_117.apply(this, arguments);
	}
	length = _$toPosInteger_267(this.length);
	start = _$toInteger_266(start);
	if (start < 0) start = __max_117(length + start, 0);
	else if (start > length) start = length;
	if (end === undefined) {
		end = length;
	} else {
		end = _$toInteger_266(end);
		if (end < 0) end = __max_117(length + end, 0);
		else if (end > length) end = length;
	}
	if (start > end) start = end;
	result = new this.constructor(end - start);
	i = 0;
	while (start !== end) {
		if (__objHasOwnProperty_117.call(this, start)) result[i] = this[start];
		++i;
		++start;
	}
	return result;
};

"use strict";

var _$slice_115 = _$isImplemented_116() ? Array.prototype.slice : _$shim_117;

"use strict";

var __objHasOwnProperty_118 = Object.prototype.hasOwnProperty
  , __call_118              = Function.prototype.call;

var _$someRight_118 = function (cb /*, thisArg*/) {
	var i, self, thisArg;
	self = Object(_$validValue_340(this));
	_$validCallable_338(cb);
	thisArg = arguments[1];

	for (i = _$toPosInteger_267(self.length) - 1; i >= 0; --i) {
		if (__objHasOwnProperty_118.call(self, i) && __call_118.call(cb, thisArg, self[i], i, self)) {
			return true;
		}
	}
	return false;
};

"use strict";

/* removed: var _$_subArrayDummySafe_127 = require("../../_sub-array-dummy-safe"); */;

var _$isImplemented_120 = function () { return new _$_subArrayDummySafe_127().splice(0) instanceof _$_subArrayDummySafe_127; };

"use strict";

var __isArray_121      = Array.isArray
  , __splice_121       = Array.prototype.splice
  , __forEach_121      = Array.prototype.forEach;

// eslint-disable-next-line no-unused-vars
var _$shim_121 = function (start, deleteCount /*, …items*/) {
	var arr = __splice_121.apply(this, arguments), result;
	if (!this || !__isArray_121(this) || _$isPlainArray_134(this)) return arr;
	result = new this.constructor(arr.length);
	__forEach_121.call(arr, function (val, i) { result[i] = val; });
	return result;
};

"use strict";

var _$splice_119 = _$isImplemented_120() ? Array.prototype.splice : _$shim_121;

"use strict";

var __filter_122  = Array.prototype.filter
  , __isFirst_122;

__isFirst_122 = function (value, index) { return _$eIndexOf_76.call(this, value) === index; };

var _$uniq_122 = function () { return __filter_122.call(this, __isFirst_122, this); };

"use strict";

var _$isImplemented_124 = function () {
	var arr = ["foo", 1], iterator, result;
	if (typeof arr.values !== "function") return false;
	iterator = arr.values();
	if (!iterator) return false;
	if (typeof iterator.next !== "function") return false;
	result = iterator.next();
	if (!result) return false;
	if (result.value !== "foo") return false;
	if (result.done !== false) return false;
	return true;
};

"use strict";

var _$values_123 = _$isImplemented_124() ? Array.prototype.values : _$shim_125;

"use strict";

var _$_99 = {
	"@@iterator": _$Iterator_61,
	"binarySearch": _$binarySearch_65,
	"clear": _$clear_66,
	"compact": _$compact_67,
	"concat": _$concat_68,
	"contains": _$contains_71,
	"copyWithin": _$copyWithin_72,
	"diff": _$diff_75,
	"eIndexOf": _$eIndexOf_76,
	"eLastIndexOf": _$eLastIndexOf_77,
	"entries": _$entries_78,
	"exclusion": _$exclusion_81,
	"fill": _$fill_82,
	"filter": _$filter_85,
	"find": _$find_91,
	"findIndex": _$findIndex_88,
	"first": _$first_95,
	"firstIndex": _$firstIndex_94,
	"flatten": _$flatten_96,
	"forEachRight": _$forEachRight_97,
	"keys": _$keys_105,
	"group": _$group_98,
	"indexesOf": _$indexesOf_100,
	"intersection": _$intersection_101,
	"isCopy": _$isCopy_102,
	"isEmpty": _$isEmpty_103,
	"isUniq": _$isUniq_104,
	"last": _$last_109,
	"lastIndex": _$lastIndex_108,
	"map": _$map_110,
	"remove": _$remove_113,
	"separate": _$separate_114,
	"slice": _$slice_115,
	"someRight": _$someRight_118,
	"splice": _$splice_119,
	"uniq": _$uniq_122,
	"values": _$values_123
};

"use strict";

var __slice_132    = Array.prototype.slice;

var _$generate_132 = function (length /*, …fill*/) {
	var arr, currentLength;
	length = _$toPosInteger_267(_$validValue_340(length));
	if (length === 0) return [];

	arr = arguments.length < 2 ? [undefined] : __slice_132.call(arguments, 1, 1 + length);

	while ((currentLength = arr.length) < length) {
		arr = arr.concat(arr.slice(0, length - currentLength));
	}
	return arr;
};

"use strict";

var _$isImplemented_136 = function () {
	var of = Array.of, result;
	if (typeof of !== "function") return false;
	result = of("foo", "bar");
	return Boolean(result && result[1] === "bar");
};

"use strict";

var __slice_137          = Array.prototype.slice
  , __defineProperty_137 = Object.defineProperty
  , __desc_137           = { configurable: true, enumerable: true, writable: true, value: null };

var _$shim_137 = function (/* …items*/) {
	var result, i, length;
	if (!this || this === Array || !_$isFunction_176(this)) return __slice_137.call(arguments);
	result = new this((length = arguments.length));
	for (i = 0; i < length; ++i) {
		__desc_137.value = arguments[i];
		__defineProperty_137(result, i, __desc_137);
	}
	__desc_137.value = null;
	result.length = length;
	return result;
};

"use strict";

var _$of_135 = _$isImplemented_136() ? Array.of : _$shim_137;

"use strict";

var __isArray_139 = Array.isArray;

var _$validArray_139 = function (value) {
	if (__isArray_139(value)) return value;
	throw new TypeError(value + " is not an array");
};

"use strict";

var _$array_133 = {
	"#": _$_99,
	"from": _$from_129,
	"generate": _$generate_132,
	"isPlainArray": _$isPlainArray_134,
	"of": _$of_135,
	"toArray": _$toArray_138,
	"validArray": _$validArray_139
};

"use strict";

var __objToString_141 = Object.prototype.toString, __id_141 = __objToString_141.call(true);

var _$isBoolean_141 = function (value) {
	return (
		typeof value === "boolean" ||
		(typeof value === "object" && (value instanceof Boolean || __objToString_141.call(value) === __id_141))
	);
};

"use strict";

var _$boolean_140 = { isBoolean: _$isBoolean_141 };

"use strict";

var getTime = Date.prototype.getTime;

var _$copy_142 = function () { return new Date(getTime.call(this)); };

"use strict";

var getMonth = Date.prototype.getMonth;

var _$daysInMonth_143 = function () {
	switch (getMonth.call(this)) {
		case 1:
			return this.getFullYear() % 4 ? 28 : 29;
		case 3:
		case 5:
		case 8:
		case 10:
			return 30;
		default:
			return 31;
	}
};

"use strict";

var setHours = Date.prototype.setHours;

var _$floorDay_144 = function () {
	setHours.call(this, 0, 0, 0, 0);
	return this;
};

"use strict";

/* removed: var _$floorDay_144 = require("./floor-day"); */;

var _$floorMonth_145 = function () {
	_$floorDay_144.call(this).setDate(1);
	return this;
};

"use strict";

/* removed: var _$floorMonth_145 = require("./floor-month"); */;

var _$floorYear_146 = function () {
	_$floorMonth_145.call(this).setMonth(0);
	return this;
};

"use strict";

var __str_402 = "foo";

var _$isImplemented_402 = function () {
	if (typeof __str_402.repeat !== "function") return false;
	return __str_402.repeat(2) === "foofoo";
};

// Thanks
// @rauchma http://www.2ality.com/2014/01/efficient-string-repeat.html
// @mathiasbynens https://github.com/mathiasbynens/String.prototype.repeat/blob/4a4b567def/repeat.js

"use strict";

/* removed: var _$toInteger_266 = require("../../../number/to-integer"); */;

var _$shim_403 = function (count) {
	var str = String(_$validValue_340(this)), result;
	count = _$toInteger_266(count);
	if (count < 0) throw new RangeError("Count must be >= 0");
	if (!isFinite(count)) throw new RangeError("Count must be < ∞");

	result = "";
	while (count) {
		if (count % 2) result += str;
		if (count > 1) str += str;
		// eslint-disable-next-line no-bitwise
		count >>= 1;
	}
	return result;
};

"use strict";

var _$repeat_401 = _$isImplemented_402() ? String.prototype.repeat : _$shim_403;

"use strict";

var __abs_398       = Math.abs
  , __max_398       = Math.max;

var _$pad_398 = function (fill /*, length*/) {
	var self = String(_$validValue_340(this)), sLength = self.length, length = arguments[1];

	length = isNaN(length) ? 1 : _$toInteger_266(length);
	fill = _$repeat_401.call(String(fill), __abs_398(length));
	if (length >= 0) return fill.slice(0, __max_398(0, length - sLength)) + self;
	return self + (sLength + length >= 0 ? "" : fill.slice(length + sLength));
};

"use strict";

var toFixed  = Number.prototype.toFixed;

var _$pad_247 = function (length /*, precision*/) {
	var precision;
	length = _$toPosInteger_267(length);
	precision = _$toPosInteger_267(arguments[1]);

	return _$pad_398.call(
		precision ? toFixed.call(this, precision) : this, "0",
		length + (precision ? 1 + precision : 0)
	);
};

"use strict";

var __objToString_151 = Object.prototype.toString, __id_151 = __objToString_151.call(new Date());

var _$isDate_151 = function (value) {
	return (
		(value && !isNaN(value) && (value instanceof Date || __objToString_151.call(value) === __id_151)) ||
		false
	);
};

"use strict";

/* removed: var _$isDate_151 = require("./is-date"); */;

var _$validDate_153 = function (value) {
	if (!_$isDate_151(value)) throw new TypeError(value + " is not valid Date object");
	return value;
};

"use strict";

var __call_408       = Function.prototype.call;

var _$formatMethod_408 = function (fmap) {
	fmap = Object(_$validValue_340(fmap));
	return function (pattern) {
		var context = this;
		_$validValue_340(context);
		pattern = String(pattern);
		return pattern.replace(
			/%([a-zA-Z]+)|\\([\u0000-\uffff])/g,
			function (match, token, escapeChar) {
				var t, result;
				if (escapeChar) return escapeChar;
				t = token;
				while (t && !(result = fmap[t])) t = t.slice(0, -1);
				if (!result) return match;
				if (_$isCallable_304(result)) result = __call_408.call(result, context);
				return result + token.slice(t.length);
			}
		);
	};
};

/* eslint id-length: "off" */

"use strict";

var format;

format = _$formatMethod_408({
	Y: function () { return String(this.getFullYear()); },
	y: function () { return String(this.getFullYear()).slice(-2); },
	m: function () { return _$pad_247.call(this.getMonth() + 1, 2); },
	d: function () { return _$pad_247.call(this.getDate(), 2); },
	H: function () { return _$pad_247.call(this.getHours(), 2); },
	M: function () { return _$pad_247.call(this.getMinutes(), 2); },
	S: function () { return _$pad_247.call(this.getSeconds(), 2); },
	L: function () { return _$pad_247.call(this.getMilliseconds(), 3); }
});

var _$format_147 = function (pattern) { return format.call(_$validDate_153(this), pattern); };

"use strict";

var _$_148 = {
	copy: _$copy_142,
	daysInMonth: _$daysInMonth_143,
	floorDay: _$floorDay_144,
	floorMonth: _$floorMonth_145,
	floorYear: _$floorYear_146,
	format: _$format_147
};

"use strict";

var _$isTimeValue_152 = function (value) {
	try { value = Number(value); }
	catch (e) { return false; }
	if (isNaN(value)) return false;
	if (Math.abs(value) > 8.64e15) return false;
	return true;
};

"use strict";

/* removed: var _$isTimeValue_152  = require("./is-time-value"); */;

var _$ensureTimeValue_149 = function (value) {
	if (_$isTimeValue_152(value)) return _$toInteger_266(value);
	throw new TypeError(_$safeToString_372(value) + " is not a valid time value");
};

"use strict";

var _$date_150 = {
	"#": _$_148,
	"ensureTimeValue": _$ensureTimeValue_149,
	"isDate": _$isDate_151,
	"isTimeValue": _$isTimeValue_152,
	"validDate": _$validDate_153
};

"use strict";

var __objToString_158 = Object.prototype.toString, __id_158 = __objToString_158.call(new Error());

var _$isError_158 = function (value) {
	return (value && (value instanceof Error || __objToString_158.call(value) === __id_158)) || false;
};

"use strict";

/* removed: var _$isError_158 = require("./is-error"); */;

var _$validError_159 = function (value) {
	if (!_$isError_158(value)) throw new TypeError(value + " is not an Error object");
	return value;
};

"use strict";

/* removed: var _$validError_159 = require("../valid-error"); */;

var _$throw_155 = function () { throw _$validError_159(this); };

"use strict";

var _$_154 = { throw: _$throw_155 };

var _$custom_156 = {};
"use strict";

var captureStackTrace = Error.captureStackTrace;

_$custom_156 = function (message /*, code, ext*/) {
	var err = new Error(message), code = arguments[1], ext = arguments[2];
	if (!_$isValue_318(ext)) {
		if (_$isObject_313(code)) {
			ext = code;
			code = null;
		}
	}
	if (_$isValue_318(ext)) _$assign_271(err, ext);
	if (_$isValue_318(code)) err.code = code;
	if (captureStackTrace) captureStackTrace(err, _$custom_156);
	return err;
};

"use strict";

var _$error_157 = {
	"#": _$_154,
	"custom": _$custom_156,
	"isError": _$isError_158,
	"validError": _$validError_159
};

"use strict";

/* removed: var _$from_129    = require("../../array/from"); */;

var __apply_160 = Function.prototype.apply
  , __call_160 = Function.prototype.call
  , callFn = function (arg, fn) { return __call_160.call(fn, this, arg); };

var _$compose_160 = function (fnIgnored /*, …fnn*/) {
	var fns, first;
	var args = _$from_129(arguments);
	fns = _$isValue_318(this) ? [this].concat(args) : args;
	fns.forEach(_$validCallable_338);
	fns = fns.reverse();
	first = fns[0];
	fns = fns.slice(1);
	return function (argIgnored) { return fns.reduce(callFn, __apply_160.call(first, this, arguments)); };
};

"use strict";

/* removed: var _$isFunction_176 = require("./is-function"); */;

var _$validFunction_179 = function (value) {
	if (!_$isFunction_176(value)) throw new TypeError(value + " is not a function");
	return value;
};

"use strict";

var mixin         = _$mixin_327({});

var _$copy_161 = function () {
	_$validFunction_179(this);

	var args = [];
	for (var i = 0; i < this.length; ++i) args.push("arg" + (i + 1));
	// eslint-disable-next-line no-new-func
	var fn = new Function(
		"fn",
		"return function " +
			(this.name || "") +
			"(" +
			args.join(", ") +
			") { return fn.apply(this, arguments); };"
	)(this);
	try { mixin(fn, this); }
	catch (ignore) {}
	return fn;
};

var _$_defineLength_170 = {};
"use strict";

/* removed: var _$toPosInteger_267 = require("../number/to-pos-integer"); */;

var test = function (arg1, arg2) { return arg2; };

var __desc_170, __defineProperty_170, generate, __mixin_170;

try {
	Object.defineProperty(test, "length", {
		configurable: true,
		writable: false,
		enumerable: false,
		value: 1
	});
}
catch (ignore) {}

if (test.length === 1) {
	// ES6
	__desc_170 = { configurable: true, writable: false, enumerable: false };
	__defineProperty_170 = Object.defineProperty;
	_$_defineLength_170 = function (fn, length) {
		length = _$toPosInteger_267(length);
		if (fn.length === length) return fn;
		__desc_170.value = length;
		return __defineProperty_170(fn, "length", __desc_170);
	};
} else {
	__mixin_170 = _$mixin_327({});
	generate = (function () {
		var cache = [];
		return function (length) {
			var args, i = 0;
			if (cache[length]) return cache[length];
			args = [];
			while (length--) args.push("a" + (++i).toString(36));
			// eslint-disable-next-line no-new-func
			return new Function(
				"fn",
				"return function (" + args.join(", ") + ") { return fn.apply(this, arguments); };"
			);
		};
	})();
	_$_defineLength_170 = function (src, length) {
		var target;
		length = _$toPosInteger_267(length);
		if (src.length === length) return src;
		target = generate(length)(src);
		try { __mixin_170(target, src); }
		catch (ignore) {}
		return target;
	};
}

"use strict";

var __slice_162        = Array.prototype.slice
  , __apply_162        = Function.prototype.apply
  , curry;

curry = function self(fn, length, preArgs) {
	return _$_defineLength_170(
		function () {
			var args = preArgs
				? preArgs.concat(__slice_162.call(arguments, 0, length - preArgs.length))
				: __slice_162.call(arguments, 0, length);
			return args.length === length ? __apply_162.call(fn, this, args) : self(fn, length, args);
		},
		preArgs ? length - preArgs.length : length
	);
};

var _$curry_162 = function (/* Length*/) {
	var length = arguments[0];
	return curry(_$validCallable_338(this), isNaN(length) ? _$toPosInteger_267(this.length) : _$toPosInteger_267(length));
};

"use strict";

var __apply_164    = Function.prototype.apply;

var _$lock_164 = function (/* …args*/) {
	var fn = _$validCallable_338(this), args = arguments;

	return function () { return __apply_164.call(fn, this, args); };
};

"use strict";

var isClassStr = RegExp.prototype.test.bind(/^\s*class[\s{/}]/)
  , fnToString = Function.prototype.toString;

var _$isPlainFunction_314 = function (fn) {
	if (typeof fn !== "function") return false;
	if (typeof fn.call !== "function") return false;
	if (typeof fn.apply !== "function") return false;
	return !isClassStr(fnToString.call(fn));
};

"use strict";

/* removed: var _$isPlainFunction_314 = require("./is-plain-function"); */;

var _$ensurePlainFunction_286 = function (value) {
	if (!_$isPlainFunction_314(value)) {
		throw new TypeError(_$safeToString_372(value) + " is not a plain function");
	}
	return value;
};

var _$browser_459 = {};
// shim for using process in browser
var __process_459 = _$browser_459 = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

__process_459.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
__process_459.title = 'browser';
__process_459.browser = true;
__process_459.env = {};
__process_459.argv = [];
__process_459.version = ''; // empty string to avoid regexp issues
__process_459.versions = {};

function noop() {}

__process_459.on = noop;
__process_459.addListener = noop;
__process_459.once = noop;
__process_459.off = noop;
__process_459.removeListener = noop;
__process_459.removeAllListeners = noop;
__process_459.emit = noop;
__process_459.prependListener = noop;
__process_459.prependOnceListener = noop;

__process_459.listeners = function (name) { return [] }

__process_459.binding = function (name) {
    throw new Error('process.binding is not supported');
};

__process_459.cwd = function () { return '/' };
__process_459.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
__process_459.umask = function() { return 0; };

var _$nextTick_454 = {};
(function (process,setImmediate){(function (){
'use strict';

var ensureCallable = function (fn) {
	if (typeof fn !== 'function') throw new TypeError(fn + " is not a function");
	return fn;
};

var byObserver = function (Observer) {
	var node = document.createTextNode(''), queue, currentQueue, i = 0;
	new Observer(function () {
		var callback;
		if (!queue) {
			if (!currentQueue) return;
			queue = currentQueue;
		} else if (currentQueue) {
			queue = currentQueue.concat(queue);
		}
		currentQueue = queue;
		queue = null;
		if (typeof currentQueue === 'function') {
			callback = currentQueue;
			currentQueue = null;
			callback();
			return;
		}
		node.data = (i = ++i % 2); // Invoke other batch, to handle leftover callbacks in case of crash
		while (currentQueue) {
			callback = currentQueue.shift();
			if (!currentQueue.length) currentQueue = null;
			callback();
		}
	}).observe(node, { characterData: true });
	return function (fn) {
		ensureCallable(fn);
		if (queue) {
			if (typeof queue === 'function') queue = [queue, fn];
			else queue.push(fn);
			return;
		}
		queue = fn;
		node.data = (i = ++i % 2);
	};
};

_$nextTick_454 = (function () {
	// Node.js
	if ((typeof process === 'object') && process && (typeof process.nextTick === 'function')) {
		return process.nextTick;
	}

	// queueMicrotask
	if (typeof queueMicrotask === "function") {
		return function (cb) { queueMicrotask(ensureCallable(cb)); };
	}

	// MutationObserver
	if ((typeof document === 'object') && document) {
		if (typeof MutationObserver === 'function') return byObserver(MutationObserver);
		if (typeof WebKitMutationObserver === 'function') return byObserver(WebKitMutationObserver);
	}

	// W3C Draft
	// http://dvcs.w3.org/hg/webperf/raw-file/tip/specs/setImmediate/Overview.html
	if (typeof setImmediate === 'function') {
		return function (cb) { setImmediate(ensureCallable(cb)); };
	}

	// Wide available standard
	if ((typeof setTimeout === 'function') || (typeof setTimeout === 'object')) {
		return function (cb) { setTimeout(ensureCallable(cb), 0); };
	}

	return null;
}());

}).call(this)}).call(this,_$browser_459,_$main_586({}).setImmediate)
"use strict";

/* removed: var _$nextTick_454            = require("next-tick"); */;

var __apply_165 = Function.prototype.apply;

var _$microtaskDelay_165 = function () {
	var src = _$ensurePlainFunction_286(this);
	return _$_defineLength_170(function () { _$nextTick_454(__apply_165.bind(src, this, arguments)); }, this.length);
};

"use strict";

var __apply_166        = Function.prototype.apply;

var _$not_166 = function () {
	var fn = _$validCallable_338(this);

	return _$_defineLength_170(function () { return !__apply_166.call(fn, this, arguments); }, fn.length);
};

"use strict";

var __apply_167        = Function.prototype.apply;

var _$partial_167 = function (/* …args*/) {
	var fn = _$validCallable_338(this), args = _$from_129(arguments);

	return _$_defineLength_170(function () {
		return __apply_167.call(fn, this, args.concat(_$from_129(arguments)));
	}, fn.length - args.length);
};

"use strict";

var __apply_168    = Function.prototype.apply;

var _$spread_168 = function () {
	var fn = _$validCallable_338(this);
	return function (args) { return __apply_168.call(fn, this, args); };
};

"use strict";

/* removed: var _$coerce_596           = require("./coerce"); */;

var _$ensure_597 = function (value/*, options*/) {
	var coerced = _$coerce_596(value);
	if (coerced !== null) return coerced;
	var options = arguments[1];
	var errorMessage =
		options && options.name ? "Expected a string for %n, received %v" : "%v is not a string";
	return _$resolveException_589(value, errorMessage, options);
};

"use strict";

var __forEach_329 = Array.prototype.forEach, __create_329 = Object.create;

// eslint-disable-next-line no-unused-vars
var _$primitiveSet_329 = function (arg /*, …args*/) {
	var set = __create_329(null);
	__forEach_329.call(arguments, function (name) { set[name] = true; });
	return set;
};

var _$eventEmitter_441 = {};
'use strict';

var __apply_441 = Function.prototype.apply, __call_441 = Function.prototype.call
  , __create_441 = Object.create, __defineProperty_441 = Object.defineProperty
  , __defineProperties_441 = Object.defineProperties
  , __hasOwnProperty_441 = Object.prototype.hasOwnProperty
  , descriptor = { configurable: true, enumerable: false, writable: true }

  , on, once, off, emit, methods, descriptors, base;

on = function (type, listener) {
	var data;

	_$validCallable_338(listener);

	if (!__hasOwnProperty_441.call(this, '__ee__')) {
		data = descriptor.value = __create_441(null);
		__defineProperty_441(this, '__ee__', descriptor);
		descriptor.value = null;
	} else {
		data = this.__ee__;
	}
	if (!data[type]) data[type] = listener;
	else if (typeof data[type] === 'object') data[type].push(listener);
	else data[type] = [data[type], listener];

	return this;
};

once = function (type, listener) {
	var once, self;

	_$validCallable_338(listener);
	self = this;
	on.call(this, type, once = function () {
		off.call(self, type, once);
		__apply_441.call(listener, this, arguments);
	});

	once.__eeOnceListener__ = listener;
	return this;
};

off = function (type, listener) {
	var data, listeners, candidate, i;

	_$validCallable_338(listener);

	if (!__hasOwnProperty_441.call(this, '__ee__')) return this;
	data = this.__ee__;
	if (!data[type]) return this;
	listeners = data[type];

	if (typeof listeners === 'object') {
		for (i = 0; (candidate = listeners[i]); ++i) {
			if ((candidate === listener) ||
					(candidate.__eeOnceListener__ === listener)) {
				if (listeners.length === 2) data[type] = listeners[i ? 0 : 1];
				else listeners.splice(i, 1);
			}
		}
	} else {
		if ((listeners === listener) ||
				(listeners.__eeOnceListener__ === listener)) {
			delete data[type];
		}
	}

	return this;
};

emit = function (type) {
	var i, l, listener, listeners, args;

	if (!__hasOwnProperty_441.call(this, '__ee__')) return;
	listeners = this.__ee__[type];
	if (!listeners) return;

	if (typeof listeners === 'object') {
		l = arguments.length;
		args = new Array(l - 1);
		for (i = 1; i < l; ++i) args[i - 1] = arguments[i];

		listeners = listeners.slice();
		for (i = 0; (listener = listeners[i]); ++i) {
			__apply_441.call(listener, this, args);
		}
	} else {
		switch (arguments.length) {
		case 1:
			__call_441.call(listeners, this);
			break;
		case 2:
			__call_441.call(listeners, this, arguments[1]);
			break;
		case 3:
			__call_441.call(listeners, this, arguments[1], arguments[2]);
			break;
		default:
			l = arguments.length;
			args = new Array(l - 1);
			for (i = 1; i < l; ++i) {
				args[i - 1] = arguments[i];
			}
			__apply_441.call(listeners, this, args);
		}
	}
};

methods = {
	on: on,
	once: once,
	off: off,
	emit: emit
};

descriptors = {
	on: _$d_15(on),
	once: _$d_15(once),
	off: _$d_15(off),
	emit: _$d_15(emit)
};

base = __defineProperties_441({}, descriptors);

_$eventEmitter_441 = _$eventEmitter_441 = function (o) {
	return (o == null) ? __create_441(base) : __defineProperties_441(Object(o), descriptors);
};
_$eventEmitter_441.methods = methods;

"use strict";

/* removed: var _$isObject_313 = require("./is-object"); */;

var _$validObject_339 = function (value) {
	if (!_$isObject_313(value)) throw new TypeError(value + " is not an Object");
	return value;
};

'use strict';

var __hasOwnProperty_440 = Object.prototype.hasOwnProperty;

var _$allOff_440 = function (emitter/*, type*/) {
	var type = arguments[1], data;

	_$validObject_339(emitter);

	if (type !== undefined) {
		data = __hasOwnProperty_440.call(emitter, '__ee__') && emitter.__ee__;
		if (!data) return;
		if (data[type]) delete data[type];
		return;
	}
	if (__hasOwnProperty_440.call(emitter, '__ee__')) delete emitter.__ee__;
};

"use strict";

/* removed: var _$primitiveSet_329 = require("es5-ext/object/primitive-set"); */;

var _$wsEol_437 = _$primitiveSet_329.apply(null, _$from_129("\n\r\u2028\u2029"));

"use strict";

/* removed: var _$primitiveSet_329 = require("es5-ext/object/primitive-set"); */;

var _$wsInline_438 = _$primitiveSet_329.apply(
	null,
	_$from_129(
		" \f\t\v​\u00a0\u1680​\u180e" +
			"\u2000​\u2001\u2002​\u2003\u2004​\u2005\u2006​\u2007\u2008​\u2009\u200a" +
			"​​​\u202f\u205f​\u3000"
	)
);

"use strict";

/* removed: var _$wsInline_438       = require("./ws-inline"); */;

var _$ws_439 = _$primitiveSet_329.apply(null, Object.keys(_$wsEol_437).concat(Object.keys(_$wsInline_438)));

"use strict";

// Stolen from excellent work by Mathias Bynens, see:
// http://mathiasbynens.be/notes/javascript-properties
// https://github.com/mathiasbynens/mothereff.in/blob/9cd5ec4649db25ae675aec25f428f3ddf3d9a087/js-properties/eff.js#L79

var _$identStartPattern_436 =
	"[\\$A-Z_a-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE" +
	"\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1" +
	"\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA" +
	"\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF" +
	"\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA" +
	"\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950" +
	"\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2" +
	"\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10" +
	"\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E" +
	"\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9" +
	"\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33" +
	"\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90" +
	"\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0" +
	"\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61" +
	"\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1" +
	"\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F" +
	"\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33" +
	"\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F" +
	"\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6" +
	"\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055" +
	"\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD" +
	"\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288" +
	"\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6" +
	"\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C" +
	"\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711" +
	"\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877" +
	"\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB" +
	"\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE" +
	"\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5" +
	"\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59" +
	"\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC" +
	"\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C" +
	"\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F" +
	"\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2" +
	"\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE" +
	"\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE" +
	"\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F" +
	"\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF" +
	"\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B" +
	"\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E" +
	"\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873" +
	"\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF" +
	"\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B" +
	"\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD" +
	"\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26" +
	"\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6" +
	"\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28" +
	"\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D" +
	"\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A" +
	"\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800" +
	"[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D" +
	"\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A" +
	"\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D" +
	"\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05" +
	"\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15" +
	"\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33" +
	"\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55" +
	"\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF" +
	"\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDE00-\uDE11" +
	"\uDE13-\uDE2B\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33" +
	"\uDF35-\uDF39\uDF3D\uDF5D-\uDF61]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE" +
	"\uDE00-\uDE2F\uDE44\uDE80-\uDEAA]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD808" +
	"[\uDC00-\uDF98]|\uD809[\uDC00-\uDC6E]|[\uD80C\uD840-\uD868\uD86A-\uD86C][\uDC00-\uDFFF]|" +
	"\uD80D[\uDC00-\uDC2E]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F" +
	"\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|\uD82C" +
	"[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835" +
	"[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB" +
	"\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39" +
	"\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA" +
	"\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88" +
	"\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03" +
	"\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47" +
	"\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62" +
	"\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B" +
	"\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D" +
	"[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D]|\uD87E[\uDC00-\uDE1D]";

"use strict";

// Stolen from excellent work by Mathias Bynens, see:
// http://mathiasbynens.be/notes/javascript-properties
// https://github.com/mathiasbynens/mothereff.in/blob/9cd5ec4649db25ae675aec25f428f3ddf3d9a087/js-properties/eff.js#L79

var _$identNextPattern_435 =
	"[\\$0-9A-Z_a-z\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC" +
	"\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1" +
	"\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587" +
	"\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A" +
	"\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A" +
	"\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B2\u08E4-\u0963" +
	"\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2" +
	"\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3" +
	"\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33" +
	"\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C" +
	"\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2" +
	"\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF" +
	"\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39" +
	"\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F" +
	"\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F" +
	"\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7" +
	"\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39" +
	"\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F" +
	"\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9" +
	"\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1" +
	"\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48" +
	"\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96" +
	"\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF" +
	"\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87" +
	"\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB" +
	"\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00" +
	"\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84" +
	"\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD" +
	"\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288" +
	"\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6" +
	"\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F" +
	"\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8" +
	"\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773" +
	"\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877" +
	"\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D" +
	"\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E" +
	"\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59" +
	"\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2" +
	"\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D" +
	"\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4" +
	"\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D" +
	"\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107" +
	"\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149" +
	"\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27" +
	"\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE" +
	"\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007" +
	"\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA" +
	"\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5" +
	"\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F" +
	"\uA674-\uA67D\uA67F-\uA69D\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E" +
	"\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7" +
	"\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE" +
	"\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD" +
	"\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26" +
	"\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9" +
	"\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06" +
	"\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44" +
	"\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F" +
	"\uFE20-\uFE2D\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A" +
	"\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|" +
	"\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D" +
	"\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A" +
	"\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D" +
	"\uDCA0-\uDCA9\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802" +
	"[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E" +
	"\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13" +
	"\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7" +
	"\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|" +
	"\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34" +
	"\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDD0-\uDDDA\uDE00-\uDE11\uDE13-\uDE37" +
	"\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF01-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30" +
	"\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF5D-\uDF63" +
	"\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5" +
	"\uDDB8-\uDDC0\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9]|\uD806" +
	"[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF98]|\uD809[\uDC00-\uDC6E]|[\uD80C" +
	"\uD840-\uD868\uD86A-\uD86C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD81A[\uDC00-\uDE38" +
	"\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43" +
	"\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]|" +
	"\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D" +
	"\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD" +
	"\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6" +
	"\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14" +
	"\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5" +
	"\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E" +
	"\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD83A" +
	"[\uDC00-\uDCC4\uDCD0-\uDCD6]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27" +
	"\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52" +
	"\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72" +
	"\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9" +
	"\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E" +
	"[\uDC00-\uDC1D]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]";

"use strict";

/* removed: var _$identNextPattern_435           = require("./lib/ident-next-pattern"); */;

var __objHasOwnProperty_434 = Object.prototype.hasOwnProperty
  , preRegExpSet = _$primitiveSet_329.apply(null, _$from_129(";{=([,<>+-*/%&|^!~?:}"))
  , nonNameSet = _$primitiveSet_329.apply(null, _$from_129(";{=([,<>+-*/%&|^!~?:})].`"))
  , reIdentStart = new RegExp(_$identStartPattern_436)
  , reIdentNext = new RegExp(_$identNextPattern_435);

var code, index, char, state, columnIndex, line, quote, scopeDepth, templateContext, previousToken
  , followsWhitespace, results, followsSkip, collectedScopeDatum, collectedScopeData
  , collectedScopeDepth, commentDatum, shouldCollectComments;

var handleEol = function () {
	if (char === "\r" && code[index + 1] === "\n") char = code[++index];
	columnIndex = index + 1;
	++line;
};

var emitter = _$eventEmitter_441();
var accessor = Object.create(null, {
	skipCodePart: _$d_15(function (codePart) {
		var codePartLength = codePart.length;
		for (var i = 0; i < codePartLength; ++i) {
			if (code[index + i] !== codePart[i]) return false;
		}
		index += codePartLength;
		char = code[index];
		previousToken = code[index - 1];
		followsWhitespace = false;
		followsSkip = true;
		return true;
	}),
	skipIdentifier: _$d_15(function () {
		if (!reIdentStart.test(char)) return null;
		var startIndex = index;
		var identifier = char;
		while ((char = code[++index]) && reIdentNext.test(char)) identifier += char;
		followsWhitespace = false;
		followsSkip = true;
		previousToken = code[index - 1];
		return { name: identifier, start: startIndex, end: index };
	}),
	skipWhitespace: _$d_15(function () {
		while (char) {
			if (__objHasOwnProperty_434.call(_$ws_439, char)) {
				if (__objHasOwnProperty_434.call(_$wsEol_437, char)) handleEol();
			} else if (char === "/") {
				if (code[index + 1] === "/") {
					// Single line comment
					if (shouldCollectComments) {
						commentDatum = {
							type: "comment",
							point: index,
							line: line,
							column: index - columnIndex
						};
					}
					index += 2;
					char = code[index];
					while (char) {
						if (__objHasOwnProperty_434.call(_$wsEol_437, char)) {
							if (commentDatum) {
								commentDatum.endPoint = index;
								results.push(commentDatum);
								commentDatum = null;
							}
							handleEol();
							break;
						}
						char = code[++index];
					}
				} else if (code[index + 1] === "*") {
					if (shouldCollectComments) {
						commentDatum = {
							type: "comment",
							point: index,
							line: line,
							column: index - columnIndex
						};
					}
					index += 2;
					char = code[index];
					while (char) {
						if (__objHasOwnProperty_434.call(_$wsEol_437, char)) handleEol();
						if (char === "*" && code[index + 1] === "/") {
							if (commentDatum) {
								commentDatum.endPoint = index + 2;
								results.push(commentDatum);
								commentDatum = null;
							}
							char = code[++index];
							break;
						}
						char = code[++index];
					}
				} else {
					break;
				}
			} else {
				break;
			}
			followsWhitespace = true;
			followsSkip = true;
			char = code[++index];
		}
	}),
	collectScope: _$d_15(function () {
		if (char !== "(") return;
		previousToken = char;
		char = code[++index];
		followsSkip = true;
		if (collectedScopeDatum) collectedScopeData.push(collectedScopeDepth, collectedScopeDatum);
		collectedScopeDepth = ++scopeDepth;
		collectedScopeDatum = {
			type: "scope",
			point: index + 1,
			line: line,
			column: index - columnIndex + 1
		};
	}),
	stop: _$d_15(function () { state = null; }),
	index: _$d_15.gs(function () { return index; }),
	previousToken: _$d_15.gs(function () { return previousToken; }),
	scopeDepth: _$d_15.gs(function () { return scopeDepth; }),
	shouldCollectComments: _$d_15.gs(
		function () { return shouldCollectComments; },
		function (value) { shouldCollectComments = Boolean(value); }
	)
});

var _$esniff_434 = function (userCode, executor) {
	code = _$ensure_597(userCode);
	executor = _$ensure_593(executor);
	_$allOff_440(emitter);
	executor(emitter, accessor);
	index = -1;
	state = "out";
	columnIndex = 0;
	line = 1;
	scopeDepth = 0;
	templateContext = [];
	previousToken = null;
	followsWhitespace = true;
	results = [];
	followsSkip = false;
	collectedScopeDatum = null;
	collectedScopeData = [];
	collectedScopeDepth = null;

	stateLoop: while (state) {
		if (followsSkip) followsSkip = false;
		else char = code[++index];
		if (!char) break;

		switch (state) {
			case "out":
				if (__objHasOwnProperty_434.call(_$ws_439, char)) {
					if (__objHasOwnProperty_434.call(_$wsEol_437, char)) {
						handleEol();
					}
					followsWhitespace = true;
					continue stateLoop;
				}
				if (char === "/") {
					if (previousToken && __objHasOwnProperty_434.call(preRegExpSet, previousToken)) {
						state = "slashOrRegexp";
					} else {
						state = "slash";
					}
				} else if (char === "'" || char === "\"") {
					state = "string";
					quote = char;
				} else if (char === "`") {
					state = "template";
				} else if (char === "(" || char === "{" || char === "[") {
					++scopeDepth;
				} else if (char === ")" || char === "}" || char === "]") {
					if (scopeDepth === collectedScopeDepth) {
						collectedScopeDatum.raw = code.slice(collectedScopeDatum.point - 1, index);
						results.push(collectedScopeDatum);
						collectedScopeDatum = collectedScopeData.pop();
						collectedScopeDepth = collectedScopeData.pop();
					}
					--scopeDepth;
					if (char === "}") {
						if (templateContext[templateContext.length - 1] === scopeDepth + 1) {
							templateContext.pop();
							state = "template";
						}
					}
				}
				if (
					!previousToken ||
					followsWhitespace ||
					__objHasOwnProperty_434.call(nonNameSet, previousToken) ||
					__objHasOwnProperty_434.call(nonNameSet, char)
				) {
					emitter.emit("trigger:" + char, accessor);
					if (followsSkip) continue stateLoop;
				}
				previousToken = char;
				followsWhitespace = false;
				continue stateLoop;
			case "slashOrRegexp":
			case "slash":
				if (char === "/") {
					if (shouldCollectComments) {
						commentDatum = {
							type: "comment",
							point: index - 1,
							line: line,
							column: index - columnIndex - 1
						};
					}
					state = "singleLineComment";
				} else if (char === "*") {
					if (shouldCollectComments) {
						commentDatum = {
							type: "comment",
							point: index - 1,
							line: line,
							column: index - columnIndex - 1
						};
					}
					state = "multiLineComment";
				} else if (__objHasOwnProperty_434.call(_$wsEol_437, char)) {
					handleEol();
					followsWhitespace = true;
					state = "out";
					continue stateLoop;
				} else if (state === "slashOrRegexp") {
					state = "regexp";
				} else {
					state = "out";
					continue stateLoop;
				}
				break;
			case "singleLineComment":
				if (__objHasOwnProperty_434.call(_$wsEol_437, char)) {
					if (commentDatum) {
						commentDatum.endPoint = index;
						results.push(commentDatum);
						commentDatum = null;
					}
					handleEol();
					followsWhitespace = true;
					state = "out";
				}
				continue stateLoop;
			case "multiLineComment":
				if (char === "*") state = "multiLineCommentStar";
				else if (__objHasOwnProperty_434.call(_$wsEol_437, char)) handleEol();
				continue stateLoop;
			case "multiLineCommentStar":
				if (char === "/") {
					followsWhitespace = true;
					state = "out";
					if (commentDatum) {
						commentDatum.endPoint = index + 1;
						results.push(commentDatum);
						commentDatum = null;
					}
				} else if (char !== "*") {
					if (__objHasOwnProperty_434.call(_$wsEol_437, char)) handleEol();
					state = "multiLineComment";
				}
				continue stateLoop;
			case "string":
				if (char === "\\") state = "stringEscape";
				else if (char === quote) state = "out";
				break;
			case "stringEscape":
				if (__objHasOwnProperty_434.call(_$wsEol_437, char)) handleEol();
				state = "string";
				break;
			case "template":
				if (char === "$") state = "templateDollar";
				else if (char === "\\") state = "templateEscape";
				else if (char === "`") state = "out";
				else if (__objHasOwnProperty_434.call(_$wsEol_437, char)) handleEol();
				break;
			case "templateEscape":
				if (__objHasOwnProperty_434.call(_$wsEol_437, char)) handleEol();
				state = "template";
				break;
			case "templateDollar":
				if (char === "{") {
					templateContext.push(++scopeDepth);
					state = "out";
				} else if (char !== "$") {
					if (__objHasOwnProperty_434.call(_$wsEol_437, char)) handleEol();
					state = "template";
				}
				break;
			case "regexp":
				if (char === "\\") state = "regexpEscape";
				else if (char === "/") state = "out";
				break;
			case "regexpEscape":
				state = "regexp";
				break;
			/* istanbul ignore next */
			default:
				throw new Error("Unexpected state " + state);
		}
		previousToken = null;
		followsWhitespace = false;
	}

	return results;
};

"use strict";

/* removed: var _$validFunction_179 = require("../valid-function"); */;

var __classRe_169 = /^\s*class[\s{/}]/;

var _$toStringTokens_169 = function () {
	var str = String(_$validFunction_179(this));
	if (__classRe_169.test(str)) throw new Error("Class methods are not supported");

	var argsStartIndex
	  , argsEndIndex
	  , bodyStartIndex
	  , bodyEndReverseIndex = -1
	  , shouldTrimArgs = false;

	_$esniff_434(str, function (emitter, accessor) {
		emitter.once("trigger:(", function () { argsStartIndex = accessor.index + 1; });
		emitter.once("trigger:=", function () {
			if (_$isValue_318(argsStartIndex)) return;
			argsStartIndex = 0;
			argsEndIndex = accessor.index;
			shouldTrimArgs = true;
			if (!accessor.skipCodePart("=>")) {
				throw new Error("Unexpected function string: " + str);
			}
			accessor.skipWhitespace();
			if (!accessor.skipCodePart("{")) bodyEndReverseIndex = Infinity;
			bodyStartIndex = accessor.index;
		});
		emitter.on("trigger:)", function () {
			if (accessor.scopeDepth) return;
			argsEndIndex = accessor.index;
			accessor.skipCodePart(")");
			accessor.skipWhitespace();
			if (accessor.skipCodePart("=>")) {
				accessor.skipWhitespace();
				if (!accessor.skipCodePart("{")) bodyEndReverseIndex = Infinity;
			} else if (!accessor.skipCodePart("{")) {
				throw new Error("Unexpected function string: " + str);
			}
			bodyStartIndex = accessor.index;
			accessor.stop();
		});
	});

	var argsString = str.slice(argsStartIndex, argsEndIndex);
	if (shouldTrimArgs) argsString = argsString.trim();
	return { args: argsString, body: str.slice(bodyStartIndex, bodyEndReverseIndex) };
};

"use strict";

var _$_163 = {
	compose: _$compose_160,
	copy: _$copy_161,
	curry: _$curry_162,
	lock: _$lock_164,
	microtaskDelay: _$microtaskDelay_165,
	not: _$not_166,
	partial: _$partial_167,
	spread: _$spread_168,
	toStringTokens: _$toStringTokens_169
};

"use strict";

var _$constant_171 = function (value) {
	return function () { return value; };
};

"use strict";

var __slice_174      = Array.prototype.slice
  , __apply_174      = Function.prototype.apply;

var _$invoke_174 = function (name /*, …args*/) {
	var args = __slice_174.call(arguments, 1), isFn = _$isCallable_304(name);
	return function (obj) {
		_$validValue_340(obj);
		return __apply_174.call(isFn ? name : obj[name], obj, args.concat(__slice_174.call(arguments, 1)));
	};
};

"use strict";

/* removed: var _$validValue_340 = require("../object/valid-value"); */;

var _$pluck_178 = function (name) {
	return function (obj) { return _$validValue_340(obj)[name]; };
};

// Export all modules.

"use strict";

var _$function_173 = {
	"#": _$_163,
	"constant": _$constant_171,
	"identity": _$identity_172,
	"invoke": _$invoke_174,
	"isArguments": _$isArguments_175,
	"isFunction": _$isFunction_176,
	"noop": _$noop_177,
	"pluck": _$pluck_178,
	"validFunction": _$validFunction_179
};

var _$string_425 = {};
// Thanks @mathiasbynens
// http://mathiasbynens.be/notes/javascript-unicode#iterating-over-symbols

"use strict";

/* removed: var _$es6Iterator_423       = require("./"); */;

var __defineProperty_425 = Object.defineProperty, StringIterator;

StringIterator = _$string_425 = function (str) {
	if (!(this instanceof StringIterator)) throw new TypeError("Constructor requires 'new'");
	str = String(str);
	_$es6Iterator_423.call(this, str);
	__defineProperty_425(this, "__length__", _$d_15("", str.length));
};
if (_$setPrototypeOf_332) _$setPrototypeOf_332(StringIterator, _$es6Iterator_423);

// Internal %ArrayIteratorPrototype% doesn't expose its constructor
delete StringIterator.prototype.constructor;

StringIterator.prototype = Object.create(_$es6Iterator_423.prototype, {
	_next: _$d_15(function () {
		if (!this.__list__) return undefined;
		if (this.__nextIndex__ < this.__length__) return this.__nextIndex__++;
		this._unBind();
		return undefined;
	}),
	_resolve: _$d_15(function (i) {
		var char = this.__list__[i], code;
		if (this.__nextIndex__ === this.__length__) return char;
		code = char.charCodeAt(0);
		if (code >= 0xd800 && code <= 0xdbff) return char + this.__list__[this.__nextIndex__++];
		return char;
	})
});
__defineProperty_425(StringIterator.prototype, _$es6Symbol_es6Symbol.toStringTag, _$d_15("c", "String Iterator"));

"use strict";

/* removed: var _$isString_413    = require("es5-ext/string/is-string"); */;

var __iteratorSymbol_424 = _$es6Symbol_es6Symbol.iterator
  , __isArray_424        = Array.isArray;

var _$isIterable_424 = function (value) {
	if (!_$isValue_318(value)) return false;
	if (__isArray_424(value)) return true;
	if (_$isString_413(value)) return true;
	if (_$isArguments_175(value)) return true;
	return typeof value[__iteratorSymbol_424] === "function";
};

"use strict";

/* removed: var _$isIterable_424 = require("./is-iterable"); */;

var _$validIterable_426 = function (value) {
	if (!_$isIterable_424(value)) throw new TypeError(value + " is not iterable");
	return value;
};

"use strict";

var __iteratorSymbol_422 = _$es6Symbol_es6Symbol.iterator;

var _$get_422 = function (obj) {
	if (typeof _$validIterable_426(obj)[__iteratorSymbol_422] === "function") return obj[__iteratorSymbol_422]();
	if (_$isArguments_175(obj)) return new _$array_420(obj);
	if (_$isString_413(obj)) return new _$string_425(obj);
	return new _$array_420(obj);
};

"use strict";

/* removed: var _$get_422         = require("./get"); */;

var __isArray_421 = Array.isArray, __call_421 = Function.prototype.call, __some_421 = Array.prototype.some;

var _$forOf_421 = function (iterable, cb /*, thisArg*/) {
	var mode, thisArg = arguments[2], result, doBreak, broken, i, length, char, code;
	if (__isArray_421(iterable) || _$isArguments_175(iterable)) mode = "array";
	else if (_$isString_413(iterable)) mode = "string";
	else iterable = _$get_422(iterable);

	_$validCallable_338(cb);
	doBreak = function () {
		broken = true;
	};
	if (mode === "array") {
		__some_421.call(iterable, function (value) {
			__call_421.call(cb, thisArg, value, doBreak);
			return broken;
		});
		return;
	}
	if (mode === "string") {
		length = iterable.length;
		for (i = 0; i < length; ++i) {
			char = iterable[i];
			if (i + 1 < length) {
				code = char.charCodeAt(0);
				if (code >= 0xd800 && code <= 0xdbff) char += iterable[++i];
			}
			__call_421.call(cb, thisArg, char, doBreak);
			if (broken) break;
		}
		return;
	}
	result = iterable.next();

	while (!result.done) {
		__call_421.call(cb, thisArg, result.value, doBreak);
		if (broken) return;
		result = iterable.next();
	}
};

"use strict";

var __iteratorSymbol_183 = _$es6Symbol_es6Symbol.iterator;

var _$is_183 = function (value) {
	if (!_$isValue_318(value)) return false;
	if (typeof value[__iteratorSymbol_183] === "function") return true;
	return _$isArrayLike_303(value);
};

"use strict";

/* removed: var _$is_183 = require("./is"); */;

var _$validate_185 = function (value) {
	if (_$is_183(value)) return value;
	throw new TypeError(value + " is not an iterable or array-like");
};

"use strict";

var __forEach_181    = Array.prototype.forEach;

var _$forEach_181 = function (target, cb /*, thisArg*/) {
	if (_$isIterable_424(_$validate_185(target))) _$forOf_421(target, cb, arguments[2]);
	else __forEach_181.call(target, cb, arguments[2]);
};

"use strict";

/* removed: var _$is_183       = require("./is"); */;

var _$validateObject_184 = function (value) {
	if (_$is_183(value) && _$isObject_313(value)) return value;
	throw new TypeError(value + " is not an iterable or array-like object");
};

"use strict";

var _$iterable_182 = {
	forEach: _$forEach_181,
	is: _$is_183,
	validate: _$validate_185,
	validateObject: _$validateObject_184
};

"use strict";

var __call_336      = Function.prototype.call
  , defaultCb = function (value, key) { return [key, value]; };

var _$toArray_336 = function (obj /*, cb, thisArg, compareFn*/) {
	var a = [], cb = arguments[1], thisArg = arguments[2];
	cb = _$isValue_318(cb) ? _$validCallable_338(cb) : defaultCb;

	_$forEach_300(
		obj,
		function (value, key, targetObj, index) {
			a.push(__call_336.call(cb, thisArg, value, key, this, index));
		},
		obj, arguments[3]
	);
	return a;
};

"use strict";

var __isArray_187   = Array.isArray
  , stringify = JSON.stringify;

var _$self_187 = function self(value /*, replacer, space*/) {
	var replacer = arguments[1], space = arguments[2];
	try {
		return stringify(value, replacer, space);
	} catch (e) {
		if (!_$isObject_313(value)) return null;
		if (typeof value.toJSON === "function") return null;
		if (__isArray_187(value)) {
			return (
				"[" +
				_$compact_67.call(value.map(function (item) { return self(item, replacer, space); })) +
				"]"
			);
		}
		return (
			"{" +
			_$compact_67
				.call(
					_$toArray_336(value, function (item, key) {
						item = self(item, replacer, space);
						if (!item) return null;
						return stringify(key) + ":" + item;
					})
				)
				.join(",") +
			"}"
		);
	}
};

"use strict";

var _$json_186 = { safeStringify: _$self_187 };

"use strict";

var _$isImplemented_192 = function () {
	var acosh = Math.acosh;
	if (typeof acosh !== "function") return false;
	return acosh(2) === 1.3169578969248166;
};

"use strict";

var log = Math.log, sqrt = Math.sqrt;

var _$shim_193 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value < 1) return NaN;
	if (value === 1) return 0;
	if (value === Infinity) return value;
	return log(value + sqrt(value * value - 1));
};

"use strict";

var _$acosh_191 = _$isImplemented_192() ? Math.acosh : _$shim_193;

"use strict";

var _$isImplemented_195 = function () {
	var asinh = Math.asinh;
	if (typeof asinh !== "function") return false;
	return asinh(2) === 1.4436354751788103;
};

"use strict";

var __log_196 = Math.log, __sqrt_196 = Math.sqrt;

var _$shim_196 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value === 0) return value;
	if (!isFinite(value)) return value;
	if (value < 0) {
		value = -value;
		return -__log_196(value + __sqrt_196(value * value + 1));
	}
	return __log_196(value + __sqrt_196(value * value + 1));
};

"use strict";

var _$asinh_194 = _$isImplemented_195() ? Math.asinh : _$shim_196;

"use strict";

var _$isImplemented_198 = function () {
	var atanh = Math.atanh;
	if (typeof atanh !== "function") return false;
	return Math.round(atanh(0.5) * 1e15) === 549306144334055;
};

"use strict";

var __log_199 = Math.log;

var _$shim_199 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value < -1) return NaN;
	if (value > 1) return NaN;
	if (value === -1) return -Infinity;
	if (value === 1) return Infinity;
	if (value === 0) return value;
	return 0.5 * __log_199((1 + value) / (1 - value));
};

"use strict";

var _$atanh_197 = _$isImplemented_198() ? Math.atanh : _$shim_199;

"use strict";

var _$isImplemented_201 = function () {
	var cbrt = Math.cbrt;
	if (typeof cbrt !== "function") return false;
	return cbrt(2) === 1.2599210498948732;
};

"use strict";

var pow = Math.pow;

var _$shim_202 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value === 0) return value;
	if (!isFinite(value)) return value;
	if (value < 0) return -pow(-value, 1 / 3);
	return pow(value, 1 / 3);
};

"use strict";

var _$cbrt_200 = _$isImplemented_201() ? Math.cbrt : _$shim_202;

"use strict";

var _$isImplemented_254 = function () {
	var isInteger = Number.isInteger;
	if (typeof isInteger !== "function") return false;
	return !isInteger("23") && isInteger(34) && !isInteger(32.34);
};

// Credit: http://www.2ality.com/2014/05/is-integer.html

"use strict";

var _$shim_255 = function (value) {
	if (typeof value !== "number") return false;
	return value % 1 === 0;
};

"use strict";

var _$isInteger_253 = _$isImplemented_254() ? Number.isInteger : _$shim_255;

"use strict";

/* removed: var _$isValue_318   = require("./is-value"); */;

var _$isInteger_309 = function (arg) {
	if (!_$isValue_318(arg)) return false;
	arg = Number(arg);
	return _$isInteger_253(arg);
};

"use strict";

/* removed: var _$isInteger_309     = require("./is-integer"); */;

var _$ensureInteger_283 = function (num) {
	if (!_$isInteger_309(num)) throw new TypeError(_$toShortStringRepresentation_419(num) + " is not a integer");
	return Number(num);
};

// Credit:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
// #Decimal_rounding

"use strict";

/* removed: var _$ensureInteger_283 = require("../object/ensure-integer"); */;

var split = String.prototype.split;

var _$_decimalAdjust_188 = function (type) {
	return function (value /*, exp*/) {
		value = Number(value);
		var exp = arguments[1];
		if (_$isValue_318(exp)) exp = _$ensureInteger_283(exp);
		if (!value) return value;
		if (!exp) return Math[type](value);
		if (!isFinite(value)) return value;

		// Shift
		var tokens = split.call(value, "e");
		value = Math[type](tokens[0] + "e" + ((tokens[1] || 0) - exp));

		// Shift back
		tokens = value.toString().split("e");
		return Number(tokens[0] + "e" + (Number(tokens[1] || 0) + exp));
	};
};

"use strict";

var _$ceil10_203 = _$_decimalAdjust_188("ceil");

"use strict";

var _$isImplemented_205 = function () {
	var clz32 = Math.clz32;
	if (typeof clz32 !== "function") return false;
	return clz32(1000) === 22;
};

"use strict";

var _$shim_206 = function (value) {
	// eslint-disable-next-line no-bitwise
	value >>>= 0;
	return value ? 32 - value.toString(2).length : 32;
};

"use strict";

var _$clz32_204 = _$isImplemented_205() ? Math.clz32 : _$shim_206;

"use strict";

var _$isImplemented_208 = function () {
	var cosh = Math.cosh;
	if (typeof cosh !== "function") return false;
	return cosh(1) === 1.5430806348152437;
};

"use strict";

var exp = Math.exp;

var _$shim_209 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value === 0) return 1;
	if (!isFinite(value)) return Infinity;
	return (exp(value) + exp(-value)) / 2;
};

"use strict";

var _$cosh_207 = _$isImplemented_208() ? Math.cosh : _$shim_209;

"use strict";

var _$isImplemented_211 = function () {
	var expm1 = Math.expm1;
	if (typeof expm1 !== "function") return false;
	return expm1(1).toFixed(15) === "1.718281828459045";
};

// Thanks: https://github.com/monolithed/ECMAScript-6

"use strict";

var __exp_212 = Math.exp;

var _$shim_212 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value === 0) return value;
	if (value === Infinity) return Infinity;
	if (value === -Infinity) return -1;

	if (value > -1.0e-6 && value < 1.0e-6) return value + (value * value) / 2;
	return __exp_212(value) - 1;
};

"use strict";

var _$expm1_210 = _$isImplemented_211() ? Math.expm1 : _$shim_212;

"use strict";

var _$floor10_213 = _$_decimalAdjust_188("floor");

"use strict";

var _$isImplemented_215 = function () {
	var fround = Math.fround;
	if (typeof fround !== "function") return false;
	return fround(1.337) === 1.3370000123977661;
};

/* global Float32Array */

// Credit: https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js

"use strict";

var toFloat32;

if (typeof Float32Array === "undefined") {
	toFloat32 = (function () {
		var pack   = _$_packIeee754_189({})
		  , unpack = _$_unpackIeee754_190({});

		return function (value) { return unpack(pack(value, 8, 23), 8, 23); };
	})();
} else {
	toFloat32 = (function () {
		var float32Array = new Float32Array(1);
		return function (num) {
			float32Array[0] = num;
			return float32Array[0];
		};
	})();
}

var _$shim_216 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value === 0) return value;
	if (!isFinite(value)) return value;

	return toFloat32(value);
};

"use strict";

var _$fround_214 = _$isImplemented_215() ? Math.fround : _$shim_216;

"use strict";

var _$isImplemented_218 = function () {
	var hypot = Math.hypot;
	if (typeof hypot !== "function") return false;
	return hypot(3, 4) === 5;
};

// Thanks for hints: https://github.com/paulmillr/es6-shim

"use strict";

var __some_219 = Array.prototype.some
  , __abs_219 = Math.abs
  , __sqrt_219 = Math.sqrt
  , compare = function (val1, val2) { return val2 - val1; }
  , divide = function (value) { return value / this; }
  , add = function (sum, number) { return sum + number * number; };

// eslint-disable-next-line no-unused-vars
var _$shim_219 = function (val1, val2 /*, …valn*/) {
	var result, numbers;
	if (!arguments.length) return 0;
	__some_219.call(arguments, function (val) {
		if (isNaN(val)) {
			result = NaN;
			return false;
		}
		if (!isFinite(val)) {
			result = Infinity;
			return true;
		}
		if (result !== undefined) return false;
		val = Number(val);
		if (val === 0) return false;
		if (numbers) numbers.push(__abs_219(val));
		else numbers = [__abs_219(val)];
		return false;
	});
	if (result !== undefined) return result;
	if (!numbers) return 0;

	numbers.sort(compare);
	return numbers[0] * __sqrt_219(numbers.map(divide, numbers[0]).reduce(add, 0));
};

"use strict";

var _$hypot_217 = _$isImplemented_218() ? Math.hypot : _$shim_219;

"use strict";

var _$isImplemented_221 = function () {
	var imul = Math.imul;
	if (typeof imul !== "function") return false;
	return imul(-1, 8) === -8;
};

/* eslint no-bitwise: "off" */

// Thanks: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference
//         /Global_Objects/Math/imul

"use strict";

var _$shim_222 = function (val1, val2) {
	var xh = (val1 >>> 16) & 0xffff
	  , xl = val1 & 0xffff
	  , yh = (val2 >>> 16) & 0xffff
	  , yl = val2 & 0xffff;

	// The shift by 0 fixes the sign on the high part
	// the final |0 converts the unsigned value into a signed value
	return (xl * yl + (((xh * yl + xl * yh) << 16) >>> 0)) | 0;
};

"use strict";

var _$imul_220 = _$isImplemented_221() ? Math.imul : _$shim_222;

"use strict";

var _$isImplemented_225 = function () {
	var log10 = Math.log10;
	if (typeof log10 !== "function") return false;
	return log10(2) === 0.3010299956639812;
};

"use strict";

var __log_226 = Math.log, LOG10E = Math.LOG10E;

var _$shim_226 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value < 0) return NaN;
	if (value === 0) return -Infinity;
	if (value === 1) return 0;
	if (value === Infinity) return Infinity;

	return __log_226(value) * LOG10E;
};

"use strict";

var _$log10_224 = _$isImplemented_225() ? Math.log10 : _$shim_226;

"use strict";

var _$isImplemented_231 = function () {
	var log2 = Math.log2;
	if (typeof log2 !== "function") return false;
	return log2(3).toFixed(15) === "1.584962500721156";
};

"use strict";

var __log_232 = Math.log, LOG2E = Math.LOG2E;

var _$shim_232 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value < 0) return NaN;
	if (value === 0) return -Infinity;
	if (value === 1) return 0;
	if (value === Infinity) return Infinity;

	return __log_232(value) * LOG2E;
};

"use strict";

var _$log2_230 = _$isImplemented_231() ? Math.log2 : _$shim_232;

"use strict";

var _$isImplemented_228 = function () {
	var log1p = Math.log1p;
	if (typeof log1p !== "function") return false;
	return log1p(1) === 0.6931471805599453;
};

// Thanks: https://github.com/monolithed/ECMAScript-6/blob/master/ES6.js

"use strict";

var __log_229 = Math.log;

var _$shim_229 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value < -1) return NaN;
	if (value === -1) return -Infinity;
	if (value === 0) return value;
	if (value === Infinity) return Infinity;

	if (value > -1.0e-8 && value < 1.0e-8) return value - (value * value) / 2;
	return __log_229(1 + value);
};

"use strict";

var _$log1p_227 = _$isImplemented_228() ? Math.log1p : _$shim_229;

"use strict";

var _$round10_233 = _$_decimalAdjust_188("round");

"use strict";

var _$isImplemented_238 = function () {
	var sinh = Math.sinh;
	if (typeof sinh !== "function") return false;
	return sinh(1) === 1.1752011936438014 && sinh(Number.MIN_VALUE) === 5e-324;
};

// Parts of implementation taken from es6-shim project
// See: https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js

"use strict";

var __abs_239   = Math.abs
  , __exp_239   = Math.exp
  , e     = Math.E;

var _$shim_239 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value === 0) return value;
	if (!isFinite(value)) return value;
	if (__abs_239(value) < 1) return (_$expm1_210(value) - _$expm1_210(-value)) / 2;
	return ((__exp_239(value - 1) - __exp_239(-value - 1)) * e) / 2;
};

"use strict";

var _$sinh_237 = _$isImplemented_238() ? Math.sinh : _$shim_239;

"use strict";

var _$isImplemented_241 = function () {
	var tanh = Math.tanh;
	if (typeof tanh !== "function") return false;
	return tanh(1) === 0.7615941559557649 && tanh(Number.MAX_VALUE) === 1;
};

"use strict";

var __exp_242 = Math.exp;

var _$shim_242 = function (value) {
	var num1, num2;
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value === 0) return value;
	if (value === Infinity) return 1;
	if (value === -Infinity) return -1;
	num1 = __exp_242(value);
	if (num1 === Infinity) return 1;
	num2 = __exp_242(-value);
	if (num2 === Infinity) return -1;
	return (num1 - num2) / (num1 + num2);
};

"use strict";

var _$tanh_240 = _$isImplemented_241() ? Math.tanh : _$shim_242;

"use strict";

var _$isImplemented_244 = function () {
	var trunc = Math.trunc;
	if (typeof trunc !== "function") return false;
	return trunc(13.67) === 13 && trunc(-13.67) === -13;
};

"use strict";

var __floor_245 = Math.floor;

var _$shim_245 = function (value) {
	if (isNaN(value)) return NaN;
	value = Number(value);
	if (value === 0) return value;
	if (value === Infinity) return Infinity;
	if (value === -Infinity) return -Infinity;
	if (value > 0) return __floor_245(value);
	return -__floor_245(-value);
};

"use strict";

var _$trunc_243 = _$isImplemented_244() ? Math.trunc : _$shim_245;

"use strict";

var _$math_223 = {
	acosh: _$acosh_191,
	asinh: _$asinh_194,
	atanh: _$atanh_197,
	cbrt: _$cbrt_200,
	ceil10: _$ceil10_203,
	clz32: _$clz32_204,
	cosh: _$cosh_207,
	expm1: _$expm1_210,
	floor10: _$floor10_213,
	fround: _$fround_214,
	hypot: _$hypot_217,
	imul: _$imul_220,
	log10: _$log10_224,
	log2: _$log2_230,
	log1p: _$log1p_227,
	round10: _$round10_233,
	sign: _$sign_234,
	sinh: _$sinh_237,
	tanh: _$tanh_240,
	trunc: _$trunc_243
};

"use strict";

var _$_246 = { pad: _$pad_247 };

"use strict";

var _$epsilon_248 = 2.220446049250313e-16;

"use strict";

var _$isImplemented_251 = function () {
	var numberIsFinite = Number.isFinite;
	if (typeof numberIsFinite !== "function") return false;
	return !numberIsFinite("23") && numberIsFinite(34) && !numberIsFinite(Infinity);
};

"use strict";

var _$shim_252 = function (value) { return typeof value === "number" && isFinite(value); };

"use strict";

var _$isFinite_250 = _$isImplemented_251() ? Number.isFinite : _$shim_252;

"use strict";

/* removed: var _$isInteger_253 = require("./is-integer"); */;

var _$isNatural_259 = function (num) { return _$isInteger_253(num) && num >= 0; };

"use strict";

var __objToString_260 = Object.prototype.toString, __id_260 = __objToString_260.call(1);

var _$isNumber_260 = function (value) {
	return (
		typeof value === "number" ||
		value instanceof Number ||
		(typeof value === "object" && __objToString_260.call(value) === __id_260)
	);
};

"use strict";

var _$isImplemented_262 = function () {
	var isSafeInteger = Number.isSafeInteger;
	if (typeof isSafeInteger !== "function") return false;
	return !isSafeInteger("23") && isSafeInteger(34232322323) && !isSafeInteger(9007199254740992);
};

"use strict";

var _$maxSafeInteger_264 = Math.pow(2, 53) - 1;

"use strict";

var __abs_263       = Math.abs;

var _$shim_263 = function (value) {
	if (!_$shim_255(value)) return false;
	return __abs_263(value) <= _$maxSafeInteger_264;
};

"use strict";

var _$isSafeInteger_261 = _$isImplemented_262() ? Number.isSafeInteger : _$shim_263;

"use strict";

var _$minSafeInteger_265 = -(Math.pow(2, 53) - 1);

"use strict";

var _$toUint32_268 = function (value) {
	// eslint-disable-next-line no-bitwise
	return value >>> 0;
};

"use strict";

var _$number_249 = {
	"#": _$_246,
	"EPSILON": _$epsilon_248,
	"isFinite": _$isFinite_250,
	"isInteger": _$isInteger_253,
	"isNaN": _$isNan_256,
	"isNatural": _$isNatural_259,
	"isNumber": _$isNumber_260,
	"isSafeInteger": _$isSafeInteger_261,
	"MAX_SAFE_INTEGER": _$maxSafeInteger_264,
	"MIN_SAFE_INTEGER": _$minSafeInteger_265,
	"toInteger": _$toInteger_266,
	"toPosInteger": _$toPosInteger_267,
	"toUint32": _$toUint32_268
};

"use strict";

var __getPrototypeOf_315 = Object.getPrototypeOf
  , prototype = Object.prototype
  , __objToString_315 = prototype.toString
  , __id_315 = Object().toString();

var _$isPlainObject_315 = function (value) {
	var proto, valueConstructor;
	if (!value || typeof value !== "object" || __objToString_315.call(value) !== __id_315) {
		return false;
	}
	proto = __getPrototypeOf_315(value);
	if (proto === null) {
		valueConstructor = value.constructor;
		if (typeof valueConstructor !== "function") return true;
		return valueConstructor.prototype !== value;
	}
	return proto === prototype || __getPrototypeOf_315(proto) === null;
};

"use strict";

var __isArray_277       = Array.isArray;

var copyValue = function (value, ancestors, ancestorsCopy) {
	var mode;
	if (_$isPlainObject_315(value)) mode = "object";
	else if (__isArray_277(value)) mode = "array";
	if (!mode) return value;

	var copy = ancestorsCopy[ancestors.indexOf(value)];
	if (copy) return copy;
	copy = mode === "object" ? {} : [];

	ancestors.push(value);
	ancestorsCopy.push(copy);
	if (mode === "object") {
		_$forEach_300(value, function (item, key) {
			copy[key] = copyValue(item, ancestors, ancestorsCopy);
		});
	} else {
		value.forEach(function (item, index) {
			copy[index] = copyValue(item, ancestors, ancestorsCopy);
		});
	}
	ancestors.pop();
	ancestorsCopy.pop();

	return copy;
};

var _$copyDeep_277 = function (source) { return copyValue(_$validValue_340(source), [], []); };

"use strict";

/* removed: var _$validValue_340   = require("./valid-value"); */;

var __isArray_270 = Array.isArray, __slice_270 = Array.prototype.slice;

var deepAssign = function (target, source) {
	if (target === source) return target;
	if (_$isPlainObject_315(target) && _$isPlainObject_315(source)) {
		_$forEach_300(source, function (value, key) { target[key] = deepAssign(target[key], value); });
		return target;
	}
	if (__isArray_270(target) && __isArray_270(source)) {
		source.forEach(function (item) {
			if (_$contains_71.call(target, item)) return;
			if (__isArray_270(item) || _$isPlainObject_315(item)) item = _$copyDeep_277(item);
			target.push(item);
		});
		return target;
	}
	if (_$isPlainObject_315(source) || __isArray_270(source)) return _$copyDeep_277(source);
	return source;
};

var _$assignDeep_270 = function (target /*, ...objects*/) {
	return _$uniq_122
		.call([_$validValue_340(target)].concat(__slice_270.call(arguments, 1).map(_$validValue_340)))
		.reduce(deepAssign);
};

"use strict";

/* removed: var _$keys_321 = require("./keys"); */;

var _$clear_274 = function (obj) {
	var error;
	_$keys_321(obj).forEach(function (key) {
		try {
			delete this[key];
		} catch (e) {
			if (!error) error = e;
		}
	}, obj);
	if (error !== undefined) throw error;
	return obj;
};

"use strict";

var __call_295     = Function.prototype.call;

var _$filter_295 = function (obj, cb /*, thisArg*/) {
	var result = {}, thisArg = arguments[2];
	_$validCallable_338(cb);
	_$forEach_300(obj, function (value, key, targetObj, index) {
		if (__call_295.call(cb, thisArg, value, key, targetObj, index)) result[key] = targetObj[key];
	});
	return result;
};

"use strict";

/* removed: var _$isValue_318 = require("./is-value"); */;

var _$compact_275 = function (obj) {
	return _$filter_295(obj, function (val) { return _$isValue_318(val); });
};

"use strict";

var toLowerCase = String.prototype.toLowerCase;

var _$caseInsensitiveCompare_379 = function (other) {
	return toLowerCase.call(this).localeCompare(toLowerCase.call(String(other)));
};

"use strict";

var resolve
  , typeMap;

typeMap = { undefined: 0, object: 1, boolean: 2, string: 3, number: 4 };

resolve = function (a) {
	if (_$isObject_313(a)) {
		if (typeof a.valueOf !== "function") return NaN;
		a = a.valueOf();
		if (_$isObject_313(a)) {
			if (typeof a.toString !== "function") return NaN;
			a = a.toString();
			if (typeof a !== "string") return NaN;
		}
	}
	return a;
};

var _$compare_276 = function (val1, val2) {
	if (val1 === val2) return 0; // Same

	val1 = resolve(val1);
	val2 = resolve(val2);
	// eslint-disable-next-line eqeqeq
	if (val1 == val2) return typeMap[typeof val1] - typeMap[typeof val2];
	if (!_$isValue_318(val1)) return -1;
	if (!_$isValue_318(val2)) return 1;
	if (typeof val1 === "string" || typeof val2 === "string") {
		return _$caseInsensitiveCompare_379.call(val1, val2);
	}
	if (_$isNan_256(val1) && _$isNan_256(val2)) return 0; // Jslint: ignore
	return Number(val1) - Number(val2);
};

"use strict";

/* removed: var _$keys_321 = require("./keys"); */;

var _$count_279 = function (obj) { return _$keys_321(obj).length; };

"use strict";

/* removed: var _$isValue_318 = require("./is-value"); */;

var _$isNumberValue_312 = function (value) {
	if (!_$isValue_318(value)) return false;
	try { return !isNaN(value); }
	catch (e) { return false; }
};

"use strict";

/* removed: var _$isNumberValue_312 = require("./is-number-value"); */;

var _$isFiniteNumber_308 = function (value) { return _$isNumberValue_312(value) && isFinite(value); };

"use strict";

/* removed: var _$safeToString_372   = require("../safe-to-string"); */;

var _$ensureFiniteNumber_282 = function (value) {
	if (_$isFiniteNumber_308(value)) return Number(value);
	throw new TypeError(_$safeToString_372(value) + " does not represent a finite number value");
};

"use strict";

/* removed: var _$toShortStringRepresentation_419 = require("../to-short-string-representation"); */;

var _$ensureNaturalNumber_285 = function (arg) {
	var num = Number(arg);
	if (!_$isNatural_259(num)) throw new TypeError(_$toShortStringRepresentation_419(arg) + " is not a natural number");
	return num;
};

"use strict";

/* removed: var _$isNatural_259 = require("../number/is-natural"); */;

var _$isNaturalNumber_311 = function (arg) { return _$isNatural_259(Number(arg)); };

"use strict";

/* removed: var _$isValue_318         = require("./is-value"); */;

var _$isNaturalNumberValue_310 = function (arg) {
	if (!_$isValue_318(arg)) return false;
	return _$isNaturalNumber_311(arg);
};

"use strict";

/* removed: var _$toShortStringRepresentation_419  = require("../to-short-string-representation"); */;

var _$ensureNaturalNumberValue_284 = function (arg) {
	var num = Number(arg);
	if (!_$isNaturalNumberValue_310(arg)) throw new TypeError(_$toShortStringRepresentation_419(arg) + " is not a natural number");
	return num;
};

"use strict";

/* removed: var _$isPlainObject_315 = require("./is-plain-object"); */;

var _$ensurePlainObject_287 = function (value) {
	if (!_$isPlainObject_315(value)) throw new TypeError(_$safeToString_372(value) + " is not a plain object");
	return value;
};

"use strict";

/* removed: var _$isObject_313   = require("./is-object"); */;

var _$isThenable_317 = function (value) { return _$isObject_313(value) && _$isCallable_304(value.then); };

"use strict";

// In next major this check will also confirm on promise constructor
var _$isPromise_316 = _$isThenable_317;

"use strict";

/* removed: var _$isPromise_316    = require("./is-promise"); */;

var _$ensurePromise_288 = function (value) {
	if (!_$isPromise_316(value)) throw new TypeError(_$safeToString_372(value) + " is not a promise");
	return value;
};

"use strict";

/* removed: var _$isThenable_317   = require("./is-thenable"); */;

var _$ensureThenable_289 = function (value) {
	if (!_$isThenable_317(value)) throw new TypeError(_$safeToString_372(value) + " is not a thenable");
	return value;
};

"use strict";

var _$isImplemented_291 = function () {
	try { return Object.entries({ foo: 12 })[0][0] === "foo"; }
	catch (e) { return false; }
};

"use strict";

/* removed: var _$validValue_340 = require("../valid-value"); */;

var _$shim_292 = function (object) {
	_$validValue_340(object);
	var result = [];
	object = Object(object);
	for (var key in object) {
		if (!propertyIsEnumerable.call(object, key)) continue;
		result.push([key, object[key]]);
	}
	return result;
};

"use strict";

var _$entries_290 = _$isImplemented_291() ? Object.entries : _$shim_292;

"use strict";

var _$every_294 = _$_iterate_269("every", true);

"use strict";

var _$findKey_296 = _$_iterate_269(_$find_91, false);

"use strict";

/* removed: var _$isValue_318 = require("./is-value"); */;

// eslint-disable-next-line no-unused-vars
var _$find_297 = function (obj, cb /*, thisArg, compareFn*/) {
	var key = _$findKey_296.apply(this, arguments);
	return _$isValue_318(key) ? obj[key] : key;
};

"use strict";

var __objPropertyIsEnumerable_298 = Object.prototype.propertyIsEnumerable;

var _$firstKey_298 = function (obj) {
	var i;
	_$validValue_340(obj);
	for (i in obj) {
		if (__objPropertyIsEnumerable_298.call(obj, i)) return i;
	}
	return null;
};

"use strict";

var __process_299;

__process_299 = function self(value, key) {
	if (_$isPlainObject_315(value)) _$forEach_300(value, self, this);
	else this[key] = value;
};

var _$flatten_299 = function (obj) {
	var flattened = {};
	_$forEach_300(obj, __process_299, flattened);
	return flattened;
};

"use strict";

var __push_301                = Array.prototype.push
  , __getOwnPropertyNames_301 = Object.getOwnPropertyNames
  , __getPrototypeOf_301      = Object.getPrototypeOf;

var _$getPropertyNames_301 = function (obj) {
	var keys;
	obj = Object(_$validValue_340(obj));
	keys = __getOwnPropertyNames_301(obj);
	while ((obj = __getPrototypeOf_301(obj))) {
		__push_301.apply(keys, __getOwnPropertyNames_301(obj));
	}
	return _$uniq_122.call(keys);
};

// Implementation credits go to:
// http://wiki.ecmascript.org/doku.php?id=harmony:egal

"use strict";

/* removed: var _$isNan_256 = require("../number/is-nan"); */;

var _$is_319 = function (val1, val2) {
	return val1 === val2 ? val1 !== 0 || 1 / val1 === 1 / val2 : _$isNan_256(val1) && _$isNan_256(val2);
};

"use strict";

var __keys_306                    = Object.keys
  , __objPropertyIsEnumerable_306 = Object.prototype.propertyIsEnumerable;

var _$isCopy_306 = function (val1, val2) {
	var k1, k2;

	if (_$eq_293(_$validValue_340(val1), _$validValue_340(val2))) return true;

	val1 = Object(val1);
	val2 = Object(val2);

	k1 = __keys_306(val1);
	k2 = __keys_306(val2);
	if (k1.length !== k2.length) return false;
	return k1.every(function (key) {
		if (!__objPropertyIsEnumerable_306.call(val2, key)) return false;
		return _$eq_293(val1[key], val2[key]);
	});
};

"use strict";

/* removed: var _$validValue_340         = require("./valid-value"); */;

var __isArray_305 = Array.isArray
  , __keys_305 = Object.keys
  , __objPropertyIsEnumerable_305 = Object.prototype.propertyIsEnumerable
  , __objHasOwnProperty_305 = Object.prototype.hasOwnProperty
  , eqArr
  , eqVal
  , eqObj;

eqArr = function (arr1, arr2, recMap) {
	var i, length = arr1.length;
	if (length !== arr2.length) return false;
	for (i = 0; i < length; ++i) {
		if (__objHasOwnProperty_305.call(arr1, i) !== __objHasOwnProperty_305.call(arr2, i)) return false;
		if (!eqVal(arr1[i], arr2[i], recMap)) return false;
	}
	return true;
};

eqObj = function (obj1, obj2, recMap) {
	var k1 = __keys_305(obj1), k2 = __keys_305(obj2);
	if (k1.length !== k2.length) return false;
	return k1.every(function (key) {
		if (!__objPropertyIsEnumerable_305.call(obj2, key)) return false;
		return eqVal(obj1[key], obj2[key], recMap);
	});
};

eqVal = function (val1, val2, recMap) {
	var i, eqX, c1, c2;
	if (_$eq_293(val1, val2)) return true;
	if (_$isPlainObject_315(val1)) {
		if (!_$isPlainObject_315(val2)) return false;
		eqX = eqObj;
	} else if (__isArray_305(val1) && __isArray_305(val2)) {
		eqX = eqArr;
	} else {
		return false;
	}
	c1 = recMap[0];
	c2 = recMap[1];
	i = c1.indexOf(val1);
	if (i === -1) {
		i = c1.push(val1) - 1;
		c2[i] = [];
	} else if (c2[i].indexOf(val2) !== -1) return true;
	c2[i].push(val2);
	return eqX(val1, val2, recMap);
};

var _$isCopyDeep_305 = function (val1, val2) {
	if (_$eq_293(_$validValue_340(val1), _$validValue_340(val2))) return true;
	return eqVal(Object(val1), Object(val2), [[], []]);
};

"use strict";

var __objPropertyIsEnumerable_307 = Object.prototype.propertyIsEnumerable;

var _$isEmpty_307 = function (obj) {
	var i;
	_$validValue_340(obj);
	for (i in obj) {
		// Jslint: ignore
		if (__objPropertyIsEnumerable_307.call(obj, i)) return false;
	}
	return true;
};

"use strict";

var _$some_335 = _$_iterate_269("some", false);

"use strict";

/* removed: var _$some_335 = require("./some"); */;

var _$keyOf_320 = function (obj, searchValue) {
	var result;
	return _$some_335(obj, function (value, name) {
		if (_$eq_293(value, searchValue)) {
			result = name;
			return true;
		}
		return false;
	})
		? result
		: null;
};

"use strict";

var __call_324     = Function.prototype.call;

var _$mapKeys_324 = function (obj, cb /*, thisArg*/) {
	var result = {}, thisArg = arguments[2];
	_$validCallable_338(cb);
	_$forEach_300(
		obj,
		function (value, key, targetObj, index) {
			result[__call_324.call(cb, thisArg, key, value, this, index)] = value;
		},
		obj
	);
	return result;
};

"use strict";

var __mixin_326 = _$mixin_327({});

var __getPrototypeOf_326 = Object.getPrototypeOf;

var _$mixinPrototypes_326 = function (target, source) {
	target = Object(_$validValue_340(target));
	source = Object(_$validValue_340(source));
	if (target === source) return target;

	var sources = [];
	while (source && !isPrototypeOf.call(source, target)) {
		sources.unshift(source);
		source = __getPrototypeOf_326(source);
	}

	var error;
	sources.forEach(function (sourceProto) {
		try { __mixin_326(target, sourceProto); } catch (mixinError) { error = mixinError; }
	});
	if (error) throw error;
	return target;
};

"use strict";

/* removed: var _$isValue_318 = require("./is-value"); */;

var _$safeTraverse_330 = function (obj /*, …names*/) {
	var length, current = 1;
	_$validValue_340(obj);
	length = arguments.length - 1;
	if (!length) return obj;
	while (current < length) {
		obj = obj[arguments[current++]];
		if (!_$isValue_318(obj)) return undefined;
	}
	return obj[arguments[current]];
};

"use strict";

var __objToString_370 = Object.prototype.toString, __id_370 = __objToString_370.call(/a/);

var _$isRegExp_370 = function (value) {
	return (value && (value instanceof RegExp || __objToString_370.call(value) === __id_370)) || false;
};

var _$serialize_331 = {};
"use strict";

/* removed: var _$isRegExp_370 = require("../reg-exp/is-reg-exp"); */;

var __isArray_331 = Array.isArray
  , __stringify_331 = JSON.stringify
  , __objHasOwnProperty_331 = Object.prototype.hasOwnProperty;
var keyValueToString = function (value, key) {
	return __stringify_331(key) + ":" + _$serialize_331(value);
};

var sparseMap = function (arr) {
	var i, length = arr.length, result = new Array(length);
	for (i = 0; i < length; ++i) {
		if (!__objHasOwnProperty_331.call(arr, i)) continue;
		result[i] = _$serialize_331(arr[i]);
	}
	return result;
};

_$serialize_331 = function (obj) {
	if (!_$isValue_318(obj)) return String(obj);
	switch (typeof obj) {
		case "string":
			return __stringify_331(obj);
		case "number":
		case "boolean":
		case "function":
			return String(obj);
		case "object":
			if (__isArray_331(obj)) return "[" + sparseMap(obj) + "]";
			if (_$isRegExp_370(obj)) return String(obj);
			if (_$isDate_151(obj)) return "new Date(" + obj.valueOf() + ")";
			return "{" + _$toArray_336(obj, keyValueToString) + "}";
		default:
			throw new TypeError("Serialization of " + String(obj) + "is unsupported");
	}
};

"use strict";

/* removed: var _$validValue_340 = require("./valid-value"); */;

var _$unserialize_337 = function (code) {
	// eslint-disable-next-line no-new-func
	return new Function("return " + _$validValue_340(code))();
};

"use strict";

/* removed: var _$isArrayLike_303 = require("./is-array-like"); */;

var _$validateArrayLike_342 = function (obj) {
	if (_$isArrayLike_303(obj)) return obj;
	throw new TypeError(obj + " is not array-like value");
};

"use strict";

/* removed: var _$isObject_313    = require("./is-object"); */;

var _$validateArrayLikeObject_341 = function (obj) {
	if (_$isObject_313(obj) && _$isArrayLike_303(obj)) return obj;
	throw new TypeError(obj + " is not array-like object");
};

"use strict";

/* removed: var _$isCallable_304 = require("./is-callable"); */;

var _$validateStringifiable_344 = function (stringifiable) {
	try {
		if (stringifiable && _$isCallable_304(stringifiable.toString)) return stringifiable.toString();
		return String(stringifiable);
	} catch (e) {
		throw new TypeError("Passed argument cannot be stringifed");
	}
};

"use strict";

/* removed: var _$validateStringifiable_344 = require("./validate-stringifiable"); */;

var _$validateStringifiableValue_343 = function (value) { return _$validateStringifiable_344(_$validValue_340(value)); };

"use strict";

var _$object_302 = {
	assign: _$assign_271,
	assignDeep: _$assignDeep_270,
	clear: _$clear_274,
	compact: _$compact_275,
	compare: _$compare_276,
	copy: _$copy_278,
	copyDeep: _$copyDeep_277,
	count: _$count_279,
	create: _$create_280({}),
	ensureArray: _$ensureArray_281,
	ensureFiniteNumber: _$ensureFiniteNumber_282,
	ensureInteger: _$ensureInteger_283,
	ensureNaturalNumber: _$ensureNaturalNumber_285,
	ensureNaturalNumberValue: _$ensureNaturalNumberValue_284,
	ensurePlainFunction: _$ensurePlainFunction_286,
	ensurePlainObject: _$ensurePlainObject_287,
	ensurePromise: _$ensurePromise_288,
	ensureThenable: _$ensureThenable_289,
	entries: _$entries_290,
	eq: _$eq_293,
	every: _$every_294,
	filter: _$filter_295,
	find: _$find_297,
	findKey: _$findKey_296,
	firstKey: _$firstKey_298,
	flatten: _$flatten_299,
	forEach: _$forEach_300,
	getPropertyNames: _$getPropertyNames_301,
	is: _$is_319,
	isArrayLike: _$isArrayLike_303,
	isCallable: _$isCallable_304,
	isCopy: _$isCopy_306,
	isCopyDeep: _$isCopyDeep_305,
	isEmpty: _$isEmpty_307,
	isFiniteNumber: _$isFiniteNumber_308,
	isInteger: _$isInteger_309,
	isNaturalNumber: _$isNaturalNumber_311,
	isNaturalNumberValue: _$isNaturalNumberValue_310,
	isNumberValue: _$isNumberValue_312,
	isObject: _$isObject_313,
	isPlainFunction: _$isPlainFunction_314,
	isPlainObject: _$isPlainObject_315,
	isPromise: _$isPromise_316,
	isThenable: _$isThenable_317,
	isValue: _$isValue_318,
	keyOf: _$keyOf_320,
	keys: _$keys_321,
	map: _$map_325,
	mapKeys: _$mapKeys_324,
	normalizeOptions: _$normalizeOptions_328,
	mixin: _$mixin_327({}),
	mixinPrototypes: _$mixinPrototypes_326,
	primitiveSet: _$primitiveSet_329,
	safeTraverse: _$safeTraverse_330,
	serialize: _$serialize_331,
	setPrototypeOf: _$setPrototypeOf_332,
	some: _$some_335,
	toArray: _$toArray_336,
	unserialize: _$unserialize_337,
	validateArrayLike: _$validateArrayLike_342,
	validateArrayLikeObject: _$validateArrayLikeObject_341,
	validCallable: _$validCallable_338,
	validObject: _$validObject_339,
	validateStringifiable: _$validateStringifiable_344,
	validateStringifiableValue: _$validateStringifiableValue_343,
	validValue: _$validValue_340
};

"use strict";

/* removed: var _$microtaskDelay_165      = require("../../function/#/microtask-delay"); */;

var _$asCallback_346 = function (callback) {
	_$ensureThenable_289(this);
	_$ensurePlainFunction_286(callback);
	// Rely on microtaskDelay to escape eventual error swallowing
	this.then(
		_$microtaskDelay_165.call(function (value) { callback(null, value); }),
		_$microtaskDelay_165.call(function (reason) { callback(reason); })
	);
};

"use strict";

var _$isImplemented_348 = function () {
	if (typeof Promise !== "function") return false;
	if (typeof Promise.prototype.finally !== "function") return false;
	return true;
};

"use strict";

/* removed: var _$ensureThenable_289      = require("../../../object/ensure-thenable"); */;

var resolveCallback = function (callback, next) {
	var callbackResult = callback();
	if (!_$isThenable_317(callbackResult)) return next();
	return callbackResult.then(next);
};

var _$shim_349 = function (callback) {
	_$ensureThenable_289(this);
	_$ensurePlainFunction_286(callback);
	return this.then(
		function (result) {
			return resolveCallback(callback, function () { return result; });
		},
		function (error) {
			return resolveCallback(callback, function () { throw error; });
		}
	);
};

"use strict";

var _$finally_347 = _$isImplemented_348() ? Promise.prototype.finally : _$shim_349;

"use strict";

var _$_350 = { asCallback: _$asCallback_346, finally: _$finally_347 };

"use strict";

/* removed: var _$isFunction_176 = require("../function/is-function"); */;

var _$lazy_352 = function (executor) {
	var Constructor;
	if (_$isFunction_176(this)) {
		Constructor = this;
	} else if (typeof Promise === "function") {
		Constructor = Promise;
	} else {
		throw new TypeError("Could not resolve Promise constuctor");
	}

	var lazyThen;
	var promise = new Constructor(function (resolve, reject) {
		lazyThen = function (onSuccess, onFailure) {
			if (!hasOwnProperty.call(this, "then")) {
				// Sanity check
				throw new Error("Unexpected (inherited) lazy then invocation");
			}

			try { executor(resolve, reject); }
			catch (reason) { reject(reason); }
			delete this.then;
			return this.then(onSuccess, onFailure);
		};
	});

	return Object.defineProperty(promise, "then", {
		configurable: true,
		writable: true,
		value: lazyThen
	});
};

"use strict";

var _$promise_351 = { "#": _$_350, "lazy": _$lazy_352 };

"use strict";

/* removed: var _$isRegExp_370 = require("./is-reg-exp"); */;

var _$validRegExp_371 = function (value) {
	if (!_$isRegExp_370(value)) throw new TypeError(value + " is not a RegExp object");
	return value;
};

"use strict";

var re          = /\/[a-xz]*y[a-xz]*$/;

var _$isSticky_354 = function () { return Boolean(String(_$validRegExp_371(this)).match(re)); };

"use strict";

var __re_355          = /\/[a-xz]*u[a-xz]*$/;

var _$isUnicode_355 = function () { return Boolean(String(_$validRegExp_371(this)).match(__re_355)); };

"use strict";

var __re_357 = /foo/;

var _$isImplemented_357 = function () {
	if (typeof __re_357.match !== "function") return false;
	return __re_357.match("barfoobar") && !__re_357.match("elo");
};

"use strict";

/* removed: var _$validRegExp_371 = require("../../valid-reg-exp"); */;

var _$shim_358 = function (string) {
	_$validRegExp_371(this);
	return String(string).match(this);
};

"use strict";

var _$match_356 = _$isImplemented_357() ? RegExp.prototype.match : _$shim_358;

"use strict";

var __re_360 = /foo/;

var _$isImplemented_360 = function () {
	if (typeof __re_360.replace !== "function") return false;
	return __re_360.replace("foobar", "mar") === "marbar";
};

"use strict";

/* removed: var _$validRegExp_371 = require("../../valid-reg-exp"); */;

var _$shim_361 = function (string, replaceValue) {
	_$validRegExp_371(this);
	return String(string).replace(this, replaceValue);
};

"use strict";

var _$replace_359 = _$isImplemented_360() ? RegExp.prototype.replace : _$shim_361;

"use strict";

var __re_363 = /foo/;

var _$isImplemented_363 = function () {
	if (typeof __re_363.search !== "function") return false;
	return __re_363.search("barfoo") === 3;
};

"use strict";

/* removed: var _$validRegExp_371 = require("../../valid-reg-exp"); */;

var _$shim_364 = function (string) {
	_$validRegExp_371(this);
	return String(string).search(this);
};

"use strict";

var _$search_362 = _$isImplemented_363() ? RegExp.prototype.search : _$shim_364;

"use strict";

var __re_366 = /\|/;

var _$isImplemented_366 = function () {
	if (typeof __re_366.split !== "function") return false;
	return __re_366.split("bar|foo")[1] === "foo";
};

"use strict";

/* removed: var _$validRegExp_371 = require("../../valid-reg-exp"); */;

var _$shim_367 = function (string) {
	_$validRegExp_371(this);
	return String(string).split(this);
};

"use strict";

var _$split_365 = _$isImplemented_366() ? RegExp.prototype.split : _$shim_367;

"use strict";

var _$_353 = {
	isSticky: _$isSticky_354,
	isUnicode: _$isUnicode_355,
	match: _$match_356,
	replace: _$replace_359,
	search: _$search_362,
	split: _$split_365
};

// Thanks to Andrew Clover:
// http://stackoverflow.com/questions/3561493
// /is-there-a-regexp-escape-function-in-javascript

"use strict";

var __re_368 = /[-/\\^$*+?.()|[\]{}]/g;

var _$escape_368 = function (str) { return String(str).replace(__re_368, "\\$&"); };

"use strict";

var _$regExp_369 = {
	"#": _$_353,
	"escape": _$escape_368,
	"isRegExp": _$isRegExp_370,
	"validRegExp": _$validRegExp_371
};

"use strict";

var __iteratorSymbol_374 = _$es6Symbol_es6Symbol.iterator;

var _$isImplemented_374 = function () {
	var str = "🙈f", iterator, result;
	if (typeof str[__iteratorSymbol_374] !== "function") return false;
	iterator = str[__iteratorSymbol_374]();
	if (!iterator) return false;
	if (typeof iterator.next !== "function") return false;
	result = iterator.next();
	if (!result) return false;
	if (result.value !== "🙈") return false;
	if (result.done !== false) return false;
	return true;
};

"use strict";

/* removed: var _$validValue_340          = require("../../../object/valid-value"); */;

var _$shim_375 = function () { return new _$string_425(_$validValue_340(this)); };

"use strict";

var _$Iterator_373 = _$isImplemented_374()
	? String.prototype[_$es6Symbol_es6Symbol.iterator]
	: _$shim_375;

// Based on: https://github.com/mathiasbynens/String.prototype.at
// Thanks @mathiasbynens !

"use strict";

/* removed: var _$validValue_340 = require("../../object/valid-value"); */;

var _$at_376 = function (pos) {
	var str = String(_$validValue_340(this)), size = str.length, cuFirst, cuSecond, nextPos, len;
	pos = _$toInteger_266(pos);

	// Account for out-of-bounds indices
	// The odd lower bound is because the ToInteger operation is
	// going to round `n` to `0` for `-1 < n <= 0`.
	if (pos <= -1 || pos >= size) return "";

	// Second half of `ToInteger`
	// eslint-disable-next-line no-bitwise
	pos |= 0;
	// Get the first code unit and code unit value
	cuFirst = str.charCodeAt(pos);
	nextPos = pos + 1;
	len = 1;
	if (
		// Check if it’s the start of a surrogate pair
		cuFirst >= 0xd800 &&
		cuFirst <= 0xdbff && // High surrogate
		size > nextPos // There is a next code unit
	) {
		cuSecond = str.charCodeAt(nextPos);
		if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) len = 2; // Low surrogate
	}
	return str.slice(pos, pos + len);
};

"use strict";

/* removed: var _$validateStringifiableValue_343 = require("../../object/validate-stringifiable-value"); */;

var _$count_386 = function (search) {
	var string = _$validateStringifiableValue_343(this), count = 0, index = 0;

	search = _$validateStringifiableValue_343(search);
	if (!search) throw new TypeError("Search string cannot be empty");
	while ((index = string.indexOf(search, index)) !== -1) {
		++count;
		index += search.length;
	}
	return count;
};

"use strict";

var replace = String.prototype.replace, __re_377 = /([A-Z])/g;

var _$camelToHyphen_377 = function () {
	var str = replace.call(this, __re_377, "-$1").toLowerCase();
	if (str[0] === "-") str = str.slice(1);
	return str;
};

"use strict";

/* removed: var _$validValue_340 = require("../../object/valid-value"); */;

var _$capitalize_378 = function () {
	var str = String(_$validValue_340(this));
	return str.charAt(0).toUpperCase() + str.slice(1);
};

"use strict";

var __str_381 = "abc\uD834\uDF06def";

var _$isImplemented_381 = function () {
	if (typeof __str_381.codePointAt !== "function") return false;
	return __str_381.codePointAt(3) === 0x1d306;
};

// Based on: https://github.com/mathiasbynens/String.prototype.codePointAt
// Thanks @mathiasbynens !

"use strict";

/* removed: var _$validValue_340 = require("../../../object/valid-value"); */;

var _$shim_382 = function (pos) {
	var str = String(_$validValue_340(this)), length = str.length, first, second;
	pos = _$toInteger_266(pos);

	// Account for out-of-bounds indices:
	if (pos < 0 || pos >= length) return undefined;

	// Get the first code unit
	first = str.charCodeAt(pos);
	if (first >= 0xd800 && first <= 0xdbff && length > pos + 1) {
		second = str.charCodeAt(pos + 1);
		if (second >= 0xdc00 && second <= 0xdfff) {
			// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
			return (first - 0xd800) * 0x400 + second - 0xdc00 + 0x10000;
		}
	}
	return first;
};

"use strict";

var _$codePointAt_380 = _$isImplemented_381() ? String.prototype.codePointAt : _$shim_382;

"use strict";

var __replace_390 = String.prototype.replace, __re_390 = /-([a-z0-9])/g;
var toUpperCase = function (ignored, a) { return a.toUpperCase(); };

var _$hyphenToCamel_390 = function () { return __replace_390.call(this, __re_390, toUpperCase); };

"use strict";

var __str_388 = "razdwatrzy";

var _$isImplemented_388 = function () {
	if (typeof __str_388.endsWith !== "function") return false;
	return __str_388.endsWith("trzy") === true && __str_388.endsWith("raz") === false;
};

"use strict";

var __min_389       = Math.min
  , __max_389       = Math.max;

var _$shim_389 = function (searchString /*, endPosition*/) {
	var self, start, endPos;
	self = String(_$validValue_340(this));
	searchString = String(searchString);
	endPos = arguments[1];
	start =
		(_$isValue_318(endPos) ? __min_389(__max_389(_$toInteger_266(endPos), 0), self.length) : self.length) -
		searchString.length;
	return start < 0 ? false : self.indexOf(searchString, start) === start;
};

"use strict";

var _$endsWith_387 = _$isImplemented_388() ? String.prototype.endsWith : _$shim_389;

"use strict";

var __replace_391 = String.prototype.replace
  , __re_391      = /(\r\n|[\n\r\u2028\u2029])([\u0000-\u0009\u000b-\uffff]+)/g;

var _$indent_391 = function (indent /*, count*/) {
	var count = arguments[1];
	indent = _$repeat_401.call(String(indent), _$isValue_318(count) ? count : 1);
	return indent + __replace_391.call(this, __re_391, "$1" + indent + "$2");
};

"use strict";

/* removed: var _$validValue_340 = require("../../object/valid-value"); */;

var _$last_393 = function () {
	var self = String(_$validValue_340(this)), length = self.length;
	return length ? self[length - 1] : null;
};

"use strict";

var __str_396 = "æøåäüö";

var _$isImplemented_396 = function () {
	if (typeof __str_396.normalize !== "function") return false;
	return __str_396.normalize("NFKD") === "æøåäüö";
};

/* eslint max-lines: "off", no-sparse-arrays: "off", comma-style: "off" */

"use strict";

var _$_data_394 = {
	0: {
		60: [, , { 824: 8814 }],
		61: [, , { 824: 8800 }],
		62: [, , { 824: 8815 }],
		65: [
			, ,
			{
				768: 192,
				769: 193,
				770: 194,
				771: 195,
				772: 256,
				774: 258,
				775: 550,
				776: 196,
				777: 7842,
				778: 197,
				780: 461,
				783: 512,
				785: 514,
				803: 7840,
				805: 7680,
				808: 260
			}
		],
		66: [, , { 775: 7682, 803: 7684, 817: 7686 }],
		67: [, , { 769: 262, 770: 264, 775: 266, 780: 268, 807: 199 }],
		68: [, , { 775: 7690, 780: 270, 803: 7692, 807: 7696, 813: 7698, 817: 7694 }],
		69: [
			, ,
			{
				768: 200,
				769: 201,
				770: 202,
				771: 7868,
				772: 274,
				774: 276,
				775: 278,
				776: 203,
				777: 7866,
				780: 282,
				783: 516,
				785: 518,
				803: 7864,
				807: 552,
				808: 280,
				813: 7704,
				816: 7706
			}
		],
		70: [, , { 775: 7710 }],
		71: [, , { 769: 500, 770: 284, 772: 7712, 774: 286, 775: 288, 780: 486, 807: 290 }],
		72: [, , { 770: 292, 775: 7714, 776: 7718, 780: 542, 803: 7716, 807: 7720, 814: 7722 }],
		73: [
			, ,
			{
				768: 204,
				769: 205,
				770: 206,
				771: 296,
				772: 298,
				774: 300,
				775: 304,
				776: 207,
				777: 7880,
				780: 463,
				783: 520,
				785: 522,
				803: 7882,
				808: 302,
				816: 7724
			}
		],
		74: [, , { 770: 308 }],
		75: [, , { 769: 7728, 780: 488, 803: 7730, 807: 310, 817: 7732 }],
		76: [, , { 769: 313, 780: 317, 803: 7734, 807: 315, 813: 7740, 817: 7738 }],
		77: [, , { 769: 7742, 775: 7744, 803: 7746 }],
		78: [
			, ,
			{
				768: 504,
				769: 323,
				771: 209,
				775: 7748,
				780: 327,
				803: 7750,
				807: 325,
				813: 7754,
				817: 7752
			}
		],
		79: [
			, ,
			{
				768: 210,
				769: 211,
				770: 212,
				771: 213,
				772: 332,
				774: 334,
				775: 558,
				776: 214,
				777: 7886,
				779: 336,
				780: 465,
				783: 524,
				785: 526,
				795: 416,
				803: 7884,
				808: 490
			}
		],
		80: [, , { 769: 7764, 775: 7766 }],
		82: [
			, ,
			{ 769: 340, 775: 7768, 780: 344, 783: 528, 785: 530, 803: 7770, 807: 342, 817: 7774 }
		],
		83: [, , { 769: 346, 770: 348, 775: 7776, 780: 352, 803: 7778, 806: 536, 807: 350 }],
		84: [, , { 775: 7786, 780: 356, 803: 7788, 806: 538, 807: 354, 813: 7792, 817: 7790 }],
		85: [
			, ,
			{
				768: 217,
				769: 218,
				770: 219,
				771: 360,
				772: 362,
				774: 364,
				776: 220,
				777: 7910,
				778: 366,
				779: 368,
				780: 467,
				783: 532,
				785: 534,
				795: 431,
				803: 7908,
				804: 7794,
				808: 370,
				813: 7798,
				816: 7796
			}
		],
		86: [, , { 771: 7804, 803: 7806 }],
		87: [, , { 768: 7808, 769: 7810, 770: 372, 775: 7814, 776: 7812, 803: 7816 }],
		88: [, , { 775: 7818, 776: 7820 }],
		89: [
			, ,
			{
				768: 7922,
				769: 221,
				770: 374,
				771: 7928,
				772: 562,
				775: 7822,
				776: 376,
				777: 7926,
				803: 7924
			}
		],
		90: [, , { 769: 377, 770: 7824, 775: 379, 780: 381, 803: 7826, 817: 7828 }],
		97: [
			, ,
			{
				768: 224,
				769: 225,
				770: 226,
				771: 227,
				772: 257,
				774: 259,
				775: 551,
				776: 228,
				777: 7843,
				778: 229,
				780: 462,
				783: 513,
				785: 515,
				803: 7841,
				805: 7681,
				808: 261
			}
		],
		98: [, , { 775: 7683, 803: 7685, 817: 7687 }],
		99: [, , { 769: 263, 770: 265, 775: 267, 780: 269, 807: 231 }],
		100: [, , { 775: 7691, 780: 271, 803: 7693, 807: 7697, 813: 7699, 817: 7695 }],
		101: [
			, ,
			{
				768: 232,
				769: 233,
				770: 234,
				771: 7869,
				772: 275,
				774: 277,
				775: 279,
				776: 235,
				777: 7867,
				780: 283,
				783: 517,
				785: 519,
				803: 7865,
				807: 553,
				808: 281,
				813: 7705,
				816: 7707
			}
		],
		102: [, , { 775: 7711 }],
		103: [, , { 769: 501, 770: 285, 772: 7713, 774: 287, 775: 289, 780: 487, 807: 291 }],
		104: [
			, ,
			{ 770: 293, 775: 7715, 776: 7719, 780: 543, 803: 7717, 807: 7721, 814: 7723, 817: 7830 }
		],
		105: [
			, ,
			{
				768: 236,
				769: 237,
				770: 238,
				771: 297,
				772: 299,
				774: 301,
				776: 239,
				777: 7881,
				780: 464,
				783: 521,
				785: 523,
				803: 7883,
				808: 303,
				816: 7725
			}
		],
		106: [, , { 770: 309, 780: 496 }],
		107: [, , { 769: 7729, 780: 489, 803: 7731, 807: 311, 817: 7733 }],
		108: [, , { 769: 314, 780: 318, 803: 7735, 807: 316, 813: 7741, 817: 7739 }],
		109: [, , { 769: 7743, 775: 7745, 803: 7747 }],
		110: [
			, ,
			{
				768: 505,
				769: 324,
				771: 241,
				775: 7749,
				780: 328,
				803: 7751,
				807: 326,
				813: 7755,
				817: 7753
			}
		],
		111: [
			, ,
			{
				768: 242,
				769: 243,
				770: 244,
				771: 245,
				772: 333,
				774: 335,
				775: 559,
				776: 246,
				777: 7887,
				779: 337,
				780: 466,
				783: 525,
				785: 527,
				795: 417,
				803: 7885,
				808: 491
			}
		],
		112: [, , { 769: 7765, 775: 7767 }],
		114: [
			, ,
			{ 769: 341, 775: 7769, 780: 345, 783: 529, 785: 531, 803: 7771, 807: 343, 817: 7775 }
		],
		115: [, , { 769: 347, 770: 349, 775: 7777, 780: 353, 803: 7779, 806: 537, 807: 351 }],
		116: [
			, ,
			{ 775: 7787, 776: 7831, 780: 357, 803: 7789, 806: 539, 807: 355, 813: 7793, 817: 7791 }
		],
		117: [
			, ,
			{
				768: 249,
				769: 250,
				770: 251,
				771: 361,
				772: 363,
				774: 365,
				776: 252,
				777: 7911,
				778: 367,
				779: 369,
				780: 468,
				783: 533,
				785: 535,
				795: 432,
				803: 7909,
				804: 7795,
				808: 371,
				813: 7799,
				816: 7797
			}
		],
		118: [, , { 771: 7805, 803: 7807 }],
		119: [, , { 768: 7809, 769: 7811, 770: 373, 775: 7815, 776: 7813, 778: 7832, 803: 7817 }],
		120: [, , { 775: 7819, 776: 7821 }],
		121: [
			, ,
			{
				768: 7923,
				769: 253,
				770: 375,
				771: 7929,
				772: 563,
				775: 7823,
				776: 255,
				777: 7927,
				778: 7833,
				803: 7925
			}
		],
		122: [, , { 769: 378, 770: 7825, 775: 380, 780: 382, 803: 7827, 817: 7829 }],
		160: [[32], 256],
		168: [[32, 776], 256, { 768: 8173, 769: 901, 834: 8129 }],
		170: [[97], 256],
		175: [[32, 772], 256],
		178: [[50], 256],
		179: [[51], 256],
		180: [[32, 769], 256],
		181: [[956], 256],
		184: [[32, 807], 256],
		185: [[49], 256],
		186: [[111], 256],
		188: [[49, 8260, 52], 256],
		189: [[49, 8260, 50], 256],
		190: [[51, 8260, 52], 256],
		192: [[65, 768]],
		193: [[65, 769]],
		194: [[65, 770], , { 768: 7846, 769: 7844, 771: 7850, 777: 7848 }],
		195: [[65, 771]],
		196: [[65, 776], , { 772: 478 }],
		197: [[65, 778], , { 769: 506 }],
		198: [, , { 769: 508, 772: 482 }],
		199: [[67, 807], , { 769: 7688 }],
		200: [[69, 768]],
		201: [[69, 769]],
		202: [[69, 770], , { 768: 7872, 769: 7870, 771: 7876, 777: 7874 }],
		203: [[69, 776]],
		204: [[73, 768]],
		205: [[73, 769]],
		206: [[73, 770]],
		207: [[73, 776], , { 769: 7726 }],
		209: [[78, 771]],
		210: [[79, 768]],
		211: [[79, 769]],
		212: [[79, 770], , { 768: 7890, 769: 7888, 771: 7894, 777: 7892 }],
		213: [[79, 771], , { 769: 7756, 772: 556, 776: 7758 }],
		214: [[79, 776], , { 772: 554 }],
		216: [, , { 769: 510 }],
		217: [[85, 768]],
		218: [[85, 769]],
		219: [[85, 770]],
		220: [[85, 776], , { 768: 475, 769: 471, 772: 469, 780: 473 }],
		221: [[89, 769]],
		224: [[97, 768]],
		225: [[97, 769]],
		226: [[97, 770], , { 768: 7847, 769: 7845, 771: 7851, 777: 7849 }],
		227: [[97, 771]],
		228: [[97, 776], , { 772: 479 }],
		229: [[97, 778], , { 769: 507 }],
		230: [, , { 769: 509, 772: 483 }],
		231: [[99, 807], , { 769: 7689 }],
		232: [[101, 768]],
		233: [[101, 769]],
		234: [[101, 770], , { 768: 7873, 769: 7871, 771: 7877, 777: 7875 }],
		235: [[101, 776]],
		236: [[105, 768]],
		237: [[105, 769]],
		238: [[105, 770]],
		239: [[105, 776], , { 769: 7727 }],
		241: [[110, 771]],
		242: [[111, 768]],
		243: [[111, 769]],
		244: [[111, 770], , { 768: 7891, 769: 7889, 771: 7895, 777: 7893 }],
		245: [[111, 771], , { 769: 7757, 772: 557, 776: 7759 }],
		246: [[111, 776], , { 772: 555 }],
		248: [, , { 769: 511 }],
		249: [[117, 768]],
		250: [[117, 769]],
		251: [[117, 770]],
		252: [[117, 776], , { 768: 476, 769: 472, 772: 470, 780: 474 }],
		253: [[121, 769]],
		255: [[121, 776]]
	},
	256: {
		256: [[65, 772]],
		257: [[97, 772]],
		258: [[65, 774], , { 768: 7856, 769: 7854, 771: 7860, 777: 7858 }],
		259: [[97, 774], , { 768: 7857, 769: 7855, 771: 7861, 777: 7859 }],
		260: [[65, 808]],
		261: [[97, 808]],
		262: [[67, 769]],
		263: [[99, 769]],
		264: [[67, 770]],
		265: [[99, 770]],
		266: [[67, 775]],
		267: [[99, 775]],
		268: [[67, 780]],
		269: [[99, 780]],
		270: [[68, 780]],
		271: [[100, 780]],
		274: [[69, 772], , { 768: 7700, 769: 7702 }],
		275: [[101, 772], , { 768: 7701, 769: 7703 }],
		276: [[69, 774]],
		277: [[101, 774]],
		278: [[69, 775]],
		279: [[101, 775]],
		280: [[69, 808]],
		281: [[101, 808]],
		282: [[69, 780]],
		283: [[101, 780]],
		284: [[71, 770]],
		285: [[103, 770]],
		286: [[71, 774]],
		287: [[103, 774]],
		288: [[71, 775]],
		289: [[103, 775]],
		290: [[71, 807]],
		291: [[103, 807]],
		292: [[72, 770]],
		293: [[104, 770]],
		296: [[73, 771]],
		297: [[105, 771]],
		298: [[73, 772]],
		299: [[105, 772]],
		300: [[73, 774]],
		301: [[105, 774]],
		302: [[73, 808]],
		303: [[105, 808]],
		304: [[73, 775]],
		306: [[73, 74], 256],
		307: [[105, 106], 256],
		308: [[74, 770]],
		309: [[106, 770]],
		310: [[75, 807]],
		311: [[107, 807]],
		313: [[76, 769]],
		314: [[108, 769]],
		315: [[76, 807]],
		316: [[108, 807]],
		317: [[76, 780]],
		318: [[108, 780]],
		319: [[76, 183], 256],
		320: [[108, 183], 256],
		323: [[78, 769]],
		324: [[110, 769]],
		325: [[78, 807]],
		326: [[110, 807]],
		327: [[78, 780]],
		328: [[110, 780]],
		329: [[700, 110], 256],
		332: [[79, 772], , { 768: 7760, 769: 7762 }],
		333: [[111, 772], , { 768: 7761, 769: 7763 }],
		334: [[79, 774]],
		335: [[111, 774]],
		336: [[79, 779]],
		337: [[111, 779]],
		340: [[82, 769]],
		341: [[114, 769]],
		342: [[82, 807]],
		343: [[114, 807]],
		344: [[82, 780]],
		345: [[114, 780]],
		346: [[83, 769], , { 775: 7780 }],
		347: [[115, 769], , { 775: 7781 }],
		348: [[83, 770]],
		349: [[115, 770]],
		350: [[83, 807]],
		351: [[115, 807]],
		352: [[83, 780], , { 775: 7782 }],
		353: [[115, 780], , { 775: 7783 }],
		354: [[84, 807]],
		355: [[116, 807]],
		356: [[84, 780]],
		357: [[116, 780]],
		360: [[85, 771], , { 769: 7800 }],
		361: [[117, 771], , { 769: 7801 }],
		362: [[85, 772], , { 776: 7802 }],
		363: [[117, 772], , { 776: 7803 }],
		364: [[85, 774]],
		365: [[117, 774]],
		366: [[85, 778]],
		367: [[117, 778]],
		368: [[85, 779]],
		369: [[117, 779]],
		370: [[85, 808]],
		371: [[117, 808]],
		372: [[87, 770]],
		373: [[119, 770]],
		374: [[89, 770]],
		375: [[121, 770]],
		376: [[89, 776]],
		377: [[90, 769]],
		378: [[122, 769]],
		379: [[90, 775]],
		380: [[122, 775]],
		381: [[90, 780]],
		382: [[122, 780]],
		383: [[115], 256, { 775: 7835 }],
		416: [[79, 795], , { 768: 7900, 769: 7898, 771: 7904, 777: 7902, 803: 7906 }],
		417: [[111, 795], , { 768: 7901, 769: 7899, 771: 7905, 777: 7903, 803: 7907 }],
		431: [[85, 795], , { 768: 7914, 769: 7912, 771: 7918, 777: 7916, 803: 7920 }],
		432: [[117, 795], , { 768: 7915, 769: 7913, 771: 7919, 777: 7917, 803: 7921 }],
		439: [, , { 780: 494 }],
		452: [[68, 381], 256],
		453: [[68, 382], 256],
		454: [[100, 382], 256],
		455: [[76, 74], 256],
		456: [[76, 106], 256],
		457: [[108, 106], 256],
		458: [[78, 74], 256],
		459: [[78, 106], 256],
		460: [[110, 106], 256],
		461: [[65, 780]],
		462: [[97, 780]],
		463: [[73, 780]],
		464: [[105, 780]],
		465: [[79, 780]],
		466: [[111, 780]],
		467: [[85, 780]],
		468: [[117, 780]],
		469: [[220, 772]],
		470: [[252, 772]],
		471: [[220, 769]],
		472: [[252, 769]],
		473: [[220, 780]],
		474: [[252, 780]],
		475: [[220, 768]],
		476: [[252, 768]],
		478: [[196, 772]],
		479: [[228, 772]],
		480: [[550, 772]],
		481: [[551, 772]],
		482: [[198, 772]],
		483: [[230, 772]],
		486: [[71, 780]],
		487: [[103, 780]],
		488: [[75, 780]],
		489: [[107, 780]],
		490: [[79, 808], , { 772: 492 }],
		491: [[111, 808], , { 772: 493 }],
		492: [[490, 772]],
		493: [[491, 772]],
		494: [[439, 780]],
		495: [[658, 780]],
		496: [[106, 780]],
		497: [[68, 90], 256],
		498: [[68, 122], 256],
		499: [[100, 122], 256],
		500: [[71, 769]],
		501: [[103, 769]],
		504: [[78, 768]],
		505: [[110, 768]],
		506: [[197, 769]],
		507: [[229, 769]],
		508: [[198, 769]],
		509: [[230, 769]],
		510: [[216, 769]],
		511: [[248, 769]],
		66045: [, 220]
	},
	512: {
		512: [[65, 783]],
		513: [[97, 783]],
		514: [[65, 785]],
		515: [[97, 785]],
		516: [[69, 783]],
		517: [[101, 783]],
		518: [[69, 785]],
		519: [[101, 785]],
		520: [[73, 783]],
		521: [[105, 783]],
		522: [[73, 785]],
		523: [[105, 785]],
		524: [[79, 783]],
		525: [[111, 783]],
		526: [[79, 785]],
		527: [[111, 785]],
		528: [[82, 783]],
		529: [[114, 783]],
		530: [[82, 785]],
		531: [[114, 785]],
		532: [[85, 783]],
		533: [[117, 783]],
		534: [[85, 785]],
		535: [[117, 785]],
		536: [[83, 806]],
		537: [[115, 806]],
		538: [[84, 806]],
		539: [[116, 806]],
		542: [[72, 780]],
		543: [[104, 780]],
		550: [[65, 775], , { 772: 480 }],
		551: [[97, 775], , { 772: 481 }],
		552: [[69, 807], , { 774: 7708 }],
		553: [[101, 807], , { 774: 7709 }],
		554: [[214, 772]],
		555: [[246, 772]],
		556: [[213, 772]],
		557: [[245, 772]],
		558: [[79, 775], , { 772: 560 }],
		559: [[111, 775], , { 772: 561 }],
		560: [[558, 772]],
		561: [[559, 772]],
		562: [[89, 772]],
		563: [[121, 772]],
		658: [, , { 780: 495 }],
		688: [[104], 256],
		689: [[614], 256],
		690: [[106], 256],
		691: [[114], 256],
		692: [[633], 256],
		693: [[635], 256],
		694: [[641], 256],
		695: [[119], 256],
		696: [[121], 256],
		728: [[32, 774], 256],
		729: [[32, 775], 256],
		730: [[32, 778], 256],
		731: [[32, 808], 256],
		732: [[32, 771], 256],
		733: [[32, 779], 256],
		736: [[611], 256],
		737: [[108], 256],
		738: [[115], 256],
		739: [[120], 256],
		740: [[661], 256]
	},
	768: {
		768: [, 230],
		769: [, 230],
		770: [, 230],
		771: [, 230],
		772: [, 230],
		773: [, 230],
		774: [, 230],
		775: [, 230],
		776: [, 230, { 769: 836 }],
		777: [, 230],
		778: [, 230],
		779: [, 230],
		780: [, 230],
		781: [, 230],
		782: [, 230],
		783: [, 230],
		784: [, 230],
		785: [, 230],
		786: [, 230],
		787: [, 230],
		788: [, 230],
		789: [, 232],
		790: [, 220],
		791: [, 220],
		792: [, 220],
		793: [, 220],
		794: [, 232],
		795: [, 216],
		796: [, 220],
		797: [, 220],
		798: [, 220],
		799: [, 220],
		800: [, 220],
		801: [, 202],
		802: [, 202],
		803: [, 220],
		804: [, 220],
		805: [, 220],
		806: [, 220],
		807: [, 202],
		808: [, 202],
		809: [, 220],
		810: [, 220],
		811: [, 220],
		812: [, 220],
		813: [, 220],
		814: [, 220],
		815: [, 220],
		816: [, 220],
		817: [, 220],
		818: [, 220],
		819: [, 220],
		820: [, 1],
		821: [, 1],
		822: [, 1],
		823: [, 1],
		824: [, 1],
		825: [, 220],
		826: [, 220],
		827: [, 220],
		828: [, 220],
		829: [, 230],
		830: [, 230],
		831: [, 230],
		832: [[768], 230],
		833: [[769], 230],
		834: [, 230],
		835: [[787], 230],
		836: [[776, 769], 230],
		837: [, 240],
		838: [, 230],
		839: [, 220],
		840: [, 220],
		841: [, 220],
		842: [, 230],
		843: [, 230],
		844: [, 230],
		845: [, 220],
		846: [, 220],
		848: [, 230],
		849: [, 230],
		850: [, 230],
		851: [, 220],
		852: [, 220],
		853: [, 220],
		854: [, 220],
		855: [, 230],
		856: [, 232],
		857: [, 220],
		858: [, 220],
		859: [, 230],
		860: [, 233],
		861: [, 234],
		862: [, 234],
		863: [, 233],
		864: [, 234],
		865: [, 234],
		866: [, 233],
		867: [, 230],
		868: [, 230],
		869: [, 230],
		870: [, 230],
		871: [, 230],
		872: [, 230],
		873: [, 230],
		874: [, 230],
		875: [, 230],
		876: [, 230],
		877: [, 230],
		878: [, 230],
		879: [, 230],
		884: [[697]],
		890: [[32, 837], 256],
		894: [[59]],
		900: [[32, 769], 256],
		901: [[168, 769]],
		902: [[913, 769]],
		903: [[183]],
		904: [[917, 769]],
		905: [[919, 769]],
		906: [[921, 769]],
		908: [[927, 769]],
		910: [[933, 769]],
		911: [[937, 769]],
		912: [[970, 769]],
		913: [, , { 768: 8122, 769: 902, 772: 8121, 774: 8120, 787: 7944, 788: 7945, 837: 8124 }],
		917: [, , { 768: 8136, 769: 904, 787: 7960, 788: 7961 }],
		919: [, , { 768: 8138, 769: 905, 787: 7976, 788: 7977, 837: 8140 }],
		921: [, , { 768: 8154, 769: 906, 772: 8153, 774: 8152, 776: 938, 787: 7992, 788: 7993 }],
		927: [, , { 768: 8184, 769: 908, 787: 8008, 788: 8009 }],
		929: [, , { 788: 8172 }],
		933: [, , { 768: 8170, 769: 910, 772: 8169, 774: 8168, 776: 939, 788: 8025 }],
		937: [, , { 768: 8186, 769: 911, 787: 8040, 788: 8041, 837: 8188 }],
		938: [[921, 776]],
		939: [[933, 776]],
		940: [[945, 769], , { 837: 8116 }],
		941: [[949, 769]],
		942: [[951, 769], , { 837: 8132 }],
		943: [[953, 769]],
		944: [[971, 769]],
		945: [
			, ,
			{
				768: 8048,
				769: 940,
				772: 8113,
				774: 8112,
				787: 7936,
				788: 7937,
				834: 8118,
				837: 8115
			}
		],
		949: [, , { 768: 8050, 769: 941, 787: 7952, 788: 7953 }],
		951: [, , { 768: 8052, 769: 942, 787: 7968, 788: 7969, 834: 8134, 837: 8131 }],
		953: [
			, ,
			{ 768: 8054, 769: 943, 772: 8145, 774: 8144, 776: 970, 787: 7984, 788: 7985, 834: 8150 }
		],
		959: [, , { 768: 8056, 769: 972, 787: 8000, 788: 8001 }],
		961: [, , { 787: 8164, 788: 8165 }],
		965: [
			, ,
			{ 768: 8058, 769: 973, 772: 8161, 774: 8160, 776: 971, 787: 8016, 788: 8017, 834: 8166 }
		],
		969: [, , { 768: 8060, 769: 974, 787: 8032, 788: 8033, 834: 8182, 837: 8179 }],
		970: [[953, 776], , { 768: 8146, 769: 912, 834: 8151 }],
		971: [[965, 776], , { 768: 8162, 769: 944, 834: 8167 }],
		972: [[959, 769]],
		973: [[965, 769]],
		974: [[969, 769], , { 837: 8180 }],
		976: [[946], 256],
		977: [[952], 256],
		978: [[933], 256, { 769: 979, 776: 980 }],
		979: [[978, 769]],
		980: [[978, 776]],
		981: [[966], 256],
		982: [[960], 256],
		1008: [[954], 256],
		1009: [[961], 256],
		1010: [[962], 256],
		1012: [[920], 256],
		1013: [[949], 256],
		1017: [[931], 256]
	},
	1024: {
		1024: [[1045, 768]],
		1025: [[1045, 776]],
		1027: [[1043, 769]],
		1030: [, , { 776: 1031 }],
		1031: [[1030, 776]],
		1036: [[1050, 769]],
		1037: [[1048, 768]],
		1038: [[1059, 774]],
		1040: [, , { 774: 1232, 776: 1234 }],
		1043: [, , { 769: 1027 }],
		1045: [, , { 768: 1024, 774: 1238, 776: 1025 }],
		1046: [, , { 774: 1217, 776: 1244 }],
		1047: [, , { 776: 1246 }],
		1048: [, , { 768: 1037, 772: 1250, 774: 1049, 776: 1252 }],
		1049: [[1048, 774]],
		1050: [, , { 769: 1036 }],
		1054: [, , { 776: 1254 }],
		1059: [, , { 772: 1262, 774: 1038, 776: 1264, 779: 1266 }],
		1063: [, , { 776: 1268 }],
		1067: [, , { 776: 1272 }],
		1069: [, , { 776: 1260 }],
		1072: [, , { 774: 1233, 776: 1235 }],
		1075: [, , { 769: 1107 }],
		1077: [, , { 768: 1104, 774: 1239, 776: 1105 }],
		1078: [, , { 774: 1218, 776: 1245 }],
		1079: [, , { 776: 1247 }],
		1080: [, , { 768: 1117, 772: 1251, 774: 1081, 776: 1253 }],
		1081: [[1080, 774]],
		1082: [, , { 769: 1116 }],
		1086: [, , { 776: 1255 }],
		1091: [, , { 772: 1263, 774: 1118, 776: 1265, 779: 1267 }],
		1095: [, , { 776: 1269 }],
		1099: [, , { 776: 1273 }],
		1101: [, , { 776: 1261 }],
		1104: [[1077, 768]],
		1105: [[1077, 776]],
		1107: [[1075, 769]],
		1110: [, , { 776: 1111 }],
		1111: [[1110, 776]],
		1116: [[1082, 769]],
		1117: [[1080, 768]],
		1118: [[1091, 774]],
		1140: [, , { 783: 1142 }],
		1141: [, , { 783: 1143 }],
		1142: [[1140, 783]],
		1143: [[1141, 783]],
		1155: [, 230],
		1156: [, 230],
		1157: [, 230],
		1158: [, 230],
		1159: [, 230],
		1217: [[1046, 774]],
		1218: [[1078, 774]],
		1232: [[1040, 774]],
		1233: [[1072, 774]],
		1234: [[1040, 776]],
		1235: [[1072, 776]],
		1238: [[1045, 774]],
		1239: [[1077, 774]],
		1240: [, , { 776: 1242 }],
		1241: [, , { 776: 1243 }],
		1242: [[1240, 776]],
		1243: [[1241, 776]],
		1244: [[1046, 776]],
		1245: [[1078, 776]],
		1246: [[1047, 776]],
		1247: [[1079, 776]],
		1250: [[1048, 772]],
		1251: [[1080, 772]],
		1252: [[1048, 776]],
		1253: [[1080, 776]],
		1254: [[1054, 776]],
		1255: [[1086, 776]],
		1256: [, , { 776: 1258 }],
		1257: [, , { 776: 1259 }],
		1258: [[1256, 776]],
		1259: [[1257, 776]],
		1260: [[1069, 776]],
		1261: [[1101, 776]],
		1262: [[1059, 772]],
		1263: [[1091, 772]],
		1264: [[1059, 776]],
		1265: [[1091, 776]],
		1266: [[1059, 779]],
		1267: [[1091, 779]],
		1268: [[1063, 776]],
		1269: [[1095, 776]],
		1272: [[1067, 776]],
		1273: [[1099, 776]]
	},
	1280: {
		1415: [[1381, 1410], 256],
		1425: [, 220],
		1426: [, 230],
		1427: [, 230],
		1428: [, 230],
		1429: [, 230],
		1430: [, 220],
		1431: [, 230],
		1432: [, 230],
		1433: [, 230],
		1434: [, 222],
		1435: [, 220],
		1436: [, 230],
		1437: [, 230],
		1438: [, 230],
		1439: [, 230],
		1440: [, 230],
		1441: [, 230],
		1442: [, 220],
		1443: [, 220],
		1444: [, 220],
		1445: [, 220],
		1446: [, 220],
		1447: [, 220],
		1448: [, 230],
		1449: [, 230],
		1450: [, 220],
		1451: [, 230],
		1452: [, 230],
		1453: [, 222],
		1454: [, 228],
		1455: [, 230],
		1456: [, 10],
		1457: [, 11],
		1458: [, 12],
		1459: [, 13],
		1460: [, 14],
		1461: [, 15],
		1462: [, 16],
		1463: [, 17],
		1464: [, 18],
		1465: [, 19],
		1466: [, 19],
		1467: [, 20],
		1468: [, 21],
		1469: [, 22],
		1471: [, 23],
		1473: [, 24],
		1474: [, 25],
		1476: [, 230],
		1477: [, 220],
		1479: [, 18]
	},
	1536: {
		1552: [, 230],
		1553: [, 230],
		1554: [, 230],
		1555: [, 230],
		1556: [, 230],
		1557: [, 230],
		1558: [, 230],
		1559: [, 230],
		1560: [, 30],
		1561: [, 31],
		1562: [, 32],
		1570: [[1575, 1619]],
		1571: [[1575, 1620]],
		1572: [[1608, 1620]],
		1573: [[1575, 1621]],
		1574: [[1610, 1620]],
		1575: [, , { 1619: 1570, 1620: 1571, 1621: 1573 }],
		1608: [, , { 1620: 1572 }],
		1610: [, , { 1620: 1574 }],
		1611: [, 27],
		1612: [, 28],
		1613: [, 29],
		1614: [, 30],
		1615: [, 31],
		1616: [, 32],
		1617: [, 33],
		1618: [, 34],
		1619: [, 230],
		1620: [, 230],
		1621: [, 220],
		1622: [, 220],
		1623: [, 230],
		1624: [, 230],
		1625: [, 230],
		1626: [, 230],
		1627: [, 230],
		1628: [, 220],
		1629: [, 230],
		1630: [, 230],
		1631: [, 220],
		1648: [, 35],
		1653: [[1575, 1652], 256],
		1654: [[1608, 1652], 256],
		1655: [[1735, 1652], 256],
		1656: [[1610, 1652], 256],
		1728: [[1749, 1620]],
		1729: [, , { 1620: 1730 }],
		1730: [[1729, 1620]],
		1746: [, , { 1620: 1747 }],
		1747: [[1746, 1620]],
		1749: [, , { 1620: 1728 }],
		1750: [, 230],
		1751: [, 230],
		1752: [, 230],
		1753: [, 230],
		1754: [, 230],
		1755: [, 230],
		1756: [, 230],
		1759: [, 230],
		1760: [, 230],
		1761: [, 230],
		1762: [, 230],
		1763: [, 220],
		1764: [, 230],
		1767: [, 230],
		1768: [, 230],
		1770: [, 220],
		1771: [, 230],
		1772: [, 230],
		1773: [, 220]
	},
	1792: {
		1809: [, 36],
		1840: [, 230],
		1841: [, 220],
		1842: [, 230],
		1843: [, 230],
		1844: [, 220],
		1845: [, 230],
		1846: [, 230],
		1847: [, 220],
		1848: [, 220],
		1849: [, 220],
		1850: [, 230],
		1851: [, 220],
		1852: [, 220],
		1853: [, 230],
		1854: [, 220],
		1855: [, 230],
		1856: [, 230],
		1857: [, 230],
		1858: [, 220],
		1859: [, 230],
		1860: [, 220],
		1861: [, 230],
		1862: [, 220],
		1863: [, 230],
		1864: [, 220],
		1865: [, 230],
		1866: [, 230],
		2027: [, 230],
		2028: [, 230],
		2029: [, 230],
		2030: [, 230],
		2031: [, 230],
		2032: [, 230],
		2033: [, 230],
		2034: [, 220],
		2035: [, 230]
	},
	2048: {
		2070: [, 230],
		2071: [, 230],
		2072: [, 230],
		2073: [, 230],
		2075: [, 230],
		2076: [, 230],
		2077: [, 230],
		2078: [, 230],
		2079: [, 230],
		2080: [, 230],
		2081: [, 230],
		2082: [, 230],
		2083: [, 230],
		2085: [, 230],
		2086: [, 230],
		2087: [, 230],
		2089: [, 230],
		2090: [, 230],
		2091: [, 230],
		2092: [, 230],
		2093: [, 230],
		2137: [, 220],
		2138: [, 220],
		2139: [, 220],
		2276: [, 230],
		2277: [, 230],
		2278: [, 220],
		2279: [, 230],
		2280: [, 230],
		2281: [, 220],
		2282: [, 230],
		2283: [, 230],
		2284: [, 230],
		2285: [, 220],
		2286: [, 220],
		2287: [, 220],
		2288: [, 27],
		2289: [, 28],
		2290: [, 29],
		2291: [, 230],
		2292: [, 230],
		2293: [, 230],
		2294: [, 220],
		2295: [, 230],
		2296: [, 230],
		2297: [, 220],
		2298: [, 220],
		2299: [, 230],
		2300: [, 230],
		2301: [, 230],
		2302: [, 230]
	},
	2304: {
		2344: [, , { 2364: 2345 }],
		2345: [[2344, 2364]],
		2352: [, , { 2364: 2353 }],
		2353: [[2352, 2364]],
		2355: [, , { 2364: 2356 }],
		2356: [[2355, 2364]],
		2364: [, 7],
		2381: [, 9],
		2385: [, 230],
		2386: [, 220],
		2387: [, 230],
		2388: [, 230],
		2392: [[2325, 2364], 512],
		2393: [[2326, 2364], 512],
		2394: [[2327, 2364], 512],
		2395: [[2332, 2364], 512],
		2396: [[2337, 2364], 512],
		2397: [[2338, 2364], 512],
		2398: [[2347, 2364], 512],
		2399: [[2351, 2364], 512],
		2492: [, 7],
		2503: [, , { 2494: 2507, 2519: 2508 }],
		2507: [[2503, 2494]],
		2508: [[2503, 2519]],
		2509: [, 9],
		2524: [[2465, 2492], 512],
		2525: [[2466, 2492], 512],
		2527: [[2479, 2492], 512]
	},
	2560: {
		2611: [[2610, 2620], 512],
		2614: [[2616, 2620], 512],
		2620: [, 7],
		2637: [, 9],
		2649: [[2582, 2620], 512],
		2650: [[2583, 2620], 512],
		2651: [[2588, 2620], 512],
		2654: [[2603, 2620], 512],
		2748: [, 7],
		2765: [, 9],
		68109: [, 220],
		68111: [, 230],
		68152: [, 230],
		68153: [, 1],
		68154: [, 220],
		68159: [, 9]
	},
	2816: {
		2876: [, 7],
		2887: [, , { 2878: 2891, 2902: 2888, 2903: 2892 }],
		2888: [[2887, 2902]],
		2891: [[2887, 2878]],
		2892: [[2887, 2903]],
		2893: [, 9],
		2908: [[2849, 2876], 512],
		2909: [[2850, 2876], 512],
		2962: [, , { 3031: 2964 }],
		2964: [[2962, 3031]],
		3014: [, , { 3006: 3018, 3031: 3020 }],
		3015: [, , { 3006: 3019 }],
		3018: [[3014, 3006]],
		3019: [[3015, 3006]],
		3020: [[3014, 3031]],
		3021: [, 9]
	},
	3072: {
		3142: [, , { 3158: 3144 }],
		3144: [[3142, 3158]],
		3149: [, 9],
		3157: [, 84],
		3158: [, 91],
		3260: [, 7],
		3263: [, , { 3285: 3264 }],
		3264: [[3263, 3285]],
		3270: [, , { 3266: 3274, 3285: 3271, 3286: 3272 }],
		3271: [[3270, 3285]],
		3272: [[3270, 3286]],
		3274: [[3270, 3266], , { 3285: 3275 }],
		3275: [[3274, 3285]],
		3277: [, 9]
	},
	3328: {
		3398: [, , { 3390: 3402, 3415: 3404 }],
		3399: [, , { 3390: 3403 }],
		3402: [[3398, 3390]],
		3403: [[3399, 3390]],
		3404: [[3398, 3415]],
		3405: [, 9],
		3530: [, 9],
		3545: [, , { 3530: 3546, 3535: 3548, 3551: 3550 }],
		3546: [[3545, 3530]],
		3548: [[3545, 3535], , { 3530: 3549 }],
		3549: [[3548, 3530]],
		3550: [[3545, 3551]]
	},
	3584: {
		3635: [[3661, 3634], 256],
		3640: [, 103],
		3641: [, 103],
		3642: [, 9],
		3656: [, 107],
		3657: [, 107],
		3658: [, 107],
		3659: [, 107],
		3763: [[3789, 3762], 256],
		3768: [, 118],
		3769: [, 118],
		3784: [, 122],
		3785: [, 122],
		3786: [, 122],
		3787: [, 122],
		3804: [[3755, 3737], 256],
		3805: [[3755, 3745], 256]
	},
	3840: {
		3852: [[3851], 256],
		3864: [, 220],
		3865: [, 220],
		3893: [, 220],
		3895: [, 220],
		3897: [, 216],
		3907: [[3906, 4023], 512],
		3917: [[3916, 4023], 512],
		3922: [[3921, 4023], 512],
		3927: [[3926, 4023], 512],
		3932: [[3931, 4023], 512],
		3945: [[3904, 4021], 512],
		3953: [, 129],
		3954: [, 130],
		3955: [[3953, 3954], 512],
		3956: [, 132],
		3957: [[3953, 3956], 512],
		3958: [[4018, 3968], 512],
		3959: [[4018, 3969], 256],
		3960: [[4019, 3968], 512],
		3961: [[4019, 3969], 256],
		3962: [, 130],
		3963: [, 130],
		3964: [, 130],
		3965: [, 130],
		3968: [, 130],
		3969: [[3953, 3968], 512],
		3970: [, 230],
		3971: [, 230],
		3972: [, 9],
		3974: [, 230],
		3975: [, 230],
		3987: [[3986, 4023], 512],
		3997: [[3996, 4023], 512],
		4002: [[4001, 4023], 512],
		4007: [[4006, 4023], 512],
		4012: [[4011, 4023], 512],
		4025: [[3984, 4021], 512],
		4038: [, 220]
	},
	4096: {
		4133: [, , { 4142: 4134 }],
		4134: [[4133, 4142]],
		4151: [, 7],
		4153: [, 9],
		4154: [, 9],
		4237: [, 220],
		4348: [[4316], 256],
		69702: [, 9],
		69785: [, , { 69818: 69786 }],
		69786: [[69785, 69818]],
		69787: [, , { 69818: 69788 }],
		69788: [[69787, 69818]],
		69797: [, , { 69818: 69803 }],
		69803: [[69797, 69818]],
		69817: [, 9],
		69818: [, 7]
	},
	4352: {
		69888: [, 230],
		69889: [, 230],
		69890: [, 230],
		69934: [[69937, 69927]],
		69935: [[69938, 69927]],
		69937: [, , { 69927: 69934 }],
		69938: [, , { 69927: 69935 }],
		69939: [, 9],
		69940: [, 9],
		70080: [, 9]
	},
	4864: { 4957: [, 230], 4958: [, 230], 4959: [, 230] },
	5632: { 71350: [, 9], 71351: [, 7] },
	5888: { 5908: [, 9], 5940: [, 9], 6098: [, 9], 6109: [, 230] },
	6144: { 6313: [, 228] },
	6400: { 6457: [, 222], 6458: [, 230], 6459: [, 220] },
	6656: {
		6679: [, 230],
		6680: [, 220],
		6752: [, 9],
		6773: [, 230],
		6774: [, 230],
		6775: [, 230],
		6776: [, 230],
		6777: [, 230],
		6778: [, 230],
		6779: [, 230],
		6780: [, 230],
		6783: [, 220]
	},
	6912: {
		6917: [, , { 6965: 6918 }],
		6918: [[6917, 6965]],
		6919: [, , { 6965: 6920 }],
		6920: [[6919, 6965]],
		6921: [, , { 6965: 6922 }],
		6922: [[6921, 6965]],
		6923: [, , { 6965: 6924 }],
		6924: [[6923, 6965]],
		6925: [, , { 6965: 6926 }],
		6926: [[6925, 6965]],
		6929: [, , { 6965: 6930 }],
		6930: [[6929, 6965]],
		6964: [, 7],
		6970: [, , { 6965: 6971 }],
		6971: [[6970, 6965]],
		6972: [, , { 6965: 6973 }],
		6973: [[6972, 6965]],
		6974: [, , { 6965: 6976 }],
		6975: [, , { 6965: 6977 }],
		6976: [[6974, 6965]],
		6977: [[6975, 6965]],
		6978: [, , { 6965: 6979 }],
		6979: [[6978, 6965]],
		6980: [, 9],
		7019: [, 230],
		7020: [, 220],
		7021: [, 230],
		7022: [, 230],
		7023: [, 230],
		7024: [, 230],
		7025: [, 230],
		7026: [, 230],
		7027: [, 230],
		7082: [, 9],
		7083: [, 9],
		7142: [, 7],
		7154: [, 9],
		7155: [, 9]
	},
	7168: {
		7223: [, 7],
		7376: [, 230],
		7377: [, 230],
		7378: [, 230],
		7380: [, 1],
		7381: [, 220],
		7382: [, 220],
		7383: [, 220],
		7384: [, 220],
		7385: [, 220],
		7386: [, 230],
		7387: [, 230],
		7388: [, 220],
		7389: [, 220],
		7390: [, 220],
		7391: [, 220],
		7392: [, 230],
		7394: [, 1],
		7395: [, 1],
		7396: [, 1],
		7397: [, 1],
		7398: [, 1],
		7399: [, 1],
		7400: [, 1],
		7405: [, 220],
		7412: [, 230]
	},
	7424: {
		7468: [[65], 256],
		7469: [[198], 256],
		7470: [[66], 256],
		7472: [[68], 256],
		7473: [[69], 256],
		7474: [[398], 256],
		7475: [[71], 256],
		7476: [[72], 256],
		7477: [[73], 256],
		7478: [[74], 256],
		7479: [[75], 256],
		7480: [[76], 256],
		7481: [[77], 256],
		7482: [[78], 256],
		7484: [[79], 256],
		7485: [[546], 256],
		7486: [[80], 256],
		7487: [[82], 256],
		7488: [[84], 256],
		7489: [[85], 256],
		7490: [[87], 256],
		7491: [[97], 256],
		7492: [[592], 256],
		7493: [[593], 256],
		7494: [[7426], 256],
		7495: [[98], 256],
		7496: [[100], 256],
		7497: [[101], 256],
		7498: [[601], 256],
		7499: [[603], 256],
		7500: [[604], 256],
		7501: [[103], 256],
		7503: [[107], 256],
		7504: [[109], 256],
		7505: [[331], 256],
		7506: [[111], 256],
		7507: [[596], 256],
		7508: [[7446], 256],
		7509: [[7447], 256],
		7510: [[112], 256],
		7511: [[116], 256],
		7512: [[117], 256],
		7513: [[7453], 256],
		7514: [[623], 256],
		7515: [[118], 256],
		7516: [[7461], 256],
		7517: [[946], 256],
		7518: [[947], 256],
		7519: [[948], 256],
		7520: [[966], 256],
		7521: [[967], 256],
		7522: [[105], 256],
		7523: [[114], 256],
		7524: [[117], 256],
		7525: [[118], 256],
		7526: [[946], 256],
		7527: [[947], 256],
		7528: [[961], 256],
		7529: [[966], 256],
		7530: [[967], 256],
		7544: [[1085], 256],
		7579: [[594], 256],
		7580: [[99], 256],
		7581: [[597], 256],
		7582: [[240], 256],
		7583: [[604], 256],
		7584: [[102], 256],
		7585: [[607], 256],
		7586: [[609], 256],
		7587: [[613], 256],
		7588: [[616], 256],
		7589: [[617], 256],
		7590: [[618], 256],
		7591: [[7547], 256],
		7592: [[669], 256],
		7593: [[621], 256],
		7594: [[7557], 256],
		7595: [[671], 256],
		7596: [[625], 256],
		7597: [[624], 256],
		7598: [[626], 256],
		7599: [[627], 256],
		7600: [[628], 256],
		7601: [[629], 256],
		7602: [[632], 256],
		7603: [[642], 256],
		7604: [[643], 256],
		7605: [[427], 256],
		7606: [[649], 256],
		7607: [[650], 256],
		7608: [[7452], 256],
		7609: [[651], 256],
		7610: [[652], 256],
		7611: [[122], 256],
		7612: [[656], 256],
		7613: [[657], 256],
		7614: [[658], 256],
		7615: [[952], 256],
		7616: [, 230],
		7617: [, 230],
		7618: [, 220],
		7619: [, 230],
		7620: [, 230],
		7621: [, 230],
		7622: [, 230],
		7623: [, 230],
		7624: [, 230],
		7625: [, 230],
		7626: [, 220],
		7627: [, 230],
		7628: [, 230],
		7629: [, 234],
		7630: [, 214],
		7631: [, 220],
		7632: [, 202],
		7633: [, 230],
		7634: [, 230],
		7635: [, 230],
		7636: [, 230],
		7637: [, 230],
		7638: [, 230],
		7639: [, 230],
		7640: [, 230],
		7641: [, 230],
		7642: [, 230],
		7643: [, 230],
		7644: [, 230],
		7645: [, 230],
		7646: [, 230],
		7647: [, 230],
		7648: [, 230],
		7649: [, 230],
		7650: [, 230],
		7651: [, 230],
		7652: [, 230],
		7653: [, 230],
		7654: [, 230],
		7676: [, 233],
		7677: [, 220],
		7678: [, 230],
		7679: [, 220]
	},
	7680: {
		7680: [[65, 805]],
		7681: [[97, 805]],
		7682: [[66, 775]],
		7683: [[98, 775]],
		7684: [[66, 803]],
		7685: [[98, 803]],
		7686: [[66, 817]],
		7687: [[98, 817]],
		7688: [[199, 769]],
		7689: [[231, 769]],
		7690: [[68, 775]],
		7691: [[100, 775]],
		7692: [[68, 803]],
		7693: [[100, 803]],
		7694: [[68, 817]],
		7695: [[100, 817]],
		7696: [[68, 807]],
		7697: [[100, 807]],
		7698: [[68, 813]],
		7699: [[100, 813]],
		7700: [[274, 768]],
		7701: [[275, 768]],
		7702: [[274, 769]],
		7703: [[275, 769]],
		7704: [[69, 813]],
		7705: [[101, 813]],
		7706: [[69, 816]],
		7707: [[101, 816]],
		7708: [[552, 774]],
		7709: [[553, 774]],
		7710: [[70, 775]],
		7711: [[102, 775]],
		7712: [[71, 772]],
		7713: [[103, 772]],
		7714: [[72, 775]],
		7715: [[104, 775]],
		7716: [[72, 803]],
		7717: [[104, 803]],
		7718: [[72, 776]],
		7719: [[104, 776]],
		7720: [[72, 807]],
		7721: [[104, 807]],
		7722: [[72, 814]],
		7723: [[104, 814]],
		7724: [[73, 816]],
		7725: [[105, 816]],
		7726: [[207, 769]],
		7727: [[239, 769]],
		7728: [[75, 769]],
		7729: [[107, 769]],
		7730: [[75, 803]],
		7731: [[107, 803]],
		7732: [[75, 817]],
		7733: [[107, 817]],
		7734: [[76, 803], , { 772: 7736 }],
		7735: [[108, 803], , { 772: 7737 }],
		7736: [[7734, 772]],
		7737: [[7735, 772]],
		7738: [[76, 817]],
		7739: [[108, 817]],
		7740: [[76, 813]],
		7741: [[108, 813]],
		7742: [[77, 769]],
		7743: [[109, 769]],
		7744: [[77, 775]],
		7745: [[109, 775]],
		7746: [[77, 803]],
		7747: [[109, 803]],
		7748: [[78, 775]],
		7749: [[110, 775]],
		7750: [[78, 803]],
		7751: [[110, 803]],
		7752: [[78, 817]],
		7753: [[110, 817]],
		7754: [[78, 813]],
		7755: [[110, 813]],
		7756: [[213, 769]],
		7757: [[245, 769]],
		7758: [[213, 776]],
		7759: [[245, 776]],
		7760: [[332, 768]],
		7761: [[333, 768]],
		7762: [[332, 769]],
		7763: [[333, 769]],
		7764: [[80, 769]],
		7765: [[112, 769]],
		7766: [[80, 775]],
		7767: [[112, 775]],
		7768: [[82, 775]],
		7769: [[114, 775]],
		7770: [[82, 803], , { 772: 7772 }],
		7771: [[114, 803], , { 772: 7773 }],
		7772: [[7770, 772]],
		7773: [[7771, 772]],
		7774: [[82, 817]],
		7775: [[114, 817]],
		7776: [[83, 775]],
		7777: [[115, 775]],
		7778: [[83, 803], , { 775: 7784 }],
		7779: [[115, 803], , { 775: 7785 }],
		7780: [[346, 775]],
		7781: [[347, 775]],
		7782: [[352, 775]],
		7783: [[353, 775]],
		7784: [[7778, 775]],
		7785: [[7779, 775]],
		7786: [[84, 775]],
		7787: [[116, 775]],
		7788: [[84, 803]],
		7789: [[116, 803]],
		7790: [[84, 817]],
		7791: [[116, 817]],
		7792: [[84, 813]],
		7793: [[116, 813]],
		7794: [[85, 804]],
		7795: [[117, 804]],
		7796: [[85, 816]],
		7797: [[117, 816]],
		7798: [[85, 813]],
		7799: [[117, 813]],
		7800: [[360, 769]],
		7801: [[361, 769]],
		7802: [[362, 776]],
		7803: [[363, 776]],
		7804: [[86, 771]],
		7805: [[118, 771]],
		7806: [[86, 803]],
		7807: [[118, 803]],
		7808: [[87, 768]],
		7809: [[119, 768]],
		7810: [[87, 769]],
		7811: [[119, 769]],
		7812: [[87, 776]],
		7813: [[119, 776]],
		7814: [[87, 775]],
		7815: [[119, 775]],
		7816: [[87, 803]],
		7817: [[119, 803]],
		7818: [[88, 775]],
		7819: [[120, 775]],
		7820: [[88, 776]],
		7821: [[120, 776]],
		7822: [[89, 775]],
		7823: [[121, 775]],
		7824: [[90, 770]],
		7825: [[122, 770]],
		7826: [[90, 803]],
		7827: [[122, 803]],
		7828: [[90, 817]],
		7829: [[122, 817]],
		7830: [[104, 817]],
		7831: [[116, 776]],
		7832: [[119, 778]],
		7833: [[121, 778]],
		7834: [[97, 702], 256],
		7835: [[383, 775]],
		7840: [[65, 803], , { 770: 7852, 774: 7862 }],
		7841: [[97, 803], , { 770: 7853, 774: 7863 }],
		7842: [[65, 777]],
		7843: [[97, 777]],
		7844: [[194, 769]],
		7845: [[226, 769]],
		7846: [[194, 768]],
		7847: [[226, 768]],
		7848: [[194, 777]],
		7849: [[226, 777]],
		7850: [[194, 771]],
		7851: [[226, 771]],
		7852: [[7840, 770]],
		7853: [[7841, 770]],
		7854: [[258, 769]],
		7855: [[259, 769]],
		7856: [[258, 768]],
		7857: [[259, 768]],
		7858: [[258, 777]],
		7859: [[259, 777]],
		7860: [[258, 771]],
		7861: [[259, 771]],
		7862: [[7840, 774]],
		7863: [[7841, 774]],
		7864: [[69, 803], , { 770: 7878 }],
		7865: [[101, 803], , { 770: 7879 }],
		7866: [[69, 777]],
		7867: [[101, 777]],
		7868: [[69, 771]],
		7869: [[101, 771]],
		7870: [[202, 769]],
		7871: [[234, 769]],
		7872: [[202, 768]],
		7873: [[234, 768]],
		7874: [[202, 777]],
		7875: [[234, 777]],
		7876: [[202, 771]],
		7877: [[234, 771]],
		7878: [[7864, 770]],
		7879: [[7865, 770]],
		7880: [[73, 777]],
		7881: [[105, 777]],
		7882: [[73, 803]],
		7883: [[105, 803]],
		7884: [[79, 803], , { 770: 7896 }],
		7885: [[111, 803], , { 770: 7897 }],
		7886: [[79, 777]],
		7887: [[111, 777]],
		7888: [[212, 769]],
		7889: [[244, 769]],
		7890: [[212, 768]],
		7891: [[244, 768]],
		7892: [[212, 777]],
		7893: [[244, 777]],
		7894: [[212, 771]],
		7895: [[244, 771]],
		7896: [[7884, 770]],
		7897: [[7885, 770]],
		7898: [[416, 769]],
		7899: [[417, 769]],
		7900: [[416, 768]],
		7901: [[417, 768]],
		7902: [[416, 777]],
		7903: [[417, 777]],
		7904: [[416, 771]],
		7905: [[417, 771]],
		7906: [[416, 803]],
		7907: [[417, 803]],
		7908: [[85, 803]],
		7909: [[117, 803]],
		7910: [[85, 777]],
		7911: [[117, 777]],
		7912: [[431, 769]],
		7913: [[432, 769]],
		7914: [[431, 768]],
		7915: [[432, 768]],
		7916: [[431, 777]],
		7917: [[432, 777]],
		7918: [[431, 771]],
		7919: [[432, 771]],
		7920: [[431, 803]],
		7921: [[432, 803]],
		7922: [[89, 768]],
		7923: [[121, 768]],
		7924: [[89, 803]],
		7925: [[121, 803]],
		7926: [[89, 777]],
		7927: [[121, 777]],
		7928: [[89, 771]],
		7929: [[121, 771]]
	},
	7936: {
		7936: [[945, 787], , { 768: 7938, 769: 7940, 834: 7942, 837: 8064 }],
		7937: [[945, 788], , { 768: 7939, 769: 7941, 834: 7943, 837: 8065 }],
		7938: [[7936, 768], , { 837: 8066 }],
		7939: [[7937, 768], , { 837: 8067 }],
		7940: [[7936, 769], , { 837: 8068 }],
		7941: [[7937, 769], , { 837: 8069 }],
		7942: [[7936, 834], , { 837: 8070 }],
		7943: [[7937, 834], , { 837: 8071 }],
		7944: [[913, 787], , { 768: 7946, 769: 7948, 834: 7950, 837: 8072 }],
		7945: [[913, 788], , { 768: 7947, 769: 7949, 834: 7951, 837: 8073 }],
		7946: [[7944, 768], , { 837: 8074 }],
		7947: [[7945, 768], , { 837: 8075 }],
		7948: [[7944, 769], , { 837: 8076 }],
		7949: [[7945, 769], , { 837: 8077 }],
		7950: [[7944, 834], , { 837: 8078 }],
		7951: [[7945, 834], , { 837: 8079 }],
		7952: [[949, 787], , { 768: 7954, 769: 7956 }],
		7953: [[949, 788], , { 768: 7955, 769: 7957 }],
		7954: [[7952, 768]],
		7955: [[7953, 768]],
		7956: [[7952, 769]],
		7957: [[7953, 769]],
		7960: [[917, 787], , { 768: 7962, 769: 7964 }],
		7961: [[917, 788], , { 768: 7963, 769: 7965 }],
		7962: [[7960, 768]],
		7963: [[7961, 768]],
		7964: [[7960, 769]],
		7965: [[7961, 769]],
		7968: [[951, 787], , { 768: 7970, 769: 7972, 834: 7974, 837: 8080 }],
		7969: [[951, 788], , { 768: 7971, 769: 7973, 834: 7975, 837: 8081 }],
		7970: [[7968, 768], , { 837: 8082 }],
		7971: [[7969, 768], , { 837: 8083 }],
		7972: [[7968, 769], , { 837: 8084 }],
		7973: [[7969, 769], , { 837: 8085 }],
		7974: [[7968, 834], , { 837: 8086 }],
		7975: [[7969, 834], , { 837: 8087 }],
		7976: [[919, 787], , { 768: 7978, 769: 7980, 834: 7982, 837: 8088 }],
		7977: [[919, 788], , { 768: 7979, 769: 7981, 834: 7983, 837: 8089 }],
		7978: [[7976, 768], , { 837: 8090 }],
		7979: [[7977, 768], , { 837: 8091 }],
		7980: [[7976, 769], , { 837: 8092 }],
		7981: [[7977, 769], , { 837: 8093 }],
		7982: [[7976, 834], , { 837: 8094 }],
		7983: [[7977, 834], , { 837: 8095 }],
		7984: [[953, 787], , { 768: 7986, 769: 7988, 834: 7990 }],
		7985: [[953, 788], , { 768: 7987, 769: 7989, 834: 7991 }],
		7986: [[7984, 768]],
		7987: [[7985, 768]],
		7988: [[7984, 769]],
		7989: [[7985, 769]],
		7990: [[7984, 834]],
		7991: [[7985, 834]],
		7992: [[921, 787], , { 768: 7994, 769: 7996, 834: 7998 }],
		7993: [[921, 788], , { 768: 7995, 769: 7997, 834: 7999 }],
		7994: [[7992, 768]],
		7995: [[7993, 768]],
		7996: [[7992, 769]],
		7997: [[7993, 769]],
		7998: [[7992, 834]],
		7999: [[7993, 834]],
		8000: [[959, 787], , { 768: 8002, 769: 8004 }],
		8001: [[959, 788], , { 768: 8003, 769: 8005 }],
		8002: [[8000, 768]],
		8003: [[8001, 768]],
		8004: [[8000, 769]],
		8005: [[8001, 769]],
		8008: [[927, 787], , { 768: 8010, 769: 8012 }],
		8009: [[927, 788], , { 768: 8011, 769: 8013 }],
		8010: [[8008, 768]],
		8011: [[8009, 768]],
		8012: [[8008, 769]],
		8013: [[8009, 769]],
		8016: [[965, 787], , { 768: 8018, 769: 8020, 834: 8022 }],
		8017: [[965, 788], , { 768: 8019, 769: 8021, 834: 8023 }],
		8018: [[8016, 768]],
		8019: [[8017, 768]],
		8020: [[8016, 769]],
		8021: [[8017, 769]],
		8022: [[8016, 834]],
		8023: [[8017, 834]],
		8025: [[933, 788], , { 768: 8027, 769: 8029, 834: 8031 }],
		8027: [[8025, 768]],
		8029: [[8025, 769]],
		8031: [[8025, 834]],
		8032: [[969, 787], , { 768: 8034, 769: 8036, 834: 8038, 837: 8096 }],
		8033: [[969, 788], , { 768: 8035, 769: 8037, 834: 8039, 837: 8097 }],
		8034: [[8032, 768], , { 837: 8098 }],
		8035: [[8033, 768], , { 837: 8099 }],
		8036: [[8032, 769], , { 837: 8100 }],
		8037: [[8033, 769], , { 837: 8101 }],
		8038: [[8032, 834], , { 837: 8102 }],
		8039: [[8033, 834], , { 837: 8103 }],
		8040: [[937, 787], , { 768: 8042, 769: 8044, 834: 8046, 837: 8104 }],
		8041: [[937, 788], , { 768: 8043, 769: 8045, 834: 8047, 837: 8105 }],
		8042: [[8040, 768], , { 837: 8106 }],
		8043: [[8041, 768], , { 837: 8107 }],
		8044: [[8040, 769], , { 837: 8108 }],
		8045: [[8041, 769], , { 837: 8109 }],
		8046: [[8040, 834], , { 837: 8110 }],
		8047: [[8041, 834], , { 837: 8111 }],
		8048: [[945, 768], , { 837: 8114 }],
		8049: [[940]],
		8050: [[949, 768]],
		8051: [[941]],
		8052: [[951, 768], , { 837: 8130 }],
		8053: [[942]],
		8054: [[953, 768]],
		8055: [[943]],
		8056: [[959, 768]],
		8057: [[972]],
		8058: [[965, 768]],
		8059: [[973]],
		8060: [[969, 768], , { 837: 8178 }],
		8061: [[974]],
		8064: [[7936, 837]],
		8065: [[7937, 837]],
		8066: [[7938, 837]],
		8067: [[7939, 837]],
		8068: [[7940, 837]],
		8069: [[7941, 837]],
		8070: [[7942, 837]],
		8071: [[7943, 837]],
		8072: [[7944, 837]],
		8073: [[7945, 837]],
		8074: [[7946, 837]],
		8075: [[7947, 837]],
		8076: [[7948, 837]],
		8077: [[7949, 837]],
		8078: [[7950, 837]],
		8079: [[7951, 837]],
		8080: [[7968, 837]],
		8081: [[7969, 837]],
		8082: [[7970, 837]],
		8083: [[7971, 837]],
		8084: [[7972, 837]],
		8085: [[7973, 837]],
		8086: [[7974, 837]],
		8087: [[7975, 837]],
		8088: [[7976, 837]],
		8089: [[7977, 837]],
		8090: [[7978, 837]],
		8091: [[7979, 837]],
		8092: [[7980, 837]],
		8093: [[7981, 837]],
		8094: [[7982, 837]],
		8095: [[7983, 837]],
		8096: [[8032, 837]],
		8097: [[8033, 837]],
		8098: [[8034, 837]],
		8099: [[8035, 837]],
		8100: [[8036, 837]],
		8101: [[8037, 837]],
		8102: [[8038, 837]],
		8103: [[8039, 837]],
		8104: [[8040, 837]],
		8105: [[8041, 837]],
		8106: [[8042, 837]],
		8107: [[8043, 837]],
		8108: [[8044, 837]],
		8109: [[8045, 837]],
		8110: [[8046, 837]],
		8111: [[8047, 837]],
		8112: [[945, 774]],
		8113: [[945, 772]],
		8114: [[8048, 837]],
		8115: [[945, 837]],
		8116: [[940, 837]],
		8118: [[945, 834], , { 837: 8119 }],
		8119: [[8118, 837]],
		8120: [[913, 774]],
		8121: [[913, 772]],
		8122: [[913, 768]],
		8123: [[902]],
		8124: [[913, 837]],
		8125: [[32, 787], 256],
		8126: [[953]],
		8127: [[32, 787], 256, { 768: 8141, 769: 8142, 834: 8143 }],
		8128: [[32, 834], 256],
		8129: [[168, 834]],
		8130: [[8052, 837]],
		8131: [[951, 837]],
		8132: [[942, 837]],
		8134: [[951, 834], , { 837: 8135 }],
		8135: [[8134, 837]],
		8136: [[917, 768]],
		8137: [[904]],
		8138: [[919, 768]],
		8139: [[905]],
		8140: [[919, 837]],
		8141: [[8127, 768]],
		8142: [[8127, 769]],
		8143: [[8127, 834]],
		8144: [[953, 774]],
		8145: [[953, 772]],
		8146: [[970, 768]],
		8147: [[912]],
		8150: [[953, 834]],
		8151: [[970, 834]],
		8152: [[921, 774]],
		8153: [[921, 772]],
		8154: [[921, 768]],
		8155: [[906]],
		8157: [[8190, 768]],
		8158: [[8190, 769]],
		8159: [[8190, 834]],
		8160: [[965, 774]],
		8161: [[965, 772]],
		8162: [[971, 768]],
		8163: [[944]],
		8164: [[961, 787]],
		8165: [[961, 788]],
		8166: [[965, 834]],
		8167: [[971, 834]],
		8168: [[933, 774]],
		8169: [[933, 772]],
		8170: [[933, 768]],
		8171: [[910]],
		8172: [[929, 788]],
		8173: [[168, 768]],
		8174: [[901]],
		8175: [[96]],
		8178: [[8060, 837]],
		8179: [[969, 837]],
		8180: [[974, 837]],
		8182: [[969, 834], , { 837: 8183 }],
		8183: [[8182, 837]],
		8184: [[927, 768]],
		8185: [[908]],
		8186: [[937, 768]],
		8187: [[911]],
		8188: [[937, 837]],
		8189: [[180]],
		8190: [[32, 788], 256, { 768: 8157, 769: 8158, 834: 8159 }]
	},
	8192: {
		8192: [[8194]],
		8193: [[8195]],
		8194: [[32], 256],
		8195: [[32], 256],
		8196: [[32], 256],
		8197: [[32], 256],
		8198: [[32], 256],
		8199: [[32], 256],
		8200: [[32], 256],
		8201: [[32], 256],
		8202: [[32], 256],
		8209: [[8208], 256],
		8215: [[32, 819], 256],
		8228: [[46], 256],
		8229: [[46, 46], 256],
		8230: [[46, 46, 46], 256],
		8239: [[32], 256],
		8243: [[8242, 8242], 256],
		8244: [[8242, 8242, 8242], 256],
		8246: [[8245, 8245], 256],
		8247: [[8245, 8245, 8245], 256],
		8252: [[33, 33], 256],
		8254: [[32, 773], 256],
		8263: [[63, 63], 256],
		8264: [[63, 33], 256],
		8265: [[33, 63], 256],
		8279: [[8242, 8242, 8242, 8242], 256],
		8287: [[32], 256],
		8304: [[48], 256],
		8305: [[105], 256],
		8308: [[52], 256],
		8309: [[53], 256],
		8310: [[54], 256],
		8311: [[55], 256],
		8312: [[56], 256],
		8313: [[57], 256],
		8314: [[43], 256],
		8315: [[8722], 256],
		8316: [[61], 256],
		8317: [[40], 256],
		8318: [[41], 256],
		8319: [[110], 256],
		8320: [[48], 256],
		8321: [[49], 256],
		8322: [[50], 256],
		8323: [[51], 256],
		8324: [[52], 256],
		8325: [[53], 256],
		8326: [[54], 256],
		8327: [[55], 256],
		8328: [[56], 256],
		8329: [[57], 256],
		8330: [[43], 256],
		8331: [[8722], 256],
		8332: [[61], 256],
		8333: [[40], 256],
		8334: [[41], 256],
		8336: [[97], 256],
		8337: [[101], 256],
		8338: [[111], 256],
		8339: [[120], 256],
		8340: [[601], 256],
		8341: [[104], 256],
		8342: [[107], 256],
		8343: [[108], 256],
		8344: [[109], 256],
		8345: [[110], 256],
		8346: [[112], 256],
		8347: [[115], 256],
		8348: [[116], 256],
		8360: [[82, 115], 256],
		8400: [, 230],
		8401: [, 230],
		8402: [, 1],
		8403: [, 1],
		8404: [, 230],
		8405: [, 230],
		8406: [, 230],
		8407: [, 230],
		8408: [, 1],
		8409: [, 1],
		8410: [, 1],
		8411: [, 230],
		8412: [, 230],
		8417: [, 230],
		8421: [, 1],
		8422: [, 1],
		8423: [, 230],
		8424: [, 220],
		8425: [, 230],
		8426: [, 1],
		8427: [, 1],
		8428: [, 220],
		8429: [, 220],
		8430: [, 220],
		8431: [, 220],
		8432: [, 230]
	},
	8448: {
		8448: [[97, 47, 99], 256],
		8449: [[97, 47, 115], 256],
		8450: [[67], 256],
		8451: [[176, 67], 256],
		8453: [[99, 47, 111], 256],
		8454: [[99, 47, 117], 256],
		8455: [[400], 256],
		8457: [[176, 70], 256],
		8458: [[103], 256],
		8459: [[72], 256],
		8460: [[72], 256],
		8461: [[72], 256],
		8462: [[104], 256],
		8463: [[295], 256],
		8464: [[73], 256],
		8465: [[73], 256],
		8466: [[76], 256],
		8467: [[108], 256],
		8469: [[78], 256],
		8470: [[78, 111], 256],
		8473: [[80], 256],
		8474: [[81], 256],
		8475: [[82], 256],
		8476: [[82], 256],
		8477: [[82], 256],
		8480: [[83, 77], 256],
		8481: [[84, 69, 76], 256],
		8482: [[84, 77], 256],
		8484: [[90], 256],
		8486: [[937]],
		8488: [[90], 256],
		8490: [[75]],
		8491: [[197]],
		8492: [[66], 256],
		8493: [[67], 256],
		8495: [[101], 256],
		8496: [[69], 256],
		8497: [[70], 256],
		8499: [[77], 256],
		8500: [[111], 256],
		8501: [[1488], 256],
		8502: [[1489], 256],
		8503: [[1490], 256],
		8504: [[1491], 256],
		8505: [[105], 256],
		8507: [[70, 65, 88], 256],
		8508: [[960], 256],
		8509: [[947], 256],
		8510: [[915], 256],
		8511: [[928], 256],
		8512: [[8721], 256],
		8517: [[68], 256],
		8518: [[100], 256],
		8519: [[101], 256],
		8520: [[105], 256],
		8521: [[106], 256],
		8528: [[49, 8260, 55], 256],
		8529: [[49, 8260, 57], 256],
		8530: [[49, 8260, 49, 48], 256],
		8531: [[49, 8260, 51], 256],
		8532: [[50, 8260, 51], 256],
		8533: [[49, 8260, 53], 256],
		8534: [[50, 8260, 53], 256],
		8535: [[51, 8260, 53], 256],
		8536: [[52, 8260, 53], 256],
		8537: [[49, 8260, 54], 256],
		8538: [[53, 8260, 54], 256],
		8539: [[49, 8260, 56], 256],
		8540: [[51, 8260, 56], 256],
		8541: [[53, 8260, 56], 256],
		8542: [[55, 8260, 56], 256],
		8543: [[49, 8260], 256],
		8544: [[73], 256],
		8545: [[73, 73], 256],
		8546: [[73, 73, 73], 256],
		8547: [[73, 86], 256],
		8548: [[86], 256],
		8549: [[86, 73], 256],
		8550: [[86, 73, 73], 256],
		8551: [[86, 73, 73, 73], 256],
		8552: [[73, 88], 256],
		8553: [[88], 256],
		8554: [[88, 73], 256],
		8555: [[88, 73, 73], 256],
		8556: [[76], 256],
		8557: [[67], 256],
		8558: [[68], 256],
		8559: [[77], 256],
		8560: [[105], 256],
		8561: [[105, 105], 256],
		8562: [[105, 105, 105], 256],
		8563: [[105, 118], 256],
		8564: [[118], 256],
		8565: [[118, 105], 256],
		8566: [[118, 105, 105], 256],
		8567: [[118, 105, 105, 105], 256],
		8568: [[105, 120], 256],
		8569: [[120], 256],
		8570: [[120, 105], 256],
		8571: [[120, 105, 105], 256],
		8572: [[108], 256],
		8573: [[99], 256],
		8574: [[100], 256],
		8575: [[109], 256],
		8585: [[48, 8260, 51], 256],
		8592: [, , { 824: 8602 }],
		8594: [, , { 824: 8603 }],
		8596: [, , { 824: 8622 }],
		8602: [[8592, 824]],
		8603: [[8594, 824]],
		8622: [[8596, 824]],
		8653: [[8656, 824]],
		8654: [[8660, 824]],
		8655: [[8658, 824]],
		8656: [, , { 824: 8653 }],
		8658: [, , { 824: 8655 }],
		8660: [, , { 824: 8654 }]
	},
	8704: {
		8707: [, , { 824: 8708 }],
		8708: [[8707, 824]],
		8712: [, , { 824: 8713 }],
		8713: [[8712, 824]],
		8715: [, , { 824: 8716 }],
		8716: [[8715, 824]],
		8739: [, , { 824: 8740 }],
		8740: [[8739, 824]],
		8741: [, , { 824: 8742 }],
		8742: [[8741, 824]],
		8748: [[8747, 8747], 256],
		8749: [[8747, 8747, 8747], 256],
		8751: [[8750, 8750], 256],
		8752: [[8750, 8750, 8750], 256],
		8764: [, , { 824: 8769 }],
		8769: [[8764, 824]],
		8771: [, , { 824: 8772 }],
		8772: [[8771, 824]],
		8773: [, , { 824: 8775 }],
		8775: [[8773, 824]],
		8776: [, , { 824: 8777 }],
		8777: [[8776, 824]],
		8781: [, , { 824: 8813 }],
		8800: [[61, 824]],
		8801: [, , { 824: 8802 }],
		8802: [[8801, 824]],
		8804: [, , { 824: 8816 }],
		8805: [, , { 824: 8817 }],
		8813: [[8781, 824]],
		8814: [[60, 824]],
		8815: [[62, 824]],
		8816: [[8804, 824]],
		8817: [[8805, 824]],
		8818: [, , { 824: 8820 }],
		8819: [, , { 824: 8821 }],
		8820: [[8818, 824]],
		8821: [[8819, 824]],
		8822: [, , { 824: 8824 }],
		8823: [, , { 824: 8825 }],
		8824: [[8822, 824]],
		8825: [[8823, 824]],
		8826: [, , { 824: 8832 }],
		8827: [, , { 824: 8833 }],
		8828: [, , { 824: 8928 }],
		8829: [, , { 824: 8929 }],
		8832: [[8826, 824]],
		8833: [[8827, 824]],
		8834: [, , { 824: 8836 }],
		8835: [, , { 824: 8837 }],
		8836: [[8834, 824]],
		8837: [[8835, 824]],
		8838: [, , { 824: 8840 }],
		8839: [, , { 824: 8841 }],
		8840: [[8838, 824]],
		8841: [[8839, 824]],
		8849: [, , { 824: 8930 }],
		8850: [, , { 824: 8931 }],
		8866: [, , { 824: 8876 }],
		8872: [, , { 824: 8877 }],
		8873: [, , { 824: 8878 }],
		8875: [, , { 824: 8879 }],
		8876: [[8866, 824]],
		8877: [[8872, 824]],
		8878: [[8873, 824]],
		8879: [[8875, 824]],
		8882: [, , { 824: 8938 }],
		8883: [, , { 824: 8939 }],
		8884: [, , { 824: 8940 }],
		8885: [, , { 824: 8941 }],
		8928: [[8828, 824]],
		8929: [[8829, 824]],
		8930: [[8849, 824]],
		8931: [[8850, 824]],
		8938: [[8882, 824]],
		8939: [[8883, 824]],
		8940: [[8884, 824]],
		8941: [[8885, 824]]
	},
	8960: { 9001: [[12296]], 9002: [[12297]] },
	9216: {
		9312: [[49], 256],
		9313: [[50], 256],
		9314: [[51], 256],
		9315: [[52], 256],
		9316: [[53], 256],
		9317: [[54], 256],
		9318: [[55], 256],
		9319: [[56], 256],
		9320: [[57], 256],
		9321: [[49, 48], 256],
		9322: [[49, 49], 256],
		9323: [[49, 50], 256],
		9324: [[49, 51], 256],
		9325: [[49, 52], 256],
		9326: [[49, 53], 256],
		9327: [[49, 54], 256],
		9328: [[49, 55], 256],
		9329: [[49, 56], 256],
		9330: [[49, 57], 256],
		9331: [[50, 48], 256],
		9332: [[40, 49, 41], 256],
		9333: [[40, 50, 41], 256],
		9334: [[40, 51, 41], 256],
		9335: [[40, 52, 41], 256],
		9336: [[40, 53, 41], 256],
		9337: [[40, 54, 41], 256],
		9338: [[40, 55, 41], 256],
		9339: [[40, 56, 41], 256],
		9340: [[40, 57, 41], 256],
		9341: [[40, 49, 48, 41], 256],
		9342: [[40, 49, 49, 41], 256],
		9343: [[40, 49, 50, 41], 256],
		9344: [[40, 49, 51, 41], 256],
		9345: [[40, 49, 52, 41], 256],
		9346: [[40, 49, 53, 41], 256],
		9347: [[40, 49, 54, 41], 256],
		9348: [[40, 49, 55, 41], 256],
		9349: [[40, 49, 56, 41], 256],
		9350: [[40, 49, 57, 41], 256],
		9351: [[40, 50, 48, 41], 256],
		9352: [[49, 46], 256],
		9353: [[50, 46], 256],
		9354: [[51, 46], 256],
		9355: [[52, 46], 256],
		9356: [[53, 46], 256],
		9357: [[54, 46], 256],
		9358: [[55, 46], 256],
		9359: [[56, 46], 256],
		9360: [[57, 46], 256],
		9361: [[49, 48, 46], 256],
		9362: [[49, 49, 46], 256],
		9363: [[49, 50, 46], 256],
		9364: [[49, 51, 46], 256],
		9365: [[49, 52, 46], 256],
		9366: [[49, 53, 46], 256],
		9367: [[49, 54, 46], 256],
		9368: [[49, 55, 46], 256],
		9369: [[49, 56, 46], 256],
		9370: [[49, 57, 46], 256],
		9371: [[50, 48, 46], 256],
		9372: [[40, 97, 41], 256],
		9373: [[40, 98, 41], 256],
		9374: [[40, 99, 41], 256],
		9375: [[40, 100, 41], 256],
		9376: [[40, 101, 41], 256],
		9377: [[40, 102, 41], 256],
		9378: [[40, 103, 41], 256],
		9379: [[40, 104, 41], 256],
		9380: [[40, 105, 41], 256],
		9381: [[40, 106, 41], 256],
		9382: [[40, 107, 41], 256],
		9383: [[40, 108, 41], 256],
		9384: [[40, 109, 41], 256],
		9385: [[40, 110, 41], 256],
		9386: [[40, 111, 41], 256],
		9387: [[40, 112, 41], 256],
		9388: [[40, 113, 41], 256],
		9389: [[40, 114, 41], 256],
		9390: [[40, 115, 41], 256],
		9391: [[40, 116, 41], 256],
		9392: [[40, 117, 41], 256],
		9393: [[40, 118, 41], 256],
		9394: [[40, 119, 41], 256],
		9395: [[40, 120, 41], 256],
		9396: [[40, 121, 41], 256],
		9397: [[40, 122, 41], 256],
		9398: [[65], 256],
		9399: [[66], 256],
		9400: [[67], 256],
		9401: [[68], 256],
		9402: [[69], 256],
		9403: [[70], 256],
		9404: [[71], 256],
		9405: [[72], 256],
		9406: [[73], 256],
		9407: [[74], 256],
		9408: [[75], 256],
		9409: [[76], 256],
		9410: [[77], 256],
		9411: [[78], 256],
		9412: [[79], 256],
		9413: [[80], 256],
		9414: [[81], 256],
		9415: [[82], 256],
		9416: [[83], 256],
		9417: [[84], 256],
		9418: [[85], 256],
		9419: [[86], 256],
		9420: [[87], 256],
		9421: [[88], 256],
		9422: [[89], 256],
		9423: [[90], 256],
		9424: [[97], 256],
		9425: [[98], 256],
		9426: [[99], 256],
		9427: [[100], 256],
		9428: [[101], 256],
		9429: [[102], 256],
		9430: [[103], 256],
		9431: [[104], 256],
		9432: [[105], 256],
		9433: [[106], 256],
		9434: [[107], 256],
		9435: [[108], 256],
		9436: [[109], 256],
		9437: [[110], 256],
		9438: [[111], 256],
		9439: [[112], 256],
		9440: [[113], 256],
		9441: [[114], 256],
		9442: [[115], 256],
		9443: [[116], 256],
		9444: [[117], 256],
		9445: [[118], 256],
		9446: [[119], 256],
		9447: [[120], 256],
		9448: [[121], 256],
		9449: [[122], 256],
		9450: [[48], 256]
	},
	10752: {
		10764: [[8747, 8747, 8747, 8747], 256],
		10868: [[58, 58, 61], 256],
		10869: [[61, 61], 256],
		10870: [[61, 61, 61], 256],
		10972: [[10973, 824], 512]
	},
	11264: {
		11388: [[106], 256],
		11389: [[86], 256],
		11503: [, 230],
		11504: [, 230],
		11505: [, 230]
	},
	11520: {
		11631: [[11617], 256],
		11647: [, 9],
		11744: [, 230],
		11745: [, 230],
		11746: [, 230],
		11747: [, 230],
		11748: [, 230],
		11749: [, 230],
		11750: [, 230],
		11751: [, 230],
		11752: [, 230],
		11753: [, 230],
		11754: [, 230],
		11755: [, 230],
		11756: [, 230],
		11757: [, 230],
		11758: [, 230],
		11759: [, 230],
		11760: [, 230],
		11761: [, 230],
		11762: [, 230],
		11763: [, 230],
		11764: [, 230],
		11765: [, 230],
		11766: [, 230],
		11767: [, 230],
		11768: [, 230],
		11769: [, 230],
		11770: [, 230],
		11771: [, 230],
		11772: [, 230],
		11773: [, 230],
		11774: [, 230],
		11775: [, 230]
	},
	11776: { 11935: [[27597], 256], 12019: [[40863], 256] },
	12032: {
		12032: [[19968], 256],
		12033: [[20008], 256],
		12034: [[20022], 256],
		12035: [[20031], 256],
		12036: [[20057], 256],
		12037: [[20101], 256],
		12038: [[20108], 256],
		12039: [[20128], 256],
		12040: [[20154], 256],
		12041: [[20799], 256],
		12042: [[20837], 256],
		12043: [[20843], 256],
		12044: [[20866], 256],
		12045: [[20886], 256],
		12046: [[20907], 256],
		12047: [[20960], 256],
		12048: [[20981], 256],
		12049: [[20992], 256],
		12050: [[21147], 256],
		12051: [[21241], 256],
		12052: [[21269], 256],
		12053: [[21274], 256],
		12054: [[21304], 256],
		12055: [[21313], 256],
		12056: [[21340], 256],
		12057: [[21353], 256],
		12058: [[21378], 256],
		12059: [[21430], 256],
		12060: [[21448], 256],
		12061: [[21475], 256],
		12062: [[22231], 256],
		12063: [[22303], 256],
		12064: [[22763], 256],
		12065: [[22786], 256],
		12066: [[22794], 256],
		12067: [[22805], 256],
		12068: [[22823], 256],
		12069: [[22899], 256],
		12070: [[23376], 256],
		12071: [[23424], 256],
		12072: [[23544], 256],
		12073: [[23567], 256],
		12074: [[23586], 256],
		12075: [[23608], 256],
		12076: [[23662], 256],
		12077: [[23665], 256],
		12078: [[24027], 256],
		12079: [[24037], 256],
		12080: [[24049], 256],
		12081: [[24062], 256],
		12082: [[24178], 256],
		12083: [[24186], 256],
		12084: [[24191], 256],
		12085: [[24308], 256],
		12086: [[24318], 256],
		12087: [[24331], 256],
		12088: [[24339], 256],
		12089: [[24400], 256],
		12090: [[24417], 256],
		12091: [[24435], 256],
		12092: [[24515], 256],
		12093: [[25096], 256],
		12094: [[25142], 256],
		12095: [[25163], 256],
		12096: [[25903], 256],
		12097: [[25908], 256],
		12098: [[25991], 256],
		12099: [[26007], 256],
		12100: [[26020], 256],
		12101: [[26041], 256],
		12102: [[26080], 256],
		12103: [[26085], 256],
		12104: [[26352], 256],
		12105: [[26376], 256],
		12106: [[26408], 256],
		12107: [[27424], 256],
		12108: [[27490], 256],
		12109: [[27513], 256],
		12110: [[27571], 256],
		12111: [[27595], 256],
		12112: [[27604], 256],
		12113: [[27611], 256],
		12114: [[27663], 256],
		12115: [[27668], 256],
		12116: [[27700], 256],
		12117: [[28779], 256],
		12118: [[29226], 256],
		12119: [[29238], 256],
		12120: [[29243], 256],
		12121: [[29247], 256],
		12122: [[29255], 256],
		12123: [[29273], 256],
		12124: [[29275], 256],
		12125: [[29356], 256],
		12126: [[29572], 256],
		12127: [[29577], 256],
		12128: [[29916], 256],
		12129: [[29926], 256],
		12130: [[29976], 256],
		12131: [[29983], 256],
		12132: [[29992], 256],
		12133: [[30000], 256],
		12134: [[30091], 256],
		12135: [[30098], 256],
		12136: [[30326], 256],
		12137: [[30333], 256],
		12138: [[30382], 256],
		12139: [[30399], 256],
		12140: [[30446], 256],
		12141: [[30683], 256],
		12142: [[30690], 256],
		12143: [[30707], 256],
		12144: [[31034], 256],
		12145: [[31160], 256],
		12146: [[31166], 256],
		12147: [[31348], 256],
		12148: [[31435], 256],
		12149: [[31481], 256],
		12150: [[31859], 256],
		12151: [[31992], 256],
		12152: [[32566], 256],
		12153: [[32593], 256],
		12154: [[32650], 256],
		12155: [[32701], 256],
		12156: [[32769], 256],
		12157: [[32780], 256],
		12158: [[32786], 256],
		12159: [[32819], 256],
		12160: [[32895], 256],
		12161: [[32905], 256],
		12162: [[33251], 256],
		12163: [[33258], 256],
		12164: [[33267], 256],
		12165: [[33276], 256],
		12166: [[33292], 256],
		12167: [[33307], 256],
		12168: [[33311], 256],
		12169: [[33390], 256],
		12170: [[33394], 256],
		12171: [[33400], 256],
		12172: [[34381], 256],
		12173: [[34411], 256],
		12174: [[34880], 256],
		12175: [[34892], 256],
		12176: [[34915], 256],
		12177: [[35198], 256],
		12178: [[35211], 256],
		12179: [[35282], 256],
		12180: [[35328], 256],
		12181: [[35895], 256],
		12182: [[35910], 256],
		12183: [[35925], 256],
		12184: [[35960], 256],
		12185: [[35997], 256],
		12186: [[36196], 256],
		12187: [[36208], 256],
		12188: [[36275], 256],
		12189: [[36523], 256],
		12190: [[36554], 256],
		12191: [[36763], 256],
		12192: [[36784], 256],
		12193: [[36789], 256],
		12194: [[37009], 256],
		12195: [[37193], 256],
		12196: [[37318], 256],
		12197: [[37324], 256],
		12198: [[37329], 256],
		12199: [[38263], 256],
		12200: [[38272], 256],
		12201: [[38428], 256],
		12202: [[38582], 256],
		12203: [[38585], 256],
		12204: [[38632], 256],
		12205: [[38737], 256],
		12206: [[38750], 256],
		12207: [[38754], 256],
		12208: [[38761], 256],
		12209: [[38859], 256],
		12210: [[38893], 256],
		12211: [[38899], 256],
		12212: [[38913], 256],
		12213: [[39080], 256],
		12214: [[39131], 256],
		12215: [[39135], 256],
		12216: [[39318], 256],
		12217: [[39321], 256],
		12218: [[39340], 256],
		12219: [[39592], 256],
		12220: [[39640], 256],
		12221: [[39647], 256],
		12222: [[39717], 256],
		12223: [[39727], 256],
		12224: [[39730], 256],
		12225: [[39740], 256],
		12226: [[39770], 256],
		12227: [[40165], 256],
		12228: [[40565], 256],
		12229: [[40575], 256],
		12230: [[40613], 256],
		12231: [[40635], 256],
		12232: [[40643], 256],
		12233: [[40653], 256],
		12234: [[40657], 256],
		12235: [[40697], 256],
		12236: [[40701], 256],
		12237: [[40718], 256],
		12238: [[40723], 256],
		12239: [[40736], 256],
		12240: [[40763], 256],
		12241: [[40778], 256],
		12242: [[40786], 256],
		12243: [[40845], 256],
		12244: [[40860], 256],
		12245: [[40864], 256]
	},
	12288: {
		12288: [[32], 256],
		12330: [, 218],
		12331: [, 228],
		12332: [, 232],
		12333: [, 222],
		12334: [, 224],
		12335: [, 224],
		12342: [[12306], 256],
		12344: [[21313], 256],
		12345: [[21316], 256],
		12346: [[21317], 256],
		12358: [, , { 12441: 12436 }],
		12363: [, , { 12441: 12364 }],
		12364: [[12363, 12441]],
		12365: [, , { 12441: 12366 }],
		12366: [[12365, 12441]],
		12367: [, , { 12441: 12368 }],
		12368: [[12367, 12441]],
		12369: [, , { 12441: 12370 }],
		12370: [[12369, 12441]],
		12371: [, , { 12441: 12372 }],
		12372: [[12371, 12441]],
		12373: [, , { 12441: 12374 }],
		12374: [[12373, 12441]],
		12375: [, , { 12441: 12376 }],
		12376: [[12375, 12441]],
		12377: [, , { 12441: 12378 }],
		12378: [[12377, 12441]],
		12379: [, , { 12441: 12380 }],
		12380: [[12379, 12441]],
		12381: [, , { 12441: 12382 }],
		12382: [[12381, 12441]],
		12383: [, , { 12441: 12384 }],
		12384: [[12383, 12441]],
		12385: [, , { 12441: 12386 }],
		12386: [[12385, 12441]],
		12388: [, , { 12441: 12389 }],
		12389: [[12388, 12441]],
		12390: [, , { 12441: 12391 }],
		12391: [[12390, 12441]],
		12392: [, , { 12441: 12393 }],
		12393: [[12392, 12441]],
		12399: [, , { 12441: 12400, 12442: 12401 }],
		12400: [[12399, 12441]],
		12401: [[12399, 12442]],
		12402: [, , { 12441: 12403, 12442: 12404 }],
		12403: [[12402, 12441]],
		12404: [[12402, 12442]],
		12405: [, , { 12441: 12406, 12442: 12407 }],
		12406: [[12405, 12441]],
		12407: [[12405, 12442]],
		12408: [, , { 12441: 12409, 12442: 12410 }],
		12409: [[12408, 12441]],
		12410: [[12408, 12442]],
		12411: [, , { 12441: 12412, 12442: 12413 }],
		12412: [[12411, 12441]],
		12413: [[12411, 12442]],
		12436: [[12358, 12441]],
		12441: [, 8],
		12442: [, 8],
		12443: [[32, 12441], 256],
		12444: [[32, 12442], 256],
		12445: [, , { 12441: 12446 }],
		12446: [[12445, 12441]],
		12447: [[12424, 12426], 256],
		12454: [, , { 12441: 12532 }],
		12459: [, , { 12441: 12460 }],
		12460: [[12459, 12441]],
		12461: [, , { 12441: 12462 }],
		12462: [[12461, 12441]],
		12463: [, , { 12441: 12464 }],
		12464: [[12463, 12441]],
		12465: [, , { 12441: 12466 }],
		12466: [[12465, 12441]],
		12467: [, , { 12441: 12468 }],
		12468: [[12467, 12441]],
		12469: [, , { 12441: 12470 }],
		12470: [[12469, 12441]],
		12471: [, , { 12441: 12472 }],
		12472: [[12471, 12441]],
		12473: [, , { 12441: 12474 }],
		12474: [[12473, 12441]],
		12475: [, , { 12441: 12476 }],
		12476: [[12475, 12441]],
		12477: [, , { 12441: 12478 }],
		12478: [[12477, 12441]],
		12479: [, , { 12441: 12480 }],
		12480: [[12479, 12441]],
		12481: [, , { 12441: 12482 }],
		12482: [[12481, 12441]],
		12484: [, , { 12441: 12485 }],
		12485: [[12484, 12441]],
		12486: [, , { 12441: 12487 }],
		12487: [[12486, 12441]],
		12488: [, , { 12441: 12489 }],
		12489: [[12488, 12441]],
		12495: [, , { 12441: 12496, 12442: 12497 }],
		12496: [[12495, 12441]],
		12497: [[12495, 12442]],
		12498: [, , { 12441: 12499, 12442: 12500 }],
		12499: [[12498, 12441]],
		12500: [[12498, 12442]],
		12501: [, , { 12441: 12502, 12442: 12503 }],
		12502: [[12501, 12441]],
		12503: [[12501, 12442]],
		12504: [, , { 12441: 12505, 12442: 12506 }],
		12505: [[12504, 12441]],
		12506: [[12504, 12442]],
		12507: [, , { 12441: 12508, 12442: 12509 }],
		12508: [[12507, 12441]],
		12509: [[12507, 12442]],
		12527: [, , { 12441: 12535 }],
		12528: [, , { 12441: 12536 }],
		12529: [, , { 12441: 12537 }],
		12530: [, , { 12441: 12538 }],
		12532: [[12454, 12441]],
		12535: [[12527, 12441]],
		12536: [[12528, 12441]],
		12537: [[12529, 12441]],
		12538: [[12530, 12441]],
		12541: [, , { 12441: 12542 }],
		12542: [[12541, 12441]],
		12543: [[12467, 12488], 256]
	},
	12544: {
		12593: [[4352], 256],
		12594: [[4353], 256],
		12595: [[4522], 256],
		12596: [[4354], 256],
		12597: [[4524], 256],
		12598: [[4525], 256],
		12599: [[4355], 256],
		12600: [[4356], 256],
		12601: [[4357], 256],
		12602: [[4528], 256],
		12603: [[4529], 256],
		12604: [[4530], 256],
		12605: [[4531], 256],
		12606: [[4532], 256],
		12607: [[4533], 256],
		12608: [[4378], 256],
		12609: [[4358], 256],
		12610: [[4359], 256],
		12611: [[4360], 256],
		12612: [[4385], 256],
		12613: [[4361], 256],
		12614: [[4362], 256],
		12615: [[4363], 256],
		12616: [[4364], 256],
		12617: [[4365], 256],
		12618: [[4366], 256],
		12619: [[4367], 256],
		12620: [[4368], 256],
		12621: [[4369], 256],
		12622: [[4370], 256],
		12623: [[4449], 256],
		12624: [[4450], 256],
		12625: [[4451], 256],
		12626: [[4452], 256],
		12627: [[4453], 256],
		12628: [[4454], 256],
		12629: [[4455], 256],
		12630: [[4456], 256],
		12631: [[4457], 256],
		12632: [[4458], 256],
		12633: [[4459], 256],
		12634: [[4460], 256],
		12635: [[4461], 256],
		12636: [[4462], 256],
		12637: [[4463], 256],
		12638: [[4464], 256],
		12639: [[4465], 256],
		12640: [[4466], 256],
		12641: [[4467], 256],
		12642: [[4468], 256],
		12643: [[4469], 256],
		12644: [[4448], 256],
		12645: [[4372], 256],
		12646: [[4373], 256],
		12647: [[4551], 256],
		12648: [[4552], 256],
		12649: [[4556], 256],
		12650: [[4558], 256],
		12651: [[4563], 256],
		12652: [[4567], 256],
		12653: [[4569], 256],
		12654: [[4380], 256],
		12655: [[4573], 256],
		12656: [[4575], 256],
		12657: [[4381], 256],
		12658: [[4382], 256],
		12659: [[4384], 256],
		12660: [[4386], 256],
		12661: [[4387], 256],
		12662: [[4391], 256],
		12663: [[4393], 256],
		12664: [[4395], 256],
		12665: [[4396], 256],
		12666: [[4397], 256],
		12667: [[4398], 256],
		12668: [[4399], 256],
		12669: [[4402], 256],
		12670: [[4406], 256],
		12671: [[4416], 256],
		12672: [[4423], 256],
		12673: [[4428], 256],
		12674: [[4593], 256],
		12675: [[4594], 256],
		12676: [[4439], 256],
		12677: [[4440], 256],
		12678: [[4441], 256],
		12679: [[4484], 256],
		12680: [[4485], 256],
		12681: [[4488], 256],
		12682: [[4497], 256],
		12683: [[4498], 256],
		12684: [[4500], 256],
		12685: [[4510], 256],
		12686: [[4513], 256],
		12690: [[19968], 256],
		12691: [[20108], 256],
		12692: [[19977], 256],
		12693: [[22235], 256],
		12694: [[19978], 256],
		12695: [[20013], 256],
		12696: [[19979], 256],
		12697: [[30002], 256],
		12698: [[20057], 256],
		12699: [[19993], 256],
		12700: [[19969], 256],
		12701: [[22825], 256],
		12702: [[22320], 256],
		12703: [[20154], 256]
	},
	12800: {
		12800: [[40, 4352, 41], 256],
		12801: [[40, 4354, 41], 256],
		12802: [[40, 4355, 41], 256],
		12803: [[40, 4357, 41], 256],
		12804: [[40, 4358, 41], 256],
		12805: [[40, 4359, 41], 256],
		12806: [[40, 4361, 41], 256],
		12807: [[40, 4363, 41], 256],
		12808: [[40, 4364, 41], 256],
		12809: [[40, 4366, 41], 256],
		12810: [[40, 4367, 41], 256],
		12811: [[40, 4368, 41], 256],
		12812: [[40, 4369, 41], 256],
		12813: [[40, 4370, 41], 256],
		12814: [[40, 4352, 4449, 41], 256],
		12815: [[40, 4354, 4449, 41], 256],
		12816: [[40, 4355, 4449, 41], 256],
		12817: [[40, 4357, 4449, 41], 256],
		12818: [[40, 4358, 4449, 41], 256],
		12819: [[40, 4359, 4449, 41], 256],
		12820: [[40, 4361, 4449, 41], 256],
		12821: [[40, 4363, 4449, 41], 256],
		12822: [[40, 4364, 4449, 41], 256],
		12823: [[40, 4366, 4449, 41], 256],
		12824: [[40, 4367, 4449, 41], 256],
		12825: [[40, 4368, 4449, 41], 256],
		12826: [[40, 4369, 4449, 41], 256],
		12827: [[40, 4370, 4449, 41], 256],
		12828: [[40, 4364, 4462, 41], 256],
		12829: [[40, 4363, 4457, 4364, 4453, 4523, 41], 256],
		12830: [[40, 4363, 4457, 4370, 4462, 41], 256],
		12832: [[40, 19968, 41], 256],
		12833: [[40, 20108, 41], 256],
		12834: [[40, 19977, 41], 256],
		12835: [[40, 22235, 41], 256],
		12836: [[40, 20116, 41], 256],
		12837: [[40, 20845, 41], 256],
		12838: [[40, 19971, 41], 256],
		12839: [[40, 20843, 41], 256],
		12840: [[40, 20061, 41], 256],
		12841: [[40, 21313, 41], 256],
		12842: [[40, 26376, 41], 256],
		12843: [[40, 28779, 41], 256],
		12844: [[40, 27700, 41], 256],
		12845: [[40, 26408, 41], 256],
		12846: [[40, 37329, 41], 256],
		12847: [[40, 22303, 41], 256],
		12848: [[40, 26085, 41], 256],
		12849: [[40, 26666, 41], 256],
		12850: [[40, 26377, 41], 256],
		12851: [[40, 31038, 41], 256],
		12852: [[40, 21517, 41], 256],
		12853: [[40, 29305, 41], 256],
		12854: [[40, 36001, 41], 256],
		12855: [[40, 31069, 41], 256],
		12856: [[40, 21172, 41], 256],
		12857: [[40, 20195, 41], 256],
		12858: [[40, 21628, 41], 256],
		12859: [[40, 23398, 41], 256],
		12860: [[40, 30435, 41], 256],
		12861: [[40, 20225, 41], 256],
		12862: [[40, 36039, 41], 256],
		12863: [[40, 21332, 41], 256],
		12864: [[40, 31085, 41], 256],
		12865: [[40, 20241, 41], 256],
		12866: [[40, 33258, 41], 256],
		12867: [[40, 33267, 41], 256],
		12868: [[21839], 256],
		12869: [[24188], 256],
		12870: [[25991], 256],
		12871: [[31631], 256],
		12880: [[80, 84, 69], 256],
		12881: [[50, 49], 256],
		12882: [[50, 50], 256],
		12883: [[50, 51], 256],
		12884: [[50, 52], 256],
		12885: [[50, 53], 256],
		12886: [[50, 54], 256],
		12887: [[50, 55], 256],
		12888: [[50, 56], 256],
		12889: [[50, 57], 256],
		12890: [[51, 48], 256],
		12891: [[51, 49], 256],
		12892: [[51, 50], 256],
		12893: [[51, 51], 256],
		12894: [[51, 52], 256],
		12895: [[51, 53], 256],
		12896: [[4352], 256],
		12897: [[4354], 256],
		12898: [[4355], 256],
		12899: [[4357], 256],
		12900: [[4358], 256],
		12901: [[4359], 256],
		12902: [[4361], 256],
		12903: [[4363], 256],
		12904: [[4364], 256],
		12905: [[4366], 256],
		12906: [[4367], 256],
		12907: [[4368], 256],
		12908: [[4369], 256],
		12909: [[4370], 256],
		12910: [[4352, 4449], 256],
		12911: [[4354, 4449], 256],
		12912: [[4355, 4449], 256],
		12913: [[4357, 4449], 256],
		12914: [[4358, 4449], 256],
		12915: [[4359, 4449], 256],
		12916: [[4361, 4449], 256],
		12917: [[4363, 4449], 256],
		12918: [[4364, 4449], 256],
		12919: [[4366, 4449], 256],
		12920: [[4367, 4449], 256],
		12921: [[4368, 4449], 256],
		12922: [[4369, 4449], 256],
		12923: [[4370, 4449], 256],
		12924: [[4366, 4449, 4535, 4352, 4457], 256],
		12925: [[4364, 4462, 4363, 4468], 256],
		12926: [[4363, 4462], 256],
		12928: [[19968], 256],
		12929: [[20108], 256],
		12930: [[19977], 256],
		12931: [[22235], 256],
		12932: [[20116], 256],
		12933: [[20845], 256],
		12934: [[19971], 256],
		12935: [[20843], 256],
		12936: [[20061], 256],
		12937: [[21313], 256],
		12938: [[26376], 256],
		12939: [[28779], 256],
		12940: [[27700], 256],
		12941: [[26408], 256],
		12942: [[37329], 256],
		12943: [[22303], 256],
		12944: [[26085], 256],
		12945: [[26666], 256],
		12946: [[26377], 256],
		12947: [[31038], 256],
		12948: [[21517], 256],
		12949: [[29305], 256],
		12950: [[36001], 256],
		12951: [[31069], 256],
		12952: [[21172], 256],
		12953: [[31192], 256],
		12954: [[30007], 256],
		12955: [[22899], 256],
		12956: [[36969], 256],
		12957: [[20778], 256],
		12958: [[21360], 256],
		12959: [[27880], 256],
		12960: [[38917], 256],
		12961: [[20241], 256],
		12962: [[20889], 256],
		12963: [[27491], 256],
		12964: [[19978], 256],
		12965: [[20013], 256],
		12966: [[19979], 256],
		12967: [[24038], 256],
		12968: [[21491], 256],
		12969: [[21307], 256],
		12970: [[23447], 256],
		12971: [[23398], 256],
		12972: [[30435], 256],
		12973: [[20225], 256],
		12974: [[36039], 256],
		12975: [[21332], 256],
		12976: [[22812], 256],
		12977: [[51, 54], 256],
		12978: [[51, 55], 256],
		12979: [[51, 56], 256],
		12980: [[51, 57], 256],
		12981: [[52, 48], 256],
		12982: [[52, 49], 256],
		12983: [[52, 50], 256],
		12984: [[52, 51], 256],
		12985: [[52, 52], 256],
		12986: [[52, 53], 256],
		12987: [[52, 54], 256],
		12988: [[52, 55], 256],
		12989: [[52, 56], 256],
		12990: [[52, 57], 256],
		12991: [[53, 48], 256],
		12992: [[49, 26376], 256],
		12993: [[50, 26376], 256],
		12994: [[51, 26376], 256],
		12995: [[52, 26376], 256],
		12996: [[53, 26376], 256],
		12997: [[54, 26376], 256],
		12998: [[55, 26376], 256],
		12999: [[56, 26376], 256],
		13000: [[57, 26376], 256],
		13001: [[49, 48, 26376], 256],
		13002: [[49, 49, 26376], 256],
		13003: [[49, 50, 26376], 256],
		13004: [[72, 103], 256],
		13005: [[101, 114, 103], 256],
		13006: [[101, 86], 256],
		13007: [[76, 84, 68], 256],
		13008: [[12450], 256],
		13009: [[12452], 256],
		13010: [[12454], 256],
		13011: [[12456], 256],
		13012: [[12458], 256],
		13013: [[12459], 256],
		13014: [[12461], 256],
		13015: [[12463], 256],
		13016: [[12465], 256],
		13017: [[12467], 256],
		13018: [[12469], 256],
		13019: [[12471], 256],
		13020: [[12473], 256],
		13021: [[12475], 256],
		13022: [[12477], 256],
		13023: [[12479], 256],
		13024: [[12481], 256],
		13025: [[12484], 256],
		13026: [[12486], 256],
		13027: [[12488], 256],
		13028: [[12490], 256],
		13029: [[12491], 256],
		13030: [[12492], 256],
		13031: [[12493], 256],
		13032: [[12494], 256],
		13033: [[12495], 256],
		13034: [[12498], 256],
		13035: [[12501], 256],
		13036: [[12504], 256],
		13037: [[12507], 256],
		13038: [[12510], 256],
		13039: [[12511], 256],
		13040: [[12512], 256],
		13041: [[12513], 256],
		13042: [[12514], 256],
		13043: [[12516], 256],
		13044: [[12518], 256],
		13045: [[12520], 256],
		13046: [[12521], 256],
		13047: [[12522], 256],
		13048: [[12523], 256],
		13049: [[12524], 256],
		13050: [[12525], 256],
		13051: [[12527], 256],
		13052: [[12528], 256],
		13053: [[12529], 256],
		13054: [[12530], 256]
	},
	13056: {
		13056: [[12450, 12497, 12540, 12488], 256],
		13057: [[12450, 12523, 12501, 12449], 256],
		13058: [[12450, 12531, 12506, 12450], 256],
		13059: [[12450, 12540, 12523], 256],
		13060: [[12452, 12491, 12531, 12464], 256],
		13061: [[12452, 12531, 12481], 256],
		13062: [[12454, 12457, 12531], 256],
		13063: [[12456, 12473, 12463, 12540, 12489], 256],
		13064: [[12456, 12540, 12459, 12540], 256],
		13065: [[12458, 12531, 12473], 256],
		13066: [[12458, 12540, 12512], 256],
		13067: [[12459, 12452, 12522], 256],
		13068: [[12459, 12521, 12483, 12488], 256],
		13069: [[12459, 12525, 12522, 12540], 256],
		13070: [[12460, 12525, 12531], 256],
		13071: [[12460, 12531, 12510], 256],
		13072: [[12462, 12460], 256],
		13073: [[12462, 12491, 12540], 256],
		13074: [[12461, 12517, 12522, 12540], 256],
		13075: [[12462, 12523, 12480, 12540], 256],
		13076: [[12461, 12525], 256],
		13077: [[12461, 12525, 12464, 12521, 12512], 256],
		13078: [[12461, 12525, 12513, 12540, 12488, 12523], 256],
		13079: [[12461, 12525, 12527, 12483, 12488], 256],
		13080: [[12464, 12521, 12512], 256],
		13081: [[12464, 12521, 12512, 12488, 12531], 256],
		13082: [[12463, 12523, 12476, 12452, 12525], 256],
		13083: [[12463, 12525, 12540, 12493], 256],
		13084: [[12465, 12540, 12473], 256],
		13085: [[12467, 12523, 12490], 256],
		13086: [[12467, 12540, 12509], 256],
		13087: [[12469, 12452, 12463, 12523], 256],
		13088: [[12469, 12531, 12481, 12540, 12512], 256],
		13089: [[12471, 12522, 12531, 12464], 256],
		13090: [[12475, 12531, 12481], 256],
		13091: [[12475, 12531, 12488], 256],
		13092: [[12480, 12540, 12473], 256],
		13093: [[12487, 12471], 256],
		13094: [[12489, 12523], 256],
		13095: [[12488, 12531], 256],
		13096: [[12490, 12494], 256],
		13097: [[12494, 12483, 12488], 256],
		13098: [[12495, 12452, 12484], 256],
		13099: [[12497, 12540, 12475, 12531, 12488], 256],
		13100: [[12497, 12540, 12484], 256],
		13101: [[12496, 12540, 12524, 12523], 256],
		13102: [[12500, 12450, 12473, 12488, 12523], 256],
		13103: [[12500, 12463, 12523], 256],
		13104: [[12500, 12467], 256],
		13105: [[12499, 12523], 256],
		13106: [[12501, 12449, 12521, 12483, 12489], 256],
		13107: [[12501, 12451, 12540, 12488], 256],
		13108: [[12502, 12483, 12471, 12455, 12523], 256],
		13109: [[12501, 12521, 12531], 256],
		13110: [[12504, 12463, 12479, 12540, 12523], 256],
		13111: [[12506, 12477], 256],
		13112: [[12506, 12491, 12498], 256],
		13113: [[12504, 12523, 12484], 256],
		13114: [[12506, 12531, 12473], 256],
		13115: [[12506, 12540, 12472], 256],
		13116: [[12505, 12540, 12479], 256],
		13117: [[12509, 12452, 12531, 12488], 256],
		13118: [[12508, 12523, 12488], 256],
		13119: [[12507, 12531], 256],
		13120: [[12509, 12531, 12489], 256],
		13121: [[12507, 12540, 12523], 256],
		13122: [[12507, 12540, 12531], 256],
		13123: [[12510, 12452, 12463, 12525], 256],
		13124: [[12510, 12452, 12523], 256],
		13125: [[12510, 12483, 12495], 256],
		13126: [[12510, 12523, 12463], 256],
		13127: [[12510, 12531, 12471, 12519, 12531], 256],
		13128: [[12511, 12463, 12525, 12531], 256],
		13129: [[12511, 12522], 256],
		13130: [[12511, 12522, 12496, 12540, 12523], 256],
		13131: [[12513, 12460], 256],
		13132: [[12513, 12460, 12488, 12531], 256],
		13133: [[12513, 12540, 12488, 12523], 256],
		13134: [[12516, 12540, 12489], 256],
		13135: [[12516, 12540, 12523], 256],
		13136: [[12518, 12450, 12531], 256],
		13137: [[12522, 12483, 12488, 12523], 256],
		13138: [[12522, 12521], 256],
		13139: [[12523, 12500, 12540], 256],
		13140: [[12523, 12540, 12502, 12523], 256],
		13141: [[12524, 12512], 256],
		13142: [[12524, 12531, 12488, 12466, 12531], 256],
		13143: [[12527, 12483, 12488], 256],
		13144: [[48, 28857], 256],
		13145: [[49, 28857], 256],
		13146: [[50, 28857], 256],
		13147: [[51, 28857], 256],
		13148: [[52, 28857], 256],
		13149: [[53, 28857], 256],
		13150: [[54, 28857], 256],
		13151: [[55, 28857], 256],
		13152: [[56, 28857], 256],
		13153: [[57, 28857], 256],
		13154: [[49, 48, 28857], 256],
		13155: [[49, 49, 28857], 256],
		13156: [[49, 50, 28857], 256],
		13157: [[49, 51, 28857], 256],
		13158: [[49, 52, 28857], 256],
		13159: [[49, 53, 28857], 256],
		13160: [[49, 54, 28857], 256],
		13161: [[49, 55, 28857], 256],
		13162: [[49, 56, 28857], 256],
		13163: [[49, 57, 28857], 256],
		13164: [[50, 48, 28857], 256],
		13165: [[50, 49, 28857], 256],
		13166: [[50, 50, 28857], 256],
		13167: [[50, 51, 28857], 256],
		13168: [[50, 52, 28857], 256],
		13169: [[104, 80, 97], 256],
		13170: [[100, 97], 256],
		13171: [[65, 85], 256],
		13172: [[98, 97, 114], 256],
		13173: [[111, 86], 256],
		13174: [[112, 99], 256],
		13175: [[100, 109], 256],
		13176: [[100, 109, 178], 256],
		13177: [[100, 109, 179], 256],
		13178: [[73, 85], 256],
		13179: [[24179, 25104], 256],
		13180: [[26157, 21644], 256],
		13181: [[22823, 27491], 256],
		13182: [[26126, 27835], 256],
		13183: [[26666, 24335, 20250, 31038], 256],
		13184: [[112, 65], 256],
		13185: [[110, 65], 256],
		13186: [[956, 65], 256],
		13187: [[109, 65], 256],
		13188: [[107, 65], 256],
		13189: [[75, 66], 256],
		13190: [[77, 66], 256],
		13191: [[71, 66], 256],
		13192: [[99, 97, 108], 256],
		13193: [[107, 99, 97, 108], 256],
		13194: [[112, 70], 256],
		13195: [[110, 70], 256],
		13196: [[956, 70], 256],
		13197: [[956, 103], 256],
		13198: [[109, 103], 256],
		13199: [[107, 103], 256],
		13200: [[72, 122], 256],
		13201: [[107, 72, 122], 256],
		13202: [[77, 72, 122], 256],
		13203: [[71, 72, 122], 256],
		13204: [[84, 72, 122], 256],
		13205: [[956, 8467], 256],
		13206: [[109, 8467], 256],
		13207: [[100, 8467], 256],
		13208: [[107, 8467], 256],
		13209: [[102, 109], 256],
		13210: [[110, 109], 256],
		13211: [[956, 109], 256],
		13212: [[109, 109], 256],
		13213: [[99, 109], 256],
		13214: [[107, 109], 256],
		13215: [[109, 109, 178], 256],
		13216: [[99, 109, 178], 256],
		13217: [[109, 178], 256],
		13218: [[107, 109, 178], 256],
		13219: [[109, 109, 179], 256],
		13220: [[99, 109, 179], 256],
		13221: [[109, 179], 256],
		13222: [[107, 109, 179], 256],
		13223: [[109, 8725, 115], 256],
		13224: [[109, 8725, 115, 178], 256],
		13225: [[80, 97], 256],
		13226: [[107, 80, 97], 256],
		13227: [[77, 80, 97], 256],
		13228: [[71, 80, 97], 256],
		13229: [[114, 97, 100], 256],
		13230: [[114, 97, 100, 8725, 115], 256],
		13231: [[114, 97, 100, 8725, 115, 178], 256],
		13232: [[112, 115], 256],
		13233: [[110, 115], 256],
		13234: [[956, 115], 256],
		13235: [[109, 115], 256],
		13236: [[112, 86], 256],
		13237: [[110, 86], 256],
		13238: [[956, 86], 256],
		13239: [[109, 86], 256],
		13240: [[107, 86], 256],
		13241: [[77, 86], 256],
		13242: [[112, 87], 256],
		13243: [[110, 87], 256],
		13244: [[956, 87], 256],
		13245: [[109, 87], 256],
		13246: [[107, 87], 256],
		13247: [[77, 87], 256],
		13248: [[107, 937], 256],
		13249: [[77, 937], 256],
		13250: [[97, 46, 109, 46], 256],
		13251: [[66, 113], 256],
		13252: [[99, 99], 256],
		13253: [[99, 100], 256],
		13254: [[67, 8725, 107, 103], 256],
		13255: [[67, 111, 46], 256],
		13256: [[100, 66], 256],
		13257: [[71, 121], 256],
		13258: [[104, 97], 256],
		13259: [[72, 80], 256],
		13260: [[105, 110], 256],
		13261: [[75, 75], 256],
		13262: [[75, 77], 256],
		13263: [[107, 116], 256],
		13264: [[108, 109], 256],
		13265: [[108, 110], 256],
		13266: [[108, 111, 103], 256],
		13267: [[108, 120], 256],
		13268: [[109, 98], 256],
		13269: [[109, 105, 108], 256],
		13270: [[109, 111, 108], 256],
		13271: [[80, 72], 256],
		13272: [[112, 46, 109, 46], 256],
		13273: [[80, 80, 77], 256],
		13274: [[80, 82], 256],
		13275: [[115, 114], 256],
		13276: [[83, 118], 256],
		13277: [[87, 98], 256],
		13278: [[86, 8725, 109], 256],
		13279: [[65, 8725, 109], 256],
		13280: [[49, 26085], 256],
		13281: [[50, 26085], 256],
		13282: [[51, 26085], 256],
		13283: [[52, 26085], 256],
		13284: [[53, 26085], 256],
		13285: [[54, 26085], 256],
		13286: [[55, 26085], 256],
		13287: [[56, 26085], 256],
		13288: [[57, 26085], 256],
		13289: [[49, 48, 26085], 256],
		13290: [[49, 49, 26085], 256],
		13291: [[49, 50, 26085], 256],
		13292: [[49, 51, 26085], 256],
		13293: [[49, 52, 26085], 256],
		13294: [[49, 53, 26085], 256],
		13295: [[49, 54, 26085], 256],
		13296: [[49, 55, 26085], 256],
		13297: [[49, 56, 26085], 256],
		13298: [[49, 57, 26085], 256],
		13299: [[50, 48, 26085], 256],
		13300: [[50, 49, 26085], 256],
		13301: [[50, 50, 26085], 256],
		13302: [[50, 51, 26085], 256],
		13303: [[50, 52, 26085], 256],
		13304: [[50, 53, 26085], 256],
		13305: [[50, 54, 26085], 256],
		13306: [[50, 55, 26085], 256],
		13307: [[50, 56, 26085], 256],
		13308: [[50, 57, 26085], 256],
		13309: [[51, 48, 26085], 256],
		13310: [[51, 49, 26085], 256],
		13311: [[103, 97, 108], 256]
	},
	42496: {
		42607: [, 230],
		42612: [, 230],
		42613: [, 230],
		42614: [, 230],
		42615: [, 230],
		42616: [, 230],
		42617: [, 230],
		42618: [, 230],
		42619: [, 230],
		42620: [, 230],
		42621: [, 230],
		42655: [, 230],
		42736: [, 230],
		42737: [, 230]
	},
	42752: { 42864: [[42863], 256], 43000: [[294], 256], 43001: [[339], 256] },
	43008: {
		43014: [, 9],
		43204: [, 9],
		43232: [, 230],
		43233: [, 230],
		43234: [, 230],
		43235: [, 230],
		43236: [, 230],
		43237: [, 230],
		43238: [, 230],
		43239: [, 230],
		43240: [, 230],
		43241: [, 230],
		43242: [, 230],
		43243: [, 230],
		43244: [, 230],
		43245: [, 230],
		43246: [, 230],
		43247: [, 230],
		43248: [, 230],
		43249: [, 230]
	},
	43264: {
		43307: [, 220],
		43308: [, 220],
		43309: [, 220],
		43347: [, 9],
		43443: [, 7],
		43456: [, 9]
	},
	43520: {
		43696: [, 230],
		43698: [, 230],
		43699: [, 230],
		43700: [, 220],
		43703: [, 230],
		43704: [, 230],
		43710: [, 230],
		43711: [, 230],
		43713: [, 230],
		43766: [, 9]
	},
	43776: { 44013: [, 9] },
	53504: {
		119134: [[119127, 119141], 512],
		119135: [[119128, 119141], 512],
		119136: [[119135, 119150], 512],
		119137: [[119135, 119151], 512],
		119138: [[119135, 119152], 512],
		119139: [[119135, 119153], 512],
		119140: [[119135, 119154], 512],
		119141: [, 216],
		119142: [, 216],
		119143: [, 1],
		119144: [, 1],
		119145: [, 1],
		119149: [, 226],
		119150: [, 216],
		119151: [, 216],
		119152: [, 216],
		119153: [, 216],
		119154: [, 216],
		119163: [, 220],
		119164: [, 220],
		119165: [, 220],
		119166: [, 220],
		119167: [, 220],
		119168: [, 220],
		119169: [, 220],
		119170: [, 220],
		119173: [, 230],
		119174: [, 230],
		119175: [, 230],
		119176: [, 230],
		119177: [, 230],
		119178: [, 220],
		119179: [, 220],
		119210: [, 230],
		119211: [, 230],
		119212: [, 230],
		119213: [, 230],
		119227: [[119225, 119141], 512],
		119228: [[119226, 119141], 512],
		119229: [[119227, 119150], 512],
		119230: [[119228, 119150], 512],
		119231: [[119227, 119151], 512],
		119232: [[119228, 119151], 512]
	},
	53760: { 119362: [, 230], 119363: [, 230], 119364: [, 230] },
	54272: {
		119808: [[65], 256],
		119809: [[66], 256],
		119810: [[67], 256],
		119811: [[68], 256],
		119812: [[69], 256],
		119813: [[70], 256],
		119814: [[71], 256],
		119815: [[72], 256],
		119816: [[73], 256],
		119817: [[74], 256],
		119818: [[75], 256],
		119819: [[76], 256],
		119820: [[77], 256],
		119821: [[78], 256],
		119822: [[79], 256],
		119823: [[80], 256],
		119824: [[81], 256],
		119825: [[82], 256],
		119826: [[83], 256],
		119827: [[84], 256],
		119828: [[85], 256],
		119829: [[86], 256],
		119830: [[87], 256],
		119831: [[88], 256],
		119832: [[89], 256],
		119833: [[90], 256],
		119834: [[97], 256],
		119835: [[98], 256],
		119836: [[99], 256],
		119837: [[100], 256],
		119838: [[101], 256],
		119839: [[102], 256],
		119840: [[103], 256],
		119841: [[104], 256],
		119842: [[105], 256],
		119843: [[106], 256],
		119844: [[107], 256],
		119845: [[108], 256],
		119846: [[109], 256],
		119847: [[110], 256],
		119848: [[111], 256],
		119849: [[112], 256],
		119850: [[113], 256],
		119851: [[114], 256],
		119852: [[115], 256],
		119853: [[116], 256],
		119854: [[117], 256],
		119855: [[118], 256],
		119856: [[119], 256],
		119857: [[120], 256],
		119858: [[121], 256],
		119859: [[122], 256],
		119860: [[65], 256],
		119861: [[66], 256],
		119862: [[67], 256],
		119863: [[68], 256],
		119864: [[69], 256],
		119865: [[70], 256],
		119866: [[71], 256],
		119867: [[72], 256],
		119868: [[73], 256],
		119869: [[74], 256],
		119870: [[75], 256],
		119871: [[76], 256],
		119872: [[77], 256],
		119873: [[78], 256],
		119874: [[79], 256],
		119875: [[80], 256],
		119876: [[81], 256],
		119877: [[82], 256],
		119878: [[83], 256],
		119879: [[84], 256],
		119880: [[85], 256],
		119881: [[86], 256],
		119882: [[87], 256],
		119883: [[88], 256],
		119884: [[89], 256],
		119885: [[90], 256],
		119886: [[97], 256],
		119887: [[98], 256],
		119888: [[99], 256],
		119889: [[100], 256],
		119890: [[101], 256],
		119891: [[102], 256],
		119892: [[103], 256],
		119894: [[105], 256],
		119895: [[106], 256],
		119896: [[107], 256],
		119897: [[108], 256],
		119898: [[109], 256],
		119899: [[110], 256],
		119900: [[111], 256],
		119901: [[112], 256],
		119902: [[113], 256],
		119903: [[114], 256],
		119904: [[115], 256],
		119905: [[116], 256],
		119906: [[117], 256],
		119907: [[118], 256],
		119908: [[119], 256],
		119909: [[120], 256],
		119910: [[121], 256],
		119911: [[122], 256],
		119912: [[65], 256],
		119913: [[66], 256],
		119914: [[67], 256],
		119915: [[68], 256],
		119916: [[69], 256],
		119917: [[70], 256],
		119918: [[71], 256],
		119919: [[72], 256],
		119920: [[73], 256],
		119921: [[74], 256],
		119922: [[75], 256],
		119923: [[76], 256],
		119924: [[77], 256],
		119925: [[78], 256],
		119926: [[79], 256],
		119927: [[80], 256],
		119928: [[81], 256],
		119929: [[82], 256],
		119930: [[83], 256],
		119931: [[84], 256],
		119932: [[85], 256],
		119933: [[86], 256],
		119934: [[87], 256],
		119935: [[88], 256],
		119936: [[89], 256],
		119937: [[90], 256],
		119938: [[97], 256],
		119939: [[98], 256],
		119940: [[99], 256],
		119941: [[100], 256],
		119942: [[101], 256],
		119943: [[102], 256],
		119944: [[103], 256],
		119945: [[104], 256],
		119946: [[105], 256],
		119947: [[106], 256],
		119948: [[107], 256],
		119949: [[108], 256],
		119950: [[109], 256],
		119951: [[110], 256],
		119952: [[111], 256],
		119953: [[112], 256],
		119954: [[113], 256],
		119955: [[114], 256],
		119956: [[115], 256],
		119957: [[116], 256],
		119958: [[117], 256],
		119959: [[118], 256],
		119960: [[119], 256],
		119961: [[120], 256],
		119962: [[121], 256],
		119963: [[122], 256],
		119964: [[65], 256],
		119966: [[67], 256],
		119967: [[68], 256],
		119970: [[71], 256],
		119973: [[74], 256],
		119974: [[75], 256],
		119977: [[78], 256],
		119978: [[79], 256],
		119979: [[80], 256],
		119980: [[81], 256],
		119982: [[83], 256],
		119983: [[84], 256],
		119984: [[85], 256],
		119985: [[86], 256],
		119986: [[87], 256],
		119987: [[88], 256],
		119988: [[89], 256],
		119989: [[90], 256],
		119990: [[97], 256],
		119991: [[98], 256],
		119992: [[99], 256],
		119993: [[100], 256],
		119995: [[102], 256],
		119997: [[104], 256],
		119998: [[105], 256],
		119999: [[106], 256],
		120000: [[107], 256],
		120001: [[108], 256],
		120002: [[109], 256],
		120003: [[110], 256],
		120005: [[112], 256],
		120006: [[113], 256],
		120007: [[114], 256],
		120008: [[115], 256],
		120009: [[116], 256],
		120010: [[117], 256],
		120011: [[118], 256],
		120012: [[119], 256],
		120013: [[120], 256],
		120014: [[121], 256],
		120015: [[122], 256],
		120016: [[65], 256],
		120017: [[66], 256],
		120018: [[67], 256],
		120019: [[68], 256],
		120020: [[69], 256],
		120021: [[70], 256],
		120022: [[71], 256],
		120023: [[72], 256],
		120024: [[73], 256],
		120025: [[74], 256],
		120026: [[75], 256],
		120027: [[76], 256],
		120028: [[77], 256],
		120029: [[78], 256],
		120030: [[79], 256],
		120031: [[80], 256],
		120032: [[81], 256],
		120033: [[82], 256],
		120034: [[83], 256],
		120035: [[84], 256],
		120036: [[85], 256],
		120037: [[86], 256],
		120038: [[87], 256],
		120039: [[88], 256],
		120040: [[89], 256],
		120041: [[90], 256],
		120042: [[97], 256],
		120043: [[98], 256],
		120044: [[99], 256],
		120045: [[100], 256],
		120046: [[101], 256],
		120047: [[102], 256],
		120048: [[103], 256],
		120049: [[104], 256],
		120050: [[105], 256],
		120051: [[106], 256],
		120052: [[107], 256],
		120053: [[108], 256],
		120054: [[109], 256],
		120055: [[110], 256],
		120056: [[111], 256],
		120057: [[112], 256],
		120058: [[113], 256],
		120059: [[114], 256],
		120060: [[115], 256],
		120061: [[116], 256],
		120062: [[117], 256],
		120063: [[118], 256]
	},
	54528: {
		120064: [[119], 256],
		120065: [[120], 256],
		120066: [[121], 256],
		120067: [[122], 256],
		120068: [[65], 256],
		120069: [[66], 256],
		120071: [[68], 256],
		120072: [[69], 256],
		120073: [[70], 256],
		120074: [[71], 256],
		120077: [[74], 256],
		120078: [[75], 256],
		120079: [[76], 256],
		120080: [[77], 256],
		120081: [[78], 256],
		120082: [[79], 256],
		120083: [[80], 256],
		120084: [[81], 256],
		120086: [[83], 256],
		120087: [[84], 256],
		120088: [[85], 256],
		120089: [[86], 256],
		120090: [[87], 256],
		120091: [[88], 256],
		120092: [[89], 256],
		120094: [[97], 256],
		120095: [[98], 256],
		120096: [[99], 256],
		120097: [[100], 256],
		120098: [[101], 256],
		120099: [[102], 256],
		120100: [[103], 256],
		120101: [[104], 256],
		120102: [[105], 256],
		120103: [[106], 256],
		120104: [[107], 256],
		120105: [[108], 256],
		120106: [[109], 256],
		120107: [[110], 256],
		120108: [[111], 256],
		120109: [[112], 256],
		120110: [[113], 256],
		120111: [[114], 256],
		120112: [[115], 256],
		120113: [[116], 256],
		120114: [[117], 256],
		120115: [[118], 256],
		120116: [[119], 256],
		120117: [[120], 256],
		120118: [[121], 256],
		120119: [[122], 256],
		120120: [[65], 256],
		120121: [[66], 256],
		120123: [[68], 256],
		120124: [[69], 256],
		120125: [[70], 256],
		120126: [[71], 256],
		120128: [[73], 256],
		120129: [[74], 256],
		120130: [[75], 256],
		120131: [[76], 256],
		120132: [[77], 256],
		120134: [[79], 256],
		120138: [[83], 256],
		120139: [[84], 256],
		120140: [[85], 256],
		120141: [[86], 256],
		120142: [[87], 256],
		120143: [[88], 256],
		120144: [[89], 256],
		120146: [[97], 256],
		120147: [[98], 256],
		120148: [[99], 256],
		120149: [[100], 256],
		120150: [[101], 256],
		120151: [[102], 256],
		120152: [[103], 256],
		120153: [[104], 256],
		120154: [[105], 256],
		120155: [[106], 256],
		120156: [[107], 256],
		120157: [[108], 256],
		120158: [[109], 256],
		120159: [[110], 256],
		120160: [[111], 256],
		120161: [[112], 256],
		120162: [[113], 256],
		120163: [[114], 256],
		120164: [[115], 256],
		120165: [[116], 256],
		120166: [[117], 256],
		120167: [[118], 256],
		120168: [[119], 256],
		120169: [[120], 256],
		120170: [[121], 256],
		120171: [[122], 256],
		120172: [[65], 256],
		120173: [[66], 256],
		120174: [[67], 256],
		120175: [[68], 256],
		120176: [[69], 256],
		120177: [[70], 256],
		120178: [[71], 256],
		120179: [[72], 256],
		120180: [[73], 256],
		120181: [[74], 256],
		120182: [[75], 256],
		120183: [[76], 256],
		120184: [[77], 256],
		120185: [[78], 256],
		120186: [[79], 256],
		120187: [[80], 256],
		120188: [[81], 256],
		120189: [[82], 256],
		120190: [[83], 256],
		120191: [[84], 256],
		120192: [[85], 256],
		120193: [[86], 256],
		120194: [[87], 256],
		120195: [[88], 256],
		120196: [[89], 256],
		120197: [[90], 256],
		120198: [[97], 256],
		120199: [[98], 256],
		120200: [[99], 256],
		120201: [[100], 256],
		120202: [[101], 256],
		120203: [[102], 256],
		120204: [[103], 256],
		120205: [[104], 256],
		120206: [[105], 256],
		120207: [[106], 256],
		120208: [[107], 256],
		120209: [[108], 256],
		120210: [[109], 256],
		120211: [[110], 256],
		120212: [[111], 256],
		120213: [[112], 256],
		120214: [[113], 256],
		120215: [[114], 256],
		120216: [[115], 256],
		120217: [[116], 256],
		120218: [[117], 256],
		120219: [[118], 256],
		120220: [[119], 256],
		120221: [[120], 256],
		120222: [[121], 256],
		120223: [[122], 256],
		120224: [[65], 256],
		120225: [[66], 256],
		120226: [[67], 256],
		120227: [[68], 256],
		120228: [[69], 256],
		120229: [[70], 256],
		120230: [[71], 256],
		120231: [[72], 256],
		120232: [[73], 256],
		120233: [[74], 256],
		120234: [[75], 256],
		120235: [[76], 256],
		120236: [[77], 256],
		120237: [[78], 256],
		120238: [[79], 256],
		120239: [[80], 256],
		120240: [[81], 256],
		120241: [[82], 256],
		120242: [[83], 256],
		120243: [[84], 256],
		120244: [[85], 256],
		120245: [[86], 256],
		120246: [[87], 256],
		120247: [[88], 256],
		120248: [[89], 256],
		120249: [[90], 256],
		120250: [[97], 256],
		120251: [[98], 256],
		120252: [[99], 256],
		120253: [[100], 256],
		120254: [[101], 256],
		120255: [[102], 256],
		120256: [[103], 256],
		120257: [[104], 256],
		120258: [[105], 256],
		120259: [[106], 256],
		120260: [[107], 256],
		120261: [[108], 256],
		120262: [[109], 256],
		120263: [[110], 256],
		120264: [[111], 256],
		120265: [[112], 256],
		120266: [[113], 256],
		120267: [[114], 256],
		120268: [[115], 256],
		120269: [[116], 256],
		120270: [[117], 256],
		120271: [[118], 256],
		120272: [[119], 256],
		120273: [[120], 256],
		120274: [[121], 256],
		120275: [[122], 256],
		120276: [[65], 256],
		120277: [[66], 256],
		120278: [[67], 256],
		120279: [[68], 256],
		120280: [[69], 256],
		120281: [[70], 256],
		120282: [[71], 256],
		120283: [[72], 256],
		120284: [[73], 256],
		120285: [[74], 256],
		120286: [[75], 256],
		120287: [[76], 256],
		120288: [[77], 256],
		120289: [[78], 256],
		120290: [[79], 256],
		120291: [[80], 256],
		120292: [[81], 256],
		120293: [[82], 256],
		120294: [[83], 256],
		120295: [[84], 256],
		120296: [[85], 256],
		120297: [[86], 256],
		120298: [[87], 256],
		120299: [[88], 256],
		120300: [[89], 256],
		120301: [[90], 256],
		120302: [[97], 256],
		120303: [[98], 256],
		120304: [[99], 256],
		120305: [[100], 256],
		120306: [[101], 256],
		120307: [[102], 256],
		120308: [[103], 256],
		120309: [[104], 256],
		120310: [[105], 256],
		120311: [[106], 256],
		120312: [[107], 256],
		120313: [[108], 256],
		120314: [[109], 256],
		120315: [[110], 256],
		120316: [[111], 256],
		120317: [[112], 256],
		120318: [[113], 256],
		120319: [[114], 256]
	},
	54784: {
		120320: [[115], 256],
		120321: [[116], 256],
		120322: [[117], 256],
		120323: [[118], 256],
		120324: [[119], 256],
		120325: [[120], 256],
		120326: [[121], 256],
		120327: [[122], 256],
		120328: [[65], 256],
		120329: [[66], 256],
		120330: [[67], 256],
		120331: [[68], 256],
		120332: [[69], 256],
		120333: [[70], 256],
		120334: [[71], 256],
		120335: [[72], 256],
		120336: [[73], 256],
		120337: [[74], 256],
		120338: [[75], 256],
		120339: [[76], 256],
		120340: [[77], 256],
		120341: [[78], 256],
		120342: [[79], 256],
		120343: [[80], 256],
		120344: [[81], 256],
		120345: [[82], 256],
		120346: [[83], 256],
		120347: [[84], 256],
		120348: [[85], 256],
		120349: [[86], 256],
		120350: [[87], 256],
		120351: [[88], 256],
		120352: [[89], 256],
		120353: [[90], 256],
		120354: [[97], 256],
		120355: [[98], 256],
		120356: [[99], 256],
		120357: [[100], 256],
		120358: [[101], 256],
		120359: [[102], 256],
		120360: [[103], 256],
		120361: [[104], 256],
		120362: [[105], 256],
		120363: [[106], 256],
		120364: [[107], 256],
		120365: [[108], 256],
		120366: [[109], 256],
		120367: [[110], 256],
		120368: [[111], 256],
		120369: [[112], 256],
		120370: [[113], 256],
		120371: [[114], 256],
		120372: [[115], 256],
		120373: [[116], 256],
		120374: [[117], 256],
		120375: [[118], 256],
		120376: [[119], 256],
		120377: [[120], 256],
		120378: [[121], 256],
		120379: [[122], 256],
		120380: [[65], 256],
		120381: [[66], 256],
		120382: [[67], 256],
		120383: [[68], 256],
		120384: [[69], 256],
		120385: [[70], 256],
		120386: [[71], 256],
		120387: [[72], 256],
		120388: [[73], 256],
		120389: [[74], 256],
		120390: [[75], 256],
		120391: [[76], 256],
		120392: [[77], 256],
		120393: [[78], 256],
		120394: [[79], 256],
		120395: [[80], 256],
		120396: [[81], 256],
		120397: [[82], 256],
		120398: [[83], 256],
		120399: [[84], 256],
		120400: [[85], 256],
		120401: [[86], 256],
		120402: [[87], 256],
		120403: [[88], 256],
		120404: [[89], 256],
		120405: [[90], 256],
		120406: [[97], 256],
		120407: [[98], 256],
		120408: [[99], 256],
		120409: [[100], 256],
		120410: [[101], 256],
		120411: [[102], 256],
		120412: [[103], 256],
		120413: [[104], 256],
		120414: [[105], 256],
		120415: [[106], 256],
		120416: [[107], 256],
		120417: [[108], 256],
		120418: [[109], 256],
		120419: [[110], 256],
		120420: [[111], 256],
		120421: [[112], 256],
		120422: [[113], 256],
		120423: [[114], 256],
		120424: [[115], 256],
		120425: [[116], 256],
		120426: [[117], 256],
		120427: [[118], 256],
		120428: [[119], 256],
		120429: [[120], 256],
		120430: [[121], 256],
		120431: [[122], 256],
		120432: [[65], 256],
		120433: [[66], 256],
		120434: [[67], 256],
		120435: [[68], 256],
		120436: [[69], 256],
		120437: [[70], 256],
		120438: [[71], 256],
		120439: [[72], 256],
		120440: [[73], 256],
		120441: [[74], 256],
		120442: [[75], 256],
		120443: [[76], 256],
		120444: [[77], 256],
		120445: [[78], 256],
		120446: [[79], 256],
		120447: [[80], 256],
		120448: [[81], 256],
		120449: [[82], 256],
		120450: [[83], 256],
		120451: [[84], 256],
		120452: [[85], 256],
		120453: [[86], 256],
		120454: [[87], 256],
		120455: [[88], 256],
		120456: [[89], 256],
		120457: [[90], 256],
		120458: [[97], 256],
		120459: [[98], 256],
		120460: [[99], 256],
		120461: [[100], 256],
		120462: [[101], 256],
		120463: [[102], 256],
		120464: [[103], 256],
		120465: [[104], 256],
		120466: [[105], 256],
		120467: [[106], 256],
		120468: [[107], 256],
		120469: [[108], 256],
		120470: [[109], 256],
		120471: [[110], 256],
		120472: [[111], 256],
		120473: [[112], 256],
		120474: [[113], 256],
		120475: [[114], 256],
		120476: [[115], 256],
		120477: [[116], 256],
		120478: [[117], 256],
		120479: [[118], 256],
		120480: [[119], 256],
		120481: [[120], 256],
		120482: [[121], 256],
		120483: [[122], 256],
		120484: [[305], 256],
		120485: [[567], 256],
		120488: [[913], 256],
		120489: [[914], 256],
		120490: [[915], 256],
		120491: [[916], 256],
		120492: [[917], 256],
		120493: [[918], 256],
		120494: [[919], 256],
		120495: [[920], 256],
		120496: [[921], 256],
		120497: [[922], 256],
		120498: [[923], 256],
		120499: [[924], 256],
		120500: [[925], 256],
		120501: [[926], 256],
		120502: [[927], 256],
		120503: [[928], 256],
		120504: [[929], 256],
		120505: [[1012], 256],
		120506: [[931], 256],
		120507: [[932], 256],
		120508: [[933], 256],
		120509: [[934], 256],
		120510: [[935], 256],
		120511: [[936], 256],
		120512: [[937], 256],
		120513: [[8711], 256],
		120514: [[945], 256],
		120515: [[946], 256],
		120516: [[947], 256],
		120517: [[948], 256],
		120518: [[949], 256],
		120519: [[950], 256],
		120520: [[951], 256],
		120521: [[952], 256],
		120522: [[953], 256],
		120523: [[954], 256],
		120524: [[955], 256],
		120525: [[956], 256],
		120526: [[957], 256],
		120527: [[958], 256],
		120528: [[959], 256],
		120529: [[960], 256],
		120530: [[961], 256],
		120531: [[962], 256],
		120532: [[963], 256],
		120533: [[964], 256],
		120534: [[965], 256],
		120535: [[966], 256],
		120536: [[967], 256],
		120537: [[968], 256],
		120538: [[969], 256],
		120539: [[8706], 256],
		120540: [[1013], 256],
		120541: [[977], 256],
		120542: [[1008], 256],
		120543: [[981], 256],
		120544: [[1009], 256],
		120545: [[982], 256],
		120546: [[913], 256],
		120547: [[914], 256],
		120548: [[915], 256],
		120549: [[916], 256],
		120550: [[917], 256],
		120551: [[918], 256],
		120552: [[919], 256],
		120553: [[920], 256],
		120554: [[921], 256],
		120555: [[922], 256],
		120556: [[923], 256],
		120557: [[924], 256],
		120558: [[925], 256],
		120559: [[926], 256],
		120560: [[927], 256],
		120561: [[928], 256],
		120562: [[929], 256],
		120563: [[1012], 256],
		120564: [[931], 256],
		120565: [[932], 256],
		120566: [[933], 256],
		120567: [[934], 256],
		120568: [[935], 256],
		120569: [[936], 256],
		120570: [[937], 256],
		120571: [[8711], 256],
		120572: [[945], 256],
		120573: [[946], 256],
		120574: [[947], 256],
		120575: [[948], 256]
	},
	55040: {
		120576: [[949], 256],
		120577: [[950], 256],
		120578: [[951], 256],
		120579: [[952], 256],
		120580: [[953], 256],
		120581: [[954], 256],
		120582: [[955], 256],
		120583: [[956], 256],
		120584: [[957], 256],
		120585: [[958], 256],
		120586: [[959], 256],
		120587: [[960], 256],
		120588: [[961], 256],
		120589: [[962], 256],
		120590: [[963], 256],
		120591: [[964], 256],
		120592: [[965], 256],
		120593: [[966], 256],
		120594: [[967], 256],
		120595: [[968], 256],
		120596: [[969], 256],
		120597: [[8706], 256],
		120598: [[1013], 256],
		120599: [[977], 256],
		120600: [[1008], 256],
		120601: [[981], 256],
		120602: [[1009], 256],
		120603: [[982], 256],
		120604: [[913], 256],
		120605: [[914], 256],
		120606: [[915], 256],
		120607: [[916], 256],
		120608: [[917], 256],
		120609: [[918], 256],
		120610: [[919], 256],
		120611: [[920], 256],
		120612: [[921], 256],
		120613: [[922], 256],
		120614: [[923], 256],
		120615: [[924], 256],
		120616: [[925], 256],
		120617: [[926], 256],
		120618: [[927], 256],
		120619: [[928], 256],
		120620: [[929], 256],
		120621: [[1012], 256],
		120622: [[931], 256],
		120623: [[932], 256],
		120624: [[933], 256],
		120625: [[934], 256],
		120626: [[935], 256],
		120627: [[936], 256],
		120628: [[937], 256],
		120629: [[8711], 256],
		120630: [[945], 256],
		120631: [[946], 256],
		120632: [[947], 256],
		120633: [[948], 256],
		120634: [[949], 256],
		120635: [[950], 256],
		120636: [[951], 256],
		120637: [[952], 256],
		120638: [[953], 256],
		120639: [[954], 256],
		120640: [[955], 256],
		120641: [[956], 256],
		120642: [[957], 256],
		120643: [[958], 256],
		120644: [[959], 256],
		120645: [[960], 256],
		120646: [[961], 256],
		120647: [[962], 256],
		120648: [[963], 256],
		120649: [[964], 256],
		120650: [[965], 256],
		120651: [[966], 256],
		120652: [[967], 256],
		120653: [[968], 256],
		120654: [[969], 256],
		120655: [[8706], 256],
		120656: [[1013], 256],
		120657: [[977], 256],
		120658: [[1008], 256],
		120659: [[981], 256],
		120660: [[1009], 256],
		120661: [[982], 256],
		120662: [[913], 256],
		120663: [[914], 256],
		120664: [[915], 256],
		120665: [[916], 256],
		120666: [[917], 256],
		120667: [[918], 256],
		120668: [[919], 256],
		120669: [[920], 256],
		120670: [[921], 256],
		120671: [[922], 256],
		120672: [[923], 256],
		120673: [[924], 256],
		120674: [[925], 256],
		120675: [[926], 256],
		120676: [[927], 256],
		120677: [[928], 256],
		120678: [[929], 256],
		120679: [[1012], 256],
		120680: [[931], 256],
		120681: [[932], 256],
		120682: [[933], 256],
		120683: [[934], 256],
		120684: [[935], 256],
		120685: [[936], 256],
		120686: [[937], 256],
		120687: [[8711], 256],
		120688: [[945], 256],
		120689: [[946], 256],
		120690: [[947], 256],
		120691: [[948], 256],
		120692: [[949], 256],
		120693: [[950], 256],
		120694: [[951], 256],
		120695: [[952], 256],
		120696: [[953], 256],
		120697: [[954], 256],
		120698: [[955], 256],
		120699: [[956], 256],
		120700: [[957], 256],
		120701: [[958], 256],
		120702: [[959], 256],
		120703: [[960], 256],
		120704: [[961], 256],
		120705: [[962], 256],
		120706: [[963], 256],
		120707: [[964], 256],
		120708: [[965], 256],
		120709: [[966], 256],
		120710: [[967], 256],
		120711: [[968], 256],
		120712: [[969], 256],
		120713: [[8706], 256],
		120714: [[1013], 256],
		120715: [[977], 256],
		120716: [[1008], 256],
		120717: [[981], 256],
		120718: [[1009], 256],
		120719: [[982], 256],
		120720: [[913], 256],
		120721: [[914], 256],
		120722: [[915], 256],
		120723: [[916], 256],
		120724: [[917], 256],
		120725: [[918], 256],
		120726: [[919], 256],
		120727: [[920], 256],
		120728: [[921], 256],
		120729: [[922], 256],
		120730: [[923], 256],
		120731: [[924], 256],
		120732: [[925], 256],
		120733: [[926], 256],
		120734: [[927], 256],
		120735: [[928], 256],
		120736: [[929], 256],
		120737: [[1012], 256],
		120738: [[931], 256],
		120739: [[932], 256],
		120740: [[933], 256],
		120741: [[934], 256],
		120742: [[935], 256],
		120743: [[936], 256],
		120744: [[937], 256],
		120745: [[8711], 256],
		120746: [[945], 256],
		120747: [[946], 256],
		120748: [[947], 256],
		120749: [[948], 256],
		120750: [[949], 256],
		120751: [[950], 256],
		120752: [[951], 256],
		120753: [[952], 256],
		120754: [[953], 256],
		120755: [[954], 256],
		120756: [[955], 256],
		120757: [[956], 256],
		120758: [[957], 256],
		120759: [[958], 256],
		120760: [[959], 256],
		120761: [[960], 256],
		120762: [[961], 256],
		120763: [[962], 256],
		120764: [[963], 256],
		120765: [[964], 256],
		120766: [[965], 256],
		120767: [[966], 256],
		120768: [[967], 256],
		120769: [[968], 256],
		120770: [[969], 256],
		120771: [[8706], 256],
		120772: [[1013], 256],
		120773: [[977], 256],
		120774: [[1008], 256],
		120775: [[981], 256],
		120776: [[1009], 256],
		120777: [[982], 256],
		120778: [[988], 256],
		120779: [[989], 256],
		120782: [[48], 256],
		120783: [[49], 256],
		120784: [[50], 256],
		120785: [[51], 256],
		120786: [[52], 256],
		120787: [[53], 256],
		120788: [[54], 256],
		120789: [[55], 256],
		120790: [[56], 256],
		120791: [[57], 256],
		120792: [[48], 256],
		120793: [[49], 256],
		120794: [[50], 256],
		120795: [[51], 256],
		120796: [[52], 256],
		120797: [[53], 256],
		120798: [[54], 256],
		120799: [[55], 256],
		120800: [[56], 256],
		120801: [[57], 256],
		120802: [[48], 256],
		120803: [[49], 256],
		120804: [[50], 256],
		120805: [[51], 256],
		120806: [[52], 256],
		120807: [[53], 256],
		120808: [[54], 256],
		120809: [[55], 256],
		120810: [[56], 256],
		120811: [[57], 256],
		120812: [[48], 256],
		120813: [[49], 256],
		120814: [[50], 256],
		120815: [[51], 256],
		120816: [[52], 256],
		120817: [[53], 256],
		120818: [[54], 256],
		120819: [[55], 256],
		120820: [[56], 256],
		120821: [[57], 256],
		120822: [[48], 256],
		120823: [[49], 256],
		120824: [[50], 256],
		120825: [[51], 256],
		120826: [[52], 256],
		120827: [[53], 256],
		120828: [[54], 256],
		120829: [[55], 256],
		120830: [[56], 256],
		120831: [[57], 256]
	},
	60928: {
		126464: [[1575], 256],
		126465: [[1576], 256],
		126466: [[1580], 256],
		126467: [[1583], 256],
		126469: [[1608], 256],
		126470: [[1586], 256],
		126471: [[1581], 256],
		126472: [[1591], 256],
		126473: [[1610], 256],
		126474: [[1603], 256],
		126475: [[1604], 256],
		126476: [[1605], 256],
		126477: [[1606], 256],
		126478: [[1587], 256],
		126479: [[1593], 256],
		126480: [[1601], 256],
		126481: [[1589], 256],
		126482: [[1602], 256],
		126483: [[1585], 256],
		126484: [[1588], 256],
		126485: [[1578], 256],
		126486: [[1579], 256],
		126487: [[1582], 256],
		126488: [[1584], 256],
		126489: [[1590], 256],
		126490: [[1592], 256],
		126491: [[1594], 256],
		126492: [[1646], 256],
		126493: [[1722], 256],
		126494: [[1697], 256],
		126495: [[1647], 256],
		126497: [[1576], 256],
		126498: [[1580], 256],
		126500: [[1607], 256],
		126503: [[1581], 256],
		126505: [[1610], 256],
		126506: [[1603], 256],
		126507: [[1604], 256],
		126508: [[1605], 256],
		126509: [[1606], 256],
		126510: [[1587], 256],
		126511: [[1593], 256],
		126512: [[1601], 256],
		126513: [[1589], 256],
		126514: [[1602], 256],
		126516: [[1588], 256],
		126517: [[1578], 256],
		126518: [[1579], 256],
		126519: [[1582], 256],
		126521: [[1590], 256],
		126523: [[1594], 256],
		126530: [[1580], 256],
		126535: [[1581], 256],
		126537: [[1610], 256],
		126539: [[1604], 256],
		126541: [[1606], 256],
		126542: [[1587], 256],
		126543: [[1593], 256],
		126545: [[1589], 256],
		126546: [[1602], 256],
		126548: [[1588], 256],
		126551: [[1582], 256],
		126553: [[1590], 256],
		126555: [[1594], 256],
		126557: [[1722], 256],
		126559: [[1647], 256],
		126561: [[1576], 256],
		126562: [[1580], 256],
		126564: [[1607], 256],
		126567: [[1581], 256],
		126568: [[1591], 256],
		126569: [[1610], 256],
		126570: [[1603], 256],
		126572: [[1605], 256],
		126573: [[1606], 256],
		126574: [[1587], 256],
		126575: [[1593], 256],
		126576: [[1601], 256],
		126577: [[1589], 256],
		126578: [[1602], 256],
		126580: [[1588], 256],
		126581: [[1578], 256],
		126582: [[1579], 256],
		126583: [[1582], 256],
		126585: [[1590], 256],
		126586: [[1592], 256],
		126587: [[1594], 256],
		126588: [[1646], 256],
		126590: [[1697], 256],
		126592: [[1575], 256],
		126593: [[1576], 256],
		126594: [[1580], 256],
		126595: [[1583], 256],
		126596: [[1607], 256],
		126597: [[1608], 256],
		126598: [[1586], 256],
		126599: [[1581], 256],
		126600: [[1591], 256],
		126601: [[1610], 256],
		126603: [[1604], 256],
		126604: [[1605], 256],
		126605: [[1606], 256],
		126606: [[1587], 256],
		126607: [[1593], 256],
		126608: [[1601], 256],
		126609: [[1589], 256],
		126610: [[1602], 256],
		126611: [[1585], 256],
		126612: [[1588], 256],
		126613: [[1578], 256],
		126614: [[1579], 256],
		126615: [[1582], 256],
		126616: [[1584], 256],
		126617: [[1590], 256],
		126618: [[1592], 256],
		126619: [[1594], 256],
		126625: [[1576], 256],
		126626: [[1580], 256],
		126627: [[1583], 256],
		126629: [[1608], 256],
		126630: [[1586], 256],
		126631: [[1581], 256],
		126632: [[1591], 256],
		126633: [[1610], 256],
		126635: [[1604], 256],
		126636: [[1605], 256],
		126637: [[1606], 256],
		126638: [[1587], 256],
		126639: [[1593], 256],
		126640: [[1601], 256],
		126641: [[1589], 256],
		126642: [[1602], 256],
		126643: [[1585], 256],
		126644: [[1588], 256],
		126645: [[1578], 256],
		126646: [[1579], 256],
		126647: [[1582], 256],
		126648: [[1584], 256],
		126649: [[1590], 256],
		126650: [[1592], 256],
		126651: [[1594], 256]
	},
	61696: {
		127232: [[48, 46], 256],
		127233: [[48, 44], 256],
		127234: [[49, 44], 256],
		127235: [[50, 44], 256],
		127236: [[51, 44], 256],
		127237: [[52, 44], 256],
		127238: [[53, 44], 256],
		127239: [[54, 44], 256],
		127240: [[55, 44], 256],
		127241: [[56, 44], 256],
		127242: [[57, 44], 256],
		127248: [[40, 65, 41], 256],
		127249: [[40, 66, 41], 256],
		127250: [[40, 67, 41], 256],
		127251: [[40, 68, 41], 256],
		127252: [[40, 69, 41], 256],
		127253: [[40, 70, 41], 256],
		127254: [[40, 71, 41], 256],
		127255: [[40, 72, 41], 256],
		127256: [[40, 73, 41], 256],
		127257: [[40, 74, 41], 256],
		127258: [[40, 75, 41], 256],
		127259: [[40, 76, 41], 256],
		127260: [[40, 77, 41], 256],
		127261: [[40, 78, 41], 256],
		127262: [[40, 79, 41], 256],
		127263: [[40, 80, 41], 256],
		127264: [[40, 81, 41], 256],
		127265: [[40, 82, 41], 256],
		127266: [[40, 83, 41], 256],
		127267: [[40, 84, 41], 256],
		127268: [[40, 85, 41], 256],
		127269: [[40, 86, 41], 256],
		127270: [[40, 87, 41], 256],
		127271: [[40, 88, 41], 256],
		127272: [[40, 89, 41], 256],
		127273: [[40, 90, 41], 256],
		127274: [[12308, 83, 12309], 256],
		127275: [[67], 256],
		127276: [[82], 256],
		127277: [[67, 68], 256],
		127278: [[87, 90], 256],
		127280: [[65], 256],
		127281: [[66], 256],
		127282: [[67], 256],
		127283: [[68], 256],
		127284: [[69], 256],
		127285: [[70], 256],
		127286: [[71], 256],
		127287: [[72], 256],
		127288: [[73], 256],
		127289: [[74], 256],
		127290: [[75], 256],
		127291: [[76], 256],
		127292: [[77], 256],
		127293: [[78], 256],
		127294: [[79], 256],
		127295: [[80], 256],
		127296: [[81], 256],
		127297: [[82], 256],
		127298: [[83], 256],
		127299: [[84], 256],
		127300: [[85], 256],
		127301: [[86], 256],
		127302: [[87], 256],
		127303: [[88], 256],
		127304: [[89], 256],
		127305: [[90], 256],
		127306: [[72, 86], 256],
		127307: [[77, 86], 256],
		127308: [[83, 68], 256],
		127309: [[83, 83], 256],
		127310: [[80, 80, 86], 256],
		127311: [[87, 67], 256],
		127338: [[77, 67], 256],
		127339: [[77, 68], 256],
		127376: [[68, 74], 256]
	},
	61952: {
		127488: [[12411, 12363], 256],
		127489: [[12467, 12467], 256],
		127490: [[12469], 256],
		127504: [[25163], 256],
		127505: [[23383], 256],
		127506: [[21452], 256],
		127507: [[12487], 256],
		127508: [[20108], 256],
		127509: [[22810], 256],
		127510: [[35299], 256],
		127511: [[22825], 256],
		127512: [[20132], 256],
		127513: [[26144], 256],
		127514: [[28961], 256],
		127515: [[26009], 256],
		127516: [[21069], 256],
		127517: [[24460], 256],
		127518: [[20877], 256],
		127519: [[26032], 256],
		127520: [[21021], 256],
		127521: [[32066], 256],
		127522: [[29983], 256],
		127523: [[36009], 256],
		127524: [[22768], 256],
		127525: [[21561], 256],
		127526: [[28436], 256],
		127527: [[25237], 256],
		127528: [[25429], 256],
		127529: [[19968], 256],
		127530: [[19977], 256],
		127531: [[36938], 256],
		127532: [[24038], 256],
		127533: [[20013], 256],
		127534: [[21491], 256],
		127535: [[25351], 256],
		127536: [[36208], 256],
		127537: [[25171], 256],
		127538: [[31105], 256],
		127539: [[31354], 256],
		127540: [[21512], 256],
		127541: [[28288], 256],
		127542: [[26377], 256],
		127543: [[26376], 256],
		127544: [[30003], 256],
		127545: [[21106], 256],
		127546: [[21942], 256],
		127552: [[12308, 26412, 12309], 256],
		127553: [[12308, 19977, 12309], 256],
		127554: [[12308, 20108, 12309], 256],
		127555: [[12308, 23433, 12309], 256],
		127556: [[12308, 28857, 12309], 256],
		127557: [[12308, 25171, 12309], 256],
		127558: [[12308, 30423, 12309], 256],
		127559: [[12308, 21213, 12309], 256],
		127560: [[12308, 25943, 12309], 256],
		127568: [[24471], 256],
		127569: [[21487], 256]
	},
	63488: {
		194560: [[20029]],
		194561: [[20024]],
		194562: [[20033]],
		194563: [[131362]],
		194564: [[20320]],
		194565: [[20398]],
		194566: [[20411]],
		194567: [[20482]],
		194568: [[20602]],
		194569: [[20633]],
		194570: [[20711]],
		194571: [[20687]],
		194572: [[13470]],
		194573: [[132666]],
		194574: [[20813]],
		194575: [[20820]],
		194576: [[20836]],
		194577: [[20855]],
		194578: [[132380]],
		194579: [[13497]],
		194580: [[20839]],
		194581: [[20877]],
		194582: [[132427]],
		194583: [[20887]],
		194584: [[20900]],
		194585: [[20172]],
		194586: [[20908]],
		194587: [[20917]],
		194588: [[168415]],
		194589: [[20981]],
		194590: [[20995]],
		194591: [[13535]],
		194592: [[21051]],
		194593: [[21062]],
		194594: [[21106]],
		194595: [[21111]],
		194596: [[13589]],
		194597: [[21191]],
		194598: [[21193]],
		194599: [[21220]],
		194600: [[21242]],
		194601: [[21253]],
		194602: [[21254]],
		194603: [[21271]],
		194604: [[21321]],
		194605: [[21329]],
		194606: [[21338]],
		194607: [[21363]],
		194608: [[21373]],
		194609: [[21375]],
		194610: [[21375]],
		194611: [[21375]],
		194612: [[133676]],
		194613: [[28784]],
		194614: [[21450]],
		194615: [[21471]],
		194616: [[133987]],
		194617: [[21483]],
		194618: [[21489]],
		194619: [[21510]],
		194620: [[21662]],
		194621: [[21560]],
		194622: [[21576]],
		194623: [[21608]],
		194624: [[21666]],
		194625: [[21750]],
		194626: [[21776]],
		194627: [[21843]],
		194628: [[21859]],
		194629: [[21892]],
		194630: [[21892]],
		194631: [[21913]],
		194632: [[21931]],
		194633: [[21939]],
		194634: [[21954]],
		194635: [[22294]],
		194636: [[22022]],
		194637: [[22295]],
		194638: [[22097]],
		194639: [[22132]],
		194640: [[20999]],
		194641: [[22766]],
		194642: [[22478]],
		194643: [[22516]],
		194644: [[22541]],
		194645: [[22411]],
		194646: [[22578]],
		194647: [[22577]],
		194648: [[22700]],
		194649: [[136420]],
		194650: [[22770]],
		194651: [[22775]],
		194652: [[22790]],
		194653: [[22810]],
		194654: [[22818]],
		194655: [[22882]],
		194656: [[136872]],
		194657: [[136938]],
		194658: [[23020]],
		194659: [[23067]],
		194660: [[23079]],
		194661: [[23000]],
		194662: [[23142]],
		194663: [[14062]],
		194664: [[14076]],
		194665: [[23304]],
		194666: [[23358]],
		194667: [[23358]],
		194668: [[137672]],
		194669: [[23491]],
		194670: [[23512]],
		194671: [[23527]],
		194672: [[23539]],
		194673: [[138008]],
		194674: [[23551]],
		194675: [[23558]],
		194676: [[24403]],
		194677: [[23586]],
		194678: [[14209]],
		194679: [[23648]],
		194680: [[23662]],
		194681: [[23744]],
		194682: [[23693]],
		194683: [[138724]],
		194684: [[23875]],
		194685: [[138726]],
		194686: [[23918]],
		194687: [[23915]],
		194688: [[23932]],
		194689: [[24033]],
		194690: [[24034]],
		194691: [[14383]],
		194692: [[24061]],
		194693: [[24104]],
		194694: [[24125]],
		194695: [[24169]],
		194696: [[14434]],
		194697: [[139651]],
		194698: [[14460]],
		194699: [[24240]],
		194700: [[24243]],
		194701: [[24246]],
		194702: [[24266]],
		194703: [[172946]],
		194704: [[24318]],
		194705: [[140081]],
		194706: [[140081]],
		194707: [[33281]],
		194708: [[24354]],
		194709: [[24354]],
		194710: [[14535]],
		194711: [[144056]],
		194712: [[156122]],
		194713: [[24418]],
		194714: [[24427]],
		194715: [[14563]],
		194716: [[24474]],
		194717: [[24525]],
		194718: [[24535]],
		194719: [[24569]],
		194720: [[24705]],
		194721: [[14650]],
		194722: [[14620]],
		194723: [[24724]],
		194724: [[141012]],
		194725: [[24775]],
		194726: [[24904]],
		194727: [[24908]],
		194728: [[24910]],
		194729: [[24908]],
		194730: [[24954]],
		194731: [[24974]],
		194732: [[25010]],
		194733: [[24996]],
		194734: [[25007]],
		194735: [[25054]],
		194736: [[25074]],
		194737: [[25078]],
		194738: [[25104]],
		194739: [[25115]],
		194740: [[25181]],
		194741: [[25265]],
		194742: [[25300]],
		194743: [[25424]],
		194744: [[142092]],
		194745: [[25405]],
		194746: [[25340]],
		194747: [[25448]],
		194748: [[25475]],
		194749: [[25572]],
		194750: [[142321]],
		194751: [[25634]],
		194752: [[25541]],
		194753: [[25513]],
		194754: [[14894]],
		194755: [[25705]],
		194756: [[25726]],
		194757: [[25757]],
		194758: [[25719]],
		194759: [[14956]],
		194760: [[25935]],
		194761: [[25964]],
		194762: [[143370]],
		194763: [[26083]],
		194764: [[26360]],
		194765: [[26185]],
		194766: [[15129]],
		194767: [[26257]],
		194768: [[15112]],
		194769: [[15076]],
		194770: [[20882]],
		194771: [[20885]],
		194772: [[26368]],
		194773: [[26268]],
		194774: [[32941]],
		194775: [[17369]],
		194776: [[26391]],
		194777: [[26395]],
		194778: [[26401]],
		194779: [[26462]],
		194780: [[26451]],
		194781: [[144323]],
		194782: [[15177]],
		194783: [[26618]],
		194784: [[26501]],
		194785: [[26706]],
		194786: [[26757]],
		194787: [[144493]],
		194788: [[26766]],
		194789: [[26655]],
		194790: [[26900]],
		194791: [[15261]],
		194792: [[26946]],
		194793: [[27043]],
		194794: [[27114]],
		194795: [[27304]],
		194796: [[145059]],
		194797: [[27355]],
		194798: [[15384]],
		194799: [[27425]],
		194800: [[145575]],
		194801: [[27476]],
		194802: [[15438]],
		194803: [[27506]],
		194804: [[27551]],
		194805: [[27578]],
		194806: [[27579]],
		194807: [[146061]],
		194808: [[138507]],
		194809: [[146170]],
		194810: [[27726]],
		194811: [[146620]],
		194812: [[27839]],
		194813: [[27853]],
		194814: [[27751]],
		194815: [[27926]]
	},
	63744: {
		63744: [[35912]],
		63745: [[26356]],
		63746: [[36554]],
		63747: [[36040]],
		63748: [[28369]],
		63749: [[20018]],
		63750: [[21477]],
		63751: [[40860]],
		63752: [[40860]],
		63753: [[22865]],
		63754: [[37329]],
		63755: [[21895]],
		63756: [[22856]],
		63757: [[25078]],
		63758: [[30313]],
		63759: [[32645]],
		63760: [[34367]],
		63761: [[34746]],
		63762: [[35064]],
		63763: [[37007]],
		63764: [[27138]],
		63765: [[27931]],
		63766: [[28889]],
		63767: [[29662]],
		63768: [[33853]],
		63769: [[37226]],
		63770: [[39409]],
		63771: [[20098]],
		63772: [[21365]],
		63773: [[27396]],
		63774: [[29211]],
		63775: [[34349]],
		63776: [[40478]],
		63777: [[23888]],
		63778: [[28651]],
		63779: [[34253]],
		63780: [[35172]],
		63781: [[25289]],
		63782: [[33240]],
		63783: [[34847]],
		63784: [[24266]],
		63785: [[26391]],
		63786: [[28010]],
		63787: [[29436]],
		63788: [[37070]],
		63789: [[20358]],
		63790: [[20919]],
		63791: [[21214]],
		63792: [[25796]],
		63793: [[27347]],
		63794: [[29200]],
		63795: [[30439]],
		63796: [[32769]],
		63797: [[34310]],
		63798: [[34396]],
		63799: [[36335]],
		63800: [[38706]],
		63801: [[39791]],
		63802: [[40442]],
		63803: [[30860]],
		63804: [[31103]],
		63805: [[32160]],
		63806: [[33737]],
		63807: [[37636]],
		63808: [[40575]],
		63809: [[35542]],
		63810: [[22751]],
		63811: [[24324]],
		63812: [[31840]],
		63813: [[32894]],
		63814: [[29282]],
		63815: [[30922]],
		63816: [[36034]],
		63817: [[38647]],
		63818: [[22744]],
		63819: [[23650]],
		63820: [[27155]],
		63821: [[28122]],
		63822: [[28431]],
		63823: [[32047]],
		63824: [[32311]],
		63825: [[38475]],
		63826: [[21202]],
		63827: [[32907]],
		63828: [[20956]],
		63829: [[20940]],
		63830: [[31260]],
		63831: [[32190]],
		63832: [[33777]],
		63833: [[38517]],
		63834: [[35712]],
		63835: [[25295]],
		63836: [[27138]],
		63837: [[35582]],
		63838: [[20025]],
		63839: [[23527]],
		63840: [[24594]],
		63841: [[29575]],
		63842: [[30064]],
		63843: [[21271]],
		63844: [[30971]],
		63845: [[20415]],
		63846: [[24489]],
		63847: [[19981]],
		63848: [[27852]],
		63849: [[25976]],
		63850: [[32034]],
		63851: [[21443]],
		63852: [[22622]],
		63853: [[30465]],
		63854: [[33865]],
		63855: [[35498]],
		63856: [[27578]],
		63857: [[36784]],
		63858: [[27784]],
		63859: [[25342]],
		63860: [[33509]],
		63861: [[25504]],
		63862: [[30053]],
		63863: [[20142]],
		63864: [[20841]],
		63865: [[20937]],
		63866: [[26753]],
		63867: [[31975]],
		63868: [[33391]],
		63869: [[35538]],
		63870: [[37327]],
		63871: [[21237]],
		63872: [[21570]],
		63873: [[22899]],
		63874: [[24300]],
		63875: [[26053]],
		63876: [[28670]],
		63877: [[31018]],
		63878: [[38317]],
		63879: [[39530]],
		63880: [[40599]],
		63881: [[40654]],
		63882: [[21147]],
		63883: [[26310]],
		63884: [[27511]],
		63885: [[36706]],
		63886: [[24180]],
		63887: [[24976]],
		63888: [[25088]],
		63889: [[25754]],
		63890: [[28451]],
		63891: [[29001]],
		63892: [[29833]],
		63893: [[31178]],
		63894: [[32244]],
		63895: [[32879]],
		63896: [[36646]],
		63897: [[34030]],
		63898: [[36899]],
		63899: [[37706]],
		63900: [[21015]],
		63901: [[21155]],
		63902: [[21693]],
		63903: [[28872]],
		63904: [[35010]],
		63905: [[35498]],
		63906: [[24265]],
		63907: [[24565]],
		63908: [[25467]],
		63909: [[27566]],
		63910: [[31806]],
		63911: [[29557]],
		63912: [[20196]],
		63913: [[22265]],
		63914: [[23527]],
		63915: [[23994]],
		63916: [[24604]],
		63917: [[29618]],
		63918: [[29801]],
		63919: [[32666]],
		63920: [[32838]],
		63921: [[37428]],
		63922: [[38646]],
		63923: [[38728]],
		63924: [[38936]],
		63925: [[20363]],
		63926: [[31150]],
		63927: [[37300]],
		63928: [[38584]],
		63929: [[24801]],
		63930: [[20102]],
		63931: [[20698]],
		63932: [[23534]],
		63933: [[23615]],
		63934: [[26009]],
		63935: [[27138]],
		63936: [[29134]],
		63937: [[30274]],
		63938: [[34044]],
		63939: [[36988]],
		63940: [[40845]],
		63941: [[26248]],
		63942: [[38446]],
		63943: [[21129]],
		63944: [[26491]],
		63945: [[26611]],
		63946: [[27969]],
		63947: [[28316]],
		63948: [[29705]],
		63949: [[30041]],
		63950: [[30827]],
		63951: [[32016]],
		63952: [[39006]],
		63953: [[20845]],
		63954: [[25134]],
		63955: [[38520]],
		63956: [[20523]],
		63957: [[23833]],
		63958: [[28138]],
		63959: [[36650]],
		63960: [[24459]],
		63961: [[24900]],
		63962: [[26647]],
		63963: [[29575]],
		63964: [[38534]],
		63965: [[21033]],
		63966: [[21519]],
		63967: [[23653]],
		63968: [[26131]],
		63969: [[26446]],
		63970: [[26792]],
		63971: [[27877]],
		63972: [[29702]],
		63973: [[30178]],
		63974: [[32633]],
		63975: [[35023]],
		63976: [[35041]],
		63977: [[37324]],
		63978: [[38626]],
		63979: [[21311]],
		63980: [[28346]],
		63981: [[21533]],
		63982: [[29136]],
		63983: [[29848]],
		63984: [[34298]],
		63985: [[38563]],
		63986: [[40023]],
		63987: [[40607]],
		63988: [[26519]],
		63989: [[28107]],
		63990: [[33256]],
		63991: [[31435]],
		63992: [[31520]],
		63993: [[31890]],
		63994: [[29376]],
		63995: [[28825]],
		63996: [[35672]],
		63997: [[20160]],
		63998: [[33590]],
		63999: [[21050]],
		194816: [[27966]],
		194817: [[28023]],
		194818: [[27969]],
		194819: [[28009]],
		194820: [[28024]],
		194821: [[28037]],
		194822: [[146718]],
		194823: [[27956]],
		194824: [[28207]],
		194825: [[28270]],
		194826: [[15667]],
		194827: [[28363]],
		194828: [[28359]],
		194829: [[147153]],
		194830: [[28153]],
		194831: [[28526]],
		194832: [[147294]],
		194833: [[147342]],
		194834: [[28614]],
		194835: [[28729]],
		194836: [[28702]],
		194837: [[28699]],
		194838: [[15766]],
		194839: [[28746]],
		194840: [[28797]],
		194841: [[28791]],
		194842: [[28845]],
		194843: [[132389]],
		194844: [[28997]],
		194845: [[148067]],
		194846: [[29084]],
		194847: [[148395]],
		194848: [[29224]],
		194849: [[29237]],
		194850: [[29264]],
		194851: [[149000]],
		194852: [[29312]],
		194853: [[29333]],
		194854: [[149301]],
		194855: [[149524]],
		194856: [[29562]],
		194857: [[29579]],
		194858: [[16044]],
		194859: [[29605]],
		194860: [[16056]],
		194861: [[16056]],
		194862: [[29767]],
		194863: [[29788]],
		194864: [[29809]],
		194865: [[29829]],
		194866: [[29898]],
		194867: [[16155]],
		194868: [[29988]],
		194869: [[150582]],
		194870: [[30014]],
		194871: [[150674]],
		194872: [[30064]],
		194873: [[139679]],
		194874: [[30224]],
		194875: [[151457]],
		194876: [[151480]],
		194877: [[151620]],
		194878: [[16380]],
		194879: [[16392]],
		194880: [[30452]],
		194881: [[151795]],
		194882: [[151794]],
		194883: [[151833]],
		194884: [[151859]],
		194885: [[30494]],
		194886: [[30495]],
		194887: [[30495]],
		194888: [[30538]],
		194889: [[16441]],
		194890: [[30603]],
		194891: [[16454]],
		194892: [[16534]],
		194893: [[152605]],
		194894: [[30798]],
		194895: [[30860]],
		194896: [[30924]],
		194897: [[16611]],
		194898: [[153126]],
		194899: [[31062]],
		194900: [[153242]],
		194901: [[153285]],
		194902: [[31119]],
		194903: [[31211]],
		194904: [[16687]],
		194905: [[31296]],
		194906: [[31306]],
		194907: [[31311]],
		194908: [[153980]],
		194909: [[154279]],
		194910: [[154279]],
		194911: [[31470]],
		194912: [[16898]],
		194913: [[154539]],
		194914: [[31686]],
		194915: [[31689]],
		194916: [[16935]],
		194917: [[154752]],
		194918: [[31954]],
		194919: [[17056]],
		194920: [[31976]],
		194921: [[31971]],
		194922: [[32000]],
		194923: [[155526]],
		194924: [[32099]],
		194925: [[17153]],
		194926: [[32199]],
		194927: [[32258]],
		194928: [[32325]],
		194929: [[17204]],
		194930: [[156200]],
		194931: [[156231]],
		194932: [[17241]],
		194933: [[156377]],
		194934: [[32634]],
		194935: [[156478]],
		194936: [[32661]],
		194937: [[32762]],
		194938: [[32773]],
		194939: [[156890]],
		194940: [[156963]],
		194941: [[32864]],
		194942: [[157096]],
		194943: [[32880]],
		194944: [[144223]],
		194945: [[17365]],
		194946: [[32946]],
		194947: [[33027]],
		194948: [[17419]],
		194949: [[33086]],
		194950: [[23221]],
		194951: [[157607]],
		194952: [[157621]],
		194953: [[144275]],
		194954: [[144284]],
		194955: [[33281]],
		194956: [[33284]],
		194957: [[36766]],
		194958: [[17515]],
		194959: [[33425]],
		194960: [[33419]],
		194961: [[33437]],
		194962: [[21171]],
		194963: [[33457]],
		194964: [[33459]],
		194965: [[33469]],
		194966: [[33510]],
		194967: [[158524]],
		194968: [[33509]],
		194969: [[33565]],
		194970: [[33635]],
		194971: [[33709]],
		194972: [[33571]],
		194973: [[33725]],
		194974: [[33767]],
		194975: [[33879]],
		194976: [[33619]],
		194977: [[33738]],
		194978: [[33740]],
		194979: [[33756]],
		194980: [[158774]],
		194981: [[159083]],
		194982: [[158933]],
		194983: [[17707]],
		194984: [[34033]],
		194985: [[34035]],
		194986: [[34070]],
		194987: [[160714]],
		194988: [[34148]],
		194989: [[159532]],
		194990: [[17757]],
		194991: [[17761]],
		194992: [[159665]],
		194993: [[159954]],
		194994: [[17771]],
		194995: [[34384]],
		194996: [[34396]],
		194997: [[34407]],
		194998: [[34409]],
		194999: [[34473]],
		195000: [[34440]],
		195001: [[34574]],
		195002: [[34530]],
		195003: [[34681]],
		195004: [[34600]],
		195005: [[34667]],
		195006: [[34694]],
		195007: [[17879]],
		195008: [[34785]],
		195009: [[34817]],
		195010: [[17913]],
		195011: [[34912]],
		195012: [[34915]],
		195013: [[161383]],
		195014: [[35031]],
		195015: [[35038]],
		195016: [[17973]],
		195017: [[35066]],
		195018: [[13499]],
		195019: [[161966]],
		195020: [[162150]],
		195021: [[18110]],
		195022: [[18119]],
		195023: [[35488]],
		195024: [[35565]],
		195025: [[35722]],
		195026: [[35925]],
		195027: [[162984]],
		195028: [[36011]],
		195029: [[36033]],
		195030: [[36123]],
		195031: [[36215]],
		195032: [[163631]],
		195033: [[133124]],
		195034: [[36299]],
		195035: [[36284]],
		195036: [[36336]],
		195037: [[133342]],
		195038: [[36564]],
		195039: [[36664]],
		195040: [[165330]],
		195041: [[165357]],
		195042: [[37012]],
		195043: [[37105]],
		195044: [[37137]],
		195045: [[165678]],
		195046: [[37147]],
		195047: [[37432]],
		195048: [[37591]],
		195049: [[37592]],
		195050: [[37500]],
		195051: [[37881]],
		195052: [[37909]],
		195053: [[166906]],
		195054: [[38283]],
		195055: [[18837]],
		195056: [[38327]],
		195057: [[167287]],
		195058: [[18918]],
		195059: [[38595]],
		195060: [[23986]],
		195061: [[38691]],
		195062: [[168261]],
		195063: [[168474]],
		195064: [[19054]],
		195065: [[19062]],
		195066: [[38880]],
		195067: [[168970]],
		195068: [[19122]],
		195069: [[169110]],
		195070: [[38923]],
		195071: [[38923]]
	},
	64000: {
		64000: [[20999]],
		64001: [[24230]],
		64002: [[25299]],
		64003: [[31958]],
		64004: [[23429]],
		64005: [[27934]],
		64006: [[26292]],
		64007: [[36667]],
		64008: [[34892]],
		64009: [[38477]],
		64010: [[35211]],
		64011: [[24275]],
		64012: [[20800]],
		64013: [[21952]],
		64016: [[22618]],
		64018: [[26228]],
		64021: [[20958]],
		64022: [[29482]],
		64023: [[30410]],
		64024: [[31036]],
		64025: [[31070]],
		64026: [[31077]],
		64027: [[31119]],
		64028: [[38742]],
		64029: [[31934]],
		64030: [[32701]],
		64032: [[34322]],
		64034: [[35576]],
		64037: [[36920]],
		64038: [[37117]],
		64042: [[39151]],
		64043: [[39164]],
		64044: [[39208]],
		64045: [[40372]],
		64046: [[37086]],
		64047: [[38583]],
		64048: [[20398]],
		64049: [[20711]],
		64050: [[20813]],
		64051: [[21193]],
		64052: [[21220]],
		64053: [[21329]],
		64054: [[21917]],
		64055: [[22022]],
		64056: [[22120]],
		64057: [[22592]],
		64058: [[22696]],
		64059: [[23652]],
		64060: [[23662]],
		64061: [[24724]],
		64062: [[24936]],
		64063: [[24974]],
		64064: [[25074]],
		64065: [[25935]],
		64066: [[26082]],
		64067: [[26257]],
		64068: [[26757]],
		64069: [[28023]],
		64070: [[28186]],
		64071: [[28450]],
		64072: [[29038]],
		64073: [[29227]],
		64074: [[29730]],
		64075: [[30865]],
		64076: [[31038]],
		64077: [[31049]],
		64078: [[31048]],
		64079: [[31056]],
		64080: [[31062]],
		64081: [[31069]],
		64082: [[31117]],
		64083: [[31118]],
		64084: [[31296]],
		64085: [[31361]],
		64086: [[31680]],
		64087: [[32244]],
		64088: [[32265]],
		64089: [[32321]],
		64090: [[32626]],
		64091: [[32773]],
		64092: [[33261]],
		64093: [[33401]],
		64094: [[33401]],
		64095: [[33879]],
		64096: [[35088]],
		64097: [[35222]],
		64098: [[35585]],
		64099: [[35641]],
		64100: [[36051]],
		64101: [[36104]],
		64102: [[36790]],
		64103: [[36920]],
		64104: [[38627]],
		64105: [[38911]],
		64106: [[38971]],
		64107: [[24693]],
		64108: [[148206]],
		64109: [[33304]],
		64112: [[20006]],
		64113: [[20917]],
		64114: [[20840]],
		64115: [[20352]],
		64116: [[20805]],
		64117: [[20864]],
		64118: [[21191]],
		64119: [[21242]],
		64120: [[21917]],
		64121: [[21845]],
		64122: [[21913]],
		64123: [[21986]],
		64124: [[22618]],
		64125: [[22707]],
		64126: [[22852]],
		64127: [[22868]],
		64128: [[23138]],
		64129: [[23336]],
		64130: [[24274]],
		64131: [[24281]],
		64132: [[24425]],
		64133: [[24493]],
		64134: [[24792]],
		64135: [[24910]],
		64136: [[24840]],
		64137: [[24974]],
		64138: [[24928]],
		64139: [[25074]],
		64140: [[25140]],
		64141: [[25540]],
		64142: [[25628]],
		64143: [[25682]],
		64144: [[25942]],
		64145: [[26228]],
		64146: [[26391]],
		64147: [[26395]],
		64148: [[26454]],
		64149: [[27513]],
		64150: [[27578]],
		64151: [[27969]],
		64152: [[28379]],
		64153: [[28363]],
		64154: [[28450]],
		64155: [[28702]],
		64156: [[29038]],
		64157: [[30631]],
		64158: [[29237]],
		64159: [[29359]],
		64160: [[29482]],
		64161: [[29809]],
		64162: [[29958]],
		64163: [[30011]],
		64164: [[30237]],
		64165: [[30239]],
		64166: [[30410]],
		64167: [[30427]],
		64168: [[30452]],
		64169: [[30538]],
		64170: [[30528]],
		64171: [[30924]],
		64172: [[31409]],
		64173: [[31680]],
		64174: [[31867]],
		64175: [[32091]],
		64176: [[32244]],
		64177: [[32574]],
		64178: [[32773]],
		64179: [[33618]],
		64180: [[33775]],
		64181: [[34681]],
		64182: [[35137]],
		64183: [[35206]],
		64184: [[35222]],
		64185: [[35519]],
		64186: [[35576]],
		64187: [[35531]],
		64188: [[35585]],
		64189: [[35582]],
		64190: [[35565]],
		64191: [[35641]],
		64192: [[35722]],
		64193: [[36104]],
		64194: [[36664]],
		64195: [[36978]],
		64196: [[37273]],
		64197: [[37494]],
		64198: [[38524]],
		64199: [[38627]],
		64200: [[38742]],
		64201: [[38875]],
		64202: [[38911]],
		64203: [[38923]],
		64204: [[38971]],
		64205: [[39698]],
		64206: [[40860]],
		64207: [[141386]],
		64208: [[141380]],
		64209: [[144341]],
		64210: [[15261]],
		64211: [[16408]],
		64212: [[16441]],
		64213: [[152137]],
		64214: [[154832]],
		64215: [[163539]],
		64216: [[40771]],
		64217: [[40846]],
		195072: [[38953]],
		195073: [[169398]],
		195074: [[39138]],
		195075: [[19251]],
		195076: [[39209]],
		195077: [[39335]],
		195078: [[39362]],
		195079: [[39422]],
		195080: [[19406]],
		195081: [[170800]],
		195082: [[39698]],
		195083: [[40000]],
		195084: [[40189]],
		195085: [[19662]],
		195086: [[19693]],
		195087: [[40295]],
		195088: [[172238]],
		195089: [[19704]],
		195090: [[172293]],
		195091: [[172558]],
		195092: [[172689]],
		195093: [[40635]],
		195094: [[19798]],
		195095: [[40697]],
		195096: [[40702]],
		195097: [[40709]],
		195098: [[40719]],
		195099: [[40726]],
		195100: [[40763]],
		195101: [[173568]]
	},
	64256: {
		64256: [[102, 102], 256],
		64257: [[102, 105], 256],
		64258: [[102, 108], 256],
		64259: [[102, 102, 105], 256],
		64260: [[102, 102, 108], 256],
		64261: [[383, 116], 256],
		64262: [[115, 116], 256],
		64275: [[1396, 1398], 256],
		64276: [[1396, 1381], 256],
		64277: [[1396, 1387], 256],
		64278: [[1406, 1398], 256],
		64279: [[1396, 1389], 256],
		64285: [[1497, 1460], 512],
		64286: [, 26],
		64287: [[1522, 1463], 512],
		64288: [[1506], 256],
		64289: [[1488], 256],
		64290: [[1491], 256],
		64291: [[1492], 256],
		64292: [[1499], 256],
		64293: [[1500], 256],
		64294: [[1501], 256],
		64295: [[1512], 256],
		64296: [[1514], 256],
		64297: [[43], 256],
		64298: [[1513, 1473], 512],
		64299: [[1513, 1474], 512],
		64300: [[64329, 1473], 512],
		64301: [[64329, 1474], 512],
		64302: [[1488, 1463], 512],
		64303: [[1488, 1464], 512],
		64304: [[1488, 1468], 512],
		64305: [[1489, 1468], 512],
		64306: [[1490, 1468], 512],
		64307: [[1491, 1468], 512],
		64308: [[1492, 1468], 512],
		64309: [[1493, 1468], 512],
		64310: [[1494, 1468], 512],
		64312: [[1496, 1468], 512],
		64313: [[1497, 1468], 512],
		64314: [[1498, 1468], 512],
		64315: [[1499, 1468], 512],
		64316: [[1500, 1468], 512],
		64318: [[1502, 1468], 512],
		64320: [[1504, 1468], 512],
		64321: [[1505, 1468], 512],
		64323: [[1507, 1468], 512],
		64324: [[1508, 1468], 512],
		64326: [[1510, 1468], 512],
		64327: [[1511, 1468], 512],
		64328: [[1512, 1468], 512],
		64329: [[1513, 1468], 512],
		64330: [[1514, 1468], 512],
		64331: [[1493, 1465], 512],
		64332: [[1489, 1471], 512],
		64333: [[1499, 1471], 512],
		64334: [[1508, 1471], 512],
		64335: [[1488, 1500], 256],
		64336: [[1649], 256],
		64337: [[1649], 256],
		64338: [[1659], 256],
		64339: [[1659], 256],
		64340: [[1659], 256],
		64341: [[1659], 256],
		64342: [[1662], 256],
		64343: [[1662], 256],
		64344: [[1662], 256],
		64345: [[1662], 256],
		64346: [[1664], 256],
		64347: [[1664], 256],
		64348: [[1664], 256],
		64349: [[1664], 256],
		64350: [[1658], 256],
		64351: [[1658], 256],
		64352: [[1658], 256],
		64353: [[1658], 256],
		64354: [[1663], 256],
		64355: [[1663], 256],
		64356: [[1663], 256],
		64357: [[1663], 256],
		64358: [[1657], 256],
		64359: [[1657], 256],
		64360: [[1657], 256],
		64361: [[1657], 256],
		64362: [[1700], 256],
		64363: [[1700], 256],
		64364: [[1700], 256],
		64365: [[1700], 256],
		64366: [[1702], 256],
		64367: [[1702], 256],
		64368: [[1702], 256],
		64369: [[1702], 256],
		64370: [[1668], 256],
		64371: [[1668], 256],
		64372: [[1668], 256],
		64373: [[1668], 256],
		64374: [[1667], 256],
		64375: [[1667], 256],
		64376: [[1667], 256],
		64377: [[1667], 256],
		64378: [[1670], 256],
		64379: [[1670], 256],
		64380: [[1670], 256],
		64381: [[1670], 256],
		64382: [[1671], 256],
		64383: [[1671], 256],
		64384: [[1671], 256],
		64385: [[1671], 256],
		64386: [[1677], 256],
		64387: [[1677], 256],
		64388: [[1676], 256],
		64389: [[1676], 256],
		64390: [[1678], 256],
		64391: [[1678], 256],
		64392: [[1672], 256],
		64393: [[1672], 256],
		64394: [[1688], 256],
		64395: [[1688], 256],
		64396: [[1681], 256],
		64397: [[1681], 256],
		64398: [[1705], 256],
		64399: [[1705], 256],
		64400: [[1705], 256],
		64401: [[1705], 256],
		64402: [[1711], 256],
		64403: [[1711], 256],
		64404: [[1711], 256],
		64405: [[1711], 256],
		64406: [[1715], 256],
		64407: [[1715], 256],
		64408: [[1715], 256],
		64409: [[1715], 256],
		64410: [[1713], 256],
		64411: [[1713], 256],
		64412: [[1713], 256],
		64413: [[1713], 256],
		64414: [[1722], 256],
		64415: [[1722], 256],
		64416: [[1723], 256],
		64417: [[1723], 256],
		64418: [[1723], 256],
		64419: [[1723], 256],
		64420: [[1728], 256],
		64421: [[1728], 256],
		64422: [[1729], 256],
		64423: [[1729], 256],
		64424: [[1729], 256],
		64425: [[1729], 256],
		64426: [[1726], 256],
		64427: [[1726], 256],
		64428: [[1726], 256],
		64429: [[1726], 256],
		64430: [[1746], 256],
		64431: [[1746], 256],
		64432: [[1747], 256],
		64433: [[1747], 256],
		64467: [[1709], 256],
		64468: [[1709], 256],
		64469: [[1709], 256],
		64470: [[1709], 256],
		64471: [[1735], 256],
		64472: [[1735], 256],
		64473: [[1734], 256],
		64474: [[1734], 256],
		64475: [[1736], 256],
		64476: [[1736], 256],
		64477: [[1655], 256],
		64478: [[1739], 256],
		64479: [[1739], 256],
		64480: [[1733], 256],
		64481: [[1733], 256],
		64482: [[1737], 256],
		64483: [[1737], 256],
		64484: [[1744], 256],
		64485: [[1744], 256],
		64486: [[1744], 256],
		64487: [[1744], 256],
		64488: [[1609], 256],
		64489: [[1609], 256],
		64490: [[1574, 1575], 256],
		64491: [[1574, 1575], 256],
		64492: [[1574, 1749], 256],
		64493: [[1574, 1749], 256],
		64494: [[1574, 1608], 256],
		64495: [[1574, 1608], 256],
		64496: [[1574, 1735], 256],
		64497: [[1574, 1735], 256],
		64498: [[1574, 1734], 256],
		64499: [[1574, 1734], 256],
		64500: [[1574, 1736], 256],
		64501: [[1574, 1736], 256],
		64502: [[1574, 1744], 256],
		64503: [[1574, 1744], 256],
		64504: [[1574, 1744], 256],
		64505: [[1574, 1609], 256],
		64506: [[1574, 1609], 256],
		64507: [[1574, 1609], 256],
		64508: [[1740], 256],
		64509: [[1740], 256],
		64510: [[1740], 256],
		64511: [[1740], 256]
	},
	64512: {
		64512: [[1574, 1580], 256],
		64513: [[1574, 1581], 256],
		64514: [[1574, 1605], 256],
		64515: [[1574, 1609], 256],
		64516: [[1574, 1610], 256],
		64517: [[1576, 1580], 256],
		64518: [[1576, 1581], 256],
		64519: [[1576, 1582], 256],
		64520: [[1576, 1605], 256],
		64521: [[1576, 1609], 256],
		64522: [[1576, 1610], 256],
		64523: [[1578, 1580], 256],
		64524: [[1578, 1581], 256],
		64525: [[1578, 1582], 256],
		64526: [[1578, 1605], 256],
		64527: [[1578, 1609], 256],
		64528: [[1578, 1610], 256],
		64529: [[1579, 1580], 256],
		64530: [[1579, 1605], 256],
		64531: [[1579, 1609], 256],
		64532: [[1579, 1610], 256],
		64533: [[1580, 1581], 256],
		64534: [[1580, 1605], 256],
		64535: [[1581, 1580], 256],
		64536: [[1581, 1605], 256],
		64537: [[1582, 1580], 256],
		64538: [[1582, 1581], 256],
		64539: [[1582, 1605], 256],
		64540: [[1587, 1580], 256],
		64541: [[1587, 1581], 256],
		64542: [[1587, 1582], 256],
		64543: [[1587, 1605], 256],
		64544: [[1589, 1581], 256],
		64545: [[1589, 1605], 256],
		64546: [[1590, 1580], 256],
		64547: [[1590, 1581], 256],
		64548: [[1590, 1582], 256],
		64549: [[1590, 1605], 256],
		64550: [[1591, 1581], 256],
		64551: [[1591, 1605], 256],
		64552: [[1592, 1605], 256],
		64553: [[1593, 1580], 256],
		64554: [[1593, 1605], 256],
		64555: [[1594, 1580], 256],
		64556: [[1594, 1605], 256],
		64557: [[1601, 1580], 256],
		64558: [[1601, 1581], 256],
		64559: [[1601, 1582], 256],
		64560: [[1601, 1605], 256],
		64561: [[1601, 1609], 256],
		64562: [[1601, 1610], 256],
		64563: [[1602, 1581], 256],
		64564: [[1602, 1605], 256],
		64565: [[1602, 1609], 256],
		64566: [[1602, 1610], 256],
		64567: [[1603, 1575], 256],
		64568: [[1603, 1580], 256],
		64569: [[1603, 1581], 256],
		64570: [[1603, 1582], 256],
		64571: [[1603, 1604], 256],
		64572: [[1603, 1605], 256],
		64573: [[1603, 1609], 256],
		64574: [[1603, 1610], 256],
		64575: [[1604, 1580], 256],
		64576: [[1604, 1581], 256],
		64577: [[1604, 1582], 256],
		64578: [[1604, 1605], 256],
		64579: [[1604, 1609], 256],
		64580: [[1604, 1610], 256],
		64581: [[1605, 1580], 256],
		64582: [[1605, 1581], 256],
		64583: [[1605, 1582], 256],
		64584: [[1605, 1605], 256],
		64585: [[1605, 1609], 256],
		64586: [[1605, 1610], 256],
		64587: [[1606, 1580], 256],
		64588: [[1606, 1581], 256],
		64589: [[1606, 1582], 256],
		64590: [[1606, 1605], 256],
		64591: [[1606, 1609], 256],
		64592: [[1606, 1610], 256],
		64593: [[1607, 1580], 256],
		64594: [[1607, 1605], 256],
		64595: [[1607, 1609], 256],
		64596: [[1607, 1610], 256],
		64597: [[1610, 1580], 256],
		64598: [[1610, 1581], 256],
		64599: [[1610, 1582], 256],
		64600: [[1610, 1605], 256],
		64601: [[1610, 1609], 256],
		64602: [[1610, 1610], 256],
		64603: [[1584, 1648], 256],
		64604: [[1585, 1648], 256],
		64605: [[1609, 1648], 256],
		64606: [[32, 1612, 1617], 256],
		64607: [[32, 1613, 1617], 256],
		64608: [[32, 1614, 1617], 256],
		64609: [[32, 1615, 1617], 256],
		64610: [[32, 1616, 1617], 256],
		64611: [[32, 1617, 1648], 256],
		64612: [[1574, 1585], 256],
		64613: [[1574, 1586], 256],
		64614: [[1574, 1605], 256],
		64615: [[1574, 1606], 256],
		64616: [[1574, 1609], 256],
		64617: [[1574, 1610], 256],
		64618: [[1576, 1585], 256],
		64619: [[1576, 1586], 256],
		64620: [[1576, 1605], 256],
		64621: [[1576, 1606], 256],
		64622: [[1576, 1609], 256],
		64623: [[1576, 1610], 256],
		64624: [[1578, 1585], 256],
		64625: [[1578, 1586], 256],
		64626: [[1578, 1605], 256],
		64627: [[1578, 1606], 256],
		64628: [[1578, 1609], 256],
		64629: [[1578, 1610], 256],
		64630: [[1579, 1585], 256],
		64631: [[1579, 1586], 256],
		64632: [[1579, 1605], 256],
		64633: [[1579, 1606], 256],
		64634: [[1579, 1609], 256],
		64635: [[1579, 1610], 256],
		64636: [[1601, 1609], 256],
		64637: [[1601, 1610], 256],
		64638: [[1602, 1609], 256],
		64639: [[1602, 1610], 256],
		64640: [[1603, 1575], 256],
		64641: [[1603, 1604], 256],
		64642: [[1603, 1605], 256],
		64643: [[1603, 1609], 256],
		64644: [[1603, 1610], 256],
		64645: [[1604, 1605], 256],
		64646: [[1604, 1609], 256],
		64647: [[1604, 1610], 256],
		64648: [[1605, 1575], 256],
		64649: [[1605, 1605], 256],
		64650: [[1606, 1585], 256],
		64651: [[1606, 1586], 256],
		64652: [[1606, 1605], 256],
		64653: [[1606, 1606], 256],
		64654: [[1606, 1609], 256],
		64655: [[1606, 1610], 256],
		64656: [[1609, 1648], 256],
		64657: [[1610, 1585], 256],
		64658: [[1610, 1586], 256],
		64659: [[1610, 1605], 256],
		64660: [[1610, 1606], 256],
		64661: [[1610, 1609], 256],
		64662: [[1610, 1610], 256],
		64663: [[1574, 1580], 256],
		64664: [[1574, 1581], 256],
		64665: [[1574, 1582], 256],
		64666: [[1574, 1605], 256],
		64667: [[1574, 1607], 256],
		64668: [[1576, 1580], 256],
		64669: [[1576, 1581], 256],
		64670: [[1576, 1582], 256],
		64671: [[1576, 1605], 256],
		64672: [[1576, 1607], 256],
		64673: [[1578, 1580], 256],
		64674: [[1578, 1581], 256],
		64675: [[1578, 1582], 256],
		64676: [[1578, 1605], 256],
		64677: [[1578, 1607], 256],
		64678: [[1579, 1605], 256],
		64679: [[1580, 1581], 256],
		64680: [[1580, 1605], 256],
		64681: [[1581, 1580], 256],
		64682: [[1581, 1605], 256],
		64683: [[1582, 1580], 256],
		64684: [[1582, 1605], 256],
		64685: [[1587, 1580], 256],
		64686: [[1587, 1581], 256],
		64687: [[1587, 1582], 256],
		64688: [[1587, 1605], 256],
		64689: [[1589, 1581], 256],
		64690: [[1589, 1582], 256],
		64691: [[1589, 1605], 256],
		64692: [[1590, 1580], 256],
		64693: [[1590, 1581], 256],
		64694: [[1590, 1582], 256],
		64695: [[1590, 1605], 256],
		64696: [[1591, 1581], 256],
		64697: [[1592, 1605], 256],
		64698: [[1593, 1580], 256],
		64699: [[1593, 1605], 256],
		64700: [[1594, 1580], 256],
		64701: [[1594, 1605], 256],
		64702: [[1601, 1580], 256],
		64703: [[1601, 1581], 256],
		64704: [[1601, 1582], 256],
		64705: [[1601, 1605], 256],
		64706: [[1602, 1581], 256],
		64707: [[1602, 1605], 256],
		64708: [[1603, 1580], 256],
		64709: [[1603, 1581], 256],
		64710: [[1603, 1582], 256],
		64711: [[1603, 1604], 256],
		64712: [[1603, 1605], 256],
		64713: [[1604, 1580], 256],
		64714: [[1604, 1581], 256],
		64715: [[1604, 1582], 256],
		64716: [[1604, 1605], 256],
		64717: [[1604, 1607], 256],
		64718: [[1605, 1580], 256],
		64719: [[1605, 1581], 256],
		64720: [[1605, 1582], 256],
		64721: [[1605, 1605], 256],
		64722: [[1606, 1580], 256],
		64723: [[1606, 1581], 256],
		64724: [[1606, 1582], 256],
		64725: [[1606, 1605], 256],
		64726: [[1606, 1607], 256],
		64727: [[1607, 1580], 256],
		64728: [[1607, 1605], 256],
		64729: [[1607, 1648], 256],
		64730: [[1610, 1580], 256],
		64731: [[1610, 1581], 256],
		64732: [[1610, 1582], 256],
		64733: [[1610, 1605], 256],
		64734: [[1610, 1607], 256],
		64735: [[1574, 1605], 256],
		64736: [[1574, 1607], 256],
		64737: [[1576, 1605], 256],
		64738: [[1576, 1607], 256],
		64739: [[1578, 1605], 256],
		64740: [[1578, 1607], 256],
		64741: [[1579, 1605], 256],
		64742: [[1579, 1607], 256],
		64743: [[1587, 1605], 256],
		64744: [[1587, 1607], 256],
		64745: [[1588, 1605], 256],
		64746: [[1588, 1607], 256],
		64747: [[1603, 1604], 256],
		64748: [[1603, 1605], 256],
		64749: [[1604, 1605], 256],
		64750: [[1606, 1605], 256],
		64751: [[1606, 1607], 256],
		64752: [[1610, 1605], 256],
		64753: [[1610, 1607], 256],
		64754: [[1600, 1614, 1617], 256],
		64755: [[1600, 1615, 1617], 256],
		64756: [[1600, 1616, 1617], 256],
		64757: [[1591, 1609], 256],
		64758: [[1591, 1610], 256],
		64759: [[1593, 1609], 256],
		64760: [[1593, 1610], 256],
		64761: [[1594, 1609], 256],
		64762: [[1594, 1610], 256],
		64763: [[1587, 1609], 256],
		64764: [[1587, 1610], 256],
		64765: [[1588, 1609], 256],
		64766: [[1588, 1610], 256],
		64767: [[1581, 1609], 256]
	},
	64768: {
		64768: [[1581, 1610], 256],
		64769: [[1580, 1609], 256],
		64770: [[1580, 1610], 256],
		64771: [[1582, 1609], 256],
		64772: [[1582, 1610], 256],
		64773: [[1589, 1609], 256],
		64774: [[1589, 1610], 256],
		64775: [[1590, 1609], 256],
		64776: [[1590, 1610], 256],
		64777: [[1588, 1580], 256],
		64778: [[1588, 1581], 256],
		64779: [[1588, 1582], 256],
		64780: [[1588, 1605], 256],
		64781: [[1588, 1585], 256],
		64782: [[1587, 1585], 256],
		64783: [[1589, 1585], 256],
		64784: [[1590, 1585], 256],
		64785: [[1591, 1609], 256],
		64786: [[1591, 1610], 256],
		64787: [[1593, 1609], 256],
		64788: [[1593, 1610], 256],
		64789: [[1594, 1609], 256],
		64790: [[1594, 1610], 256],
		64791: [[1587, 1609], 256],
		64792: [[1587, 1610], 256],
		64793: [[1588, 1609], 256],
		64794: [[1588, 1610], 256],
		64795: [[1581, 1609], 256],
		64796: [[1581, 1610], 256],
		64797: [[1580, 1609], 256],
		64798: [[1580, 1610], 256],
		64799: [[1582, 1609], 256],
		64800: [[1582, 1610], 256],
		64801: [[1589, 1609], 256],
		64802: [[1589, 1610], 256],
		64803: [[1590, 1609], 256],
		64804: [[1590, 1610], 256],
		64805: [[1588, 1580], 256],
		64806: [[1588, 1581], 256],
		64807: [[1588, 1582], 256],
		64808: [[1588, 1605], 256],
		64809: [[1588, 1585], 256],
		64810: [[1587, 1585], 256],
		64811: [[1589, 1585], 256],
		64812: [[1590, 1585], 256],
		64813: [[1588, 1580], 256],
		64814: [[1588, 1581], 256],
		64815: [[1588, 1582], 256],
		64816: [[1588, 1605], 256],
		64817: [[1587, 1607], 256],
		64818: [[1588, 1607], 256],
		64819: [[1591, 1605], 256],
		64820: [[1587, 1580], 256],
		64821: [[1587, 1581], 256],
		64822: [[1587, 1582], 256],
		64823: [[1588, 1580], 256],
		64824: [[1588, 1581], 256],
		64825: [[1588, 1582], 256],
		64826: [[1591, 1605], 256],
		64827: [[1592, 1605], 256],
		64828: [[1575, 1611], 256],
		64829: [[1575, 1611], 256],
		64848: [[1578, 1580, 1605], 256],
		64849: [[1578, 1581, 1580], 256],
		64850: [[1578, 1581, 1580], 256],
		64851: [[1578, 1581, 1605], 256],
		64852: [[1578, 1582, 1605], 256],
		64853: [[1578, 1605, 1580], 256],
		64854: [[1578, 1605, 1581], 256],
		64855: [[1578, 1605, 1582], 256],
		64856: [[1580, 1605, 1581], 256],
		64857: [[1580, 1605, 1581], 256],
		64858: [[1581, 1605, 1610], 256],
		64859: [[1581, 1605, 1609], 256],
		64860: [[1587, 1581, 1580], 256],
		64861: [[1587, 1580, 1581], 256],
		64862: [[1587, 1580, 1609], 256],
		64863: [[1587, 1605, 1581], 256],
		64864: [[1587, 1605, 1581], 256],
		64865: [[1587, 1605, 1580], 256],
		64866: [[1587, 1605, 1605], 256],
		64867: [[1587, 1605, 1605], 256],
		64868: [[1589, 1581, 1581], 256],
		64869: [[1589, 1581, 1581], 256],
		64870: [[1589, 1605, 1605], 256],
		64871: [[1588, 1581, 1605], 256],
		64872: [[1588, 1581, 1605], 256],
		64873: [[1588, 1580, 1610], 256],
		64874: [[1588, 1605, 1582], 256],
		64875: [[1588, 1605, 1582], 256],
		64876: [[1588, 1605, 1605], 256],
		64877: [[1588, 1605, 1605], 256],
		64878: [[1590, 1581, 1609], 256],
		64879: [[1590, 1582, 1605], 256],
		64880: [[1590, 1582, 1605], 256],
		64881: [[1591, 1605, 1581], 256],
		64882: [[1591, 1605, 1581], 256],
		64883: [[1591, 1605, 1605], 256],
		64884: [[1591, 1605, 1610], 256],
		64885: [[1593, 1580, 1605], 256],
		64886: [[1593, 1605, 1605], 256],
		64887: [[1593, 1605, 1605], 256],
		64888: [[1593, 1605, 1609], 256],
		64889: [[1594, 1605, 1605], 256],
		64890: [[1594, 1605, 1610], 256],
		64891: [[1594, 1605, 1609], 256],
		64892: [[1601, 1582, 1605], 256],
		64893: [[1601, 1582, 1605], 256],
		64894: [[1602, 1605, 1581], 256],
		64895: [[1602, 1605, 1605], 256],
		64896: [[1604, 1581, 1605], 256],
		64897: [[1604, 1581, 1610], 256],
		64898: [[1604, 1581, 1609], 256],
		64899: [[1604, 1580, 1580], 256],
		64900: [[1604, 1580, 1580], 256],
		64901: [[1604, 1582, 1605], 256],
		64902: [[1604, 1582, 1605], 256],
		64903: [[1604, 1605, 1581], 256],
		64904: [[1604, 1605, 1581], 256],
		64905: [[1605, 1581, 1580], 256],
		64906: [[1605, 1581, 1605], 256],
		64907: [[1605, 1581, 1610], 256],
		64908: [[1605, 1580, 1581], 256],
		64909: [[1605, 1580, 1605], 256],
		64910: [[1605, 1582, 1580], 256],
		64911: [[1605, 1582, 1605], 256],
		64914: [[1605, 1580, 1582], 256],
		64915: [[1607, 1605, 1580], 256],
		64916: [[1607, 1605, 1605], 256],
		64917: [[1606, 1581, 1605], 256],
		64918: [[1606, 1581, 1609], 256],
		64919: [[1606, 1580, 1605], 256],
		64920: [[1606, 1580, 1605], 256],
		64921: [[1606, 1580, 1609], 256],
		64922: [[1606, 1605, 1610], 256],
		64923: [[1606, 1605, 1609], 256],
		64924: [[1610, 1605, 1605], 256],
		64925: [[1610, 1605, 1605], 256],
		64926: [[1576, 1582, 1610], 256],
		64927: [[1578, 1580, 1610], 256],
		64928: [[1578, 1580, 1609], 256],
		64929: [[1578, 1582, 1610], 256],
		64930: [[1578, 1582, 1609], 256],
		64931: [[1578, 1605, 1610], 256],
		64932: [[1578, 1605, 1609], 256],
		64933: [[1580, 1605, 1610], 256],
		64934: [[1580, 1581, 1609], 256],
		64935: [[1580, 1605, 1609], 256],
		64936: [[1587, 1582, 1609], 256],
		64937: [[1589, 1581, 1610], 256],
		64938: [[1588, 1581, 1610], 256],
		64939: [[1590, 1581, 1610], 256],
		64940: [[1604, 1580, 1610], 256],
		64941: [[1604, 1605, 1610], 256],
		64942: [[1610, 1581, 1610], 256],
		64943: [[1610, 1580, 1610], 256],
		64944: [[1610, 1605, 1610], 256],
		64945: [[1605, 1605, 1610], 256],
		64946: [[1602, 1605, 1610], 256],
		64947: [[1606, 1581, 1610], 256],
		64948: [[1602, 1605, 1581], 256],
		64949: [[1604, 1581, 1605], 256],
		64950: [[1593, 1605, 1610], 256],
		64951: [[1603, 1605, 1610], 256],
		64952: [[1606, 1580, 1581], 256],
		64953: [[1605, 1582, 1610], 256],
		64954: [[1604, 1580, 1605], 256],
		64955: [[1603, 1605, 1605], 256],
		64956: [[1604, 1580, 1605], 256],
		64957: [[1606, 1580, 1581], 256],
		64958: [[1580, 1581, 1610], 256],
		64959: [[1581, 1580, 1610], 256],
		64960: [[1605, 1580, 1610], 256],
		64961: [[1601, 1605, 1610], 256],
		64962: [[1576, 1581, 1610], 256],
		64963: [[1603, 1605, 1605], 256],
		64964: [[1593, 1580, 1605], 256],
		64965: [[1589, 1605, 1605], 256],
		64966: [[1587, 1582, 1610], 256],
		64967: [[1606, 1580, 1610], 256],
		65008: [[1589, 1604, 1746], 256],
		65009: [[1602, 1604, 1746], 256],
		65010: [[1575, 1604, 1604, 1607], 256],
		65011: [[1575, 1603, 1576, 1585], 256],
		65012: [[1605, 1581, 1605, 1583], 256],
		65013: [[1589, 1604, 1593, 1605], 256],
		65014: [[1585, 1587, 1608, 1604], 256],
		65015: [[1593, 1604, 1610, 1607], 256],
		65016: [[1608, 1587, 1604, 1605], 256],
		65017: [[1589, 1604, 1609], 256],
		65018: [
			[
				1589, 1604, 1609, 32, 1575, 1604, 1604, 1607, 32, 1593, 1604, 1610, 1607, 32, 1608,
				1587, 1604, 1605
			],
			256
		],
		65019: [[1580, 1604, 32, 1580, 1604, 1575, 1604, 1607], 256],
		65020: [[1585, 1740, 1575, 1604], 256]
	},
	65024: {
		65040: [[44], 256],
		65041: [[12289], 256],
		65042: [[12290], 256],
		65043: [[58], 256],
		65044: [[59], 256],
		65045: [[33], 256],
		65046: [[63], 256],
		65047: [[12310], 256],
		65048: [[12311], 256],
		65049: [[8230], 256],
		65056: [, 230],
		65057: [, 230],
		65058: [, 230],
		65059: [, 230],
		65060: [, 230],
		65061: [, 230],
		65062: [, 230],
		65072: [[8229], 256],
		65073: [[8212], 256],
		65074: [[8211], 256],
		65075: [[95], 256],
		65076: [[95], 256],
		65077: [[40], 256],
		65078: [[41], 256],
		65079: [[123], 256],
		65080: [[125], 256],
		65081: [[12308], 256],
		65082: [[12309], 256],
		65083: [[12304], 256],
		65084: [[12305], 256],
		65085: [[12298], 256],
		65086: [[12299], 256],
		65087: [[12296], 256],
		65088: [[12297], 256],
		65089: [[12300], 256],
		65090: [[12301], 256],
		65091: [[12302], 256],
		65092: [[12303], 256],
		65095: [[91], 256],
		65096: [[93], 256],
		65097: [[8254], 256],
		65098: [[8254], 256],
		65099: [[8254], 256],
		65100: [[8254], 256],
		65101: [[95], 256],
		65102: [[95], 256],
		65103: [[95], 256],
		65104: [[44], 256],
		65105: [[12289], 256],
		65106: [[46], 256],
		65108: [[59], 256],
		65109: [[58], 256],
		65110: [[63], 256],
		65111: [[33], 256],
		65112: [[8212], 256],
		65113: [[40], 256],
		65114: [[41], 256],
		65115: [[123], 256],
		65116: [[125], 256],
		65117: [[12308], 256],
		65118: [[12309], 256],
		65119: [[35], 256],
		65120: [[38], 256],
		65121: [[42], 256],
		65122: [[43], 256],
		65123: [[45], 256],
		65124: [[60], 256],
		65125: [[62], 256],
		65126: [[61], 256],
		65128: [[92], 256],
		65129: [[36], 256],
		65130: [[37], 256],
		65131: [[64], 256],
		65136: [[32, 1611], 256],
		65137: [[1600, 1611], 256],
		65138: [[32, 1612], 256],
		65140: [[32, 1613], 256],
		65142: [[32, 1614], 256],
		65143: [[1600, 1614], 256],
		65144: [[32, 1615], 256],
		65145: [[1600, 1615], 256],
		65146: [[32, 1616], 256],
		65147: [[1600, 1616], 256],
		65148: [[32, 1617], 256],
		65149: [[1600, 1617], 256],
		65150: [[32, 1618], 256],
		65151: [[1600, 1618], 256],
		65152: [[1569], 256],
		65153: [[1570], 256],
		65154: [[1570], 256],
		65155: [[1571], 256],
		65156: [[1571], 256],
		65157: [[1572], 256],
		65158: [[1572], 256],
		65159: [[1573], 256],
		65160: [[1573], 256],
		65161: [[1574], 256],
		65162: [[1574], 256],
		65163: [[1574], 256],
		65164: [[1574], 256],
		65165: [[1575], 256],
		65166: [[1575], 256],
		65167: [[1576], 256],
		65168: [[1576], 256],
		65169: [[1576], 256],
		65170: [[1576], 256],
		65171: [[1577], 256],
		65172: [[1577], 256],
		65173: [[1578], 256],
		65174: [[1578], 256],
		65175: [[1578], 256],
		65176: [[1578], 256],
		65177: [[1579], 256],
		65178: [[1579], 256],
		65179: [[1579], 256],
		65180: [[1579], 256],
		65181: [[1580], 256],
		65182: [[1580], 256],
		65183: [[1580], 256],
		65184: [[1580], 256],
		65185: [[1581], 256],
		65186: [[1581], 256],
		65187: [[1581], 256],
		65188: [[1581], 256],
		65189: [[1582], 256],
		65190: [[1582], 256],
		65191: [[1582], 256],
		65192: [[1582], 256],
		65193: [[1583], 256],
		65194: [[1583], 256],
		65195: [[1584], 256],
		65196: [[1584], 256],
		65197: [[1585], 256],
		65198: [[1585], 256],
		65199: [[1586], 256],
		65200: [[1586], 256],
		65201: [[1587], 256],
		65202: [[1587], 256],
		65203: [[1587], 256],
		65204: [[1587], 256],
		65205: [[1588], 256],
		65206: [[1588], 256],
		65207: [[1588], 256],
		65208: [[1588], 256],
		65209: [[1589], 256],
		65210: [[1589], 256],
		65211: [[1589], 256],
		65212: [[1589], 256],
		65213: [[1590], 256],
		65214: [[1590], 256],
		65215: [[1590], 256],
		65216: [[1590], 256],
		65217: [[1591], 256],
		65218: [[1591], 256],
		65219: [[1591], 256],
		65220: [[1591], 256],
		65221: [[1592], 256],
		65222: [[1592], 256],
		65223: [[1592], 256],
		65224: [[1592], 256],
		65225: [[1593], 256],
		65226: [[1593], 256],
		65227: [[1593], 256],
		65228: [[1593], 256],
		65229: [[1594], 256],
		65230: [[1594], 256],
		65231: [[1594], 256],
		65232: [[1594], 256],
		65233: [[1601], 256],
		65234: [[1601], 256],
		65235: [[1601], 256],
		65236: [[1601], 256],
		65237: [[1602], 256],
		65238: [[1602], 256],
		65239: [[1602], 256],
		65240: [[1602], 256],
		65241: [[1603], 256],
		65242: [[1603], 256],
		65243: [[1603], 256],
		65244: [[1603], 256],
		65245: [[1604], 256],
		65246: [[1604], 256],
		65247: [[1604], 256],
		65248: [[1604], 256],
		65249: [[1605], 256],
		65250: [[1605], 256],
		65251: [[1605], 256],
		65252: [[1605], 256],
		65253: [[1606], 256],
		65254: [[1606], 256],
		65255: [[1606], 256],
		65256: [[1606], 256],
		65257: [[1607], 256],
		65258: [[1607], 256],
		65259: [[1607], 256],
		65260: [[1607], 256],
		65261: [[1608], 256],
		65262: [[1608], 256],
		65263: [[1609], 256],
		65264: [[1609], 256],
		65265: [[1610], 256],
		65266: [[1610], 256],
		65267: [[1610], 256],
		65268: [[1610], 256],
		65269: [[1604, 1570], 256],
		65270: [[1604, 1570], 256],
		65271: [[1604, 1571], 256],
		65272: [[1604, 1571], 256],
		65273: [[1604, 1573], 256],
		65274: [[1604, 1573], 256],
		65275: [[1604, 1575], 256],
		65276: [[1604, 1575], 256]
	},
	65280: {
		65281: [[33], 256],
		65282: [[34], 256],
		65283: [[35], 256],
		65284: [[36], 256],
		65285: [[37], 256],
		65286: [[38], 256],
		65287: [[39], 256],
		65288: [[40], 256],
		65289: [[41], 256],
		65290: [[42], 256],
		65291: [[43], 256],
		65292: [[44], 256],
		65293: [[45], 256],
		65294: [[46], 256],
		65295: [[47], 256],
		65296: [[48], 256],
		65297: [[49], 256],
		65298: [[50], 256],
		65299: [[51], 256],
		65300: [[52], 256],
		65301: [[53], 256],
		65302: [[54], 256],
		65303: [[55], 256],
		65304: [[56], 256],
		65305: [[57], 256],
		65306: [[58], 256],
		65307: [[59], 256],
		65308: [[60], 256],
		65309: [[61], 256],
		65310: [[62], 256],
		65311: [[63], 256],
		65312: [[64], 256],
		65313: [[65], 256],
		65314: [[66], 256],
		65315: [[67], 256],
		65316: [[68], 256],
		65317: [[69], 256],
		65318: [[70], 256],
		65319: [[71], 256],
		65320: [[72], 256],
		65321: [[73], 256],
		65322: [[74], 256],
		65323: [[75], 256],
		65324: [[76], 256],
		65325: [[77], 256],
		65326: [[78], 256],
		65327: [[79], 256],
		65328: [[80], 256],
		65329: [[81], 256],
		65330: [[82], 256],
		65331: [[83], 256],
		65332: [[84], 256],
		65333: [[85], 256],
		65334: [[86], 256],
		65335: [[87], 256],
		65336: [[88], 256],
		65337: [[89], 256],
		65338: [[90], 256],
		65339: [[91], 256],
		65340: [[92], 256],
		65341: [[93], 256],
		65342: [[94], 256],
		65343: [[95], 256],
		65344: [[96], 256],
		65345: [[97], 256],
		65346: [[98], 256],
		65347: [[99], 256],
		65348: [[100], 256],
		65349: [[101], 256],
		65350: [[102], 256],
		65351: [[103], 256],
		65352: [[104], 256],
		65353: [[105], 256],
		65354: [[106], 256],
		65355: [[107], 256],
		65356: [[108], 256],
		65357: [[109], 256],
		65358: [[110], 256],
		65359: [[111], 256],
		65360: [[112], 256],
		65361: [[113], 256],
		65362: [[114], 256],
		65363: [[115], 256],
		65364: [[116], 256],
		65365: [[117], 256],
		65366: [[118], 256],
		65367: [[119], 256],
		65368: [[120], 256],
		65369: [[121], 256],
		65370: [[122], 256],
		65371: [[123], 256],
		65372: [[124], 256],
		65373: [[125], 256],
		65374: [[126], 256],
		65375: [[10629], 256],
		65376: [[10630], 256],
		65377: [[12290], 256],
		65378: [[12300], 256],
		65379: [[12301], 256],
		65380: [[12289], 256],
		65381: [[12539], 256],
		65382: [[12530], 256],
		65383: [[12449], 256],
		65384: [[12451], 256],
		65385: [[12453], 256],
		65386: [[12455], 256],
		65387: [[12457], 256],
		65388: [[12515], 256],
		65389: [[12517], 256],
		65390: [[12519], 256],
		65391: [[12483], 256],
		65392: [[12540], 256],
		65393: [[12450], 256],
		65394: [[12452], 256],
		65395: [[12454], 256],
		65396: [[12456], 256],
		65397: [[12458], 256],
		65398: [[12459], 256],
		65399: [[12461], 256],
		65400: [[12463], 256],
		65401: [[12465], 256],
		65402: [[12467], 256],
		65403: [[12469], 256],
		65404: [[12471], 256],
		65405: [[12473], 256],
		65406: [[12475], 256],
		65407: [[12477], 256],
		65408: [[12479], 256],
		65409: [[12481], 256],
		65410: [[12484], 256],
		65411: [[12486], 256],
		65412: [[12488], 256],
		65413: [[12490], 256],
		65414: [[12491], 256],
		65415: [[12492], 256],
		65416: [[12493], 256],
		65417: [[12494], 256],
		65418: [[12495], 256],
		65419: [[12498], 256],
		65420: [[12501], 256],
		65421: [[12504], 256],
		65422: [[12507], 256],
		65423: [[12510], 256],
		65424: [[12511], 256],
		65425: [[12512], 256],
		65426: [[12513], 256],
		65427: [[12514], 256],
		65428: [[12516], 256],
		65429: [[12518], 256],
		65430: [[12520], 256],
		65431: [[12521], 256],
		65432: [[12522], 256],
		65433: [[12523], 256],
		65434: [[12524], 256],
		65435: [[12525], 256],
		65436: [[12527], 256],
		65437: [[12531], 256],
		65438: [[12441], 256],
		65439: [[12442], 256],
		65440: [[12644], 256],
		65441: [[12593], 256],
		65442: [[12594], 256],
		65443: [[12595], 256],
		65444: [[12596], 256],
		65445: [[12597], 256],
		65446: [[12598], 256],
		65447: [[12599], 256],
		65448: [[12600], 256],
		65449: [[12601], 256],
		65450: [[12602], 256],
		65451: [[12603], 256],
		65452: [[12604], 256],
		65453: [[12605], 256],
		65454: [[12606], 256],
		65455: [[12607], 256],
		65456: [[12608], 256],
		65457: [[12609], 256],
		65458: [[12610], 256],
		65459: [[12611], 256],
		65460: [[12612], 256],
		65461: [[12613], 256],
		65462: [[12614], 256],
		65463: [[12615], 256],
		65464: [[12616], 256],
		65465: [[12617], 256],
		65466: [[12618], 256],
		65467: [[12619], 256],
		65468: [[12620], 256],
		65469: [[12621], 256],
		65470: [[12622], 256],
		65474: [[12623], 256],
		65475: [[12624], 256],
		65476: [[12625], 256],
		65477: [[12626], 256],
		65478: [[12627], 256],
		65479: [[12628], 256],
		65482: [[12629], 256],
		65483: [[12630], 256],
		65484: [[12631], 256],
		65485: [[12632], 256],
		65486: [[12633], 256],
		65487: [[12634], 256],
		65490: [[12635], 256],
		65491: [[12636], 256],
		65492: [[12637], 256],
		65493: [[12638], 256],
		65494: [[12639], 256],
		65495: [[12640], 256],
		65498: [[12641], 256],
		65499: [[12642], 256],
		65500: [[12643], 256],
		65504: [[162], 256],
		65505: [[163], 256],
		65506: [[172], 256],
		65507: [[175], 256],
		65508: [[166], 256],
		65509: [[165], 256],
		65510: [[8361], 256],
		65512: [[9474], 256],
		65513: [[8592], 256],
		65514: [[8593], 256],
		65515: [[8594], 256],
		65516: [[8595], 256],
		65517: [[9632], 256],
		65518: [[9675], 256]
	}
};

/* eslint no-bitwise: "off", max-statements: "off", max-lines: "off" */

// Taken from: https://github.com/walling/unorm/blob/master/lib/unorm.js

/*
 * UnicodeNormalizer 1.0.0
 * Copyright (c) 2008 Matsuza
 * Dual licensed under the MIT (MIT-LICENSE.txt) and
 * GPL (GPL-LICENSE.txt) licenses.
 * $Date: 2008-06-05 16:44:17 +0200 (Thu, 05 Jun 2008) $
 * $Rev: 13309 $
 */

"use strict";

/* removed: var _$_data_394         = require("./_data"); */;

var __floor_397 = Math.floor
  , forms = _$primitiveSet_329("NFC", "NFD", "NFKC", "NFKD")
  , DEFAULT_FEATURE = [null, 0, {}]
  , CACHE_THRESHOLD = 10
  , SBase = 0xac00
  , LBase = 0x1100
  , VBase = 0x1161
  , TBase = 0x11a7
  , LCount = 19
  , VCount = 21
  , TCount = 28
  , NCount = VCount * TCount
  , SCount = LCount * NCount
  , UChar
  , __cache_397 = {}
  , cacheCounter = []
  , fromCache
  , fromData
  , fromCpOnly
  , fromRuleBasedJamo
  , fromCpFilter
  , strategies
  , UCharIterator
  , RecursDecompIterator
  , DecompIterator
  , CompIterator
  , createIterator
  , normalize;

UChar = function (cp, feature) {
	this.codepoint = cp;
	this.feature = feature;
};

// Strategies
(function () { for (var i = 0; i <= 0xff; ++i) cacheCounter[i] = 0; })();

fromCache = function (nextStep, cp, needFeature) {
	var ret = __cache_397[cp];
	if (!ret) {
		ret = nextStep(cp, needFeature);
		if (Boolean(ret.feature) && ++cacheCounter[(cp >> 8) & 0xff] > CACHE_THRESHOLD) {
			__cache_397[cp] = ret;
		}
	}
	return ret;
};

fromData = function (next, cp) {
	var hash = cp & 0xff00, dunit = UChar.udata[hash] || {}, feature = dunit[cp];
	return feature ? new UChar(cp, feature) : new UChar(cp, DEFAULT_FEATURE);
};
fromCpOnly = function (next, cp, needFeature) {
	return needFeature ? next(cp, needFeature) : new UChar(cp, null);
};

fromRuleBasedJamo = function (next, cp, needFeature) {
	var char, base, i, arr, SIndex, TIndex, feature, j;
	if (cp < LBase || (LBase + LCount <= cp && cp < SBase) || SBase + SCount < cp) {
		return next(cp, needFeature);
	}
	if (LBase <= cp && cp < LBase + LCount) {
		char = {};
		base = (cp - LBase) * VCount;
		for (i = 0; i < VCount; ++i) {
			char[VBase + i] = SBase + TCount * (i + base);
		}
		arr = new Array(3);
		arr[2] = char;
		return new UChar(cp, arr);
	}

	SIndex = cp - SBase;
	TIndex = SIndex % TCount;
	feature = [];
	if (TIndex === 0) {
		feature[0] = [LBase + __floor_397(SIndex / NCount), VBase + __floor_397((SIndex % NCount) / TCount)];
		feature[2] = {};
		for (j = 1; j < TCount; ++j) {
			feature[2][TBase + j] = cp + j;
		}
	} else {
		feature[0] = [SBase + SIndex - TIndex, TBase + TIndex];
	}
	return new UChar(cp, feature);
};

fromCpFilter = function (next, cp, needFeature) {
	return cp < 60 || (cp > 13311 && cp < 42607)
		? new UChar(cp, DEFAULT_FEATURE)
		: next(cp, needFeature);
};

strategies = [fromCpFilter, fromCache, fromCpOnly, fromRuleBasedJamo, fromData];

UChar.fromCharCode = strategies.reduceRight(function (next, strategy) {
	return function (cp, needFeature) { return strategy(next, cp, needFeature); };
}, null);

UChar.isHighSurrogate = function (cp) { return cp >= 0xd800 && cp <= 0xdbff; };
UChar.isLowSurrogate = function (cp) { return cp >= 0xdc00 && cp <= 0xdfff; };

UChar.prototype.prepFeature = function () {
	if (!this.feature) {
		this.feature = UChar.fromCharCode(this.codepoint, true).feature;
	}
};

UChar.prototype.toString = function () {
	var num;
	if (this.codepoint < 0x10000) return String.fromCharCode(this.codepoint);
	num = this.codepoint - 0x10000;
	return String.fromCharCode(__floor_397(num / 0x400) + 0xd800, (num % 0x400) + 0xdc00);
};

UChar.prototype.getDecomp = function () {
	this.prepFeature();
	return this.feature[0] || null;
};

UChar.prototype.isCompatibility = function () {
	this.prepFeature();
	return Boolean(this.feature[1]) && this.feature[1] & (1 << 8);
};
UChar.prototype.isExclude = function () {
	this.prepFeature();
	return Boolean(this.feature[1]) && this.feature[1] & (1 << 9);
};
UChar.prototype.getCanonicalClass = function () {
	this.prepFeature();
	return this.feature[1] ? this.feature[1] & 0xff : 0;
};
UChar.prototype.getComposite = function (following) {
	var cp;
	this.prepFeature();
	if (!this.feature[2]) return null;
	cp = this.feature[2][following.codepoint];
	return cp ? UChar.fromCharCode(cp) : null;
};

UCharIterator = function (str) {
	this.str = str;
	this.cursor = 0;
};
UCharIterator.prototype.next = function () {
	if (Boolean(this.str) && this.cursor < this.str.length) {
		var cp = this.str.charCodeAt(this.cursor++), d;
		if (
			UChar.isHighSurrogate(cp) &&
			this.cursor < this.str.length &&
			UChar.isLowSurrogate((d = this.str.charCodeAt(this.cursor)))
		) {
			cp = (cp - 0xd800) * 0x400 + (d - 0xdc00) + 0x10000;
			++this.cursor;
		}
		return UChar.fromCharCode(cp);
	}
	this.str = null;
	return null;
};

RecursDecompIterator = function (it, cano) {
	this.it = it;
	this.canonical = cano;
	this.resBuf = [];
};

RecursDecompIterator.prototype.next = function () {
	var recursiveDecomp, uchar;
	recursiveDecomp = function (cano, ucharLoc) {
		var decomp = ucharLoc.getDecomp(), ret, i, a, j;
		if (Boolean(decomp) && !(cano && ucharLoc.isCompatibility())) {
			ret = [];
			for (i = 0; i < decomp.length; ++i) {
				a = recursiveDecomp(cano, UChar.fromCharCode(decomp[i]));
				// Ret.concat(a); //<-why does not this work?
				// following block is a workaround.
				for (j = 0; j < a.length; ++j) ret.push(a[j]);
			}
			return ret;
		}
		return [ucharLoc];
	};
	if (this.resBuf.length === 0) {
		uchar = this.it.next();
		if (!uchar) return null;
		this.resBuf = recursiveDecomp(this.canonical, uchar);
	}
	return this.resBuf.shift();
};

DecompIterator = function (it) {
	this.it = it;
	this.resBuf = [];
};

DecompIterator.prototype.next = function () {
	var cc, uchar, inspt, uchar2, cc2;
	if (this.resBuf.length === 0) {
		do {
			uchar = this.it.next();
			if (!uchar) break;
			cc = uchar.getCanonicalClass();
			inspt = this.resBuf.length;
			if (cc !== 0) {
				for (inspt; inspt > 0; --inspt) {
					uchar2 = this.resBuf[inspt - 1];
					cc2 = uchar2.getCanonicalClass();
					// eslint-disable-next-line max-depth
					if (cc2 <= cc) break;
				}
			}
			this.resBuf.splice(inspt, 0, uchar);
		} while (cc !== 0);
	}
	return this.resBuf.shift();
};

CompIterator = function (it) {
	this.it = it;
	this.procBuf = [];
	this.resBuf = [];
	this.lastClass = null;
};

CompIterator.prototype.next = function () {
	var uchar, starter, composite, cc;
	while (this.resBuf.length === 0) {
		uchar = this.it.next();
		if (!uchar) {
			this.resBuf = this.procBuf;
			this.procBuf = [];
			break;
		}
		if (this.procBuf.length === 0) {
			this.lastClass = uchar.getCanonicalClass();
			this.procBuf.push(uchar);
		} else {
			starter = this.procBuf[0];
			composite = starter.getComposite(uchar);
			cc = uchar.getCanonicalClass();
			if (Boolean(composite) && (this.lastClass < cc || this.lastClass === 0)) {
				this.procBuf[0] = composite;
			} else {
				if (cc === 0) {
					this.resBuf = this.procBuf;
					this.procBuf = [];
				}
				this.lastClass = cc;
				this.procBuf.push(uchar);
			}
		}
	}
	return this.resBuf.shift();
};

createIterator = function (mode, str) {
	switch (mode) {
		case "NFD":
			return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true));
		case "NFKD":
			return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false));
		case "NFC":
			return new CompIterator(
				new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true))
			);
		case "NFKC":
			return new CompIterator(
				new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false))
			);
		default:
			throw new Error(mode + " is invalid");
	}
};
normalize = function (mode, str) {
	var it = createIterator(mode, str), ret = "", uchar;
	while ((uchar = it.next())) ret += uchar.toString();
	return ret;
};

/* Unicode data */
UChar.udata = _$_data_394;

var _$shim_397 = function (/* Form*/) {
	var str = String(_$validValue_340(this)), form = arguments[0];
	if (form === undefined) form = "NFC";
	else form = String(form);
	if (!forms[form]) throw new RangeError("Invalid normalization form: " + form);
	return normalize(form, str);
};

"use strict";

var _$normalize_395 = _$isImplemented_396() ? String.prototype.normalize : _$shim_397;

"use strict";

var __indexOf_400 = String.prototype.indexOf, __slice_400 = String.prototype.slice;

var _$plainReplace_400 = function (search, replace) {
	var index = __indexOf_400.call(this, search);
	if (index === -1) return String(this);
	return __slice_400.call(this, 0, index) + replace + __slice_400.call(this, index + String(search).length);
};

"use strict";

/* removed: var _$validValue_340 = require("../../object/valid-value"); */;

var _$plainReplaceAll_399 = function (search, replace) {
	var index, pos = 0, str = String(_$validValue_340(this)), sl, rl;
	search = String(search);
	replace = String(replace);
	sl = search.length;
	rl = replace.length;
	while ((index = str.indexOf(search, pos)) !== -1) {
		str = str.slice(0, index) + replace + str.slice(index + sl);
		pos = index + rl;
	}
	return str;
};

"use strict";

var __str_405 = "razdwatrzy";

var _$isImplemented_405 = function () {
	if (typeof __str_405.startsWith !== "function") return false;
	return __str_405.startsWith("trzy") === false && __str_405.startsWith("raz") === true;
};

"use strict";

var __max_406       = Math.max
  , __min_406       = Math.min;

var _$shim_406 = function (searchString /*, position*/) {
	var start, self = String(_$validValue_340(this));
	start = __min_406(__max_406(_$toInteger_266(arguments[1]), 0), self.length);
	return self.indexOf(searchString, start) === start;
};

"use strict";

var _$startsWith_404 = _$isImplemented_405() ? String.prototype.startsWith : _$shim_406;

"use strict";

/* removed: var _$validateStringifiableValue_343 = require("../../object/validate-stringifiable-value"); */;

var _$uncapitalize_407 = function () {
	var str = _$validateStringifiableValue_343(this);
	return str.charAt(0).toLowerCase() + str.slice(1);
};

"use strict";

var _$_392 = {
	"@@iterator": _$Iterator_373,
	"at": _$at_376,
	"count": _$count_386,
	"camelToHyphen": _$camelToHyphen_377,
	"capitalize": _$capitalize_378,
	"caseInsensitiveCompare": _$caseInsensitiveCompare_379,
	"codePointAt": _$codePointAt_380,
	"contains": _$contains_383,
	"hyphenToCamel": _$hyphenToCamel_390,
	"endsWith": _$endsWith_387,
	"indent": _$indent_391,
	"last": _$last_393,
	"normalize": _$normalize_395,
	"pad": _$pad_398,
	"plainReplace": _$plainReplace_400,
	"plainReplaceAll": _$plainReplaceAll_399,
	"repeat": _$repeat_401,
	"startsWith": _$startsWith_404,
	"uncapitalize": _$uncapitalize_407
};

"use strict";

var _$isImplemented_410 = function () {
	var fromCodePoint = String.fromCodePoint;
	if (typeof fromCodePoint !== "function") return false;
	return fromCodePoint(0x1d306, 0x61, 0x1d307) === "\ud834\udf06a\ud834\udf07";
};

// Based on:
// http://norbertlindenberg.com/2012/05/ecmascript-supplementary-characters/
// and:
// https://github.com/mathiasbynens/String.fromCodePoint/blob/master
// /fromcodepoint.js

"use strict";

var __floor_411 = Math.floor, fromCharCode = String.fromCharCode;

// eslint-disable-next-line no-unused-vars
var _$shim_411 = function (codePoint1 /*, …codePoints*/) {
	var chars = [], length = arguments.length, i, codePoint, result = "";
	for (i = 0; i < length; ++i) {
		codePoint = Number(arguments[i]);
		if (
			!isFinite(codePoint) ||
			codePoint < 0 ||
			codePoint > 0x10ffff ||
			__floor_411(codePoint) !== codePoint
		) {
			throw new RangeError("Invalid code point " + codePoint);
		}

		if (codePoint < 0x10000) {
			chars.push(codePoint);
		} else {
			codePoint -= 0x10000;
			// eslint-disable-next-line no-bitwise
			chars.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
		}
		if (i + 1 !== length && chars.length <= 0x4000) continue;
		result += fromCharCode.apply(null, chars);
		chars.length = 0;
	}
	return result;
};

"use strict";

var _$fromCodePoint_409 = _$isImplemented_410() ? String.fromCodePoint : _$shim_411;

"use strict";

/* removed: var _$toPosInteger_267 = require("../number/to-pos-integer"); */;

var generated = Object.create(null), random = Math.random, uniqTryLimit = 100;

var getChunk = function () { return random().toString(36).slice(2); };

var getString = function (/* length */) {
	var str = getChunk(), length = arguments[0];
	if (!_$isValue_318(length)) return str;
	while (str.length < length) str += getChunk();
	return str.slice(0, length);
};

var _$random_415 = function (/* options */) {
	var options = Object(arguments[0]), length = options.length, isUnique = options.isUnique;

	if (_$isValue_318(length)) length = _$toPosInteger_267(length);

	var str = getString(length);
	if (isUnique) {
		var count = 0;
		while (generated[str]) {
			if (++count === uniqTryLimit) {
				throw new Error(
					"Cannot generate random string.\n" +
						"String.random is not designed to effectively generate many short and " +
						"unique random strings"
				);
			}
			str = getString(length);
		}
		generated[str] = true;
	}
	return str;
};

"use strict";

var __generated_414 = Object.create(null), __random_414 = Math.random;

var _$randomUniq_414 = function () {
	var str;
	do {
		str = __random_414().toString(36).slice(2);
	} while (__generated_414[str]);
	return str;
};

"use strict";

var _$isImplemented_417 = function () {
	var raw = String.raw, test;
	if (typeof raw !== "function") return false;
	test = ["foo\nbar", "marko\n"];
	test.raw = ["foo\\nbar", "marko\\n"];
	return raw(test, "INSE\nRT") === "foo\\nbarINSE\nRTmarko\\n";
};

"use strict";

var reduce     = Array.prototype.reduce;

var _$shim_418 = function (callSite /*,  …substitutions*/) {
	var args, rawValue = Object(_$validValue_340(Object(_$validValue_340(callSite)).raw));
	if (!_$toPosInteger_267(rawValue.length)) return "";
	args = arguments;
	return reduce.call(rawValue, function (str1, str2, i) {
		return str1 + String(args[i]) + str2;
	});
};

"use strict";

var _$raw_416 = _$isImplemented_417() ? String.raw : _$shim_418;

"use strict";

var _$string_412 = {
	"#": _$_392,
	"formatMethod": _$formatMethod_408,
	"fromCodePoint": _$fromCodePoint_409,
	"isString": _$isString_413,
	"random": _$random_415,
	"randomUniq": _$randomUniq_414,
	"raw": _$raw_416
};

"use strict";

var _$es5Ext_es5Ext = {
	global: _$global_180,
	optionalChaining: _$optionalChaining_345,
	safeToString: _$safeToString_372,
	toShortStringRepresentation: _$toShortStringRepresentation_419,

	array: _$array_133,
	boolean: _$boolean_140,
	date: _$date_150,
	error: _$error_157,
	function: _$function_173,
	iterable: _$iterable_182,
	json: _$json_186,
	math: _$math_223,
	number: _$number_249,
	object: _$object_302,
	promise: _$promise_351,
	regExp: _$regExp_369,
	string: _$string_412
};

var _$processNextickArgs_458 = {};
(function (process){(function (){
'use strict';

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  _$processNextickArgs_458 = { nextTick: nextTick };
} else {
  _$processNextickArgs_458 = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


}).call(this)}).call(this,_$browser_459)
var __toString_451 = {}.toString;

var _$isarray_451 = Array.isArray || function (arr) {
  return __toString_451.call(arr) == '[object Array]';
};

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var objectCreate = Object.create || objectCreatePolyfill
var objectKeys = Object.keys || objectKeysPolyfill
var __bind_442 = Function.prototype.bind || functionBindPolyfill

function EventEmitter() {
  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
    this._events = objectCreate(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}
var _$EventEmitter_442 = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

var hasDefineProperty;
try {
  var o = {};
  if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
  hasDefineProperty = o.x === 0;
} catch (err) { hasDefineProperty = false }
if (hasDefineProperty) {
  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
      return defaultMaxListeners;
    },
    set: function(arg) {
      // check whether the input is a positive number (whose value is zero or
      // greater and not a NaN).
      if (typeof arg !== 'number' || arg < 0 || arg !== arg)
        throw new TypeError('"defaultMaxListeners" must be a positive number');
      defaultMaxListeners = arg;
    }
  });
} else {
  EventEmitter.defaultMaxListeners = defaultMaxListeners;
}

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    if (arguments.length > 1)
      er = arguments[1];
    if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Unhandled "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
      // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
      // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = objectCreate(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
          listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
          prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
            existing.length + ' "' + String(type) + '" listeners ' +
            'added. Use emitter.setMaxListeners() to ' +
            'increase limit.');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        if (typeof console === 'object' && console.warn) {
          console.warn('%s: %s', w.name, w.message);
        }
      }
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    switch (arguments.length) {
      case 0:
        return this.listener.call(this.target);
      case 1:
        return this.listener.call(this.target, arguments[0]);
      case 2:
        return this.listener.call(this.target, arguments[0], arguments[1]);
      case 3:
        return this.listener.call(this.target, arguments[0], arguments[1],
            arguments[2]);
      default:
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i)
          args[i] = arguments[i];
        this.listener.apply(this.target, args);
    }
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = __bind_442.call(onceWrapper, state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = objectCreate(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else
          spliceOne(list, position);

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = objectCreate(null);
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = objectCreate(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = objectKeys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = objectCreate(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (!events)
    return [];

  var evlistener = events[type];
  if (!evlistener)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function objectCreatePolyfill(proto) {
  var F = function() {};
  F.prototype = proto;
  return new F;
}
function objectKeysPolyfill(obj) {
  var keys = [];
  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
    keys.push(k);
  }
  return k;
}
function functionBindPolyfill(context) {
  var fn = this;
  return function () {
    return fn.apply(context, arguments);
  };
}

var _$streamBrowser_467 = _$EventEmitter_442.EventEmitter;

var _$base64Js_5 = {};
'use strict'

_$base64Js_5.byteLength = byteLength
_$base64Js_5.toByteArray = toByteArray
_$base64Js_5.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var __code_5 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = __code_5.length; i < len; ++i) {
  lookup[i] = __code_5[i]
  revLookup[__code_5.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

var _$ieee754_447 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
_$ieee754_447.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

_$ieee754_447.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

var _$safeBuffer_468 = {};
/* eslint-disable node/no-deprecated-api */
var buffer = _$buffer_8({})
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  _$safeBuffer_468 = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, _$safeBuffer_468)
  _$safeBuffer_468.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

var _$util_13 = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function __isArray_13(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return __objectToString_13(arg) === '[object Array]';
}
_$util_13.isArray = __isArray_13;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
_$util_13.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
_$util_13.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
_$util_13.isNullOrUndefined = isNullOrUndefined;

function __isNumber_13(arg) {
  return typeof arg === 'number';
}
_$util_13.isNumber = __isNumber_13;

function __isString_13(arg) {
  return typeof arg === 'string';
}
_$util_13.isString = __isString_13;

function __isSymbol_13(arg) {
  return typeof arg === 'symbol';
}
_$util_13.isSymbol = __isSymbol_13;

function isUndefined(arg) {
  return arg === void 0;
}
_$util_13.isUndefined = isUndefined;

function __isRegExp_13(re) {
  return __objectToString_13(re) === '[object RegExp]';
}
_$util_13.isRegExp = __isRegExp_13;

function __isObject_13(arg) {
  return typeof arg === 'object' && arg !== null;
}
_$util_13.isObject = __isObject_13;

function __isDate_13(d) {
  return __objectToString_13(d) === '[object Date]';
}
_$util_13.isDate = __isDate_13;

function __isError_13(e) {
  return (__objectToString_13(e) === '[object Error]' || e instanceof Error);
}
_$util_13.isError = __isError_13;

function __isFunction_13(arg) {
  return typeof arg === 'function';
}
_$util_13.isFunction = __isFunction_13;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
_$util_13.isPrimitive = isPrimitive;

_$util_13.isBuffer = _$buffer_8({}).Buffer.isBuffer;

function __objectToString_13(o) {
  return Object.prototype.toString.call(o);
}

var _$inherits_browser_448 = {};
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  _$inherits_browser_448 = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  _$inherits_browser_448 = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

var _$empty_6 = {};

var _$BufferList_465 = {};
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __Buffer_465 = _$safeBuffer_468.Buffer;
/* removed: var _$empty_6 = require('util'); */;

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

_$BufferList_465 = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return __Buffer_465.alloc(0);
    var ret = __Buffer_465.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (_$empty_6 && _$empty_6.inspect && _$empty_6.inspect.custom) {
  _$BufferList_465.prototype[_$empty_6.inspect.custom] = function () {
    var obj = _$empty_6.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}
'use strict';

/*<replacement>*/

/* removed: var _$processNextickArgs_458 = require('process-nextick-args'); */;
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        _$processNextickArgs_458.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        _$processNextickArgs_458.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        _$processNextickArgs_458.nextTick(emitErrorNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        _$processNextickArgs_458.nextTick(emitErrorNT, _this, err);
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

var _$destroy_466 = {
  destroy: destroy,
  undestroy: undestroy
};
var _$deprecate_602 = {};
(function (global){(function (){

/**
 * Module exports.
 */

_$deprecate_602 = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

var _$Transform_463 = Transform;

var __Duplex_463 = _$Duplex_460({});

/*<replacement>*/
var __util_463 = Object.create(_$util_13);
__util_463.inherits = _$inherits_browser_448;
/*</replacement>*/

__util_463.inherits(Transform, __Duplex_463);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  __Duplex_463.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return __Duplex_463.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  __Duplex_463.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

var _$PassThrough_461 = PassThrough;

/* removed: var _$Transform_463 = require('./_stream_transform'); */;

/*<replacement>*/
var __util_461 = Object.create(_$util_13);
__util_461.inherits = _$inherits_browser_448;
/*</replacement>*/

__util_461.inherits(PassThrough, _$Transform_463);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  _$Transform_463.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
var _$readableBrowser_470 = {};
_$readableBrowser_470 = _$readableBrowser_470 = _$Readable_462({});
_$readableBrowser_470.Stream = _$readableBrowser_470;
_$readableBrowser_470.Readable = _$readableBrowser_470;
_$readableBrowser_470.Writable = _$Writable_464({});
_$readableBrowser_470.Duplex = _$Duplex_460({});
_$readableBrowser_470.Transform = _$Transform_463;
_$readableBrowser_470.PassThrough = _$PassThrough_461;

var _$isBuffer_604 = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
var _$inherits_browser_603 = {};
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  _$inherits_browser_603 = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  _$inherits_browser_603 = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

var _$util_605 = {};
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
_$util_605.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
_$util_605.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return _$util_605.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
_$util_605.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = _$util_605.format.apply(_$util_605, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    _$util_605._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
_$util_605.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== _$util_605.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
_$util_605.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
_$util_605.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
_$util_605.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
_$util_605.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
_$util_605.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
_$util_605.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
_$util_605.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
_$util_605.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
_$util_605.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
_$util_605.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
_$util_605.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
_$util_605.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
_$util_605.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
_$util_605.isPrimitive = isPrimitive;

_$util_605.isBuffer = _$isBuffer_604;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
_$util_605.log = function() {
  console.log('%s - %s', timestamp(), _$util_605.format.apply(_$util_605, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
_$util_605.inherits = _$inherits_browser_603;

_$util_605._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this)}).call(this,_$browser_459,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
var _$extend_611 = extend

var __hasOwnProperty_611 = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (__hasOwnProperty_611.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}

var _$through2_585 = {};
(function (process){(function (){
var Transform = _$readableBrowser_470.Transform
  , inherits  = _$util_605.inherits

function DestroyableTransform(opts) {
  Transform.call(this, opts)
  this._destroyed = false
}

inherits(DestroyableTransform, Transform)

DestroyableTransform.prototype.destroy = function(err) {
  if (this._destroyed) return
  this._destroyed = true
  
  var self = this
  process.nextTick(function() {
    if (err)
      self.emit('error', err)
    self.emit('close')
  })
}

// a noop _transform function
function noop (chunk, enc, callback) {
  callback(null, chunk)
}


// create a new export function, used by both the main export and
// the .ctor export, contains common logic for dealing with arguments
function through2 (construct) {
  return function (options, transform, flush) {
    if (typeof options == 'function') {
      flush     = transform
      transform = options
      options   = {}
    }

    if (typeof transform != 'function')
      transform = noop

    if (typeof flush != 'function')
      flush = null

    return construct(options, transform, flush)
  }
}


// main export, just make me a transform stream!
_$through2_585 = through2(function (options, transform, flush) {
  var t2 = new DestroyableTransform(options)

  t2._transform = transform

  if (flush)
    t2._flush = flush

  return t2
})


// make me a reusable prototype that I can `new`, or implicitly `new`
// with a constructor call
_$through2_585.ctor = through2(function (options, transform, flush) {
  function Through2 (override) {
    if (!(this instanceof Through2))
      return new Through2(override)

    this.options = _$extend_611(options, override)

    DestroyableTransform.call(this, this.options)
  }

  inherits(Through2, DestroyableTransform)

  Through2.prototype._transform = transform

  if (flush)
    Through2.prototype._flush = flush

  return Through2
})


_$through2_585.obj = through2(function (options, transform, flush) {
  var t2 = new DestroyableTransform(_$extend_611({ objectMode: true, highWaterMark: 16 }, options))

  t2._transform = transform

  if (flush)
    t2._flush = flush

  return t2
})

}).call(this)}).call(this,_$browser_459)
var _$pathBrowserify_455 = {};
(function (process){(function (){
// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
_$pathBrowserify_455.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
_$pathBrowserify_455.normalize = function(path) {
  var isAbsolute = _$pathBrowserify_455.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
_$pathBrowserify_455.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
_$pathBrowserify_455.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return _$pathBrowserify_455.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
_$pathBrowserify_455.relative = function(from, to) {
  from = _$pathBrowserify_455.resolve(from).substr(1);
  to = _$pathBrowserify_455.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

_$pathBrowserify_455.sep = '/';
_$pathBrowserify_455.delimiter = ':';

_$pathBrowserify_455.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
_$pathBrowserify_455.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

_$pathBrowserify_455.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

}).call(this)}).call(this,_$browser_459)
var _$clone_11 = { exports: {} };
(function (Buffer){(function (){
var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if ("object" === 'object' && _$clone_11.exports) {
  _$clone_11.exports = clone;
}

}).call(this)}).call(this,_$buffer_8({}).Buffer)
_$clone_11 = _$clone_11.exports
'use strict'

var __PassThrough_12 = _$readableBrowser_470.PassThrough
/* removed: var _$inherits_browser_448 = require('inherits') */;
/* removed: var _$processNextickArgs_458 = require('process-nextick-args') */;

function Cloneable (stream, opts) {
  if (!(this instanceof Cloneable)) {
    return new Cloneable(stream, opts)
  }

  var objectMode = stream._readableState.objectMode
  this._original = stream
  this._clonesCount = 1

  opts = opts || {}
  opts.objectMode = objectMode

  __PassThrough_12.call(this, opts)

  forwardDestroy(stream, this)

  this.on('newListener', onData)
  this.once('resume', onResume)

  this._hasListener = true
}

_$inherits_browser_448(Cloneable, __PassThrough_12)

function onData (event, listener) {
  if (event === 'data' || event === 'readable') {
    this._hasListener = false
    this.removeListener('newListener', onData)
    this.removeListener('resume', onResume)
    _$processNextickArgs_458.nextTick(clonePiped, this)
  }
}

function onResume () {
  this._hasListener = false
  this.removeListener('newListener', onData)
  _$processNextickArgs_458.nextTick(clonePiped, this)
}

Cloneable.prototype.clone = function () {
  if (!this._original) {
    throw new Error('already started')
  }

  this._clonesCount++

  // the events added by the clone should not count
  // for starting the flow
  this.removeListener('newListener', onData)
  var clone = new Clone(this)
  if (this._hasListener) {
    this.on('newListener', onData)
  }

  return clone
}

Cloneable.prototype._destroy = function (err, cb) {
  if (!err) {
    this.push(null)
    this.end()
    this.emit('close')
  }

  _$processNextickArgs_458.nextTick(cb, err)
}

function forwardDestroy (src, dest) {
  src.on('error', destroy)
  src.on('close', onClose)

  function destroy (err) {
    src.removeListener('close', onClose)
    dest.destroy(err)
  }

  function onClose () {
    dest.end()
  }
}

function clonePiped (that) {
  if (--that._clonesCount === 0 && !that._readableState.destroyed) {
    that._original.pipe(that)
    that._original = undefined
  }
}

function Clone (parent, opts) {
  if (!(this instanceof Clone)) {
    return new Clone(parent, opts)
  }

  var objectMode = parent._readableState.objectMode

  opts = opts || {}
  opts.objectMode = objectMode

  this.parent = parent

  __PassThrough_12.call(this, opts)

  forwardDestroy(parent, this)

  parent.pipe(this)

  // the events added by the clone should not count
  // for starting the flow
  // so we add the newListener handle after we are done
  this.on('newListener', onDataClone)
  this.on('resume', onResumeClone)
}

function onDataClone (event, listener) {
  // We start the flow once all clones are piped or destroyed
  if (event === 'data' || event === 'readable' || event === 'close') {
    _$processNextickArgs_458.nextTick(clonePiped, this.parent)
    this.removeListener('newListener', onDataClone)
  }
}

function onResumeClone () {
  this.removeListener('newListener', onDataClone)
  _$processNextickArgs_458.nextTick(clonePiped, this.parent)
}

_$inherits_browser_448(Clone, __PassThrough_12)

Clone.prototype.clone = function () {
  return this.parent.clone()
}

Cloneable.isCloneable = function (stream) {
  return stream instanceof Cloneable || stream instanceof Clone
}

Clone.prototype._destroy = function (err, cb) {
  if (!err) {
    this.push(null)
    this.end()
    this.emit('close')
  }

  _$processNextickArgs_458.nextTick(cb, err)
}

var _$Cloneable_12 = Cloneable

'use strict';

/* removed: var _$pathBrowserify_455 = require('path'); */;

function replaceExt(npath, ext) {
  if (typeof npath !== 'string') {
    return npath;
  }

  if (npath.length === 0) {
    return npath;
  }

  var nFileName = _$pathBrowserify_455.basename(npath, _$pathBrowserify_455.extname(npath)) + ext;
  var nFilepath = _$pathBrowserify_455.join(_$pathBrowserify_455.dirname(npath), nFileName);

  // Because `path.join` removes the head './' from the given path.
  // This removal can cause a problem when passing the result to `require` or
  // `import`.
  if (startsWithSingleDot(npath)) {
    return '.' + _$pathBrowserify_455.sep + nFilepath;
  }

  return nFilepath;
}

function startsWithSingleDot(fpath) {
  var first2chars = fpath.slice(0, 2);
  return (first2chars === '.' + _$pathBrowserify_455.sep) ||
         (first2chars === './');
}

var _$replaceExt_472 = replaceExt;

var _$_empty_7 = {};

var Stat = _$_empty_7.Stats

var _$cloneStats_10 = cloneStats

function cloneStats(stats) {
  var replacement = new Stat

  Object.keys(stats).forEach(function(key) {
    replacement[key] = stats[key]
  })

  return replacement
}

'use strict';

var __Buffer_9 = _$buffer_8({}).Buffer;

function hasFrom() {
  // Node versions 5.x below 5.10 seem to have a `from` method
  // However, it doesn't clone Buffers
  // Luckily, it reports as `false` to hasOwnProperty
  return (__Buffer_9.hasOwnProperty('from') && typeof __Buffer_9.from === 'function');
}

function cloneBuffer(buf) {
  if (!__Buffer_9.isBuffer(buf)) {
    throw new Error('Can only clone Buffer.');
  }

  if (hasFrom()) {
    return __Buffer_9.from(buf);
  }

  var copy = new __Buffer_9(buf.length);
  buf.copy(copy);
  return copy;
}

cloneBuffer.hasFrom = hasFrom;

var _$cloneBuffer_9 = cloneBuffer;

var _$removeTrailingSeparator_471 = {};
(function (process){(function (){
var isWin = process.platform === 'win32';

_$removeTrailingSeparator_471 = function (str) {
	var i = str.length - 1;
	if (i < 2) {
		return str;
	}
	while (isSeparator(str, i)) {
		i--;
	}
	return str.substr(0, i + 1);
};

function isSeparator(str, i) {
	var char = str[i];
	return i > 0 && (char === '/' || (isWin && char === '\\'));
}

}).call(this)}).call(this,_$browser_459)
'use strict';

function isStream(stream) {
  if (!stream) {
    return false;
  }

  if (typeof stream.pipe !== 'function') {
    return false;
  }

  return true;
}

var _$isStream_609 = isStream;

'use strict';

/* removed: var _$pathBrowserify_455 = require('path'); */;

function __normalize_610(str) {
  return str === '' ? str : _$pathBrowserify_455.normalize(str);
}

var _$normalize_610 = __normalize_610;

'use strict';

function inspectStream(stream) {
  var streamType = stream.constructor.name;
  // Avoid StreamStream
  if (streamType === 'Stream') {
    streamType = '';
  }

  return '<' + streamType + 'Stream>';
}

var _$inspectStream_608 = inspectStream;

var _$File_607 = {};
(function (process){(function (){
'use strict';

/* removed: var _$pathBrowserify_455 = require('path'); */;
/* removed: var _$util_605 = require('util'); */;
var isBuffer = _$buffer_8({}).Buffer.isBuffer;

/* removed: var _$clone_11 = require('clone'); */;
/* removed: var _$Cloneable_12 = require('cloneable-readable'); */;
/* removed: var _$replaceExt_472 = require('replace-ext'); */;
/* removed: var _$cloneStats_10 = require('clone-stats'); */;
/* removed: var _$cloneBuffer_9 = require('clone-buffer'); */;
/* removed: var _$removeTrailingSeparator_471 = require('remove-trailing-separator'); */;

/* removed: var _$isStream_609 = require('./lib/is-stream'); */;
/* removed: var _$normalize_610 = require('./lib/normalize'); */;
/* removed: var _$inspectStream_608 = require('./lib/inspect-stream'); */;

var builtInFields = [
  '_contents', '_symlink', 'contents', 'stat', 'history', 'path',
  '_base', 'base', '_cwd', 'cwd',
];

function File(file) {
  var self = this;

  if (!file) {
    file = {};
  }

  // Stat = files stats object
  this.stat = file.stat || null;

  // Contents = stream, buffer, or null if not read
  this.contents = file.contents || null;

  // Replay path history to ensure proper normalization and trailing sep
  var history = Array.prototype.slice.call(file.history || []);
  if (file.path) {
    history.push(file.path);
  }
  this.history = [];
  history.forEach(function(path) {
    self.path = path;
  });

  this.cwd = file.cwd || process.cwd();
  this.base = file.base;

  this._isVinyl = true;

  this._symlink = null;

  // Set custom properties
  Object.keys(file).forEach(function(key) {
    if (self.constructor.isCustomProp(key)) {
      self[key] = file[key];
    }
  });
}

File.prototype.isBuffer = function() {
  return isBuffer(this.contents);
};

File.prototype.isStream = function() {
  return _$isStream_609(this.contents);
};

File.prototype.isNull = function() {
  return (this.contents === null);
};

File.prototype.isDirectory = function() {
  if (!this.isNull()) {
    return false;
  }

  if (this.stat && typeof this.stat.isDirectory === 'function') {
    return this.stat.isDirectory();
  }

  return false;
};

File.prototype.isSymbolic = function() {
  if (!this.isNull()) {
    return false;
  }

  if (this.stat && typeof this.stat.isSymbolicLink === 'function') {
    return this.stat.isSymbolicLink();
  }

  return false;
};

File.prototype.clone = function(opt) {
  var self = this;

  if (typeof opt === 'boolean') {
    opt = {
      deep: opt,
      contents: true,
    };
  } else if (!opt) {
    opt = {
      deep: true,
      contents: true,
    };
  } else {
    opt.deep = opt.deep === true;
    opt.contents = opt.contents !== false;
  }

  // Clone our file contents
  var contents;
  if (this.isStream()) {
    contents = this.contents.clone();
  } else if (this.isBuffer()) {
    contents = opt.contents ? _$cloneBuffer_9(this.contents) : this.contents;
  }

  var file = new this.constructor({
    cwd: this.cwd,
    base: this.base,
    stat: (this.stat ? _$cloneStats_10(this.stat) : null),
    history: this.history.slice(),
    contents: contents,
  });

  if (this.isSymbolic()) {
    file.symlink = this.symlink;
  }

  // Clone our custom properties
  Object.keys(this).forEach(function(key) {
    if (self.constructor.isCustomProp(key)) {
      file[key] = opt.deep ? _$clone_11(self[key], true) : self[key];
    }
  });
  return file;
};

File.prototype.inspect = function() {
  var inspect = [];

  // Use relative path if possible
  var filePath = this.path ? this.relative : null;

  if (filePath) {
    inspect.push('"' + filePath + '"');
  }

  if (this.isBuffer()) {
    inspect.push(this.contents.inspect());
  }

  if (this.isStream()) {
    inspect.push(_$inspectStream_608(this.contents));
  }

  return '<File ' + inspect.join(' ') + '>';
};

// Newer Node.js versions use this symbol for custom inspection.
if (_$util_605.inspect.custom) {
  File.prototype[_$util_605.inspect.custom] = File.prototype.inspect;
}

File.isCustomProp = function(key) {
  return builtInFields.indexOf(key) === -1;
};

File.isVinyl = function(file) {
  return (file && file._isVinyl === true) || false;
};

// Virtual attributes
// Or stuff with extra logic
Object.defineProperty(File.prototype, 'contents', {
  get: function() {
    return this._contents;
  },
  set: function(val) {
    if (!isBuffer(val) && !_$isStream_609(val) && (val !== null)) {
      throw new Error('File.contents can only be a Buffer, a Stream, or null.');
    }

    // Ask cloneable if the stream is a already a cloneable
    // this avoid piping into many streams
    // reducing the overhead of cloning
    if (_$isStream_609(val) && !_$Cloneable_12.isCloneable(val)) {
      val = _$Cloneable_12(val);
    }

    this._contents = val;
  },
});

Object.defineProperty(File.prototype, 'cwd', {
  get: function() {
    return this._cwd;
  },
  set: function(cwd) {
    if (!cwd || typeof cwd !== 'string') {
      throw new Error('cwd must be a non-empty string.');
    }
    this._cwd = _$removeTrailingSeparator_471(_$normalize_610(cwd));
  },
});

Object.defineProperty(File.prototype, 'base', {
  get: function() {
    return this._base || this._cwd;
  },
  set: function(base) {
    if (base == null) {
      delete this._base;
      return;
    }
    if (typeof base !== 'string' || !base) {
      throw new Error('base must be a non-empty string, or null/undefined.');
    }
    base = _$removeTrailingSeparator_471(_$normalize_610(base));
    if (base !== this._cwd) {
      this._base = base;
    } else {
      delete this._base;
    }
  },
});

// TODO: Should this be moved to vinyl-fs?
Object.defineProperty(File.prototype, 'relative', {
  get: function() {
    if (!this.path) {
      throw new Error('No path specified! Can not get relative.');
    }
    return _$pathBrowserify_455.relative(this.base, this.path);
  },
  set: function() {
    throw new Error('File.relative is generated from the base and path attributes. Do not modify it.');
  },
});

Object.defineProperty(File.prototype, 'dirname', {
  get: function() {
    if (!this.path) {
      throw new Error('No path specified! Can not get dirname.');
    }
    return _$pathBrowserify_455.dirname(this.path);
  },
  set: function(dirname) {
    if (!this.path) {
      throw new Error('No path specified! Can not set dirname.');
    }
    this.path = _$pathBrowserify_455.join(dirname, this.basename);
  },
});

Object.defineProperty(File.prototype, 'basename', {
  get: function() {
    if (!this.path) {
      throw new Error('No path specified! Can not get basename.');
    }
    return _$pathBrowserify_455.basename(this.path);
  },
  set: function(basename) {
    if (!this.path) {
      throw new Error('No path specified! Can not set basename.');
    }
    this.path = _$pathBrowserify_455.join(this.dirname, basename);
  },
});

// Property for getting/setting stem of the filename.
Object.defineProperty(File.prototype, 'stem', {
  get: function() {
    if (!this.path) {
      throw new Error('No path specified! Can not get stem.');
    }
    return _$pathBrowserify_455.basename(this.path, this.extname);
  },
  set: function(stem) {
    if (!this.path) {
      throw new Error('No path specified! Can not set stem.');
    }
    this.path = _$pathBrowserify_455.join(this.dirname, stem + this.extname);
  },
});

Object.defineProperty(File.prototype, 'extname', {
  get: function() {
    if (!this.path) {
      throw new Error('No path specified! Can not get extname.');
    }
    return _$pathBrowserify_455.extname(this.path);
  },
  set: function(extname) {
    if (!this.path) {
      throw new Error('No path specified! Can not set extname.');
    }
    this.path = _$replaceExt_472(this.path, extname);
  },
});

Object.defineProperty(File.prototype, 'path', {
  get: function() {
    return this.history[this.history.length - 1];
  },
  set: function(path) {
    if (typeof path !== 'string') {
      throw new Error('path should be a string.');
    }
    path = _$removeTrailingSeparator_471(_$normalize_610(path));

    // Record history only when path changed
    if (path && path !== this.path) {
      this.history.push(path);
    }
  },
});

Object.defineProperty(File.prototype, 'symlink', {
  get: function() {
    return this._symlink;
  },
  set: function(symlink) {
    // TODO: should this set the mode to symbolic if set?
    if (typeof symlink !== 'string') {
      throw new Error('symlink should be a string');
    }

    this._symlink = _$removeTrailingSeparator_471(_$normalize_610(symlink));
  },
});

_$File_607 = File;

}).call(this)}).call(this,_$browser_459)
var _$indexBrowser_453 = { exports: {} };
(function (Buffer){(function (){
!function (e, t) {
    'object' == typeof _$indexBrowser_453.exports && 'object' == "object" ? _$indexBrowser_453.exports = t() : 'function' == typeof define && define.amd ? define([], t) : 'object' == typeof _$indexBrowser_453.exports ? _$indexBrowser_453.exports.JavaScriptObfuscator = t() : e.JavaScriptObfuscator = t();
}(self, () => (() => {
    var e = {
            3913: (e, t, r) => {
                !function () {
                    'use strict';
                    var e, n, i, a, o, s, c, u, l, d, p, f, m, h, g, y, b, S, v, C, A, _, E, N, I, T;
                    function D(e) {
                        return Y.Statement.hasOwnProperty(e.type);
                    }
                    o = r(140), s = r(649), e = o.Syntax, i = {
                        '??': (n = {
                            Sequence: 0,
                            Yield: 1,
                            Assignment: 1,
                            Conditional: 2,
                            ArrowFunction: 2,
                            NullishCoalescing: 3,
                            LogicalOR: 3,
                            LogicalAND: 4,
                            BitwiseOR: 5,
                            BitwiseXOR: 6,
                            BitwiseAND: 7,
                            Equality: 8,
                            Relational: 9,
                            BitwiseSHIFT: 10,
                            Additive: 11,
                            Multiplicative: 12,
                            Exponentiation: 13,
                            Await: 14,
                            Unary: 14,
                            Postfix: 15,
                            OptionalChaining: 16,
                            Call: 17,
                            New: 18,
                            TaggedTemplate: 19,
                            Member: 20,
                            Primary: 21
                        }).NullishCoalescing,
                        '||': n.LogicalOR,
                        '&&': n.LogicalAND,
                        '|': n.BitwiseOR,
                        '^': n.BitwiseXOR,
                        '&': n.BitwiseAND,
                        '==': n.Equality,
                        '!=': n.Equality,
                        '===': n.Equality,
                        '!==': n.Equality,
                        is: n.Equality,
                        isnt: n.Equality,
                        '<': n.Relational,
                        '>': n.Relational,
                        '<=': n.Relational,
                        '>=': n.Relational,
                        in: n.Relational,
                        instanceof: n.Relational,
                        '<<': n.BitwiseSHIFT,
                        '>>': n.BitwiseSHIFT,
                        '>>>': n.BitwiseSHIFT,
                        '+': n.Additive,
                        '-': n.Additive,
                        '*': n.Multiplicative,
                        '%': n.Multiplicative,
                        '/': n.Multiplicative,
                        '**': n.Exponentiation
                    };
                    var O = 32, R = 33;
                    function M(e, t) {
                        var r = '';
                        for (t |= 0; t > 0; t >>>= 1, e += e)
                            1 & t && (r += e);
                        return r;
                    }
                    function F(e) {
                        var t = e.length;
                        return t && s.code.isLineTerminator(e.charCodeAt(t - 1));
                    }
                    function P(e, t) {
                        var r;
                        for (r in t)
                            t.hasOwnProperty(r) && (e[r] = t[r]);
                        return e;
                    }
                    function x(e, t) {
                        var r, n;
                        function i(e) {
                            return 'object' == typeof e && e instanceof Object && !(e instanceof RegExp);
                        }
                        for (r in t)
                            t.hasOwnProperty(r) && (i(n = t[r]) ? i(e[r]) ? x(e[r], n) : e[r] = x({}, n) : e[r] = n);
                        return e;
                    }
                    function w(e, t) {
                        return 8232 == (-2 & e) ? (t ? 'u' : '\\u') + (8232 === e ? '2028' : '2029') : 10 === e || 13 === e ? (t ? '' : '\\') + (10 === e ? 'n' : 'r') : String.fromCharCode(e);
                    }
                    function B(e, t) {
                        var r;
                        return 8 === e ? '\\b' : 12 === e ? '\\f' : 9 === e ? '\\t' : (r = e.toString(16).toUpperCase(), l || e > 255 ? '\\u' + '0000'.slice(r.length) + r : 0 !== e || s.code.isDecimalDigit(t) ? 11 === e ? '\\x0B' : '\\x' + '00'.slice(r.length) + r : '\\0');
                    }
                    function k(e) {
                        if (92 === e)
                            return '\\\\';
                        if (10 === e)
                            return '\\n';
                        if (13 === e)
                            return '\\r';
                        if (8232 === e)
                            return '\\u2028';
                        if (8233 === e)
                            return '\\u2029';
                        throw new Error('Incorrectly classified character');
                    }
                    function L(e) {
                        var t, r, n, i = '';
                        for (t = 0, r = e.length; t < r; ++t)
                            n = e[t], i += Array.isArray(n) ? L(n) : n;
                        return i;
                    }
                    function $(e, t) {
                        if (!_)
                            return Array.isArray(e) ? L(e) : e;
                        if (null == t) {
                            if (e instanceof a)
                                return e;
                            t = {};
                        }
                        return null == t.loc ? new a(null, null, _, e, t.name || null) : new a(t.loc.start.line, t.loc.start.column, !0 === _ ? t.loc.source || null : _, e, t.name || null);
                    }
                    function j() {
                        return g || ' ';
                    }
                    function G(e, t) {
                        var r, n, i, a;
                        return 0 === (r = $(e).toString()).length ? [t] : 0 === (n = $(t).toString()).length ? [e] : (i = r.charCodeAt(r.length - 1), a = n.charCodeAt(0), (43 === i || 45 === i) && i === a || s.code.isIdentifierPartES5(i) && s.code.isIdentifierPartES5(a) || 47 === i && 105 === a ? [
                            e,
                            j(),
                            t
                        ] : s.code.isWhiteSpace(i) || s.code.isLineTerminator(i) || s.code.isWhiteSpace(a) || s.code.isLineTerminator(a) ? [
                            e,
                            t
                        ] : [
                            e,
                            g,
                            t
                        ]);
                    }
                    function V(e) {
                        return [
                            c,
                            e
                        ];
                    }
                    function U(e) {
                        var t;
                        t = c, e(c += u), c = t;
                    }
                    function H(e, t) {
                        if ('Line' === e.type) {
                            if (F(e.value))
                                return '//' + e.value;
                            var r = '//' + e.value;
                            return N || (r += '\n'), r;
                        }
                        return C.format.indent.adjustMultilineComment && /[\n\r]/.test(e.value) ? function (e, t) {
                            var r, n, i, a, o, u, l, d;
                            for (r = e.split(/\r\n|[\r\n]/), u = Number.MAX_VALUE, n = 1, i = r.length; n < i; ++n) {
                                for (a = r[n], o = 0; o < a.length && s.code.isWhiteSpace(a.charCodeAt(o));)
                                    ++o;
                                u > o && (u = o);
                            }
                            for (void 0 !== t ? (l = c, '*' === r[1][u] && (t += ' '), c = t) : (1 & u && --u, l = c), n = 1, i = r.length; n < i; ++n)
                                d = $(V(r[n].slice(u))), r[n] = _ ? d.join('') : d;
                            return c = l, r.join('\n');
                        }('/*' + e.value + '*/', t) : '/*' + e.value + '*/';
                    }
                    function W(t, r) {
                        var n, i, a, o, l, d, p, f, m, h, g, y;
                        if (t.leadingComments && t.leadingComments.length > 0) {
                            if (o = r, N) {
                                for (r = [], f = (a = t.leadingComments[0]).extendedRange, m = a.range, (y = ((g = E.substring(f[0], m[0])).match(/\n/g) || []).length) > 0 ? (r.push(M('\n', y)), r.push(V(H(a)))) : (r.push(g), r.push(H(a))), h = m, n = 1, i = t.leadingComments.length; n < i; n++)
                                    m = (a = t.leadingComments[n]).range, y = (E.substring(h[1], m[0]).match(/\n/g) || []).length, r.push(M('\n', y)), r.push(V(H(a))), h = m;
                                y = (E.substring(m[1], f[1]).match(/\n/g) || []).length, r.push(M('\n', y));
                            } else
                                for (a = t.leadingComments[0], r = [], S && t.type === e.Program && 0 === t.body.length && r.push('\n'), r.push(H(a)), F($(r).toString()) || r.push('\n'), n = 1, i = t.leadingComments.length; n < i; ++n)
                                    F($(p = [H(a = t.leadingComments[n])]).toString()) || p.push('\n'), r.push(V(p));
                            r.push(V(o));
                        }
                        if (t.trailingComments)
                            if (N)
                                f = (a = t.trailingComments[0]).extendedRange, m = a.range, (y = ((g = E.substring(f[0], m[0])).match(/\n/g) || []).length) > 0 ? (r.push(M('\n', y)), r.push(V(H(a)))) : (r.push(g), r.push(H(a)));
                            else
                                for (l = !F($(r).toString()), d = M(' ', function (e) {
                                        var t;
                                        for (t = e.length - 1; t >= 0 && !s.code.isLineTerminator(e.charCodeAt(t)); --t);
                                        return e.length - 1 - t;
                                    }($([
                                        c,
                                        r,
                                        u
                                    ]).toString())), n = 0, i = t.trailingComments.length; n < i; ++n)
                                    a = t.trailingComments[n], l ? (r = 0 === n ? [
                                        r,
                                        u
                                    ] : [
                                        r,
                                        d
                                    ]).push(H(a, d)) : r = [
                                        r,
                                        V(H(a))
                                    ], n === i - 1 || F($(r).toString()) || (r = [
                                        r,
                                        '\n'
                                    ]);
                        return r;
                    }
                    function K(e, t, r) {
                        var n, i = 0;
                        for (n = e; n < t; n++)
                            '\n' === E[n] && i++;
                        for (n = 1; n < i; n++)
                            r.push(h);
                    }
                    function z(e, t, r) {
                        return t < r ? [
                            '(',
                            e,
                            ')'
                        ] : e;
                    }
                    function X(e) {
                        var t, r, n;
                        for (t = 1, r = (n = e.split(/\r\n|\n/)).length; t < r; t++)
                            n[t] = h + c + n[t];
                        return n;
                    }
                    function Y() {
                    }
                    function q(t) {
                        var r = t.name;
                        return t.type === e.PrivateIdentifier && (r = '#' + r), $(r, t);
                    }
                    function Z(e, t) {
                        return e.async ? 'async' + (t ? j() : g) : '';
                    }
                    function J(e) {
                        return e.generator && !C.moz.starlessGenerator ? '*' + g : '';
                    }
                    function Q(e) {
                        var t = e.value, r = '';
                        return t.async && (r += Z(t, !e.computed)), t.generator && (r += J(t) ? '*' : ''), r;
                    }
                    Y.prototype.maybeBlock = function (t, r) {
                        var n, i, a = this;
                        return i = !C.comment || !t.leadingComments, t.type === e.BlockStatement && i ? [
                            g,
                            this.generateStatement(t, r)
                        ] : t.type === e.EmptyStatement && i ? ';' : (U(function () {
                            n = [
                                h,
                                V(a.generateStatement(t, r))
                            ];
                        }), n);
                    }, Y.prototype.maybeBlockSuffix = function (t, r) {
                        var n = F($(r).toString());
                        return t.type !== e.BlockStatement || C.comment && t.leadingComments || n ? n ? [
                            r,
                            c
                        ] : [
                            r,
                            h,
                            c
                        ] : [
                            r,
                            g
                        ];
                    }, Y.prototype.generatePattern = function (t, r, n) {
                        return t.type === e.Identifier ? q(t) : this.generateExpression(t, r, n);
                    }, Y.prototype.generateFunctionParams = function (t) {
                        var r, i, a, o;
                        if (o = !1, t.type !== e.ArrowFunctionExpression || t.rest || t.defaults && 0 !== t.defaults.length || 1 !== t.params.length || t.params[0].type !== e.Identifier) {
                            for ((a = t.type === e.ArrowFunctionExpression ? [Z(t, !1)] : []).push('('), t.defaults && (o = !0), r = 0, i = t.params.length; r < i; ++r)
                                o && t.defaults[r] ? a.push(this.generateAssignment(t.params[r], t.defaults[r], '=', n.Assignment, 7)) : a.push(this.generatePattern(t.params[r], n.Assignment, 7)), r + 1 < i && a.push(',' + g);
                            t.rest && (t.params.length && a.push(',' + g), a.push('...'), a.push(q(t.rest))), a.push(')');
                        } else
                            a = [
                                Z(t, !0),
                                q(t.params[0])
                            ];
                        return a;
                    }, Y.prototype.generateFunctionBody = function (t) {
                        var r, i;
                        return r = this.generateFunctionParams(t), t.type === e.ArrowFunctionExpression && (r.push(g), r.push('=>')), t.expression ? (r.push(g), '{' === (i = this.generateExpression(t.body, n.Assignment, 7)).toString().charAt(0) && (i = [
                            '(',
                            i,
                            ')'
                        ]), r.push(i)) : r.push(this.maybeBlock(t.body, 9)), r;
                    }, Y.prototype.generateIterationForStatement = function (t, r, i) {
                        var a = ['for' + (r.await ? j() + 'await' : '') + g + '('], o = this;
                        return U(function () {
                            r.left.type === e.VariableDeclaration ? U(function () {
                                a.push(r.left.kind + j()), a.push(o.generateStatement(r.left.declarations[0], 0));
                            }) : a.push(o.generateExpression(r.left, n.Call, 7)), a = G(a, t), a = [
                                G(a, o.generateExpression(r.right, n.Assignment, 7)),
                                ')'
                            ];
                        }), a.push(this.maybeBlock(r.body, i)), a;
                    }, Y.prototype.generatePropertyKey = function (e, t) {
                        var r = [];
                        return t && r.push('['), r.push(this.generateExpression(e, n.Assignment, 7)), t && r.push(']'), r;
                    }, Y.prototype.generateAssignment = function (e, t, r, i, a) {
                        return n.Assignment < i && (a |= 1), z([
                            this.generateExpression(e, n.Call, a),
                            g + r + g,
                            this.generateExpression(t, n.Assignment, a)
                        ], n.Assignment, i);
                    }, Y.prototype.semicolon = function (e) {
                        return !b && e & O ? '' : ';';
                    }, Y.Statement = {
                        BlockStatement: function (e, t) {
                            var r, n, i = [
                                    '{',
                                    h
                                ], a = this;
                            return U(function () {
                                var o, s, c, u;
                                for (0 === e.body.length && N && (r = e.range)[1] - r[0] > 2 && ('\n' === (n = E.substring(r[0] + 1, r[1] - 1))[0] && (i = ['{']), i.push(n)), u = 1, 8 & t && (u |= 16), o = 0, s = e.body.length; o < s; ++o)
                                    N && (0 === o && (e.body[0].leadingComments && (r = e.body[0].leadingComments[0].extendedRange, '\n' === (n = E.substring(r[0], r[1]))[0] && (i = ['{'])), e.body[0].leadingComments || K(e.range[0], e.body[0].range[0], i)), o > 0 && (e.body[o - 1].trailingComments || e.body[o].leadingComments || K(e.body[o - 1].range[1], e.body[o].range[0], i))), o === s - 1 && (u |= O), c = e.body[o].leadingComments && N ? a.generateStatement(e.body[o], u) : V(a.generateStatement(e.body[o], u)), i.push(c), F($(c).toString()) || N && o < s - 1 && e.body[o + 1].leadingComments || i.push(h), N && o === s - 1 && (e.body[o].trailingComments || K(e.body[o].range[1], e.range[1], i));
                            }), i.push(V('}')), i;
                        },
                        BreakStatement: function (e, t) {
                            return e.label ? 'break ' + e.label.name + this.semicolon(t) : 'break' + this.semicolon(t);
                        },
                        ContinueStatement: function (e, t) {
                            return e.label ? 'continue ' + e.label.name + this.semicolon(t) : 'continue' + this.semicolon(t);
                        },
                        ClassBody: function (e, t) {
                            var r = [
                                    '{',
                                    h
                                ], i = this;
                            return U(function (t) {
                                var a, o;
                                for (a = 0, o = e.body.length; a < o; ++a)
                                    r.push(t), r.push(i.generateExpression(e.body[a], n.Sequence, 7)), a + 1 < o && r.push(h);
                            }), F($(r).toString()) || r.push(h), r.push(c), r.push('}'), r;
                        },
                        ClassDeclaration: function (e, t) {
                            var r, i;
                            return r = ['class'], e.id && (r = G(r, this.generateExpression(e.id, n.Sequence, 7))), e.superClass && (i = G('extends', this.generateExpression(e.superClass, n.Unary, 7)), r = G(r, i)), r.push(g), r.push(this.generateStatement(e.body, R)), r;
                        },
                        DirectiveStatement: function (e, t) {
                            return C.raw && e.raw ? e.raw + this.semicolon(t) : function (e) {
                                var t, r, n, i;
                                for (i = 'double' === f ? '"' : '\'', t = 0, r = e.length; t < r; ++t) {
                                    if (39 === (n = e.charCodeAt(t))) {
                                        i = '"';
                                        break;
                                    }
                                    if (34 === n) {
                                        i = '\'';
                                        break;
                                    }
                                    92 === n && ++t;
                                }
                                return i + e + i;
                            }(e.directive) + this.semicolon(t);
                        },
                        DoWhileStatement: function (e, t) {
                            var r = G('do', this.maybeBlock(e.body, 1));
                            return G(r = this.maybeBlockSuffix(e.body, r), [
                                'while' + g + '(',
                                this.generateExpression(e.test, n.Sequence, 7),
                                ')' + this.semicolon(t)
                            ]);
                        },
                        CatchClause: function (e, t) {
                            var r, i = this;
                            return U(function () {
                                var t;
                                e.param ? (r = [
                                    'catch' + g + '(',
                                    i.generateExpression(e.param, n.Sequence, 7),
                                    ')'
                                ], e.guard && (t = i.generateExpression(e.guard, n.Sequence, 7), r.splice(2, 0, ' if ', t))) : r = ['catch'];
                            }), r.push(this.maybeBlock(e.body, 1)), r;
                        },
                        DebuggerStatement: function (e, t) {
                            return 'debugger' + this.semicolon(t);
                        },
                        EmptyStatement: function (e, t) {
                            return ';';
                        },
                        ExportDefaultDeclaration: function (e, t) {
                            var r, i = ['export'];
                            return r = t & O ? R : 1, i = G(i, 'default'), D(e.declaration) ? G(i, this.generateStatement(e.declaration, r)) : G(i, this.generateExpression(e.declaration, n.Assignment, 7) + this.semicolon(t));
                        },
                        ExportNamedDeclaration: function (t, r) {
                            var i, a = ['export'], o = this;
                            return i = r & O ? R : 1, t.declaration ? G(a, this.generateStatement(t.declaration, i)) : (t.specifiers && (0 === t.specifiers.length ? a = G(a, '{' + g + '}') : t.specifiers[0].type === e.ExportBatchSpecifier ? a = G(a, this.generateExpression(t.specifiers[0], n.Sequence, 7)) : (a = G(a, '{'), U(function (e) {
                                var r, i;
                                for (a.push(h), r = 0, i = t.specifiers.length; r < i; ++r)
                                    a.push(e), a.push(o.generateExpression(t.specifiers[r], n.Sequence, 7)), r + 1 < i && a.push(',' + h);
                            }), F($(a).toString()) || a.push(h), a.push(c + '}')), t.source ? a = G(a, [
                                'from' + g,
                                this.generateExpression(t.source, n.Sequence, 7),
                                this.semicolon(r)
                            ]) : a.push(this.semicolon(r))), a);
                        },
                        ExportAllDeclaration: function (e, t) {
                            var r = [
                                'export' + g,
                                '*' + g
                            ];
                            return e.exported && r.push('as ' + e.exported.name + ' '), G(r, [
                                'from' + g,
                                this.generateExpression(e.source, n.Sequence, 7),
                                this.semicolon(t)
                            ]);
                        },
                        ExpressionStatement: function (t, r) {
                            var i, a;
                            return 123 === (a = $(i = [this.generateExpression(t.expression, n.Sequence, 7)]).toString()).charCodeAt(0) || function (e) {
                                var t;
                                return 'class' === e.slice(0, 5) && (123 === (t = e.charCodeAt(5)) || s.code.isWhiteSpace(t) || s.code.isLineTerminator(t));
                            }(a) || function (e) {
                                var t;
                                return 'function' === e.slice(0, 8) && (40 === (t = e.charCodeAt(8)) || s.code.isWhiteSpace(t) || 42 === t || s.code.isLineTerminator(t));
                            }(a) || function (e) {
                                var t, r, n;
                                if ('async' !== e.slice(0, 5))
                                    return !1;
                                if (!s.code.isWhiteSpace(e.charCodeAt(5)))
                                    return !1;
                                for (r = 6, n = e.length; r < n && s.code.isWhiteSpace(e.charCodeAt(r)); ++r);
                                return r !== n && 'function' === e.slice(r, r + 8) && (40 === (t = e.charCodeAt(r + 8)) || s.code.isWhiteSpace(t) || 42 === t || s.code.isLineTerminator(t));
                            }(a) || v && 16 & r && t.expression.type === e.Literal && 'string' == typeof t.expression.value ? i = [
                                '(',
                                i,
                                ')' + this.semicolon(r)
                            ] : i.push(this.semicolon(r)), i;
                        },
                        ImportDeclaration: function (t, r) {
                            var i, a, o = this;
                            return 0 === t.specifiers.length ? [
                                'import',
                                g,
                                this.generateExpression(t.source, n.Sequence, 7),
                                this.semicolon(r)
                            ] : (i = ['import'], a = 0, t.specifiers[a].type === e.ImportDefaultSpecifier && (i = G(i, [this.generateExpression(t.specifiers[a], n.Sequence, 7)]), ++a), t.specifiers[a] && (0 !== a && i.push(','), t.specifiers[a].type === e.ImportNamespaceSpecifier ? i = G(i, [
                                g,
                                this.generateExpression(t.specifiers[a], n.Sequence, 7)
                            ]) : (i.push(g + '{'), t.specifiers.length - a == 1 ? (i.push(g), i.push(this.generateExpression(t.specifiers[a], n.Sequence, 7)), i.push(g + '}' + g)) : (U(function (e) {
                                var r, s;
                                for (i.push(h), r = a, s = t.specifiers.length; r < s; ++r)
                                    i.push(e), i.push(o.generateExpression(t.specifiers[r], n.Sequence, 7)), r + 1 < s && i.push(',' + h);
                            }), F($(i).toString()) || i.push(h), i.push(c + '}' + g)))), i = G(i, [
                                'from' + g,
                                this.generateExpression(t.source, n.Sequence, 7),
                                this.semicolon(r)
                            ]));
                        },
                        VariableDeclarator: function (e, t) {
                            var r = 1 & t ? 7 : 6;
                            return e.init ? [
                                this.generateExpression(e.id, n.Assignment, r),
                                g,
                                '=',
                                g,
                                this.generateExpression(e.init, n.Assignment, r)
                            ] : this.generatePattern(e.id, n.Assignment, r);
                        },
                        VariableDeclaration: function (e, t) {
                            var r, n, i, a, o, s = this;
                            function c() {
                                for (a = e.declarations[0], C.comment && a.leadingComments ? (r.push('\n'), r.push(V(s.generateStatement(a, o)))) : (r.push(j()), r.push(s.generateStatement(a, o))), n = 1, i = e.declarations.length; n < i; ++n)
                                    a = e.declarations[n], C.comment && a.leadingComments ? (r.push(',' + h), r.push(V(s.generateStatement(a, o)))) : (r.push(',' + g), r.push(s.generateStatement(a, o)));
                            }
                            return r = [e.kind], o = 1 & t ? 1 : 0, e.declarations.length > 1 ? U(c) : c(), r.push(this.semicolon(t)), r;
                        },
                        StaticBlock: function (e, t) {
                            return [
                                'static' + g,
                                this.BlockStatement(e, t)
                            ];
                        },
                        ThrowStatement: function (e, t) {
                            return [
                                G('throw', this.generateExpression(e.argument, n.Sequence, 7)),
                                this.semicolon(t)
                            ];
                        },
                        TryStatement: function (e, t) {
                            var r, n, i, a;
                            if (r = [
                                    'try',
                                    this.maybeBlock(e.block, 1)
                                ], r = this.maybeBlockSuffix(e.block, r), e.handlers)
                                for (n = 0, i = e.handlers.length; n < i; ++n)
                                    r = G(r, this.generateStatement(e.handlers[n], 1)), (e.finalizer || n + 1 !== i) && (r = this.maybeBlockSuffix(e.handlers[n].body, r));
                            else {
                                for (n = 0, i = (a = e.guardedHandlers || []).length; n < i; ++n)
                                    r = G(r, this.generateStatement(a[n], 1)), (e.finalizer || n + 1 !== i) && (r = this.maybeBlockSuffix(a[n].body, r));
                                if (e.handler)
                                    if (Array.isArray(e.handler))
                                        for (n = 0, i = e.handler.length; n < i; ++n)
                                            r = G(r, this.generateStatement(e.handler[n], 1)), (e.finalizer || n + 1 !== i) && (r = this.maybeBlockSuffix(e.handler[n].body, r));
                                    else
                                        r = G(r, this.generateStatement(e.handler, 1)), e.finalizer && (r = this.maybeBlockSuffix(e.handler.body, r));
                            }
                            return e.finalizer && (r = G(r, [
                                'finally',
                                this.maybeBlock(e.finalizer, 1)
                            ])), r;
                        },
                        SwitchStatement: function (e, t) {
                            var r, i, a, o, s, c = this;
                            if (U(function () {
                                    r = [
                                        'switch' + g + '(',
                                        c.generateExpression(e.discriminant, n.Sequence, 7),
                                        ')' + g + '{' + h
                                    ];
                                }), e.cases)
                                for (s = 1, a = 0, o = e.cases.length; a < o; ++a)
                                    a === o - 1 && (s |= O), i = V(this.generateStatement(e.cases[a], s)), r.push(i), F($(i).toString()) || r.push(h);
                            return r.push(V('}')), r;
                        },
                        SwitchCase: function (t, r) {
                            var i, a, o, s, c, u = this;
                            return U(function () {
                                for (i = t.test ? [
                                        G('case', u.generateExpression(t.test, n.Sequence, 7)),
                                        ':'
                                    ] : ['default:'], o = 0, (s = t.consequent.length) && t.consequent[0].type === e.BlockStatement && (a = u.maybeBlock(t.consequent[0], 1), i.push(a), o = 1), o === s || F($(i).toString()) || i.push(h), c = 1; o < s; ++o)
                                    o === s - 1 && r & O && (c |= O), a = V(u.generateStatement(t.consequent[o], c)), i.push(a), o + 1 === s || F($(a).toString()) || i.push(h);
                            }), i;
                        },
                        IfStatement: function (t, r) {
                            var i, a, o = this;
                            return U(function () {
                                i = [
                                    'if' + g + '(',
                                    o.generateExpression(t.test, n.Sequence, 7),
                                    ')'
                                ];
                            }), a = 1, r & O && (a |= O), t.alternate ? (i.push(this.maybeBlock(t.consequent, 1)), i = this.maybeBlockSuffix(t.consequent, i), i = t.alternate.type === e.IfStatement ? G(i, [
                                'else ',
                                this.generateStatement(t.alternate, a)
                            ]) : G(i, G('else', this.maybeBlock(t.alternate, a)))) : i.push(this.maybeBlock(t.consequent, a)), i;
                        },
                        ForStatement: function (t, r) {
                            var i, a = this;
                            return U(function () {
                                i = ['for' + g + '('], t.init ? t.init.type === e.VariableDeclaration ? i.push(a.generateStatement(t.init, 0)) : (i.push(a.generateExpression(t.init, n.Sequence, 6)), i.push(';')) : i.push(';'), t.test ? (i.push(g), i.push(a.generateExpression(t.test, n.Sequence, 7)), i.push(';')) : i.push(';'), t.update ? (i.push(g), i.push(a.generateExpression(t.update, n.Sequence, 7)), i.push(')')) : i.push(')');
                            }), i.push(this.maybeBlock(t.body, r & O ? R : 1)), i;
                        },
                        ForInStatement: function (e, t) {
                            return this.generateIterationForStatement('in', e, t & O ? R : 1);
                        },
                        ForOfStatement: function (e, t) {
                            return this.generateIterationForStatement('of', e, t & O ? R : 1);
                        },
                        LabeledStatement: function (e, t) {
                            return [
                                e.label.name + ':',
                                this.maybeBlock(e.body, t & O ? R : 1)
                            ];
                        },
                        Program: function (e, t) {
                            var r, n, i, a, o;
                            for (a = e.body.length, r = [S && a > 0 ? '\n' : ''], o = 17, i = 0; i < a; ++i)
                                S || i !== a - 1 || (o |= O), N && (0 === i && (e.body[0].leadingComments || K(e.range[0], e.body[i].range[0], r)), i > 0 && (e.body[i - 1].trailingComments || e.body[i].leadingComments || K(e.body[i - 1].range[1], e.body[i].range[0], r))), n = V(this.generateStatement(e.body[i], o)), r.push(n), i + 1 < a && !F($(n).toString()) && (N && e.body[i + 1].leadingComments || r.push(h)), N && i === a - 1 && (e.body[i].trailingComments || K(e.body[i].range[1], e.range[1], r));
                            return r;
                        },
                        FunctionDeclaration: function (e, t) {
                            return [
                                Z(e, !0),
                                'function',
                                J(e) || j(),
                                e.id ? q(e.id) : '',
                                this.generateFunctionBody(e)
                            ];
                        },
                        ReturnStatement: function (e, t) {
                            return e.argument ? [
                                G('return', this.generateExpression(e.argument, n.Sequence, 7)),
                                this.semicolon(t)
                            ] : ['return' + this.semicolon(t)];
                        },
                        WhileStatement: function (e, t) {
                            var r, i = this;
                            return U(function () {
                                r = [
                                    'while' + g + '(',
                                    i.generateExpression(e.test, n.Sequence, 7),
                                    ')'
                                ];
                            }), r.push(this.maybeBlock(e.body, t & O ? R : 1)), r;
                        },
                        WithStatement: function (e, t) {
                            var r, i = this;
                            return U(function () {
                                r = [
                                    'with' + g + '(',
                                    i.generateExpression(e.object, n.Sequence, 7),
                                    ')'
                                ];
                            }), r.push(this.maybeBlock(e.body, t & O ? R : 1)), r;
                        }
                    }, P(Y.prototype, Y.Statement), Y.Expression = {
                        SequenceExpression: function (e, t, r) {
                            var i, a, o;
                            for (n.Sequence < t && (r |= 1), i = [], a = 0, o = e.expressions.length; a < o; ++a)
                                i.push(this.generateExpression(e.expressions[a], n.Assignment, r)), a + 1 < o && i.push(',' + g);
                            return z(i, n.Sequence, t);
                        },
                        AssignmentExpression: function (e, t, r) {
                            return this.generateAssignment(e.left, e.right, e.operator, t, r);
                        },
                        ArrowFunctionExpression: function (e, t, r) {
                            return z(this.generateFunctionBody(e), n.ArrowFunction, t);
                        },
                        ConditionalExpression: function (e, t, r) {
                            return n.Conditional < t && (r |= 1), z([
                                this.generateExpression(e.test, n.LogicalOR, r),
                                g + '?' + g,
                                this.generateExpression(e.consequent, n.Assignment, r),
                                g + ':' + g,
                                this.generateExpression(e.alternate, n.Assignment, r)
                            ], n.Conditional, t);
                        },
                        LogicalExpression: function (e, t, r) {
                            return this.BinaryExpression(e, t, r);
                        },
                        BinaryExpression: function (t, r, a) {
                            var o, c, u, l, d, p;
                            switch (c = l = i[t.operator], u = l + 1, t.operator) {
                            case '**':
                                c = n.Postfix, u = l;
                                break;
                            case '??':
                                t.left.type !== e.LogicalExpression || '||' !== t.left.operator && '&&' !== t.left.operator || (c = i[t.left.operator] + 1), t.right.type === e.LogicalExpression && '&&' === t.right.operator && (u = i[t.right.operator] + 1);
                                break;
                            case '||':
                                t.left.type === e.LogicalExpression && '??' === t.left.operator && (c = i[t.left.operator] + 1);
                            }
                            return l < r && (a |= 1), o = 47 === (p = (d = this.generateExpression(t.left, c, a)).toString()).charCodeAt(p.length - 1) && s.code.isIdentifierPartES5(t.operator.charCodeAt(0)) ? [
                                d,
                                j(),
                                t.operator
                            ] : G(d, t.operator), d = this.generateExpression(t.right, u, a), '/' === t.operator && '/' === d.toString().charAt(0) || '<' === t.operator.slice(-1) && '!--' === d.toString().slice(0, 3) ? (o.push(j()), o.push(d)) : o = G(o, d), 'in' !== t.operator || 1 & a ? z(o, l, r) : [
                                '(',
                                o,
                                ')'
                            ];
                        },
                        CallExpression: function (e, t, r) {
                            var i, a, o;
                            for (i = [this.generateExpression(e.callee, n.Call, 3)], e.optional && i.push('?.'), i.push('('), a = 0, o = e.arguments.length; a < o; ++a)
                                i.push(this.generateExpression(e.arguments[a], n.Assignment, 7)), a + 1 < o && i.push(',' + g);
                            return i.push(')'), 2 & r ? null === e.callee.id && 0 === e.callee.params.length ? z(i, t, n.Call) : z(i, n.Call, t) : [
                                '(',
                                i,
                                ')'
                            ];
                        },
                        ChainExpression: function (e, t, r) {
                            return n.OptionalChaining < t && (r |= 2), z(this.generateExpression(e.expression, n.OptionalChaining, r), n.OptionalChaining, t);
                        },
                        NewExpression: function (e, t, r) {
                            var i, a, o, s, c;
                            if (a = e.arguments.length, c = 4 & r && !y && 0 === a ? 5 : 1, i = G('new', this.generateExpression(e.callee, n.New, c)), !(4 & r) || y || a > 0) {
                                for (i.push('('), o = 0, s = a; o < s; ++o)
                                    i.push(this.generateExpression(e.arguments[o], n.Assignment, 7)), o + 1 < s && i.push(',' + g);
                                i.push(')');
                            }
                            return z(i, n.New, t);
                        },
                        MemberExpression: function (t, r, i) {
                            var a, o;
                            return a = [this.generateExpression(t.object, n.Call, 2 & i ? 3 : 1)], t.computed ? (t.optional && a.push('?.'), a.push('['), a.push(this.generateExpression(t.property, n.Sequence, 2 & i ? 7 : 5)), a.push(']')) : (t.optional || t.object.type !== e.Literal || 'number' != typeof t.object.value || (o = $(a).toString()).indexOf('.') < 0 && !/[eExX]/.test(o) && s.code.isDecimalDigit(o.charCodeAt(o.length - 1)) && !(o.length >= 2 && 48 === o.charCodeAt(0)) && a.push(' '), a.push(t.optional ? '?.' : '.'), a.push(q(t.property))), z(a, n.Member, r);
                        },
                        MetaProperty: function (e, t, r) {
                            var i;
                            return (i = []).push('string' == typeof e.meta ? e.meta : q(e.meta)), i.push('.'), i.push('string' == typeof e.property ? e.property : q(e.property)), z(i, n.Member, t);
                        },
                        UnaryExpression: function (e, t, r) {
                            var i, a, o, c, u;
                            return a = this.generateExpression(e.argument, n.Unary, 7), '' === g ? i = G(e.operator, a) : (i = [e.operator], e.operator.length > 2 ? i = G(i, a) : (u = (c = $(i).toString()).charCodeAt(c.length - 1), o = a.toString().charCodeAt(0), (43 === u || 45 === u) && u === o || s.code.isIdentifierPartES5(u) && s.code.isIdentifierPartES5(o) ? (i.push(j()), i.push(a)) : i.push(a))), z(i, n.Unary, t);
                        },
                        YieldExpression: function (e, t, r) {
                            var i;
                            return i = e.delegate ? 'yield*' : 'yield', e.argument && (i = G(i, this.generateExpression(e.argument, n.Yield, 7))), z(i, n.Yield, t);
                        },
                        AwaitExpression: function (e, t, r) {
                            return z(G(e.all ? 'await*' : 'await', this.generateExpression(e.argument, n.Await, 7)), n.Await, t);
                        },
                        UpdateExpression: function (e, t, r) {
                            return e.prefix ? z([
                                e.operator,
                                this.generateExpression(e.argument, n.Unary, 7)
                            ], n.Unary, t) : z([
                                this.generateExpression(e.argument, n.Postfix, 7),
                                e.operator
                            ], n.Postfix, t);
                        },
                        FunctionExpression: function (e, t, r) {
                            var n = [
                                Z(e, !0),
                                'function'
                            ];
                            return e.id ? (n.push(J(e) || j()), n.push(q(e.id))) : n.push(J(e) || g), n.push(this.generateFunctionBody(e)), n;
                        },
                        ArrayPattern: function (e, t, r) {
                            return this.ArrayExpression(e, t, r, !0);
                        },
                        ArrayExpression: function (e, t, r, i) {
                            var a, o, s = this;
                            return e.elements.length ? (o = !i && e.elements.length > 1, a = [
                                '[',
                                o ? h : ''
                            ], U(function (t) {
                                var r, i;
                                for (r = 0, i = e.elements.length; r < i; ++r)
                                    e.elements[r] ? (a.push(o ? t : ''), a.push(s.generateExpression(e.elements[r], n.Assignment, 7))) : (o && a.push(t), r + 1 === i && a.push(',')), r + 1 < i && a.push(',' + (o ? h : g));
                            }), o && !F($(a).toString()) && a.push(h), a.push(o ? c : ''), a.push(']'), a) : '[]';
                        },
                        RestElement: function (e, t, r) {
                            return '...' + this.generatePattern(e.argument);
                        },
                        ClassExpression: function (e, t, r) {
                            var i, a;
                            return i = ['class'], e.id && (i = G(i, this.generateExpression(e.id, n.Sequence, 7))), e.superClass && (a = G('extends', this.generateExpression(e.superClass, n.Unary, 7)), i = G(i, a)), i.push(g), i.push(this.generateStatement(e.body, R)), i;
                        },
                        MethodDefinition: function (e, t, r) {
                            var n, i;
                            return n = e.static ? ['static' + g] : [], i = 'get' === e.kind || 'set' === e.kind ? [
                                G(e.kind, this.generatePropertyKey(e.key, e.computed)),
                                this.generateFunctionBody(e.value)
                            ] : [
                                Q(e),
                                this.generatePropertyKey(e.key, e.computed),
                                this.generateFunctionBody(e.value)
                            ], G(n, i);
                        },
                        PrivateIdentifier: function (e, t, r) {
                            return q(e);
                        },
                        Property: function (e, t, r) {
                            return 'get' === e.kind || 'set' === e.kind ? [
                                e.kind,
                                j(),
                                this.generatePropertyKey(e.key, e.computed),
                                this.generateFunctionBody(e.value)
                            ] : e.shorthand ? 'AssignmentPattern' === e.value.type ? this.AssignmentPattern(e.value, n.Sequence, 7) : this.generatePropertyKey(e.key, e.computed) : e.method ? [
                                Q(e),
                                this.generatePropertyKey(e.key, e.computed),
                                this.generateFunctionBody(e.value)
                            ] : [
                                this.generatePropertyKey(e.key, e.computed),
                                ':' + g,
                                this.generateExpression(e.value, n.Assignment, 7)
                            ];
                        },
                        PropertyDefinition: function (e, t, r) {
                            var i;
                            return (i = e.static ? ['static '] : []).push(this.generatePropertyKey(e.key, e.computed)), e.value && (i.push(g + '=' + g), i.push(this.generateExpression(e.value, n.Assignment, 7))), i.push(this.semicolon(r)), i;
                        },
                        ObjectExpression: function (e, t, r) {
                            var i, a, o, s, u = this;
                            return e.properties.length ? (i = e.properties.length > 1, U(function () {
                                o = u.generateExpression(e.properties[0], n.Sequence, 7);
                            }), i || (s = $(o).toString(), /[\r\n]/g.test(s)) ? (U(function (t) {
                                var r, s;
                                if (a = [
                                        '{',
                                        h,
                                        t,
                                        o
                                    ], i)
                                    for (a.push(',' + h), r = 1, s = e.properties.length; r < s; ++r)
                                        a.push(t), a.push(u.generateExpression(e.properties[r], n.Sequence, 7)), r + 1 < s && a.push(',' + h);
                            }), F($(a).toString()) || a.push(h), a.push(c), a.push('}'), a) : [
                                '{',
                                g,
                                o,
                                g,
                                '}'
                            ]) : '{}';
                        },
                        AssignmentPattern: function (e, t, r) {
                            return this.generateAssignment(e.left, e.right, '=', t, r);
                        },
                        ObjectPattern: function (t, r, i) {
                            var a, o, s, u, l, d = this;
                            if (!t.properties.length)
                                return '{}';
                            if (u = !1, 1 === t.properties.length)
                                (l = t.properties[0]).type === e.Property && l.value.type !== e.Identifier && (u = !0);
                            else
                                for (o = 0, s = t.properties.length; o < s; ++o)
                                    if ((l = t.properties[o]).type === e.Property && !l.shorthand) {
                                        u = !0;
                                        break;
                                    }
                            return a = [
                                '{',
                                u ? h : ''
                            ], U(function (e) {
                                var r, i;
                                for (r = 0, i = t.properties.length; r < i; ++r)
                                    a.push(u ? e : ''), a.push(d.generateExpression(t.properties[r], n.Sequence, 7)), r + 1 < i && a.push(',' + (u ? h : g));
                            }), u && !F($(a).toString()) && a.push(h), a.push(u ? c : ''), a.push('}'), a;
                        },
                        ThisExpression: function (e, t, r) {
                            return 'this';
                        },
                        Super: function (e, t, r) {
                            return 'super';
                        },
                        Identifier: function (e, t, r) {
                            return q(e);
                        },
                        ImportDefaultSpecifier: function (e, t, r) {
                            return q(e.id || e.local);
                        },
                        ImportNamespaceSpecifier: function (e, t, r) {
                            var n = ['*'], i = e.id || e.local;
                            return i && n.push(g + 'as' + j() + q(i)), n;
                        },
                        ImportSpecifier: function (e, t, r) {
                            var n = e.imported, i = [n.name], a = e.local;
                            return a && a.name !== n.name && i.push(j() + 'as' + j() + q(a)), i;
                        },
                        ExportSpecifier: function (e, t, r) {
                            var n = e.local, i = [n.name], a = e.exported;
                            return a && a.name !== n.name && i.push(j() + 'as' + j() + q(a)), i;
                        },
                        Literal: function (t, r, n) {
                            var i;
                            if (t.hasOwnProperty('raw') && A && C.raw)
                                try {
                                    if ((i = A(t.raw).body[0].expression).type === e.Literal && i.value === t.value)
                                        return t.raw;
                                } catch (e) {
                                }
                            return t.regex ? '/' + t.regex.pattern + '/' + t.regex.flags : 'string' == typeof t.bigint && t.raw ? t.raw : null === t.value ? 'null' : 'string' == typeof t.value ? function (e) {
                                var t, r, n, i, a, o = '', c = 0, u = 0;
                                for (t = 0, r = e.length; t < r; ++t) {
                                    if (39 === (n = e.charCodeAt(t)))
                                        ++c;
                                    else if (34 === n)
                                        ++u;
                                    else if (47 === n && l)
                                        o += '\\';
                                    else {
                                        if (s.code.isLineTerminator(n) || 92 === n) {
                                            o += k(n);
                                            continue;
                                        }
                                        if (!s.code.isIdentifierPartES5(n) && (l && n < 32 || !l && !m && (n < 32 || n > 126))) {
                                            o += B(n, e.charCodeAt(t + 1));
                                            continue;
                                        }
                                    }
                                    o += String.fromCharCode(n);
                                }
                                if (a = (i = !('double' === f || 'auto' === f && u < c)) ? '\'' : '"', !(i ? c : u))
                                    return a + o + a;
                                for (e = o, o = a, t = 0, r = e.length; t < r; ++t)
                                    (39 === (n = e.charCodeAt(t)) && i || 34 === n && !i) && (o += '\\'), o += String.fromCharCode(n);
                                return o + a;
                            }(t.value) : 'number' == typeof t.value ? t.raw && -1 !== t.raw.indexOf('_') ? t.raw : function (e) {
                                var t, r, n, i, a;
                                if (e != e)
                                    throw new Error('Numeric literal whose value is NaN');
                                if (e < 0 || 0 === e && 1 / e < 0)
                                    throw new Error('Numeric literal whose value is negative');
                                if (e === 1 / 0)
                                    return l ? 'null' : d ? '1e400' : '1e+400';
                                if (t = '' + e, !d || t.length < 3)
                                    return t;
                                for (r = t.indexOf('.'), l || 48 !== t.charCodeAt(0) || 1 !== r || (r = 0, t = t.slice(1)), n = t, t = t.replace('e+', 'e'), i = 0, (a = n.indexOf('e')) > 0 && (i = +n.slice(a + 1), n = n.slice(0, a)), r >= 0 && (i -= n.length - r - 1, n = +(n.slice(0, r) + n.slice(r + 1)) + ''), a = 0; 48 === n.charCodeAt(n.length + a - 1);)
                                    --a;
                                return 0 !== a && (i -= a, n = n.slice(0, a)), 0 !== i && (n += 'e' + i), (n.length < t.length || p && e > 1000000000000 && Math.floor(e) === e && (n = '0x' + e.toString(16)).length < t.length) && +n === e && (t = n), t;
                            }(t.value) : 'boolean' == typeof t.value ? t.value ? 'true' : 'false' : function (e) {
                                var t, r, n, i, a, o, s, c;
                                if (r = e.toString(), e.source) {
                                    if (!(t = r.match(/\/([^/]*)$/)))
                                        return r;
                                    for (n = t[1], r = '', s = !1, c = !1, i = 0, a = e.source.length; i < a; ++i)
                                        o = e.source.charCodeAt(i), c ? (r += w(o, c), c = !1) : (s ? 93 === o && (s = !1) : 47 === o ? r += '\\' : 91 === o && (s = !0), r += w(o, c), c = 92 === o);
                                    return '/' + r + '/' + n;
                                }
                                return r;
                            }(t.value);
                        },
                        GeneratorExpression: function (e, t, r) {
                            return this.ComprehensionExpression(e, t, r);
                        },
                        ComprehensionExpression: function (t, r, i) {
                            var a, o, s, c, u = this;
                            return a = t.type === e.GeneratorExpression ? ['('] : ['['], C.moz.comprehensionExpressionStartsWithAssignment && (c = this.generateExpression(t.body, n.Assignment, 7), a.push(c)), t.blocks && U(function () {
                                for (o = 0, s = t.blocks.length; o < s; ++o)
                                    c = u.generateExpression(t.blocks[o], n.Sequence, 7), o > 0 || C.moz.comprehensionExpressionStartsWithAssignment ? a = G(a, c) : a.push(c);
                            }), t.filter && (a = G(a, 'if' + g), c = this.generateExpression(t.filter, n.Sequence, 7), a = G(a, [
                                '(',
                                c,
                                ')'
                            ])), C.moz.comprehensionExpressionStartsWithAssignment || (c = this.generateExpression(t.body, n.Assignment, 7), a = G(a, c)), a.push(t.type === e.GeneratorExpression ? ')' : ']'), a;
                        },
                        ComprehensionBlock: function (t, r, i) {
                            var a;
                            return a = G(a = t.left.type === e.VariableDeclaration ? [
                                t.left.kind,
                                j(),
                                this.generateStatement(t.left.declarations[0], 0)
                            ] : this.generateExpression(t.left, n.Call, 7), t.of ? 'of' : 'in'), a = G(a, this.generateExpression(t.right, n.Sequence, 7)), [
                                'for' + g + '(',
                                a,
                                ')'
                            ];
                        },
                        SpreadElement: function (e, t, r) {
                            return [
                                '...',
                                this.generateExpression(e.argument, n.Assignment, 7)
                            ];
                        },
                        TaggedTemplateExpression: function (e, t, r) {
                            var i = 3;
                            return 2 & r || (i = 1), z([
                                this.generateExpression(e.tag, n.Call, i),
                                this.generateExpression(e.quasi, n.Primary, 4)
                            ], n.TaggedTemplate, t);
                        },
                        TemplateElement: function (e, t, r) {
                            return e.value.raw;
                        },
                        TemplateLiteral: function (e, t, r) {
                            var i, a, o;
                            for (i = ['`'], a = 0, o = e.quasis.length; a < o; ++a)
                                i.push(this.generateExpression(e.quasis[a], n.Primary, 7)), a + 1 < o && (i.push('${' + g), i.push(this.generateExpression(e.expressions[a], n.Sequence, 7)), i.push(g + '}'));
                            return i.push('`'), i;
                        },
                        ModuleSpecifier: function (e, t, r) {
                            return this.Literal(e, t, r);
                        },
                        ImportExpression: function (e, t, r) {
                            return z([
                                'import(',
                                this.generateExpression(e.source, n.Assignment, 7),
                                ')'
                            ], n.Call, t);
                        }
                    }, P(Y.prototype, Y.Expression), Y.prototype.generateExpression = function (t, r, i) {
                        var a, o;
                        return o = t.type || e.Property, C.verbatim && t.hasOwnProperty(C.verbatim) ? function (e, t) {
                            var r;
                            return $('string' == typeof (r = e[C.verbatim]) ? z(X(r), n.Sequence, t) : z(X(r.content), null != r.precedence ? r.precedence : n.Sequence, t), e);
                        }(t, r) : (a = this[o](t, r, i), C.comment && (a = W(t, a)), $(a, t));
                    }, Y.prototype.generateStatement = function (t, r) {
                        var n, i;
                        return n = this[t.type](t, r), C.comment && (n = W(t, n)), i = $(n).toString(), t.type !== e.Program || S || '' !== h || '\n' !== i.charAt(i.length - 1) || (n = _ ? $(n).replaceRight(/\s+$/, '') : i.replace(/\s+$/, '')), $(n, t);
                    }, I = {
                        indent: {
                            style: '',
                            base: 0
                        },
                        renumber: !0,
                        hexadecimal: !0,
                        quotes: 'auto',
                        escapeless: !0,
                        compact: !0,
                        parentheses: !1,
                        semicolons: !1
                    }, T = {
                        indent: {
                            style: '    ',
                            base: 0,
                            adjustMultilineComment: !1
                        },
                        newline: '\n',
                        space: ' ',
                        json: !1,
                        renumber: !1,
                        hexadecimal: !1,
                        quotes: 'single',
                        escapeless: !1,
                        compact: !1,
                        parentheses: !0,
                        semicolons: !0,
                        safeConcatenation: !1,
                        preserveBlankLines: !1
                    }, t.version = r(6638).version, t.generate = function (e, i) {
                        var o, s, I = {
                                indent: null,
                                base: null,
                                parse: null,
                                comment: !1,
                                format: {
                                    indent: {
                                        style: '    ',
                                        base: 0,
                                        adjustMultilineComment: !1
                                    },
                                    newline: '\n',
                                    space: ' ',
                                    json: !1,
                                    renumber: !1,
                                    hexadecimal: !1,
                                    quotes: 'single',
                                    escapeless: !1,
                                    compact: !1,
                                    parentheses: !0,
                                    semicolons: !0,
                                    safeConcatenation: !1,
                                    preserveBlankLines: !1
                                },
                                moz: {
                                    comprehensionExpressionStartsWithAssignment: !1,
                                    starlessGenerator: !1
                                },
                                sourceMap: null,
                                sourceMapRoot: null,
                                sourceMapWithCode: !1,
                                directive: !1,
                                raw: !0,
                                verbatim: null,
                                sourceCode: null
                            };
                        return null != i ? ('string' == typeof i.indent && (I.format.indent.style = i.indent), 'number' == typeof i.base && (I.format.indent.base = i.base), i = x(I, i), u = i.format.indent.style, c = 'string' == typeof i.base ? i.base : M(u, i.format.indent.base)) : (u = (i = I).format.indent.style, c = M(u, i.format.indent.base)), l = i.format.json, d = i.format.renumber, p = !l && i.format.hexadecimal, f = l ? 'double' : i.format.quotes, m = i.format.escapeless, h = i.format.newline, g = i.format.space, i.format.compact && (h = g = u = c = ''), y = i.format.parentheses, b = i.format.semicolons, S = i.format.safeConcatenation, v = i.directive, A = l ? null : i.parse, _ = i.sourceMap, E = i.sourceCode, N = i.format.preserveBlankLines && null !== E, C = i, _ && (a = t.browser ? r.g.sourceMap.SourceNode : r(9125).SourceNode), o = function (e) {
                            var t;
                            if (t = new Y(), D(e))
                                return t.generateStatement(e, 1);
                            if (function (e) {
                                    return Y.Expression.hasOwnProperty(e.type);
                                }(e))
                                return t.generateExpression(e, n.Sequence, 7);
                            throw new Error('Unknown node type: ' + e.type);
                        }(e), _ ? (s = o.toStringWithSourceMap({
                            file: i.file,
                            sourceRoot: i.sourceMapRoot
                        }), i.sourceContent && s.map.setSourceContent(i.sourceMap, i.sourceContent), i.sourceMapWithCode ? s : s.map.toString()) : (s = {
                            code: o.toString(),
                            map: null
                        }, i.sourceMapWithCode ? s : s.code);
                    }, t.attachComments = o.attachComments, t.Precedence = x({}, n), t.browser = !1, t.FORMAT_MINIFY = I, t.FORMAT_DEFAULTS = T;
                }();
            },
            140: (e, t) => {
                !function e(t) {
                    'use strict';
                    var r, n, i, a, o, s;
                    function c(e) {
                        var t, r, n = {};
                        for (t in e)
                            e.hasOwnProperty(t) && (r = e[t], n[t] = 'object' == typeof r && null !== r ? c(r) : r);
                        return n;
                    }
                    function u(e, t) {
                        this.parent = e, this.key = t;
                    }
                    function l(e, t, r, n) {
                        this.node = e, this.path = t, this.wrap = r, this.ref = n;
                    }
                    function d() {
                    }
                    function p(e) {
                        return null != e && 'object' == typeof e && 'string' == typeof e.type;
                    }
                    function f(e, t) {
                        return (e === r.ObjectExpression || e === r.ObjectPattern) && 'properties' === t;
                    }
                    function m(e, t) {
                        for (var r = e.length - 1; r >= 0; --r)
                            if (e[r].node === t)
                                return !0;
                        return !1;
                    }
                    function h(e, t) {
                        return new d().traverse(e, t);
                    }
                    function g(e, t) {
                        var r;
                        return r = function (t, r) {
                            var n, i, a, o;
                            for (i = t.length, a = 0; i;)
                                t[o = a + (n = i >>> 1)].range[0] > e.range[0] ? i = n : (a = o + 1, i -= n + 1);
                            return a;
                        }(t), e.extendedRange = [
                            e.range[0],
                            e.range[1]
                        ], r !== t.length && (e.extendedRange[1] = t[r].range[0]), (r -= 1) >= 0 && (e.extendedRange[0] = t[r].range[1]), e;
                    }
                    return r = {
                        AssignmentExpression: 'AssignmentExpression',
                        AssignmentPattern: 'AssignmentPattern',
                        ArrayExpression: 'ArrayExpression',
                        ArrayPattern: 'ArrayPattern',
                        ArrowFunctionExpression: 'ArrowFunctionExpression',
                        AwaitExpression: 'AwaitExpression',
                        BlockStatement: 'BlockStatement',
                        BinaryExpression: 'BinaryExpression',
                        BreakStatement: 'BreakStatement',
                        CallExpression: 'CallExpression',
                        CatchClause: 'CatchClause',
                        ChainExpression: 'ChainExpression',
                        ClassBody: 'ClassBody',
                        ClassDeclaration: 'ClassDeclaration',
                        ClassExpression: 'ClassExpression',
                        ComprehensionBlock: 'ComprehensionBlock',
                        ComprehensionExpression: 'ComprehensionExpression',
                        ConditionalExpression: 'ConditionalExpression',
                        ContinueStatement: 'ContinueStatement',
                        DebuggerStatement: 'DebuggerStatement',
                        DirectiveStatement: 'DirectiveStatement',
                        DoWhileStatement: 'DoWhileStatement',
                        EmptyStatement: 'EmptyStatement',
                        ExportAllDeclaration: 'ExportAllDeclaration',
                        ExportDefaultDeclaration: 'ExportDefaultDeclaration',
                        ExportNamedDeclaration: 'ExportNamedDeclaration',
                        ExportSpecifier: 'ExportSpecifier',
                        ExpressionStatement: 'ExpressionStatement',
                        ForStatement: 'ForStatement',
                        ForInStatement: 'ForInStatement',
                        ForOfStatement: 'ForOfStatement',
                        FunctionDeclaration: 'FunctionDeclaration',
                        FunctionExpression: 'FunctionExpression',
                        GeneratorExpression: 'GeneratorExpression',
                        Identifier: 'Identifier',
                        IfStatement: 'IfStatement',
                        ImportExpression: 'ImportExpression',
                        ImportDeclaration: 'ImportDeclaration',
                        ImportDefaultSpecifier: 'ImportDefaultSpecifier',
                        ImportNamespaceSpecifier: 'ImportNamespaceSpecifier',
                        ImportSpecifier: 'ImportSpecifier',
                        Literal: 'Literal',
                        LabeledStatement: 'LabeledStatement',
                        LogicalExpression: 'LogicalExpression',
                        MemberExpression: 'MemberExpression',
                        MetaProperty: 'MetaProperty',
                        MethodDefinition: 'MethodDefinition',
                        ModuleSpecifier: 'ModuleSpecifier',
                        NewExpression: 'NewExpression',
                        ObjectExpression: 'ObjectExpression',
                        ObjectPattern: 'ObjectPattern',
                        PrivateIdentifier: 'PrivateIdentifier',
                        Program: 'Program',
                        Property: 'Property',
                        PropertyDefinition: 'PropertyDefinition',
                        RestElement: 'RestElement',
                        ReturnStatement: 'ReturnStatement',
                        SequenceExpression: 'SequenceExpression',
                        SpreadElement: 'SpreadElement',
                        StaticBlock: 'StaticBlock',
                        Super: 'Super',
                        SwitchStatement: 'SwitchStatement',
                        SwitchCase: 'SwitchCase',
                        TaggedTemplateExpression: 'TaggedTemplateExpression',
                        TemplateElement: 'TemplateElement',
                        TemplateLiteral: 'TemplateLiteral',
                        ThisExpression: 'ThisExpression',
                        ThrowStatement: 'ThrowStatement',
                        TryStatement: 'TryStatement',
                        UnaryExpression: 'UnaryExpression',
                        UpdateExpression: 'UpdateExpression',
                        VariableDeclaration: 'VariableDeclaration',
                        VariableDeclarator: 'VariableDeclarator',
                        WhileStatement: 'WhileStatement',
                        WithStatement: 'WithStatement',
                        YieldExpression: 'YieldExpression'
                    }, i = {
                        AssignmentExpression: [
                            'left',
                            'right'
                        ],
                        AssignmentPattern: [
                            'left',
                            'right'
                        ],
                        ArrayExpression: ['elements'],
                        ArrayPattern: ['elements'],
                        ArrowFunctionExpression: [
                            'params',
                            'body'
                        ],
                        AwaitExpression: ['argument'],
                        BlockStatement: ['body'],
                        BinaryExpression: [
                            'left',
                            'right'
                        ],
                        BreakStatement: ['label'],
                        CallExpression: [
                            'callee',
                            'arguments'
                        ],
                        CatchClause: [
                            'param',
                            'body'
                        ],
                        ChainExpression: ['expression'],
                        ClassBody: ['body'],
                        ClassDeclaration: [
                            'id',
                            'superClass',
                            'body'
                        ],
                        ClassExpression: [
                            'id',
                            'superClass',
                            'body'
                        ],
                        ComprehensionBlock: [
                            'left',
                            'right'
                        ],
                        ComprehensionExpression: [
                            'blocks',
                            'filter',
                            'body'
                        ],
                        ConditionalExpression: [
                            'test',
                            'consequent',
                            'alternate'
                        ],
                        ContinueStatement: ['label'],
                        DebuggerStatement: [],
                        DirectiveStatement: [],
                        DoWhileStatement: [
                            'body',
                            'test'
                        ],
                        EmptyStatement: [],
                        ExportAllDeclaration: ['source'],
                        ExportDefaultDeclaration: ['declaration'],
                        ExportNamedDeclaration: [
                            'declaration',
                            'specifiers',
                            'source'
                        ],
                        ExportSpecifier: [
                            'exported',
                            'local'
                        ],
                        ExpressionStatement: ['expression'],
                        ForStatement: [
                            'init',
                            'test',
                            'update',
                            'body'
                        ],
                        ForInStatement: [
                            'left',
                            'right',
                            'body'
                        ],
                        ForOfStatement: [
                            'left',
                            'right',
                            'body'
                        ],
                        FunctionDeclaration: [
                            'id',
                            'params',
                            'body'
                        ],
                        FunctionExpression: [
                            'id',
                            'params',
                            'body'
                        ],
                        GeneratorExpression: [
                            'blocks',
                            'filter',
                            'body'
                        ],
                        Identifier: [],
                        IfStatement: [
                            'test',
                            'consequent',
                            'alternate'
                        ],
                        ImportExpression: ['source'],
                        ImportDeclaration: [
                            'specifiers',
                            'source'
                        ],
                        ImportDefaultSpecifier: ['local'],
                        ImportNamespaceSpecifier: ['local'],
                        ImportSpecifier: [
                            'imported',
                            'local'
                        ],
                        Literal: [],
                        LabeledStatement: [
                            'label',
                            'body'
                        ],
                        LogicalExpression: [
                            'left',
                            'right'
                        ],
                        MemberExpression: [
                            'object',
                            'property'
                        ],
                        MetaProperty: [
                            'meta',
                            'property'
                        ],
                        MethodDefinition: [
                            'key',
                            'value'
                        ],
                        ModuleSpecifier: [],
                        NewExpression: [
                            'callee',
                            'arguments'
                        ],
                        ObjectExpression: ['properties'],
                        ObjectPattern: ['properties'],
                        PrivateIdentifier: [],
                        Program: ['body'],
                        Property: [
                            'key',
                            'value'
                        ],
                        PropertyDefinition: [
                            'key',
                            'value'
                        ],
                        RestElement: ['argument'],
                        ReturnStatement: ['argument'],
                        SequenceExpression: ['expressions'],
                        SpreadElement: ['argument'],
                        StaticBlock: ['body'],
                        Super: [],
                        SwitchStatement: [
                            'discriminant',
                            'cases'
                        ],
                        SwitchCase: [
                            'test',
                            'consequent'
                        ],
                        TaggedTemplateExpression: [
                            'tag',
                            'quasi'
                        ],
                        TemplateElement: [],
                        TemplateLiteral: [
                            'quasis',
                            'expressions'
                        ],
                        ThisExpression: [],
                        ThrowStatement: ['argument'],
                        TryStatement: [
                            'block',
                            'handler',
                            'finalizer'
                        ],
                        UnaryExpression: ['argument'],
                        UpdateExpression: ['argument'],
                        VariableDeclaration: ['declarations'],
                        VariableDeclarator: [
                            'id',
                            'init'
                        ],
                        WhileStatement: [
                            'test',
                            'body'
                        ],
                        WithStatement: [
                            'object',
                            'body'
                        ],
                        YieldExpression: ['argument']
                    }, n = {
                        Break: a = {},
                        Skip: o = {},
                        Remove: s = {}
                    }, u.prototype.replace = function (e) {
                        this.parent[this.key] = e;
                    }, u.prototype.remove = function () {
                        return Array.isArray(this.parent) ? (this.parent.splice(this.key, 1), !0) : (this.replace(null), !1);
                    }, d.prototype.path = function () {
                        var e, t, r, n, i;
                        function a(e, t) {
                            if (Array.isArray(t))
                                for (r = 0, n = t.length; r < n; ++r)
                                    e.push(t[r]);
                            else
                                e.push(t);
                        }
                        if (!this.__current.path)
                            return null;
                        for (i = [], e = 2, t = this.__leavelist.length; e < t; ++e)
                            a(i, this.__leavelist[e].path);
                        return a(i, this.__current.path), i;
                    }, d.prototype.type = function () {
                        return this.current().type || this.__current.wrap;
                    }, d.prototype.parents = function () {
                        var e, t, r;
                        for (r = [], e = 1, t = this.__leavelist.length; e < t; ++e)
                            r.push(this.__leavelist[e].node);
                        return r;
                    }, d.prototype.current = function () {
                        return this.__current.node;
                    }, d.prototype.__execute = function (e, t) {
                        var r, n;
                        return n = void 0, r = this.__current, this.__current = t, this.__state = null, e && (n = e.call(this, t.node, this.__leavelist[this.__leavelist.length - 1].node)), this.__current = r, n;
                    }, d.prototype.notify = function (e) {
                        this.__state = e;
                    }, d.prototype.skip = function () {
                        this.notify(o);
                    }, d.prototype.break = function () {
                        this.notify(a);
                    }, d.prototype.remove = function () {
                        this.notify(s);
                    }, d.prototype.__initialize = function (e, t) {
                        this.visitor = t, this.root = e, this.__worklist = [], this.__leavelist = [], this.__current = null, this.__state = null, this.__fallback = null, 'iteration' === t.fallback ? this.__fallback = Object.keys : 'function' == typeof t.fallback && (this.__fallback = t.fallback), this.__keys = i, t.keys && (this.__keys = Object.assign(Object.create(this.__keys), t.keys));
                    }, d.prototype.traverse = function (e, t) {
                        var r, n, i, s, c, u, d, h, g, y, b, S;
                        for (this.__initialize(e, t), S = {}, r = this.__worklist, n = this.__leavelist, r.push(new l(e, null, null, null)), n.push(new l(null, null, null, null)); r.length;)
                            if ((i = r.pop()) !== S) {
                                if (i.node) {
                                    if (u = this.__execute(t.enter, i), this.__state === a || u === a)
                                        return;
                                    if (r.push(S), n.push(i), this.__state === o || u === o)
                                        continue;
                                    if (c = (s = i.node).type || i.wrap, !(y = this.__keys[c])) {
                                        if (!this.__fallback)
                                            throw new Error('Unknown node type ' + c + '.');
                                        y = this.__fallback(s);
                                    }
                                    for (h = y.length; (h -= 1) >= 0;)
                                        if (b = s[d = y[h]])
                                            if (Array.isArray(b)) {
                                                for (g = b.length; (g -= 1) >= 0;)
                                                    if (b[g] && !m(n, b[g])) {
                                                        if (f(c, y[h]))
                                                            i = new l(b[g], [
                                                                d,
                                                                g
                                                            ], 'Property', null);
                                                        else {
                                                            if (!p(b[g]))
                                                                continue;
                                                            i = new l(b[g], [
                                                                d,
                                                                g
                                                            ], null, null);
                                                        }
                                                        r.push(i);
                                                    }
                                            } else if (p(b)) {
                                                if (m(n, b))
                                                    continue;
                                                r.push(new l(b, d, null, null));
                                            }
                                }
                            } else if (i = n.pop(), u = this.__execute(t.leave, i), this.__state === a || u === a)
                                return;
                    }, d.prototype.replace = function (e, t) {
                        var r, n, i, c, d, m, h, g, y, b, S, v, C;
                        function A(e) {
                            var t, n, i, a;
                            if (e.ref.remove())
                                for (n = e.ref.key, a = e.ref.parent, t = r.length; t--;)
                                    if ((i = r[t]).ref && i.ref.parent === a) {
                                        if (i.ref.key < n)
                                            break;
                                        --i.ref.key;
                                    }
                        }
                        for (this.__initialize(e, t), S = {}, r = this.__worklist, n = this.__leavelist, m = new l(e, null, null, new u(v = { root: e }, 'root')), r.push(m), n.push(m); r.length;)
                            if ((m = r.pop()) !== S) {
                                if (void 0 !== (d = this.__execute(t.enter, m)) && d !== a && d !== o && d !== s && (m.ref.replace(d), m.node = d), this.__state !== s && d !== s || (A(m), m.node = null), this.__state === a || d === a)
                                    return v.root;
                                if ((i = m.node) && (r.push(S), n.push(m), this.__state !== o && d !== o)) {
                                    if (c = i.type || m.wrap, !(y = this.__keys[c])) {
                                        if (!this.__fallback)
                                            throw new Error('Unknown node type ' + c + '.');
                                        y = this.__fallback(i);
                                    }
                                    for (h = y.length; (h -= 1) >= 0;)
                                        if (b = i[C = y[h]])
                                            if (Array.isArray(b)) {
                                                for (g = b.length; (g -= 1) >= 0;)
                                                    if (b[g]) {
                                                        if (f(c, y[h]))
                                                            m = new l(b[g], [
                                                                C,
                                                                g
                                                            ], 'Property', new u(b, g));
                                                        else {
                                                            if (!p(b[g]))
                                                                continue;
                                                            m = new l(b[g], [
                                                                C,
                                                                g
                                                            ], null, new u(b, g));
                                                        }
                                                        r.push(m);
                                                    }
                                            } else
                                                p(b) && r.push(new l(b, C, null, new u(i, C)));
                                }
                            } else if (m = n.pop(), void 0 !== (d = this.__execute(t.leave, m)) && d !== a && d !== o && d !== s && m.ref.replace(d), this.__state !== s && d !== s || A(m), this.__state === a || d === a)
                                return v.root;
                        return v.root;
                    }, t.Syntax = r, t.traverse = h, t.replace = function (e, t) {
                        return new d().replace(e, t);
                    }, t.attachComments = function (e, t, r) {
                        var i, a, o, s, u = [];
                        if (!e.range)
                            throw new Error('attachComments needs range information');
                        if (!r.length) {
                            if (t.length) {
                                for (o = 0, a = t.length; o < a; o += 1)
                                    (i = c(t[o])).extendedRange = [
                                        0,
                                        e.range[0]
                                    ], u.push(i);
                                e.leadingComments = u;
                            }
                            return e;
                        }
                        for (o = 0, a = t.length; o < a; o += 1)
                            u.push(g(c(t[o]), r));
                        return s = 0, h(e, {
                            enter: function (e) {
                                for (var t; s < u.length && !((t = u[s]).extendedRange[1] > e.range[0]);)
                                    t.extendedRange[1] === e.range[0] ? (e.leadingComments || (e.leadingComments = []), e.leadingComments.push(t), u.splice(s, 1)) : s += 1;
                                return s === u.length ? n.Break : u[s].extendedRange[0] > e.range[1] ? n.Skip : void 0;
                            }
                        }), s = 0, h(e, {
                            leave: function (e) {
                                for (var t; s < u.length && (t = u[s], !(e.range[1] < t.extendedRange[0]));)
                                    e.range[1] === t.extendedRange[0] ? (e.trailingComments || (e.trailingComments = []), e.trailingComments.push(t), u.splice(s, 1)) : s += 1;
                                return s === u.length ? n.Break : u[s].extendedRange[0] > e.range[1] ? n.Skip : void 0;
                            }
                        }), e;
                    }, t.VisitorKeys = i, t.VisitorOption = n, t.Controller = d, t.cloneEnvironment = function () {
                        return e({});
                    }, t;
                }(t);
            },
            1234: function (e, t) {
                !function (e) {
                    'use strict';
                    var t = [
                            509,
                            0,
                            227,
                            0,
                            150,
                            4,
                            294,
                            9,
                            1368,
                            2,
                            2,
                            1,
                            6,
                            3,
                            41,
                            2,
                            5,
                            0,
                            166,
                            1,
                            574,
                            3,
                            9,
                            9,
                            370,
                            1,
                            81,
                            2,
                            71,
                            10,
                            50,
                            3,
                            123,
                            2,
                            54,
                            14,
                            32,
                            10,
                            3,
                            1,
                            11,
                            3,
                            46,
                            10,
                            8,
                            0,
                            46,
                            9,
                            7,
                            2,
                            37,
                            13,
                            2,
                            9,
                            6,
                            1,
                            45,
                            0,
                            13,
                            2,
                            49,
                            13,
                            9,
                            3,
                            2,
                            11,
                            83,
                            11,
                            7,
                            0,
                            3,
                            0,
                            158,
                            11,
                            6,
                            9,
                            7,
                            3,
                            56,
                            1,
                            2,
                            6,
                            3,
                            1,
                            3,
                            2,
                            10,
                            0,
                            11,
                            1,
                            3,
                            6,
                            4,
                            4,
                            193,
                            17,
                            10,
                            9,
                            5,
                            0,
                            82,
                            19,
                            13,
                            9,
                            214,
                            6,
                            3,
                            8,
                            28,
                            1,
                            83,
                            16,
                            16,
                            9,
                            82,
                            12,
                            9,
                            9,
                            84,
                            14,
                            5,
                            9,
                            243,
                            14,
                            166,
                            9,
                            71,
                            5,
                            2,
                            1,
                            3,
                            3,
                            2,
                            0,
                            2,
                            1,
                            13,
                            9,
                            120,
                            6,
                            3,
                            6,
                            4,
                            0,
                            29,
                            9,
                            41,
                            6,
                            2,
                            3,
                            9,
                            0,
                            10,
                            10,
                            47,
                            15,
                            406,
                            7,
                            2,
                            7,
                            17,
                            9,
                            57,
                            21,
                            2,
                            13,
                            123,
                            5,
                            4,
                            0,
                            2,
                            1,
                            2,
                            6,
                            2,
                            0,
                            9,
                            9,
                            49,
                            4,
                            2,
                            1,
                            2,
                            4,
                            9,
                            9,
                            330,
                            3,
                            10,
                            1,
                            2,
                            0,
                            49,
                            6,
                            4,
                            4,
                            14,
                            9,
                            5351,
                            0,
                            7,
                            14,
                            13835,
                            9,
                            87,
                            9,
                            39,
                            4,
                            60,
                            6,
                            26,
                            9,
                            1014,
                            0,
                            2,
                            54,
                            8,
                            3,
                            82,
                            0,
                            12,
                            1,
                            19628,
                            1,
                            4706,
                            45,
                            3,
                            22,
                            543,
                            4,
                            4,
                            5,
                            9,
                            7,
                            3,
                            6,
                            31,
                            3,
                            149,
                            2,
                            1418,
                            49,
                            513,
                            54,
                            5,
                            49,
                            9,
                            0,
                            15,
                            0,
                            23,
                            4,
                            2,
                            14,
                            1361,
                            6,
                            2,
                            16,
                            3,
                            6,
                            2,
                            1,
                            2,
                            4,
                            101,
                            0,
                            161,
                            6,
                            10,
                            9,
                            357,
                            0,
                            62,
                            13,
                            499,
                            13,
                            983,
                            6,
                            110,
                            6,
                            6,
                            9,
                            4759,
                            9,
                            787719,
                            239
                        ], r = [
                            0,
                            11,
                            2,
                            25,
                            2,
                            18,
                            2,
                            1,
                            2,
                            14,
                            3,
                            13,
                            35,
                            122,
                            70,
                            52,
                            268,
                            28,
                            4,
                            48,
                            48,
                            31,
                            14,
                            29,
                            6,
                            37,
                            11,
                            29,
                            3,
                            35,
                            5,
                            7,
                            2,
                            4,
                            43,
                            157,
                            19,
                            35,
                            5,
                            35,
                            5,
                            39,
                            9,
                            51,
                            13,
                            10,
                            2,
                            14,
                            2,
                            6,
                            2,
                            1,
                            2,
                            10,
                            2,
                            14,
                            2,
                            6,
                            2,
                            1,
                            68,
                            310,
                            10,
                            21,
                            11,
                            7,
                            25,
                            5,
                            2,
                            41,
                            2,
                            8,
                            70,
                            5,
                            3,
                            0,
                            2,
                            43,
                            2,
                            1,
                            4,
                            0,
                            3,
                            22,
                            11,
                            22,
                            10,
                            30,
                            66,
                            18,
                            2,
                            1,
                            11,
                            21,
                            11,
                            25,
                            71,
                            55,
                            7,
                            1,
                            65,
                            0,
                            16,
                            3,
                            2,
                            2,
                            2,
                            28,
                            43,
                            28,
                            4,
                            28,
                            36,
                            7,
                            2,
                            27,
                            28,
                            53,
                            11,
                            21,
                            11,
                            18,
                            14,
                            17,
                            111,
                            72,
                            56,
                            50,
                            14,
                            50,
                            14,
                            35,
                            349,
                            41,
                            7,
                            1,
                            79,
                            28,
                            11,
                            0,
                            9,
                            21,
                            43,
                            17,
                            47,
                            20,
                            28,
                            22,
                            13,
                            52,
                            58,
                            1,
                            3,
                            0,
                            14,
                            44,
                            33,
                            24,
                            27,
                            35,
                            30,
                            0,
                            3,
                            0,
                            9,
                            34,
                            4,
                            0,
                            13,
                            47,
                            15,
                            3,
                            22,
                            0,
                            2,
                            0,
                            36,
                            17,
                            2,
                            24,
                            20,
                            1,
                            64,
                            6,
                            2,
                            0,
                            2,
                            3,
                            2,
                            14,
                            2,
                            9,
                            8,
                            46,
                            39,
                            7,
                            3,
                            1,
                            3,
                            21,
                            2,
                            6,
                            2,
                            1,
                            2,
                            4,
                            4,
                            0,
                            19,
                            0,
                            13,
                            4,
                            159,
                            52,
                            19,
                            3,
                            21,
                            2,
                            31,
                            47,
                            21,
                            1,
                            2,
                            0,
                            185,
                            46,
                            42,
                            3,
                            37,
                            47,
                            21,
                            0,
                            60,
                            42,
                            14,
                            0,
                            72,
                            26,
                            38,
                            6,
                            186,
                            43,
                            117,
                            63,
                            32,
                            7,
                            3,
                            0,
                            3,
                            7,
                            2,
                            1,
                            2,
                            23,
                            16,
                            0,
                            2,
                            0,
                            95,
                            7,
                            3,
                            38,
                            17,
                            0,
                            2,
                            0,
                            29,
                            0,
                            11,
                            39,
                            8,
                            0,
                            22,
                            0,
                            12,
                            45,
                            20,
                            0,
                            19,
                            72,
                            264,
                            8,
                            2,
                            36,
                            18,
                            0,
                            50,
                            29,
                            113,
                            6,
                            2,
                            1,
                            2,
                            37,
                            22,
                            0,
                            26,
                            5,
                            2,
                            1,
                            2,
                            31,
                            15,
                            0,
                            328,
                            18,
                            16,
                            0,
                            2,
                            12,
                            2,
                            33,
                            125,
                            0,
                            80,
                            921,
                            103,
                            110,
                            18,
                            195,
                            2637,
                            96,
                            16,
                            1071,
                            18,
                            5,
                            4026,
                            582,
                            8634,
                            568,
                            8,
                            30,
                            18,
                            78,
                            18,
                            29,
                            19,
                            47,
                            17,
                            3,
                            32,
                            20,
                            6,
                            18,
                            689,
                            63,
                            129,
                            74,
                            6,
                            0,
                            67,
                            12,
                            65,
                            1,
                            2,
                            0,
                            29,
                            6135,
                            9,
                            1237,
                            43,
                            8,
                            8936,
                            3,
                            2,
                            6,
                            2,
                            1,
                            2,
                            290,
                            16,
                            0,
                            30,
                            2,
                            3,
                            0,
                            15,
                            3,
                            9,
                            395,
                            2309,
                            106,
                            6,
                            12,
                            4,
                            8,
                            8,
                            9,
                            5991,
                            84,
                            2,
                            70,
                            2,
                            1,
                            3,
                            0,
                            3,
                            1,
                            3,
                            3,
                            2,
                            11,
                            2,
                            0,
                            2,
                            6,
                            2,
                            64,
                            2,
                            3,
                            3,
                            7,
                            2,
                            6,
                            2,
                            27,
                            2,
                            3,
                            2,
                            4,
                            2,
                            0,
                            4,
                            6,
                            2,
                            339,
                            3,
                            24,
                            2,
                            24,
                            2,
                            30,
                            2,
                            24,
                            2,
                            30,
                            2,
                            24,
                            2,
                            30,
                            2,
                            24,
                            2,
                            30,
                            2,
                            24,
                            2,
                            7,
                            1845,
                            30,
                            7,
                            5,
                            262,
                            61,
                            147,
                            44,
                            11,
                            6,
                            17,
                            0,
                            322,
                            29,
                            19,
                            43,
                            485,
                            27,
                            757,
                            6,
                            2,
                            3,
                            2,
                            1,
                            2,
                            14,
                            2,
                            196,
                            60,
                            67,
                            8,
                            0,
                            1205,
                            3,
                            2,
                            26,
                            2,
                            1,
                            2,
                            0,
                            3,
                            0,
                            2,
                            9,
                            2,
                            3,
                            2,
                            0,
                            2,
                            0,
                            7,
                            0,
                            5,
                            0,
                            2,
                            0,
                            2,
                            0,
                            2,
                            2,
                            2,
                            1,
                            2,
                            0,
                            3,
                            0,
                            2,
                            0,
                            2,
                            0,
                            2,
                            0,
                            2,
                            0,
                            2,
                            1,
                            2,
                            0,
                            3,
                            3,
                            2,
                            6,
                            2,
                            3,
                            2,
                            3,
                            2,
                            0,
                            2,
                            9,
                            2,
                            16,
                            6,
                            2,
                            2,
                            4,
                            2,
                            16,
                            4421,
                            42719,
                            33,
                            4153,
                            7,
                            221,
                            3,
                            5761,
                            15,
                            7472,
                            3104,
                            541,
                            1507,
                            4938,
                            6,
                            4191
                        ], n = 'ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙ\u0560-\u0588א-ת\u05EF-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘ\u0860-\u086A\u0870-\u0887\u0889-\u088Eࢠ-\u08C9ऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱ\u09FCਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚ\u0C5Dౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽ\u0CDDೞೠೡೱೲ\u0D04-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄ\u0E86-ຊ\u0E8C-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑ\u171F-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-\u1878ᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-\u1B4Cᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈ\u1C90-\u1CBA\u1CBD-\u1CBFᳩ-ᳬᳮ-ᳳᳵᳶ\u1CFAᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ\u2118-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ\u309B-ゟァ-ヺー-ヿㄅ-\u312Fㄱ-ㆎㆠ-\u31BFㇰ-ㇿ㐀-\u4DBF一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽ\uA8FEꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-\uAB69ꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ', i = {
                            3: 'abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile',
                            5: 'class enum extends super const export import',
                            6: 'enum',
                            strict: 'implements interface let package private protected public static yield',
                            strictBind: 'eval arguments'
                        }, a = 'break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this', o = {
                            5: a,
                            '5module': a + ' export import',
                            6: a + ' const class extends export import super'
                        }, s = /^in(stanceof)?$/, c = new RegExp('[' + n + ']'), u = new RegExp('[' + n + '‌‍\xB7̀-ͯ\u0387҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߳\u07FDࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛\u0898-\u089F\u08CA-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯\u09FEਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯\u0AFA-\u0AFFଁ-ଃ଼ା-ୄେୈୋ-୍\u0B55-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-\u0C04\u0C3Cా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯\u0CF3\u0D00-ഃ\u0D3B\u0D3Cാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯\u0D81-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-\u0ECE໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟\u1369-\u1371ᜒ-\u1715ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍\u180F-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-\u19DAᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽\u1ABF-\u1ACEᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴\u1CF7-᳹᷀-᷿‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ\uA82Cꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱\uA8FF-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿]');
                    function l(e, t) {
                        for (var r = 65536, n = 0; n < t.length; n += 2) {
                            if ((r += t[n]) > e)
                                return !1;
                            if ((r += t[n + 1]) >= e)
                                return !0;
                        }
                        return !1;
                    }
                    function d(e, t) {
                        return e < 65 ? 36 === e : e < 91 || (e < 97 ? 95 === e : e < 123 || (e <= 65535 ? e >= 170 && c.test(String.fromCharCode(e)) : !1 !== t && l(e, r)));
                    }
                    function p(e, n) {
                        return e < 48 ? 36 === e : e < 58 || !(e < 65) && (e < 91 || (e < 97 ? 95 === e : e < 123 || (e <= 65535 ? e >= 170 && u.test(String.fromCharCode(e)) : !1 !== n && (l(e, r) || l(e, t)))));
                    }
                    var f = function (e, t) {
                        void 0 === t && (t = {}), this.label = e, this.keyword = t.keyword, this.beforeExpr = !!t.beforeExpr, this.startsExpr = !!t.startsExpr, this.isLoop = !!t.isLoop, this.isAssign = !!t.isAssign, this.prefix = !!t.prefix, this.postfix = !!t.postfix, this.binop = t.binop || null, this.updateContext = null;
                    };
                    function m(e, t) {
                        return new f(e, {
                            beforeExpr: !0,
                            binop: t
                        });
                    }
                    var h = { beforeExpr: !0 }, g = { startsExpr: !0 }, y = {};
                    function b(e, t) {
                        return void 0 === t && (t = {}), t.keyword = e, y[e] = new f(e, t);
                    }
                    var S = {
                            num: new f('num', g),
                            regexp: new f('regexp', g),
                            string: new f('string', g),
                            name: new f('name', g),
                            privateId: new f('privateId', g),
                            eof: new f('eof'),
                            bracketL: new f('[', {
                                beforeExpr: !0,
                                startsExpr: !0
                            }),
                            bracketR: new f(']'),
                            braceL: new f('{', {
                                beforeExpr: !0,
                                startsExpr: !0
                            }),
                            braceR: new f('}'),
                            parenL: new f('(', {
                                beforeExpr: !0,
                                startsExpr: !0
                            }),
                            parenR: new f(')'),
                            comma: new f(',', h),
                            semi: new f(';', h),
                            colon: new f(':', h),
                            dot: new f('.'),
                            question: new f('?', h),
                            questionDot: new f('?.'),
                            arrow: new f('=>', h),
                            template: new f('template'),
                            invalidTemplate: new f('invalidTemplate'),
                            ellipsis: new f('...', h),
                            backQuote: new f('`', g),
                            dollarBraceL: new f('${', {
                                beforeExpr: !0,
                                startsExpr: !0
                            }),
                            eq: new f('=', {
                                beforeExpr: !0,
                                isAssign: !0
                            }),
                            assign: new f('_=', {
                                beforeExpr: !0,
                                isAssign: !0
                            }),
                            incDec: new f('++/--', {
                                prefix: !0,
                                postfix: !0,
                                startsExpr: !0
                            }),
                            prefix: new f('!/~', {
                                beforeExpr: !0,
                                prefix: !0,
                                startsExpr: !0
                            }),
                            logicalOR: m('||', 1),
                            logicalAND: m('&&', 2),
                            bitwiseOR: m('|', 3),
                            bitwiseXOR: m('^', 4),
                            bitwiseAND: m('&', 5),
                            equality: m('==/!=/===/!==', 6),
                            relational: m('</>/<=/>=', 7),
                            bitShift: m('<</>>/>>>', 8),
                            plusMin: new f('+/-', {
                                beforeExpr: !0,
                                binop: 9,
                                prefix: !0,
                                startsExpr: !0
                            }),
                            modulo: m('%', 10),
                            star: m('*', 10),
                            slash: m('/', 10),
                            starstar: new f('**', { beforeExpr: !0 }),
                            coalesce: m('??', 1),
                            _break: b('break'),
                            _case: b('case', h),
                            _catch: b('catch'),
                            _continue: b('continue'),
                            _debugger: b('debugger'),
                            _default: b('default', h),
                            _do: b('do', {
                                isLoop: !0,
                                beforeExpr: !0
                            }),
                            _else: b('else', h),
                            _finally: b('finally'),
                            _for: b('for', { isLoop: !0 }),
                            _function: b('function', g),
                            _if: b('if'),
                            _return: b('return', h),
                            _switch: b('switch'),
                            _throw: b('throw', h),
                            _try: b('try'),
                            _var: b('var'),
                            _const: b('const'),
                            _while: b('while', { isLoop: !0 }),
                            _with: b('with'),
                            _new: b('new', {
                                beforeExpr: !0,
                                startsExpr: !0
                            }),
                            _this: b('this', g),
                            _super: b('super', g),
                            _class: b('class', g),
                            _extends: b('extends', h),
                            _export: b('export'),
                            _import: b('import', g),
                            _null: b('null', g),
                            _true: b('true', g),
                            _false: b('false', g),
                            _in: b('in', {
                                beforeExpr: !0,
                                binop: 7
                            }),
                            _instanceof: b('instanceof', {
                                beforeExpr: !0,
                                binop: 7
                            }),
                            _typeof: b('typeof', {
                                beforeExpr: !0,
                                prefix: !0,
                                startsExpr: !0
                            }),
                            _void: b('void', {
                                beforeExpr: !0,
                                prefix: !0,
                                startsExpr: !0
                            }),
                            _delete: b('delete', {
                                beforeExpr: !0,
                                prefix: !0,
                                startsExpr: !0
                            })
                        }, v = /\r\n?|\n|\u2028|\u2029/, C = new RegExp(v.source, 'g');
                    function A(e) {
                        return 10 === e || 13 === e || 8232 === e || 8233 === e;
                    }
                    function _(e, t, r) {
                        void 0 === r && (r = e.length);
                        for (var n = t; n < r; n++) {
                            var i = e.charCodeAt(n);
                            if (A(i))
                                return n < r - 1 && 13 === i && 10 === e.charCodeAt(n + 1) ? n + 2 : n + 1;
                        }
                        return -1;
                    }
                    var E = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, N = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, I = Object.prototype, T = I.hasOwnProperty, D = I.toString, O = Object.hasOwn || function (e, t) {
                            return T.call(e, t);
                        }, R = Array.isArray || function (e) {
                            return '[object Array]' === D.call(e);
                        };
                    function M(e) {
                        return new RegExp('^(?:' + e.replace(/ /g, '|') + ')$');
                    }
                    function F(e) {
                        return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10), 56320 + (1023 & e)));
                    }
                    var P = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, x = function (e, t) {
                            this.line = e, this.column = t;
                        };
                    x.prototype.offset = function (e) {
                        return new x(this.line, this.column + e);
                    };
                    var w = function (e, t, r) {
                        this.start = t, this.end = r, null !== e.sourceFile && (this.source = e.sourceFile);
                    };
                    function B(e, t) {
                        for (var r = 1, n = 0;;) {
                            var i = _(e, n, t);
                            if (i < 0)
                                return new x(r, t - n);
                            ++r, n = i;
                        }
                    }
                    var k = {
                            ecmaVersion: null,
                            sourceType: 'script',
                            onInsertedSemicolon: null,
                            onTrailingComma: null,
                            allowReserved: null,
                            allowReturnOutsideFunction: !1,
                            allowImportExportEverywhere: !1,
                            allowAwaitOutsideFunction: null,
                            allowSuperOutsideMethod: null,
                            allowHashBang: !1,
                            locations: !1,
                            onToken: null,
                            onComment: null,
                            ranges: !1,
                            program: null,
                            sourceFile: null,
                            directSourceFile: null,
                            preserveParens: !1
                        }, L = !1;
                    function $(e) {
                        var t = {};
                        for (var r in k)
                            t[r] = e && O(e, r) ? e[r] : k[r];
                        if ('latest' === t.ecmaVersion ? t.ecmaVersion = 100000000 : null == t.ecmaVersion ? (!L && 'object' == typeof console && console.warn && (L = !0, console.warn('Since Acorn 8.0.0, options.ecmaVersion is required.\nDefaulting to 2020, but this will stop working in the future.')), t.ecmaVersion = 11) : t.ecmaVersion >= 2015 && (t.ecmaVersion -= 2009), null == t.allowReserved && (t.allowReserved = t.ecmaVersion < 5), e && null != e.allowHashBang || (t.allowHashBang = t.ecmaVersion >= 14), R(t.onToken)) {
                            var n = t.onToken;
                            t.onToken = function (e) {
                                return n.push(e);
                            };
                        }
                        return R(t.onComment) && (t.onComment = function (e, t) {
                            return function (r, n, i, a, o, s) {
                                var c = {
                                    type: r ? 'Block' : 'Line',
                                    value: n,
                                    start: i,
                                    end: a
                                };
                                e.locations && (c.loc = new w(this, o, s)), e.ranges && (c.range = [
                                    i,
                                    a
                                ]), t.push(c);
                            };
                        }(t, t.onComment)), t;
                    }
                    var j = 256;
                    function G(e, t) {
                        return 2 | (e ? 4 : 0) | (t ? 8 : 0);
                    }
                    var V = function (e, t, r) {
                            this.options = e = $(e), this.sourceFile = e.sourceFile, this.keywords = M(o[e.ecmaVersion >= 6 ? 6 : 'module' === e.sourceType ? '5module' : 5]);
                            var n = '';
                            !0 !== e.allowReserved && (n = i[e.ecmaVersion >= 6 ? 6 : 5 === e.ecmaVersion ? 5 : 3], 'module' === e.sourceType && (n += ' await')), this.reservedWords = M(n);
                            var a = (n ? n + ' ' : '') + i.strict;
                            this.reservedWordsStrict = M(a), this.reservedWordsStrictBind = M(a + ' ' + i.strictBind), this.input = String(t), this.containsEsc = !1, r ? (this.pos = r, this.lineStart = this.input.lastIndexOf('\n', r - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(v).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = S.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = 'module' === e.sourceType, this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = Object.create(null), 0 === this.pos && e.allowHashBang && '#!' === this.input.slice(0, 2) && this.skipLineComment(2), this.scopeStack = [], this.enterScope(1), this.regexpState = null, this.privateNameStack = [];
                        }, U = {
                            inFunction: { configurable: !0 },
                            inGenerator: { configurable: !0 },
                            inAsync: { configurable: !0 },
                            canAwait: { configurable: !0 },
                            allowSuper: { configurable: !0 },
                            allowDirectSuper: { configurable: !0 },
                            treatFunctionsAsVar: { configurable: !0 },
                            allowNewDotTarget: { configurable: !0 },
                            inClassStaticBlock: { configurable: !0 }
                        };
                    V.prototype.parse = function () {
                        var e = this.options.program || this.startNode();
                        return this.nextToken(), this.parseTopLevel(e);
                    }, U.inFunction.get = function () {
                        return (2 & this.currentVarScope().flags) > 0;
                    }, U.inGenerator.get = function () {
                        return (8 & this.currentVarScope().flags) > 0 && !this.currentVarScope().inClassFieldInit;
                    }, U.inAsync.get = function () {
                        return (4 & this.currentVarScope().flags) > 0 && !this.currentVarScope().inClassFieldInit;
                    }, U.canAwait.get = function () {
                        for (var e = this.scopeStack.length - 1; e >= 0; e--) {
                            var t = this.scopeStack[e];
                            if (t.inClassFieldInit || t.flags & j)
                                return !1;
                            if (2 & t.flags)
                                return (4 & t.flags) > 0;
                        }
                        return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
                    }, U.allowSuper.get = function () {
                        var e = this.currentThisScope(), t = e.flags, r = e.inClassFieldInit;
                        return (64 & t) > 0 || r || this.options.allowSuperOutsideMethod;
                    }, U.allowDirectSuper.get = function () {
                        return (128 & this.currentThisScope().flags) > 0;
                    }, U.treatFunctionsAsVar.get = function () {
                        return this.treatFunctionsAsVarInScope(this.currentScope());
                    }, U.allowNewDotTarget.get = function () {
                        var e = this.currentThisScope(), t = e.flags, r = e.inClassFieldInit;
                        return (258 & t) > 0 || r;
                    }, U.inClassStaticBlock.get = function () {
                        return (this.currentVarScope().flags & j) > 0;
                    }, V.extend = function () {
                        for (var e = [], t = arguments.length; t--;)
                            e[t] = arguments[t];
                        for (var r = this, n = 0; n < e.length; n++)
                            r = e[n](r);
                        return r;
                    }, V.parse = function (e, t) {
                        return new this(t, e).parse();
                    }, V.parseExpressionAt = function (e, t, r) {
                        var n = new this(r, e, t);
                        return n.nextToken(), n.parseExpression();
                    }, V.tokenizer = function (e, t) {
                        return new this(t, e);
                    }, Object.defineProperties(V.prototype, U);
                    var H = V.prototype, W = /^(?:'((?:\\.|[^'\\])*?)'|"((?:\\.|[^"\\])*?)")/;
                    H.strictDirective = function (e) {
                        if (this.options.ecmaVersion < 5)
                            return !1;
                        for (;;) {
                            N.lastIndex = e, e += N.exec(this.input)[0].length;
                            var t = W.exec(this.input.slice(e));
                            if (!t)
                                return !1;
                            if ('use strict' === (t[1] || t[2])) {
                                N.lastIndex = e + t[0].length;
                                var r = N.exec(this.input), n = r.index + r[0].length, i = this.input.charAt(n);
                                return ';' === i || '}' === i || v.test(r[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(i) || '!' === i && '=' === this.input.charAt(n + 1));
                            }
                            e += t[0].length, N.lastIndex = e, e += N.exec(this.input)[0].length, ';' === this.input[e] && e++;
                        }
                    }, H.eat = function (e) {
                        return this.type === e && (this.next(), !0);
                    }, H.isContextual = function (e) {
                        return this.type === S.name && this.value === e && !this.containsEsc;
                    }, H.eatContextual = function (e) {
                        return !!this.isContextual(e) && (this.next(), !0);
                    }, H.expectContextual = function (e) {
                        this.eatContextual(e) || this.unexpected();
                    }, H.canInsertSemicolon = function () {
                        return this.type === S.eof || this.type === S.braceR || v.test(this.input.slice(this.lastTokEnd, this.start));
                    }, H.insertSemicolon = function () {
                        if (this.canInsertSemicolon())
                            return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
                    }, H.semicolon = function () {
                        this.eat(S.semi) || this.insertSemicolon() || this.unexpected();
                    }, H.afterTrailingComma = function (e, t) {
                        if (this.type === e)
                            return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t || this.next(), !0;
                    }, H.expect = function (e) {
                        this.eat(e) || this.unexpected();
                    }, H.unexpected = function (e) {
                        this.raise(null != e ? e : this.start, 'Unexpected token');
                    };
                    var K = function () {
                        this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
                    };
                    H.checkPatternErrors = function (e, t) {
                        if (e) {
                            e.trailingComma > -1 && this.raiseRecoverable(e.trailingComma, 'Comma is not permitted after the rest element');
                            var r = t ? e.parenthesizedAssign : e.parenthesizedBind;
                            r > -1 && this.raiseRecoverable(r, t ? 'Assigning to rvalue' : 'Parenthesized pattern');
                        }
                    }, H.checkExpressionErrors = function (e, t) {
                        if (!e)
                            return !1;
                        var r = e.shorthandAssign, n = e.doubleProto;
                        if (!t)
                            return r >= 0 || n >= 0;
                        r >= 0 && this.raise(r, 'Shorthand property assignments are valid only in destructuring patterns'), n >= 0 && this.raiseRecoverable(n, 'Redefinition of __proto__ property');
                    }, H.checkYieldAwaitInDefaultParams = function () {
                        this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, 'Yield expression cannot be a default value'), this.awaitPos && this.raise(this.awaitPos, 'Await expression cannot be a default value');
                    }, H.isSimpleAssignTarget = function (e) {
                        return 'ParenthesizedExpression' === e.type ? this.isSimpleAssignTarget(e.expression) : 'Identifier' === e.type || 'MemberExpression' === e.type;
                    };
                    var z = V.prototype;
                    z.parseTopLevel = function (e) {
                        var t = Object.create(null);
                        for (e.body || (e.body = []); this.type !== S.eof;) {
                            var r = this.parseStatement(null, !0, t);
                            e.body.push(r);
                        }
                        if (this.inModule)
                            for (var n = 0, i = Object.keys(this.undefinedExports); n < i.length; n += 1) {
                                var a = i[n];
                                this.raiseRecoverable(this.undefinedExports[a].start, 'Export \'' + a + '\' is not defined');
                            }
                        return this.adaptDirectivePrologue(e.body), this.next(), e.sourceType = this.options.sourceType, this.finishNode(e, 'Program');
                    };
                    var X = { kind: 'loop' }, Y = { kind: 'switch' };
                    z.isLet = function (e) {
                        if (this.options.ecmaVersion < 6 || !this.isContextual('let'))
                            return !1;
                        N.lastIndex = this.pos;
                        var t = N.exec(this.input), r = this.pos + t[0].length, n = this.input.charCodeAt(r);
                        if (91 === n || 92 === n)
                            return !0;
                        if (e)
                            return !1;
                        if (123 === n || n > 55295 && n < 56320)
                            return !0;
                        if (d(n, !0)) {
                            for (var i = r + 1; p(n = this.input.charCodeAt(i), !0);)
                                ++i;
                            if (92 === n || n > 55295 && n < 56320)
                                return !0;
                            var a = this.input.slice(r, i);
                            if (!s.test(a))
                                return !0;
                        }
                        return !1;
                    }, z.isAsyncFunction = function () {
                        if (this.options.ecmaVersion < 8 || !this.isContextual('async'))
                            return !1;
                        N.lastIndex = this.pos;
                        var e, t = N.exec(this.input), r = this.pos + t[0].length;
                        return !(v.test(this.input.slice(this.pos, r)) || 'function' !== this.input.slice(r, r + 8) || r + 8 !== this.input.length && (p(e = this.input.charCodeAt(r + 8)) || e > 55295 && e < 56320));
                    }, z.parseStatement = function (e, t, r) {
                        var n, i = this.type, a = this.startNode();
                        switch (this.isLet(e) && (i = S._var, n = 'let'), i) {
                        case S._break:
                        case S._continue:
                            return this.parseBreakContinueStatement(a, i.keyword);
                        case S._debugger:
                            return this.parseDebuggerStatement(a);
                        case S._do:
                            return this.parseDoStatement(a);
                        case S._for:
                            return this.parseForStatement(a);
                        case S._function:
                            return e && (this.strict || 'if' !== e && 'label' !== e) && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(a, !1, !e);
                        case S._class:
                            return e && this.unexpected(), this.parseClass(a, !0);
                        case S._if:
                            return this.parseIfStatement(a);
                        case S._return:
                            return this.parseReturnStatement(a);
                        case S._switch:
                            return this.parseSwitchStatement(a);
                        case S._throw:
                            return this.parseThrowStatement(a);
                        case S._try:
                            return this.parseTryStatement(a);
                        case S._const:
                        case S._var:
                            return n = n || this.value, e && 'var' !== n && this.unexpected(), this.parseVarStatement(a, n);
                        case S._while:
                            return this.parseWhileStatement(a);
                        case S._with:
                            return this.parseWithStatement(a);
                        case S.braceL:
                            return this.parseBlock(!0, a);
                        case S.semi:
                            return this.parseEmptyStatement(a);
                        case S._export:
                        case S._import:
                            if (this.options.ecmaVersion > 10 && i === S._import) {
                                N.lastIndex = this.pos;
                                var o = N.exec(this.input), s = this.pos + o[0].length, c = this.input.charCodeAt(s);
                                if (40 === c || 46 === c)
                                    return this.parseExpressionStatement(a, this.parseExpression());
                            }
                            return this.options.allowImportExportEverywhere || (t || this.raise(this.start, '\'import\' and \'export\' may only appear at the top level'), this.inModule || this.raise(this.start, '\'import\' and \'export\' may appear only with \'sourceType: module\'')), i === S._import ? this.parseImport(a) : this.parseExport(a, r);
                        default:
                            if (this.isAsyncFunction())
                                return e && this.unexpected(), this.next(), this.parseFunctionStatement(a, !0, !e);
                            var u = this.value, l = this.parseExpression();
                            return i === S.name && 'Identifier' === l.type && this.eat(S.colon) ? this.parseLabeledStatement(a, u, l, e) : this.parseExpressionStatement(a, l);
                        }
                    }, z.parseBreakContinueStatement = function (e, t) {
                        var r = 'break' === t;
                        this.next(), this.eat(S.semi) || this.insertSemicolon() ? e.label = null : this.type !== S.name ? this.unexpected() : (e.label = this.parseIdent(), this.semicolon());
                        for (var n = 0; n < this.labels.length; ++n) {
                            var i = this.labels[n];
                            if (null == e.label || i.name === e.label.name) {
                                if (null != i.kind && (r || 'loop' === i.kind))
                                    break;
                                if (e.label && r)
                                    break;
                            }
                        }
                        return n === this.labels.length && this.raise(e.start, 'Unsyntactic ' + t), this.finishNode(e, r ? 'BreakStatement' : 'ContinueStatement');
                    }, z.parseDebuggerStatement = function (e) {
                        return this.next(), this.semicolon(), this.finishNode(e, 'DebuggerStatement');
                    }, z.parseDoStatement = function (e) {
                        return this.next(), this.labels.push(X), e.body = this.parseStatement('do'), this.labels.pop(), this.expect(S._while), e.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(S.semi) : this.semicolon(), this.finishNode(e, 'DoWhileStatement');
                    }, z.parseForStatement = function (e) {
                        this.next();
                        var t = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual('await') ? this.lastTokStart : -1;
                        if (this.labels.push(X), this.enterScope(0), this.expect(S.parenL), this.type === S.semi)
                            return t > -1 && this.unexpected(t), this.parseFor(e, null);
                        var r = this.isLet();
                        if (this.type === S._var || this.type === S._const || r) {
                            var n = this.startNode(), i = r ? 'let' : this.value;
                            return this.next(), this.parseVar(n, !0, i), this.finishNode(n, 'VariableDeclaration'), (this.type === S._in || this.options.ecmaVersion >= 6 && this.isContextual('of')) && 1 === n.declarations.length ? (this.options.ecmaVersion >= 9 && (this.type === S._in ? t > -1 && this.unexpected(t) : e.await = t > -1), this.parseForIn(e, n)) : (t > -1 && this.unexpected(t), this.parseFor(e, n));
                        }
                        var a = this.isContextual('let'), o = !1, s = new K(), c = this.parseExpression(!(t > -1) || 'await', s);
                        return this.type === S._in || (o = this.options.ecmaVersion >= 6 && this.isContextual('of')) ? (this.options.ecmaVersion >= 9 && (this.type === S._in ? t > -1 && this.unexpected(t) : e.await = t > -1), a && o && this.raise(c.start, 'The left-hand side of a for-of loop may not start with \'let\'.'), this.toAssignable(c, !1, s), this.checkLValPattern(c), this.parseForIn(e, c)) : (this.checkExpressionErrors(s, !0), t > -1 && this.unexpected(t), this.parseFor(e, c));
                    }, z.parseFunctionStatement = function (e, t, r) {
                        return this.next(), this.parseFunction(e, Z | (r ? 0 : J), !1, t);
                    }, z.parseIfStatement = function (e) {
                        return this.next(), e.test = this.parseParenExpression(), e.consequent = this.parseStatement('if'), e.alternate = this.eat(S._else) ? this.parseStatement('if') : null, this.finishNode(e, 'IfStatement');
                    }, z.parseReturnStatement = function (e) {
                        return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, '\'return\' outside of function'), this.next(), this.eat(S.semi) || this.insertSemicolon() ? e.argument = null : (e.argument = this.parseExpression(), this.semicolon()), this.finishNode(e, 'ReturnStatement');
                    }, z.parseSwitchStatement = function (e) {
                        var t;
                        this.next(), e.discriminant = this.parseParenExpression(), e.cases = [], this.expect(S.braceL), this.labels.push(Y), this.enterScope(0);
                        for (var r = !1; this.type !== S.braceR;)
                            if (this.type === S._case || this.type === S._default) {
                                var n = this.type === S._case;
                                t && this.finishNode(t, 'SwitchCase'), e.cases.push(t = this.startNode()), t.consequent = [], this.next(), n ? t.test = this.parseExpression() : (r && this.raiseRecoverable(this.lastTokStart, 'Multiple default clauses'), r = !0, t.test = null), this.expect(S.colon);
                            } else
                                t || this.unexpected(), t.consequent.push(this.parseStatement(null));
                        return this.exitScope(), t && this.finishNode(t, 'SwitchCase'), this.next(), this.labels.pop(), this.finishNode(e, 'SwitchStatement');
                    }, z.parseThrowStatement = function (e) {
                        return this.next(), v.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, 'Illegal newline after throw'), e.argument = this.parseExpression(), this.semicolon(), this.finishNode(e, 'ThrowStatement');
                    };
                    var q = [];
                    z.parseTryStatement = function (e) {
                        if (this.next(), e.block = this.parseBlock(), e.handler = null, this.type === S._catch) {
                            var t = this.startNode();
                            if (this.next(), this.eat(S.parenL)) {
                                t.param = this.parseBindingAtom();
                                var r = 'Identifier' === t.param.type;
                                this.enterScope(r ? 32 : 0), this.checkLValPattern(t.param, r ? 4 : 2), this.expect(S.parenR);
                            } else
                                this.options.ecmaVersion < 10 && this.unexpected(), t.param = null, this.enterScope(0);
                            t.body = this.parseBlock(!1), this.exitScope(), e.handler = this.finishNode(t, 'CatchClause');
                        }
                        return e.finalizer = this.eat(S._finally) ? this.parseBlock() : null, e.handler || e.finalizer || this.raise(e.start, 'Missing catch or finally clause'), this.finishNode(e, 'TryStatement');
                    }, z.parseVarStatement = function (e, t) {
                        return this.next(), this.parseVar(e, !1, t), this.semicolon(), this.finishNode(e, 'VariableDeclaration');
                    }, z.parseWhileStatement = function (e) {
                        return this.next(), e.test = this.parseParenExpression(), this.labels.push(X), e.body = this.parseStatement('while'), this.labels.pop(), this.finishNode(e, 'WhileStatement');
                    }, z.parseWithStatement = function (e) {
                        return this.strict && this.raise(this.start, '\'with\' in strict mode'), this.next(), e.object = this.parseParenExpression(), e.body = this.parseStatement('with'), this.finishNode(e, 'WithStatement');
                    }, z.parseEmptyStatement = function (e) {
                        return this.next(), this.finishNode(e, 'EmptyStatement');
                    }, z.parseLabeledStatement = function (e, t, r, n) {
                        for (var i = 0, a = this.labels; i < a.length; i += 1)
                            a[i].name === t && this.raise(r.start, 'Label \'' + t + '\' is already declared');
                        for (var o = this.type.isLoop ? 'loop' : this.type === S._switch ? 'switch' : null, s = this.labels.length - 1; s >= 0; s--) {
                            var c = this.labels[s];
                            if (c.statementStart !== e.start)
                                break;
                            c.statementStart = this.start, c.kind = o;
                        }
                        return this.labels.push({
                            name: t,
                            kind: o,
                            statementStart: this.start
                        }), e.body = this.parseStatement(n ? -1 === n.indexOf('label') ? n + 'label' : n : 'label'), this.labels.pop(), e.label = r, this.finishNode(e, 'LabeledStatement');
                    }, z.parseExpressionStatement = function (e, t) {
                        return e.expression = t, this.semicolon(), this.finishNode(e, 'ExpressionStatement');
                    }, z.parseBlock = function (e, t, r) {
                        for (void 0 === e && (e = !0), void 0 === t && (t = this.startNode()), t.body = [], this.expect(S.braceL), e && this.enterScope(0); this.type !== S.braceR;) {
                            var n = this.parseStatement(null);
                            t.body.push(n);
                        }
                        return r && (this.strict = !1), this.next(), e && this.exitScope(), this.finishNode(t, 'BlockStatement');
                    }, z.parseFor = function (e, t) {
                        return e.init = t, this.expect(S.semi), e.test = this.type === S.semi ? null : this.parseExpression(), this.expect(S.semi), e.update = this.type === S.parenR ? null : this.parseExpression(), this.expect(S.parenR), e.body = this.parseStatement('for'), this.exitScope(), this.labels.pop(), this.finishNode(e, 'ForStatement');
                    }, z.parseForIn = function (e, t) {
                        var r = this.type === S._in;
                        return this.next(), 'VariableDeclaration' === t.type && null != t.declarations[0].init && (!r || this.options.ecmaVersion < 8 || this.strict || 'var' !== t.kind || 'Identifier' !== t.declarations[0].id.type) && this.raise(t.start, (r ? 'for-in' : 'for-of') + ' loop variable declaration may not have an initializer'), e.left = t, e.right = r ? this.parseExpression() : this.parseMaybeAssign(), this.expect(S.parenR), e.body = this.parseStatement('for'), this.exitScope(), this.labels.pop(), this.finishNode(e, r ? 'ForInStatement' : 'ForOfStatement');
                    }, z.parseVar = function (e, t, r) {
                        for (e.declarations = [], e.kind = r;;) {
                            var n = this.startNode();
                            if (this.parseVarId(n, r), this.eat(S.eq) ? n.init = this.parseMaybeAssign(t) : 'const' !== r || this.type === S._in || this.options.ecmaVersion >= 6 && this.isContextual('of') ? 'Identifier' === n.id.type || t && (this.type === S._in || this.isContextual('of')) ? n.init = null : this.raise(this.lastTokEnd, 'Complex binding patterns require an initialization value') : this.unexpected(), e.declarations.push(this.finishNode(n, 'VariableDeclarator')), !this.eat(S.comma))
                                break;
                        }
                        return e;
                    }, z.parseVarId = function (e, t) {
                        e.id = this.parseBindingAtom(), this.checkLValPattern(e.id, 'var' === t ? 1 : 2, !1);
                    };
                    var Z = 1, J = 2;
                    function Q(e, t) {
                        var r = t.key.name, n = e[r], i = 'true';
                        return 'MethodDefinition' !== t.type || 'get' !== t.kind && 'set' !== t.kind || (i = (t.static ? 's' : 'i') + t.kind), 'iget' === n && 'iset' === i || 'iset' === n && 'iget' === i || 'sget' === n && 'sset' === i || 'sset' === n && 'sget' === i ? (e[r] = 'true', !1) : !!n || (e[r] = i, !1);
                    }
                    function ee(e, t) {
                        var r = e.computed, n = e.key;
                        return !r && ('Identifier' === n.type && n.name === t || 'Literal' === n.type && n.value === t);
                    }
                    z.parseFunction = function (e, t, r, n, i) {
                        this.initFunction(e), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !n) && (this.type === S.star && t & J && this.unexpected(), e.generator = this.eat(S.star)), this.options.ecmaVersion >= 8 && (e.async = !!n), t & Z && (e.id = 4 & t && this.type !== S.name ? null : this.parseIdent(), !e.id || t & J || this.checkLValSimple(e.id, this.strict || e.generator || e.async ? this.treatFunctionsAsVar ? 1 : 2 : 3));
                        var a = this.yieldPos, o = this.awaitPos, s = this.awaitIdentPos;
                        return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(G(e.async, e.generator)), t & Z || (e.id = this.type === S.name ? this.parseIdent() : null), this.parseFunctionParams(e), this.parseFunctionBody(e, r, !1, i), this.yieldPos = a, this.awaitPos = o, this.awaitIdentPos = s, this.finishNode(e, t & Z ? 'FunctionDeclaration' : 'FunctionExpression');
                    }, z.parseFunctionParams = function (e) {
                        this.expect(S.parenL), e.params = this.parseBindingList(S.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
                    }, z.parseClass = function (e, t) {
                        this.next();
                        var r = this.strict;
                        this.strict = !0, this.parseClassId(e, t), this.parseClassSuper(e);
                        var n = this.enterClassBody(), i = this.startNode(), a = !1;
                        for (i.body = [], this.expect(S.braceL); this.type !== S.braceR;) {
                            var o = this.parseClassElement(null !== e.superClass);
                            o && (i.body.push(o), 'MethodDefinition' === o.type && 'constructor' === o.kind ? (a && this.raise(o.start, 'Duplicate constructor in the same class'), a = !0) : o.key && 'PrivateIdentifier' === o.key.type && Q(n, o) && this.raiseRecoverable(o.key.start, 'Identifier \'#' + o.key.name + '\' has already been declared'));
                        }
                        return this.strict = r, this.next(), e.body = this.finishNode(i, 'ClassBody'), this.exitClassBody(), this.finishNode(e, t ? 'ClassDeclaration' : 'ClassExpression');
                    }, z.parseClassElement = function (e) {
                        if (this.eat(S.semi))
                            return null;
                        var t = this.options.ecmaVersion, r = this.startNode(), n = '', i = !1, a = !1, o = 'method', s = !1;
                        if (this.eatContextual('static')) {
                            if (t >= 13 && this.eat(S.braceL))
                                return this.parseClassStaticBlock(r), r;
                            this.isClassElementNameStart() || this.type === S.star ? s = !0 : n = 'static';
                        }
                        if (r.static = s, !n && t >= 8 && this.eatContextual('async') && (!this.isClassElementNameStart() && this.type !== S.star || this.canInsertSemicolon() ? n = 'async' : a = !0), !n && (t >= 9 || !a) && this.eat(S.star) && (i = !0), !n && !a && !i) {
                            var c = this.value;
                            (this.eatContextual('get') || this.eatContextual('set')) && (this.isClassElementNameStart() ? o = c : n = c);
                        }
                        if (n ? (r.computed = !1, r.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), r.key.name = n, this.finishNode(r.key, 'Identifier')) : this.parseClassElementName(r), t < 13 || this.type === S.parenL || 'method' !== o || i || a) {
                            var u = !r.static && ee(r, 'constructor'), l = u && e;
                            u && 'method' !== o && this.raise(r.key.start, 'Constructor can\'t have get/set modifier'), r.kind = u ? 'constructor' : o, this.parseClassMethod(r, i, a, l);
                        } else
                            this.parseClassField(r);
                        return r;
                    }, z.isClassElementNameStart = function () {
                        return this.type === S.name || this.type === S.privateId || this.type === S.num || this.type === S.string || this.type === S.bracketL || this.type.keyword;
                    }, z.parseClassElementName = function (e) {
                        this.type === S.privateId ? ('constructor' === this.value && this.raise(this.start, 'Classes can\'t have an element named \'#constructor\''), e.computed = !1, e.key = this.parsePrivateIdent()) : this.parsePropertyName(e);
                    }, z.parseClassMethod = function (e, t, r, n) {
                        var i = e.key;
                        'constructor' === e.kind ? (t && this.raise(i.start, 'Constructor can\'t be a generator'), r && this.raise(i.start, 'Constructor can\'t be an async method')) : e.static && ee(e, 'prototype') && this.raise(i.start, 'Classes may not have a static property named prototype');
                        var a = e.value = this.parseMethod(t, r, n);
                        return 'get' === e.kind && 0 !== a.params.length && this.raiseRecoverable(a.start, 'getter should have no params'), 'set' === e.kind && 1 !== a.params.length && this.raiseRecoverable(a.start, 'setter should have exactly one param'), 'set' === e.kind && 'RestElement' === a.params[0].type && this.raiseRecoverable(a.params[0].start, 'Setter cannot use rest params'), this.finishNode(e, 'MethodDefinition');
                    }, z.parseClassField = function (e) {
                        if (ee(e, 'constructor') ? this.raise(e.key.start, 'Classes can\'t have a field named \'constructor\'') : e.static && ee(e, 'prototype') && this.raise(e.key.start, 'Classes can\'t have a static field named \'prototype\''), this.eat(S.eq)) {
                            var t = this.currentThisScope(), r = t.inClassFieldInit;
                            t.inClassFieldInit = !0, e.value = this.parseMaybeAssign(), t.inClassFieldInit = r;
                        } else
                            e.value = null;
                        return this.semicolon(), this.finishNode(e, 'PropertyDefinition');
                    }, z.parseClassStaticBlock = function (e) {
                        e.body = [];
                        var t = this.labels;
                        for (this.labels = [], this.enterScope(320); this.type !== S.braceR;) {
                            var r = this.parseStatement(null);
                            e.body.push(r);
                        }
                        return this.next(), this.exitScope(), this.labels = t, this.finishNode(e, 'StaticBlock');
                    }, z.parseClassId = function (e, t) {
                        this.type === S.name ? (e.id = this.parseIdent(), t && this.checkLValSimple(e.id, 2, !1)) : (!0 === t && this.unexpected(), e.id = null);
                    }, z.parseClassSuper = function (e) {
                        e.superClass = this.eat(S._extends) ? this.parseExprSubscripts(null, !1) : null;
                    }, z.enterClassBody = function () {
                        var e = {
                            declared: Object.create(null),
                            used: []
                        };
                        return this.privateNameStack.push(e), e.declared;
                    }, z.exitClassBody = function () {
                        for (var e = this.privateNameStack.pop(), t = e.declared, r = e.used, n = this.privateNameStack.length, i = 0 === n ? null : this.privateNameStack[n - 1], a = 0; a < r.length; ++a) {
                            var o = r[a];
                            O(t, o.name) || (i ? i.used.push(o) : this.raiseRecoverable(o.start, 'Private field \'#' + o.name + '\' must be declared in an enclosing class'));
                        }
                    }, z.parseExport = function (e, t) {
                        if (this.next(), this.eat(S.star))
                            return this.options.ecmaVersion >= 11 && (this.eatContextual('as') ? (e.exported = this.parseModuleExportName(), this.checkExport(t, e.exported, this.lastTokStart)) : e.exported = null), this.expectContextual('from'), this.type !== S.string && this.unexpected(), e.source = this.parseExprAtom(), this.semicolon(), this.finishNode(e, 'ExportAllDeclaration');
                        if (this.eat(S._default)) {
                            var r;
                            if (this.checkExport(t, 'default', this.lastTokStart), this.type === S._function || (r = this.isAsyncFunction())) {
                                var n = this.startNode();
                                this.next(), r && this.next(), e.declaration = this.parseFunction(n, 4 | Z, !1, r);
                            } else if (this.type === S._class) {
                                var i = this.startNode();
                                e.declaration = this.parseClass(i, 'nullableID');
                            } else
                                e.declaration = this.parseMaybeAssign(), this.semicolon();
                            return this.finishNode(e, 'ExportDefaultDeclaration');
                        }
                        if (this.shouldParseExportStatement())
                            e.declaration = this.parseStatement(null), 'VariableDeclaration' === e.declaration.type ? this.checkVariableExport(t, e.declaration.declarations) : this.checkExport(t, e.declaration.id, e.declaration.id.start), e.specifiers = [], e.source = null;
                        else {
                            if (e.declaration = null, e.specifiers = this.parseExportSpecifiers(t), this.eatContextual('from'))
                                this.type !== S.string && this.unexpected(), e.source = this.parseExprAtom();
                            else {
                                for (var a = 0, o = e.specifiers; a < o.length; a += 1) {
                                    var s = o[a];
                                    this.checkUnreserved(s.local), this.checkLocalExport(s.local), 'Literal' === s.local.type && this.raise(s.local.start, 'A string literal cannot be used as an exported binding without `from`.');
                                }
                                e.source = null;
                            }
                            this.semicolon();
                        }
                        return this.finishNode(e, 'ExportNamedDeclaration');
                    }, z.checkExport = function (e, t, r) {
                        e && ('string' != typeof t && (t = 'Identifier' === t.type ? t.name : t.value), O(e, t) && this.raiseRecoverable(r, 'Duplicate export \'' + t + '\''), e[t] = !0);
                    }, z.checkPatternExport = function (e, t) {
                        var r = t.type;
                        if ('Identifier' === r)
                            this.checkExport(e, t, t.start);
                        else if ('ObjectPattern' === r)
                            for (var n = 0, i = t.properties; n < i.length; n += 1) {
                                var a = i[n];
                                this.checkPatternExport(e, a);
                            }
                        else if ('ArrayPattern' === r)
                            for (var o = 0, s = t.elements; o < s.length; o += 1) {
                                var c = s[o];
                                c && this.checkPatternExport(e, c);
                            }
                        else
                            'Property' === r ? this.checkPatternExport(e, t.value) : 'AssignmentPattern' === r ? this.checkPatternExport(e, t.left) : 'RestElement' === r ? this.checkPatternExport(e, t.argument) : 'ParenthesizedExpression' === r && this.checkPatternExport(e, t.expression);
                    }, z.checkVariableExport = function (e, t) {
                        if (e)
                            for (var r = 0, n = t; r < n.length; r += 1) {
                                var i = n[r];
                                this.checkPatternExport(e, i.id);
                            }
                    }, z.shouldParseExportStatement = function () {
                        return 'var' === this.type.keyword || 'const' === this.type.keyword || 'class' === this.type.keyword || 'function' === this.type.keyword || this.isLet() || this.isAsyncFunction();
                    }, z.parseExportSpecifiers = function (e) {
                        var t = [], r = !0;
                        for (this.expect(S.braceL); !this.eat(S.braceR);) {
                            if (r)
                                r = !1;
                            else if (this.expect(S.comma), this.afterTrailingComma(S.braceR))
                                break;
                            var n = this.startNode();
                            n.local = this.parseModuleExportName(), n.exported = this.eatContextual('as') ? this.parseModuleExportName() : n.local, this.checkExport(e, n.exported, n.exported.start), t.push(this.finishNode(n, 'ExportSpecifier'));
                        }
                        return t;
                    }, z.parseImport = function (e) {
                        return this.next(), this.type === S.string ? (e.specifiers = q, e.source = this.parseExprAtom()) : (e.specifiers = this.parseImportSpecifiers(), this.expectContextual('from'), e.source = this.type === S.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(e, 'ImportDeclaration');
                    }, z.parseImportSpecifiers = function () {
                        var e = [], t = !0;
                        if (this.type === S.name) {
                            var r = this.startNode();
                            if (r.local = this.parseIdent(), this.checkLValSimple(r.local, 2), e.push(this.finishNode(r, 'ImportDefaultSpecifier')), !this.eat(S.comma))
                                return e;
                        }
                        if (this.type === S.star) {
                            var n = this.startNode();
                            return this.next(), this.expectContextual('as'), n.local = this.parseIdent(), this.checkLValSimple(n.local, 2), e.push(this.finishNode(n, 'ImportNamespaceSpecifier')), e;
                        }
                        for (this.expect(S.braceL); !this.eat(S.braceR);) {
                            if (t)
                                t = !1;
                            else if (this.expect(S.comma), this.afterTrailingComma(S.braceR))
                                break;
                            var i = this.startNode();
                            i.imported = this.parseModuleExportName(), this.eatContextual('as') ? i.local = this.parseIdent() : (this.checkUnreserved(i.imported), i.local = i.imported), this.checkLValSimple(i.local, 2), e.push(this.finishNode(i, 'ImportSpecifier'));
                        }
                        return e;
                    }, z.parseModuleExportName = function () {
                        if (this.options.ecmaVersion >= 13 && this.type === S.string) {
                            var e = this.parseLiteral(this.value);
                            return P.test(e.value) && this.raise(e.start, 'An export name cannot include a lone surrogate.'), e;
                        }
                        return this.parseIdent(!0);
                    }, z.adaptDirectivePrologue = function (e) {
                        for (var t = 0; t < e.length && this.isDirectiveCandidate(e[t]); ++t)
                            e[t].directive = e[t].expression.raw.slice(1, -1);
                    }, z.isDirectiveCandidate = function (e) {
                        return this.options.ecmaVersion >= 5 && 'ExpressionStatement' === e.type && 'Literal' === e.expression.type && 'string' == typeof e.expression.value && ('"' === this.input[e.start] || '\'' === this.input[e.start]);
                    };
                    var te = V.prototype;
                    te.toAssignable = function (e, t, r) {
                        if (this.options.ecmaVersion >= 6 && e)
                            switch (e.type) {
                            case 'Identifier':
                                this.inAsync && 'await' === e.name && this.raise(e.start, 'Cannot use \'await\' as identifier inside an async function');
                                break;
                            case 'ObjectPattern':
                            case 'ArrayPattern':
                            case 'AssignmentPattern':
                            case 'RestElement':
                                break;
                            case 'ObjectExpression':
                                e.type = 'ObjectPattern', r && this.checkPatternErrors(r, !0);
                                for (var n = 0, i = e.properties; n < i.length; n += 1) {
                                    var a = i[n];
                                    this.toAssignable(a, t), 'RestElement' !== a.type || 'ArrayPattern' !== a.argument.type && 'ObjectPattern' !== a.argument.type || this.raise(a.argument.start, 'Unexpected token');
                                }
                                break;
                            case 'Property':
                                'init' !== e.kind && this.raise(e.key.start, 'Object pattern can\'t contain getter or setter'), this.toAssignable(e.value, t);
                                break;
                            case 'ArrayExpression':
                                e.type = 'ArrayPattern', r && this.checkPatternErrors(r, !0), this.toAssignableList(e.elements, t);
                                break;
                            case 'SpreadElement':
                                e.type = 'RestElement', this.toAssignable(e.argument, t), 'AssignmentPattern' === e.argument.type && this.raise(e.argument.start, 'Rest elements cannot have a default value');
                                break;
                            case 'AssignmentExpression':
                                '=' !== e.operator && this.raise(e.left.end, 'Only \'=\' operator can be used for specifying default value.'), e.type = 'AssignmentPattern', delete e.operator, this.toAssignable(e.left, t);
                                break;
                            case 'ParenthesizedExpression':
                                this.toAssignable(e.expression, t, r);
                                break;
                            case 'ChainExpression':
                                this.raiseRecoverable(e.start, 'Optional chaining cannot appear in left-hand side');
                                break;
                            case 'MemberExpression':
                                if (!t)
                                    break;
                            default:
                                this.raise(e.start, 'Assigning to rvalue');
                            }
                        else
                            r && this.checkPatternErrors(r, !0);
                        return e;
                    }, te.toAssignableList = function (e, t) {
                        for (var r = e.length, n = 0; n < r; n++) {
                            var i = e[n];
                            i && this.toAssignable(i, t);
                        }
                        if (r) {
                            var a = e[r - 1];
                            6 === this.options.ecmaVersion && t && a && 'RestElement' === a.type && 'Identifier' !== a.argument.type && this.unexpected(a.argument.start);
                        }
                        return e;
                    }, te.parseSpread = function (e) {
                        var t = this.startNode();
                        return this.next(), t.argument = this.parseMaybeAssign(!1, e), this.finishNode(t, 'SpreadElement');
                    }, te.parseRestBinding = function () {
                        var e = this.startNode();
                        return this.next(), 6 === this.options.ecmaVersion && this.type !== S.name && this.unexpected(), e.argument = this.parseBindingAtom(), this.finishNode(e, 'RestElement');
                    }, te.parseBindingAtom = function () {
                        if (this.options.ecmaVersion >= 6)
                            switch (this.type) {
                            case S.bracketL:
                                var e = this.startNode();
                                return this.next(), e.elements = this.parseBindingList(S.bracketR, !0, !0), this.finishNode(e, 'ArrayPattern');
                            case S.braceL:
                                return this.parseObj(!0);
                            }
                        return this.parseIdent();
                    }, te.parseBindingList = function (e, t, r) {
                        for (var n = [], i = !0; !this.eat(e);)
                            if (i ? i = !1 : this.expect(S.comma), t && this.type === S.comma)
                                n.push(null);
                            else {
                                if (r && this.afterTrailingComma(e))
                                    break;
                                if (this.type === S.ellipsis) {
                                    var a = this.parseRestBinding();
                                    this.parseBindingListItem(a), n.push(a), this.type === S.comma && this.raise(this.start, 'Comma is not permitted after the rest element'), this.expect(e);
                                    break;
                                }
                                var o = this.parseMaybeDefault(this.start, this.startLoc);
                                this.parseBindingListItem(o), n.push(o);
                            }
                        return n;
                    }, te.parseBindingListItem = function (e) {
                        return e;
                    }, te.parseMaybeDefault = function (e, t, r) {
                        if (r = r || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(S.eq))
                            return r;
                        var n = this.startNodeAt(e, t);
                        return n.left = r, n.right = this.parseMaybeAssign(), this.finishNode(n, 'AssignmentPattern');
                    }, te.checkLValSimple = function (e, t, r) {
                        void 0 === t && (t = 0);
                        var n = 0 !== t;
                        switch (e.type) {
                        case 'Identifier':
                            this.strict && this.reservedWordsStrictBind.test(e.name) && this.raiseRecoverable(e.start, (n ? 'Binding ' : 'Assigning to ') + e.name + ' in strict mode'), n && (2 === t && 'let' === e.name && this.raiseRecoverable(e.start, 'let is disallowed as a lexically bound name'), r && (O(r, e.name) && this.raiseRecoverable(e.start, 'Argument name clash'), r[e.name] = !0), 5 !== t && this.declareName(e.name, t, e.start));
                            break;
                        case 'ChainExpression':
                            this.raiseRecoverable(e.start, 'Optional chaining cannot appear in left-hand side');
                            break;
                        case 'MemberExpression':
                            n && this.raiseRecoverable(e.start, 'Binding member expression');
                            break;
                        case 'ParenthesizedExpression':
                            return n && this.raiseRecoverable(e.start, 'Binding parenthesized expression'), this.checkLValSimple(e.expression, t, r);
                        default:
                            this.raise(e.start, (n ? 'Binding' : 'Assigning to') + ' rvalue');
                        }
                    }, te.checkLValPattern = function (e, t, r) {
                        switch (void 0 === t && (t = 0), e.type) {
                        case 'ObjectPattern':
                            for (var n = 0, i = e.properties; n < i.length; n += 1) {
                                var a = i[n];
                                this.checkLValInnerPattern(a, t, r);
                            }
                            break;
                        case 'ArrayPattern':
                            for (var o = 0, s = e.elements; o < s.length; o += 1) {
                                var c = s[o];
                                c && this.checkLValInnerPattern(c, t, r);
                            }
                            break;
                        default:
                            this.checkLValSimple(e, t, r);
                        }
                    }, te.checkLValInnerPattern = function (e, t, r) {
                        switch (void 0 === t && (t = 0), e.type) {
                        case 'Property':
                            this.checkLValInnerPattern(e.value, t, r);
                            break;
                        case 'AssignmentPattern':
                            this.checkLValPattern(e.left, t, r);
                            break;
                        case 'RestElement':
                            this.checkLValPattern(e.argument, t, r);
                            break;
                        default:
                            this.checkLValPattern(e, t, r);
                        }
                    };
                    var re = function (e, t, r, n, i) {
                            this.token = e, this.isExpr = !!t, this.preserveSpace = !!r, this.override = n, this.generator = !!i;
                        }, ne = {
                            b_stat: new re('{', !1),
                            b_expr: new re('{', !0),
                            b_tmpl: new re('${', !1),
                            p_stat: new re('(', !1),
                            p_expr: new re('(', !0),
                            q_tmpl: new re('`', !0, !0, function (e) {
                                return e.tryReadTemplateToken();
                            }),
                            f_stat: new re('function', !1),
                            f_expr: new re('function', !0),
                            f_expr_gen: new re('function', !0, !1, null, !0),
                            f_gen: new re('function', !1, !1, null, !0)
                        }, ie = V.prototype;
                    ie.initialContext = function () {
                        return [ne.b_stat];
                    }, ie.curContext = function () {
                        return this.context[this.context.length - 1];
                    }, ie.braceIsBlock = function (e) {
                        var t = this.curContext();
                        return t === ne.f_expr || t === ne.f_stat || (e !== S.colon || t !== ne.b_stat && t !== ne.b_expr ? e === S._return || e === S.name && this.exprAllowed ? v.test(this.input.slice(this.lastTokEnd, this.start)) : e === S._else || e === S.semi || e === S.eof || e === S.parenR || e === S.arrow || (e === S.braceL ? t === ne.b_stat : e !== S._var && e !== S._const && e !== S.name && !this.exprAllowed) : !t.isExpr);
                    }, ie.inGeneratorContext = function () {
                        for (var e = this.context.length - 1; e >= 1; e--) {
                            var t = this.context[e];
                            if ('function' === t.token)
                                return t.generator;
                        }
                        return !1;
                    }, ie.updateContext = function (e) {
                        var t, r = this.type;
                        r.keyword && e === S.dot ? this.exprAllowed = !1 : (t = r.updateContext) ? t.call(this, e) : this.exprAllowed = r.beforeExpr;
                    }, ie.overrideContext = function (e) {
                        this.curContext() !== e && (this.context[this.context.length - 1] = e);
                    }, S.parenR.updateContext = S.braceR.updateContext = function () {
                        if (1 !== this.context.length) {
                            var e = this.context.pop();
                            e === ne.b_stat && 'function' === this.curContext().token && (e = this.context.pop()), this.exprAllowed = !e.isExpr;
                        } else
                            this.exprAllowed = !0;
                    }, S.braceL.updateContext = function (e) {
                        this.context.push(this.braceIsBlock(e) ? ne.b_stat : ne.b_expr), this.exprAllowed = !0;
                    }, S.dollarBraceL.updateContext = function () {
                        this.context.push(ne.b_tmpl), this.exprAllowed = !0;
                    }, S.parenL.updateContext = function (e) {
                        var t = e === S._if || e === S._for || e === S._with || e === S._while;
                        this.context.push(t ? ne.p_stat : ne.p_expr), this.exprAllowed = !0;
                    }, S.incDec.updateContext = function () {
                    }, S._function.updateContext = S._class.updateContext = function (e) {
                        !e.beforeExpr || e === S._else || e === S.semi && this.curContext() !== ne.p_stat || e === S._return && v.test(this.input.slice(this.lastTokEnd, this.start)) || (e === S.colon || e === S.braceL) && this.curContext() === ne.b_stat ? this.context.push(ne.f_stat) : this.context.push(ne.f_expr), this.exprAllowed = !1;
                    }, S.backQuote.updateContext = function () {
                        this.curContext() === ne.q_tmpl ? this.context.pop() : this.context.push(ne.q_tmpl), this.exprAllowed = !1;
                    }, S.star.updateContext = function (e) {
                        if (e === S._function) {
                            var t = this.context.length - 1;
                            this.context[t] === ne.f_expr ? this.context[t] = ne.f_expr_gen : this.context[t] = ne.f_gen;
                        }
                        this.exprAllowed = !0;
                    }, S.name.updateContext = function (e) {
                        var t = !1;
                        this.options.ecmaVersion >= 6 && e !== S.dot && ('of' === this.value && !this.exprAllowed || 'yield' === this.value && this.inGeneratorContext()) && (t = !0), this.exprAllowed = t;
                    };
                    var ae = V.prototype;
                    function oe(e) {
                        return 'MemberExpression' === e.type && 'PrivateIdentifier' === e.property.type || 'ChainExpression' === e.type && oe(e.expression);
                    }
                    ae.checkPropClash = function (e, t, r) {
                        if (!(this.options.ecmaVersion >= 9 && 'SpreadElement' === e.type || this.options.ecmaVersion >= 6 && (e.computed || e.method || e.shorthand))) {
                            var n, i = e.key;
                            switch (i.type) {
                            case 'Identifier':
                                n = i.name;
                                break;
                            case 'Literal':
                                n = String(i.value);
                                break;
                            default:
                                return;
                            }
                            var a = e.kind;
                            if (this.options.ecmaVersion >= 6)
                                '__proto__' === n && 'init' === a && (t.proto && (r ? r.doubleProto < 0 && (r.doubleProto = i.start) : this.raiseRecoverable(i.start, 'Redefinition of __proto__ property')), t.proto = !0);
                            else {
                                var o = t[n = '$' + n];
                                o ? ('init' === a ? this.strict && o.init || o.get || o.set : o.init || o[a]) && this.raiseRecoverable(i.start, 'Redefinition of property') : o = t[n] = {
                                    init: !1,
                                    get: !1,
                                    set: !1
                                }, o[a] = !0;
                            }
                        }
                    }, ae.parseExpression = function (e, t) {
                        var r = this.start, n = this.startLoc, i = this.parseMaybeAssign(e, t);
                        if (this.type === S.comma) {
                            var a = this.startNodeAt(r, n);
                            for (a.expressions = [i]; this.eat(S.comma);)
                                a.expressions.push(this.parseMaybeAssign(e, t));
                            return this.finishNode(a, 'SequenceExpression');
                        }
                        return i;
                    }, ae.parseMaybeAssign = function (e, t, r) {
                        if (this.isContextual('yield')) {
                            if (this.inGenerator)
                                return this.parseYield(e);
                            this.exprAllowed = !1;
                        }
                        var n = !1, i = -1, a = -1, o = -1;
                        t ? (i = t.parenthesizedAssign, a = t.trailingComma, o = t.doubleProto, t.parenthesizedAssign = t.trailingComma = -1) : (t = new K(), n = !0);
                        var s = this.start, c = this.startLoc;
                        this.type !== S.parenL && this.type !== S.name || (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = 'await' === e);
                        var u = this.parseMaybeConditional(e, t);
                        if (r && (u = r.call(this, u, s, c)), this.type.isAssign) {
                            var l = this.startNodeAt(s, c);
                            return l.operator = this.value, this.type === S.eq && (u = this.toAssignable(u, !1, t)), n || (t.parenthesizedAssign = t.trailingComma = t.doubleProto = -1), t.shorthandAssign >= u.start && (t.shorthandAssign = -1), this.type === S.eq ? this.checkLValPattern(u) : this.checkLValSimple(u), l.left = u, this.next(), l.right = this.parseMaybeAssign(e), o > -1 && (t.doubleProto = o), this.finishNode(l, 'AssignmentExpression');
                        }
                        return n && this.checkExpressionErrors(t, !0), i > -1 && (t.parenthesizedAssign = i), a > -1 && (t.trailingComma = a), u;
                    }, ae.parseMaybeConditional = function (e, t) {
                        var r = this.start, n = this.startLoc, i = this.parseExprOps(e, t);
                        if (this.checkExpressionErrors(t))
                            return i;
                        if (this.eat(S.question)) {
                            var a = this.startNodeAt(r, n);
                            return a.test = i, a.consequent = this.parseMaybeAssign(), this.expect(S.colon), a.alternate = this.parseMaybeAssign(e), this.finishNode(a, 'ConditionalExpression');
                        }
                        return i;
                    }, ae.parseExprOps = function (e, t) {
                        var r = this.start, n = this.startLoc, i = this.parseMaybeUnary(t, !1, !1, e);
                        return this.checkExpressionErrors(t) || i.start === r && 'ArrowFunctionExpression' === i.type ? i : this.parseExprOp(i, r, n, -1, e);
                    }, ae.parseExprOp = function (e, t, r, n, i) {
                        var a = this.type.binop;
                        if (null != a && (!i || this.type !== S._in) && a > n) {
                            var o = this.type === S.logicalOR || this.type === S.logicalAND, s = this.type === S.coalesce;
                            s && (a = S.logicalAND.binop);
                            var c = this.value;
                            this.next();
                            var u = this.start, l = this.startLoc, d = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, i), u, l, a, i), p = this.buildBinary(t, r, e, d, c, o || s);
                            return (o && this.type === S.coalesce || s && (this.type === S.logicalOR || this.type === S.logicalAND)) && this.raiseRecoverable(this.start, 'Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses'), this.parseExprOp(p, t, r, n, i);
                        }
                        return e;
                    }, ae.buildBinary = function (e, t, r, n, i, a) {
                        'PrivateIdentifier' === n.type && this.raise(n.start, 'Private identifier can only be left side of binary expression');
                        var o = this.startNodeAt(e, t);
                        return o.left = r, o.operator = i, o.right = n, this.finishNode(o, a ? 'LogicalExpression' : 'BinaryExpression');
                    }, ae.parseMaybeUnary = function (e, t, r, n) {
                        var i, a = this.start, o = this.startLoc;
                        if (this.isContextual('await') && this.canAwait)
                            i = this.parseAwait(n), t = !0;
                        else if (this.type.prefix) {
                            var s = this.startNode(), c = this.type === S.incDec;
                            s.operator = this.value, s.prefix = !0, this.next(), s.argument = this.parseMaybeUnary(null, !0, c, n), this.checkExpressionErrors(e, !0), c ? this.checkLValSimple(s.argument) : this.strict && 'delete' === s.operator && 'Identifier' === s.argument.type ? this.raiseRecoverable(s.start, 'Deleting local variable in strict mode') : 'delete' === s.operator && oe(s.argument) ? this.raiseRecoverable(s.start, 'Private fields can not be deleted') : t = !0, i = this.finishNode(s, c ? 'UpdateExpression' : 'UnaryExpression');
                        } else if (t || this.type !== S.privateId) {
                            if (i = this.parseExprSubscripts(e, n), this.checkExpressionErrors(e))
                                return i;
                            for (; this.type.postfix && !this.canInsertSemicolon();) {
                                var u = this.startNodeAt(a, o);
                                u.operator = this.value, u.prefix = !1, u.argument = i, this.checkLValSimple(i), this.next(), i = this.finishNode(u, 'UpdateExpression');
                            }
                        } else
                            (n || 0 === this.privateNameStack.length) && this.unexpected(), i = this.parsePrivateIdent(), this.type !== S._in && this.unexpected();
                        return r || !this.eat(S.starstar) ? i : t ? void this.unexpected(this.lastTokStart) : this.buildBinary(a, o, i, this.parseMaybeUnary(null, !1, !1, n), '**', !1);
                    }, ae.parseExprSubscripts = function (e, t) {
                        var r = this.start, n = this.startLoc, i = this.parseExprAtom(e, t);
                        if ('ArrowFunctionExpression' === i.type && ')' !== this.input.slice(this.lastTokStart, this.lastTokEnd))
                            return i;
                        var a = this.parseSubscripts(i, r, n, !1, t);
                        return e && 'MemberExpression' === a.type && (e.parenthesizedAssign >= a.start && (e.parenthesizedAssign = -1), e.parenthesizedBind >= a.start && (e.parenthesizedBind = -1), e.trailingComma >= a.start && (e.trailingComma = -1)), a;
                    }, ae.parseSubscripts = function (e, t, r, n, i) {
                        for (var a = this.options.ecmaVersion >= 8 && 'Identifier' === e.type && 'async' === e.name && this.lastTokEnd === e.end && !this.canInsertSemicolon() && e.end - e.start == 5 && this.potentialArrowAt === e.start, o = !1;;) {
                            var s = this.parseSubscript(e, t, r, n, a, o, i);
                            if (s.optional && (o = !0), s === e || 'ArrowFunctionExpression' === s.type) {
                                if (o) {
                                    var c = this.startNodeAt(t, r);
                                    c.expression = s, s = this.finishNode(c, 'ChainExpression');
                                }
                                return s;
                            }
                            e = s;
                        }
                    }, ae.parseSubscript = function (e, t, r, n, i, a, o) {
                        var s = this.options.ecmaVersion >= 11, c = s && this.eat(S.questionDot);
                        n && c && this.raise(this.lastTokStart, 'Optional chaining cannot appear in the callee of new expressions');
                        var u = this.eat(S.bracketL);
                        if (u || c && this.type !== S.parenL && this.type !== S.backQuote || this.eat(S.dot)) {
                            var l = this.startNodeAt(t, r);
                            l.object = e, u ? (l.property = this.parseExpression(), this.expect(S.bracketR)) : this.type === S.privateId && 'Super' !== e.type ? l.property = this.parsePrivateIdent() : l.property = this.parseIdent('never' !== this.options.allowReserved), l.computed = !!u, s && (l.optional = c), e = this.finishNode(l, 'MemberExpression');
                        } else if (!n && this.eat(S.parenL)) {
                            var d = new K(), p = this.yieldPos, f = this.awaitPos, m = this.awaitIdentPos;
                            this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
                            var h = this.parseExprList(S.parenR, this.options.ecmaVersion >= 8, !1, d);
                            if (i && !c && !this.canInsertSemicolon() && this.eat(S.arrow))
                                return this.checkPatternErrors(d, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, 'Cannot use \'await\' as identifier inside an async function'), this.yieldPos = p, this.awaitPos = f, this.awaitIdentPos = m, this.parseArrowExpression(this.startNodeAt(t, r), h, !0, o);
                            this.checkExpressionErrors(d, !0), this.yieldPos = p || this.yieldPos, this.awaitPos = f || this.awaitPos, this.awaitIdentPos = m || this.awaitIdentPos;
                            var g = this.startNodeAt(t, r);
                            g.callee = e, g.arguments = h, s && (g.optional = c), e = this.finishNode(g, 'CallExpression');
                        } else if (this.type === S.backQuote) {
                            (c || a) && this.raise(this.start, 'Optional chaining cannot appear in the tag of tagged template expressions');
                            var y = this.startNodeAt(t, r);
                            y.tag = e, y.quasi = this.parseTemplate({ isTagged: !0 }), e = this.finishNode(y, 'TaggedTemplateExpression');
                        }
                        return e;
                    }, ae.parseExprAtom = function (e, t) {
                        this.type === S.slash && this.readRegexp();
                        var r, n = this.potentialArrowAt === this.start;
                        switch (this.type) {
                        case S._super:
                            return this.allowSuper || this.raise(this.start, '\'super\' keyword outside a method'), r = this.startNode(), this.next(), this.type !== S.parenL || this.allowDirectSuper || this.raise(r.start, 'super() call outside constructor of a subclass'), this.type !== S.dot && this.type !== S.bracketL && this.type !== S.parenL && this.unexpected(), this.finishNode(r, 'Super');
                        case S._this:
                            return r = this.startNode(), this.next(), this.finishNode(r, 'ThisExpression');
                        case S.name:
                            var i = this.start, a = this.startLoc, o = this.containsEsc, s = this.parseIdent(!1);
                            if (this.options.ecmaVersion >= 8 && !o && 'async' === s.name && !this.canInsertSemicolon() && this.eat(S._function))
                                return this.overrideContext(ne.f_expr), this.parseFunction(this.startNodeAt(i, a), 0, !1, !0, t);
                            if (n && !this.canInsertSemicolon()) {
                                if (this.eat(S.arrow))
                                    return this.parseArrowExpression(this.startNodeAt(i, a), [s], !1, t);
                                if (this.options.ecmaVersion >= 8 && 'async' === s.name && this.type === S.name && !o && (!this.potentialArrowInForAwait || 'of' !== this.value || this.containsEsc))
                                    return s = this.parseIdent(!1), !this.canInsertSemicolon() && this.eat(S.arrow) || this.unexpected(), this.parseArrowExpression(this.startNodeAt(i, a), [s], !0, t);
                            }
                            return s;
                        case S.regexp:
                            var c = this.value;
                            return (r = this.parseLiteral(c.value)).regex = {
                                pattern: c.pattern,
                                flags: c.flags
                            }, r;
                        case S.num:
                        case S.string:
                            return this.parseLiteral(this.value);
                        case S._null:
                        case S._true:
                        case S._false:
                            return (r = this.startNode()).value = this.type === S._null ? null : this.type === S._true, r.raw = this.type.keyword, this.next(), this.finishNode(r, 'Literal');
                        case S.parenL:
                            var u = this.start, l = this.parseParenAndDistinguishExpression(n, t);
                            return e && (e.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(l) && (e.parenthesizedAssign = u), e.parenthesizedBind < 0 && (e.parenthesizedBind = u)), l;
                        case S.bracketL:
                            return r = this.startNode(), this.next(), r.elements = this.parseExprList(S.bracketR, !0, !0, e), this.finishNode(r, 'ArrayExpression');
                        case S.braceL:
                            return this.overrideContext(ne.b_expr), this.parseObj(!1, e);
                        case S._function:
                            return r = this.startNode(), this.next(), this.parseFunction(r, 0);
                        case S._class:
                            return this.parseClass(this.startNode(), !1);
                        case S._new:
                            return this.parseNew();
                        case S.backQuote:
                            return this.parseTemplate();
                        case S._import:
                            return this.options.ecmaVersion >= 11 ? this.parseExprImport() : this.unexpected();
                        default:
                            this.unexpected();
                        }
                    }, ae.parseExprImport = function () {
                        var e = this.startNode();
                        this.containsEsc && this.raiseRecoverable(this.start, 'Escape sequence in keyword import');
                        var t = this.parseIdent(!0);
                        switch (this.type) {
                        case S.parenL:
                            return this.parseDynamicImport(e);
                        case S.dot:
                            return e.meta = t, this.parseImportMeta(e);
                        default:
                            this.unexpected();
                        }
                    }, ae.parseDynamicImport = function (e) {
                        if (this.next(), e.source = this.parseMaybeAssign(), !this.eat(S.parenR)) {
                            var t = this.start;
                            this.eat(S.comma) && this.eat(S.parenR) ? this.raiseRecoverable(t, 'Trailing comma is not allowed in import()') : this.unexpected(t);
                        }
                        return this.finishNode(e, 'ImportExpression');
                    }, ae.parseImportMeta = function (e) {
                        this.next();
                        var t = this.containsEsc;
                        return e.property = this.parseIdent(!0), 'meta' !== e.property.name && this.raiseRecoverable(e.property.start, 'The only valid meta property for import is \'import.meta\''), t && this.raiseRecoverable(e.start, '\'import.meta\' must not contain escaped characters'), 'module' === this.options.sourceType || this.options.allowImportExportEverywhere || this.raiseRecoverable(e.start, 'Cannot use \'import.meta\' outside a module'), this.finishNode(e, 'MetaProperty');
                    }, ae.parseLiteral = function (e) {
                        var t = this.startNode();
                        return t.value = e, t.raw = this.input.slice(this.start, this.end), 110 === t.raw.charCodeAt(t.raw.length - 1) && (t.bigint = t.raw.slice(0, -1).replace(/_/g, '')), this.next(), this.finishNode(t, 'Literal');
                    }, ae.parseParenExpression = function () {
                        this.expect(S.parenL);
                        var e = this.parseExpression();
                        return this.expect(S.parenR), e;
                    }, ae.parseParenAndDistinguishExpression = function (e, t) {
                        var r, n = this.start, i = this.startLoc, a = this.options.ecmaVersion >= 8;
                        if (this.options.ecmaVersion >= 6) {
                            this.next();
                            var o, s = this.start, c = this.startLoc, u = [], l = !0, d = !1, p = new K(), f = this.yieldPos, m = this.awaitPos;
                            for (this.yieldPos = 0, this.awaitPos = 0; this.type !== S.parenR;) {
                                if (l ? l = !1 : this.expect(S.comma), a && this.afterTrailingComma(S.parenR, !0)) {
                                    d = !0;
                                    break;
                                }
                                if (this.type === S.ellipsis) {
                                    o = this.start, u.push(this.parseParenItem(this.parseRestBinding())), this.type === S.comma && this.raise(this.start, 'Comma is not permitted after the rest element');
                                    break;
                                }
                                u.push(this.parseMaybeAssign(!1, p, this.parseParenItem));
                            }
                            var h = this.lastTokEnd, g = this.lastTokEndLoc;
                            if (this.expect(S.parenR), e && !this.canInsertSemicolon() && this.eat(S.arrow))
                                return this.checkPatternErrors(p, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = f, this.awaitPos = m, this.parseParenArrowList(n, i, u, t);
                            u.length && !d || this.unexpected(this.lastTokStart), o && this.unexpected(o), this.checkExpressionErrors(p, !0), this.yieldPos = f || this.yieldPos, this.awaitPos = m || this.awaitPos, u.length > 1 ? ((r = this.startNodeAt(s, c)).expressions = u, this.finishNodeAt(r, 'SequenceExpression', h, g)) : r = u[0];
                        } else
                            r = this.parseParenExpression();
                        if (this.options.preserveParens) {
                            var y = this.startNodeAt(n, i);
                            return y.expression = r, this.finishNode(y, 'ParenthesizedExpression');
                        }
                        return r;
                    }, ae.parseParenItem = function (e) {
                        return e;
                    }, ae.parseParenArrowList = function (e, t, r, n) {
                        return this.parseArrowExpression(this.startNodeAt(e, t), r, !1, n);
                    };
                    var se = [];
                    ae.parseNew = function () {
                        this.containsEsc && this.raiseRecoverable(this.start, 'Escape sequence in keyword new');
                        var e = this.startNode(), t = this.parseIdent(!0);
                        if (this.options.ecmaVersion >= 6 && this.eat(S.dot)) {
                            e.meta = t;
                            var r = this.containsEsc;
                            return e.property = this.parseIdent(!0), 'target' !== e.property.name && this.raiseRecoverable(e.property.start, 'The only valid meta property for new is \'new.target\''), r && this.raiseRecoverable(e.start, '\'new.target\' must not contain escaped characters'), this.allowNewDotTarget || this.raiseRecoverable(e.start, '\'new.target\' can only be used in functions and class static block'), this.finishNode(e, 'MetaProperty');
                        }
                        var n = this.start, i = this.startLoc, a = this.type === S._import;
                        return e.callee = this.parseSubscripts(this.parseExprAtom(), n, i, !0, !1), a && 'ImportExpression' === e.callee.type && this.raise(n, 'Cannot use new with import()'), this.eat(S.parenL) ? e.arguments = this.parseExprList(S.parenR, this.options.ecmaVersion >= 8, !1) : e.arguments = se, this.finishNode(e, 'NewExpression');
                    }, ae.parseTemplateElement = function (e) {
                        var t = e.isTagged, r = this.startNode();
                        return this.type === S.invalidTemplate ? (t || this.raiseRecoverable(this.start, 'Bad escape sequence in untagged template literal'), r.value = {
                            raw: this.value,
                            cooked: null
                        }) : r.value = {
                            raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, '\n'),
                            cooked: this.value
                        }, this.next(), r.tail = this.type === S.backQuote, this.finishNode(r, 'TemplateElement');
                    }, ae.parseTemplate = function (e) {
                        void 0 === e && (e = {});
                        var t = e.isTagged;
                        void 0 === t && (t = !1);
                        var r = this.startNode();
                        this.next(), r.expressions = [];
                        var n = this.parseTemplateElement({ isTagged: t });
                        for (r.quasis = [n]; !n.tail;)
                            this.type === S.eof && this.raise(this.pos, 'Unterminated template literal'), this.expect(S.dollarBraceL), r.expressions.push(this.parseExpression()), this.expect(S.braceR), r.quasis.push(n = this.parseTemplateElement({ isTagged: t }));
                        return this.next(), this.finishNode(r, 'TemplateLiteral');
                    }, ae.isAsyncProp = function (e) {
                        return !e.computed && 'Identifier' === e.key.type && 'async' === e.key.name && (this.type === S.name || this.type === S.num || this.type === S.string || this.type === S.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === S.star) && !v.test(this.input.slice(this.lastTokEnd, this.start));
                    }, ae.parseObj = function (e, t) {
                        var r = this.startNode(), n = !0, i = {};
                        for (r.properties = [], this.next(); !this.eat(S.braceR);) {
                            if (n)
                                n = !1;
                            else if (this.expect(S.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(S.braceR))
                                break;
                            var a = this.parseProperty(e, t);
                            e || this.checkPropClash(a, i, t), r.properties.push(a);
                        }
                        return this.finishNode(r, e ? 'ObjectPattern' : 'ObjectExpression');
                    }, ae.parseProperty = function (e, t) {
                        var r, n, i, a, o = this.startNode();
                        if (this.options.ecmaVersion >= 9 && this.eat(S.ellipsis))
                            return e ? (o.argument = this.parseIdent(!1), this.type === S.comma && this.raise(this.start, 'Comma is not permitted after the rest element'), this.finishNode(o, 'RestElement')) : (o.argument = this.parseMaybeAssign(!1, t), this.type === S.comma && t && t.trailingComma < 0 && (t.trailingComma = this.start), this.finishNode(o, 'SpreadElement'));
                        this.options.ecmaVersion >= 6 && (o.method = !1, o.shorthand = !1, (e || t) && (i = this.start, a = this.startLoc), e || (r = this.eat(S.star)));
                        var s = this.containsEsc;
                        return this.parsePropertyName(o), !e && !s && this.options.ecmaVersion >= 8 && !r && this.isAsyncProp(o) ? (n = !0, r = this.options.ecmaVersion >= 9 && this.eat(S.star), this.parsePropertyName(o)) : n = !1, this.parsePropertyValue(o, e, r, n, i, a, t, s), this.finishNode(o, 'Property');
                    }, ae.parsePropertyValue = function (e, t, r, n, i, a, o, s) {
                        if ((r || n) && this.type === S.colon && this.unexpected(), this.eat(S.colon))
                            e.value = t ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, o), e.kind = 'init';
                        else if (this.options.ecmaVersion >= 6 && this.type === S.parenL)
                            t && this.unexpected(), e.kind = 'init', e.method = !0, e.value = this.parseMethod(r, n);
                        else if (t || s || !(this.options.ecmaVersion >= 5) || e.computed || 'Identifier' !== e.key.type || 'get' !== e.key.name && 'set' !== e.key.name || this.type === S.comma || this.type === S.braceR || this.type === S.eq)
                            this.options.ecmaVersion >= 6 && !e.computed && 'Identifier' === e.key.type ? ((r || n) && this.unexpected(), this.checkUnreserved(e.key), 'await' !== e.key.name || this.awaitIdentPos || (this.awaitIdentPos = i), e.kind = 'init', t ? e.value = this.parseMaybeDefault(i, a, this.copyNode(e.key)) : this.type === S.eq && o ? (o.shorthandAssign < 0 && (o.shorthandAssign = this.start), e.value = this.parseMaybeDefault(i, a, this.copyNode(e.key))) : e.value = this.copyNode(e.key), e.shorthand = !0) : this.unexpected();
                        else {
                            (r || n) && this.unexpected(), e.kind = e.key.name, this.parsePropertyName(e), e.value = this.parseMethod(!1);
                            var c = 'get' === e.kind ? 0 : 1;
                            if (e.value.params.length !== c) {
                                var u = e.value.start;
                                'get' === e.kind ? this.raiseRecoverable(u, 'getter should have no params') : this.raiseRecoverable(u, 'setter should have exactly one param');
                            } else
                                'set' === e.kind && 'RestElement' === e.value.params[0].type && this.raiseRecoverable(e.value.params[0].start, 'Setter cannot use rest params');
                        }
                    }, ae.parsePropertyName = function (e) {
                        if (this.options.ecmaVersion >= 6) {
                            if (this.eat(S.bracketL))
                                return e.computed = !0, e.key = this.parseMaybeAssign(), this.expect(S.bracketR), e.key;
                            e.computed = !1;
                        }
                        return e.key = this.type === S.num || this.type === S.string ? this.parseExprAtom() : this.parseIdent('never' !== this.options.allowReserved);
                    }, ae.initFunction = function (e) {
                        e.id = null, this.options.ecmaVersion >= 6 && (e.generator = e.expression = !1), this.options.ecmaVersion >= 8 && (e.async = !1);
                    }, ae.parseMethod = function (e, t, r) {
                        var n = this.startNode(), i = this.yieldPos, a = this.awaitPos, o = this.awaitIdentPos;
                        return this.initFunction(n), this.options.ecmaVersion >= 6 && (n.generator = e), this.options.ecmaVersion >= 8 && (n.async = !!t), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(64 | G(t, n.generator) | (r ? 128 : 0)), this.expect(S.parenL), n.params = this.parseBindingList(S.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(n, !1, !0, !1), this.yieldPos = i, this.awaitPos = a, this.awaitIdentPos = o, this.finishNode(n, 'FunctionExpression');
                    }, ae.parseArrowExpression = function (e, t, r, n) {
                        var i = this.yieldPos, a = this.awaitPos, o = this.awaitIdentPos;
                        return this.enterScope(16 | G(r, !1)), this.initFunction(e), this.options.ecmaVersion >= 8 && (e.async = !!r), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e.params = this.toAssignableList(t, !0), this.parseFunctionBody(e, !0, !1, n), this.yieldPos = i, this.awaitPos = a, this.awaitIdentPos = o, this.finishNode(e, 'ArrowFunctionExpression');
                    }, ae.parseFunctionBody = function (e, t, r, n) {
                        var i = t && this.type !== S.braceL, a = this.strict, o = !1;
                        if (i)
                            e.body = this.parseMaybeAssign(n), e.expression = !0, this.checkParams(e, !1);
                        else {
                            var s = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e.params);
                            a && !s || (o = this.strictDirective(this.end)) && s && this.raiseRecoverable(e.start, 'Illegal \'use strict\' directive in function with non-simple parameter list');
                            var c = this.labels;
                            this.labels = [], o && (this.strict = !0), this.checkParams(e, !a && !o && !t && !r && this.isSimpleParamList(e.params)), this.strict && e.id && this.checkLValSimple(e.id, 5), e.body = this.parseBlock(!1, void 0, o && !a), e.expression = !1, this.adaptDirectivePrologue(e.body.body), this.labels = c;
                        }
                        this.exitScope();
                    }, ae.isSimpleParamList = function (e) {
                        for (var t = 0, r = e; t < r.length; t += 1)
                            if ('Identifier' !== r[t].type)
                                return !1;
                        return !0;
                    }, ae.checkParams = function (e, t) {
                        for (var r = Object.create(null), n = 0, i = e.params; n < i.length; n += 1) {
                            var a = i[n];
                            this.checkLValInnerPattern(a, 1, t ? null : r);
                        }
                    }, ae.parseExprList = function (e, t, r, n) {
                        for (var i = [], a = !0; !this.eat(e);) {
                            if (a)
                                a = !1;
                            else if (this.expect(S.comma), t && this.afterTrailingComma(e))
                                break;
                            var o = void 0;
                            r && this.type === S.comma ? o = null : this.type === S.ellipsis ? (o = this.parseSpread(n), n && this.type === S.comma && n.trailingComma < 0 && (n.trailingComma = this.start)) : o = this.parseMaybeAssign(!1, n), i.push(o);
                        }
                        return i;
                    }, ae.checkUnreserved = function (e) {
                        var t = e.start, r = e.end, n = e.name;
                        this.inGenerator && 'yield' === n && this.raiseRecoverable(t, 'Cannot use \'yield\' as identifier inside a generator'), this.inAsync && 'await' === n && this.raiseRecoverable(t, 'Cannot use \'await\' as identifier inside an async function'), this.currentThisScope().inClassFieldInit && 'arguments' === n && this.raiseRecoverable(t, 'Cannot use \'arguments\' in class field initializer'), !this.inClassStaticBlock || 'arguments' !== n && 'await' !== n || this.raise(t, 'Cannot use ' + n + ' in class static initialization block'), this.keywords.test(n) && this.raise(t, 'Unexpected keyword \'' + n + '\''), this.options.ecmaVersion < 6 && -1 !== this.input.slice(t, r).indexOf('\\') || (this.strict ? this.reservedWordsStrict : this.reservedWords).test(n) && (this.inAsync || 'await' !== n || this.raiseRecoverable(t, 'Cannot use keyword \'await\' outside an async function'), this.raiseRecoverable(t, 'The keyword \'' + n + '\' is reserved'));
                    }, ae.parseIdent = function (e) {
                        var t = this.startNode();
                        return this.type === S.name ? t.name = this.value : this.type.keyword ? (t.name = this.type.keyword, 'class' !== t.name && 'function' !== t.name || this.lastTokEnd === this.lastTokStart + 1 && 46 === this.input.charCodeAt(this.lastTokStart) || this.context.pop()) : this.unexpected(), this.next(!!e), this.finishNode(t, 'Identifier'), e || (this.checkUnreserved(t), 'await' !== t.name || this.awaitIdentPos || (this.awaitIdentPos = t.start)), t;
                    }, ae.parsePrivateIdent = function () {
                        var e = this.startNode();
                        return this.type === S.privateId ? e.name = this.value : this.unexpected(), this.next(), this.finishNode(e, 'PrivateIdentifier'), 0 === this.privateNameStack.length ? this.raise(e.start, 'Private field \'#' + e.name + '\' must be declared in an enclosing class') : this.privateNameStack[this.privateNameStack.length - 1].used.push(e), e;
                    }, ae.parseYield = function (e) {
                        this.yieldPos || (this.yieldPos = this.start);
                        var t = this.startNode();
                        return this.next(), this.type === S.semi || this.canInsertSemicolon() || this.type !== S.star && !this.type.startsExpr ? (t.delegate = !1, t.argument = null) : (t.delegate = this.eat(S.star), t.argument = this.parseMaybeAssign(e)), this.finishNode(t, 'YieldExpression');
                    }, ae.parseAwait = function (e) {
                        this.awaitPos || (this.awaitPos = this.start);
                        var t = this.startNode();
                        return this.next(), t.argument = this.parseMaybeUnary(null, !0, !1, e), this.finishNode(t, 'AwaitExpression');
                    };
                    var ce = V.prototype;
                    ce.raise = function (e, t) {
                        var r = B(this.input, e);
                        t += ' (' + r.line + ':' + r.column + ')';
                        var n = new SyntaxError(t);
                        throw n.pos = e, n.loc = r, n.raisedAt = this.pos, n;
                    }, ce.raiseRecoverable = ce.raise, ce.curPosition = function () {
                        if (this.options.locations)
                            return new x(this.curLine, this.pos - this.lineStart);
                    };
                    var ue = V.prototype, le = function (e) {
                            this.flags = e, this.var = [], this.lexical = [], this.functions = [], this.inClassFieldInit = !1;
                        };
                    ue.enterScope = function (e) {
                        this.scopeStack.push(new le(e));
                    }, ue.exitScope = function () {
                        this.scopeStack.pop();
                    }, ue.treatFunctionsAsVarInScope = function (e) {
                        return 2 & e.flags || !this.inModule && 1 & e.flags;
                    }, ue.declareName = function (e, t, r) {
                        var n = !1;
                        if (2 === t) {
                            var i = this.currentScope();
                            n = i.lexical.indexOf(e) > -1 || i.functions.indexOf(e) > -1 || i.var.indexOf(e) > -1, i.lexical.push(e), this.inModule && 1 & i.flags && delete this.undefinedExports[e];
                        } else if (4 === t)
                            this.currentScope().lexical.push(e);
                        else if (3 === t) {
                            var a = this.currentScope();
                            n = this.treatFunctionsAsVar ? a.lexical.indexOf(e) > -1 : a.lexical.indexOf(e) > -1 || a.var.indexOf(e) > -1, a.functions.push(e);
                        } else
                            for (var o = this.scopeStack.length - 1; o >= 0; --o) {
                                var s = this.scopeStack[o];
                                if (s.lexical.indexOf(e) > -1 && !(32 & s.flags && s.lexical[0] === e) || !this.treatFunctionsAsVarInScope(s) && s.functions.indexOf(e) > -1) {
                                    n = !0;
                                    break;
                                }
                                if (s.var.push(e), this.inModule && 1 & s.flags && delete this.undefinedExports[e], 259 & s.flags)
                                    break;
                            }
                        n && this.raiseRecoverable(r, 'Identifier \'' + e + '\' has already been declared');
                    }, ue.checkLocalExport = function (e) {
                        -1 === this.scopeStack[0].lexical.indexOf(e.name) && -1 === this.scopeStack[0].var.indexOf(e.name) && (this.undefinedExports[e.name] = e);
                    }, ue.currentScope = function () {
                        return this.scopeStack[this.scopeStack.length - 1];
                    }, ue.currentVarScope = function () {
                        for (var e = this.scopeStack.length - 1;; e--) {
                            var t = this.scopeStack[e];
                            if (259 & t.flags)
                                return t;
                        }
                    }, ue.currentThisScope = function () {
                        for (var e = this.scopeStack.length - 1;; e--) {
                            var t = this.scopeStack[e];
                            if (259 & t.flags && !(16 & t.flags))
                                return t;
                        }
                    };
                    var de = function (e, t, r) {
                            this.type = '', this.start = t, this.end = 0, e.options.locations && (this.loc = new w(e, r)), e.options.directSourceFile && (this.sourceFile = e.options.directSourceFile), e.options.ranges && (this.range = [
                                t,
                                0
                            ]);
                        }, pe = V.prototype;
                    function fe(e, t, r, n) {
                        return e.type = t, e.end = r, this.options.locations && (e.loc.end = n), this.options.ranges && (e.range[1] = r), e;
                    }
                    pe.startNode = function () {
                        return new de(this, this.start, this.startLoc);
                    }, pe.startNodeAt = function (e, t) {
                        return new de(this, e, t);
                    }, pe.finishNode = function (e, t) {
                        return fe.call(this, e, t, this.lastTokEnd, this.lastTokEndLoc);
                    }, pe.finishNodeAt = function (e, t, r, n) {
                        return fe.call(this, e, t, r, n);
                    }, pe.copyNode = function (e) {
                        var t = new de(this, e.start, this.startLoc);
                        for (var r in e)
                            t[r] = e[r];
                        return t;
                    };
                    var me, he, ge = 'ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS', ye = ge + ' Extended_Pictographic', be = ye + ' EBase EComp EMod EPres ExtPict', Se = {
                            9: ge,
                            10: ye,
                            11: ye,
                            12: be,
                            13: be,
                            14: be
                        }, ve = 'Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu', Ce = 'Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb', Ae = Ce + ' Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd', _e = Ae + ' Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho', Ee = _e + ' Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi', Ne = Ee + ' Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith', Ie = {
                            9: Ce,
                            10: Ae,
                            11: _e,
                            12: Ee,
                            13: Ne,
                            14: Ne + ' Kawi Nag_Mundari Nagm'
                        }, Te = {};
                    for (var De = 0, Oe = [
                                9,
                                10,
                                11,
                                12,
                                13,
                                14
                            ]; De < Oe.length; De += 1)
                        he = void 0, (he = Te[me = Oe[De]] = {
                            binary: M(Se[me] + ' ' + ve),
                            nonBinary: {
                                General_Category: M(ve),
                                Script: M(Ie[me])
                            }
                        }).nonBinary.Script_Extensions = he.nonBinary.Script, he.nonBinary.gc = he.nonBinary.General_Category, he.nonBinary.sc = he.nonBinary.Script, he.nonBinary.scx = he.nonBinary.Script_Extensions;
                    var Re = V.prototype, Me = function (e) {
                            this.parser = e, this.validFlags = 'gim' + (e.options.ecmaVersion >= 6 ? 'uy' : '') + (e.options.ecmaVersion >= 9 ? 's' : '') + (e.options.ecmaVersion >= 13 ? 'd' : ''), this.unicodeProperties = Te[e.options.ecmaVersion >= 14 ? 14 : e.options.ecmaVersion], this.source = '', this.flags = '', this.start = 0, this.switchU = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = '', this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
                        };
                    function Fe(e) {
                        return 36 === e || e >= 40 && e <= 43 || 46 === e || 63 === e || e >= 91 && e <= 94 || e >= 123 && e <= 125;
                    }
                    function Pe(e) {
                        return e >= 65 && e <= 90 || e >= 97 && e <= 122;
                    }
                    function xe(e) {
                        return Pe(e) || 95 === e;
                    }
                    function we(e) {
                        return xe(e) || Be(e);
                    }
                    function Be(e) {
                        return e >= 48 && e <= 57;
                    }
                    function ke(e) {
                        return e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102;
                    }
                    function Le(e) {
                        return e >= 65 && e <= 70 ? e - 65 + 10 : e >= 97 && e <= 102 ? e - 97 + 10 : e - 48;
                    }
                    function $e(e) {
                        return e >= 48 && e <= 55;
                    }
                    Me.prototype.reset = function (e, t, r) {
                        var n = -1 !== r.indexOf('u');
                        this.start = 0 | e, this.source = t + '', this.flags = r, this.switchU = n && this.parser.options.ecmaVersion >= 6, this.switchN = n && this.parser.options.ecmaVersion >= 9;
                    }, Me.prototype.raise = function (e) {
                        this.parser.raiseRecoverable(this.start, 'Invalid regular expression: /' + this.source + '/: ' + e);
                    }, Me.prototype.at = function (e, t) {
                        void 0 === t && (t = !1);
                        var r = this.source, n = r.length;
                        if (e >= n)
                            return -1;
                        var i = r.charCodeAt(e);
                        if (!t && !this.switchU || i <= 55295 || i >= 57344 || e + 1 >= n)
                            return i;
                        var a = r.charCodeAt(e + 1);
                        return a >= 56320 && a <= 57343 ? (i << 10) + a - 56613888 : i;
                    }, Me.prototype.nextIndex = function (e, t) {
                        void 0 === t && (t = !1);
                        var r = this.source, n = r.length;
                        if (e >= n)
                            return n;
                        var i, a = r.charCodeAt(e);
                        return !t && !this.switchU || a <= 55295 || a >= 57344 || e + 1 >= n || (i = r.charCodeAt(e + 1)) < 56320 || i > 57343 ? e + 1 : e + 2;
                    }, Me.prototype.current = function (e) {
                        return void 0 === e && (e = !1), this.at(this.pos, e);
                    }, Me.prototype.lookahead = function (e) {
                        return void 0 === e && (e = !1), this.at(this.nextIndex(this.pos, e), e);
                    }, Me.prototype.advance = function (e) {
                        void 0 === e && (e = !1), this.pos = this.nextIndex(this.pos, e);
                    }, Me.prototype.eat = function (e, t) {
                        return void 0 === t && (t = !1), this.current(t) === e && (this.advance(t), !0);
                    }, Re.validateRegExpFlags = function (e) {
                        for (var t = e.validFlags, r = e.flags, n = 0; n < r.length; n++) {
                            var i = r.charAt(n);
                            -1 === t.indexOf(i) && this.raise(e.start, 'Invalid regular expression flag'), r.indexOf(i, n + 1) > -1 && this.raise(e.start, 'Duplicate regular expression flag');
                        }
                    }, Re.validateRegExpPattern = function (e) {
                        this.regexp_pattern(e), !e.switchN && this.options.ecmaVersion >= 9 && e.groupNames.length > 0 && (e.switchN = !0, this.regexp_pattern(e));
                    }, Re.regexp_pattern = function (e) {
                        e.pos = 0, e.lastIntValue = 0, e.lastStringValue = '', e.lastAssertionIsQuantifiable = !1, e.numCapturingParens = 0, e.maxBackReference = 0, e.groupNames.length = 0, e.backReferenceNames.length = 0, this.regexp_disjunction(e), e.pos !== e.source.length && (e.eat(41) && e.raise('Unmatched \')\''), (e.eat(93) || e.eat(125)) && e.raise('Lone quantifier brackets')), e.maxBackReference > e.numCapturingParens && e.raise('Invalid escape');
                        for (var t = 0, r = e.backReferenceNames; t < r.length; t += 1) {
                            var n = r[t];
                            -1 === e.groupNames.indexOf(n) && e.raise('Invalid named capture referenced');
                        }
                    }, Re.regexp_disjunction = function (e) {
                        for (this.regexp_alternative(e); e.eat(124);)
                            this.regexp_alternative(e);
                        this.regexp_eatQuantifier(e, !0) && e.raise('Nothing to repeat'), e.eat(123) && e.raise('Lone quantifier brackets');
                    }, Re.regexp_alternative = function (e) {
                        for (; e.pos < e.source.length && this.regexp_eatTerm(e););
                    }, Re.regexp_eatTerm = function (e) {
                        return this.regexp_eatAssertion(e) ? (e.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e) && e.switchU && e.raise('Invalid quantifier'), !0) : !!(e.switchU ? this.regexp_eatAtom(e) : this.regexp_eatExtendedAtom(e)) && (this.regexp_eatQuantifier(e), !0);
                    }, Re.regexp_eatAssertion = function (e) {
                        var t = e.pos;
                        if (e.lastAssertionIsQuantifiable = !1, e.eat(94) || e.eat(36))
                            return !0;
                        if (e.eat(92)) {
                            if (e.eat(66) || e.eat(98))
                                return !0;
                            e.pos = t;
                        }
                        if (e.eat(40) && e.eat(63)) {
                            var r = !1;
                            if (this.options.ecmaVersion >= 9 && (r = e.eat(60)), e.eat(61) || e.eat(33))
                                return this.regexp_disjunction(e), e.eat(41) || e.raise('Unterminated group'), e.lastAssertionIsQuantifiable = !r, !0;
                        }
                        return e.pos = t, !1;
                    }, Re.regexp_eatQuantifier = function (e, t) {
                        return void 0 === t && (t = !1), !!this.regexp_eatQuantifierPrefix(e, t) && (e.eat(63), !0);
                    }, Re.regexp_eatQuantifierPrefix = function (e, t) {
                        return e.eat(42) || e.eat(43) || e.eat(63) || this.regexp_eatBracedQuantifier(e, t);
                    }, Re.regexp_eatBracedQuantifier = function (e, t) {
                        var r = e.pos;
                        if (e.eat(123)) {
                            var n = 0, i = -1;
                            if (this.regexp_eatDecimalDigits(e) && (n = e.lastIntValue, e.eat(44) && this.regexp_eatDecimalDigits(e) && (i = e.lastIntValue), e.eat(125)))
                                return -1 !== i && i < n && !t && e.raise('numbers out of order in {} quantifier'), !0;
                            e.switchU && !t && e.raise('Incomplete quantifier'), e.pos = r;
                        }
                        return !1;
                    }, Re.regexp_eatAtom = function (e) {
                        return this.regexp_eatPatternCharacters(e) || e.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e);
                    }, Re.regexp_eatReverseSolidusAtomEscape = function (e) {
                        var t = e.pos;
                        if (e.eat(92)) {
                            if (this.regexp_eatAtomEscape(e))
                                return !0;
                            e.pos = t;
                        }
                        return !1;
                    }, Re.regexp_eatUncapturingGroup = function (e) {
                        var t = e.pos;
                        if (e.eat(40)) {
                            if (e.eat(63) && e.eat(58)) {
                                if (this.regexp_disjunction(e), e.eat(41))
                                    return !0;
                                e.raise('Unterminated group');
                            }
                            e.pos = t;
                        }
                        return !1;
                    }, Re.regexp_eatCapturingGroup = function (e) {
                        if (e.eat(40)) {
                            if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e) : 63 === e.current() && e.raise('Invalid group'), this.regexp_disjunction(e), e.eat(41))
                                return e.numCapturingParens += 1, !0;
                            e.raise('Unterminated group');
                        }
                        return !1;
                    }, Re.regexp_eatExtendedAtom = function (e) {
                        return e.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e) || this.regexp_eatInvalidBracedQuantifier(e) || this.regexp_eatExtendedPatternCharacter(e);
                    }, Re.regexp_eatInvalidBracedQuantifier = function (e) {
                        return this.regexp_eatBracedQuantifier(e, !0) && e.raise('Nothing to repeat'), !1;
                    }, Re.regexp_eatSyntaxCharacter = function (e) {
                        var t = e.current();
                        return !!Fe(t) && (e.lastIntValue = t, e.advance(), !0);
                    }, Re.regexp_eatPatternCharacters = function (e) {
                        for (var t = e.pos, r = 0; -1 !== (r = e.current()) && !Fe(r);)
                            e.advance();
                        return e.pos !== t;
                    }, Re.regexp_eatExtendedPatternCharacter = function (e) {
                        var t = e.current();
                        return !(-1 === t || 36 === t || t >= 40 && t <= 43 || 46 === t || 63 === t || 91 === t || 94 === t || 124 === t || (e.advance(), 0));
                    }, Re.regexp_groupSpecifier = function (e) {
                        if (e.eat(63)) {
                            if (this.regexp_eatGroupName(e))
                                return -1 !== e.groupNames.indexOf(e.lastStringValue) && e.raise('Duplicate capture group name'), void e.groupNames.push(e.lastStringValue);
                            e.raise('Invalid group');
                        }
                    }, Re.regexp_eatGroupName = function (e) {
                        if (e.lastStringValue = '', e.eat(60)) {
                            if (this.regexp_eatRegExpIdentifierName(e) && e.eat(62))
                                return !0;
                            e.raise('Invalid capture group name');
                        }
                        return !1;
                    }, Re.regexp_eatRegExpIdentifierName = function (e) {
                        if (e.lastStringValue = '', this.regexp_eatRegExpIdentifierStart(e)) {
                            for (e.lastStringValue += F(e.lastIntValue); this.regexp_eatRegExpIdentifierPart(e);)
                                e.lastStringValue += F(e.lastIntValue);
                            return !0;
                        }
                        return !1;
                    }, Re.regexp_eatRegExpIdentifierStart = function (e) {
                        var t = e.pos, r = this.options.ecmaVersion >= 11, n = e.current(r);
                        return e.advance(r), 92 === n && this.regexp_eatRegExpUnicodeEscapeSequence(e, r) && (n = e.lastIntValue), function (e) {
                            return d(e, !0) || 36 === e || 95 === e;
                        }(n) ? (e.lastIntValue = n, !0) : (e.pos = t, !1);
                    }, Re.regexp_eatRegExpIdentifierPart = function (e) {
                        var t = e.pos, r = this.options.ecmaVersion >= 11, n = e.current(r);
                        return e.advance(r), 92 === n && this.regexp_eatRegExpUnicodeEscapeSequence(e, r) && (n = e.lastIntValue), function (e) {
                            return p(e, !0) || 36 === e || 95 === e || 8204 === e || 8205 === e;
                        }(n) ? (e.lastIntValue = n, !0) : (e.pos = t, !1);
                    }, Re.regexp_eatAtomEscape = function (e) {
                        return !!(this.regexp_eatBackReference(e) || this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e) || e.switchN && this.regexp_eatKGroupName(e)) || (e.switchU && (99 === e.current() && e.raise('Invalid unicode escape'), e.raise('Invalid escape')), !1);
                    }, Re.regexp_eatBackReference = function (e) {
                        var t = e.pos;
                        if (this.regexp_eatDecimalEscape(e)) {
                            var r = e.lastIntValue;
                            if (e.switchU)
                                return r > e.maxBackReference && (e.maxBackReference = r), !0;
                            if (r <= e.numCapturingParens)
                                return !0;
                            e.pos = t;
                        }
                        return !1;
                    }, Re.regexp_eatKGroupName = function (e) {
                        if (e.eat(107)) {
                            if (this.regexp_eatGroupName(e))
                                return e.backReferenceNames.push(e.lastStringValue), !0;
                            e.raise('Invalid named reference');
                        }
                        return !1;
                    }, Re.regexp_eatCharacterEscape = function (e) {
                        return this.regexp_eatControlEscape(e) || this.regexp_eatCControlLetter(e) || this.regexp_eatZero(e) || this.regexp_eatHexEscapeSequence(e) || this.regexp_eatRegExpUnicodeEscapeSequence(e, !1) || !e.switchU && this.regexp_eatLegacyOctalEscapeSequence(e) || this.regexp_eatIdentityEscape(e);
                    }, Re.regexp_eatCControlLetter = function (e) {
                        var t = e.pos;
                        if (e.eat(99)) {
                            if (this.regexp_eatControlLetter(e))
                                return !0;
                            e.pos = t;
                        }
                        return !1;
                    }, Re.regexp_eatZero = function (e) {
                        return 48 === e.current() && !Be(e.lookahead()) && (e.lastIntValue = 0, e.advance(), !0);
                    }, Re.regexp_eatControlEscape = function (e) {
                        var t = e.current();
                        return 116 === t ? (e.lastIntValue = 9, e.advance(), !0) : 110 === t ? (e.lastIntValue = 10, e.advance(), !0) : 118 === t ? (e.lastIntValue = 11, e.advance(), !0) : 102 === t ? (e.lastIntValue = 12, e.advance(), !0) : 114 === t && (e.lastIntValue = 13, e.advance(), !0);
                    }, Re.regexp_eatControlLetter = function (e) {
                        var t = e.current();
                        return !!Pe(t) && (e.lastIntValue = t % 32, e.advance(), !0);
                    }, Re.regexp_eatRegExpUnicodeEscapeSequence = function (e, t) {
                        void 0 === t && (t = !1);
                        var r, n = e.pos, i = t || e.switchU;
                        if (e.eat(117)) {
                            if (this.regexp_eatFixedHexDigits(e, 4)) {
                                var a = e.lastIntValue;
                                if (i && a >= 55296 && a <= 56319) {
                                    var o = e.pos;
                                    if (e.eat(92) && e.eat(117) && this.regexp_eatFixedHexDigits(e, 4)) {
                                        var s = e.lastIntValue;
                                        if (s >= 56320 && s <= 57343)
                                            return e.lastIntValue = 1024 * (a - 55296) + (s - 56320) + 65536, !0;
                                    }
                                    e.pos = o, e.lastIntValue = a;
                                }
                                return !0;
                            }
                            if (i && e.eat(123) && this.regexp_eatHexDigits(e) && e.eat(125) && ((r = e.lastIntValue) >= 0 && r <= 1114111))
                                return !0;
                            i && e.raise('Invalid unicode escape'), e.pos = n;
                        }
                        return !1;
                    }, Re.regexp_eatIdentityEscape = function (e) {
                        if (e.switchU)
                            return !!this.regexp_eatSyntaxCharacter(e) || !!e.eat(47) && (e.lastIntValue = 47, !0);
                        var t = e.current();
                        return !(99 === t || e.switchN && 107 === t || (e.lastIntValue = t, e.advance(), 0));
                    }, Re.regexp_eatDecimalEscape = function (e) {
                        e.lastIntValue = 0;
                        var t = e.current();
                        if (t >= 49 && t <= 57) {
                            do {
                                e.lastIntValue = 10 * e.lastIntValue + (t - 48), e.advance();
                            } while ((t = e.current()) >= 48 && t <= 57);
                            return !0;
                        }
                        return !1;
                    }, Re.regexp_eatCharacterClassEscape = function (e) {
                        var t = e.current();
                        if (function (e) {
                                return 100 === e || 68 === e || 115 === e || 83 === e || 119 === e || 87 === e;
                            }(t))
                            return e.lastIntValue = -1, e.advance(), !0;
                        if (e.switchU && this.options.ecmaVersion >= 9 && (80 === t || 112 === t)) {
                            if (e.lastIntValue = -1, e.advance(), e.eat(123) && this.regexp_eatUnicodePropertyValueExpression(e) && e.eat(125))
                                return !0;
                            e.raise('Invalid property name');
                        }
                        return !1;
                    }, Re.regexp_eatUnicodePropertyValueExpression = function (e) {
                        var t = e.pos;
                        if (this.regexp_eatUnicodePropertyName(e) && e.eat(61)) {
                            var r = e.lastStringValue;
                            if (this.regexp_eatUnicodePropertyValue(e)) {
                                var n = e.lastStringValue;
                                return this.regexp_validateUnicodePropertyNameAndValue(e, r, n), !0;
                            }
                        }
                        if (e.pos = t, this.regexp_eatLoneUnicodePropertyNameOrValue(e)) {
                            var i = e.lastStringValue;
                            return this.regexp_validateUnicodePropertyNameOrValue(e, i), !0;
                        }
                        return !1;
                    }, Re.regexp_validateUnicodePropertyNameAndValue = function (e, t, r) {
                        O(e.unicodeProperties.nonBinary, t) || e.raise('Invalid property name'), e.unicodeProperties.nonBinary[t].test(r) || e.raise('Invalid property value');
                    }, Re.regexp_validateUnicodePropertyNameOrValue = function (e, t) {
                        e.unicodeProperties.binary.test(t) || e.raise('Invalid property name');
                    }, Re.regexp_eatUnicodePropertyName = function (e) {
                        var t = 0;
                        for (e.lastStringValue = ''; xe(t = e.current());)
                            e.lastStringValue += F(t), e.advance();
                        return '' !== e.lastStringValue;
                    }, Re.regexp_eatUnicodePropertyValue = function (e) {
                        var t = 0;
                        for (e.lastStringValue = ''; we(t = e.current());)
                            e.lastStringValue += F(t), e.advance();
                        return '' !== e.lastStringValue;
                    }, Re.regexp_eatLoneUnicodePropertyNameOrValue = function (e) {
                        return this.regexp_eatUnicodePropertyValue(e);
                    }, Re.regexp_eatCharacterClass = function (e) {
                        if (e.eat(91)) {
                            if (e.eat(94), this.regexp_classRanges(e), e.eat(93))
                                return !0;
                            e.raise('Unterminated character class');
                        }
                        return !1;
                    }, Re.regexp_classRanges = function (e) {
                        for (; this.regexp_eatClassAtom(e);) {
                            var t = e.lastIntValue;
                            if (e.eat(45) && this.regexp_eatClassAtom(e)) {
                                var r = e.lastIntValue;
                                !e.switchU || -1 !== t && -1 !== r || e.raise('Invalid character class'), -1 !== t && -1 !== r && t > r && e.raise('Range out of order in character class');
                            }
                        }
                    }, Re.regexp_eatClassAtom = function (e) {
                        var t = e.pos;
                        if (e.eat(92)) {
                            if (this.regexp_eatClassEscape(e))
                                return !0;
                            if (e.switchU) {
                                var r = e.current();
                                (99 === r || $e(r)) && e.raise('Invalid class escape'), e.raise('Invalid escape');
                            }
                            e.pos = t;
                        }
                        var n = e.current();
                        return 93 !== n && (e.lastIntValue = n, e.advance(), !0);
                    }, Re.regexp_eatClassEscape = function (e) {
                        var t = e.pos;
                        if (e.eat(98))
                            return e.lastIntValue = 8, !0;
                        if (e.switchU && e.eat(45))
                            return e.lastIntValue = 45, !0;
                        if (!e.switchU && e.eat(99)) {
                            if (this.regexp_eatClassControlLetter(e))
                                return !0;
                            e.pos = t;
                        }
                        return this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e);
                    }, Re.regexp_eatClassControlLetter = function (e) {
                        var t = e.current();
                        return !(!Be(t) && 95 !== t || (e.lastIntValue = t % 32, e.advance(), 0));
                    }, Re.regexp_eatHexEscapeSequence = function (e) {
                        var t = e.pos;
                        if (e.eat(120)) {
                            if (this.regexp_eatFixedHexDigits(e, 2))
                                return !0;
                            e.switchU && e.raise('Invalid escape'), e.pos = t;
                        }
                        return !1;
                    }, Re.regexp_eatDecimalDigits = function (e) {
                        var t = e.pos, r = 0;
                        for (e.lastIntValue = 0; Be(r = e.current());)
                            e.lastIntValue = 10 * e.lastIntValue + (r - 48), e.advance();
                        return e.pos !== t;
                    }, Re.regexp_eatHexDigits = function (e) {
                        var t = e.pos, r = 0;
                        for (e.lastIntValue = 0; ke(r = e.current());)
                            e.lastIntValue = 16 * e.lastIntValue + Le(r), e.advance();
                        return e.pos !== t;
                    }, Re.regexp_eatLegacyOctalEscapeSequence = function (e) {
                        if (this.regexp_eatOctalDigit(e)) {
                            var t = e.lastIntValue;
                            if (this.regexp_eatOctalDigit(e)) {
                                var r = e.lastIntValue;
                                t <= 3 && this.regexp_eatOctalDigit(e) ? e.lastIntValue = 64 * t + 8 * r + e.lastIntValue : e.lastIntValue = 8 * t + r;
                            } else
                                e.lastIntValue = t;
                            return !0;
                        }
                        return !1;
                    }, Re.regexp_eatOctalDigit = function (e) {
                        var t = e.current();
                        return $e(t) ? (e.lastIntValue = t - 48, e.advance(), !0) : (e.lastIntValue = 0, !1);
                    }, Re.regexp_eatFixedHexDigits = function (e, t) {
                        var r = e.pos;
                        e.lastIntValue = 0;
                        for (var n = 0; n < t; ++n) {
                            var i = e.current();
                            if (!ke(i))
                                return e.pos = r, !1;
                            e.lastIntValue = 16 * e.lastIntValue + Le(i), e.advance();
                        }
                        return !0;
                    };
                    var je = function (e) {
                            this.type = e.type, this.value = e.value, this.start = e.start, this.end = e.end, e.options.locations && (this.loc = new w(e, e.startLoc, e.endLoc)), e.options.ranges && (this.range = [
                                e.start,
                                e.end
                            ]);
                        }, Ge = V.prototype;
                    function Ve(e) {
                        return 'function' != typeof BigInt ? null : BigInt(e.replace(/_/g, ''));
                    }
                    Ge.next = function (e) {
                        !e && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, 'Escape sequence in keyword ' + this.type.keyword), this.options.onToken && this.options.onToken(new je(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
                    }, Ge.getToken = function () {
                        return this.next(), new je(this);
                    }, 'undefined' != typeof Symbol && (Ge[Symbol.iterator] = function () {
                        var e = this;
                        return {
                            next: function () {
                                var t = e.getToken();
                                return {
                                    done: t.type === S.eof,
                                    value: t
                                };
                            }
                        };
                    }), Ge.nextToken = function () {
                        var e = this.curContext();
                        return e && e.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length ? this.finishToken(S.eof) : e.override ? e.override(this) : void this.readToken(this.fullCharCodeAtPos());
                    }, Ge.readToken = function (e) {
                        return d(e, this.options.ecmaVersion >= 6) || 92 === e ? this.readWord() : this.getTokenFromCode(e);
                    }, Ge.fullCharCodeAtPos = function () {
                        var e = this.input.charCodeAt(this.pos);
                        if (e <= 55295 || e >= 56320)
                            return e;
                        var t = this.input.charCodeAt(this.pos + 1);
                        return t <= 56319 || t >= 57344 ? e : (e << 10) + t - 56613888;
                    }, Ge.skipBlockComment = function () {
                        var e = this.options.onComment && this.curPosition(), t = this.pos, r = this.input.indexOf('*/', this.pos += 2);
                        if (-1 === r && this.raise(this.pos - 2, 'Unterminated comment'), this.pos = r + 2, this.options.locations)
                            for (var n = void 0, i = t; (n = _(this.input, i, this.pos)) > -1;)
                                ++this.curLine, i = this.lineStart = n;
                        this.options.onComment && this.options.onComment(!0, this.input.slice(t + 2, r), t, this.pos, e, this.curPosition());
                    }, Ge.skipLineComment = function (e) {
                        for (var t = this.pos, r = this.options.onComment && this.curPosition(), n = this.input.charCodeAt(this.pos += e); this.pos < this.input.length && !A(n);)
                            n = this.input.charCodeAt(++this.pos);
                        this.options.onComment && this.options.onComment(!1, this.input.slice(t + e, this.pos), t, this.pos, r, this.curPosition());
                    }, Ge.skipSpace = function () {
                        e:
                            for (; this.pos < this.input.length;) {
                                var e = this.input.charCodeAt(this.pos);
                                switch (e) {
                                case 32:
                                case 160:
                                    ++this.pos;
                                    break;
                                case 13:
                                    10 === this.input.charCodeAt(this.pos + 1) && ++this.pos;
                                case 10:
                                case 8232:
                                case 8233:
                                    ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
                                    break;
                                case 47:
                                    switch (this.input.charCodeAt(this.pos + 1)) {
                                    case 42:
                                        this.skipBlockComment();
                                        break;
                                    case 47:
                                        this.skipLineComment(2);
                                        break;
                                    default:
                                        break e;
                                    }
                                    break;
                                default:
                                    if (!(e > 8 && e < 14 || e >= 5760 && E.test(String.fromCharCode(e))))
                                        break e;
                                    ++this.pos;
                                }
                            }
                    }, Ge.finishToken = function (e, t) {
                        this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
                        var r = this.type;
                        this.type = e, this.value = t, this.updateContext(r);
                    }, Ge.readToken_dot = function () {
                        var e = this.input.charCodeAt(this.pos + 1);
                        if (e >= 48 && e <= 57)
                            return this.readNumber(!0);
                        var t = this.input.charCodeAt(this.pos + 2);
                        return this.options.ecmaVersion >= 6 && 46 === e && 46 === t ? (this.pos += 3, this.finishToken(S.ellipsis)) : (++this.pos, this.finishToken(S.dot));
                    }, Ge.readToken_slash = function () {
                        var e = this.input.charCodeAt(this.pos + 1);
                        return this.exprAllowed ? (++this.pos, this.readRegexp()) : 61 === e ? this.finishOp(S.assign, 2) : this.finishOp(S.slash, 1);
                    }, Ge.readToken_mult_modulo_exp = function (e) {
                        var t = this.input.charCodeAt(this.pos + 1), r = 1, n = 42 === e ? S.star : S.modulo;
                        return this.options.ecmaVersion >= 7 && 42 === e && 42 === t && (++r, n = S.starstar, t = this.input.charCodeAt(this.pos + 2)), 61 === t ? this.finishOp(S.assign, r + 1) : this.finishOp(n, r);
                    }, Ge.readToken_pipe_amp = function (e) {
                        var t = this.input.charCodeAt(this.pos + 1);
                        return t === e ? this.options.ecmaVersion >= 12 && 61 === this.input.charCodeAt(this.pos + 2) ? this.finishOp(S.assign, 3) : this.finishOp(124 === e ? S.logicalOR : S.logicalAND, 2) : 61 === t ? this.finishOp(S.assign, 2) : this.finishOp(124 === e ? S.bitwiseOR : S.bitwiseAND, 1);
                    }, Ge.readToken_caret = function () {
                        return 61 === this.input.charCodeAt(this.pos + 1) ? this.finishOp(S.assign, 2) : this.finishOp(S.bitwiseXOR, 1);
                    }, Ge.readToken_plus_min = function (e) {
                        var t = this.input.charCodeAt(this.pos + 1);
                        return t === e ? 45 !== t || this.inModule || 62 !== this.input.charCodeAt(this.pos + 2) || 0 !== this.lastTokEnd && !v.test(this.input.slice(this.lastTokEnd, this.pos)) ? this.finishOp(S.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : 61 === t ? this.finishOp(S.assign, 2) : this.finishOp(S.plusMin, 1);
                    }, Ge.readToken_lt_gt = function (e) {
                        var t = this.input.charCodeAt(this.pos + 1), r = 1;
                        return t === e ? (r = 62 === e && 62 === this.input.charCodeAt(this.pos + 2) ? 3 : 2, 61 === this.input.charCodeAt(this.pos + r) ? this.finishOp(S.assign, r + 1) : this.finishOp(S.bitShift, r)) : 33 !== t || 60 !== e || this.inModule || 45 !== this.input.charCodeAt(this.pos + 2) || 45 !== this.input.charCodeAt(this.pos + 3) ? (61 === t && (r = 2), this.finishOp(S.relational, r)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
                    }, Ge.readToken_eq_excl = function (e) {
                        var t = this.input.charCodeAt(this.pos + 1);
                        return 61 === t ? this.finishOp(S.equality, 61 === this.input.charCodeAt(this.pos + 2) ? 3 : 2) : 61 === e && 62 === t && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(S.arrow)) : this.finishOp(61 === e ? S.eq : S.prefix, 1);
                    }, Ge.readToken_question = function () {
                        var e = this.options.ecmaVersion;
                        if (e >= 11) {
                            var t = this.input.charCodeAt(this.pos + 1);
                            if (46 === t) {
                                var r = this.input.charCodeAt(this.pos + 2);
                                if (r < 48 || r > 57)
                                    return this.finishOp(S.questionDot, 2);
                            }
                            if (63 === t)
                                return e >= 12 && 61 === this.input.charCodeAt(this.pos + 2) ? this.finishOp(S.assign, 3) : this.finishOp(S.coalesce, 2);
                        }
                        return this.finishOp(S.question, 1);
                    }, Ge.readToken_numberSign = function () {
                        var e = 35;
                        if (this.options.ecmaVersion >= 13 && (++this.pos, d(e = this.fullCharCodeAtPos(), !0) || 92 === e))
                            return this.finishToken(S.privateId, this.readWord1());
                        this.raise(this.pos, 'Unexpected character \'' + F(e) + '\'');
                    }, Ge.getTokenFromCode = function (e) {
                        switch (e) {
                        case 46:
                            return this.readToken_dot();
                        case 40:
                            return ++this.pos, this.finishToken(S.parenL);
                        case 41:
                            return ++this.pos, this.finishToken(S.parenR);
                        case 59:
                            return ++this.pos, this.finishToken(S.semi);
                        case 44:
                            return ++this.pos, this.finishToken(S.comma);
                        case 91:
                            return ++this.pos, this.finishToken(S.bracketL);
                        case 93:
                            return ++this.pos, this.finishToken(S.bracketR);
                        case 123:
                            return ++this.pos, this.finishToken(S.braceL);
                        case 125:
                            return ++this.pos, this.finishToken(S.braceR);
                        case 58:
                            return ++this.pos, this.finishToken(S.colon);
                        case 96:
                            if (this.options.ecmaVersion < 6)
                                break;
                            return ++this.pos, this.finishToken(S.backQuote);
                        case 48:
                            var t = this.input.charCodeAt(this.pos + 1);
                            if (120 === t || 88 === t)
                                return this.readRadixNumber(16);
                            if (this.options.ecmaVersion >= 6) {
                                if (111 === t || 79 === t)
                                    return this.readRadixNumber(8);
                                if (98 === t || 66 === t)
                                    return this.readRadixNumber(2);
                            }
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                        case 56:
                        case 57:
                            return this.readNumber(!1);
                        case 34:
                        case 39:
                            return this.readString(e);
                        case 47:
                            return this.readToken_slash();
                        case 37:
                        case 42:
                            return this.readToken_mult_modulo_exp(e);
                        case 124:
                        case 38:
                            return this.readToken_pipe_amp(e);
                        case 94:
                            return this.readToken_caret();
                        case 43:
                        case 45:
                            return this.readToken_plus_min(e);
                        case 60:
                        case 62:
                            return this.readToken_lt_gt(e);
                        case 61:
                        case 33:
                            return this.readToken_eq_excl(e);
                        case 63:
                            return this.readToken_question();
                        case 126:
                            return this.finishOp(S.prefix, 1);
                        case 35:
                            return this.readToken_numberSign();
                        }
                        this.raise(this.pos, 'Unexpected character \'' + F(e) + '\'');
                    }, Ge.finishOp = function (e, t) {
                        var r = this.input.slice(this.pos, this.pos + t);
                        return this.pos += t, this.finishToken(e, r);
                    }, Ge.readRegexp = function () {
                        for (var e, t, r = this.pos;;) {
                            this.pos >= this.input.length && this.raise(r, 'Unterminated regular expression');
                            var n = this.input.charAt(this.pos);
                            if (v.test(n) && this.raise(r, 'Unterminated regular expression'), e)
                                e = !1;
                            else {
                                if ('[' === n)
                                    t = !0;
                                else if (']' === n && t)
                                    t = !1;
                                else if ('/' === n && !t)
                                    break;
                                e = '\\' === n;
                            }
                            ++this.pos;
                        }
                        var i = this.input.slice(r, this.pos);
                        ++this.pos;
                        var a = this.pos, o = this.readWord1();
                        this.containsEsc && this.unexpected(a);
                        var s = this.regexpState || (this.regexpState = new Me(this));
                        s.reset(r, i, o), this.validateRegExpFlags(s), this.validateRegExpPattern(s);
                        var c = null;
                        try {
                            c = new RegExp(i, o);
                        } catch (e) {
                        }
                        return this.finishToken(S.regexp, {
                            pattern: i,
                            flags: o,
                            value: c
                        });
                    }, Ge.readInt = function (e, t, r) {
                        for (var n = this.options.ecmaVersion >= 12 && void 0 === t, i = r && 48 === this.input.charCodeAt(this.pos), a = this.pos, o = 0, s = 0, c = 0, u = null == t ? 1 / 0 : t; c < u; ++c, ++this.pos) {
                            var l = this.input.charCodeAt(this.pos), d = void 0;
                            if (n && 95 === l)
                                i && this.raiseRecoverable(this.pos, 'Numeric separator is not allowed in legacy octal numeric literals'), 95 === s && this.raiseRecoverable(this.pos, 'Numeric separator must be exactly one underscore'), 0 === c && this.raiseRecoverable(this.pos, 'Numeric separator is not allowed at the first of digits'), s = l;
                            else {
                                if ((d = l >= 97 ? l - 97 + 10 : l >= 65 ? l - 65 + 10 : l >= 48 && l <= 57 ? l - 48 : 1 / 0) >= e)
                                    break;
                                s = l, o = o * e + d;
                            }
                        }
                        return n && 95 === s && this.raiseRecoverable(this.pos - 1, 'Numeric separator is not allowed at the last of digits'), this.pos === a || null != t && this.pos - a !== t ? null : o;
                    }, Ge.readRadixNumber = function (e) {
                        var t = this.pos;
                        this.pos += 2;
                        var r = this.readInt(e);
                        return null == r && this.raise(this.start + 2, 'Expected number in radix ' + e), this.options.ecmaVersion >= 11 && 110 === this.input.charCodeAt(this.pos) ? (r = Ve(this.input.slice(t, this.pos)), ++this.pos) : d(this.fullCharCodeAtPos()) && this.raise(this.pos, 'Identifier directly after number'), this.finishToken(S.num, r);
                    }, Ge.readNumber = function (e) {
                        var t = this.pos;
                        e || null !== this.readInt(10, void 0, !0) || this.raise(t, 'Invalid number');
                        var r = this.pos - t >= 2 && 48 === this.input.charCodeAt(t);
                        r && this.strict && this.raise(t, 'Invalid number');
                        var n = this.input.charCodeAt(this.pos);
                        if (!r && !e && this.options.ecmaVersion >= 11 && 110 === n) {
                            var i = Ve(this.input.slice(t, this.pos));
                            return ++this.pos, d(this.fullCharCodeAtPos()) && this.raise(this.pos, 'Identifier directly after number'), this.finishToken(S.num, i);
                        }
                        r && /[89]/.test(this.input.slice(t, this.pos)) && (r = !1), 46 !== n || r || (++this.pos, this.readInt(10), n = this.input.charCodeAt(this.pos)), 69 !== n && 101 !== n || r || (43 !== (n = this.input.charCodeAt(++this.pos)) && 45 !== n || ++this.pos, null === this.readInt(10) && this.raise(t, 'Invalid number')), d(this.fullCharCodeAtPos()) && this.raise(this.pos, 'Identifier directly after number');
                        var a, o = (a = this.input.slice(t, this.pos), r ? parseInt(a, 8) : parseFloat(a.replace(/_/g, '')));
                        return this.finishToken(S.num, o);
                    }, Ge.readCodePoint = function () {
                        var e;
                        if (123 === this.input.charCodeAt(this.pos)) {
                            this.options.ecmaVersion < 6 && this.unexpected();
                            var t = ++this.pos;
                            e = this.readHexChar(this.input.indexOf('}', this.pos) - this.pos), ++this.pos, e > 1114111 && this.invalidStringToken(t, 'Code point out of bounds');
                        } else
                            e = this.readHexChar(4);
                        return e;
                    }, Ge.readString = function (e) {
                        for (var t = '', r = ++this.pos;;) {
                            this.pos >= this.input.length && this.raise(this.start, 'Unterminated string constant');
                            var n = this.input.charCodeAt(this.pos);
                            if (n === e)
                                break;
                            92 === n ? (t += this.input.slice(r, this.pos), t += this.readEscapedChar(!1), r = this.pos) : 8232 === n || 8233 === n ? (this.options.ecmaVersion < 10 && this.raise(this.start, 'Unterminated string constant'), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (A(n) && this.raise(this.start, 'Unterminated string constant'), ++this.pos);
                        }
                        return t += this.input.slice(r, this.pos++), this.finishToken(S.string, t);
                    };
                    var Ue = {};
                    Ge.tryReadTemplateToken = function () {
                        this.inTemplateElement = !0;
                        try {
                            this.readTmplToken();
                        } catch (e) {
                            if (e !== Ue)
                                throw e;
                            this.readInvalidTemplateToken();
                        }
                        this.inTemplateElement = !1;
                    }, Ge.invalidStringToken = function (e, t) {
                        if (this.inTemplateElement && this.options.ecmaVersion >= 9)
                            throw Ue;
                        this.raise(e, t);
                    }, Ge.readTmplToken = function () {
                        for (var e = '', t = this.pos;;) {
                            this.pos >= this.input.length && this.raise(this.start, 'Unterminated template');
                            var r = this.input.charCodeAt(this.pos);
                            if (96 === r || 36 === r && 123 === this.input.charCodeAt(this.pos + 1))
                                return this.pos !== this.start || this.type !== S.template && this.type !== S.invalidTemplate ? (e += this.input.slice(t, this.pos), this.finishToken(S.template, e)) : 36 === r ? (this.pos += 2, this.finishToken(S.dollarBraceL)) : (++this.pos, this.finishToken(S.backQuote));
                            if (92 === r)
                                e += this.input.slice(t, this.pos), e += this.readEscapedChar(!0), t = this.pos;
                            else if (A(r)) {
                                switch (e += this.input.slice(t, this.pos), ++this.pos, r) {
                                case 13:
                                    10 === this.input.charCodeAt(this.pos) && ++this.pos;
                                case 10:
                                    e += '\n';
                                    break;
                                default:
                                    e += String.fromCharCode(r);
                                }
                                this.options.locations && (++this.curLine, this.lineStart = this.pos), t = this.pos;
                            } else
                                ++this.pos;
                        }
                    }, Ge.readInvalidTemplateToken = function () {
                        for (; this.pos < this.input.length; this.pos++)
                            switch (this.input[this.pos]) {
                            case '\\':
                                ++this.pos;
                                break;
                            case '$':
                                if ('{' !== this.input[this.pos + 1])
                                    break;
                            case '`':
                                return this.finishToken(S.invalidTemplate, this.input.slice(this.start, this.pos));
                            }
                        this.raise(this.start, 'Unterminated template');
                    }, Ge.readEscapedChar = function (e) {
                        var t = this.input.charCodeAt(++this.pos);
                        switch (++this.pos, t) {
                        case 110:
                            return '\n';
                        case 114:
                            return '\r';
                        case 120:
                            return String.fromCharCode(this.readHexChar(2));
                        case 117:
                            return F(this.readCodePoint());
                        case 116:
                            return '\t';
                        case 98:
                            return '\b';
                        case 118:
                            return '\x0B';
                        case 102:
                            return '\f';
                        case 13:
                            10 === this.input.charCodeAt(this.pos) && ++this.pos;
                        case 10:
                            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), '';
                        case 56:
                        case 57:
                            if (this.strict && this.invalidStringToken(this.pos - 1, 'Invalid escape sequence'), e) {
                                var r = this.pos - 1;
                                this.invalidStringToken(r, 'Invalid escape sequence in template string');
                            }
                        default:
                            if (t >= 48 && t <= 55) {
                                var n = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], i = parseInt(n, 8);
                                return i > 255 && (n = n.slice(0, -1), i = parseInt(n, 8)), this.pos += n.length - 1, t = this.input.charCodeAt(this.pos), '0' === n && 56 !== t && 57 !== t || !this.strict && !e || this.invalidStringToken(this.pos - 1 - n.length, e ? 'Octal literal in template string' : 'Octal literal in strict mode'), String.fromCharCode(i);
                            }
                            return A(t) ? '' : String.fromCharCode(t);
                        }
                    }, Ge.readHexChar = function (e) {
                        var t = this.pos, r = this.readInt(16, e);
                        return null === r && this.invalidStringToken(t, 'Bad character escape sequence'), r;
                    }, Ge.readWord1 = function () {
                        this.containsEsc = !1;
                        for (var e = '', t = !0, r = this.pos, n = this.options.ecmaVersion >= 6; this.pos < this.input.length;) {
                            var i = this.fullCharCodeAtPos();
                            if (p(i, n))
                                this.pos += i <= 65535 ? 1 : 2;
                            else {
                                if (92 !== i)
                                    break;
                                this.containsEsc = !0, e += this.input.slice(r, this.pos);
                                var a = this.pos;
                                117 !== this.input.charCodeAt(++this.pos) && this.invalidStringToken(this.pos, 'Expecting Unicode escape sequence \\uXXXX'), ++this.pos;
                                var o = this.readCodePoint();
                                (t ? d : p)(o, n) || this.invalidStringToken(a, 'Invalid Unicode escape'), e += F(o), r = this.pos;
                            }
                            t = !1;
                        }
                        return e + this.input.slice(r, this.pos);
                    }, Ge.readWord = function () {
                        var e = this.readWord1(), t = S.name;
                        return this.keywords.test(e) && (t = y[e]), this.finishToken(t, e);
                    };
                    var He = '8.8.2';
                    V.acorn = {
                        Parser: V,
                        version: He,
                        defaultOptions: k,
                        Position: x,
                        SourceLocation: w,
                        getLineInfo: B,
                        Node: de,
                        TokenType: f,
                        tokTypes: S,
                        keywordTypes: y,
                        TokContext: re,
                        tokContexts: ne,
                        isIdentifierChar: p,
                        isIdentifierStart: d,
                        Token: je,
                        isNewLine: A,
                        lineBreak: v,
                        lineBreakG: C,
                        nonASCIIwhitespace: E
                    }, e.Node = de, e.Parser = V, e.Position = x, e.SourceLocation = w, e.TokContext = re, e.Token = je, e.TokenType = f, e.defaultOptions = k, e.getLineInfo = B, e.isIdentifierChar = p, e.isIdentifierStart = d, e.isNewLine = A, e.keywordTypes = y, e.lineBreak = v, e.lineBreakG = C, e.nonASCIIwhitespace = E, e.parse = function (e, t) {
                        return V.parse(e, t);
                    }, e.parseExpressionAt = function (e, t, r) {
                        return V.parseExpressionAt(e, t, r);
                    }, e.tokContexts = ne, e.tokTypes = S, e.tokenizer = function (e, t) {
                        return V.tokenizer(e, t);
                    }, e.version = He;
                }(t);
            },
            6434: (e, t, r) => {
                'use strict';
                e = r.nmd(e);
                const n = (e, t) => (...r) => `[${ e(...r) + t }m`, i = (e, t) => (...r) => {
                        const n = e(...r);
                        return `[${ 38 + t };5;${ n }m`;
                    }, a = (e, t) => (...r) => {
                        const n = e(...r);
                        return `[${ 38 + t };2;${ n[0] };${ n[1] };${ n[2] }m`;
                    }, o = e => e, s = (e, t, r) => [
                        e,
                        t,
                        r
                    ], c = (e, t, r) => {
                        Object.defineProperty(e, t, {
                            get: () => {
                                const n = r();
                                return Object.defineProperty(e, t, {
                                    value: n,
                                    enumerable: !0,
                                    configurable: !0
                                }), n;
                            },
                            enumerable: !0,
                            configurable: !0
                        });
                    };
                let u;
                const l = (e, t, n, i) => {
                    void 0 === u && (u = r(2085));
                    const a = i ? 10 : 0, o = {};
                    for (const [r, i] of Object.entries(u)) {
                        const s = 'ansi16' === r ? 'ansi' : r;
                        r === t ? o[s] = e(n, a) : 'object' == typeof i && (o[s] = e(i[t], a));
                    }
                    return o;
                };
                Object.defineProperty(e, 'exports', {
                    enumerable: !0,
                    get: function () {
                        const e = new Map(), t = {
                                modifier: {
                                    reset: [
                                        0,
                                        0
                                    ],
                                    bold: [
                                        1,
                                        22
                                    ],
                                    dim: [
                                        2,
                                        22
                                    ],
                                    italic: [
                                        3,
                                        23
                                    ],
                                    underline: [
                                        4,
                                        24
                                    ],
                                    inverse: [
                                        7,
                                        27
                                    ],
                                    hidden: [
                                        8,
                                        28
                                    ],
                                    strikethrough: [
                                        9,
                                        29
                                    ]
                                },
                                color: {
                                    black: [
                                        30,
                                        39
                                    ],
                                    red: [
                                        31,
                                        39
                                    ],
                                    green: [
                                        32,
                                        39
                                    ],
                                    yellow: [
                                        33,
                                        39
                                    ],
                                    blue: [
                                        34,
                                        39
                                    ],
                                    magenta: [
                                        35,
                                        39
                                    ],
                                    cyan: [
                                        36,
                                        39
                                    ],
                                    white: [
                                        37,
                                        39
                                    ],
                                    blackBright: [
                                        90,
                                        39
                                    ],
                                    redBright: [
                                        91,
                                        39
                                    ],
                                    greenBright: [
                                        92,
                                        39
                                    ],
                                    yellowBright: [
                                        93,
                                        39
                                    ],
                                    blueBright: [
                                        94,
                                        39
                                    ],
                                    magentaBright: [
                                        95,
                                        39
                                    ],
                                    cyanBright: [
                                        96,
                                        39
                                    ],
                                    whiteBright: [
                                        97,
                                        39
                                    ]
                                },
                                bgColor: {
                                    bgBlack: [
                                        40,
                                        49
                                    ],
                                    bgRed: [
                                        41,
                                        49
                                    ],
                                    bgGreen: [
                                        42,
                                        49
                                    ],
                                    bgYellow: [
                                        43,
                                        49
                                    ],
                                    bgBlue: [
                                        44,
                                        49
                                    ],
                                    bgMagenta: [
                                        45,
                                        49
                                    ],
                                    bgCyan: [
                                        46,
                                        49
                                    ],
                                    bgWhite: [
                                        47,
                                        49
                                    ],
                                    bgBlackBright: [
                                        100,
                                        49
                                    ],
                                    bgRedBright: [
                                        101,
                                        49
                                    ],
                                    bgGreenBright: [
                                        102,
                                        49
                                    ],
                                    bgYellowBright: [
                                        103,
                                        49
                                    ],
                                    bgBlueBright: [
                                        104,
                                        49
                                    ],
                                    bgMagentaBright: [
                                        105,
                                        49
                                    ],
                                    bgCyanBright: [
                                        106,
                                        49
                                    ],
                                    bgWhiteBright: [
                                        107,
                                        49
                                    ]
                                }
                            };
                        t.color.gray = t.color.blackBright, t.bgColor.bgGray = t.bgColor.bgBlackBright, t.color.grey = t.color.blackBright, t.bgColor.bgGrey = t.bgColor.bgBlackBright;
                        for (const [r, n] of Object.entries(t)) {
                            for (const [r, i] of Object.entries(n))
                                t[r] = {
                                    open: `[${ i[0] }m`,
                                    close: `[${ i[1] }m`
                                }, n[r] = t[r], e.set(i[0], i[1]);
                            Object.defineProperty(t, r, {
                                value: n,
                                enumerable: !1
                            });
                        }
                        return Object.defineProperty(t, 'codes', {
                            value: e,
                            enumerable: !1
                        }), t.color.close = '\x1B[39m', t.bgColor.close = '\x1B[49m', c(t.color, 'ansi', () => l(n, 'ansi16', o, !1)), c(t.color, 'ansi256', () => l(i, 'ansi256', o, !1)), c(t.color, 'ansi16m', () => l(a, 'rgb', s, !1)), c(t.bgColor, 'ansi', () => l(n, 'ansi16', o, !0)), c(t.bgColor, 'ansi256', () => l(i, 'ansi256', o, !0)), c(t.bgColor, 'ansi16m', () => l(a, 'rgb', s, !0)), t;
                    }
                });
            },
            2190: e => {
                e.exports = function (e, r, n) {
                    if (e.filter)
                        return e.filter(r, n);
                    if (null == e)
                        throw new TypeError();
                    if ('function' != typeof r)
                        throw new TypeError();
                    for (var i = [], a = 0; a < e.length; a++)
                        if (t.call(e, a)) {
                            var o = e[a];
                            r.call(n, o, a, e) && i.push(o);
                        }
                    return i;
                };
                var t = Object.prototype.hasOwnProperty;
            },
            9282: (e, t, r) => {
                'use strict';
                var n = r(4155);
                function i(e) {
                    return (i = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                var a, o, s = r(2136).codes, c = s.ERR_AMBIGUOUS_ARGUMENT, u = s.ERR_INVALID_ARG_TYPE, l = s.ERR_INVALID_ARG_VALUE, d = s.ERR_INVALID_RETURN_VALUE, p = s.ERR_MISSING_ARGS, f = r(5961), m = r(9539).inspect, h = r(9539).types, g = h.isPromise, y = h.isRegExp, b = Object.assign ? Object.assign : r(8091).assign, S = Object.is ? Object.is : r(609);
                function v() {
                    var e = r(9158);
                    a = e.isDeepEqual, o = e.isDeepStrictEqual;
                }
                new Map();
                var C = !1, A = e.exports = I, _ = {};
                function E(e) {
                    if (e.message instanceof Error)
                        throw e.message;
                    throw new f(e);
                }
                function N(e, t, r, n) {
                    if (!r) {
                        var i = !1;
                        if (0 === t)
                            i = !0, n = 'No value argument passed to `assert.ok()`';
                        else if (n instanceof Error)
                            throw n;
                        var a = new f({
                            actual: r,
                            expected: !0,
                            message: n,
                            operator: '==',
                            stackStartFn: e
                        });
                        throw a.generatedMessage = i, a;
                    }
                }
                function I() {
                    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
                        t[r] = arguments[r];
                    N.apply(void 0, [
                        I,
                        t.length
                    ].concat(t));
                }
                A.fail = function e(t, r, i, a, o) {
                    var s, c = arguments.length;
                    if (0 === c)
                        s = 'Failed';
                    else if (1 === c)
                        i = t, t = void 0;
                    else {
                        if (!1 === C) {
                            C = !0;
                            var u = n.emitWarning ? n.emitWarning : console.warn.bind(console);
                            u('assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.', 'DeprecationWarning', 'DEP0094');
                        }
                        2 === c && (a = '!=');
                    }
                    if (i instanceof Error)
                        throw i;
                    var l = {
                        actual: t,
                        expected: r,
                        operator: void 0 === a ? 'fail' : a,
                        stackStartFn: o || e
                    };
                    void 0 !== i && (l.message = i);
                    var d = new f(l);
                    throw s && (d.message = s, d.generatedMessage = !0), d;
                }, A.AssertionError = f, A.ok = I, A.equal = function e(t, r, n) {
                    if (arguments.length < 2)
                        throw new p('actual', 'expected');
                    t != r && E({
                        actual: t,
                        expected: r,
                        message: n,
                        operator: '==',
                        stackStartFn: e
                    });
                }, A.notEqual = function e(t, r, n) {
                    if (arguments.length < 2)
                        throw new p('actual', 'expected');
                    t == r && E({
                        actual: t,
                        expected: r,
                        message: n,
                        operator: '!=',
                        stackStartFn: e
                    });
                }, A.deepEqual = function e(t, r, n) {
                    if (arguments.length < 2)
                        throw new p('actual', 'expected');
                    void 0 === a && v(), a(t, r) || E({
                        actual: t,
                        expected: r,
                        message: n,
                        operator: 'deepEqual',
                        stackStartFn: e
                    });
                }, A.notDeepEqual = function e(t, r, n) {
                    if (arguments.length < 2)
                        throw new p('actual', 'expected');
                    void 0 === a && v(), a(t, r) && E({
                        actual: t,
                        expected: r,
                        message: n,
                        operator: 'notDeepEqual',
                        stackStartFn: e
                    });
                }, A.deepStrictEqual = function e(t, r, n) {
                    if (arguments.length < 2)
                        throw new p('actual', 'expected');
                    void 0 === a && v(), o(t, r) || E({
                        actual: t,
                        expected: r,
                        message: n,
                        operator: 'deepStrictEqual',
                        stackStartFn: e
                    });
                }, A.notDeepStrictEqual = function e(t, r, n) {
                    if (arguments.length < 2)
                        throw new p('actual', 'expected');
                    void 0 === a && v(), o(t, r) && E({
                        actual: t,
                        expected: r,
                        message: n,
                        operator: 'notDeepStrictEqual',
                        stackStartFn: e
                    });
                }, A.strictEqual = function e(t, r, n) {
                    if (arguments.length < 2)
                        throw new p('actual', 'expected');
                    S(t, r) || E({
                        actual: t,
                        expected: r,
                        message: n,
                        operator: 'strictEqual',
                        stackStartFn: e
                    });
                }, A.notStrictEqual = function e(t, r, n) {
                    if (arguments.length < 2)
                        throw new p('actual', 'expected');
                    S(t, r) && E({
                        actual: t,
                        expected: r,
                        message: n,
                        operator: 'notStrictEqual',
                        stackStartFn: e
                    });
                };
                var T = function e(t, r, n) {
                    var i = this;
                    !function (e, t) {
                        if (!(e instanceof t))
                            throw new TypeError('Cannot call a class as a function');
                    }(this, e), r.forEach(function (e) {
                        e in t && (void 0 !== n && 'string' == typeof n[e] && y(t[e]) && t[e].test(n[e]) ? i[e] = n[e] : i[e] = t[e]);
                    });
                };
                function D(e, t, r, n, i, a) {
                    if (!(r in e) || !o(e[r], t[r])) {
                        if (!n) {
                            var s = new T(e, i), c = new T(t, i, e), u = new f({
                                    actual: s,
                                    expected: c,
                                    operator: 'deepStrictEqual',
                                    stackStartFn: a
                                });
                            throw u.actual = e, u.expected = t, u.operator = a.name, u;
                        }
                        E({
                            actual: e,
                            expected: t,
                            message: n,
                            operator: a.name,
                            stackStartFn: a
                        });
                    }
                }
                function O(e, t, r, n) {
                    if ('function' != typeof t) {
                        if (y(t))
                            return t.test(e);
                        if (2 === arguments.length)
                            throw new u('expected', [
                                'Function',
                                'RegExp'
                            ], t);
                        if ('object' !== i(e) || null === e) {
                            var o = new f({
                                actual: e,
                                expected: t,
                                message: r,
                                operator: 'deepStrictEqual',
                                stackStartFn: n
                            });
                            throw o.operator = n.name, o;
                        }
                        var s = Object.keys(t);
                        if (t instanceof Error)
                            s.push('name', 'message');
                        else if (0 === s.length)
                            throw new l('error', t, 'may not be an empty object');
                        return void 0 === a && v(), s.forEach(function (i) {
                            'string' == typeof e[i] && y(t[i]) && t[i].test(e[i]) || D(e, t, i, r, s, n);
                        }), !0;
                    }
                    return void 0 !== t.prototype && e instanceof t || !Error.isPrototypeOf(t) && !0 === t.call({}, e);
                }
                function R(e) {
                    if ('function' != typeof e)
                        throw new u('fn', 'Function', e);
                    try {
                        e();
                    } catch (e) {
                        return e;
                    }
                    return _;
                }
                function M(e) {
                    return g(e) || null !== e && 'object' === i(e) && 'function' == typeof e.then && 'function' == typeof e.catch;
                }
                function F(e) {
                    return Promise.resolve().then(function () {
                        var t;
                        if ('function' == typeof e) {
                            if (!M(t = e()))
                                throw new d('instance of Promise', 'promiseFn', t);
                        } else {
                            if (!M(e))
                                throw new u('promiseFn', [
                                    'Function',
                                    'Promise'
                                ], e);
                            t = e;
                        }
                        return Promise.resolve().then(function () {
                            return t;
                        }).then(function () {
                            return _;
                        }).catch(function (e) {
                            return e;
                        });
                    });
                }
                function P(e, t, r, n) {
                    if ('string' == typeof r) {
                        if (4 === arguments.length)
                            throw new u('error', [
                                'Object',
                                'Error',
                                'Function',
                                'RegExp'
                            ], r);
                        if ('object' === i(t) && null !== t) {
                            if (t.message === r)
                                throw new c('error/message', 'The error message "'.concat(t.message, '" is identical to the message.'));
                        } else if (t === r)
                            throw new c('error/message', 'The error "'.concat(t, '" is identical to the message.'));
                        n = r, r = void 0;
                    } else if (null != r && 'object' !== i(r) && 'function' != typeof r)
                        throw new u('error', [
                            'Object',
                            'Error',
                            'Function',
                            'RegExp'
                        ], r);
                    if (t === _) {
                        var a = '';
                        r && r.name && (a += ' ('.concat(r.name, ')')), a += n ? ': '.concat(n) : '.';
                        var o = 'rejects' === e.name ? 'rejection' : 'exception';
                        E({
                            actual: void 0,
                            expected: r,
                            operator: e.name,
                            message: 'Missing expected '.concat(o).concat(a),
                            stackStartFn: e
                        });
                    }
                    if (r && !O(t, r, n, e))
                        throw t;
                }
                function x(e, t, r, n) {
                    if (t !== _) {
                        if ('string' == typeof r && (n = r, r = void 0), !r || O(t, r)) {
                            var i = n ? ': '.concat(n) : '.', a = 'doesNotReject' === e.name ? 'rejection' : 'exception';
                            E({
                                actual: t,
                                expected: r,
                                operator: e.name,
                                message: 'Got unwanted '.concat(a).concat(i, '\n') + 'Actual message: "'.concat(t && t.message, '"'),
                                stackStartFn: e
                            });
                        }
                        throw t;
                    }
                }
                function w() {
                    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
                        t[r] = arguments[r];
                    N.apply(void 0, [
                        w,
                        t.length
                    ].concat(t));
                }
                A.throws = function e(t) {
                    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
                        n[i - 1] = arguments[i];
                    P.apply(void 0, [
                        e,
                        R(t)
                    ].concat(n));
                }, A.rejects = function e(t) {
                    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
                        n[i - 1] = arguments[i];
                    return F(t).then(function (t) {
                        return P.apply(void 0, [
                            e,
                            t
                        ].concat(n));
                    });
                }, A.doesNotThrow = function e(t) {
                    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
                        n[i - 1] = arguments[i];
                    x.apply(void 0, [
                        e,
                        R(t)
                    ].concat(n));
                }, A.doesNotReject = function e(t) {
                    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
                        n[i - 1] = arguments[i];
                    return F(t).then(function (t) {
                        return x.apply(void 0, [
                            e,
                            t
                        ].concat(n));
                    });
                }, A.ifError = function e(t) {
                    if (null != t) {
                        var r = 'ifError got unwanted exception: ';
                        'object' === i(t) && 'string' == typeof t.message ? 0 === t.message.length && t.constructor ? r += t.constructor.name : r += t.message : r += m(t);
                        var n = new f({
                                actual: t,
                                expected: null,
                                operator: 'ifError',
                                message: r,
                                stackStartFn: e
                            }), a = t.stack;
                        if ('string' == typeof a) {
                            var o = a.split('\n');
                            o.shift();
                            for (var s = n.stack.split('\n'), c = 0; c < o.length; c++) {
                                var u = s.indexOf(o[c]);
                                if (-1 !== u) {
                                    s = s.slice(0, u);
                                    break;
                                }
                            }
                            n.stack = ''.concat(s.join('\n'), '\n').concat(o.join('\n'));
                        }
                        throw n;
                    }
                }, A.strict = b(w, A, {
                    equal: A.strictEqual,
                    deepEqual: A.deepStrictEqual,
                    notEqual: A.notStrictEqual,
                    notDeepEqual: A.notDeepStrictEqual
                }), A.strict.strict = A.strict;
            },
            5961: (e, t, r) => {
                'use strict';
                var n = r(4155);
                function i(e, t, r) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function a(e, t) {
                    for (var r = 0; r < t.length; r++) {
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                function o(e, t) {
                    return !t || 'object' !== f(t) && 'function' != typeof t ? s(e) : t;
                }
                function s(e) {
                    if (void 0 === e)
                        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
                    return e;
                }
                function c(e) {
                    var t = 'function' == typeof Map ? new Map() : void 0;
                    return (c = function (e) {
                        if (null === e || (r = e, -1 === Function.toString.call(r).indexOf('[native code]')))
                            return e;
                        var r;
                        if ('function' != typeof e)
                            throw new TypeError('Super expression must either be null or a function');
                        if (void 0 !== t) {
                            if (t.has(e))
                                return t.get(e);
                            t.set(e, n);
                        }
                        function n() {
                            return l(e, arguments, p(this).constructor);
                        }
                        return n.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: n,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), d(n, e);
                    })(e);
                }
                function u() {
                    if ('undefined' == typeof Reflect || !Reflect.construct)
                        return !1;
                    if (Reflect.construct.sham)
                        return !1;
                    if ('function' == typeof Proxy)
                        return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {
                        })), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function l(e, t, r) {
                    return (l = u() ? Reflect.construct : function (e, t, r) {
                        var n = [null];
                        n.push.apply(n, t);
                        var i = new (Function.bind.apply(e, n))();
                        return r && d(i, r.prototype), i;
                    }).apply(null, arguments);
                }
                function d(e, t) {
                    return (d = Object.setPrototypeOf || function (e, t) {
                        return e.__proto__ = t, e;
                    })(e, t);
                }
                function p(e) {
                    return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    })(e);
                }
                function f(e) {
                    return (f = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                var m = r(9539).inspect, h = r(2136).codes.ERR_INVALID_ARG_TYPE;
                function g(e, t, r) {
                    return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                }
                var y = '', b = '', S = '', v = '', C = {
                        deepStrictEqual: 'Expected values to be strictly deep-equal:',
                        strictEqual: 'Expected values to be strictly equal:',
                        strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
                        deepEqual: 'Expected values to be loosely deep-equal:',
                        equal: 'Expected values to be loosely equal:',
                        notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
                        notStrictEqual: 'Expected "actual" to be strictly unequal to:',
                        notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
                        notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
                        notEqual: 'Expected "actual" to be loosely unequal to:',
                        notIdentical: 'Values identical but not reference-equal:'
                    };
                function A(e) {
                    var t = Object.keys(e), r = Object.create(Object.getPrototypeOf(e));
                    return t.forEach(function (t) {
                        r[t] = e[t];
                    }), Object.defineProperty(r, 'message', { value: e.message }), r;
                }
                function _(e) {
                    return m(e, {
                        compact: !1,
                        customInspect: !1,
                        depth: 1000,
                        maxArrayLength: 1 / 0,
                        showHidden: !1,
                        breakLength: 1 / 0,
                        showProxy: !1,
                        sorted: !0,
                        getters: !0
                    });
                }
                var E = function (e) {
                    function t(e) {
                        var r;
                        if (function (e, t) {
                                if (!(e instanceof t))
                                    throw new TypeError('Cannot call a class as a function');
                            }(this, t), 'object' !== f(e) || null === e)
                            throw new h('options', 'Object', e);
                        var i = e.message, a = e.operator, c = e.stackStartFn, u = e.actual, l = e.expected, d = Error.stackTraceLimit;
                        if (Error.stackTraceLimit = 0, null != i)
                            r = o(this, p(t).call(this, String(i)));
                        else if (n.stderr && n.stderr.isTTY && (n.stderr && n.stderr.getColorDepth && 1 !== n.stderr.getColorDepth() ? (y = '\x1B[34m', b = '\x1B[32m', v = '\x1B[39m', S = '\x1B[31m') : (y = '', b = '', v = '', S = '')), 'object' === f(u) && null !== u && 'object' === f(l) && null !== l && 'stack' in u && u instanceof Error && 'stack' in l && l instanceof Error && (u = A(u), l = A(l)), 'deepStrictEqual' === a || 'strictEqual' === a)
                            r = o(this, p(t).call(this, function (e, t, r) {
                                var i = '', a = '', o = 0, s = '', c = !1, u = _(e), l = u.split('\n'), d = _(t).split('\n'), p = 0, m = '';
                                if ('strictEqual' === r && 'object' === f(e) && 'object' === f(t) && null !== e && null !== t && (r = 'strictEqualObject'), 1 === l.length && 1 === d.length && l[0] !== d[0]) {
                                    var h = l[0].length + d[0].length;
                                    if (h <= 10) {
                                        if (!('object' === f(e) && null !== e || 'object' === f(t) && null !== t || 0 === e && 0 === t))
                                            return ''.concat(C[r], '\n\n') + ''.concat(l[0], ' !== ').concat(d[0], '\n');
                                    } else if ('strictEqualObject' !== r && h < (n.stderr && n.stderr.isTTY ? n.stderr.columns : 80)) {
                                        for (; l[0][p] === d[0][p];)
                                            p++;
                                        p > 2 && (m = '\n  '.concat(function (e, t) {
                                            if (t = Math.floor(t), 0 == e.length || 0 == t)
                                                return '';
                                            var r = e.length * t;
                                            for (t = Math.floor(Math.log(t) / Math.log(2)); t;)
                                                e += e, t--;
                                            return e + e.substring(0, r - e.length);
                                        }(' ', p), '^'), p = 0);
                                    }
                                }
                                for (var A = l[l.length - 1], E = d[d.length - 1]; A === E && (p++ < 2 ? s = '\n  '.concat(A).concat(s) : i = A, l.pop(), d.pop(), 0 !== l.length && 0 !== d.length);)
                                    A = l[l.length - 1], E = d[d.length - 1];
                                var N = Math.max(l.length, d.length);
                                if (0 === N) {
                                    var I = u.split('\n');
                                    if (I.length > 30)
                                        for (I[26] = ''.concat(y, '...').concat(v); I.length > 27;)
                                            I.pop();
                                    return ''.concat(C.notIdentical, '\n\n').concat(I.join('\n'), '\n');
                                }
                                p > 3 && (s = '\n'.concat(y, '...').concat(v).concat(s), c = !0), '' !== i && (s = '\n  '.concat(i).concat(s), i = '');
                                var T = 0, D = C[r] + '\n'.concat(b, '+ actual').concat(v, ' ').concat(S, '- expected').concat(v), O = ' '.concat(y, '...').concat(v, ' Lines skipped');
                                for (p = 0; p < N; p++) {
                                    var R = p - o;
                                    if (l.length < p + 1)
                                        R > 1 && p > 2 && (R > 4 ? (a += '\n'.concat(y, '...').concat(v), c = !0) : R > 3 && (a += '\n  '.concat(d[p - 2]), T++), a += '\n  '.concat(d[p - 1]), T++), o = p, i += '\n'.concat(S, '-').concat(v, ' ').concat(d[p]), T++;
                                    else if (d.length < p + 1)
                                        R > 1 && p > 2 && (R > 4 ? (a += '\n'.concat(y, '...').concat(v), c = !0) : R > 3 && (a += '\n  '.concat(l[p - 2]), T++), a += '\n  '.concat(l[p - 1]), T++), o = p, a += '\n'.concat(b, '+').concat(v, ' ').concat(l[p]), T++;
                                    else {
                                        var M = d[p], F = l[p], P = F !== M && (!g(F, ',') || F.slice(0, -1) !== M);
                                        P && g(M, ',') && M.slice(0, -1) === F && (P = !1, F += ','), P ? (R > 1 && p > 2 && (R > 4 ? (a += '\n'.concat(y, '...').concat(v), c = !0) : R > 3 && (a += '\n  '.concat(l[p - 2]), T++), a += '\n  '.concat(l[p - 1]), T++), o = p, a += '\n'.concat(b, '+').concat(v, ' ').concat(F), i += '\n'.concat(S, '-').concat(v, ' ').concat(M), T += 2) : (a += i, i = '', 1 !== R && 0 !== p || (a += '\n  '.concat(F), T++));
                                    }
                                    if (T > 20 && p < N - 2)
                                        return ''.concat(D).concat(O, '\n').concat(a, '\n').concat(y, '...').concat(v).concat(i, '\n') + ''.concat(y, '...').concat(v);
                                }
                                return ''.concat(D).concat(c ? O : '', '\n').concat(a).concat(i).concat(s).concat(m);
                            }(u, l, a)));
                        else if ('notDeepStrictEqual' === a || 'notStrictEqual' === a) {
                            var m = C[a], E = _(u).split('\n');
                            if ('notStrictEqual' === a && 'object' === f(u) && null !== u && (m = C.notStrictEqualObject), E.length > 30)
                                for (E[26] = ''.concat(y, '...').concat(v); E.length > 27;)
                                    E.pop();
                            r = 1 === E.length ? o(this, p(t).call(this, ''.concat(m, ' ').concat(E[0]))) : o(this, p(t).call(this, ''.concat(m, '\n\n').concat(E.join('\n'), '\n')));
                        } else {
                            var N = _(u), I = '', T = C[a];
                            'notDeepEqual' === a || 'notEqual' === a ? (N = ''.concat(C[a], '\n\n').concat(N)).length > 1024 && (N = ''.concat(N.slice(0, 1021), '...')) : (I = ''.concat(_(l)), N.length > 512 && (N = ''.concat(N.slice(0, 509), '...')), I.length > 512 && (I = ''.concat(I.slice(0, 509), '...')), 'deepEqual' === a || 'equal' === a ? N = ''.concat(T, '\n\n').concat(N, '\n\nshould equal\n\n') : I = ' '.concat(a, ' ').concat(I)), r = o(this, p(t).call(this, ''.concat(N).concat(I)));
                        }
                        return Error.stackTraceLimit = d, r.generatedMessage = !i, Object.defineProperty(s(r), 'name', {
                            value: 'AssertionError [ERR_ASSERTION]',
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }), r.code = 'ERR_ASSERTION', r.actual = u, r.expected = l, r.operator = a, Error.captureStackTrace && Error.captureStackTrace(s(r), c), r.stack, r.name = 'AssertionError', o(r);
                    }
                    var r, c;
                    return function (e, t) {
                        if ('function' != typeof t && null !== t)
                            throw new TypeError('Super expression must either be null or a function');
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && d(e, t);
                    }(t, e), r = t, (c = [
                        {
                            key: 'toString',
                            value: function () {
                                return ''.concat(this.name, ' [').concat(this.code, ']: ').concat(this.message);
                            }
                        },
                        {
                            key: m.custom,
                            value: function (e, t) {
                                return m(this, function (e) {
                                    for (var t = 1; t < arguments.length; t++) {
                                        var r = null != arguments[t] ? arguments[t] : {}, n = Object.keys(r);
                                        'function' == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
                                            return Object.getOwnPropertyDescriptor(r, e).enumerable;
                                        }))), n.forEach(function (t) {
                                            i(e, t, r[t]);
                                        });
                                    }
                                    return e;
                                }({}, t, {
                                    customInspect: !1,
                                    depth: 0
                                }));
                            }
                        }
                    ]) && a(r.prototype, c), t;
                }(c(Error));
                e.exports = E;
            },
            2136: (e, t, r) => {
                'use strict';
                function n(e) {
                    return (n = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                function i(e) {
                    return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    })(e);
                }
                function a(e, t) {
                    return (a = Object.setPrototypeOf || function (e, t) {
                        return e.__proto__ = t, e;
                    })(e, t);
                }
                var o, s, c = {};
                function u(e, t, r) {
                    r || (r = Error);
                    var o = function (r) {
                        function o(r, a, s) {
                            var c;
                            return function (e, t) {
                                if (!(e instanceof t))
                                    throw new TypeError('Cannot call a class as a function');
                            }(this, o), (c = function (e, t) {
                                return !t || 'object' !== n(t) && 'function' != typeof t ? function (e) {
                                    if (void 0 === e)
                                        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
                                    return e;
                                }(e) : t;
                            }(this, i(o).call(this, function (e, r, n) {
                                return 'string' == typeof t ? t : t(e, r, n);
                            }(r, a, s)))).code = e, c;
                        }
                        return function (e, t) {
                            if ('function' != typeof t && null !== t)
                                throw new TypeError('Super expression must either be null or a function');
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && a(e, t);
                        }(o, r), o;
                    }(r);
                    c[e] = o;
                }
                function l(e, t) {
                    if (Array.isArray(e)) {
                        var r = e.length;
                        return e = e.map(function (e) {
                            return String(e);
                        }), r > 2 ? 'one of '.concat(t, ' ').concat(e.slice(0, r - 1).join(', '), ', or ') + e[r - 1] : 2 === r ? 'one of '.concat(t, ' ').concat(e[0], ' or ').concat(e[1]) : 'of '.concat(t, ' ').concat(e[0]);
                    }
                    return 'of '.concat(t, ' ').concat(String(e));
                }
                u('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError), u('ERR_INVALID_ARG_TYPE', function (e, t, i) {
                    var a, s, c, u, d;
                    if (void 0 === o && (o = r(9282)), o('string' == typeof e, '\'name\' must be a string'), 'string' == typeof t && (s = 'not ', t.substr(0, s.length) === s) ? (a = 'must not be', t = t.replace(/^not /, '')) : a = 'must be', function (e, t, r) {
                            return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                        }(e, ' argument'))
                        c = 'The '.concat(e, ' ').concat(a, ' ').concat(l(t, 'type'));
                    else {
                        var p = ('number' != typeof d && (d = 0), d + '.'.length > (u = e).length || -1 === u.indexOf('.', d) ? 'argument' : 'property');
                        c = 'The "'.concat(e, '" ').concat(p, ' ').concat(a, ' ').concat(l(t, 'type'));
                    }
                    return c + '. Received type '.concat(n(i));
                }, TypeError), u('ERR_INVALID_ARG_VALUE', function (e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 'is invalid';
                    void 0 === s && (s = r(9539));
                    var i = s.inspect(t);
                    return i.length > 128 && (i = ''.concat(i.slice(0, 128), '...')), 'The argument \''.concat(e, '\' ').concat(n, '. Received ').concat(i);
                }, TypeError, RangeError), u('ERR_INVALID_RETURN_VALUE', function (e, t, r) {
                    var i;
                    return i = r && r.constructor && r.constructor.name ? 'instance of '.concat(r.constructor.name) : 'type '.concat(n(r)), 'Expected '.concat(e, ' to be returned from the "').concat(t, '"') + ' function but got '.concat(i, '.');
                }, TypeError), u('ERR_MISSING_ARGS', function () {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                        t[n] = arguments[n];
                    void 0 === o && (o = r(9282)), o(t.length > 0, 'At least one arg needs to be specified');
                    var i = 'The ', a = t.length;
                    switch (t = t.map(function (e) {
                            return '"'.concat(e, '"');
                        }), a) {
                    case 1:
                        i += ''.concat(t[0], ' argument');
                        break;
                    case 2:
                        i += ''.concat(t[0], ' and ').concat(t[1], ' arguments');
                        break;
                    default:
                        i += t.slice(0, a - 1).join(', '), i += ', and '.concat(t[a - 1], ' arguments');
                    }
                    return ''.concat(i, ' must be specified');
                }, TypeError), e.exports.codes = c;
            },
            9158: (e, t, r) => {
                'use strict';
                function n(e, t) {
                    return function (e) {
                        if (Array.isArray(e))
                            return e;
                    }(e) || function (e, t) {
                        var r = [], n = !0, i = !1, a = void 0;
                        try {
                            for (var o, s = e[Symbol.iterator](); !(n = (o = s.next()).done) && (r.push(o.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            i = !0, a = e;
                        } finally {
                            try {
                                n || null == s.return || s.return();
                            } finally {
                                if (i)
                                    throw a;
                            }
                        }
                        return r;
                    }(e, t) || function () {
                        throw new TypeError('Invalid attempt to destructure non-iterable instance');
                    }();
                }
                function i(e) {
                    return (i = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                var a = void 0 !== /a/g.flags, o = function (e) {
                        var t = [];
                        return e.forEach(function (e) {
                            return t.push(e);
                        }), t;
                    }, s = function (e) {
                        var t = [];
                        return e.forEach(function (e, r) {
                            return t.push([
                                r,
                                e
                            ]);
                        }), t;
                    }, c = Object.is ? Object.is : r(609), u = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function () {
                        return [];
                    }, l = Number.isNaN ? Number.isNaN : r(360);
                function d(e) {
                    return e.call.bind(e);
                }
                var p = d(Object.prototype.hasOwnProperty), f = d(Object.prototype.propertyIsEnumerable), m = d(Object.prototype.toString), h = r(9539).types, g = h.isAnyArrayBuffer, y = h.isArrayBufferView, b = h.isDate, S = h.isMap, v = h.isRegExp, C = h.isSet, A = h.isNativeError, _ = h.isBoxedPrimitive, E = h.isNumberObject, N = h.isStringObject, I = h.isBooleanObject, T = h.isBigIntObject, D = h.isSymbolObject, O = h.isFloat32Array, R = h.isFloat64Array;
                function M(e) {
                    if (0 === e.length || e.length > 10)
                        return !0;
                    for (var t = 0; t < e.length; t++) {
                        var r = e.charCodeAt(t);
                        if (r < 48 || r > 57)
                            return !0;
                    }
                    return 10 === e.length && e >= Math.pow(2, 32);
                }
                function F(e) {
                    return Object.keys(e).filter(M).concat(u(e).filter(Object.prototype.propertyIsEnumerable.bind(e)));
                }
                function P(e, t) {
                    if (e === t)
                        return 0;
                    for (var r = e.length, n = t.length, i = 0, a = Math.min(r, n); i < a; ++i)
                        if (e[i] !== t[i]) {
                            r = e[i], n = t[i];
                            break;
                        }
                    return r < n ? -1 : n < r ? 1 : 0;
                }
                function x(e, t, r, n) {
                    if (e === t)
                        return 0 !== e || !r || c(e, t);
                    if (r) {
                        if ('object' !== i(e))
                            return 'number' == typeof e && l(e) && l(t);
                        if ('object' !== i(t) || null === e || null === t)
                            return !1;
                        if (Object.getPrototypeOf(e) !== Object.getPrototypeOf(t))
                            return !1;
                    } else {
                        if (null === e || 'object' !== i(e))
                            return (null === t || 'object' !== i(t)) && e == t;
                        if (null === t || 'object' !== i(t))
                            return !1;
                    }
                    var o, s, u, d, p = m(e);
                    if (p !== m(t))
                        return !1;
                    if (Array.isArray(e)) {
                        if (e.length !== t.length)
                            return !1;
                        var f = F(e), h = F(t);
                        return f.length === h.length && B(e, t, r, n, 1, f);
                    }
                    if ('[object Object]' === p && (!S(e) && S(t) || !C(e) && C(t)))
                        return !1;
                    if (b(e)) {
                        if (!b(t) || Date.prototype.getTime.call(e) !== Date.prototype.getTime.call(t))
                            return !1;
                    } else if (v(e)) {
                        if (!v(t) || (u = e, d = t, !(a ? u.source === d.source && u.flags === d.flags : RegExp.prototype.toString.call(u) === RegExp.prototype.toString.call(d))))
                            return !1;
                    } else if (A(e) || e instanceof Error) {
                        if (e.message !== t.message || e.name !== t.name)
                            return !1;
                    } else {
                        if (y(e)) {
                            if (r || !O(e) && !R(e)) {
                                if (!function (e, t) {
                                        return e.byteLength === t.byteLength && 0 === P(new Uint8Array(e.buffer, e.byteOffset, e.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
                                    }(e, t))
                                    return !1;
                            } else if (!function (e, t) {
                                    if (e.byteLength !== t.byteLength)
                                        return !1;
                                    for (var r = 0; r < e.byteLength; r++)
                                        if (e[r] !== t[r])
                                            return !1;
                                    return !0;
                                }(e, t))
                                return !1;
                            var M = F(e), x = F(t);
                            return M.length === x.length && B(e, t, r, n, 0, M);
                        }
                        if (C(e))
                            return !(!C(t) || e.size !== t.size) && B(e, t, r, n, 2);
                        if (S(e))
                            return !(!S(t) || e.size !== t.size) && B(e, t, r, n, 3);
                        if (g(e)) {
                            if (s = t, (o = e).byteLength !== s.byteLength || 0 !== P(new Uint8Array(o), new Uint8Array(s)))
                                return !1;
                        } else if (_(e) && !function (e, t) {
                                return E(e) ? E(t) && c(Number.prototype.valueOf.call(e), Number.prototype.valueOf.call(t)) : N(e) ? N(t) && String.prototype.valueOf.call(e) === String.prototype.valueOf.call(t) : I(e) ? I(t) && Boolean.prototype.valueOf.call(e) === Boolean.prototype.valueOf.call(t) : T(e) ? T(t) && BigInt.prototype.valueOf.call(e) === BigInt.prototype.valueOf.call(t) : D(t) && Symbol.prototype.valueOf.call(e) === Symbol.prototype.valueOf.call(t);
                            }(e, t))
                            return !1;
                    }
                    return B(e, t, r, n, 0);
                }
                function w(e, t) {
                    return t.filter(function (t) {
                        return f(e, t);
                    });
                }
                function B(e, t, r, n, i, a) {
                    if (5 === arguments.length) {
                        a = Object.keys(e);
                        var o = Object.keys(t);
                        if (a.length !== o.length)
                            return !1;
                    }
                    for (var s = 0; s < a.length; s++)
                        if (!p(t, a[s]))
                            return !1;
                    if (r && 5 === arguments.length) {
                        var c = u(e);
                        if (0 !== c.length) {
                            var l = 0;
                            for (s = 0; s < c.length; s++) {
                                var d = c[s];
                                if (f(e, d)) {
                                    if (!f(t, d))
                                        return !1;
                                    a.push(d), l++;
                                } else if (f(t, d))
                                    return !1;
                            }
                            var m = u(t);
                            if (c.length !== m.length && w(t, m).length !== l)
                                return !1;
                        } else {
                            var h = u(t);
                            if (0 !== h.length && 0 !== w(t, h).length)
                                return !1;
                        }
                    }
                    if (0 === a.length && (0 === i || 1 === i && 0 === e.length || 0 === e.size))
                        return !0;
                    if (void 0 === n)
                        n = {
                            val1: new Map(),
                            val2: new Map(),
                            position: 0
                        };
                    else {
                        var g = n.val1.get(e);
                        if (void 0 !== g) {
                            var y = n.val2.get(t);
                            if (void 0 !== y)
                                return g === y;
                        }
                        n.position++;
                    }
                    n.val1.set(e, n.position), n.val2.set(t, n.position);
                    var b = V(e, t, r, a, n, i);
                    return n.val1.delete(e), n.val2.delete(t), b;
                }
                function k(e, t, r, n) {
                    for (var i = o(e), a = 0; a < i.length; a++) {
                        var s = i[a];
                        if (x(t, s, r, n))
                            return e.delete(s), !0;
                    }
                    return !1;
                }
                function L(e) {
                    switch (i(e)) {
                    case 'undefined':
                        return null;
                    case 'object':
                        return;
                    case 'symbol':
                        return !1;
                    case 'string':
                        e = +e;
                    case 'number':
                        if (l(e))
                            return !1;
                    }
                    return !0;
                }
                function $(e, t, r) {
                    var n = L(r);
                    return null != n ? n : t.has(n) && !e.has(n);
                }
                function j(e, t, r, n, i) {
                    var a = L(r);
                    if (null != a)
                        return a;
                    var o = t.get(a);
                    return !(void 0 === o && !t.has(a) || !x(n, o, !1, i)) && !e.has(a) && x(n, o, !1, i);
                }
                function G(e, t, r, n, i, a) {
                    for (var s = o(e), c = 0; c < s.length; c++) {
                        var u = s[c];
                        if (x(r, u, i, a) && x(n, t.get(u), i, a))
                            return e.delete(u), !0;
                    }
                    return !1;
                }
                function V(e, t, r, a, c, u) {
                    var l = 0;
                    if (2 === u) {
                        if (!function (e, t, r, n) {
                                for (var a = null, s = o(e), c = 0; c < s.length; c++) {
                                    var u = s[c];
                                    if ('object' === i(u) && null !== u)
                                        null === a && (a = new Set()), a.add(u);
                                    else if (!t.has(u)) {
                                        if (r)
                                            return !1;
                                        if (!$(e, t, u))
                                            return !1;
                                        null === a && (a = new Set()), a.add(u);
                                    }
                                }
                                if (null !== a) {
                                    for (var l = o(t), d = 0; d < l.length; d++) {
                                        var p = l[d];
                                        if ('object' === i(p) && null !== p) {
                                            if (!k(a, p, r, n))
                                                return !1;
                                        } else if (!r && !e.has(p) && !k(a, p, r, n))
                                            return !1;
                                    }
                                    return 0 === a.size;
                                }
                                return !0;
                            }(e, t, r, c))
                            return !1;
                    } else if (3 === u) {
                        if (!function (e, t, r, a) {
                                for (var o = null, c = s(e), u = 0; u < c.length; u++) {
                                    var l = n(c[u], 2), d = l[0], p = l[1];
                                    if ('object' === i(d) && null !== d)
                                        null === o && (o = new Set()), o.add(d);
                                    else {
                                        var f = t.get(d);
                                        if (void 0 === f && !t.has(d) || !x(p, f, r, a)) {
                                            if (r)
                                                return !1;
                                            if (!j(e, t, d, p, a))
                                                return !1;
                                            null === o && (o = new Set()), o.add(d);
                                        }
                                    }
                                }
                                if (null !== o) {
                                    for (var m = s(t), h = 0; h < m.length; h++) {
                                        var g = n(m[h], 2), y = (d = g[0], g[1]);
                                        if ('object' === i(d) && null !== d) {
                                            if (!G(o, e, d, y, r, a))
                                                return !1;
                                        } else if (!(r || e.has(d) && x(e.get(d), y, !1, a) || G(o, e, d, y, !1, a)))
                                            return !1;
                                    }
                                    return 0 === o.size;
                                }
                                return !0;
                            }(e, t, r, c))
                            return !1;
                    } else if (1 === u)
                        for (; l < e.length; l++) {
                            if (!p(e, l)) {
                                if (p(t, l))
                                    return !1;
                                for (var d = Object.keys(e); l < d.length; l++) {
                                    var f = d[l];
                                    if (!p(t, f) || !x(e[f], t[f], r, c))
                                        return !1;
                                }
                                return d.length === Object.keys(t).length;
                            }
                            if (!p(t, l) || !x(e[l], t[l], r, c))
                                return !1;
                        }
                    for (l = 0; l < a.length; l++) {
                        var m = a[l];
                        if (!x(e[m], t[m], r, c))
                            return !1;
                    }
                    return !0;
                }
                e.exports = {
                    isDeepEqual: function (e, t) {
                        return x(e, t, !1);
                    },
                    isDeepStrictEqual: function (e, t) {
                        return x(e, t, !0);
                    }
                };
            },
            4061: (e, t, r) => {
                'use strict';
                const n = r(6434), {
                        stdout: i,
                        stderr: a
                    } = r(8555), {
                        stringReplaceAll: o,
                        stringEncaseCRLFWithFirstIndex: s
                    } = r(3559), {isArray: c} = Array, u = [
                        'ansi',
                        'ansi',
                        'ansi256',
                        'ansi16m'
                    ], l = Object.create(null);
                class d {
                    constructor(e) {
                        return p(e);
                    }
                }
                const p = e => {
                    const t = {};
                    return ((e, t = {}) => {
                        if (t.level && !(Number.isInteger(t.level) && t.level >= 0 && t.level <= 3))
                            throw new Error('The `level` option should be an integer from 0 to 3');
                        const r = i ? i.level : 0;
                        e.level = void 0 === t.level ? r : t.level;
                    })(t, e), t.template = (...e) => v(t.template, ...e), Object.setPrototypeOf(t, f.prototype), Object.setPrototypeOf(t.template, t), t.template.constructor = () => {
                        throw new Error('`chalk.constructor()` is deprecated. Use `new chalk.Instance()` instead.');
                    }, t.template.Instance = d, t.template;
                };
                function f(e) {
                    return p(e);
                }
                for (const [e, t] of Object.entries(n))
                    l[e] = {
                        get() {
                            const r = y(this, g(t.open, t.close, this._styler), this._isEmpty);
                            return Object.defineProperty(this, e, { value: r }), r;
                        }
                    };
                l.visible = {
                    get() {
                        const e = y(this, this._styler, !0);
                        return Object.defineProperty(this, 'visible', { value: e }), e;
                    }
                };
                const m = [
                    'rgb',
                    'hex',
                    'keyword',
                    'hsl',
                    'hsv',
                    'hwb',
                    'ansi',
                    'ansi256'
                ];
                for (const e of m)
                    l[e] = {
                        get() {
                            const {level: t} = this;
                            return function (...r) {
                                const i = g(n.color[u[t]][e](...r), n.color.close, this._styler);
                                return y(this, i, this._isEmpty);
                            };
                        }
                    };
                for (const e of m)
                    l['bg' + e[0].toUpperCase() + e.slice(1)] = {
                        get() {
                            const {level: t} = this;
                            return function (...r) {
                                const i = g(n.bgColor[u[t]][e](...r), n.bgColor.close, this._styler);
                                return y(this, i, this._isEmpty);
                            };
                        }
                    };
                const h = Object.defineProperties(() => {
                    }, {
                        ...l,
                        level: {
                            enumerable: !0,
                            get() {
                                return this._generator.level;
                            },
                            set(e) {
                                this._generator.level = e;
                            }
                        }
                    }), g = (e, t, r) => {
                        let n, i;
                        return void 0 === r ? (n = e, i = t) : (n = r.openAll + e, i = t + r.closeAll), {
                            open: e,
                            close: t,
                            openAll: n,
                            closeAll: i,
                            parent: r
                        };
                    }, y = (e, t, r) => {
                        const n = (...e) => c(e[0]) && c(e[0].raw) ? b(n, v(n, ...e)) : b(n, 1 === e.length ? '' + e[0] : e.join(' '));
                        return Object.setPrototypeOf(n, h), n._generator = e, n._styler = t, n._isEmpty = r, n;
                    }, b = (e, t) => {
                        if (e.level <= 0 || !t)
                            return e._isEmpty ? '' : t;
                        let r = e._styler;
                        if (void 0 === r)
                            return t;
                        const {
                            openAll: n,
                            closeAll: i
                        } = r;
                        if (-1 !== t.indexOf('\x1B'))
                            for (; void 0 !== r;)
                                t = o(t, r.close, r.open), r = r.parent;
                        const a = t.indexOf('\n');
                        return -1 !== a && (t = s(t, i, n, a)), n + t + i;
                    };
                let S;
                const v = (e, ...t) => {
                    const [n] = t;
                    if (!c(n) || !c(n.raw))
                        return t.join(' ');
                    const i = t.slice(1), a = [n.raw[0]];
                    for (let e = 1; e < n.length; e++)
                        a.push(String(i[e - 1]).replace(/[{}\\]/g, '\\$&'), String(n.raw[e]));
                    return void 0 === S && (S = r(9515)), S(e, a.join(''));
                };
                Object.defineProperties(f.prototype, l);
                const C = f();
                C.supportsColor = i, C.stderr = f({ level: a ? a.level : 0 }), C.stderr.supportsColor = a, e.exports = C;
            },
            9515: e => {
                'use strict';
                const t = /(?:\\(u(?:[a-f\d]{4}|\{[a-f\d]{1,6}\})|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi, r = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g, n = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/, i = /\\(u(?:[a-f\d]{4}|{[a-f\d]{1,6}})|x[a-f\d]{2}|.)|([^\\])/gi, a = new Map([
                        [
                            'n',
                            '\n'
                        ],
                        [
                            'r',
                            '\r'
                        ],
                        [
                            't',
                            '\t'
                        ],
                        [
                            'b',
                            '\b'
                        ],
                        [
                            'f',
                            '\f'
                        ],
                        [
                            'v',
                            '\x0B'
                        ],
                        [
                            '0',
                            '\0'
                        ],
                        [
                            '\\',
                            '\\'
                        ],
                        [
                            'e',
                            '\x1B'
                        ],
                        [
                            'a',
                            '\x07'
                        ]
                    ]);
                function o(e) {
                    const t = 'u' === e[0], r = '{' === e[1];
                    return t && !r && 5 === e.length || 'x' === e[0] && 3 === e.length ? String.fromCharCode(parseInt(e.slice(1), 16)) : t && r ? String.fromCodePoint(parseInt(e.slice(2, -1), 16)) : a.get(e) || e;
                }
                function s(e, t) {
                    const r = [], a = t.trim().split(/\s*,\s*/g);
                    let s;
                    for (const t of a) {
                        const a = Number(t);
                        if (Number.isNaN(a)) {
                            if (!(s = t.match(n)))
                                throw new Error(`Invalid Chalk template style argument: ${ t } (in style '${ e }')`);
                            r.push(s[2].replace(i, (e, t, r) => t ? o(t) : r));
                        } else
                            r.push(a);
                    }
                    return r;
                }
                function c(e) {
                    r.lastIndex = 0;
                    const t = [];
                    let n;
                    for (; null !== (n = r.exec(e));) {
                        const e = n[1];
                        if (n[2]) {
                            const r = s(e, n[2]);
                            t.push([e].concat(r));
                        } else
                            t.push([e]);
                    }
                    return t;
                }
                function u(e, t) {
                    const r = {};
                    for (const e of t)
                        for (const t of e.styles)
                            r[t[0]] = e.inverse ? null : t.slice(1);
                    let n = e;
                    for (const [e, t] of Object.entries(r))
                        if (Array.isArray(t)) {
                            if (!(e in n))
                                throw new Error(`Unknown Chalk style: ${ e }`);
                            n = t.length > 0 ? n[e](...t) : n[e];
                        }
                    return n;
                }
                e.exports = (e, r) => {
                    const n = [], i = [];
                    let a = [];
                    if (r.replace(t, (t, r, s, l, d, p) => {
                            if (r)
                                a.push(o(r));
                            else if (l) {
                                const t = a.join('');
                                a = [], i.push(0 === n.length ? t : u(e, n)(t)), n.push({
                                    inverse: s,
                                    styles: c(l)
                                });
                            } else if (d) {
                                if (0 === n.length)
                                    throw new Error('Found extraneous } in Chalk template literal');
                                i.push(u(e, n)(a.join(''))), a = [], n.pop();
                            } else
                                a.push(p);
                        }), i.push(a.join('')), n.length > 0) {
                        const e = `Chalk template literal is missing ${ n.length } closing bracket${ 1 === n.length ? '' : 's' } (\`}\`)`;
                        throw new Error(e);
                    }
                    return i.join('');
                };
            },
            3559: e => {
                'use strict';
                e.exports = {
                    stringReplaceAll: (e, t, r) => {
                        let n = e.indexOf(t);
                        if (-1 === n)
                            return e;
                        const i = t.length;
                        let a = 0, o = '';
                        do {
                            o += e.substr(a, n - a) + t + r, a = n + i, n = e.indexOf(t, a);
                        } while (-1 !== n);
                        return o += e.substr(a), o;
                    },
                    stringEncaseCRLFWithFirstIndex: (e, t, r, n) => {
                        let i = 0, a = '';
                        do {
                            const o = '\r' === e[n - 1];
                            a += e.substr(i, (o ? n - 1 : n) - i) + t + (o ? '\r\n' : '\n') + r, i = n + 1, n = e.indexOf('\n', i);
                        } while (-1 !== n);
                        return a += e.substr(i), a;
                    }
                };
            },
            714: (e, t) => {
                var r;
                !function () {
                    var n = 9007199254740992, i = '0123456789', a = 'abcdefghijklmnopqrstuvwxyz', o = a.toUpperCase(), s = i + 'abcdef';
                    function c(e) {
                        this.name = 'UnsupportedError', this.message = e || 'This feature is not supported on this platform';
                    }
                    c.prototype = new Error(), c.prototype.constructor = c;
                    var u = Array.prototype.slice;
                    function l(e) {
                        if (!(this instanceof l))
                            return e || (e = null), null === e ? new l() : new l(e);
                        if ('function' == typeof e)
                            return this.random = e, this;
                        arguments.length && (this.seed = 0);
                        for (var t = 0; t < arguments.length; t++) {
                            var r = 0;
                            if ('[object String]' === Object.prototype.toString.call(arguments[t]))
                                for (var n = 0; n < arguments[t].length; n++) {
                                    for (var i = 0, a = 0; a < arguments[t].length; a++)
                                        i = arguments[t].charCodeAt(a) + (i << 6) + (i << 16) - i;
                                    r += i;
                                }
                            else
                                r = arguments[t];
                            this.seed += (arguments.length - t) * r;
                        }
                        return this.mt = this.mersenne_twister(this.seed), this.bimd5 = this.blueimp_md5(), this.random = function () {
                            return this.mt.random(this.seed);
                        }, this;
                    }
                    function d(e, t) {
                        if (e = e || {}, t)
                            for (var r in t)
                                void 0 === e[r] && (e[r] = t[r]);
                        return e;
                    }
                    function p(e, t) {
                        if (e)
                            throw new RangeError(t);
                    }
                    l.prototype.VERSION = '1.1.9';
                    var f = function () {
                        throw new Error('No Base64 encoder available.');
                    };
                    function m(e) {
                        this.c = e;
                    }
                    function h(e) {
                        this.c = e;
                    }
                    function g(e) {
                        this.c = e;
                    }
                    function y(e) {
                        return function () {
                            return this.natural(e);
                        };
                    }
                    'function' == typeof btoa ? f = btoa : 'function' == typeof Buffer && (f = function (e) {
                        return new Buffer(e).toString('base64');
                    }), l.prototype.bool = function (e) {
                        return p((e = d(e, { likelihood: 50 })).likelihood < 0 || e.likelihood > 100, 'Chance: Likelihood accepts values from 0 to 100.'), 100 * this.random() < e.likelihood;
                    }, l.prototype.falsy = function (e) {
                        var t = (e = d(e, {
                            pool: [
                                !1,
                                null,
                                0,
                                NaN,
                                '',
                                void 0
                            ]
                        })).pool;
                        return t[this.integer({
                            min: 0,
                            max: t.length - 1
                        })];
                    }, l.prototype.animal = function (e) {
                        return void 0 !== (e = d(e)).type ? (p(!this.get('animals')[e.type.toLowerCase()], 'Please pick from desert, ocean, grassland, forest, zoo, pets, farm.'), this.pick(this.get('animals')[e.type.toLowerCase()])) : this.pick(this.get('animals')[this.pick([
                            'desert',
                            'forest',
                            'ocean',
                            'zoo',
                            'farm',
                            'pet',
                            'grassland'
                        ])]);
                    }, l.prototype.character = function (e) {
                        var t, r, n = '!@#$%^&*()[]';
                        return t = 'lower' === (e = d(e)).casing ? a : 'upper' === e.casing ? o : a + o, e.pool ? r = e.pool : (r = '', e.alpha && (r += t), e.numeric && (r += i), e.symbols && (r += n), r || (r = t + i + n)), r.charAt(this.natural({ max: r.length - 1 }));
                    }, l.prototype.floating = function (e) {
                        p((e = d(e, { fixed: 4 })).fixed && e.precision, 'Chance: Cannot specify both fixed and precision.');
                        var t = Math.pow(10, e.fixed), r = n / t, i = -r;
                        p(e.min && e.fixed && e.min < i, 'Chance: Min specified is out of range with fixed. Min should be, at least, ' + i), p(e.max && e.fixed && e.max > r, 'Chance: Max specified is out of range with fixed. Max should be, at most, ' + r), e = d(e, {
                            min: i,
                            max: r
                        });
                        var a = (this.integer({
                            min: e.min * t,
                            max: e.max * t
                        }) / t).toFixed(e.fixed);
                        return parseFloat(a);
                    }, l.prototype.integer = function (e) {
                        return p((e = d(e, {
                            min: -9007199254740992,
                            max: n
                        })).min > e.max, 'Chance: Min cannot be greater than Max.'), Math.floor(this.random() * (e.max - e.min + 1) + e.min);
                    }, l.prototype.natural = function (e) {
                        if ('number' == typeof (e = d(e, {
                                min: 0,
                                max: n
                            })).numerals && (p(e.numerals < 1, 'Chance: Numerals cannot be less than one.'), e.min = Math.pow(10, e.numerals - 1), e.max = Math.pow(10, e.numerals) - 1), p(e.min < 0, 'Chance: Min cannot be less than zero.'), e.exclude) {
                            for (var t in (p(!Array.isArray(e.exclude), 'Chance: exclude must be an array.'), e.exclude))
                                p(!Number.isInteger(e.exclude[t]), 'Chance: exclude must be numbers.');
                            var r = e.min + this.natural({ max: e.max - e.min - e.exclude.length }), i = e.exclude.sort();
                            for (var a in i) {
                                if (r < i[a])
                                    break;
                                r++;
                            }
                            return r;
                        }
                        return this.integer(e);
                    }, l.prototype.prime = function (e) {
                        p((e = d(e, {
                            min: 0,
                            max: 10000
                        })).min < 0, 'Chance: Min cannot be less than zero.'), p(e.min > e.max, 'Chance: Min cannot be greater than Max.');
                        var t = b.primes[b.primes.length - 1];
                        if (e.max > t)
                            for (var r = t + 2; r <= e.max; ++r)
                                this.is_prime(r) && b.primes.push(r);
                        var n = b.primes.filter(function (t) {
                            return t >= e.min && t <= e.max;
                        });
                        return this.pick(n);
                    }, l.prototype.is_prime = function (e) {
                        if (e % 1 || e < 2)
                            return !1;
                        if (e % 2 == 0)
                            return 2 === e;
                        if (e % 3 == 0)
                            return 3 === e;
                        for (var t = Math.sqrt(e), r = 5; r <= t; r += 6)
                            if (e % r == 0 || e % (r + 2) == 0)
                                return !1;
                        return !0;
                    }, l.prototype.hex = function (e) {
                        p((e = d(e, {
                            min: 0,
                            max: n,
                            casing: 'lower'
                        })).min < 0, 'Chance: Min cannot be less than zero.');
                        var t = this.natural({
                            min: e.min,
                            max: e.max
                        });
                        return 'upper' === e.casing ? t.toString(16).toUpperCase() : t.toString(16);
                    }, l.prototype.letter = function (e) {
                        e = d(e, { casing: 'lower' });
                        var t = this.character({ pool: 'abcdefghijklmnopqrstuvwxyz' });
                        return 'upper' === e.casing && (t = t.toUpperCase()), t;
                    }, l.prototype.string = function (e) {
                        0 === (e = d(e, {
                            min: 5,
                            max: 20
                        })).length || e.length || (e.length = this.natural({
                            min: e.min,
                            max: e.max
                        })), p(e.length < 0, 'Chance: Length cannot be less than zero.');
                        var t = e.length;
                        return this.n(this.character, t, e).join('');
                    }, m.prototype = {
                        substitute: function () {
                            return this.c;
                        }
                    }, h.prototype = {
                        substitute: function () {
                            if (!/[{}\\]/.test(this.c))
                                throw new Error('Invalid escape sequence: "\\' + this.c + '".');
                            return this.c;
                        }
                    }, g.prototype = {
                        replacers: {
                            '#': function (e) {
                                return e.character({ pool: i });
                            },
                            A: function (e) {
                                return e.character({ pool: o });
                            },
                            a: function (e) {
                                return e.character({ pool: a });
                            }
                        },
                        substitute: function (e) {
                            var t = this.replacers[this.c];
                            if (!t)
                                throw new Error('Invalid replacement character: "' + this.c + '".');
                            return t(e);
                        }
                    }, l.prototype.template = function (e) {
                        if (!e)
                            throw new Error('Template string is required');
                        var t = this;
                        return function (e) {
                            for (var t = [], r = 'identity', n = 0; n < e.length; n++) {
                                var i = e[n];
                                switch (r) {
                                case 'escape':
                                    t.push(new h(i)), r = 'identity';
                                    break;
                                case 'identity':
                                    '{' === i ? r = 'replace' : '\\' === i ? r = 'escape' : t.push(new m(i));
                                    break;
                                case 'replace':
                                    '}' === i ? r = 'identity' : t.push(new g(i));
                                }
                            }
                            return t;
                        }(e).map(function (e) {
                            return e.substitute(t);
                        }).join('');
                    }, l.prototype.buffer = function (e) {
                        if ('undefined' == typeof Buffer)
                            throw new c('Sorry, the buffer() function is not supported on your platform');
                        p((e = d(e, {
                            length: this.natural({
                                min: 5,
                                max: 20
                            })
                        })).length < 0, 'Chance: Length cannot be less than zero.');
                        var t = e.length, r = this.n(this.character, t, e);
                        return Buffer.from(r);
                    }, l.prototype.capitalize = function (e) {
                        return e.charAt(0).toUpperCase() + e.substr(1);
                    }, l.prototype.mixin = function (e) {
                        for (var t in e)
                            l.prototype[t] = e[t];
                        return this;
                    }, l.prototype.unique = function (e, t, r) {
                        p('function' != typeof e, 'Chance: The first argument must be a function.');
                        var n = function (e, t) {
                            return -1 !== e.indexOf(t);
                        };
                        r && (n = r.comparator || n);
                        for (var i, a = [], o = 0, s = 50 * t, c = u.call(arguments, 2); a.length < t;) {
                            var l = JSON.parse(JSON.stringify(c));
                            if (n(a, i = e.apply(this, l)) || (a.push(i), o = 0), ++o > s)
                                throw new RangeError('Chance: num is likely too large for sample set');
                        }
                        return a;
                    }, l.prototype.n = function (e, t) {
                        p('function' != typeof e, 'Chance: The first argument must be a function.'), void 0 === t && (t = 1);
                        var r = t, n = [], i = u.call(arguments, 2);
                        for (r = Math.max(0, r); r--; null)
                            n.push(e.apply(this, i));
                        return n;
                    }, l.prototype.pad = function (e, t, r) {
                        return r = r || '0', (e += '').length >= t ? e : new Array(t - e.length + 1).join(r) + e;
                    }, l.prototype.pick = function (e, t) {
                        if (0 === e.length)
                            throw new RangeError('Chance: Cannot pick() from an empty array');
                        return t && 1 !== t ? this.shuffle(e).slice(0, t) : e[this.natural({ max: e.length - 1 })];
                    }, l.prototype.pickone = function (e) {
                        if (0 === e.length)
                            throw new RangeError('Chance: Cannot pickone() from an empty array');
                        return e[this.natural({ max: e.length - 1 })];
                    }, l.prototype.pickset = function (e, t) {
                        if (0 === t)
                            return [];
                        if (0 === e.length)
                            throw new RangeError('Chance: Cannot pickset() from an empty array');
                        if (t < 0)
                            throw new RangeError('Chance: Count must be a positive number');
                        if (t && 1 !== t) {
                            var r = e.slice(0), n = r.length;
                            return this.n(function () {
                                var e = this.natural({ max: --n }), t = r[e];
                                return r[e] = r[n], t;
                            }, Math.min(n, t));
                        }
                        return [this.pickone(e)];
                    }, l.prototype.shuffle = function (e) {
                        for (var t, r, n = [], i = 0, a = Number(e.length), o = (r = a, Array.apply(null, Array(r)).map(function (e, t) {
                                    return t;
                                })), s = a - 1, c = 0; c < a; c++)
                            i = o[t = this.natural({ max: s })], n[c] = e[i], o[t] = o[s], s -= 1;
                        return n;
                    }, l.prototype.weighted = function (e, t, r) {
                        if (e.length !== t.length)
                            throw new RangeError('Chance: Length of array and weights must match');
                        for (var n, i = 0, a = 0; a < t.length; ++a) {
                            if (n = t[a], isNaN(n))
                                throw new RangeError('Chance: All weights must be numbers');
                            n > 0 && (i += n);
                        }
                        if (0 === i)
                            throw new RangeError('Chance: No valid entries in array weights');
                        var o, s = this.random() * i, c = 0, u = -1;
                        for (a = 0; a < t.length; ++a) {
                            if (c += n = t[a], n > 0) {
                                if (s <= c) {
                                    o = a;
                                    break;
                                }
                                u = a;
                            }
                            a === t.length - 1 && (o = u);
                        }
                        var l = e[o];
                        return (r = void 0 !== r && r) && (e.splice(o, 1), t.splice(o, 1)), l;
                    }, l.prototype.paragraph = function (e) {
                        var t = (e = d(e)).sentences || this.natural({
                                min: 3,
                                max: 7
                            }), r = this.n(this.sentence, t), n = !0 === e.linebreak ? '\n' : ' ';
                        return r.join(n);
                    }, l.prototype.sentence = function (e) {
                        var t, r = (e = d(e)).words || this.natural({
                                min: 12,
                                max: 18
                            }), n = e.punctuation;
                        return t = this.n(this.word, r).join(' '), t = this.capitalize(t), !1 === n || /^[.?;!:]$/.test(n) || (n = '.'), n && (t += n), t;
                    }, l.prototype.syllable = function (e) {
                        for (var t, r = (e = d(e)).length || this.natural({
                                    min: 2,
                                    max: 3
                                }), n = 'bcdfghjklmnprstvwz', i = '', a = 0; a < r; a++)
                            i += t = 0 === a ? this.character({ pool: 'bcdfghjklmnprstvwzaeiou' }) : -1 === n.indexOf(t) ? this.character({ pool: n }) : this.character({ pool: 'aeiou' });
                        return e.capitalize && (i = this.capitalize(i)), i;
                    }, l.prototype.word = function (e) {
                        p((e = d(e)).syllables && e.length, 'Chance: Cannot specify both syllables AND length.');
                        var t = e.syllables || this.natural({
                                min: 1,
                                max: 3
                            }), r = '';
                        if (e.length) {
                            do {
                                r += this.syllable();
                            } while (r.length < e.length);
                            r = r.substring(0, e.length);
                        } else
                            for (var n = 0; n < t; n++)
                                r += this.syllable();
                        return e.capitalize && (r = this.capitalize(r)), r;
                    }, l.prototype.age = function (e) {
                        var t;
                        switch ((e = d(e)).type) {
                        case 'child':
                            t = {
                                min: 0,
                                max: 12
                            };
                            break;
                        case 'teen':
                            t = {
                                min: 13,
                                max: 19
                            };
                            break;
                        case 'adult':
                            t = {
                                min: 18,
                                max: 65
                            };
                            break;
                        case 'senior':
                            t = {
                                min: 65,
                                max: 100
                            };
                            break;
                        case 'all':
                            t = {
                                min: 0,
                                max: 100
                            };
                            break;
                        default:
                            t = {
                                min: 18,
                                max: 65
                            };
                        }
                        return this.natural(t);
                    }, l.prototype.birthday = function (e) {
                        var t = this.age(e), r = new Date(), n = r.getFullYear();
                        if (e && e.type) {
                            var i = new Date(), a = new Date();
                            i.setFullYear(n - t - 1), a.setFullYear(n - t), e = d(e, {
                                min: i,
                                max: a
                            });
                        } else if (!e || void 0 === e.minAge && null == e.maxAge)
                            e = d(e, { year: n - t });
                        else {
                            p(e.minAge < 0, 'Chance: MinAge cannot be less than zero.'), p(e.minAge > e.maxAge, 'Chance: MinAge cannot be greater than MaxAge.');
                            var o = void 0 !== e.minAge ? e.minAge : 0, s = void 0 !== e.maxAge ? e.maxAge : 100, c = new Date(n - s - 1, r.getMonth(), r.getDate()), u = new Date(n - o, r.getMonth(), r.getDate());
                            c.setDate(c.getDate() + 1), u.setDate(u.getDate() + 1), u.setMilliseconds(u.getMilliseconds() - 1), e = d(e, {
                                min: c,
                                max: u
                            });
                        }
                        return this.date(e);
                    }, l.prototype.cpf = function (e) {
                        e = d(e, { formatted: !0 });
                        var t = this.n(this.natural, 9, { max: 9 }), r = 2 * t[8] + 3 * t[7] + 4 * t[6] + 5 * t[5] + 6 * t[4] + 7 * t[3] + 8 * t[2] + 9 * t[1] + 10 * t[0];
                        (r = 11 - r % 11) >= 10 && (r = 0);
                        var n = 2 * r + 3 * t[8] + 4 * t[7] + 5 * t[6] + 6 * t[5] + 7 * t[4] + 8 * t[3] + 9 * t[2] + 10 * t[1] + 11 * t[0];
                        (n = 11 - n % 11) >= 10 && (n = 0);
                        var i = '' + t[0] + t[1] + t[2] + '.' + t[3] + t[4] + t[5] + '.' + t[6] + t[7] + t[8] + '-' + r + n;
                        return e.formatted ? i : i.replace(/\D/g, '');
                    }, l.prototype.cnpj = function (e) {
                        e = d(e, { formatted: !0 });
                        var t = this.n(this.natural, 12, { max: 12 }), r = 2 * t[11] + 3 * t[10] + 4 * t[9] + 5 * t[8] + 6 * t[7] + 7 * t[6] + 8 * t[5] + 9 * t[4] + 2 * t[3] + 3 * t[2] + 4 * t[1] + 5 * t[0];
                        (r = 11 - r % 11) < 2 && (r = 0);
                        var n = 2 * r + 3 * t[11] + 4 * t[10] + 5 * t[9] + 6 * t[8] + 7 * t[7] + 8 * t[6] + 9 * t[5] + 2 * t[4] + 3 * t[3] + 4 * t[2] + 5 * t[1] + 6 * t[0];
                        (n = 11 - n % 11) < 2 && (n = 0);
                        var i = '' + t[0] + t[1] + '.' + t[2] + t[3] + t[4] + '.' + t[5] + t[6] + t[7] + '/' + t[8] + t[9] + t[10] + t[11] + '-' + r + n;
                        return e.formatted ? i : i.replace(/\D/g, '');
                    }, l.prototype.first = function (e) {
                        return e = d(e, {
                            gender: this.gender(),
                            nationality: 'en'
                        }), this.pick(this.get('firstNames')[e.gender.toLowerCase()][e.nationality.toLowerCase()]);
                    }, l.prototype.profession = function (e) {
                        return (e = d(e)).rank ? this.pick([
                            'Apprentice ',
                            'Junior ',
                            'Senior ',
                            'Lead '
                        ]) + this.pick(this.get('profession')) : this.pick(this.get('profession'));
                    }, l.prototype.company = function () {
                        return this.pick(this.get('company'));
                    }, l.prototype.gender = function (e) {
                        return e = d(e, { extraGenders: [] }), this.pick([
                            'Male',
                            'Female'
                        ].concat(e.extraGenders));
                    }, l.prototype.last = function (e) {
                        if ('*' === (e = d(e, { nationality: '*' })).nationality) {
                            var t = [], r = this.get('lastNames');
                            return Object.keys(r).forEach(function (e) {
                                t = t.concat(r[e]);
                            }), this.pick(t);
                        }
                        return this.pick(this.get('lastNames')[e.nationality.toLowerCase()]);
                    }, l.prototype.israelId = function () {
                        for (var e = this.string({
                                    pool: '0123456789',
                                    length: 8
                                }), t = 0, r = 0; r < e.length; r++) {
                            var n = e[r] * (r / 2 === parseInt(r / 2) ? 1 : 2);
                            n = this.pad(n, 2).toString(), t += n = parseInt(n[0]) + parseInt(n[1]);
                        }
                        return e + (10 - parseInt(t.toString().slice(-1))).toString().slice(-1);
                    }, l.prototype.mrz = function (e) {
                        var t, r, n, i, a = function (e) {
                                var t = '<ABCDEFGHIJKLMNOPQRSTUVWXYXZ'.split(''), r = [
                                        7,
                                        3,
                                        1
                                    ], n = 0;
                                return 'string' != typeof e && (e = e.toString()), e.split('').forEach(function (e, i) {
                                    var a = t.indexOf(e);
                                    e = -1 !== a ? 0 === a ? 0 : a + 9 : parseInt(e, 10), n += e *= r[i % r.length];
                                }), n % 10;
                            }, o = this;
                        return n = function (e) {
                            return new Array(e + 1).join('<');
                        }, (i = [
                            'P<',
                            (r = e = d(e, {
                                first: this.first(),
                                last: this.last(),
                                passportNumber: this.integer({
                                    min: 100000000,
                                    max: 999999999
                                }),
                                dob: (t = o.birthday({ type: 'adult' }), [
                                    t.getFullYear().toString().substr(2),
                                    o.pad(t.getMonth() + 1, 2),
                                    o.pad(t.getDate(), 2)
                                ].join('')),
                                expiry: function () {
                                    var e = new Date();
                                    return [
                                        (e.getFullYear() + 5).toString().substr(2),
                                        o.pad(e.getMonth() + 1, 2),
                                        o.pad(e.getDate(), 2)
                                    ].join('');
                                }(),
                                gender: 'Female' === this.gender() ? 'F' : 'M',
                                issuer: 'GBR',
                                nationality: 'GBR'
                            })).issuer,
                            r.last.toUpperCase(),
                            '<<',
                            r.first.toUpperCase(),
                            n(39 - (r.last.length + r.first.length + 2)),
                            r.passportNumber,
                            a(r.passportNumber),
                            r.nationality,
                            r.dob,
                            a(r.dob),
                            r.gender,
                            r.expiry,
                            a(r.expiry),
                            n(14),
                            a(n(14))
                        ].join('')) + a(i.substr(44, 10) + i.substr(57, 7) + i.substr(65, 7));
                    }, l.prototype.name = function (e) {
                        e = d(e);
                        var t, r = this.first(e), n = this.last(e);
                        return t = e.middle ? r + ' ' + this.first(e) + ' ' + n : e.middle_initial ? r + ' ' + this.character({
                            alpha: !0,
                            casing: 'upper'
                        }) + '. ' + n : r + ' ' + n, e.prefix && (t = this.prefix(e) + ' ' + t), e.suffix && (t = t + ' ' + this.suffix(e)), t;
                    }, l.prototype.name_prefixes = function (e) {
                        var t = [{
                                name: 'Doctor',
                                abbreviation: 'Dr.'
                            }];
                        return 'male' !== (e = (e = e || 'all').toLowerCase()) && 'all' !== e || t.push({
                            name: 'Mister',
                            abbreviation: 'Mr.'
                        }), 'female' !== e && 'all' !== e || (t.push({
                            name: 'Miss',
                            abbreviation: 'Miss'
                        }), t.push({
                            name: 'Misses',
                            abbreviation: 'Mrs.'
                        })), t;
                    }, l.prototype.prefix = function (e) {
                        return this.name_prefix(e);
                    }, l.prototype.name_prefix = function (e) {
                        return (e = d(e, { gender: 'all' })).full ? this.pick(this.name_prefixes(e.gender)).name : this.pick(this.name_prefixes(e.gender)).abbreviation;
                    }, l.prototype.HIDN = function () {
                        var e = '';
                        return (e += this.string({
                            pool: '0123456789',
                            length: 6
                        })) + this.string({
                            pool: 'ABCDEFGHIJKLMNOPQRSTUVWXYXZ',
                            length: 2
                        });
                    }, l.prototype.ssn = function (e) {
                        var t = '1234567890', r = (e = d(e, {
                                ssnFour: !1,
                                dashes: !0
                            })).dashes ? '-' : '';
                        return e.ssnFour ? this.string({
                            pool: t,
                            length: 4
                        }) : this.string({
                            pool: t,
                            length: 3
                        }) + r + this.string({
                            pool: t,
                            length: 2
                        }) + r + this.string({
                            pool: t,
                            length: 4
                        });
                    }, l.prototype.aadhar = function (e) {
                        var t = '1234567890', r = (e = d(e, {
                                onlyLastFour: !1,
                                separatedByWhiteSpace: !0
                            })).separatedByWhiteSpace ? ' ' : '';
                        return e.onlyLastFour ? this.string({
                            pool: t,
                            length: 4
                        }) : this.string({
                            pool: t,
                            length: 4
                        }) + r + this.string({
                            pool: t,
                            length: 4
                        }) + r + this.string({
                            pool: t,
                            length: 4
                        });
                    }, l.prototype.name_suffixes = function () {
                        return [
                            {
                                name: 'Doctor of Osteopathic Medicine',
                                abbreviation: 'D.O.'
                            },
                            {
                                name: 'Doctor of Philosophy',
                                abbreviation: 'Ph.D.'
                            },
                            {
                                name: 'Esquire',
                                abbreviation: 'Esq.'
                            },
                            {
                                name: 'Junior',
                                abbreviation: 'Jr.'
                            },
                            {
                                name: 'Juris Doctor',
                                abbreviation: 'J.D.'
                            },
                            {
                                name: 'Master of Arts',
                                abbreviation: 'M.A.'
                            },
                            {
                                name: 'Master of Business Administration',
                                abbreviation: 'M.B.A.'
                            },
                            {
                                name: 'Master of Science',
                                abbreviation: 'M.S.'
                            },
                            {
                                name: 'Medical Doctor',
                                abbreviation: 'M.D.'
                            },
                            {
                                name: 'Senior',
                                abbreviation: 'Sr.'
                            },
                            {
                                name: 'The Third',
                                abbreviation: 'III'
                            },
                            {
                                name: 'The Fourth',
                                abbreviation: 'IV'
                            },
                            {
                                name: 'Bachelor of Engineering',
                                abbreviation: 'B.E'
                            },
                            {
                                name: 'Bachelor of Technology',
                                abbreviation: 'B.TECH'
                            }
                        ];
                    }, l.prototype.suffix = function (e) {
                        return this.name_suffix(e);
                    }, l.prototype.name_suffix = function (e) {
                        return (e = d(e)).full ? this.pick(this.name_suffixes()).name : this.pick(this.name_suffixes()).abbreviation;
                    }, l.prototype.nationalities = function () {
                        return this.get('nationalities');
                    }, l.prototype.nationality = function () {
                        return this.pick(this.nationalities()).name;
                    }, l.prototype.android_id = function () {
                        return 'APA91' + this.string({
                            pool: '0123456789abcefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_',
                            length: 178
                        });
                    }, l.prototype.apple_token = function () {
                        return this.string({
                            pool: 'abcdef1234567890',
                            length: 64
                        });
                    }, l.prototype.wp8_anid2 = function () {
                        return f(this.hash({ length: 32 }));
                    }, l.prototype.wp7_anid = function () {
                        return 'A=' + this.guid().replace(/-/g, '').toUpperCase() + '&E=' + this.hash({ length: 3 }) + '&W=' + this.integer({
                            min: 0,
                            max: 9
                        });
                    }, l.prototype.bb_pin = function () {
                        return this.hash({ length: 8 });
                    }, l.prototype.avatar = function (e) {
                        var t = {
                            protocol: null,
                            email: null,
                            fileExtension: null,
                            size: null,
                            fallback: null,
                            rating: null
                        };
                        if (e)
                            if ('string' == typeof e)
                                t.email = e, e = {};
                            else {
                                if ('object' != typeof e)
                                    return null;
                                if ('Array' === e.constructor)
                                    return null;
                            }
                        else
                            t.email = this.email(), e = {};
                        return (t = d(e, t)).email || (t.email = this.email()), t.protocol = {
                            http: 'http',
                            https: 'https'
                        }[t.protocol] ? t.protocol + ':' : '', t.size = parseInt(t.size, 0) ? t.size : '', t.rating = {
                            g: 'g',
                            pg: 'pg',
                            r: 'r',
                            x: 'x'
                        }[t.rating] ? t.rating : '', t.fallback = {
                            404: '404',
                            mm: 'mm',
                            identicon: 'identicon',
                            monsterid: 'monsterid',
                            wavatar: 'wavatar',
                            retro: 'retro',
                            blank: 'blank'
                        }[t.fallback] ? t.fallback : '', t.fileExtension = {
                            bmp: 'bmp',
                            gif: 'gif',
                            jpg: 'jpg',
                            png: 'png'
                        }[t.fileExtension] ? t.fileExtension : '', t.protocol + '//www.gravatar.com/avatar/' + this.bimd5.md5(t.email) + (t.fileExtension ? '.' + t.fileExtension : '') + (t.size || t.rating || t.fallback ? '?' : '') + (t.size ? '&s=' + t.size.toString() : '') + (t.rating ? '&r=' + t.rating : '') + (t.fallback ? '&d=' + t.fallback : '');
                    }, l.prototype.color = function (e) {
                        function t(e, t) {
                            return [
                                e,
                                e,
                                e
                            ].join(t || '');
                        }
                        function r(e) {
                            var r = e ? 'rgba' : 'rgb', n = e ? ',' + this.floating({
                                    min: h,
                                    max: g
                                }) : '';
                            return r + '(' + (a ? t(this.natural({
                                min: o,
                                max: s
                            }), ',') : this.natural({
                                min: l,
                                max: p
                            }) + ',' + this.natural({
                                min: f,
                                max: m
                            }) + ',' + this.natural({ max: 255 })) + n + ')';
                        }
                        function n(r, n, i) {
                            var d = i ? '#' : '', h = '';
                            return a ? (h = t(this.pad(this.hex({
                                min: o,
                                max: s
                            }), 2)), 'shorthex' === e.format && (h = t(this.hex({
                                min: 0,
                                max: 15
                            })))) : h = 'shorthex' === e.format ? this.pad(this.hex({
                                min: Math.floor(c / 16),
                                max: Math.floor(u / 16)
                            }), 1) + this.pad(this.hex({
                                min: Math.floor(l / 16),
                                max: Math.floor(p / 16)
                            }), 1) + this.pad(this.hex({
                                min: Math.floor(f / 16),
                                max: Math.floor(m / 16)
                            }), 1) : void 0 !== c || void 0 !== u || void 0 !== l || void 0 !== p || void 0 !== f || void 0 !== m ? this.pad(this.hex({
                                min: c,
                                max: u
                            }), 2) + this.pad(this.hex({
                                min: l,
                                max: p
                            }), 2) + this.pad(this.hex({
                                min: f,
                                max: m
                            }), 2) : this.pad(this.hex({
                                min: o,
                                max: s
                            }), 2) + this.pad(this.hex({
                                min: o,
                                max: s
                            }), 2) + this.pad(this.hex({
                                min: o,
                                max: s
                            }), 2), d + h;
                        }
                        var i, a = (e = d(e, {
                                format: this.pick([
                                    'hex',
                                    'shorthex',
                                    'rgb',
                                    'rgba',
                                    '0x',
                                    'name'
                                ]),
                                grayscale: !1,
                                casing: 'lower',
                                min: 0,
                                max: 255,
                                min_red: void 0,
                                max_red: void 0,
                                min_green: void 0,
                                max_green: void 0,
                                min_blue: void 0,
                                max_blue: void 0,
                                min_alpha: 0,
                                max_alpha: 1
                            })).grayscale, o = e.min, s = e.max, c = e.min_red, u = e.max_red, l = e.min_green, p = e.max_green, f = e.min_blue, m = e.max_blue, h = e.min_alpha, g = e.max_alpha;
                        if (void 0 === e.min_red && (c = o), void 0 === e.max_red && (u = s), void 0 === e.min_green && (l = o), void 0 === e.max_green && (p = s), void 0 === e.min_blue && (f = o), void 0 === e.max_blue && (m = s), void 0 === e.min_alpha && (h = 0), void 0 === e.max_alpha && (g = 1), a && 0 === o && 255 === s && void 0 !== c && void 0 !== u && (o = (c + l + f) / 3, s = (u + p + m) / 3), 'hex' === e.format)
                            i = n.call(this, 2, 6, !0);
                        else if ('shorthex' === e.format)
                            i = n.call(this, 1, 3, !0);
                        else if ('rgb' === e.format)
                            i = r.call(this, !1);
                        else if ('rgba' === e.format)
                            i = r.call(this, !0);
                        else {
                            if ('0x' !== e.format) {
                                if ('name' === e.format)
                                    return this.pick(this.get('colorNames'));
                                throw new RangeError('Invalid format provided. Please provide one of "hex", "shorthex", "rgb", "rgba", "0x" or "name".');
                            }
                            i = '0x' + n.call(this, 2, 6);
                        }
                        return 'upper' === e.casing && (i = i.toUpperCase()), i;
                    }, l.prototype.domain = function (e) {
                        return e = d(e), this.word() + '.' + (e.tld || this.tld());
                    }, l.prototype.email = function (e) {
                        return e = d(e), this.word({ length: e.length }) + '@' + (e.domain || this.domain());
                    }, l.prototype.fbid = function () {
                        return '10000' + this.string({
                            pool: '1234567890',
                            length: 11
                        });
                    }, l.prototype.google_analytics = function () {
                        return 'UA-' + this.pad(this.natural({ max: 999999 }), 6) + '-' + this.pad(this.natural({ max: 99 }), 2);
                    }, l.prototype.hashtag = function () {
                        return '#' + this.word();
                    }, l.prototype.ip = function () {
                        return this.natural({
                            min: 1,
                            max: 254
                        }) + '.' + this.natural({ max: 255 }) + '.' + this.natural({ max: 255 }) + '.' + this.natural({
                            min: 1,
                            max: 254
                        });
                    }, l.prototype.ipv6 = function () {
                        return this.n(this.hash, 8, { length: 4 }).join(':');
                    }, l.prototype.klout = function () {
                        return this.natural({
                            min: 1,
                            max: 99
                        });
                    }, l.prototype.mac = function (e) {
                        return e = d(e, { delimiter: ':' }), this.pad(this.natural({ max: 255 }).toString(16), 2) + e.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + e.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + e.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + e.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + e.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2);
                    }, l.prototype.semver = function (e) {
                        e = d(e, { include_prerelease: !0 });
                        var t = this.pickone([
                            '^',
                            '~',
                            '<',
                            '>',
                            '<=',
                            '>=',
                            '='
                        ]);
                        e.range && (t = e.range);
                        var r = '';
                        return e.include_prerelease && (r = this.weighted([
                            '',
                            '-dev',
                            '-beta',
                            '-alpha'
                        ], [
                            50,
                            10,
                            5,
                            1
                        ])), t + this.rpg('3d10').join('.') + r;
                    }, l.prototype.tlds = function () {
                        return [
                            'com',
                            'org',
                            'edu',
                            'gov',
                            'co.uk',
                            'net',
                            'io',
                            'ac',
                            'ad',
                            'ae',
                            'af',
                            'ag',
                            'ai',
                            'al',
                            'am',
                            'ao',
                            'aq',
                            'ar',
                            'as',
                            'at',
                            'au',
                            'aw',
                            'ax',
                            'az',
                            'ba',
                            'bb',
                            'bd',
                            'be',
                            'bf',
                            'bg',
                            'bh',
                            'bi',
                            'bj',
                            'bm',
                            'bn',
                            'bo',
                            'br',
                            'bs',
                            'bt',
                            'bv',
                            'bw',
                            'by',
                            'bz',
                            'ca',
                            'cc',
                            'cd',
                            'cf',
                            'cg',
                            'ch',
                            'ci',
                            'ck',
                            'cl',
                            'cm',
                            'cn',
                            'co',
                            'cr',
                            'cu',
                            'cv',
                            'cw',
                            'cx',
                            'cy',
                            'cz',
                            'de',
                            'dj',
                            'dk',
                            'dm',
                            'do',
                            'dz',
                            'ec',
                            'ee',
                            'eg',
                            'eh',
                            'er',
                            'es',
                            'et',
                            'eu',
                            'fi',
                            'fj',
                            'fk',
                            'fm',
                            'fo',
                            'fr',
                            'ga',
                            'gb',
                            'gd',
                            'ge',
                            'gf',
                            'gg',
                            'gh',
                            'gi',
                            'gl',
                            'gm',
                            'gn',
                            'gp',
                            'gq',
                            'gr',
                            'gs',
                            'gt',
                            'gu',
                            'gw',
                            'gy',
                            'hk',
                            'hm',
                            'hn',
                            'hr',
                            'ht',
                            'hu',
                            'id',
                            'ie',
                            'il',
                            'im',
                            'in',
                            'io',
                            'iq',
                            'ir',
                            'is',
                            'it',
                            'je',
                            'jm',
                            'jo',
                            'jp',
                            'ke',
                            'kg',
                            'kh',
                            'ki',
                            'km',
                            'kn',
                            'kp',
                            'kr',
                            'kw',
                            'ky',
                            'kz',
                            'la',
                            'lb',
                            'lc',
                            'li',
                            'lk',
                            'lr',
                            'ls',
                            'lt',
                            'lu',
                            'lv',
                            'ly',
                            'ma',
                            'mc',
                            'md',
                            'me',
                            'mg',
                            'mh',
                            'mk',
                            'ml',
                            'mm',
                            'mn',
                            'mo',
                            'mp',
                            'mq',
                            'mr',
                            'ms',
                            'mt',
                            'mu',
                            'mv',
                            'mw',
                            'mx',
                            'my',
                            'mz',
                            'na',
                            'nc',
                            'ne',
                            'nf',
                            'ng',
                            'ni',
                            'nl',
                            'no',
                            'np',
                            'nr',
                            'nu',
                            'nz',
                            'om',
                            'pa',
                            'pe',
                            'pf',
                            'pg',
                            'ph',
                            'pk',
                            'pl',
                            'pm',
                            'pn',
                            'pr',
                            'ps',
                            'pt',
                            'pw',
                            'py',
                            'qa',
                            're',
                            'ro',
                            'rs',
                            'ru',
                            'rw',
                            'sa',
                            'sb',
                            'sc',
                            'sd',
                            'se',
                            'sg',
                            'sh',
                            'si',
                            'sj',
                            'sk',
                            'sl',
                            'sm',
                            'sn',
                            'so',
                            'sr',
                            'ss',
                            'st',
                            'su',
                            'sv',
                            'sx',
                            'sy',
                            'sz',
                            'tc',
                            'td',
                            'tf',
                            'tg',
                            'th',
                            'tj',
                            'tk',
                            'tl',
                            'tm',
                            'tn',
                            'to',
                            'tp',
                            'tr',
                            'tt',
                            'tv',
                            'tw',
                            'tz',
                            'ua',
                            'ug',
                            'uk',
                            'us',
                            'uy',
                            'uz',
                            'va',
                            'vc',
                            've',
                            'vg',
                            'vi',
                            'vn',
                            'vu',
                            'wf',
                            'ws',
                            'ye',
                            'yt',
                            'za',
                            'zm',
                            'zw'
                        ];
                    }, l.prototype.tld = function () {
                        return this.pick(this.tlds());
                    }, l.prototype.twitter = function () {
                        return '@' + this.word();
                    }, l.prototype.url = function (e) {
                        var t = (e = d(e, {
                                protocol: 'http',
                                domain: this.domain(e),
                                domain_prefix: '',
                                path: this.word(),
                                extensions: []
                            })).extensions.length > 0 ? '.' + this.pick(e.extensions) : '', r = e.domain_prefix ? e.domain_prefix + '.' + e.domain : e.domain;
                        return e.protocol + '://' + r + '/' + e.path + t;
                    }, l.prototype.port = function () {
                        return this.integer({
                            min: 0,
                            max: 65535
                        });
                    }, l.prototype.locale = function (e) {
                        return (e = d(e)).region ? this.pick(this.get('locale_regions')) : this.pick(this.get('locale_languages'));
                    }, l.prototype.locales = function (e) {
                        return (e = d(e)).region ? this.get('locale_regions') : this.get('locale_languages');
                    }, l.prototype.loremPicsum = function (e) {
                        var t = (e = d(e, {
                                width: 500,
                                height: 500,
                                greyscale: !1,
                                blurred: !1
                            })).greyscale ? 'g/' : '', r = e.blurred ? '/?blur' : '/?random';
                        return 'https://picsum.photos/' + t + e.width + '/' + e.height + r;
                    }, l.prototype.address = function (e) {
                        return e = d(e), this.natural({
                            min: 5,
                            max: 2000
                        }) + ' ' + this.street(e);
                    }, l.prototype.altitude = function (e) {
                        return e = d(e, {
                            fixed: 5,
                            min: 0,
                            max: 8848
                        }), this.floating({
                            min: e.min,
                            max: e.max,
                            fixed: e.fixed
                        });
                    }, l.prototype.areacode = function (e) {
                        var t = (e = d(e, { parens: !0 })).exampleNumber ? '555' : this.natural({
                            min: 2,
                            max: 9
                        }).toString() + this.natural({
                            min: 0,
                            max: 8
                        }).toString() + this.natural({
                            min: 0,
                            max: 9
                        }).toString();
                        return e.parens ? '(' + t + ')' : t;
                    }, l.prototype.city = function () {
                        return this.capitalize(this.word({ syllables: 3 }));
                    }, l.prototype.coordinates = function (e) {
                        return this.latitude(e) + ', ' + this.longitude(e);
                    }, l.prototype.countries = function () {
                        return this.get('countries');
                    }, l.prototype.country = function (e) {
                        e = d(e);
                        var t = this.pick(this.countries());
                        return e.raw ? t : e.full ? t.name : t.abbreviation;
                    }, l.prototype.depth = function (e) {
                        return e = d(e, {
                            fixed: 5,
                            min: -10994,
                            max: 0
                        }), this.floating({
                            min: e.min,
                            max: e.max,
                            fixed: e.fixed
                        });
                    }, l.prototype.geohash = function (e) {
                        return e = d(e, { length: 7 }), this.string({
                            length: e.length,
                            pool: '0123456789bcdefghjkmnpqrstuvwxyz'
                        });
                    }, l.prototype.geojson = function (e) {
                        return this.latitude(e) + ', ' + this.longitude(e) + ', ' + this.altitude(e);
                    }, l.prototype.latitude = function (e) {
                        var [t, r, n] = [
                                'ddm',
                                'dms',
                                'dd'
                            ], i = (e = d(e, e && e.format && [
                                t,
                                r
                            ].includes(e.format.toLowerCase()) ? {
                                min: 0,
                                max: 89,
                                fixed: 4
                            } : {
                                fixed: 5,
                                min: -90,
                                max: 90,
                                format: n
                            })).format.toLowerCase();
                        switch (i !== t && i !== r || (p(e.min < 0 || e.min > 89, 'Chance: Min specified is out of range. Should be between 0 - 89'), p(e.max < 0 || e.max > 89, 'Chance: Max specified is out of range. Should be between 0 - 89'), p(e.fixed > 4, 'Chance: Fixed specified should be below or equal to 4')), i) {
                        case t:
                            return this.integer({
                                min: e.min,
                                max: e.max
                            }) + '\xB0' + this.floating({
                                min: 0,
                                max: 59,
                                fixed: e.fixed
                            });
                        case r:
                            return this.integer({
                                min: e.min,
                                max: e.max
                            }) + '\xB0' + this.integer({
                                min: 0,
                                max: 59
                            }) + '\u2019' + this.floating({
                                min: 0,
                                max: 59,
                                fixed: e.fixed
                            }) + '\u201D';
                        case n:
                        default:
                            return this.floating({
                                min: e.min,
                                max: e.max,
                                fixed: e.fixed
                            });
                        }
                    }, l.prototype.longitude = function (e) {
                        var [t, r, n] = [
                                'ddm',
                                'dms',
                                'dd'
                            ], i = (e = d(e, e && e.format && [
                                t,
                                r
                            ].includes(e.format.toLowerCase()) ? {
                                min: 0,
                                max: 179,
                                fixed: 4
                            } : {
                                fixed: 5,
                                min: -180,
                                max: 180,
                                format: n
                            })).format.toLowerCase();
                        switch (i !== t && i !== r || (p(e.min < 0 || e.min > 179, 'Chance: Min specified is out of range. Should be between 0 - 179'), p(e.max < 0 || e.max > 179, 'Chance: Max specified is out of range. Should be between 0 - 179'), p(e.fixed > 4, 'Chance: Fixed specified should be below or equal to 4')), i) {
                        case t:
                            return this.integer({
                                min: e.min,
                                max: e.max
                            }) + '\xB0' + this.floating({
                                min: 0,
                                max: 59.9999,
                                fixed: e.fixed
                            });
                        case r:
                            return this.integer({
                                min: e.min,
                                max: e.max
                            }) + '\xB0' + this.integer({
                                min: 0,
                                max: 59
                            }) + '\u2019' + this.floating({
                                min: 0,
                                max: 59.9999,
                                fixed: e.fixed
                            }) + '\u201D';
                        case n:
                        default:
                            return this.floating({
                                min: e.min,
                                max: e.max,
                                fixed: e.fixed
                            });
                        }
                    }, l.prototype.phone = function (e) {
                        var t, r, n = this, i = function (e) {
                                var t = [];
                                return e.sections.forEach(function (e) {
                                    t.push(n.string({
                                        pool: '0123456789',
                                        length: e
                                    }));
                                }), e.area + t.join(' ');
                            };
                        switch ((e = d(e, {
                                formatted: !0,
                                country: 'us',
                                mobile: !1,
                                exampleNumber: !1
                            })).formatted || (e.parens = !1), e.country) {
                        case 'fr':
                            e.mobile ? (t = this.pick([
                                '06',
                                '07'
                            ]) + n.string({
                                pool: '0123456789',
                                length: 8
                            }), r = e.formatted ? t.match(/../g).join(' ') : t) : (t = this.pick([
                                '01' + this.pick([
                                    '30',
                                    '34',
                                    '39',
                                    '40',
                                    '41',
                                    '42',
                                    '43',
                                    '44',
                                    '45',
                                    '46',
                                    '47',
                                    '48',
                                    '49',
                                    '53',
                                    '55',
                                    '56',
                                    '58',
                                    '60',
                                    '64',
                                    '69',
                                    '70',
                                    '72',
                                    '73',
                                    '74',
                                    '75',
                                    '76',
                                    '77',
                                    '78',
                                    '79',
                                    '80',
                                    '81',
                                    '82',
                                    '83'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 6
                                }),
                                '02' + this.pick([
                                    '14',
                                    '18',
                                    '22',
                                    '23',
                                    '28',
                                    '29',
                                    '30',
                                    '31',
                                    '32',
                                    '33',
                                    '34',
                                    '35',
                                    '36',
                                    '37',
                                    '38',
                                    '40',
                                    '41',
                                    '43',
                                    '44',
                                    '45',
                                    '46',
                                    '47',
                                    '48',
                                    '49',
                                    '50',
                                    '51',
                                    '52',
                                    '53',
                                    '54',
                                    '56',
                                    '57',
                                    '61',
                                    '62',
                                    '69',
                                    '72',
                                    '76',
                                    '77',
                                    '78',
                                    '85',
                                    '90',
                                    '96',
                                    '97',
                                    '98',
                                    '99'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 6
                                }),
                                '03' + this.pick([
                                    '10',
                                    '20',
                                    '21',
                                    '22',
                                    '23',
                                    '24',
                                    '25',
                                    '26',
                                    '27',
                                    '28',
                                    '29',
                                    '39',
                                    '44',
                                    '45',
                                    '51',
                                    '52',
                                    '54',
                                    '55',
                                    '57',
                                    '58',
                                    '59',
                                    '60',
                                    '61',
                                    '62',
                                    '63',
                                    '64',
                                    '65',
                                    '66',
                                    '67',
                                    '68',
                                    '69',
                                    '70',
                                    '71',
                                    '72',
                                    '73',
                                    '80',
                                    '81',
                                    '82',
                                    '83',
                                    '84',
                                    '85',
                                    '86',
                                    '87',
                                    '88',
                                    '89',
                                    '90'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 6
                                }),
                                '04' + this.pick([
                                    '11',
                                    '13',
                                    '15',
                                    '20',
                                    '22',
                                    '26',
                                    '27',
                                    '30',
                                    '32',
                                    '34',
                                    '37',
                                    '42',
                                    '43',
                                    '44',
                                    '50',
                                    '56',
                                    '57',
                                    '63',
                                    '66',
                                    '67',
                                    '68',
                                    '69',
                                    '70',
                                    '71',
                                    '72',
                                    '73',
                                    '74',
                                    '75',
                                    '76',
                                    '77',
                                    '78',
                                    '79',
                                    '80',
                                    '81',
                                    '82',
                                    '83',
                                    '84',
                                    '85',
                                    '86',
                                    '88',
                                    '89',
                                    '90',
                                    '91',
                                    '92',
                                    '93',
                                    '94',
                                    '95',
                                    '97',
                                    '98'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 6
                                }),
                                '05' + this.pick([
                                    '08',
                                    '16',
                                    '17',
                                    '19',
                                    '24',
                                    '31',
                                    '32',
                                    '33',
                                    '34',
                                    '35',
                                    '40',
                                    '45',
                                    '46',
                                    '47',
                                    '49',
                                    '53',
                                    '55',
                                    '56',
                                    '57',
                                    '58',
                                    '59',
                                    '61',
                                    '62',
                                    '63',
                                    '64',
                                    '65',
                                    '67',
                                    '79',
                                    '81',
                                    '82',
                                    '86',
                                    '87',
                                    '90',
                                    '94'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 6
                                }),
                                '09' + n.string({
                                    pool: '0123456789',
                                    length: 8
                                })
                            ]), r = e.formatted ? t.match(/../g).join(' ') : t);
                            break;
                        case 'uk':
                            e.mobile ? (t = this.pick([
                                {
                                    area: '07' + this.pick([
                                        '4',
                                        '5',
                                        '7',
                                        '8',
                                        '9'
                                    ]),
                                    sections: [
                                        2,
                                        6
                                    ]
                                },
                                {
                                    area: '07624 ',
                                    sections: [6]
                                }
                            ]), r = e.formatted ? i(t) : i(t).replace(' ', '')) : (t = this.pick([
                                {
                                    area: '01' + this.character({ pool: '234569' }) + '1 ',
                                    sections: [
                                        3,
                                        4
                                    ]
                                },
                                {
                                    area: '020 ' + this.character({ pool: '378' }),
                                    sections: [
                                        3,
                                        4
                                    ]
                                },
                                {
                                    area: '023 ' + this.character({ pool: '89' }),
                                    sections: [
                                        3,
                                        4
                                    ]
                                },
                                {
                                    area: '024 7',
                                    sections: [
                                        3,
                                        4
                                    ]
                                },
                                {
                                    area: '028 ' + this.pick([
                                        '25',
                                        '28',
                                        '37',
                                        '71',
                                        '82',
                                        '90',
                                        '92',
                                        '95'
                                    ]),
                                    sections: [
                                        2,
                                        4
                                    ]
                                },
                                {
                                    area: '012' + this.pick([
                                        '04',
                                        '08',
                                        '54',
                                        '76',
                                        '97',
                                        '98'
                                    ]) + ' ',
                                    sections: [6]
                                },
                                {
                                    area: '013' + this.pick([
                                        '63',
                                        '64',
                                        '84',
                                        '86'
                                    ]) + ' ',
                                    sections: [6]
                                },
                                {
                                    area: '014' + this.pick([
                                        '04',
                                        '20',
                                        '60',
                                        '61',
                                        '80',
                                        '88'
                                    ]) + ' ',
                                    sections: [6]
                                },
                                {
                                    area: '015' + this.pick([
                                        '24',
                                        '27',
                                        '62',
                                        '66'
                                    ]) + ' ',
                                    sections: [6]
                                },
                                {
                                    area: '016' + this.pick([
                                        '06',
                                        '29',
                                        '35',
                                        '47',
                                        '59',
                                        '95'
                                    ]) + ' ',
                                    sections: [6]
                                },
                                {
                                    area: '017' + this.pick([
                                        '26',
                                        '44',
                                        '50',
                                        '68'
                                    ]) + ' ',
                                    sections: [6]
                                },
                                {
                                    area: '018' + this.pick([
                                        '27',
                                        '37',
                                        '84',
                                        '97'
                                    ]) + ' ',
                                    sections: [6]
                                },
                                {
                                    area: '019' + this.pick([
                                        '00',
                                        '05',
                                        '35',
                                        '46',
                                        '49',
                                        '63',
                                        '95'
                                    ]) + ' ',
                                    sections: [6]
                                }
                            ]), r = e.formatted ? i(t) : i(t).replace(' ', '', 'g'));
                            break;
                        case 'za':
                            e.mobile ? (t = this.pick([
                                '060' + this.pick([
                                    '3',
                                    '4',
                                    '5',
                                    '6',
                                    '7',
                                    '8',
                                    '9'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 6
                                }),
                                '061' + this.pick([
                                    '0',
                                    '1',
                                    '2',
                                    '3',
                                    '4',
                                    '5',
                                    '8'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 6
                                }),
                                '06' + n.string({
                                    pool: '0123456789',
                                    length: 7
                                }),
                                '071' + this.pick([
                                    '0',
                                    '1',
                                    '2',
                                    '3',
                                    '4',
                                    '5',
                                    '6',
                                    '7',
                                    '8',
                                    '9'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 6
                                }),
                                '07' + this.pick([
                                    '2',
                                    '3',
                                    '4',
                                    '6',
                                    '7',
                                    '8',
                                    '9'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 7
                                }),
                                '08' + this.pick([
                                    '0',
                                    '1',
                                    '2',
                                    '3',
                                    '4',
                                    '5'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 7
                                })
                            ]), r = e.formatted || t) : (t = this.pick([
                                '01' + this.pick([
                                    '0',
                                    '1',
                                    '2',
                                    '3',
                                    '4',
                                    '5',
                                    '6',
                                    '7',
                                    '8'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 7
                                }),
                                '02' + this.pick([
                                    '1',
                                    '2',
                                    '3',
                                    '4',
                                    '7',
                                    '8'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 7
                                }),
                                '03' + this.pick([
                                    '1',
                                    '2',
                                    '3',
                                    '5',
                                    '6',
                                    '9'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 7
                                }),
                                '04' + this.pick([
                                    '1',
                                    '2',
                                    '3',
                                    '4',
                                    '5',
                                    '6',
                                    '7',
                                    '8',
                                    '9'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 7
                                }),
                                '05' + this.pick([
                                    '1',
                                    '3',
                                    '4',
                                    '6',
                                    '7',
                                    '8'
                                ]) + n.string({
                                    pool: '0123456789',
                                    length: 7
                                })
                            ]), r = e.formatted || t);
                            break;
                        case 'us':
                            var a = this.areacode(e).toString(), o = this.natural({
                                    min: 2,
                                    max: 9
                                }).toString() + this.natural({
                                    min: 0,
                                    max: 9
                                }).toString() + this.natural({
                                    min: 0,
                                    max: 9
                                }).toString(), s = this.natural({
                                    min: 1000,
                                    max: 9999
                                }).toString();
                            r = e.formatted ? a + ' ' + o + '-' + s : a + o + s;
                            break;
                        case 'br':
                            var c, u = this.pick([
                                    '11',
                                    '12',
                                    '13',
                                    '14',
                                    '15',
                                    '16',
                                    '17',
                                    '18',
                                    '19',
                                    '21',
                                    '22',
                                    '24',
                                    '27',
                                    '28',
                                    '31',
                                    '32',
                                    '33',
                                    '34',
                                    '35',
                                    '37',
                                    '38',
                                    '41',
                                    '42',
                                    '43',
                                    '44',
                                    '45',
                                    '46',
                                    '47',
                                    '48',
                                    '49',
                                    '51',
                                    '53',
                                    '54',
                                    '55',
                                    '61',
                                    '62',
                                    '63',
                                    '64',
                                    '65',
                                    '66',
                                    '67',
                                    '68',
                                    '69',
                                    '71',
                                    '73',
                                    '74',
                                    '75',
                                    '77',
                                    '79',
                                    '81',
                                    '82',
                                    '83',
                                    '84',
                                    '85',
                                    '86',
                                    '87',
                                    '88',
                                    '89',
                                    '91',
                                    '92',
                                    '93',
                                    '94',
                                    '95',
                                    '96',
                                    '97',
                                    '98',
                                    '99'
                                ]);
                            c = e.mobile ? '9' + n.string({
                                pool: '0123456789',
                                length: 4
                            }) : this.natural({
                                min: 2000,
                                max: 5999
                            }).toString();
                            var l = n.string({
                                pool: '0123456789',
                                length: 4
                            });
                            r = e.formatted ? '(' + u + ') ' + c + '-' + l : u + c + l;
                        }
                        return r;
                    }, l.prototype.postal = function () {
                        return this.character({ pool: 'XVTSRPNKLMHJGECBA' }) + this.natural({ max: 9 }) + this.character({
                            alpha: !0,
                            casing: 'upper'
                        }) + ' ' + (this.natural({ max: 9 }) + this.character({
                            alpha: !0,
                            casing: 'upper'
                        }) + this.natural({ max: 9 }));
                    }, l.prototype.postcode = function () {
                        return this.pick(this.get('postcodeAreas')).code + this.natural({ max: 9 }) + (this.bool() ? this.character({
                            alpha: !0,
                            casing: 'upper'
                        }) : '') + ' ' + (this.natural({ max: 9 }) + (this.character({
                            alpha: !0,
                            casing: 'upper'
                        }) + this.character({
                            alpha: !0,
                            casing: 'upper'
                        })));
                    }, l.prototype.counties = function (e) {
                        return e = d(e, { country: 'uk' }), this.get('counties')[e.country.toLowerCase()];
                    }, l.prototype.county = function (e) {
                        return this.pick(this.counties(e)).name;
                    }, l.prototype.provinces = function (e) {
                        return e = d(e, { country: 'ca' }), this.get('provinces')[e.country.toLowerCase()];
                    }, l.prototype.province = function (e) {
                        return e && e.full ? this.pick(this.provinces(e)).name : this.pick(this.provinces(e)).abbreviation;
                    }, l.prototype.state = function (e) {
                        return e && e.full ? this.pick(this.states(e)).name : this.pick(this.states(e)).abbreviation;
                    }, l.prototype.states = function (e) {
                        var t;
                        switch ((e = d(e, {
                                country: 'us',
                                us_states_and_dc: !0
                            })).country.toLowerCase()) {
                        case 'us':
                            var r = this.get('us_states_and_dc'), n = this.get('territories'), i = this.get('armed_forces');
                            t = [], e.us_states_and_dc && (t = t.concat(r)), e.territories && (t = t.concat(n)), e.armed_forces && (t = t.concat(i));
                            break;
                        case 'it':
                        case 'mx':
                            t = this.get('country_regions')[e.country.toLowerCase()];
                            break;
                        case 'uk':
                            t = this.get('counties')[e.country.toLowerCase()];
                        }
                        return t;
                    }, l.prototype.street = function (e) {
                        var t;
                        switch ((e = d(e, {
                                country: 'us',
                                syllables: 2
                            })).country.toLowerCase()) {
                        case 'us':
                            t = this.word({ syllables: e.syllables }), t = this.capitalize(t), t += ' ', t += e.short_suffix ? this.street_suffix(e).abbreviation : this.street_suffix(e).name;
                            break;
                        case 'it':
                            t = this.word({ syllables: e.syllables }), t = this.capitalize(t), t = (e.short_suffix ? this.street_suffix(e).abbreviation : this.street_suffix(e).name) + ' ' + t;
                        }
                        return t;
                    }, l.prototype.street_suffix = function (e) {
                        return e = d(e, { country: 'us' }), this.pick(this.street_suffixes(e));
                    }, l.prototype.street_suffixes = function (e) {
                        return e = d(e, { country: 'us' }), this.get('street_suffixes')[e.country.toLowerCase()];
                    }, l.prototype.zip = function (e) {
                        var t = this.n(this.natural, 5, { max: 9 });
                        return e && !0 === e.plusfour && (t.push('-'), t = t.concat(this.n(this.natural, 4, { max: 9 }))), t.join('');
                    }, l.prototype.ampm = function () {
                        return this.bool() ? 'am' : 'pm';
                    }, l.prototype.date = function (e) {
                        var t, r;
                        if (e && (e.min || e.max)) {
                            var n = void 0 !== (e = d(e, {
                                    american: !0,
                                    string: !1
                                })).min ? e.min.getTime() : 1, i = void 0 !== e.max ? e.max.getTime() : 8640000000000000;
                            r = new Date(this.integer({
                                min: n,
                                max: i
                            }));
                        } else {
                            var a = this.month({ raw: !0 }), o = a.days;
                            e && e.month && (o = this.get('months')[(e.month % 12 + 12) % 12].days), e = d(e, {
                                year: parseInt(this.year(), 10),
                                month: a.numeric - 1,
                                day: this.natural({
                                    min: 1,
                                    max: o
                                }),
                                hour: this.hour({ twentyfour: !0 }),
                                minute: this.minute(),
                                second: this.second(),
                                millisecond: this.millisecond(),
                                american: !0,
                                string: !1
                            }), r = new Date(e.year, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
                        }
                        return t = e.american ? r.getMonth() + 1 + '/' + r.getDate() + '/' + r.getFullYear() : r.getDate() + '/' + (r.getMonth() + 1) + '/' + r.getFullYear(), e.string ? t : r;
                    }, l.prototype.hammertime = function (e) {
                        return this.date(e).getTime();
                    }, l.prototype.hour = function (e) {
                        return p((e = d(e, {
                            min: e && e.twentyfour ? 0 : 1,
                            max: e && e.twentyfour ? 23 : 12
                        })).min < 0, 'Chance: Min cannot be less than 0.'), p(e.twentyfour && e.max > 23, 'Chance: Max cannot be greater than 23 for twentyfour option.'), p(!e.twentyfour && e.max > 12, 'Chance: Max cannot be greater than 12.'), p(e.min > e.max, 'Chance: Min cannot be greater than Max.'), this.natural({
                            min: e.min,
                            max: e.max
                        });
                    }, l.prototype.millisecond = function () {
                        return this.natural({ max: 999 });
                    }, l.prototype.minute = l.prototype.second = function (e) {
                        return p((e = d(e, {
                            min: 0,
                            max: 59
                        })).min < 0, 'Chance: Min cannot be less than 0.'), p(e.max > 59, 'Chance: Max cannot be greater than 59.'), p(e.min > e.max, 'Chance: Min cannot be greater than Max.'), this.natural({
                            min: e.min,
                            max: e.max
                        });
                    }, l.prototype.month = function (e) {
                        p((e = d(e, {
                            min: 1,
                            max: 12
                        })).min < 1, 'Chance: Min cannot be less than 1.'), p(e.max > 12, 'Chance: Max cannot be greater than 12.'), p(e.min > e.max, 'Chance: Min cannot be greater than Max.');
                        var t = this.pick(this.months().slice(e.min - 1, e.max));
                        return e.raw ? t : t.name;
                    }, l.prototype.months = function () {
                        return this.get('months');
                    }, l.prototype.second = function () {
                        return this.natural({ max: 59 });
                    }, l.prototype.timestamp = function () {
                        return this.natural({
                            min: 1,
                            max: parseInt(new Date().getTime() / 1000, 10)
                        });
                    }, l.prototype.weekday = function (e) {
                        var t = [
                            'Monday',
                            'Tuesday',
                            'Wednesday',
                            'Thursday',
                            'Friday'
                        ];
                        return (e = d(e, { weekday_only: !1 })).weekday_only || (t.push('Saturday'), t.push('Sunday')), this.pickone(t);
                    }, l.prototype.year = function (e) {
                        return (e = d(e, { min: new Date().getFullYear() })).max = void 0 !== e.max ? e.max : e.min + 100, this.natural(e).toString();
                    }, l.prototype.cc = function (e) {
                        var t, r, n;
                        return r = (t = (e = d(e)).type ? this.cc_type({
                            name: e.type,
                            raw: !0
                        }) : this.cc_type({ raw: !0 })).prefix.split(''), n = t.length - t.prefix.length - 1, (r = r.concat(this.n(this.integer, n, {
                            min: 0,
                            max: 9
                        }))).push(this.luhn_calculate(r.join(''))), r.join('');
                    }, l.prototype.cc_types = function () {
                        return this.get('cc_types');
                    }, l.prototype.cc_type = function (e) {
                        e = d(e);
                        var t = this.cc_types(), r = null;
                        if (e.name) {
                            for (var n = 0; n < t.length; n++)
                                if (t[n].name === e.name || t[n].short_name === e.name) {
                                    r = t[n];
                                    break;
                                }
                            if (null === r)
                                throw new RangeError('Chance: Credit card type \'' + e.name + '\' is not supported');
                        } else
                            r = this.pick(t);
                        return e.raw ? r : r.name;
                    }, l.prototype.currency_types = function () {
                        return this.get('currency_types');
                    }, l.prototype.currency = function () {
                        return this.pick(this.currency_types());
                    }, l.prototype.timezones = function () {
                        return this.get('timezones');
                    }, l.prototype.timezone = function () {
                        return this.pick(this.timezones());
                    }, l.prototype.currency_pair = function (e) {
                        var t = this.unique(this.currency, 2, {
                            comparator: function (e, t) {
                                return e.reduce(function (e, r) {
                                    return e || r.code === t.code;
                                }, !1);
                            }
                        });
                        return e ? t[0].code + '/' + t[1].code : t;
                    }, l.prototype.dollar = function (e) {
                        e = d(e, {
                            max: 10000,
                            min: 0
                        });
                        var t = this.floating({
                                min: e.min,
                                max: e.max,
                                fixed: 2
                            }).toString(), r = t.split('.')[1];
                        return void 0 === r ? t += '.00' : r.length < 2 && (t += '0'), t < 0 ? '-$' + t.replace('-', '') : '$' + t;
                    }, l.prototype.euro = function (e) {
                        return Number(this.dollar(e).replace('$', '')).toLocaleString() + '\u20AC';
                    }, l.prototype.exp = function (e) {
                        e = d(e);
                        var t = {};
                        return t.year = this.exp_year(), t.year === new Date().getFullYear().toString() ? t.month = this.exp_month({ future: !0 }) : t.month = this.exp_month(), e.raw ? t : t.month + '/' + t.year;
                    }, l.prototype.exp_month = function (e) {
                        e = d(e);
                        var t, r, n = new Date().getMonth() + 1;
                        if (e.future && 12 !== n)
                            do {
                                t = this.month({ raw: !0 }).numeric, r = parseInt(t, 10);
                            } while (r <= n);
                        else
                            t = this.month({ raw: !0 }).numeric;
                        return t;
                    }, l.prototype.exp_year = function () {
                        var e = new Date().getMonth() + 1, t = new Date().getFullYear();
                        return this.year({
                            min: 12 === e ? t + 1 : t,
                            max: t + 10
                        });
                    }, l.prototype.vat = function (e) {
                        switch ((e = d(e, { country: 'it' })).country.toLowerCase()) {
                        case 'it':
                            return this.it_vat();
                        }
                    }, l.prototype.iban = function () {
                        return this.string({
                            length: 2,
                            pool: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
                        }) + this.pad(this.integer({
                            min: 0,
                            max: 99
                        }), 2) + this.string({
                            length: 4,
                            pool: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
                        }) + this.pad(this.natural(), this.natural({
                            min: 6,
                            max: 26
                        }));
                    }, l.prototype.it_vat = function () {
                        var e = this.natural({
                            min: 1,
                            max: 1800000
                        });
                        return (e = this.pad(e, 7) + this.pad(this.pick(this.provinces({ country: 'it' })).code, 3)) + this.luhn_calculate(e);
                    }, l.prototype.cf = function (e) {
                        var t = (e = e || {}).gender ? e.gender : this.gender(), r = e.first ? e.first : this.first({
                                gender: t,
                                nationality: 'it'
                            }), n = e.last ? e.last : this.last({ nationality: 'it' }), i = e.birthday ? e.birthday : this.birthday(), a = e.city ? e.city : this.pickone([
                                'A',
                                'B',
                                'C',
                                'D',
                                'E',
                                'F',
                                'G',
                                'H',
                                'I',
                                'L',
                                'M',
                                'Z'
                            ]) + this.pad(this.natural({ max: 999 }), 3), o = [], s = function (e, t) {
                                var r, n = [];
                                return e.length < 3 ? n = e.split('').concat('XXX'.split('')).splice(0, 3) : ((r = e.toUpperCase().split('').map(function (e) {
                                    return -1 !== 'BCDFGHJKLMNPRSTVWZ'.indexOf(e) ? e : void 0;
                                }).join('')).length > 3 && (r = t ? r.substr(0, 3) : r[0] + r.substr(2, 2)), r.length < 3 && (n = r, r = e.toUpperCase().split('').map(function (e) {
                                    return -1 !== 'AEIOU'.indexOf(e) ? e : void 0;
                                }).join('').substr(0, 3 - n.length)), n += r), n;
                            };
                        return o = o.concat(s(n, !0), s(r), function (e, t, r) {
                            return e.getFullYear().toString().substr(2) + [
                                'A',
                                'B',
                                'C',
                                'D',
                                'E',
                                'H',
                                'L',
                                'M',
                                'P',
                                'R',
                                'S',
                                'T'
                            ][e.getMonth()] + r.pad(e.getDate() + ('female' === t.toLowerCase() ? 40 : 0), 2);
                        }(i, t, this), a.toUpperCase().split('')).join(''), (o += function (e) {
                            for (var t = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ', r = 'ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ', n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', i = 0, a = 0; a < 15; a++)
                                i += a % 2 != 0 ? n.indexOf(r[t.indexOf(e[a])]) : 'BAKPLCQDREVOSFTGUHMINJWZYX'.indexOf(r[t.indexOf(e[a])]);
                            return n[i % 26];
                        }(o.toUpperCase())).toUpperCase();
                    }, l.prototype.pl_pesel = function () {
                        for (var e = this.natural({
                                    min: 1,
                                    max: 9999999999
                                }), t = this.pad(e, 10).split(''), r = 0; r < t.length; r++)
                            t[r] = parseInt(t[r]);
                        var n = (1 * t[0] + 3 * t[1] + 7 * t[2] + 9 * t[3] + 1 * t[4] + 3 * t[5] + 7 * t[6] + 9 * t[7] + 1 * t[8] + 3 * t[9]) % 10;
                        return 0 !== n && (n = 10 - n), t.join('') + n;
                    }, l.prototype.pl_nip = function () {
                        for (var e = this.natural({
                                    min: 1,
                                    max: 999999999
                                }), t = this.pad(e, 9).split(''), r = 0; r < t.length; r++)
                            t[r] = parseInt(t[r]);
                        var n = (6 * t[0] + 5 * t[1] + 7 * t[2] + 2 * t[3] + 3 * t[4] + 4 * t[5] + 5 * t[6] + 6 * t[7] + 7 * t[8]) % 11;
                        return 10 === n ? this.pl_nip() : t.join('') + n;
                    }, l.prototype.pl_regon = function () {
                        for (var e = this.natural({
                                    min: 1,
                                    max: 99999999
                                }), t = this.pad(e, 8).split(''), r = 0; r < t.length; r++)
                            t[r] = parseInt(t[r]);
                        var n = (8 * t[0] + 9 * t[1] + 2 * t[2] + 3 * t[3] + 4 * t[4] + 5 * t[5] + 6 * t[6] + 7 * t[7]) % 11;
                        return 10 === n && (n = 0), t.join('') + n;
                    }, l.prototype.note = function (e) {
                        e = d(e, { notes: 'flatKey' });
                        var t = {
                            naturals: [
                                'C',
                                'D',
                                'E',
                                'F',
                                'G',
                                'A',
                                'B'
                            ],
                            flats: [
                                'D\u266D',
                                'E\u266D',
                                'G\u266D',
                                'A\u266D',
                                'B\u266D'
                            ],
                            sharps: [
                                'C\u266F',
                                'D\u266F',
                                'F\u266F',
                                'G\u266F',
                                'A\u266F'
                            ]
                        };
                        return t.all = t.naturals.concat(t.flats.concat(t.sharps)), t.flatKey = t.naturals.concat(t.flats), t.sharpKey = t.naturals.concat(t.sharps), this.pickone(t[e.notes]);
                    }, l.prototype.midi_note = function (e) {
                        return e = d(e, {
                            min: 0,
                            max: 127
                        }), this.integer({
                            min: e.min,
                            max: e.max
                        });
                    }, l.prototype.chord_quality = function (e) {
                        var t = [
                            'maj',
                            'min',
                            'aug',
                            'dim'
                        ];
                        return (e = d(e, { jazz: !0 })).jazz && (t = [
                            'maj7',
                            'min7',
                            '7',
                            'sus',
                            'dim',
                            'ø'
                        ]), this.pickone(t);
                    }, l.prototype.chord = function (e) {
                        return e = d(e), this.note(e) + this.chord_quality(e);
                    }, l.prototype.tempo = function (e) {
                        return e = d(e, {
                            min: 40,
                            max: 320
                        }), this.integer({
                            min: e.min,
                            max: e.max
                        });
                    }, l.prototype.coin = function () {
                        return this.bool() ? 'heads' : 'tails';
                    }, l.prototype.d4 = y({
                        min: 1,
                        max: 4
                    }), l.prototype.d6 = y({
                        min: 1,
                        max: 6
                    }), l.prototype.d8 = y({
                        min: 1,
                        max: 8
                    }), l.prototype.d10 = y({
                        min: 1,
                        max: 10
                    }), l.prototype.d12 = y({
                        min: 1,
                        max: 12
                    }), l.prototype.d20 = y({
                        min: 1,
                        max: 20
                    }), l.prototype.d30 = y({
                        min: 1,
                        max: 30
                    }), l.prototype.d100 = y({
                        min: 1,
                        max: 100
                    }), l.prototype.rpg = function (e, t) {
                        if (t = d(t), e) {
                            var r = e.toLowerCase().split('d'), n = [];
                            if (2 !== r.length || !parseInt(r[0], 10) || !parseInt(r[1], 10))
                                throw new Error('Chance: Invalid format provided. Please provide #d# where the first # is the number of dice to roll, the second # is the max of each die');
                            for (var i = r[0]; i > 0; i--)
                                n[i - 1] = this.natural({
                                    min: 1,
                                    max: r[1]
                                });
                            return void 0 !== t.sum && t.sum ? n.reduce(function (e, t) {
                                return e + t;
                            }) : n;
                        }
                        throw new RangeError('Chance: A type of die roll must be included');
                    }, l.prototype.guid = function (e) {
                        e = d(e, { version: 5 });
                        var t = 'abcdef1234567890';
                        return this.string({
                            pool: t,
                            length: 8
                        }) + '-' + this.string({
                            pool: t,
                            length: 4
                        }) + '-' + e.version + this.string({
                            pool: t,
                            length: 3
                        }) + '-' + this.string({
                            pool: 'ab89',
                            length: 1
                        }) + this.string({
                            pool: t,
                            length: 3
                        }) + '-' + this.string({
                            pool: t,
                            length: 12
                        });
                    }, l.prototype.hash = function (e) {
                        var t = 'upper' === (e = d(e, {
                            length: 40,
                            casing: 'lower'
                        })).casing ? s.toUpperCase() : s;
                        return this.string({
                            pool: t,
                            length: e.length
                        });
                    }, l.prototype.luhn_check = function (e) {
                        var t = e.toString();
                        return +t.substring(t.length - 1) === this.luhn_calculate(+t.substring(0, t.length - 1));
                    }, l.prototype.luhn_calculate = function (e) {
                        for (var t, r = e.toString().split('').reverse(), n = 0, i = 0, a = r.length; a > i; ++i)
                            t = +r[i], i % 2 == 0 && (t *= 2) > 9 && (t -= 9), n += t;
                        return 9 * n % 10;
                    }, l.prototype.md5 = function (e) {
                        var t = {
                            str: '',
                            key: null,
                            raw: !1
                        };
                        if (e)
                            if ('string' == typeof e)
                                t.str = e, e = {};
                            else {
                                if ('object' != typeof e)
                                    return null;
                                if ('Array' === e.constructor)
                                    return null;
                            }
                        else
                            t.str = this.string(), e = {};
                        if (!(t = d(e, t)).str)
                            throw new Error('A parameter is required to return an md5 hash.');
                        return this.bimd5.md5(t.str, t.key, t.raw);
                    }, l.prototype.file = function (e) {
                        var t, r = e || {}, n = 'fileExtension', i = Object.keys(this.get('fileExtension'));
                        if (t = this.word({ length: r.length }), r.extension)
                            return t + '.' + r.extension;
                        if (r.extensions) {
                            if (Array.isArray(r.extensions))
                                return t + '.' + this.pickone(r.extensions);
                            if (r.extensions.constructor === Object) {
                                var a = r.extensions, o = Object.keys(a);
                                return t + '.' + this.pickone(a[this.pickone(o)]);
                            }
                            throw new Error('Chance: Extensions must be an Array or Object');
                        }
                        if (r.fileType) {
                            var s = r.fileType;
                            if (-1 !== i.indexOf(s))
                                return t + '.' + this.pickone(this.get(n)[s]);
                            throw new RangeError('Chance: Expect file type value to be \'raster\', \'vector\', \'3d\' or \'document\'');
                        }
                        return t + '.' + this.pickone(this.get(n)[this.pickone(i)]);
                    };
                    var b = {
                            firstNames: {
                                male: {
                                    en: [
                                        'James',
                                        'John',
                                        'Robert',
                                        'Michael',
                                        'William',
                                        'David',
                                        'Richard',
                                        'Joseph',
                                        'Charles',
                                        'Thomas',
                                        'Christopher',
                                        'Daniel',
                                        'Matthew',
                                        'George',
                                        'Donald',
                                        'Anthony',
                                        'Paul',
                                        'Mark',
                                        'Edward',
                                        'Steven',
                                        'Kenneth',
                                        'Andrew',
                                        'Brian',
                                        'Joshua',
                                        'Kevin',
                                        'Ronald',
                                        'Timothy',
                                        'Jason',
                                        'Jeffrey',
                                        'Frank',
                                        'Gary',
                                        'Ryan',
                                        'Nicholas',
                                        'Eric',
                                        'Stephen',
                                        'Jacob',
                                        'Larry',
                                        'Jonathan',
                                        'Scott',
                                        'Raymond',
                                        'Justin',
                                        'Brandon',
                                        'Gregory',
                                        'Samuel',
                                        'Benjamin',
                                        'Patrick',
                                        'Jack',
                                        'Henry',
                                        'Walter',
                                        'Dennis',
                                        'Jerry',
                                        'Alexander',
                                        'Peter',
                                        'Tyler',
                                        'Douglas',
                                        'Harold',
                                        'Aaron',
                                        'Jose',
                                        'Adam',
                                        'Arthur',
                                        'Zachary',
                                        'Carl',
                                        'Nathan',
                                        'Albert',
                                        'Kyle',
                                        'Lawrence',
                                        'Joe',
                                        'Willie',
                                        'Gerald',
                                        'Roger',
                                        'Keith',
                                        'Jeremy',
                                        'Terry',
                                        'Harry',
                                        'Ralph',
                                        'Sean',
                                        'Jesse',
                                        'Roy',
                                        'Louis',
                                        'Billy',
                                        'Austin',
                                        'Bruce',
                                        'Eugene',
                                        'Christian',
                                        'Bryan',
                                        'Wayne',
                                        'Russell',
                                        'Howard',
                                        'Fred',
                                        'Ethan',
                                        'Jordan',
                                        'Philip',
                                        'Alan',
                                        'Juan',
                                        'Randy',
                                        'Vincent',
                                        'Bobby',
                                        'Dylan',
                                        'Johnny',
                                        'Phillip',
                                        'Victor',
                                        'Clarence',
                                        'Ernest',
                                        'Martin',
                                        'Craig',
                                        'Stanley',
                                        'Shawn',
                                        'Travis',
                                        'Bradley',
                                        'Leonard',
                                        'Earl',
                                        'Gabriel',
                                        'Jimmy',
                                        'Francis',
                                        'Todd',
                                        'Noah',
                                        'Danny',
                                        'Dale',
                                        'Cody',
                                        'Carlos',
                                        'Allen',
                                        'Frederick',
                                        'Logan',
                                        'Curtis',
                                        'Alex',
                                        'Joel',
                                        'Luis',
                                        'Norman',
                                        'Marvin',
                                        'Glenn',
                                        'Tony',
                                        'Nathaniel',
                                        'Rodney',
                                        'Melvin',
                                        'Alfred',
                                        'Steve',
                                        'Cameron',
                                        'Chad',
                                        'Edwin',
                                        'Caleb',
                                        'Evan',
                                        'Antonio',
                                        'Lee',
                                        'Herbert',
                                        'Jeffery',
                                        'Isaac',
                                        'Derek',
                                        'Ricky',
                                        'Marcus',
                                        'Theodore',
                                        'Elijah',
                                        'Luke',
                                        'Jesus',
                                        'Eddie',
                                        'Troy',
                                        'Mike',
                                        'Dustin',
                                        'Ray',
                                        'Adrian',
                                        'Bernard',
                                        'Leroy',
                                        'Angel',
                                        'Randall',
                                        'Wesley',
                                        'Ian',
                                        'Jared',
                                        'Mason',
                                        'Hunter',
                                        'Calvin',
                                        'Oscar',
                                        'Clifford',
                                        'Jay',
                                        'Shane',
                                        'Ronnie',
                                        'Barry',
                                        'Lucas',
                                        'Corey',
                                        'Manuel',
                                        'Leo',
                                        'Tommy',
                                        'Warren',
                                        'Jackson',
                                        'Isaiah',
                                        'Connor',
                                        'Don',
                                        'Dean',
                                        'Jon',
                                        'Julian',
                                        'Miguel',
                                        'Bill',
                                        'Lloyd',
                                        'Charlie',
                                        'Mitchell',
                                        'Leon',
                                        'Jerome',
                                        'Darrell',
                                        'Jeremiah',
                                        'Alvin',
                                        'Brett',
                                        'Seth',
                                        'Floyd',
                                        'Jim',
                                        'Blake',
                                        'Micheal',
                                        'Gordon',
                                        'Trevor',
                                        'Lewis',
                                        'Erik',
                                        'Edgar',
                                        'Vernon',
                                        'Devin',
                                        'Gavin',
                                        'Jayden',
                                        'Chris',
                                        'Clyde',
                                        'Tom',
                                        'Derrick',
                                        'Mario',
                                        'Brent',
                                        'Marc',
                                        'Herman',
                                        'Chase',
                                        'Dominic',
                                        'Ricardo',
                                        'Franklin',
                                        'Maurice',
                                        'Max',
                                        'Aiden',
                                        'Owen',
                                        'Lester',
                                        'Gilbert',
                                        'Elmer',
                                        'Gene',
                                        'Francisco',
                                        'Glen',
                                        'Cory',
                                        'Garrett',
                                        'Clayton',
                                        'Sam',
                                        'Jorge',
                                        'Chester',
                                        'Alejandro',
                                        'Jeff',
                                        'Harvey',
                                        'Milton',
                                        'Cole',
                                        'Ivan',
                                        'Andre',
                                        'Duane',
                                        'Landon'
                                    ],
                                    it: [
                                        'Adolfo',
                                        'Alberto',
                                        'Aldo',
                                        'Alessandro',
                                        'Alessio',
                                        'Alfredo',
                                        'Alvaro',
                                        'Andrea',
                                        'Angelo',
                                        'Angiolo',
                                        'Antonino',
                                        'Antonio',
                                        'Attilio',
                                        'Benito',
                                        'Bernardo',
                                        'Bruno',
                                        'Carlo',
                                        'Cesare',
                                        'Christian',
                                        'Claudio',
                                        'Corrado',
                                        'Cosimo',
                                        'Cristian',
                                        'Cristiano',
                                        'Daniele',
                                        'Dario',
                                        'David',
                                        'Davide',
                                        'Diego',
                                        'Dino',
                                        'Domenico',
                                        'Duccio',
                                        'Edoardo',
                                        'Elia',
                                        'Elio',
                                        'Emanuele',
                                        'Emiliano',
                                        'Emilio',
                                        'Enrico',
                                        'Enzo',
                                        'Ettore',
                                        'Fabio',
                                        'Fabrizio',
                                        'Federico',
                                        'Ferdinando',
                                        'Fernando',
                                        'Filippo',
                                        'Francesco',
                                        'Franco',
                                        'Gabriele',
                                        'Giacomo',
                                        'Giampaolo',
                                        'Giampiero',
                                        'Giancarlo',
                                        'Gianfranco',
                                        'Gianluca',
                                        'Gianmarco',
                                        'Gianni',
                                        'Gino',
                                        'Giorgio',
                                        'Giovanni',
                                        'Giuliano',
                                        'Giulio',
                                        'Giuseppe',
                                        'Graziano',
                                        'Gregorio',
                                        'Guido',
                                        'Iacopo',
                                        'Jacopo',
                                        'Lapo',
                                        'Leonardo',
                                        'Lorenzo',
                                        'Luca',
                                        'Luciano',
                                        'Luigi',
                                        'Manuel',
                                        'Marcello',
                                        'Marco',
                                        'Marino',
                                        'Mario',
                                        'Massimiliano',
                                        'Massimo',
                                        'Matteo',
                                        'Mattia',
                                        'Maurizio',
                                        'Mauro',
                                        'Michele',
                                        'Mirko',
                                        'Mohamed',
                                        'Nello',
                                        'Neri',
                                        'Niccolò',
                                        'Nicola',
                                        'Osvaldo',
                                        'Otello',
                                        'Paolo',
                                        'Pier Luigi',
                                        'Piero',
                                        'Pietro',
                                        'Raffaele',
                                        'Remo',
                                        'Renato',
                                        'Renzo',
                                        'Riccardo',
                                        'Roberto',
                                        'Rolando',
                                        'Romano',
                                        'Salvatore',
                                        'Samuele',
                                        'Sandro',
                                        'Sergio',
                                        'Silvano',
                                        'Simone',
                                        'Stefano',
                                        'Thomas',
                                        'Tommaso',
                                        'Ubaldo',
                                        'Ugo',
                                        'Umberto',
                                        'Valerio',
                                        'Valter',
                                        'Vasco',
                                        'Vincenzo',
                                        'Vittorio'
                                    ],
                                    nl: [
                                        'Aaron',
                                        'Abel',
                                        'Adam',
                                        'Adriaan',
                                        'Albert',
                                        'Alexander',
                                        'Ali',
                                        'Arjen',
                                        'Arno',
                                        'Bart',
                                        'Bas',
                                        'Bastiaan',
                                        'Benjamin',
                                        'Bob',
                                        'Boris',
                                        'Bram',
                                        'Brent',
                                        'Cas',
                                        'Casper',
                                        'Chris',
                                        'Christiaan',
                                        'Cornelis',
                                        'Daan',
                                        'Daley',
                                        'Damian',
                                        'Dani',
                                        'Daniel',
                                        'Daniël',
                                        'David',
                                        'Dean',
                                        'Dirk',
                                        'Dylan',
                                        'Egbert',
                                        'Elijah',
                                        'Erik',
                                        'Erwin',
                                        'Evert',
                                        'Ezra',
                                        'Fabian',
                                        'Fedde',
                                        'Finn',
                                        'Florian',
                                        'Floris',
                                        'Frank',
                                        'Frans',
                                        'Frederik',
                                        'Freek',
                                        'Geert',
                                        'Gerard',
                                        'Gerben',
                                        'Gerrit',
                                        'Gijs',
                                        'Guus',
                                        'Hans',
                                        'Hendrik',
                                        'Henk',
                                        'Herman',
                                        'Hidde',
                                        'Hugo',
                                        'Jaap',
                                        'Jan Jaap',
                                        'Jan-Willem',
                                        'Jack',
                                        'Jacob',
                                        'Jan',
                                        'Jason',
                                        'Jasper',
                                        'Jayden',
                                        'Jelle',
                                        'Jelte',
                                        'Jens',
                                        'Jeroen',
                                        'Jesse',
                                        'Jim',
                                        'Job',
                                        'Joep',
                                        'Johannes',
                                        'John',
                                        'Jonathan',
                                        'Joris',
                                        'Joshua',
                                        'Joël',
                                        'Julian',
                                        'Kees',
                                        'Kevin',
                                        'Koen',
                                        'Lars',
                                        'Laurens',
                                        'Leendert',
                                        'Lennard',
                                        'Lodewijk',
                                        'Luc',
                                        'Luca',
                                        'Lucas',
                                        'Lukas',
                                        'Luuk',
                                        'Maarten',
                                        'Marcus',
                                        'Martijn',
                                        'Martin',
                                        'Matthijs',
                                        'Maurits',
                                        'Max',
                                        'Mees',
                                        'Melle',
                                        'Mick',
                                        'Mika',
                                        'Milan',
                                        'Mohamed',
                                        'Mohammed',
                                        'Morris',
                                        'Muhammed',
                                        'Nathan',
                                        'Nick',
                                        'Nico',
                                        'Niek',
                                        'Niels',
                                        'Noah',
                                        'Noud',
                                        'Olivier',
                                        'Oscar',
                                        'Owen',
                                        'Paul',
                                        'Pepijn',
                                        'Peter',
                                        'Pieter',
                                        'Pim',
                                        'Quinten',
                                        'Reinier',
                                        'Rens',
                                        'Robin',
                                        'Ruben',
                                        'Sam',
                                        'Samuel',
                                        'Sander',
                                        'Sebastiaan',
                                        'Sem',
                                        'Sep',
                                        'Sepp',
                                        'Siem',
                                        'Simon',
                                        'Stan',
                                        'Stef',
                                        'Steven',
                                        'Stijn',
                                        'Sven',
                                        'Teun',
                                        'Thijmen',
                                        'Thijs',
                                        'Thomas',
                                        'Tijn',
                                        'Tim',
                                        'Timo',
                                        'Tobias',
                                        'Tom',
                                        'Victor',
                                        'Vince',
                                        'Willem',
                                        'Wim',
                                        'Wouter',
                                        'Yusuf'
                                    ],
                                    fr: [
                                        'Aaron',
                                        'Abdon',
                                        'Abel',
                                        'Abélard',
                                        'Abelin',
                                        'Abondance',
                                        'Abraham',
                                        'Absalon',
                                        'Acace',
                                        'Achaire',
                                        'Achille',
                                        'Adalard',
                                        'Adalbald',
                                        'Adalbéron',
                                        'Adalbert',
                                        'Adalric',
                                        'Adam',
                                        'Adegrin',
                                        'Adel',
                                        'Adelin',
                                        'Andelin',
                                        'Adelphe',
                                        'Adam',
                                        'Adéodat',
                                        'Adhémar',
                                        'Adjutor',
                                        'Adolphe',
                                        'Adonis',
                                        'Adon',
                                        'Adrien',
                                        'Agapet',
                                        'Agathange',
                                        'Agathon',
                                        'Agilbert',
                                        'Agénor',
                                        'Agnan',
                                        'Aignan',
                                        'Agrippin',
                                        'Aimable',
                                        'Aimé',
                                        'Alain',
                                        'Alban',
                                        'Albin',
                                        'Aubin',
                                        'Albéric',
                                        'Albert',
                                        'Albertet',
                                        'Alcibiade',
                                        'Alcide',
                                        'Alcée',
                                        'Alcime',
                                        'Aldonce',
                                        'Aldric',
                                        'Aldéric',
                                        'Aleaume',
                                        'Alexandre',
                                        'Alexis',
                                        'Alix',
                                        'Alliaume',
                                        'Aleaume',
                                        'Almine',
                                        'Almire',
                                        'Aloïs',
                                        'Alphée',
                                        'Alphonse',
                                        'Alpinien',
                                        'Alverède',
                                        'Amalric',
                                        'Amaury',
                                        'Amandin',
                                        'Amant',
                                        'Ambroise',
                                        'Amédée',
                                        'Amélien',
                                        'Amiel',
                                        'Amour',
                                        'Anaël',
                                        'Anastase',
                                        'Anatole',
                                        'Ancelin',
                                        'Andéol',
                                        'Andoche',
                                        'André',
                                        'Andoche',
                                        'Ange',
                                        'Angelin',
                                        'Angilbe',
                                        'Anglebert',
                                        'Angoustan',
                                        'Anicet',
                                        'Anne',
                                        'Annibal',
                                        'Ansbert',
                                        'Anselme',
                                        'Anthelme',
                                        'Antheaume',
                                        'Anthime',
                                        'Antide',
                                        'Antoine',
                                        'Antonius',
                                        'Antonin',
                                        'Apollinaire',
                                        'Apollon',
                                        'Aquilin',
                                        'Arcade',
                                        'Archambaud',
                                        'Archambeau',
                                        'Archange',
                                        'Archibald',
                                        'Arian',
                                        'Ariel',
                                        'Ariste',
                                        'Aristide',
                                        'Armand',
                                        'Armel',
                                        'Armin',
                                        'Arnould',
                                        'Arnaud',
                                        'Arolde',
                                        'Arsène',
                                        'Arsinoé',
                                        'Arthaud',
                                        'Arthème',
                                        'Arthur',
                                        'Ascelin',
                                        'Athanase',
                                        'Aubry',
                                        'Audebert',
                                        'Audouin',
                                        'Audran',
                                        'Audric',
                                        'Auguste',
                                        'Augustin',
                                        'Aurèle',
                                        'Aurélien',
                                        'Aurian',
                                        'Auxence',
                                        'Axel',
                                        'Aymard',
                                        'Aymeric',
                                        'Aymon',
                                        'Aymond',
                                        'Balthazar',
                                        'Baptiste',
                                        'Barnabé',
                                        'Barthélemy',
                                        'Bartimée',
                                        'Basile',
                                        'Bastien',
                                        'Baudouin',
                                        'Bénigne',
                                        'Benjamin',
                                        'Benoît',
                                        'Bérenger',
                                        'Bérard',
                                        'Bernard',
                                        'Bertrand',
                                        'Blaise',
                                        'Bon',
                                        'Boniface',
                                        'Bouchard',
                                        'Brice',
                                        'Brieuc',
                                        'Bruno',
                                        'Brunon',
                                        'Calixte',
                                        'Calliste',
                                        'Camélien',
                                        'Camille',
                                        'Camillien',
                                        'Candide',
                                        'Caribert',
                                        'Carloman',
                                        'Cassandre',
                                        'Cassien',
                                        'Cédric',
                                        'Céleste',
                                        'Célestin',
                                        'Célien',
                                        'Césaire',
                                        'César',
                                        'Charles',
                                        'Charlemagne',
                                        'Childebert',
                                        'Chilpéric',
                                        'Chrétien',
                                        'Christian',
                                        'Christodule',
                                        'Christophe',
                                        'Chrysostome',
                                        'Clarence',
                                        'Claude',
                                        'Claudien',
                                        'Cléandre',
                                        'Clément',
                                        'Clotaire',
                                        'Côme',
                                        'Constance',
                                        'Constant',
                                        'Constantin',
                                        'Corentin',
                                        'Cyprien',
                                        'Cyriaque',
                                        'Cyrille',
                                        'Cyril',
                                        'Damien',
                                        'Daniel',
                                        'David',
                                        'Delphin',
                                        'Denis',
                                        'Désiré',
                                        'Didier',
                                        'Dieudonné',
                                        'Dimitri',
                                        'Dominique',
                                        'Dorian',
                                        'Dorothée',
                                        'Edgard',
                                        'Edmond',
                                        'Édouard',
                                        'Éleuthère',
                                        'Élie',
                                        'Élisée',
                                        'Émeric',
                                        'Émile',
                                        'Émilien',
                                        'Emmanuel',
                                        'Enguerrand',
                                        'Épiphane',
                                        'Éric',
                                        'Esprit',
                                        'Ernest',
                                        'Étienne',
                                        'Eubert',
                                        'Eudes',
                                        'Eudoxe',
                                        'Eugène',
                                        'Eusèbe',
                                        'Eustache',
                                        'Évariste',
                                        'Évrard',
                                        'Fabien',
                                        'Fabrice',
                                        'Falba',
                                        'Félicité',
                                        'Félix',
                                        'Ferdinand',
                                        'Fiacre',
                                        'Fidèle',
                                        'Firmin',
                                        'Flavien',
                                        'Flodoard',
                                        'Florent',
                                        'Florentin',
                                        'Florestan',
                                        'Florian',
                                        'Fortuné',
                                        'Foulques',
                                        'Francisque',
                                        'François',
                                        'Français',
                                        'Franciscus',
                                        'Francs',
                                        'Frédéric',
                                        'Fulbert',
                                        'Fulcran',
                                        'Fulgence',
                                        'Gabin',
                                        'Gabriel',
                                        'Gaël',
                                        'Garnier',
                                        'Gaston',
                                        'Gaspard',
                                        'Gatien',
                                        'Gaud',
                                        'Gautier',
                                        'Gédéon',
                                        'Geoffroy',
                                        'Georges',
                                        'Géraud',
                                        'Gérard',
                                        'Gerbert',
                                        'Germain',
                                        'Gervais',
                                        'Ghislain',
                                        'Gilbert',
                                        'Gilles',
                                        'Girart',
                                        'Gislebert',
                                        'Gondebaud',
                                        'Gonthier',
                                        'Gontran',
                                        'Gonzague',
                                        'Grégoire',
                                        'Guérin',
                                        'Gui',
                                        'Guillaume',
                                        'Gustave',
                                        'Guy',
                                        'Guyot',
                                        'Hardouin',
                                        'Hector',
                                        'Hédelin',
                                        'Hélier',
                                        'Henri',
                                        'Herbert',
                                        'Herluin',
                                        'Hervé',
                                        'Hilaire',
                                        'Hildebert',
                                        'Hincmar',
                                        'Hippolyte',
                                        'Honoré',
                                        'Hubert',
                                        'Hugues',
                                        'Innocent',
                                        'Isabeau',
                                        'Isidore',
                                        'Jacques',
                                        'Japhet',
                                        'Jason',
                                        'Jean',
                                        'Jeannel',
                                        'Jeannot',
                                        'Jérémie',
                                        'Jérôme',
                                        'Joachim',
                                        'Joanny',
                                        'Job',
                                        'Jocelyn',
                                        'Joël',
                                        'Johan',
                                        'Jonas',
                                        'Jonathan',
                                        'Joseph',
                                        'Josse',
                                        'Josselin',
                                        'Jourdain',
                                        'Jude',
                                        'Judicaël',
                                        'Jules',
                                        'Julien',
                                        'Juste',
                                        'Justin',
                                        'Lambert',
                                        'Landry',
                                        'Laurent',
                                        'Lazare',
                                        'Léandre',
                                        'Léon',
                                        'Léonard',
                                        'Léopold',
                                        'Leu',
                                        'Loup',
                                        'Leufroy',
                                        'Libère',
                                        'Liétald',
                                        'Lionel',
                                        'Loïc',
                                        'Longin',
                                        'Lorrain',
                                        'Lorraine',
                                        'Lothaire',
                                        'Louis',
                                        'Loup',
                                        'Luc',
                                        'Lucas',
                                        'Lucien',
                                        'Ludolphe',
                                        'Ludovic',
                                        'Macaire',
                                        'Malo',
                                        'Mamert',
                                        'Manassé',
                                        'Marc',
                                        'Marceau',
                                        'Marcel',
                                        'Marcelin',
                                        'Marius',
                                        'Marseille',
                                        'Martial',
                                        'Martin',
                                        'Mathurin',
                                        'Matthias',
                                        'Mathias',
                                        'Matthieu',
                                        'Maugis',
                                        'Maurice',
                                        'Mauricet',
                                        'Maxence',
                                        'Maxime',
                                        'Maximilien',
                                        'Mayeul',
                                        'Médéric',
                                        'Melchior',
                                        'Mence',
                                        'Merlin',
                                        'Mérovée',
                                        'Michaël',
                                        'Michel',
                                        'Moïse',
                                        'Morgan',
                                        'Nathan',
                                        'Nathanaël',
                                        'Narcisse',
                                        'Néhémie',
                                        'Nestor',
                                        'Nestor',
                                        'Nicéphore',
                                        'Nicolas',
                                        'Noé',
                                        'Noël',
                                        'Norbert',
                                        'Normand',
                                        'Normands',
                                        'Octave',
                                        'Odilon',
                                        'Odon',
                                        'Oger',
                                        'Olivier',
                                        'Oury',
                                        'Pacôme',
                                        'Palémon',
                                        'Parfait',
                                        'Pascal',
                                        'Paterne',
                                        'Patrice',
                                        'Paul',
                                        'Pépin',
                                        'Perceval',
                                        'Philémon',
                                        'Philibert',
                                        'Philippe',
                                        'Philothée',
                                        'Pie',
                                        'Pierre',
                                        'Pierrick',
                                        'Prosper',
                                        'Quentin',
                                        'Raoul',
                                        'Raphaël',
                                        'Raymond',
                                        'Régis',
                                        'Réjean',
                                        'Rémi',
                                        'Renaud',
                                        'René',
                                        'Reybaud',
                                        'Richard',
                                        'Robert',
                                        'Roch',
                                        'Rodolphe',
                                        'Rodrigue',
                                        'Roger',
                                        'Roland',
                                        'Romain',
                                        'Romuald',
                                        'Roméo',
                                        'Rome',
                                        'Ronan',
                                        'Roselin',
                                        'Salomon',
                                        'Samuel',
                                        'Savin',
                                        'Savinien',
                                        'Scholastique',
                                        'Sébastien',
                                        'Séraphin',
                                        'Serge',
                                        'Séverin',
                                        'Sidoine',
                                        'Sigebert',
                                        'Sigismond',
                                        'Silvère',
                                        'Simon',
                                        'Siméon',
                                        'Sixte',
                                        'Stanislas',
                                        'Stéphane',
                                        'Stephan',
                                        'Sylvain',
                                        'Sylvestre',
                                        'Tancrède',
                                        'Tanguy',
                                        'Taurin',
                                        'Théodore',
                                        'Théodose',
                                        'Théophile',
                                        'Théophraste',
                                        'Thibault',
                                        'Thibert',
                                        'Thierry',
                                        'Thomas',
                                        'Timoléon',
                                        'Timothée',
                                        'Titien',
                                        'Tonnin',
                                        'Toussaint',
                                        'Trajan',
                                        'Tristan',
                                        'Turold',
                                        'Tim',
                                        'Ulysse',
                                        'Urbain',
                                        'Valentin',
                                        'Valère',
                                        'Valéry',
                                        'Venance',
                                        'Venant',
                                        'Venceslas',
                                        'Vianney',
                                        'Victor',
                                        'Victorien',
                                        'Victorin',
                                        'Vigile',
                                        'Vincent',
                                        'Vital',
                                        'Vitalien',
                                        'Vivien',
                                        'Waleran',
                                        'Wandrille',
                                        'Xavier',
                                        'Xénophon',
                                        'Yves',
                                        'Zacharie',
                                        'Zaché',
                                        'Zéphirin'
                                    ]
                                },
                                female: {
                                    en: [
                                        'Mary',
                                        'Emma',
                                        'Elizabeth',
                                        'Minnie',
                                        'Margaret',
                                        'Ida',
                                        'Alice',
                                        'Bertha',
                                        'Sarah',
                                        'Annie',
                                        'Clara',
                                        'Ella',
                                        'Florence',
                                        'Cora',
                                        'Martha',
                                        'Laura',
                                        'Nellie',
                                        'Grace',
                                        'Carrie',
                                        'Maude',
                                        'Mabel',
                                        'Bessie',
                                        'Jennie',
                                        'Gertrude',
                                        'Julia',
                                        'Hattie',
                                        'Edith',
                                        'Mattie',
                                        'Rose',
                                        'Catherine',
                                        'Lillian',
                                        'Ada',
                                        'Lillie',
                                        'Helen',
                                        'Jessie',
                                        'Louise',
                                        'Ethel',
                                        'Lula',
                                        'Myrtle',
                                        'Eva',
                                        'Frances',
                                        'Lena',
                                        'Lucy',
                                        'Edna',
                                        'Maggie',
                                        'Pearl',
                                        'Daisy',
                                        'Fannie',
                                        'Josephine',
                                        'Dora',
                                        'Rosa',
                                        'Katherine',
                                        'Agnes',
                                        'Marie',
                                        'Nora',
                                        'May',
                                        'Mamie',
                                        'Blanche',
                                        'Stella',
                                        'Ellen',
                                        'Nancy',
                                        'Effie',
                                        'Sallie',
                                        'Nettie',
                                        'Della',
                                        'Lizzie',
                                        'Flora',
                                        'Susie',
                                        'Maud',
                                        'Mae',
                                        'Etta',
                                        'Harriet',
                                        'Sadie',
                                        'Caroline',
                                        'Katie',
                                        'Lydia',
                                        'Elsie',
                                        'Kate',
                                        'Susan',
                                        'Mollie',
                                        'Alma',
                                        'Addie',
                                        'Georgia',
                                        'Eliza',
                                        'Lulu',
                                        'Nannie',
                                        'Lottie',
                                        'Amanda',
                                        'Belle',
                                        'Charlotte',
                                        'Rebecca',
                                        'Ruth',
                                        'Viola',
                                        'Olive',
                                        'Amelia',
                                        'Hannah',
                                        'Jane',
                                        'Virginia',
                                        'Emily',
                                        'Matilda',
                                        'Irene',
                                        'Kathryn',
                                        'Esther',
                                        'Willie',
                                        'Henrietta',
                                        'Ollie',
                                        'Amy',
                                        'Rachel',
                                        'Sara',
                                        'Estella',
                                        'Theresa',
                                        'Augusta',
                                        'Ora',
                                        'Pauline',
                                        'Josie',
                                        'Lola',
                                        'Sophia',
                                        'Leona',
                                        'Anne',
                                        'Mildred',
                                        'Ann',
                                        'Beulah',
                                        'Callie',
                                        'Lou',
                                        'Delia',
                                        'Eleanor',
                                        'Barbara',
                                        'Iva',
                                        'Louisa',
                                        'Maria',
                                        'Mayme',
                                        'Evelyn',
                                        'Estelle',
                                        'Nina',
                                        'Betty',
                                        'Marion',
                                        'Bettie',
                                        'Dorothy',
                                        'Luella',
                                        'Inez',
                                        'Lela',
                                        'Rosie',
                                        'Allie',
                                        'Millie',
                                        'Janie',
                                        'Cornelia',
                                        'Victoria',
                                        'Ruby',
                                        'Winifred',
                                        'Alta',
                                        'Celia',
                                        'Christine',
                                        'Beatrice',
                                        'Birdie',
                                        'Harriett',
                                        'Mable',
                                        'Myra',
                                        'Sophie',
                                        'Tillie',
                                        'Isabel',
                                        'Sylvia',
                                        'Carolyn',
                                        'Isabelle',
                                        'Leila',
                                        'Sally',
                                        'Ina',
                                        'Essie',
                                        'Bertie',
                                        'Nell',
                                        'Alberta',
                                        'Katharine',
                                        'Lora',
                                        'Rena',
                                        'Mina',
                                        'Rhoda',
                                        'Mathilda',
                                        'Abbie',
                                        'Eula',
                                        'Dollie',
                                        'Hettie',
                                        'Eunice',
                                        'Fanny',
                                        'Ola',
                                        'Lenora',
                                        'Adelaide',
                                        'Christina',
                                        'Lelia',
                                        'Nelle',
                                        'Sue',
                                        'Johanna',
                                        'Lilly',
                                        'Lucinda',
                                        'Minerva',
                                        'Lettie',
                                        'Roxie',
                                        'Cynthia',
                                        'Helena',
                                        'Hilda',
                                        'Hulda',
                                        'Bernice',
                                        'Genevieve',
                                        'Jean',
                                        'Cordelia',
                                        'Marian',
                                        'Francis',
                                        'Jeanette',
                                        'Adeline',
                                        'Gussie',
                                        'Leah',
                                        'Lois',
                                        'Lura',
                                        'Mittie',
                                        'Hallie',
                                        'Isabella',
                                        'Olga',
                                        'Phoebe',
                                        'Teresa',
                                        'Hester',
                                        'Lida',
                                        'Lina',
                                        'Winnie',
                                        'Claudia',
                                        'Marguerite',
                                        'Vera',
                                        'Cecelia',
                                        'Bess',
                                        'Emilie',
                                        'Rosetta',
                                        'Verna',
                                        'Myrtie',
                                        'Cecilia',
                                        'Elva',
                                        'Olivia',
                                        'Ophelia',
                                        'Georgie',
                                        'Elnora',
                                        'Violet',
                                        'Adele',
                                        'Lily',
                                        'Linnie',
                                        'Loretta',
                                        'Madge',
                                        'Polly',
                                        'Virgie',
                                        'Eugenia',
                                        'Lucile',
                                        'Lucille',
                                        'Mabelle',
                                        'Rosalie'
                                    ],
                                    it: [
                                        'Ada',
                                        'Adriana',
                                        'Alessandra',
                                        'Alessia',
                                        'Alice',
                                        'Angela',
                                        'Anna',
                                        'Anna Maria',
                                        'Annalisa',
                                        'Annita',
                                        'Annunziata',
                                        'Antonella',
                                        'Arianna',
                                        'Asia',
                                        'Assunta',
                                        'Aurora',
                                        'Barbara',
                                        'Beatrice',
                                        'Benedetta',
                                        'Bianca',
                                        'Bruna',
                                        'Camilla',
                                        'Carla',
                                        'Carlotta',
                                        'Carmela',
                                        'Carolina',
                                        'Caterina',
                                        'Catia',
                                        'Cecilia',
                                        'Chiara',
                                        'Cinzia',
                                        'Clara',
                                        'Claudia',
                                        'Costanza',
                                        'Cristina',
                                        'Daniela',
                                        'Debora',
                                        'Diletta',
                                        'Dina',
                                        'Donatella',
                                        'Elena',
                                        'Eleonora',
                                        'Elisa',
                                        'Elisabetta',
                                        'Emanuela',
                                        'Emma',
                                        'Eva',
                                        'Federica',
                                        'Fernanda',
                                        'Fiorella',
                                        'Fiorenza',
                                        'Flora',
                                        'Franca',
                                        'Francesca',
                                        'Gabriella',
                                        'Gaia',
                                        'Gemma',
                                        'Giada',
                                        'Gianna',
                                        'Gina',
                                        'Ginevra',
                                        'Giorgia',
                                        'Giovanna',
                                        'Giulia',
                                        'Giuliana',
                                        'Giuseppa',
                                        'Giuseppina',
                                        'Grazia',
                                        'Graziella',
                                        'Greta',
                                        'Ida',
                                        'Ilaria',
                                        'Ines',
                                        'Iolanda',
                                        'Irene',
                                        'Irma',
                                        'Isabella',
                                        'Jessica',
                                        'Laura',
                                        'Lea',
                                        'Letizia',
                                        'Licia',
                                        'Lidia',
                                        'Liliana',
                                        'Lina',
                                        'Linda',
                                        'Lisa',
                                        'Livia',
                                        'Loretta',
                                        'Luana',
                                        'Lucia',
                                        'Luciana',
                                        'Lucrezia',
                                        'Luisa',
                                        'Manuela',
                                        'Mara',
                                        'Marcella',
                                        'Margherita',
                                        'Maria',
                                        'Maria Cristina',
                                        'Maria Grazia',
                                        'Maria Luisa',
                                        'Maria Pia',
                                        'Maria Teresa',
                                        'Marina',
                                        'Marisa',
                                        'Marta',
                                        'Martina',
                                        'Marzia',
                                        'Matilde',
                                        'Melissa',
                                        'Michela',
                                        'Milena',
                                        'Mirella',
                                        'Monica',
                                        'Natalina',
                                        'Nella',
                                        'Nicoletta',
                                        'Noemi',
                                        'Olga',
                                        'Paola',
                                        'Patrizia',
                                        'Piera',
                                        'Pierina',
                                        'Raffaella',
                                        'Rebecca',
                                        'Renata',
                                        'Rina',
                                        'Rita',
                                        'Roberta',
                                        'Rosa',
                                        'Rosanna',
                                        'Rossana',
                                        'Rossella',
                                        'Sabrina',
                                        'Sandra',
                                        'Sara',
                                        'Serena',
                                        'Silvana',
                                        'Silvia',
                                        'Simona',
                                        'Simonetta',
                                        'Sofia',
                                        'Sonia',
                                        'Stefania',
                                        'Susanna',
                                        'Teresa',
                                        'Tina',
                                        'Tiziana',
                                        'Tosca',
                                        'Valentina',
                                        'Valeria',
                                        'Vanda',
                                        'Vanessa',
                                        'Vanna',
                                        'Vera',
                                        'Veronica',
                                        'Vilma',
                                        'Viola',
                                        'Virginia',
                                        'Vittoria'
                                    ],
                                    nl: [
                                        'Ada',
                                        'Arianne',
                                        'Afke',
                                        'Amanda',
                                        'Amber',
                                        'Amy',
                                        'Aniek',
                                        'Anita',
                                        'Anja',
                                        'Anna',
                                        'Anne',
                                        'Annelies',
                                        'Annemarie',
                                        'Annette',
                                        'Anouk',
                                        'Astrid',
                                        'Aukje',
                                        'Barbara',
                                        'Bianca',
                                        'Carla',
                                        'Carlijn',
                                        'Carolien',
                                        'Chantal',
                                        'Charlotte',
                                        'Claudia',
                                        'Daniëlle',
                                        'Debora',
                                        'Diane',
                                        'Dora',
                                        'Eline',
                                        'Elise',
                                        'Ella',
                                        'Ellen',
                                        'Emma',
                                        'Esmee',
                                        'Evelien',
                                        'Esther',
                                        'Erica',
                                        'Eva',
                                        'Femke',
                                        'Fleur',
                                        'Floor',
                                        'Froukje',
                                        'Gea',
                                        'Gerda',
                                        'Hanna',
                                        'Hanneke',
                                        'Heleen',
                                        'Hilde',
                                        'Ilona',
                                        'Ina',
                                        'Inge',
                                        'Ingrid',
                                        'Iris',
                                        'Isabel',
                                        'Isabelle',
                                        'Janneke',
                                        'Jasmijn',
                                        'Jeanine',
                                        'Jennifer',
                                        'Jessica',
                                        'Johanna',
                                        'Joke',
                                        'Julia',
                                        'Julie',
                                        'Karen',
                                        'Karin',
                                        'Katja',
                                        'Kim',
                                        'Lara',
                                        'Laura',
                                        'Lena',
                                        'Lianne',
                                        'Lieke',
                                        'Lilian',
                                        'Linda',
                                        'Lisa',
                                        'Lisanne',
                                        'Lotte',
                                        'Louise',
                                        'Maaike',
                                        'Manon',
                                        'Marga',
                                        'Maria',
                                        'Marissa',
                                        'Marit',
                                        'Marjolein',
                                        'Martine',
                                        'Marleen',
                                        'Melissa',
                                        'Merel',
                                        'Miranda',
                                        'Michelle',
                                        'Mirjam',
                                        'Mirthe',
                                        'Naomi',
                                        'Natalie',
                                        'Nienke',
                                        'Nina',
                                        'Noortje',
                                        'Olivia',
                                        'Patricia',
                                        'Paula',
                                        'Paulien',
                                        'Ramona',
                                        'Ria',
                                        'Rianne',
                                        'Roos',
                                        'Rosanne',
                                        'Ruth',
                                        'Sabrina',
                                        'Sandra',
                                        'Sanne',
                                        'Sara',
                                        'Saskia',
                                        'Silvia',
                                        'Sofia',
                                        'Sophie',
                                        'Sonja',
                                        'Suzanne',
                                        'Tamara',
                                        'Tess',
                                        'Tessa',
                                        'Tineke',
                                        'Valerie',
                                        'Vanessa',
                                        'Veerle',
                                        'Vera',
                                        'Victoria',
                                        'Wendy',
                                        'Willeke',
                                        'Yvonne',
                                        'Zoë'
                                    ],
                                    fr: [
                                        'Abdon',
                                        'Abel',
                                        'Abigaëlle',
                                        'Abigaïl',
                                        'Acacius',
                                        'Acanthe',
                                        'Adalbert',
                                        'Adalsinde',
                                        'Adegrine',
                                        'Adélaïde',
                                        'Adèle',
                                        'Adélie',
                                        'Adeline',
                                        'Adeltrude',
                                        'Adolphe',
                                        'Adonis',
                                        'Adrastée',
                                        'Adrehilde',
                                        'Adrienne',
                                        'Agathe',
                                        'Agilbert',
                                        'Aglaé',
                                        'Aignan',
                                        'Agneflète',
                                        'Agnès',
                                        'Agrippine',
                                        'Aimé',
                                        'Alaine',
                                        'Alaïs',
                                        'Albane',
                                        'Albérade',
                                        'Alberte',
                                        'Alcide',
                                        'Alcine',
                                        'Alcyone',
                                        'Aldegonde',
                                        'Aleth',
                                        'Alexandrine',
                                        'Alexine',
                                        'Alice',
                                        'Aliénor',
                                        'Aliette',
                                        'Aline',
                                        'Alix',
                                        'Alizé',
                                        'Aloïse',
                                        'Aloyse',
                                        'Alphonsine',
                                        'Althée',
                                        'Amaliane',
                                        'Amalthée',
                                        'Amande',
                                        'Amandine',
                                        'Amant',
                                        'Amarande',
                                        'Amaranthe',
                                        'Amaryllis',
                                        'Ambre',
                                        'Ambroisie',
                                        'Amélie',
                                        'Améthyste',
                                        'Aminte',
                                        'Anaël',
                                        'Anaïs',
                                        'Anastasie',
                                        'Anatole',
                                        'Ancelin',
                                        'Andrée',
                                        'Anémone',
                                        'Angadrême',
                                        'Angèle',
                                        'Angeline',
                                        'Angélique',
                                        'Angilbert',
                                        'Anicet',
                                        'Annabelle',
                                        'Anne',
                                        'Annette',
                                        'Annick',
                                        'Annie',
                                        'Annonciade',
                                        'Ansbert',
                                        'Anstrudie',
                                        'Anthelme',
                                        'Antigone',
                                        'Antoinette',
                                        'Antonine',
                                        'Aphélie',
                                        'Apolline',
                                        'Apollonie',
                                        'Aquiline',
                                        'Arabelle',
                                        'Arcadie',
                                        'Archange',
                                        'Argine',
                                        'Ariane',
                                        'Aricie',
                                        'Ariel',
                                        'Arielle',
                                        'Arlette',
                                        'Armance',
                                        'Armande',
                                        'Armandine',
                                        'Armelle',
                                        'Armide',
                                        'Armelle',
                                        'Armin',
                                        'Arnaud',
                                        'Arsène',
                                        'Arsinoé',
                                        'Artémis',
                                        'Arthur',
                                        'Ascelin',
                                        'Ascension',
                                        'Assomption',
                                        'Astarté',
                                        'Astérie',
                                        'Astrée',
                                        'Astrid',
                                        'Athalie',
                                        'Athanasie',
                                        'Athina',
                                        'Aube',
                                        'Albert',
                                        'Aude',
                                        'Audrey',
                                        'Augustine',
                                        'Aure',
                                        'Aurélie',
                                        'Aurélien',
                                        'Aurèle',
                                        'Aurore',
                                        'Auxence',
                                        'Aveline',
                                        'Abigaëlle',
                                        'Avoye',
                                        'Axelle',
                                        'Aymard',
                                        'Azalée',
                                        'Adèle',
                                        'Adeline',
                                        'Barbe',
                                        'Basilisse',
                                        'Bathilde',
                                        'Béatrice',
                                        'Béatrix',
                                        'Bénédicte',
                                        'Bérengère',
                                        'Bernadette',
                                        'Berthe',
                                        'Bertille',
                                        'Beuve',
                                        'Blanche',
                                        'Blanc',
                                        'Blandine',
                                        'Brigitte',
                                        'Brune',
                                        'Brunehilde',
                                        'Callista',
                                        'Camille',
                                        'Capucine',
                                        'Carine',
                                        'Caroline',
                                        'Cassandre',
                                        'Catherine',
                                        'Cécile',
                                        'Céleste',
                                        'Célestine',
                                        'Céline',
                                        'Chantal',
                                        'Charlène',
                                        'Charline',
                                        'Charlotte',
                                        'Chloé',
                                        'Christelle',
                                        'Christiane',
                                        'Christine',
                                        'Claire',
                                        'Clara',
                                        'Claude',
                                        'Claudine',
                                        'Clarisse',
                                        'Clémence',
                                        'Clémentine',
                                        'Cléo',
                                        'Clio',
                                        'Clotilde',
                                        'Coline',
                                        'Conception',
                                        'Constance',
                                        'Coralie',
                                        'Coraline',
                                        'Corentine',
                                        'Corinne',
                                        'Cyrielle',
                                        'Daniel',
                                        'Daniel',
                                        'Daphné',
                                        'Débora',
                                        'Delphine',
                                        'Denise',
                                        'Diane',
                                        'Dieudonné',
                                        'Dominique',
                                        'Doriane',
                                        'Dorothée',
                                        'Douce',
                                        'Édith',
                                        'Edmée',
                                        'Éléonore',
                                        'Éliane',
                                        'Élia',
                                        'Éliette',
                                        'Élisabeth',
                                        'Élise',
                                        'Ella',
                                        'Élodie',
                                        'Éloïse',
                                        'Elsa',
                                        'Émeline',
                                        'Émérance',
                                        'Émérentienne',
                                        'Émérencie',
                                        'Émilie',
                                        'Emma',
                                        'Emmanuelle',
                                        'Emmelie',
                                        'Ernestine',
                                        'Esther',
                                        'Estelle',
                                        'Eudoxie',
                                        'Eugénie',
                                        'Eulalie',
                                        'Euphrasie',
                                        'Eusébie',
                                        'Évangéline',
                                        'Eva',
                                        'Ève',
                                        'Évelyne',
                                        'Fanny',
                                        'Fantine',
                                        'Faustine',
                                        'Félicie',
                                        'Fernande',
                                        'Flavie',
                                        'Fleur',
                                        'Flore',
                                        'Florence',
                                        'Florie',
                                        'Fortuné',
                                        'France',
                                        'Francia',
                                        'Françoise',
                                        'Francine',
                                        'Gabrielle',
                                        'Gaëlle',
                                        'Garance',
                                        'Geneviève',
                                        'Georgette',
                                        'Gerberge',
                                        'Germaine',
                                        'Gertrude',
                                        'Gisèle',
                                        'Guenièvre',
                                        'Guilhemine',
                                        'Guillemette',
                                        'Gustave',
                                        'Gwenael',
                                        'Hélène',
                                        'Héloïse',
                                        'Henriette',
                                        'Hermine',
                                        'Hermione',
                                        'Hippolyte',
                                        'Honorine',
                                        'Hortense',
                                        'Huguette',
                                        'Ines',
                                        'Irène',
                                        'Irina',
                                        'Iris',
                                        'Isabeau',
                                        'Isabelle',
                                        'Iseult',
                                        'Isolde',
                                        'Ismérie',
                                        'Jacinthe',
                                        'Jacqueline',
                                        'Jade',
                                        'Janine',
                                        'Jeanne',
                                        'Jocelyne',
                                        'Joëlle',
                                        'Joséphine',
                                        'Judith',
                                        'Julia',
                                        'Julie',
                                        'Jules',
                                        'Juliette',
                                        'Justine',
                                        'Katy',
                                        'Kathy',
                                        'Katie',
                                        'Laura',
                                        'Laure',
                                        'Laureline',
                                        'Laurence',
                                        'Laurene',
                                        'Lauriane',
                                        'Laurianne',
                                        'Laurine',
                                        'Léa',
                                        'Léna',
                                        'Léonie',
                                        'Léon',
                                        'Léontine',
                                        'Lorraine',
                                        'Lucie',
                                        'Lucienne',
                                        'Lucille',
                                        'Ludivine',
                                        'Lydie',
                                        'Lydie',
                                        'Megane',
                                        'Madeleine',
                                        'Magali',
                                        'Maguelone',
                                        'Mallaury',
                                        'Manon',
                                        'Marceline',
                                        'Margot',
                                        'Marguerite',
                                        'Marianne',
                                        'Marie',
                                        'Myriam',
                                        'Marie',
                                        'Marine',
                                        'Marion',
                                        'Marlène',
                                        'Marthe',
                                        'Martine',
                                        'Mathilde',
                                        'Maud',
                                        'Maureen',
                                        'Mauricette',
                                        'Maxime',
                                        'Mélanie',
                                        'Melissa',
                                        'Mélissandre',
                                        'Mélisande',
                                        'Mélodie',
                                        'Michel',
                                        'Micheline',
                                        'Mireille',
                                        'Miriam',
                                        'Moïse',
                                        'Monique',
                                        'Morgane',
                                        'Muriel',
                                        'Mylène',
                                        'Nadège',
                                        'Nadine',
                                        'Nathalie',
                                        'Nicole',
                                        'Nicolette',
                                        'Nine',
                                        'Noël',
                                        'Noémie',
                                        'Océane',
                                        'Odette',
                                        'Odile',
                                        'Olive',
                                        'Olivia',
                                        'Olympe',
                                        'Ombline',
                                        'Ombeline',
                                        'Ophélie',
                                        'Oriande',
                                        'Oriane',
                                        'Ozanne',
                                        'Pascale',
                                        'Pascaline',
                                        'Paule',
                                        'Paulette',
                                        'Pauline',
                                        'Priscille',
                                        'Prisca',
                                        'Prisque',
                                        'Pécine',
                                        'Pélagie',
                                        'Pénélope',
                                        'Perrine',
                                        'Pétronille',
                                        'Philippine',
                                        'Philomène',
                                        'Philothée',
                                        'Primerose',
                                        'Prudence',
                                        'Pulchérie',
                                        'Quentine',
                                        'Quiéta',
                                        'Quintia',
                                        'Quintilla',
                                        'Rachel',
                                        'Raphaëlle',
                                        'Raymonde',
                                        'Rebecca',
                                        'Régine',
                                        'Réjeanne',
                                        'René',
                                        'Rita',
                                        'Rita',
                                        'Rolande',
                                        'Romane',
                                        'Rosalie',
                                        'Rose',
                                        'Roseline',
                                        'Sabine',
                                        'Salomé',
                                        'Sandra',
                                        'Sandrine',
                                        'Sarah',
                                        'Ségolène',
                                        'Séverine',
                                        'Sibylle',
                                        'Simone',
                                        'Sixt',
                                        'Solange',
                                        'Soline',
                                        'Solène',
                                        'Sophie',
                                        'Stéphanie',
                                        'Suzanne',
                                        'Sylvain',
                                        'Sylvie',
                                        'Tatiana',
                                        'Thaïs',
                                        'Théodora',
                                        'Thérèse',
                                        'Tiphaine',
                                        'Ursule',
                                        'Valentine',
                                        'Valérie',
                                        'Véronique',
                                        'Victoire',
                                        'Victorine',
                                        'Vinciane',
                                        'Violette',
                                        'Virginie',
                                        'Viviane',
                                        'Xavière',
                                        'Yolande',
                                        'Ysaline',
                                        'Yvette',
                                        'Yvonne',
                                        'Zélie',
                                        'Zita',
                                        'Zoé'
                                    ]
                                }
                            },
                            lastNames: {
                                en: [
                                    'Smith',
                                    'Johnson',
                                    'Williams',
                                    'Jones',
                                    'Brown',
                                    'Davis',
                                    'Miller',
                                    'Wilson',
                                    'Moore',
                                    'Taylor',
                                    'Anderson',
                                    'Thomas',
                                    'Jackson',
                                    'White',
                                    'Harris',
                                    'Martin',
                                    'Thompson',
                                    'Garcia',
                                    'Martinez',
                                    'Robinson',
                                    'Clark',
                                    'Rodriguez',
                                    'Lewis',
                                    'Lee',
                                    'Walker',
                                    'Hall',
                                    'Allen',
                                    'Young',
                                    'Hernandez',
                                    'King',
                                    'Wright',
                                    'Lopez',
                                    'Hill',
                                    'Scott',
                                    'Green',
                                    'Adams',
                                    'Baker',
                                    'Gonzalez',
                                    'Nelson',
                                    'Carter',
                                    'Mitchell',
                                    'Perez',
                                    'Roberts',
                                    'Turner',
                                    'Phillips',
                                    'Campbell',
                                    'Parker',
                                    'Evans',
                                    'Edwards',
                                    'Collins',
                                    'Stewart',
                                    'Sanchez',
                                    'Morris',
                                    'Rogers',
                                    'Reed',
                                    'Cook',
                                    'Morgan',
                                    'Bell',
                                    'Murphy',
                                    'Bailey',
                                    'Rivera',
                                    'Cooper',
                                    'Richardson',
                                    'Cox',
                                    'Howard',
                                    'Ward',
                                    'Torres',
                                    'Peterson',
                                    'Gray',
                                    'Ramirez',
                                    'James',
                                    'Watson',
                                    'Brooks',
                                    'Kelly',
                                    'Sanders',
                                    'Price',
                                    'Bennett',
                                    'Wood',
                                    'Barnes',
                                    'Ross',
                                    'Henderson',
                                    'Coleman',
                                    'Jenkins',
                                    'Perry',
                                    'Powell',
                                    'Long',
                                    'Patterson',
                                    'Hughes',
                                    'Flores',
                                    'Washington',
                                    'Butler',
                                    'Simmons',
                                    'Foster',
                                    'Gonzales',
                                    'Bryant',
                                    'Alexander',
                                    'Russell',
                                    'Griffin',
                                    'Diaz',
                                    'Hayes',
                                    'Myers',
                                    'Ford',
                                    'Hamilton',
                                    'Graham',
                                    'Sullivan',
                                    'Wallace',
                                    'Woods',
                                    'Cole',
                                    'West',
                                    'Jordan',
                                    'Owens',
                                    'Reynolds',
                                    'Fisher',
                                    'Ellis',
                                    'Harrison',
                                    'Gibson',
                                    'McDonald',
                                    'Cruz',
                                    'Marshall',
                                    'Ortiz',
                                    'Gomez',
                                    'Murray',
                                    'Freeman',
                                    'Wells',
                                    'Webb',
                                    'Simpson',
                                    'Stevens',
                                    'Tucker',
                                    'Porter',
                                    'Hunter',
                                    'Hicks',
                                    'Crawford',
                                    'Henry',
                                    'Boyd',
                                    'Mason',
                                    'Morales',
                                    'Kennedy',
                                    'Warren',
                                    'Dixon',
                                    'Ramos',
                                    'Reyes',
                                    'Burns',
                                    'Gordon',
                                    'Shaw',
                                    'Holmes',
                                    'Rice',
                                    'Robertson',
                                    'Hunt',
                                    'Black',
                                    'Daniels',
                                    'Palmer',
                                    'Mills',
                                    'Nichols',
                                    'Grant',
                                    'Knight',
                                    'Ferguson',
                                    'Rose',
                                    'Stone',
                                    'Hawkins',
                                    'Dunn',
                                    'Perkins',
                                    'Hudson',
                                    'Spencer',
                                    'Gardner',
                                    'Stephens',
                                    'Payne',
                                    'Pierce',
                                    'Berry',
                                    'Matthews',
                                    'Arnold',
                                    'Wagner',
                                    'Willis',
                                    'Ray',
                                    'Watkins',
                                    'Olson',
                                    'Carroll',
                                    'Duncan',
                                    'Snyder',
                                    'Hart',
                                    'Cunningham',
                                    'Bradley',
                                    'Lane',
                                    'Andrews',
                                    'Ruiz',
                                    'Harper',
                                    'Fox',
                                    'Riley',
                                    'Armstrong',
                                    'Carpenter',
                                    'Weaver',
                                    'Greene',
                                    'Lawrence',
                                    'Elliott',
                                    'Chavez',
                                    'Sims',
                                    'Austin',
                                    'Peters',
                                    'Kelley',
                                    'Franklin',
                                    'Lawson',
                                    'Fields',
                                    'Gutierrez',
                                    'Ryan',
                                    'Schmidt',
                                    'Carr',
                                    'Vasquez',
                                    'Castillo',
                                    'Wheeler',
                                    'Chapman',
                                    'Oliver',
                                    'Montgomery',
                                    'Richards',
                                    'Williamson',
                                    'Johnston',
                                    'Banks',
                                    'Meyer',
                                    'Bishop',
                                    'McCoy',
                                    'Howell',
                                    'Alvarez',
                                    'Morrison',
                                    'Hansen',
                                    'Fernandez',
                                    'Garza',
                                    'Harvey',
                                    'Little',
                                    'Burton',
                                    'Stanley',
                                    'Nguyen',
                                    'George',
                                    'Jacobs',
                                    'Reid',
                                    'Kim',
                                    'Fuller',
                                    'Lynch',
                                    'Dean',
                                    'Gilbert',
                                    'Garrett',
                                    'Romero',
                                    'Welch',
                                    'Larson',
                                    'Frazier',
                                    'Burke',
                                    'Hanson',
                                    'Day',
                                    'Mendoza',
                                    'Moreno',
                                    'Bowman',
                                    'Medina',
                                    'Fowler',
                                    'Brewer',
                                    'Hoffman',
                                    'Carlson',
                                    'Silva',
                                    'Pearson',
                                    'Holland',
                                    'Douglas',
                                    'Fleming',
                                    'Jensen',
                                    'Vargas',
                                    'Byrd',
                                    'Davidson',
                                    'Hopkins',
                                    'May',
                                    'Terry',
                                    'Herrera',
                                    'Wade',
                                    'Soto',
                                    'Walters',
                                    'Curtis',
                                    'Neal',
                                    'Caldwell',
                                    'Lowe',
                                    'Jennings',
                                    'Barnett',
                                    'Graves',
                                    'Jimenez',
                                    'Horton',
                                    'Shelton',
                                    'Barrett',
                                    'Obrien',
                                    'Castro',
                                    'Sutton',
                                    'Gregory',
                                    'McKinney',
                                    'Lucas',
                                    'Miles',
                                    'Craig',
                                    'Rodriquez',
                                    'Chambers',
                                    'Holt',
                                    'Lambert',
                                    'Fletcher',
                                    'Watts',
                                    'Bates',
                                    'Hale',
                                    'Rhodes',
                                    'Pena',
                                    'Beck',
                                    'Newman',
                                    'Haynes',
                                    'McDaniel',
                                    'Mendez',
                                    'Bush',
                                    'Vaughn',
                                    'Parks',
                                    'Dawson',
                                    'Santiago',
                                    'Norris',
                                    'Hardy',
                                    'Love',
                                    'Steele',
                                    'Curry',
                                    'Powers',
                                    'Schultz',
                                    'Barker',
                                    'Guzman',
                                    'Page',
                                    'Munoz',
                                    'Ball',
                                    'Keller',
                                    'Chandler',
                                    'Weber',
                                    'Leonard',
                                    'Walsh',
                                    'Lyons',
                                    'Ramsey',
                                    'Wolfe',
                                    'Schneider',
                                    'Mullins',
                                    'Benson',
                                    'Sharp',
                                    'Bowen',
                                    'Daniel',
                                    'Barber',
                                    'Cummings',
                                    'Hines',
                                    'Baldwin',
                                    'Griffith',
                                    'Valdez',
                                    'Hubbard',
                                    'Salazar',
                                    'Reeves',
                                    'Warner',
                                    'Stevenson',
                                    'Burgess',
                                    'Santos',
                                    'Tate',
                                    'Cross',
                                    'Garner',
                                    'Mann',
                                    'Mack',
                                    'Moss',
                                    'Thornton',
                                    'Dennis',
                                    'McGee',
                                    'Farmer',
                                    'Delgado',
                                    'Aguilar',
                                    'Vega',
                                    'Glover',
                                    'Manning',
                                    'Cohen',
                                    'Harmon',
                                    'Rodgers',
                                    'Robbins',
                                    'Newton',
                                    'Todd',
                                    'Blair',
                                    'Higgins',
                                    'Ingram',
                                    'Reese',
                                    'Cannon',
                                    'Strickland',
                                    'Townsend',
                                    'Potter',
                                    'Goodwin',
                                    'Walton',
                                    'Rowe',
                                    'Hampton',
                                    'Ortega',
                                    'Patton',
                                    'Swanson',
                                    'Joseph',
                                    'Francis',
                                    'Goodman',
                                    'Maldonado',
                                    'Yates',
                                    'Becker',
                                    'Erickson',
                                    'Hodges',
                                    'Rios',
                                    'Conner',
                                    'Adkins',
                                    'Webster',
                                    'Norman',
                                    'Malone',
                                    'Hammond',
                                    'Flowers',
                                    'Cobb',
                                    'Moody',
                                    'Quinn',
                                    'Blake',
                                    'Maxwell',
                                    'Pope',
                                    'Floyd',
                                    'Osborne',
                                    'Paul',
                                    'McCarthy',
                                    'Guerrero',
                                    'Lindsey',
                                    'Estrada',
                                    'Sandoval',
                                    'Gibbs',
                                    'Tyler',
                                    'Gross',
                                    'Fitzgerald',
                                    'Stokes',
                                    'Doyle',
                                    'Sherman',
                                    'Saunders',
                                    'Wise',
                                    'Colon',
                                    'Gill',
                                    'Alvarado',
                                    'Greer',
                                    'Padilla',
                                    'Simon',
                                    'Waters',
                                    'Nunez',
                                    'Ballard',
                                    'Schwartz',
                                    'McBride',
                                    'Houston',
                                    'Christensen',
                                    'Klein',
                                    'Pratt',
                                    'Briggs',
                                    'Parsons',
                                    'McLaughlin',
                                    'Zimmerman',
                                    'French',
                                    'Buchanan',
                                    'Moran',
                                    'Copeland',
                                    'Roy',
                                    'Pittman',
                                    'Brady',
                                    'McCormick',
                                    'Holloway',
                                    'Brock',
                                    'Poole',
                                    'Frank',
                                    'Logan',
                                    'Owen',
                                    'Bass',
                                    'Marsh',
                                    'Drake',
                                    'Wong',
                                    'Jefferson',
                                    'Park',
                                    'Morton',
                                    'Abbott',
                                    'Sparks',
                                    'Patrick',
                                    'Norton',
                                    'Huff',
                                    'Clayton',
                                    'Massey',
                                    'Lloyd',
                                    'Figueroa',
                                    'Carson',
                                    'Bowers',
                                    'Roberson',
                                    'Barton',
                                    'Tran',
                                    'Lamb',
                                    'Harrington',
                                    'Casey',
                                    'Boone',
                                    'Cortez',
                                    'Clarke',
                                    'Mathis',
                                    'Singleton',
                                    'Wilkins',
                                    'Cain',
                                    'Bryan',
                                    'Underwood',
                                    'Hogan',
                                    'McKenzie',
                                    'Collier',
                                    'Luna',
                                    'Phelps',
                                    'McGuire',
                                    'Allison',
                                    'Bridges',
                                    'Wilkerson',
                                    'Nash',
                                    'Summers',
                                    'Atkins'
                                ],
                                it: [
                                    'Acciai',
                                    'Aglietti',
                                    'Agostini',
                                    'Agresti',
                                    'Ahmed',
                                    'Aiazzi',
                                    'Albanese',
                                    'Alberti',
                                    'Alessi',
                                    'Alfani',
                                    'Alinari',
                                    'Alterini',
                                    'Amato',
                                    'Ammannati',
                                    'Ancillotti',
                                    'Andrei',
                                    'Andreini',
                                    'Andreoni',
                                    'Angeli',
                                    'Anichini',
                                    'Antonelli',
                                    'Antonini',
                                    'Arena',
                                    'Ariani',
                                    'Arnetoli',
                                    'Arrighi',
                                    'Baccani',
                                    'Baccetti',
                                    'Bacci',
                                    'Bacherini',
                                    'Badii',
                                    'Baggiani',
                                    'Baglioni',
                                    'Bagni',
                                    'Bagnoli',
                                    'Baldassini',
                                    'Baldi',
                                    'Baldini',
                                    'Ballerini',
                                    'Balli',
                                    'Ballini',
                                    'Balloni',
                                    'Bambi',
                                    'Banchi',
                                    'Bandinelli',
                                    'Bandini',
                                    'Bani',
                                    'Barbetti',
                                    'Barbieri',
                                    'Barchielli',
                                    'Bardazzi',
                                    'Bardelli',
                                    'Bardi',
                                    'Barducci',
                                    'Bargellini',
                                    'Bargiacchi',
                                    'Barni',
                                    'Baroncelli',
                                    'Baroncini',
                                    'Barone',
                                    'Baroni',
                                    'Baronti',
                                    'Bartalesi',
                                    'Bartoletti',
                                    'Bartoli',
                                    'Bartolini',
                                    'Bartoloni',
                                    'Bartolozzi',
                                    'Basagni',
                                    'Basile',
                                    'Bassi',
                                    'Batacchi',
                                    'Battaglia',
                                    'Battaglini',
                                    'Bausi',
                                    'Becagli',
                                    'Becattini',
                                    'Becchi',
                                    'Becucci',
                                    'Bellandi',
                                    'Bellesi',
                                    'Belli',
                                    'Bellini',
                                    'Bellucci',
                                    'Bencini',
                                    'Benedetti',
                                    'Benelli',
                                    'Beni',
                                    'Benini',
                                    'Bensi',
                                    'Benucci',
                                    'Benvenuti',
                                    'Berlincioni',
                                    'Bernacchioni',
                                    'Bernardi',
                                    'Bernardini',
                                    'Berni',
                                    'Bernini',
                                    'Bertelli',
                                    'Berti',
                                    'Bertini',
                                    'Bessi',
                                    'Betti',
                                    'Bettini',
                                    'Biagi',
                                    'Biagini',
                                    'Biagioni',
                                    'Biagiotti',
                                    'Biancalani',
                                    'Bianchi',
                                    'Bianchini',
                                    'Bianco',
                                    'Biffoli',
                                    'Bigazzi',
                                    'Bigi',
                                    'Biliotti',
                                    'Billi',
                                    'Binazzi',
                                    'Bindi',
                                    'Bini',
                                    'Biondi',
                                    'Bizzarri',
                                    'Bocci',
                                    'Bogani',
                                    'Bolognesi',
                                    'Bonaiuti',
                                    'Bonanni',
                                    'Bonciani',
                                    'Boncinelli',
                                    'Bondi',
                                    'Bonechi',
                                    'Bongini',
                                    'Boni',
                                    'Bonini',
                                    'Borchi',
                                    'Boretti',
                                    'Borghi',
                                    'Borghini',
                                    'Borgioli',
                                    'Borri',
                                    'Borselli',
                                    'Boschi',
                                    'Bottai',
                                    'Bracci',
                                    'Braccini',
                                    'Brandi',
                                    'Braschi',
                                    'Bravi',
                                    'Brazzini',
                                    'Breschi',
                                    'Brilli',
                                    'Brizzi',
                                    'Brogelli',
                                    'Brogi',
                                    'Brogioni',
                                    'Brunelli',
                                    'Brunetti',
                                    'Bruni',
                                    'Bruno',
                                    'Brunori',
                                    'Bruschi',
                                    'Bucci',
                                    'Bucciarelli',
                                    'Buccioni',
                                    'Bucelli',
                                    'Bulli',
                                    'Burberi',
                                    'Burchi',
                                    'Burgassi',
                                    'Burroni',
                                    'Bussotti',
                                    'Buti',
                                    'Caciolli',
                                    'Caiani',
                                    'Calabrese',
                                    'Calamai',
                                    'Calamandrei',
                                    'Caldini',
                                    'Calo\'',
                                    'Calonaci',
                                    'Calosi',
                                    'Calvelli',
                                    'Cambi',
                                    'Camiciottoli',
                                    'Cammelli',
                                    'Cammilli',
                                    'Campolmi',
                                    'Cantini',
                                    'Capanni',
                                    'Capecchi',
                                    'Caponi',
                                    'Cappelletti',
                                    'Cappelli',
                                    'Cappellini',
                                    'Cappugi',
                                    'Capretti',
                                    'Caputo',
                                    'Carbone',
                                    'Carboni',
                                    'Cardini',
                                    'Carlesi',
                                    'Carletti',
                                    'Carli',
                                    'Caroti',
                                    'Carotti',
                                    'Carrai',
                                    'Carraresi',
                                    'Carta',
                                    'Caruso',
                                    'Casalini',
                                    'Casati',
                                    'Caselli',
                                    'Casini',
                                    'Castagnoli',
                                    'Castellani',
                                    'Castelli',
                                    'Castellucci',
                                    'Catalano',
                                    'Catarzi',
                                    'Catelani',
                                    'Cavaciocchi',
                                    'Cavallaro',
                                    'Cavallini',
                                    'Cavicchi',
                                    'Cavini',
                                    'Ceccarelli',
                                    'Ceccatelli',
                                    'Ceccherelli',
                                    'Ceccherini',
                                    'Cecchi',
                                    'Cecchini',
                                    'Cecconi',
                                    'Cei',
                                    'Cellai',
                                    'Celli',
                                    'Cellini',
                                    'Cencetti',
                                    'Ceni',
                                    'Cenni',
                                    'Cerbai',
                                    'Cesari',
                                    'Ceseri',
                                    'Checcacci',
                                    'Checchi',
                                    'Checcucci',
                                    'Cheli',
                                    'Chellini',
                                    'Chen',
                                    'Cheng',
                                    'Cherici',
                                    'Cherubini',
                                    'Chiaramonti',
                                    'Chiarantini',
                                    'Chiarelli',
                                    'Chiari',
                                    'Chiarini',
                                    'Chiarugi',
                                    'Chiavacci',
                                    'Chiesi',
                                    'Chimenti',
                                    'Chini',
                                    'Chirici',
                                    'Chiti',
                                    'Ciabatti',
                                    'Ciampi',
                                    'Cianchi',
                                    'Cianfanelli',
                                    'Cianferoni',
                                    'Ciani',
                                    'Ciapetti',
                                    'Ciappi',
                                    'Ciardi',
                                    'Ciatti',
                                    'Cicali',
                                    'Ciccone',
                                    'Cinelli',
                                    'Cini',
                                    'Ciobanu',
                                    'Ciolli',
                                    'Cioni',
                                    'Cipriani',
                                    'Cirillo',
                                    'Cirri',
                                    'Ciucchi',
                                    'Ciuffi',
                                    'Ciulli',
                                    'Ciullini',
                                    'Clemente',
                                    'Cocchi',
                                    'Cognome',
                                    'Coli',
                                    'Collini',
                                    'Colombo',
                                    'Colzi',
                                    'Comparini',
                                    'Conforti',
                                    'Consigli',
                                    'Conte',
                                    'Conti',
                                    'Contini',
                                    'Coppini',
                                    'Coppola',
                                    'Corsi',
                                    'Corsini',
                                    'Corti',
                                    'Cortini',
                                    'Cosi',
                                    'Costa',
                                    'Costantini',
                                    'Costantino',
                                    'Cozzi',
                                    'Cresci',
                                    'Crescioli',
                                    'Cresti',
                                    'Crini',
                                    'Curradi',
                                    'D\'Agostino',
                                    'D\'Alessandro',
                                    'D\'Amico',
                                    'D\'Angelo',
                                    'Daddi',
                                    'Dainelli',
                                    'Dallai',
                                    'Danti',
                                    'Davitti',
                                    'De Angelis',
                                    'De Luca',
                                    'De Marco',
                                    'De Rosa',
                                    'De Santis',
                                    'De Simone',
                                    'De Vita',
                                    'Degl\'Innocenti',
                                    'Degli Innocenti',
                                    'Dei',
                                    'Del Lungo',
                                    'Del Re',
                                    'Di Marco',
                                    'Di Stefano',
                                    'Dini',
                                    'Diop',
                                    'Dobre',
                                    'Dolfi',
                                    'Donati',
                                    'Dondoli',
                                    'Dong',
                                    'Donnini',
                                    'Ducci',
                                    'Dumitru',
                                    'Ermini',
                                    'Esposito',
                                    'Evangelisti',
                                    'Fabbri',
                                    'Fabbrini',
                                    'Fabbrizzi',
                                    'Fabbroni',
                                    'Fabbrucci',
                                    'Fabiani',
                                    'Facchini',
                                    'Faggi',
                                    'Fagioli',
                                    'Failli',
                                    'Faini',
                                    'Falciani',
                                    'Falcini',
                                    'Falcone',
                                    'Fallani',
                                    'Falorni',
                                    'Falsini',
                                    'Falugiani',
                                    'Fancelli',
                                    'Fanelli',
                                    'Fanetti',
                                    'Fanfani',
                                    'Fani',
                                    'Fantappie\'',
                                    'Fantechi',
                                    'Fanti',
                                    'Fantini',
                                    'Fantoni',
                                    'Farina',
                                    'Fattori',
                                    'Favilli',
                                    'Fedi',
                                    'Fei',
                                    'Ferrante',
                                    'Ferrara',
                                    'Ferrari',
                                    'Ferraro',
                                    'Ferretti',
                                    'Ferri',
                                    'Ferrini',
                                    'Ferroni',
                                    'Fiaschi',
                                    'Fibbi',
                                    'Fiesoli',
                                    'Filippi',
                                    'Filippini',
                                    'Fini',
                                    'Fioravanti',
                                    'Fiore',
                                    'Fiorentini',
                                    'Fiorini',
                                    'Fissi',
                                    'Focardi',
                                    'Foggi',
                                    'Fontana',
                                    'Fontanelli',
                                    'Fontani',
                                    'Forconi',
                                    'Formigli',
                                    'Forte',
                                    'Forti',
                                    'Fortini',
                                    'Fossati',
                                    'Fossi',
                                    'Francalanci',
                                    'Franceschi',
                                    'Franceschini',
                                    'Franchi',
                                    'Franchini',
                                    'Franci',
                                    'Francini',
                                    'Francioni',
                                    'Franco',
                                    'Frassineti',
                                    'Frati',
                                    'Fratini',
                                    'Frilli',
                                    'Frizzi',
                                    'Frosali',
                                    'Frosini',
                                    'Frullini',
                                    'Fusco',
                                    'Fusi',
                                    'Gabbrielli',
                                    'Gabellini',
                                    'Gagliardi',
                                    'Galanti',
                                    'Galardi',
                                    'Galeotti',
                                    'Galletti',
                                    'Galli',
                                    'Gallo',
                                    'Gallori',
                                    'Gambacciani',
                                    'Gargani',
                                    'Garofalo',
                                    'Garuglieri',
                                    'Gashi',
                                    'Gasperini',
                                    'Gatti',
                                    'Gelli',
                                    'Gensini',
                                    'Gentile',
                                    'Gentili',
                                    'Geri',
                                    'Gerini',
                                    'Gheri',
                                    'Ghini',
                                    'Giachetti',
                                    'Giachi',
                                    'Giacomelli',
                                    'Gianassi',
                                    'Giani',
                                    'Giannelli',
                                    'Giannetti',
                                    'Gianni',
                                    'Giannini',
                                    'Giannoni',
                                    'Giannotti',
                                    'Giannozzi',
                                    'Gigli',
                                    'Giordano',
                                    'Giorgetti',
                                    'Giorgi',
                                    'Giovacchini',
                                    'Giovannelli',
                                    'Giovannetti',
                                    'Giovannini',
                                    'Giovannoni',
                                    'Giuliani',
                                    'Giunti',
                                    'Giuntini',
                                    'Giusti',
                                    'Gonnelli',
                                    'Goretti',
                                    'Gori',
                                    'Gradi',
                                    'Gramigni',
                                    'Grassi',
                                    'Grasso',
                                    'Graziani',
                                    'Grazzini',
                                    'Greco',
                                    'Grifoni',
                                    'Grillo',
                                    'Grimaldi',
                                    'Grossi',
                                    'Gualtieri',
                                    'Guarducci',
                                    'Guarino',
                                    'Guarnieri',
                                    'Guasti',
                                    'Guerra',
                                    'Guerri',
                                    'Guerrini',
                                    'Guidi',
                                    'Guidotti',
                                    'He',
                                    'Hoxha',
                                    'Hu',
                                    'Huang',
                                    'Iandelli',
                                    'Ignesti',
                                    'Innocenti',
                                    'Jin',
                                    'La Rosa',
                                    'Lai',
                                    'Landi',
                                    'Landini',
                                    'Lanini',
                                    'Lapi',
                                    'Lapini',
                                    'Lari',
                                    'Lascialfari',
                                    'Lastrucci',
                                    'Latini',
                                    'Lazzeri',
                                    'Lazzerini',
                                    'Lelli',
                                    'Lenzi',
                                    'Leonardi',
                                    'Leoncini',
                                    'Leone',
                                    'Leoni',
                                    'Lepri',
                                    'Li',
                                    'Liao',
                                    'Lin',
                                    'Linari',
                                    'Lippi',
                                    'Lisi',
                                    'Livi',
                                    'Lombardi',
                                    'Lombardini',
                                    'Lombardo',
                                    'Longo',
                                    'Lopez',
                                    'Lorenzi',
                                    'Lorenzini',
                                    'Lorini',
                                    'Lotti',
                                    'Lu',
                                    'Lucchesi',
                                    'Lucherini',
                                    'Lunghi',
                                    'Lupi',
                                    'Madiai',
                                    'Maestrini',
                                    'Maffei',
                                    'Maggi',
                                    'Maggini',
                                    'Magherini',
                                    'Magini',
                                    'Magnani',
                                    'Magnelli',
                                    'Magni',
                                    'Magnolfi',
                                    'Magrini',
                                    'Malavolti',
                                    'Malevolti',
                                    'Manca',
                                    'Mancini',
                                    'Manetti',
                                    'Manfredi',
                                    'Mangani',
                                    'Mannelli',
                                    'Manni',
                                    'Mannini',
                                    'Mannucci',
                                    'Manuelli',
                                    'Manzini',
                                    'Marcelli',
                                    'Marchese',
                                    'Marchetti',
                                    'Marchi',
                                    'Marchiani',
                                    'Marchionni',
                                    'Marconi',
                                    'Marcucci',
                                    'Margheri',
                                    'Mari',
                                    'Mariani',
                                    'Marilli',
                                    'Marinai',
                                    'Marinari',
                                    'Marinelli',
                                    'Marini',
                                    'Marino',
                                    'Mariotti',
                                    'Marsili',
                                    'Martelli',
                                    'Martinelli',
                                    'Martini',
                                    'Martino',
                                    'Marzi',
                                    'Masi',
                                    'Masini',
                                    'Masoni',
                                    'Massai',
                                    'Materassi',
                                    'Mattei',
                                    'Matteini',
                                    'Matteucci',
                                    'Matteuzzi',
                                    'Mattioli',
                                    'Mattolini',
                                    'Matucci',
                                    'Mauro',
                                    'Mazzanti',
                                    'Mazzei',
                                    'Mazzetti',
                                    'Mazzi',
                                    'Mazzini',
                                    'Mazzocchi',
                                    'Mazzoli',
                                    'Mazzoni',
                                    'Mazzuoli',
                                    'Meacci',
                                    'Mecocci',
                                    'Meini',
                                    'Melani',
                                    'Mele',
                                    'Meli',
                                    'Mengoni',
                                    'Menichetti',
                                    'Meoni',
                                    'Merlini',
                                    'Messeri',
                                    'Messina',
                                    'Meucci',
                                    'Miccinesi',
                                    'Miceli',
                                    'Micheli',
                                    'Michelini',
                                    'Michelozzi',
                                    'Migliori',
                                    'Migliorini',
                                    'Milani',
                                    'Miniati',
                                    'Misuri',
                                    'Monaco',
                                    'Montagnani',
                                    'Montagni',
                                    'Montanari',
                                    'Montelatici',
                                    'Monti',
                                    'Montigiani',
                                    'Montini',
                                    'Morandi',
                                    'Morandini',
                                    'Morelli',
                                    'Moretti',
                                    'Morganti',
                                    'Mori',
                                    'Morini',
                                    'Moroni',
                                    'Morozzi',
                                    'Mugnai',
                                    'Mugnaini',
                                    'Mustafa',
                                    'Naldi',
                                    'Naldini',
                                    'Nannelli',
                                    'Nanni',
                                    'Nannini',
                                    'Nannucci',
                                    'Nardi',
                                    'Nardini',
                                    'Nardoni',
                                    'Natali',
                                    'Ndiaye',
                                    'Nencetti',
                                    'Nencini',
                                    'Nencioni',
                                    'Neri',
                                    'Nesi',
                                    'Nesti',
                                    'Niccolai',
                                    'Niccoli',
                                    'Niccolini',
                                    'Nigi',
                                    'Nistri',
                                    'Nocentini',
                                    'Noferini',
                                    'Novelli',
                                    'Nucci',
                                    'Nuti',
                                    'Nutini',
                                    'Oliva',
                                    'Olivieri',
                                    'Olmi',
                                    'Orlandi',
                                    'Orlandini',
                                    'Orlando',
                                    'Orsini',
                                    'Ortolani',
                                    'Ottanelli',
                                    'Pacciani',
                                    'Pace',
                                    'Paci',
                                    'Pacini',
                                    'Pagani',
                                    'Pagano',
                                    'Paggetti',
                                    'Pagliai',
                                    'Pagni',
                                    'Pagnini',
                                    'Paladini',
                                    'Palagi',
                                    'Palchetti',
                                    'Palloni',
                                    'Palmieri',
                                    'Palumbo',
                                    'Pampaloni',
                                    'Pancani',
                                    'Pandolfi',
                                    'Pandolfini',
                                    'Panerai',
                                    'Panichi',
                                    'Paoletti',
                                    'Paoli',
                                    'Paolini',
                                    'Papi',
                                    'Papini',
                                    'Papucci',
                                    'Parenti',
                                    'Parigi',
                                    'Parisi',
                                    'Parri',
                                    'Parrini',
                                    'Pasquini',
                                    'Passeri',
                                    'Pecchioli',
                                    'Pecorini',
                                    'Pellegrini',
                                    'Pepi',
                                    'Perini',
                                    'Perrone',
                                    'Peruzzi',
                                    'Pesci',
                                    'Pestelli',
                                    'Petri',
                                    'Petrini',
                                    'Petrucci',
                                    'Pettini',
                                    'Pezzati',
                                    'Pezzatini',
                                    'Piani',
                                    'Piazza',
                                    'Piazzesi',
                                    'Piazzini',
                                    'Piccardi',
                                    'Picchi',
                                    'Piccini',
                                    'Piccioli',
                                    'Pieraccini',
                                    'Pieraccioni',
                                    'Pieralli',
                                    'Pierattini',
                                    'Pieri',
                                    'Pierini',
                                    'Pieroni',
                                    'Pietrini',
                                    'Pini',
                                    'Pinna',
                                    'Pinto',
                                    'Pinzani',
                                    'Pinzauti',
                                    'Piras',
                                    'Pisani',
                                    'Pistolesi',
                                    'Poggesi',
                                    'Poggi',
                                    'Poggiali',
                                    'Poggiolini',
                                    'Poli',
                                    'Pollastri',
                                    'Porciani',
                                    'Pozzi',
                                    'Pratellesi',
                                    'Pratesi',
                                    'Prosperi',
                                    'Pruneti',
                                    'Pucci',
                                    'Puccini',
                                    'Puccioni',
                                    'Pugi',
                                    'Pugliese',
                                    'Puliti',
                                    'Querci',
                                    'Quercioli',
                                    'Raddi',
                                    'Radu',
                                    'Raffaelli',
                                    'Ragazzini',
                                    'Ranfagni',
                                    'Ranieri',
                                    'Rastrelli',
                                    'Raugei',
                                    'Raveggi',
                                    'Renai',
                                    'Renzi',
                                    'Rettori',
                                    'Ricci',
                                    'Ricciardi',
                                    'Ridi',
                                    'Ridolfi',
                                    'Rigacci',
                                    'Righi',
                                    'Righini',
                                    'Rinaldi',
                                    'Risaliti',
                                    'Ristori',
                                    'Rizzo',
                                    'Rocchi',
                                    'Rocchini',
                                    'Rogai',
                                    'Romagnoli',
                                    'Romanelli',
                                    'Romani',
                                    'Romano',
                                    'Romei',
                                    'Romeo',
                                    'Romiti',
                                    'Romoli',
                                    'Romolini',
                                    'Rontini',
                                    'Rosati',
                                    'Roselli',
                                    'Rosi',
                                    'Rossetti',
                                    'Rossi',
                                    'Rossini',
                                    'Rovai',
                                    'Ruggeri',
                                    'Ruggiero',
                                    'Russo',
                                    'Sabatini',
                                    'Saccardi',
                                    'Sacchetti',
                                    'Sacchi',
                                    'Sacco',
                                    'Salerno',
                                    'Salimbeni',
                                    'Salucci',
                                    'Salvadori',
                                    'Salvestrini',
                                    'Salvi',
                                    'Salvini',
                                    'Sanesi',
                                    'Sani',
                                    'Sanna',
                                    'Santi',
                                    'Santini',
                                    'Santoni',
                                    'Santoro',
                                    'Santucci',
                                    'Sardi',
                                    'Sarri',
                                    'Sarti',
                                    'Sassi',
                                    'Sbolci',
                                    'Scali',
                                    'Scarpelli',
                                    'Scarselli',
                                    'Scopetani',
                                    'Secci',
                                    'Selvi',
                                    'Senatori',
                                    'Senesi',
                                    'Serafini',
                                    'Sereni',
                                    'Serra',
                                    'Sestini',
                                    'Sguanci',
                                    'Sieni',
                                    'Signorini',
                                    'Silvestri',
                                    'Simoncini',
                                    'Simonetti',
                                    'Simoni',
                                    'Singh',
                                    'Sodi',
                                    'Soldi',
                                    'Somigli',
                                    'Sorbi',
                                    'Sorelli',
                                    'Sorrentino',
                                    'Sottili',
                                    'Spina',
                                    'Spinelli',
                                    'Staccioli',
                                    'Staderini',
                                    'Stefanelli',
                                    'Stefani',
                                    'Stefanini',
                                    'Stella',
                                    'Susini',
                                    'Tacchi',
                                    'Tacconi',
                                    'Taddei',
                                    'Tagliaferri',
                                    'Tamburini',
                                    'Tanganelli',
                                    'Tani',
                                    'Tanini',
                                    'Tapinassi',
                                    'Tarchi',
                                    'Tarchiani',
                                    'Targioni',
                                    'Tassi',
                                    'Tassini',
                                    'Tempesti',
                                    'Terzani',
                                    'Tesi',
                                    'Testa',
                                    'Testi',
                                    'Tilli',
                                    'Tinti',
                                    'Tirinnanzi',
                                    'Toccafondi',
                                    'Tofanari',
                                    'Tofani',
                                    'Tognaccini',
                                    'Tonelli',
                                    'Tonini',
                                    'Torelli',
                                    'Torrini',
                                    'Tosi',
                                    'Toti',
                                    'Tozzi',
                                    'Trambusti',
                                    'Trapani',
                                    'Tucci',
                                    'Turchi',
                                    'Ugolini',
                                    'Ulivi',
                                    'Valente',
                                    'Valenti',
                                    'Valentini',
                                    'Vangelisti',
                                    'Vanni',
                                    'Vannini',
                                    'Vannoni',
                                    'Vannozzi',
                                    'Vannucchi',
                                    'Vannucci',
                                    'Ventura',
                                    'Venturi',
                                    'Venturini',
                                    'Vestri',
                                    'Vettori',
                                    'Vichi',
                                    'Viciani',
                                    'Vieri',
                                    'Vigiani',
                                    'Vignoli',
                                    'Vignolini',
                                    'Vignozzi',
                                    'Villani',
                                    'Vinci',
                                    'Visani',
                                    'Vitale',
                                    'Vitali',
                                    'Viti',
                                    'Viviani',
                                    'Vivoli',
                                    'Volpe',
                                    'Volpi',
                                    'Wang',
                                    'Wu',
                                    'Xu',
                                    'Yang',
                                    'Ye',
                                    'Zagli',
                                    'Zani',
                                    'Zanieri',
                                    'Zanobini',
                                    'Zecchi',
                                    'Zetti',
                                    'Zhang',
                                    'Zheng',
                                    'Zhou',
                                    'Zhu',
                                    'Zingoni',
                                    'Zini',
                                    'Zoppi'
                                ],
                                nl: [
                                    'Albers',
                                    'Alblas',
                                    'Appelman',
                                    'Baars',
                                    'Baas',
                                    'Bakker',
                                    'Blank',
                                    'Bleeker',
                                    'Blok',
                                    'Blom',
                                    'Boer',
                                    'Boers',
                                    'Boldewijn',
                                    'Boon',
                                    'Boot',
                                    'Bos',
                                    'Bosch',
                                    'Bosma',
                                    'Bosman',
                                    'Bouma',
                                    'Bouman',
                                    'Bouwman',
                                    'Brands',
                                    'Brouwer',
                                    'Burger',
                                    'Buijs',
                                    'Buitenhuis',
                                    'Ceder',
                                    'Cohen',
                                    'Dekker',
                                    'Dekkers',
                                    'Dijkman',
                                    'Dijkstra',
                                    'Driessen',
                                    'Drost',
                                    'Engel',
                                    'Evers',
                                    'Faber',
                                    'Franke',
                                    'Gerritsen',
                                    'Goedhart',
                                    'Goossens',
                                    'Groen',
                                    'Groenenberg',
                                    'Groot',
                                    'Haan',
                                    'Hart',
                                    'Heemskerk',
                                    'Hendriks',
                                    'Hermans',
                                    'Hoekstra',
                                    'Hofman',
                                    'Hopman',
                                    'Huisman',
                                    'Jacobs',
                                    'Jansen',
                                    'Janssen',
                                    'Jonker',
                                    'Jaspers',
                                    'Keijzer',
                                    'Klaassen',
                                    'Klein',
                                    'Koek',
                                    'Koenders',
                                    'Kok',
                                    'Kool',
                                    'Koopman',
                                    'Koopmans',
                                    'Koning',
                                    'Koster',
                                    'Kramer',
                                    'Kroon',
                                    'Kuijpers',
                                    'Kuiper',
                                    'Kuipers',
                                    'Kurt',
                                    'Koster',
                                    'Kwakman',
                                    'Los',
                                    'Lubbers',
                                    'Maas',
                                    'Markus',
                                    'Martens',
                                    'Meijer',
                                    'Mol',
                                    'Molenaar',
                                    'Mulder',
                                    'Nieuwenhuis',
                                    'Peeters',
                                    'Peters',
                                    'Pengel',
                                    'Pieters',
                                    'Pool',
                                    'Post',
                                    'Postma',
                                    'Prins',
                                    'Pronk',
                                    'Reijnders',
                                    'Rietveld',
                                    'Roest',
                                    'Roos',
                                    'Sanders',
                                    'Schaap',
                                    'Scheffer',
                                    'Schenk',
                                    'Schilder',
                                    'Schipper',
                                    'Schmidt',
                                    'Scholten',
                                    'Schouten',
                                    'Schut',
                                    'Schutte',
                                    'Schuurman',
                                    'Simons',
                                    'Smeets',
                                    'Smit',
                                    'Smits',
                                    'Snel',
                                    'Swinkels',
                                    'Tas',
                                    'Terpstra',
                                    'Timmermans',
                                    'Tol',
                                    'Tromp',
                                    'Troost',
                                    'Valk',
                                    'Veenstra',
                                    'Veldkamp',
                                    'Verbeek',
                                    'Verheul',
                                    'Verhoeven',
                                    'Vermeer',
                                    'Vermeulen',
                                    'Verweij',
                                    'Vink',
                                    'Visser',
                                    'Voorn',
                                    'Vos',
                                    'Wagenaar',
                                    'Wiersema',
                                    'Willems',
                                    'Willemsen',
                                    'Witteveen',
                                    'Wolff',
                                    'Wolters',
                                    'Zijlstra',
                                    'Zwart',
                                    'de Beer',
                                    'de Boer',
                                    'de Bruijn',
                                    'de Bruin',
                                    'de Graaf',
                                    'de Groot',
                                    'de Haan',
                                    'de Haas',
                                    'de Jager',
                                    'de Jong',
                                    'de Jonge',
                                    'de Koning',
                                    'de Lange',
                                    'de Leeuw',
                                    'de Ridder',
                                    'de Rooij',
                                    'de Ruiter',
                                    'de Vos',
                                    'de Vries',
                                    'de Waal',
                                    'de Wit',
                                    'de Zwart',
                                    'van Beek',
                                    'van Boven',
                                    'van Dam',
                                    'van Dijk',
                                    'van Dongen',
                                    'van Doorn',
                                    'van Egmond',
                                    'van Eijk',
                                    'van Es',
                                    'van Gelder',
                                    'van Gelderen',
                                    'van Houten',
                                    'van Hulst',
                                    'van Kempen',
                                    'van Kesteren',
                                    'van Leeuwen',
                                    'van Loon',
                                    'van Mill',
                                    'van Noord',
                                    'van Ommen',
                                    'van Ommeren',
                                    'van Oosten',
                                    'van Oostveen',
                                    'van Rijn',
                                    'van Schaik',
                                    'van Veen',
                                    'van Vliet',
                                    'van Wijk',
                                    'van Wijngaarden',
                                    'van den Poel',
                                    'van de Pol',
                                    'van den Ploeg',
                                    'van de Ven',
                                    'van den Berg',
                                    'van den Bosch',
                                    'van den Brink',
                                    'van den Broek',
                                    'van den Heuvel',
                                    'van der Heijden',
                                    'van der Horst',
                                    'van der Hulst',
                                    'van der Kroon',
                                    'van der Laan',
                                    'van der Linden',
                                    'van der Meer',
                                    'van der Meij',
                                    'van der Meulen',
                                    'van der Molen',
                                    'van der Sluis',
                                    'van der Spek',
                                    'van der Veen',
                                    'van der Velde',
                                    'van der Velden',
                                    'van der Vliet',
                                    'van der Wal'
                                ],
                                uk: [
                                    'Smith',
                                    'Jones',
                                    'Williams',
                                    'Taylor',
                                    'Brown',
                                    'Davies',
                                    'Evans',
                                    'Wilson',
                                    'Thomas',
                                    'Johnson',
                                    'Roberts',
                                    'Robinson',
                                    'Thompson',
                                    'Wright',
                                    'Walker',
                                    'White',
                                    'Edwards',
                                    'Hughes',
                                    'Green',
                                    'Hall',
                                    'Lewis',
                                    'Harris',
                                    'Clarke',
                                    'Patel',
                                    'Jackson',
                                    'Wood',
                                    'Turner',
                                    'Martin',
                                    'Cooper',
                                    'Hill',
                                    'Ward',
                                    'Morris',
                                    'Moore',
                                    'Clark',
                                    'Lee',
                                    'King',
                                    'Baker',
                                    'Harrison',
                                    'Morgan',
                                    'Allen',
                                    'James',
                                    'Scott',
                                    'Phillips',
                                    'Watson',
                                    'Davis',
                                    'Parker',
                                    'Price',
                                    'Bennett',
                                    'Young',
                                    'Griffiths',
                                    'Mitchell',
                                    'Kelly',
                                    'Cook',
                                    'Carter',
                                    'Richardson',
                                    'Bailey',
                                    'Collins',
                                    'Bell',
                                    'Shaw',
                                    'Murphy',
                                    'Miller',
                                    'Cox',
                                    'Richards',
                                    'Khan',
                                    'Marshall',
                                    'Anderson',
                                    'Simpson',
                                    'Ellis',
                                    'Adams',
                                    'Singh',
                                    'Begum',
                                    'Wilkinson',
                                    'Foster',
                                    'Chapman',
                                    'Powell',
                                    'Webb',
                                    'Rogers',
                                    'Gray',
                                    'Mason',
                                    'Ali',
                                    'Hunt',
                                    'Hussain',
                                    'Campbell',
                                    'Matthews',
                                    'Owen',
                                    'Palmer',
                                    'Holmes',
                                    'Mills',
                                    'Barnes',
                                    'Knight',
                                    'Lloyd',
                                    'Butler',
                                    'Russell',
                                    'Barker',
                                    'Fisher',
                                    'Stevens',
                                    'Jenkins',
                                    'Murray',
                                    'Dixon',
                                    'Harvey',
                                    'Graham',
                                    'Pearson',
                                    'Ahmed',
                                    'Fletcher',
                                    'Walsh',
                                    'Kaur',
                                    'Gibson',
                                    'Howard',
                                    'Andrews',
                                    'Stewart',
                                    'Elliott',
                                    'Reynolds',
                                    'Saunders',
                                    'Payne',
                                    'Fox',
                                    'Ford',
                                    'Pearce',
                                    'Day',
                                    'Brooks',
                                    'West',
                                    'Lawrence',
                                    'Cole',
                                    'Atkinson',
                                    'Bradley',
                                    'Spencer',
                                    'Gill',
                                    'Dawson',
                                    'Ball',
                                    'Burton',
                                    'O\'brien',
                                    'Watts',
                                    'Rose',
                                    'Booth',
                                    'Perry',
                                    'Ryan',
                                    'Grant',
                                    'Wells',
                                    'Armstrong',
                                    'Francis',
                                    'Rees',
                                    'Hayes',
                                    'Hart',
                                    'Hudson',
                                    'Newman',
                                    'Barrett',
                                    'Webster',
                                    'Hunter',
                                    'Gregory',
                                    'Carr',
                                    'Lowe',
                                    'Page',
                                    'Marsh',
                                    'Riley',
                                    'Dunn',
                                    'Woods',
                                    'Parsons',
                                    'Berry',
                                    'Stone',
                                    'Reid',
                                    'Holland',
                                    'Hawkins',
                                    'Harding',
                                    'Porter',
                                    'Robertson',
                                    'Newton',
                                    'Oliver',
                                    'Reed',
                                    'Kennedy',
                                    'Williamson',
                                    'Bird',
                                    'Gardner',
                                    'Shah',
                                    'Dean',
                                    'Lane',
                                    'Cooke',
                                    'Bates',
                                    'Henderson',
                                    'Parry',
                                    'Burgess',
                                    'Bishop',
                                    'Walton',
                                    'Burns',
                                    'Nicholson',
                                    'Shepherd',
                                    'Ross',
                                    'Cross',
                                    'Long',
                                    'Freeman',
                                    'Warren',
                                    'Nicholls',
                                    'Hamilton',
                                    'Byrne',
                                    'Sutton',
                                    'Mcdonald',
                                    'Yates',
                                    'Hodgson',
                                    'Robson',
                                    'Curtis',
                                    'Hopkins',
                                    'O\'connor',
                                    'Harper',
                                    'Coleman',
                                    'Watkins',
                                    'Moss',
                                    'Mccarthy',
                                    'Chambers',
                                    'O\'neill',
                                    'Griffin',
                                    'Sharp',
                                    'Hardy',
                                    'Wheeler',
                                    'Potter',
                                    'Osborne',
                                    'Johnston',
                                    'Gordon',
                                    'Doyle',
                                    'Wallace',
                                    'George',
                                    'Jordan',
                                    'Hutchinson',
                                    'Rowe',
                                    'Burke',
                                    'May',
                                    'Pritchard',
                                    'Gilbert',
                                    'Willis',
                                    'Higgins',
                                    'Read',
                                    'Miles',
                                    'Stevenson',
                                    'Stephenson',
                                    'Hammond',
                                    'Arnold',
                                    'Buckley',
                                    'Walters',
                                    'Hewitt',
                                    'Barber',
                                    'Nelson',
                                    'Slater',
                                    'Austin',
                                    'Sullivan',
                                    'Whitehead',
                                    'Mann',
                                    'Frost',
                                    'Lambert',
                                    'Stephens',
                                    'Blake',
                                    'Akhtar',
                                    'Lynch',
                                    'Goodwin',
                                    'Barton',
                                    'Woodward',
                                    'Thomson',
                                    'Cunningham',
                                    'Quinn',
                                    'Barnett',
                                    'Baxter',
                                    'Bibi',
                                    'Clayton',
                                    'Nash',
                                    'Greenwood',
                                    'Jennings',
                                    'Holt',
                                    'Kemp',
                                    'Poole',
                                    'Gallagher',
                                    'Bond',
                                    'Stokes',
                                    'Tucker',
                                    'Davidson',
                                    'Fowler',
                                    'Heath',
                                    'Norman',
                                    'Middleton',
                                    'Lawson',
                                    'Banks',
                                    'French',
                                    'Stanley',
                                    'Jarvis',
                                    'Gibbs',
                                    'Ferguson',
                                    'Hayward',
                                    'Carroll',
                                    'Douglas',
                                    'Dickinson',
                                    'Todd',
                                    'Barlow',
                                    'Peters',
                                    'Lucas',
                                    'Knowles',
                                    'Hartley',
                                    'Miah',
                                    'Simmons',
                                    'Morton',
                                    'Alexander',
                                    'Field',
                                    'Morrison',
                                    'Norris',
                                    'Townsend',
                                    'Preston',
                                    'Hancock',
                                    'Thornton',
                                    'Baldwin',
                                    'Burrows',
                                    'Briggs',
                                    'Parkinson',
                                    'Reeves',
                                    'Macdonald',
                                    'Lamb',
                                    'Black',
                                    'Abbott',
                                    'Sanders',
                                    'Thorpe',
                                    'Holden',
                                    'Tomlinson',
                                    'Perkins',
                                    'Ashton',
                                    'Rhodes',
                                    'Fuller',
                                    'Howe',
                                    'Bryant',
                                    'Vaughan',
                                    'Dale',
                                    'Davey',
                                    'Weston',
                                    'Bartlett',
                                    'Whittaker',
                                    'Davison',
                                    'Kent',
                                    'Skinner',
                                    'Birch',
                                    'Morley',
                                    'Daniels',
                                    'Glover',
                                    'Howell',
                                    'Cartwright',
                                    'Pugh',
                                    'Humphreys',
                                    'Goddard',
                                    'Brennan',
                                    'Wall',
                                    'Kirby',
                                    'Bowen',
                                    'Savage',
                                    'Bull',
                                    'Wong',
                                    'Dobson',
                                    'Smart',
                                    'Wilkins',
                                    'Kirk',
                                    'Fraser',
                                    'Duffy',
                                    'Hicks',
                                    'Patterson',
                                    'Bradshaw',
                                    'Little',
                                    'Archer',
                                    'Warner',
                                    'Waters',
                                    'O\'sullivan',
                                    'Farrell',
                                    'Brookes',
                                    'Atkins',
                                    'Kay',
                                    'Dodd',
                                    'Bentley',
                                    'Flynn',
                                    'John',
                                    'Schofield',
                                    'Short',
                                    'Haynes',
                                    'Wade',
                                    'Butcher',
                                    'Henry',
                                    'Sanderson',
                                    'Crawford',
                                    'Sheppard',
                                    'Bolton',
                                    'Coates',
                                    'Giles',
                                    'Gould',
                                    'Houghton',
                                    'Gibbons',
                                    'Pratt',
                                    'Manning',
                                    'Law',
                                    'Hooper',
                                    'Noble',
                                    'Dyer',
                                    'Rahman',
                                    'Clements',
                                    'Moran',
                                    'Sykes',
                                    'Chan',
                                    'Doherty',
                                    'Connolly',
                                    'Joyce',
                                    'Franklin',
                                    'Hobbs',
                                    'Coles',
                                    'Herbert',
                                    'Steele',
                                    'Kerr',
                                    'Leach',
                                    'Winter',
                                    'Owens',
                                    'Duncan',
                                    'Naylor',
                                    'Fleming',
                                    'Horton',
                                    'Finch',
                                    'Fitzgerald',
                                    'Randall',
                                    'Carpenter',
                                    'Marsden',
                                    'Browne',
                                    'Garner',
                                    'Pickering',
                                    'Hale',
                                    'Dennis',
                                    'Vincent',
                                    'Chadwick',
                                    'Chandler',
                                    'Sharpe',
                                    'Nolan',
                                    'Lyons',
                                    'Hurst',
                                    'Collier',
                                    'Peacock',
                                    'Howarth',
                                    'Faulkner',
                                    'Rice',
                                    'Pollard',
                                    'Welch',
                                    'Norton',
                                    'Gough',
                                    'Sinclair',
                                    'Blackburn',
                                    'Bryan',
                                    'Conway',
                                    'Power',
                                    'Cameron',
                                    'Daly',
                                    'Allan',
                                    'Hanson',
                                    'Gardiner',
                                    'Boyle',
                                    'Myers',
                                    'Turnbull',
                                    'Wallis',
                                    'Mahmood',
                                    'Sims',
                                    'Swift',
                                    'Iqbal',
                                    'Pope',
                                    'Brady',
                                    'Chamberlain',
                                    'Rowley',
                                    'Tyler',
                                    'Farmer',
                                    'Metcalfe',
                                    'Hilton',
                                    'Godfrey',
                                    'Holloway',
                                    'Parkin',
                                    'Bray',
                                    'Talbot',
                                    'Donnelly',
                                    'Nixon',
                                    'Charlton',
                                    'Benson',
                                    'Whitehouse',
                                    'Barry',
                                    'Hope',
                                    'Lord',
                                    'North',
                                    'Storey',
                                    'Connor',
                                    'Potts',
                                    'Bevan',
                                    'Hargreaves',
                                    'Mclean',
                                    'Mistry',
                                    'Bruce',
                                    'Howells',
                                    'Hyde',
                                    'Parkes',
                                    'Wyatt',
                                    'Fry',
                                    'Lees',
                                    'O\'donnell',
                                    'Craig',
                                    'Forster',
                                    'Mckenzie',
                                    'Humphries',
                                    'Mellor',
                                    'Carey',
                                    'Ingram',
                                    'Summers',
                                    'Leonard'
                                ],
                                de: [
                                    'Müller',
                                    'Schmidt',
                                    'Schneider',
                                    'Fischer',
                                    'Weber',
                                    'Meyer',
                                    'Wagner',
                                    'Becker',
                                    'Schulz',
                                    'Hoffmann',
                                    'Schäfer',
                                    'Koch',
                                    'Bauer',
                                    'Richter',
                                    'Klein',
                                    'Wolf',
                                    'Schröder',
                                    'Neumann',
                                    'Schwarz',
                                    'Zimmermann',
                                    'Braun',
                                    'Krüger',
                                    'Hofmann',
                                    'Hartmann',
                                    'Lange',
                                    'Schmitt',
                                    'Werner',
                                    'Schmitz',
                                    'Krause',
                                    'Meier',
                                    'Lehmann',
                                    'Schmid',
                                    'Schulze',
                                    'Maier',
                                    'Köhler',
                                    'Herrmann',
                                    'König',
                                    'Walter',
                                    'Mayer',
                                    'Huber',
                                    'Kaiser',
                                    'Fuchs',
                                    'Peters',
                                    'Lang',
                                    'Scholz',
                                    'Möller',
                                    'Weiß',
                                    'Jung',
                                    'Hahn',
                                    'Schubert',
                                    'Vogel',
                                    'Friedrich',
                                    'Keller',
                                    'Günther',
                                    'Frank',
                                    'Berger',
                                    'Winkler',
                                    'Roth',
                                    'Beck',
                                    'Lorenz',
                                    'Baumann',
                                    'Franke',
                                    'Albrecht',
                                    'Schuster',
                                    'Simon',
                                    'Ludwig',
                                    'Böhm',
                                    'Winter',
                                    'Kraus',
                                    'Martin',
                                    'Schumacher',
                                    'Krämer',
                                    'Vogt',
                                    'Stein',
                                    'Jäger',
                                    'Otto',
                                    'Sommer',
                                    'Groß',
                                    'Seidel',
                                    'Heinrich',
                                    'Brandt',
                                    'Haas',
                                    'Schreiber',
                                    'Graf',
                                    'Schulte',
                                    'Dietrich',
                                    'Ziegler',
                                    'Kuhn',
                                    'Kühn',
                                    'Pohl',
                                    'Engel',
                                    'Horn',
                                    'Busch',
                                    'Bergmann',
                                    'Thomas',
                                    'Voigt',
                                    'Sauer',
                                    'Arnold',
                                    'Wolff',
                                    'Pfeiffer'
                                ],
                                jp: [
                                    'Sato',
                                    'Suzuki',
                                    'Takahashi',
                                    'Tanaka',
                                    'Watanabe',
                                    'Ito',
                                    'Yamamoto',
                                    'Nakamura',
                                    'Kobayashi',
                                    'Kato',
                                    'Yoshida',
                                    'Yamada',
                                    'Sasaki',
                                    'Yamaguchi',
                                    'Saito',
                                    'Matsumoto',
                                    'Inoue',
                                    'Kimura',
                                    'Hayashi',
                                    'Shimizu',
                                    'Yamazaki',
                                    'Mori',
                                    'Abe',
                                    'Ikeda',
                                    'Hashimoto',
                                    'Yamashita',
                                    'Ishikawa',
                                    'Nakajima',
                                    'Maeda',
                                    'Fujita',
                                    'Ogawa',
                                    'Goto',
                                    'Okada',
                                    'Hasegawa',
                                    'Murakami',
                                    'Kondo',
                                    'Ishii',
                                    'Saito',
                                    'Sakamoto',
                                    'Endo',
                                    'Aoki',
                                    'Fujii',
                                    'Nishimura',
                                    'Fukuda',
                                    'Ota',
                                    'Miura',
                                    'Fujiwara',
                                    'Okamoto',
                                    'Matsuda',
                                    'Nakagawa',
                                    'Nakano',
                                    'Harada',
                                    'Ono',
                                    'Tamura',
                                    'Takeuchi',
                                    'Kaneko',
                                    'Wada',
                                    'Nakayama',
                                    'Ishida',
                                    'Ueda',
                                    'Morita',
                                    'Hara',
                                    'Shibata',
                                    'Sakai',
                                    'Kudo',
                                    'Yokoyama',
                                    'Miyazaki',
                                    'Miyamoto',
                                    'Uchida',
                                    'Takagi',
                                    'Ando',
                                    'Taniguchi',
                                    'Ohno',
                                    'Maruyama',
                                    'Imai',
                                    'Takada',
                                    'Fujimoto',
                                    'Takeda',
                                    'Murata',
                                    'Ueno',
                                    'Sugiyama',
                                    'Masuda',
                                    'Sugawara',
                                    'Hirano',
                                    'Kojima',
                                    'Otsuka',
                                    'Chiba',
                                    'Kubo',
                                    'Matsui',
                                    'Iwasaki',
                                    'Sakurai',
                                    'Kinoshita',
                                    'Noguchi',
                                    'Matsuo',
                                    'Nomura',
                                    'Kikuchi',
                                    'Sano',
                                    'Onishi',
                                    'Sugimoto',
                                    'Arai'
                                ],
                                es: [
                                    'Garcia',
                                    'Fernandez',
                                    'Lopez',
                                    'Martinez',
                                    'Gonzalez',
                                    'Rodriguez',
                                    'Sanchez',
                                    'Perez',
                                    'Martin',
                                    'Gomez',
                                    'Ruiz',
                                    'Diaz',
                                    'Hernandez',
                                    'Alvarez',
                                    'Jimenez',
                                    'Moreno',
                                    'Munoz',
                                    'Alonso',
                                    'Romero',
                                    'Navarro',
                                    'Gutierrez',
                                    'Torres',
                                    'Dominguez',
                                    'Gil',
                                    'Vazquez',
                                    'Blanco',
                                    'Serrano',
                                    'Ramos',
                                    'Castro',
                                    'Suarez',
                                    'Sanz',
                                    'Rubio',
                                    'Ortega',
                                    'Molina',
                                    'Delgado',
                                    'Ortiz',
                                    'Morales',
                                    'Ramirez',
                                    'Marin',
                                    'Iglesias',
                                    'Santos',
                                    'Castillo',
                                    'Garrido',
                                    'Calvo',
                                    'Pena',
                                    'Cruz',
                                    'Cano',
                                    'Nunez',
                                    'Prieto',
                                    'Diez',
                                    'Lozano',
                                    'Vidal',
                                    'Pascual',
                                    'Ferrer',
                                    'Medina',
                                    'Vega',
                                    'Leon',
                                    'Herrero',
                                    'Vicente',
                                    'Mendez',
                                    'Guerrero',
                                    'Fuentes',
                                    'Campos',
                                    'Nieto',
                                    'Cortes',
                                    'Caballero',
                                    'Ibanez',
                                    'Lorenzo',
                                    'Pastor',
                                    'Gimenez',
                                    'Saez',
                                    'Soler',
                                    'Marquez',
                                    'Carrasco',
                                    'Herrera',
                                    'Montero',
                                    'Arias',
                                    'Crespo',
                                    'Flores',
                                    'Andres',
                                    'Aguilar',
                                    'Hidalgo',
                                    'Cabrera',
                                    'Mora',
                                    'Duran',
                                    'Velasco',
                                    'Rey',
                                    'Pardo',
                                    'Roman',
                                    'Vila',
                                    'Bravo',
                                    'Merino',
                                    'Moya',
                                    'Soto',
                                    'Izquierdo',
                                    'Reyes',
                                    'Redondo',
                                    'Marcos',
                                    'Carmona',
                                    'Menendez'
                                ],
                                fr: [
                                    'Martin',
                                    'Bernard',
                                    'Thomas',
                                    'Petit',
                                    'Robert',
                                    'Richard',
                                    'Durand',
                                    'Dubois',
                                    'Moreau',
                                    'Laurent',
                                    'Simon',
                                    'Michel',
                                    'Lefèvre',
                                    'Leroy',
                                    'Roux',
                                    'David',
                                    'Bertrand',
                                    'Morel',
                                    'Fournier',
                                    'Girard',
                                    'Bonnet',
                                    'Dupont',
                                    'Lambert',
                                    'Fontaine',
                                    'Rousseau',
                                    'Vincent',
                                    'Müller',
                                    'Lefèvre',
                                    'Faure',
                                    'André',
                                    'Mercier',
                                    'Blanc',
                                    'Guérin',
                                    'Boyer',
                                    'Garnier',
                                    'Chevalier',
                                    'François',
                                    'Legrand',
                                    'Gauthier',
                                    'Garcia',
                                    'Perrin',
                                    'Robin',
                                    'Clément',
                                    'Morin',
                                    'Nicolas',
                                    'Henry',
                                    'Roussel',
                                    'Matthieu',
                                    'Gautier',
                                    'Masson',
                                    'Marchand',
                                    'Duval',
                                    'Denis',
                                    'Dumont',
                                    'Marie',
                                    'Lemaire',
                                    'Noël',
                                    'Meyer',
                                    'Dufour',
                                    'Meunier',
                                    'Brun',
                                    'Blanchard',
                                    'Giraud',
                                    'Joly',
                                    'Rivière',
                                    'Lucas',
                                    'Brunet',
                                    'Gaillard',
                                    'Barbier',
                                    'Arnaud',
                                    'Martínez',
                                    'Gérard',
                                    'Roche',
                                    'Renard',
                                    'Schmitt',
                                    'Roy',
                                    'Leroux',
                                    'Colin',
                                    'Vidal',
                                    'Caron',
                                    'Picard',
                                    'Roger',
                                    'Fabre',
                                    'Aubert',
                                    'Lemoine',
                                    'Renaud',
                                    'Dumas',
                                    'Lacroix',
                                    'Olivier',
                                    'Philippe',
                                    'Bourgeois',
                                    'Pierre',
                                    'Benoît',
                                    'Rey',
                                    'Leclerc',
                                    'Payet',
                                    'Rolland',
                                    'Leclercq',
                                    'Guillaume',
                                    'Lecomte',
                                    'López',
                                    'Jean',
                                    'Dupuy',
                                    'Guillot',
                                    'Hubert',
                                    'Berger',
                                    'Carpentier',
                                    'Sánchez',
                                    'Dupuis',
                                    'Moulin',
                                    'Louis',
                                    'Deschamps',
                                    'Huet',
                                    'Vasseur',
                                    'Perez',
                                    'Boucher',
                                    'Fleury',
                                    'Royer',
                                    'Klein',
                                    'Jacquet',
                                    'Adam',
                                    'Paris',
                                    'Poirier',
                                    'Marty',
                                    'Aubry',
                                    'Guyot',
                                    'Carré',
                                    'Charles',
                                    'Renault',
                                    'Charpentier',
                                    'Ménard',
                                    'Maillard',
                                    'Baron',
                                    'Bertin',
                                    'Bailly',
                                    'Hervé',
                                    'Schneider',
                                    'Fernández',
                                    'Le GallGall',
                                    'Collet',
                                    'Léger',
                                    'Bouvier',
                                    'Julien',
                                    'Prévost',
                                    'Millet',
                                    'Perrot',
                                    'Daniel',
                                    'Le RouxRoux',
                                    'Cousin',
                                    'Germain',
                                    'Breton',
                                    'Besson',
                                    'Langlois',
                                    'Rémi',
                                    'Le GoffGoff',
                                    'Pelletier',
                                    'Lévêque',
                                    'Perrier',
                                    'Leblanc',
                                    'Barré',
                                    'Lebrun',
                                    'Marchal',
                                    'Weber',
                                    'Mallet',
                                    'Hamon',
                                    'Boulanger',
                                    'Jacob',
                                    'Monnier',
                                    'Michaud',
                                    'Rodríguez',
                                    'Guichard',
                                    'Gillet',
                                    'Étienne',
                                    'Grondin',
                                    'Poulain',
                                    'Tessier',
                                    'Chevallier',
                                    'Collin',
                                    'Chauvin',
                                    'Da SilvaSilva',
                                    'Bouchet',
                                    'Gay',
                                    'Lemaître',
                                    'Bénard',
                                    'Maréchal',
                                    'Humbert',
                                    'Reynaud',
                                    'Antoine',
                                    'Hoarau',
                                    'Perret',
                                    'Barthélemy',
                                    'Cordier',
                                    'Pichon',
                                    'Lejeune',
                                    'Gilbert',
                                    'Lamy',
                                    'Delaunay',
                                    'Pasquier',
                                    'Carlier',
                                    'LaporteLaporte'
                                ]
                            },
                            postcodeAreas: [
                                { code: 'AB' },
                                { code: 'AL' },
                                { code: 'B' },
                                { code: 'BA' },
                                { code: 'BB' },
                                { code: 'BD' },
                                { code: 'BH' },
                                { code: 'BL' },
                                { code: 'BN' },
                                { code: 'BR' },
                                { code: 'BS' },
                                { code: 'BT' },
                                { code: 'CA' },
                                { code: 'CB' },
                                { code: 'CF' },
                                { code: 'CH' },
                                { code: 'CM' },
                                { code: 'CO' },
                                { code: 'CR' },
                                { code: 'CT' },
                                { code: 'CV' },
                                { code: 'CW' },
                                { code: 'DA' },
                                { code: 'DD' },
                                { code: 'DE' },
                                { code: 'DG' },
                                { code: 'DH' },
                                { code: 'DL' },
                                { code: 'DN' },
                                { code: 'DT' },
                                { code: 'DY' },
                                { code: 'E' },
                                { code: 'EC' },
                                { code: 'EH' },
                                { code: 'EN' },
                                { code: 'EX' },
                                { code: 'FK' },
                                { code: 'FY' },
                                { code: 'G' },
                                { code: 'GL' },
                                { code: 'GU' },
                                { code: 'GY' },
                                { code: 'HA' },
                                { code: 'HD' },
                                { code: 'HG' },
                                { code: 'HP' },
                                { code: 'HR' },
                                { code: 'HS' },
                                { code: 'HU' },
                                { code: 'HX' },
                                { code: 'IG' },
                                { code: 'IM' },
                                { code: 'IP' },
                                { code: 'IV' },
                                { code: 'JE' },
                                { code: 'KA' },
                                { code: 'KT' },
                                { code: 'KW' },
                                { code: 'KY' },
                                { code: 'L' },
                                { code: 'LA' },
                                { code: 'LD' },
                                { code: 'LE' },
                                { code: 'LL' },
                                { code: 'LN' },
                                { code: 'LS' },
                                { code: 'LU' },
                                { code: 'M' },
                                { code: 'ME' },
                                { code: 'MK' },
                                { code: 'ML' },
                                { code: 'N' },
                                { code: 'NE' },
                                { code: 'NG' },
                                { code: 'NN' },
                                { code: 'NP' },
                                { code: 'NR' },
                                { code: 'NW' },
                                { code: 'OL' },
                                { code: 'OX' },
                                { code: 'PA' },
                                { code: 'PE' },
                                { code: 'PH' },
                                { code: 'PL' },
                                { code: 'PO' },
                                { code: 'PR' },
                                { code: 'RG' },
                                { code: 'RH' },
                                { code: 'RM' },
                                { code: 'S' },
                                { code: 'SA' },
                                { code: 'SE' },
                                { code: 'SG' },
                                { code: 'SK' },
                                { code: 'SL' },
                                { code: 'SM' },
                                { code: 'SN' },
                                { code: 'SO' },
                                { code: 'SP' },
                                { code: 'SR' },
                                { code: 'SS' },
                                { code: 'ST' },
                                { code: 'SW' },
                                { code: 'SY' },
                                { code: 'TA' },
                                { code: 'TD' },
                                { code: 'TF' },
                                { code: 'TN' },
                                { code: 'TQ' },
                                { code: 'TR' },
                                { code: 'TS' },
                                { code: 'TW' },
                                { code: 'UB' },
                                { code: 'W' },
                                { code: 'WA' },
                                { code: 'WC' },
                                { code: 'WD' },
                                { code: 'WF' },
                                { code: 'WN' },
                                { code: 'WR' },
                                { code: 'WS' },
                                { code: 'WV' },
                                { code: 'YO' },
                                { code: 'ZE' }
                            ],
                            countries: [
                                {
                                    name: 'Afghanistan',
                                    abbreviation: 'AF'
                                },
                                {
                                    name: 'Åland Islands',
                                    abbreviation: 'AX'
                                },
                                {
                                    name: 'Albania',
                                    abbreviation: 'AL'
                                },
                                {
                                    name: 'Algeria',
                                    abbreviation: 'DZ'
                                },
                                {
                                    name: 'American Samoa',
                                    abbreviation: 'AS'
                                },
                                {
                                    name: 'Andorra',
                                    abbreviation: 'AD'
                                },
                                {
                                    name: 'Angola',
                                    abbreviation: 'AO'
                                },
                                {
                                    name: 'Anguilla',
                                    abbreviation: 'AI'
                                },
                                {
                                    name: 'Antarctica',
                                    abbreviation: 'AQ'
                                },
                                {
                                    name: 'Antigua & Barbuda',
                                    abbreviation: 'AG'
                                },
                                {
                                    name: 'Argentina',
                                    abbreviation: 'AR'
                                },
                                {
                                    name: 'Armenia',
                                    abbreviation: 'AM'
                                },
                                {
                                    name: 'Aruba',
                                    abbreviation: 'AW'
                                },
                                {
                                    name: 'Ascension Island',
                                    abbreviation: 'AC'
                                },
                                {
                                    name: 'Australia',
                                    abbreviation: 'AU'
                                },
                                {
                                    name: 'Austria',
                                    abbreviation: 'AT'
                                },
                                {
                                    name: 'Azerbaijan',
                                    abbreviation: 'AZ'
                                },
                                {
                                    name: 'Bahamas',
                                    abbreviation: 'BS'
                                },
                                {
                                    name: 'Bahrain',
                                    abbreviation: 'BH'
                                },
                                {
                                    name: 'Bangladesh',
                                    abbreviation: 'BD'
                                },
                                {
                                    name: 'Barbados',
                                    abbreviation: 'BB'
                                },
                                {
                                    name: 'Belarus',
                                    abbreviation: 'BY'
                                },
                                {
                                    name: 'Belgium',
                                    abbreviation: 'BE'
                                },
                                {
                                    name: 'Belize',
                                    abbreviation: 'BZ'
                                },
                                {
                                    name: 'Benin',
                                    abbreviation: 'BJ'
                                },
                                {
                                    name: 'Bermuda',
                                    abbreviation: 'BM'
                                },
                                {
                                    name: 'Bhutan',
                                    abbreviation: 'BT'
                                },
                                {
                                    name: 'Bolivia',
                                    abbreviation: 'BO'
                                },
                                {
                                    name: 'Bosnia & Herzegovina',
                                    abbreviation: 'BA'
                                },
                                {
                                    name: 'Botswana',
                                    abbreviation: 'BW'
                                },
                                {
                                    name: 'Brazil',
                                    abbreviation: 'BR'
                                },
                                {
                                    name: 'British Indian Ocean Territory',
                                    abbreviation: 'IO'
                                },
                                {
                                    name: 'British Virgin Islands',
                                    abbreviation: 'VG'
                                },
                                {
                                    name: 'Brunei',
                                    abbreviation: 'BN'
                                },
                                {
                                    name: 'Bulgaria',
                                    abbreviation: 'BG'
                                },
                                {
                                    name: 'Burkina Faso',
                                    abbreviation: 'BF'
                                },
                                {
                                    name: 'Burundi',
                                    abbreviation: 'BI'
                                },
                                {
                                    name: 'Cambodia',
                                    abbreviation: 'KH'
                                },
                                {
                                    name: 'Cameroon',
                                    abbreviation: 'CM'
                                },
                                {
                                    name: 'Canada',
                                    abbreviation: 'CA'
                                },
                                {
                                    name: 'Canary Islands',
                                    abbreviation: 'IC'
                                },
                                {
                                    name: 'Cape Verde',
                                    abbreviation: 'CV'
                                },
                                {
                                    name: 'Caribbean Netherlands',
                                    abbreviation: 'BQ'
                                },
                                {
                                    name: 'Cayman Islands',
                                    abbreviation: 'KY'
                                },
                                {
                                    name: 'Central African Republic',
                                    abbreviation: 'CF'
                                },
                                {
                                    name: 'Ceuta & Melilla',
                                    abbreviation: 'EA'
                                },
                                {
                                    name: 'Chad',
                                    abbreviation: 'TD'
                                },
                                {
                                    name: 'Chile',
                                    abbreviation: 'CL'
                                },
                                {
                                    name: 'China',
                                    abbreviation: 'CN'
                                },
                                {
                                    name: 'Christmas Island',
                                    abbreviation: 'CX'
                                },
                                {
                                    name: 'Cocos (Keeling) Islands',
                                    abbreviation: 'CC'
                                },
                                {
                                    name: 'Colombia',
                                    abbreviation: 'CO'
                                },
                                {
                                    name: 'Comoros',
                                    abbreviation: 'KM'
                                },
                                {
                                    name: 'Congo - Brazzaville',
                                    abbreviation: 'CG'
                                },
                                {
                                    name: 'Congo - Kinshasa',
                                    abbreviation: 'CD'
                                },
                                {
                                    name: 'Cook Islands',
                                    abbreviation: 'CK'
                                },
                                {
                                    name: 'Costa Rica',
                                    abbreviation: 'CR'
                                },
                                {
                                    name: 'Côte d\'Ivoire',
                                    abbreviation: 'CI'
                                },
                                {
                                    name: 'Croatia',
                                    abbreviation: 'HR'
                                },
                                {
                                    name: 'Cuba',
                                    abbreviation: 'CU'
                                },
                                {
                                    name: 'Curaçao',
                                    abbreviation: 'CW'
                                },
                                {
                                    name: 'Cyprus',
                                    abbreviation: 'CY'
                                },
                                {
                                    name: 'Czech Republic',
                                    abbreviation: 'CZ'
                                },
                                {
                                    name: 'Denmark',
                                    abbreviation: 'DK'
                                },
                                {
                                    name: 'Diego Garcia',
                                    abbreviation: 'DG'
                                },
                                {
                                    name: 'Djibouti',
                                    abbreviation: 'DJ'
                                },
                                {
                                    name: 'Dominica',
                                    abbreviation: 'DM'
                                },
                                {
                                    name: 'Dominican Republic',
                                    abbreviation: 'DO'
                                },
                                {
                                    name: 'Ecuador',
                                    abbreviation: 'EC'
                                },
                                {
                                    name: 'Egypt',
                                    abbreviation: 'EG'
                                },
                                {
                                    name: 'El Salvador',
                                    abbreviation: 'SV'
                                },
                                {
                                    name: 'Equatorial Guinea',
                                    abbreviation: 'GQ'
                                },
                                {
                                    name: 'Eritrea',
                                    abbreviation: 'ER'
                                },
                                {
                                    name: 'Estonia',
                                    abbreviation: 'EE'
                                },
                                {
                                    name: 'Ethiopia',
                                    abbreviation: 'ET'
                                },
                                {
                                    name: 'Falkland Islands',
                                    abbreviation: 'FK'
                                },
                                {
                                    name: 'Faroe Islands',
                                    abbreviation: 'FO'
                                },
                                {
                                    name: 'Fiji',
                                    abbreviation: 'FJ'
                                },
                                {
                                    name: 'Finland',
                                    abbreviation: 'FI'
                                },
                                {
                                    name: 'France',
                                    abbreviation: 'FR'
                                },
                                {
                                    name: 'French Guiana',
                                    abbreviation: 'GF'
                                },
                                {
                                    name: 'French Polynesia',
                                    abbreviation: 'PF'
                                },
                                {
                                    name: 'French Southern Territories',
                                    abbreviation: 'TF'
                                },
                                {
                                    name: 'Gabon',
                                    abbreviation: 'GA'
                                },
                                {
                                    name: 'Gambia',
                                    abbreviation: 'GM'
                                },
                                {
                                    name: 'Georgia',
                                    abbreviation: 'GE'
                                },
                                {
                                    name: 'Germany',
                                    abbreviation: 'DE'
                                },
                                {
                                    name: 'Ghana',
                                    abbreviation: 'GH'
                                },
                                {
                                    name: 'Gibraltar',
                                    abbreviation: 'GI'
                                },
                                {
                                    name: 'Greece',
                                    abbreviation: 'GR'
                                },
                                {
                                    name: 'Greenland',
                                    abbreviation: 'GL'
                                },
                                {
                                    name: 'Grenada',
                                    abbreviation: 'GD'
                                },
                                {
                                    name: 'Guadeloupe',
                                    abbreviation: 'GP'
                                },
                                {
                                    name: 'Guam',
                                    abbreviation: 'GU'
                                },
                                {
                                    name: 'Guatemala',
                                    abbreviation: 'GT'
                                },
                                {
                                    name: 'Guernsey',
                                    abbreviation: 'GG'
                                },
                                {
                                    name: 'Guinea',
                                    abbreviation: 'GN'
                                },
                                {
                                    name: 'Guinea-Bissau',
                                    abbreviation: 'GW'
                                },
                                {
                                    name: 'Guyana',
                                    abbreviation: 'GY'
                                },
                                {
                                    name: 'Haiti',
                                    abbreviation: 'HT'
                                },
                                {
                                    name: 'Honduras',
                                    abbreviation: 'HN'
                                },
                                {
                                    name: 'Hong Kong SAR China',
                                    abbreviation: 'HK'
                                },
                                {
                                    name: 'Hungary',
                                    abbreviation: 'HU'
                                },
                                {
                                    name: 'Iceland',
                                    abbreviation: 'IS'
                                },
                                {
                                    name: 'India',
                                    abbreviation: 'IN'
                                },
                                {
                                    name: 'Indonesia',
                                    abbreviation: 'ID'
                                },
                                {
                                    name: 'Iran',
                                    abbreviation: 'IR'
                                },
                                {
                                    name: 'Iraq',
                                    abbreviation: 'IQ'
                                },
                                {
                                    name: 'Ireland',
                                    abbreviation: 'IE'
                                },
                                {
                                    name: 'Isle of Man',
                                    abbreviation: 'IM'
                                },
                                {
                                    name: 'Israel',
                                    abbreviation: 'IL'
                                },
                                {
                                    name: 'Italy',
                                    abbreviation: 'IT'
                                },
                                {
                                    name: 'Jamaica',
                                    abbreviation: 'JM'
                                },
                                {
                                    name: 'Japan',
                                    abbreviation: 'JP'
                                },
                                {
                                    name: 'Jersey',
                                    abbreviation: 'JE'
                                },
                                {
                                    name: 'Jordan',
                                    abbreviation: 'JO'
                                },
                                {
                                    name: 'Kazakhstan',
                                    abbreviation: 'KZ'
                                },
                                {
                                    name: 'Kenya',
                                    abbreviation: 'KE'
                                },
                                {
                                    name: 'Kiribati',
                                    abbreviation: 'KI'
                                },
                                {
                                    name: 'Kosovo',
                                    abbreviation: 'XK'
                                },
                                {
                                    name: 'Kuwait',
                                    abbreviation: 'KW'
                                },
                                {
                                    name: 'Kyrgyzstan',
                                    abbreviation: 'KG'
                                },
                                {
                                    name: 'Laos',
                                    abbreviation: 'LA'
                                },
                                {
                                    name: 'Latvia',
                                    abbreviation: 'LV'
                                },
                                {
                                    name: 'Lebanon',
                                    abbreviation: 'LB'
                                },
                                {
                                    name: 'Lesotho',
                                    abbreviation: 'LS'
                                },
                                {
                                    name: 'Liberia',
                                    abbreviation: 'LR'
                                },
                                {
                                    name: 'Libya',
                                    abbreviation: 'LY'
                                },
                                {
                                    name: 'Liechtenstein',
                                    abbreviation: 'LI'
                                },
                                {
                                    name: 'Lithuania',
                                    abbreviation: 'LT'
                                },
                                {
                                    name: 'Luxembourg',
                                    abbreviation: 'LU'
                                },
                                {
                                    name: 'Macau SAR China',
                                    abbreviation: 'MO'
                                },
                                {
                                    name: 'Macedonia',
                                    abbreviation: 'MK'
                                },
                                {
                                    name: 'Madagascar',
                                    abbreviation: 'MG'
                                },
                                {
                                    name: 'Malawi',
                                    abbreviation: 'MW'
                                },
                                {
                                    name: 'Malaysia',
                                    abbreviation: 'MY'
                                },
                                {
                                    name: 'Maldives',
                                    abbreviation: 'MV'
                                },
                                {
                                    name: 'Mali',
                                    abbreviation: 'ML'
                                },
                                {
                                    name: 'Malta',
                                    abbreviation: 'MT'
                                },
                                {
                                    name: 'Marshall Islands',
                                    abbreviation: 'MH'
                                },
                                {
                                    name: 'Martinique',
                                    abbreviation: 'MQ'
                                },
                                {
                                    name: 'Mauritania',
                                    abbreviation: 'MR'
                                },
                                {
                                    name: 'Mauritius',
                                    abbreviation: 'MU'
                                },
                                {
                                    name: 'Mayotte',
                                    abbreviation: 'YT'
                                },
                                {
                                    name: 'Mexico',
                                    abbreviation: 'MX'
                                },
                                {
                                    name: 'Micronesia',
                                    abbreviation: 'FM'
                                },
                                {
                                    name: 'Moldova',
                                    abbreviation: 'MD'
                                },
                                {
                                    name: 'Monaco',
                                    abbreviation: 'MC'
                                },
                                {
                                    name: 'Mongolia',
                                    abbreviation: 'MN'
                                },
                                {
                                    name: 'Montenegro',
                                    abbreviation: 'ME'
                                },
                                {
                                    name: 'Montserrat',
                                    abbreviation: 'MS'
                                },
                                {
                                    name: 'Morocco',
                                    abbreviation: 'MA'
                                },
                                {
                                    name: 'Mozambique',
                                    abbreviation: 'MZ'
                                },
                                {
                                    name: 'Myanmar (Burma)',
                                    abbreviation: 'MM'
                                },
                                {
                                    name: 'Namibia',
                                    abbreviation: 'NA'
                                },
                                {
                                    name: 'Nauru',
                                    abbreviation: 'NR'
                                },
                                {
                                    name: 'Nepal',
                                    abbreviation: 'NP'
                                },
                                {
                                    name: 'Netherlands',
                                    abbreviation: 'NL'
                                },
                                {
                                    name: 'New Caledonia',
                                    abbreviation: 'NC'
                                },
                                {
                                    name: 'New Zealand',
                                    abbreviation: 'NZ'
                                },
                                {
                                    name: 'Nicaragua',
                                    abbreviation: 'NI'
                                },
                                {
                                    name: 'Niger',
                                    abbreviation: 'NE'
                                },
                                {
                                    name: 'Nigeria',
                                    abbreviation: 'NG'
                                },
                                {
                                    name: 'Niue',
                                    abbreviation: 'NU'
                                },
                                {
                                    name: 'Norfolk Island',
                                    abbreviation: 'NF'
                                },
                                {
                                    name: 'North Korea',
                                    abbreviation: 'KP'
                                },
                                {
                                    name: 'Northern Mariana Islands',
                                    abbreviation: 'MP'
                                },
                                {
                                    name: 'Norway',
                                    abbreviation: 'NO'
                                },
                                {
                                    name: 'Oman',
                                    abbreviation: 'OM'
                                },
                                {
                                    name: 'Pakistan',
                                    abbreviation: 'PK'
                                },
                                {
                                    name: 'Palau',
                                    abbreviation: 'PW'
                                },
                                {
                                    name: 'Palestinian Territories',
                                    abbreviation: 'PS'
                                },
                                {
                                    name: 'Panama',
                                    abbreviation: 'PA'
                                },
                                {
                                    name: 'Papua New Guinea',
                                    abbreviation: 'PG'
                                },
                                {
                                    name: 'Paraguay',
                                    abbreviation: 'PY'
                                },
                                {
                                    name: 'Peru',
                                    abbreviation: 'PE'
                                },
                                {
                                    name: 'Philippines',
                                    abbreviation: 'PH'
                                },
                                {
                                    name: 'Pitcairn Islands',
                                    abbreviation: 'PN'
                                },
                                {
                                    name: 'Poland',
                                    abbreviation: 'PL'
                                },
                                {
                                    name: 'Portugal',
                                    abbreviation: 'PT'
                                },
                                {
                                    name: 'Puerto Rico',
                                    abbreviation: 'PR'
                                },
                                {
                                    name: 'Qatar',
                                    abbreviation: 'QA'
                                },
                                {
                                    name: 'Réunion',
                                    abbreviation: 'RE'
                                },
                                {
                                    name: 'Romania',
                                    abbreviation: 'RO'
                                },
                                {
                                    name: 'Russia',
                                    abbreviation: 'RU'
                                },
                                {
                                    name: 'Rwanda',
                                    abbreviation: 'RW'
                                },
                                {
                                    name: 'Samoa',
                                    abbreviation: 'WS'
                                },
                                {
                                    name: 'San Marino',
                                    abbreviation: 'SM'
                                },
                                {
                                    name: 'São Tomé and Príncipe',
                                    abbreviation: 'ST'
                                },
                                {
                                    name: 'Saudi Arabia',
                                    abbreviation: 'SA'
                                },
                                {
                                    name: 'Senegal',
                                    abbreviation: 'SN'
                                },
                                {
                                    name: 'Serbia',
                                    abbreviation: 'RS'
                                },
                                {
                                    name: 'Seychelles',
                                    abbreviation: 'SC'
                                },
                                {
                                    name: 'Sierra Leone',
                                    abbreviation: 'SL'
                                },
                                {
                                    name: 'Singapore',
                                    abbreviation: 'SG'
                                },
                                {
                                    name: 'Sint Maarten',
                                    abbreviation: 'SX'
                                },
                                {
                                    name: 'Slovakia',
                                    abbreviation: 'SK'
                                },
                                {
                                    name: 'Slovenia',
                                    abbreviation: 'SI'
                                },
                                {
                                    name: 'Solomon Islands',
                                    abbreviation: 'SB'
                                },
                                {
                                    name: 'Somalia',
                                    abbreviation: 'SO'
                                },
                                {
                                    name: 'South Africa',
                                    abbreviation: 'ZA'
                                },
                                {
                                    name: 'South Georgia & South Sandwich Islands',
                                    abbreviation: 'GS'
                                },
                                {
                                    name: 'South Korea',
                                    abbreviation: 'KR'
                                },
                                {
                                    name: 'South Sudan',
                                    abbreviation: 'SS'
                                },
                                {
                                    name: 'Spain',
                                    abbreviation: 'ES'
                                },
                                {
                                    name: 'Sri Lanka',
                                    abbreviation: 'LK'
                                },
                                {
                                    name: 'St. Barthélemy',
                                    abbreviation: 'BL'
                                },
                                {
                                    name: 'St. Helena',
                                    abbreviation: 'SH'
                                },
                                {
                                    name: 'St. Kitts & Nevis',
                                    abbreviation: 'KN'
                                },
                                {
                                    name: 'St. Lucia',
                                    abbreviation: 'LC'
                                },
                                {
                                    name: 'St. Martin',
                                    abbreviation: 'MF'
                                },
                                {
                                    name: 'St. Pierre & Miquelon',
                                    abbreviation: 'PM'
                                },
                                {
                                    name: 'St. Vincent & Grenadines',
                                    abbreviation: 'VC'
                                },
                                {
                                    name: 'Sudan',
                                    abbreviation: 'SD'
                                },
                                {
                                    name: 'Suriname',
                                    abbreviation: 'SR'
                                },
                                {
                                    name: 'Svalbard & Jan Mayen',
                                    abbreviation: 'SJ'
                                },
                                {
                                    name: 'Swaziland',
                                    abbreviation: 'SZ'
                                },
                                {
                                    name: 'Sweden',
                                    abbreviation: 'SE'
                                },
                                {
                                    name: 'Switzerland',
                                    abbreviation: 'CH'
                                },
                                {
                                    name: 'Syria',
                                    abbreviation: 'SY'
                                },
                                {
                                    name: 'Taiwan',
                                    abbreviation: 'TW'
                                },
                                {
                                    name: 'Tajikistan',
                                    abbreviation: 'TJ'
                                },
                                {
                                    name: 'Tanzania',
                                    abbreviation: 'TZ'
                                },
                                {
                                    name: 'Thailand',
                                    abbreviation: 'TH'
                                },
                                {
                                    name: 'Timor-Leste',
                                    abbreviation: 'TL'
                                },
                                {
                                    name: 'Togo',
                                    abbreviation: 'TG'
                                },
                                {
                                    name: 'Tokelau',
                                    abbreviation: 'TK'
                                },
                                {
                                    name: 'Tonga',
                                    abbreviation: 'TO'
                                },
                                {
                                    name: 'Trinidad & Tobago',
                                    abbreviation: 'TT'
                                },
                                {
                                    name: 'Tristan da Cunha',
                                    abbreviation: 'TA'
                                },
                                {
                                    name: 'Tunisia',
                                    abbreviation: 'TN'
                                },
                                {
                                    name: 'Turkey',
                                    abbreviation: 'TR'
                                },
                                {
                                    name: 'Turkmenistan',
                                    abbreviation: 'TM'
                                },
                                {
                                    name: 'Turks & Caicos Islands',
                                    abbreviation: 'TC'
                                },
                                {
                                    name: 'Tuvalu',
                                    abbreviation: 'TV'
                                },
                                {
                                    name: 'U.S. Outlying Islands',
                                    abbreviation: 'UM'
                                },
                                {
                                    name: 'U.S. Virgin Islands',
                                    abbreviation: 'VI'
                                },
                                {
                                    name: 'Uganda',
                                    abbreviation: 'UG'
                                },
                                {
                                    name: 'Ukraine',
                                    abbreviation: 'UA'
                                },
                                {
                                    name: 'United Arab Emirates',
                                    abbreviation: 'AE'
                                },
                                {
                                    name: 'United Kingdom',
                                    abbreviation: 'GB'
                                },
                                {
                                    name: 'United States',
                                    abbreviation: 'US'
                                },
                                {
                                    name: 'Uruguay',
                                    abbreviation: 'UY'
                                },
                                {
                                    name: 'Uzbekistan',
                                    abbreviation: 'UZ'
                                },
                                {
                                    name: 'Vanuatu',
                                    abbreviation: 'VU'
                                },
                                {
                                    name: 'Vatican City',
                                    abbreviation: 'VA'
                                },
                                {
                                    name: 'Venezuela',
                                    abbreviation: 'VE'
                                },
                                {
                                    name: 'Vietnam',
                                    abbreviation: 'VN'
                                },
                                {
                                    name: 'Wallis & Futuna',
                                    abbreviation: 'WF'
                                },
                                {
                                    name: 'Western Sahara',
                                    abbreviation: 'EH'
                                },
                                {
                                    name: 'Yemen',
                                    abbreviation: 'YE'
                                },
                                {
                                    name: 'Zambia',
                                    abbreviation: 'ZM'
                                },
                                {
                                    name: 'Zimbabwe',
                                    abbreviation: 'ZW'
                                }
                            ],
                            counties: {
                                uk: [
                                    { name: 'Bath and North East Somerset' },
                                    { name: 'Aberdeenshire' },
                                    { name: 'Anglesey' },
                                    { name: 'Angus' },
                                    { name: 'Bedford' },
                                    { name: 'Blackburn with Darwen' },
                                    { name: 'Blackpool' },
                                    { name: 'Bournemouth' },
                                    { name: 'Bracknell Forest' },
                                    { name: 'Brighton & Hove' },
                                    { name: 'Bristol' },
                                    { name: 'Buckinghamshire' },
                                    { name: 'Cambridgeshire' },
                                    { name: 'Carmarthenshire' },
                                    { name: 'Central Bedfordshire' },
                                    { name: 'Ceredigion' },
                                    { name: 'Cheshire East' },
                                    { name: 'Cheshire West and Chester' },
                                    { name: 'Clackmannanshire' },
                                    { name: 'Conwy' },
                                    { name: 'Cornwall' },
                                    { name: 'County Antrim' },
                                    { name: 'County Armagh' },
                                    { name: 'County Down' },
                                    { name: 'County Durham' },
                                    { name: 'County Fermanagh' },
                                    { name: 'County Londonderry' },
                                    { name: 'County Tyrone' },
                                    { name: 'Cumbria' },
                                    { name: 'Darlington' },
                                    { name: 'Denbighshire' },
                                    { name: 'Derby' },
                                    { name: 'Derbyshire' },
                                    { name: 'Devon' },
                                    { name: 'Dorset' },
                                    { name: 'Dumfries and Galloway' },
                                    { name: 'Dundee' },
                                    { name: 'East Lothian' },
                                    { name: 'East Riding of Yorkshire' },
                                    { name: 'East Sussex' },
                                    { name: 'Edinburgh?' },
                                    { name: 'Essex' },
                                    { name: 'Falkirk' },
                                    { name: 'Fife' },
                                    { name: 'Flintshire' },
                                    { name: 'Gloucestershire' },
                                    { name: 'Greater London' },
                                    { name: 'Greater Manchester' },
                                    { name: 'Gwent' },
                                    { name: 'Gwynedd' },
                                    { name: 'Halton' },
                                    { name: 'Hampshire' },
                                    { name: 'Hartlepool' },
                                    { name: 'Herefordshire' },
                                    { name: 'Hertfordshire' },
                                    { name: 'Highlands' },
                                    { name: 'Hull' },
                                    { name: 'Isle of Wight' },
                                    { name: 'Isles of Scilly' },
                                    { name: 'Kent' },
                                    { name: 'Lancashire' },
                                    { name: 'Leicester' },
                                    { name: 'Leicestershire' },
                                    { name: 'Lincolnshire' },
                                    { name: 'Lothian' },
                                    { name: 'Luton' },
                                    { name: 'Medway' },
                                    { name: 'Merseyside' },
                                    { name: 'Mid Glamorgan' },
                                    { name: 'Middlesbrough' },
                                    { name: 'Milton Keynes' },
                                    { name: 'Monmouthshire' },
                                    { name: 'Moray' },
                                    { name: 'Norfolk' },
                                    { name: 'North East Lincolnshire' },
                                    { name: 'North Lincolnshire' },
                                    { name: 'North Somerset' },
                                    { name: 'North Yorkshire' },
                                    { name: 'Northamptonshire' },
                                    { name: 'Northumberland' },
                                    { name: 'Nottingham' },
                                    { name: 'Nottinghamshire' },
                                    { name: 'Oxfordshire' },
                                    { name: 'Pembrokeshire' },
                                    { name: 'Perth and Kinross' },
                                    { name: 'Peterborough' },
                                    { name: 'Plymouth' },
                                    { name: 'Poole' },
                                    { name: 'Portsmouth' },
                                    { name: 'Powys' },
                                    { name: 'Reading' },
                                    { name: 'Redcar and Cleveland' },
                                    { name: 'Rutland' },
                                    { name: 'Scottish Borders' },
                                    { name: 'Shropshire' },
                                    { name: 'Slough' },
                                    { name: 'Somerset' },
                                    { name: 'South Glamorgan' },
                                    { name: 'South Gloucestershire' },
                                    { name: 'South Yorkshire' },
                                    { name: 'Southampton' },
                                    { name: 'Southend-on-Sea' },
                                    { name: 'Staffordshire' },
                                    { name: 'Stirlingshire' },
                                    { name: 'Stockton-on-Tees' },
                                    { name: 'Stoke-on-Trent' },
                                    { name: 'Strathclyde' },
                                    { name: 'Suffolk' },
                                    { name: 'Surrey' },
                                    { name: 'Swindon' },
                                    { name: 'Telford and Wrekin' },
                                    { name: 'Thurrock' },
                                    { name: 'Torbay' },
                                    { name: 'Tyne and Wear' },
                                    { name: 'Warrington' },
                                    { name: 'Warwickshire' },
                                    { name: 'West Berkshire' },
                                    { name: 'West Glamorgan' },
                                    { name: 'West Lothian' },
                                    { name: 'West Midlands' },
                                    { name: 'West Sussex' },
                                    { name: 'West Yorkshire' },
                                    { name: 'Western Isles' },
                                    { name: 'Wiltshire' },
                                    { name: 'Windsor and Maidenhead' },
                                    { name: 'Wokingham' },
                                    { name: 'Worcestershire' },
                                    { name: 'Wrexham' },
                                    { name: 'York' }
                                ]
                            },
                            provinces: {
                                ca: [
                                    {
                                        name: 'Alberta',
                                        abbreviation: 'AB'
                                    },
                                    {
                                        name: 'British Columbia',
                                        abbreviation: 'BC'
                                    },
                                    {
                                        name: 'Manitoba',
                                        abbreviation: 'MB'
                                    },
                                    {
                                        name: 'New Brunswick',
                                        abbreviation: 'NB'
                                    },
                                    {
                                        name: 'Newfoundland and Labrador',
                                        abbreviation: 'NL'
                                    },
                                    {
                                        name: 'Nova Scotia',
                                        abbreviation: 'NS'
                                    },
                                    {
                                        name: 'Ontario',
                                        abbreviation: 'ON'
                                    },
                                    {
                                        name: 'Prince Edward Island',
                                        abbreviation: 'PE'
                                    },
                                    {
                                        name: 'Quebec',
                                        abbreviation: 'QC'
                                    },
                                    {
                                        name: 'Saskatchewan',
                                        abbreviation: 'SK'
                                    },
                                    {
                                        name: 'Northwest Territories',
                                        abbreviation: 'NT'
                                    },
                                    {
                                        name: 'Nunavut',
                                        abbreviation: 'NU'
                                    },
                                    {
                                        name: 'Yukon',
                                        abbreviation: 'YT'
                                    }
                                ],
                                it: [
                                    {
                                        name: 'Agrigento',
                                        abbreviation: 'AG',
                                        code: 84
                                    },
                                    {
                                        name: 'Alessandria',
                                        abbreviation: 'AL',
                                        code: 6
                                    },
                                    {
                                        name: 'Ancona',
                                        abbreviation: 'AN',
                                        code: 42
                                    },
                                    {
                                        name: 'Aosta',
                                        abbreviation: 'AO',
                                        code: 7
                                    },
                                    {
                                        name: 'L\'Aquila',
                                        abbreviation: 'AQ',
                                        code: 66
                                    },
                                    {
                                        name: 'Arezzo',
                                        abbreviation: 'AR',
                                        code: 51
                                    },
                                    {
                                        name: 'Ascoli-Piceno',
                                        abbreviation: 'AP',
                                        code: 44
                                    },
                                    {
                                        name: 'Asti',
                                        abbreviation: 'AT',
                                        code: 5
                                    },
                                    {
                                        name: 'Avellino',
                                        abbreviation: 'AV',
                                        code: 64
                                    },
                                    {
                                        name: 'Bari',
                                        abbreviation: 'BA',
                                        code: 72
                                    },
                                    {
                                        name: 'Barletta-Andria-Trani',
                                        abbreviation: 'BT',
                                        code: 72
                                    },
                                    {
                                        name: 'Belluno',
                                        abbreviation: 'BL',
                                        code: 25
                                    },
                                    {
                                        name: 'Benevento',
                                        abbreviation: 'BN',
                                        code: 62
                                    },
                                    {
                                        name: 'Bergamo',
                                        abbreviation: 'BG',
                                        code: 16
                                    },
                                    {
                                        name: 'Biella',
                                        abbreviation: 'BI',
                                        code: 96
                                    },
                                    {
                                        name: 'Bologna',
                                        abbreviation: 'BO',
                                        code: 37
                                    },
                                    {
                                        name: 'Bolzano',
                                        abbreviation: 'BZ',
                                        code: 21
                                    },
                                    {
                                        name: 'Brescia',
                                        abbreviation: 'BS',
                                        code: 17
                                    },
                                    {
                                        name: 'Brindisi',
                                        abbreviation: 'BR',
                                        code: 74
                                    },
                                    {
                                        name: 'Cagliari',
                                        abbreviation: 'CA',
                                        code: 92
                                    },
                                    {
                                        name: 'Caltanissetta',
                                        abbreviation: 'CL',
                                        code: 85
                                    },
                                    {
                                        name: 'Campobasso',
                                        abbreviation: 'CB',
                                        code: 70
                                    },
                                    {
                                        name: 'Carbonia Iglesias',
                                        abbreviation: 'CI',
                                        code: 70
                                    },
                                    {
                                        name: 'Caserta',
                                        abbreviation: 'CE',
                                        code: 61
                                    },
                                    {
                                        name: 'Catania',
                                        abbreviation: 'CT',
                                        code: 87
                                    },
                                    {
                                        name: 'Catanzaro',
                                        abbreviation: 'CZ',
                                        code: 79
                                    },
                                    {
                                        name: 'Chieti',
                                        abbreviation: 'CH',
                                        code: 69
                                    },
                                    {
                                        name: 'Como',
                                        abbreviation: 'CO',
                                        code: 13
                                    },
                                    {
                                        name: 'Cosenza',
                                        abbreviation: 'CS',
                                        code: 78
                                    },
                                    {
                                        name: 'Cremona',
                                        abbreviation: 'CR',
                                        code: 19
                                    },
                                    {
                                        name: 'Crotone',
                                        abbreviation: 'KR',
                                        code: 101
                                    },
                                    {
                                        name: 'Cuneo',
                                        abbreviation: 'CN',
                                        code: 4
                                    },
                                    {
                                        name: 'Enna',
                                        abbreviation: 'EN',
                                        code: 86
                                    },
                                    {
                                        name: 'Fermo',
                                        abbreviation: 'FM',
                                        code: 86
                                    },
                                    {
                                        name: 'Ferrara',
                                        abbreviation: 'FE',
                                        code: 38
                                    },
                                    {
                                        name: 'Firenze',
                                        abbreviation: 'FI',
                                        code: 48
                                    },
                                    {
                                        name: 'Foggia',
                                        abbreviation: 'FG',
                                        code: 71
                                    },
                                    {
                                        name: 'Forli-Cesena',
                                        abbreviation: 'FC',
                                        code: 71
                                    },
                                    {
                                        name: 'Frosinone',
                                        abbreviation: 'FR',
                                        code: 60
                                    },
                                    {
                                        name: 'Genova',
                                        abbreviation: 'GE',
                                        code: 10
                                    },
                                    {
                                        name: 'Gorizia',
                                        abbreviation: 'GO',
                                        code: 31
                                    },
                                    {
                                        name: 'Grosseto',
                                        abbreviation: 'GR',
                                        code: 53
                                    },
                                    {
                                        name: 'Imperia',
                                        abbreviation: 'IM',
                                        code: 8
                                    },
                                    {
                                        name: 'Isernia',
                                        abbreviation: 'IS',
                                        code: 94
                                    },
                                    {
                                        name: 'La-Spezia',
                                        abbreviation: 'SP',
                                        code: 66
                                    },
                                    {
                                        name: 'Latina',
                                        abbreviation: 'LT',
                                        code: 59
                                    },
                                    {
                                        name: 'Lecce',
                                        abbreviation: 'LE',
                                        code: 75
                                    },
                                    {
                                        name: 'Lecco',
                                        abbreviation: 'LC',
                                        code: 97
                                    },
                                    {
                                        name: 'Livorno',
                                        abbreviation: 'LI',
                                        code: 49
                                    },
                                    {
                                        name: 'Lodi',
                                        abbreviation: 'LO',
                                        code: 98
                                    },
                                    {
                                        name: 'Lucca',
                                        abbreviation: 'LU',
                                        code: 46
                                    },
                                    {
                                        name: 'Macerata',
                                        abbreviation: 'MC',
                                        code: 43
                                    },
                                    {
                                        name: 'Mantova',
                                        abbreviation: 'MN',
                                        code: 20
                                    },
                                    {
                                        name: 'Massa-Carrara',
                                        abbreviation: 'MS',
                                        code: 45
                                    },
                                    {
                                        name: 'Matera',
                                        abbreviation: 'MT',
                                        code: 77
                                    },
                                    {
                                        name: 'Medio Campidano',
                                        abbreviation: 'VS',
                                        code: 77
                                    },
                                    {
                                        name: 'Messina',
                                        abbreviation: 'ME',
                                        code: 83
                                    },
                                    {
                                        name: 'Milano',
                                        abbreviation: 'MI',
                                        code: 15
                                    },
                                    {
                                        name: 'Modena',
                                        abbreviation: 'MO',
                                        code: 36
                                    },
                                    {
                                        name: 'Monza-Brianza',
                                        abbreviation: 'MB',
                                        code: 36
                                    },
                                    {
                                        name: 'Napoli',
                                        abbreviation: 'NA',
                                        code: 63
                                    },
                                    {
                                        name: 'Novara',
                                        abbreviation: 'NO',
                                        code: 3
                                    },
                                    {
                                        name: 'Nuoro',
                                        abbreviation: 'NU',
                                        code: 91
                                    },
                                    {
                                        name: 'Ogliastra',
                                        abbreviation: 'OG',
                                        code: 91
                                    },
                                    {
                                        name: 'Olbia Tempio',
                                        abbreviation: 'OT',
                                        code: 91
                                    },
                                    {
                                        name: 'Oristano',
                                        abbreviation: 'OR',
                                        code: 95
                                    },
                                    {
                                        name: 'Padova',
                                        abbreviation: 'PD',
                                        code: 28
                                    },
                                    {
                                        name: 'Palermo',
                                        abbreviation: 'PA',
                                        code: 82
                                    },
                                    {
                                        name: 'Parma',
                                        abbreviation: 'PR',
                                        code: 34
                                    },
                                    {
                                        name: 'Pavia',
                                        abbreviation: 'PV',
                                        code: 18
                                    },
                                    {
                                        name: 'Perugia',
                                        abbreviation: 'PG',
                                        code: 54
                                    },
                                    {
                                        name: 'Pesaro-Urbino',
                                        abbreviation: 'PU',
                                        code: 41
                                    },
                                    {
                                        name: 'Pescara',
                                        abbreviation: 'PE',
                                        code: 68
                                    },
                                    {
                                        name: 'Piacenza',
                                        abbreviation: 'PC',
                                        code: 33
                                    },
                                    {
                                        name: 'Pisa',
                                        abbreviation: 'PI',
                                        code: 50
                                    },
                                    {
                                        name: 'Pistoia',
                                        abbreviation: 'PT',
                                        code: 47
                                    },
                                    {
                                        name: 'Pordenone',
                                        abbreviation: 'PN',
                                        code: 93
                                    },
                                    {
                                        name: 'Potenza',
                                        abbreviation: 'PZ',
                                        code: 76
                                    },
                                    {
                                        name: 'Prato',
                                        abbreviation: 'PO',
                                        code: 100
                                    },
                                    {
                                        name: 'Ragusa',
                                        abbreviation: 'RG',
                                        code: 88
                                    },
                                    {
                                        name: 'Ravenna',
                                        abbreviation: 'RA',
                                        code: 39
                                    },
                                    {
                                        name: 'Reggio-Calabria',
                                        abbreviation: 'RC',
                                        code: 35
                                    },
                                    {
                                        name: 'Reggio-Emilia',
                                        abbreviation: 'RE',
                                        code: 35
                                    },
                                    {
                                        name: 'Rieti',
                                        abbreviation: 'RI',
                                        code: 57
                                    },
                                    {
                                        name: 'Rimini',
                                        abbreviation: 'RN',
                                        code: 99
                                    },
                                    {
                                        name: 'Roma',
                                        abbreviation: 'Roma',
                                        code: 58
                                    },
                                    {
                                        name: 'Rovigo',
                                        abbreviation: 'RO',
                                        code: 29
                                    },
                                    {
                                        name: 'Salerno',
                                        abbreviation: 'SA',
                                        code: 65
                                    },
                                    {
                                        name: 'Sassari',
                                        abbreviation: 'SS',
                                        code: 90
                                    },
                                    {
                                        name: 'Savona',
                                        abbreviation: 'SV',
                                        code: 9
                                    },
                                    {
                                        name: 'Siena',
                                        abbreviation: 'SI',
                                        code: 52
                                    },
                                    {
                                        name: 'Siracusa',
                                        abbreviation: 'SR',
                                        code: 89
                                    },
                                    {
                                        name: 'Sondrio',
                                        abbreviation: 'SO',
                                        code: 14
                                    },
                                    {
                                        name: 'Taranto',
                                        abbreviation: 'TA',
                                        code: 73
                                    },
                                    {
                                        name: 'Teramo',
                                        abbreviation: 'TE',
                                        code: 67
                                    },
                                    {
                                        name: 'Terni',
                                        abbreviation: 'TR',
                                        code: 55
                                    },
                                    {
                                        name: 'Torino',
                                        abbreviation: 'TO',
                                        code: 1
                                    },
                                    {
                                        name: 'Trapani',
                                        abbreviation: 'TP',
                                        code: 81
                                    },
                                    {
                                        name: 'Trento',
                                        abbreviation: 'TN',
                                        code: 22
                                    },
                                    {
                                        name: 'Treviso',
                                        abbreviation: 'TV',
                                        code: 26
                                    },
                                    {
                                        name: 'Trieste',
                                        abbreviation: 'TS',
                                        code: 32
                                    },
                                    {
                                        name: 'Udine',
                                        abbreviation: 'UD',
                                        code: 30
                                    },
                                    {
                                        name: 'Varese',
                                        abbreviation: 'VA',
                                        code: 12
                                    },
                                    {
                                        name: 'Venezia',
                                        abbreviation: 'VE',
                                        code: 27
                                    },
                                    {
                                        name: 'Verbania',
                                        abbreviation: 'VB',
                                        code: 27
                                    },
                                    {
                                        name: 'Vercelli',
                                        abbreviation: 'VC',
                                        code: 2
                                    },
                                    {
                                        name: 'Verona',
                                        abbreviation: 'VR',
                                        code: 23
                                    },
                                    {
                                        name: 'Vibo-Valentia',
                                        abbreviation: 'VV',
                                        code: 102
                                    },
                                    {
                                        name: 'Vicenza',
                                        abbreviation: 'VI',
                                        code: 24
                                    },
                                    {
                                        name: 'Viterbo',
                                        abbreviation: 'VT',
                                        code: 56
                                    }
                                ]
                            },
                            nationalities: [
                                { name: 'Afghan' },
                                { name: 'Albanian' },
                                { name: 'Algerian' },
                                { name: 'American' },
                                { name: 'Andorran' },
                                { name: 'Angolan' },
                                { name: 'Antiguans' },
                                { name: 'Argentinean' },
                                { name: 'Armenian' },
                                { name: 'Australian' },
                                { name: 'Austrian' },
                                { name: 'Azerbaijani' },
                                { name: 'Bahami' },
                                { name: 'Bahraini' },
                                { name: 'Bangladeshi' },
                                { name: 'Barbadian' },
                                { name: 'Barbudans' },
                                { name: 'Batswana' },
                                { name: 'Belarusian' },
                                { name: 'Belgian' },
                                { name: 'Belizean' },
                                { name: 'Beninese' },
                                { name: 'Bhutanese' },
                                { name: 'Bolivian' },
                                { name: 'Bosnian' },
                                { name: 'Brazilian' },
                                { name: 'British' },
                                { name: 'Bruneian' },
                                { name: 'Bulgarian' },
                                { name: 'Burkinabe' },
                                { name: 'Burmese' },
                                { name: 'Burundian' },
                                { name: 'Cambodian' },
                                { name: 'Cameroonian' },
                                { name: 'Canadian' },
                                { name: 'Cape Verdean' },
                                { name: 'Central African' },
                                { name: 'Chadian' },
                                { name: 'Chilean' },
                                { name: 'Chinese' },
                                { name: 'Colombian' },
                                { name: 'Comoran' },
                                { name: 'Congolese' },
                                { name: 'Costa Rican' },
                                { name: 'Croatian' },
                                { name: 'Cuban' },
                                { name: 'Cypriot' },
                                { name: 'Czech' },
                                { name: 'Danish' },
                                { name: 'Djibouti' },
                                { name: 'Dominican' },
                                { name: 'Dutch' },
                                { name: 'East Timorese' },
                                { name: 'Ecuadorean' },
                                { name: 'Egyptian' },
                                { name: 'Emirian' },
                                { name: 'Equatorial Guinean' },
                                { name: 'Eritrean' },
                                { name: 'Estonian' },
                                { name: 'Ethiopian' },
                                { name: 'Fijian' },
                                { name: 'Filipino' },
                                { name: 'Finnish' },
                                { name: 'French' },
                                { name: 'Gabonese' },
                                { name: 'Gambian' },
                                { name: 'Georgian' },
                                { name: 'German' },
                                { name: 'Ghanaian' },
                                { name: 'Greek' },
                                { name: 'Grenadian' },
                                { name: 'Guatemalan' },
                                { name: 'Guinea-Bissauan' },
                                { name: 'Guinean' },
                                { name: 'Guyanese' },
                                { name: 'Haitian' },
                                { name: 'Herzegovinian' },
                                { name: 'Honduran' },
                                { name: 'Hungarian' },
                                { name: 'I-Kiribati' },
                                { name: 'Icelander' },
                                { name: 'Indian' },
                                { name: 'Indonesian' },
                                { name: 'Iranian' },
                                { name: 'Iraqi' },
                                { name: 'Irish' },
                                { name: 'Israeli' },
                                { name: 'Italian' },
                                { name: 'Ivorian' },
                                { name: 'Jamaican' },
                                { name: 'Japanese' },
                                { name: 'Jordanian' },
                                { name: 'Kazakhstani' },
                                { name: 'Kenyan' },
                                { name: 'Kittian and Nevisian' },
                                { name: 'Kuwaiti' },
                                { name: 'Kyrgyz' },
                                { name: 'Laotian' },
                                { name: 'Latvian' },
                                { name: 'Lebanese' },
                                { name: 'Liberian' },
                                { name: 'Libyan' },
                                { name: 'Liechtensteiner' },
                                { name: 'Lithuanian' },
                                { name: 'Luxembourger' },
                                { name: 'Macedonian' },
                                { name: 'Malagasy' },
                                { name: 'Malawian' },
                                { name: 'Malaysian' },
                                { name: 'Maldivan' },
                                { name: 'Malian' },
                                { name: 'Maltese' },
                                { name: 'Marshallese' },
                                { name: 'Mauritanian' },
                                { name: 'Mauritian' },
                                { name: 'Mexican' },
                                { name: 'Micronesian' },
                                { name: 'Moldovan' },
                                { name: 'Monacan' },
                                { name: 'Mongolian' },
                                { name: 'Moroccan' },
                                { name: 'Mosotho' },
                                { name: 'Motswana' },
                                { name: 'Mozambican' },
                                { name: 'Namibian' },
                                { name: 'Nauruan' },
                                { name: 'Nepalese' },
                                { name: 'New Zealander' },
                                { name: 'Nicaraguan' },
                                { name: 'Nigerian' },
                                { name: 'Nigerien' },
                                { name: 'North Korean' },
                                { name: 'Northern Irish' },
                                { name: 'Norwegian' },
                                { name: 'Omani' },
                                { name: 'Pakistani' },
                                { name: 'Palauan' },
                                { name: 'Panamanian' },
                                { name: 'Papua New Guinean' },
                                { name: 'Paraguayan' },
                                { name: 'Peruvian' },
                                { name: 'Polish' },
                                { name: 'Portuguese' },
                                { name: 'Qatari' },
                                { name: 'Romani' },
                                { name: 'Russian' },
                                { name: 'Rwandan' },
                                { name: 'Saint Lucian' },
                                { name: 'Salvadoran' },
                                { name: 'Samoan' },
                                { name: 'San Marinese' },
                                { name: 'Sao Tomean' },
                                { name: 'Saudi' },
                                { name: 'Scottish' },
                                { name: 'Senegalese' },
                                { name: 'Serbian' },
                                { name: 'Seychellois' },
                                { name: 'Sierra Leonean' },
                                { name: 'Singaporean' },
                                { name: 'Slovakian' },
                                { name: 'Slovenian' },
                                { name: 'Solomon Islander' },
                                { name: 'Somali' },
                                { name: 'South African' },
                                { name: 'South Korean' },
                                { name: 'Spanish' },
                                { name: 'Sri Lankan' },
                                { name: 'Sudanese' },
                                { name: 'Surinamer' },
                                { name: 'Swazi' },
                                { name: 'Swedish' },
                                { name: 'Swiss' },
                                { name: 'Syrian' },
                                { name: 'Taiwanese' },
                                { name: 'Tajik' },
                                { name: 'Tanzanian' },
                                { name: 'Thai' },
                                { name: 'Togolese' },
                                { name: 'Tongan' },
                                { name: 'Trinidadian or Tobagonian' },
                                { name: 'Tunisian' },
                                { name: 'Turkish' },
                                { name: 'Tuvaluan' },
                                { name: 'Ugandan' },
                                { name: 'Ukrainian' },
                                { name: 'Uruguaya' },
                                { name: 'Uzbekistani' },
                                { name: 'Venezuela' },
                                { name: 'Vietnamese' },
                                { name: 'Wels' },
                                { name: 'Yemenit' },
                                { name: 'Zambia' },
                                { name: 'Zimbabwe' }
                            ],
                            locale_languages: [
                                'aa',
                                'ab',
                                'ae',
                                'af',
                                'ak',
                                'am',
                                'an',
                                'ar',
                                'as',
                                'av',
                                'ay',
                                'az',
                                'ba',
                                'be',
                                'bg',
                                'bh',
                                'bi',
                                'bm',
                                'bn',
                                'bo',
                                'br',
                                'bs',
                                'ca',
                                'ce',
                                'ch',
                                'co',
                                'cr',
                                'cs',
                                'cu',
                                'cv',
                                'cy',
                                'da',
                                'de',
                                'dv',
                                'dz',
                                'ee',
                                'el',
                                'en',
                                'eo',
                                'es',
                                'et',
                                'eu',
                                'fa',
                                'ff',
                                'fi',
                                'fj',
                                'fo',
                                'fr',
                                'fy',
                                'ga',
                                'gd',
                                'gl',
                                'gn',
                                'gu',
                                'gv',
                                'ha',
                                'he',
                                'hi',
                                'ho',
                                'hr',
                                'ht',
                                'hu',
                                'hy',
                                'hz',
                                'ia',
                                'id',
                                'ie',
                                'ig',
                                'ii',
                                'ik',
                                'io',
                                'is',
                                'it',
                                'iu',
                                'ja',
                                'jv',
                                'ka',
                                'kg',
                                'ki',
                                'kj',
                                'kk',
                                'kl',
                                'km',
                                'kn',
                                'ko',
                                'kr',
                                'ks',
                                'ku',
                                'kv',
                                'kw',
                                'ky',
                                'la',
                                'lb',
                                'lg',
                                'li',
                                'ln',
                                'lo',
                                'lt',
                                'lu',
                                'lv',
                                'mg',
                                'mh',
                                'mi',
                                'mk',
                                'ml',
                                'mn',
                                'mr',
                                'ms',
                                'mt',
                                'my',
                                'na',
                                'nb',
                                'nd',
                                'ne',
                                'ng',
                                'nl',
                                'nn',
                                'no',
                                'nr',
                                'nv',
                                'ny',
                                'oc',
                                'oj',
                                'om',
                                'or',
                                'os',
                                'pa',
                                'pi',
                                'pl',
                                'ps',
                                'pt',
                                'qu',
                                'rm',
                                'rn',
                                'ro',
                                'ru',
                                'rw',
                                'sa',
                                'sc',
                                'sd',
                                'se',
                                'sg',
                                'si',
                                'sk',
                                'sl',
                                'sm',
                                'sn',
                                'so',
                                'sq',
                                'sr',
                                'ss',
                                'st',
                                'su',
                                'sv',
                                'sw',
                                'ta',
                                'te',
                                'tg',
                                'th',
                                'ti',
                                'tk',
                                'tl',
                                'tn',
                                'to',
                                'tr',
                                'ts',
                                'tt',
                                'tw',
                                'ty',
                                'ug',
                                'uk',
                                'ur',
                                'uz',
                                've',
                                'vi',
                                'vo',
                                'wa',
                                'wo',
                                'xh',
                                'yi',
                                'yo',
                                'za',
                                'zh',
                                'zu'
                            ],
                            locale_regions: [
                                'agq-CM',
                                'asa-TZ',
                                'ast-ES',
                                'bas-CM',
                                'bem-ZM',
                                'bez-TZ',
                                'brx-IN',
                                'cgg-UG',
                                'chr-US',
                                'dav-KE',
                                'dje-NE',
                                'dsb-DE',
                                'dua-CM',
                                'dyo-SN',
                                'ebu-KE',
                                'ewo-CM',
                                'fil-PH',
                                'fur-IT',
                                'gsw-CH',
                                'gsw-FR',
                                'gsw-LI',
                                'guz-KE',
                                'haw-US',
                                'hsb-DE',
                                'jgo-CM',
                                'jmc-TZ',
                                'kab-DZ',
                                'kam-KE',
                                'kde-TZ',
                                'kea-CV',
                                'khq-ML',
                                'kkj-CM',
                                'kln-KE',
                                'kok-IN',
                                'ksb-TZ',
                                'ksf-CM',
                                'ksh-DE',
                                'lag-TZ',
                                'lkt-US',
                                'luo-KE',
                                'luy-KE',
                                'mas-KE',
                                'mas-TZ',
                                'mer-KE',
                                'mfe-MU',
                                'mgh-MZ',
                                'mgo-CM',
                                'mua-CM',
                                'naq-NA',
                                'nmg-CM',
                                'nnh-CM',
                                'nus-SD',
                                'nyn-UG',
                                'rof-TZ',
                                'rwk-TZ',
                                'sah-RU',
                                'saq-KE',
                                'sbp-TZ',
                                'seh-MZ',
                                'ses-ML',
                                'shi-Latn',
                                'shi-Latn-MA',
                                'shi-Tfng',
                                'shi-Tfng-MA',
                                'smn-FI',
                                'teo-KE',
                                'teo-UG',
                                'twq-NE',
                                'tzm-Latn',
                                'tzm-Latn-MA',
                                'vai-Latn',
                                'vai-Latn-LR',
                                'vai-Vaii',
                                'vai-Vaii-LR',
                                'vun-TZ',
                                'wae-CH',
                                'xog-UG',
                                'yav-CM',
                                'zgh-MA',
                                'af-NA',
                                'af-ZA',
                                'ak-GH',
                                'am-ET',
                                'ar-001',
                                'ar-AE',
                                'ar-BH',
                                'ar-DJ',
                                'ar-DZ',
                                'ar-EG',
                                'ar-EH',
                                'ar-ER',
                                'ar-IL',
                                'ar-IQ',
                                'ar-JO',
                                'ar-KM',
                                'ar-KW',
                                'ar-LB',
                                'ar-LY',
                                'ar-MA',
                                'ar-MR',
                                'ar-OM',
                                'ar-PS',
                                'ar-QA',
                                'ar-SA',
                                'ar-SD',
                                'ar-SO',
                                'ar-SS',
                                'ar-SY',
                                'ar-TD',
                                'ar-TN',
                                'ar-YE',
                                'as-IN',
                                'az-Cyrl',
                                'az-Cyrl-AZ',
                                'az-Latn',
                                'az-Latn-AZ',
                                'be-BY',
                                'bg-BG',
                                'bm-Latn',
                                'bm-Latn-ML',
                                'bn-BD',
                                'bn-IN',
                                'bo-CN',
                                'bo-IN',
                                'br-FR',
                                'bs-Cyrl',
                                'bs-Cyrl-BA',
                                'bs-Latn',
                                'bs-Latn-BA',
                                'ca-AD',
                                'ca-ES',
                                'ca-ES-VALENCIA',
                                'ca-FR',
                                'ca-IT',
                                'cs-CZ',
                                'cy-GB',
                                'da-DK',
                                'da-GL',
                                'de-AT',
                                'de-BE',
                                'de-CH',
                                'de-DE',
                                'de-LI',
                                'de-LU',
                                'dz-BT',
                                'ee-GH',
                                'ee-TG',
                                'el-CY',
                                'el-GR',
                                'en-001',
                                'en-150',
                                'en-AG',
                                'en-AI',
                                'en-AS',
                                'en-AU',
                                'en-BB',
                                'en-BE',
                                'en-BM',
                                'en-BS',
                                'en-BW',
                                'en-BZ',
                                'en-CA',
                                'en-CC',
                                'en-CK',
                                'en-CM',
                                'en-CX',
                                'en-DG',
                                'en-DM',
                                'en-ER',
                                'en-FJ',
                                'en-FK',
                                'en-FM',
                                'en-GB',
                                'en-GD',
                                'en-GG',
                                'en-GH',
                                'en-GI',
                                'en-GM',
                                'en-GU',
                                'en-GY',
                                'en-HK',
                                'en-IE',
                                'en-IM',
                                'en-IN',
                                'en-IO',
                                'en-JE',
                                'en-JM',
                                'en-KE',
                                'en-KI',
                                'en-KN',
                                'en-KY',
                                'en-LC',
                                'en-LR',
                                'en-LS',
                                'en-MG',
                                'en-MH',
                                'en-MO',
                                'en-MP',
                                'en-MS',
                                'en-MT',
                                'en-MU',
                                'en-MW',
                                'en-MY',
                                'en-NA',
                                'en-NF',
                                'en-NG',
                                'en-NR',
                                'en-NU',
                                'en-NZ',
                                'en-PG',
                                'en-PH',
                                'en-PK',
                                'en-PN',
                                'en-PR',
                                'en-PW',
                                'en-RW',
                                'en-SB',
                                'en-SC',
                                'en-SD',
                                'en-SG',
                                'en-SH',
                                'en-SL',
                                'en-SS',
                                'en-SX',
                                'en-SZ',
                                'en-TC',
                                'en-TK',
                                'en-TO',
                                'en-TT',
                                'en-TV',
                                'en-TZ',
                                'en-UG',
                                'en-UM',
                                'en-US',
                                'en-US-POSIX',
                                'en-VC',
                                'en-VG',
                                'en-VI',
                                'en-VU',
                                'en-WS',
                                'en-ZA',
                                'en-ZM',
                                'en-ZW',
                                'eo-001',
                                'es-419',
                                'es-AR',
                                'es-BO',
                                'es-CL',
                                'es-CO',
                                'es-CR',
                                'es-CU',
                                'es-DO',
                                'es-EA',
                                'es-EC',
                                'es-ES',
                                'es-GQ',
                                'es-GT',
                                'es-HN',
                                'es-IC',
                                'es-MX',
                                'es-NI',
                                'es-PA',
                                'es-PE',
                                'es-PH',
                                'es-PR',
                                'es-PY',
                                'es-SV',
                                'es-US',
                                'es-UY',
                                'es-VE',
                                'et-EE',
                                'eu-ES',
                                'fa-AF',
                                'fa-IR',
                                'ff-CM',
                                'ff-GN',
                                'ff-MR',
                                'ff-SN',
                                'fi-FI',
                                'fo-FO',
                                'fr-BE',
                                'fr-BF',
                                'fr-BI',
                                'fr-BJ',
                                'fr-BL',
                                'fr-CA',
                                'fr-CD',
                                'fr-CF',
                                'fr-CG',
                                'fr-CH',
                                'fr-CI',
                                'fr-CM',
                                'fr-DJ',
                                'fr-DZ',
                                'fr-FR',
                                'fr-GA',
                                'fr-GF',
                                'fr-GN',
                                'fr-GP',
                                'fr-GQ',
                                'fr-HT',
                                'fr-KM',
                                'fr-LU',
                                'fr-MA',
                                'fr-MC',
                                'fr-MF',
                                'fr-MG',
                                'fr-ML',
                                'fr-MQ',
                                'fr-MR',
                                'fr-MU',
                                'fr-NC',
                                'fr-NE',
                                'fr-PF',
                                'fr-PM',
                                'fr-RE',
                                'fr-RW',
                                'fr-SC',
                                'fr-SN',
                                'fr-SY',
                                'fr-TD',
                                'fr-TG',
                                'fr-TN',
                                'fr-VU',
                                'fr-WF',
                                'fr-YT',
                                'fy-NL',
                                'ga-IE',
                                'gd-GB',
                                'gl-ES',
                                'gu-IN',
                                'gv-IM',
                                'ha-Latn',
                                'ha-Latn-GH',
                                'ha-Latn-NE',
                                'ha-Latn-NG',
                                'he-IL',
                                'hi-IN',
                                'hr-BA',
                                'hr-HR',
                                'hu-HU',
                                'hy-AM',
                                'id-ID',
                                'ig-NG',
                                'ii-CN',
                                'is-IS',
                                'it-CH',
                                'it-IT',
                                'it-SM',
                                'ja-JP',
                                'ka-GE',
                                'ki-KE',
                                'kk-Cyrl',
                                'kk-Cyrl-KZ',
                                'kl-GL',
                                'km-KH',
                                'kn-IN',
                                'ko-KP',
                                'ko-KR',
                                'ks-Arab',
                                'ks-Arab-IN',
                                'kw-GB',
                                'ky-Cyrl',
                                'ky-Cyrl-KG',
                                'lb-LU',
                                'lg-UG',
                                'ln-AO',
                                'ln-CD',
                                'ln-CF',
                                'ln-CG',
                                'lo-LA',
                                'lt-LT',
                                'lu-CD',
                                'lv-LV',
                                'mg-MG',
                                'mk-MK',
                                'ml-IN',
                                'mn-Cyrl',
                                'mn-Cyrl-MN',
                                'mr-IN',
                                'ms-Latn',
                                'ms-Latn-BN',
                                'ms-Latn-MY',
                                'ms-Latn-SG',
                                'mt-MT',
                                'my-MM',
                                'nb-NO',
                                'nb-SJ',
                                'nd-ZW',
                                'ne-IN',
                                'ne-NP',
                                'nl-AW',
                                'nl-BE',
                                'nl-BQ',
                                'nl-CW',
                                'nl-NL',
                                'nl-SR',
                                'nl-SX',
                                'nn-NO',
                                'om-ET',
                                'om-KE',
                                'or-IN',
                                'os-GE',
                                'os-RU',
                                'pa-Arab',
                                'pa-Arab-PK',
                                'pa-Guru',
                                'pa-Guru-IN',
                                'pl-PL',
                                'ps-AF',
                                'pt-AO',
                                'pt-BR',
                                'pt-CV',
                                'pt-GW',
                                'pt-MO',
                                'pt-MZ',
                                'pt-PT',
                                'pt-ST',
                                'pt-TL',
                                'qu-BO',
                                'qu-EC',
                                'qu-PE',
                                'rm-CH',
                                'rn-BI',
                                'ro-MD',
                                'ro-RO',
                                'ru-BY',
                                'ru-KG',
                                'ru-KZ',
                                'ru-MD',
                                'ru-RU',
                                'ru-UA',
                                'rw-RW',
                                'se-FI',
                                'se-NO',
                                'se-SE',
                                'sg-CF',
                                'si-LK',
                                'sk-SK',
                                'sl-SI',
                                'sn-ZW',
                                'so-DJ',
                                'so-ET',
                                'so-KE',
                                'so-SO',
                                'sq-AL',
                                'sq-MK',
                                'sq-XK',
                                'sr-Cyrl',
                                'sr-Cyrl-BA',
                                'sr-Cyrl-ME',
                                'sr-Cyrl-RS',
                                'sr-Cyrl-XK',
                                'sr-Latn',
                                'sr-Latn-BA',
                                'sr-Latn-ME',
                                'sr-Latn-RS',
                                'sr-Latn-XK',
                                'sv-AX',
                                'sv-FI',
                                'sv-SE',
                                'sw-CD',
                                'sw-KE',
                                'sw-TZ',
                                'sw-UG',
                                'ta-IN',
                                'ta-LK',
                                'ta-MY',
                                'ta-SG',
                                'te-IN',
                                'th-TH',
                                'ti-ER',
                                'ti-ET',
                                'to-TO',
                                'tr-CY',
                                'tr-TR',
                                'ug-Arab',
                                'ug-Arab-CN',
                                'uk-UA',
                                'ur-IN',
                                'ur-PK',
                                'uz-Arab',
                                'uz-Arab-AF',
                                'uz-Cyrl',
                                'uz-Cyrl-UZ',
                                'uz-Latn',
                                'uz-Latn-UZ',
                                'vi-VN',
                                'yi-001',
                                'yo-BJ',
                                'yo-NG',
                                'zh-Hans',
                                'zh-Hans-CN',
                                'zh-Hans-HK',
                                'zh-Hans-MO',
                                'zh-Hans-SG',
                                'zh-Hant',
                                'zh-Hant-HK',
                                'zh-Hant-MO',
                                'zh-Hant-TW',
                                'zu-ZA'
                            ],
                            us_states_and_dc: [
                                {
                                    name: 'Alabama',
                                    abbreviation: 'AL'
                                },
                                {
                                    name: 'Alaska',
                                    abbreviation: 'AK'
                                },
                                {
                                    name: 'Arizona',
                                    abbreviation: 'AZ'
                                },
                                {
                                    name: 'Arkansas',
                                    abbreviation: 'AR'
                                },
                                {
                                    name: 'California',
                                    abbreviation: 'CA'
                                },
                                {
                                    name: 'Colorado',
                                    abbreviation: 'CO'
                                },
                                {
                                    name: 'Connecticut',
                                    abbreviation: 'CT'
                                },
                                {
                                    name: 'Delaware',
                                    abbreviation: 'DE'
                                },
                                {
                                    name: 'District of Columbia',
                                    abbreviation: 'DC'
                                },
                                {
                                    name: 'Florida',
                                    abbreviation: 'FL'
                                },
                                {
                                    name: 'Georgia',
                                    abbreviation: 'GA'
                                },
                                {
                                    name: 'Hawaii',
                                    abbreviation: 'HI'
                                },
                                {
                                    name: 'Idaho',
                                    abbreviation: 'ID'
                                },
                                {
                                    name: 'Illinois',
                                    abbreviation: 'IL'
                                },
                                {
                                    name: 'Indiana',
                                    abbreviation: 'IN'
                                },
                                {
                                    name: 'Iowa',
                                    abbreviation: 'IA'
                                },
                                {
                                    name: 'Kansas',
                                    abbreviation: 'KS'
                                },
                                {
                                    name: 'Kentucky',
                                    abbreviation: 'KY'
                                },
                                {
                                    name: 'Louisiana',
                                    abbreviation: 'LA'
                                },
                                {
                                    name: 'Maine',
                                    abbreviation: 'ME'
                                },
                                {
                                    name: 'Maryland',
                                    abbreviation: 'MD'
                                },
                                {
                                    name: 'Massachusetts',
                                    abbreviation: 'MA'
                                },
                                {
                                    name: 'Michigan',
                                    abbreviation: 'MI'
                                },
                                {
                                    name: 'Minnesota',
                                    abbreviation: 'MN'
                                },
                                {
                                    name: 'Mississippi',
                                    abbreviation: 'MS'
                                },
                                {
                                    name: 'Missouri',
                                    abbreviation: 'MO'
                                },
                                {
                                    name: 'Montana',
                                    abbreviation: 'MT'
                                },
                                {
                                    name: 'Nebraska',
                                    abbreviation: 'NE'
                                },
                                {
                                    name: 'Nevada',
                                    abbreviation: 'NV'
                                },
                                {
                                    name: 'New Hampshire',
                                    abbreviation: 'NH'
                                },
                                {
                                    name: 'New Jersey',
                                    abbreviation: 'NJ'
                                },
                                {
                                    name: 'New Mexico',
                                    abbreviation: 'NM'
                                },
                                {
                                    name: 'New York',
                                    abbreviation: 'NY'
                                },
                                {
                                    name: 'North Carolina',
                                    abbreviation: 'NC'
                                },
                                {
                                    name: 'North Dakota',
                                    abbreviation: 'ND'
                                },
                                {
                                    name: 'Ohio',
                                    abbreviation: 'OH'
                                },
                                {
                                    name: 'Oklahoma',
                                    abbreviation: 'OK'
                                },
                                {
                                    name: 'Oregon',
                                    abbreviation: 'OR'
                                },
                                {
                                    name: 'Pennsylvania',
                                    abbreviation: 'PA'
                                },
                                {
                                    name: 'Rhode Island',
                                    abbreviation: 'RI'
                                },
                                {
                                    name: 'South Carolina',
                                    abbreviation: 'SC'
                                },
                                {
                                    name: 'South Dakota',
                                    abbreviation: 'SD'
                                },
                                {
                                    name: 'Tennessee',
                                    abbreviation: 'TN'
                                },
                                {
                                    name: 'Texas',
                                    abbreviation: 'TX'
                                },
                                {
                                    name: 'Utah',
                                    abbreviation: 'UT'
                                },
                                {
                                    name: 'Vermont',
                                    abbreviation: 'VT'
                                },
                                {
                                    name: 'Virginia',
                                    abbreviation: 'VA'
                                },
                                {
                                    name: 'Washington',
                                    abbreviation: 'WA'
                                },
                                {
                                    name: 'West Virginia',
                                    abbreviation: 'WV'
                                },
                                {
                                    name: 'Wisconsin',
                                    abbreviation: 'WI'
                                },
                                {
                                    name: 'Wyoming',
                                    abbreviation: 'WY'
                                }
                            ],
                            territories: [
                                {
                                    name: 'American Samoa',
                                    abbreviation: 'AS'
                                },
                                {
                                    name: 'Federated States of Micronesia',
                                    abbreviation: 'FM'
                                },
                                {
                                    name: 'Guam',
                                    abbreviation: 'GU'
                                },
                                {
                                    name: 'Marshall Islands',
                                    abbreviation: 'MH'
                                },
                                {
                                    name: 'Northern Mariana Islands',
                                    abbreviation: 'MP'
                                },
                                {
                                    name: 'Puerto Rico',
                                    abbreviation: 'PR'
                                },
                                {
                                    name: 'Virgin Islands, U.S.',
                                    abbreviation: 'VI'
                                }
                            ],
                            armed_forces: [
                                {
                                    name: 'Armed Forces Europe',
                                    abbreviation: 'AE'
                                },
                                {
                                    name: 'Armed Forces Pacific',
                                    abbreviation: 'AP'
                                },
                                {
                                    name: 'Armed Forces the Americas',
                                    abbreviation: 'AA'
                                }
                            ],
                            country_regions: {
                                it: [
                                    {
                                        name: 'Valle d\'Aosta',
                                        abbreviation: 'VDA'
                                    },
                                    {
                                        name: 'Piemonte',
                                        abbreviation: 'PIE'
                                    },
                                    {
                                        name: 'Lombardia',
                                        abbreviation: 'LOM'
                                    },
                                    {
                                        name: 'Veneto',
                                        abbreviation: 'VEN'
                                    },
                                    {
                                        name: 'Trentino Alto Adige',
                                        abbreviation: 'TAA'
                                    },
                                    {
                                        name: 'Friuli Venezia Giulia',
                                        abbreviation: 'FVG'
                                    },
                                    {
                                        name: 'Liguria',
                                        abbreviation: 'LIG'
                                    },
                                    {
                                        name: 'Emilia Romagna',
                                        abbreviation: 'EMR'
                                    },
                                    {
                                        name: 'Toscana',
                                        abbreviation: 'TOS'
                                    },
                                    {
                                        name: 'Umbria',
                                        abbreviation: 'UMB'
                                    },
                                    {
                                        name: 'Marche',
                                        abbreviation: 'MAR'
                                    },
                                    {
                                        name: 'Abruzzo',
                                        abbreviation: 'ABR'
                                    },
                                    {
                                        name: 'Lazio',
                                        abbreviation: 'LAZ'
                                    },
                                    {
                                        name: 'Campania',
                                        abbreviation: 'CAM'
                                    },
                                    {
                                        name: 'Puglia',
                                        abbreviation: 'PUG'
                                    },
                                    {
                                        name: 'Basilicata',
                                        abbreviation: 'BAS'
                                    },
                                    {
                                        name: 'Molise',
                                        abbreviation: 'MOL'
                                    },
                                    {
                                        name: 'Calabria',
                                        abbreviation: 'CAL'
                                    },
                                    {
                                        name: 'Sicilia',
                                        abbreviation: 'SIC'
                                    },
                                    {
                                        name: 'Sardegna',
                                        abbreviation: 'SAR'
                                    }
                                ],
                                mx: [
                                    {
                                        name: 'Aguascalientes',
                                        abbreviation: 'AGU'
                                    },
                                    {
                                        name: 'Baja California',
                                        abbreviation: 'BCN'
                                    },
                                    {
                                        name: 'Baja California Sur',
                                        abbreviation: 'BCS'
                                    },
                                    {
                                        name: 'Campeche',
                                        abbreviation: 'CAM'
                                    },
                                    {
                                        name: 'Chiapas',
                                        abbreviation: 'CHP'
                                    },
                                    {
                                        name: 'Chihuahua',
                                        abbreviation: 'CHH'
                                    },
                                    {
                                        name: 'Ciudad de México',
                                        abbreviation: 'DIF'
                                    },
                                    {
                                        name: 'Coahuila',
                                        abbreviation: 'COA'
                                    },
                                    {
                                        name: 'Colima',
                                        abbreviation: 'COL'
                                    },
                                    {
                                        name: 'Durango',
                                        abbreviation: 'DUR'
                                    },
                                    {
                                        name: 'Guanajuato',
                                        abbreviation: 'GUA'
                                    },
                                    {
                                        name: 'Guerrero',
                                        abbreviation: 'GRO'
                                    },
                                    {
                                        name: 'Hidalgo',
                                        abbreviation: 'HID'
                                    },
                                    {
                                        name: 'Jalisco',
                                        abbreviation: 'JAL'
                                    },
                                    {
                                        name: 'México',
                                        abbreviation: 'MEX'
                                    },
                                    {
                                        name: 'Michoacán',
                                        abbreviation: 'MIC'
                                    },
                                    {
                                        name: 'Morelos',
                                        abbreviation: 'MOR'
                                    },
                                    {
                                        name: 'Nayarit',
                                        abbreviation: 'NAY'
                                    },
                                    {
                                        name: 'Nuevo León',
                                        abbreviation: 'NLE'
                                    },
                                    {
                                        name: 'Oaxaca',
                                        abbreviation: 'OAX'
                                    },
                                    {
                                        name: 'Puebla',
                                        abbreviation: 'PUE'
                                    },
                                    {
                                        name: 'Querétaro',
                                        abbreviation: 'QUE'
                                    },
                                    {
                                        name: 'Quintana Roo',
                                        abbreviation: 'ROO'
                                    },
                                    {
                                        name: 'San Luis Potosí',
                                        abbreviation: 'SLP'
                                    },
                                    {
                                        name: 'Sinaloa',
                                        abbreviation: 'SIN'
                                    },
                                    {
                                        name: 'Sonora',
                                        abbreviation: 'SON'
                                    },
                                    {
                                        name: 'Tabasco',
                                        abbreviation: 'TAB'
                                    },
                                    {
                                        name: 'Tamaulipas',
                                        abbreviation: 'TAM'
                                    },
                                    {
                                        name: 'Tlaxcala',
                                        abbreviation: 'TLA'
                                    },
                                    {
                                        name: 'Veracruz',
                                        abbreviation: 'VER'
                                    },
                                    {
                                        name: 'Yucatán',
                                        abbreviation: 'YUC'
                                    },
                                    {
                                        name: 'Zacatecas',
                                        abbreviation: 'ZAC'
                                    }
                                ]
                            },
                            street_suffixes: {
                                us: [
                                    {
                                        name: 'Avenue',
                                        abbreviation: 'Ave'
                                    },
                                    {
                                        name: 'Boulevard',
                                        abbreviation: 'Blvd'
                                    },
                                    {
                                        name: 'Center',
                                        abbreviation: 'Ctr'
                                    },
                                    {
                                        name: 'Circle',
                                        abbreviation: 'Cir'
                                    },
                                    {
                                        name: 'Court',
                                        abbreviation: 'Ct'
                                    },
                                    {
                                        name: 'Drive',
                                        abbreviation: 'Dr'
                                    },
                                    {
                                        name: 'Extension',
                                        abbreviation: 'Ext'
                                    },
                                    {
                                        name: 'Glen',
                                        abbreviation: 'Gln'
                                    },
                                    {
                                        name: 'Grove',
                                        abbreviation: 'Grv'
                                    },
                                    {
                                        name: 'Heights',
                                        abbreviation: 'Hts'
                                    },
                                    {
                                        name: 'Highway',
                                        abbreviation: 'Hwy'
                                    },
                                    {
                                        name: 'Junction',
                                        abbreviation: 'Jct'
                                    },
                                    {
                                        name: 'Key',
                                        abbreviation: 'Key'
                                    },
                                    {
                                        name: 'Lane',
                                        abbreviation: 'Ln'
                                    },
                                    {
                                        name: 'Loop',
                                        abbreviation: 'Loop'
                                    },
                                    {
                                        name: 'Manor',
                                        abbreviation: 'Mnr'
                                    },
                                    {
                                        name: 'Mill',
                                        abbreviation: 'Mill'
                                    },
                                    {
                                        name: 'Park',
                                        abbreviation: 'Park'
                                    },
                                    {
                                        name: 'Parkway',
                                        abbreviation: 'Pkwy'
                                    },
                                    {
                                        name: 'Pass',
                                        abbreviation: 'Pass'
                                    },
                                    {
                                        name: 'Path',
                                        abbreviation: 'Path'
                                    },
                                    {
                                        name: 'Pike',
                                        abbreviation: 'Pike'
                                    },
                                    {
                                        name: 'Place',
                                        abbreviation: 'Pl'
                                    },
                                    {
                                        name: 'Plaza',
                                        abbreviation: 'Plz'
                                    },
                                    {
                                        name: 'Point',
                                        abbreviation: 'Pt'
                                    },
                                    {
                                        name: 'Ridge',
                                        abbreviation: 'Rdg'
                                    },
                                    {
                                        name: 'River',
                                        abbreviation: 'Riv'
                                    },
                                    {
                                        name: 'Road',
                                        abbreviation: 'Rd'
                                    },
                                    {
                                        name: 'Square',
                                        abbreviation: 'Sq'
                                    },
                                    {
                                        name: 'Street',
                                        abbreviation: 'St'
                                    },
                                    {
                                        name: 'Terrace',
                                        abbreviation: 'Ter'
                                    },
                                    {
                                        name: 'Trail',
                                        abbreviation: 'Trl'
                                    },
                                    {
                                        name: 'Turnpike',
                                        abbreviation: 'Tpke'
                                    },
                                    {
                                        name: 'View',
                                        abbreviation: 'Vw'
                                    },
                                    {
                                        name: 'Way',
                                        abbreviation: 'Way'
                                    }
                                ],
                                it: [
                                    {
                                        name: 'Accesso',
                                        abbreviation: 'Acc.'
                                    },
                                    {
                                        name: 'Alzaia',
                                        abbreviation: 'Alz.'
                                    },
                                    {
                                        name: 'Arco',
                                        abbreviation: 'Arco'
                                    },
                                    {
                                        name: 'Archivolto',
                                        abbreviation: 'Acv.'
                                    },
                                    {
                                        name: 'Arena',
                                        abbreviation: 'Arena'
                                    },
                                    {
                                        name: 'Argine',
                                        abbreviation: 'Argine'
                                    },
                                    {
                                        name: 'Bacino',
                                        abbreviation: 'Bacino'
                                    },
                                    {
                                        name: 'Banchi',
                                        abbreviation: 'Banchi'
                                    },
                                    {
                                        name: 'Banchina',
                                        abbreviation: 'Ban.'
                                    },
                                    {
                                        name: 'Bastioni',
                                        abbreviation: 'Bas.'
                                    },
                                    {
                                        name: 'Belvedere',
                                        abbreviation: 'Belv.'
                                    },
                                    {
                                        name: 'Borgata',
                                        abbreviation: 'B.ta'
                                    },
                                    {
                                        name: 'Borgo',
                                        abbreviation: 'B.go'
                                    },
                                    {
                                        name: 'Calata',
                                        abbreviation: 'Cal.'
                                    },
                                    {
                                        name: 'Calle',
                                        abbreviation: 'Calle'
                                    },
                                    {
                                        name: 'Campiello',
                                        abbreviation: 'Cam.'
                                    },
                                    {
                                        name: 'Campo',
                                        abbreviation: 'Cam.'
                                    },
                                    {
                                        name: 'Canale',
                                        abbreviation: 'Can.'
                                    },
                                    {
                                        name: 'Carraia',
                                        abbreviation: 'Carr.'
                                    },
                                    {
                                        name: 'Cascina',
                                        abbreviation: 'Cascina'
                                    },
                                    {
                                        name: 'Case sparse',
                                        abbreviation: 'c.s.'
                                    },
                                    {
                                        name: 'Cavalcavia',
                                        abbreviation: 'Cv.'
                                    },
                                    {
                                        name: 'Circonvallazione',
                                        abbreviation: 'Cv.'
                                    },
                                    {
                                        name: 'Complanare',
                                        abbreviation: 'C.re'
                                    },
                                    {
                                        name: 'Contrada',
                                        abbreviation: 'C.da'
                                    },
                                    {
                                        name: 'Corso',
                                        abbreviation: 'C.so'
                                    },
                                    {
                                        name: 'Corte',
                                        abbreviation: 'C.te'
                                    },
                                    {
                                        name: 'Cortile',
                                        abbreviation: 'C.le'
                                    },
                                    {
                                        name: 'Diramazione',
                                        abbreviation: 'Dir.'
                                    },
                                    {
                                        name: 'Fondaco',
                                        abbreviation: 'F.co'
                                    },
                                    {
                                        name: 'Fondamenta',
                                        abbreviation: 'F.ta'
                                    },
                                    {
                                        name: 'Fondo',
                                        abbreviation: 'F.do'
                                    },
                                    {
                                        name: 'Frazione',
                                        abbreviation: 'Fr.'
                                    },
                                    {
                                        name: 'Isola',
                                        abbreviation: 'Is.'
                                    },
                                    {
                                        name: 'Largo',
                                        abbreviation: 'L.go'
                                    },
                                    {
                                        name: 'Litoranea',
                                        abbreviation: 'Lit.'
                                    },
                                    {
                                        name: 'Lungolago',
                                        abbreviation: 'L.go lago'
                                    },
                                    {
                                        name: 'Lungo Po',
                                        abbreviation: 'l.go Po'
                                    },
                                    {
                                        name: 'Molo',
                                        abbreviation: 'Molo'
                                    },
                                    {
                                        name: 'Mura',
                                        abbreviation: 'Mura'
                                    },
                                    {
                                        name: 'Passaggio privato',
                                        abbreviation: 'pass. priv.'
                                    },
                                    {
                                        name: 'Passeggiata',
                                        abbreviation: 'Pass.'
                                    },
                                    {
                                        name: 'Piazza',
                                        abbreviation: 'P.zza'
                                    },
                                    {
                                        name: 'Piazzale',
                                        abbreviation: 'P.le'
                                    },
                                    {
                                        name: 'Ponte',
                                        abbreviation: 'P.te'
                                    },
                                    {
                                        name: 'Portico',
                                        abbreviation: 'P.co'
                                    },
                                    {
                                        name: 'Rampa',
                                        abbreviation: 'Rampa'
                                    },
                                    {
                                        name: 'Regione',
                                        abbreviation: 'Reg.'
                                    },
                                    {
                                        name: 'Rione',
                                        abbreviation: 'R.ne'
                                    },
                                    {
                                        name: 'Rio',
                                        abbreviation: 'Rio'
                                    },
                                    {
                                        name: 'Ripa',
                                        abbreviation: 'Ripa'
                                    },
                                    {
                                        name: 'Riva',
                                        abbreviation: 'Riva'
                                    },
                                    {
                                        name: 'Rondò',
                                        abbreviation: 'Rondò'
                                    },
                                    {
                                        name: 'Rotonda',
                                        abbreviation: 'Rot.'
                                    },
                                    {
                                        name: 'Sagrato',
                                        abbreviation: 'Sagr.'
                                    },
                                    {
                                        name: 'Salita',
                                        abbreviation: 'Sal.'
                                    },
                                    {
                                        name: 'Scalinata',
                                        abbreviation: 'Scal.'
                                    },
                                    {
                                        name: 'Scalone',
                                        abbreviation: 'Scal.'
                                    },
                                    {
                                        name: 'Slargo',
                                        abbreviation: 'Sl.'
                                    },
                                    {
                                        name: 'Sottoportico',
                                        abbreviation: 'Sott.'
                                    },
                                    {
                                        name: 'Strada',
                                        abbreviation: 'Str.'
                                    },
                                    {
                                        name: 'Stradale',
                                        abbreviation: 'Str.le'
                                    },
                                    {
                                        name: 'Strettoia',
                                        abbreviation: 'Strett.'
                                    },
                                    {
                                        name: 'Traversa',
                                        abbreviation: 'Trav.'
                                    },
                                    {
                                        name: 'Via',
                                        abbreviation: 'V.'
                                    },
                                    {
                                        name: 'Viale',
                                        abbreviation: 'V.le'
                                    },
                                    {
                                        name: 'Vicinale',
                                        abbreviation: 'Vic.le'
                                    },
                                    {
                                        name: 'Vicolo',
                                        abbreviation: 'Vic.'
                                    }
                                ],
                                uk: [
                                    {
                                        name: 'Avenue',
                                        abbreviation: 'Ave'
                                    },
                                    {
                                        name: 'Close',
                                        abbreviation: 'Cl'
                                    },
                                    {
                                        name: 'Court',
                                        abbreviation: 'Ct'
                                    },
                                    {
                                        name: 'Crescent',
                                        abbreviation: 'Cr'
                                    },
                                    {
                                        name: 'Drive',
                                        abbreviation: 'Dr'
                                    },
                                    {
                                        name: 'Garden',
                                        abbreviation: 'Gdn'
                                    },
                                    {
                                        name: 'Gardens',
                                        abbreviation: 'Gdns'
                                    },
                                    {
                                        name: 'Green',
                                        abbreviation: 'Gn'
                                    },
                                    {
                                        name: 'Grove',
                                        abbreviation: 'Gr'
                                    },
                                    {
                                        name: 'Lane',
                                        abbreviation: 'Ln'
                                    },
                                    {
                                        name: 'Mount',
                                        abbreviation: 'Mt'
                                    },
                                    {
                                        name: 'Place',
                                        abbreviation: 'Pl'
                                    },
                                    {
                                        name: 'Park',
                                        abbreviation: 'Pk'
                                    },
                                    {
                                        name: 'Ridge',
                                        abbreviation: 'Rdg'
                                    },
                                    {
                                        name: 'Road',
                                        abbreviation: 'Rd'
                                    },
                                    {
                                        name: 'Square',
                                        abbreviation: 'Sq'
                                    },
                                    {
                                        name: 'Street',
                                        abbreviation: 'St'
                                    },
                                    {
                                        name: 'Terrace',
                                        abbreviation: 'Ter'
                                    },
                                    {
                                        name: 'Valley',
                                        abbreviation: 'Val'
                                    }
                                ]
                            },
                            months: [
                                {
                                    name: 'January',
                                    short_name: 'Jan',
                                    numeric: '01',
                                    days: 31
                                },
                                {
                                    name: 'February',
                                    short_name: 'Feb',
                                    numeric: '02',
                                    days: 28
                                },
                                {
                                    name: 'March',
                                    short_name: 'Mar',
                                    numeric: '03',
                                    days: 31
                                },
                                {
                                    name: 'April',
                                    short_name: 'Apr',
                                    numeric: '04',
                                    days: 30
                                },
                                {
                                    name: 'May',
                                    short_name: 'May',
                                    numeric: '05',
                                    days: 31
                                },
                                {
                                    name: 'June',
                                    short_name: 'Jun',
                                    numeric: '06',
                                    days: 30
                                },
                                {
                                    name: 'July',
                                    short_name: 'Jul',
                                    numeric: '07',
                                    days: 31
                                },
                                {
                                    name: 'August',
                                    short_name: 'Aug',
                                    numeric: '08',
                                    days: 31
                                },
                                {
                                    name: 'September',
                                    short_name: 'Sep',
                                    numeric: '09',
                                    days: 30
                                },
                                {
                                    name: 'October',
                                    short_name: 'Oct',
                                    numeric: '10',
                                    days: 31
                                },
                                {
                                    name: 'November',
                                    short_name: 'Nov',
                                    numeric: '11',
                                    days: 30
                                },
                                {
                                    name: 'December',
                                    short_name: 'Dec',
                                    numeric: '12',
                                    days: 31
                                }
                            ],
                            cc_types: [
                                {
                                    name: 'American Express',
                                    short_name: 'amex',
                                    prefix: '34',
                                    length: 15
                                },
                                {
                                    name: 'Bankcard',
                                    short_name: 'bankcard',
                                    prefix: '5610',
                                    length: 16
                                },
                                {
                                    name: 'China UnionPay',
                                    short_name: 'chinaunion',
                                    prefix: '62',
                                    length: 16
                                },
                                {
                                    name: 'Diners Club Carte Blanche',
                                    short_name: 'dccarte',
                                    prefix: '300',
                                    length: 14
                                },
                                {
                                    name: 'Diners Club enRoute',
                                    short_name: 'dcenroute',
                                    prefix: '2014',
                                    length: 15
                                },
                                {
                                    name: 'Diners Club International',
                                    short_name: 'dcintl',
                                    prefix: '36',
                                    length: 14
                                },
                                {
                                    name: 'Diners Club United States & Canada',
                                    short_name: 'dcusc',
                                    prefix: '54',
                                    length: 16
                                },
                                {
                                    name: 'Discover Card',
                                    short_name: 'discover',
                                    prefix: '6011',
                                    length: 16
                                },
                                {
                                    name: 'InstaPayment',
                                    short_name: 'instapay',
                                    prefix: '637',
                                    length: 16
                                },
                                {
                                    name: 'JCB',
                                    short_name: 'jcb',
                                    prefix: '3528',
                                    length: 16
                                },
                                {
                                    name: 'Laser',
                                    short_name: 'laser',
                                    prefix: '6304',
                                    length: 16
                                },
                                {
                                    name: 'Maestro',
                                    short_name: 'maestro',
                                    prefix: '5018',
                                    length: 16
                                },
                                {
                                    name: 'Mastercard',
                                    short_name: 'mc',
                                    prefix: '51',
                                    length: 16
                                },
                                {
                                    name: 'Solo',
                                    short_name: 'solo',
                                    prefix: '6334',
                                    length: 16
                                },
                                {
                                    name: 'Switch',
                                    short_name: 'switch',
                                    prefix: '4903',
                                    length: 16
                                },
                                {
                                    name: 'Visa',
                                    short_name: 'visa',
                                    prefix: '4',
                                    length: 16
                                },
                                {
                                    name: 'Visa Electron',
                                    short_name: 'electron',
                                    prefix: '4026',
                                    length: 16
                                }
                            ],
                            currency_types: [
                                {
                                    code: 'AED',
                                    name: 'United Arab Emirates Dirham'
                                },
                                {
                                    code: 'AFN',
                                    name: 'Afghanistan Afghani'
                                },
                                {
                                    code: 'ALL',
                                    name: 'Albania Lek'
                                },
                                {
                                    code: 'AMD',
                                    name: 'Armenia Dram'
                                },
                                {
                                    code: 'ANG',
                                    name: 'Netherlands Antilles Guilder'
                                },
                                {
                                    code: 'AOA',
                                    name: 'Angola Kwanza'
                                },
                                {
                                    code: 'ARS',
                                    name: 'Argentina Peso'
                                },
                                {
                                    code: 'AUD',
                                    name: 'Australia Dollar'
                                },
                                {
                                    code: 'AWG',
                                    name: 'Aruba Guilder'
                                },
                                {
                                    code: 'AZN',
                                    name: 'Azerbaijan New Manat'
                                },
                                {
                                    code: 'BAM',
                                    name: 'Bosnia and Herzegovina Convertible Marka'
                                },
                                {
                                    code: 'BBD',
                                    name: 'Barbados Dollar'
                                },
                                {
                                    code: 'BDT',
                                    name: 'Bangladesh Taka'
                                },
                                {
                                    code: 'BGN',
                                    name: 'Bulgaria Lev'
                                },
                                {
                                    code: 'BHD',
                                    name: 'Bahrain Dinar'
                                },
                                {
                                    code: 'BIF',
                                    name: 'Burundi Franc'
                                },
                                {
                                    code: 'BMD',
                                    name: 'Bermuda Dollar'
                                },
                                {
                                    code: 'BND',
                                    name: 'Brunei Darussalam Dollar'
                                },
                                {
                                    code: 'BOB',
                                    name: 'Bolivia Boliviano'
                                },
                                {
                                    code: 'BRL',
                                    name: 'Brazil Real'
                                },
                                {
                                    code: 'BSD',
                                    name: 'Bahamas Dollar'
                                },
                                {
                                    code: 'BTN',
                                    name: 'Bhutan Ngultrum'
                                },
                                {
                                    code: 'BWP',
                                    name: 'Botswana Pula'
                                },
                                {
                                    code: 'BYR',
                                    name: 'Belarus Ruble'
                                },
                                {
                                    code: 'BZD',
                                    name: 'Belize Dollar'
                                },
                                {
                                    code: 'CAD',
                                    name: 'Canada Dollar'
                                },
                                {
                                    code: 'CDF',
                                    name: 'Congo/Kinshasa Franc'
                                },
                                {
                                    code: 'CHF',
                                    name: 'Switzerland Franc'
                                },
                                {
                                    code: 'CLP',
                                    name: 'Chile Peso'
                                },
                                {
                                    code: 'CNY',
                                    name: 'China Yuan Renminbi'
                                },
                                {
                                    code: 'COP',
                                    name: 'Colombia Peso'
                                },
                                {
                                    code: 'CRC',
                                    name: 'Costa Rica Colon'
                                },
                                {
                                    code: 'CUC',
                                    name: 'Cuba Convertible Peso'
                                },
                                {
                                    code: 'CUP',
                                    name: 'Cuba Peso'
                                },
                                {
                                    code: 'CVE',
                                    name: 'Cape Verde Escudo'
                                },
                                {
                                    code: 'CZK',
                                    name: 'Czech Republic Koruna'
                                },
                                {
                                    code: 'DJF',
                                    name: 'Djibouti Franc'
                                },
                                {
                                    code: 'DKK',
                                    name: 'Denmark Krone'
                                },
                                {
                                    code: 'DOP',
                                    name: 'Dominican Republic Peso'
                                },
                                {
                                    code: 'DZD',
                                    name: 'Algeria Dinar'
                                },
                                {
                                    code: 'EGP',
                                    name: 'Egypt Pound'
                                },
                                {
                                    code: 'ERN',
                                    name: 'Eritrea Nakfa'
                                },
                                {
                                    code: 'ETB',
                                    name: 'Ethiopia Birr'
                                },
                                {
                                    code: 'EUR',
                                    name: 'Euro Member Countries'
                                },
                                {
                                    code: 'FJD',
                                    name: 'Fiji Dollar'
                                },
                                {
                                    code: 'FKP',
                                    name: 'Falkland Islands (Malvinas) Pound'
                                },
                                {
                                    code: 'GBP',
                                    name: 'United Kingdom Pound'
                                },
                                {
                                    code: 'GEL',
                                    name: 'Georgia Lari'
                                },
                                {
                                    code: 'GGP',
                                    name: 'Guernsey Pound'
                                },
                                {
                                    code: 'GHS',
                                    name: 'Ghana Cedi'
                                },
                                {
                                    code: 'GIP',
                                    name: 'Gibraltar Pound'
                                },
                                {
                                    code: 'GMD',
                                    name: 'Gambia Dalasi'
                                },
                                {
                                    code: 'GNF',
                                    name: 'Guinea Franc'
                                },
                                {
                                    code: 'GTQ',
                                    name: 'Guatemala Quetzal'
                                },
                                {
                                    code: 'GYD',
                                    name: 'Guyana Dollar'
                                },
                                {
                                    code: 'HKD',
                                    name: 'Hong Kong Dollar'
                                },
                                {
                                    code: 'HNL',
                                    name: 'Honduras Lempira'
                                },
                                {
                                    code: 'HRK',
                                    name: 'Croatia Kuna'
                                },
                                {
                                    code: 'HTG',
                                    name: 'Haiti Gourde'
                                },
                                {
                                    code: 'HUF',
                                    name: 'Hungary Forint'
                                },
                                {
                                    code: 'IDR',
                                    name: 'Indonesia Rupiah'
                                },
                                {
                                    code: 'ILS',
                                    name: 'Israel Shekel'
                                },
                                {
                                    code: 'IMP',
                                    name: 'Isle of Man Pound'
                                },
                                {
                                    code: 'INR',
                                    name: 'India Rupee'
                                },
                                {
                                    code: 'IQD',
                                    name: 'Iraq Dinar'
                                },
                                {
                                    code: 'IRR',
                                    name: 'Iran Rial'
                                },
                                {
                                    code: 'ISK',
                                    name: 'Iceland Krona'
                                },
                                {
                                    code: 'JEP',
                                    name: 'Jersey Pound'
                                },
                                {
                                    code: 'JMD',
                                    name: 'Jamaica Dollar'
                                },
                                {
                                    code: 'JOD',
                                    name: 'Jordan Dinar'
                                },
                                {
                                    code: 'JPY',
                                    name: 'Japan Yen'
                                },
                                {
                                    code: 'KES',
                                    name: 'Kenya Shilling'
                                },
                                {
                                    code: 'KGS',
                                    name: 'Kyrgyzstan Som'
                                },
                                {
                                    code: 'KHR',
                                    name: 'Cambodia Riel'
                                },
                                {
                                    code: 'KMF',
                                    name: 'Comoros Franc'
                                },
                                {
                                    code: 'KPW',
                                    name: 'Korea (North) Won'
                                },
                                {
                                    code: 'KRW',
                                    name: 'Korea (South) Won'
                                },
                                {
                                    code: 'KWD',
                                    name: 'Kuwait Dinar'
                                },
                                {
                                    code: 'KYD',
                                    name: 'Cayman Islands Dollar'
                                },
                                {
                                    code: 'KZT',
                                    name: 'Kazakhstan Tenge'
                                },
                                {
                                    code: 'LAK',
                                    name: 'Laos Kip'
                                },
                                {
                                    code: 'LBP',
                                    name: 'Lebanon Pound'
                                },
                                {
                                    code: 'LKR',
                                    name: 'Sri Lanka Rupee'
                                },
                                {
                                    code: 'LRD',
                                    name: 'Liberia Dollar'
                                },
                                {
                                    code: 'LSL',
                                    name: 'Lesotho Loti'
                                },
                                {
                                    code: 'LTL',
                                    name: 'Lithuania Litas'
                                },
                                {
                                    code: 'LYD',
                                    name: 'Libya Dinar'
                                },
                                {
                                    code: 'MAD',
                                    name: 'Morocco Dirham'
                                },
                                {
                                    code: 'MDL',
                                    name: 'Moldova Leu'
                                },
                                {
                                    code: 'MGA',
                                    name: 'Madagascar Ariary'
                                },
                                {
                                    code: 'MKD',
                                    name: 'Macedonia Denar'
                                },
                                {
                                    code: 'MMK',
                                    name: 'Myanmar (Burma) Kyat'
                                },
                                {
                                    code: 'MNT',
                                    name: 'Mongolia Tughrik'
                                },
                                {
                                    code: 'MOP',
                                    name: 'Macau Pataca'
                                },
                                {
                                    code: 'MRO',
                                    name: 'Mauritania Ouguiya'
                                },
                                {
                                    code: 'MUR',
                                    name: 'Mauritius Rupee'
                                },
                                {
                                    code: 'MVR',
                                    name: 'Maldives (Maldive Islands) Rufiyaa'
                                },
                                {
                                    code: 'MWK',
                                    name: 'Malawi Kwacha'
                                },
                                {
                                    code: 'MXN',
                                    name: 'Mexico Peso'
                                },
                                {
                                    code: 'MYR',
                                    name: 'Malaysia Ringgit'
                                },
                                {
                                    code: 'MZN',
                                    name: 'Mozambique Metical'
                                },
                                {
                                    code: 'NAD',
                                    name: 'Namibia Dollar'
                                },
                                {
                                    code: 'NGN',
                                    name: 'Nigeria Naira'
                                },
                                {
                                    code: 'NIO',
                                    name: 'Nicaragua Cordoba'
                                },
                                {
                                    code: 'NOK',
                                    name: 'Norway Krone'
                                },
                                {
                                    code: 'NPR',
                                    name: 'Nepal Rupee'
                                },
                                {
                                    code: 'NZD',
                                    name: 'New Zealand Dollar'
                                },
                                {
                                    code: 'OMR',
                                    name: 'Oman Rial'
                                },
                                {
                                    code: 'PAB',
                                    name: 'Panama Balboa'
                                },
                                {
                                    code: 'PEN',
                                    name: 'Peru Nuevo Sol'
                                },
                                {
                                    code: 'PGK',
                                    name: 'Papua New Guinea Kina'
                                },
                                {
                                    code: 'PHP',
                                    name: 'Philippines Peso'
                                },
                                {
                                    code: 'PKR',
                                    name: 'Pakistan Rupee'
                                },
                                {
                                    code: 'PLN',
                                    name: 'Poland Zloty'
                                },
                                {
                                    code: 'PYG',
                                    name: 'Paraguay Guarani'
                                },
                                {
                                    code: 'QAR',
                                    name: 'Qatar Riyal'
                                },
                                {
                                    code: 'RON',
                                    name: 'Romania New Leu'
                                },
                                {
                                    code: 'RSD',
                                    name: 'Serbia Dinar'
                                },
                                {
                                    code: 'RUB',
                                    name: 'Russia Ruble'
                                },
                                {
                                    code: 'RWF',
                                    name: 'Rwanda Franc'
                                },
                                {
                                    code: 'SAR',
                                    name: 'Saudi Arabia Riyal'
                                },
                                {
                                    code: 'SBD',
                                    name: 'Solomon Islands Dollar'
                                },
                                {
                                    code: 'SCR',
                                    name: 'Seychelles Rupee'
                                },
                                {
                                    code: 'SDG',
                                    name: 'Sudan Pound'
                                },
                                {
                                    code: 'SEK',
                                    name: 'Sweden Krona'
                                },
                                {
                                    code: 'SGD',
                                    name: 'Singapore Dollar'
                                },
                                {
                                    code: 'SHP',
                                    name: 'Saint Helena Pound'
                                },
                                {
                                    code: 'SLL',
                                    name: 'Sierra Leone Leone'
                                },
                                {
                                    code: 'SOS',
                                    name: 'Somalia Shilling'
                                },
                                {
                                    code: 'SPL',
                                    name: 'Seborga Luigino'
                                },
                                {
                                    code: 'SRD',
                                    name: 'Suriname Dollar'
                                },
                                {
                                    code: 'STD',
                                    name: 'São Tomé and Príncipe Dobra'
                                },
                                {
                                    code: 'SVC',
                                    name: 'El Salvador Colon'
                                },
                                {
                                    code: 'SYP',
                                    name: 'Syria Pound'
                                },
                                {
                                    code: 'SZL',
                                    name: 'Swaziland Lilangeni'
                                },
                                {
                                    code: 'THB',
                                    name: 'Thailand Baht'
                                },
                                {
                                    code: 'TJS',
                                    name: 'Tajikistan Somoni'
                                },
                                {
                                    code: 'TMT',
                                    name: 'Turkmenistan Manat'
                                },
                                {
                                    code: 'TND',
                                    name: 'Tunisia Dinar'
                                },
                                {
                                    code: 'TOP',
                                    name: 'Tonga Pa\'anga'
                                },
                                {
                                    code: 'TRY',
                                    name: 'Turkey Lira'
                                },
                                {
                                    code: 'TTD',
                                    name: 'Trinidad and Tobago Dollar'
                                },
                                {
                                    code: 'TVD',
                                    name: 'Tuvalu Dollar'
                                },
                                {
                                    code: 'TWD',
                                    name: 'Taiwan New Dollar'
                                },
                                {
                                    code: 'TZS',
                                    name: 'Tanzania Shilling'
                                },
                                {
                                    code: 'UAH',
                                    name: 'Ukraine Hryvnia'
                                },
                                {
                                    code: 'UGX',
                                    name: 'Uganda Shilling'
                                },
                                {
                                    code: 'USD',
                                    name: 'United States Dollar'
                                },
                                {
                                    code: 'UYU',
                                    name: 'Uruguay Peso'
                                },
                                {
                                    code: 'UZS',
                                    name: 'Uzbekistan Som'
                                },
                                {
                                    code: 'VEF',
                                    name: 'Venezuela Bolivar'
                                },
                                {
                                    code: 'VND',
                                    name: 'Viet Nam Dong'
                                },
                                {
                                    code: 'VUV',
                                    name: 'Vanuatu Vatu'
                                },
                                {
                                    code: 'WST',
                                    name: 'Samoa Tala'
                                },
                                {
                                    code: 'XAF',
                                    name: 'Communauté Financière Africaine (BEAC) CFA Franc BEAC'
                                },
                                {
                                    code: 'XCD',
                                    name: 'East Caribbean Dollar'
                                },
                                {
                                    code: 'XDR',
                                    name: 'International Monetary Fund (IMF) Special Drawing Rights'
                                },
                                {
                                    code: 'XOF',
                                    name: 'Communauté Financière Africaine (BCEAO) Franc'
                                },
                                {
                                    code: 'XPF',
                                    name: 'Comptoirs Français du Pacifique (CFP) Franc'
                                },
                                {
                                    code: 'YER',
                                    name: 'Yemen Rial'
                                },
                                {
                                    code: 'ZAR',
                                    name: 'South Africa Rand'
                                },
                                {
                                    code: 'ZMW',
                                    name: 'Zambia Kwacha'
                                },
                                {
                                    code: 'ZWD',
                                    name: 'Zimbabwe Dollar'
                                }
                            ],
                            colorNames: [
                                'AliceBlue',
                                'Black',
                                'Navy',
                                'DarkBlue',
                                'MediumBlue',
                                'Blue',
                                'DarkGreen',
                                'Green',
                                'Teal',
                                'DarkCyan',
                                'DeepSkyBlue',
                                'DarkTurquoise',
                                'MediumSpringGreen',
                                'Lime',
                                'SpringGreen',
                                'Aqua',
                                'Cyan',
                                'MidnightBlue',
                                'DodgerBlue',
                                'LightSeaGreen',
                                'ForestGreen',
                                'SeaGreen',
                                'DarkSlateGray',
                                'LimeGreen',
                                'MediumSeaGreen',
                                'Turquoise',
                                'RoyalBlue',
                                'SteelBlue',
                                'DarkSlateBlue',
                                'MediumTurquoise',
                                'Indigo',
                                'DarkOliveGreen',
                                'CadetBlue',
                                'CornflowerBlue',
                                'RebeccaPurple',
                                'MediumAquaMarine',
                                'DimGray',
                                'SlateBlue',
                                'OliveDrab',
                                'SlateGray',
                                'LightSlateGray',
                                'MediumSlateBlue',
                                'LawnGreen',
                                'Chartreuse',
                                'Aquamarine',
                                'Maroon',
                                'Purple',
                                'Olive',
                                'Gray',
                                'SkyBlue',
                                'LightSkyBlue',
                                'BlueViolet',
                                'DarkRed',
                                'DarkMagenta',
                                'SaddleBrown',
                                'Ivory',
                                'White',
                                'DarkSeaGreen',
                                'LightGreen',
                                'MediumPurple',
                                'DarkViolet',
                                'PaleGreen',
                                'DarkOrchid',
                                'YellowGreen',
                                'Sienna',
                                'Brown',
                                'DarkGray',
                                'LightBlue',
                                'GreenYellow',
                                'PaleTurquoise',
                                'LightSteelBlue',
                                'PowderBlue',
                                'FireBrick',
                                'DarkGoldenRod',
                                'MediumOrchid',
                                'RosyBrown',
                                'DarkKhaki',
                                'Silver',
                                'MediumVioletRed',
                                'IndianRed',
                                'Peru',
                                'Chocolate',
                                'Tan',
                                'LightGray',
                                'Thistle',
                                'Orchid',
                                'GoldenRod',
                                'PaleVioletRed',
                                'Crimson',
                                'Gainsboro',
                                'Plum',
                                'BurlyWood',
                                'LightCyan',
                                'Lavender',
                                'DarkSalmon',
                                'Violet',
                                'PaleGoldenRod',
                                'LightCoral',
                                'Khaki',
                                'AliceBlue',
                                'HoneyDew',
                                'Azure',
                                'SandyBrown',
                                'Wheat',
                                'Beige',
                                'WhiteSmoke',
                                'MintCream',
                                'GhostWhite',
                                'Salmon',
                                'AntiqueWhite',
                                'Linen',
                                'LightGoldenRodYellow',
                                'OldLace',
                                'Red',
                                'Fuchsia',
                                'Magenta',
                                'DeepPink',
                                'OrangeRed',
                                'Tomato',
                                'HotPink',
                                'Coral',
                                'DarkOrange',
                                'LightSalmon',
                                'Orange',
                                'LightPink',
                                'Pink',
                                'Gold',
                                'PeachPuff',
                                'NavajoWhite',
                                'Moccasin',
                                'Bisque',
                                'MistyRose',
                                'BlanchedAlmond',
                                'PapayaWhip',
                                'LavenderBlush',
                                'SeaShell',
                                'Cornsilk',
                                'LemonChiffon',
                                'FloralWhite',
                                'Snow',
                                'Yellow',
                                'LightYellow'
                            ],
                            company: [
                                '3Com Corp',
                                '3M Company',
                                'A.G. Edwards Inc.',
                                'Abbott Laboratories',
                                'Abercrombie & Fitch Co.',
                                'ABM Industries Incorporated',
                                'Ace Hardware Corporation',
                                'ACT Manufacturing Inc.',
                                'Acterna Corp.',
                                'Adams Resources & Energy, Inc.',
                                'ADC Telecommunications, Inc.',
                                'Adelphia Communications Corporation',
                                'Administaff, Inc.',
                                'Adobe Systems Incorporated',
                                'Adolph Coors Company',
                                'Advance Auto Parts, Inc.',
                                'Advanced Micro Devices, Inc.',
                                'AdvancePCS, Inc.',
                                'Advantica Restaurant Group, Inc.',
                                'The AES Corporation',
                                'Aetna Inc.',
                                'Affiliated Computer Services, Inc.',
                                'AFLAC Incorporated',
                                'AGCO Corporation',
                                'Agilent Technologies, Inc.',
                                'Agway Inc.',
                                'Apartment Investment and Management Company',
                                'Air Products and Chemicals, Inc.',
                                'Airborne, Inc.',
                                'Airgas, Inc.',
                                'AK Steel Holding Corporation',
                                'Alaska Air Group, Inc.',
                                'Alberto-Culver Company',
                                'Albertson\'s, Inc.',
                                'Alcoa Inc.',
                                'Alleghany Corporation',
                                'Allegheny Energy, Inc.',
                                'Allegheny Technologies Incorporated',
                                'Allergan, Inc.',
                                'ALLETE, Inc.',
                                'Alliant Energy Corporation',
                                'Allied Waste Industries, Inc.',
                                'Allmerica Financial Corporation',
                                'The Allstate Corporation',
                                'ALLTEL Corporation',
                                'The Alpine Group, Inc.',
                                'Amazon.com, Inc.',
                                'AMC Entertainment Inc.',
                                'American Power Conversion Corporation',
                                'Amerada Hess Corporation',
                                'AMERCO',
                                'Ameren Corporation',
                                'America West Holdings Corporation',
                                'American Axle & Manufacturing Holdings, Inc.',
                                'American Eagle Outfitters, Inc.',
                                'American Electric Power Company, Inc.',
                                'American Express Company',
                                'American Financial Group, Inc.',
                                'American Greetings Corporation',
                                'American International Group, Inc.',
                                'American Standard Companies Inc.',
                                'American Water Works Company, Inc.',
                                'AmerisourceBergen Corporation',
                                'Ames Department Stores, Inc.',
                                'Amgen Inc.',
                                'Amkor Technology, Inc.',
                                'AMR Corporation',
                                'AmSouth Bancorp.',
                                'Amtran, Inc.',
                                'Anadarko Petroleum Corporation',
                                'Analog Devices, Inc.',
                                'Anheuser-Busch Companies, Inc.',
                                'Anixter International Inc.',
                                'AnnTaylor Inc.',
                                'Anthem, Inc.',
                                'AOL Time Warner Inc.',
                                'Aon Corporation',
                                'Apache Corporation',
                                'Apple Computer, Inc.',
                                'Applera Corporation',
                                'Applied Industrial Technologies, Inc.',
                                'Applied Materials, Inc.',
                                'Aquila, Inc.',
                                'ARAMARK Corporation',
                                'Arch Coal, Inc.',
                                'Archer Daniels Midland Company',
                                'Arkansas Best Corporation',
                                'Armstrong Holdings, Inc.',
                                'Arrow Electronics, Inc.',
                                'ArvinMeritor, Inc.',
                                'Ashland Inc.',
                                'Astoria Financial Corporation',
                                'AT&T Corp.',
                                'Atmel Corporation',
                                'Atmos Energy Corporation',
                                'Audiovox Corporation',
                                'Autoliv, Inc.',
                                'Automatic Data Processing, Inc.',
                                'AutoNation, Inc.',
                                'AutoZone, Inc.',
                                'Avaya Inc.',
                                'Avery Dennison Corporation',
                                'Avista Corporation',
                                'Avnet, Inc.',
                                'Avon Products, Inc.',
                                'Baker Hughes Incorporated',
                                'Ball Corporation',
                                'Bank of America Corporation',
                                'The Bank of New York Company, Inc.',
                                'Bank One Corporation',
                                'Banknorth Group, Inc.',
                                'Banta Corporation',
                                'Barnes & Noble, Inc.',
                                'Bausch & Lomb Incorporated',
                                'Baxter International Inc.',
                                'BB&T Corporation',
                                'The Bear Stearns Companies Inc.',
                                'Beazer Homes USA, Inc.',
                                'Beckman Coulter, Inc.',
                                'Becton, Dickinson and Company',
                                'Bed Bath & Beyond Inc.',
                                'Belk, Inc.',
                                'Bell Microproducts Inc.',
                                'BellSouth Corporation',
                                'Belo Corp.',
                                'Bemis Company, Inc.',
                                'Benchmark Electronics, Inc.',
                                'Berkshire Hathaway Inc.',
                                'Best Buy Co., Inc.',
                                'Bethlehem Steel Corporation',
                                'Beverly Enterprises, Inc.',
                                'Big Lots, Inc.',
                                'BJ Services Company',
                                'BJ\'s Wholesale Club, Inc.',
                                'The Black & Decker Corporation',
                                'Black Hills Corporation',
                                'BMC Software, Inc.',
                                'The Boeing Company',
                                'Boise Cascade Corporation',
                                'Borders Group, Inc.',
                                'BorgWarner Inc.',
                                'Boston Scientific Corporation',
                                'Bowater Incorporated',
                                'Briggs & Stratton Corporation',
                                'Brightpoint, Inc.',
                                'Brinker International, Inc.',
                                'Bristol-Myers Squibb Company',
                                'Broadwing, Inc.',
                                'Brown Shoe Company, Inc.',
                                'Brown-Forman Corporation',
                                'Brunswick Corporation',
                                'Budget Group, Inc.',
                                'Burlington Coat Factory Warehouse Corporation',
                                'Burlington Industries, Inc.',
                                'Burlington Northern Santa Fe Corporation',
                                'Burlington Resources Inc.',
                                'C. H. Robinson Worldwide Inc.',
                                'Cablevision Systems Corp',
                                'Cabot Corp',
                                'Cadence Design Systems, Inc.',
                                'Calpine Corp.',
                                'Campbell Soup Co.',
                                'Capital One Financial Corp.',
                                'Cardinal Health Inc.',
                                'Caremark Rx Inc.',
                                'Carlisle Cos. Inc.',
                                'Carpenter Technology Corp.',
                                'Casey\'s General Stores Inc.',
                                'Caterpillar Inc.',
                                'CBRL Group Inc.',
                                'CDI Corp.',
                                'CDW Computer Centers Inc.',
                                'CellStar Corp.',
                                'Cendant Corp',
                                'Cenex Harvest States Cooperatives',
                                'Centex Corp.',
                                'CenturyTel Inc.',
                                'Ceridian Corp.',
                                'CH2M Hill Cos. Ltd.',
                                'Champion Enterprises Inc.',
                                'Charles Schwab Corp.',
                                'Charming Shoppes Inc.',
                                'Charter Communications Inc.',
                                'Charter One Financial Inc.',
                                'ChevronTexaco Corp.',
                                'Chiquita Brands International Inc.',
                                'Chubb Corp',
                                'Ciena Corp.',
                                'Cigna Corp',
                                'Cincinnati Financial Corp.',
                                'Cinergy Corp.',
                                'Cintas Corp.',
                                'Circuit City Stores Inc.',
                                'Cisco Systems Inc.',
                                'Citigroup, Inc',
                                'Citizens Communications Co.',
                                'CKE Restaurants Inc.',
                                'Clear Channel Communications Inc.',
                                'The Clorox Co.',
                                'CMGI Inc.',
                                'CMS Energy Corp.',
                                'CNF Inc.',
                                'Coca-Cola Co.',
                                'Coca-Cola Enterprises Inc.',
                                'Colgate-Palmolive Co.',
                                'Collins & Aikman Corp.',
                                'Comcast Corp.',
                                'Comdisco Inc.',
                                'Comerica Inc.',
                                'Comfort Systems USA Inc.',
                                'Commercial Metals Co.',
                                'Community Health Systems Inc.',
                                'Compass Bancshares Inc',
                                'Computer Associates International Inc.',
                                'Computer Sciences Corp.',
                                'Compuware Corp.',
                                'Comverse Technology Inc.',
                                'ConAgra Foods Inc.',
                                'Concord EFS Inc.',
                                'Conectiv, Inc',
                                'Conoco Inc',
                                'Conseco Inc.',
                                'Consolidated Freightways Corp.',
                                'Consolidated Edison Inc.',
                                'Constellation Brands Inc.',
                                'Constellation Emergy Group Inc.',
                                'Continental Airlines Inc.',
                                'Convergys Corp.',
                                'Cooper Cameron Corp.',
                                'Cooper Industries Ltd.',
                                'Cooper Tire & Rubber Co.',
                                'Corn Products International Inc.',
                                'Corning Inc.',
                                'Costco Wholesale Corp.',
                                'Countrywide Credit Industries Inc.',
                                'Coventry Health Care Inc.',
                                'Cox Communications Inc.',
                                'Crane Co.',
                                'Crompton Corp.',
                                'Crown Cork & Seal Co. Inc.',
                                'CSK Auto Corp.',
                                'CSX Corp.',
                                'Cummins Inc.',
                                'CVS Corp.',
                                'Cytec Industries Inc.',
                                'D&K Healthcare Resources, Inc.',
                                'D.R. Horton Inc.',
                                'Dana Corporation',
                                'Danaher Corporation',
                                'Darden Restaurants Inc.',
                                'DaVita Inc.',
                                'Dean Foods Company',
                                'Deere & Company',
                                'Del Monte Foods Co',
                                'Dell Computer Corporation',
                                'Delphi Corp.',
                                'Delta Air Lines Inc.',
                                'Deluxe Corporation',
                                'Devon Energy Corporation',
                                'Di Giorgio Corporation',
                                'Dial Corporation',
                                'Diebold Incorporated',
                                'Dillard\'s Inc.',
                                'DIMON Incorporated',
                                'Dole Food Company, Inc.',
                                'Dollar General Corporation',
                                'Dollar Tree Stores, Inc.',
                                'Dominion Resources, Inc.',
                                'Domino\'s Pizza LLC',
                                'Dover Corporation, Inc.',
                                'Dow Chemical Company',
                                'Dow Jones & Company, Inc.',
                                'DPL Inc.',
                                'DQE Inc.',
                                'Dreyer\'s Grand Ice Cream, Inc.',
                                'DST Systems, Inc.',
                                'DTE Energy Co.',
                                'E.I. Du Pont de Nemours and Company',
                                'Duke Energy Corp',
                                'Dun & Bradstreet Inc.',
                                'DURA Automotive Systems Inc.',
                                'DynCorp',
                                'Dynegy Inc.',
                                'E*Trade Group, Inc.',
                                'E.W. Scripps Company',
                                'Earthlink, Inc.',
                                'Eastman Chemical Company',
                                'Eastman Kodak Company',
                                'Eaton Corporation',
                                'Echostar Communications Corporation',
                                'Ecolab Inc.',
                                'Edison International',
                                'EGL Inc.',
                                'El Paso Corporation',
                                'Electronic Arts Inc.',
                                'Electronic Data Systems Corp.',
                                'Eli Lilly and Company',
                                'EMC Corporation',
                                'Emcor Group Inc.',
                                'Emerson Electric Co.',
                                'Encompass Services Corporation',
                                'Energizer Holdings Inc.',
                                'Energy East Corporation',
                                'Engelhard Corporation',
                                'Enron Corp.',
                                'Entergy Corporation',
                                'Enterprise Products Partners L.P.',
                                'EOG Resources, Inc.',
                                'Equifax Inc.',
                                'Equitable Resources Inc.',
                                'Equity Office Properties Trust',
                                'Equity Residential Properties Trust',
                                'Estee Lauder Companies Inc.',
                                'Exelon Corporation',
                                'Exide Technologies',
                                'Expeditors International of Washington Inc.',
                                'Express Scripts Inc.',
                                'ExxonMobil Corporation',
                                'Fairchild Semiconductor International Inc.',
                                'Family Dollar Stores Inc.',
                                'Farmland Industries Inc.',
                                'Federal Mogul Corp.',
                                'Federated Department Stores Inc.',
                                'Federal Express Corp.',
                                'Felcor Lodging Trust Inc.',
                                'Ferro Corp.',
                                'Fidelity National Financial Inc.',
                                'Fifth Third Bancorp',
                                'First American Financial Corp.',
                                'First Data Corp.',
                                'First National of Nebraska Inc.',
                                'First Tennessee National Corp.',
                                'FirstEnergy Corp.',
                                'Fiserv Inc.',
                                'Fisher Scientific International Inc.',
                                'FleetBoston Financial Co.',
                                'Fleetwood Enterprises Inc.',
                                'Fleming Companies Inc.',
                                'Flowers Foods Inc.',
                                'Flowserv Corp',
                                'Fluor Corp',
                                'FMC Corp',
                                'Foamex International Inc',
                                'Foot Locker Inc',
                                'Footstar Inc.',
                                'Ford Motor Co',
                                'Forest Laboratories Inc.',
                                'Fortune Brands Inc.',
                                'Foster Wheeler Ltd.',
                                'FPL Group Inc.',
                                'Franklin Resources Inc.',
                                'Freeport McMoran Copper & Gold Inc.',
                                'Frontier Oil Corp',
                                'Furniture Brands International Inc.',
                                'Gannett Co., Inc.',
                                'Gap Inc.',
                                'Gateway Inc.',
                                'GATX Corporation',
                                'Gemstar-TV Guide International Inc.',
                                'GenCorp Inc.',
                                'General Cable Corporation',
                                'General Dynamics Corporation',
                                'General Electric Company',
                                'General Mills Inc',
                                'General Motors Corporation',
                                'Genesis Health Ventures Inc.',
                                'Gentek Inc.',
                                'Gentiva Health Services Inc.',
                                'Genuine Parts Company',
                                'Genuity Inc.',
                                'Genzyme Corporation',
                                'Georgia Gulf Corporation',
                                'Georgia-Pacific Corporation',
                                'Gillette Company',
                                'Gold Kist Inc.',
                                'Golden State Bancorp Inc.',
                                'Golden West Financial Corporation',
                                'Goldman Sachs Group Inc.',
                                'Goodrich Corporation',
                                'The Goodyear Tire & Rubber Company',
                                'Granite Construction Incorporated',
                                'Graybar Electric Company Inc.',
                                'Great Lakes Chemical Corporation',
                                'Great Plains Energy Inc.',
                                'GreenPoint Financial Corp.',
                                'Greif Bros. Corporation',
                                'Grey Global Group Inc.',
                                'Group 1 Automotive Inc.',
                                'Guidant Corporation',
                                'H&R Block Inc.',
                                'H.B. Fuller Company',
                                'H.J. Heinz Company',
                                'Halliburton Co.',
                                'Harley-Davidson Inc.',
                                'Harman International Industries Inc.',
                                'Harrah\'s Entertainment Inc.',
                                'Harris Corp.',
                                'Harsco Corp.',
                                'Hartford Financial Services Group Inc.',
                                'Hasbro Inc.',
                                'Hawaiian Electric Industries Inc.',
                                'HCA Inc.',
                                'Health Management Associates Inc.',
                                'Health Net Inc.',
                                'Healthsouth Corp',
                                'Henry Schein Inc.',
                                'Hercules Inc.',
                                'Herman Miller Inc.',
                                'Hershey Foods Corp.',
                                'Hewlett-Packard Company',
                                'Hibernia Corp.',
                                'Hillenbrand Industries Inc.',
                                'Hilton Hotels Corp.',
                                'Hollywood Entertainment Corp.',
                                'Home Depot Inc.',
                                'Hon Industries Inc.',
                                'Honeywell International Inc.',
                                'Hormel Foods Corp.',
                                'Host Marriott Corp.',
                                'Household International Corp.',
                                'Hovnanian Enterprises Inc.',
                                'Hub Group Inc.',
                                'Hubbell Inc.',
                                'Hughes Supply Inc.',
                                'Humana Inc.',
                                'Huntington Bancshares Inc.',
                                'Idacorp Inc.',
                                'IDT Corporation',
                                'IKON Office Solutions Inc.',
                                'Illinois Tool Works Inc.',
                                'IMC Global Inc.',
                                'Imperial Sugar Company',
                                'IMS Health Inc.',
                                'Ingles Market Inc',
                                'Ingram Micro Inc.',
                                'Insight Enterprises Inc.',
                                'Integrated Electrical Services Inc.',
                                'Intel Corporation',
                                'International Paper Co.',
                                'Interpublic Group of Companies Inc.',
                                'Interstate Bakeries Corporation',
                                'International Business Machines Corp.',
                                'International Flavors & Fragrances Inc.',
                                'International Multifoods Corporation',
                                'Intuit Inc.',
                                'IT Group Inc.',
                                'ITT Industries Inc.',
                                'Ivax Corp.',
                                'J.B. Hunt Transport Services Inc.',
                                'J.C. Penny Co.',
                                'J.P. Morgan Chase & Co.',
                                'Jabil Circuit Inc.',
                                'Jack In The Box Inc.',
                                'Jacobs Engineering Group Inc.',
                                'JDS Uniphase Corp.',
                                'Jefferson-Pilot Co.',
                                'John Hancock Financial Services Inc.',
                                'Johnson & Johnson',
                                'Johnson Controls Inc.',
                                'Jones Apparel Group Inc.',
                                'KB Home',
                                'Kellogg Company',
                                'Kellwood Company',
                                'Kelly Services Inc.',
                                'Kemet Corp.',
                                'Kennametal Inc.',
                                'Kerr-McGee Corporation',
                                'KeyCorp',
                                'KeySpan Corp.',
                                'Kimball International Inc.',
                                'Kimberly-Clark Corporation',
                                'Kindred Healthcare Inc.',
                                'KLA-Tencor Corporation',
                                'K-Mart Corp.',
                                'Knight-Ridder Inc.',
                                'Kohl\'s Corp.',
                                'KPMG Consulting Inc.',
                                'Kroger Co.',
                                'L-3 Communications Holdings Inc.',
                                'Laboratory Corporation of America Holdings',
                                'Lam Research Corporation',
                                'LandAmerica Financial Group Inc.',
                                'Lands\' End Inc.',
                                'Landstar System Inc.',
                                'La-Z-Boy Inc.',
                                'Lear Corporation',
                                'Legg Mason Inc.',
                                'Leggett & Platt Inc.',
                                'Lehman Brothers Holdings Inc.',
                                'Lennar Corporation',
                                'Lennox International Inc.',
                                'Level 3 Communications Inc.',
                                'Levi Strauss & Co.',
                                'Lexmark International Inc.',
                                'Limited Inc.',
                                'Lincoln National Corporation',
                                'Linens \'n Things Inc.',
                                'Lithia Motors Inc.',
                                'Liz Claiborne Inc.',
                                'Lockheed Martin Corporation',
                                'Loews Corporation',
                                'Longs Drug Stores Corporation',
                                'Louisiana-Pacific Corporation',
                                'Lowe\'s Companies Inc.',
                                'LSI Logic Corporation',
                                'The LTV Corporation',
                                'The Lubrizol Corporation',
                                'Lucent Technologies Inc.',
                                'Lyondell Chemical Company',
                                'M & T Bank Corporation',
                                'Magellan Health Services Inc.',
                                'Mail-Well Inc.',
                                'Mandalay Resort Group',
                                'Manor Care Inc.',
                                'Manpower Inc.',
                                'Marathon Oil Corporation',
                                'Mariner Health Care Inc.',
                                'Markel Corporation',
                                'Marriott International Inc.',
                                'Marsh & McLennan Companies Inc.',
                                'Marsh Supermarkets Inc.',
                                'Marshall & Ilsley Corporation',
                                'Martin Marietta Materials Inc.',
                                'Masco Corporation',
                                'Massey Energy Company',
                                'MasTec Inc.',
                                'Mattel Inc.',
                                'Maxim Integrated Products Inc.',
                                'Maxtor Corporation',
                                'Maxxam Inc.',
                                'The May Department Stores Company',
                                'Maytag Corporation',
                                'MBNA Corporation',
                                'McCormick & Company Incorporated',
                                'McDonald\'s Corporation',
                                'The McGraw-Hill Companies Inc.',
                                'McKesson Corporation',
                                'McLeodUSA Incorporated',
                                'M.D.C. Holdings Inc.',
                                'MDU Resources Group Inc.',
                                'MeadWestvaco Corporation',
                                'Medtronic Inc.',
                                'Mellon Financial Corporation',
                                'The Men\'s Wearhouse Inc.',
                                'Merck & Co., Inc.',
                                'Mercury General Corporation',
                                'Merrill Lynch & Co. Inc.',
                                'Metaldyne Corporation',
                                'Metals USA Inc.',
                                'MetLife Inc.',
                                'Metris Companies Inc',
                                'MGIC Investment Corporation',
                                'MGM Mirage',
                                'Michaels Stores Inc.',
                                'Micron Technology Inc.',
                                'Microsoft Corporation',
                                'Milacron Inc.',
                                'Millennium Chemicals Inc.',
                                'Mirant Corporation',
                                'Mohawk Industries Inc.',
                                'Molex Incorporated',
                                'The MONY Group Inc.',
                                'Morgan Stanley Dean Witter & Co.',
                                'Motorola Inc.',
                                'MPS Group Inc.',
                                'Murphy Oil Corporation',
                                'Nabors Industries Inc',
                                'Nacco Industries Inc',
                                'Nash Finch Company',
                                'National City Corp.',
                                'National Commerce Financial Corporation',
                                'National Fuel Gas Company',
                                'National Oilwell Inc',
                                'National Rural Utilities Cooperative Finance Corporation',
                                'National Semiconductor Corporation',
                                'National Service Industries Inc',
                                'Navistar International Corporation',
                                'NCR Corporation',
                                'The Neiman Marcus Group Inc.',
                                'New Jersey Resources Corporation',
                                'New York Times Company',
                                'Newell Rubbermaid Inc',
                                'Newmont Mining Corporation',
                                'Nextel Communications Inc',
                                'Nicor Inc',
                                'Nike Inc',
                                'NiSource Inc',
                                'Noble Energy Inc',
                                'Nordstrom Inc',
                                'Norfolk Southern Corporation',
                                'Nortek Inc',
                                'North Fork Bancorporation Inc',
                                'Northeast Utilities System',
                                'Northern Trust Corporation',
                                'Northrop Grumman Corporation',
                                'NorthWestern Corporation',
                                'Novellus Systems Inc',
                                'NSTAR',
                                'NTL Incorporated',
                                'Nucor Corp',
                                'Nvidia Corp',
                                'NVR Inc',
                                'Northwest Airlines Corp',
                                'Occidental Petroleum Corp',
                                'Ocean Energy Inc',
                                'Office Depot Inc.',
                                'OfficeMax Inc',
                                'OGE Energy Corp',
                                'Oglethorpe Power Corp.',
                                'Ohio Casualty Corp.',
                                'Old Republic International Corp.',
                                'Olin Corp.',
                                'OM Group Inc',
                                'Omnicare Inc',
                                'Omnicom Group',
                                'On Semiconductor Corp',
                                'ONEOK Inc',
                                'Oracle Corp',
                                'Oshkosh Truck Corp',
                                'Outback Steakhouse Inc.',
                                'Owens & Minor Inc.',
                                'Owens Corning',
                                'Owens-Illinois Inc',
                                'Oxford Health Plans Inc',
                                'Paccar Inc',
                                'PacifiCare Health Systems Inc',
                                'Packaging Corp. of America',
                                'Pactiv Corp',
                                'Pall Corp',
                                'Pantry Inc',
                                'Park Place Entertainment Corp',
                                'Parker Hannifin Corp.',
                                'Pathmark Stores Inc.',
                                'Paychex Inc',
                                'Payless Shoesource Inc',
                                'Penn Traffic Co.',
                                'Pennzoil-Quaker State Company',
                                'Pentair Inc',
                                'Peoples Energy Corp.',
                                'PeopleSoft Inc',
                                'Pep Boys Manny, Moe & Jack',
                                'Potomac Electric Power Co.',
                                'Pepsi Bottling Group Inc.',
                                'PepsiAmericas Inc.',
                                'PepsiCo Inc.',
                                'Performance Food Group Co.',
                                'Perini Corp',
                                'PerkinElmer Inc',
                                'Perot Systems Corp',
                                'Petco Animal Supplies Inc.',
                                'Peter Kiewit Sons\', Inc.',
                                'PETsMART Inc',
                                'Pfizer Inc',
                                'Pacific Gas & Electric Corp.',
                                'Pharmacia Corp',
                                'Phar Mor Inc.',
                                'Phelps Dodge Corp.',
                                'Philip Morris Companies Inc.',
                                'Phillips Petroleum Co',
                                'Phillips Van Heusen Corp.',
                                'Phoenix Companies Inc',
                                'Pier 1 Imports Inc.',
                                'Pilgrim\'s Pride Corporation',
                                'Pinnacle West Capital Corp',
                                'Pioneer-Standard Electronics Inc.',
                                'Pitney Bowes Inc.',
                                'Pittston Brinks Group',
                                'Plains All American Pipeline LP',
                                'PNC Financial Services Group Inc.',
                                'PNM Resources Inc',
                                'Polaris Industries Inc.',
                                'Polo Ralph Lauren Corp',
                                'PolyOne Corp',
                                'Popular Inc',
                                'Potlatch Corp',
                                'PPG Industries Inc',
                                'PPL Corp',
                                'Praxair Inc',
                                'Precision Castparts Corp',
                                'Premcor Inc.',
                                'Pride International Inc',
                                'Primedia Inc',
                                'Principal Financial Group Inc.',
                                'Procter & Gamble Co.',
                                'Pro-Fac Cooperative Inc.',
                                'Progress Energy Inc',
                                'Progressive Corporation',
                                'Protective Life Corp',
                                'Provident Financial Group',
                                'Providian Financial Corp.',
                                'Prudential Financial Inc.',
                                'PSS World Medical Inc',
                                'Public Service Enterprise Group Inc.',
                                'Publix Super Markets Inc.',
                                'Puget Energy Inc.',
                                'Pulte Homes Inc',
                                'Qualcomm Inc',
                                'Quanta Services Inc.',
                                'Quantum Corp',
                                'Quest Diagnostics Inc.',
                                'Questar Corp',
                                'Quintiles Transnational',
                                'Qwest Communications Intl Inc',
                                'R.J. Reynolds Tobacco Company',
                                'R.R. Donnelley & Sons Company',
                                'Radio Shack Corporation',
                                'Raymond James Financial Inc.',
                                'Raytheon Company',
                                'Reader\'s Digest Association Inc.',
                                'Reebok International Ltd.',
                                'Regions Financial Corp.',
                                'Regis Corporation',
                                'Reliance Steel & Aluminum Co.',
                                'Reliant Energy Inc.',
                                'Rent A Center Inc',
                                'Republic Services Inc',
                                'Revlon Inc',
                                'RGS Energy Group Inc',
                                'Rite Aid Corp',
                                'Riverwood Holding Inc.',
                                'RoadwayCorp',
                                'Robert Half International Inc.',
                                'Rock-Tenn Co',
                                'Rockwell Automation Inc',
                                'Rockwell Collins Inc',
                                'Rohm & Haas Co.',
                                'Ross Stores Inc',
                                'RPM Inc.',
                                'Ruddick Corp',
                                'Ryder System Inc',
                                'Ryerson Tull Inc',
                                'Ryland Group Inc.',
                                'Sabre Holdings Corp',
                                'Safeco Corp',
                                'Safeguard Scientifics Inc.',
                                'Safeway Inc',
                                'Saks Inc',
                                'Sanmina-SCI Inc',
                                'Sara Lee Corp',
                                'SBC Communications Inc',
                                'Scana Corp.',
                                'Schering-Plough Corp',
                                'Scholastic Corp',
                                'SCI Systems Onc.',
                                'Science Applications Intl. Inc.',
                                'Scientific-Atlanta Inc',
                                'Scotts Company',
                                'Seaboard Corp',
                                'Sealed Air Corp',
                                'Sears Roebuck & Co',
                                'Sempra Energy',
                                'Sequa Corp',
                                'Service Corp. International',
                                'ServiceMaster Co',
                                'Shaw Group Inc',
                                'Sherwin-Williams Company',
                                'Shopko Stores Inc',
                                'Siebel Systems Inc',
                                'Sierra Health Services Inc',
                                'Sierra Pacific Resources',
                                'Silgan Holdings Inc.',
                                'Silicon Graphics Inc',
                                'Simon Property Group Inc',
                                'SLM Corporation',
                                'Smith International Inc',
                                'Smithfield Foods Inc',
                                'Smurfit-Stone Container Corp',
                                'Snap-On Inc',
                                'Solectron Corp',
                                'Solutia Inc',
                                'Sonic Automotive Inc.',
                                'Sonoco Products Co.',
                                'Southern Company',
                                'Southern Union Company',
                                'SouthTrust Corp.',
                                'Southwest Airlines Co',
                                'Southwest Gas Corp',
                                'Sovereign Bancorp Inc.',
                                'Spartan Stores Inc',
                                'Spherion Corp',
                                'Sports Authority Inc',
                                'Sprint Corp.',
                                'SPX Corp',
                                'St. Jude Medical Inc',
                                'St. Paul Cos.',
                                'Staff Leasing Inc.',
                                'StanCorp Financial Group Inc',
                                'Standard Pacific Corp.',
                                'Stanley Works',
                                'Staples Inc',
                                'Starbucks Corp',
                                'Starwood Hotels & Resorts Worldwide Inc',
                                'State Street Corp.',
                                'Stater Bros. Holdings Inc.',
                                'Steelcase Inc',
                                'Stein Mart Inc',
                                'Stewart & Stevenson Services Inc',
                                'Stewart Information Services Corp',
                                'Stilwell Financial Inc',
                                'Storage Technology Corporation',
                                'Stryker Corp',
                                'Sun Healthcare Group Inc.',
                                'Sun Microsystems Inc.',
                                'SunGard Data Systems Inc.',
                                'Sunoco Inc.',
                                'SunTrust Banks Inc',
                                'Supervalu Inc',
                                'Swift Transportation, Co., Inc',
                                'Symbol Technologies Inc',
                                'Synovus Financial Corp.',
                                'Sysco Corp',
                                'Systemax Inc.',
                                'Target Corp.',
                                'Tech Data Corporation',
                                'TECO Energy Inc',
                                'Tecumseh Products Company',
                                'Tektronix Inc',
                                'Teleflex Incorporated',
                                'Telephone & Data Systems Inc',
                                'Tellabs Inc.',
                                'Temple-Inland Inc',
                                'Tenet Healthcare Corporation',
                                'Tenneco Automotive Inc.',
                                'Teradyne Inc',
                                'Terex Corp',
                                'Tesoro Petroleum Corp.',
                                'Texas Industries Inc.',
                                'Texas Instruments Incorporated',
                                'Textron Inc',
                                'Thermo Electron Corporation',
                                'Thomas & Betts Corporation',
                                'Tiffany & Co',
                                'Timken Company',
                                'TJX Companies Inc',
                                'TMP Worldwide Inc',
                                'Toll Brothers Inc',
                                'Torchmark Corporation',
                                'Toro Company',
                                'Tower Automotive Inc.',
                                'Toys \'R\' Us Inc',
                                'Trans World Entertainment Corp.',
                                'TransMontaigne Inc',
                                'Transocean Inc',
                                'TravelCenters of America Inc.',
                                'Triad Hospitals Inc',
                                'Tribune Company',
                                'Trigon Healthcare Inc.',
                                'Trinity Industries Inc',
                                'Trump Hotels & Casino Resorts Inc.',
                                'TruServ Corporation',
                                'TRW Inc',
                                'TXU Corp',
                                'Tyson Foods Inc',
                                'U.S. Bancorp',
                                'U.S. Industries Inc.',
                                'UAL Corporation',
                                'UGI Corporation',
                                'Unified Western Grocers Inc',
                                'Union Pacific Corporation',
                                'Union Planters Corp',
                                'Unisource Energy Corp',
                                'Unisys Corporation',
                                'United Auto Group Inc',
                                'United Defense Industries Inc.',
                                'United Parcel Service Inc',
                                'United Rentals Inc',
                                'United Stationers Inc',
                                'United Technologies Corporation',
                                'UnitedHealth Group Incorporated',
                                'Unitrin Inc',
                                'Universal Corporation',
                                'Universal Forest Products Inc',
                                'Universal Health Services Inc',
                                'Unocal Corporation',
                                'Unova Inc',
                                'UnumProvident Corporation',
                                'URS Corporation',
                                'US Airways Group Inc',
                                'US Oncology Inc',
                                'USA Interactive',
                                'USFreighways Corporation',
                                'USG Corporation',
                                'UST Inc',
                                'Valero Energy Corporation',
                                'Valspar Corporation',
                                'Value City Department Stores Inc',
                                'Varco International Inc',
                                'Vectren Corporation',
                                'Veritas Software Corporation',
                                'Verizon Communications Inc',
                                'VF Corporation',
                                'Viacom Inc',
                                'Viad Corp',
                                'Viasystems Group Inc',
                                'Vishay Intertechnology Inc',
                                'Visteon Corporation',
                                'Volt Information Sciences Inc',
                                'Vulcan Materials Company',
                                'W.R. Berkley Corporation',
                                'W.R. Grace & Co',
                                'W.W. Grainger Inc',
                                'Wachovia Corporation',
                                'Wakenhut Corporation',
                                'Walgreen Co',
                                'Wallace Computer Services Inc',
                                'Wal-Mart Stores Inc',
                                'Walt Disney Co',
                                'Walter Industries Inc',
                                'Washington Mutual Inc',
                                'Washington Post Co.',
                                'Waste Management Inc',
                                'Watsco Inc',
                                'Weatherford International Inc',
                                'Weis Markets Inc.',
                                'Wellpoint Health Networks Inc',
                                'Wells Fargo & Company',
                                'Wendy\'s International Inc',
                                'Werner Enterprises Inc',
                                'WESCO International Inc',
                                'Western Digital Inc',
                                'Western Gas Resources Inc',
                                'WestPoint Stevens Inc',
                                'Weyerhauser Company',
                                'WGL Holdings Inc',
                                'Whirlpool Corporation',
                                'Whole Foods Market Inc',
                                'Willamette Industries Inc.',
                                'Williams Companies Inc',
                                'Williams Sonoma Inc',
                                'Winn Dixie Stores Inc',
                                'Wisconsin Energy Corporation',
                                'Wm Wrigley Jr Company',
                                'World Fuel Services Corporation',
                                'WorldCom Inc',
                                'Worthington Industries Inc',
                                'WPS Resources Corporation',
                                'Wyeth',
                                'Wyndham International Inc',
                                'Xcel Energy Inc',
                                'Xerox Corp',
                                'Xilinx Inc',
                                'XO Communications Inc',
                                'Yellow Corporation',
                                'York International Corp',
                                'Yum Brands Inc.',
                                'Zale Corporation',
                                'Zions Bancorporation'
                            ],
                            fileExtension: {
                                raster: [
                                    'bmp',
                                    'gif',
                                    'gpl',
                                    'ico',
                                    'jpeg',
                                    'psd',
                                    'png',
                                    'psp',
                                    'raw',
                                    'tiff'
                                ],
                                vector: [
                                    '3dv',
                                    'amf',
                                    'awg',
                                    'ai',
                                    'cgm',
                                    'cdr',
                                    'cmx',
                                    'dxf',
                                    'e2d',
                                    'egt',
                                    'eps',
                                    'fs',
                                    'odg',
                                    'svg',
                                    'xar'
                                ],
                                '3d': [
                                    '3dmf',
                                    '3dm',
                                    '3mf',
                                    '3ds',
                                    'an8',
                                    'aoi',
                                    'blend',
                                    'cal3d',
                                    'cob',
                                    'ctm',
                                    'iob',
                                    'jas',
                                    'max',
                                    'mb',
                                    'mdx',
                                    'obj',
                                    'x',
                                    'x3d'
                                ],
                                document: [
                                    'doc',
                                    'docx',
                                    'dot',
                                    'html',
                                    'xml',
                                    'odt',
                                    'odm',
                                    'ott',
                                    'csv',
                                    'rtf',
                                    'tex',
                                    'xhtml',
                                    'xps'
                                ]
                            },
                            timezones: [
                                {
                                    name: 'Dateline Standard Time',
                                    abbr: 'DST',
                                    offset: -12,
                                    isdst: !1,
                                    text: '(UTC-12:00) International Date Line West',
                                    utc: ['Etc/GMT+12']
                                },
                                {
                                    name: 'UTC-11',
                                    abbr: 'U',
                                    offset: -11,
                                    isdst: !1,
                                    text: '(UTC-11:00) Coordinated Universal Time-11',
                                    utc: [
                                        'Etc/GMT+11',
                                        'Pacific/Midway',
                                        'Pacific/Niue',
                                        'Pacific/Pago_Pago'
                                    ]
                                },
                                {
                                    name: 'Hawaiian Standard Time',
                                    abbr: 'HST',
                                    offset: -10,
                                    isdst: !1,
                                    text: '(UTC-10:00) Hawaii',
                                    utc: [
                                        'Etc/GMT+10',
                                        'Pacific/Honolulu',
                                        'Pacific/Johnston',
                                        'Pacific/Rarotonga',
                                        'Pacific/Tahiti'
                                    ]
                                },
                                {
                                    name: 'Alaskan Standard Time',
                                    abbr: 'AKDT',
                                    offset: -8,
                                    isdst: !0,
                                    text: '(UTC-09:00) Alaska',
                                    utc: [
                                        'America/Anchorage',
                                        'America/Juneau',
                                        'America/Nome',
                                        'America/Sitka',
                                        'America/Yakutat'
                                    ]
                                },
                                {
                                    name: 'Pacific Standard Time (Mexico)',
                                    abbr: 'PDT',
                                    offset: -7,
                                    isdst: !0,
                                    text: '(UTC-08:00) Baja California',
                                    utc: ['America/Santa_Isabel']
                                },
                                {
                                    name: 'Pacific Daylight Time',
                                    abbr: 'PDT',
                                    offset: -7,
                                    isdst: !0,
                                    text: '(UTC-07:00) Pacific Time (US & Canada)',
                                    utc: [
                                        'America/Dawson',
                                        'America/Los_Angeles',
                                        'America/Tijuana',
                                        'America/Vancouver',
                                        'America/Whitehorse'
                                    ]
                                },
                                {
                                    name: 'Pacific Standard Time',
                                    abbr: 'PST',
                                    offset: -8,
                                    isdst: !1,
                                    text: '(UTC-08:00) Pacific Time (US & Canada)',
                                    utc: [
                                        'America/Dawson',
                                        'America/Los_Angeles',
                                        'America/Tijuana',
                                        'America/Vancouver',
                                        'America/Whitehorse',
                                        'PST8PDT'
                                    ]
                                },
                                {
                                    name: 'US Mountain Standard Time',
                                    abbr: 'UMST',
                                    offset: -7,
                                    isdst: !1,
                                    text: '(UTC-07:00) Arizona',
                                    utc: [
                                        'America/Creston',
                                        'America/Dawson_Creek',
                                        'America/Hermosillo',
                                        'America/Phoenix',
                                        'Etc/GMT+7'
                                    ]
                                },
                                {
                                    name: 'Mountain Standard Time (Mexico)',
                                    abbr: 'MDT',
                                    offset: -6,
                                    isdst: !0,
                                    text: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
                                    utc: [
                                        'America/Chihuahua',
                                        'America/Mazatlan'
                                    ]
                                },
                                {
                                    name: 'Mountain Standard Time',
                                    abbr: 'MDT',
                                    offset: -6,
                                    isdst: !0,
                                    text: '(UTC-07:00) Mountain Time (US & Canada)',
                                    utc: [
                                        'America/Boise',
                                        'America/Cambridge_Bay',
                                        'America/Denver',
                                        'America/Edmonton',
                                        'America/Inuvik',
                                        'America/Ojinaga',
                                        'America/Yellowknife',
                                        'MST7MDT'
                                    ]
                                },
                                {
                                    name: 'Central America Standard Time',
                                    abbr: 'CAST',
                                    offset: -6,
                                    isdst: !1,
                                    text: '(UTC-06:00) Central America',
                                    utc: [
                                        'America/Belize',
                                        'America/Costa_Rica',
                                        'America/El_Salvador',
                                        'America/Guatemala',
                                        'America/Managua',
                                        'America/Tegucigalpa',
                                        'Etc/GMT+6',
                                        'Pacific/Galapagos'
                                    ]
                                },
                                {
                                    name: 'Central Standard Time',
                                    abbr: 'CDT',
                                    offset: -5,
                                    isdst: !0,
                                    text: '(UTC-06:00) Central Time (US & Canada)',
                                    utc: [
                                        'America/Chicago',
                                        'America/Indiana/Knox',
                                        'America/Indiana/Tell_City',
                                        'America/Matamoros',
                                        'America/Menominee',
                                        'America/North_Dakota/Beulah',
                                        'America/North_Dakota/Center',
                                        'America/North_Dakota/New_Salem',
                                        'America/Rainy_River',
                                        'America/Rankin_Inlet',
                                        'America/Resolute',
                                        'America/Winnipeg',
                                        'CST6CDT'
                                    ]
                                },
                                {
                                    name: 'Central Standard Time (Mexico)',
                                    abbr: 'CDT',
                                    offset: -5,
                                    isdst: !0,
                                    text: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
                                    utc: [
                                        'America/Bahia_Banderas',
                                        'America/Cancun',
                                        'America/Merida',
                                        'America/Mexico_City',
                                        'America/Monterrey'
                                    ]
                                },
                                {
                                    name: 'Canada Central Standard Time',
                                    abbr: 'CCST',
                                    offset: -6,
                                    isdst: !1,
                                    text: '(UTC-06:00) Saskatchewan',
                                    utc: [
                                        'America/Regina',
                                        'America/Swift_Current'
                                    ]
                                },
                                {
                                    name: 'SA Pacific Standard Time',
                                    abbr: 'SPST',
                                    offset: -5,
                                    isdst: !1,
                                    text: '(UTC-05:00) Bogota, Lima, Quito',
                                    utc: [
                                        'America/Bogota',
                                        'America/Cayman',
                                        'America/Coral_Harbour',
                                        'America/Eirunepe',
                                        'America/Guayaquil',
                                        'America/Jamaica',
                                        'America/Lima',
                                        'America/Panama',
                                        'America/Rio_Branco',
                                        'Etc/GMT+5'
                                    ]
                                },
                                {
                                    name: 'Eastern Standard Time',
                                    abbr: 'EDT',
                                    offset: -4,
                                    isdst: !0,
                                    text: '(UTC-05:00) Eastern Time (US & Canada)',
                                    utc: [
                                        'America/Detroit',
                                        'America/Havana',
                                        'America/Indiana/Petersburg',
                                        'America/Indiana/Vincennes',
                                        'America/Indiana/Winamac',
                                        'America/Iqaluit',
                                        'America/Kentucky/Monticello',
                                        'America/Louisville',
                                        'America/Montreal',
                                        'America/Nassau',
                                        'America/New_York',
                                        'America/Nipigon',
                                        'America/Pangnirtung',
                                        'America/Port-au-Prince',
                                        'America/Thunder_Bay',
                                        'America/Toronto',
                                        'EST5EDT'
                                    ]
                                },
                                {
                                    name: 'US Eastern Standard Time',
                                    abbr: 'UEDT',
                                    offset: -4,
                                    isdst: !0,
                                    text: '(UTC-05:00) Indiana (East)',
                                    utc: [
                                        'America/Indiana/Marengo',
                                        'America/Indiana/Vevay',
                                        'America/Indianapolis'
                                    ]
                                },
                                {
                                    name: 'Venezuela Standard Time',
                                    abbr: 'VST',
                                    offset: -4.5,
                                    isdst: !1,
                                    text: '(UTC-04:30) Caracas',
                                    utc: ['America/Caracas']
                                },
                                {
                                    name: 'Paraguay Standard Time',
                                    abbr: 'PYT',
                                    offset: -4,
                                    isdst: !1,
                                    text: '(UTC-04:00) Asuncion',
                                    utc: ['America/Asuncion']
                                },
                                {
                                    name: 'Atlantic Standard Time',
                                    abbr: 'ADT',
                                    offset: -3,
                                    isdst: !0,
                                    text: '(UTC-04:00) Atlantic Time (Canada)',
                                    utc: [
                                        'America/Glace_Bay',
                                        'America/Goose_Bay',
                                        'America/Halifax',
                                        'America/Moncton',
                                        'America/Thule',
                                        'Atlantic/Bermuda'
                                    ]
                                },
                                {
                                    name: 'Central Brazilian Standard Time',
                                    abbr: 'CBST',
                                    offset: -4,
                                    isdst: !1,
                                    text: '(UTC-04:00) Cuiaba',
                                    utc: [
                                        'America/Campo_Grande',
                                        'America/Cuiaba'
                                    ]
                                },
                                {
                                    name: 'SA Western Standard Time',
                                    abbr: 'SWST',
                                    offset: -4,
                                    isdst: !1,
                                    text: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
                                    utc: [
                                        'America/Anguilla',
                                        'America/Antigua',
                                        'America/Aruba',
                                        'America/Barbados',
                                        'America/Blanc-Sablon',
                                        'America/Boa_Vista',
                                        'America/Curacao',
                                        'America/Dominica',
                                        'America/Grand_Turk',
                                        'America/Grenada',
                                        'America/Guadeloupe',
                                        'America/Guyana',
                                        'America/Kralendijk',
                                        'America/La_Paz',
                                        'America/Lower_Princes',
                                        'America/Manaus',
                                        'America/Marigot',
                                        'America/Martinique',
                                        'America/Montserrat',
                                        'America/Port_of_Spain',
                                        'America/Porto_Velho',
                                        'America/Puerto_Rico',
                                        'America/Santo_Domingo',
                                        'America/St_Barthelemy',
                                        'America/St_Kitts',
                                        'America/St_Lucia',
                                        'America/St_Thomas',
                                        'America/St_Vincent',
                                        'America/Tortola',
                                        'Etc/GMT+4'
                                    ]
                                },
                                {
                                    name: 'Pacific SA Standard Time',
                                    abbr: 'PSST',
                                    offset: -4,
                                    isdst: !1,
                                    text: '(UTC-04:00) Santiago',
                                    utc: [
                                        'America/Santiago',
                                        'Antarctica/Palmer'
                                    ]
                                },
                                {
                                    name: 'Newfoundland Standard Time',
                                    abbr: 'NDT',
                                    offset: -2.5,
                                    isdst: !0,
                                    text: '(UTC-03:30) Newfoundland',
                                    utc: ['America/St_Johns']
                                },
                                {
                                    name: 'E. South America Standard Time',
                                    abbr: 'ESAST',
                                    offset: -3,
                                    isdst: !1,
                                    text: '(UTC-03:00) Brasilia',
                                    utc: ['America/Sao_Paulo']
                                },
                                {
                                    name: 'Argentina Standard Time',
                                    abbr: 'AST',
                                    offset: -3,
                                    isdst: !1,
                                    text: '(UTC-03:00) Buenos Aires',
                                    utc: [
                                        'America/Argentina/La_Rioja',
                                        'America/Argentina/Rio_Gallegos',
                                        'America/Argentina/Salta',
                                        'America/Argentina/San_Juan',
                                        'America/Argentina/San_Luis',
                                        'America/Argentina/Tucuman',
                                        'America/Argentina/Ushuaia',
                                        'America/Buenos_Aires',
                                        'America/Catamarca',
                                        'America/Cordoba',
                                        'America/Jujuy',
                                        'America/Mendoza'
                                    ]
                                },
                                {
                                    name: 'SA Eastern Standard Time',
                                    abbr: 'SEST',
                                    offset: -3,
                                    isdst: !1,
                                    text: '(UTC-03:00) Cayenne, Fortaleza',
                                    utc: [
                                        'America/Araguaina',
                                        'America/Belem',
                                        'America/Cayenne',
                                        'America/Fortaleza',
                                        'America/Maceio',
                                        'America/Paramaribo',
                                        'America/Recife',
                                        'America/Santarem',
                                        'Antarctica/Rothera',
                                        'Atlantic/Stanley',
                                        'Etc/GMT+3'
                                    ]
                                },
                                {
                                    name: 'Greenland Standard Time',
                                    abbr: 'GDT',
                                    offset: -3,
                                    isdst: !0,
                                    text: '(UTC-03:00) Greenland',
                                    utc: ['America/Godthab']
                                },
                                {
                                    name: 'Montevideo Standard Time',
                                    abbr: 'MST',
                                    offset: -3,
                                    isdst: !1,
                                    text: '(UTC-03:00) Montevideo',
                                    utc: ['America/Montevideo']
                                },
                                {
                                    name: 'Bahia Standard Time',
                                    abbr: 'BST',
                                    offset: -3,
                                    isdst: !1,
                                    text: '(UTC-03:00) Salvador',
                                    utc: ['America/Bahia']
                                },
                                {
                                    name: 'UTC-02',
                                    abbr: 'U',
                                    offset: -2,
                                    isdst: !1,
                                    text: '(UTC-02:00) Coordinated Universal Time-02',
                                    utc: [
                                        'America/Noronha',
                                        'Atlantic/South_Georgia',
                                        'Etc/GMT+2'
                                    ]
                                },
                                {
                                    name: 'Mid-Atlantic Standard Time',
                                    abbr: 'MDT',
                                    offset: -1,
                                    isdst: !0,
                                    text: '(UTC-02:00) Mid-Atlantic - Old',
                                    utc: []
                                },
                                {
                                    name: 'Azores Standard Time',
                                    abbr: 'ADT',
                                    offset: 0,
                                    isdst: !0,
                                    text: '(UTC-01:00) Azores',
                                    utc: [
                                        'America/Scoresbysund',
                                        'Atlantic/Azores'
                                    ]
                                },
                                {
                                    name: 'Cape Verde Standard Time',
                                    abbr: 'CVST',
                                    offset: -1,
                                    isdst: !1,
                                    text: '(UTC-01:00) Cape Verde Is.',
                                    utc: [
                                        'Atlantic/Cape_Verde',
                                        'Etc/GMT+1'
                                    ]
                                },
                                {
                                    name: 'Morocco Standard Time',
                                    abbr: 'MDT',
                                    offset: 1,
                                    isdst: !0,
                                    text: '(UTC) Casablanca',
                                    utc: [
                                        'Africa/Casablanca',
                                        'Africa/El_Aaiun'
                                    ]
                                },
                                {
                                    name: 'UTC',
                                    abbr: 'UTC',
                                    offset: 0,
                                    isdst: !1,
                                    text: '(UTC) Coordinated Universal Time',
                                    utc: [
                                        'America/Danmarkshavn',
                                        'Etc/GMT'
                                    ]
                                },
                                {
                                    name: 'GMT Standard Time',
                                    abbr: 'GMT',
                                    offset: 0,
                                    isdst: !1,
                                    text: '(UTC) Edinburgh, London',
                                    utc: [
                                        'Europe/Isle_of_Man',
                                        'Europe/Guernsey',
                                        'Europe/Jersey',
                                        'Europe/London'
                                    ]
                                },
                                {
                                    name: 'British Summer Time',
                                    abbr: 'BST',
                                    offset: 1,
                                    isdst: !0,
                                    text: '(UTC+01:00) Edinburgh, London',
                                    utc: [
                                        'Europe/Isle_of_Man',
                                        'Europe/Guernsey',
                                        'Europe/Jersey',
                                        'Europe/London'
                                    ]
                                },
                                {
                                    name: 'GMT Standard Time',
                                    abbr: 'GDT',
                                    offset: 1,
                                    isdst: !0,
                                    text: '(UTC) Dublin, Lisbon',
                                    utc: [
                                        'Atlantic/Canary',
                                        'Atlantic/Faeroe',
                                        'Atlantic/Madeira',
                                        'Europe/Dublin',
                                        'Europe/Lisbon'
                                    ]
                                },
                                {
                                    name: 'Greenwich Standard Time',
                                    abbr: 'GST',
                                    offset: 0,
                                    isdst: !1,
                                    text: '(UTC) Monrovia, Reykjavik',
                                    utc: [
                                        'Africa/Abidjan',
                                        'Africa/Accra',
                                        'Africa/Bamako',
                                        'Africa/Banjul',
                                        'Africa/Bissau',
                                        'Africa/Conakry',
                                        'Africa/Dakar',
                                        'Africa/Freetown',
                                        'Africa/Lome',
                                        'Africa/Monrovia',
                                        'Africa/Nouakchott',
                                        'Africa/Ouagadougou',
                                        'Africa/Sao_Tome',
                                        'Atlantic/Reykjavik',
                                        'Atlantic/St_Helena'
                                    ]
                                },
                                {
                                    name: 'W. Europe Standard Time',
                                    abbr: 'WEDT',
                                    offset: 2,
                                    isdst: !0,
                                    text: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
                                    utc: [
                                        'Arctic/Longyearbyen',
                                        'Europe/Amsterdam',
                                        'Europe/Andorra',
                                        'Europe/Berlin',
                                        'Europe/Busingen',
                                        'Europe/Gibraltar',
                                        'Europe/Luxembourg',
                                        'Europe/Malta',
                                        'Europe/Monaco',
                                        'Europe/Oslo',
                                        'Europe/Rome',
                                        'Europe/San_Marino',
                                        'Europe/Stockholm',
                                        'Europe/Vaduz',
                                        'Europe/Vatican',
                                        'Europe/Vienna',
                                        'Europe/Zurich'
                                    ]
                                },
                                {
                                    name: 'Central Europe Standard Time',
                                    abbr: 'CEDT',
                                    offset: 2,
                                    isdst: !0,
                                    text: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
                                    utc: [
                                        'Europe/Belgrade',
                                        'Europe/Bratislava',
                                        'Europe/Budapest',
                                        'Europe/Ljubljana',
                                        'Europe/Podgorica',
                                        'Europe/Prague',
                                        'Europe/Tirane'
                                    ]
                                },
                                {
                                    name: 'Romance Standard Time',
                                    abbr: 'RDT',
                                    offset: 2,
                                    isdst: !0,
                                    text: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
                                    utc: [
                                        'Africa/Ceuta',
                                        'Europe/Brussels',
                                        'Europe/Copenhagen',
                                        'Europe/Madrid',
                                        'Europe/Paris'
                                    ]
                                },
                                {
                                    name: 'Central European Standard Time',
                                    abbr: 'CEDT',
                                    offset: 2,
                                    isdst: !0,
                                    text: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
                                    utc: [
                                        'Europe/Sarajevo',
                                        'Europe/Skopje',
                                        'Europe/Warsaw',
                                        'Europe/Zagreb'
                                    ]
                                },
                                {
                                    name: 'W. Central Africa Standard Time',
                                    abbr: 'WCAST',
                                    offset: 1,
                                    isdst: !1,
                                    text: '(UTC+01:00) West Central Africa',
                                    utc: [
                                        'Africa/Algiers',
                                        'Africa/Bangui',
                                        'Africa/Brazzaville',
                                        'Africa/Douala',
                                        'Africa/Kinshasa',
                                        'Africa/Lagos',
                                        'Africa/Libreville',
                                        'Africa/Luanda',
                                        'Africa/Malabo',
                                        'Africa/Ndjamena',
                                        'Africa/Niamey',
                                        'Africa/Porto-Novo',
                                        'Africa/Tunis',
                                        'Etc/GMT-1'
                                    ]
                                },
                                {
                                    name: 'Namibia Standard Time',
                                    abbr: 'NST',
                                    offset: 1,
                                    isdst: !1,
                                    text: '(UTC+01:00) Windhoek',
                                    utc: ['Africa/Windhoek']
                                },
                                {
                                    name: 'GTB Standard Time',
                                    abbr: 'GDT',
                                    offset: 3,
                                    isdst: !0,
                                    text: '(UTC+02:00) Athens, Bucharest',
                                    utc: [
                                        'Asia/Nicosia',
                                        'Europe/Athens',
                                        'Europe/Bucharest',
                                        'Europe/Chisinau'
                                    ]
                                },
                                {
                                    name: 'Middle East Standard Time',
                                    abbr: 'MEDT',
                                    offset: 3,
                                    isdst: !0,
                                    text: '(UTC+02:00) Beirut',
                                    utc: ['Asia/Beirut']
                                },
                                {
                                    name: 'Egypt Standard Time',
                                    abbr: 'EST',
                                    offset: 2,
                                    isdst: !1,
                                    text: '(UTC+02:00) Cairo',
                                    utc: ['Africa/Cairo']
                                },
                                {
                                    name: 'Syria Standard Time',
                                    abbr: 'SDT',
                                    offset: 3,
                                    isdst: !0,
                                    text: '(UTC+02:00) Damascus',
                                    utc: ['Asia/Damascus']
                                },
                                {
                                    name: 'E. Europe Standard Time',
                                    abbr: 'EEDT',
                                    offset: 3,
                                    isdst: !0,
                                    text: '(UTC+02:00) E. Europe',
                                    utc: [
                                        'Asia/Nicosia',
                                        'Europe/Athens',
                                        'Europe/Bucharest',
                                        'Europe/Chisinau',
                                        'Europe/Helsinki',
                                        'Europe/Kiev',
                                        'Europe/Mariehamn',
                                        'Europe/Nicosia',
                                        'Europe/Riga',
                                        'Europe/Sofia',
                                        'Europe/Tallinn',
                                        'Europe/Uzhgorod',
                                        'Europe/Vilnius',
                                        'Europe/Zaporozhye'
                                    ]
                                },
                                {
                                    name: 'South Africa Standard Time',
                                    abbr: 'SAST',
                                    offset: 2,
                                    isdst: !1,
                                    text: '(UTC+02:00) Harare, Pretoria',
                                    utc: [
                                        'Africa/Blantyre',
                                        'Africa/Bujumbura',
                                        'Africa/Gaborone',
                                        'Africa/Harare',
                                        'Africa/Johannesburg',
                                        'Africa/Kigali',
                                        'Africa/Lubumbashi',
                                        'Africa/Lusaka',
                                        'Africa/Maputo',
                                        'Africa/Maseru',
                                        'Africa/Mbabane',
                                        'Etc/GMT-2'
                                    ]
                                },
                                {
                                    name: 'FLE Standard Time',
                                    abbr: 'FDT',
                                    offset: 3,
                                    isdst: !0,
                                    text: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
                                    utc: [
                                        'Europe/Helsinki',
                                        'Europe/Kiev',
                                        'Europe/Mariehamn',
                                        'Europe/Riga',
                                        'Europe/Sofia',
                                        'Europe/Tallinn',
                                        'Europe/Uzhgorod',
                                        'Europe/Vilnius',
                                        'Europe/Zaporozhye'
                                    ]
                                },
                                {
                                    name: 'Turkey Standard Time',
                                    abbr: 'TDT',
                                    offset: 3,
                                    isdst: !1,
                                    text: '(UTC+03:00) Istanbul',
                                    utc: ['Europe/Istanbul']
                                },
                                {
                                    name: 'Israel Standard Time',
                                    abbr: 'JDT',
                                    offset: 3,
                                    isdst: !0,
                                    text: '(UTC+02:00) Jerusalem',
                                    utc: ['Asia/Jerusalem']
                                },
                                {
                                    name: 'Libya Standard Time',
                                    abbr: 'LST',
                                    offset: 2,
                                    isdst: !1,
                                    text: '(UTC+02:00) Tripoli',
                                    utc: ['Africa/Tripoli']
                                },
                                {
                                    name: 'Jordan Standard Time',
                                    abbr: 'JST',
                                    offset: 3,
                                    isdst: !1,
                                    text: '(UTC+03:00) Amman',
                                    utc: ['Asia/Amman']
                                },
                                {
                                    name: 'Arabic Standard Time',
                                    abbr: 'AST',
                                    offset: 3,
                                    isdst: !1,
                                    text: '(UTC+03:00) Baghdad',
                                    utc: ['Asia/Baghdad']
                                },
                                {
                                    name: 'Kaliningrad Standard Time',
                                    abbr: 'KST',
                                    offset: 3,
                                    isdst: !1,
                                    text: '(UTC+02:00) Kaliningrad',
                                    utc: ['Europe/Kaliningrad']
                                },
                                {
                                    name: 'Arab Standard Time',
                                    abbr: 'AST',
                                    offset: 3,
                                    isdst: !1,
                                    text: '(UTC+03:00) Kuwait, Riyadh',
                                    utc: [
                                        'Asia/Aden',
                                        'Asia/Bahrain',
                                        'Asia/Kuwait',
                                        'Asia/Qatar',
                                        'Asia/Riyadh'
                                    ]
                                },
                                {
                                    name: 'E. Africa Standard Time',
                                    abbr: 'EAST',
                                    offset: 3,
                                    isdst: !1,
                                    text: '(UTC+03:00) Nairobi',
                                    utc: [
                                        'Africa/Addis_Ababa',
                                        'Africa/Asmera',
                                        'Africa/Dar_es_Salaam',
                                        'Africa/Djibouti',
                                        'Africa/Juba',
                                        'Africa/Kampala',
                                        'Africa/Khartoum',
                                        'Africa/Mogadishu',
                                        'Africa/Nairobi',
                                        'Antarctica/Syowa',
                                        'Etc/GMT-3',
                                        'Indian/Antananarivo',
                                        'Indian/Comoro',
                                        'Indian/Mayotte'
                                    ]
                                },
                                {
                                    name: 'Moscow Standard Time',
                                    abbr: 'MSK',
                                    offset: 3,
                                    isdst: !1,
                                    text: '(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk',
                                    utc: [
                                        'Europe/Kirov',
                                        'Europe/Moscow',
                                        'Europe/Simferopol',
                                        'Europe/Volgograd',
                                        'Europe/Minsk'
                                    ]
                                },
                                {
                                    name: 'Samara Time',
                                    abbr: 'SAMT',
                                    offset: 4,
                                    isdst: !1,
                                    text: '(UTC+04:00) Samara, Ulyanovsk, Saratov',
                                    utc: [
                                        'Europe/Astrakhan',
                                        'Europe/Samara',
                                        'Europe/Ulyanovsk'
                                    ]
                                },
                                {
                                    name: 'Iran Standard Time',
                                    abbr: 'IDT',
                                    offset: 4.5,
                                    isdst: !0,
                                    text: '(UTC+03:30) Tehran',
                                    utc: ['Asia/Tehran']
                                },
                                {
                                    name: 'Arabian Standard Time',
                                    abbr: 'AST',
                                    offset: 4,
                                    isdst: !1,
                                    text: '(UTC+04:00) Abu Dhabi, Muscat',
                                    utc: [
                                        'Asia/Dubai',
                                        'Asia/Muscat',
                                        'Etc/GMT-4'
                                    ]
                                },
                                {
                                    name: 'Azerbaijan Standard Time',
                                    abbr: 'ADT',
                                    offset: 5,
                                    isdst: !0,
                                    text: '(UTC+04:00) Baku',
                                    utc: ['Asia/Baku']
                                },
                                {
                                    name: 'Mauritius Standard Time',
                                    abbr: 'MST',
                                    offset: 4,
                                    isdst: !1,
                                    text: '(UTC+04:00) Port Louis',
                                    utc: [
                                        'Indian/Mahe',
                                        'Indian/Mauritius',
                                        'Indian/Reunion'
                                    ]
                                },
                                {
                                    name: 'Georgian Standard Time',
                                    abbr: 'GET',
                                    offset: 4,
                                    isdst: !1,
                                    text: '(UTC+04:00) Tbilisi',
                                    utc: ['Asia/Tbilisi']
                                },
                                {
                                    name: 'Caucasus Standard Time',
                                    abbr: 'CST',
                                    offset: 4,
                                    isdst: !1,
                                    text: '(UTC+04:00) Yerevan',
                                    utc: ['Asia/Yerevan']
                                },
                                {
                                    name: 'Afghanistan Standard Time',
                                    abbr: 'AST',
                                    offset: 4.5,
                                    isdst: !1,
                                    text: '(UTC+04:30) Kabul',
                                    utc: ['Asia/Kabul']
                                },
                                {
                                    name: 'West Asia Standard Time',
                                    abbr: 'WAST',
                                    offset: 5,
                                    isdst: !1,
                                    text: '(UTC+05:00) Ashgabat, Tashkent',
                                    utc: [
                                        'Antarctica/Mawson',
                                        'Asia/Aqtau',
                                        'Asia/Aqtobe',
                                        'Asia/Ashgabat',
                                        'Asia/Dushanbe',
                                        'Asia/Oral',
                                        'Asia/Samarkand',
                                        'Asia/Tashkent',
                                        'Etc/GMT-5',
                                        'Indian/Kerguelen',
                                        'Indian/Maldives'
                                    ]
                                },
                                {
                                    name: 'Yekaterinburg Time',
                                    abbr: 'YEKT',
                                    offset: 5,
                                    isdst: !1,
                                    text: '(UTC+05:00) Yekaterinburg',
                                    utc: ['Asia/Yekaterinburg']
                                },
                                {
                                    name: 'Pakistan Standard Time',
                                    abbr: 'PKT',
                                    offset: 5,
                                    isdst: !1,
                                    text: '(UTC+05:00) Islamabad, Karachi',
                                    utc: ['Asia/Karachi']
                                },
                                {
                                    name: 'India Standard Time',
                                    abbr: 'IST',
                                    offset: 5.5,
                                    isdst: !1,
                                    text: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
                                    utc: ['Asia/Kolkata']
                                },
                                {
                                    name: 'Sri Lanka Standard Time',
                                    abbr: 'SLST',
                                    offset: 5.5,
                                    isdst: !1,
                                    text: '(UTC+05:30) Sri Jayawardenepura',
                                    utc: ['Asia/Colombo']
                                },
                                {
                                    name: 'Nepal Standard Time',
                                    abbr: 'NST',
                                    offset: 5.75,
                                    isdst: !1,
                                    text: '(UTC+05:45) Kathmandu',
                                    utc: ['Asia/Kathmandu']
                                },
                                {
                                    name: 'Central Asia Standard Time',
                                    abbr: 'CAST',
                                    offset: 6,
                                    isdst: !1,
                                    text: '(UTC+06:00) Nur-Sultan (Astana)',
                                    utc: [
                                        'Antarctica/Vostok',
                                        'Asia/Almaty',
                                        'Asia/Bishkek',
                                        'Asia/Qyzylorda',
                                        'Asia/Urumqi',
                                        'Etc/GMT-6',
                                        'Indian/Chagos'
                                    ]
                                },
                                {
                                    name: 'Bangladesh Standard Time',
                                    abbr: 'BST',
                                    offset: 6,
                                    isdst: !1,
                                    text: '(UTC+06:00) Dhaka',
                                    utc: [
                                        'Asia/Dhaka',
                                        'Asia/Thimphu'
                                    ]
                                },
                                {
                                    name: 'Myanmar Standard Time',
                                    abbr: 'MST',
                                    offset: 6.5,
                                    isdst: !1,
                                    text: '(UTC+06:30) Yangon (Rangoon)',
                                    utc: [
                                        'Asia/Rangoon',
                                        'Indian/Cocos'
                                    ]
                                },
                                {
                                    name: 'SE Asia Standard Time',
                                    abbr: 'SAST',
                                    offset: 7,
                                    isdst: !1,
                                    text: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
                                    utc: [
                                        'Antarctica/Davis',
                                        'Asia/Bangkok',
                                        'Asia/Hovd',
                                        'Asia/Jakarta',
                                        'Asia/Phnom_Penh',
                                        'Asia/Pontianak',
                                        'Asia/Saigon',
                                        'Asia/Vientiane',
                                        'Etc/GMT-7',
                                        'Indian/Christmas'
                                    ]
                                },
                                {
                                    name: 'N. Central Asia Standard Time',
                                    abbr: 'NCAST',
                                    offset: 7,
                                    isdst: !1,
                                    text: '(UTC+07:00) Novosibirsk',
                                    utc: [
                                        'Asia/Novokuznetsk',
                                        'Asia/Novosibirsk',
                                        'Asia/Omsk'
                                    ]
                                },
                                {
                                    name: 'China Standard Time',
                                    abbr: 'CST',
                                    offset: 8,
                                    isdst: !1,
                                    text: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
                                    utc: [
                                        'Asia/Hong_Kong',
                                        'Asia/Macau',
                                        'Asia/Shanghai'
                                    ]
                                },
                                {
                                    name: 'North Asia Standard Time',
                                    abbr: 'NAST',
                                    offset: 8,
                                    isdst: !1,
                                    text: '(UTC+08:00) Krasnoyarsk',
                                    utc: ['Asia/Krasnoyarsk']
                                },
                                {
                                    name: 'Singapore Standard Time',
                                    abbr: 'MPST',
                                    offset: 8,
                                    isdst: !1,
                                    text: '(UTC+08:00) Kuala Lumpur, Singapore',
                                    utc: [
                                        'Asia/Brunei',
                                        'Asia/Kuala_Lumpur',
                                        'Asia/Kuching',
                                        'Asia/Makassar',
                                        'Asia/Manila',
                                        'Asia/Singapore',
                                        'Etc/GMT-8'
                                    ]
                                },
                                {
                                    name: 'W. Australia Standard Time',
                                    abbr: 'WAST',
                                    offset: 8,
                                    isdst: !1,
                                    text: '(UTC+08:00) Perth',
                                    utc: [
                                        'Antarctica/Casey',
                                        'Australia/Perth'
                                    ]
                                },
                                {
                                    name: 'Taipei Standard Time',
                                    abbr: 'TST',
                                    offset: 8,
                                    isdst: !1,
                                    text: '(UTC+08:00) Taipei',
                                    utc: ['Asia/Taipei']
                                },
                                {
                                    name: 'Ulaanbaatar Standard Time',
                                    abbr: 'UST',
                                    offset: 8,
                                    isdst: !1,
                                    text: '(UTC+08:00) Ulaanbaatar',
                                    utc: [
                                        'Asia/Choibalsan',
                                        'Asia/Ulaanbaatar'
                                    ]
                                },
                                {
                                    name: 'North Asia East Standard Time',
                                    abbr: 'NAEST',
                                    offset: 8,
                                    isdst: !1,
                                    text: '(UTC+08:00) Irkutsk',
                                    utc: ['Asia/Irkutsk']
                                },
                                {
                                    name: 'Japan Standard Time',
                                    abbr: 'JST',
                                    offset: 9,
                                    isdst: !1,
                                    text: '(UTC+09:00) Osaka, Sapporo, Tokyo',
                                    utc: [
                                        'Asia/Dili',
                                        'Asia/Jayapura',
                                        'Asia/Tokyo',
                                        'Etc/GMT-9',
                                        'Pacific/Palau'
                                    ]
                                },
                                {
                                    name: 'Korea Standard Time',
                                    abbr: 'KST',
                                    offset: 9,
                                    isdst: !1,
                                    text: '(UTC+09:00) Seoul',
                                    utc: [
                                        'Asia/Pyongyang',
                                        'Asia/Seoul'
                                    ]
                                },
                                {
                                    name: 'Cen. Australia Standard Time',
                                    abbr: 'CAST',
                                    offset: 9.5,
                                    isdst: !1,
                                    text: '(UTC+09:30) Adelaide',
                                    utc: [
                                        'Australia/Adelaide',
                                        'Australia/Broken_Hill'
                                    ]
                                },
                                {
                                    name: 'AUS Central Standard Time',
                                    abbr: 'ACST',
                                    offset: 9.5,
                                    isdst: !1,
                                    text: '(UTC+09:30) Darwin',
                                    utc: ['Australia/Darwin']
                                },
                                {
                                    name: 'E. Australia Standard Time',
                                    abbr: 'EAST',
                                    offset: 10,
                                    isdst: !1,
                                    text: '(UTC+10:00) Brisbane',
                                    utc: [
                                        'Australia/Brisbane',
                                        'Australia/Lindeman'
                                    ]
                                },
                                {
                                    name: 'AUS Eastern Standard Time',
                                    abbr: 'AEST',
                                    offset: 10,
                                    isdst: !1,
                                    text: '(UTC+10:00) Canberra, Melbourne, Sydney',
                                    utc: [
                                        'Australia/Melbourne',
                                        'Australia/Sydney'
                                    ]
                                },
                                {
                                    name: 'West Pacific Standard Time',
                                    abbr: 'WPST',
                                    offset: 10,
                                    isdst: !1,
                                    text: '(UTC+10:00) Guam, Port Moresby',
                                    utc: [
                                        'Antarctica/DumontDUrville',
                                        'Etc/GMT-10',
                                        'Pacific/Guam',
                                        'Pacific/Port_Moresby',
                                        'Pacific/Saipan',
                                        'Pacific/Truk'
                                    ]
                                },
                                {
                                    name: 'Tasmania Standard Time',
                                    abbr: 'TST',
                                    offset: 10,
                                    isdst: !1,
                                    text: '(UTC+10:00) Hobart',
                                    utc: [
                                        'Australia/Currie',
                                        'Australia/Hobart'
                                    ]
                                },
                                {
                                    name: 'Yakutsk Standard Time',
                                    abbr: 'YST',
                                    offset: 9,
                                    isdst: !1,
                                    text: '(UTC+09:00) Yakutsk',
                                    utc: [
                                        'Asia/Chita',
                                        'Asia/Khandyga',
                                        'Asia/Yakutsk'
                                    ]
                                },
                                {
                                    name: 'Central Pacific Standard Time',
                                    abbr: 'CPST',
                                    offset: 11,
                                    isdst: !1,
                                    text: '(UTC+11:00) Solomon Is., New Caledonia',
                                    utc: [
                                        'Antarctica/Macquarie',
                                        'Etc/GMT-11',
                                        'Pacific/Efate',
                                        'Pacific/Guadalcanal',
                                        'Pacific/Kosrae',
                                        'Pacific/Noumea',
                                        'Pacific/Ponape'
                                    ]
                                },
                                {
                                    name: 'Vladivostok Standard Time',
                                    abbr: 'VST',
                                    offset: 11,
                                    isdst: !1,
                                    text: '(UTC+11:00) Vladivostok',
                                    utc: [
                                        'Asia/Sakhalin',
                                        'Asia/Ust-Nera',
                                        'Asia/Vladivostok'
                                    ]
                                },
                                {
                                    name: 'New Zealand Standard Time',
                                    abbr: 'NZST',
                                    offset: 12,
                                    isdst: !1,
                                    text: '(UTC+12:00) Auckland, Wellington',
                                    utc: [
                                        'Antarctica/McMurdo',
                                        'Pacific/Auckland'
                                    ]
                                },
                                {
                                    name: 'UTC+12',
                                    abbr: 'U',
                                    offset: 12,
                                    isdst: !1,
                                    text: '(UTC+12:00) Coordinated Universal Time+12',
                                    utc: [
                                        'Etc/GMT-12',
                                        'Pacific/Funafuti',
                                        'Pacific/Kwajalein',
                                        'Pacific/Majuro',
                                        'Pacific/Nauru',
                                        'Pacific/Tarawa',
                                        'Pacific/Wake',
                                        'Pacific/Wallis'
                                    ]
                                },
                                {
                                    name: 'Fiji Standard Time',
                                    abbr: 'FST',
                                    offset: 12,
                                    isdst: !1,
                                    text: '(UTC+12:00) Fiji',
                                    utc: ['Pacific/Fiji']
                                },
                                {
                                    name: 'Magadan Standard Time',
                                    abbr: 'MST',
                                    offset: 12,
                                    isdst: !1,
                                    text: '(UTC+12:00) Magadan',
                                    utc: [
                                        'Asia/Anadyr',
                                        'Asia/Kamchatka',
                                        'Asia/Magadan',
                                        'Asia/Srednekolymsk'
                                    ]
                                },
                                {
                                    name: 'Kamchatka Standard Time',
                                    abbr: 'KDT',
                                    offset: 13,
                                    isdst: !0,
                                    text: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
                                    utc: ['Asia/Kamchatka']
                                },
                                {
                                    name: 'Tonga Standard Time',
                                    abbr: 'TST',
                                    offset: 13,
                                    isdst: !1,
                                    text: '(UTC+13:00) Nuku\'alofa',
                                    utc: [
                                        'Etc/GMT-13',
                                        'Pacific/Enderbury',
                                        'Pacific/Fakaofo',
                                        'Pacific/Tongatapu'
                                    ]
                                },
                                {
                                    name: 'Samoa Standard Time',
                                    abbr: 'SST',
                                    offset: 13,
                                    isdst: !1,
                                    text: '(UTC+13:00) Samoa',
                                    utc: ['Pacific/Apia']
                                }
                            ],
                            profession: [
                                'Airline Pilot',
                                'Academic Team',
                                'Accountant',
                                'Account Executive',
                                'Actor',
                                'Actuary',
                                'Acquisition Analyst',
                                'Administrative Asst.',
                                'Administrative Analyst',
                                'Administrator',
                                'Advertising Director',
                                'Aerospace Engineer',
                                'Agent',
                                'Agricultural Inspector',
                                'Agricultural Scientist',
                                'Air Traffic Controller',
                                'Animal Trainer',
                                'Anthropologist',
                                'Appraiser',
                                'Architect',
                                'Art Director',
                                'Artist',
                                'Astronomer',
                                'Athletic Coach',
                                'Auditor',
                                'Author',
                                'Baker',
                                'Banker',
                                'Bankruptcy Attorney',
                                'Benefits Manager',
                                'Biologist',
                                'Bio-feedback Specialist',
                                'Biomedical Engineer',
                                'Biotechnical Researcher',
                                'Broadcaster',
                                'Broker',
                                'Building Manager',
                                'Building Contractor',
                                'Building Inspector',
                                'Business Analyst',
                                'Business Planner',
                                'Business Manager',
                                'Buyer',
                                'Call Center Manager',
                                'Career Counselor',
                                'Cash Manager',
                                'Ceramic Engineer',
                                'Chief Executive Officer',
                                'Chief Operation Officer',
                                'Chef',
                                'Chemical Engineer',
                                'Chemist',
                                'Child Care Manager',
                                'Chief Medical Officer',
                                'Chiropractor',
                                'Cinematographer',
                                'City Housing Manager',
                                'City Manager',
                                'Civil Engineer',
                                'Claims Manager',
                                'Clinical Research Assistant',
                                'Collections Manager',
                                'Compliance Manager',
                                'Comptroller',
                                'Computer Manager',
                                'Commercial Artist',
                                'Communications Affairs Director',
                                'Communications Director',
                                'Communications Engineer',
                                'Compensation Analyst',
                                'Computer Programmer',
                                'Computer Ops. Manager',
                                'Computer Engineer',
                                'Computer Operator',
                                'Computer Graphics Specialist',
                                'Construction Engineer',
                                'Construction Manager',
                                'Consultant',
                                'Consumer Relations Manager',
                                'Contract Administrator',
                                'Copyright Attorney',
                                'Copywriter',
                                'Corporate Planner',
                                'Corrections Officer',
                                'Cosmetologist',
                                'Credit Analyst',
                                'Cruise Director',
                                'Chief Information Officer',
                                'Chief Technology Officer',
                                'Customer Service Manager',
                                'Cryptologist',
                                'Dancer',
                                'Data Security Manager',
                                'Database Manager',
                                'Day Care Instructor',
                                'Dentist',
                                'Designer',
                                'Design Engineer',
                                'Desktop Publisher',
                                'Developer',
                                'Development Officer',
                                'Diamond Merchant',
                                'Dietitian',
                                'Direct Marketer',
                                'Director',
                                'Distribution Manager',
                                'Diversity Manager',
                                'Economist',
                                'EEO Compliance Manager',
                                'Editor',
                                'Education Adminator',
                                'Electrical Engineer',
                                'Electro Optical Engineer',
                                'Electronics Engineer',
                                'Embassy Management',
                                'Employment Agent',
                                'Engineer Technician',
                                'Entrepreneur',
                                'Environmental Analyst',
                                'Environmental Attorney',
                                'Environmental Engineer',
                                'Environmental Specialist',
                                'Escrow Officer',
                                'Estimator',
                                'Executive Assistant',
                                'Executive Director',
                                'Executive Recruiter',
                                'Facilities Manager',
                                'Family Counselor',
                                'Fashion Events Manager',
                                'Fashion Merchandiser',
                                'Fast Food Manager',
                                'Film Producer',
                                'Film Production Assistant',
                                'Financial Analyst',
                                'Financial Planner',
                                'Financier',
                                'Fine Artist',
                                'Wildlife Specialist',
                                'Fitness Consultant',
                                'Flight Attendant',
                                'Flight Engineer',
                                'Floral Designer',
                                'Food & Beverage Director',
                                'Food Service Manager',
                                'Forestry Technician',
                                'Franchise Management',
                                'Franchise Sales',
                                'Fraud Investigator',
                                'Freelance Writer',
                                'Fund Raiser',
                                'General Manager',
                                'Geologist',
                                'General Counsel',
                                'Geriatric Specialist',
                                'Gerontologist',
                                'Glamour Photographer',
                                'Golf Club Manager',
                                'Gourmet Chef',
                                'Graphic Designer',
                                'Grounds Keeper',
                                'Hazardous Waste Manager',
                                'Health Care Manager',
                                'Health Therapist',
                                'Health Service Administrator',
                                'Hearing Officer',
                                'Home Economist',
                                'Horticulturist',
                                'Hospital Administrator',
                                'Hotel Manager',
                                'Human Resources Manager',
                                'Importer',
                                'Industrial Designer',
                                'Industrial Engineer',
                                'Information Director',
                                'Inside Sales',
                                'Insurance Adjuster',
                                'Interior Decorator',
                                'Internal Controls Director',
                                'International Acct.',
                                'International Courier',
                                'International Lawyer',
                                'Interpreter',
                                'Investigator',
                                'Investment Banker',
                                'Investment Manager',
                                'IT Architect',
                                'IT Project Manager',
                                'IT Systems Analyst',
                                'Jeweler',
                                'Joint Venture Manager',
                                'Journalist',
                                'Labor Negotiator',
                                'Labor Organizer',
                                'Labor Relations Manager',
                                'Lab Services Director',
                                'Lab Technician',
                                'Land Developer',
                                'Landscape Architect',
                                'Law Enforcement Officer',
                                'Lawyer',
                                'Lead Software Engineer',
                                'Lead Software Test Engineer',
                                'Leasing Manager',
                                'Legal Secretary',
                                'Library Manager',
                                'Litigation Attorney',
                                'Loan Officer',
                                'Lobbyist',
                                'Logistics Manager',
                                'Maintenance Manager',
                                'Management Consultant',
                                'Managed Care Director',
                                'Managing Partner',
                                'Manufacturing Director',
                                'Manpower Planner',
                                'Marine Biologist',
                                'Market Res. Analyst',
                                'Marketing Director',
                                'Materials Manager',
                                'Mathematician',
                                'Membership Chairman',
                                'Mechanic',
                                'Mechanical Engineer',
                                'Media Buyer',
                                'Medical Investor',
                                'Medical Secretary',
                                'Medical Technician',
                                'Mental Health Counselor',
                                'Merchandiser',
                                'Metallurgical Engineering',
                                'Meteorologist',
                                'Microbiologist',
                                'MIS Manager',
                                'Motion Picture Director',
                                'Multimedia Director',
                                'Musician',
                                'Network Administrator',
                                'Network Specialist',
                                'Network Operator',
                                'New Product Manager',
                                'Novelist',
                                'Nuclear Engineer',
                                'Nuclear Specialist',
                                'Nutritionist',
                                'Nursing Administrator',
                                'Occupational Therapist',
                                'Oceanographer',
                                'Office Manager',
                                'Operations Manager',
                                'Operations Research Director',
                                'Optical Technician',
                                'Optometrist',
                                'Organizational Development Manager',
                                'Outplacement Specialist',
                                'Paralegal',
                                'Park Ranger',
                                'Patent Attorney',
                                'Payroll Specialist',
                                'Personnel Specialist',
                                'Petroleum Engineer',
                                'Pharmacist',
                                'Photographer',
                                'Physical Therapist',
                                'Physician',
                                'Physician Assistant',
                                'Physicist',
                                'Planning Director',
                                'Podiatrist',
                                'Political Analyst',
                                'Political Scientist',
                                'Politician',
                                'Portfolio Manager',
                                'Preschool Management',
                                'Preschool Teacher',
                                'Principal',
                                'Private Banker',
                                'Private Investigator',
                                'Probation Officer',
                                'Process Engineer',
                                'Producer',
                                'Product Manager',
                                'Product Engineer',
                                'Production Engineer',
                                'Production Planner',
                                'Professional Athlete',
                                'Professional Coach',
                                'Professor',
                                'Project Engineer',
                                'Project Manager',
                                'Program Manager',
                                'Property Manager',
                                'Public Administrator',
                                'Public Safety Director',
                                'PR Specialist',
                                'Publisher',
                                'Purchasing Agent',
                                'Publishing Director',
                                'Quality Assurance Specialist',
                                'Quality Control Engineer',
                                'Quality Control Inspector',
                                'Radiology Manager',
                                'Railroad Engineer',
                                'Real Estate Broker',
                                'Recreational Director',
                                'Recruiter',
                                'Redevelopment Specialist',
                                'Regulatory Affairs Manager',
                                'Registered Nurse',
                                'Rehabilitation Counselor',
                                'Relocation Manager',
                                'Reporter',
                                'Research Specialist',
                                'Restaurant Manager',
                                'Retail Store Manager',
                                'Risk Analyst',
                                'Safety Engineer',
                                'Sales Engineer',
                                'Sales Trainer',
                                'Sales Promotion Manager',
                                'Sales Representative',
                                'Sales Manager',
                                'Service Manager',
                                'Sanitation Engineer',
                                'Scientific Programmer',
                                'Scientific Writer',
                                'Securities Analyst',
                                'Security Consultant',
                                'Security Director',
                                'Seminar Presenter',
                                'Ship\'s Officer',
                                'Singer',
                                'Social Director',
                                'Social Program Planner',
                                'Social Research',
                                'Social Scientist',
                                'Social Worker',
                                'Sociologist',
                                'Software Developer',
                                'Software Engineer',
                                'Software Test Engineer',
                                'Soil Scientist',
                                'Special Events Manager',
                                'Special Education Teacher',
                                'Special Projects Director',
                                'Speech Pathologist',
                                'Speech Writer',
                                'Sports Event Manager',
                                'Statistician',
                                'Store Manager',
                                'Strategic Alliance Director',
                                'Strategic Planning Director',
                                'Stress Reduction Specialist',
                                'Stockbroker',
                                'Surveyor',
                                'Structural Engineer',
                                'Superintendent',
                                'Supply Chain Director',
                                'System Engineer',
                                'Systems Analyst',
                                'Systems Programmer',
                                'System Administrator',
                                'Tax Specialist',
                                'Teacher',
                                'Technical Support Specialist',
                                'Technical Illustrator',
                                'Technical Writer',
                                'Technology Director',
                                'Telecom Analyst',
                                'Telemarketer',
                                'Theatrical Director',
                                'Title Examiner',
                                'Tour Escort',
                                'Tour Guide Director',
                                'Traffic Manager',
                                'Trainer Translator',
                                'Transportation Manager',
                                'Travel Agent',
                                'Treasurer',
                                'TV Programmer',
                                'Underwriter',
                                'Union Representative',
                                'University Administrator',
                                'University Dean',
                                'Urban Planner',
                                'Veterinarian',
                                'Vendor Relations Director',
                                'Viticulturist',
                                'Warehouse Manager'
                            ],
                            animals: {
                                ocean: [
                                    'Acantharea',
                                    'Anemone',
                                    'Angelfish King',
                                    'Ahi Tuna',
                                    'Albacore',
                                    'American Oyster',
                                    'Anchovy',
                                    'Armored Snail',
                                    'Arctic Char',
                                    'Atlantic Bluefin Tuna',
                                    'Atlantic Cod',
                                    'Atlantic Goliath Grouper',
                                    'Atlantic Trumpetfish',
                                    'Atlantic Wolffish',
                                    'Baleen Whale',
                                    'Banded Butterflyfish',
                                    'Banded Coral Shrimp',
                                    'Banded Sea Krait',
                                    'Barnacle',
                                    'Barndoor Skate',
                                    'Barracuda',
                                    'Basking Shark',
                                    'Bass',
                                    'Beluga Whale',
                                    'Bluebanded Goby',
                                    'Bluehead Wrasse',
                                    'Bluefish',
                                    'Bluestreak Cleaner-Wrasse',
                                    'Blue Marlin',
                                    'Blue Shark',
                                    'Blue Spiny Lobster',
                                    'Blue Tang',
                                    'Blue Whale',
                                    'Broadclub Cuttlefish',
                                    'Bull Shark',
                                    'Chambered Nautilus',
                                    'Chilean Basket Star',
                                    'Chilean Jack Mackerel',
                                    'Chinook Salmon',
                                    'Christmas Tree Worm',
                                    'Clam',
                                    'Clown Anemonefish',
                                    'Clown Triggerfish',
                                    'Cod',
                                    'Coelacanth',
                                    'Cockscomb Cup Coral',
                                    'Common Fangtooth',
                                    'Conch',
                                    'Cookiecutter Shark',
                                    'Copepod',
                                    'Coral',
                                    'Corydoras',
                                    'Cownose Ray',
                                    'Crab',
                                    'Crown-of-Thorns Starfish',
                                    'Cushion Star',
                                    'Cuttlefish',
                                    'California Sea Otters',
                                    'Dolphin',
                                    'Dolphinfish',
                                    'Dory',
                                    'Devil Fish',
                                    'Dugong',
                                    'Dumbo Octopus',
                                    'Dungeness Crab',
                                    'Eccentric Sand Dollar',
                                    'Edible Sea Cucumber',
                                    'Eel',
                                    'Elephant Seal',
                                    'Elkhorn Coral',
                                    'Emperor Shrimp',
                                    'Estuarine Crocodile',
                                    'Fathead Sculpin',
                                    'Fiddler Crab',
                                    'Fin Whale',
                                    'Flameback',
                                    'Flamingo Tongue Snail',
                                    'Flashlight Fish',
                                    'Flatback Turtle',
                                    'Flatfish',
                                    'Flying Fish',
                                    'Flounder',
                                    'Fluke',
                                    'French Angelfish',
                                    'Frilled Shark',
                                    'Fugu (also called Pufferfish)',
                                    'Gar',
                                    'Geoduck',
                                    'Giant Barrel Sponge',
                                    'Giant Caribbean Sea Anemone',
                                    'Giant Clam',
                                    'Giant Isopod',
                                    'Giant Kingfish',
                                    'Giant Oarfish',
                                    'Giant Pacific Octopus',
                                    'Giant Pyrosome',
                                    'Giant Sea Star',
                                    'Giant Squid',
                                    'Glowing Sucker Octopus',
                                    'Giant Tube Worm',
                                    'Goblin Shark',
                                    'Goosefish',
                                    'Great White Shark',
                                    'Greenland Shark',
                                    'Grey Atlantic Seal',
                                    'Grouper',
                                    'Grunion',
                                    'Guineafowl Puffer',
                                    'Haddock',
                                    'Hake',
                                    'Halibut',
                                    'Hammerhead Shark',
                                    'Hapuka',
                                    'Harbor Porpoise',
                                    'Harbor Seal',
                                    'Hatchetfish',
                                    'Hawaiian Monk Seal',
                                    'Hawksbill Turtle',
                                    'Hector\'s Dolphin',
                                    'Hermit Crab',
                                    'Herring',
                                    'Hoki',
                                    'Horn Shark',
                                    'Horseshoe Crab',
                                    'Humpback Anglerfish',
                                    'Humpback Whale',
                                    'Icefish',
                                    'Imperator Angelfish',
                                    'Irukandji Jellyfish',
                                    'Isopod',
                                    'Ivory Bush Coral',
                                    'Japanese Spider Crab',
                                    'Jellyfish',
                                    'John Dory',
                                    'Juan Fernandez Fur Seal',
                                    'Killer Whale',
                                    'Kiwa Hirsuta',
                                    'Krill',
                                    'Lagoon Triggerfish',
                                    'Lamprey',
                                    'Leafy Seadragon',
                                    'Leopard Seal',
                                    'Limpet',
                                    'Ling',
                                    'Lionfish',
                                    'Lions Mane Jellyfish',
                                    'Lobe Coral',
                                    'Lobster',
                                    'Loggerhead Turtle',
                                    'Longnose Sawshark',
                                    'Longsnout Seahorse',
                                    'Lophelia Coral',
                                    'Marrus Orthocanna',
                                    'Manatee',
                                    'Manta Ray',
                                    'Marlin',
                                    'Megamouth Shark',
                                    'Mexican Lookdown',
                                    'Mimic Octopus',
                                    'Moon Jelly',
                                    'Mollusk',
                                    'Monkfish',
                                    'Moray Eel',
                                    'Mullet',
                                    'Mussel',
                                    'Megaladon',
                                    'Napoleon Wrasse',
                                    'Nassau Grouper',
                                    'Narwhal',
                                    'Nautilus',
                                    'Needlefish',
                                    'Northern Seahorse',
                                    'North Atlantic Right Whale',
                                    'Northern Red Snapper',
                                    'Norway Lobster',
                                    'Nudibranch',
                                    'Nurse Shark',
                                    'Oarfish',
                                    'Ocean Sunfish',
                                    'Oceanic Whitetip Shark',
                                    'Octopus',
                                    'Olive Sea Snake',
                                    'Orange Roughy',
                                    'Ostracod',
                                    'Otter',
                                    'Oyster',
                                    'Pacific Angelshark',
                                    'Pacific Blackdragon',
                                    'Pacific Halibut',
                                    'Pacific Sardine',
                                    'Pacific Sea Nettle Jellyfish',
                                    'Pacific White Sided Dolphin',
                                    'Pantropical Spotted Dolphin',
                                    'Patagonian Toothfish',
                                    'Peacock Mantis Shrimp',
                                    'Pelagic Thresher Shark',
                                    'Penguin',
                                    'Peruvian Anchoveta',
                                    'Pilchard',
                                    'Pink Salmon',
                                    'Pinniped',
                                    'Plankton',
                                    'Porpoise',
                                    'Polar Bear',
                                    'Portuguese Man o\' War',
                                    'Pycnogonid Sea Spider',
                                    'Quahog',
                                    'Queen Angelfish',
                                    'Queen Conch',
                                    'Queen Parrotfish',
                                    'Queensland Grouper',
                                    'Ragfish',
                                    'Ratfish',
                                    'Rattail Fish',
                                    'Ray',
                                    'Red Drum',
                                    'Red King Crab',
                                    'Ringed Seal',
                                    'Risso\'s Dolphin',
                                    'Ross Seals',
                                    'Sablefish',
                                    'Salmon',
                                    'Sand Dollar',
                                    'Sandbar Shark',
                                    'Sawfish',
                                    'Sarcastic Fringehead',
                                    'Scalloped Hammerhead Shark',
                                    'Seahorse',
                                    'Sea Cucumber',
                                    'Sea Lion',
                                    'Sea Urchin',
                                    'Seal',
                                    'Shark',
                                    'Shortfin Mako Shark',
                                    'Shovelnose Guitarfish',
                                    'Shrimp',
                                    'Silverside Fish',
                                    'Skipjack Tuna',
                                    'Slender Snipe Eel',
                                    'Smalltooth Sawfish',
                                    'Smelts',
                                    'Sockeye Salmon',
                                    'Southern Stingray',
                                    'Sponge',
                                    'Spotted Porcupinefish',
                                    'Spotted Dolphin',
                                    'Spotted Eagle Ray',
                                    'Spotted Moray',
                                    'Squid',
                                    'Squidworm',
                                    'Starfish',
                                    'Stickleback',
                                    'Stonefish',
                                    'Stoplight Loosejaw',
                                    'Sturgeon',
                                    'Swordfish',
                                    'Tan Bristlemouth',
                                    'Tasseled Wobbegong',
                                    'Terrible Claw Lobster',
                                    'Threespot Damselfish',
                                    'Tiger Prawn',
                                    'Tiger Shark',
                                    'Tilefish',
                                    'Toadfish',
                                    'Tropical Two-Wing Flyfish',
                                    'Tuna',
                                    'Umbrella Squid',
                                    'Velvet Crab',
                                    'Venus Flytrap Sea Anemone',
                                    'Vigtorniella Worm',
                                    'Viperfish',
                                    'Vampire Squid',
                                    'Vaquita',
                                    'Wahoo',
                                    'Walrus',
                                    'West Indian Manatee',
                                    'Whale',
                                    'Whale Shark',
                                    'Whiptail Gulper',
                                    'White-Beaked Dolphin',
                                    'White-Ring Garden Eel',
                                    'White Shrimp',
                                    'Wobbegong',
                                    'Wrasse',
                                    'Wreckfish',
                                    'Xiphosura',
                                    'Yellowtail Damselfish',
                                    'Yelloweye Rockfish',
                                    'Yellow Cup Black Coral',
                                    'Yellow Tube Sponge',
                                    'Yellowfin Tuna',
                                    'Zebrashark',
                                    'Zooplankton'
                                ],
                                desert: [
                                    'Aardwolf',
                                    'Addax',
                                    'African Wild Ass',
                                    'Ant',
                                    'Antelope',
                                    'Armadillo',
                                    'Baboon',
                                    'Badger',
                                    'Bat',
                                    'Bearded Dragon',
                                    'Beetle',
                                    'Bird',
                                    'Black-footed Cat',
                                    'Boa',
                                    'Brown Bear',
                                    'Bustard',
                                    'Butterfly',
                                    'Camel',
                                    'Caracal',
                                    'Caracara',
                                    'Caterpillar',
                                    'Centipede',
                                    'Cheetah',
                                    'Chipmunk',
                                    'Chuckwalla',
                                    'Climbing Mouse',
                                    'Coati',
                                    'Cobra',
                                    'Cotton Rat',
                                    'Cougar',
                                    'Courser',
                                    'Crane Fly',
                                    'Crow',
                                    'Dassie Rat',
                                    'Dove',
                                    'Dunnart',
                                    'Eagle',
                                    'Echidna',
                                    'Elephant',
                                    'Emu',
                                    'Falcon',
                                    'Fly',
                                    'Fox',
                                    'Frogmouth',
                                    'Gecko',
                                    'Geoffroy\'s Cat',
                                    'Gerbil',
                                    'Grasshopper',
                                    'Guanaco',
                                    'Gundi',
                                    'Hamster',
                                    'Hawk',
                                    'Hedgehog',
                                    'Hyena',
                                    'Hyrax',
                                    'Jackal',
                                    'Kangaroo',
                                    'Kangaroo Rat',
                                    'Kestrel',
                                    'Kowari',
                                    'Kultarr',
                                    'Leopard',
                                    'Lion',
                                    'Macaw',
                                    'Meerkat',
                                    'Mouse',
                                    'Oryx',
                                    'Ostrich',
                                    'Owl',
                                    'Pronghorn',
                                    'Python',
                                    'Rabbit',
                                    'Raccoon',
                                    'Rattlesnake',
                                    'Rhinoceros',
                                    'Sand Cat',
                                    'Spectacled Bear',
                                    'Spiny Mouse',
                                    'Starling',
                                    'Stick Bug',
                                    'Tarantula',
                                    'Tit',
                                    'Toad',
                                    'Tortoise',
                                    'Tyrant Flycatcher',
                                    'Viper',
                                    'Vulture',
                                    'Waxwing',
                                    'Xerus',
                                    'Zebra'
                                ],
                                grassland: [
                                    'Aardvark',
                                    'Aardwolf',
                                    'Accentor',
                                    'African Buffalo',
                                    'African Wild Dog',
                                    'Alpaca',
                                    'Anaconda',
                                    'Ant',
                                    'Anteater',
                                    'Antelope',
                                    'Armadillo',
                                    'Baboon',
                                    'Badger',
                                    'Bandicoot',
                                    'Barbet',
                                    'Bat',
                                    'Bee',
                                    'Bee-eater',
                                    'Beetle',
                                    'Bird',
                                    'Bison',
                                    'Black-footed Cat',
                                    'Black-footed Ferret',
                                    'Bluebird',
                                    'Boa',
                                    'Bowerbird',
                                    'Brown Bear',
                                    'Bush Dog',
                                    'Bushshrike',
                                    'Bustard',
                                    'Butterfly',
                                    'Buzzard',
                                    'Caracal',
                                    'Caracara',
                                    'Cardinal',
                                    'Caterpillar',
                                    'Cheetah',
                                    'Chipmunk',
                                    'Civet',
                                    'Climbing Mouse',
                                    'Clouded Leopard',
                                    'Coati',
                                    'Cobra',
                                    'Cockatoo',
                                    'Cockroach',
                                    'Common Genet',
                                    'Cotton Rat',
                                    'Cougar',
                                    'Courser',
                                    'Coyote',
                                    'Crane',
                                    'Crane Fly',
                                    'Cricket',
                                    'Crow',
                                    'Culpeo',
                                    'Death Adder',
                                    'Deer',
                                    'Deer Mouse',
                                    'Dingo',
                                    'Dinosaur',
                                    'Dove',
                                    'Drongo',
                                    'Duck',
                                    'Duiker',
                                    'Dunnart',
                                    'Eagle',
                                    'Echidna',
                                    'Elephant',
                                    'Elk',
                                    'Emu',
                                    'Falcon',
                                    'Finch',
                                    'Flea',
                                    'Fly',
                                    'Flying Frog',
                                    'Fox',
                                    'Frog',
                                    'Frogmouth',
                                    'Garter Snake',
                                    'Gazelle',
                                    'Gecko',
                                    'Geoffroy\'s Cat',
                                    'Gerbil',
                                    'Giant Tortoise',
                                    'Giraffe',
                                    'Grasshopper',
                                    'Grison',
                                    'Groundhog',
                                    'Grouse',
                                    'Guanaco',
                                    'Guinea Pig',
                                    'Hamster',
                                    'Harrier',
                                    'Hartebeest',
                                    'Hawk',
                                    'Hedgehog',
                                    'Helmetshrike',
                                    'Hippopotamus',
                                    'Hornbill',
                                    'Hyena',
                                    'Hyrax',
                                    'Impala',
                                    'Jackal',
                                    'Jaguar',
                                    'Jaguarundi',
                                    'Kangaroo',
                                    'Kangaroo Rat',
                                    'Kestrel',
                                    'Kultarr',
                                    'Ladybug',
                                    'Leopard',
                                    'Lion',
                                    'Macaw',
                                    'Meerkat',
                                    'Mouse',
                                    'Newt',
                                    'Oryx',
                                    'Ostrich',
                                    'Owl',
                                    'Pangolin',
                                    'Pheasant',
                                    'Prairie Dog',
                                    'Pronghorn',
                                    'Przewalski\'s Horse',
                                    'Python',
                                    'Quoll',
                                    'Rabbit',
                                    'Raven',
                                    'Rhinoceros',
                                    'Shelduck',
                                    'Sloth Bear',
                                    'Spectacled Bear',
                                    'Squirrel',
                                    'Starling',
                                    'Stick Bug',
                                    'Tamandua',
                                    'Tasmanian Devil',
                                    'Thornbill',
                                    'Thrush',
                                    'Toad',
                                    'Tortoise'
                                ],
                                forest: [
                                    'Agouti',
                                    'Anaconda',
                                    'Anoa',
                                    'Ant',
                                    'Anteater',
                                    'Antelope',
                                    'Armadillo',
                                    'Asian Black Bear',
                                    'Aye-aye',
                                    'Babirusa',
                                    'Baboon',
                                    'Badger',
                                    'Bandicoot',
                                    'Banteng',
                                    'Barbet',
                                    'Basilisk',
                                    'Bat',
                                    'Bearded Dragon',
                                    'Bee',
                                    'Bee-eater',
                                    'Beetle',
                                    'Bettong',
                                    'Binturong',
                                    'Bird-of-paradise',
                                    'Bongo',
                                    'Bowerbird',
                                    'Bulbul',
                                    'Bush Dog',
                                    'Bushbaby',
                                    'Bushshrike',
                                    'Butterfly',
                                    'Buzzard',
                                    'Caecilian',
                                    'Cardinal',
                                    'Cassowary',
                                    'Caterpillar',
                                    'Centipede',
                                    'Chameleon',
                                    'Chimpanzee',
                                    'Cicada',
                                    'Civet',
                                    'Clouded Leopard',
                                    'Coati',
                                    'Cobra',
                                    'Cockatoo',
                                    'Cockroach',
                                    'Colugo',
                                    'Cotinga',
                                    'Cotton Rat',
                                    'Cougar',
                                    'Crane Fly',
                                    'Cricket',
                                    'Crocodile',
                                    'Crow',
                                    'Cuckoo',
                                    'Cuscus',
                                    'Death Adder',
                                    'Deer',
                                    'Dhole',
                                    'Dingo',
                                    'Dinosaur',
                                    'Drongo',
                                    'Duck',
                                    'Duiker',
                                    'Eagle',
                                    'Echidna',
                                    'Elephant',
                                    'Finch',
                                    'Flat-headed Cat',
                                    'Flea',
                                    'Flowerpecker',
                                    'Fly',
                                    'Flying Frog',
                                    'Fossa',
                                    'Frog',
                                    'Frogmouth',
                                    'Gaur',
                                    'Gecko',
                                    'Gorilla',
                                    'Grison',
                                    'Hawaiian Honeycreeper',
                                    'Hawk',
                                    'Hedgehog',
                                    'Helmetshrike',
                                    'Hornbill',
                                    'Hyrax',
                                    'Iguana',
                                    'Jackal',
                                    'Jaguar',
                                    'Jaguarundi',
                                    'Kestrel',
                                    'Ladybug',
                                    'Lemur',
                                    'Leopard',
                                    'Lion',
                                    'Macaw',
                                    'Mandrill',
                                    'Margay',
                                    'Monkey',
                                    'Mouse',
                                    'Mouse Deer',
                                    'Newt',
                                    'Okapi',
                                    'Old World Flycatcher',
                                    'Orangutan',
                                    'Owl',
                                    'Pangolin',
                                    'Peafowl',
                                    'Pheasant',
                                    'Possum',
                                    'Python',
                                    'Quokka',
                                    'Rabbit',
                                    'Raccoon',
                                    'Red Panda',
                                    'Red River Hog',
                                    'Rhinoceros',
                                    'Sloth Bear',
                                    'Spectacled Bear',
                                    'Squirrel',
                                    'Starling',
                                    'Stick Bug',
                                    'Sun Bear',
                                    'Tamandua',
                                    'Tamarin',
                                    'Tapir',
                                    'Tarantula',
                                    'Thrush',
                                    'Tiger',
                                    'Tit',
                                    'Toad',
                                    'Tortoise',
                                    'Toucan',
                                    'Trogon',
                                    'Trumpeter',
                                    'Turaco',
                                    'Turtle',
                                    'Tyrant Flycatcher',
                                    'Viper',
                                    'Vulture',
                                    'Wallaby',
                                    'Warbler',
                                    'Wasp',
                                    'Waxwing',
                                    'Weaver',
                                    'Weaver-finch',
                                    'Whistler',
                                    'White-eye',
                                    'Whydah',
                                    'Woodswallow',
                                    'Worm',
                                    'Wren',
                                    'Xenops',
                                    'Yellowjacket',
                                    'Accentor',
                                    'African Buffalo',
                                    'American Black Bear',
                                    'Anole',
                                    'Bird',
                                    'Bison',
                                    'Boa',
                                    'Brown Bear',
                                    'Chipmunk',
                                    'Common Genet',
                                    'Copperhead',
                                    'Coyote',
                                    'Deer Mouse',
                                    'Dormouse',
                                    'Elk',
                                    'Emu',
                                    'Fisher',
                                    'Fox',
                                    'Garter Snake',
                                    'Giant Panda',
                                    'Giant Tortoise',
                                    'Groundhog',
                                    'Grouse',
                                    'Guanaco',
                                    'Himalayan Tahr',
                                    'Kangaroo',
                                    'Koala',
                                    'Numbat',
                                    'Quoll',
                                    'Raccoon dog',
                                    'Tasmanian Devil',
                                    'Thornbill',
                                    'Turkey',
                                    'Vole',
                                    'Weasel',
                                    'Wildcat',
                                    'Wolf',
                                    'Wombat',
                                    'Woodchuck',
                                    'Woodpecker'
                                ],
                                farm: [
                                    'Alpaca',
                                    'Buffalo',
                                    'Banteng',
                                    'Cow',
                                    'Cat',
                                    'Chicken',
                                    'Carp',
                                    'Camel',
                                    'Donkey',
                                    'Dog',
                                    'Duck',
                                    'Emu',
                                    'Goat',
                                    'Gayal',
                                    'Guinea',
                                    'Goose',
                                    'Horse',
                                    'Honey',
                                    'Llama',
                                    'Pig',
                                    'Pigeon',
                                    'Rhea',
                                    'Rabbit',
                                    'Sheep',
                                    'Silkworm',
                                    'Turkey',
                                    'Yak',
                                    'Zebu'
                                ],
                                pet: [
                                    'Bearded Dragon',
                                    'Birds',
                                    'Burro',
                                    'Cats',
                                    'Chameleons',
                                    'Chickens',
                                    'Chinchillas',
                                    'Chinese Water Dragon',
                                    'Cows',
                                    'Dogs',
                                    'Donkey',
                                    'Ducks',
                                    'Ferrets',
                                    'Fish',
                                    'Geckos',
                                    'Geese',
                                    'Gerbils',
                                    'Goats',
                                    'Guinea Fowl',
                                    'Guinea Pigs',
                                    'Hamsters',
                                    'Hedgehogs',
                                    'Horses',
                                    'Iguanas',
                                    'Llamas',
                                    'Lizards',
                                    'Mice',
                                    'Mule',
                                    'Peafowl',
                                    'Pigs and Hogs',
                                    'Pigeons',
                                    'Ponies',
                                    'Pot Bellied Pig',
                                    'Rabbits',
                                    'Rats',
                                    'Sheep',
                                    'Skinks',
                                    'Snakes',
                                    'Stick Insects',
                                    'Sugar Gliders',
                                    'Tarantula',
                                    'Turkeys',
                                    'Turtles'
                                ],
                                zoo: [
                                    'Aardvark',
                                    'African Wild Dog',
                                    'Aldabra Tortoise',
                                    'American Alligator',
                                    'American Bison',
                                    'Amur Tiger',
                                    'Anaconda',
                                    'Andean Condor',
                                    'Asian Elephant',
                                    'Baby Doll Sheep',
                                    'Bald Eagle',
                                    'Barred Owl',
                                    'Blue Iguana',
                                    'Boer Goat',
                                    'California Sea Lion',
                                    'Caribbean Flamingo',
                                    'Chinchilla',
                                    'Collared Lemur',
                                    'Coquerel\'s Sifaka',
                                    'Cuban Amazon Parrot',
                                    'Ebony Langur',
                                    'Fennec Fox',
                                    'Fossa',
                                    'Gelada',
                                    'Giant Anteater',
                                    'Giraffe',
                                    'Gorilla',
                                    'Grizzly Bear',
                                    'Henkel\'s Leaf-tailed Gecko',
                                    'Indian Gharial',
                                    'Indian Rhinoceros',
                                    'King Cobra',
                                    'King Vulture',
                                    'Komodo Dragon',
                                    'Linne\'s Two-toed Sloth',
                                    'Lion',
                                    'Little Penguin',
                                    'Madagascar Tree Boa',
                                    'Magellanic Penguin',
                                    'Malayan Tapir',
                                    'Malayan Tiger',
                                    'Matschies Tree Kangaroo',
                                    'Mini Donkey',
                                    'Monarch Butterfly',
                                    'Nile crocodile',
                                    'North American Porcupine',
                                    'Nubian Ibex',
                                    'Okapi',
                                    'Poison Dart Frog',
                                    'Polar Bear',
                                    'Pygmy Marmoset',
                                    'Radiated Tortoise',
                                    'Red Panda',
                                    'Red Ruffed Lemur',
                                    'Ring-tailed Lemur',
                                    'Ring-tailed Mongoose',
                                    'Rock Hyrax',
                                    'Small Clawed Asian Otter',
                                    'Snow Leopard',
                                    'Snowy Owl',
                                    'Southern White-faced Owl',
                                    'Southern White Rhinocerous',
                                    'Squirrel Monkey',
                                    'Tufted Puffin',
                                    'White Cheeked Gibbon',
                                    'White-throated Bee Eater',
                                    'Zebra'
                                ]
                            },
                            primes: [
                                2,
                                3,
                                5,
                                7,
                                11,
                                13,
                                17,
                                19,
                                23,
                                29,
                                31,
                                37,
                                41,
                                43,
                                47,
                                53,
                                59,
                                61,
                                67,
                                71,
                                73,
                                79,
                                83,
                                89,
                                97,
                                101,
                                103,
                                107,
                                109,
                                113,
                                127,
                                131,
                                137,
                                139,
                                149,
                                151,
                                157,
                                163,
                                167,
                                173,
                                179,
                                181,
                                191,
                                193,
                                197,
                                199,
                                211,
                                223,
                                227,
                                229,
                                233,
                                239,
                                241,
                                251,
                                257,
                                263,
                                269,
                                271,
                                277,
                                281,
                                283,
                                293,
                                307,
                                311,
                                313,
                                317,
                                331,
                                337,
                                347,
                                349,
                                353,
                                359,
                                367,
                                373,
                                379,
                                383,
                                389,
                                397,
                                401,
                                409,
                                419,
                                421,
                                431,
                                433,
                                439,
                                443,
                                449,
                                457,
                                461,
                                463,
                                467,
                                479,
                                487,
                                491,
                                499,
                                503,
                                509,
                                521,
                                523,
                                541,
                                547,
                                557,
                                563,
                                569,
                                571,
                                577,
                                587,
                                593,
                                599,
                                601,
                                607,
                                613,
                                617,
                                619,
                                631,
                                641,
                                643,
                                647,
                                653,
                                659,
                                661,
                                673,
                                677,
                                683,
                                691,
                                701,
                                709,
                                719,
                                727,
                                733,
                                739,
                                743,
                                751,
                                757,
                                761,
                                769,
                                773,
                                787,
                                797,
                                809,
                                811,
                                821,
                                823,
                                827,
                                829,
                                839,
                                853,
                                857,
                                859,
                                863,
                                877,
                                881,
                                883,
                                887,
                                907,
                                911,
                                919,
                                929,
                                937,
                                941,
                                947,
                                953,
                                967,
                                971,
                                977,
                                983,
                                991,
                                997,
                                1009,
                                1013,
                                1019,
                                1021,
                                1031,
                                1033,
                                1039,
                                1049,
                                1051,
                                1061,
                                1063,
                                1069,
                                1087,
                                1091,
                                1093,
                                1097,
                                1103,
                                1109,
                                1117,
                                1123,
                                1129,
                                1151,
                                1153,
                                1163,
                                1171,
                                1181,
                                1187,
                                1193,
                                1201,
                                1213,
                                1217,
                                1223,
                                1229,
                                1231,
                                1237,
                                1249,
                                1259,
                                1277,
                                1279,
                                1283,
                                1289,
                                1291,
                                1297,
                                1301,
                                1303,
                                1307,
                                1319,
                                1321,
                                1327,
                                1361,
                                1367,
                                1373,
                                1381,
                                1399,
                                1409,
                                1423,
                                1427,
                                1429,
                                1433,
                                1439,
                                1447,
                                1451,
                                1453,
                                1459,
                                1471,
                                1481,
                                1483,
                                1487,
                                1489,
                                1493,
                                1499,
                                1511,
                                1523,
                                1531,
                                1543,
                                1549,
                                1553,
                                1559,
                                1567,
                                1571,
                                1579,
                                1583,
                                1597,
                                1601,
                                1607,
                                1609,
                                1613,
                                1619,
                                1621,
                                1627,
                                1637,
                                1657,
                                1663,
                                1667,
                                1669,
                                1693,
                                1697,
                                1699,
                                1709,
                                1721,
                                1723,
                                1733,
                                1741,
                                1747,
                                1753,
                                1759,
                                1777,
                                1783,
                                1787,
                                1789,
                                1801,
                                1811,
                                1823,
                                1831,
                                1847,
                                1861,
                                1867,
                                1871,
                                1873,
                                1877,
                                1879,
                                1889,
                                1901,
                                1907,
                                1913,
                                1931,
                                1933,
                                1949,
                                1951,
                                1973,
                                1979,
                                1987,
                                1993,
                                1997,
                                1999,
                                2003,
                                2011,
                                2017,
                                2027,
                                2029,
                                2039,
                                2053,
                                2063,
                                2069,
                                2081,
                                2083,
                                2087,
                                2089,
                                2099,
                                2111,
                                2113,
                                2129,
                                2131,
                                2137,
                                2141,
                                2143,
                                2153,
                                2161,
                                2179,
                                2203,
                                2207,
                                2213,
                                2221,
                                2237,
                                2239,
                                2243,
                                2251,
                                2267,
                                2269,
                                2273,
                                2281,
                                2287,
                                2293,
                                2297,
                                2309,
                                2311,
                                2333,
                                2339,
                                2341,
                                2347,
                                2351,
                                2357,
                                2371,
                                2377,
                                2381,
                                2383,
                                2389,
                                2393,
                                2399,
                                2411,
                                2417,
                                2423,
                                2437,
                                2441,
                                2447,
                                2459,
                                2467,
                                2473,
                                2477,
                                2503,
                                2521,
                                2531,
                                2539,
                                2543,
                                2549,
                                2551,
                                2557,
                                2579,
                                2591,
                                2593,
                                2609,
                                2617,
                                2621,
                                2633,
                                2647,
                                2657,
                                2659,
                                2663,
                                2671,
                                2677,
                                2683,
                                2687,
                                2689,
                                2693,
                                2699,
                                2707,
                                2711,
                                2713,
                                2719,
                                2729,
                                2731,
                                2741,
                                2749,
                                2753,
                                2767,
                                2777,
                                2789,
                                2791,
                                2797,
                                2801,
                                2803,
                                2819,
                                2833,
                                2837,
                                2843,
                                2851,
                                2857,
                                2861,
                                2879,
                                2887,
                                2897,
                                2903,
                                2909,
                                2917,
                                2927,
                                2939,
                                2953,
                                2957,
                                2963,
                                2969,
                                2971,
                                2999,
                                3001,
                                3011,
                                3019,
                                3023,
                                3037,
                                3041,
                                3049,
                                3061,
                                3067,
                                3079,
                                3083,
                                3089,
                                3109,
                                3119,
                                3121,
                                3137,
                                3163,
                                3167,
                                3169,
                                3181,
                                3187,
                                3191,
                                3203,
                                3209,
                                3217,
                                3221,
                                3229,
                                3251,
                                3253,
                                3257,
                                3259,
                                3271,
                                3299,
                                3301,
                                3307,
                                3313,
                                3319,
                                3323,
                                3329,
                                3331,
                                3343,
                                3347,
                                3359,
                                3361,
                                3371,
                                3373,
                                3389,
                                3391,
                                3407,
                                3413,
                                3433,
                                3449,
                                3457,
                                3461,
                                3463,
                                3467,
                                3469,
                                3491,
                                3499,
                                3511,
                                3517,
                                3527,
                                3529,
                                3533,
                                3539,
                                3541,
                                3547,
                                3557,
                                3559,
                                3571,
                                3581,
                                3583,
                                3593,
                                3607,
                                3613,
                                3617,
                                3623,
                                3631,
                                3637,
                                3643,
                                3659,
                                3671,
                                3673,
                                3677,
                                3691,
                                3697,
                                3701,
                                3709,
                                3719,
                                3727,
                                3733,
                                3739,
                                3761,
                                3767,
                                3769,
                                3779,
                                3793,
                                3797,
                                3803,
                                3821,
                                3823,
                                3833,
                                3847,
                                3851,
                                3853,
                                3863,
                                3877,
                                3881,
                                3889,
                                3907,
                                3911,
                                3917,
                                3919,
                                3923,
                                3929,
                                3931,
                                3943,
                                3947,
                                3967,
                                3989,
                                4001,
                                4003,
                                4007,
                                4013,
                                4019,
                                4021,
                                4027,
                                4049,
                                4051,
                                4057,
                                4073,
                                4079,
                                4091,
                                4093,
                                4099,
                                4111,
                                4127,
                                4129,
                                4133,
                                4139,
                                4153,
                                4157,
                                4159,
                                4177,
                                4201,
                                4211,
                                4217,
                                4219,
                                4229,
                                4231,
                                4241,
                                4243,
                                4253,
                                4259,
                                4261,
                                4271,
                                4273,
                                4283,
                                4289,
                                4297,
                                4327,
                                4337,
                                4339,
                                4349,
                                4357,
                                4363,
                                4373,
                                4391,
                                4397,
                                4409,
                                4421,
                                4423,
                                4441,
                                4447,
                                4451,
                                4457,
                                4463,
                                4481,
                                4483,
                                4493,
                                4507,
                                4513,
                                4517,
                                4519,
                                4523,
                                4547,
                                4549,
                                4561,
                                4567,
                                4583,
                                4591,
                                4597,
                                4603,
                                4621,
                                4637,
                                4639,
                                4643,
                                4649,
                                4651,
                                4657,
                                4663,
                                4673,
                                4679,
                                4691,
                                4703,
                                4721,
                                4723,
                                4729,
                                4733,
                                4751,
                                4759,
                                4783,
                                4787,
                                4789,
                                4793,
                                4799,
                                4801,
                                4813,
                                4817,
                                4831,
                                4861,
                                4871,
                                4877,
                                4889,
                                4903,
                                4909,
                                4919,
                                4931,
                                4933,
                                4937,
                                4943,
                                4951,
                                4957,
                                4967,
                                4969,
                                4973,
                                4987,
                                4993,
                                4999,
                                5003,
                                5009,
                                5011,
                                5021,
                                5023,
                                5039,
                                5051,
                                5059,
                                5077,
                                5081,
                                5087,
                                5099,
                                5101,
                                5107,
                                5113,
                                5119,
                                5147,
                                5153,
                                5167,
                                5171,
                                5179,
                                5189,
                                5197,
                                5209,
                                5227,
                                5231,
                                5233,
                                5237,
                                5261,
                                5273,
                                5279,
                                5281,
                                5297,
                                5303,
                                5309,
                                5323,
                                5333,
                                5347,
                                5351,
                                5381,
                                5387,
                                5393,
                                5399,
                                5407,
                                5413,
                                5417,
                                5419,
                                5431,
                                5437,
                                5441,
                                5443,
                                5449,
                                5471,
                                5477,
                                5479,
                                5483,
                                5501,
                                5503,
                                5507,
                                5519,
                                5521,
                                5527,
                                5531,
                                5557,
                                5563,
                                5569,
                                5573,
                                5581,
                                5591,
                                5623,
                                5639,
                                5641,
                                5647,
                                5651,
                                5653,
                                5657,
                                5659,
                                5669,
                                5683,
                                5689,
                                5693,
                                5701,
                                5711,
                                5717,
                                5737,
                                5741,
                                5743,
                                5749,
                                5779,
                                5783,
                                5791,
                                5801,
                                5807,
                                5813,
                                5821,
                                5827,
                                5839,
                                5843,
                                5849,
                                5851,
                                5857,
                                5861,
                                5867,
                                5869,
                                5879,
                                5881,
                                5897,
                                5903,
                                5923,
                                5927,
                                5939,
                                5953,
                                5981,
                                5987,
                                6007,
                                6011,
                                6029,
                                6037,
                                6043,
                                6047,
                                6053,
                                6067,
                                6073,
                                6079,
                                6089,
                                6091,
                                6101,
                                6113,
                                6121,
                                6131,
                                6133,
                                6143,
                                6151,
                                6163,
                                6173,
                                6197,
                                6199,
                                6203,
                                6211,
                                6217,
                                6221,
                                6229,
                                6247,
                                6257,
                                6263,
                                6269,
                                6271,
                                6277,
                                6287,
                                6299,
                                6301,
                                6311,
                                6317,
                                6323,
                                6329,
                                6337,
                                6343,
                                6353,
                                6359,
                                6361,
                                6367,
                                6373,
                                6379,
                                6389,
                                6397,
                                6421,
                                6427,
                                6449,
                                6451,
                                6469,
                                6473,
                                6481,
                                6491,
                                6521,
                                6529,
                                6547,
                                6551,
                                6553,
                                6563,
                                6569,
                                6571,
                                6577,
                                6581,
                                6599,
                                6607,
                                6619,
                                6637,
                                6653,
                                6659,
                                6661,
                                6673,
                                6679,
                                6689,
                                6691,
                                6701,
                                6703,
                                6709,
                                6719,
                                6733,
                                6737,
                                6761,
                                6763,
                                6779,
                                6781,
                                6791,
                                6793,
                                6803,
                                6823,
                                6827,
                                6829,
                                6833,
                                6841,
                                6857,
                                6863,
                                6869,
                                6871,
                                6883,
                                6899,
                                6907,
                                6911,
                                6917,
                                6947,
                                6949,
                                6959,
                                6961,
                                6967,
                                6971,
                                6977,
                                6983,
                                6991,
                                6997,
                                7001,
                                7013,
                                7019,
                                7027,
                                7039,
                                7043,
                                7057,
                                7069,
                                7079,
                                7103,
                                7109,
                                7121,
                                7127,
                                7129,
                                7151,
                                7159,
                                7177,
                                7187,
                                7193,
                                7207,
                                7211,
                                7213,
                                7219,
                                7229,
                                7237,
                                7243,
                                7247,
                                7253,
                                7283,
                                7297,
                                7307,
                                7309,
                                7321,
                                7331,
                                7333,
                                7349,
                                7351,
                                7369,
                                7393,
                                7411,
                                7417,
                                7433,
                                7451,
                                7457,
                                7459,
                                7477,
                                7481,
                                7487,
                                7489,
                                7499,
                                7507,
                                7517,
                                7523,
                                7529,
                                7537,
                                7541,
                                7547,
                                7549,
                                7559,
                                7561,
                                7573,
                                7577,
                                7583,
                                7589,
                                7591,
                                7603,
                                7607,
                                7621,
                                7639,
                                7643,
                                7649,
                                7669,
                                7673,
                                7681,
                                7687,
                                7691,
                                7699,
                                7703,
                                7717,
                                7723,
                                7727,
                                7741,
                                7753,
                                7757,
                                7759,
                                7789,
                                7793,
                                7817,
                                7823,
                                7829,
                                7841,
                                7853,
                                7867,
                                7873,
                                7877,
                                7879,
                                7883,
                                7901,
                                7907,
                                7919,
                                7927,
                                7933,
                                7937,
                                7949,
                                7951,
                                7963,
                                7993,
                                8009,
                                8011,
                                8017,
                                8039,
                                8053,
                                8059,
                                8069,
                                8081,
                                8087,
                                8089,
                                8093,
                                8101,
                                8111,
                                8117,
                                8123,
                                8147,
                                8161,
                                8167,
                                8171,
                                8179,
                                8191,
                                8209,
                                8219,
                                8221,
                                8231,
                                8233,
                                8237,
                                8243,
                                8263,
                                8269,
                                8273,
                                8287,
                                8291,
                                8293,
                                8297,
                                8311,
                                8317,
                                8329,
                                8353,
                                8363,
                                8369,
                                8377,
                                8387,
                                8389,
                                8419,
                                8423,
                                8429,
                                8431,
                                8443,
                                8447,
                                8461,
                                8467,
                                8501,
                                8513,
                                8521,
                                8527,
                                8537,
                                8539,
                                8543,
                                8563,
                                8573,
                                8581,
                                8597,
                                8599,
                                8609,
                                8623,
                                8627,
                                8629,
                                8641,
                                8647,
                                8663,
                                8669,
                                8677,
                                8681,
                                8689,
                                8693,
                                8699,
                                8707,
                                8713,
                                8719,
                                8731,
                                8737,
                                8741,
                                8747,
                                8753,
                                8761,
                                8779,
                                8783,
                                8803,
                                8807,
                                8819,
                                8821,
                                8831,
                                8837,
                                8839,
                                8849,
                                8861,
                                8863,
                                8867,
                                8887,
                                8893,
                                8923,
                                8929,
                                8933,
                                8941,
                                8951,
                                8963,
                                8969,
                                8971,
                                8999,
                                9001,
                                9007,
                                9011,
                                9013,
                                9029,
                                9041,
                                9043,
                                9049,
                                9059,
                                9067,
                                9091,
                                9103,
                                9109,
                                9127,
                                9133,
                                9137,
                                9151,
                                9157,
                                9161,
                                9173,
                                9181,
                                9187,
                                9199,
                                9203,
                                9209,
                                9221,
                                9227,
                                9239,
                                9241,
                                9257,
                                9277,
                                9281,
                                9283,
                                9293,
                                9311,
                                9319,
                                9323,
                                9337,
                                9341,
                                9343,
                                9349,
                                9371,
                                9377,
                                9391,
                                9397,
                                9403,
                                9413,
                                9419,
                                9421,
                                9431,
                                9433,
                                9437,
                                9439,
                                9461,
                                9463,
                                9467,
                                9473,
                                9479,
                                9491,
                                9497,
                                9511,
                                9521,
                                9533,
                                9539,
                                9547,
                                9551,
                                9587,
                                9601,
                                9613,
                                9619,
                                9623,
                                9629,
                                9631,
                                9643,
                                9649,
                                9661,
                                9677,
                                9679,
                                9689,
                                9697,
                                9719,
                                9721,
                                9733,
                                9739,
                                9743,
                                9749,
                                9767,
                                9769,
                                9781,
                                9787,
                                9791,
                                9803,
                                9811,
                                9817,
                                9829,
                                9833,
                                9839,
                                9851,
                                9857,
                                9859,
                                9871,
                                9883,
                                9887,
                                9901,
                                9907,
                                9923,
                                9929,
                                9931,
                                9941,
                                9949,
                                9967,
                                9973,
                                10007
                            ],
                            emotions: [
                                'love',
                                'joy',
                                'surprise',
                                'anger',
                                'sadness',
                                'fear'
                            ]
                        }, S = Object.prototype.hasOwnProperty, v = Object.keys || function (e) {
                            var t = [];
                            for (var r in e)
                                S.call(e, r) && t.push(r);
                            return t;
                        };
                    function C(e, t) {
                        var r = Array.isArray(e), n = t || (r ? new Array(e.length) : {});
                        return r ? function (e, t) {
                            for (var r = 0, n = e.length; r < n; r++)
                                t[r] = e[r];
                        }(e, n) : function (e, t) {
                            for (var r, n = v(e), i = 0, a = n.length; i < a; i++)
                                t[r = n[i]] = e[r] || t[r];
                        }(e, n), n;
                    }
                    l.prototype.get = function (e) {
                        return C(b[e]);
                    }, l.prototype.mac_address = function (e) {
                        (e = d(e)).separator || (e.separator = e.networkVersion ? '.' : ':');
                        var t = 'ABCDEF1234567890';
                        return e.networkVersion ? this.n(this.string, 3, {
                            pool: t,
                            length: 4
                        }).join(e.separator) : this.n(this.string, 6, {
                            pool: t,
                            length: 2
                        }).join(e.separator);
                    }, l.prototype.normal = function (e) {
                        if (p((e = d(e, {
                                mean: 0,
                                dev: 1,
                                pool: []
                            })).pool.constructor !== Array, 'Chance: The pool option must be a valid array.'), p('number' != typeof e.mean, 'Chance: Mean (mean) must be a number'), p('number' != typeof e.dev, 'Chance: Standard deviation (dev) must be a number'), e.pool.length > 0)
                            return this.normal_pool(e);
                        var t, r, n, i = e.mean, a = e.dev;
                        do {
                            t = (r = 2 * this.random() - 1) * r + (n = 2 * this.random() - 1) * n;
                        } while (t >= 1);
                        return a * (r * Math.sqrt(-2 * Math.log(t) / t)) + i;
                    }, l.prototype.normal_pool = function (e) {
                        var t = 0;
                        do {
                            var r = Math.round(this.normal({
                                mean: e.mean,
                                dev: e.dev
                            }));
                            if (r < e.pool.length && r >= 0)
                                return e.pool[r];
                            t++;
                        } while (t < 100);
                        throw new RangeError('Chance: Your pool is too small for the given mean and standard deviation. Please adjust.');
                    }, l.prototype.radio = function (e) {
                        var t = '';
                        switch ((e = d(e, { side: '?' })).side.toLowerCase()) {
                        case 'east':
                        case 'e':
                            t = 'W';
                            break;
                        case 'west':
                        case 'w':
                            t = 'K';
                            break;
                        default:
                            t = this.character({ pool: 'KW' });
                        }
                        return t + this.character({
                            alpha: !0,
                            casing: 'upper'
                        }) + this.character({
                            alpha: !0,
                            casing: 'upper'
                        }) + this.character({
                            alpha: !0,
                            casing: 'upper'
                        });
                    }, l.prototype.set = function (e, t) {
                        'string' == typeof e ? b[e] = t : b = C(e, b);
                    }, l.prototype.tv = function (e) {
                        return this.radio(e);
                    }, l.prototype.cnpj = function () {
                        var e = this.n(this.natural, 8, { max: 9 }), t = 2 + 6 * e[7] + 7 * e[6] + 8 * e[5] + 9 * e[4] + 2 * e[3] + 3 * e[2] + 4 * e[1] + 5 * e[0];
                        (t = 11 - t % 11) >= 10 && (t = 0);
                        var r = 2 * t + 3 + 7 * e[7] + 8 * e[6] + 9 * e[5] + 2 * e[4] + 3 * e[3] + 4 * e[2] + 5 * e[1] + 6 * e[0];
                        return (r = 11 - r % 11) >= 10 && (r = 0), '' + e[0] + e[1] + '.' + e[2] + e[3] + e[4] + '.' + e[5] + e[6] + e[7] + '/0001-' + t + r;
                    }, l.prototype.emotion = function () {
                        return this.pick(this.get('emotions'));
                    }, l.prototype.mersenne_twister = function (e) {
                        return new A(e);
                    }, l.prototype.blueimp_md5 = function () {
                        return new _();
                    };
                    var A = function (e) {
                        void 0 === e && (e = Math.floor(Math.random() * Math.pow(10, 13))), this.N = 624, this.M = 397, this.MATRIX_A = 2567483615, this.UPPER_MASK = 2147483648, this.LOWER_MASK = 2147483647, this.mt = new Array(this.N), this.mti = this.N + 1, this.init_genrand(e);
                    };
                    A.prototype.init_genrand = function (e) {
                        for (this.mt[0] = e >>> 0, this.mti = 1; this.mti < this.N; this.mti++)
                            e = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30, this.mt[this.mti] = (1812433253 * ((4294901760 & e) >>> 16) << 16) + 1812433253 * (65535 & e) + this.mti, this.mt[this.mti] >>>= 0;
                    }, A.prototype.init_by_array = function (e, t) {
                        var r, n, i = 1, a = 0;
                        for (this.init_genrand(19650218), r = this.N > t ? this.N : t; r; r--)
                            n = this.mt[i - 1] ^ this.mt[i - 1] >>> 30, this.mt[i] = (this.mt[i] ^ (1664525 * ((4294901760 & n) >>> 16) << 16) + 1664525 * (65535 & n)) + e[a] + a, this.mt[i] >>>= 0, a++, ++i >= this.N && (this.mt[0] = this.mt[this.N - 1], i = 1), a >= t && (a = 0);
                        for (r = this.N - 1; r; r--)
                            n = this.mt[i - 1] ^ this.mt[i - 1] >>> 30, this.mt[i] = (this.mt[i] ^ (1566083941 * ((4294901760 & n) >>> 16) << 16) + 1566083941 * (65535 & n)) - i, this.mt[i] >>>= 0, ++i >= this.N && (this.mt[0] = this.mt[this.N - 1], i = 1);
                        this.mt[0] = 2147483648;
                    }, A.prototype.genrand_int32 = function () {
                        var e, t = new Array(0, this.MATRIX_A);
                        if (this.mti >= this.N) {
                            var r;
                            for (this.mti === this.N + 1 && this.init_genrand(5489), r = 0; r < this.N - this.M; r++)
                                e = this.mt[r] & this.UPPER_MASK | this.mt[r + 1] & this.LOWER_MASK, this.mt[r] = this.mt[r + this.M] ^ e >>> 1 ^ t[1 & e];
                            for (; r < this.N - 1; r++)
                                e = this.mt[r] & this.UPPER_MASK | this.mt[r + 1] & this.LOWER_MASK, this.mt[r] = this.mt[r + (this.M - this.N)] ^ e >>> 1 ^ t[1 & e];
                            e = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK, this.mt[this.N - 1] = this.mt[this.M - 1] ^ e >>> 1 ^ t[1 & e], this.mti = 0;
                        }
                        return e = this.mt[this.mti++], e ^= e >>> 11, e ^= e << 7 & 2636928640, e ^= e << 15 & 4022730752, (e ^= e >>> 18) >>> 0;
                    }, A.prototype.genrand_int31 = function () {
                        return this.genrand_int32() >>> 1;
                    }, A.prototype.genrand_real1 = function () {
                        return this.genrand_int32() * (1 / 4294967295);
                    }, A.prototype.random = function () {
                        return this.genrand_int32() * (1 / 4294967296);
                    }, A.prototype.genrand_real3 = function () {
                        return (this.genrand_int32() + 0.5) * (1 / 4294967296);
                    }, A.prototype.genrand_res53 = function () {
                        return (67108864 * (this.genrand_int32() >>> 5) + (this.genrand_int32() >>> 6)) * (1 / 9007199254740992);
                    };
                    var _ = function () {
                    };
                    _.prototype.VERSION = '1.0.1', _.prototype.safe_add = function (e, t) {
                        var r = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
                    }, _.prototype.bit_roll = function (e, t) {
                        return e << t | e >>> 32 - t;
                    }, _.prototype.md5_cmn = function (e, t, r, n, i, a) {
                        return this.safe_add(this.bit_roll(this.safe_add(this.safe_add(t, e), this.safe_add(n, a)), i), r);
                    }, _.prototype.md5_ff = function (e, t, r, n, i, a, o) {
                        return this.md5_cmn(t & r | ~t & n, e, t, i, a, o);
                    }, _.prototype.md5_gg = function (e, t, r, n, i, a, o) {
                        return this.md5_cmn(t & n | r & ~n, e, t, i, a, o);
                    }, _.prototype.md5_hh = function (e, t, r, n, i, a, o) {
                        return this.md5_cmn(t ^ r ^ n, e, t, i, a, o);
                    }, _.prototype.md5_ii = function (e, t, r, n, i, a, o) {
                        return this.md5_cmn(r ^ (t | ~n), e, t, i, a, o);
                    }, _.prototype.binl_md5 = function (e, t) {
                        e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
                        var r, n, i, a, o, s = 1732584193, c = -271733879, u = -1732584194, l = 271733878;
                        for (r = 0; r < e.length; r += 16)
                            n = s, i = c, a = u, o = l, s = this.md5_ff(s, c, u, l, e[r], 7, -680876936), l = this.md5_ff(l, s, c, u, e[r + 1], 12, -389564586), u = this.md5_ff(u, l, s, c, e[r + 2], 17, 606105819), c = this.md5_ff(c, u, l, s, e[r + 3], 22, -1044525330), s = this.md5_ff(s, c, u, l, e[r + 4], 7, -176418897), l = this.md5_ff(l, s, c, u, e[r + 5], 12, 1200080426), u = this.md5_ff(u, l, s, c, e[r + 6], 17, -1473231341), c = this.md5_ff(c, u, l, s, e[r + 7], 22, -45705983), s = this.md5_ff(s, c, u, l, e[r + 8], 7, 1770035416), l = this.md5_ff(l, s, c, u, e[r + 9], 12, -1958414417), u = this.md5_ff(u, l, s, c, e[r + 10], 17, -42063), c = this.md5_ff(c, u, l, s, e[r + 11], 22, -1990404162), s = this.md5_ff(s, c, u, l, e[r + 12], 7, 1804603682), l = this.md5_ff(l, s, c, u, e[r + 13], 12, -40341101), u = this.md5_ff(u, l, s, c, e[r + 14], 17, -1502002290), c = this.md5_ff(c, u, l, s, e[r + 15], 22, 1236535329), s = this.md5_gg(s, c, u, l, e[r + 1], 5, -165796510), l = this.md5_gg(l, s, c, u, e[r + 6], 9, -1069501632), u = this.md5_gg(u, l, s, c, e[r + 11], 14, 643717713), c = this.md5_gg(c, u, l, s, e[r], 20, -373897302), s = this.md5_gg(s, c, u, l, e[r + 5], 5, -701558691), l = this.md5_gg(l, s, c, u, e[r + 10], 9, 38016083), u = this.md5_gg(u, l, s, c, e[r + 15], 14, -660478335), c = this.md5_gg(c, u, l, s, e[r + 4], 20, -405537848), s = this.md5_gg(s, c, u, l, e[r + 9], 5, 568446438), l = this.md5_gg(l, s, c, u, e[r + 14], 9, -1019803690), u = this.md5_gg(u, l, s, c, e[r + 3], 14, -187363961), c = this.md5_gg(c, u, l, s, e[r + 8], 20, 1163531501), s = this.md5_gg(s, c, u, l, e[r + 13], 5, -1444681467), l = this.md5_gg(l, s, c, u, e[r + 2], 9, -51403784), u = this.md5_gg(u, l, s, c, e[r + 7], 14, 1735328473), c = this.md5_gg(c, u, l, s, e[r + 12], 20, -1926607734), s = this.md5_hh(s, c, u, l, e[r + 5], 4, -378558), l = this.md5_hh(l, s, c, u, e[r + 8], 11, -2022574463), u = this.md5_hh(u, l, s, c, e[r + 11], 16, 1839030562), c = this.md5_hh(c, u, l, s, e[r + 14], 23, -35309556), s = this.md5_hh(s, c, u, l, e[r + 1], 4, -1530992060), l = this.md5_hh(l, s, c, u, e[r + 4], 11, 1272893353), u = this.md5_hh(u, l, s, c, e[r + 7], 16, -155497632), c = this.md5_hh(c, u, l, s, e[r + 10], 23, -1094730640), s = this.md5_hh(s, c, u, l, e[r + 13], 4, 681279174), l = this.md5_hh(l, s, c, u, e[r], 11, -358537222), u = this.md5_hh(u, l, s, c, e[r + 3], 16, -722521979), c = this.md5_hh(c, u, l, s, e[r + 6], 23, 76029189), s = this.md5_hh(s, c, u, l, e[r + 9], 4, -640364487), l = this.md5_hh(l, s, c, u, e[r + 12], 11, -421815835), u = this.md5_hh(u, l, s, c, e[r + 15], 16, 530742520), c = this.md5_hh(c, u, l, s, e[r + 2], 23, -995338651), s = this.md5_ii(s, c, u, l, e[r], 6, -198630844), l = this.md5_ii(l, s, c, u, e[r + 7], 10, 1126891415), u = this.md5_ii(u, l, s, c, e[r + 14], 15, -1416354905), c = this.md5_ii(c, u, l, s, e[r + 5], 21, -57434055), s = this.md5_ii(s, c, u, l, e[r + 12], 6, 1700485571), l = this.md5_ii(l, s, c, u, e[r + 3], 10, -1894986606), u = this.md5_ii(u, l, s, c, e[r + 10], 15, -1051523), c = this.md5_ii(c, u, l, s, e[r + 1], 21, -2054922799), s = this.md5_ii(s, c, u, l, e[r + 8], 6, 1873313359), l = this.md5_ii(l, s, c, u, e[r + 15], 10, -30611744), u = this.md5_ii(u, l, s, c, e[r + 6], 15, -1560198380), c = this.md5_ii(c, u, l, s, e[r + 13], 21, 1309151649), s = this.md5_ii(s, c, u, l, e[r + 4], 6, -145523070), l = this.md5_ii(l, s, c, u, e[r + 11], 10, -1120210379), u = this.md5_ii(u, l, s, c, e[r + 2], 15, 718787259), c = this.md5_ii(c, u, l, s, e[r + 9], 21, -343485551), s = this.safe_add(s, n), c = this.safe_add(c, i), u = this.safe_add(u, a), l = this.safe_add(l, o);
                        return [
                            s,
                            c,
                            u,
                            l
                        ];
                    }, _.prototype.binl2rstr = function (e) {
                        var t, r = '';
                        for (t = 0; t < 32 * e.length; t += 8)
                            r += String.fromCharCode(e[t >> 5] >>> t % 32 & 255);
                        return r;
                    }, _.prototype.rstr2binl = function (e) {
                        var t, r = [];
                        for (r[(e.length >> 2) - 1] = void 0, t = 0; t < r.length; t += 1)
                            r[t] = 0;
                        for (t = 0; t < 8 * e.length; t += 8)
                            r[t >> 5] |= (255 & e.charCodeAt(t / 8)) << t % 32;
                        return r;
                    }, _.prototype.rstr_md5 = function (e) {
                        return this.binl2rstr(this.binl_md5(this.rstr2binl(e), 8 * e.length));
                    }, _.prototype.rstr_hmac_md5 = function (e, t) {
                        var r, n, i = this.rstr2binl(e), a = [], o = [];
                        for (a[15] = o[15] = void 0, i.length > 16 && (i = this.binl_md5(i, 8 * e.length)), r = 0; r < 16; r += 1)
                            a[r] = 909522486 ^ i[r], o[r] = 1549556828 ^ i[r];
                        return n = this.binl_md5(a.concat(this.rstr2binl(t)), 512 + 8 * t.length), this.binl2rstr(this.binl_md5(o.concat(n), 640));
                    }, _.prototype.rstr2hex = function (e) {
                        var t, r, n = '0123456789abcdef', i = '';
                        for (r = 0; r < e.length; r += 1)
                            t = e.charCodeAt(r), i += n.charAt(t >>> 4 & 15) + n.charAt(15 & t);
                        return i;
                    }, _.prototype.str2rstr_utf8 = function (e) {
                        return unescape(encodeURIComponent(e));
                    }, _.prototype.raw_md5 = function (e) {
                        return this.rstr_md5(this.str2rstr_utf8(e));
                    }, _.prototype.hex_md5 = function (e) {
                        return this.rstr2hex(this.raw_md5(e));
                    }, _.prototype.raw_hmac_md5 = function (e, t) {
                        return this.rstr_hmac_md5(this.str2rstr_utf8(e), this.str2rstr_utf8(t));
                    }, _.prototype.hex_hmac_md5 = function (e, t) {
                        return this.rstr2hex(this.raw_hmac_md5(e, t));
                    }, _.prototype.md5 = function (e, t, r) {
                        return t ? r ? this.raw_hmac_md5(t, e) : this.hex_hmac_md5(t, e) : r ? this.raw_md5(e) : this.hex_md5(e);
                    }, e.exports && (t = e.exports = l), t.Chance = l, void 0 === (r = function () {
                        return l;
                    }.apply(t, [])) || (e.exports = r), 'undefined' != typeof importScripts && (chance = new l(), self.Chance = l), 'object' == typeof window && 'object' == typeof window.document && (window.Chance = l, window.chance = new l());
                }();
            },
            6880: e => {
                'use strict';
                e.exports = () => {
                    const e = '[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\u1ab0-\\u1aff\\u1dc0-\\u1dff]', t = '\\ud83c[\\udffb-\\udfff]', r = '[^\\ud800-\\udfff]', n = '(?:\\uD83C[\\uDDE6-\\uDDFF]){2}', i = '[\\ud800-\\udbff][\\udc00-\\udfff]', a = `(?:${ e }|${ t })?`, o = '[\\ufe0e\\ufe0f]?', s = o + a + `(?:\\u200d(?:${ [
                            r,
                            n,
                            i
                        ].join('|') })${ o + a })*`, c = `(?:${ [
                            `${ r }${ e }?`,
                            e,
                            n,
                            i,
                            '[\\ud800-\\udfff]',
                            '[\\uD83D\\uDC69\\uD83C\\uDFFB\\u200D\\uD83C\\uDF93]'
                        ].join('|') })`;
                    return new RegExp(`(?:\\ud83c\\udff4\\udb40\\udc67\\udb40\\udc62\\udb40(?:\\udc65|\\udc73|\\udc77)\\udb40(?:\\udc6e|\\udc63|\\udc6c)\\udb40(?:\\udc67|\\udc74|\\udc73)\\udb40\\udc7f)|${ t }(?=${ t })|${ c + s }`, 'g');
                };
            },
            487: e => {
                var t = {
                    utf8: {
                        stringToBytes: function (e) {
                            return t.bin.stringToBytes(unescape(encodeURIComponent(e)));
                        },
                        bytesToString: function (e) {
                            return decodeURIComponent(escape(t.bin.bytesToString(e)));
                        }
                    },
                    bin: {
                        stringToBytes: function (e) {
                            for (var t = [], r = 0; r < e.length; r++)
                                t.push(255 & e.charCodeAt(r));
                            return t;
                        },
                        bytesToString: function (e) {
                            for (var t = [], r = 0; r < e.length; r++)
                                t.push(String.fromCharCode(e[r]));
                            return t.join('');
                        }
                    }
                };
                e.exports = t;
            },
            4571: (e, t, r) => {
                'use strict';
                r.r(t), r.d(t, {
                    ARRAY_CONTAINS: () => Yc,
                    ARRAY_MAX_SIZE: () => su,
                    ARRAY_MIN_SIZE: () => iu,
                    ARRAY_NOT_CONTAINS: () => Jc,
                    ARRAY_NOT_EMPTY: () => tu,
                    ARRAY_UNIQUE: () => lu,
                    Allow: () => C,
                    ArrayContains: () => Zc,
                    ArrayMaxSize: () => uu,
                    ArrayMinSize: () => ou,
                    ArrayNotContains: () => eu,
                    ArrayNotEmpty: () => nu,
                    ArrayUnique: () => pu,
                    CONTAINS: () => Be,
                    Contains: () => Le,
                    EQUALS: () => z,
                    Equals: () => Y,
                    IS_ALPHA: () => Ue,
                    IS_ALPHANUMERIC: () => ze,
                    IS_ARRAY: () => Uc,
                    IS_ASCII: () => nt,
                    IS_BASE32: () => bo,
                    IS_BASE58: () => dc,
                    IS_BASE64: () => ct,
                    IS_BIC: () => _o,
                    IS_BOOLEAN: () => _c,
                    IS_BOOLEAN_STRING: () => so,
                    IS_BTC_ADDRESS: () => Do,
                    IS_BYTE_LENGTH: () => ft,
                    IS_CREDIT_CARD: () => bt,
                    IS_CURRENCY: () => _t,
                    IS_DATA_URI: () => Po,
                    IS_DATE: () => Ic,
                    IS_DATE_STRING: () => ro,
                    IS_DECIMAL: () => Je,
                    IS_DEFINED: () => I,
                    IS_DIVISIBLE_BY: () => fe,
                    IS_EAN: () => Lo,
                    IS_EMAIL: () => Dt,
                    IS_EMPTY: () => Q,
                    IS_ENUM: () => Pc,
                    IS_ETHEREUM_ADDRESS: () => Uo,
                    IS_FIREBASE_PUSH_ID: () => Bn,
                    IS_FQDN: () => Pt,
                    IS_FULL_WIDTH: () => kt,
                    IS_HALF_WIDTH: () => Gt,
                    IS_HASH: () => Xa,
                    IS_HEXADECIMAL: () => rr,
                    IS_HEX_COLOR: () => Zt,
                    IS_HSL: () => Xo,
                    IS_IBAN: () => Jo,
                    IS_IDENTITY_CARD: () => ns,
                    IS_IN: () => ae,
                    IS_INSTANCE: () => gu,
                    IS_INT: () => kc,
                    IS_IP: () => fr,
                    IS_ISBN: () => _r,
                    IS_ISIN: () => Dr,
                    IS_ISO31661_ALPHA_2: () => rn,
                    IS_ISO31661_ALPHA_3: () => cn,
                    IS_ISO4217_CURRENCY_CODE: () => vc,
                    IS_ISO8601: () => Pr,
                    IS_ISRC: () => cs,
                    IS_ISSN: () => Qa,
                    IS_JSON: () => Lr,
                    IS_JWT: () => Ur,
                    IS_LATITUDE: () => G,
                    IS_LATLONG: () => L,
                    IS_LENGTH: () => Kn,
                    IS_LOCALE: () => fs,
                    IS_LONGITUDE: () => H,
                    IS_LOWERCASE: () => Xr,
                    IS_MAC_ADDRESS: () => cr,
                    IS_MAGNET_URI: () => bs,
                    IS_MILITARY_TIME: () => Ua,
                    IS_MIME_TYPE: () => _s,
                    IS_MOBILE_PHONE: () => Jr,
                    IS_MONGO_ID: () => fn,
                    IS_MULTIBYTE: () => bn,
                    IS_NEGATIVE: () => Se,
                    IS_NOT_EMPTY: () => re,
                    IS_NOT_EMPTY_OBJECT: () => fu,
                    IS_NOT_IN: () => ce,
                    IS_NUMBER: () => Oc,
                    IS_NUMBER_STRING: () => fo,
                    IS_OBJECT: () => Kc,
                    IS_OCTAL: () => Ds,
                    IS_PASSPORT_NUMBER: () => Ps,
                    IS_PHONE_NUMBER: () => ja,
                    IS_PORT: () => br,
                    IS_POSITIVE: () => ge,
                    IS_POSTAL_CODE: () => ks,
                    IS_RFC_3339: () => Vs,
                    IS_RGB_COLOR: () => zs,
                    IS_SEM_VER: () => Js,
                    IS_STRING: () => jc,
                    IS_STRONG_PASSWORD: () => nc,
                    IS_SURROGATE_PAIR: () => _n,
                    IS_TAX_ID: () => gc,
                    IS_TIMEZONE: () => oc,
                    IS_UPPERCASE: () => Gn,
                    IS_URL: () => Dn,
                    IS_UUID: () => Pn,
                    IS_VARIABLE_WIDTH: () => Kt,
                    IsAlpha: () => We,
                    IsAlphanumeric: () => Ye,
                    IsArray: () => Wc,
                    IsAscii: () => at,
                    IsBIC: () => No,
                    IsBase32: () => vo,
                    IsBase58: () => fc,
                    IsBase64: () => lt,
                    IsBoolean: () => Nc,
                    IsBooleanString: () => uo,
                    IsBtcAddress: () => Ro,
                    IsByteLength: () => ht,
                    IsCreditCard: () => vt,
                    IsCurrency: () => Nt,
                    IsDataURI: () => wo,
                    IsDate: () => Dc,
                    IsDateString: () => io,
                    IsDecimal: () => et,
                    IsDefined: () => D,
                    IsDivisibleBy: () => he,
                    IsEAN: () => jo,
                    IsEmail: () => Rt,
                    IsEmpty: () => te,
                    IsEnum: () => Bc,
                    IsEthereumAddress: () => Wo,
                    IsFQDN: () => wt,
                    IsFirebasePushId: () => Ln,
                    IsFullWidth: () => $t,
                    IsHSL: () => qo,
                    IsHalfWidth: () => Ut,
                    IsHash: () => qa,
                    IsHexColor: () => Qt,
                    IsHexadecimal: () => ir,
                    IsIBAN: () => es,
                    IsIP: () => hr,
                    IsISBN: () => Nr,
                    IsISIN: () => Rr,
                    IsISO31661Alpha2: () => an,
                    IsISO31661Alpha3: () => ln,
                    IsISO4217CurrencyCode: () => Ac,
                    IsISO8601: () => wr,
                    IsISRC: () => ls,
                    IsISSN: () => to,
                    IsIdentityCard: () => as,
                    IsIn: () => se,
                    IsInstance: () => bu,
                    IsInt: () => $c,
                    IsJSON: () => jr,
                    IsJWT: () => Wr,
                    IsLatLong: () => j,
                    IsLatitude: () => U,
                    IsLocale: () => hs,
                    IsLongitude: () => K,
                    IsLowercase: () => qr,
                    IsMACAddress: () => lr,
                    IsMagnetURI: () => vs,
                    IsMilitaryTime: () => Wa,
                    IsMimeType: () => Ns,
                    IsMobilePhone: () => en,
                    IsMongoId: () => hn,
                    IsMultibyte: () => vn,
                    IsNegative: () => Ce,
                    IsNotEmpty: () => ie,
                    IsNotEmptyObject: () => hu,
                    IsNotIn: () => le,
                    IsNumber: () => Mc,
                    IsNumberString: () => ho,
                    IsObject: () => Xc,
                    IsOctal: () => Rs,
                    IsOptional: () => O,
                    IsPassportNumber: () => ws,
                    IsPhoneNumber: () => Va,
                    IsPort: () => vr,
                    IsPositive: () => be,
                    IsPostalCode: () => $s,
                    IsRFC3339: () => Hs,
                    IsRgbColor: () => Ys,
                    IsSemVer: () => ec,
                    IsString: () => Vc,
                    IsStrongPassword: () => ac,
                    IsSurrogatePair: () => Nn,
                    IsTaxId: () => bc,
                    IsTimeZone: () => cc,
                    IsUUID: () => wn,
                    IsUppercase: () => Un,
                    IsUrl: () => Rn,
                    IsVariableWidth: () => Xt,
                    Length: () => Xn,
                    MATCHES: () => ni,
                    MAX: () => Ae,
                    MAX_DATE: () => Me,
                    MAX_LENGTH: () => Yn,
                    MIN: () => Ne,
                    MIN_DATE: () => De,
                    MIN_LENGTH: () => Jn,
                    Matches: () => ai,
                    Max: () => Ee,
                    MaxDate: () => Pe,
                    MaxLength: () => Zn,
                    MetadataStorage: () => s,
                    Min: () => Te,
                    MinDate: () => Re,
                    MinLength: () => ei,
                    NOT_CONTAINS: () => $e,
                    NOT_EQUALS: () => q,
                    NotContains: () => Ge,
                    NotEquals: () => J,
                    Validate: () => M,
                    ValidateBy: () => N,
                    ValidateIf: () => F,
                    ValidateNested: () => x,
                    ValidatePromise: () => w,
                    ValidationError: () => u,
                    ValidationTypes: () => l,
                    Validator: () => y,
                    ValidatorConstraint: () => R,
                    arrayContains: () => qc,
                    arrayMaxSize: () => cu,
                    arrayMinSize: () => au,
                    arrayNotContains: () => Qc,
                    arrayNotEmpty: () => ru,
                    arrayUnique: () => du,
                    buildMessage: () => E,
                    contains: () => ke,
                    equals: () => X,
                    getFromContainer: () => v,
                    getMetadataStorage: () => c,
                    isAlpha: () => He,
                    isAlphanumeric: () => Xe,
                    isArray: () => Hc,
                    isAscii: () => it,
                    isBIC: () => Eo,
                    isBase32: () => So,
                    isBase58: () => pc,
                    isBase64: () => ut,
                    isBoolean: () => Ec,
                    isBooleanString: () => co,
                    isBtcAddress: () => Oo,
                    isByteLength: () => mt,
                    isCreditCard: () => St,
                    isCurrency: () => Et,
                    isDataURI: () => xo,
                    isDate: () => Tc,
                    isDateString: () => no,
                    isDecimal: () => Qe,
                    isDefined: () => T,
                    isDivisibleBy: () => me,
                    isEAN: () => $o,
                    isEmail: () => Ot,
                    isEmpty: () => ee,
                    isEnum: () => xc,
                    isEthereumAddress: () => Ho,
                    isFQDN: () => xt,
                    isFirebasePushId: () => kn,
                    isFullWidth: () => Lt,
                    isHSL: () => Yo,
                    isHalfWidth: () => Vt,
                    isHash: () => Ya,
                    isHexColor: () => Jt,
                    isHexadecimal: () => nr,
                    isIBAN: () => Qo,
                    isIP: () => mr,
                    isISBN: () => Er,
                    isISIN: () => Or,
                    isISO31661Alpha2: () => nn,
                    isISO31661Alpha3: () => un,
                    isISO4217CurrencyCode: () => Cc,
                    isISO8601: () => xr,
                    isISRC: () => us,
                    isISSN: () => eo,
                    isIdentityCard: () => is,
                    isIn: () => oe,
                    isInstance: () => yu,
                    isInt: () => Lc,
                    isJSON: () => $r,
                    isJWT: () => Hr,
                    isLatLong: () => $,
                    isLatitude: () => V,
                    isLocale: () => ms,
                    isLongitude: () => W,
                    isLowercase: () => Yr,
                    isMACAddress: () => ur,
                    isMagnetURI: () => Ss,
                    isMilitaryTime: () => Ha,
                    isMimeType: () => Es,
                    isMobilePhone: () => Qr,
                    isMongoId: () => mn,
                    isMultibyte: () => Sn,
                    isNegative: () => ve,
                    isNotEmpty: () => ne,
                    isNotEmptyObject: () => mu,
                    isNotIn: () => ue,
                    isNumber: () => Rc,
                    isNumberString: () => mo,
                    isObject: () => zc,
                    isOctal: () => Os,
                    isPassportNumber: () => xs,
                    isPhoneNumber: () => Ga,
                    isPort: () => Sr,
                    isPositive: () => ye,
                    isPostalCode: () => Ls,
                    isRFC3339: () => Us,
                    isRgbColor: () => Xs,
                    isSemVer: () => Qs,
                    isString: () => Gc,
                    isStrongPassword: () => ic,
                    isSurrogatePair: () => En,
                    isTaxId: () => yc,
                    isTimeZone: () => sc,
                    isURL: () => On,
                    isUUID: () => xn,
                    isUppercase: () => Vn,
                    isValidationOptions: () => ar,
                    isVariableWidth: () => zt,
                    length: () => zn,
                    matches: () => ii,
                    max: () => _e,
                    maxDate: () => Fe,
                    maxLength: () => qn,
                    min: () => Ie,
                    minDate: () => Oe,
                    minLength: () => Qn,
                    notContains: () => je,
                    notEquals: () => Z,
                    registerDecorator: () => _,
                    registerSchema: () => Au,
                    useContainer: () => S,
                    validate: () => Su,
                    validateOrReject: () => vu,
                    validateSync: () => Cu
                });
                var n = function (e) {
                        this.groups = [], this.each = !1, this.context = void 0, this.type = e.type, this.name = e.name, this.target = e.target, this.propertyName = e.propertyName, this.constraints = null == e ? void 0 : e.constraints, this.constraintCls = e.constraintCls, this.validationTypeOptions = e.validationTypeOptions, e.validationOptions && (this.message = e.validationOptions.message, this.groups = e.validationOptions.groups, this.always = e.validationOptions.always, this.each = e.validationOptions.each, this.context = e.validationOptions.context);
                    }, i = function () {
                        function e() {
                        }
                        return e.prototype.transform = function (e) {
                            var t = [];
                            return Object.keys(e.properties).forEach(function (r) {
                                e.properties[r].forEach(function (i) {
                                    var a = {
                                            message: i.message,
                                            groups: i.groups,
                                            always: i.always,
                                            each: i.each
                                        }, o = {
                                            type: i.type,
                                            name: i.name,
                                            target: e.name,
                                            propertyName: r,
                                            constraints: i.constraints,
                                            validationTypeOptions: i.options,
                                            validationOptions: a
                                        };
                                    t.push(new n(o));
                                });
                            }), t;
                        }, e;
                    }(), a = function (e, t) {
                        var r = 'function' == typeof Symbol && e[Symbol.iterator];
                        if (!r)
                            return e;
                        var n, i, a = r.call(e), o = [];
                        try {
                            for (; (void 0 === t || t-- > 0) && !(n = a.next()).done;)
                                o.push(n.value);
                        } catch (e) {
                            i = { error: e };
                        } finally {
                            try {
                                n && !n.done && (r = a.return) && r.call(a);
                            } finally {
                                if (i)
                                    throw i.error;
                            }
                        }
                        return o;
                    }, o = function (e, t, r) {
                        if (r || 2 === arguments.length)
                            for (var n, i = 0, a = t.length; i < a; i++)
                                !n && i in t || (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
                        return e.concat(n || Array.prototype.slice.call(t));
                    }, s = function () {
                        function e() {
                            this.validationMetadatas = new Map(), this.constraintMetadatas = new Map();
                        }
                        return Object.defineProperty(e.prototype, 'hasValidationMetaData', {
                            get: function () {
                                return !!this.validationMetadatas.size;
                            },
                            enumerable: !1,
                            configurable: !0
                        }), e.prototype.addValidationSchema = function (e) {
                            var t = this;
                            new i().transform(e).forEach(function (e) {
                                return t.addValidationMetadata(e);
                            });
                        }, e.prototype.addValidationMetadata = function (e) {
                            var t = this.validationMetadatas.get(e.target);
                            t ? t.push(e) : this.validationMetadatas.set(e.target, [e]);
                        }, e.prototype.addConstraintMetadata = function (e) {
                            var t = this.constraintMetadatas.get(e.target);
                            t ? t.push(e) : this.constraintMetadatas.set(e.target, [e]);
                        }, e.prototype.groupByPropertyName = function (e) {
                            var t = {};
                            return e.forEach(function (e) {
                                t[e.propertyName] || (t[e.propertyName] = []), t[e.propertyName].push(e);
                            }), t;
                        }, e.prototype.getTargetValidationMetadatas = function (e, t, r, n, i) {
                            var s, c, u = function (e) {
                                    return void 0 !== e.always ? e.always : (!e.groups || !e.groups.length) && r;
                                }, l = function (e) {
                                    return !(!n || i && i.length || !e.groups || !e.groups.length);
                                }, d = (this.validationMetadatas.get(e) || []).filter(function (r) {
                                    return (r.target === e || r.target === t) && (!!u(r) || !l(r) && (!(i && i.length > 0) || r.groups && !!r.groups.find(function (e) {
                                        return -1 !== i.indexOf(e);
                                    })));
                                }), p = [];
                            try {
                                for (var f = function (e) {
                                            var t = 'function' == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
                                            if (r)
                                                return r.call(e);
                                            if (e && 'number' == typeof e.length)
                                                return {
                                                    next: function () {
                                                        return e && n >= e.length && (e = void 0), {
                                                            value: e && e[n++],
                                                            done: !e
                                                        };
                                                    }
                                                };
                                            throw new TypeError(t ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
                                        }(this.validationMetadatas.entries()), m = f.next(); !m.done; m = f.next()) {
                                    var h = a(m.value, 2), g = h[0], y = h[1];
                                    e.prototype instanceof g && p.push.apply(p, o([], a(y), !1));
                                }
                            } catch (e) {
                                s = { error: e };
                            } finally {
                                try {
                                    m && !m.done && (c = f.return) && c.call(f);
                                } finally {
                                    if (s)
                                        throw s.error;
                                }
                            }
                            var b = p.filter(function (t) {
                                return 'string' != typeof t.target && t.target !== e && (!(t.target instanceof Function) || e.prototype instanceof t.target) && (!!u(t) || !l(t) && (!(i && i.length > 0) || t.groups && !!t.groups.find(function (e) {
                                    return -1 !== i.indexOf(e);
                                })));
                            }).filter(function (e) {
                                return !d.find(function (t) {
                                    return t.propertyName === e.propertyName && t.type === e.type;
                                });
                            });
                            return d.concat(b);
                        }, e.prototype.getTargetValidatorConstraints = function (e) {
                            return this.constraintMetadatas.get(e) || [];
                        }, e;
                    }();
                function c() {
                    var e = 'undefined' != typeof globalThis ? globalThis : void 0 !== r.g ? r.g : 'undefined' != typeof window ? window : 'undefined' != typeof self ? self : void 0;
                    return e.classValidatorMetadataStorage || (e.classValidatorMetadataStorage = new s()), e.classValidatorMetadataStorage;
                }
                var u = function () {
                        function e() {
                        }
                        return e.prototype.toString = function (e, t, r, n) {
                            var i = this;
                            void 0 === e && (e = !1), void 0 === t && (t = !1), void 0 === r && (r = ''), void 0 === n && (n = !1);
                            var a = e ? '\x1B[1m' : '', o = e ? '\x1B[22m' : '', s = function (e) {
                                    return ' - property '.concat(a).concat(r).concat(e).concat(o, ' has failed the following constraints: ').concat(a).concat((n ? Object.values : Object.keys)(null !== (t = i.constraints) && void 0 !== t ? t : {}).join(', ')).concat(o, ' \n');
                                    var t;
                                };
                            if (t) {
                                var c = Number.isInteger(+this.property) ? '['.concat(this.property, ']') : ''.concat(r ? '.' : '').concat(this.property);
                                return this.constraints ? s(c) : this.children ? this.children.map(function (t) {
                                    return t.toString(e, !0, ''.concat(r).concat(c), n);
                                }).join('') : '';
                            }
                            return 'An instance of '.concat(a).concat(this.target ? this.target.constructor.name : 'an object').concat(o, ' has failed the validation:\n') + (this.constraints ? s(this.property) : '') + (this.children ? this.children.map(function (t) {
                                return t.toString(e, !0, i.property, n);
                            }).join('') : '');
                        }, e;
                    }(), l = function () {
                        function e() {
                        }
                        return e.isValid = function (e) {
                            var t = this;
                            return 'isValid' !== e && 'getMessage' !== e && -1 !== Object.keys(this).map(function (e) {
                                return t[e];
                            }).indexOf(e);
                        }, e.CUSTOM_VALIDATION = 'customValidation', e.NESTED_VALIDATION = 'nestedValidation', e.PROMISE_VALIDATION = 'promiseValidation', e.CONDITIONAL_VALIDATION = 'conditionalValidation', e.WHITELIST = 'whitelistValidation', e.IS_DEFINED = 'isDefined', e;
                    }(), d = function () {
                        function e() {
                        }
                        return e.replaceMessageSpecialTokens = function (e, t) {
                            var r;
                            return e instanceof Function ? r = e(t) : 'string' == typeof e && (r = e), r && Array.isArray(t.constraints) && t.constraints.forEach(function (e, t) {
                                r = r.replace(new RegExp('\\$constraint'.concat(t + 1), 'g'), function (e) {
                                    return Array.isArray(e) ? e.join(', ') : ('symbol' == typeof e && (e = e.description), ''.concat(e));
                                }(e));
                            }), r && void 0 !== t.value && null !== t.value && 'string' == typeof t.value && (r = r.replace(/\$value/g, t.value)), r && (r = r.replace(/\$property/g, t.property)), r && (r = r.replace(/\$target/g, t.targetName)), r;
                        }, e;
                    }();
                function p(e) {
                    return null !== e && 'object' == typeof e && 'function' == typeof e.then;
                }
                var f, m, h = function (e, t) {
                        var r = 'function' == typeof Symbol && e[Symbol.iterator];
                        if (!r)
                            return e;
                        var n, i, a = r.call(e), o = [];
                        try {
                            for (; (void 0 === t || t-- > 0) && !(n = a.next()).done;)
                                o.push(n.value);
                        } catch (e) {
                            i = { error: e };
                        } finally {
                            try {
                                n && !n.done && (r = a.return) && r.call(a);
                            } finally {
                                if (i)
                                    throw i.error;
                            }
                        }
                        return o;
                    }, g = function () {
                        function e(e, t) {
                            this.validator = e, this.validatorOptions = t, this.awaitingPromises = [], this.ignoreAsyncValidations = !1, this.metadataStorage = c();
                        }
                        return e.prototype.execute = function (e, t, r) {
                            var n, i, a = this;
                            this.metadataStorage.hasValidationMetaData || !0 !== (null === (n = this.validatorOptions) || void 0 === n ? void 0 : n.enableDebugMessages) || console.warn('No validation metadata found. No validation will be  performed. There are multiple possible reasons:\n  - There may be multiple class-validator versions installed. You will need to flatten your dependencies to fix the issue.\n  - This validation runs before any file with validation decorator was parsed by NodeJS.');
                            var o = this.validatorOptions ? this.validatorOptions.groups : void 0, s = this.validatorOptions && this.validatorOptions.strictGroups || !1, c = this.validatorOptions && this.validatorOptions.always || !1, d = void 0 === (null === (i = this.validatorOptions) || void 0 === i ? void 0 : i.forbidUnknownValues) || !1 !== this.validatorOptions.forbidUnknownValues, p = this.metadataStorage.getTargetValidationMetadatas(e.constructor, t, c, s, o), f = this.metadataStorage.groupByPropertyName(p);
                            if (this.validatorOptions && d && !p.length) {
                                var m = new u();
                                return this.validatorOptions && this.validatorOptions.validationError && void 0 !== this.validatorOptions.validationError.target && !0 !== this.validatorOptions.validationError.target || (m.target = e), m.value = void 0, m.property = void 0, m.children = [], m.constraints = { unknownValue: 'an unknown value was passed to the validate function' }, void r.push(m);
                            }
                            this.validatorOptions && this.validatorOptions.whitelist && this.whitelist(e, f, r), Object.keys(f).forEach(function (t) {
                                var n = e[t], i = f[t].filter(function (e) {
                                        return e.type === l.IS_DEFINED;
                                    }), o = f[t].filter(function (e) {
                                        return e.type !== l.IS_DEFINED && e.type !== l.WHITELIST;
                                    });
                                n instanceof Promise && o.find(function (e) {
                                    return e.type === l.PROMISE_VALIDATION;
                                }) ? a.awaitingPromises.push(n.then(function (n) {
                                    a.performValidations(e, n, t, i, o, r);
                                })) : a.performValidations(e, n, t, i, o, r);
                            });
                        }, e.prototype.whitelist = function (e, t, r) {
                            var n = this, i = [];
                            Object.keys(e).forEach(function (e) {
                                t[e] && 0 !== t[e].length || i.push(e);
                            }), i.length > 0 && (this.validatorOptions && this.validatorOptions.forbidNonWhitelisted ? i.forEach(function (t) {
                                var i, a = n.generateValidationError(e, e[t], t);
                                a.constraints = ((i = {})[l.WHITELIST] = 'property '.concat(t, ' should not exist'), i), a.children = void 0, r.push(a);
                            }) : i.forEach(function (t) {
                                return delete e[t];
                            }));
                        }, e.prototype.stripEmptyErrors = function (e) {
                            var t = this;
                            return e.filter(function (e) {
                                if (e.children && (e.children = t.stripEmptyErrors(e.children)), 0 === Object.keys(e.constraints).length) {
                                    if (0 === e.children.length)
                                        return !1;
                                    delete e.constraints;
                                }
                                return !0;
                            });
                        }, e.prototype.performValidations = function (e, t, r, n, i, a) {
                            var o = i.filter(function (e) {
                                    return e.type === l.CUSTOM_VALIDATION;
                                }), s = i.filter(function (e) {
                                    return e.type === l.NESTED_VALIDATION;
                                }), c = i.filter(function (e) {
                                    return e.type === l.CONDITIONAL_VALIDATION;
                                }), u = this.generateValidationError(e, t, r);
                            a.push(u), this.conditionalValidations(e, t, c) && (this.customValidations(e, t, n, u), this.mapContexts(e, t, n, u), void 0 === t && this.validatorOptions && !0 === this.validatorOptions.skipUndefinedProperties || null === t && this.validatorOptions && !0 === this.validatorOptions.skipNullProperties || null == t && this.validatorOptions && !0 === this.validatorOptions.skipMissingProperties || (this.customValidations(e, t, o, u), this.nestedValidations(t, s, u), this.mapContexts(e, t, i, u), this.mapContexts(e, t, o, u)));
                        }, e.prototype.generateValidationError = function (e, t, r) {
                            var n = new u();
                            return this.validatorOptions && this.validatorOptions.validationError && void 0 !== this.validatorOptions.validationError.target && !0 !== this.validatorOptions.validationError.target || (n.target = e), this.validatorOptions && this.validatorOptions.validationError && void 0 !== this.validatorOptions.validationError.value && !0 !== this.validatorOptions.validationError.value || (n.value = t), n.property = r, n.children = [], n.constraints = {}, n;
                        }, e.prototype.conditionalValidations = function (e, t, r) {
                            return r.map(function (r) {
                                return r.constraints[0](e, t);
                            }).reduce(function (e, t) {
                                return e && t;
                            }, !0);
                        }, e.prototype.customValidations = function (e, t, r, n) {
                            var i = this;
                            r.forEach(function (r) {
                                i.metadataStorage.getTargetValidatorConstraints(r.constraintCls).forEach(function (a) {
                                    if (!(a.async && i.ignoreAsyncValidations || i.validatorOptions && i.validatorOptions.stopAtFirstError && Object.keys(n.constraints || {}).length > 0)) {
                                        var o = {
                                            targetName: e.constructor ? e.constructor.name : void 0,
                                            property: r.propertyName,
                                            object: e,
                                            value: t,
                                            constraints: r.constraints
                                        };
                                        if (r.each && (Array.isArray(t) || t instanceof Set || t instanceof Map)) {
                                            var s, c = ((s = t) instanceof Map ? Array.from(s.values()) : Array.isArray(s) ? s : Array.from(s)).map(function (e) {
                                                    return a.instance.validate(e, o);
                                                });
                                            if (c.some(function (e) {
                                                    return p(e);
                                                })) {
                                                var u = c.map(function (e) {
                                                        return p(e) ? e : Promise.resolve(e);
                                                    }), l = Promise.all(u).then(function (o) {
                                                        if (!o.every(function (e) {
                                                                return e;
                                                            })) {
                                                            var s = h(i.createValidationError(e, t, r, a), 2), c = s[0], u = s[1];
                                                            n.constraints[c] = u, r.context && (n.contexts || (n.contexts = {}), n.contexts[c] = Object.assign(n.contexts[c] || {}, r.context));
                                                        }
                                                    });
                                                i.awaitingPromises.push(l);
                                            } else if (!c.every(function (e) {
                                                    return e;
                                                })) {
                                                var d = h(i.createValidationError(e, t, r, a), 2);
                                                y = d[0], b = d[1], n.constraints[y] = b;
                                            }
                                        } else {
                                            var f = a.instance.validate(t, o);
                                            if (p(f)) {
                                                var m = f.then(function (o) {
                                                    if (!o) {
                                                        var s = h(i.createValidationError(e, t, r, a), 2), c = s[0], u = s[1];
                                                        n.constraints[c] = u, r.context && (n.contexts || (n.contexts = {}), n.contexts[c] = Object.assign(n.contexts[c] || {}, r.context));
                                                    }
                                                });
                                                i.awaitingPromises.push(m);
                                            } else if (!f) {
                                                var g = h(i.createValidationError(e, t, r, a), 2), y = g[0], b = g[1];
                                                n.constraints[y] = b;
                                            }
                                        }
                                    }
                                });
                            });
                        }, e.prototype.nestedValidations = function (e, t, r) {
                            var n = this;
                            void 0 !== e && t.forEach(function (i) {
                                if (!(i.type !== l.NESTED_VALIDATION && i.type !== l.PROMISE_VALIDATION || n.validatorOptions && n.validatorOptions.stopAtFirstError && Object.keys(r.constraints || {}).length > 0))
                                    if (Array.isArray(e) || e instanceof Set || e instanceof Map)
                                        (e instanceof Set ? Array.from(e) : e).forEach(function (i, a) {
                                            n.performValidations(e, i, a.toString(), [], t, r.children);
                                        });
                                    else if (e instanceof Object) {
                                        var a = 'string' == typeof i.target ? i.target : i.target.name;
                                        n.execute(e, a, r.children);
                                    } else {
                                        var o = h(n.createValidationError(i.target, e, i), 2), s = o[0], c = o[1];
                                        r.constraints[s] = c;
                                    }
                            });
                        }, e.prototype.mapContexts = function (e, t, r, n) {
                            var i = this;
                            return r.forEach(function (e) {
                                if (e.context) {
                                    var t = void 0;
                                    e.type === l.CUSTOM_VALIDATION && (t = i.metadataStorage.getTargetValidatorConstraints(e.constraintCls)[0]);
                                    var r = i.getConstraintType(e, t);
                                    n.constraints[r] && (n.contexts || (n.contexts = {}), n.contexts[r] = Object.assign(n.contexts[r] || {}, e.context));
                                }
                            });
                        }, e.prototype.createValidationError = function (e, t, r, n) {
                            var i = e.constructor ? e.constructor.name : void 0, a = this.getConstraintType(r, n), o = {
                                    targetName: i,
                                    property: r.propertyName,
                                    object: e,
                                    value: t,
                                    constraints: r.constraints
                                }, s = r.message || '';
                            return r.message || this.validatorOptions && (!this.validatorOptions || this.validatorOptions.dismissDefaultMessages) || n && n.instance.defaultMessage instanceof Function && (s = n.instance.defaultMessage(o)), [
                                a,
                                d.replaceMessageSpecialTokens(s, o)
                            ];
                        }, e.prototype.getConstraintType = function (e, t) {
                            return t && t.name ? t.name : e.type;
                        }, e;
                    }(), y = function () {
                        function e() {
                        }
                        return e.prototype.validate = function (e, t, r) {
                            return this.coreValidate(e, t, r);
                        }, e.prototype.validateOrReject = function (e, t, r) {
                            return n = this, i = void 0, o = function () {
                                var n;
                                return function (e, t) {
                                    var r, n, i, a, o = {
                                            label: 0,
                                            sent: function () {
                                                if (1 & i[0])
                                                    throw i[1];
                                                return i[1];
                                            },
                                            trys: [],
                                            ops: []
                                        };
                                    return a = {
                                        next: s(0),
                                        throw: s(1),
                                        return: s(2)
                                    }, 'function' == typeof Symbol && (a[Symbol.iterator] = function () {
                                        return this;
                                    }), a;
                                    function s(s) {
                                        return function (c) {
                                            return function (s) {
                                                if (r)
                                                    throw new TypeError('Generator is already executing.');
                                                for (; a && (a = 0, s[0] && (o = 0)), o;)
                                                    try {
                                                        if (r = 1, n && (i = 2 & s[0] ? n.return : s[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, s[1])).done)
                                                            return i;
                                                        switch (n = 0, i && (s = [
                                                                2 & s[0],
                                                                i.value
                                                            ]), s[0]) {
                                                        case 0:
                                                        case 1:
                                                            i = s;
                                                            break;
                                                        case 4:
                                                            return o.label++, {
                                                                value: s[1],
                                                                done: !1
                                                            };
                                                        case 5:
                                                            o.label++, n = s[1], s = [0];
                                                            continue;
                                                        case 7:
                                                            s = o.ops.pop(), o.trys.pop();
                                                            continue;
                                                        default:
                                                            if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                                                o = 0;
                                                                continue;
                                                            }
                                                            if (3 === s[0] && (!i || s[1] > i[0] && s[1] < i[3])) {
                                                                o.label = s[1];
                                                                break;
                                                            }
                                                            if (6 === s[0] && o.label < i[1]) {
                                                                o.label = i[1], i = s;
                                                                break;
                                                            }
                                                            if (i && o.label < i[2]) {
                                                                o.label = i[2], o.ops.push(s);
                                                                break;
                                                            }
                                                            i[2] && o.ops.pop(), o.trys.pop();
                                                            continue;
                                                        }
                                                        s = t.call(e, o);
                                                    } catch (e) {
                                                        s = [
                                                            6,
                                                            e
                                                        ], n = 0;
                                                    } finally {
                                                        r = i = 0;
                                                    }
                                                if (5 & s[0])
                                                    throw s[1];
                                                return {
                                                    value: s[0] ? s[1] : void 0,
                                                    done: !0
                                                };
                                            }([
                                                s,
                                                c
                                            ]);
                                        };
                                    }
                                }(this, function (i) {
                                    switch (i.label) {
                                    case 0:
                                        return [
                                            4,
                                            this.coreValidate(e, t, r)
                                        ];
                                    case 1:
                                        return (n = i.sent()).length ? [
                                            2,
                                            Promise.reject(n)
                                        ] : [2];
                                    }
                                });
                            }, new ((a = void 0) || (a = Promise))(function (e, t) {
                                function r(e) {
                                    try {
                                        c(o.next(e));
                                    } catch (e) {
                                        t(e);
                                    }
                                }
                                function s(e) {
                                    try {
                                        c(o.throw(e));
                                    } catch (e) {
                                        t(e);
                                    }
                                }
                                function c(t) {
                                    var n;
                                    t.done ? e(t.value) : (n = t.value, n instanceof a ? n : new a(function (e) {
                                        e(n);
                                    })).then(r, s);
                                }
                                c((o = o.apply(n, i || [])).next());
                            });
                            var n, i, a, o;
                        }, e.prototype.validateSync = function (e, t, r) {
                            var n = 'string' == typeof e ? t : e, i = 'string' == typeof e ? e : void 0, a = new g(this, 'string' == typeof e ? r : t);
                            a.ignoreAsyncValidations = !0;
                            var o = [];
                            return a.execute(n, i, o), a.stripEmptyErrors(o);
                        }, e.prototype.coreValidate = function (e, t, r) {
                            var n = 'string' == typeof e ? t : e, i = 'string' == typeof e ? e : void 0, a = new g(this, 'string' == typeof e ? r : t), o = [];
                            return a.execute(n, i, o), Promise.all(a.awaitingPromises).then(function () {
                                return a.stripEmptyErrors(o);
                            });
                        }, e;
                    }(), b = new (function () {
                        function e() {
                            this.instances = [];
                        }
                        return e.prototype.get = function (e) {
                            var t = this.instances.find(function (t) {
                                return t.type === e;
                            });
                            return t || (t = {
                                type: e,
                                object: new e()
                            }, this.instances.push(t)), t.object;
                        }, e;
                    }())();
                function S(e, t) {
                    f = e, m = t;
                }
                function v(e) {
                    if (f)
                        try {
                            var t = f.get(e);
                            if (t)
                                return t;
                            if (!m || !m.fallback)
                                return t;
                        } catch (e) {
                            if (!m || !m.fallbackOnErrors)
                                throw e;
                        }
                    return b.get(e);
                }
                function C(e) {
                    return function (t, r) {
                        var i = {
                            type: l.WHITELIST,
                            target: t.constructor,
                            propertyName: r,
                            validationOptions: e
                        };
                        c().addValidationMetadata(new n(i));
                    };
                }
                var A = function () {
                    function e(e, t, r) {
                        void 0 === r && (r = !1), this.target = e, this.name = t, this.async = r;
                    }
                    return Object.defineProperty(e.prototype, 'instance', {
                        get: function () {
                            return v(this.target);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e;
                }();
                function _(e) {
                    var t;
                    if (e.validator instanceof Function) {
                        if (t = e.validator, v(s).getTargetValidatorConstraints(e.validator).length > 1)
                            throw 'More than one implementation of ValidatorConstraintInterface found for validator on: '.concat(e.target.name, ':').concat(e.propertyName);
                    } else {
                        var r = e.validator;
                        t = function () {
                            function e() {
                            }
                            return e.prototype.validate = function (e, t) {
                                return r.validate(e, t);
                            }, e.prototype.defaultMessage = function (e) {
                                return r.defaultMessage ? r.defaultMessage(e) : '';
                            }, e;
                        }(), c().addConstraintMetadata(new A(t, e.name, e.async));
                    }
                    var i = {
                        type: e.name && l.isValid(e.name) ? e.name : l.CUSTOM_VALIDATION,
                        name: e.name,
                        target: e.target,
                        propertyName: e.propertyName,
                        validationOptions: e.options,
                        constraintCls: t,
                        constraints: e.constraints
                    };
                    c().addValidationMetadata(new n(i));
                }
                function E(e, t) {
                    return function (r) {
                        var n = t && t.each ? 'each value in ' : '';
                        return e(n, r);
                    };
                }
                function N(e, t) {
                    return function (r, n) {
                        _({
                            name: e.name,
                            target: r.constructor,
                            propertyName: n,
                            options: t,
                            constraints: e.constraints,
                            validator: e.validator
                        });
                    };
                }
                var I = l.IS_DEFINED;
                function T(e) {
                    return null != e;
                }
                function D(e) {
                    return N({
                        name: I,
                        validator: {
                            validate: function (e) {
                                return T(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property should not be null or undefined';
                            }, e)
                        }
                    }, e);
                }
                function O(e) {
                    return function (t, r) {
                        var i = {
                            type: l.CONDITIONAL_VALIDATION,
                            target: t.constructor,
                            propertyName: r,
                            constraints: [function (e, t) {
                                    return null !== e[r] && void 0 !== e[r];
                                }],
                            validationOptions: e
                        };
                        c().addValidationMetadata(new n(i));
                    };
                }
                function R(e) {
                    return function (t) {
                        var r = e && e.async, n = e && e.name ? e.name : '';
                        n || (n = t.name) || (n = n.replace(/\.?([A-Z]+)/g, function (e, t) {
                            return '_' + t.toLowerCase();
                        }).replace(/^_/, ''));
                        var i = new A(t, n, r);
                        c().addConstraintMetadata(i);
                    };
                }
                function M(e, t, r) {
                    return function (i, a) {
                        var o = {
                            type: l.CUSTOM_VALIDATION,
                            target: i.constructor,
                            propertyName: a,
                            constraintCls: e,
                            constraints: Array.isArray(t) ? t : void 0,
                            validationOptions: Array.isArray(t) ? r : t
                        };
                        c().addValidationMetadata(new n(o));
                    };
                }
                function F(e, t) {
                    return function (r, i) {
                        var a = {
                            type: l.CONDITIONAL_VALIDATION,
                            target: r.constructor,
                            propertyName: i,
                            constraints: [e],
                            validationOptions: t
                        };
                        c().addValidationMetadata(new n(a));
                    };
                }
                var P = function () {
                    return (P = Object.assign || function (e) {
                        for (var t, r = 1, n = arguments.length; r < n; r++)
                            for (var i in t = arguments[r])
                                Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                        return e;
                    }).apply(this, arguments);
                };
                function x(e) {
                    var t = P({}, e), r = t.each ? 'each value in ' : '';
                    return t.message = t.message || r + 'nested property $property must be either object or array', function (e, r) {
                        var i = {
                            type: l.NESTED_VALIDATION,
                            target: e.constructor,
                            propertyName: r,
                            validationOptions: t
                        };
                        c().addValidationMetadata(new n(i));
                    };
                }
                function w(e) {
                    return function (t, r) {
                        var i = {
                            type: l.PROMISE_VALIDATION,
                            target: t.constructor,
                            propertyName: r,
                            validationOptions: e
                        };
                        c().addValidationMetadata(new n(i));
                    };
                }
                var B = r(478), k = r.n(B), L = 'isLatLong';
                function $(e) {
                    return 'string' == typeof e && k()(e);
                }
                function j(e) {
                    return N({
                        name: L,
                        validator: {
                            validate: function (e, t) {
                                return $(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a latitude,longitude string';
                            }, e)
                        }
                    }, e);
                }
                var G = 'isLatitude';
                function V(e) {
                    return ('number' == typeof e || 'string' == typeof e) && $(''.concat(e, ',0'));
                }
                function U(e) {
                    return N({
                        name: G,
                        validator: {
                            validate: function (e, t) {
                                return V(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a latitude string or number';
                            }, e)
                        }
                    }, e);
                }
                var H = 'isLongitude';
                function W(e) {
                    return ('number' == typeof e || 'string' == typeof e) && $('0,'.concat(e));
                }
                function K(e) {
                    return N({
                        name: H,
                        validator: {
                            validate: function (e, t) {
                                return W(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a longitude string or number';
                            }, e)
                        }
                    }, e);
                }
                var z = 'equals';
                function X(e, t) {
                    return e === t;
                }
                function Y(e, t) {
                    return N({
                        name: z,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return X(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be equal to $constraint1';
                            }, t)
                        }
                    }, t);
                }
                var q = 'notEquals';
                function Z(e, t) {
                    return e !== t;
                }
                function J(e, t) {
                    return N({
                        name: q,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Z(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property should not be equal to $constraint1';
                            }, t)
                        }
                    }, t);
                }
                var Q = 'isEmpty';
                function ee(e) {
                    return '' === e || null == e;
                }
                function te(e) {
                    return N({
                        name: Q,
                        validator: {
                            validate: function (e, t) {
                                return ee(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be empty';
                            }, e)
                        }
                    }, e);
                }
                var re = 'isNotEmpty';
                function ne(e) {
                    return '' !== e && null != e;
                }
                function ie(e) {
                    return N({
                        name: re,
                        validator: {
                            validate: function (e, t) {
                                return ne(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property should not be empty';
                            }, e)
                        }
                    }, e);
                }
                var ae = 'isIn';
                function oe(e, t) {
                    return !Array.isArray(t) || t.some(function (t) {
                        return t === e;
                    });
                }
                function se(e, t) {
                    return N({
                        name: ae,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return oe(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be one of the following values: $constraint1';
                            }, t)
                        }
                    }, t);
                }
                var ce = 'isNotIn';
                function ue(e, t) {
                    return !Array.isArray(t) || !t.some(function (t) {
                        return t === e;
                    });
                }
                function le(e, t) {
                    return N({
                        name: ce,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return ue(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property should not be one of the following values: $constraint1';
                            }, t)
                        }
                    }, t);
                }
                var de = r(8335), pe = r.n(de), fe = 'isDivisibleBy';
                function me(e, t) {
                    return 'number' == typeof e && 'number' == typeof t && pe()(String(e), t);
                }
                function he(e, t) {
                    return N({
                        name: fe,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return me(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be divisible by $constraint1';
                            }, t)
                        }
                    }, t);
                }
                var ge = 'isPositive';
                function ye(e) {
                    return 'number' == typeof e && e > 0;
                }
                function be(e) {
                    return N({
                        name: ge,
                        validator: {
                            validate: function (e, t) {
                                return ye(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a positive number';
                            }, e)
                        }
                    }, e);
                }
                var Se = 'isNegative';
                function ve(e) {
                    return 'number' == typeof e && e < 0;
                }
                function Ce(e) {
                    return N({
                        name: Se,
                        validator: {
                            validate: function (e, t) {
                                return ve(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a negative number';
                            }, e)
                        }
                    }, e);
                }
                var Ae = 'max';
                function _e(e, t) {
                    return 'number' == typeof e && 'number' == typeof t && e <= t;
                }
                function Ee(e, t) {
                    return N({
                        name: Ae,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return _e(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must not be greater than $constraint1';
                            }, t)
                        }
                    }, t);
                }
                var Ne = 'min';
                function Ie(e, t) {
                    return 'number' == typeof e && 'number' == typeof t && e >= t;
                }
                function Te(e, t) {
                    return N({
                        name: Ne,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Ie(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must not be less than $constraint1';
                            }, t)
                        }
                    }, t);
                }
                var De = 'minDate';
                function Oe(e, t) {
                    return e instanceof Date && e.getTime() >= (t instanceof Date ? t : t()).getTime();
                }
                function Re(e, t) {
                    return N({
                        name: De,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Oe(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return 'minimal allowed date for ' + e + '$property is $constraint1';
                            }, t)
                        }
                    }, t);
                }
                var Me = 'maxDate';
                function Fe(e, t) {
                    return e instanceof Date && e.getTime() <= (t instanceof Date ? t : t()).getTime();
                }
                function Pe(e, t) {
                    return N({
                        name: Me,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Fe(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return 'maximal allowed date for ' + e + '$property is $constraint1';
                            }, t)
                        }
                    }, t);
                }
                var xe = r(9466), we = r.n(xe), Be = 'contains';
                function ke(e, t) {
                    return 'string' == typeof e && we()(e, t);
                }
                function Le(e, t) {
                    return N({
                        name: Be,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return ke(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain a $constraint1 string';
                            }, t)
                        }
                    }, t);
                }
                var $e = 'notContains';
                function je(e, t) {
                    return 'string' == typeof e && !we()(e, t);
                }
                function Ge(e, t) {
                    return N({
                        name: $e,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return je(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property should not contain a $constraint1 string';
                            }, t)
                        }
                    }, t);
                }
                var Ve = r(9234), Ue = 'isAlpha';
                function He(e, t) {
                    return 'string' == typeof e && (0, Ve.default)(e, t);
                }
                function We(e, t) {
                    return N({
                        name: Ue,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return He(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain only letters (a-zA-Z)';
                            }, t)
                        }
                    }, t);
                }
                var Ke = r(4583), ze = 'isAlphanumeric';
                function Xe(e, t) {
                    return 'string' == typeof e && (0, Ke.default)(e, t);
                }
                function Ye(e, t) {
                    return N({
                        name: ze,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Xe(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain only letters and numbers';
                            }, t)
                        }
                    }, t);
                }
                var qe = r(5218), Ze = r.n(qe), Je = 'isDecimal';
                function Qe(e, t) {
                    return 'string' == typeof e && Ze()(e, t);
                }
                function et(e, t) {
                    return N({
                        name: Je,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Qe(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property is not a valid decimal number.';
                            }, t)
                        }
                    }, t);
                }
                var tt = r(4094), rt = r.n(tt), nt = 'isAscii';
                function it(e) {
                    return 'string' == typeof e && rt()(e);
                }
                function at(e) {
                    return N({
                        name: nt,
                        validator: {
                            validate: function (e, t) {
                                return it(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain only ASCII characters';
                            }, e)
                        }
                    }, e);
                }
                var ot = r(2689), st = r.n(ot), ct = 'isBase64';
                function ut(e) {
                    return 'string' == typeof e && st()(e);
                }
                function lt(e) {
                    return N({
                        name: ct,
                        validator: {
                            validate: function (e, t) {
                                return ut(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be base64 encoded';
                            }, e)
                        }
                    }, e);
                }
                var dt = r(3235), pt = r.n(dt), ft = 'isByteLength';
                function mt(e, t, r) {
                    return 'string' == typeof e && pt()(e, {
                        min: t,
                        max: r
                    });
                }
                function ht(e, t, r) {
                    return N({
                        name: ft,
                        constraints: [
                            e,
                            t
                        ],
                        validator: {
                            validate: function (e, t) {
                                return mt(e, null == t ? void 0 : t.constraints[0], null == t ? void 0 : t.constraints[1]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property\'s byte length must fall into ($constraint1, $constraint2) range';
                            }, r)
                        }
                    }, r);
                }
                var gt = r(682), yt = r.n(gt), bt = 'isCreditCard';
                function St(e) {
                    return 'string' == typeof e && yt()(e);
                }
                function vt(e) {
                    return N({
                        name: bt,
                        validator: {
                            validate: function (e, t) {
                                return St(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a credit card';
                            }, e)
                        }
                    }, e);
                }
                var Ct = r(94), At = r.n(Ct), _t = 'isCurrency';
                function Et(e, t) {
                    return 'string' == typeof e && At()(e, t);
                }
                function Nt(e, t) {
                    return N({
                        name: _t,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Et(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a currency';
                            }, t)
                        }
                    }, t);
                }
                var It = r(3868), Tt = r.n(It), Dt = 'isEmail';
                function Ot(e, t) {
                    return 'string' == typeof e && Tt()(e, t);
                }
                function Rt(e, t) {
                    return N({
                        name: Dt,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Ot(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an email';
                            }, t)
                        }
                    }, t);
                }
                var Mt = r(221), Ft = r.n(Mt), Pt = 'isFqdn';
                function xt(e, t) {
                    return 'string' == typeof e && Ft()(e, t);
                }
                function wt(e, t) {
                    return N({
                        name: Pt,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return xt(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a valid domain name';
                            }, t)
                        }
                    }, t);
                }
                var Bt = r(7146), kt = 'isFullWidth';
                function Lt(e) {
                    return 'string' == typeof e && (0, Bt.default)(e);
                }
                function $t(e) {
                    return N({
                        name: kt,
                        validator: {
                            validate: function (e, t) {
                                return Lt(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain a full-width characters';
                            }, e)
                        }
                    }, e);
                }
                var jt = r(2941), Gt = 'isHalfWidth';
                function Vt(e) {
                    return 'string' == typeof e && (0, jt.default)(e);
                }
                function Ut(e) {
                    return N({
                        name: Gt,
                        validator: {
                            validate: function (e, t) {
                                return Vt(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain a half-width characters';
                            }, e)
                        }
                    }, e);
                }
                var Ht = r(9019), Wt = r.n(Ht), Kt = 'isVariableWidth';
                function zt(e) {
                    return 'string' == typeof e && Wt()(e);
                }
                function Xt(e) {
                    return N({
                        name: Kt,
                        validator: {
                            validate: function (e, t) {
                                return zt(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain a full-width and half-width characters';
                            }, e)
                        }
                    }, e);
                }
                var Yt = r(6298), qt = r.n(Yt), Zt = 'isHexColor';
                function Jt(e) {
                    return 'string' == typeof e && qt()(e);
                }
                function Qt(e) {
                    return N({
                        name: Zt,
                        validator: {
                            validate: function (e, t) {
                                return Jt(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a hexadecimal color';
                            }, e)
                        }
                    }, e);
                }
                var er = r(7117), tr = r.n(er), rr = 'isHexadecimal';
                function nr(e) {
                    return 'string' == typeof e && tr()(e);
                }
                function ir(e) {
                    return N({
                        name: rr,
                        validator: {
                            validate: function (e, t) {
                                return nr(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a hexadecimal number';
                            }, e)
                        }
                    }, e);
                }
                function ar(e) {
                    return !!e && ('each' in e || 'message' in e || 'groups' in e || 'always' in e || 'context' in e);
                }
                var or = r(8999), sr = r.n(or), cr = 'isMacAddress';
                function ur(e, t) {
                    return 'string' == typeof e && sr()(e, t);
                }
                function lr(e, t) {
                    var r = ar(e) ? void 0 : e, n = ar(e) ? e : t;
                    return N({
                        name: cr,
                        constraints: [r],
                        validator: {
                            validate: function (e, t) {
                                return ur(e, r);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a MAC Address';
                            }, n)
                        }
                    }, n);
                }
                var dr = r(1028), pr = r.n(dr), fr = 'isIp';
                function mr(e, t) {
                    var r = t ? ''.concat(t) : void 0;
                    return 'string' == typeof e && pr()(e, r);
                }
                function hr(e, t) {
                    return N({
                        name: fr,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return mr(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an ip address';
                            }, t)
                        }
                    }, t);
                }
                var gr = r(4595), yr = r.n(gr), br = 'isPort';
                function Sr(e) {
                    return 'string' == typeof e && yr()(e);
                }
                function vr(e) {
                    return N({
                        name: br,
                        validator: {
                            validate: function (e, t) {
                                return Sr(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a port';
                            }, e)
                        }
                    }, e);
                }
                var Cr = r(7612), Ar = r.n(Cr), _r = 'isIsbn';
                function Er(e, t) {
                    var r = t ? ''.concat(t) : void 0;
                    return 'string' == typeof e && Ar()(e, r);
                }
                function Nr(e, t) {
                    return N({
                        name: _r,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Er(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an ISBN';
                            }, t)
                        }
                    }, t);
                }
                var Ir = r(7148), Tr = r.n(Ir), Dr = 'isIsin';
                function Or(e) {
                    return 'string' == typeof e && Tr()(e);
                }
                function Rr(e) {
                    return N({
                        name: Dr,
                        validator: {
                            validate: function (e, t) {
                                return Or(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an ISIN (stock/security identifier)';
                            }, e)
                        }
                    }, e);
                }
                var Mr = r(5061), Fr = r.n(Mr), Pr = 'isIso8601';
                function xr(e, t) {
                    return 'string' == typeof e && Fr()(e, t);
                }
                function wr(e, t) {
                    return N({
                        name: Pr,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return xr(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a valid ISO 8601 date string';
                            }, t)
                        }
                    }, t);
                }
                var Br = r(1008), kr = r.n(Br), Lr = 'isJson';
                function $r(e) {
                    return 'string' == typeof e && kr()(e);
                }
                function jr(e) {
                    return N({
                        name: Lr,
                        validator: {
                            validate: function (e, t) {
                                return $r(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a json string';
                            }, e)
                        }
                    }, e);
                }
                var Gr = r(4979), Vr = r.n(Gr), Ur = 'isJwt';
                function Hr(e) {
                    return 'string' == typeof e && Vr()(e);
                }
                function Wr(e) {
                    return N({
                        name: Ur,
                        validator: {
                            validate: function (e, t) {
                                return Hr(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a jwt string';
                            }, e)
                        }
                    }, e);
                }
                var Kr = r(3928), zr = r.n(Kr), Xr = 'isLowercase';
                function Yr(e) {
                    return 'string' == typeof e && zr()(e);
                }
                function qr(e) {
                    return N({
                        name: Xr,
                        validator: {
                            validate: function (e, t) {
                                return Yr(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a lowercase string';
                            }, e)
                        }
                    }, e);
                }
                var Zr = r(8355), Jr = 'isMobilePhone';
                function Qr(e, t, r) {
                    return 'string' == typeof e && (0, Zr.default)(e, t, r);
                }
                function en(e, t, r) {
                    return N({
                        name: Jr,
                        constraints: [
                            e,
                            t
                        ],
                        validator: {
                            validate: function (e, t) {
                                return Qr(e, null == t ? void 0 : t.constraints[0], null == t ? void 0 : t.constraints[1]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a phone number';
                            }, r)
                        }
                    }, r);
                }
                var tn = r(1727), rn = 'isISO31661Alpha2';
                function nn(e) {
                    return 'string' == typeof e && (0, tn.default)(e);
                }
                function an(e) {
                    return N({
                        name: rn,
                        validator: {
                            validate: function (e, t) {
                                return nn(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a valid ISO31661 Alpha2 code';
                            }, e)
                        }
                    }, e);
                }
                var on = r(6776), sn = r.n(on), cn = 'isISO31661Alpha3';
                function un(e) {
                    return 'string' == typeof e && sn()(e);
                }
                function ln(e) {
                    return N({
                        name: cn,
                        validator: {
                            validate: function (e, t) {
                                return un(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a valid ISO31661 Alpha3 code';
                            }, e)
                        }
                    }, e);
                }
                var dn = r(9131), pn = r.n(dn), fn = 'isMongoId';
                function mn(e) {
                    return 'string' == typeof e && pn()(e);
                }
                function hn(e) {
                    return N({
                        name: fn,
                        validator: {
                            validate: function (e, t) {
                                return mn(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a mongodb id';
                            }, e)
                        }
                    }, e);
                }
                var gn = r(3590), yn = r.n(gn), bn = 'isMultibyte';
                function Sn(e) {
                    return 'string' == typeof e && yn()(e);
                }
                function vn(e) {
                    return N({
                        name: bn,
                        validator: {
                            validate: function (e, t) {
                                return Sn(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain one or more multibyte chars';
                            }, e)
                        }
                    }, e);
                }
                var Cn = r(2828), An = r.n(Cn), _n = 'isSurrogatePair';
                function En(e) {
                    return 'string' == typeof e && An()(e);
                }
                function Nn(e) {
                    return N({
                        name: _n,
                        validator: {
                            validate: function (e, t) {
                                return En(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain any surrogate pairs chars';
                            }, e)
                        }
                    }, e);
                }
                var In = r(2492), Tn = r.n(In), Dn = 'isUrl';
                function On(e, t) {
                    return 'string' == typeof e && Tn()(e, t);
                }
                function Rn(e, t) {
                    return N({
                        name: Dn,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return On(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a URL address';
                            }, t)
                        }
                    }, t);
                }
                var Mn = r(7278), Fn = r.n(Mn), Pn = 'isUuid';
                function xn(e, t) {
                    return 'string' == typeof e && Fn()(e, t);
                }
                function wn(e, t) {
                    return N({
                        name: Pn,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return xn(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a UUID';
                            }, t)
                        }
                    }, t);
                }
                var Bn = 'IsFirebasePushId';
                function kn(e) {
                    return 'string' == typeof e && 20 === e.length && /^[a-zA-Z0-9_-]*$/.test(e);
                }
                function Ln(e) {
                    return N({
                        name: Bn,
                        validator: {
                            validate: function (e, t) {
                                return kn(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a Firebase Push Id';
                            }, e)
                        }
                    }, e);
                }
                var $n = r(7245), jn = r.n($n), Gn = 'isUppercase';
                function Vn(e) {
                    return 'string' == typeof e && jn()(e);
                }
                function Un(e) {
                    return N({
                        name: Gn,
                        validator: {
                            validate: function (e, t) {
                                return Vn(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be uppercase';
                            }, e)
                        }
                    }, e);
                }
                var Hn = r(661), Wn = r.n(Hn), Kn = 'isLength';
                function zn(e, t, r) {
                    return 'string' == typeof e && Wn()(e, {
                        min: t,
                        max: r
                    });
                }
                function Xn(e, t, r) {
                    return N({
                        name: Kn,
                        constraints: [
                            e,
                            t
                        ],
                        validator: {
                            validate: function (e, t) {
                                return zn(e, null == t ? void 0 : t.constraints[0], null == t ? void 0 : t.constraints[1]);
                            },
                            defaultMessage: E(function (e, t) {
                                var r = null !== (null == t ? void 0 : t.constraints[0]) && void 0 !== (null == t ? void 0 : t.constraints[0]), n = null !== (null == t ? void 0 : t.constraints[1]) && void 0 !== (null == t ? void 0 : t.constraints[1]);
                                return r && (!t.value || t.value.length < (null == t ? void 0 : t.constraints[0])) ? e + '$property must be longer than or equal to $constraint1 characters' : n && t.value.length > (null == t ? void 0 : t.constraints[1]) ? e + '$property must be shorter than or equal to $constraint2 characters' : e + '$property must be longer than or equal to $constraint1 and shorter than or equal to $constraint2 characters';
                            }, r)
                        }
                    }, r);
                }
                var Yn = 'maxLength';
                function qn(e, t) {
                    return 'string' == typeof e && Wn()(e, {
                        min: 0,
                        max: t
                    });
                }
                function Zn(e, t) {
                    return N({
                        name: Yn,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return qn(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be shorter than or equal to $constraint1 characters';
                            }, t)
                        }
                    }, t);
                }
                var Jn = 'minLength';
                function Qn(e, t) {
                    return 'string' == typeof e && Wn()(e, { min: t });
                }
                function ei(e, t) {
                    return N({
                        name: Jn,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Qn(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be longer than or equal to $constraint1 characters';
                            }, t)
                        }
                    }, t);
                }
                var ti = r(5090), ri = r.n(ti), ni = 'matches';
                function ii(e, t, r) {
                    return 'string' == typeof e && ri()(e, t, r);
                }
                function ai(e, t, r) {
                    var n;
                    return t && t instanceof Object && !r ? r = t : n = t, N({
                        name: ni,
                        constraints: [
                            e,
                            n
                        ],
                        validator: {
                            validate: function (e, t) {
                                return ii(e, null == t ? void 0 : t.constraints[0], null == t ? void 0 : t.constraints[1]);
                            },
                            defaultMessage: E(function (e, t) {
                                return e + '$property must match $constraint1 regular expression';
                            }, r)
                        }
                    }, r);
                }
                const oi = {
                    version: 4,
                    country_calling_codes: {
                        1: [
                            'US',
                            'AG',
                            'AI',
                            'AS',
                            'BB',
                            'BM',
                            'BS',
                            'CA',
                            'DM',
                            'DO',
                            'GD',
                            'GU',
                            'JM',
                            'KN',
                            'KY',
                            'LC',
                            'MP',
                            'MS',
                            'PR',
                            'SX',
                            'TC',
                            'TT',
                            'VC',
                            'VG',
                            'VI'
                        ],
                        7: [
                            'RU',
                            'KZ'
                        ],
                        20: ['EG'],
                        27: ['ZA'],
                        30: ['GR'],
                        31: ['NL'],
                        32: ['BE'],
                        33: ['FR'],
                        34: ['ES'],
                        36: ['HU'],
                        39: [
                            'IT',
                            'VA'
                        ],
                        40: ['RO'],
                        41: ['CH'],
                        43: ['AT'],
                        44: [
                            'GB',
                            'GG',
                            'IM',
                            'JE'
                        ],
                        45: ['DK'],
                        46: ['SE'],
                        47: [
                            'NO',
                            'SJ'
                        ],
                        48: ['PL'],
                        49: ['DE'],
                        51: ['PE'],
                        52: ['MX'],
                        53: ['CU'],
                        54: ['AR'],
                        55: ['BR'],
                        56: ['CL'],
                        57: ['CO'],
                        58: ['VE'],
                        60: ['MY'],
                        61: [
                            'AU',
                            'CC',
                            'CX'
                        ],
                        62: ['ID'],
                        63: ['PH'],
                        64: ['NZ'],
                        65: ['SG'],
                        66: ['TH'],
                        81: ['JP'],
                        82: ['KR'],
                        84: ['VN'],
                        86: ['CN'],
                        90: ['TR'],
                        91: ['IN'],
                        92: ['PK'],
                        93: ['AF'],
                        94: ['LK'],
                        95: ['MM'],
                        98: ['IR'],
                        211: ['SS'],
                        212: [
                            'MA',
                            'EH'
                        ],
                        213: ['DZ'],
                        216: ['TN'],
                        218: ['LY'],
                        220: ['GM'],
                        221: ['SN'],
                        222: ['MR'],
                        223: ['ML'],
                        224: ['GN'],
                        225: ['CI'],
                        226: ['BF'],
                        227: ['NE'],
                        228: ['TG'],
                        229: ['BJ'],
                        230: ['MU'],
                        231: ['LR'],
                        232: ['SL'],
                        233: ['GH'],
                        234: ['NG'],
                        235: ['TD'],
                        236: ['CF'],
                        237: ['CM'],
                        238: ['CV'],
                        239: ['ST'],
                        240: ['GQ'],
                        241: ['GA'],
                        242: ['CG'],
                        243: ['CD'],
                        244: ['AO'],
                        245: ['GW'],
                        246: ['IO'],
                        247: ['AC'],
                        248: ['SC'],
                        249: ['SD'],
                        250: ['RW'],
                        251: ['ET'],
                        252: ['SO'],
                        253: ['DJ'],
                        254: ['KE'],
                        255: ['TZ'],
                        256: ['UG'],
                        257: ['BI'],
                        258: ['MZ'],
                        260: ['ZM'],
                        261: ['MG'],
                        262: [
                            'RE',
                            'YT'
                        ],
                        263: ['ZW'],
                        264: ['NA'],
                        265: ['MW'],
                        266: ['LS'],
                        267: ['BW'],
                        268: ['SZ'],
                        269: ['KM'],
                        290: [
                            'SH',
                            'TA'
                        ],
                        291: ['ER'],
                        297: ['AW'],
                        298: ['FO'],
                        299: ['GL'],
                        350: ['GI'],
                        351: ['PT'],
                        352: ['LU'],
                        353: ['IE'],
                        354: ['IS'],
                        355: ['AL'],
                        356: ['MT'],
                        357: ['CY'],
                        358: [
                            'FI',
                            'AX'
                        ],
                        359: ['BG'],
                        370: ['LT'],
                        371: ['LV'],
                        372: ['EE'],
                        373: ['MD'],
                        374: ['AM'],
                        375: ['BY'],
                        376: ['AD'],
                        377: ['MC'],
                        378: ['SM'],
                        380: ['UA'],
                        381: ['RS'],
                        382: ['ME'],
                        383: ['XK'],
                        385: ['HR'],
                        386: ['SI'],
                        387: ['BA'],
                        389: ['MK'],
                        420: ['CZ'],
                        421: ['SK'],
                        423: ['LI'],
                        500: ['FK'],
                        501: ['BZ'],
                        502: ['GT'],
                        503: ['SV'],
                        504: ['HN'],
                        505: ['NI'],
                        506: ['CR'],
                        507: ['PA'],
                        508: ['PM'],
                        509: ['HT'],
                        590: [
                            'GP',
                            'BL',
                            'MF'
                        ],
                        591: ['BO'],
                        592: ['GY'],
                        593: ['EC'],
                        594: ['GF'],
                        595: ['PY'],
                        596: ['MQ'],
                        597: ['SR'],
                        598: ['UY'],
                        599: [
                            'CW',
                            'BQ'
                        ],
                        670: ['TL'],
                        672: ['NF'],
                        673: ['BN'],
                        674: ['NR'],
                        675: ['PG'],
                        676: ['TO'],
                        677: ['SB'],
                        678: ['VU'],
                        679: ['FJ'],
                        680: ['PW'],
                        681: ['WF'],
                        682: ['CK'],
                        683: ['NU'],
                        685: ['WS'],
                        686: ['KI'],
                        687: ['NC'],
                        688: ['TV'],
                        689: ['PF'],
                        690: ['TK'],
                        691: ['FM'],
                        692: ['MH'],
                        850: ['KP'],
                        852: ['HK'],
                        853: ['MO'],
                        855: ['KH'],
                        856: ['LA'],
                        880: ['BD'],
                        886: ['TW'],
                        960: ['MV'],
                        961: ['LB'],
                        962: ['JO'],
                        963: ['SY'],
                        964: ['IQ'],
                        965: ['KW'],
                        966: ['SA'],
                        967: ['YE'],
                        968: ['OM'],
                        970: ['PS'],
                        971: ['AE'],
                        972: ['IL'],
                        973: ['BH'],
                        974: ['QA'],
                        975: ['BT'],
                        976: ['MN'],
                        977: ['NP'],
                        992: ['TJ'],
                        993: ['TM'],
                        994: ['AZ'],
                        995: ['GE'],
                        996: ['KG'],
                        998: ['UZ']
                    },
                    countries: {
                        AC: [
                            '247',
                            '00',
                            '(?:[01589]\\d|[46])\\d{4}',
                            [
                                5,
                                6
                            ]
                        ],
                        AD: [
                            '376',
                            '00',
                            '(?:1|6\\d)\\d{7}|[135-9]\\d{5}',
                            [
                                6,
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3})',
                                    '$1 $2',
                                    ['[135-9]']
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['1']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['6']
                                ]
                            ]
                        ],
                        AE: [
                            '971',
                            '00',
                            '(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}',
                            [
                                5,
                                6,
                                7,
                                8,
                                9,
                                10,
                                11,
                                12
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{2,9})',
                                    '$1 $2',
                                    ['60|8']
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[236]|[479][2-8]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d)(\\d{5})',
                                    '$1 $2 $3',
                                    ['[479]']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['5'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        AF: [
                            '93',
                            '00',
                            '[2-7]\\d{8}',
                            [9],
                            [[
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[2-7]'],
                                    '0$1'
                                ]],
                            '0'
                        ],
                        AG: [
                            '1',
                            '011',
                            '(?:268|[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([457]\\d{6})$',
                            '268$1',
                            0,
                            '268'
                        ],
                        AI: [
                            '1',
                            '011',
                            '(?:264|[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2457]\\d{6})$',
                            '264$1',
                            0,
                            '264'
                        ],
                        AL: [
                            '355',
                            '00',
                            '(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}',
                            [
                                6,
                                7,
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3,4})',
                                    '$1 $2',
                                    ['80|9'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['4[2-6]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[2358][2-5]|4'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['[23578]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['6'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        AM: [
                            '374',
                            '00',
                            '(?:[1-489]\\d|55|60|77)\\d{6}',
                            [8],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[89]0'],
                                    '0 $1'
                                ],
                                [
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['2|3[12]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{6})',
                                    '$1 $2',
                                    ['1|47'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{6})',
                                    '$1 $2',
                                    ['[3-9]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        AO: [
                            '244',
                            '00',
                            '[29]\\d{8}',
                            [9],
                            [[
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[29]']
                                ]]
                        ],
                        AR: [
                            '54',
                            '00',
                            '(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}',
                            [
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{2})(\\d{4})',
                                    '$1 $2-$3',
                                    [
                                        '2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])',
                                        '2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)',
                                        '2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]',
                                        '2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]'
                                    ],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2-$3',
                                    ['1'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1-$2-$3',
                                    ['[68]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2-$3',
                                    ['[23]'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d)(\\d{4})(\\d{2})(\\d{4})',
                                    '$2 15-$3-$4',
                                    [
                                        '9(?:2[2-469]|3[3-578])',
                                        '9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))',
                                        '9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)',
                                        '9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]',
                                        '9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]'
                                    ],
                                    '0$1',
                                    0,
                                    '$1 $2 $3-$4'
                                ],
                                [
                                    '(\\d)(\\d{2})(\\d{4})(\\d{4})',
                                    '$2 15-$3-$4',
                                    ['91'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3-$4'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{5})',
                                    '$1-$2-$3',
                                    ['8'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{3})(\\d{4})',
                                    '$2 15-$3-$4',
                                    ['9'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3-$4'
                                ]
                            ],
                            '0',
                            0,
                            '0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?',
                            '9$1'
                        ],
                        AS: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|684|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([267]\\d{6})$',
                            '684$1',
                            0,
                            '684'
                        ],
                        AT: [
                            '43',
                            '00',
                            '1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}',
                            [
                                4,
                                5,
                                6,
                                7,
                                8,
                                9,
                                10,
                                11,
                                12,
                                13
                            ],
                            [
                                [
                                    '(\\d)(\\d{3,12})',
                                    '$1 $2',
                                    ['1(?:11|[2-9])'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})',
                                    '$1 $2',
                                    ['517'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3,5})',
                                    '$1 $2',
                                    ['5[079]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3,10})',
                                    '$1 $2',
                                    ['(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3,9})',
                                    '$1 $2',
                                    ['[2-467]|5[2-6]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['5'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4,7})',
                                    '$1 $2 $3',
                                    ['5'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        AU: [
                            '61',
                            '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
                            '1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}',
                            [
                                5,
                                6,
                                7,
                                8,
                                9,
                                10,
                                12
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3,4})',
                                    '$1 $2',
                                    ['16'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2,4})',
                                    '$1 $2 $3',
                                    ['16'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['14|4'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[2378]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['1(?:30|[89])']
                                ]
                            ],
                            '0',
                            0,
                            '0|(183[12])',
                            0,
                            0,
                            0,
                            [
                                [
                                    '(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}',
                                    [9]
                                ],
                                [
                                    '4(?:83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}',
                                    [9]
                                ],
                                [
                                    '180(?:0\\d{3}|2)\\d{3}',
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    '190[0-26]\\d{6}',
                                    [10]
                                ],
                                0,
                                0,
                                0,
                                [
                                    '163\\d{2,6}',
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    '14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}',
                                    [9]
                                ],
                                [
                                    '13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}',
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ]
                            ],
                            '0011'
                        ],
                        AW: [
                            '297',
                            '00',
                            '(?:[25-79]\\d\\d|800)\\d{4}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[25-9]']
                                ]]
                        ],
                        AX: [
                            '358',
                            '00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))',
                            '2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}',
                            [
                                5,
                                6,
                                7,
                                8,
                                9,
                                10,
                                11,
                                12
                            ],
                            0,
                            '0',
                            0,
                            0,
                            0,
                            0,
                            '18',
                            0,
                            '00'
                        ],
                        AZ: [
                            '994',
                            '00',
                            '365\\d{6}|(?:[124579]\\d|60|88)\\d{7}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['90'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    [
                                        '1[28]|2|365|46',
                                        '1[28]|2|365[45]|46',
                                        '1[28]|2|365(?:4|5[02])|46'
                                    ],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[13-9]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        BA: [
                            '387',
                            '00',
                            '6\\d{8}|(?:[35689]\\d|49|70)\\d{6}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['6[1-3]|[7-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2-$3',
                                    ['[3-5]|6[56]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['6'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        BB: [
                            '1',
                            '011',
                            '(?:246|[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-9]\\d{6})$',
                            '246$1',
                            0,
                            '246'
                        ],
                        BD: [
                            '880',
                            '00',
                            '[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}',
                            [
                                6,
                                7,
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{4,6})',
                                    '$1-$2',
                                    ['31[5-8]|[459]1'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3,7})',
                                    '$1-$2',
                                    ['3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3,6})',
                                    '$1-$2',
                                    ['[13-9]|22'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{7,8})',
                                    '$1-$2',
                                    ['2'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        BE: [
                            '32',
                            '00',
                            '4\\d{8}|[1-9]\\d{7}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['(?:80|9)0'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[239]|4[23]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[15-8]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['4'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        BF: [
                            '226',
                            '00',
                            '[025-7]\\d{7}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[025-7]']
                                ]]
                        ],
                        BG: [
                            '359',
                            '00',
                            '00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}',
                            [
                                6,
                                7,
                                8,
                                9,
                                12
                            ],
                            [
                                [
                                    '(\\d)(\\d)(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['2'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['43[1-6]|70[1-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['2'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2,3})',
                                    '$1 $2 $3',
                                    ['[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['(?:70|8)0'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{2})',
                                    '$1 $2 $3',
                                    ['43[1-7]|7'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[48]|9[08]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['9'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        BH: [
                            '973',
                            '00',
                            '[136-9]\\d{7}',
                            [8],
                            [[
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[13679]|8[047]']
                                ]]
                        ],
                        BI: [
                            '257',
                            '00',
                            '(?:[267]\\d|31)\\d{6}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[2367]']
                                ]]
                        ],
                        BJ: [
                            '229',
                            '00',
                            '[24-689]\\d{7}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[24-689]']
                                ]]
                        ],
                        BL: [
                            '590',
                            '00',
                            '(?:590|(?:69|80)\\d|976)\\d{6}',
                            [9],
                            0,
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                ['590(?:2[7-9]|5[12]|87)\\d{4}'],
                                ['69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}'],
                                ['80[0-5]\\d{6}'],
                                0,
                                0,
                                0,
                                0,
                                0,
                                ['976[01]\\d{5}']
                            ]
                        ],
                        BM: [
                            '1',
                            '011',
                            '(?:441|[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-9]\\d{6})$',
                            '441$1',
                            0,
                            '441'
                        ],
                        BN: [
                            '673',
                            '00',
                            '[2-578]\\d{6}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[2-578]']
                                ]]
                        ],
                        BO: [
                            '591',
                            '00(?:1\\d)?',
                            '(?:[2-467]\\d\\d|8001)\\d{5}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d)(\\d{7})',
                                    '$1 $2',
                                    ['[23]|4[46]']
                                ],
                                [
                                    '(\\d{8})',
                                    '$1',
                                    ['[67]']
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{4})',
                                    '$1 $2 $3',
                                    ['8']
                                ]
                            ],
                            '0',
                            0,
                            '0(1\\d)?'
                        ],
                        BQ: [
                            '599',
                            '00',
                            '(?:[34]1|7\\d)\\d{5}',
                            [7],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '[347]'
                        ],
                        BR: [
                            '55',
                            '00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)',
                            '(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}',
                            [
                                8,
                                9,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1-$2',
                                    [
                                        '300|4(?:0[02]|37)',
                                        '4(?:02|37)0|[34]00'
                                    ]
                                ],
                                [
                                    '(\\d{3})(\\d{2,3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['(?:[358]|90)0'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2-$3',
                                    ['(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]'],
                                    '($1)'
                                ],
                                [
                                    '(\\d{2})(\\d{5})(\\d{4})',
                                    '$1 $2-$3',
                                    ['[16][1-9]|[2-57-9]'],
                                    '($1)'
                                ]
                            ],
                            '0',
                            0,
                            '(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?',
                            '$2'
                        ],
                        BS: [
                            '1',
                            '011',
                            '(?:242|[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([3-8]\\d{6})$',
                            '242$1',
                            0,
                            '242'
                        ],
                        BT: [
                            '975',
                            '00',
                            '[17]\\d{7}|[2-8]\\d{6}',
                            [
                                7,
                                8
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[2-68]|7[246]']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['1[67]|7']
                                ]
                            ]
                        ],
                        BW: [
                            '267',
                            '00',
                            '(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}',
                            [
                                7,
                                8,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{5})',
                                    '$1 $2',
                                    ['90']
                                ],
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[24-6]|3[15-79]']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[37]']
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['0']
                                ],
                                [
                                    '(\\d{3})(\\d{4})(\\d{3})',
                                    '$1 $2 $3',
                                    ['8']
                                ]
                            ]
                        ],
                        BY: [
                            '375',
                            '810',
                            '(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}',
                            [
                                6,
                                7,
                                8,
                                9,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3})',
                                    '$1 $2',
                                    ['800'],
                                    '8 $1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2,4})',
                                    '$1 $2 $3',
                                    ['800'],
                                    '8 $1'
                                ],
                                [
                                    '(\\d{4})(\\d{2})(\\d{3})',
                                    '$1 $2-$3',
                                    [
                                        '1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])',
                                        '1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])'
                                    ],
                                    '8 0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2-$3-$4',
                                    ['1(?:[56]|7[467])|2[1-3]'],
                                    '8 0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2-$3-$4',
                                    ['[1-4]'],
                                    '8 0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3,4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[89]'],
                                    '8 $1'
                                ]
                            ],
                            '8',
                            0,
                            '0|80?',
                            0,
                            0,
                            0,
                            0,
                            '8~10'
                        ],
                        BZ: [
                            '501',
                            '00',
                            '(?:0800\\d|[2-8])\\d{6}',
                            [
                                7,
                                11
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1-$2',
                                    ['[2-8]']
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{4})(\\d{3})',
                                    '$1-$2-$3-$4',
                                    ['0']
                                ]
                            ]
                        ],
                        CA: [
                            '1',
                            '011',
                            '(?:[2-8]\\d|90)\\d{8}|3\\d{6}',
                            [
                                7,
                                10
                            ],
                            0,
                            '1',
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                [
                                    '(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}',
                                    [10]
                                ],
                                [
                                    '',
                                    [10]
                                ],
                                [
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    [10]
                                ],
                                [
                                    '900[2-9]\\d{6}',
                                    [10]
                                ],
                                [
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-7]|33|44|66|77|88)|622)[2-9]\\d{6}',
                                    [10]
                                ],
                                0,
                                [
                                    '310\\d{4}',
                                    [7]
                                ],
                                0,
                                [
                                    '600[2-9]\\d{6}',
                                    [10]
                                ]
                            ]
                        ],
                        CC: [
                            '61',
                            '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
                            '1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}',
                            [
                                6,
                                7,
                                8,
                                9,
                                10,
                                12
                            ],
                            0,
                            '0',
                            0,
                            '0|([59]\\d{7})$',
                            '8$1',
                            0,
                            0,
                            [
                                [
                                    '8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}',
                                    [9]
                                ],
                                [
                                    '4(?:83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}',
                                    [9]
                                ],
                                [
                                    '180(?:0\\d{3}|2)\\d{3}',
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    '190[0-26]\\d{6}',
                                    [10]
                                ],
                                0,
                                0,
                                0,
                                0,
                                [
                                    '14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}',
                                    [9]
                                ],
                                [
                                    '13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}',
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ]
                            ],
                            '0011'
                        ],
                        CD: [
                            '243',
                            '00',
                            '[189]\\d{8}|[1-68]\\d{6}',
                            [
                                7,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['88'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{5})',
                                    '$1 $2',
                                    ['[1-6]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[89]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        CF: [
                            '236',
                            '00',
                            '(?:[27]\\d{3}|8776)\\d{4}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[278]']
                                ]]
                        ],
                        CG: [
                            '242',
                            '00',
                            '222\\d{6}|(?:0\\d|80)\\d{7}',
                            [9],
                            [
                                [
                                    '(\\d)(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['8']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[02]']
                                ]
                            ]
                        ],
                        CH: [
                            '41',
                            '00',
                            '8\\d{11}|[2-9]\\d{8}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['8[047]|90'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[2-79]|81'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4 $5',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        CI: [
                            '225',
                            '00',
                            '[02]\\d{9}',
                            [10],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d)(\\d{5})',
                                    '$1 $2 $3 $4',
                                    ['2']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{4})',
                                    '$1 $2 $3 $4',
                                    ['0']
                                ]
                            ]
                        ],
                        CK: [
                            '682',
                            '00',
                            '[2-578]\\d{4}',
                            [5],
                            [[
                                    '(\\d{2})(\\d{3})',
                                    '$1 $2',
                                    ['[2-578]']
                                ]]
                        ],
                        CL: [
                            '56',
                            '(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0',
                            '12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}',
                            [
                                9,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{5})(\\d{4})',
                                    '$1 $2',
                                    [
                                        '219',
                                        '2196'
                                    ],
                                    '($1)'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['44']
                                ],
                                [
                                    '(\\d)(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['2[1-36]'],
                                    '($1)'
                                ],
                                [
                                    '(\\d)(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['9[2-9]']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])'],
                                    '($1)'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['60|8']
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{2})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['60']
                                ]
                            ]
                        ],
                        CM: [
                            '237',
                            '00',
                            '[26]\\d{8}|88\\d{6,7}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['88']
                                ],
                                [
                                    '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4 $5',
                                    ['[26]|88']
                                ]
                            ]
                        ],
                        CN: [
                            '86',
                            '00|1(?:[12]\\d|79)\\d\\d00',
                            '1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}',
                            [
                                7,
                                8,
                                9,
                                10,
                                11,
                                12
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{5,6})',
                                    '$1 $2',
                                    [
                                        '(?:10|2[0-57-9])[19]',
                                        '(?:10|2[0-57-9])(?:10|9[56])',
                                        '10(?:10|9[56])|2[0-57-9](?:100|9[56])'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{5,6})',
                                    '$1 $2',
                                    [
                                        '3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]',
                                        '(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]',
                                        '85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])',
                                        '85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['(?:4|80)0']
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    [
                                        '10|2(?:[02-57-9]|1[1-9])',
                                        '10|2(?:[02-57-9]|1[1-9])',
                                        '10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])'
                                    ],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{7,8})',
                                    '$1 $2',
                                    ['9']
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['80'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[3-578]'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1[3-9]']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3 $4',
                                    ['[12]'],
                                    '0$1',
                                    1
                                ]
                            ],
                            '0',
                            0,
                            '0|(1(?:[12]\\d|79)\\d\\d)',
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        CO: [
                            '57',
                            '00(?:4(?:[14]4|56)|[579])',
                            '(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}',
                            [
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{7})',
                                    '$1 $2',
                                    ['6'],
                                    '($1)'
                                ],
                                [
                                    '(\\d{3})(\\d{7})',
                                    '$1 $2',
                                    ['3[0-357]|91']
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{7})',
                                    '$1-$2-$3',
                                    ['1'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3'
                                ]
                            ],
                            '0',
                            0,
                            '0(4(?:[14]4|56)|[579])?'
                        ],
                        CR: [
                            '506',
                            '00',
                            '(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}',
                            [
                                8,
                                10
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[2-7]|8[3-9]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1-$2-$3',
                                    ['[89]']
                                ]
                            ],
                            0,
                            0,
                            '(19(?:0[0-2468]|1[09]|20|66|77|99))'
                        ],
                        CU: [
                            '53',
                            '119',
                            '[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}',
                            [
                                6,
                                7,
                                8,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{4,6})',
                                    '$1 $2',
                                    ['2[1-4]|[34]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d)(\\d{6,7})',
                                    '$1 $2',
                                    ['7'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d)(\\d{7})',
                                    '$1 $2',
                                    ['5'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{7})',
                                    '$1 $2',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        CV: [
                            '238',
                            '0',
                            '(?:[2-59]\\d\\d|800)\\d{4}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3',
                                    ['[2-589]']
                                ]]
                        ],
                        CW: [
                            '599',
                            '00',
                            '(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}',
                            [
                                7,
                                8
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[3467]']
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['9[4-8]']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            '[69]'
                        ],
                        CX: [
                            '61',
                            '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
                            '1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}',
                            [
                                6,
                                7,
                                8,
                                9,
                                10,
                                12
                            ],
                            0,
                            '0',
                            0,
                            '0|([59]\\d{7})$',
                            '8$1',
                            0,
                            0,
                            [
                                [
                                    '8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}',
                                    [9]
                                ],
                                [
                                    '4(?:83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}',
                                    [9]
                                ],
                                [
                                    '180(?:0\\d{3}|2)\\d{3}',
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    '190[0-26]\\d{6}',
                                    [10]
                                ],
                                0,
                                0,
                                0,
                                0,
                                [
                                    '14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}',
                                    [9]
                                ],
                                [
                                    '13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}',
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ]
                            ],
                            '0011'
                        ],
                        CY: [
                            '357',
                            '00',
                            '(?:[279]\\d|[58]0)\\d{6}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{6})',
                                    '$1 $2',
                                    ['[257-9]']
                                ]]
                        ],
                        CZ: [
                            '420',
                            '00',
                            '(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[2-8]|9[015-7]']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['96']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['9']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['9']
                                ]
                            ]
                        ],
                        DE: [
                            '49',
                            '00',
                            '[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}',
                            [
                                4,
                                5,
                                6,
                                7,
                                8,
                                9,
                                10,
                                11,
                                12,
                                13,
                                14,
                                15
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3,13})',
                                    '$1 $2',
                                    ['3[02]|40|[68]9'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3,12})',
                                    '$1 $2',
                                    [
                                        '2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1',
                                        '2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{2,11})',
                                    '$1 $2',
                                    [
                                        '[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]',
                                        '[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['138'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{5})(\\d{2,10})',
                                    '$1 $2',
                                    ['3'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{5,11})',
                                    '$1 $2',
                                    ['181'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d)(\\d{4,10})',
                                    '$1 $2 $3',
                                    ['1(?:3|80)|9'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{7,8})',
                                    '$1 $2',
                                    ['1[67]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{7,12})',
                                    '$1 $2',
                                    ['8'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{5})(\\d{6})',
                                    '$1 $2',
                                    [
                                        '185',
                                        '1850',
                                        '18500'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['7'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{7})',
                                    '$1 $2',
                                    ['18[68]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{5})(\\d{6})',
                                    '$1 $2',
                                    ['15[0568]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{7})',
                                    '$1 $2',
                                    ['15[1279]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{8})',
                                    '$1 $2',
                                    ['18'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{7,8})',
                                    '$1 $2 $3',
                                    ['1(?:6[023]|7)'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{2})(\\d{7})',
                                    '$1 $2 $3',
                                    ['15[279]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{8})',
                                    '$1 $2 $3',
                                    ['15'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        DJ: [
                            '253',
                            '00',
                            '(?:2\\d|77)\\d{6}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[27]']
                                ]]
                        ],
                        DK: [
                            '45',
                            '00',
                            '[2-9]\\d{7}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[2-9]']
                                ]]
                        ],
                        DM: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|767|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-7]\\d{6})$',
                            '767$1',
                            0,
                            '767'
                        ],
                        DO: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            0,
                            0,
                            0,
                            '8001|8[024]9'
                        ],
                        DZ: [
                            '213',
                            '00',
                            '(?:[1-4]|[5-79]\\d|80)\\d{7}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[1-4]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['9'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[5-8]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        EC: [
                            '593',
                            '00',
                            '1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}',
                            [
                                8,
                                9,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2-$3',
                                    ['[2-7]'],
                                    '(0$1)',
                                    0,
                                    '$1-$2-$3'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['9'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['1']
                                ]
                            ],
                            '0'
                        ],
                        EE: [
                            '372',
                            '00',
                            '8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}',
                            [
                                7,
                                8,
                                10
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    [
                                        '[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88',
                                        '[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88'
                                    ]
                                ],
                                [
                                    '(\\d{4})(\\d{3,4})',
                                    '$1 $2',
                                    [
                                        '[45]|8(?:00|[1-49])',
                                        '[45]|8(?:00[1-9]|[1-49])'
                                    ]
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{4})',
                                    '$1 $2 $3',
                                    ['7']
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['8']
                                ]
                            ]
                        ],
                        EG: [
                            '20',
                            '00',
                            '[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}',
                            [
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d)(\\d{7,8})',
                                    '$1 $2',
                                    ['[23]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{6,7})',
                                    '$1 $2',
                                    ['1[35]|[4-6]|8[2468]|9[235-7]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[189]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        EH: [
                            '212',
                            '00',
                            '[5-8]\\d{8}',
                            [9],
                            0,
                            '0',
                            0,
                            0,
                            0,
                            0,
                            '528[89]'
                        ],
                        ER: [
                            '291',
                            '00',
                            '[178]\\d{6}',
                            [7],
                            [[
                                    '(\\d)(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[178]'],
                                    '0$1'
                                ]],
                            '0'
                        ],
                        ES: [
                            '34',
                            '00',
                            '[5-9]\\d{8}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[89]00']
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[5-9]']
                                ]
                            ]
                        ],
                        ET: [
                            '251',
                            '00',
                            '(?:11|[2-579]\\d)\\d{7}',
                            [9],
                            [[
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[1-579]'],
                                    '0$1'
                                ]],
                            '0'
                        ],
                        FI: [
                            '358',
                            '00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))',
                            '[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}',
                            [
                                5,
                                6,
                                7,
                                8,
                                9,
                                10,
                                11,
                                12
                            ],
                            [
                                [
                                    '(\\d)(\\d{4,9})',
                                    '$1 $2',
                                    ['[2568][1-8]|3(?:0[1-9]|[1-9])|9'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3,7})',
                                    '$1 $2',
                                    ['[12]00|[368]|70[07-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4,8})',
                                    '$1 $2',
                                    ['[1245]|7[135]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{6,10})',
                                    '$1 $2',
                                    ['7'],
                                    '0$1'
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            '1[03-79]|[2-9]',
                            0,
                            '00'
                        ],
                        FJ: [
                            '679',
                            '0(?:0|52)',
                            '45\\d{5}|(?:0800\\d|[235-9])\\d{6}',
                            [
                                7,
                                11
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[235-9]|45']
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['0']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        FK: [
                            '500',
                            '00',
                            '[2-7]\\d{4}',
                            [5]
                        ],
                        FM: [
                            '691',
                            '00',
                            '(?:[39]\\d\\d|820)\\d{4}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[389]']
                                ]]
                        ],
                        FO: [
                            '298',
                            '00',
                            '[2-9]\\d{5}',
                            [6],
                            [[
                                    '(\\d{6})',
                                    '$1',
                                    ['[2-9]']
                                ]],
                            0,
                            0,
                            '(10(?:01|[12]0|88))'
                        ],
                        FR: [
                            '33',
                            '00',
                            '[1-9]\\d{8}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['8'],
                                    '0 $1'
                                ],
                                [
                                    '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4 $5',
                                    ['[1-79]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        GA: [
                            '241',
                            '00',
                            '(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}',
                            [
                                7,
                                8
                            ],
                            [
                                [
                                    '(\\d)(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[2-7]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['0']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['11|[67]'],
                                    '0$1'
                                ]
                            ],
                            0,
                            0,
                            '0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})',
                            '$1'
                        ],
                        GB: [
                            '44',
                            '00',
                            '[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}',
                            [
                                7,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    [
                                        '800',
                                        '8001',
                                        '80011',
                                        '800111',
                                        '8001111'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3',
                                    [
                                        '845',
                                        '8454',
                                        '84546',
                                        '845464'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{6})',
                                    '$1 $2',
                                    ['800'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{5})(\\d{4,5})',
                                    '$1 $2',
                                    [
                                        '1(?:38|5[23]|69|76|94)',
                                        '1(?:(?:38|69)7|5(?:24|39)|768|946)',
                                        '1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{5,6})',
                                    '$1 $2',
                                    ['1(?:[2-69][02-9]|[78])'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    [
                                        '[25]|7(?:0|6[02-9])',
                                        '[25]|7(?:0|6(?:[03-9]|2[356]))'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{6})',
                                    '$1 $2',
                                    ['7'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[1389]'],
                                    '0$1'
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                [
                                    '(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-246-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}',
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    '7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}',
                                    [10]
                                ],
                                ['80[08]\\d{7}|800\\d{6}|8001111'],
                                [
                                    '(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d',
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    '70\\d{8}',
                                    [10]
                                ],
                                0,
                                [
                                    '(?:3[0347]|55)\\d{8}',
                                    [10]
                                ],
                                [
                                    '76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}',
                                    [10]
                                ],
                                [
                                    '56\\d{8}',
                                    [10]
                                ]
                            ],
                            0,
                            ' x'
                        ],
                        GD: [
                            '1',
                            '011',
                            '(?:473|[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-9]\\d{6})$',
                            '473$1',
                            0,
                            '473'
                        ],
                        GE: [
                            '995',
                            '00',
                            '(?:[3-57]\\d\\d|800)\\d{6}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['70'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['32'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[57]']
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[348]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        GF: [
                            '594',
                            '00',
                            '(?:[56]94|80\\d|976)\\d{6}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[569]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        GG: [
                            '44',
                            '00',
                            '(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?',
                            [
                                7,
                                9,
                                10
                            ],
                            0,
                            '0',
                            0,
                            '0|([25-9]\\d{5})$',
                            '1481$1',
                            0,
                            0,
                            [
                                [
                                    '1481[25-9]\\d{5}',
                                    [10]
                                ],
                                [
                                    '7(?:(?:781|839)\\d|911[17])\\d{5}',
                                    [10]
                                ],
                                ['80[08]\\d{7}|800\\d{6}|8001111'],
                                [
                                    '(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d',
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    '70\\d{8}',
                                    [10]
                                ],
                                0,
                                [
                                    '(?:3[0347]|55)\\d{8}',
                                    [10]
                                ],
                                [
                                    '76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}',
                                    [10]
                                ],
                                [
                                    '56\\d{8}',
                                    [10]
                                ]
                            ]
                        ],
                        GH: [
                            '233',
                            '00',
                            '(?:[235]\\d{3}|800)\\d{5}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['8'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[235]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        GI: [
                            '350',
                            '00',
                            '(?:[25]\\d\\d|606)\\d{5}',
                            [8],
                            [[
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['2']
                                ]]
                        ],
                        GL: [
                            '299',
                            '00',
                            '(?:19|[2-689]\\d|70)\\d{4}',
                            [6],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3',
                                    ['19|[2-9]']
                                ]]
                        ],
                        GM: [
                            '220',
                            '00',
                            '[2-9]\\d{6}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[2-9]']
                                ]]
                        ],
                        GN: [
                            '224',
                            '00',
                            '722\\d{6}|(?:3|6\\d)\\d{7}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['3']
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[67]']
                                ]
                            ]
                        ],
                        GP: [
                            '590',
                            '00',
                            '(?:590|(?:69|80)\\d|976)\\d{6}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[569]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                ['590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-389]|7[08]|8[0-689]|9\\d)\\d{4}'],
                                ['69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}'],
                                ['80[0-5]\\d{6}'],
                                0,
                                0,
                                0,
                                0,
                                0,
                                ['976[01]\\d{5}']
                            ]
                        ],
                        GQ: [
                            '240',
                            '00',
                            '222\\d{6}|(?:3\\d|55|[89]0)\\d{7}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[235]']
                                ],
                                [
                                    '(\\d{3})(\\d{6})',
                                    '$1 $2',
                                    ['[89]']
                                ]
                            ]
                        ],
                        GR: [
                            '30',
                            '00',
                            '5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}',
                            [
                                10,
                                11,
                                12
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['21|7']
                                ],
                                [
                                    '(\\d{4})(\\d{6})',
                                    '$1 $2',
                                    ['2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[2689]']
                                ],
                                [
                                    '(\\d{3})(\\d{3,4})(\\d{5})',
                                    '$1 $2 $3',
                                    ['8']
                                ]
                            ]
                        ],
                        GT: [
                            '502',
                            '00',
                            '(?:1\\d{3}|[2-7])\\d{7}',
                            [
                                8,
                                11
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[2-7]']
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1']
                                ]
                            ]
                        ],
                        GU: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|671|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([3-9]\\d{6})$',
                            '671$1',
                            0,
                            '671'
                        ],
                        GW: [
                            '245',
                            '00',
                            '[49]\\d{8}|4\\d{6}',
                            [
                                7,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['40']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[49]']
                                ]
                            ]
                        ],
                        GY: [
                            '592',
                            '001',
                            '9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[2-46-9]']
                                ]]
                        ],
                        HK: [
                            '852',
                            '00(?:30|5[09]|[126-9]?)',
                            '8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}',
                            [
                                5,
                                6,
                                7,
                                8,
                                9,
                                11
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{2,5})',
                                    '$1 $2',
                                    [
                                        '900',
                                        '9003'
                                    ]
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[2-7]|8[1-4]|9(?:0[1-9]|[1-8])']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['8']
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['9']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        HN: [
                            '504',
                            '00',
                            '8\\d{10}|[237-9]\\d{7}',
                            [
                                8,
                                11
                            ],
                            [[
                                    '(\\d{4})(\\d{4})',
                                    '$1-$2',
                                    ['[237-9]']
                                ]]
                        ],
                        HR: [
                            '385',
                            '00',
                            '(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}',
                            [
                                6,
                                7,
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2,3})',
                                    '$1 $2 $3',
                                    ['6[01]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2,3})',
                                    '$1 $2 $3',
                                    ['8'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{4})(\\d{3})',
                                    '$1 $2 $3',
                                    ['1'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[67]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['9'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[2-5]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        HT: [
                            '509',
                            '00',
                            '(?:[2-489]\\d|55)\\d{6}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[2-589]']
                                ]]
                        ],
                        HU: [
                            '36',
                            '00',
                            '[235-7]\\d{8}|[1-9]\\d{7}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1'],
                                    '(06 $1)'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]'],
                                    '(06 $1)'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[2-9]'],
                                    '06 $1'
                                ]
                            ],
                            '06'
                        ],
                        ID: [
                            '62',
                            '00[89]',
                            '(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}',
                            [
                                7,
                                8,
                                9,
                                10,
                                11,
                                12,
                                13
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['15']
                                ],
                                [
                                    '(\\d{2})(\\d{5,9})',
                                    '$1 $2',
                                    ['2[124]|[36]1'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{3})(\\d{5,7})',
                                    '$1 $2',
                                    ['800'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{5,8})',
                                    '$1 $2',
                                    ['[2-79]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{3})(\\d{3,4})(\\d{3})',
                                    '$1-$2-$3',
                                    ['8[1-35-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{6,8})',
                                    '$1 $2',
                                    ['1'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['804'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d)(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['80'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{4})(\\d{4,5})',
                                    '$1-$2-$3',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        IE: [
                            '353',
                            '00',
                            '(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}',
                            [
                                7,
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{5})',
                                    '$1 $2',
                                    ['2[24-9]|47|58|6[237-9]|9[35-9]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['[45]0'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d)(\\d{3,4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[2569]|4[1-69]|7[14]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['70'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['81'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[78]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['1']
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['4'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3 $4',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        IL: [
                            '972',
                            '0(?:0|1[2-9])',
                            '1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}',
                            [
                                7,
                                8,
                                9,
                                10,
                                11,
                                12
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{3})',
                                    '$1-$2',
                                    ['125']
                                ],
                                [
                                    '(\\d{4})(\\d{2})(\\d{2})',
                                    '$1-$2-$3',
                                    ['121']
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1-$2-$3',
                                    ['[2-489]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1-$2-$3',
                                    ['[57]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3})',
                                    '$1-$2-$3',
                                    ['12']
                                ],
                                [
                                    '(\\d{4})(\\d{6})',
                                    '$1-$2',
                                    ['159']
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{3})(\\d{3})',
                                    '$1-$2-$3-$4',
                                    ['1[7-9]']
                                ],
                                [
                                    '(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})',
                                    '$1-$2 $3-$4',
                                    ['15']
                                ]
                            ],
                            '0'
                        ],
                        IM: [
                            '44',
                            '00',
                            '1624\\d{6}|(?:[3578]\\d|90)\\d{8}',
                            [10],
                            0,
                            '0',
                            0,
                            '0|([25-8]\\d{5})$',
                            '1624$1',
                            0,
                            '74576|(?:16|7[56])24'
                        ],
                        IN: [
                            '91',
                            '00',
                            '(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}',
                            [
                                8,
                                9,
                                10,
                                11,
                                12,
                                13
                            ],
                            [
                                [
                                    '(\\d{8})',
                                    '$1',
                                    [
                                        '5(?:0|2[23]|3[03]|[67]1|88)',
                                        '5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)',
                                        '5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)'
                                    ],
                                    0,
                                    1
                                ],
                                [
                                    '(\\d{4})(\\d{4,5})',
                                    '$1 $2',
                                    [
                                        '180',
                                        '1800'
                                    ],
                                    0,
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['140'],
                                    0,
                                    1
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    [
                                        '11|2[02]|33|4[04]|79[1-7]|80[2-46]',
                                        '11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])',
                                        '11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])'
                                    ],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    [
                                        '1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]',
                                        '1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]',
                                        '1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]'
                                    ],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    [
                                        '1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807',
                                        '1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]',
                                        '1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]'
                                    ],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{5})(\\d{5})',
                                    '$1 $2',
                                    ['[6-9]'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{4})(\\d{2,4})(\\d{4})',
                                    '$1 $2 $3',
                                    [
                                        '1(?:6|8[06])',
                                        '1(?:6|8[06]0)'
                                    ],
                                    0,
                                    1
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['18'],
                                    0,
                                    1
                                ]
                            ],
                            '0'
                        ],
                        IO: [
                            '246',
                            '00',
                            '3\\d{6}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['3']
                                ]]
                        ],
                        IQ: [
                            '964',
                            '00',
                            '(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}',
                            [
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[2-6]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['7'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        IR: [
                            '98',
                            '00',
                            '[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}',
                            [
                                4,
                                5,
                                6,
                                7,
                                10
                            ],
                            [
                                [
                                    '(\\d{4,5})',
                                    '$1',
                                    ['96'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4,5})',
                                    '$1 $2',
                                    ['(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['9'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[1-8]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        IS: [
                            '354',
                            '00|1(?:0(?:01|[12]0)|100)',
                            '(?:38\\d|[4-9])\\d{6}',
                            [
                                7,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[4-9]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['3']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        IT: [
                            '39',
                            '00',
                            '0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?',
                            [
                                6,
                                7,
                                8,
                                9,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{4,6})',
                                    '$1 $2',
                                    ['0[26]']
                                ],
                                [
                                    '(\\d{3})(\\d{3,6})',
                                    '$1 $2',
                                    [
                                        '0[13-57-9][0159]|8(?:03|4[17]|9[2-5])',
                                        '0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))'
                                    ]
                                ],
                                [
                                    '(\\d{4})(\\d{2,6})',
                                    '$1 $2',
                                    ['0(?:[13-579][2-46-8]|8[236-8])']
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['894']
                                ],
                                [
                                    '(\\d{2})(\\d{3,4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['0[26]|5']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['1(?:44|[679])|[378]']
                                ],
                                [
                                    '(\\d{3})(\\d{3,4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['0[13-57-9][0159]|14']
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{5})',
                                    '$1 $2 $3',
                                    ['0[26]']
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['0']
                                ],
                                [
                                    '(\\d{3})(\\d{4})(\\d{4,5})',
                                    '$1 $2 $3',
                                    ['3']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                ['0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}'],
                                [
                                    '3[1-9]\\d{8}|3[2-9]\\d{7}',
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    '80(?:0\\d{3}|3)\\d{3}',
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    '(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}',
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    '1(?:78\\d|99)\\d{6}',
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                0,
                                0,
                                0,
                                [
                                    '55\\d{8}',
                                    [10]
                                ],
                                [
                                    '84(?:[08]\\d{3}|[17])\\d{3}',
                                    [
                                        6,
                                        9
                                    ]
                                ]
                            ]
                        ],
                        JE: [
                            '44',
                            '00',
                            '1534\\d{6}|(?:[3578]\\d|90)\\d{8}',
                            [10],
                            0,
                            '0',
                            0,
                            '0|([0-24-8]\\d{5})$',
                            '1534$1',
                            0,
                            0,
                            [
                                ['1534[0-24-8]\\d{5}'],
                                ['7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}'],
                                ['80(?:07(?:35|81)|8901)\\d{4}'],
                                ['(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}'],
                                ['701511\\d{4}'],
                                0,
                                ['(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}'],
                                ['76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}'],
                                ['56\\d{8}']
                            ]
                        ],
                        JM: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|658|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            0,
                            0,
                            0,
                            '658|876'
                        ],
                        JO: [
                            '962',
                            '00',
                            '(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[2356]|87'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{3})(\\d{5,6})',
                                    '$1 $2',
                                    ['[89]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{7})',
                                    '$1 $2',
                                    ['70'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['7'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        JP: [
                            '81',
                            '010',
                            '00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}',
                            [
                                8,
                                9,
                                10,
                                11,
                                12,
                                13,
                                14,
                                15,
                                16,
                                17
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1-$2-$3',
                                    ['(?:12|57|99)0'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d)(\\d{4})',
                                    '$1-$2-$3',
                                    [
                                        '1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])',
                                        '1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]',
                                        '1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1-$2-$3',
                                    ['60'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{4})(\\d{4})',
                                    '$1-$2-$3',
                                    [
                                        '[36]|4(?:2[09]|7[01])',
                                        '[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1-$2-$3',
                                    [
                                        '1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])',
                                        '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]',
                                        '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]',
                                        '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{4})',
                                    '$1-$2-$3',
                                    ['[14]|[289][2-9]|5[3-9]|7[2-4679]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1-$2-$3',
                                    ['800'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1-$2-$3',
                                    ['[257-9]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        KE: [
                            '254',
                            '000',
                            '(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}',
                            [
                                7,
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{5,7})',
                                    '$1 $2',
                                    ['[24-6]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{6})',
                                    '$1 $2',
                                    ['[17]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[89]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        KG: [
                            '996',
                            '00',
                            '8\\d{9}|(?:[235-8]\\d|99)\\d{7}',
                            [
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{5})',
                                    '$1 $2',
                                    ['3(?:1[346]|[24-79])'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[235-79]|88'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d)(\\d{2,3})',
                                    '$1 $2 $3 $4',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        KH: [
                            '855',
                            '00[14-9]',
                            '1\\d{9}|[1-9]\\d{7,8}',
                            [
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[1-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['1']
                                ]
                            ],
                            '0'
                        ],
                        KI: [
                            '686',
                            '00',
                            '(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}',
                            [
                                5,
                                8
                            ],
                            0,
                            '0'
                        ],
                        KM: [
                            '269',
                            '00',
                            '[3478]\\d{6}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3',
                                    ['[3478]']
                                ]]
                        ],
                        KN: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-7]\\d{6})$',
                            '869$1',
                            0,
                            '869'
                        ],
                        KP: [
                            '850',
                            '00|99',
                            '85\\d{6}|(?:19\\d|[2-7])\\d{7}',
                            [
                                8,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['8'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[2-7]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        KR: [
                            '82',
                            '00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))',
                            '00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}',
                            [
                                5,
                                6,
                                8,
                                9,
                                10,
                                11,
                                12,
                                13,
                                14
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3,4})',
                                    '$1-$2',
                                    ['(?:3[1-3]|[46][1-4]|5[1-5])1'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1-$2',
                                    ['1']
                                ],
                                [
                                    '(\\d)(\\d{3,4})(\\d{4})',
                                    '$1-$2-$3',
                                    ['2'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1-$2-$3',
                                    ['60|8'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3,4})(\\d{4})',
                                    '$1-$2-$3',
                                    ['[1346]|5[1-5]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1-$2-$3',
                                    ['[57]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{5})(\\d{4})',
                                    '$1-$2-$3',
                                    ['5'],
                                    '0$1'
                                ]
                            ],
                            '0',
                            0,
                            '0(8(?:[1-46-8]|5\\d\\d))?'
                        ],
                        KW: [
                            '965',
                            '00',
                            '18\\d{5}|(?:[2569]\\d|41)\\d{6}',
                            [
                                7,
                                8
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{3,4})',
                                    '$1 $2',
                                    ['[169]|2(?:[235]|4[1-35-9])|52']
                                ],
                                [
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['[245]']
                                ]
                            ]
                        ],
                        KY: [
                            '1',
                            '011',
                            '(?:345|[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-9]\\d{6})$',
                            '345$1',
                            0,
                            '345'
                        ],
                        KZ: [
                            '7',
                            '810',
                            '(?:33622|8\\d{8})\\d{5}|[78]\\d{9}',
                            [
                                10,
                                14
                            ],
                            0,
                            '8',
                            0,
                            0,
                            0,
                            0,
                            '33|7',
                            0,
                            '8~10'
                        ],
                        LA: [
                            '856',
                            '00',
                            '[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}',
                            [
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['2[13]|3[14]|[4-8]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['30[013-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['[23]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        LB: [
                            '961',
                            '00',
                            '[27-9]\\d{7}|[13-9]\\d{6}',
                            [
                                7,
                                8
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[27-9]']
                                ]
                            ],
                            '0'
                        ],
                        LC: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|758|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-8]\\d{6})$',
                            '758$1',
                            0,
                            '758'
                        ],
                        LI: [
                            '423',
                            '00',
                            '[68]\\d{8}|(?:[2378]\\d|90)\\d{5}',
                            [
                                7,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3',
                                    [
                                        '[2379]|8(?:0[09]|7)',
                                        '[2379]|8(?:0(?:02|9)|7)'
                                    ]
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['8']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['69']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['6']
                                ]
                            ],
                            '0',
                            0,
                            '0|(1001)'
                        ],
                        LK: [
                            '94',
                            '00',
                            '[1-9]\\d{8}',
                            [9],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['7'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[1-689]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        LR: [
                            '231',
                            '00',
                            '(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}',
                            [
                                7,
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[4-6]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['2'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[23578]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        LS: [
                            '266',
                            '00',
                            '(?:[256]\\d\\d|800)\\d{5}',
                            [8],
                            [[
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[2568]']
                                ]]
                        ],
                        LT: [
                            '370',
                            '00',
                            '(?:[3469]\\d|52|[78]0)\\d{6}',
                            [8],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['52[0-7]'],
                                    '(8-$1)',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[7-9]'],
                                    '8 $1',
                                    1
                                ],
                                [
                                    '(\\d{2})(\\d{6})',
                                    '$1 $2',
                                    ['37|4(?:[15]|6[1-8])'],
                                    '(8-$1)',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['[3-6]'],
                                    '(8-$1)',
                                    1
                                ]
                            ],
                            '8',
                            0,
                            '[08]'
                        ],
                        LU: [
                            '352',
                            '00',
                            '35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}',
                            [
                                4,
                                5,
                                6,
                                7,
                                8,
                                9,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})',
                                    '$1 $2',
                                    ['2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3',
                                    ['2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['20[2-689]']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})',
                                    '$1 $2 $3 $4',
                                    ['2(?:[0367]|4[3-8])']
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['80[01]|90[015]']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['20']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['6']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})',
                                    '$1 $2 $3 $4 $5',
                                    ['2(?:[0367]|4[3-8])']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})',
                                    '$1 $2 $3 $4',
                                    ['[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]']
                                ]
                            ],
                            0,
                            0,
                            '(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)'
                        ],
                        LV: [
                            '371',
                            '00',
                            '(?:[268]\\d|90)\\d{6}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[269]|8[01]']
                                ]]
                        ],
                        LY: [
                            '218',
                            '00',
                            '[2-9]\\d{8}',
                            [9],
                            [[
                                    '(\\d{2})(\\d{7})',
                                    '$1-$2',
                                    ['[2-9]'],
                                    '0$1'
                                ]],
                            '0'
                        ],
                        MA: [
                            '212',
                            '00',
                            '[5-8]\\d{8}',
                            [9],
                            [
                                [
                                    '(\\d{5})(\\d{4})',
                                    '$1-$2',
                                    [
                                        '5(?:29|38)',
                                        '5(?:29[1289]|389)',
                                        '529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['5[45]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{5})',
                                    '$1-$2',
                                    [
                                        '5(?:2[2-489]|3[5-9]|9)|892',
                                        '5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{7})',
                                    '$1-$2',
                                    ['8'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{6})',
                                    '$1-$2',
                                    ['[5-7]'],
                                    '0$1'
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                ['5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}'],
                                ['(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}'],
                                ['80\\d{7}'],
                                ['89\\d{7}'],
                                0,
                                0,
                                0,
                                0,
                                ['592(?:4[0-2]|93)\\d{4}']
                            ]
                        ],
                        MC: [
                            '377',
                            '00',
                            '(?:[3489]|6\\d)\\d{7}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['4'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[389]']
                                ],
                                [
                                    '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4 $5',
                                    ['6'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        MD: [
                            '373',
                            '00',
                            '(?:[235-7]\\d|[89]0)\\d{6}',
                            [8],
                            [
                                [
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['[89]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['22|3'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[25-7]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        ME: [
                            '382',
                            '00',
                            '(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}',
                            [
                                8,
                                9
                            ],
                            [[
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[2-9]'],
                                    '0$1'
                                ]],
                            '0'
                        ],
                        MF: [
                            '590',
                            '00',
                            '(?:590|(?:69|80)\\d|976)\\d{6}',
                            [9],
                            0,
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                ['590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}'],
                                ['69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}'],
                                ['80[0-5]\\d{6}'],
                                0,
                                0,
                                0,
                                0,
                                0,
                                ['976[01]\\d{5}']
                            ]
                        ],
                        MG: [
                            '261',
                            '00',
                            '[23]\\d{8}',
                            [9],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{3})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[23]'],
                                    '0$1'
                                ]],
                            '0',
                            0,
                            '0|([24-9]\\d{6})$',
                            '20$1'
                        ],
                        MH: [
                            '692',
                            '011',
                            '329\\d{4}|(?:[256]\\d|45)\\d{5}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1-$2',
                                    ['[2-6]']
                                ]],
                            '1'
                        ],
                        MK: [
                            '389',
                            '00',
                            '[2-578]\\d{7}',
                            [8],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['2|34[47]|4(?:[37]7|5[47]|64)'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[347]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d)(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[58]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        ML: [
                            '223',
                            '00',
                            '[24-9]\\d{7}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[24-9]']
                                ]]
                        ],
                        MM: [
                            '95',
                            '00',
                            '1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}',
                            [
                                6,
                                7,
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d)(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['16|2'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[12]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[4-7]|8[1-35]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{4,6})',
                                    '$1 $2 $3',
                                    ['9(?:2[0-4]|[35-9]|4[137-9])'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['2'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['8'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['92'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{5})(\\d{4})',
                                    '$1 $2 $3',
                                    ['9'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        MN: [
                            '976',
                            '001',
                            '[12]\\d{7,9}|[5-9]\\d{7}',
                            [
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[12]1'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[5-9]']
                                ],
                                [
                                    '(\\d{3})(\\d{5,6})',
                                    '$1 $2',
                                    ['[12]2[1-3]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{5,6})',
                                    '$1 $2',
                                    [
                                        '[12](?:27|3[2-8]|4[2-68]|5[1-4689])',
                                        '[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{5})(\\d{4,5})',
                                    '$1 $2',
                                    ['[12]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        MO: [
                            '853',
                            '00',
                            '0800\\d{3}|(?:28|[68]\\d)\\d{6}',
                            [
                                7,
                                8
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{3})',
                                    '$1 $2',
                                    ['0']
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[268]']
                                ]
                            ]
                        ],
                        MP: [
                            '1',
                            '011',
                            '[58]\\d{9}|(?:67|90)0\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-9]\\d{6})$',
                            '670$1',
                            0,
                            '670'
                        ],
                        MQ: [
                            '596',
                            '00',
                            '(?:69|80)\\d{7}|(?:59|97)6\\d{6}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[569]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        MR: [
                            '222',
                            '00',
                            '(?:[2-4]\\d\\d|800)\\d{5}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[2-48]']
                                ]]
                        ],
                        MS: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|664|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([34]\\d{6})$',
                            '664$1',
                            0,
                            '664'
                        ],
                        MT: [
                            '356',
                            '00',
                            '3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}',
                            [8],
                            [[
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[2357-9]']
                                ]]
                        ],
                        MU: [
                            '230',
                            '0(?:0|[24-7]0|3[03])',
                            '(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}',
                            [
                                7,
                                8,
                                10
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[2-46]|8[013]']
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[57]']
                                ],
                                [
                                    '(\\d{5})(\\d{5})',
                                    '$1 $2',
                                    ['8']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '020'
                        ],
                        MV: [
                            '960',
                            '0(?:0|19)',
                            '(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}',
                            [
                                7,
                                10
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1-$2',
                                    ['[3467]|9[1-9]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[89]']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        MW: [
                            '265',
                            '00',
                            '(?:[1289]\\d|31|77)\\d{7}|1\\d{6}',
                            [
                                7,
                                9
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['1[2-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['2'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[137-9]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        MX: [
                            '52',
                            '0[09]',
                            '1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}',
                            [
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['33|5[56]|81'],
                                    0,
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[2-9]'],
                                    0,
                                    1
                                ],
                                [
                                    '(\\d)(\\d{2})(\\d{4})(\\d{4})',
                                    '$2 $3 $4',
                                    ['1(?:33|5[56]|81)'],
                                    0,
                                    1
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{3})(\\d{4})',
                                    '$2 $3 $4',
                                    ['1'],
                                    0,
                                    1
                                ]
                            ],
                            '01',
                            0,
                            '0(?:[12]|4[45])|1',
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        MY: [
                            '60',
                            '00',
                            '1\\d{8,9}|(?:3\\d|[4-9])\\d{7}',
                            [
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1-$2 $3',
                                    ['[4-79]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1-$2 $3',
                                    [
                                        '1(?:[02469]|[378][1-9]|53)|8',
                                        '1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{4})(\\d{4})',
                                    '$1-$2 $3',
                                    ['3'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{2})(\\d{4})',
                                    '$1-$2-$3-$4',
                                    ['1(?:[367]|80)']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1-$2 $3',
                                    ['15'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1-$2 $3',
                                    ['1'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        MZ: [
                            '258',
                            '00',
                            '(?:2|8\\d)\\d{7}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['2|8[2-79]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['8']
                                ]
                            ]
                        ],
                        NA: [
                            '264',
                            '00',
                            '[68]\\d{7,8}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['88'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['6'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['87'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        NC: [
                            '687',
                            '00',
                            '(?:050|[2-57-9]\\d\\d)\\d{3}',
                            [6],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})',
                                    '$1.$2.$3',
                                    ['[02-57-9]']
                                ]]
                        ],
                        NE: [
                            '227',
                            '00',
                            '[027-9]\\d{7}',
                            [8],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['08']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[089]|2[013]|7[04]']
                                ]
                            ]
                        ],
                        NF: [
                            '672',
                            '00',
                            '[13]\\d{5}',
                            [6],
                            [
                                [
                                    '(\\d{2})(\\d{4})',
                                    '$1 $2',
                                    ['1[0-3]']
                                ],
                                [
                                    '(\\d)(\\d{5})',
                                    '$1 $2',
                                    ['[13]']
                                ]
                            ],
                            0,
                            0,
                            '([0-258]\\d{4})$',
                            '3$1'
                        ],
                        NG: [
                            '234',
                            '009',
                            '(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}',
                            [
                                7,
                                8,
                                10,
                                11,
                                12,
                                13,
                                14
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['78'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[12]|9(?:0[3-9]|[1-9])'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2,3})',
                                    '$1 $2 $3',
                                    ['[3-7]|8[2-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[7-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{4})(\\d{4,5})',
                                    '$1 $2 $3',
                                    ['[78]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{5})(\\d{5,6})',
                                    '$1 $2 $3',
                                    ['[78]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        NI: [
                            '505',
                            '00',
                            '(?:1800|[25-8]\\d{3})\\d{4}',
                            [8],
                            [[
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[125-8]']
                                ]]
                        ],
                        NL: [
                            '31',
                            '00',
                            '(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}',
                            [
                                5,
                                6,
                                7,
                                8,
                                9,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4,7})',
                                    '$1 $2',
                                    ['[89]0'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{7})',
                                    '$1 $2',
                                    ['66'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{8})',
                                    '$1 $2',
                                    ['6'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['1[16-8]|2[259]|3[124]|4[17-9]|5[124679]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[1-578]|91'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{5})',
                                    '$1 $2 $3',
                                    ['9'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        NO: [
                            '47',
                            '00',
                            '(?:0|[2-9]\\d{3})\\d{4}',
                            [
                                5,
                                8
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[489]|59']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[235-7]']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            '[02-689]|7[0-8]'
                        ],
                        NP: [
                            '977',
                            '00',
                            '(?:1\\d|9)\\d{9}|[1-9]\\d{7}',
                            [
                                8,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d)(\\d{7})',
                                    '$1-$2',
                                    ['1[2-6]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{6})',
                                    '$1-$2',
                                    ['1[01]|[2-8]|9(?:[1-59]|[67][2-6])'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{7})',
                                    '$1-$2',
                                    ['9']
                                ]
                            ],
                            '0'
                        ],
                        NR: [
                            '674',
                            '00',
                            '(?:444|(?:55|8\\d)\\d|666)\\d{4}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[4-68]']
                                ]]
                        ],
                        NU: [
                            '683',
                            '00',
                            '(?:[47]|888\\d)\\d{3}',
                            [
                                4,
                                7
                            ],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['8']
                                ]]
                        ],
                        NZ: [
                            '64',
                            '0(?:0|161)',
                            '[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}',
                            [
                                5,
                                6,
                                7,
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3,8})',
                                    '$1 $2',
                                    ['8[1-579]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2,3})',
                                    '$1 $2 $3',
                                    [
                                        '50[036-8]|[89]0',
                                        '50(?:[0367]|88)|[89]0'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['24|[346]|7[2-57-9]|9[2-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['2(?:10|74)|[59]|80'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3,4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1|2[028]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,5})',
                                    '$1 $2 $3',
                                    ['2(?:[169]|7[0-35-9])|7|86'],
                                    '0$1'
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        OM: [
                            '968',
                            '00',
                            '(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}',
                            [
                                7,
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4,6})',
                                    '$1 $2',
                                    ['[58]']
                                ],
                                [
                                    '(\\d{2})(\\d{6})',
                                    '$1 $2',
                                    ['2']
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[179]']
                                ]
                            ]
                        ],
                        PA: [
                            '507',
                            '00',
                            '(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}',
                            [
                                7,
                                8,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1-$2',
                                    ['[1-57-9]']
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1-$2',
                                    ['[68]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['8']
                                ]
                            ]
                        ],
                        PE: [
                            '51',
                            '00|19(?:1[124]|77|90)00',
                            '(?:[14-8]|9\\d)\\d{7}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['80'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d)(\\d{7})',
                                    '$1 $2',
                                    ['1'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{6})',
                                    '$1 $2',
                                    ['[4-8]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['9']
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00',
                            ' Anexo '
                        ],
                        PF: [
                            '689',
                            '00',
                            '4\\d{5}(?:\\d{2})?|8\\d{7,8}',
                            [
                                6,
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3',
                                    ['44']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['4|8[7-9]']
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['8']
                                ]
                            ]
                        ],
                        PG: [
                            '675',
                            '00|140[1-3]',
                            '(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}',
                            [
                                7,
                                8
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['18|[2-69]|85']
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[78]']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        PH: [
                            '63',
                            '00',
                            '(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}',
                            [
                                6,
                                8,
                                9,
                                10,
                                11,
                                12,
                                13
                            ],
                            [
                                [
                                    '(\\d)(\\d{5})',
                                    '$1 $2',
                                    ['2'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{4})(\\d{4,6})',
                                    '$1 $2',
                                    [
                                        '3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2',
                                        '3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))'
                                    ],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{5})(\\d{4})',
                                    '$1 $2',
                                    [
                                        '346|4(?:27|9[35])|883',
                                        '3469|4(?:279|9(?:30|56))|8834'
                                    ],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d)(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['2'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[3-7]|8[2-8]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[89]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1']
                                ],
                                [
                                    '(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3 $4',
                                    ['1']
                                ]
                            ],
                            '0'
                        ],
                        PK: [
                            '92',
                            '00',
                            '122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}',
                            [
                                8,
                                9,
                                10,
                                11,
                                12
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{2,7})',
                                    '$1 $2 $3',
                                    ['[89]0'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{5})',
                                    '$1 $2',
                                    ['1']
                                ],
                                [
                                    '(\\d{3})(\\d{6,7})',
                                    '$1 $2',
                                    [
                                        '2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])',
                                        '9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]'
                                    ],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{7,8})',
                                    '$1 $2',
                                    ['(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{5})(\\d{5})',
                                    '$1 $2',
                                    ['58'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{3})(\\d{7})',
                                    '$1 $2',
                                    ['3'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['[24-9]'],
                                    '(0$1)'
                                ]
                            ],
                            '0'
                        ],
                        PL: [
                            '48',
                            '00',
                            '(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}',
                            [
                                6,
                                7,
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{5})',
                                    '$1',
                                    ['19']
                                ],
                                [
                                    '(\\d{3})(\\d{3})',
                                    '$1 $2',
                                    ['11|20|64']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{3})',
                                    '$1 $2 $3',
                                    [
                                        '(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1',
                                        '(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19'
                                    ]
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2,3})',
                                    '$1 $2 $3',
                                    ['64']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['1[2-8]|[2-7]|8[1-79]|9[145]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['8']
                                ]
                            ]
                        ],
                        PM: [
                            '508',
                            '00',
                            '(?:[45]|80\\d\\d)\\d{5}',
                            [
                                6,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3',
                                    ['[45]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        PR: [
                            '1',
                            '011',
                            '(?:[589]\\d\\d|787)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            0,
                            0,
                            0,
                            '787|939'
                        ],
                        PS: [
                            '970',
                            '00',
                            '[2489]2\\d{6}|(?:1\\d|5)\\d{8}',
                            [
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[2489]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['5'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['1']
                                ]
                            ],
                            '0'
                        ],
                        PT: [
                            '351',
                            '00',
                            '1693\\d{5}|(?:[26-9]\\d|30)\\d{7}',
                            [9],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['2[12]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['16|[236-9]']
                                ]
                            ]
                        ],
                        PW: [
                            '680',
                            '01[12]',
                            '(?:[24-8]\\d\\d|345|900)\\d{4}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[2-9]']
                                ]]
                        ],
                        PY: [
                            '595',
                            '00',
                            '59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}',
                            [
                                6,
                                7,
                                8,
                                9,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3,6})',
                                    '$1 $2',
                                    ['[2-9]0'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{5})',
                                    '$1 $2',
                                    ['[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{3})(\\d{4,5})',
                                    '$1 $2',
                                    ['2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]'],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['87']
                                ],
                                [
                                    '(\\d{3})(\\d{6})',
                                    '$1 $2',
                                    ['9(?:[5-79]|8[1-6])'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[2-8]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['9']
                                ]
                            ],
                            '0'
                        ],
                        QA: [
                            '974',
                            '00',
                            '800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}',
                            [
                                7,
                                8,
                                9,
                                11
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['2[16]|8']
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[3-7]']
                                ]
                            ]
                        ],
                        RE: [
                            '262',
                            '00',
                            '976\\d{6}|(?:26|[68]\\d)\\d{7}',
                            [9],
                            [[
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[2689]'],
                                    '0$1'
                                ]],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            '26[23]|69|[89]'
                        ],
                        RO: [
                            '40',
                            '00',
                            '(?:[2378]\\d|90)\\d{7}|[23]\\d{5}',
                            [
                                6,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3})',
                                    '$1 $2',
                                    [
                                        '2[3-6]',
                                        '2[3-6]\\d9'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4})',
                                    '$1 $2',
                                    ['219|31'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[23]1'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[237-9]'],
                                    '0$1'
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            ' int '
                        ],
                        RS: [
                            '381',
                            '00',
                            '38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}',
                            [
                                6,
                                7,
                                8,
                                9,
                                10,
                                11,
                                12
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3,9})',
                                    '$1 $2',
                                    ['(?:2[389]|39)0|[7-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{5,10})',
                                    '$1 $2',
                                    ['[1-36]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        RU: [
                            '7',
                            '810',
                            '8\\d{13}|[347-9]\\d{9}',
                            [
                                10,
                                14
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    [
                                        '7(?:1[0-8]|2[1-9])',
                                        '7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))',
                                        '7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2'
                                    ],
                                    '8 ($1)',
                                    1
                                ],
                                [
                                    '(\\d{5})(\\d)(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    [
                                        '7(?:1[0-68]|2[1-9])',
                                        '7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))',
                                        '7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]'
                                    ],
                                    '8 ($1)',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['7'],
                                    '8 ($1)',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2-$3-$4',
                                    ['[349]|8(?:[02-7]|1[1-8])'],
                                    '8 ($1)',
                                    1
                                ],
                                [
                                    '(\\d{4})(\\d{4})(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['8'],
                                    '8 ($1)'
                                ]
                            ],
                            '8',
                            0,
                            0,
                            0,
                            0,
                            '3[04-689]|[489]',
                            0,
                            '8~10'
                        ],
                        RW: [
                            '250',
                            '00',
                            '(?:06|[27]\\d\\d|[89]00)\\d{6}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['0']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[7-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['2']
                                ]
                            ],
                            '0'
                        ],
                        SA: [
                            '966',
                            '00',
                            '92\\d{7}|(?:[15]|8\\d)\\d{8}',
                            [
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{5})',
                                    '$1 $2',
                                    ['9']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['5'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['81'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['8']
                                ]
                            ],
                            '0'
                        ],
                        SB: [
                            '677',
                            '0[01]',
                            '(?:[1-6]|[7-9]\\d\\d)\\d{4}',
                            [
                                5,
                                7
                            ],
                            [[
                                    '(\\d{2})(\\d{5})',
                                    '$1 $2',
                                    ['7|8[4-9]|9(?:[1-8]|9[0-8])']
                                ]]
                        ],
                        SC: [
                            '248',
                            '010|0[0-2]',
                            '800\\d{4}|(?:[249]\\d|64)\\d{5}',
                            [7],
                            [[
                                    '(\\d)(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[246]|9[57]']
                                ]],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        SD: [
                            '249',
                            '00',
                            '[19]\\d{8}',
                            [9],
                            [[
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[19]'],
                                    '0$1'
                                ]],
                            '0'
                        ],
                        SE: [
                            '46',
                            '00',
                            '(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}',
                            [
                                6,
                                7,
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2,3})(\\d{2})',
                                    '$1-$2 $3',
                                    ['20'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3'
                                ],
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1-$2',
                                    ['9(?:00|39|44|9)'],
                                    '0$1',
                                    0,
                                    '$1 $2'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})',
                                    '$1-$2 $3',
                                    ['[12][136]|3[356]|4[0246]|6[03]|90[1-9]'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3'
                                ],
                                [
                                    '(\\d)(\\d{2,3})(\\d{2})(\\d{2})',
                                    '$1-$2 $3 $4',
                                    ['8'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3 $4'
                                ],
                                [
                                    '(\\d{3})(\\d{2,3})(\\d{2})',
                                    '$1-$2 $3',
                                    ['1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3'
                                ],
                                [
                                    '(\\d{3})(\\d{2,3})(\\d{3})',
                                    '$1-$2 $3',
                                    ['9(?:00|39|44)'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3'
                                ],
                                [
                                    '(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})',
                                    '$1-$2 $3 $4',
                                    ['1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3 $4'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1-$2 $3 $4',
                                    ['10|7'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3 $4'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{3})(\\d{2})',
                                    '$1-$2 $3 $4',
                                    ['8'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3 $4'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1-$2 $3 $4',
                                    ['[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3 $4'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{3})',
                                    '$1-$2 $3 $4',
                                    ['9'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3 $4'
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1-$2 $3 $4 $5',
                                    ['[26]'],
                                    '0$1',
                                    0,
                                    '$1 $2 $3 $4 $5'
                                ]
                            ],
                            '0'
                        ],
                        SG: [
                            '65',
                            '0[0-3]\\d',
                            '(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}',
                            [
                                8,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[369]|8(?:0[1-6]|[1-9])']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['8']
                                ],
                                [
                                    '(\\d{4})(\\d{4})(\\d{3})',
                                    '$1 $2 $3',
                                    ['7']
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1']
                                ]
                            ]
                        ],
                        SH: [
                            '290',
                            '00',
                            '(?:[256]\\d|8)\\d{3}',
                            [
                                4,
                                5
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '[256]'
                        ],
                        SI: [
                            '386',
                            '00|10(?:22|66|88|99)',
                            '[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}',
                            [
                                5,
                                6,
                                7,
                                8
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3,6})',
                                    '$1 $2',
                                    ['8[09]|9'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['59|8'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[37][01]|4[0139]|51|6'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[1-57]'],
                                    '(0$1)'
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        SJ: [
                            '47',
                            '00',
                            '0\\d{4}|(?:[489]\\d|[57]9)\\d{6}',
                            [
                                5,
                                8
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '79'
                        ],
                        SK: [
                            '421',
                            '00',
                            '[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}',
                            [
                                6,
                                7,
                                9
                            ],
                            [
                                [
                                    '(\\d)(\\d{2})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['21'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{2,3})',
                                    '$1 $2 $3',
                                    [
                                        '[3-5][1-8]1',
                                        '[3-5][1-8]1[67]'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{3})(\\d{2})',
                                    '$1/$2 $3 $4',
                                    ['2'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[689]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1/$2 $3 $4',
                                    ['[3-5]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        SL: [
                            '232',
                            '00',
                            '(?:[237-9]\\d|66)\\d{6}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{6})',
                                    '$1 $2',
                                    ['[236-9]'],
                                    '(0$1)'
                                ]],
                            '0'
                        ],
                        SM: [
                            '378',
                            '00',
                            '(?:0549|[5-7]\\d)\\d{6}',
                            [
                                8,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[5-7]']
                                ],
                                [
                                    '(\\d{4})(\\d{6})',
                                    '$1 $2',
                                    ['0']
                                ]
                            ],
                            0,
                            0,
                            '([89]\\d{5})$',
                            '0549$1'
                        ],
                        SN: [
                            '221',
                            '00',
                            '(?:[378]\\d|93)\\d{7}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['8']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[379]']
                                ]
                            ]
                        ],
                        SO: [
                            '252',
                            '00',
                            '[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}',
                            [
                                6,
                                7,
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{4})',
                                    '$1 $2',
                                    ['8[125]']
                                ],
                                [
                                    '(\\d{6})',
                                    '$1',
                                    ['[134]']
                                ],
                                [
                                    '(\\d)(\\d{6})',
                                    '$1 $2',
                                    ['[15]|2[0-79]|3[0-46-8]|4[0-7]']
                                ],
                                [
                                    '(\\d)(\\d{7})',
                                    '$1 $2',
                                    ['(?:2|90)4|[67]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[3478]|64|90']
                                ],
                                [
                                    '(\\d{2})(\\d{5,7})',
                                    '$1 $2',
                                    ['1|28|6(?:0[5-7]|[1-35-9])|9[2-9]']
                                ]
                            ],
                            '0'
                        ],
                        SR: [
                            '597',
                            '00',
                            '(?:[2-5]|68|[78]\\d)\\d{5}',
                            [
                                6,
                                7
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})',
                                    '$1-$2-$3',
                                    ['56']
                                ],
                                [
                                    '(\\d{3})(\\d{3})',
                                    '$1-$2',
                                    ['[2-5]']
                                ],
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1-$2',
                                    ['[6-8]']
                                ]
                            ]
                        ],
                        SS: [
                            '211',
                            '00',
                            '[19]\\d{8}',
                            [9],
                            [[
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[19]'],
                                    '0$1'
                                ]],
                            '0'
                        ],
                        ST: [
                            '239',
                            '00',
                            '(?:22|9\\d)\\d{5}',
                            [7],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[29]']
                                ]]
                        ],
                        SV: [
                            '503',
                            '00',
                            '[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?',
                            [
                                7,
                                8,
                                11
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[89]']
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[267]']
                                ],
                                [
                                    '(\\d{3})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[89]']
                                ]
                            ]
                        ],
                        SX: [
                            '1',
                            '011',
                            '7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|(5\\d{6})$',
                            '721$1',
                            0,
                            '721'
                        ],
                        SY: [
                            '963',
                            '00',
                            '[1-39]\\d{8}|[1-5]\\d{7}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[1-5]'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['9'],
                                    '0$1',
                                    1
                                ]
                            ],
                            '0'
                        ],
                        SZ: [
                            '268',
                            '00',
                            '0800\\d{4}|(?:[237]\\d|900)\\d{6}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[0237]']
                                ],
                                [
                                    '(\\d{5})(\\d{4})',
                                    '$1 $2',
                                    ['9']
                                ]
                            ]
                        ],
                        TA: [
                            '290',
                            '00',
                            '8\\d{3}',
                            [4],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '8'
                        ],
                        TC: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|649|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-479]\\d{6})$',
                            '649$1',
                            0,
                            '649'
                        ],
                        TD: [
                            '235',
                            '00|16',
                            '(?:22|[69]\\d|77)\\d{6}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[2679]']
                                ]],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00'
                        ],
                        TG: [
                            '228',
                            '00',
                            '[279]\\d{7}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[279]']
                                ]]
                        ],
                        TH: [
                            '66',
                            '00[1-9]',
                            '(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}',
                            [
                                8,
                                9,
                                10,
                                13
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['2'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[13-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['1']
                                ]
                            ],
                            '0'
                        ],
                        TJ: [
                            '992',
                            '810',
                            '(?:00|[1-57-9]\\d)\\d{7}',
                            [9],
                            [
                                [
                                    '(\\d{6})(\\d)(\\d{2})',
                                    '$1 $2 $3',
                                    [
                                        '331',
                                        '3317'
                                    ]
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[34]7|91[78]']
                                ],
                                [
                                    '(\\d{4})(\\d)(\\d{4})',
                                    '$1 $2 $3',
                                    ['3[1-5]']
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[0-57-9]']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '8~10'
                        ],
                        TK: [
                            '690',
                            '00',
                            '[2-47]\\d{3,6}',
                            [
                                4,
                                5,
                                6,
                                7
                            ]
                        ],
                        TL: [
                            '670',
                            '00',
                            '7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}',
                            [
                                7,
                                8
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[2-489]|70']
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['7']
                                ]
                            ]
                        ],
                        TM: [
                            '993',
                            '810',
                            '[1-6]\\d{7}',
                            [8],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2-$3-$4',
                                    ['12'],
                                    '(8 $1)'
                                ],
                                [
                                    '(\\d{3})(\\d)(\\d{2})(\\d{2})',
                                    '$1 $2-$3-$4',
                                    ['[1-5]'],
                                    '(8 $1)'
                                ],
                                [
                                    '(\\d{2})(\\d{6})',
                                    '$1 $2',
                                    ['6'],
                                    '8 $1'
                                ]
                            ],
                            '8',
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '8~10'
                        ],
                        TN: [
                            '216',
                            '00',
                            '[2-57-9]\\d{7}',
                            [8],
                            [[
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[2-57-9]']
                                ]]
                        ],
                        TO: [
                            '676',
                            '00',
                            '(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}',
                            [
                                5,
                                7
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})',
                                    '$1-$2',
                                    ['[2-4]|50|6[09]|7[0-24-69]|8[05]']
                                ],
                                [
                                    '(\\d{4})(\\d{3})',
                                    '$1 $2',
                                    ['0']
                                ],
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[5-9]']
                                ]
                            ]
                        ],
                        TR: [
                            '90',
                            '00',
                            '4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}',
                            [
                                7,
                                10,
                                12,
                                13
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['512|8[01589]|90'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    [
                                        '5(?:[0-59]|61)',
                                        '5(?:[0-59]|616)',
                                        '5(?:[0-59]|6161)'
                                    ],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[24][1-8]|3[1-9]'],
                                    '(0$1)',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{6,7})',
                                    '$1 $2 $3',
                                    ['80'],
                                    '0$1',
                                    1
                                ]
                            ],
                            '0'
                        ],
                        TT: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-46-8]\\d{6})$',
                            '868$1',
                            0,
                            '868'
                        ],
                        TV: [
                            '688',
                            '00',
                            '(?:2|7\\d\\d|90)\\d{4}',
                            [
                                5,
                                6,
                                7
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3})',
                                    '$1 $2',
                                    ['2']
                                ],
                                [
                                    '(\\d{2})(\\d{4})',
                                    '$1 $2',
                                    ['90']
                                ],
                                [
                                    '(\\d{2})(\\d{5})',
                                    '$1 $2',
                                    ['7']
                                ]
                            ]
                        ],
                        TW: [
                            '886',
                            '0(?:0[25-79]|19)',
                            '[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}',
                            [
                                7,
                                8,
                                9,
                                10,
                                11
                            ],
                            [
                                [
                                    '(\\d{2})(\\d)(\\d{4})',
                                    '$1 $2 $3',
                                    ['202'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[258]0'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3,4})(\\d{4})',
                                    '$1 $2 $3',
                                    [
                                        '[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]',
                                        '[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[49]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4,5})',
                                    '$1 $2 $3',
                                    ['7'],
                                    '0$1'
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '#'
                        ],
                        TZ: [
                            '255',
                            '00[056]',
                            '(?:[25-8]\\d|41|90)\\d{7}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{2})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[89]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[24]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{7})',
                                    '$1 $2',
                                    ['5']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[67]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        UA: [
                            '380',
                            '00',
                            '[89]\\d{9}|[3-9]\\d{8}',
                            [
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    [
                                        '6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]',
                                        '6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{5})',
                                    '$1 $2',
                                    [
                                        '3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])',
                                        '3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[3-7]|89|9[1-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[89]'],
                                    '0$1'
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '0~0'
                        ],
                        UG: [
                            '256',
                            '00[057]',
                            '800\\d{6}|(?:[29]0|[347]\\d)\\d{7}',
                            [9],
                            [
                                [
                                    '(\\d{4})(\\d{5})',
                                    '$1 $2',
                                    [
                                        '202',
                                        '2024'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{6})',
                                    '$1 $2',
                                    ['[27-9]|4(?:6[45]|[7-9])'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{7})',
                                    '$1 $2',
                                    ['[34]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        US: [
                            '1',
                            '011',
                            '[2-9]\\d{9}|3\\d{6}',
                            [10],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1-$2',
                                    ['310'],
                                    0,
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '($1) $2-$3',
                                    ['[2-9]'],
                                    0,
                                    1,
                                    '$1-$2-$3'
                                ]
                            ],
                            '1',
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                ['505(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|4[46]))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}'],
                                [''],
                                ['8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'],
                                ['900[2-9]\\d{6}'],
                                ['52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}']
                            ]
                        ],
                        UY: [
                            '598',
                            '0(?:0|1[3-9]\\d)',
                            '(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}',
                            [
                                7,
                                8,
                                10,
                                13
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['405|8|90'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['9'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[124]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['4'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3 $4',
                                    ['0']
                                ]
                            ],
                            '0',
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '00',
                            ' int. '
                        ],
                        UZ: [
                            '998',
                            '810',
                            '(?:33|[5-79]\\d|88)\\d{7}',
                            [9],
                            [[
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[35-9]'],
                                    '8 $1'
                                ]],
                            '8',
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '8~10'
                        ],
                        VA: [
                            '39',
                            '00',
                            '0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}',
                            [
                                6,
                                7,
                                8,
                                9,
                                10,
                                11
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            '06698'
                        ],
                        VC: [
                            '1',
                            '011',
                            '(?:[58]\\d\\d|784|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-7]\\d{6})$',
                            '784$1',
                            0,
                            '784'
                        ],
                        VE: [
                            '58',
                            '00',
                            '[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}',
                            [10],
                            [[
                                    '(\\d{3})(\\d{7})',
                                    '$1-$2',
                                    ['[24-689]'],
                                    '0$1'
                                ]],
                            '0'
                        ],
                        VG: [
                            '1',
                            '011',
                            '(?:284|[58]\\d\\d|900)\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-578]\\d{6})$',
                            '284$1',
                            0,
                            '284'
                        ],
                        VI: [
                            '1',
                            '011',
                            '[58]\\d{9}|(?:34|90)0\\d{7}',
                            [10],
                            0,
                            '1',
                            0,
                            '1|([2-9]\\d{6})$',
                            '340$1',
                            0,
                            '340'
                        ],
                        VN: [
                            '84',
                            '00',
                            '[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}',
                            [
                                7,
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{5})',
                                    '$1 $2',
                                    ['80'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{4})(\\d{4,6})',
                                    '$1 $2',
                                    ['1'],
                                    0,
                                    1
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['[69]'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[3578]'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['2[48]'],
                                    '0$1',
                                    1
                                ],
                                [
                                    '(\\d{3})(\\d{4})(\\d{3})',
                                    '$1 $2 $3',
                                    ['2'],
                                    '0$1',
                                    1
                                ]
                            ],
                            '0'
                        ],
                        VU: [
                            '678',
                            '00',
                            '[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}',
                            [
                                5,
                                7
                            ],
                            [[
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['[57-9]']
                                ]]
                        ],
                        WF: [
                            '681',
                            '00',
                            '(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?',
                            [
                                6,
                                9
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3',
                                    ['[478]']
                                ],
                                [
                                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                    '$1 $2 $3 $4',
                                    ['8']
                                ]
                            ]
                        ],
                        WS: [
                            '685',
                            '0',
                            '(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}',
                            [
                                5,
                                6,
                                7,
                                10
                            ],
                            [
                                [
                                    '(\\d{5})',
                                    '$1',
                                    ['[2-5]|6[1-9]']
                                ],
                                [
                                    '(\\d{3})(\\d{3,7})',
                                    '$1 $2',
                                    ['[68]']
                                ],
                                [
                                    '(\\d{2})(\\d{5})',
                                    '$1 $2',
                                    ['7']
                                ]
                            ]
                        ],
                        XK: [
                            '383',
                            '00',
                            '[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}',
                            [
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{5})',
                                    '$1 $2',
                                    ['[89]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[2-4]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[23]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        YE: [
                            '967',
                            '00',
                            '(?:1|7\\d)\\d{7}|[1-7]\\d{6}',
                            [
                                7,
                                8,
                                9
                            ],
                            [
                                [
                                    '(\\d)(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['[1-6]|7(?:[24-6]|8[0-7])'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['7'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        YT: [
                            '262',
                            '00',
                            '80\\d{7}|(?:26|63)9\\d{6}',
                            [9],
                            0,
                            '0',
                            0,
                            0,
                            0,
                            0,
                            '269|63'
                        ],
                        ZA: [
                            '27',
                            '00',
                            '[1-79]\\d{8}|8\\d{4,9}',
                            [
                                5,
                                6,
                                7,
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{3,4})',
                                    '$1 $2',
                                    ['8[1-4]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{2,3})',
                                    '$1 $2 $3',
                                    ['8[1-4]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['860'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[1-9]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['8'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        ZM: [
                            '260',
                            '00',
                            '800\\d{6}|(?:21|63|[79]\\d)\\d{7}',
                            [9],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[28]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{7})',
                                    '$1 $2',
                                    ['[79]'],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ],
                        ZW: [
                            '263',
                            '00',
                            '2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}',
                            [
                                5,
                                6,
                                7,
                                8,
                                9,
                                10
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3,5})',
                                    '$1 $2',
                                    ['2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d)(\\d{3})(\\d{2,4})',
                                    '$1 $2 $3',
                                    ['[49]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{4})',
                                    '$1 $2',
                                    ['80'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{7})',
                                    '$1 $2',
                                    [
                                        '24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2',
                                        '2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]'
                                    ],
                                    '(0$1)'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['7'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    [
                                        '2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)',
                                        '2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)'
                                    ],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{6})',
                                    '$1 $2',
                                    ['8'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3,5})',
                                    '$1 $2',
                                    ['1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{2})(\\d{3})(\\d{3,4})',
                                    '$1 $2 $3',
                                    ['29[013-9]|39|54'],
                                    '0$1'
                                ],
                                [
                                    '(\\d{4})(\\d{3,5})',
                                    '$1 $2',
                                    [
                                        '(?:25|54)8',
                                        '258|5483'
                                    ],
                                    '0$1'
                                ]
                            ],
                            '0'
                        ]
                    },
                    nonGeographic: {
                        800: [
                            '800',
                            0,
                            '(?:00|[1-9]\\d)\\d{6}',
                            [8],
                            [[
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['\\d']
                                ]],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                0,
                                0,
                                ['(?:00|[1-9]\\d)\\d{6}']
                            ]
                        ],
                        808: [
                            '808',
                            0,
                            '[1-9]\\d{7}',
                            [8],
                            [[
                                    '(\\d{4})(\\d{4})',
                                    '$1 $2',
                                    ['[1-9]']
                                ]],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                ['[1-9]\\d{7}']
                            ]
                        ],
                        870: [
                            '870',
                            0,
                            '7\\d{11}|[35-7]\\d{8}',
                            [
                                9,
                                12
                            ],
                            [[
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['[35-7]']
                                ]],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                0,
                                ['(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}']
                            ]
                        ],
                        878: [
                            '878',
                            0,
                            '10\\d{10}',
                            [12],
                            [[
                                    '(\\d{2})(\\d{5})(\\d{5})',
                                    '$1 $2 $3',
                                    ['1']
                                ]],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                ['10\\d{10}']
                            ]
                        ],
                        881: [
                            '881',
                            0,
                            '[0-36-9]\\d{8}',
                            [9],
                            [[
                                    '(\\d)(\\d{3})(\\d{5})',
                                    '$1 $2 $3',
                                    ['[0-36-9]']
                                ]],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                0,
                                ['[0-36-9]\\d{8}']
                            ]
                        ],
                        882: [
                            '882',
                            0,
                            '[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?',
                            [
                                7,
                                8,
                                9,
                                10,
                                11,
                                12
                            ],
                            [
                                [
                                    '(\\d{2})(\\d{5})',
                                    '$1 $2',
                                    ['16|342']
                                ],
                                [
                                    '(\\d{2})(\\d{6})',
                                    '$1 $2',
                                    ['49']
                                ],
                                [
                                    '(\\d{2})(\\d{2})(\\d{4})',
                                    '$1 $2 $3',
                                    ['1[36]|9']
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{3})',
                                    '$1 $2 $3',
                                    ['3[23]']
                                ],
                                [
                                    '(\\d{2})(\\d{3,4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['16']
                                ],
                                [
                                    '(\\d{2})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['10|23|3(?:[15]|4[57])|4|51']
                                ],
                                [
                                    '(\\d{3})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['34']
                                ],
                                [
                                    '(\\d{2})(\\d{4,5})(\\d{5})',
                                    '$1 $2 $3',
                                    ['[1-35]']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                0,
                                [
                                    '342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}',
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                ['1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}']
                            ]
                        ],
                        883: [
                            '883',
                            0,
                            '(?:[1-4]\\d|51)\\d{6,10}',
                            [
                                8,
                                9,
                                10,
                                11,
                                12
                            ],
                            [
                                [
                                    '(\\d{3})(\\d{3})(\\d{2,8})',
                                    '$1 $2 $3',
                                    ['[14]|2[24-689]|3[02-689]|51[24-9]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3',
                                    ['510']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{4})',
                                    '$1 $2 $3',
                                    ['21']
                                ],
                                [
                                    '(\\d{4})(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['51[13]']
                                ],
                                [
                                    '(\\d{3})(\\d{3})(\\d{3})(\\d{3})',
                                    '$1 $2 $3 $4',
                                    ['[235]']
                                ]
                            ],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                ['(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}']
                            ]
                        ],
                        888: [
                            '888',
                            0,
                            '\\d{11}',
                            [11],
                            [[
                                    '(\\d{3})(\\d{3})(\\d{5})',
                                    '$1 $2 $3'
                                ]],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                ['\\d{11}']
                            ]
                        ],
                        979: [
                            '979',
                            0,
                            '[1359]\\d{8}',
                            [9],
                            [[
                                    '(\\d)(\\d{4})(\\d{4})',
                                    '$1 $2 $3',
                                    ['[1359]']
                                ]],
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            [
                                0,
                                0,
                                0,
                                ['[1359]\\d{8}']
                            ]
                        ]
                    }
                };
                function si(e, t) {
                    var r = Array.prototype.slice.call(t);
                    return r.push(oi), e.apply(this, r);
                }
                function ci(e) {
                    return (ci = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                function ui(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function (t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function li(e, t, r) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function di(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var r = 0, n = new Array(t); r < t; r++)
                        n[r] = e[r];
                    return n;
                }
                function pi(e) {
                    var t, r, n, i, a, o = (i = Array.prototype.slice.call(e), a = 4, function (e) {
                            if (Array.isArray(e))
                                return e;
                        }(i) || function (e, t) {
                            var r = null == e ? null : 'undefined' != typeof Symbol && e[Symbol.iterator] || e['@@iterator'];
                            if (null != r) {
                                var n, i, a = [], o = !0, s = !1;
                                try {
                                    for (r = r.call(e); !(o = (n = r.next()).done) && (a.push(n.value), !t || a.length !== t); o = !0);
                                } catch (e) {
                                    s = !0, i = e;
                                } finally {
                                    try {
                                        o || null == r.return || r.return();
                                    } finally {
                                        if (s)
                                            throw i;
                                    }
                                }
                                return a;
                            }
                        }(i, a) || function (e, t) {
                            if (e) {
                                if ('string' == typeof e)
                                    return di(e, t);
                                var r = Object.prototype.toString.call(e).slice(8, -1);
                                return 'Object' === r && e.constructor && (r = e.constructor.name), 'Map' === r || 'Set' === r ? Array.from(e) : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? di(e, t) : void 0;
                            }
                        }(i, a) || function () {
                            throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                        }()), s = o[0], c = o[1], u = o[2], l = o[3];
                    if ('string' != typeof s)
                        throw new TypeError('A text for parsing must be a string.');
                    if (t = s, c && 'string' != typeof c) {
                        if (!fi(c))
                            throw new Error('Invalid second argument: '.concat(c));
                        u ? (r = c, n = u) : n = c;
                    } else
                        l ? (r = u, n = l) : (r = void 0, n = u), c && (r = function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var r = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? ui(Object(r), !0).forEach(function (t) {
                                    li(e, t, r[t]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ui(Object(r)).forEach(function (t) {
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                            }
                            return e;
                        }({ defaultCountry: c }, r));
                    return {
                        text: t,
                        options: r,
                        metadata: n
                    };
                }
                var fi = function (e) {
                        return 'object' === ci(e);
                    }, mi = ''.concat('-\u2010-\u2015\u2212ー\uFF0D').concat('\uFF0F/').concat('\uFF0E.').concat(' \xA0\xAD\u200B\u2060\u3000').concat('()\uFF08\uFF09\uFF3B\uFF3D\\[\\]').concat('~\u2053\u223C\uFF5E');
                function hi(e) {
                    return (hi = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                function gi(e, t) {
                    if (t && ('object' === hi(t) || 'function' == typeof t))
                        return t;
                    if (void 0 !== t)
                        throw new TypeError('Derived constructors may only return object or undefined');
                    return yi(e);
                }
                function yi(e) {
                    if (void 0 === e)
                        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
                    return e;
                }
                function bi(e) {
                    var t = 'function' == typeof Map ? new Map() : void 0;
                    return (bi = function (e) {
                        if (null === e || (r = e, -1 === Function.toString.call(r).indexOf('[native code]')))
                            return e;
                        var r;
                        if ('function' != typeof e)
                            throw new TypeError('Super expression must either be null or a function');
                        if (void 0 !== t) {
                            if (t.has(e))
                                return t.get(e);
                            t.set(e, n);
                        }
                        function n() {
                            return Si(e, arguments, Ai(this).constructor);
                        }
                        return n.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: n,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), Ci(n, e);
                    })(e);
                }
                function Si(e, t, r) {
                    return (Si = vi() ? Reflect.construct : function (e, t, r) {
                        var n = [null];
                        n.push.apply(n, t);
                        var i = new (Function.bind.apply(e, n))();
                        return r && Ci(i, r.prototype), i;
                    }).apply(null, arguments);
                }
                function vi() {
                    if ('undefined' == typeof Reflect || !Reflect.construct)
                        return !1;
                    if (Reflect.construct.sham)
                        return !1;
                    if ('function' == typeof Proxy)
                        return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
                        })), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function Ci(e, t) {
                    return (Ci = Object.setPrototypeOf || function (e, t) {
                        return e.__proto__ = t, e;
                    })(e, t);
                }
                function Ai(e) {
                    return (Ai = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    })(e);
                }
                var _i = function (e) {
                    !function (e, t) {
                        if ('function' != typeof t && null !== t)
                            throw new TypeError('Super expression must either be null or a function');
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, 'prototype', { writable: !1 }), t && Ci(e, t);
                    }(a, e);
                    var t, r, n, i = (t = a, r = vi(), function () {
                            var e, n = Ai(t);
                            if (r) {
                                var i = Ai(this).constructor;
                                e = Reflect.construct(n, arguments, i);
                            } else
                                e = n.apply(this, arguments);
                            return gi(this, e);
                        });
                    function a(e) {
                        var t;
                        return function (e, t) {
                            if (!(e instanceof t))
                                throw new TypeError('Cannot call a class as a function');
                        }(this, a), t = i.call(this, e), Object.setPrototypeOf(yi(t), a.prototype), t.name = t.constructor.name, t;
                    }
                    return n = a, Object.defineProperty(n, 'prototype', { writable: !1 }), n;
                }(bi(Error));
                function Ei(e, t) {
                    e = e.split('-'), t = t.split('-');
                    for (var r = e[0].split('.'), n = t[0].split('.'), i = 0; i < 3; i++) {
                        var a = Number(r[i]), o = Number(n[i]);
                        if (a > o)
                            return 1;
                        if (o > a)
                            return -1;
                        if (!isNaN(a) && isNaN(o))
                            return 1;
                        if (isNaN(a) && !isNaN(o))
                            return -1;
                    }
                    return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
                }
                function Ni(e) {
                    return (Ni = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                function Ii(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError('Cannot call a class as a function');
                }
                function Ti(e, t) {
                    for (var r = 0; r < t.length; r++) {
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                function Di(e, t, r) {
                    return t && Ti(e.prototype, t), r && Ti(e, r), Object.defineProperty(e, 'prototype', { writable: !1 }), e;
                }
                var Oi = ' ext. ', Ri = /^\d+$/, Mi = function () {
                        function e(t) {
                            Ii(this, e), function (e) {
                                if (!e)
                                    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
                                if (!ki(e) || !ki(e.countries))
                                    throw new Error('[libphonenumber-js] `metadata` argument was passed but it\'s not a valid metadata. Must be an object having `.countries` child object property. Got '.concat(ki(e) ? 'an object of shape: { ' + Object.keys(e).join(', ') + ' }' : 'a ' + Li(e) + ': ' + e, '.'));
                            }(t), this.metadata = t, ji.call(this, t);
                        }
                        return Di(e, [
                            {
                                key: 'getCountries',
                                value: function () {
                                    return Object.keys(this.metadata.countries).filter(function (e) {
                                        return '001' !== e;
                                    });
                                }
                            },
                            {
                                key: 'getCountryMetadata',
                                value: function (e) {
                                    return this.metadata.countries[e];
                                }
                            },
                            {
                                key: 'nonGeographic',
                                value: function () {
                                    if (!(this.v1 || this.v2 || this.v3))
                                        return this.metadata.nonGeographic || this.metadata.nonGeographical;
                                }
                            },
                            {
                                key: 'hasCountry',
                                value: function (e) {
                                    return void 0 !== this.getCountryMetadata(e);
                                }
                            },
                            {
                                key: 'hasCallingCode',
                                value: function (e) {
                                    if (this.getCountryCodesForCallingCode(e))
                                        return !0;
                                    if (this.nonGeographic()) {
                                        if (this.nonGeographic()[e])
                                            return !0;
                                    } else {
                                        var t = this.countryCallingCodes()[e];
                                        if (t && 1 === t.length && '001' === t[0])
                                            return !0;
                                    }
                                }
                            },
                            {
                                key: 'isNonGeographicCallingCode',
                                value: function (e) {
                                    return this.nonGeographic() ? !!this.nonGeographic()[e] : !this.getCountryCodesForCallingCode(e);
                                }
                            },
                            {
                                key: 'country',
                                value: function (e) {
                                    return this.selectNumberingPlan(e);
                                }
                            },
                            {
                                key: 'selectNumberingPlan',
                                value: function (e, t) {
                                    if (e && Ri.test(e) && (t = e, e = null), e && '001' !== e) {
                                        if (!this.hasCountry(e))
                                            throw new Error('Unknown country: '.concat(e));
                                        this.numberingPlan = new Fi(this.getCountryMetadata(e), this);
                                    } else if (t) {
                                        if (!this.hasCallingCode(t))
                                            throw new Error('Unknown calling code: '.concat(t));
                                        this.numberingPlan = new Fi(this.getNumberingPlanMetadata(t), this);
                                    } else
                                        this.numberingPlan = void 0;
                                    return this;
                                }
                            },
                            {
                                key: 'getCountryCodesForCallingCode',
                                value: function (e) {
                                    var t = this.countryCallingCodes()[e];
                                    if (t) {
                                        if (1 === t.length && 3 === t[0].length)
                                            return;
                                        return t;
                                    }
                                }
                            },
                            {
                                key: 'getCountryCodeForCallingCode',
                                value: function (e) {
                                    var t = this.getCountryCodesForCallingCode(e);
                                    if (t)
                                        return t[0];
                                }
                            },
                            {
                                key: 'getNumberingPlanMetadata',
                                value: function (e) {
                                    var t = this.getCountryCodeForCallingCode(e);
                                    if (t)
                                        return this.getCountryMetadata(t);
                                    if (this.nonGeographic()) {
                                        var r = this.nonGeographic()[e];
                                        if (r)
                                            return r;
                                    } else {
                                        var n = this.countryCallingCodes()[e];
                                        if (n && 1 === n.length && '001' === n[0])
                                            return this.metadata.countries['001'];
                                    }
                                }
                            },
                            {
                                key: 'countryCallingCode',
                                value: function () {
                                    return this.numberingPlan.callingCode();
                                }
                            },
                            {
                                key: 'IDDPrefix',
                                value: function () {
                                    return this.numberingPlan.IDDPrefix();
                                }
                            },
                            {
                                key: 'defaultIDDPrefix',
                                value: function () {
                                    return this.numberingPlan.defaultIDDPrefix();
                                }
                            },
                            {
                                key: 'nationalNumberPattern',
                                value: function () {
                                    return this.numberingPlan.nationalNumberPattern();
                                }
                            },
                            {
                                key: 'possibleLengths',
                                value: function () {
                                    return this.numberingPlan.possibleLengths();
                                }
                            },
                            {
                                key: 'formats',
                                value: function () {
                                    return this.numberingPlan.formats();
                                }
                            },
                            {
                                key: 'nationalPrefixForParsing',
                                value: function () {
                                    return this.numberingPlan.nationalPrefixForParsing();
                                }
                            },
                            {
                                key: 'nationalPrefixTransformRule',
                                value: function () {
                                    return this.numberingPlan.nationalPrefixTransformRule();
                                }
                            },
                            {
                                key: 'leadingDigits',
                                value: function () {
                                    return this.numberingPlan.leadingDigits();
                                }
                            },
                            {
                                key: 'hasTypes',
                                value: function () {
                                    return this.numberingPlan.hasTypes();
                                }
                            },
                            {
                                key: 'type',
                                value: function (e) {
                                    return this.numberingPlan.type(e);
                                }
                            },
                            {
                                key: 'ext',
                                value: function () {
                                    return this.numberingPlan.ext();
                                }
                            },
                            {
                                key: 'countryCallingCodes',
                                value: function () {
                                    return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
                                }
                            },
                            {
                                key: 'chooseCountryByCountryCallingCode',
                                value: function (e) {
                                    return this.selectNumberingPlan(e);
                                }
                            },
                            {
                                key: 'hasSelectedNumberingPlan',
                                value: function () {
                                    return void 0 !== this.numberingPlan;
                                }
                            }
                        ]), e;
                    }(), Fi = function () {
                        function e(t, r) {
                            Ii(this, e), this.globalMetadataObject = r, this.metadata = t, ji.call(this, r.metadata);
                        }
                        return Di(e, [
                            {
                                key: 'callingCode',
                                value: function () {
                                    return this.metadata[0];
                                }
                            },
                            {
                                key: 'getDefaultCountryMetadataForRegion',
                                value: function () {
                                    return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
                                }
                            },
                            {
                                key: 'IDDPrefix',
                                value: function () {
                                    if (!this.v1 && !this.v2)
                                        return this.metadata[1];
                                }
                            },
                            {
                                key: 'defaultIDDPrefix',
                                value: function () {
                                    if (!this.v1 && !this.v2)
                                        return this.metadata[12];
                                }
                            },
                            {
                                key: 'nationalNumberPattern',
                                value: function () {
                                    return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
                                }
                            },
                            {
                                key: 'possibleLengths',
                                value: function () {
                                    if (!this.v1)
                                        return this.metadata[this.v2 ? 2 : 3];
                                }
                            },
                            {
                                key: '_getFormats',
                                value: function (e) {
                                    return e[this.v1 ? 2 : this.v2 ? 3 : 4];
                                }
                            },
                            {
                                key: 'formats',
                                value: function () {
                                    var e = this;
                                    return (this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || []).map(function (t) {
                                        return new Pi(t, e);
                                    });
                                }
                            },
                            {
                                key: 'nationalPrefix',
                                value: function () {
                                    return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
                                }
                            },
                            {
                                key: '_getNationalPrefixFormattingRule',
                                value: function (e) {
                                    return e[this.v1 ? 4 : this.v2 ? 5 : 6];
                                }
                            },
                            {
                                key: 'nationalPrefixFormattingRule',
                                value: function () {
                                    return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
                                }
                            },
                            {
                                key: '_nationalPrefixForParsing',
                                value: function () {
                                    return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
                                }
                            },
                            {
                                key: 'nationalPrefixForParsing',
                                value: function () {
                                    return this._nationalPrefixForParsing() || this.nationalPrefix();
                                }
                            },
                            {
                                key: 'nationalPrefixTransformRule',
                                value: function () {
                                    return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
                                }
                            },
                            {
                                key: '_getNationalPrefixIsOptionalWhenFormatting',
                                value: function () {
                                    return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
                                }
                            },
                            {
                                key: 'nationalPrefixIsOptionalWhenFormattingInNationalFormat',
                                value: function () {
                                    return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
                                }
                            },
                            {
                                key: 'leadingDigits',
                                value: function () {
                                    return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
                                }
                            },
                            {
                                key: 'types',
                                value: function () {
                                    return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
                                }
                            },
                            {
                                key: 'hasTypes',
                                value: function () {
                                    return !(this.types() && 0 === this.types().length || !this.types());
                                }
                            },
                            {
                                key: 'type',
                                value: function (e) {
                                    if (this.hasTypes() && Bi(this.types(), e))
                                        return new wi(Bi(this.types(), e), this);
                                }
                            },
                            {
                                key: 'ext',
                                value: function () {
                                    return this.v1 || this.v2 ? Oi : this.metadata[13] || Oi;
                                }
                            }
                        ]), e;
                    }(), Pi = function () {
                        function e(t, r) {
                            Ii(this, e), this._format = t, this.metadata = r;
                        }
                        return Di(e, [
                            {
                                key: 'pattern',
                                value: function () {
                                    return this._format[0];
                                }
                            },
                            {
                                key: 'format',
                                value: function () {
                                    return this._format[1];
                                }
                            },
                            {
                                key: 'leadingDigitsPatterns',
                                value: function () {
                                    return this._format[2] || [];
                                }
                            },
                            {
                                key: 'nationalPrefixFormattingRule',
                                value: function () {
                                    return this._format[3] || this.metadata.nationalPrefixFormattingRule();
                                }
                            },
                            {
                                key: 'nationalPrefixIsOptionalWhenFormattingInNationalFormat',
                                value: function () {
                                    return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
                                }
                            },
                            {
                                key: 'nationalPrefixIsMandatoryWhenFormattingInNationalFormat',
                                value: function () {
                                    return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
                                }
                            },
                            {
                                key: 'usesNationalPrefix',
                                value: function () {
                                    return !(!this.nationalPrefixFormattingRule() || xi.test(this.nationalPrefixFormattingRule()));
                                }
                            },
                            {
                                key: 'internationalFormat',
                                value: function () {
                                    return this._format[5] || this.format();
                                }
                            }
                        ]), e;
                    }(), xi = /^\(?\$1\)?$/, wi = function () {
                        function e(t, r) {
                            Ii(this, e), this.type = t, this.metadata = r;
                        }
                        return Di(e, [
                            {
                                key: 'pattern',
                                value: function () {
                                    return this.metadata.v1 ? this.type : this.type[0];
                                }
                            },
                            {
                                key: 'possibleLengths',
                                value: function () {
                                    if (!this.metadata.v1)
                                        return this.type[1] || this.metadata.possibleLengths();
                                }
                            }
                        ]), e;
                    }();
                function Bi(e, t) {
                    switch (t) {
                    case 'FIXED_LINE':
                        return e[0];
                    case 'MOBILE':
                        return e[1];
                    case 'TOLL_FREE':
                        return e[2];
                    case 'PREMIUM_RATE':
                        return e[3];
                    case 'PERSONAL_NUMBER':
                        return e[4];
                    case 'VOICEMAIL':
                        return e[5];
                    case 'UAN':
                        return e[6];
                    case 'PAGER':
                        return e[7];
                    case 'VOIP':
                        return e[8];
                    case 'SHARED_COST':
                        return e[9];
                    }
                }
                var ki = function (e) {
                        return 'object' === Ni(e);
                    }, Li = function (e) {
                        return Ni(e);
                    };
                function $i(e, t) {
                    if ((t = new Mi(t)).hasCountry(e))
                        return t.country(e).countryCallingCode();
                    throw new Error('Unknown country: '.concat(e));
                }
                function ji(e) {
                    var t = e.version;
                    'number' == typeof t ? (this.v1 = 1 === t, this.v2 = 2 === t, this.v3 = 3 === t, this.v4 = 4 === t) : t ? -1 === Ei(t, '1.2.0') ? this.v2 = !0 : -1 === Ei(t, '1.7.35') ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
                }
                var Gi = function (e) {
                    return '(['.concat('0-9０-９٠-٩۰-۹', ']{1,').concat(e, '})');
                };
                function Vi(e) {
                    var t = '#?';
                    return ';ext=' + Gi('20') + '|[ \xA0\\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.\uFF0E]?[ \xA0\\t,-]*' + Gi('20') + '#?|[ \xA0\\t,]*(?:[xｘ#\uFF03~\uFF5E]|int|ｉｎｔ)[:\\.\uFF0E]?[ \xA0\\t,-]*' + Gi('9') + '#?|[- ]+' + Gi('6') + '#|[ \xA0\\t]*(?:,{2}|;)[:\\.\uFF0E]?[ \xA0\\t,-]*' + Gi('15') + '#?|[ \xA0\\t]*(?:,)+[:\\.\uFF0E]?[ \xA0\\t,-]*' + Gi('9') + t;
                }
                var Ui = '[+\uFF0B]{0,1}(?:[' + mi + ']*[0-9０-９٠-٩۰-۹]){3,}[' + mi + '0-9０-９٠-٩۰-۹]*', Hi = new RegExp('^[+\uFF0B]{0,1}(?:[' + mi + ']*[0-9０-９٠-٩۰-۹]){1,2}$', 'i'), Wi = Ui + '(?:' + Vi() + ')?', Ki = new RegExp('^[0-9０-９٠-٩۰-۹]{2}$|^' + Wi + '$', 'i');
                function zi(e) {
                    return e.length >= 2 && Ki.test(e);
                }
                var Xi = new RegExp('(?:' + Vi() + ')$', 'i'), Yi = {
                        0: '0',
                        1: '1',
                        2: '2',
                        3: '3',
                        4: '4',
                        5: '5',
                        6: '6',
                        7: '7',
                        8: '8',
                        9: '9',
                        '０': '0',
                        '１': '1',
                        '２': '2',
                        '３': '3',
                        '４': '4',
                        '５': '5',
                        '６': '6',
                        '７': '7',
                        '８': '8',
                        '９': '9',
                        '٠': '0',
                        '١': '1',
                        '٢': '2',
                        '٣': '3',
                        '٤': '4',
                        '٥': '5',
                        '٦': '6',
                        '٧': '7',
                        '٨': '8',
                        '٩': '9',
                        '۰': '0',
                        '۱': '1',
                        '۲': '2',
                        '۳': '3',
                        '۴': '4',
                        '۵': '5',
                        '۶': '6',
                        '۷': '7',
                        '۸': '8',
                        '۹': '9'
                    };
                function qi(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var r = 0, n = new Array(t); r < t; r++)
                        n[r] = e[r];
                    return n;
                }
                function Zi(e) {
                    for (var t, r = '', n = function (e, t) {
                                var r = 'undefined' != typeof Symbol && e[Symbol.iterator] || e['@@iterator'];
                                if (r)
                                    return (r = r.call(e)).next.bind(r);
                                if (Array.isArray(e) || (r = function (e, t) {
                                        if (e) {
                                            if ('string' == typeof e)
                                                return qi(e, t);
                                            var r = Object.prototype.toString.call(e).slice(8, -1);
                                            return 'Object' === r && e.constructor && (r = e.constructor.name), 'Map' === r || 'Set' === r ? Array.from(e) : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? qi(e, t) : void 0;
                                        }
                                    }(e)) || t && e && 'number' == typeof e.length) {
                                    r && (e = r);
                                    var n = 0;
                                    return function () {
                                        return n >= e.length ? { done: !0 } : {
                                            done: !1,
                                            value: e[n++]
                                        };
                                    };
                                }
                                throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                            }(e.split('')); !(t = n()).done;)
                        r += Ji(t.value, r) || '';
                    return r;
                }
                function Ji(e, t) {
                    if ('+' === e) {
                        if (t)
                            return;
                        return '+';
                    }
                    return function (e) {
                        return Yi[e];
                    }(e);
                }
                function Qi(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var r = 0, n = new Array(t); r < t; r++)
                        n[r] = e[r];
                    return n;
                }
                function ea(e, t) {
                    return ta(e, void 0, t);
                }
                function ta(e, t, r) {
                    var n = r.type(t), i = n && n.possibleLengths() || r.possibleLengths();
                    if (!i)
                        return 'IS_POSSIBLE';
                    if ('FIXED_LINE_OR_MOBILE' === t) {
                        if (!r.type('FIXED_LINE'))
                            return ta(e, 'MOBILE', r);
                        var a = r.type('MOBILE');
                        a && (i = function (e, t) {
                            for (var r, n = e.slice(), i = function (e, t) {
                                        var r = 'undefined' != typeof Symbol && e[Symbol.iterator] || e['@@iterator'];
                                        if (r)
                                            return (r = r.call(e)).next.bind(r);
                                        if (Array.isArray(e) || (r = function (e, t) {
                                                if (e) {
                                                    if ('string' == typeof e)
                                                        return Qi(e, t);
                                                    var r = Object.prototype.toString.call(e).slice(8, -1);
                                                    return 'Object' === r && e.constructor && (r = e.constructor.name), 'Map' === r || 'Set' === r ? Array.from(e) : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Qi(e, t) : void 0;
                                                }
                                            }(e)) || t && e && 'number' == typeof e.length) {
                                            r && (e = r);
                                            var n = 0;
                                            return function () {
                                                return n >= e.length ? { done: !0 } : {
                                                    done: !1,
                                                    value: e[n++]
                                                };
                                            };
                                        }
                                        throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                                    }(t); !(r = i()).done;) {
                                var a = r.value;
                                e.indexOf(a) < 0 && n.push(a);
                            }
                            return n.sort(function (e, t) {
                                return e - t;
                            });
                        }(i, a.possibleLengths()));
                    } else if (t && !n)
                        return 'INVALID_LENGTH';
                    var o = e.length, s = i[0];
                    return s === o ? 'IS_POSSIBLE' : s > o ? 'TOO_SHORT' : i[i.length - 1] < o ? 'TOO_LONG' : i.indexOf(o, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
                }
                function ra(e, t) {
                    switch (ea(e, t)) {
                    case 'IS_POSSIBLE':
                        return !0;
                    default:
                        return !1;
                    }
                }
                function na(e, t) {
                    if (e) {
                        if ('string' == typeof e)
                            return ia(e, t);
                        var r = Object.prototype.toString.call(e).slice(8, -1);
                        return 'Object' === r && e.constructor && (r = e.constructor.name), 'Map' === r || 'Set' === r ? Array.from(e) : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ia(e, t) : void 0;
                    }
                }
                function ia(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var r = 0, n = new Array(t); r < t; r++)
                        n[r] = e[r];
                    return n;
                }
                function aa(e, t) {
                    return e = e || '', new RegExp('^(?:' + t + ')$').test(e);
                }
                function oa(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var r = 0, n = new Array(t); r < t; r++)
                        n[r] = e[r];
                    return n;
                }
                var sa = [
                    'MOBILE',
                    'PREMIUM_RATE',
                    'TOLL_FREE',
                    'SHARED_COST',
                    'VOIP',
                    'PERSONAL_NUMBER',
                    'PAGER',
                    'UAN',
                    'VOICEMAIL'
                ];
                function ca(e, t, r) {
                    if (t = t || {}, e.country) {
                        (r = new Mi(r)).selectNumberingPlan(e.country, e.countryCallingCode);
                        var n = t.v2 ? e.nationalNumber : e.phone;
                        if (aa(n, r.nationalNumberPattern())) {
                            if (ua(n, 'FIXED_LINE', r))
                                return r.type('MOBILE') && '' === r.type('MOBILE').pattern() ? 'FIXED_LINE_OR_MOBILE' : r.type('MOBILE') ? ua(n, 'MOBILE', r) ? 'FIXED_LINE_OR_MOBILE' : 'FIXED_LINE' : 'FIXED_LINE_OR_MOBILE';
                            for (var i, a = function (e, t) {
                                        var r = 'undefined' != typeof Symbol && e[Symbol.iterator] || e['@@iterator'];
                                        if (r)
                                            return (r = r.call(e)).next.bind(r);
                                        if (Array.isArray(e) || (r = function (e, t) {
                                                if (e) {
                                                    if ('string' == typeof e)
                                                        return oa(e, t);
                                                    var r = Object.prototype.toString.call(e).slice(8, -1);
                                                    return 'Object' === r && e.constructor && (r = e.constructor.name), 'Map' === r || 'Set' === r ? Array.from(e) : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? oa(e, t) : void 0;
                                                }
                                            }(e)) || t && e && 'number' == typeof e.length) {
                                            r && (e = r);
                                            var n = 0;
                                            return function () {
                                                return n >= e.length ? { done: !0 } : {
                                                    done: !1,
                                                    value: e[n++]
                                                };
                                            };
                                        }
                                        throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                                    }(sa); !(i = a()).done;) {
                                var o = i.value;
                                if (ua(n, o, r))
                                    return o;
                            }
                        }
                    }
                }
                function ua(e, t, r) {
                    return !(!(t = r.type(t)) || !t.pattern()) && !(t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0) && aa(e, t.pattern());
                }
                var la = /(\$\d)/;
                var da = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
                function pa(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var r = 0, n = new Array(t); r < t; r++)
                        n[r] = e[r];
                    return n;
                }
                function fa(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function (t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function ma(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? fa(Object(r), !0).forEach(function (t) {
                            ha(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fa(Object(r)).forEach(function (t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function ha(e, t, r) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                var ga = {
                    formatExtension: function (e, t, r) {
                        return ''.concat(e).concat(r.ext()).concat(t);
                    }
                };
                function ya(e, t, r, n, i) {
                    var a = function (e, t) {
                        for (var r, n = function (e, t) {
                                    var r = 'undefined' != typeof Symbol && e[Symbol.iterator] || e['@@iterator'];
                                    if (r)
                                        return (r = r.call(e)).next.bind(r);
                                    if (Array.isArray(e) || (r = function (e, t) {
                                            if (e) {
                                                if ('string' == typeof e)
                                                    return pa(e, t);
                                                var r = Object.prototype.toString.call(e).slice(8, -1);
                                                return 'Object' === r && e.constructor && (r = e.constructor.name), 'Map' === r || 'Set' === r ? Array.from(e) : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? pa(e, t) : void 0;
                                            }
                                        }(e)) || t && e && 'number' == typeof e.length) {
                                        r && (e = r);
                                        var n = 0;
                                        return function () {
                                            return n >= e.length ? { done: !0 } : {
                                                done: !1,
                                                value: e[n++]
                                            };
                                        };
                                    }
                                    throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                                }(e); !(r = n()).done;) {
                            var i = r.value;
                            if (i.leadingDigitsPatterns().length > 0) {
                                var a = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
                                if (0 !== t.search(a))
                                    continue;
                            }
                            if (aa(t, i.pattern()))
                                return i;
                        }
                    }(n.formats(), e);
                    return a ? function (e, t, r) {
                        var n = r.useInternationalFormat, i = r.withNationalPrefix, a = (r.carrierCode, r.metadata, e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : i && t.nationalPrefixFormattingRule() ? t.format().replace(la, t.nationalPrefixFormattingRule()) : t.format()));
                        return n ? function (e) {
                            return e.replace(new RegExp('['.concat(mi, ']+'), 'g'), ' ').trim();
                        }(a) : a;
                    }(e, a, {
                        useInternationalFormat: 'INTERNATIONAL' === r,
                        withNationalPrefix: !a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !i || !1 !== i.nationalPrefix,
                        carrierCode: t,
                        metadata: n
                    }) : e;
                }
                function ba(e, t, r, n) {
                    return t ? n(e, t, r) : e;
                }
                function Sa(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function (t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function va(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Sa(Object(r), !0).forEach(function (t) {
                            Ca(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sa(Object(r)).forEach(function (t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function Ca(e, t, r) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function Aa(e, t) {
                    for (var r = 0; r < t.length; r++) {
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                var _a = function () {
                        function e(t, r, n) {
                            if (function (e, t) {
                                    if (!(e instanceof t))
                                        throw new TypeError('Cannot call a class as a function');
                                }(this, e), !t)
                                throw new TypeError('`country` or `countryCallingCode` not passed');
                            if (!r)
                                throw new TypeError('`nationalNumber` not passed');
                            if (!n)
                                throw new TypeError('`metadata` not passed');
                            var i = new Mi(n);
                            Ea(t) && (this.country = t, i.country(t), t = i.countryCallingCode()), this.countryCallingCode = t, this.nationalNumber = r, this.number = '+' + this.countryCallingCode + this.nationalNumber, this.metadata = n;
                        }
                        var t, r;
                        return t = e, (r = [
                            {
                                key: 'setExt',
                                value: function (e) {
                                    this.ext = e;
                                }
                            },
                            {
                                key: 'getPossibleCountries',
                                value: function () {
                                    return this.country ? [this.country] : (e = this.countryCallingCode, t = this.nationalNumber, r = this.metadata, (n = new Mi(r).getCountryCodesForCallingCode(e)) ? n.filter(function (e) {
                                        return function (e, t, r) {
                                            var n = new Mi(r);
                                            return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
                                        }(t, e, r);
                                    }) : []);
                                    var e, t, r, n;
                                }
                            },
                            {
                                key: 'isPossible',
                                value: function () {
                                    return function (e, t, r) {
                                        if (void 0 === t && (t = {}), r = new Mi(r), t.v2) {
                                            if (!e.countryCallingCode)
                                                throw new Error('Invalid phone number object passed');
                                            r.selectNumberingPlan(e.countryCallingCode);
                                        } else {
                                            if (!e.phone)
                                                return !1;
                                            if (e.country) {
                                                if (!r.hasCountry(e.country))
                                                    throw new Error('Unknown country: '.concat(e.country));
                                                r.country(e.country);
                                            } else {
                                                if (!e.countryCallingCode)
                                                    throw new Error('Invalid phone number object passed');
                                                r.selectNumberingPlan(e.countryCallingCode);
                                            }
                                        }
                                        if (r.possibleLengths())
                                            return ra(e.phone || e.nationalNumber, r);
                                        if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
                                            return !0;
                                        throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
                                    }(this, { v2: !0 }, this.metadata);
                                }
                            },
                            {
                                key: 'isValid',
                                value: function () {
                                    return e = this, t = { v2: !0 }, r = this.metadata, t = t || {}, r = new Mi(r), !!e.country && (r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes() ? void 0 !== ca(e, t, r.metadata) : aa(t.v2 ? e.nationalNumber : e.phone, r.nationalNumberPattern()));
                                    var e, t, r;
                                }
                            },
                            {
                                key: 'isNonGeographic',
                                value: function () {
                                    return new Mi(this.metadata).isNonGeographicCallingCode(this.countryCallingCode);
                                }
                            },
                            {
                                key: 'isEqual',
                                value: function (e) {
                                    return this.number === e.number && this.ext === e.ext;
                                }
                            },
                            {
                                key: 'getType',
                                value: function () {
                                    return ca(this, { v2: !0 }, this.metadata);
                                }
                            },
                            {
                                key: 'format',
                                value: function (e, t) {
                                    return function (e, t, r, n) {
                                        if (r = r ? ma(ma({}, ga), r) : ga, n = new Mi(n), e.country && '001' !== e.country) {
                                            if (!n.hasCountry(e.country))
                                                throw new Error('Unknown country: '.concat(e.country));
                                            n.country(e.country);
                                        } else {
                                            if (!e.countryCallingCode)
                                                return e.phone || '';
                                            n.selectNumberingPlan(e.countryCallingCode);
                                        }
                                        var i, a = n.countryCallingCode(), o = r.v2 ? e.nationalNumber : e.phone;
                                        switch (t) {
                                        case 'NATIONAL':
                                            return o ? ba(i = ya(o, e.carrierCode, 'NATIONAL', n, r), e.ext, n, r.formatExtension) : '';
                                        case 'INTERNATIONAL':
                                            return o ? (i = ya(o, null, 'INTERNATIONAL', n, r), ba(i = '+'.concat(a, ' ').concat(i), e.ext, n, r.formatExtension)) : '+'.concat(a);
                                        case 'E.164':
                                            return '+'.concat(a).concat(o);
                                        case 'RFC3966':
                                            return function (e) {
                                                var t = e.number, r = e.ext;
                                                if (!t)
                                                    return '';
                                                if ('+' !== t[0])
                                                    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
                                                return 'tel:'.concat(t).concat(r ? ';ext=' + r : '');
                                            }({
                                                number: '+'.concat(a).concat(o),
                                                ext: e.ext
                                            });
                                        case 'IDD':
                                            if (!r.fromCountry)
                                                return;
                                            return ba(function (e, t, r, n, i) {
                                                if ($i(n, i.metadata) === r) {
                                                    var a = ya(e, t, 'NATIONAL', i);
                                                    return '1' === r ? r + ' ' + a : a;
                                                }
                                                var o = function (e, t, r) {
                                                    var n = new Mi(r);
                                                    return n.selectNumberingPlan(e, void 0), n.defaultIDDPrefix() ? n.defaultIDDPrefix() : da.test(n.IDDPrefix()) ? n.IDDPrefix() : void 0;
                                                }(n, 0, i.metadata);
                                                if (o)
                                                    return ''.concat(o, ' ').concat(r, ' ').concat(ya(e, null, 'INTERNATIONAL', i));
                                            }(o, e.carrierCode, a, r.fromCountry, n), e.ext, n, r.formatExtension);
                                        default:
                                            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
                                        }
                                    }(this, e, t ? va(va({}, t), {}, { v2: !0 }) : { v2: !0 }, this.metadata);
                                }
                            },
                            {
                                key: 'formatNational',
                                value: function (e) {
                                    return this.format('NATIONAL', e);
                                }
                            },
                            {
                                key: 'formatInternational',
                                value: function (e) {
                                    return this.format('INTERNATIONAL', e);
                                }
                            },
                            {
                                key: 'getURI',
                                value: function (e) {
                                    return this.format('RFC3966', e);
                                }
                            }
                        ]) && Aa(t.prototype, r), Object.defineProperty(t, 'prototype', { writable: !1 }), e;
                    }(), Ea = function (e) {
                        return /^[A-Z]{2}$/.test(e);
                    }, Na = new RegExp('([0-9０-９٠-٩۰-۹])');
                function Ia(e, t) {
                    var r = function (e, t) {
                            if (e && t.numberingPlan.nationalPrefixForParsing()) {
                                var r = new RegExp('^(?:' + t.numberingPlan.nationalPrefixForParsing() + ')'), n = r.exec(e);
                                if (n) {
                                    var i, a, o, s = n.length - 1, c = s > 0 && n[s];
                                    if (t.nationalPrefixTransformRule() && c)
                                        i = e.replace(r, t.nationalPrefixTransformRule()), s > 1 && (a = n[1]);
                                    else {
                                        var u = n[0];
                                        i = e.slice(u.length), c && (a = n[1]);
                                    }
                                    if (c) {
                                        var l = e.indexOf(n[1]);
                                        e.slice(0, l) === t.numberingPlan.nationalPrefix() && (o = t.numberingPlan.nationalPrefix());
                                    } else
                                        o = n[0];
                                    return {
                                        nationalNumber: i,
                                        nationalPrefix: o,
                                        carrierCode: a
                                    };
                                }
                            }
                            return { nationalNumber: e };
                        }(e, t), n = r.carrierCode, i = r.nationalNumber;
                    if (i !== e) {
                        if (!function (e, t, r) {
                                return !(aa(e, r.nationalNumberPattern()) && !aa(t, r.nationalNumberPattern()));
                            }(e, i, t))
                            return { nationalNumber: e };
                        if (t.possibleLengths() && !function (e, t) {
                                switch (ea(e, t)) {
                                case 'TOO_SHORT':
                                case 'INVALID_LENGTH':
                                    return !1;
                                default:
                                    return !0;
                                }
                            }(i, t))
                            return { nationalNumber: e };
                    }
                    return {
                        nationalNumber: i,
                        carrierCode: n
                    };
                }
                function Ta(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var r = 0, n = new Array(t); r < t; r++)
                        n[r] = e[r];
                    return n;
                }
                function Da(e, t, r) {
                    var n = r.getCountryCodesForCallingCode(e);
                    if (n)
                        return 1 === n.length ? n[0] : function (e, t, r) {
                            r = new Mi(r);
                            for (var n, i = function (e, t) {
                                        var r = 'undefined' != typeof Symbol && e[Symbol.iterator] || e['@@iterator'];
                                        if (r)
                                            return (r = r.call(e)).next.bind(r);
                                        if (Array.isArray(e) || (r = function (e, t) {
                                                if (e) {
                                                    if ('string' == typeof e)
                                                        return Ta(e, t);
                                                    var r = Object.prototype.toString.call(e).slice(8, -1);
                                                    return 'Object' === r && e.constructor && (r = e.constructor.name), 'Map' === r || 'Set' === r ? Array.from(e) : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ta(e, t) : void 0;
                                                }
                                            }(e)) || t && e && 'number' == typeof e.length) {
                                            r && (e = r);
                                            var n = 0;
                                            return function () {
                                                return n >= e.length ? { done: !0 } : {
                                                    done: !1,
                                                    value: e[n++]
                                                };
                                            };
                                        }
                                        throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                                    }(e); !(n = i()).done;) {
                                var a = n.value;
                                if (r.country(a), r.leadingDigits()) {
                                    if (t && 0 === t.search(r.leadingDigits()))
                                        return a;
                                } else if (ca({
                                        phone: t,
                                        country: a
                                    }, void 0, r.metadata))
                                    return a;
                            }
                        }(n, t, r.metadata);
                }
                var Oa = new RegExp('[+\uFF0B0-9０-９٠-٩۰-۹]'), Ra = new RegExp('[^0-9０-９٠-٩۰-۹#]+$');
                function Ma(e, t, r) {
                    if (t = t || {}, r = new Mi(r), t.defaultCountry && !r.hasCountry(t.defaultCountry)) {
                        if (t.v2)
                            throw new _i('INVALID_COUNTRY');
                        throw new Error('Unknown country: '.concat(t.defaultCountry));
                    }
                    var n = function (e, t, r) {
                            if (e && 0 === e.indexOf('tel:'))
                                return function (e) {
                                    for (var t, r, n, i = function (e, t) {
                                                var r = 'undefined' != typeof Symbol && e[Symbol.iterator] || e['@@iterator'];
                                                if (r)
                                                    return (r = r.call(e)).next.bind(r);
                                                if (Array.isArray(e) || (r = na(e))) {
                                                    r && (e = r);
                                                    var n = 0;
                                                    return function () {
                                                        return n >= e.length ? { done: !0 } : {
                                                            done: !1,
                                                            value: e[n++]
                                                        };
                                                    };
                                                }
                                                throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                                            }((e = e.replace(/^tel:/, 'tel=')).split(';')); !(n = i()).done;) {
                                        var a = (u = 2, function (e) {
                                                if (Array.isArray(e))
                                                    return e;
                                            }(c = n.value.split('=')) || function (e, t) {
                                                var r = null == e ? null : 'undefined' != typeof Symbol && e[Symbol.iterator] || e['@@iterator'];
                                                if (null != r) {
                                                    var n, i, a = [], o = !0, s = !1;
                                                    try {
                                                        for (r = r.call(e); !(o = (n = r.next()).done) && (a.push(n.value), !t || a.length !== t); o = !0);
                                                    } catch (e) {
                                                        s = !0, i = e;
                                                    } finally {
                                                        try {
                                                            o || null == r.return || r.return();
                                                        } finally {
                                                            if (s)
                                                                throw i;
                                                        }
                                                    }
                                                    return a;
                                                }
                                            }(c, u) || na(c, u) || function () {
                                                throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                                            }()), o = a[0], s = a[1];
                                        switch (o) {
                                        case 'tel':
                                            t = s;
                                            break;
                                        case 'ext':
                                            r = s;
                                            break;
                                        case 'phone-context':
                                            '+' === s[0] && (t = s + t);
                                        }
                                    }
                                    var c, u;
                                    if (!zi(t))
                                        return {};
                                    var l = { number: t };
                                    return r && (l.ext = r), l;
                                }(e);
                            var n = function (e, t, r) {
                                if (e)
                                    if (e.length > 250) {
                                        if (r)
                                            throw new _i('TOO_LONG');
                                    } else {
                                        if (!1 === t)
                                            return e;
                                        var n = e.search(Oa);
                                        if (!(n < 0))
                                            return e.slice(n).replace(Ra, '');
                                    }
                            }(e, r, t);
                            if (!n)
                                return {};
                            if (!zi(n))
                                return function (e) {
                                    return Hi.test(e);
                                }(n) ? { error: 'TOO_SHORT' } : {};
                            var i = function (e) {
                                var t = e.search(Xi);
                                if (t < 0)
                                    return {};
                                for (var r = e.slice(0, t), n = e.match(Xi), i = 1; i < n.length;) {
                                    if (n[i])
                                        return {
                                            number: r,
                                            ext: n[i]
                                        };
                                    i++;
                                }
                            }(n);
                            return i.ext ? i : { number: n };
                        }(e, t.v2, t.extract), i = n.number, a = n.ext, o = n.error;
                    if (!i) {
                        if (t.v2) {
                            if ('TOO_SHORT' === o)
                                throw new _i('TOO_SHORT');
                            throw new _i('NOT_A_NUMBER');
                        }
                        return {};
                    }
                    var s = function (e, t, r, n) {
                            var i, a = function (e, t, r, n) {
                                    if (!e)
                                        return {};
                                    if ('+' !== e[0]) {
                                        var i = function (e, t, r, n) {
                                            if (t) {
                                                var i = new Mi(n);
                                                i.selectNumberingPlan(t, r);
                                                var a = new RegExp(i.IDDPrefix());
                                                if (0 === e.search(a)) {
                                                    var o = (e = e.slice(e.match(a)[0].length)).match(Na);
                                                    if (!(o && null != o[1] && o[1].length > 0 && '0' === o[1]))
                                                        return e;
                                                }
                                            }
                                        }(e, t, r, n);
                                        if (!i || i === e) {
                                            if (t || r) {
                                                var a = function (e, t, r, n) {
                                                        var i = t ? $i(t, n) : r;
                                                        if (0 === e.indexOf(i)) {
                                                            (n = new Mi(n)).selectNumberingPlan(t, r);
                                                            var a = e.slice(i.length), o = Ia(a, n).nationalNumber, s = Ia(e, n).nationalNumber;
                                                            if (!aa(s, n.nationalNumberPattern()) && aa(o, n.nationalNumberPattern()) || 'TOO_LONG' === ea(s, n))
                                                                return {
                                                                    countryCallingCode: i,
                                                                    number: a
                                                                };
                                                        }
                                                        return { number: e };
                                                    }(e, t, r, n), o = a.countryCallingCode, s = a.number;
                                                if (o)
                                                    return {
                                                        countryCallingCode: o,
                                                        number: s
                                                    };
                                            }
                                            return { number: e };
                                        }
                                        e = '+' + i;
                                    }
                                    if ('0' === e[1])
                                        return {};
                                    n = new Mi(n);
                                    for (var c = 2; c - 1 <= 3 && c <= e.length;) {
                                        var u = e.slice(1, c);
                                        if (n.hasCallingCode(u))
                                            return n.selectNumberingPlan(u), {
                                                countryCallingCode: u,
                                                number: e.slice(c)
                                            };
                                        c++;
                                    }
                                    return {};
                                }(Zi(e), t, r, n.metadata), o = a.countryCallingCode, s = a.number;
                            if (o)
                                n.selectNumberingPlan(o);
                            else {
                                if (!s || !t && !r)
                                    return {};
                                n.selectNumberingPlan(t, r), t && (i = t), o = r || $i(t, n.metadata);
                            }
                            if (!s)
                                return { countryCallingCode: o };
                            var c = Ia(Zi(s), n), u = c.nationalNumber, l = c.carrierCode, d = Da(o, u, n);
                            return d && (i = d, '001' === d || n.country(i)), {
                                country: i,
                                countryCallingCode: o,
                                nationalNumber: u,
                                carrierCode: l
                            };
                        }(i, t.defaultCountry, t.defaultCallingCode, r), c = s.country, u = s.nationalNumber, l = s.countryCallingCode, d = s.carrierCode;
                    if (!r.hasSelectedNumberingPlan()) {
                        if (t.v2)
                            throw new _i('INVALID_COUNTRY');
                        return {};
                    }
                    if (!u || u.length < 2) {
                        if (t.v2)
                            throw new _i('TOO_SHORT');
                        return {};
                    }
                    if (u.length > 17) {
                        if (t.v2)
                            throw new _i('TOO_LONG');
                        return {};
                    }
                    if (t.v2) {
                        var p = new _a(l, u, r.metadata);
                        return c && (p.country = c), d && (p.carrierCode = d), a && (p.ext = a), p;
                    }
                    var f = !!(t.extended ? r.hasSelectedNumberingPlan() : c) && aa(u, r.nationalNumberPattern());
                    return t.extended ? {
                        country: c,
                        countryCallingCode: l,
                        carrierCode: d,
                        valid: f,
                        possible: !!f || !(!0 !== t.extended || !r.possibleLengths() || !ra(u, r)),
                        phone: u,
                        ext: a
                    } : f ? function (e, t, r) {
                        var n = {
                            country: e,
                            phone: t
                        };
                        return r && (n.ext = r), n;
                    }(c, u, a) : {};
                }
                function Fa(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function (t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function Pa(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Fa(Object(r), !0).forEach(function (t) {
                            xa(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fa(Object(r)).forEach(function (t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function xa(e, t, r) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function wa(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function (t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function Ba(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? wa(Object(r), !0).forEach(function (t) {
                            ka(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wa(Object(r)).forEach(function (t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function ka(e, t, r) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function La(e, t, r) {
                    t && t.defaultCountry && !function (e, t) {
                        return void 0 !== t.countries[e];
                    }(t.defaultCountry, r) && (t = Ba(Ba({}, t), {}, { defaultCountry: void 0 }));
                    try {
                        return function (e, t, r) {
                            return Ma(e, Pa(Pa({}, t), {}, { v2: !0 }), r);
                        }(e, t, r);
                    } catch (e) {
                        if (!(e instanceof _i))
                            throw e;
                    }
                }
                function $a() {
                    var e = pi(arguments), t = e.text, r = e.options, n = e.metadata;
                    return La(t, r, n);
                }
                var ja = 'isPhoneNumber';
                function Ga(e, t) {
                    try {
                        var r = function () {
                            return si($a, arguments);
                        }(e, t);
                        return !!(null == r ? void 0 : r.isValid());
                    } catch (e) {
                        return !1;
                    }
                }
                function Va(e, t) {
                    return N({
                        name: ja,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Ga(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a valid phone number';
                            }, t)
                        }
                    }, t);
                }
                var Ua = 'isMilitaryTime';
                function Ha(e) {
                    return 'string' == typeof e && ri()(e, /^([01]\d|2[0-3]):?([0-5]\d)$/);
                }
                function Wa(e) {
                    return N({
                        name: Ua,
                        validator: {
                            validate: function (e, t) {
                                return Ha(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a valid representation of military time in the format HH:MM';
                            }, e)
                        }
                    }, e);
                }
                var Ka = r(7156), za = r.n(Ka), Xa = 'isHash';
                function Ya(e, t) {
                    return 'string' == typeof e && za()(e, t);
                }
                function qa(e, t) {
                    return N({
                        name: Xa,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Ya(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a hash of type $constraint1';
                            }, t)
                        }
                    }, t);
                }
                var Za = r(9887), Ja = r.n(Za), Qa = 'isISSN';
                function eo(e, t) {
                    return 'string' == typeof e && Ja()(e, t);
                }
                function to(e, t) {
                    return N({
                        name: Qa,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return eo(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a ISSN';
                            }, t)
                        }
                    }, t);
                }
                var ro = 'isDateString';
                function no(e, t) {
                    return xr(e, t);
                }
                function io(e, t) {
                    return N({
                        name: ro,
                        constraints: [e],
                        validator: {
                            validate: function (t) {
                                return no(t, e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a valid ISO 8601 date string';
                            }, t)
                        }
                    }, t);
                }
                var ao = r(9493), oo = r.n(ao), so = 'isBooleanString';
                function co(e) {
                    return 'string' == typeof e && oo()(e);
                }
                function uo(e) {
                    return N({
                        name: so,
                        validator: {
                            validate: function (e, t) {
                                return co(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a boolean string';
                            }, e)
                        }
                    }, e);
                }
                var lo = r(4986), po = r.n(lo), fo = 'isNumberString';
                function mo(e, t) {
                    return 'string' == typeof e && po()(e, t);
                }
                function ho(e, t) {
                    return N({
                        name: fo,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return mo(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a number string';
                            }, t)
                        }
                    }, t);
                }
                var go = r(2782), yo = r.n(go), bo = 'isBase32';
                function So(e) {
                    return 'string' == typeof e && yo()(e);
                }
                function vo(e) {
                    return N({
                        name: bo,
                        validator: {
                            validate: function (e, t) {
                                return So(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be base32 encoded';
                            }, e)
                        }
                    }, e);
                }
                var Co = r(2438), Ao = r.n(Co), _o = 'isBIC';
                function Eo(e) {
                    return 'string' == typeof e && Ao()(e);
                }
                function No(e) {
                    return N({
                        name: _o,
                        validator: {
                            validate: function (e, t) {
                                return Eo(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a BIC or SWIFT code';
                            }, e)
                        }
                    }, e);
                }
                var Io = r(8021), To = r.n(Io), Do = 'isBtcAddress';
                function Oo(e) {
                    return 'string' == typeof e && To()(e);
                }
                function Ro(e) {
                    return N({
                        name: Do,
                        validator: {
                            validate: function (e, t) {
                                return Oo(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a BTC address';
                            }, e)
                        }
                    }, e);
                }
                var Mo = r(555), Fo = r.n(Mo), Po = 'isDataURI';
                function xo(e) {
                    return 'string' == typeof e && Fo()(e);
                }
                function wo(e) {
                    return N({
                        name: Po,
                        validator: {
                            validate: function (e, t) {
                                return xo(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a data uri format';
                            }, e)
                        }
                    }, e);
                }
                var Bo = r(5807), ko = r.n(Bo), Lo = 'isEAN';
                function $o(e) {
                    return 'string' == typeof e && ko()(e);
                }
                function jo(e) {
                    return N({
                        name: Lo,
                        validator: {
                            validate: function (e, t) {
                                return $o(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an EAN (European Article Number)';
                            }, e)
                        }
                    }, e);
                }
                var Go = r(2129), Vo = r.n(Go), Uo = 'isEthereumAddress';
                function Ho(e) {
                    return 'string' == typeof e && Vo()(e);
                }
                function Wo(e) {
                    return N({
                        name: Uo,
                        validator: {
                            validate: function (e, t) {
                                return Ho(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an Ethereum address';
                            }, e)
                        }
                    }, e);
                }
                var Ko = r(6648), zo = r.n(Ko), Xo = 'isHSL';
                function Yo(e) {
                    return 'string' == typeof e && zo()(e);
                }
                function qo(e) {
                    return N({
                        name: Xo,
                        validator: {
                            validate: function (e, t) {
                                return Yo(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a HSL color';
                            }, e)
                        }
                    }, e);
                }
                var Zo = r(8177), Jo = 'isIBAN';
                function Qo(e) {
                    return 'string' == typeof e && (0, Zo.default)(e);
                }
                function es(e) {
                    return N({
                        name: Jo,
                        validator: {
                            validate: function (e, t) {
                                return Qo(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an IBAN';
                            }, e)
                        }
                    }, e);
                }
                var ts = r(9396), rs = r.n(ts), ns = 'isIdentityCard';
                function is(e, t) {
                    return 'string' == typeof e && rs()(e, t);
                }
                function as(e, t) {
                    return N({
                        name: ns,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return is(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a identity card number';
                            }, t)
                        }
                    }, t);
                }
                var os = r(4339), ss = r.n(os), cs = 'isISRC';
                function us(e) {
                    return 'string' == typeof e && ss()(e);
                }
                function ls(e) {
                    return N({
                        name: cs,
                        validator: {
                            validate: function (e, t) {
                                return us(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an ISRC';
                            }, e)
                        }
                    }, e);
                }
                var ds = r(7380), ps = r.n(ds), fs = 'isLocale';
                function ms(e) {
                    return 'string' == typeof e && ps()(e);
                }
                function hs(e) {
                    return N({
                        name: fs,
                        validator: {
                            validate: function (e, t) {
                                return ms(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be locale';
                            }, e)
                        }
                    }, e);
                }
                var gs = r(2776), ys = r.n(gs), bs = 'isMagnetURI';
                function Ss(e) {
                    return 'string' == typeof e && ys()(e);
                }
                function vs(e) {
                    return N({
                        name: bs,
                        validator: {
                            validate: function (e, t) {
                                return Ss(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be magnet uri format';
                            }, e)
                        }
                    }, e);
                }
                var Cs = r(4554), As = r.n(Cs), _s = 'isMimeType';
                function Es(e) {
                    return 'string' == typeof e && As()(e);
                }
                function Ns(e) {
                    return N({
                        name: _s,
                        validator: {
                            validate: function (e, t) {
                                return Es(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be MIME type format';
                            }, e)
                        }
                    }, e);
                }
                var Is = r(6090), Ts = r.n(Is), Ds = 'isOctal';
                function Os(e) {
                    return 'string' == typeof e && Ts()(e);
                }
                function Rs(e) {
                    return N({
                        name: Ds,
                        validator: {
                            validate: function (e, t) {
                                return Os(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be valid octal number';
                            }, e)
                        }
                    }, e);
                }
                var Ms = r(1513), Fs = r.n(Ms), Ps = 'isPassportNumber';
                function xs(e, t) {
                    return 'string' == typeof e && Fs()(e, t);
                }
                function ws(e, t) {
                    return N({
                        name: Ps,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return xs(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be valid passport number';
                            }, t)
                        }
                    }, t);
                }
                var Bs = r(8140), ks = 'isPostalCode';
                function Ls(e, t) {
                    return 'string' == typeof e && (0, Bs.default)(e, t);
                }
                function $s(e, t) {
                    return N({
                        name: ks,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Ls(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a postal code';
                            }, t)
                        }
                    }, t);
                }
                var js = r(4611), Gs = r.n(js), Vs = 'isRFC3339';
                function Us(e) {
                    return 'string' == typeof e && Gs()(e);
                }
                function Hs(e) {
                    return N({
                        name: Vs,
                        validator: {
                            validate: function (e, t) {
                                return Us(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be RFC 3339 date';
                            }, e)
                        }
                    }, e);
                }
                var Ws = r(6454), Ks = r.n(Ws), zs = 'isRgbColor';
                function Xs(e, t) {
                    return 'string' == typeof e && Ks()(e, t);
                }
                function Ys(e, t) {
                    return N({
                        name: zs,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Xs(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be RGB color';
                            }, t)
                        }
                    }, t);
                }
                var qs = r(6826), Zs = r.n(qs), Js = 'isSemVer';
                function Qs(e) {
                    return 'string' == typeof e && Zs()(e);
                }
                function ec(e) {
                    return N({
                        name: Js,
                        validator: {
                            validate: function (e, t) {
                                return Qs(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a Semantic Versioning Specification';
                            }, e)
                        }
                    }, e);
                }
                var tc = r(8966), rc = r.n(tc), nc = 'isStrongPassword';
                function ic(e, t) {
                    return 'string' == typeof e && rc().isStrongPassword(e, t);
                }
                function ac(e, t) {
                    return N({
                        name: nc,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return ic(e, t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property is not strong enough';
                            }, t)
                        }
                    }, t);
                }
                var oc = 'isTimeZone';
                function sc(e) {
                    try {
                        return 'string' == typeof e && (Intl.DateTimeFormat(void 0, { timeZone: e }), !0);
                    } catch (e) {
                        return !1;
                    }
                }
                function cc(e) {
                    return N({
                        name: oc,
                        validator: {
                            validate: function (e, t) {
                                return sc(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a valid IANA time-zone';
                            }, e)
                        }
                    }, e);
                }
                var uc = r(5008), lc = r.n(uc), dc = 'isBase58';
                function pc(e) {
                    return 'string' == typeof e && lc()(e);
                }
                function fc(e) {
                    return N({
                        name: dc,
                        validator: {
                            validate: function (e, t) {
                                return pc(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be base58 encoded';
                            }, e)
                        }
                    }, e);
                }
                var mc = r(3058), hc = r.n(mc), gc = 'isTaxId';
                function yc(e, t) {
                    return 'string' == typeof e && hc()(e, t || 'en-US');
                }
                function bc(e, t) {
                    return N({
                        name: gc,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return yc(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a Tax Identification Number';
                            }, t)
                        }
                    }, t);
                }
                var Sc = r(9963), vc = 'isISO4217CurrencyCode';
                function Cc(e) {
                    return 'string' == typeof e && (0, Sc.default)(e);
                }
                function Ac(e) {
                    return N({
                        name: vc,
                        validator: {
                            validate: function (e, t) {
                                return Cc(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a valid ISO4217 currency code';
                            }, e)
                        }
                    }, e);
                }
                var _c = 'isBoolean';
                function Ec(e) {
                    return e instanceof Boolean || 'boolean' == typeof e;
                }
                function Nc(e) {
                    return N({
                        name: _c,
                        validator: {
                            validate: function (e, t) {
                                return Ec(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a boolean value';
                            }, e)
                        }
                    }, e);
                }
                var Ic = 'isDate';
                function Tc(e) {
                    return e instanceof Date && !isNaN(e.getTime());
                }
                function Dc(e) {
                    return N({
                        name: Ic,
                        validator: {
                            validate: function (e, t) {
                                return Tc(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a Date instance';
                            }, e)
                        }
                    }, e);
                }
                var Oc = 'isNumber';
                function Rc(e, t) {
                    if (void 0 === t && (t = {}), 'number' != typeof e)
                        return !1;
                    if (e === 1 / 0 || e === -1 / 0)
                        return !!t.allowInfinity;
                    if (Number.isNaN(e))
                        return !!t.allowNaN;
                    if (void 0 !== t.maxDecimalPlaces) {
                        var r = 0;
                        if (e % 1 != 0 && (r = e.toString().split('.')[1].length), r > t.maxDecimalPlaces)
                            return !1;
                    }
                    return Number.isFinite(e);
                }
                function Mc(e, t) {
                    return void 0 === e && (e = {}), N({
                        name: Oc,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Rc(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a number conforming to the specified constraints';
                            }, t)
                        }
                    }, t);
                }
                var Fc = function (e, t) {
                        var r = 'function' == typeof Symbol && e[Symbol.iterator];
                        if (!r)
                            return e;
                        var n, i, a = r.call(e), o = [];
                        try {
                            for (; (void 0 === t || t-- > 0) && !(n = a.next()).done;)
                                o.push(n.value);
                        } catch (e) {
                            i = { error: e };
                        } finally {
                            try {
                                n && !n.done && (r = a.return) && r.call(a);
                            } finally {
                                if (i)
                                    throw i.error;
                            }
                        }
                        return o;
                    }, Pc = 'isEnum';
                function xc(e, t) {
                    return Object.keys(t).map(function (e) {
                        return t[e];
                    }).includes(e);
                }
                function wc(e) {
                    return Object.entries(e).filter(function (e) {
                        var t = Fc(e, 2), r = t[0];
                        return t[1], isNaN(parseInt(r));
                    }).map(function (e) {
                        var t = Fc(e, 2);
                        return t[0], t[1];
                    });
                }
                function Bc(e, t) {
                    return N({
                        name: Pc,
                        constraints: [
                            e,
                            wc(e)
                        ],
                        validator: {
                            validate: function (e, t) {
                                return xc(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be one of the following values: $constraint2';
                            }, t)
                        }
                    }, t);
                }
                var kc = 'isInt';
                function Lc(e) {
                    return 'number' == typeof e && Number.isInteger(e);
                }
                function $c(e) {
                    return N({
                        name: kc,
                        validator: {
                            validate: function (e, t) {
                                return Lc(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an integer number';
                            }, e)
                        }
                    }, e);
                }
                var jc = 'isString';
                function Gc(e) {
                    return e instanceof String || 'string' == typeof e;
                }
                function Vc(e) {
                    return N({
                        name: jc,
                        validator: {
                            validate: function (e, t) {
                                return Gc(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a string';
                            }, e)
                        }
                    }, e);
                }
                var Uc = 'isArray';
                function Hc(e) {
                    return Array.isArray(e);
                }
                function Wc(e) {
                    return N({
                        name: Uc,
                        validator: {
                            validate: function (e, t) {
                                return Hc(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an array';
                            }, e)
                        }
                    }, e);
                }
                var Kc = 'isObject';
                function zc(e) {
                    return null != e && ('object' == typeof e || 'function' == typeof e) && !Array.isArray(e);
                }
                function Xc(e) {
                    return N({
                        name: Kc,
                        validator: {
                            validate: function (e, t) {
                                return zc(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be an object';
                            }, e)
                        }
                    }, e);
                }
                var Yc = 'arrayContains';
                function qc(e, t) {
                    return !!Array.isArray(e) && t.every(function (t) {
                        return -1 !== e.indexOf(t);
                    });
                }
                function Zc(e, t) {
                    return N({
                        name: Yc,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return qc(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain $constraint1 values';
                            }, t)
                        }
                    }, t);
                }
                var Jc = 'arrayNotContains';
                function Qc(e, t) {
                    return !!Array.isArray(e) && t.every(function (t) {
                        return -1 === e.indexOf(t);
                    });
                }
                function eu(e, t) {
                    return N({
                        name: Jc,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return Qc(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property should not contain $constraint1 values';
                            }, t)
                        }
                    }, t);
                }
                var tu = 'arrayNotEmpty';
                function ru(e) {
                    return Array.isArray(e) && e.length > 0;
                }
                function nu(e) {
                    return N({
                        name: tu,
                        validator: {
                            validate: function (e, t) {
                                return ru(e);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property should not be empty';
                            }, e)
                        }
                    }, e);
                }
                var iu = 'arrayMinSize';
                function au(e, t) {
                    return Array.isArray(e) && e.length >= t;
                }
                function ou(e, t) {
                    return N({
                        name: iu,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return au(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain at least $constraint1 elements';
                            }, t)
                        }
                    }, t);
                }
                var su = 'arrayMaxSize';
                function cu(e, t) {
                    return Array.isArray(e) && e.length <= t;
                }
                function uu(e, t) {
                    return N({
                        name: su,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return cu(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must contain no more than $constraint1 elements';
                            }, t)
                        }
                    }, t);
                }
                var lu = 'arrayUnique';
                function du(e, t) {
                    if (!Array.isArray(e))
                        return !1;
                    t && (e = e.map(function (e) {
                        return null != e ? t(e) : e;
                    }));
                    var r = e.filter(function (e, t, r) {
                        return r.indexOf(e) === t;
                    });
                    return e.length === r.length;
                }
                function pu(e, t) {
                    var r = 'function' == typeof e ? e : void 0, n = 'function' != typeof e ? e : t;
                    return N({
                        name: lu,
                        validator: {
                            validate: function (e, t) {
                                return du(e, r);
                            },
                            defaultMessage: E(function (e) {
                                return e + 'All $property\'s elements must be unique';
                            }, n)
                        }
                    }, n);
                }
                var fu = 'isNotEmptyObject';
                function mu(e, t) {
                    if (!zc(e))
                        return !1;
                    if (!0 === (null == t ? void 0 : t.nullable))
                        return !Object.values(e).every(function (e) {
                            return null == e;
                        });
                    for (var r in e)
                        if (e.hasOwnProperty(r))
                            return !0;
                    return !1;
                }
                function hu(e, t) {
                    return N({
                        name: fu,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return mu(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e) {
                                return e + '$property must be a non-empty object';
                            }, t)
                        }
                    }, t);
                }
                var gu = 'isInstance';
                function yu(e, t) {
                    return t && 'function' == typeof t && e instanceof t;
                }
                function bu(e, t) {
                    return N({
                        name: gu,
                        constraints: [e],
                        validator: {
                            validate: function (e, t) {
                                return yu(e, null == t ? void 0 : t.constraints[0]);
                            },
                            defaultMessage: E(function (e, t) {
                                return (null == t ? void 0 : t.constraints[0]) ? e + '$property must be an instance of '.concat(null == t ? void 0 : t.constraints[0].name) : e + ''.concat(gu, ' decorator expects and object as value, but got falsy value.');
                            }, t)
                        }
                    }, t);
                }
                function Su(e, t, r) {
                    return 'string' == typeof e ? v(y).validate(e, t, r) : v(y).validate(e, t);
                }
                function vu(e, t, r) {
                    return 'string' == typeof e ? v(y).validateOrReject(e, t, r) : v(y).validateOrReject(e, t);
                }
                function Cu(e, t, r) {
                    return 'string' == typeof e ? v(y).validateSync(e, t, r) : v(y).validateSync(e, t);
                }
                function Au(e) {
                    c().addValidationSchema(e);
                }
            },
            8168: (e, t, r) => {
                const n = r(8874), i = {};
                for (const e of Object.keys(n))
                    i[n[e]] = e;
                const a = {
                    rgb: {
                        channels: 3,
                        labels: 'rgb'
                    },
                    hsl: {
                        channels: 3,
                        labels: 'hsl'
                    },
                    hsv: {
                        channels: 3,
                        labels: 'hsv'
                    },
                    hwb: {
                        channels: 3,
                        labels: 'hwb'
                    },
                    cmyk: {
                        channels: 4,
                        labels: 'cmyk'
                    },
                    xyz: {
                        channels: 3,
                        labels: 'xyz'
                    },
                    lab: {
                        channels: 3,
                        labels: 'lab'
                    },
                    lch: {
                        channels: 3,
                        labels: 'lch'
                    },
                    hex: {
                        channels: 1,
                        labels: ['hex']
                    },
                    keyword: {
                        channels: 1,
                        labels: ['keyword']
                    },
                    ansi16: {
                        channels: 1,
                        labels: ['ansi16']
                    },
                    ansi256: {
                        channels: 1,
                        labels: ['ansi256']
                    },
                    hcg: {
                        channels: 3,
                        labels: [
                            'h',
                            'c',
                            'g'
                        ]
                    },
                    apple: {
                        channels: 3,
                        labels: [
                            'r16',
                            'g16',
                            'b16'
                        ]
                    },
                    gray: {
                        channels: 1,
                        labels: ['gray']
                    }
                };
                e.exports = a;
                for (const e of Object.keys(a)) {
                    if (!('channels' in a[e]))
                        throw new Error('missing channels property: ' + e);
                    if (!('labels' in a[e]))
                        throw new Error('missing channel labels property: ' + e);
                    if (a[e].labels.length !== a[e].channels)
                        throw new Error('channel and label counts mismatch: ' + e);
                    const {
                        channels: t,
                        labels: r
                    } = a[e];
                    delete a[e].channels, delete a[e].labels, Object.defineProperty(a[e], 'channels', { value: t }), Object.defineProperty(a[e], 'labels', { value: r });
                }
                a.rgb.hsl = function (e) {
                    const t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, i = Math.min(t, r, n), a = Math.max(t, r, n), o = a - i;
                    let s, c;
                    a === i ? s = 0 : t === a ? s = (r - n) / o : r === a ? s = 2 + (n - t) / o : n === a && (s = 4 + (t - r) / o), s = Math.min(60 * s, 360), s < 0 && (s += 360);
                    const u = (i + a) / 2;
                    return c = a === i ? 0 : u <= 0.5 ? o / (a + i) : o / (2 - a - i), [
                        s,
                        100 * c,
                        100 * u
                    ];
                }, a.rgb.hsv = function (e) {
                    let t, r, n, i, a;
                    const o = e[0] / 255, s = e[1] / 255, c = e[2] / 255, u = Math.max(o, s, c), l = u - Math.min(o, s, c), d = function (e) {
                            return (u - e) / 6 / l + 0.5;
                        };
                    return 0 === l ? (i = 0, a = 0) : (a = l / u, t = d(o), r = d(s), n = d(c), o === u ? i = n - r : s === u ? i = 1 / 3 + t - n : c === u && (i = 2 / 3 + r - t), i < 0 ? i += 1 : i > 1 && (i -= 1)), [
                        360 * i,
                        100 * a,
                        100 * u
                    ];
                }, a.rgb.hwb = function (e) {
                    const t = e[0], r = e[1];
                    let n = e[2];
                    const i = a.rgb.hsl(e)[0], o = 1 / 255 * Math.min(t, Math.min(r, n));
                    return n = 1 - 1 / 255 * Math.max(t, Math.max(r, n)), [
                        i,
                        100 * o,
                        100 * n
                    ];
                }, a.rgb.cmyk = function (e) {
                    const t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, i = Math.min(1 - t, 1 - r, 1 - n);
                    return [
                        100 * ((1 - t - i) / (1 - i) || 0),
                        100 * ((1 - r - i) / (1 - i) || 0),
                        100 * ((1 - n - i) / (1 - i) || 0),
                        100 * i
                    ];
                }, a.rgb.keyword = function (e) {
                    const t = i[e];
                    if (t)
                        return t;
                    let r, a = 1 / 0;
                    for (const t of Object.keys(n)) {
                        const i = (s = n[t], ((o = e)[0] - s[0]) ** 2 + (o[1] - s[1]) ** 2 + (o[2] - s[2]) ** 2);
                        i < a && (a = i, r = t);
                    }
                    var o, s;
                    return r;
                }, a.keyword.rgb = function (e) {
                    return n[e];
                }, a.rgb.xyz = function (e) {
                    let t = e[0] / 255, r = e[1] / 255, n = e[2] / 255;
                    return t = t > 0.04045 ? ((t + 0.055) / 1.055) ** 2.4 : t / 12.92, r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92, n = n > 0.04045 ? ((n + 0.055) / 1.055) ** 2.4 : n / 12.92, [
                        100 * (0.4124 * t + 0.3576 * r + 0.1805 * n),
                        100 * (0.2126 * t + 0.7152 * r + 0.0722 * n),
                        100 * (0.0193 * t + 0.1192 * r + 0.9505 * n)
                    ];
                }, a.rgb.lab = function (e) {
                    const t = a.rgb.xyz(e);
                    let r = t[0], n = t[1], i = t[2];
                    return r /= 95.047, n /= 100, i /= 108.883, r = r > 0.008856 ? r ** (1 / 3) : 7.787 * r + 16 / 116, n = n > 0.008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116, i = i > 0.008856 ? i ** (1 / 3) : 7.787 * i + 16 / 116, [
                        116 * n - 16,
                        500 * (r - n),
                        200 * (n - i)
                    ];
                }, a.hsl.rgb = function (e) {
                    const t = e[0] / 360, r = e[1] / 100, n = e[2] / 100;
                    let i, a, o;
                    if (0 === r)
                        return o = 255 * n, [
                            o,
                            o,
                            o
                        ];
                    i = n < 0.5 ? n * (1 + r) : n + r - n * r;
                    const s = 2 * n - i, c = [
                            0,
                            0,
                            0
                        ];
                    for (let e = 0; e < 3; e++)
                        a = t + 1 / 3 * -(e - 1), a < 0 && a++, a > 1 && a--, o = 6 * a < 1 ? s + 6 * (i - s) * a : 2 * a < 1 ? i : 3 * a < 2 ? s + (i - s) * (2 / 3 - a) * 6 : s, c[e] = 255 * o;
                    return c;
                }, a.hsl.hsv = function (e) {
                    const t = e[0];
                    let r = e[1] / 100, n = e[2] / 100, i = r;
                    const a = Math.max(n, 0.01);
                    return n *= 2, r *= n <= 1 ? n : 2 - n, i *= a <= 1 ? a : 2 - a, [
                        t,
                        100 * (0 === n ? 2 * i / (a + i) : 2 * r / (n + r)),
                        (n + r) / 2 * 100
                    ];
                }, a.hsv.rgb = function (e) {
                    const t = e[0] / 60, r = e[1] / 100;
                    let n = e[2] / 100;
                    const i = Math.floor(t) % 6, a = t - Math.floor(t), o = 255 * n * (1 - r), s = 255 * n * (1 - r * a), c = 255 * n * (1 - r * (1 - a));
                    switch (n *= 255, i) {
                    case 0:
                        return [
                            n,
                            c,
                            o
                        ];
                    case 1:
                        return [
                            s,
                            n,
                            o
                        ];
                    case 2:
                        return [
                            o,
                            n,
                            c
                        ];
                    case 3:
                        return [
                            o,
                            s,
                            n
                        ];
                    case 4:
                        return [
                            c,
                            o,
                            n
                        ];
                    case 5:
                        return [
                            n,
                            o,
                            s
                        ];
                    }
                }, a.hsv.hsl = function (e) {
                    const t = e[0], r = e[1] / 100, n = e[2] / 100, i = Math.max(n, 0.01);
                    let a, o;
                    o = (2 - r) * n;
                    const s = (2 - r) * i;
                    return a = r * i, a /= s <= 1 ? s : 2 - s, a = a || 0, o /= 2, [
                        t,
                        100 * a,
                        100 * o
                    ];
                }, a.hwb.rgb = function (e) {
                    const t = e[0] / 360;
                    let r = e[1] / 100, n = e[2] / 100;
                    const i = r + n;
                    let a;
                    i > 1 && (r /= i, n /= i);
                    const o = Math.floor(6 * t), s = 1 - n;
                    a = 6 * t - o, 0 != (1 & o) && (a = 1 - a);
                    const c = r + a * (s - r);
                    let u, l, d;
                    switch (o) {
                    default:
                    case 6:
                    case 0:
                        u = s, l = c, d = r;
                        break;
                    case 1:
                        u = c, l = s, d = r;
                        break;
                    case 2:
                        u = r, l = s, d = c;
                        break;
                    case 3:
                        u = r, l = c, d = s;
                        break;
                    case 4:
                        u = c, l = r, d = s;
                        break;
                    case 5:
                        u = s, l = r, d = c;
                    }
                    return [
                        255 * u,
                        255 * l,
                        255 * d
                    ];
                }, a.cmyk.rgb = function (e) {
                    const t = e[0] / 100, r = e[1] / 100, n = e[2] / 100, i = e[3] / 100;
                    return [
                        255 * (1 - Math.min(1, t * (1 - i) + i)),
                        255 * (1 - Math.min(1, r * (1 - i) + i)),
                        255 * (1 - Math.min(1, n * (1 - i) + i))
                    ];
                }, a.xyz.rgb = function (e) {
                    const t = e[0] / 100, r = e[1] / 100, n = e[2] / 100;
                    let i, a, o;
                    return i = 3.2406 * t + -1.5372 * r + -0.4986 * n, a = -0.9689 * t + 1.8758 * r + 0.0415 * n, o = 0.0557 * t + -0.204 * r + 1.057 * n, i = i > 0.0031308 ? 1.055 * i ** (1 / 2.4) - 0.055 : 12.92 * i, a = a > 0.0031308 ? 1.055 * a ** (1 / 2.4) - 0.055 : 12.92 * a, o = o > 0.0031308 ? 1.055 * o ** (1 / 2.4) - 0.055 : 12.92 * o, i = Math.min(Math.max(0, i), 1), a = Math.min(Math.max(0, a), 1), o = Math.min(Math.max(0, o), 1), [
                        255 * i,
                        255 * a,
                        255 * o
                    ];
                }, a.xyz.lab = function (e) {
                    let t = e[0], r = e[1], n = e[2];
                    return t /= 95.047, r /= 100, n /= 108.883, t = t > 0.008856 ? t ** (1 / 3) : 7.787 * t + 16 / 116, r = r > 0.008856 ? r ** (1 / 3) : 7.787 * r + 16 / 116, n = n > 0.008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116, [
                        116 * r - 16,
                        500 * (t - r),
                        200 * (r - n)
                    ];
                }, a.lab.xyz = function (e) {
                    let t, r, n;
                    r = (e[0] + 16) / 116, t = e[1] / 500 + r, n = r - e[2] / 200;
                    const i = r ** 3, a = t ** 3, o = n ** 3;
                    return r = i > 0.008856 ? i : (r - 16 / 116) / 7.787, t = a > 0.008856 ? a : (t - 16 / 116) / 7.787, n = o > 0.008856 ? o : (n - 16 / 116) / 7.787, t *= 95.047, r *= 100, n *= 108.883, [
                        t,
                        r,
                        n
                    ];
                }, a.lab.lch = function (e) {
                    const t = e[0], r = e[1], n = e[2];
                    let i;
                    return i = 360 * Math.atan2(n, r) / 2 / Math.PI, i < 0 && (i += 360), [
                        t,
                        Math.sqrt(r * r + n * n),
                        i
                    ];
                }, a.lch.lab = function (e) {
                    const t = e[0], r = e[1], n = e[2] / 360 * 2 * Math.PI;
                    return [
                        t,
                        r * Math.cos(n),
                        r * Math.sin(n)
                    ];
                }, a.rgb.ansi16 = function (e, t = null) {
                    const [r, n, i] = e;
                    let o = null === t ? a.rgb.hsv(e)[2] : t;
                    if (o = Math.round(o / 50), 0 === o)
                        return 30;
                    let s = 30 + (Math.round(i / 255) << 2 | Math.round(n / 255) << 1 | Math.round(r / 255));
                    return 2 === o && (s += 60), s;
                }, a.hsv.ansi16 = function (e) {
                    return a.rgb.ansi16(a.hsv.rgb(e), e[2]);
                }, a.rgb.ansi256 = function (e) {
                    const t = e[0], r = e[1], n = e[2];
                    return t === r && r === n ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(r / 255 * 5) + Math.round(n / 255 * 5);
                }, a.ansi16.rgb = function (e) {
                    let t = e % 10;
                    if (0 === t || 7 === t)
                        return e > 50 && (t += 3.5), t = t / 10.5 * 255, [
                            t,
                            t,
                            t
                        ];
                    const r = 0.5 * (1 + ~~(e > 50));
                    return [
                        (1 & t) * r * 255,
                        (t >> 1 & 1) * r * 255,
                        (t >> 2 & 1) * r * 255
                    ];
                }, a.ansi256.rgb = function (e) {
                    if (e >= 232) {
                        const t = 10 * (e - 232) + 8;
                        return [
                            t,
                            t,
                            t
                        ];
                    }
                    let t;
                    return e -= 16, [
                        Math.floor(e / 36) / 5 * 255,
                        Math.floor((t = e % 36) / 6) / 5 * 255,
                        t % 6 / 5 * 255
                    ];
                }, a.rgb.hex = function (e) {
                    const t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
                    return '000000'.substring(t.length) + t;
                }, a.hex.rgb = function (e) {
                    const t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
                    if (!t)
                        return [
                            0,
                            0,
                            0
                        ];
                    let r = t[0];
                    3 === t[0].length && (r = r.split('').map(e => e + e).join(''));
                    const n = parseInt(r, 16);
                    return [
                        n >> 16 & 255,
                        n >> 8 & 255,
                        255 & n
                    ];
                }, a.rgb.hcg = function (e) {
                    const t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, i = Math.max(Math.max(t, r), n), a = Math.min(Math.min(t, r), n), o = i - a;
                    let s, c;
                    return s = o < 1 ? a / (1 - o) : 0, c = o <= 0 ? 0 : i === t ? (r - n) / o % 6 : i === r ? 2 + (n - t) / o : 4 + (t - r) / o, c /= 6, c %= 1, [
                        360 * c,
                        100 * o,
                        100 * s
                    ];
                }, a.hsl.hcg = function (e) {
                    const t = e[1] / 100, r = e[2] / 100, n = r < 0.5 ? 2 * t * r : 2 * t * (1 - r);
                    let i = 0;
                    return n < 1 && (i = (r - 0.5 * n) / (1 - n)), [
                        e[0],
                        100 * n,
                        100 * i
                    ];
                }, a.hsv.hcg = function (e) {
                    const t = e[1] / 100, r = e[2] / 100, n = t * r;
                    let i = 0;
                    return n < 1 && (i = (r - n) / (1 - n)), [
                        e[0],
                        100 * n,
                        100 * i
                    ];
                }, a.hcg.rgb = function (e) {
                    const t = e[0] / 360, r = e[1] / 100, n = e[2] / 100;
                    if (0 === r)
                        return [
                            255 * n,
                            255 * n,
                            255 * n
                        ];
                    const i = [
                            0,
                            0,
                            0
                        ], a = t % 1 * 6, o = a % 1, s = 1 - o;
                    let c = 0;
                    switch (Math.floor(a)) {
                    case 0:
                        i[0] = 1, i[1] = o, i[2] = 0;
                        break;
                    case 1:
                        i[0] = s, i[1] = 1, i[2] = 0;
                        break;
                    case 2:
                        i[0] = 0, i[1] = 1, i[2] = o;
                        break;
                    case 3:
                        i[0] = 0, i[1] = s, i[2] = 1;
                        break;
                    case 4:
                        i[0] = o, i[1] = 0, i[2] = 1;
                        break;
                    default:
                        i[0] = 1, i[1] = 0, i[2] = s;
                    }
                    return c = (1 - r) * n, [
                        255 * (r * i[0] + c),
                        255 * (r * i[1] + c),
                        255 * (r * i[2] + c)
                    ];
                }, a.hcg.hsv = function (e) {
                    const t = e[1] / 100, r = t + e[2] / 100 * (1 - t);
                    let n = 0;
                    return r > 0 && (n = t / r), [
                        e[0],
                        100 * n,
                        100 * r
                    ];
                }, a.hcg.hsl = function (e) {
                    const t = e[1] / 100, r = e[2] / 100 * (1 - t) + 0.5 * t;
                    let n = 0;
                    return r > 0 && r < 0.5 ? n = t / (2 * r) : r >= 0.5 && r < 1 && (n = t / (2 * (1 - r))), [
                        e[0],
                        100 * n,
                        100 * r
                    ];
                }, a.hcg.hwb = function (e) {
                    const t = e[1] / 100, r = t + e[2] / 100 * (1 - t);
                    return [
                        e[0],
                        100 * (r - t),
                        100 * (1 - r)
                    ];
                }, a.hwb.hcg = function (e) {
                    const t = e[1] / 100, r = 1 - e[2] / 100, n = r - t;
                    let i = 0;
                    return n < 1 && (i = (r - n) / (1 - n)), [
                        e[0],
                        100 * n,
                        100 * i
                    ];
                }, a.apple.rgb = function (e) {
                    return [
                        e[0] / 65535 * 255,
                        e[1] / 65535 * 255,
                        e[2] / 65535 * 255
                    ];
                }, a.rgb.apple = function (e) {
                    return [
                        e[0] / 255 * 65535,
                        e[1] / 255 * 65535,
                        e[2] / 255 * 65535
                    ];
                }, a.gray.rgb = function (e) {
                    return [
                        e[0] / 100 * 255,
                        e[0] / 100 * 255,
                        e[0] / 100 * 255
                    ];
                }, a.gray.hsl = function (e) {
                    return [
                        0,
                        0,
                        e[0]
                    ];
                }, a.gray.hsv = a.gray.hsl, a.gray.hwb = function (e) {
                    return [
                        0,
                        100,
                        e[0]
                    ];
                }, a.gray.cmyk = function (e) {
                    return [
                        0,
                        0,
                        0,
                        e[0]
                    ];
                }, a.gray.lab = function (e) {
                    return [
                        e[0],
                        0,
                        0
                    ];
                }, a.gray.hex = function (e) {
                    const t = 255 & Math.round(e[0] / 100 * 255), r = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
                    return '000000'.substring(r.length) + r;
                }, a.rgb.gray = function (e) {
                    return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
                };
            },
            2085: (e, t, r) => {
                const n = r(8168), i = r(4111), a = {};
                Object.keys(n).forEach(e => {
                    a[e] = {}, Object.defineProperty(a[e], 'channels', { value: n[e].channels }), Object.defineProperty(a[e], 'labels', { value: n[e].labels });
                    const t = i(e);
                    Object.keys(t).forEach(r => {
                        const n = t[r];
                        a[e][r] = function (e) {
                            const t = function (...t) {
                                const r = t[0];
                                if (null == r)
                                    return r;
                                r.length > 1 && (t = r);
                                const n = e(t);
                                if ('object' == typeof n)
                                    for (let e = n.length, t = 0; t < e; t++)
                                        n[t] = Math.round(n[t]);
                                return n;
                            };
                            return 'conversion' in e && (t.conversion = e.conversion), t;
                        }(n), a[e][r].raw = function (e) {
                            const t = function (...t) {
                                const r = t[0];
                                return null == r ? r : (r.length > 1 && (t = r), e(t));
                            };
                            return 'conversion' in e && (t.conversion = e.conversion), t;
                        }(n);
                    });
                }), e.exports = a;
            },
            4111: (e, t, r) => {
                const n = r(8168);
                function i(e, t) {
                    return function (r) {
                        return t(e(r));
                    };
                }
                function a(e, t) {
                    const r = [
                        t[e].parent,
                        e
                    ];
                    let a = n[t[e].parent][e], o = t[e].parent;
                    for (; t[o].parent;)
                        r.unshift(t[o].parent), a = i(n[t[o].parent][o], a), o = t[o].parent;
                    return a.conversion = r, a;
                }
                e.exports = function (e) {
                    const t = function (e) {
                            const t = function () {
                                    const e = {}, t = Object.keys(n);
                                    for (let r = t.length, n = 0; n < r; n++)
                                        e[t[n]] = {
                                            distance: -1,
                                            parent: null
                                        };
                                    return e;
                                }(), r = [e];
                            for (t[e].distance = 0; r.length;) {
                                const e = r.pop(), i = Object.keys(n[e]);
                                for (let n = i.length, a = 0; a < n; a++) {
                                    const n = i[a], o = t[n];
                                    -1 === o.distance && (o.distance = t[e].distance + 1, o.parent = e, r.unshift(n));
                                }
                            }
                            return t;
                        }(e), r = {}, i = Object.keys(t);
                    for (let e = i.length, n = 0; n < e; n++) {
                        const e = i[n];
                        null !== t[e].parent && (r[e] = a(e, t));
                    }
                    return r;
                };
            },
            8874: e => {
                'use strict';
                e.exports = {
                    aliceblue: [
                        240,
                        248,
                        255
                    ],
                    antiquewhite: [
                        250,
                        235,
                        215
                    ],
                    aqua: [
                        0,
                        255,
                        255
                    ],
                    aquamarine: [
                        127,
                        255,
                        212
                    ],
                    azure: [
                        240,
                        255,
                        255
                    ],
                    beige: [
                        245,
                        245,
                        220
                    ],
                    bisque: [
                        255,
                        228,
                        196
                    ],
                    black: [
                        0,
                        0,
                        0
                    ],
                    blanchedalmond: [
                        255,
                        235,
                        205
                    ],
                    blue: [
                        0,
                        0,
                        255
                    ],
                    blueviolet: [
                        138,
                        43,
                        226
                    ],
                    brown: [
                        165,
                        42,
                        42
                    ],
                    burlywood: [
                        222,
                        184,
                        135
                    ],
                    cadetblue: [
                        95,
                        158,
                        160
                    ],
                    chartreuse: [
                        127,
                        255,
                        0
                    ],
                    chocolate: [
                        210,
                        105,
                        30
                    ],
                    coral: [
                        255,
                        127,
                        80
                    ],
                    cornflowerblue: [
                        100,
                        149,
                        237
                    ],
                    cornsilk: [
                        255,
                        248,
                        220
                    ],
                    crimson: [
                        220,
                        20,
                        60
                    ],
                    cyan: [
                        0,
                        255,
                        255
                    ],
                    darkblue: [
                        0,
                        0,
                        139
                    ],
                    darkcyan: [
                        0,
                        139,
                        139
                    ],
                    darkgoldenrod: [
                        184,
                        134,
                        11
                    ],
                    darkgray: [
                        169,
                        169,
                        169
                    ],
                    darkgreen: [
                        0,
                        100,
                        0
                    ],
                    darkgrey: [
                        169,
                        169,
                        169
                    ],
                    darkkhaki: [
                        189,
                        183,
                        107
                    ],
                    darkmagenta: [
                        139,
                        0,
                        139
                    ],
                    darkolivegreen: [
                        85,
                        107,
                        47
                    ],
                    darkorange: [
                        255,
                        140,
                        0
                    ],
                    darkorchid: [
                        153,
                        50,
                        204
                    ],
                    darkred: [
                        139,
                        0,
                        0
                    ],
                    darksalmon: [
                        233,
                        150,
                        122
                    ],
                    darkseagreen: [
                        143,
                        188,
                        143
                    ],
                    darkslateblue: [
                        72,
                        61,
                        139
                    ],
                    darkslategray: [
                        47,
                        79,
                        79
                    ],
                    darkslategrey: [
                        47,
                        79,
                        79
                    ],
                    darkturquoise: [
                        0,
                        206,
                        209
                    ],
                    darkviolet: [
                        148,
                        0,
                        211
                    ],
                    deeppink: [
                        255,
                        20,
                        147
                    ],
                    deepskyblue: [
                        0,
                        191,
                        255
                    ],
                    dimgray: [
                        105,
                        105,
                        105
                    ],
                    dimgrey: [
                        105,
                        105,
                        105
                    ],
                    dodgerblue: [
                        30,
                        144,
                        255
                    ],
                    firebrick: [
                        178,
                        34,
                        34
                    ],
                    floralwhite: [
                        255,
                        250,
                        240
                    ],
                    forestgreen: [
                        34,
                        139,
                        34
                    ],
                    fuchsia: [
                        255,
                        0,
                        255
                    ],
                    gainsboro: [
                        220,
                        220,
                        220
                    ],
                    ghostwhite: [
                        248,
                        248,
                        255
                    ],
                    gold: [
                        255,
                        215,
                        0
                    ],
                    goldenrod: [
                        218,
                        165,
                        32
                    ],
                    gray: [
                        128,
                        128,
                        128
                    ],
                    green: [
                        0,
                        128,
                        0
                    ],
                    greenyellow: [
                        173,
                        255,
                        47
                    ],
                    grey: [
                        128,
                        128,
                        128
                    ],
                    honeydew: [
                        240,
                        255,
                        240
                    ],
                    hotpink: [
                        255,
                        105,
                        180
                    ],
                    indianred: [
                        205,
                        92,
                        92
                    ],
                    indigo: [
                        75,
                        0,
                        130
                    ],
                    ivory: [
                        255,
                        255,
                        240
                    ],
                    khaki: [
                        240,
                        230,
                        140
                    ],
                    lavender: [
                        230,
                        230,
                        250
                    ],
                    lavenderblush: [
                        255,
                        240,
                        245
                    ],
                    lawngreen: [
                        124,
                        252,
                        0
                    ],
                    lemonchiffon: [
                        255,
                        250,
                        205
                    ],
                    lightblue: [
                        173,
                        216,
                        230
                    ],
                    lightcoral: [
                        240,
                        128,
                        128
                    ],
                    lightcyan: [
                        224,
                        255,
                        255
                    ],
                    lightgoldenrodyellow: [
                        250,
                        250,
                        210
                    ],
                    lightgray: [
                        211,
                        211,
                        211
                    ],
                    lightgreen: [
                        144,
                        238,
                        144
                    ],
                    lightgrey: [
                        211,
                        211,
                        211
                    ],
                    lightpink: [
                        255,
                        182,
                        193
                    ],
                    lightsalmon: [
                        255,
                        160,
                        122
                    ],
                    lightseagreen: [
                        32,
                        178,
                        170
                    ],
                    lightskyblue: [
                        135,
                        206,
                        250
                    ],
                    lightslategray: [
                        119,
                        136,
                        153
                    ],
                    lightslategrey: [
                        119,
                        136,
                        153
                    ],
                    lightsteelblue: [
                        176,
                        196,
                        222
                    ],
                    lightyellow: [
                        255,
                        255,
                        224
                    ],
                    lime: [
                        0,
                        255,
                        0
                    ],
                    limegreen: [
                        50,
                        205,
                        50
                    ],
                    linen: [
                        250,
                        240,
                        230
                    ],
                    magenta: [
                        255,
                        0,
                        255
                    ],
                    maroon: [
                        128,
                        0,
                        0
                    ],
                    mediumaquamarine: [
                        102,
                        205,
                        170
                    ],
                    mediumblue: [
                        0,
                        0,
                        205
                    ],
                    mediumorchid: [
                        186,
                        85,
                        211
                    ],
                    mediumpurple: [
                        147,
                        112,
                        219
                    ],
                    mediumseagreen: [
                        60,
                        179,
                        113
                    ],
                    mediumslateblue: [
                        123,
                        104,
                        238
                    ],
                    mediumspringgreen: [
                        0,
                        250,
                        154
                    ],
                    mediumturquoise: [
                        72,
                        209,
                        204
                    ],
                    mediumvioletred: [
                        199,
                        21,
                        133
                    ],
                    midnightblue: [
                        25,
                        25,
                        112
                    ],
                    mintcream: [
                        245,
                        255,
                        250
                    ],
                    mistyrose: [
                        255,
                        228,
                        225
                    ],
                    moccasin: [
                        255,
                        228,
                        181
                    ],
                    navajowhite: [
                        255,
                        222,
                        173
                    ],
                    navy: [
                        0,
                        0,
                        128
                    ],
                    oldlace: [
                        253,
                        245,
                        230
                    ],
                    olive: [
                        128,
                        128,
                        0
                    ],
                    olivedrab: [
                        107,
                        142,
                        35
                    ],
                    orange: [
                        255,
                        165,
                        0
                    ],
                    orangered: [
                        255,
                        69,
                        0
                    ],
                    orchid: [
                        218,
                        112,
                        214
                    ],
                    palegoldenrod: [
                        238,
                        232,
                        170
                    ],
                    palegreen: [
                        152,
                        251,
                        152
                    ],
                    paleturquoise: [
                        175,
                        238,
                        238
                    ],
                    palevioletred: [
                        219,
                        112,
                        147
                    ],
                    papayawhip: [
                        255,
                        239,
                        213
                    ],
                    peachpuff: [
                        255,
                        218,
                        185
                    ],
                    peru: [
                        205,
                        133,
                        63
                    ],
                    pink: [
                        255,
                        192,
                        203
                    ],
                    plum: [
                        221,
                        160,
                        221
                    ],
                    powderblue: [
                        176,
                        224,
                        230
                    ],
                    purple: [
                        128,
                        0,
                        128
                    ],
                    rebeccapurple: [
                        102,
                        51,
                        153
                    ],
                    red: [
                        255,
                        0,
                        0
                    ],
                    rosybrown: [
                        188,
                        143,
                        143
                    ],
                    royalblue: [
                        65,
                        105,
                        225
                    ],
                    saddlebrown: [
                        139,
                        69,
                        19
                    ],
                    salmon: [
                        250,
                        128,
                        114
                    ],
                    sandybrown: [
                        244,
                        164,
                        96
                    ],
                    seagreen: [
                        46,
                        139,
                        87
                    ],
                    seashell: [
                        255,
                        245,
                        238
                    ],
                    sienna: [
                        160,
                        82,
                        45
                    ],
                    silver: [
                        192,
                        192,
                        192
                    ],
                    skyblue: [
                        135,
                        206,
                        235
                    ],
                    slateblue: [
                        106,
                        90,
                        205
                    ],
                    slategray: [
                        112,
                        128,
                        144
                    ],
                    slategrey: [
                        112,
                        128,
                        144
                    ],
                    snow: [
                        255,
                        250,
                        250
                    ],
                    springgreen: [
                        0,
                        255,
                        127
                    ],
                    steelblue: [
                        70,
                        130,
                        180
                    ],
                    tan: [
                        210,
                        180,
                        140
                    ],
                    teal: [
                        0,
                        128,
                        128
                    ],
                    thistle: [
                        216,
                        191,
                        216
                    ],
                    tomato: [
                        255,
                        99,
                        71
                    ],
                    turquoise: [
                        64,
                        224,
                        208
                    ],
                    violet: [
                        238,
                        130,
                        238
                    ],
                    wheat: [
                        245,
                        222,
                        179
                    ],
                    white: [
                        255,
                        255,
                        255
                    ],
                    whitesmoke: [
                        245,
                        245,
                        245
                    ],
                    yellow: [
                        255,
                        255,
                        0
                    ],
                    yellowgreen: [
                        154,
                        205,
                        50
                    ]
                };
            },
            1012: e => {
                var t, r;
                t = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', r = {
                    rotl: function (e, t) {
                        return e << t | e >>> 32 - t;
                    },
                    rotr: function (e, t) {
                        return e << 32 - t | e >>> t;
                    },
                    endian: function (e) {
                        if (e.constructor == Number)
                            return 16711935 & r.rotl(e, 8) | 4278255360 & r.rotl(e, 24);
                        for (var t = 0; t < e.length; t++)
                            e[t] = r.endian(e[t]);
                        return e;
                    },
                    randomBytes: function (e) {
                        for (var t = []; e > 0; e--)
                            t.push(Math.floor(256 * Math.random()));
                        return t;
                    },
                    bytesToWords: function (e) {
                        for (var t = [], r = 0, n = 0; r < e.length; r++, n += 8)
                            t[n >>> 5] |= e[r] << 24 - n % 32;
                        return t;
                    },
                    wordsToBytes: function (e) {
                        for (var t = [], r = 0; r < 32 * e.length; r += 8)
                            t.push(e[r >>> 5] >>> 24 - r % 32 & 255);
                        return t;
                    },
                    bytesToHex: function (e) {
                        for (var t = [], r = 0; r < e.length; r++)
                            t.push((e[r] >>> 4).toString(16)), t.push((15 & e[r]).toString(16));
                        return t.join('');
                    },
                    hexToBytes: function (e) {
                        for (var t = [], r = 0; r < e.length; r += 2)
                            t.push(parseInt(e.substr(r, 2), 16));
                        return t;
                    },
                    bytesToBase64: function (e) {
                        for (var r = [], n = 0; n < e.length; n += 3)
                            for (var i = e[n] << 16 | e[n + 1] << 8 | e[n + 2], a = 0; a < 4; a++)
                                8 * n + 6 * a <= 8 * e.length ? r.push(t.charAt(i >>> 6 * (3 - a) & 63)) : r.push('=');
                        return r.join('');
                    },
                    base64ToBytes: function (e) {
                        e = e.replace(/[^A-Z0-9+\/]/gi, '');
                        for (var r = [], n = 0, i = 0; n < e.length; i = ++n % 4)
                            0 != i && r.push((t.indexOf(e.charAt(n - 1)) & Math.pow(2, -2 * i + 8) - 1) << 2 * i | t.indexOf(e.charAt(n)) >>> 6 - 2 * i);
                        return r;
                    }
                }, e.exports = r;
            },
            4289: (e, t, r) => {
                'use strict';
                var n = r(2215), i = 'function' == typeof Symbol && 'symbol' == typeof Symbol('foo'), a = Object.prototype.toString, o = Array.prototype.concat, s = Object.defineProperty, c = s && function () {
                        var e = {};
                        try {
                            for (var t in (s(e, 'x', {
                                    enumerable: !1,
                                    value: e
                                }), e))
                                return !1;
                            return e.x === e;
                        } catch (e) {
                            return !1;
                        }
                    }(), u = function (e, t, r, n) {
                        var i;
                        (!(t in e) || 'function' == typeof (i = n) && '[object Function]' === a.call(i) && n()) && (c ? s(e, t, {
                            configurable: !0,
                            enumerable: !1,
                            value: r,
                            writable: !0
                        }) : e[t] = r);
                    }, l = function (e, t) {
                        var r = arguments.length > 2 ? arguments[2] : {}, a = n(t);
                        i && (a = o.call(a, Object.getOwnPropertySymbols(t)));
                        for (var s = 0; s < a.length; s += 1)
                            u(e, a[s], t[a[s]], r[a[s]]);
                    };
                l.supportsDescriptors = !!c, e.exports = l;
            },
            8091: e => {
                'use strict';
                function t(e, t) {
                    if (null == e)
                        throw new TypeError('Cannot convert first argument to object');
                    for (var r = Object(e), n = 1; n < arguments.length; n++) {
                        var i = arguments[n];
                        if (null != i)
                            for (var a = Object.keys(Object(i)), o = 0, s = a.length; o < s; o++) {
                                var c = a[o], u = Object.getOwnPropertyDescriptor(i, c);
                                void 0 !== u && u.enumerable && (r[c] = i[c]);
                            }
                    }
                    return r;
                }
                e.exports = {
                    assign: t,
                    polyfill: function () {
                        Object.assign || Object.defineProperty(Object, 'assign', {
                            enumerable: !1,
                            configurable: !0,
                            writable: !0,
                            value: t
                        });
                    }
                };
            },
            8192: (e, t, r) => {
                !function () {
                    'use strict';
                    var e = r(7085);
                    function n(e) {
                        return null != e && 'object' == typeof e && 'string' == typeof e.type;
                    }
                    function i(t, r) {
                        r = r || {}, this.__visitor = t || this, this.__childVisitorKeys = r.childVisitorKeys ? Object.assign({}, e.VisitorKeys, r.childVisitorKeys) : e.VisitorKeys, 'iteration' === r.fallback ? this.__fallback = Object.keys : 'function' == typeof r.fallback && (this.__fallback = r.fallback);
                    }
                    i.prototype.visitChildren = function (t) {
                        var r, i, a, o, s, c, u;
                        if (null != t) {
                            if (r = t.type || e.Syntax.Property, !(i = this.__childVisitorKeys[r])) {
                                if (!this.__fallback)
                                    throw new Error('Unknown node type ' + r + '.');
                                i = this.__fallback(t);
                            }
                            for (a = 0, o = i.length; a < o; ++a)
                                if (u = t[i[a]])
                                    if (Array.isArray(u))
                                        for (s = 0, c = u.length; s < c; ++s)
                                            u[s] && (!n(u[s]) && (l = r, d = i[a], l !== e.Syntax.ObjectExpression && l !== e.Syntax.ObjectPattern || 'properties' !== d) || this.visit(u[s]));
                                    else
                                        n(u) && this.visit(u);
                            var l, d;
                        }
                    }, i.prototype.visit = function (t) {
                        var r;
                        null != t && (r = t.type || e.Syntax.Property, this.__visitor[r] ? this.__visitor[r].call(this, t) : this.visitChildren(t));
                    }, t.version = r(9389).version, t.Visitor = i, t.visit = function (e, t, r) {
                        new i(t, r).visit(e);
                    };
                }();
            },
            7085: (e, t) => {
                !function e(t) {
                    'use strict';
                    var r, n, i, a, o, s;
                    function c(e) {
                        var t, r, n = {};
                        for (t in e)
                            e.hasOwnProperty(t) && (r = e[t], n[t] = 'object' == typeof r && null !== r ? c(r) : r);
                        return n;
                    }
                    function u(e, t) {
                        this.parent = e, this.key = t;
                    }
                    function l(e, t, r, n) {
                        this.node = e, this.path = t, this.wrap = r, this.ref = n;
                    }
                    function d() {
                    }
                    function p(e) {
                        return null != e && 'object' == typeof e && 'string' == typeof e.type;
                    }
                    function f(e, t) {
                        return (e === r.ObjectExpression || e === r.ObjectPattern) && 'properties' === t;
                    }
                    function m(e, t) {
                        for (var r = e.length - 1; r >= 0; --r)
                            if (e[r].node === t)
                                return !0;
                        return !1;
                    }
                    function h(e, t) {
                        return new d().traverse(e, t);
                    }
                    function g(e, t) {
                        var r;
                        return r = function (t, r) {
                            var n, i, a, o;
                            for (i = t.length, a = 0; i;)
                                t[o = a + (n = i >>> 1)].range[0] > e.range[0] ? i = n : (a = o + 1, i -= n + 1);
                            return a;
                        }(t), e.extendedRange = [
                            e.range[0],
                            e.range[1]
                        ], r !== t.length && (e.extendedRange[1] = t[r].range[0]), (r -= 1) >= 0 && (e.extendedRange[0] = t[r].range[1]), e;
                    }
                    return r = {
                        AssignmentExpression: 'AssignmentExpression',
                        AssignmentPattern: 'AssignmentPattern',
                        ArrayExpression: 'ArrayExpression',
                        ArrayPattern: 'ArrayPattern',
                        ArrowFunctionExpression: 'ArrowFunctionExpression',
                        AwaitExpression: 'AwaitExpression',
                        BlockStatement: 'BlockStatement',
                        BinaryExpression: 'BinaryExpression',
                        BreakStatement: 'BreakStatement',
                        CallExpression: 'CallExpression',
                        CatchClause: 'CatchClause',
                        ChainExpression: 'ChainExpression',
                        ClassBody: 'ClassBody',
                        ClassDeclaration: 'ClassDeclaration',
                        ClassExpression: 'ClassExpression',
                        ComprehensionBlock: 'ComprehensionBlock',
                        ComprehensionExpression: 'ComprehensionExpression',
                        ConditionalExpression: 'ConditionalExpression',
                        ContinueStatement: 'ContinueStatement',
                        DebuggerStatement: 'DebuggerStatement',
                        DirectiveStatement: 'DirectiveStatement',
                        DoWhileStatement: 'DoWhileStatement',
                        EmptyStatement: 'EmptyStatement',
                        ExportAllDeclaration: 'ExportAllDeclaration',
                        ExportDefaultDeclaration: 'ExportDefaultDeclaration',
                        ExportNamedDeclaration: 'ExportNamedDeclaration',
                        ExportSpecifier: 'ExportSpecifier',
                        ExpressionStatement: 'ExpressionStatement',
                        ForStatement: 'ForStatement',
                        ForInStatement: 'ForInStatement',
                        ForOfStatement: 'ForOfStatement',
                        FunctionDeclaration: 'FunctionDeclaration',
                        FunctionExpression: 'FunctionExpression',
                        GeneratorExpression: 'GeneratorExpression',
                        Identifier: 'Identifier',
                        IfStatement: 'IfStatement',
                        ImportExpression: 'ImportExpression',
                        ImportDeclaration: 'ImportDeclaration',
                        ImportDefaultSpecifier: 'ImportDefaultSpecifier',
                        ImportNamespaceSpecifier: 'ImportNamespaceSpecifier',
                        ImportSpecifier: 'ImportSpecifier',
                        Literal: 'Literal',
                        LabeledStatement: 'LabeledStatement',
                        LogicalExpression: 'LogicalExpression',
                        MemberExpression: 'MemberExpression',
                        MetaProperty: 'MetaProperty',
                        MethodDefinition: 'MethodDefinition',
                        ModuleSpecifier: 'ModuleSpecifier',
                        NewExpression: 'NewExpression',
                        ObjectExpression: 'ObjectExpression',
                        ObjectPattern: 'ObjectPattern',
                        Program: 'Program',
                        Property: 'Property',
                        RestElement: 'RestElement',
                        ReturnStatement: 'ReturnStatement',
                        SequenceExpression: 'SequenceExpression',
                        SpreadElement: 'SpreadElement',
                        Super: 'Super',
                        SwitchStatement: 'SwitchStatement',
                        SwitchCase: 'SwitchCase',
                        TaggedTemplateExpression: 'TaggedTemplateExpression',
                        TemplateElement: 'TemplateElement',
                        TemplateLiteral: 'TemplateLiteral',
                        ThisExpression: 'ThisExpression',
                        ThrowStatement: 'ThrowStatement',
                        TryStatement: 'TryStatement',
                        UnaryExpression: 'UnaryExpression',
                        UpdateExpression: 'UpdateExpression',
                        VariableDeclaration: 'VariableDeclaration',
                        VariableDeclarator: 'VariableDeclarator',
                        WhileStatement: 'WhileStatement',
                        WithStatement: 'WithStatement',
                        YieldExpression: 'YieldExpression'
                    }, i = {
                        AssignmentExpression: [
                            'left',
                            'right'
                        ],
                        AssignmentPattern: [
                            'left',
                            'right'
                        ],
                        ArrayExpression: ['elements'],
                        ArrayPattern: ['elements'],
                        ArrowFunctionExpression: [
                            'params',
                            'body'
                        ],
                        AwaitExpression: ['argument'],
                        BlockStatement: ['body'],
                        BinaryExpression: [
                            'left',
                            'right'
                        ],
                        BreakStatement: ['label'],
                        CallExpression: [
                            'callee',
                            'arguments'
                        ],
                        CatchClause: [
                            'param',
                            'body'
                        ],
                        ChainExpression: ['expression'],
                        ClassBody: ['body'],
                        ClassDeclaration: [
                            'id',
                            'superClass',
                            'body'
                        ],
                        ClassExpression: [
                            'id',
                            'superClass',
                            'body'
                        ],
                        ComprehensionBlock: [
                            'left',
                            'right'
                        ],
                        ComprehensionExpression: [
                            'blocks',
                            'filter',
                            'body'
                        ],
                        ConditionalExpression: [
                            'test',
                            'consequent',
                            'alternate'
                        ],
                        ContinueStatement: ['label'],
                        DebuggerStatement: [],
                        DirectiveStatement: [],
                        DoWhileStatement: [
                            'body',
                            'test'
                        ],
                        EmptyStatement: [],
                        ExportAllDeclaration: ['source'],
                        ExportDefaultDeclaration: ['declaration'],
                        ExportNamedDeclaration: [
                            'declaration',
                            'specifiers',
                            'source'
                        ],
                        ExportSpecifier: [
                            'exported',
                            'local'
                        ],
                        ExpressionStatement: ['expression'],
                        ForStatement: [
                            'init',
                            'test',
                            'update',
                            'body'
                        ],
                        ForInStatement: [
                            'left',
                            'right',
                            'body'
                        ],
                        ForOfStatement: [
                            'left',
                            'right',
                            'body'
                        ],
                        FunctionDeclaration: [
                            'id',
                            'params',
                            'body'
                        ],
                        FunctionExpression: [
                            'id',
                            'params',
                            'body'
                        ],
                        GeneratorExpression: [
                            'blocks',
                            'filter',
                            'body'
                        ],
                        Identifier: [],
                        IfStatement: [
                            'test',
                            'consequent',
                            'alternate'
                        ],
                        ImportExpression: ['source'],
                        ImportDeclaration: [
                            'specifiers',
                            'source'
                        ],
                        ImportDefaultSpecifier: ['local'],
                        ImportNamespaceSpecifier: ['local'],
                        ImportSpecifier: [
                            'imported',
                            'local'
                        ],
                        Literal: [],
                        LabeledStatement: [
                            'label',
                            'body'
                        ],
                        LogicalExpression: [
                            'left',
                            'right'
                        ],
                        MemberExpression: [
                            'object',
                            'property'
                        ],
                        MetaProperty: [
                            'meta',
                            'property'
                        ],
                        MethodDefinition: [
                            'key',
                            'value'
                        ],
                        ModuleSpecifier: [],
                        NewExpression: [
                            'callee',
                            'arguments'
                        ],
                        ObjectExpression: ['properties'],
                        ObjectPattern: ['properties'],
                        Program: ['body'],
                        Property: [
                            'key',
                            'value'
                        ],
                        RestElement: ['argument'],
                        ReturnStatement: ['argument'],
                        SequenceExpression: ['expressions'],
                        SpreadElement: ['argument'],
                        Super: [],
                        SwitchStatement: [
                            'discriminant',
                            'cases'
                        ],
                        SwitchCase: [
                            'test',
                            'consequent'
                        ],
                        TaggedTemplateExpression: [
                            'tag',
                            'quasi'
                        ],
                        TemplateElement: [],
                        TemplateLiteral: [
                            'quasis',
                            'expressions'
                        ],
                        ThisExpression: [],
                        ThrowStatement: ['argument'],
                        TryStatement: [
                            'block',
                            'handler',
                            'finalizer'
                        ],
                        UnaryExpression: ['argument'],
                        UpdateExpression: ['argument'],
                        VariableDeclaration: ['declarations'],
                        VariableDeclarator: [
                            'id',
                            'init'
                        ],
                        WhileStatement: [
                            'test',
                            'body'
                        ],
                        WithStatement: [
                            'object',
                            'body'
                        ],
                        YieldExpression: ['argument']
                    }, n = {
                        Break: a = {},
                        Skip: o = {},
                        Remove: s = {}
                    }, u.prototype.replace = function (e) {
                        this.parent[this.key] = e;
                    }, u.prototype.remove = function () {
                        return Array.isArray(this.parent) ? (this.parent.splice(this.key, 1), !0) : (this.replace(null), !1);
                    }, d.prototype.path = function () {
                        var e, t, r, n, i;
                        function a(e, t) {
                            if (Array.isArray(t))
                                for (r = 0, n = t.length; r < n; ++r)
                                    e.push(t[r]);
                            else
                                e.push(t);
                        }
                        if (!this.__current.path)
                            return null;
                        for (i = [], e = 2, t = this.__leavelist.length; e < t; ++e)
                            a(i, this.__leavelist[e].path);
                        return a(i, this.__current.path), i;
                    }, d.prototype.type = function () {
                        return this.current().type || this.__current.wrap;
                    }, d.prototype.parents = function () {
                        var e, t, r;
                        for (r = [], e = 1, t = this.__leavelist.length; e < t; ++e)
                            r.push(this.__leavelist[e].node);
                        return r;
                    }, d.prototype.current = function () {
                        return this.__current.node;
                    }, d.prototype.__execute = function (e, t) {
                        var r, n;
                        return n = void 0, r = this.__current, this.__current = t, this.__state = null, e && (n = e.call(this, t.node, this.__leavelist[this.__leavelist.length - 1].node)), this.__current = r, n;
                    }, d.prototype.notify = function (e) {
                        this.__state = e;
                    }, d.prototype.skip = function () {
                        this.notify(o);
                    }, d.prototype.break = function () {
                        this.notify(a);
                    }, d.prototype.remove = function () {
                        this.notify(s);
                    }, d.prototype.__initialize = function (e, t) {
                        this.visitor = t, this.root = e, this.__worklist = [], this.__leavelist = [], this.__current = null, this.__state = null, this.__fallback = null, 'iteration' === t.fallback ? this.__fallback = Object.keys : 'function' == typeof t.fallback && (this.__fallback = t.fallback), this.__keys = i, t.keys && (this.__keys = Object.assign(Object.create(this.__keys), t.keys));
                    }, d.prototype.traverse = function (e, t) {
                        var r, n, i, s, c, u, d, h, g, y, b, S;
                        for (this.__initialize(e, t), S = {}, r = this.__worklist, n = this.__leavelist, r.push(new l(e, null, null, null)), n.push(new l(null, null, null, null)); r.length;)
                            if ((i = r.pop()) !== S) {
                                if (i.node) {
                                    if (u = this.__execute(t.enter, i), this.__state === a || u === a)
                                        return;
                                    if (r.push(S), n.push(i), this.__state === o || u === o)
                                        continue;
                                    if (c = (s = i.node).type || i.wrap, !(y = this.__keys[c])) {
                                        if (!this.__fallback)
                                            throw new Error('Unknown node type ' + c + '.');
                                        y = this.__fallback(s);
                                    }
                                    for (h = y.length; (h -= 1) >= 0;)
                                        if (b = s[d = y[h]])
                                            if (Array.isArray(b)) {
                                                for (g = b.length; (g -= 1) >= 0;)
                                                    if (b[g] && !m(n, b[g])) {
                                                        if (f(c, y[h]))
                                                            i = new l(b[g], [
                                                                d,
                                                                g
                                                            ], 'Property', null);
                                                        else {
                                                            if (!p(b[g]))
                                                                continue;
                                                            i = new l(b[g], [
                                                                d,
                                                                g
                                                            ], null, null);
                                                        }
                                                        r.push(i);
                                                    }
                                            } else if (p(b)) {
                                                if (m(n, b))
                                                    continue;
                                                r.push(new l(b, d, null, null));
                                            }
                                }
                            } else if (i = n.pop(), u = this.__execute(t.leave, i), this.__state === a || u === a)
                                return;
                    }, d.prototype.replace = function (e, t) {
                        var r, n, i, c, d, m, h, g, y, b, S, v, C;
                        function A(e) {
                            var t, n, i, a;
                            if (e.ref.remove())
                                for (n = e.ref.key, a = e.ref.parent, t = r.length; t--;)
                                    if ((i = r[t]).ref && i.ref.parent === a) {
                                        if (i.ref.key < n)
                                            break;
                                        --i.ref.key;
                                    }
                        }
                        for (this.__initialize(e, t), S = {}, r = this.__worklist, n = this.__leavelist, m = new l(e, null, null, new u(v = { root: e }, 'root')), r.push(m), n.push(m); r.length;)
                            if ((m = r.pop()) !== S) {
                                if (void 0 !== (d = this.__execute(t.enter, m)) && d !== a && d !== o && d !== s && (m.ref.replace(d), m.node = d), this.__state !== s && d !== s || (A(m), m.node = null), this.__state === a || d === a)
                                    return v.root;
                                if ((i = m.node) && (r.push(S), n.push(m), this.__state !== o && d !== o)) {
                                    if (c = i.type || m.wrap, !(y = this.__keys[c])) {
                                        if (!this.__fallback)
                                            throw new Error('Unknown node type ' + c + '.');
                                        y = this.__fallback(i);
                                    }
                                    for (h = y.length; (h -= 1) >= 0;)
                                        if (b = i[C = y[h]])
                                            if (Array.isArray(b)) {
                                                for (g = b.length; (g -= 1) >= 0;)
                                                    if (b[g]) {
                                                        if (f(c, y[h]))
                                                            m = new l(b[g], [
                                                                C,
                                                                g
                                                            ], 'Property', new u(b, g));
                                                        else {
                                                            if (!p(b[g]))
                                                                continue;
                                                            m = new l(b[g], [
                                                                C,
                                                                g
                                                            ], null, new u(b, g));
                                                        }
                                                        r.push(m);
                                                    }
                                            } else
                                                p(b) && r.push(new l(b, C, null, new u(i, C)));
                                }
                            } else if (m = n.pop(), void 0 !== (d = this.__execute(t.leave, m)) && d !== a && d !== o && d !== s && m.ref.replace(d), this.__state !== s && d !== s || A(m), this.__state === a || d === a)
                                return v.root;
                        return v.root;
                    }, t.Syntax = r, t.traverse = h, t.replace = function (e, t) {
                        return new d().replace(e, t);
                    }, t.attachComments = function (e, t, r) {
                        var i, a, o, s, u = [];
                        if (!e.range)
                            throw new Error('attachComments needs range information');
                        if (!r.length) {
                            if (t.length) {
                                for (o = 0, a = t.length; o < a; o += 1)
                                    (i = c(t[o])).extendedRange = [
                                        0,
                                        e.range[0]
                                    ], u.push(i);
                                e.leadingComments = u;
                            }
                            return e;
                        }
                        for (o = 0, a = t.length; o < a; o += 1)
                            u.push(g(c(t[o]), r));
                        return s = 0, h(e, {
                            enter: function (e) {
                                for (var t; s < u.length && !((t = u[s]).extendedRange[1] > e.range[0]);)
                                    t.extendedRange[1] === e.range[0] ? (e.leadingComments || (e.leadingComments = []), e.leadingComments.push(t), u.splice(s, 1)) : s += 1;
                                return s === u.length ? n.Break : u[s].extendedRange[0] > e.range[1] ? n.Skip : void 0;
                            }
                        }), s = 0, h(e, {
                            leave: function (e) {
                                for (var t; s < u.length && (t = u[s], !(e.range[1] < t.extendedRange[0]));)
                                    e.range[1] === t.extendedRange[0] ? (e.trailingComments || (e.trailingComments = []), e.trailingComments.push(t), u.splice(s, 1)) : s += 1;
                                return s === u.length ? n.Break : u[s].extendedRange[0] > e.range[1] ? n.Skip : void 0;
                            }
                        }), e;
                    }, t.VisitorKeys = i, t.VisitorOption = n, t.Controller = d, t.cloneEnvironment = function () {
                        return e({});
                    }, t;
                }(t);
            },
            4974: e => {
                !function () {
                    'use strict';
                    function t(e) {
                        if (null == e)
                            return !1;
                        switch (e.type) {
                        case 'BlockStatement':
                        case 'BreakStatement':
                        case 'ContinueStatement':
                        case 'DebuggerStatement':
                        case 'DoWhileStatement':
                        case 'EmptyStatement':
                        case 'ExpressionStatement':
                        case 'ForInStatement':
                        case 'ForStatement':
                        case 'IfStatement':
                        case 'LabeledStatement':
                        case 'ReturnStatement':
                        case 'SwitchStatement':
                        case 'ThrowStatement':
                        case 'TryStatement':
                        case 'VariableDeclaration':
                        case 'WhileStatement':
                        case 'WithStatement':
                            return !0;
                        }
                        return !1;
                    }
                    function r(e) {
                        switch (e.type) {
                        case 'IfStatement':
                            return null != e.alternate ? e.alternate : e.consequent;
                        case 'LabeledStatement':
                        case 'ForStatement':
                        case 'ForInStatement':
                        case 'WhileStatement':
                        case 'WithStatement':
                            return e.body;
                        }
                        return null;
                    }
                    e.exports = {
                        isExpression: function (e) {
                            if (null == e)
                                return !1;
                            switch (e.type) {
                            case 'ArrayExpression':
                            case 'AssignmentExpression':
                            case 'BinaryExpression':
                            case 'CallExpression':
                            case 'ConditionalExpression':
                            case 'FunctionExpression':
                            case 'Identifier':
                            case 'Literal':
                            case 'LogicalExpression':
                            case 'MemberExpression':
                            case 'NewExpression':
                            case 'ObjectExpression':
                            case 'SequenceExpression':
                            case 'ThisExpression':
                            case 'UnaryExpression':
                            case 'UpdateExpression':
                                return !0;
                            }
                            return !1;
                        },
                        isStatement: t,
                        isIterationStatement: function (e) {
                            if (null == e)
                                return !1;
                            switch (e.type) {
                            case 'DoWhileStatement':
                            case 'ForInStatement':
                            case 'ForStatement':
                            case 'WhileStatement':
                                return !0;
                            }
                            return !1;
                        },
                        isSourceElement: function (e) {
                            return t(e) || null != e && 'FunctionDeclaration' === e.type;
                        },
                        isProblematicIfStatement: function (e) {
                            var t;
                            if ('IfStatement' !== e.type)
                                return !1;
                            if (null == e.alternate)
                                return !1;
                            t = e.consequent;
                            do {
                                if ('IfStatement' === t.type && null == t.alternate)
                                    return !0;
                                t = r(t);
                            } while (t);
                            return !1;
                        },
                        trailingStatement: r
                    };
                }();
            },
            5619: e => {
                !function () {
                    'use strict';
                    var t, r, n, i, a, o;
                    function s(e) {
                        return e <= 65535 ? String.fromCharCode(e) : String.fromCharCode(Math.floor((e - 65536) / 1024) + 55296) + String.fromCharCode((e - 65536) % 1024 + 56320);
                    }
                    for (r = {
                            NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
                            NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/
                        }, t = {
                            NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
                            NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
                        }, n = [
                            5760,
                            8192,
                            8193,
                            8194,
                            8195,
                            8196,
                            8197,
                            8198,
                            8199,
                            8200,
                            8201,
                            8202,
                            8239,
                            8287,
                            12288,
                            65279
                        ], i = new Array(128), o = 0; o < 128; ++o)
                        i[o] = o >= 97 && o <= 122 || o >= 65 && o <= 90 || 36 === o || 95 === o;
                    for (a = new Array(128), o = 0; o < 128; ++o)
                        a[o] = o >= 97 && o <= 122 || o >= 65 && o <= 90 || o >= 48 && o <= 57 || 36 === o || 95 === o;
                    e.exports = {
                        isDecimalDigit: function (e) {
                            return 48 <= e && e <= 57;
                        },
                        isHexDigit: function (e) {
                            return 48 <= e && e <= 57 || 97 <= e && e <= 102 || 65 <= e && e <= 70;
                        },
                        isOctalDigit: function (e) {
                            return e >= 48 && e <= 55;
                        },
                        isWhiteSpace: function (e) {
                            return 32 === e || 9 === e || 11 === e || 12 === e || 160 === e || e >= 5760 && n.indexOf(e) >= 0;
                        },
                        isLineTerminator: function (e) {
                            return 10 === e || 13 === e || 8232 === e || 8233 === e;
                        },
                        isIdentifierStartES5: function (e) {
                            return e < 128 ? i[e] : r.NonAsciiIdentifierStart.test(s(e));
                        },
                        isIdentifierPartES5: function (e) {
                            return e < 128 ? a[e] : r.NonAsciiIdentifierPart.test(s(e));
                        },
                        isIdentifierStartES6: function (e) {
                            return e < 128 ? i[e] : t.NonAsciiIdentifierStart.test(s(e));
                        },
                        isIdentifierPartES6: function (e) {
                            return e < 128 ? a[e] : t.NonAsciiIdentifierPart.test(s(e));
                        }
                    };
                }();
            },
            702: (e, t, r) => {
                !function () {
                    'use strict';
                    var t = r(5619);
                    function n(e, t) {
                        return !(!t && 'yield' === e) && i(e, t);
                    }
                    function i(e, t) {
                        if (t && function (e) {
                                switch (e) {
                                case 'implements':
                                case 'interface':
                                case 'package':
                                case 'private':
                                case 'protected':
                                case 'public':
                                case 'static':
                                case 'let':
                                    return !0;
                                default:
                                    return !1;
                                }
                            }(e))
                            return !0;
                        switch (e.length) {
                        case 2:
                            return 'if' === e || 'in' === e || 'do' === e;
                        case 3:
                            return 'var' === e || 'for' === e || 'new' === e || 'try' === e;
                        case 4:
                            return 'this' === e || 'else' === e || 'case' === e || 'void' === e || 'with' === e || 'enum' === e;
                        case 5:
                            return 'while' === e || 'break' === e || 'catch' === e || 'throw' === e || 'const' === e || 'yield' === e || 'class' === e || 'super' === e;
                        case 6:
                            return 'return' === e || 'typeof' === e || 'delete' === e || 'switch' === e || 'export' === e || 'import' === e;
                        case 7:
                            return 'default' === e || 'finally' === e || 'extends' === e;
                        case 8:
                            return 'function' === e || 'continue' === e || 'debugger' === e;
                        case 10:
                            return 'instanceof' === e;
                        default:
                            return !1;
                        }
                    }
                    function a(e, t) {
                        return 'null' === e || 'true' === e || 'false' === e || n(e, t);
                    }
                    function o(e, t) {
                        return 'null' === e || 'true' === e || 'false' === e || i(e, t);
                    }
                    function s(e) {
                        var r, n, i;
                        if (0 === e.length)
                            return !1;
                        if (i = e.charCodeAt(0), !t.isIdentifierStartES5(i))
                            return !1;
                        for (r = 1, n = e.length; r < n; ++r)
                            if (i = e.charCodeAt(r), !t.isIdentifierPartES5(i))
                                return !1;
                        return !0;
                    }
                    function c(e) {
                        var r, n, i, a, o;
                        if (0 === e.length)
                            return !1;
                        for (o = t.isIdentifierStartES6, r = 0, n = e.length; r < n; ++r) {
                            if (55296 <= (i = e.charCodeAt(r)) && i <= 56319) {
                                if (++r >= n)
                                    return !1;
                                if (!(56320 <= (a = e.charCodeAt(r)) && a <= 57343))
                                    return !1;
                                i = 1024 * (i - 55296) + (a - 56320) + 65536;
                            }
                            if (!o(i))
                                return !1;
                            o = t.isIdentifierPartES6;
                        }
                        return !0;
                    }
                    e.exports = {
                        isKeywordES5: n,
                        isKeywordES6: i,
                        isReservedWordES5: a,
                        isReservedWordES6: o,
                        isRestrictedWord: function (e) {
                            return 'eval' === e || 'arguments' === e;
                        },
                        isIdentifierNameES5: s,
                        isIdentifierNameES6: c,
                        isIdentifierES5: function (e, t) {
                            return s(e) && !a(e, t);
                        },
                        isIdentifierES6: function (e, t) {
                            return c(e) && !o(e, t);
                        }
                    };
                }();
            },
            649: (e, t, r) => {
                !function () {
                    'use strict';
                    t.ast = r(4974), t.code = r(5619), t.keyword = r(702);
                }();
            },
            4063: e => {
                'use strict';
                e.exports = function e(t, r) {
                    if (t === r)
                        return !0;
                    if (t && r && 'object' == typeof t && 'object' == typeof r) {
                        if (t.constructor !== r.constructor)
                            return !1;
                        var n, i, a;
                        if (Array.isArray(t)) {
                            if ((n = t.length) != r.length)
                                return !1;
                            for (i = n; 0 != i--;)
                                if (!e(t[i], r[i]))
                                    return !1;
                            return !0;
                        }
                        if (t.constructor === RegExp)
                            return t.source === r.source && t.flags === r.flags;
                        if (t.valueOf !== Object.prototype.valueOf)
                            return t.valueOf() === r.valueOf();
                        if (t.toString !== Object.prototype.toString)
                            return t.toString() === r.toString();
                        if ((n = (a = Object.keys(t)).length) !== Object.keys(r).length)
                            return !1;
                        for (i = n; 0 != i--;)
                            if (!Object.prototype.hasOwnProperty.call(r, a[i]))
                                return !1;
                        for (i = n; 0 != i--;) {
                            var o = a[i];
                            if (!e(t[o], r[o]))
                                return !1;
                        }
                        return !0;
                    }
                    return t != t && r != r;
                };
            },
            9804: e => {
                var t = Object.prototype.hasOwnProperty, r = Object.prototype.toString;
                e.exports = function (e, n, i) {
                    if ('[object Function]' !== r.call(n))
                        throw new TypeError('iterator must be a function');
                    var a = e.length;
                    if (a === +a)
                        for (var o = 0; o < a; o++)
                            n.call(i, e[o], o, e);
                    else
                        for (var s in e)
                            t.call(e, s) && n.call(i, e[s], s, e);
                };
            },
            7648: e => {
                'use strict';
                var t = 'Function.prototype.bind called on incompatible ', r = Array.prototype.slice, n = Object.prototype.toString, i = '[object Function]';
                e.exports = function (e) {
                    var a = this;
                    if ('function' != typeof a || n.call(a) !== i)
                        throw new TypeError(t + a);
                    for (var o, s = r.call(arguments, 1), c = function () {
                                if (this instanceof o) {
                                    var t = a.apply(this, s.concat(r.call(arguments)));
                                    return Object(t) === t ? t : this;
                                }
                                return a.apply(e, s.concat(r.call(arguments)));
                            }, u = Math.max(0, a.length - s.length), l = [], d = 0; d < u; d++)
                        l.push('$' + d);
                    if (o = Function('binder', 'return function (' + l.join(',') + '){ return binder.apply(this,arguments); }')(c), a.prototype) {
                        var p = function () {
                        };
                        p.prototype = a.prototype, o.prototype = new p(), p.prototype = null;
                    }
                    return o;
                };
            },
            8612: (e, t, r) => {
                'use strict';
                var n = r(7648);
                e.exports = Function.prototype.bind || n;
            },
            1405: (e, t, r) => {
                'use strict';
                var n = r.g.Symbol, i = r(5419);
                e.exports = function () {
                    return 'function' == typeof n && 'function' == typeof Symbol && 'symbol' == typeof n('foo') && 'symbol' == typeof Symbol('bar') && i();
                };
            },
            5419: e => {
                'use strict';
                e.exports = function () {
                    if ('function' != typeof Symbol || 'function' != typeof Object.getOwnPropertySymbols)
                        return !1;
                    if ('symbol' == typeof Symbol.iterator)
                        return !0;
                    var e = {}, t = Symbol('test'), r = Object(t);
                    if ('string' == typeof t)
                        return !1;
                    if ('[object Symbol]' !== Object.prototype.toString.call(t))
                        return !1;
                    if ('[object Symbol]' !== Object.prototype.toString.call(r))
                        return !1;
                    for (t in (e[t] = 42, e))
                        return !1;
                    if ('function' == typeof Object.keys && 0 !== Object.keys(e).length)
                        return !1;
                    if ('function' == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length)
                        return !1;
                    var n = Object.getOwnPropertySymbols(e);
                    if (1 !== n.length || n[0] !== t)
                        return !1;
                    if (!Object.prototype.propertyIsEnumerable.call(e, t))
                        return !1;
                    if ('function' == typeof Object.getOwnPropertyDescriptor) {
                        var i = Object.getOwnPropertyDescriptor(e, t);
                        if (42 !== i.value || !0 !== i.enumerable)
                            return !1;
                    }
                    return !0;
                };
            },
            7642: (e, t, r) => {
                'use strict';
                var n = r(8612);
                e.exports = n.call(Function.call, Object.prototype.hasOwnProperty);
            },
            5717: e => {
                'function' == typeof Object.create ? e.exports = function (e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : e.exports = function (e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function () {
                        };
                        r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
                    }
                };
            },
            6594: (e, t, r) => {
                'use strict';
                r.r(t), r.d(t, {
                    AsyncContainerModule: () => Ge,
                    BindingScopeEnum: () => y,
                    BindingTypeEnum: () => b,
                    Container: () => $e,
                    ContainerModule: () => je,
                    LazyServiceIdentifer: () => $,
                    METADATA_KEY: () => st,
                    MetadataReader: () => O,
                    TargetTypeEnum: () => S,
                    createTaggedDecorator: () => He,
                    decorate: () => ze,
                    getServiceIdentifierAsString: () => M,
                    id: () => C,
                    inject: () => Je,
                    injectable: () => Xe,
                    interfaces: () => it,
                    multiBindToService: () => ie,
                    multiInject: () => tt,
                    named: () => qe,
                    namedConstraint: () => Ee,
                    optional: () => Qe,
                    postConstruct: () => at,
                    preDestroy: () => ot,
                    tagged: () => Ye,
                    taggedConstraint: () => _e,
                    targetName: () => rt,
                    traverseAncerstors: () => Ae,
                    typeConstraint: () => Ne,
                    unmanaged: () => et
                });
                var n = {};
                r.r(n), r.d(n, {
                    DESIGN_PARAM_TYPES: () => f,
                    INJECT_TAG: () => c,
                    MULTI_INJECT_TAG: () => u,
                    NAMED_TAG: () => i,
                    NAME_TAG: () => a,
                    NON_CUSTOM_TAG_KEYS: () => g,
                    OPTIONAL_TAG: () => s,
                    PARAM_TYPES: () => p,
                    POST_CONSTRUCT: () => m,
                    PRE_DESTROY: () => h,
                    TAGGED: () => l,
                    TAGGED_PROP: () => d,
                    UNMANAGED_TAG: () => o
                });
                var i = 'named', a = 'name', o = 'unmanaged', s = 'optional', c = 'inject', u = 'multi_inject', l = 'inversify:tagged', d = 'inversify:tagged_props', p = 'inversify:paramtypes', f = 'design:paramtypes', m = 'post_construct', h = 'pre_destroy', g = [
                        c,
                        u,
                        a,
                        o,
                        i,
                        s
                    ], y = {
                        Request: 'Request',
                        Singleton: 'Singleton',
                        Transient: 'Transient'
                    }, b = {
                        ConstantValue: 'ConstantValue',
                        Constructor: 'Constructor',
                        DynamicValue: 'DynamicValue',
                        Factory: 'Factory',
                        Function: 'Function',
                        Instance: 'Instance',
                        Invalid: 'Invalid',
                        Provider: 'Provider'
                    }, S = {
                        ClassProperty: 'ClassProperty',
                        ConstructorArgument: 'ConstructorArgument',
                        Variable: 'Variable'
                    }, v = 0;
                function C() {
                    return v++;
                }
                var A = function () {
                        function e(e, t) {
                            this.id = C(), this.activated = !1, this.serviceIdentifier = e, this.scope = t, this.type = b.Invalid, this.constraint = function (e) {
                                return !0;
                            }, this.implementationType = null, this.cache = null, this.factory = null, this.provider = null, this.onActivation = null, this.onDeactivation = null, this.dynamicValue = null;
                        }
                        return e.prototype.clone = function () {
                            var t = new e(this.serviceIdentifier, this.scope);
                            return t.activated = t.scope === y.Singleton && this.activated, t.implementationType = this.implementationType, t.dynamicValue = this.dynamicValue, t.scope = this.scope, t.type = this.type, t.factory = this.factory, t.provider = this.provider, t.constraint = this.constraint, t.onActivation = this.onActivation, t.onDeactivation = this.onDeactivation, t.cache = this.cache, t;
                        }, e;
                    }(), _ = 'Metadata key was used more than once in a parameter:', E = 'NULL argument', N = 'Key Not Found', I = 'Missing required @injectable annotation in:', T = 'The @inject @multiInject @tagged and @named decorators must be applied to the parameters of a class constructor or a class property.', D = function (e, t) {
                        return 'onDeactivation() error in class ' + e + ': ' + t;
                    }, O = function () {
                        function e() {
                        }
                        return e.prototype.getConstructorMetadata = function (e) {
                            return {
                                compilerGeneratedMetadata: Reflect.getMetadata(p, e),
                                userGeneratedMetadata: Reflect.getMetadata(l, e) || {}
                            };
                        }, e.prototype.getPropertiesMetadata = function (e) {
                            return Reflect.getMetadata(d, e) || [];
                        }, e;
                    }();
                function R(e) {
                    return e instanceof RangeError || 'Maximum call stack size exceeded' === e.message;
                }
                function M(e) {
                    return 'function' == typeof e ? e.name : 'symbol' == typeof e ? e.toString() : e;
                }
                function F(e, t, r) {
                    var n = '', i = r(e, t);
                    return 0 !== i.length && (n = '\nRegistered bindings:', i.forEach(function (e) {
                        var t = 'Object';
                        null !== e.implementationType && (t = w(e.implementationType)), n = n + '\n ' + t, e.constraint.metaData && (n = n + ' - ' + e.constraint.metaData);
                    })), n;
                }
                function P(e, t) {
                    return null !== e.parentRequest && (e.parentRequest.serviceIdentifier === t || P(e.parentRequest, t));
                }
                function x(e) {
                    e.childRequests.forEach(function (e) {
                        if (P(e, e.serviceIdentifier)) {
                            var t = function (e) {
                                return function e(t, r) {
                                    void 0 === r && (r = []);
                                    var n = M(t.serviceIdentifier);
                                    return r.push(n), null !== t.parentRequest ? e(t.parentRequest, r) : r;
                                }(e).reverse().join(' --> ');
                            }(e);
                            throw new Error('Circular dependency found: ' + t);
                        }
                        x(e);
                    });
                }
                function w(e) {
                    if (e.name)
                        return e.name;
                    var t = e.toString(), r = t.match(/^function\s*([^\s(]+)/);
                    return r ? r[1] : 'Anonymous function: ' + t;
                }
                var B = function () {
                        function e(e) {
                            this.id = C(), this.container = e;
                        }
                        return e.prototype.addPlan = function (e) {
                            this.plan = e;
                        }, e.prototype.setCurrentRequest = function (e) {
                            this.currentRequest = e;
                        }, e;
                    }(), k = function () {
                        function e(e, t) {
                            this.key = e, this.value = t;
                        }
                        return e.prototype.toString = function () {
                            return this.key === i ? 'named: ' + String(this.value).toString() + ' ' : 'tagged: { key:' + this.key.toString() + ', value: ' + String(this.value) + ' }';
                        }, e;
                    }(), L = function (e, t) {
                        this.parentContext = e, this.rootRequest = t;
                    }, $ = function () {
                        function e(e) {
                            this._cb = e;
                        }
                        return e.prototype.unwrap = function () {
                            return this._cb();
                        }, e;
                    }(), j = function () {
                        function e(e) {
                            this.str = e;
                        }
                        return e.prototype.startsWith = function (e) {
                            return 0 === this.str.indexOf(e);
                        }, e.prototype.endsWith = function (e) {
                            var t, r = e.split('').reverse().join('');
                            return t = this.str.split('').reverse().join(''), this.startsWith.call({ str: t }, r);
                        }, e.prototype.contains = function (e) {
                            return -1 !== this.str.indexOf(e);
                        }, e.prototype.equals = function (e) {
                            return this.str === e;
                        }, e.prototype.value = function () {
                            return this.str;
                        }, e;
                    }(), G = function () {
                        function e(e, t, r, n) {
                            this.id = C(), this.type = e, this.serviceIdentifier = r;
                            var a = 'symbol' == typeof t ? t.toString().slice(7, -1) : t;
                            this.name = new j(a || ''), this.identifier = t, this.metadata = new Array();
                            var o = null;
                            'string' == typeof n ? o = new k(i, n) : n instanceof k && (o = n), null !== o && this.metadata.push(o);
                        }
                        return e.prototype.hasTag = function (e) {
                            for (var t = 0, r = this.metadata; t < r.length; t++)
                                if (r[t].key === e)
                                    return !0;
                            return !1;
                        }, e.prototype.isArray = function () {
                            return this.hasTag(u);
                        }, e.prototype.matchesArray = function (e) {
                            return this.matchesTag(u)(e);
                        }, e.prototype.isNamed = function () {
                            return this.hasTag(i);
                        }, e.prototype.isTagged = function () {
                            return this.metadata.some(function (e) {
                                return g.every(function (t) {
                                    return e.key !== t;
                                });
                            });
                        }, e.prototype.isOptional = function () {
                            return this.matchesTag(s)(!0);
                        }, e.prototype.getNamedTag = function () {
                            return this.isNamed() ? this.metadata.filter(function (e) {
                                return e.key === i;
                            })[0] : null;
                        }, e.prototype.getCustomTags = function () {
                            return this.isTagged() ? this.metadata.filter(function (e) {
                                return g.every(function (t) {
                                    return e.key !== t;
                                });
                            }) : null;
                        }, e.prototype.matchesNamedTag = function (e) {
                            return this.matchesTag(i)(e);
                        }, e.prototype.matchesTag = function (e) {
                            var t = this;
                            return function (r) {
                                for (var n = 0, i = t.metadata; n < i.length; n++) {
                                    var a = i[n];
                                    if (a.key === e && a.value === r)
                                        return !0;
                                }
                                return !1;
                            };
                        }, e;
                    }(), V = function (e, t, r) {
                        if (r || 2 === arguments.length)
                            for (var n, i = 0, a = t.length; i < a; i++)
                                !n && i in t || (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
                        return e.concat(n || Array.prototype.slice.call(t));
                    };
                function U(e, t, r, n) {
                    var i = e.getConstructorMetadata(r), a = i.compilerGeneratedMetadata;
                    if (void 0 === a)
                        throw new Error(I + ' ' + t + '.');
                    var o = i.userGeneratedMetadata, s = Object.keys(o), c = 0 === r.length && s.length > 0, u = s.length > r.length, l = function (e, t, r, n, i) {
                            for (var a = [], o = 0; o < i; o++) {
                                var s = H(o, e, t, r, n);
                                null !== s && a.push(s);
                            }
                            return a;
                        }(n, t, a, o, c || u ? s.length : r.length), d = K(e, r, t);
                    return V(V([], l, !0), d, !0);
                }
                function H(e, t, r, n, i) {
                    var a = i[e.toString()] || [], o = X(a), s = !0 !== o.unmanaged, c = n[e];
                    if ((c = o.inject || o.multiInject || c) instanceof $ && (c = c.unwrap()), s) {
                        if (!t && (c === Object || c === Function || void 0 === c))
                            throw new Error('Missing required @inject or @multiInject annotation in: argument ' + e + ' in class ' + r + '.');
                        var u = new G(S.ConstructorArgument, o.targetName, c);
                        return u.metadata = a, u;
                    }
                    return null;
                }
                function W(e, t, r, n) {
                    var i = e || t;
                    if (void 0 === i) {
                        var a = I + ' for property ' + String(r) + ' in class ' + n + '.';
                        throw new Error(a);
                    }
                    return i;
                }
                function K(e, t, r) {
                    for (var n = e.getPropertiesMetadata(t), i = [], a = Object.getOwnPropertySymbols(n), o = 0, s = Object.keys(n).concat(a); o < s.length; o++) {
                        var c = s[o], u = n[c], l = X(u), d = l.targetName || c, p = W(l.inject, l.multiInject, c, r), f = new G(S.ClassProperty, d, p);
                        f.metadata = u, i.push(f);
                    }
                    var m = Object.getPrototypeOf(t.prototype).constructor;
                    if (m !== Object) {
                        var h = K(e, m, r);
                        i = V(V([], i, !0), h, !0);
                    }
                    return i;
                }
                function z(e, t) {
                    var r = Object.getPrototypeOf(t.prototype).constructor;
                    if (r !== Object) {
                        var n = U(e, w(r), r, !0), i = n.map(function (e) {
                                return e.metadata.filter(function (e) {
                                    return e.key === o;
                                });
                            }), a = [].concat.apply([], i).length, s = n.length - a;
                        return s > 0 ? s : z(e, r);
                    }
                    return 0;
                }
                function X(e) {
                    var t = {};
                    return e.forEach(function (e) {
                        t[e.key.toString()] = e.value;
                    }), {
                        inject: t[c],
                        multiInject: t[u],
                        targetName: t[a],
                        unmanaged: t[o]
                    };
                }
                var Y = function () {
                    function e(e, t, r, n, i) {
                        this.id = C(), this.serviceIdentifier = e, this.parentContext = t, this.parentRequest = r, this.target = i, this.childRequests = [], this.bindings = Array.isArray(n) ? n : [n], this.requestScope = null === r ? new Map() : null;
                    }
                    return e.prototype.addChildRequest = function (t, r, n) {
                        var i = new e(t, this.parentContext, this, r, n);
                        return this.childRequests.push(i), i;
                    }, e;
                }();
                function q(e) {
                    return e._bindingDictionary;
                }
                function Z(e, t, r, n, i) {
                    var a, o = Q(r.container, i.serviceIdentifier);
                    return 0 === o.length && r.container.options.autoBindInjectable && 'function' == typeof i.serviceIdentifier && e.getConstructorMetadata(i.serviceIdentifier).compilerGeneratedMetadata && (r.container.bind(i.serviceIdentifier).toSelf(), o = Q(r.container, i.serviceIdentifier)), a = t ? o : o.filter(function (e) {
                        var t = new Y(e.serviceIdentifier, r, n, e, i);
                        return e.constraint(t);
                    }), function (e, t, r, n) {
                        switch (t.length) {
                        case 0:
                            if (r.isOptional())
                                return t;
                            var i = M(e), a = 'No matching bindings found for serviceIdentifier:';
                            throw a += function (e, t) {
                                if (t.isTagged() || t.isNamed()) {
                                    var r = '', n = t.getNamedTag(), i = t.getCustomTags();
                                    return null !== n && (r += n.toString() + '\n'), null !== i && i.forEach(function (e) {
                                        r += e.toString() + '\n';
                                    }), ' ' + e + '\n ' + e + ' - ' + r;
                                }
                                return ' ' + e;
                            }(i, r), a += F(n, i, Q), new Error(a);
                        case 1:
                            return t;
                        case 2:
                        default:
                            if (r.isArray())
                                return t;
                            throw a = 'Ambiguous match found for serviceIdentifier: ' + (i = M(e)), a += F(n, i, Q), new Error(a);
                        }
                    }(i.serviceIdentifier, a, i, r.container), a;
                }
                function J(e, t, r, n, i, a) {
                    var o, s;
                    if (null === i) {
                        o = Z(e, t, n, null, a), s = new Y(r, n, null, o, a);
                        var c = new L(n, s);
                        n.addPlan(c);
                    } else
                        o = Z(e, t, n, i, a), s = i.addChildRequest(a.serviceIdentifier, o, a);
                    o.forEach(function (t) {
                        var r = null;
                        if (a.isArray())
                            r = s.addChildRequest(t.serviceIdentifier, t, a);
                        else {
                            if (t.cache)
                                return;
                            r = s;
                        }
                        if (t.type === b.Instance && null !== t.implementationType) {
                            var i = function (e, t) {
                                return U(e, w(t), t, !1);
                            }(e, t.implementationType);
                            if (!n.container.options.skipBaseClassChecks) {
                                var o = z(e, t.implementationType);
                                if (i.length < o) {
                                    var c = function () {
                                        for (var e = [], t = 0; t < arguments.length; t++)
                                            e[t] = arguments[t];
                                        return 'The number of constructor arguments in the derived class ' + e[0] + ' must be >= than the number of constructor arguments of its base class.';
                                    }(w(t.implementationType));
                                    throw new Error(c);
                                }
                            }
                            i.forEach(function (t) {
                                J(e, !1, t.serviceIdentifier, n, r, t);
                            });
                        }
                    });
                }
                function Q(e, t) {
                    var r = [], n = q(e);
                    return n.hasKey(t) ? r = n.get(t) : null !== e.parent && (r = Q(e.parent, t)), r;
                }
                function ee(e) {
                    return ('object' == typeof e && null !== e || 'function' == typeof e) && 'function' == typeof e.then;
                }
                function te(e) {
                    return !!ee(e) || Array.isArray(e) && e.some(ee);
                }
                var re, ne = function (e, t) {
                        return r = void 0, n = void 0, a = function () {
                            var r, n;
                            return function (e, t) {
                                var r, n, i, a, o = {
                                        label: 0,
                                        sent: function () {
                                            if (1 & i[0])
                                                throw i[1];
                                            return i[1];
                                        },
                                        trys: [],
                                        ops: []
                                    };
                                return a = {
                                    next: s(0),
                                    throw: s(1),
                                    return: s(2)
                                }, 'function' == typeof Symbol && (a[Symbol.iterator] = function () {
                                    return this;
                                }), a;
                                function s(a) {
                                    return function (s) {
                                        return function (a) {
                                            if (r)
                                                throw new TypeError('Generator is already executing.');
                                            for (; o;)
                                                try {
                                                    if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done)
                                                        return i;
                                                    switch (n = 0, i && (a = [
                                                            2 & a[0],
                                                            i.value
                                                        ]), a[0]) {
                                                    case 0:
                                                    case 1:
                                                        i = a;
                                                        break;
                                                    case 4:
                                                        return o.label++, {
                                                            value: a[1],
                                                            done: !1
                                                        };
                                                    case 5:
                                                        o.label++, n = a[1], a = [0];
                                                        continue;
                                                    case 7:
                                                        a = o.ops.pop(), o.trys.pop();
                                                        continue;
                                                    default:
                                                        if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                                            o = 0;
                                                            continue;
                                                        }
                                                        if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                                            o.label = a[1];
                                                            break;
                                                        }
                                                        if (6 === a[0] && o.label < i[1]) {
                                                            o.label = i[1], i = a;
                                                            break;
                                                        }
                                                        if (i && o.label < i[2]) {
                                                            o.label = i[2], o.ops.push(a);
                                                            break;
                                                        }
                                                        i[2] && o.ops.pop(), o.trys.pop();
                                                        continue;
                                                    }
                                                    a = t.call(e, o);
                                                } catch (e) {
                                                    a = [
                                                        6,
                                                        e
                                                    ], n = 0;
                                                } finally {
                                                    r = i = 0;
                                                }
                                            if (5 & a[0])
                                                throw a[1];
                                            return {
                                                value: a[0] ? a[1] : void 0,
                                                done: !0
                                            };
                                        }([
                                            a,
                                            s
                                        ]);
                                    };
                                }
                            }(this, function (i) {
                                switch (i.label) {
                                case 0:
                                    return i.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]), [
                                        4,
                                        t
                                    ];
                                case 1:
                                    return r = i.sent(), e.cache = r, [
                                        3,
                                        3
                                    ];
                                case 2:
                                    throw n = i.sent(), e.cache = null, e.activated = !1, n;
                                case 3:
                                    return [2];
                                }
                            });
                        }, new ((i = void 0) || (i = Promise))(function (e, t) {
                            function o(e) {
                                try {
                                    c(a.next(e));
                                } catch (e) {
                                    t(e);
                                }
                            }
                            function s(e) {
                                try {
                                    c(a.throw(e));
                                } catch (e) {
                                    t(e);
                                }
                            }
                            function c(t) {
                                var r;
                                t.done ? e(t.value) : (r = t.value, r instanceof i ? r : new i(function (e) {
                                    e(r);
                                })).then(o, s);
                            }
                            c((a = a.apply(r, n || [])).next());
                        });
                        var r, n, i, a;
                    };
                !function (e) {
                    e.DynamicValue = 'toDynamicValue', e.Factory = 'toFactory', e.Provider = 'toProvider';
                }(re || (re = {}));
                var ie = function (e) {
                        return function (t) {
                            return function () {
                                for (var r = [], n = 0; n < arguments.length; n++)
                                    r[n] = arguments[n];
                                return r.forEach(function (r) {
                                    return e.bind(r).toService(t);
                                });
                            };
                        };
                    }, ae = function () {
                        return (ae = Object.assign || function (e) {
                            for (var t, r = 1, n = arguments.length; r < n; r++)
                                for (var i in t = arguments[r])
                                    Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                            return e;
                        }).apply(this, arguments);
                    }, oe = function (e, t, r, n) {
                        return new (r || (r = Promise))(function (i, a) {
                            function o(e) {
                                try {
                                    c(n.next(e));
                                } catch (e) {
                                    a(e);
                                }
                            }
                            function s(e) {
                                try {
                                    c(n.throw(e));
                                } catch (e) {
                                    a(e);
                                }
                            }
                            function c(e) {
                                var t;
                                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                                    e(t);
                                })).then(o, s);
                            }
                            c((n = n.apply(e, t || [])).next());
                        });
                    }, se = function (e, t) {
                        var r, n, i, a, o = {
                                label: 0,
                                sent: function () {
                                    if (1 & i[0])
                                        throw i[1];
                                    return i[1];
                                },
                                trys: [],
                                ops: []
                            };
                        return a = {
                            next: s(0),
                            throw: s(1),
                            return: s(2)
                        }, 'function' == typeof Symbol && (a[Symbol.iterator] = function () {
                            return this;
                        }), a;
                        function s(a) {
                            return function (s) {
                                return function (a) {
                                    if (r)
                                        throw new TypeError('Generator is already executing.');
                                    for (; o;)
                                        try {
                                            if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done)
                                                return i;
                                            switch (n = 0, i && (a = [
                                                    2 & a[0],
                                                    i.value
                                                ]), a[0]) {
                                            case 0:
                                            case 1:
                                                i = a;
                                                break;
                                            case 4:
                                                return o.label++, {
                                                    value: a[1],
                                                    done: !1
                                                };
                                            case 5:
                                                o.label++, n = a[1], a = [0];
                                                continue;
                                            case 7:
                                                a = o.ops.pop(), o.trys.pop();
                                                continue;
                                            default:
                                                if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                                    o = 0;
                                                    continue;
                                                }
                                                if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                                    o.label = a[1];
                                                    break;
                                                }
                                                if (6 === a[0] && o.label < i[1]) {
                                                    o.label = i[1], i = a;
                                                    break;
                                                }
                                                if (i && o.label < i[2]) {
                                                    o.label = i[2], o.ops.push(a);
                                                    break;
                                                }
                                                i[2] && o.ops.pop(), o.trys.pop();
                                                continue;
                                            }
                                            a = t.call(e, o);
                                        } catch (e) {
                                            a = [
                                                6,
                                                e
                                            ], n = 0;
                                        } finally {
                                            r = i = 0;
                                        }
                                    if (5 & a[0])
                                        throw a[1];
                                    return {
                                        value: a[0] ? a[1] : void 0,
                                        done: !0
                                    };
                                }([
                                    a,
                                    s
                                ]);
                            };
                        }
                    };
                function ce(e) {
                    var t, r = new ((t = e.constr).bind.apply(t, function (e, t, r) {
                            if (r || 2 === arguments.length)
                                for (var n, i = 0, a = t.length; i < a; i++)
                                    !n && i in t || (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
                            return e.concat(n || Array.prototype.slice.call(t));
                        }([void 0], e.constructorInjections, !1)))();
                    return e.propertyRequests.forEach(function (t, n) {
                        var i = t.target.identifier, a = e.propertyInjections[n];
                        r[i] = a;
                    }), r;
                }
                function ue(e) {
                    return oe(this, void 0, void 0, function () {
                        var t, r, n, i;
                        return se(this, function (a) {
                            for (t = [], r = 0, n = e; r < n.length; r++)
                                i = n[r], Array.isArray(i) ? t.push(Promise.all(i)) : t.push(i);
                            return [
                                2,
                                Promise.all(t)
                            ];
                        });
                    });
                }
                function le(e, t) {
                    var r = function (e, t) {
                        var r, n;
                        if (Reflect.hasMetadata(m, e)) {
                            var i = Reflect.getMetadata(m, e);
                            try {
                                return null === (n = (r = t)[i.value]) || void 0 === n ? void 0 : n.call(r);
                            } catch (t) {
                                throw new Error('@postConstruct error in class ' + e.name + ': ' + t.message);
                            }
                        }
                    }(e, t);
                    return ee(r) ? r.then(function () {
                        return t;
                    }) : t;
                }
                var de = function (e) {
                        return function (t) {
                            t.parentContext.setCurrentRequest(t);
                            var r = t.bindings, n = t.childRequests, i = t.target && t.target.isArray(), a = !(t.parentRequest && t.parentRequest.target && t.target && t.parentRequest.target.matchesArray(t.target.serviceIdentifier));
                            if (i && a)
                                return n.map(function (t) {
                                    return de(e)(t);
                                });
                            if (!t.target.isOptional() || 0 !== r.length) {
                                var o = r[0];
                                return he(e, t, o);
                            }
                        };
                    }, pe = function (e, t) {
                        var r = function (e) {
                            switch (e.type) {
                            case b.Factory:
                                return {
                                    factory: e.factory,
                                    factoryType: re.Factory
                                };
                            case b.Provider:
                                return {
                                    factory: e.provider,
                                    factoryType: re.Provider
                                };
                            case b.DynamicValue:
                                return {
                                    factory: e.dynamicValue,
                                    factoryType: re.DynamicValue
                                };
                            default:
                                throw new Error('Unexpected factory type ' + e.type);
                            }
                        }(e);
                        return function (n, i) {
                            try {
                                return r.factory.bind(e)(t);
                            } catch (e) {
                                throw R(e) && (e = new Error((a = r.factoryType, o = t.currentRequest.serviceIdentifier.toString(), 'It looks like there is a circular dependency in one of the \'' + a + '\' bindings. Please investigate bindings withservice identifier \'' + o + '\'.'))), e;
                            }
                            var a, o;
                        }();
                    }, fe = function (e, t, r) {
                        var n, i = t.childRequests;
                        switch (function (e) {
                                var t = null;
                                switch (e.type) {
                                case b.ConstantValue:
                                case b.Function:
                                    t = e.cache;
                                    break;
                                case b.Constructor:
                                case b.Instance:
                                    t = e.implementationType;
                                    break;
                                case b.DynamicValue:
                                    t = e.dynamicValue;
                                    break;
                                case b.Provider:
                                    t = e.provider;
                                    break;
                                case b.Factory:
                                    t = e.factory;
                                }
                                if (null === t) {
                                    var r = M(e.serviceIdentifier);
                                    throw new Error('Invalid binding type: ' + r);
                                }
                            }(r), r.type) {
                        case b.ConstantValue:
                        case b.Function:
                            n = r.cache;
                            break;
                        case b.Constructor:
                            n = r.implementationType;
                            break;
                        case b.Instance:
                            n = function (e, t, r, n) {
                                !function (e, t) {
                                    e.scope !== y.Singleton && function (e, t) {
                                        var r = 'Class cannot be instantiated in ' + (e.scope === y.Request ? 'request' : 'transient') + ' scope.';
                                        if ('function' == typeof e.onDeactivation)
                                            throw new Error(D(t.name, r));
                                        if (Reflect.hasMetadata(h, t))
                                            throw new Error('@preDestroy error in class ' + t.name + ': ' + r);
                                    }(e, t);
                                }(e, t);
                                var i = function (e, t, r) {
                                    var n;
                                    if (t.length > 0) {
                                        var i = function (e, t) {
                                                return e.reduce(function (e, r) {
                                                    var n = t(r);
                                                    return r.target.type === S.ConstructorArgument ? e.constructorInjections.push(n) : (e.propertyRequests.push(r), e.propertyInjections.push(n)), e.isAsync || (e.isAsync = te(n)), e;
                                                }, {
                                                    constructorInjections: [],
                                                    propertyInjections: [],
                                                    propertyRequests: [],
                                                    isAsync: !1
                                                });
                                            }(t, r), a = ae(ae({}, i), { constr: e });
                                        n = i.isAsync ? function (e) {
                                            return oe(this, void 0, void 0, function () {
                                                var t, r;
                                                return se(this, function (n) {
                                                    switch (n.label) {
                                                    case 0:
                                                        return [
                                                            4,
                                                            ue(e.constructorInjections)
                                                        ];
                                                    case 1:
                                                        return t = n.sent(), [
                                                            4,
                                                            ue(e.propertyInjections)
                                                        ];
                                                    case 2:
                                                        return r = n.sent(), [
                                                            2,
                                                            ce(ae(ae({}, e), {
                                                                constructorInjections: t,
                                                                propertyInjections: r
                                                            }))
                                                        ];
                                                    }
                                                });
                                            });
                                        }(a) : ce(a);
                                    } else
                                        n = new e();
                                    return n;
                                }(t, r, n);
                                return ee(i) ? i.then(function (e) {
                                    return le(t, e);
                                }) : le(t, i);
                            }(r, r.implementationType, i, de(e));
                            break;
                        default:
                            n = pe(r, t.parentContext);
                        }
                        return n;
                    }, me = function (e, t, r) {
                        var n = function (e, t) {
                            return t.scope === y.Singleton && t.activated ? t.cache : t.scope === y.Request && e.has(t.id) ? e.get(t.id) : null;
                        }(e, t);
                        return null !== n || function (e, t, r) {
                            t.scope === y.Singleton && function (e, t) {
                                e.cache = t, e.activated = !0, ee(t) && ne(e, t);
                            }(t, r), t.scope === y.Request && function (e, t, r) {
                                e.has(t.id) || e.set(t.id, r);
                            }(e, t, r);
                        }(e, t, n = r()), n;
                    }, he = function (e, t, r) {
                        return me(e, r, function () {
                            var n = fe(e, t, r);
                            return ee(n) ? n.then(function (e) {
                                return ge(t, r, e);
                            }) : ge(t, r, n);
                        });
                    };
                function ge(e, t, r) {
                    var n, i = ye(e.parentContext, t, r), a = Ce(e.parentContext.container), o = a.next();
                    do {
                        n = o.value;
                        var s = e.parentContext, c = e.serviceIdentifier, u = ve(n, c);
                        i = ee(i) ? Se(u, s, i) : be(u, s, i), o = a.next();
                    } while (!0 !== o.done && !q(n).hasKey(e.serviceIdentifier));
                    return i;
                }
                var ye = function (e, t, r) {
                        return 'function' == typeof t.onActivation ? t.onActivation(e, r) : r;
                    }, be = function (e, t, r) {
                        for (var n = e.next(); !n.done;) {
                            if (ee(r = n.value(t, r)))
                                return Se(e, t, r);
                            n = e.next();
                        }
                        return r;
                    }, Se = function (e, t, r) {
                        return n = void 0, i = void 0, o = function () {
                            var n, i;
                            return function (e, t) {
                                var r, n, i, a, o = {
                                        label: 0,
                                        sent: function () {
                                            if (1 & i[0])
                                                throw i[1];
                                            return i[1];
                                        },
                                        trys: [],
                                        ops: []
                                    };
                                return a = {
                                    next: s(0),
                                    throw: s(1),
                                    return: s(2)
                                }, 'function' == typeof Symbol && (a[Symbol.iterator] = function () {
                                    return this;
                                }), a;
                                function s(a) {
                                    return function (s) {
                                        return function (a) {
                                            if (r)
                                                throw new TypeError('Generator is already executing.');
                                            for (; o;)
                                                try {
                                                    if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done)
                                                        return i;
                                                    switch (n = 0, i && (a = [
                                                            2 & a[0],
                                                            i.value
                                                        ]), a[0]) {
                                                    case 0:
                                                    case 1:
                                                        i = a;
                                                        break;
                                                    case 4:
                                                        return o.label++, {
                                                            value: a[1],
                                                            done: !1
                                                        };
                                                    case 5:
                                                        o.label++, n = a[1], a = [0];
                                                        continue;
                                                    case 7:
                                                        a = o.ops.pop(), o.trys.pop();
                                                        continue;
                                                    default:
                                                        if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                                            o = 0;
                                                            continue;
                                                        }
                                                        if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                                            o.label = a[1];
                                                            break;
                                                        }
                                                        if (6 === a[0] && o.label < i[1]) {
                                                            o.label = i[1], i = a;
                                                            break;
                                                        }
                                                        if (i && o.label < i[2]) {
                                                            o.label = i[2], o.ops.push(a);
                                                            break;
                                                        }
                                                        i[2] && o.ops.pop(), o.trys.pop();
                                                        continue;
                                                    }
                                                    a = t.call(e, o);
                                                } catch (e) {
                                                    a = [
                                                        6,
                                                        e
                                                    ], n = 0;
                                                } finally {
                                                    r = i = 0;
                                                }
                                            if (5 & a[0])
                                                throw a[1];
                                            return {
                                                value: a[0] ? a[1] : void 0,
                                                done: !0
                                            };
                                        }([
                                            a,
                                            s
                                        ]);
                                    };
                                }
                            }(this, function (a) {
                                switch (a.label) {
                                case 0:
                                    return [
                                        4,
                                        r
                                    ];
                                case 1:
                                    n = a.sent(), i = e.next(), a.label = 2;
                                case 2:
                                    return i.done ? [
                                        3,
                                        4
                                    ] : [
                                        4,
                                        i.value(t, n)
                                    ];
                                case 3:
                                    return n = a.sent(), i = e.next(), [
                                        3,
                                        2
                                    ];
                                case 4:
                                    return [
                                        2,
                                        n
                                    ];
                                }
                            });
                        }, new ((a = void 0) || (a = Promise))(function (e, t) {
                            function r(e) {
                                try {
                                    c(o.next(e));
                                } catch (e) {
                                    t(e);
                                }
                            }
                            function s(e) {
                                try {
                                    c(o.throw(e));
                                } catch (e) {
                                    t(e);
                                }
                            }
                            function c(t) {
                                var n;
                                t.done ? e(t.value) : (n = t.value, n instanceof a ? n : new a(function (e) {
                                    e(n);
                                })).then(r, s);
                            }
                            c((o = o.apply(n, i || [])).next());
                        });
                        var n, i, a, o;
                    }, ve = function (e, t) {
                        var r = e._activations;
                        return r.hasKey(t) ? r.get(t).values() : [].values();
                    }, Ce = function (e) {
                        for (var t = [e], r = e.parent; null !== r;)
                            t.push(r), r = r.parent;
                        return {
                            next: function () {
                                var e = t.pop();
                                return void 0 !== e ? {
                                    done: !1,
                                    value: e
                                } : {
                                    done: !0,
                                    value: void 0
                                };
                            }
                        };
                    }, Ae = function (e, t) {
                        var r = e.parentRequest;
                        return null !== r && (!!t(r) || Ae(r, t));
                    }, _e = function (e) {
                        return function (t) {
                            var r = function (r) {
                                return null !== r && null !== r.target && r.target.matchesTag(e)(t);
                            };
                            return r.metaData = new k(e, t), r;
                        };
                    }, Ee = _e(i), Ne = function (e) {
                        return function (t) {
                            var r = null;
                            if (null !== t) {
                                if (r = t.bindings[0], 'string' == typeof e)
                                    return r.serviceIdentifier === e;
                                var n = t.bindings[0].implementationType;
                                return e === n;
                            }
                            return !1;
                        };
                    }, Ie = function () {
                        function e(e) {
                            this._binding = e;
                        }
                        return e.prototype.when = function (e) {
                            return this._binding.constraint = e, new Te(this._binding);
                        }, e.prototype.whenTargetNamed = function (e) {
                            return this._binding.constraint = Ee(e), new Te(this._binding);
                        }, e.prototype.whenTargetIsDefault = function () {
                            return this._binding.constraint = function (e) {
                                return null !== e && null !== e.target && !e.target.isNamed() && !e.target.isTagged();
                            }, new Te(this._binding);
                        }, e.prototype.whenTargetTagged = function (e, t) {
                            return this._binding.constraint = _e(e)(t), new Te(this._binding);
                        }, e.prototype.whenInjectedInto = function (e) {
                            return this._binding.constraint = function (t) {
                                return null !== t && Ne(e)(t.parentRequest);
                            }, new Te(this._binding);
                        }, e.prototype.whenParentNamed = function (e) {
                            return this._binding.constraint = function (t) {
                                return null !== t && Ee(e)(t.parentRequest);
                            }, new Te(this._binding);
                        }, e.prototype.whenParentTagged = function (e, t) {
                            return this._binding.constraint = function (r) {
                                return null !== r && _e(e)(t)(r.parentRequest);
                            }, new Te(this._binding);
                        }, e.prototype.whenAnyAncestorIs = function (e) {
                            return this._binding.constraint = function (t) {
                                return null !== t && Ae(t, Ne(e));
                            }, new Te(this._binding);
                        }, e.prototype.whenNoAncestorIs = function (e) {
                            return this._binding.constraint = function (t) {
                                return null !== t && !Ae(t, Ne(e));
                            }, new Te(this._binding);
                        }, e.prototype.whenAnyAncestorNamed = function (e) {
                            return this._binding.constraint = function (t) {
                                return null !== t && Ae(t, Ee(e));
                            }, new Te(this._binding);
                        }, e.prototype.whenNoAncestorNamed = function (e) {
                            return this._binding.constraint = function (t) {
                                return null !== t && !Ae(t, Ee(e));
                            }, new Te(this._binding);
                        }, e.prototype.whenAnyAncestorTagged = function (e, t) {
                            return this._binding.constraint = function (r) {
                                return null !== r && Ae(r, _e(e)(t));
                            }, new Te(this._binding);
                        }, e.prototype.whenNoAncestorTagged = function (e, t) {
                            return this._binding.constraint = function (r) {
                                return null !== r && !Ae(r, _e(e)(t));
                            }, new Te(this._binding);
                        }, e.prototype.whenAnyAncestorMatches = function (e) {
                            return this._binding.constraint = function (t) {
                                return null !== t && Ae(t, e);
                            }, new Te(this._binding);
                        }, e.prototype.whenNoAncestorMatches = function (e) {
                            return this._binding.constraint = function (t) {
                                return null !== t && !Ae(t, e);
                            }, new Te(this._binding);
                        }, e;
                    }(), Te = function () {
                        function e(e) {
                            this._binding = e;
                        }
                        return e.prototype.onActivation = function (e) {
                            return this._binding.onActivation = e, new Ie(this._binding);
                        }, e.prototype.onDeactivation = function (e) {
                            return this._binding.onDeactivation = e, new Ie(this._binding);
                        }, e;
                    }(), De = function () {
                        function e(e) {
                            this._binding = e, this._bindingWhenSyntax = new Ie(this._binding), this._bindingOnSyntax = new Te(this._binding);
                        }
                        return e.prototype.when = function (e) {
                            return this._bindingWhenSyntax.when(e);
                        }, e.prototype.whenTargetNamed = function (e) {
                            return this._bindingWhenSyntax.whenTargetNamed(e);
                        }, e.prototype.whenTargetIsDefault = function () {
                            return this._bindingWhenSyntax.whenTargetIsDefault();
                        }, e.prototype.whenTargetTagged = function (e, t) {
                            return this._bindingWhenSyntax.whenTargetTagged(e, t);
                        }, e.prototype.whenInjectedInto = function (e) {
                            return this._bindingWhenSyntax.whenInjectedInto(e);
                        }, e.prototype.whenParentNamed = function (e) {
                            return this._bindingWhenSyntax.whenParentNamed(e);
                        }, e.prototype.whenParentTagged = function (e, t) {
                            return this._bindingWhenSyntax.whenParentTagged(e, t);
                        }, e.prototype.whenAnyAncestorIs = function (e) {
                            return this._bindingWhenSyntax.whenAnyAncestorIs(e);
                        }, e.prototype.whenNoAncestorIs = function (e) {
                            return this._bindingWhenSyntax.whenNoAncestorIs(e);
                        }, e.prototype.whenAnyAncestorNamed = function (e) {
                            return this._bindingWhenSyntax.whenAnyAncestorNamed(e);
                        }, e.prototype.whenAnyAncestorTagged = function (e, t) {
                            return this._bindingWhenSyntax.whenAnyAncestorTagged(e, t);
                        }, e.prototype.whenNoAncestorNamed = function (e) {
                            return this._bindingWhenSyntax.whenNoAncestorNamed(e);
                        }, e.prototype.whenNoAncestorTagged = function (e, t) {
                            return this._bindingWhenSyntax.whenNoAncestorTagged(e, t);
                        }, e.prototype.whenAnyAncestorMatches = function (e) {
                            return this._bindingWhenSyntax.whenAnyAncestorMatches(e);
                        }, e.prototype.whenNoAncestorMatches = function (e) {
                            return this._bindingWhenSyntax.whenNoAncestorMatches(e);
                        }, e.prototype.onActivation = function (e) {
                            return this._bindingOnSyntax.onActivation(e);
                        }, e.prototype.onDeactivation = function (e) {
                            return this._bindingOnSyntax.onDeactivation(e);
                        }, e;
                    }(), Oe = function () {
                        function e(e) {
                            this._binding = e;
                        }
                        return e.prototype.inRequestScope = function () {
                            return this._binding.scope = y.Request, new De(this._binding);
                        }, e.prototype.inSingletonScope = function () {
                            return this._binding.scope = y.Singleton, new De(this._binding);
                        }, e.prototype.inTransientScope = function () {
                            return this._binding.scope = y.Transient, new De(this._binding);
                        }, e;
                    }(), Re = function () {
                        function e(e) {
                            this._binding = e, this._bindingWhenSyntax = new Ie(this._binding), this._bindingOnSyntax = new Te(this._binding), this._bindingInSyntax = new Oe(e);
                        }
                        return e.prototype.inRequestScope = function () {
                            return this._bindingInSyntax.inRequestScope();
                        }, e.prototype.inSingletonScope = function () {
                            return this._bindingInSyntax.inSingletonScope();
                        }, e.prototype.inTransientScope = function () {
                            return this._bindingInSyntax.inTransientScope();
                        }, e.prototype.when = function (e) {
                            return this._bindingWhenSyntax.when(e);
                        }, e.prototype.whenTargetNamed = function (e) {
                            return this._bindingWhenSyntax.whenTargetNamed(e);
                        }, e.prototype.whenTargetIsDefault = function () {
                            return this._bindingWhenSyntax.whenTargetIsDefault();
                        }, e.prototype.whenTargetTagged = function (e, t) {
                            return this._bindingWhenSyntax.whenTargetTagged(e, t);
                        }, e.prototype.whenInjectedInto = function (e) {
                            return this._bindingWhenSyntax.whenInjectedInto(e);
                        }, e.prototype.whenParentNamed = function (e) {
                            return this._bindingWhenSyntax.whenParentNamed(e);
                        }, e.prototype.whenParentTagged = function (e, t) {
                            return this._bindingWhenSyntax.whenParentTagged(e, t);
                        }, e.prototype.whenAnyAncestorIs = function (e) {
                            return this._bindingWhenSyntax.whenAnyAncestorIs(e);
                        }, e.prototype.whenNoAncestorIs = function (e) {
                            return this._bindingWhenSyntax.whenNoAncestorIs(e);
                        }, e.prototype.whenAnyAncestorNamed = function (e) {
                            return this._bindingWhenSyntax.whenAnyAncestorNamed(e);
                        }, e.prototype.whenAnyAncestorTagged = function (e, t) {
                            return this._bindingWhenSyntax.whenAnyAncestorTagged(e, t);
                        }, e.prototype.whenNoAncestorNamed = function (e) {
                            return this._bindingWhenSyntax.whenNoAncestorNamed(e);
                        }, e.prototype.whenNoAncestorTagged = function (e, t) {
                            return this._bindingWhenSyntax.whenNoAncestorTagged(e, t);
                        }, e.prototype.whenAnyAncestorMatches = function (e) {
                            return this._bindingWhenSyntax.whenAnyAncestorMatches(e);
                        }, e.prototype.whenNoAncestorMatches = function (e) {
                            return this._bindingWhenSyntax.whenNoAncestorMatches(e);
                        }, e.prototype.onActivation = function (e) {
                            return this._bindingOnSyntax.onActivation(e);
                        }, e.prototype.onDeactivation = function (e) {
                            return this._bindingOnSyntax.onDeactivation(e);
                        }, e;
                    }(), Me = function () {
                        function e(e) {
                            this._binding = e;
                        }
                        return e.prototype.to = function (e) {
                            return this._binding.type = b.Instance, this._binding.implementationType = e, new Re(this._binding);
                        }, e.prototype.toSelf = function () {
                            if ('function' != typeof this._binding.serviceIdentifier)
                                throw new Error('The toSelf function can only be applied when a constructor is used as service identifier');
                            var e = this._binding.serviceIdentifier;
                            return this.to(e);
                        }, e.prototype.toConstantValue = function (e) {
                            return this._binding.type = b.ConstantValue, this._binding.cache = e, this._binding.dynamicValue = null, this._binding.implementationType = null, this._binding.scope = y.Singleton, new De(this._binding);
                        }, e.prototype.toDynamicValue = function (e) {
                            return this._binding.type = b.DynamicValue, this._binding.cache = null, this._binding.dynamicValue = e, this._binding.implementationType = null, new Re(this._binding);
                        }, e.prototype.toConstructor = function (e) {
                            return this._binding.type = b.Constructor, this._binding.implementationType = e, this._binding.scope = y.Singleton, new De(this._binding);
                        }, e.prototype.toFactory = function (e) {
                            return this._binding.type = b.Factory, this._binding.factory = e, this._binding.scope = y.Singleton, new De(this._binding);
                        }, e.prototype.toFunction = function (e) {
                            if ('function' != typeof e)
                                throw new Error('Value provided to function binding must be a function!');
                            var t = this.toConstantValue(e);
                            return this._binding.type = b.Function, this._binding.scope = y.Singleton, t;
                        }, e.prototype.toAutoFactory = function (e) {
                            return this._binding.type = b.Factory, this._binding.factory = function (t) {
                                return function () {
                                    return t.container.get(e);
                                };
                            }, this._binding.scope = y.Singleton, new De(this._binding);
                        }, e.prototype.toAutoNamedFactory = function (e) {
                            return this._binding.type = b.Factory, this._binding.factory = function (t) {
                                return function (r) {
                                    return t.container.getNamed(e, r);
                                };
                            }, new De(this._binding);
                        }, e.prototype.toProvider = function (e) {
                            return this._binding.type = b.Provider, this._binding.provider = e, this._binding.scope = y.Singleton, new De(this._binding);
                        }, e.prototype.toService = function (e) {
                            this.toDynamicValue(function (t) {
                                return t.container.get(e);
                            });
                        }, e;
                    }(), Fe = function () {
                        function e() {
                        }
                        return e.of = function (t, r, n, i, a) {
                            var o = new e();
                            return o.bindings = t, o.middleware = r, o.deactivations = i, o.activations = n, o.moduleActivationStore = a, o;
                        }, e;
                    }(), Pe = function () {
                        function e() {
                            this._map = new Map();
                        }
                        return e.prototype.getMap = function () {
                            return this._map;
                        }, e.prototype.add = function (e, t) {
                            if (null == e)
                                throw new Error(E);
                            if (null == t)
                                throw new Error(E);
                            var r = this._map.get(e);
                            void 0 !== r ? r.push(t) : this._map.set(e, [t]);
                        }, e.prototype.get = function (e) {
                            if (null == e)
                                throw new Error(E);
                            var t = this._map.get(e);
                            if (void 0 !== t)
                                return t;
                            throw new Error(N);
                        }, e.prototype.remove = function (e) {
                            if (null == e)
                                throw new Error(E);
                            if (!this._map.delete(e))
                                throw new Error(N);
                        }, e.prototype.removeIntersection = function (e) {
                            var t = this;
                            this.traverse(function (r, n) {
                                var i = e.hasKey(r) ? e.get(r) : void 0;
                                if (void 0 !== i) {
                                    var a = n.filter(function (e) {
                                        return !i.some(function (t) {
                                            return e === t;
                                        });
                                    });
                                    t._setValue(r, a);
                                }
                            });
                        }, e.prototype.removeByCondition = function (e) {
                            var t = this, r = [];
                            return this._map.forEach(function (n, i) {
                                for (var a = [], o = 0, s = n; o < s.length; o++) {
                                    var c = s[o];
                                    e(c) ? r.push(c) : a.push(c);
                                }
                                t._setValue(i, a);
                            }), r;
                        }, e.prototype.hasKey = function (e) {
                            if (null == e)
                                throw new Error(E);
                            return this._map.has(e);
                        }, e.prototype.clone = function () {
                            var t = new e();
                            return this._map.forEach(function (e, r) {
                                e.forEach(function (e) {
                                    return t.add(r, 'object' == typeof (n = e) && null !== n && 'clone' in n && 'function' == typeof n.clone ? e.clone() : e);
                                    var n;
                                });
                            }), t;
                        }, e.prototype.traverse = function (e) {
                            this._map.forEach(function (t, r) {
                                e(r, t);
                            });
                        }, e.prototype._setValue = function (e, t) {
                            t.length > 0 ? this._map.set(e, t) : this._map.delete(e);
                        }, e;
                    }(), xe = function () {
                        function e() {
                            this._map = new Map();
                        }
                        return e.prototype.remove = function (e) {
                            if (this._map.has(e)) {
                                var t = this._map.get(e);
                                return this._map.delete(e), t;
                            }
                            return this._getEmptyHandlersStore();
                        }, e.prototype.addDeactivation = function (e, t, r) {
                            this._getModuleActivationHandlers(e).onDeactivations.add(t, r);
                        }, e.prototype.addActivation = function (e, t, r) {
                            this._getModuleActivationHandlers(e).onActivations.add(t, r);
                        }, e.prototype.clone = function () {
                            var t = new e();
                            return this._map.forEach(function (e, r) {
                                t._map.set(r, {
                                    onActivations: e.onActivations.clone(),
                                    onDeactivations: e.onDeactivations.clone()
                                });
                            }), t;
                        }, e.prototype._getModuleActivationHandlers = function (e) {
                            var t = this._map.get(e);
                            return void 0 === t && (t = this._getEmptyHandlersStore(), this._map.set(e, t)), t;
                        }, e.prototype._getEmptyHandlersStore = function () {
                            return {
                                onActivations: new Pe(),
                                onDeactivations: new Pe()
                            };
                        }, e;
                    }(), we = function () {
                        return (we = Object.assign || function (e) {
                            for (var t, r = 1, n = arguments.length; r < n; r++)
                                for (var i in t = arguments[r])
                                    Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                            return e;
                        }).apply(this, arguments);
                    }, Be = function (e, t, r, n) {
                        return new (r || (r = Promise))(function (i, a) {
                            function o(e) {
                                try {
                                    c(n.next(e));
                                } catch (e) {
                                    a(e);
                                }
                            }
                            function s(e) {
                                try {
                                    c(n.throw(e));
                                } catch (e) {
                                    a(e);
                                }
                            }
                            function c(e) {
                                var t;
                                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                                    e(t);
                                })).then(o, s);
                            }
                            c((n = n.apply(e, t || [])).next());
                        });
                    }, ke = function (e, t) {
                        var r, n, i, a, o = {
                                label: 0,
                                sent: function () {
                                    if (1 & i[0])
                                        throw i[1];
                                    return i[1];
                                },
                                trys: [],
                                ops: []
                            };
                        return a = {
                            next: s(0),
                            throw: s(1),
                            return: s(2)
                        }, 'function' == typeof Symbol && (a[Symbol.iterator] = function () {
                            return this;
                        }), a;
                        function s(a) {
                            return function (s) {
                                return function (a) {
                                    if (r)
                                        throw new TypeError('Generator is already executing.');
                                    for (; o;)
                                        try {
                                            if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done)
                                                return i;
                                            switch (n = 0, i && (a = [
                                                    2 & a[0],
                                                    i.value
                                                ]), a[0]) {
                                            case 0:
                                            case 1:
                                                i = a;
                                                break;
                                            case 4:
                                                return o.label++, {
                                                    value: a[1],
                                                    done: !1
                                                };
                                            case 5:
                                                o.label++, n = a[1], a = [0];
                                                continue;
                                            case 7:
                                                a = o.ops.pop(), o.trys.pop();
                                                continue;
                                            default:
                                                if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                                    o = 0;
                                                    continue;
                                                }
                                                if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                                    o.label = a[1];
                                                    break;
                                                }
                                                if (6 === a[0] && o.label < i[1]) {
                                                    o.label = i[1], i = a;
                                                    break;
                                                }
                                                if (i && o.label < i[2]) {
                                                    o.label = i[2], o.ops.push(a);
                                                    break;
                                                }
                                                i[2] && o.ops.pop(), o.trys.pop();
                                                continue;
                                            }
                                            a = t.call(e, o);
                                        } catch (e) {
                                            a = [
                                                6,
                                                e
                                            ], n = 0;
                                        } finally {
                                            r = i = 0;
                                        }
                                    if (5 & a[0])
                                        throw a[1];
                                    return {
                                        value: a[0] ? a[1] : void 0,
                                        done: !0
                                    };
                                }([
                                    a,
                                    s
                                ]);
                            };
                        }
                    }, Le = function (e, t, r) {
                        if (r || 2 === arguments.length)
                            for (var n, i = 0, a = t.length; i < a; i++)
                                !n && i in t || (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
                        return e.concat(n || Array.prototype.slice.call(t));
                    }, $e = function () {
                        function e(e) {
                            var t = e || {};
                            if ('object' != typeof t)
                                throw new Error('Invalid Container constructor argument. Container options must be an object.');
                            if (void 0 === t.defaultScope)
                                t.defaultScope = y.Transient;
                            else if (t.defaultScope !== y.Singleton && t.defaultScope !== y.Transient && t.defaultScope !== y.Request)
                                throw new Error('Invalid Container option. Default scope must be a string (\'singleton\' or \'transient\').');
                            if (void 0 === t.autoBindInjectable)
                                t.autoBindInjectable = !1;
                            else if ('boolean' != typeof t.autoBindInjectable)
                                throw new Error('Invalid Container option. Auto bind injectable must be a boolean');
                            if (void 0 === t.skipBaseClassChecks)
                                t.skipBaseClassChecks = !1;
                            else if ('boolean' != typeof t.skipBaseClassChecks)
                                throw new Error('Invalid Container option. Skip base check must be a boolean');
                            this.options = {
                                autoBindInjectable: t.autoBindInjectable,
                                defaultScope: t.defaultScope,
                                skipBaseClassChecks: t.skipBaseClassChecks
                            }, this.id = C(), this._bindingDictionary = new Pe(), this._snapshots = [], this._middleware = null, this._activations = new Pe(), this._deactivations = new Pe(), this.parent = null, this._metadataReader = new O(), this._moduleActivationStore = new xe();
                        }
                        return e.merge = function (t, r) {
                            for (var n = [], i = 2; i < arguments.length; i++)
                                n[i - 2] = arguments[i];
                            var a = new e(), o = Le([
                                    t,
                                    r
                                ], n, !0).map(function (e) {
                                    return q(e);
                                }), s = q(a);
                            function c(e, t) {
                                e.traverse(function (e, r) {
                                    r.forEach(function (e) {
                                        t.add(e.serviceIdentifier, e.clone());
                                    });
                                });
                            }
                            return o.forEach(function (e) {
                                c(e, s);
                            }), a;
                        }, e.prototype.load = function () {
                            for (var e = [], t = 0; t < arguments.length; t++)
                                e[t] = arguments[t];
                            for (var r = this._getContainerModuleHelpersFactory(), n = 0, i = e; n < i.length; n++) {
                                var a = i[n], o = r(a.id);
                                a.registry(o.bindFunction, o.unbindFunction, o.isboundFunction, o.rebindFunction, o.unbindAsyncFunction, o.onActivationFunction, o.onDeactivationFunction);
                            }
                        }, e.prototype.loadAsync = function () {
                            for (var e = [], t = 0; t < arguments.length; t++)
                                e[t] = arguments[t];
                            return Be(this, void 0, void 0, function () {
                                var t, r, n, i, a;
                                return ke(this, function (o) {
                                    switch (o.label) {
                                    case 0:
                                        t = this._getContainerModuleHelpersFactory(), r = 0, n = e, o.label = 1;
                                    case 1:
                                        return r < n.length ? (i = n[r], a = t(i.id), [
                                            4,
                                            i.registry(a.bindFunction, a.unbindFunction, a.isboundFunction, a.rebindFunction, a.unbindAsyncFunction, a.onActivationFunction, a.onDeactivationFunction)
                                        ]) : [
                                            3,
                                            4
                                        ];
                                    case 2:
                                        o.sent(), o.label = 3;
                                    case 3:
                                        return r++, [
                                            3,
                                            1
                                        ];
                                    case 4:
                                        return [2];
                                    }
                                });
                            });
                        }, e.prototype.unload = function () {
                            for (var e = this, t = [], r = 0; r < arguments.length; r++)
                                t[r] = arguments[r];
                            t.forEach(function (t) {
                                var r = e._removeModuleBindings(t.id);
                                e._deactivateSingletons(r), e._removeModuleHandlers(t.id);
                            });
                        }, e.prototype.unloadAsync = function () {
                            for (var e = [], t = 0; t < arguments.length; t++)
                                e[t] = arguments[t];
                            return Be(this, void 0, void 0, function () {
                                var t, r, n, i;
                                return ke(this, function (a) {
                                    switch (a.label) {
                                    case 0:
                                        t = 0, r = e, a.label = 1;
                                    case 1:
                                        return t < r.length ? (n = r[t], i = this._removeModuleBindings(n.id), [
                                            4,
                                            this._deactivateSingletonsAsync(i)
                                        ]) : [
                                            3,
                                            4
                                        ];
                                    case 2:
                                        a.sent(), this._removeModuleHandlers(n.id), a.label = 3;
                                    case 3:
                                        return t++, [
                                            3,
                                            1
                                        ];
                                    case 4:
                                        return [2];
                                    }
                                });
                            });
                        }, e.prototype.bind = function (e) {
                            var t = this.options.defaultScope || y.Transient, r = new A(e, t);
                            return this._bindingDictionary.add(e, r), new Me(r);
                        }, e.prototype.rebind = function (e) {
                            return this.unbind(e), this.bind(e);
                        }, e.prototype.rebindAsync = function (e) {
                            return Be(this, void 0, void 0, function () {
                                return ke(this, function (t) {
                                    switch (t.label) {
                                    case 0:
                                        return [
                                            4,
                                            this.unbindAsync(e)
                                        ];
                                    case 1:
                                        return t.sent(), [
                                            2,
                                            this.bind(e)
                                        ];
                                    }
                                });
                            });
                        }, e.prototype.unbind = function (e) {
                            if (this._bindingDictionary.hasKey(e)) {
                                var t = this._bindingDictionary.get(e);
                                this._deactivateSingletons(t);
                            }
                            this._removeServiceFromDictionary(e);
                        }, e.prototype.unbindAsync = function (e) {
                            return Be(this, void 0, void 0, function () {
                                var t;
                                return ke(this, function (r) {
                                    switch (r.label) {
                                    case 0:
                                        return this._bindingDictionary.hasKey(e) ? (t = this._bindingDictionary.get(e), [
                                            4,
                                            this._deactivateSingletonsAsync(t)
                                        ]) : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        r.sent(), r.label = 2;
                                    case 2:
                                        return this._removeServiceFromDictionary(e), [2];
                                    }
                                });
                            });
                        }, e.prototype.unbindAll = function () {
                            var e = this;
                            this._bindingDictionary.traverse(function (t, r) {
                                e._deactivateSingletons(r);
                            }), this._bindingDictionary = new Pe();
                        }, e.prototype.unbindAllAsync = function () {
                            return Be(this, void 0, void 0, function () {
                                var e, t = this;
                                return ke(this, function (r) {
                                    switch (r.label) {
                                    case 0:
                                        return e = [], this._bindingDictionary.traverse(function (r, n) {
                                            e.push(t._deactivateSingletonsAsync(n));
                                        }), [
                                            4,
                                            Promise.all(e)
                                        ];
                                    case 1:
                                        return r.sent(), this._bindingDictionary = new Pe(), [2];
                                    }
                                });
                            });
                        }, e.prototype.onActivation = function (e, t) {
                            this._activations.add(e, t);
                        }, e.prototype.onDeactivation = function (e, t) {
                            this._deactivations.add(e, t);
                        }, e.prototype.isBound = function (e) {
                            var t = this._bindingDictionary.hasKey(e);
                            return !t && this.parent && (t = this.parent.isBound(e)), t;
                        }, e.prototype.isCurrentBound = function (e) {
                            return this._bindingDictionary.hasKey(e);
                        }, e.prototype.isBoundNamed = function (e, t) {
                            return this.isBoundTagged(e, i, t);
                        }, e.prototype.isBoundTagged = function (e, t, r) {
                            var n = !1;
                            if (this._bindingDictionary.hasKey(e)) {
                                var i = this._bindingDictionary.get(e), a = function (e, t, r, n) {
                                        var i = new G(S.Variable, '', t, new k(r, n)), a = new B(e);
                                        return new Y(t, a, null, [], i);
                                    }(this, e, t, r);
                                n = i.some(function (e) {
                                    return e.constraint(a);
                                });
                            }
                            return !n && this.parent && (n = this.parent.isBoundTagged(e, t, r)), n;
                        }, e.prototype.snapshot = function () {
                            this._snapshots.push(Fe.of(this._bindingDictionary.clone(), this._middleware, this._activations.clone(), this._deactivations.clone(), this._moduleActivationStore.clone()));
                        }, e.prototype.restore = function () {
                            var e = this._snapshots.pop();
                            if (void 0 === e)
                                throw new Error('No snapshot available to restore.');
                            this._bindingDictionary = e.bindings, this._activations = e.activations, this._deactivations = e.deactivations, this._middleware = e.middleware, this._moduleActivationStore = e.moduleActivationStore;
                        }, e.prototype.createChild = function (t) {
                            var r = new e(t || this.options);
                            return r.parent = this, r;
                        }, e.prototype.applyMiddleware = function () {
                            for (var e = [], t = 0; t < arguments.length; t++)
                                e[t] = arguments[t];
                            var r = this._middleware ? this._middleware : this._planAndResolve();
                            this._middleware = e.reduce(function (e, t) {
                                return t(e);
                            }, r);
                        }, e.prototype.applyCustomMetadataReader = function (e) {
                            this._metadataReader = e;
                        }, e.prototype.get = function (e) {
                            var t = this._getNotAllArgs(e, !1);
                            return this._getButThrowIfAsync(t);
                        }, e.prototype.getAsync = function (e) {
                            return Be(this, void 0, void 0, function () {
                                var t;
                                return ke(this, function (r) {
                                    return t = this._getNotAllArgs(e, !1), [
                                        2,
                                        this._get(t)
                                    ];
                                });
                            });
                        }, e.prototype.getTagged = function (e, t, r) {
                            var n = this._getNotAllArgs(e, !1, t, r);
                            return this._getButThrowIfAsync(n);
                        }, e.prototype.getTaggedAsync = function (e, t, r) {
                            return Be(this, void 0, void 0, function () {
                                var n;
                                return ke(this, function (i) {
                                    return n = this._getNotAllArgs(e, !1, t, r), [
                                        2,
                                        this._get(n)
                                    ];
                                });
                            });
                        }, e.prototype.getNamed = function (e, t) {
                            return this.getTagged(e, i, t);
                        }, e.prototype.getNamedAsync = function (e, t) {
                            return this.getTaggedAsync(e, i, t);
                        }, e.prototype.getAll = function (e) {
                            var t = this._getAllArgs(e);
                            return this._getButThrowIfAsync(t);
                        }, e.prototype.getAllAsync = function (e) {
                            var t = this._getAllArgs(e);
                            return this._getAll(t);
                        }, e.prototype.getAllTagged = function (e, t, r) {
                            var n = this._getNotAllArgs(e, !0, t, r);
                            return this._getButThrowIfAsync(n);
                        }, e.prototype.getAllTaggedAsync = function (e, t, r) {
                            var n = this._getNotAllArgs(e, !0, t, r);
                            return this._getAll(n);
                        }, e.prototype.getAllNamed = function (e, t) {
                            return this.getAllTagged(e, i, t);
                        }, e.prototype.getAllNamedAsync = function (e, t) {
                            return this.getAllTaggedAsync(e, i, t);
                        }, e.prototype.resolve = function (e) {
                            var t = this.isBound(e);
                            t || this.bind(e).toSelf();
                            var r = this.get(e);
                            return t || this.unbind(e), r;
                        }, e.prototype._preDestroy = function (e, t) {
                            if (Reflect.hasMetadata(h, e))
                                return t[Reflect.getMetadata(h, e).value]();
                        }, e.prototype._removeModuleHandlers = function (e) {
                            var t = this._moduleActivationStore.remove(e);
                            this._activations.removeIntersection(t.onActivations), this._deactivations.removeIntersection(t.onDeactivations);
                        }, e.prototype._removeModuleBindings = function (e) {
                            return this._bindingDictionary.removeByCondition(function (t) {
                                return t.moduleId === e;
                            });
                        }, e.prototype._deactivate = function (e, t) {
                            var r = this, n = Object.getPrototypeOf(t).constructor;
                            try {
                                if (this._deactivations.hasKey(e.serviceIdentifier)) {
                                    var i = this._deactivateContainer(t, this._deactivations.get(e.serviceIdentifier).values());
                                    if (ee(i))
                                        return this._handleDeactivationError(i.then(function () {
                                            return r._propagateContainerDeactivationThenBindingAndPreDestroyAsync(e, t, n);
                                        }), n);
                                }
                                var a = this._propagateContainerDeactivationThenBindingAndPreDestroy(e, t, n);
                                if (ee(a))
                                    return this._handleDeactivationError(a, n);
                            } catch (e) {
                                throw new Error(D(n.name, e.message));
                            }
                        }, e.prototype._handleDeactivationError = function (e, t) {
                            return Be(this, void 0, void 0, function () {
                                var r;
                                return ke(this, function (n) {
                                    switch (n.label) {
                                    case 0:
                                        return n.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]), [
                                            4,
                                            e
                                        ];
                                    case 1:
                                        return n.sent(), [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        throw r = n.sent(), new Error(D(t.name, r.message));
                                    case 3:
                                        return [2];
                                    }
                                });
                            });
                        }, e.prototype._deactivateContainer = function (e, t) {
                            for (var r = this, n = t.next(); n.value;) {
                                var i = n.value(e);
                                if (ee(i))
                                    return i.then(function () {
                                        return r._deactivateContainerAsync(e, t);
                                    });
                                n = t.next();
                            }
                        }, e.prototype._deactivateContainerAsync = function (e, t) {
                            return Be(this, void 0, void 0, function () {
                                var r;
                                return ke(this, function (n) {
                                    switch (n.label) {
                                    case 0:
                                        r = t.next(), n.label = 1;
                                    case 1:
                                        return r.value ? [
                                            4,
                                            r.value(e)
                                        ] : [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        return n.sent(), r = t.next(), [
                                            3,
                                            1
                                        ];
                                    case 3:
                                        return [2];
                                    }
                                });
                            });
                        }, e.prototype._getContainerModuleHelpersFactory = function () {
                            var e = this, t = function (e, t) {
                                    e._binding.moduleId = t;
                                }, r = function (r) {
                                    return function (n) {
                                        var i = e.rebind(n);
                                        return t(i, r), i;
                                    };
                                }, n = function (t) {
                                    return function (r, n) {
                                        e._moduleActivationStore.addActivation(t, r, n), e.onActivation(r, n);
                                    };
                                }, i = function (t) {
                                    return function (r, n) {
                                        e._moduleActivationStore.addDeactivation(t, r, n), e.onDeactivation(r, n);
                                    };
                                };
                            return function (a) {
                                return {
                                    bindFunction: (o = a, function (r) {
                                        var n = e.bind(r);
                                        return t(n, o), n;
                                    }),
                                    isboundFunction: function (t) {
                                        return e.isBound(t);
                                    },
                                    onActivationFunction: n(a),
                                    onDeactivationFunction: i(a),
                                    rebindFunction: r(a),
                                    unbindFunction: function (t) {
                                        return e.unbind(t);
                                    },
                                    unbindAsyncFunction: function (t) {
                                        return e.unbindAsync(t);
                                    }
                                };
                                var o;
                            };
                        }, e.prototype._getAll = function (e) {
                            return Promise.all(this._get(e));
                        }, e.prototype._get = function (e) {
                            var t = we(we({}, e), {
                                contextInterceptor: function (e) {
                                    return e;
                                },
                                targetType: S.Variable
                            });
                            if (this._middleware) {
                                var r = this._middleware(t);
                                if (null == r)
                                    throw new Error('Invalid return type in middleware. Middleware must return!');
                                return r;
                            }
                            return this._planAndResolve()(t);
                        }, e.prototype._getButThrowIfAsync = function (e) {
                            var t = this._get(e);
                            if (te(t))
                                throw new Error('You are attempting to construct \'' + e.serviceIdentifier + '\' in a synchronous way\n but it has asynchronous dependencies.');
                            return t;
                        }, e.prototype._getAllArgs = function (e) {
                            return {
                                avoidConstraints: !0,
                                isMultiInject: !0,
                                serviceIdentifier: e
                            };
                        }, e.prototype._getNotAllArgs = function (e, t, r, n) {
                            return {
                                avoidConstraints: !1,
                                isMultiInject: t,
                                serviceIdentifier: e,
                                key: r,
                                value: n
                            };
                        }, e.prototype._planAndResolve = function () {
                            var e = this;
                            return function (t) {
                                var r = function (e, t, r, n, i, a, o, s) {
                                    void 0 === s && (s = !1);
                                    var l = new B(t), d = function (e, t, r, n, i, a) {
                                            var o = new k(e ? u : c, r), s = new G(t, '', r, o);
                                            if (void 0 !== i) {
                                                var l = new k(i, a);
                                                s.metadata.push(l);
                                            }
                                            return s;
                                        }(r, n, i, 0, a, o);
                                    try {
                                        return J(e, s, i, l, null, d), l;
                                    } catch (e) {
                                        throw R(e) && x(l.plan.rootRequest), e;
                                    }
                                }(e._metadataReader, e, t.isMultiInject, t.targetType, t.serviceIdentifier, t.key, t.value, t.avoidConstraints);
                                return function (e) {
                                    return de(e.plan.rootRequest.requestScope)(e.plan.rootRequest);
                                }(r = t.contextInterceptor(r));
                            };
                        }, e.prototype._deactivateIfSingleton = function (e) {
                            var t = this;
                            if (e.activated)
                                return ee(e.cache) ? e.cache.then(function (r) {
                                    return t._deactivate(e, r);
                                }) : this._deactivate(e, e.cache);
                        }, e.prototype._deactivateSingletons = function (e) {
                            for (var t = 0, r = e; t < r.length; t++) {
                                var n = r[t];
                                if (ee(this._deactivateIfSingleton(n)))
                                    throw new Error('Attempting to unbind dependency with asynchronous destruction (@preDestroy or onDeactivation)');
                            }
                        }, e.prototype._deactivateSingletonsAsync = function (e) {
                            return Be(this, void 0, void 0, function () {
                                var t = this;
                                return ke(this, function (r) {
                                    switch (r.label) {
                                    case 0:
                                        return [
                                            4,
                                            Promise.all(e.map(function (e) {
                                                return t._deactivateIfSingleton(e);
                                            }))
                                        ];
                                    case 1:
                                        return r.sent(), [2];
                                    }
                                });
                            });
                        }, e.prototype._propagateContainerDeactivationThenBindingAndPreDestroy = function (e, t, r) {
                            return this.parent ? this._deactivate.bind(this.parent)(e, t) : this._bindingDeactivationAndPreDestroy(e, t, r);
                        }, e.prototype._propagateContainerDeactivationThenBindingAndPreDestroyAsync = function (e, t, r) {
                            return Be(this, void 0, void 0, function () {
                                return ke(this, function (n) {
                                    switch (n.label) {
                                    case 0:
                                        return this.parent ? [
                                            4,
                                            this._deactivate.bind(this.parent)(e, t)
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        return n.sent(), [
                                            3,
                                            4
                                        ];
                                    case 2:
                                        return [
                                            4,
                                            this._bindingDeactivationAndPreDestroyAsync(e, t, r)
                                        ];
                                    case 3:
                                        n.sent(), n.label = 4;
                                    case 4:
                                        return [2];
                                    }
                                });
                            });
                        }, e.prototype._removeServiceFromDictionary = function (e) {
                            try {
                                this._bindingDictionary.remove(e);
                            } catch (t) {
                                throw new Error('Could not unbind serviceIdentifier: ' + M(e));
                            }
                        }, e.prototype._bindingDeactivationAndPreDestroy = function (e, t, r) {
                            var n = this;
                            if ('function' == typeof e.onDeactivation) {
                                var i = e.onDeactivation(t);
                                if (ee(i))
                                    return i.then(function () {
                                        return n._preDestroy(r, t);
                                    });
                            }
                            return this._preDestroy(r, t);
                        }, e.prototype._bindingDeactivationAndPreDestroyAsync = function (e, t, r) {
                            return Be(this, void 0, void 0, function () {
                                return ke(this, function (n) {
                                    switch (n.label) {
                                    case 0:
                                        return 'function' != typeof e.onDeactivation ? [
                                            3,
                                            2
                                        ] : [
                                            4,
                                            e.onDeactivation(t)
                                        ];
                                    case 1:
                                        n.sent(), n.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            this._preDestroy(r, t)
                                        ];
                                    case 3:
                                        return n.sent(), [2];
                                    }
                                });
                            });
                        }, e;
                    }(), je = function (e) {
                        this.id = C(), this.registry = e;
                    }, Ge = function (e) {
                        this.id = C(), this.registry = e;
                    };
                function Ve(e, t, r, n) {
                    !function (e) {
                        if (void 0 !== e)
                            throw new Error(T);
                    }(t), Ue(l, e, r.toString(), n);
                }
                function Ue(e, t, r, n) {
                    var i = function (e) {
                            var t = [];
                            if (Array.isArray(e)) {
                                var r = function (e) {
                                    for (var t = new Set(), r = 0, n = e; r < n.length; r++) {
                                        var i = n[r];
                                        if (t.has(i))
                                            return i;
                                        t.add(i);
                                    }
                                }((t = e).map(function (e) {
                                    return e.key;
                                }));
                                if (void 0 !== r)
                                    throw new Error(_ + ' ' + r.toString());
                            } else
                                t = [e];
                            return t;
                        }(n), a = {};
                    Reflect.hasOwnMetadata(e, t) && (a = Reflect.getMetadata(e, t));
                    var o = a[r];
                    if (void 0 === o)
                        o = [];
                    else
                        for (var s = function (e) {
                                    if (i.some(function (t) {
                                            return t.key === e.key;
                                        }))
                                        throw new Error(_ + ' ' + e.key.toString());
                                }, c = 0, u = o; c < u.length; c++)
                            s(u[c]);
                    o.push.apply(o, i), a[r] = o, Reflect.defineMetadata(e, a, t);
                }
                function He(e) {
                    return function (t, r, n) {
                        'number' == typeof n ? Ve(t, r, n, e) : function (e, t, r) {
                            if (void 0 !== e.prototype)
                                throw new Error(T);
                            Ue(d, e.constructor, t, r);
                        }(t, r, e);
                    };
                }
                function We(e, t) {
                    Reflect.decorate(e, t);
                }
                function Ke(e, t) {
                    return function (r, n) {
                        t(r, n, e);
                    };
                }
                function ze(e, t, r) {
                    'number' == typeof r ? We([Ke(r, e)], t) : 'string' == typeof r ? Reflect.decorate([e], t, r) : We([e], t);
                }
                function Xe() {
                    return function (e) {
                        if (Reflect.hasOwnMetadata(p, e))
                            throw new Error('Cannot apply @injectable decorator multiple times.');
                        var t = Reflect.getMetadata(f, e) || [];
                        return Reflect.defineMetadata(p, t, e), e;
                    };
                }
                function Ye(e, t) {
                    return He(new k(e, t));
                }
                function qe(e) {
                    return He(new k(i, e));
                }
                function Ze(e) {
                    return function (t) {
                        return function (r, n, i) {
                            if (void 0 === t) {
                                var a = 'function' == typeof r ? r.name : r.constructor.name;
                                throw new Error('@inject called with undefined this could mean that the class ' + a + ' has a circular dependency problem. You can use a LazyServiceIdentifer to  overcome this limitation.');
                            }
                            return He(new k(e, t))(r, n, i);
                        };
                    };
                }
                var Je = Ze(c);
                function Qe() {
                    return He(new k(s, !0));
                }
                function et() {
                    return function (e, t, r) {
                        Ve(e, t, r, new k(o, !0));
                    };
                }
                var tt = Ze(u);
                function rt(e) {
                    return function (t, r, n) {
                        Ve(t, r, n, new k(a, e));
                    };
                }
                function nt(e, t) {
                    return function () {
                        return function (r, n) {
                            var i = new k(e, n);
                            if (Reflect.hasOwnMetadata(e, r.constructor))
                                throw new Error(t);
                            Reflect.defineMetadata(e, i, r.constructor);
                        };
                    };
                }
                var it, at = nt(m, 'Cannot apply @postConstruct decorator multiple times in the same class'), ot = nt(h, 'Cannot apply @preDestroy decorator multiple times in the same class');
                it || (it = {});
                var st = n;
            },
            2584: e => {
                'use strict';
                var t = 'function' == typeof Symbol && 'symbol' == typeof Symbol.toStringTag, r = Object.prototype.toString, n = function (e) {
                        return !(t && e && 'object' == typeof e && Symbol.toStringTag in e) && '[object Arguments]' === r.call(e);
                    }, i = function (e) {
                        return !!n(e) || null !== e && 'object' == typeof e && 'number' == typeof e.length && e.length >= 0 && '[object Array]' !== r.call(e) && '[object Function]' === r.call(e.callee);
                    }, a = function () {
                        return n(arguments);
                    }();
                n.isLegacyArguments = i, e.exports = a ? n : i;
            },
            8738: e => {
                function t(e) {
                    return !!e.constructor && 'function' == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
                }
                e.exports = function (e) {
                    return null != e && (t(e) || function (e) {
                        return 'function' == typeof e.readFloatLE && 'function' == typeof e.slice && t(e.slice(0, 0));
                    }(e) || !!e._isBuffer);
                };
            },
            8662: e => {
                'use strict';
                var t = Object.prototype.toString, r = Function.prototype.toString, n = /^\s*(?:function)?\*/, i = 'function' == typeof Symbol && 'symbol' == typeof Symbol.toStringTag, a = Object.getPrototypeOf, o = function () {
                        if (!i)
                            return !1;
                        try {
                            return Function('return function*() {}')();
                        } catch (e) {
                        }
                    }(), s = o ? a(o) : {};
                e.exports = function (e) {
                    return 'function' == typeof e && (!!n.test(r.call(e)) || (i ? a(e) === s : '[object GeneratorFunction]' === t.call(e)));
                };
            },
            8611: e => {
                'use strict';
                e.exports = function (e) {
                    return e != e;
                };
            },
            360: (e, t, r) => {
                'use strict';
                var n = r(4289), i = r(8611), a = r(9415), o = r(3194), s = a();
                n(s, {
                    getPolyfill: a,
                    implementation: i,
                    shim: o
                }), e.exports = s;
            },
            9415: (e, t, r) => {
                'use strict';
                var n = r(8611);
                e.exports = function () {
                    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a') ? Number.isNaN : n;
                };
            },
            3194: (e, t, r) => {
                'use strict';
                var n = r(4289), i = r(9415);
                e.exports = function () {
                    var e = i();
                    return n(Number, { isNaN: e }, {
                        isNaN: function () {
                            return Number.isNaN !== e;
                        }
                    }), e;
                };
            },
            1153: e => {
                e.exports = function (e) {
                    return ('' + e).replace(/["'\\\n\r\u2028\u2029]/g, function (e) {
                        switch (e) {
                        case '"':
                        case '\'':
                        case '\\':
                            return '\\' + e;
                        case '\n':
                            return '\\n';
                        case '\r':
                            return '\\r';
                        case '\u2028':
                            return '\\u2028';
                        case '\u2029':
                            return '\\u2029';
                        }
                    });
                };
            },
            2568: (e, t, r) => {
                var n, i, a, o, s;
                n = r(1012), i = r(487).utf8, a = r(8738), o = r(487).bin, (s = function (e, t) {
                    e.constructor == String ? e = t && 'binary' === t.encoding ? o.stringToBytes(e) : i.stringToBytes(e) : a(e) ? e = Array.prototype.slice.call(e, 0) : Array.isArray(e) || e.constructor === Uint8Array || (e = e.toString());
                    for (var r = n.bytesToWords(e), c = 8 * e.length, u = 1732584193, l = -271733879, d = -1732584194, p = 271733878, f = 0; f < r.length; f++)
                        r[f] = 16711935 & (r[f] << 8 | r[f] >>> 24) | 4278255360 & (r[f] << 24 | r[f] >>> 8);
                    r[c >>> 5] |= 128 << c % 32, r[14 + (c + 64 >>> 9 << 4)] = c;
                    var m = s._ff, h = s._gg, g = s._hh, y = s._ii;
                    for (f = 0; f < r.length; f += 16) {
                        var b = u, S = l, v = d, C = p;
                        u = m(u, l, d, p, r[f + 0], 7, -680876936), p = m(p, u, l, d, r[f + 1], 12, -389564586), d = m(d, p, u, l, r[f + 2], 17, 606105819), l = m(l, d, p, u, r[f + 3], 22, -1044525330), u = m(u, l, d, p, r[f + 4], 7, -176418897), p = m(p, u, l, d, r[f + 5], 12, 1200080426), d = m(d, p, u, l, r[f + 6], 17, -1473231341), l = m(l, d, p, u, r[f + 7], 22, -45705983), u = m(u, l, d, p, r[f + 8], 7, 1770035416), p = m(p, u, l, d, r[f + 9], 12, -1958414417), d = m(d, p, u, l, r[f + 10], 17, -42063), l = m(l, d, p, u, r[f + 11], 22, -1990404162), u = m(u, l, d, p, r[f + 12], 7, 1804603682), p = m(p, u, l, d, r[f + 13], 12, -40341101), d = m(d, p, u, l, r[f + 14], 17, -1502002290), u = h(u, l = m(l, d, p, u, r[f + 15], 22, 1236535329), d, p, r[f + 1], 5, -165796510), p = h(p, u, l, d, r[f + 6], 9, -1069501632), d = h(d, p, u, l, r[f + 11], 14, 643717713), l = h(l, d, p, u, r[f + 0], 20, -373897302), u = h(u, l, d, p, r[f + 5], 5, -701558691), p = h(p, u, l, d, r[f + 10], 9, 38016083), d = h(d, p, u, l, r[f + 15], 14, -660478335), l = h(l, d, p, u, r[f + 4], 20, -405537848), u = h(u, l, d, p, r[f + 9], 5, 568446438), p = h(p, u, l, d, r[f + 14], 9, -1019803690), d = h(d, p, u, l, r[f + 3], 14, -187363961), l = h(l, d, p, u, r[f + 8], 20, 1163531501), u = h(u, l, d, p, r[f + 13], 5, -1444681467), p = h(p, u, l, d, r[f + 2], 9, -51403784), d = h(d, p, u, l, r[f + 7], 14, 1735328473), u = g(u, l = h(l, d, p, u, r[f + 12], 20, -1926607734), d, p, r[f + 5], 4, -378558), p = g(p, u, l, d, r[f + 8], 11, -2022574463), d = g(d, p, u, l, r[f + 11], 16, 1839030562), l = g(l, d, p, u, r[f + 14], 23, -35309556), u = g(u, l, d, p, r[f + 1], 4, -1530992060), p = g(p, u, l, d, r[f + 4], 11, 1272893353), d = g(d, p, u, l, r[f + 7], 16, -155497632), l = g(l, d, p, u, r[f + 10], 23, -1094730640), u = g(u, l, d, p, r[f + 13], 4, 681279174), p = g(p, u, l, d, r[f + 0], 11, -358537222), d = g(d, p, u, l, r[f + 3], 16, -722521979), l = g(l, d, p, u, r[f + 6], 23, 76029189), u = g(u, l, d, p, r[f + 9], 4, -640364487), p = g(p, u, l, d, r[f + 12], 11, -421815835), d = g(d, p, u, l, r[f + 15], 16, 530742520), u = y(u, l = g(l, d, p, u, r[f + 2], 23, -995338651), d, p, r[f + 0], 6, -198630844), p = y(p, u, l, d, r[f + 7], 10, 1126891415), d = y(d, p, u, l, r[f + 14], 15, -1416354905), l = y(l, d, p, u, r[f + 5], 21, -57434055), u = y(u, l, d, p, r[f + 12], 6, 1700485571), p = y(p, u, l, d, r[f + 3], 10, -1894986606), d = y(d, p, u, l, r[f + 10], 15, -1051523), l = y(l, d, p, u, r[f + 1], 21, -2054922799), u = y(u, l, d, p, r[f + 8], 6, 1873313359), p = y(p, u, l, d, r[f + 15], 10, -30611744), d = y(d, p, u, l, r[f + 6], 15, -1560198380), l = y(l, d, p, u, r[f + 13], 21, 1309151649), u = y(u, l, d, p, r[f + 4], 6, -145523070), p = y(p, u, l, d, r[f + 11], 10, -1120210379), d = y(d, p, u, l, r[f + 2], 15, 718787259), l = y(l, d, p, u, r[f + 9], 21, -343485551), u = u + b >>> 0, l = l + S >>> 0, d = d + v >>> 0, p = p + C >>> 0;
                    }
                    return n.endian([
                        u,
                        l,
                        d,
                        p
                    ]);
                })._ff = function (e, t, r, n, i, a, o) {
                    var s = e + (t & r | ~t & n) + (i >>> 0) + o;
                    return (s << a | s >>> 32 - a) + t;
                }, s._gg = function (e, t, r, n, i, a, o) {
                    var s = e + (t & n | r & ~n) + (i >>> 0) + o;
                    return (s << a | s >>> 32 - a) + t;
                }, s._hh = function (e, t, r, n, i, a, o) {
                    var s = e + (t ^ r ^ n) + (i >>> 0) + o;
                    return (s << a | s >>> 32 - a) + t;
                }, s._ii = function (e, t, r, n, i, a, o) {
                    var s = e + (r ^ (t | ~n)) + (i >>> 0) + o;
                    return (s << a | s >>> 32 - a) + t;
                }, s._blocksize = 16, s._digestsize = 16, e.exports = function (e, t) {
                    if (null == e)
                        throw new Error('Illegal argument ' + e);
                    var r = n.wordsToBytes(s(e, t));
                    return t && t.asBytes ? r : t && t.asString ? o.bytesToString(r) : n.bytesToHex(r);
                };
            },
            4244: e => {
                'use strict';
                var t = function (e) {
                    return e != e;
                };
                e.exports = function (e, r) {
                    return 0 === e && 0 === r ? 1 / e == 1 / r : e === r || !(!t(e) || !t(r));
                };
            },
            609: (e, t, r) => {
                'use strict';
                var n = r(4289), i = r(850), a = r(4244), o = r(5624), s = r(2281), c = i(o(), Object);
                n(c, {
                    getPolyfill: o,
                    implementation: a,
                    shim: s
                }), e.exports = c;
            },
            1607: (e, t, r) => {
                'use strict';
                var n, i = SyntaxError, a = Function, o = TypeError, s = function (e) {
                        try {
                            return Function('"use strict"; return (' + e + ').constructor;')();
                        } catch (e) {
                        }
                    }, c = Object.getOwnPropertyDescriptor;
                if (c)
                    try {
                        c({}, '');
                    } catch (e) {
                        c = null;
                    }
                var u = function () {
                        throw new o();
                    }, l = c ? function () {
                        try {
                            return u;
                        } catch (e) {
                            try {
                                return c(arguments, 'callee').get;
                            } catch (e) {
                                return u;
                            }
                        }
                    }() : u, d = r(1405)(), p = Object.getPrototypeOf || function (e) {
                        return e.__proto__;
                    }, f = s('async function* () {}'), m = f ? f.prototype : n, h = m ? m.prototype : n, g = 'undefined' == typeof Uint8Array ? n : p(Uint8Array), y = {
                        '%AggregateError%': 'undefined' == typeof AggregateError ? n : AggregateError,
                        '%Array%': Array,
                        '%ArrayBuffer%': 'undefined' == typeof ArrayBuffer ? n : ArrayBuffer,
                        '%ArrayIteratorPrototype%': d ? p([][Symbol.iterator]()) : n,
                        '%AsyncFromSyncIteratorPrototype%': n,
                        '%AsyncFunction%': s('async function () {}'),
                        '%AsyncGenerator%': m,
                        '%AsyncGeneratorFunction%': f,
                        '%AsyncIteratorPrototype%': h ? p(h) : n,
                        '%Atomics%': 'undefined' == typeof Atomics ? n : Atomics,
                        '%BigInt%': 'undefined' == typeof BigInt ? n : BigInt,
                        '%Boolean%': Boolean,
                        '%DataView%': 'undefined' == typeof DataView ? n : DataView,
                        '%Date%': Date,
                        '%decodeURI%': decodeURI,
                        '%decodeURIComponent%': decodeURIComponent,
                        '%encodeURI%': encodeURI,
                        '%encodeURIComponent%': encodeURIComponent,
                        '%Error%': Error,
                        '%eval%': eval,
                        '%EvalError%': EvalError,
                        '%Float32Array%': 'undefined' == typeof Float32Array ? n : Float32Array,
                        '%Float64Array%': 'undefined' == typeof Float64Array ? n : Float64Array,
                        '%FinalizationRegistry%': 'undefined' == typeof FinalizationRegistry ? n : FinalizationRegistry,
                        '%Function%': a,
                        '%GeneratorFunction%': s('function* () {}'),
                        '%Int8Array%': 'undefined' == typeof Int8Array ? n : Int8Array,
                        '%Int16Array%': 'undefined' == typeof Int16Array ? n : Int16Array,
                        '%Int32Array%': 'undefined' == typeof Int32Array ? n : Int32Array,
                        '%isFinite%': isFinite,
                        '%isNaN%': isNaN,
                        '%IteratorPrototype%': d ? p(p([][Symbol.iterator]())) : n,
                        '%JSON%': 'object' == typeof JSON ? JSON : n,
                        '%Map%': 'undefined' == typeof Map ? n : Map,
                        '%MapIteratorPrototype%': 'undefined' != typeof Map && d ? p(new Map()[Symbol.iterator]()) : n,
                        '%Math%': Math,
                        '%Number%': Number,
                        '%Object%': Object,
                        '%parseFloat%': parseFloat,
                        '%parseInt%': parseInt,
                        '%Promise%': 'undefined' == typeof Promise ? n : Promise,
                        '%Proxy%': 'undefined' == typeof Proxy ? n : Proxy,
                        '%RangeError%': RangeError,
                        '%ReferenceError%': ReferenceError,
                        '%Reflect%': 'undefined' == typeof Reflect ? n : Reflect,
                        '%RegExp%': RegExp,
                        '%Set%': 'undefined' == typeof Set ? n : Set,
                        '%SetIteratorPrototype%': 'undefined' != typeof Set && d ? p(new Set()[Symbol.iterator]()) : n,
                        '%SharedArrayBuffer%': 'undefined' == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
                        '%String%': String,
                        '%StringIteratorPrototype%': d ? p(''[Symbol.iterator]()) : n,
                        '%Symbol%': d ? Symbol : n,
                        '%SyntaxError%': i,
                        '%ThrowTypeError%': l,
                        '%TypedArray%': g,
                        '%TypeError%': o,
                        '%Uint8Array%': 'undefined' == typeof Uint8Array ? n : Uint8Array,
                        '%Uint8ClampedArray%': 'undefined' == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
                        '%Uint16Array%': 'undefined' == typeof Uint16Array ? n : Uint16Array,
                        '%Uint32Array%': 'undefined' == typeof Uint32Array ? n : Uint32Array,
                        '%URIError%': URIError,
                        '%WeakMap%': 'undefined' == typeof WeakMap ? n : WeakMap,
                        '%WeakRef%': 'undefined' == typeof WeakRef ? n : WeakRef,
                        '%WeakSet%': 'undefined' == typeof WeakSet ? n : WeakSet
                    }, b = {
                        '%ArrayBufferPrototype%': [
                            'ArrayBuffer',
                            'prototype'
                        ],
                        '%ArrayPrototype%': [
                            'Array',
                            'prototype'
                        ],
                        '%ArrayProto_entries%': [
                            'Array',
                            'prototype',
                            'entries'
                        ],
                        '%ArrayProto_forEach%': [
                            'Array',
                            'prototype',
                            'forEach'
                        ],
                        '%ArrayProto_keys%': [
                            'Array',
                            'prototype',
                            'keys'
                        ],
                        '%ArrayProto_values%': [
                            'Array',
                            'prototype',
                            'values'
                        ],
                        '%AsyncFunctionPrototype%': [
                            'AsyncFunction',
                            'prototype'
                        ],
                        '%AsyncGenerator%': [
                            'AsyncGeneratorFunction',
                            'prototype'
                        ],
                        '%AsyncGeneratorPrototype%': [
                            'AsyncGeneratorFunction',
                            'prototype',
                            'prototype'
                        ],
                        '%BooleanPrototype%': [
                            'Boolean',
                            'prototype'
                        ],
                        '%DataViewPrototype%': [
                            'DataView',
                            'prototype'
                        ],
                        '%DatePrototype%': [
                            'Date',
                            'prototype'
                        ],
                        '%ErrorPrototype%': [
                            'Error',
                            'prototype'
                        ],
                        '%EvalErrorPrototype%': [
                            'EvalError',
                            'prototype'
                        ],
                        '%Float32ArrayPrototype%': [
                            'Float32Array',
                            'prototype'
                        ],
                        '%Float64ArrayPrototype%': [
                            'Float64Array',
                            'prototype'
                        ],
                        '%FunctionPrototype%': [
                            'Function',
                            'prototype'
                        ],
                        '%Generator%': [
                            'GeneratorFunction',
                            'prototype'
                        ],
                        '%GeneratorPrototype%': [
                            'GeneratorFunction',
                            'prototype',
                            'prototype'
                        ],
                        '%Int8ArrayPrototype%': [
                            'Int8Array',
                            'prototype'
                        ],
                        '%Int16ArrayPrototype%': [
                            'Int16Array',
                            'prototype'
                        ],
                        '%Int32ArrayPrototype%': [
                            'Int32Array',
                            'prototype'
                        ],
                        '%JSONParse%': [
                            'JSON',
                            'parse'
                        ],
                        '%JSONStringify%': [
                            'JSON',
                            'stringify'
                        ],
                        '%MapPrototype%': [
                            'Map',
                            'prototype'
                        ],
                        '%NumberPrototype%': [
                            'Number',
                            'prototype'
                        ],
                        '%ObjectPrototype%': [
                            'Object',
                            'prototype'
                        ],
                        '%ObjProto_toString%': [
                            'Object',
                            'prototype',
                            'toString'
                        ],
                        '%ObjProto_valueOf%': [
                            'Object',
                            'prototype',
                            'valueOf'
                        ],
                        '%PromisePrototype%': [
                            'Promise',
                            'prototype'
                        ],
                        '%PromiseProto_then%': [
                            'Promise',
                            'prototype',
                            'then'
                        ],
                        '%Promise_all%': [
                            'Promise',
                            'all'
                        ],
                        '%Promise_reject%': [
                            'Promise',
                            'reject'
                        ],
                        '%Promise_resolve%': [
                            'Promise',
                            'resolve'
                        ],
                        '%RangeErrorPrototype%': [
                            'RangeError',
                            'prototype'
                        ],
                        '%ReferenceErrorPrototype%': [
                            'ReferenceError',
                            'prototype'
                        ],
                        '%RegExpPrototype%': [
                            'RegExp',
                            'prototype'
                        ],
                        '%SetPrototype%': [
                            'Set',
                            'prototype'
                        ],
                        '%SharedArrayBufferPrototype%': [
                            'SharedArrayBuffer',
                            'prototype'
                        ],
                        '%StringPrototype%': [
                            'String',
                            'prototype'
                        ],
                        '%SymbolPrototype%': [
                            'Symbol',
                            'prototype'
                        ],
                        '%SyntaxErrorPrototype%': [
                            'SyntaxError',
                            'prototype'
                        ],
                        '%TypedArrayPrototype%': [
                            'TypedArray',
                            'prototype'
                        ],
                        '%TypeErrorPrototype%': [
                            'TypeError',
                            'prototype'
                        ],
                        '%Uint8ArrayPrototype%': [
                            'Uint8Array',
                            'prototype'
                        ],
                        '%Uint8ClampedArrayPrototype%': [
                            'Uint8ClampedArray',
                            'prototype'
                        ],
                        '%Uint16ArrayPrototype%': [
                            'Uint16Array',
                            'prototype'
                        ],
                        '%Uint32ArrayPrototype%': [
                            'Uint32Array',
                            'prototype'
                        ],
                        '%URIErrorPrototype%': [
                            'URIError',
                            'prototype'
                        ],
                        '%WeakMapPrototype%': [
                            'WeakMap',
                            'prototype'
                        ],
                        '%WeakSetPrototype%': [
                            'WeakSet',
                            'prototype'
                        ]
                    }, S = r(8612), v = r(7642), C = S.call(Function.call, Array.prototype.concat), A = S.call(Function.apply, Array.prototype.splice), _ = S.call(Function.call, String.prototype.replace), E = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, N = /\\(\\)?/g, I = function (e) {
                        var t = [];
                        return _(e, E, function (e, r, n, i) {
                            t[t.length] = n ? _(i, N, '$1') : r || e;
                        }), t;
                    }, T = function (e, t) {
                        var r, n = e;
                        if (v(b, n) && (n = '%' + (r = b[n])[0] + '%'), v(y, n)) {
                            var a = y[n];
                            if (void 0 === a && !t)
                                throw new o('intrinsic ' + e + ' exists, but is not available. Please file an issue!');
                            return {
                                alias: r,
                                name: n,
                                value: a
                            };
                        }
                        throw new i('intrinsic ' + e + ' does not exist!');
                    };
                e.exports = function (e, t) {
                    if ('string' != typeof e || 0 === e.length)
                        throw new o('intrinsic name must be a non-empty string');
                    if (arguments.length > 1 && 'boolean' != typeof t)
                        throw new o('"allowMissing" argument must be a boolean');
                    var r = I(e), n = r.length > 0 ? r[0] : '', i = T('%' + n + '%', t), a = i.name, s = i.value, u = !1, l = i.alias;
                    l && (n = l[0], A(r, C([
                        0,
                        1
                    ], l)));
                    for (var d = 1, p = !0; d < r.length; d += 1) {
                        var f = r[d];
                        if ('constructor' !== f && p || (u = !0), v(y, a = '%' + (n += '.' + f) + '%'))
                            s = y[a];
                        else if (null != s) {
                            if (c && d + 1 >= r.length) {
                                var m = c(s, f);
                                if (p = !!m, !t && !(f in s))
                                    throw new o('base intrinsic for ' + e + ' exists, but the property is not available.');
                                s = p && 'get' in m && !('originalValue' in m.get) ? m.get : s[f];
                            } else
                                p = v(s, f), s = s[f];
                            p && !u && (y[a] = s);
                        }
                    }
                    return s;
                };
            },
            850: (e, t, r) => {
                'use strict';
                var n = r(8612), i = r(1607), a = i('%Function.prototype.apply%'), o = i('%Function.prototype.call%'), s = i('%Reflect.apply%', !0) || n.call(o, a), c = i('%Object.defineProperty%', !0);
                if (c)
                    try {
                        c({}, 'a', { value: 1 });
                    } catch (e) {
                        c = null;
                    }
                e.exports = function () {
                    return s(n, o, arguments);
                };
                var u = function () {
                    return s(n, a, arguments);
                };
                c ? c(e.exports, 'apply', { value: u }) : e.exports.apply = u;
            },
            5624: (e, t, r) => {
                'use strict';
                var n = r(4244);
                e.exports = function () {
                    return 'function' == typeof Object.is ? Object.is : n;
                };
            },
            2281: (e, t, r) => {
                'use strict';
                var n = r(5624), i = r(4289);
                e.exports = function () {
                    var e = n();
                    return i(Object, { is: e }, {
                        is: function () {
                            return Object.is !== e;
                        }
                    }), e;
                };
            },
            8987: (e, t, r) => {
                'use strict';
                var n;
                if (!Object.keys) {
                    var i = Object.prototype.hasOwnProperty, a = Object.prototype.toString, o = r(1414), s = Object.prototype.propertyIsEnumerable, c = !s.call({ toString: null }, 'toString'), u = s.call(function () {
                        }, 'prototype'), l = [
                            'toString',
                            'toLocaleString',
                            'valueOf',
                            'hasOwnProperty',
                            'isPrototypeOf',
                            'propertyIsEnumerable',
                            'constructor'
                        ], d = function (e) {
                            var t = e.constructor;
                            return t && t.prototype === e;
                        }, p = {
                            $applicationCache: !0,
                            $console: !0,
                            $external: !0,
                            $frame: !0,
                            $frameElement: !0,
                            $frames: !0,
                            $innerHeight: !0,
                            $innerWidth: !0,
                            $onmozfullscreenchange: !0,
                            $onmozfullscreenerror: !0,
                            $outerHeight: !0,
                            $outerWidth: !0,
                            $pageXOffset: !0,
                            $pageYOffset: !0,
                            $parent: !0,
                            $scrollLeft: !0,
                            $scrollTop: !0,
                            $scrollX: !0,
                            $scrollY: !0,
                            $self: !0,
                            $webkitIndexedDB: !0,
                            $webkitStorageInfo: !0,
                            $window: !0
                        }, f = function () {
                            if ('undefined' == typeof window)
                                return !1;
                            for (var e in window)
                                try {
                                    if (!p['$' + e] && i.call(window, e) && null !== window[e] && 'object' == typeof window[e])
                                        try {
                                            d(window[e]);
                                        } catch (e) {
                                            return !0;
                                        }
                                } catch (e) {
                                    return !0;
                                }
                            return !1;
                        }();
                    n = function (e) {
                        var t = null !== e && 'object' == typeof e, r = '[object Function]' === a.call(e), n = o(e), s = t && '[object String]' === a.call(e), p = [];
                        if (!t && !r && !n)
                            throw new TypeError('Object.keys called on a non-object');
                        var m = u && r;
                        if (s && e.length > 0 && !i.call(e, 0))
                            for (var h = 0; h < e.length; ++h)
                                p.push(String(h));
                        if (n && e.length > 0)
                            for (var g = 0; g < e.length; ++g)
                                p.push(String(g));
                        else
                            for (var y in e)
                                m && 'prototype' === y || !i.call(e, y) || p.push(String(y));
                        if (c)
                            for (var b = function (e) {
                                        if ('undefined' == typeof window || !f)
                                            return d(e);
                                        try {
                                            return d(e);
                                        } catch (e) {
                                            return !1;
                                        }
                                    }(e), S = 0; S < l.length; ++S)
                                b && 'constructor' === l[S] || !i.call(e, l[S]) || p.push(l[S]);
                        return p;
                    };
                }
                e.exports = n;
            },
            2215: (e, t, r) => {
                'use strict';
                var n = Array.prototype.slice, i = r(1414), a = Object.keys, o = a ? function (e) {
                        return a(e);
                    } : r(8987), s = Object.keys;
                o.shim = function () {
                    return Object.keys ? function () {
                        var e = Object.keys(arguments);
                        return e && e.length === arguments.length;
                    }(1, 2) || (Object.keys = function (e) {
                        return i(e) ? s(n.call(e)) : s(e);
                    }) : Object.keys = o, Object.keys || o;
                }, e.exports = o;
            },
            1414: e => {
                'use strict';
                var t = Object.prototype.toString;
                e.exports = function (e) {
                    var r = t.call(e), n = '[object Arguments]' === r;
                    return n || (n = '[object Array]' !== r && null !== e && 'object' == typeof e && 'number' == typeof e.length && e.length >= 0 && '[object Function]' === t.call(e.callee)), n;
                };
            },
            4155: e => {
                var t, r, n = e.exports = {};
                function i() {
                    throw new Error('setTimeout has not been defined');
                }
                function a() {
                    throw new Error('clearTimeout has not been defined');
                }
                function o(e) {
                    if (t === setTimeout)
                        return setTimeout(e, 0);
                    if ((t === i || !t) && setTimeout)
                        return t = setTimeout, setTimeout(e, 0);
                    try {
                        return t(e, 0);
                    } catch (r) {
                        try {
                            return t.call(null, e, 0);
                        } catch (r) {
                            return t.call(this, e, 0);
                        }
                    }
                }
                !function () {
                    try {
                        t = 'function' == typeof setTimeout ? setTimeout : i;
                    } catch (e) {
                        t = i;
                    }
                    try {
                        r = 'function' == typeof clearTimeout ? clearTimeout : a;
                    } catch (e) {
                        r = a;
                    }
                }();
                var s, c = [], u = !1, l = -1;
                function d() {
                    u && s && (u = !1, s.length ? c = s.concat(c) : l = -1, c.length && p());
                }
                function p() {
                    if (!u) {
                        var e = o(d);
                        u = !0;
                        for (var t = c.length; t;) {
                            for (s = c, c = []; ++l < t;)
                                s && s[l].run();
                            l = -1, t = c.length;
                        }
                        s = null, u = !1, function (e) {
                            if (r === clearTimeout)
                                return clearTimeout(e);
                            if ((r === a || !r) && clearTimeout)
                                return r = clearTimeout, clearTimeout(e);
                            try {
                                r(e);
                            } catch (t) {
                                try {
                                    return r.call(null, e);
                                } catch (t) {
                                    return r.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function f(e, t) {
                    this.fun = e, this.array = t;
                }
                function m() {
                }
                n.nextTick = function (e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1)
                        for (var r = 1; r < arguments.length; r++)
                            t[r - 1] = arguments[r];
                    c.push(new f(e, t)), 1 !== c.length || u || o(p);
                }, f.prototype.run = function () {
                    this.fun.apply(null, this.array);
                }, n.title = 'browser', n.browser = !0, n.env = {}, n.argv = [], n.version = '', n.versions = {}, n.on = m, n.addListener = m, n.once = m, n.off = m, n.removeListener = m, n.removeAllListeners = m, n.emit = m, n.prependListener = m, n.prependOnceListener = m, n.listeners = function (e) {
                    return [];
                }, n.binding = function (e) {
                    throw new Error('process.binding is not supported');
                }, n.cwd = function () {
                    return '/';
                }, n.chdir = function (e) {
                    throw new Error('process.chdir is not supported');
                }, n.umask = function () {
                    return 0;
                };
            },
            8660: (e, t, r) => {
                var n, i = r(4155);
                !function (e) {
                    !function (t) {
                        var n = 'object' == typeof r.g ? r.g : 'object' == typeof self ? self : 'object' == typeof this ? this : Function('return this;')(), a = o(e);
                        function o(e, t) {
                            return function (r, n) {
                                'function' != typeof e[r] && Object.defineProperty(e, r, {
                                    configurable: !0,
                                    writable: !0,
                                    value: n
                                }), t && t(r, n);
                            };
                        }
                        void 0 === n.Reflect ? n.Reflect = e : a = o(n.Reflect, a), function (e) {
                            var t = Object.prototype.hasOwnProperty, r = 'function' == typeof Symbol, n = r && void 0 !== Symbol.toPrimitive ? Symbol.toPrimitive : '@@toPrimitive', a = r && void 0 !== Symbol.iterator ? Symbol.iterator : '@@iterator', o = 'function' == typeof Object.create, s = { __proto__: [] } instanceof Array, c = !o && !s, u = {
                                    create: o ? function () {
                                        return B(Object.create(null));
                                    } : s ? function () {
                                        return B({ __proto__: null });
                                    } : function () {
                                        return B({});
                                    },
                                    has: c ? function (e, r) {
                                        return t.call(e, r);
                                    } : function (e, t) {
                                        return t in e;
                                    },
                                    get: c ? function (e, r) {
                                        return t.call(e, r) ? e[r] : void 0;
                                    } : function (e, t) {
                                        return e[t];
                                    }
                                }, l = Object.getPrototypeOf(Function), d = 'object' == typeof i && i.env && 'true' === i.env.REFLECT_METADATA_USE_MAP_POLYFILL, p = d || 'function' != typeof Map || 'function' != typeof Map.prototype.entries ? function () {
                                    var e = {}, t = [], r = function () {
                                            function e(e, t, r) {
                                                this._index = 0, this._keys = e, this._values = t, this._selector = r;
                                            }
                                            return e.prototype['@@iterator'] = function () {
                                                return this;
                                            }, e.prototype[a] = function () {
                                                return this;
                                            }, e.prototype.next = function () {
                                                var e = this._index;
                                                if (e >= 0 && e < this._keys.length) {
                                                    var r = this._selector(this._keys[e], this._values[e]);
                                                    return e + 1 >= this._keys.length ? (this._index = -1, this._keys = t, this._values = t) : this._index++, {
                                                        value: r,
                                                        done: !1
                                                    };
                                                }
                                                return {
                                                    value: void 0,
                                                    done: !0
                                                };
                                            }, e.prototype.throw = function (e) {
                                                throw this._index >= 0 && (this._index = -1, this._keys = t, this._values = t), e;
                                            }, e.prototype.return = function (e) {
                                                return this._index >= 0 && (this._index = -1, this._keys = t, this._values = t), {
                                                    value: e,
                                                    done: !0
                                                };
                                            }, e;
                                        }();
                                    return function () {
                                        function t() {
                                            this._keys = [], this._values = [], this._cacheKey = e, this._cacheIndex = -2;
                                        }
                                        return Object.defineProperty(t.prototype, 'size', {
                                            get: function () {
                                                return this._keys.length;
                                            },
                                            enumerable: !0,
                                            configurable: !0
                                        }), t.prototype.has = function (e) {
                                            return this._find(e, !1) >= 0;
                                        }, t.prototype.get = function (e) {
                                            var t = this._find(e, !1);
                                            return t >= 0 ? this._values[t] : void 0;
                                        }, t.prototype.set = function (e, t) {
                                            var r = this._find(e, !0);
                                            return this._values[r] = t, this;
                                        }, t.prototype.delete = function (t) {
                                            var r = this._find(t, !1);
                                            if (r >= 0) {
                                                for (var n = this._keys.length, i = r + 1; i < n; i++)
                                                    this._keys[i - 1] = this._keys[i], this._values[i - 1] = this._values[i];
                                                return this._keys.length--, this._values.length--, t === this._cacheKey && (this._cacheKey = e, this._cacheIndex = -2), !0;
                                            }
                                            return !1;
                                        }, t.prototype.clear = function () {
                                            this._keys.length = 0, this._values.length = 0, this._cacheKey = e, this._cacheIndex = -2;
                                        }, t.prototype.keys = function () {
                                            return new r(this._keys, this._values, n);
                                        }, t.prototype.values = function () {
                                            return new r(this._keys, this._values, i);
                                        }, t.prototype.entries = function () {
                                            return new r(this._keys, this._values, o);
                                        }, t.prototype['@@iterator'] = function () {
                                            return this.entries();
                                        }, t.prototype[a] = function () {
                                            return this.entries();
                                        }, t.prototype._find = function (e, t) {
                                            return this._cacheKey !== e && (this._cacheIndex = this._keys.indexOf(this._cacheKey = e)), this._cacheIndex < 0 && t && (this._cacheIndex = this._keys.length, this._keys.push(e), this._values.push(void 0)), this._cacheIndex;
                                        }, t;
                                    }();
                                    function n(e, t) {
                                        return e;
                                    }
                                    function i(e, t) {
                                        return t;
                                    }
                                    function o(e, t) {
                                        return [
                                            e,
                                            t
                                        ];
                                    }
                                }() : Map, f = d || 'function' != typeof Set || 'function' != typeof Set.prototype.entries ? function () {
                                    function e() {
                                        this._map = new p();
                                    }
                                    return Object.defineProperty(e.prototype, 'size', {
                                        get: function () {
                                            return this._map.size;
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    }), e.prototype.has = function (e) {
                                        return this._map.has(e);
                                    }, e.prototype.add = function (e) {
                                        return this._map.set(e, e), this;
                                    }, e.prototype.delete = function (e) {
                                        return this._map.delete(e);
                                    }, e.prototype.clear = function () {
                                        this._map.clear();
                                    }, e.prototype.keys = function () {
                                        return this._map.keys();
                                    }, e.prototype.values = function () {
                                        return this._map.values();
                                    }, e.prototype.entries = function () {
                                        return this._map.entries();
                                    }, e.prototype['@@iterator'] = function () {
                                        return this.keys();
                                    }, e.prototype[a] = function () {
                                        return this.keys();
                                    }, e;
                                }() : Set, m = new (d || 'function' != typeof WeakMap ? (function () {
                                    var e = u.create(), r = n();
                                    return function () {
                                        function e() {
                                            this._key = n();
                                        }
                                        return e.prototype.has = function (e) {
                                            var t = i(e, !1);
                                            return void 0 !== t && u.has(t, this._key);
                                        }, e.prototype.get = function (e) {
                                            var t = i(e, !1);
                                            return void 0 !== t ? u.get(t, this._key) : void 0;
                                        }, e.prototype.set = function (e, t) {
                                            return i(e, !0)[this._key] = t, this;
                                        }, e.prototype.delete = function (e) {
                                            var t = i(e, !1);
                                            return void 0 !== t && delete t[this._key];
                                        }, e.prototype.clear = function () {
                                            this._key = n();
                                        }, e;
                                    }();
                                    function n() {
                                        var t;
                                        do {
                                            t = '@@WeakMap@@' + o();
                                        } while (u.has(e, t));
                                        return e[t] = !0, t;
                                    }
                                    function i(e, n) {
                                        if (!t.call(e, r)) {
                                            if (!n)
                                                return;
                                            Object.defineProperty(e, r, { value: u.create() });
                                        }
                                        return e[r];
                                    }
                                    function a(e, t) {
                                        for (var r = 0; r < t; ++r)
                                            e[r] = 255 * Math.random() | 0;
                                        return e;
                                    }
                                    function o() {
                                        var e, t = (e = 16, 'function' == typeof Uint8Array ? 'undefined' != typeof crypto ? crypto.getRandomValues(new Uint8Array(e)) : 'undefined' != typeof msCrypto ? msCrypto.getRandomValues(new Uint8Array(e)) : a(new Uint8Array(e), e) : a(new Array(e), e));
                                        t[6] = 79 & t[6] | 64, t[8] = 191 & t[8] | 128;
                                        for (var r = '', n = 0; n < 16; ++n) {
                                            var i = t[n];
                                            4 !== n && 6 !== n && 8 !== n || (r += '-'), i < 16 && (r += '0'), r += i.toString(16).toLowerCase();
                                        }
                                        return r;
                                    }
                                }()) : WeakMap)();
                            function h(e, t, r) {
                                var n = m.get(e);
                                if (E(n)) {
                                    if (!r)
                                        return;
                                    n = new p(), m.set(e, n);
                                }
                                var i = n.get(t);
                                if (E(i)) {
                                    if (!r)
                                        return;
                                    i = new p(), n.set(t, i);
                                }
                                return i;
                            }
                            function g(e, t, r) {
                                if (y(e, t, r))
                                    return !0;
                                var n = w(t);
                                return !N(n) && g(e, n, r);
                            }
                            function y(e, t, r) {
                                var n = h(t, r, !1);
                                return !E(n) && !!n.has(e);
                            }
                            function b(e, t, r) {
                                if (y(e, t, r))
                                    return S(e, t, r);
                                var n = w(t);
                                return N(n) ? void 0 : b(e, n, r);
                            }
                            function S(e, t, r) {
                                var n = h(t, r, !1);
                                if (!E(n))
                                    return n.get(e);
                            }
                            function v(e, t, r, n) {
                                h(r, n, !0).set(e, t);
                            }
                            function C(e, t) {
                                var r = A(e, t), n = w(e);
                                if (null === n)
                                    return r;
                                var i = C(n, t);
                                if (i.length <= 0)
                                    return r;
                                if (r.length <= 0)
                                    return i;
                                for (var a = new f(), o = [], s = 0, c = r; s < c.length; s++) {
                                    var u = c[s];
                                    a.has(u) || (a.add(u), o.push(u));
                                }
                                for (var l = 0, d = i; l < d.length; l++)
                                    u = d[l], a.has(u) || (a.add(u), o.push(u));
                                return o;
                            }
                            function A(e, t) {
                                var r = [], n = h(e, t, !1);
                                if (E(n))
                                    return r;
                                for (var i = function (e) {
                                            var t = F(e, a);
                                            if (!R(t))
                                                throw new TypeError();
                                            var r = t.call(e);
                                            if (!I(r))
                                                throw new TypeError();
                                            return r;
                                        }(n.keys()), o = 0;;) {
                                    var s = P(i);
                                    if (!s)
                                        return r.length = o, r;
                                    var c = s.value;
                                    try {
                                        r[o] = c;
                                    } catch (e) {
                                        try {
                                            x(i);
                                        } finally {
                                            throw e;
                                        }
                                    }
                                    o++;
                                }
                            }
                            function _(e) {
                                if (null === e)
                                    return 1;
                                switch (typeof e) {
                                case 'undefined':
                                    return 0;
                                case 'boolean':
                                    return 2;
                                case 'string':
                                    return 3;
                                case 'symbol':
                                    return 4;
                                case 'number':
                                    return 5;
                                case 'object':
                                    return null === e ? 1 : 6;
                                default:
                                    return 6;
                                }
                            }
                            function E(e) {
                                return void 0 === e;
                            }
                            function N(e) {
                                return null === e;
                            }
                            function I(e) {
                                return 'object' == typeof e ? null !== e : 'function' == typeof e;
                            }
                            function T(e, t) {
                                switch (_(e)) {
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    return e;
                                }
                                var r = 3 === t ? 'string' : 5 === t ? 'number' : 'default', i = F(e, n);
                                if (void 0 !== i) {
                                    var a = i.call(e, r);
                                    if (I(a))
                                        throw new TypeError();
                                    return a;
                                }
                                return function (e, t) {
                                    if ('string' === t) {
                                        var r = e.toString;
                                        if (R(r) && !I(i = r.call(e)))
                                            return i;
                                        if (R(n = e.valueOf) && !I(i = n.call(e)))
                                            return i;
                                    } else {
                                        var n;
                                        if (R(n = e.valueOf) && !I(i = n.call(e)))
                                            return i;
                                        var i, a = e.toString;
                                        if (R(a) && !I(i = a.call(e)))
                                            return i;
                                    }
                                    throw new TypeError();
                                }(e, 'default' === r ? 'number' : r);
                            }
                            function D(e) {
                                var t = T(e, 3);
                                return 'symbol' == typeof t ? t : function (e) {
                                    return '' + e;
                                }(t);
                            }
                            function O(e) {
                                return Array.isArray ? Array.isArray(e) : e instanceof Object ? e instanceof Array : '[object Array]' === Object.prototype.toString.call(e);
                            }
                            function R(e) {
                                return 'function' == typeof e;
                            }
                            function M(e) {
                                return 'function' == typeof e;
                            }
                            function F(e, t) {
                                var r = e[t];
                                if (null != r) {
                                    if (!R(r))
                                        throw new TypeError();
                                    return r;
                                }
                            }
                            function P(e) {
                                var t = e.next();
                                return !t.done && t;
                            }
                            function x(e) {
                                var t = e.return;
                                t && t.call(e);
                            }
                            function w(e) {
                                var t = Object.getPrototypeOf(e);
                                if ('function' != typeof e || e === l)
                                    return t;
                                if (t !== l)
                                    return t;
                                var r = e.prototype, n = r && Object.getPrototypeOf(r);
                                if (null == n || n === Object.prototype)
                                    return t;
                                var i = n.constructor;
                                return 'function' != typeof i || i === e ? t : i;
                            }
                            function B(e) {
                                return e.__ = void 0, delete e.__, e;
                            }
                            e('decorate', function (e, t, r, n) {
                                if (E(r)) {
                                    if (!O(e))
                                        throw new TypeError();
                                    if (!M(t))
                                        throw new TypeError();
                                    return function (e, t) {
                                        for (var r = e.length - 1; r >= 0; --r) {
                                            var n = (0, e[r])(t);
                                            if (!E(n) && !N(n)) {
                                                if (!M(n))
                                                    throw new TypeError();
                                                t = n;
                                            }
                                        }
                                        return t;
                                    }(e, t);
                                }
                                if (!O(e))
                                    throw new TypeError();
                                if (!I(t))
                                    throw new TypeError();
                                if (!I(n) && !E(n) && !N(n))
                                    throw new TypeError();
                                return N(n) && (n = void 0), function (e, t, r, n) {
                                    for (var i = e.length - 1; i >= 0; --i) {
                                        var a = (0, e[i])(t, r, n);
                                        if (!E(a) && !N(a)) {
                                            if (!I(a))
                                                throw new TypeError();
                                            n = a;
                                        }
                                    }
                                    return n;
                                }(e, t, r = D(r), n);
                            }), e('metadata', function (e, t) {
                                return function (r, n) {
                                    if (!I(r))
                                        throw new TypeError();
                                    if (!E(n) && !function (e) {
                                            switch (_(e)) {
                                            case 3:
                                            case 4:
                                                return !0;
                                            default:
                                                return !1;
                                            }
                                        }(n))
                                        throw new TypeError();
                                    v(e, t, r, n);
                                };
                            }), e('defineMetadata', function (e, t, r, n) {
                                if (!I(r))
                                    throw new TypeError();
                                return E(n) || (n = D(n)), v(e, t, r, n);
                            }), e('hasMetadata', function (e, t, r) {
                                if (!I(t))
                                    throw new TypeError();
                                return E(r) || (r = D(r)), g(e, t, r);
                            }), e('hasOwnMetadata', function (e, t, r) {
                                if (!I(t))
                                    throw new TypeError();
                                return E(r) || (r = D(r)), y(e, t, r);
                            }), e('getMetadata', function (e, t, r) {
                                if (!I(t))
                                    throw new TypeError();
                                return E(r) || (r = D(r)), b(e, t, r);
                            }), e('getOwnMetadata', function (e, t, r) {
                                if (!I(t))
                                    throw new TypeError();
                                return E(r) || (r = D(r)), S(e, t, r);
                            }), e('getMetadataKeys', function (e, t) {
                                if (!I(e))
                                    throw new TypeError();
                                return E(t) || (t = D(t)), C(e, t);
                            }), e('getOwnMetadataKeys', function (e, t) {
                                if (!I(e))
                                    throw new TypeError();
                                return E(t) || (t = D(t)), A(e, t);
                            }), e('deleteMetadata', function (e, t, r) {
                                if (!I(t))
                                    throw new TypeError();
                                E(r) || (r = D(r));
                                var n = h(t, r, !1);
                                if (E(n))
                                    return !1;
                                if (!n.delete(e))
                                    return !1;
                                if (n.size > 0)
                                    return !0;
                                var i = m.get(t);
                                return i.delete(r), i.size > 0 || m.delete(t), !0;
                            });
                        }(a);
                    }();
                }(n || (n = {}));
            },
            8213: (e, t, r) => {
                var n = r(2728), i = Object.prototype.hasOwnProperty, a = 'undefined' != typeof Map;
                function o() {
                    this._array = [], this._set = a ? new Map() : Object.create(null);
                }
                o.fromArray = function (e, t) {
                    for (var r = new o(), n = 0, i = e.length; n < i; n++)
                        r.add(e[n], t);
                    return r;
                }, o.prototype.size = function () {
                    return a ? this._set.size : Object.getOwnPropertyNames(this._set).length;
                }, o.prototype.add = function (e, t) {
                    var r = a ? e : n.toSetString(e), o = a ? this.has(e) : i.call(this._set, r), s = this._array.length;
                    o && !t || this._array.push(e), o || (a ? this._set.set(e, s) : this._set[r] = s);
                }, o.prototype.has = function (e) {
                    if (a)
                        return this._set.has(e);
                    var t = n.toSetString(e);
                    return i.call(this._set, t);
                }, o.prototype.indexOf = function (e) {
                    if (a) {
                        var t = this._set.get(e);
                        if (t >= 0)
                            return t;
                    } else {
                        var r = n.toSetString(e);
                        if (i.call(this._set, r))
                            return this._set[r];
                    }
                    throw new Error('"' + e + '" is not in the set.');
                }, o.prototype.at = function (e) {
                    if (e >= 0 && e < this._array.length)
                        return this._array[e];
                    throw new Error('No element indexed by ' + e);
                }, o.prototype.toArray = function () {
                    return this._array.slice();
                }, t.I = o;
            },
            6400: (e, t, r) => {
                var n = r(7923);
                t.encode = function (e) {
                    var t, r = '', i = function (e) {
                            return e < 0 ? 1 + (-e << 1) : 0 + (e << 1);
                        }(e);
                    do {
                        t = 31 & i, (i >>>= 5) > 0 && (t |= 32), r += n.encode(t);
                    } while (i > 0);
                    return r;
                }, t.decode = function (e, t, r) {
                    var i, a, o, s, c = e.length, u = 0, l = 0;
                    do {
                        if (t >= c)
                            throw new Error('Expected more digits in base 64 VLQ value.');
                        if (-1 === (a = n.decode(e.charCodeAt(t++))))
                            throw new Error('Invalid base64 digit: ' + e.charAt(t - 1));
                        i = !!(32 & a), u += (a &= 31) << l, l += 5;
                    } while (i);
                    r.value = (s = (o = u) >> 1, 1 == (1 & o) ? -s : s), r.rest = t;
                };
            },
            7923: (e, t) => {
                var r = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
                t.encode = function (e) {
                    if (0 <= e && e < r.length)
                        return r[e];
                    throw new TypeError('Must be between 0 and 63: ' + e);
                }, t.decode = function (e) {
                    return 65 <= e && e <= 90 ? e - 65 : 97 <= e && e <= 122 ? e - 97 + 26 : 48 <= e && e <= 57 ? e - 48 + 52 : 43 == e ? 62 : 47 == e ? 63 : -1;
                };
            },
            9216: (e, t) => {
                function r(e, n, i, a, o, s) {
                    var c = Math.floor((n - e) / 2) + e, u = o(i, a[c], !0);
                    return 0 === u ? c : u > 0 ? n - c > 1 ? r(c, n, i, a, o, s) : s == t.LEAST_UPPER_BOUND ? n < a.length ? n : -1 : c : c - e > 1 ? r(e, c, i, a, o, s) : s == t.LEAST_UPPER_BOUND ? c : e < 0 ? -1 : e;
                }
                t.GREATEST_LOWER_BOUND = 1, t.LEAST_UPPER_BOUND = 2, t.search = function (e, n, i, a) {
                    if (0 === n.length)
                        return -1;
                    var o = r(-1, n.length, e, n, i, a || t.GREATEST_LOWER_BOUND);
                    if (o < 0)
                        return -1;
                    for (; o - 1 >= 0 && 0 === i(n[o], n[o - 1], !0);)
                        --o;
                    return o;
                };
            },
            1188: (e, t, r) => {
                var n = r(2728);
                function i() {
                    this._array = [], this._sorted = !0, this._last = {
                        generatedLine: -1,
                        generatedColumn: 0
                    };
                }
                i.prototype.unsortedForEach = function (e, t) {
                    this._array.forEach(e, t);
                }, i.prototype.add = function (e) {
                    var t, r, i, a, o, s;
                    r = e, i = (t = this._last).generatedLine, a = r.generatedLine, o = t.generatedColumn, s = r.generatedColumn, a > i || a == i && s >= o || n.compareByGeneratedPositionsInflated(t, r) <= 0 ? (this._last = e, this._array.push(e)) : (this._sorted = !1, this._array.push(e));
                }, i.prototype.toArray = function () {
                    return this._sorted || (this._array.sort(n.compareByGeneratedPositionsInflated), this._sorted = !0), this._array;
                }, t.H = i;
            },
            2826: (e, t) => {
                function r(e, t, r) {
                    var n = e[t];
                    e[t] = e[r], e[r] = n;
                }
                function n(e, t, i, a) {
                    if (i < a) {
                        var o = i - 1;
                        r(e, (l = i, d = a, Math.round(l + Math.random() * (d - l))), a);
                        for (var s = e[a], c = i; c < a; c++)
                            t(e[c], s) <= 0 && r(e, o += 1, c);
                        r(e, o + 1, c);
                        var u = o + 1;
                        n(e, t, i, u - 1), n(e, t, u + 1, a);
                    }
                    var l, d;
                }
                t.U = function (e, t) {
                    n(e, t, 0, e.length - 1);
                };
            },
            6771: (e, t, r) => {
                var n = r(2728), i = r(9216), a = r(8213).I, o = r(6400), s = r(2826).U;
                function c(e, t) {
                    var r = e;
                    return 'string' == typeof e && (r = n.parseSourceMapInput(e)), null != r.sections ? new d(r, t) : new u(r, t);
                }
                function u(e, t) {
                    var r = e;
                    'string' == typeof e && (r = n.parseSourceMapInput(e));
                    var i = n.getArg(r, 'version'), o = n.getArg(r, 'sources'), s = n.getArg(r, 'names', []), c = n.getArg(r, 'sourceRoot', null), u = n.getArg(r, 'sourcesContent', null), l = n.getArg(r, 'mappings'), d = n.getArg(r, 'file', null);
                    if (i != this._version)
                        throw new Error('Unsupported version: ' + i);
                    c && (c = n.normalize(c)), o = o.map(String).map(n.normalize).map(function (e) {
                        return c && n.isAbsolute(c) && n.isAbsolute(e) ? n.relative(c, e) : e;
                    }), this._names = a.fromArray(s.map(String), !0), this._sources = a.fromArray(o, !0), this._absoluteSources = this._sources.toArray().map(function (e) {
                        return n.computeSourceURL(c, e, t);
                    }), this.sourceRoot = c, this.sourcesContent = u, this._mappings = l, this._sourceMapURL = t, this.file = d;
                }
                function l() {
                    this.generatedLine = 0, this.generatedColumn = 0, this.source = null, this.originalLine = null, this.originalColumn = null, this.name = null;
                }
                function d(e, t) {
                    var r = e;
                    'string' == typeof e && (r = n.parseSourceMapInput(e));
                    var i = n.getArg(r, 'version'), o = n.getArg(r, 'sections');
                    if (i != this._version)
                        throw new Error('Unsupported version: ' + i);
                    this._sources = new a(), this._names = new a();
                    var s = {
                        line: -1,
                        column: 0
                    };
                    this._sections = o.map(function (e) {
                        if (e.url)
                            throw new Error('Support for url field in sections not implemented.');
                        var r = n.getArg(e, 'offset'), i = n.getArg(r, 'line'), a = n.getArg(r, 'column');
                        if (i < s.line || i === s.line && a < s.column)
                            throw new Error('Section offsets must be ordered and non-overlapping.');
                        return s = r, {
                            generatedOffset: {
                                generatedLine: i + 1,
                                generatedColumn: a + 1
                            },
                            consumer: new c(n.getArg(e, 'map'), t)
                        };
                    });
                }
                c.fromSourceMap = function (e, t) {
                    return u.fromSourceMap(e, t);
                }, c.prototype._version = 3, c.prototype.__generatedMappings = null, Object.defineProperty(c.prototype, '_generatedMappings', {
                    configurable: !0,
                    enumerable: !0,
                    get: function () {
                        return this.__generatedMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__generatedMappings;
                    }
                }), c.prototype.__originalMappings = null, Object.defineProperty(c.prototype, '_originalMappings', {
                    configurable: !0,
                    enumerable: !0,
                    get: function () {
                        return this.__originalMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__originalMappings;
                    }
                }), c.prototype._charIsMappingSeparator = function (e, t) {
                    var r = e.charAt(t);
                    return ';' === r || ',' === r;
                }, c.prototype._parseMappings = function (e, t) {
                    throw new Error('Subclasses must implement _parseMappings');
                }, c.GENERATED_ORDER = 1, c.ORIGINAL_ORDER = 2, c.GREATEST_LOWER_BOUND = 1, c.LEAST_UPPER_BOUND = 2, c.prototype.eachMapping = function (e, t, r) {
                    var i, a = t || null;
                    switch (r || c.GENERATED_ORDER) {
                    case c.GENERATED_ORDER:
                        i = this._generatedMappings;
                        break;
                    case c.ORIGINAL_ORDER:
                        i = this._originalMappings;
                        break;
                    default:
                        throw new Error('Unknown order of iteration.');
                    }
                    var o = this.sourceRoot;
                    i.map(function (e) {
                        var t = null === e.source ? null : this._sources.at(e.source);
                        return {
                            source: t = n.computeSourceURL(o, t, this._sourceMapURL),
                            generatedLine: e.generatedLine,
                            generatedColumn: e.generatedColumn,
                            originalLine: e.originalLine,
                            originalColumn: e.originalColumn,
                            name: null === e.name ? null : this._names.at(e.name)
                        };
                    }, this).forEach(e, a);
                }, c.prototype.allGeneratedPositionsFor = function (e) {
                    var t = n.getArg(e, 'line'), r = {
                            source: n.getArg(e, 'source'),
                            originalLine: t,
                            originalColumn: n.getArg(e, 'column', 0)
                        };
                    if (r.source = this._findSourceIndex(r.source), r.source < 0)
                        return [];
                    var a = [], o = this._findMapping(r, this._originalMappings, 'originalLine', 'originalColumn', n.compareByOriginalPositions, i.LEAST_UPPER_BOUND);
                    if (o >= 0) {
                        var s = this._originalMappings[o];
                        if (void 0 === e.column)
                            for (var c = s.originalLine; s && s.originalLine === c;)
                                a.push({
                                    line: n.getArg(s, 'generatedLine', null),
                                    column: n.getArg(s, 'generatedColumn', null),
                                    lastColumn: n.getArg(s, 'lastGeneratedColumn', null)
                                }), s = this._originalMappings[++o];
                        else
                            for (var u = s.originalColumn; s && s.originalLine === t && s.originalColumn == u;)
                                a.push({
                                    line: n.getArg(s, 'generatedLine', null),
                                    column: n.getArg(s, 'generatedColumn', null),
                                    lastColumn: n.getArg(s, 'lastGeneratedColumn', null)
                                }), s = this._originalMappings[++o];
                    }
                    return a;
                }, u.prototype = Object.create(c.prototype), u.prototype.consumer = c, u.prototype._findSourceIndex = function (e) {
                    var t, r = e;
                    if (null != this.sourceRoot && (r = n.relative(this.sourceRoot, r)), this._sources.has(r))
                        return this._sources.indexOf(r);
                    for (t = 0; t < this._absoluteSources.length; ++t)
                        if (this._absoluteSources[t] == e)
                            return t;
                    return -1;
                }, u.fromSourceMap = function (e, t) {
                    var r = Object.create(u.prototype), i = r._names = a.fromArray(e._names.toArray(), !0), o = r._sources = a.fromArray(e._sources.toArray(), !0);
                    r.sourceRoot = e._sourceRoot, r.sourcesContent = e._generateSourcesContent(r._sources.toArray(), r.sourceRoot), r.file = e._file, r._sourceMapURL = t, r._absoluteSources = r._sources.toArray().map(function (e) {
                        return n.computeSourceURL(r.sourceRoot, e, t);
                    });
                    for (var c = e._mappings.toArray().slice(), d = r.__generatedMappings = [], p = r.__originalMappings = [], f = 0, m = c.length; f < m; f++) {
                        var h = c[f], g = new l();
                        g.generatedLine = h.generatedLine, g.generatedColumn = h.generatedColumn, h.source && (g.source = o.indexOf(h.source), g.originalLine = h.originalLine, g.originalColumn = h.originalColumn, h.name && (g.name = i.indexOf(h.name)), p.push(g)), d.push(g);
                    }
                    return s(r.__originalMappings, n.compareByOriginalPositions), r;
                }, u.prototype._version = 3, Object.defineProperty(u.prototype, 'sources', {
                    get: function () {
                        return this._absoluteSources.slice();
                    }
                }), u.prototype._parseMappings = function (e, t) {
                    for (var r, i, a, c, u, d = 1, p = 0, f = 0, m = 0, h = 0, g = 0, y = e.length, b = 0, S = {}, v = {}, C = [], A = []; b < y;)
                        if (';' === e.charAt(b))
                            d++, b++, p = 0;
                        else if (',' === e.charAt(b))
                            b++;
                        else {
                            for ((r = new l()).generatedLine = d, c = b; c < y && !this._charIsMappingSeparator(e, c); c++);
                            if (a = S[i = e.slice(b, c)])
                                b += i.length;
                            else {
                                for (a = []; b < c;)
                                    o.decode(e, b, v), u = v.value, b = v.rest, a.push(u);
                                if (2 === a.length)
                                    throw new Error('Found a source, but no line and column');
                                if (3 === a.length)
                                    throw new Error('Found a source and line, but no column');
                                S[i] = a;
                            }
                            r.generatedColumn = p + a[0], p = r.generatedColumn, a.length > 1 && (r.source = h + a[1], h += a[1], r.originalLine = f + a[2], f = r.originalLine, r.originalLine += 1, r.originalColumn = m + a[3], m = r.originalColumn, a.length > 4 && (r.name = g + a[4], g += a[4])), A.push(r), 'number' == typeof r.originalLine && C.push(r);
                        }
                    s(A, n.compareByGeneratedPositionsDeflated), this.__generatedMappings = A, s(C, n.compareByOriginalPositions), this.__originalMappings = C;
                }, u.prototype._findMapping = function (e, t, r, n, a, o) {
                    if (e[r] <= 0)
                        throw new TypeError('Line must be greater than or equal to 1, got ' + e[r]);
                    if (e[n] < 0)
                        throw new TypeError('Column must be greater than or equal to 0, got ' + e[n]);
                    return i.search(e, t, a, o);
                }, u.prototype.computeColumnSpans = function () {
                    for (var e = 0; e < this._generatedMappings.length; ++e) {
                        var t = this._generatedMappings[e];
                        if (e + 1 < this._generatedMappings.length) {
                            var r = this._generatedMappings[e + 1];
                            if (t.generatedLine === r.generatedLine) {
                                t.lastGeneratedColumn = r.generatedColumn - 1;
                                continue;
                            }
                        }
                        t.lastGeneratedColumn = 1 / 0;
                    }
                }, u.prototype.originalPositionFor = function (e) {
                    var t = {
                            generatedLine: n.getArg(e, 'line'),
                            generatedColumn: n.getArg(e, 'column')
                        }, r = this._findMapping(t, this._generatedMappings, 'generatedLine', 'generatedColumn', n.compareByGeneratedPositionsDeflated, n.getArg(e, 'bias', c.GREATEST_LOWER_BOUND));
                    if (r >= 0) {
                        var i = this._generatedMappings[r];
                        if (i.generatedLine === t.generatedLine) {
                            var a = n.getArg(i, 'source', null);
                            null !== a && (a = this._sources.at(a), a = n.computeSourceURL(this.sourceRoot, a, this._sourceMapURL));
                            var o = n.getArg(i, 'name', null);
                            return null !== o && (o = this._names.at(o)), {
                                source: a,
                                line: n.getArg(i, 'originalLine', null),
                                column: n.getArg(i, 'originalColumn', null),
                                name: o
                            };
                        }
                    }
                    return {
                        source: null,
                        line: null,
                        column: null,
                        name: null
                    };
                }, u.prototype.hasContentsOfAllSources = function () {
                    return !!this.sourcesContent && this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function (e) {
                        return null == e;
                    });
                }, u.prototype.sourceContentFor = function (e, t) {
                    if (!this.sourcesContent)
                        return null;
                    var r = this._findSourceIndex(e);
                    if (r >= 0)
                        return this.sourcesContent[r];
                    var i, a = e;
                    if (null != this.sourceRoot && (a = n.relative(this.sourceRoot, a)), null != this.sourceRoot && (i = n.urlParse(this.sourceRoot))) {
                        var o = a.replace(/^file:\/\//, '');
                        if ('file' == i.scheme && this._sources.has(o))
                            return this.sourcesContent[this._sources.indexOf(o)];
                        if ((!i.path || '/' == i.path) && this._sources.has('/' + a))
                            return this.sourcesContent[this._sources.indexOf('/' + a)];
                    }
                    if (t)
                        return null;
                    throw new Error('"' + a + '" is not in the SourceMap.');
                }, u.prototype.generatedPositionFor = function (e) {
                    var t = n.getArg(e, 'source');
                    if ((t = this._findSourceIndex(t)) < 0)
                        return {
                            line: null,
                            column: null,
                            lastColumn: null
                        };
                    var r = {
                            source: t,
                            originalLine: n.getArg(e, 'line'),
                            originalColumn: n.getArg(e, 'column')
                        }, i = this._findMapping(r, this._originalMappings, 'originalLine', 'originalColumn', n.compareByOriginalPositions, n.getArg(e, 'bias', c.GREATEST_LOWER_BOUND));
                    if (i >= 0) {
                        var a = this._originalMappings[i];
                        if (a.source === r.source)
                            return {
                                line: n.getArg(a, 'generatedLine', null),
                                column: n.getArg(a, 'generatedColumn', null),
                                lastColumn: n.getArg(a, 'lastGeneratedColumn', null)
                            };
                    }
                    return {
                        line: null,
                        column: null,
                        lastColumn: null
                    };
                }, d.prototype = Object.create(c.prototype), d.prototype.constructor = c, d.prototype._version = 3, Object.defineProperty(d.prototype, 'sources', {
                    get: function () {
                        for (var e = [], t = 0; t < this._sections.length; t++)
                            for (var r = 0; r < this._sections[t].consumer.sources.length; r++)
                                e.push(this._sections[t].consumer.sources[r]);
                        return e;
                    }
                }), d.prototype.originalPositionFor = function (e) {
                    var t = {
                            generatedLine: n.getArg(e, 'line'),
                            generatedColumn: n.getArg(e, 'column')
                        }, r = i.search(t, this._sections, function (e, t) {
                            return e.generatedLine - t.generatedOffset.generatedLine || e.generatedColumn - t.generatedOffset.generatedColumn;
                        }), a = this._sections[r];
                    return a ? a.consumer.originalPositionFor({
                        line: t.generatedLine - (a.generatedOffset.generatedLine - 1),
                        column: t.generatedColumn - (a.generatedOffset.generatedLine === t.generatedLine ? a.generatedOffset.generatedColumn - 1 : 0),
                        bias: e.bias
                    }) : {
                        source: null,
                        line: null,
                        column: null,
                        name: null
                    };
                }, d.prototype.hasContentsOfAllSources = function () {
                    return this._sections.every(function (e) {
                        return e.consumer.hasContentsOfAllSources();
                    });
                }, d.prototype.sourceContentFor = function (e, t) {
                    for (var r = 0; r < this._sections.length; r++) {
                        var n = this._sections[r].consumer.sourceContentFor(e, !0);
                        if (n)
                            return n;
                    }
                    if (t)
                        return null;
                    throw new Error('"' + e + '" is not in the SourceMap.');
                }, d.prototype.generatedPositionFor = function (e) {
                    for (var t = 0; t < this._sections.length; t++) {
                        var r = this._sections[t];
                        if (-1 !== r.consumer._findSourceIndex(n.getArg(e, 'source'))) {
                            var i = r.consumer.generatedPositionFor(e);
                            if (i)
                                return {
                                    line: i.line + (r.generatedOffset.generatedLine - 1),
                                    column: i.column + (r.generatedOffset.generatedLine === i.line ? r.generatedOffset.generatedColumn - 1 : 0)
                                };
                        }
                    }
                    return {
                        line: null,
                        column: null
                    };
                }, d.prototype._parseMappings = function (e, t) {
                    this.__generatedMappings = [], this.__originalMappings = [];
                    for (var r = 0; r < this._sections.length; r++)
                        for (var i = this._sections[r], a = i.consumer._generatedMappings, o = 0; o < a.length; o++) {
                            var c = a[o], u = i.consumer._sources.at(c.source);
                            u = n.computeSourceURL(i.consumer.sourceRoot, u, this._sourceMapURL), this._sources.add(u), u = this._sources.indexOf(u);
                            var l = null;
                            c.name && (l = i.consumer._names.at(c.name), this._names.add(l), l = this._names.indexOf(l));
                            var d = {
                                source: u,
                                generatedLine: c.generatedLine + (i.generatedOffset.generatedLine - 1),
                                generatedColumn: c.generatedColumn + (i.generatedOffset.generatedLine === c.generatedLine ? i.generatedOffset.generatedColumn - 1 : 0),
                                originalLine: c.originalLine,
                                originalColumn: c.originalColumn,
                                name: l
                            };
                            this.__generatedMappings.push(d), 'number' == typeof d.originalLine && this.__originalMappings.push(d);
                        }
                    s(this.__generatedMappings, n.compareByGeneratedPositionsDeflated), s(this.__originalMappings, n.compareByOriginalPositions);
                };
            },
            4433: (e, t, r) => {
                var n = r(6400), i = r(2728), a = r(8213).I, o = r(1188).H;
                function s(e) {
                    e || (e = {}), this._file = i.getArg(e, 'file', null), this._sourceRoot = i.getArg(e, 'sourceRoot', null), this._skipValidation = i.getArg(e, 'skipValidation', !1), this._sources = new a(), this._names = new a(), this._mappings = new o(), this._sourcesContents = null;
                }
                s.prototype._version = 3, s.fromSourceMap = function (e) {
                    var t = e.sourceRoot, r = new s({
                            file: e.file,
                            sourceRoot: t
                        });
                    return e.eachMapping(function (e) {
                        var n = {
                            generated: {
                                line: e.generatedLine,
                                column: e.generatedColumn
                            }
                        };
                        null != e.source && (n.source = e.source, null != t && (n.source = i.relative(t, n.source)), n.original = {
                            line: e.originalLine,
                            column: e.originalColumn
                        }, null != e.name && (n.name = e.name)), r.addMapping(n);
                    }), e.sources.forEach(function (n) {
                        var a = n;
                        null !== t && (a = i.relative(t, n)), r._sources.has(a) || r._sources.add(a);
                        var o = e.sourceContentFor(n);
                        null != o && r.setSourceContent(n, o);
                    }), r;
                }, s.prototype.addMapping = function (e) {
                    var t = i.getArg(e, 'generated'), r = i.getArg(e, 'original', null), n = i.getArg(e, 'source', null), a = i.getArg(e, 'name', null);
                    this._skipValidation || this._validateMapping(t, r, n, a), null != n && (n = String(n), this._sources.has(n) || this._sources.add(n)), null != a && (a = String(a), this._names.has(a) || this._names.add(a)), this._mappings.add({
                        generatedLine: t.line,
                        generatedColumn: t.column,
                        originalLine: null != r && r.line,
                        originalColumn: null != r && r.column,
                        source: n,
                        name: a
                    });
                }, s.prototype.setSourceContent = function (e, t) {
                    var r = e;
                    null != this._sourceRoot && (r = i.relative(this._sourceRoot, r)), null != t ? (this._sourcesContents || (this._sourcesContents = Object.create(null)), this._sourcesContents[i.toSetString(r)] = t) : this._sourcesContents && (delete this._sourcesContents[i.toSetString(r)], 0 === Object.keys(this._sourcesContents).length && (this._sourcesContents = null));
                }, s.prototype.applySourceMap = function (e, t, r) {
                    var n = t;
                    if (null == t) {
                        if (null == e.file)
                            throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');
                        n = e.file;
                    }
                    var o = this._sourceRoot;
                    null != o && (n = i.relative(o, n));
                    var s = new a(), c = new a();
                    this._mappings.unsortedForEach(function (t) {
                        if (t.source === n && null != t.originalLine) {
                            var a = e.originalPositionFor({
                                line: t.originalLine,
                                column: t.originalColumn
                            });
                            null != a.source && (t.source = a.source, null != r && (t.source = i.join(r, t.source)), null != o && (t.source = i.relative(o, t.source)), t.originalLine = a.line, t.originalColumn = a.column, null != a.name && (t.name = a.name));
                        }
                        var u = t.source;
                        null == u || s.has(u) || s.add(u);
                        var l = t.name;
                        null == l || c.has(l) || c.add(l);
                    }, this), this._sources = s, this._names = c, e.sources.forEach(function (t) {
                        var n = e.sourceContentFor(t);
                        null != n && (null != r && (t = i.join(r, t)), null != o && (t = i.relative(o, t)), this.setSourceContent(t, n));
                    }, this);
                }, s.prototype._validateMapping = function (e, t, r, n) {
                    if (t && 'number' != typeof t.line && 'number' != typeof t.column)
                        throw new Error('original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.');
                    if ((!(e && 'line' in e && 'column' in e && e.line > 0 && e.column >= 0) || t || r || n) && !(e && 'line' in e && 'column' in e && t && 'line' in t && 'column' in t && e.line > 0 && e.column >= 0 && t.line > 0 && t.column >= 0 && r))
                        throw new Error('Invalid mapping: ' + JSON.stringify({
                            generated: e,
                            source: r,
                            original: t,
                            name: n
                        }));
                }, s.prototype._serializeMappings = function () {
                    for (var e, t, r, a, o = 0, s = 1, c = 0, u = 0, l = 0, d = 0, p = '', f = this._mappings.toArray(), m = 0, h = f.length; m < h; m++) {
                        if (e = '', (t = f[m]).generatedLine !== s)
                            for (o = 0; t.generatedLine !== s;)
                                e += ';', s++;
                        else if (m > 0) {
                            if (!i.compareByGeneratedPositionsInflated(t, f[m - 1]))
                                continue;
                            e += ',';
                        }
                        e += n.encode(t.generatedColumn - o), o = t.generatedColumn, null != t.source && (a = this._sources.indexOf(t.source), e += n.encode(a - d), d = a, e += n.encode(t.originalLine - 1 - u), u = t.originalLine - 1, e += n.encode(t.originalColumn - c), c = t.originalColumn, null != t.name && (r = this._names.indexOf(t.name), e += n.encode(r - l), l = r)), p += e;
                    }
                    return p;
                }, s.prototype._generateSourcesContent = function (e, t) {
                    return e.map(function (e) {
                        if (!this._sourcesContents)
                            return null;
                        null != t && (e = i.relative(t, e));
                        var r = i.toSetString(e);
                        return Object.prototype.hasOwnProperty.call(this._sourcesContents, r) ? this._sourcesContents[r] : null;
                    }, this);
                }, s.prototype.toJSON = function () {
                    var e = {
                        version: this._version,
                        sources: this._sources.toArray(),
                        names: this._names.toArray(),
                        mappings: this._serializeMappings()
                    };
                    return null != this._file && (e.file = this._file), null != this._sourceRoot && (e.sourceRoot = this._sourceRoot), this._sourcesContents && (e.sourcesContent = this._generateSourcesContent(e.sources, e.sourceRoot)), e;
                }, s.prototype.toString = function () {
                    return JSON.stringify(this.toJSON());
                }, t.h = s;
            },
            1841: (e, t, r) => {
                var n = r(4433).h, i = r(2728), a = /(\r?\n)/, o = '$$$isSourceNode$$$';
                function s(e, t, r, n, i) {
                    this.children = [], this.sourceContents = {}, this.line = null == e ? null : e, this.column = null == t ? null : t, this.source = null == r ? null : r, this.name = null == i ? null : i, this[o] = !0, null != n && this.add(n);
                }
                s.fromStringWithSourceMap = function (e, t, r) {
                    var n = new s(), o = e.split(a), c = 0, u = function () {
                            return e() + (e() || '');
                            function e() {
                                return c < o.length ? o[c++] : void 0;
                            }
                        }, l = 1, d = 0, p = null;
                    return t.eachMapping(function (e) {
                        if (null !== p) {
                            if (!(l < e.generatedLine)) {
                                var t = (r = o[c] || '').substr(0, e.generatedColumn - d);
                                return o[c] = r.substr(e.generatedColumn - d), d = e.generatedColumn, f(p, t), void (p = e);
                            }
                            f(p, u()), l++, d = 0;
                        }
                        for (; l < e.generatedLine;)
                            n.add(u()), l++;
                        if (d < e.generatedColumn) {
                            var r = o[c] || '';
                            n.add(r.substr(0, e.generatedColumn)), o[c] = r.substr(e.generatedColumn), d = e.generatedColumn;
                        }
                        p = e;
                    }, this), c < o.length && (p && f(p, u()), n.add(o.splice(c).join(''))), t.sources.forEach(function (e) {
                        var a = t.sourceContentFor(e);
                        null != a && (null != r && (e = i.join(r, e)), n.setSourceContent(e, a));
                    }), n;
                    function f(e, t) {
                        if (null === e || void 0 === e.source)
                            n.add(t);
                        else {
                            var a = r ? i.join(r, e.source) : e.source;
                            n.add(new s(e.originalLine, e.originalColumn, a, t, e.name));
                        }
                    }
                }, s.prototype.add = function (e) {
                    if (Array.isArray(e))
                        e.forEach(function (e) {
                            this.add(e);
                        }, this);
                    else {
                        if (!e[o] && 'string' != typeof e)
                            throw new TypeError('Expected a SourceNode, string, or an array of SourceNodes and strings. Got ' + e);
                        e && this.children.push(e);
                    }
                    return this;
                }, s.prototype.prepend = function (e) {
                    if (Array.isArray(e))
                        for (var t = e.length - 1; t >= 0; t--)
                            this.prepend(e[t]);
                    else {
                        if (!e[o] && 'string' != typeof e)
                            throw new TypeError('Expected a SourceNode, string, or an array of SourceNodes and strings. Got ' + e);
                        this.children.unshift(e);
                    }
                    return this;
                }, s.prototype.walk = function (e) {
                    for (var t, r = 0, n = this.children.length; r < n; r++)
                        (t = this.children[r])[o] ? t.walk(e) : '' !== t && e(t, {
                            source: this.source,
                            line: this.line,
                            column: this.column,
                            name: this.name
                        });
                }, s.prototype.join = function (e) {
                    var t, r, n = this.children.length;
                    if (n > 0) {
                        for (t = [], r = 0; r < n - 1; r++)
                            t.push(this.children[r]), t.push(e);
                        t.push(this.children[r]), this.children = t;
                    }
                    return this;
                }, s.prototype.replaceRight = function (e, t) {
                    var r = this.children[this.children.length - 1];
                    return r[o] ? r.replaceRight(e, t) : 'string' == typeof r ? this.children[this.children.length - 1] = r.replace(e, t) : this.children.push(''.replace(e, t)), this;
                }, s.prototype.setSourceContent = function (e, t) {
                    this.sourceContents[i.toSetString(e)] = t;
                }, s.prototype.walkSourceContents = function (e) {
                    for (var t = 0, r = this.children.length; t < r; t++)
                        this.children[t][o] && this.children[t].walkSourceContents(e);
                    var n = Object.keys(this.sourceContents);
                    for (t = 0, r = n.length; t < r; t++)
                        e(i.fromSetString(n[t]), this.sourceContents[n[t]]);
                }, s.prototype.toString = function () {
                    var e = '';
                    return this.walk(function (t) {
                        e += t;
                    }), e;
                }, s.prototype.toStringWithSourceMap = function (e) {
                    var t = {
                            code: '',
                            line: 1,
                            column: 0
                        }, r = new n(e), i = !1, a = null, o = null, s = null, c = null;
                    return this.walk(function (e, n) {
                        t.code += e, null !== n.source && null !== n.line && null !== n.column ? (a === n.source && o === n.line && s === n.column && c === n.name || r.addMapping({
                            source: n.source,
                            original: {
                                line: n.line,
                                column: n.column
                            },
                            generated: {
                                line: t.line,
                                column: t.column
                            },
                            name: n.name
                        }), a = n.source, o = n.line, s = n.column, c = n.name, i = !0) : i && (r.addMapping({
                            generated: {
                                line: t.line,
                                column: t.column
                            }
                        }), a = null, i = !1);
                        for (var u = 0, l = e.length; u < l; u++)
                            10 === e.charCodeAt(u) ? (t.line++, t.column = 0, u + 1 === l ? (a = null, i = !1) : i && r.addMapping({
                                source: n.source,
                                original: {
                                    line: n.line,
                                    column: n.column
                                },
                                generated: {
                                    line: t.line,
                                    column: t.column
                                },
                                name: n.name
                            })) : t.column++;
                    }), this.walkSourceContents(function (e, t) {
                        r.setSourceContent(e, t);
                    }), {
                        code: t.code,
                        map: r
                    };
                }, t.SourceNode = s;
            },
            2728: (e, t) => {
                t.getArg = function (e, t, r) {
                    if (t in e)
                        return e[t];
                    if (3 === arguments.length)
                        return r;
                    throw new Error('"' + t + '" is a required argument.');
                };
                var r = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/, n = /^data:.+\,.+$/;
                function i(e) {
                    var t = e.match(r);
                    return t ? {
                        scheme: t[1],
                        auth: t[2],
                        host: t[3],
                        port: t[4],
                        path: t[5]
                    } : null;
                }
                function a(e) {
                    var t = '';
                    return e.scheme && (t += e.scheme + ':'), t += '//', e.auth && (t += e.auth + '@'), e.host && (t += e.host), e.port && (t += ':' + e.port), e.path && (t += e.path), t;
                }
                function o(e) {
                    var r = e, n = i(e);
                    if (n) {
                        if (!n.path)
                            return e;
                        r = n.path;
                    }
                    for (var o, s = t.isAbsolute(r), c = r.split(/\/+/), u = 0, l = c.length - 1; l >= 0; l--)
                        '.' === (o = c[l]) ? c.splice(l, 1) : '..' === o ? u++ : u > 0 && ('' === o ? (c.splice(l + 1, u), u = 0) : (c.splice(l, 2), u--));
                    return '' === (r = c.join('/')) && (r = s ? '/' : '.'), n ? (n.path = r, a(n)) : r;
                }
                function s(e, t) {
                    '' === e && (e = '.'), '' === t && (t = '.');
                    var r = i(t), s = i(e);
                    if (s && (e = s.path || '/'), r && !r.scheme)
                        return s && (r.scheme = s.scheme), a(r);
                    if (r || t.match(n))
                        return t;
                    if (s && !s.host && !s.path)
                        return s.host = t, a(s);
                    var c = '/' === t.charAt(0) ? t : o(e.replace(/\/+$/, '') + '/' + t);
                    return s ? (s.path = c, a(s)) : c;
                }
                t.urlParse = i, t.urlGenerate = a, t.normalize = o, t.join = s, t.isAbsolute = function (e) {
                    return '/' === e.charAt(0) || r.test(e);
                }, t.relative = function (e, t) {
                    '' === e && (e = '.'), e = e.replace(/\/$/, '');
                    for (var r = 0; 0 !== t.indexOf(e + '/');) {
                        var n = e.lastIndexOf('/');
                        if (n < 0)
                            return t;
                        if ((e = e.slice(0, n)).match(/^([^\/]+:\/)?\/*$/))
                            return t;
                        ++r;
                    }
                    return Array(r + 1).join('../') + t.substr(e.length + 1);
                };
                var c = !('__proto__' in Object.create(null));
                function u(e) {
                    return e;
                }
                function l(e) {
                    if (!e)
                        return !1;
                    var t = e.length;
                    if (t < 9)
                        return !1;
                    if (95 !== e.charCodeAt(t - 1) || 95 !== e.charCodeAt(t - 2) || 111 !== e.charCodeAt(t - 3) || 116 !== e.charCodeAt(t - 4) || 111 !== e.charCodeAt(t - 5) || 114 !== e.charCodeAt(t - 6) || 112 !== e.charCodeAt(t - 7) || 95 !== e.charCodeAt(t - 8) || 95 !== e.charCodeAt(t - 9))
                        return !1;
                    for (var r = t - 10; r >= 0; r--)
                        if (36 !== e.charCodeAt(r))
                            return !1;
                    return !0;
                }
                function d(e, t) {
                    return e === t ? 0 : null === e ? 1 : null === t ? -1 : e > t ? 1 : -1;
                }
                t.toSetString = c ? u : function (e) {
                    return l(e) ? '$' + e : e;
                }, t.fromSetString = c ? u : function (e) {
                    return l(e) ? e.slice(1) : e;
                }, t.compareByOriginalPositions = function (e, t, r) {
                    var n = d(e.source, t.source);
                    return 0 !== n || 0 != (n = e.originalLine - t.originalLine) || 0 != (n = e.originalColumn - t.originalColumn) || r || 0 != (n = e.generatedColumn - t.generatedColumn) || 0 != (n = e.generatedLine - t.generatedLine) ? n : d(e.name, t.name);
                }, t.compareByGeneratedPositionsDeflated = function (e, t, r) {
                    var n = e.generatedLine - t.generatedLine;
                    return 0 !== n || 0 != (n = e.generatedColumn - t.generatedColumn) || r || 0 !== (n = d(e.source, t.source)) || 0 != (n = e.originalLine - t.originalLine) || 0 != (n = e.originalColumn - t.originalColumn) ? n : d(e.name, t.name);
                }, t.compareByGeneratedPositionsInflated = function (e, t) {
                    var r = e.generatedLine - t.generatedLine;
                    return 0 !== r || 0 != (r = e.generatedColumn - t.generatedColumn) || 0 !== (r = d(e.source, t.source)) || 0 != (r = e.originalLine - t.originalLine) || 0 != (r = e.originalColumn - t.originalColumn) ? r : d(e.name, t.name);
                }, t.parseSourceMapInput = function (e) {
                    return JSON.parse(e.replace(/^\)]}'[^\n]*\n/, ''));
                }, t.computeSourceURL = function (e, t, r) {
                    if (t = t || '', e && ('/' !== e[e.length - 1] && '/' !== t[0] && (e += '/'), t = e + t), r) {
                        var n = i(r);
                        if (!n)
                            throw new Error('sourceMapURL could not be parsed');
                        if (n.path) {
                            var c = n.path.lastIndexOf('/');
                            c >= 0 && (n.path = n.path.substring(0, c + 1));
                        }
                        t = s(a(n), t);
                    }
                    return o(t);
                };
            },
            9125: (e, t, r) => {
                r(4433).h, r(6771), t.SourceNode = r(1841).SourceNode;
            },
            6573: e => {
                var t = /\{([0-9a-zA-Z_]+)\}/g;
                e.exports = function (e) {
                    var r;
                    if (2 === arguments.length && 'object' == typeof arguments[1])
                        r = arguments[1];
                    else {
                        r = new Array(arguments.length - 1);
                        for (var n = 1; n < arguments.length; ++n)
                            r[n - 1] = arguments[n];
                    }
                    return r && r.hasOwnProperty || (r = {}), e.replace(t, function (t, n, i) {
                        var a;
                        return '{' === e[i - 1] && '}' === e[i + t.length] ? n : null == (a = r.hasOwnProperty(n) ? r[n] : null) ? '' : a;
                    });
                };
            },
            641: function (e, t, r) {
                'use strict';
                var n = this && this.__importDefault || function (e) {
                    return e && e.__esModule ? e : { default: e };
                };
                Object.defineProperty(t, '__esModule', { value: !0 });
                var i = n(r(6880));
                function a(e) {
                    if ('string' != typeof e)
                        throw new Error('A string is expected as input');
                    return e.match(i.default()) || [];
                }
                function o(e) {
                    if ('string' != typeof e)
                        throw new Error('Input must be a string');
                    var t = e.match(i.default());
                    return null === t ? 0 : t.length;
                }
                function s(e, t, r) {
                    if (void 0 === t && (t = 0), 'string' != typeof e)
                        throw new Error('Input must be a string');
                    ('number' != typeof t || t < 0) && (t = 0), 'number' == typeof r && r < 0 && (r = 0);
                    var n = e.match(i.default());
                    return n ? n.slice(t, r).join('') : '';
                }
                t.toArray = a, t.length = o, t.substring = s, t.substr = function (e, t, r) {
                    if (void 0 === t && (t = 0), 'string' != typeof e)
                        throw new Error('Input must be a string');
                    var n, a = o(e);
                    if ('number' != typeof t && (t = parseInt(t, 10)), t >= a)
                        return '';
                    t < 0 && (t += a), void 0 === r ? n = a : ('number' != typeof r && (r = parseInt(r, 10)), n = r >= 0 ? r + t : t);
                    var s = e.match(i.default());
                    return s ? s.slice(t, n).join('') : '';
                }, t.limit = function (e, t, r, n) {
                    if (void 0 === t && (t = 16), void 0 === r && (r = '#'), void 0 === n && (n = 'right'), 'string' != typeof e || 'number' != typeof t)
                        throw new Error('Invalid arguments specified');
                    if (-1 === [
                            'left',
                            'right'
                        ].indexOf(n))
                        throw new Error('Pad position should be either left or right');
                    'string' != typeof r && (r = String(r));
                    var i = o(e);
                    if (i > t)
                        return s(e, 0, t);
                    if (i < t) {
                        var a = r.repeat(t - i);
                        return 'left' === n ? a + e : e + a;
                    }
                    return e;
                }, t.indexOf = function (e, t, r) {
                    if (void 0 === r && (r = 0), 'string' != typeof e)
                        throw new Error('Input must be a string');
                    if ('' === e)
                        return '' === t ? 0 : -1;
                    r = Number(r), r = isNaN(r) ? 0 : r, t = String(t);
                    var n = a(e);
                    if (r >= n.length)
                        return '' === t ? n.length : -1;
                    if ('' === t)
                        return r;
                    var i, o = a(t), s = !1;
                    for (i = r; i < n.length; i += 1) {
                        for (var c = 0; c < o.length && o[c] === n[i + c];)
                            c += 1;
                        if (c === o.length && o[c - 1] === n[i + c - 1]) {
                            s = !0;
                            break;
                        }
                    }
                    return s ? i : -1;
                };
            },
            8555: e => {
                'use strict';
                e.exports = {
                    stdout: !1,
                    stderr: !1
                };
            },
            8492: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 });
                const n = r(5248);
                e.exports = n.JavaScriptObfuscator;
            },
            3191: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    }, o = this && this.__importDefault || function (e) {
                        return e && e.__esModule ? e : { default: e };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ASTParserFacade = void 0;
                const s = a(r(1234)), c = o(r(4061));
                class u {
                    static parse(e, t) {
                        const r = u.sourceTypes.length;
                        for (let n = 0; n < r; n++)
                            try {
                                return u.parseType(e, t, u.sourceTypes[n]);
                            } catch (t) {
                                if (n < r - 1)
                                    continue;
                                throw new Error(u.processParsingError(e, t.message, t.loc));
                            }
                        throw new Error('Acorn parsing error');
                    }
                    static parseType(e, t, r) {
                        const n = [], i = {
                                ...t,
                                allowAwaitOutsideFunction: !0,
                                onComment: n,
                                sourceType: r
                            }, a = s.parse(e, i);
                        return n.length && (a.comments = n), a;
                    }
                    static processParsingError(e, t, r) {
                        if (!(null == r ? void 0 : r.line) || !r.column)
                            throw new Error(t);
                        const n = e.split(/\r?\n/)[r.line - 1];
                        if (!n)
                            throw new Error(t);
                        const i = Math.max(0, r.column - u.nearestSymbolsCount), a = Math.min(n.length, r.column + u.nearestSymbolsCount), o = u.colorError('>'), s = `...${ n.slice(i, a).replace(/^\s+/, '') }...`;
                        throw new Error(`ERROR at line ${ r.line }: ${ t }\n${ o } ${ s }`);
                    }
                }
                t.ASTParserFacade = u, u.colorError = c.default.red, u.nearestSymbolsCount = 15, u.sourceTypes = [
                    'script',
                    'module'
                ];
            },
            157: function (e, t, r) {
                'use strict';
                var n, i = r(4155), a = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), s = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, c = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && a(t, e, r);
                        return o(t, e), t;
                    }, u = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, l = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.JavaScriptObfuscator = void 0;
                const d = r(6594), p = r(2553), f = c(r(3913)), m = r(9292), h = r(6045), g = r(7943), y = r(6188), b = r(780), S = r(3550), v = r(5371), C = r(3191), A = r(8983), _ = r(1700);
                let E = n = class {
                    constructor(e, t, r, n, i, a) {
                        this.codeTransformersRunner = e, this.nodeTransformersRunner = t, this.randomGenerator = r, this.obfuscationResultFactory = n, this.logger = i, this.options = a;
                    }
                    obfuscate(e) {
                        'string' != typeof e && (e = '');
                        const t = Date.now();
                        this.logger.info(g.LoggingMessage.Version, _.Utils.buildVersionMessage('4.1.0', i.env.BUILD_TIMESTAMP)), this.logger.info(g.LoggingMessage.ObfuscationStarted), this.logger.info(g.LoggingMessage.RandomGeneratorSeed, this.randomGenerator.getInputSeed()), e = this.runCodeTransformationStage(e, h.CodeTransformationStage.PreparingTransformers);
                        const r = this.parseCode(e), n = this.transformAstTree(r), a = this.generateCode(e, n);
                        a.code = this.runCodeTransformationStage(a.code, h.CodeTransformationStage.FinalizingTransformers);
                        const o = (Date.now() - t) / 1000;
                        return this.logger.success(g.LoggingMessage.ObfuscationCompleted, o), this.getObfuscationResult(a);
                    }
                    parseCode(e) {
                        return C.ASTParserFacade.parse(e, n.parseOptions);
                    }
                    transformAstTree(e) {
                        return e = this.runNodeTransformationStage(e, b.NodeTransformationStage.Initializing), !A.NodeGuards.isProgramNode(e) || e.body.length || e.leadingComments || e.trailingComments ? (e = this.runNodeTransformationStage(e, b.NodeTransformationStage.Preparing), this.options.deadCodeInjection && (e = this.runNodeTransformationStage(e, b.NodeTransformationStage.DeadCodeInjection)), e = this.runNodeTransformationStage(e, b.NodeTransformationStage.ControlFlowFlattening), this.options.renameProperties && (e = this.runNodeTransformationStage(e, b.NodeTransformationStage.RenameProperties)), e = this.runNodeTransformationStage(e, b.NodeTransformationStage.Converting), e = this.runNodeTransformationStage(e, b.NodeTransformationStage.RenameIdentifiers), e = this.runNodeTransformationStage(e, b.NodeTransformationStage.StringArray), this.options.simplify && (e = this.runNodeTransformationStage(e, b.NodeTransformationStage.Simplifying)), e = this.runNodeTransformationStage(e, b.NodeTransformationStage.Finalizing)) : (this.logger.warn(g.LoggingMessage.EmptySourceCode), e);
                    }
                    generateCode(e, t) {
                        const r = {
                                ...n.escodegenParams,
                                format: { compact: this.options.compact },
                                ...this.options.sourceMap && {
                                    ...this.options.sourceMapSourcesMode === S.SourceMapSourcesMode.SourcesContent ? {
                                        sourceMap: 'sourceMap',
                                        sourceContent: e
                                    } : { sourceMap: this.options.inputFileName || 'sourceMap' }
                                }
                            }, i = f.generate(t, r);
                        return i.map = i.map ? i.map.toString() : '', i;
                    }
                    getObfuscationResult(e) {
                        return this.obfuscationResultFactory(e.code, e.map);
                    }
                    runCodeTransformationStage(e, t) {
                        return this.logger.info(g.LoggingMessage.CodeTransformationStage, t), this.codeTransformersRunner.transform(e, n.codeTransformersList, t);
                    }
                    runNodeTransformationStage(e, t) {
                        return this.logger.info(g.LoggingMessage.NodeTransformationStage, t), this.nodeTransformersRunner.transform(e, n.nodeTransformersList, t);
                    }
                };
                E.parseOptions = {
                    ecmaVersion: v.ecmaVersion,
                    allowHashBang: !0,
                    allowImportExportEverywhere: !0,
                    allowReturnOutsideFunction: !0,
                    locations: !0,
                    ranges: !0
                }, E.escodegenParams = {
                    comment: !0,
                    verbatim: 'x-verbatim-property',
                    sourceMapWithCode: !0
                }, E.codeTransformersList = [m.CodeTransformer.HashbangOperatorTransformer], E.nodeTransformersList = [
                    y.NodeTransformer.BooleanLiteralTransformer,
                    y.NodeTransformer.BlockStatementControlFlowTransformer,
                    y.NodeTransformer.BlockStatementSimplifyTransformer,
                    y.NodeTransformer.ClassFieldTransformer,
                    y.NodeTransformer.CommentsTransformer,
                    y.NodeTransformer.CustomCodeHelpersTransformer,
                    y.NodeTransformer.DeadCodeInjectionTransformer,
                    y.NodeTransformer.EscapeSequenceTransformer,
                    y.NodeTransformer.EvalCallExpressionTransformer,
                    y.NodeTransformer.ExportSpecifierTransformer,
                    y.NodeTransformer.ExpressionStatementsMergeTransformer,
                    y.NodeTransformer.FunctionControlFlowTransformer,
                    y.NodeTransformer.IfStatementSimplifyTransformer,
                    y.NodeTransformer.LabeledStatementTransformer,
                    y.NodeTransformer.RenamePropertiesTransformer,
                    y.NodeTransformer.MemberExpressionTransformer,
                    y.NodeTransformer.MetadataTransformer,
                    y.NodeTransformer.NumberLiteralTransformer,
                    y.NodeTransformer.NumberToNumericalExpressionTransformer,
                    y.NodeTransformer.ObfuscatingGuardsTransformer,
                    y.NodeTransformer.ObjectExpressionKeysTransformer,
                    y.NodeTransformer.ObjectExpressionTransformer,
                    y.NodeTransformer.ObjectPatternPropertiesTransformer,
                    y.NodeTransformer.ParentificationTransformer,
                    y.NodeTransformer.ScopeIdentifiersTransformer,
                    y.NodeTransformer.ScopeThroughIdentifiersTransformer,
                    y.NodeTransformer.SplitStringTransformer,
                    y.NodeTransformer.StringArrayControlFlowTransformer,
                    y.NodeTransformer.StringArrayRotateFunctionTransformer,
                    y.NodeTransformer.StringArrayScopeCallsWrapperTransformer,
                    y.NodeTransformer.StringArrayTransformer,
                    y.NodeTransformer.TemplateLiteralTransformer,
                    y.NodeTransformer.DirectivePlacementTransformer,
                    y.NodeTransformer.VariableDeclarationsMergeTransformer,
                    y.NodeTransformer.VariablePreserveTransformer
                ], E = n = s([
                    (0, d.injectable)(),
                    l(0, (0, d.inject)(p.ServiceIdentifiers.ICodeTransformersRunner)),
                    l(1, (0, d.inject)(p.ServiceIdentifiers.INodeTransformersRunner)),
                    l(2, (0, d.inject)(p.ServiceIdentifiers.IRandomGenerator)),
                    l(3, (0, d.inject)(p.ServiceIdentifiers.Factory__IObfuscationResult)),
                    l(4, (0, d.inject)(p.ServiceIdentifiers.ILogger)),
                    l(5, (0, d.inject)(p.ServiceIdentifiers.IOptions)),
                    u('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Function,
                        Object,
                        Object
                    ])
                ], E), t.JavaScriptObfuscator = E;
            },
            5248: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.JavaScriptObfuscator = void 0, r(8660);
                const n = r(2553), i = r(9723), a = r(4081), o = r(1700);
                class s {
                    static obfuscate(e, t = {}) {
                        const r = new i.InversifyContainerFacade();
                        r.load(e, '', t);
                        const a = r.get(n.ServiceIdentifiers.IJavaScriptObfuscator).obfuscate(e);
                        return r.unload(), a;
                    }
                    static obfuscateMultiple(e, t = {}) {
                        if ('object' != typeof e)
                            throw new Error('Source codes object should be a plain object');
                        return Object.keys(e).reduce((r, n, i) => {
                            const a = o.Utils.getIdentifiersPrefixForMultipleSources(t.identifiersPrefix, i), c = e[n], u = {
                                    ...t,
                                    identifiersPrefix: a
                                };
                            return {
                                ...r,
                                [n]: s.obfuscate(c, u)
                            };
                        }, {});
                    }
                    static getOptionsByPreset(e) {
                        return a.Options.getOptionsByPreset(e);
                    }
                }
                t.JavaScriptObfuscator = s, s.version = null !== '4.1.0' ? '4.1.0' : 'unknown';
            },
            9385: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    }, c = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, u = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CallsGraphAnalyzer = void 0;
                const l = r(6594), d = r(2553), p = s(r(140)), f = r(9072), m = r(8983), h = r(3790);
                let g = n = class {
                    constructor(e) {
                        this.calleeDataExtractorFactory = e;
                    }
                    static getLimitIndex(e) {
                        const t = e - 1, r = n.limitThresholdActivationLength - 1;
                        let i = t;
                        return t > r && (i = Math.round(r + t * n.limitThreshold), i > t && (i = t)), i;
                    }
                    analyze(e) {
                        return this.analyzeRecursive(e.body);
                    }
                    analyzeRecursive(e) {
                        const t = n.getLimitIndex(e.length), r = [], i = e.length;
                        for (let n = 0; n < i && !(n > t); n++) {
                            const t = e[n];
                            p.traverse(t, {
                                enter: n => {
                                    if (m.NodeGuards.isCallExpressionNode(n))
                                        return t.parentNode !== h.NodeStatementUtils.getParentNodeWithStatements(n) ? p.VisitorOption.Skip : void this.analyzeCallExpressionNode(r, e, n);
                                }
                            });
                        }
                        return r;
                    }
                    analyzeCallExpressionNode(e, t, r) {
                        n.calleeDataExtractorsList.forEach(n => {
                            const i = this.calleeDataExtractorFactory(n).extract(t, r.callee);
                            i && e.push({
                                ...i,
                                callsGraph: this.analyzeRecursive(i.callee.body)
                            });
                        });
                    }
                };
                g.calleeDataExtractorsList = [
                    f.CalleeDataExtractor.FunctionDeclarationCalleeDataExtractor,
                    f.CalleeDataExtractor.FunctionExpressionCalleeDataExtractor,
                    f.CalleeDataExtractor.ObjectExpressionCalleeDataExtractor
                ], g.limitThresholdActivationLength = 25, g.limitThreshold = 0.002, g = n = o([
                    (0, l.injectable)(),
                    u(0, (0, l.inject)(d.ServiceIdentifiers.Factory__ICalleeDataExtractor)),
                    c('design:paramtypes', [Function])
                ], g), t.CallsGraphAnalyzer = g;
            },
            4205: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                    var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                    if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                        o = Reflect.decorate(e, t, r, n);
                    else
                        for (var s = e.length - 1; s >= 0; s--)
                            (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                    return a > 3 && o && Object.defineProperty(t, r, o), o;
                };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractCalleeDataExtractor = void 0;
                const i = r(6594);
                let a = class {
                };
                a = n([(0, i.injectable)()], a), t.AbstractCalleeDataExtractor = a;
            },
            6829: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, o = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.FunctionDeclarationCalleeDataExtractor = void 0;
                const s = r(6594), c = o(r(140)), u = r(4205), l = r(8983), d = r(3790);
                let p = class extends u.AbstractCalleeDataExtractor {
                    extract(e, t) {
                        if (!l.NodeGuards.isIdentifierNode(t))
                            return null;
                        const r = this.getCalleeBlockStatement(d.NodeStatementUtils.getParentNodeWithStatements(e[0]), t.name);
                        return r ? {
                            callee: r,
                            name: t.name
                        } : null;
                    }
                    getCalleeBlockStatement(e, t) {
                        let r = null;
                        return c.traverse(e, {
                            enter: e => {
                                if (l.NodeGuards.isFunctionDeclarationNode(e) && e.id.name === t)
                                    return r = e.body, c.VisitorOption.Break;
                            }
                        }), r;
                    }
                };
                p = a([(0, s.injectable)()], p), t.FunctionDeclarationCalleeDataExtractor = p;
            },
            1699: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, o = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.FunctionExpressionCalleeDataExtractor = void 0;
                const s = r(6594), c = o(r(140)), u = r(4205), l = r(8983), d = r(3790);
                let p = class extends u.AbstractCalleeDataExtractor {
                    extract(e, t) {
                        let r = null, n = null;
                        return l.NodeGuards.isIdentifierNode(t) ? (r = t.name, n = this.getCalleeBlockStatement(d.NodeStatementUtils.getParentNodeWithStatements(e[0]), t.name)) : l.NodeGuards.isFunctionExpressionNode(t) && (r = null, n = t.body), n ? {
                            callee: n,
                            name: r
                        } : null;
                    }
                    getCalleeBlockStatement(e, t) {
                        let r = null;
                        return c.traverse(e, {
                            enter: (e, n) => {
                                if (l.NodeGuards.isFunctionExpressionNode(e) && n && l.NodeGuards.isVariableDeclaratorNode(n) && l.NodeGuards.isIdentifierNode(n.id) && n.id.name === t)
                                    return r = e.body, c.VisitorOption.Break;
                            }
                        }), r;
                    }
                };
                p = a([(0, s.injectable)()], p), t.FunctionExpressionCalleeDataExtractor = p;
            },
            8448: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObjectExpressionCalleeDataExtractor = void 0;
                const c = r(6594), u = s(r(140)), l = r(4205), d = r(8983), p = r(3790);
                let f = n = class extends l.AbstractCalleeDataExtractor {
                    static isValidTargetPropertyNode(e, t) {
                        if (!e.key)
                            return !1;
                        const r = d.NodeGuards.isIdentifierNode(e.key) && e.key.name === t, n = d.NodeGuards.isLiteralNode(e.key) && Boolean(e.key.value) && e.key.value === t;
                        return r || n;
                    }
                    extract(e, t) {
                        if (!d.NodeGuards.isMemberExpressionNode(t))
                            return null;
                        const r = this.createObjectMembersCallsChain([], t);
                        if (!r.length)
                            return null;
                        const n = r[r.length - 1], i = this.getCalleeBlockStatement(p.NodeStatementUtils.getParentNodeWithStatements(e[0]), r);
                        return i ? {
                            callee: i,
                            name: n
                        } : null;
                    }
                    createObjectMembersCallsChain(e, t) {
                        if (d.NodeGuards.isIdentifierNode(t.property) && !t.computed)
                            e.unshift(t.property.name);
                        else {
                            if (!d.NodeGuards.isLiteralNode(t.property) || 'string' != typeof t.property.value && 'number' != typeof t.property.value)
                                return e;
                            e.unshift(t.property.value);
                        }
                        return d.NodeGuards.isMemberExpressionNode(t.object) ? this.createObjectMembersCallsChain(e, t.object) : (d.NodeGuards.isIdentifierNode(t.object) && e.unshift(t.object.name), e);
                    }
                    getCalleeBlockStatement(e, t) {
                        const r = t.shift();
                        if (!r)
                            return null;
                        let n = null;
                        return u.traverse(e, {
                            enter: e => {
                                if (d.NodeGuards.isVariableDeclaratorNode(e) && d.NodeGuards.isIdentifierNode(e.id) && e.init && d.NodeGuards.isObjectExpressionNode(e.init) && e.id.name === r)
                                    return n = this.findCalleeBlockStatement(e.init.properties, t), u.VisitorOption.Break;
                            }
                        }), n;
                    }
                    findCalleeBlockStatement(e, t) {
                        const r = t.shift();
                        if (!r)
                            return null;
                        for (const i of e)
                            if (d.NodeGuards.isPropertyNode(i) && n.isValidTargetPropertyNode(i, r)) {
                                if (d.NodeGuards.isObjectExpressionNode(i.value))
                                    return this.findCalleeBlockStatement(i.value.properties, t);
                                if (d.NodeGuards.isFunctionExpressionNode(i.value))
                                    return i.value.body;
                            }
                        return null;
                    }
                };
                f = n = o([(0, c.injectable)()], f), t.ObjectExpressionCalleeDataExtractor = f;
            },
            9504: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NumberNumericalExpressionAnalyzer = void 0;
                const s = r(6594), c = r(2553), u = r(2303);
                let l = n = class {
                    constructor(e) {
                        this.numberFactorsMap = new Map(), this.randomGenerator = e;
                    }
                    analyze(e, t) {
                        if (isNaN(e))
                            throw new Error('Given value is NaN');
                        return u.NumberUtils.isUnsafeNumber(e) ? [e] : this.generateAdditionParts(e, t).map(e => this.mixWithMultiplyParts(e));
                    }
                    generateAdditionParts(e, t) {
                        const r = [], i = Math.min(Math.abs(2 * e), Number.MAX_SAFE_INTEGER), a = Math.min(-n.delta, -i), o = Math.max(n.delta, i);
                        let s = 0;
                        for (let n = 0; n < t; n++)
                            if (n < t - 1) {
                                let e = this.randomGenerator.getRandomInteger(a, o);
                                u.NumberUtils.isUnsafeNumber(s + e) && (e = -e), r.push(e), s += e;
                            } else {
                                const t = e - s;
                                u.NumberUtils.isUnsafeNumber(t) ? (r.push(0 - s), r.push(e)) : r.push(t);
                            }
                        return r;
                    }
                    mixWithMultiplyParts(e) {
                        var t;
                        if (!(this.randomGenerator.getMathRandom() > 0.5) || 0 === e)
                            return e;
                        let r = null !== (t = this.numberFactorsMap.get(e)) && void 0 !== t ? t : null;
                        if (r || (r = u.NumberUtils.getFactors(e), this.numberFactorsMap.set(e, r)), !r.length)
                            return e;
                        const n = r[this.randomGenerator.getRandomInteger(0, r.length - 1)];
                        return [
                            n,
                            e / n
                        ];
                    }
                };
                l.defaultAdditionalPartsCount = 3, l.delta = 10000, l = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    a('design:paramtypes', [Object])
                ], l), t.NumberNumericalExpressionAnalyzer = l;
            },
            6849: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    }, c = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, u = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.PrevailingKindOfVariablesAnalyzer = void 0;
                const l = r(6594), d = r(2553), p = s(r(140)), f = r(8983);
                let m = n = class {
                    constructor(e) {
                        this.prevailingKindOfVariables = n.defaultKindOfVariables, this.arrayUtils = e;
                    }
                    analyze(e) {
                        var t;
                        const r = [];
                        p.traverse(e, {
                            enter: e => {
                                f.NodeGuards.isVariableDeclarationNode(e) && r.push(e.kind);
                            }
                        }), this.prevailingKindOfVariables = null !== (t = this.arrayUtils.findMostOccurringElement(r)) && void 0 !== t ? t : n.defaultKindOfVariables;
                    }
                    getPrevailingKind() {
                        return this.prevailingKindOfVariables;
                    }
                };
                m.defaultKindOfVariables = 'var', m = n = o([
                    (0, l.injectable)(),
                    u(0, (0, l.inject)(d.ServiceIdentifiers.IArrayUtils)),
                    c('design:paramtypes', [Object])
                ], m), t.PrevailingKindOfVariablesAnalyzer = m;
            },
            1519: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ScopeAnalyzer = void 0;
                const c = r(6594), u = s(r(4900)), l = s(r(140)), d = r(1286), p = r(5371), f = r(8983);
                let m = n = class {
                    constructor() {
                        this.scopeManager = null;
                    }
                    static attachMissingRanges(e) {
                        l.replace(e, {
                            enter: (e, t) => {
                                var r, i, a, o;
                                return e.range || (e.range = [
                                    null !== (i = null === (r = null == t ? void 0 : t.range) || void 0 === r ? void 0 : r[0]) && void 0 !== i ? i : n.emptyRangeValue,
                                    null !== (o = null === (a = null == t ? void 0 : t.range) || void 0 === a ? void 0 : a[1]) && void 0 !== o ? o : n.emptyRangeValue
                                ]), e;
                            }
                        });
                    }
                    static isRootNode(e) {
                        return f.NodeGuards.isProgramNode(e) || e.parentNode === e;
                    }
                    analyze(e) {
                        const t = n.sourceTypes.length;
                        n.attachMissingRanges(e);
                        for (let r = 0; r < t; r++)
                            try {
                                return void (this.scopeManager = u.analyze(e, {
                                    ...n.eslintScopeOptions,
                                    sourceType: n.sourceTypes[r]
                                }));
                            } catch (e) {
                                if (r < t - 1)
                                    continue;
                                throw new Error(e);
                            }
                        throw new Error('Scope analyzing error');
                    }
                    acquireScope(e) {
                        if (!this.scopeManager)
                            throw new Error('Scope manager is not defined');
                        const t = this.scopeManager.acquire(e, n.isRootNode(e));
                        if (!t)
                            throw new Error('Cannot acquire scope for node');
                        return this.sanitizeScopes(t), t;
                    }
                    sanitizeScopes(e) {
                        e.childScopes.forEach(e => {
                            if ('class' === e.type && e.upper) {
                                if (!e.variables.length)
                                    return;
                                const t = e.variables[0], r = e.upper.variables.find(e => t.defs.some(e => 'ClassName' === e.type) && e.name === t.name);
                                null == r || r.references.push(...e.variables[0].references);
                            }
                        });
                        for (const t of e.childScopes)
                            this.sanitizeScopes(t);
                    }
                };
                m.eslintScopeOptions = {
                    ecmaVersion: p.ecmaVersion,
                    childVisitorKeys: d.KEYS,
                    optimistic: !0
                }, m.sourceTypes = [
                    'script',
                    'module'
                ], m.emptyRangeValue = 0, m = n = o([(0, c.injectable)()], m), t.ScopeAnalyzer = m;
            },
            3480: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    }, c = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, u = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayStorageAnalyzer = void 0;
                const l = r(6594), d = r(2553), p = s(r(140)), f = r(8983), m = r(7586), h = r(5301);
                let g = n = class {
                    constructor(e, t, r) {
                        this.stringArrayStorageData = new WeakMap(), this.stringArrayStorage = e, this.randomGenerator = t, this.options = r;
                    }
                    analyze(e) {
                        this.options.stringArray && p.traverse(e, {
                            enter: (e, t) => {
                                if (t)
                                    return h.NodeMetadata.isIgnoredNode(e) ? p.VisitorOption.Skip : void (f.NodeGuards.isLiteralNode(e) && this.analyzeLiteralNode(e, t));
                            }
                        });
                    }
                    analyzeLiteralNode(e, t) {
                        m.NodeLiteralUtils.isStringLiteralNode(e) && (m.NodeLiteralUtils.isProhibitedLiteralNode(e, t) || this.shouldAddValueToStringArray(e) && this.addItemDataForLiteralNode(e));
                    }
                    addItemDataForLiteralNode(e) {
                        this.stringArrayStorageData.set(e, this.stringArrayStorage.getOrThrow(e.value));
                    }
                    getItemDataForLiteralNode(e) {
                        return this.stringArrayStorageData.get(e);
                    }
                    shouldAddValueToStringArray(e) {
                        return !!h.NodeMetadata.isForceTransformNode(e) || e.value.length >= n.minimumLengthForStringArray && !!this.options.stringArrayThreshold && this.randomGenerator.getMathRandom() <= this.options.stringArrayThreshold;
                    }
                };
                g.minimumLengthForStringArray = 3, g = n = o([
                    (0, l.injectable)(),
                    u(0, (0, l.inject)(d.ServiceIdentifiers.IStringArrayStorage)),
                    u(1, (0, l.inject)(d.ServiceIdentifiers.IRandomGenerator)),
                    u(2, (0, l.inject)(d.ServiceIdentifiers.IOptions)),
                    c('design:paramtypes', [
                        Object,
                        Object,
                        Object
                    ])
                ], g), t.StringArrayStorageAnalyzer = g;
            },
            5485: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractCodeTransformer = void 0;
                const o = r(6594), s = r(2553);
                let c = class {
                    constructor(e, t) {
                        this.randomGenerator = e, this.options = t;
                    }
                };
                c = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], c), t.AbstractCodeTransformer = c;
            },
            2768: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                    var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                    if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                        o = Reflect.decorate(e, t, r, n);
                    else
                        for (var s = e.length - 1; s >= 0; s--)
                            (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                    return a > 3 && o && Object.defineProperty(t, r, o), o;
                };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CodeTransformerNamesGroupsBuilder = void 0;
                const i = r(6594), a = r(576);
                let o = class extends a.AbstractTransformerNamesGroupsBuilder {
                };
                o = n([(0, i.injectable)()], o), t.CodeTransformerNamesGroupsBuilder = o;
            },
            8206: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CodeTransformersRunner = void 0;
                const o = r(6594), s = r(2553);
                let c = class {
                    constructor(e, t) {
                        this.codeTransformerFactory = e, this.codeTransformerNamesGroupsBuilder = t;
                    }
                    transform(e, t, r) {
                        if (!t.length)
                            return e;
                        const n = this.buildNormalizedCodeTransformers(t, r), i = this.codeTransformerNamesGroupsBuilder.build(n);
                        for (const t of i)
                            for (const i of t)
                                e = n[i].transformCode(e, r);
                        return e;
                    }
                    buildNormalizedCodeTransformers(e, t) {
                        return e.reduce((e, t) => ({
                            ...e,
                            [t]: this.codeTransformerFactory(t)
                        }), {});
                    }
                };
                c = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__ICodeTransformer)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICodeTransformerNamesGroupsBuilder)),
                    i('design:paramtypes', [
                        Function,
                        Object
                    ])
                ], c), t.CodeTransformersRunner = c;
            },
            6917: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.HashbangOperatorTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(6045), u = r(5485);
                let l = class extends u.AbstractCodeTransformer {
                    constructor(e, t) {
                        super(e, t), this.hashbangOperatorLine = null;
                    }
                    transformCode(e, t) {
                        switch (t) {
                        case c.CodeTransformationStage.PreparingTransformers:
                            return this.removeAndSaveHashbangOperatorLine(e);
                        case c.CodeTransformationStage.FinalizingTransformers:
                            return this.appendSavedHashbangOperatorLine(e);
                        default:
                            return e;
                        }
                    }
                    removeAndSaveHashbangOperatorLine(e) {
                        return e.replace(/^#!.*$(\r?\n)*/m, e => (e && (this.hashbangOperatorLine = e), '')).trim();
                    }
                    appendSavedHashbangOperatorLine(e) {
                        var t;
                        return `${ null !== (t = this.hashbangOperatorLine) && void 0 !== t ? t : '' }${ e }`;
                    }
                };
                l = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], l), t.HashbangOperatorTransformer = l;
            },
            3477: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.alphabetString = void 0, t.alphabetString = 'abcdefghijklmnopqrstuvwxyz';
            },
            4287: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.alphabetStringUppercase = void 0;
                const n = r(3477);
                t.alphabetStringUppercase = n.alphabetString.toUpperCase();
            },
            1047: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.base64alphabet = void 0;
                const n = r(4287), i = r(3477), a = r(6544);
                t.base64alphabet = `${ n.alphabetStringUppercase }${ i.alphabetString }${ a.numbersString }+/=`;
            },
            99: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.base64alphabetSwapped = void 0;
                const n = r(4287), i = r(3477), a = r(6544);
                t.base64alphabetSwapped = `${ i.alphabetString }${ n.alphabetStringUppercase }${ a.numbersString }+/=`;
            },
            5371: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ecmaVersion = void 0, t.ecmaVersion = 13;
            },
            6544: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.numbersString = void 0, t.numbersString = '0123456789';
            },
            7078: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.reservedIdentifierNames = void 0, t.reservedIdentifierNames = [
                    'byte',
                    'case',
                    'char',
                    'do',
                    'else',
                    'enum',
                    'eval',
                    'for',
                    'goto',
                    'if',
                    'in',
                    'int',
                    'let',
                    'long',
                    'new',
                    'null',
                    'this',
                    'true',
                    'try',
                    'var',
                    'void',
                    'with',
                    'Array',
                    'Attr',
                    'Audio',
                    'Blob',
                    'Cache',
                    'Date',
                    'Error',
                    'Event',
                    'Feed',
                    'File',
                    'Hz',
                    'Image',
                    'Intl',
                    'Lock',
                    'Map',
                    'Math',
                    'Node',
                    'Proxy',
                    'Range',
                    'Rect',
                    'Set',
                    'Table',
                    'Text',
                    'Touch'
                ];
            },
            9723: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.InversifyContainerFacade = void 0;
                const n = r(6594), i = r(2553), a = r(3299), o = r(6273), s = r(6274), c = r(6624), u = r(5768), l = r(2366), d = r(8130), p = r(1092), f = r(1212), m = r(3713), h = r(5293), g = r(8638), y = r(2755), b = r(6458), S = r(4561), v = r(8682), C = r(4008), A = r(4948), _ = r(4697), E = r(5332), N = r(8206), I = r(157), T = r(7702), D = r(3107), O = r(128), R = r(7865);
                t.InversifyContainerFacade = class {
                    constructor() {
                        this.container = new n.Container();
                    }
                    static getFactory(e) {
                        return t => r => t.container.getNamed(e, r);
                    }
                    static getCacheFactory(e) {
                        return t => {
                            const r = new Map();
                            return n => {
                                if (r.has(n))
                                    return r.get(n);
                                const i = t.container.getNamed(e, n);
                                return r.set(n, i), i;
                            };
                        };
                    }
                    static getConstructorFactory(e, ...t) {
                        return r => {
                            const n = new Map(), i = [];
                            return a => {
                                if (t.forEach((e, t) => {
                                        i[t] || (i[t] = r.container.get(e));
                                    }), n.has(a))
                                    return new (n.get(a))(...i);
                                const o = r.container.getNamed(e, a);
                                return n.set(a, o), new o(...i);
                            };
                        };
                    }
                    get(e) {
                        return this.container.get(e);
                    }
                    getNamed(e, t) {
                        return this.container.getNamed(e, t);
                    }
                    load(e, t, r) {
                        this.container.bind(i.ServiceIdentifiers.ISourceCode).toDynamicValue(() => new R.SourceCode(e, t)).inSingletonScope(), this.container.bind(i.ServiceIdentifiers.TInputOptions).toDynamicValue(() => r).inSingletonScope(), this.container.bind(i.ServiceIdentifiers.ILogger).to(T.Logger).inSingletonScope(), this.container.bind(i.ServiceIdentifiers.IJavaScriptObfuscator).to(I.JavaScriptObfuscator).inSingletonScope(), this.container.bind(i.ServiceIdentifiers.ICodeTransformersRunner).to(N.CodeTransformersRunner).inSingletonScope(), this.container.bind(i.ServiceIdentifiers.INodeTransformersRunner).to(D.NodeTransformersRunner).inSingletonScope(), this.container.bind(i.ServiceIdentifiers.IObfuscationResult).to(O.ObfuscationResult), this.container.bind(i.ServiceIdentifiers.Factory__IObfuscationResult).toFactory(e => (t, r) => {
                            const n = e.container.get(i.ServiceIdentifiers.IObfuscationResult);
                            return n.initialize(t, r), n;
                        }), this.container.load(a.analyzersModule), this.container.load(o.codeTransformersModule), this.container.load(s.controlFlowTransformersModule), this.container.load(c.convertingTransformersModule), this.container.load(u.customCodeHelpersModule), this.container.load(l.customNodesModule), this.container.load(d.deadCodeInjectionTransformersModule), this.container.load(p.finalizingTransformersModule), this.container.load(f.generatorsModule), this.container.load(m.initializingTransformersModule), this.container.load(h.nodeModule), this.container.load(g.nodeTransformersModule), this.container.load(y.optionsModule), this.container.load(b.preparingTransformersModule), this.container.load(S.renameIdentifiersTransformersModule), this.container.load(v.renamePropertiesTransformersModule), this.container.load(C.simplifyingTransformersModule), this.container.load(A.storagesModule), this.container.load(_.stringArrayTransformersModule), this.container.load(E.utilsModule);
                    }
                    unload() {
                        this.container.unbindAll();
                    }
                };
            },
            2553: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ServiceIdentifiers = void 0, (r = t.ServiceIdentifiers || (t.ServiceIdentifiers = {})).Factory__ICalleeDataExtractor = 'Factory<ICalleeDataExtractor>', r.Factory__ICodeTransformer = 'Factory<ICodeTransformer[]>', r.Factory__IControlFlowCustomNode = 'Factory<IControlFlowCustomNode>', r.Factory__IControlFlowReplacer = 'Factory<IControlFlowReplacer>', r.Factory__ICustomCodeHelper = 'Factory<ICustomCodeHelper>', r.Factory__ICustomCodeHelperGroup = 'Factory<ICustomCodeHelperGroup>', r.Factory__IDeadCodeInjectionCustomNode = 'Factory<IDeadCodeInjectionCustomNode>', r.Factory__IIdentifierNamesGenerator = 'Factory<IIdentifierNamesGenerator>', r.Factory__INodeGuard = 'Factory<INodeGuard>', r.Factory__INodeTransformer = 'Factory<INodeTransformer[]>', r.Factory__IObfuscationResult = 'Factory<IObfuscationResult>', r.Factory__IObjectExpressionKeysTransformerCustomNode = 'Factory<IObjectExpressionKeysTransformerCustomNode>', r.Factory__IObjectExpressionExtractor = 'Factory<IObjectExpressionExtractor>', r.Factory__IStringArrayCustomNode = 'Factory<IStringArrayCustomNode>', r.Factory__IStringArrayIndexNode = 'Factory<IStringArrayIndexNode>', r.Factory__TControlFlowStorage = 'Factory<TControlFlowStorage>', r.IArrayUtils = 'IArrayUtils', r.ICalleeDataExtractor = 'ICalleeDataExtractor', r.ICallsGraphAnalyzer = 'ICallsGraphAnalyzer', r.ICodeTransformer = 'ICodeTransformer', r.ICodeTransformerNamesGroupsBuilder = 'ICodeTransformerNamesGroupsBuilder', r.ICodeTransformersRunner = 'ICodeTransformersRunner', r.IControlFlowStorage = 'IControlFlowStorage', r.ICryptUtils = 'ICryptUtils', r.ICryptUtilsStringArray = 'ICryptUtilsStringArray', r.ICustomCodeHelper = 'ICustomCodeHelper', r.ICustomCodeHelperGroup = 'ICustomCodeHelperGroup', r.IControlFlowReplacer = 'IControlFlowReplacer', r.ICustomCodeHelperFormatter = 'ICustomCodeHelperFormatter', r.ICustomCodeHelperObfuscator = 'ICustomCodeHelperObfuscator', r.IEscapeSequenceEncoder = 'IEscapeSequenceEncoder', r.IGlobalIdentifierNamesCacheStorage = 'IGlobalIdentifierNamesCacheStorage', r.IIdentifierNamesGenerator = 'IIdentifierNamesGenerator', r.IIdentifierReplacer = 'IIdentifierReplacer', r.IJavaScriptObfuscator = 'IJavaScriptObfuscator', r.ILevelledTopologicalSorter = 'ILevelledTopologicalSorter', r.ILiteralNodesCacheStorage = 'ILiteralNodesCacheStorage', r.ILogger = 'ILogger', r.INodeGuard = 'INodeGuard', r.INodeTransformer = 'INodeTransformer', r.INodeTransformerNamesGroupsBuilder = 'INodeTransformerNamesGroupsBuilder', r.INodeTransformersRunner = 'INodeTransformersRunner', r.INumberNumericalExpressionAnalyzer = 'INumberNumericalExpressionAnalyzer', r.IObfuscationResult = 'IObfuscationResult', r.IOptions = 'IOptions', r.IOptionsNormalizer = 'IOptionsNormalizer', r.IPrevailingKindOfVariablesAnalyzer = 'IPrevailingKindOfVariablesAnalyzer', r.IPropertyIdentifierNamesCacheStorage = 'IPropertyIdentifierNamesCacheStorage', r.IObjectExpressionExtractor = 'IObjectExpressionExtractor', r.IRandomGenerator = 'IRandomGenerator', r.IRenamePropertiesReplacer = 'IRenamePropertiesReplacer', r.IScopeIdentifiersTraverser = 'IScopeIdentifiersTraverser', r.ISetUtils = 'ISetUtils', r.ISourceCode = 'ISourceCode', r.IScopeAnalyzer = 'IScopeAnalyzer', r.IStringArrayIndexNode = 'IStringArrayIndexNode', r.IStringArrayScopeCallsWrappersDataStorage = 'IStringArrayScopeCallsWrappersDataStorage', r.IStringArrayStorage = 'IStringArrayStorage', r.IStringArrayStorageAnalyzer = 'IStringArrayStorageAnalyzer', r.IThroughIdentifierReplacer = 'IThroughIdentifierReplacer', r.IVisitedLexicalScopeNodesStackStorage = 'IVisitedLexicalScopeNodesStackStorage', r.Newable__ICustomNode = 'Newable<ICustomNode>', r.TCustomNodeGroupStorage = 'TCustomNodeGroupStorage', r.TInputOptions = 'TInputOptions';
            },
            3299: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.analyzersModule = void 0;
                const n = r(9723), i = r(6594), a = r(2553), o = r(9072), s = r(9385), c = r(6829), u = r(1699), l = r(9504), d = r(8448), p = r(6849), f = r(1519), m = r(3480);
                t.analyzersModule = new i.ContainerModule(e => {
                    e(a.ServiceIdentifiers.ICallsGraphAnalyzer).to(s.CallsGraphAnalyzer).inSingletonScope(), e(a.ServiceIdentifiers.INumberNumericalExpressionAnalyzer).to(l.NumberNumericalExpressionAnalyzer).inSingletonScope(), e(a.ServiceIdentifiers.IPrevailingKindOfVariablesAnalyzer).to(p.PrevailingKindOfVariablesAnalyzer).inSingletonScope(), e(a.ServiceIdentifiers.IScopeAnalyzer).to(f.ScopeAnalyzer).inSingletonScope(), e(a.ServiceIdentifiers.IStringArrayStorageAnalyzer).to(m.StringArrayStorageAnalyzer).inSingletonScope(), e(a.ServiceIdentifiers.ICalleeDataExtractor).to(c.FunctionDeclarationCalleeDataExtractor).whenTargetNamed(o.CalleeDataExtractor.FunctionDeclarationCalleeDataExtractor), e(a.ServiceIdentifiers.ICalleeDataExtractor).to(u.FunctionExpressionCalleeDataExtractor).whenTargetNamed(o.CalleeDataExtractor.FunctionExpressionCalleeDataExtractor), e(a.ServiceIdentifiers.ICalleeDataExtractor).to(d.ObjectExpressionCalleeDataExtractor).whenTargetNamed(o.CalleeDataExtractor.ObjectExpressionCalleeDataExtractor), e(a.ServiceIdentifiers.Factory__ICalleeDataExtractor).toFactory(n.InversifyContainerFacade.getCacheFactory(a.ServiceIdentifiers.ICalleeDataExtractor));
                });
            },
            6273: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.codeTransformersModule = void 0;
                const n = r(9723), i = r(6594), a = r(2553), o = r(9292), s = r(2768), c = r(6917);
                t.codeTransformersModule = new i.ContainerModule(e => {
                    e(a.ServiceIdentifiers.Factory__ICodeTransformer).toFactory(n.InversifyContainerFacade.getCacheFactory(a.ServiceIdentifiers.ICodeTransformer)), e(a.ServiceIdentifiers.ICodeTransformerNamesGroupsBuilder).to(s.CodeTransformerNamesGroupsBuilder).inSingletonScope(), e(a.ServiceIdentifiers.ICodeTransformer).to(c.HashbangOperatorTransformer).whenTargetNamed(o.CodeTransformer.HashbangOperatorTransformer);
                });
            },
            5768: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.customCodeHelpersModule = void 0;
                const n = r(9723), i = r(6594), a = r(2553), o = r(8547), s = r(7705), c = r(2657), u = r(3257), l = r(6853), d = r(5273), p = r(4229), f = r(6580), m = r(7276), h = r(7855), g = r(9), y = r(9648), b = r(4513), S = r(9029), v = r(7911), C = r(9074), A = r(2881), _ = r(5350), E = r(6375), N = r(7025), I = r(8409);
                t.customCodeHelpersModule = new i.ContainerModule(e => {
                    e(a.ServiceIdentifiers.ICustomCodeHelper).to(f.ConsoleOutputDisableCodeHelper).whenTargetNamed(o.CustomCodeHelper.ConsoleOutputDisable), e(a.ServiceIdentifiers.ICustomCodeHelper).to(g.DebugProtectionFunctionCallCodeHelper).whenTargetNamed(o.CustomCodeHelper.DebugProtectionFunctionCall), e(a.ServiceIdentifiers.ICustomCodeHelper).to(y.DebugProtectionFunctionIntervalCodeHelper).whenTargetNamed(o.CustomCodeHelper.DebugProtectionFunctionInterval), e(a.ServiceIdentifiers.ICustomCodeHelper).to(b.DebugProtectionFunctionCodeHelper).whenTargetNamed(o.CustomCodeHelper.DebugProtectionFunction), e(a.ServiceIdentifiers.ICustomCodeHelper).to(S.DomainLockCodeHelper).whenTargetNamed(o.CustomCodeHelper.DomainLock), e(a.ServiceIdentifiers.ICustomCodeHelper).to(v.CallsControllerFunctionCodeHelper).whenTargetNamed(o.CustomCodeHelper.CallsControllerFunction), e(a.ServiceIdentifiers.ICustomCodeHelper).to(C.SelfDefendingCodeHelper).whenTargetNamed(o.CustomCodeHelper.SelfDefending), e(a.ServiceIdentifiers.ICustomCodeHelper).to(A.StringArrayCallsWrapperCodeHelper).whenTargetNamed(o.CustomCodeHelper.StringArrayCallsWrapper), e(a.ServiceIdentifiers.ICustomCodeHelper).to(_.StringArrayCallsWrapperBase64CodeHelper).whenTargetNamed(o.CustomCodeHelper.StringArrayCallsWrapperBase64), e(a.ServiceIdentifiers.ICustomCodeHelper).to(E.StringArrayCallsWrapperRc4CodeHelper).whenTargetNamed(o.CustomCodeHelper.StringArrayCallsWrapperRc4), e(a.ServiceIdentifiers.ICustomCodeHelper).to(N.StringArrayCodeHelper).whenTargetNamed(o.CustomCodeHelper.StringArray), e(a.ServiceIdentifiers.ICustomCodeHelper).to(I.StringArrayRotateFunctionCodeHelper).whenTargetNamed(o.CustomCodeHelper.StringArrayRotateFunction), e(a.ServiceIdentifiers.ICustomCodeHelperGroup).to(c.ConsoleOutputCodeHelperGroup).whenTargetNamed(s.CustomCodeHelperGroup.ConsoleOutput), e(a.ServiceIdentifiers.ICustomCodeHelperGroup).to(u.DebugProtectionCodeHelperGroup).whenTargetNamed(s.CustomCodeHelperGroup.DebugProtection), e(a.ServiceIdentifiers.ICustomCodeHelperGroup).to(l.DomainLockCustomCodeHelperGroup).whenTargetNamed(s.CustomCodeHelperGroup.DomainLock), e(a.ServiceIdentifiers.ICustomCodeHelperGroup).to(d.SelfDefendingCodeHelperGroup).whenTargetNamed(s.CustomCodeHelperGroup.SelfDefending), e(a.ServiceIdentifiers.ICustomCodeHelperGroup).to(p.StringArrayCodeHelperGroup).whenTargetNamed(s.CustomCodeHelperGroup.StringArray), e(a.ServiceIdentifiers.Factory__ICustomCodeHelper).toFactory(n.InversifyContainerFacade.getFactory(a.ServiceIdentifiers.ICustomCodeHelper)), e(a.ServiceIdentifiers.Factory__ICustomCodeHelperGroup).toFactory(n.InversifyContainerFacade.getFactory(a.ServiceIdentifiers.ICustomCodeHelperGroup)), e(a.ServiceIdentifiers.ICustomCodeHelperFormatter).to(m.CustomCodeHelperFormatter).inSingletonScope(), e(a.ServiceIdentifiers.ICustomCodeHelperObfuscator).to(h.CustomCodeHelperObfuscator).inSingletonScope();
                });
            },
            2366: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.customNodesModule = void 0;
                const n = r(9723), i = r(6594), a = r(2553), o = r(6517), s = r(6782), c = r(2982), u = r(3627), l = r(5761), d = r(8773), p = r(5188), f = r(5993), m = r(2854), h = r(5808), g = r(9843), y = r(7587), b = r(6204), S = r(5707), v = r(9358), C = r(8904), A = r(2855), _ = r(1135), E = r(8405), N = r(2603), I = r(6300);
                t.customNodesModule = new i.ContainerModule(e => {
                    e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(l.BinaryExpressionFunctionNode).whenTargetNamed(o.ControlFlowCustomNode.BinaryExpressionFunctionNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(d.BlockStatementControlFlowFlatteningNode).whenTargetNamed(o.ControlFlowCustomNode.BlockStatementControlFlowFlatteningNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(f.CallExpressionControlFlowStorageCallNode).whenTargetNamed(o.ControlFlowCustomNode.CallExpressionControlFlowStorageCallNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(m.CallExpressionFunctionNode).whenTargetNamed(o.ControlFlowCustomNode.CallExpressionFunctionNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(h.ControlFlowStorageNode).whenTargetNamed(o.ControlFlowCustomNode.ControlFlowStorageNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(g.ExpressionWithOperatorControlFlowStorageCallNode).whenTargetNamed(o.ControlFlowCustomNode.ExpressionWithOperatorControlFlowStorageCallNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(I.LiteralNode).whenTargetNamed(o.ControlFlowCustomNode.LiteralNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(y.LogicalExpressionFunctionNode).whenTargetNamed(o.ControlFlowCustomNode.LogicalExpressionFunctionNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(N.StringLiteralControlFlowStorageCallNode).whenTargetNamed(o.ControlFlowCustomNode.StringLiteralControlFlowStorageCallNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(p.BlockStatementDeadCodeInjectionNode).whenTargetNamed(s.DeadCodeInjectionCustomNode.BlockStatementDeadCodeInjectionNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(b.ObjectExpressionVariableDeclarationHostNode).whenTargetNamed(c.ObjectExpressionKeysTransformerCustomNode.ObjectExpressionVariableDeclarationHostNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(S.StringArrayCallNode).whenTargetNamed(u.StringArrayCustomNode.StringArrayCallNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(_.StringArrayScopeCallsWrapperFunctionNode).whenTargetNamed(u.StringArrayCustomNode.StringArrayScopeCallsWrapperFunctionNode), e(a.ServiceIdentifiers.Newable__ICustomNode).toConstructor(E.StringArrayScopeCallsWrapperVariableNode).whenTargetNamed(u.StringArrayCustomNode.StringArrayScopeCallsWrapperVariableNode), e(a.ServiceIdentifiers.IStringArrayIndexNode).to(v.StringArrayHexadecimalNumberIndexNode).inSingletonScope().whenTargetNamed(A.StringArrayIndexNode.StringArrayHexadecimalNumberIndexNode), e(a.ServiceIdentifiers.IStringArrayIndexNode).to(C.StringArrayHexadecimalNumericStringIndexNode).inSingletonScope().whenTargetNamed(A.StringArrayIndexNode.StringArrayHexadecimalNumericStringIndexNode), e(a.ServiceIdentifiers.Factory__IControlFlowCustomNode).toFactory(n.InversifyContainerFacade.getConstructorFactory(a.ServiceIdentifiers.Newable__ICustomNode, a.ServiceIdentifiers.Factory__IIdentifierNamesGenerator, a.ServiceIdentifiers.ICustomCodeHelperFormatter, a.ServiceIdentifiers.IRandomGenerator, a.ServiceIdentifiers.IOptions)), e(a.ServiceIdentifiers.Factory__IDeadCodeInjectionCustomNode).toFactory(n.InversifyContainerFacade.getConstructorFactory(a.ServiceIdentifiers.Newable__ICustomNode, a.ServiceIdentifiers.Factory__IIdentifierNamesGenerator, a.ServiceIdentifiers.ICustomCodeHelperFormatter, a.ServiceIdentifiers.IRandomGenerator, a.ServiceIdentifiers.IOptions)), e(a.ServiceIdentifiers.Factory__IObjectExpressionKeysTransformerCustomNode).toFactory(n.InversifyContainerFacade.getConstructorFactory(a.ServiceIdentifiers.Newable__ICustomNode, a.ServiceIdentifiers.Factory__IIdentifierNamesGenerator, a.ServiceIdentifiers.ICustomCodeHelperFormatter, a.ServiceIdentifiers.IRandomGenerator, a.ServiceIdentifiers.IOptions)), e(a.ServiceIdentifiers.Factory__IStringArrayCustomNode).toFactory(n.InversifyContainerFacade.getConstructorFactory(a.ServiceIdentifiers.Newable__ICustomNode, a.ServiceIdentifiers.Factory__IIdentifierNamesGenerator, a.ServiceIdentifiers.Factory__IStringArrayIndexNode, a.ServiceIdentifiers.ICustomCodeHelperFormatter, a.ServiceIdentifiers.IStringArrayStorage, a.ServiceIdentifiers.IArrayUtils, a.ServiceIdentifiers.IRandomGenerator, a.ServiceIdentifiers.IOptions)), e(a.ServiceIdentifiers.Factory__IStringArrayIndexNode).toFactory(n.InversifyContainerFacade.getCacheFactory(a.ServiceIdentifiers.IStringArrayIndexNode));
                });
            },
            1212: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.generatorsModule = void 0;
                const n = r(6594), i = r(2553), a = r(3552), o = r(1515), s = r(2162), c = r(9212), u = r(5102);
                t.generatorsModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.IIdentifierNamesGenerator).to(o.DictionaryIdentifierNamesGenerator).inSingletonScope().whenTargetNamed(a.IdentifierNamesGenerator.DictionaryIdentifierNamesGenerator), e(i.ServiceIdentifiers.IIdentifierNamesGenerator).to(s.HexadecimalIdentifierNamesGenerator).inSingletonScope().whenTargetNamed(a.IdentifierNamesGenerator.HexadecimalIdentifierNamesGenerator), e(i.ServiceIdentifiers.IIdentifierNamesGenerator).to(c.MangledIdentifierNamesGenerator).inSingletonScope().whenTargetNamed(a.IdentifierNamesGenerator.MangledIdentifierNamesGenerator), e(i.ServiceIdentifiers.IIdentifierNamesGenerator).to(u.MangledShuffledIdentifierNamesGenerator).inSingletonScope().whenTargetNamed(a.IdentifierNamesGenerator.MangledShuffledIdentifierNamesGenerator), e(i.ServiceIdentifiers.Factory__IIdentifierNamesGenerator).toFactory(function () {
                        let e = null;
                        return t => r => {
                            if (e)
                                return e;
                            let n;
                            switch (r.identifierNamesGenerator) {
                            case a.IdentifierNamesGenerator.DictionaryIdentifierNamesGenerator:
                                n = t.container.getNamed(i.ServiceIdentifiers.IIdentifierNamesGenerator, a.IdentifierNamesGenerator.DictionaryIdentifierNamesGenerator);
                                break;
                            case a.IdentifierNamesGenerator.MangledIdentifierNamesGenerator:
                                n = t.container.getNamed(i.ServiceIdentifiers.IIdentifierNamesGenerator, a.IdentifierNamesGenerator.MangledIdentifierNamesGenerator);
                                break;
                            case a.IdentifierNamesGenerator.MangledShuffledIdentifierNamesGenerator:
                                n = t.container.getNamed(i.ServiceIdentifiers.IIdentifierNamesGenerator, a.IdentifierNamesGenerator.MangledShuffledIdentifierNamesGenerator);
                                break;
                            case a.IdentifierNamesGenerator.HexadecimalIdentifierNamesGenerator:
                            default:
                                n = t.container.getNamed(i.ServiceIdentifiers.IIdentifierNamesGenerator, a.IdentifierNamesGenerator.HexadecimalIdentifierNamesGenerator);
                            }
                            return e = n, n;
                        };
                    }());
                });
            },
            6274: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.controlFlowTransformersModule = void 0;
                const n = r(9723), i = r(6594), a = r(2553), o = r(5739), s = r(6188), c = r(6800), u = r(9045), l = r(1766), d = r(8769), p = r(1788), f = r(4149), m = r(4825), h = r(2775);
                t.controlFlowTransformersModule = new i.ContainerModule(e => {
                    e(a.ServiceIdentifiers.INodeTransformer).to(u.BlockStatementControlFlowTransformer).whenTargetNamed(s.NodeTransformer.BlockStatementControlFlowTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(d.FunctionControlFlowTransformer).whenTargetNamed(s.NodeTransformer.FunctionControlFlowTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(m.StringArrayControlFlowTransformer).whenTargetNamed(s.NodeTransformer.StringArrayControlFlowTransformer), e(a.ServiceIdentifiers.IControlFlowReplacer).to(c.BinaryExpressionControlFlowReplacer).whenTargetNamed(o.ControlFlowReplacer.BinaryExpressionControlFlowReplacer), e(a.ServiceIdentifiers.IControlFlowReplacer).to(l.CallExpressionControlFlowReplacer).whenTargetNamed(o.ControlFlowReplacer.CallExpressionControlFlowReplacer), e(a.ServiceIdentifiers.IControlFlowReplacer).to(p.LogicalExpressionControlFlowReplacer).whenTargetNamed(o.ControlFlowReplacer.LogicalExpressionControlFlowReplacer), e(a.ServiceIdentifiers.IControlFlowReplacer).to(f.StringArrayCallControlFlowReplacer).whenTargetNamed(o.ControlFlowReplacer.StringArrayCallControlFlowReplacer), e(a.ServiceIdentifiers.IControlFlowReplacer).to(h.StringLiteralControlFlowReplacer).whenTargetNamed(o.ControlFlowReplacer.StringLiteralControlFlowReplacer), e(a.ServiceIdentifiers.Factory__IControlFlowReplacer).toFactory(n.InversifyContainerFacade.getCacheFactory(a.ServiceIdentifiers.IControlFlowReplacer));
                });
            },
            6624: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.convertingTransformersModule = void 0;
                const n = r(6594), i = r(9723), a = r(2553), o = r(6188), s = r(547), c = r(7412), u = r(4425), l = r(9947), d = r(1160), p = r(8317), f = r(8962), m = r(3827), h = r(3710), g = r(618), y = r(7506), b = r(3412), S = r(9662), v = r(8985);
                t.convertingTransformersModule = new n.ContainerModule(e => {
                    e(a.ServiceIdentifiers.INodeTransformer).to(u.BooleanLiteralTransformer).whenTargetNamed(o.NodeTransformer.BooleanLiteralTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(l.ExportSpecifierTransformer).whenTargetNamed(o.NodeTransformer.ExportSpecifierTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(d.MemberExpressionTransformer).whenTargetNamed(o.NodeTransformer.MemberExpressionTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(p.ClassFieldTransformer).whenTargetNamed(o.NodeTransformer.ClassFieldTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(f.NumberLiteralTransformer).whenTargetNamed(o.NodeTransformer.NumberLiteralTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(m.NumberToNumericalExpressionTransformer).whenTargetNamed(o.NodeTransformer.NumberToNumericalExpressionTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(h.ObjectExpressionKeysTransformer).whenTargetNamed(o.NodeTransformer.ObjectExpressionKeysTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(y.ObjectExpressionTransformer).whenTargetNamed(o.NodeTransformer.ObjectExpressionTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(b.ObjectPatternPropertiesTransformer).whenTargetNamed(o.NodeTransformer.ObjectPatternPropertiesTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(S.SplitStringTransformer).whenTargetNamed(o.NodeTransformer.SplitStringTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(v.TemplateLiteralTransformer).whenTargetNamed(o.NodeTransformer.TemplateLiteralTransformer), e(a.ServiceIdentifiers.IObjectExpressionExtractor).to(g.ObjectExpressionToVariableDeclarationExtractor).whenTargetNamed(s.ObjectExpressionExtractor.ObjectExpressionToVariableDeclarationExtractor), e(a.ServiceIdentifiers.IObjectExpressionExtractor).to(c.BasePropertiesExtractor).whenTargetNamed(s.ObjectExpressionExtractor.BasePropertiesExtractor), e(a.ServiceIdentifiers.Factory__IObjectExpressionExtractor).toFactory(i.InversifyContainerFacade.getCacheFactory(a.ServiceIdentifiers.IObjectExpressionExtractor));
                });
            },
            8130: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.deadCodeInjectionTransformersModule = void 0;
                const n = r(6594), i = r(2553), a = r(6188), o = r(1718);
                t.deadCodeInjectionTransformersModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.INodeTransformer).to(o.DeadCodeInjectionTransformer).whenTargetNamed(a.NodeTransformer.DeadCodeInjectionTransformer);
                });
            },
            1092: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.finalizingTransformersModule = void 0;
                const n = r(6594), i = r(2553), a = r(6188), o = r(3425), s = r(4187);
                t.finalizingTransformersModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.INodeTransformer).to(o.DirectivePlacementTransformer).whenTargetNamed(a.NodeTransformer.DirectivePlacementTransformer), e(i.ServiceIdentifiers.INodeTransformer).to(s.EscapeSequenceTransformer).whenTargetNamed(a.NodeTransformer.EscapeSequenceTransformer);
                });
            },
            3713: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.initializingTransformersModule = void 0;
                const n = r(6594), i = r(2553), a = r(6188), o = r(3836);
                t.initializingTransformersModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.INodeTransformer).to(o.CommentsTransformer).whenTargetNamed(a.NodeTransformer.CommentsTransformer);
                });
            },
            8638: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.nodeTransformersModule = void 0;
                const n = r(9723), i = r(6594), a = r(2553), o = r(8521);
                t.nodeTransformersModule = new i.ContainerModule(e => {
                    e(a.ServiceIdentifiers.Factory__INodeTransformer).toFactory(n.InversifyContainerFacade.getCacheFactory(a.ServiceIdentifiers.INodeTransformer)), e(a.ServiceIdentifiers.INodeTransformerNamesGroupsBuilder).to(o.NodeTransformerNamesGroupsBuilder).inSingletonScope();
                });
            },
            6458: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.preparingTransformersModule = void 0;
                const n = r(9723), i = r(6594), a = r(2553), o = r(6188), s = r(4930), c = r(4150), u = r(2240), l = r(9763), d = r(4188), p = r(1595), f = r(4892), m = r(2722), h = r(1478), g = r(6815), y = r(7189), b = r(515);
                t.preparingTransformersModule = new i.ContainerModule(e => {
                    e(a.ServiceIdentifiers.INodeTransformer).to(l.CustomCodeHelpersTransformer).whenTargetNamed(o.NodeTransformer.CustomCodeHelpersTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(d.EvalCallExpressionTransformer).whenTargetNamed(o.NodeTransformer.EvalCallExpressionTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(m.MetadataTransformer).whenTargetNamed(o.NodeTransformer.MetadataTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(h.ObfuscatingGuardsTransformer).whenTargetNamed(o.NodeTransformer.ObfuscatingGuardsTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(g.ParentificationTransformer).whenTargetNamed(o.NodeTransformer.ParentificationTransformer), e(a.ServiceIdentifiers.INodeTransformer).to(b.VariablePreserveTransformer).whenTargetNamed(o.NodeTransformer.VariablePreserveTransformer), e(a.ServiceIdentifiers.INodeGuard).to(c.BlackListObfuscatingGuard).inSingletonScope().whenTargetNamed(s.ObfuscatingGuard.BlackListObfuscatingGuard), e(a.ServiceIdentifiers.INodeGuard).to(u.ConditionalCommentObfuscatingGuard).inSingletonScope().whenTargetNamed(s.ObfuscatingGuard.ConditionalCommentObfuscatingGuard), e(a.ServiceIdentifiers.INodeGuard).to(p.ForceTransformStringObfuscatingGuard).inSingletonScope().whenTargetNamed(s.ObfuscatingGuard.ForceTransformStringObfuscatingGuard), e(a.ServiceIdentifiers.INodeGuard).to(f.IgnoredImportObfuscatingGuard).inSingletonScope().whenTargetNamed(s.ObfuscatingGuard.IgnoredImportObfuscatingGuard), e(a.ServiceIdentifiers.INodeGuard).to(y.ReservedStringObfuscatingGuard).inSingletonScope().whenTargetNamed(s.ObfuscatingGuard.ReservedStringObfuscatingGuard), e(a.ServiceIdentifiers.Factory__INodeGuard).toFactory(n.InversifyContainerFacade.getCacheFactory(a.ServiceIdentifiers.INodeGuard));
                });
            },
            4561: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.renameIdentifiersTransformersModule = void 0;
                const n = r(6594), i = r(2553), a = r(6188), o = r(100), s = r(57), c = r(6652), u = r(1048), l = r(502), d = r(2204);
                t.renameIdentifiersTransformersModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.INodeTransformer).to(o.DeadCodeInjectionIdentifiersTransformer).whenTargetNamed(a.NodeTransformer.DeadCodeInjectionIdentifiersTransformer), e(i.ServiceIdentifiers.INodeTransformer).to(c.LabeledStatementTransformer).whenTargetNamed(a.NodeTransformer.LabeledStatementTransformer), e(i.ServiceIdentifiers.INodeTransformer).to(u.ScopeIdentifiersTransformer).whenTargetNamed(a.NodeTransformer.ScopeIdentifiersTransformer), e(i.ServiceIdentifiers.INodeTransformer).to(l.ScopeThroughIdentifiersTransformer).whenTargetNamed(a.NodeTransformer.ScopeThroughIdentifiersTransformer), e(i.ServiceIdentifiers.IIdentifierReplacer).to(s.IdentifierReplacer).inSingletonScope(), e(i.ServiceIdentifiers.IThroughIdentifierReplacer).to(d.ThroughIdentifierReplacer).inSingletonScope();
                });
            },
            8682: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.renamePropertiesTransformersModule = void 0;
                const n = r(6594), i = r(2553), a = r(6188), o = r(9320), s = r(7015);
                t.renamePropertiesTransformersModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.INodeTransformer).to(s.RenamePropertiesTransformer).whenTargetNamed(a.NodeTransformer.RenamePropertiesTransformer), e(i.ServiceIdentifiers.IRenamePropertiesReplacer).to(o.RenamePropertiesReplacer);
                });
            },
            4008: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.simplifyingTransformersModule = void 0;
                const n = r(6594), i = r(2553), a = r(6188), o = r(7596), s = r(7615), c = r(942), u = r(5805);
                t.simplifyingTransformersModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.INodeTransformer).to(o.BlockStatementSimplifyTransformer).whenTargetNamed(a.NodeTransformer.BlockStatementSimplifyTransformer), e(i.ServiceIdentifiers.INodeTransformer).to(s.ExpressionStatementsMergeTransformer).whenTargetNamed(a.NodeTransformer.ExpressionStatementsMergeTransformer), e(i.ServiceIdentifiers.INodeTransformer).to(c.IfStatementSimplifyTransformer).whenTargetNamed(a.NodeTransformer.IfStatementSimplifyTransformer), e(i.ServiceIdentifiers.INodeTransformer).to(u.VariableDeclarationsMergeTransformer).whenTargetNamed(a.NodeTransformer.VariableDeclarationsMergeTransformer);
                });
            },
            4697: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.stringArrayTransformersModule = void 0;
                const n = r(6594), i = r(2553), a = r(6188), o = r(1903), s = r(9720), c = r(8033);
                t.stringArrayTransformersModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.INodeTransformer).to(o.StringArrayRotateFunctionTransformer).whenTargetNamed(a.NodeTransformer.StringArrayRotateFunctionTransformer), e(i.ServiceIdentifiers.INodeTransformer).to(s.StringArrayScopeCallsWrapperTransformer).whenTargetNamed(a.NodeTransformer.StringArrayScopeCallsWrapperTransformer), e(i.ServiceIdentifiers.INodeTransformer).to(c.StringArrayTransformer).whenTargetNamed(a.NodeTransformer.StringArrayTransformer);
                });
            },
            5293: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.nodeModule = void 0;
                const n = r(6594), i = r(2553), a = r(6186);
                t.nodeModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.IScopeIdentifiersTraverser).to(a.ScopeIdentifiersTraverser).inSingletonScope();
                });
            },
            2755: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.optionsModule = void 0;
                const n = r(6594), i = r(2553), a = r(4081), o = r(6181);
                t.optionsModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.IOptions).to(a.Options).inSingletonScope(), e(i.ServiceIdentifiers.IOptionsNormalizer).to(o.OptionsNormalizer).inSingletonScope();
                });
            },
            4948: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.storagesModule = void 0;
                const n = r(6594), i = r(2553), a = r(7657), o = r(7359), s = r(4576), c = r(9469), u = r(5159), l = r(4642), d = r(5275), p = r(5455), f = r(5046), m = r(3621);
                t.storagesModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.TCustomNodeGroupStorage).to(o.CustomCodeHelperGroupStorage).inSingletonScope(), e(i.ServiceIdentifiers.IControlFlowStorage).to(s.FunctionControlFlowStorage).whenTargetNamed(a.ControlFlowStorage.FunctionControlFlowStorage), e(i.ServiceIdentifiers.IGlobalIdentifierNamesCacheStorage).to(c.GlobalIdentifierNamesCacheStorage).inSingletonScope(), e(i.ServiceIdentifiers.ILiteralNodesCacheStorage).to(u.LiteralNodesCacheStorage).inSingletonScope(), e(i.ServiceIdentifiers.IPropertyIdentifierNamesCacheStorage).to(l.PropertyIdentifierNamesCacheStorage).inSingletonScope(), e(i.ServiceIdentifiers.IStringArrayStorage).to(f.StringArrayStorage).inSingletonScope(), e(i.ServiceIdentifiers.IStringArrayScopeCallsWrappersDataStorage).to(d.StringArrayScopeCallsWrappersDataStorage).inSingletonScope(), e(i.ServiceIdentifiers.IControlFlowStorage).to(p.StringControlFlowStorage).whenTargetNamed(a.ControlFlowStorage.StringControlFlowStorage), e(i.ServiceIdentifiers.IVisitedLexicalScopeNodesStackStorage).to(m.VisitedLexicalScopeNodesStackStorage).inSingletonScope(), e(i.ServiceIdentifiers.Factory__TControlFlowStorage).toFactory(e => t => () => e.container.getNamed(i.ServiceIdentifiers.IControlFlowStorage, t));
                });
            },
            5332: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.utilsModule = void 0;
                const n = r(6594), i = r(2553), a = r(6959), o = r(5678), s = r(7301), c = r(3062), u = r(5579), l = r(4291), d = r(1586);
                t.utilsModule = new n.ContainerModule(e => {
                    e(i.ServiceIdentifiers.IArrayUtils).to(a.ArrayUtils).inSingletonScope(), e(i.ServiceIdentifiers.IRandomGenerator).to(l.RandomGenerator).inSingletonScope(), e(i.ServiceIdentifiers.ICryptUtils).to(o.CryptUtils).inSingletonScope(), e(i.ServiceIdentifiers.ICryptUtilsStringArray).to(s.CryptUtilsStringArray).inSingletonScope(), e(i.ServiceIdentifiers.IEscapeSequenceEncoder).to(c.EscapeSequenceEncoder).inSingletonScope(), e(i.ServiceIdentifiers.ILevelledTopologicalSorter).to(u.LevelledTopologicalSorter), e(i.ServiceIdentifiers.ISetUtils).to(d.SetUtils).inSingletonScope();
                });
            },
            9235: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractCustomCodeHelper = void 0;
                const s = r(6594), c = r(2553), u = r(9315), l = r(5369), d = r(7081), p = r(2644), f = r(9286);
                let m = n = class {
                    constructor(e, t, r, n, i) {
                        this.cachedNode = null, this.identifierNamesGenerator = e(i), this.customCodeHelperFormatter = t, this.customCodeHelperObfuscator = r, this.randomGenerator = n, this.options = i;
                    }
                    getNode() {
                        if (!this.cachedNode) {
                            const e = this.getCodeHelperTemplate();
                            this.cachedNode = this.customCodeHelperFormatter.formatStructure(this.getNodeStructure(e));
                        }
                        return this.cachedNode;
                    }
                    getGlobalVariableTemplate() {
                        switch (this.options.target) {
                        case d.ObfuscationTarget.BrowserNoEval:
                            return (0, p.GlobalVariableNoEvalTemplate)();
                        case d.ObfuscationTarget.ServiceWorker:
                            return (0, f.GlobalVariableServiceWorkerTemplate)();
                        default:
                            return this.randomGenerator.getRandomGenerator().pickone(n.globalVariableTemplateFunctions);
                        }
                    }
                    getCodeHelperTemplate() {
                        return '';
                    }
                };
                m.globalVariableTemplateFunctions = [
                    (0, u.GlobalVariableTemplate1)(),
                    (0, l.GlobalVariableTemplate2)()
                ], m = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(4, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], m), t.AbstractCustomCodeHelper = m;
            },
            6245: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractCustomCodeHelperGroup = void 0;
                const o = r(6594), s = r(2553);
                let c = class {
                    constructor(e, t, r) {
                        this.identifierNamesGenerator = e(r), this.randomGenerator = t, this.options = r;
                    }
                    getCustomCodeHelpers() {
                        return this.customCodeHelpers;
                    }
                    appendCustomNodeIfExist(e, t) {
                        const r = this.customCodeHelpers.get(e);
                        r && t(r);
                    }
                    getRandomCallsGraphIndex(e) {
                        return this.randomGenerator.getRandomInteger(0, Math.max(0, Math.round(e - 1)));
                    }
                };
                c = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object
                    ])
                ], c), t.AbstractCustomCodeHelperGroup = c;
            },
            7276: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, o = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    }, s = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, c = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    }, u = this && this.__importDefault || function (e) {
                        return e && e.__esModule ? e : { default: e };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CustomCodeHelperFormatter = void 0;
                const l = r(6594), d = r(2553), p = o(r(140)), f = u(r(6573)), m = r(8983);
                let h = class {
                    constructor(e) {
                        this.prevailingKindOfVariables = e.getPrevailingKind();
                    }
                    formatTemplate(e, t) {
                        return (0, f.default)(e, t);
                    }
                    formatStructure(e) {
                        for (const t of e)
                            p.replace(t, {
                                enter: e => {
                                    if (m.NodeGuards.isVariableDeclarationNode(e))
                                        return 'var' === this.prevailingKindOfVariables && (e.kind = 'var'), e;
                                }
                            });
                        return e;
                    }
                };
                h = a([
                    (0, l.injectable)(),
                    c(0, (0, l.inject)(d.ServiceIdentifiers.IPrevailingKindOfVariablesAnalyzer)),
                    s('design:paramtypes', [Object])
                ], h), t.CustomCodeHelperFormatter = h;
            },
            7855: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CustomCodeHelperObfuscator = void 0;
                const o = r(6594), s = r(2553), c = r(9237), u = r(5248);
                let l = class {
                    constructor(e, t) {
                        this.randomGenerator = e, this.options = t;
                    }
                    obfuscateTemplate(e, t = {}) {
                        return u.JavaScriptObfuscator.obfuscate(e, {
                            ...c.NO_ADDITIONAL_NODES_PRESET,
                            identifierNamesGenerator: this.options.identifierNamesGenerator,
                            identifiersDictionary: this.options.identifiersDictionary,
                            numbersToExpressions: this.options.numbersToExpressions,
                            simplify: this.options.simplify,
                            seed: this.randomGenerator.getRawSeed(),
                            ...t
                        }).getObfuscatedCode();
                    }
                };
                l = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], l), t.CustomCodeHelperObfuscator = l;
            },
            7911: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CallsControllerFunctionCodeHelper = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(626), l = r(1225), d = r(9235), p = r(2815);
                let f = class extends d.AbstractCustomCodeHelper {
                    constructor(e, t, r, n, i) {
                        super(e, t, r, n, i);
                    }
                    initialize(e, t) {
                        this.nodeTransformationStage = e, this.callsControllerFunctionName = t;
                    }
                    getNodeStructure(e) {
                        return p.NodeUtils.convertCodeToStructure(e);
                    }
                    getCodeHelperTemplate() {
                        return this.nodeTransformationStage === c.NodeTransformationStage.Finalizing ? this.customCodeHelperObfuscator.obfuscateTemplate(this.customCodeHelperFormatter.formatTemplate((0, l.SingleCallControllerTemplate)(), { callControllerFunctionName: this.callsControllerFunctionName })) : this.customCodeHelperFormatter.formatTemplate((0, l.SingleCallControllerTemplate)(), { callControllerFunctionName: this.callsControllerFunctionName });
                    }
                };
                n([
                    (0, u.initializable)(),
                    i('design:type', String)
                ], f.prototype, 'callsControllerFunctionName', void 0), n([
                    (0, u.initializable)(),
                    i('design:type', String)
                ], f.prototype, 'nodeTransformationStage', void 0), f = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], f), t.CallsControllerFunctionCodeHelper = f;
            },
            2644: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.GlobalVariableNoEvalTemplate = void 0, t.GlobalVariableNoEvalTemplate = function () {
                    return '\n        const that = (typeof window !== \'undefined\'\n           ? window\n           : (typeof process === \'object\' &&\n              typeof require === \'function\' &&\n              typeof global === \'object\')\n             ? global\n             : this);\n    ';
                };
            },
            9286: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.GlobalVariableServiceWorkerTemplate = void 0, t.GlobalVariableServiceWorkerTemplate = function () {
                    return 'const that = typeof global === \'object\' ? global : this;';
                };
            },
            9315: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.GlobalVariableTemplate1 = void 0, t.GlobalVariableTemplate1 = function () {
                    return '\n        let that;\n        \n        try {\n            const getGlobal = Function(\'return (function() \' + \'{}.constructor("return this")( )\' + \');\');\n            \n            that = getGlobal();\n        } catch (e) {\n            that = window;\n        }\n    ';
                };
            },
            5369: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.GlobalVariableTemplate2 = void 0, t.GlobalVariableTemplate2 = function () {
                    return '\n        const getGlobal = function () {\n            let globalObject;\n        \n            try {\n                globalObject = Function(\'return (function() \' + \'{}.constructor("return this")( )\' + \');\')();\n            } catch (e) {\n                globalObject = window;\n            }\n            \n            return globalObject;\n        };\n        const that = getGlobal();\n    ';
                };
            },
            1225: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SingleCallControllerTemplate = void 0, t.SingleCallControllerTemplate = function () {
                    return '\n        const {callControllerFunctionName} = (function(){\n            let firstCall = true;\n            \n            return function (context, fn){\n                const rfn = firstCall ? function(){\n                    if(fn){\n                        const res = fn.apply(context, arguments);\n                        fn = null;\n                        return res;\n                    }\n                } : function(){}\n                \n                firstCall = false;\n                \n                return rfn;\n            }\n        })();\n    ';
                };
            },
            6580: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ConsoleOutputDisableCodeHelper = void 0;
                const o = r(6594), s = r(2553), c = r(9106), u = r(626), l = r(9235), d = r(2815);
                let p = class extends l.AbstractCustomCodeHelper {
                    constructor(e, t, r, n, i) {
                        super(e, t, r, n, i);
                    }
                    initialize(e, t) {
                        this.callsControllerFunctionName = e, this.consoleOutputDisableFunctionName = t;
                    }
                    getNodeStructure(e) {
                        return d.NodeUtils.convertCodeToStructure(e);
                    }
                    getCodeHelperTemplate() {
                        return this.customCodeHelperFormatter.formatTemplate((0, c.ConsoleOutputDisableTemplate)(), {
                            callControllerFunctionName: this.callsControllerFunctionName,
                            consoleLogDisableFunctionName: this.consoleOutputDisableFunctionName,
                            globalVariableTemplate: this.getGlobalVariableTemplate()
                        });
                    }
                };
                n([
                    (0, u.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'callsControllerFunctionName', void 0), n([
                    (0, u.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'consoleOutputDisableFunctionName', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.ConsoleOutputDisableCodeHelper = p;
            },
            2657: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ConsoleOutputCodeHelperGroup = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(8547), l = r(780), d = r(6245), p = r(8434), f = r(8520);
                let m = class extends d.AbstractCustomCodeHelperGroup {
                    constructor(e, t, r, n) {
                        super(t, r, n), this.customCodeHelperFactory = e;
                    }
                    appendOnPreparingStage(e, t) {
                        var r;
                        if (!this.options.disableConsoleOutput)
                            return;
                        const n = this.getRandomCallsGraphIndex(t.length), i = t.length ? p.NodeAppender.getOptimalBlockScope(t, n) : e, a = t.length ? p.NodeAppender.getOptimalBlockScope(t, n, 1) : e, o = null !== (r = f.NodeLexicalScopeUtils.getLexicalScope(i)) && void 0 !== r ? r : null, s = o ? this.identifierNamesGenerator.generate(o) : this.identifierNamesGenerator.generateNext(), c = o ? this.identifierNamesGenerator.generate(o) : this.identifierNamesGenerator.generateNext();
                        this.appendCustomNodeIfExist(u.CustomCodeHelper.ConsoleOutputDisable, e => {
                            e.initialize(c, s), p.NodeAppender.prepend(i, e.getNode());
                        }), this.appendCustomNodeIfExist(u.CustomCodeHelper.CallsControllerFunction, e => {
                            e.initialize(l.NodeTransformationStage.Preparing, c), p.NodeAppender.prepend(a, e.getNode());
                        });
                    }
                    initialize() {
                        if (this.customCodeHelpers = new Map(), !this.options.disableConsoleOutput)
                            return;
                        const e = this.customCodeHelperFactory(u.CustomCodeHelper.ConsoleOutputDisable), t = this.customCodeHelperFactory(u.CustomCodeHelper.CallsControllerFunction);
                        this.customCodeHelpers.set(u.CustomCodeHelper.ConsoleOutputDisable, e), this.customCodeHelpers.set(u.CustomCodeHelper.CallsControllerFunction, t);
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Map)
                ], m.prototype, 'customCodeHelpers', void 0), m = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__ICustomCodeHelper)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], m), t.ConsoleOutputCodeHelperGroup = m;
            },
            9106: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ConsoleOutputDisableTemplate = void 0, t.ConsoleOutputDisableTemplate = function () {
                    return '\n        const {consoleLogDisableFunctionName} = {callControllerFunctionName}(this, function () {\n            {globalVariableTemplate}\n\n            const consoleObject = (that.console = that.console || {});\n            const methods = [\'log\', \'warn\', \'info\', \'error\', \'exception\', \'table\', \'trace\'];\n\n            for (let index = 0; index < methods.length; index++){\n                const func = {callControllerFunctionName}.constructor.prototype.bind({callControllerFunctionName});\n                const methodName = methods[index];\n                const originalFunction = consoleObject[methodName] || func;\n\n                func.__proto__ = {callControllerFunctionName}.bind({callControllerFunctionName});\n                func.toString = originalFunction.toString.bind(originalFunction);\n                \n                consoleObject[methodName] = func;\n            }\n        });\n\n        {consoleLogDisableFunctionName}();\n    ';
                };
            },
            9: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DebugProtectionFunctionCallCodeHelper = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(2880), l = r(9235), d = r(2815);
                let p = class extends l.AbstractCustomCodeHelper {
                    constructor(e, t, r, n, i) {
                        super(e, t, r, n, i);
                    }
                    initialize(e, t) {
                        this.debugProtectionFunctionName = e, this.callsControllerFunctionName = t;
                    }
                    getNodeStructure(e) {
                        return d.NodeUtils.convertCodeToStructure(e);
                    }
                    getCodeHelperTemplate() {
                        return this.customCodeHelperFormatter.formatTemplate((0, u.DebugProtectionFunctionCallTemplate)(), {
                            debugProtectionFunctionName: this.debugProtectionFunctionName,
                            callControllerFunctionName: this.callsControllerFunctionName
                        });
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'callsControllerFunctionName', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'debugProtectionFunctionName', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.DebugProtectionFunctionCallCodeHelper = p;
            },
            4513: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DebugProtectionFunctionCodeHelper = void 0;
                const o = r(6594), s = r(2553), c = r(7081), u = r(626), l = r(8402), d = r(9828), p = r(9245), f = r(9235), m = r(2815);
                let h = class extends f.AbstractCustomCodeHelper {
                    constructor(e, t, r, n, i) {
                        super(e, t, r, n, i);
                    }
                    initialize(e) {
                        this.debugProtectionFunctionName = e;
                    }
                    getNodeStructure(e) {
                        return m.NodeUtils.convertCodeToStructure(e);
                    }
                    getCodeHelperTemplate() {
                        const e = this.options.target !== c.ObfuscationTarget.BrowserNoEval ? (0, l.DebuggerTemplate)() : (0, d.DebuggerTemplateNoEval)();
                        return this.customCodeHelperFormatter.formatTemplate((0, p.DebugProtectionFunctionTemplate)(), {
                            debuggerTemplate: e,
                            debugProtectionFunctionName: this.debugProtectionFunctionName
                        });
                    }
                };
                n([
                    (0, u.initializable)(),
                    i('design:type', String)
                ], h.prototype, 'debugProtectionFunctionName', void 0), h = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], h), t.DebugProtectionFunctionCodeHelper = h;
            },
            9648: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DebugProtectionFunctionIntervalCodeHelper = void 0;
                const o = r(6594), s = r(2553), c = r(7081), u = r(626), l = r(7935), d = r(2644), p = r(9235), f = r(2815);
                let m = class extends p.AbstractCustomCodeHelper {
                    constructor(e, t, r, n, i) {
                        super(e, t, r, n, i);
                    }
                    initialize(e, t) {
                        this.debugProtectionFunctionName = e, this.debugProtectionInterval = t;
                    }
                    getNodeStructure(e) {
                        return f.NodeUtils.convertCodeToStructure(e);
                    }
                    getCodeHelperTemplate() {
                        const e = this.options.target !== c.ObfuscationTarget.BrowserNoEval ? this.getGlobalVariableTemplate() : (0, d.GlobalVariableNoEvalTemplate)();
                        return this.customCodeHelperFormatter.formatTemplate((0, l.DebugProtectionFunctionIntervalTemplate)(), {
                            debugProtectionFunctionName: this.debugProtectionFunctionName,
                            debugProtectionInterval: this.debugProtectionInterval,
                            globalVariableTemplate: e
                        });
                    }
                };
                n([
                    (0, u.initializable)(),
                    i('design:type', String)
                ], m.prototype, 'debugProtectionFunctionName', void 0), n([
                    (0, u.initializable)(),
                    i('design:type', Number)
                ], m.prototype, 'debugProtectionInterval', void 0), m = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], m), t.DebugProtectionFunctionIntervalCodeHelper = m;
            },
            3257: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DebugProtectionCodeHelperGroup = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(8547), l = r(780), d = r(6245), p = r(8434), f = r(8983), m = r(8520);
                let h = class extends d.AbstractCustomCodeHelperGroup {
                    constructor(e, t, r, n) {
                        super(t, r, n), this.customCodeHelperFactory = e;
                    }
                    appendOnPreparingStage(e, t) {
                        var r;
                        if (!this.options.debugProtection)
                            return;
                        const n = this.getRandomCallsGraphIndex(t.length), i = t.length ? p.NodeAppender.getOptimalBlockScope(t, n) : e, a = t.length ? p.NodeAppender.getOptimalBlockScope(t, n, 1) : e, o = null !== (r = m.NodeLexicalScopeUtils.getLexicalScope(i)) && void 0 !== r ? r : null, s = o ? this.identifierNamesGenerator.generate(o) : this.identifierNamesGenerator.generateNext(), c = o ? this.identifierNamesGenerator.generate(o) : this.identifierNamesGenerator.generateNext();
                        this.appendCustomNodeIfExist(u.CustomCodeHelper.DebugProtectionFunctionCall, e => {
                            e.initialize(s, c), p.NodeAppender.prepend(i, e.getNode());
                        }), this.appendCustomNodeIfExist(u.CustomCodeHelper.CallsControllerFunction, e => {
                            e.initialize(l.NodeTransformationStage.Preparing, c), p.NodeAppender.prepend(a, e.getNode());
                        }), this.appendCustomNodeIfExist(u.CustomCodeHelper.DebugProtectionFunction, t => {
                            t.initialize(s), p.NodeAppender.append(e, t.getNode());
                        }), this.appendCustomNodeIfExist(u.CustomCodeHelper.DebugProtectionFunctionInterval, t => {
                            const r = f.NodeGuards.isSwitchCaseNode(e) ? e.consequent.length : e.body.length, n = this.randomGenerator.getRandomInteger(0, r);
                            t.initialize(s, this.options.debugProtectionInterval), p.NodeAppender.insertAtIndex(e, t.getNode(), n);
                        });
                    }
                    initialize() {
                        if (this.customCodeHelpers = new Map(), !this.options.debugProtection)
                            return;
                        const e = this.customCodeHelperFactory(u.CustomCodeHelper.DebugProtectionFunction), t = this.customCodeHelperFactory(u.CustomCodeHelper.DebugProtectionFunctionCall), r = this.customCodeHelperFactory(u.CustomCodeHelper.DebugProtectionFunctionInterval), n = this.customCodeHelperFactory(u.CustomCodeHelper.CallsControllerFunction);
                        this.customCodeHelpers.set(u.CustomCodeHelper.DebugProtectionFunction, e), this.customCodeHelpers.set(u.CustomCodeHelper.DebugProtectionFunctionCall, t), this.options.debugProtectionInterval && this.customCodeHelpers.set(u.CustomCodeHelper.DebugProtectionFunctionInterval, r), this.customCodeHelpers.set(u.CustomCodeHelper.CallsControllerFunction, n);
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Map)
                ], h.prototype, 'customCodeHelpers', void 0), h = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__ICustomCodeHelper)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], h), t.DebugProtectionCodeHelperGroup = h;
            },
            2880: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DebugProtectionFunctionCallTemplate = void 0, t.DebugProtectionFunctionCallTemplate = function () {
                    return '\n        (function () {\n            {callControllerFunctionName}(\n                this,\n                function () {\n                    const regExp1 = new RegExp(\'function *\\\\( *\\\\)\');\n                    const regExp2 = new RegExp(\'\\\\+\\\\+ *\\(?:[a-zA-Z_$][0-9a-zA-Z_$]*\\)\', \'i\');\n           \n                    const result = {debugProtectionFunctionName}(\'init\');\n                    \n                    if (!regExp1.test(result + \'chain\') || !regExp2.test(result + \'input\')) {\n                        result(\'0\');\n                    } else {\n                        {debugProtectionFunctionName}();\n                    }\n                }\n            )();\n        })();\n    ';
                };
            },
            7935: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DebugProtectionFunctionIntervalTemplate = void 0, t.DebugProtectionFunctionIntervalTemplate = function () {
                    return '\n        (function () {\n            {globalVariableTemplate}\n    \n            that.setInterval({debugProtectionFunctionName}, {debugProtectionInterval});\n        })();\n    ';
                };
            },
            9245: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DebugProtectionFunctionTemplate = void 0, t.DebugProtectionFunctionTemplate = function () {
                    return '\n        function {debugProtectionFunctionName} (ret) {\n            function debuggerProtection (counter) {\n                {debuggerTemplate}\n                \n                debuggerProtection(++counter);\n            }\n            \n            try {\n                if (ret) {\n                    return debuggerProtection;\n                } else {\n                    debuggerProtection(0);\n                }\n            } catch (y) {}\n        }\n    ';
                };
            },
            8402: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DebuggerTemplate = void 0, t.DebuggerTemplate = function () {
                    return '\n        if (typeof counter === \'string\') {\n            return (function (arg) {}.constructor(\'while (true) {}\').apply(\'counter\'));\n        } else {\n            if ((\'\' + counter / counter)[\'length\'] !== 1 || counter % 20 === 0) {\n                (function () {return true;}.constructor(\'debu\' + \'gger\').call(\'action\'));\n            } else {\n                (function () {return false;}.constructor(\'debu\' + \'gger\').apply(\'stateObject\'));\n            }\n            \n        }\n    ';
                };
            },
            9828: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DebuggerTemplateNoEval = void 0, t.DebuggerTemplateNoEval = function () {
                    return '\n        if (typeof counter === \'string\') {\n            const func = function () {\n                while (true) {}\n            };\n            \n            return func();\n        } else {\n            if ((\'\' + counter / counter)[\'length\'] !== 1 || counter % 20 === 0) {\n                debugger;\n            } else {\n                debugger;\n            }\n            \n        }\n    ';
                };
            },
            9029: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DomainLockCodeHelper = void 0;
                const o = r(6594), s = r(2553), c = r(7081), u = r(626), l = r(1017), d = r(2644), p = r(9235), f = r(2815);
                let m = class extends p.AbstractCustomCodeHelper {
                    constructor(e, t, r, n, i, a) {
                        super(e, t, r, n, i), this.cryptUtils = a;
                    }
                    initialize(e, t) {
                        this.callsControllerFunctionName = e, this.domainLockFunctionName = t;
                    }
                    getNodeStructure(e) {
                        return f.NodeUtils.convertCodeToStructure(e);
                    }
                    getCodeHelperTemplate() {
                        const e = this.options.domainLock.join(';'), t = this.options.domainLockRedirectUrl, [r, n] = this.cryptUtils.hideString(e, 3 * e.length), [i, a] = this.cryptUtils.hideString(t, 3 * t.length), o = this.options.target !== c.ObfuscationTarget.BrowserNoEval ? this.getGlobalVariableTemplate() : (0, d.GlobalVariableNoEvalTemplate)();
                        return this.customCodeHelperFormatter.formatTemplate((0, l.DomainLockTemplate)(), {
                            callControllerFunctionName: this.callsControllerFunctionName,
                            domainLockFunctionName: this.domainLockFunctionName,
                            domainsStringDiff: n,
                            domains: r,
                            domainLockRedirectUrlDiff: a,
                            hiddenDomainLockRedirectUrl: i,
                            globalVariableTemplate: o
                        });
                    }
                };
                n([
                    (0, u.initializable)(),
                    i('design:type', String)
                ], m.prototype, 'callsControllerFunctionName', void 0), n([
                    (0, u.initializable)(),
                    i('design:type', String)
                ], m.prototype, 'domainLockFunctionName', void 0), m = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    a(5, (0, o.inject)(s.ServiceIdentifiers.ICryptUtils)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], m), t.DomainLockCodeHelper = m;
            },
            6853: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DomainLockCustomCodeHelperGroup = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(8547), l = r(780), d = r(6245), p = r(8434), f = r(8520);
                let m = class extends d.AbstractCustomCodeHelperGroup {
                    constructor(e, t, r, n) {
                        super(t, r, n), this.customCodeHelperFactory = e;
                    }
                    appendOnPreparingStage(e, t) {
                        var r;
                        if (!this.options.domainLock.length)
                            return;
                        const n = this.getRandomCallsGraphIndex(t.length), i = t.length ? p.NodeAppender.getOptimalBlockScope(t, n) : e, a = t.length ? p.NodeAppender.getOptimalBlockScope(t, n, 1) : e, o = null !== (r = f.NodeLexicalScopeUtils.getLexicalScope(i)) && void 0 !== r ? r : null, s = o ? this.identifierNamesGenerator.generate(o) : this.identifierNamesGenerator.generateNext(), c = o ? this.identifierNamesGenerator.generate(o) : this.identifierNamesGenerator.generateNext();
                        this.appendCustomNodeIfExist(u.CustomCodeHelper.DomainLock, e => {
                            e.initialize(c, s), p.NodeAppender.prepend(i, e.getNode());
                        }), this.appendCustomNodeIfExist(u.CustomCodeHelper.CallsControllerFunction, e => {
                            e.initialize(l.NodeTransformationStage.Preparing, c), p.NodeAppender.prepend(a, e.getNode());
                        });
                    }
                    initialize() {
                        if (this.customCodeHelpers = new Map(), !this.options.domainLock.length)
                            return;
                        const e = this.customCodeHelperFactory(u.CustomCodeHelper.DomainLock), t = this.customCodeHelperFactory(u.CustomCodeHelper.CallsControllerFunction);
                        this.customCodeHelpers.set(u.CustomCodeHelper.DomainLock, e), this.customCodeHelpers.set(u.CustomCodeHelper.CallsControllerFunction, t);
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Map)
                ], m.prototype, 'customCodeHelpers', void 0), m = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__ICustomCodeHelper)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], m), t.DomainLockCustomCodeHelperGroup = m;
            },
            1017: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DomainLockTemplate = void 0, t.DomainLockTemplate = function () {
                    return '\n        const {domainLockFunctionName} = {callControllerFunctionName}(this, function () {\n            \n            {globalVariableTemplate}\n            \n            const regExp = new RegExp("[{domainsStringDiff}]", "g");\n            const domains = "{domains}".replace(regExp, "").split(";");\n            let document;\n            let domain;\n            let location;\n            let hostname;\n\n            const isName = function(name, length, cs) {\n                if (name.length != length) {\n                    return false;\n                }\n\n                for (let i = 0; i < length; i++) {\n                    for (let j = 0; j < cs.length; j += 2) {\n                        if (i == cs[j] && name.charCodeAt(i) != cs[j+1]) {\n                            return false;\n                        }\n                    }\n                }\n\n                return true;\n            };\n\n            const isNameVariant1 = function(cs, name, length) {\n              return isName(name, length, cs);\n            };\n\n            const isNameVariant2 = function(name, cs, length) {\n              return isNameVariant1(cs, name, length);\n            };\n\n            const isNameVariant3 = function(length, name, cs) {\n              return isNameVariant2(name, cs, length);\n            };\n\n            for (let d in that) {\n                if (isName(d, 8, [7, 116, 5, 101, 3, 117, 0, 100])) {\n                    document = d;\n                \n                    break;\n                }\n            }\n\n            for (let d1 in that[document]) {\n                if (isNameVariant3(6, d1, [5, 110, 0, 100])) {\n                    domain = d1;\n\n                    break;\n                }\n            }\n\n            for (let d2 in that[document]) {\n                if (isNameVariant2(d2, [7, 110, 0, 108], 8)) {\n                    location = d2;\n\n                    break;\n                }\n            }\n\n            if (!("~" > domain)) {\n                for (let d3 in that[document][location]) {\n                    if (isNameVariant1([7, 101, 0, 104], d3, 8)) {\n                        hostname = d3;\n                        \n                        break;\n                    }\n                }\n            }\n            \n            if (!document || !that[document]) {\n                return;\n            }\n            \n            const documentDomain = that[document][domain];\n            const documentLocationHostName = !!that[document][location] && that[document][location][hostname];\n            const currentDomain = documentDomain || documentLocationHostName;\n          \n            if (!currentDomain) {\n                return;\n            }\n          \n            let ok = false;\n                        \n            for (let i = 0; i < domains.length; i++) {\n                const domain = domains[i];\n                const domainNormalized = domain[0] === String.fromCharCode(46)\n                    ? domain.slice(1)\n                    : domain;\n                const position = currentDomain.length - domainNormalized.length;\n                const lastIndex = currentDomain.indexOf(domainNormalized, position);\n                const endsWith = lastIndex !== -1 && lastIndex === position;\n                \n                if (endsWith) {\n                    if (currentDomain.length == domain.length || domain.indexOf(".") === 0) {\n                        ok = true;\n                    }\n                }\n            }\n\n            if (!ok) {\n                const regExp2 = new RegExp("[{domainLockRedirectUrlDiff}]", "g");\n                const domainLockRedirectUrl = "{hiddenDomainLockRedirectUrl}".replace(regExp2, "");\n\n                that[document][location] = domainLockRedirectUrl;\n            }\n        });\n\n        {domainLockFunctionName}();\n    ';
                };
            },
            9074: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SelfDefendingCodeHelper = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(5185), l = r(9235), d = r(2815);
                let p = class extends l.AbstractCustomCodeHelper {
                    constructor(e, t, r, n, i) {
                        super(e, t, r, n, i);
                    }
                    initialize(e, t) {
                        this.callsControllerFunctionName = e, this.selfDefendingFunctionName = t;
                    }
                    getNodeStructure(e) {
                        return d.NodeUtils.convertCodeToStructure(e);
                    }
                    getCodeHelperTemplate() {
                        return this.customCodeHelperFormatter.formatTemplate((0, u.SelfDefendingTemplate)(), {
                            callControllerFunctionName: this.callsControllerFunctionName,
                            selfDefendingFunctionName: this.selfDefendingFunctionName
                        });
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'callsControllerFunctionName', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'selfDefendingFunctionName', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.SelfDefendingCodeHelper = p;
            },
            5273: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SelfDefendingCodeHelperGroup = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(8547), l = r(780), d = r(6245), p = r(8434), f = r(8520);
                let m = class extends d.AbstractCustomCodeHelperGroup {
                    constructor(e, t, r, n) {
                        super(t, r, n), this.customCodeHelperFactory = e;
                    }
                    appendOnPreparingStage(e, t) {
                        var r;
                        if (!this.options.selfDefending)
                            return;
                        const n = this.getRandomCallsGraphIndex(t.length), i = t.length ? p.NodeAppender.getOptimalBlockScope(t, n) : e, a = t.length ? p.NodeAppender.getOptimalBlockScope(t, n, 1) : e, o = null !== (r = f.NodeLexicalScopeUtils.getLexicalScope(i)) && void 0 !== r ? r : null, s = o ? this.identifierNamesGenerator.generate(o) : this.identifierNamesGenerator.generateNext(), c = o ? this.identifierNamesGenerator.generate(o) : this.identifierNamesGenerator.generateNext();
                        this.appendCustomNodeIfExist(u.CustomCodeHelper.SelfDefending, e => {
                            e.initialize(c, s), p.NodeAppender.prepend(i, e.getNode());
                        }), this.appendCustomNodeIfExist(u.CustomCodeHelper.CallsControllerFunction, e => {
                            e.initialize(l.NodeTransformationStage.Preparing, c), p.NodeAppender.prepend(a, e.getNode());
                        });
                    }
                    initialize() {
                        if (this.customCodeHelpers = new Map(), !this.options.selfDefending)
                            return;
                        const e = this.customCodeHelperFactory(u.CustomCodeHelper.SelfDefending), t = this.customCodeHelperFactory(u.CustomCodeHelper.CallsControllerFunction);
                        this.customCodeHelpers.set(u.CustomCodeHelper.SelfDefending, e), this.customCodeHelpers.set(u.CustomCodeHelper.CallsControllerFunction, t);
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Map)
                ], m.prototype, 'customCodeHelpers', void 0), m = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__ICustomCodeHelper)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], m), t.SelfDefendingCodeHelperGroup = m;
            },
            5185: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SelfDefendingTemplate = void 0, t.SelfDefendingTemplate = function () {
                    return '\n        const {selfDefendingFunctionName} = {callControllerFunctionName}(this, function () {\n            return {selfDefendingFunctionName}\n                .toString()\n                .search(\'(((.+)+)+)+$\')\n                .toString()\n                .constructor({selfDefendingFunctionName})\n                .search(\'(((.+)+)+)+$\');\n        });\n        \n        {selfDefendingFunctionName}();\n    ';
                };
            },
            5350: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                    var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                    if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                        o = Reflect.decorate(e, t, r, n);
                    else
                        for (var s = e.length - 1; s >= 0; s--)
                            (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                    return a > 3 && o && Object.defineProperty(t, r, o), o;
                };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayCallsWrapperBase64CodeHelper = void 0;
                const i = r(6594), a = r(2437), o = r(7486), s = r(2881);
                let c = class extends s.StringArrayCallsWrapperCodeHelper {
                    getDecodeStringArrayTemplate() {
                        const e = this.randomGenerator.getRandomString(6), t = this.customCodeHelperFormatter.formatTemplate((0, a.AtobTemplate)(this.options.selfDefending), { atobFunctionName: e }), r = this.getSelfDefendingTemplate();
                        return this.customCodeHelperFormatter.formatTemplate((0, o.StringArrayBase64DecodeTemplate)(this.randomGenerator), {
                            atobPolyfill: t,
                            atobFunctionName: e,
                            selfDefendingCode: r,
                            stringArrayCallsWrapperName: this.stringArrayCallsWrapperName,
                            stringArrayCacheName: this.stringArrayCacheName
                        });
                    }
                };
                c = n([(0, i.injectable)()], c), t.StringArrayCallsWrapperBase64CodeHelper = c;
            },
            2881: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayCallsWrapperCodeHelper = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(1108), l = r(7851), d = r(9235), p = r(2815);
                let f = class extends d.AbstractCustomCodeHelper {
                    constructor(e, t, r, n, i, a) {
                        super(e, t, r, n, i), this.escapeSequenceEncoder = a;
                    }
                    initialize(e, t, r) {
                        this.stringArrayFunctionName = e, this.stringArrayCallsWrapperName = t, this.indexShiftAmount = r, this.stringArrayCacheName = this.randomGenerator.getRandomString(6);
                    }
                    getNodeStructure(e) {
                        return p.NodeUtils.convertCodeToStructure(e);
                    }
                    getCodeHelperTemplate() {
                        const e = this.getDecodeStringArrayTemplate(), t = [`^${ this.stringArrayFunctionName }$`];
                        return this.customCodeHelperObfuscator.obfuscateTemplate(this.customCodeHelperFormatter.formatTemplate((0, l.StringArrayCallsWrapperTemplate)(), {
                            decodeCodeHelperTemplate: e,
                            stringArrayCallsWrapperName: this.stringArrayCallsWrapperName,
                            stringArrayCacheName: this.stringArrayCacheName,
                            stringArrayFunctionName: this.stringArrayFunctionName,
                            indexShiftAmount: this.indexShiftAmount
                        }), { reservedNames: t });
                    }
                    getDecodeStringArrayTemplate() {
                        return '';
                    }
                    getSelfDefendingTemplate() {
                        return this.options.selfDefending ? this.customCodeHelperFormatter.formatTemplate((0, u.SelfDefendingTemplate)(this.randomGenerator, this.escapeSequenceEncoder), { stringArrayCallsWrapperName: this.stringArrayCallsWrapperName }) : '';
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Number)
                ], f.prototype, 'indexShiftAmount', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], f.prototype, 'stringArrayCallsWrapperName', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], f.prototype, 'stringArrayFunctionName', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], f.prototype, 'stringArrayCacheName', void 0), f = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    a(5, (0, o.inject)(s.ServiceIdentifiers.IEscapeSequenceEncoder)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], f), t.StringArrayCallsWrapperCodeHelper = f;
            },
            6375: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                    var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                    if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                        o = Reflect.decorate(e, t, r, n);
                    else
                        for (var s = e.length - 1; s >= 0; s--)
                            (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                    return a > 3 && o && Object.defineProperty(t, r, o), o;
                };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayCallsWrapperRc4CodeHelper = void 0;
                const i = r(6594), a = r(2437), o = r(5316), s = r(9013), c = r(2881);
                let u = class extends c.StringArrayCallsWrapperCodeHelper {
                    getDecodeStringArrayTemplate() {
                        const e = this.randomGenerator.getRandomString(6), t = this.randomGenerator.getRandomString(6), r = this.customCodeHelperFormatter.formatTemplate((0, a.AtobTemplate)(this.options.selfDefending), { atobFunctionName: e }), n = this.customCodeHelperFormatter.formatTemplate((0, o.Rc4Template)(), {
                                atobFunctionName: e,
                                rc4FunctionName: t
                            }), i = this.getSelfDefendingTemplate();
                        return this.customCodeHelperFormatter.formatTemplate((0, s.StringArrayRC4DecodeTemplate)(this.randomGenerator), {
                            atobPolyfill: r,
                            rc4FunctionName: t,
                            rc4Polyfill: n,
                            selfDefendingCode: i,
                            stringArrayCallsWrapperName: this.stringArrayCallsWrapperName,
                            stringArrayCacheName: this.stringArrayCacheName
                        });
                    }
                };
                u = n([(0, i.injectable)()], u), t.StringArrayCallsWrapperRc4CodeHelper = u;
            },
            7025: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayCodeHelper = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(3331), l = r(9235), d = r(2815), p = r(6493);
                let f = class extends l.AbstractCustomCodeHelper {
                    constructor(e, t, r, n, i) {
                        super(e, t, r, n, i);
                    }
                    initialize(e, t) {
                        this.stringArrayStorage = e, this.stringArrayFunctionName = t;
                    }
                    getNodeStructure(e) {
                        return d.NodeUtils.convertCodeToStructure(e);
                    }
                    getCodeHelperTemplate() {
                        const e = this.identifierNamesGenerator.generateNext();
                        return this.customCodeHelperFormatter.formatTemplate((0, u.StringArrayTemplate)(), {
                            stringArrayFunctionName: this.stringArrayFunctionName,
                            stringArrayName: e,
                            stringArrayStorageItems: this.getEncodedStringArrayStorageItems()
                        });
                    }
                    getEncodedStringArrayStorageItems() {
                        return Array.from(this.stringArrayStorage.getStorage().values()).map(e => `'${ p.StringUtils.escapeJsString(e.encodedValue) }'`).toString();
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], f.prototype, 'stringArrayStorage', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], f.prototype, 'stringArrayFunctionName', void 0), f = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], f), t.StringArrayCodeHelper = f;
            },
            8409: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayRotateFunctionCodeHelper = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(720), l = r(9235), d = r(2815);
                let p = class extends l.AbstractCustomCodeHelper {
                    constructor(e, t, r, n, i) {
                        super(e, t, r, n, i);
                    }
                    initialize(e, t, r) {
                        this.stringArrayFunctionName = e, this.comparisonValue = t, this.comparisonExpressionNode = r;
                    }
                    getNodeStructure(e) {
                        return d.NodeUtils.convertCodeToStructure(e);
                    }
                    getCodeHelperTemplate() {
                        const e = d.NodeUtils.convertStructureToCode([this.comparisonExpressionNode]);
                        return this.customCodeHelperFormatter.formatTemplate((0, u.StringArrayRotateFunctionTemplate)(), {
                            comparisonExpressionCode: e,
                            comparisonValue: this.comparisonValue,
                            stringArrayFunctionName: this.stringArrayFunctionName
                        });
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Number)
                ], p.prototype, 'comparisonValue', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], p.prototype, 'comparisonExpressionNode', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'stringArrayFunctionName', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.StringArrayRotateFunctionCodeHelper = p;
            },
            4229: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayCodeHelperGroup = void 0;
                const s = r(6594), c = r(2553), u = r(626), l = r(8547), d = r(1296), p = r(6245), f = r(8434);
                let m = n = class extends p.AbstractCustomCodeHelperGroup {
                    constructor(e, t, r, n, i) {
                        super(r, n, i), this.customCodeHelperFactory = e, this.stringArrayStorage = t;
                    }
                    appendOnFinalizingStage(e, t) {
                        if (!this.stringArrayStorage.getLength())
                            return;
                        const r = f.NodeAppender.getScopeStatements(e);
                        this.appendCustomNodeIfExist(l.CustomCodeHelper.StringArray, t => {
                            f.NodeAppender.insertAtIndex(e, t.getNode(), this.getScopeStatementRandomIndex(r));
                        });
                        for (const t of this.options.stringArrayEncoding) {
                            const n = this.getStringArrayCallsWrapperCodeHelperName(t);
                            this.appendCustomNodeIfExist(n, t => {
                                f.NodeAppender.insertAtIndex(e, t.getNode(), this.getScopeStatementRandomIndex(r));
                            });
                        }
                    }
                    initialize() {
                        if (this.customCodeHelpers = new Map(), !this.options.stringArray)
                            return;
                        const e = this.stringArrayStorage.getStorageName(), t = this.customCodeHelperFactory(l.CustomCodeHelper.StringArray);
                        t.initialize(this.stringArrayStorage, e), this.customCodeHelpers.set(l.CustomCodeHelper.StringArray, t);
                        for (const t of this.options.stringArrayEncoding) {
                            const r = this.getStringArrayCallsWrapperCodeHelperName(t), n = this.customCodeHelperFactory(r), i = this.stringArrayStorage.getStorageCallsWrapperName(t);
                            n.initialize(e, i, this.stringArrayStorage.getIndexShiftAmount()), this.customCodeHelpers.set(r, n);
                        }
                    }
                    getStringArrayCallsWrapperCodeHelperName(e) {
                        var t;
                        return null !== (t = n.stringArrayCallsWrapperCodeHelperMap.get(e)) && void 0 !== t ? t : l.CustomCodeHelper.StringArrayCallsWrapper;
                    }
                    getScopeStatementRandomIndex(e) {
                        return this.randomGenerator.getRandomInteger(0, Math.max(0, e.length));
                    }
                };
                m.stringArrayCallsWrapperCodeHelperMap = new Map([
                    [
                        d.StringArrayEncoding.None,
                        l.CustomCodeHelper.StringArrayCallsWrapper
                    ],
                    [
                        d.StringArrayEncoding.Base64,
                        l.CustomCodeHelper.StringArrayCallsWrapperBase64
                    ],
                    [
                        d.StringArrayEncoding.Rc4,
                        l.CustomCodeHelper.StringArrayCallsWrapperRc4
                    ]
                ]), i([
                    (0, u.initializable)(),
                    a('design:type', Map)
                ], m.prototype, 'customCodeHelpers', void 0), m = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__ICustomCodeHelper)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IStringArrayStorage)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(4, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Object,
                        Function,
                        Object,
                        Object
                    ])
                ], m), t.StringArrayCodeHelperGroup = m;
            },
            2437: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AtobTemplate = void 0;
                const n = r(99);
                t.AtobTemplate = function (e) {
                    return `\n        var {atobFunctionName} = function (input) {\n            const chars = '${ n.base64alphabetSwapped }';\n\n            let output = '';\n            let tempEncodedString = '';\n            ${ e ? 'let func = output + {atobFunctionName};' : '' }\n            \n            for (\n                let bc = 0, bs, buffer, idx = 0;\n                buffer = input.charAt(idx++);\n                ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4)\n                    ? output += ${ (() => {
                        const t = 'String.fromCharCode(255 & bs >> (-2 * bc & 6))';
                        return e ? `((func.charCodeAt(idx + 10) - 10 !== 0) ? ${ t } : bc)` : t;
                    })() }\n                    : 0\n            ) {\n                buffer = chars.indexOf(buffer);\n            }\n            \n             for (let k = 0, length = output.length; k < length; k++) {\n                tempEncodedString += '%' + ('00' + output.charCodeAt(k).toString(16)).slice(-2);\n            }\n        \n            return decodeURIComponent(tempEncodedString);\n        };\n    `;
                };
            },
            5316: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.Rc4Template = void 0, t.Rc4Template = function () {
                    return '\n        const {rc4FunctionName} = function (str, key) {\n            let s = [], j = 0, x, output = \'\';\n           \n            str = {atobFunctionName}(str);\n                \n            let i;\n                    \t        \n            for (i = 0; i < 256; i++) {\n                s[i] = i;\n            }\n \n            for (i = 0; i < 256; i++) {\n                j = (j + s[i] + key.charCodeAt(i % key.length)) % 256;\n                x = s[i];\n                s[i] = s[j];\n                s[j] = x;\n            }\n            \n            i = 0;\n            j = 0;\n            \n            for (let y = 0; y < str.length; y++) {\n                i = (i + 1) % 256;\n                j = (j + s[i]) % 256;\n                x = s[i];\n                s[i] = s[j];\n                s[j] = x;\n                output += String.fromCharCode(str.charCodeAt(y) ^ s[(s[i] + s[j]) % 256]);\n            }\n                      \n            return output;\n        }\n    ';
                };
            },
            1108: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SelfDefendingTemplate = void 0, t.SelfDefendingTemplate = function (e, t) {
                    const r = e.getRandomString(6), n = e.getRandomString(6), i = e.getRandomString(6), a = e.getRandomString(6), o = e.getRandomString(6), s = e.getRandomString(6), c = e.getRandomString(6), u = e.getRandomString(6), l = e.getRandomString(6);
                    return `\n        const StatesClass = function (${ r }) {\n            this.${ r } = ${ r };\n            this.${ n } = [1, 0, 0];\n            this.${ i } = function(){return 'newState';};\n            this.${ a } = '${ t.encode('\\w+ *\\(\\) *{\\w+ *', !0) }';\n            this.${ o } = '${ t.encode('[\'|"].+[\'|"];? *}', !0) }';\n        };\n        \n        StatesClass.prototype.${ s } = function () {\n            const regExp = new RegExp(this.${ a } + this.${ o });\n            const expression = regExp.test(this.${ i }.toString())\n                ? --this.${ n }[1]\n                : --this.${ n }[0];\n            \n            return this.${ c }(expression);\n        };\n        \n        StatesClass.prototype.${ c } = function (${ l }) {\n            if (!Boolean(~${ l })) {\n                return ${ l };\n            }\n            \n            return this.${ u }(this.${ r });\n        };\n\n        StatesClass.prototype.${ u } = function (${ r }) {\n            for (let i = 0, len = this.${ n }.length; i < len; i++) {\n                this.${ n }.push(Math.round(Math.random()));\n                len = this.${ n }.length;\n            }\n            \n            return ${ r }(this.${ n }[0]);\n        };\n\n        new StatesClass({stringArrayCallsWrapperName}).${ s }();\n    `;
                };
            },
            7486: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayBase64DecodeTemplate = void 0, t.StringArrayBase64DecodeTemplate = function (e) {
                    const t = e.getRandomString(6), r = e.getRandomString(6);
                    return `\n        if ({stringArrayCallsWrapperName}.${ t } === undefined) {\n            {atobPolyfill}\n            {stringArrayCallsWrapperName}.${ r } = {atobFunctionName};\n\n            {stringArrayCacheName} = arguments;\n            \n            {stringArrayCallsWrapperName}.${ t } = true;\n        }\n                  \n        const firstValue = stringArray[0];\n        const cacheKey = index + firstValue;\n        const cachedValue = {stringArrayCacheName}[cacheKey];\n        \n        if (!cachedValue) {\n            {selfDefendingCode}\n            \n            value = {stringArrayCallsWrapperName}.${ r }(value);\n            {stringArrayCacheName}[cacheKey] = value;\n        } else {\n            value = cachedValue;\n        }\n    `;
                };
            },
            7851: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayCallsWrapperTemplate = void 0, t.StringArrayCallsWrapperTemplate = function () {
                    return '\n        function {stringArrayCallsWrapperName} ({stringArrayCacheName}, key) {\n            const stringArray = {stringArrayFunctionName}();\n            \n            {stringArrayCallsWrapperName} = function (index, key) {\n                index = index - {indexShiftAmount};\n                \n                let value = stringArray[index];\n                \n                {decodeCodeHelperTemplate}\n            \n                return value;\n            };\n         \n            return {stringArrayCallsWrapperName}({stringArrayCacheName}, key);\n        }\n    ';
                };
            },
            9013: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayRC4DecodeTemplate = void 0, t.StringArrayRC4DecodeTemplate = function (e) {
                    const t = e.getRandomString(6), r = e.getRandomString(6), n = e.getRandomString(6);
                    return `\n        if ({stringArrayCallsWrapperName}.${ t } === undefined) {\n            {atobPolyfill}\n            {rc4Polyfill}\n            {stringArrayCallsWrapperName}.${ r } = {rc4FunctionName};\n            \n            {stringArrayCacheName} = arguments;\n            \n            {stringArrayCallsWrapperName}.${ t } = true;\n        }\n  \n        const firstValue = stringArray[0];\n        const cacheKey = index + firstValue;\n        const cachedValue = {stringArrayCacheName}[cacheKey];\n\n        if (!cachedValue) {\n            if ({stringArrayCallsWrapperName}.${ n } === undefined) {\n                {selfDefendingCode}\n                \n                {stringArrayCallsWrapperName}.${ n } = true;\n            }\n            \n            value = {stringArrayCallsWrapperName}.${ r }(value, key);\n            {stringArrayCacheName}[cacheKey] = value;\n        } else {\n            value = cachedValue;\n        }\n    `;
                };
            },
            720: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayRotateFunctionTemplate = void 0, t.StringArrayRotateFunctionTemplate = function () {
                    return '\n        (function (stringArrayFunction, comparisonValue) {\n            const stringArray = stringArrayFunction();\n        \n            while (true) {\n                try {\n                    const expression = {comparisonExpressionCode};\n                                            \n                    if (expression === comparisonValue) {\n                        break;\n                    } else {\n                        stringArray[\'push\'](stringArray[\'shift\']());\n                    }\n                } catch (e) {\n                    stringArray[\'push\'](stringArray[\'shift\']());\n                }\n            }\n        })({stringArrayFunctionName}, {comparisonValue});\n    ';
                };
            },
            3331: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayTemplate = void 0, t.StringArrayTemplate = function () {
                    return '\n        function {stringArrayFunctionName} () {\n            const {stringArrayName} = [{stringArrayStorageItems}];\n            \n            {stringArrayFunctionName} = function () {\n                return {stringArrayName};\n            };\n            \n            return {stringArrayFunctionName}();\n        }\n    ';
                };
            },
            4985: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractCustomNode = void 0;
                const o = r(6594), s = r(2553);
                let c = class {
                    constructor(e, t, r, n) {
                        this.cachedNode = null, this.identifierNamesGenerator = e(n), this.customCodeHelperFormatter = t, this.randomGenerator = r, this.options = n;
                    }
                    getNode() {
                        return this.cachedNode || (this.cachedNode = this.customCodeHelperFormatter.formatStructure(this.getNodeStructure())), this.cachedNode;
                    }
                };
                c = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], c), t.AbstractCustomNode = c;
            },
            5761: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.BinaryExpressionFunctionNode = void 0;
                const o = r(6594), s = r(2553), c = r(4985), u = r(9181), l = r(2815);
                let d = class extends c.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e) {
                        this.operator = e;
                    }
                    getNodeStructure() {
                        const e = u.NodeFactory.expressionStatementNode(u.NodeFactory.functionExpressionNode([
                            u.NodeFactory.identifierNode('x'),
                            u.NodeFactory.identifierNode('y')
                        ], u.NodeFactory.blockStatementNode([u.NodeFactory.returnStatementNode(u.NodeFactory.binaryExpressionNode(this.operator, u.NodeFactory.identifierNode('x'), u.NodeFactory.identifierNode('y')))])));
                        return l.NodeUtils.parentizeAst(e), [e];
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], d), t.BinaryExpressionFunctionNode = d;
            },
            8773: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.BlockStatementControlFlowFlatteningNode = void 0;
                const o = r(6594), s = r(2553), c = r(4413), u = r(626), l = r(4985), d = r(9181), p = r(8983), f = r(2815);
                let m = class extends l.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e, t, r) {
                        this.blockStatementBody = e, this.shuffledKeys = t, this.originalKeysIndexesInShuffledArray = r;
                    }
                    getNodeStructure() {
                        const e = this.randomGenerator.getRandomString(6), t = this.randomGenerator.getRandomString(6), r = d.NodeFactory.blockStatementNode([
                                d.NodeFactory.variableDeclarationNode([d.NodeFactory.variableDeclaratorNode(d.NodeFactory.identifierNode(e), d.NodeFactory.callExpressionNode(d.NodeFactory.memberExpressionNode(d.NodeFactory.literalNode(this.originalKeysIndexesInShuffledArray.join(c.StringSeparator.VerticalLine)), d.NodeFactory.identifierNode('split')), [d.NodeFactory.literalNode(c.StringSeparator.VerticalLine)]))], 'const'),
                                d.NodeFactory.variableDeclarationNode([d.NodeFactory.variableDeclaratorNode(d.NodeFactory.identifierNode(t), d.NodeFactory.literalNode(0))], 'let'),
                                d.NodeFactory.whileStatementNode(d.NodeFactory.literalNode(!0), d.NodeFactory.blockStatementNode([
                                    d.NodeFactory.switchStatementNode(d.NodeFactory.memberExpressionNode(d.NodeFactory.identifierNode(e), d.NodeFactory.updateExpressionNode('++', d.NodeFactory.identifierNode(t)), !0), this.shuffledKeys.map((e, t) => {
                                        const r = this.blockStatementBody[e], n = [r];
                                        return p.NodeGuards.isReturnStatementNode(r) || n.push(d.NodeFactory.continueStatement()), d.NodeFactory.switchCaseNode(d.NodeFactory.literalNode(String(t)), n);
                                    })),
                                    d.NodeFactory.breakStatement()
                                ]))
                            ]);
                        return f.NodeUtils.parentizeAst(r), [r];
                    }
                };
                n([
                    (0, u.initializable)(),
                    i('design:type', Array)
                ], m.prototype, 'blockStatementBody', void 0), n([
                    (0, u.initializable)(),
                    i('design:type', Array)
                ], m.prototype, 'originalKeysIndexesInShuffledArray', void 0), n([
                    (0, u.initializable)(),
                    i('design:type', Array)
                ], m.prototype, 'shuffledKeys', void 0), m = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], m), t.BlockStatementControlFlowFlatteningNode = m;
            },
            2854: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CallExpressionFunctionNode = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(4985), l = r(9181), d = r(2815), p = r(8983);
                let f = class extends u.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e) {
                        this.expressionArguments = e;
                    }
                    getNodeStructure() {
                        const e = l.NodeFactory.identifierNode('callee'), t = [], r = [], n = this.expressionArguments.length;
                        for (let e = 0; e < n; e++) {
                            const i = this.expressionArguments[e], a = p.NodeGuards.isSpreadElementNode(i), o = l.NodeFactory.identifierNode(`param${ e + 1 }`);
                            if (a) {
                                if (t.push(l.NodeFactory.restElementNode(o)), r.push(l.NodeFactory.spreadElementNode(o)), e < n - 1)
                                    break;
                            } else
                                t.push(o), r.push(o);
                        }
                        const i = l.NodeFactory.expressionStatementNode(l.NodeFactory.functionExpressionNode([
                            e,
                            ...t
                        ], l.NodeFactory.blockStatementNode([l.NodeFactory.returnStatementNode(l.NodeFactory.callExpressionNode(e, r))])));
                        return d.NodeUtils.parentizeAst(i), [i];
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Array)
                ], f.prototype, 'expressionArguments', void 0), f = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], f), t.CallExpressionFunctionNode = f;
            },
            6300: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.LiteralNode = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(4985), l = r(9181);
                let d = class extends u.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e) {
                        this.literalNode = e;
                    }
                    getNodeStructure() {
                        return [l.NodeFactory.expressionStatementNode(this.literalNode)];
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], d.prototype, 'literalNode', void 0), d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], d), t.LiteralNode = d;
            },
            7587: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.LogicalExpressionFunctionNode = void 0;
                const o = r(6594), s = r(2553), c = r(4985), u = r(9181), l = r(2815);
                let d = class extends c.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e) {
                        this.operator = e;
                    }
                    getNodeStructure() {
                        const e = u.NodeFactory.expressionStatementNode(u.NodeFactory.functionExpressionNode([
                            u.NodeFactory.identifierNode('x'),
                            u.NodeFactory.identifierNode('y')
                        ], u.NodeFactory.blockStatementNode([u.NodeFactory.returnStatementNode(u.NodeFactory.logicalExpressionNode(this.operator, u.NodeFactory.identifierNode('x'), u.NodeFactory.identifierNode('y')))])));
                        return l.NodeUtils.parentizeAst(e), [e];
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], d), t.LogicalExpressionFunctionNode = d;
            },
            5993: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CallExpressionControlFlowStorageCallNode = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(4985), l = r(9181), d = r(2815);
                let p = class extends u.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e, t, r, n) {
                        this.controlFlowStorageName = e, this.controlFlowStorageKey = t, this.callee = r, this.expressionArguments = n;
                    }
                    getNodeStructure() {
                        const e = l.NodeFactory.expressionStatementNode(l.NodeFactory.callExpressionNode(l.NodeFactory.memberExpressionNode(l.NodeFactory.identifierNode(this.controlFlowStorageName), l.NodeFactory.identifierNode(this.controlFlowStorageKey)), [
                            this.callee,
                            ...this.expressionArguments
                        ]));
                        return d.NodeUtils.parentizeAst(e), [e];
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], p.prototype, 'callee', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'controlFlowStorageKey', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'controlFlowStorageName', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', Array)
                ], p.prototype, 'expressionArguments', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.CallExpressionControlFlowStorageCallNode = p;
            },
            5808: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ControlFlowStorageNode = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(4985), l = r(9181), d = r(8983);
                let p = class extends u.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e) {
                        this.controlFlowStorage = e;
                    }
                    getNodeStructure() {
                        const e = [], t = this.controlFlowStorage.getStorage();
                        for (const [r, n] of t) {
                            const t = n.getNode()[0];
                            if (!d.NodeGuards.isExpressionStatementNode(t))
                                throw new Error('Function node for control flow storage object should be passed inside the `ExpressionStatement` node!');
                            e.push(l.NodeFactory.propertyNode(l.NodeFactory.identifierNode(r), t.expression));
                        }
                        return [l.NodeFactory.variableDeclarationNode([l.NodeFactory.variableDeclaratorNode(l.NodeFactory.identifierNode(this.controlFlowStorage.getStorageId()), l.NodeFactory.objectExpressionNode(e))], 'const')];
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], p.prototype, 'controlFlowStorage', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.ControlFlowStorageNode = p;
            },
            9843: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ExpressionWithOperatorControlFlowStorageCallNode = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(4985), l = r(9181), d = r(2815);
                let p = class extends u.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e, t, r, n) {
                        this.controlFlowStorageName = e, this.controlFlowStorageKey = t, this.leftValue = r, this.rightValue = n;
                    }
                    getNodeStructure() {
                        const e = l.NodeFactory.expressionStatementNode(l.NodeFactory.callExpressionNode(l.NodeFactory.memberExpressionNode(l.NodeFactory.identifierNode(this.controlFlowStorageName), l.NodeFactory.identifierNode(this.controlFlowStorageKey)), [
                            this.leftValue,
                            this.rightValue
                        ]));
                        return d.NodeUtils.parentizeAst(e), [e];
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'controlFlowStorageKey', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'controlFlowStorageName', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.ExpressionWithOperatorControlFlowStorageCallNode = p;
            },
            2603: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringLiteralControlFlowStorageCallNode = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(4985), l = r(9181), d = r(2815);
                let p = class extends u.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e, t) {
                        this.controlFlowStorageName = e, this.controlFlowStorageKey = t;
                    }
                    getNodeStructure() {
                        const e = l.NodeFactory.expressionStatementNode(l.NodeFactory.memberExpressionNode(l.NodeFactory.identifierNode(this.controlFlowStorageName), l.NodeFactory.identifierNode(this.controlFlowStorageKey)));
                        return d.NodeUtils.parentizeAst(e), [e];
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'controlFlowStorageKey', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], p.prototype, 'controlFlowStorageName', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.StringLiteralControlFlowStorageCallNode = p;
            },
            5188: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.BlockStatementDeadCodeInjectionNode = void 0;
                const o = r(6594), s = r(2553), c = r(4985), u = r(9181), l = r(2815);
                let d = class extends c.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e, t) {
                        this.blockStatementNode = e, this.deadCodeInjectionRootAstHostNode = t;
                    }
                    getNode() {
                        return this.getNodeStructure();
                    }
                    getNodeStructure() {
                        const e = this.randomGenerator.getMathRandom() > 0.5, t = this.randomGenerator.getMathRandom() > 0.5, r = e ? '===' : '!==', n = this.randomGenerator.getRandomString(5), i = t ? n : this.randomGenerator.getRandomString(5), [a, o] = e === t ? [
                                this.blockStatementNode,
                                this.deadCodeInjectionRootAstHostNode
                            ] : [
                                this.deadCodeInjectionRootAstHostNode,
                                this.blockStatementNode
                            ], s = u.NodeFactory.blockStatementNode([u.NodeFactory.ifStatementNode(u.NodeFactory.binaryExpressionNode(r, u.NodeFactory.literalNode(n), u.NodeFactory.literalNode(i)), a, o)]);
                        return l.NodeUtils.parentizeAst(s), [s];
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], d), t.BlockStatementDeadCodeInjectionNode = d;
            },
            6204: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObjectExpressionVariableDeclarationHostNode = void 0;
                const o = r(6594), s = r(2553), c = r(4985), u = r(9181), l = r(8983);
                let d = class extends c.AbstractCustomNode {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    initialize(e, t) {
                        this.lexicalScopeNode = e, this.properties = t;
                    }
                    getNodeStructure() {
                        const e = l.NodeGuards.isProgramNode(this.lexicalScopeNode) ? this.identifierNamesGenerator.generateForGlobalScope() : this.identifierNamesGenerator.generateForLexicalScope(this.lexicalScopeNode);
                        return [u.NodeFactory.variableDeclarationNode([u.NodeFactory.variableDeclaratorNode(u.NodeFactory.identifierNode(e), u.NodeFactory.objectExpressionNode(this.properties))], 'const')];
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], d), t.ObjectExpressionVariableDeclarationHostNode = d;
            },
            7177: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractStringArrayCallNode = void 0;
                const s = r(6594), c = r(2553), u = r(5114), l = r(2855), d = r(4985), p = r(9181), f = r(5301), m = r(2815);
                let h = n = class extends d.AbstractCustomNode {
                    constructor(e, t, r, n, i, a, o) {
                        super(e, r, a, o), this.stringArrayIndexNodeFactory = t, this.stringArrayStorage = n, this.arrayUtils = i;
                    }
                    getStringArrayIndexNode(e) {
                        var t;
                        const r = e >= 0, i = Math.abs(e), a = this.randomGenerator.getRandomGenerator().pickone(this.options.stringArrayIndexesType), o = null !== (t = n.stringArrayIndexNodesMap.get(a)) && void 0 !== t ? t : null;
                        if (!o)
                            throw new Error('Invalid string array index node name');
                        const s = this.stringArrayIndexNodeFactory(o).getNode(i);
                        f.NodeMetadata.set(s, { stringArrayCallLiteralNode: !0 });
                        const c = r ? s : p.NodeFactory.unaryExpressionNode('-', s);
                        return m.NodeUtils.parentizeAst(c), c;
                    }
                    getRc4KeyLiteralNode(e) {
                        const t = p.NodeFactory.literalNode(e);
                        return f.NodeMetadata.set(t, { stringArrayCallLiteralNode: !0 }), t;
                    }
                };
                h.stringArrayRootCallsWrapperParametersCount = 2, h.stringArrayIndexNodesMap = new Map([
                    [
                        u.StringArrayIndexesType.HexadecimalNumber,
                        l.StringArrayIndexNode.StringArrayHexadecimalNumberIndexNode
                    ],
                    [
                        u.StringArrayIndexesType.HexadecimalNumericString,
                        l.StringArrayIndexNode.StringArrayHexadecimalNumericStringIndexNode
                    ]
                ]), h = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.Factory__IStringArrayIndexNode)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.IStringArrayStorage)),
                    o(4, (0, s.inject)(c.ServiceIdentifiers.IArrayUtils)),
                    o(5, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(6, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], h), t.AbstractStringArrayCallNode = h;
            },
            5707: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayCallNode = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(7177), l = r(9181), d = r(2815);
                let p = class extends u.AbstractStringArrayCallNode {
                    constructor(e, t, r, n, i, a, o) {
                        super(e, t, r, n, i, a, o);
                    }
                    initialize(e, t, r, n) {
                        this.index = e, this.indexShiftAmount = t, this.stringArrayCallsWrapperData = r, this.decodeKey = n;
                    }
                    getNodeStructure() {
                        var e, t;
                        const r = this.indexShiftAmount + this.stringArrayCallsWrapperData.index + this.index, n = this.getStringArrayIndexNode(r), i = this.decodeKey ? this.getRc4KeyLiteralNode(this.decodeKey) : null, a = this.arrayUtils.fillWithRange(this.stringArrayCallsWrapperData.parameterIndexesData ? this.options.stringArrayWrappersParametersMaxCount : u.AbstractStringArrayCallNode.stringArrayRootCallsWrapperParametersCount, () => this.getFakeStringArrayIndexNode(r));
                        a.splice(null !== (t = null === (e = this.stringArrayCallsWrapperData.parameterIndexesData) || void 0 === e ? void 0 : e.valueIndexParameterIndex) && void 0 !== t ? t : 0, 1, n), this.stringArrayCallsWrapperData.parameterIndexesData ? a.splice(this.stringArrayCallsWrapperData.parameterIndexesData.decodeKeyParameterIndex, 1, null != i ? i : this.getFakeStringArrayIndexNode(r)) : i ? a.splice(1, 1, i) : a.splice(1, 1);
                        const o = l.NodeFactory.expressionStatementNode(l.NodeFactory.callExpressionNode(l.NodeFactory.identifierNode(this.stringArrayCallsWrapperData.name), a));
                        return d.NodeUtils.parentizeAst(o), [o];
                    }
                    getFakeStringArrayIndexNode(e) {
                        return this.getStringArrayIndexNode(this.getFakeStringArrayIndex(e));
                    }
                    getFakeStringArrayIndex(e) {
                        const t = this.stringArrayStorage.getLength() / 2, r = e - t, n = e + t;
                        return this.randomGenerator.getRandomInteger(r, n);
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], p.prototype, 'decodeKey', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', Number)
                ], p.prototype, 'index', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', Number)
                ], p.prototype, 'indexShiftAmount', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], p.prototype, 'stringArrayCallsWrapperData', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.Factory__IStringArrayIndexNode)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IStringArrayStorage)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IArrayUtils)),
                    a(5, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(6, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.StringArrayCallNode = p;
            },
            1135: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayScopeCallsWrapperFunctionNode = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(7177), l = r(9181), d = r(2815);
                let p = class extends u.AbstractStringArrayCallNode {
                    constructor(e, t, r, n, i, a, o) {
                        super(e, t, r, n, i, a, o);
                    }
                    initialize(e, t) {
                        this.stringArrayScopeCallsWrapperData = e, this.upperStringArrayCallsWrapperData = t;
                    }
                    getNodeStructure() {
                        var e, t, r, n, i, a, o, s;
                        const c = l.NodeFactory.identifierNode(this.randomGenerator.getRandomString(6)), p = l.NodeFactory.identifierNode(this.randomGenerator.getRandomString(6)), f = this.getUpperStringArrayCallNode(c, this.getStringArrayIndexNode(this.stringArrayScopeCallsWrapperData.index - this.upperStringArrayCallsWrapperData.index)), m = this.arrayUtils.fillWithRange(this.stringArrayScopeCallsWrapperData.parameterIndexesData ? this.options.stringArrayWrappersParametersMaxCount : u.AbstractStringArrayCallNode.stringArrayRootCallsWrapperParametersCount, () => this.getFakeParameterNode());
                        m.splice(null !== (t = null === (e = this.stringArrayScopeCallsWrapperData.parameterIndexesData) || void 0 === e ? void 0 : e.valueIndexParameterIndex) && void 0 !== t ? t : 0, 1, c), m.splice(null !== (n = null === (r = this.stringArrayScopeCallsWrapperData.parameterIndexesData) || void 0 === r ? void 0 : r.decodeKeyParameterIndex) && void 0 !== n ? n : 1, 1, p);
                        const h = this.arrayUtils.fillWithRange(this.upperStringArrayCallsWrapperData.parameterIndexesData ? this.options.stringArrayWrappersParametersMaxCount : u.AbstractStringArrayCallNode.stringArrayRootCallsWrapperParametersCount, e => this.getUpperStringArrayCallNode(m[e], this.getFakeUpperStringArrayIndexNode()));
                        h.splice(null !== (a = null === (i = this.upperStringArrayCallsWrapperData.parameterIndexesData) || void 0 === i ? void 0 : i.valueIndexParameterIndex) && void 0 !== a ? a : 0, 1, f), h.splice(null !== (s = null === (o = this.upperStringArrayCallsWrapperData.parameterIndexesData) || void 0 === o ? void 0 : o.decodeKeyParameterIndex) && void 0 !== s ? s : 1, 1, p);
                        const g = l.NodeFactory.functionDeclarationNode(this.stringArrayScopeCallsWrapperData.name, m, l.NodeFactory.blockStatementNode([l.NodeFactory.returnStatementNode(l.NodeFactory.callExpressionNode(l.NodeFactory.identifierNode(this.upperStringArrayCallsWrapperData.name), h))])), y = g;
                        d.NodeUtils.parentizeAst(y);
                        for (const e of m)
                            e.name = this.identifierNamesGenerator.generateForLexicalScope(g);
                        return [y];
                    }
                    getUpperStringArrayCallNode(e, t) {
                        return l.NodeFactory.binaryExpressionNode('-', e, t);
                    }
                    getFakeParameterNode() {
                        return l.NodeFactory.identifierNode(this.randomGenerator.getRandomString(6));
                    }
                    getFakeUpperStringArrayIndexNode() {
                        return this.getStringArrayIndexNode(this.randomGenerator.getRandomInteger(0, 500));
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], p.prototype, 'upperStringArrayCallsWrapperData', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], p.prototype, 'stringArrayScopeCallsWrapperData', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.Factory__IStringArrayIndexNode)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IStringArrayStorage)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IArrayUtils)),
                    a(5, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(6, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.StringArrayScopeCallsWrapperFunctionNode = p;
            },
            8405: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayScopeCallsWrapperVariableNode = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(7177), l = r(9181), d = r(2815);
                let p = class extends u.AbstractStringArrayCallNode {
                    constructor(e, t, r, n, i, a, o) {
                        super(e, t, r, n, i, a, o);
                    }
                    initialize(e, t) {
                        this.stringArrayScopeCallsWrapperData = e, this.stringArrayCallsWrapperData = t;
                    }
                    getNodeStructure() {
                        const e = l.NodeFactory.variableDeclarationNode([l.NodeFactory.variableDeclaratorNode(l.NodeFactory.identifierNode(this.stringArrayScopeCallsWrapperData.name), l.NodeFactory.identifierNode(this.stringArrayCallsWrapperData.name))], 'const');
                        return d.NodeUtils.parentizeAst(e), [e];
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], p.prototype, 'stringArrayCallsWrapperData', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', Object)
                ], p.prototype, 'stringArrayScopeCallsWrapperData', void 0), p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.Factory__IStringArrayIndexNode)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.ICustomCodeHelperFormatter)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IStringArrayStorage)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IArrayUtils)),
                    a(5, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(6, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.StringArrayScopeCallsWrapperVariableNode = p;
            },
            3858: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractStringArrayIndexNode = void 0;
                const o = r(6594), s = r(2553);
                let c = class {
                    constructor(e, t) {
                        this.randomGenerator = e, this.options = t;
                    }
                };
                c = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], c), t.AbstractStringArrayIndexNode = c;
            },
            9358: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayHexadecimalNumberIndexNode = void 0;
                const o = r(6594), s = r(2553), c = r(3858), u = r(9181), l = r(2303);
                let d = class extends c.AbstractStringArrayIndexNode {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getNode(e) {
                        const t = l.NumberUtils.toHex(e);
                        return u.NodeFactory.literalNode(e, t);
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], d), t.StringArrayHexadecimalNumberIndexNode = d;
            },
            8904: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayHexadecimalNumericStringIndexNode = void 0;
                const o = r(6594), s = r(2553), c = r(3858), u = r(9181), l = r(2303);
                let d = class extends c.AbstractStringArrayIndexNode {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getNode(e) {
                        const t = l.NumberUtils.toHex(e);
                        return u.NodeFactory.literalNode(t);
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], d), t.StringArrayHexadecimalNumericStringIndexNode = d;
            },
            626: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.initializable = void 0;
                const r = {
                        configurable: !0,
                        enumerable: !0
                    }, n = '_initialized', i = '_initializablePropertiesSet', a = '_wrappedMethodsSet', o = 'initialize';
                function s(e, t, r) {
                    Reflect.hasMetadata(e, r) || Reflect.defineMetadata(e, t, r);
                }
                t.initializable = function () {
                    return (e, t) => {
                        const c = e.initialize;
                        if (!c || 'function' != typeof c)
                            throw new Error('`initialize` method with initialization logic not found. `@initializable` decorator requires `initialize` method');
                        return s(n, !1, e), s(i, new Set(), e), s(a, new Set(), e), function (e) {
                            const t = Object.getOwnPropertyNames(e), s = new Set([
                                    o,
                                    'constructor'
                                ]);
                            t.forEach(t => {
                                var o;
                                const c = Reflect.getMetadata(i, e), u = Reflect.getMetadata(a, e);
                                if (s.has(t) || c.has(t) || u.has(t))
                                    return;
                                if ('function' != typeof e[t])
                                    return;
                                const l = null !== (o = Object.getOwnPropertyDescriptor(e, t)) && void 0 !== o ? o : r, d = l.value;
                                Object.defineProperty(e, t, {
                                    ...l,
                                    value() {
                                        if (!Reflect.getMetadata(n, this))
                                            throw new Error('Class should be initialized with `initialize()` method');
                                        return d.apply(this, arguments);
                                    }
                                }), u.add(t);
                            });
                        }(e), function (e, t) {
                            var i;
                            const a = null !== (i = Object.getOwnPropertyDescriptor(e, o)) && void 0 !== i ? i : r, s = a.value;
                            Object.defineProperty(e, o, {
                                ...a,
                                value: function () {
                                    Reflect.defineMetadata(n, !0, this);
                                    const e = s.apply(this, arguments);
                                    return this[t], e;
                                }
                            });
                        }(e, t), function (e, t) {
                            var n;
                            Reflect.getMetadata(i, e).add(t);
                            const a = `_${ t.toString() }`, o = null !== (n = Object.getOwnPropertyDescriptor(e, a)) && void 0 !== n ? n : r;
                            return Object.defineProperty(e, t, {
                                ...o,
                                get: function () {
                                    if (void 0 === this[a])
                                        throw new Error(`Property \`${ t.toString() }\` is not initialized! Initialize it first!`);
                                    return this[a];
                                },
                                set: function (e) {
                                    this[a] = e;
                                }
                            }), o;
                        }(e, t);
                    };
                };
            },
            7081: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObfuscationTarget = void 0;
                const n = r(1700);
                t.ObfuscationTarget = n.Utils.makeEnum({
                    Browser: 'browser',
                    BrowserNoEval: 'browser-no-eval',
                    Node: 'node',
                    ServiceWorker: 'service-worker'
                });
            },
            4413: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringSeparator = void 0, (r = t.StringSeparator || (t.StringSeparator = {})).Comma = ',', r.Dot = '.', r.VerticalLine = '|';
            },
            9072: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CalleeDataExtractor = void 0, (r = t.CalleeDataExtractor || (t.CalleeDataExtractor = {})).FunctionDeclarationCalleeDataExtractor = 'FunctionDeclarationCalleeDataExtractor', r.FunctionExpressionCalleeDataExtractor = 'FunctionExpressionCalleeDataExtractor', r.ObjectExpressionCalleeDataExtractor = 'ObjectExpressionCalleeDataExtractor';
            },
            6045: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CodeTransformationStage = void 0, (r = t.CodeTransformationStage || (t.CodeTransformationStage = {})).PreparingTransformers = 'PreparingTransformers', r.FinalizingTransformers = 'FinalizingTransformers';
            },
            9292: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CodeTransformer = void 0, (t.CodeTransformer || (t.CodeTransformer = {})).HashbangOperatorTransformer = 'HashbangOperatorTransformer';
            },
            8547: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CustomCodeHelper = void 0, (r = t.CustomCodeHelper || (t.CustomCodeHelper = {})).CallsControllerFunction = 'CallsControllerFunction', r.ConsoleOutputDisable = 'ConsoleOutputDisable', r.DebugProtectionFunctionCall = 'DebugProtectionFunctionCall', r.DebugProtectionFunctionInterval = 'DebugProtectionFunctionInterval', r.DebugProtectionFunction = 'DebugProtectionFunction', r.DomainLock = 'DomainLock', r.SelfDefending = 'SelfDefending', r.StringArray = 'StringArray', r.StringArrayCallsWrapper = 'StringArrayCallsWrapper', r.StringArrayCallsWrapperBase64 = 'StringArrayCallsWrapperBase64', r.StringArrayCallsWrapperRc4 = 'StringArrayCallsWrapperRc4', r.StringArrayRotateFunction = 'StringArrayRotateFunction';
            },
            7705: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CustomCodeHelperGroup = void 0, (r = t.CustomCodeHelperGroup || (t.CustomCodeHelperGroup = {})).ConsoleOutput = 'ConsoleOutput', r.DebugProtection = 'DebugProtection', r.DomainLock = 'DomainLock', r.SelfDefending = 'SelfDefending', r.StringArray = 'StringArray';
            },
            6517: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ControlFlowCustomNode = void 0, (r = t.ControlFlowCustomNode || (t.ControlFlowCustomNode = {})).BinaryExpressionFunctionNode = 'BinaryExpressionFunctionNode', r.BlockStatementControlFlowFlatteningNode = 'BlockStatementControlFlowFlatteningNode', r.CallExpressionControlFlowStorageCallNode = 'CallExpressionControlFlowStorageCallNode', r.CallExpressionFunctionNode = 'CallExpressionFunctionNode', r.ControlFlowStorageNode = 'ControlFlowStorageNode', r.ExpressionWithOperatorControlFlowStorageCallNode = 'ExpressionWithOperatorControlFlowStorageCallNode', r.LiteralNode = 'LiteralNode', r.LogicalExpressionFunctionNode = 'LogicalExpressionFunctionNode', r.StringLiteralControlFlowStorageCallNode = 'StringLiteralControlFlowStorageCallNode';
            },
            6782: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DeadCodeInjectionCustomNode = void 0, (t.DeadCodeInjectionCustomNode || (t.DeadCodeInjectionCustomNode = {})).BlockStatementDeadCodeInjectionNode = 'BlockStatementDeadCodeInjectionNode';
            },
            2982: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObjectExpressionKeysTransformerCustomNode = void 0, (t.ObjectExpressionKeysTransformerCustomNode || (t.ObjectExpressionKeysTransformerCustomNode = {})).ObjectExpressionVariableDeclarationHostNode = 'ObjectExpressionVariableDeclarationHostNode';
            },
            3627: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayCustomNode = void 0, (r = t.StringArrayCustomNode || (t.StringArrayCustomNode = {})).StringArrayCallNode = 'StringArrayCallNode', r.StringArrayScopeCallsWrapperFunctionNode = 'StringArrayScopeCallsWrapperFunctionNode', r.StringArrayScopeCallsWrapperVariableNode = 'StringArrayScopeCallsWrapperVariableNode';
            },
            2855: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayIndexNode = void 0, (r = t.StringArrayIndexNode || (t.StringArrayIndexNode = {})).StringArrayHexadecimalNumberIndexNode = 'StringArrayHexadecimalNumberIndexNode', r.StringArrayHexadecimalNumericStringIndexNode = 'StringArrayHexadecimalNumericStringIndexNode';
            },
            3552: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.IdentifierNamesGenerator = void 0;
                const n = r(1700);
                t.IdentifierNamesGenerator = n.Utils.makeEnum({
                    DictionaryIdentifierNamesGenerator: 'dictionary',
                    HexadecimalIdentifierNamesGenerator: 'hexadecimal',
                    MangledIdentifierNamesGenerator: 'mangled',
                    MangledShuffledIdentifierNamesGenerator: 'mangled-shuffled'
                });
            },
            7943: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.LoggingMessage = void 0, (r = t.LoggingMessage || (t.LoggingMessage = {})).EmptySourceCode = 'Empty source code. Obfuscation canceled...', r.ObfuscationCompleted = 'Obfuscation completed. Total time: %s sec.', r.ObfuscationStarted = 'Obfuscation started...', r.RandomGeneratorSeed = 'Random generator seed: %s...', r.CodeTransformationStage = 'Code transformation stage: %s...', r.NodeTransformationStage = 'AST transformation stage: %s...', r.Version = 'Version: %s';
            },
            4038: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.LoggingPrefix = void 0, (r = t.LoggingPrefix || (t.LoggingPrefix = {})).Base = '[javascript-obfuscator]', r.CLI = '[javascript-obfuscator-cli]';
            },
            780: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeTransformationStage = void 0, (r = t.NodeTransformationStage || (t.NodeTransformationStage = {})).ControlFlowFlattening = 'ControlFlowFlattening', r.Converting = 'Converting', r.DeadCodeInjection = 'DeadCodeInjection', r.Finalizing = 'Finalizing', r.Initializing = 'Initializing', r.Preparing = 'Preparing', r.RenameIdentifiers = 'RenameIdentifiers', r.RenameProperties = 'RenameProperties', r.Simplifying = 'Simplifying', r.StringArray = 'StringArray';
            },
            6188: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeTransformer = void 0, (r = t.NodeTransformer || (t.NodeTransformer = {})).BooleanLiteralTransformer = 'BooleanLiteralTransformer', r.BlockStatementControlFlowTransformer = 'BlockStatementControlFlowTransformer', r.BlockStatementSimplifyTransformer = 'BlockStatementSimplifyTransformer', r.ClassFieldTransformer = 'ClassFieldTransformer', r.CommentsTransformer = 'CommentsTransformer', r.CustomCodeHelpersTransformer = 'CustomCodeHelpersTransformer', r.DeadCodeInjectionIdentifiersTransformer = 'DeadCodeInjectionIdentifiersTransformer', r.DeadCodeInjectionTransformer = 'DeadCodeInjectionTransformer', r.DirectivePlacementTransformer = 'DirectivePlacementTransformer', r.EscapeSequenceTransformer = 'EscapeSequenceTransformer', r.EvalCallExpressionTransformer = 'EvalCallExpressionTransformer', r.ExportSpecifierTransformer = 'ExportSpecifierTransformer', r.ExpressionStatementsMergeTransformer = 'ExpressionStatementsMergeTransformer', r.FunctionControlFlowTransformer = 'FunctionControlFlowTransformer', r.IfStatementSimplifyTransformer = 'IfStatementSimplifyTransformer', r.LabeledStatementTransformer = 'LabeledStatementTransformer', r.MemberExpressionTransformer = 'MemberExpressionTransformer', r.MetadataTransformer = 'MetadataTransformer', r.NumberLiteralTransformer = 'NumberLiteralTransformer', r.NumberToNumericalExpressionTransformer = 'NumberToNumericalExpressionTransformer', r.ObfuscatingGuardsTransformer = 'ObfuscatingGuardsTransformer', r.ObjectExpressionKeysTransformer = 'ObjectExpressionKeysTransformer', r.ObjectExpressionTransformer = 'ObjectExpressionTransformer', r.ObjectPatternPropertiesTransformer = 'ObjectPatternPropertiesTransformer', r.ParentificationTransformer = 'ParentificationTransformer', r.RenamePropertiesTransformer = 'RenamePropertiesTransformer', r.ScopeIdentifiersTransformer = 'ScopeIdentifiersTransformer', r.ScopeThroughIdentifiersTransformer = 'ScopeThroughIdentifiersTransformer', r.SplitStringTransformer = 'SplitStringTransformer', r.StringArrayControlFlowTransformer = 'StringArrayControlFlowTransformer', r.StringArrayTransformer = 'StringArrayTransformer', r.StringArrayRotateFunctionTransformer = 'StringArrayRotateFunctionTransformer', r.StringArrayScopeCallsWrapperTransformer = 'StringArrayScopeCallsWrapperTransformer', r.TemplateLiteralTransformer = 'TemplateLiteralTransformer', r.VariableDeclarationsMergeTransformer = 'VariableDeclarationsMergeTransformer', r.VariablePreserveTransformer = 'VariablePreserveTransformer';
            },
            1155: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.VisitorDirection = void 0, (r = t.VisitorDirection || (t.VisitorDirection = {})).Enter = 'enter', r.Leave = 'leave';
            },
            5739: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ControlFlowReplacer = void 0, (r = t.ControlFlowReplacer || (t.ControlFlowReplacer = {})).BinaryExpressionControlFlowReplacer = 'BinaryExpressionControlFlowReplacer', r.CallExpressionControlFlowReplacer = 'CallExpressionControlFlowReplacer', r.LogicalExpressionControlFlowReplacer = 'LogicalExpressionControlFlowReplacer', r.StringArrayCallControlFlowReplacer = 'StringArrayCallControlFlowReplacer', r.StringLiteralControlFlowReplacer = 'StringLiteralControlFlowReplacer';
            },
            547: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObjectExpressionExtractor = void 0, (r = t.ObjectExpressionExtractor || (t.ObjectExpressionExtractor = {})).BasePropertiesExtractor = 'BasePropertiesExtractor', r.ObjectExpressionToVariableDeclarationExtractor = 'ObjectExpressionToVariableDeclarationExtractor';
            },
            4930: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObfuscatingGuard = void 0, (r = t.ObfuscatingGuard || (t.ObfuscatingGuard = {})).BlackListObfuscatingGuard = 'BlackListObfuscatingGuard', r.ConditionalCommentObfuscatingGuard = 'ConditionalCommentObfuscatingGuard', r.ForceTransformStringObfuscatingGuard = 'ForceTransformStringObfuscatingGuard', r.IgnoredImportObfuscatingGuard = 'IgnoredImportObfuscatingGuard', r.ReservedStringObfuscatingGuard = 'ReservedStringObfuscatingGuard';
            },
            3442: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.RenamePropertiesMode = void 0;
                const n = r(1700);
                t.RenamePropertiesMode = n.Utils.makeEnum({
                    Safe: 'safe',
                    Unsafe: 'unsafe'
                });
            },
            1296: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayEncoding = void 0;
                const n = r(1700);
                t.StringArrayEncoding = n.Utils.makeEnum({
                    None: 'none',
                    Base64: 'base64',
                    Rc4: 'rc4'
                });
            },
            5114: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayIndexesType = void 0;
                const n = r(1700);
                t.StringArrayIndexesType = n.Utils.makeEnum({
                    HexadecimalNumber: 'hexadecimal-number',
                    HexadecimalNumericString: 'hexadecimal-numeric-string'
                });
            },
            679: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayWrappersType = void 0;
                const n = r(1700);
                t.StringArrayWrappersType = n.Utils.makeEnum({
                    Variable: 'variable',
                    Function: 'function'
                });
            },
            9789: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeType = void 0, (r = t.NodeType || (t.NodeType = {})).ArrayExpression = 'ArrayExpression', r.ArrayPattern = 'ArrayPattern', r.ArrowFunctionExpression = 'ArrowFunctionExpression', r.AssignmentExpression = 'AssignmentExpression', r.AssignmentPattern = 'AssignmentPattern', r.AwaitExpression = 'AwaitExpression', r.BinaryExpression = 'BinaryExpression', r.BlockStatement = 'BlockStatement', r.BreakStatement = 'BreakStatement', r.CallExpression = 'CallExpression', r.CatchClause = 'CatchClause', r.ChainExpression = 'ChainExpression', r.ClassBody = 'ClassBody', r.ClassDeclaration = 'ClassDeclaration', r.ConditionalExpression = 'ConditionalExpression', r.ContinueStatement = 'ContinueStatement', r.DoWhileStatement = 'DoWhileStatement', r.ExportAllDeclaration = 'ExportAllDeclaration', r.ExportNamedDeclaration = 'ExportNamedDeclaration', r.ExportSpecifier = 'ExportSpecifier', r.ExpressionStatement = 'ExpressionStatement', r.ForStatement = 'ForStatement', r.ForInStatement = 'ForInStatement', r.ForOfStatement = 'ForOfStatement', r.FunctionDeclaration = 'FunctionDeclaration', r.FunctionExpression = 'FunctionExpression', r.Identifier = 'Identifier', r.IfStatement = 'IfStatement', r.ImportDeclaration = 'ImportDeclaration', r.ImportExpression = 'ImportExpression', r.ImportDefaultSpecifier = 'ImportDefaultSpecifier', r.ImportNamespaceSpecifier = 'ImportNamespaceSpecifier', r.ImportSpecifier = 'ImportSpecifier', r.LabeledStatement = 'LabeledStatement', r.Literal = 'Literal', r.LogicalExpression = 'LogicalExpression', r.MemberExpression = 'MemberExpression', r.MethodDefinition = 'MethodDefinition', r.NewExpression = 'NewExpression', r.ObjectExpression = 'ObjectExpression', r.ObjectPattern = 'ObjectPattern', r.PrivateIdentifier = 'PrivateIdentifier', r.Program = 'Program', r.Property = 'Property', r.PropertyDefinition = 'PropertyDefinition', r.RestElement = 'RestElement', r.ReturnStatement = 'ReturnStatement', r.SequenceExpression = 'SequenceExpression', r.SpreadElement = 'SpreadElement', r.StaticBlock = 'StaticBlock', r.Super = 'Super', r.SwitchCase = 'SwitchCase', r.SwitchStatement = 'SwitchStatement', r.TaggedTemplateExpression = 'TaggedTemplateExpression', r.TemplateElement = 'TemplateElement', r.TemplateLiteral = 'TemplateLiteral', r.ThisExpression = 'ThisExpression', r.ThrowStatement = 'ThrowStatement', r.TryStatement = 'TryStatement', r.UnaryExpression = 'UnaryExpression', r.UpdateExpression = 'UpdateExpression', r.VariableDeclaration = 'VariableDeclaration', r.VariableDeclarator = 'VariableDeclarator', r.WithStatement = 'WithStatement', r.WhileStatement = 'WhileStatement', r.YieldExpression = 'YieldExpression';
            },
            5181: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObfuscatingGuardResult = void 0, (r = t.ObfuscatingGuardResult || (t.ObfuscatingGuardResult = {})).ForceTransform = 'ForceTransform', r.Ignore = 'Ignore', r.Transform = 'Transform';
            },
            4867: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.OptionsPreset = void 0;
                const n = r(1700);
                t.OptionsPreset = n.Utils.makeEnum({
                    Default: 'default',
                    LowObfuscation: 'low-obfuscation',
                    MediumObfuscation: 'medium-obfuscation',
                    HighObfuscation: 'high-obfuscation'
                });
            },
            5138: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SourceMapMode = void 0;
                const n = r(1700);
                t.SourceMapMode = n.Utils.makeEnum({
                    Inline: 'inline',
                    Separate: 'separate'
                });
            },
            3550: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SourceMapSourcesMode = void 0;
                const n = r(1700);
                t.SourceMapSourcesMode = n.Utils.makeEnum({
                    Sources: 'sources',
                    SourcesContent: 'sources-content'
                });
            },
            7657: (e, t) => {
                'use strict';
                var r;
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ControlFlowStorage = void 0, (r = t.ControlFlowStorage || (t.ControlFlowStorage = {})).FunctionControlFlowStorage = 'function-control-flow-storage', r.StringControlFlowStorage = 'string-control-flow-storage';
            },
            5749: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractIdentifierNamesGenerator = void 0;
                const o = r(6594), s = r(2553), c = r(8983);
                let u = class {
                    constructor(e, t) {
                        this.preservedNamesSet = new Set(), this.lexicalScopesPreservedNamesMap = new WeakMap(), this.randomGenerator = e, this.options = t;
                    }
                    generate(e, t) {
                        return c.NodeGuards.isProgramNode(e) ? this.generateForGlobalScope() : this.generateForLexicalScope(e);
                    }
                    preserveName(e) {
                        this.preservedNamesSet.add(e);
                    }
                    preserveNameForLexicalScope(e, t) {
                        var r;
                        const n = null !== (r = this.lexicalScopesPreservedNamesMap.get(t)) && void 0 !== r ? r : new Set();
                        n.add(e), this.lexicalScopesPreservedNamesMap.set(t, n);
                    }
                    isValidIdentifierName(e) {
                        return !this.isReservedName(e) && !this.preservedNamesSet.has(e);
                    }
                    isValidIdentifierNameInLexicalScopes(e, t) {
                        var r;
                        if (!this.isValidIdentifierName(e))
                            return !1;
                        for (const n of t) {
                            const t = null !== (r = this.lexicalScopesPreservedNamesMap.get(n)) && void 0 !== r ? r : null;
                            if (t && t.has(e))
                                return !1;
                        }
                        return !0;
                    }
                    isReservedName(e) {
                        return !!this.options.reservedNames.length && this.options.reservedNames.some(t => null !== new RegExp(t, 'g').exec(e));
                    }
                };
                u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], u), t.AbstractIdentifierNamesGenerator = u;
            },
            1515: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DictionaryIdentifierNamesGenerator = void 0;
                const s = r(6594), c = r(2553), u = r(5749), l = r(8520);
                let d = n = class extends u.AbstractIdentifierNamesGenerator {
                    constructor(e, t, r) {
                        super(e, t), this.arrayUtils = r, this.identifierNamesSet = new Set(this.getInitialIdentifierNames(this.options.identifiersDictionary)), this.identifiersIterator = this.identifierNamesSet.values();
                    }
                    static incrementIdentifierName(e) {
                        let t = '', r = !1;
                        for (const n of e)
                            r || n !== n.toUpperCase() ? r || n !== n.toLowerCase() ? t += n : (t += n.toUpperCase(), r = !0) : t += n.toLowerCase();
                        return r ? t : null;
                    }
                    generateNext() {
                        const e = this.generateNewDictionaryName();
                        return this.preserveName(e), e;
                    }
                    generateForGlobalScope() {
                        const e = this.options.identifiersPrefix ? `${ this.options.identifiersPrefix }` : '', t = this.generateNewDictionaryName(t => {
                                const r = `${ e }${ t }`;
                                return this.isValidIdentifierName(r);
                            }), r = `${ e }${ t }`;
                        return this.preserveName(r), r;
                    }
                    generateForLexicalScope(e) {
                        const t = [
                                e,
                                ...l.NodeLexicalScopeUtils.getLexicalScopes(e)
                            ], r = this.generateNewDictionaryName(e => this.isValidIdentifierNameInLexicalScopes(e, t));
                        return this.preserveNameForLexicalScope(r, e), r;
                    }
                    generateForLabel(e) {
                        return this.generateNewDictionaryName();
                    }
                    generateNewDictionaryName(e) {
                        const t = () => {
                            var r;
                            if (!this.identifierNamesSet.size)
                                throw new Error('Too many identifiers in the code, add more words to identifiers dictionary');
                            const n = this.identifiersIterator.next();
                            if (!n.done) {
                                const i = n.value;
                                return (null !== (r = null == e ? void 0 : e(i)) && void 0 !== r ? r : this.isValidIdentifierName(i)) ? n.value : t();
                            }
                            return this.identifierNamesSet = new Set(this.getIncrementedIdentifierNames([...this.identifierNamesSet])), this.identifiersIterator = this.identifierNamesSet.values(), t();
                        };
                        return t();
                    }
                    getInitialIdentifierNames(e) {
                        const t = e.filter(Boolean).map(e => e.toLowerCase());
                        return this.arrayUtils.shuffle(t);
                    }
                    getIncrementedIdentifierNames(e) {
                        const t = [];
                        for (const r of e) {
                            const e = n.incrementIdentifierName(r);
                            e && t.push(e);
                        }
                        return this.arrayUtils.shuffle(t);
                    }
                };
                d = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IArrayUtils)),
                    a('design:paramtypes', [
                        Object,
                        Object,
                        Object
                    ])
                ], d), t.DictionaryIdentifierNamesGenerator = d;
            },
            2162: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.HexadecimalIdentifierNamesGenerator = void 0;
                const s = r(6594), c = r(2553), u = r(5749), l = r(2303), d = r(1700);
                let p = n = class extends u.AbstractIdentifierNamesGenerator {
                    constructor(e, t) {
                        super(e, t);
                    }
                    generateNext(e) {
                        const t = this.randomGenerator.getRandomInteger(10000, 99999999), r = l.NumberUtils.toHex(t), i = d.Utils.hexadecimalPrefix.length, a = (null != e ? e : n.baseIdentifierNameLength) + i, o = `_${ r.slice(0, a) }`;
                        return this.isValidIdentifierName(o) ? (this.preserveName(o), o) : this.generateNext(e);
                    }
                    generateForGlobalScope(e) {
                        const t = this.generateNext(e);
                        return `${ this.options.identifiersPrefix }${ t }`.replace('__', '_');
                    }
                    generateForLexicalScope(e, t) {
                        return this.generateNext(t);
                    }
                    generateForLabel(e, t) {
                        return this.generateNext(t);
                    }
                };
                p.baseIdentifierNameLength = 6, p = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], p), t.HexadecimalIdentifierNamesGenerator = p;
            },
            9212: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.MangledIdentifierNamesGenerator = void 0;
                const s = r(6594), c = r(2553), u = r(3477), l = r(4287), d = r(6544), p = r(7078), f = r(5749), m = r(8520);
                let h = n = class extends f.AbstractIdentifierNamesGenerator {
                    constructor(e, t, r) {
                        super(e, t), this.lastMangledName = n.initMangledNameCharacter, this.lastMangledNameForScopeMap = new WeakMap(), this.lastMangledNameForLabelMap = new Map(), this.setUtils = r;
                    }
                    generateNext(e) {
                        const t = this.generateNewMangledName(this.lastMangledName);
                        return this.updatePreviousMangledName(t), this.preserveName(t), t;
                    }
                    generateForGlobalScope(e) {
                        const t = this.options.identifiersPrefix ? `${ this.options.identifiersPrefix }` : '', r = this.generateNewMangledName(this.lastMangledName, e => {
                                const r = `${ t }${ e }`;
                                return this.isValidIdentifierName(r);
                            }), n = `${ t }${ r }`;
                        return this.updatePreviousMangledName(r), this.preserveName(n), n;
                    }
                    generateForLexicalScope(e, t) {
                        const r = [
                                e,
                                ...m.NodeLexicalScopeUtils.getLexicalScopes(e)
                            ], n = this.getLastMangledNameForScopes(r), i = this.generateNewMangledName(n, e => this.isValidIdentifierNameInLexicalScopes(e, r));
                        return this.lastMangledNameForScopeMap.set(e, i), this.updatePreviousMangledName(i), this.preserveNameForLexicalScope(i, e), i;
                    }
                    generateForLabel(e, t) {
                        const r = this.getLastMangledNameForLabel(e), n = this.generateNewMangledName(r);
                        return this.updatePreviousMangledNameForLabel(n, e, r), n;
                    }
                    isIncrementedMangledName(e, t) {
                        if (e === t)
                            return !1;
                        const r = e.length, n = t.length;
                        if (r !== n)
                            return r > n;
                        const i = this.getNameSequence();
                        for (let n = 0; n < r; n++) {
                            const r = e[n], a = t[n];
                            if (r !== a)
                                return i.indexOf(r) > i.indexOf(a);
                        }
                        throw new Error('Something goes wrong during comparison of mangled names');
                    }
                    isValidIdentifierName(e) {
                        return super.isValidIdentifierName(e) && !n.reservedNamesSet.has(e);
                    }
                    getNameSequence() {
                        return n.nameSequence;
                    }
                    updatePreviousMangledName(e) {
                        this.isIncrementedMangledName(e, this.lastMangledName) && (this.lastMangledName = e);
                    }
                    updatePreviousMangledNameForLabel(e, t, r) {
                        this.isIncrementedMangledName(e, r) && this.lastMangledNameForLabelMap.set(t, e);
                    }
                    generateNewMangledName(e, t) {
                        var r;
                        const i = (e, t = 0) => {
                            if (t > n.maxRegenerationAttempts) {
                                const e = this.setUtils.getLastElement(this.preservedNamesSet);
                                if (e)
                                    return this.generateNewMangledName(e);
                            }
                            const r = this.getNameSequence(), i = r.length, a = e.length, o = e => '0'.repeat(e);
                            let s = a - 1;
                            do {
                                const t = e[s], n = r.indexOf(t);
                                if (n !== i - 1)
                                    return e.slice(0, s) + r[n + 1] + o(a - (s + 1));
                                --s;
                            } while (s >= 0);
                            return `${ r[d.numbersString.length] }${ o(a) }`;
                        };
                        let a, o = e;
                        do {
                            o = i(o), a = null !== (r = null == t ? void 0 : t(o)) && void 0 !== r ? r : this.isValidIdentifierName(o);
                        } while (!a);
                        return o;
                    }
                    getLastMangledNameForScopes(e) {
                        var t;
                        for (const r of e) {
                            const e = null !== (t = this.lastMangledNameForScopeMap.get(r)) && void 0 !== t ? t : null;
                            if (e)
                                return e;
                        }
                        return n.initMangledNameCharacter;
                    }
                    getLastMangledNameForLabel(e) {
                        var t;
                        const r = null !== (t = this.lastMangledNameForLabelMap.get(e)) && void 0 !== t ? t : null;
                        return null != r ? r : n.initMangledNameCharacter;
                    }
                };
                h.maxRegenerationAttempts = 20, h.initMangledNameCharacter = '9', h.nameSequence = [...`${ d.numbersString }${ u.alphabetString }${ l.alphabetStringUppercase }`], h.reservedNamesSet = new Set(p.reservedIdentifierNames), h = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.ISetUtils)),
                    a('design:paramtypes', [
                        Object,
                        Object,
                        Object
                    ])
                ], h), t.MangledIdentifierNamesGenerator = h;
            },
            5102: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.MangledShuffledIdentifierNamesGenerator = void 0;
                const s = r(6594), c = r(2553), u = r(6544), l = r(3477), d = r(4287), p = r(9212);
                let f = n = class extends p.MangledIdentifierNamesGenerator {
                    constructor(e, t, r, n) {
                        super(t, r, n), this.arrayUtils = e;
                    }
                    initialize() {
                        this.initializeNameSequence([
                            ...`${ u.numbersString }`,
                            ...this.arrayUtils.shuffle([...`${ l.alphabetString }${ d.alphabetStringUppercase }`])
                        ]);
                    }
                    initializeNameSequence(e) {
                        this.getNameSequence() || (n.shuffledNameSequence = e);
                    }
                    getNameSequence() {
                        return n.shuffledNameSequence;
                    }
                };
                i([
                    (0, s.postConstruct)(),
                    a('design:type', Function),
                    a('design:paramtypes', []),
                    a('design:returntype', void 0)
                ], f.prototype, 'initialize', null), f = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IArrayUtils)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.ISetUtils)),
                    a('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], f), t.MangledShuffledIdentifierNamesGenerator = f;
            },
            7702: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    }, s = this && this.__importDefault || function (e) {
                        return e && e.__esModule ? e : { default: e };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.Logger = void 0;
                const c = r(6594), u = r(2553), l = s(r(4061)), d = r(4038);
                let p = n = class {
                    constructor(e) {
                        this.options = e;
                    }
                    static log(e, t, r, n) {
                        const i = e(`\n${ t } ${ r }`);
                        console.log(i, null != n ? n : '');
                    }
                    info(e, t) {
                        this.options.log && n.log(n.colorInfo, d.LoggingPrefix.Base, e, t);
                    }
                    success(e, t) {
                        this.options.log && n.log(n.colorSuccess, d.LoggingPrefix.Base, e, t);
                    }
                    warn(e, t) {
                        this.options.log && n.log(n.colorWarn, d.LoggingPrefix.Base, e, t);
                    }
                };
                p.colorInfo = l.default.cyan, p.colorSuccess = l.default.green, p.colorWarn = l.default.yellow, p = n = i([
                    (0, c.injectable)(),
                    o(0, (0, c.inject)(u.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [Object])
                ], p), t.Logger = p;
            },
            2063: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractNodeTransformer = void 0;
                const o = r(6594), s = r(2553);
                let c = class {
                    constructor(e, t) {
                        this.randomGenerator = e, this.options = t;
                    }
                };
                c = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], c), t.AbstractNodeTransformer = c;
            },
            8521: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                    var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                    if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                        o = Reflect.decorate(e, t, r, n);
                    else
                        for (var s = e.length - 1; s >= 0; s--)
                            (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                    return a > 3 && o && Object.defineProperty(t, r, o), o;
                };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeTransformerNamesGroupsBuilder = void 0;
                const i = r(6594), a = r(576);
                let o = class extends a.AbstractTransformerNamesGroupsBuilder {
                };
                o = n([(0, i.injectable)()], o), t.NodeTransformerNamesGroupsBuilder = o;
            },
            3107: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, o = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    }, s = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, c = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeTransformersRunner = void 0;
                const u = r(6594), l = r(2553), d = o(r(140)), p = r(1155), f = r(8983), m = r(5301);
                let h = class {
                    constructor(e, t) {
                        this.nodeTransformerFactory = e, this.nodeTransformerNamesGroupsBuilder = t;
                    }
                    transform(e, t, r) {
                        if (!t.length)
                            return e;
                        const n = this.buildNormalizedNodeTransformers(t, r), i = this.nodeTransformerNamesGroupsBuilder.build(n);
                        for (const t of i) {
                            const i = [], a = [];
                            for (const e of t) {
                                const t = n[e].getVisitor(r);
                                t && (t.enter && i.push({ enter: t.enter }), t.leave && a.push({ leave: t.leave }));
                            }
                            (i.length || a.length) && d.replace(e, {
                                enter: this.mergeVisitorsForDirection(i, p.VisitorDirection.Enter),
                                leave: this.mergeVisitorsForDirection(a, p.VisitorDirection.Leave)
                            });
                        }
                        return e;
                    }
                    buildNormalizedNodeTransformers(e, t) {
                        return e.reduce((e, r) => {
                            const n = this.nodeTransformerFactory(r);
                            return n.getVisitor(t) ? {
                                ...e,
                                [r]: n
                            } : e;
                        }, {});
                    }
                    mergeVisitorsForDirection(e, t) {
                        const r = e.length;
                        return r ? (n, i) => {
                            if (m.NodeMetadata.isIgnoredNode(n))
                                return d.VisitorOption.Skip;
                            for (let a = 0; a < r; a++) {
                                const r = e[a][t];
                                if (!r)
                                    continue;
                                const o = r(n, i);
                                o && f.NodeGuards.isNode(o) && (n = o);
                            }
                            return n;
                        } : (e, t) => e;
                    }
                };
                h = a([
                    (0, u.injectable)(),
                    c(0, (0, u.inject)(l.ServiceIdentifiers.Factory__INodeTransformer)),
                    c(1, (0, u.inject)(l.ServiceIdentifiers.INodeTransformerNamesGroupsBuilder)),
                    s('design:paramtypes', [
                        Function,
                        Object
                    ])
                ], h), t.NodeTransformersRunner = h;
            },
            9045: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    }, c = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, u = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.BlockStatementControlFlowTransformer = void 0;
                const l = r(6594), d = r(2553), p = s(r(140)), f = r(6517), m = r(780), h = r(2063), g = r(8983), y = r(2815);
                let b = n = class extends h.AbstractNodeTransformer {
                    constructor(e, t, r, n) {
                        super(r, n), this.controlFlowCustomNodeFactory = e, this.arrayUtils = t;
                    }
                    static isProhibitedStatementNode(e) {
                        const t = g.NodeGuards.isBreakStatementNode(e) || g.NodeGuards.isContinueStatementNode(e), r = g.NodeGuards.isVariableDeclarationNode(e) && ('const' === e.kind || 'let' === e.kind), n = g.NodeGuards.isClassDeclarationNode(e);
                        return g.NodeGuards.isFunctionDeclarationNode(e) || t || r || n;
                    }
                    static canTransformBlockStatementNode(e) {
                        let t = !0;
                        return p.traverse(e, {
                            enter: e => {
                                if (g.NodeGuards.isWhileStatementNode(e))
                                    return p.VisitorOption.Skip;
                                n.isProhibitedStatementNode(e) && (t = !1);
                            }
                        }), e.body.length <= 4 && (t = !1), t;
                    }
                    getVisitor(e) {
                        if (!this.options.controlFlowFlattening)
                            return null;
                        switch (e) {
                        case m.NodeTransformationStage.ControlFlowFlattening:
                            return {
                                leave: (e, t) => {
                                    if (t && g.NodeGuards.isBlockStatementNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if (this.randomGenerator.getMathRandom() > this.options.controlFlowFlatteningThreshold || !n.canTransformBlockStatementNode(e))
                            return e;
                        const r = e.body, i = this.arrayUtils.createWithRange(r.length), a = this.arrayUtils.shuffle(i), o = i.map(e => a.indexOf(e)), s = this.controlFlowCustomNodeFactory(f.ControlFlowCustomNode.BlockStatementControlFlowFlatteningNode);
                        s.initialize(r, a, o);
                        const c = s.getNode()[0];
                        return y.NodeUtils.parentizeNode(c, t), c;
                    }
                };
                b = n = o([
                    (0, l.injectable)(),
                    u(0, (0, l.inject)(d.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
                    u(1, (0, l.inject)(d.ServiceIdentifiers.IArrayUtils)),
                    u(2, (0, l.inject)(d.ServiceIdentifiers.IRandomGenerator)),
                    u(3, (0, l.inject)(d.ServiceIdentifiers.IOptions)),
                    c('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], b), t.BlockStatementControlFlowTransformer = b;
            },
            8769: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    }, c = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, u = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.FunctionControlFlowTransformer = void 0;
                const l = r(6594), d = r(2553), p = s(r(140)), f = r(6517), m = r(5739), h = r(7657), g = r(9789), y = r(780), b = r(2063), S = r(8434), v = r(8983), C = r(5301), A = r(3790), _ = r(2815);
                let E = n = class extends b.AbstractNodeTransformer {
                    constructor(e, t, r, n, i) {
                        super(n, i), this.controlFlowReplacersMap = new Map([
                            [
                                g.NodeType.BinaryExpression,
                                m.ControlFlowReplacer.BinaryExpressionControlFlowReplacer
                            ],
                            [
                                g.NodeType.CallExpression,
                                m.ControlFlowReplacer.CallExpressionControlFlowReplacer
                            ],
                            [
                                g.NodeType.LogicalExpression,
                                m.ControlFlowReplacer.LogicalExpressionControlFlowReplacer
                            ],
                            [
                                g.NodeType.Literal,
                                m.ControlFlowReplacer.StringLiteralControlFlowReplacer
                            ]
                        ]), this.controlFlowData = new WeakMap(), this.hostNodesWithControlFlowNode = new WeakMap(), this.visitedFunctionNodes = new WeakSet(), this.controlFlowStorageFactory = e(h.ControlFlowStorage.FunctionControlFlowStorage), this.controlFlowReplacerFactory = t, this.controlFlowCustomNodeFactory = r;
                    }
                    getVisitor(e) {
                        if (!this.options.controlFlowFlattening)
                            return null;
                        switch (e) {
                        case y.NodeTransformationStage.ControlFlowFlattening:
                            return {
                                leave: (e, t) => {
                                    if (t && v.NodeGuards.isFunctionNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if (this.visitedFunctionNodes.add(e), !v.NodeGuards.isBlockStatementNode(e.body))
                            return e;
                        const r = this.getHostNode(e.body), n = this.getControlFlowStorage(r);
                        if (this.transformFunctionBody(e, n), !n.getLength())
                            return e;
                        const i = this.getControlFlowStorageNode(n);
                        return this.appendControlFlowStorageNode(r, i), e;
                    }
                    transformFunctionBody(e, t) {
                        p.replace(e.body, { enter: (r, n) => this.transformFunctionBodyNode(r, n, e, t) });
                    }
                    transformFunctionBodyNode(e, t, r, n) {
                        var i;
                        if (!t || C.NodeMetadata.isIgnoredNode(e) || this.isVisitedFunctionNode(e))
                            return p.VisitorOption.Skip;
                        const a = null !== (i = this.controlFlowReplacersMap.get(e.type)) && void 0 !== i ? i : null;
                        if (!a)
                            return e;
                        if (!this.isAllowedTransformationByThreshold())
                            return e;
                        const o = this.controlFlowReplacerFactory(a).replace(e, t, n);
                        return _.NodeUtils.parentizeNode(o, t), o;
                    }
                    getHostNode(e) {
                        const t = A.NodeStatementUtils.getParentNodesWithStatements(e);
                        return 1 === t.length ? e : (t.pop(), t.length > n.hostNodeSearchMinDepth && t.splice(0, n.hostNodeSearchMinDepth), t.length > n.hostNodeSearchMaxDepth && (t.length = n.hostNodeSearchMaxDepth), this.randomGenerator.getRandomGenerator().pickone(t));
                    }
                    getControlFlowStorage(e) {
                        var t, r;
                        let n;
                        const i = null !== (t = this.controlFlowData.get(e)) && void 0 !== t ? t : null;
                        if (i) {
                            const t = null !== (r = this.hostNodesWithControlFlowNode.get(e)) && void 0 !== r ? r : null;
                            t && S.NodeAppender.remove(e, t), n = i;
                        } else
                            n = this.controlFlowStorageFactory();
                        return this.controlFlowData.set(e, n), n;
                    }
                    getControlFlowStorageNode(e) {
                        const t = this.controlFlowCustomNodeFactory(f.ControlFlowCustomNode.ControlFlowStorageNode);
                        t.initialize(e);
                        const r = t.getNode()[0];
                        if (!v.NodeGuards.isVariableDeclarationNode(r))
                            throw new Error('`controlFlowStorageNode` should contain `VariableDeclaration` node with control flow storage object');
                        return r;
                    }
                    appendControlFlowStorageNode(e, t) {
                        _.NodeUtils.parentizeAst(t), S.NodeAppender.prepend(e, [t]), this.hostNodesWithControlFlowNode.set(e, t);
                    }
                    isVisitedFunctionNode(e) {
                        return v.NodeGuards.isFunctionNode(e) && this.visitedFunctionNodes.has(e);
                    }
                    isAllowedTransformationByThreshold() {
                        return this.randomGenerator.getMathRandom() <= this.options.controlFlowFlatteningThreshold;
                    }
                };
                E.hostNodeSearchMinDepth = 0, E.hostNodeSearchMaxDepth = 2, E = n = o([
                    (0, l.injectable)(),
                    u(0, (0, l.inject)(d.ServiceIdentifiers.Factory__TControlFlowStorage)),
                    u(1, (0, l.inject)(d.ServiceIdentifiers.Factory__IControlFlowReplacer)),
                    u(2, (0, l.inject)(d.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
                    u(3, (0, l.inject)(d.ServiceIdentifiers.IRandomGenerator)),
                    u(4, (0, l.inject)(d.ServiceIdentifiers.IOptions)),
                    c('design:paramtypes', [
                        Function,
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], E), t.FunctionControlFlowTransformer = E;
            },
            4825: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, o = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    }, s = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, c = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayControlFlowTransformer = void 0;
                const u = r(6594), l = r(2553), d = o(r(140)), p = r(5739), f = r(7657), m = r(9789), h = r(780), g = r(6188), y = r(8769), b = r(8983);
                let S = class extends y.FunctionControlFlowTransformer {
                    constructor(e, t, r, n, i) {
                        super(e, t, r, n, i), this.runAfter = [
                            g.NodeTransformer.StringArrayTransformer,
                            g.NodeTransformer.StringArrayRotateFunctionTransformer,
                            g.NodeTransformer.StringArrayScopeCallsWrapperTransformer
                        ], this.controlFlowReplacersMap = new Map([[
                                m.NodeType.Literal,
                                p.ControlFlowReplacer.StringArrayCallControlFlowReplacer
                            ]]), this.controlFlowStorageNodes = new WeakSet(), this.controlFlowStorageFactory = e(f.ControlFlowStorage.StringControlFlowStorage);
                    }
                    getVisitor(e) {
                        if (!this.options.stringArrayCallsTransform)
                            return null;
                        switch (e) {
                        case h.NodeTransformationStage.StringArray:
                            return {
                                leave: (e, t) => {
                                    if (t && b.NodeGuards.isFunctionNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformFunctionBodyNode(e, t, r, n) {
                        return b.NodeGuards.isVariableDeclarationNode(e) && this.controlFlowStorageNodes.has(e) ? d.VisitorOption.Skip : super.transformFunctionBodyNode(e, t, r, n);
                    }
                    getControlFlowStorage(e) {
                        return this.controlFlowStorageFactory();
                    }
                    appendControlFlowStorageNode(e, t) {
                        super.appendControlFlowStorageNode(e, t), this.controlFlowStorageNodes.add(t);
                    }
                    isAllowedTransformationByThreshold() {
                        return this.randomGenerator.getMathRandom() <= this.options.stringArrayCallsTransformThreshold;
                    }
                };
                S = a([
                    (0, u.injectable)(),
                    c(0, (0, u.inject)(l.ServiceIdentifiers.Factory__TControlFlowStorage)),
                    c(1, (0, u.inject)(l.ServiceIdentifiers.Factory__IControlFlowReplacer)),
                    c(2, (0, u.inject)(l.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
                    c(3, (0, u.inject)(l.ServiceIdentifiers.IRandomGenerator)),
                    c(4, (0, u.inject)(l.ServiceIdentifiers.IOptions)),
                    s('design:paramtypes', [
                        Function,
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], S), t.StringArrayControlFlowTransformer = S;
            },
            6110: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractControlFlowReplacer = void 0;
                const o = r(6594), s = r(2553);
                let c = class {
                    constructor(e, t, r, n) {
                        this.replacerDataByControlFlowStorageId = new Map(), this.controlFlowCustomNodeFactory = e, this.identifierNamesGenerator = t(n), this.randomGenerator = r, this.options = n;
                    }
                    generateStorageKey(e) {
                        const t = this.randomGenerator.getRandomString(5);
                        return e.has(t) ? this.generateStorageKey(e) : t;
                    }
                    insertCustomNodeToControlFlowStorage(e, t, r, n) {
                        var i, a;
                        const o = t.getStorageId(), s = null !== (i = this.replacerDataByControlFlowStorageId.get(o)) && void 0 !== i ? i : new Map(), c = null !== (a = s.get(r)) && void 0 !== a ? a : [];
                        if (this.randomGenerator.getMathRandom() < n && c.length)
                            return this.randomGenerator.getRandomGenerator().pickone(c);
                        const u = this.generateStorageKey(t);
                        return c.push(u), s.set(r, c), this.replacerDataByControlFlowStorageId.set(o, s), t.set(u, e), u;
                    }
                };
                c = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], c), t.AbstractControlFlowReplacer = c;
            },
            6800: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.BinaryExpressionControlFlowReplacer = void 0;
                const s = r(6594), c = r(2553), u = r(6517), l = r(7233);
                let d = n = class extends l.ExpressionWithOperatorControlFlowReplacer {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    replace(e, t, r) {
                        const i = e.operator, a = this.controlFlowCustomNodeFactory(u.ControlFlowCustomNode.BinaryExpressionFunctionNode);
                        a.initialize(i);
                        const o = this.insertCustomNodeToControlFlowStorage(a, r, i, n.usingExistingIdentifierChance);
                        return this.getControlFlowStorageCallNode(r.getStorageId(), o, e.left, e.right);
                    }
                };
                d.usingExistingIdentifierChance = 0.5, d = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], d), t.BinaryExpressionControlFlowReplacer = d;
            },
            1766: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CallExpressionControlFlowReplacer = void 0;
                const s = r(6594), c = r(2553), u = r(6517), l = r(6110), d = r(8983);
                let p = n = class extends l.AbstractControlFlowReplacer {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    replace(e, t, r) {
                        const i = e.callee;
                        if (!d.NodeGuards.isIdentifierNode(i))
                            return e;
                        const a = e.arguments.length, o = this.controlFlowCustomNodeFactory(u.ControlFlowCustomNode.CallExpressionFunctionNode), s = e.arguments;
                        o.initialize(s);
                        const c = this.insertCustomNodeToControlFlowStorage(o, r, a, n.usingExistingIdentifierChance);
                        return this.getControlFlowStorageCallNode(r.getStorageId(), c, i, s);
                    }
                    getControlFlowStorageCallNode(e, t, r, n) {
                        const i = this.controlFlowCustomNodeFactory(u.ControlFlowCustomNode.CallExpressionControlFlowStorageCallNode);
                        i.initialize(e, t, r, n);
                        const a = i.getNode()[0];
                        if (!a || !d.NodeGuards.isExpressionStatementNode(a))
                            throw new Error('`controlFlowStorageCallCustomNode.getNode()[0]` should returns array with `ExpressionStatement` node');
                        return a.expression;
                    }
                };
                p.usingExistingIdentifierChance = 0.5, p = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], p), t.CallExpressionControlFlowReplacer = p;
            },
            7233: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ExpressionWithOperatorControlFlowReplacer = void 0;
                const o = r(6594), s = r(2553), c = r(6517), u = r(6110), l = r(8983);
                let d = class extends u.AbstractControlFlowReplacer {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    getControlFlowStorageCallNode(e, t, r, n) {
                        const i = this.controlFlowCustomNodeFactory(c.ControlFlowCustomNode.ExpressionWithOperatorControlFlowStorageCallNode);
                        i.initialize(e, t, r, n);
                        const a = i.getNode()[0];
                        if (!a || !l.NodeGuards.isExpressionStatementNode(a))
                            throw new Error('`controlFlowStorageCallCustomNode.getNode()[0]` should returns array with `ExpressionStatement` node');
                        return a.expression;
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], d), t.ExpressionWithOperatorControlFlowReplacer = d;
            },
            1788: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.LogicalExpressionControlFlowReplacer = void 0;
                const s = r(6594), c = r(2553), u = r(6517), l = r(7233), d = r(8983), p = r(2815);
                let f = n = class extends l.ExpressionWithOperatorControlFlowReplacer {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    replace(e, t, r) {
                        if (this.checkForProhibitedExpressions(e.left, e.right))
                            return e;
                        const i = e.operator, a = this.controlFlowCustomNodeFactory(u.ControlFlowCustomNode.LogicalExpressionFunctionNode);
                        a.initialize(i);
                        const o = this.insertCustomNodeToControlFlowStorage(a, r, i, n.usingExistingIdentifierChance);
                        return this.getControlFlowStorageCallNode(r.getStorageId(), o, e.left, e.right);
                    }
                    checkForProhibitedExpressions(e, t) {
                        return [
                            e,
                            t
                        ].some(e => {
                            let t;
                            return t = d.NodeGuards.isUnaryExpressionNode(e) ? p.NodeUtils.getUnaryExpressionArgumentNode(e) : e, !(d.NodeGuards.isLiteralNode(t) || d.NodeGuards.isIdentifierNode(t) || d.NodeGuards.isObjectExpressionNode(t) || d.NodeGuards.isExpressionStatementNode(t));
                        });
                    }
                };
                f.usingExistingIdentifierChance = 0.5, f = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], f), t.LogicalExpressionControlFlowReplacer = f;
            },
            4149: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayCallControlFlowReplacer = void 0;
                const s = r(6594), c = r(2553), u = r(6517), l = r(6110), d = r(8983), p = r(7586), f = r(5301);
                let m = n = class extends l.AbstractControlFlowReplacer {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    replace(e, t, r) {
                        if (!f.NodeMetadata.isStringArrayCallLiteralNode(e) || !p.NodeLiteralUtils.isNumberLiteralNode(e) && !p.NodeLiteralUtils.isStringLiteralNode(e))
                            return e;
                        const i = e.value, a = this.controlFlowCustomNodeFactory(u.ControlFlowCustomNode.LiteralNode);
                        a.initialize(e);
                        const o = this.insertCustomNodeToControlFlowStorage(a, r, i, n.usingExistingIdentifierChance);
                        return this.getControlFlowStorageCallNode(r.getStorageId(), o);
                    }
                    generateStorageKey(e) {
                        const t = this.identifierNamesGenerator.generateForLabel(e.getStorageId());
                        return e.has(t) ? this.generateStorageKey(e) : t;
                    }
                    getControlFlowStorageCallNode(e, t) {
                        const r = this.controlFlowCustomNodeFactory(u.ControlFlowCustomNode.StringLiteralControlFlowStorageCallNode);
                        r.initialize(e, t);
                        const n = r.getNode()[0];
                        if (!n || !d.NodeGuards.isExpressionStatementNode(n))
                            throw new Error('`controlFlowStorageCallCustomNode.getNode()[0]` should returns array with `ExpressionStatement` node');
                        return n.expression;
                    }
                };
                m.usingExistingIdentifierChance = 0.5, m = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], m), t.StringArrayCallControlFlowReplacer = m;
            },
            2775: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringLiteralControlFlowReplacer = void 0;
                const s = r(6594), c = r(2553), u = r(6517), l = r(6110), d = r(8983), p = r(7586);
                let f = n = class extends l.AbstractControlFlowReplacer {
                    constructor(e, t, r, n) {
                        super(e, t, r, n);
                    }
                    replace(e, t, r) {
                        if (d.NodeGuards.isPropertyNode(t) && t.key === e)
                            return e;
                        if (!p.NodeLiteralUtils.isStringLiteralNode(e) || e.value.length < 3)
                            return e;
                        const i = e.value, a = this.controlFlowCustomNodeFactory(u.ControlFlowCustomNode.LiteralNode);
                        a.initialize(e);
                        const o = this.insertCustomNodeToControlFlowStorage(a, r, i, n.usingExistingIdentifierChance);
                        return this.getControlFlowStorageCallNode(r.getStorageId(), o);
                    }
                    getControlFlowStorageCallNode(e, t) {
                        const r = this.controlFlowCustomNodeFactory(u.ControlFlowCustomNode.StringLiteralControlFlowStorageCallNode);
                        r.initialize(e, t);
                        const n = r.getNode()[0];
                        if (!n || !d.NodeGuards.isExpressionStatementNode(n))
                            throw new Error('`controlFlowStorageCallCustomNode.getNode()[0]` should returns array with `ExpressionStatement` node');
                        return n.expression;
                    }
                };
                f.usingExistingIdentifierChance = 1, f = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Function,
                        Object,
                        Object
                    ])
                ], f), t.StringLiteralControlFlowReplacer = f;
            },
            4425: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.BooleanLiteralTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(2063), l = r(8983), d = r(2815), p = r(9181);
                let f = class extends u.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case c.NodeTransformationStage.Converting:
                            return {
                                enter: (e, t) => {
                                    if (t && l.NodeGuards.isLiteralNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if ('boolean' != typeof e.value)
                            return e;
                        const r = e.value ? this.getTrueUnaryExpressionNode() : this.getFalseUnaryExpressionNode();
                        return d.NodeUtils.parentizeNode(r, t), r;
                    }
                    getTrueUnaryExpressionNode() {
                        return p.NodeFactory.unaryExpressionNode('!', this.getFalseUnaryExpressionNode());
                    }
                    getFalseUnaryExpressionNode() {
                        return p.NodeFactory.unaryExpressionNode('!', p.NodeFactory.arrayExpressionNode());
                    }
                };
                f = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], f), t.BooleanLiteralTransformer = f;
            },
            8317: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ClassFieldTransformer = void 0;
                const s = r(6594), c = r(2553), u = r(780), l = r(2063), d = r(9181), p = r(8983);
                let f = n = class extends l.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case u.NodeTransformationStage.Converting:
                            return {
                                enter: (e, t) => {
                                    if (t && (p.NodeGuards.isMethodDefinitionNode(e) || p.NodeGuards.isPropertyDefinitionNode(e)))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        return p.NodeGuards.isIdentifierNode(e.key) ? this.replaceIdentifierKey(e, e.key) : p.NodeGuards.isLiteralNode(e.key) ? this.replaceLiteralKey(e, e.key) : e;
                    }
                    replaceIdentifierKey(e, t) {
                        return n.ignoredNames.includes(t.name) || e.computed || (e.computed = !0, e.key = d.NodeFactory.literalNode(t.name)), e;
                    }
                    replaceLiteralKey(e, t) {
                        return 'string' != typeof t.value || n.ignoredNames.includes(t.value) || e.computed || (e.computed = !0), e;
                    }
                };
                f.ignoredNames = ['constructor'], f = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], f), t.ClassFieldTransformer = f;
            },
            9947: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ExportSpecifierTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(2063), l = r(8983), d = r(2815);
                let p = class extends u.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case c.NodeTransformationStage.Converting:
                            return {
                                enter: (e, t) => {
                                    if (t && l.NodeGuards.isExportSpecifierNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        return e.local.name === e.exported.name && (e.exported = d.NodeUtils.clone(e.local)), e;
                    }
                };
                p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], p), t.ExportSpecifierTransformer = p;
            },
            1160: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.MemberExpressionTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(2063), l = r(9181), d = r(8983);
                let p = class extends u.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case c.NodeTransformationStage.Converting:
                            return {
                                enter: (e, t) => {
                                    if (t && d.NodeGuards.isMemberExpressionNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if (d.NodeGuards.isIdentifierNode(e.property)) {
                            if (e.computed)
                                return e;
                            e.computed = !0, e.property = l.NodeFactory.literalNode(e.property.name);
                        }
                        return e;
                    }
                };
                p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], p), t.MemberExpressionTransformer = p;
            },
            8962: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NumberLiteralTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(6188), u = r(780), l = r(2063), d = r(9181), p = r(8983), f = r(2303);
                let m = class extends l.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t), this.runAfter = [c.NodeTransformer.NumberToNumericalExpressionTransformer], this.numberLiteralCache = new Map();
                    }
                    getVisitor(e) {
                        switch (e) {
                        case u.NodeTransformationStage.Converting:
                            return {
                                enter: (e, t) => {
                                    if (t && p.NodeGuards.isLiteralNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if ('number' != typeof e.value && 'bigint' != typeof e.value)
                            return e;
                        const r = e.value;
                        let n;
                        return this.numberLiteralCache.has(r) ? n = this.numberLiteralCache.get(r) : (n = f.NumberUtils.isCeil(r) ? f.NumberUtils.toHex(r) : String(r), this.numberLiteralCache.set(r, n)), d.NodeFactory.literalNode(r, n);
                    }
                };
                m = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], m), t.NumberLiteralTransformer = m;
            },
            3827: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NumberToNumericalExpressionTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(2063), l = r(8983), d = r(9181), p = r(9504), f = r(2303), m = r(8472);
                let h = class extends u.AbstractNodeTransformer {
                    constructor(e, t, r) {
                        super(t, r), this.numberNumericalExpressionAnalyzer = e;
                    }
                    getVisitor(e) {
                        if (!this.options.numbersToExpressions)
                            return null;
                        switch (e) {
                        case c.NodeTransformationStage.Converting:
                            return {
                                leave: (e, t) => {
                                    if (t && l.NodeGuards.isLiteralNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if ('number' != typeof e.value)
                            return e;
                        if (l.NodeGuards.isPropertyNode(t) && !t.computed)
                            return e;
                        const r = e.value, [n, i] = f.NumberUtils.extractIntegerAndDecimalParts(r), a = this.numberNumericalExpressionAnalyzer.analyze(n, p.NumberNumericalExpressionAnalyzer.defaultAdditionalPartsCount);
                        return i ? m.NumericalExpressionDataToNodeConverter.convertFloatNumberData(a, i, this.getNumberNumericalExpressionLiteralNode) : m.NumericalExpressionDataToNodeConverter.convertIntegerNumberData(a, this.getNumberNumericalExpressionLiteralNode);
                    }
                    getNumberNumericalExpressionLiteralNode(e, t) {
                        const r = d.NodeFactory.literalNode(e);
                        return t ? r : d.NodeFactory.unaryExpressionNode('-', r);
                    }
                };
                h = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.INumberNumericalExpressionAnalyzer)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Object
                    ])
                ], h), t.NumberToNumericalExpressionTransformer = h;
            },
            3710: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    }, c = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, u = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObjectExpressionKeysTransformer = void 0;
                const l = r(6594), d = r(2553), p = s(r(140)), f = r(780), m = r(547), h = r(2063), g = r(8983), y = r(3790);
                let b = n = class extends h.AbstractNodeTransformer {
                    constructor(e, t, r) {
                        super(t, r), this.objectExpressionExtractorFactory = e;
                    }
                    static isProhibitedObjectExpressionNode(e, t, r) {
                        return n.isReferencedIdentifierName(e, r) || n.isProhibitedArrowFunctionExpression(e, t) || n.isObjectExpressionWithCallExpression(e) || n.isProhibitedSequenceExpression(e, r);
                    }
                    static getReferencedIdentifierName(e) {
                        return g.NodeGuards.isIdentifierNode(e) ? e.name : n.thisIdentifierName;
                    }
                    static isReferencedIdentifierName(e, t) {
                        const r = [];
                        let i = !1, a = !1;
                        return p.traverse(t, {
                            enter: t => {
                                t === e && (a = !0), (g.NodeGuards.isIdentifierNode(t) || g.NodeGuards.isThisExpressionNode(t)) && (a ? r.includes(n.getReferencedIdentifierName(t)) && (i = !0) : r.push(n.getReferencedIdentifierName(t)));
                            },
                            leave: t => {
                                if (t === e)
                                    return a = !1, p.VisitorOption.Break;
                            }
                        }), i;
                    }
                    static isProhibitedArrowFunctionExpression(e, t) {
                        return g.NodeGuards.isArrowFunctionExpressionNode(t) && t.body === e;
                    }
                    static isObjectExpressionWithCallExpression(e) {
                        let t = !1;
                        return p.traverse(e, {
                            enter: e => {
                                if (g.NodeGuards.isCallExpressionNode(e) || g.NodeGuards.isNewExpressionNode(e))
                                    return t = !0, p.VisitorOption.Break;
                            }
                        }), t;
                    }
                    static isProhibitedSequenceExpression(e, t) {
                        return g.NodeGuards.isExpressionStatementNode(t) && g.NodeGuards.isSequenceExpressionNode(t.expression) && t.expression.expressions.some(e => g.NodeGuards.isCallExpressionNode(e) && g.NodeGuards.isSuperNode(e.callee));
                    }
                    getVisitor(e) {
                        if (!this.options.transformObjectKeys)
                            return null;
                        switch (e) {
                        case f.NodeTransformationStage.Converting:
                            return {
                                leave: (e, t) => {
                                    if (t && g.NodeGuards.isObjectExpressionNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if (!e.properties.length)
                            return e;
                        const r = y.NodeStatementUtils.getRootStatementOfNode(e);
                        return n.isProhibitedObjectExpressionNode(e, t, r) ? e : this.applyObjectExpressionKeysExtractorsRecursive(n.objectExpressionExtractorNames, e, r);
                    }
                    applyObjectExpressionKeysExtractorsRecursive(e, t, r) {
                        const n = [...e], i = n.shift();
                        if (!i)
                            return t;
                        const {
                            nodeToReplace: a,
                            objectExpressionHostStatement: o,
                            objectExpressionNode: s
                        } = this.objectExpressionExtractorFactory(i).extract(t, r);
                        return this.applyObjectExpressionKeysExtractorsRecursive(n, s, o), a;
                    }
                };
                b.thisIdentifierName = 'this', b.objectExpressionExtractorNames = [
                    m.ObjectExpressionExtractor.ObjectExpressionToVariableDeclarationExtractor,
                    m.ObjectExpressionExtractor.BasePropertiesExtractor
                ], b = n = o([
                    (0, l.injectable)(),
                    u(0, (0, l.inject)(d.ServiceIdentifiers.Factory__IObjectExpressionExtractor)),
                    u(1, (0, l.inject)(d.ServiceIdentifiers.IRandomGenerator)),
                    u(2, (0, l.inject)(d.ServiceIdentifiers.IOptions)),
                    c('design:paramtypes', [
                        Function,
                        Object,
                        Object
                    ])
                ], b), t.ObjectExpressionKeysTransformer = b;
            },
            7506: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObjectExpressionTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(2063), l = r(9181), d = r(8983);
                let p = class extends u.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case c.NodeTransformationStage.Converting:
                            return {
                                enter: (e, t) => {
                                    if (t && d.NodeGuards.isObjectExpressionNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        return e.properties.forEach(e => {
                            d.NodeGuards.isPropertyNode(e) && e.key && (e.computed ? this.transformComputedProperty(e) : this.transformBaseProperty(e));
                        }), e;
                    }
                    transformComputedProperty(e) {
                        d.NodeGuards.isLiteralNode(e.key) && 'string' == typeof e.key.value && (e.key = l.NodeFactory.literalNode(e.key.value));
                    }
                    transformBaseProperty(e) {
                        e.shorthand && (e.shorthand = !1), d.NodeGuards.isIdentifierNode(e.key) && (e.key = l.NodeFactory.literalNode(e.key.name));
                    }
                };
                p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], p), t.ObjectExpressionTransformer = p;
            },
            3412: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObjectPatternPropertiesTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(2063), l = r(8983), d = r(8520), p = r(2815);
                let f = class extends u.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case c.NodeTransformationStage.Converting:
                            return {
                                enter: (e, t) => {
                                    if (t && l.NodeGuards.isPropertyNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if (!l.NodeGuards.isObjectPatternNode(t) || !e.shorthand)
                            return e;
                        if (!this.options.renameGlobals) {
                            const t = d.NodeLexicalScopeUtils.getLexicalScope(e);
                            if (t && l.NodeGuards.isProgramNode(t))
                                return e;
                        }
                        return e.shorthand = !1, e.value = p.NodeUtils.clone(e.value), p.NodeUtils.parentizeNode(e.value, e), e;
                    }
                };
                f = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], f), t.ObjectPatternPropertiesTransformer = f;
            },
            9662: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    }, c = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, u = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SplitStringTransformer = void 0;
                const l = r(6594), d = r(2553), p = s(r(140)), f = s(r(641)), m = r(6188), h = r(780), g = r(2063), y = r(9181), b = r(8983), S = r(7586), v = r(2815);
                let C = n = class extends g.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t), this.runAfter = [
                            m.NodeTransformer.ObjectExpressionKeysTransformer,
                            m.NodeTransformer.TemplateLiteralTransformer
                        ];
                    }
                    static chunkString(e, t, r) {
                        const n = Math.ceil(t / r), i = [];
                        let a = 0;
                        for (let t = 0; t < n; ++t, a += r)
                            i[t] = f.substr(e, a, r);
                        return i;
                    }
                    getVisitor(e) {
                        if (!this.options.splitStrings)
                            return null;
                        switch (e) {
                        case h.NodeTransformationStage.Converting:
                            return {
                                enter: (e, t) => {
                                    if (t && b.NodeGuards.isLiteralNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if (S.NodeLiteralUtils.isProhibitedLiteralNode(e, t))
                            return e;
                        const r = this.transformLiteralNodeByChunkLength(e, n.firstPassChunkLength), i = p.replace(r, {
                                enter: (e, t) => {
                                    if (b.NodeGuards.isLiteralNode(e))
                                        return this.transformLiteralNodeByChunkLength(e, this.options.splitStringsChunkLength);
                                }
                            });
                        return v.NodeUtils.parentizeNode(i, t), v.NodeUtils.parentizeAst(i), i;
                    }
                    transformLiteralNodeByChunkLength(e, t) {
                        if (!S.NodeLiteralUtils.isStringLiteralNode(e))
                            return e;
                        const r = f.length(e.value);
                        if (t >= r)
                            return e;
                        const i = n.chunkString(e.value, r, t);
                        return this.transformStringChunksToBinaryExpressionNode(i);
                    }
                    transformStringChunksToBinaryExpressionNode(e) {
                        const t = e.shift(), r = e.shift();
                        if (!t || !r)
                            throw new Error('First and second chunks values should not be empty');
                        const n = y.NodeFactory.binaryExpressionNode('+', y.NodeFactory.literalNode(t), y.NodeFactory.literalNode(r));
                        return e.reduce((e, t) => {
                            const r = y.NodeFactory.literalNode(t);
                            return y.NodeFactory.binaryExpressionNode('+', e, r);
                        }, n);
                    }
                };
                C.firstPassChunkLength = 1000, C = n = o([
                    (0, l.injectable)(),
                    u(0, (0, l.inject)(d.ServiceIdentifiers.IRandomGenerator)),
                    u(1, (0, l.inject)(d.ServiceIdentifiers.IOptions)),
                    c('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], C), t.SplitStringTransformer = C;
            },
            8985: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.TemplateLiteralTransformer = void 0;
                const s = r(6594), c = r(2553), u = r(780), l = r(2063), d = r(9181), p = r(8983), f = r(2815);
                let m = n = class extends l.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    static isLiteralNodeWithStringValue(e) {
                        return !!e && p.NodeGuards.isLiteralNode(e) && 'string' == typeof e.value;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case u.NodeTransformationStage.Converting:
                            return {
                                enter: (e, t) => {
                                    if (t && p.NodeGuards.isTemplateLiteralNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        return p.NodeGuards.isTaggedTemplateExpressionNode(t) ? e : this.transformTemplateLiteralNode(e, t);
                    }
                    transformTemplateLiteralNode(e, t) {
                        const r = e.expressions;
                        let i, a = [];
                        if (e.quasis.forEach(e => {
                                if (void 0 === e.value.cooked || null === e.value.cooked)
                                    return;
                                a.push(d.NodeFactory.literalNode(e.value.cooked));
                                const t = r.shift();
                                t && a.push(t);
                            }), a = a.filter(e => !(p.NodeGuards.isLiteralNode(e) && '' === e.value)), n.isLiteralNodeWithStringValue(a[0]) || n.isLiteralNodeWithStringValue(a[1]) || a.unshift(d.NodeFactory.literalNode('')), a.length > 1) {
                            let e = d.NodeFactory.binaryExpressionNode('+', a.shift(), a.shift());
                            a.forEach(t => {
                                e = d.NodeFactory.binaryExpressionNode('+', e, t);
                            }), i = e;
                        } else
                            i = a[0];
                        return f.NodeUtils.parentizeAst(i), f.NodeUtils.parentizeNode(i, t), i;
                    }
                };
                m = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], m), t.TemplateLiteralTransformer = m;
            },
            7412: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.BasePropertiesExtractor = void 0;
                const a = r(6594), o = r(8434), s = r(9181), c = r(8983), u = r(3790), l = r(2815);
                let d = n = class {
                    static getPropertyNodeKeyName(e) {
                        const t = e.key;
                        return !c.NodeGuards.isLiteralNode(t) || 'string' != typeof t.value && 'number' != typeof t.value ? c.NodeGuards.isIdentifierNode(t) ? t.name : null : t.value.toString();
                    }
                    static isProhibitedPropertyNode(e) {
                        return 'init' !== e.kind;
                    }
                    static isProhibitedPattern(e) {
                        return !e || c.NodeGuards.isObjectPatternNode(e) || c.NodeGuards.isArrayPatternNode(e) || c.NodeGuards.isAssignmentPatternNode(e) || c.NodeGuards.isRestElementNode(e);
                    }
                    static shouldCreateLiteralNode(e) {
                        return !e.computed || e.computed && !!e.key && c.NodeGuards.isLiteralNode(e.key);
                    }
                    extract(e, t) {
                        const r = e.parentNode;
                        return r && c.NodeGuards.isVariableDeclaratorNode(r) && c.NodeGuards.isIdentifierNode(r.id) ? this.transformObjectExpressionNode(e, t, r.id) : {
                            nodeToReplace: e,
                            objectExpressionHostStatement: t,
                            objectExpressionNode: e
                        };
                    }
                    transformObjectExpressionNode(e, t, r) {
                        const n = e.properties, [i, a] = this.extractPropertiesToExpressionStatements(n, t, r), s = u.NodeStatementUtils.getScopeOfNode(t);
                        return this.filterExtractedObjectExpressionProperties(e, a), o.NodeAppender.insertAfter(s, i, t), l.NodeUtils.parentizeAst(s), {
                            nodeToReplace: e,
                            objectExpressionHostStatement: t,
                            objectExpressionNode: e
                        };
                    }
                    extractPropertiesToExpressionStatements(e, t, r) {
                        const i = [], a = [];
                        for (let o = e.length - 1; o >= 0; o--) {
                            const u = e[o];
                            if (c.NodeGuards.isSpreadElementNode(u))
                                break;
                            if (n.isProhibitedPropertyNode(u))
                                continue;
                            const l = u.value;
                            if (n.isProhibitedPattern(l))
                                continue;
                            const d = n.getPropertyNodeKeyName(u);
                            if (!d)
                                continue;
                            const p = n.shouldCreateLiteralNode(u) ? s.NodeFactory.literalNode(d) : s.NodeFactory.identifierNode(d), f = s.NodeFactory.memberExpressionNode(r, p, !0), m = s.NodeFactory.expressionStatementNode(s.NodeFactory.assignmentExpressionNode('=', f, l));
                            c.NodeGuards.isObjectExpressionNode(u.value) && this.transformObjectExpressionNode(u.value, t, f), i.unshift(m), a.unshift(o);
                        }
                        return [
                            i,
                            a
                        ];
                    }
                    filterExtractedObjectExpressionProperties(e, t) {
                        e.properties = e.properties.filter((e, r) => !t.includes(r));
                    }
                };
                d = n = i([(0, a.injectable)()], d), t.BasePropertiesExtractor = d;
            },
            618: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObjectExpressionToVariableDeclarationExtractor = void 0;
                const o = r(6594), s = r(2553), c = r(2982), u = r(8434), l = r(8983), d = r(3790), p = r(2815), f = r(8520);
                let m = class {
                    constructor(e) {
                        this.objectExpressionKeysTransformerCustomNodeFactory = e;
                    }
                    extract(e, t) {
                        return this.transformObjectExpressionToVariableDeclaration(e, t);
                    }
                    transformObjectExpressionToVariableDeclaration(e, t) {
                        var r;
                        const n = d.NodeStatementUtils.getScopeOfNode(t), i = l.NodeGuards.isNodeWithLexicalScope(n) ? n : null !== (r = f.NodeLexicalScopeUtils.getLexicalScope(n)) && void 0 !== r ? r : null;
                        if (!i)
                            throw new Error('Cannot find lexical scope node for the host statement node');
                        const a = e.properties, o = this.getObjectExpressionHostNode(i, a), s = [o];
                        return u.NodeAppender.insertBefore(n, s, t), p.NodeUtils.parentizeAst(o), p.NodeUtils.parentizeNode(o, n), {
                            nodeToReplace: this.getObjectExpressionIdentifierNode(o),
                            objectExpressionHostStatement: o,
                            objectExpressionNode: this.getObjectExpressionNode(o)
                        };
                    }
                    getObjectExpressionHostNode(e, t) {
                        const r = this.objectExpressionKeysTransformerCustomNodeFactory(c.ObjectExpressionKeysTransformerCustomNode.ObjectExpressionVariableDeclarationHostNode);
                        r.initialize(e, t);
                        const n = r.getNode()[0];
                        if (!n || !l.NodeGuards.isVariableDeclarationNode(n))
                            throw new Error('`objectExpressionHostCustomNode.getNode()[0]` should returns array with `VariableDeclaration` node');
                        return n;
                    }
                    getObjectExpressionIdentifierNode(e) {
                        const t = e.declarations[0].id;
                        if (!l.NodeGuards.isIdentifierNode(t))
                            throw new Error('`objectExpressionHostNode` should contain `VariableDeclarator` node with `Identifier` id property');
                        return t;
                    }
                    getObjectExpressionNode(e) {
                        var t;
                        const r = null !== (t = e.declarations[0].init) && void 0 !== t ? t : null;
                        if (!r || !l.NodeGuards.isObjectExpressionNode(r))
                            throw new Error('`objectExpressionHostNode` should contain `VariableDeclarator` node with `ObjectExpression` init property');
                        return r;
                    }
                };
                m = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IObjectExpressionKeysTransformerCustomNode)),
                    i('design:paramtypes', [Function])
                ], m), t.ObjectExpressionToVariableDeclarationExtractor = m;
            },
            100: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DeadCodeInjectionIdentifiersTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(2063), l = r(8983);
                let d = class extends u.AbstractNodeTransformer {
                    constructor(e, t, r, n) {
                        super(t, r), this.identifierReplacer = e, this.scopeIdentifiersTraverser = n;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case c.NodeTransformationStage.RenameIdentifiers:
                            return {
                                enter: (e, t) => {
                                    if (t && l.NodeGuards.isProgramNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        return this.scopeIdentifiersTraverser.traverseScopeThroughIdentifiers(e, t, e => {
                            const {
                                reference: t,
                                variableLexicalScopeNode: r
                            } = e;
                            this.transformScopeThroughIdentifiers(t, r);
                        }), e;
                    }
                    transformScopeThroughIdentifiers(e, t) {
                        if (e.resolved)
                            return;
                        const r = e.identifier;
                        this.storeIdentifierName(r, t), this.replaceIdentifierName(r, t, e);
                    }
                    storeIdentifierName(e, t) {
                        this.identifierReplacer.storeLocalName(e, t);
                    }
                    replaceIdentifierName(e, t, r) {
                        const n = this.identifierReplacer.replace(e, t);
                        r.identifier.name = n.name;
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IIdentifierReplacer)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IScopeIdentifiersTraverser)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], d), t.DeadCodeInjectionIdentifiersTransformer = d;
            },
            1718: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    }, c = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, u = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DeadCodeInjectionTransformer = void 0;
                const l = r(6594), d = r(2553), p = s(r(140)), f = r(6782), m = r(6188), h = r(9789), g = r(780), y = r(2063), b = r(9181), S = r(8983), v = r(5301), C = r(3790), A = r(2815);
                let _ = n = class extends y.AbstractNodeTransformer {
                    constructor(e, t, r, n) {
                        super(r, n), this.deadCodeInjectionRootAstHostNodeSet = new WeakSet(), this.collectedBlockStatements = [], this.collectedBlockStatementsTotalLength = 0, this.deadCodeInjectionCustomNodeFactory = e, this.transformersRunner = t;
                    }
                    static isProhibitedNodeInsideCollectedBlockStatement(e) {
                        return S.NodeGuards.isFunctionDeclarationNode(e) || S.NodeGuards.isBreakStatementNode(e) || S.NodeGuards.isContinueStatementNode(e) || S.NodeGuards.isAwaitExpressionNode(e) || S.NodeGuards.isYieldExpressionNode(e) || S.NodeGuards.isSuperNode(e) || S.NodeGuards.isForOfStatementNode(e) && e.await || S.NodeGuards.isPrivateIdentifierNode(e);
                    }
                    static isScopeHoistingFunctionDeclaration(e) {
                        if (!S.NodeGuards.isFunctionDeclarationNode(e))
                            return !1;
                        const t = C.NodeStatementUtils.getScopeOfNode(e), r = S.NodeGuards.isSwitchCaseNode(t) ? t.consequent : t.body, n = r.indexOf(e);
                        if (0 === n)
                            return !1;
                        const i = r.slice(0, n), a = b.NodeFactory.blockStatementNode(i), o = e.id.name;
                        let s = !1;
                        return p.traverse(a, {
                            enter: e => {
                                if (S.NodeGuards.isIdentifierNode(e) && e.name === o)
                                    return s = !0, p.VisitorOption.Break;
                            }
                        }), s;
                    }
                    static isValidCollectedBlockStatementNode(e) {
                        if (!e.body.length)
                            return !1;
                        let t = 0, r = !0;
                        return p.traverse(e, {
                            enter: e => {
                                if (S.NodeGuards.isBlockStatementNode(e) && t++, t > n.maxNestedBlockStatementsCount || n.isProhibitedNodeInsideCollectedBlockStatement(e) || n.isScopeHoistingFunctionDeclaration(e))
                                    return r = !1, p.VisitorOption.Break;
                            }
                        }), r;
                    }
                    static isValidWrappedBlockStatementNode(e, t) {
                        if (v.NodeMetadata.isEvalHostNode(t))
                            return !1;
                        if (!e.body.length)
                            return !1;
                        let r = !0;
                        return p.traverse(e, {
                            enter: e => {
                                if (n.isScopeHoistingFunctionDeclaration(e))
                                    return r = !1, p.VisitorOption.Break;
                            }
                        }), !!r && C.NodeStatementUtils.getParentNodeWithStatements(e).type !== h.NodeType.Program;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case g.NodeTransformationStage.DeadCodeInjection:
                            return {
                                enter: (e, t) => {
                                    if (t && S.NodeGuards.isProgramNode(e))
                                        return this.prepareNode(e, t), e;
                                },
                                leave: (e, t) => {
                                    if (t && S.NodeGuards.isBlockStatementNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        case g.NodeTransformationStage.StringArray:
                            return {
                                enter: (e, t) => {
                                    if (t && this.isDeadCodeInjectionRootAstHostNode(e))
                                        return this.restoreNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    prepareNode(e, t) {
                        p.traverse(e, {
                            enter: e => {
                                if (!S.NodeGuards.isBlockStatementNode(e))
                                    return;
                                const t = A.NodeUtils.clone(e);
                                if (!n.isValidCollectedBlockStatementNode(t))
                                    return;
                                const r = this.makeClonedBlockStatementNodeUnique(t);
                                this.collectedBlockStatements.push(r);
                            }
                        }), this.collectedBlockStatementsTotalLength = this.collectedBlockStatements.length;
                    }
                    transformNode(e, t) {
                        if (!this.collectedBlockStatements.length || this.collectedBlockStatementsTotalLength < n.minCollectedBlockStatementsCount)
                            return p.VisitorOption.Break;
                        if (this.randomGenerator.getMathRandom() > this.options.deadCodeInjectionThreshold || !n.isValidWrappedBlockStatementNode(e, t))
                            return e;
                        const r = this.collectedBlockStatements.length - 1, i = this.randomGenerator.getRandomInteger(0, r), a = this.collectedBlockStatements.splice(i, 1)[0];
                        return a === e ? e : this.replaceBlockStatementNode(e, a, t);
                    }
                    restoreNode(e, t) {
                        const r = e.body[0];
                        if (!S.NodeGuards.isFunctionDeclarationNode(r))
                            throw new Error('Wrong dead code injection root AST host node. Host node should contain `FunctionDeclaration` node');
                        return r.body;
                    }
                    isDeadCodeInjectionRootAstHostNode(e) {
                        const t = S.NodeGuards.isBlockStatementNode(e) && this.deadCodeInjectionRootAstHostNodeSet.has(e);
                        return t && this.deadCodeInjectionRootAstHostNodeSet.delete(e), t;
                    }
                    makeClonedBlockStatementNodeUnique(e) {
                        const t = b.NodeFactory.programNode([b.NodeFactory.expressionStatementNode(b.NodeFactory.functionExpressionNode([], e))]);
                        return A.NodeUtils.parentizeAst(t), A.NodeUtils.parentizeNode(t, t), this.transformersRunner.transform(t, n.transformersToRenameBlockScopeIdentifiers, g.NodeTransformationStage.RenameIdentifiers), e;
                    }
                    replaceBlockStatementNode(e, t, r) {
                        const i = b.NodeFactory.blockStatementNode([b.NodeFactory.functionDeclarationNode(n.deadCodeInjectionRootAstHostNodeName, [], t)]);
                        this.deadCodeInjectionRootAstHostNodeSet.add(i);
                        const a = this.deadCodeInjectionCustomNodeFactory(f.DeadCodeInjectionCustomNode.BlockStatementDeadCodeInjectionNode);
                        a.initialize(e, i);
                        const o = a.getNode()[0];
                        return A.NodeUtils.parentizeNode(o, r), o;
                    }
                };
                _.deadCodeInjectionRootAstHostNodeName = 'deadCodeInjectionRootAstHostNode', _.maxNestedBlockStatementsCount = 4, _.minCollectedBlockStatementsCount = 5, _.transformersToRenameBlockScopeIdentifiers = [
                    m.NodeTransformer.DeadCodeInjectionIdentifiersTransformer,
                    m.NodeTransformer.LabeledStatementTransformer,
                    m.NodeTransformer.ScopeIdentifiersTransformer
                ], _ = n = o([
                    (0, l.injectable)(),
                    u(0, (0, l.inject)(d.ServiceIdentifiers.Factory__IDeadCodeInjectionCustomNode)),
                    u(1, (0, l.inject)(d.ServiceIdentifiers.INodeTransformersRunner)),
                    u(2, (0, l.inject)(d.ServiceIdentifiers.IRandomGenerator)),
                    u(3, (0, l.inject)(d.ServiceIdentifiers.IOptions)),
                    c('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object
                    ])
                ], _), t.DeadCodeInjectionTransformer = _;
            },
            3425: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, o = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    }, s = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, c = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DirectivePlacementTransformer = void 0;
                const u = r(6594), l = r(2553), d = o(r(140)), p = r(780), f = r(6188), m = r(2063), h = r(8434), g = r(8983), y = r(2815);
                let b = class extends m.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t), this.runAfter = [f.NodeTransformer.CustomCodeHelpersTransformer], this.lexicalScopeDirectives = new WeakMap();
                    }
                    getVisitor(e) {
                        switch (e) {
                        case p.NodeTransformationStage.Preparing:
                            return {
                                enter: (e, t) => {
                                    if (t && g.NodeGuards.isNodeWithLexicalScopeStatements(e, t))
                                        return this.analyzeNode(e, t);
                                }
                            };
                        case p.NodeTransformationStage.Finalizing:
                            return {
                                enter: (e, t) => {
                                    if (t && g.NodeGuards.isNodeWithLexicalScopeStatements(e, t))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    analyzeNode(e, t) {
                        var r;
                        if (!g.NodeGuards.isNodeWithLexicalScope(t))
                            return e;
                        const n = null !== (r = e.body[0]) && void 0 !== r ? r : null;
                        return n && g.NodeGuards.isDirectiveNode(n) && this.lexicalScopeDirectives.set(t, n), e;
                    }
                    transformNode(e, t) {
                        if (!g.NodeGuards.isNodeWithLexicalScope(t))
                            return e;
                        const r = this.lexicalScopeDirectives.get(t);
                        if (r) {
                            const t = y.NodeUtils.clone(r);
                            h.NodeAppender.prepend(e, [t]);
                            let n = !1;
                            d.replace(e, { enter: e => n ? d.VisitorOption.Break : e === r ? (n = !0, d.VisitorOption.Remove) : void 0 });
                        }
                        return e;
                    }
                };
                b = a([
                    (0, u.injectable)(),
                    c(0, (0, u.inject)(l.ServiceIdentifiers.IRandomGenerator)),
                    c(1, (0, u.inject)(l.ServiceIdentifiers.IOptions)),
                    s('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], b), t.DirectivePlacementTransformer = b;
            },
            4187: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.EscapeSequenceTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(6188), l = r(2063), d = r(8983), p = r(7586), f = r(9181), m = r(2815);
                let h = class extends l.AbstractNodeTransformer {
                    constructor(e, t, r) {
                        super(e, t), this.runAfter = [u.NodeTransformer.CustomCodeHelpersTransformer], this.escapeSequenceEncoder = r;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case c.NodeTransformationStage.Finalizing:
                            return {
                                enter: (e, t) => {
                                    if (d.NodeGuards.isLiteralNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if (!p.NodeLiteralUtils.isStringLiteralNode(e))
                            return e;
                        const r = this.escapeSequenceEncoder.encode(e.value, this.options.unicodeEscapeSequence), n = f.NodeFactory.literalNode(r);
                        return m.NodeUtils.parentizeNode(n, t), n;
                    }
                };
                h = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IEscapeSequenceEncoder)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Object
                    ])
                ], h), t.EscapeSequenceTransformer = h;
            },
            3836: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    }, c = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, u = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CommentsTransformer = void 0;
                const l = r(6594), d = r(2553), p = s(r(140)), f = r(780), m = r(2063), h = r(2240), g = r(8983);
                let y = n = class extends m.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case f.NodeTransformationStage.Initializing:
                            return {
                                leave: e => {
                                    if (g.NodeGuards.isProgramNode(e))
                                        return this.transformNode(e);
                                }
                            };
                        case f.NodeTransformationStage.Finalizing:
                            return {
                                leave: e => {
                                    if (g.NodeGuards.isProgramNode(e))
                                        return this.filterCommentsOnFinalizingTraverse(e);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e) {
                        var t;
                        if (!(null === (t = (e = this.filterCommentsOnPrimaryTraverse(e)).comments) || void 0 === t ? void 0 : t.length))
                            return e;
                        const r = e.comments.reverse();
                        if (0 === r.length)
                            return e;
                        if (!e.body.length)
                            return e.leadingComments = r, e;
                        let n = !0;
                        return p.traverse(e, {
                            enter: t => {
                                if (t === e)
                                    return;
                                const i = r.findIndex(e => e.range && t.range && e.range[0] < t.range[0]);
                                i >= 0 && ((n ? e : t).leadingComments = r.splice(i, r.length - i).reverse()), n = !1;
                            }
                        }), r.length > 0 && (e.trailingComments = r.reverse()), e;
                    }
                    filterCommentsOnPrimaryTraverse(e) {
                        var t;
                        return e.comments = null === (t = e.comments) || void 0 === t ? void 0 : t.filter(e => this.filterComment(e, !0)), e;
                    }
                    filterCommentsOnFinalizingTraverse(e) {
                        return p.replace(e, {
                            enter: e => {
                                var t, r;
                                return e.leadingComments && (e.leadingComments = null === (t = e.leadingComments) || void 0 === t ? void 0 : t.filter(e => this.filterComment(e, !1))), e.trailingComments && (e.trailingComments = null === (r = e.trailingComments) || void 0 === r ? void 0 : r.filter(e => this.filterComment(e, !1))), e;
                            }
                        }), e;
                    }
                    filterComment(e, t) {
                        return !(!t || !h.ConditionalCommentObfuscatingGuard.isConditionalComment(e)) || n.preservedWords.some(t => e.value.includes(t));
                    }
                };
                y.preservedWords = [
                    '@license',
                    '@preserve'
                ], y = n = o([
                    (0, l.injectable)(),
                    u(0, (0, l.inject)(d.ServiceIdentifiers.IRandomGenerator)),
                    u(1, (0, l.inject)(d.ServiceIdentifiers.IOptions)),
                    c('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], y), t.CommentsTransformer = y;
            },
            9763: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CustomCodeHelpersTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(6188), u = r(780), l = r(2063), d = r(8983);
                let p = class extends l.AbstractNodeTransformer {
                    constructor(e, t, r, n, i) {
                        super(n, i), this.runAfter = [
                            c.NodeTransformer.ParentificationTransformer,
                            c.NodeTransformer.VariablePreserveTransformer
                        ], this.callsGraphData = [], this.callsGraphAnalyzer = e, this.prevailingKindOfVariablesAnalyzer = t, this.customCodeHelperGroupStorage = r;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case u.NodeTransformationStage.Preparing:
                            return {
                                leave: (e, t) => {
                                    if (d.NodeGuards.isProgramNode(e))
                                        return this.prepareNode(e, t), this.appendCustomNodesForPreparingStage(e, t), this.transformNode(e, t);
                                }
                            };
                        default:
                            return { leave: (t, r) => (d.NodeGuards.isProgramNode(t) && this.appendCustomNodesForStage(e, t, r), t) };
                        }
                    }
                    prepareNode(e, t) {
                        this.callsGraphData = this.callsGraphAnalyzer.analyze(e), this.prevailingKindOfVariablesAnalyzer.analyze(e);
                    }
                    transformNode(e, t) {
                        return e;
                    }
                    appendCustomNodesForPreparingStage(e, t) {
                        this.customCodeHelperGroupStorage.getStorage().forEach(t => {
                            var r;
                            t.initialize(), null === (r = t.appendOnPreparingStage) || void 0 === r || r.call(t, e, this.callsGraphData);
                        });
                    }
                    appendCustomNodesForStage(e, t, r) {
                        this.customCodeHelperGroupStorage.getStorage().forEach(r => {
                            var n;
                            null === (n = r[`appendOn${ e }Stage`]) || void 0 === n || n.call(r, t, this.callsGraphData);
                        });
                    }
                };
                p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.ICallsGraphAnalyzer)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IPrevailingKindOfVariablesAnalyzer)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.TCustomNodeGroupStorage)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.CustomCodeHelpersTransformer = p;
            },
            4188: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.EvalCallExpressionTransformer = void 0;
                const s = r(6594), c = r(2553), u = r(6188), l = r(780), d = r(2063), p = r(9181), f = r(8983), m = r(5301), h = r(2815), g = r(6493);
                let y = n = class extends d.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t), this.runAfter = [
                            u.NodeTransformer.EscapeSequenceTransformer,
                            u.NodeTransformer.ParentificationTransformer,
                            u.NodeTransformer.VariablePreserveTransformer
                        ];
                    }
                    static extractEvalStringFromCallExpressionArgument(e) {
                        return f.NodeGuards.isLiteralNode(e) ? n.extractEvalStringFromLiteralNode(e) : f.NodeGuards.isTemplateLiteralNode(e) ? n.extractEvalStringFromTemplateLiteralNode(e) : null;
                    }
                    static extractEvalStringFromLiteralNode(e) {
                        return 'string' == typeof e.value ? e.value : null;
                    }
                    static extractEvalStringFromTemplateLiteralNode(e) {
                        var t;
                        const r = e.quasis;
                        return 1 !== r.length || e.expressions.length ? null : null !== (t = r[0].value.cooked) && void 0 !== t ? t : null;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case l.NodeTransformationStage.Preparing:
                            return {
                                enter: (e, t) => {
                                    if (t)
                                        return this.transformNode(e, t);
                                }
                            };
                        case l.NodeTransformationStage.Finalizing:
                            return {
                                leave: (e, t) => {
                                    if (t)
                                        return this.restoreNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if (!(t && f.NodeGuards.isCallExpressionNode(e) && f.NodeGuards.isIdentifierNode(e.callee) && 'eval' === e.callee.name))
                            return e;
                        const r = e.arguments[0];
                        if (!r)
                            return e;
                        const i = n.extractEvalStringFromCallExpressionArgument(r);
                        if (!i)
                            return e;
                        let a;
                        try {
                            a = h.NodeUtils.convertCodeToStructure(i);
                        } catch (t) {
                            return e;
                        }
                        const o = p.NodeFactory.functionExpressionNode([], p.NodeFactory.blockStatementNode(a));
                        return m.NodeMetadata.set(o, { evalHostNode: !0 }), h.NodeUtils.parentizeAst(o), h.NodeUtils.parentizeNode(o, t), o;
                    }
                    restoreNode(e, t) {
                        if (!this.isEvalRootAstHostNode(e))
                            return e;
                        const r = e.body.body, n = h.NodeUtils.convertStructureToCode(r);
                        return p.NodeFactory.callExpressionNode(p.NodeFactory.identifierNode('eval'), [p.NodeFactory.literalNode(g.StringUtils.escapeJsString(n))]);
                    }
                    isEvalRootAstHostNode(e) {
                        return m.NodeMetadata.isEvalHostNode(e);
                    }
                };
                y = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], y), t.EvalCallExpressionTransformer = y;
            },
            2722: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.MetadataTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(6188), u = r(780), l = r(2063), d = r(8983), p = r(5301);
                let f = class extends l.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t), this.runAfter = [
                            c.NodeTransformer.ParentificationTransformer,
                            c.NodeTransformer.VariablePreserveTransformer
                        ];
                    }
                    getVisitor(e) {
                        switch (e) {
                        case u.NodeTransformationStage.Preparing:
                            return { enter: (e, t) => this.transformNode(e, t) };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        return p.NodeMetadata.set(e, { ignoredNode: !1 }), d.NodeGuards.isLiteralNode(e) && p.NodeMetadata.set(e, { stringArrayCallLiteralNode: !1 }), e;
                    }
                };
                f = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], f), t.MetadataTransformer = f;
            },
            1478: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObfuscatingGuardsTransformer = void 0;
                const s = r(6594), c = r(2553), u = r(6188), l = r(780), d = r(4930), p = r(5181), f = r(2063), m = r(8983), h = r(5301);
                let g = n = class extends f.AbstractNodeTransformer {
                    constructor(e, t, r) {
                        super(t, r), this.runAfter = [
                            u.NodeTransformer.ParentificationTransformer,
                            u.NodeTransformer.VariablePreserveTransformer
                        ], this.obfuscatingGuards = n.obfuscatingGuardsList.map(e);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case l.NodeTransformationStage.Preparing:
                            return { enter: (e, t) => this.transformNode(e, t) };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        const r = this.obfuscatingGuards.map(t => t.check(e));
                        return this.setNodeMetadata(e, r), e;
                    }
                    setNodeMetadata(e, t) {
                        let r = !1, n = !1;
                        t.every(e => e === p.ObfuscatingGuardResult.Transform) || (r = t.includes(p.ObfuscatingGuardResult.ForceTransform), n = !r && t.includes(p.ObfuscatingGuardResult.Ignore)), h.NodeMetadata.set(e, {
                            forceTransformNode: r && !m.NodeGuards.isProgramNode(e),
                            ignoredNode: n && !m.NodeGuards.isProgramNode(e)
                        });
                    }
                };
                g.obfuscatingGuardsList = [
                    d.ObfuscatingGuard.BlackListObfuscatingGuard,
                    d.ObfuscatingGuard.ConditionalCommentObfuscatingGuard,
                    d.ObfuscatingGuard.ForceTransformStringObfuscatingGuard,
                    d.ObfuscatingGuard.IgnoredImportObfuscatingGuard,
                    d.ObfuscatingGuard.ReservedStringObfuscatingGuard
                ], g = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__INodeGuard)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Object,
                        Object
                    ])
                ], g), t.ObfuscatingGuardsTransformer = g;
            },
            6815: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ParentificationTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(2063), l = r(2815);
                let d = class extends u.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case c.NodeTransformationStage.Preparing:
                            return { enter: (e, t) => this.transformNode(e, t) };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        return l.NodeUtils.parentizeNode(e, t);
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], d), t.ParentificationTransformer = d;
            },
            515: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.VariablePreserveTransformer = void 0;
                const o = r(6594), s = r(6188), c = r(2553), u = r(780), l = r(2063), d = r(8983);
                let p = class extends l.AbstractNodeTransformer {
                    constructor(e, t, r, n) {
                        super(t, r), this.runAfter = [s.NodeTransformer.ParentificationTransformer], this.identifierReplacer = e, this.scopeIdentifiersTraverser = n, this.preserveScopeVariableIdentifiers = this.preserveScopeVariableIdentifiers.bind(this);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case u.NodeTransformationStage.Preparing:
                        case u.NodeTransformationStage.Converting:
                        case u.NodeTransformationStage.RenameIdentifiers:
                            return {
                                enter: (e, t) => {
                                    if (t && d.NodeGuards.isProgramNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        return this.scopeIdentifiersTraverser.traverseScopeIdentifiers(e, t, this.preserveScopeVariableIdentifiers), e;
                    }
                    preserveScopeVariableIdentifiers(e) {
                        const {
                            isGlobalDeclaration: t,
                            isBubblingDeclaration: r,
                            variable: n,
                            variableScope: i
                        } = e;
                        for (const e of n.identifiers)
                            t || r ? this.preserveIdentifierNameForRootLexicalScope(e) : this.preserveIdentifierNameForLexicalScope(e, i);
                    }
                    preserveIdentifierNameForRootLexicalScope(e) {
                        this.identifierReplacer.preserveName(e);
                    }
                    preserveIdentifierNameForLexicalScope(e, t) {
                        const r = d.NodeGuards.isNodeWithLexicalScope(t.block) ? t.block : null;
                        r && this.identifierReplacer.preserveNameForLexicalScope(e, r);
                    }
                };
                p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(c.ServiceIdentifiers.IIdentifierReplacer)),
                    a(1, (0, o.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    a(2, (0, o.inject)(c.ServiceIdentifiers.IOptions)),
                    a(3, (0, o.inject)(c.ServiceIdentifiers.IScopeIdentifiersTraverser)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], p), t.VariablePreserveTransformer = p;
            },
            4150: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.BlackListObfuscatingGuard = void 0;
                const o = r(6594), s = r(5181), c = r(8983);
                let u = n = class {
                    constructor() {
                        this.blackListGuardsLength = n.blackListGuards.length;
                    }
                    check(e) {
                        for (let t = 0; t < this.blackListGuardsLength; t++)
                            if (n.blackListGuards[t](e))
                                return s.ObfuscatingGuardResult.Ignore;
                        return s.ObfuscatingGuardResult.Transform;
                    }
                };
                u.blackListGuards = [c.NodeGuards.isDirectiveNode], u = n = i([
                    (0, o.injectable)(),
                    a('design:paramtypes', [])
                ], u), t.BlackListObfuscatingGuard = u;
            },
            2240: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ConditionalCommentObfuscatingGuard = void 0;
                const a = r(6594), o = r(5181), s = r(8983);
                let c = n = class {
                    constructor() {
                        this.obfuscationAllowed = !0;
                    }
                    static isConditionalComment(e) {
                        return n.obfuscationEnableCommentRegExp.test(e.value) || n.obfuscationDisableCommentRegExp.test(e.value);
                    }
                    check(e) {
                        if (s.NodeGuards.isNodeWithComments(e)) {
                            const t = e.leadingComments;
                            t && (this.obfuscationAllowed = this.checkComments(t));
                        }
                        return this.obfuscationAllowed ? o.ObfuscatingGuardResult.Transform : o.ObfuscatingGuardResult.Ignore;
                    }
                    checkComments(e) {
                        const t = e.length;
                        let r = this.obfuscationAllowed;
                        for (let i = 0; i < t; i++) {
                            const t = e[i];
                            n.obfuscationEnableCommentRegExp.test(t.value) ? r = !0 : n.obfuscationDisableCommentRegExp.test(t.value) && (r = !1);
                        }
                        return r;
                    }
                };
                c.obfuscationEnableCommentRegExp = new RegExp('javascript-obfuscator *: *enable'), c.obfuscationDisableCommentRegExp = new RegExp('javascript-obfuscator *: *disable'), c = n = i([(0, a.injectable)()], c), t.ConditionalCommentObfuscatingGuard = c;
            },
            1595: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ForceTransformStringObfuscatingGuard = void 0;
                const o = r(6594), s = r(5181), c = r(2553), u = r(8983);
                let l = class {
                    constructor(e) {
                        this.options = e;
                    }
                    check(e) {
                        return this.options.forceTransformStrings.length && u.NodeGuards.isLiteralNode(e) && 'string' == typeof e.value && this.isForceTransformString(e.value) ? s.ObfuscatingGuardResult.ForceTransform : s.ObfuscatingGuardResult.Transform;
                    }
                    isForceTransformString(e) {
                        return this.options.forceTransformStrings.some(t => null !== new RegExp(t, 'g').exec(e));
                    }
                };
                l = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(c.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [Object])
                ], l), t.ForceTransformStringObfuscatingGuard = l;
            },
            4892: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.IgnoredImportObfuscatingGuard = void 0;
                const s = r(6594), c = r(5181), u = r(2553), l = r(8983);
                let d = n = class {
                    constructor(e) {
                        this.options = e;
                    }
                    static isDynamicImport(e) {
                        return l.NodeGuards.isImportExpressionNode(e);
                    }
                    static isRequireImport(e) {
                        return l.NodeGuards.isCallExpressionNode(e) && l.NodeGuards.isIdentifierNode(e.callee) && 'require' === e.callee.name;
                    }
                    check(e) {
                        return this.options.ignoreImports && (n.isDynamicImport(e) || n.isRequireImport(e)) ? c.ObfuscatingGuardResult.Ignore : c.ObfuscatingGuardResult.Transform;
                    }
                };
                d = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(u.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [Object])
                ], d), t.IgnoredImportObfuscatingGuard = d;
            },
            7189: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ReservedStringObfuscatingGuard = void 0;
                const o = r(6594), s = r(5181), c = r(2553), u = r(8983);
                let l = class {
                    constructor(e) {
                        this.options = e;
                    }
                    check(e) {
                        return this.options.reservedStrings.length && u.NodeGuards.isLiteralNode(e) && 'string' == typeof e.value && this.isReservedString(e.value) ? s.ObfuscatingGuardResult.Ignore : s.ObfuscatingGuardResult.Transform;
                    }
                    isReservedString(e) {
                        return this.options.reservedStrings.some(t => null !== new RegExp(t, 'g').exec(e));
                    }
                };
                l = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(c.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [Object])
                ], l), t.ReservedStringObfuscatingGuard = l;
            },
            6652: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, o = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    }, s = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, c = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.LabeledStatementTransformer = void 0;
                const u = r(6594), l = r(2553), d = o(r(140)), p = r(780), f = r(2063), m = r(8983), h = r(8520);
                let g = class extends f.AbstractNodeTransformer {
                    constructor(e, t, r) {
                        super(t, r), this.identifierReplacer = e;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case p.NodeTransformationStage.RenameIdentifiers:
                            return {
                                enter: (e, t) => {
                                    if (t && m.NodeGuards.isLabeledStatementNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        const r = h.NodeLexicalScopeUtils.getLexicalScope(e);
                        return r ? (this.storeLabeledStatementName(e, r), this.replaceLabeledStatementName(e, r), e) : e;
                    }
                    storeLabeledStatementName(e, t) {
                        this.identifierReplacer.storeLocalName(e.label, t);
                    }
                    replaceLabeledStatementName(e, t) {
                        d.replace(e, {
                            enter: (e, r) => {
                                if (r && m.NodeGuards.isLabelIdentifierNode(e, r)) {
                                    const r = this.identifierReplacer.replace(e, t);
                                    e.name = r.name;
                                }
                            }
                        });
                    }
                };
                g = a([
                    (0, u.injectable)(),
                    c(0, (0, u.inject)(l.ServiceIdentifiers.IIdentifierReplacer)),
                    c(1, (0, u.inject)(l.ServiceIdentifiers.IRandomGenerator)),
                    c(2, (0, u.inject)(l.ServiceIdentifiers.IOptions)),
                    s('design:paramtypes', [
                        Object,
                        Object,
                        Object
                    ])
                ], g), t.LabeledStatementTransformer = g;
            },
            1048: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, o = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    }, s = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, c = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ScopeIdentifiersTransformer = void 0;
                const u = r(6594), l = r(2553), d = o(r(140)), p = r(780), f = r(2063), m = r(8983), h = r(5301);
                let g = class extends f.AbstractNodeTransformer {
                    constructor(e, t, r, n) {
                        super(t, r), this.lexicalScopesWithObjectPatternWithoutDeclarationMap = new WeakMap(), this.identifierReplacer = e, this.scopeIdentifiersTraverser = n;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case p.NodeTransformationStage.RenameIdentifiers:
                            return {
                                enter: (e, t) => {
                                    if (t && m.NodeGuards.isProgramNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        return this.scopeIdentifiersTraverser.traverseScopeIdentifiers(e, t, e => {
                            const {
                                isGlobalDeclaration: t,
                                variable: r,
                                variableLexicalScopeNode: n
                            } = e;
                            (this.options.renameGlobals || !t || r.defs.every(e => 'ImportBinding' === e.type || 'CatchClause' === e.type)) && this.transformScopeVariableIdentifiers(r, n, t);
                        }), e;
                    }
                    transformScopeVariableIdentifiers(e, t, r) {
                        var n;
                        const i = null !== (n = e.identifiers[0]) && void 0 !== n ? n : null;
                        i && this.isReplaceableIdentifierNode(i, t, e) && (this.storeIdentifierName(i, t, r), this.replaceIdentifierName(i, t, e));
                    }
                    storeIdentifierName(e, t, r) {
                        r ? this.identifierReplacer.storeGlobalName(e, t) : this.identifierReplacer.storeLocalName(e, t);
                    }
                    replaceIdentifierName(e, t, r) {
                        const n = this.identifierReplacer.replace(e, t);
                        r.identifiers.forEach(e => {
                            e.name = n.name;
                        }), r.references.forEach(t => {
                            t.identifier.name = e.name;
                        });
                    }
                    isReplaceableIdentifierNode(e, t, r) {
                        const n = e.parentNode;
                        return !(!n || h.NodeMetadata.isIgnoredNode(e) || this.isProhibitedPropertyIdentifierNode(e, n) || this.isProhibitedPropertyAssignmentPatternIdentifierNode(e, n) || this.isProhibitedClassDeclarationNameIdentifierNode(r, e, n) || this.isProhibitedExportNamedClassDeclarationIdentifierNode(e, n) || this.isProhibitedExportNamedFunctionDeclarationIdentifierNode(e, n) || this.isProhibitedExportNamedVariableDeclarationIdentifierNode(e, n) || this.isProhibitedImportSpecifierNode(e, n) || this.isProhibitedVariableNameUsedInObjectPatternNode(r, e, t) || m.NodeGuards.isLabelIdentifierNode(e, n));
                    }
                    isProhibitedClassDeclarationNameIdentifierNode(e, t, r) {
                        return m.NodeGuards.isClassDeclarationNode(e.scope.block) && m.NodeGuards.isClassDeclarationNode(r) && r.id === t;
                    }
                    isProhibitedExportNamedClassDeclarationIdentifierNode(e, t) {
                        return m.NodeGuards.isClassDeclarationNode(t) && t.id === e && !!t.parentNode && m.NodeGuards.isExportNamedDeclarationNode(t.parentNode);
                    }
                    isProhibitedExportNamedFunctionDeclarationIdentifierNode(e, t) {
                        return m.NodeGuards.isFunctionDeclarationNode(t) && t.id === e && !!t.parentNode && m.NodeGuards.isExportNamedDeclarationNode(t.parentNode);
                    }
                    isProhibitedExportNamedVariableDeclarationIdentifierNode(e, t) {
                        return m.NodeGuards.isVariableDeclaratorNode(t) && t.id === e && !!t.parentNode && m.NodeGuards.isVariableDeclarationNode(t.parentNode) && !!t.parentNode.parentNode && m.NodeGuards.isExportNamedDeclarationNode(t.parentNode.parentNode);
                    }
                    isProhibitedImportSpecifierNode(e, t) {
                        return m.NodeGuards.isImportSpecifierNode(t) && t.imported.name === t.local.name;
                    }
                    isProhibitedPropertyIdentifierNode(e, t) {
                        return m.NodeGuards.isPropertyNode(t) && !t.computed && m.NodeGuards.isIdentifierNode(t.key) && m.NodeGuards.isIdentifierNode(e) && t.shorthand && t.key.name === e.name;
                    }
                    isProhibitedPropertyAssignmentPatternIdentifierNode(e, t) {
                        return m.NodeGuards.isAssignmentPatternNode(t) && t.left === e && !!t.parentNode && m.NodeGuards.isPropertyNode(t.parentNode) && m.NodeGuards.isIdentifierNode(t.left) && m.NodeGuards.isIdentifierNode(t.parentNode.key) && t.left.name === t.parentNode.key.name;
                    }
                    isProhibitedVariableNameUsedInObjectPatternNode(e, t, r) {
                        let n = this.lexicalScopesWithObjectPatternWithoutDeclarationMap.get(r);
                        if (!1 === n)
                            return !1;
                        if (!e.defs.some(e => 'var' === e.kind))
                            return !1;
                        let i = !1;
                        return d.traverse(r, {
                            enter: (e, r) => {
                                if (m.NodeGuards.isObjectPatternNode(e) && r && m.NodeGuards.isAssignmentExpressionNode(r)) {
                                    n = !0;
                                    const r = e.properties;
                                    for (const e of r)
                                        if (i = m.NodeGuards.isPropertyNode(e) && !e.computed && e.shorthand && m.NodeGuards.isIdentifierNode(e.key) && t.name === e.key.name, i)
                                            return d.VisitorOption.Break;
                                }
                            }
                        }), this.lexicalScopesWithObjectPatternWithoutDeclarationMap.set(r, null != n && n), i;
                    }
                };
                g = a([
                    (0, u.injectable)(),
                    c(0, (0, u.inject)(l.ServiceIdentifiers.IIdentifierReplacer)),
                    c(1, (0, u.inject)(l.ServiceIdentifiers.IRandomGenerator)),
                    c(2, (0, u.inject)(l.ServiceIdentifiers.IOptions)),
                    c(3, (0, u.inject)(l.ServiceIdentifiers.IScopeIdentifiersTraverser)),
                    s('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], g), t.ScopeIdentifiersTransformer = g;
            },
            502: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ScopeThroughIdentifiersTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(2063), l = r(8983);
                let d = class extends u.AbstractNodeTransformer {
                    constructor(e, t, r, n) {
                        super(r, n), this.throughIdentifierReplacer = e, this.scopeIdentifiersTraverser = t;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case c.NodeTransformationStage.RenameIdentifiers:
                            return {
                                enter: (e, t) => {
                                    if (t && l.NodeGuards.isProgramNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        return this.scopeIdentifiersTraverser.traverseScopeThroughIdentifiers(e, t, e => {
                            const {
                                reference: t,
                                variableLexicalScopeNode: r
                            } = e;
                            this.transformScopeThroughIdentifiers(t, r);
                        }), e;
                    }
                    transformScopeThroughIdentifiers(e, t) {
                        e.resolved || this.replaceIdentifierName(e);
                    }
                    replaceIdentifierName(e) {
                        const t = e.identifier, r = this.throughIdentifierReplacer.replace(t);
                        e.identifier.name = r.name;
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IThroughIdentifierReplacer)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IScopeIdentifiersTraverser)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], d), t.ScopeThroughIdentifiersTransformer = d;
            },
            57: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.IdentifierReplacer = void 0;
                const o = r(6594), s = r(2553), c = r(9181);
                let u = class {
                    constructor(e, t, r) {
                        this.blockScopesMap = new WeakMap(), this.options = r, this.identifierNamesCacheStorage = t, this.identifierNamesGenerator = e(r);
                    }
                    storeGlobalName(e, t) {
                        var r;
                        const n = e.name;
                        if (this.isReservedName(n))
                            return;
                        const i = this.identifierNamesGenerator.generateForGlobalScope(), a = null !== (r = this.blockScopesMap.get(t)) && void 0 !== r ? r : new Map();
                        a.set(n, i), this.blockScopesMap.set(t, a), this.options.identifierNamesCache && this.identifierNamesCacheStorage.set(n, i);
                    }
                    storeLocalName(e, t) {
                        var r;
                        const n = e.name;
                        if (this.isReservedName(n))
                            return;
                        const i = this.identifierNamesGenerator.generateForLexicalScope(t), a = null !== (r = this.blockScopesMap.get(t)) && void 0 !== r ? r : new Map();
                        a.set(n, i), this.blockScopesMap.set(t, a);
                    }
                    replace(e, t) {
                        var r, n;
                        const i = null !== (r = this.blockScopesMap.get(t)) && void 0 !== r ? r : null;
                        if (!i)
                            return e;
                        const a = null !== (n = i.get(e.name)) && void 0 !== n ? n : null;
                        return a ? c.NodeFactory.identifierNode(a) : e;
                    }
                    preserveName(e) {
                        this.identifierNamesGenerator.preserveName(e.name);
                    }
                    preserveNameForLexicalScope(e, t) {
                        this.identifierNamesGenerator.preserveNameForLexicalScope(e.name, t);
                    }
                    isReservedName(e) {
                        return !!this.options.reservedNames.length && this.options.reservedNames.some(t => null !== new RegExp(t, 'g').exec(e));
                    }
                };
                u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IGlobalIdentifierNamesCacheStorage)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Function,
                        Object,
                        Object
                    ])
                ], u), t.IdentifierReplacer = u;
            },
            2204: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ThroughIdentifierReplacer = void 0;
                const o = r(6594), s = r(2553), c = r(9181);
                let u = class {
                    constructor(e, t) {
                        this.identifierNamesCacheStorage = e, this.options = t;
                    }
                    replace(e) {
                        var t;
                        const r = e.name, n = this.options.identifierNamesCache && !this.isReservedName(r) && null !== (t = this.identifierNamesCacheStorage.get(r)) && void 0 !== t ? t : r;
                        return c.NodeFactory.identifierNode(n);
                    }
                    isReservedName(e) {
                        return !!this.options.reservedNames.length && this.options.reservedNames.some(t => null !== new RegExp(t, 'g').exec(e));
                    }
                };
                u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IGlobalIdentifierNamesCacheStorage)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], u), t.ThroughIdentifierReplacer = u;
            },
            7015: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.RenamePropertiesTransformer = void 0;
                const s = r(6594), c = r(2553), u = r(780), l = r(3442), d = r(2063), p = r(8983), f = r(7586), m = r(5301);
                let h = n = class extends d.AbstractNodeTransformer {
                    constructor(e, t, r) {
                        super(t, r), this.renamePropertiesReplacer = e;
                    }
                    static isValidPropertyNode(e, t) {
                        return !p.NodeGuards.isIdentifierNode(t) || !e.computed;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case u.NodeTransformationStage.Preparing:
                            return {
                                enter: (e, t) => {
                                    t && this.prepareNode(e, t);
                                }
                            };
                        case u.NodeTransformationStage.RenameProperties:
                            return {
                                enter: (e, t) => {
                                    if (t)
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    prepareNode(e, t) {
                        p.NodeGuards.isPropertyNode(t) && t.key === e || p.NodeGuards.isMemberExpressionNode(t) && t.property === e || p.NodeGuards.isMethodDefinitionNode(t) && t.key === e || p.NodeGuards.isPropertyDefinitionNode(t) && t.key === e ? m.NodeMetadata.set(e, { propertyKeyToRenameNode: !0 }) : this.options.renamePropertiesMode === l.RenamePropertiesMode.Safe && this.analyzeAutoExcludedPropertyNames(e, t);
                    }
                    transformNode(e, t) {
                        if (!p.NodeGuards.isIdentifierNode(e) && !p.NodeGuards.isLiteralNode(e))
                            return e;
                        if (!m.NodeMetadata.isPropertyKeyToRenameNode(e))
                            return e;
                        const r = p.NodeGuards.isPropertyNode(t);
                        return (r || p.NodeGuards.isPropertyDefinitionNode(t) || p.NodeGuards.isMemberExpressionNode(t) || p.NodeGuards.isMethodDefinitionNode(t)) && !n.isValidPropertyNode(t, e) ? e : (r && (t.shorthand = !1), this.renamePropertiesReplacer.replace(e));
                    }
                    analyzeAutoExcludedPropertyNames(e, t) {
                        p.NodeGuards.isLiteralNode(e) && f.NodeLiteralUtils.isStringLiteralNode(e) && this.renamePropertiesReplacer.excludePropertyName(e.value);
                    }
                };
                h = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IRenamePropertiesReplacer)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Object,
                        Object,
                        Object
                    ])
                ], h), t.RenamePropertiesTransformer = h;
            },
            9320: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    }, s = this && this.__importDefault || function (e) {
                        return e && e.__esModule ? e : { default: e };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.RenamePropertiesReplacer = void 0;
                const c = r(6594), u = r(2553), l = s(r(9854)), d = r(8983), p = r(9181);
                let f = n = class {
                    constructor(e, t, r) {
                        this.excludedPropertyNames = new Set(), this.propertyNamesMap = new Map(), this.identifierNamesGenerator = e(r), this.propertyIdentifierNamesCacheStorage = t, this.options = r;
                    }
                    excludePropertyName(e) {
                        this.excludedPropertyNames.add(e);
                    }
                    replace(e) {
                        return d.NodeGuards.isIdentifierNode(e) ? p.NodeFactory.identifierNode(this.replacePropertyName(e.name)) : d.NodeGuards.isLiteralNode(e) && 'string' == typeof e.value ? p.NodeFactory.literalNode(this.replacePropertyName(e.value)) : e;
                    }
                    replacePropertyName(e) {
                        var t, r;
                        if (this.isReservedName(e))
                            return this.identifierNamesGenerator.preserveName(e), e;
                        let n = this.options.identifierNamesCache && null !== (t = this.propertyIdentifierNamesCacheStorage.get(e)) && void 0 !== t ? t : null;
                        return n = null !== (r = null != n ? n : this.propertyNamesMap.get(e)) && void 0 !== r ? r : null, null !== n || (n = this.identifierNamesGenerator.generateNext(), this.propertyNamesMap.set(e, n), this.options.identifierNamesCache && this.propertyIdentifierNamesCacheStorage.set(e, n)), n;
                    }
                    isReservedName(e) {
                        return this.isExcludedName(e) || this.isReservedOptionName(e) || this.isReservedDomPropertyName(e);
                    }
                    isExcludedName(e) {
                        return this.excludedPropertyNames.has(e);
                    }
                    isReservedOptionName(e) {
                        return !!this.options.reservedNames.length && this.options.reservedNames.some(t => null !== new RegExp(t, 'g').exec(e));
                    }
                    isReservedDomPropertyName(e) {
                        return n.reservedDomPropertiesList.has(e);
                    }
                };
                f.reservedDomPropertiesList = new Set(l.default), f = n = i([
                    (0, c.injectable)(),
                    o(0, (0, c.inject)(u.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(1, (0, c.inject)(u.ServiceIdentifiers.IPropertyIdentifierNamesCacheStorage)),
                    o(2, (0, c.inject)(u.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Object,
                        Object
                    ])
                ], f), t.RenamePropertiesReplacer = f;
            },
            743: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractStatementSimplifyTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(6188), u = r(2063), l = r(8983), d = r(9181);
                let p = class extends u.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t), this.runAfter = [
                            c.NodeTransformer.ExpressionStatementsMergeTransformer,
                            c.NodeTransformer.VariableDeclarationsMergeTransformer
                        ];
                    }
                    getStatementSimplifyData(e) {
                        if (!e)
                            return null;
                        if (!l.NodeGuards.isBlockStatementNode(e))
                            return {
                                leadingStatements: [e],
                                trailingStatement: null,
                                hasReturnStatement: !1,
                                hasSingleExpression: !1
                            };
                        const {
                            startIndex: t,
                            unwrappedExpressions: r,
                            hasReturnStatement: n,
                            hasStatementsAfterReturnStatement: i
                        } = this.collectIteratedStatementsSimplifyData(e);
                        if (i)
                            return {
                                leadingStatements: e.body,
                                trailingStatement: null,
                                hasReturnStatement: !1,
                                hasSingleExpression: !1
                            };
                        const a = this.getLeadingStatements(e, t);
                        if (!r.length)
                            return {
                                leadingStatements: a,
                                trailingStatement: null,
                                hasReturnStatement: n,
                                hasSingleExpression: !1
                            };
                        const o = 1 === r.length, s = o ? r[0] : d.NodeFactory.sequenceExpressionNode(r);
                        return {
                            leadingStatements: a,
                            trailingStatement: {
                                statement: n ? d.NodeFactory.returnStatementNode(s) : d.NodeFactory.expressionStatementNode(s),
                                expression: s
                            },
                            hasReturnStatement: n,
                            hasSingleExpression: o
                        };
                    }
                    collectIteratedStatementsSimplifyData(e) {
                        const t = e.body.length, r = [];
                        let n = !1, i = !1, a = null;
                        for (let o = t - 1; o >= 0; o--) {
                            const s = e.body[o];
                            if (l.NodeGuards.isExpressionStatementNode(s))
                                l.NodeGuards.isSequenceExpressionNode(s.expression) ? r.unshift(...s.expression.expressions) : r.unshift(s.expression), a = o;
                            else {
                                if (!l.NodeGuards.isReturnStatementNode(s) || !s.argument)
                                    break;
                                r.unshift(s.argument), n = !0, i = o !== t - 1, a = o;
                            }
                        }
                        return {
                            startIndex: a,
                            unwrappedExpressions: r,
                            hasReturnStatement: n,
                            hasStatementsAfterReturnStatement: i
                        };
                    }
                    getLeadingStatements(e, t) {
                        return null === t ? e.body : 0 === t ? [] : e.body.slice(0, t);
                    }
                    getPartialStatement(e) {
                        return !e.leadingStatements.length && e.trailingStatement ? e.trailingStatement.statement : d.NodeFactory.blockStatementNode([
                            ...e.leadingStatements.length ? e.leadingStatements : [],
                            ...e.trailingStatement ? [e.trailingStatement.statement] : []
                        ]);
                    }
                };
                p = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], p), t.AbstractStatementSimplifyTransformer = p;
            },
            7596: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.BlockStatementSimplifyTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(6188), u = r(780), l = r(743), d = r(8983), p = r(9181), f = r(2815);
                let m = class extends l.AbstractStatementSimplifyTransformer {
                    constructor(e, t) {
                        super(e, t), this.runAfter = [c.NodeTransformer.VariableDeclarationsMergeTransformer];
                    }
                    getVisitor(e) {
                        switch (e) {
                        case u.NodeTransformationStage.Simplifying:
                            return {
                                leave: (e, t) => {
                                    if (t && d.NodeGuards.isBlockStatementNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        const r = this.getStatementSimplifyData(e);
                        if (!r)
                            return e;
                        const n = this.getPartialStatement(r), i = d.NodeGuards.isBlockStatementNode(n) ? n : p.NodeFactory.blockStatementNode([n]);
                        return f.NodeUtils.parentizeNode(i, t);
                    }
                };
                m = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], m), t.BlockStatementSimplifyTransformer = m;
            },
            7615: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, o = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    }, s = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, c = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ExpressionStatementsMergeTransformer = void 0;
                const u = r(6594), l = r(2553), d = o(r(140)), p = r(780), f = r(2063), m = r(9181), h = r(8983), g = r(3790), y = r(2815);
                let b = class extends f.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case p.NodeTransformationStage.Simplifying:
                            return {
                                leave: (e, t) => {
                                    if (t && h.NodeGuards.isExpressionStatementNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if (!h.NodeGuards.isNodeWithStatements(t))
                            return e;
                        const r = g.NodeStatementUtils.getPreviousSiblingStatement(e);
                        return r && h.NodeGuards.isExpressionStatementNode(r) ? (h.NodeGuards.isSequenceExpressionNode(r.expression) ? (r.expression.expressions.push(e.expression), y.NodeUtils.parentizeNode(e.expression, r.expression)) : (r.expression = m.NodeFactory.sequenceExpressionNode([
                            r.expression,
                            e.expression
                        ]), y.NodeUtils.parentizeAst(r.expression), y.NodeUtils.parentizeNode(r.expression, r)), d.VisitorOption.Remove) : e;
                    }
                };
                b = a([
                    (0, u.injectable)(),
                    c(0, (0, u.inject)(l.ServiceIdentifiers.IRandomGenerator)),
                    c(1, (0, u.inject)(l.ServiceIdentifiers.IOptions)),
                    s('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], b), t.ExpressionStatementsMergeTransformer = b;
            },
            942: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.IfStatementSimplifyTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(780), u = r(743), l = r(8983), d = r(9181), p = r(2815);
                let f = class extends u.AbstractStatementSimplifyTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case c.NodeTransformationStage.Simplifying:
                            return {
                                leave: (e, t) => {
                                    if (t && l.NodeGuards.isIfStatementNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        const r = this.getStatementSimplifyData(e.consequent);
                        if (!r)
                            return e;
                        let n;
                        if (e.alternate) {
                            const t = this.getStatementSimplifyData(e.alternate);
                            if (!t)
                                return e;
                            n = this.getConsequentAndAlternateNode(e, r, t);
                        } else
                            n = this.getConsequentNode(e, r);
                        return p.NodeUtils.parentizeNode(n, t);
                    }
                    getConsequentNode(e, t) {
                        return t.leadingStatements.length || !t.trailingStatement ? d.NodeFactory.ifStatementNode(e.test, this.getPartialStatement(t)) : t.hasReturnStatement ? d.NodeFactory.ifStatementNode(e.test, t.trailingStatement.statement) : d.NodeFactory.expressionStatementNode(d.NodeFactory.logicalExpressionNode('&&', e.test, t.trailingStatement.expression));
                    }
                    getConsequentAndAlternateNode(e, t, r) {
                        return t.leadingStatements.length || r.leadingStatements.length || !t.trailingStatement || !r.trailingStatement ? d.NodeFactory.ifStatementNode(e.test, this.getPartialStatement(t), this.getPartialStatement(r)) : t.hasReturnStatement && r.hasReturnStatement ? d.NodeFactory.returnStatementNode(d.NodeFactory.conditionalExpressionNode(e.test, t.trailingStatement.expression, r.trailingStatement.expression)) : t.hasReturnStatement || r.hasReturnStatement ? d.NodeFactory.ifStatementNode(e.test, t.trailingStatement.statement, r.trailingStatement.statement) : d.NodeFactory.expressionStatementNode(d.NodeFactory.conditionalExpressionNode(e.test, t.trailingStatement.expression, r.trailingStatement.expression));
                    }
                    getPartialStatement(e) {
                        const t = super.getPartialStatement(e);
                        return l.NodeGuards.isBlockStatementNode(t) ? 1 !== t.body.length || this.isProhibitedSingleStatementForIfStatementBranch(t.body[0]) ? t : t.body[0] : t;
                    }
                    isProhibitedSingleStatementForIfStatementBranch(e) {
                        return l.NodeGuards.isFunctionDeclarationNode(e) || l.NodeGuards.isIfStatementNode(e) || l.NodeGuards.isNodeWithSingleStatementBody(e) || l.NodeGuards.isVariableDeclarationNode(e) && 'var' !== e.kind;
                    }
                };
                f = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], f), t.IfStatementSimplifyTransformer = f;
            },
            5805: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, o = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    }, s = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, c = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.VariableDeclarationsMergeTransformer = void 0;
                const u = r(6594), l = r(2553), d = o(r(140)), p = r(780), f = r(2063), m = r(8983), h = r(3790);
                let g = class extends f.AbstractNodeTransformer {
                    constructor(e, t) {
                        super(e, t);
                    }
                    getVisitor(e) {
                        switch (e) {
                        case p.NodeTransformationStage.Simplifying:
                            return {
                                leave: (e, t) => {
                                    if (t && m.NodeGuards.isVariableDeclarationNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e, t) {
                        if (!m.NodeGuards.isNodeWithStatements(t))
                            return e;
                        const r = h.NodeStatementUtils.getPreviousSiblingStatement(e);
                        return r && m.NodeGuards.isVariableDeclarationNode(r) ? e.kind !== r.kind ? e : (r.declarations.push(...e.declarations), d.VisitorOption.Remove) : e;
                    }
                };
                g = a([
                    (0, u.injectable)(),
                    c(0, (0, u.inject)(l.ServiceIdentifiers.IRandomGenerator)),
                    c(1, (0, u.inject)(l.ServiceIdentifiers.IOptions)),
                    s('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], g), t.VariableDeclarationsMergeTransformer = g;
            },
            1903: function (e, t, r) {
                'use strict';
                var n, i = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), o = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, s = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                        return a(t, e), t;
                    }, c = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, u = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayRotateFunctionTransformer = void 0;
                const l = r(6594), d = r(2553), p = s(r(140)), f = r(8547), m = r(780), h = r(2063), g = r(8434), y = r(8983), b = r(9181), S = r(7586), v = r(5301), C = r(6188), A = r(2815), _ = r(8472);
                let E = n = class extends h.AbstractNodeTransformer {
                    constructor(e, t, r, n, i, a, o) {
                        super(e, t), this.stringArrayStorage = n, this.stringArrayStorageAnalyzer = i, this.transformersRunner = r, this.customCodeHelperFactory = a, this.numberNumericalExpressionAnalyzer = o;
                    }
                    static isProgramNodeHasStringLiterals(e) {
                        let t = !1;
                        return p.traverse(e, {
                            enter: e => {
                                if (y.NodeGuards.isLiteralNode(e) && S.NodeLiteralUtils.isStringLiteralNode(e))
                                    return t = !0, p.VisitorOption.Break;
                            }
                        }), t;
                    }
                    getVisitor(e) {
                        if (!this.options.stringArrayRotate)
                            return null;
                        switch (e) {
                        case m.NodeTransformationStage.StringArray:
                            return { enter: e => y.NodeGuards.isProgramNode(e) ? n.isProgramNodeHasStringLiterals(e) ? this.transformNode(e) : p.VisitorOption.Break : e };
                        default:
                            return null;
                        }
                    }
                    transformNode(e) {
                        const t = this.getStringArrayRotateFunctionNode(), r = b.NodeFactory.programNode([t]);
                        A.NodeUtils.parentizeAst(r);
                        const i = [
                            m.NodeTransformationStage.Preparing,
                            m.NodeTransformationStage.Converting,
                            m.NodeTransformationStage.RenameIdentifiers,
                            m.NodeTransformationStage.Finalizing
                        ];
                        for (const e of i)
                            this.transformersRunner.transform(r, n.stringArrayRotateFunctionTransformers, e);
                        return p.traverse(r, {
                            enter: e => {
                                y.NodeGuards.isLiteralNode(e) && S.NodeLiteralUtils.isStringLiteralNode(e) && (this.isComparisonExpressionStringLiteralNode(e) ? this.stringArrayStorageAnalyzer.addItemDataForLiteralNode(e) : v.NodeMetadata.set(e, { ignoredNode: !0 }));
                            }
                        }), g.NodeAppender.prepend(e, [t]), e;
                    }
                    getStringArrayRotateFunctionNode() {
                        const e = this.getComparisonValue(), t = this.numberNumericalExpressionAnalyzer.analyze(e, n.comparisonExpressionAdditionalPartsCount);
                        let r = 1;
                        const i = _.NumericalExpressionDataToNodeConverter.convertIntegerNumberData(t, (e, t) => {
                                const n = e * r, i = b.NodeFactory.literalNode(`${ n }${ this.randomGenerator.getRandomString(6) }`), a = b.NodeFactory.callExpressionNode(b.NodeFactory.identifierNode('parseInt'), [i]), o = b.NodeFactory.binaryExpressionNode('/', t ? a : b.NodeFactory.unaryExpressionNode('-', a), b.NodeFactory.literalNode(r, r.toString()));
                                return r++, o;
                            }), a = this.customCodeHelperFactory(f.CustomCodeHelper.StringArrayRotateFunction);
                        return a.initialize(this.stringArrayStorage.getStorageName(), e, i), a.getNode()[0];
                    }
                    isComparisonExpressionStringLiteralNode(e) {
                        return /\d/.test(e.value);
                    }
                    getComparisonValue() {
                        return this.randomGenerator.getRandomInteger(100000, 1000000);
                    }
                };
                E.stringArrayRotateFunctionTransformers = [
                    C.NodeTransformer.BooleanLiteralTransformer,
                    C.NodeTransformer.MemberExpressionTransformer,
                    C.NodeTransformer.NumberLiteralTransformer,
                    C.NodeTransformer.NumberToNumericalExpressionTransformer,
                    C.NodeTransformer.ParentificationTransformer,
                    C.NodeTransformer.ScopeIdentifiersTransformer
                ], E.comparisonExpressionAdditionalPartsCount = 7, E = n = o([
                    (0, l.injectable)(),
                    u(0, (0, l.inject)(d.ServiceIdentifiers.IRandomGenerator)),
                    u(1, (0, l.inject)(d.ServiceIdentifiers.IOptions)),
                    u(2, (0, l.inject)(d.ServiceIdentifiers.INodeTransformersRunner)),
                    u(3, (0, l.inject)(d.ServiceIdentifiers.IStringArrayStorage)),
                    u(4, (0, l.inject)(d.ServiceIdentifiers.IStringArrayStorageAnalyzer)),
                    u(5, (0, l.inject)(d.ServiceIdentifiers.Factory__ICustomCodeHelper)),
                    u(6, (0, l.inject)(d.ServiceIdentifiers.INumberNumericalExpressionAnalyzer)),
                    c('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Object,
                        Object,
                        Function,
                        Object
                    ])
                ], E), t.StringArrayRotateFunctionTransformer = E;
            },
            9720: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayScopeCallsWrapperTransformer = void 0;
                const o = r(6594), s = r(2553), c = r(6188), u = r(780), l = r(3627), d = r(679), p = r(2063), f = r(8434), m = r(8983);
                let h = class extends p.AbstractNodeTransformer {
                    constructor(e, t, r, n, i, a) {
                        super(e, t), this.runAfter = [c.NodeTransformer.StringArrayRotateFunctionTransformer], this.visitedLexicalScopeNodesStackStorage = r, this.stringArrayStorage = n, this.stringArrayScopeCallsWrappersDataStorage = i, this.stringArrayTransformerCustomNodeFactory = a;
                    }
                    getVisitor(e) {
                        if (!this.options.stringArrayWrappersCount)
                            return null;
                        switch (e) {
                        case u.NodeTransformationStage.StringArray:
                            return {
                                enter: (e, t) => {
                                    t && m.NodeGuards.isNodeWithLexicalScopeStatements(e, t) && this.onLexicalScopeNodeEnter(e);
                                },
                                leave: (e, t) => {
                                    if (t && m.NodeGuards.isNodeWithLexicalScopeStatements(e, t))
                                        return this.onLexicalScopeNodeLeave(), this.transformNode(e);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    transformNode(e) {
                        var t;
                        const r = null !== (t = this.stringArrayScopeCallsWrappersDataStorage.get(e)) && void 0 !== t ? t : null;
                        if (!r)
                            return e;
                        const n = Object.values(r);
                        for (const t of n) {
                            if (!t)
                                continue;
                            const {scopeCallsWrappersData: r} = t;
                            for (let n = r.length - 1; n >= 0; n--) {
                                const i = r[n], a = this.getUpperStringArrayCallsWrapperData(t);
                                this.getAndAppendStringArrayScopeCallsWrapperNode(e, i, a);
                            }
                        }
                        return e;
                    }
                    getRootStringArrayCallsWrapperData(e) {
                        const {encoding: t} = e;
                        return {
                            name: this.stringArrayStorage.getStorageCallsWrapperName(t),
                            index: 0,
                            parameterIndexesData: null
                        };
                    }
                    getUpperStringArrayCallsWrapperData(e) {
                        var t, r, n, i;
                        const {encoding: a} = e, o = this.getRootStringArrayCallsWrapperData(e);
                        if (!this.options.stringArrayWrappersChainedCalls)
                            return o;
                        const s = null !== (t = this.visitedLexicalScopeNodesStackStorage.getLastElement()) && void 0 !== t ? t : null;
                        if (!s)
                            return o;
                        const c = null !== (r = this.stringArrayScopeCallsWrappersDataStorage.get(s)) && void 0 !== r ? r : null, u = null !== (i = null === (n = null == c ? void 0 : c[a]) || void 0 === n ? void 0 : n.scopeCallsWrappersData) && void 0 !== i ? i : null;
                        return (null == u ? void 0 : u.length) ? this.randomGenerator.getRandomGenerator().pickone(u) : o;
                    }
                    getAndAppendStringArrayScopeCallsWrapperNode(e, t, r) {
                        let n;
                        switch (this.options.stringArrayWrappersType) {
                        case d.StringArrayWrappersType.Function: {
                                const i = this.randomGenerator.getRandomInteger(0, e.body.length - 1);
                                n = this.getStringArrayScopeCallsWrapperFunctionNode(t, r), f.NodeAppender.insertAtIndex(e, n, i);
                                break;
                            }
                        case d.StringArrayWrappersType.Variable:
                        default:
                            n = this.getStringArrayScopeCallsWrapperVariableNode(t, r), f.NodeAppender.prepend(e, n);
                        }
                    }
                    getStringArrayScopeCallsWrapperVariableNode(e, t) {
                        const r = this.stringArrayTransformerCustomNodeFactory(l.StringArrayCustomNode.StringArrayScopeCallsWrapperVariableNode);
                        return r.initialize(e, t), r.getNode();
                    }
                    getStringArrayScopeCallsWrapperFunctionNode(e, t) {
                        const r = this.stringArrayTransformerCustomNodeFactory(l.StringArrayCustomNode.StringArrayScopeCallsWrapperFunctionNode);
                        return r.initialize(e, t), r.getNode();
                    }
                    onLexicalScopeNodeEnter(e) {
                        this.visitedLexicalScopeNodesStackStorage.push(e);
                    }
                    onLexicalScopeNodeLeave() {
                        this.visitedLexicalScopeNodesStackStorage.pop();
                    }
                };
                h = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IVisitedLexicalScopeNodesStackStorage)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IStringArrayStorage)),
                    a(4, (0, o.inject)(s.ServiceIdentifiers.IStringArrayScopeCallsWrappersDataStorage)),
                    a(5, (0, o.inject)(s.ServiceIdentifiers.Factory__IStringArrayCustomNode)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Object,
                        Object,
                        Function
                    ])
                ], h), t.StringArrayScopeCallsWrapperTransformer = h;
            },
            8033: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayTransformer = void 0;
                const s = r(6594), c = r(2553), u = r(6188), l = r(780), d = r(3627), p = r(679), f = r(2063), m = r(8983), h = r(7586), g = r(5301), y = r(2815);
                let b = n = class extends f.AbstractNodeTransformer {
                    constructor(e, t, r, n, i, a, o, s, c) {
                        super(e, t), this.runAfter = [u.NodeTransformer.StringArrayRotateFunctionTransformer], this.literalNodesCacheStorage = r, this.visitedLexicalScopeNodesStackStorage = n, this.stringArrayStorage = i, this.stringArrayScopeCallsWrappersDataStorage = a, this.stringArrayStorageAnalyzer = o, this.identifierNamesGenerator = s(t), this.stringArrayTransformerCustomNodeFactory = c;
                    }
                    getVisitor(e) {
                        switch (e) {
                        case l.NodeTransformationStage.StringArray:
                            return {
                                enter: (e, t) => {
                                    if (m.NodeGuards.isProgramNode(e) && this.prepareNode(e), t && m.NodeGuards.isLiteralNode(e) && !g.NodeMetadata.isStringArrayCallLiteralNode(e))
                                        return this.transformNode(e, t);
                                }
                            };
                        default:
                            return null;
                        }
                    }
                    prepareNode(e) {
                        this.options.stringArray && this.stringArrayStorageAnalyzer.analyze(e), this.options.stringArrayShuffle && this.stringArrayStorage.shuffleStorage(), this.options.stringArrayRotate && this.stringArrayStorage.rotateStorage();
                    }
                    transformNode(e, t) {
                        if (!h.NodeLiteralUtils.isStringLiteralNode(e) || h.NodeLiteralUtils.isProhibitedLiteralNode(e, t))
                            return e;
                        const r = e.value, n = this.stringArrayStorageAnalyzer.getItemDataForLiteralNode(e), i = this.literalNodesCacheStorage.buildKey(r, n);
                        let a;
                        if (this.literalNodesCacheStorage.shouldUseCachedValue(i, n)) {
                            const e = this.literalNodesCacheStorage.get(i);
                            a = y.NodeUtils.clone(e);
                        } else
                            a = n ? this.getStringArrayCallNode(n) : e, this.literalNodesCacheStorage.set(i, a);
                        return y.NodeUtils.parentizeNode(a, t), a;
                    }
                    getStringArrayCallNode(e) {
                        const t = this.getStringArrayScopeCallsWrapperData(e), {
                                decodeKey: r,
                                index: n
                            } = e, i = this.stringArrayTransformerCustomNodeFactory(d.StringArrayCustomNode.StringArrayCallNode);
                        i.initialize(n, this.stringArrayStorage.getIndexShiftAmount(), t, r);
                        const a = i.getNode()[0];
                        if (!m.NodeGuards.isExpressionStatementNode(a))
                            throw new Error('`stringArrayCallCustomNode.getNode()[0]` should returns array with `ExpressionStatement` node');
                        return a.expression;
                    }
                    getStringArrayScopeCallsWrapperData(e) {
                        return this.options.stringArrayWrappersCount ? this.getUpperStringArrayScopeCallsWrapperData(e) : this.getRootStringArrayScopeCallsWrapperData(e);
                    }
                    getRootStringArrayScopeCallsWrapperData(e) {
                        const {encoding: t} = e;
                        return {
                            name: this.stringArrayStorage.getStorageCallsWrapperName(t),
                            index: 0,
                            parameterIndexesData: null
                        };
                    }
                    getUpperStringArrayScopeCallsWrapperData(e) {
                        var t, r, n;
                        const {encoding: i} = e, a = null !== (t = this.visitedLexicalScopeNodesStackStorage.getLastElement()) && void 0 !== t ? t : null;
                        if (!a)
                            throw new Error('Cannot find current lexical scope body node');
                        const o = null !== (n = null === (r = this.getAndUpdateStringArrayScopeCallsWrappersDataByEncoding(a, e)[i]) || void 0 === r ? void 0 : r.scopeCallsWrappersData) && void 0 !== n ? n : [];
                        return this.randomGenerator.getRandomGenerator().pickone(o);
                    }
                    getAndUpdateStringArrayScopeCallsWrappersDataByEncoding(e, t) {
                        var r, n, i;
                        const {encoding: a} = t, o = null !== (r = this.stringArrayScopeCallsWrappersDataStorage.get(e)) && void 0 !== r ? r : {}, s = null !== (i = null === (n = o[a]) || void 0 === n ? void 0 : n.scopeCallsWrappersData) && void 0 !== i ? i : [];
                        if (s.length === this.options.stringArrayWrappersCount)
                            return o;
                        const c = m.NodeGuards.isProgramNode(e) ? this.identifierNamesGenerator.generateForGlobalScope() : this.identifierNamesGenerator.generateNext(), u = this.getStringArrayCallsWrapperShiftedIndex(), l = this.getStringArrayCallsWrapperParameterIndexesData();
                        return o[a] = {
                            encoding: a,
                            scopeCallsWrappersData: [
                                ...s,
                                {
                                    name: c,
                                    index: u,
                                    parameterIndexesData: l
                                }
                            ]
                        }, this.stringArrayScopeCallsWrappersDataStorage.set(e, o), o;
                    }
                    getStringArrayCallsWrapperShiftedIndex() {
                        return this.options.stringArrayWrappersType === p.StringArrayWrappersType.Function ? this.randomGenerator.getRandomInteger(n.minShiftedIndexValue, n.maxShiftedIndexValue) : 0;
                    }
                    getStringArrayCallsWrapperParameterIndexesData() {
                        if (this.options.stringArrayWrappersType !== p.StringArrayWrappersType.Function)
                            return null;
                        const e = this.options.stringArrayWrappersParametersMaxCount - 1, t = this.randomGenerator.getRandomInteger(0, e);
                        return {
                            valueIndexParameterIndex: t,
                            decodeKeyParameterIndex: this.randomGenerator.getRandomIntegerExcluding(0, e, [t])
                        };
                    }
                };
                b.minShiftedIndexValue = -1000, b.maxShiftedIndexValue = 1000, b = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.ILiteralNodesCacheStorage)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.IVisitedLexicalScopeNodesStackStorage)),
                    o(4, (0, s.inject)(c.ServiceIdentifiers.IStringArrayStorage)),
                    o(5, (0, s.inject)(c.ServiceIdentifiers.IStringArrayScopeCallsWrappersDataStorage)),
                    o(6, (0, s.inject)(c.ServiceIdentifiers.IStringArrayStorageAnalyzer)),
                    o(7, (0, s.inject)(c.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(8, (0, s.inject)(c.ServiceIdentifiers.Factory__IStringArrayCustomNode)),
                    a('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Object,
                        Object,
                        Object,
                        Object,
                        Function,
                        Function
                    ])
                ], b), t.StringArrayTransformer = b;
            },
            8434: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeAppender = void 0;
                const n = r(8983);
                class i {
                    static append(e, t) {
                        t = i.parentizeScopeStatementsBeforeAppend(e, t);
                        const r = i.getScopeStatements(e).concat(t);
                        i.setScopeStatements(e, r);
                    }
                    static appendToOptimalBlockScope(e, t, r, n = 0) {
                        const a = e.length ? i.getOptimalBlockScope(e, n) : t;
                        i.prepend(a, r);
                    }
                    static getOptimalBlockScope(e, t, r = 1 / 0) {
                        const n = e[t];
                        if (r <= 0)
                            throw new Error('Invalid `deep` argument value. Value should be bigger then 0.');
                        return r > 1 && n.callsGraph.length ? i.getOptimalBlockScope(n.callsGraph, 0, --r) : n.callee;
                    }
                    static getScopeStatements(e) {
                        return n.NodeGuards.isSwitchCaseNode(e) ? e.consequent : e.body;
                    }
                    static insertBefore(e, t, r) {
                        const n = i.getScopeStatements(e).indexOf(r);
                        i.insertAtIndex(e, t, n);
                    }
                    static insertAfter(e, t, r) {
                        const n = i.getScopeStatements(e).indexOf(r);
                        i.insertAtIndex(e, t, n + 1);
                    }
                    static insertAtIndex(e, t, r) {
                        t = i.parentizeScopeStatementsBeforeAppend(e, t), i.setScopeStatements(e, [
                            ...i.getScopeStatements(e).slice(0, r),
                            ...t,
                            ...i.getScopeStatements(e).slice(r)
                        ]);
                    }
                    static prepend(e, t) {
                        const r = (t = i.parentizeScopeStatementsBeforeAppend(e, t)).concat(i.getScopeStatements(e));
                        i.setScopeStatements(e, r);
                    }
                    static remove(e, t) {
                        const r = i.getScopeStatements(e), n = r.indexOf(t);
                        if (-1 === n)
                            return;
                        const a = [...r];
                        a.splice(n, 1), i.setScopeStatements(e, a);
                    }
                    static parentizeScopeStatementsBeforeAppend(e, t) {
                        return t.forEach(t => {
                            t.parentNode = e;
                        }), t;
                    }
                    static setScopeStatements(e, t) {
                        n.NodeGuards.isSwitchCaseNode(e) ? e.consequent = t : e.body = t;
                    }
                }
                t.NodeAppender = i;
            },
            9181: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeFactory = void 0;
                const o = a(r(3913)), s = r(9789);
                class c {
                    static programNode(e = []) {
                        return {
                            type: s.NodeType.Program,
                            body: e,
                            sourceType: 'script',
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static arrayExpressionNode(e = []) {
                        return {
                            type: s.NodeType.ArrayExpression,
                            elements: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static assignmentExpressionNode(e, t, r) {
                        return {
                            type: s.NodeType.AssignmentExpression,
                            operator: e,
                            left: t,
                            right: r,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static binaryExpressionNode(e, t, r) {
                        return {
                            type: s.NodeType.BinaryExpression,
                            operator: e,
                            left: t,
                            right: r,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static blockStatementNode(e = []) {
                        return {
                            type: s.NodeType.BlockStatement,
                            body: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static breakStatement(e) {
                        return {
                            type: s.NodeType.BreakStatement,
                            label: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static callExpressionNode(e, t = [], r = !1) {
                        return {
                            type: s.NodeType.CallExpression,
                            callee: e,
                            optional: r,
                            arguments: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static conditionalExpressionNode(e, t, r) {
                        return {
                            type: s.NodeType.ConditionalExpression,
                            test: e,
                            consequent: t,
                            alternate: r,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static continueStatement(e) {
                        return {
                            type: s.NodeType.ContinueStatement,
                            label: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static directiveNode(e, t) {
                        return {
                            type: s.NodeType.ExpressionStatement,
                            expression: e,
                            directive: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static doWhileStatementNode(e, t) {
                        return {
                            type: s.NodeType.DoWhileStatement,
                            body: e,
                            test: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static exportAllDeclarationNode(e, t) {
                        return {
                            type: s.NodeType.ExportAllDeclaration,
                            exported: t,
                            source: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static exportNamedDeclarationNode(e, t) {
                        return {
                            type: s.NodeType.ExportNamedDeclaration,
                            specifiers: e,
                            source: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static expressionStatementNode(e) {
                        return {
                            type: s.NodeType.ExpressionStatement,
                            expression: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static forStatementNode(e, t, r, n) {
                        return {
                            type: s.NodeType.ForStatement,
                            init: e,
                            test: t,
                            update: r,
                            body: n,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static forInStatementNode(e, t, r) {
                        return {
                            type: s.NodeType.ForInStatement,
                            left: e,
                            right: t,
                            body: r,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static forOfStatementNode(e, t, r, n) {
                        return {
                            type: s.NodeType.ForOfStatement,
                            await: e,
                            left: t,
                            right: r,
                            body: n,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static functionDeclarationNode(e, t, r) {
                        return {
                            type: s.NodeType.FunctionDeclaration,
                            id: c.identifierNode(e),
                            params: t,
                            body: r,
                            generator: !1,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static functionExpressionNode(e, t) {
                        return {
                            type: s.NodeType.FunctionExpression,
                            params: e,
                            body: t,
                            generator: !1,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static ifStatementNode(e, t, r) {
                        return {
                            type: s.NodeType.IfStatement,
                            test: e,
                            consequent: t,
                            ...r && { alternate: r },
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static identifierNode(e) {
                        return {
                            type: s.NodeType.Identifier,
                            name: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static importDeclarationNode(e, t) {
                        return {
                            type: s.NodeType.ImportDeclaration,
                            specifiers: e,
                            source: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static labeledStatementNode(e, t) {
                        return {
                            type: s.NodeType.LabeledStatement,
                            label: e,
                            body: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static literalNode(e, t) {
                        return t = void 0 !== t ? t : `'${ e }'`, {
                            type: s.NodeType.Literal,
                            value: e,
                            raw: t,
                            'x-verbatim-property': {
                                content: t,
                                precedence: o.Precedence.Primary
                            },
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static logicalExpressionNode(e, t, r) {
                        return {
                            type: s.NodeType.LogicalExpression,
                            operator: e,
                            left: t,
                            right: r,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static memberExpressionNode(e, t, r = !1, n = !1) {
                        return {
                            type: s.NodeType.MemberExpression,
                            computed: r,
                            object: e,
                            optional: n,
                            property: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static objectExpressionNode(e) {
                        return {
                            type: s.NodeType.ObjectExpression,
                            properties: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static propertyNode(e, t, r = !1) {
                        return {
                            type: s.NodeType.Property,
                            key: e,
                            value: t,
                            kind: 'init',
                            method: !1,
                            shorthand: !1,
                            computed: r,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static restElementNode(e) {
                        return {
                            type: s.NodeType.RestElement,
                            argument: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static returnStatementNode(e) {
                        return {
                            type: s.NodeType.ReturnStatement,
                            argument: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static sequenceExpressionNode(e) {
                        return {
                            type: s.NodeType.SequenceExpression,
                            expressions: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static spreadElementNode(e) {
                        return {
                            type: s.NodeType.SpreadElement,
                            argument: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static staticBlockNode(e = []) {
                        return {
                            type: s.NodeType.StaticBlock,
                            body: e,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static switchStatementNode(e, t) {
                        return {
                            type: s.NodeType.SwitchStatement,
                            discriminant: e,
                            cases: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static switchCaseNode(e, t) {
                        return {
                            type: s.NodeType.SwitchCase,
                            test: e,
                            consequent: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static unaryExpressionNode(e, t, r = !0) {
                        return {
                            type: s.NodeType.UnaryExpression,
                            operator: e,
                            argument: t,
                            prefix: r,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static updateExpressionNode(e, t) {
                        return {
                            type: s.NodeType.UpdateExpression,
                            operator: e,
                            argument: t,
                            prefix: !1,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static variableDeclarationNode(e = [], t = 'var') {
                        return {
                            type: s.NodeType.VariableDeclaration,
                            declarations: e,
                            kind: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static variableDeclaratorNode(e, t) {
                        return {
                            type: s.NodeType.VariableDeclarator,
                            id: e,
                            init: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                    static whileStatementNode(e, t) {
                        return {
                            type: s.NodeType.WhileStatement,
                            test: e,
                            body: t,
                            metadata: { ignoredNode: !1 }
                        };
                    }
                }
                t.NodeFactory = c;
            },
            8983: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeGuards = void 0;
                const n = r(9789);
                class i {
                    static isArrayPatternNode(e) {
                        return e.type === n.NodeType.ArrayPattern;
                    }
                    static isArrowFunctionExpressionNode(e) {
                        return e.type === n.NodeType.ArrowFunctionExpression;
                    }
                    static isAssignmentExpressionNode(e) {
                        return e.type === n.NodeType.AssignmentExpression;
                    }
                    static isAssignmentPatternNode(e) {
                        return e.type === n.NodeType.AssignmentPattern;
                    }
                    static isAwaitExpressionNode(e) {
                        return e.type === n.NodeType.AwaitExpression;
                    }
                    static isBigIntLiteralNode(e) {
                        return i.isLiteralNode(e) && !!e.bigint;
                    }
                    static isBlockStatementNode(e) {
                        return e.type === n.NodeType.BlockStatement;
                    }
                    static isBreakStatementNode(e) {
                        return e.type === n.NodeType.BreakStatement;
                    }
                    static isCallExpressionNode(e) {
                        return e.type === n.NodeType.CallExpression;
                    }
                    static isClassBodyNode(e) {
                        return e.type === n.NodeType.ClassBody;
                    }
                    static isClassDeclarationNode(e) {
                        return e.type === n.NodeType.ClassDeclaration && null !== e.id;
                    }
                    static isConditionalExpressionNode(e) {
                        return e.type === n.NodeType.ConditionalExpression;
                    }
                    static isContinueStatementNode(e) {
                        return e.type === n.NodeType.ContinueStatement;
                    }
                    static isDirectiveNode(e) {
                        return e.type === n.NodeType.ExpressionStatement && 'directive' in e;
                    }
                    static isDoWhileStatementNode(e) {
                        return e.type === n.NodeType.DoWhileStatement;
                    }
                    static isExportAllDeclarationNode(e) {
                        return e.type === n.NodeType.ExportAllDeclaration;
                    }
                    static isExportNamedDeclarationNode(e) {
                        return e.type === n.NodeType.ExportNamedDeclaration;
                    }
                    static isExportSpecifierNode(e) {
                        return e.type === n.NodeType.ExportSpecifier;
                    }
                    static isExpressionStatementNode(e) {
                        return e.type === n.NodeType.ExpressionStatement && !('directive' in e);
                    }
                    static isForStatementNode(e) {
                        return e.type === n.NodeType.ForStatement;
                    }
                    static isForInStatementNode(e) {
                        return e.type === n.NodeType.ForInStatement;
                    }
                    static isForOfStatementNode(e) {
                        return e.type === n.NodeType.ForOfStatement;
                    }
                    static isFunctionNode(e) {
                        return i.isFunctionDeclarationNode(e) || i.isFunctionExpressionNode(e) || i.isArrowFunctionExpressionNode(e);
                    }
                    static isFunctionDeclarationNode(e) {
                        return e.type === n.NodeType.FunctionDeclaration && null !== e.id;
                    }
                    static isFunctionExpressionNode(e) {
                        return e.type === n.NodeType.FunctionExpression;
                    }
                    static isIdentifierNode(e) {
                        return e.type === n.NodeType.Identifier;
                    }
                    static isIfStatementNode(e) {
                        return e.type === n.NodeType.IfStatement;
                    }
                    static isIfStatementNodeWithSingleStatementBody(e) {
                        return !(!i.isIfStatementNode(e) || i.isBlockStatementNode(e.consequent) && (!e.alternate || i.isBlockStatementNode(e.alternate)));
                    }
                    static isImportDeclarationNode(e) {
                        return e.type === n.NodeType.ImportDeclaration;
                    }
                    static isImportExpressionNode(e) {
                        return e.type === n.NodeType.ImportExpression;
                    }
                    static isImportSpecifierNode(e) {
                        return e.type === n.NodeType.ImportSpecifier;
                    }
                    static isLabelIdentifierNode(e, t) {
                        const r = i.isLabeledStatementNode(t) && t.label === e, n = i.isContinueStatementNode(t) && t.label === e, a = i.isBreakStatementNode(t) && t.label === e;
                        return r || n || a;
                    }
                    static isLabeledStatementNode(e) {
                        return e.type === n.NodeType.LabeledStatement;
                    }
                    static isLiteralNode(e) {
                        return e.type === n.NodeType.Literal;
                    }
                    static isLogicalExpressionNode(e) {
                        return e.type === n.NodeType.LogicalExpression;
                    }
                    static isMemberExpressionNode(e) {
                        return e.type === n.NodeType.MemberExpression;
                    }
                    static isMethodDefinitionNode(e) {
                        return e.type === n.NodeType.MethodDefinition;
                    }
                    static isNewExpressionNode(e) {
                        return e.type === n.NodeType.NewExpression;
                    }
                    static isNode(e) {
                        return e && void 0 !== !e.type;
                    }
                    static isNodeWithLexicalScope(e) {
                        return i.isProgramNode(e) || i.isFunctionNode(e);
                    }
                    static isNodeWithBlockLexicalScope(e) {
                        return i.isNodeWithLexicalScope(e) || i.isBlockStatementNode(e) || i.isStaticBlockNode(e);
                    }
                    static isNodeWithSingleStatementBody(e) {
                        return i.isIfStatementNode(e) ? i.isIfStatementNodeWithSingleStatementBody(e) : (i.isForStatementNode(e) || i.isForOfStatementNode(e) || i.isForInStatementNode(e) || i.isWhileStatementNode(e) || i.isDoWhileStatementNode(e) || i.isWithStatementNode(e) || i.isLabeledStatementNode(e)) && !i.isBlockStatementNode(e.body);
                    }
                    static isNodeWithLexicalScopeStatements(e, t) {
                        return i.isProgramNode(e) || i.isBlockStatementNode(e) && i.nodesWithLexicalStatements.includes(t.type);
                    }
                    static isNodeWithStatements(e) {
                        return i.isProgramNode(e) || i.isBlockStatementNode(e) || i.isStaticBlockNode(e) || i.isSwitchCaseNode(e);
                    }
                    static isNodeWithComments(e) {
                        return Boolean(e.leadingComments) || Boolean(e.trailingComments);
                    }
                    static isObjectPatternNode(e) {
                        return e.type === n.NodeType.ObjectPattern;
                    }
                    static isObjectExpressionNode(e) {
                        return e.type === n.NodeType.ObjectExpression;
                    }
                    static isPrivateIdentifierNode(e) {
                        return e.type === n.NodeType.PrivateIdentifier;
                    }
                    static isProgramNode(e) {
                        return e.type === n.NodeType.Program;
                    }
                    static isPropertyNode(e) {
                        return e.type === n.NodeType.Property;
                    }
                    static isPropertyDefinitionNode(e) {
                        return e.type === n.NodeType.PropertyDefinition;
                    }
                    static isRestElementNode(e) {
                        return e.type === n.NodeType.RestElement;
                    }
                    static isReturnStatementNode(e) {
                        return e.type === n.NodeType.ReturnStatement;
                    }
                    static isSequenceExpressionNode(e) {
                        return e.type === n.NodeType.SequenceExpression;
                    }
                    static isSpreadElementNode(e) {
                        return e.type === n.NodeType.SpreadElement;
                    }
                    static isStaticBlockNode(e) {
                        return e.type === n.NodeType.StaticBlock;
                    }
                    static isSuperNode(e) {
                        return e.type === n.NodeType.Super;
                    }
                    static isSwitchCaseNode(e) {
                        return e.type === n.NodeType.SwitchCase;
                    }
                    static isTaggedTemplateExpressionNode(e) {
                        return e.type === n.NodeType.TaggedTemplateExpression;
                    }
                    static isTemplateLiteralNode(e) {
                        return e.type === n.NodeType.TemplateLiteral;
                    }
                    static isThisExpressionNode(e) {
                        return e.type === n.NodeType.ThisExpression;
                    }
                    static isUnaryExpressionNode(e) {
                        return e.type === n.NodeType.UnaryExpression;
                    }
                    static isVariableDeclarationNode(e) {
                        return e.type === n.NodeType.VariableDeclaration;
                    }
                    static isVariableDeclaratorNode(e) {
                        return e.type === n.NodeType.VariableDeclarator;
                    }
                    static isWithStatementNode(e) {
                        return e.type === n.NodeType.WithStatement;
                    }
                    static isWhileStatementNode(e) {
                        return e.type === n.NodeType.WhileStatement;
                    }
                    static isYieldExpressionNode(e) {
                        return e.type === n.NodeType.YieldExpression;
                    }
                }
                t.NodeGuards = i, i.nodesWithLexicalStatements = [
                    n.NodeType.ArrowFunctionExpression,
                    n.NodeType.FunctionDeclaration,
                    n.NodeType.FunctionExpression,
                    n.NodeType.MethodDefinition
                ];
            },
            8520: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeLexicalScopeUtils = void 0;
                const n = r(8983);
                class i {
                    static getLexicalScope(e) {
                        return i.getLexicalScopesRecursive(e, 1)[0];
                    }
                    static getLexicalScopes(e) {
                        return i.getLexicalScopesRecursive(e);
                    }
                    static getLexicalScopesRecursive(e, t = 1 / 0, r = [], a = 0) {
                        if (r.length >= t)
                            return r;
                        const o = e.parentNode;
                        if (!o)
                            throw new ReferenceError('`parentNode` property of given node is `undefined`');
                        return n.NodeGuards.isNodeWithLexicalScope(e) && r.push(e), e !== o ? i.getLexicalScopesRecursive(o, t, r, ++a) : r;
                    }
                }
                t.NodeLexicalScopeUtils = i;
            },
            7586: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeLiteralUtils = void 0;
                const n = r(8983);
                t.NodeLiteralUtils = class {
                    static isNumberLiteralNode(e) {
                        return 'number' == typeof e.value;
                    }
                    static isStringLiteralNode(e) {
                        return 'string' == typeof e.value;
                    }
                    static isProhibitedLiteralNode(e, t) {
                        return !(!n.NodeGuards.isPropertyNode(t) || t.computed || t.key !== e) || !!n.NodeGuards.isImportDeclarationNode(t) || !(!n.NodeGuards.isExportAllDeclarationNode(t) && !n.NodeGuards.isExportNamedDeclarationNode(t));
                    }
                };
            },
            5301: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeMetadata = void 0;
                class r {
                    static set(e, t) {
                        var r;
                        e.metadata = Object.assign(null !== (r = e.metadata) && void 0 !== r ? r : {}, t);
                    }
                    static get(e, t) {
                        return void 0 !== e.metadata ? e.metadata[t] : void 0;
                    }
                    static isEvalHostNode(e) {
                        return !0 === r.get(e, 'evalHostNode');
                    }
                    static isForceTransformNode(e) {
                        return !0 === r.get(e, 'forceTransformNode');
                    }
                    static isIgnoredNode(e) {
                        return !0 === r.get(e, 'ignoredNode');
                    }
                    static isPropertyKeyToRenameNode(e) {
                        return !0 === r.get(e, 'propertyKeyToRenameNode');
                    }
                    static isStringArrayCallLiteralNode(e) {
                        return !0 === r.get(e, 'stringArrayCallLiteralNode');
                    }
                }
                t.NodeMetadata = r;
            },
            3790: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeStatementUtils = void 0;
                const n = r(8983);
                class i {
                    static getParentNodeWithStatements(e) {
                        return i.getParentNodesWithStatementsRecursive(e, 1)[0];
                    }
                    static getParentNodesWithStatements(e) {
                        return i.getParentNodesWithStatementsRecursive(e);
                    }
                    static getNextSiblingStatement(e) {
                        return i.getSiblingStatementByOffset(e, 1);
                    }
                    static getPreviousSiblingStatement(e) {
                        return i.getSiblingStatementByOffset(e, -1);
                    }
                    static getRootStatementOfNode(e) {
                        if (n.NodeGuards.isProgramNode(e))
                            throw new Error('Unable to find root statement for `Program` node');
                        const t = e.parentNode;
                        if (!t)
                            throw new ReferenceError('`parentNode` property of given node is `undefined`');
                        return n.NodeGuards.isNodeWithStatements(t) ? e : i.getRootStatementOfNode(t);
                    }
                    static getScopeOfNode(e) {
                        const t = e.parentNode;
                        if (!t)
                            throw new ReferenceError('`parentNode` property of given node is `undefined`');
                        return n.NodeGuards.isNodeWithStatements(t) ? t : i.getScopeOfNode(t);
                    }
                    static getParentNodesWithStatementsRecursive(e, t = 1 / 0, r = [], a = 0) {
                        if (r.length >= t)
                            return r;
                        const o = e.parentNode;
                        if (!o)
                            throw new ReferenceError('`parentNode` property of given node is `undefined`');
                        return (n.NodeGuards.isProgramNode(e) || n.NodeGuards.isNodeWithLexicalScopeStatements(e, o) && a > 0) && r.push(e), e !== o ? i.getParentNodesWithStatementsRecursive(o, t, r, ++a) : r;
                    }
                    static getSiblingStatementByOffset(e, t) {
                        const r = i.getScopeOfNode(e), a = n.NodeGuards.isSwitchCaseNode(r) ? r.consequent : r.body, o = a.indexOf(e);
                        return a[o + t] || null;
                    }
                }
                t.NodeStatementUtils = i;
            },
            2815: function (e, t, r) {
                'use strict';
                var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
                        void 0 === n && (n = r);
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        i && !('get' in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                            enumerable: !0,
                            get: function () {
                                return t[r];
                            }
                        }), Object.defineProperty(e, n, i);
                    } : function (e, t, r, n) {
                        void 0 === n && (n = r), e[n] = t[r];
                    }), i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
                        Object.defineProperty(e, 'default', {
                            enumerable: !0,
                            value: t
                        });
                    } : function (e, t) {
                        e.default = t;
                    }), a = this && this.__importStar || function (e) {
                        if (e && e.__esModule)
                            return e;
                        var t = {};
                        if (null != e)
                            for (var r in e)
                                'default' !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                        return i(t, e), t;
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NodeUtils = void 0;
                const o = a(r(3913)), s = a(r(140)), c = r(5371), u = r(3191), l = r(8983), d = r(5301);
                class p {
                    static addXVerbatimPropertyTo(e) {
                        return e['x-verbatim-property'] = {
                            content: e.raw,
                            precedence: o.Precedence.Primary
                        }, e;
                    }
                    static clone(e) {
                        return p.parentizeAst(p.cloneRecursive(e));
                    }
                    static convertCodeToStructure(e) {
                        const t = u.ASTParserFacade.parse(e, {
                            ecmaVersion: c.ecmaVersion,
                            sourceType: 'script'
                        });
                        return s.replace(t, { enter: (e, t) => (p.parentizeNode(e, t), l.NodeGuards.isLiteralNode(e) && p.addXVerbatimPropertyTo(e), d.NodeMetadata.set(e, { ignoredNode: !1 }), e) }), t.body;
                    }
                    static convertStructureToCode(e) {
                        return e.reduce((e, t) => e + o.generate(t, { sourceMapWithCode: !0 }).code, '');
                    }
                    static getUnaryExpressionArgumentNode(e) {
                        return l.NodeGuards.isUnaryExpressionNode(e.argument) ? p.getUnaryExpressionArgumentNode(e.argument) : e.argument;
                    }
                    static parentizeAst(e) {
                        var t;
                        const r = null !== (t = e.parentNode) && void 0 !== t ? t : null;
                        return s.replace(e, { enter: p.parentizeNode }), r && (e.parentNode = r), e;
                    }
                    static parentizeNode(e, t) {
                        return e.parentNode = null != t ? t : e, e;
                    }
                    static cloneRecursive(e) {
                        if (null === e)
                            return e;
                        const t = {};
                        return Object.keys(e).forEach(r => {
                            var n;
                            if ('parentNode' === r)
                                return;
                            const i = null !== (n = e[r]) && void 0 !== n ? n : null;
                            let a;
                            a = null === i || i instanceof RegExp ? i : i instanceof Array ? i.map(p.cloneRecursive) : 'object' == typeof i ? p.cloneRecursive(i) : i, t[r] = a;
                        }), t;
                    }
                }
                t.NodeUtils = p;
            },
            8472: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NumericalExpressionDataToNodeConverter = void 0;
                const n = r(9181), i = r(2303);
                class a {
                    static convertIntegerNumberData(e, t) {
                        return a.convertNumericalExpressionDataToNode(e, t);
                    }
                    static convertFloatNumberData(e, t, r) {
                        const i = a.convertNumericalExpressionDataToNode(e, r);
                        return n.NodeFactory.binaryExpressionNode('+', i, n.NodeFactory.literalNode(t));
                    }
                    static convertNumericalExpressionDataToNode(e, t, r = '+') {
                        var n;
                        const i = e.length, o = i > 1 ? e.slice(0, i - 1) : [e[0]], s = i > 1 ? e.slice(-1) : [];
                        if (s.length)
                            return a.convertPartsToBinaryExpression(r, o, s, t);
                        const c = null !== (n = o[0]) && void 0 !== n ? n : null;
                        return Array.isArray(c) ? a.convertNumericalExpressionDataToNode(c, t, '*') : a.convertPartOrNumberToLiteralNode(c, t);
                    }
                    static convertPartsToBinaryExpression(e, t, r, i) {
                        const o = r[0];
                        return Array.isArray(o) ? n.NodeFactory.binaryExpressionNode(e, a.convertNumericalExpressionDataToNode(t, i), a.convertNumericalExpressionDataToNode(o, i, '*')) : n.NodeFactory.binaryExpressionNode(e, a.convertNumericalExpressionDataToNode(t, i), this.convertPartOrNumberToLiteralNode(o, i));
                    }
                    static convertPartOrNumberToLiteralNode(e, t) {
                        const r = Array.isArray(e) ? e[0] : e, n = i.NumberUtils.isPositive(r);
                        return t(Math.abs(r), n);
                    }
                }
                t.NumericalExpressionDataToNodeConverter = a;
            },
            6186: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ScopeIdentifiersTraverser = void 0;
                const s = r(6594), c = r(2553), u = r(8983);
                let l = n = class {
                    constructor(e) {
                        this.scopeAnalyzer = e;
                    }
                    traverseScopeIdentifiers(e, t, r) {
                        this.scopeAnalyzer.analyze(e);
                        const n = this.scopeAnalyzer.acquireScope(e);
                        this.traverseScopeIdentifiersRecursive(n, n, r);
                    }
                    traverseScopeThroughIdentifiers(e, t, r) {
                        this.scopeAnalyzer.analyze(e);
                        const n = this.scopeAnalyzer.acquireScope(e);
                        this.traverseScopeThroughIdentifiersRecursive(n, n, r);
                    }
                    traverseScopeIdentifiersRecursive(e, t, r) {
                        const i = t.variableScope, a = u.NodeGuards.isNodeWithBlockLexicalScope(i.block) ? i.block : null, o = n.globalScopeNames.includes(i.type);
                        if (a) {
                            for (const s of t.variables)
                                s.name !== n.argumentsVariableName && r({
                                    isGlobalDeclaration: o,
                                    isBubblingDeclaration: s.identifiers.some(e => e.parentNode && u.NodeGuards.isPropertyNode(e.parentNode) && e.parentNode.shorthand),
                                    rootScope: e,
                                    variable: s,
                                    variableScope: i,
                                    variableLexicalScopeNode: a
                                });
                            for (const n of t.childScopes)
                                this.traverseScopeIdentifiersRecursive(e, n, r);
                        }
                    }
                    traverseScopeThroughIdentifiersRecursive(e, t, r) {
                        const i = t.variableScope, a = u.NodeGuards.isNodeWithBlockLexicalScope(i.block) ? i.block : null, o = n.globalScopeNames.includes(i.type);
                        if (a) {
                            for (const e of t.through)
                                r({
                                    isGlobalDeclaration: o,
                                    reference: e,
                                    variableLexicalScopeNode: a
                                });
                            for (const n of t.childScopes)
                                this.traverseScopeThroughIdentifiersRecursive(e, n, r);
                        }
                    }
                };
                l.argumentsVariableName = 'arguments', l.globalScopeNames = [
                    'global',
                    'module'
                ], l = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.IScopeAnalyzer)),
                    a('design:paramtypes', [Object])
                ], l), t.ScopeIdentifiersTraverser = l;
            },
            4081: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.Options = void 0;
                const s = r(6594), c = r(2553), u = r(4571), l = r(3552), d = r(7081), p = r(4867), f = r(3442), m = r(5138), h = r(3550), g = r(5114), y = r(1296), b = r(679), S = r(2932), v = r(4503), C = r(7312), A = r(875), _ = r(8810), E = r(6485), N = r(4372), I = r(8566), T = r(2117);
                let D = n = class {
                    constructor(e, t) {
                        var r;
                        const i = n.getOptionsByPreset(null !== (r = e.optionsPreset) && void 0 !== r ? r : p.OptionsPreset.Default);
                        Object.assign(this, i, e);
                        const a = (0, u.validateSync)(this, n.validatorOptions);
                        if (a.length)
                            throw new ReferenceError(`Validation failed. errors:\n${ _.ValidationErrorsFormatter.format(a) }`);
                        Object.assign(this, t.normalize(this));
                    }
                    static getOptionsByPreset(e) {
                        var t;
                        const r = null !== (t = n.optionPresetsMap.get(e)) && void 0 !== t ? t : null;
                        if (!r)
                            throw new Error(`Options for preset name \`${ e }\` are not found`);
                        return r;
                    }
                };
                D.optionPresetsMap = new Map([
                    [
                        p.OptionsPreset.Default,
                        S.DEFAULT_PRESET
                    ],
                    [
                        p.OptionsPreset.LowObfuscation,
                        v.LOW_OBFUSCATION_PRESET
                    ],
                    [
                        p.OptionsPreset.MediumObfuscation,
                        C.MEDIUM_OBFUSCATION_PRESET
                    ],
                    [
                        p.OptionsPreset.HighObfuscation,
                        A.HIGH_OBFUSCATION_PRESET
                    ]
                ]), D.validatorOptions = {
                    forbidUnknownValues: !0,
                    validationError: { target: !1 }
                }, i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'compact', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'controlFlowFlattening', void 0), i([
                    (0, u.IsNumber)(),
                    (0, u.Min)(0),
                    (0, u.Max)(1),
                    a('design:type', Number)
                ], D.prototype, 'controlFlowFlatteningThreshold', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'deadCodeInjection', void 0), i([
                    (0, u.IsNumber)(),
                    a('design:type', Number)
                ], D.prototype, 'deadCodeInjectionThreshold', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'debugProtection', void 0), i([
                    (0, u.IsNumber)(),
                    (0, u.Min)(0),
                    a('design:type', Number)
                ], D.prototype, 'debugProtectionInterval', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'disableConsoleOutput', void 0), i([
                    (0, u.IsArray)(),
                    (0, u.ArrayUnique)(),
                    (0, u.IsString)({ each: !0 }),
                    (0, E.IsAllowedForObfuscationTargets)([
                        d.ObfuscationTarget.Browser,
                        d.ObfuscationTarget.BrowserNoEval
                    ]),
                    a('design:type', Array)
                ], D.prototype, 'domainLock', void 0), i([
                    (0, N.IsDomainLockRedirectUrl)(),
                    a('design:type', String)
                ], D.prototype, 'domainLockRedirectUrl', void 0), i([
                    (0, u.IsArray)(),
                    (0, u.ArrayUnique)(),
                    (0, u.IsString)({ each: !0 }),
                    a('design:type', Array)
                ], D.prototype, 'forceTransformStrings', void 0), i([
                    (0, I.IsIdentifierNamesCache)(),
                    a('design:type', Object)
                ], D.prototype, 'identifierNamesCache', void 0), i([
                    (0, u.IsIn)([
                        l.IdentifierNamesGenerator.DictionaryIdentifierNamesGenerator,
                        l.IdentifierNamesGenerator.HexadecimalIdentifierNamesGenerator,
                        l.IdentifierNamesGenerator.MangledIdentifierNamesGenerator,
                        l.IdentifierNamesGenerator.MangledShuffledIdentifierNamesGenerator
                    ]),
                    a('design:type', Object)
                ], D.prototype, 'identifierNamesGenerator', void 0), i([
                    (0, u.IsString)(),
                    a('design:type', String)
                ], D.prototype, 'identifiersPrefix', void 0), i([
                    (0, u.IsArray)(),
                    (0, u.ArrayUnique)(),
                    (0, u.IsString)({ each: !0 }),
                    (0, u.ValidateIf)(e => e.identifierNamesGenerator === l.IdentifierNamesGenerator.DictionaryIdentifierNamesGenerator),
                    (0, u.ArrayNotEmpty)(),
                    a('design:type', Array)
                ], D.prototype, 'identifiersDictionary', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'ignoreImports', void 0), i([
                    (0, T.IsInputFileName)(),
                    a('design:type', String)
                ], D.prototype, 'inputFileName', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'log', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'numbersToExpressions', void 0), i([
                    (0, u.IsIn)([
                        p.OptionsPreset.Default,
                        p.OptionsPreset.LowObfuscation,
                        p.OptionsPreset.MediumObfuscation,
                        p.OptionsPreset.HighObfuscation
                    ]),
                    a('design:type', String)
                ], D.prototype, 'optionsPreset', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'renameGlobals', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'renameProperties', void 0), i([
                    (0, u.IsIn)([
                        f.RenamePropertiesMode.Safe,
                        f.RenamePropertiesMode.Unsafe
                    ]),
                    a('design:type', String)
                ], D.prototype, 'renamePropertiesMode', void 0), i([
                    (0, u.IsArray)(),
                    (0, u.ArrayUnique)(),
                    (0, u.IsString)({ each: !0 }),
                    a('design:type', Array)
                ], D.prototype, 'reservedNames', void 0), i([
                    (0, u.IsArray)(),
                    (0, u.ArrayUnique)(),
                    (0, u.IsString)({ each: !0 }),
                    a('design:type', Array)
                ], D.prototype, 'reservedStrings', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'selfDefending', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'simplify', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'sourceMap', void 0), i([
                    (0, u.IsString)(),
                    (0, u.ValidateIf)(e => Boolean(e.sourceMapBaseUrl)),
                    (0, u.IsUrl)({
                        require_protocol: !0,
                        require_tld: !1,
                        require_valid_protocol: !0
                    }),
                    a('design:type', String)
                ], D.prototype, 'sourceMapBaseUrl', void 0), i([
                    (0, u.IsString)(),
                    a('design:type', String)
                ], D.prototype, 'sourceMapFileName', void 0), i([
                    (0, u.IsIn)([
                        m.SourceMapMode.Inline,
                        m.SourceMapMode.Separate
                    ]),
                    a('design:type', Object)
                ], D.prototype, 'sourceMapMode', void 0), i([
                    (0, u.IsIn)([
                        h.SourceMapSourcesMode.Sources,
                        h.SourceMapSourcesMode.SourcesContent
                    ]),
                    a('design:type', Object)
                ], D.prototype, 'sourceMapSourcesMode', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'splitStrings', void 0), i([
                    (0, u.IsNumber)(),
                    (0, u.ValidateIf)(e => Boolean(e.splitStrings)),
                    (0, u.Min)(1),
                    a('design:type', Number)
                ], D.prototype, 'splitStringsChunkLength', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'stringArray', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'stringArrayCallsTransform', void 0), i([
                    (0, u.IsNumber)(),
                    (0, u.Min)(0),
                    (0, u.Max)(1),
                    a('design:type', Number)
                ], D.prototype, 'stringArrayCallsTransformThreshold', void 0), i([
                    (0, u.IsArray)(),
                    (0, u.ArrayUnique)(),
                    (0, u.IsIn)([
                        y.StringArrayEncoding.None,
                        y.StringArrayEncoding.Base64,
                        y.StringArrayEncoding.Rc4
                    ], { each: !0 }),
                    a('design:type', Array)
                ], D.prototype, 'stringArrayEncoding', void 0), i([
                    (0, u.IsArray)(),
                    (0, u.ArrayNotEmpty)(),
                    (0, u.ArrayUnique)(),
                    (0, u.IsIn)([
                        g.StringArrayIndexesType.HexadecimalNumber,
                        g.StringArrayIndexesType.HexadecimalNumericString
                    ], { each: !0 }),
                    a('design:type', Array)
                ], D.prototype, 'stringArrayIndexesType', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'stringArrayIndexShift', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'stringArrayRotate', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'stringArrayShuffle', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'stringArrayWrappersChainedCalls', void 0), i([
                    (0, u.IsNumber)(),
                    (0, u.Min)(0),
                    a('design:type', Number)
                ], D.prototype, 'stringArrayWrappersCount', void 0), i([
                    (0, u.IsNumber)(),
                    (0, u.Min)(2),
                    a('design:type', Number)
                ], D.prototype, 'stringArrayWrappersParametersMaxCount', void 0), i([
                    (0, u.IsIn)([
                        b.StringArrayWrappersType.Variable,
                        b.StringArrayWrappersType.Function
                    ]),
                    a('design:type', String)
                ], D.prototype, 'stringArrayWrappersType', void 0), i([
                    (0, u.IsNumber)(),
                    (0, u.Min)(0),
                    (0, u.Max)(1),
                    a('design:type', Number)
                ], D.prototype, 'stringArrayThreshold', void 0), i([
                    (0, u.IsIn)([
                        d.ObfuscationTarget.Browser,
                        d.ObfuscationTarget.BrowserNoEval,
                        d.ObfuscationTarget.Node,
                        d.ObfuscationTarget.ServiceWorker
                    ]),
                    a('design:type', Object)
                ], D.prototype, 'target', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'transformObjectKeys', void 0), i([
                    (0, u.IsBoolean)(),
                    a('design:type', Boolean)
                ], D.prototype, 'unicodeEscapeSequence', void 0), D = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.TInputOptions)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IOptionsNormalizer)),
                    a('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], D), t.Options = D;
            },
            6181: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.OptionsNormalizer = void 0;
                const a = r(6594), o = r(7031), s = r(4007), c = r(2114), u = r(7415), l = r(2979), d = r(90), p = r(4993), f = r(2135), m = r(9309), h = r(3360), g = r(5084), y = r(6516), b = r(1343), S = r(4101), v = r(9553), C = r(3783);
                let A = n = class {
                    normalize(e) {
                        let t = { ...e };
                        for (const e of n.normalizerRules)
                            t = e(t);
                        return t;
                    }
                };
                A.normalizerRules = [
                    o.ControlFlowFlatteningThresholdRule,
                    s.DeadCodeInjectionRule,
                    c.DeadCodeInjectionThresholdRule,
                    u.DomainLockRedirectUrlRule,
                    l.DomainLockRule,
                    d.IdentifierNamesCacheRule,
                    p.InputFileNameRule,
                    f.SeedRule,
                    m.SelfDefendingRule,
                    h.SourceMapBaseUrlRule,
                    g.SourceMapFileNameRule,
                    y.SplitStringsChunkLengthRule,
                    b.StringArrayRule,
                    S.StringArrayCallsTransformThresholdRule,
                    v.StringArrayEncodingRule,
                    C.StringArrayWrappersChainedCallsRule
                ], A = n = i([(0, a.injectable)()], A), t.OptionsNormalizer = A;
            },
            8810: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ValidationErrorsFormatter = void 0;
                class r {
                    static format(e) {
                        return e.reduce((e, t) => [
                            ...e,
                            r.formatWithNestedConstraints(t)
                        ], []).join('\n');
                    }
                    static formatWithNestedConstraints(e) {
                        const t = e.constraints;
                        return t ? `\`${ e.property }\` errors:\n${ Object.keys(t).map(e => `    - ${ t[e] }\n`).join() }` : `\`${ e.property }\` error\n`;
                    }
                }
                t.ValidationErrorsFormatter = r;
            },
            7031: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ControlFlowFlatteningThresholdRule = void 0, t.ControlFlowFlatteningThresholdRule = e => (0 === e.controlFlowFlatteningThreshold && (e = {
                    ...e,
                    controlFlowFlattening: !1,
                    controlFlowFlatteningThreshold: 0
                }), e);
            },
            4007: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DeadCodeInjectionRule = void 0;
                const n = r(2932);
                t.DeadCodeInjectionRule = e => (e.deadCodeInjection && ((e = {
                    ...e,
                    deadCodeInjection: !0,
                    stringArray: !0
                }).stringArrayThreshold || (e = {
                    ...e,
                    stringArray: !0,
                    stringArrayThreshold: n.DEFAULT_PRESET.stringArrayThreshold
                })), e);
            },
            2114: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DeadCodeInjectionThresholdRule = void 0, t.DeadCodeInjectionThresholdRule = e => (0 === e.deadCodeInjectionThreshold && (e = {
                    ...e,
                    deadCodeInjection: !1,
                    deadCodeInjectionThreshold: 0
                }), e);
            },
            7415: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DomainLockRedirectUrlRule = void 0;
                const n = r(2932);
                t.DomainLockRedirectUrlRule = e => (e.domainLock.length || (e = {
                    ...e,
                    domainLockRedirectUrl: n.DEFAULT_PRESET.domainLockRedirectUrl
                }), e);
            },
            2979: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DomainLockRule = void 0;
                const n = r(1700);
                t.DomainLockRule = e => {
                    if (e.domainLock.length) {
                        const t = [];
                        for (const r of e.domainLock)
                            t.push(n.Utils.extractDomainFrom(r));
                        e = {
                            ...e,
                            domainLock: t
                        };
                    }
                    return e;
                };
            },
            90: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.IdentifierNamesCacheRule = void 0, t.IdentifierNamesCacheRule = e => {
                    let t = e.identifierNamesCache;
                    return t && !t.globalIdentifiers && (t = {
                        ...t,
                        globalIdentifiers: {}
                    }), t && !t.propertyIdentifiers && (t = {
                        ...t,
                        propertyIdentifiers: {}
                    }), {
                        ...e,
                        identifierNamesCache: t
                    };
                };
            },
            4993: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.InputFileNameRule = void 0;
                const n = r(4413);
                t.InputFileNameRule = e => {
                    let {inputFileName: t} = e;
                    return t && (t = t.replace(/^\/+/, '').split(n.StringSeparator.Dot).slice(0, -1).join(n.StringSeparator.Dot) || t, e = {
                        ...e,
                        inputFileName: `${ t }.js`
                    }), e;
                };
            },
            2135: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SeedRule = void 0, t.SeedRule = e => e.seed ? {
                    ...e,
                    seed: e.seed
                } : {
                    ...e,
                    seed: (0, 999999999, Math.floor(1000000000 * Math.random() + 0))
                };
            },
            9309: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SelfDefendingRule = void 0, t.SelfDefendingRule = e => (e.selfDefending && (e = {
                    ...e,
                    compact: !0,
                    selfDefending: !0
                }), e);
            },
            3360: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SourceMapBaseUrlRule = void 0, t.SourceMapBaseUrlRule = e => {
                    const {sourceMapBaseUrl: t} = e;
                    return e.sourceMapFileName ? (t && !t.endsWith('/') && (e = {
                        ...e,
                        sourceMapBaseUrl: `${ t }/`
                    }), e) : e = {
                        ...e,
                        sourceMapBaseUrl: ''
                    };
                };
            },
            5084: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SourceMapFileNameRule = void 0;
                const n = r(4413);
                t.SourceMapFileNameRule = e => {
                    let {sourceMapFileName: t} = e;
                    if (t) {
                        t = t.replace(/^\/+/, '').replace(/(?:\.js)?(?:\.map)?$/, '');
                        let r = t.split(n.StringSeparator.Dot);
                        const i = r.length, a = r[i - 1];
                        i > 1 && a.length <= 3 && (r = r.slice(0, -1)), t = r.join(n.StringSeparator.Dot), e = {
                            ...e,
                            sourceMapFileName: `${ t }.js.map`
                        };
                    }
                    return e;
                };
            },
            6516: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SplitStringsChunkLengthRule = void 0, t.SplitStringsChunkLengthRule = e => 0 === e.splitStringsChunkLength ? {
                    ...e,
                    splitStrings: !1,
                    splitStringsChunkLength: 0
                } : {
                    ...e,
                    splitStringsChunkLength: Math.floor(e.splitStringsChunkLength)
                };
            },
            4101: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayCallsTransformThresholdRule = void 0, t.StringArrayCallsTransformThresholdRule = e => (0 === e.stringArrayCallsTransformThreshold && (e = {
                    ...e,
                    stringArrayCallsTransform: !1,
                    stringArrayCallsTransformThreshold: 0
                }), e);
            },
            9553: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayEncodingRule = void 0;
                const n = r(1296);
                t.StringArrayEncodingRule = e => (e.stringArrayEncoding.length || (e = {
                    ...e,
                    stringArrayEncoding: [n.StringArrayEncoding.None]
                }), e);
            },
            1343: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayRule = void 0;
                const n = r(1296);
                t.StringArrayRule = e => (e.stringArray || (e = {
                    ...e,
                    stringArray: !1,
                    stringArrayCallsTransform: !1,
                    stringArrayCallsTransformThreshold: 0,
                    stringArrayEncoding: [n.StringArrayEncoding.None],
                    stringArrayIndexShift: !1,
                    stringArrayRotate: !1,
                    stringArrayShuffle: !1,
                    stringArrayWrappersChainedCalls: !1,
                    stringArrayWrappersCount: 0,
                    stringArrayThreshold: 0
                }), e);
            },
            3783: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayWrappersChainedCallsRule = void 0, t.StringArrayWrappersChainedCallsRule = e => (0 === e.stringArrayWrappersCount && (e = {
                    ...e,
                    stringArrayWrappersChainedCalls: !1,
                    stringArrayWrappersCount: 0
                }), e);
            },
            2932: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.DEFAULT_PRESET = void 0;
                const n = r(3552), i = r(7081), a = r(4867), o = r(3442), s = r(5138), c = r(3550), u = r(5114), l = r(1296), d = r(679);
                t.DEFAULT_PRESET = Object.freeze({
                    compact: !0,
                    config: '',
                    controlFlowFlattening: !1,
                    controlFlowFlatteningThreshold: 0.75,
                    deadCodeInjection: !1,
                    deadCodeInjectionThreshold: 0.4,
                    debugProtection: !1,
                    debugProtectionInterval: 0,
                    disableConsoleOutput: !1,
                    domainLock: [],
                    domainLockRedirectUrl: 'about:blank',
                    exclude: [],
                    forceTransformStrings: [],
                    identifierNamesCache: null,
                    identifierNamesGenerator: n.IdentifierNamesGenerator.HexadecimalIdentifierNamesGenerator,
                    identifiersPrefix: '',
                    identifiersDictionary: [],
                    ignoreImports: !1,
                    inputFileName: '',
                    log: !1,
                    numbersToExpressions: !1,
                    optionsPreset: a.OptionsPreset.Default,
                    renameGlobals: !1,
                    renameProperties: !1,
                    renamePropertiesMode: o.RenamePropertiesMode.Safe,
                    reservedNames: [],
                    reservedStrings: [],
                    stringArrayRotate: !0,
                    seed: 0,
                    selfDefending: !1,
                    stringArrayShuffle: !0,
                    simplify: !0,
                    sourceMap: !1,
                    sourceMapBaseUrl: '',
                    sourceMapFileName: '',
                    sourceMapMode: s.SourceMapMode.Separate,
                    sourceMapSourcesMode: c.SourceMapSourcesMode.SourcesContent,
                    splitStrings: !1,
                    splitStringsChunkLength: 10,
                    stringArray: !0,
                    stringArrayCallsTransform: !1,
                    stringArrayCallsTransformThreshold: 0.5,
                    stringArrayEncoding: [l.StringArrayEncoding.None],
                    stringArrayIndexesType: [u.StringArrayIndexesType.HexadecimalNumber],
                    stringArrayIndexShift: !0,
                    stringArrayWrappersChainedCalls: !0,
                    stringArrayWrappersCount: 1,
                    stringArrayWrappersParametersMaxCount: 2,
                    stringArrayWrappersType: d.StringArrayWrappersType.Variable,
                    stringArrayThreshold: 0.75,
                    target: i.ObfuscationTarget.Browser,
                    transformObjectKeys: !1,
                    unicodeEscapeSequence: !1
                });
            },
            875: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.HIGH_OBFUSCATION_PRESET = void 0;
                const n = r(4867), i = r(1296), a = r(7312);
                t.HIGH_OBFUSCATION_PRESET = Object.freeze({
                    ...a.MEDIUM_OBFUSCATION_PRESET,
                    controlFlowFlatteningThreshold: 1,
                    deadCodeInjectionThreshold: 1,
                    debugProtection: !0,
                    debugProtectionInterval: 4000,
                    optionsPreset: n.OptionsPreset.HighObfuscation,
                    splitStringsChunkLength: 5,
                    stringArrayCallsTransformThreshold: 1,
                    stringArrayEncoding: [i.StringArrayEncoding.Rc4],
                    stringArrayWrappersCount: 5,
                    stringArrayWrappersParametersMaxCount: 5,
                    stringArrayThreshold: 1
                });
            },
            4503: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.LOW_OBFUSCATION_PRESET = void 0;
                const n = r(4867), i = r(2932);
                t.LOW_OBFUSCATION_PRESET = Object.freeze({
                    ...i.DEFAULT_PRESET,
                    disableConsoleOutput: !0,
                    optionsPreset: n.OptionsPreset.LowObfuscation,
                    stringArrayRotate: !0,
                    selfDefending: !0,
                    simplify: !0,
                    stringArrayCallsTransform: !1,
                    stringArrayCallsTransformThreshold: 0,
                    stringArrayShuffle: !0
                });
            },
            7312: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.MEDIUM_OBFUSCATION_PRESET = void 0;
                const n = r(4867), i = r(1296), a = r(679), o = r(4503);
                t.MEDIUM_OBFUSCATION_PRESET = Object.freeze({
                    ...o.LOW_OBFUSCATION_PRESET,
                    controlFlowFlattening: !0,
                    deadCodeInjection: !0,
                    numbersToExpressions: !0,
                    optionsPreset: n.OptionsPreset.MediumObfuscation,
                    splitStrings: !0,
                    splitStringsChunkLength: 10,
                    stringArrayCallsTransformThreshold: 0.75,
                    stringArrayEncoding: [i.StringArrayEncoding.Base64],
                    stringArrayWrappersCount: 2,
                    stringArrayWrappersParametersMaxCount: 4,
                    stringArrayWrappersType: a.StringArrayWrappersType.Function,
                    transformObjectKeys: !0
                });
            },
            9237: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NO_ADDITIONAL_NODES_PRESET = void 0;
                const n = r(3552), i = r(7081), a = r(3442), o = r(5138), s = r(3550), c = r(1296), u = r(679), l = r(5114);
                t.NO_ADDITIONAL_NODES_PRESET = Object.freeze({
                    compact: !0,
                    controlFlowFlattening: !1,
                    controlFlowFlatteningThreshold: 0,
                    deadCodeInjection: !1,
                    deadCodeInjectionThreshold: 0,
                    debugProtection: !1,
                    debugProtectionInterval: 0,
                    disableConsoleOutput: !1,
                    domainLock: [],
                    domainLockRedirectUrl: 'about:blank',
                    exclude: [],
                    forceTransformStrings: [],
                    identifierNamesGenerator: n.IdentifierNamesGenerator.HexadecimalIdentifierNamesGenerator,
                    identifiersPrefix: '',
                    identifiersDictionary: [],
                    ignoreImports: !1,
                    inputFileName: '',
                    log: !1,
                    numbersToExpressions: !1,
                    renameGlobals: !1,
                    renameProperties: !1,
                    renamePropertiesMode: a.RenamePropertiesMode.Safe,
                    reservedNames: [],
                    reservedStrings: [],
                    stringArrayRotate: !1,
                    seed: 0,
                    selfDefending: !1,
                    stringArrayShuffle: !1,
                    simplify: !1,
                    sourceMap: !1,
                    sourceMapBaseUrl: '',
                    sourceMapFileName: '',
                    sourceMapMode: o.SourceMapMode.Separate,
                    sourceMapSourcesMode: s.SourceMapSourcesMode.SourcesContent,
                    splitStrings: !1,
                    splitStringsChunkLength: 0,
                    stringArray: !1,
                    stringArrayCallsTransform: !1,
                    stringArrayCallsTransformThreshold: 0,
                    stringArrayEncoding: [c.StringArrayEncoding.None],
                    stringArrayIndexesType: [l.StringArrayIndexesType.HexadecimalNumber],
                    stringArrayIndexShift: !1,
                    stringArrayWrappersChainedCalls: !1,
                    stringArrayWrappersCount: 0,
                    stringArrayWrappersParametersMaxCount: 2,
                    stringArrayWrappersType: u.StringArrayWrappersType.Variable,
                    stringArrayThreshold: 0,
                    target: i.ObfuscationTarget.Browser,
                    transformObjectKeys: !1,
                    unicodeEscapeSequence: !1
                });
            },
            6485: function (e, t, r) {
                'use strict';
                var n = this && this.__importDefault || function (e) {
                    return e && e.__esModule ? e : { default: e };
                };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.IsAllowedForObfuscationTargets = void 0;
                const i = r(4571), a = n(r(4063)), o = r(4413), s = r(2932);
                t.IsAllowedForObfuscationTargets = function (e, t) {
                    return (r, n) => {
                        (0, i.registerDecorator)({
                            propertyName: n,
                            constraints: [e],
                            name: 'IsAllowedForObfuscationTargets',
                            options: t,
                            target: r.constructor,
                            validator: {
                                validate(t, r) {
                                    const i = r.object, o = s.DEFAULT_PRESET[n];
                                    return (0, a.default)(t, o) || e.includes(i.target);
                                },
                                defaultMessage: t => `This option allowed only for obfuscation targets: ${ e.join(`${ o.StringSeparator.Comma } `) }`
                            }
                        });
                    };
                };
            },
            4372: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.IsDomainLockRedirectUrl = void 0;
                const n = r(4571), i = r(7081), a = r(2932), o = r(6485);
                t.IsDomainLockRedirectUrl = () => (e, t) => {
                    (0, n.ValidateIf)(({domainLockRedirectUrl: e}) => e !== a.DEFAULT_PRESET.domainLockRedirectUrl)(e, t), (0, n.IsUrl)({
                        require_protocol: !1,
                        require_host: !1
                    })(e, t), (0, o.IsAllowedForObfuscationTargets)([
                        i.ObfuscationTarget.Browser,
                        i.ObfuscationTarget.BrowserNoEval
                    ])(e, t);
                };
            },
            8566: function (e, t, r) {
                'use strict';
                var n = this && this.__importDefault || function (e) {
                    return e && e.__esModule ? e : { default: e };
                };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.IsIdentifierNamesCache = void 0;
                const i = n(r(4063)), a = r(4571), o = r(2932), s = e => {
                        if (void 0 === e)
                            return !0;
                        if ('object' != typeof e || null === e)
                            return !1;
                        const t = Object.values(e);
                        if (!t.length)
                            return !0;
                        for (const e of t)
                            if ('string' != typeof e)
                                return !1;
                        return !0;
                    };
                t.IsIdentifierNamesCache = function (e) {
                    return (t, r) => {
                        (0, a.registerDecorator)({
                            propertyName: r,
                            constraints: [],
                            name: 'IsIdentifierNamesCache',
                            options: e,
                            target: t.constructor,
                            validator: {
                                validate(e, t) {
                                    const n = o.DEFAULT_PRESET[r];
                                    return !(!(0, i.default)(e, n) && null !== e) || 'object' == typeof e && !!s(null == e ? void 0 : e.globalIdentifiers) && s(null == e ? void 0 : e.propertyIdentifiers);
                                },
                                defaultMessage: () => 'Passed value must be an identifier names cache object or `null` value'
                            }
                        });
                    };
                };
            },
            2117: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.IsInputFileName = void 0;
                const n = r(4571), i = r(3550);
                t.IsInputFileName = () => (e, t) => {
                    (0, n.IsString)()(e, t), (0, n.ValidateIf)(({sourceMapSourcesMode: e}) => e === i.SourceMapSourcesMode.Sources)(e, t), (0, n.IsNotEmpty)()(e, t);
                };
            },
            128: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ObfuscationResult = void 0;
                const o = r(6594), s = r(2553), c = r(626), u = r(5138);
                let l = class {
                    constructor(e, t, r, n) {
                        this.cryptUtils = e, this.globalIdentifierNamesCacheStorage = t, this.propertyIdentifierNamesCacheStorage = r, this.options = n;
                    }
                    initialize(e, t) {
                        this.obfuscatedCode = e, this.sourceMap = t;
                    }
                    getIdentifierNamesCache() {
                        return this.options.identifierNamesCache ? {
                            globalIdentifiers: this.globalIdentifierNamesCacheStorage.getStorageAsDictionary(),
                            propertyIdentifiers: this.propertyIdentifierNamesCacheStorage.getStorageAsDictionary()
                        } : null;
                    }
                    getObfuscatedCode() {
                        return this.correctObfuscatedCode();
                    }
                    getOptions() {
                        return this.options;
                    }
                    getSourceMap() {
                        return this.sourceMap;
                    }
                    toString() {
                        return this.obfuscatedCode;
                    }
                    correctObfuscatedCode() {
                        if (!this.sourceMap)
                            return this.obfuscatedCode;
                        const e = this.options.sourceMapBaseUrl + this.options.sourceMapFileName;
                        let t = '//# sourceMappingURL=';
                        switch (this.options.sourceMapMode) {
                        case u.SourceMapMode.Inline:
                            t += `data:application/json;base64,${ this.cryptUtils.btoa(this.sourceMap) }`;
                            break;
                        case u.SourceMapMode.Separate:
                        default:
                            if (!e)
                                return this.obfuscatedCode;
                            t += e;
                        }
                        return `${ this.obfuscatedCode }\n${ t }`;
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], l.prototype, 'obfuscatedCode', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], l.prototype, 'sourceMap', void 0), l = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.ICryptUtils)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IGlobalIdentifierNamesCacheStorage)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IPropertyIdentifierNamesCacheStorage)),
                    a(3, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], l), t.ObfuscationResult = l;
            },
            7865: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SourceCode = void 0, t.SourceCode = class {
                    constructor(e, t) {
                        this.sourceCode = e, this.sourceMap = t;
                    }
                    getSourceCode() {
                        return this.sourceCode;
                    }
                    getSourceMap() {
                        return this.sourceMap;
                    }
                    toString() {
                        return this.sourceCode;
                    }
                };
            },
            9559: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ArrayStorage = void 0;
                const o = r(6594), s = r(2553), c = r(626);
                let u = class {
                    constructor(e, t) {
                        this.storageLength = 0, this.randomGenerator = e, this.options = t;
                    }
                    initialize() {
                        this.storage = [], this.storageId = this.randomGenerator.getRandomString(6);
                    }
                    delete(e) {
                        var t;
                        const r = null !== (t = this.storage.splice(e, 1)[0]) && void 0 !== t ? t : void 0;
                        return r && this.storageLength--, r;
                    }
                    get(e) {
                        return this.storage[e];
                    }
                    getOrThrow(e) {
                        const t = this.get(e);
                        if (!t)
                            throw new Error(`No value found in array storage with key \`${ e }\``);
                        return t;
                    }
                    getKeyOf(e) {
                        const t = this.storage.indexOf(e);
                        return t >= 0 ? t : null;
                    }
                    getLength() {
                        return this.storageLength;
                    }
                    getStorage() {
                        return this.storage;
                    }
                    getStorageId() {
                        return this.storageId;
                    }
                    mergeWith(e, t = !1) {
                        this.storage = [
                            ...this.storage,
                            ...e.getStorage()
                        ], t && (this.storageId = e.getStorageId());
                    }
                    set(e, t) {
                        e === this.storageLength ? this.storage.push(t) : this.storage.splice(e, 0, t), this.storageLength++;
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', Array)
                ], u.prototype, 'storage', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], u.prototype, 'storageId', void 0), n([
                    (0, o.postConstruct)(),
                    i('design:type', Function),
                    i('design:paramtypes', []),
                    i('design:returntype', void 0)
                ], u.prototype, 'initialize', null), u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], u), t.ArrayStorage = u;
            },
            2814: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.MapStorage = void 0;
                const o = r(6594), s = r(2553), c = r(626);
                let u = class {
                    constructor(e, t) {
                        this.randomGenerator = e, this.options = t;
                    }
                    initialize() {
                        this.storage = new Map(), this.storageId = this.randomGenerator.getRandomString(6);
                    }
                    get(e) {
                        return this.storage.get(e);
                    }
                    getOrThrow(e) {
                        const t = this.get(e);
                        if (!t)
                            throw new Error(`No value found in map storage with key \`${ e }\``);
                        return t;
                    }
                    getKeyOf(e) {
                        for (const [t, r] of this.storage)
                            if (e === r)
                                return t;
                        return null;
                    }
                    getLength() {
                        return this.storage.size;
                    }
                    getStorage() {
                        return this.storage;
                    }
                    getStorageAsDictionary() {
                        return Object.fromEntries(this.storage);
                    }
                    getStorageId() {
                        return this.storageId;
                    }
                    has(e) {
                        return this.storage.has(e);
                    }
                    mergeWith(e, t = !1) {
                        this.storage = new Map([
                            ...this.storage,
                            ...e.getStorage()
                        ]), t && (this.storageId = e.getStorageId());
                    }
                    set(e, t) {
                        this.storage.set(e, t);
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], u.prototype, 'storageId', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', Map)
                ], u.prototype, 'storage', void 0), n([
                    (0, o.postConstruct)(),
                    i('design:type', Function),
                    i('design:paramtypes', []),
                    i('design:returntype', void 0)
                ], u.prototype, 'initialize', null), u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], u), t.MapStorage = u;
            },
            6000: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.WeakMapStorage = void 0;
                const o = r(6594), s = r(2553), c = r(626);
                let u = class {
                    constructor(e, t) {
                        this.randomGenerator = e, this.options = t;
                    }
                    initialize() {
                        this.storage = new Map(), this.storageId = this.randomGenerator.getRandomString(6);
                    }
                    get(e) {
                        return this.storage.get(e);
                    }
                    getOrThrow(e) {
                        const t = this.get(e);
                        if (!t)
                            throw new Error(`No value found in weak map storage with key \`${ e }\``);
                        return t;
                    }
                    getStorage() {
                        return this.storage;
                    }
                    getStorageId() {
                        return this.storageId;
                    }
                    has(e) {
                        return this.storage.has(e);
                    }
                    set(e, t) {
                        this.storage.set(e, t);
                    }
                };
                n([
                    (0, c.initializable)(),
                    i('design:type', String)
                ], u.prototype, 'storageId', void 0), n([
                    (0, c.initializable)(),
                    i('design:type', WeakMap)
                ], u.prototype, 'storage', void 0), n([
                    (0, o.postConstruct)(),
                    i('design:type', Function),
                    i('design:paramtypes', []),
                    i('design:returntype', void 0)
                ], u.prototype, 'initialize', null), u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], u), t.WeakMapStorage = u;
            },
            4576: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.FunctionControlFlowStorage = void 0;
                const o = r(6594), s = r(2553), c = r(2814);
                let u = class extends c.MapStorage {
                    constructor(e, t, r) {
                        super(e, t), this.identifierNamesGenerator = r(t);
                    }
                };
                u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Function
                    ])
                ], u), t.FunctionControlFlowStorage = u;
            },
            5455: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringControlFlowStorage = void 0;
                const o = r(6594), s = r(2553), c = r(4576);
                let u = class extends c.FunctionControlFlowStorage {
                    constructor(e, t, r) {
                        super(e, t, r);
                    }
                    initialize() {
                        super.initialize(), this.storageId = this.identifierNamesGenerator.generateForGlobalScope();
                    }
                };
                u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Function
                    ])
                ], u), t.StringControlFlowStorage = u;
            },
            7359: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CustomCodeHelperGroupStorage = void 0;
                const s = r(6594), c = r(2553), u = r(7705), l = r(2814);
                let d = n = class extends l.MapStorage {
                    constructor(e, t, r) {
                        super(t, r), this.customCodeHelperGroupFactory = e;
                    }
                    initialize() {
                        super.initialize(), n.customCodeHelperGroupsList.forEach(e => {
                            const t = this.customCodeHelperGroupFactory(e);
                            this.storage.set(e, t);
                        });
                    }
                };
                d.customCodeHelperGroupsList = [
                    u.CustomCodeHelperGroup.ConsoleOutput,
                    u.CustomCodeHelperGroup.DebugProtection,
                    u.CustomCodeHelperGroup.DomainLock,
                    u.CustomCodeHelperGroup.SelfDefending,
                    u.CustomCodeHelperGroup.StringArray
                ], i([
                    (0, s.postConstruct)(),
                    a('design:type', Function),
                    a('design:paramtypes', []),
                    a('design:returntype', void 0)
                ], d.prototype, 'initialize', null), d = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__ICustomCodeHelperGroup)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Function,
                        Object,
                        Object
                    ])
                ], d), t.CustomCodeHelperGroupStorage = d;
            },
            9469: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.GlobalIdentifierNamesCacheStorage = void 0;
                const o = r(6594), s = r(2553), c = r(2814);
                let u = class extends c.MapStorage {
                    constructor(e, t) {
                        super(e, t);
                    }
                    initialize() {
                        var e, t;
                        super.initialize(), this.storage = new Map(Object.entries(null !== (t = null === (e = this.options.identifierNamesCache) || void 0 === e ? void 0 : e.globalIdentifiers) && void 0 !== t ? t : {}));
                    }
                };
                n([
                    (0, o.postConstruct)(),
                    i('design:type', Function),
                    i('design:paramtypes', []),
                    i('design:returntype', void 0)
                ], u.prototype, 'initialize', null), u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], u), t.GlobalIdentifierNamesCacheStorage = u;
            },
            4642: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.PropertyIdentifierNamesCacheStorage = void 0;
                const o = r(6594), s = r(2553), c = r(2814);
                let u = class extends c.MapStorage {
                    constructor(e, t) {
                        super(e, t);
                    }
                    initialize() {
                        var e, t;
                        super.initialize(), this.storage = new Map(Object.entries(null !== (t = null === (e = this.options.identifierNamesCache) || void 0 === e ? void 0 : e.propertyIdentifiers) && void 0 !== t ? t : {}));
                    }
                };
                n([
                    (0, o.postConstruct)(),
                    i('design:type', Function),
                    i('design:paramtypes', []),
                    i('design:returntype', void 0)
                ], u.prototype, 'initialize', null), u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], u), t.PropertyIdentifierNamesCacheStorage = u;
            },
            5159: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.LiteralNodesCacheStorage = void 0;
                const o = r(6594), s = r(2553), c = r(1296), u = r(2814);
                let l = class extends u.MapStorage {
                    constructor(e, t) {
                        super(e, t);
                    }
                    buildKey(e, t) {
                        return `${ e }-${ Boolean(t) }`;
                    }
                    shouldUseCachedValue(e, t) {
                        return !this.options.stringArrayWrappersCount && (null == t ? void 0 : t.encoding) !== c.StringArrayEncoding.Rc4 && this.storage.has(e);
                    }
                };
                l = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], l), t.LiteralNodesCacheStorage = l;
            },
            5275: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayScopeCallsWrappersDataStorage = void 0;
                const o = r(6594), s = r(2553), c = r(6000);
                let u = class extends c.WeakMapStorage {
                    constructor(e, t) {
                        super(e, t);
                    }
                };
                u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    i('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], u), t.StringArrayScopeCallsWrappersDataStorage = u;
            },
            5046: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringArrayStorage = void 0;
                const s = r(6594), c = r(2553), u = r(1296), l = r(2814);
                let d = n = class extends l.MapStorage {
                    constructor(e, t, r, i, a) {
                        super(r, i), this.rc4EncodedValuesSourcesCache = new Map(), this.indexShiftAmount = 0, this.rotationAmount = 0, this.stringArrayStorageCallsWrapperNamesMap = new Map(), this.identifierNamesGenerator = e(i), this.arrayUtils = t, this.cryptUtilsStringArray = a, this.rc4Keys = this.randomGenerator.getRandomGenerator().n(() => this.randomGenerator.getRandomGenerator().string({ length: n.rc4KeyLength }), n.rc4KeysCount);
                    }
                    initialize() {
                        super.initialize(), this.indexShiftAmount = this.options.stringArrayIndexShift ? this.randomGenerator.getRandomInteger(n.minimumIndexShiftAmount, n.maximumIndexShiftAmount) : 0, this.rotationAmount = this.options.stringArrayRotate ? this.randomGenerator.getRandomInteger(n.minimumRotationAmount, n.maximumRotationAmount) : 0;
                    }
                    get(e) {
                        return this.getOrSetIfDoesNotExist(e);
                    }
                    getIndexShiftAmount() {
                        return this.indexShiftAmount;
                    }
                    getRotationAmount() {
                        return this.rotationAmount;
                    }
                    getStorageName() {
                        return this.getStorageId();
                    }
                    getStorageId() {
                        return this.stringArrayStorageName || (this.stringArrayStorageName = this.identifierNamesGenerator.generateForGlobalScope(n.stringArrayFunctionNameLength)), this.stringArrayStorageName;
                    }
                    getStorageCallsWrapperName(e) {
                        var t;
                        const r = null !== (t = this.stringArrayStorageCallsWrapperNamesMap.get(e)) && void 0 !== t ? t : null;
                        if (r)
                            return r;
                        const i = this.identifierNamesGenerator.generateForGlobalScope(n.stringArrayFunctionNameLength);
                        return this.stringArrayStorageCallsWrapperNamesMap.set(e, i), i;
                    }
                    rotateStorage() {
                        this.getLength() && (this.storage = new Map(this.arrayUtils.rotate(Array.from(this.storage.entries()), this.rotationAmount)));
                    }
                    shuffleStorage() {
                        this.storage = new Map(this.arrayUtils.shuffle(Array.from(this.storage.entries())).map(([e, t], r) => (t.index = r, [
                            e,
                            t
                        ])).sort(([, e], [, t]) => e.index - t.index));
                    }
                    getOrSetIfDoesNotExist(e) {
                        const {
                                encodedValue: t,
                                encoding: r,
                                decodeKey: n
                            } = this.getEncodedValue(e), i = `${ t }-${ r }`, a = this.storage.get(i);
                        if (a)
                            return a;
                        const o = {
                            encodedValue: t,
                            encoding: r,
                            decodeKey: n,
                            value: e,
                            index: this.getLength()
                        };
                        return this.storage.set(i, o), o;
                    }
                    getEncodedValue(e) {
                        var t;
                        const r = this.options.stringArrayEncoding.length ? this.randomGenerator.getRandomGenerator().pickone(this.options.stringArrayEncoding) : null;
                        if (!r)
                            throw new Error('`stringArrayEncoding` option array is empty');
                        switch (r) {
                        case u.StringArrayEncoding.Rc4: {
                                const n = this.randomGenerator.getRandomGenerator().pickone(this.rc4Keys), i = this.cryptUtilsStringArray.btoa(this.cryptUtilsStringArray.rc4(e, n)), a = null !== (t = this.rc4EncodedValuesSourcesCache.get(i)) && void 0 !== t ? t : [];
                                let o = a.length;
                                return (!o || !a.includes(e)) && (a.push(e), o++), this.rc4EncodedValuesSourcesCache.set(i, a), o > 1 ? this.getEncodedValue(e) : {
                                    encodedValue: i,
                                    encoding: r,
                                    decodeKey: n
                                };
                            }
                        case u.StringArrayEncoding.Base64: {
                                const t = null;
                                return {
                                    encodedValue: this.cryptUtilsStringArray.btoa(e),
                                    encoding: r,
                                    decodeKey: t
                                };
                            }
                        default:
                            return {
                                encodedValue: e,
                                encoding: r,
                                decodeKey: null
                            };
                        }
                    }
                };
                d.minimumRotationAmount = 100, d.maximumRotationAmount = 500, d.minimumIndexShiftAmount = 100, d.maximumIndexShiftAmount = 500, d.rc4KeyLength = 4, d.rc4KeysCount = 50, d.stringArrayFunctionNameLength = 4, i([
                    (0, s.postConstruct)(),
                    a('design:type', Function),
                    a('design:paramtypes', []),
                    a('design:returntype', void 0)
                ], d.prototype, 'initialize', null), d = n = i([
                    (0, s.injectable)(),
                    o(0, (0, s.inject)(c.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
                    o(1, (0, s.inject)(c.ServiceIdentifiers.IArrayUtils)),
                    o(2, (0, s.inject)(c.ServiceIdentifiers.IRandomGenerator)),
                    o(3, (0, s.inject)(c.ServiceIdentifiers.IOptions)),
                    o(4, (0, s.inject)(c.ServiceIdentifiers.ICryptUtilsStringArray)),
                    a('design:paramtypes', [
                        Function,
                        Object,
                        Object,
                        Object,
                        Object
                    ])
                ], d), t.StringArrayStorage = d;
            },
            3621: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.VisitedLexicalScopeNodesStackStorage = void 0;
                const o = r(6594), s = r(2553), c = r(9559);
                let u = class extends c.ArrayStorage {
                    constructor(e, t, r) {
                        super(e, t), this.arrayUtils = r;
                    }
                    getLastElement() {
                        return this.arrayUtils.getLastElement(this.getStorage());
                    }
                    getPenultimateElement() {
                        return this.arrayUtils.getLastElementByIndex(this.getStorage(), 1);
                    }
                    push(e) {
                        const t = this.getLength();
                        this.set(t, e);
                    }
                    pop() {
                        const e = this.getLength();
                        return this.delete(e - 1);
                    }
                };
                u = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    a(1, (0, o.inject)(s.ServiceIdentifiers.IOptions)),
                    a(2, (0, o.inject)(s.ServiceIdentifiers.IArrayUtils)),
                    i('design:paramtypes', [
                        Object,
                        Object,
                        Object
                    ])
                ], u), t.VisitedLexicalScopeNodesStackStorage = u;
            },
            576: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.AbstractTransformerNamesGroupsBuilder = void 0;
                const o = r(6594), s = r(2553);
                let c = class {
                    constructor(e) {
                        this.levelledTopologicalSorter = e;
                    }
                    build(e) {
                        const t = Object.keys(e), r = this.buildTransformersRelationEdges(t, e);
                        for (const [e, t] of r)
                            this.levelledTopologicalSorter.add(e, t);
                        return this.levelledTopologicalSorter.sortByGroups();
                    }
                    buildTransformersRelationEdges(e, t) {
                        const r = [];
                        for (const n of e) {
                            const e = t[n].runAfter;
                            if (null == e ? void 0 : e.length)
                                for (const i of e)
                                    void 0 === t[i] ? r.push([
                                        n,
                                        null
                                    ]) : r.push([
                                        i,
                                        n
                                    ]);
                            else
                                r.push([
                                    n,
                                    null
                                ]);
                        }
                        return r;
                    }
                };
                c = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.ILevelledTopologicalSorter)),
                    i('design:paramtypes', [Object])
                ], c), t.AbstractTransformerNamesGroupsBuilder = c;
            },
            6959: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.ArrayUtils = void 0;
                const o = r(6594), s = r(2553);
                let c = class {
                    constructor(e) {
                        this.randomGenerator = e;
                    }
                    createWithRange(e) {
                        const t = [];
                        for (let r = 0; r < e; r++)
                            t.push(r);
                        return t;
                    }
                    fillWithRange(e, t) {
                        const r = [];
                        for (let n = 0; n < e; n++)
                            r.push(t(n));
                        return r;
                    }
                    findMostOccurringElement(e) {
                        var t;
                        if (!e.length)
                            return null;
                        const r = {};
                        let n = e[0], i = 1;
                        for (const a of e) {
                            const e = (null !== (t = r[a]) && void 0 !== t ? t : 0) + 1;
                            e > i && (n = a, i = e), r[a] = e;
                        }
                        return n;
                    }
                    getLastElement(e) {
                        return this.getLastElementByIndex(e, 0);
                    }
                    getLastElementByIndex(e, t) {
                        var r;
                        return null !== (r = e[e.length - 1 - t]) && void 0 !== r ? r : void 0;
                    }
                    rotate(e, t) {
                        if (!e.length)
                            throw new ReferenceError('Cannot rotate empty array.');
                        if (t <= 0)
                            return e;
                        const r = e;
                        let n;
                        for (; t--;)
                            n = r.pop(), n && r.unshift(n);
                        return r;
                    }
                    shuffle(e) {
                        const t = [...e];
                        for (let e = t.length; e; e--) {
                            const r = Math.floor(this.randomGenerator.getMathRandom() * e);
                            [t[e - 1], t[r]] = [
                                t[r],
                                t[e - 1]
                            ];
                        }
                        return t;
                    }
                };
                c = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    i('design:paramtypes', [Object])
                ], c), t.ArrayUtils = c;
            },
            5678: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CryptUtils = void 0;
                const o = r(6594), s = r(2553), c = r(1047), u = r(4291), l = r(1700);
                let d = class {
                    constructor(e) {
                        this.base64Alphabet = c.base64alphabet, this.randomGenerator = e;
                    }
                    btoa(e) {
                        const t = this.base64Alphabet;
                        let r = '';
                        e = encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, (e, t) => String.fromCharCode(parseInt(`${ l.Utils.hexadecimalPrefix }${ t }`, 16)));
                        for (let n, i, a = 0, o = t; e.charAt(0 | a) || (o = '=', a % 1); r += o.charAt(63 & n >> 8 - a % 1 * 8)) {
                            if (i = e.charCodeAt(a += 3 / 4), i > 255)
                                throw new Error('\'btoa\' failed: The string to be encoded contains characters outside of the Latin1 range.');
                            n = n << 8 | i;
                        }
                        return r;
                    }
                    hideString(e, t) {
                        let r = this.randomGenerator.getRandomGenerator().string({
                            length: t,
                            pool: u.RandomGenerator.randomGeneratorPool
                        }).replace(new RegExp(`[${ n = e, n.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') }]`, 'g'), '');
                        var n;
                        const i = r.split('');
                        return this.randomGenerator.getRandomGenerator().shuffle(i), r = i.join(''), [
                            ((e, t) => {
                                let r = -1, n = -1, i = '';
                                for (; r < e.length || n < t.length;)
                                    this.randomGenerator.getMathRandom() < 0.5 && n < t.length ? i += t.charAt(++n) : i += e.charAt(++r);
                                return i;
                            })(e, r),
                            r
                        ];
                    }
                    rc4(e, t) {
                        const r = [];
                        let n, i = 0, a = '';
                        for (var o = 0; o < 256; o++)
                            r[o] = o;
                        for (o = 0; o < 256; o++)
                            i = (i + r[o] + t.charCodeAt(o % t.length)) % 256, n = r[o], r[o] = r[i], r[i] = n;
                        o = 0, i = 0;
                        for (let t = 0; t < e.length; t++)
                            i = (i + r[o = (o + 1) % 256]) % 256, n = r[o], r[o] = r[i], r[i] = n, a += String.fromCharCode(e.charCodeAt(t) ^ r[(r[o] + r[i]) % 256]);
                        return a;
                    }
                };
                d = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    i('design:paramtypes', [Object])
                ], d), t.CryptUtils = d;
            },
            7301: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.CryptUtilsStringArray = void 0;
                const o = r(6594), s = r(2553), c = r(99), u = r(5678);
                let l = class extends u.CryptUtils {
                    constructor(e) {
                        super(e), this.base64Alphabet = c.base64alphabetSwapped;
                    }
                    btoa(e) {
                        return super.btoa(e).replace(/=+$/, '');
                    }
                };
                l = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IRandomGenerator)),
                    i('design:paramtypes', [Object])
                ], l), t.CryptUtilsStringArray = l;
            },
            3062: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.EscapeSequenceEncoder = void 0;
                const a = r(6594);
                let o = n = class {
                    constructor() {
                        this.stringsCache = new Map();
                    }
                    encode(e, t) {
                        const r = `${ e }-${ String(t) }`;
                        if (this.stringsCache.has(r))
                            return this.stringsCache.get(r);
                        const i = new RegExp('[\\s\\S]', 'g');
                        let a, o;
                        const s = e.replace(i, e => t || n.forceEscapeCharactersRegExp.test(e) ? (n.ASCIICharactersRegExp.test(e) ? (a = '\\x', o = '00') : (a = '\\u', o = '0000'), `${ a }${ (o + e.charCodeAt(0).toString(16)).slice(-o.length) }`) : e);
                        return this.stringsCache.set(r, s), this.stringsCache.set(`${ s }-${ String(t) }`, s), s;
                    }
                };
                o.ASCIICharactersRegExp = /[\x00-\x7F]/, o.forceEscapeCharactersRegExp = /[\x00-\x1F\x7F-\x9F'"\\\s]/, o = n = i([(0, a.injectable)()], o), t.EscapeSequenceEncoder = o;
            },
            5579: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                    var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                    if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                        o = Reflect.decorate(e, t, r, n);
                    else
                        for (var s = e.length - 1; s >= 0; s--)
                            (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                    return a > 3 && o && Object.defineProperty(t, r, o), o;
                };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.LevelledTopologicalSorter = void 0;
                const i = r(6594);
                let a = class {
                    constructor() {
                        this.graph = new Map();
                    }
                    add(e, t = null) {
                        return null !== t ? this.link(e, t) : this.register(e);
                    }
                    sort() {
                        const e = Array.from(this.graph.keys()), t = [], r = {};
                        for (const n of e)
                            void 0 === r[n] && this.visit(t, r, n);
                        return t;
                    }
                    sortByGroups() {
                        this.sort();
                        const e = [];
                        for (; this.hasNodes();) {
                            const t = this.findRootNodes();
                            e.push(t);
                            for (const e of t)
                                this.delete(e);
                        }
                        return e;
                    }
                    delete(e) {
                        if (this.getPrecedents(e).length)
                            throw new Error(`Unable to remove non-root node: ${ e }`);
                        this.graph.delete(e);
                        const t = Array.from(this.graph.values());
                        for (const r of t)
                            for (let t = r.length - 1; t >= 0; t -= 1)
                                r[t] === e && r.splice(t, 1);
                    }
                    findRootNodes() {
                        const e = Array.from(this.graph.keys()), t = [];
                        for (const r of e)
                            this.hasPrecedents(r) || t.push(r);
                        return t;
                    }
                    getPrecedents(e) {
                        const t = this.graph.get(e);
                        if (!t)
                            throw new Error(`Unknown node: ${ e }`);
                        return t;
                    }
                    hasNodes() {
                        return this.graph.size > 0;
                    }
                    hasPrecedents(e) {
                        return this.getPrecedents(e).length > 0;
                    }
                    link(e, t) {
                        this.register(e), this.register(t);
                        const r = this.graph.get(t);
                        return r && !r.includes(e) && r.push(e), this;
                    }
                    register(e) {
                        return this.graph.has(e) || this.graph.set(e, []), this;
                    }
                    visit(e, t, r) {
                        const n = t[r];
                        if ('visiting' === n)
                            throw new Error(`Detected cycle involving node: ${ r }`);
                        if (n)
                            return;
                        t[r] = 'visiting';
                        const i = this.getPrecedents(r);
                        for (const r of i)
                            this.visit(e, t, r);
                        t[r] = 'ok', e.push(r);
                    }
                };
                a = n([(0, i.injectable)()], a), t.LevelledTopologicalSorter = a;
            },
            2303: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.NumberUtils = void 0;
                const n = r(1700);
                t.NumberUtils = class {
                    static toHex(e) {
                        const t = 'number' == typeof e ? e.toString(16) : `${ e.toString(16) }n`;
                        return `${ n.Utils.hexadecimalPrefix }${ t }`;
                    }
                    static extractIntegerAndDecimalParts(e) {
                        const t = Math.trunc(e);
                        return [
                            t,
                            e !== t ? e % 1 : null
                        ];
                    }
                    static isCeil(e) {
                        return 'number' != typeof e || e % 1 == 0;
                    }
                    static isPositive(e) {
                        if (isNaN(e))
                            throw new Error('Given value is NaN');
                        return e > 0 || !(e < 0) && 1 / e === Number.POSITIVE_INFINITY;
                    }
                    static isUnsafeNumber(e) {
                        if (isNaN(e))
                            throw new Error('Given value is NaN');
                        return e < Number.MIN_SAFE_INTEGER || e > Number.MAX_SAFE_INTEGER;
                    }
                    static getFactors(e) {
                        if (0 === e)
                            throw new Error('Invalid number. Allowed only non-zero number');
                        if (1 === (e = Math.abs(e)))
                            return [
                                -e,
                                e
                            ];
                        const t = [], r = Math.sqrt(e), n = e % 2 == 0 ? 1 : 2;
                        for (let i = 1; i <= r; i += n) {
                            const r = e / i;
                            e - Math.floor(r) * i != 0 || (t.push(-i, i), r !== i && t.push(-r, r));
                        }
                        return t.sort((e, t) => e - t);
                    }
                };
            },
            4291: function (e, t, r) {
                'use strict';
                var n, i = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, a = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, o = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    }, s = this && this.__importDefault || function (e) {
                        return e && e.__esModule ? e : { default: e };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.RandomGenerator = void 0;
                const c = r(6594), u = r(2553), l = s(r(2568)), d = r(714), p = r(626), f = r(3477), m = r(4287);
                let h = n = class {
                    constructor(e, t) {
                        this.sourceCode = e, this.options = t;
                    }
                    initialize() {
                        this.randomGenerator = new d.Chance(this.getRawSeed());
                    }
                    getMathRandom() {
                        return this.getRandomInteger(0, 99999) / 100000;
                    }
                    getRandomGenerator() {
                        return this.randomGenerator;
                    }
                    getRandomInteger(e, t) {
                        return this.getRandomGenerator().integer({
                            min: e,
                            max: t
                        });
                    }
                    getRandomIntegerExcluding(e, t, r) {
                        const n = [];
                        for (let i = e; i <= t; i++)
                            r.includes(i) || n.push(i);
                        return this.randomGenerator.pickone(n);
                    }
                    getRandomString(e, t = n.randomGeneratorPool) {
                        return this.getRandomGenerator().string({
                            length: e,
                            pool: t
                        });
                    }
                    getInputSeed() {
                        return this.options.seed.toString();
                    }
                    getRawSeed() {
                        const e = this.getInputSeed();
                        return `${ e }`.split('|').length > 1 ? e : `${ e }|${ (0, l.default)(this.sourceCode.getSourceCode()) }`;
                    }
                };
                h.randomGeneratorPool = `${ f.alphabetString }${ m.alphabetStringUppercase }`, i([
                    (0, p.initializable)(),
                    a('design:type', Object)
                ], h.prototype, 'randomGenerator', void 0), i([
                    (0, c.postConstruct)(),
                    a('design:type', Function),
                    a('design:paramtypes', []),
                    a('design:returntype', void 0)
                ], h.prototype, 'initialize', null), h = n = i([
                    (0, c.injectable)(),
                    o(0, (0, c.inject)(u.ServiceIdentifiers.ISourceCode)),
                    o(1, (0, c.inject)(u.ServiceIdentifiers.IOptions)),
                    a('design:paramtypes', [
                        Object,
                        Object
                    ])
                ], h), t.RandomGenerator = h;
            },
            1586: function (e, t, r) {
                'use strict';
                var n = this && this.__decorate || function (e, t, r, n) {
                        var i, a = arguments.length, o = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                            o = Reflect.decorate(e, t, r, n);
                        else
                            for (var s = e.length - 1; s >= 0; s--)
                                (i = e[s]) && (o = (a < 3 ? i(o) : a > 3 ? i(t, r, o) : i(t, r)) || o);
                        return a > 3 && o && Object.defineProperty(t, r, o), o;
                    }, i = this && this.__metadata || function (e, t) {
                        if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata)
                            return Reflect.metadata(e, t);
                    }, a = this && this.__param || function (e, t) {
                        return function (r, n) {
                            t(r, n, e);
                        };
                    };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.SetUtils = void 0;
                const o = r(6594), s = r(2553);
                let c = class {
                    constructor(e) {
                        this.arrayUtils = e;
                    }
                    getLastElement(e) {
                        const t = [...e];
                        return this.arrayUtils.getLastElement(t);
                    }
                };
                c = n([
                    (0, o.injectable)(),
                    a(0, (0, o.inject)(s.ServiceIdentifiers.IArrayUtils)),
                    i('design:paramtypes', [Object])
                ], c), t.SetUtils = c;
            },
            6493: function (e, t, r) {
                'use strict';
                var n = this && this.__importDefault || function (e) {
                    return e && e.__esModule ? e : { default: e };
                };
                Object.defineProperty(t, '__esModule', { value: !0 }), t.StringUtils = void 0;
                const i = n(r(1153));
                t.StringUtils = class {
                    static escapeJsString(e) {
                        return (0, i.default)(e);
                    }
                };
            },
            1700: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.Utils = void 0;
                class r {
                    static buildVersionMessage(e, t) {
                        return e && t ? `${ e }_${ new Date(parseInt(t, 10)).toISOString() }` : 'unknown';
                    }
                    static extractDomainFrom(e) {
                        let t;
                        return t = e.includes('://') || 0 === e.indexOf('//') ? e.split('/')[2] : e.split('/')[0], t = t.split(':')[0], t;
                    }
                    static getIdentifiersPrefixForMultipleSources(e, t) {
                        return `${ e || r.baseMultipleSourcesIdentifiersPrefix }${ t }`;
                    }
                    static makeEnum(e) {
                        return Object.freeze({ ...e });
                    }
                }
                t.Utils = r, r.baseMultipleSourcesIdentifiersPrefix = 'a', r.hexadecimalPrefix = '0x';
            },
            6231: (e, t, r) => {
                'use strict';
                var n, i = TypeError, a = Object.getOwnPropertyDescriptor;
                if (a)
                    try {
                        a({}, '');
                    } catch (e) {
                        a = null;
                    }
                var o = function () {
                        throw new i();
                    }, s = a ? function () {
                        try {
                            return o;
                        } catch (e) {
                            try {
                                return a(arguments, 'callee').get;
                            } catch (e) {
                                return o;
                            }
                        }
                    }() : o, c = r(1405)(), u = Object.getPrototypeOf || function (e) {
                        return e.__proto__;
                    }, l = n, d = 'undefined' == typeof Uint8Array ? n : u(Uint8Array), p = {
                        '%Array%': Array,
                        '%ArrayBuffer%': 'undefined' == typeof ArrayBuffer ? n : ArrayBuffer,
                        '%ArrayBufferPrototype%': 'undefined' == typeof ArrayBuffer ? n : ArrayBuffer.prototype,
                        '%ArrayIteratorPrototype%': c ? u([][Symbol.iterator]()) : n,
                        '%ArrayPrototype%': Array.prototype,
                        '%ArrayProto_entries%': Array.prototype.entries,
                        '%ArrayProto_forEach%': Array.prototype.forEach,
                        '%ArrayProto_keys%': Array.prototype.keys,
                        '%ArrayProto_values%': Array.prototype.values,
                        '%AsyncFromSyncIteratorPrototype%': n,
                        '%AsyncFunction%': undefined,
                        '%AsyncFunctionPrototype%': n,
                        '%AsyncGenerator%': n,
                        '%AsyncGeneratorFunction%': undefined,
                        '%AsyncGeneratorPrototype%': n,
                        '%AsyncIteratorPrototype%': l && c && Symbol.asyncIterator ? l[Symbol.asyncIterator]() : n,
                        '%Atomics%': 'undefined' == typeof Atomics ? n : Atomics,
                        '%Boolean%': Boolean,
                        '%BooleanPrototype%': Boolean.prototype,
                        '%DataView%': 'undefined' == typeof DataView ? n : DataView,
                        '%DataViewPrototype%': 'undefined' == typeof DataView ? n : DataView.prototype,
                        '%Date%': Date,
                        '%DatePrototype%': Date.prototype,
                        '%decodeURI%': decodeURI,
                        '%decodeURIComponent%': decodeURIComponent,
                        '%encodeURI%': encodeURI,
                        '%encodeURIComponent%': encodeURIComponent,
                        '%Error%': Error,
                        '%ErrorPrototype%': Error.prototype,
                        '%eval%': eval,
                        '%EvalError%': EvalError,
                        '%EvalErrorPrototype%': EvalError.prototype,
                        '%Float32Array%': 'undefined' == typeof Float32Array ? n : Float32Array,
                        '%Float32ArrayPrototype%': 'undefined' == typeof Float32Array ? n : Float32Array.prototype,
                        '%Float64Array%': 'undefined' == typeof Float64Array ? n : Float64Array,
                        '%Float64ArrayPrototype%': 'undefined' == typeof Float64Array ? n : Float64Array.prototype,
                        '%Function%': Function,
                        '%FunctionPrototype%': Function.prototype,
                        '%Generator%': n,
                        '%GeneratorFunction%': undefined,
                        '%GeneratorPrototype%': n,
                        '%Int8Array%': 'undefined' == typeof Int8Array ? n : Int8Array,
                        '%Int8ArrayPrototype%': 'undefined' == typeof Int8Array ? n : Int8Array.prototype,
                        '%Int16Array%': 'undefined' == typeof Int16Array ? n : Int16Array,
                        '%Int16ArrayPrototype%': 'undefined' == typeof Int16Array ? n : Int8Array.prototype,
                        '%Int32Array%': 'undefined' == typeof Int32Array ? n : Int32Array,
                        '%Int32ArrayPrototype%': 'undefined' == typeof Int32Array ? n : Int32Array.prototype,
                        '%isFinite%': isFinite,
                        '%isNaN%': isNaN,
                        '%IteratorPrototype%': c ? u(u([][Symbol.iterator]())) : n,
                        '%JSON%': 'object' == typeof JSON ? JSON : n,
                        '%JSONParse%': 'object' == typeof JSON ? JSON.parse : n,
                        '%Map%': 'undefined' == typeof Map ? n : Map,
                        '%MapIteratorPrototype%': 'undefined' != typeof Map && c ? u(new Map()[Symbol.iterator]()) : n,
                        '%MapPrototype%': 'undefined' == typeof Map ? n : Map.prototype,
                        '%Math%': Math,
                        '%Number%': Number,
                        '%NumberPrototype%': Number.prototype,
                        '%Object%': Object,
                        '%ObjectPrototype%': Object.prototype,
                        '%ObjProto_toString%': Object.prototype.toString,
                        '%ObjProto_valueOf%': Object.prototype.valueOf,
                        '%parseFloat%': parseFloat,
                        '%parseInt%': parseInt,
                        '%Promise%': 'undefined' == typeof Promise ? n : Promise,
                        '%PromisePrototype%': 'undefined' == typeof Promise ? n : Promise.prototype,
                        '%PromiseProto_then%': 'undefined' == typeof Promise ? n : Promise.prototype.then,
                        '%Promise_all%': 'undefined' == typeof Promise ? n : Promise.all,
                        '%Promise_reject%': 'undefined' == typeof Promise ? n : Promise.reject,
                        '%Promise_resolve%': 'undefined' == typeof Promise ? n : Promise.resolve,
                        '%Proxy%': 'undefined' == typeof Proxy ? n : Proxy,
                        '%RangeError%': RangeError,
                        '%RangeErrorPrototype%': RangeError.prototype,
                        '%ReferenceError%': ReferenceError,
                        '%ReferenceErrorPrototype%': ReferenceError.prototype,
                        '%Reflect%': 'undefined' == typeof Reflect ? n : Reflect,
                        '%RegExp%': RegExp,
                        '%RegExpPrototype%': RegExp.prototype,
                        '%Set%': 'undefined' == typeof Set ? n : Set,
                        '%SetIteratorPrototype%': 'undefined' != typeof Set && c ? u(new Set()[Symbol.iterator]()) : n,
                        '%SetPrototype%': 'undefined' == typeof Set ? n : Set.prototype,
                        '%SharedArrayBuffer%': 'undefined' == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
                        '%SharedArrayBufferPrototype%': 'undefined' == typeof SharedArrayBuffer ? n : SharedArrayBuffer.prototype,
                        '%String%': String,
                        '%StringIteratorPrototype%': c ? u(''[Symbol.iterator]()) : n,
                        '%StringPrototype%': String.prototype,
                        '%Symbol%': c ? Symbol : n,
                        '%SymbolPrototype%': c ? Symbol.prototype : n,
                        '%SyntaxError%': SyntaxError,
                        '%SyntaxErrorPrototype%': SyntaxError.prototype,
                        '%ThrowTypeError%': s,
                        '%TypedArray%': d,
                        '%TypedArrayPrototype%': d ? d.prototype : n,
                        '%TypeError%': i,
                        '%TypeErrorPrototype%': i.prototype,
                        '%Uint8Array%': 'undefined' == typeof Uint8Array ? n : Uint8Array,
                        '%Uint8ArrayPrototype%': 'undefined' == typeof Uint8Array ? n : Uint8Array.prototype,
                        '%Uint8ClampedArray%': 'undefined' == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
                        '%Uint8ClampedArrayPrototype%': 'undefined' == typeof Uint8ClampedArray ? n : Uint8ClampedArray.prototype,
                        '%Uint16Array%': 'undefined' == typeof Uint16Array ? n : Uint16Array,
                        '%Uint16ArrayPrototype%': 'undefined' == typeof Uint16Array ? n : Uint16Array.prototype,
                        '%Uint32Array%': 'undefined' == typeof Uint32Array ? n : Uint32Array,
                        '%Uint32ArrayPrototype%': 'undefined' == typeof Uint32Array ? n : Uint32Array.prototype,
                        '%URIError%': URIError,
                        '%URIErrorPrototype%': URIError.prototype,
                        '%WeakMap%': 'undefined' == typeof WeakMap ? n : WeakMap,
                        '%WeakMapPrototype%': 'undefined' == typeof WeakMap ? n : WeakMap.prototype,
                        '%WeakSet%': 'undefined' == typeof WeakSet ? n : WeakSet,
                        '%WeakSetPrototype%': 'undefined' == typeof WeakSet ? n : WeakSet.prototype
                    }, f = r(8612).call(Function.call, String.prototype.replace), m = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, h = /\\(\\)?/g, g = function (e) {
                        var t = [];
                        return f(e, m, function (e, r, n, i) {
                            t[t.length] = n ? f(i, h, '$1') : r || e;
                        }), t;
                    }, y = function (e, t) {
                        if (!(e in p))
                            throw new SyntaxError('intrinsic ' + e + ' does not exist!');
                        if (void 0 === p[e] && !t)
                            throw new i('intrinsic ' + e + ' exists, but is not available. Please file an issue!');
                        return p[e];
                    };
                e.exports = function (e, t) {
                    if ('string' != typeof e || 0 === e.length)
                        throw new TypeError('intrinsic name must be a non-empty string');
                    if (arguments.length > 1 && 'boolean' != typeof t)
                        throw new TypeError('"allowMissing" argument must be a boolean');
                    for (var r = g(e), n = y('%' + (r.length > 0 ? r[0] : '') + '%', t), o = 1; o < r.length; o += 1)
                        if (null != n)
                            if (a && o + 1 >= r.length) {
                                var s = a(n, r[o]);
                                if (!t && !(r[o] in n))
                                    throw new i('base intrinsic for ' + e + ' exists, but the property is not available.');
                                n = s ? s.get || s.value : n[r[o]];
                            } else
                                n = n[r[o]];
                    return n;
                };
            },
            7836: (e, t, r) => {
                'use strict';
                var n = r(8612), i = r(6231)('%Function%'), a = i.apply, o = i.call;
                e.exports = function () {
                    return n.apply(o, arguments);
                }, e.exports.apply = function () {
                    return n.apply(a, arguments);
                };
            },
            6604: (e, t, r) => {
                'use strict';
                var n = r(6231), i = r(7836), a = i(n('String.prototype.indexOf'));
                e.exports = function (e, t) {
                    var r = n(e, !!t);
                    return 'function' == typeof r && a(e, '.prototype.') ? i(r) : r;
                };
            },
            4128: (e, t, r) => {
                'use strict';
                var n = r(6231)('%Object.getOwnPropertyDescriptor%');
                if (n)
                    try {
                        n([], 'length');
                    } catch (e) {
                        n = null;
                    }
                e.exports = n;
            },
            2020: (e, t, r) => {
                'use strict';
                var n = r(9804), i = r(9628), a = r(6604), o = a('Object.prototype.toString'), s = r(1405)() && 'symbol' == typeof Symbol.toStringTag, c = i(), u = a('Array.prototype.indexOf', !0) || function (e, t) {
                        for (var r = 0; r < e.length; r += 1)
                            if (e[r] === t)
                                return r;
                        return -1;
                    }, l = a('String.prototype.slice'), d = {}, p = r(4128), f = Object.getPrototypeOf;
                s && p && f && n(c, function (e) {
                    var t = new r.g[e]();
                    if (!(Symbol.toStringTag in t))
                        throw new EvalError('this engine has support for Symbol.toStringTag, but ' + e + ' does not have the property! Please report this.');
                    var n = f(t), i = p(n, Symbol.toStringTag);
                    if (!i) {
                        var a = f(n);
                        i = p(a, Symbol.toStringTag);
                    }
                    d[e] = i.get;
                }), e.exports = function (e) {
                    if (!e || 'object' != typeof e)
                        return !1;
                    if (!s) {
                        var t = l(o(e), 8, -1);
                        return u(c, t) > -1;
                    }
                    return !!p && function (e) {
                        var t = !1;
                        return n(d, function (r, n) {
                            if (!t)
                                try {
                                    t = r.call(e) === n;
                                } catch (e) {
                                }
                        }), t;
                    }(e);
                };
            },
            3395: (e, t, r) => {
                'use strict';
                var n = r(9804), i = r(9628), a = r(8413), o = a('Object.prototype.toString'), s = r(1405)() && 'symbol' == typeof Symbol.toStringTag, c = i(), u = a('String.prototype.slice'), l = {}, d = r(5773), p = Object.getPrototypeOf;
                s && d && p && n(c, function (e) {
                    if ('function' == typeof r.g[e]) {
                        var t = new r.g[e]();
                        if (!(Symbol.toStringTag in t))
                            throw new EvalError('this engine has support for Symbol.toStringTag, but ' + e + ' does not have the property! Please report this.');
                        var n = p(t), i = d(n, Symbol.toStringTag);
                        if (!i) {
                            var a = p(n);
                            i = d(a, Symbol.toStringTag);
                        }
                        l[e] = i.get;
                    }
                });
                var f = r(2020);
                e.exports = function (e) {
                    return !!f(e) && (s ? function (e) {
                        var t = !1;
                        return n(l, function (r, n) {
                            if (!t)
                                try {
                                    var i = r.call(e);
                                    i === n && (t = i);
                                } catch (e) {
                                }
                        }), t;
                    }(e) : u(o(e), 8, -1));
                };
            },
            1812: (e, t, r) => {
                'use strict';
                var n, i = TypeError, a = Object.getOwnPropertyDescriptor;
                if (a)
                    try {
                        a({}, '');
                    } catch (e) {
                        a = null;
                    }
                var o = function () {
                        throw new i();
                    }, s = a ? function () {
                        try {
                            return o;
                        } catch (e) {
                            try {
                                return a(arguments, 'callee').get;
                            } catch (e) {
                                return o;
                            }
                        }
                    }() : o, c = r(1405)(), u = Object.getPrototypeOf || function (e) {
                        return e.__proto__;
                    }, l = n, d = 'undefined' == typeof Uint8Array ? n : u(Uint8Array), p = {
                        '%Array%': Array,
                        '%ArrayBuffer%': 'undefined' == typeof ArrayBuffer ? n : ArrayBuffer,
                        '%ArrayBufferPrototype%': 'undefined' == typeof ArrayBuffer ? n : ArrayBuffer.prototype,
                        '%ArrayIteratorPrototype%': c ? u([][Symbol.iterator]()) : n,
                        '%ArrayPrototype%': Array.prototype,
                        '%ArrayProto_entries%': Array.prototype.entries,
                        '%ArrayProto_forEach%': Array.prototype.forEach,
                        '%ArrayProto_keys%': Array.prototype.keys,
                        '%ArrayProto_values%': Array.prototype.values,
                        '%AsyncFromSyncIteratorPrototype%': n,
                        '%AsyncFunction%': undefined,
                        '%AsyncFunctionPrototype%': n,
                        '%AsyncGenerator%': n,
                        '%AsyncGeneratorFunction%': undefined,
                        '%AsyncGeneratorPrototype%': n,
                        '%AsyncIteratorPrototype%': l && c && Symbol.asyncIterator ? l[Symbol.asyncIterator]() : n,
                        '%Atomics%': 'undefined' == typeof Atomics ? n : Atomics,
                        '%Boolean%': Boolean,
                        '%BooleanPrototype%': Boolean.prototype,
                        '%DataView%': 'undefined' == typeof DataView ? n : DataView,
                        '%DataViewPrototype%': 'undefined' == typeof DataView ? n : DataView.prototype,
                        '%Date%': Date,
                        '%DatePrototype%': Date.prototype,
                        '%decodeURI%': decodeURI,
                        '%decodeURIComponent%': decodeURIComponent,
                        '%encodeURI%': encodeURI,
                        '%encodeURIComponent%': encodeURIComponent,
                        '%Error%': Error,
                        '%ErrorPrototype%': Error.prototype,
                        '%eval%': eval,
                        '%EvalError%': EvalError,
                        '%EvalErrorPrototype%': EvalError.prototype,
                        '%Float32Array%': 'undefined' == typeof Float32Array ? n : Float32Array,
                        '%Float32ArrayPrototype%': 'undefined' == typeof Float32Array ? n : Float32Array.prototype,
                        '%Float64Array%': 'undefined' == typeof Float64Array ? n : Float64Array,
                        '%Float64ArrayPrototype%': 'undefined' == typeof Float64Array ? n : Float64Array.prototype,
                        '%Function%': Function,
                        '%FunctionPrototype%': Function.prototype,
                        '%Generator%': n,
                        '%GeneratorFunction%': undefined,
                        '%GeneratorPrototype%': n,
                        '%Int8Array%': 'undefined' == typeof Int8Array ? n : Int8Array,
                        '%Int8ArrayPrototype%': 'undefined' == typeof Int8Array ? n : Int8Array.prototype,
                        '%Int16Array%': 'undefined' == typeof Int16Array ? n : Int16Array,
                        '%Int16ArrayPrototype%': 'undefined' == typeof Int16Array ? n : Int8Array.prototype,
                        '%Int32Array%': 'undefined' == typeof Int32Array ? n : Int32Array,
                        '%Int32ArrayPrototype%': 'undefined' == typeof Int32Array ? n : Int32Array.prototype,
                        '%isFinite%': isFinite,
                        '%isNaN%': isNaN,
                        '%IteratorPrototype%': c ? u(u([][Symbol.iterator]())) : n,
                        '%JSON%': 'object' == typeof JSON ? JSON : n,
                        '%JSONParse%': 'object' == typeof JSON ? JSON.parse : n,
                        '%Map%': 'undefined' == typeof Map ? n : Map,
                        '%MapIteratorPrototype%': 'undefined' != typeof Map && c ? u(new Map()[Symbol.iterator]()) : n,
                        '%MapPrototype%': 'undefined' == typeof Map ? n : Map.prototype,
                        '%Math%': Math,
                        '%Number%': Number,
                        '%NumberPrototype%': Number.prototype,
                        '%Object%': Object,
                        '%ObjectPrototype%': Object.prototype,
                        '%ObjProto_toString%': Object.prototype.toString,
                        '%ObjProto_valueOf%': Object.prototype.valueOf,
                        '%parseFloat%': parseFloat,
                        '%parseInt%': parseInt,
                        '%Promise%': 'undefined' == typeof Promise ? n : Promise,
                        '%PromisePrototype%': 'undefined' == typeof Promise ? n : Promise.prototype,
                        '%PromiseProto_then%': 'undefined' == typeof Promise ? n : Promise.prototype.then,
                        '%Promise_all%': 'undefined' == typeof Promise ? n : Promise.all,
                        '%Promise_reject%': 'undefined' == typeof Promise ? n : Promise.reject,
                        '%Promise_resolve%': 'undefined' == typeof Promise ? n : Promise.resolve,
                        '%Proxy%': 'undefined' == typeof Proxy ? n : Proxy,
                        '%RangeError%': RangeError,
                        '%RangeErrorPrototype%': RangeError.prototype,
                        '%ReferenceError%': ReferenceError,
                        '%ReferenceErrorPrototype%': ReferenceError.prototype,
                        '%Reflect%': 'undefined' == typeof Reflect ? n : Reflect,
                        '%RegExp%': RegExp,
                        '%RegExpPrototype%': RegExp.prototype,
                        '%Set%': 'undefined' == typeof Set ? n : Set,
                        '%SetIteratorPrototype%': 'undefined' != typeof Set && c ? u(new Set()[Symbol.iterator]()) : n,
                        '%SetPrototype%': 'undefined' == typeof Set ? n : Set.prototype,
                        '%SharedArrayBuffer%': 'undefined' == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
                        '%SharedArrayBufferPrototype%': 'undefined' == typeof SharedArrayBuffer ? n : SharedArrayBuffer.prototype,
                        '%String%': String,
                        '%StringIteratorPrototype%': c ? u(''[Symbol.iterator]()) : n,
                        '%StringPrototype%': String.prototype,
                        '%Symbol%': c ? Symbol : n,
                        '%SymbolPrototype%': c ? Symbol.prototype : n,
                        '%SyntaxError%': SyntaxError,
                        '%SyntaxErrorPrototype%': SyntaxError.prototype,
                        '%ThrowTypeError%': s,
                        '%TypedArray%': d,
                        '%TypedArrayPrototype%': d ? d.prototype : n,
                        '%TypeError%': i,
                        '%TypeErrorPrototype%': i.prototype,
                        '%Uint8Array%': 'undefined' == typeof Uint8Array ? n : Uint8Array,
                        '%Uint8ArrayPrototype%': 'undefined' == typeof Uint8Array ? n : Uint8Array.prototype,
                        '%Uint8ClampedArray%': 'undefined' == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
                        '%Uint8ClampedArrayPrototype%': 'undefined' == typeof Uint8ClampedArray ? n : Uint8ClampedArray.prototype,
                        '%Uint16Array%': 'undefined' == typeof Uint16Array ? n : Uint16Array,
                        '%Uint16ArrayPrototype%': 'undefined' == typeof Uint16Array ? n : Uint16Array.prototype,
                        '%Uint32Array%': 'undefined' == typeof Uint32Array ? n : Uint32Array,
                        '%Uint32ArrayPrototype%': 'undefined' == typeof Uint32Array ? n : Uint32Array.prototype,
                        '%URIError%': URIError,
                        '%URIErrorPrototype%': URIError.prototype,
                        '%WeakMap%': 'undefined' == typeof WeakMap ? n : WeakMap,
                        '%WeakMapPrototype%': 'undefined' == typeof WeakMap ? n : WeakMap.prototype,
                        '%WeakSet%': 'undefined' == typeof WeakSet ? n : WeakSet,
                        '%WeakSetPrototype%': 'undefined' == typeof WeakSet ? n : WeakSet.prototype
                    }, f = r(8612).call(Function.call, String.prototype.replace), m = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, h = /\\(\\)?/g, g = function (e) {
                        var t = [];
                        return f(e, m, function (e, r, n, i) {
                            t[t.length] = n ? f(i, h, '$1') : r || e;
                        }), t;
                    }, y = function (e, t) {
                        if (!(e in p))
                            throw new SyntaxError('intrinsic ' + e + ' does not exist!');
                        if (void 0 === p[e] && !t)
                            throw new i('intrinsic ' + e + ' exists, but is not available. Please file an issue!');
                        return p[e];
                    };
                e.exports = function (e, t) {
                    if ('string' != typeof e || 0 === e.length)
                        throw new TypeError('intrinsic name must be a non-empty string');
                    if (arguments.length > 1 && 'boolean' != typeof t)
                        throw new TypeError('"allowMissing" argument must be a boolean');
                    for (var r = g(e), n = y('%' + (r.length > 0 ? r[0] : '') + '%', t), o = 1; o < r.length; o += 1)
                        if (null != n)
                            if (a && o + 1 >= r.length) {
                                var s = a(n, r[o]);
                                if (!t && !(r[o] in n))
                                    throw new i('base intrinsic for ' + e + ' exists, but the property is not available.');
                                n = s && 'get' in s && !('originalValue' in s.get) ? s.get : n[r[o]];
                            } else
                                n = n[r[o]];
                    return n;
                };
            },
            1215: (e, t, r) => {
                'use strict';
                var n = r(8612), i = r(1812), a = i('%Function.prototype.apply%'), o = i('%Function.prototype.call%'), s = i('%Reflect.apply%', !0) || n.call(o, a), c = i('%Object.defineProperty%', !0);
                if (c)
                    try {
                        c({}, 'a', { value: 1 });
                    } catch (e) {
                        c = null;
                    }
                e.exports = function () {
                    return s(n, o, arguments);
                };
                var u = function () {
                    return s(n, a, arguments);
                };
                c ? c(e.exports, 'apply', { value: u }) : e.exports.apply = u;
            },
            8413: (e, t, r) => {
                'use strict';
                var n = r(1812), i = r(1215), a = i(n('String.prototype.indexOf'));
                e.exports = function (e, t) {
                    var r = n(e, !!t);
                    return 'function' == typeof r && a(e, '.prototype.') ? i(r) : r;
                };
            },
            5773: (e, t, r) => {
                'use strict';
                var n = r(1812)('%Object.getOwnPropertyDescriptor%');
                if (n)
                    try {
                        n([], 'length');
                    } catch (e) {
                        n = null;
                    }
                e.exports = n;
            },
            384: e => {
                e.exports = function (e) {
                    return e && 'object' == typeof e && 'function' == typeof e.copy && 'function' == typeof e.fill && 'function' == typeof e.readUInt8;
                };
            },
            5955: (e, t, r) => {
                'use strict';
                var n = r(2584), i = r(8662), a = r(3395), o = r(2020);
                function s(e) {
                    return e.call.bind(e);
                }
                var c = 'undefined' != typeof BigInt, u = 'undefined' != typeof Symbol, l = s(Object.prototype.toString), d = s(Number.prototype.valueOf), p = s(String.prototype.valueOf), f = s(Boolean.prototype.valueOf);
                if (c)
                    var m = s(BigInt.prototype.valueOf);
                if (u)
                    var h = s(Symbol.prototype.valueOf);
                function g(e, t) {
                    if ('object' != typeof e)
                        return !1;
                    try {
                        return t(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function y(e) {
                    return '[object Map]' === l(e);
                }
                function b(e) {
                    return '[object Set]' === l(e);
                }
                function S(e) {
                    return '[object WeakMap]' === l(e);
                }
                function v(e) {
                    return '[object WeakSet]' === l(e);
                }
                function C(e) {
                    return '[object ArrayBuffer]' === l(e);
                }
                function A(e) {
                    return 'undefined' != typeof ArrayBuffer && (C.working ? C(e) : e instanceof ArrayBuffer);
                }
                function _(e) {
                    return '[object DataView]' === l(e);
                }
                function E(e) {
                    return 'undefined' != typeof DataView && (_.working ? _(e) : e instanceof DataView);
                }
                function N(e) {
                    return '[object SharedArrayBuffer]' === l(e);
                }
                function I(e) {
                    return 'undefined' != typeof SharedArrayBuffer && (N.working ? N(e) : e instanceof SharedArrayBuffer);
                }
                function T(e) {
                    return g(e, d);
                }
                function D(e) {
                    return g(e, p);
                }
                function O(e) {
                    return g(e, f);
                }
                function R(e) {
                    return c && g(e, m);
                }
                function M(e) {
                    return u && g(e, h);
                }
                t.isArgumentsObject = n, t.isGeneratorFunction = i, t.isTypedArray = o, t.isPromise = function (e) {
                    return 'undefined' != typeof Promise && e instanceof Promise || null !== e && 'object' == typeof e && 'function' == typeof e.then && 'function' == typeof e.catch;
                }, t.isArrayBufferView = function (e) {
                    return 'undefined' != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : o(e) || E(e);
                }, t.isUint8Array = function (e) {
                    return 'Uint8Array' === a(e);
                }, t.isUint8ClampedArray = function (e) {
                    return 'Uint8ClampedArray' === a(e);
                }, t.isUint16Array = function (e) {
                    return 'Uint16Array' === a(e);
                }, t.isUint32Array = function (e) {
                    return 'Uint32Array' === a(e);
                }, t.isInt8Array = function (e) {
                    return 'Int8Array' === a(e);
                }, t.isInt16Array = function (e) {
                    return 'Int16Array' === a(e);
                }, t.isInt32Array = function (e) {
                    return 'Int32Array' === a(e);
                }, t.isFloat32Array = function (e) {
                    return 'Float32Array' === a(e);
                }, t.isFloat64Array = function (e) {
                    return 'Float64Array' === a(e);
                }, t.isBigInt64Array = function (e) {
                    return 'BigInt64Array' === a(e);
                }, t.isBigUint64Array = function (e) {
                    return 'BigUint64Array' === a(e);
                }, y.working = 'undefined' != typeof Map && y(new Map()), t.isMap = function (e) {
                    return 'undefined' != typeof Map && (y.working ? y(e) : e instanceof Map);
                }, b.working = 'undefined' != typeof Set && b(new Set()), t.isSet = function (e) {
                    return 'undefined' != typeof Set && (b.working ? b(e) : e instanceof Set);
                }, S.working = 'undefined' != typeof WeakMap && S(new WeakMap()), t.isWeakMap = function (e) {
                    return 'undefined' != typeof WeakMap && (S.working ? S(e) : e instanceof WeakMap);
                }, v.working = 'undefined' != typeof WeakSet && v(new WeakSet()), t.isWeakSet = function (e) {
                    return v(e);
                }, C.working = 'undefined' != typeof ArrayBuffer && C(new ArrayBuffer()), t.isArrayBuffer = A, _.working = 'undefined' != typeof ArrayBuffer && 'undefined' != typeof DataView && _(new DataView(new ArrayBuffer(1), 0, 1)), t.isDataView = E, N.working = 'undefined' != typeof SharedArrayBuffer && N(new SharedArrayBuffer()), t.isSharedArrayBuffer = I, t.isAsyncFunction = function (e) {
                    return '[object AsyncFunction]' === l(e);
                }, t.isMapIterator = function (e) {
                    return '[object Map Iterator]' === l(e);
                }, t.isSetIterator = function (e) {
                    return '[object Set Iterator]' === l(e);
                }, t.isGeneratorObject = function (e) {
                    return '[object Generator]' === l(e);
                }, t.isWebAssemblyCompiledModule = function (e) {
                    return '[object WebAssembly.Module]' === l(e);
                }, t.isNumberObject = T, t.isStringObject = D, t.isBooleanObject = O, t.isBigIntObject = R, t.isSymbolObject = M, t.isBoxedPrimitive = function (e) {
                    return T(e) || D(e) || O(e) || R(e) || M(e);
                }, t.isAnyArrayBuffer = function (e) {
                    return 'undefined' != typeof Uint8Array && (A(e) || I(e));
                }, [
                    'isProxy',
                    'isExternal',
                    'isModuleNamespaceObject'
                ].forEach(function (e) {
                    Object.defineProperty(t, e, {
                        enumerable: !1,
                        value: function () {
                            throw new Error(e + ' is not supported in userland');
                        }
                    });
                });
            },
            9539: (e, t, r) => {
                var n = r(4155), i = Object.getOwnPropertyDescriptors || function (e) {
                        for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++)
                            r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);
                        return r;
                    }, a = /%[sdj%]/g;
                t.format = function (e) {
                    if (!S(e)) {
                        for (var t = [], r = 0; r < arguments.length; r++)
                            t.push(u(arguments[r]));
                        return t.join(' ');
                    }
                    r = 1;
                    for (var n = arguments, i = n.length, o = String(e).replace(a, function (e) {
                                if ('%%' === e)
                                    return '%';
                                if (r >= i)
                                    return e;
                                switch (e) {
                                case '%s':
                                    return String(n[r++]);
                                case '%d':
                                    return Number(n[r++]);
                                case '%j':
                                    try {
                                        return JSON.stringify(n[r++]);
                                    } catch (e) {
                                        return '[Circular]';
                                    }
                                default:
                                    return e;
                                }
                            }), s = n[r]; r < i; s = n[++r])
                        y(s) || !A(s) ? o += ' ' + s : o += ' ' + u(s);
                    return o;
                }, t.deprecate = function (e, r) {
                    if (void 0 !== n && !0 === n.noDeprecation)
                        return e;
                    if (void 0 === n)
                        return function () {
                            return t.deprecate(e, r).apply(this, arguments);
                        };
                    var i = !1;
                    return function () {
                        if (!i) {
                            if (n.throwDeprecation)
                                throw new Error(r);
                            n.traceDeprecation ? console.trace(r) : console.error(r), i = !0;
                        }
                        return e.apply(this, arguments);
                    };
                };
                var o = {}, s = /^$/;
                if (n.env.NODE_DEBUG) {
                    var c = n.env.NODE_DEBUG;
                    c = c.replace(/[|\\{}()[\]^$+?.]/g, '\\$&').replace(/\*/g, '.*').replace(/,/g, '$|^').toUpperCase(), s = new RegExp('^' + c + '$', 'i');
                }
                function u(e, r) {
                    var n = {
                        seen: [],
                        stylize: d
                    };
                    return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), g(r) ? n.showHidden = r : r && t._extend(n, r), v(n.showHidden) && (n.showHidden = !1), v(n.depth) && (n.depth = 2), v(n.colors) && (n.colors = !1), v(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), p(n, e, n.depth);
                }
                function l(e, t) {
                    var r = u.styles[t];
                    return r ? '\x1B[' + u.colors[r][0] + 'm' + e + '\x1B[' + u.colors[r][1] + 'm' : e;
                }
                function d(e, t) {
                    return e;
                }
                function p(e, r, n) {
                    if (e.customInspect && r && N(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
                        var i = r.inspect(n, e);
                        return S(i) || (i = p(e, i, n)), i;
                    }
                    var a = function (e, t) {
                        if (v(t))
                            return e.stylize('undefined', 'undefined');
                        if (S(t)) {
                            var r = '\'' + JSON.stringify(t).replace(/^"|"$/g, '').replace(/'/g, '\\\'').replace(/\\"/g, '"') + '\'';
                            return e.stylize(r, 'string');
                        }
                        return b(t) ? e.stylize('' + t, 'number') : g(t) ? e.stylize('' + t, 'boolean') : y(t) ? e.stylize('null', 'null') : void 0;
                    }(e, r);
                    if (a)
                        return a;
                    var o = Object.keys(r), s = function (e) {
                            var t = {};
                            return e.forEach(function (e, r) {
                                t[e] = !0;
                            }), t;
                        }(o);
                    if (e.showHidden && (o = Object.getOwnPropertyNames(r)), E(r) && (o.indexOf('message') >= 0 || o.indexOf('description') >= 0))
                        return f(r);
                    if (0 === o.length) {
                        if (N(r)) {
                            var c = r.name ? ': ' + r.name : '';
                            return e.stylize('[Function' + c + ']', 'special');
                        }
                        if (C(r))
                            return e.stylize(RegExp.prototype.toString.call(r), 'regexp');
                        if (_(r))
                            return e.stylize(Date.prototype.toString.call(r), 'date');
                        if (E(r))
                            return f(r);
                    }
                    var u, l = '', d = !1, A = [
                            '{',
                            '}'
                        ];
                    return h(r) && (d = !0, A = [
                        '[',
                        ']'
                    ]), N(r) && (l = ' [Function' + (r.name ? ': ' + r.name : '') + ']'), C(r) && (l = ' ' + RegExp.prototype.toString.call(r)), _(r) && (l = ' ' + Date.prototype.toUTCString.call(r)), E(r) && (l = ' ' + f(r)), 0 !== o.length || d && 0 != r.length ? n < 0 ? C(r) ? e.stylize(RegExp.prototype.toString.call(r), 'regexp') : e.stylize('[Object]', 'special') : (e.seen.push(r), u = d ? function (e, t, r, n, i) {
                        for (var a = [], o = 0, s = t.length; o < s; ++o)
                            R(t, String(o)) ? a.push(m(e, t, r, n, String(o), !0)) : a.push('');
                        return i.forEach(function (i) {
                            i.match(/^\d+$/) || a.push(m(e, t, r, n, i, !0));
                        }), a;
                    }(e, r, n, s, o) : o.map(function (t) {
                        return m(e, r, n, s, t, d);
                    }), e.seen.pop(), function (e, t, r) {
                        return e.reduce(function (e, t) {
                            return t.indexOf('\n'), e + t.replace(/\u001b\[\d\d?m/g, '').length + 1;
                        }, 0) > 60 ? r[0] + ('' === t ? '' : t + '\n ') + ' ' + e.join(',\n  ') + ' ' + r[1] : r[0] + t + ' ' + e.join(', ') + ' ' + r[1];
                    }(u, l, A)) : A[0] + l + A[1];
                }
                function f(e) {
                    return '[' + Error.prototype.toString.call(e) + ']';
                }
                function m(e, t, r, n, i, a) {
                    var o, s, c;
                    if ((c = Object.getOwnPropertyDescriptor(t, i) || { value: t[i] }).get ? s = c.set ? e.stylize('[Getter/Setter]', 'special') : e.stylize('[Getter]', 'special') : c.set && (s = e.stylize('[Setter]', 'special')), R(n, i) || (o = '[' + i + ']'), s || (e.seen.indexOf(c.value) < 0 ? (s = y(r) ? p(e, c.value, null) : p(e, c.value, r - 1)).indexOf('\n') > -1 && (s = a ? s.split('\n').map(function (e) {
                            return '  ' + e;
                        }).join('\n').substr(2) : '\n' + s.split('\n').map(function (e) {
                            return '   ' + e;
                        }).join('\n')) : s = e.stylize('[Circular]', 'special')), v(o)) {
                        if (a && i.match(/^\d+$/))
                            return s;
                        (o = JSON.stringify('' + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, 'name')) : (o = o.replace(/'/g, '\\\'').replace(/\\"/g, '"').replace(/(^"|"$)/g, '\''), o = e.stylize(o, 'string'));
                    }
                    return o + ': ' + s;
                }
                function h(e) {
                    return Array.isArray(e);
                }
                function g(e) {
                    return 'boolean' == typeof e;
                }
                function y(e) {
                    return null === e;
                }
                function b(e) {
                    return 'number' == typeof e;
                }
                function S(e) {
                    return 'string' == typeof e;
                }
                function v(e) {
                    return void 0 === e;
                }
                function C(e) {
                    return A(e) && '[object RegExp]' === I(e);
                }
                function A(e) {
                    return 'object' == typeof e && null !== e;
                }
                function _(e) {
                    return A(e) && '[object Date]' === I(e);
                }
                function E(e) {
                    return A(e) && ('[object Error]' === I(e) || e instanceof Error);
                }
                function N(e) {
                    return 'function' == typeof e;
                }
                function I(e) {
                    return Object.prototype.toString.call(e);
                }
                function T(e) {
                    return e < 10 ? '0' + e.toString(10) : e.toString(10);
                }
                t.debuglog = function (e) {
                    if (e = e.toUpperCase(), !o[e])
                        if (s.test(e)) {
                            var r = n.pid;
                            o[e] = function () {
                                var n = t.format.apply(t, arguments);
                                console.error('%s %d: %s', e, r, n);
                            };
                        } else
                            o[e] = function () {
                            };
                    return o[e];
                }, t.inspect = u, u.colors = {
                    bold: [
                        1,
                        22
                    ],
                    italic: [
                        3,
                        23
                    ],
                    underline: [
                        4,
                        24
                    ],
                    inverse: [
                        7,
                        27
                    ],
                    white: [
                        37,
                        39
                    ],
                    grey: [
                        90,
                        39
                    ],
                    black: [
                        30,
                        39
                    ],
                    blue: [
                        34,
                        39
                    ],
                    cyan: [
                        36,
                        39
                    ],
                    green: [
                        32,
                        39
                    ],
                    magenta: [
                        35,
                        39
                    ],
                    red: [
                        31,
                        39
                    ],
                    yellow: [
                        33,
                        39
                    ]
                }, u.styles = {
                    special: 'cyan',
                    number: 'yellow',
                    boolean: 'yellow',
                    undefined: 'grey',
                    null: 'bold',
                    string: 'green',
                    date: 'magenta',
                    regexp: 'red'
                }, t.types = r(5955), t.isArray = h, t.isBoolean = g, t.isNull = y, t.isNullOrUndefined = function (e) {
                    return null == e;
                }, t.isNumber = b, t.isString = S, t.isSymbol = function (e) {
                    return 'symbol' == typeof e;
                }, t.isUndefined = v, t.isRegExp = C, t.types.isRegExp = C, t.isObject = A, t.isDate = _, t.types.isDate = _, t.isError = E, t.types.isNativeError = E, t.isFunction = N, t.isPrimitive = function (e) {
                    return null === e || 'boolean' == typeof e || 'number' == typeof e || 'string' == typeof e || 'symbol' == typeof e || void 0 === e;
                }, t.isBuffer = r(384);
                var D = [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                ];
                function O() {
                    var e = new Date(), t = [
                            T(e.getHours()),
                            T(e.getMinutes()),
                            T(e.getSeconds())
                        ].join(':');
                    return [
                        e.getDate(),
                        D[e.getMonth()],
                        t
                    ].join(' ');
                }
                function R(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }
                t.log = function () {
                    console.log('%s - %s', O(), t.format.apply(t, arguments));
                }, t.inherits = r(5717), t._extend = function (e, t) {
                    if (!t || !A(t))
                        return e;
                    for (var r = Object.keys(t), n = r.length; n--;)
                        e[r[n]] = t[r[n]];
                    return e;
                };
                var M = 'undefined' != typeof Symbol ? Symbol('util.promisify.custom') : void 0;
                function F(e, t) {
                    if (!e) {
                        var r = new Error('Promise was rejected with a falsy value');
                        r.reason = e, e = r;
                    }
                    return t(e);
                }
                t.promisify = function (e) {
                    if ('function' != typeof e)
                        throw new TypeError('The "original" argument must be of type Function');
                    if (M && e[M]) {
                        var t;
                        if ('function' != typeof (t = e[M]))
                            throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                        return Object.defineProperty(t, M, {
                            value: t,
                            enumerable: !1,
                            writable: !1,
                            configurable: !0
                        }), t;
                    }
                    function t() {
                        for (var t, r, n = new Promise(function (e, n) {
                                    t = e, r = n;
                                }), i = [], a = 0; a < arguments.length; a++)
                            i.push(arguments[a]);
                        i.push(function (e, n) {
                            e ? r(e) : t(n);
                        });
                        try {
                            e.apply(this, i);
                        } catch (e) {
                            r(e);
                        }
                        return n;
                    }
                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), M && Object.defineProperty(t, M, {
                        value: t,
                        enumerable: !1,
                        writable: !1,
                        configurable: !0
                    }), Object.defineProperties(t, i(e));
                }, t.promisify.custom = M, t.callbackify = function (e) {
                    if ('function' != typeof e)
                        throw new TypeError('The "original" argument must be of type Function');
                    function t() {
                        for (var t = [], r = 0; r < arguments.length; r++)
                            t.push(arguments[r]);
                        var i = t.pop();
                        if ('function' != typeof i)
                            throw new TypeError('The last argument must be of type Function');
                        var a = this, o = function () {
                                return i.apply(a, arguments);
                            };
                        e.apply(this, t).then(function (e) {
                            n.nextTick(o.bind(null, null, e));
                        }, function (e) {
                            n.nextTick(F.bind(null, e, o));
                        });
                    }
                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, i(e)), t;
                };
            },
            8966: (e, t, r) => {
                'use strict';
                function n(e) {
                    return (n = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = void 0;
                var i = We(r(8469)), a = We(r(7536)), o = We(r(1359)), s = We(r(557)), c = We(r(2315)), u = We(r(9466)), l = We(r(5090)), d = We(r(3868)), p = We(r(2492)), f = We(r(8999)), m = We(r(1028)), h = We(r(7795)), g = We(r(221)), y = We(r(2549)), b = We(r(9493)), S = We(r(7380)), v = He(r(9234)), C = He(r(4583)), A = We(r(4986)), _ = We(r(1513)), E = We(r(4595)), N = We(r(3928)), I = We(r(7245)), T = We(r(5566)), D = We(r(4094)), O = We(r(7146)), R = We(r(2941)), M = We(r(9019)), F = We(r(3590)), P = We(r(6826)), x = We(r(2828)), w = We(r(937)), B = He(r(9146)), k = We(r(5218)), L = We(r(7117)), $ = We(r(6090)), j = We(r(8335)), G = We(r(6298)), V = We(r(6454)), U = We(r(6648)), H = We(r(4339)), W = He(r(8177)), K = We(r(2438)), z = We(r(368)), X = We(r(7156)), Y = We(r(4979)), q = We(r(1008)), Z = We(r(4069)), J = We(r(661)), Q = We(r(3235)), ee = We(r(7278)), te = We(r(9131)), re = We(r(3315)), ne = We(r(1464)), ie = We(r(7228)), ae = We(r(682)), oe = We(r(9396)), se = We(r(5807)), ce = We(r(7148)), ue = We(r(7612)), le = We(r(9887)), de = We(r(3058)), pe = He(r(8355)), fe = We(r(2129)), me = We(r(94)), he = We(r(8021)), ge = We(r(5061)), ye = We(r(4611)), be = We(r(1727)), Se = We(r(6776)), ve = We(r(9963)), Ce = We(r(2782)), Ae = We(r(5008)), _e = We(r(2689)), Ee = We(r(555)), Ne = We(r(2776)), Ie = We(r(4554)), Te = We(r(478)), De = He(r(8140)), Oe = We(r(4959)), Re = We(r(9778)), Me = We(r(4790)), Fe = We(r(5152)), Pe = We(r(4816)), xe = We(r(8035)), we = We(r(4714)), Be = We(r(4928)), ke = We(r(8346)), Le = We(r(2900)), $e = We(r(8220)), je = We(r(2786)), Ge = We(r(7633)), Ve = We(r(5977));
                function Ue() {
                    if ('function' != typeof WeakMap)
                        return null;
                    var e = new WeakMap();
                    return Ue = function () {
                        return e;
                    }, e;
                }
                function He(e) {
                    if (e && e.__esModule)
                        return e;
                    if (null === e || 'object' !== n(e) && 'function' != typeof e)
                        return { default: e };
                    var t = Ue();
                    if (t && t.has(e))
                        return t.get(e);
                    var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for (var a in e)
                        if (Object.prototype.hasOwnProperty.call(e, a)) {
                            var o = i ? Object.getOwnPropertyDescriptor(e, a) : null;
                            o && (o.get || o.set) ? Object.defineProperty(r, a, o) : r[a] = e[a];
                        }
                    return r.default = e, t && t.set(e, r), r;
                }
                function We(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var Ke = {
                    version: '13.7.0',
                    toDate: i.default,
                    toFloat: a.default,
                    toInt: o.default,
                    toBoolean: s.default,
                    equals: c.default,
                    contains: u.default,
                    matches: l.default,
                    isEmail: d.default,
                    isURL: p.default,
                    isMACAddress: f.default,
                    isIP: m.default,
                    isIPRange: h.default,
                    isFQDN: g.default,
                    isBoolean: b.default,
                    isIBAN: W.default,
                    isBIC: K.default,
                    isAlpha: v.default,
                    isAlphaLocales: v.locales,
                    isAlphanumeric: C.default,
                    isAlphanumericLocales: C.locales,
                    isNumeric: A.default,
                    isPassportNumber: _.default,
                    isPort: E.default,
                    isLowercase: N.default,
                    isUppercase: I.default,
                    isAscii: D.default,
                    isFullWidth: O.default,
                    isHalfWidth: R.default,
                    isVariableWidth: M.default,
                    isMultibyte: F.default,
                    isSemVer: P.default,
                    isSurrogatePair: x.default,
                    isInt: w.default,
                    isIMEI: T.default,
                    isFloat: B.default,
                    isFloatLocales: B.locales,
                    isDecimal: k.default,
                    isHexadecimal: L.default,
                    isOctal: $.default,
                    isDivisibleBy: j.default,
                    isHexColor: G.default,
                    isRgbColor: V.default,
                    isHSL: U.default,
                    isISRC: H.default,
                    isMD5: z.default,
                    isHash: X.default,
                    isJWT: Y.default,
                    isJSON: q.default,
                    isEmpty: Z.default,
                    isLength: J.default,
                    isLocale: S.default,
                    isByteLength: Q.default,
                    isUUID: ee.default,
                    isMongoId: te.default,
                    isAfter: re.default,
                    isBefore: ne.default,
                    isIn: ie.default,
                    isCreditCard: ae.default,
                    isIdentityCard: oe.default,
                    isEAN: se.default,
                    isISIN: ce.default,
                    isISBN: ue.default,
                    isISSN: le.default,
                    isMobilePhone: pe.default,
                    isMobilePhoneLocales: pe.locales,
                    isPostalCode: De.default,
                    isPostalCodeLocales: De.locales,
                    isEthereumAddress: fe.default,
                    isCurrency: me.default,
                    isBtcAddress: he.default,
                    isISO8601: ge.default,
                    isRFC3339: ye.default,
                    isISO31661Alpha2: be.default,
                    isISO31661Alpha3: Se.default,
                    isISO4217: ve.default,
                    isBase32: Ce.default,
                    isBase58: Ae.default,
                    isBase64: _e.default,
                    isDataURI: Ee.default,
                    isMagnetURI: Ne.default,
                    isMimeType: Ie.default,
                    isLatLong: Te.default,
                    ltrim: Oe.default,
                    rtrim: Re.default,
                    trim: Me.default,
                    escape: Fe.default,
                    unescape: Pe.default,
                    stripLow: xe.default,
                    whitelist: we.default,
                    blacklist: Be.default,
                    isWhitelisted: ke.default,
                    normalizeEmail: Le.default,
                    toString,
                    isSlug: $e.default,
                    isStrongPassword: Ge.default,
                    isTaxID: de.default,
                    isDate: y.default,
                    isLicensePlate: je.default,
                    isVAT: Ve.default,
                    ibanLocales: W.locales
                };
                t.default = Ke, e.exports = t.default, e.exports.default = t.default;
            },
            79: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.commaDecimal = t.dotDecimal = t.farsiLocales = t.arabicLocales = t.englishLocales = t.decimal = t.alphanumeric = t.alpha = void 0;
                var r = {
                    'en-US': /^[A-Z]+$/i,
                    'az-AZ': /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
                    'bg-BG': /^[А-Я]+$/i,
                    'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
                    'da-DK': /^[A-ZÆØÅ]+$/i,
                    'de-DE': /^[A-ZÄÖÜß]+$/i,
                    'el-GR': /^[Α-ώ]+$/i,
                    'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
                    'fa-IR': /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
                    'fi-FI': /^[A-ZÅÄÖ]+$/i,
                    'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
                    'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
                    'nb-NO': /^[A-ZÆØÅ]+$/i,
                    'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
                    'nn-NO': /^[A-ZÆØÅ]+$/i,
                    'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
                    'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
                    'pt-PT': /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
                    'ru-RU': /^[А-ЯЁ]+$/i,
                    'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
                    'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
                    'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
                    'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
                    'sv-SE': /^[A-ZÅÄÖ]+$/i,
                    'th-TH': /^[ก-๐\s]+$/i,
                    'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
                    'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
                    'vi-VN': /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
                    'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
                    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
                    he: /^[א-ת]+$/,
                    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
                    'hi-IN': /^[\u0900-\u0961]+[\u0972-\u097F]*$/i
                };
                t.alpha = r;
                var n = {
                    'en-US': /^[0-9A-Z]+$/i,
                    'az-AZ': /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
                    'bg-BG': /^[0-9А-Я]+$/i,
                    'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
                    'da-DK': /^[0-9A-ZÆØÅ]+$/i,
                    'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
                    'el-GR': /^[0-9Α-ω]+$/i,
                    'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
                    'fi-FI': /^[0-9A-ZÅÄÖ]+$/i,
                    'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
                    'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
                    'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
                    'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
                    'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
                    'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
                    'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
                    'pt-PT': /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
                    'ru-RU': /^[0-9А-ЯЁ]+$/i,
                    'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
                    'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
                    'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
                    'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
                    'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
                    'th-TH': /^[ก-๙\s]+$/i,
                    'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
                    'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
                    'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
                    'vi-VN': /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
                    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
                    he: /^[0-9א-ת]+$/,
                    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
                    'hi-IN': /^[\u0900-\u0963]+[\u0966-\u097F]*$/i
                };
                t.alphanumeric = n;
                var i = {
                    'en-US': '.',
                    ar: '\u066B'
                };
                t.decimal = i;
                var a = [
                    'AU',
                    'GB',
                    'HK',
                    'IN',
                    'NZ',
                    'ZA',
                    'ZM'
                ];
                t.englishLocales = a;
                for (var o, s = 0; s < a.length; s++)
                    r[o = 'en-'.concat(a[s])] = r['en-US'], n[o] = n['en-US'], i[o] = i['en-US'];
                var c = [
                    'AE',
                    'BH',
                    'DZ',
                    'EG',
                    'IQ',
                    'JO',
                    'KW',
                    'LB',
                    'LY',
                    'MA',
                    'QM',
                    'QA',
                    'SA',
                    'SD',
                    'SY',
                    'TN',
                    'YE'
                ];
                t.arabicLocales = c;
                for (var u, l = 0; l < c.length; l++)
                    r[u = 'ar-'.concat(c[l])] = r.ar, n[u] = n.ar, i[u] = i.ar;
                var d = [
                    'IR',
                    'AF'
                ];
                t.farsiLocales = d;
                for (var p, f = 0; f < d.length; f++)
                    n[p = 'fa-'.concat(d[f])] = n.fa, i[p] = i.ar;
                var m = [
                    'ar-EG',
                    'ar-LB',
                    'ar-LY'
                ];
                t.dotDecimal = m;
                var h = [
                    'bg-BG',
                    'cs-CZ',
                    'da-DK',
                    'de-DE',
                    'el-GR',
                    'en-ZM',
                    'es-ES',
                    'fr-CA',
                    'fr-FR',
                    'id-ID',
                    'it-IT',
                    'ku-IQ',
                    'hi-IN',
                    'hu-HU',
                    'nb-NO',
                    'nn-NO',
                    'nl-NL',
                    'pl-PL',
                    'pt-PT',
                    'ru-RU',
                    'sl-SI',
                    'sr-RS@latin',
                    'sr-RS',
                    'sv-SE',
                    'tr-TR',
                    'uk-UA',
                    'vi-VN'
                ];
                t.commaDecimal = h;
                for (var g = 0; g < m.length; g++)
                    i[m[g]] = i['en-US'];
                for (var y = 0; y < h.length; y++)
                    i[h[y]] = ',';
                r['fr-CA'] = r['fr-FR'], n['fr-CA'] = n['fr-FR'], r['pt-BR'] = r['pt-PT'], n['pt-BR'] = n['pt-PT'], i['pt-BR'] = i['pt-PT'], r['pl-Pl'] = r['pl-PL'], n['pl-Pl'] = n['pl-PL'], i['pl-Pl'] = i['pl-PL'], r['fa-AF'] = r.fa;
            },
            4928: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, i.default)(e), e.replace(new RegExp('['.concat(t, ']+'), 'g'), '');
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            9466: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t, r) {
                    return (0, n.default)(e), (r = (0, a.default)(r, s)).ignoreCase ? e.toLowerCase().split((0, i.default)(t).toLowerCase()).length > r.minOccurrences : e.split((0, i.default)(t)).length > r.minOccurrences;
                };
                var n = o(r(5571)), i = o(r(1913)), a = o(r(4808));
                function o(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var s = {
                    ignoreCase: !1,
                    minOccurrences: 1
                };
                e.exports = t.default, e.exports.default = t.default;
            },
            2315: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, i.default)(e), e === t;
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            5152: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), e.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            3315: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : String(new Date());
                    (0, n.default)(e);
                    var r = (0, i.default)(t), a = (0, i.default)(e);
                    return !!(a && r && a > r);
                };
                var n = a(r(5571)), i = a(r(8469));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            9234: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'en-US', r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    (0, i.default)(e);
                    var n = e, o = r.ignore;
                    if (o)
                        if (o instanceof RegExp)
                            n = n.replace(o, '');
                        else {
                            if ('string' != typeof o)
                                throw new Error('ignore should be instance of a String or RegExp');
                            n = n.replace(new RegExp('['.concat(o.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), ']'), 'g'), '');
                        }
                    if (t in a.alpha)
                        return a.alpha[t].test(n);
                    throw new Error('Invalid locale \''.concat(t, '\''));
                }, t.locales = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = r(79), o = Object.keys(a.alpha);
                t.locales = o;
            },
            4583: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'en-US', r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    (0, i.default)(e);
                    var n = e, o = r.ignore;
                    if (o)
                        if (o instanceof RegExp)
                            n = n.replace(o, '');
                        else {
                            if ('string' != typeof o)
                                throw new Error('ignore should be instance of a String or RegExp');
                            n = n.replace(new RegExp('['.concat(o.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), ']'), 'g'), '');
                        }
                    if (t in a.alphanumeric)
                        return a.alphanumeric[t].test(n);
                    throw new Error('Invalid locale \''.concat(t, '\''));
                }, t.locales = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = r(79), o = Object.keys(a.alphanumeric);
                t.locales = o;
            },
            4094: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^[\x00-\x7F]+$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            2438: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), !!a.CountryCodes.has(e.slice(4, 6).toUpperCase()) && o.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = r(1727), o = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            2782: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), !(e.length % 8 != 0 || !a.test(e));
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^[A-Z2-7]+=*$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            5008: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), !!a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^[A-HJ-NP-Za-km-z1-9]*$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            2689: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, n.default)(e), t = (0, i.default)(t, c);
                    var r = e.length;
                    if (t.urlSafe)
                        return s.test(e);
                    if (r % 4 != 0 || o.test(e))
                        return !1;
                    var a = e.indexOf('=');
                    return -1 === a || a === r - 1 || a === r - 2 && '=' === e[r - 1];
                };
                var n = a(r(5571)), i = a(r(4808));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var o = /[^A-Z0-9+\/=]/i, s = /^[A-Z0-9_\-]*$/i, c = { urlSafe: !1 };
                e.exports = t.default, e.exports.default = t.default;
            },
            1464: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : String(new Date());
                    (0, n.default)(e);
                    var r = (0, i.default)(t), a = (0, i.default)(e);
                    return !!(a && r && a < r);
                };
                var n = a(r(5571)), i = a(r(8469));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            9493: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : a;
                    return (0, i.default)(e), t.loose ? s.includes(e.toLowerCase()) : o.includes(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = { loose: !1 }, o = [
                        'true',
                        'false',
                        '1',
                        '0'
                    ], s = [].concat(o, [
                        'yes',
                        'no'
                    ]);
                e.exports = t.default, e.exports.default = t.default;
            },
            8021: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), e.startsWith('bc1') ? a.test(e) : o.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^(bc1)[a-z0-9]{25,39}$/, o = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            3235: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    var r, n;
                    (0, i.default)(e), 'object' === a(t) ? (r = t.min || 0, n = t.max) : (r = arguments[1], n = arguments[2]);
                    var o = encodeURI(e).split(/%..|./).length - 1;
                    return o >= r && (void 0 === n || o <= n);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                function a(e) {
                    return (a = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            682: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    (0, i.default)(e);
                    var t = e.replace(/[- ]+/g, '');
                    if (!a.test(t))
                        return !1;
                    for (var r, n, o, s = 0, c = t.length - 1; c >= 0; c--)
                        r = t.substring(c, c + 1), n = parseInt(r, 10), s += o && (n *= 2) >= 10 ? n % 10 + 1 : n, o = !o;
                    return !(s % 10 != 0 || !t);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14}|^(81[0-9]{14,17}))$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            94: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, i.default)(e), function (e) {
                        var t = '\\d{'.concat(e.digits_after_decimal[0], '}');
                        e.digits_after_decimal.forEach(function (e, r) {
                            0 !== r && (t = ''.concat(t, '|\\d{').concat(e, '}'));
                        });
                        var r = '('.concat(e.symbol.replace(/\W/, function (e) {
                                return '\\'.concat(e);
                            }), ')').concat(e.require_symbol ? '' : '?'), n = '-?', i = '[1-9]\\d{0,2}(\\'.concat(e.thousands_separator, '\\d{3})*'), a = '('.concat([
                                '0',
                                '[1-9]\\d*',
                                i
                            ].join('|'), ')?'), o = '(\\'.concat(e.decimal_separator, '(').concat(t, '))').concat(e.require_decimal ? '' : '?'), s = a + (e.allow_decimal || e.require_decimal ? o : '');
                        return e.allow_negatives && !e.parens_for_negatives && (e.negative_sign_after_digits ? s += n : e.negative_sign_before_digits && (s = n + s)), e.allow_negative_sign_placeholder ? s = '( (?!\\-))?'.concat(s) : e.allow_space_after_symbol ? s = ' ?'.concat(s) : e.allow_space_after_digits && (s += '( (?!$))?'), e.symbol_after_digits ? s += r : s = r + s, e.allow_negatives && (e.parens_for_negatives ? s = '(\\('.concat(s, '\\)|').concat(s, ')') : e.negative_sign_before_digits || e.negative_sign_after_digits || (s = n + s)), new RegExp('^(?!-? )(?=.*\\d)'.concat(s, '$'));
                    }(t = (0, n.default)(t, o)).test(e);
                };
                var n = a(r(4808)), i = a(r(5571));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var o = {
                    symbol: '$',
                    require_symbol: !1,
                    allow_space_after_symbol: !1,
                    symbol_after_digits: !1,
                    allow_negatives: !0,
                    parens_for_negatives: !1,
                    negative_sign_before_digits: !1,
                    negative_sign_after_digits: !1,
                    allow_negative_sign_placeholder: !1,
                    thousands_separator: ',',
                    decimal_separator: '.',
                    allow_decimal: !0,
                    require_decimal: !1,
                    digits_after_decimal: [2],
                    allow_space_after_digits: !1
                };
                e.exports = t.default, e.exports.default = t.default;
            },
            555: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    (0, i.default)(e);
                    var t = e.split(',');
                    if (t.length < 2)
                        return !1;
                    var r = t.shift().trim().split(';'), n = r.shift();
                    if ('data:' !== n.substr(0, 5))
                        return !1;
                    var c = n.substr(5);
                    if ('' !== c && !a.test(c))
                        return !1;
                    for (var u = 0; u < r.length; u++)
                        if ((u !== r.length - 1 || 'base64' !== r[u].toLowerCase()) && !o.test(r[u]))
                            return !1;
                    for (var l = 0; l < t.length; l++)
                        if (!s.test(t[l]))
                            return !1;
                    return !0;
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^[a-z]+\/[a-z0-9\-\+]+$/i, o = /^[a-z\-]+=[a-z0-9\-]+$/i, s = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
                e.exports = t.default, e.exports.default = t.default;
            },
            2549: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    if (t = 'string' == typeof t ? (0, i.default)({ format: t }, s) : (0, i.default)(t, s), 'string' == typeof e && (m = t.format, /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(m))) {
                        var r, n = t.delimiters.find(function (e) {
                                return -1 !== t.format.indexOf(e);
                            }), o = t.strictMode ? n : t.delimiters.find(function (t) {
                                return -1 !== e.indexOf(t);
                            }), c = {}, u = function (e, t) {
                                var r;
                                if ('undefined' == typeof Symbol || null == e[Symbol.iterator]) {
                                    if (Array.isArray(e) || (r = a(e))) {
                                        r && (e = r);
                                        var n = 0, i = function () {
                                            };
                                        return {
                                            s: i,
                                            n: function () {
                                                return n >= e.length ? { done: !0 } : {
                                                    done: !1,
                                                    value: e[n++]
                                                };
                                            },
                                            e: function (e) {
                                                throw e;
                                            },
                                            f: i
                                        };
                                    }
                                    throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                                }
                                var o, s = !0, c = !1;
                                return {
                                    s: function () {
                                        r = e[Symbol.iterator]();
                                    },
                                    n: function () {
                                        var e = r.next();
                                        return s = e.done, e;
                                    },
                                    e: function (e) {
                                        c = !0, o = e;
                                    },
                                    f: function () {
                                        try {
                                            s || null == r.return || r.return();
                                        } finally {
                                            if (c)
                                                throw o;
                                        }
                                    }
                                };
                            }(function (e, t) {
                                for (var r = [], n = Math.min(e.length, t.length), i = 0; i < n; i++)
                                    r.push([
                                        e[i],
                                        t[i]
                                    ]);
                                return r;
                            }(e.split(o), t.format.toLowerCase().split(n)));
                        try {
                            for (u.s(); !(r = u.n()).done;) {
                                var l = (f = r.value, 2, function (e) {
                                        if (Array.isArray(e))
                                            return e;
                                    }(f) || function (e, t) {
                                        if ('undefined' != typeof Symbol && Symbol.iterator in Object(e)) {
                                            var r = [], n = !0, i = !1, a = void 0;
                                            try {
                                                for (var o, s = e[Symbol.iterator](); !(n = (o = s.next()).done) && (r.push(o.value), 2 !== r.length); n = !0);
                                            } catch (e) {
                                                i = !0, a = e;
                                            } finally {
                                                try {
                                                    n || null == s.return || s.return();
                                                } finally {
                                                    if (i)
                                                        throw a;
                                                }
                                            }
                                            return r;
                                        }
                                    }(f) || a(f, 2) || function () {
                                        throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                                    }()), d = l[0], p = l[1];
                                if (d.length !== p.length)
                                    return !1;
                                c[p.charAt(0)] = d;
                            }
                        } catch (e) {
                            u.e(e);
                        } finally {
                            u.f();
                        }
                        return new Date(''.concat(c.m, '/').concat(c.d, '/').concat(c.y)).getDate() === +c.d;
                    }
                    var f, m;
                    return !t.strictMode && ('[object Date]' === Object.prototype.toString.call(e) && isFinite(e));
                };
                var n, i = (n = r(4808)) && n.__esModule ? n : { default: n };
                function a(e, t) {
                    if (e) {
                        if ('string' == typeof e)
                            return o(e, t);
                        var r = Object.prototype.toString.call(e).slice(8, -1);
                        return 'Object' === r && e.constructor && (r = e.constructor.name), 'Map' === r || 'Set' === r ? Array.from(e) : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? o(e, t) : void 0;
                    }
                }
                function o(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var r = 0, n = new Array(t); r < t; r++)
                        n[r] = e[r];
                    return n;
                }
                var s = {
                    format: 'YYYY/MM/DD',
                    delimiters: [
                        '/',
                        '-'
                    ],
                    strictMode: !1
                };
                e.exports = t.default, e.exports.default = t.default;
            },
            5218: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    if ((0, i.default)(e), (t = (0, n.default)(t, c)).locale in o.decimal)
                        return !(0, a.default)(u, e.replace(/ /g, '')) && function (e) {
                            return new RegExp('^[-+]?([0-9]+)?(\\'.concat(o.decimal[e.locale], '[0-9]{').concat(e.decimal_digits, '})').concat(e.force_decimal ? '' : '?', '$'));
                        }(t).test(e);
                    throw new Error('Invalid locale \''.concat(t.locale, '\''));
                };
                var n = s(r(4808)), i = s(r(5571)), a = s(r(8343)), o = r(79);
                function s(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var c = {
                        force_decimal: !1,
                        decimal_digits: '1,',
                        locale: 'en-US'
                    }, u = [
                        '',
                        '-',
                        '+'
                    ];
                e.exports = t.default, e.exports.default = t.default;
            },
            8335: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, n.default)(e), (0, i.default)(e) % parseInt(t, 10) == 0;
                };
                var n = a(r(5571)), i = a(r(7536));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            5807: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    (0, i.default)(e);
                    var t, r, n = Number(e.slice(-1));
                    return a.test(e) && n === ((r = 10 - (t = e).slice(0, -1).split('').map(function (e, r) {
                        return Number(e) * function (e, t) {
                            return 8 === e || 14 === e ? t % 2 == 0 ? 3 : 1 : t % 2 == 0 ? 1 : 3;
                        }(t.length, r);
                    }).reduce(function (e, t) {
                        return e + t;
                    }, 0) % 10) < 10 ? r : 0);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^(\d{8}|\d{13}|\d{14})$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            3868: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    if ((0, n.default)(e), (t = (0, i.default)(t, u)).require_display_name || t.allow_display_name) {
                        var r = e.match(l);
                        if (r) {
                            var c = r[1];
                            if (e = e.replace(c, '').replace(/(^<|>$)/g, ''), c.endsWith(' ') && (c = c.substr(0, c.length - 1)), !function (e) {
                                    var t = e.replace(/^"(.+)"$/, '$1');
                                    if (!t.trim())
                                        return !1;
                                    if (/[\.";<>]/.test(t)) {
                                        if (t === e)
                                            return !1;
                                        if (t.split('"').length !== t.split('\\"').length)
                                            return !1;
                                    }
                                    return !0;
                                }(c))
                                return !1;
                        } else if (t.require_display_name)
                            return !1;
                    }
                    if (!t.ignore_max_length && e.length > 254)
                        return !1;
                    var g = e.split('@'), y = g.pop(), b = y.toLowerCase();
                    if (t.host_blacklist.includes(b))
                        return !1;
                    var S = g.join('@');
                    if (t.domain_specific_validation && ('gmail.com' === b || 'googlemail.com' === b)) {
                        var v = (S = S.toLowerCase()).split('+')[0];
                        if (!(0, a.default)(v.replace(/\./g, ''), {
                                min: 6,
                                max: 30
                            }))
                            return !1;
                        for (var C = v.split('.'), A = 0; A < C.length; A++)
                            if (!p.test(C[A]))
                                return !1;
                    }
                    if (!(!1 !== t.ignore_max_length || (0, a.default)(S, { max: 64 }) && (0, a.default)(y, { max: 254 })))
                        return !1;
                    if (!(0, o.default)(y, { require_tld: t.require_tld })) {
                        if (!t.allow_ip_domain)
                            return !1;
                        if (!(0, s.default)(y)) {
                            if (!y.startsWith('[') || !y.endsWith(']'))
                                return !1;
                            var _ = y.substr(1, y.length - 2);
                            if (0 === _.length || !(0, s.default)(_))
                                return !1;
                        }
                    }
                    if ('"' === S[0])
                        return S = S.slice(1, S.length - 1), t.allow_utf8_local_part ? h.test(S) : f.test(S);
                    for (var E = t.allow_utf8_local_part ? m : d, N = S.split('.'), I = 0; I < N.length; I++)
                        if (!E.test(N[I]))
                            return !1;
                    return !t.blacklisted_chars || -1 === S.search(new RegExp('['.concat(t.blacklisted_chars, ']+'), 'g'));
                };
                var n = c(r(5571)), i = c(r(4808)), a = c(r(3235)), o = c(r(221)), s = c(r(1028));
                function c(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var u = {
                        allow_display_name: !1,
                        require_display_name: !1,
                        allow_utf8_local_part: !0,
                        require_tld: !0,
                        blacklisted_chars: '',
                        ignore_max_length: !1,
                        host_blacklist: []
                    }, l = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, d = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, p = /^[a-z\d]+$/, f = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, m = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, h = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
                e.exports = t.default, e.exports.default = t.default;
            },
            4069: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, n.default)(e), 0 === ((t = (0, i.default)(t, o)).ignore_whitespace ? e.trim().length : e.length);
                };
                var n = a(r(5571)), i = a(r(4808));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var o = { ignore_whitespace: !1 };
                e.exports = t.default, e.exports.default = t.default;
            },
            2129: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^(0x)[0-9a-f]{40}$/i;
                e.exports = t.default, e.exports.default = t.default;
            },
            221: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, n.default)(e), (t = (0, i.default)(t, o)).allow_trailing_dot && '.' === e[e.length - 1] && (e = e.substring(0, e.length - 1)), !0 === t.allow_wildcard && 0 === e.indexOf('*.') && (e = e.substring(2));
                    var r = e.split('.'), a = r[r.length - 1];
                    if (t.require_tld) {
                        if (r.length < 2)
                            return !1;
                        if (!/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(a))
                            return !1;
                        if (/\s/.test(a))
                            return !1;
                    }
                    return !(!t.allow_numeric_tld && /^\d+$/.test(a)) && r.every(function (e) {
                        return !(e.length > 63 || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(e) || /[\uff01-\uff5e]/.test(e) || /^-|-$/.test(e) || !t.allow_underscores && /_/.test(e));
                    });
                };
                var n = a(r(5571)), i = a(r(4808));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var o = {
                    require_tld: !0,
                    allow_underscores: !1,
                    allow_trailing_dot: !1,
                    allow_numeric_tld: !1,
                    allow_wildcard: !1
                };
                e.exports = t.default, e.exports.default = t.default;
            },
            9146: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, i.default)(e), t = t || {};
                    var r = new RegExp('^(?:[-+])?(?:[0-9]+)?(?:\\'.concat(t.locale ? a.decimal[t.locale] : '.', '[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$'));
                    if ('' === e || '.' === e || '-' === e || '+' === e)
                        return !1;
                    var n = parseFloat(e.replace(',', '.'));
                    return r.test(e) && (!t.hasOwnProperty('min') || n >= t.min) && (!t.hasOwnProperty('max') || n <= t.max) && (!t.hasOwnProperty('lt') || n < t.lt) && (!t.hasOwnProperty('gt') || n > t.gt);
                }, t.locales = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = r(79), o = Object.keys(a.decimal);
                t.locales = o;
            },
            7146: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                }, t.fullWidth = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
                t.fullWidth = a;
            },
            6648: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    (0, i.default)(e);
                    var t = e.replace(/\s+/g, ' ').replace(/\s?(hsla?\(|\)|,)\s?/gi, '$1');
                    return -1 !== t.indexOf(',') ? a.test(t) : o.test(t);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i, o = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
                e.exports = t.default, e.exports.default = t.default;
            },
            2941: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                }, t.halfWidth = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
                t.halfWidth = a;
            },
            7156: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, i.default)(e), new RegExp('^[a-fA-F0-9]{'.concat(a[t], '}$')).test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = {
                        md5: 32,
                        md4: 32,
                        sha1: 40,
                        sha256: 64,
                        sha384: 96,
                        sha512: 128,
                        ripemd128: 32,
                        ripemd160: 40,
                        tiger128: 32,
                        tiger160: 40,
                        tiger192: 48,
                        crc32: 8,
                        crc32b: 8
                    };
                e.exports = t.default, e.exports.default = t.default;
            },
            6298: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
                e.exports = t.default, e.exports.default = t.default;
            },
            7117: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^(0x|0h)?[0-9A-F]+$/i;
                e.exports = t.default, e.exports.default = t.default;
            },
            8177: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), function (e) {
                        var t = e.replace(/[\s\-]+/gi, '').toUpperCase(), r = t.slice(0, 2).toUpperCase();
                        return r in a && a[r].test(t);
                    }(e) && function (e) {
                        var t = e.replace(/[^A-Z0-9]+/gi, '').toUpperCase();
                        return 1 === (t.slice(4) + t.slice(0, 4)).replace(/[A-Z]/g, function (e) {
                            return e.charCodeAt(0) - 55;
                        }).match(/\d{1,7}/g).reduce(function (e, t) {
                            return Number(e + t) % 97;
                        }, '');
                    }(e);
                }, t.locales = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = {
                        AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
                        AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
                        AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
                        AT: /^(AT[0-9]{2})\d{16}$/,
                        AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
                        BA: /^(BA[0-9]{2})\d{16}$/,
                        BE: /^(BE[0-9]{2})\d{12}$/,
                        BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
                        BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
                        BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
                        BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
                        CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
                        CR: /^(CR[0-9]{2})\d{18}$/,
                        CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
                        CZ: /^(CZ[0-9]{2})\d{20}$/,
                        DE: /^(DE[0-9]{2})\d{18}$/,
                        DK: /^(DK[0-9]{2})\d{14}$/,
                        DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
                        EE: /^(EE[0-9]{2})\d{16}$/,
                        EG: /^(EG[0-9]{2})\d{25}$/,
                        ES: /^(ES[0-9]{2})\d{20}$/,
                        FI: /^(FI[0-9]{2})\d{14}$/,
                        FO: /^(FO[0-9]{2})\d{14}$/,
                        FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
                        GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
                        GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
                        GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
                        GL: /^(GL[0-9]{2})\d{14}$/,
                        GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
                        GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
                        HR: /^(HR[0-9]{2})\d{17}$/,
                        HU: /^(HU[0-9]{2})\d{24}$/,
                        IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
                        IL: /^(IL[0-9]{2})\d{19}$/,
                        IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
                        IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
                        IS: /^(IS[0-9]{2})\d{22}$/,
                        IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
                        JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
                        KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
                        KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
                        LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
                        LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
                        LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
                        LT: /^(LT[0-9]{2})\d{16}$/,
                        LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
                        LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
                        MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
                        MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
                        ME: /^(ME[0-9]{2})\d{18}$/,
                        MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
                        MR: /^(MR[0-9]{2})\d{23}$/,
                        MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
                        MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
                        MZ: /^(MZ[0-9]{2})\d{21}$/,
                        NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
                        NO: /^(NO[0-9]{2})\d{11}$/,
                        PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
                        PL: /^(PL[0-9]{2})\d{24}$/,
                        PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
                        PT: /^(PT[0-9]{2})\d{21}$/,
                        QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
                        RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
                        RS: /^(RS[0-9]{2})\d{18}$/,
                        SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
                        SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
                        SE: /^(SE[0-9]{2})\d{20}$/,
                        SI: /^(SI[0-9]{2})\d{15}$/,
                        SK: /^(SK[0-9]{2})\d{20}$/,
                        SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
                        SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
                        TL: /^(TL[0-9]{2})\d{19}$/,
                        TN: /^(TN[0-9]{2})\d{20}$/,
                        TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
                        UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
                        VA: /^(VA[0-9]{2})\d{18}$/,
                        VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
                        XK: /^(XK[0-9]{2})\d{16}$/
                    }, o = Object.keys(a);
                t.locales = o;
            },
            5566: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, i.default)(e);
                    var r = a;
                    if ((t = t || {}).allow_hyphens && (r = o), !r.test(e))
                        return !1;
                    e = e.replace(/-/g, '');
                    for (var n = 0, s = 2, c = 0; c < 14; c++) {
                        var u = e.substring(14 - c - 1, 14 - c), l = parseInt(u, 10) * s;
                        n += l >= 10 ? l % 10 + 1 : l, 1 === s ? s += 1 : s -= 1;
                    }
                    return (10 - n % 10) % 10 === parseInt(e.substring(14, 15), 10);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^[0-9]{15}$/, o = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            1028: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function e(t) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : '';
                    if ((0, i.default)(t), !(r = String(r)))
                        return e(t, 4) || e(t, 6);
                    if ('4' === r) {
                        if (!s.test(t))
                            return !1;
                        var n = t.split('.').sort(function (e, t) {
                            return e - t;
                        });
                        return n[3] <= 255;
                    }
                    return '6' === r && !!u.test(t);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])', o = '('.concat(a, '[.]){3}').concat(a), s = new RegExp('^'.concat(o, '$')), c = '(?:[0-9a-fA-F]{1,4})', u = new RegExp('^(' + '(?:'.concat(c, ':){7}(?:').concat(c, '|:)|') + '(?:'.concat(c, ':){6}(?:').concat(o, '|:').concat(c, '|:)|') + '(?:'.concat(c, ':){5}(?::').concat(o, '|(:').concat(c, '){1,2}|:)|') + '(?:'.concat(c, ':){4}(?:(:').concat(c, '){0,1}:').concat(o, '|(:').concat(c, '){1,3}|:)|') + '(?:'.concat(c, ':){3}(?:(:').concat(c, '){0,2}:').concat(o, '|(:').concat(c, '){1,4}|:)|') + '(?:'.concat(c, ':){2}(?:(:').concat(c, '){0,3}:').concat(o, '|(:').concat(c, '){1,5}|:)|') + '(?:'.concat(c, ':){1}(?:(:').concat(c, '){0,4}:').concat(o, '|(:').concat(c, '){1,6}|:)|') + '(?::((?::'.concat(c, '){0,5}:').concat(o, '|(?::').concat(c, '){1,7}|:))') + ')(%[0-9a-zA-Z-.:]{1,})?$');
                e.exports = t.default, e.exports.default = t.default;
            },
            7795: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : '';
                    (0, n.default)(e);
                    var r = e.split('/');
                    if (2 !== r.length)
                        return !1;
                    if (!o.test(r[1]))
                        return !1;
                    if (r[1].length > 1 && r[1].startsWith('0'))
                        return !1;
                    var a = (0, i.default)(r[0], t);
                    if (!a)
                        return !1;
                    var c = null;
                    switch (String(t)) {
                    case '4':
                        c = 32;
                        break;
                    case '6':
                        c = s;
                        break;
                    default:
                        c = (0, i.default)(r[0], '6') ? s : 32;
                    }
                    return r[1] <= c && r[1] >= 0;
                };
                var n = a(r(5571)), i = a(r(1028));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var o = /^\d{1,3}$/, s = 128;
                e.exports = t.default, e.exports.default = t.default;
            },
            7612: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function e(t) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : '';
                    if ((0, i.default)(t), !(r = String(r)))
                        return e(t, 10) || e(t, 13);
                    var n, c = t.replace(/[\s-]+/g, ''), u = 0;
                    if ('10' === r) {
                        if (!a.test(c))
                            return !1;
                        for (n = 0; n < 9; n++)
                            u += (n + 1) * c.charAt(n);
                        if ('X' === c.charAt(9) ? u += 100 : u += 10 * c.charAt(9), u % 11 == 0)
                            return !!c;
                    } else if ('13' === r) {
                        if (!o.test(c))
                            return !1;
                        for (n = 0; n < 12; n++)
                            u += s[n % 2] * c.charAt(n);
                        if (c.charAt(12) - (10 - u % 10) % 10 == 0)
                            return !!c;
                    }
                    return !1;
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^(?:[0-9]{9}X|[0-9]{10})$/, o = /^(?:[0-9]{13})$/, s = [
                        1,
                        3
                    ];
                e.exports = t.default, e.exports.default = t.default;
            },
            7148: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    if ((0, i.default)(e), !a.test(e))
                        return !1;
                    for (var t = !0, r = 0, n = e.length - 2; n >= 0; n--)
                        if (e[n] >= 'A' && e[n] <= 'Z')
                            for (var o = e[n].charCodeAt(0) - 55, s = 0, c = [
                                        o % 10,
                                        Math.trunc(o / 10)
                                    ]; s < c.length; s++) {
                                var u = c[s];
                                r += t ? u >= 5 ? 1 + 2 * (u - 5) : 2 * u : u, t = !t;
                            }
                        else {
                            var l = e[n].charCodeAt(0) - '0'.charCodeAt(0);
                            r += t ? l >= 5 ? 1 + 2 * (l - 5) : 2 * l : l, t = !t;
                        }
                    var d = 10 * Math.trunc((r + 9) / 10) - r;
                    return +e[e.length - 1] === d;
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            1727: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.has(e.toUpperCase());
                }, t.CountryCodes = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = new Set([
                        'AD',
                        'AE',
                        'AF',
                        'AG',
                        'AI',
                        'AL',
                        'AM',
                        'AO',
                        'AQ',
                        'AR',
                        'AS',
                        'AT',
                        'AU',
                        'AW',
                        'AX',
                        'AZ',
                        'BA',
                        'BB',
                        'BD',
                        'BE',
                        'BF',
                        'BG',
                        'BH',
                        'BI',
                        'BJ',
                        'BL',
                        'BM',
                        'BN',
                        'BO',
                        'BQ',
                        'BR',
                        'BS',
                        'BT',
                        'BV',
                        'BW',
                        'BY',
                        'BZ',
                        'CA',
                        'CC',
                        'CD',
                        'CF',
                        'CG',
                        'CH',
                        'CI',
                        'CK',
                        'CL',
                        'CM',
                        'CN',
                        'CO',
                        'CR',
                        'CU',
                        'CV',
                        'CW',
                        'CX',
                        'CY',
                        'CZ',
                        'DE',
                        'DJ',
                        'DK',
                        'DM',
                        'DO',
                        'DZ',
                        'EC',
                        'EE',
                        'EG',
                        'EH',
                        'ER',
                        'ES',
                        'ET',
                        'FI',
                        'FJ',
                        'FK',
                        'FM',
                        'FO',
                        'FR',
                        'GA',
                        'GB',
                        'GD',
                        'GE',
                        'GF',
                        'GG',
                        'GH',
                        'GI',
                        'GL',
                        'GM',
                        'GN',
                        'GP',
                        'GQ',
                        'GR',
                        'GS',
                        'GT',
                        'GU',
                        'GW',
                        'GY',
                        'HK',
                        'HM',
                        'HN',
                        'HR',
                        'HT',
                        'HU',
                        'ID',
                        'IE',
                        'IL',
                        'IM',
                        'IN',
                        'IO',
                        'IQ',
                        'IR',
                        'IS',
                        'IT',
                        'JE',
                        'JM',
                        'JO',
                        'JP',
                        'KE',
                        'KG',
                        'KH',
                        'KI',
                        'KM',
                        'KN',
                        'KP',
                        'KR',
                        'KW',
                        'KY',
                        'KZ',
                        'LA',
                        'LB',
                        'LC',
                        'LI',
                        'LK',
                        'LR',
                        'LS',
                        'LT',
                        'LU',
                        'LV',
                        'LY',
                        'MA',
                        'MC',
                        'MD',
                        'ME',
                        'MF',
                        'MG',
                        'MH',
                        'MK',
                        'ML',
                        'MM',
                        'MN',
                        'MO',
                        'MP',
                        'MQ',
                        'MR',
                        'MS',
                        'MT',
                        'MU',
                        'MV',
                        'MW',
                        'MX',
                        'MY',
                        'MZ',
                        'NA',
                        'NC',
                        'NE',
                        'NF',
                        'NG',
                        'NI',
                        'NL',
                        'NO',
                        'NP',
                        'NR',
                        'NU',
                        'NZ',
                        'OM',
                        'PA',
                        'PE',
                        'PF',
                        'PG',
                        'PH',
                        'PK',
                        'PL',
                        'PM',
                        'PN',
                        'PR',
                        'PS',
                        'PT',
                        'PW',
                        'PY',
                        'QA',
                        'RE',
                        'RO',
                        'RS',
                        'RU',
                        'RW',
                        'SA',
                        'SB',
                        'SC',
                        'SD',
                        'SE',
                        'SG',
                        'SH',
                        'SI',
                        'SJ',
                        'SK',
                        'SL',
                        'SM',
                        'SN',
                        'SO',
                        'SR',
                        'SS',
                        'ST',
                        'SV',
                        'SX',
                        'SY',
                        'SZ',
                        'TC',
                        'TD',
                        'TF',
                        'TG',
                        'TH',
                        'TJ',
                        'TK',
                        'TL',
                        'TM',
                        'TN',
                        'TO',
                        'TR',
                        'TT',
                        'TV',
                        'TW',
                        'TZ',
                        'UA',
                        'UG',
                        'UM',
                        'US',
                        'UY',
                        'UZ',
                        'VA',
                        'VC',
                        'VE',
                        'VG',
                        'VI',
                        'VN',
                        'VU',
                        'WF',
                        'WS',
                        'YE',
                        'YT',
                        'ZA',
                        'ZM',
                        'ZW'
                    ]), o = a;
                t.CountryCodes = o;
            },
            6776: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.has(e.toUpperCase());
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = new Set([
                        'AFG',
                        'ALA',
                        'ALB',
                        'DZA',
                        'ASM',
                        'AND',
                        'AGO',
                        'AIA',
                        'ATA',
                        'ATG',
                        'ARG',
                        'ARM',
                        'ABW',
                        'AUS',
                        'AUT',
                        'AZE',
                        'BHS',
                        'BHR',
                        'BGD',
                        'BRB',
                        'BLR',
                        'BEL',
                        'BLZ',
                        'BEN',
                        'BMU',
                        'BTN',
                        'BOL',
                        'BES',
                        'BIH',
                        'BWA',
                        'BVT',
                        'BRA',
                        'IOT',
                        'BRN',
                        'BGR',
                        'BFA',
                        'BDI',
                        'KHM',
                        'CMR',
                        'CAN',
                        'CPV',
                        'CYM',
                        'CAF',
                        'TCD',
                        'CHL',
                        'CHN',
                        'CXR',
                        'CCK',
                        'COL',
                        'COM',
                        'COG',
                        'COD',
                        'COK',
                        'CRI',
                        'CIV',
                        'HRV',
                        'CUB',
                        'CUW',
                        'CYP',
                        'CZE',
                        'DNK',
                        'DJI',
                        'DMA',
                        'DOM',
                        'ECU',
                        'EGY',
                        'SLV',
                        'GNQ',
                        'ERI',
                        'EST',
                        'ETH',
                        'FLK',
                        'FRO',
                        'FJI',
                        'FIN',
                        'FRA',
                        'GUF',
                        'PYF',
                        'ATF',
                        'GAB',
                        'GMB',
                        'GEO',
                        'DEU',
                        'GHA',
                        'GIB',
                        'GRC',
                        'GRL',
                        'GRD',
                        'GLP',
                        'GUM',
                        'GTM',
                        'GGY',
                        'GIN',
                        'GNB',
                        'GUY',
                        'HTI',
                        'HMD',
                        'VAT',
                        'HND',
                        'HKG',
                        'HUN',
                        'ISL',
                        'IND',
                        'IDN',
                        'IRN',
                        'IRQ',
                        'IRL',
                        'IMN',
                        'ISR',
                        'ITA',
                        'JAM',
                        'JPN',
                        'JEY',
                        'JOR',
                        'KAZ',
                        'KEN',
                        'KIR',
                        'PRK',
                        'KOR',
                        'KWT',
                        'KGZ',
                        'LAO',
                        'LVA',
                        'LBN',
                        'LSO',
                        'LBR',
                        'LBY',
                        'LIE',
                        'LTU',
                        'LUX',
                        'MAC',
                        'MKD',
                        'MDG',
                        'MWI',
                        'MYS',
                        'MDV',
                        'MLI',
                        'MLT',
                        'MHL',
                        'MTQ',
                        'MRT',
                        'MUS',
                        'MYT',
                        'MEX',
                        'FSM',
                        'MDA',
                        'MCO',
                        'MNG',
                        'MNE',
                        'MSR',
                        'MAR',
                        'MOZ',
                        'MMR',
                        'NAM',
                        'NRU',
                        'NPL',
                        'NLD',
                        'NCL',
                        'NZL',
                        'NIC',
                        'NER',
                        'NGA',
                        'NIU',
                        'NFK',
                        'MNP',
                        'NOR',
                        'OMN',
                        'PAK',
                        'PLW',
                        'PSE',
                        'PAN',
                        'PNG',
                        'PRY',
                        'PER',
                        'PHL',
                        'PCN',
                        'POL',
                        'PRT',
                        'PRI',
                        'QAT',
                        'REU',
                        'ROU',
                        'RUS',
                        'RWA',
                        'BLM',
                        'SHN',
                        'KNA',
                        'LCA',
                        'MAF',
                        'SPM',
                        'VCT',
                        'WSM',
                        'SMR',
                        'STP',
                        'SAU',
                        'SEN',
                        'SRB',
                        'SYC',
                        'SLE',
                        'SGP',
                        'SXM',
                        'SVK',
                        'SVN',
                        'SLB',
                        'SOM',
                        'ZAF',
                        'SGS',
                        'SSD',
                        'ESP',
                        'LKA',
                        'SDN',
                        'SUR',
                        'SJM',
                        'SWZ',
                        'SWE',
                        'CHE',
                        'SYR',
                        'TWN',
                        'TJK',
                        'TZA',
                        'THA',
                        'TLS',
                        'TGO',
                        'TKL',
                        'TON',
                        'TTO',
                        'TUN',
                        'TUR',
                        'TKM',
                        'TCA',
                        'TUV',
                        'UGA',
                        'UKR',
                        'ARE',
                        'GBR',
                        'USA',
                        'UMI',
                        'URY',
                        'UZB',
                        'VUT',
                        'VEN',
                        'VNM',
                        'VGB',
                        'VIR',
                        'WLF',
                        'ESH',
                        'YEM',
                        'ZMB',
                        'ZWE'
                    ]);
                e.exports = t.default, e.exports.default = t.default;
            },
            9963: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.has(e.toUpperCase());
                }, t.CurrencyCodes = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = new Set([
                        'AED',
                        'AFN',
                        'ALL',
                        'AMD',
                        'ANG',
                        'AOA',
                        'ARS',
                        'AUD',
                        'AWG',
                        'AZN',
                        'BAM',
                        'BBD',
                        'BDT',
                        'BGN',
                        'BHD',
                        'BIF',
                        'BMD',
                        'BND',
                        'BOB',
                        'BOV',
                        'BRL',
                        'BSD',
                        'BTN',
                        'BWP',
                        'BYN',
                        'BZD',
                        'CAD',
                        'CDF',
                        'CHE',
                        'CHF',
                        'CHW',
                        'CLF',
                        'CLP',
                        'CNY',
                        'COP',
                        'COU',
                        'CRC',
                        'CUC',
                        'CUP',
                        'CVE',
                        'CZK',
                        'DJF',
                        'DKK',
                        'DOP',
                        'DZD',
                        'EGP',
                        'ERN',
                        'ETB',
                        'EUR',
                        'FJD',
                        'FKP',
                        'GBP',
                        'GEL',
                        'GHS',
                        'GIP',
                        'GMD',
                        'GNF',
                        'GTQ',
                        'GYD',
                        'HKD',
                        'HNL',
                        'HRK',
                        'HTG',
                        'HUF',
                        'IDR',
                        'ILS',
                        'INR',
                        'IQD',
                        'IRR',
                        'ISK',
                        'JMD',
                        'JOD',
                        'JPY',
                        'KES',
                        'KGS',
                        'KHR',
                        'KMF',
                        'KPW',
                        'KRW',
                        'KWD',
                        'KYD',
                        'KZT',
                        'LAK',
                        'LBP',
                        'LKR',
                        'LRD',
                        'LSL',
                        'LYD',
                        'MAD',
                        'MDL',
                        'MGA',
                        'MKD',
                        'MMK',
                        'MNT',
                        'MOP',
                        'MRU',
                        'MUR',
                        'MVR',
                        'MWK',
                        'MXN',
                        'MXV',
                        'MYR',
                        'MZN',
                        'NAD',
                        'NGN',
                        'NIO',
                        'NOK',
                        'NPR',
                        'NZD',
                        'OMR',
                        'PAB',
                        'PEN',
                        'PGK',
                        'PHP',
                        'PKR',
                        'PLN',
                        'PYG',
                        'QAR',
                        'RON',
                        'RSD',
                        'RUB',
                        'RWF',
                        'SAR',
                        'SBD',
                        'SCR',
                        'SDG',
                        'SEK',
                        'SGD',
                        'SHP',
                        'SLL',
                        'SOS',
                        'SRD',
                        'SSP',
                        'STN',
                        'SVC',
                        'SYP',
                        'SZL',
                        'THB',
                        'TJS',
                        'TMT',
                        'TND',
                        'TOP',
                        'TRY',
                        'TTD',
                        'TWD',
                        'TZS',
                        'UAH',
                        'UGX',
                        'USD',
                        'USN',
                        'UYI',
                        'UYU',
                        'UYW',
                        'UZS',
                        'VES',
                        'VND',
                        'VUV',
                        'WST',
                        'XAF',
                        'XAG',
                        'XAU',
                        'XBA',
                        'XBB',
                        'XBC',
                        'XBD',
                        'XCD',
                        'XDR',
                        'XOF',
                        'XPD',
                        'XPF',
                        'XPT',
                        'XSU',
                        'XTS',
                        'XUA',
                        'XXX',
                        'YER',
                        'ZAR',
                        'ZMW',
                        'ZWL'
                    ]), o = a;
                t.CurrencyCodes = o;
            },
            5061: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    (0, i.default)(e);
                    var r = t.strictSeparator ? o.test(e) : a.test(e);
                    return r && t.strict ? s(e) : r;
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, o = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, s = function (e) {
                        var t = e.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
                        if (t) {
                            var r = Number(t[1]), n = Number(t[2]);
                            return r % 4 == 0 && r % 100 != 0 || r % 400 == 0 ? n <= 366 : n <= 365;
                        }
                        var i = e.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number), a = i[1], o = i[2], s = i[3], c = o ? '0'.concat(o).slice(-2) : o, u = s ? '0'.concat(s).slice(-2) : s, l = new Date(''.concat(a, '-').concat(c || '01', '-').concat(u || '01'));
                        return !o || !s || l.getUTCFullYear() === a && l.getUTCMonth() + 1 === o && l.getUTCDate() === s;
                    };
                e.exports = t.default, e.exports.default = t.default;
            },
            4339: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            9887: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    (0, i.default)(e);
                    var r = a;
                    if (r = t.require_hyphen ? r.replace('?', '') : r, !(r = t.case_sensitive ? new RegExp(r) : new RegExp(r, 'i')).test(e))
                        return !1;
                    for (var n = e.replace('-', '').toUpperCase(), o = 0, s = 0; s < n.length; s++) {
                        var c = n[s];
                        o += ('X' === c ? 10 : +c) * (8 - s);
                    }
                    return o % 11 == 0;
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = '^\\d{4}-?\\d{3}[\\dX]$';
                e.exports = t.default, e.exports.default = t.default;
            },
            9396: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    if ((0, n.default)(e), t in o)
                        return o[t](e);
                    if ('any' === t) {
                        for (var r in o)
                            if (o.hasOwnProperty(r) && (0, o[r])(e))
                                return !0;
                        return !1;
                    }
                    throw new Error('Invalid locale \''.concat(t, '\''));
                };
                var n = a(r(5571)), i = a(r(937));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var o = {
                    PL: function (e) {
                        (0, n.default)(e);
                        var t = {
                            1: 1,
                            2: 3,
                            3: 7,
                            4: 9,
                            5: 1,
                            6: 3,
                            7: 7,
                            8: 9,
                            9: 1,
                            10: 3,
                            11: 0
                        };
                        if (null != e && 11 === e.length && (0, i.default)(e, { allow_leading_zeroes: !0 })) {
                            var r = e.split('').slice(0, -1).reduce(function (e, r, n) {
                                    return e + Number(r) * t[n + 1];
                                }, 0) % 10, a = Number(e.charAt(e.length - 1));
                            if (0 === r && 0 === a || a === 10 - r)
                                return !0;
                        }
                        return !1;
                    },
                    ES: function (e) {
                        (0, n.default)(e);
                        var t = {
                                X: 0,
                                Y: 1,
                                Z: 2
                            }, r = e.trim().toUpperCase();
                        if (!/^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/.test(r))
                            return !1;
                        var i = r.slice(0, -1).replace(/[X,Y,Z]/g, function (e) {
                            return t[e];
                        });
                        return r.endsWith([
                            'T',
                            'R',
                            'W',
                            'A',
                            'G',
                            'M',
                            'Y',
                            'F',
                            'P',
                            'D',
                            'X',
                            'B',
                            'N',
                            'J',
                            'Z',
                            'S',
                            'Q',
                            'V',
                            'H',
                            'L',
                            'C',
                            'K',
                            'E'
                        ][i % 23]);
                    },
                    FI: function (e) {
                        return (0, n.default)(e), 11 === e.length && (!!e.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/) && '0123456789ABCDEFHJKLMNPRSTUVWXY'[(1000 * parseInt(e.slice(0, 6), 10) + parseInt(e.slice(7, 10), 10)) % 31] === e.slice(10, 11));
                    },
                    IN: function (e) {
                        var t = [
                                [
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9
                                ],
                                [
                                    1,
                                    2,
                                    3,
                                    4,
                                    0,
                                    6,
                                    7,
                                    8,
                                    9,
                                    5
                                ],
                                [
                                    2,
                                    3,
                                    4,
                                    0,
                                    1,
                                    7,
                                    8,
                                    9,
                                    5,
                                    6
                                ],
                                [
                                    3,
                                    4,
                                    0,
                                    1,
                                    2,
                                    8,
                                    9,
                                    5,
                                    6,
                                    7
                                ],
                                [
                                    4,
                                    0,
                                    1,
                                    2,
                                    3,
                                    9,
                                    5,
                                    6,
                                    7,
                                    8
                                ],
                                [
                                    5,
                                    9,
                                    8,
                                    7,
                                    6,
                                    0,
                                    4,
                                    3,
                                    2,
                                    1
                                ],
                                [
                                    6,
                                    5,
                                    9,
                                    8,
                                    7,
                                    1,
                                    0,
                                    4,
                                    3,
                                    2
                                ],
                                [
                                    7,
                                    6,
                                    5,
                                    9,
                                    8,
                                    2,
                                    1,
                                    0,
                                    4,
                                    3
                                ],
                                [
                                    8,
                                    7,
                                    6,
                                    5,
                                    9,
                                    3,
                                    2,
                                    1,
                                    0,
                                    4
                                ],
                                [
                                    9,
                                    8,
                                    7,
                                    6,
                                    5,
                                    4,
                                    3,
                                    2,
                                    1,
                                    0
                                ]
                            ], r = [
                                [
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9
                                ],
                                [
                                    1,
                                    5,
                                    7,
                                    6,
                                    2,
                                    8,
                                    3,
                                    0,
                                    9,
                                    4
                                ],
                                [
                                    5,
                                    8,
                                    0,
                                    3,
                                    7,
                                    9,
                                    6,
                                    1,
                                    4,
                                    2
                                ],
                                [
                                    8,
                                    9,
                                    1,
                                    6,
                                    0,
                                    4,
                                    3,
                                    5,
                                    2,
                                    7
                                ],
                                [
                                    9,
                                    4,
                                    5,
                                    3,
                                    1,
                                    2,
                                    6,
                                    8,
                                    7,
                                    0
                                ],
                                [
                                    4,
                                    2,
                                    8,
                                    6,
                                    5,
                                    7,
                                    3,
                                    9,
                                    0,
                                    1
                                ],
                                [
                                    2,
                                    7,
                                    9,
                                    3,
                                    8,
                                    0,
                                    6,
                                    4,
                                    1,
                                    5
                                ],
                                [
                                    7,
                                    0,
                                    4,
                                    6,
                                    9,
                                    1,
                                    3,
                                    2,
                                    5,
                                    8
                                ]
                            ], n = e.trim();
                        if (!/^[1-9]\d{3}\s?\d{4}\s?\d{4}$/.test(n))
                            return !1;
                        var i = 0;
                        return n.replace(/\s/g, '').split('').map(Number).reverse().forEach(function (e, n) {
                            i = t[i][r[n % 8][e]];
                        }), 0 === i;
                    },
                    IR: function (e) {
                        if (!e.match(/^\d{10}$/))
                            return !1;
                        if (e = '0000'.concat(e).substr(e.length - 6), 0 === parseInt(e.substr(3, 6), 10))
                            return !1;
                        for (var t = parseInt(e.substr(9, 1), 10), r = 0, n = 0; n < 9; n++)
                            r += parseInt(e.substr(n, 1), 10) * (10 - n);
                        return (r %= 11) < 2 && t === r || r >= 2 && t === 11 - r;
                    },
                    IT: function (e) {
                        return 9 === e.length && 'CA00000AA' !== e && e.search(/C[A-Z][0-9]{5}[A-Z]{2}/i) > -1;
                    },
                    NO: function (e) {
                        var t = e.trim();
                        if (isNaN(Number(t)))
                            return !1;
                        if (11 !== t.length)
                            return !1;
                        if ('00000000000' === t)
                            return !1;
                        var r = t.split('').map(Number), n = (11 - (3 * r[0] + 7 * r[1] + 6 * r[2] + 1 * r[3] + 8 * r[4] + 9 * r[5] + 4 * r[6] + 5 * r[7] + 2 * r[8]) % 11) % 11, i = (11 - (5 * r[0] + 4 * r[1] + 3 * r[2] + 2 * r[3] + 7 * r[4] + 6 * r[5] + 5 * r[6] + 4 * r[7] + 3 * r[8] + 2 * n) % 11) % 11;
                        return n === r[9] && i === r[10];
                    },
                    TH: function (e) {
                        if (!e.match(/^[1-8]\d{12}$/))
                            return !1;
                        for (var t = 0, r = 0; r < 12; r++)
                            t += parseInt(e[r], 10) * (13 - r);
                        return e[12] === ((11 - t % 11) % 10).toString();
                    },
                    LK: function (e) {
                        return !(10 !== e.length || !/^[1-9]\d{8}[vx]$/i.test(e)) || !(12 !== e.length || !/^[1-9]\d{11}$/i.test(e));
                    },
                    'he-IL': function (e) {
                        var t = e.trim();
                        if (!/^\d{9}$/.test(t))
                            return !1;
                        for (var r, n = t, i = 0, a = 0; a < n.length; a++)
                            i += (r = Number(n[a]) * (a % 2 + 1)) > 9 ? r - 9 : r;
                        return i % 10 == 0;
                    },
                    'ar-LY': function (e) {
                        var t = e.trim();
                        return !!/^(1|2)\d{11}$/.test(t);
                    },
                    'ar-TN': function (e) {
                        var t = e.trim();
                        return !!/^\d{8}$/.test(t);
                    },
                    'zh-CN': function (e) {
                        var t, r = [
                                '11',
                                '12',
                                '13',
                                '14',
                                '15',
                                '21',
                                '22',
                                '23',
                                '31',
                                '32',
                                '33',
                                '34',
                                '35',
                                '36',
                                '37',
                                '41',
                                '42',
                                '43',
                                '44',
                                '45',
                                '46',
                                '50',
                                '51',
                                '52',
                                '53',
                                '54',
                                '61',
                                '62',
                                '63',
                                '64',
                                '65',
                                '71',
                                '81',
                                '82',
                                '91'
                            ], n = [
                                '7',
                                '9',
                                '10',
                                '5',
                                '8',
                                '4',
                                '2',
                                '1',
                                '6',
                                '3',
                                '7',
                                '9',
                                '10',
                                '5',
                                '8',
                                '4',
                                '2'
                            ], i = [
                                '1',
                                '0',
                                'X',
                                '9',
                                '8',
                                '7',
                                '6',
                                '5',
                                '4',
                                '3',
                                '2'
                            ], a = function (e) {
                                return r.includes(e);
                            }, o = function (e) {
                                var t = parseInt(e.substring(0, 4), 10), r = parseInt(e.substring(4, 6), 10), n = parseInt(e.substring(6), 10), i = new Date(t, r - 1, n);
                                return !(i > new Date()) && i.getFullYear() === t && i.getMonth() === r - 1 && i.getDate() === n;
                            };
                        return !!/^\d{15}|(\d{17}(\d|x|X))$/.test(t = e) && (15 === t.length ? function (e) {
                            var t = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(e);
                            if (!t)
                                return !1;
                            var r = e.substring(0, 2);
                            if (!(t = a(r)))
                                return !1;
                            var n = '19'.concat(e.substring(6, 12));
                            return !!(t = o(n));
                        }(t) : function (e) {
                            var t = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(e);
                            if (!t)
                                return !1;
                            var r = e.substring(0, 2);
                            if (!(t = a(r)))
                                return !1;
                            var s = e.substring(6, 14);
                            return !!(t = o(s)) && function (e) {
                                return function (e) {
                                    for (var t = e.substring(0, 17), r = 0, a = 0; a < 17; a++)
                                        r += parseInt(t.charAt(a), 10) * parseInt(n[a], 10);
                                    return i[r % 11];
                                }(e) === e.charAt(17).toUpperCase();
                            }(e);
                        }(t));
                    },
                    'zh-TW': function (e) {
                        var t = {
                                A: 10,
                                B: 11,
                                C: 12,
                                D: 13,
                                E: 14,
                                F: 15,
                                G: 16,
                                H: 17,
                                I: 34,
                                J: 18,
                                K: 19,
                                L: 20,
                                M: 21,
                                N: 22,
                                O: 35,
                                P: 23,
                                Q: 24,
                                R: 25,
                                S: 26,
                                T: 27,
                                U: 28,
                                V: 29,
                                W: 32,
                                X: 30,
                                Y: 31,
                                Z: 33
                            }, r = e.trim().toUpperCase();
                        return !!/^[A-Z][0-9]{9}$/.test(r) && Array.from(r).reduce(function (e, r, n) {
                            if (0 === n) {
                                var i = t[r];
                                return i % 10 * 9 + Math.floor(i / 10);
                            }
                            return 9 === n ? (10 - e % 10 - Number(r)) % 10 == 0 : e + Number(r) * (9 - n);
                        }, 0);
                    }
                };
                e.exports = t.default, e.exports.default = t.default;
            },
            7228: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    var r;
                    if ((0, n.default)(e), '[object Array]' === Object.prototype.toString.call(t)) {
                        var a = [];
                        for (r in t)
                            ({}.hasOwnProperty.call(t, r) && (a[r] = (0, i.default)(t[r])));
                        return a.indexOf(e) >= 0;
                    }
                    return 'object' === o(t) ? t.hasOwnProperty(e) : !(!t || 'function' != typeof t.indexOf) && t.indexOf(e) >= 0;
                };
                var n = a(r(5571)), i = a(r(1913));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o(e) {
                    return (o = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            937: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, i.default)(e);
                    var r = (t = t || {}).hasOwnProperty('allow_leading_zeroes') && !t.allow_leading_zeroes ? a : o, n = !t.hasOwnProperty('min') || e >= t.min, s = !t.hasOwnProperty('max') || e <= t.max, c = !t.hasOwnProperty('lt') || e < t.lt, u = !t.hasOwnProperty('gt') || e > t.gt;
                    return r.test(e) && n && s && c && u;
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^(?:[-+]?(?:0|[1-9][0-9]*))$/, o = /^[-+]?[0-9]+$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            1008: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, n.default)(e);
                    try {
                        t = (0, i.default)(t, s);
                        var r = [];
                        t.allow_primitives && (r = [
                            null,
                            !1,
                            !0
                        ]);
                        var a = JSON.parse(e);
                        return r.includes(a) || !!a && 'object' === o(a);
                    } catch (e) {
                    }
                    return !1;
                };
                var n = a(r(5571)), i = a(r(4808));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o(e) {
                    return (o = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                var s = { allow_primitives: !1 };
                e.exports = t.default, e.exports.default = t.default;
            },
            4979: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    (0, n.default)(e);
                    var t = e.split('.'), r = t.length;
                    return !(r > 3 || r < 2) && t.reduce(function (e, t) {
                        return e && (0, i.default)(t, { urlSafe: !0 });
                    }, !0);
                };
                var n = a(r(5571)), i = a(r(2689));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            478: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    if ((0, n.default)(e), t = (0, i.default)(t, l), !e.includes(','))
                        return !1;
                    var r = e.split(',');
                    return !(r[0].startsWith('(') && !r[1].endsWith(')') || r[1].endsWith(')') && !r[0].startsWith('(')) && (t.checkDMS ? c.test(r[0]) && u.test(r[1]) : o.test(r[0]) && s.test(r[1]));
                };
                var n = a(r(5571)), i = a(r(4808));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var o = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/, s = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/, c = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i, u = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i, l = { checkDMS: !1 };
                e.exports = t.default, e.exports.default = t.default;
            },
            661: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    var r, n;
                    (0, i.default)(e), 'object' === a(t) ? (r = t.min || 0, n = t.max) : (r = arguments[1] || 0, n = arguments[2]);
                    var o = e.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], s = e.length - o.length;
                    return s >= r && (void 0 === n || s <= n);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                function a(e) {
                    return (a = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            2786: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    if ((0, i.default)(e), t in a)
                        return a[t](e);
                    if ('any' === t) {
                        for (var r in a)
                            if ((0, a[r])(e))
                                return !0;
                        return !1;
                    }
                    throw new Error('Invalid locale \''.concat(t, '\''));
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = {
                        'cs-CZ': function (e) {
                            return /^(([ABCDEFHKIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(e);
                        },
                        'de-DE': function (e) {
                            return /^((AW|UL|AK|GA|AÖ|LF|AZ|AM|AS|ZE|AN|AB|A|KG|KH|BA|EW|BZ|HY|KM|BT|HP|B|BC|BI|BO|FN|TT|ÜB|BN|AH|BS|FR|HB|ZZ|BB|BK|BÖ|OC|OK|CW|CE|C|CO|LH|CB|KW|LC|LN|DA|DI|DE|DH|SY|NÖ|DO|DD|DU|DN|D|EI|EA|EE|FI|EM|EL|EN|PF|ED|EF|ER|AU|ZP|E|ES|NT|EU|FL|FO|FT|FF|F|FS|FD|FÜ|GE|G|GI|GF|GS|ZR|GG|GP|GR|NY|ZI|GÖ|GZ|GT|HA|HH|HM|HU|WL|HZ|WR|RN|HK|HD|HN|HS|GK|HE|HF|RZ|HI|HG|HO|HX|IK|IL|IN|J|JL|KL|KA|KS|KF|KE|KI|KT|KO|KN|KR|KC|KU|K|LD|LL|LA|L|OP|LM|LI|LB|LU|LÖ|HL|LG|MD|GN|MZ|MA|ML|MR|MY|AT|DM|MC|NZ|RM|RG|MM|ME|MB|MI|FG|DL|HC|MW|RL|MK|MG|MÜ|WS|MH|M|MS|NU|NB|ND|NM|NK|NW|NR|NI|NF|DZ|EB|OZ|TG|TO|N|OA|GM|OB|CA|EH|FW|OF|OL|OE|OG|BH|LR|OS|AA|GD|OH|KY|NP|WK|PB|PA|PE|PI|PS|P|PM|PR|RA|RV|RE|R|H|SB|WN|RS|RD|RT|BM|NE|GV|RP|SU|GL|RO|GÜ|RH|EG|RW|PN|SK|MQ|RU|SZ|RI|SL|SM|SC|HR|FZ|VS|SW|SN|CR|SE|SI|SO|LP|SG|NH|SP|IZ|ST|BF|TE|HV|OD|SR|S|AC|DW|ZW|TF|TS|TR|TÜ|UM|PZ|TP|UE|UN|UH|MN|KK|VB|V|AE|PL|RC|VG|GW|PW|VR|VK|KB|WA|WT|BE|WM|WE|AP|MO|WW|FB|WZ|WI|WB|JE|WF|WO|W|WÜ|BL|Z|GC)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(AIC|FDB|ABG|SLN|SAW|KLZ|BUL|ESB|NAB|SUL|WST|ABI|AZE|BTF|KÖT|DKB|FEU|ROT|ALZ|SMÜ|WER|AUR|NOR|DÜW|BRK|HAB|TÖL|WOR|BAD|BAR|BER|BIW|EBS|KEM|MÜB|PEG|BGL|BGD|REI|WIL|BKS|BIR|WAT|BOR|BOH|BOT|BRB|BLK|HHM|NEB|NMB|WSF|LEO|HDL|WMS|WZL|BÜS|CHA|KÖZ|ROD|WÜM|CLP|NEC|COC|ZEL|COE|CUX|DAH|LDS|DEG|DEL|RSL|DLG|DGF|LAN|HEI|MED|DON|KIB|ROK|JÜL|MON|SLE|EBE|EIC|HIG|WBS|BIT|PRÜ|LIB|EMD|WIT|ERH|HÖS|ERZ|ANA|ASZ|MAB|MEK|STL|SZB|FDS|HCH|HOR|WOL|FRG|GRA|WOS|FRI|FFB|GAP|GER|BRL|CLZ|GTH|NOH|HGW|GRZ|LÖB|NOL|WSW|DUD|HMÜ|OHA|KRU|HAL|HAM|HBS|QLB|HVL|NAU|HAS|EBN|GEO|HOH|HDH|ERK|HER|WAN|HEF|ROF|HBN|ALF|HSK|USI|NAI|REH|SAN|KÜN|ÖHR|HOL|WAR|ARN|BRG|GNT|HOG|WOH|KEH|MAI|PAR|RID|ROL|KLE|GEL|KUS|KYF|ART|SDH|LDK|DIL|MAL|VIB|LER|BNA|GHA|GRM|MTL|WUR|LEV|LIF|STE|WEL|LIP|VAI|LUP|HGN|LBZ|LWL|PCH|STB|DAN|MKK|SLÜ|MSP|TBB|MGH|MTK|BIN|MSH|EIL|HET|SGH|BID|MYK|MSE|MST|MÜR|WRN|MEI|GRH|RIE|MZG|MIL|OBB|BED|FLÖ|MOL|FRW|SEE|SRB|AIB|MOS|BCH|ILL|SOB|NMS|NEA|SEF|UFF|NEW|VOH|NDH|TDO|NWM|GDB|GVM|WIS|NOM|EIN|GAN|LAU|HEB|OHV|OSL|SFB|ERB|LOS|BSK|KEL|BSB|MEL|WTL|OAL|FÜS|MOD|OHZ|OPR|BÜR|PAF|PLÖ|CAS|GLA|REG|VIT|ECK|SIM|GOA|EMS|DIZ|GOH|RÜD|SWA|NES|KÖN|MET|LRO|BÜZ|DBR|ROS|TET|HRO|ROW|BRV|HIP|PAN|GRI|SHK|EIS|SRO|SOK|LBS|SCZ|MER|QFT|SLF|SLS|HOM|SLK|ASL|BBG|SBK|SFT|SHG|MGN|MEG|ZIG|SAD|NEN|OVI|SHA|BLB|SIG|SON|SPN|FOR|GUB|SPB|IGB|WND|STD|STA|SDL|OBG|HST|BOG|SHL|PIR|FTL|SEB|SÖM|SÜW|TIR|SAB|TUT|ANG|SDT|LÜN|LSZ|MHL|VEC|VER|VIE|OVL|ANK|OVP|SBG|UEM|UER|WLG|GMN|NVP|RDG|RÜG|DAU|FKB|WAF|WAK|SLZ|WEN|SOG|APD|WUG|GUN|ESW|WIZ|WES|DIN|BRA|BÜD|WHV|HWI|GHC|WTM|WOB|WUN|MAK|SEL|OCH|HOT|WDA)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(e);
                        },
                        'de-LI': function (e) {
                            return /^FL[- ]?\d{1,5}[UZ]?$/.test(e);
                        },
                        'fi-FI': function (e) {
                            return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(e);
                        },
                        'pt-PT': function (e) {
                            return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(e);
                        },
                        'sq-AL': function (e) {
                            return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(e);
                        },
                        'pt-BR': function (e) {
                            return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(e);
                        }
                    };
                e.exports = t.default, e.exports.default = t.default;
            },
            7380: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), 'en_US_POSIX' === e || 'ca_ES_VALENCIA' === e || a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^[A-Za-z]{2,4}([_-]([A-Za-z]{4}|[\d]{3}))?([_-]([A-Za-z]{2}|[\d]{3}))?$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            3928: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), e === e.toLowerCase();
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            8999: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, i.default)(e), t && (t.no_colons || t.no_separators) ? o.test(e) : a.test(e) || s.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/, o = /^([0-9a-fA-F]){12}$/, s = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            368: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^[a-f0-9]{32}$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            2776: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e.trim());
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^magnet:\?xt(?:\.1)?=urn:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?($|&)/i;
                e.exports = t.default, e.exports.default = t.default;
            },
            4554: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e) || o.test(e) || s.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i, o = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i, s = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
                e.exports = t.default, e.exports.default = t.default;
            },
            8355: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t, r) {
                    if ((0, i.default)(e), r && r.strictMode && !e.startsWith('+'))
                        return !1;
                    if (Array.isArray(t))
                        return t.some(function (t) {
                            return !(!a.hasOwnProperty(t) || !a[t].test(e));
                        });
                    if (t in a)
                        return a[t].test(e);
                    if (!t || 'any' === t) {
                        for (var n in a)
                            if (a.hasOwnProperty(n) && a[n].test(e))
                                return !0;
                        return !1;
                    }
                    throw new Error('Invalid locale \''.concat(t, '\''));
                }, t.locales = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = {
                        'am-AM': /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
                        'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
                        'ar-BH': /^(\+?973)?(3|6)\d{7}$/,
                        'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
                        'ar-LB': /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
                        'ar-EG': /^((\+?20)|0)?1[0125]\d{8}$/,
                        'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
                        'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
                        'ar-KW': /^(\+?965)[569]\d{7}$/,
                        'ar-LY': /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
                        'ar-MA': /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
                        'ar-OM': /^((\+|00)968)?(9[1-9])\d{6}$/,
                        'ar-PS': /^(\+?970|0)5[6|9](\d{7})$/,
                        'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
                        'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
                        'ar-TN': /^(\+?216)?[2459]\d{7}$/,
                        'az-AZ': /^(\+994|0)(5[015]|7[07]|99)\d{7}$/,
                        'bs-BA': /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
                        'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
                        'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
                        'bn-BD': /^(\+?880|0)1[13456789][0-9]{8}$/,
                        'ca-AD': /^(\+376)?[346]\d{5}$/,
                        'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
                        'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
                        'de-DE': /^((\+49|0)[1|3])([0|5][0-45-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
                        'de-AT': /^(\+43|0)\d{1,4}\d{3,12}$/,
                        'de-CH': /^(\+41|0)([1-9])\d{1,9}$/,
                        'de-LU': /^(\+352)?((6\d1)\d{6})$/,
                        'dv-MV': /^(\+?960)?(7[2-9]|91|9[3-9])\d{7}$/,
                        'el-GR': /^(\+?30|0)?(69\d{8})$/,
                        'en-AU': /^(\+?61|0)4\d{8}$/,
                        'en-BM': /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}))/,
                        'en-GB': /^(\+?44|0)7\d{9}$/,
                        'en-GG': /^(\+?44|0)1481\d{6}$/,
                        'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
                        'en-GY': /^(\+592|0)6\d{6}$/,
                        'en-HK': /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
                        'en-MO': /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
                        'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
                        'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
                        'en-KE': /^(\+?254|0)(7|1)\d{8}$/,
                        'en-KI': /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
                        'en-MT': /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
                        'en-MU': /^(\+?230|0)?\d{8}$/,
                        'en-NA': /^(\+?264|0)(6|8)\d{7}$/,
                        'en-NG': /^(\+?234|0)?[789]\d{9}$/,
                        'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
                        'en-PK': /^((00|\+)?92|0)3[0-6]\d{8}$/,
                        'en-PH': /^(09|\+639)\d{9}$/,
                        'en-RW': /^(\+?250|0)?[7]\d{8}$/,
                        'en-SG': /^(\+65)?[3689]\d{7}$/,
                        'en-SL': /^(\+?232|0)\d{8}$/,
                        'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
                        'en-UG': /^(\+?256|0)?[7]\d{8}$/,
                        'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
                        'en-ZA': /^(\+?27|0)\d{9}$/,
                        'en-ZM': /^(\+?26)?09[567]\d{7}$/,
                        'en-ZW': /^(\+263)[0-9]{9}$/,
                        'en-BW': /^(\+?267)?(7[1-8]{1})\d{6}$/,
                        'es-AR': /^\+?549(11|[2368]\d)\d{8}$/,
                        'es-BO': /^(\+?591)?(6|7)\d{7}$/,
                        'es-CO': /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
                        'es-CL': /^(\+?56|0)[2-9]\d{1}\d{7}$/,
                        'es-CR': /^(\+506)?[2-8]\d{7}$/,
                        'es-CU': /^(\+53|0053)?5\d{7}/,
                        'es-DO': /^(\+?1)?8[024]9\d{7}$/,
                        'es-HN': /^(\+?504)?[9|8]\d{7}$/,
                        'es-EC': /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
                        'es-ES': /^(\+?34)?[6|7]\d{8}$/,
                        'es-PE': /^(\+?51)?9\d{8}$/,
                        'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
                        'es-PA': /^(\+?507)\d{7,8}$/,
                        'es-PY': /^(\+?595|0)9[9876]\d{7}$/,
                        'es-SV': /^(\+?503)?[67]\d{7}$/,
                        'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
                        'es-VE': /^(\+?58)?(2|4)\d{9}$/,
                        'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
                        'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
                        'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
                        'fj-FJ': /^(\+?679)?\s?\d{3}\s?\d{4}$/,
                        'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
                        'fr-BF': /^(\+226|0)[67]\d{7}$/,
                        'fr-CM': /^(\+?237)6[0-9]{8}$/,
                        'fr-FR': /^(\+?33|0)[67]\d{8}$/,
                        'fr-GF': /^(\+?594|0|00594)[67]\d{8}$/,
                        'fr-GP': /^(\+?590|0|00590)[67]\d{8}$/,
                        'fr-MQ': /^(\+?596|0|00596)[67]\d{8}$/,
                        'fr-PF': /^(\+?689)?8[789]\d{6}$/,
                        'fr-RE': /^(\+?262|0|00262)[67]\d{8}$/,
                        'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
                        'hu-HU': /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
                        'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
                        'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
                        'it-SM': /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
                        'ja-JP': /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
                        'ka-GE': /^(\+?995)?(5|79)\d{7}$/,
                        'kk-KZ': /^(\+?7|8)?7\d{9}$/,
                        'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
                        'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
                        'lt-LT': /^(\+370|8)\d{8}$/,
                        'lv-LV': /^(\+?371)2\d{7}$/,
                        'ms-MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
                        'mz-MZ': /^(\+?258)?8[234567]\d{7}$/,
                        'nb-NO': /^(\+?47)?[49]\d{7}$/,
                        'ne-NP': /^(\+?977)?9[78]\d{8}$/,
                        'nl-BE': /^(\+?32|0)4\d{8}$/,
                        'nl-NL': /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
                        'nn-NO': /^(\+?47)?[49]\d{7}$/,
                        'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
                        'pt-BR': /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[2-9]{1}\d{3}\-?\d{4}))$/,
                        'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
                        'pt-AO': /^(\+244)\d{9}$/,
                        'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
                        'ru-RU': /^(\+?7|8)?9\d{9}$/,
                        'si-LK': /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
                        'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
                        'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
                        'sq-AL': /^(\+355|0)6[789]\d{6}$/,
                        'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
                        'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
                        'tg-TJ': /^(\+?992)?[5][5]\d{7}$/,
                        'th-TH': /^(\+66|66|0)\d{9}$/,
                        'tr-TR': /^(\+?90|0)?5\d{9}$/,
                        'tk-TM': /^(\+993|993|8)\d{8}$/,
                        'uk-UA': /^(\+?38|8)?0\d{9}$/,
                        'uz-UZ': /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
                        'vi-VN': /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
                        'zh-CN': /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
                        'zh-TW': /^(\+?886\-?|0)?9\d{8}$/,
                        'dz-BT': /^(\+?975|0)?(17|16|77|02)\d{6}$/
                    };
                a['en-CA'] = a['en-US'], a['fr-CA'] = a['en-CA'], a['fr-BE'] = a['nl-BE'], a['zh-HK'] = a['en-HK'], a['zh-MO'] = a['en-MO'], a['ga-IE'] = a['en-IE'], a['fr-CH'] = a['de-CH'], a['it-CH'] = a['fr-CH'];
                var o = Object.keys(a);
                t.locales = o;
            },
            9131: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, n.default)(e), (0, i.default)(e) && 24 === e.length;
                };
                var n = a(r(5571)), i = a(r(7117));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            3590: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /[^\x00-\x7F]/;
                e.exports = t.default, e.exports.default = t.default;
            },
            4986: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, i.default)(e), t && t.no_symbols ? o.test(e) : new RegExp('^[+-]?([0-9]*['.concat((t || {}).locale ? a.decimal[t.locale] : '.', '])?[0-9]+$')).test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = r(79), o = /^[0-9]+$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            6090: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^(0o)?[0-7]+$/i;
                e.exports = t.default, e.exports.default = t.default;
            },
            1513: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, i.default)(e);
                    var r = e.replace(/\s/g, '').toUpperCase();
                    return t.toUpperCase() in a && a[t].test(r);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = {
                        AM: /^[A-Z]{2}\d{7}$/,
                        AR: /^[A-Z]{3}\d{6}$/,
                        AT: /^[A-Z]\d{7}$/,
                        AU: /^[A-Z]\d{7}$/,
                        BE: /^[A-Z]{2}\d{6}$/,
                        BG: /^\d{9}$/,
                        BR: /^[A-Z]{2}\d{6}$/,
                        BY: /^[A-Z]{2}\d{7}$/,
                        CA: /^[A-Z]{2}\d{6}$/,
                        CH: /^[A-Z]\d{7}$/,
                        CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
                        CY: /^[A-Z](\d{6}|\d{8})$/,
                        CZ: /^\d{8}$/,
                        DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
                        DK: /^\d{9}$/,
                        DZ: /^\d{9}$/,
                        EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
                        ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
                        FI: /^[A-Z]{2}\d{7}$/,
                        FR: /^\d{2}[A-Z]{2}\d{5}$/,
                        GB: /^\d{9}$/,
                        GR: /^[A-Z]{2}\d{7}$/,
                        HR: /^\d{9}$/,
                        HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
                        IE: /^[A-Z0-9]{2}\d{7}$/,
                        IN: /^[A-Z]{1}-?\d{7}$/,
                        ID: /^[A-C]\d{7}$/,
                        IR: /^[A-Z]\d{8}$/,
                        IS: /^(A)\d{7}$/,
                        IT: /^[A-Z0-9]{2}\d{7}$/,
                        JP: /^[A-Z]{2}\d{7}$/,
                        KR: /^[MS]\d{8}$/,
                        LT: /^[A-Z0-9]{8}$/,
                        LU: /^[A-Z0-9]{8}$/,
                        LV: /^[A-Z0-9]{2}\d{7}$/,
                        LY: /^[A-Z0-9]{8}$/,
                        MT: /^\d{7}$/,
                        MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
                        MY: /^[AHK]\d{8}$/,
                        NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
                        PL: /^[A-Z]{2}\d{7}$/,
                        PT: /^[A-Z]\d{6}$/,
                        RO: /^\d{8,9}$/,
                        RU: /^\d{9}$/,
                        SE: /^\d{8}$/,
                        SL: /^(P)[A-Z]\d{7}$/,
                        SK: /^[0-9A-Z]\d{7}$/,
                        TR: /^[A-Z]\d{8}$/,
                        UA: /^[A-Z]{2}\d{6}$/,
                        US: /^\d{9}$/
                    };
                e.exports = t.default, e.exports.default = t.default;
            },
            4595: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e, {
                        min: 0,
                        max: 65535
                    });
                };
                var n, i = (n = r(937)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            8140: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    if ((0, i.default)(e), t in c)
                        return c[t].test(e);
                    if ('any' === t) {
                        for (var r in c)
                            if (c.hasOwnProperty(r) && c[r].test(e))
                                return !0;
                        return !1;
                    }
                    throw new Error('Invalid locale \''.concat(t, '\''));
                }, t.locales = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^\d{4}$/, o = /^\d{5}$/, s = /^\d{6}$/, c = {
                        AD: /^AD\d{3}$/,
                        AT: a,
                        AU: a,
                        AZ: /^AZ\d{4}$/,
                        BE: a,
                        BG: a,
                        BR: /^\d{5}-\d{3}$/,
                        BY: /2[1-4]{1}\d{4}$/,
                        CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
                        CH: a,
                        CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
                        CZ: /^\d{3}\s?\d{2}$/,
                        DE: o,
                        DK: a,
                        DO: o,
                        DZ: o,
                        EE: o,
                        ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
                        FI: o,
                        FR: /^\d{2}\s?\d{3}$/,
                        GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
                        GR: /^\d{3}\s?\d{2}$/,
                        HR: /^([1-5]\d{4}$)/,
                        HT: /^HT\d{4}$/,
                        HU: a,
                        ID: o,
                        IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
                        IL: /^(\d{5}|\d{7})$/,
                        IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
                        IR: /\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/,
                        IS: /^\d{3}$/,
                        IT: o,
                        JP: /^\d{3}\-\d{4}$/,
                        KE: o,
                        KR: /^(\d{5}|\d{6})$/,
                        LI: /^(948[5-9]|949[0-7])$/,
                        LT: /^LT\-\d{5}$/,
                        LU: a,
                        LV: /^LV\-\d{4}$/,
                        LK: o,
                        MX: o,
                        MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
                        MY: o,
                        NL: /^\d{4}\s?[a-z]{2}$/i,
                        NO: a,
                        NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
                        NZ: a,
                        PL: /^\d{2}\-\d{3}$/,
                        PR: /^00[679]\d{2}([ -]\d{4})?$/,
                        PT: /^\d{4}\-\d{3}?$/,
                        RO: s,
                        RU: s,
                        SA: o,
                        SE: /^[1-9]\d{2}\s?\d{2}$/,
                        SG: s,
                        SI: a,
                        SK: /^\d{3}\s?\d{2}$/,
                        TH: o,
                        TN: a,
                        TW: /^\d{3}(\d{2})?$/,
                        UA: o,
                        US: /^\d{5}(-\d{4})?$/,
                        ZA: a,
                        ZM: o
                    }, u = Object.keys(c);
                t.locales = u;
            },
            4611: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), p.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /([01][0-9]|2[0-3])/, o = /[0-5][0-9]/, s = new RegExp('[-+]'.concat(a.source, ':').concat(o.source)), c = new RegExp('([zZ]|'.concat(s.source, ')')), u = new RegExp(''.concat(a.source, ':').concat(o.source, ':').concat(/([0-5][0-9]|60)/.source).concat(/(\.[0-9]+)?/.source)), l = new RegExp(''.concat(/[0-9]{4}/.source, '-').concat(/(0[1-9]|1[0-2])/.source, '-').concat(/([12]\d|0[1-9]|3[01])/.source)), d = new RegExp(''.concat(u.source).concat(c.source)), p = new RegExp('^'.concat(l.source, '[ tT]').concat(d.source, '$'));
                e.exports = t.default, e.exports.default = t.default;
            },
            6454: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    return (0, i.default)(e), t ? a.test(e) || o.test(e) || s.test(e) || c.test(e) : a.test(e) || o.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/, o = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, s = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)/, c = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)/;
                e.exports = t.default, e.exports.default = t.default;
            },
            6826: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, n.default)(e), a.test(e);
                };
                var n = i(r(5571));
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var a = (0, i(r(4731)).default)([
                    '^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)',
                    '(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))',
                    '?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$'
                ], 'i');
                e.exports = t.default, e.exports.default = t.default;
            },
            8220: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
                e.exports = t.default, e.exports.default = t.default;
            },
            7633: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    (0, i.default)(e);
                    var r = d(e);
                    return (t = (0, n.default)(t || {}, l)).returnScore ? p(r, t) : r.length >= t.minLength && r.lowercaseCount >= t.minLowercase && r.uppercaseCount >= t.minUppercase && r.numberCount >= t.minNumbers && r.symbolCount >= t.minSymbols;
                };
                var n = a(r(4808)), i = a(r(5571));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var o = /^[A-Z]$/, s = /^[a-z]$/, c = /^[0-9]$/, u = /^[-#!$@%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]$/, l = {
                        minLength: 8,
                        minLowercase: 1,
                        minUppercase: 1,
                        minNumbers: 1,
                        minSymbols: 1,
                        returnScore: !1,
                        pointsPerUnique: 1,
                        pointsPerRepeat: 0.5,
                        pointsForContainingLower: 10,
                        pointsForContainingUpper: 10,
                        pointsForContainingNumber: 10,
                        pointsForContainingSymbol: 10
                    };
                function d(e) {
                    var t, r, n = (t = e, r = {}, Array.from(t).forEach(function (e) {
                            r[e] ? r[e] += 1 : r[e] = 1;
                        }), r), i = {
                            length: e.length,
                            uniqueChars: Object.keys(n).length,
                            uppercaseCount: 0,
                            lowercaseCount: 0,
                            numberCount: 0,
                            symbolCount: 0
                        };
                    return Object.keys(n).forEach(function (e) {
                        o.test(e) ? i.uppercaseCount += n[e] : s.test(e) ? i.lowercaseCount += n[e] : c.test(e) ? i.numberCount += n[e] : u.test(e) && (i.symbolCount += n[e]);
                    }), i;
                }
                function p(e, t) {
                    var r = 0;
                    return r += e.uniqueChars * t.pointsPerUnique, r += (e.length - e.uniqueChars) * t.pointsPerRepeat, e.lowercaseCount > 0 && (r += t.pointsForContainingLower), e.uppercaseCount > 0 && (r += t.pointsForContainingUpper), e.numberCount > 0 && (r += t.pointsForContainingNumber), e.symbolCount > 0 && (r += t.pointsForContainingSymbol), r;
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            2828: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
                e.exports = t.default, e.exports.default = t.default;
            },
            3058: (e, t, r) => {
                'use strict';
                function n(e) {
                    return (n = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'en-US';
                    (0, i.default)(e);
                    var r = e.slice(0);
                    if (t in p)
                        return t in h && (r = r.replace(h[t], '')), !!p[t].test(r) && (!(t in f) || f[t](r));
                    throw new Error('Invalid locale \''.concat(t, '\''));
                };
                var i = c(r(5571)), a = function (e) {
                        if (e && e.__esModule)
                            return e;
                        if (null === e || 'object' !== n(e) && 'function' != typeof e)
                            return { default: e };
                        var t = s();
                        if (t && t.has(e))
                            return t.get(e);
                        var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
                        for (var a in e)
                            if (Object.prototype.hasOwnProperty.call(e, a)) {
                                var o = i ? Object.getOwnPropertyDescriptor(e, a) : null;
                                o && (o.get || o.set) ? Object.defineProperty(r, a, o) : r[a] = e[a];
                            }
                        return r.default = e, t && t.set(e, r), r;
                    }(r(3672)), o = c(r(2549));
                function s() {
                    if ('function' != typeof WeakMap)
                        return null;
                    var e = new WeakMap();
                    return s = function () {
                        return e;
                    }, e;
                }
                function c(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function u(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var r = 0, n = new Array(t); r < t; r++)
                        n[r] = e[r];
                    return n;
                }
                var l = {
                    andover: [
                        '10',
                        '12'
                    ],
                    atlanta: [
                        '60',
                        '67'
                    ],
                    austin: [
                        '50',
                        '53'
                    ],
                    brookhaven: [
                        '01',
                        '02',
                        '03',
                        '04',
                        '05',
                        '06',
                        '11',
                        '13',
                        '14',
                        '16',
                        '21',
                        '22',
                        '23',
                        '25',
                        '34',
                        '51',
                        '52',
                        '54',
                        '55',
                        '56',
                        '57',
                        '58',
                        '59',
                        '65'
                    ],
                    cincinnati: [
                        '30',
                        '32',
                        '35',
                        '36',
                        '37',
                        '38',
                        '61'
                    ],
                    fresno: [
                        '15',
                        '24'
                    ],
                    internet: [
                        '20',
                        '26',
                        '27',
                        '45',
                        '46',
                        '47'
                    ],
                    kansas: [
                        '40',
                        '44'
                    ],
                    memphis: [
                        '94',
                        '95'
                    ],
                    ogden: [
                        '80',
                        '90'
                    ],
                    philadelphia: [
                        '33',
                        '39',
                        '41',
                        '42',
                        '43',
                        '46',
                        '48',
                        '62',
                        '63',
                        '64',
                        '66',
                        '68',
                        '71',
                        '72',
                        '73',
                        '74',
                        '75',
                        '76',
                        '77',
                        '81',
                        '82',
                        '83',
                        '84',
                        '85',
                        '86',
                        '87',
                        '88',
                        '91',
                        '92',
                        '93',
                        '98',
                        '99'
                    ],
                    sba: ['31']
                };
                function d(e) {
                    for (var t = !1, r = !1, n = 0; n < 3; n++)
                        if (!t && /[AEIOU]/.test(e[n]))
                            t = !0;
                        else if (!r && t && 'X' === e[n])
                            r = !0;
                        else if (n > 0) {
                            if (t && !r && !/[AEIOU]/.test(e[n]))
                                return !1;
                            if (r && !/X/.test(e[n]))
                                return !1;
                        }
                    return !0;
                }
                var p = {
                    'bg-BG': /^\d{10}$/,
                    'cs-CZ': /^\d{6}\/{0,1}\d{3,4}$/,
                    'de-AT': /^\d{9}$/,
                    'de-DE': /^[1-9]\d{10}$/,
                    'dk-DK': /^\d{6}-{0,1}\d{4}$/,
                    'el-CY': /^[09]\d{7}[A-Z]$/,
                    'el-GR': /^([0-4]|[7-9])\d{8}$/,
                    'en-GB': /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
                    'en-IE': /^\d{7}[A-W][A-IW]{0,1}$/i,
                    'en-US': /^\d{2}[- ]{0,1}\d{7}$/,
                    'es-ES': /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
                    'et-EE': /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
                    'fi-FI': /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
                    'fr-BE': /^\d{11}$/,
                    'fr-FR': /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
                    'fr-LU': /^\d{13}$/,
                    'hr-HR': /^\d{11}$/,
                    'hu-HU': /^8\d{9}$/,
                    'it-IT': /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
                    'lv-LV': /^\d{6}-{0,1}\d{5}$/,
                    'mt-MT': /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
                    'nl-NL': /^\d{9}$/,
                    'pl-PL': /^\d{10,11}$/,
                    'pt-BR': /(?:^\d{11}$)|(?:^\d{14}$)/,
                    'pt-PT': /^\d{9}$/,
                    'ro-RO': /^\d{13}$/,
                    'sk-SK': /^\d{6}\/{0,1}\d{3,4}$/,
                    'sl-SI': /^[1-9]\d{7}$/,
                    'sv-SE': /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/
                };
                p['lb-LU'] = p['fr-LU'], p['lt-LT'] = p['et-EE'], p['nl-BE'] = p['fr-BE'];
                var f = {
                    'bg-BG': function (e) {
                        var t = e.slice(0, 2), r = parseInt(e.slice(2, 4), 10);
                        r > 40 ? (r -= 40, t = '20'.concat(t)) : r > 20 ? (r -= 20, t = '18'.concat(t)) : t = '19'.concat(t), r < 10 && (r = '0'.concat(r));
                        var n = ''.concat(t, '/').concat(r, '/').concat(e.slice(4, 6));
                        if (!(0, o.default)(n, 'YYYY/MM/DD'))
                            return !1;
                        for (var i = e.split('').map(function (e) {
                                    return parseInt(e, 10);
                                }), a = [
                                    2,
                                    4,
                                    8,
                                    5,
                                    10,
                                    9,
                                    7,
                                    3,
                                    6
                                ], s = 0, c = 0; c < a.length; c++)
                            s += i[c] * a[c];
                        return (s = s % 11 == 10 ? 0 : s % 11) === i[9];
                    },
                    'cs-CZ': function (e) {
                        e = e.replace(/\W/, '');
                        var t = parseInt(e.slice(0, 2), 10);
                        if (10 === e.length)
                            t = t < 54 ? '20'.concat(t) : '19'.concat(t);
                        else {
                            if ('000' === e.slice(6))
                                return !1;
                            if (!(t < 54))
                                return !1;
                            t = '19'.concat(t);
                        }
                        3 === t.length && (t = [
                            t.slice(0, 2),
                            '0',
                            t.slice(2)
                        ].join(''));
                        var r = parseInt(e.slice(2, 4), 10);
                        if (r > 50 && (r -= 50), r > 20) {
                            if (parseInt(t, 10) < 2004)
                                return !1;
                            r -= 20;
                        }
                        r < 10 && (r = '0'.concat(r));
                        var n = ''.concat(t, '/').concat(r, '/').concat(e.slice(4, 6));
                        if (!(0, o.default)(n, 'YYYY/MM/DD'))
                            return !1;
                        if (10 === e.length && parseInt(e, 10) % 11 != 0) {
                            var i = parseInt(e.slice(0, 9), 10) % 11;
                            if (!(parseInt(t, 10) < 1986 && 10 === i))
                                return !1;
                            if (0 !== parseInt(e.slice(9), 10))
                                return !1;
                        }
                        return !0;
                    },
                    'de-AT': function (e) {
                        return a.luhnCheck(e);
                    },
                    'de-DE': function (e) {
                        for (var t = e.split('').map(function (e) {
                                    return parseInt(e, 10);
                                }), r = [], n = 0; n < t.length - 1; n++) {
                            r.push('');
                            for (var i = 0; i < t.length - 1; i++)
                                t[n] === t[i] && (r[n] += i);
                        }
                        if (2 !== (r = r.filter(function (e) {
                                return e.length > 1;
                            })).length && 3 !== r.length)
                            return !1;
                        if (3 === r[0].length) {
                            for (var o = r[0].split('').map(function (e) {
                                        return parseInt(e, 10);
                                    }), s = 0, c = 0; c < o.length - 1; c++)
                                o[c] + 1 === o[c + 1] && (s += 1);
                            if (2 === s)
                                return !1;
                        }
                        return a.iso7064Check(e);
                    },
                    'dk-DK': function (e) {
                        e = e.replace(/\W/, '');
                        var t = parseInt(e.slice(4, 6), 10);
                        switch (e.slice(6, 7)) {
                        case '0':
                        case '1':
                        case '2':
                        case '3':
                            t = '19'.concat(t);
                            break;
                        case '4':
                        case '9':
                            t = t < 37 ? '20'.concat(t) : '19'.concat(t);
                            break;
                        default:
                            if (t < 37)
                                t = '20'.concat(t);
                            else {
                                if (!(t > 58))
                                    return !1;
                                t = '18'.concat(t);
                            }
                        }
                        3 === t.length && (t = [
                            t.slice(0, 2),
                            '0',
                            t.slice(2)
                        ].join(''));
                        var r = ''.concat(t, '/').concat(e.slice(2, 4), '/').concat(e.slice(0, 2));
                        if (!(0, o.default)(r, 'YYYY/MM/DD'))
                            return !1;
                        for (var n = e.split('').map(function (e) {
                                    return parseInt(e, 10);
                                }), i = 0, a = 4, s = 0; s < 9; s++)
                            i += n[s] * a, 1 == (a -= 1) && (a = 7);
                        return 1 != (i %= 11) && (0 === i ? 0 === n[9] : n[9] === 11 - i);
                    },
                    'el-CY': function (e) {
                        for (var t = e.slice(0, 8).split('').map(function (e) {
                                    return parseInt(e, 10);
                                }), r = 0, n = 1; n < t.length; n += 2)
                            r += t[n];
                        for (var i = 0; i < t.length; i += 2)
                            t[i] < 2 ? r += 1 - t[i] : (r += 2 * (t[i] - 2) + 5, t[i] > 4 && (r += 2));
                        return String.fromCharCode(r % 26 + 65) === e.charAt(8);
                    },
                    'el-GR': function (e) {
                        for (var t = e.split('').map(function (e) {
                                    return parseInt(e, 10);
                                }), r = 0, n = 0; n < 8; n++)
                            r += t[n] * Math.pow(2, 8 - n);
                        return r % 11 % 10 === t[8];
                    },
                    'en-IE': function (e) {
                        var t = a.reverseMultiplyAndSum(e.split('').slice(0, 7).map(function (e) {
                            return parseInt(e, 10);
                        }), 8);
                        return 9 === e.length && 'W' !== e[8] && (t += 9 * (e[8].charCodeAt(0) - 64)), 0 == (t %= 23) ? 'W' === e[7].toUpperCase() : e[7].toUpperCase() === String.fromCharCode(64 + t);
                    },
                    'en-US': function (e) {
                        return -1 !== function () {
                            var e, t = [];
                            for (var r in l)
                                l.hasOwnProperty(r) && t.push.apply(t, function (e) {
                                    if (Array.isArray(e))
                                        return u(e);
                                }(e = l[r]) || function (e) {
                                    if ('undefined' != typeof Symbol && Symbol.iterator in Object(e))
                                        return Array.from(e);
                                }(e) || function (e, t) {
                                    if (e) {
                                        if ('string' == typeof e)
                                            return u(e, t);
                                        var r = Object.prototype.toString.call(e).slice(8, -1);
                                        return 'Object' === r && e.constructor && (r = e.constructor.name), 'Map' === r || 'Set' === r ? Array.from(e) : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? u(e, t) : void 0;
                                    }
                                }(e) || function () {
                                    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                                }());
                            return t;
                        }().indexOf(e.substr(0, 2));
                    },
                    'es-ES': function (e) {
                        var t = e.toUpperCase().split('');
                        if (isNaN(parseInt(t[0], 10)) && t.length > 1) {
                            var r = 0;
                            switch (t[0]) {
                            case 'Y':
                                r = 1;
                                break;
                            case 'Z':
                                r = 2;
                            }
                            t.splice(0, 1, r);
                        } else
                            for (; t.length < 9;)
                                t.unshift(0);
                        t = t.join('');
                        var n = parseInt(t.slice(0, 8), 10) % 23;
                        return t[8] === [
                            'T',
                            'R',
                            'W',
                            'A',
                            'G',
                            'M',
                            'Y',
                            'F',
                            'P',
                            'D',
                            'X',
                            'B',
                            'N',
                            'J',
                            'Z',
                            'S',
                            'Q',
                            'V',
                            'H',
                            'L',
                            'C',
                            'K',
                            'E'
                        ][n];
                    },
                    'et-EE': function (e) {
                        var t = e.slice(1, 3);
                        switch (e.slice(0, 1)) {
                        case '1':
                        case '2':
                            t = '18'.concat(t);
                            break;
                        case '3':
                        case '4':
                            t = '19'.concat(t);
                            break;
                        default:
                            t = '20'.concat(t);
                        }
                        var r = ''.concat(t, '/').concat(e.slice(3, 5), '/').concat(e.slice(5, 7));
                        if (!(0, o.default)(r, 'YYYY/MM/DD'))
                            return !1;
                        for (var n = e.split('').map(function (e) {
                                    return parseInt(e, 10);
                                }), i = 0, a = 1, s = 0; s < 10; s++)
                            i += n[s] * a, 10 === (a += 1) && (a = 1);
                        if (i % 11 == 10) {
                            i = 0, a = 3;
                            for (var c = 0; c < 10; c++)
                                i += n[c] * a, 10 === (a += 1) && (a = 1);
                            if (i % 11 == 10)
                                return 0 === n[10];
                        }
                        return i % 11 === n[10];
                    },
                    'fi-FI': function (e) {
                        var t = e.slice(4, 6);
                        switch (e.slice(6, 7)) {
                        case '+':
                            t = '18'.concat(t);
                            break;
                        case '-':
                            t = '19'.concat(t);
                            break;
                        default:
                            t = '20'.concat(t);
                        }
                        var r = ''.concat(t, '/').concat(e.slice(2, 4), '/').concat(e.slice(0, 2));
                        if (!(0, o.default)(r, 'YYYY/MM/DD'))
                            return !1;
                        var n = parseInt(e.slice(0, 6) + e.slice(7, 10), 10) % 31;
                        return n < 10 ? n === parseInt(e.slice(10), 10) : [
                            'A',
                            'B',
                            'C',
                            'D',
                            'E',
                            'F',
                            'H',
                            'J',
                            'K',
                            'L',
                            'M',
                            'N',
                            'P',
                            'R',
                            'S',
                            'T',
                            'U',
                            'V',
                            'W',
                            'X',
                            'Y'
                        ][n -= 10] === e.slice(10);
                    },
                    'fr-BE': function (e) {
                        if ('00' !== e.slice(2, 4) || '00' !== e.slice(4, 6)) {
                            var t = ''.concat(e.slice(0, 2), '/').concat(e.slice(2, 4), '/').concat(e.slice(4, 6));
                            if (!(0, o.default)(t, 'YY/MM/DD'))
                                return !1;
                        }
                        var r = 97 - parseInt(e.slice(0, 9), 10) % 97, n = parseInt(e.slice(9, 11), 10);
                        return r === n || (r = 97 - parseInt('2'.concat(e.slice(0, 9)), 10) % 97) === n;
                    },
                    'fr-FR': function (e) {
                        return e = e.replace(/\s/g, ''), parseInt(e.slice(0, 10), 10) % 511 === parseInt(e.slice(10, 13), 10);
                    },
                    'fr-LU': function (e) {
                        var t = ''.concat(e.slice(0, 4), '/').concat(e.slice(4, 6), '/').concat(e.slice(6, 8));
                        return !!(0, o.default)(t, 'YYYY/MM/DD') && !!a.luhnCheck(e.slice(0, 12)) && a.verhoeffCheck(''.concat(e.slice(0, 11)).concat(e[12]));
                    },
                    'hr-HR': function (e) {
                        return a.iso7064Check(e);
                    },
                    'hu-HU': function (e) {
                        for (var t = e.split('').map(function (e) {
                                    return parseInt(e, 10);
                                }), r = 8, n = 1; n < 9; n++)
                            r += t[n] * (n + 1);
                        return r % 11 === t[9];
                    },
                    'it-IT': function (e) {
                        var t = e.toUpperCase().split('');
                        if (!d(t.slice(0, 3)))
                            return !1;
                        if (!d(t.slice(3, 6)))
                            return !1;
                        for (var r = {
                                    L: '0',
                                    M: '1',
                                    N: '2',
                                    P: '3',
                                    Q: '4',
                                    R: '5',
                                    S: '6',
                                    T: '7',
                                    U: '8',
                                    V: '9'
                                }, n = 0, i = [
                                    6,
                                    7,
                                    9,
                                    10,
                                    12,
                                    13,
                                    14
                                ]; n < i.length; n++) {
                            var a = i[n];
                            t[a] in r && t.splice(a, 1, r[t[a]]);
                        }
                        var s = {
                                A: '01',
                                B: '02',
                                C: '03',
                                D: '04',
                                E: '05',
                                H: '06',
                                L: '07',
                                M: '08',
                                P: '09',
                                R: '10',
                                S: '11',
                                T: '12'
                            }[t[8]], c = parseInt(t[9] + t[10], 10);
                        c > 40 && (c -= 40), c < 10 && (c = '0'.concat(c));
                        var u = ''.concat(t[6]).concat(t[7], '/').concat(s, '/').concat(c);
                        if (!(0, o.default)(u, 'YY/MM/DD'))
                            return !1;
                        for (var l = 0, p = 1; p < t.length - 1; p += 2) {
                            var f = parseInt(t[p], 10);
                            isNaN(f) && (f = t[p].charCodeAt(0) - 65), l += f;
                        }
                        for (var m = {
                                    A: 1,
                                    B: 0,
                                    C: 5,
                                    D: 7,
                                    E: 9,
                                    F: 13,
                                    G: 15,
                                    H: 17,
                                    I: 19,
                                    J: 21,
                                    K: 2,
                                    L: 4,
                                    M: 18,
                                    N: 20,
                                    O: 11,
                                    P: 3,
                                    Q: 6,
                                    R: 8,
                                    S: 12,
                                    T: 14,
                                    U: 16,
                                    V: 10,
                                    W: 22,
                                    X: 25,
                                    Y: 24,
                                    Z: 23,
                                    0: 1,
                                    1: 0
                                }, h = 0; h < t.length - 1; h += 2) {
                            var g = 0;
                            if (t[h] in m)
                                g = m[t[h]];
                            else {
                                var y = parseInt(t[h], 10);
                                g = 2 * y + 1, y > 4 && (g += 2);
                            }
                            l += g;
                        }
                        return String.fromCharCode(65 + l % 26) === t[15];
                    },
                    'lv-LV': function (e) {
                        var t = (e = e.replace(/\W/, '')).slice(0, 2);
                        if ('32' !== t) {
                            if ('00' !== e.slice(2, 4)) {
                                var r = e.slice(4, 6);
                                switch (e[6]) {
                                case '0':
                                    r = '18'.concat(r);
                                    break;
                                case '1':
                                    r = '19'.concat(r);
                                    break;
                                default:
                                    r = '20'.concat(r);
                                }
                                var n = ''.concat(r, '/').concat(e.slice(2, 4), '/').concat(t);
                                if (!(0, o.default)(n, 'YYYY/MM/DD'))
                                    return !1;
                            }
                            for (var i = 1101, a = [
                                        1,
                                        6,
                                        3,
                                        7,
                                        9,
                                        10,
                                        5,
                                        8,
                                        4,
                                        2
                                    ], s = 0; s < e.length - 1; s++)
                                i -= parseInt(e[s], 10) * a[s];
                            return parseInt(e[10], 10) === i % 11;
                        }
                        return !0;
                    },
                    'mt-MT': function (e) {
                        if (9 !== e.length) {
                            for (var t = e.toUpperCase().split(''); t.length < 8;)
                                t.unshift(0);
                            switch (e[7]) {
                            case 'A':
                            case 'P':
                                if (0 === parseInt(t[6], 10))
                                    return !1;
                                break;
                            default:
                                var r = parseInt(t.join('').slice(0, 5), 10);
                                if (r > 32000)
                                    return !1;
                                if (r === parseInt(t.join('').slice(5, 7), 10))
                                    return !1;
                            }
                        }
                        return !0;
                    },
                    'nl-NL': function (e) {
                        return a.reverseMultiplyAndSum(e.split('').slice(0, 8).map(function (e) {
                            return parseInt(e, 10);
                        }), 9) % 11 === parseInt(e[8], 10);
                    },
                    'pl-PL': function (e) {
                        if (10 === e.length) {
                            for (var t = [
                                        6,
                                        5,
                                        7,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ], r = 0, n = 0; n < t.length; n++)
                                r += parseInt(e[n], 10) * t[n];
                            return 10 != (r %= 11) && r === parseInt(e[9], 10);
                        }
                        var i = e.slice(0, 2), a = parseInt(e.slice(2, 4), 10);
                        a > 80 ? (i = '18'.concat(i), a -= 80) : a > 60 ? (i = '22'.concat(i), a -= 60) : a > 40 ? (i = '21'.concat(i), a -= 40) : a > 20 ? (i = '20'.concat(i), a -= 20) : i = '19'.concat(i), a < 10 && (a = '0'.concat(a));
                        var s = ''.concat(i, '/').concat(a, '/').concat(e.slice(4, 6));
                        if (!(0, o.default)(s, 'YYYY/MM/DD'))
                            return !1;
                        for (var c = 0, u = 1, l = 0; l < e.length - 1; l++)
                            c += parseInt(e[l], 10) * u % 10, (u += 2) > 10 ? u = 1 : 5 === u && (u += 2);
                        return (c = 10 - c % 10) === parseInt(e[10], 10);
                    },
                    'pt-BR': function (e) {
                        if (11 === e.length) {
                            var t, r;
                            if (t = 0, '11111111111' === e || '22222222222' === e || '33333333333' === e || '44444444444' === e || '55555555555' === e || '66666666666' === e || '77777777777' === e || '88888888888' === e || '99999999999' === e || '00000000000' === e)
                                return !1;
                            for (var n = 1; n <= 9; n++)
                                t += parseInt(e.substring(n - 1, n), 10) * (11 - n);
                            if (10 == (r = 10 * t % 11) && (r = 0), r !== parseInt(e.substring(9, 10), 10))
                                return !1;
                            t = 0;
                            for (var i = 1; i <= 10; i++)
                                t += parseInt(e.substring(i - 1, i), 10) * (12 - i);
                            return 10 == (r = 10 * t % 11) && (r = 0), r === parseInt(e.substring(10, 11), 10);
                        }
                        if ('00000000000000' === e || '11111111111111' === e || '22222222222222' === e || '33333333333333' === e || '44444444444444' === e || '55555555555555' === e || '66666666666666' === e || '77777777777777' === e || '88888888888888' === e || '99999999999999' === e)
                            return !1;
                        for (var a = e.length - 2, o = e.substring(0, a), s = e.substring(a), c = 0, u = a - 7, l = a; l >= 1; l--)
                            c += o.charAt(a - l) * u, (u -= 1) < 2 && (u = 9);
                        var d = c % 11 < 2 ? 0 : 11 - c % 11;
                        if (d !== parseInt(s.charAt(0), 10))
                            return !1;
                        a += 1, o = e.substring(0, a), c = 0, u = a - 7;
                        for (var p = a; p >= 1; p--)
                            c += o.charAt(a - p) * u, (u -= 1) < 2 && (u = 9);
                        return (d = c % 11 < 2 ? 0 : 11 - c % 11) === parseInt(s.charAt(1), 10);
                    },
                    'pt-PT': function (e) {
                        var t = 11 - a.reverseMultiplyAndSum(e.split('').slice(0, 8).map(function (e) {
                            return parseInt(e, 10);
                        }), 9) % 11;
                        return t > 9 ? 0 === parseInt(e[8], 10) : t === parseInt(e[8], 10);
                    },
                    'ro-RO': function (e) {
                        if ('9000' !== e.slice(0, 4)) {
                            var t = e.slice(1, 3);
                            switch (e[0]) {
                            case '1':
                            case '2':
                                t = '19'.concat(t);
                                break;
                            case '3':
                            case '4':
                                t = '18'.concat(t);
                                break;
                            case '5':
                            case '6':
                                t = '20'.concat(t);
                            }
                            var r = ''.concat(t, '/').concat(e.slice(3, 5), '/').concat(e.slice(5, 7));
                            if (8 === r.length) {
                                if (!(0, o.default)(r, 'YY/MM/DD'))
                                    return !1;
                            } else if (!(0, o.default)(r, 'YYYY/MM/DD'))
                                return !1;
                            for (var n = e.split('').map(function (e) {
                                        return parseInt(e, 10);
                                    }), i = [
                                        2,
                                        7,
                                        9,
                                        1,
                                        4,
                                        6,
                                        3,
                                        5,
                                        8,
                                        2,
                                        7,
                                        9
                                    ], a = 0, s = 0; s < i.length; s++)
                                a += n[s] * i[s];
                            return a % 11 == 10 ? 1 === n[12] : n[12] === a % 11;
                        }
                        return !0;
                    },
                    'sk-SK': function (e) {
                        if (9 === e.length) {
                            if ('000' === (e = e.replace(/\W/, '')).slice(6))
                                return !1;
                            var t = parseInt(e.slice(0, 2), 10);
                            if (t > 53)
                                return !1;
                            t = t < 10 ? '190'.concat(t) : '19'.concat(t);
                            var r = parseInt(e.slice(2, 4), 10);
                            r > 50 && (r -= 50), r < 10 && (r = '0'.concat(r));
                            var n = ''.concat(t, '/').concat(r, '/').concat(e.slice(4, 6));
                            if (!(0, o.default)(n, 'YYYY/MM/DD'))
                                return !1;
                        }
                        return !0;
                    },
                    'sl-SI': function (e) {
                        var t = 11 - a.reverseMultiplyAndSum(e.split('').slice(0, 7).map(function (e) {
                            return parseInt(e, 10);
                        }), 8) % 11;
                        return 10 === t ? 0 === parseInt(e[7], 10) : t === parseInt(e[7], 10);
                    },
                    'sv-SE': function (e) {
                        var t = e.slice(0);
                        e.length > 11 && (t = t.slice(2));
                        var r = '', n = t.slice(2, 4), i = parseInt(t.slice(4, 6), 10);
                        if (e.length > 11)
                            r = e.slice(0, 4);
                        else if (r = e.slice(0, 2), 11 === e.length && i < 60) {
                            var s = new Date().getFullYear().toString(), c = parseInt(s.slice(0, 2), 10);
                            if (s = parseInt(s, 10), '-' === e[6])
                                r = parseInt(''.concat(c).concat(r), 10) > s ? ''.concat(c - 1).concat(r) : ''.concat(c).concat(r);
                            else if (r = ''.concat(c - 1).concat(r), s - parseInt(r, 10) < 100)
                                return !1;
                        }
                        i > 60 && (i -= 60), i < 10 && (i = '0'.concat(i));
                        var u = ''.concat(r, '/').concat(n, '/').concat(i);
                        if (8 === u.length) {
                            if (!(0, o.default)(u, 'YY/MM/DD'))
                                return !1;
                        } else if (!(0, o.default)(u, 'YYYY/MM/DD'))
                            return !1;
                        return a.luhnCheck(e.replace(/\W/, ''));
                    }
                };
                f['lb-LU'] = f['fr-LU'], f['lt-LT'] = f['et-EE'], f['nl-BE'] = f['fr-BE'];
                var m = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g, h = {
                        'de-AT': m,
                        'de-DE': /[\/\\]/g,
                        'fr-BE': m
                    };
                h['nl-BE'] = h['fr-BE'], e.exports = t.default, e.exports.default = t.default;
            },
            2492: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    if ((0, n.default)(e), !e || /[\s<>]/.test(e))
                        return !1;
                    if (0 === e.indexOf('mailto:'))
                        return !1;
                    if ((t = (0, o.default)(t, u)).validate_length && e.length >= 2083)
                        return !1;
                    if (!t.allow_fragments && e.includes('#'))
                        return !1;
                    if (!t.allow_query_components && (e.includes('?') || e.includes('&')))
                        return !1;
                    var r, s, p, f, m, h, g, y, b;
                    if (g = e.split('#'), e = g.shift(), g = e.split('?'), e = g.shift(), (g = e.split('://')).length > 1) {
                        if (r = g.shift().toLowerCase(), t.require_valid_protocol && -1 === t.protocols.indexOf(r))
                            return !1;
                    } else {
                        if (t.require_protocol)
                            return !1;
                        if ('//' === e.substr(0, 2)) {
                            if (!t.allow_protocol_relative_urls)
                                return !1;
                            g[0] = e.substr(2);
                        }
                    }
                    if ('' === (e = g.join('://')))
                        return !1;
                    if (g = e.split('/'), '' === (e = g.shift()) && !t.require_host)
                        return !0;
                    if ((g = e.split('@')).length > 1) {
                        if (t.disallow_auth)
                            return !1;
                        if ('' === g[0])
                            return !1;
                        if ((s = g.shift()).indexOf(':') >= 0 && s.split(':').length > 2)
                            return !1;
                        var S = (2, function (e) {
                                if (Array.isArray(e))
                                    return e;
                            }(b = s.split(':')) || function (e, t) {
                                if ('undefined' != typeof Symbol && Symbol.iterator in Object(e)) {
                                    var r = [], n = !0, i = !1, a = void 0;
                                    try {
                                        for (var o, s = e[Symbol.iterator](); !(n = (o = s.next()).done) && (r.push(o.value), 2 !== r.length); n = !0);
                                    } catch (e) {
                                        i = !0, a = e;
                                    } finally {
                                        try {
                                            n || null == s.return || s.return();
                                        } finally {
                                            if (i)
                                                throw a;
                                        }
                                    }
                                    return r;
                                }
                            }(b) || function (e, t) {
                                if (e) {
                                    if ('string' == typeof e)
                                        return c(e, 2);
                                    var r = Object.prototype.toString.call(e).slice(8, -1);
                                    return 'Object' === r && e.constructor && (r = e.constructor.name), 'Map' === r || 'Set' === r ? Array.from(e) : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? c(e, 2) : void 0;
                                }
                            }(b) || function () {
                                throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
                            }()), v = S[0], C = S[1];
                        if ('' === v && '' === C)
                            return !1;
                    }
                    h = null, y = null;
                    var A = (f = g.join('@')).match(l);
                    if (A ? (p = '', y = A[1], h = A[2] || null) : (p = (g = f.split(':')).shift(), g.length && (h = g.join(':'))), null !== h && h.length > 0) {
                        if (m = parseInt(h, 10), !/^[0-9]+$/.test(h) || m <= 0 || m > 65535)
                            return !1;
                    } else if (t.require_port)
                        return !1;
                    return t.host_whitelist ? d(p, t.host_whitelist) : !!((0, a.default)(p) || (0, i.default)(p, t) || y && (0, a.default)(y, 6)) && (p = p || y, !t.host_blacklist || !d(p, t.host_blacklist));
                };
                var n = s(r(5571)), i = s(r(221)), a = s(r(1028)), o = s(r(4808));
                function s(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function c(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var r = 0, n = new Array(t); r < t; r++)
                        n[r] = e[r];
                    return n;
                }
                var u = {
                        protocols: [
                            'http',
                            'https',
                            'ftp'
                        ],
                        require_tld: !0,
                        require_protocol: !1,
                        require_host: !0,
                        require_port: !1,
                        require_valid_protocol: !0,
                        allow_underscores: !1,
                        allow_trailing_dot: !1,
                        allow_protocol_relative_urls: !1,
                        allow_fragments: !0,
                        allow_query_components: !0,
                        validate_length: !0
                    }, l = /^\[([^\]]+)\](?::([0-9]+))?$/;
                function d(e, t) {
                    for (var r = 0; r < t.length; r++) {
                        var n = t[r];
                        if (e === n || (i = n, '[object RegExp]' === Object.prototype.toString.call(i) && n.test(e)))
                            return !0;
                    }
                    var i;
                    return !1;
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            7278: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, i.default)(e);
                    var r = a[[
                        void 0,
                        null
                    ].includes(t) ? 'all' : t];
                    return !!r && r.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = {
                        1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
                        2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
                        3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
                        4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
                        5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
                        all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
                    };
                e.exports = t.default, e.exports.default = t.default;
            },
            7245: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), e === e.toUpperCase();
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            5977: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    if ((0, i.default)(e), (0, i.default)(t), t in a)
                        return a[t].test(e);
                    throw new Error('Invalid country code: \''.concat(t, '\''));
                }, t.vatMatchers = void 0;
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = {
                        GB: /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/,
                        IT: /^(IT)?[0-9]{11}$/,
                        NL: /^(NL)?[0-9]{9}B[0-9]{2}$/
                    };
                t.vatMatchers = a;
            },
            9019: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), a.fullWidth.test(e) && o.halfWidth.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n }, a = r(7146), o = r(2941);
                e.exports = t.default, e.exports.default = t.default;
            },
            8346: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, i.default)(e);
                    for (var r = e.length - 1; r >= 0; r--)
                        if (-1 === t.indexOf(e[r]))
                            return !1;
                    return !0;
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            4959: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, i.default)(e);
                    var r = t ? new RegExp('^['.concat(t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), ']+'), 'g') : /^\s+/g;
                    return e.replace(r, '');
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            5090: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t, r) {
                    return (0, i.default)(e), '[object RegExp]' !== Object.prototype.toString.call(t) && (t = new RegExp(t, r)), t.test(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            2900: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    t = (0, i.default)(t, a);
                    var r = e.split('@'), n = r.pop(), d = [
                            r.join('@'),
                            n
                        ];
                    if (d[1] = d[1].toLowerCase(), 'gmail.com' === d[1] || 'googlemail.com' === d[1]) {
                        if (t.gmail_remove_subaddress && (d[0] = d[0].split('+')[0]), t.gmail_remove_dots && (d[0] = d[0].replace(/\.+/g, l)), !d[0].length)
                            return !1;
                        (t.all_lowercase || t.gmail_lowercase) && (d[0] = d[0].toLowerCase()), d[1] = t.gmail_convert_googlemaildotcom ? 'gmail.com' : d[1];
                    } else if (o.indexOf(d[1]) >= 0) {
                        if (t.icloud_remove_subaddress && (d[0] = d[0].split('+')[0]), !d[0].length)
                            return !1;
                        (t.all_lowercase || t.icloud_lowercase) && (d[0] = d[0].toLowerCase());
                    } else if (s.indexOf(d[1]) >= 0) {
                        if (t.outlookdotcom_remove_subaddress && (d[0] = d[0].split('+')[0]), !d[0].length)
                            return !1;
                        (t.all_lowercase || t.outlookdotcom_lowercase) && (d[0] = d[0].toLowerCase());
                    } else if (c.indexOf(d[1]) >= 0) {
                        if (t.yahoo_remove_subaddress) {
                            var p = d[0].split('-');
                            d[0] = p.length > 1 ? p.slice(0, -1).join('-') : p[0];
                        }
                        if (!d[0].length)
                            return !1;
                        (t.all_lowercase || t.yahoo_lowercase) && (d[0] = d[0].toLowerCase());
                    } else
                        u.indexOf(d[1]) >= 0 ? ((t.all_lowercase || t.yandex_lowercase) && (d[0] = d[0].toLowerCase()), d[1] = 'yandex.ru') : t.all_lowercase && (d[0] = d[0].toLowerCase());
                    return d.join('@');
                };
                var n, i = (n = r(4808)) && n.__esModule ? n : { default: n }, a = {
                        all_lowercase: !0,
                        gmail_lowercase: !0,
                        gmail_remove_dots: !0,
                        gmail_remove_subaddress: !0,
                        gmail_convert_googlemaildotcom: !0,
                        outlookdotcom_lowercase: !0,
                        outlookdotcom_remove_subaddress: !0,
                        yahoo_lowercase: !0,
                        yahoo_remove_subaddress: !0,
                        yandex_lowercase: !0,
                        icloud_lowercase: !0,
                        icloud_remove_subaddress: !0
                    }, o = [
                        'icloud.com',
                        'me.com'
                    ], s = [
                        'hotmail.at',
                        'hotmail.be',
                        'hotmail.ca',
                        'hotmail.cl',
                        'hotmail.co.il',
                        'hotmail.co.nz',
                        'hotmail.co.th',
                        'hotmail.co.uk',
                        'hotmail.com',
                        'hotmail.com.ar',
                        'hotmail.com.au',
                        'hotmail.com.br',
                        'hotmail.com.gr',
                        'hotmail.com.mx',
                        'hotmail.com.pe',
                        'hotmail.com.tr',
                        'hotmail.com.vn',
                        'hotmail.cz',
                        'hotmail.de',
                        'hotmail.dk',
                        'hotmail.es',
                        'hotmail.fr',
                        'hotmail.hu',
                        'hotmail.id',
                        'hotmail.ie',
                        'hotmail.in',
                        'hotmail.it',
                        'hotmail.jp',
                        'hotmail.kr',
                        'hotmail.lv',
                        'hotmail.my',
                        'hotmail.ph',
                        'hotmail.pt',
                        'hotmail.sa',
                        'hotmail.sg',
                        'hotmail.sk',
                        'live.be',
                        'live.co.uk',
                        'live.com',
                        'live.com.ar',
                        'live.com.mx',
                        'live.de',
                        'live.es',
                        'live.eu',
                        'live.fr',
                        'live.it',
                        'live.nl',
                        'msn.com',
                        'outlook.at',
                        'outlook.be',
                        'outlook.cl',
                        'outlook.co.il',
                        'outlook.co.nz',
                        'outlook.co.th',
                        'outlook.com',
                        'outlook.com.ar',
                        'outlook.com.au',
                        'outlook.com.br',
                        'outlook.com.gr',
                        'outlook.com.pe',
                        'outlook.com.tr',
                        'outlook.com.vn',
                        'outlook.cz',
                        'outlook.de',
                        'outlook.dk',
                        'outlook.es',
                        'outlook.fr',
                        'outlook.hu',
                        'outlook.id',
                        'outlook.ie',
                        'outlook.in',
                        'outlook.it',
                        'outlook.jp',
                        'outlook.kr',
                        'outlook.lv',
                        'outlook.my',
                        'outlook.ph',
                        'outlook.pt',
                        'outlook.sa',
                        'outlook.sg',
                        'outlook.sk',
                        'passport.com'
                    ], c = [
                        'rocketmail.com',
                        'yahoo.ca',
                        'yahoo.co.uk',
                        'yahoo.com',
                        'yahoo.de',
                        'yahoo.fr',
                        'yahoo.in',
                        'yahoo.it',
                        'ymail.com'
                    ], u = [
                        'yandex.ru',
                        'yandex.ua',
                        'yandex.kz',
                        'yandex.com',
                        'yandex.by',
                        'ya.ru'
                    ];
                function l(e) {
                    return e.length > 1 ? e : '';
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            9778: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    if ((0, i.default)(e), t) {
                        var r = new RegExp('['.concat(t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), ']+$'), 'g');
                        return e.replace(r, '');
                    }
                    for (var n = e.length - 1; /\s/.test(e.charAt(n));)
                        n -= 1;
                    return e.slice(0, n + 1);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            8035: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    (0, n.default)(e);
                    var r = t ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
                    return (0, i.default)(e, r);
                };
                var n = a(r(5571)), i = a(r(4928));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            557: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, i.default)(e), t ? '1' === e || /^true$/i.test(e) : '0' !== e && !/^false$/i.test(e) && '' !== e;
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            8469: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), e = Date.parse(e), isNaN(e) ? null : new Date(e);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            7536: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e) ? parseFloat(e) : NaN;
                };
                var n, i = (n = r(9146)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            1359: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, i.default)(e), parseInt(e, t || 10);
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            4790: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, n.default)((0, i.default)(e, t), t);
                };
                var n = a(r(9778)), i = a(r(4959));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                e.exports = t.default, e.exports.default = t.default;
            },
            4816: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return (0, i.default)(e), e.replace(/&quot;/g, '"').replace(/&#x27;/g, '\'').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`').replace(/&amp;/g, '&');
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            3672: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.iso7064Check = function (e) {
                    for (var t = 10, r = 0; r < e.length - 1; r++)
                        t = (parseInt(e[r], 10) + t) % 10 == 0 ? 9 : (parseInt(e[r], 10) + t) % 10 * 2 % 11;
                    return (t = 1 === t ? 0 : 11 - t) === parseInt(e[10], 10);
                }, t.luhnCheck = function (e) {
                    for (var t = 0, r = !1, n = e.length - 1; n >= 0; n--) {
                        if (r) {
                            var i = 2 * parseInt(e[n], 10);
                            t += i > 9 ? i.toString().split('').map(function (e) {
                                return parseInt(e, 10);
                            }).reduce(function (e, t) {
                                return e + t;
                            }, 0) : i;
                        } else
                            t += parseInt(e[n], 10);
                        r = !r;
                    }
                    return t % 10 == 0;
                }, t.reverseMultiplyAndSum = function (e, t) {
                    for (var r = 0, n = 0; n < e.length; n++)
                        r += e[n] * (t - n);
                    return r;
                }, t.verhoeffCheck = function (e) {
                    for (var t = [
                                [
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9
                                ],
                                [
                                    1,
                                    2,
                                    3,
                                    4,
                                    0,
                                    6,
                                    7,
                                    8,
                                    9,
                                    5
                                ],
                                [
                                    2,
                                    3,
                                    4,
                                    0,
                                    1,
                                    7,
                                    8,
                                    9,
                                    5,
                                    6
                                ],
                                [
                                    3,
                                    4,
                                    0,
                                    1,
                                    2,
                                    8,
                                    9,
                                    5,
                                    6,
                                    7
                                ],
                                [
                                    4,
                                    0,
                                    1,
                                    2,
                                    3,
                                    9,
                                    5,
                                    6,
                                    7,
                                    8
                                ],
                                [
                                    5,
                                    9,
                                    8,
                                    7,
                                    6,
                                    0,
                                    4,
                                    3,
                                    2,
                                    1
                                ],
                                [
                                    6,
                                    5,
                                    9,
                                    8,
                                    7,
                                    1,
                                    0,
                                    4,
                                    3,
                                    2
                                ],
                                [
                                    7,
                                    6,
                                    5,
                                    9,
                                    8,
                                    2,
                                    1,
                                    0,
                                    4,
                                    3
                                ],
                                [
                                    8,
                                    7,
                                    6,
                                    5,
                                    9,
                                    3,
                                    2,
                                    1,
                                    0,
                                    4
                                ],
                                [
                                    9,
                                    8,
                                    7,
                                    6,
                                    5,
                                    4,
                                    3,
                                    2,
                                    1,
                                    0
                                ]
                            ], r = [
                                [
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9
                                ],
                                [
                                    1,
                                    5,
                                    7,
                                    6,
                                    2,
                                    8,
                                    3,
                                    0,
                                    9,
                                    4
                                ],
                                [
                                    5,
                                    8,
                                    0,
                                    3,
                                    7,
                                    9,
                                    6,
                                    1,
                                    4,
                                    2
                                ],
                                [
                                    8,
                                    9,
                                    1,
                                    6,
                                    0,
                                    4,
                                    3,
                                    5,
                                    2,
                                    7
                                ],
                                [
                                    9,
                                    4,
                                    5,
                                    3,
                                    1,
                                    2,
                                    6,
                                    8,
                                    7,
                                    0
                                ],
                                [
                                    4,
                                    2,
                                    8,
                                    6,
                                    5,
                                    7,
                                    3,
                                    9,
                                    0,
                                    1
                                ],
                                [
                                    2,
                                    7,
                                    9,
                                    3,
                                    8,
                                    0,
                                    6,
                                    4,
                                    1,
                                    5
                                ],
                                [
                                    7,
                                    0,
                                    4,
                                    6,
                                    9,
                                    1,
                                    3,
                                    2,
                                    5,
                                    8
                                ]
                            ], n = e.split('').reverse().join(''), i = 0, a = 0; a < n.length; a++)
                        i = t[i][r[a % 8][parseInt(n[a], 10)]];
                    return 0 === i;
                };
            },
            5571: (e, t) => {
                'use strict';
                function r(e) {
                    return (r = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    if (!('string' == typeof e || e instanceof String)) {
                        var t = r(e);
                        throw null === e ? t = 'null' : 'object' === t && (t = e.constructor.name), new TypeError('Expected a string but received a '.concat(t));
                    }
                }, e.exports = t.default, e.exports.default = t.default;
            },
            8343: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = void 0;
                t.default = function (e, t) {
                    return e.some(function (e) {
                        return t === e;
                    });
                }, e.exports = t.default, e.exports.default = t.default;
            },
            4808: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function () {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
                    for (var r in t)
                        void 0 === e[r] && (e[r] = t[r]);
                    return e;
                }, e.exports = t.default, e.exports.default = t.default;
            },
            4731: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    var r = e.join('');
                    return new RegExp(r, t);
                }, e.exports = t.default, e.exports.default = t.default;
            },
            1913: (e, t) => {
                'use strict';
                function r(e) {
                    return (r = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
                        return typeof e;
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                    })(e);
                }
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e) {
                    return 'object' === r(e) && null !== e ? e = 'function' == typeof e.toString ? e.toString() : '[object Object]' : (null == e || isNaN(e) && !e.length) && (e = ''), String(e);
                }, e.exports = t.default, e.exports.default = t.default;
            },
            4714: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 }), t.default = function (e, t) {
                    return (0, i.default)(e), e.replace(new RegExp('[^'.concat(t, ']+'), 'g'), '');
                };
                var n, i = (n = r(5571)) && n.__esModule ? n : { default: n };
                e.exports = t.default, e.exports.default = t.default;
            },
            4900: (e, t, r) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 });
                var n = r(9282), i = r(7085), a = r(8192);
                function o(e) {
                    return e && 'object' == typeof e && 'default' in e ? e : { default: e };
                }
                var s = o(n), c = o(i), u = o(a);
                class l {
                    constructor(e, t, r, n, i, a, o) {
                        this.identifier = e, this.from = t, this.tainted = !1, this.resolved = null, this.flag = r, this.isWrite() && (this.writeExpr = n, this.partial = a, this.init = o), this.__maybeImplicitGlobal = i;
                    }
                    isStatic() {
                        return !this.tainted && this.resolved && this.resolved.scope.isStatic();
                    }
                    isWrite() {
                        return !!(this.flag & l.WRITE);
                    }
                    isRead() {
                        return !!(this.flag & l.READ);
                    }
                    isReadOnly() {
                        return this.flag === l.READ;
                    }
                    isWriteOnly() {
                        return this.flag === l.WRITE;
                    }
                    isReadWrite() {
                        return this.flag === l.RW;
                    }
                }
                l.READ = 1, l.WRITE = 2, l.RW = 3;
                class d {
                    constructor(e, t) {
                        this.name = e, this.identifiers = [], this.references = [], this.defs = [], this.tainted = !1, this.stack = !0, this.scope = t;
                    }
                }
                d.CatchClause = 'CatchClause', d.Parameter = 'Parameter', d.FunctionName = 'FunctionName', d.ClassName = 'ClassName', d.Variable = 'Variable', d.ImportBinding = 'ImportBinding', d.ImplicitGlobalVariable = 'ImplicitGlobalVariable';
                class p {
                    constructor(e, t, r, n, i, a) {
                        this.type = e, this.name = t, this.node = r, this.parent = n, this.index = i, this.kind = a;
                    }
                }
                class f extends p {
                    constructor(e, t, r, n) {
                        super(d.Parameter, e, t, null, r, null), this.rest = n;
                    }
                }
                const {Syntax: m} = c.default;
                function h(e) {
                    return e.type === d.ClassName || e.type === d.Variable && 'var' !== e.parent.kind;
                }
                class g {
                    constructor(e, t, r, n, i) {
                        this.type = t, this.set = new Map(), this.taints = new Map(), this.dynamic = 'global' === this.type || 'with' === this.type, this.block = n, this.through = [], this.variables = [], this.references = [], this.variableScope = 'global' === this.type || 'module' === this.type || 'function' === this.type || 'class-field-initializer' === this.type || 'class-static-block' === this.type ? this : r.variableScope, this.functionExpressionScope = !1, this.directCallToEvalScope = !1, this.thisFound = !1, this.__left = [], this.upper = r, this.isStrict = !!e.isStrictModeSupported() && function (e, t, r, n) {
                            let i;
                            if (e.upper && e.upper.isStrict)
                                return !0;
                            if (r)
                                return !0;
                            if ('class' === e.type || 'module' === e.type)
                                return !0;
                            if ('block' === e.type || 'switch' === e.type)
                                return !1;
                            if ('function' === e.type) {
                                if (t.type === m.ArrowFunctionExpression && t.body.type !== m.BlockStatement)
                                    return !1;
                                if (i = t.type === m.Program ? t : t.body, !i)
                                    return !1;
                            } else {
                                if ('global' !== e.type)
                                    return !1;
                                i = t;
                            }
                            if (n)
                                for (let e = 0, t = i.body.length; e < t; ++e) {
                                    const t = i.body[e];
                                    if (t.type !== m.DirectiveStatement)
                                        break;
                                    if ('"use strict"' === t.raw || '\'use strict\'' === t.raw)
                                        return !0;
                                }
                            else
                                for (let e = 0, t = i.body.length; e < t; ++e) {
                                    const t = i.body[e];
                                    if (t.type !== m.ExpressionStatement)
                                        break;
                                    const r = t.expression;
                                    if (r.type !== m.Literal || 'string' != typeof r.value)
                                        break;
                                    if (null !== r.raw && void 0 !== r.raw) {
                                        if ('"use strict"' === r.raw || '\'use strict\'' === r.raw)
                                            return !0;
                                    } else if ('use strict' === r.value)
                                        return !0;
                                }
                            return !1;
                        }(this, n, i, e.__useDirective()), this.childScopes = [], this.upper && this.upper.childScopes.push(this), this.__declaredVariables = e.__declaredVariables, function (e, t) {
                            e.scopes.push(t);
                            const r = e.__nodeToScope.get(t.block);
                            r ? r.push(t) : e.__nodeToScope.set(t.block, [t]);
                        }(e, this);
                    }
                    __shouldStaticallyClose(e) {
                        return !this.dynamic || e.__isOptimistic();
                    }
                    __shouldStaticallyCloseForGlobal(e) {
                        const t = e.identifier.name;
                        if (!this.set.has(t))
                            return !1;
                        const r = this.set.get(t).defs;
                        return r.length > 0 && r.every(h);
                    }
                    __staticCloseRef(e) {
                        this.__resolve(e) || this.__delegateToUpperScope(e);
                    }
                    __dynamicCloseRef(e) {
                        let t = this;
                        do {
                            t.through.push(e), t = t.upper;
                        } while (t);
                    }
                    __globalCloseRef(e) {
                        this.__shouldStaticallyCloseForGlobal(e) ? this.__staticCloseRef(e) : this.__dynamicCloseRef(e);
                    }
                    __close(e) {
                        let t;
                        t = this.__shouldStaticallyClose(e) ? this.__staticCloseRef : 'global' !== this.type ? this.__dynamicCloseRef : this.__globalCloseRef;
                        for (let e = 0, r = this.__left.length; e < r; ++e) {
                            const r = this.__left[e];
                            t.call(this, r);
                        }
                        return this.__left = null, this.upper;
                    }
                    __isValidResolution(e, t) {
                        return !0;
                    }
                    __resolve(e) {
                        const t = e.identifier.name;
                        if (!this.set.has(t))
                            return !1;
                        const r = this.set.get(t);
                        return !!this.__isValidResolution(e, r) && (r.references.push(e), r.stack = r.stack && e.from.variableScope === this.variableScope, e.tainted && (r.tainted = !0, this.taints.set(r.name, !0)), e.resolved = r, !0);
                    }
                    __delegateToUpperScope(e) {
                        this.upper && this.upper.__left.push(e), this.through.push(e);
                    }
                    __addDeclaredVariablesOfNode(e, t) {
                        if (null == t)
                            return;
                        let r = this.__declaredVariables.get(t);
                        null == r && (r = [], this.__declaredVariables.set(t, r)), -1 === r.indexOf(e) && r.push(e);
                    }
                    __defineGeneric(e, t, r, n, i) {
                        let a;
                        a = t.get(e), a || (a = new d(e, this), t.set(e, a), r.push(a)), i && (a.defs.push(i), this.__addDeclaredVariablesOfNode(a, i.node), this.__addDeclaredVariablesOfNode(a, i.parent)), n && a.identifiers.push(n);
                    }
                    __define(e, t) {
                        e && e.type === m.Identifier && this.__defineGeneric(e.name, this.set, this.variables, e, t);
                    }
                    __referencing(e, t, r, n, i, a) {
                        if (!e || e.type !== m.Identifier)
                            return;
                        if ('super' === e.name)
                            return;
                        const o = new l(e, this, t || l.READ, r, n, !!i, !!a);
                        this.references.push(o), this.__left.push(o);
                    }
                    __detectEval() {
                        let e = this;
                        this.directCallToEvalScope = !0;
                        do {
                            e.dynamic = !0, e = e.upper;
                        } while (e);
                    }
                    __detectThis() {
                        this.thisFound = !0;
                    }
                    __isClosed() {
                        return null === this.__left;
                    }
                    resolve(e) {
                        let t, r, n;
                        for (s.default(this.__isClosed(), 'Scope should be closed.'), s.default(e.type === m.Identifier, 'Target should be identifier.'), r = 0, n = this.references.length; r < n; ++r)
                            if (t = this.references[r], t.identifier === e)
                                return t;
                        return null;
                    }
                    isStatic() {
                        return !this.dynamic;
                    }
                    isArgumentsMaterialized() {
                        return !0;
                    }
                    isThisMaterialized() {
                        return !0;
                    }
                    isUsedName(e) {
                        if (this.set.has(e))
                            return !0;
                        for (let t = 0, r = this.through.length; t < r; ++t)
                            if (this.through[t].identifier.name === e)
                                return !0;
                        return !1;
                    }
                }
                class y extends g {
                    constructor(e, t) {
                        super(e, 'global', null, t, !1), this.implicit = {
                            set: new Map(),
                            variables: [],
                            left: []
                        };
                    }
                    __close(e) {
                        const t = [];
                        for (let e = 0, r = this.__left.length; e < r; ++e) {
                            const r = this.__left[e];
                            r.__maybeImplicitGlobal && !this.set.has(r.identifier.name) && t.push(r.__maybeImplicitGlobal);
                        }
                        for (let e = 0, r = t.length; e < r; ++e) {
                            const r = t[e];
                            this.__defineImplicit(r.pattern, new p(d.ImplicitGlobalVariable, r.pattern, r.node, null, null, null));
                        }
                        return this.implicit.left = this.__left, super.__close(e);
                    }
                    __defineImplicit(e, t) {
                        e && e.type === m.Identifier && this.__defineGeneric(e.name, this.implicit.set, this.implicit.variables, e, t);
                    }
                }
                class b extends g {
                    constructor(e, t, r) {
                        super(e, 'module', t, r, !1);
                    }
                }
                class S extends g {
                    constructor(e, t, r) {
                        super(e, 'function-expression-name', t, r, !1), this.__define(r.id, new p(d.FunctionName, r.id, r, null, null, null)), this.functionExpressionScope = !0;
                    }
                }
                class v extends g {
                    constructor(e, t, r) {
                        super(e, 'catch', t, r, !1);
                    }
                }
                class C extends g {
                    constructor(e, t, r) {
                        super(e, 'with', t, r, !1);
                    }
                    __close(e) {
                        if (this.__shouldStaticallyClose(e))
                            return super.__close(e);
                        for (let e = 0, t = this.__left.length; e < t; ++e) {
                            const t = this.__left[e];
                            t.tainted = !0, this.__delegateToUpperScope(t);
                        }
                        return this.__left = null, this.upper;
                    }
                }
                class A extends g {
                    constructor(e, t, r) {
                        super(e, 'block', t, r, !1);
                    }
                }
                class _ extends g {
                    constructor(e, t, r) {
                        super(e, 'switch', t, r, !1);
                    }
                }
                class E extends g {
                    constructor(e, t, r, n) {
                        super(e, 'function', t, r, n), this.block.type !== m.ArrowFunctionExpression && this.__defineArguments();
                    }
                    isArgumentsMaterialized() {
                        if (this.block.type === m.ArrowFunctionExpression)
                            return !1;
                        if (!this.isStatic())
                            return !0;
                        const e = this.set.get('arguments');
                        return s.default(e, 'Always have arguments variable.'), e.tainted || 0 !== e.references.length;
                    }
                    isThisMaterialized() {
                        return !this.isStatic() || this.thisFound;
                    }
                    __defineArguments() {
                        this.__defineGeneric('arguments', this.set, this.variables, null, null), this.taints.set('arguments', !0);
                    }
                    __isValidResolution(e, t) {
                        if ('Program' === this.block.type)
                            return !0;
                        const r = this.block.body.range[0];
                        return !(t.scope === this && e.identifier.range[0] < r && t.defs.every(e => e.name.range[0] >= r));
                    }
                }
                class N extends g {
                    constructor(e, t, r) {
                        super(e, 'for', t, r, !1);
                    }
                }
                class I extends g {
                    constructor(e, t, r) {
                        super(e, 'class', t, r, !1);
                    }
                }
                class T extends g {
                    constructor(e, t, r) {
                        super(e, 'class-field-initializer', t, r, !0);
                    }
                }
                class D extends g {
                    constructor(e, t, r) {
                        super(e, 'class-static-block', t, r, !0);
                    }
                }
                class O {
                    constructor(e) {
                        this.scopes = [], this.globalScope = null, this.__nodeToScope = new WeakMap(), this.__currentScope = null, this.__options = e, this.__declaredVariables = new WeakMap();
                    }
                    __useDirective() {
                        return this.__options.directive;
                    }
                    __isOptimistic() {
                        return this.__options.optimistic;
                    }
                    __ignoreEval() {
                        return this.__options.ignoreEval;
                    }
                    __isNodejsScope() {
                        return this.__options.nodejsScope || 'commonjs' === this.__options.sourceType;
                    }
                    isModule() {
                        return 'module' === this.__options.sourceType;
                    }
                    isImpliedStrict() {
                        return this.__options.impliedStrict;
                    }
                    isStrictModeSupported() {
                        return this.__options.ecmaVersion >= 5;
                    }
                    __get(e) {
                        return this.__nodeToScope.get(e);
                    }
                    getDeclaredVariables(e) {
                        return this.__declaredVariables.get(e) || [];
                    }
                    acquire(e, t) {
                        function r(e) {
                            return 'function' !== e.type || !e.functionExpressionScope;
                        }
                        const n = this.__get(e);
                        if (!n || 0 === n.length)
                            return null;
                        if (1 === n.length)
                            return n[0];
                        if (t)
                            for (let e = n.length - 1; e >= 0; --e) {
                                const t = n[e];
                                if (r(t))
                                    return t;
                            }
                        else
                            for (let e = 0, t = n.length; e < t; ++e) {
                                const t = n[e];
                                if (r(t))
                                    return t;
                            }
                        return null;
                    }
                    acquireAll(e) {
                        return this.__get(e);
                    }
                    release(e, t) {
                        const r = this.__get(e);
                        if (r && r.length) {
                            const e = r[0].upper;
                            return e ? this.acquire(e.block, t) : null;
                        }
                        return null;
                    }
                    attach() {
                    }
                    detach() {
                    }
                    __nestScope(e) {
                        return e instanceof y && (s.default(null === this.__currentScope), this.globalScope = e), this.__currentScope = e, e;
                    }
                    __nestGlobalScope(e) {
                        return this.__nestScope(new y(this, e));
                    }
                    __nestBlockScope(e) {
                        return this.__nestScope(new A(this, this.__currentScope, e));
                    }
                    __nestFunctionScope(e, t) {
                        return this.__nestScope(new E(this, this.__currentScope, e, t));
                    }
                    __nestForScope(e) {
                        return this.__nestScope(new N(this, this.__currentScope, e));
                    }
                    __nestCatchScope(e) {
                        return this.__nestScope(new v(this, this.__currentScope, e));
                    }
                    __nestWithScope(e) {
                        return this.__nestScope(new C(this, this.__currentScope, e));
                    }
                    __nestClassScope(e) {
                        return this.__nestScope(new I(this, this.__currentScope, e));
                    }
                    __nestClassFieldInitializerScope(e) {
                        return this.__nestScope(new T(this, this.__currentScope, e));
                    }
                    __nestClassStaticBlockScope(e) {
                        return this.__nestScope(new D(this, this.__currentScope, e));
                    }
                    __nestSwitchScope(e) {
                        return this.__nestScope(new _(this, this.__currentScope, e));
                    }
                    __nestModuleScope(e) {
                        return this.__nestScope(new b(this, this.__currentScope, e));
                    }
                    __nestFunctionExpressionNameScope(e) {
                        return this.__nestScope(new S(this, this.__currentScope, e));
                    }
                    __isES6() {
                        return this.__options.ecmaVersion >= 6;
                    }
                }
                const {Syntax: R} = c.default;
                class M extends u.default.Visitor {
                    static isPattern(e) {
                        const t = e.type;
                        return t === R.Identifier || t === R.ObjectPattern || t === R.ArrayPattern || t === R.SpreadElement || t === R.RestElement || t === R.AssignmentPattern;
                    }
                    constructor(e, t, r) {
                        super(null, e), this.rootPattern = t, this.callback = r, this.assignments = [], this.rightHandNodes = [], this.restElements = [];
                    }
                    Identifier(e) {
                        const t = (r = this.restElements)[r.length - 1] || null;
                        var r;
                        this.callback(e, {
                            topLevel: e === this.rootPattern,
                            rest: null != t && t.argument === e,
                            assignments: this.assignments
                        });
                    }
                    Property(e) {
                        e.computed && this.rightHandNodes.push(e.key), this.visit(e.value);
                    }
                    ArrayPattern(e) {
                        for (let t = 0, r = e.elements.length; t < r; ++t) {
                            const r = e.elements[t];
                            this.visit(r);
                        }
                    }
                    AssignmentPattern(e) {
                        this.assignments.push(e), this.visit(e.left), this.rightHandNodes.push(e.right), this.assignments.pop();
                    }
                    RestElement(e) {
                        this.restElements.push(e), this.visit(e.argument), this.restElements.pop();
                    }
                    MemberExpression(e) {
                        e.computed && this.rightHandNodes.push(e.property), this.rightHandNodes.push(e.object);
                    }
                    SpreadElement(e) {
                        this.visit(e.argument);
                    }
                    ArrayExpression(e) {
                        e.elements.forEach(this.visit, this);
                    }
                    AssignmentExpression(e) {
                        this.assignments.push(e), this.visit(e.left), this.rightHandNodes.push(e.right), this.assignments.pop();
                    }
                    CallExpression(e) {
                        e.arguments.forEach(e => {
                            this.rightHandNodes.push(e);
                        }), this.visit(e.callee);
                    }
                }
                const {Syntax: F} = c.default;
                class P extends u.default.Visitor {
                    constructor(e, t) {
                        super(null, t.options), this.declaration = e, this.referencer = t;
                    }
                    visitImport(e, t) {
                        this.referencer.visitPattern(e, e => {
                            this.referencer.currentScope().__define(e, new p(d.ImportBinding, e, t, this.declaration, null, null));
                        });
                    }
                    ImportNamespaceSpecifier(e) {
                        const t = e.local || e.id;
                        t && this.visitImport(t, e);
                    }
                    ImportDefaultSpecifier(e) {
                        const t = e.local || e.id;
                        this.visitImport(t, e);
                    }
                    ImportSpecifier(e) {
                        const t = e.local || e.id;
                        e.name ? this.visitImport(e.name, e) : this.visitImport(t, e);
                    }
                }
                class x extends u.default.Visitor {
                    constructor(e, t) {
                        super(null, e), this.options = e, this.scopeManager = t, this.parent = null, this.isInnerMethodDefinition = !1;
                    }
                    currentScope() {
                        return this.scopeManager.__currentScope;
                    }
                    close(e) {
                        for (; this.currentScope() && e === this.currentScope().block;)
                            this.scopeManager.__currentScope = this.currentScope().__close(this.scopeManager);
                    }
                    pushInnerMethodDefinition(e) {
                        const t = this.isInnerMethodDefinition;
                        return this.isInnerMethodDefinition = e, t;
                    }
                    popInnerMethodDefinition(e) {
                        this.isInnerMethodDefinition = e;
                    }
                    referencingDefaultValue(e, t, r, n) {
                        const i = this.currentScope();
                        t.forEach(t => {
                            i.__referencing(e, l.WRITE, t.right, r, e !== t.left, n);
                        });
                    }
                    visitPattern(e, t, r) {
                        let n = t, i = r;
                        'function' == typeof t && (i = t, n = { processRightHandNodes: !1 }), function (e, t, r, n) {
                            const i = new M(e, t, n);
                            i.visit(t), null != r && i.rightHandNodes.forEach(r.visit, r);
                        }(this.options, e, n.processRightHandNodes ? this : null, i);
                    }
                    visitFunction(e) {
                        let t, r;
                        e.type === F.FunctionDeclaration && this.currentScope().__define(e.id, new p(d.FunctionName, e.id, e, null, null, null)), e.type === F.FunctionExpression && e.id && this.scopeManager.__nestFunctionExpressionNameScope(e), this.scopeManager.__nestFunctionScope(e, this.isInnerMethodDefinition);
                        const n = this;
                        function i(r, i) {
                            n.currentScope().__define(r, new f(r, e, t, i.rest)), n.referencingDefaultValue(r, i.assignments, null, !0);
                        }
                        for (t = 0, r = e.params.length; t < r; ++t)
                            this.visitPattern(e.params[t], { processRightHandNodes: !0 }, i);
                        e.rest && this.visitPattern({
                            type: 'RestElement',
                            argument: e.rest
                        }, t => {
                            this.currentScope().__define(t, new f(t, e, e.params.length, !0));
                        }), e.body && (e.body.type === F.BlockStatement ? this.visitChildren(e.body) : this.visit(e.body)), this.close(e);
                    }
                    visitClass(e) {
                        e.type === F.ClassDeclaration && this.currentScope().__define(e.id, new p(d.ClassName, e.id, e, null, null, null)), this.visit(e.superClass), this.scopeManager.__nestClassScope(e), e.id && this.currentScope().__define(e.id, new p(d.ClassName, e.id, e)), this.visit(e.body), this.close(e);
                    }
                    visitProperty(e) {
                        let t;
                        e.computed && this.visit(e.key);
                        const r = e.type === F.MethodDefinition;
                        r && (t = this.pushInnerMethodDefinition(!0)), this.visit(e.value), r && this.popInnerMethodDefinition(t);
                    }
                    visitForIn(e) {
                        e.left.type === F.VariableDeclaration && 'var' !== e.left.kind && this.scopeManager.__nestForScope(e), e.left.type === F.VariableDeclaration ? (this.visit(e.left), this.visitPattern(e.left.declarations[0].id, t => {
                            this.currentScope().__referencing(t, l.WRITE, e.right, null, !0, !0);
                        })) : this.visitPattern(e.left, { processRightHandNodes: !0 }, (t, r) => {
                            let n = null;
                            this.currentScope().isStrict || (n = {
                                pattern: t,
                                node: e
                            }), this.referencingDefaultValue(t, r.assignments, n, !1), this.currentScope().__referencing(t, l.WRITE, e.right, n, !0, !1);
                        }), this.visit(e.right), this.visit(e.body), this.close(e);
                    }
                    visitVariableDeclaration(e, t, r, n) {
                        const i = r.declarations[n], a = i.init;
                        this.visitPattern(i.id, { processRightHandNodes: !0 }, (o, s) => {
                            e.__define(o, new p(t, o, i, r, n, r.kind)), this.referencingDefaultValue(o, s.assignments, null, !0), a && this.currentScope().__referencing(o, l.WRITE, a, null, !s.topLevel, !0);
                        });
                    }
                    AssignmentExpression(e) {
                        M.isPattern(e.left) ? '=' === e.operator ? this.visitPattern(e.left, { processRightHandNodes: !0 }, (t, r) => {
                            let n = null;
                            this.currentScope().isStrict || (n = {
                                pattern: t,
                                node: e
                            }), this.referencingDefaultValue(t, r.assignments, n, !1), this.currentScope().__referencing(t, l.WRITE, e.right, n, !r.topLevel, !1);
                        }) : this.currentScope().__referencing(e.left, l.RW, e.right) : this.visit(e.left), this.visit(e.right);
                    }
                    CatchClause(e) {
                        this.scopeManager.__nestCatchScope(e), this.visitPattern(e.param, { processRightHandNodes: !0 }, (t, r) => {
                            this.currentScope().__define(t, new p(d.CatchClause, e.param, e, null, null, null)), this.referencingDefaultValue(t, r.assignments, null, !0);
                        }), this.visit(e.body), this.close(e);
                    }
                    Program(e) {
                        this.scopeManager.__nestGlobalScope(e), this.scopeManager.__isNodejsScope() && (this.currentScope().isStrict = !1, this.scopeManager.__nestFunctionScope(e, !1)), this.scopeManager.__isES6() && this.scopeManager.isModule() && this.scopeManager.__nestModuleScope(e), this.scopeManager.isStrictModeSupported() && this.scopeManager.isImpliedStrict() && (this.currentScope().isStrict = !0), this.visitChildren(e), this.close(e);
                    }
                    Identifier(e) {
                        this.currentScope().__referencing(e);
                    }
                    PrivateIdentifier() {
                    }
                    UpdateExpression(e) {
                        M.isPattern(e.argument) ? this.currentScope().__referencing(e.argument, l.RW, null) : this.visitChildren(e);
                    }
                    MemberExpression(e) {
                        this.visit(e.object), e.computed && this.visit(e.property);
                    }
                    Property(e) {
                        this.visitProperty(e);
                    }
                    PropertyDefinition(e) {
                        const {
                            computed: t,
                            key: r,
                            value: n
                        } = e;
                        t && this.visit(r), n && (this.scopeManager.__nestClassFieldInitializerScope(n), this.visit(n), this.close(n));
                    }
                    StaticBlock(e) {
                        this.scopeManager.__nestClassStaticBlockScope(e), this.visitChildren(e), this.close(e);
                    }
                    MethodDefinition(e) {
                        this.visitProperty(e);
                    }
                    BreakStatement() {
                    }
                    ContinueStatement() {
                    }
                    LabeledStatement(e) {
                        this.visit(e.body);
                    }
                    ForStatement(e) {
                        e.init && e.init.type === F.VariableDeclaration && 'var' !== e.init.kind && this.scopeManager.__nestForScope(e), this.visitChildren(e), this.close(e);
                    }
                    ClassExpression(e) {
                        this.visitClass(e);
                    }
                    ClassDeclaration(e) {
                        this.visitClass(e);
                    }
                    CallExpression(e) {
                        this.scopeManager.__ignoreEval() || e.callee.type !== F.Identifier || 'eval' !== e.callee.name || this.currentScope().variableScope.__detectEval(), this.visitChildren(e);
                    }
                    BlockStatement(e) {
                        this.scopeManager.__isES6() && this.scopeManager.__nestBlockScope(e), this.visitChildren(e), this.close(e);
                    }
                    ThisExpression() {
                        this.currentScope().variableScope.__detectThis();
                    }
                    WithStatement(e) {
                        this.visit(e.object), this.scopeManager.__nestWithScope(e), this.visit(e.body), this.close(e);
                    }
                    VariableDeclaration(e) {
                        const t = 'var' === e.kind ? this.currentScope().variableScope : this.currentScope();
                        for (let r = 0, n = e.declarations.length; r < n; ++r) {
                            const n = e.declarations[r];
                            this.visitVariableDeclaration(t, d.Variable, e, r), n.init && this.visit(n.init);
                        }
                    }
                    SwitchStatement(e) {
                        this.visit(e.discriminant), this.scopeManager.__isES6() && this.scopeManager.__nestSwitchScope(e);
                        for (let t = 0, r = e.cases.length; t < r; ++t)
                            this.visit(e.cases[t]);
                        this.close(e);
                    }
                    FunctionDeclaration(e) {
                        this.visitFunction(e);
                    }
                    FunctionExpression(e) {
                        this.visitFunction(e);
                    }
                    ForOfStatement(e) {
                        this.visitForIn(e);
                    }
                    ForInStatement(e) {
                        this.visitForIn(e);
                    }
                    ArrowFunctionExpression(e) {
                        this.visitFunction(e);
                    }
                    ImportDeclaration(e) {
                        s.default(this.scopeManager.__isES6() && this.scopeManager.isModule(), 'ImportDeclaration should appear when the mode is ES6 and in the module context.'), new P(e, this).visit(e);
                    }
                    visitExportDeclaration(e) {
                        e.source || (e.declaration ? this.visit(e.declaration) : this.visitChildren(e));
                    }
                    ExportDeclaration(e) {
                        this.visitExportDeclaration(e);
                    }
                    ExportAllDeclaration(e) {
                        this.visitExportDeclaration(e);
                    }
                    ExportDefaultDeclaration(e) {
                        this.visitExportDeclaration(e);
                    }
                    ExportNamedDeclaration(e) {
                        this.visitExportDeclaration(e);
                    }
                    ExportSpecifier(e) {
                        const t = e.id || e.local;
                        this.visit(t);
                    }
                    MetaProperty() {
                    }
                }
                function w(e, t) {
                    function r(e) {
                        return 'object' == typeof e && e instanceof Object && !(e instanceof Array) && !(e instanceof RegExp);
                    }
                    for (const n in t)
                        if (Object.prototype.hasOwnProperty.call(t, n)) {
                            const i = t[n];
                            r(i) ? r(e[n]) ? w(e[n], i) : e[n] = w({}, i) : e[n] = i;
                        }
                    return e;
                }
                t.Definition = p, t.PatternVisitor = M, t.Reference = l, t.Referencer = x, t.Scope = g, t.ScopeManager = O, t.Variable = d, t.analyze = function (e, t) {
                    const r = w({
                            optimistic: !1,
                            directive: !1,
                            nodejsScope: !1,
                            impliedStrict: !1,
                            sourceType: 'script',
                            ecmaVersion: 5,
                            childVisitorKeys: null,
                            fallback: 'iteration'
                        }, t), n = new O(r);
                    return new x(r, n).visit(e), s.default(null === n.__currentScope, 'currentScope should be null.'), n;
                }, t.version = '7.1.1';
            },
            1286: (e, t) => {
                'use strict';
                Object.defineProperty(t, '__esModule', { value: !0 });
                const r = {
                        AssignmentExpression: [
                            'left',
                            'right'
                        ],
                        AssignmentPattern: [
                            'left',
                            'right'
                        ],
                        ArrayExpression: ['elements'],
                        ArrayPattern: ['elements'],
                        ArrowFunctionExpression: [
                            'params',
                            'body'
                        ],
                        AwaitExpression: ['argument'],
                        BlockStatement: ['body'],
                        BinaryExpression: [
                            'left',
                            'right'
                        ],
                        BreakStatement: ['label'],
                        CallExpression: [
                            'callee',
                            'arguments'
                        ],
                        CatchClause: [
                            'param',
                            'body'
                        ],
                        ChainExpression: ['expression'],
                        ClassBody: ['body'],
                        ClassDeclaration: [
                            'id',
                            'superClass',
                            'body'
                        ],
                        ClassExpression: [
                            'id',
                            'superClass',
                            'body'
                        ],
                        ConditionalExpression: [
                            'test',
                            'consequent',
                            'alternate'
                        ],
                        ContinueStatement: ['label'],
                        DebuggerStatement: [],
                        DoWhileStatement: [
                            'body',
                            'test'
                        ],
                        EmptyStatement: [],
                        ExportAllDeclaration: [
                            'exported',
                            'source'
                        ],
                        ExportDefaultDeclaration: ['declaration'],
                        ExportNamedDeclaration: [
                            'declaration',
                            'specifiers',
                            'source'
                        ],
                        ExportSpecifier: [
                            'exported',
                            'local'
                        ],
                        ExpressionStatement: ['expression'],
                        ExperimentalRestProperty: ['argument'],
                        ExperimentalSpreadProperty: ['argument'],
                        ForStatement: [
                            'init',
                            'test',
                            'update',
                            'body'
                        ],
                        ForInStatement: [
                            'left',
                            'right',
                            'body'
                        ],
                        ForOfStatement: [
                            'left',
                            'right',
                            'body'
                        ],
                        FunctionDeclaration: [
                            'id',
                            'params',
                            'body'
                        ],
                        FunctionExpression: [
                            'id',
                            'params',
                            'body'
                        ],
                        Identifier: [],
                        IfStatement: [
                            'test',
                            'consequent',
                            'alternate'
                        ],
                        ImportDeclaration: [
                            'specifiers',
                            'source'
                        ],
                        ImportDefaultSpecifier: ['local'],
                        ImportExpression: ['source'],
                        ImportNamespaceSpecifier: ['local'],
                        ImportSpecifier: [
                            'imported',
                            'local'
                        ],
                        JSXAttribute: [
                            'name',
                            'value'
                        ],
                        JSXClosingElement: ['name'],
                        JSXElement: [
                            'openingElement',
                            'children',
                            'closingElement'
                        ],
                        JSXEmptyExpression: [],
                        JSXExpressionContainer: ['expression'],
                        JSXIdentifier: [],
                        JSXMemberExpression: [
                            'object',
                            'property'
                        ],
                        JSXNamespacedName: [
                            'namespace',
                            'name'
                        ],
                        JSXOpeningElement: [
                            'name',
                            'attributes'
                        ],
                        JSXSpreadAttribute: ['argument'],
                        JSXText: [],
                        JSXFragment: [
                            'openingFragment',
                            'children',
                            'closingFragment'
                        ],
                        JSXClosingFragment: [],
                        JSXOpeningFragment: [],
                        Literal: [],
                        LabeledStatement: [
                            'label',
                            'body'
                        ],
                        LogicalExpression: [
                            'left',
                            'right'
                        ],
                        MemberExpression: [
                            'object',
                            'property'
                        ],
                        MetaProperty: [
                            'meta',
                            'property'
                        ],
                        MethodDefinition: [
                            'key',
                            'value'
                        ],
                        NewExpression: [
                            'callee',
                            'arguments'
                        ],
                        ObjectExpression: ['properties'],
                        ObjectPattern: ['properties'],
                        PrivateIdentifier: [],
                        Program: ['body'],
                        Property: [
                            'key',
                            'value'
                        ],
                        PropertyDefinition: [
                            'key',
                            'value'
                        ],
                        RestElement: ['argument'],
                        ReturnStatement: ['argument'],
                        SequenceExpression: ['expressions'],
                        SpreadElement: ['argument'],
                        StaticBlock: ['body'],
                        Super: [],
                        SwitchStatement: [
                            'discriminant',
                            'cases'
                        ],
                        SwitchCase: [
                            'test',
                            'consequent'
                        ],
                        TaggedTemplateExpression: [
                            'tag',
                            'quasi'
                        ],
                        TemplateElement: [],
                        TemplateLiteral: [
                            'quasis',
                            'expressions'
                        ],
                        ThisExpression: [],
                        ThrowStatement: ['argument'],
                        TryStatement: [
                            'block',
                            'handler',
                            'finalizer'
                        ],
                        UnaryExpression: ['argument'],
                        UpdateExpression: ['argument'],
                        VariableDeclaration: ['declarations'],
                        VariableDeclarator: [
                            'id',
                            'init'
                        ],
                        WhileStatement: [
                            'test',
                            'body'
                        ],
                        WithStatement: [
                            'object',
                            'body'
                        ],
                        YieldExpression: ['argument']
                    }, n = Object.keys(r);
                for (const e of n)
                    Object.freeze(r[e]);
                Object.freeze(r);
                const i = new Set([
                    'parent',
                    'leadingComments',
                    'trailingComments'
                ]);
                function a(e) {
                    return !i.has(e) && '_' !== e[0];
                }
                t.KEYS = r, t.getKeys = function (e) {
                    return Object.keys(e).filter(a);
                }, t.unionWith = function (e) {
                    const t = Object.assign({}, r);
                    for (const r of Object.keys(e))
                        if (Object.prototype.hasOwnProperty.call(t, r)) {
                            const n = new Set(e[r]);
                            for (const e of t[r])
                                n.add(e);
                            t[r] = Object.freeze(Array.from(n));
                        } else
                            t[r] = Object.freeze(Array.from(e[r]));
                    return Object.freeze(t);
                };
            },
            9628: (e, t, r) => {
                'use strict';
                var n = r(2190);
                e.exports = function () {
                    return n([
                        'BigInt64Array',
                        'BigUint64Array',
                        'Float32Array',
                        'Float64Array',
                        'Int16Array',
                        'Int32Array',
                        'Int8Array',
                        'Uint16Array',
                        'Uint32Array',
                        'Uint8Array',
                        'Uint8ClampedArray'
                    ], function (e) {
                        return 'function' == typeof r.g[e];
                    });
                };
            },
            6638: e => {
                'use strict';
                e.exports = { version: '2.3.0' };
            },
            9389: e => {
                'use strict';
                e.exports = { version: '4.3.0' };
            },
            9854: e => {
                'use strict';
                e.exports = JSON.parse('["$&","$\'","$*","$+","$1","$2","$3","$4","$5","$6","$7","$8","$9","$_","$`","$input","-moz-animation","-moz-animation-delay","-moz-animation-direction","-moz-animation-duration","-moz-animation-fill-mode","-moz-animation-iteration-count","-moz-animation-name","-moz-animation-play-state","-moz-animation-timing-function","-moz-appearance","-moz-backface-visibility","-moz-border-end","-moz-border-end-color","-moz-border-end-style","-moz-border-end-width","-moz-border-image","-moz-border-start","-moz-border-start-color","-moz-border-start-style","-moz-border-start-width","-moz-box-align","-moz-box-direction","-moz-box-flex","-moz-box-ordinal-group","-moz-box-orient","-moz-box-pack","-moz-box-sizing","-moz-float-edge","-moz-font-feature-settings","-moz-font-language-override","-moz-force-broken-image-icon","-moz-hyphens","-moz-image-region","-moz-margin-end","-moz-margin-start","-moz-orient","-moz-osx-font-smoothing","-moz-outline-radius","-moz-outline-radius-bottomleft","-moz-outline-radius-bottomright","-moz-outline-radius-topleft","-moz-outline-radius-topright","-moz-padding-end","-moz-padding-start","-moz-perspective","-moz-perspective-origin","-moz-tab-size","-moz-text-size-adjust","-moz-transform","-moz-transform-origin","-moz-transform-style","-moz-transition","-moz-transition-delay","-moz-transition-duration","-moz-transition-property","-moz-transition-timing-function","-moz-user-focus","-moz-user-input","-moz-user-modify","-moz-user-select","-moz-window-dragging","-webkit-align-content","-webkit-align-items","-webkit-align-self","-webkit-animation","-webkit-animation-delay","-webkit-animation-direction","-webkit-animation-duration","-webkit-animation-fill-mode","-webkit-animation-iteration-count","-webkit-animation-name","-webkit-animation-play-state","-webkit-animation-timing-function","-webkit-appearance","-webkit-backface-visibility","-webkit-background-clip","-webkit-background-origin","-webkit-background-size","-webkit-border-bottom-left-radius","-webkit-border-bottom-right-radius","-webkit-border-image","-webkit-border-radius","-webkit-border-top-left-radius","-webkit-border-top-right-radius","-webkit-box-align","-webkit-box-direction","-webkit-box-flex","-webkit-box-ordinal-group","-webkit-box-orient","-webkit-box-pack","-webkit-box-shadow","-webkit-box-sizing","-webkit-filter","-webkit-flex","-webkit-flex-basis","-webkit-flex-direction","-webkit-flex-flow","-webkit-flex-grow","-webkit-flex-shrink","-webkit-flex-wrap","-webkit-justify-content","-webkit-line-clamp","-webkit-mask","-webkit-mask-clip","-webkit-mask-composite","-webkit-mask-image","-webkit-mask-origin","-webkit-mask-position","-webkit-mask-position-x","-webkit-mask-position-y","-webkit-mask-repeat","-webkit-mask-size","-webkit-order","-webkit-perspective","-webkit-perspective-origin","-webkit-text-fill-color","-webkit-text-size-adjust","-webkit-text-stroke","-webkit-text-stroke-color","-webkit-text-stroke-width","-webkit-transform","-webkit-transform-origin","-webkit-transform-style","-webkit-transition","-webkit-transition-delay","-webkit-transition-duration","-webkit-transition-property","-webkit-transition-timing-function","-webkit-user-select","0","1","10","11","12","13","14","15","16","17","18","19","2","20","3","4","5","6","7","8","9","@@iterator","ABORT_ERR","ACTIVE","ACTIVE_ATTRIBUTES","ACTIVE_TEXTURE","ACTIVE_UNIFORMS","ACTIVE_UNIFORM_BLOCKS","ADDITION","ALIASED_LINE_WIDTH_RANGE","ALIASED_POINT_SIZE_RANGE","ALLOW_KEYBOARD_INPUT","ALLPASS","ALPHA","ALPHA_BITS","ALREADY_SIGNALED","ALT_MASK","ALWAYS","ANY_SAMPLES_PASSED","ANY_SAMPLES_PASSED_CONSERVATIVE","ANY_TYPE","ANY_UNORDERED_NODE_TYPE","ARRAY_BUFFER","ARRAY_BUFFER_BINDING","ATTACHED_SHADERS","ATTRIBUTE_NODE","AT_TARGET","AbortController","AbortSignal","AbsoluteOrientationSensor","AbstractRange","Accelerometer","AddSearchProvider","AggregateError","AnalyserNode","Animation","AnimationEffect","AnimationEvent","AnimationPlaybackEvent","AnimationTimeline","AnonXMLHttpRequest","Any","ApplicationCache","ApplicationCacheErrorEvent","Array","ArrayBuffer","ArrayType","Atomics","Attr","Audio","AudioBuffer","AudioBufferSourceNode","AudioContext","AudioDestinationNode","AudioListener","AudioNode","AudioParam","AudioParamMap","AudioProcessingEvent","AudioScheduledSourceNode","AudioStreamTrack","AudioWorklet","AudioWorkletNode","AuthenticatorAssertionResponse","AuthenticatorAttestationResponse","AuthenticatorResponse","AutocompleteErrorEvent","BACK","BAD_BOUNDARYPOINTS_ERR","BAD_REQUEST","BANDPASS","BLEND","BLEND_COLOR","BLEND_DST_ALPHA","BLEND_DST_RGB","BLEND_EQUATION","BLEND_EQUATION_ALPHA","BLEND_EQUATION_RGB","BLEND_SRC_ALPHA","BLEND_SRC_RGB","BLUE_BITS","BLUR","BOOL","BOOLEAN_TYPE","BOOL_VEC2","BOOL_VEC3","BOOL_VEC4","BOTH","BROWSER_DEFAULT_WEBGL","BUBBLING_PHASE","BUFFER_SIZE","BUFFER_USAGE","BYTE","BYTES_PER_ELEMENT","BackgroundFetchManager","BackgroundFetchRecord","BackgroundFetchRegistration","BarProp","BarcodeDetector","BaseAudioContext","BaseHref","BatteryManager","BeforeInstallPromptEvent","BeforeLoadEvent","BeforeUnloadEvent","BigInt","BigInt64Array","BigUint64Array","BiquadFilterNode","Blob","BlobEvent","Bluetooth","BluetoothCharacteristicProperties","BluetoothDevice","BluetoothRemoteGATTCharacteristic","BluetoothRemoteGATTDescriptor","BluetoothRemoteGATTServer","BluetoothRemoteGATTService","BluetoothUUID","Boolean","BroadcastChannel","ByteLengthQueuingStrategy","CAPTURING_PHASE","CCW","CDATASection","CDATA_SECTION_NODE","CHANGE","CHARSET_RULE","CHECKING","CLAMP_TO_EDGE","CLICK","CLOSED","CLOSING","COLOR","COLOR_ATTACHMENT0","COLOR_ATTACHMENT1","COLOR_ATTACHMENT10","COLOR_ATTACHMENT11","COLOR_ATTACHMENT12","COLOR_ATTACHMENT13","COLOR_ATTACHMENT14","COLOR_ATTACHMENT15","COLOR_ATTACHMENT2","COLOR_ATTACHMENT3","COLOR_ATTACHMENT4","COLOR_ATTACHMENT5","COLOR_ATTACHMENT6","COLOR_ATTACHMENT7","COLOR_ATTACHMENT8","COLOR_ATTACHMENT9","COLOR_BUFFER_BIT","COLOR_CLEAR_VALUE","COLOR_WRITEMASK","COMMENT_NODE","COMPARE_REF_TO_TEXTURE","COMPILE_STATUS","COMPRESSED_RGBA_S3TC_DXT1_EXT","COMPRESSED_RGBA_S3TC_DXT3_EXT","COMPRESSED_RGBA_S3TC_DXT5_EXT","COMPRESSED_RGB_S3TC_DXT1_EXT","COMPRESSED_TEXTURE_FORMATS","CONDITION_SATISFIED","CONFIGURATION_UNSUPPORTED","CONNECTING","CONSTANT_ALPHA","CONSTANT_COLOR","CONSTRAINT_ERR","CONTEXT_LOST_WEBGL","CONTROL_MASK","COPY_READ_BUFFER","COPY_READ_BUFFER_BINDING","COPY_WRITE_BUFFER","COPY_WRITE_BUFFER_BINDING","COUNTER_STYLE_RULE","CSS","CSS2Properties","CSSAnimation","CSSCharsetRule","CSSConditionRule","CSSCounterStyleRule","CSSFontFaceRule","CSSFontFeatureValuesRule","CSSGroupingRule","CSSImageValue","CSSImportRule","CSSKeyframeRule","CSSKeyframesRule","CSSKeywordValue","CSSMathInvert","CSSMathMax","CSSMathMin","CSSMathNegate","CSSMathProduct","CSSMathSum","CSSMathValue","CSSMatrixComponent","CSSMediaRule","CSSMozDocumentRule","CSSNameSpaceRule","CSSNamespaceRule","CSSNumericArray","CSSNumericValue","CSSPageRule","CSSPerspective","CSSPositionValue","CSSPrimitiveValue","CSSRotate","CSSRule","CSSRuleList","CSSScale","CSSSkew","CSSSkewX","CSSSkewY","CSSStyleDeclaration","CSSStyleRule","CSSStyleSheet","CSSStyleValue","CSSSupportsRule","CSSTransformComponent","CSSTransformValue","CSSTransition","CSSTranslate","CSSUnitValue","CSSUnknownRule","CSSUnparsedValue","CSSValue","CSSValueList","CSSVariableReferenceValue","CSSVariablesDeclaration","CSSVariablesRule","CSSViewportRule","CSS_ATTR","CSS_CM","CSS_COUNTER","CSS_CUSTOM","CSS_DEG","CSS_DIMENSION","CSS_EMS","CSS_EXS","CSS_FILTER_BLUR","CSS_FILTER_BRIGHTNESS","CSS_FILTER_CONTRAST","CSS_FILTER_CUSTOM","CSS_FILTER_DROP_SHADOW","CSS_FILTER_GRAYSCALE","CSS_FILTER_HUE_ROTATE","CSS_FILTER_INVERT","CSS_FILTER_OPACITY","CSS_FILTER_REFERENCE","CSS_FILTER_SATURATE","CSS_FILTER_SEPIA","CSS_GRAD","CSS_HZ","CSS_IDENT","CSS_IN","CSS_INHERIT","CSS_KHZ","CSS_MATRIX","CSS_MATRIX3D","CSS_MM","CSS_MS","CSS_NUMBER","CSS_PC","CSS_PERCENTAGE","CSS_PERSPECTIVE","CSS_PRIMITIVE_VALUE","CSS_PT","CSS_PX","CSS_RAD","CSS_RECT","CSS_RGBCOLOR","CSS_ROTATE","CSS_ROTATE3D","CSS_ROTATEX","CSS_ROTATEY","CSS_ROTATEZ","CSS_S","CSS_SCALE","CSS_SCALE3D","CSS_SCALEX","CSS_SCALEY","CSS_SCALEZ","CSS_SKEW","CSS_SKEWX","CSS_SKEWY","CSS_STRING","CSS_TRANSLATE","CSS_TRANSLATE3D","CSS_TRANSLATEX","CSS_TRANSLATEY","CSS_TRANSLATEZ","CSS_UNKNOWN","CSS_URI","CSS_VALUE_LIST","CSS_VH","CSS_VMAX","CSS_VMIN","CSS_VW","CULL_FACE","CULL_FACE_MODE","CURRENT_PROGRAM","CURRENT_QUERY","CURRENT_VERTEX_ATTRIB","CUSTOM","CW","Cache","CacheStorage","CanvasCaptureMediaStream","CanvasCaptureMediaStreamTrack","CanvasGradient","CanvasPattern","CanvasRenderingContext2D","CaretPosition","ChannelMergerNode","ChannelSplitterNode","CharacterData","ClientRect","ClientRectList","Clipboard","ClipboardEvent","ClipboardItem","CloseEvent","Collator","CommandEvent","Comment","CompileError","CompositionEvent","CompressionStream","Console","ConstantSourceNode","Controllers","ConvolverNode","CountQueuingStrategy","Counter","Credential","CredentialsContainer","Crypto","CryptoKey","CustomElementRegistry","CustomEvent","DATABASE_ERR","DATA_CLONE_ERR","DATA_ERR","DBLCLICK","DECR","DECR_WRAP","DELETE_STATUS","DEPTH","DEPTH24_STENCIL8","DEPTH32F_STENCIL8","DEPTH_ATTACHMENT","DEPTH_BITS","DEPTH_BUFFER_BIT","DEPTH_CLEAR_VALUE","DEPTH_COMPONENT","DEPTH_COMPONENT16","DEPTH_COMPONENT24","DEPTH_COMPONENT32F","DEPTH_FUNC","DEPTH_RANGE","DEPTH_STENCIL","DEPTH_STENCIL_ATTACHMENT","DEPTH_TEST","DEPTH_WRITEMASK","DEVICE_INELIGIBLE","DIRECTION_DOWN","DIRECTION_LEFT","DIRECTION_RIGHT","DIRECTION_UP","DISABLED","DISPATCH_REQUEST_ERR","DITHER","DOCUMENT_FRAGMENT_NODE","DOCUMENT_NODE","DOCUMENT_POSITION_CONTAINED_BY","DOCUMENT_POSITION_CONTAINS","DOCUMENT_POSITION_DISCONNECTED","DOCUMENT_POSITION_FOLLOWING","DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC","DOCUMENT_POSITION_PRECEDING","DOCUMENT_TYPE_NODE","DOMCursor","DOMError","DOMException","DOMImplementation","DOMImplementationLS","DOMMatrix","DOMMatrixReadOnly","DOMParser","DOMPoint","DOMPointReadOnly","DOMQuad","DOMRect","DOMRectList","DOMRectReadOnly","DOMRequest","DOMSTRING_SIZE_ERR","DOMSettableTokenList","DOMStringList","DOMStringMap","DOMTokenList","DOMTransactionEvent","DOM_DELTA_LINE","DOM_DELTA_PAGE","DOM_DELTA_PIXEL","DOM_INPUT_METHOD_DROP","DOM_INPUT_METHOD_HANDWRITING","DOM_INPUT_METHOD_IME","DOM_INPUT_METHOD_KEYBOARD","DOM_INPUT_METHOD_MULTIMODAL","DOM_INPUT_METHOD_OPTION","DOM_INPUT_METHOD_PASTE","DOM_INPUT_METHOD_SCRIPT","DOM_INPUT_METHOD_UNKNOWN","DOM_INPUT_METHOD_VOICE","DOM_KEY_LOCATION_JOYSTICK","DOM_KEY_LOCATION_LEFT","DOM_KEY_LOCATION_MOBILE","DOM_KEY_LOCATION_NUMPAD","DOM_KEY_LOCATION_RIGHT","DOM_KEY_LOCATION_STANDARD","DOM_VK_0","DOM_VK_1","DOM_VK_2","DOM_VK_3","DOM_VK_4","DOM_VK_5","DOM_VK_6","DOM_VK_7","DOM_VK_8","DOM_VK_9","DOM_VK_A","DOM_VK_ACCEPT","DOM_VK_ADD","DOM_VK_ALT","DOM_VK_ALTGR","DOM_VK_AMPERSAND","DOM_VK_ASTERISK","DOM_VK_AT","DOM_VK_ATTN","DOM_VK_B","DOM_VK_BACKSPACE","DOM_VK_BACK_QUOTE","DOM_VK_BACK_SLASH","DOM_VK_BACK_SPACE","DOM_VK_C","DOM_VK_CANCEL","DOM_VK_CAPS_LOCK","DOM_VK_CIRCUMFLEX","DOM_VK_CLEAR","DOM_VK_CLOSE_BRACKET","DOM_VK_CLOSE_CURLY_BRACKET","DOM_VK_CLOSE_PAREN","DOM_VK_COLON","DOM_VK_COMMA","DOM_VK_CONTEXT_MENU","DOM_VK_CONTROL","DOM_VK_CONVERT","DOM_VK_CRSEL","DOM_VK_CTRL","DOM_VK_D","DOM_VK_DECIMAL","DOM_VK_DELETE","DOM_VK_DIVIDE","DOM_VK_DOLLAR","DOM_VK_DOUBLE_QUOTE","DOM_VK_DOWN","DOM_VK_E","DOM_VK_EISU","DOM_VK_END","DOM_VK_ENTER","DOM_VK_EQUALS","DOM_VK_EREOF","DOM_VK_ESCAPE","DOM_VK_EXCLAMATION","DOM_VK_EXECUTE","DOM_VK_EXSEL","DOM_VK_F","DOM_VK_F1","DOM_VK_F10","DOM_VK_F11","DOM_VK_F12","DOM_VK_F13","DOM_VK_F14","DOM_VK_F15","DOM_VK_F16","DOM_VK_F17","DOM_VK_F18","DOM_VK_F19","DOM_VK_F2","DOM_VK_F20","DOM_VK_F21","DOM_VK_F22","DOM_VK_F23","DOM_VK_F24","DOM_VK_F25","DOM_VK_F26","DOM_VK_F27","DOM_VK_F28","DOM_VK_F29","DOM_VK_F3","DOM_VK_F30","DOM_VK_F31","DOM_VK_F32","DOM_VK_F33","DOM_VK_F34","DOM_VK_F35","DOM_VK_F36","DOM_VK_F4","DOM_VK_F5","DOM_VK_F6","DOM_VK_F7","DOM_VK_F8","DOM_VK_F9","DOM_VK_FINAL","DOM_VK_FRONT","DOM_VK_G","DOM_VK_GREATER_THAN","DOM_VK_H","DOM_VK_HANGUL","DOM_VK_HANJA","DOM_VK_HASH","DOM_VK_HELP","DOM_VK_HK_TOGGLE","DOM_VK_HOME","DOM_VK_HYPHEN_MINUS","DOM_VK_I","DOM_VK_INSERT","DOM_VK_J","DOM_VK_JUNJA","DOM_VK_K","DOM_VK_KANA","DOM_VK_KANJI","DOM_VK_L","DOM_VK_LEFT","DOM_VK_LEFT_TAB","DOM_VK_LESS_THAN","DOM_VK_M","DOM_VK_META","DOM_VK_MODECHANGE","DOM_VK_MULTIPLY","DOM_VK_N","DOM_VK_NONCONVERT","DOM_VK_NUMPAD0","DOM_VK_NUMPAD1","DOM_VK_NUMPAD2","DOM_VK_NUMPAD3","DOM_VK_NUMPAD4","DOM_VK_NUMPAD5","DOM_VK_NUMPAD6","DOM_VK_NUMPAD7","DOM_VK_NUMPAD8","DOM_VK_NUMPAD9","DOM_VK_NUM_LOCK","DOM_VK_O","DOM_VK_OEM_1","DOM_VK_OEM_102","DOM_VK_OEM_2","DOM_VK_OEM_3","DOM_VK_OEM_4","DOM_VK_OEM_5","DOM_VK_OEM_6","DOM_VK_OEM_7","DOM_VK_OEM_8","DOM_VK_OEM_COMMA","DOM_VK_OEM_MINUS","DOM_VK_OEM_PERIOD","DOM_VK_OEM_PLUS","DOM_VK_OPEN_BRACKET","DOM_VK_OPEN_CURLY_BRACKET","DOM_VK_OPEN_PAREN","DOM_VK_P","DOM_VK_PA1","DOM_VK_PAGEDOWN","DOM_VK_PAGEUP","DOM_VK_PAGE_DOWN","DOM_VK_PAGE_UP","DOM_VK_PAUSE","DOM_VK_PERCENT","DOM_VK_PERIOD","DOM_VK_PIPE","DOM_VK_PLAY","DOM_VK_PLUS","DOM_VK_PRINT","DOM_VK_PRINTSCREEN","DOM_VK_PROCESSKEY","DOM_VK_PROPERITES","DOM_VK_Q","DOM_VK_QUESTION_MARK","DOM_VK_QUOTE","DOM_VK_R","DOM_VK_REDO","DOM_VK_RETURN","DOM_VK_RIGHT","DOM_VK_S","DOM_VK_SCROLL_LOCK","DOM_VK_SELECT","DOM_VK_SEMICOLON","DOM_VK_SEPARATOR","DOM_VK_SHIFT","DOM_VK_SLASH","DOM_VK_SLEEP","DOM_VK_SPACE","DOM_VK_SUBTRACT","DOM_VK_T","DOM_VK_TAB","DOM_VK_TILDE","DOM_VK_U","DOM_VK_UNDERSCORE","DOM_VK_UNDO","DOM_VK_UNICODE","DOM_VK_UP","DOM_VK_V","DOM_VK_VOLUME_DOWN","DOM_VK_VOLUME_MUTE","DOM_VK_VOLUME_UP","DOM_VK_W","DOM_VK_WIN","DOM_VK_WINDOW","DOM_VK_WIN_ICO_00","DOM_VK_WIN_ICO_CLEAR","DOM_VK_WIN_ICO_HELP","DOM_VK_WIN_OEM_ATTN","DOM_VK_WIN_OEM_AUTO","DOM_VK_WIN_OEM_BACKTAB","DOM_VK_WIN_OEM_CLEAR","DOM_VK_WIN_OEM_COPY","DOM_VK_WIN_OEM_CUSEL","DOM_VK_WIN_OEM_ENLW","DOM_VK_WIN_OEM_FINISH","DOM_VK_WIN_OEM_FJ_JISHO","DOM_VK_WIN_OEM_FJ_LOYA","DOM_VK_WIN_OEM_FJ_MASSHOU","DOM_VK_WIN_OEM_FJ_ROYA","DOM_VK_WIN_OEM_FJ_TOUROKU","DOM_VK_WIN_OEM_JUMP","DOM_VK_WIN_OEM_PA1","DOM_VK_WIN_OEM_PA2","DOM_VK_WIN_OEM_PA3","DOM_VK_WIN_OEM_RESET","DOM_VK_WIN_OEM_WSCTRL","DOM_VK_X","DOM_VK_XF86XK_ADD_FAVORITE","DOM_VK_XF86XK_APPLICATION_LEFT","DOM_VK_XF86XK_APPLICATION_RIGHT","DOM_VK_XF86XK_AUDIO_CYCLE_TRACK","DOM_VK_XF86XK_AUDIO_FORWARD","DOM_VK_XF86XK_AUDIO_LOWER_VOLUME","DOM_VK_XF86XK_AUDIO_MEDIA","DOM_VK_XF86XK_AUDIO_MUTE","DOM_VK_XF86XK_AUDIO_NEXT","DOM_VK_XF86XK_AUDIO_PAUSE","DOM_VK_XF86XK_AUDIO_PLAY","DOM_VK_XF86XK_AUDIO_PREV","DOM_VK_XF86XK_AUDIO_RAISE_VOLUME","DOM_VK_XF86XK_AUDIO_RANDOM_PLAY","DOM_VK_XF86XK_AUDIO_RECORD","DOM_VK_XF86XK_AUDIO_REPEAT","DOM_VK_XF86XK_AUDIO_REWIND","DOM_VK_XF86XK_AUDIO_STOP","DOM_VK_XF86XK_AWAY","DOM_VK_XF86XK_BACK","DOM_VK_XF86XK_BACK_FORWARD","DOM_VK_XF86XK_BATTERY","DOM_VK_XF86XK_BLUE","DOM_VK_XF86XK_BLUETOOTH","DOM_VK_XF86XK_BOOK","DOM_VK_XF86XK_BRIGHTNESS_ADJUST","DOM_VK_XF86XK_CALCULATOR","DOM_VK_XF86XK_CALENDAR","DOM_VK_XF86XK_CD","DOM_VK_XF86XK_CLOSE","DOM_VK_XF86XK_COMMUNITY","DOM_VK_XF86XK_CONTRAST_ADJUST","DOM_VK_XF86XK_COPY","DOM_VK_XF86XK_CUT","DOM_VK_XF86XK_CYCLE_ANGLE","DOM_VK_XF86XK_DISPLAY","DOM_VK_XF86XK_DOCUMENTS","DOM_VK_XF86XK_DOS","DOM_VK_XF86XK_EJECT","DOM_VK_XF86XK_EXCEL","DOM_VK_XF86XK_EXPLORER","DOM_VK_XF86XK_FAVORITES","DOM_VK_XF86XK_FINANCE","DOM_VK_XF86XK_FORWARD","DOM_VK_XF86XK_FRAME_BACK","DOM_VK_XF86XK_FRAME_FORWARD","DOM_VK_XF86XK_GAME","DOM_VK_XF86XK_GO","DOM_VK_XF86XK_GREEN","DOM_VK_XF86XK_HIBERNATE","DOM_VK_XF86XK_HISTORY","DOM_VK_XF86XK_HOME_PAGE","DOM_VK_XF86XK_HOT_LINKS","DOM_VK_XF86XK_I_TOUCH","DOM_VK_XF86XK_KBD_BRIGHTNESS_DOWN","DOM_VK_XF86XK_KBD_BRIGHTNESS_UP","DOM_VK_XF86XK_KBD_LIGHT_ON_OFF","DOM_VK_XF86XK_LAUNCH0","DOM_VK_XF86XK_LAUNCH1","DOM_VK_XF86XK_LAUNCH2","DOM_VK_XF86XK_LAUNCH3","DOM_VK_XF86XK_LAUNCH4","DOM_VK_XF86XK_LAUNCH5","DOM_VK_XF86XK_LAUNCH6","DOM_VK_XF86XK_LAUNCH7","DOM_VK_XF86XK_LAUNCH8","DOM_VK_XF86XK_LAUNCH9","DOM_VK_XF86XK_LAUNCH_A","DOM_VK_XF86XK_LAUNCH_B","DOM_VK_XF86XK_LAUNCH_C","DOM_VK_XF86XK_LAUNCH_D","DOM_VK_XF86XK_LAUNCH_E","DOM_VK_XF86XK_LAUNCH_F","DOM_VK_XF86XK_LIGHT_BULB","DOM_VK_XF86XK_LOG_OFF","DOM_VK_XF86XK_MAIL","DOM_VK_XF86XK_MAIL_FORWARD","DOM_VK_XF86XK_MARKET","DOM_VK_XF86XK_MEETING","DOM_VK_XF86XK_MEMO","DOM_VK_XF86XK_MENU_KB","DOM_VK_XF86XK_MENU_PB","DOM_VK_XF86XK_MESSENGER","DOM_VK_XF86XK_MON_BRIGHTNESS_DOWN","DOM_VK_XF86XK_MON_BRIGHTNESS_UP","DOM_VK_XF86XK_MUSIC","DOM_VK_XF86XK_MY_COMPUTER","DOM_VK_XF86XK_MY_SITES","DOM_VK_XF86XK_NEW","DOM_VK_XF86XK_NEWS","DOM_VK_XF86XK_OFFICE_HOME","DOM_VK_XF86XK_OPEN","DOM_VK_XF86XK_OPEN_URL","DOM_VK_XF86XK_OPTION","DOM_VK_XF86XK_PASTE","DOM_VK_XF86XK_PHONE","DOM_VK_XF86XK_PICTURES","DOM_VK_XF86XK_POWER_DOWN","DOM_VK_XF86XK_POWER_OFF","DOM_VK_XF86XK_RED","DOM_VK_XF86XK_REFRESH","DOM_VK_XF86XK_RELOAD","DOM_VK_XF86XK_REPLY","DOM_VK_XF86XK_ROCKER_DOWN","DOM_VK_XF86XK_ROCKER_ENTER","DOM_VK_XF86XK_ROCKER_UP","DOM_VK_XF86XK_ROTATE_WINDOWS","DOM_VK_XF86XK_ROTATION_KB","DOM_VK_XF86XK_ROTATION_PB","DOM_VK_XF86XK_SAVE","DOM_VK_XF86XK_SCREEN_SAVER","DOM_VK_XF86XK_SCROLL_CLICK","DOM_VK_XF86XK_SCROLL_DOWN","DOM_VK_XF86XK_SCROLL_UP","DOM_VK_XF86XK_SEARCH","DOM_VK_XF86XK_SEND","DOM_VK_XF86XK_SHOP","DOM_VK_XF86XK_SPELL","DOM_VK_XF86XK_SPLIT_SCREEN","DOM_VK_XF86XK_STANDBY","DOM_VK_XF86XK_START","DOM_VK_XF86XK_STOP","DOM_VK_XF86XK_SUBTITLE","DOM_VK_XF86XK_SUPPORT","DOM_VK_XF86XK_SUSPEND","DOM_VK_XF86XK_TASK_PANE","DOM_VK_XF86XK_TERMINAL","DOM_VK_XF86XK_TIME","DOM_VK_XF86XK_TOOLS","DOM_VK_XF86XK_TOP_MENU","DOM_VK_XF86XK_TO_DO_LIST","DOM_VK_XF86XK_TRAVEL","DOM_VK_XF86XK_USER1KB","DOM_VK_XF86XK_USER2KB","DOM_VK_XF86XK_USER_PB","DOM_VK_XF86XK_UWB","DOM_VK_XF86XK_VENDOR_HOME","DOM_VK_XF86XK_VIDEO","DOM_VK_XF86XK_VIEW","DOM_VK_XF86XK_WAKE_UP","DOM_VK_XF86XK_WEB_CAM","DOM_VK_XF86XK_WHEEL_BUTTON","DOM_VK_XF86XK_WLAN","DOM_VK_XF86XK_WORD","DOM_VK_XF86XK_WWW","DOM_VK_XF86XK_XFER","DOM_VK_XF86XK_YELLOW","DOM_VK_XF86XK_ZOOM_IN","DOM_VK_XF86XK_ZOOM_OUT","DOM_VK_Y","DOM_VK_Z","DOM_VK_ZOOM","DONE","DONT_CARE","DOWNLOADING","DRAGDROP","DRAW_BUFFER0","DRAW_BUFFER1","DRAW_BUFFER10","DRAW_BUFFER11","DRAW_BUFFER12","DRAW_BUFFER13","DRAW_BUFFER14","DRAW_BUFFER15","DRAW_BUFFER2","DRAW_BUFFER3","DRAW_BUFFER4","DRAW_BUFFER5","DRAW_BUFFER6","DRAW_BUFFER7","DRAW_BUFFER8","DRAW_BUFFER9","DRAW_FRAMEBUFFER","DRAW_FRAMEBUFFER_BINDING","DST_ALPHA","DST_COLOR","DYNAMIC_COPY","DYNAMIC_DRAW","DYNAMIC_READ","DataChannel","DataTransfer","DataTransferItem","DataTransferItemList","DataView","Date","DateTimeFormat","DecompressionStream","DelayNode","DeprecationReportBody","DesktopNotification","DesktopNotificationCenter","DeviceLightEvent","DeviceMotionEvent","DeviceMotionEventAcceleration","DeviceMotionEventRotationRate","DeviceOrientationEvent","DeviceProximityEvent","DeviceStorage","DeviceStorageChangeEvent","Directory","DisplayNames","Document","DocumentFragment","DocumentTimeline","DocumentType","DragEvent","DynamicsCompressorNode","E","ELEMENT_ARRAY_BUFFER","ELEMENT_ARRAY_BUFFER_BINDING","ELEMENT_NODE","EMPTY","ENCODING_ERR","ENDED","END_TO_END","END_TO_START","ENTITY_NODE","ENTITY_REFERENCE_NODE","EPSILON","EQUAL","EQUALPOWER","ERROR","EXPONENTIAL_DISTANCE","exports","Element","ElementInternals","ElementQuery","EnterPictureInPictureEvent","Entity","EntityReference","Error","ErrorEvent","EvalError","Event","EventException","EventSource","EventTarget","External","FASTEST","FIDOSDK","FILTER_ACCEPT","FILTER_INTERRUPT","FILTER_REJECT","FILTER_SKIP","FINISHED_STATE","FIRST_ORDERED_NODE_TYPE","FLOAT","FLOAT_32_UNSIGNED_INT_24_8_REV","FLOAT_MAT2","FLOAT_MAT2x3","FLOAT_MAT2x4","FLOAT_MAT3","FLOAT_MAT3x2","FLOAT_MAT3x4","FLOAT_MAT4","FLOAT_MAT4x2","FLOAT_MAT4x3","FLOAT_VEC2","FLOAT_VEC3","FLOAT_VEC4","FOCUS","FONT_FACE_RULE","FONT_FEATURE_VALUES_RULE","FRAGMENT_SHADER","FRAGMENT_SHADER_DERIVATIVE_HINT","FRAGMENT_SHADER_DERIVATIVE_HINT_OES","FRAMEBUFFER","FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE","FRAMEBUFFER_ATTACHMENT_BLUE_SIZE","FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING","FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE","FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE","FRAMEBUFFER_ATTACHMENT_GREEN_SIZE","FRAMEBUFFER_ATTACHMENT_OBJECT_NAME","FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE","FRAMEBUFFER_ATTACHMENT_RED_SIZE","FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE","FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE","FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER","FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL","FRAMEBUFFER_BINDING","FRAMEBUFFER_COMPLETE","FRAMEBUFFER_DEFAULT","FRAMEBUFFER_INCOMPLETE_ATTACHMENT","FRAMEBUFFER_INCOMPLETE_DIMENSIONS","FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT","FRAMEBUFFER_INCOMPLETE_MULTISAMPLE","FRAMEBUFFER_UNSUPPORTED","FRONT","FRONT_AND_BACK","FRONT_FACE","FUNC_ADD","FUNC_REVERSE_SUBTRACT","FUNC_SUBTRACT","FeaturePolicy","FeaturePolicyViolationReportBody","FederatedCredential","Feed","FeedEntry","File","FileError","FileList","FileReader","FileSystem","FileSystemDirectoryEntry","FileSystemDirectoryReader","FileSystemEntry","FileSystemFileEntry","FinalizationRegistry","FindInPage","Float32Array","Float64Array","FocusEvent","FontFace","FontFaceSet","FontFaceSetLoadEvent","FormData","FormDataEvent","FragmentDirective","Function","GENERATE_MIPMAP_HINT","GEQUAL","GREATER","GREEN_BITS","GainNode","Gamepad","GamepadAxisMoveEvent","GamepadButton","GamepadButtonEvent","GamepadEvent","GamepadHapticActuator","GamepadPose","Geolocation","GeolocationCoordinates","GeolocationPosition","GeolocationPositionError","GestureEvent","Global","Gyroscope","HALF_FLOAT","HAVE_CURRENT_DATA","HAVE_ENOUGH_DATA","HAVE_FUTURE_DATA","HAVE_METADATA","HAVE_NOTHING","HEADERS_RECEIVED","HIDDEN","HIERARCHY_REQUEST_ERR","HIGHPASS","HIGHSHELF","HIGH_FLOAT","HIGH_INT","HORIZONTAL","HORIZONTAL_AXIS","HRTF","HTMLAllCollection","HTMLAnchorElement","HTMLAppletElement","HTMLAreaElement","HTMLAudioElement","HTMLBRElement","HTMLBaseElement","HTMLBaseFontElement","HTMLBlockquoteElement","HTMLBodyElement","HTMLButtonElement","HTMLCanvasElement","HTMLCollection","HTMLCommandElement","HTMLContentElement","HTMLDListElement","HTMLDataElement","HTMLDataListElement","HTMLDetailsElement","HTMLDialogElement","HTMLDirectoryElement","HTMLDivElement","HTMLDocument","HTMLElement","HTMLEmbedElement","HTMLFieldSetElement","HTMLFontElement","HTMLFormControlsCollection","HTMLFormElement","HTMLFrameElement","HTMLFrameSetElement","HTMLHRElement","HTMLHeadElement","HTMLHeadingElement","HTMLHtmlElement","HTMLIFrameElement","HTMLImageElement","HTMLInputElement","HTMLIsIndexElement","HTMLKeygenElement","HTMLLIElement","HTMLLabelElement","HTMLLegendElement","HTMLLinkElement","HTMLMapElement","HTMLMarqueeElement","HTMLMediaElement","HTMLMenuElement","HTMLMenuItemElement","HTMLMetaElement","HTMLMeterElement","HTMLModElement","HTMLOListElement","HTMLObjectElement","HTMLOptGroupElement","HTMLOptionElement","HTMLOptionsCollection","HTMLOutputElement","HTMLParagraphElement","HTMLParamElement","HTMLPictureElement","HTMLPreElement","HTMLProgressElement","HTMLPropertiesCollection","HTMLQuoteElement","HTMLScriptElement","HTMLSelectElement","HTMLShadowElement","HTMLSlotElement","HTMLSourceElement","HTMLSpanElement","HTMLStyleElement","HTMLTableCaptionElement","HTMLTableCellElement","HTMLTableColElement","HTMLTableElement","HTMLTableRowElement","HTMLTableSectionElement","HTMLTemplateElement","HTMLTextAreaElement","HTMLTimeElement","HTMLTitleElement","HTMLTrackElement","HTMLUListElement","HTMLUnknownElement","HTMLVideoElement","HashChangeEvent","Headers","History","Hz","ICE_CHECKING","ICE_CLOSED","ICE_COMPLETED","ICE_CONNECTED","ICE_FAILED","ICE_GATHERING","ICE_WAITING","IDBCursor","IDBCursorWithValue","IDBDatabase","IDBDatabaseException","IDBFactory","IDBFileHandle","IDBFileRequest","IDBIndex","IDBKeyRange","IDBMutableFile","IDBObjectStore","IDBOpenDBRequest","IDBRequest","IDBTransaction","IDBVersionChangeEvent","IDLE","IIRFilterNode","IMPLEMENTATION_COLOR_READ_FORMAT","IMPLEMENTATION_COLOR_READ_TYPE","IMPORT_RULE","INCR","INCR_WRAP","INDEX_SIZE_ERR","INT","INTERLEAVED_ATTRIBS","INT_2_10_10_10_REV","INT_SAMPLER_2D","INT_SAMPLER_2D_ARRAY","INT_SAMPLER_3D","INT_SAMPLER_CUBE","INT_VEC2","INT_VEC3","INT_VEC4","INUSE_ATTRIBUTE_ERR","INVALID_ACCESS_ERR","INVALID_CHARACTER_ERR","INVALID_ENUM","INVALID_EXPRESSION_ERR","INVALID_FRAMEBUFFER_OPERATION","INVALID_INDEX","INVALID_MODIFICATION_ERR","INVALID_NODE_TYPE_ERR","INVALID_OPERATION","INVALID_STATE_ERR","INVALID_VALUE","INVERSE_DISTANCE","INVERT","IceCandidate","IdleDeadline","Image","ImageBitmap","ImageBitmapRenderingContext","ImageCapture","ImageData","Infinity","InputDeviceCapabilities","InputDeviceInfo","InputEvent","InputMethodContext","InstallTrigger","InstallTriggerImpl","Instance","Int16Array","Int32Array","Int8Array","Intent","InternalError","IntersectionObserver","IntersectionObserverEntry","Intl","IsSearchProviderInstalled","Iterator","JSON","KEEP","KEYDOWN","KEYFRAMES_RULE","KEYFRAME_RULE","KEYPRESS","KEYUP","KeyEvent","Keyboard","KeyboardEvent","KeyboardLayoutMap","KeyframeEffect","LENGTHADJUST_SPACING","LENGTHADJUST_SPACINGANDGLYPHS","LENGTHADJUST_UNKNOWN","LEQUAL","LESS","LINEAR","LINEAR_DISTANCE","LINEAR_MIPMAP_LINEAR","LINEAR_MIPMAP_NEAREST","LINES","LINE_LOOP","LINE_STRIP","LINE_WIDTH","LINK_STATUS","LIVE","LN10","LN2","LOADED","LOADING","LOG10E","LOG2E","LOWPASS","LOWSHELF","LOW_FLOAT","LOW_INT","LSException","LSParserFilter","LUMINANCE","LUMINANCE_ALPHA","LargestContentfulPaint","LayoutShift","LayoutShiftAttribution","LinearAccelerationSensor","LinkError","ListFormat","LocalMediaStream","Locale","Location","Lock","LockManager","MAX","MAX_3D_TEXTURE_SIZE","MAX_ARRAY_TEXTURE_LAYERS","MAX_CLIENT_WAIT_TIMEOUT_WEBGL","MAX_COLOR_ATTACHMENTS","MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS","MAX_COMBINED_TEXTURE_IMAGE_UNITS","MAX_COMBINED_UNIFORM_BLOCKS","MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS","MAX_CUBE_MAP_TEXTURE_SIZE","MAX_DRAW_BUFFERS","MAX_ELEMENTS_INDICES","MAX_ELEMENTS_VERTICES","MAX_ELEMENT_INDEX","MAX_FRAGMENT_INPUT_COMPONENTS","MAX_FRAGMENT_UNIFORM_BLOCKS","MAX_FRAGMENT_UNIFORM_COMPONENTS","MAX_FRAGMENT_UNIFORM_VECTORS","MAX_PROGRAM_TEXEL_OFFSET","MAX_RENDERBUFFER_SIZE","MAX_SAFE_INTEGER","MAX_SAMPLES","MAX_SERVER_WAIT_TIMEOUT","MAX_TEXTURE_IMAGE_UNITS","MAX_TEXTURE_LOD_BIAS","MAX_TEXTURE_MAX_ANISOTROPY_EXT","MAX_TEXTURE_SIZE","MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS","MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS","MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS","MAX_UNIFORM_BLOCK_SIZE","MAX_UNIFORM_BUFFER_BINDINGS","MAX_VALUE","MAX_VARYING_COMPONENTS","MAX_VARYING_VECTORS","MAX_VERTEX_ATTRIBS","MAX_VERTEX_OUTPUT_COMPONENTS","MAX_VERTEX_TEXTURE_IMAGE_UNITS","MAX_VERTEX_UNIFORM_BLOCKS","MAX_VERTEX_UNIFORM_COMPONENTS","MAX_VERTEX_UNIFORM_VECTORS","MAX_VIEWPORT_DIMS","MEDIA_ERR_ABORTED","MEDIA_ERR_DECODE","MEDIA_ERR_ENCRYPTED","MEDIA_ERR_NETWORK","MEDIA_ERR_SRC_NOT_SUPPORTED","MEDIA_KEYERR_CLIENT","MEDIA_KEYERR_DOMAIN","MEDIA_KEYERR_HARDWARECHANGE","MEDIA_KEYERR_OUTPUT","MEDIA_KEYERR_SERVICE","MEDIA_KEYERR_UNKNOWN","MEDIA_RULE","MEDIUM_FLOAT","MEDIUM_INT","META_MASK","MIDIAccess","MIDIConnectionEvent","MIDIInput","MIDIInputMap","MIDIMessageEvent","MIDIOutput","MIDIOutputMap","MIDIPort","MIN","MIN_PROGRAM_TEXEL_OFFSET","MIN_SAFE_INTEGER","MIN_VALUE","MIRRORED_REPEAT","MODE_ASYNCHRONOUS","MODE_SYNCHRONOUS","MODIFICATION","MOUSEDOWN","MOUSEDRAG","MOUSEMOVE","MOUSEOUT","MOUSEOVER","MOUSEUP","MOZ_KEYFRAMES_RULE","MOZ_KEYFRAME_RULE","MOZ_SOURCE_CURSOR","MOZ_SOURCE_ERASER","MOZ_SOURCE_KEYBOARD","MOZ_SOURCE_MOUSE","MOZ_SOURCE_PEN","MOZ_SOURCE_TOUCH","MOZ_SOURCE_UNKNOWN","MSGESTURE_FLAG_BEGIN","MSGESTURE_FLAG_CANCEL","MSGESTURE_FLAG_END","MSGESTURE_FLAG_INERTIA","MSGESTURE_FLAG_NONE","MSPOINTER_TYPE_MOUSE","MSPOINTER_TYPE_PEN","MSPOINTER_TYPE_TOUCH","MS_ASYNC_CALLBACK_STATUS_ASSIGN_DELEGATE","MS_ASYNC_CALLBACK_STATUS_CANCEL","MS_ASYNC_CALLBACK_STATUS_CHOOSEANY","MS_ASYNC_CALLBACK_STATUS_ERROR","MS_ASYNC_CALLBACK_STATUS_JOIN","MS_ASYNC_OP_STATUS_CANCELED","MS_ASYNC_OP_STATUS_ERROR","MS_ASYNC_OP_STATUS_SUCCESS","MS_MANIPULATION_STATE_ACTIVE","MS_MANIPULATION_STATE_CANCELLED","MS_MANIPULATION_STATE_COMMITTED","MS_MANIPULATION_STATE_DRAGGING","MS_MANIPULATION_STATE_INERTIA","MS_MANIPULATION_STATE_PRESELECT","MS_MANIPULATION_STATE_SELECTING","MS_MANIPULATION_STATE_STOPPED","MS_MEDIA_ERR_ENCRYPTED","MS_MEDIA_KEYERR_CLIENT","MS_MEDIA_KEYERR_DOMAIN","MS_MEDIA_KEYERR_HARDWARECHANGE","MS_MEDIA_KEYERR_OUTPUT","MS_MEDIA_KEYERR_SERVICE","MS_MEDIA_KEYERR_UNKNOWN","Map","Math","MathMLElement","MediaCapabilities","MediaCapabilitiesInfo","MediaController","MediaDeviceInfo","MediaDevices","MediaElementAudioSourceNode","MediaEncryptedEvent","MediaError","MediaKeyError","MediaKeyEvent","MediaKeyMessageEvent","MediaKeyNeededEvent","MediaKeySession","MediaKeyStatusMap","MediaKeySystemAccess","MediaKeys","MediaList","MediaMetadata","MediaQueryList","MediaQueryListEvent","MediaRecorder","MediaRecorderErrorEvent","MediaSession","MediaSettingsRange","MediaSource","MediaStream","MediaStreamAudioDestinationNode","MediaStreamAudioSourceNode","MediaStreamEvent","MediaStreamTrack","MediaStreamTrackAudioSourceNode","MediaStreamTrackEvent","Memory","MessageChannel","MessageEvent","MessagePort","Methods","MimeType","MimeTypeArray","Module","MouseEvent","MouseScrollEvent","MozAnimation","MozAnimationDelay","MozAnimationDirection","MozAnimationDuration","MozAnimationFillMode","MozAnimationIterationCount","MozAnimationName","MozAnimationPlayState","MozAnimationTimingFunction","MozAppearance","MozBackfaceVisibility","MozBinding","MozBorderBottomColors","MozBorderEnd","MozBorderEndColor","MozBorderEndStyle","MozBorderEndWidth","MozBorderImage","MozBorderLeftColors","MozBorderRightColors","MozBorderStart","MozBorderStartColor","MozBorderStartStyle","MozBorderStartWidth","MozBorderTopColors","MozBoxAlign","MozBoxDirection","MozBoxFlex","MozBoxOrdinalGroup","MozBoxOrient","MozBoxPack","MozBoxSizing","MozCSSKeyframeRule","MozCSSKeyframesRule","MozColumnCount","MozColumnFill","MozColumnGap","MozColumnRule","MozColumnRuleColor","MozColumnRuleStyle","MozColumnRuleWidth","MozColumnWidth","MozColumns","MozContactChangeEvent","MozFloatEdge","MozFontFeatureSettings","MozFontLanguageOverride","MozForceBrokenImageIcon","MozHyphens","MozImageRegion","MozMarginEnd","MozMarginStart","MozMmsEvent","MozMmsMessage","MozMobileMessageThread","MozOSXFontSmoothing","MozOrient","MozOsxFontSmoothing","MozOutlineRadius","MozOutlineRadiusBottomleft","MozOutlineRadiusBottomright","MozOutlineRadiusTopleft","MozOutlineRadiusTopright","MozPaddingEnd","MozPaddingStart","MozPerspective","MozPerspectiveOrigin","MozPowerManager","MozSettingsEvent","MozSmsEvent","MozSmsMessage","MozStackSizing","MozTabSize","MozTextAlignLast","MozTextDecorationColor","MozTextDecorationLine","MozTextDecorationStyle","MozTextSizeAdjust","MozTransform","MozTransformOrigin","MozTransformStyle","MozTransition","MozTransitionDelay","MozTransitionDuration","MozTransitionProperty","MozTransitionTimingFunction","MozUserFocus","MozUserInput","MozUserModify","MozUserSelect","MozWindowDragging","MozWindowShadow","MutationEvent","MutationObserver","MutationRecord","NAMESPACE_ERR","NAMESPACE_RULE","NEAREST","NEAREST_MIPMAP_LINEAR","NEAREST_MIPMAP_NEAREST","NEGATIVE_INFINITY","NETWORK_EMPTY","NETWORK_ERR","NETWORK_IDLE","NETWORK_LOADED","NETWORK_LOADING","NETWORK_NO_SOURCE","NEVER","NEW","NEXT","NEXT_NO_DUPLICATE","NICEST","NODE_AFTER","NODE_BEFORE","NODE_BEFORE_AND_AFTER","NODE_INSIDE","NONE","NON_TRANSIENT_ERR","NOTATION_NODE","NOTCH","NOTEQUAL","NOT_ALLOWED_ERR","NOT_FOUND_ERR","NOT_READABLE_ERR","NOT_SUPPORTED_ERR","NO_DATA_ALLOWED_ERR","NO_ERR","NO_ERROR","NO_MODIFICATION_ALLOWED_ERR","NUMBER_TYPE","NUM_COMPRESSED_TEXTURE_FORMATS","NaN","NamedNodeMap","NavigationPreloadManager","Navigator","NearbyLinks","NetworkInformation","Node","NodeFilter","NodeIterator","NodeList","Notation","Notification","NotifyPaintEvent","Number","NumberFormat","OBJECT_TYPE","OBSOLETE","OK","ONE","ONE_MINUS_CONSTANT_ALPHA","ONE_MINUS_CONSTANT_COLOR","ONE_MINUS_DST_ALPHA","ONE_MINUS_DST_COLOR","ONE_MINUS_SRC_ALPHA","ONE_MINUS_SRC_COLOR","OPEN","OPENED","OPENING","ORDERED_NODE_ITERATOR_TYPE","ORDERED_NODE_SNAPSHOT_TYPE","OTHER_ERROR","OUT_OF_MEMORY","Object","OfflineAudioCompletionEvent","OfflineAudioContext","OfflineResourceList","OffscreenCanvas","OffscreenCanvasRenderingContext2D","Option","OrientationSensor","OscillatorNode","OverconstrainedError","OverflowEvent","PACK_ALIGNMENT","PACK_ROW_LENGTH","PACK_SKIP_PIXELS","PACK_SKIP_ROWS","PAGE_RULE","PARSE_ERR","PATHSEG_ARC_ABS","PATHSEG_ARC_REL","PATHSEG_CLOSEPATH","PATHSEG_CURVETO_CUBIC_ABS","PATHSEG_CURVETO_CUBIC_REL","PATHSEG_CURVETO_CUBIC_SMOOTH_ABS","PATHSEG_CURVETO_CUBIC_SMOOTH_REL","PATHSEG_CURVETO_QUADRATIC_ABS","PATHSEG_CURVETO_QUADRATIC_REL","PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS","PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL","PATHSEG_LINETO_ABS","PATHSEG_LINETO_HORIZONTAL_ABS","PATHSEG_LINETO_HORIZONTAL_REL","PATHSEG_LINETO_REL","PATHSEG_LINETO_VERTICAL_ABS","PATHSEG_LINETO_VERTICAL_REL","PATHSEG_MOVETO_ABS","PATHSEG_MOVETO_REL","PATHSEG_UNKNOWN","PATH_EXISTS_ERR","PEAKING","PERMISSION_DENIED","PERSISTENT","PI","PIXEL_PACK_BUFFER","PIXEL_PACK_BUFFER_BINDING","PIXEL_UNPACK_BUFFER","PIXEL_UNPACK_BUFFER_BINDING","PLAYING_STATE","POINTS","POLYGON_OFFSET_FACTOR","POLYGON_OFFSET_FILL","POLYGON_OFFSET_UNITS","POSITION_UNAVAILABLE","POSITIVE_INFINITY","PREV","PREV_NO_DUPLICATE","PROCESSING_INSTRUCTION_NODE","PageChangeEvent","PageTransitionEvent","PaintRequest","PaintRequestList","PannerNode","PasswordCredential","Path2D","PaymentAddress","PaymentInstruments","PaymentManager","PaymentMethodChangeEvent","PaymentRequest","PaymentRequestUpdateEvent","PaymentResponse","Performance","PerformanceElementTiming","PerformanceEntry","PerformanceEventTiming","PerformanceLongTaskTiming","PerformanceMark","PerformanceMeasure","PerformanceNavigation","PerformanceNavigationTiming","PerformanceObserver","PerformanceObserverEntryList","PerformancePaintTiming","PerformanceResourceTiming","PerformanceServerTiming","PerformanceTiming","PeriodicSyncManager","PeriodicWave","PermissionStatus","Permissions","PhotoCapabilities","PictureInPictureWindow","Plugin","PluginArray","PluralRules","PointerEvent","PopStateEvent","PopupBlockedEvent","Presentation","PresentationAvailability","PresentationConnection","PresentationConnectionAvailableEvent","PresentationConnectionCloseEvent","PresentationConnectionList","PresentationReceiver","PresentationRequest","ProcessingInstruction","ProgressEvent","Promise","PromiseRejectionEvent","PropertyNodeList","Proxy","PublicKeyCredential","PushManager","PushSubscription","PushSubscriptionOptions","Q","QUERY_RESULT","QUERY_RESULT_AVAILABLE","QUOTA_ERR","QUOTA_EXCEEDED_ERR","QueryInterface","R11F_G11F_B10F","R16F","R16I","R16UI","R32F","R32I","R32UI","R8","R8I","R8UI","R8_SNORM","RASTERIZER_DISCARD","READ_BUFFER","READ_FRAMEBUFFER","READ_FRAMEBUFFER_BINDING","READ_ONLY","READ_ONLY_ERR","READ_WRITE","RED","RED_BITS","RED_INTEGER","REMOVAL","RENDERBUFFER","RENDERBUFFER_ALPHA_SIZE","RENDERBUFFER_BINDING","RENDERBUFFER_BLUE_SIZE","RENDERBUFFER_DEPTH_SIZE","RENDERBUFFER_GREEN_SIZE","RENDERBUFFER_HEIGHT","RENDERBUFFER_INTERNAL_FORMAT","RENDERBUFFER_RED_SIZE","RENDERBUFFER_SAMPLES","RENDERBUFFER_STENCIL_SIZE","RENDERBUFFER_WIDTH","RENDERER","RENDERING_INTENT_ABSOLUTE_COLORIMETRIC","RENDERING_INTENT_AUTO","RENDERING_INTENT_PERCEPTUAL","RENDERING_INTENT_RELATIVE_COLORIMETRIC","RENDERING_INTENT_SATURATION","RENDERING_INTENT_UNKNOWN","REPEAT","REPLACE","RG","RG16F","RG16I","RG16UI","RG32F","RG32I","RG32UI","RG8","RG8I","RG8UI","RG8_SNORM","RGB","RGB10_A2","RGB10_A2UI","RGB16F","RGB16I","RGB16UI","RGB32F","RGB32I","RGB32UI","RGB565","RGB5_A1","RGB8","RGB8I","RGB8UI","RGB8_SNORM","RGB9_E5","RGBA","RGBA16F","RGBA16I","RGBA16UI","RGBA32F","RGBA32I","RGBA32UI","RGBA4","RGBA8","RGBA8I","RGBA8UI","RGBA8_SNORM","RGBA_INTEGER","RGBColor","RGB_INTEGER","RG_INTEGER","ROTATION_CLOCKWISE","ROTATION_COUNTERCLOCKWISE","RTCCertificate","RTCDTMFSender","RTCDTMFToneChangeEvent","RTCDataChannel","RTCDataChannelEvent","RTCDtlsTransport","RTCError","RTCErrorEvent","RTCIceCandidate","RTCIceTransport","RTCPeerConnection","RTCPeerConnectionIceErrorEvent","RTCPeerConnectionIceEvent","RTCRtpReceiver","RTCRtpSender","RTCRtpTransceiver","RTCSctpTransport","RTCSessionDescription","RTCStatsReport","RTCTrackEvent","RadioNodeList","Range","RangeError","RangeException","ReadableStream","ReadableStreamDefaultReader","RecordErrorEvent","Rect","ReferenceError","Reflect","RegExp","RelativeOrientationSensor","RelativeTimeFormat","RemotePlayback","Report","ReportBody","ReportingObserver","Request","ResizeObserver","ResizeObserverEntry","ResizeObserverSize","Response","RuntimeError","SAMPLER_2D","SAMPLER_2D_ARRAY","SAMPLER_2D_ARRAY_SHADOW","SAMPLER_2D_SHADOW","SAMPLER_3D","SAMPLER_BINDING","SAMPLER_CUBE","SAMPLER_CUBE_SHADOW","SAMPLES","SAMPLE_ALPHA_TO_COVERAGE","SAMPLE_BUFFERS","SAMPLE_COVERAGE","SAMPLE_COVERAGE_INVERT","SAMPLE_COVERAGE_VALUE","SAWTOOTH","SCHEDULED_STATE","SCISSOR_BOX","SCISSOR_TEST","SCROLL_PAGE_DOWN","SCROLL_PAGE_UP","SDP_ANSWER","SDP_OFFER","SDP_PRANSWER","SECURITY_ERR","SELECT","SEPARATE_ATTRIBS","SERIALIZE_ERR","SEVERITY_ERROR","SEVERITY_FATAL_ERROR","SEVERITY_WARNING","SHADER_COMPILER","SHADER_TYPE","SHADING_LANGUAGE_VERSION","SHIFT_MASK","SHORT","SHOWING","SHOW_ALL","SHOW_ATTRIBUTE","SHOW_CDATA_SECTION","SHOW_COMMENT","SHOW_DOCUMENT","SHOW_DOCUMENT_FRAGMENT","SHOW_DOCUMENT_TYPE","SHOW_ELEMENT","SHOW_ENTITY","SHOW_ENTITY_REFERENCE","SHOW_NOTATION","SHOW_PROCESSING_INSTRUCTION","SHOW_TEXT","SIGNALED","SIGNED_NORMALIZED","SINE","SOUNDFIELD","SQLException","SQRT1_2","SQRT2","SQUARE","SRC_ALPHA","SRC_ALPHA_SATURATE","SRC_COLOR","SRGB","SRGB8","SRGB8_ALPHA8","START_TO_END","START_TO_START","STATIC_COPY","STATIC_DRAW","STATIC_READ","STENCIL","STENCIL_ATTACHMENT","STENCIL_BACK_FAIL","STENCIL_BACK_FUNC","STENCIL_BACK_PASS_DEPTH_FAIL","STENCIL_BACK_PASS_DEPTH_PASS","STENCIL_BACK_REF","STENCIL_BACK_VALUE_MASK","STENCIL_BACK_WRITEMASK","STENCIL_BITS","STENCIL_BUFFER_BIT","STENCIL_CLEAR_VALUE","STENCIL_FAIL","STENCIL_FUNC","STENCIL_INDEX","STENCIL_INDEX8","STENCIL_PASS_DEPTH_FAIL","STENCIL_PASS_DEPTH_PASS","STENCIL_REF","STENCIL_TEST","STENCIL_VALUE_MASK","STENCIL_WRITEMASK","STREAM_COPY","STREAM_DRAW","STREAM_READ","STRING_TYPE","STYLE_RULE","SUBPIXEL_BITS","SUPPORTS_RULE","SVGAElement","SVGAltGlyphDefElement","SVGAltGlyphElement","SVGAltGlyphItemElement","SVGAngle","SVGAnimateColorElement","SVGAnimateElement","SVGAnimateMotionElement","SVGAnimateTransformElement","SVGAnimatedAngle","SVGAnimatedBoolean","SVGAnimatedEnumeration","SVGAnimatedInteger","SVGAnimatedLength","SVGAnimatedLengthList","SVGAnimatedNumber","SVGAnimatedNumberList","SVGAnimatedPreserveAspectRatio","SVGAnimatedRect","SVGAnimatedString","SVGAnimatedTransformList","SVGAnimationElement","SVGCircleElement","SVGClipPathElement","SVGColor","SVGComponentTransferFunctionElement","SVGCursorElement","SVGDefsElement","SVGDescElement","SVGDiscardElement","SVGDocument","SVGElement","SVGElementInstance","SVGElementInstanceList","SVGEllipseElement","SVGException","SVGFEBlendElement","SVGFEColorMatrixElement","SVGFEComponentTransferElement","SVGFECompositeElement","SVGFEConvolveMatrixElement","SVGFEDiffuseLightingElement","SVGFEDisplacementMapElement","SVGFEDistantLightElement","SVGFEDropShadowElement","SVGFEFloodElement","SVGFEFuncAElement","SVGFEFuncBElement","SVGFEFuncGElement","SVGFEFuncRElement","SVGFEGaussianBlurElement","SVGFEImageElement","SVGFEMergeElement","SVGFEMergeNodeElement","SVGFEMorphologyElement","SVGFEOffsetElement","SVGFEPointLightElement","SVGFESpecularLightingElement","SVGFESpotLightElement","SVGFETileElement","SVGFETurbulenceElement","SVGFilterElement","SVGFontElement","SVGFontFaceElement","SVGFontFaceFormatElement","SVGFontFaceNameElement","SVGFontFaceSrcElement","SVGFontFaceUriElement","SVGForeignObjectElement","SVGGElement","SVGGeometryElement","SVGGlyphElement","SVGGlyphRefElement","SVGGradientElement","SVGGraphicsElement","SVGHKernElement","SVGImageElement","SVGLength","SVGLengthList","SVGLineElement","SVGLinearGradientElement","SVGMPathElement","SVGMarkerElement","SVGMaskElement","SVGMatrix","SVGMetadataElement","SVGMissingGlyphElement","SVGNumber","SVGNumberList","SVGPaint","SVGPathElement","SVGPathSeg","SVGPathSegArcAbs","SVGPathSegArcRel","SVGPathSegClosePath","SVGPathSegCurvetoCubicAbs","SVGPathSegCurvetoCubicRel","SVGPathSegCurvetoCubicSmoothAbs","SVGPathSegCurvetoCubicSmoothRel","SVGPathSegCurvetoQuadraticAbs","SVGPathSegCurvetoQuadraticRel","SVGPathSegCurvetoQuadraticSmoothAbs","SVGPathSegCurvetoQuadraticSmoothRel","SVGPathSegLinetoAbs","SVGPathSegLinetoHorizontalAbs","SVGPathSegLinetoHorizontalRel","SVGPathSegLinetoRel","SVGPathSegLinetoVerticalAbs","SVGPathSegLinetoVerticalRel","SVGPathSegList","SVGPathSegMovetoAbs","SVGPathSegMovetoRel","SVGPatternElement","SVGPoint","SVGPointList","SVGPolygonElement","SVGPolylineElement","SVGPreserveAspectRatio","SVGRadialGradientElement","SVGRect","SVGRectElement","SVGRenderingIntent","SVGSVGElement","SVGScriptElement","SVGSetElement","SVGStopElement","SVGStringList","SVGStyleElement","SVGSwitchElement","SVGSymbolElement","SVGTRefElement","SVGTSpanElement","SVGTextContentElement","SVGTextElement","SVGTextPathElement","SVGTextPositioningElement","SVGTitleElement","SVGTransform","SVGTransformList","SVGUnitTypes","SVGUseElement","SVGVKernElement","SVGViewElement","SVGViewSpec","SVGZoomAndPan","SVGZoomEvent","SVG_ANGLETYPE_DEG","SVG_ANGLETYPE_GRAD","SVG_ANGLETYPE_RAD","SVG_ANGLETYPE_UNKNOWN","SVG_ANGLETYPE_UNSPECIFIED","SVG_CHANNEL_A","SVG_CHANNEL_B","SVG_CHANNEL_G","SVG_CHANNEL_R","SVG_CHANNEL_UNKNOWN","SVG_COLORTYPE_CURRENTCOLOR","SVG_COLORTYPE_RGBCOLOR","SVG_COLORTYPE_RGBCOLOR_ICCCOLOR","SVG_COLORTYPE_UNKNOWN","SVG_EDGEMODE_DUPLICATE","SVG_EDGEMODE_NONE","SVG_EDGEMODE_UNKNOWN","SVG_EDGEMODE_WRAP","SVG_FEBLEND_MODE_COLOR","SVG_FEBLEND_MODE_COLOR_BURN","SVG_FEBLEND_MODE_COLOR_DODGE","SVG_FEBLEND_MODE_DARKEN","SVG_FEBLEND_MODE_DIFFERENCE","SVG_FEBLEND_MODE_EXCLUSION","SVG_FEBLEND_MODE_HARD_LIGHT","SVG_FEBLEND_MODE_HUE","SVG_FEBLEND_MODE_LIGHTEN","SVG_FEBLEND_MODE_LUMINOSITY","SVG_FEBLEND_MODE_MULTIPLY","SVG_FEBLEND_MODE_NORMAL","SVG_FEBLEND_MODE_OVERLAY","SVG_FEBLEND_MODE_SATURATION","SVG_FEBLEND_MODE_SCREEN","SVG_FEBLEND_MODE_SOFT_LIGHT","SVG_FEBLEND_MODE_UNKNOWN","SVG_FECOLORMATRIX_TYPE_HUEROTATE","SVG_FECOLORMATRIX_TYPE_LUMINANCETOALPHA","SVG_FECOLORMATRIX_TYPE_MATRIX","SVG_FECOLORMATRIX_TYPE_SATURATE","SVG_FECOLORMATRIX_TYPE_UNKNOWN","SVG_FECOMPONENTTRANSFER_TYPE_DISCRETE","SVG_FECOMPONENTTRANSFER_TYPE_GAMMA","SVG_FECOMPONENTTRANSFER_TYPE_IDENTITY","SVG_FECOMPONENTTRANSFER_TYPE_LINEAR","SVG_FECOMPONENTTRANSFER_TYPE_TABLE","SVG_FECOMPONENTTRANSFER_TYPE_UNKNOWN","SVG_FECOMPOSITE_OPERATOR_ARITHMETIC","SVG_FECOMPOSITE_OPERATOR_ATOP","SVG_FECOMPOSITE_OPERATOR_IN","SVG_FECOMPOSITE_OPERATOR_OUT","SVG_FECOMPOSITE_OPERATOR_OVER","SVG_FECOMPOSITE_OPERATOR_UNKNOWN","SVG_FECOMPOSITE_OPERATOR_XOR","SVG_INVALID_VALUE_ERR","SVG_LENGTHTYPE_CM","SVG_LENGTHTYPE_EMS","SVG_LENGTHTYPE_EXS","SVG_LENGTHTYPE_IN","SVG_LENGTHTYPE_MM","SVG_LENGTHTYPE_NUMBER","SVG_LENGTHTYPE_PC","SVG_LENGTHTYPE_PERCENTAGE","SVG_LENGTHTYPE_PT","SVG_LENGTHTYPE_PX","SVG_LENGTHTYPE_UNKNOWN","SVG_MARKERUNITS_STROKEWIDTH","SVG_MARKERUNITS_UNKNOWN","SVG_MARKERUNITS_USERSPACEONUSE","SVG_MARKER_ORIENT_ANGLE","SVG_MARKER_ORIENT_AUTO","SVG_MARKER_ORIENT_UNKNOWN","SVG_MASKTYPE_ALPHA","SVG_MASKTYPE_LUMINANCE","SVG_MATRIX_NOT_INVERTABLE","SVG_MEETORSLICE_MEET","SVG_MEETORSLICE_SLICE","SVG_MEETORSLICE_UNKNOWN","SVG_MORPHOLOGY_OPERATOR_DILATE","SVG_MORPHOLOGY_OPERATOR_ERODE","SVG_MORPHOLOGY_OPERATOR_UNKNOWN","SVG_PAINTTYPE_CURRENTCOLOR","SVG_PAINTTYPE_NONE","SVG_PAINTTYPE_RGBCOLOR","SVG_PAINTTYPE_RGBCOLOR_ICCCOLOR","SVG_PAINTTYPE_UNKNOWN","SVG_PAINTTYPE_URI","SVG_PAINTTYPE_URI_CURRENTCOLOR","SVG_PAINTTYPE_URI_NONE","SVG_PAINTTYPE_URI_RGBCOLOR","SVG_PAINTTYPE_URI_RGBCOLOR_ICCCOLOR","SVG_PRESERVEASPECTRATIO_NONE","SVG_PRESERVEASPECTRATIO_UNKNOWN","SVG_PRESERVEASPECTRATIO_XMAXYMAX","SVG_PRESERVEASPECTRATIO_XMAXYMID","SVG_PRESERVEASPECTRATIO_XMAXYMIN","SVG_PRESERVEASPECTRATIO_XMIDYMAX","SVG_PRESERVEASPECTRATIO_XMIDYMID","SVG_PRESERVEASPECTRATIO_XMIDYMIN","SVG_PRESERVEASPECTRATIO_XMINYMAX","SVG_PRESERVEASPECTRATIO_XMINYMID","SVG_PRESERVEASPECTRATIO_XMINYMIN","SVG_SPREADMETHOD_PAD","SVG_SPREADMETHOD_REFLECT","SVG_SPREADMETHOD_REPEAT","SVG_SPREADMETHOD_UNKNOWN","SVG_STITCHTYPE_NOSTITCH","SVG_STITCHTYPE_STITCH","SVG_STITCHTYPE_UNKNOWN","SVG_TRANSFORM_MATRIX","SVG_TRANSFORM_ROTATE","SVG_TRANSFORM_SCALE","SVG_TRANSFORM_SKEWX","SVG_TRANSFORM_SKEWY","SVG_TRANSFORM_TRANSLATE","SVG_TRANSFORM_UNKNOWN","SVG_TURBULENCE_TYPE_FRACTALNOISE","SVG_TURBULENCE_TYPE_TURBULENCE","SVG_TURBULENCE_TYPE_UNKNOWN","SVG_UNIT_TYPE_OBJECTBOUNDINGBOX","SVG_UNIT_TYPE_UNKNOWN","SVG_UNIT_TYPE_USERSPACEONUSE","SVG_WRONG_TYPE_ERR","SVG_ZOOMANDPAN_DISABLE","SVG_ZOOMANDPAN_MAGNIFY","SVG_ZOOMANDPAN_UNKNOWN","SYNC_CONDITION","SYNC_FENCE","SYNC_FLAGS","SYNC_FLUSH_COMMANDS_BIT","SYNC_GPU_COMMANDS_COMPLETE","SYNC_STATUS","SYNTAX_ERR","SavedPages","Screen","ScreenOrientation","Script","ScriptProcessorNode","ScrollAreaEvent","SecurityPolicyViolationEvent","Selection","Sensor","SensorErrorEvent","ServiceWorker","ServiceWorkerContainer","ServiceWorkerRegistration","SessionDescription","Set","ShadowRoot","SharedArrayBuffer","SharedWorker","SimpleGestureEvent","SourceBuffer","SourceBufferList","SpeechSynthesis","SpeechSynthesisErrorEvent","SpeechSynthesisEvent","SpeechSynthesisUtterance","SpeechSynthesisVoice","StaticRange","StereoPannerNode","StopIteration","Storage","StorageEvent","StorageManager","String","StructType","StylePropertyMap","StylePropertyMapReadOnly","StyleSheet","StyleSheetList","SubmitEvent","SubtleCrypto","Symbol","SyncManager","SyntaxError","TEMPORARY","TEXTPATH_METHODTYPE_ALIGN","TEXTPATH_METHODTYPE_STRETCH","TEXTPATH_METHODTYPE_UNKNOWN","TEXTPATH_SPACINGTYPE_AUTO","TEXTPATH_SPACINGTYPE_EXACT","TEXTPATH_SPACINGTYPE_UNKNOWN","TEXTURE","TEXTURE0","TEXTURE1","TEXTURE10","TEXTURE11","TEXTURE12","TEXTURE13","TEXTURE14","TEXTURE15","TEXTURE16","TEXTURE17","TEXTURE18","TEXTURE19","TEXTURE2","TEXTURE20","TEXTURE21","TEXTURE22","TEXTURE23","TEXTURE24","TEXTURE25","TEXTURE26","TEXTURE27","TEXTURE28","TEXTURE29","TEXTURE3","TEXTURE30","TEXTURE31","TEXTURE4","TEXTURE5","TEXTURE6","TEXTURE7","TEXTURE8","TEXTURE9","TEXTURE_2D","TEXTURE_2D_ARRAY","TEXTURE_3D","TEXTURE_BASE_LEVEL","TEXTURE_BINDING_2D","TEXTURE_BINDING_2D_ARRAY","TEXTURE_BINDING_3D","TEXTURE_BINDING_CUBE_MAP","TEXTURE_COMPARE_FUNC","TEXTURE_COMPARE_MODE","TEXTURE_CUBE_MAP","TEXTURE_CUBE_MAP_NEGATIVE_X","TEXTURE_CUBE_MAP_NEGATIVE_Y","TEXTURE_CUBE_MAP_NEGATIVE_Z","TEXTURE_CUBE_MAP_POSITIVE_X","TEXTURE_CUBE_MAP_POSITIVE_Y","TEXTURE_CUBE_MAP_POSITIVE_Z","TEXTURE_IMMUTABLE_FORMAT","TEXTURE_IMMUTABLE_LEVELS","TEXTURE_MAG_FILTER","TEXTURE_MAX_ANISOTROPY_EXT","TEXTURE_MAX_LEVEL","TEXTURE_MAX_LOD","TEXTURE_MIN_FILTER","TEXTURE_MIN_LOD","TEXTURE_WRAP_R","TEXTURE_WRAP_S","TEXTURE_WRAP_T","TEXT_NODE","TIMEOUT","TIMEOUT_ERR","TIMEOUT_EXPIRED","TIMEOUT_IGNORED","TOO_LARGE_ERR","TRANSACTION_INACTIVE_ERR","TRANSFORM_FEEDBACK","TRANSFORM_FEEDBACK_ACTIVE","TRANSFORM_FEEDBACK_BINDING","TRANSFORM_FEEDBACK_BUFFER","TRANSFORM_FEEDBACK_BUFFER_BINDING","TRANSFORM_FEEDBACK_BUFFER_MODE","TRANSFORM_FEEDBACK_BUFFER_SIZE","TRANSFORM_FEEDBACK_BUFFER_START","TRANSFORM_FEEDBACK_PAUSED","TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN","TRANSFORM_FEEDBACK_VARYINGS","TRIANGLE","TRIANGLES","TRIANGLE_FAN","TRIANGLE_STRIP","TYPE_BACK_FORWARD","TYPE_ERR","TYPE_MISMATCH_ERR","TYPE_NAVIGATE","TYPE_RELOAD","TYPE_RESERVED","Table","TaskAttributionTiming","Text","TextDecoder","TextDecoderStream","TextEncoder","TextEncoderStream","TextEvent","TextMetrics","TextTrack","TextTrackCue","TextTrackCueList","TextTrackList","TimeEvent","TimeRanges","Touch","TouchEvent","TouchList","TrackEvent","TransformStream","TransitionEvent","TreeWalker","TrustedHTML","TrustedScript","TrustedScriptURL","TrustedTypePolicy","TrustedTypePolicyFactory","TypeError","TypedObject","U2F","UIEvent","UNCACHED","UNIFORM_ARRAY_STRIDE","UNIFORM_BLOCK_ACTIVE_UNIFORMS","UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES","UNIFORM_BLOCK_BINDING","UNIFORM_BLOCK_DATA_SIZE","UNIFORM_BLOCK_INDEX","UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER","UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER","UNIFORM_BUFFER","UNIFORM_BUFFER_BINDING","UNIFORM_BUFFER_OFFSET_ALIGNMENT","UNIFORM_BUFFER_SIZE","UNIFORM_BUFFER_START","UNIFORM_IS_ROW_MAJOR","UNIFORM_MATRIX_STRIDE","UNIFORM_OFFSET","UNIFORM_SIZE","UNIFORM_TYPE","UNKNOWN_ERR","UNKNOWN_RULE","UNMASKED_RENDERER_WEBGL","UNMASKED_VENDOR_WEBGL","UNORDERED_NODE_ITERATOR_TYPE","UNORDERED_NODE_SNAPSHOT_TYPE","UNPACK_ALIGNMENT","UNPACK_COLORSPACE_CONVERSION_WEBGL","UNPACK_FLIP_Y_WEBGL","UNPACK_IMAGE_HEIGHT","UNPACK_PREMULTIPLY_ALPHA_WEBGL","UNPACK_ROW_LENGTH","UNPACK_SKIP_IMAGES","UNPACK_SKIP_PIXELS","UNPACK_SKIP_ROWS","UNSCHEDULED_STATE","UNSENT","UNSIGNALED","UNSIGNED_BYTE","UNSIGNED_INT","UNSIGNED_INT_10F_11F_11F_REV","UNSIGNED_INT_24_8","UNSIGNED_INT_2_10_10_10_REV","UNSIGNED_INT_5_9_9_9_REV","UNSIGNED_INT_SAMPLER_2D","UNSIGNED_INT_SAMPLER_2D_ARRAY","UNSIGNED_INT_SAMPLER_3D","UNSIGNED_INT_SAMPLER_CUBE","UNSIGNED_INT_VEC2","UNSIGNED_INT_VEC3","UNSIGNED_INT_VEC4","UNSIGNED_NORMALIZED","UNSIGNED_SHORT","UNSIGNED_SHORT_4_4_4_4","UNSIGNED_SHORT_5_5_5_1","UNSIGNED_SHORT_5_6_5","UNSPECIFIED_EVENT_TYPE_ERR","UPDATEREADY","URIError","URL","URLSearchParams","URLUnencoded","URL_MISMATCH_ERR","USB","USBAlternateInterface","USBConfiguration","USBConnectionEvent","USBDevice","USBEndpoint","USBInTransferResult","USBInterface","USBIsochronousInTransferPacket","USBIsochronousInTransferResult","USBIsochronousOutTransferPacket","USBIsochronousOutTransferResult","USBOutTransferResult","UTC","Uint16Array","Uint32Array","Uint8Array","Uint8ClampedArray","UserActivation","UserMessageHandler","UserMessageHandlersNamespace","UserProximityEvent","VALIDATE_STATUS","VALIDATION_ERR","VARIABLES_RULE","VENDOR","VERSION","VERSION_CHANGE","VERSION_ERR","VERTEX_ARRAY_BINDING","VERTEX_ATTRIB_ARRAY_BUFFER_BINDING","VERTEX_ATTRIB_ARRAY_DIVISOR","VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE","VERTEX_ATTRIB_ARRAY_ENABLED","VERTEX_ATTRIB_ARRAY_INTEGER","VERTEX_ATTRIB_ARRAY_NORMALIZED","VERTEX_ATTRIB_ARRAY_POINTER","VERTEX_ATTRIB_ARRAY_SIZE","VERTEX_ATTRIB_ARRAY_STRIDE","VERTEX_ATTRIB_ARRAY_TYPE","VERTEX_SHADER","VERTICAL","VERTICAL_AXIS","VER_ERR","VIEWPORT","VIEWPORT_RULE","VRDisplay","VRDisplayCapabilities","VRDisplayEvent","VREyeParameters","VRFieldOfView","VRFrameData","VRPose","VRStageParameters","VTTCue","VTTRegion","ValidityState","VideoPlaybackQuality","VideoStreamTrack","VisualViewport","WAIT_FAILED","WEBKIT_FILTER_RULE","WEBKIT_KEYFRAMES_RULE","WEBKIT_KEYFRAME_RULE","WEBKIT_REGION_RULE","WRONG_DOCUMENT_ERR","WakeLock","WakeLockSentinel","WasmAnyRef","WaveShaperNode","WeakMap","WeakRef","WeakSet","WebAssembly","WebGL2RenderingContext","WebGLActiveInfo","WebGLBuffer","WebGLContextEvent","WebGLFramebuffer","WebGLProgram","WebGLQuery","WebGLRenderbuffer","WebGLRenderingContext","WebGLSampler","WebGLShader","WebGLShaderPrecisionFormat","WebGLSync","WebGLTexture","WebGLTransformFeedback","WebGLUniformLocation","WebGLVertexArray","WebGLVertexArrayObject","WebKitAnimationEvent","WebKitBlobBuilder","WebKitCSSFilterRule","WebKitCSSFilterValue","WebKitCSSKeyframeRule","WebKitCSSKeyframesRule","WebKitCSSMatrix","WebKitCSSRegionRule","WebKitCSSTransformValue","WebKitDataCue","WebKitGamepad","WebKitMediaKeyError","WebKitMediaKeyMessageEvent","WebKitMediaKeySession","WebKitMediaKeys","WebKitMediaSource","WebKitMutationObserver","WebKitNamespace","WebKitPlaybackTargetAvailabilityEvent","WebKitPoint","WebKitShadowRoot","WebKitSourceBuffer","WebKitSourceBufferList","WebKitTransitionEvent","WebSocket","WebkitAlignContent","WebkitAlignItems","WebkitAlignSelf","WebkitAnimation","WebkitAnimationDelay","WebkitAnimationDirection","WebkitAnimationDuration","WebkitAnimationFillMode","WebkitAnimationIterationCount","WebkitAnimationName","WebkitAnimationPlayState","WebkitAnimationTimingFunction","WebkitAppearance","WebkitBackfaceVisibility","WebkitBackgroundClip","WebkitBackgroundOrigin","WebkitBackgroundSize","WebkitBorderBottomLeftRadius","WebkitBorderBottomRightRadius","WebkitBorderImage","WebkitBorderRadius","WebkitBorderTopLeftRadius","WebkitBorderTopRightRadius","WebkitBoxAlign","WebkitBoxDirection","WebkitBoxFlex","WebkitBoxOrdinalGroup","WebkitBoxOrient","WebkitBoxPack","WebkitBoxShadow","WebkitBoxSizing","WebkitFilter","WebkitFlex","WebkitFlexBasis","WebkitFlexDirection","WebkitFlexFlow","WebkitFlexGrow","WebkitFlexShrink","WebkitFlexWrap","WebkitJustifyContent","WebkitLineClamp","WebkitMask","WebkitMaskClip","WebkitMaskComposite","WebkitMaskImage","WebkitMaskOrigin","WebkitMaskPosition","WebkitMaskPositionX","WebkitMaskPositionY","WebkitMaskRepeat","WebkitMaskSize","WebkitOrder","WebkitPerspective","WebkitPerspectiveOrigin","WebkitTextFillColor","WebkitTextSizeAdjust","WebkitTextStroke","WebkitTextStrokeColor","WebkitTextStrokeWidth","WebkitTransform","WebkitTransformOrigin","WebkitTransformStyle","WebkitTransition","WebkitTransitionDelay","WebkitTransitionDuration","WebkitTransitionProperty","WebkitTransitionTimingFunction","WebkitUserSelect","WheelEvent","Window","Worker","Worklet","WritableStream","WritableStreamDefaultWriter","XMLDocument","XMLHttpRequest","XMLHttpRequestEventTarget","XMLHttpRequestException","XMLHttpRequestProgressEvent","XMLHttpRequestUpload","XMLSerializer","XMLStylesheetProcessingInstruction","XPathEvaluator","XPathException","XPathExpression","XPathNSResolver","XPathResult","XRBoundedReferenceSpace","XRDOMOverlayState","XRFrame","XRHitTestResult","XRHitTestSource","XRInputSource","XRInputSourceArray","XRInputSourceEvent","XRInputSourcesChangeEvent","XRLayer","XRPose","XRRay","XRReferenceSpace","XRReferenceSpaceEvent","XRRenderState","XRRigidTransform","XRSession","XRSessionEvent","XRSpace","XRSystem","XRTransientInputHitTestResult","XRTransientInputHitTestSource","XRView","XRViewerPose","XRViewport","XRWebGLLayer","XSLTProcessor","ZERO","_XD0M_","_YD0M_","__defineGetter__","__defineSetter__","__lookupGetter__","__lookupSetter__","__opera","__proto__","_browserjsran","a","aLink","abbr","abort","aborted","abs","absolute","acceleration","accelerationIncludingGravity","accelerator","accept","acceptCharset","acceptNode","accessKey","accessKeyLabel","accuracy","acos","acosh","action","actionURL","actions","activated","active","activeCues","activeElement","activeSourceBuffers","activeSourceCount","activeTexture","activeVRDisplays","actualBoundingBoxAscent","actualBoundingBoxDescent","actualBoundingBoxLeft","actualBoundingBoxRight","add","addAll","addBehavior","addCandidate","addColorStop","addCue","addElement","addEventListener","addFilter","addFromString","addFromUri","addIceCandidate","addImport","addListener","addModule","addNamed","addPageRule","addPath","addPointer","addRange","addRegion","addRule","addSearchEngine","addSourceBuffer","addStream","addTextTrack","addTrack","addTransceiver","addWakeLockListener","added","addedNodes","additionalName","additiveSymbols","addons","address","addressLine","adoptNode","adoptedStyleSheets","adr","advance","after","album","alert","algorithm","align","align-content","align-items","align-self","alignContent","alignItems","alignSelf","alignmentBaseline","alinkColor","all","allSettled","allow","allowFullscreen","allowPaymentRequest","allowedDirections","allowedFeatures","allowedToPlay","allowsFeature","alpha","alt","altGraphKey","altHtml","altKey","altLeft","alternate","alternateSetting","alternates","altitude","altitudeAccuracy","amplitude","ancestorOrigins","anchor","anchorNode","anchorOffset","anchors","and","angle","angularAcceleration","angularVelocity","animVal","animate","animatedInstanceRoot","animatedNormalizedPathSegList","animatedPathSegList","animatedPoints","animation","animation-delay","animation-direction","animation-duration","animation-fill-mode","animation-iteration-count","animation-name","animation-play-state","animation-timing-function","animationDelay","animationDirection","animationDuration","animationFillMode","animationIterationCount","animationName","animationPlayState","animationStartTime","animationTimingFunction","animationsPaused","anniversary","antialias","anticipatedRemoval","any","app","appCodeName","appMinorVersion","appName","appNotifications","appVersion","appearance","append","appendBuffer","appendChild","appendData","appendItem","appendMedium","appendNamed","appendRule","appendStream","appendWindowEnd","appendWindowStart","applets","applicationCache","applicationServerKey","apply","applyConstraints","applyElement","arc","arcTo","archive","areas","arguments","ariaAtomic","ariaAutoComplete","ariaBusy","ariaChecked","ariaColCount","ariaColIndex","ariaColSpan","ariaCurrent","ariaDescription","ariaDisabled","ariaExpanded","ariaHasPopup","ariaHidden","ariaKeyShortcuts","ariaLabel","ariaLevel","ariaLive","ariaModal","ariaMultiLine","ariaMultiSelectable","ariaOrientation","ariaPlaceholder","ariaPosInSet","ariaPressed","ariaReadOnly","ariaRelevant","ariaRequired","ariaRoleDescription","ariaRowCount","ariaRowIndex","ariaRowSpan","ariaSelected","ariaSetSize","ariaSort","ariaValueMax","ariaValueMin","ariaValueNow","ariaValueText","arrayBuffer","artist","artwork","as","asIntN","asUintN","asin","asinh","assert","assign","assignedElements","assignedNodes","assignedSlot","async","asyncIterator","atEnd","atan","atan2","atanh","atob","attachEvent","attachInternals","attachShader","attachShadow","attachments","attack","attestationObject","attrChange","attrName","attributeFilter","attributeName","attributeNamespace","attributeOldValue","attributeStyleMap","attributes","attribution","audioBitsPerSecond","audioTracks","audioWorklet","authenticatedSignedWrites","authenticatorData","autoIncrement","autobuffer","autocapitalize","autocomplete","autocorrect","autofocus","automationRate","autoplay","availHeight","availLeft","availTop","availWidth","availability","available","aversion","ax","axes","axis","ay","azimuth","b","back","backface-visibility","backfaceVisibility","background","background-attachment","background-blend-mode","background-clip","background-color","background-image","background-origin","background-position","background-position-x","background-position-y","background-repeat","background-size","backgroundAttachment","backgroundBlendMode","backgroundClip","backgroundColor","backgroundFetch","backgroundImage","backgroundOrigin","backgroundPosition","backgroundPositionX","backgroundPositionY","backgroundRepeat","backgroundSize","badInput","badge","balance","baseFrequencyX","baseFrequencyY","baseLatency","baseLayer","baseNode","baseOffset","baseURI","baseVal","baselineShift","battery","bday","before","beginElement","beginElementAt","beginPath","beginQuery","beginTransformFeedback","behavior","behaviorCookie","behaviorPart","behaviorUrns","beta","bezierCurveTo","bgColor","bgProperties","bias","big","bigint64","biguint64","binaryType","bind","bindAttribLocation","bindBuffer","bindBufferBase","bindBufferRange","bindFramebuffer","bindRenderbuffer","bindSampler","bindTexture","bindTransformFeedback","bindVertexArray","blendColor","blendEquation","blendEquationSeparate","blendFunc","blendFuncSeparate","blink","blitFramebuffer","blob","block-size","blockDirection","blockSize","blockedURI","blue","bluetooth","blur","body","bodyUsed","bold","bookmarks","booleanValue","border","border-block","border-block-color","border-block-end","border-block-end-color","border-block-end-style","border-block-end-width","border-block-start","border-block-start-color","border-block-start-style","border-block-start-width","border-block-style","border-block-width","border-bottom","border-bottom-color","border-bottom-left-radius","border-bottom-right-radius","border-bottom-style","border-bottom-width","border-collapse","border-color","border-end-end-radius","border-end-start-radius","border-image","border-image-outset","border-image-repeat","border-image-slice","border-image-source","border-image-width","border-inline","border-inline-color","border-inline-end","border-inline-end-color","border-inline-end-style","border-inline-end-width","border-inline-start","border-inline-start-color","border-inline-start-style","border-inline-start-width","border-inline-style","border-inline-width","border-left","border-left-color","border-left-style","border-left-width","border-radius","border-right","border-right-color","border-right-style","border-right-width","border-spacing","border-start-end-radius","border-start-start-radius","border-style","border-top","border-top-color","border-top-left-radius","border-top-right-radius","border-top-style","border-top-width","border-width","borderBlock","borderBlockColor","borderBlockEnd","borderBlockEndColor","borderBlockEndStyle","borderBlockEndWidth","borderBlockStart","borderBlockStartColor","borderBlockStartStyle","borderBlockStartWidth","borderBlockStyle","borderBlockWidth","borderBottom","borderBottomColor","borderBottomLeftRadius","borderBottomRightRadius","borderBottomStyle","borderBottomWidth","borderBoxSize","borderCollapse","borderColor","borderColorDark","borderColorLight","borderEndEndRadius","borderEndStartRadius","borderImage","borderImageOutset","borderImageRepeat","borderImageSlice","borderImageSource","borderImageWidth","borderInline","borderInlineColor","borderInlineEnd","borderInlineEndColor","borderInlineEndStyle","borderInlineEndWidth","borderInlineStart","borderInlineStartColor","borderInlineStartStyle","borderInlineStartWidth","borderInlineStyle","borderInlineWidth","borderLeft","borderLeftColor","borderLeftStyle","borderLeftWidth","borderRadius","borderRight","borderRightColor","borderRightStyle","borderRightWidth","borderSpacing","borderStartEndRadius","borderStartStartRadius","borderStyle","borderTop","borderTopColor","borderTopLeftRadius","borderTopRightRadius","borderTopStyle","borderTopWidth","borderWidth","bottom","bottomMargin","bound","boundElements","boundingClientRect","boundingHeight","boundingLeft","boundingTop","boundingWidth","bounds","boundsGeometry","box-decoration-break","box-shadow","box-sizing","boxDecorationBreak","boxShadow","boxSizing","break-after","break-before","break-inside","breakAfter","breakBefore","breakInside","broadcast","browserLanguage","btoa","bubbles","buffer","bufferData","bufferDepth","bufferSize","bufferSubData","buffered","bufferedAmount","bufferedAmountLowThreshold","buildID","buildNumber","button","buttonID","buttons","byteLength","byteOffset","bytesWritten","c","cache","caches","call","caller","canBeFormatted","canBeMounted","canBeShared","canHaveChildren","canHaveHTML","canInsertDTMF","canMakePayment","canPlayType","canPresent","canTrickleIceCandidates","cancel","cancelAndHoldAtTime","cancelAnimationFrame","cancelBubble","cancelIdleCallback","cancelScheduledValues","cancelVideoFrameCallback","cancelWatchAvailability","cancelable","candidate","canonicalUUID","canvas","capabilities","caption","caption-side","captionSide","capture","captureEvents","captureStackTrace","captureStream","caret-color","caretBidiLevel","caretColor","caretPositionFromPoint","caretRangeFromPoint","cast","catch","category","cbrt","cd","ceil","cellIndex","cellPadding","cellSpacing","cells","ch","chOff","chain","challenge","changeType","changedTouches","channel","channelCount","channelCountMode","channelInterpretation","char","charAt","charCode","charCodeAt","charIndex","charLength","characterData","characterDataOldValue","characterSet","characteristic","charging","chargingTime","charset","check","checkEnclosure","checkFramebufferStatus","checkIntersection","checkValidity","checked","childElementCount","childList","childNodes","children","chrome","ciphertext","cite","city","claimInterface","claimed","classList","className","classid","clear","clearAppBadge","clearAttributes","clearBufferfi","clearBufferfv","clearBufferiv","clearBufferuiv","clearColor","clearData","clearDepth","clearHalt","clearImmediate","clearInterval","clearLiveSeekableRange","clearMarks","clearMaxGCPauseAccumulator","clearMeasures","clearParameters","clearRect","clearResourceTimings","clearShadow","clearStencil","clearTimeout","clearWatch","click","clickCount","clientDataJSON","clientHeight","clientInformation","clientLeft","clientRect","clientRects","clientTop","clientWaitSync","clientWidth","clientX","clientY","clip","clip-path","clip-rule","clipBottom","clipLeft","clipPath","clipPathUnits","clipRight","clipRule","clipTop","clipboard","clipboardData","clone","cloneContents","cloneNode","cloneRange","close","closePath","closed","closest","clz","clz32","cm","cmp","code","codeBase","codePointAt","codeType","colSpan","collapse","collapseToEnd","collapseToStart","collapsed","collect","colno","color","color-adjust","color-interpolation","color-interpolation-filters","colorAdjust","colorDepth","colorInterpolation","colorInterpolationFilters","colorMask","colorType","cols","column-count","column-fill","column-gap","column-rule","column-rule-color","column-rule-style","column-rule-width","column-span","column-width","columnCount","columnFill","columnGap","columnNumber","columnRule","columnRuleColor","columnRuleStyle","columnRuleWidth","columnSpan","columnWidth","columns","command","commit","commitPreferences","commitStyles","commonAncestorContainer","compact","compareBoundaryPoints","compareDocumentPosition","compareEndPoints","compareExchange","compareNode","comparePoint","compatMode","compatible","compile","compileShader","compileStreaming","complete","component","componentFromPoint","composed","composedPath","composite","compositionEndOffset","compositionStartOffset","compressedTexImage2D","compressedTexImage3D","compressedTexSubImage2D","compressedTexSubImage3D","computedStyleMap","concat","conditionText","coneInnerAngle","coneOuterAngle","coneOuterGain","configuration","configurationName","configurationValue","configurations","confirm","confirmComposition","confirmSiteSpecificTrackingException","confirmWebWideTrackingException","connect","connectEnd","connectShark","connectStart","connected","connection","connectionList","connectionSpeed","connectionState","connections","console","consolidate","constraint","constrictionActive","construct","constructor","contactID","contain","containerId","containerName","containerSrc","containerType","contains","containsNode","content","contentBoxSize","contentDocument","contentEditable","contentHint","contentOverflow","contentRect","contentScriptType","contentStyleType","contentType","contentWindow","context","contextMenu","contextmenu","continue","continuePrimaryKey","continuous","control","controlTransferIn","controlTransferOut","controller","controls","controlsList","convertPointFromNode","convertQuadFromNode","convertRectFromNode","convertToBlob","convertToSpecifiedUnits","cookie","cookieEnabled","coords","copyBufferSubData","copyFromChannel","copyTexImage2D","copyTexSubImage2D","copyTexSubImage3D","copyToChannel","copyWithin","correspondingElement","correspondingUseElement","corruptedVideoFrames","cos","cosh","count","countReset","counter-increment","counter-reset","counter-set","counterIncrement","counterReset","counterSet","country","cpuClass","cpuSleepAllowed","create","createAnalyser","createAnswer","createAttribute","createAttributeNS","createBiquadFilter","createBuffer","createBufferSource","createCDATASection","createCSSStyleSheet","createCaption","createChannelMerger","createChannelSplitter","createComment","createConstantSource","createContextualFragment","createControlRange","createConvolver","createDTMFSender","createDataChannel","createDelay","createDelayNode","createDocument","createDocumentFragment","createDocumentType","createDynamicsCompressor","createElement","createElementNS","createEntityReference","createEvent","createEventObject","createExpression","createFramebuffer","createFunction","createGain","createGainNode","createHTML","createHTMLDocument","createIIRFilter","createImageBitmap","createImageData","createIndex","createJavaScriptNode","createLinearGradient","createMediaElementSource","createMediaKeys","createMediaStreamDestination","createMediaStreamSource","createMediaStreamTrackSource","createMutableFile","createNSResolver","createNodeIterator","createNotification","createObjectStore","createObjectURL","createOffer","createOscillator","createPanner","createPattern","createPeriodicWave","createPolicy","createPopup","createProcessingInstruction","createProgram","createQuery","createRadialGradient","createRange","createRangeCollection","createReader","createRenderbuffer","createSVGAngle","createSVGLength","createSVGMatrix","createSVGNumber","createSVGPathSegArcAbs","createSVGPathSegArcRel","createSVGPathSegClosePath","createSVGPathSegCurvetoCubicAbs","createSVGPathSegCurvetoCubicRel","createSVGPathSegCurvetoCubicSmoothAbs","createSVGPathSegCurvetoCubicSmoothRel","createSVGPathSegCurvetoQuadraticAbs","createSVGPathSegCurvetoQuadraticRel","createSVGPathSegCurvetoQuadraticSmoothAbs","createSVGPathSegCurvetoQuadraticSmoothRel","createSVGPathSegLinetoAbs","createSVGPathSegLinetoHorizontalAbs","createSVGPathSegLinetoHorizontalRel","createSVGPathSegLinetoRel","createSVGPathSegLinetoVerticalAbs","createSVGPathSegLinetoVerticalRel","createSVGPathSegMovetoAbs","createSVGPathSegMovetoRel","createSVGPoint","createSVGRect","createSVGTransform","createSVGTransformFromMatrix","createSampler","createScript","createScriptProcessor","createScriptURL","createSession","createShader","createShadowRoot","createStereoPanner","createStyleSheet","createTBody","createTFoot","createTHead","createTextNode","createTextRange","createTexture","createTouch","createTouchList","createTransformFeedback","createTreeWalker","createVertexArray","createWaveShaper","creationTime","credentials","crossOrigin","crossOriginIsolated","crypto","csi","csp","cssFloat","cssRules","cssText","cssValueType","ctrlKey","ctrlLeft","cues","cullFace","currentDirection","currentLocalDescription","currentNode","currentPage","currentRect","currentRemoteDescription","currentScale","currentScript","currentSrc","currentState","currentStyle","currentTarget","currentTime","currentTranslate","currentView","cursor","curve","customElements","customError","cx","cy","d","data","dataFld","dataFormatAs","dataLoss","dataLossMessage","dataPageSize","dataSrc","dataTransfer","database","databases","dataset","dateTime","db","debug","debuggerEnabled","declare","decode","decodeAudioData","decodeURI","decodeURIComponent","decodedBodySize","decoding","decodingInfo","decrypt","default","defaultCharset","defaultChecked","defaultMuted","defaultPlaybackRate","defaultPolicy","defaultPrevented","defaultRequest","defaultSelected","defaultStatus","defaultURL","defaultValue","defaultView","defaultstatus","defer","define","defineMagicFunction","defineMagicVariable","defineProperties","defineProperty","deg","delay","delayTime","delegatesFocus","delete","deleteBuffer","deleteCaption","deleteCell","deleteContents","deleteData","deleteDatabase","deleteFramebuffer","deleteFromDocument","deleteIndex","deleteMedium","deleteObjectStore","deleteProgram","deleteProperty","deleteQuery","deleteRenderbuffer","deleteRow","deleteRule","deleteSampler","deleteShader","deleteSync","deleteTFoot","deleteTHead","deleteTexture","deleteTransformFeedback","deleteVertexArray","deliverChangeRecords","delivery","deliveryInfo","deliveryStatus","deliveryTimestamp","delta","deltaMode","deltaX","deltaY","deltaZ","dependentLocality","depthFar","depthFunc","depthMask","depthNear","depthRange","deref","deriveBits","deriveKey","description","deselectAll","designMode","desiredSize","destination","destinationURL","detach","detachEvent","detachShader","detail","details","detect","detune","device","deviceClass","deviceId","deviceMemory","devicePixelContentBoxSize","devicePixelRatio","deviceProtocol","deviceSubclass","deviceVersionMajor","deviceVersionMinor","deviceVersionSubminor","deviceXDPI","deviceYDPI","didTimeout","diffuseConstant","digest","dimensions","dir","dirName","direction","dirxml","disable","disablePictureInPicture","disableRemotePlayback","disableVertexAttribArray","disabled","dischargingTime","disconnect","disconnectShark","dispatchEvent","display","displayId","displayName","disposition","distanceModel","div","divisor","djsapi","djsproxy","doImport","doNotTrack","doScroll","doctype","document","documentElement","documentMode","documentURI","dolphin","dolphinGameCenter","dolphininfo","dolphinmeta","domComplete","domContentLoadedEventEnd","domContentLoadedEventStart","domInteractive","domLoading","domOverlayState","domain","domainLookupEnd","domainLookupStart","dominant-baseline","dominantBaseline","done","dopplerFactor","dotAll","downDegrees","downlink","download","downloadTotal","downloaded","dpcm","dpi","dppx","dragDrop","draggable","drawArrays","drawArraysInstanced","drawArraysInstancedANGLE","drawBuffers","drawCustomFocusRing","drawElements","drawElementsInstanced","drawElementsInstancedANGLE","drawFocusIfNeeded","drawImage","drawImageFromRect","drawRangeElements","drawSystemFocusRing","drawingBufferHeight","drawingBufferWidth","dropEffect","droppedVideoFrames","dropzone","dtmf","dump","dumpProfile","duplicate","durability","duration","dvname","dvnum","dx","dy","dynsrc","e","edgeMode","effect","effectAllowed","effectiveDirective","effectiveType","elapsedTime","element","elementFromPoint","elementTiming","elements","elementsFromPoint","elevation","ellipse","em","email","embeds","emma","empty","empty-cells","emptyCells","emptyHTML","emptyScript","emulatedPosition","enable","enableBackground","enableDelegations","enableStyleSheetsForSet","enableVertexAttribArray","enabled","enabledPlugin","encode","encodeInto","encodeURI","encodeURIComponent","encodedBodySize","encoding","encodingInfo","encrypt","enctype","end","endContainer","endElement","endElementAt","endOfStream","endOffset","endQuery","endTime","endTransformFeedback","ended","endpoint","endpointNumber","endpoints","endsWith","enterKeyHint","entities","entries","entryType","enumerate","enumerateDevices","enumerateEditable","environmentBlendMode","equals","error","errorCode","errorDetail","errorText","escape","estimate","eval","evaluate","event","eventPhase","every","ex","exception","exchange","exec","execCommand","execCommandShowHelp","execScript","exitFullscreen","exitPictureInPicture","exitPointerLock","exitPresent","exp","expand","expandEntityReferences","expando","expansion","expiration","expirationTime","expires","expiryDate","explicitOriginalTarget","expm1","exponent","exponentialRampToValueAtTime","exportKey","extend","extensions","extentNode","extentOffset","external","externalResourcesRequired","extractContents","extractable","eye","f","face","factoryReset","failureReason","fallback","family","familyName","farthestViewportElement","fastSeek","fatal","featureId","featurePolicy","featureSettings","features","fenceSync","fetch","fetchStart","fftSize","fgColor","fieldOfView","file","fileCreatedDate","fileHandle","fileModifiedDate","fileName","fileSize","fileUpdatedDate","filename","files","filesystem","fill","fill-opacity","fill-rule","fillLightMode","fillOpacity","fillRect","fillRule","fillStyle","fillText","filter","filterResX","filterResY","filterUnits","filters","finally","find","findIndex","findRule","findText","finish","finished","fireEvent","firesTouchEvents","firstChild","firstElementChild","firstPage","fixed","flags","flat","flatMap","flex","flex-basis","flex-direction","flex-flow","flex-grow","flex-shrink","flex-wrap","flexBasis","flexDirection","flexFlow","flexGrow","flexShrink","flexWrap","flipX","flipY","float","float32","float64","flood-color","flood-opacity","floodColor","floodOpacity","floor","flush","focus","focusNode","focusOffset","font","font-family","font-feature-settings","font-kerning","font-language-override","font-optical-sizing","font-size","font-size-adjust","font-stretch","font-style","font-synthesis","font-variant","font-variant-alternates","font-variant-caps","font-variant-east-asian","font-variant-ligatures","font-variant-numeric","font-variant-position","font-variation-settings","font-weight","fontFamily","fontFeatureSettings","fontKerning","fontLanguageOverride","fontOpticalSizing","fontSize","fontSizeAdjust","fontSmoothingEnabled","fontStretch","fontStyle","fontSynthesis","fontVariant","fontVariantAlternates","fontVariantCaps","fontVariantEastAsian","fontVariantLigatures","fontVariantNumeric","fontVariantPosition","fontVariationSettings","fontWeight","fontcolor","fontfaces","fonts","fontsize","for","forEach","force","forceRedraw","form","formAction","formData","formEnctype","formMethod","formNoValidate","formTarget","format","formatToParts","forms","forward","forwardX","forwardY","forwardZ","foundation","fr","fragmentDirective","frame","frameBorder","frameElement","frameSpacing","framebuffer","framebufferHeight","framebufferRenderbuffer","framebufferTexture2D","framebufferTextureLayer","framebufferWidth","frames","freeSpace","freeze","frequency","frequencyBinCount","from","fromCharCode","fromCodePoint","fromElement","fromEntries","fromFloat32Array","fromFloat64Array","fromMatrix","fromPoint","fromQuad","fromRect","frontFace","fround","fullPath","fullScreen","fullscreen","fullscreenElement","fullscreenEnabled","fx","fy","gain","gamepad","gamma","gap","gatheringState","gatt","genderIdentity","generateCertificate","generateKey","generateMipmap","generateRequest","geolocation","gestureObject","get","getActiveAttrib","getActiveUniform","getActiveUniformBlockName","getActiveUniformBlockParameter","getActiveUniforms","getAdjacentText","getAll","getAllKeys","getAllResponseHeaders","getAllowlistForFeature","getAnimations","getAsFile","getAsString","getAttachedShaders","getAttribLocation","getAttribute","getAttributeNS","getAttributeNames","getAttributeNode","getAttributeNodeNS","getAttributeType","getAudioTracks","getAvailability","getBBox","getBattery","getBigInt64","getBigUint64","getBlob","getBookmark","getBoundingClientRect","getBounds","getBoxQuads","getBufferParameter","getBufferSubData","getByteFrequencyData","getByteTimeDomainData","getCSSCanvasContext","getCTM","getCandidateWindowClientRect","getCanonicalLocales","getCapabilities","getChannelData","getCharNumAtPosition","getCharacteristic","getCharacteristics","getClientExtensionResults","getClientRect","getClientRects","getCoalescedEvents","getCompositionAlternatives","getComputedStyle","getComputedTextLength","getComputedTiming","getConfiguration","getConstraints","getContext","getContextAttributes","getContributingSources","getCounterValue","getCueAsHTML","getCueById","getCurrentPosition","getCurrentTime","getData","getDatabaseNames","getDate","getDay","getDefaultComputedStyle","getDescriptor","getDescriptors","getDestinationInsertionPoints","getDevices","getDirectory","getDisplayMedia","getDistributedNodes","getEditable","getElementById","getElementsByClassName","getElementsByName","getElementsByTagName","getElementsByTagNameNS","getEnclosureList","getEndPositionOfChar","getEntries","getEntriesByName","getEntriesByType","getError","getExtension","getExtentOfChar","getEyeParameters","getFeature","getFile","getFiles","getFilesAndDirectories","getFingerprints","getFloat32","getFloat64","getFloatFrequencyData","getFloatTimeDomainData","getFloatValue","getFragDataLocation","getFrameData","getFramebufferAttachmentParameter","getFrequencyResponse","getFullYear","getGamepads","getHitTestResults","getHitTestResultsForTransientInput","getHours","getIdentityAssertion","getIds","getImageData","getIndexedParameter","getInstalledRelatedApps","getInt16","getInt32","getInt8","getInternalformatParameter","getIntersectionList","getItem","getItems","getKey","getKeyframes","getLayers","getLayoutMap","getLineDash","getLocalCandidates","getLocalParameters","getLocalStreams","getMarks","getMatchedCSSRules","getMaxGCPauseSinceClear","getMeasures","getMetadata","getMilliseconds","getMinutes","getModifierState","getMonth","getNamedItem","getNamedItemNS","getNativeFramebufferScaleFactor","getNotifications","getNotifier","getNumberOfChars","getOffsetReferenceSpace","getOutputTimestamp","getOverrideHistoryNavigationMode","getOverrideStyle","getOwnPropertyDescriptor","getOwnPropertyDescriptors","getOwnPropertyNames","getOwnPropertySymbols","getParameter","getParameters","getParent","getPathSegAtLength","getPhotoCapabilities","getPhotoSettings","getPointAtLength","getPose","getPredictedEvents","getPreference","getPreferenceDefault","getPresentationAttribute","getPreventDefault","getPrimaryService","getPrimaryServices","getProgramInfoLog","getProgramParameter","getPropertyCSSValue","getPropertyPriority","getPropertyShorthand","getPropertyType","getPropertyValue","getPrototypeOf","getQuery","getQueryParameter","getRGBColorValue","getRandomValues","getRangeAt","getReader","getReceivers","getRectValue","getRegistration","getRegistrations","getRemoteCandidates","getRemoteCertificates","getRemoteParameters","getRemoteStreams","getRenderbufferParameter","getResponseHeader","getRoot","getRootNode","getRotationOfChar","getSVGDocument","getSamplerParameter","getScreenCTM","getSeconds","getSelectedCandidatePair","getSelection","getSenders","getService","getSettings","getShaderInfoLog","getShaderParameter","getShaderPrecisionFormat","getShaderSource","getSimpleDuration","getSiteIcons","getSources","getSpeculativeParserUrls","getStartPositionOfChar","getStartTime","getState","getStats","getStatusForPolicy","getStorageUpdates","getStreamById","getStringValue","getSubStringLength","getSubscription","getSupportedConstraints","getSupportedExtensions","getSupportedFormats","getSyncParameter","getSynchronizationSources","getTags","getTargetRanges","getTexParameter","getTime","getTimezoneOffset","getTiming","getTotalLength","getTrackById","getTracks","getTransceivers","getTransform","getTransformFeedbackVarying","getTransformToElement","getTransports","getType","getTypeMapping","getUTCDate","getUTCDay","getUTCFullYear","getUTCHours","getUTCMilliseconds","getUTCMinutes","getUTCMonth","getUTCSeconds","getUint16","getUint32","getUint8","getUniform","getUniformBlockIndex","getUniformIndices","getUniformLocation","getUserMedia","getVRDisplays","getValues","getVarDate","getVariableValue","getVertexAttrib","getVertexAttribOffset","getVideoPlaybackQuality","getVideoTracks","getViewerPose","getViewport","getVoices","getWakeLockState","getWriter","getYear","givenName","global","globalAlpha","globalCompositeOperation","globalThis","glyphOrientationHorizontal","glyphOrientationVertical","glyphRef","go","grabFrame","grad","gradientTransform","gradientUnits","grammars","green","grid","grid-area","grid-auto-columns","grid-auto-flow","grid-auto-rows","grid-column","grid-column-end","grid-column-gap","grid-column-start","grid-gap","grid-row","grid-row-end","grid-row-gap","grid-row-start","grid-template","grid-template-areas","grid-template-columns","grid-template-rows","gridArea","gridAutoColumns","gridAutoFlow","gridAutoRows","gridColumn","gridColumnEnd","gridColumnGap","gridColumnStart","gridGap","gridRow","gridRowEnd","gridRowGap","gridRowStart","gridTemplate","gridTemplateAreas","gridTemplateColumns","gridTemplateRows","gripSpace","group","groupCollapsed","groupEnd","groupId","hadRecentInput","hand","handedness","hapticActuators","hardwareConcurrency","has","hasAttribute","hasAttributeNS","hasAttributes","hasBeenActive","hasChildNodes","hasComposition","hasEnrolledInstrument","hasExtension","hasExternalDisplay","hasFeature","hasFocus","hasInstance","hasLayout","hasOrientation","hasOwnProperty","hasPointerCapture","hasPosition","hasReading","hasStorageAccess","hash","head","headers","heading","height","hidden","hide","hideFocus","high","highWaterMark","hint","history","honorificPrefix","honorificSuffix","horizontalOverflow","host","hostCandidate","hostname","href","hrefTranslate","hreflang","hspace","html5TagCheckInerface","htmlFor","htmlText","httpEquiv","httpRequestStatusCode","hwTimestamp","hyphens","hypot","iccId","iceConnectionState","iceGatheringState","iceTransport","icon","iconURL","id","identifier","identity","idpLoginUrl","ignoreBOM","ignoreCase","ignoreDepthValues","image-orientation","image-rendering","imageHeight","imageOrientation","imageRendering","imageSizes","imageSmoothingEnabled","imageSmoothingQuality","imageSrcset","imageWidth","images","ime-mode","imeMode","implementation","importKey","importNode","importStylesheet","imports","impp","imul","in","in1","in2","inBandMetadataTrackDispatchType","inRange","includes","incremental","indeterminate","index","indexNames","indexOf","indexedDB","indicate","inertiaDestinationX","inertiaDestinationY","info","init","initAnimationEvent","initBeforeLoadEvent","initClipboardEvent","initCloseEvent","initCommandEvent","initCompositionEvent","initCustomEvent","initData","initDataType","initDeviceMotionEvent","initDeviceOrientationEvent","initDragEvent","initErrorEvent","initEvent","initFocusEvent","initGestureEvent","initHashChangeEvent","initKeyEvent","initKeyboardEvent","initMSManipulationEvent","initMessageEvent","initMouseEvent","initMouseScrollEvent","initMouseWheelEvent","initMutationEvent","initNSMouseEvent","initOverflowEvent","initPageEvent","initPageTransitionEvent","initPointerEvent","initPopStateEvent","initProgressEvent","initScrollAreaEvent","initSimpleGestureEvent","initStorageEvent","initTextEvent","initTimeEvent","initTouchEvent","initTransitionEvent","initUIEvent","initWebKitAnimationEvent","initWebKitTransitionEvent","initWebKitWheelEvent","initWheelEvent","initialTime","initialize","initiatorType","inline-size","inlineSize","inlineVerticalFieldOfView","inner","innerHTML","innerHeight","innerText","innerWidth","input","inputBuffer","inputEncoding","inputMethod","inputMode","inputSource","inputSources","inputType","inputs","insertAdjacentElement","insertAdjacentHTML","insertAdjacentText","insertBefore","insertCell","insertDTMF","insertData","insertItemBefore","insertNode","insertRow","insertRule","inset","inset-block","inset-block-end","inset-block-start","inset-inline","inset-inline-end","inset-inline-start","insetBlock","insetBlockEnd","insetBlockStart","insetInline","insetInlineEnd","insetInlineStart","installing","instanceRoot","instantiate","instantiateStreaming","instruments","int16","int32","int8","integrity","interactionMode","intercept","interfaceClass","interfaceName","interfaceNumber","interfaceProtocol","interfaceSubclass","interfaces","interimResults","internalSubset","interpretation","intersectionRatio","intersectionRect","intersectsNode","interval","invalidIteratorState","invalidateFramebuffer","invalidateSubFramebuffer","inverse","invertSelf","is","is2D","isActive","isAlternate","isArray","isBingCurrentSearchDefault","isBuffer","isCandidateWindowVisible","isChar","isCollapsed","isComposing","isConcatSpreadable","isConnected","isContentEditable","isContentHandlerRegistered","isContextLost","isDefaultNamespace","isDirectory","isDisabled","isEnabled","isEqual","isEqualNode","isExtensible","isExternalCTAP2SecurityKeySupported","isFile","isFinite","isFramebuffer","isFrozen","isGenerator","isHTML","isHistoryNavigation","isId","isIdentity","isInjected","isInteger","isIntersecting","isLockFree","isMap","isMultiLine","isNaN","isOpen","isPointInFill","isPointInPath","isPointInRange","isPointInStroke","isPrefAlternate","isPresenting","isPrimary","isProgram","isPropertyImplicit","isProtocolHandlerRegistered","isPrototypeOf","isQuery","isRenderbuffer","isSafeInteger","isSameNode","isSampler","isScript","isScriptURL","isSealed","isSecureContext","isSessionSupported","isShader","isSupported","isSync","isTextEdit","isTexture","isTransformFeedback","isTrusted","isTypeSupported","isUserVerifyingPlatformAuthenticatorAvailable","isVertexArray","isView","isVisible","isochronousTransferIn","isochronousTransferOut","isolation","italics","item","itemId","itemProp","itemRef","itemScope","itemType","itemValue","items","iterateNext","iterationComposite","iterator","javaEnabled","jobTitle","join","json","justify-content","justify-items","justify-self","justifyContent","justifyItems","justifySelf","k1","k2","k3","k4","kHz","keepalive","kernelMatrix","kernelUnitLengthX","kernelUnitLengthY","kerning","key","keyCode","keyFor","keyIdentifier","keyLightEnabled","keyLocation","keyPath","keyStatuses","keySystem","keyText","keyUsage","keyboard","keys","keytype","kind","knee","label","labels","lang","language","languages","largeArcFlag","lastChild","lastElementChild","lastEventId","lastIndex","lastIndexOf","lastInputTime","lastMatch","lastMessageSubject","lastMessageType","lastModified","lastModifiedDate","lastPage","lastParen","lastState","lastStyleSheetSet","latitude","layerX","layerY","layoutFlow","layoutGrid","layoutGridChar","layoutGridLine","layoutGridMode","layoutGridType","lbound","left","leftContext","leftDegrees","leftMargin","leftProjectionMatrix","leftViewMatrix","length","lengthAdjust","lengthComputable","letter-spacing","letterSpacing","level","lighting-color","lightingColor","limitingConeAngle","line","line-break","line-height","lineAlign","lineBreak","lineCap","lineDashOffset","lineHeight","lineJoin","lineNumber","lineTo","lineWidth","linearAcceleration","linearRampToValueAtTime","linearVelocity","lineno","lines","link","linkColor","linkProgram","links","list","list-style","list-style-image","list-style-position","list-style-type","listStyle","listStyleImage","listStylePosition","listStyleType","listener","load","loadEventEnd","loadEventStart","loadTime","loadTimes","loaded","loading","localDescription","localName","localService","localStorage","locale","localeCompare","location","locationbar","lock","locked","lockedFile","locks","log","log10","log1p","log2","logicalXDPI","logicalYDPI","longDesc","longitude","lookupNamespaceURI","lookupPrefix","loop","loopEnd","loopStart","looping","low","lower","lowerBound","lowerOpen","lowsrc","m11","m12","m13","m14","m21","m22","m23","m24","m31","m32","m33","m34","m41","m42","m43","m44","makeXRCompatible","manifest","manufacturer","manufacturerName","map","mapping","margin","margin-block","margin-block-end","margin-block-start","margin-bottom","margin-inline","margin-inline-end","margin-inline-start","margin-left","margin-right","margin-top","marginBlock","marginBlockEnd","marginBlockStart","marginBottom","marginHeight","marginInline","marginInlineEnd","marginInlineStart","marginLeft","marginRight","marginTop","marginWidth","mark","marker","marker-end","marker-mid","marker-offset","marker-start","markerEnd","markerHeight","markerMid","markerOffset","markerStart","markerUnits","markerWidth","marks","mask","mask-clip","mask-composite","mask-image","mask-mode","mask-origin","mask-position","mask-position-x","mask-position-y","mask-repeat","mask-size","mask-type","maskClip","maskComposite","maskContentUnits","maskImage","maskMode","maskOrigin","maskPosition","maskPositionX","maskPositionY","maskRepeat","maskSize","maskType","maskUnits","match","matchAll","matchMedia","matchMedium","matches","matrix","matrixTransform","max","max-block-size","max-height","max-inline-size","max-width","maxActions","maxAlternatives","maxBlockSize","maxChannelCount","maxChannels","maxConnectionsPerServer","maxDecibels","maxDistance","maxHeight","maxInlineSize","maxLayers","maxLength","maxMessageSize","maxPacketLifeTime","maxRetransmits","maxTouchPoints","maxValue","maxWidth","measure","measureText","media","mediaCapabilities","mediaDevices","mediaElement","mediaGroup","mediaKeys","mediaSession","mediaStream","mediaText","meetOrSlice","memory","menubar","mergeAttributes","message","messageClass","messageHandlers","messageType","metaKey","metadata","method","methodDetails","methodName","mid","mimeType","mimeTypes","min","min-block-size","min-height","min-inline-size","min-width","minBlockSize","minDecibels","minHeight","minInlineSize","minLength","minValue","minWidth","miterLimit","mix-blend-mode","mixBlendMode","mm","mode","modify","mount","move","moveBy","moveEnd","moveFirst","moveFocusDown","moveFocusLeft","moveFocusRight","moveFocusUp","moveNext","moveRow","moveStart","moveTo","moveToBookmark","moveToElementText","moveToPoint","movementX","movementY","mozAdd","mozAnimationStartTime","mozAnon","mozApps","mozAudioCaptured","mozAudioChannelType","mozAutoplayEnabled","mozCancelAnimationFrame","mozCancelFullScreen","mozCancelRequestAnimationFrame","mozCaptureStream","mozCaptureStreamUntilEnded","mozClearDataAt","mozContact","mozContacts","mozCreateFileHandle","mozCurrentTransform","mozCurrentTransformInverse","mozCursor","mozDash","mozDashOffset","mozDecodedFrames","mozExitPointerLock","mozFillRule","mozFragmentEnd","mozFrameDelay","mozFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozGetAll","mozGetAllKeys","mozGetAsFile","mozGetDataAt","mozGetMetadata","mozGetUserMedia","mozHasAudio","mozHasItem","mozHidden","mozImageSmoothingEnabled","mozIndexedDB","mozInnerScreenX","mozInnerScreenY","mozInputSource","mozIsTextField","mozItem","mozItemCount","mozItems","mozLength","mozLockOrientation","mozMatchesSelector","mozMovementX","mozMovementY","mozOpaque","mozOrientation","mozPaintCount","mozPaintedFrames","mozParsedFrames","mozPay","mozPointerLockElement","mozPresentedFrames","mozPreservesPitch","mozPressure","mozPrintCallback","mozRTCIceCandidate","mozRTCPeerConnection","mozRTCSessionDescription","mozRemove","mozRequestAnimationFrame","mozRequestFullScreen","mozRequestPointerLock","mozSetDataAt","mozSetImageElement","mozSourceNode","mozSrcObject","mozSystem","mozTCPSocket","mozTextStyle","mozTypesAt","mozUnlockOrientation","mozUserCancelled","mozVisibilityState","ms","msAnimation","msAnimationDelay","msAnimationDirection","msAnimationDuration","msAnimationFillMode","msAnimationIterationCount","msAnimationName","msAnimationPlayState","msAnimationStartTime","msAnimationTimingFunction","msBackfaceVisibility","msBlockProgression","msCSSOMElementFloatMetrics","msCaching","msCachingEnabled","msCancelRequestAnimationFrame","msCapsLockWarningOff","msClearImmediate","msClose","msContentZoomChaining","msContentZoomFactor","msContentZoomLimit","msContentZoomLimitMax","msContentZoomLimitMin","msContentZoomSnap","msContentZoomSnapPoints","msContentZoomSnapType","msContentZooming","msConvertURL","msCrypto","msDoNotTrack","msElementsFromPoint","msElementsFromRect","msExitFullscreen","msExtendedCode","msFillRule","msFirstPaint","msFlex","msFlexAlign","msFlexDirection","msFlexFlow","msFlexItemAlign","msFlexLinePack","msFlexNegative","msFlexOrder","msFlexPack","msFlexPositive","msFlexPreferredSize","msFlexWrap","msFlowFrom","msFlowInto","msFontFeatureSettings","msFullscreenElement","msFullscreenEnabled","msGetInputContext","msGetRegionContent","msGetUntransformedBounds","msGraphicsTrustStatus","msGridColumn","msGridColumnAlign","msGridColumnSpan","msGridColumns","msGridRow","msGridRowAlign","msGridRowSpan","msGridRows","msHidden","msHighContrastAdjust","msHyphenateLimitChars","msHyphenateLimitLines","msHyphenateLimitZone","msHyphens","msImageSmoothingEnabled","msImeAlign","msIndexedDB","msInterpolationMode","msIsStaticHTML","msKeySystem","msKeys","msLaunchUri","msLockOrientation","msManipulationViewsEnabled","msMatchMedia","msMatchesSelector","msMaxTouchPoints","msOrientation","msOverflowStyle","msPerspective","msPerspectiveOrigin","msPlayToDisabled","msPlayToPreferredSourceUri","msPlayToPrimary","msPointerEnabled","msRegionOverflow","msReleasePointerCapture","msRequestAnimationFrame","msRequestFullscreen","msSaveBlob","msSaveOrOpenBlob","msScrollChaining","msScrollLimit","msScrollLimitXMax","msScrollLimitXMin","msScrollLimitYMax","msScrollLimitYMin","msScrollRails","msScrollSnapPointsX","msScrollSnapPointsY","msScrollSnapType","msScrollSnapX","msScrollSnapY","msScrollTranslation","msSetImmediate","msSetMediaKeys","msSetPointerCapture","msTextCombineHorizontal","msTextSizeAdjust","msToBlob","msTouchAction","msTouchSelect","msTraceAsyncCallbackCompleted","msTraceAsyncCallbackStarting","msTraceAsyncOperationCompleted","msTraceAsyncOperationStarting","msTransform","msTransformOrigin","msTransformStyle","msTransition","msTransitionDelay","msTransitionDuration","msTransitionProperty","msTransitionTimingFunction","msUnlockOrientation","msUpdateAsyncCallbackRelation","msUserSelect","msVisibilityState","msWrapFlow","msWrapMargin","msWrapThrough","msWriteProfilerMark","msZoom","msZoomTo","mt","mul","multiEntry","multiSelectionObj","multiline","multiple","multiply","multiplySelf","mutableFile","muted","n","name","nameProp","namedItem","namedRecordset","names","namespaceURI","namespaces","naturalHeight","naturalWidth","navigate","navigation","navigationMode","navigationPreload","navigationStart","navigator","near","nearestViewportElement","negative","negotiated","netscape","networkState","newScale","newTranslate","newURL","newValue","newValueSpecifiedUnits","newVersion","newhome","next","nextElementSibling","nextHopProtocol","nextNode","nextPage","nextSibling","nickname","noHref","noModule","noResize","noShade","noValidate","noWrap","node","nodeName","nodeType","nodeValue","nonce","normalize","normalizedPathSegList","notationName","notations","note","noteGrainOn","noteOff","noteOn","notify","now","numOctaves","number","numberOfChannels","numberOfInputs","numberOfItems","numberOfOutputs","numberValue","oMatchesSelector","object","object-fit","object-position","objectFit","objectPosition","objectStore","objectStoreNames","objectType","observe","of","offscreenBuffering","offset","offset-anchor","offset-distance","offset-path","offset-rotate","offsetAnchor","offsetDistance","offsetHeight","offsetLeft","offsetNode","offsetParent","offsetPath","offsetRotate","offsetTop","offsetWidth","offsetX","offsetY","ok","oldURL","oldValue","oldVersion","olderShadowRoot","onLine","onabort","onabsolutedeviceorientation","onactivate","onactive","onaddsourcebuffer","onaddstream","onaddtrack","onafterprint","onafterscriptexecute","onafterupdate","onanimationcancel","onanimationend","onanimationiteration","onanimationstart","onappinstalled","onaudioend","onaudioprocess","onaudiostart","onautocomplete","onautocompleteerror","onauxclick","onbeforeactivate","onbeforecopy","onbeforecut","onbeforedeactivate","onbeforeeditfocus","onbeforeinstallprompt","onbeforepaste","onbeforeprint","onbeforescriptexecute","onbeforeunload","onbeforeupdate","onbeforexrselect","onbegin","onblocked","onblur","onbounce","onboundary","onbufferedamountlow","oncached","oncancel","oncandidatewindowhide","oncandidatewindowshow","oncandidatewindowupdate","oncanplay","oncanplaythrough","once","oncellchange","onchange","oncharacteristicvaluechanged","onchargingchange","onchargingtimechange","onchecking","onclick","onclose","onclosing","oncompassneedscalibration","oncomplete","onconnect","onconnecting","onconnectionavailable","onconnectionstatechange","oncontextmenu","oncontrollerchange","oncontrolselect","oncopy","oncuechange","oncut","ondataavailable","ondatachannel","ondatasetchanged","ondatasetcomplete","ondblclick","ondeactivate","ondevicechange","ondevicelight","ondevicemotion","ondeviceorientation","ondeviceorientationabsolute","ondeviceproximity","ondischargingtimechange","ondisconnect","ondisplay","ondownloading","ondrag","ondragend","ondragenter","ondragexit","ondragleave","ondragover","ondragstart","ondrop","ondurationchange","onemptied","onencrypted","onend","onended","onenter","onenterpictureinpicture","onerror","onerrorupdate","onexit","onfilterchange","onfinish","onfocus","onfocusin","onfocusout","onformdata","onfreeze","onfullscreenchange","onfullscreenerror","ongatheringstatechange","ongattserverdisconnected","ongesturechange","ongestureend","ongesturestart","ongotpointercapture","onhashchange","onhelp","onicecandidate","onicecandidateerror","oniceconnectionstatechange","onicegatheringstatechange","oninactive","oninput","oninputsourceschange","oninvalid","onkeydown","onkeypress","onkeystatuseschange","onkeyup","onlanguagechange","onlayoutcomplete","onleavepictureinpicture","onlevelchange","onload","onloadeddata","onloadedmetadata","onloadend","onloading","onloadingdone","onloadingerror","onloadstart","onlosecapture","onlostpointercapture","only","onmark","onmessage","onmessageerror","onmidimessage","onmousedown","onmouseenter","onmouseleave","onmousemove","onmouseout","onmouseover","onmouseup","onmousewheel","onmove","onmoveend","onmovestart","onmozfullscreenchange","onmozfullscreenerror","onmozorientationchange","onmozpointerlockchange","onmozpointerlockerror","onmscontentzoom","onmsfullscreenchange","onmsfullscreenerror","onmsgesturechange","onmsgesturedoubletap","onmsgestureend","onmsgesturehold","onmsgesturestart","onmsgesturetap","onmsgotpointercapture","onmsinertiastart","onmslostpointercapture","onmsmanipulationstatechanged","onmsneedkey","onmsorientationchange","onmspointercancel","onmspointerdown","onmspointerenter","onmspointerhover","onmspointerleave","onmspointermove","onmspointerout","onmspointerover","onmspointerup","onmssitemodejumplistitemremoved","onmsthumbnailclick","onmute","onnegotiationneeded","onnomatch","onnoupdate","onobsolete","onoffline","ononline","onopen","onorientationchange","onpagechange","onpagehide","onpageshow","onpaste","onpause","onpayerdetailchange","onpaymentmethodchange","onplay","onplaying","onpluginstreamstart","onpointercancel","onpointerdown","onpointerenter","onpointerleave","onpointerlockchange","onpointerlockerror","onpointermove","onpointerout","onpointerover","onpointerrawupdate","onpointerup","onpopstate","onprocessorerror","onprogress","onpropertychange","onratechange","onreading","onreadystatechange","onrejectionhandled","onrelease","onremove","onremovesourcebuffer","onremovestream","onremovetrack","onrepeat","onreset","onresize","onresizeend","onresizestart","onresourcetimingbufferfull","onresult","onresume","onrowenter","onrowexit","onrowsdelete","onrowsinserted","onscroll","onsearch","onsecuritypolicyviolation","onseeked","onseeking","onselect","onselectedcandidatepairchange","onselectend","onselectionchange","onselectstart","onshippingaddresschange","onshippingoptionchange","onshow","onsignalingstatechange","onsoundend","onsoundstart","onsourceclose","onsourceclosed","onsourceended","onsourceopen","onspeechend","onspeechstart","onsqueeze","onsqueezeend","onsqueezestart","onstalled","onstart","onstatechange","onstop","onstorage","onstoragecommit","onsubmit","onsuccess","onsuspend","onterminate","ontextinput","ontimeout","ontimeupdate","ontoggle","ontonechange","ontouchcancel","ontouchend","ontouchmove","ontouchstart","ontrack","ontransitioncancel","ontransitionend","ontransitionrun","ontransitionstart","onunhandledrejection","onunload","onunmute","onupdate","onupdateend","onupdatefound","onupdateready","onupdatestart","onupgradeneeded","onuserproximity","onversionchange","onvisibilitychange","onvoiceschanged","onvolumechange","onvrdisplayactivate","onvrdisplayconnect","onvrdisplaydeactivate","onvrdisplaydisconnect","onvrdisplaypresentchange","onwaiting","onwaitingforkey","onwarning","onwebkitanimationend","onwebkitanimationiteration","onwebkitanimationstart","onwebkitcurrentplaybacktargetiswirelesschanged","onwebkitfullscreenchange","onwebkitfullscreenerror","onwebkitkeyadded","onwebkitkeyerror","onwebkitkeymessage","onwebkitneedkey","onwebkitorientationchange","onwebkitplaybacktargetavailabilitychanged","onwebkitpointerlockchange","onwebkitpointerlockerror","onwebkitresourcetimingbufferfull","onwebkittransitionend","onwheel","onzoom","opacity","open","openCursor","openDatabase","openKeyCursor","opened","opener","opera","operationType","operator","opr","optimum","options","or","order","orderX","orderY","ordered","org","organization","orient","orientAngle","orientType","orientation","orientationX","orientationY","orientationZ","origin","originalPolicy","originalTarget","orphans","oscpu","outerHTML","outerHeight","outerText","outerWidth","outline","outline-color","outline-offset","outline-style","outline-width","outlineColor","outlineOffset","outlineStyle","outlineWidth","outputBuffer","outputLatency","outputs","overflow","overflow-anchor","overflow-block","overflow-inline","overflow-wrap","overflow-x","overflow-y","overflowAnchor","overflowBlock","overflowInline","overflowWrap","overflowX","overflowY","overrideMimeType","oversample","overscroll-behavior","overscroll-behavior-block","overscroll-behavior-inline","overscroll-behavior-x","overscroll-behavior-y","overscrollBehavior","overscrollBehaviorBlock","overscrollBehaviorInline","overscrollBehaviorX","overscrollBehaviorY","ownKeys","ownerDocument","ownerElement","ownerNode","ownerRule","ownerSVGElement","owningElement","p1","p2","p3","p4","packetSize","packets","pad","padEnd","padStart","padding","padding-block","padding-block-end","padding-block-start","padding-bottom","padding-inline","padding-inline-end","padding-inline-start","padding-left","padding-right","padding-top","paddingBlock","paddingBlockEnd","paddingBlockStart","paddingBottom","paddingInline","paddingInlineEnd","paddingInlineStart","paddingLeft","paddingRight","paddingTop","page","page-break-after","page-break-before","page-break-inside","pageBreakAfter","pageBreakBefore","pageBreakInside","pageCount","pageLeft","pageTop","pageX","pageXOffset","pageY","pageYOffset","pages","paint-order","paintOrder","paintRequests","paintType","paintWorklet","palette","pan","panningModel","parameters","parent","parentElement","parentNode","parentRule","parentStyleSheet","parentTextEdit","parentWindow","parse","parseAll","parseFloat","parseFromString","parseInt","part","participants","passive","password","pasteHTML","path","pathLength","pathSegList","pathSegType","pathSegTypeAsLetter","pathname","pattern","patternContentUnits","patternMismatch","patternTransform","patternUnits","pause","pauseAnimations","pauseOnExit","pauseProfilers","pauseTransformFeedback","paused","payerEmail","payerName","payerPhone","paymentManager","pc","peerIdentity","pending","pendingLocalDescription","pendingRemoteDescription","percent","performance","periodicSync","permission","permissionState","permissions","persist","persisted","personalbar","perspective","perspective-origin","perspectiveOrigin","phone","phoneticFamilyName","phoneticGivenName","photo","pictureInPictureElement","pictureInPictureEnabled","pictureInPictureWindow","ping","pipeThrough","pipeTo","pitch","pixelBottom","pixelDepth","pixelHeight","pixelLeft","pixelRight","pixelStorei","pixelTop","pixelUnitToMillimeterX","pixelUnitToMillimeterY","pixelWidth","place-content","place-items","place-self","placeContent","placeItems","placeSelf","placeholder","platform","platforms","play","playEffect","playState","playbackRate","playbackState","playbackTime","played","playoutDelayHint","playsInline","plugins","pluginspage","pname","pointer-events","pointerBeforeReferenceNode","pointerEnabled","pointerEvents","pointerId","pointerLockElement","pointerType","points","pointsAtX","pointsAtY","pointsAtZ","polygonOffset","pop","populateMatrix","popupWindowFeatures","popupWindowName","popupWindowURI","port","port1","port2","ports","posBottom","posHeight","posLeft","posRight","posTop","posWidth","pose","position","positionAlign","positionX","positionY","positionZ","postError","postMessage","postalCode","poster","pow","powerEfficient","powerOff","preMultiplySelf","precision","preferredStyleSheetSet","preferredStylesheetSet","prefix","preload","prepend","presentation","preserveAlpha","preserveAspectRatio","preserveAspectRatioString","pressed","pressure","prevValue","preventDefault","preventExtensions","preventSilentAccess","previousElementSibling","previousNode","previousPage","previousRect","previousScale","previousSibling","previousTranslate","primaryKey","primitiveType","primitiveUnits","principals","print","priority","privateKey","probablySupportsContext","process","processIceMessage","processingEnd","processingStart","product","productId","productName","productSub","profile","profileEnd","profiles","projectionMatrix","promise","prompt","properties","propertyIsEnumerable","propertyName","protocol","protocolLong","prototype","provider","pseudoClass","pseudoElement","pt","publicId","publicKey","published","pulse","push","pushManager","pushNotification","pushState","put","putImageData","px","quadraticCurveTo","qualifier","quaternion","query","queryCommandEnabled","queryCommandIndeterm","queryCommandState","queryCommandSupported","queryCommandText","queryCommandValue","querySelector","querySelectorAll","queueMicrotask","quote","quotes","r","r1","r2","race","rad","radiogroup","radiusX","radiusY","random","range","rangeCount","rangeMax","rangeMin","rangeOffset","rangeOverflow","rangeParent","rangeUnderflow","rate","ratio","raw","rawId","read","readAsArrayBuffer","readAsBinaryString","readAsBlob","readAsDataURL","readAsText","readBuffer","readEntries","readOnly","readPixels","readReportRequested","readText","readValue","readable","ready","readyState","reason","reboot","receivedAlert","receiver","receivers","recipient","reconnect","recordNumber","recordsAvailable","recordset","rect","red","redEyeReduction","redirect","redirectCount","redirectEnd","redirectStart","redirected","reduce","reduceRight","reduction","refDistance","refX","refY","referenceNode","referenceSpace","referrer","referrerPolicy","refresh","region","regionAnchorX","regionAnchorY","regionId","regions","register","registerContentHandler","registerElement","registerProperty","registerProtocolHandler","reject","rel","relList","relatedAddress","relatedNode","relatedPort","relatedTarget","release","releaseCapture","releaseEvents","releaseInterface","releaseLock","releasePointerCapture","releaseShaderCompiler","reliable","reliableWrite","reload","rem","remainingSpace","remote","remoteDescription","remove","removeAllRanges","removeAttribute","removeAttributeNS","removeAttributeNode","removeBehavior","removeChild","removeCue","removeEventListener","removeFilter","removeImport","removeItem","removeListener","removeNamedItem","removeNamedItemNS","removeNode","removeParameter","removeProperty","removeRange","removeRegion","removeRule","removeSiteSpecificTrackingException","removeSourceBuffer","removeStream","removeTrack","removeVariable","removeWakeLockListener","removeWebWideTrackingException","removed","removedNodes","renderHeight","renderState","renderTime","renderWidth","renderbufferStorage","renderbufferStorageMultisample","renderedBuffer","renderingMode","renotify","repeat","replace","replaceAdjacentText","replaceAll","replaceChild","replaceChildren","replaceData","replaceId","replaceItem","replaceNode","replaceState","replaceSync","replaceTrack","replaceWholeText","replaceWith","reportValidity","request","requestAnimationFrame","requestAutocomplete","requestData","requestDevice","requestFrame","requestFullscreen","requestHitTestSource","requestHitTestSourceForTransientInput","requestId","requestIdleCallback","requestMIDIAccess","requestMediaKeySystemAccess","requestPermission","requestPictureInPicture","requestPointerLock","requestPresent","requestReferenceSpace","requestSession","requestStart","requestStorageAccess","requestSubmit","requestVideoFrameCallback","requestingWindow","requireInteraction","required","requiredExtensions","requiredFeatures","reset","resetPose","resetTransform","resize","resizeBy","resizeTo","resolve","response","responseBody","responseEnd","responseReady","responseStart","responseText","responseType","responseURL","responseXML","restartIce","restore","result","resultIndex","resultType","results","resume","resumeProfilers","resumeTransformFeedback","retry","returnValue","rev","reverse","reversed","revocable","revokeObjectURL","rgbColor","right","rightContext","rightDegrees","rightMargin","rightProjectionMatrix","rightViewMatrix","role","rolloffFactor","root","rootBounds","rootElement","rootMargin","rotate","rotateAxisAngle","rotateAxisAngleSelf","rotateFromVector","rotateFromVectorSelf","rotateSelf","rotation","rotationAngle","rotationRate","round","row-gap","rowGap","rowIndex","rowSpan","rows","rtcpTransport","rtt","ruby-align","ruby-position","rubyAlign","rubyOverhang","rubyPosition","rules","runtime","runtimeStyle","rx","ry","s","safari","sample","sampleCoverage","sampleRate","samplerParameterf","samplerParameteri","sandbox","save","saveData","scale","scale3d","scale3dSelf","scaleNonUniform","scaleNonUniformSelf","scaleSelf","scheme","scissor","scope","scopeName","scoped","screen","screenBrightness","screenEnabled","screenLeft","screenPixelToMillimeterX","screenPixelToMillimeterY","screenTop","screenX","screenY","scriptURL","scripts","scroll","scroll-behavior","scroll-margin","scroll-margin-block","scroll-margin-block-end","scroll-margin-block-start","scroll-margin-bottom","scroll-margin-inline","scroll-margin-inline-end","scroll-margin-inline-start","scroll-margin-left","scroll-margin-right","scroll-margin-top","scroll-padding","scroll-padding-block","scroll-padding-block-end","scroll-padding-block-start","scroll-padding-bottom","scroll-padding-inline","scroll-padding-inline-end","scroll-padding-inline-start","scroll-padding-left","scroll-padding-right","scroll-padding-top","scroll-snap-align","scroll-snap-type","scrollAmount","scrollBehavior","scrollBy","scrollByLines","scrollByPages","scrollDelay","scrollHeight","scrollIntoView","scrollIntoViewIfNeeded","scrollLeft","scrollLeftMax","scrollMargin","scrollMarginBlock","scrollMarginBlockEnd","scrollMarginBlockStart","scrollMarginBottom","scrollMarginInline","scrollMarginInlineEnd","scrollMarginInlineStart","scrollMarginLeft","scrollMarginRight","scrollMarginTop","scrollMaxX","scrollMaxY","scrollPadding","scrollPaddingBlock","scrollPaddingBlockEnd","scrollPaddingBlockStart","scrollPaddingBottom","scrollPaddingInline","scrollPaddingInlineEnd","scrollPaddingInlineStart","scrollPaddingLeft","scrollPaddingRight","scrollPaddingTop","scrollRestoration","scrollSnapAlign","scrollSnapType","scrollTo","scrollTop","scrollTopMax","scrollWidth","scrollX","scrollY","scrollbar-color","scrollbar-width","scrollbar3dLightColor","scrollbarArrowColor","scrollbarBaseColor","scrollbarColor","scrollbarDarkShadowColor","scrollbarFaceColor","scrollbarHighlightColor","scrollbarShadowColor","scrollbarTrackColor","scrollbarWidth","scrollbars","scrolling","scrollingElement","sctp","sctpCauseCode","sdp","sdpLineNumber","sdpMLineIndex","sdpMid","seal","search","searchBox","searchBoxJavaBridge_","searchParams","sectionRowIndex","secureConnectionStart","security","seed","seekToNextFrame","seekable","seeking","select","selectAllChildren","selectAlternateInterface","selectConfiguration","selectNode","selectNodeContents","selectNodes","selectSingleNode","selectSubString","selected","selectedIndex","selectedOptions","selectedStyleSheetSet","selectedStylesheetSet","selection","selectionDirection","selectionEnd","selectionStart","selector","selectorText","self","send","sendAsBinary","sendBeacon","sender","sentAlert","sentTimestamp","separator","serialNumber","serializeToString","serverTiming","service","serviceWorker","session","sessionId","sessionStorage","set","setActionHandler","setActive","setAlpha","setAppBadge","setAttribute","setAttributeNS","setAttributeNode","setAttributeNodeNS","setBaseAndExtent","setBigInt64","setBigUint64","setBingCurrentSearchDefault","setCapture","setCodecPreferences","setColor","setCompositeOperation","setConfiguration","setCurrentTime","setCustomValidity","setData","setDate","setDragImage","setEnd","setEndAfter","setEndBefore","setEndPoint","setFillColor","setFilterRes","setFloat32","setFloat64","setFloatValue","setFormValue","setFullYear","setHeaderValue","setHours","setIdentityProvider","setImmediate","setInt16","setInt32","setInt8","setInterval","setItem","setKeyframes","setLineCap","setLineDash","setLineJoin","setLineWidth","setLiveSeekableRange","setLocalDescription","setMatrix","setMatrixValue","setMediaKeys","setMilliseconds","setMinutes","setMiterLimit","setMonth","setNamedItem","setNamedItemNS","setNonUserCodeExceptions","setOrientToAngle","setOrientToAuto","setOrientation","setOverrideHistoryNavigationMode","setPaint","setParameter","setParameters","setPeriodicWave","setPointerCapture","setPosition","setPositionState","setPreference","setProperty","setPrototypeOf","setRGBColor","setRGBColorICCColor","setRadius","setRangeText","setRemoteDescription","setRequestHeader","setResizable","setResourceTimingBufferSize","setRotate","setScale","setSeconds","setSelectionRange","setServerCertificate","setShadow","setSinkId","setSkewX","setSkewY","setStart","setStartAfter","setStartBefore","setStdDeviation","setStreams","setStringValue","setStrokeColor","setSuggestResult","setTargetAtTime","setTargetValueAtTime","setTime","setTimeout","setTransform","setTranslate","setUTCDate","setUTCFullYear","setUTCHours","setUTCMilliseconds","setUTCMinutes","setUTCMonth","setUTCSeconds","setUint16","setUint32","setUint8","setUri","setValidity","setValueAtTime","setValueCurveAtTime","setVariable","setVelocity","setVersion","setYear","settingName","settingValue","sex","shaderSource","shadowBlur","shadowColor","shadowOffsetX","shadowOffsetY","shadowRoot","shape","shape-image-threshold","shape-margin","shape-outside","shape-rendering","shapeImageThreshold","shapeMargin","shapeOutside","shapeRendering","sheet","shift","shiftKey","shiftLeft","shippingAddress","shippingOption","shippingType","show","showHelp","showModal","showModalDialog","showModelessDialog","showNotification","sidebar","sign","signal","signalingState","signature","silent","sin","singleNodeValue","sinh","sinkId","sittingToStandingTransform","size","sizeToContent","sizeX","sizeZ","sizes","skewX","skewXSelf","skewY","skewYSelf","slice","slope","slot","small","smil","smooth","smoothingTimeConstant","snapToLines","snapshotItem","snapshotLength","some","sort","sortingCode","source","sourceBuffer","sourceBuffers","sourceCapabilities","sourceFile","sourceIndex","sources","spacing","span","speak","speakAs","speaking","species","specified","specularConstant","specularExponent","speechSynthesis","speed","speedOfSound","spellcheck","splice","split","splitText","spreadMethod","sqrt","src","srcElement","srcFilter","srcObject","srcUrn","srcdoc","srclang","srcset","stack","stackTraceLimit","stacktrace","stageParameters","standalone","standby","start","startContainer","startIce","startMessages","startNotifications","startOffset","startProfiling","startRendering","startShark","startTime","startsWith","state","status","statusCode","statusMessage","statusText","statusbar","stdDeviationX","stdDeviationY","stencilFunc","stencilFuncSeparate","stencilMask","stencilMaskSeparate","stencilOp","stencilOpSeparate","step","stepDown","stepMismatch","stepUp","sticky","stitchTiles","stop","stop-color","stop-opacity","stopColor","stopImmediatePropagation","stopNotifications","stopOpacity","stopProfiling","stopPropagation","stopShark","stopped","storage","storageArea","storageName","storageStatus","store","storeSiteSpecificTrackingException","storeWebWideTrackingException","stpVersion","stream","streams","stretch","strike","string","stringValue","stringify","stroke","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","strokeDasharray","strokeDashoffset","strokeLinecap","strokeLinejoin","strokeMiterlimit","strokeOpacity","strokeRect","strokeStyle","strokeText","strokeWidth","style","styleFloat","styleMap","styleMedia","styleSheet","styleSheetSets","styleSheets","sub","subarray","subject","submit","submitFrame","submitter","subscribe","substr","substring","substringData","subtle","subtree","suffix","suffixes","summary","sup","supported","supportedContentEncodings","supportedEntryTypes","supports","supportsSession","surfaceScale","surroundContents","suspend","suspendRedraw","swapCache","swapNode","sweepFlag","symbols","sync","sysexEnabled","system","systemCode","systemId","systemLanguage","systemXDPI","systemYDPI","tBodies","tFoot","tHead","tabIndex","table","table-layout","tableLayout","tableValues","tag","tagName","tagUrn","tags","taintEnabled","takePhoto","takeRecords","tan","tangentialPressure","tanh","target","targetElement","targetRayMode","targetRaySpace","targetTouches","targetX","targetY","tcpType","tee","tel","terminate","test","texImage2D","texImage3D","texParameterf","texParameteri","texStorage2D","texStorage3D","texSubImage2D","texSubImage3D","text","text-align","text-align-last","text-anchor","text-combine-upright","text-decoration","text-decoration-color","text-decoration-line","text-decoration-skip-ink","text-decoration-style","text-decoration-thickness","text-emphasis","text-emphasis-color","text-emphasis-position","text-emphasis-style","text-indent","text-justify","text-orientation","text-overflow","text-rendering","text-shadow","text-transform","text-underline-offset","text-underline-position","textAlign","textAlignLast","textAnchor","textAutospace","textBaseline","textCombineUpright","textContent","textDecoration","textDecorationBlink","textDecorationColor","textDecorationLine","textDecorationLineThrough","textDecorationNone","textDecorationOverline","textDecorationSkipInk","textDecorationStyle","textDecorationThickness","textDecorationUnderline","textEmphasis","textEmphasisColor","textEmphasisPosition","textEmphasisStyle","textIndent","textJustify","textJustifyTrim","textKashida","textKashidaSpace","textLength","textOrientation","textOverflow","textRendering","textShadow","textTracks","textTransform","textUnderlineOffset","textUnderlinePosition","then","threadId","threshold","thresholds","tiltX","tiltY","time","timeEnd","timeLog","timeOrigin","timeRemaining","timeStamp","timecode","timeline","timelineTime","timeout","timestamp","timestampOffset","timing","title","to","toArray","toBlob","toDataURL","toDateString","toElement","toExponential","toFixed","toFloat32Array","toFloat64Array","toGMTString","toISOString","toJSON","toLocaleDateString","toLocaleFormat","toLocaleLowerCase","toLocaleString","toLocaleTimeString","toLocaleUpperCase","toLowerCase","toMatrix","toMethod","toPrecision","toPrimitive","toSdp","toSource","toStaticHTML","toString","toStringTag","toSum","toTimeString","toUTCString","toUpperCase","toggle","toggleAttribute","toggleLongPressEnabled","tone","toneBuffer","tooLong","tooShort","toolbar","top","topMargin","total","totalFrameDelay","totalVideoFrames","touch-action","touchAction","touched","touches","trace","track","trackVisibility","transaction","transactions","transceiver","transferControlToOffscreen","transferFromImageBitmap","transferImageBitmap","transferIn","transferOut","transferSize","transferToImageBitmap","transform","transform-box","transform-origin","transform-style","transformBox","transformFeedbackVaryings","transformOrigin","transformPoint","transformString","transformStyle","transformToDocument","transformToFragment","transition","transition-delay","transition-duration","transition-property","transition-timing-function","transitionDelay","transitionDuration","transitionProperty","transitionTimingFunction","translate","translateSelf","translationX","translationY","transport","trim","trimEnd","trimLeft","trimRight","trimStart","trueSpeed","trunc","truncate","trustedTypes","turn","twist","type","typeDetail","typeMismatch","typeMustMatch","types","u2f","ubound","uint16","uint32","uint8","uint8Clamped","undefined","unescape","uneval","unicode","unicode-bidi","unicodeBidi","unicodeRange","uniform1f","uniform1fv","uniform1i","uniform1iv","uniform1ui","uniform1uiv","uniform2f","uniform2fv","uniform2i","uniform2iv","uniform2ui","uniform2uiv","uniform3f","uniform3fv","uniform3i","uniform3iv","uniform3ui","uniform3uiv","uniform4f","uniform4fv","uniform4i","uniform4iv","uniform4ui","uniform4uiv","uniformBlockBinding","uniformMatrix2fv","uniformMatrix2x3fv","uniformMatrix2x4fv","uniformMatrix3fv","uniformMatrix3x2fv","uniformMatrix3x4fv","uniformMatrix4fv","uniformMatrix4x2fv","uniformMatrix4x3fv","unique","uniqueID","uniqueNumber","unit","unitType","units","unloadEventEnd","unloadEventStart","unlock","unmount","unobserve","unpause","unpauseAnimations","unreadCount","unregister","unregisterContentHandler","unregisterProtocolHandler","unscopables","unselectable","unshift","unsubscribe","unsuspendRedraw","unsuspendRedrawAll","unwatch","unwrapKey","upDegrees","upX","upY","upZ","update","updateCommands","updateIce","updateInterval","updatePlaybackRate","updateRenderState","updateSettings","updateTiming","updateViaCache","updateWith","updated","updating","upgrade","upload","uploadTotal","uploaded","upper","upperBound","upperOpen","uri","url","urn","urns","usages","usb","usbVersionMajor","usbVersionMinor","usbVersionSubminor","useCurrentView","useMap","useProgram","usedSpace","user-select","userActivation","userAgent","userChoice","userHandle","userHint","userLanguage","userSelect","userVisibleOnly","username","usernameFragment","utterance","uuid","v8BreakIterator","vAlign","vLink","valid","validate","validateProgram","validationMessage","validity","value","valueAsDate","valueAsNumber","valueAsString","valueInSpecifiedUnits","valueMissing","valueOf","valueText","valueType","values","variable","variant","variationSettings","vector-effect","vectorEffect","velocityAngular","velocityExpansion","velocityX","velocityY","vendor","vendorId","vendorSub","verify","version","vertexAttrib1f","vertexAttrib1fv","vertexAttrib2f","vertexAttrib2fv","vertexAttrib3f","vertexAttrib3fv","vertexAttrib4f","vertexAttrib4fv","vertexAttribDivisor","vertexAttribDivisorANGLE","vertexAttribI4i","vertexAttribI4iv","vertexAttribI4ui","vertexAttribI4uiv","vertexAttribIPointer","vertexAttribPointer","vertical","vertical-align","verticalAlign","verticalOverflow","vh","vibrate","vibrationActuator","videoBitsPerSecond","videoHeight","videoTracks","videoWidth","view","viewBox","viewBoxString","viewTarget","viewTargetString","viewport","viewportAnchorX","viewportAnchorY","viewportElement","views","violatedDirective","visibility","visibilityState","visible","visualViewport","vlinkColor","vmax","vmin","voice","voiceURI","volume","vrml","vspace","vw","w","wait","waitSync","waiting","wake","wakeLock","wand","warn","wasClean","wasDiscarded","watch","watchAvailability","watchPosition","webdriver","webkitAddKey","webkitAlignContent","webkitAlignItems","webkitAlignSelf","webkitAnimation","webkitAnimationDelay","webkitAnimationDirection","webkitAnimationDuration","webkitAnimationFillMode","webkitAnimationIterationCount","webkitAnimationName","webkitAnimationPlayState","webkitAnimationTimingFunction","webkitAppearance","webkitAudioContext","webkitAudioDecodedByteCount","webkitAudioPannerNode","webkitBackfaceVisibility","webkitBackground","webkitBackgroundAttachment","webkitBackgroundClip","webkitBackgroundColor","webkitBackgroundImage","webkitBackgroundOrigin","webkitBackgroundPosition","webkitBackgroundPositionX","webkitBackgroundPositionY","webkitBackgroundRepeat","webkitBackgroundSize","webkitBackingStorePixelRatio","webkitBorderBottomLeftRadius","webkitBorderBottomRightRadius","webkitBorderImage","webkitBorderImageOutset","webkitBorderImageRepeat","webkitBorderImageSlice","webkitBorderImageSource","webkitBorderImageWidth","webkitBorderRadius","webkitBorderTopLeftRadius","webkitBorderTopRightRadius","webkitBoxAlign","webkitBoxDirection","webkitBoxFlex","webkitBoxOrdinalGroup","webkitBoxOrient","webkitBoxPack","webkitBoxShadow","webkitBoxSizing","webkitCancelAnimationFrame","webkitCancelFullScreen","webkitCancelKeyRequest","webkitCancelRequestAnimationFrame","webkitClearResourceTimings","webkitClosedCaptionsVisible","webkitConvertPointFromNodeToPage","webkitConvertPointFromPageToNode","webkitCreateShadowRoot","webkitCurrentFullScreenElement","webkitCurrentPlaybackTargetIsWireless","webkitDecodedFrameCount","webkitDirectionInvertedFromDevice","webkitDisplayingFullscreen","webkitDroppedFrameCount","webkitEnterFullScreen","webkitEnterFullscreen","webkitEntries","webkitExitFullScreen","webkitExitFullscreen","webkitExitPointerLock","webkitFilter","webkitFlex","webkitFlexBasis","webkitFlexDirection","webkitFlexFlow","webkitFlexGrow","webkitFlexShrink","webkitFlexWrap","webkitFullScreenKeyboardInputAllowed","webkitFullscreenElement","webkitFullscreenEnabled","webkitGenerateKeyRequest","webkitGetAsEntry","webkitGetDatabaseNames","webkitGetEntries","webkitGetEntriesByName","webkitGetEntriesByType","webkitGetFlowByName","webkitGetGamepads","webkitGetImageDataHD","webkitGetNamedFlows","webkitGetRegionFlowRanges","webkitGetUserMedia","webkitHasClosedCaptions","webkitHidden","webkitIDBCursor","webkitIDBDatabase","webkitIDBDatabaseError","webkitIDBDatabaseException","webkitIDBFactory","webkitIDBIndex","webkitIDBKeyRange","webkitIDBObjectStore","webkitIDBRequest","webkitIDBTransaction","webkitImageSmoothingEnabled","webkitIndexedDB","webkitInitMessageEvent","webkitIsFullScreen","webkitJustifyContent","webkitKeys","webkitLineClamp","webkitLineDashOffset","webkitLockOrientation","webkitMask","webkitMaskClip","webkitMaskComposite","webkitMaskImage","webkitMaskOrigin","webkitMaskPosition","webkitMaskPositionX","webkitMaskPositionY","webkitMaskRepeat","webkitMaskSize","webkitMatchesSelector","webkitMediaStream","webkitNotifications","webkitOfflineAudioContext","webkitOrder","webkitOrientation","webkitPeerConnection00","webkitPersistentStorage","webkitPerspective","webkitPerspectiveOrigin","webkitPointerLockElement","webkitPostMessage","webkitPreservesPitch","webkitPutImageDataHD","webkitRTCPeerConnection","webkitRegionOverset","webkitRelativePath","webkitRequestAnimationFrame","webkitRequestFileSystem","webkitRequestFullScreen","webkitRequestFullscreen","webkitRequestPointerLock","webkitResolveLocalFileSystemURL","webkitSetMediaKeys","webkitSetResourceTimingBufferSize","webkitShadowRoot","webkitShowPlaybackTargetPicker","webkitSlice","webkitSpeechGrammar","webkitSpeechGrammarList","webkitSpeechRecognition","webkitSpeechRecognitionError","webkitSpeechRecognitionEvent","webkitStorageInfo","webkitSupportsFullscreen","webkitTemporaryStorage","webkitTextFillColor","webkitTextSizeAdjust","webkitTextStroke","webkitTextStrokeColor","webkitTextStrokeWidth","webkitTransform","webkitTransformOrigin","webkitTransformStyle","webkitTransition","webkitTransitionDelay","webkitTransitionDuration","webkitTransitionProperty","webkitTransitionTimingFunction","webkitURL","webkitUnlockOrientation","webkitUserSelect","webkitVideoDecodedByteCount","webkitVisibilityState","webkitWirelessVideoPlaybackDisabled","webkitdirectory","webkitdropzone","webstore","weight","whatToShow","wheelDelta","wheelDeltaX","wheelDeltaY","whenDefined","which","white-space","whiteSpace","wholeText","widows","width","will-change","willChange","willValidate","window","withCredentials","word-break","word-spacing","word-wrap","wordBreak","wordSpacing","wordWrap","workerStart","wrap","wrapKey","writable","writableAuxiliaries","write","writeText","writeValue","writeWithoutResponse","writeln","writing-mode","writingMode","x","x1","x2","xChannelSelector","xmlEncoding","xmlStandalone","xmlVersion","xmlbase","xmllang","xmlspace","xor","xr","y","y1","y2","yChannelSelector","yandex","z","z-index","zIndex","zoom","zoomAndPan","zoomRectScreen"]');
            }
        }, t = {};
    function r(n) {
        var i = t[n];
        if (void 0 !== i)
            return i.exports;
        var a = t[n] = {
            id: n,
            loaded: !1,
            exports: {}
        };
        return e[n].call(a.exports, a, a.exports, r), a.loaded = !0, a.exports;
    }
    return r.n = e => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return r.d(t, { a: t }), t;
    }, r.d = (e, t) => {
        for (var n in t)
            r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
    }, r.g = function () {
        if ('object' == typeof globalThis)
            return globalThis;
        try {
            return this || new Function('return this')();
        } catch (e) {
            if ('object' == typeof window)
                return window;
        }
    }(), r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), r.r = e => {
        'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }), Object.defineProperty(e, '__esModule', { value: !0 });
    }, r.nmd = e => (e.paths = [], e.children || (e.children = []), e), r(8492);
})());
}).call(this)}).call(this,_$buffer_8({}).Buffer)
_$indexBrowser_453 = _$indexBrowser_453.exports
'use strict';

var _$ansiWrap_1 = function(a, b, msg) {
  return '\u001b['+ a + 'm' + msg + '\u001b[' + b + 'm';
};

var _$ansiColors_457 = {};
/*!
 * ansi-colors <https://github.com/doowb/ansi-colors>
 *
 * Copyright (c) 2015-2017, Brian Woodward.
 * Released under the MIT License.
 */

'use strict';

/**
 * Module dependencies
 */

/* removed: var _$ansiWrap_1 = require('ansi-wrap'); */;

/**
 * Wrap a string with ansi codes to create a black background.
 *
 * ```js
 * console.log(colors.bgblack('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  bgblack
 */

_$ansiColors_457.bgblack = function bgblack(message) {
  return _$ansiWrap_1(40, 49, message);
};

/**
 * Wrap a string with ansi codes to create a blue background.
 *
 * ```js
 * console.log(colors.bgblue('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  bgblue
 */

_$ansiColors_457.bgblue = function bgblue(message) {
  return _$ansiWrap_1(44, 49, message);
};

/**
 * Wrap a string with ansi codes to create a cyan background.
 *
 * ```js
 * console.log(colors.bgcyan('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  bgcyan
 */

_$ansiColors_457.bgcyan = function bgcyan(message) {
  return _$ansiWrap_1(46, 49, message);
};

/**
 * Wrap a string with ansi codes to create a green background.
 *
 * ```js
 * console.log(colors.bggreen('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  bggreen
 */

_$ansiColors_457.bggreen = function bggreen(message) {
  return _$ansiWrap_1(42, 49, message);
};

/**
 * Wrap a string with ansi codes to create a magenta background.
 *
 * ```js
 * console.log(colors.bgmagenta('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  bgmagenta
 */

_$ansiColors_457.bgmagenta = function bgmagenta(message) {
  return _$ansiWrap_1(45, 49, message);
};

/**
 * Wrap a string with ansi codes to create a red background.
 *
 * ```js
 * console.log(colors.bgred('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  bgred
 */

_$ansiColors_457.bgred = function bgred(message) {
  return _$ansiWrap_1(41, 49, message);
};

/**
 * Wrap a string with ansi codes to create a white background.
 *
 * ```js
 * console.log(colors.bgwhite('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  bgwhite
 */

_$ansiColors_457.bgwhite = function bgwhite(message) {
  return _$ansiWrap_1(47, 49, message);
};

/**
 * Wrap a string with ansi codes to create a yellow background.
 *
 * ```js
 * console.log(colors.bgyellow('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  bgyellow
 */

_$ansiColors_457.bgyellow = function bgyellow(message) {
  return _$ansiWrap_1(43, 49, message);
};

/**
 * Wrap a string with ansi codes to create black text.
 *
 * ```js
 * console.log(colors.black('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  black
 */

_$ansiColors_457.black = function black(message) {
  return _$ansiWrap_1(30, 39, message);
};

/**
 * Wrap a string with ansi codes to create blue text.
 *
 * ```js
 * console.log(colors.blue('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  blue
 */

_$ansiColors_457.blue = function blue(message) {
  return _$ansiWrap_1(34, 39, message);
};

/**
 * Wrap a string with ansi codes to create bold text.
 *
 * ```js
 * console.log(colors.bold('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  bold
 */

_$ansiColors_457.bold = function bold(message) {
  return _$ansiWrap_1(1, 22, message);
};

/**
 * Wrap a string with ansi codes to create cyan text.
 *
 * ```js
 * console.log(colors.cyan('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  cyan
 */

_$ansiColors_457.cyan = function cyan(message) {
  return _$ansiWrap_1(36, 39, message);
};

/**
 * Wrap a string with ansi codes to create dim text.
 *
 * ```js
 * console.log(colors.dim('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  dim
 */

_$ansiColors_457.dim = function dim(message) {
  return _$ansiWrap_1(2, 22, message);
};

/**
 * Wrap a string with ansi codes to create gray text.
 *
 * ```js
 * console.log(colors.gray('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  gray
 */

_$ansiColors_457.gray = function gray(message) {
  return _$ansiWrap_1(90, 39, message);
};

/**
 * Wrap a string with ansi codes to create green text.
 *
 * ```js
 * console.log(colors.green('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  green
 */

_$ansiColors_457.green = function green(message) {
  return _$ansiWrap_1(32, 39, message);
};

/**
 * Wrap a string with ansi codes to create grey text.
 *
 * ```js
 * console.log(colors.grey('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  grey
 */

_$ansiColors_457.grey = function grey(message) {
  return _$ansiWrap_1(90, 39, message);
};

/**
 * Wrap a string with ansi codes to create hidden text.
 *
 * ```js
 * console.log(colors.hidden('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  hidden
 */

_$ansiColors_457.hidden = function hidden(message) {
  return _$ansiWrap_1(8, 28, message);
};

/**
 * Wrap a string with ansi codes to create inverse text.
 *
 * ```js
 * console.log(colors.inverse('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  inverse
 */

_$ansiColors_457.inverse = function inverse(message) {
  return _$ansiWrap_1(7, 27, message);
};

/**
 * Wrap a string with ansi codes to create italic text.
 *
 * ```js
 * console.log(colors.italic('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  italic
 */

_$ansiColors_457.italic = function italic(message) {
  return _$ansiWrap_1(3, 23, message);
};

/**
 * Wrap a string with ansi codes to create magenta text.
 *
 * ```js
 * console.log(colors.magenta('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  magenta
 */

_$ansiColors_457.magenta = function magenta(message) {
  return _$ansiWrap_1(35, 39, message);
};

/**
 * Wrap a string with ansi codes to create red text.
 *
 * ```js
 * console.log(colors.red('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  red
 */

_$ansiColors_457.red = function red(message) {
  return _$ansiWrap_1(31, 39, message);
};

/**
 * Wrap a string with ansi codes to reset ansi colors currently on the string.
 *
 * ```js
 * console.log(colors.reset('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  reset
 */

_$ansiColors_457.reset = function reset(message) {
  return _$ansiWrap_1(0, 0, message);
};

/**
 * Wrap a string with ansi codes to add a strikethrough to the text.
 *
 * ```js
 * console.log(colors.strikethrough('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  strikethrough
 */

_$ansiColors_457.strikethrough = function strikethrough(message) {
  return _$ansiWrap_1(9, 29, message);
};

/**
 * Wrap a string with ansi codes to underline the text.
 *
 * ```js
 * console.log(colors.underline('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  underline
 */

_$ansiColors_457.underline = function underline(message) {
  return _$ansiWrap_1(4, 24, message);
};

/**
 * Wrap a string with ansi codes to create white text.
 *
 * ```js
 * console.log(colors.white('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  white
 */

_$ansiColors_457.white = function white(message) {
  return _$ansiWrap_1(37, 39, message);
};

/**
 * Wrap a string with ansi codes to create yellow text.
 *
 * ```js
 * console.log(colors.yellow('some string'));
 * ```
 *
 * @param  {string} message String to wrap with ansi codes.
 * @return {string} Wrapped string
 * @api public
 * @name  yellow
 */

_$ansiColors_457.yellow = function yellow(message) {
  return _$ansiWrap_1(33, 39, message);
};

/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

'use strict';

var _$isObject_452 = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

'use strict';

/* removed: var _$isObject_452 = require('isobject'); */;

function isObjectObject(o) {
  return _$isObject_452(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

var _$isPlainObject_450 = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};

/*!
 * is-extendable <https://github.com/jonschlinkert/is-extendable>
 *
 * Copyright (c) 2015-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

'use strict';

/* removed: var _$isPlainObject_450 = require('is-plain-object'); */;

var _$isExtendable_449 = function isExtendable(val) {
  return _$isPlainObject_450(val) || typeof val === 'function' || Array.isArray(val);
};

/*!
 * assign-symbols <https://github.com/jonschlinkert/assign-symbols>
 *
 * Copyright (c) 2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

'use strict';

var _$assignSymbols_4 = function(receiver, objects) {
  if (receiver === null || typeof receiver === 'undefined') {
    throw new TypeError('expected first argument to be an object.');
  }

  if (typeof objects === 'undefined' || typeof Symbol === 'undefined') {
    return receiver;
  }

  if (typeof Object.getOwnPropertySymbols !== 'function') {
    return receiver;
  }

  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var target = Object(receiver);
  var len = arguments.length, i = 0;

  while (++i < len) {
    var provider = Object(arguments[i]);
    var names = Object.getOwnPropertySymbols(provider);

    for (var j = 0; j < names.length; j++) {
      var key = names[j];

      if (isEnumerable.call(provider, key)) {
        target[key] = provider[key];
      }
    }
  }
  return target;
};

'use strict';

/* removed: var _$isExtendable_449 = require('is-extendable'); */;
/* removed: var _$assignSymbols_4 = require('assign-symbols'); */;

var _$extendShallow_446 = Object.assign || function(obj/*, objects*/) {
  if (obj === null || typeof obj === 'undefined') {
    throw new TypeError('Cannot convert undefined or null to object');
  }
  if (!__isObject_446(obj)) {
    obj = {};
  }
  for (var i = 1; i < arguments.length; i++) {
    var val = arguments[i];
    if (__isString_446(val)) {
      val = toObject(val);
    }
    if (__isObject_446(val)) {
      __assign_446(obj, val);
      _$assignSymbols_4(obj, val);
    }
  }
  return obj;
};

function __assign_446(a, b) {
  for (var key in b) {
    if (hasOwn(b, key)) {
      a[key] = b[key];
    }
  }
}

function __isString_446(val) {
  return (val && typeof val === 'string');
}

function toObject(str) {
  var obj = {};
  for (var i in str) {
    obj[i] = str[i];
  }
  return obj;
}

function __isObject_446(val) {
  return (val && typeof val === 'object') || _$isExtendable_449(val);
}

/**
 * Returns true if the given `key` is an own property of `obj`.
 */

function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

function isEnum(obj, key) {
  return Object.prototype.propertyIsEnumerable.call(obj, key);
}

/*!
 * arr-diff <https://github.com/jonschlinkert/arr-diff>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

'use strict';

var _$diff_2 = function diff(arr/*, arrays*/) {
  var len = arguments.length;
  var idx = 0;
  while (++idx < len) {
    arr = diffArray(arr, arguments[idx]);
  }
  return arr;
};

function diffArray(one, two) {
  if (!Array.isArray(two)) {
    return one.slice();
  }

  var tlen = two.length
  var olen = one.length;
  var idx = -1;
  var arr = [];

  while (++idx < olen) {
    var ele = one[idx];

    var hasEle = false;
    for (var i = 0; i < tlen; i++) {
      var val = two[i];

      if (ele === val) {
        hasEle = true;
        break;
      }
    }

    if (hasEle === false) {
      arr.push(ele);
    }
  }
  return arr;
}

'use strict';

var _$union_3 = function union(init) {
  if (!Array.isArray(init)) {
    throw new TypeError('arr-union expects the first argument to be an array.');
  }

  var len = arguments.length;
  var i = 0;

  while (++i < len) {
    var arg = arguments[i];
    if (!arg) continue;

    if (!Array.isArray(arg)) {
      arg = [arg];
    }

    for (var j = 0; j < arg.length; j++) {
      var ele = arg[j];

      if (init.indexOf(ele) >= 0) {
        continue;
      }
      init.push(ele);
    }
  }
  return init;
};

/* removed: var _$util_605 = require('util'); */;
/* removed: var _$ansiColors_457 = require('ansi-colors'); */;
/* removed: var _$extendShallow_446 = require('extend-shallow'); */;
/* removed: var _$diff_2 = require('arr-diff'); */;
/* removed: var _$union_3 = require('arr-union'); */;

var nonEnum = ['message', 'name', 'stack'];
var ignored = _$union_3(nonEnum, ['__safety', '_stack', 'plugin', 'showProperties', 'showStack']);
var props = ['fileName', 'lineNumber', 'message', 'name', 'plugin', 'showProperties', 'showStack', 'stack'];

function PluginError(plugin, message, options) {
  if (!(this instanceof PluginError)) {
    throw new Error('Call PluginError using new');
  }

  Error.call(this);
  var opts = setDefaults(plugin, message, options);
  var self = this;

  // If opts has an error, get details from it
  if (typeof opts.error === 'object') {
    var keys = _$union_3(Object.keys(opts.error), nonEnum);

    // These properties are not enumerable, so we have to add them explicitly.
    keys.forEach(function(prop) {
      self[prop] = opts.error[prop];
    });
  }

  // Opts object can override
  props.forEach(function(prop) {
    if (prop in opts) {
      this[prop] = opts[prop];
    }
  }, this);

  // Defaults
  if (!this.name) {
    this.name = 'Error';
  }
  if (!this.stack) {

    /**
     * `Error.captureStackTrace` appends a stack property which
     * relies on the toString method of the object it is applied to.
     *
     * Since we are using our own toString method which controls when
     * to display the stack trace, if we don't go through this safety
     * object we'll get stack overflow problems.
     */

    var safety = {};
    safety.toString = function() {
      return this._messageWithDetails() + '\nStack:';
    }.bind(this);

    Error.captureStackTrace(safety, arguments.callee || this.constructor);
    this.__safety = safety;
  }
  if (!this.plugin) {
    throw new Error('Missing plugin name');
  }
  if (!this.message) {
    throw new Error('Missing error message');
  }
}

_$util_605.inherits(PluginError, Error);

/**
 * Output a formatted message with details
 */

PluginError.prototype._messageWithDetails = function() {
  var msg = 'Message:\n    ' + this.message;
  var details = this._messageDetails();
  if (details !== '') {
    msg += '\n' + details;
  }
  return msg;
};

/**
 * Output actual message details
 */

PluginError.prototype._messageDetails = function() {
  if (!this.showProperties) {
    return '';
  }

  var props = _$diff_2(Object.keys(this), ignored);
  var len = props.length;

  if (len === 0) {
    return '';
  }

  var res = '';
  var i = 0;
  while (len--) {
    var prop = props[i++];
    res += '    ';
    res += prop + ': ' + this[prop];
    res += '\n';
  }
  return 'Details:\n' + res;
};

/**
 * Override the `toString` method
 */

PluginError.prototype.toString = function() {
  var detailsWithStack = function(stack) {
    return this._messageWithDetails() + '\nStack:\n' + stack;
  }.bind(this);

  var msg = '';
  if (this.showStack) {
    // If there is no wrapped error, use the stack captured in the PluginError ctor
    if (this.__safety) {
      msg = this.__safety.stack;

    } else if (this._stack) {
      msg = detailsWithStack(this._stack);

    } else {
      // Stack from wrapped error
      msg = detailsWithStack(this.stack);
    }
    return message(msg, this);
  }

  msg = this._messageWithDetails();
  return message(msg, this);
};

// Format the output message
function message(msg, thisArg) {
  var sig = _$ansiColors_457.red(thisArg.name);
  sig += ' in plugin ';
  sig += '"' + _$ansiColors_457.cyan(thisArg.plugin) + '"';
  sig += '\n';
  sig += msg;
  return sig;
}

/**
 * Set default options based on arguments.
 */

function setDefaults(plugin, message, opts) {
  if (typeof plugin === 'object') {
    return defaults(plugin);
  }
  opts = opts || {};
  if (message instanceof Error) {
    opts.error = message;
  } else if (typeof message === 'object') {
    opts = message;
  } else {
    opts.message = message;
  }
  opts.plugin = plugin;
  return defaults(opts);
}

/**
 * Extend default options with:
 *
 *  - `showStack`: default=false
 *  - `showProperties`: default=true
 *
 * @param  {Object} `opts` Options to extend
 * @return {Object}
 */

function defaults(opts) {
  return _$extendShallow_446({
    showStack: false,
    showProperties: true,
  }, opts);
}

/**
 * Expose `PluginError`
 */

var _$PluginError_456 = PluginError;

var _$base64_576 = {};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');

/**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */
_$base64_576.encode = function (number) {
  if (0 <= number && number < intToCharMap.length) {
    return intToCharMap[number];
  }
  throw new TypeError("Must be between 0 and 63: " + number);
};

/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */
_$base64_576.decode = function (charCode) {
  var bigA = 65;     // 'A'
  var bigZ = 90;     // 'Z'

  var littleA = 97;  // 'a'
  var littleZ = 122; // 'z'

  var zero = 48;     // '0'
  var nine = 57;     // '9'

  var plus = 43;     // '+'
  var slash = 47;    // '/'

  var littleOffset = 26;
  var numberOffset = 52;

  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
  if (bigA <= charCode && charCode <= bigZ) {
    return (charCode - bigA);
  }

  // 26 - 51: abcdefghijklmnopqrstuvwxyz
  if (littleA <= charCode && charCode <= littleZ) {
    return (charCode - littleA + littleOffset);
  }

  // 52 - 61: 0123456789
  if (zero <= charCode && charCode <= nine) {
    return (charCode - zero + numberOffset);
  }

  // 62: +
  if (charCode == plus) {
    return 62;
  }

  // 63: /
  if (charCode == slash) {
    return 63;
  }

  // Invalid base64 digit.
  return -1;
};

var _$base64Vlq_575 = {};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/* removed: var _$base64_576 = require('./base64'); */;

// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011

var VLQ_BASE_SHIFT = 5;

// binary: 100000
var VLQ_BASE = 1 << VLQ_BASE_SHIFT;

// binary: 011111
var VLQ_BASE_MASK = VLQ_BASE - 1;

// binary: 100000
var VLQ_CONTINUATION_BIT = VLQ_BASE;

/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */
function toVLQSigned(aValue) {
  return aValue < 0
    ? ((-aValue) << 1) + 1
    : (aValue << 1) + 0;
}

/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */
function fromVLQSigned(aValue) {
  var isNegative = (aValue & 1) === 1;
  var shifted = aValue >> 1;
  return isNegative
    ? -shifted
    : shifted;
}

/**
 * Returns the base 64 VLQ encoded value.
 */
_$base64Vlq_575.encode = function base64VLQ_encode(aValue) {
  var encoded = "";
  var digit;

  var vlq = toVLQSigned(aValue);

  do {
    digit = vlq & VLQ_BASE_MASK;
    vlq >>>= VLQ_BASE_SHIFT;
    if (vlq > 0) {
      // There are still more digits in this value, so we must make sure the
      // continuation bit is marked.
      digit |= VLQ_CONTINUATION_BIT;
    }
    encoded += _$base64_576.encode(digit);
  } while (vlq > 0);

  return encoded;
};

/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */
_$base64Vlq_575.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
  var strLen = aStr.length;
  var result = 0;
  var shift = 0;
  var continuation, digit;

  do {
    if (aIndex >= strLen) {
      throw new Error("Expected more digits in base 64 VLQ value.");
    }

    digit = _$base64_576.decode(aStr.charCodeAt(aIndex++));
    if (digit === -1) {
      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
    }

    continuation = !!(digit & VLQ_CONTINUATION_BIT);
    digit &= VLQ_BASE_MASK;
    result = result + (digit << shift);
    shift += VLQ_BASE_SHIFT;
  } while (continuation);

  aOutParam.value = fromVLQSigned(result);
  aOutParam.rest = aIndex;
};

var _$util_583 = {};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */
function getArg(aArgs, aName, aDefaultValue) {
  if (aName in aArgs) {
    return aArgs[aName];
  } else if (arguments.length === 3) {
    return aDefaultValue;
  } else {
    throw new Error('"' + aName + '" is a required argument.');
  }
}
_$util_583.getArg = getArg;

var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
var dataUrlRegexp = /^data:.+\,.+$/;

function urlParse(aUrl) {
  var match = aUrl.match(urlRegexp);
  if (!match) {
    return null;
  }
  return {
    scheme: match[1],
    auth: match[2],
    host: match[3],
    port: match[4],
    path: match[5]
  };
}
_$util_583.urlParse = urlParse;

function urlGenerate(aParsedUrl) {
  var url = '';
  if (aParsedUrl.scheme) {
    url += aParsedUrl.scheme + ':';
  }
  url += '//';
  if (aParsedUrl.auth) {
    url += aParsedUrl.auth + '@';
  }
  if (aParsedUrl.host) {
    url += aParsedUrl.host;
  }
  if (aParsedUrl.port) {
    url += ":" + aParsedUrl.port
  }
  if (aParsedUrl.path) {
    url += aParsedUrl.path;
  }
  return url;
}
_$util_583.urlGenerate = urlGenerate;

/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */
function __normalize_583(aPath) {
  var path = aPath;
  var url = urlParse(aPath);
  if (url) {
    if (!url.path) {
      return aPath;
    }
    path = url.path;
  }
  var isAbsolute = _$util_583.isAbsolute(path);

  var parts = path.split(/\/+/);
  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
    part = parts[i];
    if (part === '.') {
      parts.splice(i, 1);
    } else if (part === '..') {
      up++;
    } else if (up > 0) {
      if (part === '') {
        // The first part is blank if the path is absolute. Trying to go
        // above the root is a no-op. Therefore we can remove all '..' parts
        // directly after the root.
        parts.splice(i + 1, up);
        up = 0;
      } else {
        parts.splice(i, 2);
        up--;
      }
    }
  }
  path = parts.join('/');

  if (path === '') {
    path = isAbsolute ? '/' : '.';
  }

  if (url) {
    url.path = path;
    return urlGenerate(url);
  }
  return path;
}
_$util_583.normalize = __normalize_583;

/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */
function join(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }
  if (aPath === "") {
    aPath = ".";
  }
  var aPathUrl = urlParse(aPath);
  var aRootUrl = urlParse(aRoot);
  if (aRootUrl) {
    aRoot = aRootUrl.path || '/';
  }

  // `join(foo, '//www.example.org')`
  if (aPathUrl && !aPathUrl.scheme) {
    if (aRootUrl) {
      aPathUrl.scheme = aRootUrl.scheme;
    }
    return urlGenerate(aPathUrl);
  }

  if (aPathUrl || aPath.match(dataUrlRegexp)) {
    return aPath;
  }

  // `join('http://', 'www.example.com')`
  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
    aRootUrl.host = aPath;
    return urlGenerate(aRootUrl);
  }

  var joined = aPath.charAt(0) === '/'
    ? aPath
    : __normalize_583(aRoot.replace(/\/+$/, '') + '/' + aPath);

  if (aRootUrl) {
    aRootUrl.path = joined;
    return urlGenerate(aRootUrl);
  }
  return joined;
}
_$util_583.join = join;

_$util_583.isAbsolute = function (aPath) {
  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
};

/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */
function relative(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }

  aRoot = aRoot.replace(/\/$/, '');

  // It is possible for the path to be above the root. In this case, simply
  // checking whether the root is a prefix of the path won't work. Instead, we
  // need to remove components from the root one by one, until either we find
  // a prefix that fits, or we run out of components to remove.
  var level = 0;
  while (aPath.indexOf(aRoot + '/') !== 0) {
    var index = aRoot.lastIndexOf("/");
    if (index < 0) {
      return aPath;
    }

    // If the only part of the root that is left is the scheme (i.e. http://,
    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
    // have exhausted all components, so the path is not relative to the root.
    aRoot = aRoot.slice(0, index);
    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
      return aPath;
    }

    ++level;
  }

  // Make sure we add a "../" for each component we removed from the root.
  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
_$util_583.relative = relative;

var supportsNullProto = (function () {
  var obj = Object.create(null);
  return !('__proto__' in obj);
}());

function __identity_583 (s) {
  return s;
}

/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */
function toSetString(aStr) {
  if (isProtoString(aStr)) {
    return '$' + aStr;
  }

  return aStr;
}
_$util_583.toSetString = supportsNullProto ? __identity_583 : toSetString;

function fromSetString(aStr) {
  if (isProtoString(aStr)) {
    return aStr.slice(1);
  }

  return aStr;
}
_$util_583.fromSetString = supportsNullProto ? __identity_583 : fromSetString;

function isProtoString(s) {
  if (!s) {
    return false;
  }

  var length = s.length;

  if (length < 9 /* "__proto__".length */) {
    return false;
  }

  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
      s.charCodeAt(length - 9) !== 95  /* '_' */) {
    return false;
  }

  for (var i = length - 10; i >= 0; i--) {
    if (s.charCodeAt(i) !== 36 /* '$' */) {
      return false;
    }
  }

  return true;
}

/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */
function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
  var cmp = mappingA.source - mappingB.source;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0 || onlyCompareOriginal) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  return mappingA.name - mappingB.name;
}
_$util_583.compareByOriginalPositions = compareByOriginalPositions;

/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */
function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0 || onlyCompareGenerated) {
    return cmp;
  }

  cmp = mappingA.source - mappingB.source;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return mappingA.name - mappingB.name;
}
_$util_583.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;

function strcmp(aStr1, aStr2) {
  if (aStr1 === aStr2) {
    return 0;
  }

  if (aStr1 > aStr2) {
    return 1;
  }

  return -1;
}

/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */
function compareByGeneratedPositionsInflated(mappingA, mappingB) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
_$util_583.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;

var _$arraySet_574 = {};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/* removed: var _$util_583 = require('./util'); */;
var has = Object.prototype.hasOwnProperty;
var hasNativeMap = typeof Map !== "undefined";

/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */
function ArraySet() {
  this._array = [];
  this._set = hasNativeMap ? new Map() : Object.create(null);
}

/**
 * Static method for creating ArraySet instances from an existing array.
 */
ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
  var set = new ArraySet();
  for (var i = 0, len = aArray.length; i < len; i++) {
    set.add(aArray[i], aAllowDuplicates);
  }
  return set;
};

/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */
ArraySet.prototype.size = function ArraySet_size() {
  return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};

/**
 * Add the given string to this set.
 *
 * @param String aStr
 */
ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
  var sStr = hasNativeMap ? aStr : _$util_583.toSetString(aStr);
  var isDuplicate = hasNativeMap ? this.has(aStr) : has.call(this._set, sStr);
  var idx = this._array.length;
  if (!isDuplicate || aAllowDuplicates) {
    this._array.push(aStr);
  }
  if (!isDuplicate) {
    if (hasNativeMap) {
      this._set.set(aStr, idx);
    } else {
      this._set[sStr] = idx;
    }
  }
};

/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */
ArraySet.prototype.has = function ArraySet_has(aStr) {
  if (hasNativeMap) {
    return this._set.has(aStr);
  } else {
    var sStr = _$util_583.toSetString(aStr);
    return has.call(this._set, sStr);
  }
};

/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */
ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
  if (hasNativeMap) {
    var idx = this._set.get(aStr);
    if (idx >= 0) {
        return idx;
    }
  } else {
    var sStr = _$util_583.toSetString(aStr);
    if (has.call(this._set, sStr)) {
      return this._set[sStr];
    }
  }

  throw new Error('"' + aStr + '" is not in the set.');
};

/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */
ArraySet.prototype.at = function ArraySet_at(aIdx) {
  if (aIdx >= 0 && aIdx < this._array.length) {
    return this._array[aIdx];
  }
  throw new Error('No element indexed by ' + aIdx);
};

/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */
ArraySet.prototype.toArray = function ArraySet_toArray() {
  return this._array.slice();
};

_$arraySet_574.ArraySet = ArraySet;

var _$mappingList_578 = {};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/* removed: var _$util_583 = require('./util'); */;

/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */
function generatedPositionAfter(mappingA, mappingB) {
  // Optimized for most common case
  var lineA = mappingA.generatedLine;
  var lineB = mappingB.generatedLine;
  var columnA = mappingA.generatedColumn;
  var columnB = mappingB.generatedColumn;
  return lineB > lineA || lineB == lineA && columnB >= columnA ||
         _$util_583.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}

/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */
function MappingList() {
  this._array = [];
  this._sorted = true;
  // Serves as infimum
  this._last = {generatedLine: -1, generatedColumn: 0};
}

/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */
MappingList.prototype.unsortedForEach =
  function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
  };

/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */
MappingList.prototype.add = function MappingList_add(aMapping) {
  if (generatedPositionAfter(this._last, aMapping)) {
    this._last = aMapping;
    this._array.push(aMapping);
  } else {
    this._sorted = false;
    this._array.push(aMapping);
  }
};

/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */
MappingList.prototype.toArray = function MappingList_toArray() {
  if (!this._sorted) {
    this._array.sort(_$util_583.compareByGeneratedPositionsInflated);
    this._sorted = true;
  }
  return this._array;
};

_$mappingList_578.MappingList = MappingList;

var _$sourceMapGenerator_581 = {};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/* removed: var _$base64Vlq_575 = require('./base64-vlq'); */;
/* removed: var _$util_583 = require('./util'); */;
var __ArraySet_581 = _$arraySet_574.ArraySet;
var __MappingList_581 = _$mappingList_578.MappingList;

/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */
function SourceMapGenerator(aArgs) {
  if (!aArgs) {
    aArgs = {};
  }
  this._file = _$util_583.getArg(aArgs, 'file', null);
  this._sourceRoot = _$util_583.getArg(aArgs, 'sourceRoot', null);
  this._skipValidation = _$util_583.getArg(aArgs, 'skipValidation', false);
  this._sources = new __ArraySet_581();
  this._names = new __ArraySet_581();
  this._mappings = new __MappingList_581();
  this._sourcesContents = null;
}

SourceMapGenerator.prototype._version = 3;

/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */
SourceMapGenerator.fromSourceMap =
  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new SourceMapGenerator({
      file: aSourceMapConsumer.file,
      sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function (mapping) {
      var newMapping = {
        generated: {
          line: mapping.generatedLine,
          column: mapping.generatedColumn
        }
      };

      if (mapping.source != null) {
        newMapping.source = mapping.source;
        if (sourceRoot != null) {
          newMapping.source = _$util_583.relative(sourceRoot, newMapping.source);
        }

        newMapping.original = {
          line: mapping.originalLine,
          column: mapping.originalColumn
        };

        if (mapping.name != null) {
          newMapping.name = mapping.name;
        }
      }

      generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        generator.setSourceContent(sourceFile, content);
      }
    });
    return generator;
  };

/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */
SourceMapGenerator.prototype.addMapping =
  function SourceMapGenerator_addMapping(aArgs) {
    var generated = _$util_583.getArg(aArgs, 'generated');
    var original = _$util_583.getArg(aArgs, 'original', null);
    var source = _$util_583.getArg(aArgs, 'source', null);
    var name = _$util_583.getArg(aArgs, 'name', null);

    if (!this._skipValidation) {
      this._validateMapping(generated, original, source, name);
    }

    if (source != null) {
      source = String(source);
      if (!this._sources.has(source)) {
        this._sources.add(source);
      }
    }

    if (name != null) {
      name = String(name);
      if (!this._names.has(name)) {
        this._names.add(name);
      }
    }

    this._mappings.add({
      generatedLine: generated.line,
      generatedColumn: generated.column,
      originalLine: original != null && original.line,
      originalColumn: original != null && original.column,
      source: source,
      name: name
    });
  };

/**
 * Set the source content for a source file.
 */
SourceMapGenerator.prototype.setSourceContent =
  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) {
      source = _$util_583.relative(this._sourceRoot, source);
    }

    if (aSourceContent != null) {
      // Add the source content to the _sourcesContents map.
      // Create a new _sourcesContents map if the property is null.
      if (!this._sourcesContents) {
        this._sourcesContents = Object.create(null);
      }
      this._sourcesContents[_$util_583.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
      // Remove the source file from the _sourcesContents map.
      // If the _sourcesContents map is empty, set the property to null.
      delete this._sourcesContents[_$util_583.toSetString(source)];
      if (Object.keys(this._sourcesContents).length === 0) {
        this._sourcesContents = null;
      }
    }
  };

/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */
SourceMapGenerator.prototype.applySourceMap =
  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
      if (aSourceMapConsumer.file == null) {
        throw new Error(
          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
          'or the source map\'s "file" property. Both were omitted.'
        );
      }
      sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) {
      sourceFile = _$util_583.relative(sourceRoot, sourceFile);
    }
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new __ArraySet_581();
    var newNames = new __ArraySet_581();

    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function (mapping) {
      if (mapping.source === sourceFile && mapping.originalLine != null) {
        // Check if it can be mapped by the source map, then update the mapping.
        var original = aSourceMapConsumer.originalPositionFor({
          line: mapping.originalLine,
          column: mapping.originalColumn
        });
        if (original.source != null) {
          // Copy mapping
          mapping.source = original.source;
          if (aSourceMapPath != null) {
            mapping.source = _$util_583.join(aSourceMapPath, mapping.source)
          }
          if (sourceRoot != null) {
            mapping.source = _$util_583.relative(sourceRoot, mapping.source);
          }
          mapping.originalLine = original.line;
          mapping.originalColumn = original.column;
          if (original.name != null) {
            mapping.name = original.name;
          }
        }
      }

      var source = mapping.source;
      if (source != null && !newSources.has(source)) {
        newSources.add(source);
      }

      var name = mapping.name;
      if (name != null && !newNames.has(name)) {
        newNames.add(name);
      }

    }, this);
    this._sources = newSources;
    this._names = newNames;

    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aSourceMapPath != null) {
          sourceFile = _$util_583.join(aSourceMapPath, sourceFile);
        }
        if (sourceRoot != null) {
          sourceFile = _$util_583.relative(sourceRoot, sourceFile);
        }
        this.setSourceContent(sourceFile, content);
      }
    }, this);
  };

/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */
SourceMapGenerator.prototype._validateMapping =
  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
                                              aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
        throw new Error(
            'original.line and original.column are not numbers -- you probably meant to omit ' +
            'the original mapping entirely and only map the generated position. If so, pass ' +
            'null for the original mapping instead of an object with empty or null values.'
        );
    }

    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
        && aGenerated.line > 0 && aGenerated.column >= 0
        && !aOriginal && !aSource && !aName) {
      // Case 1.
      return;
    }
    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
             && aGenerated.line > 0 && aGenerated.column >= 0
             && aOriginal.line > 0 && aOriginal.column >= 0
             && aSource) {
      // Cases 2 and 3.
      return;
    }
    else {
      throw new Error('Invalid mapping: ' + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
      }));
    }
  };

/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */
SourceMapGenerator.prototype._serializeMappings =
  function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = '';
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;

    var mappings = this._mappings.toArray();
    for (var i = 0, len = mappings.length; i < len; i++) {
      mapping = mappings[i];
      next = ''

      if (mapping.generatedLine !== previousGeneratedLine) {
        previousGeneratedColumn = 0;
        while (mapping.generatedLine !== previousGeneratedLine) {
          next += ';';
          previousGeneratedLine++;
        }
      }
      else {
        if (i > 0) {
          if (!_$util_583.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
            continue;
          }
          next += ',';
        }
      }

      next += _$base64Vlq_575.encode(mapping.generatedColumn
                                 - previousGeneratedColumn);
      previousGeneratedColumn = mapping.generatedColumn;

      if (mapping.source != null) {
        sourceIdx = this._sources.indexOf(mapping.source);
        next += _$base64Vlq_575.encode(sourceIdx - previousSource);
        previousSource = sourceIdx;

        // lines are stored 0-based in SourceMap spec version 3
        next += _$base64Vlq_575.encode(mapping.originalLine - 1
                                   - previousOriginalLine);
        previousOriginalLine = mapping.originalLine - 1;

        next += _$base64Vlq_575.encode(mapping.originalColumn
                                   - previousOriginalColumn);
        previousOriginalColumn = mapping.originalColumn;

        if (mapping.name != null) {
          nameIdx = this._names.indexOf(mapping.name);
          next += _$base64Vlq_575.encode(nameIdx - previousName);
          previousName = nameIdx;
        }
      }

      result += next;
    }

    return result;
  };

SourceMapGenerator.prototype._generateSourcesContent =
  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function (source) {
      if (!this._sourcesContents) {
        return null;
      }
      if (aSourceRoot != null) {
        source = _$util_583.relative(aSourceRoot, source);
      }
      var key = _$util_583.toSetString(source);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
        ? this._sourcesContents[key]
        : null;
    }, this);
  };

/**
 * Externalize the source map.
 */
SourceMapGenerator.prototype.toJSON =
  function SourceMapGenerator_toJSON() {
    var map = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    if (this._file != null) {
      map.file = this._file;
    }
    if (this._sourceRoot != null) {
      map.sourceRoot = this._sourceRoot;
    }
    if (this._sourcesContents) {
      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    }

    return map;
  };

/**
 * Render the source map being generated to a string.
 */
SourceMapGenerator.prototype.toString =
  function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
  };

_$sourceMapGenerator_581.SourceMapGenerator = SourceMapGenerator;

var _$binarySearch_577 = {};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

_$binarySearch_577.GREATEST_LOWER_BOUND = 1;
_$binarySearch_577.LEAST_UPPER_BOUND = 2;

/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */
function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
  // This function terminates when one of the following is true:
  //
  //   1. We find the exact element we are looking for.
  //
  //   2. We did not find the exact element, but we can return the index of
  //      the next-closest element.
  //
  //   3. We did not find the exact element, and there is no next-closest
  //      element than the one we are searching for, so we return -1.
  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
  var cmp = aCompare(aNeedle, aHaystack[mid], true);
  if (cmp === 0) {
    // Found the element we are looking for.
    return mid;
  }
  else if (cmp > 0) {
    // Our needle is greater than aHaystack[mid].
    if (aHigh - mid > 1) {
      // The element is in the upper half.
      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
    }

    // The exact needle element was not found in this haystack. Determine if
    // we are in termination case (3) or (2) and return the appropriate thing.
    if (aBias == _$binarySearch_577.LEAST_UPPER_BOUND) {
      return aHigh < aHaystack.length ? aHigh : -1;
    } else {
      return mid;
    }
  }
  else {
    // Our needle is less than aHaystack[mid].
    if (mid - aLow > 1) {
      // The element is in the lower half.
      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
    }

    // we are in termination case (3) or (2) and return the appropriate thing.
    if (aBias == _$binarySearch_577.LEAST_UPPER_BOUND) {
      return mid;
    } else {
      return aLow < 0 ? -1 : aLow;
    }
  }
}

/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */
_$binarySearch_577.search = function search(aNeedle, aHaystack, aCompare, aBias) {
  if (aHaystack.length === 0) {
    return -1;
  }

  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
                              aCompare, aBias || _$binarySearch_577.GREATEST_LOWER_BOUND);
  if (index < 0) {
    return -1;
  }

  // We have found either the exact element, or the next-closest element than
  // the one we are searching for. However, there may be more than one such
  // element. Make sure we always return the smallest of these.
  while (index - 1 >= 0) {
    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
      break;
    }
    --index;
  }

  return index;
};

var _$quickSort_579 = {};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

// It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.

/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */
function swap(ary, x, y) {
  var temp = ary[x];
  ary[x] = ary[y];
  ary[y] = temp;
}

/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */
function randomIntInRange(low, high) {
  return Math.round(low + (Math.random() * (high - low)));
}

/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */
function doQuickSort(ary, comparator, p, r) {
  // If our lower bound is less than our upper bound, we (1) partition the
  // array into two pieces and (2) recurse on each half. If it is not, this is
  // the empty array and our base case.

  if (p < r) {
    // (1) Partitioning.
    //
    // The partitioning chooses a pivot between `p` and `r` and moves all
    // elements that are less than or equal to the pivot to the before it, and
    // all the elements that are greater than it after it. The effect is that
    // once partition is done, the pivot is in the exact place it will be when
    // the array is put in sorted order, and it will not need to be moved
    // again. This runs in O(n) time.

    // Always choose a random pivot so that an input array which is reverse
    // sorted does not cause O(n^2) running time.
    var pivotIndex = randomIntInRange(p, r);
    var i = p - 1;

    swap(ary, pivotIndex, r);
    var pivot = ary[r];

    // Immediately after `j` is incremented in this loop, the following hold
    // true:
    //
    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
    //
    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
    for (var j = p; j < r; j++) {
      if (comparator(ary[j], pivot) <= 0) {
        i += 1;
        swap(ary, i, j);
      }
    }

    swap(ary, i + 1, j);
    var q = i + 1;

    // (2) Recurse on each half.

    doQuickSort(ary, comparator, p, q - 1);
    doQuickSort(ary, comparator, q + 1, r);
  }
}

/**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */
_$quickSort_579.quickSort = function (ary, comparator) {
  doQuickSort(ary, comparator, 0, ary.length - 1);
};

var _$sourceMapConsumer_580 = {};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/* removed: var _$util_583 = require('./util'); */;
/* removed: var _$binarySearch_577 = require('./binary-search'); */;
var __ArraySet_580 = _$arraySet_574.ArraySet;
/* removed: var _$base64Vlq_575 = require('./base64-vlq'); */;
var quickSort = _$quickSort_579.quickSort;

function SourceMapConsumer(aSourceMap) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
  }

  return sourceMap.sections != null
    ? new IndexedSourceMapConsumer(sourceMap)
    : new BasicSourceMapConsumer(sourceMap);
}

SourceMapConsumer.fromSourceMap = function(aSourceMap) {
  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
}

/**
 * The version of the source mapping spec that we are consuming.
 */
SourceMapConsumer.prototype._version = 3;

// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.

SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
  get: function () {
    if (!this.__generatedMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__generatedMappings;
  }
});

SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
  get: function () {
    if (!this.__originalMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__originalMappings;
  }
});

SourceMapConsumer.prototype._charIsMappingSeparator =
  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
  };

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
SourceMapConsumer.prototype._parseMappings =
  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
  };

SourceMapConsumer.GENERATED_ORDER = 1;
SourceMapConsumer.ORIGINAL_ORDER = 2;

SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
SourceMapConsumer.LEAST_UPPER_BOUND = 2;

/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */
SourceMapConsumer.prototype.eachMapping =
  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;

    var mappings;
    switch (order) {
    case SourceMapConsumer.GENERATED_ORDER:
      mappings = this._generatedMappings;
      break;
    case SourceMapConsumer.ORIGINAL_ORDER:
      mappings = this._originalMappings;
      break;
    default:
      throw new Error("Unknown order of iteration.");
    }

    var sourceRoot = this.sourceRoot;
    mappings.map(function (mapping) {
      var source = mapping.source === null ? null : this._sources.at(mapping.source);
      if (source != null && sourceRoot != null) {
        source = _$util_583.join(sourceRoot, source);
      }
      return {
        source: source,
        generatedLine: mapping.generatedLine,
        generatedColumn: mapping.generatedColumn,
        originalLine: mapping.originalLine,
        originalColumn: mapping.originalColumn,
        name: mapping.name === null ? null : this._names.at(mapping.name)
      };
    }, this).forEach(aCallback, context);
  };

/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: Optional. the column number in the original source.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */
SourceMapConsumer.prototype.allGeneratedPositionsFor =
  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = _$util_583.getArg(aArgs, 'line');

    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
      source: _$util_583.getArg(aArgs, 'source'),
      originalLine: line,
      originalColumn: _$util_583.getArg(aArgs, 'column', 0)
    };

    if (this.sourceRoot != null) {
      needle.source = _$util_583.relative(this.sourceRoot, needle.source);
    }
    if (!this._sources.has(needle.source)) {
      return [];
    }
    needle.source = this._sources.indexOf(needle.source);

    var mappings = [];

    var index = this._findMapping(needle,
                                  this._originalMappings,
                                  "originalLine",
                                  "originalColumn",
                                  _$util_583.compareByOriginalPositions,
                                  _$binarySearch_577.LEAST_UPPER_BOUND);
    if (index >= 0) {
      var mapping = this._originalMappings[index];

      if (aArgs.column === undefined) {
        var originalLine = mapping.originalLine;

        // Iterate until either we run out of mappings, or we run into
        // a mapping for a different line than the one we found. Since
        // mappings are sorted, this is guaranteed to find all mappings for
        // the line we found.
        while (mapping && mapping.originalLine === originalLine) {
          mappings.push({
            line: _$util_583.getArg(mapping, 'generatedLine', null),
            column: _$util_583.getArg(mapping, 'generatedColumn', null),
            lastColumn: _$util_583.getArg(mapping, 'lastGeneratedColumn', null)
          });

          mapping = this._originalMappings[++index];
        }
      } else {
        var originalColumn = mapping.originalColumn;

        // Iterate until either we run out of mappings, or we run into
        // a mapping for a different line than the one we were searching for.
        // Since mappings are sorted, this is guaranteed to find all mappings for
        // the line we are searching for.
        while (mapping &&
               mapping.originalLine === line &&
               mapping.originalColumn == originalColumn) {
          mappings.push({
            line: _$util_583.getArg(mapping, 'generatedLine', null),
            column: _$util_583.getArg(mapping, 'generatedColumn', null),
            lastColumn: _$util_583.getArg(mapping, 'lastGeneratedColumn', null)
          });

          mapping = this._originalMappings[++index];
        }
      }
    }

    return mappings;
  };

_$sourceMapConsumer_580.SourceMapConsumer = SourceMapConsumer;

/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The only parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */
function BasicSourceMapConsumer(aSourceMap) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
  }

  var version = _$util_583.getArg(sourceMap, 'version');
  var sources = _$util_583.getArg(sourceMap, 'sources');
  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
  // requires the array) to play nice here.
  var names = _$util_583.getArg(sourceMap, 'names', []);
  var sourceRoot = _$util_583.getArg(sourceMap, 'sourceRoot', null);
  var sourcesContent = _$util_583.getArg(sourceMap, 'sourcesContent', null);
  var mappings = _$util_583.getArg(sourceMap, 'mappings');
  var file = _$util_583.getArg(sourceMap, 'file', null);

  // Once again, Sass deviates from the spec and supplies the version as a
  // string rather than a number, so we use loose equality checking here.
  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  sources = sources
    .map(String)
    // Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map(_$util_583.normalize)
    // Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function (source) {
      return sourceRoot && _$util_583.isAbsolute(sourceRoot) && _$util_583.isAbsolute(source)
        ? _$util_583.relative(sourceRoot, source)
        : source;
    });

  // Pass `true` below to allow duplicate names and sources. While source maps
  // are intended to be compressed and deduplicated, the TypeScript compiler
  // sometimes generates source maps with duplicates in them. See Github issue
  // #72 and bugzil.la/889492.
  this._names = __ArraySet_580.fromArray(names.map(String), true);
  this._sources = __ArraySet_580.fromArray(sources, true);

  this.sourceRoot = sourceRoot;
  this.sourcesContent = sourcesContent;
  this._mappings = mappings;
  this.file = file;
}

BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;

/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @returns BasicSourceMapConsumer
 */
BasicSourceMapConsumer.fromSourceMap =
  function SourceMapConsumer_fromSourceMap(aSourceMap) {
    var smc = Object.create(BasicSourceMapConsumer.prototype);

    var names = smc._names = __ArraySet_580.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = __ArraySet_580.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
                                                            smc.sourceRoot);
    smc.file = aSourceMap._file;

    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.

    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];

    for (var i = 0, length = generatedMappings.length; i < length; i++) {
      var srcMapping = generatedMappings[i];
      var destMapping = new Mapping;
      destMapping.generatedLine = srcMapping.generatedLine;
      destMapping.generatedColumn = srcMapping.generatedColumn;

      if (srcMapping.source) {
        destMapping.source = sources.indexOf(srcMapping.source);
        destMapping.originalLine = srcMapping.originalLine;
        destMapping.originalColumn = srcMapping.originalColumn;

        if (srcMapping.name) {
          destMapping.name = names.indexOf(srcMapping.name);
        }

        destOriginalMappings.push(destMapping);
      }

      destGeneratedMappings.push(destMapping);
    }

    quickSort(smc.__originalMappings, _$util_583.compareByOriginalPositions);

    return smc;
  };

/**
 * The version of the source mapping spec that we are consuming.
 */
BasicSourceMapConsumer.prototype._version = 3;

/**
 * The list of original sources.
 */
Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
  get: function () {
    return this._sources.toArray().map(function (s) {
      return this.sourceRoot != null ? _$util_583.join(this.sourceRoot, s) : s;
    }, this);
  }
});

/**
 * Provide the JIT with a nice shape / hidden class.
 */
function Mapping() {
  this.generatedLine = 0;
  this.generatedColumn = 0;
  this.source = null;
  this.originalLine = null;
  this.originalColumn = null;
  this.name = null;
}

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
BasicSourceMapConsumer.prototype._parseMappings =
  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;

    while (index < length) {
      if (aStr.charAt(index) === ';') {
        generatedLine++;
        index++;
        previousGeneratedColumn = 0;
      }
      else if (aStr.charAt(index) === ',') {
        index++;
      }
      else {
        mapping = new Mapping();
        mapping.generatedLine = generatedLine;

        // Because each offset is encoded relative to the previous one,
        // many segments often have the same encoding. We can exploit this
        // fact by caching the parsed variable length fields of each segment,
        // allowing us to avoid a second parse if we encounter the same
        // segment again.
        for (end = index; end < length; end++) {
          if (this._charIsMappingSeparator(aStr, end)) {
            break;
          }
        }
        str = aStr.slice(index, end);

        segment = cachedSegments[str];
        if (segment) {
          index += str.length;
        } else {
          segment = [];
          while (index < end) {
            _$base64Vlq_575.decode(aStr, index, temp);
            value = temp.value;
            index = temp.rest;
            segment.push(value);
          }

          if (segment.length === 2) {
            throw new Error('Found a source, but no line and column');
          }

          if (segment.length === 3) {
            throw new Error('Found a source and line, but no column');
          }

          cachedSegments[str] = segment;
        }

        // Generated column.
        mapping.generatedColumn = previousGeneratedColumn + segment[0];
        previousGeneratedColumn = mapping.generatedColumn;

        if (segment.length > 1) {
          // Original source.
          mapping.source = previousSource + segment[1];
          previousSource += segment[1];

          // Original line.
          mapping.originalLine = previousOriginalLine + segment[2];
          previousOriginalLine = mapping.originalLine;
          // Lines are stored 0-based
          mapping.originalLine += 1;

          // Original column.
          mapping.originalColumn = previousOriginalColumn + segment[3];
          previousOriginalColumn = mapping.originalColumn;

          if (segment.length > 4) {
            // Original name.
            mapping.name = previousName + segment[4];
            previousName += segment[4];
          }
        }

        generatedMappings.push(mapping);
        if (typeof mapping.originalLine === 'number') {
          originalMappings.push(mapping);
        }
      }
    }

    quickSort(generatedMappings, _$util_583.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;

    quickSort(originalMappings, _$util_583.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
  };

/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */
BasicSourceMapConsumer.prototype._findMapping =
  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
                                         aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.

    if (aNeedle[aLineName] <= 0) {
      throw new TypeError('Line must be greater than or equal to 1, got '
                          + aNeedle[aLineName]);
    }
    if (aNeedle[aColumnName] < 0) {
      throw new TypeError('Column must be greater than or equal to 0, got '
                          + aNeedle[aColumnName]);
    }

    return _$binarySearch_577.search(aNeedle, aMappings, aComparator, aBias);
  };

/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */
BasicSourceMapConsumer.prototype.computeColumnSpans =
  function SourceMapConsumer_computeColumnSpans() {
    for (var index = 0; index < this._generatedMappings.length; ++index) {
      var mapping = this._generatedMappings[index];

      // Mappings do not contain a field for the last generated columnt. We
      // can come up with an optimistic estimate, however, by assuming that
      // mappings are contiguous (i.e. given two consecutive mappings, the
      // first mapping ends where the second one starts).
      if (index + 1 < this._generatedMappings.length) {
        var nextMapping = this._generatedMappings[index + 1];

        if (mapping.generatedLine === nextMapping.generatedLine) {
          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
          continue;
        }
      }

      // The last mapping for each line spans the entire line.
      mapping.lastGeneratedColumn = Infinity;
    }
  };

/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */
BasicSourceMapConsumer.prototype.originalPositionFor =
  function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
      generatedLine: _$util_583.getArg(aArgs, 'line'),
      generatedColumn: _$util_583.getArg(aArgs, 'column')
    };

    var index = this._findMapping(
      needle,
      this._generatedMappings,
      "generatedLine",
      "generatedColumn",
      _$util_583.compareByGeneratedPositionsDeflated,
      _$util_583.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
    );

    if (index >= 0) {
      var mapping = this._generatedMappings[index];

      if (mapping.generatedLine === needle.generatedLine) {
        var source = _$util_583.getArg(mapping, 'source', null);
        if (source !== null) {
          source = this._sources.at(source);
          if (this.sourceRoot != null) {
            source = _$util_583.join(this.sourceRoot, source);
          }
        }
        var name = _$util_583.getArg(mapping, 'name', null);
        if (name !== null) {
          name = this._names.at(name);
        }
        return {
          source: source,
          line: _$util_583.getArg(mapping, 'originalLine', null),
          column: _$util_583.getArg(mapping, 'originalColumn', null),
          name: name
        };
      }
    }

    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  };

/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
  function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) {
      return false;
    }
    return this.sourcesContent.length >= this._sources.size() &&
      !this.sourcesContent.some(function (sc) { return sc == null; });
  };

/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
BasicSourceMapConsumer.prototype.sourceContentFor =
  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) {
      return null;
    }

    if (this.sourceRoot != null) {
      aSource = _$util_583.relative(this.sourceRoot, aSource);
    }

    if (this._sources.has(aSource)) {
      return this.sourcesContent[this._sources.indexOf(aSource)];
    }

    var url;
    if (this.sourceRoot != null
        && (url = _$util_583.urlParse(this.sourceRoot))) {
      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
      // many users. We can help them out when they expect file:// URIs to
      // behave like it would if they were running a local HTTP server. See
      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
      if (url.scheme == "file"
          && this._sources.has(fileUriAbsPath)) {
        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
      }

      if ((!url.path || url.path == "/")
          && this._sources.has("/" + aSource)) {
        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
      }
    }

    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) {
      return null;
    }
    else {
      throw new Error('"' + aSource + '" is not in the SourceMap.');
    }
  };

/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */
BasicSourceMapConsumer.prototype.generatedPositionFor =
  function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = _$util_583.getArg(aArgs, 'source');
    if (this.sourceRoot != null) {
      source = _$util_583.relative(this.sourceRoot, source);
    }
    if (!this._sources.has(source)) {
      return {
        line: null,
        column: null,
        lastColumn: null
      };
    }
    source = this._sources.indexOf(source);

    var needle = {
      source: source,
      originalLine: _$util_583.getArg(aArgs, 'line'),
      originalColumn: _$util_583.getArg(aArgs, 'column')
    };

    var index = this._findMapping(
      needle,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      _$util_583.compareByOriginalPositions,
      _$util_583.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
    );

    if (index >= 0) {
      var mapping = this._originalMappings[index];

      if (mapping.source === needle.source) {
        return {
          line: _$util_583.getArg(mapping, 'generatedLine', null),
          column: _$util_583.getArg(mapping, 'generatedColumn', null),
          lastColumn: _$util_583.getArg(mapping, 'lastGeneratedColumn', null)
        };
      }
    }

    return {
      line: null,
      column: null,
      lastColumn: null
    };
  };

_$sourceMapConsumer_580.BasicSourceMapConsumer = BasicSourceMapConsumer;

/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The only parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */
function IndexedSourceMapConsumer(aSourceMap) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
  }

  var version = _$util_583.getArg(sourceMap, 'version');
  var sections = _$util_583.getArg(sourceMap, 'sections');

  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  this._sources = new __ArraySet_580();
  this._names = new __ArraySet_580();

  var lastOffset = {
    line: -1,
    column: 0
  };
  this._sections = sections.map(function (s) {
    if (s.url) {
      // The url field will require support for asynchronicity.
      // See https://github.com/mozilla/source-map/issues/16
      throw new Error('Support for url field in sections not implemented.');
    }
    var offset = _$util_583.getArg(s, 'offset');
    var offsetLine = _$util_583.getArg(offset, 'line');
    var offsetColumn = _$util_583.getArg(offset, 'column');

    if (offsetLine < lastOffset.line ||
        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
      throw new Error('Section offsets must be ordered and non-overlapping.');
    }
    lastOffset = offset;

    return {
      generatedOffset: {
        // The offset fields are 0-based, but we use 1-based indices when
        // encoding/decoding from VLQ.
        generatedLine: offsetLine + 1,
        generatedColumn: offsetColumn + 1
      },
      consumer: new SourceMapConsumer(_$util_583.getArg(s, 'map'))
    }
  });
}

IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;

/**
 * The version of the source mapping spec that we are consuming.
 */
IndexedSourceMapConsumer.prototype._version = 3;

/**
 * The list of original sources.
 */
Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
  get: function () {
    var sources = [];
    for (var i = 0; i < this._sections.length; i++) {
      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
        sources.push(this._sections[i].consumer.sources[j]);
      }
    }
    return sources;
  }
});

/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */
IndexedSourceMapConsumer.prototype.originalPositionFor =
  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
      generatedLine: _$util_583.getArg(aArgs, 'line'),
      generatedColumn: _$util_583.getArg(aArgs, 'column')
    };

    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = _$binarySearch_577.search(needle, this._sections,
      function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) {
          return cmp;
        }

        return (needle.generatedColumn -
                section.generatedOffset.generatedColumn);
      });
    var section = this._sections[sectionIndex];

    if (!section) {
      return {
        source: null,
        line: null,
        column: null,
        name: null
      };
    }

    return section.consumer.originalPositionFor({
      line: needle.generatedLine -
        (section.generatedOffset.generatedLine - 1),
      column: needle.generatedColumn -
        (section.generatedOffset.generatedLine === needle.generatedLine
         ? section.generatedOffset.generatedColumn - 1
         : 0),
      bias: aArgs.bias
    });
  };

/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function (s) {
      return s.consumer.hasContentsOfAllSources();
    });
  };

/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
IndexedSourceMapConsumer.prototype.sourceContentFor =
  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];

      var content = section.consumer.sourceContentFor(aSource, true);
      if (content) {
        return content;
      }
    }
    if (nullOnMissing) {
      return null;
    }
    else {
      throw new Error('"' + aSource + '" is not in the SourceMap.');
    }
  };

/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */
IndexedSourceMapConsumer.prototype.generatedPositionFor =
  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];

      // Only consider this section if the requested source is in the list of
      // sources of the consumer.
      if (section.consumer.sources.indexOf(_$util_583.getArg(aArgs, 'source')) === -1) {
        continue;
      }
      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
      if (generatedPosition) {
        var ret = {
          line: generatedPosition.line +
            (section.generatedOffset.generatedLine - 1),
          column: generatedPosition.column +
            (section.generatedOffset.generatedLine === generatedPosition.line
             ? section.generatedOffset.generatedColumn - 1
             : 0)
        };
        return ret;
      }
    }

    return {
      line: null,
      column: null
    };
  };

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
IndexedSourceMapConsumer.prototype._parseMappings =
  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];
      var sectionMappings = section.consumer._generatedMappings;
      for (var j = 0; j < sectionMappings.length; j++) {
        var mapping = sectionMappings[j];

        var source = section.consumer._sources.at(mapping.source);
        if (section.consumer.sourceRoot !== null) {
          source = _$util_583.join(section.consumer.sourceRoot, source);
        }
        this._sources.add(source);
        source = this._sources.indexOf(source);

        var name = section.consumer._names.at(mapping.name);
        this._names.add(name);
        name = this._names.indexOf(name);

        // The mappings coming from the consumer for the section have
        // generated positions relative to the start of the section, so we
        // need to offset them to be relative to the start of the concatenated
        // generated file.
        var adjustedMapping = {
          source: source,
          generatedLine: mapping.generatedLine +
            (section.generatedOffset.generatedLine - 1),
          generatedColumn: mapping.generatedColumn +
            (section.generatedOffset.generatedLine === mapping.generatedLine
            ? section.generatedOffset.generatedColumn - 1
            : 0),
          originalLine: mapping.originalLine,
          originalColumn: mapping.originalColumn,
          name: name
        };

        this.__generatedMappings.push(adjustedMapping);
        if (typeof adjustedMapping.originalLine === 'number') {
          this.__originalMappings.push(adjustedMapping);
        }
      }
    }

    quickSort(this.__generatedMappings, _$util_583.compareByGeneratedPositionsDeflated);
    quickSort(this.__originalMappings, _$util_583.compareByOriginalPositions);
  };

_$sourceMapConsumer_580.IndexedSourceMapConsumer = IndexedSourceMapConsumer;

var _$sourceNode_582 = {};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var __SourceMapGenerator_582 = _$sourceMapGenerator_581.SourceMapGenerator;
/* removed: var _$util_583 = require('./util'); */;

// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).
var REGEX_NEWLINE = /(\r?\n)/;

// Newline character code for charCodeAt() comparisons
var NEWLINE_CODE = 10;

// Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!
var isSourceNode = "$$$isSourceNode$$$";

/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */
function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
  this.children = [];
  this.sourceContents = {};
  this.line = aLine == null ? null : aLine;
  this.column = aColumn == null ? null : aColumn;
  this.source = aSource == null ? null : aSource;
  this.name = aName == null ? null : aName;
  this[isSourceNode] = true;
  if (aChunks != null) this.add(aChunks);
}

/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */
SourceNode.fromStringWithSourceMap =
  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
    // The SourceNode we want to fill with the generated code
    // and the SourceMap
    var node = new SourceNode();

    // All even indices of this array are one line of the generated code,
    // while all odd indices are the newlines between two adjacent lines
    // (since `REGEX_NEWLINE` captures its match).
    // Processed fragments are accessed by calling `shiftNextLine`.
    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
    var remainingLinesIndex = 0;
    var shiftNextLine = function() {
      var lineContents = getNextLine();
      // The last line of a file might not have a newline.
      var newLine = getNextLine() || "";
      return lineContents + newLine;

      function getNextLine() {
        return remainingLinesIndex < remainingLines.length ?
            remainingLines[remainingLinesIndex++] : undefined;
      }
    };

    // We need to remember the position of "remainingLines"
    var lastGeneratedLine = 1, lastGeneratedColumn = 0;

    // The generate SourceNodes we need a code range.
    // To extract it current and last mapping is used.
    // Here we store the last mapping.
    var lastMapping = null;

    aSourceMapConsumer.eachMapping(function (mapping) {
      if (lastMapping !== null) {
        // We add the code from "lastMapping" to "mapping":
        // First check if there is a new line in between.
        if (lastGeneratedLine < mapping.generatedLine) {
          // Associate first line with "lastMapping"
          addMappingWithCode(lastMapping, shiftNextLine());
          lastGeneratedLine++;
          lastGeneratedColumn = 0;
          // The remaining code is added without mapping
        } else {
          // There is no new line in between.
          // Associate the code between "lastGeneratedColumn" and
          // "mapping.generatedColumn" with "lastMapping"
          var nextLine = remainingLines[remainingLinesIndex];
          var code = nextLine.substr(0, mapping.generatedColumn -
                                        lastGeneratedColumn);
          remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn -
                                              lastGeneratedColumn);
          lastGeneratedColumn = mapping.generatedColumn;
          addMappingWithCode(lastMapping, code);
          // No more remaining code, continue
          lastMapping = mapping;
          return;
        }
      }
      // We add the generated code until the first mapping
      // to the SourceNode without any mapping.
      // Each line is added as separate string.
      while (lastGeneratedLine < mapping.generatedLine) {
        node.add(shiftNextLine());
        lastGeneratedLine++;
      }
      if (lastGeneratedColumn < mapping.generatedColumn) {
        var nextLine = remainingLines[remainingLinesIndex];
        node.add(nextLine.substr(0, mapping.generatedColumn));
        remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
        lastGeneratedColumn = mapping.generatedColumn;
      }
      lastMapping = mapping;
    }, this);
    // We have processed all mappings.
    if (remainingLinesIndex < remainingLines.length) {
      if (lastMapping) {
        // Associate the remaining code in the current line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
      }
      // and add the remaining lines without any mapping
      node.add(remainingLines.splice(remainingLinesIndex).join(""));
    }

    // Copy sourcesContent into SourceNode
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aRelativePath != null) {
          sourceFile = _$util_583.join(aRelativePath, sourceFile);
        }
        node.setSourceContent(sourceFile, content);
      }
    });

    return node;

    function addMappingWithCode(mapping, code) {
      if (mapping === null || mapping.source === undefined) {
        node.add(code);
      } else {
        var source = aRelativePath
          ? _$util_583.join(aRelativePath, mapping.source)
          : mapping.source;
        node.add(new SourceNode(mapping.originalLine,
                                mapping.originalColumn,
                                source,
                                code,
                                mapping.name));
      }
    }
  };

/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */
SourceNode.prototype.add = function SourceNode_add(aChunk) {
  if (Array.isArray(aChunk)) {
    aChunk.forEach(function (chunk) {
      this.add(chunk);
    }, this);
  }
  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    if (aChunk) {
      this.children.push(aChunk);
    }
  }
  else {
    throw new TypeError(
      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
    );
  }
  return this;
};

/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */
SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
  if (Array.isArray(aChunk)) {
    for (var i = aChunk.length-1; i >= 0; i--) {
      this.prepend(aChunk[i]);
    }
  }
  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    this.children.unshift(aChunk);
  }
  else {
    throw new TypeError(
      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
    );
  }
  return this;
};

/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */
SourceNode.prototype.walk = function SourceNode_walk(aFn) {
  var chunk;
  for (var i = 0, len = this.children.length; i < len; i++) {
    chunk = this.children[i];
    if (chunk[isSourceNode]) {
      chunk.walk(aFn);
    }
    else {
      if (chunk !== '') {
        aFn(chunk, { source: this.source,
                     line: this.line,
                     column: this.column,
                     name: this.name });
      }
    }
  }
};

/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */
SourceNode.prototype.join = function SourceNode_join(aSep) {
  var newChildren;
  var i;
  var len = this.children.length;
  if (len > 0) {
    newChildren = [];
    for (i = 0; i < len-1; i++) {
      newChildren.push(this.children[i]);
      newChildren.push(aSep);
    }
    newChildren.push(this.children[i]);
    this.children = newChildren;
  }
  return this;
};

/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */
SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
  var lastChild = this.children[this.children.length - 1];
  if (lastChild[isSourceNode]) {
    lastChild.replaceRight(aPattern, aReplacement);
  }
  else if (typeof lastChild === 'string') {
    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
  }
  else {
    this.children.push(''.replace(aPattern, aReplacement));
  }
  return this;
};

/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */
SourceNode.prototype.setSourceContent =
  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
    this.sourceContents[_$util_583.toSetString(aSourceFile)] = aSourceContent;
  };

/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */
SourceNode.prototype.walkSourceContents =
  function SourceNode_walkSourceContents(aFn) {
    for (var i = 0, len = this.children.length; i < len; i++) {
      if (this.children[i][isSourceNode]) {
        this.children[i].walkSourceContents(aFn);
      }
    }

    var sources = Object.keys(this.sourceContents);
    for (var i = 0, len = sources.length; i < len; i++) {
      aFn(_$util_583.fromSetString(sources[i]), this.sourceContents[sources[i]]);
    }
  };

/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */
SourceNode.prototype.toString = function SourceNode_toString() {
  var str = "";
  this.walk(function (chunk) {
    str += chunk;
  });
  return str;
};

/**
 * Returns the string representation of this source node along with a source
 * map.
 */
SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
  var generated = {
    code: "",
    line: 1,
    column: 0
  };
  var map = new __SourceMapGenerator_582(aArgs);
  var sourceMappingActive = false;
  var lastOriginalSource = null;
  var lastOriginalLine = null;
  var lastOriginalColumn = null;
  var lastOriginalName = null;
  this.walk(function (chunk, original) {
    generated.code += chunk;
    if (original.source !== null
        && original.line !== null
        && original.column !== null) {
      if(lastOriginalSource !== original.source
         || lastOriginalLine !== original.line
         || lastOriginalColumn !== original.column
         || lastOriginalName !== original.name) {
        map.addMapping({
          source: original.source,
          original: {
            line: original.line,
            column: original.column
          },
          generated: {
            line: generated.line,
            column: generated.column
          },
          name: original.name
        });
      }
      lastOriginalSource = original.source;
      lastOriginalLine = original.line;
      lastOriginalColumn = original.column;
      lastOriginalName = original.name;
      sourceMappingActive = true;
    } else if (sourceMappingActive) {
      map.addMapping({
        generated: {
          line: generated.line,
          column: generated.column
        }
      });
      lastOriginalSource = null;
      sourceMappingActive = false;
    }
    for (var idx = 0, length = chunk.length; idx < length; idx++) {
      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
        generated.line++;
        generated.column = 0;
        // Mappings end at eol
        if (idx + 1 === length) {
          lastOriginalSource = null;
          sourceMappingActive = false;
        } else if (sourceMappingActive) {
          map.addMapping({
            source: original.source,
            original: {
              line: original.line,
              column: original.column
            },
            generated: {
              line: generated.line,
              column: generated.column
            },
            name: original.name
          });
        }
      } else {
        generated.column++;
      }
    }
  });
  this.walkSourceContents(function (sourceFile, sourceContent) {
    map.setSourceContent(sourceFile, sourceContent);
  });

  return { code: generated.code, map: map };
};

_$sourceNode_582.SourceNode = SourceNode;

var _$sourceMap_584 = {};
/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
_$sourceMap_584.SourceMapGenerator = _$sourceMapGenerator_581.SourceMapGenerator;
_$sourceMap_584.SourceMapConsumer = _$sourceMapConsumer_580.SourceMapConsumer;
_$sourceMap_584.SourceNode = _$sourceNode_582.SourceNode;

'use strict';
var __SourceMapGenerator_606 = _$sourceMap_584.SourceMapGenerator;
var __SourceMapConsumer_606 = _$sourceMap_584.SourceMapConsumer;
var _$applySourceMap_606 = function applySourceMap(file, sourceMap) {
    if (typeof sourceMap === 'string' || sourceMap instanceof String) {
        sourceMap = JSON.parse(sourceMap);
    }
    if (file.sourceMap && (typeof file.sourceMap === 'string' || file.sourceMap instanceof String)) {
        file.sourceMap = JSON.parse(file.sourceMap);
    }
    assertProperty(sourceMap, 'file');
    assertProperty(sourceMap, 'mappings');
    assertProperty(sourceMap, 'sources');
    sourceMap.file = sourceMap.file.replace(/\\/g, '/');
    sourceMap.sources = sourceMap.sources.map(function (filePath) {
        return filePath.replace(/\\/g, '/');
    });
    if (file.sourceMap && file.sourceMap.mappings !== '') {
        var generator = __SourceMapGenerator_606.fromSourceMap(new __SourceMapConsumer_606(sourceMap));
        generator.applySourceMap(new __SourceMapConsumer_606(file.sourceMap));
        file.sourceMap = JSON.parse(generator.toString());
    } else {
        file.sourceMap = sourceMap;
    }
};
function assertProperty(sourceMap, propertyName) {
    if (!sourceMap.hasOwnProperty(propertyName)) {
        var e = new Error('Source map to be applied is missing the "' + propertyName + '" property');
        throw e;
    }
}
var _$gulpJavaScriptObfuscator_gulpJavascriptObfuscator = {};
(function (Buffer){(function (){
/* removed: const _$through2_585 = require('through2'); */;
/* removed: const _$File_607 = require('vinyl'); */;
/* removed: const _$indexBrowser_453 = require('javascript-obfuscator'); */;
/* removed: const _$PluginError_456 = require('plugin-error'); */;
/* removed: const _$applySourceMap_606 = require('vinyl-sourcemaps-apply'); */;

_$gulpJavaScriptObfuscator_gulpJavascriptObfuscator = function gulpJavaScriptObfuscator (options = {}) {
	return _$through2_585.obj(function (file, enc, cb) {
		if (file.isNull()) return cb(null, file);
		if (!file.isBuffer()) throw new _$PluginError_456('gulp-javascript-obfuscator', 'Only Buffers are supported!');
		if (file.sourceMap) {
			options.sourceMap = true;
			options.inputFileName = file.relative;
			options.sourceMapMode = 'separate';
		}

		try {
			const obfuscationResult = _$indexBrowser_453.obfuscate(String(file.contents), options);
			file.contents = new Buffer(obfuscationResult.getObfuscatedCode());
			if (options.sourceMap && options.sourceMapMode !== 'inline') {
				if ( file.sourceMap ) {
					const sourceMap = JSON.parse(obfuscationResult.getSourceMap());
					sourceMap.file = file.sourceMap.file;
					_$applySourceMap_606(file, sourceMap);
				}
				else {
					this.push(new _$File_607({
						cwd: file.cwd,
						base: file.base,
						path: file.path + '.map',
						contents: new Buffer(obfuscationResult.getSourceMap())
					}))
				}
			}
			return cb(null, file);
		} catch (err) {
			throw new _$PluginError_456('gulp-javascript-obfuscator', err);
		}
	});
};

}).call(this)}).call(this,_$buffer_8({}).Buffer)
var _$uglifycssLib_601 = {};
(function (process){(function (){
/**
 * UglifyCSS
 * Port of YUI CSS Compressor to NodeJS
 * Author: Franck Marcia - https://github.com/fmarcia
 * MIT licenced
 */

/**
 * cssmin.js
 * Author: Stoyan Stefanov - http://phpied.com/
 * This is a JavaScript port of the CSS minification tool
 * distributed with YUICompressor, itself a port
 * of the cssmin utility by Isaac Schlueter - http://foohack.com/
 * Permission is hereby granted to use the JavaScript version under the same
 * conditions as the YUICompressor (original YUICompressor note below).
 */

/**
 * YUI Compressor
 * http://developer.yahoo.com/yui/compressor/
 * Author: Julien Lecomte - http://www.julienlecomte.net/
 * Copyright (c) 2011 Yahoo! Inc. All rights reserved.
 * The copyrights embodied in the content of this file are licensed
 * by Yahoo! Inc. under the BSD (revised) open source license.
 */

'use strict';

/* removed: var _$_empty_7 = require('fs'); */;
/* removed: var _$pathBrowserify_455 = require('path'); */;

var SEP = "/";
var PATH_SEP = _$pathBrowserify_455.sep;
var ___PRESERVED_TOKEN_ = "___PRESERVED_TOKEN_";

var defaultOptions = {
    maxLineLen: 0,
    expandVars: false,
    uglyComments: false,
    cuteComments: false,
    convertUrls: "",
    debug: false
};

/**
 * Utility method to convert relative urls and replace them with tokens before
 * we start compressing. It must be called *after* extractDataUrls
 *
 * @private
 * @function convertRelativeUrls
 * @param {String} css The input css
 * @param {Object} options Options
 * @param {Array} The global array of tokens to preserve
 * @returns String The processed css
 */
function convertRelativeUrls(css, options, preservedTokens) {

    var maxIndex = css.length - 1,
        appendIndex = 0,
        startIndex,
        endIndex,
        terminator,
        foundTerminator,
        sb = [],
        m,
        preserver,
        token,
        url,
        file,
        target,
        pattern = /(url\s*\()\s*(["']?)/g;

    // Since we need to account for non-base64 data urls, we need to handle
    // ' and ) being part of the data string. Hence switching to indexOf,
    // to determine whether or not we have matching string terminators and
    // handling sb appends directly, instead of using matcher.append* methods.

    while ((m = pattern.exec(css)) !== null) {

        startIndex = m.index + m[1].length;  // "url(".length()
        terminator = m[2];         // ', " or empty (not quoted)

        if (terminator.length === 0) {
            terminator = ")";
        }

        foundTerminator = false;

        endIndex = pattern.lastIndex - 1;

        while(foundTerminator === false && endIndex+1 <= maxIndex) {
            endIndex = css.indexOf(terminator, endIndex + 1);

            // endIndex == 0 doesn't really apply here
            if ((endIndex > 0) && (css.charAt(endIndex - 1) !== '\\')) {
                foundTerminator = true;
                if (")" != terminator) {
                    endIndex = css.indexOf(")", endIndex);
                }
            }
        }

        // Enough searching, start moving stuff over to the buffer
        sb.push(css.substring(appendIndex, m.index));

        if (foundTerminator) {

            token = css.substring(startIndex, endIndex).replace(/(^\s*|\s*$)/g, "");
            if (token.slice(0, 19) !== ___PRESERVED_TOKEN_) {

                if (terminator === "'" || terminator === '"') {
                    token = token.slice(1, -1);
                } else if (terminator === ")") {
                    terminator = "";
                }

                if (options.convertUrls && token.charAt(0) !== SEP && token.slice(0, 7) !== "http://" && token.slice(0, 8) !== "https://") {

                    // build path of detected urls
                    target = options.target.slice();
                    token = token.split(SEP).join(PATH_SEP); // assuming urls in css use "/"
                    url = _$pathBrowserify_455.resolve(options.source.join(PATH_SEP), token).split(PATH_SEP);

                    file = url.pop();

                    // remove common part of both paths
                    while (target[0] === url[0]) {
                        target.shift();
                        url.shift();
                    }

                    for (var i = 0, l = target.length; i < l; ++i) {
                        target[i] = "..";
                    }
                    url = terminator + target.concat(url, file).join(SEP) + terminator;

                } else {
                    url = terminator + token + terminator;
                }

                preservedTokens.push(url);

                preserver = "url(" + ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___)";
                sb.push(preserver);

            } else {
                sb.push("url(" + token + ")");
            }

            appendIndex = endIndex + 1;

        } else {
            // No end terminator found, re-add the whole match. Should we throw/warn here?
            sb.push(css.substring(m.index, pattern.lastIndex));
            appendIndex = pattern.lastIndex;
        }
    }

    sb.push(css.substring(appendIndex));

    return sb.join("");
}

/**
 * Utility method to replace all data urls with tokens before we start
 * compressing, to avoid performance issues running some of the subsequent
 * regexes against large strings chunks.
 *
 * @private
 * @function extractDataUrls
 * @param {String} css The input css
 * @param {Array} The global array of tokens to preserve
 * @returns String The processed css
 */
function extractDataUrls(css, preservedTokens) {

    // Leave data urls alone to increase parse performance.
    var maxIndex = css.length - 1,
        appendIndex = 0,
        startIndex,
        endIndex,
        terminator,
        foundTerminator,
        sb = [],
        m,
        preserver,
        token,
        pattern = /url\(\s*(["']?)data\:/g;

    // Since we need to account for non-base64 data urls, we need to handle
    // ' and ) being part of the data string. Hence switching to indexOf,
    // to determine whether or not we have matching string terminators and
    // handling sb appends directly, instead of using matcher.append* methods.

    while ((m = pattern.exec(css)) !== null) {

        startIndex = m.index + 4;  // "url(".length()
        terminator = m[1];         // ', " or empty (not quoted)

        if (terminator.length === 0) {
            terminator = ")";
        }

        foundTerminator = false;

        endIndex = pattern.lastIndex - 1;

        while(foundTerminator === false && endIndex+1 <= maxIndex) {
            endIndex = css.indexOf(terminator, endIndex + 1);

            // endIndex == 0 doesn't really apply here
            if ((endIndex > 0) && (css.charAt(endIndex - 1) !== '\\')) {
                foundTerminator = true;
                if (")" != terminator) {
                    endIndex = css.indexOf(")", endIndex);
                }
            }
        }

        // Enough searching, start moving stuff over to the buffer
        sb.push(css.substring(appendIndex, m.index));

        if (foundTerminator) {

            token = css.substring(startIndex, endIndex);
            var parts = token.split(",");
            if (parts.length > 1 && parts[0].slice(-7) == ";base64") {
                token = token.replace(/\s+/g, "");
            } else {
                token = token.replace(/\n/g, " ");
                token = token.replace(/\s+/g, " ");
                token = token.replace(/(^\s+|\s+$)/g, "");
            }

            preservedTokens.push(token);

            preserver = "url(" + ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___)";
            sb.push(preserver);

            appendIndex = endIndex + 1;
        } else {
            // No end terminator found, re-add the whole match. Should we throw/warn here?
            sb.push(css.substring(m.index, pattern.lastIndex));
            appendIndex = pattern.lastIndex;
        }
    }

    sb.push(css.substring(appendIndex));

    return sb.join("");
}

/**
 * Utility method to compress hex color values of the form #AABBCC to #ABC.
 *
 * DOES NOT compress CSS ID selectors which match the above pattern (which would break things).
 * e.g. #AddressForm { ... }
 *
 * DOES NOT compress IE filters, which have hex color values (which would break things).
 * e.g. filter: chroma(color="#FFFFFF");
 *
 * DOES NOT compress invalid hex values.
 * e.g. background-color: #aabbccdd
 *
 * @private
 * @function compressHexColors
 * @param {String} css The input css
 * @returns String The processed css
 */
function compressHexColors(css) {

    // Look for hex colors inside { ... } (to avoid IDs) and which don't have a =, or a " in front of them (to avoid filters)
    var pattern = /(\=\s*?["']?)?#([0-9a-f])([0-9a-f])([0-9a-f])([0-9a-f])([0-9a-f])([0-9a-f])(\}|[^0-9a-f{][^{]*?\})/gi,
        m,
        index = 0,
        isFilter,
        sb = [];

    while ((m = pattern.exec(css)) !== null) {

        sb.push(css.substring(index, m.index));

        isFilter = m[1];

        if (isFilter) {
            // Restore, maintain case, otherwise filter will break
            sb.push(m[1] + "#" + (m[2] + m[3] + m[4] + m[5] + m[6] + m[7]));
        } else {
            if (m[2].toLowerCase() == m[3].toLowerCase() &&
                m[4].toLowerCase() == m[5].toLowerCase() &&
                m[6].toLowerCase() == m[7].toLowerCase()) {

                // Compress.
                sb.push("#" + (m[3] + m[5] + m[7]).toLowerCase());
            } else {
                // Non compressible color, restore but lower case.
                sb.push("#" + (m[2] + m[3] + m[4] + m[5] + m[6] + m[7]).toLowerCase());
            }
        }

        index = pattern.lastIndex = pattern.lastIndex - m[8].length;
    }

    sb.push(css.substring(index));

    return sb.join("");
}

// Preserve 0 followed by unit in keyframes steps

function keyframes(content, preservedTokens) {

    var level,
        buffer,
        buffers,
        pattern = /@[a-z0-9-_]*keyframes\s+[a-z0-9-_]+\s*{/gi,
        index = 0,
        len,
        c,
        startIndex;

    var preserve = function (part, index) {
        part = part.replace(/(^\s|\s$)/g, '');
        if (part.charAt(0) === '0') {
            preservedTokens.push(part);
            buffer[index] = ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___";
        }
    };

    while (true) {

        level = 0;
        buffer = '';

        startIndex = content.slice(index).search(pattern);
        if (startIndex < 0) {
            break;
        }

        index += startIndex;
        startIndex = index;
        len = content.length;
        buffers = [];

        for (; index < len; ++index) {

            c = content.charAt(index);

            if (c === '{') {

                if (level === 0) {
                    buffers.push(buffer.replace(/(^\s|\s$)/g, ''));

                } else if (level === 1) {

                    buffer = buffer.split(',');

                    buffer.forEach(preserve);

                    buffers.push(buffer.join(',').replace(/(^\s|\s$)/g, ''));
                }

                buffer = '';
                level += 1;

            } else if (c === '}') {

                if (level === 2) {
                    buffers.push('{' + buffer.replace(/(^\s|\s$)/g, '') + '}');
                    buffer = '';

                } else if (level === 1) {
                    content = content.slice(0, startIndex) +
                        buffers.shift() + '{' +
                        buffers.join('') +
                        content.slice(index);
                    break;
                }

                level -= 1;
            }

            if (level < 0) {
                break;

            } else if (c !== '{' && c !== '}') {
                buffer += c;
            }
        }
    }

    return content;
}

// Collect all comment blocks and return new content with comment placeholders
// (comments is an array thus passed by reference)

function collectComments(content, comments) {
    var table = [];
    var from = 0;
    var start, end;
    while (true) {
        start = content.indexOf("/*", from);
        if (start > -1) {
            end = content.indexOf("*/", start + 2);
            if (end > -1) {
                comments.push(content.slice(start + 2, end));
                table.push(content.slice(from, start));
                table.push("/*___PRESERVE_CANDIDATE_COMMENT_" + (comments.length - 1) + "___*/");
                from = end + 2;
            } else {
                // unterminated comment
                end = -2;
                break;
            }
        } else {
            break;
        }
    }
    table.push(content.slice(end + 2));
    return table.join("");
}

// Uglify a CSS string

function processString(content, options) {

    var startIndex,
        comments = [],
        preservedTokens = [],
        token,
        len = content.length,
        pattern,
        quote,
        rgbcolors,
        hexcolor,
        placeholder,
        val,
        i,
        c,
        line = [],
        lines = [],
        vars = {};

    options = options || defaultOptions;
    content = extractDataUrls(content, preservedTokens);
    content = convertRelativeUrls(content, options, preservedTokens);
    content = collectComments(content, comments);

    // preserve strings so their content doesn't get accidentally minified
    pattern = /("([^\\"]|\\.|\\)*")|('([^\\']|\\.|\\)*')/g;
    content = content.replace(pattern, function (token) {
        quote = token.substring(0, 1);
        token = token.slice(1, -1);
        // maybe the string contains a comment-like substring or more? put'em back then
        if (token.indexOf("___PRESERVE_CANDIDATE_COMMENT_") >= 0) {
            for (i = 0, len = comments.length; i < len; i += 1) {
                token = token.replace("___PRESERVE_CANDIDATE_COMMENT_" + i + "___", comments[i]);
            }
        }
        // minify alpha opacity in filter strings
        token = token.replace(/progid:DXImageTransform.Microsoft.Alpha\(Opacity=/gi, "alpha(opacity=");
        preservedTokens.push(token);
        return quote + ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___" + quote;
    });

    // strings are safe, now wrestle the comments
    for (i = 0, len = comments.length; i < len; i += 1) {

        token = comments[i];
        placeholder = "___PRESERVE_CANDIDATE_COMMENT_" + i + "___";

        // ! in the first position of the comment means preserve
        // so push to the preserved tokens keeping the !
        if (token.charAt(0) === "!") {
            if (options.cuteComments) {
                preservedTokens.push(token.substring(1));
            } else if (options.uglyComments) {
                preservedTokens.push(token.substring(1).replace(/[\r\n]/g, ''));
            } else {
                preservedTokens.push(token);
            }
            content = content.replace(placeholder, ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___");
            continue;
        }

        // \ in the last position looks like hack for Mac/IE5
        // shorten that to /*\*/ and the next one to /**/
        if (token.charAt(token.length - 1) === "\\") {
            preservedTokens.push("\\");
            content = content.replace(placeholder, ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___");
            i = i + 1; // attn: advancing the loop
            preservedTokens.push("");
            content = content.replace(
                "___PRESERVE_CANDIDATE_COMMENT_" + i + "___",
                ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___"
            );
            continue;
        }

        // keep empty comments after child selectors (IE7 hack)
        // e.g. html >/**/ body
        if (token.length === 0) {
            startIndex = content.indexOf(placeholder);
            if (startIndex > 2) {
                if (content.charAt(startIndex - 3) === '>') {
                    preservedTokens.push("");
                    content = content.replace(placeholder, ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___");
                }
            }
        }

        // in all other cases kill the comment
        content = content.replace("/*" + placeholder + "*/", "");
    }

    if (options.expandVars) {
        // parse simple @variables blocks and remove them
        pattern = /@variables\s*\{\s*([^\}]+)\s*\}/g;
        content = content.replace(pattern, function (ignore, f1) {
            pattern = /\s*([a-z0-9\-]+)\s*:\s*([^;\}]+)\s*/gi;
            f1.replace(pattern, function (ignore, f1, f2) {
                if (f1 && f2) {
                vars[f1] = f2;
                }
                return '';
            });
            return '';
        });

        // replace var(x) with the value of x
        pattern = /var\s*\(\s*([^\)]+)\s*\)/g;
        content = content.replace(pattern, function (ignore, f1) {
            return vars[f1] || 'none';
        });
    }

    // normalize all whitespace strings to single spaces. Easier to work with that way.
    content = content.replace(/\s+/g, " ");

    // preserve formulas in calc() before removing spaces
    pattern = /calc\(([^;}]*)\)/g;
    content = content.replace(pattern, function (ignore, f1) {
        preservedTokens.push(
            'calc(' +
                f1.replace(/(^\s*|\s*$)/g, "")
                  .replace(/\( /g, "(")
                  .replace(/ \)/g, ")") +
            ')'
        );
        return ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___";
    });

    // preserve matrix
    pattern = /\s*filter:\s*progid:DXImageTransform.Microsoft.Matrix\(([^\)]+)\);/g;
    content = content.replace(pattern, function (ignore, f1) {
        preservedTokens.push(f1);
        return "filter:progid:DXImageTransform.Microsoft.Matrix(" + ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___);";
    });

    // remove the spaces before the things that should not have spaces before them.
    // but, be careful not to turn "p :link {...}" into "p:link{...}"
    // swap out any pseudo-class colons with the token, and then swap back.
    pattern = /(^|\})(([^\{:])+:)+([^\{]*\{)/g;
    content = content.replace(pattern, function (token) {
        return token.replace(/:/g, "___PSEUDOCLASSCOLON___");
    });

    // remove spaces before the things that should not have spaces before them.
    content = content.replace(/\s+([!{};:>+\(\)\],])/g, "$1");

    // restore spaces for !important
    content = content.replace(/!important/g, " !important");

    // bring back the colon
    content = content.replace(/___PSEUDOCLASSCOLON___/g, ":");

    // preserve 0 followed by a time unit for properties using time units
    pattern = /\s*(animation|animation-delay|animation-duration|transition|transition-delay|transition-duration):\s*([^;}]+)/gi;
    content = content.replace(pattern, function (ignore, f1, f2) {

        f2 = f2.replace(/(^|\D)0?\.?0(m?s)/gi, function (ignore, g1, g2) {
            preservedTokens.push('0' + g2);
            return g1 + ___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___";
        });

        return f1 + ":" + f2;
    });

    // preserve 0% in hsl and hsla color definitions
    content = content.replace(/(hsla?)\(([^)]+)\)/g, function (ignore, f1, f2) {
        var f0 = [];
        f2.split(',').forEach(function (part) {
            part = part.replace(/(^\s+|\s+$)/g, "");
            if (part === '0%') {
                preservedTokens.push('0%');
                f0.push(___PRESERVED_TOKEN_ + (preservedTokens.length - 1) + "___");
            } else {
                f0.push(part);
            }
        });
        return f1 + '(' + f0.join(',') + ')';
    });

    // preserve 0 followed by unit in keyframes steps (WIP)
    content = keyframes(content, preservedTokens);

    // retain space for special IE6 cases
    content = content.replace(/:first-(line|letter)(\{|,)/gi, function (ignore, f1, f2) {
        return ":first-" + f1.toLowerCase() + " " + f2;
    });

    // newlines before and after the end of a preserved comment
    if (options.cuteComments) {
        content = content.replace(/\s*\/\*/g, "___PRESERVED_NEWLINE___/*");
        content = content.replace(/\*\/\s*/g, "*/___PRESERVED_NEWLINE___");
    // no space after the end of a preserved comment
    } else {
        content = content.replace(/\*\/\s*/g, '*/');
    }

    // If there are multiple @charset directives, push them to the top of the file.
    pattern = /^(.*)(@charset)( "[^"]*";)/gi;
    content = content.replace(pattern, function (ignore, f1, f2, f3) {
        return f2.toLowerCase() + f3 + f1;
    });

    // When all @charset are at the top, remove the second and after (as they are completely ignored).
    pattern = /^((\s*)(@charset)( [^;]+;\s*))+/gi;
    content = content.replace(pattern, function (ignore, ignore2, f2, f3, f4) {
        return f2 + f3.toLowerCase() + f4;
    });

    // lowercase some popular @directives (@charset is done right above)
    pattern = /@(font-face|import|(?:-(?:atsc|khtml|moz|ms|o|wap|webkit)-)?keyframe|media|page|namespace)/gi;
    content = content.replace(pattern, function (ignore, f1) {
        return '@' + f1.toLowerCase();
    });

    // lowercase some more common pseudo-elements
    pattern = /:(active|after|before|checked|disabled|empty|enabled|first-(?:child|of-type)|focus|hover|last-(?:child|of-type)|link|only-(?:child|of-type)|root|:selection|target|visited)/gi;
    content = content.replace(pattern, function (ignore, f1) {
        return ':' + f1.toLowerCase();
    });

    // if there is a @charset, then only allow one, and push to the top of the file.
    content = content.replace(/^(.*)(@charset \"[^\"]*\";)/g, "$2$1");
    content = content.replace(/^(\s*@charset [^;]+;\s*)+/g, "$1");

    // lowercase some more common functions
    pattern = /:(lang|not|nth-child|nth-last-child|nth-last-of-type|nth-of-type|(?:-(?:atsc|khtml|moz|ms|o|wap|webkit)-)?any)\(/gi;
    content = content.replace(pattern, function (ignore, f1) {
        return ':' + f1.toLowerCase() + '(';
    });

    // lower case some common function that can be values
    // NOTE: rgb() isn't useful as we replace with #hex later, as well as and() is already done for us right after this
    pattern = /([:,\( ]\s*)(attr|color-stop|from|rgba|to|url|(?:-(?:atsc|khtml|moz|ms|o|wap|webkit)-)?(?:calc|max|min|(?:repeating-)?(?:linear|radial)-gradient)|-webkit-gradient)/gi;
    content = content.replace(pattern, function (ignore, f1, f2) {
        return f1 + f2.toLowerCase();
    });

    // put the space back in some cases, to support stuff like
    // @media screen and (-webkit-min-device-pixel-ratio:0){
    content = content.replace(/\band\(/gi, "and (");

    // remove the spaces after the things that should not have spaces after them.
    content = content.replace(/([!{}:;>+\(\[,])\s+/g, "$1");

    // remove unnecessary semicolons
    content = content.replace(/;+\}/g, "}");

    // replace 0(px,em,%) with 0.
    content = content.replace(/(^|[^.0-9\\])(?:0?\.)?0(?:ex|ch|r?em|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|g?rad|turn|m?s|k?Hz|dpi|dpcm|dppx|%)/gi, "$10");

    // Replace x.0(px,em,%) with x(px,em,%).
    content = content.replace(/([0-9])\.0(ex|ch|r?em|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|g?rad|turn|m?s|k?Hz|dpi|dpcm|dppx|%| |;)/gi, "$1$2");

    // replace 0 0 0 0; with 0.
    content = content.replace(/:0 0 0 0(;|\})/g, ":0$1");
    content = content.replace(/:0 0 0(;|\})/g, ":0$1");
    content = content.replace(/:0 0(;|\})/g, ":0$1");

    // replace background-position:0; with background-position:0 0;
    // same for transform-origin and box-shadow
    pattern = /(background-position|transform-origin|webkit-transform-origin|moz-transform-origin|o-transform-origin|ms-transform-origin|box-shadow):0(;|\})/gi;
    content = content.replace(pattern, function (ignore, f1, f2) {
        return f1.toLowerCase() + ":0 0" + f2;
    });

    // replace 0.6 to .6, but only when preceded by : or a white-space
    content = content.replace(/(:|\s)0+\.(\d+)/g, "$1.$2");

    // shorten colors from rgb(51,102,153) to #336699
    // this makes it more likely that it'll get further compressed in the next step.
    pattern = /rgb\s*\(\s*([0-9,\s]+)\s*\)/gi;
    content = content.replace(pattern, function (ignore, f1) {
        rgbcolors = f1.split(",");
        hexcolor = "#";
        for (i = 0; i < rgbcolors.length; i += 1) {
            val = parseInt(rgbcolors[i], 10);
            if (val < 16) {
                hexcolor += "0";
            }
            if (val > 255) {
                val = 255;
            }
            hexcolor += val.toString(16);
        }
        return hexcolor;
    });

    // Shorten colors from #AABBCC to #ABC.
    content = compressHexColors(content);

    // Replace #f00 -> red
    content = content.replace(/(:|\s)(#f00)(;|})/g, "$1red$3");

    // Replace other short color keywords
    content = content.replace(/(:|\s)(#000080)(;|})/g, "$1navy$3");
    content = content.replace(/(:|\s)(#808080)(;|})/g, "$1gray$3");
    content = content.replace(/(:|\s)(#808000)(;|})/g, "$1olive$3");
    content = content.replace(/(:|\s)(#800080)(;|})/g, "$1purple$3");
    content = content.replace(/(:|\s)(#c0c0c0)(;|})/g, "$1silver$3");
    content = content.replace(/(:|\s)(#008080)(;|})/g, "$1teal$3");
    content = content.replace(/(:|\s)(#ffa500)(;|})/g, "$1orange$3");
    content = content.replace(/(:|\s)(#800000)(;|})/g, "$1maroon$3");

    // border: none -> border:0
    pattern = /(border|border-top|border-right|border-bottom|border-left|outline|background):none(;|\})/gi;
    content = content.replace(pattern, function (ignore, f1, f2) {
        return f1.toLowerCase() + ":0" + f2;
    });

    // shorter opacity IE filter
    content = content.replace(/progid:DXImageTransform\.Microsoft\.Alpha\(Opacity=/gi, "alpha(opacity=");

    // Find a fraction that is used for Opera's -o-device-pixel-ratio query
    // Add token to add the "\" back in later
    content = content.replace(/\(([\-A-Za-z]+):([0-9]+)\/([0-9]+)\)/g, "($1:$2___QUERY_FRACTION___$3)");

    // remove empty rules.
    content = content.replace(/[^\};\{\/]+\{\}/g, "");

    // Add "\" back to fix Opera -o-device-pixel-ratio query
    content = content.replace(/___QUERY_FRACTION___/g, "/");

    // some source control tools don't like it when files containing lines longer
    // than, say 8000 characters, are checked in. The linebreak option is used in
    // that case to split long lines after a specific column.
    if (options.maxLineLen > 0) {
        for (i = 0, len = content.length; i < len; i += 1) {
            c = content.charAt(i);
            line.push(c);
            if (c === '}' && line.length > options.maxLineLen) {
                lines.push(line.join(''));
                line = [];
            }
        }
        if (line.length) {
            lines.push(line.join(''));
        }

        content = lines.join('\n');
    }

    // replace multiple semi-colons in a row by a single one
    // see SF bug #1980989
    content = content.replace(/;;+/g, ";");

    // trim the final string (for any leading or trailing white spaces)
    content = content.replace(/(^\s*|\s*$)/g, "");

    // restore preserved tokens
    for (i = preservedTokens.length - 1; i >= 0 ; i--) {
        content = content.replace(___PRESERVED_TOKEN_ + i + "___", preservedTokens[i], "g");
    }

    // restore preserved newlines
    content = content.replace(/___PRESERVED_NEWLINE___/g, '\n');

    // return
    return content;
}

// Uglify CSS files

function processFiles(filenames, options) {

    var nFiles = filenames.length,
        uglies = [],
        index,
        filename,
        content;

    options = options || defaultOptions;

    if (options.convertUrls) {
        options.target = _$pathBrowserify_455.resolve(process.cwd(), options.convertUrls).split(PATH_SEP);
    }

    // process files
    for (index = 0; index < nFiles; index += 1) {
        filename = filenames[index];
        try {
            content = _$_empty_7.readFileSync(filename, 'utf8');
            if (content.length) {
                if (options.convertUrls) {
                    options.source = _$pathBrowserify_455.resolve(process.cwd(), filename).split(PATH_SEP);
                    options.source.pop();
                }
                uglies.push(processString(content, options));
            }
        } catch (e) {
            if (options.debug) {
                console.error('uglifycss: unable to process "' + filename + '"\n' + e.stack);
            } else {
                console.error('uglifycss: unable to process "' + filename + '"\n\t' + e);
            }
            process.exit(1);
        }
    }

    // return concat'd results
    return uglies.join('');
}

_$uglifycssLib_601 = {
    defaultOptions: defaultOptions,
    processString: processString,
    processFiles: processFiles
};

}).call(this)}).call(this,_$browser_459)
/**
 * UglifyCSS
 * Port of YUI CSS Compressor to NodeJS
 * Author: Franck Marcia - https://github.com/fmarcia
 * MIT licenced
 */

/**
 * cssmin.js
 * Author: Stoyan Stefanov - http://phpied.com/
 * This is a JavaScript port of the CSS minification tool
 * distributed with YUICompressor, itself a port
 * of the cssmin utility by Isaac Schlueter - http://foohack.com/
 * Permission is hereby granted to use the JavaScript version under the same
 * conditions as the YUICompressor (original YUICompressor note below).
 */

/**
 * YUI Compressor
 * http://developer.yahoo.com/yui/compressor/
 * Author: Julien Lecomte - http://www.julienlecomte.net/
 * Copyright (c) 2011 Yahoo! Inc. All rights reserved.
 * The copyrights embodied in the content of this file are licensed
 * by Yahoo! Inc. under the BSD (revised) open source license.
 */

var _$uglifycss_600 = _$uglifycssLib_601;

var _$gulpUglifycss_gulpUglifycss = {};
(function (Buffer){(function (){
/* removed: var _$PluginError_456 = require('plugin-error'); */;;
/* removed: var _$through2_585 = require('through2'); */;
/* removed: var _$uglifycss_600 = require('uglifycss'); */;

_$gulpUglifycss_gulpUglifycss = function (options) {
    return _$through2_585.obj(function (file, enc, cb) {
        if (file.isNull()) {
            return cb(null, file);
        }

        if (file.isStream()) {
            return cb(new _$PluginError_456('gulp-uglifycss', 'Stream is not supported'));
        }

        var str = file.contents.toString('utf8');
        file.contents = new Buffer(_$uglifycss_600.processString(str, options));

        return cb(null, file);
    });
};

}).call(this)}).call(this,_$buffer_8({}).Buffer)
var _$jsCookie_jsCookie = { exports: {} };
/*! js-cookie v3.0.5 | MIT */
;
(function (global, factory) {
  typeof _$jsCookie_jsCookie.exports === 'object' && "object" !== 'undefined' ? _$jsCookie_jsCookie.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  })());
})(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (name, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        name + '=' + converter.write(value, name) + stringifiedAttributes)
    }

    function get (name) {
      if (typeof document === 'undefined' || (arguments.length && !name)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);

          if (name === found) {
            break
          }
        } catch (e) {}
      }

      return name ? jar[name] : jar
    }

    return Object.create(
      {
        set,
        get,
        remove: function (name, attributes) {
          set(
            name,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

}));

_$jsCookie_jsCookie = _$jsCookie_jsCookie.exports
var _$jwtDecode_jwtDecode = {};
"use strict";function __e_jwtDecode(e){this.message=e}__e_jwtDecode.prototype=new Error,__e_jwtDecode.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new __e_jwtDecode("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function __o_jwtDecode(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";const __a_jwtDecode=__o_jwtDecode;__a_jwtDecode.default=__o_jwtDecode,__a_jwtDecode.InvalidTokenError=n,_$jwtDecode_jwtDecode=__a_jwtDecode;
//# sourceMappingURL=jwt-decode.cjs.js.map

var _$lodash_lodashMerge = { exports: {} };
(function (global){(function (){
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof _$lodash_lodashMerge.exports == 'object' && _$lodash_lodashMerge.exports && !_$lodash_lodashMerge.exports.nodeType && _$lodash_lodashMerge.exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && _$lodash_lodashMerge && !_$lodash_lodashMerge.nodeType && _$lodash_lodashMerge;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

_$lodash_lodashMerge.exports = merge;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
_$lodash_lodashMerge = _$lodash_lodashMerge.exports
'use strict';

function hasKey(obj, keys) {
	var o = obj;
	keys.slice(0, -1).forEach(function (key) {
		o = o[key] || {};
	});

	var key = keys[keys.length - 1];
	return key in o;
}

function __isNumber_minimist(x) {
	if (typeof x === 'number') { return true; }
	if ((/^0x[0-9a-f]+$/i).test(x)) { return true; }
	return (/^[-+]?(?:\d+(?:\.\d*)?|\.\d+)(e[-+]?\d+)?$/).test(x);
}

function isConstructorOrProto(obj, key) {
	return (key === 'constructor' && typeof obj[key] === 'function') || key === '__proto__';
}

var _$minimist_minimist = function (args, opts) {
	if (!opts) { opts = {}; }

	var flags = {
		bools: {},
		strings: {},
		unknownFn: null,
	};

	if (typeof opts.unknown === 'function') {
		flags.unknownFn = opts.unknown;
	}

	if (typeof opts.boolean === 'boolean' && opts.boolean) {
		flags.allBools = true;
	} else {
		[].concat(opts.boolean).filter(Boolean).forEach(function (key) {
			flags.bools[key] = true;
		});
	}

	var aliases = {};

	function aliasIsBoolean(key) {
		return aliases[key].some(function (x) {
			return flags.bools[x];
		});
	}

	Object.keys(opts.alias || {}).forEach(function (key) {
		aliases[key] = [].concat(opts.alias[key]);
		aliases[key].forEach(function (x) {
			aliases[x] = [key].concat(aliases[key].filter(function (y) {
				return x !== y;
			}));
		});
	});

	[].concat(opts.string).filter(Boolean).forEach(function (key) {
		flags.strings[key] = true;
		if (aliases[key]) {
			[].concat(aliases[key]).forEach(function (k) {
				flags.strings[k] = true;
			});
		}
	});

	var defaults = opts.default || {};

	var argv = { _: [] };

	function argDefined(key, arg) {
		return (flags.allBools && (/^--[^=]+$/).test(arg))
			|| flags.strings[key]
			|| flags.bools[key]
			|| aliases[key];
	}

	function setKey(obj, keys, value) {
		var o = obj;
		for (var i = 0; i < keys.length - 1; i++) {
			var key = keys[i];
			if (isConstructorOrProto(o, key)) { return; }
			if (o[key] === undefined) { o[key] = {}; }
			if (
				o[key] === Object.prototype
				|| o[key] === Number.prototype
				|| o[key] === String.prototype
			) {
				o[key] = {};
			}
			if (o[key] === Array.prototype) { o[key] = []; }
			o = o[key];
		}

		var lastKey = keys[keys.length - 1];
		if (isConstructorOrProto(o, lastKey)) { return; }
		if (
			o === Object.prototype
			|| o === Number.prototype
			|| o === String.prototype
		) {
			o = {};
		}
		if (o === Array.prototype) { o = []; }
		if (o[lastKey] === undefined || flags.bools[lastKey] || typeof o[lastKey] === 'boolean') {
			o[lastKey] = value;
		} else if (Array.isArray(o[lastKey])) {
			o[lastKey].push(value);
		} else {
			o[lastKey] = [o[lastKey], value];
		}
	}

	function setArg(key, val, arg) {
		if (arg && flags.unknownFn && !argDefined(key, arg)) {
			if (flags.unknownFn(arg) === false) { return; }
		}

		var value = !flags.strings[key] && __isNumber_minimist(val)
			? Number(val)
			: val;
		setKey(argv, key.split('.'), value);

		(aliases[key] || []).forEach(function (x) {
			setKey(argv, x.split('.'), value);
		});
	}

	Object.keys(flags.bools).forEach(function (key) {
		setArg(key, defaults[key] === undefined ? false : defaults[key]);
	});

	var notFlags = [];

	if (args.indexOf('--') !== -1) {
		notFlags = args.slice(args.indexOf('--') + 1);
		args = args.slice(0, args.indexOf('--'));
	}

	for (var i = 0; i < args.length; i++) {
		var arg = args[i];
		var key;
		var next;

		if ((/^--.+=/).test(arg)) {
			// Using [\s\S] instead of . because js doesn't support the
			// 'dotall' regex modifier. See:
			// http://stackoverflow.com/a/1068308/13216
			var m = arg.match(/^--([^=]+)=([\s\S]*)$/);
			key = m[1];
			var value = m[2];
			if (flags.bools[key]) {
				value = value !== 'false';
			}
			setArg(key, value, arg);
		} else if ((/^--no-.+/).test(arg)) {
			key = arg.match(/^--no-(.+)/)[1];
			setArg(key, false, arg);
		} else if ((/^--.+/).test(arg)) {
			key = arg.match(/^--(.+)/)[1];
			next = args[i + 1];
			if (
				next !== undefined
				&& !(/^(-|--)[^-]/).test(next)
				&& !flags.bools[key]
				&& !flags.allBools
				&& (aliases[key] ? !aliasIsBoolean(key) : true)
			) {
				setArg(key, next, arg);
				i += 1;
			} else if ((/^(true|false)$/).test(next)) {
				setArg(key, next === 'true', arg);
				i += 1;
			} else {
				setArg(key, flags.strings[key] ? '' : true, arg);
			}
		} else if ((/^-[^-]+/).test(arg)) {
			var letters = arg.slice(1, -1).split('');

			var broken = false;
			for (var j = 0; j < letters.length; j++) {
				next = arg.slice(j + 2);

				if (next === '-') {
					setArg(letters[j], next, arg);
					continue;
				}

				if ((/[A-Za-z]/).test(letters[j]) && next[0] === '=') {
					setArg(letters[j], next.slice(1), arg);
					broken = true;
					break;
				}

				if (
					(/[A-Za-z]/).test(letters[j])
					&& (/-?\d+(\.\d*)?(e-?\d+)?$/).test(next)
				) {
					setArg(letters[j], next, arg);
					broken = true;
					break;
				}

				if (letters[j + 1] && letters[j + 1].match(/\W/)) {
					setArg(letters[j], arg.slice(j + 2), arg);
					broken = true;
					break;
				} else {
					setArg(letters[j], flags.strings[letters[j]] ? '' : true, arg);
				}
			}

			key = arg.slice(-1)[0];
			if (!broken && key !== '-') {
				if (
					args[i + 1]
					&& !(/^(-|--)[^-]/).test(args[i + 1])
					&& !flags.bools[key]
					&& (aliases[key] ? !aliasIsBoolean(key) : true)
				) {
					setArg(key, args[i + 1], arg);
					i += 1;
				} else if (args[i + 1] && (/^(true|false)$/).test(args[i + 1])) {
					setArg(key, args[i + 1] === 'true', arg);
					i += 1;
				} else {
					setArg(key, flags.strings[key] ? '' : true, arg);
				}
			}
		} else {
			if (!flags.unknownFn || flags.unknownFn(arg) !== false) {
				argv._.push(flags.strings._ || !__isNumber_minimist(arg) ? arg : Number(arg));
			}
			if (opts.stopEarly) {
				argv._.push.apply(argv._, args.slice(i + 1));
				break;
			}
		}
	}

	Object.keys(defaults).forEach(function (k) {
		if (!hasKey(argv, k.split('.'))) {
			setKey(argv, k.split('.'), defaults[k]);

			(aliases[k] || []).forEach(function (x) {
				setKey(argv, x.split('.'), defaults[k]);
			});
		}
	});

	if (opts['--']) {
		argv['--'] = notFlags.slice();
	} else {
		notFlags.forEach(function (k) {
			argv._.push(k);
		});
	}

	return argv;
};

var _$reflectMetadata_reflectMetadata = {};
(function (process,global){(function (){
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function (factory) {
        var root = typeof global === "object" ? global :
            typeof self === "object" ? self :
                typeof this === "object" ? this :
                    Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
        }
        else {
            exporter = makeExporter(root.Reflect, exporter);
        }
        factory(exporter);
        function makeExporter(target, previous) {
            return function (key, value) {
                if (typeof target[key] !== "function") {
                    Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
                }
                if (previous)
                    previous(key, value);
            };
        }
    })(function (exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate
                ? function () { return MakeDictionary(Object.create(null)); }
                : supportsProto
                    ? function () { return MakeDictionary({ __proto__: null }); }
                    : function () { return MakeDictionary({}); },
            has: downLevel
                ? function (map, key) { return hasOwn.call(map, key); }
                : function (map, key) { return key in map; },
            get: downLevel
                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
                : function (map, key) { return map[key]; },
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof process === "object" && process.env && process.env["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */
        function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                    throw new TypeError();
                if (IsNull(attributes))
                    attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            }
            else {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsConstructor(target))
                    throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */
        function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */
        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */
        function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */
        function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            if (!metadataMap.delete(metadataKey))
                return false;
            if (metadataMap.size > 0)
                return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0)
                return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated))
                        throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated))
                        throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create)
                    return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create)
                    return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null)
                return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0)
                return ownKeys;
            if (ownKeys.length <= 0)
                return parentKeys;
            var set = new _Set();
            var keys = [];
            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while (true) {
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                }
                catch (e) {
                    try {
                        IteratorClose(iterator);
                    }
                    finally {
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null)
                return 1 /* Null */;
            switch (typeof x) {
                case "undefined": return 0 /* Undefined */;
                case "boolean": return 2 /* Boolean */;
                case "string": return 3 /* String */;
                case "symbol": return 4 /* Symbol */;
                case "number": return 5 /* Number */;
                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
                default: return 6 /* Object */;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
                case 0 /* Undefined */: return input;
                case 1 /* Null */: return input;
                case 2 /* Boolean */: return input;
                case 3 /* String */: return input;
                case 4 /* Symbol */: return input;
                case 5 /* Number */: return input;
            }
            var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result))
                    throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */);
            if (IsSymbol(key))
                return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray
                ? Array.isArray(argument)
                : argument instanceof Object
                    ? argument instanceof Array
                    : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch (Type(argument)) {
                case 3 /* String */: return true;
                case 4 /* Symbol */: return true;
                default: return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null)
                return undefined;
            if (!IsCallable(func))
                throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method))
                throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator))
                throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f)
                f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype)
                return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype)
                return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype)
                return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function")
                return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O)
                return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ (function () {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function () { return this; };
                MapIterator.prototype[iteratorSymbol] = function () { return this; };
                MapIterator.prototype.next = function () {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        }
                        else {
                            this._index++;
                        }
                        return { value: result, done: false };
                    }
                    return { value: undefined, done: true };
                };
                MapIterator.prototype.throw = function (error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function (value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return { value: value, done: true };
                };
                return MapIterator;
            }());
            return /** @class */ (function () {
                function Map() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map.prototype, "size", {
                    get: function () { return this._keys.length; },
                    enumerable: true,
                    configurable: true
                });
                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
                Map.prototype.get = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map.prototype.set = function (key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map.prototype.delete = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for (var i = index + 1; i < size; i++) {
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map.prototype.clear = function () {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
                Map.prototype["@@iterator"] = function () { return this.entries(); };
                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
                Map.prototype._find = function (key, insert) {
                    if (this._cacheKey !== key) {
                        this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map;
            }());
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [key, value];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return /** @class */ (function () {
                function Set() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set.prototype, "size", {
                    get: function () { return this._map.size; },
                    enumerable: true,
                    configurable: true
                });
                Set.prototype.has = function (value) { return this._map.has(value); };
                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
                Set.prototype.delete = function (value) { return this._map.delete(value); };
                Set.prototype.clear = function () { this._map.clear(); };
                Set.prototype.keys = function () { return this._map.keys(); };
                Set.prototype.values = function () { return this._map.values(); };
                Set.prototype.entries = function () { return this._map.entries(); };
                Set.prototype["@@iterator"] = function () { return this.keys(); };
                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
                return Set;
            }());
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ (function () {
                function WeakMap() {
                    this._key = CreateUniqueKey();
                }
                WeakMap.prototype.has = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap.prototype.get = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap.prototype.set = function (target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap.prototype.delete = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap.prototype.clear = function () {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap;
            }());
            function CreateUniqueKey() {
                var key;
                do
                    key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create)
                        return undefined;
                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for (var i = 0; i < size; ++i)
                    buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined")
                        return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined")
                        return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for (var offset = 0; offset < UUID_SIZE; ++offset) {
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8)
                        result += "-";
                    if (byte < 16)
                        result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})(Reflect || (Reflect = {}));

}).call(this)}).call(this,_$browser_459,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
var _$isFunction_556 = {};
"use strict";
Object.defineProperty(_$isFunction_556, "__esModule", { value: true });
function __isFunction_556(x) {
    return typeof x === 'function';
}
_$isFunction_556.isFunction = __isFunction_556;
//# sourceMappingURL=isFunction.js.map
var _$config_486 = {};
"use strict";
Object.defineProperty(_$config_486, "__esModule", { value: true });
var _enable_super_gross_mode_that_will_cause_bad_things = false;
_$config_486.config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = new Error();
            console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        else if (_enable_super_gross_mode_that_will_cause_bad_things) {
            console.log('RxJS: Back to a better error behavior. Thank you. <3');
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};
//# sourceMappingURL=config.js.map
var _$hostReportError_552 = {};
"use strict";
Object.defineProperty(_$hostReportError_552, "__esModule", { value: true });
function hostReportError(err) {
    setTimeout(function () { throw err; }, 0);
}
_$hostReportError_552.hostReportError = hostReportError;
//# sourceMappingURL=hostReportError.js.map
var _$Observer_478 = {};
"use strict";
Object.defineProperty(_$Observer_478, "__esModule", { value: true });
/* removed: var _$config_486 = require("./config"); */;
/* removed: var _$hostReportError_552 = require("./util/hostReportError"); */;
_$Observer_478.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (_$config_486.config.useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            _$hostReportError_552.hostReportError(err);
        }
    },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map
var _$isArray_554 = {};
"use strict";
Object.defineProperty(_$isArray_554, "__esModule", { value: true });
_$isArray_554.isArray = (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();
//# sourceMappingURL=isArray.js.map
var _$isObject_560 = {};
"use strict";
Object.defineProperty(_$isObject_560, "__esModule", { value: true });
function __isObject_560(x) {
    return x !== null && typeof x === 'object';
}
_$isObject_560.isObject = __isObject_560;
//# sourceMappingURL=isObject.js.map
var _$UnsubscriptionError_550 = {};
"use strict";
Object.defineProperty(_$UnsubscriptionError_550, "__esModule", { value: true });
var UnsubscriptionErrorImpl = (function () {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ?
            errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
})();
_$UnsubscriptionError_550.UnsubscriptionError = UnsubscriptionErrorImpl;
//# sourceMappingURL=UnsubscriptionError.js.map
var _$Subscription_485 = {};
"use strict";
Object.defineProperty(_$Subscription_485, "__esModule", { value: true });
/* removed: var _$isArray_554 = require("./util/isArray"); */;
/* removed: var _$isObject_560 = require("./util/isObject"); */;
/* removed: var _$isFunction_556 = require("./util/isFunction"); */;
/* removed: var _$UnsubscriptionError_550 = require("./util/UnsubscriptionError"); */;
var Subscription = (function () {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function () {
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) {
            _parentOrParents.remove(this);
        }
        else if (_parentOrParents !== null) {
            for (var index = 0; index < _parentOrParents.length; ++index) {
                var parent_1 = _parentOrParents[index];
                parent_1.remove(this);
            }
        }
        if (_$isFunction_556.isFunction(_unsubscribe)) {
            if (_ctorUnsubscribe) {
                this._unsubscribe = undefined;
            }
            try {
                _unsubscribe.call(this);
            }
            catch (e) {
                errors = e instanceof _$UnsubscriptionError_550.UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
            }
        }
        if (_$isArray_554.isArray(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (_$isObject_560.isObject(sub)) {
                    try {
                        sub.unsubscribe();
                    }
                    catch (e) {
                        errors = errors || [];
                        if (e instanceof _$UnsubscriptionError_550.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                        }
                        else {
                            errors.push(e);
                        }
                    }
                }
            }
        }
        if (errors) {
            throw new _$UnsubscriptionError_550.UnsubscriptionError(errors);
        }
    };
    Subscription.prototype.add = function (teardown) {
        var subscription = teardown;
        if (!teardown) {
            return Subscription.EMPTY;
        }
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default: {
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
            }
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) {
            subscription._parentOrParents = this;
        }
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) {
                return subscription;
            }
            subscription._parentOrParents = [_parentOrParents, this];
        }
        else if (_parentOrParents.indexOf(this) === -1) {
            _parentOrParents.push(this);
        }
        else {
            return subscription;
        }
        var subscriptions = this._subscriptions;
        if (subscriptions === null) {
            this._subscriptions = [subscription];
        }
        else {
            subscriptions.push(subscription);
        }
        return subscription;
    };
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
_$Subscription_485.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof _$UnsubscriptionError_550.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map
var _$rxSubscriber_544 = {};
"use strict";
Object.defineProperty(_$rxSubscriber_544, "__esModule", { value: true });
_$rxSubscriber_544.rxSubscriber = (function () {
    return typeof Symbol === 'function'
        ? Symbol('rxSubscriber')
        : '@@rxSubscriber_' + Math.random();
})();
_$rxSubscriber_544.$$rxSubscriber = _$rxSubscriber_544.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map
var _$Subscriber_484 = {};
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$Subscriber_484, "__esModule", { value: true });
/* removed: var _$isFunction_556 = require("./util/isFunction"); */;
/* removed: var _$Observer_478 = require("./Observer"); */;
/* removed: var _$Subscription_485 = require("./Subscription"); */;
/* removed: var _$rxSubscriber_544 = require("../internal/symbol/rxSubscriber"); */;
/* removed: var _$config_486 = require("./config"); */;
/* removed: var _$hostReportError_552 = require("./util/hostReportError"); */;
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = _$Observer_478.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = _$Observer_478.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[_$rxSubscriber_544.rxSubscriber] = function () { return this; };
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}(_$Subscription_485.Subscription));
_$Subscriber_484.Subscriber = Subscriber;
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (_$isFunction_556.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== _$Observer_478.empty) {
                context = Object.create(observerOrNext);
                if (_$isFunction_556.isFunction(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_$config_486.config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = _$config_486.config.useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                _$hostReportError_552.hostReportError(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    _$hostReportError_552.hostReportError(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_$config_486.config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (_$config_486.config.useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                _$hostReportError_552.hostReportError(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!_$config_486.config.useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (_$config_486.config.useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                _$hostReportError_552.hostReportError(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
_$Subscriber_484.SafeSubscriber = SafeSubscriber;
//# sourceMappingURL=Subscriber.js.map
var _$canReportError_551 = {};
"use strict";
Object.defineProperty(_$canReportError_551, "__esModule", { value: true });
/* removed: var _$Subscriber_484 = require("../Subscriber"); */;
function canReportError(observer) {
    while (observer) {
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) {
            return false;
        }
        else if (destination && destination instanceof _$Subscriber_484.Subscriber) {
            observer = destination;
        }
        else {
            observer = null;
        }
    }
    return true;
}
_$canReportError_551.canReportError = canReportError;
//# sourceMappingURL=canReportError.js.map
var _$toSubscriber_573 = {};
"use strict";
Object.defineProperty(_$toSubscriber_573, "__esModule", { value: true });
/* removed: var _$Subscriber_484 = require("../Subscriber"); */;
/* removed: var _$rxSubscriber_544 = require("../symbol/rxSubscriber"); */;
/* removed: var _$Observer_478 = require("../Observer"); */;
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof _$Subscriber_484.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[_$rxSubscriber_544.rxSubscriber]) {
            return nextOrObserver[_$rxSubscriber_544.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new _$Subscriber_484.Subscriber(_$Observer_478.empty);
    }
    return new _$Subscriber_484.Subscriber(nextOrObserver, error, complete);
}
_$toSubscriber_573.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map
var _$observable_543 = {};
"use strict";
Object.defineProperty(_$observable_543, "__esModule", { value: true });
_$observable_543.observable = (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();
//# sourceMappingURL=observable.js.map
var _$identity_553 = {};
"use strict";
Object.defineProperty(_$identity_553, "__esModule", { value: true });
function __identity_553(x) {
    return x;
}
_$identity_553.identity = __identity_553;
//# sourceMappingURL=identity.js.map
var _$pipe_566 = {};
"use strict";
Object.defineProperty(_$pipe_566, "__esModule", { value: true });
/* removed: var _$identity_553 = require("./identity"); */;
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
_$pipe_566.pipe = pipe;
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return _$identity_553.identity;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
_$pipe_566.pipeFromArray = pipeFromArray;
//# sourceMappingURL=pipe.js.map
var _$Observable_477 = {};
"use strict";
Object.defineProperty(_$Observable_477, "__esModule", { value: true });
/* removed: var _$canReportError_551 = require("./util/canReportError"); */;
/* removed: var _$toSubscriber_573 = require("./util/toSubscriber"); */;
/* removed: var _$observable_543 = require("./symbol/observable"); */;
/* removed: var _$pipe_566 = require("./util/pipe"); */;
/* removed: var _$config_486 = require("./config"); */;
var Observable = (function () {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = _$toSubscriber_573.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            sink.add(operator.call(sink, this.source));
        }
        else {
            sink.add(this.source || (_$config_486.config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                this._subscribe(sink) :
                this._trySubscribe(sink));
        }
        if (_$config_486.config.useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (_$config_486.config.useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if (_$canReportError_551.canReportError(sink)) {
                sink.error(err);
            }
            else {
                console.warn(err);
            }
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[_$observable_543.observable] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return _$pipe_566.pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
_$Observable_477.Observable = Observable;
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = _$config_486.config.Promise || Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}
//# sourceMappingURL=Observable.js.map
var _$ObjectUnsubscribedError_548 = {};
"use strict";
Object.defineProperty(_$ObjectUnsubscribedError_548, "__esModule", { value: true });
var ObjectUnsubscribedErrorImpl = (function () {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = 'object unsubscribed';
        this.name = 'ObjectUnsubscribedError';
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
})();
_$ObjectUnsubscribedError_548.ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;
//# sourceMappingURL=ObjectUnsubscribedError.js.map
var _$SubjectSubscription_483 = {};
"use strict";
var ____extends_483 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$SubjectSubscription_483, "__esModule", { value: true });
/* removed: var _$Subscription_485 = require("./Subscription"); */;
var SubjectSubscription = (function (_super) {
    ____extends_483(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(_$Subscription_485.Subscription));
_$SubjectSubscription_483.SubjectSubscription = SubjectSubscription;
//# sourceMappingURL=SubjectSubscription.js.map
var _$Subject_482 = {};
"use strict";
var ____extends_482 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$Subject_482, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("./Observable"); */;
/* removed: var _$Subscriber_484 = require("./Subscriber"); */;
/* removed: var _$Subscription_485 = require("./Subscription"); */;
/* removed: var _$ObjectUnsubscribedError_548 = require("./util/ObjectUnsubscribedError"); */;
/* removed: var _$SubjectSubscription_483 = require("./SubjectSubscription"); */;
/* removed: var _$rxSubscriber_544 = require("../internal/symbol/rxSubscriber"); */;
var SubjectSubscriber = (function (_super) {
    ____extends_482(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}(_$Subscriber_484.Subscriber));
_$Subject_482.SubjectSubscriber = SubjectSubscriber;
var Subject = (function (_super) {
    ____extends_482(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[_$rxSubscriber_544.rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new _$ObjectUnsubscribedError_548.ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new _$ObjectUnsubscribedError_548.ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new _$ObjectUnsubscribedError_548.ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new _$ObjectUnsubscribedError_548.ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new _$ObjectUnsubscribedError_548.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return _$Subscription_485.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return _$Subscription_485.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new _$SubjectSubscription_483.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new _$Observable_477.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(_$Observable_477.Observable));
_$Subject_482.Subject = Subject;
var AnonymousSubject = (function (_super) {
    ____extends_482(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return _$Subscription_485.Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));
_$Subject_482.AnonymousSubject = AnonymousSubject;
//# sourceMappingURL=Subject.js.map
var _$refCount_522 = {};
"use strict";
var ____extends_522 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$refCount_522, "__esModule", { value: true });
/* removed: var _$Subscriber_484 = require("../Subscriber"); */;
function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
_$refCount_522.refCount = refCount;
var RefCountOperator = (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = (function (_super) {
    ____extends_522(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(_$Subscriber_484.Subscriber));
//# sourceMappingURL=refCount.js.map
var _$ConnectableObservable_488 = {};
"use strict";
var ____extends_488 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$ConnectableObservable_488, "__esModule", { value: true });
/* removed: var _$Subject_482 = require("../Subject"); */;
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$Subscriber_484 = require("../Subscriber"); */;
/* removed: var _$Subscription_485 = require("../Subscription"); */;
/* removed: var _$refCount_522 = require("../operators/refCount"); */;
var ConnectableObservable = (function (_super) {
    ____extends_488(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new _$Subscription_485.Subscription();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = _$Subscription_485.Subscription.EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return _$refCount_522.refCount()(this);
    };
    return ConnectableObservable;
}(_$Observable_477.Observable));
_$ConnectableObservable_488.ConnectableObservable = ConnectableObservable;
_$ConnectableObservable_488.connectableObservableDescriptor = (function () {
    var connectableProto = ConnectableObservable.prototype;
    return {
        operator: { value: null },
        _refCount: { value: 0, writable: true },
        _subject: { value: null, writable: true },
        _connection: { value: null, writable: true },
        _subscribe: { value: connectableProto._subscribe },
        _isComplete: { value: connectableProto._isComplete, writable: true },
        getSubject: { value: connectableProto.getSubject },
        connect: { value: connectableProto.connect },
        refCount: { value: connectableProto.refCount }
    };
})();
var ConnectableSubscriber = (function (_super) {
    ____extends_488(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(_$Subject_482.SubjectSubscriber));
var __RefCountOperator_488 = (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new __RefCountSubscriber_488(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var __RefCountSubscriber_488 = (function (_super) {
    ____extends_488(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(_$Subscriber_484.Subscriber));
//# sourceMappingURL=ConnectableObservable.js.map
var _$groupBy_517 = {};
"use strict";
var ____extends_517 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$groupBy_517, "__esModule", { value: true });
/* removed: var _$Subscriber_484 = require("../Subscriber"); */;
/* removed: var _$Subscription_485 = require("../Subscription"); */;
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$Subject_482 = require("../Subject"); */;
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function (source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
_$groupBy_517.groupBy = groupBy;
var GroupByOperator = (function () {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}());
var GroupBySubscriber = (function (_super) {
    ____extends_517(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.elementSelector = elementSelector;
        _this.durationSelector = durationSelector;
        _this.subjectSelector = subjectSelector;
        _this.groups = null;
        _this.attemptedToUnsubscribe = false;
        _this.count = 0;
        return _this;
    }
    GroupBySubscriber.prototype._next = function (value) {
        var key;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function (value, key) {
        var groups = this.groups;
        if (!groups) {
            groups = this.groups = new Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
            try {
                element = this.elementSelector(value);
            }
            catch (err) {
                this.error(err);
            }
        }
        else {
            element = value;
        }
        if (!group) {
            group = (this.subjectSelector ? this.subjectSelector() : new _$Subject_482.Subject());
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                }
                catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) {
            group.next(element);
        }
    };
    GroupBySubscriber.prototype._error = function (err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function () {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function (key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) {
                _super.prototype.unsubscribe.call(this);
            }
        }
    };
    return GroupBySubscriber;
}(_$Subscriber_484.Subscriber));
var GroupDurationSubscriber = (function (_super) {
    ____extends_517(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        var _this = _super.call(this, group) || this;
        _this.key = key;
        _this.group = group;
        _this.parent = parent;
        return _this;
    }
    GroupDurationSubscriber.prototype._next = function (value) {
        this.complete();
    };
    GroupDurationSubscriber.prototype._unsubscribe = function () {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) {
            parent.removeGroup(key);
        }
    };
    return GroupDurationSubscriber;
}(_$Subscriber_484.Subscriber));
var GroupedObservable = (function (_super) {
    ____extends_517(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new _$Subscription_485.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(_$Observable_477.Observable));
_$groupBy_517.GroupedObservable = GroupedObservable;
var InnerRefCountSubscription = (function (_super) {
    ____extends_517(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(_$Subscription_485.Subscription));
//# sourceMappingURL=groupBy.js.map
var _$BehaviorSubject_474 = {};
"use strict";
var ____extends_474 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$BehaviorSubject_474, "__esModule", { value: true });
/* removed: var _$Subject_482 = require("./Subject"); */;
/* removed: var _$ObjectUnsubscribedError_548 = require("./util/ObjectUnsubscribedError"); */;
var BehaviorSubject = (function (_super) {
    ____extends_474(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new _$ObjectUnsubscribedError_548.ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(_$Subject_482.Subject));
_$BehaviorSubject_474.BehaviorSubject = BehaviorSubject;
//# sourceMappingURL=BehaviorSubject.js.map
var _$Action_528 = {};
"use strict";
var ____extends_528 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$Action_528, "__esModule", { value: true });
/* removed: var _$Subscription_485 = require("../Subscription"); */;
var Action = (function (_super) {
    ____extends_528(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        return this;
    };
    return Action;
}(_$Subscription_485.Subscription));
_$Action_528.Action = Action;
//# sourceMappingURL=Action.js.map
var _$AsyncAction_533 = {};
"use strict";
var ____extends_533 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$AsyncAction_533, "__esModule", { value: true });
/* removed: var _$Action_528 = require("./Action"); */;
var AsyncAction = (function (_super) {
    ____extends_533(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(_$Action_528.Action));
_$AsyncAction_533.AsyncAction = AsyncAction;
//# sourceMappingURL=AsyncAction.js.map
var _$QueueAction_535 = {};
"use strict";
var ____extends_535 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$QueueAction_535, "__esModule", { value: true });
/* removed: var _$AsyncAction_533 = require("./AsyncAction"); */;
var QueueAction = (function (_super) {
    ____extends_535(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        return scheduler.flush(this);
    };
    return QueueAction;
}(_$AsyncAction_533.AsyncAction));
_$QueueAction_535.QueueAction = QueueAction;
//# sourceMappingURL=QueueAction.js.map
var _$Scheduler_481 = {};
"use strict";
Object.defineProperty(_$Scheduler_481, "__esModule", { value: true });
var Scheduler = (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function () { return Date.now(); };
    return Scheduler;
}());
_$Scheduler_481.Scheduler = Scheduler;
//# sourceMappingURL=Scheduler.js.map
var _$AsyncScheduler_534 = {};
"use strict";
var ____extends_534 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$AsyncScheduler_534, "__esModule", { value: true });
/* removed: var _$Scheduler_481 = require("../Scheduler"); */;
var AsyncScheduler = (function (_super) {
    ____extends_534(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) { now = _$Scheduler_481.Scheduler.now; }
        var _this = _super.call(this, SchedulerAction, function () {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                return AsyncScheduler.delegate.now();
            }
            else {
                return now();
            }
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
            return AsyncScheduler.delegate.schedule(work, delay, state);
        }
        else {
            return _super.prototype.schedule.call(this, work, delay, state);
        }
    };
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift());
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(_$Scheduler_481.Scheduler));
_$AsyncScheduler_534.AsyncScheduler = AsyncScheduler;
//# sourceMappingURL=AsyncScheduler.js.map
var _$QueueScheduler_536 = {};
"use strict";
var ____extends_536 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$QueueScheduler_536, "__esModule", { value: true });
/* removed: var _$AsyncScheduler_534 = require("./AsyncScheduler"); */;
var QueueScheduler = (function (_super) {
    ____extends_536(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(_$AsyncScheduler_534.AsyncScheduler));
_$QueueScheduler_536.QueueScheduler = QueueScheduler;
//# sourceMappingURL=QueueScheduler.js.map
var _$queue_541 = {};
"use strict";
Object.defineProperty(_$queue_541, "__esModule", { value: true });
/* removed: var _$QueueAction_535 = require("./QueueAction"); */;
/* removed: var _$QueueScheduler_536 = require("./QueueScheduler"); */;
_$queue_541.queueScheduler = new _$QueueScheduler_536.QueueScheduler(_$QueueAction_535.QueueAction);
_$queue_541.queue = _$queue_541.queueScheduler;
//# sourceMappingURL=queue.js.map
var _$empty_494 = {};
"use strict";
Object.defineProperty(_$empty_494, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
_$empty_494.EMPTY = new _$Observable_477.Observable(function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : _$empty_494.EMPTY;
}
_$empty_494.empty = empty;
function emptyScheduled(scheduler) {
    return new _$Observable_477.Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}
//# sourceMappingURL=empty.js.map
var _$isScheduler_563 = {};
"use strict";
Object.defineProperty(_$isScheduler_563, "__esModule", { value: true });
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
_$isScheduler_563.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map
var _$subscribeToArray_568 = {};
"use strict";
Object.defineProperty(_$subscribeToArray_568, "__esModule", { value: true });
_$subscribeToArray_568.subscribeToArray = function (array) { return function (subscriber) {
    for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
        subscriber.next(array[i]);
    }
    subscriber.complete();
}; };
//# sourceMappingURL=subscribeToArray.js.map
var _$scheduleArray_523 = {};
"use strict";
Object.defineProperty(_$scheduleArray_523, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$Subscription_485 = require("../Subscription"); */;
function scheduleArray(input, scheduler) {
    return new _$Observable_477.Observable(function (subscriber) {
        var sub = new _$Subscription_485.Subscription();
        var i = 0;
        sub.add(scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) {
                sub.add(this.schedule());
            }
        }));
        return sub;
    });
}
_$scheduleArray_523.scheduleArray = scheduleArray;
//# sourceMappingURL=scheduleArray.js.map
var _$fromArray_497 = {};
"use strict";
Object.defineProperty(_$fromArray_497, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$subscribeToArray_568 = require("../util/subscribeToArray"); */;
/* removed: var _$scheduleArray_523 = require("../scheduled/scheduleArray"); */;
function fromArray(input, scheduler) {
    if (!scheduler) {
        return new _$Observable_477.Observable(_$subscribeToArray_568.subscribeToArray(input));
    }
    else {
        return _$scheduleArray_523.scheduleArray(input, scheduler);
    }
}
_$fromArray_497.fromArray = fromArray;
//# sourceMappingURL=fromArray.js.map
var _$of_505 = {};
"use strict";
Object.defineProperty(_$of_505, "__esModule", { value: true });
/* removed: var _$isScheduler_563 = require("../util/isScheduler"); */;
/* removed: var _$fromArray_497 = require("./fromArray"); */;
/* removed: var _$scheduleArray_523 = require("../scheduled/scheduleArray"); */;
function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args[args.length - 1];
    if (_$isScheduler_563.isScheduler(scheduler)) {
        args.pop();
        return _$scheduleArray_523.scheduleArray(args, scheduler);
    }
    else {
        return _$fromArray_497.fromArray(args);
    }
}
_$of_505.of = of;
//# sourceMappingURL=of.js.map
var _$throwError_511 = {};
"use strict";
Object.defineProperty(_$throwError_511, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
function throwError(error, scheduler) {
    if (!scheduler) {
        return new _$Observable_477.Observable(function (subscriber) { return subscriber.error(error); });
    }
    else {
        return new _$Observable_477.Observable(function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
    }
}
_$throwError_511.throwError = throwError;
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}
//# sourceMappingURL=throwError.js.map
var _$Notification_476 = {};
"use strict";
Object.defineProperty(_$Notification_476, "__esModule", { value: true });
/* removed: var _$empty_494 = require("./observable/empty"); */;
/* removed: var _$of_505 = require("./observable/of"); */;
/* removed: var _$throwError_511 = require("./observable/throwError"); */;
var NotificationKind;
(function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind = _$Notification_476.NotificationKind || (_$Notification_476.NotificationKind = {}));
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return _$of_505.of(this.value);
            case 'E':
                return _$throwError_511.throwError(this.error);
            case 'C':
                return _$empty_494.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());
_$Notification_476.Notification = Notification;
//# sourceMappingURL=Notification.js.map
var _$observeOn_521 = {};
"use strict";
var ____extends_521 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$observeOn_521, "__esModule", { value: true });
/* removed: var _$Subscriber_484 = require("../Subscriber"); */;
/* removed: var _$Notification_476 = require("../Notification"); */;
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
_$observeOn_521.observeOn = observeOn;
var ObserveOnOperator = (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());
_$observeOn_521.ObserveOnOperator = ObserveOnOperator;
var ObserveOnSubscriber = (function (_super) {
    ____extends_521(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(_$Notification_476.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(_$Notification_476.Notification.createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(_$Notification_476.Notification.createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}(_$Subscriber_484.Subscriber));
_$observeOn_521.ObserveOnSubscriber = ObserveOnSubscriber;
var ObserveOnMessage = (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());
_$observeOn_521.ObserveOnMessage = ObserveOnMessage;
//# sourceMappingURL=observeOn.js.map
var _$ReplaySubject_480 = {};
"use strict";
var ____extends_480 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$ReplaySubject_480, "__esModule", { value: true });
/* removed: var _$Subject_482 = require("./Subject"); */;
/* removed: var _$queue_541 = require("./scheduler/queue"); */;
/* removed: var _$Subscription_485 = require("./Subscription"); */;
/* removed: var _$observeOn_521 = require("./operators/observeOn"); */;
/* removed: var _$ObjectUnsubscribedError_548 = require("./util/ObjectUnsubscribedError"); */;
/* removed: var _$SubjectSubscription_483 = require("./SubjectSubscription"); */;
var ReplaySubject = (function (_super) {
    ____extends_480(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        }
        else {
            _this.next = _this.nextTimeWindow;
        }
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
        if (!this.isStopped) {
            var _events = this._events;
            _events.push(value);
            if (_events.length > this._bufferSize) {
                _events.shift();
            }
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function (value) {
        if (!this.isStopped) {
            this._events.push(new ReplayEvent(this._getNow(), value));
            this._trimBufferThenGetEvents();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) {
            throw new _$ObjectUnsubscribedError_548.ObjectUnsubscribedError();
        }
        else if (this.isStopped || this.hasError) {
            subscription = _$Subscription_485.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new _$SubjectSubscription_483.SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new _$observeOn_521.ObserveOnSubscriber(subscriber, scheduler));
        }
        if (_infiniteTimeWindow) {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i]);
            }
        }
        else {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i].value);
            }
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || _$queue_541.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(_$Subject_482.Subject));
_$ReplaySubject_480.ReplaySubject = ReplaySubject;
var ReplayEvent = (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map
var _$AsyncSubject_473 = {};
"use strict";
var ____extends_473 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$AsyncSubject_473, "__esModule", { value: true });
/* removed: var _$Subject_482 = require("./Subject"); */;
/* removed: var _$Subscription_485 = require("./Subscription"); */;
var AsyncSubject = (function (_super) {
    ____extends_473(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return _$Subscription_485.Subscription.EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return _$Subscription_485.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(_$Subject_482.Subject));
_$AsyncSubject_473.AsyncSubject = AsyncSubject;
//# sourceMappingURL=AsyncSubject.js.map
var _$Immediate_547 = {};
"use strict";
Object.defineProperty(_$Immediate_547, "__esModule", { value: true });
var nextHandle = 1;
var RESOLVED = (function () { return Promise.resolve(); })();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
_$Immediate_547.Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function () { return findAndClearHandle(handle) && cb(); });
        return handle;
    },
    clearImmediate: function (handle) {
        findAndClearHandle(handle);
    },
};
_$Immediate_547.TestTools = {
    pending: function () {
        return Object.keys(activeHandles).length;
    }
};
//# sourceMappingURL=Immediate.js.map
var _$AsapAction_531 = {};
"use strict";
var ____extends_531 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$AsapAction_531, "__esModule", { value: true });
/* removed: var _$Immediate_547 = require("../util/Immediate"); */;
/* removed: var _$AsyncAction_533 = require("./AsyncAction"); */;
var AsapAction = (function (_super) {
    ____extends_531(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = _$Immediate_547.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            _$Immediate_547.Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}(_$AsyncAction_533.AsyncAction));
_$AsapAction_531.AsapAction = AsapAction;
//# sourceMappingURL=AsapAction.js.map
var _$AsapScheduler_532 = {};
"use strict";
var ____extends_532 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$AsapScheduler_532, "__esModule", { value: true });
/* removed: var _$AsyncScheduler_534 = require("./AsyncScheduler"); */;
var AsapScheduler = (function (_super) {
    ____extends_532(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(_$AsyncScheduler_534.AsyncScheduler));
_$AsapScheduler_532.AsapScheduler = AsapScheduler;
//# sourceMappingURL=AsapScheduler.js.map
var _$asap_539 = {};
"use strict";
Object.defineProperty(_$asap_539, "__esModule", { value: true });
/* removed: var _$AsapAction_531 = require("./AsapAction"); */;
/* removed: var _$AsapScheduler_532 = require("./AsapScheduler"); */;
_$asap_539.asapScheduler = new _$AsapScheduler_532.AsapScheduler(_$AsapAction_531.AsapAction);
_$asap_539.asap = _$asap_539.asapScheduler;
//# sourceMappingURL=asap.js.map
var _$async_540 = {};
"use strict";
Object.defineProperty(_$async_540, "__esModule", { value: true });
/* removed: var _$AsyncAction_533 = require("./AsyncAction"); */;
/* removed: var _$AsyncScheduler_534 = require("./AsyncScheduler"); */;
_$async_540.asyncScheduler = new _$AsyncScheduler_534.AsyncScheduler(_$AsyncAction_533.AsyncAction);
_$async_540.async = _$async_540.asyncScheduler;
//# sourceMappingURL=async.js.map
var _$AnimationFrameAction_529 = {};
"use strict";
var ____extends_529 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$AnimationFrameAction_529, "__esModule", { value: true });
/* removed: var _$AsyncAction_533 = require("./AsyncAction"); */;
var AnimationFrameAction = (function (_super) {
    ____extends_529(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(_$AsyncAction_533.AsyncAction));
_$AnimationFrameAction_529.AnimationFrameAction = AnimationFrameAction;
//# sourceMappingURL=AnimationFrameAction.js.map
var _$AnimationFrameScheduler_530 = {};
"use strict";
var ____extends_530 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$AnimationFrameScheduler_530, "__esModule", { value: true });
/* removed: var _$AsyncScheduler_534 = require("./AsyncScheduler"); */;
var AnimationFrameScheduler = (function (_super) {
    ____extends_530(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(_$AsyncScheduler_534.AsyncScheduler));
_$AnimationFrameScheduler_530.AnimationFrameScheduler = AnimationFrameScheduler;
//# sourceMappingURL=AnimationFrameScheduler.js.map
var _$animationFrame_538 = {};
"use strict";
Object.defineProperty(_$animationFrame_538, "__esModule", { value: true });
/* removed: var _$AnimationFrameAction_529 = require("./AnimationFrameAction"); */;
/* removed: var _$AnimationFrameScheduler_530 = require("./AnimationFrameScheduler"); */;
_$animationFrame_538.animationFrameScheduler = new _$AnimationFrameScheduler_530.AnimationFrameScheduler(_$AnimationFrameAction_529.AnimationFrameAction);
_$animationFrame_538.animationFrame = _$animationFrame_538.animationFrameScheduler;
//# sourceMappingURL=animationFrame.js.map
var _$VirtualTimeScheduler_537 = {};
"use strict";
var ____extends_537 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$VirtualTimeScheduler_537, "__esModule", { value: true });
/* removed: var _$AsyncAction_533 = require("./AsyncAction"); */;
/* removed: var _$AsyncScheduler_534 = require("./AsyncScheduler"); */;
var VirtualTimeScheduler = (function (_super) {
    ____extends_537(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
        if (maxFrames === void 0) { maxFrames = Number.POSITIVE_INFINITY; }
        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(_$AsyncScheduler_534.AsyncScheduler));
_$VirtualTimeScheduler_537.VirtualTimeScheduler = VirtualTimeScheduler;
var VirtualAction = (function (_super) {
    ____extends_537(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) { index = scheduler.index += 1; }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(_$AsyncAction_533.AsyncAction));
_$VirtualTimeScheduler_537.VirtualAction = VirtualAction;
//# sourceMappingURL=VirtualTimeScheduler.js.map
var _$noop_564 = {};
"use strict";
Object.defineProperty(_$noop_564, "__esModule", { value: true });
function __noop_564() { }
_$noop_564.noop = __noop_564;
//# sourceMappingURL=noop.js.map
var _$isObservable_561 = {};
"use strict";
Object.defineProperty(_$isObservable_561, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
function isObservable(obj) {
    return !!obj && (obj instanceof _$Observable_477.Observable || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
}
_$isObservable_561.isObservable = isObservable;
//# sourceMappingURL=isObservable.js.map
var _$ArgumentOutOfRangeError_545 = {};
"use strict";
Object.defineProperty(_$ArgumentOutOfRangeError_545, "__esModule", { value: true });
var ArgumentOutOfRangeErrorImpl = (function () {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = 'argument out of range';
        this.name = 'ArgumentOutOfRangeError';
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
})();
_$ArgumentOutOfRangeError_545.ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;
//# sourceMappingURL=ArgumentOutOfRangeError.js.map
var _$EmptyError_546 = {};
"use strict";
Object.defineProperty(_$EmptyError_546, "__esModule", { value: true });
var EmptyErrorImpl = (function () {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = 'no elements in sequence';
        this.name = 'EmptyError';
        return this;
    }
    EmptyErrorImpl.prototype = Object.create(Error.prototype);
    return EmptyErrorImpl;
})();
_$EmptyError_546.EmptyError = EmptyErrorImpl;
//# sourceMappingURL=EmptyError.js.map
var _$TimeoutError_549 = {};
"use strict";
Object.defineProperty(_$TimeoutError_549, "__esModule", { value: true });
var TimeoutErrorImpl = (function () {
    function TimeoutErrorImpl() {
        Error.call(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        return this;
    }
    TimeoutErrorImpl.prototype = Object.create(Error.prototype);
    return TimeoutErrorImpl;
})();
_$TimeoutError_549.TimeoutError = TimeoutErrorImpl;
//# sourceMappingURL=TimeoutError.js.map
var _$map_518 = {};
"use strict";
var ____extends_518 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$map_518, "__esModule", { value: true });
/* removed: var _$Subscriber_484 = require("../Subscriber"); */;
function __map_518(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
_$map_518.map = __map_518;
var MapOperator = (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
_$map_518.MapOperator = MapOperator;
var MapSubscriber = (function (_super) {
    ____extends_518(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(_$Subscriber_484.Subscriber));
//# sourceMappingURL=map.js.map
var _$bindCallback_489 = {};
"use strict";
Object.defineProperty(_$bindCallback_489, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$AsyncSubject_473 = require("../AsyncSubject"); */;
/* removed: var _$map_518 = require("../operators/map"); */;
/* removed: var _$canReportError_551 = require("../util/canReportError"); */;
/* removed: var _$isArray_554 = require("../util/isArray"); */;
/* removed: var _$isScheduler_563 = require("../util/isScheduler"); */;
function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (_$isScheduler_563.isScheduler(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(_$map_518.map(function (args) { return _$isArray_554.isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
        };
        return new _$Observable_477.Observable(function (subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new _$AsyncSubject_473.AsyncSubject();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (_$canReportError_551.canReportError(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                var state = {
                    args: args, subscriber: subscriber, params: params,
                };
                return scheduler.schedule(__dispatch_489, 0, state);
            }
        });
    };
}
_$bindCallback_489.bindCallback = bindCallback;
function __dispatch_489(state) {
    var _this = this;
    var self = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new _$AsyncSubject_473.AsyncSubject();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(state) {
    var err = state.err, subject = state.subject;
    subject.error(err);
}
//# sourceMappingURL=bindCallback.js.map
var _$bindNodeCallback_490 = {};
"use strict";
Object.defineProperty(_$bindNodeCallback_490, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$AsyncSubject_473 = require("../AsyncSubject"); */;
/* removed: var _$map_518 = require("../operators/map"); */;
/* removed: var _$canReportError_551 = require("../util/canReportError"); */;
/* removed: var _$isScheduler_563 = require("../util/isScheduler"); */;
/* removed: var _$isArray_554 = require("../util/isArray"); */;
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (_$isScheduler_563.isScheduler(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(_$map_518.map(function (args) { return _$isArray_554.isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this,
        };
        return new _$Observable_477.Observable(function (subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new _$AsyncSubject_473.AsyncSubject();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (_$canReportError_551.canReportError(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                return scheduler.schedule(__dispatch_490, 0, { params: params, subscriber: subscriber, context: context });
            }
        });
    };
}
_$bindNodeCallback_490.bindNodeCallback = bindNodeCallback;
function __dispatch_490(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new _$AsyncSubject_473.AsyncSubject();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var err = innerArgs.shift();
            if (err) {
                _this.add(scheduler.schedule(__dispatchError_490, 0, { err: err, subject: subject }));
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(__dispatchNext_490, 0, { value: value, subject: subject }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            this.add(scheduler.schedule(__dispatchError_490, 0, { err: err, subject: subject }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function __dispatchNext_490(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function __dispatchError_490(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=bindNodeCallback.js.map
var _$OuterSubscriber_479 = {};
"use strict";
var ____extends_479 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$OuterSubscriber_479, "__esModule", { value: true });
/* removed: var _$Subscriber_484 = require("./Subscriber"); */;
var OuterSubscriber = (function (_super) {
    ____extends_479(OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(_$Subscriber_484.Subscriber));
_$OuterSubscriber_479.OuterSubscriber = OuterSubscriber;
//# sourceMappingURL=OuterSubscriber.js.map
var _$InnerSubscriber_475 = {};
"use strict";
var ____extends_475 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$InnerSubscriber_475, "__esModule", { value: true });
/* removed: var _$Subscriber_484 = require("./Subscriber"); */;
var InnerSubscriber = (function (_super) {
    ____extends_475(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(_$Subscriber_484.Subscriber));
_$InnerSubscriber_475.InnerSubscriber = InnerSubscriber;
//# sourceMappingURL=InnerSubscriber.js.map
var _$subscribeToPromise_571 = {};
"use strict";
Object.defineProperty(_$subscribeToPromise_571, "__esModule", { value: true });
/* removed: var _$hostReportError_552 = require("./hostReportError"); */;
_$subscribeToPromise_571.subscribeToPromise = function (promise) { return function (subscriber) {
    promise.then(function (value) {
        if (!subscriber.closed) {
            subscriber.next(value);
            subscriber.complete();
        }
    }, function (err) { return subscriber.error(err); })
        .then(null, _$hostReportError_552.hostReportError);
    return subscriber;
}; };
//# sourceMappingURL=subscribeToPromise.js.map
var _$iterator_542 = {};
"use strict";
Object.defineProperty(_$iterator_542, "__esModule", { value: true });
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
_$iterator_542.getSymbolIterator = getSymbolIterator;
_$iterator_542.iterator = getSymbolIterator();
_$iterator_542.$$iterator = _$iterator_542.iterator;
//# sourceMappingURL=iterator.js.map
var _$subscribeToIterable_569 = {};
"use strict";
Object.defineProperty(_$subscribeToIterable_569, "__esModule", { value: true });
/* removed: var _$iterator_542 = require("../symbol/iterator"); */;
_$subscribeToIterable_569.subscribeToIterable = function (iterable) { return function (subscriber) {
    var iterator = iterable[_$iterator_542.iterator]();
    do {
        var item = void 0;
        try {
            item = iterator.next();
        }
        catch (err) {
            subscriber.error(err);
            return subscriber;
        }
        if (item.done) {
            subscriber.complete();
            break;
        }
        subscriber.next(item.value);
        if (subscriber.closed) {
            break;
        }
    } while (true);
    if (typeof iterator.return === 'function') {
        subscriber.add(function () {
            if (iterator.return) {
                iterator.return();
            }
        });
    }
    return subscriber;
}; };
//# sourceMappingURL=subscribeToIterable.js.map
var _$subscribeToObservable_570 = {};
"use strict";
Object.defineProperty(_$subscribeToObservable_570, "__esModule", { value: true });
/* removed: var _$observable_543 = require("../symbol/observable"); */;
_$subscribeToObservable_570.subscribeToObservable = function (obj) { return function (subscriber) {
    var obs = obj[_$observable_543.observable]();
    if (typeof obs.subscribe !== 'function') {
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    }
    else {
        return obs.subscribe(subscriber);
    }
}; };
//# sourceMappingURL=subscribeToObservable.js.map
var _$isArrayLike_555 = {};
"use strict";
Object.defineProperty(_$isArrayLike_555, "__esModule", { value: true });
_$isArrayLike_555.isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
//# sourceMappingURL=isArrayLike.js.map
var _$isPromise_562 = {};
"use strict";
Object.defineProperty(_$isPromise_562, "__esModule", { value: true });
function __isPromise_562(value) {
    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
_$isPromise_562.isPromise = __isPromise_562;
//# sourceMappingURL=isPromise.js.map
var _$subscribeTo_567 = {};
"use strict";
Object.defineProperty(_$subscribeTo_567, "__esModule", { value: true });
/* removed: var _$subscribeToArray_568 = require("./subscribeToArray"); */;
/* removed: var _$subscribeToPromise_571 = require("./subscribeToPromise"); */;
/* removed: var _$subscribeToIterable_569 = require("./subscribeToIterable"); */;
/* removed: var _$subscribeToObservable_570 = require("./subscribeToObservable"); */;
/* removed: var _$isArrayLike_555 = require("./isArrayLike"); */;
/* removed: var _$isPromise_562 = require("./isPromise"); */;
/* removed: var _$isObject_560 = require("./isObject"); */;
/* removed: var _$iterator_542 = require("../symbol/iterator"); */;
/* removed: var _$observable_543 = require("../symbol/observable"); */;
_$subscribeTo_567.subscribeTo = function (result) {
    if (!!result && typeof result[_$observable_543.observable] === 'function') {
        return _$subscribeToObservable_570.subscribeToObservable(result);
    }
    else if (_$isArrayLike_555.isArrayLike(result)) {
        return _$subscribeToArray_568.subscribeToArray(result);
    }
    else if (_$isPromise_562.isPromise(result)) {
        return _$subscribeToPromise_571.subscribeToPromise(result);
    }
    else if (!!result && typeof result[_$iterator_542.iterator] === 'function') {
        return _$subscribeToIterable_569.subscribeToIterable(result);
    }
    else {
        var value = _$isObject_560.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected."
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        throw new TypeError(msg);
    }
};
//# sourceMappingURL=subscribeTo.js.map
var _$subscribeToResult_572 = {};
"use strict";
Object.defineProperty(_$subscribeToResult_572, "__esModule", { value: true });
/* removed: var _$InnerSubscriber_475 = require("../InnerSubscriber"); */;
/* removed: var _$subscribeTo_567 = require("./subscribeTo"); */;
/* removed: var _$Observable_477 = require("../Observable"); */;
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) { innerSubscriber = new _$InnerSubscriber_475.InnerSubscriber(outerSubscriber, outerValue, outerIndex); }
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof _$Observable_477.Observable) {
        return result.subscribe(innerSubscriber);
    }
    return _$subscribeTo_567.subscribeTo(result)(innerSubscriber);
}
_$subscribeToResult_572.subscribeToResult = subscribeToResult;
//# sourceMappingURL=subscribeToResult.js.map
var _$combineLatest_491 = {};
"use strict";
var ____extends_491 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$combineLatest_491, "__esModule", { value: true });
/* removed: var _$isScheduler_563 = require("../util/isScheduler"); */;
/* removed: var _$isArray_554 = require("../util/isArray"); */;
/* removed: var _$OuterSubscriber_479 = require("../OuterSubscriber"); */;
/* removed: var _$subscribeToResult_572 = require("../util/subscribeToResult"); */;
/* removed: var _$fromArray_497 = require("./fromArray"); */;
var NONE = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = undefined;
    var scheduler = undefined;
    if (_$isScheduler_563.isScheduler(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        resultSelector = observables.pop();
    }
    if (observables.length === 1 && _$isArray_554.isArray(observables[0])) {
        observables = observables[0];
    }
    return _$fromArray_497.fromArray(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
_$combineLatest_491.combineLatest = combineLatest;
var CombineLatestOperator = (function () {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}());
_$combineLatest_491.CombineLatestOperator = CombineLatestOperator;
var CombineLatestSubscriber = (function (_super) {
    ____extends_491(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(_$subscribeToResult_572.subscribeToResult(this, observable, undefined, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) {
                this._tryResultSelector(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(_$OuterSubscriber_479.OuterSubscriber));
_$combineLatest_491.CombineLatestSubscriber = CombineLatestSubscriber;
//# sourceMappingURL=combineLatest.js.map
var _$scheduleObservable_525 = {};
"use strict";
Object.defineProperty(_$scheduleObservable_525, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$Subscription_485 = require("../Subscription"); */;
/* removed: var _$observable_543 = require("../symbol/observable"); */;
function scheduleObservable(input, scheduler) {
    return new _$Observable_477.Observable(function (subscriber) {
        var sub = new _$Subscription_485.Subscription();
        sub.add(scheduler.schedule(function () {
            var observable = input[_$observable_543.observable]();
            sub.add(observable.subscribe({
                next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
            }));
        }));
        return sub;
    });
}
_$scheduleObservable_525.scheduleObservable = scheduleObservable;
//# sourceMappingURL=scheduleObservable.js.map
var _$schedulePromise_526 = {};
"use strict";
Object.defineProperty(_$schedulePromise_526, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$Subscription_485 = require("../Subscription"); */;
function schedulePromise(input, scheduler) {
    return new _$Observable_477.Observable(function (subscriber) {
        var sub = new _$Subscription_485.Subscription();
        sub.add(scheduler.schedule(function () { return input.then(function (value) {
            sub.add(scheduler.schedule(function () {
                subscriber.next(value);
                sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
            }));
        }, function (err) {
            sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
        }); }));
        return sub;
    });
}
_$schedulePromise_526.schedulePromise = schedulePromise;
//# sourceMappingURL=schedulePromise.js.map
var _$scheduleIterable_524 = {};
"use strict";
Object.defineProperty(_$scheduleIterable_524, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$Subscription_485 = require("../Subscription"); */;
/* removed: var _$iterator_542 = require("../symbol/iterator"); */;
function scheduleIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new _$Observable_477.Observable(function (subscriber) {
        var sub = new _$Subscription_485.Subscription();
        var iterator;
        sub.add(function () {
            if (iterator && typeof iterator.return === 'function') {
                iterator.return();
            }
        });
        sub.add(scheduler.schedule(function () {
            iterator = input[_$iterator_542.iterator]();
            sub.add(scheduler.schedule(function () {
                if (subscriber.closed) {
                    return;
                }
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}
_$scheduleIterable_524.scheduleIterable = scheduleIterable;
//# sourceMappingURL=scheduleIterable.js.map
var _$isInteropObservable_557 = {};
"use strict";
Object.defineProperty(_$isInteropObservable_557, "__esModule", { value: true });
/* removed: var _$observable_543 = require("../symbol/observable"); */;
function isInteropObservable(input) {
    return input && typeof input[_$observable_543.observable] === 'function';
}
_$isInteropObservable_557.isInteropObservable = isInteropObservable;
//# sourceMappingURL=isInteropObservable.js.map
var _$isIterable_558 = {};
"use strict";
Object.defineProperty(_$isIterable_558, "__esModule", { value: true });
/* removed: var _$iterator_542 = require("../symbol/iterator"); */;
function __isIterable_558(input) {
    return input && typeof input[_$iterator_542.iterator] === 'function';
}
_$isIterable_558.isIterable = __isIterable_558;
//# sourceMappingURL=isIterable.js.map
var _$scheduled_527 = {};
"use strict";
Object.defineProperty(_$scheduled_527, "__esModule", { value: true });
/* removed: var _$scheduleObservable_525 = require("./scheduleObservable"); */;
/* removed: var _$schedulePromise_526 = require("./schedulePromise"); */;
/* removed: var _$scheduleArray_523 = require("./scheduleArray"); */;
/* removed: var _$scheduleIterable_524 = require("./scheduleIterable"); */;
/* removed: var _$isInteropObservable_557 = require("../util/isInteropObservable"); */;
/* removed: var _$isPromise_562 = require("../util/isPromise"); */;
/* removed: var _$isArrayLike_555 = require("../util/isArrayLike"); */;
/* removed: var _$isIterable_558 = require("../util/isIterable"); */;
function scheduled(input, scheduler) {
    if (input != null) {
        if (_$isInteropObservable_557.isInteropObservable(input)) {
            return _$scheduleObservable_525.scheduleObservable(input, scheduler);
        }
        else if (_$isPromise_562.isPromise(input)) {
            return _$schedulePromise_526.schedulePromise(input, scheduler);
        }
        else if (_$isArrayLike_555.isArrayLike(input)) {
            return _$scheduleArray_523.scheduleArray(input, scheduler);
        }
        else if (_$isIterable_558.isIterable(input) || typeof input === 'string') {
            return _$scheduleIterable_524.scheduleIterable(input, scheduler);
        }
    }
    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
}
_$scheduled_527.scheduled = scheduled;
//# sourceMappingURL=scheduled.js.map
var _$from_496 = {};
"use strict";
Object.defineProperty(_$from_496, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$subscribeTo_567 = require("../util/subscribeTo"); */;
/* removed: var _$scheduled_527 = require("../scheduled/scheduled"); */;
function __from_496(input, scheduler) {
    if (!scheduler) {
        if (input instanceof _$Observable_477.Observable) {
            return input;
        }
        return new _$Observable_477.Observable(_$subscribeTo_567.subscribeTo(input));
    }
    else {
        return _$scheduled_527.scheduled(input, scheduler);
    }
}
_$from_496.from = __from_496;
//# sourceMappingURL=from.js.map
var _$innerSubscribe_487 = {};
"use strict";
var ____extends_487 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$innerSubscribe_487, "__esModule", { value: true });
/* removed: var _$Subscriber_484 = require("./Subscriber"); */;
/* removed: var _$Observable_477 = require("./Observable"); */;
/* removed: var _$subscribeTo_567 = require("./util/subscribeTo"); */;
var SimpleInnerSubscriber = (function (_super) {
    ____extends_487(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}(_$Subscriber_484.Subscriber));
_$innerSubscribe_487.SimpleInnerSubscriber = SimpleInnerSubscriber;
var ComplexInnerSubscriber = (function (_super) {
    ____extends_487(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}(_$Subscriber_484.Subscriber));
_$innerSubscribe_487.ComplexInnerSubscriber = ComplexInnerSubscriber;
var SimpleOuterSubscriber = (function (_super) {
    ____extends_487(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function () {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}(_$Subscriber_484.Subscriber));
_$innerSubscribe_487.SimpleOuterSubscriber = SimpleOuterSubscriber;
var ComplexOuterSubscriber = (function (_super) {
    ____extends_487(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function (_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function (error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function (_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}(_$Subscriber_484.Subscriber));
_$innerSubscribe_487.ComplexOuterSubscriber = ComplexOuterSubscriber;
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof _$Observable_477.Observable) {
        return result.subscribe(innerSubscriber);
    }
    var subscription;
    try {
        subscription = _$subscribeTo_567.subscribeTo(result)(innerSubscriber);
    }
    catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}
_$innerSubscribe_487.innerSubscribe = innerSubscribe;
//# sourceMappingURL=innerSubscribe.js.map
var _$mergeMap_520 = {};
"use strict";
var ____extends_520 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$mergeMap_520, "__esModule", { value: true });
/* removed: var _$map_518 = require("./map"); */;
/* removed: var _$from_496 = require("../observable/from"); */;
/* removed: var _$innerSubscribe_487 = require("../innerSubscribe"); */;
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(mergeMap(function (a, i) { return _$from_496.from(project(a, i)).pipe(_$map_518.map(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
}
_$mergeMap_520.mergeMap = mergeMap;
var MergeMapOperator = (function () {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}());
_$mergeMap_520.MergeMapOperator = MergeMapOperator;
var MergeMapSubscriber = (function (_super) {
    ____extends_520(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish) {
        var innerSubscriber = new _$innerSubscribe_487.SimpleInnerSubscriber(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = _$innerSubscribe_487.innerSubscribe(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            destination.add(innerSubscription);
        }
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function () {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(_$innerSubscribe_487.SimpleOuterSubscriber));
_$mergeMap_520.MergeMapSubscriber = MergeMapSubscriber;
_$mergeMap_520.flatMap = mergeMap;
//# sourceMappingURL=mergeMap.js.map
var _$mergeAll_519 = {};
"use strict";
Object.defineProperty(_$mergeAll_519, "__esModule", { value: true });
/* removed: var _$mergeMap_520 = require("./mergeMap"); */;
/* removed: var _$identity_553 = require("../util/identity"); */;
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return _$mergeMap_520.mergeMap(_$identity_553.identity, concurrent);
}
_$mergeAll_519.mergeAll = mergeAll;
//# sourceMappingURL=mergeAll.js.map
var _$concatAll_515 = {};
"use strict";
Object.defineProperty(_$concatAll_515, "__esModule", { value: true });
/* removed: var _$mergeAll_519 = require("./mergeAll"); */;
function concatAll() {
    return _$mergeAll_519.mergeAll(1);
}
_$concatAll_515.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map
var _$concat_492 = {};
"use strict";
Object.defineProperty(_$concat_492, "__esModule", { value: true });
/* removed: var _$of_505 = require("./of"); */;
/* removed: var _$concatAll_515 = require("../operators/concatAll"); */;
function __concat_492() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return _$concatAll_515.concatAll()(_$of_505.of.apply(void 0, observables));
}
_$concat_492.concat = __concat_492;
//# sourceMappingURL=concat.js.map
var _$defer_493 = {};
"use strict";
Object.defineProperty(_$defer_493, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$from_496 = require("./from"); */;
/* removed: var _$empty_494 = require("./empty"); */;
function defer(observableFactory) {
    return new _$Observable_477.Observable(function (subscriber) {
        var input;
        try {
            input = observableFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? _$from_496.from(input) : _$empty_494.empty();
        return source.subscribe(subscriber);
    });
}
_$defer_493.defer = defer;
//# sourceMappingURL=defer.js.map
var _$forkJoin_495 = {};
"use strict";
Object.defineProperty(_$forkJoin_495, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$isArray_554 = require("../util/isArray"); */;
/* removed: var _$map_518 = require("../operators/map"); */;
/* removed: var _$isObject_560 = require("../util/isObject"); */;
/* removed: var _$from_496 = require("./from"); */;
function forkJoin() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 1) {
        var first_1 = sources[0];
        if (_$isArray_554.isArray(first_1)) {
            return forkJoinInternal(first_1, null);
        }
        if (_$isObject_560.isObject(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function (key) { return first_1[key]; }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === 'function') {
        var resultSelector_1 = sources.pop();
        sources = (sources.length === 1 && _$isArray_554.isArray(sources[0])) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe(_$map_518.map(function (args) { return resultSelector_1.apply(void 0, args); }));
    }
    return forkJoinInternal(sources, null);
}
_$forkJoin_495.forkJoin = forkJoin;
function forkJoinInternal(sources, keys) {
    return new _$Observable_477.Observable(function (subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function (i) {
            var source = _$from_496.from(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function (value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function (err) { return subscriber.error(err); },
                complete: function () {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) {
                            subscriber.next(keys ?
                                keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
                                values);
                        }
                        subscriber.complete();
                    }
                }
            }));
        };
        for (var i = 0; i < len; i++) {
            _loop_1(i);
        }
    });
}
//# sourceMappingURL=forkJoin.js.map
var _$fromEvent_498 = {};
"use strict";
Object.defineProperty(_$fromEvent_498, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$isArray_554 = require("../util/isArray"); */;
/* removed: var _$isFunction_556 = require("../util/isFunction"); */;
/* removed: var _$map_518 = require("../operators/map"); */;
var __toString_498 = (function () { return Object.prototype.toString; })();
function fromEvent(target, eventName, options, resultSelector) {
    if (_$isFunction_556.isFunction(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(_$map_518.map(function (args) { return _$isArray_554.isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new _$Observable_477.Observable(function (subscriber) {
        function handler(e) {
            if (arguments.length > 1) {
                subscriber.next(Array.prototype.slice.call(arguments));
            }
            else {
                subscriber.next(e);
            }
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
_$fromEvent_498.fromEvent = fromEvent;
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
    }
    else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function () { return source_2.off(eventName, handler); };
    }
    else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
    }
    else if (sourceObj && sourceObj.length) {
        for (var i = 0, len = sourceObj.length; i < len; i++) {
            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        }
    }
    else {
        throw new TypeError('Invalid event target');
    }
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
//# sourceMappingURL=fromEvent.js.map
var _$fromEventPattern_499 = {};
"use strict";
Object.defineProperty(_$fromEventPattern_499, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$isArray_554 = require("../util/isArray"); */;
/* removed: var _$isFunction_556 = require("../util/isFunction"); */;
/* removed: var _$map_518 = require("../operators/map"); */;
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(_$map_518.map(function (args) { return _$isArray_554.isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new _$Observable_477.Observable(function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!_$isFunction_556.isFunction(removeHandler)) {
            return undefined;
        }
        return function () { return removeHandler(handler, retValue); };
    });
}
_$fromEventPattern_499.fromEventPattern = fromEventPattern;
//# sourceMappingURL=fromEventPattern.js.map
var _$generate_500 = {};
"use strict";
Object.defineProperty(_$generate_500, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$identity_553 = require("../util/identity"); */;
/* removed: var _$isScheduler_563 = require("../util/isScheduler"); */;
function __generate_500(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || _$identity_553.identity;
        scheduler = options.scheduler;
    }
    else if (resultSelectorOrObservable === undefined || _$isScheduler_563.isScheduler(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = _$identity_553.identity;
        scheduler = resultSelectorOrObservable;
    }
    else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new _$Observable_477.Observable(function (subscriber) {
        var state = initialState;
        if (scheduler) {
            return scheduler.schedule(__dispatch_500, 0, {
                subscriber: subscriber,
                iterate: iterate,
                condition: condition,
                resultSelector: resultSelector,
                state: state
            });
        }
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
        } while (true);
        return undefined;
    });
}
_$generate_500.generate = __generate_500;
function __dispatch_500(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) {
        return undefined;
    }
    if (state.needIterate) {
        try {
            state.state = state.iterate(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
    }
    else {
        state.needIterate = true;
    }
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) {
            return undefined;
        }
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    }
    catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) {
        return undefined;
    }
    subscriber.next(value);
    if (subscriber.closed) {
        return undefined;
    }
    return this.schedule(state);
}
//# sourceMappingURL=generate.js.map
var _$iif_501 = {};
"use strict";
Object.defineProperty(_$iif_501, "__esModule", { value: true });
/* removed: var _$defer_493 = require("./defer"); */;
/* removed: var _$empty_494 = require("./empty"); */;
function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) { trueResult = _$empty_494.EMPTY; }
    if (falseResult === void 0) { falseResult = _$empty_494.EMPTY; }
    return _$defer_493.defer(function () { return condition() ? trueResult : falseResult; });
}
_$iif_501.iif = iif;
//# sourceMappingURL=iif.js.map
var _$isNumeric_559 = {};
"use strict";
Object.defineProperty(_$isNumeric_559, "__esModule", { value: true });
/* removed: var _$isArray_554 = require("./isArray"); */;
function isNumeric(val) {
    return !_$isArray_554.isArray(val) && (val - parseFloat(val) + 1) >= 0;
}
_$isNumeric_559.isNumeric = isNumeric;
//# sourceMappingURL=isNumeric.js.map
var _$interval_502 = {};
"use strict";
Object.defineProperty(_$interval_502, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$async_540 = require("../scheduler/async"); */;
/* removed: var _$isNumeric_559 = require("../util/isNumeric"); */;
function interval(period, scheduler) {
    if (period === void 0) { period = 0; }
    if (scheduler === void 0) { scheduler = _$async_540.async; }
    if (!_$isNumeric_559.isNumeric(period) || period < 0) {
        period = 0;
    }
    if (!scheduler || typeof scheduler.schedule !== 'function') {
        scheduler = _$async_540.async;
    }
    return new _$Observable_477.Observable(function (subscriber) {
        subscriber.add(scheduler.schedule(__dispatch_502, period, { subscriber: subscriber, counter: 0, period: period }));
        return subscriber;
    });
}
_$interval_502.interval = interval;
function __dispatch_502(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
}
//# sourceMappingURL=interval.js.map
var _$merge_503 = {};
"use strict";
Object.defineProperty(_$merge_503, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$isScheduler_563 = require("../util/isScheduler"); */;
/* removed: var _$mergeAll_519 = require("../operators/mergeAll"); */;
/* removed: var _$fromArray_497 = require("./fromArray"); */;
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (_$isScheduler_563.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof _$Observable_477.Observable) {
        return observables[0];
    }
    return _$mergeAll_519.mergeAll(concurrent)(_$fromArray_497.fromArray(observables, scheduler));
}
_$merge_503.merge = merge;
//# sourceMappingURL=merge.js.map
var _$onErrorResumeNext_506 = {};
"use strict";
Object.defineProperty(_$onErrorResumeNext_506, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$from_496 = require("./from"); */;
/* removed: var _$isArray_554 = require("../util/isArray"); */;
/* removed: var _$empty_494 = require("./empty"); */;
function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 0) {
        return _$empty_494.EMPTY;
    }
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && _$isArray_554.isArray(first)) {
        return onErrorResumeNext.apply(void 0, first);
    }
    return new _$Observable_477.Observable(function (subscriber) {
        var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
        return _$from_496.from(first).subscribe({
            next: function (value) { subscriber.next(value); },
            error: subNext,
            complete: subNext,
        });
    });
}
_$onErrorResumeNext_506.onErrorResumeNext = onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map
var _$pairs_507 = {};
"use strict";
Object.defineProperty(_$pairs_507, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$Subscription_485 = require("../Subscription"); */;
function pairs(obj, scheduler) {
    if (!scheduler) {
        return new _$Observable_477.Observable(function (subscriber) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
                var key = keys[i];
                if (obj.hasOwnProperty(key)) {
                    subscriber.next([key, obj[key]]);
                }
            }
            subscriber.complete();
        });
    }
    else {
        return new _$Observable_477.Observable(function (subscriber) {
            var keys = Object.keys(obj);
            var subscription = new _$Subscription_485.Subscription();
            subscription.add(scheduler.schedule(__dispatch_507, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
            return subscription;
        });
    }
}
_$pairs_507.pairs = pairs;
function __dispatch_507(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([key, obj[key]]);
            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
        }
        else {
            subscriber.complete();
        }
    }
}
_$pairs_507.dispatch = __dispatch_507;
//# sourceMappingURL=pairs.js.map
var _$not_565 = {};
"use strict";
Object.defineProperty(_$not_565, "__esModule", { value: true });
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
_$not_565.not = not;
//# sourceMappingURL=not.js.map
var _$filter_516 = {};
"use strict";
var ____extends_516 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$filter_516, "__esModule", { value: true });
/* removed: var _$Subscriber_484 = require("../Subscriber"); */;
function __filter_516(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
_$filter_516.filter = __filter_516;
var FilterOperator = (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
var FilterSubscriber = (function (_super) {
    ____extends_516(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(_$Subscriber_484.Subscriber));
//# sourceMappingURL=filter.js.map
var _$partition_508 = {};
"use strict";
Object.defineProperty(_$partition_508, "__esModule", { value: true });
/* removed: var _$not_565 = require("../util/not"); */;
/* removed: var _$subscribeTo_567 = require("../util/subscribeTo"); */;
/* removed: var _$filter_516 = require("../operators/filter"); */;
/* removed: var _$Observable_477 = require("../Observable"); */;
function partition(source, predicate, thisArg) {
    return [
        _$filter_516.filter(predicate, thisArg)(new _$Observable_477.Observable(_$subscribeTo_567.subscribeTo(source))),
        _$filter_516.filter(_$not_565.not(predicate, thisArg))(new _$Observable_477.Observable(_$subscribeTo_567.subscribeTo(source)))
    ];
}
_$partition_508.partition = partition;
//# sourceMappingURL=partition.js.map
var _$race_509 = {};
"use strict";
var ____extends_509 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$race_509, "__esModule", { value: true });
/* removed: var _$isArray_554 = require("../util/isArray"); */;
/* removed: var _$fromArray_497 = require("./fromArray"); */;
/* removed: var _$OuterSubscriber_479 = require("../OuterSubscriber"); */;
/* removed: var _$subscribeToResult_572 = require("../util/subscribeToResult"); */;
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    if (observables.length === 1) {
        if (_$isArray_554.isArray(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return _$fromArray_497.fromArray(observables, undefined).lift(new RaceOperator());
}
_$race_509.race = race;
var RaceOperator = (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());
_$race_509.RaceOperator = RaceOperator;
var RaceSubscriber = (function (_super) {
    ____extends_509(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = _$subscribeToResult_572.subscribeToResult(this, observable, undefined, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(_$OuterSubscriber_479.OuterSubscriber));
_$race_509.RaceSubscriber = RaceSubscriber;
//# sourceMappingURL=race.js.map
var _$range_510 = {};
"use strict";
Object.defineProperty(_$range_510, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
function range(start, count, scheduler) {
    if (start === void 0) { start = 0; }
    return new _$Observable_477.Observable(function (subscriber) {
        if (count === undefined) {
            count = start;
            start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) {
            return scheduler.schedule(__dispatch_510, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(current++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
        return undefined;
    });
}
_$range_510.range = range;
function __dispatch_510(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) {
        return;
    }
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}
_$range_510.dispatch = __dispatch_510;
//# sourceMappingURL=range.js.map
var _$timer_512 = {};
"use strict";
Object.defineProperty(_$timer_512, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$async_540 = require("../scheduler/async"); */;
/* removed: var _$isNumeric_559 = require("../util/isNumeric"); */;
/* removed: var _$isScheduler_563 = require("../util/isScheduler"); */;
function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) { dueTime = 0; }
    var period = -1;
    if (_$isNumeric_559.isNumeric(periodOrScheduler)) {
        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    }
    else if (_$isScheduler_563.isScheduler(periodOrScheduler)) {
        scheduler = periodOrScheduler;
    }
    if (!_$isScheduler_563.isScheduler(scheduler)) {
        scheduler = _$async_540.async;
    }
    return new _$Observable_477.Observable(function (subscriber) {
        var due = _$isNumeric_559.isNumeric(dueTime)
            ? dueTime
            : (+dueTime - scheduler.now());
        return scheduler.schedule(__dispatch_512, due, {
            index: 0, period: period, subscriber: subscriber
        });
    });
}
_$timer_512.timer = timer;
function __dispatch_512(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) {
        return;
    }
    else if (period === -1) {
        return subscriber.complete();
    }
    state.index = index + 1;
    this.schedule(state, period);
}
//# sourceMappingURL=timer.js.map
var _$using_513 = {};
"use strict";
Object.defineProperty(_$using_513, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$from_496 = require("./from"); */;
/* removed: var _$empty_494 = require("./empty"); */;
function using(resourceFactory, observableFactory) {
    return new _$Observable_477.Observable(function (subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? _$from_496.from(result) : _$empty_494.EMPTY;
        var subscription = source.subscribe(subscriber);
        return function () {
            subscription.unsubscribe();
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}
_$using_513.using = using;
//# sourceMappingURL=using.js.map
var _$zip_514 = {};
"use strict";
var ____extends_514 = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(_$zip_514, "__esModule", { value: true });
/* removed: var _$fromArray_497 = require("./fromArray"); */;
/* removed: var _$isArray_554 = require("../util/isArray"); */;
/* removed: var _$Subscriber_484 = require("../Subscriber"); */;
/* removed: var _$iterator_542 = require("../../internal/symbol/iterator"); */;
/* removed: var _$innerSubscribe_487 = require("../innerSubscribe"); */;
function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === 'function') {
        observables.pop();
    }
    return _$fromArray_497.fromArray(observables, undefined).lift(new ZipOperator(resultSelector));
}
_$zip_514.zip = zip;
var ZipOperator = (function () {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}());
_$zip_514.ZipOperator = ZipOperator;
var ZipSubscriber = (function (_super) {
    ____extends_514(ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        if (values === void 0) { values = Object.create(null); }
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : undefined;
        return _this;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (_$isArray_554.isArray(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[_$iterator_542.iterator] === 'function') {
            iterators.push(new StaticIterator(value[_$iterator_542.iterator]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe());
            }
            else {
                this.active--;
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) {
            this._tryresultSelector(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryresultSelector = function (args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(_$Subscriber_484.Subscriber));
_$zip_514.ZipSubscriber = ZipSubscriber;
var StaticIterator = (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return Boolean(nextResult && nextResult.done);
    };
    return StaticIterator;
}());
var StaticArrayIterator = (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[_$iterator_542.iterator] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
var ZipBufferIterator = (function (_super) {
    ____extends_514(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[_$iterator_542.iterator] = function () {
        return this;
    };
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (innerValue) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function () {
        return _$innerSubscribe_487.innerSubscribe(this.observable, new _$innerSubscribe_487.SimpleInnerSubscriber(this));
    };
    return ZipBufferIterator;
}(_$innerSubscribe_487.SimpleOuterSubscriber));
//# sourceMappingURL=zip.js.map
var _$never_504 = {};
"use strict";
Object.defineProperty(_$never_504, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("../Observable"); */;
/* removed: var _$noop_564 = require("../util/noop"); */;
_$never_504.NEVER = new _$Observable_477.Observable(_$noop_564.noop);
function never() {
    return _$never_504.NEVER;
}
_$never_504.never = never;
//# sourceMappingURL=never.js.map
var _$rxjs_rxjs = {};
"use strict";
Object.defineProperty(_$rxjs_rxjs, "__esModule", { value: true });
/* removed: var _$Observable_477 = require("./internal/Observable"); */;
_$rxjs_rxjs.Observable = _$Observable_477.Observable;
/* removed: var _$ConnectableObservable_488 = require("./internal/observable/ConnectableObservable"); */;
_$rxjs_rxjs.ConnectableObservable = _$ConnectableObservable_488.ConnectableObservable;
/* removed: var _$groupBy_517 = require("./internal/operators/groupBy"); */;
_$rxjs_rxjs.GroupedObservable = _$groupBy_517.GroupedObservable;
/* removed: var _$observable_543 = require("./internal/symbol/observable"); */;
_$rxjs_rxjs.observable = _$observable_543.observable;
/* removed: var _$Subject_482 = require("./internal/Subject"); */;
_$rxjs_rxjs.Subject = _$Subject_482.Subject;
/* removed: var _$BehaviorSubject_474 = require("./internal/BehaviorSubject"); */;
_$rxjs_rxjs.BehaviorSubject = _$BehaviorSubject_474.BehaviorSubject;
/* removed: var _$ReplaySubject_480 = require("./internal/ReplaySubject"); */;
_$rxjs_rxjs.ReplaySubject = _$ReplaySubject_480.ReplaySubject;
/* removed: var _$AsyncSubject_473 = require("./internal/AsyncSubject"); */;
_$rxjs_rxjs.AsyncSubject = _$AsyncSubject_473.AsyncSubject;
/* removed: var _$asap_539 = require("./internal/scheduler/asap"); */;
_$rxjs_rxjs.asap = _$asap_539.asap;
_$rxjs_rxjs.asapScheduler = _$asap_539.asapScheduler;
/* removed: var _$async_540 = require("./internal/scheduler/async"); */;
_$rxjs_rxjs.async = _$async_540.async;
_$rxjs_rxjs.asyncScheduler = _$async_540.asyncScheduler;
/* removed: var _$queue_541 = require("./internal/scheduler/queue"); */;
_$rxjs_rxjs.queue = _$queue_541.queue;
_$rxjs_rxjs.queueScheduler = _$queue_541.queueScheduler;
/* removed: var _$animationFrame_538 = require("./internal/scheduler/animationFrame"); */;
_$rxjs_rxjs.animationFrame = _$animationFrame_538.animationFrame;
_$rxjs_rxjs.animationFrameScheduler = _$animationFrame_538.animationFrameScheduler;
/* removed: var _$VirtualTimeScheduler_537 = require("./internal/scheduler/VirtualTimeScheduler"); */;
_$rxjs_rxjs.VirtualTimeScheduler = _$VirtualTimeScheduler_537.VirtualTimeScheduler;
_$rxjs_rxjs.VirtualAction = _$VirtualTimeScheduler_537.VirtualAction;
/* removed: var _$Scheduler_481 = require("./internal/Scheduler"); */;
_$rxjs_rxjs.Scheduler = _$Scheduler_481.Scheduler;
/* removed: var _$Subscription_485 = require("./internal/Subscription"); */;
_$rxjs_rxjs.Subscription = _$Subscription_485.Subscription;
/* removed: var _$Subscriber_484 = require("./internal/Subscriber"); */;
_$rxjs_rxjs.Subscriber = _$Subscriber_484.Subscriber;
/* removed: var _$Notification_476 = require("./internal/Notification"); */;
_$rxjs_rxjs.Notification = _$Notification_476.Notification;
_$rxjs_rxjs.NotificationKind = _$Notification_476.NotificationKind;
/* removed: var _$pipe_566 = require("./internal/util/pipe"); */;
_$rxjs_rxjs.pipe = _$pipe_566.pipe;
/* removed: var _$noop_564 = require("./internal/util/noop"); */;
_$rxjs_rxjs.noop = _$noop_564.noop;
/* removed: var _$identity_553 = require("./internal/util/identity"); */;
_$rxjs_rxjs.identity = _$identity_553.identity;
/* removed: var _$isObservable_561 = require("./internal/util/isObservable"); */;
_$rxjs_rxjs.isObservable = _$isObservable_561.isObservable;
/* removed: var _$ArgumentOutOfRangeError_545 = require("./internal/util/ArgumentOutOfRangeError"); */;
_$rxjs_rxjs.ArgumentOutOfRangeError = _$ArgumentOutOfRangeError_545.ArgumentOutOfRangeError;
/* removed: var _$EmptyError_546 = require("./internal/util/EmptyError"); */;
_$rxjs_rxjs.EmptyError = _$EmptyError_546.EmptyError;
/* removed: var _$ObjectUnsubscribedError_548 = require("./internal/util/ObjectUnsubscribedError"); */;
_$rxjs_rxjs.ObjectUnsubscribedError = _$ObjectUnsubscribedError_548.ObjectUnsubscribedError;
/* removed: var _$UnsubscriptionError_550 = require("./internal/util/UnsubscriptionError"); */;
_$rxjs_rxjs.UnsubscriptionError = _$UnsubscriptionError_550.UnsubscriptionError;
/* removed: var _$TimeoutError_549 = require("./internal/util/TimeoutError"); */;
_$rxjs_rxjs.TimeoutError = _$TimeoutError_549.TimeoutError;
/* removed: var _$bindCallback_489 = require("./internal/observable/bindCallback"); */;
_$rxjs_rxjs.bindCallback = _$bindCallback_489.bindCallback;
/* removed: var _$bindNodeCallback_490 = require("./internal/observable/bindNodeCallback"); */;
_$rxjs_rxjs.bindNodeCallback = _$bindNodeCallback_490.bindNodeCallback;
/* removed: var _$combineLatest_491 = require("./internal/observable/combineLatest"); */;
_$rxjs_rxjs.combineLatest = _$combineLatest_491.combineLatest;
/* removed: var _$concat_492 = require("./internal/observable/concat"); */;
_$rxjs_rxjs.concat = _$concat_492.concat;
/* removed: var _$defer_493 = require("./internal/observable/defer"); */;
_$rxjs_rxjs.defer = _$defer_493.defer;
/* removed: var _$empty_494 = require("./internal/observable/empty"); */;
_$rxjs_rxjs.empty = _$empty_494.empty;
/* removed: var _$forkJoin_495 = require("./internal/observable/forkJoin"); */;
_$rxjs_rxjs.forkJoin = _$forkJoin_495.forkJoin;
/* removed: var _$from_496 = require("./internal/observable/from"); */;
_$rxjs_rxjs.from = _$from_496.from;
/* removed: var _$fromEvent_498 = require("./internal/observable/fromEvent"); */;
_$rxjs_rxjs.fromEvent = _$fromEvent_498.fromEvent;
/* removed: var _$fromEventPattern_499 = require("./internal/observable/fromEventPattern"); */;
_$rxjs_rxjs.fromEventPattern = _$fromEventPattern_499.fromEventPattern;
/* removed: var _$generate_500 = require("./internal/observable/generate"); */;
_$rxjs_rxjs.generate = _$generate_500.generate;
/* removed: var _$iif_501 = require("./internal/observable/iif"); */;
_$rxjs_rxjs.iif = _$iif_501.iif;
/* removed: var _$interval_502 = require("./internal/observable/interval"); */;
_$rxjs_rxjs.interval = _$interval_502.interval;
/* removed: var _$merge_503 = require("./internal/observable/merge"); */;
_$rxjs_rxjs.merge = _$merge_503.merge;
/* removed: var _$never_504 = require("./internal/observable/never"); */;
_$rxjs_rxjs.never = _$never_504.never;
/* removed: var _$of_505 = require("./internal/observable/of"); */;
_$rxjs_rxjs.of = _$of_505.of;
/* removed: var _$onErrorResumeNext_506 = require("./internal/observable/onErrorResumeNext"); */;
_$rxjs_rxjs.onErrorResumeNext = _$onErrorResumeNext_506.onErrorResumeNext;
/* removed: var _$pairs_507 = require("./internal/observable/pairs"); */;
_$rxjs_rxjs.pairs = _$pairs_507.pairs;
/* removed: var _$partition_508 = require("./internal/observable/partition"); */;
_$rxjs_rxjs.partition = _$partition_508.partition;
/* removed: var _$race_509 = require("./internal/observable/race"); */;
_$rxjs_rxjs.race = _$race_509.race;
/* removed: var _$range_510 = require("./internal/observable/range"); */;
_$rxjs_rxjs.range = _$range_510.range;
/* removed: var _$throwError_511 = require("./internal/observable/throwError"); */;
_$rxjs_rxjs.throwError = _$throwError_511.throwError;
/* removed: var _$timer_512 = require("./internal/observable/timer"); */;
_$rxjs_rxjs.timer = _$timer_512.timer;
/* removed: var _$using_513 = require("./internal/observable/using"); */;
_$rxjs_rxjs.using = _$using_513.using;
/* removed: var _$zip_514 = require("./internal/observable/zip"); */;
_$rxjs_rxjs.zip = _$zip_514.zip;
/* removed: var _$scheduled_527 = require("./internal/scheduled/scheduled"); */;
_$rxjs_rxjs.scheduled = _$scheduled_527.scheduled;
/* removed: var _$empty_494 = require("./internal/observable/empty"); */;
_$rxjs_rxjs.EMPTY = _$empty_494.EMPTY;
/* removed: var _$never_504 = require("./internal/observable/never"); */;
_$rxjs_rxjs.NEVER = _$never_504.NEVER;
/* removed: var _$config_486 = require("./internal/config"); */;
_$rxjs_rxjs.config = _$config_486.config;
//# sourceMappingURL=index.js.map
var _$urlSearchParamsPolyfill_urlSearchParamsPolyfill = {};
(function (global){(function (){
/**!
 * url-search-params-polyfill
 *
 * @author Jerry Bendy (https://github.com/jerrybendy)
 * @licence MIT
 */
(function(self) {
    'use strict';

    var nativeURLSearchParams = (function() {
            // #41 Fix issue in RN
            try {
                if (self.URLSearchParams && (new self.URLSearchParams('foo=bar')).get('foo') === 'bar') {
                    return self.URLSearchParams;
                }
            } catch (e) {}
            return null;
        })(),
        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
        isSupportSize = nativeURLSearchParams && 'size' in nativeURLSearchParams.prototype,
        __URLSearchParams__ = "__URLSearchParams__",
        // Fix bug in Edge which cannot encode ' &' correctly
        encodesAmpersandsCorrectly = nativeURLSearchParams ? (function() {
            var ampersandTest = new nativeURLSearchParams();
            ampersandTest.append('s', ' &');
            return ampersandTest.toString() === 's=+%26';
        })() : true,
        prototype = URLSearchParamsPolyfill.prototype,
        iterable = !!(self.Symbol && self.Symbol.iterator);

    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly && isSupportSize) {
        return;
    }


    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
    function URLSearchParamsPolyfill(search) {
        search = search || "";

        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
            search = search.toString();
        }
        this [__URLSearchParams__] = parseToDict(search);
    }


    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.append = function(name, value) {
        appendTo(this [__URLSearchParams__], name, value);
    };

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
    prototype['delete'] = function(name) {
        delete this [__URLSearchParams__] [name];
    };

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
    prototype.get = function(name) {
        var dict = this [__URLSearchParams__];
        return this.has(name) ? dict[name][0] : null;
    };

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
    prototype.getAll = function(name) {
        var dict = this [__URLSearchParams__];
        return this.has(name) ? dict [name].slice(0) : [];
    };

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    prototype.has = function(name) {
        return hasOwnProperty(this [__URLSearchParams__], name);
    };

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.set = function set(name, value) {
        this [__URLSearchParams__][name] = ['' + value];
    };

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
    prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for (key in dict) {
            name = encode(key);
            for (i = 0, value = dict[key]; i < value.length; i++) {
                query.push(name + '=' + encode(value[i]));
            }
        }
        return query.join('&');
    };

    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var useProxy = self.Proxy && nativeURLSearchParams && (!decodesPlusesCorrectly || !encodesAmpersandsCorrectly || !isSupportObjectConstructor || !isSupportSize);
    var propValue;
    if (useProxy) {
        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        propValue = new Proxy(nativeURLSearchParams, {
            construct: function (target, args) {
                return new target((new URLSearchParamsPolyfill(args[0]).toString()));
            }
        })
        // Chrome <=60 .toString() on a function proxy got error "Function.prototype.toString is not generic"
        propValue.toString = Function.prototype.toString.bind(URLSearchParamsPolyfill);
    } else {
        propValue = URLSearchParamsPolyfill;
    }

    /*
     * Apply polyfill to global object and append other prototype into it
     */
    Object.defineProperty(self, 'URLSearchParams', {
        value: propValue
    });

    var USPProto = self.URLSearchParams.prototype;

    USPProto.polyfill = true;

    // Fix #54, `toString.call(new URLSearchParams)` will return correct value when Proxy not used
    if (!useProxy && self.Symbol) {
        USPProto[self.Symbol.toStringTag] = 'URLSearchParams';
    }

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };

    /**
     * Sort all name-value pairs
     */
    USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for (k in dict) {
            keys.push(k);
        }
        keys.sort();

        for (i = 0; i < keys.length; i++) {
            this['delete'](keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            var key = keys[i], values = dict[key];
            for (j = 0; j < values.length; j++) {
                this.append(key, values[j]);
            }
        }
    };

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name, item]);
        });
        return makeIterator(items);
    };


    if (iterable) {
        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    }

    if (!USPProto.size) {
        Object.defineProperty(USPProto, 'size', {
            get: function () {
                var dict = parseToDict(this.toString())
                if (USPProto === this) {
                    throw new TypeError('Illegal invocation at URLSearchParams.invokeGetter')
                }
                return Object.keys(dict).reduce(function (prev, cur) {
                    return prev + dict[cur].length;
                }, 0);
            }
        });
    }

    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }

    function decode(str) {
        return str
            .replace(/[ +]/g, '%20')
            .replace(/(%[a-f0-9]{2})+/ig, function(match) {
                return decodeURIComponent(match);
            });
    }

    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {done: value === undefined, value: value};
            }
        };

        if (iterable) {
            iterator[self.Symbol.iterator] = function() {
                return iterator;
            };
        }

        return iterator;
    }

    function parseToDict(search) {
        var dict = {};

        if (typeof search === "object") {
            // if `search` is an array, treat it as a sequence
            if (isArray(search)) {
                for (var i = 0; i < search.length; i++) {
                    var item = search[i];
                    if (isArray(item) && item.length === 2) {
                        appendTo(dict, item[0], item[1]);
                    } else {
                        throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
                    }
                }

            } else {
                for (var key in search) {
                    if (search.hasOwnProperty(key)) {
                        appendTo(dict, key, search[key]);
                    }
                }
            }

        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) {
                search = search.slice(1);
            }

            var pairs = search.split("&");
            for (var j = 0; j < pairs.length; j++) {
                var value = pairs [j],
                    index = value.indexOf('=');

                if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

                } else {
                    if (value) {
                        appendTo(dict, decode(value), '');
                    }
                }
            }
        }

        return dict;
    }

    function appendTo(dict, name, value) {
        var val = typeof value === 'string' ? value : (
            value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
        );

        // #47 Prevent using `hasOwnProperty` as a property name
        if (hasOwnProperty(dict, name)) {
            dict[name].push(val);
        } else {
            dict[name] = [val];
        }
    }

    function isArray(val) {
        return !!val && '[object Array]' === Object.prototype.toString.call(val);
    }

    function hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }

})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
var _$whatwgFetch_whatwgFetch = { exports: {} };
(function (global){(function (){
(function (global, factory) {
  typeof _$whatwgFetch_whatwgFetch.exports === 'object' && "object" !== 'undefined' ? factory(_$whatwgFetch_whatwgFetch.exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.WHATWGFetch = {})));
}(this, (function (exports) { 'use strict';

  /* eslint-disable no-prototype-builtins */
  var g =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    // eslint-disable-next-line no-undef
    (typeof global !== 'undefined' && global) ||
    {};

  var support = {
    searchParams: 'URLSearchParams' in g,
    iterable: 'Symbol' in g && 'iterator' in Symbol,
    blob:
      'FileReader' in g &&
      'Blob' in g &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in g,
    arrayBuffer: 'ArrayBuffer' in g
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        if (header.length != 2) {
          throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
        }
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body._noBody) return
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      // eslint-disable-next-line no-self-assign
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._noBody = true;
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this);
        if (isConsumed) {
          return isConsumed
        } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          )
        } else {
          return Promise.resolve(this._bodyArrayBuffer)
        }
      } else if (support.blob) {
        return this.blob().then(readBlobAsArrayBuffer)
      } else {
        throw new Error('could not read as ArrayBuffer')
      }
    };

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || (function () {
      if ('AbortController' in g) {
        var ctrl = new AbortController();
        return ctrl.signal;
      }
    }());
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          try {
            headers.append(key, value);
          } catch (error) {
            console.warn('Response ' + error.message);
          }
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) {
      throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
    }
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 200, statusText: ''});
    response.status = 0;
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = g.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && g.location.href ? g.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
        var names = [];
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          names.push(normalizeName(name));
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
        request.headers.forEach(function(value, name) {
          if (names.indexOf(name) === -1) {
            xhr.setRequestHeader(name, value);
          }
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!g.fetch) {
    g.fetch = fetch;
    g.Headers = Headers;
    g.Request = Request;
    g.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
_$whatwgFetch_whatwgFetch = _$whatwgFetch_whatwgFetch.exports
var _$applicationinsightsWeb_MicrosoftApplicationinsightsWeb = { exports: {} };
(function (global){(function (){
/*!
 * Application Insights JavaScript SDK - Web, 2.8.14
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
(function (global, factory) {
    typeof _$applicationinsightsWeb_MicrosoftApplicationinsightsWeb.exports === 'object' && "object" !== 'undefined' ? factory(_$applicationinsightsWeb_MicrosoftApplicationinsightsWeb.exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.Microsoft = global.Microsoft || {}, global.Microsoft.ApplicationInsights = global.Microsoft.ApplicationInsights || {})));
})(this, (function (exports) { 'use strict';

    /*!
     * Microsoft Dynamic Proto Utility, 1.1.9
     * Copyright (c) Microsoft and contributors. All rights reserved.
     */
    var _a$3;
    var UNDEFINED = "undefined";
    var Constructor = 'constructor';
    var Prototype = 'prototype';
    var strFunction = 'function';
    var DynInstFuncTable = '_dynInstFuncs';
    var DynProxyTag = '_isDynProxy';
    var DynClassName = '_dynClass';
    var DynClassNamePrefix = '_dynCls$';
    var DynInstChkTag = '_dynInstChk';
    var DynAllowInstChkTag = DynInstChkTag;
    var DynProtoDefaultOptions = '_dfOpts';
    var UnknownValue = '_unknown_';
    var str__Proto$1 = "__proto__";
    var DynProtoBaseProto = "_dyn" + str__Proto$1;
    var DynProtoGlobalSettings = "__dynProto$Gbl";
    var DynProtoCurrent = "_dynInstProto";
    var strUseBaseInst = 'useBaseInst';
    var strSetInstFuncs = 'setInstFuncs';
    var Obj = Object;
    var _objGetPrototypeOf$1 = Obj["getPrototypeOf"];
    var _objGetOwnProps = Obj["getOwnPropertyNames"];
    function _getGlobal() {
        var result;
        if (typeof globalThis !== UNDEFINED) {
            result = globalThis;
        }
        if (!result && typeof self !== UNDEFINED) {
            result = self;
        }
        if (!result && typeof window !== UNDEFINED) {
            result = window;
        }
        if (!result && typeof global !== UNDEFINED) {
            result = global;
        }
        return result || {};
    }
    var _gbl = _getGlobal();
    var _gblInst = _gbl[DynProtoGlobalSettings] || (_gbl[DynProtoGlobalSettings] = {
        o: (_a$3 = {},
            _a$3[strSetInstFuncs] = true,
            _a$3[strUseBaseInst] = true,
            _a$3),
        n: 1000
    });
    function _hasOwnProperty(obj, prop) {
        return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
    }
    function _isObjectOrArrayPrototype(target) {
        return target && (target === Obj[Prototype] || target === Array[Prototype]);
    }
    function _isObjectArrayOrFunctionPrototype(target) {
        return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
    }
    function _getObjProto$1(target) {
        var newProto;
        if (target) {
            if (_objGetPrototypeOf$1) {
                return _objGetPrototypeOf$1(target);
            }
            var curProto = target[str__Proto$1] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
            newProto = target[DynProtoBaseProto] || curProto;
            if (!_hasOwnProperty(target, DynProtoBaseProto)) {
                delete target[DynProtoCurrent];
                newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
                target[DynProtoCurrent] = curProto;
            }
        }
        return newProto;
    }
    function _forEachProp(target, func) {
        var props = [];
        if (_objGetOwnProps) {
            props = _objGetOwnProps(target);
        }
        else {
            for (var name_1 in target) {
                if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
                    props.push(name_1);
                }
            }
        }
        if (props && props.length > 0) {
            for (var lp = 0; lp < props.length; lp++) {
                func(props[lp]);
            }
        }
    }
    function _isDynamicCandidate(target, funcName, skipOwn) {
        return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || _hasOwnProperty(target, funcName)));
    }
    function _throwTypeError(message) {
        throw new TypeError("DynamicProto: " + message);
    }
    function _getInstanceFuncs(thisTarget) {
        var instFuncs = {};
        _forEachProp(thisTarget, function (name) {
            if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
                instFuncs[name] = thisTarget[name];
            }
        });
        return instFuncs;
    }
    function _hasVisited(values, value) {
        for (var lp = values.length - 1; lp >= 0; lp--) {
            if (values[lp] === value) {
                return true;
            }
        }
        return false;
    }
    function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
        function _instFuncProxy(target, funcHost, funcName) {
            var theFunc = funcHost[funcName];
            if (theFunc[DynProxyTag] && useBaseInst) {
                var instFuncTable = target[DynInstFuncTable] || {};
                if (instFuncTable[DynAllowInstChkTag] !== false) {
                    theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
                }
            }
            return function () {
                return theFunc.apply(target, arguments);
            };
        }
        var baseFuncs = {};
        _forEachProp(instFuncs, function (name) {
            baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
        });
        var baseProto = _getObjProto$1(classProto);
        var visited = [];
        while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
            _forEachProp(baseProto, function (name) {
                if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf$1)) {
                    baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
                }
            });
            visited.push(baseProto);
            baseProto = _getObjProto$1(baseProto);
        }
        return baseFuncs;
    }
    function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
        var instFunc = null;
        if (target && _hasOwnProperty(proto, DynClassName)) {
            var instFuncTable = target[DynInstFuncTable] || {};
            instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
            if (!instFunc) {
                _throwTypeError("Missing [" + funcName + "] " + strFunction);
            }
            if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
                var canAddInst = !_hasOwnProperty(target, funcName);
                var objProto = _getObjProto$1(target);
                var visited = [];
                while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
                    var protoFunc = objProto[funcName];
                    if (protoFunc) {
                        canAddInst = (protoFunc === currentDynProtoProxy);
                        break;
                    }
                    visited.push(objProto);
                    objProto = _getObjProto$1(objProto);
                }
                try {
                    if (canAddInst) {
                        target[funcName] = instFunc;
                    }
                    instFunc[DynInstChkTag] = 1;
                }
                catch (e) {
                    instFuncTable[DynAllowInstChkTag] = false;
                }
            }
        }
        return instFunc;
    }
    function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
        var protoFunc = proto[funcName];
        if (protoFunc === currentDynProtoProxy) {
            protoFunc = _getObjProto$1(proto)[funcName];
        }
        if (typeof protoFunc !== strFunction) {
            _throwTypeError("[" + funcName + "] is not a " + strFunction);
        }
        return protoFunc;
    }
    function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
        function _createDynamicPrototype(proto, funcName) {
            var dynProtoProxy = function () {
                var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
                return instFunc.apply(this, arguments);
            };
            dynProtoProxy[DynProxyTag] = 1;
            return dynProtoProxy;
        }
        if (!_isObjectOrArrayPrototype(proto)) {
            var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
            var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || {});
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
            }
            _forEachProp(target, function (name) {
                if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                    instFuncs_1[name] = target[name];
                    delete target[name];
                    if (!_hasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
                        proto[name] = _createDynamicPrototype(proto, name);
                    }
                }
            });
        }
    }
    function _checkPrototype(classProto, thisTarget) {
        if (_objGetPrototypeOf$1) {
            var visited = [];
            var thisProto = _getObjProto$1(thisTarget);
            while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
                if (thisProto === classProto) {
                    return true;
                }
                visited.push(thisProto);
                thisProto = _getObjProto$1(thisProto);
            }
            return false;
        }
        return true;
    }
    function _getObjName(target, unknownValue) {
        if (_hasOwnProperty(target, Prototype)) {
            return target.name || unknownValue || UnknownValue;
        }
        return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
    }
    function dynamicProto(theClass, target, delegateFunc, options) {
        if (!_hasOwnProperty(theClass, Prototype)) {
            _throwTypeError("theClass is an invalid class definition.");
        }
        var classProto = theClass[Prototype];
        if (!_checkPrototype(classProto, target)) {
            _throwTypeError("[" + _getObjName(theClass) + "] not in hierarchy of [" + _getObjName(target) + "]");
        }
        var className = null;
        if (_hasOwnProperty(classProto, DynClassName)) {
            className = classProto[DynClassName];
        }
        else {
            className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _gblInst.n;
            _gblInst.n++;
            classProto[DynClassName] = className;
        }
        var perfOptions = dynamicProto[DynProtoDefaultOptions];
        var useBaseInst = !!perfOptions[strUseBaseInst];
        if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
            useBaseInst = !!options[strUseBaseInst];
        }
        var instFuncs = _getInstanceFuncs(target);
        var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
        delegateFunc(target, baseFuncs);
        var setInstanceFunc = !!_objGetPrototypeOf$1 && !!perfOptions[strSetInstFuncs];
        if (setInstanceFunc && options) {
            setInstanceFunc = !!options[strSetInstFuncs];
        }
        _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
    }
    dynamicProto[DynProtoDefaultOptions] = _gblInst.o;

    var strShimFunction = "function";
    var strShimObject = "object";
    var strShimUndefined = "undefined";
    var strShimPrototype = "prototype";
    var strShimHasOwnProperty = "hasOwnProperty";
    var ObjClass = Object;
    var ObjProto = ObjClass[strShimPrototype];
    var ObjAssign = ObjClass["assign"];
    var ObjCreate = ObjClass["create"];
    var ObjDefineProperty = ObjClass["defineProperty"];
    var ObjHasOwnProperty = ObjProto[strShimHasOwnProperty];

    var _cachedGlobal = null;
    function getGlobal(useCached) {
        if (useCached === void 0) { useCached = true; }
        var result = useCached === false ? null : _cachedGlobal;
        if (!result) {
            if (typeof globalThis !== strShimUndefined) {
                result = globalThis;
            }
            if (!result && typeof self !== strShimUndefined) {
                result = self;
            }
            if (!result && typeof window !== strShimUndefined) {
                result = window;
            }
            if (!result && typeof global !== strShimUndefined) {
                result = global;
            }
            _cachedGlobal = result;
        }
        return result;
    }
    function throwTypeError(message) {
        throw new TypeError(message);
    }
    function objCreateFn(obj) {
        var func = ObjCreate;
        if (func) {
            return func(obj);
        }
        if (obj == null) {
            return {};
        }
        var type = typeof obj;
        if (type !== strShimObject && type !== strShimFunction) {
            throwTypeError("Object prototype may only be an Object:" + obj);
        }
        function tmpFunc() { }
        tmpFunc[strShimPrototype] = obj;
        return new tmpFunc();
    }

    (getGlobal() || {})["Symbol"];
    (getGlobal() || {})["Reflect"];
    var __objAssignFnImpl = function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (ObjProto[strShimHasOwnProperty].call(s, p)) {
                    t[p] = s[p];
                }
            }
        }
        return t;
    };
    var __assignFn = ObjAssign || __objAssignFnImpl;
    var extendStaticsFn = function (d, b) {
        extendStaticsFn = ObjClass["setPrototypeOf"] ||
            ({ __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            }) ||
            function (d, b) {
                for (var p in b) {
                    if (b[strShimHasOwnProperty](p)) {
                        d[p] = b[p];
                    }
                }
            };
        return extendStaticsFn(d, b);
    };
    function __extendsFn(d, b) {
        if (typeof b !== strShimFunction && b !== null) {
            throwTypeError("Class extends value " + String(b) + " is not a constructor or null");
        }
        extendStaticsFn(d, b);
        function __() {
            this.constructor = d;
        }
        d[strShimPrototype] = b === null ? objCreateFn(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
    }
    function __spreadArrayFn(to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
            to[j] = from[i];
        }
        return to;
    }

    var _DYN_INITIALIZE = "initialize";
    var _DYN_NAME$3 = "name";
    var _DYN_GET_NOTIFY_MGR = "getNotifyMgr";
    var _DYN_IDENTIFIER = "identifier";
    var _DYN_PUSH$2 = "push";
    var _DYN_IS_INITIALIZED = "isInitialized";
    var _DYN_CONFIG$2 = "config";
    var _DYN_INSTRUMENTATION_KEY$2 = "instrumentationKey";
    var _DYN_LOGGER = "logger";
    var _DYN_LENGTH$5 = "length";
    var _DYN_TIME = "time";
    var _DYN_PROCESS_NEXT = "processNext";
    var _DYN_GET_PROCESS_TEL_CONT0 = "getProcessTelContext";
    var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener";
    var _DYN_REMOVE_NOTIFICATION_2 = "removeNotificationListener";
    var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs";
    var _DYN_ON_COMPLETE = "onComplete";
    var _DYN_GET_PLUGIN = "getPlugin";
    var _DYN_FLUSH = "flush";
    var _DYN__EXTENSIONS = "_extensions";
    var _DYN_SPLICE = "splice";
    var _DYN_TEARDOWN = "teardown";
    var _DYN_MESSAGE_ID = "messageId";
    var _DYN_MESSAGE$2 = "message";
    var _DYN_IS_ASYNC = "isAsync";
    var _DYN__DO_TEARDOWN = "_doTeardown";
    var _DYN_UPDATE$1 = "update";
    var _DYN_GET_NEXT = "getNext";
    var _DYN_DIAG_LOG$2 = "diagLog";
    var _DYN_SET_NEXT_PLUGIN = "setNextPlugin";
    var _DYN_CREATE_NEW = "createNew";
    var _DYN_COOKIE_CFG = "cookieCfg";
    var _DYN_INDEX_OF$2 = "indexOf";
    var _DYN_SUBSTRING$1 = "substring";
    var _DYN_USER_AGENT = "userAgent";
    var _DYN_SPLIT$1 = "split";
    var _DYN_SET_ENABLED = "setEnabled";
    var _DYN_SUBSTR = "substr";
    var _DYN_NODE_TYPE = "nodeType";
    var _DYN_APPLY = "apply";
    var _DYN_REPLACE = "replace";
    var _DYN_ENABLE_DEBUG_EXCEPTI4 = "enableDebugExceptions";
    var _DYN_LOG_INTERNAL_MESSAGE = "logInternalMessage";
    var _DYN_TO_LOWER_CASE$2 = "toLowerCase";
    var _DYN_CALL = "call";
    var _DYN_TYPE = "type";
    var _DYN_HANDLER = "handler";
    var _DYN_LISTENERS = "listeners";
    var _DYN_IS_CHILD_EVT = "isChildEvt";
    var _DYN_GET_CTX = "getCtx";
    var _DYN_SET_CTX = "setCtx";
    var _DYN_COMPLETE = "complete";
    var _DYN_TRACE_ID$2 = "traceId";
    var _DYN_SPAN_ID$1 = "spanId";
    var _DYN_TRACE_FLAGS$1 = "traceFlags";
    var _DYN_VERSION$1 = "version";

    var STR_EMPTY = "";
    var STR_CHANNELS = "channels";
    var STR_CORE = "core";
    var STR_CREATE_PERF_MGR = "createPerfMgr";
    var STR_DISABLED = "disabled";
    var STR_EXTENSION_CONFIG = "extensionConfig";
    var STR_EXTENSIONS = "extensions";
    var STR_PROCESS_TELEMETRY = "processTelemetry";
    var STR_PRIORITY = "priority";
    var STR_EVENTS_SENT = "eventsSent";
    var STR_EVENTS_DISCARDED = "eventsDiscarded";
    var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
    var STR_PERF_EVENT = "perfEvent";
    var STR_ERROR_TO_CONSOLE = "errorToConsole";
    var STR_WARN_TO_CONSOLE = "warnToConsole";
    var STR_GET_PERF_MGR = "getPerfMgr";

    var strToISOString = "toISOString";
    var cStrEndsWith = "endsWith";
    var strIndexOf = "indexOf";
    var strMap = "map";
    var strReduce = "reduce";
    var cStrTrim = "trim";
    var strToString = "toString";
    var str__Proto = "__proto__";
    var strConstructor = "constructor";
    var _objDefineProperty$1 = ObjDefineProperty;
    var _objFreeze = ObjClass.freeze;
    var _objKeys = ObjClass.keys;
    var StringProto = String[strShimPrototype];
    var _strTrim = StringProto[cStrTrim];
    var _strEndsWith = StringProto[cStrEndsWith];
    var DateProto = Date[strShimPrototype];
    var _dataToISOString = DateProto[strToISOString];
    var _isArray = Array.isArray;
    var _objToString = ObjProto[strToString];
    var _fnToString = ObjHasOwnProperty[strToString];
    var _objFunctionString = _fnToString[_DYN_CALL ](ObjClass);
    var rCamelCase = /-([a-z])/g;
    var rNormalizeInvalid = /([^\w\d_$])/g;
    var rLeadingNumeric = /^(\d+[\w\d_$])/;
    var _objGetPrototypeOf = Object["getPrototypeOf"];
    function _getObjProto(target) {
        if (target) {
            if (_objGetPrototypeOf) {
                return _objGetPrototypeOf(target);
            }
            var newProto = target[str__Proto] || target[strShimPrototype] || target[strConstructor];
            if (newProto) {
                return newProto;
            }
        }
        return null;
    }
    function isTypeof(value, theType) {
        return typeof value === theType;
    }
    function isUndefined(value) {
        return value === undefined || typeof value === strShimUndefined;
    }
    function isNullOrUndefined(value) {
        return (value === null || isUndefined(value));
    }
    function isNotNullOrUndefined(value) {
        return !isNullOrUndefined(value);
    }
    function hasOwnProperty(obj, prop) {
        return !!(obj && ObjHasOwnProperty[_DYN_CALL ](obj, prop));
    }
    function isObject(value) {
        return !!(value && typeof value === strShimObject);
    }
    function isFunction(value) {
        return !!(value && typeof value === strShimFunction);
    }
    function normalizeJsName(name) {
        var value = name;
        if (value && isString(value)) {
            value = value[_DYN_REPLACE ](rCamelCase, function (_all, letter) {
                return letter.toUpperCase();
            });
            value = value[_DYN_REPLACE ](rNormalizeInvalid, "_");
            value = value[_DYN_REPLACE ](rLeadingNumeric, function (_all, match) {
                return "_" + match;
            });
        }
        return value;
    }
    function objForEachKey(target, callbackfn) {
        if (target) {
            for (var prop in target) {
                if (ObjHasOwnProperty[_DYN_CALL ](target, prop)) {
                    callbackfn[_DYN_CALL ](target, prop, target[prop]);
                }
            }
        }
    }
    function strEndsWith(value, search) {
        var result = false;
        if (value && search && !(result = value === search)) {
            result = _strEndsWith ? value[cStrEndsWith](search) : _strEndsWithPoly(value, search);
        }
        return result;
    }
    function _strEndsWithPoly(value, search) {
        var result = false;
        var searchLen = search ? search[_DYN_LENGTH$5 ] : 0;
        var valLen = value ? value[_DYN_LENGTH$5 ] : 0;
        if (searchLen && valLen && valLen >= searchLen && !(result = value === search)) {
            var pos = valLen - 1;
            for (var lp = searchLen - 1; lp >= 0; lp--) {
                if (value[pos] != search[lp]) {
                    return false;
                }
                pos--;
            }
            result = true;
        }
        return result;
    }
    function strContains(value, search) {
        if (value && search) {
            return value[_DYN_INDEX_OF$2 ](search) !== -1;
        }
        return false;
    }
    function isDate(obj) {
        return !!(obj && _objToString[_DYN_CALL ](obj) === "[object Date]");
    }
    var isArray = _isArray || _isArrayPoly;
    function _isArrayPoly(obj) {
        return !!(obj && _objToString[_DYN_CALL ](obj) === "[object Array]");
    }
    function isError(obj) {
        return !!(obj && _objToString[_DYN_CALL ](obj) === "[object Error]");
    }
    function isString(value) {
        return typeof value === "string";
    }
    function isNumber(value) {
        return typeof value === "number";
    }
    function isBoolean(value) {
        return typeof value === "boolean";
    }
    function isPlainObject(value) {
        var result = false;
        if (value && typeof value === "object") {
            var proto = _objGetPrototypeOf ? _objGetPrototypeOf(value) : _getObjProto(value);
            if (!proto) {
                result = true;
            }
            else {
                if (proto[strConstructor] && ObjHasOwnProperty[_DYN_CALL ](proto, strConstructor)) {
                    proto = proto[strConstructor];
                }
                result = typeof proto === strShimFunction && _fnToString[_DYN_CALL ](proto) === _objFunctionString;
            }
        }
        return result;
    }
    function toISOString(date) {
        if (date) {
            return _dataToISOString ? date[strToISOString]() : _toISOStringPoly(date);
        }
    }
    function _toISOStringPoly(date) {
        if (date && date.getUTCFullYear) {
            var pad = function (num) {
                var r = String(num);
                if (r[_DYN_LENGTH$5 ] === 1) {
                    r = "0" + r;
                }
                return r;
            };
            return date.getUTCFullYear()
                + "-" + pad(date.getUTCMonth() + 1)
                + "-" + pad(date.getUTCDate())
                + "T" + pad(date.getUTCHours())
                + ":" + pad(date.getUTCMinutes())
                + ":" + pad(date.getUTCSeconds())
                + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
                + "Z";
        }
    }
    function arrForEach(arr, callbackfn, thisArg) {
        var len = arr[_DYN_LENGTH$5 ];
        try {
            for (var idx = 0; idx < len; idx++) {
                if (idx in arr) {
                    if (callbackfn[_DYN_CALL ](thisArg || arr, arr[idx], idx, arr) === -1) {
                        break;
                    }
                }
            }
        }
        catch (e) {
        }
    }
    function arrIndexOf(arr, searchElement, fromIndex) {
        if (arr) {
            if (arr[strIndexOf]) {
                return arr[strIndexOf](searchElement, fromIndex);
            }
            var len = arr[_DYN_LENGTH$5 ];
            var from = fromIndex || 0;
            try {
                for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
                    if (lp in arr && arr[lp] === searchElement) {
                        return lp;
                    }
                }
            }
            catch (e) {
            }
        }
        return -1;
    }
    function arrMap(arr, callbackfn, thisArg) {
        var results;
        if (arr) {
            if (arr[strMap]) {
                return arr[strMap](callbackfn, thisArg);
            }
            var len = arr[_DYN_LENGTH$5 ];
            var _this = thisArg || arr;
            results = new Array(len);
            try {
                for (var lp = 0; lp < len; lp++) {
                    if (lp in arr) {
                        results[lp] = callbackfn[_DYN_CALL ](_this, arr[lp], arr);
                    }
                }
            }
            catch (e) {
            }
        }
        return results;
    }
    function arrReduce(arr, callbackfn, initialValue) {
        var value;
        if (arr) {
            if (arr[strReduce]) {
                return arr[strReduce](callbackfn, initialValue);
            }
            var len = arr[_DYN_LENGTH$5 ];
            var lp = 0;
            if (arguments[_DYN_LENGTH$5 ] >= 3) {
                value = arguments[2];
            }
            else {
                while (lp < len && !(lp in arr)) {
                    lp++;
                }
                value = arr[lp++];
            }
            while (lp < len) {
                if (lp in arr) {
                    value = callbackfn(value, arr[lp], lp, arr);
                }
                lp++;
            }
        }
        return value;
    }
    function strTrim(str) {
        if (str) {
            str = (_strTrim && str[cStrTrim]) ? str[cStrTrim]() : (str[_DYN_REPLACE ] ? str[_DYN_REPLACE ](/^\s+|(?=\s)\s+$/g, STR_EMPTY) : str);
        }
        return str;
    }
    var _objKeysHasDontEnumBug = !({ toString: null }).propertyIsEnumerable("toString");
    var _objKeysDontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    function objKeys(obj) {
        var objType = typeof obj;
        if (objType !== strShimFunction && (objType !== strShimObject || obj === null)) {
            throwTypeError("objKeys called on non-object");
        }
        if (!_objKeysHasDontEnumBug && _objKeys) {
            return _objKeys(obj);
        }
        var result = [];
        for (var prop in obj) {
            if (obj && ObjHasOwnProperty[_DYN_CALL ](obj, prop)) {
                result[_DYN_PUSH$2 ](prop);
            }
        }
        if (_objKeysHasDontEnumBug) {
            var dontEnumsLength = _objKeysDontEnums[_DYN_LENGTH$5 ];
            for (var lp = 0; lp < dontEnumsLength; lp++) {
                if (obj && ObjHasOwnProperty[_DYN_CALL ](obj, _objKeysDontEnums[lp])) {
                    result[_DYN_PUSH$2 ](_objKeysDontEnums[lp]);
                }
            }
        }
        return result;
    }
    function objDefineAccessors(target, prop, getProp, setProp) {
        if (_objDefineProperty$1) {
            try {
                var descriptor = {
                    enumerable: true,
                    configurable: true
                };
                if (getProp) {
                    descriptor.get = getProp;
                }
                if (setProp) {
                    descriptor.set = setProp;
                }
                _objDefineProperty$1(target, prop, descriptor);
                return true;
            }
            catch (e) {
            }
        }
        return false;
    }
    function _doNothing(value) {
        return value;
    }
    function deepFreeze(obj) {
        if (_objFreeze) {
            objForEachKey(obj, function (name, value) {
                if (isArray(value) || isObject(value)) {
                    _objFreeze(value);
                }
            });
        }
        return objFreeze(obj);
    }
    var objFreeze = _objFreeze || _doNothing;
    function dateNow() {
        var dt = Date;
        return dt.now ? dt.now() : new dt().getTime();
    }
    function getExceptionName(object) {
        if (isError(object)) {
            return object[_DYN_NAME$3 ];
        }
        return STR_EMPTY;
    }
    function setValue(target, field, value, valChk, srcChk) {
        var theValue = value;
        if (target) {
            theValue = target[field];
            if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
                theValue = value;
                target[field] = theValue;
            }
        }
        return theValue;
    }
    function getSetValue(target, field, defValue) {
        var theValue;
        if (target) {
            theValue = target[field];
            if (!theValue && isNullOrUndefined(theValue)) {
                theValue = !isUndefined(defValue) ? defValue : {};
                target[field] = theValue;
            }
        }
        else {
            theValue = !isUndefined(defValue) ? defValue : {};
        }
        return theValue;
    }
    function getCfgValue(theValue, defaultValue) {
        return !isNullOrUndefined(theValue) ? theValue : defaultValue;
    }
    function isTruthy(value) {
        return !!value;
    }
    function throwError(message) {
        throw new Error(message);
    }
    function _createProxyFunction(source, funcName) {
        var srcFunc = null;
        var src = null;
        if (isFunction(source)) {
            srcFunc = source;
        }
        else {
            src = source;
        }
        return function () {
            var originalArguments = arguments;
            if (srcFunc) {
                src = srcFunc();
            }
            if (src) {
                return src[funcName][_DYN_APPLY ](src, originalArguments);
            }
        };
    }
    function proxyAssign(target, source, chkSet) {
        if (target && source && isObject(target) && isObject(source)) {
            var _loop_1 = function (field) {
                if (isString(field)) {
                    var value = source[field];
                    if (isFunction(value)) {
                        if (!chkSet || chkSet(field, true, source, target)) {
                            target[field] = _createProxyFunction(source, field);
                        }
                    }
                    else if (!chkSet || chkSet(field, false, source, target)) {
                        if (hasOwnProperty(target, field)) {
                            delete target[field];
                        }
                        if (!objDefineAccessors(target, field, function () {
                            return source[field];
                        }, function (theValue) {
                            source[field] = theValue;
                        })) {
                            target[field] = value;
                        }
                    }
                }
            };
            for (var field in source) {
                _loop_1(field);
            }
        }
        return target;
    }
    function proxyFunctionAs(target, name, source, theFunc, overwriteTarget) {
        if (target && name && source) {
            if (overwriteTarget !== false || isUndefined(target[name])) {
                target[name] = _createProxyFunction(source, theFunc);
            }
        }
    }
    function proxyFunctions(target, source, functionsToProxy, overwriteTarget) {
        if (target && source && isObject(target) && isArray(functionsToProxy)) {
            arrForEach(functionsToProxy, function (theFuncName) {
                if (isString(theFuncName)) {
                    proxyFunctionAs(target, theFuncName, source, theFuncName, overwriteTarget);
                }
            });
        }
        return target;
    }
    function createClassFromInterface(defaults) {
        return /** @class */ (function () {
            function class_1() {
                var _this_1 = this;
                if (defaults) {
                    objForEachKey(defaults, function (field, value) {
                        _this_1[field] = value;
                    });
                }
            }
            return class_1;
        }());
    }
    function optimizeObject(theObject) {
        if (theObject && ObjAssign) {
            theObject = ObjClass(ObjAssign({}, theObject));
        }
        return theObject;
    }
    function objExtend(obj1, obj2, obj3, obj4, obj5, obj6) {
        var theArgs = arguments;
        var extended = theArgs[0] || {};
        var argLen = theArgs[_DYN_LENGTH$5 ];
        var deep = false;
        var idx = 1;
        if (argLen > 0 && isBoolean(extended)) {
            deep = extended;
            extended = theArgs[idx] || {};
            idx++;
        }
        if (!isObject(extended)) {
            extended = {};
        }
        for (; idx < argLen; idx++) {
            var arg = theArgs[idx];
            var isArgArray = isArray(arg);
            var isArgObj = isObject(arg);
            for (var prop in arg) {
                var propOk = (isArgArray && (prop in arg)) || (isArgObj && (ObjHasOwnProperty[_DYN_CALL ](arg, prop)));
                if (!propOk) {
                    continue;
                }
                var newValue = arg[prop];
                var isNewArray = void 0;
                if (deep && newValue && ((isNewArray = isArray(newValue)) || isPlainObject(newValue))) {
                    var clone = extended[prop];
                    if (isNewArray) {
                        if (!isArray(clone)) {
                            clone = [];
                        }
                    }
                    else if (!isPlainObject(clone)) {
                        clone = {};
                    }
                    newValue = objExtend(deep, clone, newValue);
                }
                if (newValue !== undefined) {
                    extended[prop] = newValue;
                }
            }
        }
        return extended;
    }

    function createEnumStyle(values) {
        var enumClass = {};
        objForEachKey(values, function (field, value) {
            enumClass[field] = value;
            enumClass[value] = field;
        });
        return deepFreeze(enumClass);
    }
    function createValueMap(values) {
        var mapClass = {};
        objForEachKey(values, function (field, value) {
            mapClass[field] = value[1];
            mapClass[value[0]] = value[1];
        });
        return deepFreeze(mapClass);
    }

    var strWindow = "window";
    var strDocument = "document";
    var strDocumentMode = "documentMode";
    var strNavigator = "navigator";
    var strHistory = "history";
    var strLocation = "location";
    var strConsole = "console";
    var strPerformance = "performance";
    var strJSON = "JSON";
    var strCrypto = "crypto";
    var strMsCrypto = "msCrypto";
    var strReactNative = "ReactNative";
    var strMsie = "msie";
    var strTrident = "trident/";
    var strXMLHttpRequest = "XMLHttpRequest";
    var _isTrident = null;
    var _navUserAgentCheck = null;
    var _enableMocks = false;
    var _useXDomainRequest = null;
    var _beaconsSupported = null;
    function _hasProperty(theClass, property) {
        var supported = false;
        if (theClass) {
            try {
                supported = property in theClass;
                if (!supported) {
                    var proto = theClass[strShimPrototype];
                    if (proto) {
                        supported = property in proto;
                    }
                }
            }
            catch (e) {
            }
            if (!supported) {
                try {
                    var tmp = new theClass();
                    supported = !isUndefined(tmp[property]);
                }
                catch (e) {
                }
            }
        }
        return supported;
    }
    function getGlobalInst(name) {
        var gbl = getGlobal();
        if (gbl && gbl[name]) {
            return gbl[name];
        }
        if (name === strWindow && hasWindow()) {
            return window;
        }
        return null;
    }
    function hasWindow() {
        return Boolean(typeof window === strShimObject && window);
    }
    function getWindow() {
        if (hasWindow()) {
            return window;
        }
        return getGlobalInst(strWindow);
    }
    function hasDocument() {
        return Boolean(typeof document === strShimObject && document);
    }
    function getDocument() {
        if (hasDocument()) {
            return document;
        }
        return getGlobalInst(strDocument);
    }
    function hasNavigator() {
        return Boolean(typeof navigator === strShimObject && navigator);
    }
    function getNavigator() {
        if (hasNavigator()) {
            return navigator;
        }
        return getGlobalInst(strNavigator);
    }
    function hasHistory() {
        return Boolean(typeof history === strShimObject && history);
    }
    function getHistory() {
        if (hasHistory()) {
            return history;
        }
        return getGlobalInst(strHistory);
    }
    function getLocation(checkForMock) {
        if (checkForMock && _enableMocks) {
            var mockLocation = getGlobalInst("__mockLocation");
            if (mockLocation) {
                return mockLocation;
            }
        }
        if (typeof location === strShimObject && location) {
            return location;
        }
        return getGlobalInst(strLocation);
    }
    function getConsole() {
        if (typeof console !== strShimUndefined) {
            return console;
        }
        return getGlobalInst(strConsole);
    }
    function getPerformance() {
        return getGlobalInst(strPerformance);
    }
    function hasJSON() {
        return Boolean((typeof JSON === strShimObject && JSON) || getGlobalInst(strJSON) !== null);
    }
    function getJSON() {
        if (hasJSON()) {
            return JSON || getGlobalInst(strJSON);
        }
        return null;
    }
    function getCrypto() {
        return getGlobalInst(strCrypto);
    }
    function getMsCrypto() {
        return getGlobalInst(strMsCrypto);
    }
    function isReactNative() {
        var nav = getNavigator();
        if (nav && nav.product) {
            return nav.product === strReactNative;
        }
        return false;
    }
    function isIE() {
        var nav = getNavigator();
        if (nav && (nav[_DYN_USER_AGENT ] !== _navUserAgentCheck || _isTrident === null)) {
            _navUserAgentCheck = nav[_DYN_USER_AGENT ];
            var userAgent = (_navUserAgentCheck || STR_EMPTY)[_DYN_TO_LOWER_CASE$2 ]();
            _isTrident = (strContains(userAgent, strMsie) || strContains(userAgent, strTrident));
        }
        return _isTrident;
    }
    function getIEVersion(userAgentStr) {
        if (userAgentStr === void 0) { userAgentStr = null; }
        if (!userAgentStr) {
            var navigator_1 = getNavigator() || {};
            userAgentStr = navigator_1 ? (navigator_1[_DYN_USER_AGENT ] || STR_EMPTY)[_DYN_TO_LOWER_CASE$2 ]() : STR_EMPTY;
        }
        var ua = (userAgentStr || STR_EMPTY)[_DYN_TO_LOWER_CASE$2 ]();
        if (strContains(ua, strMsie)) {
            var doc = getDocument() || {};
            return Math.max(parseInt(ua[_DYN_SPLIT$1 ](strMsie)[1]), (doc[strDocumentMode] || 0));
        }
        else if (strContains(ua, strTrident)) {
            var tridentVer = parseInt(ua[_DYN_SPLIT$1 ](strTrident)[1]);
            if (tridentVer) {
                return tridentVer + 4;
            }
        }
        return null;
    }
    function dumpObj(object) {
        var objectTypeDump = Object[strShimPrototype].toString[_DYN_CALL ](object);
        var propertyValueDump = STR_EMPTY;
        if (objectTypeDump === "[object Error]") {
            propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object[_DYN_NAME$3 ] + "'";
        }
        else if (hasJSON()) {
            propertyValueDump = getJSON().stringify(object);
        }
        return objectTypeDump + propertyValueDump;
    }
    function isBeaconsSupported() {
        if (_beaconsSupported === null) {
            _beaconsSupported = hasNavigator() && Boolean(getNavigator().sendBeacon);
        }
        return _beaconsSupported;
    }
    function isFetchSupported(withKeepAlive) {
        var isSupported = false;
        try {
            isSupported = !!getGlobalInst("fetch");
            var request = getGlobalInst("Request");
            if (isSupported && withKeepAlive && request) {
                isSupported = _hasProperty(request, "keepalive");
            }
        }
        catch (e) {
        }
        return isSupported;
    }
    function useXDomainRequest() {
        if (_useXDomainRequest === null) {
            _useXDomainRequest = (typeof XDomainRequest !== strShimUndefined);
            if (_useXDomainRequest && isXhrSupported()) {
                _useXDomainRequest = _useXDomainRequest && !_hasProperty(getGlobalInst(strXMLHttpRequest), "withCredentials");
            }
        }
        return _useXDomainRequest;
    }
    function isXhrSupported() {
        var isSupported = false;
        try {
            var xmlHttpRequest = getGlobalInst(strXMLHttpRequest);
            isSupported = !!xmlHttpRequest;
        }
        catch (e) {
        }
        return isSupported;
    }

    var listenerFuncs = ["eventsSent", "eventsDiscarded", "eventsSendRequest", "perfEvent"];
    var _aiNamespace = null;
    var _debugListener;
    function _listenerProxyFunc(name, config) {
        return function () {
            var args = arguments;
            var dbgExt = getDebugExt(config);
            if (dbgExt) {
                var listener = dbgExt.listener;
                if (listener && listener[name]) {
                    listener[name][_DYN_APPLY ](listener, args);
                }
            }
        };
    }
    function _getExtensionNamespace() {
        var target = getGlobalInst("Microsoft");
        if (target) {
            _aiNamespace = target["ApplicationInsights"];
        }
        return _aiNamespace;
    }
    function getDebugExt(config) {
        var ns = _aiNamespace;
        if (!ns && config.disableDbgExt !== true) {
            ns = _aiNamespace || _getExtensionNamespace();
        }
        return ns ? ns["ChromeDbgExt"] : null;
    }
    function getDebugListener(config) {
        if (!_debugListener) {
            _debugListener = {};
            for (var lp = 0; lp < listenerFuncs[_DYN_LENGTH$5 ]; lp++) {
                _debugListener[listenerFuncs[lp]] = _listenerProxyFunc(listenerFuncs[lp], config);
            }
        }
        return _debugListener;
    }

    var AiNonUserActionablePrefix = "AI (Internal): ";
    var AiUserActionablePrefix = "AI: ";
    var AIInternalMessagePrefix = "AITR_";
    function _sanitizeDiagnosticText(text) {
        if (text) {
            return "\"" + text[_DYN_REPLACE ](/\"/g, STR_EMPTY) + "\"";
        }
        return STR_EMPTY;
    }
    function _logToConsole(func, message) {
        var theConsole = getConsole();
        if (!!theConsole) {
            var logFunc = "log";
            if (theConsole[func]) {
                logFunc = func;
            }
            if (isFunction(theConsole[logFunc])) {
                theConsole[logFunc](message);
            }
        }
    }
    var _InternalLogMessage = /** @class */ (function () {
        function _InternalLogMessage(msgId, msg, isUserAct, properties) {
            if (isUserAct === void 0) { isUserAct = false; }
            var _self = this;
            _self[_DYN_MESSAGE_ID ] = msgId;
            _self[_DYN_MESSAGE$2 ] =
                (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                    msgId;
            var strProps = STR_EMPTY;
            if (hasJSON()) {
                strProps = getJSON().stringify(properties);
            }
            var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : STR_EMPTY) +
                (properties ? " props:" + _sanitizeDiagnosticText(strProps) : STR_EMPTY);
            _self[_DYN_MESSAGE$2 ] += diagnosticText;
        }
        _InternalLogMessage.dataType = "MessageData";
        return _InternalLogMessage;
    }());
    function safeGetLogger(core, config) {
        return (core || {})[_DYN_LOGGER ] || new DiagnosticLogger(config);
    }
    var DiagnosticLogger = /** @class */ (function () {
        function DiagnosticLogger(config) {
            this.identifier = "DiagnosticLogger";
            this.queue = [];
            var _messageCount = 0;
            var _messageLogged = {};
            var _loggingLevelConsole;
            var _loggingLevelTelemetry;
            var _maxInternalMessageLimit;
            var _enableDebug;
            dynamicProto(DiagnosticLogger, this, function (_self) {
                _setDefaultsFromConfig(config || {});
                _self.consoleLoggingLevel = function () { return _loggingLevelConsole; };
                _self.telemetryLoggingLevel = function () { return _loggingLevelTelemetry; };
                _self.maxInternalMessageLimit = function () { return _maxInternalMessageLimit; };
                _self[_DYN_ENABLE_DEBUG_EXCEPTI4 ] = function () { return _enableDebug; };
                _self.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
                    if (isUserAct === void 0) { isUserAct = false; }
                    var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                    if (_enableDebug) {
                        throw dumpObj(message);
                    }
                    else {
                        var logFunc = severity === 1  ? STR_ERROR_TO_CONSOLE : STR_WARN_TO_CONSOLE;
                        if (!isUndefined(message[_DYN_MESSAGE$2 ])) {
                            if (isUserAct) {
                                var messageKey = +message[_DYN_MESSAGE_ID ];
                                if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                    _self[logFunc](message[_DYN_MESSAGE$2 ]);
                                    _messageLogged[messageKey] = true;
                                }
                            }
                            else {
                                if (_loggingLevelConsole >= severity) {
                                    _self[logFunc](message[_DYN_MESSAGE$2 ]);
                                }
                            }
                            _logInternalMessage(severity, message);
                        }
                        else {
                            _debugExtMsg("throw" + (severity === 1  ? "Critical" : "Warning"), message);
                        }
                    }
                };
                _self[STR_WARN_TO_CONSOLE ] = function (message) {
                    _logToConsole("warn", message);
                    _debugExtMsg("warning", message);
                };
                _self[STR_ERROR_TO_CONSOLE ] = function (message) {
                    _logToConsole("error", message);
                    _debugExtMsg("error", message);
                };
                _self.resetInternalMessageCount = function () {
                    _messageCount = 0;
                    _messageLogged = {};
                };
                _self[_DYN_LOG_INTERNAL_MESSAGE ] = _logInternalMessage;
                function _logInternalMessage(severity, message) {
                    if (_areInternalMessagesThrottled()) {
                        return;
                    }
                    var logMessage = true;
                    var messageKey = AIInternalMessagePrefix + message[_DYN_MESSAGE_ID ];
                    if (_messageLogged[messageKey]) {
                        logMessage = false;
                    }
                    else {
                        _messageLogged[messageKey] = true;
                    }
                    if (logMessage) {
                        if (severity <= _loggingLevelTelemetry) {
                            _self.queue[_DYN_PUSH$2 ](message);
                            _messageCount++;
                            _debugExtMsg((severity === 1  ? "error" : "warn"), message);
                        }
                        if (_messageCount === _maxInternalMessageLimit) {
                            var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                            var throttleMessage = new _InternalLogMessage(23 , throttleLimitMessage, false);
                            _self.queue[_DYN_PUSH$2 ](throttleMessage);
                            if (severity === 1 ) {
                                _self[STR_ERROR_TO_CONSOLE ](throttleLimitMessage);
                            }
                            else {
                                _self[STR_WARN_TO_CONSOLE ](throttleLimitMessage);
                            }
                        }
                    }
                }
                function _setDefaultsFromConfig(config) {
                    _loggingLevelConsole = getCfgValue(config.loggingLevelConsole, 0);
                    _loggingLevelTelemetry = getCfgValue(config.loggingLevelTelemetry, 1);
                    _maxInternalMessageLimit = getCfgValue(config.maxMessageLimit, 25);
                    _enableDebug = getCfgValue(config.enableDebug, getCfgValue(config[_DYN_ENABLE_DEBUG_EXCEPTI4 ], false));
                }
                function _areInternalMessagesThrottled() {
                    return _messageCount >= _maxInternalMessageLimit;
                }
                function _debugExtMsg(name, data) {
                    var dbgExt = getDebugExt(config || {});
                    if (dbgExt && dbgExt[_DYN_DIAG_LOG$2 ]) {
                        dbgExt[_DYN_DIAG_LOG$2 ](name, data);
                    }
                }
            });
        }
        DiagnosticLogger.__ieDyn=1;
        return DiagnosticLogger;
    }());
    function _getLogger(logger) {
        return (logger || new DiagnosticLogger());
    }
    function _throwInternal(logger, severity, msgId, msg, properties, isUserAct) {
        if (isUserAct === void 0) { isUserAct = false; }
        _getLogger(logger).throwInternal(severity, msgId, msg, properties, isUserAct);
    }
    function _warnToConsole(logger, message) {
        _getLogger(logger)[STR_WARN_TO_CONSOLE ](message);
    }
    function _logInternalMessage(logger, severity, message) {
        _getLogger(logger)[_DYN_LOG_INTERNAL_MESSAGE ](severity, message);
    }

    var strExecutionContextKey = "ctx";
    var strParentContextKey = "ParentContextKey";
    var strChildrenContextKey = "ChildrenContextKey";
    var _defaultPerfManager = null;
    var PerfEvent = /** @class */ (function () {
        function PerfEvent(name, payloadDetails, isAsync) {
            var _self = this;
            var accessorDefined = false;
            _self.start = dateNow();
            _self[_DYN_NAME$3 ] = name;
            _self[_DYN_IS_ASYNC ] = isAsync;
            _self[_DYN_IS_CHILD_EVT ] = function () { return false; };
            if (isFunction(payloadDetails)) {
                var theDetails_1;
                accessorDefined = objDefineAccessors(_self, "payload", function () {
                    if (!theDetails_1 && isFunction(payloadDetails)) {
                        theDetails_1 = payloadDetails();
                        payloadDetails = null;
                    }
                    return theDetails_1;
                });
            }
            _self[_DYN_GET_CTX ] = function (key) {
                if (key) {
                    if (key === PerfEvent[strParentContextKey] || key === PerfEvent[strChildrenContextKey]) {
                        return _self[key];
                    }
                    return (_self[strExecutionContextKey] || {})[key];
                }
                return null;
            };
            _self[_DYN_SET_CTX ] = function (key, value) {
                if (key) {
                    if (key === PerfEvent[strParentContextKey]) {
                        if (!_self[key]) {
                            _self[_DYN_IS_CHILD_EVT ] = function () { return true; };
                        }
                        _self[key] = value;
                    }
                    else if (key === PerfEvent[strChildrenContextKey]) {
                        _self[key] = value;
                    }
                    else {
                        var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                        ctx[key] = value;
                    }
                }
            };
            _self[_DYN_COMPLETE ] = function () {
                var childTime = 0;
                var childEvts = _self[_DYN_GET_CTX ](PerfEvent[strChildrenContextKey]);
                if (isArray(childEvts)) {
                    for (var lp = 0; lp < childEvts[_DYN_LENGTH$5 ]; lp++) {
                        var childEvt = childEvts[lp];
                        if (childEvt) {
                            childTime += childEvt[_DYN_TIME ];
                        }
                    }
                }
                _self[_DYN_TIME ] = dateNow() - _self.start;
                _self.exTime = _self[_DYN_TIME ] - childTime;
                _self[_DYN_COMPLETE ] = function () { };
                if (!accessorDefined && isFunction(payloadDetails)) {
                    _self.payload = payloadDetails();
                }
            };
        }
        PerfEvent.ParentContextKey = "parent";
        PerfEvent.ChildrenContextKey = "childEvts";
        return PerfEvent;
    }());
    var PerfManager = /** @class */ (function () {
        function PerfManager(manager) {
            this.ctx = {};
            dynamicProto(PerfManager, this, function (_self) {
                _self.create = function (src, payloadDetails, isAsync) {
                    return new PerfEvent(src, payloadDetails, isAsync);
                };
                _self.fire = function (perfEvent) {
                    if (perfEvent) {
                        perfEvent[_DYN_COMPLETE ]();
                        if (manager && isFunction(manager[STR_PERF_EVENT ])) {
                            manager[STR_PERF_EVENT ](perfEvent);
                        }
                    }
                };
                _self[_DYN_SET_CTX ] = function (key, value) {
                    if (key) {
                        var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                        ctx[key] = value;
                    }
                };
                _self[_DYN_GET_CTX ] = function (key) {
                    return (_self[strExecutionContextKey] || {})[key];
                };
            });
        }
        PerfManager.__ieDyn=1;
        return PerfManager;
    }());
    var doPerfActiveKey = "CoreUtils.doPerf";
    function doPerf(mgrSource, getSource, func, details, isAsync) {
        if (mgrSource) {
            var perfMgr = mgrSource;
            if (perfMgr[STR_GET_PERF_MGR]) {
                perfMgr = perfMgr[STR_GET_PERF_MGR]();
            }
            if (perfMgr) {
                var perfEvt = void 0;
                var currentActive = perfMgr[_DYN_GET_CTX ](doPerfActiveKey);
                try {
                    perfEvt = perfMgr.create(getSource(), details, isAsync);
                    if (perfEvt) {
                        if (currentActive && perfEvt[_DYN_SET_CTX ]) {
                            perfEvt[_DYN_SET_CTX ](PerfEvent[strParentContextKey], currentActive);
                            if (currentActive[_DYN_GET_CTX ] && currentActive[_DYN_SET_CTX ]) {
                                var children = currentActive[_DYN_GET_CTX ](PerfEvent[strChildrenContextKey]);
                                if (!children) {
                                    children = [];
                                    currentActive[_DYN_SET_CTX ](PerfEvent[strChildrenContextKey], children);
                                }
                                children[_DYN_PUSH$2 ](perfEvt);
                            }
                        }
                        perfMgr[_DYN_SET_CTX ](doPerfActiveKey, perfEvt);
                        return func(perfEvt);
                    }
                }
                catch (ex) {
                    if (perfEvt && perfEvt[_DYN_SET_CTX ]) {
                        perfEvt[_DYN_SET_CTX ]("exception", ex);
                    }
                }
                finally {
                    if (perfEvt) {
                        perfMgr.fire(perfEvt);
                    }
                    perfMgr[_DYN_SET_CTX ](doPerfActiveKey, currentActive);
                }
            }
        }
        return func();
    }
    function getGblPerfMgr() {
        return _defaultPerfManager;
    }

    var UInt32Mask = 0x100000000;
    var MaxUInt32 = 0xffffffff;
    var _mwcSeeded = false;
    var _mwcW = 123456789;
    var _mwcZ = 987654321;
    function _mwcSeed(seedValue) {
        if (seedValue < 0) {
            seedValue >>>= 0;
        }
        _mwcW = (123456789 + seedValue) & MaxUInt32;
        _mwcZ = (987654321 - seedValue) & MaxUInt32;
        _mwcSeeded = true;
    }
    function _autoSeedMwc() {
        try {
            var now = dateNow() & 0x7fffffff;
            _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
        }
        catch (e) {
        }
    }
    function randomValue(maxValue) {
        if (maxValue > 0) {
            return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
        }
        return 0;
    }
    function random32(signed) {
        var value = 0;
        var c = getCrypto() || getMsCrypto();
        if (c && c.getRandomValues) {
            value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
        }
        if (value === 0 && isIE()) {
            if (!_mwcSeeded) {
                _autoSeedMwc();
            }
            value = mwcRandom32() & MaxUInt32;
        }
        if (value === 0) {
            value = Math.floor((UInt32Mask * Math.random()) | 0);
        }
        if (!signed) {
            value >>>= 0;
        }
        return value;
    }
    function mwcRandomSeed(value) {
        if (!value) {
            _autoSeedMwc();
        }
        else {
            _mwcSeed(value);
        }
    }
    function mwcRandom32(signed) {
        _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
        _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
        var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
        if (!signed) {
            value >>>= 0;
        }
        return value;
    }
    function newId(maxLength) {
        if (maxLength === void 0) { maxLength = 22; }
        var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var number = random32() >>> 0;
        var chars = 0;
        var result = STR_EMPTY;
        while (result[_DYN_LENGTH$5 ] < maxLength) {
            chars++;
            result += base64chars.charAt(number & 0x3F);
            number >>>= 6;
            if (chars === 5) {
                number = (((random32() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
                chars = 0;
            }
        }
        return result;
    }

    var _objDefineProperty = ObjDefineProperty;
    var version = '2.8.14';
    var instanceName = "." + newId(6);
    var _dataUid = 0;
    function _createAccessor(target, prop, value) {
        if (_objDefineProperty) {
            try {
                _objDefineProperty(target, prop, {
                    value: value,
                    enumerable: false,
                    configurable: true
                });
                return true;
            }
            catch (e) {
            }
        }
        return false;
    }
    function _canAcceptData(target) {
        return target[_DYN_NODE_TYPE ] === 1 || target[_DYN_NODE_TYPE ] === 9 || !(+target[_DYN_NODE_TYPE ]);
    }
    function _getCache(data, target) {
        var theCache = target[data.id];
        if (!theCache) {
            theCache = {};
            try {
                if (_canAcceptData(target)) {
                    if (!_createAccessor(target, data.id, theCache)) {
                        target[data.id] = theCache;
                    }
                }
            }
            catch (e) {
            }
        }
        return theCache;
    }
    function createUniqueNamespace(name, includeVersion) {
        if (includeVersion === void 0) { includeVersion = false; }
        return normalizeJsName(name + (_dataUid++) + (includeVersion ? "." + version : STR_EMPTY) + instanceName);
    }
    function createElmNodeData(name) {
        var data = {
            id: createUniqueNamespace("_aiData-" + (name || STR_EMPTY) + "." + version),
            accept: function (target) {
                return _canAcceptData(target);
            },
            get: function (target, name, defValue, addDefault) {
                var theCache = target[data.id];
                if (!theCache) {
                    if (addDefault) {
                        theCache = _getCache(data, target);
                        theCache[normalizeJsName(name)] = defValue;
                    }
                    return defValue;
                }
                return theCache[normalizeJsName(name)];
            },
            kill: function (target, name) {
                if (target && target[name]) {
                    try {
                        delete target[name];
                    }
                    catch (e) {
                    }
                }
            }
        };
        return data;
    }

    var strToGMTString = "toGMTString";
    var strToUTCString = "toUTCString";
    var strCookie = "cookie";
    var strExpires = "expires";
    var strEnabled = "enabled";
    var strIsCookieUseDisabled = "isCookieUseDisabled";
    var strDisableCookiesUsage = "disableCookiesUsage";
    var strConfigCookieMgr = "_ckMgr";
    var _supportsCookies = null;
    var _allowUaSameSite = null;
    var _parsedCookieValue = null;
    var _doc = getDocument();
    var _cookieCache = {};
    var _globalCookieConfig = {};
    function _gblCookieMgr(config, logger) {
        var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
        if (!inst) {
            inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
            _globalCookieConfig[strConfigCookieMgr] = inst;
        }
        return inst;
    }
    function _isMgrEnabled(cookieMgr) {
        if (cookieMgr) {
            return cookieMgr.isEnabled();
        }
        return true;
    }
    function _createCookieMgrConfig(rootConfig) {
        var cookieMgrCfg = rootConfig[_DYN_COOKIE_CFG ] = rootConfig[_DYN_COOKIE_CFG ] || {};
        setValue(cookieMgrCfg, "domain", rootConfig.cookieDomain, isNotNullOrUndefined, isNullOrUndefined);
        setValue(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, isNullOrUndefined);
        if (isNullOrUndefined(cookieMgrCfg[strEnabled])) {
            var cookieEnabled = void 0;
            if (!isUndefined(rootConfig[strIsCookieUseDisabled])) {
                cookieEnabled = !rootConfig[strIsCookieUseDisabled];
            }
            if (!isUndefined(rootConfig[strDisableCookiesUsage])) {
                cookieEnabled = !rootConfig[strDisableCookiesUsage];
            }
            cookieMgrCfg[strEnabled] = cookieEnabled;
        }
        return cookieMgrCfg;
    }
    function _isIgnoredCookie(cookieMgrCfg, name) {
        if (name && cookieMgrCfg && isArray(cookieMgrCfg.ignoreCookies)) {
            return cookieMgrCfg.ignoreCookies[_DYN_INDEX_OF$2 ](name) !== -1;
        }
        return false;
    }
    function _isBlockedCookie(cookieMgrCfg, name) {
        if (name && cookieMgrCfg && isArray(cookieMgrCfg.blockedCookies)) {
            if (cookieMgrCfg.blockedCookies[_DYN_INDEX_OF$2 ](name) !== -1) {
                return true;
            }
        }
        return _isIgnoredCookie(cookieMgrCfg, name);
    }
    function safeGetCookieMgr(core, config) {
        var cookieMgr;
        if (core) {
            cookieMgr = core.getCookieMgr();
        }
        else if (config) {
            var cookieCfg = config[_DYN_COOKIE_CFG ];
            if (cookieCfg[strConfigCookieMgr]) {
                cookieMgr = cookieCfg[strConfigCookieMgr];
            }
            else {
                cookieMgr = createCookieMgr(config);
            }
        }
        if (!cookieMgr) {
            cookieMgr = _gblCookieMgr(config, (core || {})[_DYN_LOGGER ]);
        }
        return cookieMgr;
    }
    function createCookieMgr(rootConfig, logger) {
        var _a;
        var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
        var _path = cookieMgrConfig.path || "/";
        var _domain = cookieMgrConfig.domain;
        var _enabled = cookieMgrConfig[strEnabled] !== false;
        var cookieMgr = (_a = {
                isEnabled: function () {
                    var enabled = _enabled && areCookiesSupported(logger);
                    var gblManager = _globalCookieConfig[strConfigCookieMgr];
                    if (enabled && gblManager && cookieMgr !== gblManager) {
                        enabled = _isMgrEnabled(gblManager);
                    }
                    return enabled;
                }
            },
            _a[_DYN_SET_ENABLED ] = function (value) {
                _enabled = value !== false;
            },
            _a.set = function (name, value, maxAgeSec, domain, path) {
                var result = false;
                if (_isMgrEnabled(cookieMgr) && !_isBlockedCookie(cookieMgrConfig, name)) {
                    var values = {};
                    var theValue = strTrim(value || STR_EMPTY);
                    var idx = theValue[_DYN_INDEX_OF$2 ](";");
                    if (idx !== -1) {
                        theValue = strTrim(value[_DYN_SUBSTRING$1 ](0, idx));
                        values = _extractParts(value[_DYN_SUBSTRING$1 ](idx + 1));
                    }
                    setValue(values, "domain", domain || _domain, isTruthy, isUndefined);
                    if (!isNullOrUndefined(maxAgeSec)) {
                        var _isIE = isIE();
                        if (isUndefined(values[strExpires])) {
                            var nowMs = dateNow();
                            var expireMs = nowMs + (maxAgeSec * 1000);
                            if (expireMs > 0) {
                                var expiry = new Date();
                                expiry.setTime(expireMs);
                                setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || STR_EMPTY, isTruthy);
                            }
                        }
                        if (!_isIE) {
                            setValue(values, "max-age", STR_EMPTY + maxAgeSec, null, isUndefined);
                        }
                    }
                    var location_1 = getLocation();
                    if (location_1 && location_1.protocol === "https:") {
                        setValue(values, "secure", null, null, isUndefined);
                        if (_allowUaSameSite === null) {
                            _allowUaSameSite = !uaDisallowsSameSiteNone((getNavigator() || {})[_DYN_USER_AGENT ]);
                        }
                        if (_allowUaSameSite) {
                            setValue(values, "SameSite", "None", null, isUndefined);
                        }
                    }
                    setValue(values, "path", path || _path, null, isUndefined);
                    var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                    setCookieFn(name, _formatCookieValue(theValue, values));
                    result = true;
                }
                return result;
            },
            _a.get = function (name) {
                var value = STR_EMPTY;
                if (_isMgrEnabled(cookieMgr) && !_isIgnoredCookie(cookieMgrConfig, name)) {
                    value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
                }
                return value;
            },
            _a.del = function (name, path) {
                var result = false;
                if (_isMgrEnabled(cookieMgr)) {
                    result = cookieMgr.purge(name, path);
                }
                return result;
            },
            _a.purge = function (name, path) {
                var _a;
                var result = false;
                if (areCookiesSupported(logger)) {
                    var values = (_a = {},
                        _a["path"] = path ? path : "/",
                        _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
                        _a);
                    if (!isIE()) {
                        values["max-age"] = "0";
                    }
                    var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                    delCookie(name, _formatCookieValue(STR_EMPTY, values));
                    result = true;
                }
                return result;
            },
            _a);
        cookieMgr[strConfigCookieMgr] = cookieMgr;
        return cookieMgr;
    }
    function areCookiesSupported(logger) {
        if (_supportsCookies === null) {
            _supportsCookies = false;
            try {
                var doc = _doc || {};
                _supportsCookies = doc[strCookie] !== undefined;
            }
            catch (e) {
                _throwInternal(logger, 2 , 68 , "Cannot access document.cookie - " + getExceptionName(e), { exception: dumpObj(e) });
            }
        }
        return _supportsCookies;
    }
    function _extractParts(theValue) {
        var values = {};
        if (theValue && theValue[_DYN_LENGTH$5 ]) {
            var parts = strTrim(theValue)[_DYN_SPLIT$1 ](";");
            arrForEach(parts, function (thePart) {
                thePart = strTrim(thePart || STR_EMPTY);
                if (thePart) {
                    var idx = thePart[_DYN_INDEX_OF$2 ]("=");
                    if (idx === -1) {
                        values[thePart] = null;
                    }
                    else {
                        values[strTrim(thePart[_DYN_SUBSTRING$1 ](0, idx))] = strTrim(thePart[_DYN_SUBSTRING$1 ](idx + 1));
                    }
                }
            });
        }
        return values;
    }
    function _formatDate(theDate, func) {
        if (isFunction(theDate[func])) {
            return theDate[func]();
        }
        return null;
    }
    function _formatCookieValue(value, values) {
        var cookieValue = value || STR_EMPTY;
        objForEachKey(values, function (name, theValue) {
            cookieValue += "; " + name + (!isNullOrUndefined(theValue) ? "=" + theValue : STR_EMPTY);
        });
        return cookieValue;
    }
    function _getCookieValue(name) {
        var cookieValue = STR_EMPTY;
        if (_doc) {
            var theCookie = _doc[strCookie] || STR_EMPTY;
            if (_parsedCookieValue !== theCookie) {
                _cookieCache = _extractParts(theCookie);
                _parsedCookieValue = theCookie;
            }
            cookieValue = strTrim(_cookieCache[name] || STR_EMPTY);
        }
        return cookieValue;
    }
    function _setCookieValue(name, cookieValue) {
        if (_doc) {
            _doc[strCookie] = name + "=" + cookieValue;
        }
    }
    function uaDisallowsSameSiteNone(userAgent) {
        if (!isString(userAgent)) {
            return false;
        }
        if (strContains(userAgent, "CPU iPhone OS 12") || strContains(userAgent, "iPad; CPU OS 12")) {
            return true;
        }
        if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strContains(userAgent, "Version/") && strContains(userAgent, "Safari")) {
            return true;
        }
        if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
            return true;
        }
        if (strContains(userAgent, "Chrome/5") || strContains(userAgent, "Chrome/6")) {
            return true;
        }
        if (strContains(userAgent, "UnrealEngine") && !strContains(userAgent, "Chrome")) {
            return true;
        }
        if (strContains(userAgent, "UCBrowser/12") || strContains(userAgent, "UCBrowser/11")) {
            return true;
        }
        return false;
    }

    var strOnPrefix = "on";
    var strAttachEvent = "attachEvent";
    var strAddEventHelper = "addEventListener";
    var strDetachEvent = "detachEvent";
    var strRemoveEventListener = "removeEventListener";
    var strEvents = "events";
    var strVisibilityChangeEvt = "visibilitychange";
    var strPageHide = "pagehide";
    var strUnload = "unload";
    var strBeforeUnload = "beforeunload";
    var strPageHideNamespace = createUniqueNamespace("aiEvtPageHide");
    createUniqueNamespace("aiEvtPageShow");
    var rRemoveEmptyNs = /\.[\.]+/g;
    var rRemoveTrailingEmptyNs = /[\.]+$/;
    var _guid = 1;
    var elmNodeData = createElmNodeData("events");
    var eventNamespace = /^([^.]*)(?:\.(.+)|)/;
    function _normalizeNamespace(name) {
        if (name && name[_DYN_REPLACE ]) {
            return name[_DYN_REPLACE ](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, STR_EMPTY);
        }
        return name;
    }
    function _getEvtNamespace(eventName, evtNamespace) {
        var _a;
        if (evtNamespace) {
            var theNamespace_1 = STR_EMPTY;
            if (isArray(evtNamespace)) {
                theNamespace_1 = STR_EMPTY;
                arrForEach(evtNamespace, function (name) {
                    name = _normalizeNamespace(name);
                    if (name) {
                        if (name[0] !== ".") {
                            name = "." + name;
                        }
                        theNamespace_1 += name;
                    }
                });
            }
            else {
                theNamespace_1 = _normalizeNamespace(evtNamespace);
            }
            if (theNamespace_1) {
                if (theNamespace_1[0] !== ".") {
                    theNamespace_1 = "." + theNamespace_1;
                }
                eventName = (eventName || STR_EMPTY) + theNamespace_1;
            }
        }
        var parsedEvent = (eventNamespace.exec(eventName || STR_EMPTY) || []);
        return _a = {},
            _a[_DYN_TYPE ] = parsedEvent[1],
            _a.ns = ((parsedEvent[2] || STR_EMPTY).replace(rRemoveEmptyNs, ".").replace(rRemoveTrailingEmptyNs, STR_EMPTY)[_DYN_SPLIT$1 ](".").sort()).join("."),
            _a;
    }
    function _getRegisteredEvents(target, evtName, addDefault) {
        if (addDefault === void 0) { addDefault = true; }
        var aiEvts = elmNodeData.get(target, strEvents, {}, addDefault);
        var registeredEvents = aiEvts[evtName];
        if (!registeredEvents) {
            registeredEvents = aiEvts[evtName] = [];
        }
        return registeredEvents;
    }
    function _doDetach(obj, evtName, handlerRef, useCapture) {
        if (obj && evtName && evtName[_DYN_TYPE ]) {
            if (obj[strRemoveEventListener]) {
                obj[strRemoveEventListener](evtName[_DYN_TYPE ], handlerRef, useCapture);
            }
            else if (obj[strDetachEvent]) {
                obj[strDetachEvent](strOnPrefix + evtName[_DYN_TYPE ], handlerRef);
            }
        }
    }
    function _doAttach(obj, evtName, handlerRef, useCapture) {
        var result = false;
        if (obj && evtName && evtName[_DYN_TYPE ] && handlerRef) {
            if (obj[strAddEventHelper]) {
                obj[strAddEventHelper](evtName[_DYN_TYPE ], handlerRef, useCapture);
                result = true;
            }
            else if (obj[strAttachEvent]) {
                obj[strAttachEvent](strOnPrefix + evtName[_DYN_TYPE ], handlerRef);
                result = true;
            }
        }
        return result;
    }
    function _doUnregister(target, events, evtName, unRegFn) {
        var idx = events[_DYN_LENGTH$5 ];
        while (idx--) {
            var theEvent = events[idx];
            if (theEvent) {
                if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
                    if (!unRegFn || unRegFn(theEvent)) {
                        _doDetach(target, theEvent.evtName, theEvent[_DYN_HANDLER ], theEvent.capture);
                        events[_DYN_SPLICE ](idx, 1);
                    }
                }
            }
        }
    }
    function _unregisterEvents(target, evtName, unRegFn) {
        if (evtName[_DYN_TYPE ]) {
            _doUnregister(target, _getRegisteredEvents(target, evtName[_DYN_TYPE ]), evtName, unRegFn);
        }
        else {
            var eventCache = elmNodeData.get(target, strEvents, {});
            objForEachKey(eventCache, function (evtType, events) {
                _doUnregister(target, events, evtName, unRegFn);
            });
            if (objKeys(eventCache)[_DYN_LENGTH$5 ] === 0) {
                elmNodeData.kill(target, strEvents);
            }
        }
    }
    function mergeEvtNamespace(theNamespace, namespaces) {
        var newNamespaces;
        if (namespaces) {
            if (isArray(namespaces)) {
                newNamespaces = [theNamespace].concat(namespaces);
            }
            else {
                newNamespaces = [theNamespace, namespaces];
            }
            newNamespaces = (_getEvtNamespace("xx", newNamespaces).ns)[_DYN_SPLIT$1 ](".");
        }
        else {
            newNamespaces = theNamespace;
        }
        return newNamespaces;
    }
    function eventOn(target, eventName, handlerRef, evtNamespace, useCapture) {
        var _a;
        if (useCapture === void 0) { useCapture = false; }
        var result = false;
        if (target) {
            try {
                var evtName = _getEvtNamespace(eventName, evtNamespace);
                result = _doAttach(target, evtName, handlerRef, useCapture);
                if (result && elmNodeData.accept(target)) {
                    var registeredEvent = (_a = {
                            guid: _guid++,
                            evtName: evtName
                        },
                        _a[_DYN_HANDLER ] = handlerRef,
                        _a.capture = useCapture,
                        _a);
                    _getRegisteredEvents(target, evtName.type)[_DYN_PUSH$2 ](registeredEvent);
                }
            }
            catch (e) {
            }
        }
        return result;
    }
    function eventOff(target, eventName, handlerRef, evtNamespace, useCapture) {
        if (useCapture === void 0) { useCapture = false; }
        if (target) {
            try {
                var evtName_1 = _getEvtNamespace(eventName, evtNamespace);
                var found_1 = false;
                _unregisterEvents(target, evtName_1, function (regEvent) {
                    if ((evtName_1.ns && !handlerRef) || regEvent[_DYN_HANDLER ] === handlerRef) {
                        found_1 = true;
                        return true;
                    }
                    return false;
                });
                if (!found_1) {
                    _doDetach(target, evtName_1, handlerRef, useCapture);
                }
            }
            catch (e) {
            }
        }
    }
    function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
        if (useCapture === void 0) { useCapture = false; }
        return eventOn(obj, eventNameWithoutOn, handlerRef, null, useCapture);
    }
    function addEventHandler(eventName, callback, evtNamespace) {
        var result = false;
        var w = getWindow();
        if (w) {
            result = eventOn(w, eventName, callback, evtNamespace);
            result = eventOn(w["body"], eventName, callback, evtNamespace) || result;
        }
        var doc = getDocument();
        if (doc) {
            result = eventOn(doc, eventName, callback, evtNamespace) || result;
        }
        return result;
    }
    function removeEventHandler(eventName, callback, evtNamespace) {
        var w = getWindow();
        if (w) {
            eventOff(w, eventName, callback, evtNamespace);
            eventOff(w["body"], eventName, callback, evtNamespace);
        }
        var doc = getDocument();
        if (doc) {
            eventOff(doc, eventName, callback, evtNamespace);
        }
    }
    function _addEventListeners(events, listener, excludeEvents, evtNamespace) {
        var added = false;
        if (listener && events && events[_DYN_LENGTH$5 ] > 0) {
            arrForEach(events, function (name) {
                if (name) {
                    if (!excludeEvents || arrIndexOf(excludeEvents, name) === -1) {
                        added = addEventHandler(name, listener, evtNamespace) || added;
                    }
                }
            });
        }
        return added;
    }
    function addEventListeners(events, listener, excludeEvents, evtNamespace) {
        var added = false;
        if (listener && events && isArray(events)) {
            added = _addEventListeners(events, listener, excludeEvents, evtNamespace);
            if (!added && excludeEvents && excludeEvents[_DYN_LENGTH$5 ] > 0) {
                added = _addEventListeners(events, listener, null, evtNamespace);
            }
        }
        return added;
    }
    function removeEventListeners(events, listener, evtNamespace) {
        if (events && isArray(events)) {
            arrForEach(events, function (name) {
                if (name) {
                    removeEventHandler(name, listener, evtNamespace);
                }
            });
        }
    }
    function addPageUnloadEventListener(listener, excludeEvents, evtNamespace) {
        return addEventListeners([strBeforeUnload, strUnload, strPageHide], listener, excludeEvents, evtNamespace);
    }
    function removePageUnloadEventListener(listener, evtNamespace) {
        removeEventListeners([strBeforeUnload, strUnload, strPageHide], listener, evtNamespace);
    }
    function addPageHideEventListener(listener, excludeEvents, evtNamespace) {
        function _handlePageVisibility(evt) {
            var doc = getDocument();
            if (listener && doc && doc.visibilityState === "hidden") {
                listener(evt);
            }
        }
        var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
        var pageUnloadAdded = _addEventListeners([strPageHide], listener, excludeEvents, newNamespaces);
        if (!excludeEvents || arrIndexOf(excludeEvents, strVisibilityChangeEvt) === -1) {
            pageUnloadAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
        }
        if (!pageUnloadAdded && excludeEvents) {
            pageUnloadAdded = addPageHideEventListener(listener, null, evtNamespace);
        }
        return pageUnloadAdded;
    }
    function removePageHideEventListener(listener, evtNamespace) {
        var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
        removeEventListeners([strPageHide], listener, newNamespaces);
        removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
    }

    var _cookieMgrs = null;
    var _canUseCookies;
    function newGuid() {
        var uuid = generateW3CId();
        return uuid[_DYN_SUBSTRING$1 ](0, 8) + "-" + uuid[_DYN_SUBSTRING$1 ](8, 12) + "-" + uuid[_DYN_SUBSTRING$1 ](12, 16) + "-" + uuid[_DYN_SUBSTRING$1 ](16, 20) + "-" + uuid[_DYN_SUBSTRING$1 ](20);
    }
    function perfNow() {
        var perf = getPerformance();
        if (perf && perf.now) {
            return perf.now();
        }
        return dateNow();
    }
    function generateW3CId() {
        var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
        var oct = STR_EMPTY, tmp;
        for (var a = 0; a < 4; a++) {
            tmp = random32();
            oct +=
                hexValues[tmp & 0xF] +
                    hexValues[tmp >> 4 & 0xF] +
                    hexValues[tmp >> 8 & 0xF] +
                    hexValues[tmp >> 12 & 0xF] +
                    hexValues[tmp >> 16 & 0xF] +
                    hexValues[tmp >> 20 & 0xF] +
                    hexValues[tmp >> 24 & 0xF] +
                    hexValues[tmp >> 28 & 0xF];
        }
        var clockSequenceHi = hexValues[8 + (random32() & 0x03) | 0];
        return oct[_DYN_SUBSTR ](0, 8) + oct[_DYN_SUBSTR ](9, 4) + "4" + oct[_DYN_SUBSTR ](13, 3) + clockSequenceHi + oct[_DYN_SUBSTR ](16, 3) + oct[_DYN_SUBSTR ](19, 12);
    }
    var CoreUtils = {
        _canUseCookies: undefined,
        isTypeof: isTypeof,
        isUndefined: isUndefined,
        isNullOrUndefined: isNullOrUndefined,
        hasOwnProperty: hasOwnProperty,
        isFunction: isFunction,
        isObject: isObject,
        isDate: isDate,
        isArray: isArray,
        isError: isError,
        isString: isString,
        isNumber: isNumber,
        isBoolean: isBoolean,
        toISOString: toISOString,
        arrForEach: arrForEach,
        arrIndexOf: arrIndexOf,
        arrMap: arrMap,
        arrReduce: arrReduce,
        strTrim: strTrim,
        objCreate: objCreateFn,
        objKeys: objKeys,
        objDefineAccessors: objDefineAccessors,
        addEventHandler: addEventHandler,
        dateNow: dateNow,
        isIE: isIE,
        disableCookies: disableCookies,
        newGuid: newGuid,
        perfNow: perfNow,
        newId: newId,
        randomValue: randomValue,
        random32: random32,
        mwcRandomSeed: mwcRandomSeed,
        mwcRandom32: mwcRandom32,
        generateW3CId: generateW3CId
    };
    function _legacyCookieMgr(config, logger) {
        var cookieMgr = _gblCookieMgr(config, logger);
        var legacyCanUseCookies = CoreUtils._canUseCookies;
        if (_cookieMgrs === null) {
            _cookieMgrs = [];
            _canUseCookies = legacyCanUseCookies;
            objDefineAccessors(CoreUtils, "_canUseCookies", function () {
                return _canUseCookies;
            }, function (value) {
                _canUseCookies = value;
                arrForEach(_cookieMgrs, function (mgr) {
                    mgr[_DYN_SET_ENABLED ](value);
                });
            });
        }
        if (arrIndexOf(_cookieMgrs, cookieMgr) === -1) {
            _cookieMgrs[_DYN_PUSH$2 ](cookieMgr);
        }
        if (isBoolean(legacyCanUseCookies)) {
            cookieMgr[_DYN_SET_ENABLED ](legacyCanUseCookies);
        }
        if (isBoolean(_canUseCookies)) {
            cookieMgr[_DYN_SET_ENABLED ](_canUseCookies);
        }
        return cookieMgr;
    }
    function disableCookies() {
        _legacyCookieMgr()[_DYN_SET_ENABLED ](false);
    }
    function canUseCookies(logger) {
        return _legacyCookieMgr(null, logger).isEnabled();
    }
    function getCookie(logger, name) {
        return _legacyCookieMgr(null, logger).get(name);
    }
    function setCookie(logger, name, value, domain) {
        _legacyCookieMgr(null, logger).set(name, value, null, domain);
    }
    function deleteCookie(logger, name) {
        return _legacyCookieMgr(null, logger).del(name);
    }

    var DEFAULT_VERSION = "00";
    var INVALID_VERSION = "ff";
    var INVALID_TRACE_ID = "00000000000000000000000000000000";
    var INVALID_SPAN_ID = "0000000000000000";
    function _isValid(value, len, invalidValue) {
        if (value && value[_DYN_LENGTH$5 ] === len && value !== invalidValue) {
            return !!value.match(/^[\da-f]*$/);
        }
        return false;
    }
    function _formatValue(value, len, defValue) {
        if (_isValid(value, len)) {
            return value;
        }
        return defValue;
    }
    function _formatFlags(value) {
        if (isNaN(value) || value < 0 || value > 255) {
            value = 0x01;
        }
        var result = value.toString(16);
        while (result[_DYN_LENGTH$5 ] < 2) {
            result = "0" + result;
        }
        return result;
    }
    function createTraceParent(traceId, spanId, flags, version) {
        var _a;
        return _a = {},
            _a[_DYN_VERSION$1 ] = _isValid(version, 2, INVALID_VERSION) ? version : DEFAULT_VERSION,
            _a[_DYN_TRACE_ID$2 ] = isValidTraceId(traceId) ? traceId : generateW3CId(),
            _a.spanId = isValidSpanId(spanId) ? spanId : generateW3CId()[_DYN_SUBSTR ](0, 16),
            _a.traceFlags = flags >= 0 && flags <= 0xFF ? flags : 1,
            _a;
    }
    function isValidTraceId(value) {
        return _isValid(value, 32, INVALID_TRACE_ID);
    }
    function isValidSpanId(value) {
        return _isValid(value, 16, INVALID_SPAN_ID);
    }
    function formatTraceParent(value) {
        if (value) {
            var flags = _formatFlags(value[_DYN_TRACE_FLAGS$1 ]);
            if (!_isValid(flags, 2)) {
                flags = "01";
            }
            var version = value[_DYN_VERSION$1 ] || DEFAULT_VERSION;
            if (version !== "00" && version !== "ff") {
                version = DEFAULT_VERSION;
            }
            return "".concat(version, "-").concat(_formatValue(value.traceId, 32, INVALID_TRACE_ID), "-").concat(_formatValue(value.spanId, 16, INVALID_SPAN_ID), "-").concat(flags);
        }
        return "";
    }

    var pluginStateData = createElmNodeData("plugin");
    function _getPluginState(plugin) {
        return pluginStateData.get(plugin, "state", {}, true);
    }
    function initializePlugins(processContext, extensions) {
        var initPlugins = [];
        var lastPlugin = null;
        var proxy = processContext[_DYN_GET_NEXT ]();
        var pluginState;
        while (proxy) {
            var thePlugin = proxy[_DYN_GET_PLUGIN ]();
            if (thePlugin) {
                if (lastPlugin &&
                    isFunction(lastPlugin[_DYN_SET_NEXT_PLUGIN ]) &&
                    isFunction(thePlugin[STR_PROCESS_TELEMETRY ])) {
                    lastPlugin[_DYN_SET_NEXT_PLUGIN ](thePlugin);
                }
                var isInitialized = false;
                if (isFunction(thePlugin[_DYN_IS_INITIALIZED ])) {
                    isInitialized = thePlugin[_DYN_IS_INITIALIZED ]();
                }
                else {
                    pluginState = _getPluginState(thePlugin);
                    isInitialized = pluginState[_DYN_IS_INITIALIZED ];
                }
                if (!isInitialized) {
                    initPlugins[_DYN_PUSH$2 ](thePlugin);
                }
                lastPlugin = thePlugin;
                proxy = proxy[_DYN_GET_NEXT ]();
            }
        }
        arrForEach(initPlugins, function (thePlugin) {
            var core = processContext[STR_CORE]();
            thePlugin[_DYN_INITIALIZE ](processContext.getCfg(), core, extensions, processContext[_DYN_GET_NEXT ]());
            pluginState = _getPluginState(thePlugin);
            if (!thePlugin[STR_CORE] && !pluginState[STR_CORE]) {
                pluginState[STR_CORE] = core;
            }
            pluginState[_DYN_IS_INITIALIZED ] = true;
            delete pluginState[_DYN_TEARDOWN ];
        });
    }
    function sortPlugins(plugins) {
        return plugins.sort(function (extA, extB) {
            var result = 0;
            if (extB) {
                var bHasProcess = isFunction(extB[STR_PROCESS_TELEMETRY]);
                if (isFunction(extA[STR_PROCESS_TELEMETRY])) {
                    result = bHasProcess ? extA[STR_PRIORITY] - extB[STR_PRIORITY] : 1;
                }
                else if (bHasProcess) {
                    result = -1;
                }
            }
            else {
                result = extA ? 1 : -1;
            }
            return result;
        });
    }
    function createDistributedTraceContext(parentCtx) {
        var trace = {};
        return {
            getName: function () {
                return trace[_DYN_NAME$3 ];
            },
            setName: function (newValue) {
                parentCtx && parentCtx.setName(newValue);
                trace[_DYN_NAME$3 ] = newValue;
            },
            getTraceId: function () {
                return trace[_DYN_TRACE_ID$2 ];
            },
            setTraceId: function (newValue) {
                parentCtx && parentCtx.setTraceId(newValue);
                if (isValidTraceId(newValue)) {
                    trace[_DYN_TRACE_ID$2 ] = newValue;
                }
            },
            getSpanId: function () {
                return trace[_DYN_SPAN_ID$1 ];
            },
            setSpanId: function (newValue) {
                parentCtx && parentCtx.setSpanId(newValue);
                if (isValidSpanId(newValue)) {
                    trace[_DYN_SPAN_ID$1 ] = newValue;
                }
            },
            getTraceFlags: function () {
                return trace[_DYN_TRACE_FLAGS$1 ];
            },
            setTraceFlags: function (newTraceFlags) {
                parentCtx && parentCtx.setTraceFlags(newTraceFlags);
                trace[_DYN_TRACE_FLAGS$1 ] = newTraceFlags;
            }
        };
    }

    var strTelemetryPluginChain = "TelemetryPluginChain";
    var strHasRunFlags = "_hasRun";
    var strGetTelCtx = "_getTelCtx";
    var _chainId = 0;
    function _getNextProxyStart(proxy, core, startAt) {
        while (proxy) {
            if (proxy[_DYN_GET_PLUGIN ]() === startAt) {
                return proxy;
            }
            proxy = proxy[_DYN_GET_NEXT ]();
        }
        return createTelemetryProxyChain([startAt], core[_DYN_CONFIG$2 ] || {}, core);
    }
    function _createInternalContext(telemetryChain, config, core, startAt) {
        var _nextProxy = null;
        var _onComplete = [];
        if (startAt !== null) {
            _nextProxy = startAt ? _getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
        }
        var context = {
            _next: _moveNext,
            ctx: {
                core: function () {
                    return core;
                },
                diagLog: function () {
                    return safeGetLogger(core, config);
                },
                getCfg: function () {
                    return config;
                },
                getExtCfg: _getExtCfg,
                getConfig: _getConfig,
                hasNext: function () {
                    return !!_nextProxy;
                },
                getNext: function () {
                    return _nextProxy;
                },
                setNext: function (nextPlugin) {
                    _nextProxy = nextPlugin;
                },
                iterate: _iterateChain,
                onComplete: _addOnComplete
            }
        };
        function _addOnComplete(onComplete, that) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            if (onComplete) {
                _onComplete[_DYN_PUSH$2 ]({
                    func: onComplete,
                    self: !isUndefined(that) ? that : context.ctx,
                    args: args
                });
            }
        }
        function _moveNext() {
            var nextProxy = _nextProxy;
            _nextProxy = nextProxy ? nextProxy[_DYN_GET_NEXT ]() : null;
            if (!nextProxy) {
                var onComplete = _onComplete;
                if (onComplete && onComplete[_DYN_LENGTH$5 ] > 0) {
                    arrForEach(onComplete, function (completeDetails) {
                        try {
                            completeDetails.func[_DYN_CALL ](completeDetails.self, completeDetails.args);
                        }
                        catch (e) {
                            _throwInternal(core[_DYN_LOGGER ], 2 , 73 , "Unexpected Exception during onComplete - " + dumpObj(e));
                        }
                    });
                    _onComplete = [];
                }
            }
            return nextProxy;
        }
        function _getExtCfg(identifier, defaultValue, mergeDefault) {
            if (defaultValue === void 0) { defaultValue = {}; }
            if (mergeDefault === void 0) { mergeDefault = 0 ; }
            var theConfig;
            if (config) {
                var extConfig = config[STR_EXTENSION_CONFIG ];
                if (extConfig && identifier) {
                    theConfig = extConfig[identifier];
                }
            }
            if (!theConfig) {
                theConfig = defaultValue;
            }
            else if (isObject(defaultValue)) {
                if (mergeDefault !== 0 ) {
                    var newConfig_1 = objExtend(true, defaultValue, theConfig);
                    if (config && mergeDefault === 2 ) {
                        objForEachKey(defaultValue, function (field) {
                            if (isNullOrUndefined(newConfig_1[field])) {
                                var cfgValue = config[field];
                                if (!isNullOrUndefined(cfgValue)) {
                                    newConfig_1[field] = cfgValue;
                                }
                            }
                        });
                    }
                    theConfig = newConfig_1;
                }
            }
            return theConfig;
        }
        function _getConfig(identifier, field, defaultValue) {
            if (defaultValue === void 0) { defaultValue = false; }
            var theValue;
            var extConfig = _getExtCfg(identifier, null);
            if (extConfig && !isNullOrUndefined(extConfig[field])) {
                theValue = extConfig[field];
            }
            else if (config && !isNullOrUndefined(config[field])) {
                theValue = config[field];
            }
            return !isNullOrUndefined(theValue) ? theValue : defaultValue;
        }
        function _iterateChain(cb) {
            var nextPlugin;
            while (!!(nextPlugin = context._next())) {
                var plugin = nextPlugin[_DYN_GET_PLUGIN ]();
                if (plugin) {
                    cb(plugin);
                }
            }
        }
        return context;
    }
    function createProcessTelemetryContext(telemetryChain, config, core, startAt) {
        var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
        var context = internalContext.ctx;
        function _processNext(env) {
            var nextPlugin = internalContext._next();
            nextPlugin && nextPlugin[STR_PROCESS_TELEMETRY ](env, context);
            return !nextPlugin;
        }
        function _createNew(plugins, startAt) {
            if (plugins === void 0) { plugins = null; }
            if (isArray(plugins)) {
                plugins = createTelemetryProxyChain(plugins, config, core, startAt);
            }
            return createProcessTelemetryContext(plugins || context[_DYN_GET_NEXT ](), config, core, startAt);
        }
        context[_DYN_PROCESS_NEXT ] = _processNext;
        context[_DYN_CREATE_NEW ] = _createNew;
        return context;
    }
    function createProcessTelemetryUnloadContext(telemetryChain, core, startAt) {
        var config = core[_DYN_CONFIG$2 ] || {};
        var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
        var context = internalContext.ctx;
        function _processNext(unloadState) {
            var nextPlugin = internalContext._next();
            nextPlugin && nextPlugin.unload(context, unloadState);
            return !nextPlugin;
        }
        function _createNew(plugins, startAt) {
            if (plugins === void 0) { plugins = null; }
            if (isArray(plugins)) {
                plugins = createTelemetryProxyChain(plugins, config, core, startAt);
            }
            return createProcessTelemetryUnloadContext(plugins || context[_DYN_GET_NEXT ](), core, startAt);
        }
        context[_DYN_PROCESS_NEXT ] = _processNext;
        context[_DYN_CREATE_NEW ] = _createNew;
        return context;
    }
    function createProcessTelemetryUpdateContext(telemetryChain, core, startAt) {
        var config = core[_DYN_CONFIG$2 ] || {};
        var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
        var context = internalContext.ctx;
        function _processNext(updateState) {
            return context.iterate(function (plugin) {
                if (isFunction(plugin[_DYN_UPDATE$1 ])) {
                    plugin[_DYN_UPDATE$1 ](context, updateState);
                }
            });
        }
        function _createNew(plugins, startAt) {
            if (plugins === void 0) { plugins = null; }
            if (isArray(plugins)) {
                plugins = createTelemetryProxyChain(plugins, config, core, startAt);
            }
            return createProcessTelemetryUpdateContext(plugins || context[_DYN_GET_NEXT ](), core, startAt);
        }
        context[_DYN_PROCESS_NEXT ] = _processNext;
        context[_DYN_CREATE_NEW ] = _createNew;
        return context;
    }
    function createTelemetryProxyChain(plugins, config, core, startAt) {
        var firstProxy = null;
        var add = startAt ? false : true;
        if (isArray(plugins) && plugins[_DYN_LENGTH$5 ] > 0) {
            var lastProxy_1 = null;
            arrForEach(plugins, function (thePlugin) {
                if (!add && startAt === thePlugin) {
                    add = true;
                }
                if (add && thePlugin && isFunction(thePlugin[STR_PROCESS_TELEMETRY ])) {
                    var newProxy = createTelemetryPluginProxy(thePlugin, config, core);
                    if (!firstProxy) {
                        firstProxy = newProxy;
                    }
                    if (lastProxy_1) {
                        lastProxy_1._setNext(newProxy);
                    }
                    lastProxy_1 = newProxy;
                }
            });
        }
        if (startAt && !firstProxy) {
            return createTelemetryProxyChain([startAt], config, core);
        }
        return firstProxy;
    }
    function createTelemetryPluginProxy(plugin, config, core) {
        var nextProxy = null;
        var hasProcessTelemetry = isFunction(plugin[STR_PROCESS_TELEMETRY ]);
        var hasSetNext = isFunction(plugin[_DYN_SET_NEXT_PLUGIN ]);
        var chainId;
        if (plugin) {
            chainId = plugin[_DYN_IDENTIFIER ] + "-" + plugin[STR_PRIORITY ] + "-" + _chainId++;
        }
        else {
            chainId = "Unknown-0-" + _chainId++;
        }
        var proxyChain = {
            getPlugin: function () {
                return plugin;
            },
            getNext: function () {
                return nextProxy;
            },
            processTelemetry: _processTelemetry,
            unload: _unloadPlugin,
            update: _updatePlugin,
            _id: chainId,
            _setNext: function (nextPlugin) {
                nextProxy = nextPlugin;
            }
        };
        function _getTelCtx() {
            var itemCtx;
            if (plugin && isFunction(plugin[strGetTelCtx])) {
                itemCtx = plugin[strGetTelCtx]();
            }
            if (!itemCtx) {
                itemCtx = createProcessTelemetryContext(proxyChain, config, core);
            }
            return itemCtx;
        }
        function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
            var hasRun = false;
            var identifier = plugin ? plugin[_DYN_IDENTIFIER ] : strTelemetryPluginChain;
            var hasRunContext = itemCtx[strHasRunFlags];
            if (!hasRunContext) {
                hasRunContext = itemCtx[strHasRunFlags] = {};
            }
            itemCtx.setNext(nextProxy);
            if (plugin) {
                doPerf(itemCtx[STR_CORE ](), function () { return identifier + ":" + name; }, function () {
                    hasRunContext[chainId] = true;
                    try {
                        var nextId = nextProxy ? nextProxy._id : STR_EMPTY;
                        if (nextId) {
                            hasRunContext[nextId] = false;
                        }
                        hasRun = processPluginFn(itemCtx);
                    }
                    catch (error) {
                        var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                        if (hasNextRun) {
                            hasRun = true;
                        }
                        if (!nextProxy || !hasNextRun) {
                            _throwInternal(itemCtx[_DYN_DIAG_LOG$2 ](), 1 , 73 , "Plugin [" + identifier + "] failed during " + name + " - " + dumpObj(error) + ", run flags: " + dumpObj(hasRunContext));
                        }
                    }
                }, details, isAsync);
            }
            return hasRun;
        }
        function _processTelemetry(env, itemCtx) {
            itemCtx = itemCtx || _getTelCtx();
            function _callProcessTelemetry(itemCtx) {
                if (!plugin || !hasProcessTelemetry) {
                    return false;
                }
                var pluginState = _getPluginState(plugin);
                if (pluginState[_DYN_TEARDOWN ] || pluginState[STR_DISABLED]) {
                    return false;
                }
                if (hasSetNext) {
                    plugin[_DYN_SET_NEXT_PLUGIN ](nextProxy);
                }
                plugin[STR_PROCESS_TELEMETRY ](env, itemCtx);
                return true;
            }
            if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function () { return ({ item: env }); }, !(env.sync))) {
                itemCtx[_DYN_PROCESS_NEXT ](env);
            }
        }
        function _unloadPlugin(unloadCtx, unloadState) {
            function _callTeardown() {
                var hasRun = false;
                if (plugin) {
                    var pluginState = _getPluginState(plugin);
                    var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE ];
                    if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[_DYN_TEARDOWN ]) {
                        pluginState[STR_CORE ] = null;
                        pluginState[_DYN_TEARDOWN ] = true;
                        pluginState[_DYN_IS_INITIALIZED ] = false;
                        if (plugin[_DYN_TEARDOWN ] && plugin[_DYN_TEARDOWN ](unloadCtx, unloadState) === true) {
                            hasRun = true;
                        }
                    }
                }
                return hasRun;
            }
            if (!_processChain(unloadCtx, _callTeardown, "unload", function () { }, unloadState[_DYN_IS_ASYNC ])) {
                unloadCtx[_DYN_PROCESS_NEXT ](unloadState);
            }
        }
        function _updatePlugin(updateCtx, updateState) {
            function _callUpdate() {
                var hasRun = false;
                if (plugin) {
                    var pluginState = _getPluginState(plugin);
                    var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE ];
                    if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[_DYN_TEARDOWN ]) {
                        if (plugin[_DYN_UPDATE$1 ] && plugin[_DYN_UPDATE$1 ](updateCtx, updateState) === true) {
                            hasRun = true;
                        }
                    }
                }
                return hasRun;
            }
            if (!_processChain(updateCtx, _callUpdate, "update", function () { }, false)) {
                updateCtx[_DYN_PROCESS_NEXT ](updateState);
            }
        }
        return objFreeze(proxyChain);
    }

    var ChannelControllerPriority = 500;
    var ChannelValidationMessage = "Channel has invalid priority - ";
    function _addChannelQueue(channelQueue, queue, core) {
        if (queue && isArray(queue) && queue[_DYN_LENGTH$5 ] > 0) {
            queue = queue.sort(function (a, b) {
                return a[STR_PRIORITY ] - b[STR_PRIORITY ];
            });
            arrForEach(queue, function (queueItem) {
                if (queueItem[STR_PRIORITY ] < ChannelControllerPriority) {
                    throwError(ChannelValidationMessage + queueItem[_DYN_IDENTIFIER ]);
                }
            });
            channelQueue[_DYN_PUSH$2 ]({
                queue: objFreeze(queue),
                chain: createTelemetryProxyChain(queue, core[_DYN_CONFIG$2 ], core)
            });
        }
    }
    function createChannelControllerPlugin(channelQueue, core) {
        function _getTelCtx() {
            return createProcessTelemetryContext(null, core[_DYN_CONFIG$2 ], core, null);
        }
        function _processChannelQueue(theChannels, itemCtx, processFn, onComplete) {
            var waiting = theChannels ? (theChannels[_DYN_LENGTH$5 ] + 1) : 1;
            function _runChainOnComplete() {
                waiting--;
                if (waiting === 0) {
                    onComplete && onComplete();
                    onComplete = null;
                }
            }
            if (waiting > 0) {
                arrForEach(theChannels, function (channels) {
                    if (channels && channels.queue[_DYN_LENGTH$5 ] > 0) {
                        var channelChain = channels.chain;
                        var chainCtx = itemCtx[_DYN_CREATE_NEW ](channelChain);
                        chainCtx[_DYN_ON_COMPLETE ](_runChainOnComplete);
                        processFn(chainCtx);
                    }
                    else {
                        waiting--;
                    }
                });
            }
            _runChainOnComplete();
        }
        function _doUpdate(updateCtx, updateState) {
            var theUpdateState = updateState || {
                reason: 0
            };
            _processChannelQueue(channelQueue, updateCtx, function (chainCtx) {
                chainCtx[_DYN_PROCESS_NEXT ](theUpdateState);
            }, function () {
                updateCtx[_DYN_PROCESS_NEXT ](theUpdateState);
            });
            return true;
        }
        function _doTeardown(unloadCtx, unloadState) {
            var theUnloadState = unloadState || {
                reason: 0 ,
                isAsync: false
            };
            _processChannelQueue(channelQueue, unloadCtx, function (chainCtx) {
                chainCtx[_DYN_PROCESS_NEXT ](theUnloadState);
            }, function () {
                unloadCtx[_DYN_PROCESS_NEXT ](theUnloadState);
                isInitialized = false;
            });
            return true;
        }
        function _getChannel(pluginIdentifier) {
            var thePlugin = null;
            if (channelQueue && channelQueue[_DYN_LENGTH$5 ] > 0) {
                arrForEach(channelQueue, function (channels) {
                    if (channels && channels.queue[_DYN_LENGTH$5 ] > 0) {
                        arrForEach(channels.queue, function (ext) {
                            if (ext[_DYN_IDENTIFIER ] === pluginIdentifier) {
                                thePlugin = ext;
                                return -1;
                            }
                        });
                        if (thePlugin) {
                            return -1;
                        }
                    }
                });
            }
            return thePlugin;
        }
        var isInitialized = false;
        var channelController = {
            identifier: "ChannelControllerPlugin",
            priority: ChannelControllerPriority,
            initialize: function (config, core, extensions, pluginChain) {
                isInitialized = true;
                arrForEach(channelQueue, function (channels) {
                    if (channels && channels.queue[_DYN_LENGTH$5 ] > 0) {
                        initializePlugins(createProcessTelemetryContext(channels.chain, config, core), extensions);
                    }
                });
            },
            isInitialized: function () {
                return isInitialized;
            },
            processTelemetry: function (item, itemCtx) {
                _processChannelQueue(channelQueue, itemCtx || _getTelCtx(), function (chainCtx) {
                    chainCtx[_DYN_PROCESS_NEXT ](item);
                }, function () {
                    itemCtx[_DYN_PROCESS_NEXT ](item);
                });
            },
            update: _doUpdate,
            pause: function () {
                _processChannelQueue(channelQueue, _getTelCtx(), function (chainCtx) {
                    chainCtx.iterate(function (plugin) {
                        plugin.pause && plugin.pause();
                    });
                }, null);
            },
            resume: function () {
                _processChannelQueue(channelQueue, _getTelCtx(), function (chainCtx) {
                    chainCtx.iterate(function (plugin) {
                        plugin.resume && plugin.resume();
                    });
                }, null);
            },
            teardown: _doTeardown,
            getChannel: _getChannel,
            flush: function (isAsync, callBack, sendReason, cbTimeout) {
                var waiting = 1;
                var doneIterating = false;
                var cbTimer = null;
                cbTimeout = cbTimeout || 5000;
                function doCallback() {
                    waiting--;
                    if (doneIterating && waiting === 0) {
                        if (cbTimer) {
                            clearTimeout(cbTimer);
                            cbTimer = null;
                        }
                        callBack && callBack(doneIterating);
                        callBack = null;
                    }
                }
                _processChannelQueue(channelQueue, _getTelCtx(), function (chainCtx) {
                    chainCtx.iterate(function (plugin) {
                        if (plugin[_DYN_FLUSH ]) {
                            waiting++;
                            var handled_1 = false;
                            if (!plugin[_DYN_FLUSH ](isAsync, function () {
                                handled_1 = true;
                                doCallback();
                            }, sendReason)) {
                                if (!handled_1) {
                                    if (isAsync && cbTimer == null) {
                                        cbTimer = setTimeout(function () {
                                            cbTimer = null;
                                            doCallback();
                                        }, cbTimeout);
                                    }
                                    else {
                                        doCallback();
                                    }
                                }
                            }
                        }
                    });
                }, function () {
                    doneIterating = true;
                    doCallback();
                });
                return true;
            },
            _setQueue: function (queue) {
                channelQueue = queue;
            }
        };
        return channelController;
    }
    function createChannelQueues(channels, extensions, core) {
        var channelQueue = [];
        if (channels) {
            arrForEach(channels, function (queue) { return _addChannelQueue(channelQueue, queue, core); });
        }
        if (extensions) {
            var extensionQueue_1 = [];
            arrForEach(extensions, function (plugin) {
                if (plugin[STR_PRIORITY ] > ChannelControllerPriority) {
                    extensionQueue_1[_DYN_PUSH$2 ](plugin);
                }
            });
            _addChannelQueue(channelQueue, extensionQueue_1, core);
        }
        return channelQueue;
    }

    function createUnloadHandlerContainer() {
        var handlers = [];
        function _addHandler(handler) {
            if (handler) {
                handlers[_DYN_PUSH$2 ](handler);
            }
        }
        function _runHandlers(unloadCtx, unloadState) {
            arrForEach(handlers, function (handler) {
                try {
                    handler(unloadCtx, unloadState);
                }
                catch (e) {
                    _throwInternal(unloadCtx[_DYN_DIAG_LOG$2 ](), 2 , 73 , "Unexpected error calling unload handler - " + dumpObj(e));
                }
            });
            handlers = [];
        }
        return {
            add: _addHandler,
            run: _runHandlers
        };
    }

    var strGetPlugin = "getPlugin";
    var BaseTelemetryPlugin = /** @class */ (function () {
        function BaseTelemetryPlugin() {
            var _self = this;
            var _isinitialized;
            var _rootCtx;
            var _nextPlugin;
            var _unloadHandlerContainer;
            var _hooks;
            _initDefaults();
            dynamicProto(BaseTelemetryPlugin, _self, function (_self) {
                _self[_DYN_INITIALIZE ] = function (config, core, extensions, pluginChain) {
                    _setDefaults(config, core, pluginChain);
                    _isinitialized = true;
                };
                _self[_DYN_TEARDOWN ] = function (unloadCtx, unloadState) {
                    var _a;
                    var core = _self[STR_CORE ];
                    if (!core || (unloadCtx && core !== unloadCtx[STR_CORE ]())) {
                        return;
                    }
                    var result;
                    var unloadDone = false;
                    var theUnloadCtx = unloadCtx || createProcessTelemetryUnloadContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                    var theUnloadState = unloadState || (_a = {
                            reason: 0
                        },
                        _a[_DYN_IS_ASYNC ] = false,
                        _a);
                    function _unloadCallback() {
                        if (!unloadDone) {
                            unloadDone = true;
                            _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                            var oldHooks = _hooks;
                            _hooks = [];
                            arrForEach(oldHooks, function (fn) {
                                fn.rm();
                            });
                            if (result === true) {
                                theUnloadCtx[_DYN_PROCESS_NEXT ](theUnloadState);
                            }
                            _initDefaults();
                        }
                    }
                    if (!_self[_DYN__DO_TEARDOWN ] || _self[_DYN__DO_TEARDOWN ](theUnloadCtx, theUnloadState, _unloadCallback) !== true) {
                        _unloadCallback();
                    }
                    else {
                        result = true;
                    }
                    return result;
                };
                _self[_DYN_UPDATE$1 ] = function (updateCtx, updateState) {
                    var core = _self[STR_CORE ];
                    if (!core || (updateCtx && core !== updateCtx[STR_CORE ]())) {
                        return;
                    }
                    var result;
                    var updateDone = false;
                    var theUpdateCtx = updateCtx || createProcessTelemetryUpdateContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                    var theUpdateState = updateState || {
                        reason: 0
                    };
                    function _updateCallback() {
                        if (!updateDone) {
                            updateDone = true;
                            _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[_DYN_GET_NEXT ]());
                        }
                    }
                    if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) {
                        _updateCallback();
                    }
                    else {
                        result = true;
                    }
                    return result;
                };
                _self._addHook = function (hooks) {
                    if (hooks) {
                        if (isArray(hooks)) {
                            _hooks = _hooks.concat(hooks);
                        }
                        else {
                            _hooks[_DYN_PUSH$2 ](hooks);
                        }
                    }
                };
                proxyFunctionAs(_self, "_addUnloadCb", function () { return _unloadHandlerContainer; }, "add");
            });
            _self[_DYN_DIAG_LOG$2 ] = function (itemCtx) {
                return _getTelCtx(itemCtx)[_DYN_DIAG_LOG$2 ]();
            };
            _self[_DYN_IS_INITIALIZED ] = function () {
                return _isinitialized;
            };
            _self.setInitialized = function (isInitialized) {
                _isinitialized = isInitialized;
            };
            _self[_DYN_SET_NEXT_PLUGIN ] = function (next) {
                _nextPlugin = next;
            };
            _self[_DYN_PROCESS_NEXT ] = function (env, itemCtx) {
                if (itemCtx) {
                    itemCtx[_DYN_PROCESS_NEXT ](env);
                }
                else if (_nextPlugin && isFunction(_nextPlugin[STR_PROCESS_TELEMETRY ])) {
                    _nextPlugin[STR_PROCESS_TELEMETRY ](env, null);
                }
            };
            _self._getTelCtx = _getTelCtx;
            function _getTelCtx(currentCtx) {
                if (currentCtx === void 0) { currentCtx = null; }
                var itemCtx = currentCtx;
                if (!itemCtx) {
                    var rootCtx = _rootCtx || createProcessTelemetryContext(null, {}, _self[STR_CORE ]);
                    if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                        itemCtx = rootCtx[_DYN_CREATE_NEW ](null, _nextPlugin[strGetPlugin]);
                    }
                    else {
                        itemCtx = rootCtx[_DYN_CREATE_NEW ](null, _nextPlugin);
                    }
                }
                return itemCtx;
            }
            function _setDefaults(config, core, pluginChain) {
                if (config) {
                    setValue(config, STR_EXTENSION_CONFIG, [], null, isNullOrUndefined);
                }
                if (!pluginChain && core) {
                    pluginChain = core[_DYN_GET_PROCESS_TEL_CONT0 ]()[_DYN_GET_NEXT ]();
                }
                var nextPlugin = _nextPlugin;
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    nextPlugin = _nextPlugin[strGetPlugin]();
                }
                _self[STR_CORE ] = core;
                _rootCtx = createProcessTelemetryContext(pluginChain, config, core, nextPlugin);
            }
            function _initDefaults() {
                _isinitialized = false;
                _self[STR_CORE ] = null;
                _rootCtx = null;
                _nextPlugin = null;
                _hooks = [];
                _unloadHandlerContainer = createUnloadHandlerContainer();
            }
        }
        BaseTelemetryPlugin.__ieDyn=1;
        return BaseTelemetryPlugin;
    }());

    var TelemetryInitializerPlugin = /** @class */ (function (_super) {
        __extendsFn(TelemetryInitializerPlugin, _super);
        function TelemetryInitializerPlugin() {
            var _this = _super.call(this) || this;
            _this.identifier = "TelemetryInitializerPlugin";
            _this.priority = 199;
            var _id;
            var _initializers;
            _initDefaults();
            dynamicProto(TelemetryInitializerPlugin, _this, function (_self, _base) {
                _self.addTelemetryInitializer = function (telemetryInitializer) {
                    var theInitializer = {
                        id: _id++,
                        fn: telemetryInitializer
                    };
                    _initializers[_DYN_PUSH$2 ](theInitializer);
                    var handler = {
                        remove: function () {
                            arrForEach(_initializers, function (initializer, idx) {
                                if (initializer.id === theInitializer.id) {
                                    _initializers[_DYN_SPLICE ](idx, 1);
                                    return -1;
                                }
                            });
                        }
                    };
                    return handler;
                };
                _self[STR_PROCESS_TELEMETRY ] = function (item, itemCtx) {
                    var doNotSendItem = false;
                    var telemetryInitializersCount = _initializers[_DYN_LENGTH$5 ];
                    for (var i = 0; i < telemetryInitializersCount; ++i) {
                        var telemetryInitializer = _initializers[i];
                        if (telemetryInitializer) {
                            try {
                                if (telemetryInitializer.fn[_DYN_APPLY ](null, [item]) === false) {
                                    doNotSendItem = true;
                                    break;
                                }
                            }
                            catch (e) {
                                _throwInternal(itemCtx[_DYN_DIAG_LOG$2 ](), 1 , 64 , "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), { exception: dumpObj(e) }, true);
                            }
                        }
                    }
                    if (!doNotSendItem) {
                        _self[_DYN_PROCESS_NEXT ](item, itemCtx);
                    }
                };
                _self[_DYN__DO_TEARDOWN ] = function () {
                    _initDefaults();
                };
            });
            function _initDefaults() {
                _id = 0;
                _initializers = [];
            }
            return _this;
        }
        TelemetryInitializerPlugin.__ieDyn=1;
        return TelemetryInitializerPlugin;
    }(BaseTelemetryPlugin));

    var strValidationError = "Plugins must provide initialize method";
    var strNotificationManager = "_notificationManager";
    var strSdkUnloadingError = "SDK is still unloading...";
    var strSdkNotInitialized = "SDK is not initialized";
    var defaultInitConfig = {
        loggingLevelConsole: 1
    };
    function _createPerfManager(core, notificationMgr) {
        return new PerfManager(notificationMgr);
    }
    function _validateExtensions(logger, channelPriority, allExtensions) {
        var _a;
        var coreExtensions = [];
        var extPriorities = {};
        arrForEach(allExtensions, function (ext) {
            if (isNullOrUndefined(ext) || isNullOrUndefined(ext[_DYN_INITIALIZE ])) {
                throwError(strValidationError);
            }
            var extPriority = ext[STR_PRIORITY ];
            var identifier = ext[_DYN_IDENTIFIER ];
            if (ext && extPriority) {
                if (!isNullOrUndefined(extPriorities[extPriority])) {
                    _warnToConsole(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
                }
                else {
                    extPriorities[extPriority] = identifier;
                }
            }
            if (!extPriority || extPriority < channelPriority) {
                coreExtensions[_DYN_PUSH$2 ](ext);
            }
        });
        return _a = {
                all: allExtensions
            },
            _a[STR_CORE ] = coreExtensions,
            _a;
    }
    function _isPluginPresent(thePlugin, plugins) {
        var exists = false;
        arrForEach(plugins, function (plugin) {
            if (plugin === thePlugin) {
                exists = true;
                return -1;
            }
        });
        return exists;
    }
    function _createDummyNotificationManager() {
        var _a;
        return objCreateFn((_a = {},
            _a[_DYN_ADD_NOTIFICATION_LIS1 ] = function (listener) { },
            _a[_DYN_REMOVE_NOTIFICATION_2 ] = function (listener) { },
            _a[STR_EVENTS_SENT ] = function (events) { },
            _a[STR_EVENTS_DISCARDED ] = function (events, reason) { },
            _a[STR_EVENTS_SEND_REQUEST ] = function (sendReason, isAsync) { },
            _a));
    }
    var BaseCore = /** @class */ (function () {
        function BaseCore() {
            var _config;
            var _isInitialized;
            var _eventQueue;
            var _notificationManager;
            var _perfManager;
            var _cfgPerfManager;
            var _cookieManager;
            var _pluginChain;
            var _configExtensions;
            var _coreExtensions;
            var _channelControl;
            var _channelConfig;
            var _channelQueue;
            var _isUnloading;
            var _telemetryInitializerPlugin;
            var _internalLogsEventName;
            var _evtNamespace;
            var _unloadHandlers;
            var _debugListener;
            var _traceCtx;
            var _internalLogPoller = 0;
            var _forceStopInternalLogPoller = false;
            dynamicProto(BaseCore, this, function (_self) {
                _initDefaults();
                _self[_DYN_IS_INITIALIZED ] = function () { return _isInitialized; };
                _self[_DYN_INITIALIZE ] = function (config, extensions, logger, notificationManager) {
                    if (_isUnloading) {
                        throwError(strSdkUnloadingError);
                    }
                    if (_self[_DYN_IS_INITIALIZED ]()) {
                        throwError("Core should not be initialized more than once");
                    }
                    _config = config || {};
                    _self[_DYN_CONFIG$2 ] = _config;
                    if (isNullOrUndefined(config[_DYN_INSTRUMENTATION_KEY$2 ])) {
                        throwError("Please provide instrumentation key");
                    }
                    _notificationManager = notificationManager;
                    _self[strNotificationManager] = notificationManager;
                    _initDebugListener();
                    _initPerfManager();
                    _initExtConfig();
                    if (logger) {
                        _self[_DYN_LOGGER ] = logger;
                    }
                    var cfgExtensions = getSetValue(_config, STR_EXTENSIONS, []);
                    _configExtensions = [];
                    _configExtensions[_DYN_PUSH$2 ].apply(_configExtensions, __spreadArrayFn(__spreadArrayFn([], extensions, false), cfgExtensions));
                    _channelConfig = getSetValue(_config, STR_CHANNELS, []);
                    _initPluginChain(null);
                    if (!_channelQueue || _channelQueue[_DYN_LENGTH$5 ] === 0) {
                        throwError("No " + STR_CHANNELS + " available");
                    }
                    _isInitialized = true;
                    _self.releaseQueue();
                };
                _self.getTransmissionControls = function () {
                    var controls = [];
                    if (_channelQueue) {
                        arrForEach(_channelQueue, function (channels) {
                            controls[_DYN_PUSH$2 ](channels.queue);
                        });
                    }
                    return objFreeze(controls);
                };
                _self.track = function (telemetryItem) {
                    telemetryItem.iKey = telemetryItem.iKey || _config[_DYN_INSTRUMENTATION_KEY$2 ];
                    telemetryItem[_DYN_TIME ] = telemetryItem[_DYN_TIME ] || toISOString(new Date());
                    telemetryItem.ver = telemetryItem.ver || "4.0";
                    if (!_isUnloading && _self[_DYN_IS_INITIALIZED ]()) {
                        _createTelCtx()[_DYN_PROCESS_NEXT ](telemetryItem);
                    }
                    else {
                        _eventQueue[_DYN_PUSH$2 ](telemetryItem);
                    }
                };
                _self[_DYN_GET_PROCESS_TEL_CONT0 ] = _createTelCtx;
                _self[_DYN_GET_NOTIFY_MGR ] = function () {
                    if (!_notificationManager) {
                        _notificationManager = _createDummyNotificationManager();
                        _self[strNotificationManager] = _notificationManager;
                    }
                    return _notificationManager;
                };
                _self[_DYN_ADD_NOTIFICATION_LIS1 ] = function (listener) {
                    if (_notificationManager) {
                        _notificationManager[_DYN_ADD_NOTIFICATION_LIS1 ](listener);
                    }
                };
                _self[_DYN_REMOVE_NOTIFICATION_2 ] = function (listener) {
                    if (_notificationManager) {
                        _notificationManager[_DYN_REMOVE_NOTIFICATION_2 ](listener);
                    }
                };
                _self.getCookieMgr = function () {
                    if (!_cookieManager) {
                        _cookieManager = createCookieMgr(_config, _self[_DYN_LOGGER ]);
                    }
                    return _cookieManager;
                };
                _self.setCookieMgr = function (cookieMgr) {
                    _cookieManager = cookieMgr;
                };
                _self[STR_GET_PERF_MGR ] = function () {
                    if (!_perfManager && !_cfgPerfManager) {
                        if (getCfgValue(_config.enablePerfMgr)) {
                            var createPerfMgr = getCfgValue(_config[STR_CREATE_PERF_MGR ]);
                            if (isFunction(createPerfMgr)) {
                                _cfgPerfManager = createPerfMgr(_self, _self[_DYN_GET_NOTIFY_MGR ]());
                            }
                        }
                    }
                    return _perfManager || _cfgPerfManager || getGblPerfMgr();
                };
                _self.setPerfMgr = function (perfMgr) {
                    _perfManager = perfMgr;
                };
                _self.eventCnt = function () {
                    return _eventQueue[_DYN_LENGTH$5 ];
                };
                _self.releaseQueue = function () {
                    if (_isInitialized && _eventQueue[_DYN_LENGTH$5 ] > 0) {
                        var eventQueue = _eventQueue;
                        _eventQueue = [];
                        arrForEach(eventQueue, function (event) {
                            _createTelCtx()[_DYN_PROCESS_NEXT ](event);
                        });
                    }
                };
                _self.pollInternalLogs = function (eventName) {
                    _internalLogsEventName = eventName || null;
                    _forceStopInternalLogPoller = false;
                    if (_internalLogPoller) {
                        clearInterval(_internalLogPoller);
                        _internalLogPoller = null;
                    }
                    return _startInternalLogTimer(true);
                };
                function _startInternalLogTimer(alwaysStart) {
                    if (!_internalLogPoller && !_forceStopInternalLogPoller) {
                        var shouldStart = alwaysStart || (_self[_DYN_LOGGER ] && _self[_DYN_LOGGER ].queue[_DYN_LENGTH$5 ] > 0);
                        if (shouldStart) {
                            var interval = getCfgValue(_config.diagnosticLogInterval);
                            if (!interval || !(interval > 0)) {
                                interval = 10000;
                            }
                            _internalLogPoller = setInterval(function () {
                                clearInterval(_internalLogPoller);
                                _internalLogPoller = 0;
                                _flushInternalLogs();
                            }, interval);
                        }
                    }
                    return _internalLogPoller;
                }
                _self[_DYN_STOP_POLLING_INTERNA3 ] = function () {
                    _forceStopInternalLogPoller = true;
                    if (_internalLogPoller) {
                        clearInterval(_internalLogPoller);
                        _internalLogPoller = 0;
                        _flushInternalLogs();
                    }
                };
                proxyFunctions(_self, function () { return _telemetryInitializerPlugin; }, ["addTelemetryInitializer"]);
                _self.unload = function (isAsync, unloadComplete, cbTimeout) {
                    var _a;
                    if (isAsync === void 0) { isAsync = true; }
                    if (!_isInitialized) {
                        throwError(strSdkNotInitialized);
                    }
                    if (_isUnloading) {
                        throwError(strSdkUnloadingError);
                    }
                    var unloadState = (_a = {
                            reason: 50
                        },
                        _a[_DYN_IS_ASYNC ] = isAsync,
                        _a.flushComplete = false,
                        _a);
                    var processUnloadCtx = createProcessTelemetryUnloadContext(_getPluginChain(), _self);
                    processUnloadCtx[_DYN_ON_COMPLETE ](function () {
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    }, _self);
                    function _doUnload(flushComplete) {
                        unloadState.flushComplete = flushComplete;
                        _isUnloading = true;
                        _unloadHandlers.run(processUnloadCtx, unloadState);
                        _self[_DYN_STOP_POLLING_INTERNA3 ]();
                        processUnloadCtx[_DYN_PROCESS_NEXT ](unloadState);
                    }
                    _flushInternalLogs();
                    if (!_flushChannels(isAsync, _doUnload, 6 , cbTimeout)) {
                        _doUnload(false);
                    }
                };
                _self[_DYN_GET_PLUGIN ] = _getPlugin;
                _self.addPlugin = function (plugin, replaceExisting, isAsync, addCb) {
                    if (!plugin) {
                        addCb && addCb(false);
                        _logOrThrowError(strValidationError);
                        return;
                    }
                    var existingPlugin = _getPlugin(plugin[_DYN_IDENTIFIER ]);
                    if (existingPlugin && !replaceExisting) {
                        addCb && addCb(false);
                        _logOrThrowError("Plugin [" + plugin[_DYN_IDENTIFIER ] + "] is already loaded!");
                        return;
                    }
                    var updateState = {
                        reason: 16
                    };
                    function _addPlugin(removed) {
                        _configExtensions[_DYN_PUSH$2 ](plugin);
                        updateState.added = [plugin];
                        _initPluginChain(updateState);
                        addCb && addCb(true);
                    }
                    if (existingPlugin) {
                        var removedPlugins_1 = [existingPlugin.plugin];
                        var unloadState = {
                            reason: 2 ,
                            isAsync: !!isAsync
                        };
                        _removePlugins(removedPlugins_1, unloadState, function (removed) {
                            if (!removed) {
                                addCb && addCb(false);
                            }
                            else {
                                updateState.removed = removedPlugins_1;
                                updateState.reason |= 32 ;
                                _addPlugin();
                            }
                        });
                    }
                    else {
                        _addPlugin();
                    }
                };
                _self.evtNamespace = function () {
                    return _evtNamespace;
                };
                _self[_DYN_FLUSH ] = _flushChannels;
                _self.getTraceCtx = function (createNew) {
                    if (!_traceCtx) {
                        _traceCtx = createDistributedTraceContext();
                    }
                    return _traceCtx;
                };
                _self.setTraceCtx = function (traceCtx) {
                    _traceCtx = traceCtx || null;
                };
                proxyFunctionAs(_self, "addUnloadCb", function () { return _unloadHandlers; }, "add");
                function _initDefaults() {
                    _isInitialized = false;
                    _config = objExtend(true, {}, defaultInitConfig);
                    _self[_DYN_CONFIG$2 ] = _config;
                    _self[_DYN_LOGGER ] = new DiagnosticLogger(_config);
                    _self[_DYN__EXTENSIONS ] = [];
                    _telemetryInitializerPlugin = new TelemetryInitializerPlugin();
                    _eventQueue = [];
                    _notificationManager = null;
                    _perfManager = null;
                    _cfgPerfManager = null;
                    _cookieManager = null;
                    _pluginChain = null;
                    _coreExtensions = null;
                    _configExtensions = [];
                    _channelControl = null;
                    _channelConfig = null;
                    _channelQueue = null;
                    _isUnloading = false;
                    _internalLogsEventName = null;
                    _evtNamespace = createUniqueNamespace("AIBaseCore", true);
                    _unloadHandlers = createUnloadHandlerContainer();
                    _traceCtx = null;
                }
                function _createTelCtx() {
                    var theCtx = createProcessTelemetryContext(_getPluginChain(), _config, _self);
                    theCtx[_DYN_ON_COMPLETE ](_startInternalLogTimer);
                    return theCtx;
                }
                function _initPluginChain(updateState) {
                    var theExtensions = _validateExtensions(_self[_DYN_LOGGER ], ChannelControllerPriority, _configExtensions);
                    _coreExtensions = theExtensions[STR_CORE ];
                    _pluginChain = null;
                    var allExtensions = theExtensions.all;
                    _channelQueue = objFreeze(createChannelQueues(_channelConfig, allExtensions, _self));
                    if (_channelControl) {
                        var idx = arrIndexOf(allExtensions, _channelControl);
                        if (idx !== -1) {
                            allExtensions[_DYN_SPLICE ](idx, 1);
                        }
                        idx = arrIndexOf(_coreExtensions, _channelControl);
                        if (idx !== -1) {
                            _coreExtensions[_DYN_SPLICE ](idx, 1);
                        }
                        _channelControl._setQueue(_channelQueue);
                    }
                    else {
                        _channelControl = createChannelControllerPlugin(_channelQueue, _self);
                    }
                    allExtensions[_DYN_PUSH$2 ](_channelControl);
                    _coreExtensions[_DYN_PUSH$2 ](_channelControl);
                    _self[_DYN__EXTENSIONS ] = sortPlugins(allExtensions);
                    _channelControl[_DYN_INITIALIZE ](_config, _self, allExtensions);
                    var initCtx = _createTelCtx();
                    initializePlugins(initCtx, allExtensions);
                    _self[_DYN__EXTENSIONS ] = objFreeze(sortPlugins(_coreExtensions || [])).slice();
                    if (updateState) {
                        _doUpdate(updateState);
                    }
                }
                function _getPlugin(pluginIdentifier) {
                    var _a;
                    var theExt = null;
                    var thePlugin = null;
                    arrForEach(_self[_DYN__EXTENSIONS ], function (ext) {
                        if (ext[_DYN_IDENTIFIER ] === pluginIdentifier && ext !== _channelControl && ext !== _telemetryInitializerPlugin) {
                            thePlugin = ext;
                            return -1;
                        }
                    });
                    if (!thePlugin && _channelControl) {
                        thePlugin = _channelControl.getChannel(pluginIdentifier);
                    }
                    if (thePlugin) {
                        theExt = (_a = {
                                plugin: thePlugin
                            },
                            _a[_DYN_SET_ENABLED ] = function (enabled) {
                                _getPluginState(thePlugin)[STR_DISABLED] = !enabled;
                            },
                            _a.isEnabled = function () {
                                var pluginState = _getPluginState(thePlugin);
                                return !pluginState[_DYN_TEARDOWN ] && !pluginState[STR_DISABLED];
                            },
                            _a.remove = function (isAsync, removeCb) {
                                var _a;
                                if (isAsync === void 0) { isAsync = true; }
                                var pluginsToRemove = [thePlugin];
                                var unloadState = (_a = {
                                        reason: 1
                                    },
                                    _a[_DYN_IS_ASYNC ] = isAsync,
                                    _a);
                                _removePlugins(pluginsToRemove, unloadState, function (removed) {
                                    if (removed) {
                                        _initPluginChain({
                                            reason: 32 ,
                                            removed: pluginsToRemove
                                        });
                                    }
                                    removeCb && removeCb(removed);
                                });
                            },
                            _a);
                    }
                    return theExt;
                }
                function _getPluginChain() {
                    if (!_pluginChain) {
                        var extensions = (_coreExtensions || []).slice();
                        if (arrIndexOf(extensions, _telemetryInitializerPlugin) === -1) {
                            extensions[_DYN_PUSH$2 ](_telemetryInitializerPlugin);
                        }
                        _pluginChain = createTelemetryProxyChain(sortPlugins(extensions), _config, _self);
                    }
                    return _pluginChain;
                }
                function _removePlugins(thePlugins, unloadState, removeComplete) {
                    if (thePlugins && thePlugins[_DYN_LENGTH$5 ] > 0) {
                        var unloadChain = createTelemetryProxyChain(thePlugins, _config, _self);
                        var unloadCtx = createProcessTelemetryUnloadContext(unloadChain, _self);
                        unloadCtx[_DYN_ON_COMPLETE ](function () {
                            var removed = false;
                            var newConfigExtensions = [];
                            arrForEach(_configExtensions, function (plugin, idx) {
                                if (!_isPluginPresent(plugin, thePlugins)) {
                                    newConfigExtensions[_DYN_PUSH$2 ](plugin);
                                }
                                else {
                                    removed = true;
                                }
                            });
                            _configExtensions = newConfigExtensions;
                            var newChannelConfig = [];
                            if (_channelConfig) {
                                arrForEach(_channelConfig, function (queue, idx) {
                                    var newQueue = [];
                                    arrForEach(queue, function (channel) {
                                        if (!_isPluginPresent(channel, thePlugins)) {
                                            newQueue[_DYN_PUSH$2 ](channel);
                                        }
                                        else {
                                            removed = true;
                                        }
                                    });
                                    newChannelConfig[_DYN_PUSH$2 ](newQueue);
                                });
                                _channelConfig = newChannelConfig;
                            }
                            removeComplete && removeComplete(removed);
                            _startInternalLogTimer();
                        });
                        unloadCtx[_DYN_PROCESS_NEXT ](unloadState);
                    }
                    else {
                        removeComplete(false);
                    }
                }
                function _flushInternalLogs() {
                    if (_self[_DYN_LOGGER ] && _self[_DYN_LOGGER ].queue) {
                        var queue = _self[_DYN_LOGGER ].queue.slice(0);
                        _self[_DYN_LOGGER ].queue[_DYN_LENGTH$5 ] = 0;
                        arrForEach(queue, function (logMessage) {
                            var _a;
                            var item = (_a = {},
                                _a[_DYN_NAME$3 ] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[_DYN_MESSAGE_ID ],
                                _a.iKey = getCfgValue(_config[_DYN_INSTRUMENTATION_KEY$2 ]),
                                _a.time = toISOString(new Date()),
                                _a.baseType = _InternalLogMessage.dataType,
                                _a.baseData = { message: logMessage[_DYN_MESSAGE$2 ] },
                                _a);
                            _self.track(item);
                        });
                    }
                }
                function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                    if (_channelControl) {
                        return _channelControl[_DYN_FLUSH ](isAsync, callBack, sendReason || 6 , cbTimeout);
                    }
                    callBack && callBack(false);
                    return true;
                }
                function _initDebugListener() {
                    var disableDbgExt = getCfgValue(_config.disableDbgExt);
                    if (disableDbgExt === true && _debugListener) {
                        _notificationManager[_DYN_REMOVE_NOTIFICATION_2 ](_debugListener);
                        _debugListener = null;
                    }
                    if (_notificationManager && !_debugListener && disableDbgExt !== true) {
                        _debugListener = getDebugListener(_config);
                        _notificationManager[_DYN_ADD_NOTIFICATION_LIS1 ](_debugListener);
                    }
                }
                function _initPerfManager() {
                    var enablePerfMgr = getCfgValue(_config.enablePerfMgr);
                    if (!enablePerfMgr && _cfgPerfManager) {
                        _cfgPerfManager = null;
                    }
                    if (enablePerfMgr) {
                        getSetValue(_config, STR_CREATE_PERF_MGR, _createPerfManager);
                    }
                }
                function _initExtConfig() {
                    var extConfig = getSetValue(_config, STR_EXTENSION_CONFIG, {});
                    extConfig.NotificationManager = _notificationManager;
                }
                function _doUpdate(updateState) {
                    var updateCtx = createProcessTelemetryUpdateContext(_getPluginChain(), _self);
                    updateCtx[_DYN_ON_COMPLETE ](_startInternalLogTimer);
                    if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) {
                        updateCtx[_DYN_PROCESS_NEXT ](updateState);
                    }
                }
                function _logOrThrowError(message) {
                    var logger = _self[_DYN_LOGGER ];
                    if (logger) {
                        _throwInternal(logger, 2 , 73 , message);
                        _startInternalLogTimer();
                    }
                    else {
                        throwError(message);
                    }
                }
            });
        }
        BaseCore.__ieDyn=1;
        return BaseCore;
    }());

    function _runListeners(listeners, name, isAsync, callback) {
        arrForEach(listeners, function (listener) {
            if (listener && listener[name]) {
                if (isAsync) {
                    setTimeout(function () { return callback(listener); }, 0);
                }
                else {
                    try {
                        callback(listener);
                    }
                    catch (e) {
                    }
                }
            }
        });
    }
    var NotificationManager = /** @class */ (function () {
        function NotificationManager(config) {
            this.listeners = [];
            var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
            dynamicProto(NotificationManager, this, function (_self) {
                _self[_DYN_ADD_NOTIFICATION_LIS1 ] = function (listener) {
                    _self.listeners[_DYN_PUSH$2 ](listener);
                };
                _self[_DYN_REMOVE_NOTIFICATION_2 ] = function (listener) {
                    var index = arrIndexOf(_self[_DYN_LISTENERS ], listener);
                    while (index > -1) {
                        _self.listeners[_DYN_SPLICE ](index, 1);
                        index = arrIndexOf(_self[_DYN_LISTENERS ], listener);
                    }
                };
                _self[STR_EVENTS_SENT ] = function (events) {
                    _runListeners(_self[_DYN_LISTENERS ], STR_EVENTS_SENT, true, function (listener) {
                        listener[STR_EVENTS_SENT ](events);
                    });
                };
                _self[STR_EVENTS_DISCARDED ] = function (events, reason) {
                    _runListeners(_self[_DYN_LISTENERS ], STR_EVENTS_DISCARDED, true, function (listener) {
                        listener[STR_EVENTS_DISCARDED ](events, reason);
                    });
                };
                _self[STR_EVENTS_SEND_REQUEST ] = function (sendReason, isAsync) {
                    _runListeners(_self[_DYN_LISTENERS ], STR_EVENTS_SEND_REQUEST, isAsync, function (listener) {
                        listener[STR_EVENTS_SEND_REQUEST ](sendReason, isAsync);
                    });
                };
                _self[STR_PERF_EVENT ] = function (perfEvent) {
                    if (perfEvent) {
                        if (perfEvtsSendAll || !perfEvent[_DYN_IS_CHILD_EVT ]()) {
                            _runListeners(_self[_DYN_LISTENERS ], STR_PERF_EVENT, false, function (listener) {
                                if (perfEvent[_DYN_IS_ASYNC ]) {
                                    setTimeout(function () { return listener[STR_PERF_EVENT ](perfEvent); }, 0);
                                }
                                else {
                                    listener[STR_PERF_EVENT ](perfEvent);
                                }
                            });
                        }
                    }
                };
            });
        }
        NotificationManager.__ieDyn=1;
        return NotificationManager;
    }());

    var AppInsightsCore = /** @class */ (function (_super) {
        __extendsFn(AppInsightsCore, _super);
        function AppInsightsCore() {
            var _this = _super.call(this) || this;
            dynamicProto(AppInsightsCore, _this, function (_self, _base) {
                _self[_DYN_INITIALIZE ] = function (config, extensions, logger, notificationManager) {
                    _base[_DYN_INITIALIZE ](config, extensions, logger || new DiagnosticLogger(config), notificationManager || new NotificationManager(config));
                };
                _self.track = function (telemetryItem) {
                    doPerf(_self[STR_GET_PERF_MGR ](), function () { return "AppInsightsCore:track"; }, function () {
                        if (telemetryItem === null) {
                            _notifyInvalidEvent(telemetryItem);
                            throwError("Invalid telemetry item");
                        }
                        _validateTelemetryItem(telemetryItem);
                        _base.track(telemetryItem);
                    }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
                };
                function _validateTelemetryItem(telemetryItem) {
                    if (isNullOrUndefined(telemetryItem[_DYN_NAME$3 ])) {
                        _notifyInvalidEvent(telemetryItem);
                        throwError("telemetry name required");
                    }
                }
                function _notifyInvalidEvent(telemetryItem) {
                    var manager = _self[_DYN_GET_NOTIFY_MGR ]();
                    if (manager) {
                        manager[STR_EVENTS_DISCARDED ]([telemetryItem], 2 );
                    }
                }
            });
            return _this;
        }
        AppInsightsCore.__ieDyn=1;
        return AppInsightsCore;
    }(BaseCore));

    var _a$2;
    var FAILED = "Failed";
    var FAILED_MONITOR_AJAX = FAILED + "MonitorAjax";
    var TRACK = "Track";
    var START = "Start";
    var STOP = "Stop";
    var EVENT = "Event";
    var AUTH_CONTEXT = "AuthContext";
    var EXCEPTION = "Exception";
    var LOCAL = "Local";
    var SESSION = "Session";
    var STORAGE = "Storage";
    var BROWSER = "Browser";
    var CANNOT = "Cannot";
    var BUFFER = "Buffer";
    var INSTRUMENTATION_KEY = "InstrumentationKey";
    var LoggingSeverity = createEnumStyle({
        CRITICAL: 1 ,
        WARNING: 2
    });
    var _InternalMessageId = createEnumStyle((_a$2 = {},
        _a$2[BROWSER + "DoesNotSupport" + LOCAL + STORAGE] = 0 ,
        _a$2[BROWSER + CANNOT + "Read" + LOCAL + STORAGE] = 1 ,
        _a$2[BROWSER + CANNOT + "Read" + SESSION + STORAGE] = 2 ,
        _a$2[BROWSER + CANNOT + "Write" + LOCAL + STORAGE] = 3 ,
        _a$2[BROWSER + CANNOT + "Write" + SESSION + STORAGE] = 4 ,
        _a$2[BROWSER + FAILED + "RemovalFrom" + LOCAL + STORAGE] = 5 ,
        _a$2[BROWSER + FAILED + "RemovalFrom" + SESSION + STORAGE] = 6 ,
        _a$2[CANNOT + "SendEmptyTelemetry"] = 7 ,
        _a$2.ClientPerformanceMathError = 8 ,
        _a$2["ErrorParsingAI" + SESSION + "Cookie"] = 9 ,
        _a$2.ErrorPVCalc = 10 ,
        _a$2[EXCEPTION + "WhileLoggingError"] = 11 ,
        _a$2[FAILED + "AddingTelemetryTo" + BUFFER] = 12 ,
        _a$2[FAILED_MONITOR_AJAX + "Abort"] = 13 ,
        _a$2[FAILED_MONITOR_AJAX + "Dur"] = 14 ,
        _a$2[FAILED_MONITOR_AJAX + "Open"] = 15 ,
        _a$2[FAILED_MONITOR_AJAX + "RSC"] = 16 ,
        _a$2[FAILED_MONITOR_AJAX + "Send"] = 17 ,
        _a$2[FAILED_MONITOR_AJAX + "GetCorrelationHeader"] = 18 ,
        _a$2[FAILED + "ToAddHandlerForOnBeforeUnload"] = 19 ,
        _a$2[FAILED + "ToSendQueuedTelemetry"] = 20 ,
        _a$2[FAILED + "ToReportDataLoss"] = 21 ,
        _a$2["Flush" + FAILED] = 22 ,
        _a$2.MessageLimitPerPVExceeded = 23 ,
        _a$2.MissingRequiredFieldSpecification = 24 ,
        _a$2.NavigationTimingNotSupported = 25 ,
        _a$2.OnError = 26 ,
        _a$2[SESSION + "RenewalDateIsZero"] = 27 ,
        _a$2.SenderNotInitialized = 28 ,
        _a$2[START + TRACK + EVENT + FAILED] = 29 ,
        _a$2[STOP + TRACK + EVENT + FAILED] = 30 ,
        _a$2[START + TRACK + FAILED] = 31 ,
        _a$2[STOP + TRACK + FAILED] = 32 ,
        _a$2.TelemetrySampledAndNotSent = 33 ,
        _a$2[TRACK + EVENT + FAILED] = 34 ,
        _a$2[TRACK + EXCEPTION + FAILED] = 35 ,
        _a$2[TRACK + "Metric" + FAILED] = 36 ,
        _a$2[TRACK + "PV" + FAILED] = 37 ,
        _a$2[TRACK + "PV" + FAILED + "Calc"] = 38 ,
        _a$2[TRACK + "Trace" + FAILED] = 39 ,
        _a$2["Transmission" + FAILED] = 40 ,
        _a$2[FAILED + "ToSet" + STORAGE + BUFFER] = 41 ,
        _a$2[FAILED + "ToRestore" + STORAGE + BUFFER] = 42 ,
        _a$2.InvalidBackendResponse = 43 ,
        _a$2[FAILED + "ToFixDepricatedValues"] = 44 ,
        _a$2.InvalidDurationValue = 45 ,
        _a$2.TelemetryEnvelopeInvalid = 46 ,
        _a$2.CreateEnvelopeError = 47 ,
        _a$2[CANNOT + "SerializeObject"] = 48 ,
        _a$2[CANNOT + "SerializeObjectNonSerializable"] = 49 ,
        _a$2.CircularReferenceDetected = 50 ,
        _a$2["Clear" + AUTH_CONTEXT + FAILED] = 51 ,
        _a$2[EXCEPTION + "Truncated"] = 52 ,
        _a$2.IllegalCharsInName = 53 ,
        _a$2.ItemNotInArray = 54 ,
        _a$2.MaxAjaxPerPVExceeded = 55 ,
        _a$2.MessageTruncated = 56 ,
        _a$2.NameTooLong = 57 ,
        _a$2.SampleRateOutOfRange = 58 ,
        _a$2["Set" + AUTH_CONTEXT + FAILED] = 59 ,
        _a$2["Set" + AUTH_CONTEXT + FAILED + "AccountName"] = 60 ,
        _a$2.StringValueTooLong = 61 ,
        _a$2.StartCalledMoreThanOnce = 62 ,
        _a$2.StopCalledWithoutStart = 63 ,
        _a$2["TelemetryInitializer" + FAILED] = 64 ,
        _a$2.TrackArgumentsNotSpecified = 65 ,
        _a$2.UrlTooLong = 66 ,
        _a$2[SESSION + STORAGE + BUFFER + "Full"] = 67 ,
        _a$2[CANNOT + "AccessCookie"] = 68 ,
        _a$2.IdTooLong = 69 ,
        _a$2.InvalidEvent = 70 ,
        _a$2[FAILED_MONITOR_AJAX + "SetRequestHeader"] = 71 ,
        _a$2["Send" + BROWSER + "InfoOnUserInit"] = 72 ,
        _a$2["Plugin" + EXCEPTION] = 73 ,
        _a$2["Notification" + EXCEPTION] = 74 ,
        _a$2.SnippetScriptLoadFailure = 99 ,
        _a$2["Invalid" + INSTRUMENTATION_KEY] = 100 ,
        _a$2[CANNOT + "ParseAiBlobValue"] = 101 ,
        _a$2.InvalidContentBlob = 102 ,
        _a$2[TRACK + "PageAction" + EVENT + FAILED] = 103 ,
        _a$2[FAILED + "AddingCustomDefinedRequestContext"] = 104 ,
        _a$2["InMemory" + STORAGE + BUFFER + "Full"] = 105 ,
        _a$2[INSTRUMENTATION_KEY + "Deprecation"] = 106 ,
        _a$2));

    var aiInstrumentHooks = "_aiHooks";
    var cbNames = [
        "req", "rsp", "hkErr", "fnErr"
    ];
    function _arrLoop(arr, fn) {
        if (arr) {
            for (var lp = 0; lp < arr[_DYN_LENGTH$5 ]; lp++) {
                if (fn(arr[lp], lp)) {
                    break;
                }
            }
        }
    }
    function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
        if (type >= 0  && type <= 2 ) {
            _arrLoop(hooks, function (hook, idx) {
                var cbks = hook.cbks;
                var cb = cbks[cbNames[type]];
                if (cb) {
                    callDetails.ctx = function () {
                        var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                        return ctx;
                    };
                    try {
                        cb[_DYN_APPLY ](callDetails.inst, cbArgs);
                    }
                    catch (err) {
                        var orgEx = callDetails.err;
                        try {
                            var hookErrorCb = cbks[cbNames[2 ]];
                            if (hookErrorCb) {
                                callDetails.err = err;
                                hookErrorCb[_DYN_APPLY ](callDetails.inst, cbArgs);
                            }
                        }
                        catch (e) {
                        }
                        finally {
                            callDetails.err = orgEx;
                        }
                    }
                }
            });
        }
    }
    function _createFunctionHook(aiHook) {
        return function () {
            var _a;
            var funcThis = this;
            var orgArgs = arguments;
            var hooks = aiHook.h;
            var funcArgs = (_a = {},
                _a[_DYN_NAME$3 ] = aiHook.n,
                _a.inst = funcThis,
                _a.ctx = null,
                _a.set = _replaceArg,
                _a);
            var hookCtx = [];
            var cbArgs = _createArgs([funcArgs], orgArgs);
            funcArgs.evt = getGlobalInst("event");
            function _createArgs(target, theArgs) {
                _arrLoop(theArgs, function (arg) {
                    target[_DYN_PUSH$2 ](arg);
                });
                return target;
            }
            function _replaceArg(idx, value) {
                orgArgs = _createArgs([], orgArgs);
                orgArgs[idx] = value;
                cbArgs = _createArgs([funcArgs], orgArgs);
            }
            _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 );
            var theFunc = aiHook.f;
            if (theFunc) {
                try {
                    funcArgs.rslt = theFunc[_DYN_APPLY ](funcThis, orgArgs);
                }
                catch (err) {
                    funcArgs.err = err;
                    _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 );
                    throw err;
                }
            }
            _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 );
            return funcArgs.rslt;
        };
    }
    function _getOwner(target, name, checkPrototype, checkParentProto) {
        var owner = null;
        if (target) {
            if (hasOwnProperty(target, name)) {
                owner = target;
            }
            else if (checkPrototype) {
                owner = _getOwner(_getObjProto(target), name, checkParentProto, false);
            }
        }
        return owner;
    }
    function InstrumentProto(target, funcName, callbacks) {
        if (target) {
            return InstrumentFunc(target[strShimPrototype], funcName, callbacks, false);
        }
        return null;
    }
    function _createInstrumentHook(owner, funcName, fn, callbacks) {
        var aiHook = fn && fn[aiInstrumentHooks];
        if (!aiHook) {
            aiHook = {
                i: 0,
                n: funcName,
                f: fn,
                h: []
            };
            var newFunc = _createFunctionHook(aiHook);
            newFunc[aiInstrumentHooks] = aiHook;
            owner[funcName] = newFunc;
        }
        var theHook = {
            id: aiHook.i,
            cbks: callbacks,
            rm: function () {
                var id = this.id;
                _arrLoop(aiHook.h, function (hook, idx) {
                    if (hook.id === id) {
                        aiHook.h[_DYN_SPLICE ](idx, 1);
                        return 1;
                    }
                });
            }
        };
        aiHook.i++;
        aiHook.h[_DYN_PUSH$2 ](theHook);
        return theHook;
    }
    function InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto) {
        if (checkPrototype === void 0) { checkPrototype = true; }
        if (target && funcName && callbacks) {
            var owner = _getOwner(target, funcName, checkPrototype, checkParentProto);
            if (owner) {
                var fn = owner[funcName];
                if (typeof fn === strShimFunction) {
                    return _createInstrumentHook(owner, funcName, fn, callbacks);
                }
            }
        }
        return null;
    }
    function InstrumentEvent(target, evtName, callbacks, checkPrototype, checkParentProto) {
        if (target && evtName && callbacks) {
            var owner = _getOwner(target, evtName, checkPrototype, checkParentProto) || target;
            if (owner) {
                return _createInstrumentHook(owner, evtName, owner[evtName], callbacks);
            }
        }
        return null;
    }

    var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
    var SampleRate = "sampleRate";
    var ProcessLegacy = "ProcessLegacy";
    var HttpMethod = "http.method";
    var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
    var DEFAULT_BREEZE_PATH = "/v2/track";
    var strNotSpecified = "not_specified";
    var strIkey = "iKey";

    function createDomEvent(eventName) {
        var event = null;
        if (isFunction(Event)) {
            event = new Event(eventName);
        }
        else {
            var doc = getDocument();
            if (doc && doc.createEvent) {
                event = doc.createEvent("Event");
                event.initEvent(eventName, true, true);
            }
        }
        return event;
    }

    var _DYN_SPLIT = "split";
    var _DYN_LENGTH$4 = "length";
    var _DYN_TO_LOWER_CASE$1 = "toLowerCase";
    var _DYN_INGESTIONENDPOINT = "ingestionendpoint";
    var _DYN_TO_STRING$2 = "toString";
    var _DYN_REMOVE_ITEM = "removeItem";
    var _DYN_NAME$2 = "name";
    var _DYN_MESSAGE$1 = "message";
    var _DYN_COUNT$1 = "count";
    var _DYN_STRINGIFY$1 = "stringify";
    var _DYN_PATHNAME = "pathname";
    var _DYN_CORRELATION_HEADER_E0 = "correlationHeaderExcludePatterns";
    var _DYN_INDEX_OF$1 = "indexOf";
    var _DYN_EXTENSION_CONFIG = "extensionConfig";
    var _DYN_EXCEPTIONS = "exceptions";
    var _DYN_PARSED_STACK = "parsedStack";
    var _DYN_PROPERTIES = "properties";
    var _DYN_MEASUREMENTS$1 = "measurements";
    var _DYN_SIZE_IN_BYTES = "sizeInBytes";
    var _DYN_TYPE_NAME = "typeName";
    var _DYN_SEVERITY_LEVEL = "severityLevel";
    var _DYN_PROBLEM_GROUP = "problemGroup";
    var _DYN_IS_MANUAL = "isManual";
    var _DYN__CREATE_FROM_INTERFA1 = "CreateFromInterface";
    var _DYN_ASSEMBLY = "assembly";
    var _DYN_HAS_FULL_STACK = "hasFullStack";
    var _DYN_LEVEL = "level";
    var _DYN_METHOD$1 = "method";
    var _DYN_FILE_NAME = "fileName";
    var _DYN_LINE = "line";
    var _DYN_DURATION$1 = "duration";
    var _DYN_RECEIVED_RESPONSE = "receivedResponse";
    var _DYN_SUBSTRING = "substring";
    var _DYN_SANITIZE_KEY_AND_ADD2 = "sanitizeKeyAndAddUniqueness";
    var _DYN_SANITIZE_EXCEPTION = "sanitizeException";
    var _DYN_SANITIZE_PROPERTIES = "sanitizeProperties";
    var _DYN_SANITIZE_MEASUREMENT3 = "sanitizeMeasurements";

    var strEmpty = "";
    function stringToBoolOrDefault(str, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        if (str === undefined || str === null) {
            return defaultValue;
        }
        return str.toString()[_DYN_TO_LOWER_CASE$1 ]() === "true";
    }
    function msToTimeSpan(totalms) {
        if (isNaN(totalms) || totalms < 0) {
            totalms = 0;
        }
        totalms = Math.round(totalms);
        var ms = strEmpty + totalms % 1000;
        var sec = strEmpty + Math.floor(totalms / 1000) % 60;
        var min = strEmpty + Math.floor(totalms / (1000 * 60)) % 60;
        var hour = strEmpty + Math.floor(totalms / (1000 * 60 * 60)) % 24;
        var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
        ms = ms[_DYN_LENGTH$4 ] === 1 ? "00" + ms : ms[_DYN_LENGTH$4 ] === 2 ? "0" + ms : ms;
        sec = sec[_DYN_LENGTH$4 ] < 2 ? "0" + sec : sec;
        min = min[_DYN_LENGTH$4 ] < 2 ? "0" + min : min;
        hour = hour[_DYN_LENGTH$4 ] < 2 ? "0" + hour : hour;
        return (days > 0 ? days + "." : strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
    }
    function getExtensionByName(extensions, identifier) {
        var extension = null;
        arrForEach(extensions, function (value) {
            if (value.identifier === identifier) {
                extension = value;
                return -1;
            }
        });
        return extension;
    }
    function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
        return !error && isString(message) && (message === "Script error." || message === "Script error");
    }

    var RequestHeaders = createValueMap({
        requestContextHeader: [0 , "Request-Context"],
        requestContextTargetKey: [1 , "appId"],
        requestContextAppIdFormat: [2 , "appId=cid-v1:"],
        requestIdHeader: [3 , "Request-Id"],
        traceParentHeader: [4 , "traceparent"],
        traceStateHeader: [5 , "tracestate"],
        sdkContextHeader: [6 , "Sdk-Context"],
        sdkContextHeaderAppIdRequest: [7 , "appId"],
        requestContextHeaderLowerCase: [8 , "request-context"]
    });

    var StorageType = createEnumStyle({
        LocalStorage: 0 ,
        SessionStorage: 1
    });
    var DistributedTracingModes = createEnumStyle({
        AI: 0 ,
        AI_AND_W3C: 1 ,
        W3C: 2
    });

    var _canUseLocalStorage = undefined;
    var _canUseSessionStorage = undefined;
    function _getLocalStorageObject() {
        if (utlCanUseLocalStorage()) {
            return _getVerifiedStorageObject(StorageType.LocalStorage);
        }
        return null;
    }
    function _getVerifiedStorageObject(storageType) {
        try {
            if (isNullOrUndefined(getGlobal())) {
                return null;
            }
            var uid = (new Date)[_DYN_TO_STRING$2 ]();
            var storage = getGlobalInst(storageType === StorageType.LocalStorage ? "localStorage" : "sessionStorage");
            storage.setItem(uid, uid);
            var fail = storage.getItem(uid) !== uid;
            storage[_DYN_REMOVE_ITEM ](uid);
            if (!fail) {
                return storage;
            }
        }
        catch (exception) {
        }
        return null;
    }
    function _getSessionStorageObject() {
        if (utlCanUseSessionStorage()) {
            return _getVerifiedStorageObject(StorageType.SessionStorage);
        }
        return null;
    }
    function utlDisableStorage() {
        _canUseLocalStorage = false;
        _canUseSessionStorage = false;
    }
    function utlEnableStorage() {
        _canUseLocalStorage = utlCanUseLocalStorage(true);
        _canUseSessionStorage = utlCanUseSessionStorage(true);
    }
    function utlCanUseLocalStorage(reset) {
        if (reset || _canUseLocalStorage === undefined) {
            _canUseLocalStorage = !!_getVerifiedStorageObject(StorageType.LocalStorage);
        }
        return _canUseLocalStorage;
    }
    function utlGetLocalStorage(logger, name) {
        var storage = _getLocalStorageObject();
        if (storage !== null) {
            try {
                return storage.getItem(name);
            }
            catch (e) {
                _canUseLocalStorage = false;
                _throwInternal(logger, 2 , 1 , "Browser failed read of local storage. " + getExceptionName(e), { exception: dumpObj(e) });
            }
        }
        return null;
    }
    function utlSetLocalStorage(logger, name, data) {
        var storage = _getLocalStorageObject();
        if (storage !== null) {
            try {
                storage.setItem(name, data);
                return true;
            }
            catch (e) {
                _canUseLocalStorage = false;
                _throwInternal(logger, 2 , 3 , "Browser failed write to local storage. " + getExceptionName(e), { exception: dumpObj(e) });
            }
        }
        return false;
    }
    function utlRemoveStorage(logger, name) {
        var storage = _getLocalStorageObject();
        if (storage !== null) {
            try {
                storage[_DYN_REMOVE_ITEM ](name);
                return true;
            }
            catch (e) {
                _canUseLocalStorage = false;
                _throwInternal(logger, 2 , 5 , "Browser failed removal of local storage item. " + getExceptionName(e), { exception: dumpObj(e) });
            }
        }
        return false;
    }
    function utlCanUseSessionStorage(reset) {
        if (reset || _canUseSessionStorage === undefined) {
            _canUseSessionStorage = !!_getVerifiedStorageObject(StorageType.SessionStorage);
        }
        return _canUseSessionStorage;
    }
    function utlGetSessionStorageKeys() {
        var keys = [];
        if (utlCanUseSessionStorage()) {
            objForEachKey(getGlobalInst("sessionStorage"), function (key) {
                keys.push(key);
            });
        }
        return keys;
    }
    function utlGetSessionStorage(logger, name) {
        var storage = _getSessionStorageObject();
        if (storage !== null) {
            try {
                return storage.getItem(name);
            }
            catch (e) {
                _canUseSessionStorage = false;
                _throwInternal(logger, 2 , 2 , "Browser failed read of session storage. " + getExceptionName(e), { exception: dumpObj(e) });
            }
        }
        return null;
    }
    function utlSetSessionStorage(logger, name, data) {
        var storage = _getSessionStorageObject();
        if (storage !== null) {
            try {
                storage.setItem(name, data);
                return true;
            }
            catch (e) {
                _canUseSessionStorage = false;
                _throwInternal(logger, 2 , 4 , "Browser failed write to session storage. " + getExceptionName(e), { exception: dumpObj(e) });
            }
        }
        return false;
    }
    function utlRemoveSessionStorage(logger, name) {
        var storage = _getSessionStorageObject();
        if (storage !== null) {
            try {
                storage[_DYN_REMOVE_ITEM ](name);
                return true;
            }
            catch (e) {
                _canUseSessionStorage = false;
                _throwInternal(logger, 2 , 6 , "Browser failed removal of session storage item. " + getExceptionName(e), { exception: dumpObj(e) });
            }
        }
        return false;
    }

    var _a$1;
    function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
        var origLength = key[_DYN_LENGTH$4 ];
        var field = dataSanitizeKey(logger, key);
        if (field[_DYN_LENGTH$4 ] !== origLength) {
            var i = 0;
            var uniqueField = field;
            while (map[uniqueField] !== undefined) {
                i++;
                uniqueField = field[_DYN_SUBSTRING ](0, 150  - 3) + dsPadNumber(i);
            }
            field = uniqueField;
        }
        return field;
    }
    function dataSanitizeKey(logger, name) {
        var nameTrunc;
        if (name) {
            name = strTrim(name[_DYN_TO_STRING$2 ]());
            if (name[_DYN_LENGTH$4 ] > 150 ) {
                nameTrunc = name[_DYN_SUBSTRING ](0, 150 );
                _throwInternal(logger, 2 , 57 , "name is too long.  It has been truncated to " + 150  + " characters.", { name: name }, true);
            }
        }
        return nameTrunc || name;
    }
    function dataSanitizeString(logger, value, maxLength) {
        if (maxLength === void 0) { maxLength = 1024 ; }
        var valueTrunc;
        if (value) {
            maxLength = maxLength ? maxLength : 1024 ;
            value = strTrim(value);
            if (value.toString()[_DYN_LENGTH$4 ] > maxLength) {
                valueTrunc = value[_DYN_TO_STRING$2 ]()[_DYN_SUBSTRING ](0, maxLength);
                _throwInternal(logger, 2 , 61 , "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
            }
        }
        return valueTrunc || value;
    }
    function dataSanitizeUrl(logger, url) {
        return dataSanitizeInput(logger, url, 2048 , 66 );
    }
    function dataSanitizeMessage(logger, message) {
        var messageTrunc;
        if (message) {
            if (message[_DYN_LENGTH$4 ] > 32768 ) {
                messageTrunc = message[_DYN_SUBSTRING ](0, 32768 );
                _throwInternal(logger, 2 , 56 , "message is too long, it has been truncated to " + 32768  + " characters.", { message: message }, true);
            }
        }
        return messageTrunc || message;
    }
    function dataSanitizeException(logger, exception) {
        var exceptionTrunc;
        if (exception) {
            var value = "" + exception;
            if (value[_DYN_LENGTH$4 ] > 32768 ) {
                exceptionTrunc = value[_DYN_SUBSTRING ](0, 32768 );
                _throwInternal(logger, 2 , 52 , "exception is too long, it has been truncated to " + 32768  + " characters.", { exception: exception }, true);
            }
        }
        return exceptionTrunc || exception;
    }
    function dataSanitizeProperties(logger, properties) {
        if (properties) {
            var tempProps_1 = {};
            objForEachKey(properties, function (prop, value) {
                if (isObject(value) && hasJSON()) {
                    try {
                        value = getJSON()[_DYN_STRINGIFY$1 ](value);
                    }
                    catch (e) {
                        _throwInternal(logger, 2 , 49 , "custom property is not valid", { exception: e }, true);
                    }
                }
                value = dataSanitizeString(logger, value, 8192 );
                prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
                tempProps_1[prop] = value;
            });
            properties = tempProps_1;
        }
        return properties;
    }
    function dataSanitizeMeasurements(logger, measurements) {
        if (measurements) {
            var tempMeasurements_1 = {};
            objForEachKey(measurements, function (measure, value) {
                measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
                tempMeasurements_1[measure] = value;
            });
            measurements = tempMeasurements_1;
        }
        return measurements;
    }
    function dataSanitizeId(logger, id) {
        return id ? dataSanitizeInput(logger, id, 128 , 69 )[_DYN_TO_STRING$2 ]() : id;
    }
    function dataSanitizeInput(logger, input, maxLength, _msgId) {
        var inputTrunc;
        if (input) {
            input = strTrim(input);
            if (input[_DYN_LENGTH$4 ] > maxLength) {
                inputTrunc = input[_DYN_SUBSTRING ](0, maxLength);
                _throwInternal(logger, 2 , _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
            }
        }
        return inputTrunc || input;
    }
    function dsPadNumber(num) {
        var s = "00" + num;
        return s.substr(s[_DYN_LENGTH$4 ] - 3);
    }
    var DataSanitizer = (_a$1 = {
            MAX_NAME_LENGTH: 150 ,
            MAX_ID_LENGTH: 128 ,
            MAX_PROPERTY_LENGTH: 8192 ,
            MAX_STRING_LENGTH: 1024 ,
            MAX_URL_LENGTH: 2048 ,
            MAX_MESSAGE_LENGTH: 32768 ,
            MAX_EXCEPTION_LENGTH: 32768
        },
        _a$1[_DYN_SANITIZE_KEY_AND_ADD2 ] = dataSanitizeKeyAndAddUniqueness,
        _a$1.sanitizeKey = dataSanitizeKey,
        _a$1.sanitizeString = dataSanitizeString,
        _a$1.sanitizeUrl = dataSanitizeUrl,
        _a$1.sanitizeMessage = dataSanitizeMessage,
        _a$1[_DYN_SANITIZE_EXCEPTION ] = dataSanitizeException,
        _a$1[_DYN_SANITIZE_PROPERTIES ] = dataSanitizeProperties,
        _a$1[_DYN_SANITIZE_MEASUREMENT3 ] = dataSanitizeMeasurements,
        _a$1.sanitizeId = dataSanitizeId,
        _a$1.sanitizeInput = dataSanitizeInput,
        _a$1.padNumber = dsPadNumber,
        _a$1.trim = strTrim,
        _a$1);

    var _document = getDocument() || {};
    var _htmlAnchorIdx = 0;
    var _htmlAnchorElement = [null, null, null, null, null];
    function urlParseUrl(url) {
        var anchorIdx = _htmlAnchorIdx;
        var anchorCache = _htmlAnchorElement;
        var tempAnchor = anchorCache[anchorIdx];
        if (!_document.createElement) {
            tempAnchor = { host: urlParseHost(url, true) };
        }
        else if (!anchorCache[anchorIdx]) {
            tempAnchor = anchorCache[anchorIdx] = _document.createElement("a");
        }
        tempAnchor.href = url;
        anchorIdx++;
        if (anchorIdx >= anchorCache[_DYN_LENGTH$4 ]) {
            anchorIdx = 0;
        }
        _htmlAnchorIdx = anchorIdx;
        return tempAnchor;
    }
    function urlGetAbsoluteUrl(url) {
        var result;
        var a = urlParseUrl(url);
        if (a) {
            result = a.href;
        }
        return result;
    }
    function urlGetPathName(url) {
        var result;
        var a = urlParseUrl(url);
        if (a) {
            result = a[_DYN_PATHNAME ];
        }
        return result;
    }
    function urlGetCompleteUrl(method, absoluteUrl) {
        if (method) {
            return method.toUpperCase() + " " + absoluteUrl;
        }
        return absoluteUrl;
    }
    function urlParseHost(url, inclPort) {
        var fullHost = urlParseFullHost(url, inclPort) || "";
        if (fullHost) {
            var match = fullHost.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
            if (match != null && match[_DYN_LENGTH$4 ] > 3 && isString(match[2]) && match[2][_DYN_LENGTH$4 ] > 0) {
                return match[2] + (match[3] || "");
            }
        }
        return fullHost;
    }
    function urlParseFullHost(url, inclPort) {
        var result = null;
        if (url) {
            var match = url.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
            if (match != null && match[_DYN_LENGTH$4 ] > 2 && isString(match[2]) && match[2][_DYN_LENGTH$4 ] > 0) {
                result = match[2] || "";
                if (inclPort && match[_DYN_LENGTH$4 ] > 2) {
                    var protocol = (match[1] || "")[_DYN_TO_LOWER_CASE$1 ]();
                    var port = match[3] || "";
                    if (protocol === "http" && port === ":80") {
                        port = "";
                    }
                    else if (protocol === "https" && port === ":443") {
                        port = "";
                    }
                    result += port;
                }
            }
        }
        return result;
    }

    var _internalEndpoints = [
        DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH,
        "https://breeze.aimon.applicationinsights.io" + DEFAULT_BREEZE_PATH,
        "https://dc-int.services.visualstudio.com" + DEFAULT_BREEZE_PATH
    ];
    function isInternalApplicationInsightsEndpoint(endpointUrl) {
        return arrIndexOf(_internalEndpoints, endpointUrl[_DYN_TO_LOWER_CASE$1 ]()) !== -1;
    }
    var Util = {
        NotSpecified: strNotSpecified,
        createDomEvent: createDomEvent,
        disableStorage: utlDisableStorage,
        isInternalApplicationInsightsEndpoint: isInternalApplicationInsightsEndpoint,
        canUseLocalStorage: utlCanUseLocalStorage,
        getStorage: utlGetLocalStorage,
        setStorage: utlSetLocalStorage,
        removeStorage: utlRemoveStorage,
        canUseSessionStorage: utlCanUseSessionStorage,
        getSessionStorageKeys: utlGetSessionStorageKeys,
        getSessionStorage: utlGetSessionStorage,
        setSessionStorage: utlSetSessionStorage,
        removeSessionStorage: utlRemoveSessionStorage,
        disableCookies: disableCookies,
        canUseCookies: canUseCookies,
        disallowsSameSiteNone: uaDisallowsSameSiteNone,
        setCookie: setCookie,
        stringToBoolOrDefault: stringToBoolOrDefault,
        getCookie: getCookie,
        deleteCookie: deleteCookie,
        trim: strTrim,
        newId: newId,
        random32: function () {
            return random32(true);
        },
        generateW3CId: generateW3CId,
        isArray: isArray,
        isError: isError,
        isDate: isDate,
        toISOStringForIE8: toISOString,
        getIEVersion: getIEVersion,
        msToTimeSpan: msToTimeSpan,
        isCrossOriginError: isCrossOriginError,
        dump: dumpObj,
        getExceptionName: getExceptionName,
        addEventHandler: attachEvent,
        IsBeaconApiSupported: isBeaconsSupported,
        getExtension: getExtensionByName
    };
    var UrlHelper = {
        parseUrl: urlParseUrl,
        getAbsoluteUrl: urlGetAbsoluteUrl,
        getPathName: urlGetPathName,
        getCompleteUrl: urlGetCompleteUrl,
        parseHost: urlParseHost,
        parseFullHost: urlParseFullHost
    };
    var CorrelationIdHelper = {
        correlationIdPrefix: "cid-v1:",
        canIncludeCorrelationHeader: function (config, requestUrl, currentHost) {
            if (!requestUrl || (config && config.disableCorrelationHeaders)) {
                return false;
            }
            if (config && config[_DYN_CORRELATION_HEADER_E0 ]) {
                for (var i = 0; i < config.correlationHeaderExcludePatterns[_DYN_LENGTH$4 ]; i++) {
                    if (config[_DYN_CORRELATION_HEADER_E0 ][i].test(requestUrl)) {
                        return false;
                    }
                }
            }
            var requestHost = urlParseUrl(requestUrl).host[_DYN_TO_LOWER_CASE$1 ]();
            if (requestHost && (requestHost[_DYN_INDEX_OF$1 ](":443") !== -1 || requestHost[_DYN_INDEX_OF$1 ](":80") !== -1)) {
                requestHost = (urlParseFullHost(requestUrl, true) || "")[_DYN_TO_LOWER_CASE$1 ]();
            }
            if ((!config || !config.enableCorsCorrelation) && (requestHost && requestHost !== currentHost)) {
                return false;
            }
            var includedDomains = config && config.correlationHeaderDomains;
            if (includedDomains) {
                var matchExists_1;
                arrForEach(includedDomains, function (domain) {
                    var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
                    matchExists_1 = matchExists_1 || regex.test(requestHost);
                });
                if (!matchExists_1) {
                    return false;
                }
            }
            var excludedDomains = config && config.correlationHeaderExcludedDomains;
            if (!excludedDomains || excludedDomains[_DYN_LENGTH$4 ] === 0) {
                return true;
            }
            for (var i = 0; i < excludedDomains[_DYN_LENGTH$4 ]; i++) {
                var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
                if (regex.test(requestHost)) {
                    return false;
                }
            }
            return requestHost && requestHost[_DYN_LENGTH$4 ] > 0;
        },
        getCorrelationContext: function (responseHeader) {
            if (responseHeader) {
                var correlationId = CorrelationIdHelper.getCorrelationContextValue(responseHeader, RequestHeaders[1 ]);
                if (correlationId && correlationId !== CorrelationIdHelper.correlationIdPrefix) {
                    return correlationId;
                }
            }
        },
        getCorrelationContextValue: function (responseHeader, key) {
            if (responseHeader) {
                var keyValues = responseHeader[_DYN_SPLIT ](",");
                for (var i = 0; i < keyValues[_DYN_LENGTH$4 ]; ++i) {
                    var keyValue = keyValues[i][_DYN_SPLIT ]("=");
                    if (keyValue[_DYN_LENGTH$4 ] === 2 && keyValue[0] === key) {
                        return keyValue[1];
                    }
                }
            }
        }
    };
    function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
        var target, name = commandName, data = commandName;
        if (absoluteUrl && absoluteUrl[_DYN_LENGTH$4 ] > 0) {
            var parsedUrl = urlParseUrl(absoluteUrl);
            target = parsedUrl.host;
            if (!name) {
                if (parsedUrl[_DYN_PATHNAME ] != null) {
                    var pathName = (parsedUrl.pathname[_DYN_LENGTH$4 ] === 0) ? "/" : parsedUrl[_DYN_PATHNAME ];
                    if (pathName.charAt(0) !== "/") {
                        pathName = "/" + pathName;
                    }
                    data = parsedUrl[_DYN_PATHNAME ];
                    name = dataSanitizeString(logger, method ? method + " " + pathName : pathName);
                }
                else {
                    name = dataSanitizeString(logger, absoluteUrl);
                }
            }
        }
        else {
            target = commandName;
            name = commandName;
        }
        return {
            target: target,
            name: name,
            data: data
        };
    }
    function dateTimeUtilsNow() {
        var perf = getPerformance();
        if (perf && perf.now && perf.timing) {
            var now = perf.now() + perf.timing.navigationStart;
            if (now > 0) {
                return now;
            }
        }
        return dateNow();
    }
    function dateTimeUtilsDuration(start, end) {
        var result = null;
        if (start !== 0 && end !== 0 && !isNullOrUndefined(start) && !isNullOrUndefined(end)) {
            result = end - start;
        }
        return result;
    }
    var DateTimeUtils = {
        Now: dateTimeUtilsNow,
        GetDuration: dateTimeUtilsDuration
    };
    function createDistributedTraceContextFromTrace(telemetryTrace, parentCtx) {
        var trace = telemetryTrace || {};
        return {
            getName: function () {
                return trace[_DYN_NAME$2 ];
            },
            setName: function (newValue) {
                parentCtx && parentCtx.setName(newValue);
                trace[_DYN_NAME$2 ] = newValue;
            },
            getTraceId: function () {
                return trace.traceID;
            },
            setTraceId: function (newValue) {
                parentCtx && parentCtx.setTraceId(newValue);
                if (isValidTraceId(newValue)) {
                    trace.traceID = newValue;
                }
            },
            getSpanId: function () {
                return trace.parentID;
            },
            setSpanId: function (newValue) {
                parentCtx && parentCtx.setSpanId(newValue);
                if (isValidSpanId(newValue)) {
                    trace.parentID = newValue;
                }
            },
            getTraceFlags: function () {
                return trace.traceFlags;
            },
            setTraceFlags: function (newTraceFlags) {
                parentCtx && parentCtx.setTraceFlags(newTraceFlags);
                trace.traceFlags = newTraceFlags;
            }
        };
    }

    var _FIELDS_SEPARATOR = ";";
    var _FIELD_KEY_VALUE_SEPARATOR = "=";
    function parseConnectionString(connectionString) {
        if (!connectionString) {
            return {};
        }
        var kvPairs = connectionString[_DYN_SPLIT ](_FIELDS_SEPARATOR);
        var result = arrReduce(kvPairs, function (fields, kv) {
            var kvParts = kv[_DYN_SPLIT ](_FIELD_KEY_VALUE_SEPARATOR);
            if (kvParts[_DYN_LENGTH$4 ] === 2) {
                var key = kvParts[0][_DYN_TO_LOWER_CASE$1 ]();
                var value = kvParts[1];
                fields[key] = value;
            }
            return fields;
        }, {});
        if (objKeys(result)[_DYN_LENGTH$4 ] > 0) {
            if (result.endpointsuffix) {
                var locationPrefix = result.location ? result.location + "." : "";
                result[_DYN_INGESTIONENDPOINT ] = result[_DYN_INGESTIONENDPOINT ] || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
            }
            result[_DYN_INGESTIONENDPOINT ] = result[_DYN_INGESTIONENDPOINT ] || DEFAULT_BREEZE_ENDPOINT;
        }
        return result;
    }
    var ConnectionStringParser = {
        parse: parseConnectionString
    };

    var Envelope = /** @class */ (function () {
        function Envelope(logger, data, name) {
            var _this = this;
            var _self = this;
            _self.ver = 1;
            _self.sampleRate = 100.0;
            _self.tags = {};
            _self[_DYN_NAME$2 ] = dataSanitizeString(logger, name) || strNotSpecified;
            _self.data = data;
            _self.time = toISOString(new Date());
            _self.aiDataContract = {
                time: 1 ,
                iKey: 1 ,
                name: 1 ,
                sampleRate: function () {
                    return (_this.sampleRate === 100) ? 4  : 1 ;
                },
                tags: 1 ,
                data: 1
            };
        }
        return Envelope;
    }());

    var Event$1 = /** @class */ (function () {
        function Event(logger, name, properties, measurements) {
            this.aiDataContract = {
                ver: 1 ,
                name: 1 ,
                properties: 0 ,
                measurements: 0
            };
            var _self = this;
            _self.ver = 2;
            _self[_DYN_NAME$2 ] = dataSanitizeString(logger, name) || strNotSpecified;
            _self[_DYN_PROPERTIES ] = dataSanitizeProperties(logger, properties);
            _self[_DYN_MEASUREMENTS$1 ] = dataSanitizeMeasurements(logger, measurements);
        }
        Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
        Event.dataType = "EventData";
        return Event;
    }());

    var NoMethod = "<no_method>";
    var strError = "error";
    var strStack = "stack";
    var strStackDetails = "stackDetails";
    var strErrorSrc = "errorSrc";
    var strMessage = "message";
    var strDescription = "description";
    function _stringify(value, convertToString) {
        var result = value;
        if (result && !isString(result)) {
            if (JSON && JSON[_DYN_STRINGIFY$1 ]) {
                result = JSON[_DYN_STRINGIFY$1 ](value);
                if (convertToString && (!result || result === "{}")) {
                    if (isFunction(value[_DYN_TO_STRING$2 ])) {
                        result = value[_DYN_TO_STRING$2 ]();
                    }
                    else {
                        result = "" + value;
                    }
                }
            }
            else {
                result = "" + value + " - (Missing JSON.stringify)";
            }
        }
        return result || "";
    }
    function _formatMessage(theEvent, errorType) {
        var evtMessage = theEvent;
        if (theEvent) {
            if (evtMessage && !isString(evtMessage)) {
                evtMessage = theEvent[strMessage] || theEvent[strDescription] || evtMessage;
            }
            if (evtMessage && !isString(evtMessage)) {
                evtMessage = _stringify(evtMessage, true);
            }
            if (theEvent["filename"]) {
                evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
            }
        }
        if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "")[_DYN_INDEX_OF$1 ](errorType) === -1) {
            evtMessage = errorType + ": " + evtMessage;
        }
        return evtMessage || "";
    }
    function _isExceptionDetailsInternal(value) {
        try {
            if (isObject(value)) {
                return "hasFullStack" in value && "typeName" in value;
            }
        }
        catch (e) {
        }
        return false;
    }
    function _isExceptionInternal(value) {
        try {
            if (isObject(value)) {
                return ("ver" in value && "exceptions" in value && "properties" in value);
            }
        }
        catch (e) {
        }
        return false;
    }
    function _isStackDetails(details) {
        return details && details.src && isString(details.src) && details.obj && isArray(details.obj);
    }
    function _convertStackObj(errorStack) {
        var src = errorStack || "";
        if (!isString(src)) {
            if (isString(src[strStack])) {
                src = src[strStack];
            }
            else {
                src = "" + src;
            }
        }
        var items = src[_DYN_SPLIT ]("\n");
        return {
            src: src,
            obj: items
        };
    }
    function _getOperaStack(errorMessage) {
        var stack = [];
        var lines = errorMessage[_DYN_SPLIT ]("\n");
        for (var lp = 0; lp < lines[_DYN_LENGTH$4 ]; lp++) {
            var entry = lines[lp];
            if (lines[lp + 1]) {
                entry += "@" + lines[lp + 1];
                lp++;
            }
            stack.push(entry);
        }
        return {
            src: errorMessage,
            obj: stack
        };
    }
    function _getStackFromErrorObj(errorObj) {
        var details = null;
        if (errorObj) {
            try {
                if (errorObj[strStack]) {
                    details = _convertStackObj(errorObj[strStack]);
                }
                else if (errorObj[strError] && errorObj[strError][strStack]) {
                    details = _convertStackObj(errorObj[strError][strStack]);
                }
                else if (errorObj["exception"] && errorObj.exception[strStack]) {
                    details = _convertStackObj(errorObj.exception[strStack]);
                }
                else if (_isStackDetails(errorObj)) {
                    details = errorObj;
                }
                else if (_isStackDetails(errorObj[strStackDetails])) {
                    details = errorObj[strStackDetails];
                }
                else if (window && window["opera"] && errorObj[strMessage]) {
                    details = _getOperaStack(errorObj[_DYN_MESSAGE$1 ]);
                }
                else if (errorObj["reason"] && errorObj.reason[strStack]) {
                    details = _convertStackObj(errorObj.reason[strStack]);
                }
                else if (isString(errorObj)) {
                    details = _convertStackObj(errorObj);
                }
                else {
                    var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                    if (isString(errorObj[strErrorSrc])) {
                        if (evtMessage) {
                            evtMessage += "\n";
                        }
                        evtMessage += " from " + errorObj[strErrorSrc];
                    }
                    if (evtMessage) {
                        details = _convertStackObj(evtMessage);
                    }
                }
            }
            catch (e) {
                details = _convertStackObj(e);
            }
        }
        return details || {
            src: "",
            obj: null
        };
    }
    function _formatStackTrace(stackDetails) {
        var stack = "";
        if (stackDetails) {
            if (stackDetails.obj) {
                arrForEach(stackDetails.obj, function (entry) {
                    stack += entry + "\n";
                });
            }
            else {
                stack = stackDetails.src || "";
            }
        }
        return stack;
    }
    function _parseStack(stack) {
        var parsedStack;
        var frames = stack.obj;
        if (frames && frames[_DYN_LENGTH$4 ] > 0) {
            parsedStack = [];
            var level_1 = 0;
            var totalSizeInBytes_1 = 0;
            arrForEach(frames, function (frame) {
                var theFrame = frame[_DYN_TO_STRING$2 ]();
                if (_StackFrame.regex.test(theFrame)) {
                    var parsedFrame = new _StackFrame(theFrame, level_1++);
                    totalSizeInBytes_1 += parsedFrame[_DYN_SIZE_IN_BYTES ];
                    parsedStack.push(parsedFrame);
                }
            });
            var exceptionParsedStackThreshold = 32 * 1024;
            if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
                var left = 0;
                var right = parsedStack[_DYN_LENGTH$4 ] - 1;
                var size = 0;
                var acceptedLeft = left;
                var acceptedRight = right;
                while (left < right) {
                    var lSize = parsedStack[left][_DYN_SIZE_IN_BYTES ];
                    var rSize = parsedStack[right][_DYN_SIZE_IN_BYTES ];
                    size += lSize + rSize;
                    if (size > exceptionParsedStackThreshold) {
                        var howMany = acceptedRight - acceptedLeft + 1;
                        parsedStack.splice(acceptedLeft, howMany);
                        break;
                    }
                    acceptedLeft = left;
                    acceptedRight = right;
                    left++;
                    right--;
                }
            }
        }
        return parsedStack;
    }
    function _getErrorType(errorType) {
        var typeName = "";
        if (errorType) {
            typeName = errorType.typeName || errorType[_DYN_NAME$2 ] || "";
            if (!typeName) {
                try {
                    var funcNameRegex = /function (.{1,200})\(/;
                    var results = (funcNameRegex).exec((errorType).constructor[_DYN_TO_STRING$2 ]());
                    typeName = (results && results[_DYN_LENGTH$4 ] > 1) ? results[1] : "";
                }
                catch (e) {
                }
            }
        }
        return typeName;
    }
    function _formatErrorCode(errorObj) {
        if (errorObj) {
            try {
                if (!isString(errorObj)) {
                    var errorType = _getErrorType(errorObj);
                    var result = _stringify(errorObj, false);
                    if (!result || result === "{}") {
                        if (errorObj[strError]) {
                            errorObj = errorObj[strError];
                            errorType = _getErrorType(errorObj);
                        }
                        result = _stringify(errorObj, true);
                    }
                    if (result[_DYN_INDEX_OF$1 ](errorType) !== 0 && errorType !== "String") {
                        return errorType + ":" + result;
                    }
                    return result;
                }
            }
            catch (e) {
            }
        }
        return "" + (errorObj || "");
    }
    var Exception = /** @class */ (function () {
        function Exception(logger, exception, properties, measurements, severityLevel, id) {
            this.aiDataContract = {
                ver: 1 ,
                exceptions: 1 ,
                severityLevel: 0 ,
                properties: 0 ,
                measurements: 0
            };
            var _self = this;
            _self.ver = 2;
            if (!_isExceptionInternal(exception)) {
                if (!properties) {
                    properties = {};
                }
                _self[_DYN_EXCEPTIONS ] = [new _ExceptionDetails(logger, exception, properties)];
                _self[_DYN_PROPERTIES ] = dataSanitizeProperties(logger, properties);
                _self[_DYN_MEASUREMENTS$1 ] = dataSanitizeMeasurements(logger, measurements);
                if (severityLevel) {
                    _self[_DYN_SEVERITY_LEVEL ] = severityLevel;
                }
                if (id) {
                    _self.id = id;
                }
            }
            else {
                _self[_DYN_EXCEPTIONS ] = exception[_DYN_EXCEPTIONS ] || [];
                _self[_DYN_PROPERTIES ] = exception[_DYN_PROPERTIES ];
                _self[_DYN_MEASUREMENTS$1 ] = exception[_DYN_MEASUREMENTS$1 ];
                if (exception[_DYN_SEVERITY_LEVEL ]) {
                    _self[_DYN_SEVERITY_LEVEL ] = exception[_DYN_SEVERITY_LEVEL ];
                }
                if (exception.id) {
                    _self.id = exception.id;
                }
                if (exception[_DYN_PROBLEM_GROUP ]) {
                    _self[_DYN_PROBLEM_GROUP ] = exception[_DYN_PROBLEM_GROUP ];
                }
                if (!isNullOrUndefined(exception[_DYN_IS_MANUAL ])) {
                    _self[_DYN_IS_MANUAL ] = exception[_DYN_IS_MANUAL ];
                }
            }
        }
        Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
            var _a;
            var errorType = _getErrorType(error || evt || message);
            return _a = {},
                _a[_DYN_MESSAGE$1 ] = _formatMessage(message, errorType),
                _a.url = url,
                _a.lineNumber = lineNumber,
                _a.columnNumber = columnNumber,
                _a.error = _formatErrorCode(error || evt || message),
                _a.evt = _formatErrorCode(evt || message),
                _a[_DYN_TYPE_NAME ] = errorType,
                _a.stackDetails = _getStackFromErrorObj(stack || error || evt),
                _a.errorSrc = errorSrc,
                _a;
        };
        Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
            var exceptions = exception[_DYN_EXCEPTIONS ]
                && arrMap(exception[_DYN_EXCEPTIONS ], function (ex) { return _ExceptionDetails[_DYN__CREATE_FROM_INTERFA1 ](logger, ex); });
            var exceptionData = new Exception(logger, __assignFn(__assignFn({}, exception), { exceptions: exceptions }), properties, measurements);
            return exceptionData;
        };
        Exception.prototype.toInterface = function () {
            var _a;
            var _b = this, exceptions = _b.exceptions, properties = _b.properties, measurements = _b.measurements, severityLevel = _b.severityLevel, problemGroup = _b.problemGroup, id = _b.id, isManual = _b.isManual;
            var exceptionDetailsInterface = exceptions instanceof Array
                && arrMap(exceptions, function (exception) { return exception.toInterface(); })
                || undefined;
            return _a = {
                    ver: "4.0"
                },
                _a[_DYN_EXCEPTIONS ] = exceptionDetailsInterface,
                _a.severityLevel = severityLevel,
                _a.properties = properties,
                _a.measurements = measurements,
                _a.problemGroup = problemGroup,
                _a.id = id,
                _a.isManual = isManual,
                _a;
        };
        Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
            var _a;
            return {
                exceptions: [
                    (_a = {},
                        _a[_DYN_HAS_FULL_STACK ] = true,
                        _a.message = message,
                        _a.stack = details,
                        _a.typeName = typeName,
                        _a)
                ]
            };
        };
        Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
        Exception.dataType = "ExceptionData";
        Exception.formatError = _formatErrorCode;
        return Exception;
    }());
    var _ExceptionDetails = /** @class */ (function () {
        function _ExceptionDetails(logger, exception, properties) {
            this.aiDataContract = {
                id: 0 ,
                outerId: 0 ,
                typeName: 1 ,
                message: 1 ,
                hasFullStack: 0 ,
                stack: 0 ,
                parsedStack: 2
            };
            var _self = this;
            if (!_isExceptionDetailsInternal(exception)) {
                var error = exception;
                var evt = error && error.evt;
                if (!isError(error)) {
                    error = error[strError] || evt || error;
                }
                _self[_DYN_TYPE_NAME ] = dataSanitizeString(logger, _getErrorType(error)) || strNotSpecified;
                _self[_DYN_MESSAGE$1 ] = dataSanitizeMessage(logger, _formatMessage(exception || error, _self[_DYN_TYPE_NAME ])) || strNotSpecified;
                var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
                _self[_DYN_PARSED_STACK ] = _parseStack(stack);
                if (isArray(_self[_DYN_PARSED_STACK ])) {
                    arrMap(_self[_DYN_PARSED_STACK ], function (frame) { return frame[_DYN_ASSEMBLY ] = dataSanitizeString(logger, frame[_DYN_ASSEMBLY ]); });
                }
                _self[strStack] = dataSanitizeException(logger, _formatStackTrace(stack));
                _self.hasFullStack = isArray(_self.parsedStack) && _self.parsedStack[_DYN_LENGTH$4 ] > 0;
                if (properties) {
                    properties[_DYN_TYPE_NAME ] = properties[_DYN_TYPE_NAME ] || _self[_DYN_TYPE_NAME ];
                }
            }
            else {
                _self[_DYN_TYPE_NAME ] = exception[_DYN_TYPE_NAME ];
                _self[_DYN_MESSAGE$1 ] = exception[_DYN_MESSAGE$1 ];
                _self[strStack] = exception[strStack];
                _self[_DYN_PARSED_STACK ] = exception[_DYN_PARSED_STACK ] || [];
                _self[_DYN_HAS_FULL_STACK ] = exception[_DYN_HAS_FULL_STACK ];
            }
        }
        _ExceptionDetails.prototype.toInterface = function () {
            var _a;
            var _self = this;
            var parsedStack = _self[_DYN_PARSED_STACK ] instanceof Array
                && arrMap(_self[_DYN_PARSED_STACK ], function (frame) { return frame.toInterface(); });
            var exceptionDetailsInterface = (_a = {
                    id: _self.id,
                    outerId: _self.outerId,
                    typeName: _self[_DYN_TYPE_NAME ],
                    message: _self[_DYN_MESSAGE$1 ],
                    hasFullStack: _self[_DYN_HAS_FULL_STACK ],
                    stack: _self[strStack]
                },
                _a[_DYN_PARSED_STACK ] = parsedStack || undefined,
                _a);
            return exceptionDetailsInterface;
        };
        _ExceptionDetails.CreateFromInterface = function (logger, exception) {
            var parsedStack = (exception[_DYN_PARSED_STACK ] instanceof Array
                && arrMap(exception[_DYN_PARSED_STACK ], function (frame) { return _StackFrame[_DYN__CREATE_FROM_INTERFA1 ](frame); }))
                || exception[_DYN_PARSED_STACK ];
            var exceptionDetails = new _ExceptionDetails(logger, __assignFn(__assignFn({}, exception), { parsedStack: parsedStack }));
            return exceptionDetails;
        };
        return _ExceptionDetails;
    }());
    var _StackFrame = /** @class */ (function () {
        function _StackFrame(sourceFrame, level) {
            this.aiDataContract = {
                level: 1 ,
                method: 1 ,
                assembly: 0 ,
                fileName: 0 ,
                line: 0
            };
            var _self = this;
            _self[_DYN_SIZE_IN_BYTES ] = 0;
            if (typeof sourceFrame === "string") {
                var frame = sourceFrame;
                _self[_DYN_LEVEL ] = level;
                _self[_DYN_METHOD$1 ] = NoMethod;
                _self[_DYN_ASSEMBLY ] = strTrim(frame);
                _self[_DYN_FILE_NAME ] = "";
                _self[_DYN_LINE ] = 0;
                var matches = frame.match(_StackFrame.regex);
                if (matches && matches[_DYN_LENGTH$4 ] >= 5) {
                    _self[_DYN_METHOD$1 ] = strTrim(matches[2]) || _self[_DYN_METHOD$1 ];
                    _self[_DYN_FILE_NAME ] = strTrim(matches[4]);
                    _self[_DYN_LINE ] = parseInt(matches[5]) || 0;
                }
            }
            else {
                _self[_DYN_LEVEL ] = sourceFrame[_DYN_LEVEL ];
                _self[_DYN_METHOD$1 ] = sourceFrame[_DYN_METHOD$1 ];
                _self[_DYN_ASSEMBLY ] = sourceFrame[_DYN_ASSEMBLY ];
                _self[_DYN_FILE_NAME ] = sourceFrame[_DYN_FILE_NAME ];
                _self[_DYN_LINE ] = sourceFrame[_DYN_LINE ];
                _self[_DYN_SIZE_IN_BYTES ] = 0;
            }
            _self.sizeInBytes += _self.method[_DYN_LENGTH$4 ];
            _self.sizeInBytes += _self.fileName[_DYN_LENGTH$4 ];
            _self.sizeInBytes += _self.assembly[_DYN_LENGTH$4 ];
            _self[_DYN_SIZE_IN_BYTES ] += _StackFrame.baseSize;
            _self.sizeInBytes += _self.level.toString()[_DYN_LENGTH$4 ];
            _self.sizeInBytes += _self.line.toString()[_DYN_LENGTH$4 ];
        }
        _StackFrame.CreateFromInterface = function (frame) {
            return new _StackFrame(frame, null );
        };
        _StackFrame.prototype.toInterface = function () {
            var _self = this;
            return {
                level: _self[_DYN_LEVEL ],
                method: _self[_DYN_METHOD$1 ],
                assembly: _self[_DYN_ASSEMBLY ],
                fileName: _self[_DYN_FILE_NAME ],
                line: _self[_DYN_LINE ]
            };
        };
        _StackFrame.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
        _StackFrame.baseSize = 58;
        return _StackFrame;
    }());

    var DataPoint = /** @class */ (function () {
        function DataPoint() {
            this.aiDataContract = {
                name: 1 ,
                kind: 0 ,
                value: 1 ,
                count: 0 ,
                min: 0 ,
                max: 0 ,
                stdDev: 0
            };
            this.kind = 0 ;
        }
        return DataPoint;
    }());

    var Metric = /** @class */ (function () {
        function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
            this.aiDataContract = {
                ver: 1 ,
                metrics: 1 ,
                properties: 0
            };
            var _self = this;
            _self.ver = 2;
            var dataPoint = new DataPoint();
            dataPoint[_DYN_COUNT$1 ] = count > 0 ? count : undefined;
            dataPoint.max = isNaN(max) || max === null ? undefined : max;
            dataPoint.min = isNaN(min) || min === null ? undefined : min;
            dataPoint[_DYN_NAME$2 ] = dataSanitizeString(logger, name) || strNotSpecified;
            dataPoint.value = value;
            dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
            _self.metrics = [dataPoint];
            _self[_DYN_PROPERTIES ] = dataSanitizeProperties(logger, properties);
            _self[_DYN_MEASUREMENTS$1 ] = dataSanitizeMeasurements(logger, measurements);
        }
        Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
        Metric.dataType = "MetricData";
        return Metric;
    }());

    var PageView = /** @class */ (function () {
        function PageView(logger, name, url, durationMs, properties, measurements, id) {
            this.aiDataContract = {
                ver: 1 ,
                name: 0 ,
                url: 0 ,
                duration: 0 ,
                properties: 0 ,
                measurements: 0 ,
                id: 0
            };
            var _self = this;
            _self.ver = 2;
            _self.id = dataSanitizeId(logger, id);
            _self.url = dataSanitizeUrl(logger, url);
            _self[_DYN_NAME$2 ] = dataSanitizeString(logger, name) || strNotSpecified;
            if (!isNaN(durationMs)) {
                _self[_DYN_DURATION$1 ] = msToTimeSpan(durationMs);
            }
            _self[_DYN_PROPERTIES ] = dataSanitizeProperties(logger, properties);
            _self[_DYN_MEASUREMENTS$1 ] = dataSanitizeMeasurements(logger, measurements);
        }
        PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
        PageView.dataType = "PageviewData";
        return PageView;
    }());

    var RemoteDependencyData = /** @class */ (function () {
        function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
            if (requestAPI === void 0) { requestAPI = "Ajax"; }
            this.aiDataContract = {
                id: 1 ,
                ver: 1 ,
                name: 0 ,
                resultCode: 0 ,
                duration: 0 ,
                success: 0 ,
                data: 0 ,
                target: 0 ,
                type: 0 ,
                properties: 0 ,
                measurements: 0 ,
                kind: 0 ,
                value: 0 ,
                count: 0 ,
                min: 0 ,
                max: 0 ,
                stdDev: 0 ,
                dependencyKind: 0 ,
                dependencySource: 0 ,
                commandName: 0 ,
                dependencyTypeName: 0
            };
            var _self = this;
            _self.ver = 2;
            _self.id = id;
            _self[_DYN_DURATION$1 ] = msToTimeSpan(value);
            _self.success = success;
            _self.resultCode = resultCode + "";
            _self.type = dataSanitizeString(logger, requestAPI);
            var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
            _self.data = dataSanitizeUrl(logger, commandName) || dependencyFields.data;
            _self.target = dataSanitizeString(logger, dependencyFields.target);
            if (correlationContext) {
                _self.target = "".concat(_self.target, " | ").concat(correlationContext);
            }
            _self[_DYN_NAME$2 ] = dataSanitizeString(logger, dependencyFields[_DYN_NAME$2 ]);
            _self[_DYN_PROPERTIES ] = dataSanitizeProperties(logger, properties);
            _self[_DYN_MEASUREMENTS$1 ] = dataSanitizeMeasurements(logger, measurements);
        }
        RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
        RemoteDependencyData.dataType = "RemoteDependencyData";
        return RemoteDependencyData;
    }());

    var Trace = /** @class */ (function () {
        function Trace(logger, message, severityLevel, properties, measurements) {
            this.aiDataContract = {
                ver: 1 ,
                message: 1 ,
                severityLevel: 0 ,
                properties: 0
            };
            var _self = this;
            _self.ver = 2;
            message = message || strNotSpecified;
            _self[_DYN_MESSAGE$1 ] = dataSanitizeMessage(logger, message);
            _self[_DYN_PROPERTIES ] = dataSanitizeProperties(logger, properties);
            _self[_DYN_MEASUREMENTS$1 ] = dataSanitizeMeasurements(logger, measurements);
            if (severityLevel) {
                _self[_DYN_SEVERITY_LEVEL ] = severityLevel;
            }
        }
        Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
        Trace.dataType = "MessageData";
        return Trace;
    }());

    var PageViewPerformance = /** @class */ (function () {
        function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
            this.aiDataContract = {
                ver: 1 ,
                name: 0 ,
                url: 0 ,
                duration: 0 ,
                perfTotal: 0 ,
                networkConnect: 0 ,
                sentRequest: 0 ,
                receivedResponse: 0 ,
                domProcessing: 0 ,
                properties: 0 ,
                measurements: 0
            };
            var _self = this;
            _self.ver = 2;
            _self.url = dataSanitizeUrl(logger, url);
            _self[_DYN_NAME$2 ] = dataSanitizeString(logger, name) || strNotSpecified;
            _self[_DYN_PROPERTIES ] = dataSanitizeProperties(logger, properties);
            _self[_DYN_MEASUREMENTS$1 ] = dataSanitizeMeasurements(logger, measurements);
            if (cs4BaseData) {
                _self.domProcessing = cs4BaseData.domProcessing;
                _self[_DYN_DURATION$1 ] = cs4BaseData[_DYN_DURATION$1 ];
                _self.networkConnect = cs4BaseData.networkConnect;
                _self.perfTotal = cs4BaseData.perfTotal;
                _self[_DYN_RECEIVED_RESPONSE ] = cs4BaseData[_DYN_RECEIVED_RESPONSE ];
                _self.sentRequest = cs4BaseData.sentRequest;
            }
        }
        PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
        PageViewPerformance.dataType = "PageviewPerformanceData";
        return PageViewPerformance;
    }());

    var Data = /** @class */ (function () {
        function Data(baseType, data) {
            this.aiDataContract = {
                baseType: 1 ,
                baseData: 1
            };
            this.baseType = baseType;
            this.baseData = data;
        }
        return Data;
    }());

    var SeverityLevel = createEnumStyle({
        Verbose: 0 ,
        Information: 1 ,
        Warning: 2 ,
        Error: 3 ,
        Critical: 4
    });

    var ConfigurationManager = /** @class */ (function () {
        function ConfigurationManager() {
        }
        ConfigurationManager.getConfig = function (config, field, identifier, defaultValue) {
            if (defaultValue === void 0) { defaultValue = false; }
            var configValue;
            if (identifier && config[_DYN_EXTENSION_CONFIG ] && config[_DYN_EXTENSION_CONFIG ][identifier] && !isNullOrUndefined(config[_DYN_EXTENSION_CONFIG ][identifier][field])) {
                configValue = config[_DYN_EXTENSION_CONFIG ][identifier][field];
            }
            else {
                configValue = config[field];
            }
            return !isNullOrUndefined(configValue) ? configValue : defaultValue;
        };
        return ConfigurationManager;
    }());

    function _aiNameFunc(baseName) {
        var aiName = "ai." + baseName + ".";
        return function (name) {
            return aiName + name;
        };
    }
    var _aiApplication = _aiNameFunc("application");
    var _aiDevice = _aiNameFunc("device");
    var _aiLocation = _aiNameFunc("location");
    var _aiOperation = _aiNameFunc("operation");
    var _aiSession = _aiNameFunc("session");
    var _aiUser = _aiNameFunc("user");
    var _aiCloud = _aiNameFunc("cloud");
    var _aiInternal = _aiNameFunc("internal");
    var ContextTagKeys = /** @class */ (function (_super) {
        __extendsFn(ContextTagKeys, _super);
        function ContextTagKeys() {
            return _super.call(this) || this;
        }
        return ContextTagKeys;
    }(createClassFromInterface({
        applicationVersion: _aiApplication("ver"),
        applicationBuild: _aiApplication("build"),
        applicationTypeId: _aiApplication("typeId"),
        applicationId: _aiApplication("applicationId"),
        applicationLayer: _aiApplication("layer"),
        deviceId: _aiDevice("id"),
        deviceIp: _aiDevice("ip"),
        deviceLanguage: _aiDevice("language"),
        deviceLocale: _aiDevice("locale"),
        deviceModel: _aiDevice("model"),
        deviceFriendlyName: _aiDevice("friendlyName"),
        deviceNetwork: _aiDevice("network"),
        deviceNetworkName: _aiDevice("networkName"),
        deviceOEMName: _aiDevice("oemName"),
        deviceOS: _aiDevice("os"),
        deviceOSVersion: _aiDevice("osVersion"),
        deviceRoleInstance: _aiDevice("roleInstance"),
        deviceRoleName: _aiDevice("roleName"),
        deviceScreenResolution: _aiDevice("screenResolution"),
        deviceType: _aiDevice("type"),
        deviceMachineName: _aiDevice("machineName"),
        deviceVMName: _aiDevice("vmName"),
        deviceBrowser: _aiDevice("browser"),
        deviceBrowserVersion: _aiDevice("browserVersion"),
        locationIp: _aiLocation("ip"),
        locationCountry: _aiLocation("country"),
        locationProvince: _aiLocation("province"),
        locationCity: _aiLocation("city"),
        operationId: _aiOperation("id"),
        operationName: _aiOperation("name"),
        operationParentId: _aiOperation("parentId"),
        operationRootId: _aiOperation("rootId"),
        operationSyntheticSource: _aiOperation("syntheticSource"),
        operationCorrelationVector: _aiOperation("correlationVector"),
        sessionId: _aiSession("id"),
        sessionIsFirst: _aiSession("isFirst"),
        sessionIsNew: _aiSession("isNew"),
        userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
        userAccountId: _aiUser("accountId"),
        userAgent: _aiUser("userAgent"),
        userId: _aiUser("id"),
        userStoreRegion: _aiUser("storeRegion"),
        userAuthUserId: _aiUser("authUserId"),
        userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
        userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
        cloudName: _aiCloud("name"),
        cloudRole: _aiCloud("role"),
        cloudRoleVer: _aiCloud("roleVer"),
        cloudRoleInstance: _aiCloud("roleInstance"),
        cloudEnvironment: _aiCloud("environment"),
        cloudLocation: _aiCloud("location"),
        cloudDeploymentUnit: _aiCloud("deploymentUnit"),
        internalNodeName: _aiInternal("nodeName"),
        internalSdkVersion: _aiInternal("sdkVersion"),
        internalAgentVersion: _aiInternal("agentVersion"),
        internalSnippet: _aiInternal("snippet"),
        internalSdkSrc: _aiInternal("sdkSrc")
    })));

    function createTelemetryItem(item, baseType, envelopeName, logger, customProperties, systemProperties) {
        var _a;
        envelopeName = dataSanitizeString(logger, envelopeName) || strNotSpecified;
        if (isNullOrUndefined(item) ||
            isNullOrUndefined(baseType) ||
            isNullOrUndefined(envelopeName)) {
            throwError("Input doesn't contain all required fields");
        }
        var iKey = "";
        if (item[strIkey]) {
            iKey = item[strIkey];
            delete item[strIkey];
        }
        var telemetryItem = (_a = {},
            _a[_DYN_NAME$2 ] = envelopeName,
            _a.time = toISOString(new Date()),
            _a.iKey = iKey,
            _a.ext = systemProperties ? systemProperties : {},
            _a.tags = [],
            _a.data = {},
            _a.baseType = baseType,
            _a.baseData = item
        ,
            _a);
        if (!isNullOrUndefined(customProperties)) {
            objForEachKey(customProperties, function (prop, value) {
                telemetryItem.data[prop] = value;
            });
        }
        return telemetryItem;
    }
    var TelemetryItemCreator = /** @class */ (function () {
        function TelemetryItemCreator() {
        }
        TelemetryItemCreator.create = createTelemetryItem;
        return TelemetryItemCreator;
    }());

    var Extensions = {
        UserExt: "user",
        DeviceExt: "device",
        TraceExt: "trace",
        WebExt: "web",
        AppExt: "app",
        OSExt: "os",
        SessionExt: "ses",
        SDKExt: "sdk"
    };
    var CtxTagKeys = new ContextTagKeys();

    var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
    var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
    var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";

    var _DYN_TO_STRING$1 = "toString";
    var _DYN_DISABLE_EXCEPTION_TR0 = "disableExceptionTracking";
    var _DYN_AUTO_TRACK_PAGE_VISI1 = "autoTrackPageVisitTime";
    var _DYN_OVERRIDE_PAGE_VIEW_D2 = "overridePageViewDuration";
    var _DYN_ENABLE_UNHANDLED_PRO3 = "enableUnhandledPromiseRejectionTracking";
    var _DYN_SAMPLING_PERCENTAGE$2 = "samplingPercentage";
    var _DYN_IS_STORAGE_USE_DISAB4 = "isStorageUseDisabled";
    var _DYN_IS_BROWSER_LINK_TRAC5 = "isBrowserLinkTrackingEnabled";
    var _DYN_ENABLE_AUTO_ROUTE_TR6 = "enableAutoRouteTracking";
    var _DYN_NAME_PREFIX$2 = "namePrefix";
    var _DYN_DISABLE_FLUSH_ON_BEF7 = "disableFlushOnBeforeUnload";
    var _DYN_CORE$1 = "core";
    var _DYN_DATA_TYPE$1 = "dataType";
    var _DYN_ENVELOPE_TYPE$1 = "envelopeType";
    var _DYN_DIAG_LOG$1 = "diagLog";
    var _DYN_TRACK = "track";
    var _DYN_TRACK_PAGE_VIEW = "trackPageView";
    var _DYN_TRACK_PREVIOUS_PAGE_9 = "trackPreviousPageVisit";
    var _DYN_SEND_PAGE_VIEW_INTER10 = "sendPageViewInternal";
    var _DYN_SEND_PAGE_VIEW_PERFO11 = "sendPageViewPerformanceInternal";
    var _DYN_POPULATE_PAGE_VIEW_P12 = "populatePageViewPerformanceEvent";
    var _DYN_HREF = "href";
    var _DYN_SEND_EXCEPTION_INTER13 = "sendExceptionInternal";
    var _DYN_EXCEPTION = "exception";
    var _DYN_ERROR = "error";
    var _DYN__ONERROR = "_onerror";
    var _DYN_ERROR_SRC = "errorSrc";
    var _DYN_LINE_NUMBER = "lineNumber";
    var _DYN_COLUMN_NUMBER = "columnNumber";
    var _DYN_MESSAGE = "message";
    var _DYN__CREATE_AUTO_EXCEPTI14 = "CreateAutoException";
    var _DYN_ADD_TELEMETRY_INITIA15 = "addTelemetryInitializer";
    var _DYN_DURATION = "duration";
    var _DYN_LENGTH$3 = "length";
    var _DYN_IS_PERFORMANCE_TIMIN16 = "isPerformanceTimingSupported";
    var _DYN_GET_PERFORMANCE_TIMI17 = "getPerformanceTiming";
    var _DYN_NAVIGATION_START = "navigationStart";
    var _DYN_SHOULD_COLLECT_DURAT18 = "shouldCollectDuration";
    var _DYN_IS_PERFORMANCE_TIMIN19 = "isPerformanceTimingDataReady";
    var _DYN_GET_ENTRIES_BY_TYPE = "getEntriesByType";
    var _DYN_RESPONSE_START = "responseStart";
    var _DYN_REQUEST_START = "requestStart";
    var _DYN_LOAD_EVENT_END = "loadEventEnd";
    var _DYN_RESPONSE_END = "responseEnd";
    var _DYN_CONNECT_END = "connectEnd";
    var _DYN_PAGE_VISIT_START_TIM20 = "pageVisitStartTime";

    var _isWebWorker$1 = null;
    function isWebWorker$1() {
        if (_isWebWorker$1 == null) {
            try {
                _isWebWorker$1 = !!(self && self instanceof WorkerGlobalScope);
            }
            catch (e) {
                _isWebWorker$1 = false;
            }
        }
        return _isWebWorker$1;
    }
    var PageViewManager = /** @class */ (function () {
        function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
            dynamicProto(PageViewManager, this, function (_self) {
                var queueTimer = null;
                var itemQueue = [];
                var pageViewPerformanceSent = false;
                var _logger;
                if (core) {
                    _logger = core.logger;
                }
                function _flushChannels(isAsync) {
                    if (core) {
                        core.flush(isAsync);
                    }
                }
                function _startTimer() {
                    if (!queueTimer) {
                        queueTimer = setTimeout((function () {
                            queueTimer = null;
                            var allItems = itemQueue.slice(0);
                            var doFlush = false;
                            itemQueue = [];
                            arrForEach(allItems, function (item) {
                                if (!item()) {
                                    itemQueue.push(item);
                                }
                                else {
                                    doFlush = true;
                                }
                            });
                            if (itemQueue[_DYN_LENGTH$3 ] > 0) {
                                _startTimer();
                            }
                            if (doFlush) {
                                _flushChannels(true);
                            }
                        }), 100);
                    }
                }
                function _addQueue(cb) {
                    itemQueue.push(cb);
                    _startTimer();
                }
                _self[_DYN_TRACK_PAGE_VIEW ] = function (pageView, customProperties) {
                    var name = pageView.name;
                    if (isNullOrUndefined(name) || typeof name !== "string") {
                        var doc = getDocument();
                        name = pageView.name = doc && doc.title || "";
                    }
                    var uri = pageView.uri;
                    if (isNullOrUndefined(uri) || typeof uri !== "string") {
                        var location_1 = getLocation();
                        uri = pageView.uri = location_1 && location_1[_DYN_HREF ] || "";
                    }
                    if (!pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN16 ]()) {
                        appInsights[_DYN_SEND_PAGE_VIEW_INTER10 ](pageView, customProperties);
                        _flushChannels(true);
                        if (!isWebWorker$1()) {
                            _throwInternal(_logger, 2 , 25 , "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                        }
                        return;
                    }
                    var pageViewSent = false;
                    var customDuration;
                    var start = pageViewPerformanceManager[_DYN_GET_PERFORMANCE_TIMI17 ]()[_DYN_NAVIGATION_START ];
                    if (start > 0) {
                        customDuration = dateTimeUtilsDuration(start, +new Date);
                        if (!pageViewPerformanceManager[_DYN_SHOULD_COLLECT_DURAT18 ](customDuration)) {
                            customDuration = undefined;
                        }
                    }
                    var duration;
                    if (!isNullOrUndefined(customProperties) &&
                        !isNullOrUndefined(customProperties[_DYN_DURATION ])) {
                        duration = customProperties[_DYN_DURATION ];
                    }
                    if (overridePageViewDuration || !isNaN(duration)) {
                        if (isNaN(duration)) {
                            if (!customProperties) {
                                customProperties = {};
                            }
                            customProperties[_DYN_DURATION ] = customDuration;
                        }
                        appInsights[_DYN_SEND_PAGE_VIEW_INTER10 ](pageView, customProperties);
                        _flushChannels(true);
                        pageViewSent = true;
                    }
                    var maxDurationLimit = 60000;
                    if (!customProperties) {
                        customProperties = {};
                    }
                    _addQueue(function () {
                        var processed = false;
                        try {
                            if (pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN19 ]()) {
                                processed = true;
                                var pageViewPerformance = {
                                    name: name,
                                    uri: uri
                                };
                                pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P12 ](pageViewPerformance);
                                if (!pageViewPerformance.isValid && !pageViewSent) {
                                    customProperties[_DYN_DURATION ] = customDuration;
                                    appInsights[_DYN_SEND_PAGE_VIEW_INTER10 ](pageView, customProperties);
                                }
                                else {
                                    if (!pageViewSent) {
                                        customProperties[_DYN_DURATION ] = pageViewPerformance.durationMs;
                                        appInsights[_DYN_SEND_PAGE_VIEW_INTER10 ](pageView, customProperties);
                                    }
                                    if (!pageViewPerformanceSent) {
                                        appInsights[_DYN_SEND_PAGE_VIEW_PERFO11 ](pageViewPerformance, customProperties);
                                        pageViewPerformanceSent = true;
                                    }
                                }
                            }
                            else if (start > 0 && dateTimeUtilsDuration(start, +new Date) > maxDurationLimit) {
                                processed = true;
                                if (!pageViewSent) {
                                    customProperties[_DYN_DURATION ] = maxDurationLimit;
                                    appInsights[_DYN_SEND_PAGE_VIEW_INTER10 ](pageView, customProperties);
                                }
                            }
                        }
                        catch (e) {
                            _throwInternal(_logger, 1 , 38 , "trackPageView failed on page load calculation: " + getExceptionName(e), { exception: dumpObj(e) });
                        }
                        return processed;
                    });
                };
                _self.teardown = function (unloadCtx, unloadState) {
                    if (queueTimer) {
                        clearTimeout(queueTimer);
                        queueTimer = null;
                        var allItems = itemQueue.slice(0);
                        itemQueue = [];
                        arrForEach(allItems, function (item) {
                            if (item()) ;
                        });
                    }
                };
            });
        }
        PageViewManager.__ieDyn=1;
        return PageViewManager;
    }());

    var MAX_DURATION_ALLOWED = 3600000;
    var botAgentNames = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
    function _isPerformanceTimingSupported() {
        var perf = getPerformance();
        return perf && !!perf.timing;
    }
    function _isPerformanceNavigationTimingSupported() {
        var perf = getPerformance();
        return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[_DYN_LENGTH$3 ] > 0;
    }
    function _isPerformanceTimingDataReady() {
        var perf = getPerformance();
        var timing = perf ? perf.timing : 0;
        return timing
            && timing.domainLookupStart > 0
            && timing[_DYN_NAVIGATION_START ] > 0
            && timing[_DYN_RESPONSE_START ] > 0
            && timing[_DYN_REQUEST_START ] > 0
            && timing[_DYN_LOAD_EVENT_END ] > 0
            && timing[_DYN_RESPONSE_END ] > 0
            && timing[_DYN_CONNECT_END ] > 0
            && timing.domLoading > 0;
    }
    function _getPerformanceTiming() {
        if (_isPerformanceTimingSupported()) {
            return getPerformance().timing;
        }
        return null;
    }
    function _getPerformanceNavigationTiming() {
        if (_isPerformanceNavigationTimingSupported()) {
            return getPerformance()[_DYN_GET_ENTRIES_BY_TYPE ]("navigation")[0];
        }
        return null;
    }
    function _shouldCollectDuration() {
        var durations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            durations[_i] = arguments[_i];
        }
        var _navigator = getNavigator() || {};
        var userAgent = _navigator.userAgent;
        var isGoogleBot = false;
        if (userAgent) {
            for (var i = 0; i < botAgentNames[_DYN_LENGTH$3 ]; i++) {
                isGoogleBot = isGoogleBot || userAgent.toLowerCase().indexOf(botAgentNames[i]) !== -1;
            }
        }
        if (isGoogleBot) {
            return false;
        }
        else {
            for (var i = 0; i < durations[_DYN_LENGTH$3 ]; i++) {
                if (durations[i] < 0 || durations[i] >= MAX_DURATION_ALLOWED) {
                    return false;
                }
            }
        }
        return true;
    }
    var PageViewPerformanceManager = /** @class */ (function () {
        function PageViewPerformanceManager(core) {
            var _logger = safeGetLogger(core);
            dynamicProto(PageViewPerformanceManager, this, function (_self) {
                _self[_DYN_POPULATE_PAGE_VIEW_P12 ] = function (pageViewPerformance) {
                    pageViewPerformance.isValid = false;
                    var navigationTiming = _getPerformanceNavigationTiming();
                    var timing = _getPerformanceTiming();
                    var total = 0;
                    var network = 0;
                    var request = 0;
                    var response = 0;
                    var dom = 0;
                    if (navigationTiming || timing) {
                        if (navigationTiming) {
                            total = navigationTiming[_DYN_DURATION ];
                            network = navigationTiming.startTime === 0 ? navigationTiming[_DYN_CONNECT_END ] : dateTimeUtilsDuration(navigationTiming.startTime, navigationTiming[_DYN_CONNECT_END ]);
                            request = dateTimeUtilsDuration(navigationTiming.requestStart, navigationTiming[_DYN_RESPONSE_START ]);
                            response = dateTimeUtilsDuration(navigationTiming[_DYN_RESPONSE_START ], navigationTiming[_DYN_RESPONSE_END ]);
                            dom = dateTimeUtilsDuration(navigationTiming.responseEnd, navigationTiming[_DYN_LOAD_EVENT_END ]);
                        }
                        else {
                            total = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START ], timing[_DYN_LOAD_EVENT_END ]);
                            network = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START ], timing[_DYN_CONNECT_END ]);
                            request = dateTimeUtilsDuration(timing.requestStart, timing[_DYN_RESPONSE_START ]);
                            response = dateTimeUtilsDuration(timing[_DYN_RESPONSE_START ], timing[_DYN_RESPONSE_END ]);
                            dom = dateTimeUtilsDuration(timing.responseEnd, timing[_DYN_LOAD_EVENT_END ]);
                        }
                        if (total === 0) {
                            _throwInternal(_logger, 2 , 10 , "error calculating page view performance.", { total: total, network: network, request: request, response: response, dom: dom });
                        }
                        else if (!_self[_DYN_SHOULD_COLLECT_DURAT18 ](total, network, request, response, dom)) {
                            _throwInternal(_logger, 2 , 45 , "Invalid page load duration value. Browser perf data won't be sent.", { total: total, network: network, request: request, response: response, dom: dom });
                        }
                        else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) {
                            _throwInternal(_logger, 2 , 8 , "client performance math error.", { total: total, network: network, request: request, response: response, dom: dom });
                        }
                        else {
                            pageViewPerformance.durationMs = total;
                            pageViewPerformance.perfTotal = pageViewPerformance[_DYN_DURATION ] = msToTimeSpan(total);
                            pageViewPerformance.networkConnect = msToTimeSpan(network);
                            pageViewPerformance.sentRequest = msToTimeSpan(request);
                            pageViewPerformance.receivedResponse = msToTimeSpan(response);
                            pageViewPerformance.domProcessing = msToTimeSpan(dom);
                            pageViewPerformance.isValid = true;
                        }
                    }
                };
                _self[_DYN_GET_PERFORMANCE_TIMI17 ] = _getPerformanceTiming;
                _self[_DYN_IS_PERFORMANCE_TIMIN16 ] = _isPerformanceTimingSupported;
                _self[_DYN_IS_PERFORMANCE_TIMIN19 ] = _isPerformanceTimingDataReady;
                _self[_DYN_SHOULD_COLLECT_DURAT18 ] = _shouldCollectDuration;
            });
        }
        PageViewPerformanceManager.__ieDyn=1;
        return PageViewPerformanceManager;
    }());

    var PageVisitTimeManager = /** @class */ (function () {
        function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
            var prevPageVisitDataKeyName = "prevPageVisitData";
            dynamicProto(PageVisitTimeManager, this, function (_self) {
                _self[_DYN_TRACK_PREVIOUS_PAGE_9 ] = function (currentPageName, currentPageUrl) {
                    try {
                        var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                        if (prevPageVisitTimeData) {
                            pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
                        }
                    }
                    catch (e) {
                        _warnToConsole(logger, "Auto track page visit time failed, metric will not be collected: " + dumpObj(e));
                    }
                };
                function restartPageVisitTimer(pageName, pageUrl) {
                    var prevPageVisitData = null;
                    try {
                        prevPageVisitData = stopPageVisitTimer();
                        startPageVisitTimer(pageName, pageUrl);
                    }
                    catch (e) {
                        _warnToConsole(logger, "Call to restart failed: " + dumpObj(e));
                        prevPageVisitData = null;
                    }
                    return prevPageVisitData;
                }
                function startPageVisitTimer(pageName, pageUrl) {
                    try {
                        if (utlCanUseSessionStorage()) {
                            if (utlGetSessionStorage(logger, prevPageVisitDataKeyName) != null) {
                                throwError("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                            }
                            var currPageVisitData = new PageVisitData(pageName, pageUrl);
                            var currPageVisitDataStr = getJSON().stringify(currPageVisitData);
                            utlSetSessionStorage(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
                        }
                    }
                    catch (e) {
                        _warnToConsole(logger, "Call to start failed: " + dumpObj(e));
                    }
                }
                function stopPageVisitTimer() {
                    var prevPageVisitData = null;
                    try {
                        if (utlCanUseSessionStorage()) {
                            var pageVisitEndTime = dateNow();
                            var pageVisitDataJsonStr = utlGetSessionStorage(logger, prevPageVisitDataKeyName);
                            if (pageVisitDataJsonStr && hasJSON()) {
                                prevPageVisitData = getJSON().parse(pageVisitDataJsonStr);
                                prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[_DYN_PAGE_VISIT_START_TIM20 ];
                                utlRemoveSessionStorage(logger, prevPageVisitDataKeyName);
                            }
                        }
                    }
                    catch (e) {
                        _warnToConsole(logger, "Stop page visit timer failed: " + dumpObj(e));
                        prevPageVisitData = null;
                    }
                    return prevPageVisitData;
                }
                objDefineAccessors(_self, "_logger", function () { return logger; });
                objDefineAccessors(_self, "pageVisitTimeTrackingHandler", function () { return pageVisitTimeTrackingHandler; });
            });
        }
        PageVisitTimeManager.__ieDyn=1;
        return PageVisitTimeManager;
    }());
    var PageVisitData = /** @class */ (function () {
        function PageVisitData(pageName, pageUrl) {
            this[_DYN_PAGE_VISIT_START_TIM20 ] = dateNow();
            this.pageName = pageName;
            this.pageUrl = pageUrl;
        }
        return PageVisitData;
    }());

    var Timing = /** @class */ (function () {
        function Timing(logger, name) {
            var _self = this;
            var _events = {};
            _self.start = function (name) {
                if (typeof _events[name] !== "undefined") {
                    _throwInternal(logger, 2 , 62 , "start was called more than once for this event without calling stop.", { name: name, key: name }, true);
                }
                _events[name] = +new Date;
            };
            _self.stop = function (name, url, properties, measurements) {
                var start = _events[name];
                if (isNaN(start)) {
                    _throwInternal(logger, 2 , 63 , "stop was called without a corresponding start.", { name: name, key: name }, true);
                }
                else {
                    var end = +new Date;
                    var duration = dateTimeUtilsDuration(start, end);
                    _self.action(name, url, duration, properties, measurements);
                }
                delete _events[name];
                _events[name] = undefined;
            };
        }
        return Timing;
    }());

    var strEvent = "event";
    function _dispatchEvent(target, evnt) {
        if (target && target.dispatchEvent && evnt) {
            target.dispatchEvent(evnt);
        }
    }
    function _getReason(error) {
        if (error && error.reason) {
            var reason = error.reason;
            if (!isString(reason) && isFunction(reason[_DYN_TO_STRING$1 ])) {
                return reason[_DYN_TO_STRING$1 ]();
            }
            return dumpObj(reason);
        }
        return error || "";
    }
    var MinMilliSeconds = 60000;
    function _configMilliseconds(value, defValue) {
        value = value || defValue;
        if (value < MinMilliSeconds) {
            value = MinMilliSeconds;
        }
        return value;
    }
    function _getDefaultConfig$1(config) {
        if (!config) {
            config = {};
        }
        config.sessionRenewalMs = _configMilliseconds(config.sessionRenewalMs, 30 * 60 * 1000);
        config.sessionExpirationMs = _configMilliseconds(config.sessionExpirationMs, 24 * 60 * 60 * 1000);
        config[_DYN_DISABLE_EXCEPTION_TR0 ] = stringToBoolOrDefault(config[_DYN_DISABLE_EXCEPTION_TR0 ]);
        config[_DYN_AUTO_TRACK_PAGE_VISI1 ] = stringToBoolOrDefault(config[_DYN_AUTO_TRACK_PAGE_VISI1 ]);
        config[_DYN_OVERRIDE_PAGE_VIEW_D2 ] = stringToBoolOrDefault(config[_DYN_OVERRIDE_PAGE_VIEW_D2 ]);
        config[_DYN_ENABLE_UNHANDLED_PRO3 ] = stringToBoolOrDefault(config[_DYN_ENABLE_UNHANDLED_PRO3 ]);
        if (isNaN(config[_DYN_SAMPLING_PERCENTAGE$2 ]) || config[_DYN_SAMPLING_PERCENTAGE$2 ] <= 0 || config[_DYN_SAMPLING_PERCENTAGE$2 ] >= 100) {
            config[_DYN_SAMPLING_PERCENTAGE$2 ] = 100;
        }
        config[_DYN_IS_STORAGE_USE_DISAB4 ] = stringToBoolOrDefault(config[_DYN_IS_STORAGE_USE_DISAB4 ]);
        config[_DYN_IS_BROWSER_LINK_TRAC5 ] = stringToBoolOrDefault(config[_DYN_IS_BROWSER_LINK_TRAC5 ]);
        config[_DYN_ENABLE_AUTO_ROUTE_TR6 ] = stringToBoolOrDefault(config[_DYN_ENABLE_AUTO_ROUTE_TR6 ]);
        config[_DYN_NAME_PREFIX$2 ] = config[_DYN_NAME_PREFIX$2 ] || "";
        config.enableDebug = stringToBoolOrDefault(config.enableDebug);
        config[_DYN_DISABLE_FLUSH_ON_BEF7 ] = stringToBoolOrDefault(config[_DYN_DISABLE_FLUSH_ON_BEF7 ]);
        config.disableFlushOnUnload = stringToBoolOrDefault(config.disableFlushOnUnload, config[_DYN_DISABLE_FLUSH_ON_BEF7 ]);
        return config;
    }
    function _updateStorageUsage(extConfig) {
        if (!isUndefined(extConfig[_DYN_IS_STORAGE_USE_DISAB4 ])) {
            if (extConfig[_DYN_IS_STORAGE_USE_DISAB4 ]) {
                utlDisableStorage();
            }
            else {
                utlEnableStorage();
            }
        }
    }
    var AnalyticsPlugin = /** @class */ (function (_super) {
        __extendsFn(AnalyticsPlugin, _super);
        function AnalyticsPlugin() {
            var _this = _super.call(this) || this;
            _this.identifier = AnalyticsPluginIdentifier;
            _this.priority = 180;
            _this.autoRoutePVDelay = 500;
            var _eventTracking;
            var _pageTracking;
            var _pageViewManager;
            var _pageViewPerformanceManager;
            var _pageVisitTimeManager;
            var _preInitTelemetryInitializers;
            var _isBrowserLinkTrackingEnabled;
            var _browserLinkInitializerAdded;
            var _enableAutoRouteTracking;
            var _historyListenerAdded;
            var _disableExceptionTracking;
            var _autoExceptionInstrumented;
            var _enableUnhandledPromiseRejectionTracking;
            var _autoUnhandledPromiseInstrumented;
            var _prevUri;
            var _currUri;
            var _evtNamespace;
            dynamicProto(AnalyticsPlugin, _this, function (_self, _base) {
                var _addHook = _base._addHook;
                _initDefaults();
                _self.getCookieMgr = function () {
                    return safeGetCookieMgr(_self[_DYN_CORE$1 ]);
                };
                _self.processTelemetry = function (env, itemCtx) {
                    _self.processNext(env, itemCtx);
                };
                _self.trackEvent = function (event, customProperties) {
                    try {
                        var telemetryItem = createTelemetryItem(event, Event$1[_DYN_DATA_TYPE$1 ], Event$1[_DYN_ENVELOPE_TYPE$1 ], _self[_DYN_DIAG_LOG$1 ](), customProperties);
                        _self[_DYN_CORE$1 ][_DYN_TRACK ](telemetryItem);
                    }
                    catch (e) {
                        _throwInternal(2 , 39 , "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                };
                _self.startTrackEvent = function (name) {
                    try {
                        _eventTracking.start(name);
                    }
                    catch (e) {
                        _throwInternal(1 , 29 , "startTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                };
                _self.stopTrackEvent = function (name, properties, measurements) {
                    try {
                        _eventTracking.stop(name, undefined, properties, measurements);
                    }
                    catch (e) {
                        _throwInternal(1 , 30 , "stopTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                };
                _self.trackTrace = function (trace, customProperties) {
                    try {
                        var telemetryItem = createTelemetryItem(trace, Trace[_DYN_DATA_TYPE$1 ], Trace[_DYN_ENVELOPE_TYPE$1 ], _self[_DYN_DIAG_LOG$1 ](), customProperties);
                        _self[_DYN_CORE$1 ][_DYN_TRACK ](telemetryItem);
                    }
                    catch (e) {
                        _throwInternal(2 , 39 , "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                };
                _self.trackMetric = function (metric, customProperties) {
                    try {
                        var telemetryItem = createTelemetryItem(metric, Metric[_DYN_DATA_TYPE$1 ], Metric[_DYN_ENVELOPE_TYPE$1 ], _self[_DYN_DIAG_LOG$1 ](), customProperties);
                        _self[_DYN_CORE$1 ][_DYN_TRACK ](telemetryItem);
                    }
                    catch (e) {
                        _throwInternal(1 , 36 , "trackMetric failed, metric will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                };
                _self[_DYN_TRACK_PAGE_VIEW ] = function (pageView, customProperties) {
                    try {
                        var inPv = pageView || {};
                        _pageViewManager[_DYN_TRACK_PAGE_VIEW ](inPv, __assignFn(__assignFn(__assignFn({}, inPv.properties), inPv.measurements), customProperties));
                        if (_self.config[_DYN_AUTO_TRACK_PAGE_VISI1 ]) {
                            _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_9 ](inPv.name, inPv.uri);
                        }
                    }
                    catch (e) {
                        _throwInternal(1 , 37 , "trackPageView failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                };
                _self[_DYN_SEND_PAGE_VIEW_INTER10 ] = function (pageView, properties, systemProperties) {
                    var doc = getDocument();
                    if (doc) {
                        pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
                    }
                    var telemetryItem = createTelemetryItem(pageView, PageView[_DYN_DATA_TYPE$1 ], PageView[_DYN_ENVELOPE_TYPE$1 ], _self[_DYN_DIAG_LOG$1 ](), properties, systemProperties);
                    _self[_DYN_CORE$1 ][_DYN_TRACK ](telemetryItem);
                };
                _self[_DYN_SEND_PAGE_VIEW_PERFO11 ] = function (pageViewPerformance, properties, systemProperties) {
                    var telemetryItem = createTelemetryItem(pageViewPerformance, PageViewPerformance[_DYN_DATA_TYPE$1 ], PageViewPerformance[_DYN_ENVELOPE_TYPE$1 ], _self[_DYN_DIAG_LOG$1 ](), properties, systemProperties);
                    _self[_DYN_CORE$1 ][_DYN_TRACK ](telemetryItem);
                };
                _self.trackPageViewPerformance = function (pageViewPerformance, customProperties) {
                    var inPvp = pageViewPerformance || {};
                    try {
                        _pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P12 ](inPvp);
                        _self[_DYN_SEND_PAGE_VIEW_PERFO11 ](inPvp, customProperties);
                    }
                    catch (e) {
                        _throwInternal(1 , 37 , "trackPageViewPerformance failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                };
                _self.startTrackPage = function (name) {
                    try {
                        if (typeof name !== "string") {
                            var doc = getDocument();
                            name = doc && doc.title || "";
                        }
                        _pageTracking.start(name);
                    }
                    catch (e) {
                        _throwInternal(1 , 31 , "startTrackPage failed, page view may not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                };
                _self.stopTrackPage = function (name, url, properties, measurement) {
                    try {
                        if (typeof name !== "string") {
                            var doc = getDocument();
                            name = doc && doc.title || "";
                        }
                        if (typeof url !== "string") {
                            var loc = getLocation();
                            url = loc && loc[_DYN_HREF ] || "";
                        }
                        _pageTracking.stop(name, url, properties, measurement);
                        if (_self.config[_DYN_AUTO_TRACK_PAGE_VISI1 ]) {
                            _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_9 ](name, url);
                        }
                    }
                    catch (e) {
                        _throwInternal(1 , 32 , "stopTrackPage failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                };
                _self[_DYN_SEND_EXCEPTION_INTER13 ] = function (exception, customProperties, systemProperties) {
                    var theError = (exception && (exception[_DYN_EXCEPTION ] || exception[_DYN_ERROR ])) ||
                        isError(exception) && exception ||
                        { name: (exception && typeof exception), message: exception || strNotSpecified };
                    exception = exception || {};
                    var exceptionPartB = new Exception(_self[_DYN_DIAG_LOG$1 ](), theError, exception.properties || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                    var telemetryItem = createTelemetryItem(exceptionPartB, Exception[_DYN_DATA_TYPE$1 ], Exception[_DYN_ENVELOPE_TYPE$1 ], _self[_DYN_DIAG_LOG$1 ](), customProperties, systemProperties);
                    _self[_DYN_CORE$1 ][_DYN_TRACK ](telemetryItem);
                };
                _self.trackException = function (exception, customProperties) {
                    if (exception && !exception[_DYN_EXCEPTION ] && exception[_DYN_ERROR ]) {
                        exception[_DYN_EXCEPTION ] = exception[_DYN_ERROR ];
                    }
                    try {
                        _self[_DYN_SEND_EXCEPTION_INTER13 ](exception, customProperties);
                    }
                    catch (e) {
                        _throwInternal(1 , 35 , "trackException failed, exception will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                };
                _self[_DYN__ONERROR ] = function (exception) {
                    var error = exception && exception[_DYN_ERROR ];
                    var evt = exception && exception.evt;
                    try {
                        if (!evt) {
                            var _window = getWindow();
                            if (_window) {
                                evt = _window[strEvent];
                            }
                        }
                        var url = (exception && exception.url) || (getDocument() || {}).URL;
                        var errorSrc = exception[_DYN_ERROR_SRC ] || "window.onerror@" + url + ":" + (exception[_DYN_LINE_NUMBER ] || 0) + ":" + (exception[_DYN_COLUMN_NUMBER ] || 0);
                        var properties = {
                            errorSrc: errorSrc,
                            url: url,
                            lineNumber: exception[_DYN_LINE_NUMBER ] || 0,
                            columnNumber: exception[_DYN_COLUMN_NUMBER ] || 0,
                            message: exception[_DYN_MESSAGE ]
                        };
                        if (isCrossOriginError(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[_DYN_ERROR ])) {
                            _sendCORSException(Exception[_DYN__CREATE_AUTO_EXCEPTI14 ]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[_DYN_LINE_NUMBER ] || 0, exception[_DYN_COLUMN_NUMBER ] || 0, error, evt, null, errorSrc), properties);
                        }
                        else {
                            if (!exception[_DYN_ERROR_SRC ]) {
                                exception[_DYN_ERROR_SRC ] = errorSrc;
                            }
                            _self.trackException({ exception: exception, severityLevel: 3  }, properties);
                        }
                    }
                    catch (e) {
                        var errorString = error ? (error.name + ", " + error[_DYN_MESSAGE ]) : "null";
                        _throwInternal(1 , 11 , "_onError threw exception while logging error, error will not be collected: "
                            + getExceptionName(e), { exception: dumpObj(e), errorString: errorString });
                    }
                };
                _self[_DYN_ADD_TELEMETRY_INITIA15 ] = function (telemetryInitializer) {
                    if (_self[_DYN_CORE$1 ]) {
                        return _self[_DYN_CORE$1 ][_DYN_ADD_TELEMETRY_INITIA15 ](telemetryInitializer);
                    }
                    if (!_preInitTelemetryInitializers) {
                        _preInitTelemetryInitializers = [];
                    }
                    _preInitTelemetryInitializers.push(telemetryInitializer);
                };
                _self.initialize = function (config, core, extensions, pluginChain) {
                    if (_self.isInitialized()) {
                        return;
                    }
                    if (isNullOrUndefined(core)) {
                        throwError("Error initializing");
                    }
                    _base.initialize(config, core, extensions, pluginChain);
                    try {
                        _evtNamespace = mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
                        if (_preInitTelemetryInitializers) {
                            arrForEach(_preInitTelemetryInitializers, function (initializer) {
                                core[_DYN_ADD_TELEMETRY_INITIA15 ](initializer);
                            });
                            _preInitTelemetryInitializers = null;
                        }
                        var extConfig = _populateDefaults(config);
                        _updateStorageUsage(extConfig);
                        _pageViewPerformanceManager = new PageViewPerformanceManager(_self[_DYN_CORE$1 ]);
                        _pageViewManager = new PageViewManager(_self, extConfig[_DYN_OVERRIDE_PAGE_VIEW_D2 ], _self[_DYN_CORE$1 ], _pageViewPerformanceManager);
                        _pageVisitTimeManager = new PageVisitTimeManager(_self[_DYN_DIAG_LOG$1 ](), function (pageName, pageUrl, pageVisitTime) { return trackPageVisitTime(pageName, pageUrl, pageVisitTime); });
                        _updateBrowserLinkTracking(extConfig, config);
                        _eventTracking = new Timing(_self[_DYN_DIAG_LOG$1 ](), "trackEvent");
                        _eventTracking.action =
                            function (name, url, duration, properties, measurements) {
                                if (!properties) {
                                    properties = {};
                                }
                                if (!measurements) {
                                    measurements = {};
                                }
                                properties.duration = duration[_DYN_TO_STRING$1 ]();
                                _self.trackEvent({ name: name, properties: properties, measurements: measurements });
                            };
                        _pageTracking = new Timing(_self[_DYN_DIAG_LOG$1 ](), "trackPageView");
                        _pageTracking.action = function (name, url, duration, properties, measurements) {
                            if (isNullOrUndefined(properties)) {
                                properties = {};
                            }
                            properties.duration = duration[_DYN_TO_STRING$1 ]();
                            var pageViewItem = {
                                name: name,
                                uri: url,
                                properties: properties,
                                measurements: measurements
                            };
                            _self[_DYN_SEND_PAGE_VIEW_INTER10 ](pageViewItem, properties);
                        };
                        if (hasWindow()) {
                            _updateExceptionTracking(extConfig);
                            _updateLocationChange(extConfig);
                        }
                    }
                    catch (e) {
                        _self.setInitialized(false);
                        throw e;
                    }
                };
                _self._doTeardown = function (unloadCtx, unloadState) {
                    _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                    eventOff(window, null, null, _evtNamespace);
                    _initDefaults();
                };
                function _populateDefaults(config) {
                    var ctx = createProcessTelemetryContext(null, config, _self[_DYN_CORE$1 ]);
                    var identifier = _self.identifier;
                    var defaults = _getDefaultConfig$1(config);
                    var extConfig = _self.config = ctx.getExtCfg(identifier);
                    if (defaults !== undefined) {
                        objForEachKey(defaults, function (field, value) {
                            extConfig[field] = ctx.getConfig(identifier, field, value);
                            if (extConfig[field] === undefined) {
                                extConfig = value;
                            }
                        });
                    }
                    return extConfig;
                }
                function _updateBrowserLinkTracking(extConfig, config) {
                    _isBrowserLinkTrackingEnabled = extConfig[_DYN_IS_BROWSER_LINK_TRAC5 ] || config[_DYN_IS_BROWSER_LINK_TRAC5 ];
                    _addDefaultTelemetryInitializers();
                }
                function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                    var properties = { PageName: pageName, PageUrl: pageUrl };
                    _self.trackMetric({
                        name: "PageVisitTime",
                        average: pageVisitTime,
                        max: pageVisitTime,
                        min: pageVisitTime,
                        sampleCount: 1
                    }, properties);
                }
                function _addDefaultTelemetryInitializers() {
                    if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                        var browserLinkPaths_1 = ["/browserLinkSignalR/", "/__browserLink/"];
                        var dropBrowserLinkRequests = function (envelope) {
                            if (_isBrowserLinkTrackingEnabled && envelope.baseType === RemoteDependencyData[_DYN_DATA_TYPE$1 ]) {
                                var remoteData = envelope.baseData;
                                if (remoteData) {
                                    for (var i = 0; i < browserLinkPaths_1[_DYN_LENGTH$3 ]; i++) {
                                        if (remoteData.target && remoteData.target.indexOf(browserLinkPaths_1[i]) >= 0) {
                                            return false;
                                        }
                                    }
                                }
                            }
                            return true;
                        };
                        _self[_DYN_ADD_TELEMETRY_INITIA15 ](dropBrowserLinkRequests);
                        _browserLinkInitializerAdded = true;
                    }
                }
                function _sendCORSException(exception, properties) {
                    var telemetryItem = createTelemetryItem(exception, Exception[_DYN_DATA_TYPE$1 ], Exception[_DYN_ENVELOPE_TYPE$1 ], _self[_DYN_DIAG_LOG$1 ](), properties);
                    _self[_DYN_CORE$1 ][_DYN_TRACK ](telemetryItem);
                }
                function _updateExceptionTracking(extConfig) {
                    var _window = getWindow();
                    var locn = getLocation(true);
                    _disableExceptionTracking = extConfig[_DYN_DISABLE_EXCEPTION_TR0 ];
                    if (!_disableExceptionTracking && !_autoExceptionInstrumented && !extConfig.autoExceptionInstrumented) {
                        _addHook(InstrumentEvent(_window, "onerror", {
                            ns: _evtNamespace,
                            rsp: function (callDetails, message, url, lineNumber, columnNumber, error) {
                                if (!_disableExceptionTracking && callDetails.rslt !== true) {
                                    _self[_DYN__ONERROR ](Exception[_DYN__CREATE_AUTO_EXCEPTI14 ](message, url, lineNumber, columnNumber, error, callDetails.evt));
                                }
                            }
                        }, false));
                        _autoExceptionInstrumented = true;
                    }
                    _addUnhandledPromiseRejectionTracking(extConfig, _window, locn);
                }
                function _updateLocationChange(extConfig) {
                    var win = getWindow();
                    var locn = getLocation(true);
                    _enableAutoRouteTracking = extConfig[_DYN_ENABLE_AUTO_ROUTE_TR6 ] === true;
                    if (win && _enableAutoRouteTracking && hasHistory()) {
                        var _history = getHistory();
                        if (isFunction(_history.pushState) && isFunction(_history.replaceState) && typeof Event !== strShimUndefined) {
                            _addHistoryListener(extConfig, win, _history, locn);
                        }
                    }
                }
                function _getDistributedTraceCtx() {
                    var distributedTraceCtx = null;
                    if (_self[_DYN_CORE$1 ] && _self[_DYN_CORE$1 ].getTraceCtx) {
                        distributedTraceCtx = _self[_DYN_CORE$1 ].getTraceCtx(false);
                    }
                    if (!distributedTraceCtx) {
                        var properties = _self[_DYN_CORE$1 ].getPlugin(PropertiesPluginIdentifier);
                        if (properties) {
                            var context = properties.plugin.context;
                            if (context) {
                                distributedTraceCtx = createDistributedTraceContextFromTrace(context.telemetryTrace);
                            }
                        }
                    }
                    return distributedTraceCtx;
                }
                function _addHistoryListener(extConfig, win, history, locn) {
                    var namePrefix = extConfig[_DYN_NAME_PREFIX$2 ] || "";
                    function _popstateHandler() {
                        if (_enableAutoRouteTracking) {
                            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                        }
                    }
                    function _locationChangeHandler() {
                        if (_currUri) {
                            _prevUri = _currUri;
                            _currUri = locn && locn[_DYN_HREF ] || "";
                        }
                        else {
                            _currUri = locn && locn[_DYN_HREF ] || "";
                        }
                        if (_enableAutoRouteTracking) {
                            var distributedTraceCtx = _getDistributedTraceCtx();
                            if (distributedTraceCtx) {
                                distributedTraceCtx.setTraceId(generateW3CId());
                                var traceLocationName = "_unknown_";
                                if (locn && locn.pathname) {
                                    traceLocationName = locn.pathname + (locn.hash || "");
                                }
                                distributedTraceCtx.setName(dataSanitizeString(_self[_DYN_DIAG_LOG$1 ](), traceLocationName));
                            }
                            setTimeout((function (uri) {
                                _self[_DYN_TRACK_PAGE_VIEW ]({ refUri: uri, properties: { duration: 0 } });
                            }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                        }
                    }
                    if (!_historyListenerAdded) {
                        _addHook(InstrumentEvent(history, "pushState", {
                            ns: _evtNamespace,
                            rsp: function () {
                                if (_enableAutoRouteTracking) {
                                    _dispatchEvent(win, createDomEvent(namePrefix + "pushState"));
                                    _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                                }
                            }
                        }, true));
                        _addHook(InstrumentEvent(history, "replaceState", {
                            ns: _evtNamespace,
                            rsp: function () {
                                if (_enableAutoRouteTracking) {
                                    _dispatchEvent(win, createDomEvent(namePrefix + "replaceState"));
                                    _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                                }
                            }
                        }, true));
                        eventOn(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                        eventOn(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                        _historyListenerAdded = true;
                    }
                }
                function _addUnhandledPromiseRejectionTracking(extConfig, _window, _location) {
                    _enableUnhandledPromiseRejectionTracking = extConfig[_DYN_ENABLE_UNHANDLED_PRO3 ] === true;
                    if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                        _addHook(InstrumentEvent(_window, "onunhandledrejection", {
                            ns: _evtNamespace,
                            rsp: function (callDetails, error) {
                                if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) {
                                    _self[_DYN__ONERROR ](Exception[_DYN__CREATE_AUTO_EXCEPTI14 ](_getReason(error), _location ? _location[_DYN_HREF ] : "", 0, 0, error, callDetails.evt));
                                }
                            }
                        }, false));
                        _autoUnhandledPromiseInstrumented = true;
                        extConfig.autoUnhandledPromiseInstrumented = _autoUnhandledPromiseInstrumented;
                    }
                }
                function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                    _self[_DYN_DIAG_LOG$1 ]().throwInternal(severity, msgId, msg, properties, isUserAct);
                }
                function _initDefaults() {
                    _eventTracking = null;
                    _pageTracking = null;
                    _pageViewManager = null;
                    _pageViewPerformanceManager = null;
                    _pageVisitTimeManager = null;
                    _preInitTelemetryInitializers = null;
                    _isBrowserLinkTrackingEnabled = false;
                    _browserLinkInitializerAdded = false;
                    _enableAutoRouteTracking = false;
                    _historyListenerAdded = false;
                    _disableExceptionTracking = false;
                    _autoExceptionInstrumented = false;
                    _enableUnhandledPromiseRejectionTracking = false;
                    _autoUnhandledPromiseInstrumented = false;
                    var location = getLocation(true);
                    _prevUri = location && location[_DYN_HREF ] || "";
                    _currUri = null;
                    _evtNamespace = null;
                }
                objDefineAccessors(_self, "_pageViewManager", function () { return _pageViewManager; });
                objDefineAccessors(_self, "_pageViewPerformanceManager", function () { return _pageViewPerformanceManager; });
                objDefineAccessors(_self, "_pageVisitTimeManager", function () { return _pageVisitTimeManager; });
                objDefineAccessors(_self, "_evtNamespace", function () { return "." + _evtNamespace; });
            });
            return _this;
        }
        AnalyticsPlugin.Version = '2.8.14';
        AnalyticsPlugin.getDefaultConfig = _getDefaultConfig$1;
        return AnalyticsPlugin;
    }(BaseTelemetryPlugin));

    var STR_DURATION$1 = "duration";

    var _DYN_TAGS = "tags";
    var _DYN_DEVICE_TYPE = "deviceType";
    var _DYN_DATA = "data";
    var _DYN_NAME$1 = "name";
    var _DYN_TRACE_ID$1 = "traceID";
    var _DYN_LENGTH$2 = "length";
    var _DYN_STRINGIFY = "stringify";
    var _DYN_MEASUREMENTS = "measurements";
    var _DYN_DATA_TYPE = "dataType";
    var _DYN_ENVELOPE_TYPE = "envelopeType";
    var _DYN_TO_STRING = "toString";
    var _DYN_ON_LINE = "onLine";
    var _DYN_IS_ONLINE = "isOnline";
    var _DYN_ENQUEUE = "enqueue";
    var _DYN_COUNT = "count";
    var _DYN_PUSH$1 = "push";
    var _DYN_EMIT_LINE_DELIMITED_0 = "emitLineDelimitedJson";
    var _DYN_CLEAR = "clear";
    var _DYN_BATCH_PAYLOADS = "batchPayloads";
    var _DYN_MARK_AS_SENT = "markAsSent";
    var _DYN_CLEAR_SENT = "clearSent";
    var _DYN_BUFFER_OVERRIDE = "bufferOverride";
    var _DYN__BUFFER__KEY = "BUFFER_KEY";
    var _DYN__SENT__BUFFER__KEY = "SENT_BUFFER_KEY";
    var _DYN__MAX__BUFFER__SIZE = "MAX_BUFFER_SIZE";
    var _DYN_NAME_PREFIX$1 = "namePrefix";
    var _DYN_MAX_BATCH_SIZE_IN_BY1$1 = "maxBatchSizeInBytes";
    var _DYN_TRIGGER_SEND = "triggerSend";
    var _DYN_DIAG_LOG = "diagLog";
    var _DYN_ONUNLOAD_DISABLE_BEA2 = "onunloadDisableBeacon";
    var _DYN_IS_BEACON_API_DISABL3 = "isBeaconApiDisabled";
    var _DYN__SENDER = "_sender";
    var _DYN__SENDER_CONFIG = "_senderConfig";
    var _DYN_ENABLE_SESSION_STORA4 = "enableSessionStorageBuffer";
    var _DYN__BUFFER = "_buffer";
    var _DYN_SAMPLING_PERCENTAGE$1 = "samplingPercentage";
    var _DYN_INSTRUMENTATION_KEY$1 = "instrumentationKey";
    var _DYN_ENDPOINT_URL$1 = "endpointUrl";
    var _DYN_CUSTOM_HEADERS = "customHeaders";
    var _DYN_DISABLE_XHR = "disableXhr";
    var _DYN_ONUNLOAD_DISABLE_FET5 = "onunloadDisableFetch";
    var _DYN_DISABLE_TELEMETRY$1 = "disableTelemetry";
    var _DYN_BASE_TYPE = "baseType";
    var _DYN_SAMPLE_RATE = "sampleRate";
    var _DYN_CONVERT_UNDEFINED = "convertUndefined";
    var _DYN__XHR_READY_STATE_CHA6 = "_xhrReadyStateChange";
    var _DYN__ON_ERROR = "_onError";
    var _DYN__ON_PARTIAL_SUCCESS = "_onPartialSuccess";
    var _DYN__ON_SUCCESS = "_onSuccess";
    var _DYN_ITEMS_ACCEPTED = "itemsAccepted";
    var _DYN_ITEMS_RECEIVED = "itemsReceived";
    var _DYN_IS_RETRY_DISABLED = "isRetryDisabled";
    var _DYN_SET_REQUEST_HEADER$1 = "setRequestHeader";
    var _DYN_MAX_BATCH_INTERVAL$1 = "maxBatchInterval";
    var _DYN_EVENTS_SEND_REQUEST = "eventsSendRequest";
    var _DYN_DISABLE_INSTRUMENTAT7 = "disableInstrumentationKeyValidation";
    var _DYN_GET_SAMPLING_SCORE = "getSamplingScore";
    var _DYN_GET_HASH_CODE_SCORE = "getHashCodeScore";

    var strBaseType = "baseType";
    var strBaseData = "baseData";
    var strProperties = "properties";
    var strTrue = "true";
    function _setValueIf(target, field, value) {
        return setValue(target, field, value, isTruthy);
    }
    function _extractPartAExtensions(logger, item, env) {
        var envTags = env[_DYN_TAGS ] = env[_DYN_TAGS ] || {};
        var itmExt = item.ext = item.ext || {};
        var itmTags = item[_DYN_TAGS ] = item[_DYN_TAGS ] || [];
        var extUser = itmExt.user;
        if (extUser) {
            _setValueIf(envTags, CtxTagKeys.userAuthUserId, extUser.authId);
            _setValueIf(envTags, CtxTagKeys.userId, extUser.id || extUser.localId);
        }
        var extApp = itmExt.app;
        if (extApp) {
            _setValueIf(envTags, CtxTagKeys.sessionId, extApp.sesId);
        }
        var extDevice = itmExt.device;
        if (extDevice) {
            _setValueIf(envTags, CtxTagKeys.deviceId, extDevice.id || extDevice.localId);
            _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE ], extDevice.deviceClass);
            _setValueIf(envTags, CtxTagKeys.deviceIp, extDevice.ip);
            _setValueIf(envTags, CtxTagKeys.deviceModel, extDevice.model);
            _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE ], extDevice[_DYN_DEVICE_TYPE ]);
        }
        var web = item.ext.web;
        if (web) {
            _setValueIf(envTags, CtxTagKeys.deviceLanguage, web.browserLang);
            _setValueIf(envTags, CtxTagKeys.deviceBrowserVersion, web.browserVer);
            _setValueIf(envTags, CtxTagKeys.deviceBrowser, web.browser);
            var envData = env[_DYN_DATA ] = env[_DYN_DATA ] || {};
            var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
            var envProps = envBaseData[strProperties] = envBaseData[strProperties] || {};
            _setValueIf(envProps, "domain", web.domain);
            _setValueIf(envProps, "isManual", web.isManual ? strTrue : null);
            _setValueIf(envProps, "screenRes", web.screenRes);
            _setValueIf(envProps, "userConsent", web.userConsent ? strTrue : null);
        }
        var extOs = itmExt.os;
        if (extOs) {
            _setValueIf(envTags, CtxTagKeys.deviceOS, extOs[_DYN_NAME$1 ]);
        }
        var extTrace = itmExt.trace;
        if (extTrace) {
            _setValueIf(envTags, CtxTagKeys.operationParentId, extTrace.parentID);
            _setValueIf(envTags, CtxTagKeys.operationName, dataSanitizeString(logger, extTrace[_DYN_NAME$1 ]));
            _setValueIf(envTags, CtxTagKeys.operationId, extTrace[_DYN_TRACE_ID$1 ]);
        }
        var tgs = {};
        for (var i = itmTags[_DYN_LENGTH$2 ] - 1; i >= 0; i--) {
            var tg = itmTags[i];
            objForEachKey(tg, function (key, value) {
                tgs[key] = value;
            });
            itmTags.splice(i, 1);
        }
        objForEachKey(itmTags, function (tg, value) {
            tgs[tg] = value;
        });
        var theTags = __assignFn(__assignFn({}, envTags), tgs);
        if (!theTags[CtxTagKeys.internalSdkVersion]) {
            theTags[CtxTagKeys.internalSdkVersion] = dataSanitizeString(logger, "javascript:".concat(EnvelopeCreator.Version), 64);
        }
        env[_DYN_TAGS ] = optimizeObject(theTags);
    }
    function _extractPropsAndMeasurements(data, properties, measurements) {
        if (!isNullOrUndefined(data)) {
            objForEachKey(data, function (key, value) {
                if (isNumber(value)) {
                    measurements[key] = value;
                }
                else if (isString(value)) {
                    properties[key] = value;
                }
                else if (hasJSON()) {
                    properties[key] = getJSON()[_DYN_STRINGIFY ](value);
                }
            });
        }
    }
    function _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
        if (!isNullOrUndefined(properties)) {
            objForEachKey(properties, function (key, value) {
                properties[key] = value || customUndefinedValue;
            });
        }
    }
    function _createEnvelope(logger, envelopeType, telemetryItem, data) {
        var envelope = new Envelope(logger, data, envelopeType);
        _setValueIf(envelope, "sampleRate", telemetryItem[SampleRate]);
        if ((telemetryItem[strBaseData] || {}).startTime) {
            envelope.time = toISOString(telemetryItem[strBaseData].startTime);
        }
        envelope.iKey = telemetryItem.iKey;
        var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
        envelope[_DYN_NAME$1 ] = envelope[_DYN_NAME$1 ].replace("{0}", iKeyNoDashes);
        _extractPartAExtensions(logger, telemetryItem, envelope);
        telemetryItem[_DYN_TAGS ] = telemetryItem[_DYN_TAGS ] || [];
        return optimizeObject(envelope);
    }
    function EnvelopeCreatorInit(logger, telemetryItem) {
        if (isNullOrUndefined(telemetryItem[strBaseData])) {
            _throwInternal(logger, 1 , 46 , "telemetryItem.baseData cannot be null.");
        }
    }
    var EnvelopeCreator = {
        Version: '2.8.14'
    };
    function DependencyEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
        EnvelopeCreatorInit(logger, telemetryItem);
        var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS ] || {};
        var customProperties = telemetryItem[strBaseData][strProperties] || {};
        _extractPropsAndMeasurements(telemetryItem[_DYN_DATA ], customProperties, customMeasurements);
        if (!isNullOrUndefined(customUndefinedValue)) {
            _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
        }
        var bd = telemetryItem[strBaseData];
        if (isNullOrUndefined(bd)) {
            _warnToConsole(logger, "Invalid input for dependency data");
            return null;
        }
        var method = bd[strProperties] && bd[strProperties][HttpMethod] ? bd[strProperties][HttpMethod] : "GET";
        var remoteDepData = new RemoteDependencyData(logger, bd.id, bd.target, bd[_DYN_NAME$1 ], bd[STR_DURATION$1 ], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
        var data = new Data(RemoteDependencyData[_DYN_DATA_TYPE ], remoteDepData);
        return _createEnvelope(logger, RemoteDependencyData[_DYN_ENVELOPE_TYPE ], telemetryItem, data);
    }
    function EventEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
        EnvelopeCreatorInit(logger, telemetryItem);
        var customProperties = {};
        var customMeasurements = {};
        if (telemetryItem[strBaseType] !== Event$1[_DYN_DATA_TYPE ]) {
            customProperties["baseTypeSource"] = telemetryItem[strBaseType];
        }
        if (telemetryItem[strBaseType] === Event$1[_DYN_DATA_TYPE ]) {
            customProperties = telemetryItem[strBaseData][strProperties] || {};
            customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS ] || {};
        }
        else {
            if (telemetryItem[strBaseData]) {
                _extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
            }
        }
        _extractPropsAndMeasurements(telemetryItem[_DYN_DATA ], customProperties, customMeasurements);
        if (!isNullOrUndefined(customUndefinedValue)) {
            _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
        }
        var eventName = telemetryItem[strBaseData][_DYN_NAME$1 ];
        var eventData = new Event$1(logger, eventName, customProperties, customMeasurements);
        var data = new Data(Event$1[_DYN_DATA_TYPE ], eventData);
        return _createEnvelope(logger, Event$1[_DYN_ENVELOPE_TYPE ], telemetryItem, data);
    }
    function ExceptionEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
        EnvelopeCreatorInit(logger, telemetryItem);
        var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS ] || {};
        var customProperties = telemetryItem[strBaseData][strProperties] || {};
        _extractPropsAndMeasurements(telemetryItem[_DYN_DATA ], customProperties, customMeasurements);
        if (!isNullOrUndefined(customUndefinedValue)) {
            _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
        }
        var bd = telemetryItem[strBaseData];
        var exData = Exception.CreateFromInterface(logger, bd, customProperties, customMeasurements);
        var data = new Data(Exception[_DYN_DATA_TYPE ], exData);
        return _createEnvelope(logger, Exception[_DYN_ENVELOPE_TYPE ], telemetryItem, data);
    }
    function MetricEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
        EnvelopeCreatorInit(logger, telemetryItem);
        var baseData = telemetryItem[strBaseData];
        var props = baseData[strProperties] || {};
        var measurements = baseData[_DYN_MEASUREMENTS ] || {};
        _extractPropsAndMeasurements(telemetryItem[_DYN_DATA ], props, measurements);
        if (!isNullOrUndefined(customUndefinedValue)) {
            _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
        }
        var baseMetricData = new Metric(logger, baseData[_DYN_NAME$1 ], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
        var data = new Data(Metric[_DYN_DATA_TYPE ], baseMetricData);
        return _createEnvelope(logger, Metric[_DYN_ENVELOPE_TYPE ], telemetryItem, data);
    }
    function PageViewEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
        EnvelopeCreatorInit(logger, telemetryItem);
        var duration;
        var baseData = telemetryItem[strBaseData];
        if (!isNullOrUndefined(baseData) &&
            !isNullOrUndefined(baseData[strProperties]) &&
            !isNullOrUndefined(baseData[strProperties][STR_DURATION$1])) {
            duration = baseData[strProperties][STR_DURATION$1];
            delete baseData[strProperties][STR_DURATION$1];
        }
        else if (!isNullOrUndefined(telemetryItem[_DYN_DATA ]) &&
            !isNullOrUndefined(telemetryItem[_DYN_DATA ][STR_DURATION$1])) {
            duration = telemetryItem[_DYN_DATA ][STR_DURATION$1];
            delete telemetryItem[_DYN_DATA ][STR_DURATION$1];
        }
        var bd = telemetryItem[strBaseData];
        var currentContextId;
        if (((telemetryItem.ext || {}).trace || {})[_DYN_TRACE_ID$1 ]) {
            currentContextId = telemetryItem.ext.trace[_DYN_TRACE_ID$1 ];
        }
        var id = bd.id || currentContextId;
        var name = bd[_DYN_NAME$1 ];
        var url = bd.uri;
        var properties = bd[strProperties] || {};
        var measurements = bd[_DYN_MEASUREMENTS ] || {};
        if (!isNullOrUndefined(bd.refUri)) {
            properties["refUri"] = bd.refUri;
        }
        if (!isNullOrUndefined(bd.pageType)) {
            properties["pageType"] = bd.pageType;
        }
        if (!isNullOrUndefined(bd.isLoggedIn)) {
            properties["isLoggedIn"] = bd.isLoggedIn[_DYN_TO_STRING ]();
        }
        if (!isNullOrUndefined(bd[strProperties])) {
            var pageTags = bd[strProperties];
            objForEachKey(pageTags, function (key, value) {
                properties[key] = value;
            });
        }
        _extractPropsAndMeasurements(telemetryItem[_DYN_DATA ], properties, measurements);
        if (!isNullOrUndefined(customUndefinedValue)) {
            _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
        }
        var pageViewData = new PageView(logger, name, url, duration, properties, measurements, id);
        var data = new Data(PageView[_DYN_DATA_TYPE ], pageViewData);
        return _createEnvelope(logger, PageView[_DYN_ENVELOPE_TYPE ], telemetryItem, data);
    }
    function PageViewPerformanceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
        EnvelopeCreatorInit(logger, telemetryItem);
        var bd = telemetryItem[strBaseData];
        var name = bd[_DYN_NAME$1 ];
        var url = bd.uri || bd.url;
        var properties = bd[strProperties] || {};
        var measurements = bd[_DYN_MEASUREMENTS ] || {};
        _extractPropsAndMeasurements(telemetryItem[_DYN_DATA ], properties, measurements);
        if (!isNullOrUndefined(customUndefinedValue)) {
            _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
        }
        var baseData = new PageViewPerformance(logger, name, url, undefined, properties, measurements, bd);
        var data = new Data(PageViewPerformance[_DYN_DATA_TYPE ], baseData);
        return _createEnvelope(logger, PageViewPerformance[_DYN_ENVELOPE_TYPE ], telemetryItem, data);
    }
    function TraceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
        EnvelopeCreatorInit(logger, telemetryItem);
        var message = telemetryItem[strBaseData].message;
        var severityLevel = telemetryItem[strBaseData].severityLevel;
        var props = telemetryItem[strBaseData][strProperties] || {};
        var measurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS ] || {};
        _extractPropsAndMeasurements(telemetryItem[_DYN_DATA ], props, measurements);
        if (!isNullOrUndefined(customUndefinedValue)) {
            _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
        }
        var baseData = new Trace(logger, message, severityLevel, props, measurements);
        var data = new Data(Trace[_DYN_DATA_TYPE ], baseData);
        return _createEnvelope(logger, Trace[_DYN_ENVELOPE_TYPE ], telemetryItem, data);
    }

    function _disableEvents(target, evtNamespace) {
        eventOff(target, null, null, evtNamespace);
    }
    function createOfflineListener(parentEvtNamespace) {
        var _a;
        var _document = getDocument();
        var _navigator = getNavigator();
        var _isListening = false;
        var _onlineStatus = true;
        var _evtNamespace = mergeEvtNamespace(createUniqueNamespace("OfflineListener"), parentEvtNamespace);
        try {
            if (_enableEvents(getWindow())) {
                _isListening = true;
            }
            if (_document) {
                var target = _document.body || _document;
                if (target.ononline) {
                    if (_enableEvents(target)) {
                        _isListening = true;
                    }
                }
            }
            if (_isListening) {
                if (_navigator && !isNullOrUndefined(_navigator[_DYN_ON_LINE ])) {
                    _onlineStatus = _navigator[_DYN_ON_LINE ];
                }
            }
        }
        catch (e) {
            _isListening = false;
        }
        function _enableEvents(target) {
            var enabled = false;
            if (target) {
                enabled = eventOn(target, "online", _setOnline, _evtNamespace);
                if (enabled) {
                    eventOn(target, "offline", _setOffline, _evtNamespace);
                }
            }
            return enabled;
        }
        function _setOnline() {
            _onlineStatus = true;
        }
        function _setOffline() {
            _onlineStatus = false;
        }
        function _isOnline() {
            var result = true;
            if (_isListening) {
                result = _onlineStatus;
            }
            else if (_navigator && !isNullOrUndefined(_navigator[_DYN_ON_LINE ])) {
                result = _navigator[_DYN_ON_LINE ];
            }
            return result;
        }
        function _unload() {
            var win = getWindow();
            if (win && _isListening) {
                _disableEvents(win, _evtNamespace);
                if (_document) {
                    var target = _document.body || _document;
                    if (!isUndefined(target.ononline)) {
                        _disableEvents(target, _evtNamespace);
                    }
                }
                _isListening = false;
            }
        }
        return _a = {},
            _a[_DYN_IS_ONLINE ] = _isOnline,
            _a.isListening = function () { return _isListening; },
            _a.unload = _unload,
            _a;
    }

    var BaseSendBuffer = /** @class */ (function () {
        function BaseSendBuffer(logger, config) {
            var _buffer = [];
            var _bufferFullMessageSent = false;
            this._get = function () {
                return _buffer;
            };
            this._set = function (buffer) {
                _buffer = buffer;
                return _buffer;
            };
            dynamicProto(BaseSendBuffer, this, function (_self) {
                _self[_DYN_ENQUEUE ] = function (payload) {
                    if (_self[_DYN_COUNT ]() >= config.eventsLimitInMem()) {
                        if (!_bufferFullMessageSent) {
                            _throwInternal(logger, 2 , 105 , "Maximum in-memory buffer size reached: " + _self[_DYN_COUNT ](), true);
                            _bufferFullMessageSent = true;
                        }
                        return;
                    }
                    _buffer[_DYN_PUSH$1 ](payload);
                };
                _self[_DYN_COUNT ] = function () {
                    return _buffer[_DYN_LENGTH$2 ];
                };
                _self.size = function () {
                    var size = _buffer[_DYN_LENGTH$2 ];
                    for (var lp = 0; lp < _buffer[_DYN_LENGTH$2 ]; lp++) {
                        size += _buffer[lp][_DYN_LENGTH$2 ];
                    }
                    if (!config[_DYN_EMIT_LINE_DELIMITED_0 ]()) {
                        size += 2;
                    }
                    return size;
                };
                _self[_DYN_CLEAR ] = function () {
                    _buffer = [];
                    _bufferFullMessageSent = false;
                };
                _self.getItems = function () {
                    return _buffer.slice(0);
                };
                _self[_DYN_BATCH_PAYLOADS ] = function (payload) {
                    if (payload && payload[_DYN_LENGTH$2 ] > 0) {
                        var batch = config[_DYN_EMIT_LINE_DELIMITED_0 ]() ?
                            payload.join("\n") :
                            "[" + payload.join(",") + "]";
                        return batch;
                    }
                    return null;
                };
            });
        }
        BaseSendBuffer.__ieDyn=1;
        return BaseSendBuffer;
    }());
    var ArraySendBuffer = /** @class */ (function (_super) {
        __extendsFn(ArraySendBuffer, _super);
        function ArraySendBuffer(logger, config) {
            var _this = _super.call(this, logger, config) || this;
            dynamicProto(ArraySendBuffer, _this, function (_self, _base) {
                _self[_DYN_MARK_AS_SENT ] = function (payload) {
                    _base[_DYN_CLEAR ]();
                };
                _self[_DYN_CLEAR_SENT ] = function (payload) {
                };
            });
            return _this;
        }
        ArraySendBuffer.__ieDyn=1;
        return ArraySendBuffer;
    }(BaseSendBuffer));
    var SessionStorageSendBuffer = /** @class */ (function (_super) {
        __extendsFn(SessionStorageSendBuffer, _super);
        function SessionStorageSendBuffer(logger, config) {
            var _this = _super.call(this, logger, config) || this;
            var _bufferFullMessageSent = false;
            var _a = config[_DYN_BUFFER_OVERRIDE ]() || { getItem: utlGetSessionStorage, setItem: utlSetSessionStorage }, getItem = _a.getItem, setItem = _a.setItem;
            dynamicProto(SessionStorageSendBuffer, _this, function (_self, _base) {
                var bufferItems = _getBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY ]);
                var notDeliveredItems = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY ]);
                var buffer = _self._set(bufferItems.concat(notDeliveredItems));
                if (buffer[_DYN_LENGTH$2 ] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE ]) {
                    buffer[_DYN_LENGTH$2 ] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE ];
                }
                _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY ], []);
                _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY ], buffer);
                _self[_DYN_ENQUEUE ] = function (payload) {
                    if (_self[_DYN_COUNT ]() >= SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE ]) {
                        if (!_bufferFullMessageSent) {
                            _throwInternal(logger, 2 , 67 , "Maximum buffer size reached: " + _self[_DYN_COUNT ](), true);
                            _bufferFullMessageSent = true;
                        }
                        return;
                    }
                    _base[_DYN_ENQUEUE ](payload);
                    _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY ], _self._get());
                };
                _self[_DYN_CLEAR ] = function () {
                    _base[_DYN_CLEAR ]();
                    _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY ], _self._get());
                    _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY ], []);
                    _bufferFullMessageSent = false;
                };
                _self[_DYN_MARK_AS_SENT ] = function (payload) {
                    _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY ], _self._set(_removePayloadsFromBuffer(payload, _self._get())));
                    var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY ]);
                    if (sentElements instanceof Array && payload instanceof Array) {
                        sentElements = sentElements.concat(payload);
                        if (sentElements[_DYN_LENGTH$2 ] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE ]) {
                            _throwInternal(logger, 1 , 67 , "Sent buffer reached its maximum size: " + sentElements[_DYN_LENGTH$2 ], true);
                            sentElements[_DYN_LENGTH$2 ] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE ];
                        }
                        _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY ], sentElements);
                    }
                };
                _self[_DYN_CLEAR_SENT ] = function (payload) {
                    var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY ]);
                    sentElements = _removePayloadsFromBuffer(payload, sentElements);
                    _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY ], sentElements);
                };
                function _removePayloadsFromBuffer(payloads, buffer) {
                    var remaining = [];
                    arrForEach(buffer, function (value) {
                        if (!isFunction(value) && arrIndexOf(payloads, value) === -1) {
                            remaining[_DYN_PUSH$1 ](value);
                        }
                    });
                    return remaining;
                }
                function _getBuffer(key) {
                    var prefixedKey = key;
                    try {
                        prefixedKey = config[_DYN_NAME_PREFIX$1 ] && config[_DYN_NAME_PREFIX$1 ]() ? config[_DYN_NAME_PREFIX$1 ]() + "_" + prefixedKey : prefixedKey;
                        var bufferJson = getItem(logger, prefixedKey);
                        if (bufferJson) {
                            var buffer_1 = getJSON().parse(bufferJson);
                            if (isString(buffer_1)) {
                                buffer_1 = getJSON().parse(buffer_1);
                            }
                            if (buffer_1 && isArray(buffer_1)) {
                                return buffer_1;
                            }
                        }
                    }
                    catch (e) {
                        _throwInternal(logger, 1 , 42 , " storage key: " + prefixedKey + ", " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                    return [];
                }
                function _setBuffer(key, buffer) {
                    var prefixedKey = key;
                    try {
                        prefixedKey = config[_DYN_NAME_PREFIX$1 ] && config[_DYN_NAME_PREFIX$1 ]() ? config[_DYN_NAME_PREFIX$1 ]() + "_" + prefixedKey : prefixedKey;
                        var bufferJson = JSON[_DYN_STRINGIFY ](buffer);
                        setItem(logger, prefixedKey, bufferJson);
                    }
                    catch (e) {
                        setItem(logger, prefixedKey, JSON[_DYN_STRINGIFY ]([]));
                        _throwInternal(logger, 2 , 41 , " storage key: " + prefixedKey + ", " + getExceptionName(e) + ". Buffer cleared", { exception: dumpObj(e) });
                    }
                }
            });
            return _this;
        }
        SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
        SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
        SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
        return SessionStorageSendBuffer;
    }(BaseSendBuffer));

    var Serializer = /** @class */ (function () {
        function Serializer(logger) {
            dynamicProto(Serializer, this, function (_self) {
                _self.serialize = function (input) {
                    var output = _serializeObject(input, "root");
                    try {
                        return getJSON()[_DYN_STRINGIFY ](output);
                    }
                    catch (e) {
                        _throwInternal(logger, 1 , 48 , (e && isFunction(e[_DYN_TO_STRING ])) ? e[_DYN_TO_STRING ]() : "Error serializing object", null, true);
                    }
                };
                function _serializeObject(source, name) {
                    var circularReferenceCheck = "__aiCircularRefCheck";
                    var output = {};
                    if (!source) {
                        _throwInternal(logger, 1 , 48 , "cannot serialize object because it is null or undefined", { name: name }, true);
                        return output;
                    }
                    if (source[circularReferenceCheck]) {
                        _throwInternal(logger, 2 , 50 , "Circular reference detected while serializing object", { name: name }, true);
                        return output;
                    }
                    if (!source.aiDataContract) {
                        if (name === "measurements") {
                            output = _serializeStringMap(source, "number", name);
                        }
                        else if (name === "properties") {
                            output = _serializeStringMap(source, "string", name);
                        }
                        else if (name === "tags") {
                            output = _serializeStringMap(source, "string", name);
                        }
                        else if (isArray(source)) {
                            output = _serializeArray(source, name);
                        }
                        else {
                            _throwInternal(logger, 2 , 49 , "Attempting to serialize an object which does not implement ISerializable", { name: name }, true);
                            try {
                                getJSON()[_DYN_STRINGIFY ](source);
                                output = source;
                            }
                            catch (e) {
                                _throwInternal(logger, 1 , 48 , (e && isFunction(e[_DYN_TO_STRING ])) ? e[_DYN_TO_STRING ]() : "Error serializing object", null, true);
                            }
                        }
                        return output;
                    }
                    source[circularReferenceCheck] = true;
                    objForEachKey(source.aiDataContract, function (field, contract) {
                        var isRequired = (isFunction(contract)) ? (contract() & 1 ) : (contract & 1 );
                        var isHidden = (isFunction(contract)) ? (contract() & 4 ) : (contract & 4 );
                        var isArray = contract & 2 ;
                        var isPresent = source[field] !== undefined;
                        var isObj = isObject(source[field]) && source[field] !== null;
                        if (isRequired && !isPresent && !isArray) {
                            _throwInternal(logger, 1 , 24 , "Missing required field specification. The field is required but not present on source", { field: field, name: name });
                        }
                        else if (!isHidden) {
                            var value = void 0;
                            if (isObj) {
                                if (isArray) {
                                    value = _serializeArray(source[field], field);
                                }
                                else {
                                    value = _serializeObject(source[field], field);
                                }
                            }
                            else {
                                value = source[field];
                            }
                            if (value !== undefined) {
                                output[field] = value;
                            }
                        }
                    });
                    delete source[circularReferenceCheck];
                    return output;
                }
                function _serializeArray(sources, name) {
                    var output;
                    if (!!sources) {
                        if (!isArray(sources)) {
                            _throwInternal(logger, 1 , 54 , "This field was specified as an array in the contract but the item is not an array.\r\n", { name: name }, true);
                        }
                        else {
                            output = [];
                            for (var i = 0; i < sources[_DYN_LENGTH$2 ]; i++) {
                                var source = sources[i];
                                var item = _serializeObject(source, name + "[" + i + "]");
                                output[_DYN_PUSH$1 ](item);
                            }
                        }
                    }
                    return output;
                }
                function _serializeStringMap(map, expectedType, name) {
                    var output;
                    if (map) {
                        output = {};
                        objForEachKey(map, function (field, value) {
                            if (expectedType === "string") {
                                if (value === undefined) {
                                    output[field] = "undefined";
                                }
                                else if (value === null) {
                                    output[field] = "null";
                                }
                                else if (!value[_DYN_TO_STRING ]) {
                                    output[field] = "invalid field: toString() is not defined.";
                                }
                                else {
                                    output[field] = value[_DYN_TO_STRING ]();
                                }
                            }
                            else if (expectedType === "number") {
                                if (value === undefined) {
                                    output[field] = "undefined";
                                }
                                else if (value === null) {
                                    output[field] = "null";
                                }
                                else {
                                    var num = parseFloat(value);
                                    if (isNaN(num)) {
                                        output[field] = "NaN";
                                    }
                                    else {
                                        output[field] = num;
                                    }
                                }
                            }
                            else {
                                output[field] = "invalid field: " + name + " is of unknown type.";
                                _throwInternal(logger, 1 , output[field], null, true);
                            }
                        });
                    }
                    return output;
                }
            });
        }
        Serializer.__ieDyn=1;
        return Serializer;
    }());

    var MIN_INPUT_LENGTH = 8;
    var HashCodeScoreGenerator = /** @class */ (function () {
        function HashCodeScoreGenerator() {
        }
        HashCodeScoreGenerator.prototype.getHashCodeScore = function (key) {
            var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
            return score * 100;
        };
        HashCodeScoreGenerator.prototype.getHashCode = function (input) {
            if (input === "") {
                return 0;
            }
            while (input[_DYN_LENGTH$2 ] < MIN_INPUT_LENGTH) {
                input = input.concat(input);
            }
            var hash = 5381;
            for (var i = 0; i < input[_DYN_LENGTH$2 ]; ++i) {
                hash = ((hash << 5) + hash) + input.charCodeAt(i);
                hash = hash & hash;
            }
            return Math.abs(hash);
        };
        HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
        return HashCodeScoreGenerator;
    }());

    var SamplingScoreGenerator = /** @class */ (function () {
        function SamplingScoreGenerator() {
            var _self = this;
            var hashCodeGenerator = new HashCodeScoreGenerator();
            var keys = new ContextTagKeys();
            _self[_DYN_GET_SAMPLING_SCORE ] = function (item) {
                var score = 0;
                if (item[_DYN_TAGS ] && item[_DYN_TAGS ][keys.userId]) {
                    score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS ][keys.userId]);
                }
                else if (item.ext && item.ext.user && item.ext.user.id) {
                    score = hashCodeGenerator[_DYN_GET_HASH_CODE_SCORE ](item.ext.user.id);
                }
                else if (item[_DYN_TAGS ] && item[_DYN_TAGS ][keys.operationId]) {
                    score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS ][keys.operationId]);
                }
                else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[_DYN_TRACE_ID$1 ]) {
                    score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[_DYN_TRACE_ID$1 ]);
                }
                else {
                    score = (Math.random() * 100);
                }
                return score;
            };
        }
        return SamplingScoreGenerator;
    }());

    var Sample = /** @class */ (function () {
        function Sample(sampleRate, logger) {
            this.INT_MAX_VALUE = 2147483647;
            var _logger = logger || safeGetLogger(null);
            if (sampleRate > 100 || sampleRate < 0) {
                _logger.throwInternal(2 , 58 , "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
                sampleRate = 100;
            }
            this[_DYN_SAMPLE_RATE ] = sampleRate;
            this.samplingScoreGenerator = new SamplingScoreGenerator();
        }
        Sample.prototype.isSampledIn = function (envelope) {
            var samplingPercentage = this[_DYN_SAMPLE_RATE ];
            var isSampledIn = false;
            if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) {
                return true;
            }
            else if (envelope.baseType === Metric[_DYN_DATA_TYPE ]) {
                return true;
            }
            isSampledIn = this.samplingScoreGenerator[_DYN_GET_SAMPLING_SCORE ](envelope) < samplingPercentage;
            return isSampledIn;
        };
        return Sample;
    }());

    var _a;
    var FetchSyncRequestSizeLimitBytes = 65000;
    function _getResponseText(xhr) {
        try {
            return xhr.responseText;
        }
        catch (e) {
        }
        return null;
    }
    function _getDefaultAppInsightsChannelConfig() {
        var _a;
        var defaultValue;
        var defaultCustomHeaders;
        return _a = {
                endpointUrl: function () { return DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH; }
            },
            _a[_DYN_EMIT_LINE_DELIMITED_0 ] = function () { return false; },
            _a[_DYN_MAX_BATCH_INTERVAL$1 ] = function () { return 15000; },
            _a[_DYN_MAX_BATCH_SIZE_IN_BY1$1 ] = function () { return 102400; },
            _a[_DYN_DISABLE_TELEMETRY$1 ] = function () { return false; },
            _a[_DYN_ENABLE_SESSION_STORA4 ] = function () { return true; },
            _a[_DYN_BUFFER_OVERRIDE ] = function () { return false; },
            _a[_DYN_IS_RETRY_DISABLED ] = function () { return false; },
            _a[_DYN_IS_BEACON_API_DISABL3 ] = function () { return true; },
            _a[_DYN_DISABLE_XHR ] = function () { return false; },
            _a[_DYN_ONUNLOAD_DISABLE_FET5 ] = function () { return false; },
            _a[_DYN_ONUNLOAD_DISABLE_BEA2 ] = function () { return false; },
            _a[_DYN_INSTRUMENTATION_KEY$1 ] = function () { return defaultValue; },
            _a[_DYN_NAME_PREFIX$1 ] = function () { return defaultValue; },
            _a[_DYN_SAMPLING_PERCENTAGE$1 ] = function () { return 100; },
            _a[_DYN_CUSTOM_HEADERS ] = function () { return defaultCustomHeaders; },
            _a[_DYN_CONVERT_UNDEFINED ] = function () { return defaultValue; },
            _a.eventsLimitInMem = function () { return 10000; },
            _a;
    }
    var EnvelopeTypeCreator = (_a = {},
        _a[Event$1.dataType] = EventEnvelopeCreator,
        _a[Trace.dataType] = TraceEnvelopeCreator,
        _a[PageView.dataType] = PageViewEnvelopeCreator,
        _a[PageViewPerformance.dataType] = PageViewPerformanceEnvelopeCreator,
        _a[Exception.dataType] = ExceptionEnvelopeCreator,
        _a[Metric.dataType] = MetricEnvelopeCreator,
        _a[RemoteDependencyData.dataType] = DependencyEnvelopeCreator,
        _a);
    var Sender = /** @class */ (function (_super) {
        __extendsFn(Sender, _super);
        function Sender() {
            var _this = _super.call(this) || this;
            _this.priority = 1001;
            _this.identifier = BreezeChannelIdentifier;
            _this._senderConfig = _getDefaultAppInsightsChannelConfig();
            var _consecutiveErrors;
            var _retryAt;
            var _paused;
            var _timeoutHandle;
            var _serializer;
            var _stamp_specific_redirects;
            var _headers;
            var _syncFetchPayload = 0;
            var _fallbackSender;
            var _syncUnloadSender;
            var _offlineListener;
            var _evtNamespace;
            dynamicProto(Sender, _this, function (_self, _base) {
                _initDefaults();
                _self.pause = function () {
                    _clearScheduledTimer();
                    _paused = true;
                };
                _self.resume = function () {
                    if (_paused) {
                        _paused = false;
                        _retryAt = null;
                        if (_self._buffer.size() > _self._senderConfig[_DYN_MAX_BATCH_SIZE_IN_BY1$1 ]()) {
                            _self[_DYN_TRIGGER_SEND ](true, null, 10 );
                        }
                        _setupTimer();
                    }
                };
                _self.flush = function (isAsync, callBack, sendReason) {
                    if (isAsync === void 0) { isAsync = true; }
                    if (!_paused) {
                        _clearScheduledTimer();
                        try {
                            _self[_DYN_TRIGGER_SEND ](isAsync, null, sendReason || 1 );
                        }
                        catch (e) {
                            _throwInternal(_self[_DYN_DIAG_LOG ](), 1 , 22 , "flush failed, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                        }
                    }
                };
                _self.onunloadFlush = function () {
                    if (!_paused) {
                        if ((_self._senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2 ]() === false || _self[_DYN__SENDER_CONFIG ][_DYN_IS_BEACON_API_DISABL3 ]() === false) && isBeaconsSupported()) {
                            try {
                                _self[_DYN_TRIGGER_SEND ](true, _doUnloadSend, 2 );
                            }
                            catch (e) {
                                _throwInternal(_self[_DYN_DIAG_LOG ](), 1 , 20 , "failed to flush with beacon sender on page unload, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                            }
                        }
                        else {
                            _self.flush();
                        }
                    }
                };
                _self.addHeader = function (name, value) {
                    _headers[name] = value;
                };
                _self.initialize = function (config, core, extensions, pluginChain) {
                    if (_self.isInitialized()) {
                        _throwInternal(_self[_DYN_DIAG_LOG ](), 1 , 28 , "Sender is already initialized");
                    }
                    _base.initialize(config, core, extensions, pluginChain);
                    var ctx = _self._getTelCtx();
                    var identifier = _self.identifier;
                    _serializer = new Serializer(core.logger);
                    _consecutiveErrors = 0;
                    _retryAt = null;
                    _self[_DYN__SENDER ] = null;
                    _stamp_specific_redirects = 0;
                    var diagLog = _self[_DYN_DIAG_LOG ]();
                    _evtNamespace = mergeEvtNamespace(createUniqueNamespace("Sender"), core.evtNamespace && core.evtNamespace());
                    _offlineListener = createOfflineListener(_evtNamespace);
                    var defaultConfig = _getDefaultAppInsightsChannelConfig();
                    objForEachKey(defaultConfig, function (field, value) {
                        _self[_DYN__SENDER_CONFIG ][field] = function () {
                            var theValue = ctx.getConfig(identifier, field, value());
                            if (!theValue && field === "endpointUrl") {
                                theValue = value();
                            }
                            return theValue;
                        };
                    });
                    var useSessionStorage = _self[_DYN__SENDER_CONFIG ][_DYN_ENABLE_SESSION_STORA4 ]() &&
                        !!(_self._senderConfig[_DYN_BUFFER_OVERRIDE ]() || utlCanUseSessionStorage());
                    _self[_DYN__BUFFER ] = useSessionStorage
                        ? new SessionStorageSendBuffer(diagLog, _self[_DYN__SENDER_CONFIG ])
                        : new ArraySendBuffer(diagLog, _self[_DYN__SENDER_CONFIG ]);
                    _self._sample = new Sample(_self[_DYN__SENDER_CONFIG ][_DYN_SAMPLING_PERCENTAGE$1 ](), diagLog);
                    if (!_validateInstrumentationKey(config)) {
                        _throwInternal(diagLog, 1 , 100 , "Invalid Instrumentation key " + config[_DYN_INSTRUMENTATION_KEY$1 ]);
                    }
                    if (!isInternalApplicationInsightsEndpoint(_self._senderConfig.endpointUrl()) && _self._senderConfig.customHeaders() && _self._senderConfig.customHeaders()[_DYN_LENGTH$2 ] > 0) {
                        arrForEach(_self[_DYN__SENDER_CONFIG ][_DYN_CUSTOM_HEADERS ](), function (customHeader) {
                            _this.addHeader(customHeader.header, customHeader.value);
                        });
                    }
                    var senderConfig = _self[_DYN__SENDER_CONFIG ];
                    var sendPostFunc = null;
                    if (!senderConfig[_DYN_DISABLE_XHR ]() && useXDomainRequest()) {
                        sendPostFunc = _xdrSender;
                    }
                    else if (!senderConfig[_DYN_DISABLE_XHR ]() && isXhrSupported()) {
                        sendPostFunc = _xhrSender;
                    }
                    if (!sendPostFunc && isFetchSupported()) {
                        sendPostFunc = _fetchSender;
                    }
                    _fallbackSender = sendPostFunc || _xhrSender;
                    if (!senderConfig[_DYN_IS_BEACON_API_DISABL3 ]() && isBeaconsSupported()) {
                        sendPostFunc = _beaconSender;
                    }
                    _self[_DYN__SENDER ] = sendPostFunc || _xhrSender;
                    if (!senderConfig[_DYN_ONUNLOAD_DISABLE_FET5 ]() && isFetchSupported(true)) {
                        _syncUnloadSender = _fetchKeepAliveSender;
                    }
                    else if (isBeaconsSupported()) {
                        _syncUnloadSender = _beaconSender;
                    }
                    else if (!senderConfig[_DYN_DISABLE_XHR ]() && useXDomainRequest()) {
                        _syncUnloadSender = _xdrSender;
                    }
                    else if (!senderConfig[_DYN_DISABLE_XHR ]() && isXhrSupported()) {
                        _syncUnloadSender = _xhrSender;
                    }
                    else {
                        _syncUnloadSender = _fallbackSender;
                    }
                };
                _self.processTelemetry = function (telemetryItem, itemCtx) {
                    itemCtx = _self._getTelCtx(itemCtx);
                    var diagLogger = itemCtx[_DYN_DIAG_LOG ]();
                    try {
                        if (_self[_DYN__SENDER_CONFIG ][_DYN_DISABLE_TELEMETRY$1 ]()) {
                            return;
                        }
                        if (!telemetryItem) {
                            _throwInternal(diagLogger, 1 , 7 , "Cannot send empty telemetry");
                            return;
                        }
                        if (telemetryItem.baseData && !telemetryItem[_DYN_BASE_TYPE ]) {
                            _throwInternal(diagLogger, 1 , 70 , "Cannot send telemetry without baseData and baseType");
                            return;
                        }
                        if (!telemetryItem[_DYN_BASE_TYPE ]) {
                            telemetryItem[_DYN_BASE_TYPE ] = "EventData";
                        }
                        if (!_self[_DYN__SENDER ]) {
                            _throwInternal(diagLogger, 1 , 28 , "Sender was not initialized");
                            return;
                        }
                        if (!_isSampledIn(telemetryItem)) {
                            _throwInternal(diagLogger, 2 , 33 , "Telemetry item was sampled out and not sent", { SampleRate: _self._sample[_DYN_SAMPLE_RATE ] });
                            return;
                        }
                        else {
                            telemetryItem[SampleRate] = _self._sample[_DYN_SAMPLE_RATE ];
                        }
                        var convertUndefined = _self[_DYN__SENDER_CONFIG ][_DYN_CONVERT_UNDEFINED ]() || undefined;
                        var defaultEnvelopeIkey = telemetryItem.iKey || _self[_DYN__SENDER_CONFIG ][_DYN_INSTRUMENTATION_KEY$1 ]();
                        var aiEnvelope_1 = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, convertUndefined);
                        if (!aiEnvelope_1) {
                            _throwInternal(diagLogger, 1 , 47 , "Unable to create an AppInsights envelope");
                            return;
                        }
                        var doNotSendItem_1 = false;
                        if (telemetryItem[_DYN_TAGS ] && telemetryItem[_DYN_TAGS ][ProcessLegacy]) {
                            arrForEach(telemetryItem[_DYN_TAGS ][ProcessLegacy], function (callBack) {
                                try {
                                    if (callBack && callBack(aiEnvelope_1) === false) {
                                        doNotSendItem_1 = true;
                                        _warnToConsole(diagLogger, "Telemetry processor check returns false");
                                    }
                                }
                                catch (e) {
                                    _throwInternal(diagLogger, 1 , 64 , "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), { exception: dumpObj(e) }, true);
                                }
                            });
                            delete telemetryItem[_DYN_TAGS ][ProcessLegacy];
                        }
                        if (doNotSendItem_1) {
                            return;
                        }
                        var payload = _serializer.serialize(aiEnvelope_1);
                        var buffer = _self[_DYN__BUFFER ];
                        var bufferSize = buffer.size();
                        if ((bufferSize + payload[_DYN_LENGTH$2 ]) > _self[_DYN__SENDER_CONFIG ][_DYN_MAX_BATCH_SIZE_IN_BY1$1 ]()) {
                            if (!_offlineListener || _offlineListener[_DYN_IS_ONLINE ]()) {
                                _self[_DYN_TRIGGER_SEND ](true, null, 10 );
                            }
                        }
                        buffer[_DYN_ENQUEUE ](payload);
                        _setupTimer();
                    }
                    catch (e) {
                        _throwInternal(diagLogger, 2 , 12 , "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                    _self.processNext(telemetryItem, itemCtx);
                };
                _self[_DYN__XHR_READY_STATE_CHA6 ] = function (xhr, payload, countOfItemsInPayload) {
                    if (xhr.readyState === 4) {
                        _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, _formatErrorMessageXhr(xhr), _getResponseText(xhr) || xhr.response);
                    }
                };
                _self[_DYN_TRIGGER_SEND ] = function (async, forcedSender, sendReason) {
                    if (async === void 0) { async = true; }
                    if (!_paused) {
                        try {
                            var buffer = _self[_DYN__BUFFER ];
                            if (!_self[_DYN__SENDER_CONFIG ][_DYN_DISABLE_TELEMETRY$1 ]()) {
                                if (buffer[_DYN_COUNT ]() > 0) {
                                    var payload = buffer.getItems();
                                    _notifySendRequest(sendReason || 0 , async);
                                    if (forcedSender) {
                                        forcedSender.call(_self, payload, async);
                                    }
                                    else {
                                        _self[_DYN__SENDER ](payload, async);
                                    }
                                }
                            }
                            else {
                                buffer[_DYN_CLEAR ]();
                            }
                            _clearScheduledTimer();
                        }
                        catch (e) {
                            var ieVer = getIEVersion();
                            if (!ieVer || ieVer > 9) {
                                _throwInternal(_self[_DYN_DIAG_LOG ](), 1 , 40 , "Telemetry transmission failed, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
                            }
                        }
                    }
                };
                _self._doTeardown = function (unloadCtx, unloadState) {
                    _self.onunloadFlush();
                    _offlineListener.unload();
                    _initDefaults();
                };
                _self[_DYN__ON_ERROR ] = function (payload, message, event) {
                    _throwInternal(_self[_DYN_DIAG_LOG ](), 2 , 26 , "Failed to send telemetry.", { message: message });
                    _self._buffer && _self._buffer[_DYN_CLEAR_SENT ](payload);
                };
                _self[_DYN__ON_PARTIAL_SUCCESS ] = function (payload, results) {
                    var failed = [];
                    var retry = [];
                    var errors = results.errors.reverse();
                    for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                        var error = errors_1[_i];
                        var extracted = payload.splice(error.index, 1)[0];
                        if (_isRetriable(error.statusCode)) {
                            retry[_DYN_PUSH$1 ](extracted);
                        }
                        else {
                            failed[_DYN_PUSH$1 ](extracted);
                        }
                    }
                    if (payload[_DYN_LENGTH$2 ] > 0) {
                        _self[_DYN__ON_SUCCESS ](payload, results[_DYN_ITEMS_ACCEPTED ]);
                    }
                    if (failed[_DYN_LENGTH$2 ] > 0) {
                        _self[_DYN__ON_ERROR ](failed, _formatErrorMessageXhr(null, ["partial success", results[_DYN_ITEMS_ACCEPTED ], "of", results.itemsReceived].join(" ")));
                    }
                    if (retry[_DYN_LENGTH$2 ] > 0) {
                        _resendPayload(retry);
                        _throwInternal(_self[_DYN_DIAG_LOG ](), 2 , 40 , "Partial success. " +
                            "Delivered: " + payload[_DYN_LENGTH$2 ] + ", Failed: " + failed[_DYN_LENGTH$2 ] +
                            ". Will retry to send " + retry[_DYN_LENGTH$2 ] + " our of " + results[_DYN_ITEMS_RECEIVED ] + " items");
                    }
                };
                _self[_DYN__ON_SUCCESS ] = function (payload, countOfItemsInPayload) {
                    _self._buffer && _self._buffer[_DYN_CLEAR_SENT ](payload);
                };
                _self._xdrOnLoad = function (xdr, payload) {
                    var responseText = _getResponseText(xdr);
                    if (xdr && (responseText + "" === "200" || responseText === "")) {
                        _consecutiveErrors = 0;
                        _self[_DYN__ON_SUCCESS ](payload, 0);
                    }
                    else {
                        var results = _parseResponse(responseText);
                        if (results && results.itemsReceived && results.itemsReceived > results[_DYN_ITEMS_ACCEPTED ]
                            && !_self[_DYN__SENDER_CONFIG ][_DYN_IS_RETRY_DISABLED ]()) {
                            _self[_DYN__ON_PARTIAL_SUCCESS ](payload, results);
                        }
                        else {
                            _self[_DYN__ON_ERROR ](payload, _formatErrorMessageXdr(xdr));
                        }
                    }
                };
                function _isSampledIn(envelope) {
                    return _self._sample.isSampledIn(envelope);
                }
                function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                    var response = null;
                    if (!_self._appId) {
                        response = _parseResponse(res);
                        if (response && response.appId) {
                            _self._appId = response.appId;
                        }
                    }
                    if ((status < 200 || status >= 300) && status !== 0) {
                        if (status === 301 || status === 307 || status === 308) {
                            if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                                _self[_DYN__ON_ERROR ](payload, errorMessage);
                                return;
                            }
                        }
                        if (!_self[_DYN__SENDER_CONFIG ][_DYN_IS_RETRY_DISABLED ]() && _isRetriable(status)) {
                            _resendPayload(payload);
                            _throwInternal(_self[_DYN_DIAG_LOG ](), 2 , 40 , ". " +
                                "Response code " + status + ". Will retry to send " + payload[_DYN_LENGTH$2 ] + " items.");
                        }
                        else {
                            _self[_DYN__ON_ERROR ](payload, errorMessage);
                        }
                    }
                    else if (_offlineListener && !_offlineListener[_DYN_IS_ONLINE ]()) {
                        if (!_self[_DYN__SENDER_CONFIG ][_DYN_IS_RETRY_DISABLED ]()) {
                            var offlineBackOffMultiplier = 10;
                            _resendPayload(payload, offlineBackOffMultiplier);
                            _throwInternal(_self[_DYN_DIAG_LOG ](), 2 , 40 , ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                        }
                    }
                    else {
                        _checkAndUpdateEndPointUrl(responseUrl);
                        if (status === 206) {
                            if (!response) {
                                response = _parseResponse(res);
                            }
                            if (response && !_self[_DYN__SENDER_CONFIG ][_DYN_IS_RETRY_DISABLED ]()) {
                                _self[_DYN__ON_PARTIAL_SUCCESS ](payload, response);
                            }
                            else {
                                _self[_DYN__ON_ERROR ](payload, errorMessage);
                            }
                        }
                        else {
                            _consecutiveErrors = 0;
                            _self[_DYN__ON_SUCCESS ](payload, countOfItemsInPayload);
                        }
                    }
                }
                function _checkAndUpdateEndPointUrl(responseUrl) {
                    if (_stamp_specific_redirects >= 10) {
                        return false;
                    }
                    if (!isNullOrUndefined(responseUrl) && responseUrl !== "") {
                        if (responseUrl !== _self[_DYN__SENDER_CONFIG ][_DYN_ENDPOINT_URL$1 ]()) {
                            _self[_DYN__SENDER_CONFIG ][_DYN_ENDPOINT_URL$1 ] = function () { return responseUrl; };
                            ++_stamp_specific_redirects;
                            return true;
                        }
                    }
                    return false;
                }
                function _doUnloadSend(payload, isAsync) {
                    if (_syncUnloadSender) {
                        _syncUnloadSender(payload, false);
                    }
                    else {
                        _beaconSender(payload);
                    }
                }
                function _doBeaconSend(payload) {
                    var nav = getNavigator();
                    var buffer = _self[_DYN__BUFFER ];
                    var url = _self[_DYN__SENDER_CONFIG ][_DYN_ENDPOINT_URL$1 ]();
                    var batch = _self._buffer[_DYN_BATCH_PAYLOADS ](payload);
                    var plainTextBatch = new Blob([batch], { type: "text/plain;charset=UTF-8" });
                    var queued = nav.sendBeacon(url, plainTextBatch);
                    if (queued) {
                        buffer[_DYN_MARK_AS_SENT ](payload);
                        _self._onSuccess(payload, payload[_DYN_LENGTH$2 ]);
                    }
                    return queued;
                }
                function _beaconSender(payload, isAsync) {
                    if (isArray(payload) && payload[_DYN_LENGTH$2 ] > 0) {
                        if (!_doBeaconSend(payload)) {
                            var droppedPayload = [];
                            for (var lp = 0; lp < payload[_DYN_LENGTH$2 ]; lp++) {
                                var thePayload = payload[lp];
                                if (!_doBeaconSend([thePayload])) {
                                    droppedPayload[_DYN_PUSH$1 ](thePayload);
                                }
                            }
                            if (droppedPayload[_DYN_LENGTH$2 ] > 0) {
                                _fallbackSender && _fallbackSender(droppedPayload, true);
                                _throwInternal(_self[_DYN_DIAG_LOG ](), 2 , 40 , ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                            }
                        }
                    }
                }
                function _xhrSender(payload, isAsync) {
                    var xhr = new XMLHttpRequest();
                    var endPointUrl = _self[_DYN__SENDER_CONFIG ][_DYN_ENDPOINT_URL$1 ]();
                    try {
                        xhr[DisabledPropertyName] = true;
                    }
                    catch (e) {
                    }
                    xhr.open("POST", endPointUrl, isAsync);
                    xhr[_DYN_SET_REQUEST_HEADER$1 ]("Content-type", "application/json");
                    if (isInternalApplicationInsightsEndpoint(endPointUrl)) {
                        xhr[_DYN_SET_REQUEST_HEADER$1 ](RequestHeaders[6 ], RequestHeaders[7 ]);
                    }
                    arrForEach(objKeys(_headers), function (headerName) {
                        xhr[_DYN_SET_REQUEST_HEADER$1 ](headerName, _headers[headerName]);
                    });
                    xhr.onreadystatechange = function () { return _self._xhrReadyStateChange(xhr, payload, payload[_DYN_LENGTH$2 ]); };
                    xhr.onerror = function (event) { return _self[_DYN__ON_ERROR ](payload, _formatErrorMessageXhr(xhr), event); };
                    var batch = _self._buffer[_DYN_BATCH_PAYLOADS ](payload);
                    xhr.send(batch);
                    _self._buffer[_DYN_MARK_AS_SENT ](payload);
                }
                function _fetchKeepAliveSender(payload, isAsync) {
                    if (isArray(payload)) {
                        var payloadSize = payload[_DYN_LENGTH$2 ];
                        for (var lp = 0; lp < payload[_DYN_LENGTH$2 ]; lp++) {
                            payloadSize += payload[lp][_DYN_LENGTH$2 ];
                        }
                        if ((_syncFetchPayload + payloadSize) <= FetchSyncRequestSizeLimitBytes) {
                            _doFetchSender(payload, false);
                        }
                        else if (isBeaconsSupported()) {
                            _beaconSender(payload);
                        }
                        else {
                            _fallbackSender && _fallbackSender(payload, true);
                            _throwInternal(_self[_DYN_DIAG_LOG ](), 2 , 40 , ". " + "Failed to send telemetry with Beacon API, retried with xhrSender.");
                        }
                    }
                }
                function _fetchSender(payload, isAsync) {
                    _doFetchSender(payload, true);
                }
                function _doFetchSender(payload, isAsync) {
                    var _a;
                    var endPointUrl = _self[_DYN__SENDER_CONFIG ][_DYN_ENDPOINT_URL$1 ]();
                    var batch = _self._buffer[_DYN_BATCH_PAYLOADS ](payload);
                    var plainTextBatch = new Blob([batch], { type: "application/json" });
                    var requestHeaders = new Headers();
                    var batchLength = batch[_DYN_LENGTH$2 ];
                    var ignoreResponse = false;
                    var responseHandled = false;
                    if (isInternalApplicationInsightsEndpoint(endPointUrl)) {
                        requestHeaders.append(RequestHeaders[6 ], RequestHeaders[7 ]);
                    }
                    arrForEach(objKeys(_headers), function (headerName) {
                        requestHeaders.append(headerName, _headers[headerName]);
                    });
                    var init = (_a = {
                            method: "POST",
                            headers: requestHeaders,
                            body: plainTextBatch
                        },
                        _a[DisabledPropertyName] = true
                    ,
                        _a);
                    if (!isAsync) {
                        init.keepalive = true;
                        ignoreResponse = true;
                        _syncFetchPayload += batchLength;
                    }
                    var request = new Request(endPointUrl, init);
                    try {
                        request[DisabledPropertyName] = true;
                    }
                    catch (e) {
                    }
                    _self._buffer[_DYN_MARK_AS_SENT ](payload);
                    try {
                        fetch(request).then(function (response) {
                            if (!isAsync) {
                                _syncFetchPayload -= batchLength;
                                batchLength = 0;
                            }
                            if (!responseHandled) {
                                responseHandled = true;
                                if (!response.ok) {
                                    _self[_DYN__ON_ERROR ](payload, response.statusText);
                                }
                                else {
                                    response.text().then(function (text) {
                                        _checkResponsStatus(response.status, payload, response.url, payload[_DYN_LENGTH$2 ], response.statusText, text);
                                    });
                                }
                            }
                        })["catch"](function (error) {
                            if (!isAsync) {
                                _syncFetchPayload -= batchLength;
                                batchLength = 0;
                            }
                            if (!responseHandled) {
                                responseHandled = true;
                                _self[_DYN__ON_ERROR ](payload, error.message);
                            }
                        });
                    }
                    catch (e) {
                        if (!responseHandled) {
                            _self[_DYN__ON_ERROR ](payload, dumpObj(e));
                        }
                    }
                    if (ignoreResponse && !responseHandled) {
                        responseHandled = true;
                        _self._onSuccess(payload, payload[_DYN_LENGTH$2 ]);
                    }
                }
                function _parseResponse(response) {
                    try {
                        if (response && response !== "") {
                            var result = getJSON().parse(response);
                            if (result && result.itemsReceived && result.itemsReceived >= result[_DYN_ITEMS_ACCEPTED ] &&
                                result.itemsReceived - result.itemsAccepted === result.errors[_DYN_LENGTH$2 ]) {
                                return result;
                            }
                        }
                    }
                    catch (e) {
                        _throwInternal(_self[_DYN_DIAG_LOG ](), 1 , 43 , "Cannot parse the response. " + getExceptionName(e), {
                            response: response
                        });
                    }
                    return null;
                }
                function _resendPayload(payload, linearFactor) {
                    if (linearFactor === void 0) { linearFactor = 1; }
                    if (!payload || payload[_DYN_LENGTH$2 ] === 0) {
                        return;
                    }
                    var buffer = _self[_DYN__BUFFER ];
                    buffer[_DYN_CLEAR_SENT ](payload);
                    _consecutiveErrors++;
                    for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
                        var item = payload_1[_i];
                        buffer[_DYN_ENQUEUE ](item);
                    }
                    _setRetryTime(linearFactor);
                    _setupTimer();
                }
                function _setRetryTime(linearFactor) {
                    var SlotDelayInSeconds = 10;
                    var delayInSeconds;
                    if (_consecutiveErrors <= 1) {
                        delayInSeconds = SlotDelayInSeconds;
                    }
                    else {
                        var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                        var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                        backOffDelay = linearFactor * backOffDelay;
                        delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
                    }
                    var retryAfterTimeSpan = dateNow() + (delayInSeconds * 1000);
                    _retryAt = retryAfterTimeSpan;
                }
                function _setupTimer() {
                    if (!_timeoutHandle && !_paused) {
                        var retryInterval = _retryAt ? Math.max(0, _retryAt - dateNow()) : 0;
                        var timerValue = Math.max(_self[_DYN__SENDER_CONFIG ][_DYN_MAX_BATCH_INTERVAL$1 ](), retryInterval);
                        _timeoutHandle = setTimeout(function () {
                            _timeoutHandle = null;
                            _self[_DYN_TRIGGER_SEND ](true, null, 1 );
                        }, timerValue);
                    }
                }
                function _clearScheduledTimer() {
                    clearTimeout(_timeoutHandle);
                    _timeoutHandle = null;
                    _retryAt = null;
                }
                function _isRetriable(statusCode) {
                    return statusCode === 401
                        || statusCode === 403
                        || statusCode === 408
                        || statusCode === 429
                        || statusCode === 500
                        || statusCode === 502
                        || statusCode === 503
                        || statusCode === 504;
                }
                function _formatErrorMessageXhr(xhr, message) {
                    if (xhr) {
                        return "XMLHttpRequest,Status:" + xhr.status + ",Response:" + _getResponseText(xhr) || xhr.response || "";
                    }
                    return message;
                }
                function _xdrSender(payload, isAsync) {
                    var buffer = _self[_DYN__BUFFER ];
                    var _window = getWindow();
                    var xdr = new XDomainRequest();
                    xdr.onload = function () { return _self._xdrOnLoad(xdr, payload); };
                    xdr.onerror = function (event) { return _self[_DYN__ON_ERROR ](payload, _formatErrorMessageXdr(xdr), event); };
                    var hostingProtocol = _window && _window.location && _window.location.protocol || "";
                    if (_self[_DYN__SENDER_CONFIG ][_DYN_ENDPOINT_URL$1 ]().lastIndexOf(hostingProtocol, 0) !== 0) {
                        _throwInternal(_self[_DYN_DIAG_LOG ](), 2 , 40 , ". " +
                            "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.");
                        buffer[_DYN_CLEAR ]();
                        return;
                    }
                    var endpointUrl = _self[_DYN__SENDER_CONFIG ][_DYN_ENDPOINT_URL$1 ]().replace(/^(https?:)/, "");
                    xdr.open("POST", endpointUrl);
                    var batch = buffer[_DYN_BATCH_PAYLOADS ](payload);
                    xdr.send(batch);
                    buffer[_DYN_MARK_AS_SENT ](payload);
                }
                function _formatErrorMessageXdr(xdr, message) {
                    if (xdr) {
                        return "XDomainRequest,Response:" + _getResponseText(xdr) || "";
                    }
                    return message;
                }
                function _getNotifyMgr() {
                    var func = "getNotifyMgr";
                    if (_self.core[func]) {
                        return _self.core[func]();
                    }
                    return _self.core["_notificationManager"];
                }
                function _notifySendRequest(sendRequest, isAsync) {
                    var manager = _getNotifyMgr();
                    if (manager && manager[_DYN_EVENTS_SEND_REQUEST ]) {
                        try {
                            manager[_DYN_EVENTS_SEND_REQUEST ](sendRequest, isAsync);
                        }
                        catch (e) {
                            _throwInternal(_self[_DYN_DIAG_LOG ](), 1 , 74 , "send request notification failed: " + getExceptionName(e), { exception: dumpObj(e) });
                        }
                    }
                }
                function _validateInstrumentationKey(config) {
                    var disableIKeyValidationFlag = isNullOrUndefined(config[_DYN_DISABLE_INSTRUMENTAT7 ]) ? false : config[_DYN_DISABLE_INSTRUMENTAT7 ];
                    if (disableIKeyValidationFlag) {
                        return true;
                    }
                    var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                    var regexp = new RegExp(UUID_Regex);
                    return regexp.test(config[_DYN_INSTRUMENTATION_KEY$1 ]);
                }
                function _initDefaults() {
                    _self[_DYN__SENDER ] = null;
                    _self[_DYN__BUFFER ] = null;
                    _self._appId = null;
                    _self._sample = null;
                    _headers = {};
                    _offlineListener = null;
                    _consecutiveErrors = 0;
                    _retryAt = null;
                    _paused = false;
                    _timeoutHandle = null;
                    _serializer = null;
                    _stamp_specific_redirects = 0;
                    _syncFetchPayload = 0;
                    _fallbackSender = null;
                    _syncUnloadSender = null;
                    _evtNamespace = null;
                }
            });
            return _this;
        }
        Sender.constructEnvelope = function (orig, iKey, logger, convertUndefined) {
            var envelope;
            if (iKey !== orig.iKey && !isNullOrUndefined(iKey)) {
                envelope = __assignFn(__assignFn({}, orig), { iKey: iKey });
            }
            else {
                envelope = orig;
            }
            var creator = EnvelopeTypeCreator[envelope.baseType] || EventEnvelopeCreator;
            return creator(logger, envelope, convertUndefined);
        };
        return Sender;
    }(BaseTelemetryPlugin));

    var STR_DURATION = "duration";
    var STR_PROPERTIES = "properties";

    var _DYN_REQUEST_URL = "requestUrl";
    var _DYN_INST = "inst";
    var _DYN_LENGTH$1 = "length";
    var _DYN_TRACE_ID = "traceID";
    var _DYN_SPAN_ID = "spanID";
    var _DYN_TRACE_FLAGS = "traceFlags";
    var _DYN_CONTEXT$1 = "context";
    var _DYN_ABORTED = "aborted";
    var _DYN_TRACE_ID0 = "traceId";
    var _DYN_SPAN_ID1 = "spanId";
    var _DYN_CORE = "core";
    var _DYN_INCLUDE_CORRELATION_2 = "includeCorrelationHeaders";
    var _DYN_CAN_INCLUDE_CORRELAT3 = "canIncludeCorrelationHeader";
    var _DYN_GET_ABSOLUTE_URL = "getAbsoluteUrl";
    var _DYN_HEADERS = "headers";
    var _DYN_REQUEST_HEADERS = "requestHeaders";
    var _DYN_APP_ID = "appId";
    var _DYN_SET_REQUEST_HEADER = "setRequestHeader";
    var _DYN_TRACK_DEPENDENCY_DAT4 = "trackDependencyDataInternal";
    var _DYN_DISTRIBUTED_TRACING_5 = "distributedTracingMode";
    var _DYN_START_TIME = "startTime";
    var _DYN_TO_LOWER_CASE = "toLowerCase";
    var _DYN_ENABLE_REQUEST_HEADE6 = "enableRequestHeaderTracking";
    var _DYN_ENABLE_AJAX_ERROR_ST7 = "enableAjaxErrorStatusText";
    var _DYN_ENABLE_AJAX_PERF_TRA8 = "enableAjaxPerfTracking";
    var _DYN_MAX_AJAX_CALLS_PER_V9 = "maxAjaxCallsPerView";
    var _DYN_ENABLE_RESPONSE_HEAD10 = "enableResponseHeaderTracking";
    var _DYN_EXCLUDE_REQUEST_FROM11 = "excludeRequestFromAutoTrackingPatterns";
    var _DYN_ADD_REQUEST_CONTEXT = "addRequestContext";
    var _DYN_DISABLE_AJAX_TRACKIN12 = "disableAjaxTracking";
    var _DYN_DISABLE_FETCH_TRACKI13 = "disableFetchTracking";
    var _DYN_STATUS = "status";
    var _DYN_STATUS_TEXT = "statusText";
    var _DYN_HEADER_MAP = "headerMap";
    var _DYN_OPEN_DONE = "openDone";
    var _DYN_SEND_DONE = "sendDone";
    var _DYN_REQUEST_SENT_TIME = "requestSentTime";
    var _DYN_ABORT_DONE = "abortDone";
    var _DYN_GET_TRACE_ID = "getTraceId";
    var _DYN_GET_TRACE_FLAGS = "getTraceFlags";
    var _DYN_METHOD = "method";
    var _DYN_ERROR_STATUS_TEXT = "errorStatusText";
    var _DYN_STATE_CHANGE_ATTACHE14 = "stateChangeAttached";
    var _DYN_RESPONSE_TEXT = "responseText";
    var _DYN_RESPONSE_FINISHED_TI15 = "responseFinishedTime";
    var _DYN__CREATE_TRACK_ITEM = "CreateTrackItem";
    var _DYN_RESPONSE = "response";
    var _DYN_GET_ALL_RESPONSE_HEA16 = "getAllResponseHeaders";
    var _DYN_GET_PART_APROPS = "getPartAProps";
    var _DYN_GET_CORRELATION_CONT17 = "getCorrelationContext";
    var _DYN_PERF_MARK = "perfMark";
    var _DYN_AJAX_PERF_LOOKUP_DEL18 = "ajaxPerfLookupDelay";
    var _DYN_NAME = "name";
    var _DYN_PERF_TIMING = "perfTiming";
    var _DYN_CORRELATION_CONTEXT = "correlationContext";
    var _DYN_AJAX_TOTAL_DURATION = "ajaxTotalDuration";
    var _DYN_EVENT_TRACE_CTX = "eventTraceCtx";

    function _calcPerfDuration(resourceEntry, start, end) {
        var result = 0;
        var from = resourceEntry[start];
        var to = resourceEntry[end];
        if (from && to) {
            result = dateTimeUtilsDuration(from, to);
        }
        return result;
    }
    function _setPerfDuration(props, name, resourceEntry, start, end) {
        var result = 0;
        var value = _calcPerfDuration(resourceEntry, start, end);
        if (value) {
            result = _setPerfValue(props, name, msToTimeSpan(value));
        }
        return result;
    }
    function _setPerfValue(props, name, value) {
        var strPerf = "ajaxPerf";
        var result = 0;
        if (props && name && value) {
            var perfData = props[strPerf] = (props[strPerf] || {});
            perfData[name] = value;
            result = 1;
        }
        return result;
    }
    function _populatePerfData(ajaxData, dependency) {
        var resourceEntry = ajaxData[_DYN_PERF_TIMING ];
        var props = dependency[STR_PROPERTIES ] || {};
        var propsSet = 0;
        var strName = "name";
        var strStart = "Start";
        var strEnd = "End";
        var strDomainLookup = "domainLookup";
        var strConnect = "connect";
        var strRedirect = "redirect";
        var strRequest = "request";
        var strResponse = "response";
        var strStartTime = "startTime";
        var strDomainLookupStart = strDomainLookup + strStart;
        var strDomainLookupEnd = strDomainLookup + strEnd;
        var strConnectStart = strConnect + strStart;
        var strConnectEnd = strConnect + strEnd;
        var strRequestStart = strRequest + strStart;
        var strRequestEnd = strRequest + strEnd;
        var strResponseStart = strResponse + strStart;
        var strResponseEnd = strResponse + strEnd;
        var strRedirectStart = strRedirect + strStart;
        var strRedirectEnd = strRedirect = strEnd;
        var strTransferSize = "transferSize";
        var strEncodedBodySize = "encodedBodySize";
        var strDecodedBodySize = "decodedBodySize";
        var strServerTiming = "serverTiming";
        if (resourceEntry) {
            propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
            propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
            propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
            propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
            propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
            propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
            propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
            var duration = resourceEntry[STR_DURATION ];
            if (!duration) {
                duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
            }
            propsSet |= _setPerfValue(props, STR_DURATION, duration);
            propsSet |= _setPerfValue(props, "perfTotal", duration);
            var serverTiming = resourceEntry[strServerTiming];
            if (serverTiming) {
                var server_1 = {};
                arrForEach(serverTiming, function (value, idx) {
                    var name = normalizeJsName(value[strName] || "" + idx);
                    var newValue = server_1[name] || {};
                    objForEachKey(value, function (key, val) {
                        if (key !== strName && isString(val) || isNumber(val)) {
                            if (newValue[key]) {
                                val = newValue[key] + ";" + val;
                            }
                            if (val || !isString(val)) {
                                newValue[key] = val;
                            }
                        }
                    });
                    server_1[name] = newValue;
                });
                propsSet |= _setPerfValue(props, strServerTiming, server_1);
            }
            propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
            propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
            propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
        }
        else {
            if (ajaxData[_DYN_PERF_MARK ]) {
                propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
            }
        }
        if (propsSet) {
            dependency[STR_PROPERTIES ] = props;
        }
    }
    var XHRMonitoringState = /** @class */ (function () {
        function XHRMonitoringState() {
            var self = this;
            self[_DYN_OPEN_DONE ] = false;
            self.setRequestHeaderDone = false;
            self[_DYN_SEND_DONE ] = false;
            self[_DYN_ABORT_DONE ] = false;
            self[_DYN_STATE_CHANGE_ATTACHE14 ] = false;
        }
        return XHRMonitoringState;
    }());
    var ajaxRecord = /** @class */ (function () {
        function ajaxRecord(traceId, spanId, logger, traceCtx) {
            var _a;
            var self = this;
            var _logger = logger;
            var strResponseText = "responseText";
            self[_DYN_PERF_MARK ] = null;
            self.completed = false;
            self.requestHeadersSize = null;
            self[_DYN_REQUEST_HEADERS ] = null;
            self.responseReceivingDuration = null;
            self.callbackDuration = null;
            self[_DYN_AJAX_TOTAL_DURATION ] = null;
            self[_DYN_ABORTED ] = 0;
            self.pageUrl = null;
            self[_DYN_REQUEST_URL ] = null;
            self.requestSize = 0;
            self[_DYN_METHOD ] = null;
            self[_DYN_STATUS ] = null;
            self[_DYN_REQUEST_SENT_TIME ] = null;
            self.responseStartedTime = null;
            self[_DYN_RESPONSE_FINISHED_TI15 ] = null;
            self.callbackFinishedTime = null;
            self.endTime = null;
            self.xhrMonitoringState = new XHRMonitoringState();
            self.clientFailure = 0;
            self[_DYN_TRACE_ID ] = traceId;
            self[_DYN_SPAN_ID ] = spanId;
            self[_DYN_TRACE_FLAGS ] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
            if (traceCtx) {
                self[_DYN_EVENT_TRACE_CTX ] = (_a = {},
                    _a[_DYN_TRACE_ID0 ] = traceCtx[_DYN_GET_TRACE_ID ](),
                    _a[_DYN_SPAN_ID1 ] = traceCtx.getSpanId(),
                    _a[_DYN_TRACE_FLAGS ] = traceCtx[_DYN_GET_TRACE_FLAGS ](),
                    _a);
            }
            else {
                self[_DYN_EVENT_TRACE_CTX ] = null;
            }
            dynamicProto(ajaxRecord, self, function (self) {
                self.getAbsoluteUrl = function () {
                    return self[_DYN_REQUEST_URL ] ? urlGetAbsoluteUrl(self[_DYN_REQUEST_URL ]) : null;
                };
                self.getPathName = function () {
                    return self[_DYN_REQUEST_URL ] ? dataSanitizeUrl(_logger, urlGetCompleteUrl(self[_DYN_METHOD ], self[_DYN_REQUEST_URL ])) : null;
                };
                self[_DYN__CREATE_TRACK_ITEM ] = function (ajaxType, enableRequestHeaderTracking, getResponse) {
                    var _a;
                    self.ajaxTotalDuration = Math.round(dateTimeUtilsDuration(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                    if (self[_DYN_AJAX_TOTAL_DURATION ] < 0) {
                        return null;
                    }
                    var dependency = (_a = {
                            id: "|" + self[_DYN_TRACE_ID ] + "." + self[_DYN_SPAN_ID ],
                            target: self[_DYN_GET_ABSOLUTE_URL ]()
                        },
                        _a[_DYN_NAME ] = self.getPathName(),
                        _a.type = ajaxType,
                        _a[_DYN_START_TIME ] = null,
                        _a.duration = self[_DYN_AJAX_TOTAL_DURATION ],
                        _a.success = (+(self[_DYN_STATUS ])) >= 200 && (+(self[_DYN_STATUS ])) < 400,
                        _a.responseCode = (+(self[_DYN_STATUS ])),
                        _a[STR_PROPERTIES] = { HttpMethod: self[_DYN_METHOD ] },
                        _a);
                    var props = dependency[STR_PROPERTIES];
                    if (self[_DYN_ABORTED ]) {
                        props[_DYN_ABORTED ] = true;
                    }
                    if (self[_DYN_REQUEST_SENT_TIME ]) {
                        dependency[_DYN_START_TIME ] = new Date();
                        dependency[_DYN_START_TIME ].setTime(self[_DYN_REQUEST_SENT_TIME ]);
                    }
                    _populatePerfData(self, dependency);
                    if (enableRequestHeaderTracking) {
                        if (objKeys(self.requestHeaders)[_DYN_LENGTH$1 ] > 0) {
                            props[_DYN_REQUEST_HEADERS ] = self[_DYN_REQUEST_HEADERS ];
                        }
                    }
                    if (getResponse) {
                        var response = getResponse();
                        if (response) {
                            var correlationContext = response[_DYN_CORRELATION_CONTEXT ];
                            if (correlationContext) {
                                dependency.correlationContext =  correlationContext;
                            }
                            if (response[_DYN_HEADER_MAP ]) {
                                if (objKeys(response.headerMap)[_DYN_LENGTH$1 ] > 0) {
                                    props.responseHeaders = response[_DYN_HEADER_MAP ];
                                }
                            }
                            if (self[_DYN_ERROR_STATUS_TEXT ]) {
                                if (self[_DYN_STATUS ] >= 400) {
                                    var responseType = response.type;
                                    if (responseType === "" || responseType === "text") {
                                        props.responseText = response.responseText ? response[_DYN_STATUS_TEXT ] + " - " + response[strResponseText] : response[_DYN_STATUS_TEXT ];
                                    }
                                    if (responseType === "json") {
                                        props.responseText = response.response ? response[_DYN_STATUS_TEXT ] + " - " + JSON.stringify(response[_DYN_RESPONSE ]) : response[_DYN_STATUS_TEXT ];
                                    }
                                }
                                else if (self[_DYN_STATUS ] === 0) {
                                    props.responseText = response[_DYN_STATUS_TEXT ] || "";
                                }
                            }
                        }
                    }
                    return dependency;
                };
                self[_DYN_GET_PART_APROPS ] = function () {
                    var _a;
                    var partA = null;
                    var traceCtx = self[_DYN_EVENT_TRACE_CTX ];
                    if (traceCtx && (traceCtx[_DYN_TRACE_ID0 ] || traceCtx[_DYN_SPAN_ID1 ])) {
                        partA = {};
                        var traceExt = partA[Extensions.TraceExt] = (_a = {},
                            _a[_DYN_TRACE_ID ] = traceCtx[_DYN_TRACE_ID0 ],
                            _a.parentID = traceCtx[_DYN_SPAN_ID1 ],
                            _a);
                        if (!isNullOrUndefined(traceCtx[_DYN_TRACE_FLAGS ])) {
                            traceExt[_DYN_TRACE_FLAGS ] = traceCtx[_DYN_TRACE_FLAGS ];
                        }
                    }
                    return partA;
                };
            });
        }
        ajaxRecord.__ieDyn=1;
        return ajaxRecord;
    }());

    var AJAX_MONITOR_PREFIX = "ai.ajxmn.";
    var strDiagLog = "diagLog";
    var strAjaxData = "ajaxData";
    var STR_FETCH = "fetch";
    var ERROR_HEADER = "Failed to monitor XMLHttpRequest";
    var ERROR_PREFIX = ", monitoring data for this ajax call ";
    var ERROR_POSTFIX = ERROR_PREFIX + "may be incorrect.";
    var ERROR_NOT_SENT = ERROR_PREFIX + "won't be sent.";
    var CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
    var CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
    var FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
    var _markCount = 0;
    function _supportsFetch() {
        var _global = getGlobal();
        if (!_global ||
            isNullOrUndefined(_global.Request) ||
            isNullOrUndefined(_global.Request[strShimPrototype]) ||
            isNullOrUndefined(_global[STR_FETCH])) {
            return null;
        }
        return _global[STR_FETCH];
    }
    var _isWebWorker = null;
    function isWebWorker() {
        if (_isWebWorker == null) {
            try {
                _isWebWorker = !!(self && self instanceof WorkerGlobalScope);
            }
            catch (e) {
                _isWebWorker = false;
            }
        }
        return _isWebWorker;
    }
    function _supportsAjaxMonitoring(ajaxMonitorInstance) {
        var result = false;
        if (isXhrSupported()) {
            var proto = XMLHttpRequest[strShimPrototype];
            result = !isNullOrUndefined(proto) &&
                !isNullOrUndefined(proto.open) &&
                !isNullOrUndefined(proto.send) &&
                !isNullOrUndefined(proto.abort);
        }
        var ieVer = getIEVersion();
        if (ieVer && ieVer < 9) {
            result = false;
        }
        if (result) {
            try {
                var xhr = new XMLHttpRequest();
                xhr[strAjaxData] = {};
                var theOpen = XMLHttpRequest[strShimPrototype].open;
                XMLHttpRequest[strShimPrototype].open = theOpen;
            }
            catch (e) {
                result = false;
                _throwInternalCritical(ajaxMonitorInstance, 15 , "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
                    exception: dumpObj(e)
                });
            }
        }
        return result;
    }
    function _getFailedAjaxDiagnosticsMessage(xhr) {
        var result = "";
        try {
            if (xhr && xhr[strAjaxData] && xhr[strAjaxData][_DYN_REQUEST_URL ]) {
                result += "(url: '" + xhr[strAjaxData][_DYN_REQUEST_URL ] + "')";
            }
        }
        catch (e) {
        }
        return result;
    }
    function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
        _throwInternal(ajaxMonitorInstance[strDiagLog](), 1 , msgId, message, properties, isUserAct);
    }
    function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
        _throwInternal(ajaxMonitorInstance[strDiagLog](), 2 , msgId, message, properties, isUserAct);
    }
    function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
        return function (args) {
            _throwInternalCritical(ajaxMonitorInstance, internalMessage, message, {
                ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(args[_DYN_INST ]),
                exception: dumpObj(args.err)
            });
        };
    }
    function _indexOf(value, match) {
        if (value && match) {
            return value.indexOf(match);
        }
        return -1;
    }
    function _addHandler(container, id, theFunc) {
        var theHandler = {
            id: id,
            fn: theFunc
        };
        container.push(theHandler);
        return {
            remove: function () {
                arrForEach(container, function (initializer, idx) {
                    if (initializer.id === theHandler.id) {
                        container.splice(idx, 1);
                        return -1;
                    }
                });
            }
        };
    }
    function _processDependencyContainer(core, container, details, message) {
        var result = true;
        arrForEach(container, function (theFunc, idx) {
            try {
                if (theFunc.fn.call(null, details) === false) {
                    result = false;
                }
            }
            catch (e) {
                _throwInternal(core && core.logger, 1 , 64 , "Dependency " + message + " [#" + idx + "] failed: " + getExceptionName(e), { exception: dumpObj(e) }, true);
            }
        });
        return result;
    }
    function _processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
        var initializersCount = listeners[_DYN_LENGTH$1 ];
        if (initializersCount > 0) {
            var details = {
                core: core,
                xhr: xhr,
                input: input,
                init: init,
                traceId: ajaxData[_DYN_TRACE_ID ],
                spanId: ajaxData[_DYN_SPAN_ID ],
                traceFlags: ajaxData[_DYN_TRACE_FLAGS ],
                context: ajaxData[_DYN_CONTEXT$1 ] || {},
                aborted: !!ajaxData[_DYN_ABORTED ]
            };
            _processDependencyContainer(core, listeners, details, "listener");
            ajaxData[_DYN_TRACE_ID ] = details[_DYN_TRACE_ID0 ];
            ajaxData[_DYN_SPAN_ID ] = details[_DYN_SPAN_ID1 ];
            ajaxData[_DYN_TRACE_FLAGS ] = details[_DYN_TRACE_FLAGS ];
            ajaxData[_DYN_CONTEXT$1 ] = details[_DYN_CONTEXT$1 ];
        }
    }
    var BLOB_CORE = "*.blob.core.";
    var DfltAjaxCorrelationHeaderExDomains = deepFreeze([
        BLOB_CORE + "windows.net",
        BLOB_CORE + "chinacloudapi.cn",
        BLOB_CORE + "cloudapi.de",
        BLOB_CORE + "usgovcloudapi.net"
    ]);
    var _internalExcludeEndpoints = [
        /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
    ];
    function _getDefaultConfig() {
        var config = {
            maxAjaxCallsPerView: 500,
            disableAjaxTracking: false,
            disableFetchTracking: false,
            excludeRequestFromAutoTrackingPatterns: undefined,
            disableCorrelationHeaders: false,
            distributedTracingMode: 1 ,
            correlationHeaderExcludedDomains: DfltAjaxCorrelationHeaderExDomains,
            correlationHeaderDomains: undefined,
            correlationHeaderExcludePatterns: undefined,
            appId: undefined,
            enableCorsCorrelation: false,
            enableRequestHeaderTracking: false,
            enableResponseHeaderTracking: false,
            enableAjaxErrorStatusText: false,
            enableAjaxPerfTracking: false,
            maxAjaxPerfLookupAttempts: 3,
            ajaxPerfLookupDelay: 25,
            ignoreHeaders: [
                "Authorization",
                "X-API-Key",
                "WWW-Authenticate"
            ],
            addRequestContext: undefined,
            addIntEndpoints: true
        };
        return config;
    }
    function _getEmptyConfig() {
        var emptyConfig = _getDefaultConfig();
        objForEachKey(emptyConfig, function (value) {
            emptyConfig[value] = undefined;
        });
        return emptyConfig;
    }
    var AjaxMonitor = /** @class */ (function (_super) {
        __extendsFn(AjaxMonitor, _super);
        function AjaxMonitor() {
            var _this = _super.call(this) || this;
            _this.identifier = AjaxMonitor.identifier;
            _this.priority = 120;
            var _fetchInitialized;
            var _xhrInitialized;
            var _currentWindowHost;
            var _config;
            var _enableRequestHeaderTracking;
            var _enableAjaxErrorStatusText;
            var _trackAjaxAttempts;
            var _context;
            var _isUsingW3CHeaders;
            var _isUsingAIHeaders;
            var _markPrefix;
            var _enableAjaxPerfTracking;
            var _maxAjaxCallsPerView;
            var _enableResponseHeaderTracking;
            var _disabledUrls;
            var _disableAjaxTracking;
            var _disableFetchTracking;
            var _excludeRequestFromAutoTrackingPatterns;
            var _addRequestContext;
            var _evtNamespace;
            var _dependencyHandlerId;
            var _dependencyListeners;
            var _dependencyInitializers;
            dynamicProto(AjaxMonitor, _this, function (_self, _base) {
                var _addHook = _base._addHook;
                _initDefaults();
                _self.initialize = function (config, core, extensions, pluginChain) {
                    if (!_self.isInitialized()) {
                        _base.initialize(config, core, extensions, pluginChain);
                        _evtNamespace = mergeEvtNamespace(createUniqueNamespace("ajax"), core && core.evtNamespace && core.evtNamespace());
                        _populateDefaults(config);
                        _instrumentXhr();
                        _instrumentFetch();
                        _populateContext();
                    }
                };
                _self._doTeardown = function () {
                    _initDefaults();
                };
                _self.trackDependencyData = function (dependency, properties) {
                    _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE ], null, dependency, properties);
                };
                _self[_DYN_INCLUDE_CORRELATION_2 ] = function (ajaxData, input, init, xhr) {
                    var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                    _processDependencyListeners(_dependencyListeners, _self[_DYN_CORE ], ajaxData, xhr, input, init);
                    if (input) {
                        if (CorrelationIdHelper[_DYN_CAN_INCLUDE_CORRELAT3 ](_config, ajaxData[_DYN_GET_ABSOLUTE_URL ](), currentWindowHost)) {
                            if (!init) {
                                init = {};
                            }
                            var headers = new Headers(init[_DYN_HEADERS ] || (input instanceof Request ? (input[_DYN_HEADERS ] || {}) : {}));
                            if (_isUsingAIHeaders) {
                                var id = "|" + ajaxData[_DYN_TRACE_ID ] + "." + ajaxData[_DYN_SPAN_ID ];
                                headers.set(RequestHeaders[3 ], id);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS ][RequestHeaders[3 ]] = id;
                                }
                            }
                            var appId = _config[_DYN_APP_ID ] || (_context && _context[_DYN_APP_ID ]());
                            if (appId) {
                                headers.set(RequestHeaders[0 ], RequestHeaders[2 ] + appId);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS ][RequestHeaders[0 ]] = RequestHeaders[2 ] + appId;
                                }
                            }
                            if (_isUsingW3CHeaders) {
                                var traceFlags = ajaxData[_DYN_TRACE_FLAGS ];
                                if (isNullOrUndefined(traceFlags)) {
                                    traceFlags = 0x01;
                                }
                                var traceParent = formatTraceParent(createTraceParent(ajaxData[_DYN_TRACE_ID ], ajaxData[_DYN_SPAN_ID ], traceFlags));
                                headers.set(RequestHeaders[4 ], traceParent);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS ][RequestHeaders[4 ]] = traceParent;
                                }
                            }
                            init[_DYN_HEADERS ] = headers;
                        }
                        return init;
                    }
                    else if (xhr) {
                        if (CorrelationIdHelper[_DYN_CAN_INCLUDE_CORRELAT3 ](_config, ajaxData[_DYN_GET_ABSOLUTE_URL ](), currentWindowHost)) {
                            if (_isUsingAIHeaders) {
                                var id = "|" + ajaxData[_DYN_TRACE_ID ] + "." + ajaxData[_DYN_SPAN_ID ];
                                xhr[_DYN_SET_REQUEST_HEADER ](RequestHeaders[3 ], id);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS ][RequestHeaders[3 ]] = id;
                                }
                            }
                            var appId = _config[_DYN_APP_ID ] || (_context && _context[_DYN_APP_ID ]());
                            if (appId) {
                                xhr[_DYN_SET_REQUEST_HEADER ](RequestHeaders[0 ], RequestHeaders[2 ] + appId);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS ][RequestHeaders[0 ]] = RequestHeaders[2 ] + appId;
                                }
                            }
                            if (_isUsingW3CHeaders) {
                                var traceFlags = ajaxData[_DYN_TRACE_FLAGS ];
                                if (isNullOrUndefined(traceFlags)) {
                                    traceFlags = 0x01;
                                }
                                var traceParent = formatTraceParent(createTraceParent(ajaxData[_DYN_TRACE_ID ], ajaxData[_DYN_SPAN_ID ], traceFlags));
                                xhr[_DYN_SET_REQUEST_HEADER ](RequestHeaders[4 ], traceParent);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS ][RequestHeaders[4 ]] = traceParent;
                                }
                            }
                        }
                        return xhr;
                    }
                    return undefined;
                };
                _self[_DYN_TRACK_DEPENDENCY_DAT4 ] = function (dependency, properties, systemProperties) {
                    if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                        if ((_config[_DYN_DISTRIBUTED_TRACING_5 ] === 2
                            || _config[_DYN_DISTRIBUTED_TRACING_5 ] === 1 )
                            && typeof dependency.id === "string" && dependency.id[dependency.id[_DYN_LENGTH$1 ] - 1] !== ".") {
                            dependency.id += ".";
                        }
                        if (isNullOrUndefined(dependency[_DYN_START_TIME ])) {
                            dependency[_DYN_START_TIME ] = new Date();
                        }
                        var item = createTelemetryItem(dependency, RemoteDependencyData.dataType, RemoteDependencyData.envelopeType, _self[strDiagLog](), properties, systemProperties);
                        _self[_DYN_CORE ].track(item);
                    }
                    else if (_trackAjaxAttempts === _maxAjaxCallsPerView) {
                        _throwInternalCritical(_self, 55 , "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                    }
                    ++_trackAjaxAttempts;
                };
                _self.addDependencyListener = function (dependencyListener) {
                    return _addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
                };
                _self.addDependencyInitializer = function (dependencyInitializer) {
                    return _addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
                };
                function _initDefaults() {
                    var location = getLocation();
                    _fetchInitialized = false;
                    _xhrInitialized = false;
                    _currentWindowHost = location && location.host && location.host[_DYN_TO_LOWER_CASE ]();
                    _config = AjaxMonitor.getEmptyConfig();
                    _enableRequestHeaderTracking = false;
                    _enableAjaxErrorStatusText = false;
                    _trackAjaxAttempts = 0;
                    _context = null;
                    _isUsingW3CHeaders = false;
                    _isUsingAIHeaders = false;
                    _markPrefix = null;
                    _enableAjaxPerfTracking = false;
                    _maxAjaxCallsPerView = 0;
                    _enableResponseHeaderTracking = false;
                    _disabledUrls = {};
                    _disableAjaxTracking = false;
                    _disableFetchTracking = false;
                    _excludeRequestFromAutoTrackingPatterns = null;
                    _addRequestContext = null;
                    _evtNamespace = null;
                    _dependencyHandlerId = 0;
                    _dependencyListeners = [];
                    _dependencyInitializers = [];
                }
                function _populateDefaults(config) {
                    var ctx = createProcessTelemetryContext(null, config, _self[_DYN_CORE ]);
                    _config = _getEmptyConfig();
                    var defaultConfig = _getDefaultConfig();
                    objForEachKey(defaultConfig, function (field, value) {
                        _config[field] = ctx.getConfig(AjaxMonitor.identifier, field, value);
                    });
                    var distributedTracingMode = _config[_DYN_DISTRIBUTED_TRACING_5 ];
                    _enableRequestHeaderTracking = _config[_DYN_ENABLE_REQUEST_HEADE6 ];
                    _enableAjaxErrorStatusText = _config[_DYN_ENABLE_AJAX_ERROR_ST7 ];
                    _enableAjaxPerfTracking = _config[_DYN_ENABLE_AJAX_PERF_TRA8 ];
                    _maxAjaxCallsPerView = _config[_DYN_MAX_AJAX_CALLS_PER_V9 ];
                    _enableResponseHeaderTracking = _config[_DYN_ENABLE_RESPONSE_HEAD10 ];
                    _excludeRequestFromAutoTrackingPatterns = [].concat(_config[_DYN_EXCLUDE_REQUEST_FROM11 ] || [], _config.addIntEndpoints !== false ? _internalExcludeEndpoints : []);
                    _addRequestContext = _config[_DYN_ADD_REQUEST_CONTEXT ];
                    _isUsingAIHeaders = distributedTracingMode === 0  || distributedTracingMode === 1 ;
                    _isUsingW3CHeaders = distributedTracingMode === 1  || distributedTracingMode === 2 ;
                    if (_enableAjaxPerfTracking) {
                        var iKey = config.instrumentationKey || "unkwn";
                        if (iKey[_DYN_LENGTH$1 ] > 5) {
                            _markPrefix = AJAX_MONITOR_PREFIX + iKey.substring(iKey[_DYN_LENGTH$1 ] - 5) + ".";
                        }
                        else {
                            _markPrefix = AJAX_MONITOR_PREFIX + iKey + ".";
                        }
                    }
                    _disableAjaxTracking = !!_config[_DYN_DISABLE_AJAX_TRACKIN12 ];
                    _disableFetchTracking = !!_config[_DYN_DISABLE_FETCH_TRACKI13 ];
                }
                function _populateContext() {
                    var propExt = _self[_DYN_CORE ].getPlugin(PropertiesPluginIdentifier);
                    if (propExt) {
                        _context = propExt.plugin[_DYN_CONTEXT$1 ];
                    }
                }
                function _canIncludeHeaders(header) {
                    var rlt = true;
                    if (header || _config.ignoreHeaders) {
                        arrForEach(_config.ignoreHeaders, (function (key) {
                            if (key[_DYN_TO_LOWER_CASE ]() === header[_DYN_TO_LOWER_CASE ]()) {
                                rlt = false;
                                return -1;
                            }
                        }));
                    }
                    return rlt;
                }
                function _instrumentFetch() {
                    var fetch = _supportsFetch();
                    if (!fetch) {
                        return;
                    }
                    var global = getGlobal();
                    var isPolyfill = fetch.polyfill;
                    if (!_disableFetchTracking && !_fetchInitialized) {
                        _addHook(InstrumentFunc(global, STR_FETCH, {
                            ns: _evtNamespace,
                            req: function (callDetails, input, init) {
                                var fetchData;
                                if (!_disableFetchTracking && _fetchInitialized &&
                                    !_isDisabledRequest(null, input, init) &&
                                    !(isPolyfill && _xhrInitialized)) {
                                    var ctx = callDetails.ctx();
                                    fetchData = _createFetchRecord(input, init);
                                    var newInit = _self[_DYN_INCLUDE_CORRELATION_2 ](fetchData, input, init);
                                    if (newInit !== init) {
                                        callDetails.set(1, newInit);
                                    }
                                    ctx.data = fetchData;
                                }
                            },
                            rsp: function (callDetails, input) {
                                if (!_disableFetchTracking) {
                                    var fetchData_1 = callDetails.ctx().data;
                                    if (fetchData_1) {
                                        callDetails.rslt = callDetails.rslt.then(function (response) {
                                            _reportFetchMetrics(callDetails, (response || {})[_DYN_STATUS ], input, response, fetchData_1, function () {
                                                var ajaxResponse = {
                                                    statusText: (response || {})[_DYN_STATUS_TEXT ],
                                                    headerMap: null,
                                                    correlationContext: _getFetchCorrelationContext(response)
                                                };
                                                if (_enableResponseHeaderTracking && response) {
                                                    var responseHeaderMap_1 = {};
                                                    response.headers.forEach(function (value, name) {
                                                        if (_canIncludeHeaders(name)) {
                                                            responseHeaderMap_1[name] = value;
                                                        }
                                                    });
                                                    ajaxResponse[_DYN_HEADER_MAP ] = responseHeaderMap_1;
                                                }
                                                return ajaxResponse;
                                            });
                                            return response;
                                        })["catch"](function (reason) {
                                            _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, { error: reason.message || dumpObj(reason) });
                                            throw reason;
                                        });
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 15 , "Failed to monitor Window.fetch" + ERROR_POSTFIX)
                        }, true, isWebWorker()));
                        _fetchInitialized = true;
                    }
                    else if (isPolyfill) {
                        _addHook(InstrumentFunc(global, STR_FETCH, {
                            ns: _evtNamespace,
                            req: function (callDetails, input, init) {
                                _isDisabledRequest(null, input, init);
                            }
                        }));
                    }
                    if (isPolyfill) {
                        global[STR_FETCH].polyfill = isPolyfill;
                    }
                }
                function _hookProto(target, funcName, callbacks) {
                    _addHook(InstrumentProto(target, funcName, callbacks));
                }
                function _instrumentXhr() {
                    if (_supportsAjaxMonitoring(_self) && !_disableAjaxTracking && !_xhrInitialized) {
                        _hookProto(XMLHttpRequest, "open", {
                            ns: _evtNamespace,
                            req: function (args, method, url, async) {
                                if (!_disableAjaxTracking) {
                                    var xhr = args[_DYN_INST ];
                                    var ajaxData = xhr[strAjaxData];
                                    if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, true)) {
                                        if (!ajaxData || !ajaxData.xhrMonitoringState[_DYN_OPEN_DONE ]) {
                                            _openHandler(xhr, method, url, async);
                                        }
                                        _attachToOnReadyStateChange(xhr);
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 15 , ERROR_HEADER + ".open" + ERROR_POSTFIX)
                        });
                        _hookProto(XMLHttpRequest, "send", {
                            ns: _evtNamespace,
                            req: function (args, context) {
                                if (!_disableAjaxTracking) {
                                    var xhr = args[_DYN_INST ];
                                    var ajaxData = xhr[strAjaxData];
                                    if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState[_DYN_SEND_DONE ]) {
                                        _createMarkId("xhr", ajaxData);
                                        ajaxData[_DYN_REQUEST_SENT_TIME ] = dateTimeUtilsNow();
                                        _self[_DYN_INCLUDE_CORRELATION_2 ](ajaxData, undefined, undefined, xhr);
                                        ajaxData.xhrMonitoringState[_DYN_SEND_DONE ] = true;
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 17 , ERROR_HEADER + ERROR_POSTFIX)
                        });
                        _hookProto(XMLHttpRequest, "abort", {
                            ns: _evtNamespace,
                            req: function (args) {
                                if (!_disableAjaxTracking) {
                                    var xhr = args[_DYN_INST ];
                                    var ajaxData = xhr[strAjaxData];
                                    if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState[_DYN_ABORT_DONE ]) {
                                        ajaxData[_DYN_ABORTED ] = 1;
                                        ajaxData.xhrMonitoringState[_DYN_ABORT_DONE ] = true;
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 13 , ERROR_HEADER + ".abort" + ERROR_POSTFIX)
                        });
                        _hookProto(XMLHttpRequest, "setRequestHeader", {
                            ns: _evtNamespace,
                            req: function (args, header, value) {
                                if (!_disableAjaxTracking && _enableRequestHeaderTracking) {
                                    var xhr = args[_DYN_INST ];
                                    if (_isMonitoredXhrInstance(xhr) && _canIncludeHeaders(header)) {
                                        xhr[strAjaxData][_DYN_REQUEST_HEADERS ][header] = value;
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 71 , ERROR_HEADER + ".setRequestHeader" + ERROR_POSTFIX)
                        });
                        _xhrInitialized = true;
                    }
                }
                function _isDisabledRequest(xhr, request, init) {
                    var isDisabled = false;
                    var theUrl = ((!isString(request) ? (request || {}).url || "" : request) || "")[_DYN_TO_LOWER_CASE ]();
                    arrForEach(_excludeRequestFromAutoTrackingPatterns, function (regex) {
                        var theRegex = regex;
                        if (isString(regex)) {
                            theRegex = new RegExp(regex);
                        }
                        if (!isDisabled) {
                            isDisabled = theRegex.test(theUrl);
                        }
                    });
                    if (isDisabled) {
                        return isDisabled;
                    }
                    var idx = _indexOf(theUrl, "?");
                    var idx2 = _indexOf(theUrl, "#");
                    if (idx === -1 || (idx2 !== -1 && idx2 < idx)) {
                        idx = idx2;
                    }
                    if (idx !== -1) {
                        theUrl = theUrl.substring(0, idx);
                    }
                    if (!isNullOrUndefined(xhr)) {
                        isDisabled = xhr[DisabledPropertyName] === true || theUrl[DisabledPropertyName] === true;
                    }
                    else if (!isNullOrUndefined(request)) {
                        isDisabled = (typeof request === "object" ? request[DisabledPropertyName] === true : false) ||
                            (init ? init[DisabledPropertyName] === true : false);
                    }
                    if (!isDisabled && theUrl && isInternalApplicationInsightsEndpoint(theUrl)) {
                        isDisabled = true;
                    }
                    if (isDisabled) {
                        if (!_disabledUrls[theUrl]) {
                            _disabledUrls[theUrl] = 1;
                        }
                    }
                    else {
                        if (_disabledUrls[theUrl]) {
                            isDisabled = true;
                        }
                    }
                    return isDisabled;
                }
                function _isMonitoredXhrInstance(xhr, excludeAjaxDataValidation) {
                    var ajaxValidation = true;
                    var initialized = _xhrInitialized;
                    if (!isNullOrUndefined(xhr)) {
                        ajaxValidation = excludeAjaxDataValidation === true || !isNullOrUndefined(xhr[strAjaxData]);
                    }
                    return initialized
                        && ajaxValidation;
                }
                function _getDistributedTraceCtx() {
                    var distributedTraceCtx = null;
                    if (_self[_DYN_CORE ] && _self[_DYN_CORE ].getTraceCtx) {
                        distributedTraceCtx = _self[_DYN_CORE ].getTraceCtx(false);
                    }
                    if (!distributedTraceCtx && _context && _context.telemetryTrace) {
                        distributedTraceCtx = createDistributedTraceContextFromTrace(_context.telemetryTrace);
                    }
                    return distributedTraceCtx;
                }
                function _openHandler(xhr, method, url, async) {
                    var _a;
                    var distributedTraceCtx = _getDistributedTraceCtx();
                    var traceID = (distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_ID ]()) || generateW3CId();
                    var spanID = generateW3CId().substr(0, 16);
                    var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                    ajaxData[_DYN_TRACE_FLAGS ] = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_FLAGS ]();
                    ajaxData[_DYN_METHOD ] = method;
                    ajaxData[_DYN_REQUEST_URL ] = url;
                    ajaxData.xhrMonitoringState[_DYN_OPEN_DONE ] = true;
                    ajaxData[_DYN_REQUEST_HEADERS ] = {};
                    ajaxData.async = async;
                    ajaxData[_DYN_ERROR_STATUS_TEXT ] = _enableAjaxErrorStatusText;
                    xhr[strAjaxData] = ajaxData;
                }
                function _attachToOnReadyStateChange(xhr) {
                    xhr[strAjaxData].xhrMonitoringState[_DYN_STATE_CHANGE_ATTACHE14 ] = eventOn(xhr, "readystatechange", function () {
                        try {
                            if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr)) {
                                _onAjaxComplete(xhr);
                            }
                        }
                        catch (e) {
                            var exceptionText = dumpObj(e);
                            if (!exceptionText || _indexOf(exceptionText[_DYN_TO_LOWER_CASE ](), "c00c023f") === -1) {
                                _throwInternalCritical(_self, 16 , ERROR_HEADER + " 'readystatechange' event handler" + ERROR_POSTFIX, {
                                    ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(xhr),
                                    exception: exceptionText
                                });
                            }
                        }
                    }, _evtNamespace);
                }
                function _getResponseText(xhr) {
                    try {
                        var responseType = xhr.responseType;
                        if (responseType === "" || responseType === "text") {
                            return xhr[_DYN_RESPONSE_TEXT ];
                        }
                    }
                    catch (e) {
                    }
                    return null;
                }
                function _onAjaxComplete(xhr) {
                    var ajaxData = xhr[strAjaxData];
                    ajaxData[_DYN_RESPONSE_FINISHED_TI15 ] = dateTimeUtilsNow();
                    ajaxData[_DYN_STATUS ] = xhr[_DYN_STATUS ];
                    function _reportXhrError(e, failedProps) {
                        var errorProps = failedProps || {};
                        errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr);
                        if (e) {
                            errorProps["exception"] = dumpObj(e);
                        }
                        _throwInternalWarning(_self, 14 , FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + ERROR_NOT_SENT, errorProps);
                    }
                    _findPerfResourceEntry("xmlhttprequest", ajaxData, function () {
                        try {
                            var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM ]("Ajax", _enableRequestHeaderTracking, function () {
                                var ajaxResponse = {
                                    statusText: xhr[_DYN_STATUS_TEXT ],
                                    headerMap: null,
                                    correlationContext: _getAjaxCorrelationContext(xhr),
                                    type: xhr.responseType,
                                    responseText: _getResponseText(xhr),
                                    response: xhr[_DYN_RESPONSE ]
                                };
                                if (_enableResponseHeaderTracking) {
                                    var headers = xhr[_DYN_GET_ALL_RESPONSE_HEA16 ]();
                                    if (headers) {
                                        var arr = strTrim(headers).split(/[\r\n]+/);
                                        var responseHeaderMap_2 = {};
                                        arrForEach(arr, function (line) {
                                            var parts = line.split(": ");
                                            var header = parts.shift();
                                            var value = parts.join(": ");
                                            if (_canIncludeHeaders(header)) {
                                                responseHeaderMap_2[header] = value;
                                            }
                                        });
                                        ajaxResponse[_DYN_HEADER_MAP ] = responseHeaderMap_2;
                                    }
                                }
                                return ajaxResponse;
                            });
                            var properties = void 0;
                            try {
                                if (!!_addRequestContext) {
                                    properties = _addRequestContext({ status: xhr[_DYN_STATUS ], xhr: xhr });
                                }
                            }
                            catch (e) {
                                _throwInternalWarning(_self, 104 , CUSTOM_REQUEST_CONTEXT_ERROR);
                            }
                            if (dependency) {
                                if (properties !== undefined) {
                                    dependency[STR_PROPERTIES ] = __assignFn(__assignFn({}, dependency.properties), properties);
                                }
                                var sysProperties = ajaxData[_DYN_GET_PART_APROPS ]();
                                _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE ], ajaxData, dependency, null, sysProperties);
                            }
                            else {
                                _reportXhrError(null, {
                                    requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME ],
                                    responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI15 ]
                                });
                            }
                        }
                        finally {
                            try {
                                xhr[strAjaxData] = null;
                            }
                            catch (e) {
                            }
                        }
                    }, function (e) {
                        _reportXhrError(e, null);
                    });
                }
                function _getAjaxCorrelationContext(xhr) {
                    try {
                        var responseHeadersString = xhr[_DYN_GET_ALL_RESPONSE_HEA16 ]();
                        if (responseHeadersString !== null) {
                            var index = _indexOf(responseHeadersString[_DYN_TO_LOWER_CASE ](), RequestHeaders[8 ]);
                            if (index !== -1) {
                                var responseHeader = xhr.getResponseHeader(RequestHeaders[0 ]);
                                return CorrelationIdHelper[_DYN_GET_CORRELATION_CONT17 ](responseHeader);
                            }
                        }
                    }
                    catch (e) {
                        _throwInternalWarning(_self, 18 , CORRELATION_HEADER_ERROR, {
                            ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(xhr),
                            exception: dumpObj(e)
                        });
                    }
                }
                function _createMarkId(type, ajaxData) {
                    if (ajaxData[_DYN_REQUEST_URL ] && _markPrefix && _enableAjaxPerfTracking) {
                        var performance_1 = getPerformance();
                        if (performance_1 && isFunction(performance_1.mark)) {
                            _markCount++;
                            var markId = _markPrefix + type + "#" + _markCount;
                            performance_1.mark(markId);
                            var entries = performance_1.getEntriesByName(markId);
                            if (entries && entries[_DYN_LENGTH$1 ] === 1) {
                                ajaxData[_DYN_PERF_MARK ] = entries[0];
                            }
                        }
                    }
                }
                function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                    var perfMark = ajaxData[_DYN_PERF_MARK ];
                    var performance = getPerformance();
                    var maxAttempts = _config.maxAjaxPerfLookupAttempts;
                    var retryDelay = _config[_DYN_AJAX_PERF_LOOKUP_DEL18 ];
                    var requestUrl = ajaxData[_DYN_REQUEST_URL ];
                    var attempt = 0;
                    (function locateResourceTiming() {
                        try {
                            if (performance && perfMark) {
                                attempt++;
                                var perfTiming = null;
                                var entries = performance.getEntries();
                                for (var lp = entries[_DYN_LENGTH$1 ] - 1; lp >= 0; lp--) {
                                    var entry = entries[lp];
                                    if (entry) {
                                        if (entry.entryType === "resource") {
                                            if (entry.initiatorType === initiatorType &&
                                                (_indexOf(entry[_DYN_NAME ], requestUrl) !== -1 || _indexOf(requestUrl, entry[_DYN_NAME ]) !== -1)) {
                                                perfTiming = entry;
                                            }
                                        }
                                        else if (entry.entryType === "mark" && entry[_DYN_NAME ] === perfMark[_DYN_NAME ]) {
                                            ajaxData[_DYN_PERF_TIMING ] = perfTiming;
                                            break;
                                        }
                                        if (entry[_DYN_START_TIME ] < perfMark[_DYN_START_TIME ] - 1000) {
                                            break;
                                        }
                                    }
                                }
                            }
                            if (!perfMark ||
                                ajaxData[_DYN_PERF_TIMING ] ||
                                attempt >= maxAttempts ||
                                ajaxData.async === false) {
                                if (perfMark && isFunction(performance.clearMarks)) {
                                    performance.clearMarks(perfMark[_DYN_NAME ]);
                                }
                                ajaxData.perfAttempts = attempt;
                                trackCallback();
                            }
                            else {
                                setTimeout(locateResourceTiming, retryDelay);
                            }
                        }
                        catch (e) {
                            reportError(e);
                        }
                    })();
                }
                function _createFetchRecord(input, init) {
                    var _a;
                    var distributedTraceCtx = _getDistributedTraceCtx();
                    var traceID = (distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_ID ]()) || generateW3CId();
                    var spanID = generateW3CId().substr(0, 16);
                    var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                    ajaxData[_DYN_TRACE_FLAGS ] = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_FLAGS ]();
                    ajaxData[_DYN_REQUEST_SENT_TIME ] = dateTimeUtilsNow();
                    ajaxData[_DYN_ERROR_STATUS_TEXT ] = _enableAjaxErrorStatusText;
                    if (input instanceof Request) {
                        ajaxData[_DYN_REQUEST_URL ] = input ? input.url : "";
                    }
                    else {
                        ajaxData[_DYN_REQUEST_URL ] = input;
                    }
                    var method = "GET";
                    if (init && init[_DYN_METHOD ]) {
                        method = init[_DYN_METHOD ];
                    }
                    else if (input && input instanceof Request) {
                        method = input[_DYN_METHOD ];
                    }
                    ajaxData[_DYN_METHOD ] = method;
                    var requestHeaders = {};
                    if (_enableRequestHeaderTracking) {
                        var headers = new Headers((init ? init[_DYN_HEADERS ] : 0) || (input instanceof Request ? (input[_DYN_HEADERS ] || {}) : {}));
                        headers.forEach(function (value, key) {
                            if (_canIncludeHeaders(key)) {
                                requestHeaders[key] = value;
                            }
                        });
                    }
                    ajaxData[_DYN_REQUEST_HEADERS ] = requestHeaders;
                    _createMarkId(STR_FETCH, ajaxData);
                    return ajaxData;
                }
                function _getFailedFetchDiagnosticsMessage(input) {
                    var result = "";
                    try {
                        if (!isNullOrUndefined(input)) {
                            if (typeof (input) === "string") {
                                result += "(url: '".concat(input, "')");
                            }
                            else {
                                result += "(url: '".concat(input.url, "')");
                            }
                        }
                    }
                    catch (e) {
                        _throwInternalCritical(_self, 15 , "Failed to grab failed fetch diagnostics message", { exception: dumpObj(e) });
                    }
                    return result;
                }
                function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
                    if (!ajaxData) {
                        return;
                    }
                    function _reportFetchError(msgId, e, failedProps) {
                        var errorProps = failedProps || {};
                        errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                        if (e) {
                            errorProps["exception"] = dumpObj(e);
                        }
                        _throwInternalWarning(_self, msgId, FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + ERROR_NOT_SENT, errorProps);
                    }
                    ajaxData[_DYN_RESPONSE_FINISHED_TI15 ] = dateTimeUtilsNow();
                    ajaxData[_DYN_STATUS ] = status;
                    _findPerfResourceEntry(STR_FETCH, ajaxData, function () {
                        var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM ]("Fetch", _enableRequestHeaderTracking, getResponse);
                        var properties;
                        try {
                            if (!!_addRequestContext) {
                                properties = _addRequestContext({ status: status, request: input, response: response });
                            }
                        }
                        catch (e) {
                            _throwInternalWarning(_self, 104 , CUSTOM_REQUEST_CONTEXT_ERROR);
                        }
                        if (dependency) {
                            if (properties !== undefined) {
                                dependency[STR_PROPERTIES ] = __assignFn(__assignFn({}, dependency.properties), properties);
                            }
                            var sysProperties = ajaxData[_DYN_GET_PART_APROPS ]();
                            _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE ], ajaxData, dependency, null, sysProperties);
                        }
                        else {
                            _reportFetchError(14 , null, {
                                requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME ],
                                responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI15 ]
                            });
                        }
                    }, function (e) {
                        _reportFetchError(18 , e, null);
                    });
                }
                function _getFetchCorrelationContext(response) {
                    if (response && response[_DYN_HEADERS ]) {
                        try {
                            var responseHeader = response[_DYN_HEADERS ].get(RequestHeaders[0 ]);
                            return CorrelationIdHelper[_DYN_GET_CORRELATION_CONT17 ](responseHeader);
                        }
                        catch (e) {
                            _throwInternalWarning(_self, 18 , CORRELATION_HEADER_ERROR, {
                                fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
                                exception: dumpObj(e)
                            });
                        }
                    }
                }
                function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
                    var result = true;
                    var initializersCount = initializers[_DYN_LENGTH$1 ];
                    if (initializersCount > 0) {
                        var details = {
                            item: dependency,
                            properties: properties,
                            sysProperties: systemProperties,
                            context: ajaxData ? ajaxData[_DYN_CONTEXT$1 ] : null,
                            aborted: ajaxData ? !!ajaxData[_DYN_ABORTED ] : false
                        };
                        result = _processDependencyContainer(core, initializers, details, "initializer");
                    }
                    if (result) {
                        _self[_DYN_TRACK_DEPENDENCY_DAT4 ](dependency, properties, systemProperties);
                    }
                }
            });
            return _this;
        }
        AjaxMonitor.prototype.processTelemetry = function (item, itemCtx) {
            this.processNext(item, itemCtx);
        };
        AjaxMonitor.prototype.addDependencyInitializer = function (dependencyInitializer) {
            return null;
        };
        AjaxMonitor.identifier = "AjaxDependencyPlugin";
        AjaxMonitor.getDefaultConfig = _getDefaultConfig;
        AjaxMonitor.getEmptyConfig = _getEmptyConfig;
        return AjaxMonitor;
    }(BaseTelemetryPlugin));

    var Application = /** @class */ (function () {
        function Application() {
        }
        return Application;
    }());

    var Device = /** @class */ (function () {
        function Device() {
            this.id = "browser";
            this.deviceClass = "Browser";
        }
        return Device;
    }());

    var _DYN_SESSION_MANAGER = "sessionManager";
    var _DYN_UPDATE = "update";
    var _DYN_IS_USER_COOKIE_SET = "isUserCookieSet";
    var _DYN_IS_NEW_USER = "isNewUser";
    var _DYN_GET_TRACE_CTX = "getTraceCtx";
    var _DYN_TELEMETRY_TRACE = "telemetryTrace";
    var _DYN_APPLY_SESSION_CONTEX0 = "applySessionContext";
    var _DYN_APPLY_APPLICATION_CO1 = "applyApplicationContext";
    var _DYN_APPLY_DEVICE_CONTEXT = "applyDeviceContext";
    var _DYN_APPLY_OPERATION_CONT2 = "applyOperationContext";
    var _DYN_APPLY_USER_CONTEXT = "applyUserContext";
    var _DYN_APPLY_OPERATING_SYST3 = "applyOperatingSystemContxt";
    var _DYN_APPLY_LOCATION_CONTE4 = "applyLocationContext";
    var _DYN_APPLY_INTERNAL_CONTE5 = "applyInternalContext";
    var _DYN_ACCOUNT_ID = "accountId";
    var _DYN_SDK_EXTENSION = "sdkExtension";
    var _DYN_GET_SESSION_ID = "getSessionId";
    var _DYN_NAME_PREFIX = "namePrefix";
    var _DYN_SESSION_COOKIE_POSTF6 = "sessionCookiePostfix";
    var _DYN_USER_COOKIE_POSTFIX = "userCookiePostfix";
    var _DYN_ID_LENGTH = "idLength";
    var _DYN_GET_NEW_ID = "getNewId";
    var _DYN_LENGTH = "length";
    var _DYN_AUTOMATIC_SESSION = "automaticSession";
    var _DYN_AUTHENTICATED_ID = "authenticatedId";
    var _DYN_SESSION_EXPIRATION_M7 = "sessionExpirationMs";
    var _DYN_SESSION_RENEWAL_MS = "sessionRenewalMs";
    var _DYN_CONFIG$1 = "config";
    var _DYN_ACQUISITION_DATE = "acquisitionDate";
    var _DYN_RENEWAL_DATE = "renewalDate";
    var _DYN_COOKIE_DOMAIN = "cookieDomain";
    var _DYN_JOIN = "join";
    var _DYN_COOKIE_SEPARATOR = "cookieSeparator";
    var _DYN_AUTH_USER_COOKIE_NAM8 = "authUserCookieName";

    var Version = '2.8.14';
    var Internal = /** @class */ (function () {
        function Internal(config) {
            this.sdkVersion = (config[_DYN_SDK_EXTENSION ] && config[_DYN_SDK_EXTENSION ]() ? config[_DYN_SDK_EXTENSION ]() + "_" : "") + "javascript:" + Version;
        }
        return Internal;
    }());

    var Location = /** @class */ (function () {
        function Location() {
        }
        return Location;
    }());

    var cookieNameConst = "ai_session";
    var Session = /** @class */ (function () {
        function Session() {
        }
        return Session;
    }());
    var _SessionManager = /** @class */ (function () {
        function _SessionManager(config, core) {
            var self = this;
            var _storageNamePrefix;
            var _cookieUpdatedTimestamp;
            var _logger = safeGetLogger(core);
            var _cookieManager = safeGetCookieMgr(core);
            dynamicProto(_SessionManager, self, function (_self) {
                if (!config) {
                    config = {};
                }
                if (!isFunction(config[_DYN_SESSION_EXPIRATION_M7 ])) {
                    config[_DYN_SESSION_EXPIRATION_M7 ] = function () { return _SessionManager.acquisitionSpan; };
                }
                if (!isFunction(config[_DYN_SESSION_RENEWAL_MS ])) {
                    config[_DYN_SESSION_RENEWAL_MS ] = function () { return _SessionManager.renewalSpan; };
                }
                _self[_DYN_CONFIG$1 ] = config;
                var sessionCookiePostfix = (_self.config[_DYN_SESSION_COOKIE_POSTF6 ] && _self[_DYN_CONFIG$1 ][_DYN_SESSION_COOKIE_POSTF6 ]()) ?
                    _self.config[_DYN_SESSION_COOKIE_POSTF6 ]() :
                    ((_self.config[_DYN_NAME_PREFIX ] && _self[_DYN_CONFIG$1 ][_DYN_NAME_PREFIX ]()) ? _self[_DYN_CONFIG$1 ][_DYN_NAME_PREFIX ]() : "");
                _storageNamePrefix = function () { return cookieNameConst + sessionCookiePostfix; };
                _self[_DYN_AUTOMATIC_SESSION ] = new Session();
                _self[_DYN_UPDATE ] = function () {
                    var nowMs = dateNow();
                    var isExpired = false;
                    var session = _self[_DYN_AUTOMATIC_SESSION ];
                    if (!session.id) {
                        isExpired = !_initializeAutomaticSession(session);
                    }
                    var sessionExpirationMs = _self.config[_DYN_SESSION_EXPIRATION_M7 ]();
                    if (!isExpired && sessionExpirationMs > 0) {
                        var sessionRenewalMs = _self.config[_DYN_SESSION_RENEWAL_MS ]();
                        var timeSinceAcqMs = nowMs - session[_DYN_ACQUISITION_DATE ];
                        var timeSinceRenewalMs = nowMs - session[_DYN_RENEWAL_DATE ];
                        isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0;
                        isExpired = isExpired || timeSinceAcqMs > sessionExpirationMs;
                        isExpired = isExpired || timeSinceRenewalMs > sessionRenewalMs;
                    }
                    if (isExpired) {
                        _renew(nowMs);
                    }
                    else {
                        if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > _SessionManager.cookieUpdateInterval) {
                            _setCookie(session, nowMs);
                        }
                    }
                };
                _self.backup = function () {
                    var session = _self[_DYN_AUTOMATIC_SESSION ];
                    _setStorage(session.id, session[_DYN_ACQUISITION_DATE ], session[_DYN_RENEWAL_DATE ]);
                };
                function _initializeAutomaticSession(session, now) {
                    var isValid = false;
                    var cookieValue = _cookieManager.get(_storageNamePrefix());
                    if (cookieValue && isFunction(cookieValue.split)) {
                        isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                    }
                    else {
                        var storageValue = utlGetLocalStorage(_logger, _storageNamePrefix());
                        if (storageValue) {
                            isValid = _initializeAutomaticSessionWithData(session, storageValue);
                        }
                    }
                    return isValid || !!session.id;
                }
                function _initializeAutomaticSessionWithData(session, sessionData) {
                    var isValid = false;
                    var sessionReset = ", session will be reset";
                    var tokens = sessionData.split("|");
                    if (tokens[_DYN_LENGTH ] >= 2) {
                        try {
                            var acqMs = +tokens[1] || 0;
                            var renewalMs = +tokens[2] || 0;
                            if (isNaN(acqMs) || acqMs <= 0) {
                                _throwInternal(_logger, 2 , 27 , "AI session acquisition date is 0" + sessionReset);
                            }
                            else if (isNaN(renewalMs) || renewalMs <= 0) {
                                _throwInternal(_logger, 2 , 27 , "AI session renewal date is 0" + sessionReset);
                            }
                            else if (tokens[0]) {
                                session.id = tokens[0];
                                session[_DYN_ACQUISITION_DATE ] = acqMs;
                                session[_DYN_RENEWAL_DATE ] = renewalMs;
                                isValid = true;
                            }
                        }
                        catch (e) {
                            _throwInternal(_logger, 1 , 9 , "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + getExceptionName(e), { exception: dumpObj(e) });
                        }
                    }
                    return isValid;
                }
                function _renew(nowMs) {
                    var theConfig = (_self[_DYN_CONFIG$1 ] || {});
                    var getNewId = (theConfig[_DYN_GET_NEW_ID ] ? theConfig[_DYN_GET_NEW_ID ]() : null) || newId;
                    _self.automaticSession.id = getNewId(theConfig[_DYN_ID_LENGTH ] ? theConfig[_DYN_ID_LENGTH ]() : 22);
                    _self[_DYN_AUTOMATIC_SESSION ][_DYN_ACQUISITION_DATE ] = nowMs;
                    _setCookie(_self[_DYN_AUTOMATIC_SESSION ], nowMs);
                    if (!utlCanUseLocalStorage()) {
                        _throwInternal(_logger, 2 , 0 , "Browser does not support local storage. Session durations will be inaccurate.");
                    }
                }
                function _setCookie(session, nowMs) {
                    var acq = session[_DYN_ACQUISITION_DATE ];
                    session[_DYN_RENEWAL_DATE ] = nowMs;
                    var config = _self[_DYN_CONFIG$1 ];
                    var renewalPeriodMs = config[_DYN_SESSION_RENEWAL_MS ]();
                    var acqTimeLeftMs = (acq + config[_DYN_SESSION_EXPIRATION_M7 ]()) - nowMs;
                    var cookie = [session.id, acq, nowMs];
                    var maxAgeSec = 0;
                    if (acqTimeLeftMs < renewalPeriodMs) {
                        maxAgeSec = acqTimeLeftMs / 1000;
                    }
                    else {
                        maxAgeSec = renewalPeriodMs / 1000;
                    }
                    var cookieDomain = config[_DYN_COOKIE_DOMAIN ] ? config[_DYN_COOKIE_DOMAIN ]() : null;
                    _cookieManager.set(_storageNamePrefix(), cookie.join("|"), config[_DYN_SESSION_EXPIRATION_M7 ]() > 0 ? maxAgeSec : null, cookieDomain);
                    _cookieUpdatedTimestamp = nowMs;
                }
                function _setStorage(guid, acq, renewal) {
                    utlSetLocalStorage(_logger, _storageNamePrefix(), [guid, acq, renewal][_DYN_JOIN ]("|"));
                }
            });
        }
        _SessionManager.acquisitionSpan = 86400000;
        _SessionManager.renewalSpan = 1800000;
        _SessionManager.cookieUpdateInterval = 60000;
        return _SessionManager;
    }());

    var TelemetryTrace = /** @class */ (function () {
        function TelemetryTrace(id, parentId, name, logger) {
            var _self = this;
            _self.traceID = id || generateW3CId();
            _self.parentID = parentId;
            var location = getLocation();
            if (!name && location && location.pathname) {
                name = location.pathname;
            }
            _self.name = dataSanitizeString(logger, name);
        }
        return TelemetryTrace;
    }());

    function _validateUserInput(id) {
        if (typeof id !== "string" ||
            !id ||
            id.match(/,|;|=| |\|/)) {
            return false;
        }
        return true;
    }
    var User = /** @class */ (function () {
        function User(config, core) {
            this.isNewUser = false;
            this.isUserCookieSet = false;
            var _logger = safeGetLogger(core);
            var _cookieManager = safeGetCookieMgr(core);
            var _storageNamePrefix;
            dynamicProto(User, this, function (_self) {
                _self[_DYN_CONFIG$1 ] = config;
                var userCookiePostfix = (_self.config[_DYN_USER_COOKIE_POSTFIX ] && _self[_DYN_CONFIG$1 ][_DYN_USER_COOKIE_POSTFIX ]()) ? _self[_DYN_CONFIG$1 ][_DYN_USER_COOKIE_POSTFIX ]() : "";
                _storageNamePrefix = function () { return User.userCookieName + userCookiePostfix; };
                var cookie = _cookieManager.get(_storageNamePrefix());
                if (cookie) {
                    _self[_DYN_IS_NEW_USER ] = false;
                    var params = cookie.split(User[_DYN_COOKIE_SEPARATOR ]);
                    if (params[_DYN_LENGTH ] > 0) {
                        _self.id = params[0];
                        _self[_DYN_IS_USER_COOKIE_SET ] = !!_self.id;
                    }
                }
                function _generateNewId() {
                    var theConfig = (config || {});
                    var getNewId = (theConfig[_DYN_GET_NEW_ID ] ? theConfig[_DYN_GET_NEW_ID ]() : null) || newId;
                    var id = getNewId(theConfig[_DYN_ID_LENGTH ] ? config[_DYN_ID_LENGTH ]() : 22);
                    return id;
                }
                function _generateNewCookie(userId) {
                    var acqStr = toISOString(new Date());
                    _self.accountAcquisitionDate = acqStr;
                    _self[_DYN_IS_NEW_USER ] = true;
                    var newCookie = [userId, acqStr];
                    return newCookie;
                }
                function _setUserCookie(cookie) {
                    var oneYear = 31536000;
                    _self[_DYN_IS_USER_COOKIE_SET ] = _cookieManager.set(_storageNamePrefix(), cookie, oneYear);
                }
                if (!_self.id) {
                    _self.id = _generateNewId();
                    var newCookie = _generateNewCookie(_self.id);
                    _setUserCookie(newCookie[_DYN_JOIN ](User[_DYN_COOKIE_SEPARATOR ]));
                    var name_1 = config[_DYN_NAME_PREFIX ] && config[_DYN_NAME_PREFIX ]() ? config[_DYN_NAME_PREFIX ]() + "ai_session" : "ai_session";
                    utlRemoveStorage(_logger, name_1);
                }
                _self[_DYN_ACCOUNT_ID ] = config[_DYN_ACCOUNT_ID ] ? config[_DYN_ACCOUNT_ID ]() : undefined;
                var authCookie = _cookieManager.get(User[_DYN_AUTH_USER_COOKIE_NAM8 ]);
                if (authCookie) {
                    authCookie = decodeURI(authCookie);
                    var authCookieString = authCookie.split(User[_DYN_COOKIE_SEPARATOR ]);
                    if (authCookieString[0]) {
                        _self[_DYN_AUTHENTICATED_ID ] = authCookieString[0];
                    }
                    if (authCookieString[_DYN_LENGTH ] > 1 && authCookieString[1]) {
                        _self[_DYN_ACCOUNT_ID ] = authCookieString[1];
                    }
                }
                _self.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
                    if (storeInCookie === void 0) { storeInCookie = false; }
                    var isInvalidInput = !_validateUserInput(authenticatedUserId) || (accountId && !_validateUserInput(accountId));
                    if (isInvalidInput) {
                        _throwInternal(_logger, 2 , 60 , "Setting auth user context failed. " +
                            "User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                        return;
                    }
                    _self[_DYN_AUTHENTICATED_ID ] = authenticatedUserId;
                    var authCookie = _self[_DYN_AUTHENTICATED_ID ];
                    if (accountId) {
                        _self[_DYN_ACCOUNT_ID ] = accountId;
                        authCookie = [_self[_DYN_AUTHENTICATED_ID ], _self.accountId][_DYN_JOIN ](User[_DYN_COOKIE_SEPARATOR ]);
                    }
                    if (storeInCookie) {
                        _cookieManager.set(User[_DYN_AUTH_USER_COOKIE_NAM8 ], encodeURI(authCookie));
                    }
                };
                _self.clearAuthenticatedUserContext = function () {
                    _self[_DYN_AUTHENTICATED_ID ] = null;
                    _self[_DYN_ACCOUNT_ID ] = null;
                    _cookieManager.del(User[_DYN_AUTH_USER_COOKIE_NAM8 ]);
                };
                _self[_DYN_UPDATE ] = function (userId) {
                    if (_self.id !== userId || !_self[_DYN_IS_USER_COOKIE_SET ]) {
                        var user_id = userId ? userId : _generateNewId();
                        var user_cookie = _generateNewCookie(user_id);
                        _setUserCookie(user_cookie[_DYN_JOIN ](User[_DYN_COOKIE_SEPARATOR ]));
                    }
                };
            });
        }
        User.cookieSeparator = "|";
        User.userCookieName = "ai_user";
        User.authUserCookieName = "ai_authUser";
        return User;
    }());

    var strExt = "ext";
    var strTags = "tags";
    function _removeEmpty(target, name) {
        if (target && target[name] && objKeys(target[name])[_DYN_LENGTH ] === 0) {
            delete target[name];
        }
    }
    var TelemetryContext = /** @class */ (function () {
        function TelemetryContext(core, defaultConfig, previousTraceCtx) {
            var _this = this;
            var logger = core.logger;
            this.appId = function () { return null; };
            this[_DYN_GET_SESSION_ID ] = function () { return null; };
            dynamicProto(TelemetryContext, this, function (_self) {
                _self.application = new Application();
                _self.internal = new Internal(defaultConfig);
                if (hasWindow()) {
                    _self[_DYN_SESSION_MANAGER ] = new _SessionManager(defaultConfig, core);
                    _self.device = new Device();
                    _self.location = new Location();
                    _self.user = new User(defaultConfig, core);
                    var traceId = void 0;
                    var parentId = void 0;
                    var name_1;
                    if (previousTraceCtx) {
                        traceId = previousTraceCtx.getTraceId();
                        parentId = previousTraceCtx.getSpanId();
                        name_1 = previousTraceCtx.getName();
                    }
                    _self[_DYN_TELEMETRY_TRACE ] = new TelemetryTrace(traceId, parentId, name_1, logger);
                    _self.session = new Session();
                }
                _self[_DYN_GET_SESSION_ID ] = function () {
                    var session = _self.session;
                    var sesId = null;
                    if (session && isString(session.id)) {
                        sesId = session.id;
                    }
                    else {
                        var autoSession = (_self[_DYN_SESSION_MANAGER ] || {})[_DYN_AUTOMATIC_SESSION ];
                        sesId = autoSession && isString(autoSession.id) ? autoSession.id : null;
                    }
                    return sesId;
                };
                _self[_DYN_APPLY_SESSION_CONTEX0 ] = function (evt, itemCtx) {
                    setValue(getSetValue(evt.ext, Extensions.AppExt), "sesId", _self[_DYN_GET_SESSION_ID ](), isString);
                };
                _self[_DYN_APPLY_OPERATING_SYST3 ] = function (evt, itemCtx) {
                    setValue(evt.ext, Extensions.OSExt, _self.os);
                };
                _self[_DYN_APPLY_APPLICATION_CO1 ] = function (evt, itemCtx) {
                    var application = _self.application;
                    if (application) {
                        var tags = getSetValue(evt, strTags);
                        setValue(tags, CtxTagKeys.applicationVersion, application.ver, isString);
                        setValue(tags, CtxTagKeys.applicationBuild, application.build, isString);
                    }
                };
                _self[_DYN_APPLY_DEVICE_CONTEXT ] = function (evt, itemCtx) {
                    var device = _self.device;
                    if (device) {
                        var extDevice = getSetValue(getSetValue(evt, strExt), Extensions.DeviceExt);
                        setValue(extDevice, "localId", device.id, isString);
                        setValue(extDevice, "ip", device.ip, isString);
                        setValue(extDevice, "model", device.model, isString);
                        setValue(extDevice, "deviceClass", device.deviceClass, isString);
                    }
                };
                _self[_DYN_APPLY_INTERNAL_CONTE5 ] = function (evt, itemCtx) {
                    var internal = _self.internal;
                    if (internal) {
                        var tags = getSetValue(evt, strTags);
                        setValue(tags, CtxTagKeys.internalAgentVersion, internal.agentVersion, isString);
                        setValue(tags, CtxTagKeys.internalSdkVersion, dataSanitizeString(logger, internal.sdkVersion, 64), isString);
                        if (evt.baseType === _InternalLogMessage.dataType || evt.baseType === PageView.dataType) {
                            setValue(tags, CtxTagKeys.internalSnippet, internal.snippetVer, isString);
                            setValue(tags, CtxTagKeys.internalSdkSrc, internal.sdkSrc, isString);
                        }
                    }
                };
                _self[_DYN_APPLY_LOCATION_CONTE4 ] = function (evt, itemCtx) {
                    var location = _this.location;
                    if (location) {
                        setValue(getSetValue(evt, strTags, []), CtxTagKeys.locationIp, location.ip, isString);
                    }
                };
                _self[_DYN_APPLY_OPERATION_CONT2 ] = function (evt, itemCtx) {
                    var telemetryTrace = _self[_DYN_TELEMETRY_TRACE ];
                    if (telemetryTrace) {
                        var extTrace = getSetValue(getSetValue(evt, strExt), Extensions.TraceExt, { traceID: undefined, parentID: undefined });
                        setValue(extTrace, "traceID", telemetryTrace.traceID, isString, isNullOrUndefined);
                        setValue(extTrace, "name", telemetryTrace.name, isString, isNullOrUndefined);
                        setValue(extTrace, "parentID", telemetryTrace.parentID, isString, isNullOrUndefined);
                    }
                };
                _self.applyWebContext = function (evt, itemCtx) {
                    var web = _this.web;
                    if (web) {
                        setValue(getSetValue(evt, strExt), Extensions.WebExt, web);
                    }
                };
                _self[_DYN_APPLY_USER_CONTEXT ] = function (evt, itemCtx) {
                    var user = _self.user;
                    if (user) {
                        var tags = getSetValue(evt, strTags, []);
                        setValue(tags, CtxTagKeys.userAccountId, user[_DYN_ACCOUNT_ID ], isString);
                        var extUser = getSetValue(getSetValue(evt, strExt), Extensions.UserExt);
                        setValue(extUser, "id", user.id, isString);
                        setValue(extUser, "authId", user[_DYN_AUTHENTICATED_ID ], isString);
                    }
                };
                _self.cleanUp = function (evt, itemCtx) {
                    var ext = evt.ext;
                    if (ext) {
                        _removeEmpty(ext, Extensions.DeviceExt);
                        _removeEmpty(ext, Extensions.UserExt);
                        _removeEmpty(ext, Extensions.WebExt);
                        _removeEmpty(ext, Extensions.OSExt);
                        _removeEmpty(ext, Extensions.AppExt);
                        _removeEmpty(ext, Extensions.TraceExt);
                    }
                };
            });
        }
        TelemetryContext.__ieDyn=1;
        return TelemetryContext;
    }());

    var PropertiesPlugin = /** @class */ (function (_super) {
        __extendsFn(PropertiesPlugin, _super);
        function PropertiesPlugin() {
            var _this = _super.call(this) || this;
            _this.priority = 110;
            _this.identifier = PropertiesPluginIdentifier;
            var _extensionConfig;
            var _distributedTraceCtx;
            var _previousTraceCtx;
            dynamicProto(PropertiesPlugin, _this, function (_self, _base) {
                _initDefaults();
                _self.initialize = function (config, core, extensions, pluginChain) {
                    _base.initialize(config, core, extensions, pluginChain);
                    _populateDefaults(config);
                };
                _self.processTelemetry = function (event, itemCtx) {
                    if (isNullOrUndefined(event)) ;
                    else {
                        itemCtx = _self._getTelCtx(itemCtx);
                        if (event.name === PageView.envelopeType) {
                            itemCtx.diagLog().resetInternalMessageCount();
                        }
                        var theContext = (_self.context || {});
                        if (theContext.session) {
                            if (typeof _self.context.session.id !== "string" && theContext[_DYN_SESSION_MANAGER ]) {
                                theContext[_DYN_SESSION_MANAGER ][_DYN_UPDATE ]();
                            }
                        }
                        var userCtx = theContext.user;
                        if (userCtx && !userCtx[_DYN_IS_USER_COOKIE_SET ]) {
                            userCtx[_DYN_UPDATE ](theContext.user.id);
                        }
                        _processTelemetryInternal(event, itemCtx);
                        if (userCtx && userCtx[_DYN_IS_NEW_USER ]) {
                            userCtx[_DYN_IS_NEW_USER ] = false;
                            var message = new _InternalLogMessage(72 , ((getNavigator() || {}).userAgent || ""));
                            _logInternalMessage(itemCtx.diagLog(), 1 , message);
                        }
                        _self.processNext(event, itemCtx);
                    }
                };
                _self._doTeardown = function (unloadCtx, unloadState) {
                    var core = (unloadCtx || {}).core();
                    if (core && core[_DYN_GET_TRACE_CTX ]) {
                        var traceCtx = core[_DYN_GET_TRACE_CTX ](false);
                        if (traceCtx === _distributedTraceCtx) {
                            core.setTraceCtx(_previousTraceCtx);
                        }
                    }
                    _initDefaults();
                };
                function _initDefaults() {
                    _extensionConfig = null;
                    _distributedTraceCtx = null;
                    _previousTraceCtx = null;
                }
                function _populateDefaults(config) {
                    var identifier = _self.identifier;
                    var core = _self.core;
                    var ctx = createProcessTelemetryContext(null, config, core);
                    var defaultConfig = PropertiesPlugin.getDefaultConfig();
                    _extensionConfig = _extensionConfig || {};
                    objForEachKey(defaultConfig, function (field, value) {
                        _extensionConfig[field] = function () { return ctx.getConfig(identifier, field, value()); };
                    });
                    _previousTraceCtx = core[_DYN_GET_TRACE_CTX ](false);
                    _self.context = new TelemetryContext(core, _extensionConfig, _previousTraceCtx);
                    _distributedTraceCtx = createDistributedTraceContextFromTrace(_self.context[_DYN_TELEMETRY_TRACE ], _previousTraceCtx);
                    core.setTraceCtx(_distributedTraceCtx);
                    _self.context.appId = function () {
                        var breezeChannel = core.getPlugin(BreezeChannelIdentifier);
                        return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                    };
                    _self["_extConfig"] = _extensionConfig;
                }
                function _processTelemetryInternal(evt, itemCtx) {
                    getSetValue(evt, "tags", []);
                    getSetValue(evt, "ext", {});
                    var ctx = _self.context;
                    ctx[_DYN_APPLY_SESSION_CONTEX0 ](evt, itemCtx);
                    ctx[_DYN_APPLY_APPLICATION_CO1 ](evt, itemCtx);
                    ctx[_DYN_APPLY_DEVICE_CONTEXT ](evt, itemCtx);
                    ctx[_DYN_APPLY_OPERATION_CONT2 ](evt, itemCtx);
                    ctx[_DYN_APPLY_USER_CONTEXT ](evt, itemCtx);
                    ctx[_DYN_APPLY_OPERATING_SYST3 ](evt, itemCtx);
                    ctx.applyWebContext(evt, itemCtx);
                    ctx[_DYN_APPLY_LOCATION_CONTE4 ](evt, itemCtx);
                    ctx[_DYN_APPLY_INTERNAL_CONTE5 ](evt, itemCtx);
                    ctx.cleanUp(evt, itemCtx);
                }
            });
            return _this;
        }
        PropertiesPlugin.getDefaultConfig = function () {
            var _a;
            var defaultValue;
            var nullValue = null;
            var defaultConfig = (_a = {
                    instrumentationKey: function () { return defaultValue; }
                },
                _a[_DYN_ACCOUNT_ID ] = function () { return nullValue; },
                _a.sessionRenewalMs = function () { return 30 * 60 * 1000; },
                _a.samplingPercentage = function () { return 100; },
                _a.sessionExpirationMs = function () { return 24 * 60 * 60 * 1000; },
                _a[_DYN_COOKIE_DOMAIN ] = function () { return nullValue; },
                _a[_DYN_SDK_EXTENSION ] = function () { return nullValue; },
                _a.isBrowserLinkTrackingEnabled = function () { return false; },
                _a.appId = function () { return nullValue; },
                _a[_DYN_GET_SESSION_ID ] = function () { return nullValue; },
                _a[_DYN_NAME_PREFIX ] = function () { return defaultValue; },
                _a[_DYN_SESSION_COOKIE_POSTF6 ] = function () { return defaultValue; },
                _a[_DYN_USER_COOKIE_POSTFIX ] = function () { return defaultValue; },
                _a[_DYN_ID_LENGTH ] = function () { return 22; },
                _a[_DYN_GET_NEW_ID ] = function () { return nullValue; },
                _a);
            return defaultConfig;
        };
        return PropertiesPlugin;
    }(BaseTelemetryPlugin));
    var PropertiesPlugin$1 = PropertiesPlugin;

    var _AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
    var _TRACK = "track";
    var STR_SNIPPET = "snippet";
    var STR_GET_COOKIE_MGR = "getCookieMgr";
    var STR_START_TRACK_PAGE = "startTrackPage";
    var STR_STOP_TRACK_PAGE = "stopTrackPage";
    var STR_FLUSH = "flush";
    var STR_START_TRACK_EVENT = "startTrackEvent";
    var STR_STOP_TRACK_EVENT = "stopTrackEvent";
    var STR_ADD_TELEMETRY_INITIALIZER = "addTelemetryInitializer";
    var STR_ADD_TELEMETRY_INITIALIZERS = STR_ADD_TELEMETRY_INITIALIZER + "s";
    var STR_POLL_INTERNAL_LOGS = "pollInternalLogs";
    var STR_GET_PLUGIN = "getPlugin";
    var STR_EVT_NAMESPACE = "evtNamespace";
    var STR_TRACK_EVENT = _TRACK + "Event";
    var STR_TRACK_TRACE = _TRACK + "Trace";
    var STR_TRACK_METRIC = _TRACK + "Metric";
    var STR_TRACK_PAGE_VIEW = _TRACK + "PageView";
    var STR_TRACK_EXCEPTION = _TRACK + "Exception";
    var STR_TRACK_DEPENDENCY_DATA = _TRACK + "DependencyData";
    var STR_SET_AUTHENTICATED_USER_CONTEXT = "set" + _AUTHENTICATED_USER_CONTEXT;
    var STR_CLEAR_AUTHENTICATED_USER_CONTEXT = "clear" + _AUTHENTICATED_USER_CONTEXT;

    var _DYN_UPDATE_SNIPPET_DEFIN0 = "updateSnippetDefinitions";
    var _DYN_LOAD_APP_INSIGHTS = "loadAppInsights";
    var _DYN_ENDPOINT_URL = "endpointUrl";
    var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes";
    var _DYN_MAX_BATCH_INTERVAL = "maxBatchInterval";
    var _DYN_DISABLE_EXCEPTION_TR2 = "disableExceptionTracking";
    var _DYN_DISABLE_TELEMETRY = "disableTelemetry";
    var _DYN_EMIT_LINE_DELIMITED_3 = "emitLineDelimitedJson";
    var _DYN_DIAGNOSTIC_LOG_INTER4 = "diagnosticLogInterval";
    var _DYN_AUTO_TRACK_PAGE_VISI5 = "autoTrackPageVisitTime";
    var _DYN_SAMPLING_PERCENTAGE = "samplingPercentage";
    var _DYN_DISABLE_AJAX_TRACKIN6 = "disableAjaxTracking";
    var _DYN_MAX_AJAX_CALLS_PER_V7 = "maxAjaxCallsPerView";
    var _DYN_IS_BEACON_API_DISABL8 = "isBeaconApiDisabled";
    var _DYN_DISABLE_CORRELATION_9 = "disableCorrelationHeaders";
    var _DYN_CORRELATION_HEADER_E10 = "correlationHeaderExcludedDomains";
    var _DYN_DISABLE_FLUSH_ON_BEF11 = "disableFlushOnBeforeUnload";
    var _DYN_DISABLE_FLUSH_ON_UNL12 = "disableFlushOnUnload";
    var _DYN_ENABLE_SESSION_STORA13 = "enableSessionStorageBuffer";
    var _DYN_IS_COOKIE_USE_DISABL14 = "isCookieUseDisabled";
    var _DYN_IS_STORAGE_USE_DISAB15 = "isStorageUseDisabled";
    var _DYN_IS_BROWSER_LINK_TRAC16 = "isBrowserLinkTrackingEnabled";
    var _DYN_ENABLE_CORS_CORRELAT17 = "enableCorsCorrelation";
    var _DYN_CONFIG = "config";
    var _DYN_CONTEXT = "context";
    var _DYN_PUSH = "push";
    var _DYN_VERSION = "version";
    var _DYN_QUEUE = "queue";
    var _DYN_CONNECTION_STRING = "connectionString";
    var _DYN_INSTRUMENTATION_KEY = "instrumentationKey";
    var _DYN_APP_INSIGHTS = "appInsights";
    var _DYN_DISABLE_IKEY_DEPRECA18 = "disableIkeyDeprecationMessage";
    var _DYN_GET_TRANSMISSION_CON19 = "getTransmissionControls";
    var _DYN_ONUNLOAD_FLUSH = "onunloadFlush";
    var _DYN_ADD_HOUSEKEEPING_BEF20 = "addHousekeepingBeforeUnload";
    var _DYN_INDEX_OF = "indexOf";

    var _internalSdkSrc;
    var _ignoreUpdateSnippetProperties$1 = [
        STR_SNIPPET, "dependencies", "properties", "_snippetVersion", "appInsightsNew", "getSKUDefaults"
    ];
    var fieldType = {
        Default: 0 ,
        Required: 1 ,
        Array: 2 ,
        Hidden: 4
    };
    var Telemetry = {
        __proto__: null,
        PropertiesPluginIdentifier: PropertiesPluginIdentifier,
        BreezeChannelIdentifier: BreezeChannelIdentifier,
        AnalyticsPluginIdentifier: AnalyticsPluginIdentifier,
        Util: Util,
        CorrelationIdHelper: CorrelationIdHelper,
        UrlHelper: UrlHelper,
        DateTimeUtils: DateTimeUtils,
        ConnectionStringParser: ConnectionStringParser,
        FieldType: fieldType,
        RequestHeaders: RequestHeaders,
        DisabledPropertyName: DisabledPropertyName,
        ProcessLegacy: ProcessLegacy,
        SampleRate: SampleRate,
        HttpMethod: HttpMethod,
        DEFAULT_BREEZE_ENDPOINT: DEFAULT_BREEZE_ENDPOINT,
        Envelope: Envelope,
        Event: Event$1,
        Exception: Exception,
        Metric: Metric,
        PageView: PageView,
        RemoteDependencyData: RemoteDependencyData,
        Trace: Trace,
        PageViewPerformance: PageViewPerformance,
        Data: Data,
        SeverityLevel: SeverityLevel,
        ConfigurationManager: ConfigurationManager,
        ContextTagKeys: ContextTagKeys,
        DataSanitizer: DataSanitizer,
        TelemetryItemCreator: TelemetryItemCreator,
        CtxTagKeys: CtxTagKeys,
        Extensions: Extensions,
        DistributedTracingModes: DistributedTracingModes
    };
    var Initialization = /** @class */ (function () {
        function Initialization(snippet) {
            var _this = this;
            var dependencies;
            var properties;
            var _sender;
            var _snippetVersion;
            var _evtNamespace;
            var _houseKeepingNamespace;
            var _core;
            dynamicProto(Initialization, this, function (_self) {
                _initDefaults();
                _snippetVersion = "" + (snippet.sv || snippet[_DYN_VERSION ] || "");
                snippet[_DYN_QUEUE ] = snippet[_DYN_QUEUE ] || [];
                snippet[_DYN_VERSION ] = snippet[_DYN_VERSION ] || 2.0;
                var config = snippet[_DYN_CONFIG ] || {};
                if (config[_DYN_CONNECTION_STRING ]) {
                    var cs = parseConnectionString(config[_DYN_CONNECTION_STRING ]);
                    var ingest = cs.ingestionendpoint;
                    config[_DYN_ENDPOINT_URL ] = ingest ? (ingest + DEFAULT_BREEZE_PATH) : config[_DYN_ENDPOINT_URL ];
                    config[_DYN_INSTRUMENTATION_KEY ] = cs.instrumentationkey || config[_DYN_INSTRUMENTATION_KEY ];
                }
                _self[_DYN_APP_INSIGHTS ] = new AnalyticsPlugin();
                properties = new PropertiesPlugin$1();
                dependencies = new AjaxMonitor();
                _sender = new Sender();
                _core = new AppInsightsCore();
                _self.core = _core;
                var isErrMessageDisabled = isNullOrUndefined(config[_DYN_DISABLE_IKEY_DEPRECA18 ]) ? true : config[_DYN_DISABLE_IKEY_DEPRECA18 ];
                if (!config[_DYN_CONNECTION_STRING ] && !isErrMessageDisabled) {
                    _throwInternal(_core.logger, 1 , 106 , "Instrumentation key support will end soon, see aka.ms/IkeyMigrate");
                }
                _self[STR_SNIPPET ] = snippet;
                _self[_DYN_CONFIG ] = config;
                _getSKUDefaults();
                _self[STR_FLUSH ] = function (async) {
                    if (async === void 0) { async = true; }
                    doPerf(_core, function () { return "AISKU.flush"; }, function () {
                        arrForEach(_core[_DYN_GET_TRANSMISSION_CON19 ](), function (channels) {
                            arrForEach(channels, function (channel) {
                                channel[STR_FLUSH ](async);
                            });
                        });
                    }, null, async);
                };
                _self[_DYN_ONUNLOAD_FLUSH ] = function (async) {
                    if (async === void 0) { async = true; }
                    arrForEach(_core[_DYN_GET_TRANSMISSION_CON19 ](), function (channels) {
                        arrForEach(channels, function (channel) {
                            if (channel[_DYN_ONUNLOAD_FLUSH ]) {
                                channel[_DYN_ONUNLOAD_FLUSH ]();
                            }
                            else {
                                channel[STR_FLUSH ](async);
                            }
                        });
                    });
                };
                _self[_DYN_LOAD_APP_INSIGHTS ] = function (legacyMode, logger, notificationManager) {
                    if (legacyMode === void 0) { legacyMode = false; }
                    function _updateSnippetProperties(snippet) {
                        if (snippet) {
                            var snippetVer = "";
                            if (!isNullOrUndefined(_snippetVersion)) {
                                snippetVer += _snippetVersion;
                            }
                            if (legacyMode) {
                                snippetVer += ".lg";
                            }
                            if (_self[_DYN_CONTEXT ] && _self[_DYN_CONTEXT ].internal) {
                                _self[_DYN_CONTEXT ].internal.snippetVer = snippetVer || "-";
                            }
                            objForEachKey(_self, function (field, value) {
                                if (isString(field) &&
                                    !isFunction(value) &&
                                    field && field[0] !== "_" &&
                                    arrIndexOf(_ignoreUpdateSnippetProperties$1, field) === -1) {
                                    snippet[field] = value;
                                }
                            });
                        }
                    }
                    if (legacyMode && _self[_DYN_CONFIG ].extensions && _self[_DYN_CONFIG ].extensions.length > 0) {
                        throwError("Extensions not allowed in legacy mode");
                    }
                    doPerf(_self.core, function () { return "AISKU.loadAppInsights"; }, function () {
                        var extensions = [];
                        extensions[_DYN_PUSH ](_sender);
                        extensions[_DYN_PUSH ](properties);
                        extensions[_DYN_PUSH ](dependencies);
                        extensions[_DYN_PUSH ](_self[_DYN_APP_INSIGHTS ]);
                        _core.initialize(_self[_DYN_CONFIG ], extensions, logger, notificationManager);
                        _self[_DYN_CONTEXT ] = properties[_DYN_CONTEXT ];
                        if (_internalSdkSrc && _self[_DYN_CONTEXT ]) {
                            _self[_DYN_CONTEXT ].internal.sdkSrc = _internalSdkSrc;
                        }
                        _updateSnippetProperties(_self[STR_SNIPPET ]);
                        _self.emptyQueue();
                        _self[STR_POLL_INTERNAL_LOGS ]();
                        _self[_DYN_ADD_HOUSEKEEPING_BEF20 ](_self);
                    });
                    return _self;
                };
                _self[_DYN_UPDATE_SNIPPET_DEFIN0 ] = function (snippet) {
                    proxyAssign(snippet, _self, function (name) {
                        return name && arrIndexOf(_ignoreUpdateSnippetProperties$1, name) === -1;
                    });
                };
                _self.emptyQueue = function () {
                    try {
                        if (isArray(_self.snippet[_DYN_QUEUE ])) {
                            var length_1 = _self.snippet[_DYN_QUEUE ].length;
                            for (var i = 0; i < length_1; i++) {
                                var call = _self.snippet[_DYN_QUEUE ][i];
                                call();
                            }
                            _self.snippet[_DYN_QUEUE ] = undefined;
                            delete _self.snippet[_DYN_QUEUE ];
                        }
                    }
                    catch (exception) {
                        var properties_1 = {};
                        if (exception && isFunction(exception.toString)) {
                            properties_1.exception = exception.toString();
                        }
                    }
                };
                _self[_DYN_ADD_HOUSEKEEPING_BEF20 ] = function (appInsightsInstance) {
                    if (hasWindow() || hasDocument()) {
                        var performHousekeeping = function () {
                            appInsightsInstance[_DYN_ONUNLOAD_FLUSH ](false);
                            if (isFunction(_this.core[STR_GET_PLUGIN ])) {
                                var loadedPlugin = _this.core[STR_GET_PLUGIN ](PropertiesPluginIdentifier);
                                if (loadedPlugin) {
                                    var propertiesPlugin = loadedPlugin.plugin;
                                    if (propertiesPlugin && propertiesPlugin[_DYN_CONTEXT ] && propertiesPlugin[_DYN_CONTEXT ]._sessionManager) {
                                        propertiesPlugin[_DYN_CONTEXT ]._sessionManager.backup();
                                    }
                                }
                            }
                        };
                        var added = false;
                        var excludePageUnloadEvents = appInsightsInstance.appInsights[_DYN_CONFIG ].disablePageUnloadEvents;
                        if (!_houseKeepingNamespace) {
                            _houseKeepingNamespace = mergeEvtNamespace(_evtNamespace, _core[STR_EVT_NAMESPACE ] && _core[STR_EVT_NAMESPACE ]());
                        }
                        if (!appInsightsInstance.appInsights.config[_DYN_DISABLE_FLUSH_ON_BEF11 ]) {
                            if (addPageUnloadEventListener(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) {
                                added = true;
                            }
                            if (addPageHideEventListener(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) {
                                added = true;
                            }
                            if (!added && !isReactNative()) {
                                _throwInternal(appInsightsInstance[_DYN_APP_INSIGHTS ].core.logger, 1 , 19 , "Could not add handler for beforeunload and pagehide");
                            }
                        }
                        if (!added && !appInsightsInstance.appInsights.config[_DYN_DISABLE_FLUSH_ON_UNL12 ]) {
                            addPageHideEventListener(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace);
                        }
                    }
                };
                _self.getSender = function () {
                    return _sender;
                };
                _self.unload = function (isAsync, unloadComplete, cbTimeout) {
                    _self[_DYN_ONUNLOAD_FLUSH ](isAsync);
                    if (_houseKeepingNamespace) {
                        removePageUnloadEventListener(null, _houseKeepingNamespace);
                        removePageHideEventListener(null, _houseKeepingNamespace);
                    }
                    _core.unload && _core.unload(isAsync, unloadComplete, cbTimeout);
                };
                proxyFunctions(_self, _self[_DYN_APP_INSIGHTS ], [
                    STR_GET_COOKIE_MGR,
                    STR_TRACK_EVENT,
                    STR_TRACK_PAGE_VIEW,
                    "trackPageViewPerformance",
                    STR_TRACK_EXCEPTION,
                    "_onerror",
                    STR_TRACK_TRACE,
                    STR_TRACK_METRIC,
                    STR_START_TRACK_PAGE,
                    STR_STOP_TRACK_PAGE,
                    STR_START_TRACK_EVENT,
                    STR_STOP_TRACK_EVENT
                ]);
                proxyFunctions(_self, _getCurrentDependencies, [
                    STR_TRACK_DEPENDENCY_DATA,
                    "addDependencyListener",
                    "addDependencyInitializer"
                ]);
                proxyFunctions(_self, _core, [
                    STR_ADD_TELEMETRY_INITIALIZER,
                    STR_POLL_INTERNAL_LOGS,
                    "stopPollingInternalLogs",
                    STR_GET_PLUGIN,
                    "addPlugin",
                    STR_EVT_NAMESPACE,
                    "addUnloadCb",
                    "getTraceCtx"
                ]);
                proxyFunctions(_self, function () {
                    var context = properties[_DYN_CONTEXT ];
                    return context ? context.user : null;
                }, [
                    STR_SET_AUTHENTICATED_USER_CONTEXT,
                    STR_CLEAR_AUTHENTICATED_USER_CONTEXT
                ]);
                function _getSKUDefaults() {
                    _self.config[_DYN_DIAGNOSTIC_LOG_INTER4 ] =
                        _self.config[_DYN_DIAGNOSTIC_LOG_INTER4 ] && _self[_DYN_CONFIG ][_DYN_DIAGNOSTIC_LOG_INTER4 ] > 0 ? _self[_DYN_CONFIG ][_DYN_DIAGNOSTIC_LOG_INTER4 ] : 10000;
                }
                function _getCurrentDependencies() {
                    return dependencies;
                }
                function _initDefaults() {
                    _evtNamespace = createUniqueNamespace("AISKU");
                    _houseKeepingNamespace = null;
                    dependencies = null;
                    properties = null;
                    _sender = null;
                    _snippetVersion = null;
                }
            });
        }
        Initialization.prototype.addDependencyInitializer = function (dependencyInitializer) {
            return null;
        };
        return Initialization;
    }());
    (function () {
        var sdkSrc = null;
        var cdns = [
            "://js.monitor.azure.com/",
            "://az416426.vo.msecnd.net/"
        ];
        try {
            var scrpt = (document || {}).currentScript;
            if (scrpt) {
                sdkSrc = scrpt.src;
            }
        }
        catch (e) {
        }
        if (sdkSrc) {
            try {
                var url = sdkSrc.toLowerCase();
                if (url) {
                    var src = "";
                    for (var idx = 0; idx < cdns.length; idx++) {
                        if (url[_DYN_INDEX_OF ](cdns[idx]) !== -1) {
                            src = "cdn" + (idx + 1);
                            if (url[_DYN_INDEX_OF ]("/scripts/") === -1) {
                                if (url[_DYN_INDEX_OF ]("/next/") !== -1) {
                                    src += "-next";
                                }
                                else if (url[_DYN_INDEX_OF ]("/beta/") !== -1) {
                                    src += "-beta";
                                }
                            }
                            _internalSdkSrc = src + ("");
                            break;
                        }
                    }
                }
            }
            catch (e) {
            }
        }
    })();

    var _ignoreUpdateSnippetProperties = [
        STR_SNIPPET, "getDefaultConfig", "_hasLegacyInitializers", "_queue", "_processLegacyInitializers"
    ];
    function getDefaultConfig(config) {
        if (!config) {
            config = {};
        }
        config[_DYN_ENDPOINT_URL ] = config[_DYN_ENDPOINT_URL ] || DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH;
        config.sessionRenewalMs = 30 * 60 * 1000;
        config.sessionExpirationMs = 24 * 60 * 60 * 1000;
        config[_DYN_MAX_BATCH_SIZE_IN_BY1 ] = config[_DYN_MAX_BATCH_SIZE_IN_BY1 ] > 0 ? config[_DYN_MAX_BATCH_SIZE_IN_BY1 ] : 102400;
        config[_DYN_MAX_BATCH_INTERVAL ] = !isNaN(config[_DYN_MAX_BATCH_INTERVAL ]) ? config[_DYN_MAX_BATCH_INTERVAL ] : 15000;
        config.enableDebug = stringToBoolOrDefault(config.enableDebug);
        config[_DYN_DISABLE_EXCEPTION_TR2 ] = stringToBoolOrDefault(config[_DYN_DISABLE_EXCEPTION_TR2 ]);
        config[_DYN_DISABLE_TELEMETRY ] = stringToBoolOrDefault(config[_DYN_DISABLE_TELEMETRY ]);
        config.verboseLogging = stringToBoolOrDefault(config.verboseLogging);
        config[_DYN_EMIT_LINE_DELIMITED_3 ] = stringToBoolOrDefault(config[_DYN_EMIT_LINE_DELIMITED_3 ]);
        config[_DYN_DIAGNOSTIC_LOG_INTER4 ] = config[_DYN_DIAGNOSTIC_LOG_INTER4 ] || 10000;
        config[_DYN_AUTO_TRACK_PAGE_VISI5 ] = stringToBoolOrDefault(config[_DYN_AUTO_TRACK_PAGE_VISI5 ]);
        if (isNaN(config[_DYN_SAMPLING_PERCENTAGE ]) || config[_DYN_SAMPLING_PERCENTAGE ] <= 0 || config[_DYN_SAMPLING_PERCENTAGE ] >= 100) {
            config[_DYN_SAMPLING_PERCENTAGE ] = 100;
        }
        config[_DYN_DISABLE_AJAX_TRACKIN6 ] = stringToBoolOrDefault(config[_DYN_DISABLE_AJAX_TRACKIN6 ]);
        config[_DYN_MAX_AJAX_CALLS_PER_V7 ] = !isNaN(config[_DYN_MAX_AJAX_CALLS_PER_V7 ]) ? config[_DYN_MAX_AJAX_CALLS_PER_V7 ] : 500;
        config[_DYN_IS_BEACON_API_DISABL8 ] = stringToBoolOrDefault(config[_DYN_IS_BEACON_API_DISABL8 ], true);
        config[_DYN_DISABLE_CORRELATION_9 ] = stringToBoolOrDefault(config[_DYN_DISABLE_CORRELATION_9 ]);
        config[_DYN_CORRELATION_HEADER_E10 ] = config[_DYN_CORRELATION_HEADER_E10 ] || DfltAjaxCorrelationHeaderExDomains;
        config[_DYN_DISABLE_FLUSH_ON_BEF11 ] = stringToBoolOrDefault(config[_DYN_DISABLE_FLUSH_ON_BEF11 ]);
        config.disableFlushOnUnload = stringToBoolOrDefault(config.disableFlushOnUnload, config[_DYN_DISABLE_FLUSH_ON_BEF11 ]);
        config[_DYN_ENABLE_SESSION_STORA13 ] = stringToBoolOrDefault(config[_DYN_ENABLE_SESSION_STORA13 ], true);
        config.isRetryDisabled = stringToBoolOrDefault(config.isRetryDisabled);
        config[_DYN_IS_COOKIE_USE_DISABL14 ] = stringToBoolOrDefault(config[_DYN_IS_COOKIE_USE_DISABL14 ]);
        config[_DYN_IS_STORAGE_USE_DISAB15 ] = stringToBoolOrDefault(config[_DYN_IS_STORAGE_USE_DISAB15 ]);
        config[_DYN_IS_BROWSER_LINK_TRAC16 ] = stringToBoolOrDefault(config[_DYN_IS_BROWSER_LINK_TRAC16 ]);
        config[_DYN_ENABLE_CORS_CORRELAT17 ] = stringToBoolOrDefault(config[_DYN_ENABLE_CORS_CORRELAT17 ]);
        return config;
    }
    var AppInsightsDeprecated = /** @class */ (function () {
        function AppInsightsDeprecated(snippet, appInsightsNew) {
            var _this = this;
            var _hasLegacyInitializers = false;
            var _queue = [];
            var _config;
            dynamicProto(AppInsightsDeprecated, this, function (_self) {
                _config = getDefaultConfig(snippet[_DYN_CONFIG ]);
                _self[_DYN_CONFIG ] = _config;
                _self[STR_SNIPPET ] = snippet;
                _self.appInsightsNew = appInsightsNew;
                _self[_DYN_CONTEXT ] = { addTelemetryInitializer: _addTelemetryInitializers.bind(_self) };
                _self[STR_ADD_TELEMETRY_INITIALIZERS ] = _addTelemetryInitializers;
                function _addTelemetryInitializers(callBack) {
                    if (!_hasLegacyInitializers) {
                        appInsightsNew[STR_ADD_TELEMETRY_INITIALIZER ](function (item) {
                            _processLegacyInitializers(item);
                        });
                        _hasLegacyInitializers = true;
                    }
                    _queue[_DYN_PUSH ](callBack);
                }
                proxyFunctions(_self, appInsightsNew, [
                    STR_GET_COOKIE_MGR,
                    STR_START_TRACK_PAGE,
                    STR_STOP_TRACK_PAGE,
                    STR_FLUSH,
                    STR_START_TRACK_EVENT,
                    STR_STOP_TRACK_EVENT
                ]);
                _self[STR_TRACK_PAGE_VIEW ] = function (name, url, properties, measurements, duration) {
                    var telemetry = {
                        name: name,
                        uri: url,
                        properties: properties,
                        measurements: measurements
                    };
                    appInsightsNew[STR_TRACK_PAGE_VIEW ](telemetry);
                };
                _self[STR_TRACK_EVENT ] = function (name, properties, measurements) {
                    appInsightsNew[STR_TRACK_EVENT ]({ name: name });
                };
                _self.trackDependency = function (id, method, absoluteUrl, pathName, totalTime, success, resultCode) {
                    appInsightsNew[STR_TRACK_DEPENDENCY_DATA ]({
                        id: id,
                        target: absoluteUrl,
                        type: pathName,
                        duration: totalTime,
                        properties: { HttpMethod: method },
                        success: success,
                        responseCode: resultCode
                    });
                };
                _self[STR_TRACK_EXCEPTION ] = function (exception, handledAt, properties, measurements, severityLevel) {
                    appInsightsNew[STR_TRACK_EXCEPTION ]({
                        exception: exception
                    });
                };
                _self[STR_TRACK_METRIC ] = function (name, average, sampleCount, min, max, properties) {
                    appInsightsNew[STR_TRACK_METRIC ]({ name: name, average: average, sampleCount: sampleCount, min: min, max: max });
                };
                _self[STR_TRACK_TRACE ] = function (message, properties, severityLevel) {
                    appInsightsNew[STR_TRACK_TRACE ]({ message: message, severityLevel: severityLevel });
                };
                _self[STR_SET_AUTHENTICATED_USER_CONTEXT ] = function (authenticatedUserId, accountId, storeInCookie) {
                    appInsightsNew[_DYN_CONTEXT ].user[STR_SET_AUTHENTICATED_USER_CONTEXT ](authenticatedUserId, accountId, storeInCookie);
                };
                _self[STR_CLEAR_AUTHENTICATED_USER_CONTEXT ] = function () {
                    appInsightsNew[_DYN_CONTEXT ].user[STR_CLEAR_AUTHENTICATED_USER_CONTEXT ]();
                };
                _self._onerror = function (message, url, lineNumber, columnNumber, error) {
                    appInsightsNew._onerror({ message: message, url: url, lineNumber: lineNumber, columnNumber: columnNumber, error: error });
                };
                _self.downloadAndSetup = function (config) {
                    throwError("downloadAndSetup not implemented in web SKU");
                };
                _self[_DYN_UPDATE_SNIPPET_DEFIN0 ] = function (snippet) {
                    proxyAssign(snippet, _this, function (name) {
                        return name && arrIndexOf(_ignoreUpdateSnippetProperties, name) === -1;
                    });
                };
                _self[_DYN_LOAD_APP_INSIGHTS ] = function () {
                    if (_self[_DYN_CONFIG ]["iKey"]) {
                        var originalTrackPageView_1 = _self[STR_TRACK_PAGE_VIEW ];
                        _self[STR_TRACK_PAGE_VIEW ] = function (pagePath, properties, measurements) {
                            originalTrackPageView_1.apply(_self, [null, pagePath, properties, measurements]);
                        };
                    }
                    var legacyPageView = "logPageView";
                    if (isFunction(_self[STR_SNIPPET ][legacyPageView])) {
                        _this[legacyPageView] = function (pagePath, properties, measurements) {
                            _self[STR_TRACK_PAGE_VIEW ](null, pagePath, properties, measurements);
                        };
                    }
                    var legacyEvent = "logEvent";
                    if (isFunction(_self[STR_SNIPPET ][legacyEvent])) {
                        _this[legacyEvent] = function (name, props, measurements) {
                            _self[STR_TRACK_EVENT ](name, props, measurements);
                        };
                    }
                    return _this;
                };
                function _processLegacyInitializers(item) {
                    item.tags[ProcessLegacy] = _queue;
                    return item;
                }
            });
        }
        AppInsightsDeprecated.__ieDyn=1;
        return AppInsightsDeprecated;
    }());

    var ApplicationInsightsContainer = /** @class */ (function () {
        function ApplicationInsightsContainer() {
        }
        ApplicationInsightsContainer.getAppInsights = function (snippet, version) {
            var initialization = new Initialization(snippet);
            var legacyMode = version >= 2 ? false : true;
            _legacyCookieMgr();
            if (!legacyMode) {
                initialization[_DYN_UPDATE_SNIPPET_DEFIN0 ](snippet);
                initialization[_DYN_LOAD_APP_INSIGHTS ](legacyMode);
                return initialization;
            }
            else {
                var legacy = new AppInsightsDeprecated(snippet, initialization);
                legacy[_DYN_UPDATE_SNIPPET_DEFIN0 ](snippet);
                initialization[_DYN_LOAD_APP_INSIGHTS ](legacyMode);
                return legacy;
            }
        };
        return ApplicationInsightsContainer;
    }());

    exports.AppInsightsCore = AppInsightsCore;
    exports.ApplicationAnalytics = AnalyticsPlugin;
    exports.ApplicationInsights = Initialization;
    exports.ApplicationInsightsContainer = ApplicationInsightsContainer;
    exports.BaseCore = BaseCore;
    exports.BaseTelemetryPlugin = BaseTelemetryPlugin;
    exports.CoreUtils = CoreUtils;
    exports.DependenciesPlugin = AjaxMonitor;
    exports.DistributedTracingModes = DistributedTracingModes;
    exports.Event = Event$1;
    exports.Exception = Exception;
    exports.LoggingSeverity = LoggingSeverity;
    exports.Metric = Metric;
    exports.NotificationManager = NotificationManager;
    exports.PageView = PageView;
    exports.PageViewPerformance = PageViewPerformance;
    exports.PerfEvent = PerfEvent;
    exports.PerfManager = PerfManager;
    exports.PropertiesPlugin = PropertiesPlugin$1;
    exports.RemoteDependencyData = RemoteDependencyData;
    exports.Sender = Sender;
    exports.SeverityLevel = SeverityLevel;
    exports.Telemetry = Telemetry;
    exports.Trace = Trace;
    exports.Util = Util;
    exports._InternalMessageId = _InternalMessageId;
    exports.doPerf = doPerf;

    (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=applicationinsights-web.js.map

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
_$applicationinsightsWeb_MicrosoftApplicationinsightsWeb = _$applicationinsightsWeb_MicrosoftApplicationinsightsWeb.exports
exposedRequire.m["device-detector-js"] = _$DeviceDetector_deviceDetectorJs;
exposedRequire.m["dompurify"] = _$dompurify_dompurify;
exposedRequire.m["es6-symbol"] = _$es6Symbol_es6Symbol;
exposedRequire.m["es5-ext"] = _$es5Ext_es5Ext;
exposedRequire.m["gulp-javascript-obfuscator"] = _$gulpJavaScriptObfuscator_gulpJavascriptObfuscator;
exposedRequire.m["gulp-uglifycss"] = _$gulpUglifycss_gulpUglifycss;
exposedRequire.m["js-cookie"] = _$jsCookie_jsCookie;
exposedRequire.m["jwt-decode"] = _$jwtDecode_jwtDecode;
exposedRequire.m["lodash.merge"] = _$lodash_lodashMerge;
exposedRequire.m["minimist"] = _$minimist_minimist;
exposedRequire.m["reflect-metadata"] = _$reflectMetadata_reflectMetadata;
exposedRequire.m["rxjs"] = _$rxjs_rxjs;
exposedRequire.m["url-search-params-polyfill"] = _$urlSearchParamsPolyfill_urlSearchParamsPolyfill;
exposedRequire.m["whatwg-fetch"] = _$whatwgFetch_whatwgFetch;
exposedRequire.m["@microsoft/applicationinsights-web"] = _$applicationinsightsWeb_MicrosoftApplicationinsightsWeb;
return exposedRequire;
}(typeof require === 'function' ? require : void 0));
